(function() {
    'use strict';

    angular
        .module('platformApp', [
            'ngStorage',
            'tmh.dynamicLocale',
            'pascalprecht.translate',
            'ngResource',
            'ngCookies',
            'ngAria',
            'ngCacheBuster',
            'ngFileUpload',
            'ui.bootstrap',
            'ui.bootstrap.datetimepicker',
            'ui.router',
            'ui.select2',
            'infinite-scroll',
            'image.service',
            'modules.service',
            // jhipster-needle-angularjs-add-module JHipster will add new module here
            'angular-loading-bar',
            'ui.sortable',
            'ngDraggable'
        ])
        .run(run);

    run.$inject = ['stateHandler', 'translationHandler'];

    function run(stateHandler, translationHandler) {
        stateHandler.initialize();
        translationHandler.initialize();
    }
})();

(function () {
    'use strict';

    angular
        .module('platformApp')
        .factory('User', User);

    User.$inject = ['$resource'];

    function User ($resource) {
        var service = $resource('api/users/:login', {}, {
            'query': {method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'save': { method:'POST' },
            'update': { method:'PUT' },
            'delete':{ method:'DELETE'}
        });

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('platformApp')
        .factory('ProfileService', ProfileService);

    ProfileService.$inject = ['$http'];

    function ProfileService($http) {

        var dataPromise;

        var service = {
            getProfileInfo : getProfileInfo
        };

        return service;

        function getProfileInfo() {
            if (angular.isUndefined(dataPromise)) {
                dataPromise = $http.get('api/profile-info').then(function(result) {
                    if (result.data.activeProfiles) {
                        var response = {};
                        response.activeProfiles = result.data.activeProfiles;
                        response.ribbonEnv = result.data.ribbonEnv;
                        response.inProduction = result.data.activeProfiles.indexOf("prod") !== -1;
                        response.swaggerEnabled = result.data.activeProfiles.indexOf("swagger") !== -1;
                        return response;
                    }
                });
            }
            return dataPromise;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('platformApp')
        .directive('pageRibbon', pageRibbon);

    pageRibbon.$inject = ['ProfileService', '$rootScope', '$translate'];

    function pageRibbon(ProfileService, $rootScope, $translate) {
        var directive = {
            replace : true,
            restrict : 'AE',
            template : '<div class="ribbon hidden"><a href="" data-translate="global.ribbon.{{ribbonEnv}}">{{ribbonEnv}}</a></div>',
            link : linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            ProfileService.getProfileInfo().then(function(response) {
                if (response.ribbonEnv) {
                    scope.ribbonEnv = response.ribbonEnv;
                    element.addClass(response.ribbonEnv);
                    element.removeClass('hidden');
                }
            });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('platformApp')
        .factory('Register', Register);

    Register.$inject = ['$resource'];

    function Register ($resource) {
        return $resource('bunny/api/front-users/register', {}, {});
    }
})();

(function() {
    'use strict';

    angular
        .module('platformApp')
        .factory('Principal', Principal);

    Principal.$inject = ['$q', 'Account', '$localStorage'];

    function Principal ($q, Account, $localStorage) {
        var _identity,
            _authenticated = false;

        var service = {
            authenticate: authenticate,
            hasAnyAuthority: hasAnyAuthority,
            hasAuthority: hasAuthority,
            identity: identity,
            isAuthenticated: isAuthenticated,
            isIdentityResolved: isIdentityResolved
        };

        return service;

        function authenticate (identity) {
            _identity = identity;
            _authenticated = identity !== null;
        }

        function hasAnyAuthority (authorities) {
            if (!_authenticated || !_identity || !_identity.authorities) {
                return false;
            }

            for (var i = 0; i < authorities.length; i++) {
                if (_identity.authorities.indexOf(authorities[i]) !== -1) {
                    return true;
                }
            }

            return false;
        }

        function hasAuthority (authority) {
            if (!_authenticated) {
                return $q.when(false);
            }

            return this.identity().then(function(_id) {
                return _id.authorities && _id.authorities.indexOf(authority) !== -1;
            }, function(){
                return false;
            });
        }

        function identity (force) {
            var deferred = $q.defer();

            if (force === true) {
                _identity = undefined;
            }

            // check and see if we have retrieved the identity data from the server.
            // if we have, reuse it by immediately resolving
            if (angular.isDefined(_identity)) {
                deferred.resolve(_identity);

                return deferred.promise;
            }

            // retrieve the identity data from the server, update the identity object, and then resolve.
            Account.get().$promise
                .then(getAccountThen)
                .catch(getAccountCatch);

            return deferred.promise;

            function getAccountThen (account) {
                _identity = account.data;
                $localStorage.user = account.data;
                _authenticated = true;
                deferred.resolve(_identity);
            }

            function getAccountCatch () {
                _identity = null;
                _authenticated = false;
                deferred.resolve(_identity);
            }
        }

        function isAuthenticated () {
            return _authenticated;
        }

        function isIdentityResolved () {
            return angular.isDefined(_identity);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('platformApp')
        .factory('PasswordResetInit', PasswordResetInit);

    PasswordResetInit.$inject = ['$resource'];

    function PasswordResetInit($resource) {
        var service = $resource('api/account/reset-password/init', {}, {});

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('platformApp')
        .factory('PasswordResetFinish', PasswordResetFinish);

    PasswordResetFinish.$inject = ['$resource'];

    function PasswordResetFinish($resource) {
        var service = $resource('api/account/reset-password/finish', {}, {});

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('platformApp')
        .factory('Password', Password);

    Password.$inject = ['$resource'];

    function Password($resource) {
        var service = $resource('api/account/change-password', {}, {});

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('platformApp')
        .directive('hasAuthority', hasAuthority);

    hasAuthority.$inject = ['Principal'];

    function hasAuthority(Principal) {
        var directive = {
            restrict: 'A',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            var authority = attrs.hasAuthority.replace(/\s+/g, '');

            var setVisible = function () {
                    element.removeClass('hidden');
                },
                setHidden = function () {
                    element.addClass('hidden');
                },
                defineVisibility = function (reset) {

                    if (reset) {
                        setVisible();
                    }

                    Principal.hasAuthority(authority)
                        .then(function (result) {
                            if (result) {
                                setVisible();
                            } else {
                                setHidden();
                            }
                        });
                };

            if (authority.length > 0) {
                defineVisibility(true);

                scope.$watch(function() {
                    return Principal.isAuthenticated();
                }, function() {
                    defineVisibility(true);
                });
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('platformApp')
        .directive('hasAnyAuthority', hasAnyAuthority);

    hasAnyAuthority.$inject = ['Principal'];

    function hasAnyAuthority(Principal) {
        var directive = {
            restrict: 'A',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            var authorities = attrs.hasAnyAuthority.replace(/\s+/g, '').split(',');

            var setVisible = function () {
                    element.removeClass('hidden');
                },
                setHidden = function () {
                    element.addClass('hidden');
                },
                defineVisibility = function (reset) {
                    var result;
                    if (reset) {
                        setVisible();
                    }

                    result = Principal.hasAnyAuthority(authorities);
                    if (result) {
                        setVisible();
                    } else {
                        setHidden();
                    }
                };

            if (authorities.length > 0) {
                defineVisibility(true);

                scope.$watch(function() {
                    return Principal.isAuthenticated();
                }, function() {
                    defineVisibility(true);
                });
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('platformApp')
        .factory('Auth', Auth);

    Auth.$inject = ['$rootScope', '$state', '$sessionStorage', '$q', '$translate', 'Principal', 'AuthServerProvider', 'Account', 'LoginService', 'Register', 'Activate', 'Password', 'PasswordResetInit', 'PasswordResetFinish', 'MessageService'];

    function Auth ($rootScope, $state, $sessionStorage, $q, $translate, Principal, AuthServerProvider, Account, LoginService, Register, Activate, Password, PasswordResetInit, PasswordResetFinish, MessageService) {
        var service = {
            activateAccount: activateAccount,
            authorize: authorize,
            changePassword: changePassword,
            createAccount: createAccount,
            getPreviousState: getPreviousState,
            login: login,
            logout: logout,
            loginWithToken: loginWithToken,
            resetPasswordFinish: resetPasswordFinish,
            resetPasswordInit: resetPasswordInit,
            resetPreviousState: resetPreviousState,
            storePreviousState: storePreviousState,
            updateAccount: updateAccount
        };

        return service;

        function activateAccount (key, callback) {
            var cb = callback || angular.noop;

            return Activate.get(key,
                function (response) {
                    return cb(response);
                },
                function (err) {
                    return cb(err);
                }.bind(this)).$promise;
        }

        function authorize (force) {
            var authReturn = Principal.identity(force).then(authThen);

            return authReturn;

            function authThen () {
                var isAuthenticated = Principal.isAuthenticated();

                // 账户失效
                if (!isAuthenticated && !['home','register','requestReset','homeFirst'].includes($rootScope.toState.name)) {
                    MessageService.notice("认证已失效，请重新登录");
                    $state.go('home')
                }

                // an authenticated user can't access to login and register pages
                if (isAuthenticated && ($rootScope.toState.name === 'home' || $rootScope.toState.name === 'register' || $rootScope.toState.name === 'requestReset')) {
                    $state.go('page');
                }

                // recover and clear previousState after external login redirect (e.g. oauth2)
                if (isAuthenticated && !$rootScope.fromState.name && getPreviousState()) {
                    var previousState = getPreviousState();
                    resetPreviousState();
                    $state.go(previousState.name, previousState.params);
                }

                if ($rootScope.toState.data.authorities && $rootScope.toState.data.authorities.length > 0 && !Principal.hasAnyAuthority($rootScope.toState.data.authorities)) {
                    if (isAuthenticated) {
                        // user is signed in but not authorized for desired state
                        $state.go('home');
                    }
                    else {
                        // user is not authenticated. stow the state they wanted before you
                        // send them to the login service, so you can return them when you're done
                        storePreviousState($rootScope.toState.name, $rootScope.toStateParams);

                        // now, send them to the signin state so they can log in
                        $state.go('home').then(function() {
                            // LoginService.open();
                        });
                    }
                }
            }
        }

        function changePassword (newPassword, callback) {
            var cb = callback || angular.noop;

            return Password.save(newPassword, function () {
                return cb();
            }, function (err) {
                return cb(err);
            }).$promise;
        }

        function createAccount (account, callback) {
            var cb = callback || angular.noop;

            return Register.save(account,
                function () {
                    return cb(account);
                },
                function (err) {
                    this.logout();
                    return cb(err);
                }.bind(this)).$promise;
        }

        function login (credentials, callback) {
            var cb = callback || angular.noop;
            var deferred = $q.defer();

            AuthServerProvider.login(credentials)
                .then(loginThen)
                .catch(function (err) {
                    this.logout();
                    deferred.reject(err);
                    return cb(err);
                }.bind(this));

            function loginThen (data) {
                Principal.identity(true).then(function(account) {
                    // After the login the language will be changed to
                    // the language selected by the user during his registration
                    if (account!== null) {
                        $translate.use(account.langKey).then(function () {
                            $translate.refresh();
                        });
                    }
                    deferred.resolve(data);
                });
                return cb();
            }

            return deferred.promise;
        }

        function loginWithToken(jwt, rememberMe) {
            return AuthServerProvider.loginWithToken(jwt, rememberMe);
        }

        function logout () {
            AuthServerProvider.logout();
            Principal.authenticate(null);
        }

        function resetPasswordFinish (keyAndPassword, callback) {
            var cb = callback || angular.noop;

            return PasswordResetFinish.save(keyAndPassword, function () {
                return cb();
            }, function (err) {
                return cb(err);
            }).$promise;
        }

        function resetPasswordInit (mail, callback) {
            var cb = callback || angular.noop;

            return PasswordResetInit.save(mail, function() {
                return cb();
            }, function (err) {
                return cb(err);
            }).$promise;
        }

        function updateAccount (account, callback) {
            var cb = callback || angular.noop;

            return Account.save(account,
                function () {
                    return cb(account);
                },
                function (err) {
                    return cb(err);
                }.bind(this)).$promise;
        }

        function getPreviousState() {
            var previousState = $sessionStorage.previousState;
            return previousState;
        }

        function resetPreviousState() {
            delete $sessionStorage.previousState;
        }

        function storePreviousState(previousStateName, previousStateParams) {
            var previousState = { "name": previousStateName, "params": previousStateParams };
            $sessionStorage.previousState = previousState;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('platformApp')
        .factory('AuthServerProvider', AuthServerProvider);

    AuthServerProvider.$inject = ['$http', '$localStorage', '$sessionStorage', '$q'];

    function AuthServerProvider ($http, $localStorage, $sessionStorage, $q) {
        var service = {
            getToken: getToken,
            login: login,
            loginWithToken: loginWithToken,
            storeAuthenticationToken: storeAuthenticationToken,
            logout: logout
        };

        return service;

        function getToken () {

            return $localStorage.authenticationToken || $sessionStorage.authenticationToken;
        }

        function login (credentials) {

            var data = {
                username: credentials.username,
                password: credentials.password,
                rememberMe: credentials.rememberMe
            };
            return $http.post('bunny/api/authenticate', data).success(authenticateSuccess);

            function authenticateSuccess (data, status, headers) {
                var bearerToken = headers('Authorization');
                if (angular.isDefined(bearerToken) && bearerToken.slice(0, 7) === 'Bearer ') {
                    var jwt = bearerToken.slice(7, bearerToken.length);
                    service.storeAuthenticationToken(jwt, credentials.rememberMe);
                    return jwt;
                }
            }
        }

        function loginWithToken(jwt, rememberMe) {
            var deferred = $q.defer();

            if (angular.isDefined(jwt)) {
                this.storeAuthenticationToken(jwt, rememberMe);
                deferred.resolve(jwt);
            } else {
                deferred.reject();
            }

            return deferred.promise;
        }

        function storeAuthenticationToken(jwt, rememberMe) {
            if(rememberMe){
                $localStorage.authenticationToken = jwt;
            } else {
                $sessionStorage.authenticationToken = jwt;
            }
        }

        function logout () {
            delete $localStorage.user;
            delete $localStorage.authenticationToken;
            delete $sessionStorage.authenticationToken;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('platformApp')
        .factory('Activate', Activate);

    Activate.$inject = ['$resource'];

    function Activate ($resource) {
        var service = $resource('api/activate', {}, {
            'get': { method: 'GET', params: {}, isArray: false}
        });

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('platformApp')
        .factory('Account', Account);

    Account.$inject = ['$resource'];

    function Account ($resource) {
        var service = $resource('bunny/api/front-users/account', {}, {
            'get': { method: 'GET', params: {}, isArray: false,
                interceptor: {
                    response: function(response) {
                        return response;
                    }
                }
            }
        });

        return service;
    }
})();

(function () {
    'use strict';

    angular
        .module('platformApp')
        .controller('NavbarController', NavbarController);

    NavbarController.$inject = ['$state', 'Auth', 'Principal', 'ProfileService', 'LoginService', '$scope',
    '$localStorage', '$uibModal','Catalog', "Notice", '$rootScope'];

    function NavbarController($state, Auth, Principal, ProfileService, LoginService, $scope,
     $localStorage, $uibModal,Catalog, Notice, $rootScope) {
        var vm = this;
        vm.isNavbarCollapsed = true;
        vm.isAuthenticated = Principal.isAuthenticated;
        vm.menus=[];
        vm.menusSelf=[];
        vm.account = $localStorage.user;

        vm.current = $state.current;
        $rootScope.$on('$stateChangeStart',
            function(event, toState, toParams, fromState, fromParams) {
                vm.current = toState;
                console.log(toState);
            })
    }
})();

(function () {
    'use strict';

    var homeNav1 = {
        restrict: 'EAC',
        replace: true,
        transclude: true,
        templateUrl: 'app/layouts/navbar/home-nav1.html',
        controllerAs: 'vm',
        bindings: {
            current: '<',
        },
        controller: ['$state', 'Auth', 'Principal',
            function ($state, Auth, Principal) {
                var vm = this;
                vm.isNavbarCollapsed = true;
                vm.isAuthenticated = Principal.isAuthenticated;
            }]
    };

    angular
        .module('platformApp')
        .component('homeNav1', homeNav1);
})();

(function () {
    'use strict';

    var homeNav = {
        restrict: 'EAC',
        replace: true,
        transclude: true,
        templateUrl: 'app/layouts/navbar/home-nav.html',
        controllerAs: 'vm',
        bindings: {
            current: '<',
        },
        controller: ['$state', 'Auth', 'Principal',
            function ($state, Auth, Principal) {
                var vm = this;
                vm.isNavbarCollapsed = true;
                vm.isAuthenticated = Principal.isAuthenticated;
            }]
    };

    angular
        .module('platformApp')
        .component('homeNav', homeNav);
})();

(function () {
    "use strict";

    var homeHead = {
        restrict: "EAC",
        replace: true,
        transclude: true,
        templateUrl: "app/layouts/navbar/home-head.html",
        controllerAs: "vm",
        bindings: {},

        controller: [
            "$state",
            "Auth",
            "Principal",
            "ProfileService",
            "LoginService",
            "$scope",
            "$localStorage",
            "$uibModal",
            "Catalog",
            "Notice",
            "$rootScope",
            function (
                $state,
                Auth,
                Principal,
                ProfileService,
                LoginService,
                $scope,
                $localStorage,
                $uibModal,
                Catalog,
                Notice,
                $rootScope
            ) {
                var vm = this;

                vm.isNavbarCollapsed = true;
                vm.isAuthenticated = Principal.isAuthenticated;
                vm.login = login;
                vm.logout = logout;
                vm.menus = [];
                vm.menusSelf = [];
                vm.account = $localStorage.user;

                var unsubscribe = $rootScope.$on("platformApp:noticeUpdate", function (event) {
                    $scope.getNotice();
                });

                Catalog.findCatalogByProductXml({ custom: true, type: "LAYOUT" }, function (data) {
                    if (data.status == 200) {
                        vm.catalogs = data.message;
                    }
                });

                vm.categoryList = [
                    { name: "模板分类", value: "module", path: "catalog-management", catalogType: "XML" },
                    { name: "布局分类", value: "layout", path: "catalog-management", catalogType: "LAYOUT" },
                    { name: "素材分类", value: "material", path: "catalog-management", catalogType: "CLIPART" },
                    { name: "边框分类", value: "border", path: "catalog-management", catalogType: "BORDER" }
                ];

                vm.items = ["设计工具", "分享中心", "消息中心"];
                $scope.selectedEvent = vm.items[0];
                if (
                    $state.current.name == "textShare" ||
                    $state.current.name == "picture-share" ||
                    $state.current.name == "calendar-center-body" ||
                    $state.current.name == "calendar-center-title"
                ) {
                    $scope.selectedEvent = "分享中心";
                }
                if ($state.current.name == "notice") {
                    $scope.selectedEvent = "消息中心";
                }

                vm.current = $state.current;
                $rootScope.$on("$stateChangeStart", function (event, toState, toParams, fromState, fromParams) {
                    vm.current = toState;
                });

                $scope.templateList = function () {
                    $scope.getCatalogs();
                    $scope.getSelfCatalogs();
                    //$state.go("templateList");
                };
                $scope.chooseItem = function (item) {
                    $scope.selectedEvent = item;
                    if (item == "设计工具") {
                        $(".sidebar1").show();
                        $state.go("page");
                    }
                    if (item == "分享中心") {
                        $state.go("textShare");
                    }
                    if (item == "消息中心") {
                        $state.go("notice");
                    }
                };
                function login() {
                    LoginService.open();
                }

                function logout() {
                    vm.account = null;
                    Auth.logout();
                    $state.go("home");
                }

                var createModal = function (url, controller) {
                    return $uibModal.open({
                        templateUrl: url,
                        controller: controller,
                        backdrop: "static",
                        keyboard: true,
                        windowClass: "jh-modal-md",
                        controllerAs: "vm",
                        resolve: {
                            pagingParams: [
                                "$stateParams",
                                "PaginationUtil",
                                function ($stateParams, PaginationUtil) {
                                    return {
                                        page: PaginationUtil.parsePage($stateParams.page)
                                    };
                                }
                            ],
                            translatePartialLoader: [
                                "$translate",
                                "$translatePartialLoader",
                                function ($translate, $translatePartialLoader) {
                                    $translatePartialLoader.addPart("password");
                                    return $translate.refresh();
                                }
                            ]
                        }
                    });
                };

                $scope.resetPassword = function () {
                    createModal("app/account/password/password.html", "PasswordController").result.then(function (
                        data
                    ) {});
                };
                vm.remind = 0;
                $scope.getNotice = function () {
                    //需要接口调用
                    Notice.getAllByCondition1({ items: [] }, function (data) {
                        if (data && data.message && data.message.length > 0) {
                            for (var i = data.message.length - 1; i >= 0; i--) {
                                var notice = data.message[i];
                                if (!notice.read) {
                                    vm.remind = vm.remind + 1;
                                }
                            }
                        }
                    });
                };
                $scope.getNotice();
                $scope.readBatch = function () {
                    Notice.readAll({}, function () {
                        vm.remind = 0;
                        messageInit();
                    });
                };
                $scope.jzMessageOver = function () {
                    messageInit();
                };
                function messageInit() {
                    vm.jzMessage = [];
                    Notice.getAllByCondition1({ items: [] }, function (data) {
                        if (data && data.message && data.message.length > 0) {
                            vm.jzMessage = data.message;
                        }
                    });
                }

                $scope.read = function (data) {
                    if (!data.read) {
                        Notice.read({ id: data.id });
                    }
                    $uibModal
                        .open({
                            templateUrl: "app/entities/notice/notice-detail.html",
                            controller: "NoticeDetailController",
                            backdrop: "static",
                            keyboard: true,
                            windowClass: "jh-modal-md",
                            controllerAs: "vm",
                            size: "lg",
                            resolve: {
                                entity: data
                            }
                        })
                        .result.then(function (res) {
                            data.read = true;
                        });
                };
            }
        ]
    };

    angular.module("platformApp").component("homeHead", homeHead);
})();

(function() {
    'use strict';

    angular
        .module('platformApp')
        .directive('activeMenu', activeMenu);

    activeMenu.$inject = ['$translate', '$locale', 'tmhDynamicLocale'];

    function activeMenu($translate, $locale, tmhDynamicLocale) {
        var directive = {
            restrict: 'A',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            var language = attrs.activeMenu;

            scope.$watch(function() {
                return $translate.use();
            }, function(selectedLanguage) {
                if (language === selectedLanguage) {
                    tmhDynamicLocale.set(language);
                    element.addClass('active');
                } else {
                    element.removeClass('active');
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('platformApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('error', {
                parent: 'app',
                url: '/error',
                data: {
                    authorities: [],
                    pageTitle: 'error.title'
                },
                views: {
                    'content': {
                        templateUrl: 'app/layouts/error/error.html'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('error');
                        return $translate.refresh();
                    }]
                }
            })
            .state('accessdenied', {
                parent: 'app',
                url: '/accessdenied',
                data: {
                    authorities: []
                },
                views: {
                    'content': {
                        templateUrl: 'app/layouts/error/accessdenied.html'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('error');
                        return $translate.refresh();
                    }]
                }
            });
    }
})();

(function() {
    'use strict';

    angular
        .module('platformApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('home', {
            parent: 'app',
            url: '/',
            data: {
                authorities: [],
                pageTitle: 'platformAppTitle.login'
            },
            views: {
                'navbar@': {
                    templateUrl: 'app/home/home.html',
                    controller: 'HomeController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    $translatePartialLoader.addPart('home');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('platformApp')
        .controller('HomeController', HomeController);

    HomeController.$inject = ['$scope', 'Principal', 'MessageService', '$state', 'Auth', '$rootScope',
    '$localStorage'];

    function HomeController ($scope, Principal, MessageService, $state, Auth, $rootScope,
        $localStorage) {
        var vm = this;
        vm.passType = 'password';
        vm.account = null;
        vm.isAuthenticated = null;
        vm.login = login;
        vm.register = register;
        vm.rememberMe = true;
        vm.changePassType = changePassType;
        $scope.$on('authenticationSuccess', function() {
            getAccount();
        });

        $(".navbar").hide();
        $(".wrap").css({margin:0});
        Auth.logout();
        getAccount();

        //修改密码框类型
        function changePassType(type){
            vm.passType = type;
        }
        function getAccount() {
            Principal.identity().then(function(account) {
                vm.account = account;
                vm.isAuthenticated = Principal.isAuthenticated;
            });
        }

        function login(event) {
            if (vm.username == null || vm.username == '' || vm.password == null || vm.password == '') {
                MessageService.error("请输入用户名和密码");
                return;
            }
            event.preventDefault();
            Auth.login({
                username: vm.username,
                password: vm.password,
                rememberMe: vm.rememberMe
            }).then(function () {
                vm.authenticationError = false;
                $(".navbar").show();
                vm.account = $localStorage.user;
                $(".users-a").html(vm.account.name)
                $state.go('page');
                $(".wrap").css({margin: '48px 0 10px 254px'});
                delete $localStorage.menu1;
                delete $localStorage.menu2;
                delete $localStorage.pageName;
                $rootScope.$broadcast('authenticationSuccess');
                if (Auth.getPreviousState()) {
                    var previousState = Auth.getPreviousState();
                    Auth.resetPreviousState();
                    $state.go(previousState.name, previousState.params);
                }
            }).catch(function (error) {
                if (error && error.data && error.data["com.boostech.westeros.security.UserNotActivatedException"]) {
                    MessageService.error("用户未激活");
                }else{
                    MessageService.error("用户名或密码不正确");
                }
                vm.authenticationError = true;
            });


        }

        function register () {
            $state.go('register');
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('platformApp')
        .controller('TextXmlEditController', TextXmlEditController);

    TextXmlEditController.$inject = ['$state', '$scope', 'UidService', 'ProductXml', 'ParseLinks', 'AlertService', 'MessageService', '$uibModal', 'FontManagement', 'Qinius', '$q', '$timeout', 'FontXmls', '$stateParams', 'ImageService', 'ClipArts', 'Backgrounds', '$http', 'ThemeClassify'];

    function TextXmlEditController($state, $scope, UidService, ProductXml, ParseLinks, AlertService, MessageService, $uibModal, FontManagement, Qinius, $q, $timeout, FontXmls, $stateParams, ImageService, ClipArts, Backgrounds, $http, ThemeClassify) {
        var vm = this;
        vm.loading = true;
        vm.menuImageView = menuImageView;
        vm.materialUnfold = false;
        vm.chineseSupport = true;
        //是否是拖曳画布状态
        vm.moveCanvasView = false;
        vm.moveCanvasInfo = {
            x:0,
            y:0
        }
        //初始化画布移动信息
        vm.initMoveCanvasInfo = function(){
            vm.moveCanvasInfo = {
                x:0,
                y:0
            }
        }
        $scope.materialUnfold = function(){
            vm.materialUnfold = !vm.materialUnfold;
        }
        if($stateParams.id){
            vm.data = FontXmls.get({id : $stateParams.id});
        }else{
            vm.textPage = JSON.parse(localStorage.textPage);
            vm.data = {
                name: vm.textPage.name,
                cover: '',
                identifier: '',
                textDocument: {
                    movable: true,
                    editable: true,
                    rotation: {angle: 0},
                    background: {
                        resource: {
                            provider: '',
                            identifier: '',
                            width: '',
                            height: '',
                        },
                        offsetx: '0',
                        offsety: '0',
                        adaptation: 'Width',
                        type: 'FontXml',
                        color: '',
                        scale: '1'
                    },
                    geometry: {
                        x: '0',
                        y: '0',
                        width: vm.textPage.width,
                        height: vm.textPage.height
                    },
                    levels: {
                        level: [
                            // {
                            //     seq: '1',
                            //     textbox: {
                            //             geometry: {
                            //                 x: '0',
                            //                 y: '0',
                            //                 width: '',
                            //                 height: ''
                            //             },
                            //             rotation: {
                            //                 angle: '0'
                            //             },
                            //             text: '',
                            //             style: {
                            //                 font: '',
                            //                 size: '',
                            //                 color: '',
                            //                 bold: '',
                            //                 italic: '',
                            //                 lineheight: '',
                            //                 letterspacing: '',
                            //             },
                            //             identifier: '',
                            //             editable: false,
                            //             movable: false,
                            //             version: false,
                            //             transparency: '1',
                            //         },
                            //     imageart: {
                            //             movable: false,
                            //             editable: false,
                            //             onlyshow: false,
                            //             offsetX: '10',
                            //             offsetY: '10',
                            //             transparency: '1',
                            //             geometry: {
                            //                 x: '0',
                            //                 y: '0',
                            //                 width: '',
                            //                 height: ''
                            //             },
                            //             rotation: {
                            //                 angle: '0'
                            //             },
                            //             resource: {
                            //                 provider: '',
                            //                 identifier: '',
                            //             },
                            //         }
                            // }
                        ]
                    }
                }
            }
        }
        ThemeClassify.getAllByCondition4({type:'CLIPART'}, function (res) {
            vm.themeClassifies = res.message;
        });

        $scope.domains = Qinius.getDomain();
        vm.fileSelect = [
            {name: 'rain', id:'1'}
        ];
        vm.navList = [
            {img:'/content/images/icons/nav_font.svg', name: '字体', id:'font'},
            {img:'/content/images/icons/nav_font.svg', name: '背景', id:'background'},
            {img:'/content/images/icons/nav_font.svg', name: '素材', id:'material'}
        ]
        vm.navPitch = 'font';
        vm.units = [
            { name: 'px', id: 'px'},
            { name: 'mm', id: 'mm'}
        ];
        vm.xmlSelect = {
            type: '',
            transparency: 0,
            editable: true
        };
        vm.font = {
            geometry: {
                x: '0',
                y: '0',
                width: '',
                height: ''
            },
            rotation: {
                angle: '0'
            },
            text: '',
            style: {
                font: '',
                size: '',
                color: '',
                bold: '',
                italic: '',
                lineheight: '',
                letterspacing: '',
            },
            identifier: '',
            editable: true,
            movable: true,
            lock: false,
            version: '2.0',
            transparency: '1'
        };
        vm.sizeList = [
            {name: '6', id: '6'},
            {name: '7', id: '7'},
            {name: '8', id: '8'},
            {name: '9', id: '9'},
            {name: '10', id: '10'},
            {name: '11', id: '11'},
            {name: '12', id: '12'},
            {name: '13', id: '13'},
            {name: '14', id: '14'},
            {name: '15', id: '15'},
            {name: '16', id: '16'},
            {name: '17', id: '17'},
            {name: '18', id: '18'},
            {name: '19', id: '19'},
            {name: '20', id: '20'},
            {name: '21', id: '21'},
            {name: '22', id: '22'},
            {name: '23', id: '23'},
            {name: '24', id: '24'},
            {name: '25', id: '25'},
            {name: '26', id: '26'},
            {name: '27', id: '27'},
            {name: '28', id: '28'},
            {name: '29', id: '29'},
            {name: '30', id: '30'},
            {name: '31', id: '31'},
            {name: '32', id: '32'},
            {name: '33', id: '33'},
            {name: '34', id: '34'},
            {name: '35', id: '35'},
            {name: '36', id: '36'},
            {name: '37', id: '37'},
            {name: '38', id: '38'},
            {name: '39', id: '39'},
            {name: '40', id: '40'},
            {name: '41', id: '41'},
            {name: '42', id: '42'},
            {name: '43', id: '43'},
            {name: '44', id: '44'},
            {name: '45', id: '45'},
            {name: '46', id: '46'},
            {name: '47', id: '47'},
            {name: '48', id: '48'},
            {name: '49', id: '49'},
            {name: '50', id: '50'},
            {name: '51', id: '51'},
            {name: '52', id: '52'},
            {name: '53', id: '53'},
            {name: '54', id: '54'},
            {name: '55', id: '55'},
            {name: '56', id: '56'},
            {name: '57', id: '57'},
            {name: '58', id: '58'},
            {name: '59', id: '59'},
            {name: '60', id: '60'},
            {name: '61', id: '61'},
            {name: '62', id: '62'},
            {name: '63', id: '63'},
            {name: '64', id: '64'},
            {name: '65', id: '65'},
            {name: '66', id: '66'},
            {name: '67', id: '67'},
            {name: '68', id: '68'},
            {name: '69', id: '69'},
            {name: '70', id: '70'},
            {name: '71', id: '71'},
            {name: '72', id: '72'},
            {name: '73', id: '73'},
            {name: '74', id: '74'},
            {name: '75', id: '75'},
            {name: '76', id: '76'},
            {name: '77', id: '77'},
            {name: '78', id: '78'},
            {name: '79', id: '79'},
            {name: '80', id: '80'},
            {name: '81', id: '81'},
            {name: '82', id: '82'},
            {name: '83', id: '83'},
            {name: '84', id: '84'},
            {name: '85', id: '85'},
            {name: '86', id: '86'},
            {name: '87', id: '87'},
            {name: '88', id: '88'},
            {name: '89', id: '89'},
            {name: '89', id: '90'},
            {name: '91', id: '91'},
            {name: '92', id: '92'},
            {name: '93', id: '93'},
            {name: '94', id: '94'},
            {name: '95', id: '95'},
            {name: '96', id: '96'},
            {name: '97', id: '97'},
            {name: '98', id: '98'},
            {name: '99', id: '99'},
            {name: '100', id: '100'},
        ]
        vm.colorList = [
            {name: '#000000', id: '#000000'},
            {name: '#666666', id: '#666666'},
            {name: '#a8a8a8', id: '#a8a8a8'},
            {name: '#d9d9d9', id: '#d9d9d9'},
            {name: '#ffffff', id: '#ffffff'},
            {name: '#647c6e', id: '#647c6e'},
            {name: '#ffbd4a', id: '#ffbd4a'},
            {name: '#fef952', id: '#fef952'},
            {name: '#99e264', id: '#99e264'},
            {name: '#36b72a', id: '#36b72a'},
            {name: '#44d9e5', id: '#44d9e5'},
            {name: '#c27171', id: '#c27171'},
            {name: '#2fb3ff', id: '#2fb3ff'},
            {name: '#b760a6', id: '#b760a6'},
        ]
        vm.isFont = false;
        vm.isOperationColor = false;
        vm.cookies = [];
        vm.cookieIndex = 0;
        vm.isUnfold = false;
        vm.isUnfoldRight = false;
        vm.isXmlDblclick = false;
        vm.isImageartTrim = false;
        vm.imageartTrim = null;

        //素材
        vm.materialList = [];
        vm.materialSum = 10;
        vm.materialIndex = 0;
        vm.isMaterialData = false;
        vm.isTheme = "isTheme";
        function materialInit(){
            ClipArts.byCondition({
                items: [{key: "type", op: "=", value: "USER"}],
                page: vm.materialIndex,
                size: vm.materialSum,
                sort: ["id,desc"]
            }, function (res) {
                for(var i=0; i<res.length; i++){
                    if(!res[i].cancelled){
                        res[i].identifier = vm.url + res[i].identifier;
                        vm.materialList.push(res[i])
                    }
                }
                if(res.length < vm.materialSum){
                    vm.isMaterialData = true;
                }
            });
        }
        $scope.themeClassifiesCb1 = function(){
            vm.materialList = [];
            vm.materialSum = 10;
            vm.materialIndex = 0;
            vm.isMaterialData = false;
            vm.isTheme = "isTheme";
            materialInit()
        }
        $scope.themeClassifiesCb = function(item){
            vm.materialList = [];
            vm.materialSum = 10;
            vm.materialIndex = 0;
            vm.isMaterialData = false;
            vm.isTheme = item.id;
            materialInit1()
        }
        function materialInit1(){
            ClipArts.byCondition({
                items: [{key:"themeClassify.id", op:"=",value:vm.isTheme}],
                page: vm.materialIndex,
                size: vm.materialSum,
                sort: ["id,desc"]
            }, function (res) {
                for(var i=0; i<res.length; i++){
                    if(!res[i].cancelled){
                        res[i].identifier = vm.url + res[i].identifier;
                        vm.materialList.push(res[i])
                    }
                    if(res.length < vm.materialSum){
                        vm.isMaterialData = true;
                    }
                }
            }, function (error) {
                vm.isMaterialData = true;
            });
        }
        $scope.materialPageing = function(){
            vm.materialIndex++;
            if(vm.isTheme == 'isTheme'){
                materialInit()
            }else {
                materialInit1()
            }
        }
        //背景
        vm.bgImgList = [];
        vm.bgImgSum = 20;
        vm.bgImgIndex = 0;
        vm.isBgImgData = false;
        vm.showBackgroundsLabel = false;
        function backgroundInit(){
            ThemeClassify.getAllByCondition1({
                items: [{key: "type", op: "=", value: 'BACKGROUND'}, {
                    key: "used",
                    op: "=",
                    value: true
                }], sort: ["seq,asc"]
            }, function (res) {
                vm.backgroundLabels = angular.copy(res);
                vm.backgroundLabels.unshift({
                    id:'',
                    name:'全部'
                });
                $scope.backgroundData(vm.backgroundLabels[0].id)
            });
        }
        $scope.backgroundData = function(id){
            vm.backgroundLabel = id;
            vm.bgImgIndex = 0;
            vm.bgImgList=[];
            backgroundsByCondition();
        }
        function backgroundsByCondition(){
            Backgrounds.byCondition({
                items: [{key: "themeClassify.id", op: "=", value: vm.backgroundLabel}],
                page: vm.bgImgIndex,
                size: vm.bgImgSum,
                sort: ["id,desc"]
            }, function (res, headers) {
                for(var i=0; i<res.length; i++){
                    if(!res[i].cancelled){
                        res[i].identifier = vm.url + res[i].identifier;
                        vm.bgImgList.push(res[i])
                    }
                }
                if(res.length < vm.bgImgSum){
                    vm.isBgImgData = true;
                }
            })
        }
        $scope.bgImgPageing = function(){
            vm.bgImgIndex++;
            backgroundsByCondition()
        }
        $scope.$watch(function() {
            return vm.data.name;
        }, function(newName, oldName) {
            if (newName!==undefined) {
                document.title = newName + '-设计页'
            }
        });
        $q.all([$scope.domains.$promise, vm.data.$promise]).then(function () {
            if($stateParams.id){
                vm.data = unitPx(vm.data);
                vm.textPage = {
                    name: vm.data.name,
                    width: vm.data.textDocument.geometry.width,
                    height: vm.data.textDocument.geometry.height,
                    unit: 'px'
                }
            }
            vm.url = $scope.domains.domain;
            vm.unit = vm.textPage.unit;
            backgroundInit();
            materialInit();
            //获取字体
            vm.fontList = [];
            vm.fontList1 = [];
            FontManagement.getAll3({}, function (res) {
                vm.fontList = angular.copy(res);
                vm.fontList1 = angular.copy(res);
            });
            //获取token
            Qinius.get(function (msg) {
                vm.token = msg.token;
            });
            //初始化像素
            if(vm.unit == 'mm'){
                vm.data.textDocument.geometry.width = (vm.textPage.width/25.4 * vm.windowDpiW).toFixed(2);
                vm.data.textDocument.geometry.height = (vm.textPage.height/25.4 * vm.windowDpiH).toFixed(2);
                //属性栏
                vm.attribute = {
                    product: {
                        width: (vm.data.textDocument.geometry.width/vm.windowDpiW*25.4).toFixed(2),
                        height:(vm.data.textDocument.geometry.height/vm.windowDpiH*25.4).toFixed(2),
                    },
                    background: {
                        width: '',
                        height: '',
                        x: '',
                        y: ''
                    },
                    material: {
                        width: '',
                        height: '',
                        x: '',
                        y: '',
                    },
                    font: {
                        width: '',
                        x: '',
                        y: '',
                    }
                }
            }
            if (vm.unit == 'px'){
                vm.data.textDocument.geometry.width = vm.textPage.width;
                vm.data.textDocument.geometry.height = vm.textPage.height;
                //属性栏
                vm.attribute = {
                    product: {
                        width: vm.data.textDocument.geometry.width,
                        height:vm.data.textDocument.geometry.height,
                    },
                    background: {
                        width: '',
                        height: '',
                        x: '',
                        y: ''
                    },
                    material: {
                        width: '',
                        height: '',
                        x: '',
                        y: '',
                    },
                    font: {
                        width: '',
                        x: '',
                        y: '',
                    }
                }
            }
            //背景宽高
            $timeout(function () {
                //作品宽高
                initWindow()
                bgImgInit(true);
                vm.loading = false;
                $timeout(function () {
                    vm.dataInit = angular.copy(vm.data);
                },1000)
            }, 500)
            //下载字体
            if(vm.data.textDocument.levels.level){
                for(var i=0; i<vm.data.textDocument.levels.level.length; i++){
                    if(vm.data.textDocument.levels.level[i].textbox) {
                        var textbox = vm.data.textDocument.levels.level[i].textbox;
                        getFont(textbox)
                    }
                }
            }
        })
        $scope.navCb = function (data) {
            vm.navPitch = data;
            // if(vm.navPitch == data.id){
            //     vm.isUnfold = !vm.isUnfold;
            //     // vm.isUnfoldRight = !vm.isUnfoldRight;
            // }else {
            //     vm.navPitch = data.id;
            //     vm.isUnfold = false;
            //     // vm.isUnfoldRight = false;
            // }
        };
        $scope.unfoldLeft = function(){
            vm.isUnfold = !vm.isUnfold;
        }
        $scope.unfoldRight = function(){
            vm.isUnfoldRight = !vm.isUnfoldRight;
        }
        // 背景图和素材的上传
        var bigSizePics = [];
        window.updatePic = function ($event,item) {
            vm.uploadType = item;
            $scope.$digest();
            var files = $event.target.files;
            bigSizePics = [];
            for (var i = 0; i < files.length; i++) {
                var file = files[i];
                if (file.size >= 20 * 1024 * 1024) {
                    file.imageSize = Math.ceil(file.size / 1024 / 1024);
                    bigSizePics.push(file);
                } else {
                    getBgImg(files, i, item);
                    if (bigSizePics.length == 0 && i == (files.length - 1)) {
                        setTimeout(function () {
                            $scope.$digest();
                        }, 600);
                    }
                }
            }
            if (bigSizePics.length > 0) {
                thumbnailatorPic();
            }
            $event.srcElement.value = ""
        };
        function getBgImg(files, i, item) {
            var formData = new FormData();
            var fileName = files[i].name;
            formData.append('file', files[i]);
            formData.append('unique_names', false);
            if(item == 'background'){
                formData.append('key', 'background-' + UidService.get());
            }else if(item == 'material'){
                formData.append('key', 'clipArt-' + UidService.get());
            }else {
                formData.append('key', 'file-' + UidService.get());
            }
            formData.append('token', vm.token);
            $.ajax({
                cache: true,
                type: "POST",
                url: 'https://upload.qiniup.com/',
                data: formData,
                async: true,
                contentType: false,
                processData: false,
                success: function (data) {
                    if(item == 'background'){
                        Backgrounds.save({
                            identifier: data.key,
                            provider: 'qiniu',
                            name: fileName,
                            type: 'FontXml',
                            themeClassifyId:vm.backgroundLabel
                        }, function (resp) {
                            resp.identifier = vm.url + resp.identifier;
                            vm.bgImgList.unshift(resp);
                        });
                    }
                    if(item == 'material'){
                        ClipArts.createOne({
                            identifier: data.key,
                            provider: 'qiniu'
                        }, function (resp) {
                            // resp.identifier = vm.url + resp.identifier;
                            // vm.materialList.unshift(resp);
                            $scope.themeClassifiesCb1();
                        });
                    }
                    $scope.$apply();
                    i++;
                    //if (i < files.length) {
                        //getBgImg(file, i, item);
                    //}
                },
                error: function (error) {
                    MessageService.error("图片上传失败");
                }
            });
        }
        $scope.bgImgCb = function(data){
            if(vm.textEditor){return}
            vm.data.textDocument.background.resource.identifier = data.identifier;
            vm.data.textDocument.background.offsetx = 0;
            vm.data.textDocument.background.offsety = 0;
            $timeout(function () {
                bgImgInit()
            })
        };
        $scope.bgImgDelete = function ($event, item, index) {
            Backgrounds.delete({id: item.id}, function () {
                vm.bgImgList.splice(index, 1)
            });
            var $event = $event || window.event;
            if($event && $event.preventDefault){
                $event.preventDefault();
            }
            else {
                window.event.returnValue = false;
                return false;
            }
            $event.stopPropagation();
        }
        $scope.materialDelete = function ($event, item, index) {
            var $event = $event || window.event;
            if($event && $event.preventDefault){
                $event.preventDefault();
            }
            else {
                window.event.returnValue = false;
                return false;
            }
            $event.stopPropagation();
            ClipArts.delete({id: item.id}, function () {
                vm.materialList.splice(index, 1)
            });
        }
        //拖动背景
        var isBgImgMouseDown = false;
        var oldX = 0;
        var oldY = 0;
        //鼠标按下事件
        $scope.bgImgMouseDown = function ($event) {
            var $event = $event || window.event;
            if($event && $event.preventDefault){
                $event.preventDefault();
            }
            else {
                window.event.returnValue = false;
                return false;
            }
            $event.stopPropagation();
            var x = $event.clientX;
            var y = $event.clientY;
            var l = $event.target.offsetParent.offsetLeft;
            var t = $event.target.offsetParent.offsetTop;

            var x1 = $event.target.offsetLeft;
            var y1 = $event.target.offsetTop;
            oldX = $event.target.offsetLeft;
            oldY = $event.target.offsetTop;

            var l1 = -($($event.target).width() - vm.data.textDocument.geometry.width * vm.ratio);
            var t1 = -($($event.target).height() - vm.data.textDocument.geometry.height * vm.ratio);
            //开关打开
            isBgImgMouseDown = true;
            //鼠标移动
            window.onmousemove = function (e) {
                if (isBgImgMouseDown == false) {
                    return;
                }
                //获取x和y
                var nx = e.clientX;
                var ny = e.clientY;
                //计算移动后的左偏移量和顶部的偏移量
                var nl = Number(nx - (x - l)) + Number(x1);
                var nt = Number(ny - (y - t)) + Number(y1);

                if(vm.data.textDocument.background.adaptation == 'Height'){
                    // if(nl == 0){ return;}
                    if(nl < l1){nl = Number(l1) + Number(1);}
                    if(nl > 0){nl = 0;}
                    vm.data.textDocument.background.offsetx = nl / vm.ratio;
                    $($event.target).css({
                        left: nl + 'px'
                    });
                    $("#c-xml-bgImg-trim-img").find('img').css({
                        left: nl + 'px'
                    });
                }
                if(vm.data.textDocument.background.adaptation == 'Width'){
                    // if(nt == 0){ return;}
                    if(nt <= t1){nt = Number(t1) + Number(1);}
                    if(nt > 0){nt = 0;}
                    vm.data.textDocument.background.offsety = nt / vm.ratio;
                    $($event.target).css({
                        top: nt + 'px'
                    });
                    $("#c-xml-bgImg-trim-img").find('img').css({
                        top: nt + 'px'
                    });
                }
            }
            //鼠标抬起事件
            window.onmouseup = function ($event) {
                isBgImgMouseDown = false;
                $event.stopPropagation();
            }
            cookie()
        }
        $scope.bgImgFalseClick = function () {
            vm.isXmlDblclick = false;
            vm.data.textDocument.background.offsetx = oldX / vm.ratio;
            vm.data.textDocument.background.offsety = oldY / vm.ratio;
            $("#c-xmlbgImg").css({
                top: oldY + 'px',
                left: oldX + 'px'
            });
        }
        $scope.bgImgTrueClick = function () {
            vm.isXmlDblclick = false;
        }
        function bgImgInit(){
            vm.data.textDocument.background.scale = 1;
            getBackgroundSource($http, vm.data.textDocument.background.resource, vm.data.textDocument.geometry.width, vm.data.textDocument.geometry.height, vm.data.textDocument.background, $scope, function () {
                if(vm.unit == 'mm'){
                    vm.attribute.background = {
                        x: (vm.data.textDocument.background.offsetx/vm.windowDpiW*25.4).toFixed(2),
                        y: (vm.data.textDocument.background.offsety/vm.windowDpiH*25.4).toFixed(2)
                    }
                }
                if (vm.unit == 'px'){
                    vm.attribute.background = {
                        x: vm.data.textDocument.background.offsetx,
                        y: vm.data.textDocument.background.offsety
                    }
                }
            });
        }
        //添加素材
        $scope.materialCb = function(data){
            if(vm.textEditor){return}

            var newImg = document.createElement('img');
            newImg.crossOrigin = "Anonymous";
            newImg.src = data.identifier + '?imageView2';
            newImg.onload = function () {
                var _material = {
                    movable: true,
                    lock: false,
                    editable: true,
                    onlyshow: false,
                    offsetx: '0',
                    offsety: '0',
                    transparency: '1',
                    geometry: {
                        x: '0',
                        y: '0',
                        width: '',
                        height: ''
                    },
                    rotation: {
                        angle: '0'
                    },
                    resource: {
                        provider: '',
                        identifier: data.identifier,
                        width:'',
                        height: ''
                    },
                    scale: 1,
                    selected: false
                };
                var bgImgW = newImg.width;
                var bgImgH = newImg.height;
                _material.resource.width = bgImgW;
                _material.resource.height = bgImgH;
                var bgImgR = bgImgW/bgImgH;
                if(bgImgR >= 1){
                    if(bgImgW > vm.data.textDocument.geometry.width){
                        _material.geometry.width = vm.data.textDocument.geometry.width;
                        _material.geometry.height = _material.geometry.width * bgImgH / bgImgW;
                        // _material.scale = vm.data.textDocument.geometry.width / bgImgW;
                    }else {
                        _material.geometry.width = bgImgW;
                        _material.geometry.height = bgImgH;
                    }
                }else {
                    if(bgImgH > vm.data.textDocument.geometry.height){
                        _material.geometry.height = vm.data.textDocument.geometry.height;
                        _material.geometry.width = _material.geometry.height * bgImgW / bgImgH;
                        // _material.scale = vm.data.textDocument.geometry.height / bgImgH;
                    }else {
                        _material.geometry.width = bgImgW;
                        _material.geometry.height = bgImgH;
                    }
                }
                addElement('imageart', _material)
                cookie()
                $scope.$apply();
            };
        }
        //点击素材
        $scope.imageartClick = function ($event, item, index) {
            if(vm.textEditor){return}
            var $event = $event || window.event;
            if ($event.ctrlKey == true || $event.metaKey == true) {
                for(var i=0 ;i<vm.data.textDocument.levels.level.length; i++){
                    if(vm.data.textDocument.levels.level[i].textbox) {
                        var _font = vm.data.textDocument.levels.level[i].textbox;
                        if (_font.selected) {
                            _font.ctrlKey = true;
                        }
                    }
                    if(vm.data.textDocument.levels.level[i].imageart) {
                        var _font = vm.data.textDocument.levels.level[i].imageart;
                        if (_font.selected) {
                            _font.ctrlKey = true;
                        }
                    }
                }
                vm.data.textDocument.levels.level[index].imageart.ctrlKey = true;
                vm.ctrlKeyArray.push(item)
            }else{
                if($event && $event.preventDefault){
                    $event.preventDefault();
                }
                else {
                    window.event.returnValue = false;
                    return false;
                }
                $event.stopPropagation();
                if(!vm.data.textDocument.levels.level[index].imageart.ctrlKey){
                    vm.ctrlKeyArray = [];
                    for(var i1=0 ;i1<vm.data.textDocument.levels.level.length; i1++){
                        if(vm.data.textDocument.levels.level[i1].textbox){
                            vm.data.textDocument.levels.level[i1].textbox.selected = false;
                            vm.data.textDocument.levels.level[i1].textbox.ctrlKey = false;
                        }
                        if(vm.data.textDocument.levels.level[i1].imageart){
                            vm.data.textDocument.levels.level[i1].imageart.selected = false;
                            vm.data.textDocument.levels.level[i1].imageart.ctrlKey = false;
                        }
                    }
                    for(var i=0; i<vm.data.textDocument.levels.level.length; i++){
                        if(vm.data.textDocument.levels.level[i].imageart) {
                            vm.data.textDocument.levels.level[i].imageart.selected = false;
                        }
                    }
                }
                fontHide()
                item.selected = true;
                vm.xmlSelect.type = 'imageart';
                vm.xmlSelect.transparency = item.transparency;
                vm.xmlSelect.editable = item.editable;
                vm.xmlSelect.lock = item.lock;
                if(vm.unit == 'mm'){
                    vm.attribute.material = {
                        width: (item.geometry.width/vm.windowDpiW * 25.4).toFixed(2),
                        height: (item.geometry.height/vm.windowDpiH * 25.4).toFixed(2),
                        x: (item.geometry.x/vm.windowDpiW * 25.4).toFixed(2),
                        y: (item.geometry.y/vm.windowDpiH * 25.4).toFixed(2),
                    }
                }
                if (vm.unit == 'px'){
                    vm.attribute.material = {
                        width: item.geometry.width,
                        height: item.geometry.height,
                        x: item.geometry.x,
                        y: item.geometry.y
                    }
                }
            }
            clearBubble();
        }
        //拖动素材
        var isDown = false;
        $scope.imageartdown = function ($event, item) {
            if(item.lock || vm.textEditor){return}
            var $event = $event || window.event;
            if($event && $event.preventDefault){
                $event.preventDefault();
            }
            else {
                window.event.returnValue = false;
                return false;
            }
            if (vm.ctrlKeyArray.length > 0) {
                levelMove($event);
            }else{
                textMove($event, item)
            }
        }
        //素材缩放right
        var isZoomDown = false;
        $scope.imageartdownZoomRight = function($event, item){
            if(item.lock){return}
            var $event = $event || window.event;
            //防止浏览器默认行为(W3C)
            if($event && $event.preventDefault){
                $event.preventDefault();
            }
            //IE中组织浏览器行为
            else {
                window.event.returnValue = false;
                return false;
            }
            $event.stopPropagation();
            imageartZoom($event, item, 'right')
            // var x = $event.clientX;
            // var y = $event.clientY;
            // //获取w和h
            // var nw = angular.copy(item.geometry.width) * vm.ratio;
            // var nh = angular.copy(item.geometry.height) * vm.ratio;
            // var nw1 = angular.copy(item.resource.width) * vm.ratio;
            // var nh1 = angular.copy(item.resource.height) * vm.ratio;
            // // var x1 = $($event.target).parent().find('.c-xml-page-material-img')[0].offsetLeft;
            // var x1 = angular.copy(item.offsetx * vm.ratio);
            // // var y1 = $($event.target).parent().find('.c-xml-page-material-img')[0].offsetTop;
            // var y1 = angular.copy(item.offsety * vm.ratio);
            // var _scale = angular.copy(item.scale);
            // console.log(nw1 + '/' + nh1)
            // //开关打开
            // isZoomDown = true;
            // //鼠标移动
            // window.onmousemove = function (e) {
            //     if (isZoomDown == false) {
            //         return;
            //     }
            //     //获取x和y
            //     var nx = e.clientX;
            //     var ny = e.clientY;
            //     //计算移动后的左偏移量和顶部的偏移量
            //     var nl = nx - x;
            //     var _w = (Number(nw) + Number(nl));
            //     var _h = _w / nw * nh;
            //     if(_w > vm.data.textDocument.geometry.width * vm.ratio){
            //         _w = vm.data.textDocument.geometry.width * vm.ratio;
            //         _h = _w / nw * nh;
            //     }
            //     if(_h > vm.data.textDocument.geometry.height * vm.ratio){
            //         _h = vm.data.textDocument.geometry.height * vm.ratio;
            //         _w = _h / nh * nw;
            //     }
            //
            //
            //     if(_w > 20){
            //         item.geometry.width = _w / vm.ratio;
            //         item.geometry.height = _h / vm.ratio;
            //         item.offsetx = (_w / (nw / nw1)) / (nw1 / x1) / vm.ratio;
            //         item.offsety = (_h / (nh / nh1)) / (nh1 / y1) / vm.ratio;
            //         $($event.target).parent().css({
            //             width: _w + 'px',
            //             height: _h + 'px'
            //         });
            //         $($event.target).parent().find('.c-xml-page-material-img').css({
            //             width: _w * _scale + 'px',
            //             left:  (_w / (nw / nw1)) / (nw1 / x1) + 'px',
            //             top:  (_h / (nh / nh1)) / (nh1 / y1) + 'px',
            //         });
            //     }
            //     // if(_w > 20){
            //     //     item.scale = _w / nw * _scale;
            //     //     item.geometry.width = _w / vm.ratio;
            //     //     item.geometry.height = _h / vm.ratio;
            //     //     item.offsetx = (_w / (nw / nw1)) / (nw1 / x1) / vm.ratio;
            //     //     item.offsety = (_h / (nh / nh1)) / (nh1 / y1) / vm.ratio;
            //     //     $($event.target).parent().css({
            //     //         width: _w + 'px',
            //     //         height: _h + 'px'
            //     //     });
            //     //     $($event.target).parent().find('.c-xml-page-material-img').css({
            //     //         width: nw1 * item.scale + 'px',
            //     //         height: nh1 * item.scale + 'px',
            //     //         left:  (_w / (nw / nw1)) / (nw1 / x1) + 'px',
            //     //         top:  (_h / (nh / nh1)) / (nh1 / y1) + 'px',
            //     //     });
            //     // }
            //
            //
            //     // item.geometry.width = _w / vm.ratio;
            //     // item.geometry.height = _h / vm.ratio;
            //     // item.resource.width = _w / (nw / nw1) / vm.ratio;
            //     // item.resource.height = _h / (nh / nh1) / vm.ratio;
            //     // item.offsetx = (_w / (nw / nw1)) / (nw1 / x1) / vm.ratio;
            //     // item.offsety = (_h / (nh / nh1)) / (nh1 / y1) / vm.ratio;
            //     // $($event.target).parent().css({
            //     //     width: _w + 'px',
            //     //     height: _h + 'px'
            //     // });
            //     // $($event.target).parent().find('.c-xml-page-material-img').css({
            //     //     width: _w / (nw / nw1) + 'px',
            //     //     height: _h / (nh / nh1) + 'px',
            //     //     left:  (_w / (nw / nw1)) / (nw1 / x1) + 'px',
            //     //     top:  (_h / (nh / nh1)) / (nh1 / y1) + 'px',
            //     // });
            // }
            // //鼠标抬起事件
            // window.onmouseup = function ($event) {
            //     isZoomDown = false;
            //     $event.stopPropagation();
            // }
        }
        //素材缩放left
        $scope.imageartdownZoomLeft = function ($event, item) {
            if(item.lock){return}
            var $event = $event || window.event;
            //防止浏览器默认行为(W3C)
            if($event && $event.preventDefault){
                $event.preventDefault();
            }
            //IE中组织浏览器行为
            else {
                window.event.returnValue = false;
                return false;
            }
            $event.stopPropagation();
            imageartZoom($event, item, 'left')
        }
        //素材缩放top
        $scope.imageartdownZoomTop = function ($event, item) {
            if(item.lock){return}
            var $event = $event || window.event;
            //防止浏览器默认行为(W3C)
            if($event && $event.preventDefault){
                $event.preventDefault();
            }
            //IE中组织浏览器行为
            else {
                window.event.returnValue = false;
                return false;
            }
            $event.stopPropagation();
            imageartZoom($event, item, 'top')
        }
        //素材缩放bottom
        $scope.imageartdownZoomBottom = function ($event, item) {
            if(item.lock){return}
            var $event = $event || window.event;
            //防止浏览器默认行为(W3C)
            if($event && $event.preventDefault){
                $event.preventDefault();
            }
            //IE中组织浏览器行为
            else {
                window.event.returnValue = false;
                return false;
            }
            $event.stopPropagation();
            imageartZoom($event, item, 'bottom')
        }
        function imageartZoom($event,item, direction) {
            var x = $event.clientX;
            var y = $event.clientY;
            //获取w和h
            var nw = angular.copy(item.geometry.width) * vm.ratio;
            var nh = angular.copy(item.geometry.height) * vm.ratio;
            var nw1 = angular.copy(item.resource.width) * vm.ratio;
            var nh1 = angular.copy(item.resource.height) * vm.ratio;
            var x1 = angular.copy(item.offsetx * vm.ratio);
            var y1 = angular.copy(item.offsety * vm.ratio);
            var x2 = item.geometry.x * vm.ratio;
            var y2 = item.geometry.y * vm.ratio;
            var _scale = angular.copy(item.scale);
            //开关打开
            isZoomDown = true;
            //鼠标移动
            window.onmousemove = function (e) {
                if (isZoomDown == false) {
                    return;
                }
                //获取x和y
                var nx = e.clientX;
                //计算移动后的左偏移量和顶部的偏移量
                var nl = nx - x;

                if(direction == 'bottom' || direction == 'left'){
                    var _w = (Number(nw) - Number(nl));
                }
                if(direction == 'top' || direction == 'right'){
                    var _w = (Number(nw) + Number(nl));
                }
                var _h = _w / nw * nh;
                if(_w > vm.data.textDocument.geometry.width * vm.ratio){
                    _w = vm.data.textDocument.geometry.width * vm.ratio;
                    _h = _w / nw * nh;
                }
                if(_h > vm.data.textDocument.geometry.height * vm.ratio){
                    _h = vm.data.textDocument.geometry.height * vm.ratio;
                    _w = _h / nh * nw;
                }


                if(_w > 20){
                    item.geometry.width = _w / vm.ratio;
                    item.geometry.height = _h / vm.ratio;
                    item.offsetx = (_w / (nw / nw1)) / (nw1 / x1) / vm.ratio;
                    item.offsety = (_h / (nh / nh1)) / (nh1 / y1) / vm.ratio;
                    $($event.target).parent().find('.c-xml-page-material-img').css({
                        width: _w * _scale + 'px',
                        left:  (_w / (nw / nw1)) / (nw1 / x1) + 'px',
                        top:  (_h / (nh / nh1)) / (nh1 / y1) + 'px',
                    });

                    if(direction == 'left'){
                        item.geometry.x = (Number(x2) - Number(_w - nw)) / vm.ratio;
                        item.geometry.y = (Number(y2) - Number(_h - nh)) / vm.ratio;
                        $($event.target).parent().css({
                            width: _w + 'px',
                            height: _h + 'px',
                            left: Number(x2) - Number(_w - nw) + 'px',
                            top: Number(y2) - Number(_h - nh) + 'px',
                        });
                    }
                    if(direction == 'top'){
                        item.geometry.y = (Number(y2) - Number(_h - nh)) / vm.ratio;
                        $($event.target).parent().css({
                            width: _w + 'px',
                            height: _h + 'px',
                            top: Number(y2) - Number(_h - nh) + 'px',
                        });
                    }
                    if(direction == 'right'){
                        $($event.target).parent().css({
                            width: _w + 'px',
                            height: _h + 'px'
                        });
                    }
                    if(direction == 'bottom'){
                        item.geometry.x = (Number(x2) - Number(_w - nw)) / vm.ratio;
                        $($event.target).parent().css({
                            width: _w + 'px',
                            height: _h + 'px',
                            left: Number(x2) - Number(_w - nw) + 'px',
                        });
                    }
                }
            }
            //鼠标抬起事件
            window.onmouseup = function ($event) {
                isZoomDown = false;
                $event.stopPropagation();
            }
        }

        //素材旋转
        var isRotate = false;
        $scope.imageartdownRotate = function($event, item){
            if(item.lock){return}
            var $event = $event || window.event;
            //防止浏览器默认行为(W3C)
            if($event && $event.preventDefault){
                $event.preventDefault();
            }
            //IE中组织浏览器行为
            else {
                window.event.returnValue = false;
                return false;
            }

            $event.stopPropagation();
            var _top = $($event.target).parents('.c-xml-page-material').offset().top + (item.geometry.height * vm.ratio / 2);
            var _left = $($event.target).parents('.c-xml-page-material').offset().left + (item.geometry.width * vm.ratio / 2);

            //开关打开
            isRotate = true;
            //鼠标移动
            window.onmousemove = function (e) {
                if (isRotate == false) {
                    return;
                }
                item.rotation.angle = getAngle(_left,_top, e.clientX, e.clientY);
                $scope.$digest();
            }
            //鼠标抬起事件
            window.onmouseup = function (e) {
                isRotate = false;
            };
            cookie()
        }
        function getAngle(px,py,mx,my){//获得人物中心和鼠标坐标连线，与y轴正半轴之间的夹角
            var x = Math.abs(px-mx);
            var y = Math.abs(py-my);
            var z = Math.sqrt(Math.pow(x,2)+Math.pow(y,2));
            var cos = y/z;
            var radina = Math.acos(cos);//用反三角函数求弧度
            var angle = Math.floor(180/(Math.PI/radina));//将弧度转换成角度
            if(mx<px&&my>py){//鼠标在第三象限
                angle = angle;
            }
            if(mx<px&&my<py){
                angle = 180 - angle;
            }
            if(mx>px&&my<py){
                angle = 180 + angle;
            }
            if(mx>px&&my>py){
                angle = 360 - angle;
            }
            return angle;
        }
        //素材裁切
        $scope.imageartDblclick = function($event, item){
            if(item.lock || vm.textEditor){return}
            var $event = $event || window.event;
            //防止浏览器默认行为(W3C)
            if($event && $event.preventDefault){
                $event.preventDefault();
            }
            //IE中组织浏览器行为
            else {
                window.event.returnValue = false;
                return false;
            }
            $event.stopPropagation();
            var x = $event.clientX;
            var y = $event.clientY;
            vm.isImageartTrim = true;
            vm.imageartTrim = angular.copy(item);
            vm.imageartTrim.geometry.width1 = angular.copy(item.geometry.width);
            vm.imageartTrim.geometry.height1 = angular.copy(item.geometry.height);
            vm.imageartTrim.geometry.x1 = angular.copy(item.geometry.x);
            vm.imageartTrim.geometry.y1 = angular.copy(item.geometry.y);
            if(vm.imageartTrim.geometry.width * vm.ratio == vm.imageartTrim.geometry.width1 * vm.ratio * vm.imageartTrim.scale){
                vm.imageartTrim.geometry.width = vm.imageartTrim.geometry.width * 0.8;
                vm.imageartTrim.geometry.height = vm.imageartTrim.geometry.height * 0.8;
                vm.imageartTrim.geometry.x = Number(vm.imageartTrim.geometry.x) + Number(vm.imageartTrim.geometry.width / 0.8 * 0.2 / 2);
                vm.imageartTrim.geometry.y = Number(vm.imageartTrim.geometry.y) + Number(vm.imageartTrim.geometry.height / 0.8 * 0.2 / 2);
            }
        }

        //拖动素材裁切
        var isImageartTrim = false;
        $scope.imageartTrimdown = function ($event) {
            var $event = $event || window.event;
            if($event && $event.preventDefault){
                $event.preventDefault();
            }
            else {
                window.event.returnValue = false;
                return false;
            }
            // $event.stopPropagation();
            var x = $event.clientX;
            var y = $event.clientY;
            var l = vm.imageartTrim.geometry.x * vm.ratio;
            var t = vm.imageartTrim.geometry.y * vm.ratio;
            var r = (vm.imageartTrim.geometry.width1 * vm.imageartTrim.scale - vm.imageartTrim.geometry.width) * vm.ratio;
            var b = (($("#c-xml-imageart-trim-img").find('img').height()) / vm.ratio - vm.imageartTrim.geometry.height) * vm.ratio;
            console.log(l)
            console.log(t)

            var x1 = (Number(vm.imageartTrim.geometry.x1) + Number(vm.imageartTrim.offsetx)) * vm.ratio;
            var y1 = (Number(vm.imageartTrim.geometry.y1) + Number(vm.imageartTrim.offsety)) * vm.ratio;

            var x2 = vm.imageartTrim.geometry.x1 * vm.ratio;
            var y2 = vm.imageartTrim.geometry.y1 * vm.ratio;
            var x3 = vm.imageartTrim.offsetx * vm.ratio;
            var y3 = vm.imageartTrim.offsety * vm.ratio;
            //开关打开
            isImageartTrim = true;
            //鼠标移动
            window.onmousemove = function (e) {
                if (isImageartTrim == false) {
                    return;
                }
                //获取x和y
                var nx = e.clientX;
                var ny = e.clientY;
                //计算移动后的左偏移量和顶部的偏移量
                var nl = nx - (x - l);
                var nt = ny - (y - t);

                if(nl< x1){ nl = x1};
                if(nl > Number(r) + Number(x1)){ nl = Number(r) + Number(x1)};
                if(nt < y1){ nt = y1};
                if(nt > Number(b) + Number(y1)){ nt = Number(b) + Number(y1)};

                vm.imageartTrim.geometry.x = nl / vm.ratio;
                vm.imageartTrim.geometry.y = nt / vm.ratio;
                $("#c-xml-imageart-trim-frame").css({
                    left: nl + 'px',
                    top: nt + 'px',
                });
                $("#c-xml-imageart-trim-frame-img").css({
                    left: Number(x2 - nl) + Number(x3) + 'px',
                    top: Number(y2 - nt) + Number(y3) + 'px',
                });
            }
            //鼠标抬起事件
            window.onmouseup = function ($event) {
                isImageartTrim = false;
                $event.stopPropagation();
            }
        }

        //素材裁切放大缩小
        var isImageartTrimRight = false;
        $scope.imageartTrimRight = function($event, item){
            var $event = $event || window.event;                  // IE、火狐获取事件对象
            //防止浏览器默认行为(W3C)
            if($event && $event.preventDefault){
                $event.preventDefault();
            }
            //IE中组织浏览器行为
            else {
                window.event.returnValue = false;
                return false;
            }
            $event.stopPropagation();
            var x = $event.clientX;
            var y = $event.clientY;
            //获取w和h
            var nw = Number(vm.imageartTrim.geometry.width * vm.ratio) + Number(vm.imageartTrim.geometry.x * vm.ratio);
            var nh = Number(vm.imageartTrim.geometry.height * vm.ratio) + Number(vm.imageartTrim.geometry.y * vm.ratio);
            var _l = vm.imageartTrim.geometry.x * vm.ratio;
            var _t = vm.imageartTrim.geometry.y * vm.ratio;

            var r = Number(vm.imageartTrim.geometry.x1 * vm.ratio) + Number(vm.imageartTrim.offsetx * vm.ratio) + Number(vm.imageartTrim.geometry.width1 * vm.ratio * vm.imageartTrim.scale);
            var b = Number(vm.imageartTrim.geometry.y1 * vm.ratio) + Number(vm.imageartTrim.offsety * vm.ratio) + Number($("#imageartTrimRight1").height());
            //开关打开
            isImageartTrimRight = true;

            //鼠标移动
            window.onmousemove = function (e) {
                if (isImageartTrimRight == false) {
                    return;
                }
                //获取x和y
                var nx = e.clientX;
                var ny = e.clientY;
                //计算移动后的左偏移量和顶部的偏移量
                var nl = Number(nw) + Number(nx - x);
                var nt = Number(nh) + Number(ny - y);

                if(nl >= r){nl = r}
                if(nt >= b){ nt = b}

                item.geometry.width = (nl - _l) / vm.ratio;
                item.geometry.height = (nt - _t) / vm.ratio;
                $scope.$digest();
            }
            //鼠标抬起事件
            window.onmouseup = function ($event) {
                isImageartTrimRight = false;
                $event.stopPropagation();
            }
        }
        $scope.imageartTrimRight1 = function($event, item){
            var $event = $event || window.event;                  // IE、火狐获取事件对象
            //防止浏览器默认行为(W3C)
            if($event && $event.preventDefault){
                $event.preventDefault();
            }
            //IE中组织浏览器行为
            else {
                window.event.returnValue = false;
                return false;
            }
            $event.stopPropagation();
            var x = $event.clientX;
            var y = $event.clientY;
            //获取w和h
            var nw = item.geometry.width1 * vm.ratio * vm.imageartTrim.scale;
            var nh = item.geometry.height1 * vm.ratio * vm.imageartTrim.scale;

            var r = Number($("#c-xml-imageart-div").offset().left) + Number(vm.data.textDocument.geometry.width * vm.ratio);
            var x2 = (Number(item.geometry.x1 * vm.ratio) + Number($("#c-xml-imageart-trim-div").width()) - (Number(item.geometry.x * vm.ratio) + Number(item.geometry.width * vm.ratio)));
            var y2 = (Number(item.geometry.y1 * vm.ratio) + Number($("#c-xml-imageart-trim-div").height()) - (Number(item.geometry.y * vm.ratio) + Number(item.geometry.height * vm.ratio)));
            if(x2 < y2){
                var r1 = Number($("#c-xml-imageart-div").offset().left) + Number(item.geometry.x * vm.ratio) + Number(item.geometry.width * vm.ratio);
            }else {
                var r1 = Number($("#c-xml-imageart-div").offset().left) + Number(item.geometry.x * vm.ratio) + Number(item.geometry.width * vm.ratio) + (x2 - y2);
            }
            //开关打开
            isImageartTrimRight = true;

            //鼠标移动
            window.onmousemove = function (e) {
                if (isImageartTrimRight == false) {
                    return;
                }
                //获取x和y
                var nx = e.clientX;
                var ny = e.clientY;
                if(nx >= r){nx = r}
                if(nx <= r1){nx = r1}

                //计算移动后的左偏移量和顶部的偏移量
                var nl = nx - x;
                var nt = ny - y;

                item.geometry.width1 = ((Number(nw) + Number(nl))) / vm.ratio / vm.imageartTrim.scale;
                item.geometry.height1 = (Number(nh) + Number(nt)) / vm.ratio / vm.imageartTrim.scale;
                $("#imageartTrimRight1").css({
                    width: Number(nw) + Number(nl) + 'px'
                });
                $("#c-xml-imageart-trim-frame-img img").css({
                    width: Number(nw) + Number(nl) + 'px'
                });
            }
            //鼠标抬起事件
            window.onmouseup = function ($event) {
                isImageartTrimRight = false;
                $event.stopPropagation();
            }
        }
        $scope.imageartTrimTrueClick = function(){
            vm.isImageartTrim = false;
            vm.imageartTrim.scale = (vm.imageartTrim.geometry.width1 * vm.ratio * vm.imageartTrim.scale)/(vm.imageartTrim.geometry.width * vm.ratio);
            vm.imageartTrim.offsetx = (Number(-(vm.imageartTrim.geometry.x - vm.imageartTrim.geometry.x1)) + Number(vm.imageartTrim.offsetx)).toFixed(2);
            vm.imageartTrim.offsety = (Number(-(vm.imageartTrim.geometry.y - vm.imageartTrim.geometry.y1)) + Number(vm.imageartTrim.offsety)).toFixed(2);
            if(vm.imageartTrim.offsetx > 0){
                vm.imageartTrim.offsetx = 0;
            }
            if(vm.imageartTrim.offsety > 0){
                vm.imageartTrim.offsety = 0;
            }
            if(vm.imageartTrim.scale < 1){
                vm.imageartTrim.scale = 1;
            }
            if(vm.imageartTrim.geometry.width > vm.imageartTrim.geometry.width1 * vm.imageartTrim.scale){
                vm.imageartTrim.geometry.width = vm.imageartTrim.geometry.width1 * vm.imageartTrim.scale;
            }
            for(var i=0; i<vm.data.textDocument.levels.level.length; i++){
                if(vm.data.textDocument.levels.level[i].imageart){
                    if(vm.data.textDocument.levels.level[i].imageart.selected){
                        vm.imageartTrim.geometry.x = vm.data.textDocument.levels.level[i].imageart.geometry.x;
                        vm.imageartTrim.geometry.y = vm.data.textDocument.levels.level[i].imageart.geometry.y;
                        vm.data.textDocument.levels.level[i].imageart = vm.imageartTrim;
                    }
                }
            }
        }
        $scope.imageartTrimFalseClick = function(){
            vm.isImageartTrim = false;
        }

        //添加文字
        $scope.fontAdd = function (data) {
            if(vm.textEditor){return}
            var _fontSize = 20;
            if(vm.ratio <= Number(0.5)){_fontSize = 40}
            if(0.5 < vm.ratio && vm.ratio <= 1){_fontSize = 26}
            if(1 < vm.ratio && vm.ratio <= 2){_fontSize = 20}
            if(vm.ratio > 2){_fontSize = 12}
            var _font = {
                geometry: {
                    x: '0',
                    y: '0',
                    width: 100 / vm.ratio,
                    height: 70
                },
                rotation: {
                    angle: '0'
                },
                text: '请输入文字',
                style: {
                    font: "",
                    size: _fontSize,
                    color: '#000000',
                    bold: false,
                    italic: false,
                    lineheight: 35,
                    letterspacing: 1,
                    align: 'left',
                },
                fontuuid: data.uuid,
                identifier: "",
                editable: true,
                movable: true,
                lock: false,
                version: '2.0',
                transparency: '1',
                selected: true
            };
            var _fontStyle = [];
            for(var i=0; i<vm.fontList.length; i++){
                if(vm.fontList[i].uuid == data.uuid){
                    for(var j=0; j<vm.fontList[i].fontStyles.length; j++){
                        _fontStyle.push(vm.fontList[i].fontStyles[j].style)
                    }
                }
            }
            if(_fontStyle.indexOf('NORMAL') != '-1'){
                _font.style.bold = false;
                _font.style.italic = false;
            }else {
                if(_fontStyle.indexOf('BOLD_ITALIC') != '-1'){
                    _font.style.bold = true;
                    _font.style.italic = true;
                }else {
                    if(_fontStyle.indexOf('ITALIC') != '-1'){
                        _font.style.italic = true;
                        _font.style.bold = false;
                    }
                    if(_fontStyle.indexOf('BOLD') != '-1'){
                        _font.style.bold = true;
                        _font.style.italic = false;
                    }
                }
            }
            vm.ctrlKeyArray = []
            for(var i=0 ;i<vm.data.textDocument.levels.level.length; i++){
                if(vm.data.textDocument.levels.level[i].textbox) {
                    var _font1 = vm.data.textDocument.levels.level[i].textbox;
                    _font1.selected = false;
                    _font1.ctrlKey = false;
                }
            }
            vm.fontHide = _font;
            $timeout(function () {
                _font.geometry.width = Number($("#c-xml-page-material-fontId").width() / vm.ratio) + Number(10);
                _font.geometry.height = Number($("#c-xml-page-material-fontId").height() / vm.ratio) +  Number(5);
                addElement('textbox', _font)
                cookie();
                fontSelect()
                getFont(_font);
            })
        }
        function fontSelect() {
            for(var i=0 ;i<vm.data.textDocument.levels.level.length; i++){
                if(vm.data.textDocument.levels.level[i].textbox) {
                    var _font2 = vm.data.textDocument.levels.level[i].textbox;
                    if(_font2.selected){
                        vm.font = _font2;
                        vm.fontHide = _font2;
                        vm.font.style.size = vm.font.style.size.toString();
                        vm.isFont = true;
                        vm.xmlSelect.type = 'textbox';
                        vm.xmlSelect.transparency = _font2.transparency;
                        vm.xmlSelect.editable = _font2.editable;
                        vm.xmlSelect.lock = _font2.lock;

                        if(vm.unit == 'mm'){
                            vm.attribute.font = {
                                width: (_font2.geometry.width/vm.windowDpiW * 25.4).toFixed(2),
                                x: (_font2.geometry.x/vm.windowDpiW * 25.4).toFixed(2),
                                y: (_font2.geometry.y/vm.windowDpiH * 25.4).toFixed(2),
                            }
                        }
                        if (vm.unit == 'px'){
                            vm.attribute.font = {
                                width: _font2.geometry.width,
                                x: _font2.geometry.x,
                                y: _font2.geometry.y
                            }
                        }
                        clearBubble()
                        fontStyle()
                        break;
                    }
                }
            }
            for(var i1=0; i1<vm.data.textDocument.levels.level.length; i1++){
                if(vm.data.textDocument.levels.level[i1].imageart) {
                    vm.data.textDocument.levels.level[i1].imageart.selected = false;
                }
            }
        }
        function fontEdit() {
            for(var i=0 ;i<vm.data.textDocument.levels.level.length; i++){
                if(vm.data.textDocument.levels.level[i].textbox) {
                    var _font = vm.data.textDocument.levels.level[i].textbox;
                    if (_font.selected) {
                        _font = vm.font;
                        break;
                    }
                }
            }
            cookie()
        }
        function fontHide() {
            vm.isFont = false;
            vm.font = {};
        }
        function fontStyle(){
            vm.font.fontStyle = [];
            for(var i=0; i<vm.fontList.length; i++){
                if(vm.fontList[i].uuid == vm.font.fontuuid){
                    for(var j=0; j<vm.fontList[i].fontStyles.length; j++){
                        vm.font.fontStyle.push(vm.fontList[i].fontStyles[j].style)
                    }
                }
            }
            vm.font.style.bold1 = false;
            vm.font.style.italic1= false;
            if(vm.font.fontStyle.indexOf('NORMAL') == '-1'){
                vm.font.style.normal = false;
            }else {
                vm.font.style.normal = true;
            }
            if(vm.font.fontStyle.indexOf('BOLD_ITALIC') != '-1'){
                vm.font.style.bold1 = true;
                vm.font.style.italic1= true;
            }else {
                if(vm.font.fontStyle.indexOf('ITALIC') != '-1'){
                    vm.font.style.italic1= true;
                }
                if(vm.font.fontStyle.indexOf('BOLD') != '-1'){
                    vm.font.style.bold1 = true;
                }
            }
        }
        vm.ctrlKeyArray=[]
        //选中文字
        $scope.textboxClick = function ($event, item, index) {
            if (vm.textEditor) {
                return
            }
            var $event = $event || window.event;
            if ($event.ctrlKey == true || $event.metaKey == true) {
                for(var i=0 ;i<vm.data.textDocument.levels.level.length; i++){
                    if(vm.data.textDocument.levels.level[i].textbox) {
                        var _font = vm.data.textDocument.levels.level[i].textbox;
                        if (_font.selected) {
                            _font.ctrlKey = true;
                        }
                    }
                    if(vm.data.textDocument.levels.level[i].imageart) {
                        var _font = vm.data.textDocument.levels.level[i].imageart;
                        if (_font.selected) {
                            _font.ctrlKey = true;
                        }
                    }
                }
                vm.data.textDocument.levels.level[index].textbox.ctrlKey = true;
                vm.ctrlKeyArray.push(item)
            }else{
                if($event && $event.preventDefault){
                    $event.preventDefault();
                }
                else {
                    window.event.returnValue = false;
                    return false;
                }
                $event.stopPropagation();
                if(!vm.data.textDocument.levels.level[index].textbox.ctrlKey){
                    for(var i=0 ;i<vm.data.textDocument.levels.level.length; i++){
                        if(vm.data.textDocument.levels.level[i].textbox) {
                            var _font = vm.data.textDocument.levels.level[i].textbox;
                            _font.selected = false;
                            _font.ctrlKey = false;
                        }
                        if(vm.data.textDocument.levels.level[i].imageart) {
                            var _font = vm.data.textDocument.levels.level[i].imageart;
                            _font.selected = false;
                            _font.ctrlKey = false;
                        }
                    }
                    vm.ctrlKeyArray = [];
                    item.selected = true;
                }
                vm.xmlSelect.type = 'textbox';
                vm.xmlSelect.transparency = item.transparency;
                vm.xmlSelect.editable = item.editable;
                vm.xmlSelect.lock = item.lock;
                clearBubble();
                fontSelect()
            }
        }
        //双击编辑文字
        vm.textEditor = false;
        $scope.doubleClicktext = function (e, item, index) {
            fn(e);
            if (item.lock || vm.textEditor) {
                return
            }
            $timeout(function () {
                vm.textEditor = angular.copy(vm.data.textDocument.levels.level[index].textbox);
                vm.fontOn = $(e.target).parents('.c-xml-page-textboxe');
                var span = vm.fontOn.find('span');
                span[0].innerHTML = '';
                span.focus();
                span[0].innerHTML = item.text;
                $(span[0]).css({'cursor':'text'});
                span[0].setAttribute("contenteditable", "true");
                if (document.selection) {
                    var range = document.body.createTextRange();
                    range.moveToElementText(span[0]);
                    range.select();
                } else if (window.getSelection) {
                    var range = document.createRange();
                    range.selectNodeContents(span[0]);
                    window.getSelection().removeAllRanges();
                    window.getSelection().addRange(range);
                }
            })
        }
        //去除所有html标签，只保留文字
        var textReg=/<\/?.+?\/?>/g;
        // 过滤style行内标签
        var textReg1=/ style\s*?=\s*?(['"])[\s\S]*?\1/g;
        $scope.textBlur = function (e, item, i) {
            fn(e);
            $timeout(function () {
                $(e.target).css({'cursor':'pointer'});
                $(e.target).attr("contenteditable", "false");
                item.text = angular.copy($(e.target).text());
                item.text = item.text.replace(/&nbsp;/g,' ').replace(textReg1,'').replace(/<br>/g,'\n').replace(textReg,'');
                FontManagement.fontSupport({
                    uuid: item.fontuuid,
                    bold: item.style.bold,
                    italic: item.style.italic,
                    content: item.text
                }, function (res) {
                    var msg = res.message;
                    if (res.status == 200) {
                        item.success = msg.success;
                        if (!msg.success) {
                            MessageService.error("当前字体不可用，请更换字体");
                            return
                        }
                        if (msg.success && !msg.supported) {
                            var message = "【" + msg.failed + "】" + "当前字体不支持这些文字！";
                            MessageService.error(message);
                        }
                        vm.textEditor.text = msg.passed;
                        sizeHeight1(function () {
                            vm.textEditor = false;
                            cookie();
                            $scope.$apply();
                        });
                    }
                })
            })
        }
        $scope.changeHeight = function(e,item){
            vm.textEditor.text = $(e.target).text();
            sizeHeight1();
        }
        //拖动文字
        var isTextDrag = false;
        $scope.textboxdown = function ($event, item) {
            if(item.lock || vm.textEditor){return}
            var $event = $event || window.event;
            if($event && $event.preventDefault){
                $event.preventDefault();
            }
            else {
                window.event.returnValue = false;
                return false;
            }
            if (vm.ctrlKeyArray.length > 0) {
                levelMove($event);
            }else{
                textMove($event, item)
            }
        }
        function levelMove(event) {
            angular.forEach(vm.data.textDocument.levels.level, function (level, i) {
                if(level.textbox && level.textbox.ctrlKey){
                    if(!level.textbox.lock){
                        (function(textbox){
                            textMove(event, textbox)
                        })(level.textbox)
                    }
                }
                if(level.imageart && level.imageart.ctrlKey){
                    if(!level.imageart.lock){
                        (function(imageart){
                            textMove(event, imageart)
                        })(level.imageart)
                    }
                }
            })
        }
        var moveItem = [];
        function textMove($event, item){
            $event.stopPropagation();
            var x = $event.clientX;
            var y = $event.clientY;
            item.l = angular.copy(item.geometry.x * vm.ratio);
            item.t = angular.copy(item.geometry.y * vm.ratio);
            moveItem.push(item)
            //开关打开
            isDown = true;
            //鼠标移动
            window.onmousemove = function (e) {
                if (isDown == false) {
                    return;
                }
                moveItem.forEach(function (item1) {
                    var nx = e.clientX;
                    var ny = e.clientY;
                    //计算移动后的左偏移量和顶部的偏移量
                    var nl = nx - (x - item1.l);
                    var nt = ny - (y - item1.t);
                    item1.geometry.x = nl / vm.ratio;
                    item1.geometry.y = nt / vm.ratio;
                })
                $scope.$digest();
            }
            //鼠标抬起事件
            window.onmouseup = function ($event) {
                console.log('11111111')
                if (isDown) {
                    cookie();
                }
                isDown = false;
                moveItem = [];
                $event.stopPropagation();
            }
        }
        // function textMove(){
        //     $event.stopPropagation();
        //     var x = $event.clientX;
        //     var y = $event.clientY;
        //     var l = item.geometry.x * vm.ratio;
        //     var t = item.geometry.y * vm.ratio;
        //     var r = (vm.data.textDocument.geometry.width - item.geometry.width) * vm.ratio;
        //     var b = (vm.data.textDocument.geometry.height - item.geometry.height) * vm.ratio;
        //     //开关打开
        //     isTextDrag = true;
        //     //鼠标移动
        //     window.onmousemove = function (e) {
        //         if (isTextDrag == false) {
        //             return;
        //         }
        //         //获取x和y
        //         var nx = e.clientX;
        //         var ny = e.clientY;
        //         //计算移动后的左偏移量和顶部的偏移量
        //         var nl = nx - (x - l);
        //         var nt = ny - (y - t);

        //         if(nl < 0){nl = 0;}
        //         if(nl > r){nl = r;}
        //         if(nt < 0){nt = 0;}
        //         if(nt > b){nt = b;}
        //         item.geometry.x = nl / vm.ratio;
        //         item.geometry.y = nt / vm.ratio;
        //         $($event.target).parents('.c-xml-page-textboxe').css({
        //             left: nl + 'px',
        //             top: nt + 'px',
        //         });
        //     }
        //     //鼠标抬起事件
        //     window.onmouseup = function ($event) {
        //         isTextDrag = false;
        //         $event.stopPropagation();
        //     }
        // }
        //文字旋转
        var isTextRotate = false;
        $scope.textboxRotate = function($event, item){
            if(item.lock){return}
            var $event = $event || window.event;
            //防止浏览器默认行为(W3C)
            if($event && $event.preventDefault){
                $event.preventDefault();
            }
            //IE中组织浏览器行为
            else {
                window.event.returnValue = false;
                return false;
            }
            $event.stopPropagation();
            var _top = $($event.target).parents('.c-xml-page-textboxe').offset().top + (item.geometry.height * vm.ratio / 2);
            var _left = $($event.target).parents('.c-xml-page-textboxe').offset().left + (item.geometry.width * vm.ratio / 2);
            //开关打开
            isTextRotate = true;
            //鼠标移动
            window.onmousemove = function (e) {
                if (isTextRotate == false) {
                    return;
                }
                item.rotation.angle = getAngle(_left,_top, e.clientX, e.clientY);
                $scope.$digest();
            }
            //鼠标抬起事件
            window.onmouseup = function (e) {
                isTextRotate = false;
            };
            cookie()
        }

        //文字放大缩小
        var isTextDown = false;
        $scope.textboxZoomRight = function($event, item){
            textboxZoom($event, item, 'right')
        }
        $scope.textboxZoomLeft = function($event, item){
            textboxZoom($event, item, 'left')
        }
        function textboxZoom($event, item, element){
            if(item.lock){return}
            var $event = $event || window.event;
            //防止浏览器默认行为(W3C)
            if($event && $event.preventDefault){
                $event.preventDefault();
            }
            //IE中组织浏览器行为
            else {
                window.event.returnValue = false;
                return false;
            }
            $event.stopPropagation();
            var x = $event.clientX;

            var nw = angular.copy(item.geometry.width) * vm.ratio;
            var left = angular.copy(item.geometry.x) * vm.ratio;
            //开关打开
            isTextDown = true;
            //鼠标移动
            window.onmousemove = function (e) {
                if (isTextDown == false) {
                    return;
                }
                //获取x和y
                var nx = e.clientX;
                //计算移动后的左偏移量和顶部的偏移量
                var nl = nx - x;

                var h = Number($($event.target).parent().find('.c-xml-page-textboxe-text').height()) + Number(5);
                if(element == 'left'){
                    item.geometry.x = (left + nl) / vm.ratio;
                    item.geometry.width = (Number(nw) - Number(nl)) / vm.ratio;
                    if(item.geometry.width < (Number(parseInt(item.style.size)) + Number(10))){
                        item.geometry.width = (Number(parseInt(item.style.size)) + Number(20));
                        item.geometry.x = (left + nl - Number(5)) / vm.ratio;
                        isTextDown = false;
                        return;
                    }
                    if((Number(nw) - Number(nl)) > vm.data.textDocument.geometry.width * vm.ratio){
                        item.geometry.width = vm.data.textDocument.geometry.width;
                        item.geometry.x = 0;
                    }
                }
                if(element == 'right'){
                    item.geometry.width = (Number(nw) + Number(nl)) / vm.ratio;
                    if(item.geometry.width < (Number(parseInt(item.style.size)) + Number(10))){
                        item.geometry.width = (Number(parseInt(item.style.size)) + Number(20));
                        isTextDown = false;
                        return;
                    }
                    if((Number(nw) + Number(nl)) > vm.data.textDocument.geometry.width * vm.ratio){
                        item.geometry.width = vm.data.textDocument.geometry.width;
                        item.geometry.x = 0;
                    }
                }
                item.geometry.height = h / vm.ratio;
                sizeHeight();
                $scope.$digest();
            }
            //鼠标抬起事件
            window.onmouseup = function ($event) {
                isTextDown = false;
                $event.stopPropagation();
            }
        };
        $scope.textboxZoomLeft1 = function($event, item){
            textboxZoom1($event, item, 'left')
        };
        $scope.textboxZoomTop1 = function($event, item){
            textboxZoom1($event, item, 'top')
        };
        $scope.textboxZoomRight1 = function($event, item){
            textboxZoom1($event, item, 'right')
        };
        $scope.textboxZoomBottom1 = function($event, item){
            textboxZoom1($event, item, 'bottom')
        };
        function textboxZoom1($event, item, element){
            if(item.lock){return}
            var $event = $event || window.event;                  // IE、火狐获取事件对象
            //防止浏览器默认行为(W3C)
            if($event && $event.preventDefault){
                $event.preventDefault();
            }
            //IE中组织浏览器行为
            else {
                window.event.returnValue = false;
                return false;
            }
            $event.stopPropagation();
            var x = $event.clientX;
            var y = $event.clientY;
            //获取w和h
            var nw = angular.copy(item.geometry.width);
            var nh = angular.copy(item.geometry.height);
            var _left = angular.copy(item.geometry.x);
            var _top = angular.copy(item.geometry.y);
            var _size = angular.copy(parseInt(item.style.size));
            var _lineheight = angular.copy(parseInt(item.style.lineheight));
            //开关打开
            isTextDown = true;
            //鼠标移动
            window.onmousemove = function (e) {
                if (isTextDown == false) {return;}
                if(item.style.size < 6){
                    item.style.size = 6;
                    item.style.lineheight = 6;
                    isTextDown = false;
                    return;
                }
                //获取x和y
                var nx = e.clientX;
                var ny = e.clientY;
                //计算移动后的左偏移量和顶部的偏移量
                var nl = (nx - x) / vm.ratio;
                var nt = (ny - y) / vm.ratio;

                if(element == 'left'){
                    if((Number(nw) - Number(nl)) < 20){
                        isTextDown = false;
                        return;
                    }
                    item.geometry.width = (Number(nw) - Number(nl));
                    item.geometry.x = (Number(_left) + Number(nl));
                    item.style.size = Math.ceil(((Number(nw) - Number(nl)) / nw * _size));
                    item.style.lineheight = Math.ceil(((Number(nw) - Number(nl)) / nw * _lineheight));
                    item.geometry.y = (Number(_top) - Number(item.geometry.height - nh));
                }
                if(element == 'top'){
                    if((Number(nw) + Number(nl)) < 20){
                        isTextDown = false;
                        return;
                    }
                    item.geometry.width = (Number(nw) + Number(nl));
                    item.style.size = Math.ceil(((Number(nw) + Number(nl)) / nw * _size));
                    item.style.lineheight = Math.ceil(((Number(nw) + Number(nl)) / nw * _lineheight));
                    item.geometry.y = (Number(_top) - Number(item.geometry.height - nh));
                }
                if(element == 'right'){
                    if((Number(nw) + Number(nl)) < 20){
                        isTextDown = false;
                        return;
                    }
                    item.geometry.width = (Number(nw) + Number(nl) + Number(5));
                    item.style.size = Math.ceil(((Number(nw) + Number(nl)) / nw * _size));
                    item.style.lineheight = Math.ceil(((Number(nw) + Number(nl)) / nw * _lineheight));
                }
                if(element == 'bottom'){
                    if((Number(nw) - Number(nl)) < 20){
                        isTextDown = false;
                        return;
                    }
                    item.geometry.width = (Number(nw) - Number(nl));
                    item.geometry.x = (Number(_left) + Number(nl));
                    item.style.size = Math.ceil(((Number(nw) - Number(nl)) / nw * _size));
                    item.style.lineheight = Math.ceil(((Number(nw) - Number(nl)) / nw * _lineheight));
                    // item.geometry.y = (Number(_top) + Number(item.geometry.height - nh));
                }
                sizeHeight();
                $scope.$digest();
            }
            //鼠标抬起事件
            window.onmouseup = function ($event) {
                isTextDown = false;
                $event.stopPropagation();
            }
        }

        //点击作品框
        $scope.xmlClick = function(event){
            // fn(event);
            if(vm.textEditor){return}

            // var $event = $event || window.event;                  // IE、火狐获取事件对象
            // //防止浏览器默认行为(W3C)
            // if($event && $event.preventDefault){
            //     $event.preventDefault();
            // }
            // //IE中组织浏览器行为
            // else {
            //     window.event.returnValue = false;
            //     return false;
            // }
            // $event.stopPropagation();
            for(var i=0; i<vm.data.textDocument.levels.level.length; i++){
                if(vm.data.textDocument.levels.level[i].imageart) {
                    vm.data.textDocument.levels.level[i].imageart.selected = false;
                }
            }
            for(var i1=0 ;i1<vm.data.textDocument.levels.level.length; i1++){
                if(vm.data.textDocument.levels.level[i1].textbox) {
                    var _font = vm.data.textDocument.levels.level[i1].textbox;
                    _font.selected = false;
                }
            }
            fontHide()
            vm.xmlSelect.type = "";
            vm.xmlSelect.transparency = "";
            vm.xmlSelect.editable = vm.data.textDocument.editable;
            vm.xmlSelect.lock = null;
            clearBubble();
        }
        //双击作品框
        $scope.xmlDblclick = function($event){
            var $event = $event || window.event;                  // IE、火狐获取事件对象
            //防止浏览器默认行为(W3C)
            if($event && $event.preventDefault){
                $event.preventDefault();
            }
            //IE中组织浏览器行为
            else {
                window.event.returnValue = false;
                return false;
            }
            $event.stopPropagation();
            if(vm.data.textDocument.background.resource.identifier){
                vm.isXmlDblclick = true;
            }
        }




        //单位换算
        $scope.unitConversion = function () {
            unit()
        }
        function unit(){
            if(vm.unit == 'mm'){
                vm.attribute = {
                    product: {
                        width: (vm.data.textDocument.geometry.width/vm.windowDpiW*25.4).toFixed(2),
                        height:(vm.data.textDocument.geometry.height/vm.windowDpiH*25.4).toFixed(2),
                    },
                    background: {
                        x: (vm.data.textDocument.background.offsetx/vm.windowDpiW*25.4).toFixed(2),
                        y: (vm.data.textDocument.background.offsety/vm.windowDpiH*25.4).toFixed(2)
                    },
                    material: {
                        width: (vm.attribute.material.width/vm.windowDpiW*25.4).toFixed(2),
                        height: (vm.attribute.material.height/vm.windowDpiH*25.4).toFixed(2),
                        x: (vm.attribute.material.x/vm.windowDpiW*25.4).toFixed(2),
                        y: (vm.attribute.material.y/vm.windowDpiH*25.4).toFixed(2),
                    },
                    font: {
                        width: (vm.attribute.font.width/vm.windowDpiW*25.4).toFixed(2),
                        x: (vm.attribute.font.x/vm.windowDpiW*25.4).toFixed(2),
                        y: (vm.attribute.font.y/vm.windowDpiH*25.4).toFixed(2),
                    }
                }
            }
            if (vm.unit == 'px'){
                vm.attribute = {
                    product: {
                        width: vm.data.textDocument.geometry.width,
                        height:vm.data.textDocument.geometry.height,
                    },
                    background: {
                        x: vm.data.textDocument.background.offsetx,
                        y: vm.data.textDocument.background.offsety
                    },
                    material: {
                        width: (vm.attribute.material.width/25.4 * vm.windowDpiW).toFixed(2),
                        height: (vm.attribute.material.height/25.4 * vm.windowDpiH).toFixed(2),
                        x: (vm.attribute.material.x/25.4 * vm.windowDpiW).toFixed(2),
                        y: (vm.attribute.material.y/25.4 * vm.windowDpiH).toFixed(2),
                    },
                    font: {
                        width: (vm.attribute.font.width/25.4 * vm.windowDpiW).toFixed(2),
                        x: (vm.attribute.font.x/25.4 * vm.windowDpiW).toFixed(2),
                        y: (vm.attribute.font.y/25.4 * vm.windowDpiH).toFixed(2),
                    }
                }
            }
        }
        js_getDPI()
        function js_getDPI() {
            var arrDPI = new Array();
            if (window.screen.deviceXDPI != undefined) {
                arrDPI[0] = window.screen.deviceXDPI;
                arrDPI[1] = window.screen.deviceYDPI;
            }
            else {
                var tmpNode = document.createElement("DIV");
                tmpNode.style.cssText = "width:1in;height:1in;position:absolute;left:0px;top:0px;z-index:99;visibility:hidden";
                document.body.appendChild(tmpNode);
                arrDPI[0] = parseInt(tmpNode.offsetWidth);
                arrDPI[1] = parseInt(tmpNode.offsetHeight);
                tmpNode.parentNode.removeChild(tmpNode);
            }
            vm.windowDpiW = arrDPI[0];
            vm.windowDpiH = arrDPI[1];
            // console.log(arrDPI)
            // vm.windowDpiW = 103;
            // vm.windowDpiH = 103;
            return arrDPI;
        }
        //作品框宽高优化
        function initWindow(){
            vm.windowH = window.innerHeight - 90;
            vm.windowW = window.innerWidth - 500;
            if(vm.windowH / vm.data.textDocument.geometry.height >= vm.windowW / vm.data.textDocument.geometry.width ){
                vm.ratio = vm.windowW / vm.data.textDocument.geometry.width * 0.8;
            }else {
                vm.ratio = vm.windowH / vm.data.textDocument.geometry.height * 0.8;
            }
            //记录初始缩放比
            vm.initRatio = vm.ratio;
            vm.windowH1 = 200;
            vm.windowW1 = 200;
            if(vm.windowH1 / vm.data.textDocument.geometry.height >= vm.windowW1 / vm.data.textDocument.geometry.width ){
                vm.ratio1 = vm.windowW1 / vm.data.textDocument.geometry.width * 0.8;
            }else {
                vm.ratio1 = vm.windowH1 / vm.data.textDocument.geometry.height * 0.8;
            }

        }
        window.onresize = function(){
            initWindow()
            $scope.$apply();
            getFullState();
        }
        //属性栏
        $scope.$watch("vm.attribute.product.width",function(newValue,oldValue){
            if(oldValue){
                if(vm.unit == 'mm'){vm.data.textDocument.geometry.width = (vm.attribute.product.width/25.4 * vm.windowDpiW).toFixed(2);}
                if (vm.unit == 'px'){vm.data.textDocument.geometry.width = vm.attribute.product.width;}
                vm.data.textDocument.background.offsetx = 0;
                vm.data.textDocument.background.offsety = 0;
                initWindow();
                bgImgInit();
            }
        })
        $scope.$watch("vm.attribute.product.height",function(newValue,oldValue){
            if(oldValue){
                if(vm.unit == 'mm'){vm.data.textDocument.geometry.height = (vm.attribute.product.height/25.4 * vm.windowDpiH).toFixed(2);}
                if (vm.unit == 'px'){vm.data.textDocument.geometry.height = vm.attribute.product.height;}
                vm.data.textDocument.background.offsetx = 0;
                vm.data.textDocument.background.offsety = 0;
                initWindow();
                bgImgInit()
            }
        })
        $scope.$watch("vm.attribute.background.x",function(newValue,oldValue){
            if(oldValue){
                if(vm.unit == 'mm'){vm.data.textDocument.background.offsetx = (vm.attribute.background.x/25.4 * vm.windowDpiW).toFixed(2);}
                if (vm.unit == 'px'){vm.data.textDocument.background.offsetx = vm.attribute.background.x;}
                bgImgInit()
            }
        })
        $scope.$watch("vm.attribute.background.y",function(newValue,oldValue){
            if(oldValue){
                if(vm.unit == 'mm'){vm.data.textDocument.background.offsety = (vm.attribute.background.y/25.4 * vm.windowDpiH).toFixed(2);}
                if (vm.unit == 'px'){vm.data.textDocument.background.offsety = vm.attribute.background.y;}
                bgImgInit()
            }
        })
        $scope.attributeMaterialWidth = function(){
            var _org = angular.copy(vm.attribute.material.width);
            $timeout(function () {
                var _w = 1;
                if(vm.unit == 'mm'){
                    _w = (vm.attribute.material.width/25.4 * vm.windowDpiW);
                }
                if (vm.unit == 'px'){
                    _w = vm.attribute.material.width;
                }
                if(_w <= 0){
                    MessageService.error("宽度不能小于等于0");
                    $timeout(function () {
                        vm.attribute.material.width = _org;
                    })
                    return
                }
                for(var i=0; i<vm.data.textDocument.levels.level.length; i++){
                    if(vm.data.textDocument.levels.level[i].imageart){
                        var imageart = vm.data.textDocument.levels.level[i].imageart;
                        if(imageart.selected){
                            var _scale = _w / imageart.geometry.width;
                            imageart.geometry.height = imageart.geometry.height * _scale;
                            imageart.geometry.width = imageart.geometry.width * _scale;
                            imageart.scale = _scale * imageart.scale;
                            if(vm.unit == 'mm'){
                                vm.attribute.material.height = (imageart.geometry.height/vm.windowDpiH * 25.4).toFixed(2);
                            }
                            if (vm.unit == 'px'){
                                vm.attribute.material.height = imageart.geometry.height;
                            }
                            break;
                        }
                    }
                }
            }, 500)
        }
        $scope.attributeMaterialHeight = function(){
            var _org = angular.copy(vm.attribute.material.height);
            $timeout(function () {
                var _h = 1;
                if(vm.unit == 'mm'){
                    _h = (vm.attribute.material.height/25.4 * vm.windowDpiW);
                }
                if (vm.unit == 'px'){
                    _h = vm.attribute.material.height;
                }
                if(_h <= 0){
                    MessageService.error("宽度不能小于等于0");
                    $timeout(function () {
                        vm.attribute.material.height = _org;
                    })
                    return
                }
                for(var i=0; i<vm.data.textDocument.levels.level.length; i++){
                    if(vm.data.textDocument.levels.level[i].imageart){
                        var imageart = vm.data.textDocument.levels.level[i].imageart;
                        if(imageart.selected){
                            var _scale = _h / imageart.geometry.height;
                            imageart.geometry.height = imageart.geometry.height * _scale;
                            imageart.geometry.width = imageart.geometry.width * _scale;
                            imageart.scale = _scale * imageart.scale;
                            if(vm.unit == 'mm'){
                                vm.attribute.material.width = (imageart.geometry.width/vm.windowDpiW * 25.4).toFixed(2);
                            }
                            if (vm.unit == 'px'){
                                vm.attribute.material.width = imageart.geometry.width;
                            }
                            break;
                        }
                    }
                }
            }, 500)
        }

        $scope.$watch("vm.attribute.material.width",function(newValue,oldValue){
            // if(oldValue){cookie()}
        })
        $scope.$watch("vm.attribute.material.x",function(newValue,oldValue){
            if(oldValue){
                for(var i=0; i<vm.data.textDocument.levels.level.length; i++){
                    if(vm.data.textDocument.levels.level[i].imageart) {
                        var imageart = vm.data.textDocument.levels.level[i].imageart;
                        if (imageart.selected) {
                            if (vm.unit == 'mm') {
                                imageart.geometry.x = (vm.attribute.material.x / 25.4 * vm.windowDpiW).toFixed(2);
                            }
                            if (vm.unit == 'px') {
                                imageart.geometry.x = vm.attribute.material.x;
                            }
                            break;
                        }
                    }
                }
            }
        })
        $scope.$watch("vm.attribute.material.y",function(newValue,oldValue){
            if(oldValue){
                for(var i=0; i<vm.data.textDocument.levels.level.length; i++){
                    if(vm.data.textDocument.levels.level[i].imageart) {
                        var imageart = vm.data.textDocument.levels.level[i].imageart;
                        if (imageart.selected) {
                            if (vm.unit == 'mm') {
                                imageart.geometry.y = (vm.attribute.material.y / 25.4 * vm.windowDpiH).toFixed(2);
                            }
                            if (vm.unit == 'px') {
                                imageart.geometry.y = vm.attribute.material.y;
                            }
                            break;
                        }
                    }
                }
            }
        })

        $scope.$watch("vm.font.text",function(newValue,oldValue){
            if(newValue){
                sizeHeight();
            }
        })
        $scope.verifyText = function(){
            FontManagement.fontSupport({uuid:vm.font.fontuuid,bold:vm.font.style.bold,italic:vm.font.style.italic,content:vm.font.text},function (res) {
                var msg = res.message;
                if(res.status==200){
                    if(msg.success&&!msg.supported){
                        MessageService.error("【"+ msg.failed +"】" + "当前字体不支持这些文字！");
                    }
                    vm.font.text = msg.passed;
                }
            })
        }
        $scope.$watch("vm.attribute.font.width",function(newValue,oldValue){
            if(oldValue){
                for(var i=0; i<vm.data.textDocument.levels.level.length; i++){
                    if(vm.data.textDocument.levels.level[i].textbox) {
                        var textbox = vm.data.textDocument.levels.level[i].textbox;
                        if (textbox.selected) {
                            if (vm.unit == 'mm') {
                                textbox.geometry.width = (vm.attribute.font.width / 25.4 * vm.windowDpiW).toFixed(2);
                            }
                            if (vm.unit == 'px') {
                                textbox.geometry.width = vm.attribute.font.width;
                            }
                            break;
                        }
                    }
                }
                sizeHeight();
            }
        })
        $scope.$watch("vm.attribute.font.x",function(newValue,oldValue){
            if(oldValue){
                for(var i=0; i<vm.data.textDocument.levels.level.length; i++){
                    if(vm.data.textDocument.levels.level[i].textbox) {
                        var textbox = vm.data.textDocument.levels.level[i].textbox;
                        if (textbox.selected) {
                            if (vm.unit == 'mm') {
                                textbox.geometry.x = (vm.attribute.font.x / 25.4 * vm.windowDpiW).toFixed(2);
                            }
                            if (vm.unit == 'px') {
                                textbox.geometry.x = vm.attribute.font.x;
                            }
                            break;
                        }
                    }
                }
            }
        })
        $scope.$watch("vm.attribute.font.y",function(newValue,oldValue){
            if(oldValue){
                for(var i=0; i<vm.data.textDocument.levels.level.length; i++){
                    if(vm.data.textDocument.levels.level[i].textbox) {
                        var textbox = vm.data.textDocument.levels.level[i].textbox;
                        if (textbox.selected) {
                            if (vm.unit == 'mm') {
                                textbox.geometry.y = (vm.attribute.font.y / 25.4 * vm.windowDpiW).toFixed(2);
                            }
                            if (vm.unit == 'px') {
                                textbox.geometry.y = vm.attribute.font.y;
                            }
                            break;
                        }
                    }
                }
            }
        })

        //锁定
        $scope.xmlLock = function(){
            if (!vm.xmlSelect.type) {
                MessageService.notice('请选择一个元素');
                return
            }
            if(vm.xmlSelect.type == 'imageart'){
                for(var i=0; i<vm.data.textDocument.levels.level.length; i++){
                    if(vm.data.textDocument.levels.level[i].imageart){
                        var _imageart = vm.data.textDocument.levels.level[i].imageart;
                        if(_imageart.selected){
                            _imageart.lock = !_imageart.lock;
                            vm.xmlSelect.lock = _imageart.lock;
                            break
                        }
                    }
                }
            }
            if(vm.xmlSelect.type == 'textbox'){
                for(var i=0; i<vm.data.textDocument.levels.level.length; i++){
                    if(vm.data.textDocument.levels.level[i].textbox){
                        var _textbox = vm.data.textDocument.levels.level[i].textbox;
                        if(_textbox.selected){
                            _textbox.lock = !_textbox.lock;
                            vm.xmlSelect.lock = _textbox.lock;
                            break
                        }
                    }
                }
            }
            cookie()
        }
        //复制
        $scope.xmlCopy = function(){
            if (!vm.xmlSelect.type) {
                MessageService.notice('请选择一个元素');
                return
            }
            xmlCopy()
        }
        var keyDownTimer = null;
        //键盘事件
        document.onkeydown = function(event){
            //ctrl + c
            if (event.ctrlKey && window.event.keyCode==67){
                if(event.target.nodeName=='TEXTAREA'){
                    return
                }
                return false;
            }
            //ctrl + v
            if (event.ctrlKey && window.event.keyCode==86){
                if(event.target.nodeName=='TEXTAREA'){
                    return
                }
                xmlCopy();
                $scope.$digest();
                return false;
            }
            // 删除
            if (event.keyCode == 46) {
                xmlDelete();
                $scope.$digest();
            }
            //空格
            if(event.keyCode === 32){
                if(vm.moveCanvasView) return false;
                $timeout(function(){
                    vm.moveCanvasView = true;
                })
                return false;
            }
            //F11
            if (event.keyCode===122 && !vm.isFullScreen) {
                event.preventDefault();
                $scope.fullScreen();
            }
            // ctrl+z
            if (event.keyCode == 90 && event.ctrlKey && !vm.textEditor) {
                $scope.xmlRevocation(event);
                $scope.$digest();
            }
        }
        document.onkeyup = function(){
            if(event.keyCode === 32){
                $timeout(function(){
                    vm.moveCanvasView = false;
                })
            }

        }
        //移动画布
        $scope.moveCanvas = function(e){
            if(!vm.moveCanvasView) return;
            var moveCanvasInfo = angular.copy(vm.moveCanvasInfo);
            moveCanvas(e,function(x,y){
                $timeout(function(){
                    vm.moveCanvasInfo.x = moveCanvasInfo.x + x;
                    vm.moveCanvasInfo.y = moveCanvasInfo.y + y;
                })

            })
        }
        //画布位置x
        $scope.canvasCoordX = function(width){
            if(!width) return 0;
            var canvasWidth = $("#canvas").width();
            var x = (canvasWidth - width) / 2 + vm.moveCanvasInfo.x;

            return x + "px";
        }
        //画布位置Y
        $scope.canvasCoordY = function(height){
            if(!height) return 0;
            var canvasHeight = $("#canvas").height();
            var y = (canvasHeight - height) / 2 + vm.moveCanvasInfo.y;
            return y + "px";
        }
        /**
         * 画布放大、缩小、还原
         * @param {*} type  0 还原 1缩小 2放大  3原尺寸
         */
        $scope.changeCanvasSize = function(type){
            $timeout(function(){
                //步长
                var stepSize = 0.02;
                //还原
                if(type === 0){
                    initWindow();
                    vm.initMoveCanvasInfo();
                }
                //1:1 原尺寸
                if(type === 3){
                    vm.ratio = 1;
                    vm.initMoveCanvasInfo();
                }
                // 缩小
                if(type === 1){
                    vm.ratio = vm.ratio - stepSize;
                    //限制最小缩放比不能小于0.5倍的初始尺寸
                    if(vm.ratio < (0.5 * vm.initRatio)) vm.ratio = 0.5 * vm.initRatio;
                }
                //放大
                if(type === 2){
                    vm.ratio = vm.ratio + stepSize;
                    //限制放大倍数不能大于1.5倍的初始尺寸
                    if(vm.ratio > (1.5 * vm.initRatio)) vm.ratio = 1.5 * vm.initRatio;
                }
            })
        }
        function originalEventRatio(){
            if (event.ctrlKey === true || event.metaKey) {
                var wheelDelta = event.wheelDelta ? (event.wheelDelta / 120) : (-event.detail / 3);
                if (wheelDelta > 0) {
                    $scope.changeCanvasSize(2);
                } else {
                    $scope.changeCanvasSize(1);
                }
                $scope.$apply();
                event.preventDefault();
            }
        }
        //鼠标滚轮事件
        window.addEventListener('mousewheel',originalEventRatio,{passive: false});
        $scope.$on('$destroy',function () {
            //取消监听事件
            window.removeEventListener('mousewheel',originalEventRatio)
        });
        function xmlCopy(){
            var _level = "";
            if(vm.xmlSelect.type == 'imageart'){
                for(var i=0; i<vm.data.textDocument.levels.level.length; i++){
                    if(vm.data.textDocument.levels.level[i].imageart) {
                        var _imageart = vm.data.textDocument.levels.level[i].imageart;
                        if (_imageart.selected) {
                            _level = angular.copy(vm.data.textDocument.levels.level[i]);
                            break
                        }
                    }
                }
                if(_level){
                    _level.imageart.selected = false;
                    _level.imageart.geometry.x = Number(_level.imageart.geometry.x) + Number(10);
                    _level.imageart.geometry.y = Number(_level.imageart.geometry.y) + Number(10);
                    _level.seq = Number(vm.data.textDocument.levels.level.length) + Number(1);
                    vm.data.textDocument.levels.level.push(_level)
                }
                cookie()
            }
            if(vm.xmlSelect.type == 'textbox'){
                for(var i=0; i<vm.data.textDocument.levels.level.length; i++){
                    if(vm.data.textDocument.levels.level[i].textbox) {
                        var _textbox = vm.data.textDocument.levels.level[i].textbox;
                        if (_textbox.selected) {
                            _level = angular.copy(vm.data.textDocument.levels.level[i]);
                            break
                        }
                    }
                }
                if(_level){
                    vm.ctrlKeyArray = [];
                    _level.textbox.selected = false;
                    _level.textbox.ctrlKey = false;
                    _level.textbox.geometry.x = Number(_level.textbox.geometry.x) + Number(10);
                    _level.textbox.geometry.y = Number(_level.textbox.geometry.y) + Number(10);
                    _level.seq = Number(vm.data.textDocument.levels.level.length) + Number(1);
                    vm.data.textDocument.levels.level.push(_level)
                }
                cookie()
            }
        }
        //上移一层
        $scope.seqUp = function(event){
            seqTier('seqUp');
            fn(event);
        }
        //下移一层
        $scope.seqDown = function(event){
            seqTier('seqDown');
            fn(event);
        }
        //置顶
        $scope.seqStick = function(event){
            seqTier('seqStick');
            fn(event);
        }
        //置底
        $scope.seqBottom = function(event){
            seqTier('seqBottom');
            fn(event);
        }
        function seqTier(data){
            if(vm.xmlSelect.type == 'imageart'){
                for(var i=0; i<vm.data.textDocument.levels.level.length; i++){
                    if(vm.data.textDocument.levels.level[i].imageart) {
                        var _imageart = vm.data.textDocument.levels.level[i].imageart;
                        if (_imageart.selected) {
                            var _seq = Number(vm.data.textDocument.levels.level.length) + Number(1);
                            if(data == 'seqUp'){
                                if(vm.data.textDocument.levels.level[i].seq >= _seq){
                                    MessageService.error("已在最顶层");
                                    return
                                }
                                vm.data.textDocument.levels.level[i].seq > _seq ? _seq : vm.data.textDocument.levels.level[i].seq++;
                            }
                            if(data == 'seqDown'){
                                if(vm.data.textDocument.levels.level[i].seq == 0){
                                    MessageService.error("已在最底层");
                                    return
                                }
                                vm.data.textDocument.levels.level[i].seq < 1 ? 0 : vm.data.textDocument.levels.level[i].seq--
                            }
                            if(data == 'seqStick'){
                                if(vm.data.textDocument.levels.level[i].seq >= _seq){
                                    MessageService.error("已在最顶层");
                                    return
                                }
                                vm.data.textDocument.levels.level[i].seq = _seq
                            }
                            if(data == 'seqBottom'){
                                if(vm.data.textDocument.levels.level[i].seq == 0){
                                    MessageService.error("已在最底层");
                                    return
                                }
                                vm.data.textDocument.levels.level[i].seq = 0
                            }
                            break
                        }
                    }
                }
            }
            if(vm.xmlSelect.type == 'textbox'){
                for(var i=0; i<vm.data.textDocument.levels.level.length; i++){
                    if(vm.data.textDocument.levels.level[i].textbox) {
                        var _textbox = vm.data.textDocument.levels.level[i].textbox;
                        if (_textbox.selected) {
                            if(data == 'seqUp'){
                                if(vm.data.textDocument.levels.level[i].seq == 99){
                                    MessageService.error("已在最顶层");
                                    return
                                }
                                vm.data.textDocument.levels.level[i].seq > 99 ? 99 : vm.data.textDocument.levels.level[i].seq++;
                            }
                            if(data == 'seqDown'){
                                if(vm.data.textDocument.levels.level[i].seq == 0){
                                    MessageService.error("已在最底层");
                                    return
                                }
                                vm.data.textDocument.levels.level[i].seq < 1 ? 0 : vm.data.textDocument.levels.level[i].seq--;
                            }
                            if(data == 'seqStick'){
                                if(vm.data.textDocument.levels.level[i].seq == 99){
                                    MessageService.error("已在最顶层");
                                    return
                                }
                                vm.data.textDocument.levels.level[i].seq = 99;
                            }
                            if(data == 'seqBottom'){
                                if(vm.data.textDocument.levels.level[i].seq == 0){
                                    MessageService.error("已在最底层");
                                    return
                                }
                                vm.data.textDocument.levels.level[i].seq = 0;
                            }
                            break
                        }
                    }
                }
            }
            cookie()
        }

        //删除
        $scope.xmlDelete = function(){
            if (!vm.xmlSelect.type) {
                MessageService.notice('请选择一个元素');
                return
            }
            xmlDelete()
        }
        function xmlDelete(){
            var level = angular.copy(vm.data.textDocument.levels.level);
            if(vm.xmlSelect.type == 'imageart'){
                for(var i=0; i<level.length; i++){
                    if(level[i].imageart){
                        var _imageart = level[i].imageart;
                        if(_imageart.selected){
                            level.splice(i, 1)
                            break
                        }
                    }
                }
                vm.data.textDocument.levels.level = [];
                $timeout(function () {
                    vm.data.textDocument.levels.level = level;
                    cookie()
                })
            }
            if(vm.xmlSelect.type == 'textbox'){
                for(var i=0; i<level.length; i++){
                    if(level[i].textbox){
                        var _textbox = level[i].textbox;
                        if(_textbox.selected){
                            level.splice(i, 1)
                            break
                        }
                    }
                }
                vm.data.textDocument.levels.level = [];
                $timeout(function () {
                    vm.data.textDocument.levels.level = level;
                    cookie()
                })
            }
        }
        //上一步
        $scope.xmlRevocation = function(){
            vm.data.textDocument.levels.level = [];
            $timeout(function () {
                if(vm.cookies.length<2){
                    vm.data = angular.copy(vm.dataInit);
                    vm.cookies=[];
                    return
                }
                vm.data = vm.cookies[vm.cookies.length-2];
                vm.cookies.splice(1)
            })
            clear()
        };
        //恢复
        $scope.xmlNextStep = function(){
            $timeout(function () {
                vm.data = angular.copy(vm.dataInit);
                vm.cookies = [];
            })
            clear()
        };
        vm.isFullScreen = false;
        function getFullState(){
            $timeout(function () {
                vm.isFullScreen = Math.abs(window.screen.height-window.document.documentElement.clientHeight) <= 17;
            })
        }
        getFullState();
        //全屏
        $scope.fullScreen = function(){
            var el = document.documentElement
            var rfs = el.requestFullScreen || el.webkitRequestFullScreen || el.mozRequestFullScreen || el.msRequestFullscreen
            if (rfs) { // typeof rfs != "undefined" && rfs
                rfs.call(el)
            }else if (typeof window.ActiveXObject !== 'undefined') {
                // for IE，这里其实就是模拟了按下键盘的F11，使浏览器全屏
                var wscript = new ActiveXObject('WScript.Shell')
                if (wscript != null) {
                    wscript.SendKeys('{F11}')
                }
            }
        }
        $scope.exitScreen = function(){
            var el = document
            var cfs = el.cancelFullScreen || el.mozCancelFullScreen || el.msExitFullscreen || el.webkitExitFullscreen || el.exitFullscreen
            if (cfs) { // typeof cfs != "undefined" && cfs
                cfs.call(el)
            } else if (typeof window.ActiveXObject !== 'undefined') {
                // for IE，这里和fullScreen相同，模拟按下F11键退出全屏
                var wscript = new ActiveXObject('WScript.Shell')
                if (wscript != null) {
                    wscript.SendKeys('{F11}')
                }
            }
        }
        //透明度
        vm.isTransparency = false;
        $scope.transparencyCb = function ($event) {
            if (!vm.xmlSelect.type) {
                MessageService.notice('请选择一个元素');
                return
            }
            var arrt = vm.isTransparency;
            clearBubble();
            vm.isTransparency = !arrt;
            if(vm.isTransparency){
                vm.xmlSelect.transparency1 = Math.round(vm.xmlSelect.transparency * 100);
            }
            var $event = $event || window.event;
            //防止浏览器默认行为(W3C)
            if($event && $event.preventDefault){
                $event.preventDefault();
            }
            //IE中组织浏览器行为
            else {
                window.event.returnValue = false;
                return false;
            }
            $event.stopPropagation();
        }
        $scope.transparencyChange1 = function(){
            $timeout(function () {
                if(vm.xmlSelect.transparency1 === '' || vm.xmlSelect.transparency1 === null || vm.xmlSelect.transparency1<0){
                    vm.xmlSelect.transparency1 = 0
                }
                if(vm.xmlSelect.transparency1 > 100){
                    vm.xmlSelect.transparency1 = 100
                }
                vm.xmlSelect.transparency = vm.xmlSelect.transparency1 / 100;
                if(vm.xmlSelect.type == 'imageart'){
                    for(var i=0; i<vm.data.textDocument.levels.level.length; i++){
                        if(vm.data.textDocument.levels.level[i].imageart) {
                            var _imageart = vm.data.textDocument.levels.level[i].imageart;
                            if (_imageart.selected) {
                                _imageart.transparency = vm.xmlSelect.transparency;
                                break
                            }
                        }
                    }
                }
                if(vm.xmlSelect.type == 'textbox'){
                    for(var i=0; i<vm.data.textDocument.levels.level.length; i++){
                        if(vm.data.textDocument.levels.level[i].textbox) {
                            var _textbox = vm.data.textDocument.levels.level[i].textbox;
                            if (_textbox.selected) {
                                _textbox.transparency = vm.xmlSelect.transparency;
                                break
                            }
                        }
                    }
                }
            })
        }
        window.onclick = function (e) {
            $timeout(function () {
                clearBubble();
            })
        }
        var isTransparency = false;
        $scope.transparencydown = function($event){
            fn($event)
            var x = $event.clientX;
            //获取透明度
            var transparency = vm.xmlSelect.transparency;

            //开关打开
            isTransparency = true;
            //鼠标移动
            window.onmousemove = function (e) {
                if (isTransparency == false) {
                    return;
                }
                var e = e || window.event;
                //防止浏览器默认行为(W3C)
                if(e && e.preventDefault){
                    e.preventDefault();
                }
                //IE中组织浏览器行为
                else {
                    window.event.returnValue = false;
                    return false;
                }
                //获取x和y
                var nx = e.clientX;
                //计算移动后的左偏移量和顶部的偏移量
                var nl = nx - x;
                vm.xmlSelect.transparency = Math.ceil(Number(transparency) + Number(nl));
                if(vm.xmlSelect.transparency<0){
                    vm.xmlSelect.transparency = 0;
                }
                if(vm.xmlSelect.transparency > 100){
                    vm.xmlSelect.transparency = 100;
                }
                $("#c-xml-action-div-transparency-bar").css({
                    'left': vm.xmlSelect.transparency
                });
                if(vm.xmlSelect.type == 'imageart'){
                    for(var i=0; i<vm.data.textDocument.levels.level.length; i++){
                        if(vm.data.textDocument.levels.level[i].imageart) {
                            var _imageart = vm.data.textDocument.levels.level[i].imageart;
                            if (_imageart.selected) {
                                _imageart.transparency = vm.xmlSelect.transparency / 100;
                                break
                            }
                        }
                    }
                }
                if(vm.xmlSelect.type == 'textbox'){
                    for(var i=0; i<vm.data.textDocument.levels.level.length; i++){
                        if(vm.data.textDocument.levels.level[i].textbox) {
                            var _textbox = vm.data.textDocument.levels.level[i].textbox;
                            if (_textbox.selected) {
                                _textbox.transparency = vm.xmlSelect.transparency / 100;
                                break
                            }
                        }
                    }
                }
            }
            //鼠标抬起事件
            window.onmouseup = function (e) {
                isTransparency = false;
            };
            cookie()
        }

        $scope.changeTransparency = function($event){
            fn($event)
            if(vm.xmlSelect.type == 'imageart'){
                for(var i=0; i<vm.data.textDocument.levels.level.length; i++){
                    if(vm.data.textDocument.levels.level[i].imageart) {
                        var _imageart = vm.data.textDocument.levels.level[i].imageart;
                        if (_imageart.selected) {
                            _imageart.transparency = vm.xmlSelect.transparency;
                            break
                        }
                    }
                }
            }
            if(vm.xmlSelect.type == 'textbox'){
                for(var i=0; i<vm.data.textDocument.levels.level.length; i++){
                    if(vm.data.textDocument.levels.level[i].textbox) {
                        var _textbox = vm.data.textDocument.levels.level[i].textbox;
                        if (_textbox.selected) {
                            _textbox.transparency = vm.xmlSelect.transparency;
                            break
                        }
                    }
                }
            }
            vm.xmlSelect.transparency1 = Math.round(vm.xmlSelect.transparency * 100);
        }

        //字体family
        vm.selectFont = '';
        vm.selectFontBtn = fontInit;
        vm.selectFontName = selectFontName;
        function fontInit(){
            vm.fontList1 = [];
            FontManagement.getAll3({family: vm.selectFont}, function (res) {
                vm.fontList1 = res;
            });
        }
        function selectFontName(item){
            if(item){
                for(var i=0;i<vm.fontList.length; i++){
                    if(vm.fontList[i].uuid == item){
                        return vm.fontList[i].family
                    }
                }
            }
        }
        $scope.operationFontFamily = function (item) {
            vm.font.fontuuid = item.uuid;
            var _fontStyle = [];
            for(var i=0; i<vm.fontList.length; i++){
                if(vm.fontList[i].uuid == item.uuid){
                    for(var j=0; j<vm.fontList[i].fontStyles.length; j++){
                        _fontStyle.push(vm.fontList[i].fontStyles[j].style)
                    }
                }
            }
            if(_fontStyle.indexOf('NORMAL') != '-1'){
                vm.font.style.bold = false;
                vm.font.style.italic = false;
            }else {
                if(_fontStyle.indexOf('BOLD_ITALIC') != '-1'){
                    vm.font.style.bold = true;
                    vm.font.style.italic = true;
                }else {
                    if(_fontStyle.indexOf('ITALIC') != '-1'){
                        vm.font.style.italic = true;
                        vm.font.style.bold = false;
                    }
                    if(_fontStyle.indexOf('BOLD') != '-1'){
                        vm.font.style.bold = true;
                        vm.font.style.italic = false;
                    }
                }
            }
            getFont(vm.font)
            fontEdit();
            sizeHeight();
            fontStyle();
        }
        //字体
        $scope.operationFont = function () {
            vm.font.style.lineheight = parseInt(vm.font.style.size);
            fontEdit();
            sizeHeight();
        }
        //斜体
        $scope.operationItalic = function () {
            if(vm.font.fontStyle.indexOf('NORMAL') != '-1'){
                vm.font.style.italic = !vm.font.style.italic;
                fontEdit();
                sizeHeight();
            }else {
                if(vm.font.fontStyle.indexOf('BOLD_ITALIC') != '-1' || vm.font.fontStyle.indexOf('BOLD') != '-1'){
                    if(vm.font.style.bold){
                        vm.font.style.italic = !vm.font.style.italic;
                        fontEdit();
                        sizeHeight();
                    }
                }
            }
        }
        //粗体
        $scope.operationBold = function () {
            if(vm.font.fontStyle.indexOf('NORMAL') != '-1'){
                vm.font.style.bold = !vm.font.style.bold;
                fontEdit();
                sizeHeight();
            }else {
                if(vm.font.fontStyle.indexOf('BOLD_ITALIC') != '-1' || vm.font.fontStyle.indexOf('ITALIC') != '-1'){
                    if(vm.font.style.italic){
                        vm.font.style.bold = !vm.font.style.bold;
                        fontEdit();
                        sizeHeight();
                    }
                }
            }
        }
        //间距
        vm.isOperationSpacing = false
        $scope.operationSpacing = function ($event) {
            var arrt = vm.isOperationSpacing;
            clearBubble();
            vm.isOperationSpacing = !arrt;
            var $event = $event || window.event;
            //防止浏览器默认行为(W3C)
            if($event && $event.preventDefault){
                $event.preventDefault();
            }
            //IE中组织浏览器行为
            else {
                window.event.returnValue = false;
                return false;
            }
            $event.stopPropagation();
        }
        //字间距
        var isWordSpace = false;
        $scope.wordSpacedown = function($event){
            var $event = $event || window.event;
            //防止浏览器默认行为(W3C)
            if($event && $event.preventDefault){
                $event.preventDefault();
            }
            //IE中组织浏览器行为
            else {
                window.event.returnValue = false;
                return false;
            }
            $event.stopPropagation();
            var x = $event.clientX;
            //获取字间距
            var letterspacing = parseInt(vm.font.style.letterspacing);

            //开关打开
            isWordSpace = true;
            //鼠标移动
            window.onmousemove = function (e) {
                if (isWordSpace == false) {
                    return;
                }
                var e = e || window.event;
                //防止浏览器默认行为(W3C)
                if(e && e.preventDefault){
                    e.preventDefault();
                }
                //IE中组织浏览器行为
                else {
                    window.event.returnValue = false;
                    return false;
                }
                //获取x和y
                var nx = e.clientX;
                //计算移动后的左偏移量和顶部的偏移量
                var nl = nx - x;
                vm.font.style.letterspacing = Math.ceil(Number(letterspacing) + Number(nl));
                if(vm.font.style.letterspacing<0){
                    vm.font.style.letterspacing = 0;
                }
                if(vm.font.style.letterspacing > 100){
                    vm.font.style.letterspacing = 100;
                }
                $("#c-xml-wordSpace").css({
                    'left': vm.font.style.letterspacing
                });
                sizeHeight();
            }
            //鼠标抬起事件
            window.onmouseup = function (e) {
                isWordSpace = false;
            };
        }
        $scope.wordSpacedown1 = function ($event) {
            var $event = $event || window.event;
            //防止浏览器默认行为(W3C)
            if($event && $event.preventDefault){
                $event.preventDefault();
            }
            //IE中组织浏览器行为
            else {
                window.event.returnValue = false;
                return false;
            }
            $event.stopPropagation();
            var x = $event.clientX;
            // var x1 = $event.originalEvent.changedTouches[0].clientX;
            // console.log(x)
            // console.log(x1)
        }
        //行间距
        var isLineSpace = false;
        $scope.lineSpacedown = function($event){
            var $event = $event || window.event;
            //防止浏览器默认行为(W3C)
            if($event && $event.preventDefault){
                $event.preventDefault();
            }
            //IE中组织浏览器行为
            else {
                window.event.returnValue = false;
                return false;
            }
            $event.stopPropagation();
            var x = $event.clientX;
            //获取字间距
            var lineheight = parseInt(vm.font.style.lineheight);

            //开关打开
            isLineSpace = true;
            //鼠标移动
            window.onmousemove = function (e) {
                if (isLineSpace == false) {
                    return;
                }
                var e = e || window.event;
                //防止浏览器默认行为(W3C)
                if(e && e.preventDefault){
                    e.preventDefault();
                }
                //IE中组织浏览器行为
                else {
                    window.event.returnValue = false;
                    return false;
                }
                //获取x和y
                var nx = e.clientX;
                //计算移动后的左偏移量和顶部的偏移量
                var nl = nx - x;
                vm.font.style.lineheight = Math.ceil(Number(lineheight) + Number(nl));
                if(vm.font.style.lineheight<0){
                    vm.font.style.lineheight = 0;
                }
                if(vm.font.style.lineheight > 100){
                    vm.font.style.lineheight = 100;
                }
                $("#c-xml-lineSpace").css({
                    'left': vm.font.style.lineheight
                });
                sizeHeight();
            }
            //鼠标抬起事件
            window.onmouseup = function (e) {
                isLineSpace = false;
            };
        }

        $scope.changeLetterspacing = function(){
            vm.font.style.letterspacing = Number(vm.font.style.letterspacing)
            sizeHeight();
        }
        $scope.changeLineheight = function() {
            vm.font.style.lineheight = Number(vm.font.style.lineheight)
            sizeHeight();
        }

        $scope.$watch("vm.font.style.lineheight",function(newValue,oldValue){
            if(oldValue && vm.font){
                if(vm.font.style && vm.font.style.size && newValue < parseInt(vm.font.style.size)){
                    vm.font.style.lineheight = parseInt(vm.font.style.size);
                }
                sizeHeight();
            }
        })

        function sizeHeight(){
            $timeout(function () {
                var _h = Number($(".c-xml-page-textboxe-pitch").find('.c-xml-page-textboxe-text span').height()) + Number(5);
                // var _h = Number($("#c-xml-page-material-fontId").height()) + Number(5);
                // var _w = Number($(".c-xml-page-textboxe-pitch").find('.c-xml-page-textboxe-text').width()) + Number(5);
                for(var i=0; i<vm.data.textDocument.levels.level.length; i++){
                    if(vm.data.textDocument.levels.level[i].textbox) {
                        var _textbox = vm.data.textDocument.levels.level[i].textbox;
                        if (_textbox.selected) {
                            _textbox.geometry.height = _h / vm.ratio;
                            // _textbox.geometry.width = _w / vm.ratio;
                            if(_textbox.geometry.height > vm.data.textDocument.geometry.height){
                                _textbox.geometry.height = vm.data.textDocument.geometry.height;
                                // _textbox.style.size = parseInt(_textbox.style.size * (_textbox.geometry.height / _h * vm.ratio));
                            }
                            if(Number(_textbox.geometry.height) + Number(_textbox.geometry.y) > vm.data.textDocument.geometry.height){
                                _textbox.geometry.y = (vm.data.textDocument.geometry.height - _textbox.geometry.height);
                            }
                            break
                        }
                    }
                }
            })
        }
        function sizeHeight1(callback) {
            if (vm.textEditor) {
                $timeout(function () {
                    var _h = Number($("#c-xml-page-material-fontId2").height()) + Number(10);
                    var _w = Number($("#c-xml-page-material-fontId2").width()) + Number(10);
                    if(!writingmodeInit(vm.textEditor.style.writingmode)){
                        vm.textEditor.geometry.height = _h;
                    }
                    if(writingmodeInit(vm.textEditor.style.writingmode)){
                        vm.textEditor.geometry.width = _w;
                    }
                    for(var i=0; i<vm.data.textDocument.levels.level.length; i++){
                        if(vm.data.textDocument.levels.level[i].textbox) {
                            var _textbox = vm.data.textDocument.levels.level[i].textbox;
                            if (_textbox.selected) {
                                _textbox = vm.textEditor;
                                console.log(_textbox)
                                break
                            }
                        }
                    }
                    if(callback){callback()};
                })
            }
        }
        $scope.writingmodeInit = writingmodeInit;
        function writingmodeInit(item) {
            if (item == 'vertical-lr' || item == 'vertical-rl') {
                return true
            } else {
                return false
            }
        }

        //左对齐
        $scope.operationBarLeft = function ($event) {
            vm.font.style.align = 'left';
            // vm.font.geometry.x = 10;
            fontEdit()
        }
        //居中对齐
        $scope.operationBarCenter = function ($event) {
            vm.font.style.align = 'center';
            // vm.font.geometry.x = (vm.data.textDocument.geometry.width - vm.font.geometry.width) / 2;
            fontEdit()
        }
        //右对齐
        $scope.operationBarRight = function ($event) {
            vm.font.style.align = 'right';
            // vm.font.geometry.x = (vm.data.textDocument.geometry.width - vm.font.geometry.width) - 10;
            fontEdit()
        }
        //两端对齐
        $scope.operationBarJustify = function ($event) {
            vm.font.style.align = 'justified';
            fontEdit()
        }
        //颜色
        $scope.operationColorOpen = function($event){
            var $event = $event || window.event;
            //防止浏览器默认行为(W3C)
            if($event && $event.preventDefault){
                $event.preventDefault();
            }
            //IE中组织浏览器行为
            else {
                window.event.returnValue = false;
                return false;
            }
            $event.stopPropagation();
            vm.isOperationColor = true;
        }
        $scope.operationColor = function(item){
            vm.font.style.color = item.id;
            fontEdit()
        }
        $scope.chooseColor = function () {
            fontEdit();
        }


        //缓存每一步
        vm.operation = false;
        function cookie(){
            var _data = angular.copy(vm.data);
            if(_data.textDocument.levels.level){
                for(var i=0; i<_data.textDocument.levels.level.length; i++){
                    var _levels = _data.textDocument.levels.level[i];
                    if(_levels.imageart){
                        _levels.imageart.selected = false;
                    }
                    if(_levels.textbox){
                        _levels.textbox.selected = false;
                        _levels.textbox.ctrlKey = false;
                        _levels.textbox.loading = false;
                    }
                }
                vm.cookies.push(_data);
                vm.cookieIndex = vm.cookies.length - 1;
                vm.operation = true;
            }
        }

        function addElement(type, data) {
            var _seq = Number(vm.data.textDocument.levels.level.length) + Number(1);
            if(type == 'imageart'){
                var _level = {
                    seq: _seq,
                    imageart: null
                }
                _level.imageart = data;
                vm.data.textDocument.levels.level.push(_level);
            }
            if(type == 'textbox'){
                var _level = {
                    seq: _seq,
                    textbox: null
                }
                _level.textbox = data;
                vm.data.textDocument.levels.level.push(_level);
            }
        }

        //可编辑
        $scope.editableTrue = function(){
            editableInit(true)
        }
        //不可编辑
        $scope.editableFalse = function(){
            editableInit(false)
        }
        function editableInit(data) {
            vm.xmlSelect.editable = data;
            if(vm.xmlSelect.type == ''){
                vm.data.textDocument.editable = data;
            }
            if(vm.xmlSelect.type == 'imageart'){
                for(var i=0; i<vm.data.textDocument.levels.level.length; i++){
                    if(vm.data.textDocument.levels.level[i].imageart) {
                        var _imageart = vm.data.textDocument.levels.level[i].imageart;
                        if (_imageart.selected) {
                            _imageart.editable = data;
                            break
                        }
                    }
                }
            }
            if(vm.xmlSelect.type == 'textbox'){
                for(var i=0; i<vm.data.textDocument.levels.level.length; i++){
                    if(vm.data.textDocument.levels.level[i].textbox) {
                        var _textbox = vm.data.textDocument.levels.level[i].textbox;
                        if (_textbox.selected) {
                            _textbox.editable = data;
                            break
                        }
                    }
                }
            }
        }

        var fontuuids = [];
        function getFont(item){
            if(!fontuuids){
                fontuuids = [];
            }
            if(fontuuids.indexOf(item.fontuuid) == -1) {
                fontuuids.push(item.fontuuid);
                item.loading = true;
                FontManagement.getCss({uuid: item.fontuuid}, function (res) {
                    var style=document.createElement("style");
                    style.type='text/css';
                    try{
                        style.appendChild(document.createTextNode(res.message));
                    }catch(ex){
                        style.stylesheet.cssText=res.message;
                    }
                    var Head=document.getElementsByTagName("head")[0];
                    Head.appendChild(style);
                    document.fonts.ready.then(function() {
                        item.loading = false;
                        $scope.$digest();
                    });
                });
            }
        }

        //保存至作品
        $scope.save = function () {
            selectCancel();
            vm.loading = true;
            setTimeout(function () {
                var _data = unitMm();
                var nodes = document.getElementById('c-xml');
                html2canvas_adapt(nodes, {
                    onrendered: function(canvas) {
                        var url = canvas.toDataURL("image/png");
                        var blob = dataURLtoBlob(url);

                        var formData = new FormData();
                        formData.append('file', blob);
                        formData.append('key', 'font-' + UidService.get());
                        formData.append('token', vm.token);
                        $.ajax({
                            cache: true,
                            type: "POST",
                            url: 'https://upload.qiniup.com/',
                            data: formData,
                            async: false,
                            contentType: false,
                            processData: false,
                            success: function (data) {
                                _data.cover = vm.url + data.key;
                                if(_data.id){
                                    FontXmls.update(_data, function (res) {
                                        MessageService.success("保存成功");
                                        // $state.go('textList')
                                        history.go(-1)
                                    })
                                }else{
                                    FontXmls.save(_data, function (res) {
                                        MessageService.success("保存成功");
                                        $state.go('text')
                                        // history.go(-1)
                                    })
                                }
                                vm.loading = false;
                                $scope.$digest();
                            },
                            error: function (request) {
                                MessageService.error("文件上传失败");
                            }
                        });
                    },
                    letterRendering: true,
                    useCORS: true,
                    logging: false
                });
            })
        }
        //保存并发布
        $scope.publish = function () {
            selectCancel()
            setTimeout(function () {
                var _data = unitMm();
                var nodes = document.getElementById('c-xml');
                html2canvas_adapt(nodes, {
                    onrendered: function(canvas) {
                        var url = canvas.toDataURL("image/png");
                        var blob = dataURLtoBlob(url);

                        var formData = new FormData();
                        formData.append('file', blob);
                        formData.append('key', 'font-' + UidService.get());
                        formData.append('token', vm.token);
                        $.ajax({
                            cache: true,
                            type: "POST",
                            url: 'https://upload.qiniup.com/',
                            data: formData,
                            async: false,
                            contentType: false,
                            processData: false,
                            success: function (data) {
                                _data.cover = vm.url + data.key;
                                FontXmls.release(_data, function (res) {
                                    MessageService.success("保存发布成功");
                                    // $state.go('textList')
                                    history.go(-1)
                                })
                                $scope.$digest();
                            },
                            error: function (request) {
                                MessageService.error("文件上传失败");
                            }
                        });
                    },
                    letterRendering: true,
                    useCORS: true,
                    logging: false
                });
            })
        }

        $scope.out = function () {
            if(!vm.operation){
                history.go(-1)
            }else{
                MessageService.confirm({
                    title:'温馨提示',
                    goback:'取消',
                    cancel:'不保存',
                    confirm:'保存',
                    msg:'退出前是否需要保存已变更的内容?',
                },function(){
                    $scope.save();
                },function (flag) {
                    if(flag){
                        history.go(-1)
                    }
                })
            }
        }

        function clear() {
            vm.isFont = false;
            vm.xmlSelect = {
                type: '',
                transparency: 0,
                editable: false
            };
        }

        $scope.selectCancel = selectCancel;
        function selectCancel() {
            if (vm.textEditor) {
                return
            }
            if(vm.data.textDocument.levels.level){
                for(var i=0; i<vm.data.textDocument.levels.level.length; i++){
                    if(vm.data.textDocument.levels.level[i].imageart) {
                        vm.data.textDocument.levels.level[i].imageart.selected = false;
                    }
                }
                for(var i1=0 ;i1<vm.data.textDocument.levels.level.length; i1++){
                    if(vm.data.textDocument.levels.level[i1].textbox) {
                        var _font = vm.data.textDocument.levels.level[i1].textbox;
                        _font.selected = false;
                        _font.ctrlKey = false;
                    }
                }
            }
            clear();
            vm.ctrlKeyArray = [];
        }

        function dataURLtoBlob(dataurl) {
            var arr = dataurl.split(','), mime = arr[0].match(/:(.*?);/)[1],
                bstr = atob(arr[1]), n = bstr.length, u8arr = new Uint8Array(n);
            while (n--) {
                u8arr[n] = bstr.charCodeAt(n);
            }
            return new Blob([u8arr], { type: mime });
        }

        function unitMm() {
            var _w = 25.4 / vm.windowDpiW;
            var _h = 25.4 / vm.windowDpiH;
            var _data = angular.copy(vm.data);
            _data.textDocument.geometry = {
                x: (_data.textDocument.geometry.x * _w).toFixed(2),
                y: (_data.textDocument.geometry.y * _h).toFixed(2),
                width: (_data.textDocument.geometry.width * _w).toFixed(2),
                height: (_data.textDocument.geometry.height * _h).toFixed(2)
            }
            _data.textDocument.background.offsetx= (_data.textDocument.background.offsetx * _w).toFixed(2);
            _data.textDocument.background.offsety= (_data.textDocument.background.offsety * _h).toFixed(2);
            if(_data.textDocument.levels.level){
                for(var i=0; i<_data.textDocument.levels.level.length; i++){
                    var _level = _data.textDocument.levels.level[i];
                    if(_level.textbox){
                        _level.textbox.geometry = {
                            x: (_level.textbox.geometry.x * _w).toFixed(2),
                            y: (_level.textbox.geometry.y * _h).toFixed(2),
                            width: (_level.textbox.geometry.width * _w).toFixed(2),
                            height: (_level.textbox.geometry.height * _h).toFixed(2)
                        }
                        delete _level.textbox.style.bold1;
                        delete _level.textbox.style.italic1;
                    }
                    if(_level.imageart){
                        _level.imageart.geometry = {
                            x: (_level.imageart.geometry.x * _w).toFixed(2),
                            y: (_level.imageart.geometry.y * _h).toFixed(2),
                            width: (_level.imageart.geometry.width * _w).toFixed(2),
                            height: (_level.imageart.geometry.height * _h).toFixed(2)
                        }
                        _level.imageart.offsetx = (_level.imageart.offsetx * _w).toFixed(2);
                        _level.imageart.offsety = (_level.imageart.offsety * _h).toFixed(2);
                        // _level.imageart.resource.width = (_level.imageart.resource.width * _w).toFixed(2);
                        // _level.imageart.resource.height = (_level.imageart.resource.height * _h).toFixed(2);
                    }
                }
            }
            return _data
        }
        function unitPx(item) {
            var _w = vm.windowDpiW / 25.4;
            var _h = vm.windowDpiH / 25.4;
            var _data = angular.copy(item);
            _data.textDocument.geometry = {
                x: (_data.textDocument.geometry.x * _w).toFixed(2),
                y: (_data.textDocument.geometry.y * _h).toFixed(2),
                width: (_data.textDocument.geometry.width * _w).toFixed(2),
                height: (_data.textDocument.geometry.height * _h).toFixed(2)
            }
            _data.textDocument.background.offsetx= (_data.textDocument.background.offsetx * _w).toFixed(2);
            _data.textDocument.background.offsety= (_data.textDocument.background.offsety * _h).toFixed(2);
            if(_data.textDocument.levels.level){
                for(var i=0; i<_data.textDocument.levels.level.length; i++){
                    var _level = _data.textDocument.levels.level[i];
                    if(_level.textbox){
                        _level.textbox.geometry = {
                            x: (_level.textbox.geometry.x * _w).toFixed(2),
                            y: (_level.textbox.geometry.y * _h).toFixed(2),
                            width: (_level.textbox.geometry.width * _w).toFixed(2),
                            height: (_level.textbox.geometry.height * _h).toFixed(2)
                        }
                    }
                    if(_level.imageart){
                        _level.imageart.geometry = {
                            x: (_level.imageart.geometry.x * _w).toFixed(2),
                            y: (_level.imageart.geometry.y * _h).toFixed(2),
                            width: (_level.imageart.geometry.width * _w).toFixed(2),
                            height: (_level.imageart.geometry.height * _h).toFixed(2)
                        }
                        _level.imageart.offsetx = (_level.imageart.offsetx * _w).toFixed(2);
                        _level.imageart.offsety = (_level.imageart.offsety * _h).toFixed(2);
                        imgWH(_level.imageart)
                    }
                }
            }else {
                _data.textDocument.levels.level = [];
            }
            return _data
        }

        function imgWH(data) {
            $http({url: data.resource.identifier + '?imageInfo'}).success(function (res) {
                data.resource.width = res.width;
                data.resource.height = res.height;
            }).error(function (error) {});
        }


        // 监听顶部操作栏
        vm.moreDisplay = false;
        vm.moreIcon = false;
        vm.moreDisplayFont = false;
        $(window).resize(function(){
            if ($('#nav-header').outerWidth() <= 1200) {
                vm.moreIcon = true;
            }else{
                vm.moreIcon = false;
                vm.moreDisplay = false;
                vm.moreDisplayFont = false;
            }
        })

        $scope.moreDisplay = function(){
            vm.moreDisplay = !vm.moreDisplay;
        }

        $scope.moreDisplayFont = function(){
            vm.moreDisplayFont = !vm.moreDisplayFont;
        }


        //对齐点击
        vm.isOperationDir = false
        $scope.operationDir = function (attr) {
            vm.isOperationDir = attr;
            vm.isOperationSpacing = false;
            vm.isAlignAt = false;
        }
        vm.isAlignAt = false;
        $scope.operationAlignAt = function(event){
            fn(event)
            var arrt = vm.isAlignAt;
            clearBubble();
            vm.isAlignAt = !arrt;
        }

        vm.isCoverage = false;
        $scope.coverageSelect = function(event){
            if (!vm.xmlSelect.type) {
                MessageService.notice('请选择一个元素');
                return
            }
            fn(event)
            var arrt = vm.isCoverage;
            clearBubble();
            vm.isCoverage = !arrt;
        }


        vm.uploadType = "";
        function thumbnailatorPic() {
            $uibModal.open({
                templateUrl: 'app/entities/page/thumbnailator.html',
                controller: 'ThumbnailatorController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'md',
                resolve: {
                    entity: [function () {
                        return {
                            files: bigSizePics
                        };
                    }]
                }
            }).result.then(function (values) {
                bigSizePics = [];
                if (values) {
                    //for (var j = 0; j < values.length; j++) {
                    //var value = values[j];
                    //var data = {key: value.key};
                    console.log(vm.uploadType)
                    for (var i = 0; i < values.length; i++) {
                        getBgImg(values, i, vm.uploadType);
                    }
                    //}
                }
                vm.uploadType = "";
            }, function () {
            });false
        }

        $timeout(function(){
            $('#navId').on('scroll', function(event){
                if(vm.navPitch == 'background'){
                    var realScrollHeight=event.currentTarget.clientHeight+event.currentTarget.scrollTop;
                    if(!vm.isBgImgData){
                        if((event.currentTarget.scrollHeight-1)<realScrollHeight && realScrollHeight < (event.currentTarget.scrollHeight+1)){
                            $scope.bgImgPageing();
                        }
                    }
                }
                if(vm.navPitch == 'material'){
                    var realScrollHeight=event.currentTarget.clientHeight+event.currentTarget.scrollTop;
                    if(!vm.isMaterialData){
                        if((event.currentTarget.scrollHeight-1)<realScrollHeight && realScrollHeight < (event.currentTarget.scrollHeight+1)){
                            $scope.materialPageing();
                        }
                    }
                }
            });
        })

        $scope.fn = fn;
        function fn($event){
            var $event = $event || window.event;
            $event.stopPropagation();
        }


        function clearBubble(){
            vm.isTransparency = false;
            vm.isOperationSpacing = false;
            vm.isOperationColor = false;
            vm.isAlignAt = false;
            vm.isCoverage = false;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('platformApp')
        .controller('TextShareController', TextShareController);

    TextShareController.$inject = ['$state', '$scope', 'ProductXml', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams', 'MessageService', 'FontXmls', '$localStorage', 'Qinius', '$uibModal','$timeout'];

    function TextShareController($state, $scope, ProductXml, ParseLinks, AlertService, paginationConstants, pagingParams, MessageService, FontXmls, $localStorage, Qinius, $uibModal,$timeout) {
        var vm = this;
        //搜索防抖定时器
        vm.timer = null;
        //分页信息
        vm.pageInfo = {
            page:1,
            size:20,
            total:0,
        }
        //批量操作状态
        vm.batchState = false;
        vm.batchLoading = false;
        //批量操作选中的条数
        vm.selectCount = 0;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.search = search;
        vm.loadAll = loadAll;
        vm.searchQuery = "";
        vm.account = $localStorage.user;
        $scope.domains = Qinius.getDomain();

        loadAll();

        $scope.delete = function(id){
            MessageService.confirm({
                title:'提示',
                cancel:'取消',
                confirm:'确认',
                msg:'确定要删除该数据？'
            },function(){
                FontXmls.delete({id: id},function () {
                    loadAll();
                });
            },function(){});
        };
        //当前页变更
        vm.currentChange = function(){
            $timeout(function(){
                vm.loadAll();
            })
        }
        function loadAll () {
            if (vm.account == undefined || vm.account == null) {
                $state.go('home');
                return;
            }
            if (vm.searchQuery != "") {
                FontXmls.byCondition2({
                    items:[{key:"name",value:vm.searchQuery, op:"like"},{key:"opened", op:"=", value:'true'},{key:"status", op:"=", value:'Approved'}],
                    page: vm.pageInfo.page - 1,
                    size: vm.pageInfo.size,
                    sort: ["lastModifiedDate,desc"]
                }, onSuccess, onError);
            } else {
                FontXmls.byCondition2({
                        items:[{key:"opened", op:"=", value:'true'},{key:"status", op:"=", value:'Approved'}],
                        page: vm.pageInfo.page - 1,
                        size: vm.pageInfo.size,
                        sort: ["lastModifiedDate,desc"]
                    },
                    onSuccess, onError);

            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.pageInfo.total = headers('X-Total-Count');
                vm.textList = data;
                //退出批量编辑模式
                vm.selectCount = 0;
                vm.batchState = false;
            }
            function onError(error) {
                MessageService.error("字体获取失败");
            }
        }
        function search() {
            if(event.keyCode === 13){
                vm.links = null;
                vm.pageInfo.page = 1;
                vm.predicate = 'id';
                vm.reverse = false;
                if(vm.searchQuery == ""){
                    vm.reverse = true;
                }
                vm.loadAll();
            }
        }

        $scope.release = function (data) {
            FontXmls.onlyRelease({id: data.id}, function (res) {

            })
        }
        //查看
        $scope.look = function (data) {
            $uibModal.open({
                templateUrl: 'app/entities/text/modal/text-xml-look.html',
                controller: 'TextXmlLookController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: "md",
                resolve: {
                    entity: [function() {
                        return {
                            url: data.cover,
                            domain: $scope.domains.domain
                        };
                    }]
                }
            });
        }
        // 批量操作点击选择
        vm.checkItem = function (item) {
            if(!vm.batchState) return;
            item.checked = !item.checked;
            var checkedList = vm.textList.filter(function(item){
                return item.checked === true
            });
            vm.selectCount = checkedList.length;
        }
        //批量使用
        $scope.batchUse = function(){
            if(vm.batchLoading) return;
            var checkedList = vm.textList.filter(function(item){
                return item.checked === true
            });
            var ids = checkedList.map(function(item){
                return item.id;
            })
            vm.batchLoading = true;
            FontXmls.batchUse(ids,function(res){
                MessageService.success("使用成功");
                vm.batchLoading = false;
                vm.loadAll();
            },function(){
                vm.batchLoading = false;
                MessageService.error("请求失败，请重试");
            });

        }
        $scope.save = function(data){
            FontXmls.get({id: data.id}, function (res) {
                console.log(res)
                res.id = "";
                res.opened = false;
                res.status = null;
                FontXmls.save(res, function (res) {
                    MessageService.success("使用成功");
                })
            })
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('platformApp')
        .controller('TextListController', TextListController);

    TextListController.$inject = ['$state', '$scope', 'ProductXml', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams', 'MessageService', 'FontXmls', '$localStorage', 'Qinius', '$uibModal'];

    function TextListController($state, $scope, ProductXml, ParseLinks, AlertService, paginationConstants, pagingParams, MessageService, FontXmls, $localStorage, Qinius, $uibModal) {
        var vm = this;
        //新增
        $scope.add = function () {
            $uibModal.open({
                templateUrl: 'app/entities/text/modal/text-add.html',
                controller: 'TextAddController',
                controllerAs: 'vm',
                backdrop: 'static',
                resolve: {
                    entity: [function() {
                        return {
                        };
                    }]
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('platformApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('text', {
            parent: 'app',
            url: '/text',
            data: {
                authorities: [],
                pageTitle: 'platformAppTitle.text'
            },
            views: {
                'content': {
                    templateUrl: 'app/entities/text/text.html',
                    controller: 'TextController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,desc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('fontManagement');
                    $translatePartialLoader.addPart('global');
                    $translatePartialLoader.addPart('title');
                    return $translate.refresh();
                }]
            }
        })
        .state('text-xml', {
            url: '/text-xml',
            data: {
                authorities: [],
                pageTitle: 'platformApp.productXml.home.title'
            },
            views: {
                'navbar@': {
                    templateUrl: 'app/entities/text/text-xml-edit.html',
                    controller: 'TextXmlEditController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('text-xml-edit', {
            url: '/text-xml-edit/{id}',
            data: {
                authorities: [],
                pageTitle: 'platformAppTitle.text-xml-edit'
            },
            views: {
                'navbar@': {
                    templateUrl: 'app/entities/text/text-xml-edit.html',
                    controller: 'TextXmlEditController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('global');
                    $translatePartialLoader.addPart('title');
                    return $translate.refresh();
                }]
            }
        })
            .state('textList', {
                parent: 'page',
                url: '/textList?page&sort&search',
                data: {
                    authorities: [],
                    pageTitle: 'platformApp.productXml.home.title'
                },
                views: {
                    'content': {
                        templateUrl: 'app/entities/text/text-list.html',
                        controller: 'TextListController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,desc',
                        squash: true
                    },
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('fontManagement');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            .state('textShare', {
                parent: 'app1',
                url: '/textShare?page&sort&search',
                data: {
                    authorities: [],
                    pageTitle: 'platformAppTitle.textShare'
                },
                views: {
                    'content1': {
                        templateUrl: 'app/entities/text/text-share.html',
                        controller: 'TextShareController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,desc',
                        squash: true
                    },
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('fontManagement');
                        $translatePartialLoader.addPart('global');
                        $translatePartialLoader.addPart('title');
                        return $translate.refresh();
                    }]
                }
            });
    }

})();

(function() {
    'use strict';
    angular
        .module('platformApp')
        .factory('FontXmls', FontXmls)
        .factory('ThemeClassify', ThemeClassify);
    FontXmls.$inject = ['$resource'];
    ThemeClassify.$inject = ['$resource'];
    function FontXmls($resource) {
        var resourceUrl = 'bunny/' + 'api/font-xmls/:path/:id';

        return $resource(resourceUrl, {}, {
            "save": {
                method: 'POST'
            },
            "delete": {
                method: 'DELETE'
            },
            "batchDelete":{//批量删除
                method:"POST",
                params:{
                    path:"batchDelete"
                }
            },
            "release": {
                method: 'POST',
                params:{
                    path:"release"
                },
            },
            "byCondition":{
                method:"POST",
                params:{
                    path:"byCondition"
                },
                isArray:true
            },
            "byCondition2":{
                method:"POST",
                params:{
                    path:"byCondition2"
                },
                isArray:true
            },
            "getAll":{
                method:"POST",
                params:{
                    path:"getAll"
                },
                isArray:true
            },
            "getAll2":{
                method:"POST",
                params:{
                    path:"getAll2"
                },
                isArray:true
            },
            "batchUse":{
                method:"POST",
                params:{
                    path:"batchUse"
                },
            },
            'get': {
                method: 'GET',
                transformResponse: function(data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': {
                method: 'PUT'
            },
            'onlyRelease': {
                method: 'GET',
                params:{
                    path:"onlyRelease"
                },
            },
            'share': {
                method: 'GET',
                params:{
                    path:"share"
                },
            },
            'batchShare':{//批量分享
                method: 'POST',
                params:{
                    path:'batchShare'
                }
            },
            'auditing': {
                method: 'GET',
                params:{
                    path:"auditing"
                },
            },
        });
    }
    function ThemeClassify ($resource) {
        var resourceUrl =  'bunny/' + 'api/theme-classify/:path/:id';
        return $resource(resourceUrl, {}, {
            "saveForUser":{
                method:"POST",
                params:{
                    path:"saveForUser"
                }
            },
            "byCondition1":{
                method:"POST",
                params:{
                    path:"byCondition1"
                },
                isArray:true
            },
            "getAllByCondition1":{
                method:"POST",
                params:{
                    path:"getAllByCondition1"
                },
                isArray:true
            },
            "byCondition":{
                method:"POST",
                params:{
                    path:"byCondition"
                },
                isArray:true
            },
            "byCondition3":{
                method:"POST",
                params:{
                    path:"byCondition3"
                },
                isArray:true
            },
            "byCondition4":{
                method:"GET",
                params:{
                    path:"byCondition4"
                }
            },
            "getAllByCondition":{
                method:"POST",
                params:{
                    path:"getAllByCondition"
                },
                isArray:true
            },
            "getAllByCondition2":{
                method:"POST",
                params:{
                    path:"getAllByCondition2"
                },
                isArray:true
            },
            "getAllByCondition3":{
                method:"POST",
                params:{
                    path:"getAllByCondition3"
                },
                isArray:true
            },
            "getAllByCondition4":{
                method:"GET",
                params:{
                    path:"getAllByCondition4"
                }
            },
            "del":{
                method:"DELETE"
            },
            "changeStatue":{
                method:"GET",
                params:{
                    path:"changeStatue"
                }
            },
            "get":{
                method:"GET"
            },
            "save":{
                method:"PUT"
            }
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('platformApp')
        .controller('TextController', TextController);

    TextController.$inject = ['$state', '$scope', 'ProductXml', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams', 'MessageService', 'FontXmls', '$localStorage', 'Qinius', '$uibModal', '$timeout'];

    function TextController($state, $scope, ProductXml, ParseLinks, AlertService, paginationConstants, pagingParams, MessageService, FontXmls, $localStorage, Qinius, $uibModal, $timeout) {
        var vm = this;
        //分页信息
        vm.pageInfo = {
            page: 1,
            size: 20,
            total: 0,
        }
        //批量操作状态
        vm.batchState = false;
        vm.statusList = [
            {label: '全部', value: '', op: '='},
            {label: '未分享', value: null, op: 'isnull'},
            {label: '审核中', value: 'Created', op: '='},
            {label: '已分享', value: 'Approved', op: '='},
            {label: '已驳回', value: 'Rejected', op: '='}
        ]
        vm.selectStatus = '';
        // 批量操作选中的数量
        vm.selectCount = 0;
        //分享按钮Loading
        vm.shareLoading = false;
        //批量分享Loading
        vm.batchShareLoading = false;

        vm.loadPage = loadPage;
        vm.predicate = "lastModifiedDate";
        vm.reverse = false;
        vm.transition = transition;
        vm.clear = clear;
        vm.search = search;
        vm.loadAll = loadAll;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;
        vm.jump = jump;
        vm.account = $localStorage.user;
        $scope.domains = Qinius.getDomain();
        vm.status = status;
        loadAll();
        //单个删除
        $scope.delete = function (id) {
            MessageService.confirm({
                title: '提示',
                cancel: '取消',
                confirm: '确认',
                msg: '确定要删除该数据？'
            }, function () {
                FontXmls.delete({id: id}, function () {
                    MessageService.success("删除成功");
                    loadAll();
                });
            }, function () {
            });
        };
        //批量删除
        $scope.batchDelete = function () {
            var selectList = vm.textList.filter(function (item) {
                return item.selected === true;
            });
            if (selectList.length === 0) return MessageService.error("至少选择一条数据");
            MessageService.confirm({
                title: '提示',
                cancel: '取消',
                confirm: '确认',
                msg: '确定要删除选中的数据？'
            }, function () {
                var ids = selectList.map(function (item) {
                    return item.id;
                })
                FontXmls.batchDelete(ids, function () {
                    MessageService.success("删除成功");
                    vm.loadAll();
                }, function () {
                    MessageService.error("操作失败，请重试");
                })
            })
        }
        //分页变更
        vm.currentChange = function () {
            $timeout(function () {
                vm.loadAll();
            })
        }

        function loadAll() {
            if (!vm.account) {
                return $state.go('home');
            }
            var items = [];
            var status = vm.statusList.find(function (item) {
                return item.value === vm.selectStatus;
            })
            if (status.value !== "") {
                items.push({key: 'status', value: status.value, op: status.op})
            }
            if (vm.searchQuery) {
                items.push({key: "name", value: vm.searchQuery, op: "like"});
            }
            FontXmls.byCondition({
                items: items,
                page: vm.pageInfo.page - 1,
                size: vm.pageInfo.size,
                sort: ["lastModifiedDate,desc"]
            }, onSuccess, onError);

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.pageInfo.total = headers('X-Total-Count');
                vm.textList = data;
                //退出批量操作状态
                vm.batchState = false;
                vm.selectCount = 0;
            }

            function onError(error) {
                MessageService.error("文字模板获取失败");
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search() {
            if(event.keyCode === 13){
                vm.links = null;
                vm.pageInfo.page = 1;
                vm.loadAll();
            }
        }

        function clear() {
            vm.links = null;
            vm.page = 1;
            vm.currentSearch = null;
            vm.transition();
        }

        function jump() {
            vm.page = vm.jumpText <= 0 ? 1 : vm.jumpText;
            loadPage(vm.page);
        }

        //发布
        $scope.release = function (data) {
            FontXmls.get({id: data.id}, function (res) {
                $uibModal.open({
                    templateUrl: 'app/entities/text/modal/text-detection.html',
                    controller: 'TextDetectionController',
                    controllerAs: 'vm',
                    size: 'lg',
                    resolve: {
                        entity: [function () {
                            return {
                                textDocument: res.textDocument,
                                id: res.id,
                                storeIds: [],
                            };
                        }]
                    }
                }).result.then(function (isReturn) {
                })
            })


            // FontXmls.onlyRelease({id: data.id}, function (res) {
            //     MessageService.success("发布成功");
            //     loadAll();
            // }, function (error) {
            //     MessageService.error("发布失败，请稍后重试！");
            // })
        }
        //状态点击
        $scope.statusCheck = function (e) {
            if (e === vm.selectStatus) return;
            vm.selectStatus = e;
            vm.pageInfo.page = 1;
            vm.loadAll();
        }
        //批量操作选择
        $scope.checkItem = function (item) {
            if (!vm.batchState) {
                return
            }
            if (item.selected) {
                item.selected = false;
            } else {
                item.selected = true;
            }
            //获取选中的数量
            var selectList = vm.textList.filter(function (item) {
                return item.selected === true;
            })
            vm.selectCount = selectList.length;
        }
        //单个分享
        $scope.share = function (data) {
            if (vm.shareLoading) return;
            vm.shareLoading = true;
            FontXmls.share({id: data.id}, function (res) {
                vm.shareLoading = false;
                MessageService.success("分享成功");
                loadAll();
            }, function () {
                vm.shareLoading = false;
                MessageService.error("请求失败，请重试");
            })
        }
        //批量分享
        $scope.batchShare = function () {
            if (vm.batchShareLoading) return;
            var selectList = vm.textList.filter(function (item) {
                return item.selected === true;
            });
            if (selectList.length === 0) return MessageService.error("至少选择一条数据");
            selectList = selectList.filter(function (item) {
                return !item.status || item.status == 'Rejected';
            });
            var ids = selectList.map(function (item) {
                return item.id;
            });
            vm.batchShareLoading = true;
            if (ids.length > 0) {
                FontXmls.batchShare(ids, function () {
                    MessageService.success("分享成功");
                    vm.batchShareLoading = false;
                    vm.loadAll();
                }, function () {
                    vm.batchShareLoading = false;
                    MessageService.error("操作失败，请重试");
                })
            } else {
                vm.batchShareLoading = false;
                vm.loadAll();
            }

        }
        $scope.delete = function (data) {
            MessageService.confirm({
                title: '提示',
                cancel: '取消',
                confirm: '确认',
                msg: '确定要删除该数据？'
            }, function () {
                FontXmls.delete({id: data.id}, function (res) {
                    MessageService.success("删除成功");
                    loadAll();
                })
            }, function () {
            });
        }
        //查看
        $scope.look = function (data) {
            $uibModal.open({
                templateUrl: 'app/entities/text/modal/text-xml-look.html',
                controller: 'TextXmlLookController',
                controllerAs: 'vm',
                backdrop: 'static',
                resolve: {
                    entity: [function () {
                        return {
                            url: data.cover,
                            domain: $scope.domains.domain
                        };
                    }]
                }
            });
        }
        //新增
        $scope.add = function () {
            $uibModal.open({
                templateUrl: 'app/entities/text/modal/text-add.html',
                controller: 'TextAddController',
                controllerAs: 'vm',
                backdrop: 'static',
                size:'lg',
                resolve: {
                    entity: [function () {
                        return {};
                    }]
                }
            });
        }

        $scope.copy = function(item){
            FontXmls.get({id: item.id}, function (res) {
                res.id = "";
                res.opened = false;
                res.status = null;
                FontXmls.save(res, function (res) {
                    MessageService.success("复制成功");
                    vm.loadAll();
                })
            })
        }
        //查看驳回原因
        $scope.showReason = function (item) {
            MessageService.confirm({
                title:'驳回理由',
                hideCancel:true,
                confirm:'知道了',
                msg:'理由： '+ (item.rejectReason || '')
            },function(){

            })
        }

        function status(item) {
            switch (item) {
                case 'Created':
                    return '已分享';
                    break;
                case 'Approved':
                    return '已通过';
                    break;
                case 'Rejected':
                    return '已拒绝';
                    break;
                default:
                    return '未分享'
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('platformApp')
        .controller('TextXmlOutController', TextXmlOutController);

    TextXmlOutController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', '$state', 'MessageService'];

    function TextXmlOutController ($timeout, $scope, $stateParams, $uibModalInstance, entity, $state, MessageService) {
        var vm = this;
        vm.cancel = cancel;
        vm.save = save;

        function save() {
            $uibModalInstance.close(true);
        }
        function cancel() {
            $uibModalInstance.close(false);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('platformApp')
        .controller('TextDetectionController', TextDetectionController);

    TextDetectionController.$inject = ['$timeout', '$scope', 'GetSetDpi', '$stateParams', '$uibModalInstance', 'entity', '$state', '$q', 'MessageService', 'Qinius',
     '$http', 'Catalog', '$uibModal','FontXmls', 'FontManagement'];

    function TextDetectionController ($timeout, $scope, GetSetDpi, $stateParams, $uibModalInstance, entity, $state, $q, MessageService, Qinius,
        $http, Catalog, $uibModal, FontXmls, FontManagement) {
        var vm = this;
        vm.loading=true;
        vm.platform2User = JSON.parse(localStorage.getItem('platform2-user'));
        vm.saveData = entity;
        vm.source = vm.saveData.source;
        vm.textDocument = vm.saveData.textDocument;
        vm.gitDpi = GetSetDpi.getCurrent();
        vm.backup = false;
        vm.data=[];
        vm.tapIndex = 1;
        vm.checkAll = false;
        $q.all([vm.gitDpi.$promise, vm.textDocument.$promise]).then(function () {
            vm.thirdPartySettings = vm.platform2User.thirdPartySettings || [];
            console.log(vm.thirdPartySettings,"ssss")
            vm.gitDpi = vm.gitDpi.message;
            vm.pages=[];
            vm.backupPages=[];
            pageDetection(vm.textDocument);
            $timeout(function () {
                pageInit();
            },1000)
        })

        $scope.backupFn = function (item) {
            vm.backup = item;
            pageInit();
        }
        function verifyTextfont(textbox, failCallback) {
            if (!textbox) {
                return;
            }
            textbox.characterWarning = false;
            textbox.characterMessage = "";
            FontManagement.fontSupport({
                uuid: textbox.fontuuid,
                bold: textbox.style.bold,
                italic: textbox.style.italic,
                content: textbox.text
            }, function (res) {
                var msg = res.message;
                if (res.status == 200) {
                    if (msg.success && !msg.supported) {
                        var message = "【" + msg.failed + "】" + "当前字体不支持这些文字！";
                        if (failCallback) {
                            failCallback(message);
                        }
                    }
                }
            })
        }
        function pageDetection(page){
            page.dpiResult = [];
            page.fontResult = [];
            if(page.levels && page.levels.level && page.levels.level.length>0){
                page.levels.level.forEach(function (level, i) {
                    var index = i+1;
                    if(level.imagebox && level.imagebox.image && level.imagebox.image.resource && level.imagebox.image.resource.identifier){
                        if(level.imagebox.image.resource.width && level.imagebox.image.resource.height){
                            var _data = pxInsufficient(level.imagebox.image.resource.width, level.imagebox.image.resource.height, level.imagebox.image.scale, level.imagebox.geometry.width, level.imagebox.geometry.height);
                            if(_data < vm.gitDpi.imgDpi - 0.01){
                                page.dpiResult.push({
                                    type: 'imagebox',
                                    img: level.imagebox.image.resource.identifier,
                                    dpi: _data,
                                    expectDpi: vm.gitDpi.imgDpi,
                                    name: '图片' + index
                                })
                            }
                        }else{
                            imageInfo($http, level.imagebox.image.resource, function () {
                                var _data = pxInsufficient(level.imagebox.image.resource.width, level.imagebox.image.resource.height, level.imagebox.image.scale, level.imagebox.geometry.width, level.imagebox.geometry.height);
                                if(_data < vm.gitDpi.imgDpi - 0.01){
                                    page.dpiResult.push({
                                        type: 'imagebox',
                                        img: level.imagebox.image.resource.identifier,
                                        dpi: _data,
                                        expectDpi: vm.gitDpi.imgDpi,
                                        name: '图片' + index
                                    })
                                }
                            })
                        }
                    }
                    if(level.imagebox && level.imagebox.mask && level.imagebox.mask.resource && level.imagebox.mask.resource.identifier){
                        if(level.imagebox.mask.resource.width && level.imagebox.mask.resource.height){
                            var _data = pxInsufficient(level.imagebox.mask.resource.width, level.imagebox.mask.resource.height, level.imagebox.mask.scale, level.imagebox.geometry.width, level.imagebox.geometry.height);
                            if(_data < vm.gitDpi.maskDpi - 0.01){
                                page.dpiResult.push({
                                    type: 'imageboxMask',
                                    img: level.imagebox.mask.resource.identifier,
                                    dpi: _data,
                                    expectDpi: vm.gitDpi.maskDpi,
                                    name: '相框' + index
                                })
                            }
                        }else{
                            imageInfo($http, level.imagebox.mask.resource, function () {
                                var _data = pxInsufficient(level.imagebox.mask.resource.width, level.imagebox.mask.resource.height, level.imagebox.mask.scale, level.imagebox.geometry.width, level.imagebox.geometry.height);
                                if(_data < vm.gitDpi.maskDpi - 0.01){
                                    page.dpiResult.push({
                                        type: 'imageboxMask',
                                        img: level.imagebox.mask.resource.identifier,
                                        dpi: _data,
                                        expectDpi: vm.gitDpi.maskDpi,
                                        name: '相框' + index
                                    })
                                }
                            })
                        }
                    }
                    if(level.imageart && level.imageart.resource && level.imageart.resource.identifier){
                        if(level.imageart.resource.width && level.imageart.resource.height){
                            var _data = pxInsufficient(level.imageart.resource.width, level.imageart.resource.height, level.imageart.scale, level.imageart.geometry.width, level.imageart.geometry.height);
                            if(_data < vm.gitDpi.clipArtDpi - 0.01){
                                page.dpiResult.push({
                                    type: 'imageart',
                                    img: level.imageart.resource.identifier,
                                    dpi: _data,
                                    expectDpi: vm.gitDpi.clipArtDpi,
                                    name: '素材' + index
                                })
                            }
                        }else{
                            imageInfo($http, level.imageart.resource, function () {
                                var _data = pxInsufficient(level.imageart.resource.width, level.imageart.resource.height, level.imageart.scale, level.imageart.geometry.width, level.imageart.geometry.height);
                                if(_data < vm.gitDpi.clipArtDpi - 0.01){
                                    page.dpiResult.push({
                                        type: 'imageart',
                                        img: level.imageart.resource.identifier,
                                        dpi: _data,
                                        expectDpi: vm.gitDpi.clipArtDpi,
                                        name: '素材' + index
                                    })
                                }
                            })
                        }
                    }
                    if (level.textbox && level.textbox.text && level.textbox.fontuuid) {
                        verifyTextfont(level.textbox, function (message) {
                            page.fontResult.push({
                                type: 'textbox',
                                message: message,
                                name: '文字' + index
                            })
                        });

                    }
                })
            }
        }


        function pageInit(){
            vm.disqualification = false;
            if(vm.textDocument.dpiResult && vm.textDocument.dpiResult.length>0){
                vm.disqualification = true;
            }
            if (vm.textDocument.fontResult && vm.textDocument.fontResult.length > 0) {
                vm.disqualification = true;
            }
            console.log(typeof vm.textDocument.fontResult,vm.textDocument.fontResult);
            vm.loading=false;
        }

        vm.checkAllFn = function(){
            vm.checkAll = !vm.checkAll;
            vm.thirdPartySettings.forEach(function (item) {
                item.selected = vm.checkAll;
            })
        };
        vm.checkFn = function(item){
            item.selected = !item.selected;
            vm.checkAll = true;
            vm.thirdPartySettings.forEach(function (item) {
                if(!item.selected){
                    vm.checkAll = false;
                }
            })
        };
        //返回
        vm.cancel = function() {
            $uibModalInstance.close(false);
        };
        function checkPageFonts() {
            if (vm.pages.length > 0) {
                for (var i = 0; i < vm.pages.length; i++) {
                    var page = vm.pages[i];
                    if (page.fontResult && page.fontResult.length > 0) {
                        if (!page.backup) {
                            MessageService.error("检测到页面文字中包含字体不支持的字符！");
                        } else {
                            MessageService.error("检测到备用页面文字中包含字体不支持的字符！");
                        }
                        return false;
                    }
                }
            }

            return true;
        }
        $scope.save1 = function(){
            if (!checkPageFonts()) {
                // 文字检查不通过
                return;
            }
            if(vm.thirdPartySettings.length>1){
                vm.tapIndex = 2;
            }else{
                vm.thirdPartySettings.forEach(function (item) {
                    item.selected = true;
                })
                save()
            }
        };
        $scope.cancel2 = function(){
            vm.tapIndex = 1;
        };
        $scope.save2 = function () {
            save()
        };
        $scope.save3 = function () {
            $uibModalInstance.close(true);
        }

        function save() {
            vm.storeIds = [];
            vm.thirdPartySettings.forEach(function (item) {
                if(item.selected){
                    vm.storeIds.push(item.id);
                }
            })
            if(vm.storeIds.length == 0){
                MessageService.error("请选择发布的渠道");
                return
            }
            vm.tapIndex = 3;
            vm.saveData.storeIds = vm.storeIds.toString();
                vm.saveLoading = true;
                FontXmls.onlyRelease(
                    {
                        id: vm.saveData.id,
                        storeIds: vm.saveData.storeIds,
                    }, function (res) {
                    vm.releaseData = res;
                    vm.saveLoading = false;
                }, function () {
                    MessageService.error("发布失败");
                    vm.saveLoading = false;
                });

            // if(vm.source == 'editor'){
            //     vm.saveData.storeIds = vm.storeIds;
            //     vm.saveLoading = true;
            //     ProductXml.release(vm.saveData, function (res) {
            //         vm.releaseData = res;
            //         vm.saveLoading = false;
            //     }, function () {
            //         MessageService.error("发布失败");
            //         vm.saveLoading = false;
            //     });
            // }
            // if(vm.source == 'list'){
            //     vm.saveData.storeIds = vm.storeIds.toString();
            //     vm.saveLoading = true;
            //     ProductXml.onlyRelease(
            //         {
            //             id: vm.saveData.id,
            //             storeIds: vm.saveData.storeIds,
            //             type: vm.saveData.type,
            //         }, function (res) {
            //         vm.releaseData = res;
            //         vm.saveLoading = false;
            //     }, function () {
            //         MessageService.error("发布失败");
            //         vm.saveLoading = false;
            //     });
            // }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('platformApp')
        .controller('TextXmlLookController', TextXmlLookController);

    TextXmlLookController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', '$state', 'MessageService'];

    function TextXmlLookController ($timeout, $scope, $stateParams, $uibModalInstance, entity, $state, MessageService) {
        var vm = this;
        vm.cancel = cancel;
        vm.url = entity.url;
        vm.domain = entity.domain;

        //返回
        function cancel() {
            $uibModalInstance.close();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('platformApp')
        .controller('TextAddController', TextAddController);

    TextAddController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', '$state', 'MessageService'];

    function TextAddController ($timeout, $scope, $stateParams, $uibModalInstance, entity, $state, MessageService) {
        var vm = this;
        vm.save = save;
        vm.cancel = cancel;
        vm.units = [
            { name: 'px', id: 'px'},
            { name: 'mm', id: 'mm'}
        ];
        vm.data = {
            name: '',
            width: '',
            height: '',
            unit: 'mm'
        }
        //返回
        function cancel() {
            $uibModalInstance.close();
        }
        
        function save() {
            var reg = /^\d+(?=\.{0,1}\d+$|$)/
            if(!vm.data.name){
                MessageService.error("文字模板名称不能为空");
                return
            }
            if(isNaN(vm.data.width) || Number(vm.data.width) < 1){
                MessageService.error("宽度必须输入正数");
                return
            }
            if(isNaN(vm.data.height) || Number(vm.data.height) < 1){
                MessageService.error("高度必须输入正数");
                return
            }
            localStorage.setItem("textPage",JSON.stringify(vm.data));
            $state.go('text-xml');
            $uibModalInstance.close();
        }

        //单位换算
        $scope.unitCb = function(){
            console.log(vm.data.unit)
            if(vm.data.unit == 'mm'){
                vm.data.width = (vm.data.width/vm.windowDpiW*25.4).toFixed(0);
                vm.data.height = (vm.data.height/vm.windowDpiH*25.4).toFixed(0);
            }
            if (vm.data.unit == 'px'){
                vm.data.width = (vm.data.width/25.4 * vm.windowDpiW).toFixed(2);
                vm.data.height = (vm.data.height/25.4 * vm.windowDpiH).toFixed(2);
            }
        }

        //获取dpi
        js_getDPI()
        function js_getDPI() {
            var arrDPI = new Array();
            if (window.screen.deviceXDPI != undefined) {
                arrDPI[0] = window.screen.deviceXDPI;
                arrDPI[1] = window.screen.deviceYDPI;
            }
            else {
                var tmpNode = document.createElement("DIV");
                tmpNode.style.cssText = "width:1in;height:1in;position:absolute;left:0px;top:0px;z-index:99;visibility:hidden";
                document.body.appendChild(tmpNode);
                arrDPI[0] = parseInt(tmpNode.offsetWidth);
                arrDPI[1] = parseInt(tmpNode.offsetHeight);
                tmpNode.parentNode.removeChild(tmpNode);
            }
            vm.windowDpiW = arrDPI[0];
            vm.windowDpiH = arrDPI[1];
            return arrDPI;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('platformApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('product-xml-purchase', {
            parent: 'app',
            url: '/product-xml-purchase?page&sort&search',
            data: {
                authorities: [],
                pageTitle: 'platformAppTitle.product-xml-purchase'
            },
            views: {
                'content': {
                    templateUrl: 'app/entities/product-xml-purchase/product-xml-purchase.html',
                    controller: 'ProductXmlPurchases',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('productXmlPurchase');
                    $translatePartialLoader.addPart('global');
                    $translatePartialLoader.addPart('title');
                    return $translate.refresh();
                }]
            }
        })
         ;
    }

})();

(function() {
    'use strict';

    angular
        .module('platformApp')
        .controller('ProductXmlPurchases', ProductXmlPurchases);

    ProductXmlPurchases.$inject = ['$scope', '$state', 'ProductXmlPurchase', 'ParseLinks', 'AlertService', 'paginationConstants',
     'pagingParams', 'MessageService', '$timeout'];

    function ProductXmlPurchases ($scope, $state, ProductXmlPurchase, ParseLinks, AlertService, paginationConstants,
     pagingParams, MessageService, $timeout) {
        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.clear = clear;
        vm.search = search;
        vm.loadAll = loadAll;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;
        vm.jump = jump;
        vm.exitSure = false;

        loadAll();

        function loadAll () {
            if (pagingParams.search) {
                ProductXmlPurchase.byCondition2({
                    items: [{key: "number,productXml.name", op: "like", value: pagingParams.search},{key: "paid", op: "=", value: "true"}],
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                ProductXmlPurchase.byCondition2({
                    items: [{key: "paid", op: "=", value: "true"}],
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'desc' : 'asc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.productXmlPurchases = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
            focus("search");
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'desc' : 'asc'),
                search: vm.currentSearch
            });
        }

        function focus(element) {
            var elementId = element;
            $timeout(function (){
                var element = document.getElementById(elementId);
                if (element) {
                    element.focus();
                }
            }, 100);
        }

        function search(searchQuery) {
            if(event.keyCode === 13){
                if (!searchQuery){
                    return vm.clear();
                }
                vm.links = null;
                vm.page = 1;
                vm.predicate = 'id';
                vm.reverse = false;
                vm.currentSearch = searchQuery;
                vm.transition();
            }

        }

        function clear() {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }

        function jump () {
            vm.page = vm.jumpText<=0?1:vm.jumpText;
            loadPage(vm.page);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('platformApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('product-xml', {
            parent: 'app',
            url: '/product-xml?page&sort&search',
            data: {
                authorities: [],
                pageTitle: 'platformApp.productXml.home.title'
            },
            views: {
                'content': {
                    templateUrl: 'app/entities/product-xml/product-xmls.html',
                    controller: 'ProductXmlController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,desc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('productXml');
                    $translatePartialLoader.addPart('reprintType');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
    }

})();

(function() {
    'use strict';
    angular
        .module('platformApp')
        .factory('Verify', Verify)
        .factory('FrontUser', FrontUser)
        .factory('Notice', Notice)
        .factory('ProductXmlPurchase', ProductXmlPurchase)
        .factory('PaymentSettings', PaymentSettings)
        .factory('ThirdPartySetting', ThirdPartySetting)
        .factory('ProductXml', ProductXml);

    ProductXml.$inject = ['$resource'];

    ThirdPartySetting.$inject = ['$resource'];

    Verify.$inject = ['$resource'];

    Notice.$inject = ['$resource'];
    FrontUser.$inject = ['$resource'];
    ProductXmlPurchase.$inject = ['$resource'];
    PaymentSettings.$inject = ['$resource'];

    function Notice($resource) {
        var resourceUrl = 'bunny/' + 'api/notices/:path/:id';
        return $resource(resourceUrl, {}, {
            "byCondition1":{
                method: 'POST',
                params:{
                    path:"byCondition1"
                },
            },
            "getAllByCondition1": {
                method: 'POST',
                params: {
                    path: "getAllByCondition1"
                },
            },
            "readAll": {
                method: 'GET',
                params: {
                    path: "readAll"
                }
            },
            "read": {
                method: 'GET',
                params: {
                    path: "read"
                }
            },
        });
    }


    function ProductXmlPurchase($resource) {
        var resourceUrl = 'bunny/' + 'api/product-xml-purchases/:path/:id';

        return $resource(resourceUrl, {}, {
            "create": {
                method: 'POST',
                params: {
                    path: "create"
                }
            },
            "byCondition": {
                method: 'POST',
                params: {
                    path: "byCondition"
                },
                isArray:true
            },
            "byCondition2":{
                method:"POST",
                params:{
                    path:"byCondition2"
                },
                isArray:true
            },
            "getAllByCondition": {
                method: 'POST',
                params: {
                    path: "getAllByCondition"
                },
                isArray:true
            },
            "createQRCode": {
                method: 'POST',
                params: {
                    path: "createQRCode"
                }
            },
            "aliPay": {
                method: 'GET',
                params: {
                    path: "aliPay"
                }
            },
            "alipayNotify": {
                method: 'POST',
                params: {
                    path: "alipayNotify"
                }
            },
            "weChatNotify": {
                method: 'POST',
                params: {
                    path: "weChatNotify"
                }
            }
        });
    }

    function PaymentSettings($resource) {
        var resourceUrl = 'bunny/' + 'api/payment-settings/:path/:id';
        return $resource(resourceUrl, {}, {
            "get": {
                method: 'GET',
                isArray: true
            }
        });
    }


    function FrontUser($resource) {
        var resourceUrl = 'bunny/' + 'api/front-users/:path/:id';

        return $resource(resourceUrl, {}, {
            "registerByThird": {
                method: 'POST',
                params: {
                    path: "registerByThird"
                }
            },
            "bindByThird": {
                method: 'GET',
                params: {
                    path: "bindByThird"
                }
            },
            "authByThird": {
                method: 'GET',
                params: {
                    path: "authByThird"
                }
            },
            "checkPassword": {
                method: 'GET',
                params: {
                    path: "checkPassword"
                }
            },
            "changePassword": {
                method: 'POST',
                params: {
                    path: "changePassword"
                }
            },
            "forgetPassword": {
                method: 'POST',
                params: {
                    path: "forgetPassword"
                }
            },
            "checkUser": {
                method: 'POST',
                params: {
                    path: "checkUser"
                },
                isArray:true
            },
            "resetPassword": {
                method: 'GET',
                params: {
                    path: "resetPassword"
                }
            },
            "upgrade":{//确认升级
                method: 'GET',
                params: {
                    path: "upgrade"
                }
            },
            "original":{//同意远程协议声明
                method: 'GET',
                params: {
                    path: "original"
                }
            }
        });
    }

    function ThirdPartySetting($resource) {
        var resourceUrl = 'bunny/' + 'api/third-party-settings/:path/:id';

        return $resource(resourceUrl, {}, {
            "getByKey": {
                method: 'GET',
                params: {
                    path: "getByKey"
                }
            }

        });
    }

    function Verify($resource) {
        var resourceUrl = 'bunny/' + 'api/verify-code/:path';

        return $resource(resourceUrl, {}, {
            "checkVerifyCode": {
                method: 'GET',
                params: {
                    path: "checkVerifyCode"
                }
            },
            "getVerifyCode": {
                method: 'GET',
                params: {
                    path: "getVerifyCode"
                }
            }
        });
    }

    function ProductXml($resource) {
        var resourceUrl = 'bunny/' + 'api/product-xmls/:path/:id';

        return $resource(resourceUrl, {}, {
            "batchDelete": {
                method:"POST",
                params:{
                    path:"batchDelete"
                }
            },
            "upgradeProductXml": {
                method:"POST",
                params:{
                    path:"upgradeProductXml"
                }
            },
            "documentToImg": {
                method:"POST",
                params:{
                    path:"documentToImg"
                },
                isArray:true
            },
            "byCondition":{
                method:"POST",
                params:{
                    path:"byCondition"
                },
                isArray:true
            },
            "getAll": {
                method: "POST",
                params: {
                    path: "getAllByCondition"
                },
                isArray: true
            },
            'getXml': {
                method: 'GET'
            },
            "getAll2": {
                method: "POST",
                params: {
                    path: "getAllByCondition2"
                },
                isArray: true
            },
            "updateSizeInfo": {
                method: "GET",
                params: {
                    path: "updateSizeInfo"
                }
            },
            "byCondition2":{
                method:"POST",
                params:{
                    path:"byCondition2"
                },
                isArray:true
            },
            "release": {
                method: "POST",
                params: {
                    path: "release"
                }
            },
             "updateImageArt": {
                method: "GET",
                params: {
                    path: "updateImageArt"
                }
            },
            "updateHashtags": {
                method: "GET",
                params: {
                    path: "updateHashtags"
                }
            },
            'query': {
                method: 'GET',
                isArray: true
            },
            'get': {
                method: 'GET',
                transformResponse: function(data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': {
                method: 'PUT'
            },
            'getDocumentByKey':{
                method: "GET",
                params: {
                    path: "uploadDocumentByKey"
                }
            },
            'thirdXmlSave': {
                method: "POST",
                params: {
                    path: "thirdXmlSave"
                },
            },

            'getThirdData': {
                method: "GET",
                params: {
                    path: "getThirdData"
                },
            },
            'onlyRelease': {
                method: "GET",
                params: {
                    path: "onlyRelease"
                },
            },
            'share': {
                method: "GET",
                params: {
                    path: "share"
                },
            },
            'checkAndFixDocument': {
                method: "GET",
                params: {
                    path: 'checkAndFixDocument'
                }
            },
            'rename': {
                method: 'POST',
                params: {
                    path: 'rename'
                }
            },
            "setPrice":{
                method: "GET",
                params: {
                    path: "setPrice"
                }
            },
            "auditing": {
                method: "GET",
                params: {
                    path: "auditing"
                }
            },
            "hotspot": {
                method: "GET",
                params: {
                    path: "hotspot"
                }
            },
            'getPurchasedList':{
                method: 'GET',
                params:{
                    path:'purchasedList',
                },
                isArray: true
            },
            'delete': { method:'DELETE' },
            'cancelShare': {
                method: "GET",
                params: {
                    path: "cancelShare"
                }
            },
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('platformApp')
        .controller('ProductXmlController', ProductXmlController);

    ProductXmlController.$inject = ['$state', '$scope', 'ProductXml', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams', 'MessageService'];

    function ProductXmlController($state, $scope, ProductXml, ParseLinks, AlertService, paginationConstants, pagingParams, MessageService) {

        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        $(".navbar").show();
        $(".wrap").css({margin: '48px 0 10px 254px'});

        loadAll();

        $scope.delete = function (id) {
            MessageService.confirm({
                title:'提示',
                cancel:'取消',
                confirm:'确认',
                msg:'确认要删除该模板文件么？'
            },function(){
                ProductXml.delete({id: id}, function () {
                    loadAll();
                });
            }, function () {
            });
        };

        function loadAll () {
            if (pagingParams.search) {
                ProductXml.byCondition({
                    items: [{key: "name", op: "like", value: pagingParams.search}],
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                ProductXml.byCondition({
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.productXmls = data;
                vm.page = pagingParams.page;
                console.log(data);
            }
            function onError(error) {
                MessageService.error("数据加载失败");
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('platformApp')
        .controller('PictureXmlController', PictureXmlController);

    PictureXmlController.$inject = ['$state', '$scope', 'UidService', 'ProductXml', 'ParseLinks', 'AlertService', 'MessageService', '$uibModal', 'FontManagement', 'Qinius', '$q', '$timeout', 'PicLayoutXmls', 'ClipArts', 'Backgrounds', 'ThemeClassify', 'SourceMaterial', 'entity', 'ImageService'];

    function PictureXmlController($state, $scope, UidService, ProductXml, ParseLinks, AlertService, MessageService, $uibModal, FontManagement, Qinius, $q, $timeout, PicLayoutXmls, ClipArts, Backgrounds, ThemeClassify, SourceMaterial, entity, ImageService) {
        var vm = this;
        // vm.moreDisplay = false;
        // vm.moreIcon = false;
        // $(window).resize(function(){
        //     if ($('.c-xml-action').outerWidth() <= 800) {
        //         vm.moreIcon = true;
        //     }else{
        //         vm.moreIcon = false;
        //         vm.moreDisplay = false;
        //     }
        // })
        //是否是拖曳画布状态
        vm.moveCanvasView = false;
        vm.moveCanvasInfo = {
            x:0,
            y:0
        }
        //初始化画布移动信息
        vm.initMoveCanvasInfo = function(){
            vm.moveCanvasInfo = {
                x:0,
                y:0
            }
        }
        if(entity){
            vm.data = entity;
        }else{
            vm.picturePage = JSON.parse(localStorage.picturePage);
            vm.data = {
                name: vm.picturePage.width + '×' + vm.picturePage.height + 'MM',
                cover: '',
                identifier: '',
                opened: false,
                quantity: '',
                catalogId: vm.picturePage.catalogId,
                catalogName: vm.picturePage.catalogName,
                document: {
                    movable: true,
                    mediabox: {
                        x: '0',
                        y: '0',
                        width: vm.picturePage.width,
                        height: vm.picturePage.height
                    },
                    levels: {
                        level: []
                    }
                }
            }
        }
        $scope.domains = Qinius.getDomain();
        vm.navList = [
            {img:'/content/images/icons/nav_photo.svg', name: '相框', id:'imagebox'}
        ]
        vm.navPitch = 'imagebox';
        vm.units = [
            { name: 'px', id: 'px'},
            { name: 'mm', id: 'mm'}
        ];
        vm.unit = "px";
        vm.xmlSelect = {
            type: '',
            index:''
        };
        vm.cookies = [];
        vm.isUnfold = false;
        vm.isUnfoldRight = false;
        vm.isXmlDblclick = false;
        vm.photoTab='oneself';
        vm.mask = [];
        vm.recommendImg = [];
        $scope.masklabels = [
            {id:'', name:'全部'}
        ]
        $scope.$watch(function() {
            return vm.data.name;
        }, function(newName, oldName) {
            if (newName!==undefined) {
                document.title = newName + '-设计页'
            }
        });
        $q.all([$scope.domains.$promise, vm.data.$promise]).then(function () {
            vm.url = $scope.domains.domain;
            //获取token
            Qinius.get(function (msg) {
                vm.token = msg.token;
            });
            init();
            //作品宽高
            initWindow()
            vm.dataInit = angular.copy(vm.data);

            //分类
            ThemeClassify.getAllByCondition({
                items:[{key: "type", op: "=", value: 'MASK'},{key: "cancelled", op: "=", value: false},{key: "used", op: "=", value: true}],
                sort: ["id,desc"]
            }, function (res) {
                res.forEach(function (item) {
                    if(!item.cancelled){
                        $scope.masklabels.push(item)
                    }
                })
                vm.masklabelChooseId = $scope.masklabels[0].id;
                vm.bgImgIndex = 0;
                clickMaskLabels();
            });
        })

        function init(){
            vm.data.document.mediabox.width = transitionPx(vm.data.document.mediabox.width).toFixed(2);
            vm.data.document.mediabox.height = transitionPx(vm.data.document.mediabox.height).toFixed(2);
            if (vm.data.document.levels.level == null) {
                vm.data.document.levels.level = [];
            }
            angular.forEach(vm.data.document.levels.level, function (level, index) {
                if(level.imagebox){
                    level.imagebox.rotation.angle = -level.imagebox.rotation.angle;
                    level.imagebox.geometry = {
                        width: transitionPx(level.imagebox.geometry.width),
                        height: transitionPx(level.imagebox.geometry.height),
                        x: transitionPx(level.imagebox.geometry.x),
                        y: transitionPx(level.imagebox.geometry.y)
                    };
                    maskScale(vm.data.document.levels.level[index].imagebox, index, level.imagebox.mask.resource.identifier)
                }
            });
            vm.attribute = {
                product: {
                    width: vm.data.document.mediabox.width,
                    height:vm.data.document.mediabox.height,
                }
            }
        }
        //相框
        vm.bgImgList = [];
        vm.bgImgSum = 10;
        vm.bgImgIndex = 0;
        vm.isBgImgData = false;

        $scope.selectMaskLabel = function (item) {
            vm.masklabelChooseId = item.id;
            vm.bgImgIndex = 0;
            vm.mask=[];
            clickMaskLabels();
        }
        function clickMaskLabels() {
            var items = [];
            if(vm.masklabelChooseId){
                items.push({key: "themeClassify.id", op: "=", value: vm.masklabelChooseId})
            }else{
                // items.push({key: "type", op: "=", value: 'User'})
            }
            SourceMaterial.byCondition({
                items: items,
                page: vm.bgImgIndex,
                size: vm.bgImgSum,
                sort: ["id,desc"]
            }, function (resp, headers) {
                vm.totalMaskItems = headers('X-Total-Count');
                angular.forEach(resp, function (data,i) {
                    var arr = {
                        resource: {
                            identifier: vm.url + data.identifier,
                            provider: data.provider,
                        },
                        type: data.type,
                        id: data.id,
                        isRecommend: false,
                        identifier: vm.url + data.identifier,
                        provider: 'qiniu',
                        bgImg: '',
                    }
                    vm.mask.push(arr);
                })
                if(resp.length < vm.bgImgSum){
                    vm.isBgImgData = true;
                }else{
                    vm.isBgImgData = false;
                }
            })
        }
        $scope.bgImgPageing = function(){
            vm.bgImgIndex++;
            clickMaskLabels()
        }
        $scope.recommendCb = function($event, item){
            vm.recommendImg = [];
            item.isRecommend = !item.isRecommend;
            vm.mask.forEach(function (data) {
                if(data.isRecommend){
                    vm.recommendImg.push(data);
                }
            })
            fn($event)
        }

        $scope.navCb = function (data) {
            vm.navPitch = data;
            // if(vm.navPitch == data.id){
            //     vm.isUnfold = !vm.isUnfold;
            //     // vm.isUnfoldRight = !vm.isUnfoldRight;
            // }else {
            //     vm.navPitch = data.id;
            //     vm.isUnfold = false;
            //     // vm.isUnfoldRight = false;
            // }
        };

        $scope.unfoldLeft = function(){
            vm.isUnfold = !vm.isUnfold;
        }
        $scope.unfoldRight = function(){
            vm.isUnfoldRight = !vm.isUnfoldRight;
        }
        $scope.photoTabClick = function(item){
            vm.photoTab=item;
        }
        $scope.aa = function(){
            console.log('fdslkjahfjkshda')
        }
        // 相框的上传
        window.updatePic = function (e) {
            console.log('fdslkjahfjkshda')
            var files = e.target.files;
            getBgImg(files, 0);
        };
        function getBgImg(file, i) {
            var formData = new FormData();
            formData.append('file', file[i]);
            formData.append('unique_names', false);
            formData.append('key', 'mask-' + UidService.get());
            formData.append('token', vm.token);
            $.ajax({
                cache: true,
                type: "POST",
                url: 'https://upload.qiniup.com/',
                data: formData,
                async: true,
                contentType: false,
                processData: false,
                success: function (data) {
                    SourceMaterial.createOne({
                        identifier: data.key,
                        provider: 'qiniu',
                        themeClassifyId: vm.masklabelChooseId,
                        opened: true,
                        type: 'User'
                    }, function (resp) {
                        resp.resource= {
                            identifier: vm.url + resp.identifier,
                            provider: 'qiniu',
                        };
                        resp.identifier= vm.url + resp.identifier;
                        vm.mask.unshift(resp);
                    });
                    $scope.$apply();
                    i++;
                    if (i < file.length) {
                        getBgImg(file, i);
                    }
                },
                error: function (error) {
                    MessageService.error("图片上传失败");
                }
            });
        }
        $scope.bgImgCb = function(item){

            var newImg = new Image();
            newImg.crossOrigin = "Anonymous";
            newImg.src = item.resource.identifier + '?imageMogr2/auto-orient/rotate';
            newImg.onload = function () {
                var _level = {
                    imagebox:{},
                    seq: vm.data.document.levels.level.length + Number(1)
                }
                var _imagebox = {
                    blurredrectangle:null,
                    bokehtype:'None',
                    transparency:1,
                    geometry:{
                        width:newImg.width,
                        height:newImg.height,
                        x:0,
                        y:0
                    },
                    image: {
                        resource: {
                            identifier: '',
                            provider: ''
                        },
                        filterResource: {
                            identifier: '',
                            provider: 'qiniu'
                        },
                        scale: 1,
                        angle: 0
                    },
                    mask: {
                        resource:{
                            identifier: item.resource.identifier,
                            provider: 'qiniu',
                        }
                    },
                    rotation:{
                        angle: 0
                    },
                    border: {
                        shape: 'Rectangle',
                        radius: {
                            lt: 0,
                            rt: 0,
                            rb: 0,
                            lb: 0,
                            all:0,
                            filletType: "Fixed"
                        },
                        "edge": {
                            top: 0,
                            right: 0,
                            bottom: 0,
                            left: 0
                        },
                        lineWidth: 0,
                        type: "Color",
                        lineType:"solid",
                        resource: {
                            "identifier": ''
                        },
                        color: '#000000',
                    },
                    shadow:{
                        color:'#777777',
                        x:0,
                        y:0,
                        blur:0
                    },
                }
                _imagebox.geometry.width= vm.data.document.mediabox.width / 2;
                _imagebox.geometry.height= _imagebox.geometry.width/newImg.width*newImg.height;
                _imagebox.geometry.x = (vm.data.document.mediabox.width - _imagebox.geometry.width) / 2;
                _imagebox.geometry.y = (vm.data.document.mediabox.height - _imagebox.geometry.height) / 2;
                _level.imagebox = _imagebox;
                vm.data.document.levels.level.push(_level);
                maskScale(vm.data.document.levels.level[vm.data.document.levels.level.length-1].imagebox, vm.data.document.levels.level.length-1, item.resource.identifier)
                $scope.$digest();
            };
        };

        $scope.canvasMiddle = function(){
            if (!$scope.selectBox) {
                MessageService.notice('请选择相框')
                return
            }
            if (vm.ctrlKey.length>1) {
                vm.data.document.levels.level.forEach(function(item){
                    if(!item.imagebox.lock && item.imagebox.selected){
                        item.imagebox.geometry.x = (vm.data.document.mediabox.width - item.imagebox.geometry.width) / 2;
                        item.imagebox.geometry.y = (vm.data.document.mediabox.height - item.imagebox.geometry.height) / 2;
                    }
                    item.imagebox.selected = false
                })
                vm.ctrlKey = []
                return
            }
            var item = null;

            if(vm.data.document.levels.level[vm.xmlSelect.index].imagebox){
                item = vm.data.document.levels.level[vm.xmlSelect.index].imagebox;
            }
            if(item && !item.lock){
                item.geometry.x = (vm.data.document.mediabox.width - item.geometry.width) / 2;
                item.geometry.y = (vm.data.document.mediabox.height - item.geometry.height) / 2;
            }
        }

        function maskScale(imageboxs, index, identifier) {
            var imagebox = angular.copy(imageboxs);
            imagebox.mask.resource.identifier = identifier;

            var imgUrl = 'content/images/camera.png';

            var imagecanvas = document.createElement('canvas');
            var imagecontext = imagecanvas.getContext('2d');
            var newImg = document.createElement('img');
            newImg.crossOrigin = "Anonymous";
            newImg.src = imgUrl;
            newImg.onload = function () {
                newImg.onload = null;
                var width = newImg.width;
                var height = newImg.height;
                var scaleW = 1, scaleH = 1;
                var masks = document.createElement('img');
                masks.src = identifier;
                masks.crossOrigin = "anonymous";
                masks.onload = function () {
                    masks.onload = null;
                    imagecanvas.width = width;
                    imagecanvas.height = height;
                    imagecontext.drawImage(masks, 0, 0, width, height);
                    imagecontext.globalCompositeOperation = 'source-in';
                    imagecontext.scale(scaleW, scaleH);
                    imagecontext.drawImage(newImg, 0, 0);
                    var pic = imagecanvas.toDataURL();
                    imageboxs.bgImg = ImageService.dataURLtoBlob(pic);
                    $scope.$digest();
                };
            };

        }


        $scope.bgImgDelete = function ($event, item, index) {
            SourceMaterial.delete({id: item.id}, function () {
                vm.mask.splice(index, 1)
            });
            fn($event)
        }
        vm.ctrlKey = []
        //相框
        $scope.imageartClick = function($event, imagebox, index){
            updateUnitImagebox(imagebox);
            if ($event.ctrlKey == true || $event.metaKey == true) {
                if (vm.xmlSelect.index !== '') {
                    vm.data.document.levels.level[vm.xmlSelect.index].imagebox.selected = !imagebox.selected;
                    vm.ctrlKey.push(vm.data.document.levels.level[vm.xmlSelect.index].imagebox)
                }
                imagebox.selected = !imagebox.selected;
                vm.xmlSelect.type = "";
                vm.xmlSelect.index = "";
                vm.ctrlKey.push(imagebox)
            }else{
                if(!vm.data.document.levels.level[index].imagebox.selected){
                    vm.ctrlKey = [];
                    vm.data.document.levels.level.forEach(function(item){
                        item.imagebox.selected = false
                    })
                }
                vm.xmlSelect.type = 'imagebox';
                vm.xmlSelect.index = index;
                $scope.selectBox = imagebox;
                fn($event)
            }
            toolbarStatus();
        }
        $scope.isAlignHover = false;
        $scope.isDistriHover = false;
        $scope.toobarAlignment = function (attr) {
            if (!$scope.selectBox) {
                MessageService.notice('请选择一个相框')
                return
            }
            toolbarStatus();
            $scope.isAlignHover = attr;
        }

        $scope.boxDistribution = function (attr) {
            var all1 = vm.ctrlKey
            var all = [];
            all1.forEach(function(box){
                if (!box.lock) {
                    all.push(box)
                }
            })
            if (all.length < 3) {
                MessageService.notice('请选择3个以上非锁定状态的元素！');
                return
            }

            // 水平分布
            if (attr == 'standard') {
                setAllCtrlKeyArray(all, 'x');
            } else {
                // 垂直分布
                setAllCtrlKeyArray(all, 'y');

            }
        }
        function setAllCtrlKeyArray(all, attr) {
            var len = all.length - 1;
            all.sort(compare2(attr, true));
            if (attr == 'x') {
                var elementAllWidth = 0;
                for (var i = 1; i < len; i++) {
                    elementAllWidth+=all[i].geometry.width;
                }
                var spacingPx = (all[len].geometry.x - all[0].geometry.x - all[0].geometry.width - elementAllWidth) / len;
                for (var i = 1; i < len; i++) {
                    all[i].geometry.x = all[i-1].geometry.x + all[i-1].geometry.width + spacingPx;
                }
            }
            if (attr == 'y') {
                var elementAllHeight = 0;
                for (var i = 1; i < len; i++) {
                    elementAllHeight+=all[i].geometry.height;
                }
                var spacingPx = (all[len].geometry.y - all[0].geometry.y - all[0].geometry.height - elementAllHeight) / len;
                for (var i = 1; i < len; i++) {
                    all[i].geometry.y = all[i-1].geometry.y + all[i-1].geometry.height + spacingPx;
                }
            }
            vm.ctrlKey = []
            vm.data.document.levels.level.forEach(function(item){
                item.imagebox.selected = false;
            })

        }
        //拖动图片框
        var isDown = false;
        $scope.imageboxDown = function ($event, item) {
            if(item.lock){return}
            var $event = $event || window.event;
            if($event && $event.preventDefault){
                $event.preventDefault();
            }
            else {
                window.event.returnValue = false;
                return false;
            }
            if (vm.ctrlKey.length > 0) {
                levelMove($event);
            }else{
                imageMove($event, item)
            }
        }
        function levelMove(event) {
            console.log(vm.ctrlKey)
            angular.forEach(vm.data.document.levels.level, function (level, i) {
                if(level.imagebox && level.imagebox.selected){
                    if(!level.imagebox.lock){
                        (function(imagebox){
                            imageMove(event, imagebox)
                        })(level.imagebox)
                    }
                }
            })
        }
        var moveItem = [];
        function imageMove($event, item){
            $event.stopPropagation();
            var x = $event.clientX;
            var y = $event.clientY;
            item.l = angular.copy(item.geometry.x * vm.ratio);
            item.t = angular.copy(item.geometry.y * vm.ratio);
            moveItem.push(item)
            //开关打开
            isDown = true;
            //鼠标移动
            window.onmousemove = function (e) {
                if (isDown == false) {
                    return;
                }
                moveItem.forEach(function (item1) {
                    var nx = e.clientX;
                    var ny = e.clientY;
                    //计算移动后的左偏移量和顶部的偏移量
                    var nl = nx - (x - item1.l);
                    var nt = ny - (y - item1.t);
                    item1.geometry.x = nl / vm.ratio;
                    item1.geometry.y = nt / vm.ratio;
                })
                $scope.$digest();
            }
            //鼠标抬起事件
            window.onmouseup = function ($event) {
                if (isDown) {
                    cookie();
                }
                isDown = false;
                moveItem = [];
                $event.stopPropagation();
            }
        }
        // //缩放
        var isZoomDown = false;
        // $scope.resizeStartRigth = function($event, item,pro,index,slide){
        //     if(item.lock){return}
        //     fn($event);
        //     imageboxZoom($event, item, 'right',pro,index,slide)
        // }
        // $scope.resizeStartLeft = function ($event, item,pro,index,slide) {
        //     if(item.lock){return}
        //     fn($event);
        //     imageboxZoom($event, item, 'left',pro,index,slide)
        // }
        // $scope.resizeStartTop = function ($event, item,pro,index,slide) {
        //     if(item.lock){return}
        //     fn($event);
        //     imageboxZoom($event, item, 'top',pro,index,slide)
        // }
        // $scope.resizeStartBottom = function ($event, item,pro,index,slide) {
        //     if(item.lock){return}
        //     fn($event);
        //     imageboxZoom($event, item, 'bottom',pro,index,slide)
        // }
        // $scope.resizeStartLeft1 = function ($event, item,pro,index,slide) {
        //     if(item.lock){return}
        //     fn($event);
        //     imageboxZoom1($event, item, 'left',pro,index,slide)
        // }
        // $scope.resizeStartTop1 = function ($event, item,pro,index,slide) {
        //     if(item.lock){return}
        //     fn($event);
        //     imageboxZoom1($event, item, 'top',pro,index,slide)
        // }
        // $scope.resizeStartRight1 = function ($event, item,pro,index,slide) {
        //     if(item.lock){return}
        //     fn($event);
        //     imageboxZoom1($event, item, 'right',pro,index,slide)
        // }
        // $scope.resizeStartBottom1 = function ($event, item,pro,index,slide) {
        //     if(item.lock){return}
        //     fn($event);
        //     imageboxZoom1($event, item, 'bottom',pro,index,slide)
        // }
        function imageboxZoom($event,item, direction,pro,index,slide) {
            var x = $event.clientX;
            var y = $event.clientY;
            //获取w和h
            var nw = angular.copy(item.geometry.width) * pro;
            var nh = angular.copy(item.geometry.height) * pro;
            var nw1 = item.image ? angular.copy(item.image.width) * pro : 0;
            var nh1 = item.image ? angular.copy(item.image.height) * pro : 0;
            var nw2 = item.image ? angular.copy(item.image.width) * pro : 1;
            var nh2 = item.image ? angular.copy(item.image.height) * pro : 1;
            var x1 = item.image ? angular.copy(item.image.offsetx * pro) : 0;
            var y1 = item.image ? angular.copy(item.image.offsety * pro) : 0;
            var x2 = item.geometry.x * pro;
            var y2 = item.geometry.y * pro;
            var _scale = item.image ? angular.copy(item.image.scale) : 1;
            var maxX = vm.data.document.mediabox.width * vm.ratio;
            var maxY = vm.data.document.mediabox.height * vm.ratio;

            //开关打开
            isZoomDown = true;
            //鼠标移动
            window.onmousemove = function (e) {
                if (isZoomDown == false) {
                    return;
                }
                //获取x和y
                var nx = e.clientX;
                //计算移动后的左偏移量和顶部的偏移量
                var nl = nx - x;

                if(direction == 'bottom' || direction == 'left'){
                    var _w = (Number(nw) - Number(nl));
                }
                if(direction == 'top' || direction == 'right'){
                    var _w = (Number(nw) + Number(nl));
                }
                var _h = _w / nw * nh;
                // if(_w > ($scope.currentPage.width+$scope.wahBorder/$scope.currentPage.proportion)*$scope.currentPage.scale){
                //     _w = ($scope.currentPage.width+$scope.wahBorder/$scope.currentPage.proportion)*$scope.currentPage.scale;
                //     _h = _w / nw * nh;
                // }
                // if(_h > ($scope.currentPage.height+$scope.xayBorder/$scope.currentPage.proportion)*$scope.currentPage.scale){
                //     _h = ($scope.currentPage.height+$scope.xayBorder/$scope.currentPage.proportion)*$scope.currentPage.scale;
                //     _w = _h / nh * nw;
                // }
                if(_w > maxX){
                    _w = maxX;
                    _h = _w / nw * nh;
                }
                if(_h > maxY){
                    _h = maxY;
                    _w = _h / nh * nw;
                }
                item.geometry.width = _w / pro;
                item.geometry.height = _h / pro;
                if(item.image && item.image.resource.identifier){
                    item.image.width = _w / nw * nw2 / pro;
                    item.image.height = _w / nw * nh2 / pro;
                    item.image.offsetx = (_w / (nw / nw1)) / (nw1 / x1) / pro;
                    item.image.offsety = (_h / (nh / nh1)) / (nh1 / y1) / pro;

                    if(item.bokehtypes != 'None'){
                        var imgR = item.geometry.width/item.geometry.height;
                        var imgR1 = item.image.width/item.image.height;
                        if(imgR >= imgR1){
                            item.image.resource.adaptation = 'Height';
                            item.blurredrectangle = {
                                width: item.geometry.width,
                                height: item.geometry.width/item.image.width*item.image.height,
                                x: 0,
                                y: (item.geometry.height - item.geometry.width/item.image.width*item.image.height) / 2,
                            }
                        }else {
                            item.image.resource.adaptation = 'Width';
                            item.blurredrectangle = {
                                width: item.geometry.height/item.image.height*item.image.width,
                                height: item.geometry.height,
                                x: (item.geometry.width - item.geometry.height/item.image.height*item.image.width) / 2,
                                y: 0,
                            }
                        }
                    }
                }
                if(direction == 'left'){
                    item.geometry.x = (Number(x2) - Number(_w - nw)) / pro;
                    item.geometry.y = (Number(y2) - Number(_h - nh)) / pro;
                    if(item.geometry.x < 0){
                        item.geometry.x = 0;
                    }
                    if(item.geometry.y < 0){
                        item.geometry.y = 0;
                    }
                }
                if(direction == 'top'){
                    if(item.geometry.width*pro > maxX - item.geometry.x*pro){
                        item.geometry.width = (maxX - item.geometry.x*pro) / pro;
                    }
                    item.geometry.y = (Number(y2) - Number(_h - nh)) / pro;
                    if(item.geometry.y < 0){
                        item.geometry.y = 0;
                    }
                }
                if(direction == 'right'){
                    if(item.geometry.width*pro > maxX - item.geometry.x*pro){
                        item.geometry.width = (maxX - item.geometry.x*pro) / pro;
                        item.geometry.height = item.geometry.width / nw * nh;
                    }
                    if(Number(item.geometry.height * pro) + Number(item.geometry.y * pro) > maxY){
                        item.geometry.height = (maxY - Number(item.geometry.y * pro)) / pro;
                        item.geometry.width = item.geometry.height / nh * nw;
                        return;
                    }
                }
                if(direction == 'bottom'){
                    if(Number(item.geometry.height * pro) + Number(item.geometry.y * pro) > maxY){
                        item.geometry.height = (maxY - Number(item.geometry.y * pro)) / pro;
                        item.geometry.width = item.geometry.height / nh * nw;
                        return;
                    }
                    item.geometry.x = (Number(x2) - Number(_w - nw)) / pro;
                    if(item.geometry.x < 0){
                        item.geometry.x = 0;
                    }
                }

                vm.data.document.levels.level[vm.xmlSelect.index].imagebox = item;
                updateUnitImagebox(item);
                $scope.$digest();
            }
            //鼠标抬起事件
            window.onmouseup = function ($event) {
                if(isZoomDown){
                    cookie();
                }
                $scope.$digest();
                $event.stopPropagation();
                isZoomDown = false;
            }
        }
        function imageboxZoom1($event,item, direction, pro,index,slide) {
            var x = $event.clientX;
            var y = $event.clientY;
            //获取w和h
            var nw = angular.copy(item.geometry.width) * pro;
            var nh = angular.copy(item.geometry.height) * pro;
            var nw1 = item.image ? angular.copy(item.image.width) * pro : 0;
            var nh1 = item.image ? angular.copy(item.image.height) * pro : 0;
            var nw2 = item.image ? angular.copy(item.image.width) * pro : 1;
            var nh2 = item.image ? angular.copy(item.image.height) * pro : 1;
            var x1 = item.image ? angular.copy(item.image.offsetx * pro) : 0;
            var y1 = item.image ? angular.copy(item.image.offsety * pro) : 0;
            var x2 = item.geometry.x * pro;
            var y2 = item.geometry.y * pro;
            var _scale = item.image ? angular.copy(item.image.scale) : 1;
            var maxX = vm.data.document.mediabox.width * vm.ratio;
            var maxY = vm.data.document.mediabox.height * vm.ratio;
            //开关打开
            isZoomDown = true;
            //鼠标移动
            window.onmousemove = function (e) {
                if (isZoomDown == false) {
                    return;
                }
                //获取x和y
                var nx = e.clientX;
                var ny = e.clientY;
                //计算移动后的左偏移量和顶部的偏移量
                var nl = nx - x;
                var nt = ny - y;

                if(direction == 'left'){
                    var _w = (Number(nw) - Number(nl));
                }
                if(direction == 'right'){
                    var _w = (Number(nw) + Number(nl));
                }
                if(direction == 'top'){
                    var _h = (Number(nh) - Number(nt));
                }
                if(direction == 'bottom'){
                    var _h = (Number(nh) + Number(nt));
                }
                if(direction == 'left'){
                    item.geometry.x = (Number(x2) - Number(_w - nw)) / pro;
                    item.geometry.width = _w / pro;
                    if(item.geometry.x < 0){
                        item.geometry.x = 0;
                    }
                }
                if(direction == 'top'){
                    item.geometry.y = (Number(y2) - Number(_h - nh)) / pro;
                    item.geometry.height = _h / pro;
                    if(item.geometry.y < 0){
                        item.geometry.y = 0;
                    }
                }
                if(direction == 'right'){
                    item.geometry.width = _w / pro;
                }
                if(direction == 'bottom'){
                    item.geometry.height = _h / pro;
                }
                if(item.geometry.width*pro > maxX - item.geometry.x*pro){
                    item.geometry.width = (maxX - item.geometry.x*pro) / pro;
                }
                if(item.geometry.height*pro > maxY - item.geometry.y*pro){
                    item.geometry.height = (maxY - item.geometry.y*pro) / pro;
                }
                vm.data.document.levels.level[vm.xmlSelect.index].imagebox = item;
                updateUnitImagebox(item);
                $scope.$digest();
            }
            //鼠标抬起事件
            window.onmouseup = function ($event) {
                if (isZoomDown){
                    cookie();
                }
                $event.stopPropagation();
                isZoomDown = false;
            }
        }
        $scope.imageboxdownRotate = function ($event, item) {
            if(item.lock){return}
            fn($event);
            var _top = $($event.target).parents('.c-xml-page-material').offset().top + (item.geometry.height * vm.ratio / 2);
            var _left = $($event.target).parents('.c-xml-page-material').offset().left + (item.geometry.width * vm.ratio / 2);

            //开关打开
            var isRotate = true;
            //鼠标移动
            window.onmousemove = function (e) {
                if (isRotate == false) {
                    return;
                }
                item.rotation.angle = getAngle(_left,_top, e.clientX, e.clientY);
                $scope.$digest();
            }
            //鼠标抬起事件
            window.onmouseup = function (e) {
                if(isRotate){
                    cookie()
                }
                isRotate = false;
            };
        }
        function getAngle(px,py,mx,my){//获得人物中心和鼠标坐标连线，与y轴正半轴之间的夹角
            var x = Math.abs(px-mx);
            var y = Math.abs(py-my);
            var z = Math.sqrt(Math.pow(x,2)+Math.pow(y,2));
            var cos = y/z;
            var radina = Math.acos(cos);//用反三角函数求弧度
            var angle = Math.floor(180/(Math.PI/radina));//将弧度转换成角度
            if(mx<px&&my>py){//鼠标在第三象限
                angle = 360 - angle;
            }
            if(mx<px&&my<py){
                angle = 180 + angle;
            }
            if(mx>px&&my<py){
                angle = 180 - angle;
            }
            if(mx>px&&my>py){
                angle = 360 + angle;
            }
            return normalizeAngle(-angle);
        }
        // 旋转角度取值0-360
        function normalizeAngle(angle) {
            angle = angle % 360;
            if (angle < 0) {
            angle = angle + 360;
            }
            return angle;
        }
        $scope.fn = fn;
        function fn($event){
            var $event = $event || window.event;
            // if($event && $event.preventDefault){
            //     $event.preventDefault();
            // }
            // else {
            //     window.event.returnValue = false;
            //     return false;
            // }
            $event.stopPropagation();
        }

        //点击作品框
        $scope.xmlClick = function($event){
            if ($event.ctrlKey == true || $event.metaKey == true) {
                return
            }
            fn($event)
        }

        $scope.clearCtrlKey = function ($event) {
            if ($event.ctrlKey == true || $event.metaKey == true) {
                return
            }
            vm.ctrlKey = []
            vm.data.document.levels.level.forEach(function(item){
                item.imagebox.selected = false;
            })
            // console.log(vm.data.document.levels.level[vm.xmlSelect.index].imagebox.geometry.x,vm.data.document.levels.level[vm.xmlSelect.index].imagebox.geometry.y,'点计画布');
            $scope.selectBox = null;
            vm.xmlSelect = {
                type: '',
                index:''
            };
            toolbarStatus();
        }

        $scope.boxAlignment = function (attr) {
            var all = vm.ctrlKey
            if (attr == 'left') {
                all.sort(compare2('x', true));
            } else if (attr == 'right') {
                all.sort(compare2('x', false, 'width'));
            } else if (attr == 'top') {
                all.sort(compare2('y', true));
            } else if (attr == 'bottom') {
                all.sort(compare2('y', false,'height'));
            }
            if(attr == 'vertical' && all.length>0){
                var verticalY = horizontalAndVerticalCenter(attr, all);
            }
            if(attr == 'standard' && all.length>0){
                var standardX = horizontalAndVerticalCenter(attr, all);
            }
            var bigBoxCoord = null;
            if(['left','right','top','bottom'].includes(attr)){
                bigBoxCoord = getAllElemCoord(all);
            }
            for (var i = 0; i < all.length; i++) {
                if (all[i].lock) {
                    break;
                }
                if (attr == 'left') {
                    var coord = getElemMoveCoord('left',bigBoxCoord,all[i]);
                    all[i].geometry.x = coord;

                } else if (attr == 'right') {
                    var coord = getElemMoveCoord('right',bigBoxCoord,all[i]);
                    all[i].geometry.x = coord;

                } else if (attr == 'top') {
                    var coord = getElemMoveCoord('top',bigBoxCoord,all[i]);
                    all[i].geometry.y = coord;

                } else if (attr == 'bottom') {
                    var coord = getElemMoveCoord('bottom',bigBoxCoord,all[i]);
                    all[i].geometry.y = coord;

                } else if (attr == 'vertical') {
                    all[i].geometry.y = verticalY - all[i].geometry.height / 2;
                } else {
                    all[i].geometry.x = standardX - all[i].geometry.width / 2;
                }
            }
            vm.ctrlKey = []
            vm.data.document.levels.level.forEach(function(item){
                item.imagebox.selected = false;
            })
            cookie();
        }

        function compare2(property, attr,property2) {
            return function (a, b) {
                var value1 = a.geometry[property];
                var value2 = b.geometry[property];
                // console.log(value1);
                // console.log(value2);
                if (attr) {
                    return value1 - value2;
                } else {
                    var value12 = a.geometry[property2];
                    var value22 = b.geometry[property2];
                    return value2+value22 - value1-value12;
                }
            }
        }
        //单位换算
        $scope.unitConversion = function () {
            unit()
        }
        function unit(){
            if(vm.unit == 'mm'){
                vm.attribute = {
                    product: {
                        width: (vm.data.document.mediabox.width/vm.windowDpiW*25.4).toFixed(2),
                        height:(vm.data.document.mediabox.height/vm.windowDpiH*25.4).toFixed(2),
                    },
                    imagebox:!$scope.selectBox?null:{
                        width: PxTurnMm($scope.selectBox.geometry.width),
                        height: PxTurnMm($scope.selectBox.geometry.height),
                        x: PxTurnMm($scope.selectBox.geometry.x),
                        y: PxTurnMm($scope.selectBox.geometry.y)
                    },
                }
            }
            if (vm.unit == 'px'){
                vm.attribute = {
                    product: {
                        width: vm.data.document.mediabox.width,
                        height:vm.data.document.mediabox.height,
                    },
                    imagebox:!$scope.selectBox?null:{
                        width: $scope.selectBox.geometry.width,
                        height: $scope.selectBox.geometry.height,
                        x: $scope.selectBox.geometry.x,
                        y: $scope.selectBox.geometry.y
                    },
                }
            }
        }
        js_getDPI()
        function js_getDPI() {
            var arrDPI = new Array();
            if (window.screen.deviceXDPI != undefined) {
                arrDPI[0] = window.screen.deviceXDPI;
                arrDPI[1] = window.screen.deviceYDPI;
            }
            else {
                var tmpNode = document.createElement("DIV");
                tmpNode.style.cssText = "width:1in;height:1in;position:absolute;left:0px;top:0px;z-index:99;visibility:hidden";
                document.body.appendChild(tmpNode);
                arrDPI[0] = parseInt(tmpNode.offsetWidth);
                arrDPI[1] = parseInt(tmpNode.offsetHeight);
                tmpNode.parentNode.removeChild(tmpNode);
            }
            vm.windowDpiW = arrDPI[0];
            vm.windowDpiH = arrDPI[1];
            // vm.windowDpiW = 300;
            // vm.windowDpiH = 300;
            return arrDPI;
        }

        //作品框宽高优化
        function initWindow(){
            vm.windowH = window.innerHeight - 110;
            vm.windowW = window.innerWidth - 500;
            if(vm.windowH / vm.data.document.mediabox.height >= vm.windowW / vm.data.document.mediabox.width ){
                vm.ratio = vm.windowW / vm.data.document.mediabox.width * 0.8;
            }else {
                vm.ratio = vm.windowH / vm.data.document.mediabox.height * 0.8;
            }
            //记录初始缩放比
            vm.initRatio = vm.ratio;
            vm.windowH1 = 200;
            vm.windowW1 = 200;
            if(vm.windowH1 / vm.data.document.mediabox.height >= vm.windowW1 / vm.data.document.mediabox.width ){
                vm.ratio1 = vm.windowW1 / vm.data.document.mediabox.width * 0.8;
            }else {
                vm.ratio1 = vm.windowH1 / vm.data.document.mediabox.height * 0.8;
            }
        }
        window.onresize = function(){
            initWindow()
            $scope.$apply();
            getFullState();
        }
        //属性栏
        $scope.$watch("vm.attribute.product.width",function(newValue,oldValue){
            if(oldValue){
                if(vm.unit == 'mm'){vm.data.document.mediabox.width = (vm.attribute.product.width/25.4 * vm.windowDpiW).toFixed(2);}
                if (vm.unit == 'px'){vm.data.document.mediabox.width = vm.attribute.product.width;}
                initWindow();
            }
        })
        $scope.$watch("vm.attribute.product.height",function(newValue,oldValue){
            if(oldValue){
                if(vm.unit == 'mm'){vm.data.document.mediabox.height = (vm.attribute.product.height/25.4 * vm.windowDpiH).toFixed(2);}
                if (vm.unit == 'px'){vm.data.document.mediabox.height = vm.attribute.product.height;}
                initWindow();
            }
        })

        //锁定
        $scope.xmlLock = function($event){
            if (!$scope.selectBox) {
                MessageService.notice('请选择一个相框')
                return
            }
            if(vm.xmlSelect.type == 'imagebox'){
                vm.data.document.levels.level[vm.xmlSelect.index].imagebox.lock = !vm.data.document.levels.level[vm.xmlSelect.index].imagebox.lock ? true : false;
                console.log(vm.data.document.levels.level[vm.xmlSelect.index].imagebox.lock)
            }
            fn($event)
        }
        //复制
        $scope.xmlCopy = function($event){
            if (!$scope.selectBox) {
                MessageService.notice('请选择一个相框')
                return
            }
            xmlCopy()
            fn($event)
        }
        //键盘事件
        document.onkeydown = function(event){
            if(vm.isTransp){
                return
            }
            fn(event);
            //ctrl + c
            if (event.ctrlKey && window.event.keyCode==67){
                if(event.target.nodeName=='TEXTAREA'){
                    return
                }
                return false;
            }
            //ctrl + v
            if (event.ctrlKey && window.event.keyCode==86){
                if(event.target.nodeName=='TEXTAREA'){
                    return
                }
                xmlCopy();
                $scope.$digest();
                return false;
            }
            // 删除
            if (event.keyCode == 46) {
                xmlDelete();
                $scope.$digest();
            }

            // 上
            if (event.keyCode == 38) {
                keycodeArrow(38);
            }
            // 下
            if (event.keyCode == 40) {
                keycodeArrow(40);
            }
            // 左
            if (event.keyCode == 37) {
                keycodeArrow(37);
            }
            // 右
            if (event.keyCode == 39) {
                keycodeArrow(39);
            }
            //空格
            if (event.keyCode === 32){
                if(vm.moveCanvasView) return false;
                $timeout(function(){
                    vm.moveCanvasView = true;
                })
                return false;
            }
            //F11
            if (event.keyCode===122 && !vm.isFullScreen) {
                event.preventDefault();
                $scope.fullScreen();
            }
            // ctrl+z
            if (event.keyCode == 90 && event.ctrlKey) {
                $scope.xmlRevocation(event);
                $scope.$digest();
            }
        }
        document.onkeyup = function(){
            if(event.keyCode === 32){
                $timeout(function(){
                    vm.moveCanvasView = false;
                })
            }

        }
        //移动画布
        $scope.moveCanvas = function(e){
            if(!vm.moveCanvasView) return;
            var moveCanvasInfo = angular.copy(vm.moveCanvasInfo);
            moveCanvas(e,function(x,y){
                $timeout(function(){
                    vm.moveCanvasInfo.x = moveCanvasInfo.x + x;
                    vm.moveCanvasInfo.y = moveCanvasInfo.y + y;
                })

            })
        }
        //画布位置x
        $scope.canvasCoordX = function(width){
            if(!width) return 0;
            var canvasWidth = $("#canvas").width();
            var x = (canvasWidth - width) / 2 + vm.moveCanvasInfo.x;

            return x + "px";
        }
        //画布位置Y
        $scope.canvasCoordY = function(height){
            if(!height) return 0;
            var canvasHeight = $("#canvas").height();
            var y = (canvasHeight - height) / 2 + vm.moveCanvasInfo.y;
            return y + "px";
        }
        /**
         * 画布放大、缩小、还原
         * @param {*} type  0 还原 1缩小 2放大  3原尺寸
         */
        $scope.changeCanvasSize = function(type){
            $timeout(function(){
                //步长
                var stepSize = 0.02;
                //还原
                if(type === 0){
                    initWindow();
                    vm.initMoveCanvasInfo();
                }
                //1:1 原尺寸
                if(type === 3){
                    vm.ratio = 1;
                    vm.initMoveCanvasInfo();
                }
                // 缩小
                if(type === 1){
                    vm.ratio = vm.ratio - stepSize;
                    //限制最小缩放比不能小于0.5倍的初始尺寸
                    if(vm.ratio < (0.5 * vm.initRatio)) vm.ratio = 0.5 * vm.initRatio;
                }
                //放大
                if(type === 2){
                    vm.ratio = vm.ratio + stepSize;
                    //限制放大倍数不能大于1.5倍的初始尺寸
                    if(vm.ratio > (1.5 * vm.initRatio)) vm.ratio = 1.5 * vm.initRatio;
                }
            })
        }
        //鼠标滚轮事件
        function originalEventRatio(){
            if (event.ctrlKey === true || event.metaKey) {
                var wheelDelta = event.wheelDelta ? (event.wheelDelta / 120) : (-event.detail / 3);
                if (wheelDelta > 0) {
                    $scope.changeCanvasSize(2);
                } else {
                    $scope.changeCanvasSize(1);
                }
                $scope.$apply();
                event.preventDefault();
            }
        }
        //鼠标滚轮事件
        window.addEventListener('mousewheel',originalEventRatio,{passive: false});
        $scope.$on('$destroy',function () {
            //取消监听事件
            window.removeEventListener('mousewheel',originalEventRatio)
        });
        function xmlCopy(){
            var _level = "";
            if(vm.xmlSelect.type == 'imagebox'){
                _level = angular.copy(vm.data.document.levels.level[vm.xmlSelect.index]);
                if(_level){
                    _level.imagebox.geometry.x = Number(_level.imagebox.geometry.x) + Number(10);
                    _level.imagebox.geometry.y = Number(_level.imagebox.geometry.y) + Number(10);
                    _level.seq = Number(vm.data.document.levels.level.length) + Number(1);
                    vm.data.document.levels.level.push(_level)
                }
                cookie()
            }
        }
        //上移一层
        $scope.seqUp = function($event){
            seqTier('seqUp');
            fn($event)
        }
        //下移一层
        $scope.seqDown = function($event){
            seqTier('seqDown');
            fn($event)
        }
        //置顶
        $scope.seqStick = function($event){
            seqTier('seqStick');
            fn($event)
        }
        //置底
        $scope.seqBottom = function($event){
            seqTier('seqBottom');
            fn($event)
        }
        function seqTier(data){
            if(vm.xmlSelect.type == 'imagebox'){
                for(var i=0; i<vm.data.document.levels.level.length; i++){
                    if(vm.data.document.levels.level[i].imagebox) {
                        var _imageart = vm.data.document.levels.level[i].imagebox;
                        if (i === vm.xmlSelect.index) {
                            var _seq = Number(vm.data.document.levels.level.length) + Number(1);
                            if(data == 'seqUp'){
                                if(vm.data.document.levels.level[i].seq >= _seq){
                                    MessageService.notice("已在最顶层");
                                    return
                                }
                                vm.data.document.levels.level[i].seq > _seq ? _seq : vm.data.document.levels.level[i].seq++;
                            }
                            if(data == 'seqDown'){
                                if(vm.data.document.levels.level[i].seq == 0){
                                    MessageService.notice("已在最底层");
                                    return
                                }
                                vm.data.document.levels.level[i].seq < 1 ? 0 : vm.data.document.levels.level[i].seq--
                            }
                            if(data == 'seqStick'){
                                if(vm.data.document.levels.level[i].seq >= _seq){
                                    MessageService.notice("已在最顶层");
                                    return
                                }
                                vm.data.document.levels.level[i].seq = _seq
                            }
                            if(data == 'seqBottom'){
                                if(vm.data.document.levels.level[i].seq == 0){
                                    MessageService.notice("已在最底层");
                                    return
                                }
                                vm.data.document.levels.level[i].seq = 0
                            }
                            break
                        }
                    }
                }
            }
            cookie()
        }

        //删除
        $scope.xmlDelete = function($event){
            if (!$scope.selectBox) {
                MessageService.notice('请选择一个相框')
                return
            }
            xmlDelete()
            fn($event)
        }
        function xmlDelete(){
            if(vm.xmlSelect.type == 'imagebox'){
                for(var i=0; i<vm.data.document.levels.level.length; i++){
                    if(vm.data.document.levels.level[i].imagebox){
                        var _imageart = vm.data.document.levels.level[i].imagebox;
                        if(i === vm.xmlSelect.index){
                            vm.data.document.levels.level.splice(i, 1)
                            $scope.selectBox = null;
                            vm.xmlSelect.index = null;
                            break
                        }
                    }
                }
                vm.xmlSelect.type = "";
                vm.xmlSelect.index = '';
                cookie()
            }
        }
        //上一步
        $scope.xmlRevocation = function($event){
            $timeout(function () {
                if(vm.cookies.length<2){
                    vm.data = angular.copy(vm.dataInit);
                    vm.cookies=[];
                    return
                }
                vm.data = vm.cookies[vm.cookies.length-2];
                vm.cookies.splice(1)
            })
            clear();
            fn($event)
        };
        //恢复
        $scope.xmlNextStep = function($event){
            $timeout(function () {
                vm.data = angular.copy(vm.dataInit);
                vm.cookies = [];
                initWindow()
                angular.forEach(vm.data.document.levels.level, function (level, index) {
                    if(level.imagebox){
                        level.imagebox.geometry = {
                            width: level.imagebox.geometry.width,
                            height: level.imagebox.geometry.height,
                            x: level.imagebox.geometry.x,
                            y: level.imagebox.geometry.y
                        };
                        maskScale(vm.data.document.levels.level[index].imagebox, index, level.imagebox.mask.resource.identifier)
                    }
                });

                $scope.$digest();
            })
            clear()
            fn($event)
        };
        vm.isFullScreen = false;
        function getFullState(){
            $timeout(function () {
                vm.isFullScreen = Math.abs(window.screen.height-window.document.documentElement.clientHeight) <= 17;
            })
        }
        getFullState();
        //全屏
        $scope.fullScreen = function(){
            var el = document.documentElement
            var rfs = el.requestFullScreen || el.webkitRequestFullScreen || el.mozRequestFullScreen || el.msRequestFullscreen
            if (rfs) { // typeof rfs != "undefined" && rfs
                rfs.call(el)
            }else if (typeof window.ActiveXObject !== 'undefined') {
                // for IE，这里其实就是模拟了按下键盘的F11，使浏览器全屏
                var wscript = new ActiveXObject('WScript.Shell')
                if (wscript != null) {
                    wscript.SendKeys('{F11}')
                }
            }
        }
        $scope.exitScreen = function(){
            var el = document
            var cfs = el.cancelFullScreen || el.mozCancelFullScreen || el.msExitFullscreen || el.webkitExitFullscreen || el.exitFullscreen
            if (cfs) { // typeof cfs != "undefined" && cfs
                cfs.call(el)
            } else if (typeof window.ActiveXObject !== 'undefined') {
                // for IE，这里和fullScreen相同，模拟按下F11键退出全屏
                var wscript = new ActiveXObject('WScript.Shell')
                if (wscript != null) {
                    wscript.SendKeys('{F11}')
                }
            }
        }
        //缓存每一步
        vm.operation = false;
        function cookie(){
            var _data = angular.copy(vm.data);
            vm.cookies.push(_data);
            vm.operation = true;
        }

        function addElement(type, data) {
            var _seq = Number(vm.data.document.levels.level.length) + Number(1);
            if(type == 'imagebox'){
                var _level = {
                    seq: _seq,
                    imagebox: null
                }
                _level.imagebox = data;
                vm.data.document.levels.level.push(_level);
            }
        }
        //保存至作品
        $scope.save = function () {
            vm.xmlSelect.index = null;
            $scope.selectBox = null;
            $timeout(function () {
                var _data = angular.copy(vm.data);
                _data.document = selectCancel();
                _data.quantity = _data.document.levels.level.length;
                var nodes = document.getElementById('c-xml');
                html2canvas_adapt(nodes, {
                    onrendered: function(canvas) {
                        var url = canvas.toDataURL("image/png");
                        var blob = dataURLtoBlob(url);

                        var formData = new FormData();
                        formData.append('file', blob);
                        formData.append('key', 'cover-' + UidService.get());
                        formData.append('token', vm.token);
                        $.ajax({
                            cache: true,
                            type: "POST",
                            url: 'https://upload.qiniup.com/',
                            data: formData,
                            async: false,
                            contentType: false,
                            processData: false,
                            success: function (data) {
                                _data.cover = vm.url + data.key;
                                //_data.name = _data.document.mediabox.width.toFixed(2) + '×' + _data.document.mediabox.height.toFixed(2) + 'mm';
                                if(_data.id){
                                    PicLayoutXmls.update(_data, function (res) {
                                        MessageService.success("保存成功");
                                        $state.go('picture')
                                    })
                                }else{
                                    PicLayoutXmls.save(_data, function (res) {
                                        MessageService.success("保存成功");
                                        $state.go('picture')
                                    })
                                }
                                $scope.$digest();
                            },
                            error: function (request) {
                                MessageService.error("文件上传失败");
                            }
                        });
                    },
                    letterRendering: true,
                    useCORS: true,
                    logging: false
                });
            })
        }

        function selectCancel() {
            var _document = angular.copy(vm.data.document);
            _document.mediabox.width = transitionMm(_document.mediabox.width);
            _document.mediabox.height = transitionMm(_document.mediabox.height);
            angular.forEach(_document.levels.level, function (level, index) {
                if(level.imagebox){
                    level.imagebox.rotation.angle = -level.imagebox.rotation.angle;
                    level.imagebox.geometry = {
                        width: transitionMm(level.imagebox.geometry.width),
                        height: transitionMm(level.imagebox.geometry.height),
                        x: transitionMm(level.imagebox.geometry.x),
                        y: transitionMm(level.imagebox.geometry.y)
                    };
                }
            });
            return _document
        }

        //mm转px
        function transitionPx(item) {
            return Number(item) * vm.windowDpiW / 25.4;
        }
        //px转mm
        function transitionMm(item) {
            return Number(item) * 25.4 / vm.windowDpiW;
        }
        // $scope.out = function () {
        //     MessageService.confirm({
        //         title:'提示',
        //         cancel:'取消',
        //         confirm:'确认',
        //         msg:'确认要退出吗？'
        //     },function(){
        //         $state.go('picture');
        //     })
        // }
        $scope.out = function () {
            if(!vm.operation){
                history.go(-1)
            }else{
                MessageService.confirm({
                    title:'温馨提示',
                    goback:'取消',
                    cancel:'不保存',
                    confirm:'保存',
                    msg:'退出前是否需要保存已变更的内容?',
                },function(){
                    $scope.save();
                },function (flag) {
                    if(flag){
                        history.go(-1)
                    }
                })
            }
        }
        function clear() {
            vm.isFont = false;
            vm.xmlSelect = {
                type: ''
            };
        }
        function dataURLtoBlob(dataurl) {
            var arr = dataurl.split(','), mime = arr[0].match(/:(.*?);/)[1],
                bstr = atob(arr[1]), n = bstr.length, u8arr = new Uint8Array(n);
            while (n--) {
                u8arr[n] = bstr.charCodeAt(n);
            }
            return new Blob([u8arr], { type: mime });
        }
         // 圆角设置
         vm.isRoundedSet = false;
         $scope.roundedSet = function(attr){
            if (!$scope.selectBox) {
                MessageService.notice('请选择一个相框')
                return
            }
             toolbarStatus();
             vm.isRoundedSet = attr;
             vm.borderRadiusAllbtn = false
         }

         // 边框设置
         vm.isBorderSet = false;
         $scope.borderSet = function(attr){
            if (!$scope.selectBox) {
                MessageService.notice('请选择一个相框')
                return
            }
             toolbarStatus();
             vm.isBorderSet = attr;
         }

         // 阴影设置
         vm.isShadowSet = false;
         $scope.shadowSet = function(attr){
            if (!$scope.selectBox) {
                MessageService.notice('请选择一个相框')
                return
            }
             toolbarStatus();
             vm.isShadowSet = attr;
         }
        // 透明度
        vm.isTransp = false;
        $scope.transparencySelect = function (e,attr) {
            if (!$scope.selectBox) {
                MessageService.notice('请选择一个相框')
                return
            }
            fn(e);
            toolbarStatus();
            vm.isTransp = attr;
            if(vm.isTransp){
                vm.transparency1 = Math.round($scope.selectBox.transparency*100);
            }
        }
        $scope.changeTransparency = function($event){
            fn($event)
            vm.transparency1 = Math.round($scope.selectBox.transparency*100);
        }
        $scope.transparencyChange1 = function($event){
            fn($event);
            $timeout(function () {
                if(vm.transparency1 === '' || vm.transparency1 === null || vm.transparency1<0){
                    vm.transparency1 = 0;
                }
                if(vm.transparency1 > 100){
                    vm.transparency1 = 100;
                }
                $scope.selectBox.transparency = vm.transparency1 / 100;
            })
        }
        $scope.coverageSelect = function (attr) {
            if (!$scope.selectBox) {
                MessageService.notice('请选择一个相框')
                return
            }
            toolbarStatus();
            vm.isCoverage = attr;
        }
         function toolbarStatus() {
            vm.isOperationDir = false;
            vm.isOperationSpacing = false;
            vm.isTransp = false;
            vm.isCoverage = false;
            vm.isRoundedSet = false;
            vm.isBorderSet = false;
            vm.isShadowSet = false;
            vm.isOperationColor = false;
            $scope.isAlignHover = false;
        }
        vm.borderRadiusAllbtn = false
        $scope.borderRadiusAll = function () {
            $scope.selectBox.border.radius.lt = $scope.selectBox.border.radius.all;
            $scope.selectBox.border.radius.rt = $scope.selectBox.border.radius.all;
            $scope.selectBox.border.radius.rb = $scope.selectBox.border.radius.all;
            $scope.selectBox.border.radius.lb = $scope.selectBox.border.radius.all;
        }
        $scope.borderRadiusAllbtn = function(event){
            fn(event);
            vm.borderRadiusAllbtn = true;
            $scope.selectBox.border.radius.rt = $scope.selectBox.border.radius.lt;
            $scope.selectBox.border.radius.rb = $scope.selectBox.border.radius.lt;
            $scope.selectBox.border.radius.lb = $scope.selectBox.border.radius.lt;
            $scope.selectBox.border.radius.all = $scope.selectBox.border.radius.lt
        }

        $scope.changeFilletType = function(type){
            if ($scope.selectBox.border.radius.filletType == type) {
                return
            }
            $scope.selectBox.border.radius.filletType = type;
            switchToRoundedMode($scope.selectBox,vm.borderRadiusAllbtn);//切换圆角显示模式
        }
        $scope.borderRadius = function(event){
            fn(event);
        }

        $scope.imageboxWRadius = function (imagebox, radius, ratio) {
            if (!imagebox) {
                return
            }
            if (imagebox.border) {
                if (imagebox.border.shape == 'Ellipse') {
                    return '50%'
                }
                if (imagebox.border.radius.filletType == 'Fixed') {//圆角固定值
                    var _radius = imagebox.border.radius[radius];
                    return _radius > 0 ? (_radius + Number(imagebox.border.lineWidth)/2) * ratio : 0;
                }else{
                    var radiusW = imagebox.geometry.width > imagebox.geometry.height ? imagebox.geometry.height : imagebox.geometry.width;
                    radiusW = radiusW + imagebox.border.lineWidth;
                    var _r = radiusW * imagebox.border.radius[radius] / 100;
                    return _r > 0 ? (_r + Number(imagebox.border.lineWidth)/2) * ratio : 0
                }
            } else {
                return 0
            }
        }
        $scope.lineTypeChenge = function(lineType){
            vm.data.document.levels.level[vm.xmlSelect.index].imagebox.border.lineType = lineType;
        }
        $scope.dropShadow = function(imagebox,radius){
            if (imagebox.shadow==null) {
                imagebox.shadow = {
                    color:'#777777',
                    x:0,
                    y:0,
                    blur:0
                }
            }
            if (imagebox.border == null) {
                imagebox.border = {
                    shape: 'Rectangle',
                    radius: {
                        lt: 0,
                        rt: 0,
                        rb: 0,
                        lb: 0,
                        all:0,
                        filletType: "Fixed"
                    },
                    "edge": {
                        top: 0,
                        right: 0,
                        bottom: 0,
                        left: 0
                    },
                    lineWidth: 0,
                    type: "Color",
                    lineType:"solid",
                    resource: {
                        "identifier": ''
                    },
                    color: '#000000',
                }
            }
            var width = imagebox.geometry.width * radius;
            var height = imagebox.geometry.height * radius;
            return dropShadow(imagebox,width,height)
        }


        $scope.moreDisplay = function(){
            vm.moreDisplay = !vm.moreDisplay;
        }

        function updateUnitImagebox(item){
            if (vm.unit == 'mm') {
                vm.attribute.imagebox = {
                    width: PxTurnMm(item.geometry.width).toFixed(2) - 0,
                    height: PxTurnMm(item.geometry.height).toFixed(2) - 0,
                    x: PxTurnMm(item.geometry.x).toFixed(2) - 0,
                    y: PxTurnMm(item.geometry.y).toFixed(2) - 0,
                }
            } else if (vm.unit == 'px') {
                vm.attribute.imagebox = {
                    width: PxTurnMm(item.geometry.width / 25.4 * vm.windowDpiW).toFixed(2)- 0,
                    height: PxTurnMm(item.geometry.height / 25.4 * vm.windowDpiW).toFixed(2)- 0,
                    x: PxTurnMm(item.geometry.x / 25.4 * vm.windowDpiW).toFixed(2)- 0,
                    y: PxTurnMm(item.geometry.y / 25.4 * vm.windowDpiW).toFixed(2)- 0,
                }
            } else if (vm.unit == 'in') {
                vm.attribute.imagebox = {
                    width: PxTurnIn(item.geometry.width),
                    height: PxTurnIn(item.geometry.height),
                    x: PxTurnIn(item.geometry.x),
                    y: PxTurnIn(item.geometry.y),
                }
            }
        }

        $scope.updateBoxParameter = function () {
            var box = {}, value = {};
            if (vm.xmlSelect.type == 'imagebox') {
                box = $scope.selectBox;
                value = vm.attribute.imagebox;
            }
            if (box.lock) {
                return
            }

            if (vm.unit == 'mm') {
                box.geometry = {
                    width: MmTurnPx(value.width),
                    height: MmTurnPx(value.height),
                    x: MmTurnPx(value.x),
                    y: MmTurnPx(value.y)
                }
            }
            if (vm.unit == 'px') {
                box.geometry = value;
            }
        };

        function keycodeArrow(keyCode) {
            var temp = JSON.parse(localStorage.getItem('singleArray'));
            var levels = vm.data.document.levels;
            var level = levels.level[vm.xmlSelect.index];
            var currentPage = vm.data.document;
            var all = vm.ctrlKey;

            var len = all.length;
            var box = [], value = {};
            if (!len) {
                if ($scope.selectBox) {
                    box = level.imagebox;
                    value = angular.copy(vm.attribute.imagebox);
                }
                if (box.lock) {
                    return
                }

                var maxHeightPx = parseFloat(currentPage.mediabox.height - box.geometry.height).toFixed(2) - 0;
                var maxWidthPx = parseFloat(currentPage.mediabox.width - box.geometry.width).toFixed(2) - 0;
                $timeout(function(){
                    // 上
                    if (keyCode == 38) {
                        if (vm.unit == 'px') {
                            if (value.y >= 1) {
                                value.y--;
                                box.geometry.y = MmTurnPx(value.y / vm.windowDpiH * 25.4);
                            }
                        } else if (vm.unit == 'mm') {
                            if (value.y >= 1) {
                                value.y -= 0.2;
                                box.geometry.y = MmTurnPx(value.y);
                            }
                        } else if (vm.unit == 'in') {
                            if (value.y >= 1) {
                                value.y -= 0.2;
                                box.geometry.y = InTurnPx(value.y);
                            }
                        }
                    }
                    // 下
                    if (keyCode == 40) {
                        if (vm.unit == 'px') {
                            if (value.y < maxHeightPx) {
                                value.y++;
                                box.geometry.y = MmTurnPx(value.y / vm.windowDpiH * 25.4);
                            }
                        } else if (vm.unit == 'mm') {
                            if (value.y < PxTurnMm(currentPage.mediabox.height - box.geometry.height)) {
                                value.y += 0.2;
                                box.geometry.y = MmTurnPx(value.y);
                            }
                        } else if (vm.unit == 'in') {
                            if (value.y < PxTurnIn(currentPage.mediabox.height - box.geometry.height)) {
                                value.y += 0.2;
                                box.geometry.y = InTurnPx(value.y);
                            }
                        }
                    }
                    // 左
                    if (keyCode == 37) {
                        if (vm.unit == 'px') {
                            if (value.x >= 1) {
                                value.x--;
                                box.geometry.x = MmTurnPx(value.x / vm.windowDpiW * 25.4);
                            }
                        } else if (vm.unit == 'mm') {
                            if (value.x >= 1) {
                                value.x -= 0.2;
                                box.geometry.x = MmTurnPx(value.x);
                            }
                        } else if (vm.unit == 'in') {
                            if (value.x >= 1) {
                                value.x -= 0.2;
                                box.geometry.x = InTurnPx(value.x);
                            }
                        }
                    }
                    // 右
                    if (keyCode == 39) {
                        if (vm.unit == 'px') {
                            if (box.geometry.x < maxWidthPx) {
                                value.x++;
                                box.geometry.x = MmTurnPx(value.x / vm.windowDpiW * 25.4);
                            }
                        } else if (vm.unit == 'mm') {
                            if (value.x < PxTurnMm(maxWidthPx)) {
                                value.x += 0.2;
                                box.geometry.x = MmTurnPx(value.x);
                            }
                        } else if (vm.unit == 'In') {
                            if (value.x < PxTurnIn(maxWidthPx)) {
                                value.x += 0.2;
                                box.geometry.x = InTurnPx(value.x);
                            }
                        }
                    }

                    updateUnitImagebox(box)
                })
            } else {
                for (var i = len - 1; i >= 0; i--) {
                    if (!all[i]) {
                        continue;
                    }
                    var box = [];
                    if (all[i]) {
                        box = all[i];
                    }
                    if (box.lock) {
                        return
                    }
                    var maxHeightPx = parseFloat(currentPage.mediabox.height - box.geometry.height).toFixed(2) - 0;
                    var maxWidthPx = parseFloat(currentPage.mediabox.width - box.geometry.width).toFixed(2) - 0;
                    if (keyCode == 38) {
                        if (vm.unit == 'px') {
                            if (box.geometry.y >= 1) {
                                box.geometry.y--;
                            }
                        } else if (vm.unit == 'mm') {
                            var y = PxTurnMm(box.geometry.y);
                            if (y >= 1) {
                                y -= 0.2;
                                box.geometry.y = MmTurnPx(y);
                            }
                        } else if (vm.unit == 'in') {
                            var y = PxTurnIn(box.geometry.y);
                            if (y >= 1) {
                                y -= 0.2;
                                box.geometry.y = InTurnPx(y);
                            }
                        }
                    }
                    // 下
                    if (keyCode == 40) {
                        if (vm.unit == 'px') {
                            if (box.geometry.y < maxHeightPx) {
                                box.geometry.y++;
                            }
                        } else if (vm.unit == 'mm') {
                            var y = PxTurnMm(box.geometry.y);
                            if (y < PxTurnMm(maxHeightPx)) {
                                y += 0.2;
                                box.geometry.y = MmTurnPx(y);
                            }
                        }
                    }
                    // 左
                    if (keyCode == 37) {
                        if (vm.unit == 'px') {
                            if (box.geometry.x >= 1) {
                                box.geometry.x--;
                            }
                        } else if (vm.unit == 'mm') {
                            var x = PxTurnMm(box.geometry.x)
                            if (x >= 1) {
                                x -= 0.2;
                                box.geometry.x = MmTurnPx(x);
                            }
                        } else if (vm.unit == 'in') {
                            var x = PxTurnIn(box.geometry.x)
                            if (x >= 1) {
                                x -= 0.2;
                                box.geometry.x = InTurnPx(x);
                            }
                        }
                    }
                    // 右
                    if (keyCode == 39) {
                        if (vm.unit == 'px') {
                            if (box.geometry.x < maxWidthPx) {
                                box.geometry.x++;
                            }
                        } else if (vm.unit == 'mm') {
                            var x = PxTurnMm(box.geometry.x);
                            if (x < PxTurnMm(maxWidthPx)) {
                                x += 0.2;
                                box.geometry.x = MmTurnPx(x);
                            }
                        } else if (vm.unit == 'In') {
                            var x = PxTurnIn(box.geometry.x);
                            if (x < PxTurnIn(maxWidthPx)) {
                                x += 0.2;
                                box.geometry.x = InTurnPx(x);
                            }
                        }
                    }
                    updateUnitImagebox(all[i])
                    $scope.$apply();
                }
            }
        }

        $scope.singleBoxAlignment = function (attr) {
            var all = vm.ctrlKey;
            if(all.length >= 2){
                $scope.boxAlignment(attr)
                return
            }
            if (!$scope.selectBox.geometry) {
                MessageService.notice("请选择一个元素");
                return
            }
            if ($scope.selectBox.lock) {
                MessageService.notice("请先解锁该元素");
                return
            }
            if (attr == 'left') {
                $scope.selectBox.geometry.x = elementAlign($scope.selectBox.geometry , $scope.selectBox.rotation.angle , 'left' , vm.data.document.mediabox.width , vm.data.document.mediabox.height);
            } else if (attr == 'right') {
                $scope.selectBox.geometry.x = elementAlign($scope.selectBox.geometry , $scope.selectBox.rotation.angle , 'right' , vm.data.document.mediabox.width , vm.data.document.mediabox.height);
            } else if (attr == 'top') {
                $scope.selectBox.geometry.y = elementAlign($scope.selectBox.geometry , $scope.selectBox.rotation.angle , 'top' , vm.data.document.mediabox.width , vm.data.document.mediabox.height);
            } else if (attr == 'bottom') {
                $scope.selectBox.geometry.y = elementAlign($scope.selectBox.geometry , $scope.selectBox.rotation.angle , 'bottom' , vm.data.document.mediabox.width , vm.data.document.mediabox.height);
            } else if (attr == 'vertical') {
                $scope.selectBox.geometry.y = (vm.data.document.mediabox.height - $scope.selectBox.geometry.height) / 2;
            } else {
                $scope.selectBox.geometry.x = (vm.data.document.mediabox.width - $scope.selectBox.geometry.width) / 2;
            }
            updateUnitImagebox($scope.selectBox)
            cookie();
        }

        //元素四角拖拽
        $scope.cursor = function (angle, source, boolean) {
            var _cursor = '';
            if (angle > 0 && !boolean) {
                angle = 360 - angle;
            }
            if (source == 'left' || source == 'right') {
                if (337 <= angle || angle < 22) {
                    _cursor = 'se-resize';
                }
                if (22 <= angle && angle < 67) {
                    _cursor = 'n-resize';
                }
                if (67 <= angle && angle < 112) {
                    _cursor = 'sw-resize';
                }
                if (112 <= angle && angle < 157) {
                    _cursor = 'e-resize';
                }
                if (157 <= angle && angle < 202) {
                    _cursor = 'se-resize';
                }
                if (202 <= angle && angle < 247) {
                    _cursor = 'n-resize';
                }
                if (247 <= angle && angle < 292) {
                    _cursor = 'sw-resize';
                }
                if (292 <= angle && angle < 337) {
                    _cursor = 'e-resize';
                }
            }
            if (source == 'top' || source == 'bottom') {
                if (337 <= angle || angle < 22) {
                    _cursor = 'sw-resize';
                }
                if (22 <= angle && angle < 67) {
                    _cursor = 'e-resize';
                }
                if (67 <= angle && angle < 112) {
                    _cursor = 'se-resize';
                }
                if (112 <= angle && angle < 157) {
                    _cursor = 'n-resize';
                }
                if (157 <= angle && angle < 202) {
                    _cursor = 'sw-resize';
                }
                if (202 <= angle && angle < 247) {
                    _cursor = 'e-resize';
                }
                if (247 <= angle && angle < 292) {
                    _cursor = 'se-resize';
                }
                if (292 <= angle && angle < 337) {
                    _cursor = 'n-resize';
                }
            }
            if (source == 'left1' || source == 'right1') {
                if (337 <= angle || angle < 22) {
                    _cursor = 'e-resize';
                }
                if (22 <= angle && angle < 67) {
                    _cursor = 'se-resize';
                }
                if (67 <= angle && angle < 112) {
                    _cursor = 'n-resize';
                }
                if (112 <= angle && angle < 157) {
                    _cursor = 'sw-resize';
                }
                if (157 <= angle && angle < 202) {
                    _cursor = 'e-resize';
                }
                if (202 <= angle && angle < 247) {
                    _cursor = 'se-resize';
                }
                if (247 <= angle && angle < 292) {
                    _cursor = 'n-resize';
                }
                if (292 <= angle && angle < 337) {
                    _cursor = 'sw-resize';
                }
            }
            if (source == 'top1' || source == 'bottom1') {
                if (337 <= angle || angle < 22) {
                    _cursor = 'n-resize';
                }
                if (22 <= angle && angle < 67) {
                    _cursor = 'sw-resize';
                }
                if (67 <= angle && angle < 112) {
                    _cursor = 'e-resize';
                }
                if (112 <= angle && angle < 157) {
                    _cursor = 'se-resize';
                }
                if (157 <= angle && angle < 202) {
                    _cursor = 'n-resize';
                }
                if (202 <= angle && angle < 247) {
                    _cursor = 'sw-resize';
                }
                if (247 <= angle && angle < 292) {
                    _cursor = 'e-resize';
                }
                if (292 <= angle && angle < 337) {
                    _cursor = 'se-resize';
                }
            }
            return _cursor
        }

        $scope.resizeStartLeft = function ($event, item, pro, index) {
            if (item.lock) {
                return
            }
            fn($event);
            editorBoxZoom($event, item, 'leftTop', pro, $($event.target).parents('.selected'), function (it) {
                $scope.$apply();
            }, function (it) {

            });
        }
        $scope.resizeStartTop = function ($event, item, pro, index) {
            if (item.lock) {
                return
            }
            fn($event);
            editorBoxZoom($event, item, 'rightTop', pro, $($event.target).parents('.selected'), function (it) {
                $scope.$apply();
            }, function (it) {

            });
        }
        $scope.resizeStartBottom = function ($event, item, pro, index) {
            if (item.lock) {
                return
            }
            fn($event);
            editorBoxZoom($event, item, 'leftBottom', pro, $($event.target).parents('.selected'), function (it) {
                $scope.$apply();
            }, function (it) {

            });
        }
        $scope.resizeStartLeft1 = function ($event, item, pro, index) {
            if (item.lock) {
                return
            }
            fn($event);
            editorBoxZoom($event, item, 'left', pro, $($event.target).parents('.selected'), function (it) {
                $scope.$apply();
            }, function (it) {

            });
        }
        $scope.resizeStartTop1 = function ($event, item, pro, index) {
            if (item.lock) {
                return
            }
            fn($event);
            editorBoxZoom($event, item, 'top', pro, $($event.target).parents('.selected'), function (it) {
                $scope.$apply();
            }, function (it) {

            });
        }
        $scope.resizeStartRight1 = function ($event, item, pro, index) {
            if (item.lock) {
                return
            }
            fn($event);
            editorBoxZoom($event, item, 'right', pro, $($event.target).parents('.selected'), function (it) {
                $scope.$apply();
            }, function (it) {

            });
        }
        $scope.resizeStartBottom1 = function ($event, item, pro, index) {
            if (item.lock) {
                return
            }
            fn($event);
            editorBoxZoom($event, item, 'bottom', pro, $($event.target).parents('.selected'), function (it) {
                $scope.$apply();
            }, function (it) {

            });
        }
        $scope.resizeStartRigth = function ($event, item, pro, index) {
            if (item.lock) {
                return
            }
            fn($event);
            editorBoxZoom($event, item, 'rightBottom', pro, $($event.target).parents('.selected'), function (it) {
                $scope.$apply();
            }, function (it) {

            });
        }
        $timeout(function(){
            $('#navId').on('scroll', function(event){
                if(vm.navPitch == 'imagebox'){
                    var realScrollHeight=event.currentTarget.clientHeight+event.currentTarget.scrollTop;
                    if(!vm.isBgImgData){
                        if((event.currentTarget.scrollHeight-1)<realScrollHeight && realScrollHeight < (event.currentTarget.scrollHeight+1)){
                            $scope.bgImgPageing();
                        }
                    }
                }
            });
        })

        $scope.fn = fn;
        $scope.rangeShadowX = function(x){
            var X = Number(x) * 0.5 + 50;
            return X +'% 100%'
        }
        $scope.rangeShadowY = function(y){
            var Y = Number(y) * 0.5 + 50;
            return Y +'% 100%'
        }
    }

})();

(function() {
    'use strict';

    angular
        .module('platformApp')
        .controller('PictureShareModal1Controller', PictureShareModal1Controller);

    PictureShareModal1Controller.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', '$state', 'MessageService','Catalog','PicLayoutXmls'];

    function PictureShareModal1Controller ($timeout, $scope, $stateParams, $uibModalInstance, entity, $state, MessageService,Catalog,PicLayoutXmls) {
        var vm = this;
        vm.save = save;
        vm.cancel = cancel;
        vm.data = entity.pictureArr;
        console.log(entity)
        vm.catalogId = "";
        Catalog.getAll({items:[{key:"usable",op:"=",value:"true"},{key:"catalogType",op:"=",value:"LAYOUT"}]}, function (data) {
            console.log(data,"data");
            vm.catalogs = data;
        })
        //返回
        function cancel() {
            $uibModalInstance.close();
        }

        function save() {
            if(entity.selectedAll){
                PicLayoutXmls.useAll({
                    backCatalogId: entity.backCatalogId,
                    catalogId: vm.catalogId
                }, function (res) {
                    MessageService.success("使用成功");
                    $uibModalInstance.close();
                })
            }else{
                var ids = [];
                vm.data.forEach(function (item) {
                    ids.push(item);
                })
                PicLayoutXmls.use({
                    ids:ids.join(","),
                    catalogId:vm.catalogId
                }, function (res) {
                    MessageService.success("使用成功");
                    $uibModalInstance.close();
                })
            }

        }
    }
})();

(function () {
    'use strict';

    angular
        .module('platformApp')
        .controller('PictureShareModalController', PictureShareModalController);

    PictureShareModalController.$inject = ['$scope', '$uibModalInstance', '$state', '$stateParams', 'MessageService', 'Catalog', 'entity', 'PicLayoutXmls'];

    function PictureShareModalController($scope, $uibModalInstance, $state, $stateParams, MessageService, Catalog, entity, PicLayoutXmls) {

        var vm = this;
        vm.PicLayoutXmlIds = entity;
        console.log(entity,'entity');

        vm.clear = clear;
        vm.save = save;
        vm.label = ''

        vm.catalogs = Catalog.getAll2({items:[{key:"usable",op:"=",value:"true"},{key:"catalogType",op:"=",value:"LAYOUT"}]})


        function clear() {
            $uibModalInstance.dismiss('cancel');
        }


        $scope.validate = function () {
            if (vm.backCatalog == null || vm.backCatalog == "") {
                MessageService.error("请选择专题");
                return false;
            }
            return true;
        };

        function save() {
            // $uibModalInstance.dismiss('cancel');
            if (!$scope.validate()) {
                return;
            }
            PicLayoutXmls.batchShare({ids:vm.PicLayoutXmlIds, catalogId:vm.backCatalog},function(data){
                MessageService.success("分享成功,等待后台审核");
                $uibModalInstance.close(data);
            },function(){

                MessageService.error("分享失败");
            });
        }

    }

})();

(function() {
    'use strict';

    angular
        .module('platformApp')
        .controller('PictureShareController', PictureShareController);

    PictureShareController.$inject = ['$state', '$scope', 'ProductXml', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams', 'MessageService', 'PicLayoutXmls', '$localStorage', 'Qinius', '$uibModal','Catalog','$timeout'];

    function PictureShareController($state, $scope, ProductXml, ParseLinks, AlertService, paginationConstants, pagingParams, MessageService, PicLayoutXmls, $localStorage, Qinius, $uibModal,Catalog,$timeout) {
        var vm = this;
        $(".sidebar1").hide();
        $(".navbar").show();
        $(".nav-bg").show();
        $(".wrap").css({margin: 0});
        //搜索防抖定时器
        vm.timer = null;
        //分页信息
        vm.pageInfo = {
            page:1,
            size:20,
            total:0,
        }
        //批量操作状态
        vm.batchState = false;
        //批量操作选中的条数
        vm.selectCount = 0;
        vm.loadPage = loadPage;
        vm.predicate = "id";
        vm.reverse = false;
        vm.transition = transition;
        vm.search = search;
        vm.loadAll = loadAll;
        vm.searchQuery = "";
        vm.catalogId = null;
        vm.selectedAll = false;
        vm.account = $localStorage.user;
        $scope.domains = Qinius.getDomain();
        vm.pictureArr=[];
        Catalog.getAll2({items:[{key:"type",op:"=",value:"SYSTEM"},{key:"catalogType",op:"=",value:"LAYOUT"},{key:"usable", op:"=", value:"true"}]}, function (res) {
            res.sort(function (a,b) {
                return a.seq - b.seq
            })
            vm.catalogs = res;
            if(res.length>0 && vm.catalogId == null){
                vm.catalogId = res[0].id;
            }
            loadAll();
        });
        //分类点击
        $scope.catalogClick = function (item) {
            if(item === null){
                vm.catalogId = null;
            }else{
                vm.catalogId = item.id;
            }

            vm.page = 1;
            vm.loadAll();
        }
        vm.currentChange = function(){
            $timeout(function(){
                vm.loadAll();
            })
        }
        function loadAll () {
            if (vm.account == undefined || vm.account == null) {
                $state.go('home');
                return;
            }
            var items = [{key:"opened", op:"=", value:'true'},{key:"status", op:"=", value:'Approved'}];
            if(vm.catalogId != null){
                items.push({key:"backCatalog.id", op:"=", value:vm.catalogId})
            }
            if(vm.searchQuery != null){
                items.push({key:"name", op:"like", value:vm.searchQuery})
            }
            PicLayoutXmls.byCondition2({
                    items:items,
                    page: vm.pageInfo.page - 1,
                    size: vm.pageInfo.size,
                    sort: ["lastModifiedDate,desc"]
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.totalItems = headers('X-Total-Count');
                vm.pageInfo.total = headers('X-Total-Count');
                vm.textList = data;
                vm.selectedAll = false;
                //退出批量编辑模式
                vm.pictureArr = [];
                vm.batchState = false;
            }
            function onError(error) {
                console.log(2);
                MessageService.error("布局获取失败");
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch,
                catalogId: vm.catalogId,
                selectedAll: vm.selectedAll,
            });
        }

        function search() {
            if(event.keyCode === 13){
                vm.pageInfo.page = 1;
                vm.predicate = 'id';
                if(vm.searchQuery == ""){
                    vm.reverse = false;
                }
                vm.loadAll();
            }

        }

        function jump () {
            vm.page = vm.jumpText<=0?1:vm.jumpText;
            loadPage(vm.page);
        }

        $scope.release = function (data) {
            PicLayoutXmls.onlyRelease({id: data.id}, function (res) {

            })
        }

        $scope.pictureSelect = function(item){
            if(!vm.batchState) return;
            item.selected = !item.selected;
            pictureSelectInfo();
            if(vm.pictureArr.length == vm.textList.length){
                vm.selectedAll = true;
            }else{
                vm.selectedAll = false;
            }
        }
        $scope.selectedAllClick = function () {
            vm.selectedAll = !vm.selectedAll;
            vm.textList.forEach(function (item) {
                item.selected = vm.selectedAll;
            })
            pictureSelectInfo();
            if(vm.pictureArr.length == vm.textList.length){
                vm.selectedAll = true;
            }else{
                vm.selectedAll = false;
            }
        }

        function pictureSelectInfo(){
            vm.pictureArr=[];
            vm.textList.forEach(function (item) {
                if(item.selected){
                    vm.pictureArr.push(item)
                }
            })
        }

        //查看
        $scope.look = function (data) {
            $uibModal.open({
                templateUrl: 'app/entities/text/modal/text-xml-look.html',
                controller: 'TextXmlLookController',
                controllerAs: 'vm',
                backdrop: 'static',
                resolve: {
                    entity: [function() {
                        return {
                            url: data.cover,
                            domain: $scope.domains.domain
                        };
                    }]
                }
            });
        }
        $scope.save = function(id){
            if(vm.pictureArr.length == 0 && !id){
                MessageService.error("请选择布局");
                return
            }
            $uibModal.open({
                templateUrl: 'app/entities/picture/picture-share-modal1.html',
                controller: 'PictureShareModal1Controller',
                controllerAs: 'vm',
                backdrop: 'static',
                resolve: {
                    entity: [function() {
                        // return vm.pictureArr;
                        return {
                            selectedAll: vm.selectedAll,
                            pictureArr: id ? [id] : vm.pictureArr,
                            backCatalogId: vm.catalogId,
                        };
                    }]
                }
            }).result.then(function(){
                //弹窗关闭
                vm.loadAll();
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('platformApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('picture', {
            parent: 'app',
            url: '/picture',
            data: {
                authorities: [],
                pageTitle: 'platformAppTitle.picture'
            },
            views: {
                'content': {
                    templateUrl: 'app/entities/picture/picture.html',
                    controller: 'PictureController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,desc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('fontManagement');
                    $translatePartialLoader.addPart('global');
                    $translatePartialLoader.addPart('title');
                    return $translate.refresh();
                }]
            }
        })
        .state('picture1', {
            parent: 'app',
            url: '/picture1/{id}',
            data: {
                authorities: [],
                pageTitle: 'platformApp.productXml.home.title'
            },
            views: {
                'content': {
                    templateUrl: 'app/entities/picture/picture.html',
                    controller: 'PictureController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,desc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('fontManagement');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
            .state('picture-xml', {
                url: '/picture-xml',
                data: {
                    authorities: [],
                    pageTitle: 'platformApp.productXml.home.title'
                },
                views: {
                    'navbar@': {
                        templateUrl: 'app/entities/picture/picture-xml.html',
                        controller: 'PictureXmlController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }],
                    entity: [function() {
                        return null;
                    }],
                }
            })
            .state('picture-xml-edit', {
                url: '/picture-xml-edit/{id}',
                data: {
                    authorities: [],
                    pageTitle: 'platformAppTitle.picture-xml-edit'
                },
                views: {
                    'navbar@': {
                        templateUrl: 'app/entities/picture/picture-xml.html',
                        controller: 'PictureXmlController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }],
                    entity: ['PicLayoutXmls','$stateParams', function(PicLayoutXmls,$stateParams) {
                        return PicLayoutXmls.get({id: $stateParams.id}).$promise;
                    }],
                }
            })
            .state('picture-share', {
                parent: 'app1',
                url: '/picture-share?page&sort&search&catalogId&selectedAll',
                data: {
                    authorities: [],
                    pageTitle: 'platformAppTitle.picture-share'
                },
                views: {
                    'content1': {
                        templateUrl: 'app/entities/picture/picture-share.html',
                        controller: 'PictureShareController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,desc',
                        squash: true
                    },
                    search: null,
                    catalogId: null,
                    selectedAll: null,
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search,
                            catalogId: $stateParams.catalogId,
                            selectedAll: $stateParams.selectedAll,
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('fontManagement');
                        $translatePartialLoader.addPart('global');
                        $translatePartialLoader.addPart('title');
                        return $translate.refresh();
                    }]
                }
            });
    }

})();

(function() {
    'use strict';
    angular
        .module('platformApp')
        .factory('PicLayoutXmls', PicLayoutXmls);
    PicLayoutXmls.$inject = ['$resource'];
    function PicLayoutXmls($resource) {
        var resourceUrl = 'bunny/' + 'api/pic-layout-xmls/:path/:id';

        return $resource(resourceUrl, {}, {
            "useAll":{
                method: 'GET',
                params:{
                    path:"useAll"
                },
            },
            "covert":{
                method: 'GET',
                params:{
                    path:"covert"
                },
            },
            "use":{
                method: 'GET',
                params:{
                    path:"use"
                },
            },
            "save": {
                method: 'POST'
            },
            "delete": {
                method: 'DELETE'
            },
            "batchDelete":{//批量删除
                method: 'POST',
                params:{
                    path:"batchDelete"
                }
            },
            "release": {
                method: 'POST',
                params:{
                    path:"release"
                },
            },
            "byCondition":{
                method:"POST",
                params:{
                    path:"byCondition"
                },
                isArray:true
            },
            "byCondition2":{
                method:"POST",
                params:{
                    path:"byCondition2"
                },
                isArray:true
            },
            "getAll":{
                method:"POST",
                params:{
                    path:"getAll"
                },
                isArray:true
            },
            "getAll2":{
                method:"POST",
                params:{
                    path:"getAll2"
                },
                isArray:true
            },
            "copy":{
                method:"GET",
                params:{
                    path:"copy"
                }
            },
            'get': {
                method: 'GET',
                transformResponse: function(data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': {
                method: 'PUT'
            },
            'onlyRelease': {
                method: 'GET',
                params:{
                    path:"onlyRelease"
                },
            },
            'share': {
                method: 'GET',
                params:{
                    path:"share"
                },
            },
            'batchShare': {//批量分享
                method: 'POST',
                params:{
                    path:"batchShare"
                }
            },
            'auditing': {
                method: 'GET',
                params:{
                    path:"auditing"
                },
            },
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('platformApp')
        .controller('PictureController', PictureController);

    PictureController.$inject = ['$state', '$scope', 'ProductXml', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams', 'MessageService', 'PicLayoutXmls', '$localStorage', 'Qinius', '$uibModal', '$stateParams','$timeout','Catalog'];

    function PictureController($state, $scope, ProductXml, ParseLinks, AlertService, paginationConstants, pagingParams, MessageService, PicLayoutXmls, $localStorage, Qinius, $uibModal, $stateParams,$timeout,Catalog) {
        var vm = this;
        //搜索防抖定时器
        vm.timer = null;
        //分页信息
        vm.pageInfo = {
            page: 1,
            size: 20,
            total: 0,
        }
        //批量操作状态
        vm.batchState = false;
        vm.statusList = [
            {label: '全部', value: '', op: '='},
            {label: '未分享', value: null, op: 'isnull'},
            {label: '审核中', value: 'Created', op: '='},
            {label: '已分享', value: 'Approved', op: '='},
            {label: '已驳回', value: 'Rejected', op: '='}
        ]
        //主题列表
        vm.catalogs = [];
        //选中的主题id
        vm.catalogSelected = null;
        vm.selectStatus = '';
        //选中的数量
        vm.selectCount = 0;
        vm.loadPage = loadPage;
        vm.predicate = "lastModifiedDate";
        vm.reverse = false;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.search = search;
        vm.loadAll = loadAll;
        vm.searchQuery = "";
        vm.jump = jump;
        vm.account = $localStorage.user;
        $scope.domains = Qinius.getDomain();
        vm.operations=['编辑','复制','删除','分享'];
        vm.catalogId = $stateParams.id;

        loadAll();

        //分页变更
        vm.currentChange = function () {
            $timeout(function () {
                vm.loadAll();
            })
        }
        vm.getCatalog = function () {
            Catalog.getAll({items:[{key:"usable",op:"=",value:"true"},{key:"catalogType",op:"=",value:"LAYOUT"}]}, function (data) {
                vm.catalogs = data;
                vm.catalogs.sort(function(a, b){
                    return a.seq - b.seq;
                })
                console.log(vm.catalogs,"ca")
            })
        }
        vm.getCatalog();
        function loadAll() {
            if (vm.account == undefined || vm.account == null) {
                $state.go('home');
                return;
            }
            var items = [];
            if(vm.catalogSelected){
                items.push({key: "catalog.id", op: "=", value: vm.catalogSelected})
            }
            var status = vm.statusList.find(function (item) {
                return item.value === vm.selectStatus;
            })
            if (status.value !== "") {
                items.push({key: 'status', value: status.value, op: status.op})
            }
            if (vm.searchQuery) {
                items.push({key: "name", value: vm.searchQuery, op: "like"});
            }
            PicLayoutXmls.byCondition({
                items:items,
                page: vm.pageInfo.page -1,
                size: vm.pageInfo.size,
                sort: ["lastModifiedDate,desc"]
            }, onSuccess, onError);
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.pageInfo.total = headers('X-Total-Count');
                vm.textList = data;
                //退出批量操作
                vm.batchState = false;
                vm.selectCount = 0;
            }
            function onError(error) {
                MessageService.error("照片布局列表获取失败");
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search() {
            if(event.keyCode != 13) return;
            vm.links = null;
            vm.pageInfo.page = 1;
            vm.loadAll();

        }

        function jump () {
            vm.page = vm.jumpText<=0?1:vm.jumpText;
            loadPage(vm.page);
        }
        //主题选择
        $scope.selectCatalog = function(e){
            if((e && e.id == vm.catalogSelected) || (!e && !vm.catalogSelected)) return;
            if(!e){
                vm.catalogSelected = null;
            }else{
                vm.catalogSelected = e.id
            }
            vm.pageInfo.page = 1;
            vm.loadAll();
        }
        //批量操作选择
        $scope.checkItem = function(item){
            if (!vm.batchState) {
                return
            }
            if(!item.selected){
                item.selected = true;
            }else{
                item.selected = false;
            }
            //获取选中的数量
            var selectList = vm.textList.filter(function (item) {
                return item.selected === true;
            })
            vm.selectCount = selectList.length;
        };
        //状态点击
        $scope.statusCheck = function (e) {
            if (e === vm.selectStatus) return;
            vm.selectStatus = e;
            vm.pageInfo.page = 1;
            vm.loadAll();
        }
        //查看
        $scope.look = function(item){
            console.log(item);
            $uibModal.open({
                templateUrl: 'app/entities/picture/modal/picture-preview.html',
                controller: 'PicturePreviewController',
                backdrop: 'static',
                keyboard: true,
                windowClass: "jh-modal-md",
                controllerAs: 'vm',
                resolve: {
                    entity: [function () {
                        return {
                            cover:item.cover
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        return $translate.refresh();
                    }]
                }
            });
        }
        //查看驳回原因
        $scope.showReason = function (item) {
            MessageService.confirm({
                title:'驳回理由',
                cancel:'取消',
                hideCancel:true,
                confirm:'知道了',
                msg:'理由： '+ (item.rejectReason || '') ,
            },function(){

            })
        }
        $scope.editorClassify = function(){
            $uibModal.open({
                templateUrl: 'app/entities/page/catalog-management.html',
                controller: 'CatalogManagementController',
                backdrop: 'static',
                keyboard: true,
                windowClass: "jh-modal-md",
                controllerAs: 'vm',
                resolve: {
                    entity: function () {
                        return {catalogType: "LAYOUT"}
                    }
                }
            }).result.then(function(res) {
                vm.getCatalog();
            },function(){
                vm.getCatalog();
            });
        }
        $scope.share = function (data) {
            var ids = [];
            if(data){
                ids = [data.id];
            }else{
                var selectList = vm.textList.filter(function (item) {
                    return item.selected === true;
                })
                if(selectList.length === 0) return MessageService.error("至少选择一条数据");
                ids = selectList.map(function (item) {
                    return item.id;
                });

            }
            $uibModal.open({
                templateUrl: 'app/entities/picture/picture-share-modal.html',
                controller: 'PictureShareModalController',
                backdrop: 'static',
                keyboard: true,
                windowClass: "jh-modal-md",
                controllerAs: 'vm',
                resolve: {
                    entity: [function () {
                        return ids;
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        return $translate.refresh();
                    }]
                }
            }).result.then(function() {
                vm.loadAll();
            });
        }
        $scope.delete = function (data) {
            MessageService.confirm({
                title:'提示',
                cancel:'取消',
                confirm:'确认',
                msg:'确定要删除该数据？'
            },function(){
                PicLayoutXmls.delete({id: data.id}, function (res) {
                    MessageService.success("删除成功");
                    vm.loadAll();
                })
            },function(){});
        }
        //批量删除
        $scope.batchDelete = function(){
            var selectList = vm.textList.filter(function (item) {
                return item.selected === true;
            })
            if(selectList.length === 0) return MessageService.error("至少选择一条数据");
            MessageService.confirm({
                title:'提示',
                cancel:'取消',
                confirm:'确认',
                msg:'确定要删除选中的数据？'
            },function() {
                var ids = selectList.map(function (item) {
                    return item.id;
                });
                PicLayoutXmls.batchDelete(ids,function(){
                    MessageService.success("删除成功");
                    vm.loadAll();
                })
            })

        }
        $scope.editXml = function (data) {
            $state.go('picture-xml-edit',{id: data.id});
        }
        $scope.copyXml = function (data) {
            PicLayoutXmls.copy({id: data.id}, function (res) {
                MessageService.success("复制成功");
                loadAll();
            })
        }
        //新增
        $scope.add = function () {
            $uibModal.open({
                templateUrl: 'app/entities/picture/modal/picture-add.html',
                controller: 'PictureAddController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'lg',
                resolve: {
                    entity: [function() {
                        return {
                        };
                    }]
                }
            });
        }

        $scope.editXmlTheme = function(item){
            $uibModal.open({
                templateUrl: 'app/entities/picture/modal/picture-edit.html',
                controller: 'PictureEditController',
                controllerAs: 'vm',
                backdrop: 'static',
                resolve: {
                    entity: item
                }
            }).result.then(function(backData) {
                if (backData) {
                    loadAll();
                }
            });
        }

        $scope.operation = function(item){
            var operationOldFlag = item.flag;
            vm.textList.forEach(function(li) {
                li.flag = false;
            });
            item.flag = !operationOldFlag;
        }
    }
})();

(function () {
    "use strict";

    angular
        .module("platformApp")
        .controller("PicturePreviewController", PicturePreviewController);

    PicturePreviewController.$inject = [
        "$timeout",
        "$scope",
        "$stateParams",
        "$uibModalInstance",
        "entity",
        "$state",
        "MessageService",
        "Catalog",
    ];

    function PicturePreviewController(
        $timeout,
        $scope,
        $stateParams,
        $uibModalInstance,
        entity,
        $state,
        MessageService,
        Catalog
    ) {
        var vm = this;
        vm.cover = entity.cover;
        //返回
        vm.cancel = function() {
            $uibModalInstance.close(false);
        };
    }
})();

(function() {
    'use strict';

    angular
        .module('platformApp')
        .controller('PictureEditController', PictureEditController);

        PictureEditController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', '$state', 'MessageService','Catalog','PicLayoutXmls'];

    function PictureEditController ($timeout, $scope, $stateParams, $uibModalInstance, entity, $state, MessageService,Catalog, PicLayoutXmls) {
        var vm = this;
        vm.save = save;
        vm.cancel = cancel;
        vm.data = entity;
        console.log(vm.data);
        Catalog.getAll({items:[{key:"usable",op:"=",value:"true"},{key:"catalogType",op:"=",value:"LAYOUT"}]}, function (data) {
            vm.catalogs = data;
        })
        //返回
        function cancel() {
            $uibModalInstance.close(false);
        }

        function save() {
            PicLayoutXmls.update(vm.data, function (res) {
                MessageService.success("保存成功");
                $uibModalInstance.close(true);
            })
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('platformApp')
        .controller('PictureAddController', PictureAddController);

    PictureAddController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', '$state', 'MessageService','Catalog'];

    function PictureAddController ($timeout, $scope, $stateParams, $uibModalInstance, entity, $state, MessageService,Catalog) {
        var vm = this;
        vm.save = save;
        vm.cancel = cancel;
        vm.units = [
            { name: 'px', id: 'px'},
            { name: 'mm', id: 'mm'}
        ];
        vm.data = {
            name: '',
            width: '',
            height: '',
            unit: 'mm'
        }
        Catalog.getAll({items:[{key:"usable",op:"=",value:"true"},{key:"catalogType",op:"=",value:"LAYOUT"}]}, function (data) {
            vm.catalogs = data;
        })
        //返回
        function cancel() {
            $uibModalInstance.close();
        }

        function save() {
            var reg = /^\d+(?=\.{0,1}\d+$|$)/
            if(isNaN(vm.data.width) || Number(vm.data.width) < 1){
                MessageService.error("宽度必须输入正数");
                return
            }
            if(isNaN(vm.data.height) || Number(vm.data.height) < 1){
                MessageService.error("高度必须输入正数");
                return
            }
            if(!vm.data.catalogId){
                MessageService.error("主题不能为空");
                return
            }

            var _data = angular.copy(vm.data);
            if (_data.unit == 'px'){
                // _data.width = (_data.width/25.4 * vm.windowDpiW).toFixed(2);
                // _data.height = (_data.height/25.4 * vm.windowDpiH).toFixed(2);
                _data.width = (_data.width/vm.windowDpiW * 25.4).toFixed(2);
                _data.height = (_data.height/vm.windowDpiH * 25.4).toFixed(2);
            }
            _data.unit = 'mm';
            localStorage.setItem("picturePage",JSON.stringify(_data));
            $state.go('picture-xml');
            $uibModalInstance.close();
        }

        //单位换算
        $scope.unitCb = function(){
            console.log(vm.data.unit)
            if(vm.data.unit == 'mm'){
                vm.data.width = (vm.data.width/vm.windowDpiW*25.4).toFixed(0);
                vm.data.height = (vm.data.height/vm.windowDpiH*25.4).toFixed(0);
            }
            if (vm.data.unit == 'px'){
                vm.data.width = (vm.data.width/25.4 * vm.windowDpiW).toFixed(2);
                vm.data.height = (vm.data.height/25.4 * vm.windowDpiH).toFixed(2);
            }
        }

        //获取dpi
        js_getDPI()
        function js_getDPI() {
            var arrDPI = new Array();
            if (window.screen.deviceXDPI != undefined) {
                arrDPI[0] = window.screen.deviceXDPI;
                arrDPI[1] = window.screen.deviceYDPI;
            }
            else {
                var tmpNode = document.createElement("DIV");
                tmpNode.style.cssText = "width:1in;height:1in;position:absolute;left:0px;top:0px;z-index:99;visibility:hidden";
                document.body.appendChild(tmpNode);
                arrDPI[0] = parseInt(tmpNode.offsetWidth);
                arrDPI[1] = parseInt(tmpNode.offsetHeight);
                tmpNode.parentNode.removeChild(tmpNode);
            }
            vm.windowDpiW = arrDPI[0];
            vm.windowDpiH = arrDPI[1];
            return arrDPI;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('platformApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('patterns', {
            parent: 'app',
            url: '/patterns?page&sort&search&modelType',
            data: {
                authorities: [],
                pageTitle: 'platformAppTitle.patterns'
            },
            views: {
                'content': {
                    templateUrl: 'app/entities/patterns/patterns.html',
                    controller: 'PatternsController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search,
                        modelType:$stateParams.modelType,
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('productXml');
                    $translatePartialLoader.addPart('reprintType');
                    $translatePartialLoader.addPart('frontStatus');
                    $translatePartialLoader.addPart('patternType');
                    $translatePartialLoader.addPart('global');
                    $translatePartialLoader.addPart('title');
                    return $translate.refresh();
                }]
            }
        })
         ;
    }

})();

(function() {
    'use strict';
    angular
        .module('platformApp')
        .factory('Moulds', Moulds);

    Moulds.$inject = ['$resource'];

    function Moulds ($resource) {
        var resourceUrl =  'bunny/' + 'api/moulds/:path/:id';

        return $resource(resourceUrl, {}, {
            "save": {
                method: 'POST'
            },
            "get": {
                method: 'GET'
            },
            "update": {
                method: 'PUT'
            },
            "delete": {
                method: 'DELETE'
            },
            "batchDelete": {
                method: 'POST',
                params:{
                    path:"batchDelete"
                },
            },
            "getAllUsable": {
                method: 'GET',
                params:{
                    path:"getAllUsable"
                },
                isArray:true
            },
            "getAllByCondition": {
                method: 'POST',
                params:{
                    path:"getAllByCondition"
                },
                isArray:true
            },
            "getAllByCondition2": {
                method: 'POST',
                params:{
                    path:"getAllByCondition2"
                },
                isArray:true
            },
            "byCondition": {
                method: 'POST',
                params:{
                    path:"byCondition"
                },
                isArray:true
            },
            "byCondition2": {
                method: 'POST',
                params:{
                    path:"byCondition2"
                },
                isArray:true
            },
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('platformApp')
        .controller('PatternsController', PatternsController);

    PatternsController.$inject = ['$scope', '$state', 'Moulds', 'ParseLinks', 'AlertService', 'paginationConstants',
     'pagingParams', 'MessageService', 'Qinius', '$uibModal','$timeout'];

    function PatternsController ($scope, $state, Moulds, ParseLinks, AlertService, paginationConstants,
     pagingParams, MessageService, Qinius, $uibModal,$timeout) {
        var vm = this;
        vm.oldView = false;
        //搜索防抖定时器
        vm.timer = null;
        //分页信息
        vm.pageInfo = {
            page: 1,
            size: 20,
            total: 0,
        }
        //批量操作状态
        vm.batchState = false;
        //选中的数量
        vm.selectCount = 0;
        vm.loadPage = loadPage;
        vm.predicate = "lastModifiedDate";
        vm.reverse = false;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.search = search;
        vm.loadAll = loadAll;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;
        vm.jump = jump;
        vm.status = status;
        $scope.domains = Qinius.getDomain();
        vm.modelTypeList=[
            {name:'2D模型', value:'TWO'},
            {name:'3D模型', value:'THREE'},
        ];
        vm.modelType = pagingParams.modelType || 'TWO';

        loadAll();

        //分页变更
        vm.currentChange = function () {
            $timeout(function () {
                vm.loadAll();
            })
        }
        //批量操作选择
        $scope.checkItem = function(item){
            if (!vm.batchState) {
                return
            }
            if(!item.selected){
                item.selected = true;
            }else{
                item.selected = false;
            }
            //获取选中的数量
            var selectList = vm.data.filter(function (item) {
                return item.selected === true;
            })
            vm.selectCount = selectList.length;
        };
        function loadAll () {
            var items = [{key: "cancelled", op: "=", value: 'false'},{key:"sourceType", op:"=", value:'front'}];
            if (vm.searchQuery) {
                items.push({key: "name", op: "like", value: vm.searchQuery});
            }

            if (vm.modelType == 'THREE') {
                items.push({key: "modelType", op: "=", value: vm.modelType});
            }
            if (vm.modelType == 'TWO') {
                items.push({key: "modelType", op: "=", value: "TWO"});
            }
            vm.data = [];
            Moulds.byCondition2({
                items: items,
                page: vm.pageInfo.page - 1,
                size: vm.pageInfo.size,
                sort: ["lastModifiedDate,desc"]
            }, onSuccess, onError);
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.pageInfo.total = headers('X-Total-Count');
                vm.data = data;
                //退出批量编辑
                vm.batchState = false;
                vm.selectCount = 0;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }
        $scope.modelTypeTab = function (item) {
            vm.modelType = item.value;
            vm.page = 1;
            loadAll();
        }
        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch,
                modelType: vm.modelType
            });
        }

        function search() {
            if(event.keyCode === 13){
                vm.links = null;
                vm.pageInfo.page = 1;
                vm.loadAll();
            }
        }

        function jump () {
            vm.page = vm.jumpText<=0?1:vm.jumpText;
            loadPage(vm.page);
        }

        //新建
        $scope.add = function (type) {
            if(type == 'TWO'){
                $uibModal.open({
                    templateUrl: 'app/entities/patterns/modal/patterns-modal.html',
                    controller: 'PatternsModalController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: [function() {
                            return {
                                type: 'add',
                                id: ''
                            };
                        }]
                    }
                }).result.then(function(data) {
                    if(data){
                        loadAll();
                    }
                });
            }
            if(type == 'THREE'){
                $uibModal.open({
                    templateUrl: 'app/entities/patterns/modal/patterns-modal-three.html',
                    controller: 'PatternsModalThreeController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: [function() {
                            return {
                                type: 'add',
                                id: ''
                            };
                        }]
                    }
                }).result.then(function(data) {
                    if(data){
                        loadAll();
                    }
                });
            }
        };
        //编辑产品
        $scope.edit = function (item) {
            if(vm.modelType == 'TWO'){
                $uibModal.open({
                    templateUrl: 'app/entities/patterns/modal/patterns-modal.html',
                    controller: 'PatternsModalController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: [function() {
                            return {
                                type: 'edit',
                                id: item
                            };
                        }]
                    }
                }).result.then(function(data) {
                    if(data){
                        loadAll();
                    }
                });
            }
            if(vm.modelType == 'THREE'){
                $uibModal.open({
                    templateUrl: 'app/entities/patterns/modal/patterns-modal-three.html',
                    controller: 'PatternsModalThreeController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: [function() {
                            return {
                                type: 'edit',
                                id: item
                            };
                        }]
                    }
                }).result.then(function(data) {
                    if(data){
                        loadAll();
                    }
                });
            }
        };

        $scope.look = function (item) {
            var data = {
                id:item.id,
            }
            if(vm.modelType == 'TWO'){
                data.modelType = 'TWO';
                data.modelPic = $scope.domains.domain + item.modelPic
            }
            if(vm.modelType == 'THREE'){
                data.modelType = 'THREE';
                data.modelPath = item.modelPath;
                data.modelData = JSON.parse(item.modelData)
            }
            console.log(data,'sss');
            $uibModal.open({
                templateUrl: 'app/entities/patterns/modal/patterns-preview.html',
                controller: 'PatternsPreviewController',
                controllerAs: 'vm',
                backdrop: 'static',
                resolve: {
                    entity: [function() {
                        return data
                    }]
                }
            });
        }
        $scope.batchDelete = function(){
            //获取选中的
            var selectList = vm.data.filter(function (item) {
                return item.selected === true;
            });
            if(selectList.length == 0) return MessageService.error("至少选择一条数据");
             var ids = selectList.map(function (item) {
                return item.id;
            });
            MessageService.confirm({
                title:'提示',
                cancel:'取消',
                confirm:'确认',
                msg:'确认要删除选中的模型？'
            },function(){
                Moulds.batchDelete(ids,function(){
                    MessageService.success("删除成功");
                    vm.loadAll();
                },function(){
                    MessageService.error("网络异常，请重试");
                    vm.batchDeleteLoading = false;
                })
            })
        }
        $scope.delete = function(id){
            MessageService.confirm({
                title:'提示',
                cancel:'取消',
                confirm:'确认',
                msg:'确认要删除该模型？'
            },function(){
                Moulds.delete({id:id},function(data){
                    MessageService.success("删除成功");
                    loadAll();
                },function(){
                    MessageService.error("删除失败");
                })
            })
        };
    }
})();

(function () {
    "use strict";

    angular
        .module("platformApp")
        .controller("PatternsPreviewController", PatternsPreviewController);

    PatternsPreviewController.$inject = [
        "$timeout",
        "$scope",
        "UidService",
        "$stateParams",
        "$uibModalInstance",
        "entity",
        "$state",
        "Moulds",
        "MessageService",
        "Qinius",
        "$uibModal",
    ];

    function PatternsPreviewController(
        $timeout,
        $scope,
        UidService,
        $stateParams,
        $uibModalInstance,
        entity,
        $state,
        Moulds,
        MessageService,
        Qinius,
        $uibModal
    ) {
        var vm = this;
        vm.modelPic = entity.modelPic;
        vm.modelType = entity.modelType;
        vm.modelPath = entity.modelPath;
        vm.modelData = entity.modelData;
        //返回
        vm.cancel = function(){
            $uibModalInstance.close(false);
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('platformApp')
        .controller('PatternsModalThreeController', PatternsModalThreeController);

    PatternsModalThreeController.$inject = ['$timeout', '$scope', 'UidService', '$stateParams', '$uibModalInstance', 'entity', '$state', 'Moulds', 'MessageService', 'Qinius','$q'];

    function PatternsModalThreeController ($timeout, $scope, UidService, $stateParams, $uibModalInstance, entity, $state, Moulds, MessageService, Qinius,$q) {
        var vm = this;
        vm.oldView = false;
        vm.cancel = cancel;
        vm.save = save;
        vm.type = entity.type;
        vm.id = entity.id;
        vm.openedCheck = openedCheck;
        $scope.domains = Qinius.getDomain();
        vm.tokens = Qinius.get();
        vm.modelData = [];
        vm.units = [
            {name:'px', id:'px'},
            {name:'mm', id:'mm'},
        ]
        if(vm.type == 'add'){
            vm.data = {
                name: '',
                gWidth: '',
                gHeight: '',
                sizeUnit: 'mm',
                x: '',
                y: '',
                width: '',
                height: '',
                modelPic: '',
                hierarchy: 'BOTTOM',
                modelType:'THREE',
                modelData:[],
                modelPath:""
            }
        }else {
            Moulds.get({id: vm.id},function (res) {
                vm.data = res;
                if(vm.data.modelData){
                    vm.modelData = JSON.parse(vm.data.modelData);
                }
            })
        }
        //模型图片
        window.uploadPic = function ($event) {
            var files = $event.target.files;
            if (files != null && files.length > 0) {
                qiniuUpload(files[0]);
            }
        }
        function qiniuUpload(file) {
            var formData = new FormData();
            formData.append('file', file);
            formData.append('unique_names', false);
            formData.append('key', 'pic-' + UidService.get());
            formData.append('token', vm.tokens.token);
            $.ajax({
                cache: true,
                type: "POST",
                url: 'https://upload.qiniup.com/',
                data: formData,
                async: true,
                contentType: false,
                processData: false,
                success: function (data) {
                    vm.data.modelPic = data.key;
                    $scope.$apply();
                },
                error: function (request) {
                    MessageService.error("图片上传失败");
                }
            });
        }
        $scope.removeFile = function () {
            vm.data.modelPic = "";
        }

        //层级
        function openedCheck(item) {
            vm.data.hierarchy = item ? 'TOP' : 'BOTTOM';
            console.log(vm.data.hierarchy)
        }

        function checkFloatNum(str){
            var reg_zs = /^[0-9]\d*(\.\d+)?$/i;
            if (!reg_zs.test(str)) {
                return false;
            }
            return true;
        }
        //保存
        function save() {
            vm.data.modelData = JSON.stringify(vm.modelData);
            vm.data.modelType = 'THREE';
            if(vm.data.name.length > 20 || vm.data.name.length < 1){
                MessageService.error("模型名称不能为空且不大于20个字符");
                return
            }
            if(!vm.data.modelPic){
                MessageService.error("请上传模型图片");
                return
            }
            if(!vm.data.modelPath){
                MessageService.error("请上传3D模型");
                return
            }
            vm.data.sourceType = 'front';
            if(vm.type == 'add'){
                Moulds.save(vm.data, function (res) {
                    MessageService.success("新增成功");
                    $uibModalInstance.close(true);
                },function (error) {
                    MessageService.error("保存失败，请稍后重试！");
                })
            }
            if(vm.type == 'edit'){
                Moulds.update(vm.data, function (res) {
                    MessageService.success("编辑成功");
                    $uibModalInstance.close(true);
                },function (error) {
                    MessageService.error("保存失败，请稍后重试！");
                })
            }
        }
        //返回
        function cancel() {
            $uibModalInstance.close(false);
        }
        //dpi
        js_getDPI()
        function js_getDPI() {
            var arrDPI = new Array();
            if (window.screen.deviceXDPI != undefined) {
                arrDPI[0] = window.screen.deviceXDPI;
                arrDPI[1] = window.screen.deviceYDPI;
            }
            else {
                var tmpNode = document.createElement("DIV");
                tmpNode.style.cssText = "width:1in;height:1in;position:absolute;left:0px;top:0px;z-index:99;visibility:hidden";
                document.body.appendChild(tmpNode);
                arrDPI[0] = parseInt(tmpNode.offsetWidth);
                arrDPI[1] = parseInt(tmpNode.offsetHeight);
                tmpNode.parentNode.removeChild(tmpNode);
            }
            vm.windowDpi = arrDPI[0];
            return arrDPI;
        }


        //上传3D模型
        window.uploadPic1 = function ($event) {
            var files = $event.target.files;
            if (files != null && files.length > 0) {
                qiniuUpload1(files[0]);
            }
        }

        function qiniuUpload1(file) {
            var formData = new FormData();
            formData.append('file', file);
            formData.append('unique_names', false);
            formData.append('key', 'pic-' + UidService.get());
            formData.append('token', vm.tokens.token);
            $.ajax({
                cache: true,
                type: "POST",
                url: 'https://upload.qiniup.com/',
                data: formData,
                async: true,
                contentType: false,
                processData: false,
                success: function (data) {
                    vm.data.modeTFileName = file.name;
                    vm.data.modelPath = $scope.domains.domain + data.key;
                    gltfInfo(vm.data.modelPath)
                    $scope.$apply();
                },
                error: function (request) {
                    MessageService.error("图片上传失败");
                }
            });
        };

        function gltfInfo(path) {
            // 加载glTF格式的模型
            vm.modelData = [];
            vm.materialMap = [];
            var loader = new THREE.GLTFLoader();
            if (THREE.DRACOLoader) {
                var dracoLoader = new THREE.DRACOLoader();
                if (dracoLoader) {
                    loader.setDRACOLoader( dracoLoader );
                }
            }
            vm.modelLoad = true;
            loader.load(path, function (gltf) {
                gltf.scene.traverse(function(child){
                    if (child.isMesh) {
                        traverseMaterials(child, function(node,i){
                            if(vm.materialMap.indexOf(node.name) == -1){
                                var _modelData = {
                                    materialName:node.name,
                                    page:''
                                };
                                vm.modelData.push(_modelData);
                                vm.materialMap.push(node.name);
                            }
                        });
                    }
                });
                vm.modelLoad = false;
                $scope.$apply();
            }, function (xhr) {
                vm.schedule = (xhr.loaded / xhr.total * 100);
            }, function (error) {
                MessageService.error("3D模型上传失败，请稍后重试！")
                vm.modelLoad = false;
            })
        }

        function traverseMaterials(object, callback) {
            object.traverse(function(node){
                if (!node.isMesh) return;
                var materials = Array.isArray(node.material)
                    ? node.material
                    : [node.material];
                materials.forEach(callback);
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('platformApp')
        .controller('PatternsModalController', PatternsModalController);

    PatternsModalController.$inject = ['$timeout', '$scope', 'UidService', '$stateParams', '$uibModalInstance', 'entity', '$state', 'Moulds', 'MessageService', 'Qinius','$uibModal'];

    function PatternsModalController ($timeout, $scope, UidService, $stateParams, $uibModalInstance, entity, $state, Moulds, MessageService, Qinius,$uibModal) {
        var vm = this;
        vm.oldView = false;

        vm.cancel = cancel;
        vm.save = save;
        vm.type = entity.type;
        vm.id = entity.id;
        vm.openedCheck = openedCheck;
        $scope.domains = Qinius.getDomain();
        vm.tokens = Qinius.get();
        vm.units = [
            {name:'px', id:'px'},
            {name:'mm', id:'mm'},
        ]
        if(vm.type == 'add'){
            vm.data = {
                name: '',
                gWidth: '',
                gHeight: '',
                sizeUnit: 'mm',
                x: '',
                y: '',
                width: '',
                height: '',
                modelPic: '',
                hierarchy: 'BOTTOM',
                modelType:'TWO'
            }
        }else {
            Moulds.get({id: vm.id},function (res) {
                vm.data = res;
            })
        }

        var bigSizePics = [] ;
        //模型图片
        window.uploadPic = function ($event) {
            var files = $event.target.files;
            bigSizePics = [];
            if (files != null && files.length > 0) {
                var file = files[0];
                if (file.size >= 20 * 1024 * 1024){
                    file.imageSize = Math.ceil(file.size / 1024 / 1024);
                    bigSizePics.push(file);
                }else {
                    qiniuUpload(file);
                }
            }
            if (bigSizePics.length > 0) {
                thumbnailatorPic();
            }
            $event.srcElement.value = ""
        }
        function qiniuUpload(file) {
            var formData = new FormData();
            formData.append('file', file);
            formData.append('unique_names', false);
            formData.append('key', 'pic-' + UidService.get());
            formData.append('token', vm.tokens.token);
            $.ajax({
                cache: true,
                type: "POST",
                url: 'https://upload.qiniup.com/',
                data: formData,
                async: true,
                contentType: false,
                processData: false,
                success: function (data) {
                    vm.data.modelPic = data.key;
                    $scope.$apply();
                },
                error: function (request) {
                    MessageService.error("图片上传失败");
                }
            });
        }
        $scope.removeFile = function () {
            vm.data.modelPic = "";
        }

        //层级
        function openedCheck(item) {
            vm.data.hierarchy = item ? 'TOP' : 'BOTTOM';
            console.log(vm.data.hierarchy)
        }

        function checkFloatNum(str){
            var reg_zs = /^[0-9]\d*(\.\d+)?$/i;
            if (!reg_zs.test(str)) {
                return false;
            }
            return true;
        }
        //保存
        function save() {
            if(vm.data.sizeUnit == 'px'){
                vm.data.sizeUnit = 'mm';
                unit(vm.data.sizeUnit);
            }
            if(vm.data.name.length > 20 || vm.data.name.length < 1){
                MessageService.error("模型名称不能为空且不大于20个字符");
                return
            }
            if(!checkFloatNum(vm.data.gWidth) || !checkFloatNum(vm.data.gHeight)){
                MessageService.error("请输入有效的模型尺寸");
                return
            }
            if(!checkFloatNum(vm.data.x) || !checkFloatNum(vm.data.y) || !checkFloatNum(vm.data.width) || !checkFloatNum(vm.data.height)){
                MessageService.error("请输入有效的定制区域值");
                return
            }
            if(!vm.data.modelPic){
                MessageService.error("请上传模型图片");
                return
            }
            if(vm.data.sizeUnit == 'px'){
                unit('mm')
                vm.data.sizeUnit = 'mm';
            }
            vm.data.sourceType = 'front';
            if(vm.type == 'add'){
                Moulds.save(vm.data, function (res) {
                    MessageService.success("新增成功");
                    $uibModalInstance.close(true);
                },function (error) {
                    MessageService.error("保存失败，请稍后重试！");
                })
            }
            if(vm.type == 'edit'){
                Moulds.update(vm.data, function (res) {
                    MessageService.success("编辑成功");
                    $uibModalInstance.close(true);
                },function (error) {
                    MessageService.error("保存失败，请稍后重试！");
                })
            }
        }
        //返回
        function cancel() {
            $uibModalInstance.close(false);
        }
        //dpi
        js_getDPI()
        function js_getDPI() {
            var arrDPI = new Array();
            if (window.screen.deviceXDPI != undefined) {
                arrDPI[0] = window.screen.deviceXDPI;
                arrDPI[1] = window.screen.deviceYDPI;
            }
            else {
                var tmpNode = document.createElement("DIV");
                tmpNode.style.cssText = "width:1in;height:1in;position:absolute;left:0px;top:0px;z-index:99;visibility:hidden";
                document.body.appendChild(tmpNode);
                arrDPI[0] = parseInt(tmpNode.offsetWidth);
                arrDPI[1] = parseInt(tmpNode.offsetHeight);
                tmpNode.parentNode.removeChild(tmpNode);
            }
            vm.windowDpi = arrDPI[0];
            return arrDPI;
        }

        //单位换算
        $scope.unitConversion = function () {
            unit(vm.data.sizeUnit)
        }
        function unit(item){
            if(item == 'mm'){
                vm.data.gWidth = (vm.data.gWidth/vm.windowDpi*25.4).toFixed(2);
                vm.data.gHeight = (vm.data.gHeight/vm.windowDpi*25.4).toFixed(2);
                vm.data.x = (vm.data.x/vm.windowDpi*25.4).toFixed(2);
                vm.data.y = (vm.data.y/vm.windowDpi*25.4).toFixed(2);
                vm.data.width = (vm.data.width/vm.windowDpi*25.4).toFixed(2);
                vm.data.height = (vm.data.height/vm.windowDpi*25.4).toFixed(2);
            }
            if (item == 'px'){
                vm.data.gWidth = (vm.data.gWidth/25.4 * vm.windowDpi).toFixed(2);
                vm.data.gHeight = (vm.data.gHeight/25.4 * vm.windowDpi).toFixed(2);
                vm.data.x = (vm.data.x/25.4 * vm.windowDpi).toFixed(2);
                vm.data.y = (vm.data.y/25.4 * vm.windowDpi).toFixed(2);
                vm.data.width = (vm.data.width/25.4 * vm.windowDpi).toFixed(2);
                vm.data.height = (vm.data.height/25.4 * vm.windowDpi).toFixed(2);
            }
        }

        function thumbnailatorPic(){
            $uibModal.open({
                templateUrl: 'app/entities/page/thumbnailator.html',
                controller: 'ThumbnailatorController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'md',
                resolve: {
                    entity: [function() {
                        return {
                            files: bigSizePics
                        };
                    }]
                }
            }).result.then(function (values) {
                bigSizePics = [];
                if (values) {
                    //for (var j = 0; j < values.length; j++) {

                    //var data = {key: value.key};
                    var value = values[0];
                    qiniuUpload(value);
                    //}
                }
            }, function () {
            });false
        }

    }
})();

(function () {
    "use strict";

    angular
        .module("platformApp")
        .controller("XmlCenterController", XmlCenterController)
        .directive("errSrc", function () {
            return {
                link: function (scope, element, attrs) {
                    element.bind("error", function () {
                        if (attrs.src != attrs.errSrc) {
                            attrs.$set("src", attrs.errSrc);
                        }
                    });
                }
            };
        });

    XmlCenterController.$inject = [
        "$state",
        "$scope",
        "Qinius",
        "$uibModal",
        "$http",
        "$q",
        "pagingParams",
        "paginationConstants",
        "$timeout",
        "$stateParams",
        "MessageService",
        "ProductXml",
        "Catalog",
        "Hashtag",
        "ParseLinks",
        "$localStorage",
        "Account",
        "ProductXmlPurchase",
        "$window"
    ];

    function XmlCenterController(
        $state,
        $scope,
        Qinius,
        $uibModal,
        $http,
        $q,
        pagingParams,
        paginationConstants,
        $timeout,
        $stateParams,
        MessageService,
        ProductXml,
        Catalog,
        Hashtag,
        ParseLinks,
        $localStorage,
        Account,
        ProductXmlPurchase,
        $window
    ) {
        var vm = this;
        $(".sidebar1").hide();
        $(".navbar").show();
        $(".nav-bg").show();
        $(".wrap").css({ margin: 0 });
        //分类
        vm.catalogList = [
            { id: null, name: "全部", active: true },
            { id: null, name: "热门模板", active: false }
        ];
        //模板
        vm.hashtagList = [{ id: null, name: "全部", active: true }];
        //选中的产品分类索引
        vm.productActive = 0;
        //产品列表
        vm.productList = [
            { label: "全部", value: null },
            { label: "照片书", value: "BOOK" },
            { label: "冲印", value: "PHOTO" },
            { label: "台历", value: "CALENDAR" },
            { label: "万物", value: "THING" }
        ];
        //排序
        vm.sortList = [
            { label: "最新上传", value: "shareDate" },
            { label: "最多使用", value: "usedCount" }
        ];
        //价格筛选列
        vm.priceList = [
            { label: "全部", value: null },
            { label: "免费", value: "=" },
            { label: "付费", value: ">" }
        ];
        //搜索框输入定时器
        vm.timer = null;
        //标签筛选项是否展开
        vm.tagScreenIsOpen = false;
        //分页信息
        vm.pageInfo = {
            page: 1,
            size: 20,
            total: 0
        };
        vm.user = $localStorage.user;
        if (vm.user == null) {
            Account.get(
                {},
                function (data) {
                    if (data.status == 200) {
                        vm.user = data.data;
                    }
                },
                function () {}
            );
        }

        vm.search = search;
        vm.loadPage = loadPage;
        vm.predicate = "shareDate";
        vm.reverse = false;
        vm.transition = transition;
        vm.searchQuery = "";
        vm.currentSearch = pagingParams.search;
        vm.jump = jump;
        $scope.catalogSelected = null;
        $scope.tagSelected = null;
        $scope.productSelected = null;
        $scope.priceSelected = null;
        //分类选择
        $scope.selectCatalog = function (catalog) {
            if (catalog.active) return;
            vm.pageInfo.page = 1;
            angular.forEach(vm.catalogList, function (item) {
                item.active = false;
                if (catalog.name === item.name) {
                    item.active = true;
                    if (catalog.name === "全部") {
                        $scope.catalogSelected = null;
                    } else if (catalog.name === "热门模板") {
                        $scope.catalogSelected = catalog.name;
                    } else {
                        $scope.catalogSelected = catalog;
                    }
                }
            });
            $scope.getXmlByCondition();
        };
        //标签选择
        $scope.selectTag = function (tag) {
            if (tag.active) return;
            vm.pageInfo.page = 1;
            angular.forEach(vm.hashtagList, function (item) {
                item.active = false;
                if (item.name === tag.name) {
                    item.active = true;
                    if (item.name === "全部") {
                        $scope.tagSelected = item.name;
                    } else {
                        $scope.tagSelected = tag;
                    }
                }
            });
            $scope.getXmlByCondition();
        };
        //产品选择
        $scope.selectProduct = function (index) {
            if (vm.productActive === index) return;
            vm.productActive = index;
            $scope.productSelected = vm.productList[index].value;
            vm.pageInfo.page = 1;
            $scope.getXmlByCondition();
        };
        //获取产品名称
        $scope.getProductName = function (type) {
            if (!type) return;
            var productItem = vm.productList.find(function (item) {
                return item.value === type;
            });
            if (productItem) {
                return productItem.label;
            }
            return "";
        };
        //排序选择
        $scope.selectSort = function (sort) {
            if (vm.predicate === sort) return;
            vm.predicate = sort;
            vm.pageInfo.page = 1;
            $scope.getXmlByCondition();
        };
        //价格筛选点
        $scope.selectPrice = function (e) {
            if ($scope.priceSelected === e) return;
            $scope.priceSelected = e;
            vm.pageInfo.page = 1;
            $scope.getXmlByCondition();
        };
        //判断模板是否可以使用或者需要购买
        $scope.canUse = function (template) {
            if (
                template.price == null ||
                template.price == 0 ||
                vm.user.id == template.userId ||
                template.purchased
            ) {
                return true;
            }
            return false;
        };

        $scope.buyXml = function (item) {
            createModal3(
                "app/entities/page/buy-product-xml.html",
                "BuyProductXMLController",
                item
            ).result.then(function (data) {
                //刷新列表
                $scope.getXmlByCondition();
                //$window.location.reload()
            });
        };
        //更改展开收起状态
        $scope.changeMoreState = function (key) {
            vm[key] = !vm[key];
        };
        var createModal3 = function (url, controller, item) {
            return $uibModal.open({
                templateUrl: url,
                controller: controller,
                backdrop: "static",
                keyboard: true,
                windowClass: "jh-modal-md",
                controllerAs: "vm",
                resolve: {
                    item: function () {
                        return item;
                    },
                    pagingParams: [
                        "$stateParams",
                        "PaginationUtil",
                        function ($stateParams, PaginationUtil) {
                            return {
                                page: PaginationUtil.parsePage(
                                    $stateParams.page
                                )
                            };
                        }
                    ],
                    translatePartialLoader: [
                        "$translate",
                        "$translatePartialLoader",
                        function ($translate, $translatePartialLoader) {
                            $translatePartialLoader.addPart("page");
                            return $translate.refresh();
                        }
                    ]
                }
            });
        };

        $scope.previewTemplate = function (template) {
            if (template.version != "4.0") {
                MessageService.error("当前模板不可用");
                return;
            }
            ProductXml.get({ id: template.id }, function (data) {
                createModal2(
                    "app/entities/page/template-view.html",
                    "TemplateViewController",
                    data.id
                ).result.then(function (data) {});
            });
            $(".modal-content").hide();
        };

        var createModal2 = function (url, controller, id) {
            return $uibModal.open({
                templateUrl: url,
                controller: controller,
                backdrop: "static",
                keyboard: true,
                windowClass: "jh-modal-md",
                controllerAs: "vm",
                resolve: {
                    entity: [
                        "ProductXml",
                        "$stateParams",
                        function (ProductXml, $stateParams) {
                            return ProductXml.get({ id: id }).$promise;
                        }
                    ],
                    translatePartialLoader: [
                        "$translate",
                        "$translatePartialLoader",
                        function ($translate, $translatePartialLoader) {
                            $translatePartialLoader.addPart("product");
                            $translatePartialLoader.addPart("productType");
                            return $translate.refresh();
                        }
                    ]
                }
            });
        };
        $scope.gotoCreate = function (item) {
            createModal(
                "app/entities/page/page-create.html",
                "PageCreateController",
                item
            ).result.then(function (data) {});
        };
        var createModal = function (url, controller, item) {
            return $uibModal.open({
                templateUrl: url,
                controller: controller,
                backdrop: "static",
                keyboard: true,
                windowClass: "jh-modal-md",
                controllerAs: "vm",
                resolve: {
                    items: function () {
                        return item;
                    },
                    pagingParams: [
                        "$stateParams",
                        "PaginationUtil",
                        function ($stateParams, PaginationUtil) {
                            return {
                                page: PaginationUtil.parsePage(
                                    $stateParams.page
                                )
                            };
                        }
                    ],
                    translatePartialLoader: [
                        "$translate",
                        "$translatePartialLoader",
                        function ($translate, $translatePartialLoader) {
                            $translatePartialLoader.addPart("page");
                            return $translate.refresh();
                        }
                    ]
                }
            });
        };
        //当前页变更
        vm.currentChange = function () {
            $timeout(function () {
                $scope.getXmlByCondition();
            });
        };

        $scope.getXmlByCondition = function () {
            var items = [
                { key: "status", op: "=", value: "Approved" },
                { key: "opened", op: "=", value: "true" }
            ];
            if (
                $scope.catalogSelected != null &&
                $scope.catalogSelected != "热门模板"
            ) {
                items.push({
                    key: "backCatalog.id",
                    op: "=",
                    value: $scope.catalogSelected.id
                });
            } else if (
                $scope.catalogSelected != null &&
                $scope.catalogSelected == "热门模板"
            ) {
                items.push({ key: "hotspot", op: "=", value: "true" });
            }
            if ($scope.tagSelected != null && $scope.tagSelected != "全部") {
                items.push({
                    key: "hashtags",
                    op: "like",
                    value: $scope.tagSelected.name
                });
            }
            if (vm.searchQuery != "") {
                items.push({ key: "name", op: "like", value: vm.searchQuery });
            }
            if (vm.productActive !== 0) {
                items.push({
                    key: "productType",
                    op: "=",
                    value: $scope.productSelected
                });
            }
            if ($scope.priceSelected) {
                items.push({
                    key: "price",
                    op: $scope.priceSelected,
                    value: "0.00"
                });
            }
            ProductXml.byCondition2(
                {
                    items: items,
                    page: vm.pageInfo.page - 1,
                    size: vm.pageInfo.size,
                    sort: sort()
                },
                onSuccess,
                onError
            );

            function sort() {
                var result = [
                    vm.predicate + "," + (vm.reverse ? "asc" : "desc")
                ];
                // if (vm.predicate !== 'id') {
                //     result.push('id');
                // }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers("link"));
                vm.pageInfo.total = headers("X-Total-Count");
                console.log(vm.pageInfo.total);
                vm.productXmls = data;
            }
            function onError(error) {
                MessageService.error("数据加载失败");
            }
        };

        $scope.getXmlByCondition();

        $scope.getTag = function (xml) {
            if (xml.hashtags == null) {
                return;
            }
            return xml.hashtags.replace(";", "  ");
        };

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + "," + (vm.reverse ? "asc" : "desc"),
                search: vm.currentSearch
            });
        }

        function search() {
            if(event.keyCode === 13){
                vm.links = null;
                vm.pageInfo.page = 1;
                vm.reverse = false;
                $scope.getXmlByCondition();
            }
        }
        function jump() {
            vm.page = vm.jumpText <= 0 ? 1 : vm.jumpText;
            loadPage(vm.page);
        }

        vm.domain = Qinius.getDomain();
        vm.hashtags = Hashtag.byCondition2({
            items: [{ key: "usable", value: true, op: "=" }]
        });
        vm.catalogs = Catalog.getAll2({
            items: [
                { key: "type", op: "=", value: "SYSTEM" },
                { key: "catalogType", op: "=", value: "XML" },
                { key: "usable", op: "=", value: "true" }
            ]
        });
        $q.all([
            vm.catalogs.$promise,
            vm.hashtags.$promise,
            vm.domain.$promise
        ]).then(function () {
            vm.domainQ = vm.domain.domain;
            vm.catalogs.sort(function (a, b) {
                return a.seq - b.seq;
            });
            vm.catalogList = vm.catalogList.concat(vm.catalogs);
            vm.hashtags.sort(function (a, b) {
                return a.seq - b.seq;
            });
            vm.hashtagList = vm.hashtagList.concat(vm.hashtags);
        });

        $scope.useTemp = function (temp) {
            if (temp.version != "4.0") {
                MessageService.error("当前模板不可用");
                return;
            }
            if (temp.userId != vm.user.id && temp.price > 0) {
                var items = [
                    { key: "paid", op: "=", value: "true" },
                    { key: "productXml.id", op: "=", value: temp.id },
                    { key: "userId", op: "=", value: vm.user.id }
                ];
                ProductXmlPurchase.getAllByCondition(
                    { items: items },
                    function (data) {
                        if (data && data.length >= 1) {
                            $scope.employ(temp);
                        } else {
                            MessageService.error("请先购买模板，再使用。");
                        }
                    },
                    function () {
                        MessageService.error("查询购买记录失败，请稍后再试。");
                    }
                );
            } else {
                $scope.employ(temp);
            }
        };

        $scope.employ = function (temp) {
            ProductXml.get({ id: temp.id }, function (res) {
                $uibModal.open({
                    templateUrl: "app/entities/page/modal/page-standard.html",
                    controller: "PageStandardController",
                    backdrop: false,
                    keyboard: true,
                    windowClass: "jh-modal-md",
                    controllerAs: "vm",
                    resolve: {
                        items: function () {
                            return {
                                type: "copy",
                                hideModal:true,//隐藏弹窗
                                id: temp.id,
                                data: null
                            };
                        },
                        pagingParams: [
                            "$stateParams",
                            "PaginationUtil",
                            function ($stateParams, PaginationUtil) {
                                return {
                                    page: PaginationUtil.parsePage(
                                        $stateParams.page
                                    )
                                };
                            }
                        ],
                        translatePartialLoader: [
                            "$translate",
                            "$translatePartialLoader",
                            function ($translate, $translatePartialLoader) {
                                $translatePartialLoader.addPart("page");
                                return $translate.refresh();
                            }
                        ]
                    }
                });
            });
        };
    }
})();

(function () {
    'use strict';

    angular
        .module('platformApp')
        .controller('ThumbnailatorController', ThumbnailatorController);

    ThumbnailatorController.$inject = ['$scope', 'Category', '$uibModalInstance', 'MessageService','entity',
        'Base64Image', 'Qinius', 'ImageService'];

    function ThumbnailatorController( $scope, Category, $uibModalInstance, MessageService,entity,
                                      Base64Image, Qinius, ImageService) {
        var vm = this;
        vm.files = entity.files;
        vm.tokenTime = 360000;
        Qinius.get({"mimeLimit":"image/jpeg;image/png"},function (msg) {
            vm.token = msg.token;
            vm.tokenTime = parseInt((msg.expireAt - new Date().getTime()));
        });

        angular.forEach(vm.files,function (f) {
            f.blobCover = URL.createObjectURL(f);
        })
        vm.clear = clear;
        vm.save = save;
        vm.newFiles = [];

        $scope.deletePic = function ($index) {
            vm.files.splice($index,1)
        }

        function blobToFile(theBlob, fileName) {
            theBlob.lastModifiedDate = new Date();
            theBlob.name = fileName;
            return theBlob;
        };
        $scope.compression = function () {
            vm.loading = true;
            var f = 0;
            angular.forEach(vm.files,function (file,i) {
                var img = new  Image();
                img.src = file.blobCover;
                var imgLength = img.height>img.width?img.height:img.width;
                Base64Image.compress(file.blobCover, imgLength, 9.5, function(newBase64) {
                    var compressedSize = Base64Image.getSize(newBase64);
                    var blob = dataURLtoBlob(newBase64);
                    var aasfile = blobToFile(blob, file["name"]);
                    var aafile = new File([aasfile], file["name"], { type: file["type"] });
                    console.log("compress: " + file.size + " ==> " + aafile.size);
                    //ImageService.backendUploadPics(aafile, $scope.domain, vm.token, function (res, aafile) {
                        f++;
                        file.lowerSize = Math.ceil(compressedSize/1024/1024);
                        file.newSize = compressedSize;
                        //aafile.key = res.key;
                        vm.newFiles.push(aafile);
                        if(f == vm.files.length){
                            vm.isEnd = true;
                            vm.loading = false;
                            $scope.$digest();
                        }
                    /*},function (res) {
                        f++;
                        if(f == vm.files.length){
                            vm.isEnd = true;
                            vm.loading = false;
                            $scope.$digest();
                        }
                    });*/
                });

            })
        }

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function save() {
            console.log(vm.files)
            $uibModalInstance.close(vm.newFiles);
            vm.isSaving = false;
            // onSaveSuccess(vm.files);
        }


        function onSaveSuccess(result) {
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError() {
            vm.isSaving = false;
        }

    }
})();

(function () {
    'use strict';

    var threePreview = {
        restrict: 'EAC',
        replace: true,
        transclude: true,
        templateUrl: 'app/entities/page/three-preview.html',
        // controller: 'articlePreviewController',
        controllerAs: 'vm',
        bindings: {
            height: '=',
            width: '=',
            productXml: '=',
            pages: '<',
        },

        controller: ['$scope', '$stateParams', 'Qinius', '$http', '$q',
            'MessageService','$state', '$compile','$timeout', 'ThreeEnv',
            function ($scope, $stateParams, Qinius, $http, $q,
                       MessageService,$state, $compile,$timeout, ThreeEnv) {
                var vm = this;
                vm.loading = true;
                vm.error = false;
                vm.data = "";
                vm.viewWidth = vm.width;
                vm.viewHeight = vm.height;
                vm.modelBlendentItem = null;
                vm.$onChanges = function(data) {
                    if (data.pages) {
                        var pages = data.pages.currentValue;
                        if(pages && vm.modelData){
                            for(var i=0; i<vm.modelData.length; i++){
                                for(var j=0; j<pages.length; j++){
                                    if(vm.modelData[i].page == j&&vm.modelData[i].page!==''){
                                        vm.modelData[i].img = pages[j].pagecover.identifier;
                                    }
                                }
                            }
                            $scope.modelBlendentCb(vm.modelBlendentItem);
                        }
                    }
                };
                vm.$onDestroy = function(){
                    cancelAnimationFrame(vm.animateFrame);
                }
                $q.all().then(function () {
                    vm.modelBlendent = vm.productXml.modelBlendent ? JSON.parse(vm.productXml.modelBlendent) : [];
                    vm.modelData = JSON.parse(vm.productXml.modelData);
                    vm.modelPath = vm.productXml.modelPath;
                    for(var i=0; i<vm.modelData.length; i++){
                        for(var j=0; j<vm.pages.length; j++){
                            if(vm.modelData[i].page == j&&vm.modelData[i].page!==''){
                                vm.modelData[i].img = vm.pages[j].pagecover.identifier;
                            }
                        }
                    }
                    init();
                });
                $scope.modelBlendentCb = function (item) {
                    vm.modelBlendentItem = item;
                    if(vm.modelBlendentItem){
                        for(var i=0; i<vm.modelData.length; i++){
                            for(var j=0; j<vm.modelBlendentItem.modelData.length; j++){
                                if(vm.modelData[i].materialName === vm.modelBlendentItem.modelData[j].materialName){
                                    vm.modelData[i].color = vm.modelBlendentItem.modelData[j].color;
                                }
                            }
                        }
                    }else{
                        for(var i=0; i<vm.modelData.length; i++){
                            vm.modelData[i].color = null;
                        }
                    }
                    initContent1();
                }

                function loaddingError(message) {
                    vm.loading = false;
                    vm.error = true;
                    vm.errorText = message;
                }
                function loaddingSuccess() {
                    vm.loading = false;
                    vm.error = false;
                }

                var scene, camera, renderer, controls, guiControls;
                // var stats = initStats();

                /* 场景 */
                function initScene() {
                    scene = new THREE.Scene();
                    // scene.background = new THREE.Color(0xB3CEFB);
                    // scene.fog = new THREE.Fog(scene.background, 0.1, 1);
                }

                /* 相机 */
                function initCamera(clientWidth, clientHeight) {
                    // camera = new THREE.PerspectiveCamera(45, vm.viewWidth / vm.viewHeight, 0.1, 100000);
                    // camera.position.z = 15;
                    // camera.lookAt(new THREE.Vector3(0, 10, 0));


                    camera = new THREE.PerspectiveCamera(50, clientWidth / clientHeight, 0.1, 1000);
                    var l1 = new THREE.AmbientLight(0xffffff, 0.3);
                    l1.name = 'a-light';
                    camera.add(l1);
                    var l2 = new THREE.DirectionalLight(0xffffff, 0.8 * Math.PI);
                    l2.position.set(6, 0, 6); // ~60º
                    l2.name = 'm-light';
                    l2.castShadow = true;
                    camera.add(l2);
                    var l3 = new THREE.HemisphereLight(0xffffff, 0x000000, 1);
                    l3.name = 'h-light';
                    camera.add(l3);
                    scene.add(camera);

                }

                /* 渲染器 */
                function initRender() {
                    renderer = new THREE.WebGLRenderer({
                        antialias: true,
                        alpha:true,
                        precision: 'highp',
                        preserveDrawingBuffer: true
                    });
                    renderer.setClearColor(new THREE.Color(0xf3f3f3),0.0);
                    renderer.setSize(vm.viewWidth, vm.viewHeight);
                    renderer.shadowMap.enabled = true;
                    renderer.physicallyCorrectLights = true;
                    renderer.outputEncoding = THREE.sRGBEncoding;
                    renderer.minFilter = THREE.LinearFilter;
                    renderer.gammaOutput = true;
                    renderer.setPixelRatio( window.devicePixelRatio );

                    $timeout(function () {
                        document.getElementById("threeView").appendChild(renderer.domElement);
                        onWindowResize()
                        initContent();
                        loaddingSuccess();
                        $scope.$apply();
                    })
                }

                /* 灯光 */
                function initLight() {
                    scene.add(new THREE.AmbientLight(0xdddddd));
                    var directionalLight = new THREE.DirectionalLight(0xdddddd, 0.1);
                    directionalLight.position.set(-4, 8, 4);
                    var dhelper = new THREE.DirectionalLightHelper(directionalLight, 5, 0xff0000);

                    var hemisphereLight = new THREE.HemisphereLight(0xffffff, 0xffffff, 0.6);
                    hemisphereLight.position.set(0, 8, 0);
                    var hHelper = new THREE.HemisphereLightHelper(hemisphereLight, 5);

                    // directionalLight.castShadow = true;
                    // directionalLight.shadow.mapSize = new THREE.Vector2(100000, 100);
                    // directionalLight.shadow.bias = -0.1;
                    // scene.add(hemisphereLight);
                    scene.add(directionalLight);


                    // let floorGeometry = new THREE.PlaneGeometry(500, 500, 32);
                    // var material = new THREE.MeshBasicMaterial( {color: 0xffff00, side: THREE.DoubleSide} );
                    // let floorMaterial = new THREE.MeshPhongMaterial({
                    //     color: 0xffff00,
                    //     shininess: 0,
                    //     // wireframe: true
                    // });
                    // let floor = new THREE.Mesh(floorGeometry, material);
                    // floor.rotation.x = -0.5 * Math.PI;
                    // floor.position.y = -120;
                    // floor.receiveShadow = true;
                    // scene.add(floor);
                }

                /* 控制器 */
                function initControls() {
                    controls = new THREE.OrbitControls(camera, renderer.domElement);
                    controls.autoRotate = true;
                    controls.autoRotateSpeed = -6;
                }

                /* 场景中的内容 */
                function initContent() {
                    // 加载 glTF 格式的模型
                    var loader = new THREE.GLTFLoader();
                    if (THREE.DRACOLoader) {
                        var dracoLoader = new THREE.DRACOLoader();
                        if (dracoLoader) {
                            dracoLoader.setDecoderPath("lib/three/draco/");
                            loader.setDRACOLoader( dracoLoader );
                        }
                    }
                    loader.load(vm.modelPath, function (gltf) {
                        // console.log(gltf);
                        var metalness = checkGltfMetalness(gltf);
                        var gltfScene = gltf.scene || gltf.scenes[0];
                        var clips = gltf.animations || [];
                        gltfScene.updateMatrixWorld();
                        var box = new THREE.Box3().setFromObject(gltfScene);
                        var size = box.getSize(new THREE.Vector3()).length();
                        var center = box.getCenter(new THREE.Vector3());
                        // controls.reset();
                        gltfScene.position.x += gltfScene.position.x - center.x;
                        gltfScene.position.y += gltfScene.position.y - center.y;
                        gltfScene.position.z += gltfScene.position.z - center.z;

                        // 重新设置相机参数
                        controls.maxDistance = size * 10;
                        camera.near = size / 80;
                        camera.far = size * 80;
                        camera.updateProjectionMatrix();

                        camera.position.copy(center);
                        camera.position.x += size / 1.0;
                        camera.position.y += size / 1.0;
                        camera.position.z += size / 1.0;
                        camera.lookAt(center);

                        gltf.scene.traverse(function(child){
                            if (child.isMesh) {
                                child.material.depthWrite = !child.material.transparent;
                                // child.material.emissive =  child.material.color;
                                // child.material.emissiveMap = child.material.map;

                                var materials = Array.isArray(child.material) ? child.material : [child.material];
                                materials.forEach(function (node) {
                                    for(var i=0; i<vm.modelData.length; i++){
                                        if(vm.modelData[i].materialName === node.name){
                                            if(vm.modelData[i].img){
                                                var textureLoader = new THREE.TextureLoader();
                                                var map = textureLoader.load(vm.modelData[i].img);
                                                map.minFilter = THREE.LinearFilter;
                                                map.flipY = false;

                                                if (node.map) {
                                                    // copy current map repeat and offset to the new map
                                                    // this is for gltfpack (meshoptimizer) compressed models
                                                    // Also, in the model, you need to embed a texture image so that we can retrieve it here.
                                                    map.repeat.copy(node.map.repeat);
                                                    map.offset.copy(node.map.offset);
                                                }

                                                // copy texture encoding from existing one to the loaded texture
                                                map.encoding = node.map ? node.map.encoding : THREE.sRGBEncoding;

                                                node.map = map;
                                                node.needsUpdate = true;
                                            }else{
                                                if(vm.modelData[i].color){
                                                    node.color = new THREE.Color(vm.modelData[i].color);
                                                }
                                            }

                                        }
                                    }
                                });
                            }
                        })
                        scene.add(gltfScene);
                        if (metalness > 0) {
                            console.log("metalness=" + metalness);
                            updateEnvironment();
                        }
                        // 判断当前的gltf问价中是否有动画
                        if (clips.length !== 0) {
                            var mixer = new THREE.AnimationMixer(gltfScene);
                            mixer.clipAction(gltf.animations[0]).play();
                        }
                    }, function (xhr) {
                        // console.log((xhr.loaded / xhr.total * 100) + '% loaded');
                    }, function (error) {
                        // console.log(error)
                        loaddingError();
                    })

                }
                function initContent1() {
                    // 加载 glTF 格式的模型
                    var loader = new THREE.GLTFLoader();
                    if (THREE.DRACOLoader) {
                        var dracoLoader = new THREE.DRACOLoader();
                        if (dracoLoader) {
                            dracoLoader.setDecoderPath("lib/three/draco/");
                            loader.setDRACOLoader( dracoLoader );
                        }
                    }
                    loader.load(vm.modelPath, function (gltf) {
                        var gltfScene = gltf.scene || gltf.scenes[0];
                        var clips = gltf.animations || [];
                        gltfScene.updateMatrixWorld();
                        var box = new THREE.Box3().setFromObject(gltfScene);
                        var size = box.getSize(new THREE.Vector3()).length();
                        var center = box.getCenter(new THREE.Vector3());
                        gltfScene.position.x += gltfScene.position.x - center.x;
                        gltfScene.position.y += gltfScene.position.y - center.y;
                        gltfScene.position.z += gltfScene.position.z - center.z;

                        gltf.scene.traverse(function(child){
                            if (child.isMesh) {
                                var materials = Array.isArray(child.material) ? child.material : [child.material];
                                materials.forEach(function (node) {
                                    for(var i=0; i<vm.modelData.length; i++){
                                        if(vm.modelData[i].materialName === node.name){
                                            if(vm.modelData[i].img){
                                                var textureLoader = new THREE.TextureLoader();
                                                var map = textureLoader.load(vm.modelData[i].img);
                                                map.minFilter = THREE.LinearFilter;
                                                map.flipY = false;

                                                if (node.map) {
                                                    // copy current map repeat and offset to the new map
                                                    // this is for gltfpack (meshoptimizer) compressed models
                                                    // Also, in the model, you need to embed a texture image so that we can retrieve it here.
                                                    map.repeat.copy(node.map.repeat);
                                                    map.offset.copy(node.map.offset);
                                                }

                                                // copy texture encoding from existing one to the loaded texture
                                                map.encoding = node.map ? node.map.encoding : THREE.sRGBEncoding;

                                                node.map = map;
                                                node.needsUpdate = true;
                                            }else{
                                                if(vm.modelData[i].color){
                                                    node.color = new THREE.Color(vm.modelData[i].color);
                                                }
                                            }
                                        }
                                    }
                                });
                            }
                        })
                        scene.add(gltf.scene);
                    }, function (xhr) {
                        // console.log((xhr.loaded / xhr.total * 100) + '% loaded');
                    }, function (error) {
                        // console.log(error)
                        loaddingError();
                    })

                }

                /* 窗口变动触发 */
                function onWindowResize() {
                    var width =vm.viewWidth;
                    var height = vm.viewHeight;
                    camera.aspect = width / height;
                    camera.updateProjectionMatrix();
                    renderer.setSize(width, height);
                }

                /* 数据更新 */
                // function update() {
                //     stats.update();
                // }
                /* 初始化 */
                function init() {
                    var container = document.getElementById("threeView");
                    initScene();
                    initCamera(container.clientWidth, container.clientHeight);
                    initRender();
                    // initLight();
                    initControls();
                    // initGui();
                    /* 监听事件 */
                    window.addEventListener('resize', onWindowResize, false);
                    animate();
                }

                /* 循环渲染 */
                function animate() {
                    // 每次取消动画
                    cancelAnimationFrame(vm.animateFrame);

                    var r = function (){
                        if (!renderer) {
                            return;
                        }
                        vm.animateFrame = requestAnimationFrame(r);
                        renderer.render(scene, camera);
                        controls.update();
                    };
                    r();
                }

                $scope.onMouseOver = function () {
                    controls.autoRotate = false;
                }
                $scope.onMouseOut = function () {
                    controls.autoRotate = true;
                }

                function checkGltfMetalness(gltf) {
                    var metalness = 0;
                    if (gltf && gltf.scene) {
                        metalness = parseGroupMetalness(gltf.scene);
                    }
                    return metalness;
                }

                function parseGroupMetalness(group) {
                    var metalness = 0;
                    if (!group.children) {
                        return metalness;
                    }
                    for (var i = 0; i < group.children.length; i++) {
                        var child = group.children[i];
                        if (child.type == 'Mesh') {
                            if (child.material && child.material.metalness > metalness) {
                                metalness = child.material.metalness;
                            }
                        }
                        else if (child.type == 'Group') {
                            var val = parseGroupMetalness(child);
                            if (val > metalness) {
                                metalness = val;
                            }
                        }
                    }
                    return metalness;
                }

                function updateEnvironment () {
                    ThreeEnv.getEnvMap(renderer).then(
                        function (data) {
                            if (data && data.envMap) {
                                scene.environment = data.envMap;
                            }
                        }
                    );
                }
            }
        ]
    };

    angular
        .module('platformApp')
        .component('threePreview', threePreview);
})();

(function() {
    'use strict';

    angular
        .module('platformApp')
        .factory('ThreeEnv', ThreeEnv);

    ThreeEnv.$inject = ['$q'];

    function ThreeEnv ($q) {
        var environments = [{
            id: 'comfy-cafe-1',
            name: 'Comfy Cafe',
            path: 'lib/three/env/comfy_cafe_1k.hdr',
            format: '.hdr'
        }, {
            id: 'comfy-cafe-2',
            name: 'Comfy Cafe 2K',
            path: 'lib/three/env/comfy_cafe_2k.hdr',
            format: '.hdr'
        }, {
            id: 'venice-sunset',
            name: 'Venice Sunset',
            path: 'lib/three/env/venice_sunset_1k.hdr',
            format: '.hdr'
        }];
        var envIndex = 0;

        var service = {
            getEnvMap: getEnvMap
        };

        return service;

        function getEnvMap (renderer) {
            if (envIndex < 0) {
                envIndex = 0;
            }
            if (envIndex >= environments.length) {
                envIndex = environments.length - 1;
            }
            var env = environments[envIndex];
            return getCubeMapTexture(renderer, env);
        }

        function getCubeMapTexture (renderer, environment) {
            var path = environment.path;

            var deferred = $q.defer();
            // no envmap
            if ( ! path ) {
                deferred.resolve( { envMap: null } );
                return deferred.promise;
            }
            console.log("try to loading environment: " + environment.id);
            new THREE.RGBELoader()
            .setDataType( THREE.HalfFloatType )
            .load( path, 
                function ( texture ) {
                    var pmremGenerator = new THREE.PMREMGenerator( renderer );
                    pmremGenerator.compileEquirectangularShader();
                    const envMap = pmremGenerator.fromEquirectangular( texture ).texture;
                    pmremGenerator.dispose();

                    var data = {envMap: envMap};
                    deferred.resolve(data);

                }, 
                undefined, // progress
                deferred.reject );

            return deferred.promise;

        }
    }
})();

(function () {
    'use strict';

    angular
        .module('platformApp')
        .controller('TemplateListController', TemplateListController);

    TemplateListController.$inject = ['$state', '$scope', '$uibModal', 'ParseLinks','Qinius','$q', 'paginationConstants', 'MessageService','$stateParams','Hashtag','ProductXml', 'ProductTemplate', '$location','Catalog','$localStorage'];

    function TemplateListController($state, $scope, $uibModal, ParseLinks,Qinius,$q, paginationConstants, MessageService,$stateParams,Hashtag,ProductXml, ProductTemplate, $location, Catalog,$localStorage) {

        var vm = this;

        $(".navbar").show();
        $(".wrap").css({margin: '50px 0 10px 254px'});
        vm.templateList =[];
        vm.hashtags = [];
        vm.loadPage = loadPage;
        var _location = $location.search();
        vm.reverse = '';
        vm.transition = transition;
        vm.clear = clear;
        vm.search = search;
        vm.jump = jump;
        vm.id ='';
        vm.operations=['编辑','复制','删除','分享','发布模板','发布产品', '获取数据'];
        vm.show = false;
        vm.tagScreenIsOpen = false;
        vm.isBatch = false;

        vm.tableData = {
            size:paginationConstants.itemsPerPage,
            page:_location.page || 1,
            searchQuery: _location.search || '',
            selectN: _location.selectN || '',
            classify: _location.classify || '',
            shareStatus: _location.shareStatus || '',
            source: _location.source || '',
            product: _location.product || '',
            upgradeStatus: _location.upgradeStatus || ''
        }
        localStorage.removeItem('label');
        vm.sourceList=[
            {name:'自定义',id:'self'},
            {name:'平台推荐',id:'recommend'}
        ];
        vm.productList = [
            {name:'照片书',id:'BOOK'},
            {name:'冲印',id:'PHOTO'},
            {name:'台历',id:'CALENDAR'},
            {name:'万物',id:'THING'},
        ];

        vm.shareStatus = [
            {name:'全部',id:'',},
            {name:'未分享',id:null},
            {name:'审核中',id:'Created',},
            {name:'已分享',id:'Approved',},
            {name:'已驳回',id:'Rejected',}
        ]

        $scope.selectShareStatus = function(item){
            vm.tableData.shareStatus = item;
            vm.tableData.page = 1;
            getTemplate();
        }

        vm.upgradeStatus = [
            {name:'全部',id:''},
            {name:'已升级',id:'upgrade'},
            {name:'未升级',id:'noUpgrade'},
        ]


        $scope.selectUpgradeStatus = function(item){
            vm.tableData.upgradeStatus = item;
            vm.tableData.page = 1;
            getTemplate();
        }


        //模板分类
        Catalog.getAll({items:[{key:"usable", op:"=", value:"true"},{key:"catalogType", op:"=", value:"XML"}]}, function (res) {
            vm.catalogs = res;
        });

        vm.domain = Qinius.getDomain();
        $q.all([vm.domain.$promise]).then(function(){
            vm.domainQ  =vm.domain.domain
        });

        $scope.templateFlag = function(template){
            angular.forEach(vm.templateList ,function(item){
                if (item.id != template.id ) {
                    item.flag = false;
                }
            })
            template.flag = !template.flag;
        }

        $scope.getResult = function(template){
            if (template.status == "Rejected") {
                // $state.go("template-opened-result", {id: template.id});
                // $uibModal.open({
                //     templateUrl: 'app/entities/page/template-opened-result.html',
                //     controller: 'PageShareController',
                //     controllerAs: 'vm',
                //     backdrop: 'static',
                //     size: 'lg',
                //     resolve: {
                //         entity: ['ProductXml',   function (ProductXml) {
                //             return ProductXml.get({id: template.id}).$promise;
                //         }],
                //         translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                //             return $translate.refresh();
                //         }]
                //     }
                // }).result.then(function() {

                // });
                MessageService.confirm({
                    title:'驳回理由',
                    hideCancel:true,
                    cancel:'取消',
                    confirm:'知道了',
                    msg:'理由： '+template.statusRemarks,
                },function(){

                })
            }
        };
        function tempVersion(temp,callback){
            if(temp.version != '4.0'){
                MessageService.confirm({
                    title:'提示',
                    cancel:'取消',
                    confirm:'确认',
                    msg:'系统全面更新，模板需升级方可使用，确认升级?',
                    isThemecolor:true
                },function(){
                    $uibModal.open({
                        templateUrl: 'app/entities/page/modal/template-upgrade.html',
                        controller: 'TemplateUpgradeController',
                        backdrop: 'static',
                        keyboard: true,
                        windowClass: "jh-modal-md",
                        controllerAs: 'vm',
                        size:'lg',
                        resolve: {
                            entity: function(){
                                return temp
                            },
                            pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                                return {
                                    page: PaginationUtil.parsePage($stateParams.page)
                                };
                            }],
                            translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                                $translatePartialLoader.addPart('page');
                                return $translate.refresh();
                            }]
                        }
                    }).result.then(
                        function (data) {
                            if(data){
                                getTemplate();
                                ProductXml.get({id: temp.id}, function (res) {
                                    callback(res)
                                })
                            }
                        })
                })
            }else{
                callback(temp)
            }
        }
        /**
         * 显示原创协议弹窗
         * @param {*} callback
         */
        function showOriginalAgreement(callback){
            var userInfo = $localStorage.user;
            if(userInfo.original){
                return callback(true);
            }
            $uibModal.open({
                templateUrl: 'app/entities/page/modal/original-agreement.html',
                controller: 'OriginalAgreementController',
                controllerAs: 'vm',
                backdrop: "static",
                size: 'lg',
                resolve: {

                }
            }).result.then(function (state) {
                callback(state);
            })
        }
        $scope.operateLi = function(tempItem, op){
            if (op == null || tempItem == null) {
                return;
            }
            if (op == "删除") {
                MessageService.confirm({
                    title:'提示',
                    cancel:'取消',
                    confirm:'确认',
                    msg:'确认删除该模板？'
                },function(){
                    ProductXml.delete({id:tempItem.id},function(data){
                        loadAll();
                        MessageService.success("删除成功");
                    },function(){
                        MessageService.error("删除失败");
                    });
                })
                return;
            }
            tempVersion(tempItem,function (temp) {
                if (op == "编辑") {
                    // $uibModal.open({
                    //     templateUrl: 'app/entities/page/modal/page-standard.html',
                    //     controller: 'PageStandardController',
                    //     backdrop: 'static',
                    //     keyboard: true,
                    //     windowClass: "jh-modal-md",
                    //     controllerAs: 'vm',
                    //     resolve: {
                    //         items: function(){
                    //             return {
                    //                 type: 'edit',
                    //                 id: temp.id,
                    //                 data: null
                    //             }
                    //         },
                    //         pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    //             return {
                    //                 page: PaginationUtil.parsePage($stateParams.page)
                    //             };
                    //         }],
                    //         translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    //             $translatePartialLoader.addPart('page');
                    //             return $translate.refresh();
                    //         }]
                    //     }
                    // }).result.then(function(data) {
                    //     if(data){
                    //         getTemplate()
                    //     }
                    // });
                    $state.go('page-my-suffix-edit', {id: tempItem.id}, {reload: true})
                }else if (op == '编辑数据') {
                    $uibModal.open({
                        templateUrl: 'app/entities/page/modal/page-standard.html',
                        controller: 'PageStandardController',
                        backdrop: 'static',
                        keyboard: true,
                        windowClass: "jh-modal-md",
                        controllerAs: 'vm',
                        resolve: {
                            items: function(){
                                return {
                                    type: 'edit',
                                    id: temp.id,
                                    data: null
                                }
                            },
                            pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                                return {
                                    page: PaginationUtil.parsePage($stateParams.page)
                                };
                            }],
                            translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                                $translatePartialLoader.addPart('page');
                                return $translate.refresh();
                            }]
                        }
                    }).result.then(function(data) {
                        if(data){
                            getTemplate()
                        }
                    });
                }else if (op == "复制") {
                    $uibModal.open({
                        templateUrl: 'app/entities/page/modal/page-standard.html',
                        controller: 'PageStandardController',
                        backdrop: 'static',
                        keyboard: true,
                        windowClass: "jh-modal-md",
                        controllerAs: 'vm',
                        resolve: {
                            items: function(){
                                return {
                                    type: 'copy',
                                    id: temp.id,
                                    data: null
                                }
                            },
                            pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                                return {
                                    page: PaginationUtil.parsePage($stateParams.page)
                                };
                            }],
                            translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                                $translatePartialLoader.addPart('page');
                                return $translate.refresh();
                            }]
                        }
                    });
                }else if (op == "发布模板") {
                    showOriginalAgreement(function(state){
                        if(state){
                            ProductXml.get({id:temp.id}, function (res) {
                                if(res.document.documentpics.documentpic.length === 0){
                                    MessageService.error("请添加样例图！");
                                    return
                                }
                                calendarContinuous(res.document,function () {
                                    $uibModal.open({
                                        templateUrl: 'app/entities/page/modal/document-detection.html',
                                        controller: 'DocumentDetectionController',
                                        controllerAs: 'vm',
                                        size: 'lg',
                                        resolve: {
                                            entity: [function() {
                                                return {
                                                    document: res.document,
                                                    id:temp.id,
                                                    type: 'XML',
                                                    storeIds:[],
                                                    source:'list'
                                                };
                                            }]
                                        }
                                    }).result.then(function (isReturn) {
                                    })
                                })
                            })
                        }
                    });
                }else if (op == "获取数据") {
                    ProductXml.updateSizeInfo({
                        id:temp.id,
                    },function(data){
                        loadAll();
                        MessageService.success("修改成功");
                    },function(){
                        MessageService.error("修改失败");
                    });
                }else if (op == "分享") {
                    $uibModal.open({
                        templateUrl: 'app/entities/page/template-share.html',
                        controller: 'PageShareController',
                        backdrop: 'static',
                        keyboard: true,
                        windowClass: "jh-modal-md",
                        controllerAs: 'vm',
                        resolve: {
                            entity: ['ProductXml',   function (ProductXml) {
                                return ProductXml.get({id: temp.id}).$promise;
                            }],
                            translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                                return $translate.refresh();
                            }]
                        }
                    }).result.then(function() {
                        getTemplate()
                    });
                }else if (op == "发布产品") {
                    var pass = true;
                    ProductXml.get({id:temp.id}, function (res) {
                        if(res.document.documentpics.documentpic.length === 0){
                            MessageService.error("请添加样例图！");
                            return
                        }
                        var _page = res.document.pages.page;
                        for(var i=0; i<_page.length; i++){
                            var _level = _page[i].levels.level;
                            if (_level== null) {
                                continue;
                            }
                            for(var j=0; j<_level.length; j++){
                                if(_level[j].imagebox){
                                    if(!_level[j].imagebox.image){
                                        pass = false;
                                        break;
                                    }
                                }
                            }
                        }
                        if(!pass){
                            MessageService.error("没有制作完成！");
                        }else {
                            showOriginalAgreement(function(state){
                                if(state){
                                    calendarContinuous(res.document,function () {
                                        $uibModal.open({
                                            templateUrl: 'app/entities/page/modal/document-detection.html',
                                            controller: 'DocumentDetectionController',
                                            controllerAs: 'vm',
                                            size: 'lg',
                                            resolve: {
                                                entity: [function() {
                                                    return {
                                                        document: res.document,
                                                        id:temp.id,
                                                        type: 'PRODUCT',
                                                        storeIds:[],
                                                        source:'list'
                                                    };
                                                }]
                                            }
                                        }).result.then(function (isReturn) {
                                        })
                                    })
                                }
                            })
                        }
                    })
                }
                else if (op == "重命名") {
                    $uibModal.open({
                        templateUrl: 'app/entities/page/modal/template-rename.html',
                        controller: 'TemplateRenameController',
                        controllerAs: 'vm',
                        size: 'm',
                        resolve: {
                            entity: [function() {
                                return {
                                    id: temp.id,
                                    name: temp.name
                                };
                            }]
                        }
                    }).result.then(function (data) {
                        temp.name = data.name;
                        $scope.$digest();
                    })
                }
                else if (op == "升级"){

                }
                angular.forEach(vm.templateList ,function(item){
                    item.flag = false;
                })
            })
        }

        function calendarContinuous(template,callback) {
            if(template.config.dynamic){
                var numbers = [];
                template.pages.page.forEach(function (page) {
                    if(page.config.monthIndex>0){
                        numbers.push(page.config.monthIndex)
                    }
                })
                var result = findMissingNumbers(numbers);
                if (result.length>0){
                    $uibModal.open({
                        templateUrl: 'app/entities/page/modal/calendar-modal.html',
                        controller: 'CalendarModalController',
                        backdrop: 'static',
                        keyboard: true,
                        windowClass: "jh-modal-md",
                        controllerAs: 'vm',
                        resolve: {
                            entity: [function () {
                                return {
                                    numbers: numbers,
                                    templateConfig: template.config
                                };
                            }]
                        }
                    }).result.then(function (data) {
                        if (data) {
                            callback()
                        }
                    });
                    return
                }
            }
            callback()
        }

        //    分类显示
        loadAll();
        function loadAll () {
            //获取可使用的主题标签
            Hashtag.byCondition2({
                items:[{key:"usable",value:true, op:"="}]
            }, onSuccess, onError);

            function onSuccess(data) {
                vm.hashtags = data;
            }
            function onError(error) {
                MessageService.error("获取主题标签数据失败");
            }
            getTemplate();
        }

        vm.pageCb = pageCb;
        function pageCb(page) {
            vm.tableData.page = page;
            getTemplate();
        }
        //   获取模板列表
        function getTemplate(){
            var items=[];
            if (vm.tableData.selectN != '' && vm.tableData.selectN != null) {
                items.push({key: "hashtags", op: "like", value: vm.tableData.selectN});
            }
            if (vm.tableData.source == "self") {
                items.push({key: "productTemplate.id", op: "isNull"});
            }
            if (vm.tableData.source == "recommend") {
                items.push({key: "productTemplate.id", op: "notNull"});
            }
            if (vm.tableData.classify != '') {
                items.push({key: "catalog.id", op: "=", value: vm.tableData.classify});
            }
            if (vm.tableData.product != '') {
                items.push({key: "productType", op: "=", value: vm.tableData.product});
            }
            if (vm.tableData.shareStatus != '') {
                if(vm.tableData.shareStatus === null){
                    items.push({key: "status", value: null, op: "isnull"});
                }else{
                    items.push({key: "status", op: "=", value: vm.tableData.shareStatus});
                }

            }
            if (vm.tableData.upgradeStatus != '') {
                if (vm.tableData.upgradeStatus == 'upgrade') {
                    items.push({key: "productType", op: "notNull"});
                }
                if (vm.tableData.upgradeStatus == 'noUpgrade') {
                    items.push({key: "productType", op: "isNull"});
                }
            }

            if (vm.tableData.searchQuery) {
                items.push({key: "name", op: "like", value: vm.tableData.searchQuery});
            }
            ProductXml.byCondition({
                items: items,
                page: vm.tableData.page-1,
                size: vm.tableData.size,
                sort: ["lastModifiedDate,desc"]
            }, onSuccess1, onError1);

            function onSuccess1(data, headers) {
                vm.totalItems = headers('X-Total-Count');
                vm.templateList = data;
                transition();
                vm.selectList = [];
                vm.selectIds = [];
                vm.templateList.forEach(function(item){
                    item.selected = false;
                })
            }
            function onError1(error) {
                MessageService.error("获取模板列表数据失败");
            }
        }

        $scope.selectTag = function(item){
            vm.tableData.selectN =item;
            vm.tableData.page = 1;
            getTemplate();
        };

        $scope.selectClassify = function(item){
            vm.tableData.classify = item;
            vm.tableData.page = 1;
            getTemplate();
        }

        $scope.selectSource = function(item){
            vm.tableData.source = item;
            vm.tableData.page = 1;
            getTemplate();
        }

        $scope.selectProduct = function(item){
            vm.tableData.product = item;
            vm.tableData.page = 1;
            getTemplate();
        }

        function loadPage(page) {
            vm.tableData.page = page;
            getTemplate();
            vm.transition();
        }

        function transition() {
            // $location.search({
            //     page:vm.tableData.page || 1,
            //     searchQuery: vm.tableData.searchQuery,
            //     selectN: vm.tableData.selectN,
            //     classify: vm.tableData.classify,
            //     shareStatus: vm.tableData.shareStatus,
            //     source: vm.tableData.source,
            //     product: vm.tableData.product,
            //     upgradeStatus: vm.tableData.upgradeStatus
            // })
        }

        function search() {
            if (event.keyCode === 13) {
                vm.links = null;
                vm.tableData.page = 1;
                vm.reverse = false;
                getTemplate();
            }

        }

        function clear() {
            vm.links = null;
            vm.tableData.page = 1;
            vm.reverse = false;
            vm.tableData.searchQuery = null;
            getTemplate();
        }
        function jump () {
            vm.tableData.page = vm.jumpText<=0?1:vm.jumpText;
            loadPage(vm.tableData.page);
        }

        $scope.previewTemplate = function(templateItem){
            tempVersion(templateItem,function (template) {
                ProductXml.get({id:template.id},function(data){
                    createModal('app/entities/page/template-view.html', 'TemplateViewController',data.id).result.then(
                        function (data) {

                        });
                });
                $(".modal-content").hide();
            })
        };

        var createModal = function (url, controller,id) {
            return $uibModal.open({
                templateUrl: url,
                controller: controller,
                backdrop: 'static',
                keyboard: true,
                windowClass: "jh-modal-md",
                controllerAs: 'vm',
                resolve: {
                    entity: ['ProductXml', '$stateParams', function (ProductXml, $stateParams) {
                        return ProductXml.get({id: id}).$promise;
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('product');
                        $translatePartialLoader.addPart('productType');
                        return $translate.refresh();
                    }]
                }
            });
        };
        $scope.hashtags = function(hashtags){
            if (hashtags) {
                var hashtags = hashtags.split(',')
                return hashtags
            }else{
                return
            }
        }
        $scope.addLabel=function(item){
            // $state.go('templateList.new',{
            //     id:item.id
            // });
            console.log(item);
            $uibModal.open({
                templateUrl: 'app/entities/page/template-dialog.html',
                controller: 'TemplateDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'lg',
                resolve: {
                    entity: function () {
                        return {
                            name: null,
                            seq: null,
                            type: null,
                            usable: null,
                            id: null,
                            templateId:item.id
                        };
                    }
                }
            }).result.then(function (isReturn) {
                item.hashtags = isReturn.hashtags
            });
            localStorage.setItem('label',JSON.stringify(item));
        }

        vm.checkAndFix = checkAndFix;
        function checkAndFix() {
            ProductXml.checkAndFixDocument({ticket: 'check12345'}, function(res) {
                var counter = res.counter;
                var duration = res.durationInSeconds;
                MessageService.success("操作成功！修复数量:" + counter + ", 使用时间:" + duration + "s");
            }, function(err) {

            });
        }

        $scope.gotoCreate = function (item, custom, productType) {
            if(custom){
                createModal2('app/entities/page/modal/template-add.html', 'TemplateAddController',item, custom,productType).result.then(
                    function (data) {
                });
            }
        };

        var createModal2 = function (url, controller,item, custom,productType) {
            return $uibModal.open({
                templateUrl: url,
                controller: controller,
                backdrop: 'static',
                keyboard: true,
                windowClass: "jh-modal-md",
                controllerAs: 'vm',
                size: 'lg',
                resolve: {
                    items: function(){
                        return {
                            type: 'add',
                            data: item,
                            custom: custom,
                            productType:productType
                        }
                    },
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page)
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('page');
                        return $translate.refresh();
                    }]
                }
            });
        };

        $scope.productType = function (item) {
            switch (item) {
                case 'BOOK':
                    return '照片书';
                    break;
                case 'PHOTO':
                    return '冲印';
                    break;
                case 'CALENDAR':
                    return '台历';
                    break;
                case 'THING':
                    return '万物';
                    break;
                default:
                    return ''
            }
        }


        $scope.batch = function(){
            vm.templateList.forEach(function(item){
                item.selected = false;
            })
            vm.selectList = [];
            vm.selectIds = [];
            vm.batch = true;
        }

        $scope.quitBatch = function(){
            vm.batch = false;
        }
        vm.selectList = [];
        $scope.selectItem = function(item){
            if (!vm.batch) {
                return
            }
            item.selected = !item.selected;
            selects();
        }

        function selects(){
            vm.selectList = [];
            vm.selectIds = [];
            vm.templateList.forEach(function(item){
                if (item.selected) {
                    vm.selectList.push(item);
                    vm.selectIds.push(item.id);
                }
            })
        }

        $scope.deleteSelect = function(){
            if (vm.selectIds.length == 0) {
                MessageService.notice('请选择需要删除的模板')
                return
            }
            MessageService.confirm({
                title:'提示',
                cancel:'取消',
                confirm:'确认',
                msg:'确认删除选中的模板？'
            },function(){
                ProductXml.batchDelete(vm.selectIds,function(){
                    loadAll();
                    MessageService.success("删除成功");
                    vm.batch = false;
                },function(){
                    MessageService.error("删除失败");
                });
            })
        }

        $scope.changeMore = function(){
            vm.tagScreenIsOpen = !vm.tagScreenIsOpen;
        }

        $scope.editorClassify = function(){
            $uibModal.open({
                templateUrl: 'app/entities/page/catalog-management.html',
                controller: 'CatalogManagementController',
                backdrop: 'static',
                keyboard: true,
                windowClass: "jh-modal-md",
                controllerAs: 'vm',
                resolve: {
                    entity: function () {
                        return {catalogType: "XML"}
                    }
                }
            }).result.then(function(res) {
                Catalog.getAll({items:[{key:"usable", op:"=", value:"true"},{key:"catalogType", op:"=", value:"XML"}]}, function (res) {
                    vm.catalogs = res;
                    vm.tableData.classify = '';
                    getTemplate()
                });
            },function(){
                Catalog.getAll({items:[{key:"usable", op:"=", value:"true"},{key:"catalogType", op:"=", value:"XML"}]}, function (res) {
                    vm.catalogs = res;
                    vm.tableData.classify = '';
                    getTemplate()
                });
            });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('platformApp')
        .controller('TemplateViewController', TemplateViewController);

    TemplateViewController.$inject = ['$scope', 'entity', 'Qinius', '$http', '$q', 'ImageService', '$uibModalInstance', 'FontManagement'];

    function TemplateViewController($scope, entity, Qinius, $http, $q, ImageService, $uibModalInstance, FontManagement) {

        var vm = this;
        vm.article = entity;
        $scope.domains = Qinius.getDomain();

        $q.all([$scope.domains.$promise]).then(function () {
            vm.url = $scope.domains.domain;
            var artDoc = angular.copy(vm.article.document);
            //3d
            if(vm.article.modelType && vm.article.modelType === 'THREE'){
                vm.threeView = true;
                vm.threeTemplate = artDoc;
                vm.threeProductXmlData = {
                    modelBlendent: vm.article.modelBlendent,
                    modelData:vm.article.modelData,
                    modelPath:vm.article.modelPath,
                };
            }else{
                vm.watchSure = true
            }

            if (artDoc.bindingtype == 'Left2') {
                $scope.isPull = false;
                vm.bindingtype = 'Left';
            } else {
                vm.bindingtype = artDoc.bindingtype;
            }
        })


        $scope.backTo = function () {
            $uibModalInstance.dismiss('cancel');

            $(".modal-content").show().removeClass('opacity0');
        };
    }
})();

(function () {
    'use strict';

    angular
        .module('platformApp')
        .controller('PageShareController', PageShareController);

    PageShareController.$inject = ['$scope', '$uibModalInstance', '$state', '$stateParams', 'MessageService', 'Catalog', 'entity',
    'ProductXml'];

    function PageShareController($scope, $uibModalInstance, $state, $stateParams, MessageService, Catalog, entity,
        ProductXml) {

        var vm = this;
        vm.productXml = entity;

        vm.clear = clear;
        vm.save = save;
        vm.label = ''

        vm.catalogs = Catalog.getAll2({items:[{key:"usable",op:"=",value:"true"},{key:"catalogType",op:"=",value:"XML"}]})


        function clear() {
            $uibModalInstance.dismiss('cancel');
        }


        $scope.validate = function () {
            if (vm.backCatalog == null || vm.backCatalog == "") {
                MessageService.error("请选择专题");
                return false;
            }
            return true;
        };

        function save() {
            // $uibModalInstance.dismiss('cancel');
            if (!$scope.validate()) {
                return;
            }
            ProductXml.share({id:vm.productXml.id, catalogId:vm.backCatalog.id},function(data){
                MessageService.success("分享成功,等待后台审核");
                $uibModalInstance.close(data);
            },function(){

                MessageService.error("分享失败");
            });
        }

    }

})();

(function() {
    'use strict';

    angular
        .module('platformApp')
        .controller('TemplateDialogController', TemplateDialogController);

    TemplateDialogController.$inject = ['$timeout', '$q', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Hashtag','ProductXml','MessageService', 'Qinius', 'UidService'];

    function TemplateDialogController ($timeout, $q, $scope, $stateParams, $uibModalInstance, entity, Hashtag,ProductXml,MessageService, Qinius, UidService) {
        var vm = this;

        vm.hashtags = entity;
        vm.clear = clear;
        vm.save = save;
        vm.totalTags=[];
        var total = 3;
        if(JSON.parse(localStorage.getItem('label')) == null || JSON.parse(localStorage.getItem('label')).hashtags == undefined){
            vm.labels=[];
        }else{
            vm.labels = JSON.parse(localStorage.getItem('label')).hashtags.split(',');
        }
        //vm.labels = JSON.parse(localStorage.getItem('label'));
        //console.log(vm.labels.hashtags);
        //console.log(JSON.parse(localStorage.getItem('label')).hashtags);

        Hashtag.byCondition2({
            items:[{key:"usable",value:true, op:"="}]
        }, onSuccess, onError);

        function onSuccess(data) {
            vm.tempHashtags = data;
            angular.forEach(vm.tempHashtags,function(item){
                item.selected = false;
            });
            if(vm.labels == null){
                vm.hashtags =vm.tempHashtags;
            }else{
                repeat(vm.tempHashtags,vm.labels);
            }
        }
        function onError(error) {
            MessageService.error("获取主题标签数据失败");
        }

        //    这里做比较  已有的显示已经启用  未有的未启用
        function repeat(items,list){
            for(var i=0;i<items.length;i++){
                var item=items[i].name;
                for(var j=0;j<list.length;j++){
                    if(item== list[j]){
                        items[i].selected=true;
                    }
                }
            }
            vm.hashtags =vm.tempHashtags;
        }

        $scope.useHashtag = function(item){
            var count= vm.hashtags.filter(function(item){
                return item.selected;
            }).length;
            if(item.selected == false){
                if(count>=total){
                    MessageService.error('最多只能选择3个标签');
                }else{
                    item.selected = !item.selected;
                }
            }else{
                item.selected = !item.selected;
            }

        };

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            var temp=vm.hashtags.filter(function(item,index){
                return item.selected;
            });
            var hashTags =temp.map(function(item){
                return item.name;
            }).join(',');
            vm.isSaving = true;
            ProductXml.updateHashtags({
                id:entity.templateId,
                hashtags:hashTags
            },onSaveSuccess, onSaveError);
        }

        function onSaveSuccess (result) {
            $scope.$emit('backApp:bannerUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
            MessageService.success('添加标签成功!')
        }

        function onSaveError () {
            MessageService.error('添加标签失败!');
            vm.isSaving = false;
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('platformApp')
        .controller('TemplateController', TemplateController);

    TemplateController.$inject = ['$state', '$scope', '$timeout', '$uibModal', '$http', 'Qinius','$q', 'pagingParams', 'paginationConstants', '$stateParams','ProductTemplate'];

    function TemplateController($state, $scope, $timeout, $uibModal, $http, Qinius,$q, pagingParams, paginationConstants, $stateParams,ProductTemplate) {

        var vm = this;
        $(".navbar").show();
        $(".wrap").css({margin: '40px 0 10px 254px'});

        $scope.gotoCreate = function (item) {
            createModal('app/entities/page/page-create.html', 'PageCreateController',item).result.then(
                function (data) {
                });
        };

        var createModal = function (url, controller,item) {
            return $uibModal.open({
                templateUrl: url,
                controller: controller,
                backdrop: 'static',
                keyboard: true,
                windowClass: "jh-modal-md",
                controllerAs: 'vm',
                resolve: {
                    items: function(){
                        return item
                    },
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page)
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('page');
                        return $translate.refresh();
                    }]
                }
            });
        };

        vm.domain = Qinius.getDomain();
        $q.all([vm.domain.$promise]).then(function(){
            vm.domainQ  =vm.domain.domain
        });

        //    分类显示
        loadAll();
        function loadAll () {
            ProductTemplate.getAllByCondition({items:[]}, function (data) {
                vm.userDefined = data;
            })
        }

    }

})();

(function() {
    'use strict';

    angular
        .module('platformApp')
        .directive('isOver', isOver);

    isOver.$inject = ['$timeout'];


    function isOver($timeout) {

        return {
            restrict: 'A',
            scope: {
                over: '=isOver'
            },
            link:function(scope, elm, attr){
                if(scope.$parent.$last){
                    scope.over = true;
                }
            }
        }
    }
})();

(function () {
    "use strict";

    angular
        .module("platformApp")
        .controller("RecommendTemplateController", RecommendTemplateController);

    RecommendTemplateController.$inject = [
        "$state",
        "$scope",
        "$timeout",
        "$uibModal",
        "$http",
        "Qinius",
        "$q",
        "paginationConstants",
        "$stateParams",
        "ProductTemplate",
        "ProductXml",
        "Catalog",
        "UidService",
        "MessageService"
    ];

    function RecommendTemplateController(
        $state,
        $scope,
        $timeout,
        $uibModal,
        $http,
        Qinius,
        $q,
        paginationConstants,
        $stateParams,
        ProductTemplate,
        ProductXml,
        Catalog,
        UidService,
        MessageService
    ) {
        var vm = this;
        vm.oldView = false;

        //分页信息
        vm.pageInfo = {
            page: 1,
            size: 20,
            total: 0
        };
        //搜索定时器
        vm.timer = null;
        //选中的产品分类索引
        vm.productSelected = null;
        //产品列表
        vm.productList = [
            { label: "全部", value: null },
            { label: "照片书", value: "BOOK" },
            { label: "冲印", value: "PHOTO" },
            { label: "台历", value: "CALENDAR" },
            { label: "万物", value: "THING" }
        ];
        $(".navbar").show();
        $(".wrap").css({ margin: "40px 0 10px 254px" });
        vm.domain = Qinius.getDomain();
        $q.all([vm.domain.$promise]).then(function () {
            vm.domainQ = vm.domain.domain;
            timeoutInit();
            vm.hotxmls = ProductXml.byCondition2({
                items: [
                    { key: "hotspot", op: "=", value: "true" },
                    { key: "status", op: "=", value: "Approved" }
                ]
            });
            vm.latexmls = ProductXml.byCondition({
                sort: ["createdDate,desc"]
            });
        });
        $scope.gotoCreate = function (item, custom) {
            console.log(item);
            // return
            if (custom) {
                createModal(
                    "app/entities/page/modal/template-add.html",
                    "TemplateAddController",
                    item,
                    custom
                ).result.then(function (data) {});
            } else {
                if (item.version == 1) {
                    MessageService.error("当前模板暂不能使用，请联系运营人员");
                    // MessageService.confirm({
                    //     title:'提示',
                    //     cancel:'取消',
                    //     confirm:'确认',
                    //     msg:'系统全面更新，模板需升级方可使用，确认升级?'
                    // },function(){
                    //     createModal('app/entities/page/modal/template-upgrade.html', 'TemplateUpgradeController',item, custom).result.then(
                    //         function (data) {
                    //             if(data){
                    //                 loadAll();
                    //                 saveTemplate(data)
                    //             }
                    //         });
                    // })
                } else {
                    saveTemplate(item);
                }
            }
        };
        function saveTemplate(data) {
            if(vm.isSaving){
                return
            }
            vm.isSaving = true;
            $scope.template = {
                "addpage":false,
                "addunit":0,
                "maxpage":0,
                "minpage":0,
                "replace":"",
                "cover":"",
                backupPages:{
                    list:[]
                },
                config:{
                    innerOffset:0,
                    parts:{
                        list:[]
                    },
                    productType:''
                },
                deletedPages:{
                    page:[]
                },
                "frameConfigs":{
                    "frameConfig":[]
                },
                pages: {
                    page: []
                },
                "version":"4.0",
                transparency: 1,
                scene: null,
                pageI: 0,
                angle: 0,
                backup: false,
                spread: false,
                unreplace: false,
                letterspacing: 0,
                lineheight: 0,
                text: '',
                bgimgs: {bgimg: []},
                bgimgs2: {bgimg: []},
                masks: {mask: []},
                cliparts: {clipart: []},
                documentpics: {documentpic: []},
                showPic: false,
                psdFiles: {psdFile: []}
            };
            var _seq = 0;
            data.parts.sort(compare('seq', true));
            data.parts.forEach(function (part,index) {
                var editboxes = {
                    editbox:[{
                        height: part.pageEditH,
                        width: part.pageEditW,
                        x: part.pageEditX,
                        y: part.pageEditY
                    }]
                };
                $scope.template.config.parts.list.push({
                    "bleed":{
                        "bottom":part.pageBloodB,
                        "left":part.pageBloodL,
                        "right":part.pageBloodR,
                        "top":part.pageBloodT
                    },
                    "editboxes":editboxes,
                    "mediabox":{
                        height: part.pageSizeH,
                        width: part.pageSizeW,
                    },
                    "counter":part.pageCount,
                    "id":part.code,
                    "name":part.name,
                    "required":(part.code == 'P' || part.code == 'P0') ? true : false,
                    "seq":index,
                    "spread":part.spread
                })
                var _page = createPage(data, part, editboxes);
                for(var i=0;i<part.pageCount; i++){
                    _page.uuid = UidService.get();
                    _page.seq = _seq;
                    if(data.type == 'BOOK'){
                        $scope.template.pages.page.push(angular.copy(_page));
                        _seq++
                    }
                    if(data.type == 'PHOTO'){
                        $scope.template.pages.page.push(angular.copy(_page));
                        _seq++
                    }
                    if(data.type == 'CALENDAR'){
                        $scope.template.pages.page.push(angular.copy(_page));
                        _seq++
                    }
                    if(data.type == 'THING'){
                        $scope.template.pages.page.push(angular.copy(_page));
                        _seq++;
                    }
                }
            })
            vm.hashtags = '';
            if(data.catalog.hashtags){
                for (var i = 0; i < data.catalog.hashtags.length; i++) {
                    vm.hashtags += data.catalog.hashtags[i].name + ','
                }
            }
            $scope.template.config.innerOffset = data.innerOffset;
            $scope.template.config.productType = data.type;
            $scope.template.config.dynamic = data.dynamic;
            if($scope.template.config.dynamic){
                $scope.template.config.startYear = (data.month.split("-"))[0];
                $scope.template.config.startMonth = (data.month.split("-"))[1];
            }
            $scope.template.cover = data.cover;
            $scope.template.replace = data.replace;
            $scope.template.addpage = data.addpage;
            $scope.template.minpage = data.minpage;
            $scope.template.maxpage = data.maxpage;
            $scope.template.addunit = data.addunit;
            ProductXml.save({
                document: $scope.template,
                replace: data.replace,
                name: data.name,
                catalogId: data.catalog.id,
                catalogName: data.catalog.name,
                version: '4.0',
                type: 'XML',
                productTemplateId: data.id,
                hashtags: vm.hashtags,
                modelBlendent: data.modelBlendent,
                modelData: data.modelData,
                modelPath: data.modelPath,
                modelType: data.modelType,
                productType: data.type
            }, function (res) {
                vm.isSaving = false;
                $state.go('page-my-suffix-edit', {id: res.id}, {reload: true})
            }, function () {
                vm.isSaving = false;
            });
        }
        function createPage(data, part, editboxes) {
            var _page = {
                config:{
                    "dynamic":(data.dynamic ? true : false),
                    "monthIndex":0,
                    "monthMultiple":false,
                    "partid":part.code
                },
                isScene: false,
                bgImg: '',
                background: {resource: {},color:'#ffffff', type: "Color"},
                pagecover: {},
                levels: {},
                barcode: {},
                qrcode: {},
                editbox: editboxes.editbox[0],
                editboxes: editboxes,
                mediabox: {
                    height: part.pageSizeH,
                    width: part.pageSizeW,
                },
                trimbox: {
                    height: part.pageSizeH - Number(part.pageBloodB) - Number(part.pageBloodT),
                    width: part.pageSizeW - Number(part.pageBloodL) - Number(part.pageBloodR),
                    x: part.pageBloodL,
                    y: part.pageBloodT
                },
                scale: 1,
                proportion: 1,
                seq: 0,
                spread: part.spread,
                backup: false,
                unreplace: !data.replace
            }
            if (part.mould) {
                if(part.mould.modelType == 'TWO' || part.mould.modelType == 'NONE'){
                    part.mould.modelType = 'TWO';
                    _page.scene = {
                        background: {
                            resource: {
                                identifier: part.mould.modelPic.indexOf('http') > -1 ? part.mould.modelPic : vm.domainQ + part.mould.modelPic,
                                provider: "qiniu"
                            }
                        },
                        geometry: {
                            width: part.mould.gWidth,
                            height: part.mould.gHeight,
                            x: 0,
                            y: 0
                        },
                        imagebox: {
                            geometry: {
                                width: part.mould.width,
                                height: part.mould.height,
                                x: part.mould.x,
                                y: part.mould.y
                            },
                            rotation: {angle: 0},
                            transparency: 1,
                        },
                        hierarchy: part.mould.hierarchy,
                        mouldid: part.mould.id,
                        isScene: true,
                        scale: 1,
                        unit: "mm",
                        resource:{
                            identifier: part.mould.modelPic.indexOf('http') > -1 ? part.mould.modelPic : vm.domainQ + part.mould.modelPic,
                            provider: "qiniu"
                        }
                    }
                }
            }
            return _page;
        }
        $scope.gotoCreate1 = function (item, custom) {
            if (custom) {
                $uibModal
                    .open({
                        templateUrl:
                            "app/entities/page/modal/template-modal.html",
                        controller: "TemplateModalController",
                        controllerAs: "vm",
                        backdrop: "static",
                        resolve: {
                            entity: [
                                function () {
                                    return {
                                        type: "add",
                                        data: ""
                                    };
                                }
                            ]
                        }
                    })
                    .result.then(function (data) {
                        if (data) {
                        }
                    });
            } else {
                var _item = item;
                for (var j = _item.pageTemplates.length - 1; j >= 0; j--) {
                    if (!_item.pageTemplates[j].pageEdits) {
                        _item.pageTemplates[j].pageEdits = [
                            {
                                pageEditX: parseInt(
                                    _item.pageTemplates[j].pageEditX
                                ),
                                pageEditY: parseInt(
                                    _item.pageTemplates[j].pageEditY
                                ),
                                pageEditW: parseInt(
                                    _item.pageTemplates[j].pageEditW
                                ),
                                pageEditH: parseInt(
                                    _item.pageTemplates[j].pageEditH
                                )
                            }
                        ];
                    }
                    if (_item.pageTemplates[j].cancelled) {
                        _item.pageTemplates.splice(j, 1);
                    }
                }

                _item.pageSizeH = parseInt(_item.pageSizeH) - 0;
                _item.pageSizeW = parseInt(_item.pageSizeW) - 0;
                _item.pageBloodT = parseInt(_item.pageBloodT) - 0;
                _item.pageBloodB = parseInt(_item.pageBloodB) - 0;
                _item.pageBloodL = parseInt(_item.pageBloodL) - 0;
                _item.pageBloodR = parseInt(_item.pageBloodR) - 0;
                _item.pageEdits = parseInt(_item.pageEdits) - 0;
                if (!_item.pageEdits) {
                    _item.pageEdits = [
                        {
                            pageEditX: parseInt(_item.pageEditX),
                            pageEditY: parseInt(_item.pageEditY),
                            pageEditW: parseInt(_item.pageEditW),
                            pageEditH: parseInt(_item.pageEditH)
                        }
                    ];
                }
                _item.custom = vm.type;
                localStorage.setItem("page-new", JSON.stringify(_item));
                $state.go("page-my-suffix", { reload: true });
            }
        };

        $scope.productType = function (item) {
            switch (item) {
                case "BOOK":
                    return "照片书";
                case "PHOTO":
                    return "冲印";
                case "CALENDAR":
                    return "台历";
                case "THING":
                    return "万物";
                default:
                    return "";
            }
        };
        var createModal = function (url, controller, item, custom) {
            return $uibModal.open({
                templateUrl: url,
                controller: controller,
                backdrop: "static",
                keyboard: true,
                windowClass: "jh-modal-md",
                controllerAs: "vm",
                resolve: {
                    items: function () {
                        return {
                            type: "add",
                            data: item,
                            custom: custom
                        };
                    },
                    pagingParams: [
                        "$stateParams",
                        "PaginationUtil",
                        function ($stateParams, PaginationUtil) {
                            return {
                                page: PaginationUtil.parsePage(
                                    $stateParams.page
                                )
                            };
                        }
                    ],
                    translatePartialLoader: [
                        "$translate",
                        "$translatePartialLoader",
                        function ($translate, $translatePartialLoader) {
                            $translatePartialLoader.addPart("page");
                            return $translate.refresh();
                        }
                    ]
                }
            });
        };

        //    分类显示
        vm.userDefinedPage = 1;
        vm.userDefinedSize = paginationConstants.itemsPerPage;
        vm.search = search;
        vm.jump = jump;
        vm.pageCb = pageCb;
        vm.clear = clear;
        function jump() {
            vm.userDefinedPage = vm.jumpText <= 0 ? 1 : vm.jumpText;
            loadAll();
        }
        function pageCb() {
            loadAll();
        }
        function clear() {
            vm.searchQuery = "";
            loadAll();
        }
        //产品选择
        $scope.selectProduct = function (item) {
            if (vm.productSelected === item.value) return;
            vm.productSelected = item.value;
            vm.pageInfo.page = 1;
            loadAll();
        };
        //当前页变更
        vm.currentChange = function () {
            $timeout(function () {
                loadAll();
            });
        };
        function loadAll() {
            var items = [
                { key: "status", op: "=", value: true },
                { key: "cancelled", op: "=", value: "false" }
            ];
            if (vm.catalogView) {
                items.push({
                    key: "catalog.id",
                    op: "=",
                    value: vm.catalogView.id
                });
            }
            if (vm.searchQuery) {
                items.push({
                    key: "name",
                    op: "like",
                    value: vm.searchQuery
                });
            }
            if (vm.productSelected) {
                items.push({
                    key: "type",
                    op: "=",
                    value: vm.productSelected
                });
            }

            ProductTemplate.byCondition(
                {
                    items: items,
                    page: vm.pageInfo.page - 1,
                    size: vm.pageInfo.size,
                    sort: ["id,desc"]
                },
                function (data, headers) {
                    vm.pageInfo.total = headers("X-Total-Count");
                    vm.queryCount = vm.totalItems;
                    vm.userDefined = data;
                }
            );
        }
        vm.catalogView = $stateParams.catalogId ? {id:$stateParams.catalogId} : "";

        function timeoutInit() {
            Catalog.getAll3(
                {
                    items: [{ key: "usable", op: "=", value: "true" }],
                    sort: ["id,desc"]
                },
                function (res) {
                    vm.catalogs = res;
                    loadAll();
                }
            );
        }
        $scope.catalogCb = function (item) {
            if (item == "all") {
                vm.catalogView = "";
            } else {
                vm.catalogView = item;
            }
            vm.pageInfo.page = 1;
            loadAll();
        };

        function search() {
            //回车
            if(event.keyCode === 13){
                vm.pageInfo.page = 1;
                loadAll();
            }
        }
        $scope.operateLi = function (tempItem) {
            tempVersion(tempItem, function (temp) {
                $state.go(
                    "page-my-suffix-edit",
                    { id: temp.id },
                    { reload: true }
                );
            });
        };
        $scope.look = function (e) {
            if(!e.cover) return MessageService.error("暂无预览图");
            $uibModal.open({
                templateUrl: "app/entities/page/modal/recommend-look.html",
                controller: "RecommendLookController",
                controllerAs: "vm",
                backdrop: "static",
                resolve: {
                    entity: [
                        function () {
                            return {
                                url: vm.domainQ + e.cover
                            };
                        },
                    ],
                },
            });
        }
        function tempVersion(temp, callback) {
            if (temp.version != "4.0") {
                MessageService.confirm(
                    {
                        title: "提示",
                        cancel: "取消",
                        confirm: "确认",
                        msg: "系统全面更新，模板需升级方可使用，确认升级?",
                    },
                    function () {
                        $uibModal
                            .open({
                                templateUrl:
                                    "app/entities/page/modal/template-upgrade.html",
                                controller: "TemplateUpgradeController",
                                backdrop: "static",
                                keyboard: true,
                                windowClass: "jh-modal-md",
                                controllerAs: "vm",
                                size: "lg",
                                resolve: {
                                    entity: function () {
                                        return temp;
                                    },
                                    pagingParams: [
                                        "$stateParams",
                                        "PaginationUtil",
                                        function (
                                            $stateParams,
                                            PaginationUtil
                                        ) {
                                            return {
                                                page: PaginationUtil.parsePage(
                                                    $stateParams.page
                                                )
                                            };
                                        }
                                    ],
                                    translatePartialLoader: [
                                        "$translate",
                                        "$translatePartialLoader",
                                        function (
                                            $translate,
                                            $translatePartialLoader
                                        ) {
                                            $translatePartialLoader.addPart(
                                                "page"
                                            );
                                            return $translate.refresh();
                                        }
                                    ]
                                }
                            })
                            .result.then(function (data) {
                                if (data) {
                                    ProductXml.get(
                                        { id: temp.id },
                                        function (res) {
                                            callback(res);
                                        }
                                    );
                                }
                            });
                    }
                );
            } else {
                callback(temp);
            }
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('platformApp')
        .controller('PurchasedTemplateController', PurchasedTemplateController);

    PurchasedTemplateController.$inject = ['$state', '$scope', 'Qinius', '$uibModal', '$http', '$q', 'pagingParams', 'paginationConstants', '$timeout', '$stateParams', 'MessageService',
        'ProductXml', "Catalog", 'Hashtag', 'ParseLinks', '$localStorage', 'Account', 'ProductXmlPurchase','$window'];

    function PurchasedTemplateController($state, $scope, Qinius, $uibModal, $http, $q, pagingParams, paginationConstants, $timeout, $stateParams,  MessageService,
        ProductXml, Catalog , Hashtag, ParseLinks, $localStorage, Account, ProductXmlPurchase,$window) {

        var vm = this;
        vm.user = $localStorage.user;
        vm.productList = [];
        //分页信息
        vm.pageInfo = {
            page: 1,
            size: 20,
            total: 0
        }
        vm.pruchases = ProductXmlPurchase.getAllByCondition({items:[{key:"paid", op:"=", value:"true"} ,{key:"userId", op:"=", value:vm.user.id}]});
        vm.domain = Qinius.getDomain();
        $q.all([vm.domain.$promise]).then(function () {
            vm.domainQ =vm.domain.domain;
        })
        vm.getList = function () {
            ProductXml.getPurchasedList({page: vm.pageInfo.page - 1, size: vm.pageInfo.size}, function (data, headers) {
                vm.pageInfo.total = headers('X-Total-Count');
                vm.productList = data;
            })
        }
        vm.getList();
        //分页点击回调
        vm.currentChange = function(){
            $timeout(function (){
                vm.getList();
            })
        }
        //模板预览
        $scope.previewTemplate = function(template){
            console.log(template);
            if (template.version != "4.0") {
                MessageService.error("当前模板不可用");
                return;
            }
            ProductXml.get({id:template.id},function(data){
                createModal2('app/entities/page/template-view.html', 'TemplateViewController',data.id).result.then(
                    function (data) {
                    });
            });
            $(".modal-content").hide();
        };
        var createModal2 = function (url, controller,id) {
            return $uibModal.open({
                templateUrl: url,
                controller: controller,
                backdrop: 'static',
                keyboard: true,
                windowClass: "jh-modal-md",
                controllerAs: 'vm',
                resolve: {
                    entity: ['ProductXml', '$stateParams', function (ProductXml, $stateParams) {
                        return ProductXml.get({id: id}).$promise;
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('product');
                        $translatePartialLoader.addPart('productType');
                        return $translate.refresh();
                    }]
                }
            });
        };
        //使用模板
        $scope.useTemp = function(temp){
            if(temp.version != '4.0'){
                MessageService.error("当前模板不可用");
                return
            }
            if (temp.userId != vm.user.id && temp.price>0) {
                var items =[{key:"paid", op:"=", value:"true"},{key:"productXml.id", op:"=", value:temp.id},{key:"userId", op:"=", value:vm.user.id}];
                ProductXmlPurchase.getAllByCondition({items:items} , function(data){
                    if (data && data.length>=1) {
                        $scope.employ(temp);
                    }else{
                        MessageService.error("请先购买模板，再使用。");
                    }
                }, function(){
                    MessageService.error("查询购买记录失败，请稍后再试。");
                })
            }else{
                $scope.employ(temp);
            }
        }
        $scope.employ = function (temp) {
            ProductXml.get({id: temp.id}, function (res) {
                $uibModal.open({
                    templateUrl: 'app/entities/page/modal/page-standard.html',
                    controller: 'PageStandardController',
                    backdrop: 'static',
                    keyboard: true,
                    windowClass: "jh-modal-md",
                    controllerAs: 'vm',
                    resolve: {
                        items: function(){
                            return {
                                type: 'copy',
                                id: temp.id,
                                data: null
                            }
                        },
                        pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                            return {
                                page: PaginationUtil.parsePage($stateParams.page)
                            };
                        }],
                        translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                            $translatePartialLoader.addPart('page');
                            return $translate.refresh();
                        }]
                    }
                });
            })
        }

        //返回模板中心
        $scope.backToTemp = function () {
            history.back();
        }

    }

})();

(function () {
    'use strict';

    angular
        .module('platformApp')
        .controller('PageSimpleController', PageSimpleController);

    PageSimpleController.$inject = ['pages', '$rootScope', '$scope', '$state', '$uibModalInstance', '$q', 'documentpics', 'MessageService', 'UidService','ListService'];

    function PageSimpleController(pages, $rootScope, $scope, $state, $uibModalInstance, $q, documentpics, MessageService, UidService,ListService) {
        var vm = this;
        vm.documentpics = {
            documentpic:angular.copy(documentpics.arr)
        }
        vm.clear = clear;
        vm.save = save;
        vm.token = pages.token;
        $scope.domain = pages.domain;
        var pageCover = [];

        angular.forEach(pages.template.pages.page,function (p) {
            if(!p.backup&&p.pagecover&&p.pagecover.identifier){
                var res = p.pagecover.identifier.split($scope.domain).join("");
                pageCover.push({
                    name:res,
                    resource:{
                        identifier:res,
                        provider:"qiniu",
                    },
                    added: true,
                    uuid: UidService.get()
                })
            }

        })

        $scope.deletePic = function(index){
            vm.documentpics.documentpic.splice(index, 1);
        };

        function qiniuUpload(files) {
            var result = [];
            for (var i = files.length - 1; i >= 0; i--) {
                var file = files[i];
                var formData = new FormData();
                formData.append('file', file);
                formData.append('unique_names', false);
                formData.append('key', 'file' + file.name + UidService.get());
                formData.append('token', vm.token);
                $.ajax({
                    cache: true,
                    type: "POST",
                    url: 'https://upload.qiniup.com/',
                    data: formData,
                    async: true,
                    contentType: false,
                    processData: false,
                    success: function (data) {
                        result.push({ key:data.key})
                        if (result.length == files.length) {
                            result.sort(function(a, b){
                                return a.key.localeCompare(b.key);
                            })
                            if (vm.documentpics.documentpic == null) {
                                vm.documentpics.documentpic = [];
                            }
                            for (var j = 0 ; j< result.length ; j++) {
                                var seq = vm.documentpics.documentpic.length+1;
                                var r = result[j];
                                vm.documentpics.documentpic.push({
                                    name:r.key,
                                    seq:seq,
                                    resource:{
                                        identifier: $scope.domain + r.key,
                                        provider:"qiniu",
                                    },
                                    added: true
                                });
                            }
                            $scope.$apply();
                        }
                    },
                    error: function (request) {
                        MessageService.error("图片上传失败");
                    }
                });
            }

        }

        window.uploadPic = function ($event) {
            var files = $event.target.files;
            if (files !=null && files.length >0) {
                // qiniuUpload(files);
                var isSort = true;
                var arr = [];
                for (var i = 0; i< files.length  ; i++) {
                    var f = files[i];
                    arr.push(files[i])
                    var name = f.name.substring(0,f.name.indexOf('.'));
                    if (/^[\d\-]+$/.test(name)) {
                        files[i].name1 = name.replace('-','')
                    }else{
                        isSort = false;
                    }
                }
                if (isSort) {
                    arr.sort(function(a,b){
                        return a.name1 - b.name1
                    })
                }
                qiniuUpload(arr);
            }
        };

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        var unsubscribe = $rootScope.$on('editorApp:productXmlUpdate', function(event, result) {
            vm.productXml = result;
        });

        $scope.$on('$destroy', unsubscribe);

        function save() {

            vm.isSaving = false;
            $uibModalInstance.close(vm.documentpics);
        }

        $scope.generCover = function () {
            angular.forEach(pageCover,function (cover) {
                var result = ListService.inList(cover, vm.documentpics.documentpic, ["uuid"]);
                if(result){
                    cover.isAdd = true;
                }else{
                    cover.isAdd = false;
                }
            })
            console.log(pageCover)
            angular.forEach(pageCover,function (cover) {
                if(!cover.isAdd){
                    cover.seq = vm.documentpics.documentpic.length+1;
                    if(cover.name){
                        cover.name = cover.name.substring(cover.name.lastIndexOf("/")+1);
                    }
                    if(cover.resource && cover.resource.identifier){
                        cover.resource.identifier = $scope.domain + cover.resource.identifier.substring(cover.resource.identifier.lastIndexOf("/")+1);
                    }
                    vm.documentpics.documentpic.push(cover)
                }

            })
            console.log(vm.documentpics)
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('platformApp')
        .controller('PageSceneController', PageSceneController);

    PageSceneController.$inject = ['$scope', '$uibModalInstance', '$q', '$timeout', 'MessageService','pages', 'UidService'];

    function PageSceneController($scope, $uibModalInstance, $q, $timeout, MessageService,pages, UidService) {

        var vm = this;

        vm.clear = clear;
        vm.save = save;
        console.log(pages);
        vm.dpiChoose = [{data: 'mm', id: 0}, {data: 'px', id: 1}];
        $scope.dpi = vm.dpiChoose[0];

        vm.token = pages.token;
        $scope.domain = pages.domain;

        var unitTransform = function (mm) {
            // mm换算成px  Math.ceil(mm / 25.4 * 300);
            return (mm * 3) - 0;
        };
        var unitTransformPx = function (px) {
            // px换算成mm  Math.floor(px / 300 * 25.4)
            return (px * 1 / 3).toFixed(2) - 0;
        };

        $scope.scene = {
            isScene: true,
            background: {
                resource: {
                    provider: 'qiniu',
                    identifier: ''
                }
            },
            geometry: {
                width: unitTransform(420),
                height: unitTransform(285),
                x: unitTransform(0),
                y: unitTransform(0)
            },
            widthM: 420,
            heightM: 285,
            offsetXM: 0,
            offsetYM: 0,
            proportion: 1,
            scale: 1,
            unit: 'mm'
        }

        //模板背景图更改
        window.updateImgFile = function ($event) {
            $scope.$digest();
            $timeout(function () {
                var file = $event.target.files[0];
                var getBase64 = function (file, callback) {
                    var reader = new FileReader();      //用来把文件读入内存，并且读取文件中的数据
                    reader.readAsDataURL(file);         //将文件读取为DataURL,存在result中
                    reader.onload = function () {       //  成功读取
                        $('.sweet-alert .confirm').trigger("click");    //trigger触发被选元素的指定事件类型
                    };
                    reader.onerror = function (error) {     //  出错
                    };
                };
                getBase64(file, function (result) {
                });
                var formData = new FormData();
                formData.append('file', file);
                formData.append('key', 'background-' + UidService.get());
                formData.append('token', vm.token);
                $.ajax({
                    cache: true,
                    type: "POST",
                    url: 'https://upload.qiniup.com/',
                    data: formData,
                    async: false,
                    contentType: false,
                    processData: false,
                    success: function (data) {
                        $scope.scene.background.resource.identifier = $scope.domain + data.key;
                    },
                    error: function (request) {
                        MessageService.error("文件上传失败");
                    }
                });
            });
        };


        $scope.removeFile = function () {
            $scope.scene.background.resource.identifier = '';
        };

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        $scope.updateDpi = function (data) {

            if (data.id == 1) {
                $scope.scene.unit = 'px';
                var wah = ThreeHundredDpi($scope.scene.widthM, $scope.scene.heightM);
                $scope.scene.widthPx = wah.px1;
                $scope.scene.heightPx = wah.px2;
            } else {
                $scope.scene.unit = 'mm';
                var wah = ThreeHundredDpiToMm($scope.scene.widthPx, $scope.scene.heightPx);
                $scope.scene.widthM = wah.mm1;
                $scope.scene.heightM = wah.mm2;
            }


        }

        // mm---px
        function ThreeHundredDpi(attr1, attr2) {
            // Math.floor(px / 300 * 25.4)   (px--mm)
            // Math.ceil(mm / 25.4 * 300)   (mm---px)
            var px1 = parseFloat((attr1 / 25.4 * 300 - 0)).toFixed(2) - 0;
            var px2 = parseFloat((attr2 / 25.4 * 300 - 0)).toFixed(2) - 0;
            return {
                px1: px1,
                px2: px2
            }
        }

        // px---mm
        function ThreeHundredDpiToMm(attr1, attr2) {
            var mm1 = parseFloat((attr1 / 300 * 25.4 - 0)).toFixed(2) - 0;
            var mm2 = parseFloat((attr2 / 300 * 25.4 - 0)).toFixed(2) - 0;
            return {
                mm1: mm1,
                mm2: mm2
            }

        }

        $scope.validate = function () {
            // if (vm.page.pageSize == null || vm.page.pageSize == "") {
            //     MessageService.error("请设置页面尺寸");
            //     return false;
            // }
            // if (vm.page.bloodSize == null || vm.page.bloodSize == "") {
            //     MessageService.error("请设置出血尺寸");
            //     return false;
            // }
            // if (vm.page.name == null || vm.page.name == "") {
            //     MessageService.error("请输入作品名称");
            //     return false;
            // }
            // if (vm.page.pageNum == null || vm.page.pageNum == "") {
            //     MessageService.error("请输入页数");
            //     return false;
            // }
            return true;
        };

        function save() {
            if (!$scope.validate()) {
                return;
            }
            if ($scope.scene.unit == 'px') {
                var wah = ThreeHundredDpiToMm($scope.scene.widthPx, $scope.scene.heightPx);
                $scope.scene.widthM = wah.mm1;
                $scope.scene.heightM = wah.mm2;
            } else {
                var wah = ThreeHundredDpi($scope.scene.widthM, $scope.scene.heightM);
                $scope.scene.widthPx = wah.px1;
                $scope.scene.heightPx = wah.px2;
            }
            $scope.scene.geometry.width = unitTransform($scope.scene.widthM);
            $scope.scene.geometry.height = unitTransform($scope.scene.heightM);

            onSaveSuccess($scope.scene);
        }


        function onSaveSuccess(result) {
            console.log(result)

            vm.isSaving = false;
            $uibModalInstance.close(result);

        }

        function onSaveError() {
            vm.isSaving = false;
        }

    }

})();

(function () {
    'use strict';

    angular
        .module('platformApp')
        .controller('PageMySuffix2Controller', PageMySuffix2Controller);

    PageMySuffix2Controller.$inject = ['$state', '$scope', '$uibModal', '$http', '$q', '$timeout', '$stateParams', 'ImageService', 'MessageService',
        'ProductXml', 'UidService', 'ClipArts', 'SourceMaterial', 'ThirdPartySetting', 'FontManagement'];

    function PageMySuffix2Controller($state, $scope, $uibModal, $http, $q, $timeout, $stateParams, ImageService, MessageService,
                                     ProductXml, UidService, ClipArts, SourceMaterial, ThirdPartySetting, FontManagement) {
        var vm = this;
        $(".navbar").hide();
        $(".nav-bg").show();
        $(".wrap").css({margin: 0});
        var timer = null;
        localStorage.removeItem('ctrlKeyArray');
        $scope.thumbnailPic = false;
        vm.exitSure = false;
        var productXmlPage = $stateParams.pageIndex;
        var modelType = $stateParams.modelType;
        var modelData = $stateParams.modelData;
        var modelPath = unescape($stateParams.modelPath)
        // console.log(unescape($stateParams.modelPath))
        console.log(modelType)

        // 图片大小，增加七牛参数
        vm.menuImageView = menuImageView; //菜单栏
        vm.pageImageView = pageImageView; //画布内
        vm.pageImageViewOrient = pageImageViewOrient; //画布内加旋转参数

        ThirdPartySetting.getByKey({key: $stateParams.key}, function (data) {
            vm.thirds = data;
        }, function () {
            MessageService.error("配置信息 获取失败");
        });

        js_getDPI()
        function js_getDPI() {
            var arrDPI = new Array();
            if (window.screen.deviceXDPI != undefined) {
                arrDPI[0] = window.screen.deviceXDPI;
                arrDPI[1] = window.screen.deviceYDPI;
            }
            else {
                var tmpNode = document.createElement("DIV");
                tmpNode.style.cssText = "width:1in;height:1in;position:absolute;left:0px;top:0px;z-index:99;visibility:hidden";
                document.body.appendChild(tmpNode);
                arrDPI[0] = parseInt(tmpNode.offsetWidth);
                arrDPI[1] = parseInt(tmpNode.offsetHeight);
                tmpNode.parentNode.removeChild(tmpNode);
            }
            vm.windowDpiW = arrDPI[0];
            vm.windowDpiH = arrDPI[1];
            // vm.windowDpiW = 300;
            // vm.windowDpiH = 300;
            return arrDPI;
        }

        //键盘操作array
        vm.CtrlKeyArray = {imageboxes: [], textboxes: [], imagearts: [], barcode: [], qrcode: [], textdocuments: []};
        vm.singleArray = {imagebox: {}, textbox: {}, imageart: {}, barcode: {}, qrcode: {}, textdocument: {}};

        var unitTransform = function (mm) {
            // mm换算成px  Math.ceil(mm / 25.4 * 300);
            // return (mm * 3) - 0;
            return (mm / 25.4 * vm.windowDpiW).toFixed(2) - 0;
        };
        var unitTransformPx = function (px) {
            // px换算成mm  Math.floor(px / 300 * 25.4)
            // return (px * 1 / 3).toFixed(2) - 0;
            return (px / vm.windowDpiW * 25.4).toFixed(2) - 0;
        };

        vm.windowH = window.innerHeight - 90;

        vm.colorArr1 = ['#ffffff', '#666666', '#7babaf', '#e69594', '#93a9da', '#eac8fb'];
        vm.colorArr2 = ['#000000', '#666666', '#a8a8a8', '#d9d9d9', '#ffffff', '#647c6e', '#ff5b5c', '#ffbd4a', '#fef952', '#99e264', '#36b72a', '#44d9e5', '#c27171', '#2fb3ff', '#b760a6'];

        vm.sizeList = [
            {name: '12', id: '12'},
            {name: '13', id: '13'},
            {name: '14', id: '14'},
            {name: '15', id: '15'},
            {name: '16', id: '16'},
            {name: '17', id: '17'},
            {name: '18', id: '18'},
            {name: '19', id: '19'},
            {name: '20', id: '20'},
            {name: '22', id: '22'},
            {name: '24', id: '24'},
            {name: '26', id: '26'},
            {name: '28', id: '28'},
            {name: '30', id: '30'},
        ]
        vm.colorList = [
            {name: '#000000', id: '#000000'},
            {name: '#666666', id: '#666666'},
            {name: '#a8a8a8', id: '#a8a8a8'},
            {name: '#d9d9d9', id: '#d9d9d9'},
            {name: '#ffffff', id: '#ffffff'},
            {name: '#647c6e', id: '#647c6e'},
            {name: '#ffbd4a', id: '#ffbd4a'},
            {name: '#fef952', id: '#fef952'},
            {name: '#99e264', id: '#99e264'},
            {name: '#36b72a', id: '#36b72a'},
            {name: '#44d9e5', id: '#44d9e5'},
            {name: '#c27171', id: '#c27171'},
            {name: '#2fb3ff', id: '#2fb3ff'},
            {name: '#b760a6', id: '#b760a6'},
        ]

        /* ===============================================
         页面
         ================================================= */
        vm.units = [
            {name: 'px', id: 'px'},
            {name: 'mm', id: 'mm'}
        ];
        vm.unit = 'mm';
        var oldPage = null;

        var dpId = 0;
        vm.dpiChoose = [{data: 'mm', id: 0}, {data: 'px', id: 1}];
        $scope.dpi = vm.dpiChoose[dpId];
        $scope.dWidth = document.documentElement.clientWidth || document.body.clientWidth;
        $scope.dHeight = document.documentElement.clientHeight || document.body.clientHeight;
        // 左边操作栏 显示规则
        $scope.selPanel = 'page';
        // 右侧边栏 显示规则
        $scope.RightPanel = 'page';
        $scope.pageValue = {
            px: {width: 0, height: 0, x: 0, y: 0},
            mm: {width: 0, height: 0, x: 0, y: 0}
        }
        $scope.template = {
            transparency: 1,
            cover: {},
            scene: null,
            pageI: 0,
            angle: 0,
            backup: false,
            unreplace: false,
            spread: false,
            letterspacing: 0,
            lineheight: 0,
            text: '',
            bgimgs: {bgimg: []},
            bgimgs2: {bgimg: []},
            masks: {mask: []},
            cliparts: {clipart: []},
            documentpics: {documentpic: []},
            pages: {
                page: []
            }
        };
        $scope.selectBox = {
            current: 'page'
        }
        vm.backupPageSize = 0;

        /* ==========================================================================
         出血值
         ========================================================================== */
        var oldSizePx = 0, oldSizeMm = 0;

        function getBloodSize(page,i) {
            if (vm.unit == 'mm') {
                // mm
                page.blood = {
                    bottom: vm.page.pageBloodB,
                    left: vm.page.pageBloodL,
                    right: vm.page.pageBloodR,
                    top: vm.page.pageBloodT
                };
                page.bloodPx = {
                    top: unitTransform(vm.page.pageBloodT),
                    right: unitTransform(vm.page.pageBloodR),
                    bottom: unitTransform(vm.page.pageBloodB),
                    left: unitTransform(vm.page.pageBloodL),
                };
            } else {
                // px
                var tab = ThreeHundredDpiToMm(vm.page.pageBloodT, vm.page.pageBloodB);
                var lar = ThreeHundredDpiToMm(vm.page.pageBloodL, vm.page.pageBloodR);
                page.blood = {
                    top: tab.mm1,
                    bottom: tab.mm2,
                    left: lar.mm1,
                    right: lar.mm2,
                }
                page.bloodPx = {
                    top: unitTransform(tab.mm1),
                    bottom: unitTransform(tab.mm2),
                    left: unitTransform(lar.mm1),
                    right: unitTransform(lar.mm2),
                }
            }

            page.xayBorder = page.bloodPx.top + page.bloodPx.bottom;
            // page.mediabox.height = page.bloodPx.top + page.bloodPx.bottom + page.trimbox.height;
            // page.mediabox.width = page.bloodPx.left + page.bloodPx.right + page.trimbox.width;
            page.trimbox.height = page.mediabox.height - page.bloodPx.top - page.bloodPx.bottom;
            page.trimbox.width = page.mediabox.width - page.bloodPx.left - page.bloodPx.right;

            var mmL = page.blood.left - oldSizeMm.left;
            var mmT = page.blood.top - oldSizeMm.top;
            if (page.barcode && page.barcode.geometry) {
                page.barcode.geometry.x += unitTransform(mmL);
                page.barcode.geometry.y += unitTransform(mmT);
            }
            if (page.qrcode && page.qrcode.geometry) {
                page.qrcode.geometry.x += unitTransform(mmL);
                page.qrcode.geometry.y += unitTransform(mmT);
            }

            angular.forEach(page.levels.level, function (level) {
                if (level.imageart && level.imageart.current) {
                    level.imageart.geometry.x += unitTransform(mmL);
                    level.imageart.geometry.y += unitTransform(mmT);
                }
                if (level.imagebox && level.imagebox.current) {
                    level.imagebox.geometry.x += unitTransform(mmL);
                    level.imagebox.geometry.y += unitTransform(mmT);
                }
                if (level.textbox && level.textbox.current) {
                    level.textbox.geometry.x += unitTransform(mmL);
                    level.textbox.geometry.y += unitTransform(mmT);
                }
            })
            setOriginalWaH(page.trimbox.width, page.trimbox.height, i);
            // console.log(page)
            // console.log(page.mediabox)
        }

        /* ===============================================
         文字
         ================================================= */
        vm.fontNames = [];
        $scope.fontSizes = [];
        for (var f = 6; f < 101; f++) {
            $scope.fontSizes.push(f);
        }
        $scope.size = $scope.fontSizes[10];

        function myBrowser() {
            var userAgent = navigator.userAgent; //取得浏览器的userAgent字符串
            var isOpera = userAgent.indexOf("Opera") > -1;
            if (isOpera) {
                return "Opera"
            }
            ; //判断是否Opera浏览器
            if (userAgent.indexOf("Firefox") > -1) {
                return "FF";
            } //判断是否Firefox浏览器
            if (userAgent.indexOf("Chrome") > -1) {
                return "Chrome";
            }
            if (userAgent.indexOf("Safari") > -1) {
                return "Safari";
            } //判断是否Safari浏览器
            if (userAgent.indexOf("compatible") > -1 && userAgent.indexOf("MSIE") > -1 && !isOpera) {
                return "IE";
            }
            ; //判断是否IE浏览器
        }


        var mb = myBrowser();

        //得到原始模板框中最大宽高比例
        var $con = $(".content-scroll");
        var $contain = $(".content-page-main");
        var originalScale = $con.width() * 0.8 / ($con.height() * 0.8);
        vm.windowH = window.innerHeight - 50 - 42 -110;
        vm.windowW = window.innerWidth - 500;
        vm.windowH1 = 100;
        vm.windowW1 = 100;

        ProductXml.getThirdData({key: $stateParams.key}, function (res) {
            ProductXml.getDocumentByKey({
                key: $stateParams.identifier,
                domain: res.domain
            }, function (resp) {
                vm.token = res.token;
                vm.url = res.domain + '/';
                if (resp && resp.pages && resp.pages.page) {
                    resp.pages.page.forEach(function (page) {
                        if(page.levels && page.levels.level && page.levels.level.length>0){
                            page.levels.level.sort(compare('seq', true));
                        }
                    })
                    console.log(resp);
                    var pages = resp.pages.page;
                    var page = pages[0];
                    vm.top = page.trimbox.y;
                    vm.bottom = page.mediabox.height - page.trimbox.height - page.trimbox.y;
                    vm.left = page.trimbox.x;
                    vm.right = page.mediabox.width - page.trimbox.width - page.trimbox.x;

                    vm.page = {
                        name: $stateParams.xmlName,
                        pageSize: {width: page.mediabox.width, height: page.mediabox.height},
                        bloodSize: {top: vm.top, bottom: vm.bottom, left: vm.left, right: vm.right},
                        pageBloodT:vm.top,
                        pageBloodB:vm.bottom,
                        pageBloodL:vm.left,
                        pageBloodR:vm.right,
                        pageNum: pages.length,
                        dpi: $scope.dpi,
                        bindingtype: resp.bindingtype,
                        replace: $stateParams.replace
                    };
                    if (page.editbox) {
                        vm.page.editbox = {
                            x: page.editbox.x, y: page.editbox.y, width: page.editbox.width, height: page.editbox.height
                        }
                    }
                    dpId = 0;
                    vm.page.provider = 'qiniu';
                    vm.page.identifier = $stateParams.identifier;

                    if (vm.page.pageNum > 1) {
                        $scope.visibleRight = true;
                    }

                    $scope.template = angular.copy(resp);
                    $scope.template.bgimgs = angular.copy(resp.bgimgs);
                    $scope.template.bgimgs2 = angular.copy(resp.bgimgs2);
                    $scope.template.masks = angular.copy(resp.masks);
                    $scope.template.cliparts = angular.copy(resp.cliparts);
                    $scope.template.pages = angular.copy(resp.pages);
                    $scope.template.documentpics = angular.copy(resp.documentpics);
                    if ($scope.template.documentpics == null) {
                        $scope.template.documentpics = {
                            documentpic: []
                        }
                    }
                    if ($scope.template.documentpics.documentpic == null) {
                        $scope.template.documentpics.documentpic = [];
                    }
                    var trimbox = resp.pages.page[0].trimbox;
                    // console.log($scope.template)
                    // console.log(vm.page)

                    pagesToPx(resp.pages.page,$scope.template.pages,'pages')
                    if(resp.deletedPages&&resp.deletedPages.page&&resp.deletedPages.page.length){
                        pagesToPx(resp.deletedPages.page,$scope.template.deletedPages)
                    }
                    $scope.template.width = unitTransform(trimbox.width);
                    $scope.template.height = unitTransform(trimbox.height);
                    var pageSize = vm.page.pageSize;
                    var pages = $scope.template.pages.page;
                    $scope.currentPage = pages[0];
                    $scope.lastPage = pages[0];
                    setUlWidth();
                    getImageboxLen();
                    loadAttribute();

                    oldSizePx = angular.copy(pages[0].bloodPx);
                    oldSizeMm = angular.copy(pages[0].blood);
                    oldSizeMm.left = trimbox.x;
                    oldSizeMm.top = trimbox.y;

                    $scope.template.pageI = 0;
                    $scope.template.levelI = 0;
                    setTimeout(function () {
                        oldPage = angular.copy(pages[0]);
                        // console.log(oldPage);
                    },2000)
                    // console.log($scope.template.pages.page)
                    setMargin();
                }
                $scope.history = [angular.copy($scope.template)];
                $scope.currentHistoryIndex = 0;
                $scope.pageHistory = [{
                    history: [angular.copy($scope.template.pages.page[0])],
                    currentHistoryIndex: 0
                }];
                // console.log($scope.template)
                if($scope.template.pages.page[0].scene){
                    vm.isCustom = false;
                }else {
                    vm.isCustom = true;
                }

            });
        })
        function getImageSource(item) {
            var width = item.image.resource.width;
            var height = item.image.resource.height;

            var _w = item.geometry.width;
            var _h = item.geometry.height;
            var bgImgR = width/height;
            var bgImgR1 = _w/_h;
            item.image.offsetx = 0;
            item.image.offsety = 0;
            if(bgImgR >= bgImgR1){
                item.image.adaptation = 'Height';
                item.image.height = _h;
                item.image.width = _h/height*width;
            }else {
                item.image.adaptation = 'Width';
                item.image.width = _w;
                item.image.height = _w/width*height;
            }
        }


        $scope.$watch('toggle.now', function () {
            if ($scope.toggle.now) {
                // console.log($scope.template.bgimgs2.bgimg)
                setTimeout(function () {
                    waterFall('main0');
                    $scope.$digest();
                }, 600);
            }
        });

        $scope.toggle = {
            now: false
        };
        /**
         * 宽高坐标从 mm 换算成 px
         * @param obj
         * @param index
         * @returns {{height: number, width: number, x: number, y: number}}
         */
        function getGeometry(obj) {
            return {
                height: unitTransform(obj.height),
                width: unitTransform(obj.width),
                x: unitTransform(obj.x),
                y: unitTransform(obj.y)
            }
        }

        var elem = document.querySelector('input[type="range"]');

        var rangeValue = function () {
            $(".transparency-num").val(elem.value);
            $scope.selectBox.transparency = parseFloat(elem.value);
            $scope.template.transparency = elem.value * 100;

            $scope.$digest();
        };

        elem.addEventListener("input", rangeValue);

        $scope.transparencyChange = function (attr) {
            var level = $scope.currentPage.levels.level[$scope.template.levelI];
            if ($scope.template.transparency > 100) {
                MessageService.error("透明度有效范围：0~100");
                $scope.template.transparency = 100;
            }
            $(elem).val($scope.template.transparency / 100);
            level[$scope.selectBox.current].transparency = $scope.template.transparency / 100;
            updateHistorys();
        }

        // 左边侧边栏点击切换
        $scope.selectPanel = function (attr) {
            if ($scope.selPanel == attr) {
                $scope.hidePanel(1);
                return
            }
            vm.leftShow = true;
            $(".leftPanel-mainContent").removeClass('hide1');
            $(".rightPanel").removeClass('rightPanel-big rightPanel-big1 rightPanel-big2 rightPanel-big3');
            if (attr == 'page') {
                if (vm.unit == 'mm') {
                    $scope.pageValue.mediabox.width = unitTransformPx($scope.currentPage.mediabox.width);
                    $scope.pageValue.mediabox.height = unitTransformPx($scope.currentPage.mediabox.height);
                } else {
                    $scope.pageValue.mediabox.width = $scope.currentPage.mediabox.width;
                    $scope.pageValue.mediabox.height = $scope.currentPage.mediabox.height;
                }

                $scope.RightPanel = 'page';
                $scope.selPanel = attr;
                setTimeout(function () {
                    waterFall('main0');
                }, 200);
            }

            if (attr == 'design') {
                if (vm.unit == 'mm') {
                    $scope.pageValue.mediabox.width = unitTransformPx($scope.currentPage.mediabox.width);
                    $scope.pageValue.mediabox.height = unitTransformPx($scope.currentPage.mediabox.height);
                } else {
                    $scope.pageValue.mediabox.width = $scope.currentPage.mediabox.width;
                    $scope.pageValue.mediabox.height = $scope.currentPage.mediabox.height;
                }
                $scope.RightPanel = 'page';
                $scope.selPanel = attr;
                setTimeout(function () {
                    waterFall('main0');
                }, 200);
            }

            if (attr == 'placement') {
                if ($scope.currentPage.scene) {
                    $scope.pageValue.mm = {
                        width: 170,
                        height: 120,
                        x: 12,
                        y: 12
                    }
                    $(".temp-px").addClass('hide1');
                    $(".temp-mm").removeClass('hide1');

                    $scope.currentPage.imagebox = {
                        geometry: {
                            width: unitTransform($scope.pageValue.mm.width),
                            height: unitTransform($scope.pageValue.mm.height),
                            x: unitTransform($scope.pageValue.mm.x),
                            y: unitTransform($scope.pageValue.mm.y)
                        }, rotation: {
                            angle: 0
                        },
                        widthM: $scope.pageValue.mm.width,
                        heightM: $scope.pageValue.mm.height,
                        offsetXM: $scope.pageValue.mm.x,
                        offsetYM: $scope.pageValue.mm.y,
                    }
                    $scope.selectScene();
                } else {
                    addPlacement();
                }
                $scope.RightPanel = 'placement';
            }
            if (attr == 'barcode') {
                $scope.selPanel = 'barcode';
                $scope.RightPanel = 'barcode';
            }
            if (attr == 'qrcode') {
                $scope.selPanel = 'qrcode';
                $scope.RightPanel = 'qrcode';
            }

            if (attr == 'text') {
                $scope.selPanel = 'text';
            }

            if (attr == 'mask') {
                $scope.RightPanel = $scope.selPanel;
                $scope.selPanel = attr;
                setTimeout(function () {
                    waterFall('main2');
                }, 200);

                $scope.selPanel = attr;
            }

            if (attr == 'material') {
                $scope.RightPanel = $scope.selPanel;
                $scope.selPanel = attr;
                setTimeout(function () {
                    var h = $(".leftPanel-head").height() + 50;
                    $(".clipart-con").css({height: 'calc(100vh - ' + h + 'px)'});
                    if(mb=='FF'){
                        $(".leftPanel-con li").addClass('mar-left-6');
                    }
                }, 200);

                $scope.selPanel = attr;
            }

            if (attr == 'backup') {
                $scope.selPanel = attr;
            }
            if (attr == 'backup' && 0 == vm.backupPageSize) {
                vm.backupPageSize = 20;
            }
        }

        $scope.shezhi = false;
        $scope.darkTheme = false;
        $scope.shezhiClick = function () {
            $scope.shezhi = !$scope.shezhi;
        }

        /* ==========================================================================
         模板处理
         ========================================================================== */
        //删除模板背景图片
        $scope.deleteBgImg = function () {
            if ($scope.template.pages.page[$scope.template.pageI].bgImg == '') {
                return;
            }
            $scope.template.pages.page[$scope.template.pageI].bgImg = '';
            $scope.template.pages.page[$scope.template.pageI].background.resource.identifier = '';
            $scope.template.pages.page[$scope.template.pageI].hasBgImg = false;
            updateHistorys();
        };

        //模板预览点击时
        $scope.selectPages = function (index, e) {
            fn(e)
            if (index == null) {
                return;
            }
            $scope.lastPage = $scope.template.pages.page[$scope.template.pageI];
            // console.log($scope.template.pageI)
            setTimeout(function () {
                checkPageCover();
            })
            // var nodes = document.getElementsByClassName('pageNode');
            // setThumbnailPic(nodes[$scope.template.pageI], $scope.currentPage);
            // if (index !== $scope.template.pageI) {
            //     $(".bg-image").attr('src', '');
            // }
            $scope.template.pageI = index;
            $scope.RightPanel = 'page';
            isCanLeftAndRightPage();
            getPagePx();
            canvasInfo();
        };

        var setUlWidth = function () {
            var w = 30 + 50, w1 = 44;
            var seq = 1;
            angular.forEach($scope.template.pages.page, function (page) {
                if (!page.scene&&!page.backup) {
                    w += page.mediabox.width * 98 / page.mediabox.height + 16;
                }
                if(!page.editboxes || !page.editboxes.editbox){
                    page.editboxes={
                        editbox: [page.editbox]
                    }
                }
                if(!page.backup){
                    page.seq = seq++;
                }
                if (page.scene) {
                    var scene = page.scene;
                    w += scene.geometry.width * 98 / scene.geometry.height + 16;
                }
            });
            $(".sort-ul").width(w + 'px');
            if (mb == 'FF') {
                $(".leftPanel-con li").addClass('mar-left-6');
            }
        };

        $scope.sortableOptions = {
            // 数据有变化
            update: function (e, ui) {
                $timeout(function () {
                    var resArr = [];
                    angular.forEach($scope.template.pages.page, function (page, i) {
                        var x = 0;
                        angular.forEach(page.levels.level, function (level, l) {
                            if (level.imagebox && level.imagebox.geometry) {
                                x++;
                            }
                        })
                        resArr.push(x)
                    })
                })
            },

            // 完成动作
            stop: function (e, ui) {
                //do nothing
                isCanLeftAndRightPage();
            },
            items: "li:not(.not-sortable)"
        };

        //模板宽高onchange
        $scope.updateTemplateHeightAndWidth = function () {
            var i = $scope.template.pageI;
            var currentPage = $scope.template.pages.page[i];
            if(!currentPage){
                return
            }
            if (vm.unit == 'px') {
                // px---mm
                vm.page.pageSize.width = unitTransformPx($scope.pageValue.mediabox.width);
                vm.page.pageSize.height = unitTransformPx($scope.pageValue.mediabox.height);
                currentPage.mediabox.width = $scope.pageValue.mediabox.width;
                currentPage.mediabox.height = $scope.pageValue.mediabox.height;

            } else {

                vm.page.pageSize.width = $scope.pageValue.mediabox.width;
                vm.page.pageSize.height = $scope.pageValue.mediabox.height;
                currentPage.mediabox.width = unitTransform($scope.pageValue.mediabox.width);
                currentPage.mediabox.height = unitTransform($scope.pageValue.mediabox.height);
            }
            currentPage.trimbox.width = currentPage.mediabox.width - currentPage.bloodPx.left - currentPage.bloodPx.right;
            currentPage.trimbox.height = currentPage.mediabox.height - currentPage.bloodPx.top - currentPage.bloodPx.bottom;
            setOriginalWaH(currentPage.trimbox.width, currentPage.trimbox.height, i);
            setUlWidth();
            resetBackground();
        };

        //初始化像素
        function loadAttribute() {
            if (vm.unit == 'mm') {
                //属性栏
                $scope.pageValue = {
                    mediabox: {
                        width: unitTransformPx($scope.currentPage.mediabox.width),
                        height: unitTransformPx($scope.currentPage.mediabox.height)
                    },
                    editbox: {
                        width: unitTransformPx($scope.currentPage.editbox.width),
                        height: unitTransformPx($scope.currentPage.editbox.height),
                        x: unitTransformPx($scope.currentPage.editbox.x),
                        y: unitTransformPx($scope.currentPage.editbox.y)
                    },
                    barcode: {
                        width: '',
                        height: '',
                        x: '',
                        y: ''
                    },
                    qrcode: {
                        width: '',
                        height: '',
                        x: '',
                        y: ''
                    },
                    imagebox: {
                        width: '',
                        height: '',
                        x: '',
                        y: ''
                    },
                    imageart: {
                        width: '',
                        height: '',
                        x: '',
                        y: '',
                    },
                    textbox: {
                        width: '',
                        height: '',
                        x: '',
                        y: '',
                    },
                    textdocument: {
                        width: '',
                        height: '',
                        x: '',
                        y: '',
                    }
                }
            }
            if (vm.unit == 'px') {
                //属性栏
                $scope.pageValue = {
                    mediabox: {
                        width: $scope.currentPage.mediabox.width,
                        height: $scope.currentPage.mediabox.height
                    },
                    editbox: {
                        width: $scope.currentPage.editbox.width,
                        height: $scope.currentPage.editbox.height,
                        x: $scope.currentPage.editbox.x,
                        y: $scope.currentPage.editbox.y
                    },
                    barcode: {
                        width: '',
                        height: '',
                        x: '',
                        y: ''
                    },
                    qrcode: {
                        width: '',
                        height: '',
                        x: '',
                        y: ''
                    },
                    imagebox: {
                        width: '',
                        height: '',
                        x: '',
                        y: ''
                    },
                    imageart: {
                        width: '',
                        height: '',
                        x: '',
                        y: '',
                    },
                    textbox: {
                        width: '',
                        height: '',
                        x: '',
                        y: '',
                    },
                    textdocument: {
                        width: '',
                        height: '',
                        x: '',
                        y: '',
                    }
                }
            }
            // console.log($scope.pageValue)
            // console.log($scope.currentPage)
        }

        //单位换算
        $scope.unitConversion = function () {
            unit()
        }

        function unit() {
            if (vm.unit == 'mm') {
                $scope.pageValue = {
                    mediabox: {
                        width: unitTransformPx($scope.currentPage.mediabox.width),
                        height: unitTransformPx($scope.currentPage.mediabox.height)
                    },
                    editbox: {
                        width: unitTransformPx($scope.currentPage.editbox.width),
                        height: unitTransformPx($scope.currentPage.editbox.height),
                        x: unitTransformPx($scope.currentPage.editbox.x),
                        y: unitTransformPx($scope.currentPage.editbox.y)
                    },
                    barcode: {
                        width: unitTransformPx($scope.pageValue.barcode.width),
                        height: unitTransformPx($scope.pageValue.barcode.height),
                        x: unitTransformPx($scope.pageValue.barcode.x),
                        y: unitTransformPx($scope.pageValue.barcode.y)
                    },
                    qrcode: {
                        width: unitTransformPx($scope.pageValue.qrcode.width),
                        height: unitTransformPx($scope.pageValue.qrcode.height),
                        x: unitTransformPx($scope.pageValue.qrcode.x),
                        y: unitTransformPx($scope.pageValue.qrcode.y)
                    },
                    imagebox: {
                        width: unitTransformPx($scope.pageValue.imagebox.width),
                        height: unitTransformPx($scope.pageValue.imagebox.height),
                        x: unitTransformPx($scope.pageValue.imagebox.x),
                        y: unitTransformPx($scope.pageValue.imagebox.y)
                    },
                    imageart: {
                        width: unitTransformPx($scope.pageValue.imageart.width),
                        height: unitTransformPx($scope.pageValue.imageart.height),
                        x: unitTransformPx($scope.pageValue.imageart.x),
                        y: unitTransformPx($scope.pageValue.imageart.y)
                    },
                    textbox: {
                        width: unitTransformPx($scope.pageValue.textbox.width),
                        height: unitTransformPx($scope.pageValue.textbox.height),
                        x: unitTransformPx($scope.pageValue.textbox.x),
                        y: unitTransformPx($scope.pageValue.textbox.y)
                    },
                    textdocument: {
                        width: unitTransformPx($scope.pageValue.textdocument.width),
                        height: unitTransformPx($scope.pageValue.textdocument.height),
                        x: unitTransformPx($scope.pageValue.textdocument.x),
                        y: unitTransformPx($scope.pageValue.textdocument.y)
                    },
                }
            }
            if (vm.unit == 'px') {
                $scope.pageValue = {
                    mediabox: {
                        width: $scope.currentPage.mediabox.width,
                        height: $scope.currentPage.mediabox.height
                    },
                    editbox: {
                        width: $scope.currentPage.editbox.width,
                        height: $scope.currentPage.editbox.height,
                        x: $scope.currentPage.editbox.x,
                        y: $scope.currentPage.editbox.y
                    },
                    barcode: {
                        width: unitTransform($scope.pageValue.barcode.width),
                        height: unitTransform($scope.pageValue.barcode.height),
                        x: unitTransform($scope.pageValue.barcode.x),
                        y: unitTransform($scope.pageValue.barcode.y)
                    },
                    qrcode: {
                        width: unitTransform($scope.pageValue.qrcode.width),
                        height: unitTransform($scope.pageValue.qrcode.height),
                        x: unitTransform($scope.pageValue.qrcode.x),
                        y: unitTransform($scope.pageValue.qrcode.y)
                    },
                    imagebox: {
                        width: unitTransform($scope.pageValue.imagebox.width),
                        height: unitTransform($scope.pageValue.imagebox.height),
                        x: unitTransform($scope.pageValue.imagebox.x),
                        y: unitTransform($scope.pageValue.imagebox.y)
                    },
                    imageart: {
                        width: unitTransform($scope.pageValue.imageart.width),
                        height: unitTransform($scope.pageValue.imageart.height),
                        x: unitTransform($scope.pageValue.imageart.x),
                        y: unitTransform($scope.pageValue.imageart.y)
                    },
                    textbox: {
                        width: unitTransform($scope.pageValue.textbox.width),
                        height: unitTransform($scope.pageValue.textbox.height),
                        x: unitTransform($scope.pageValue.textbox.x),
                        y: unitTransform($scope.pageValue.textbox.y)
                    },
                    textdocument: {
                        width: unitTransform($scope.pageValue.textdocument.width),
                        height: unitTransform($scope.pageValue.textdocument.height),
                        x: unitTransform($scope.pageValue.textdocument.x),
                        y: unitTransform($scope.pageValue.textdocument.y)
                    }
                }
            }
            // console.log($scope.pageValue)
        }

        function resetBackground() {
            var background = $scope.currentPage.background;
            if (background.resource && background.resource.identifier) {
                var pageW = $scope.currentPage.mediabox.width / $scope.currentPage.proportion;
                var pageH = $scope.currentPage.mediabox.height / $scope.currentPage.proportion;

                var bgW = background.resource.width;
                var bgH = background.resource.height;
                // 高适配
                var adaptation = 'Height', h = pageH, w = pageH * bgW / bgH;
                // 宽适配
                if ((bgW <= bgH || pageW <= pageH) && (bgW / bgH < pageW / pageH) || bgW >= bgH && pageW >= pageH && (bgW / bgH < pageW / pageH)) {
                    w = pageW;
                    h = pageW * bgH / bgW;
                    adaptation = 'Width';
                }
                var pro = $scope.currentPage.scale / $scope.currentPage.proportion
                background.offsetx = 0;
                background.offsety = 0;
                background.widthM = unitTransformPx(w / pro);
                background.heightM = unitTransformPx(h / pro);
                background.width = w / pro;
                background.height = h / pro;
                background.resource.width = bgW;
                background.resource.height = bgH;
                background.adaptation = adaptation;
                background.scale = 1;
            }
        }

        //模板宽高onchange
        $scope.updateEditbox = function () {
            var i = $scope.template.pageI;
            var currentPage = $scope.template.pages.page[i];
            if (vm.unit == 'mm') {
                currentPage.editbox = {
                    width: unitTransform($scope.pageValue.editbox.width),
                    height: unitTransform($scope.pageValue.editbox.height),
                    x: unitTransform($scope.pageValue.editbox.x),
                    y: unitTransform($scope.pageValue.editbox.y)
                }
            }
            if (vm.unit == 'px') {
                currentPage.editbox = {
                    width: $scope.pageValue.editbox.width,
                    height: $scope.pageValue.editbox.height,
                    x: $scope.pageValue.editbox.x,
                    y: $scope.pageValue.editbox.y
                }
            }
            $scope.currentPage = currentPage

        };

        function waterFall(main) {
            var lis = $('#' + main).children('li');
            var liw = 100;
            var counts = 2;
            var arr = [],arr2=[],arr3 = [];
            lis.each(function (index, value) {//index索引值和当前的值
                if (index < counts) {
                    arr.push(lis.eq(index).innerHeight())
                    arr2.push(lis.eq(index).innerHeight());
                } else {
                    var minH = Math.min.apply(null, arr);
                    var minIndex = $.inArray(minH, arr);
                    arr2.push(minH + 30);
                    lis.eq(index).css({
                        'position': 'absolute',
                        'top': (minH + 30) + 'px',
                        'left': minIndex == 0 ? (minIndex * liw + 5) + 'px' : (minIndex * liw + 15) + 'px'
                    });
                    arr[minIndex] += lis.eq(index).innerHeight() + 10;
                    // console.log(arr)
                }
            });

            for(var i = 0;i<arr2.length;i++){
                var a1 = arr2[i];
                var a2 = arr2[i+2];
                arr3.push(a2-a1);
            }
            // console.log(arr3)

            if(arr3.length<4){
                return
            }
            var t = 1;
            for(var i = 1; i < arr3.length; i++) {
                if(arr3[2]==arr3[i]){
                    t++;
                }
            }
            if(t+4==arr3.length){
                setTimeout(function () {
                    waterFall(main);
                    $scope.$digest();
                }, 600);
            }
            // console.log(arr3.length)
            // console.log(t)

        }

        $scope.deleteLeftPanelPic = function (index, e) {
            fn(e);
            $(".art-click").hide();
            if ($scope.selPanel == 'page') {
                $scope.template.bgimgs2.bgimg.splice(index, 1);
                setTimeout(function () {
                    $scope.$digest();
                    waterFall('main0');
                }, 100);
            } else if ($scope.selPanel == 'design') {
                $scope.template.bgimgs.bgimg.splice(index, 1);
                setTimeout(function () {
                    $scope.$digest();
                    waterFall('main3');
                }, 100);

            } else if ($scope.selPanel == 'mask') {
                $scope.template.masks.mask.splice(index, 1);
                setTimeout(function () {
                    $scope.$digest();
                    waterFall('main2');
                }, 100);
            } else {
                $scope.template.cliparts.clipart.splice(index, 1);
            }
        };

        window.doubleClickbgImg = function (e,item) {
            fn(e);
            var currentPage = $scope.currentPage = $scope.template.pages.page[$scope.template.pageI];
            if (currentPage.background && currentPage.background.resource && currentPage.background.resource.identifier) {
                if(item){
                    $scope.cutImage1(currentPage, $scope.template.pageI);
                }else {
                    $scope.cutImage(currentPage, $scope.template.pageI);
                }
            }
            return
        }

        /**
         * 进入图片编辑模式
         */
        $scope.cutImage = function (page, pageI) {
            $scope.w = $('.bg-image' + pageI).width();
            $scope.h = $('.bg-image' + pageI).height();
            var pro = $scope.currentPage.scale / $scope.currentPage.proportion;

            $scope.pageW = $scope.currentPage.mediabox.width / $scope.currentPage.proportion * $scope.currentPage.scale;
            $scope.pageH = $scope.currentPage.mediabox.height / $scope.currentPage.proportion * $scope.currentPage.scale;
            $scope.showCut = true;
            $scope.showImageMenu = false;
            $("#cut-mask").attr('src', '');

            var background = $scope.currentPage.background;
            background.width = $scope.w / pro;
            background.height = $scope.h / pro;

            // 显示区域（包含上/下页按钮）
            var bodyW = $(".body-content").width();
            var bodyH = $(".body-content").height();

            // 裁切框显示位置
            var left = $scope.l = parseFloat($(".page-item").css('marginLeft'));
            var top = $scope.t = parseFloat($(".page-item").css('marginTop'));
            $("#cut-img").css({left: left + background.offsetx * pro, top: top + background.offsety * pro});

            ImageService.convertImgToBase64('content/images/white.png', function (s) {
                var imagecanvas = $("#mask-canvas")[0];
                var imagecontext = imagecanvas.getContext('2d');
                var newImg = document.createElement('img');
                // newImg.crossOrigin = "Anonymous";
                newImg.src = 'content/images/zhezhao1.png';
                newImg.onload = function () {
                    newImg.onload = null;
                    var masks = document.createElement('img');
                    masks.src = 'content/images/white.png';
                    // masks.crossOrigin = "Anonymous";
                    masks.onload = function () {
                        masks.onload = null;
                        imagecanvas.width = bodyW;
                        imagecanvas.height = bodyH;
                        imagecontext.drawImage(masks, left, top, $scope.pageW, $scope.pageH);
                        imagecontext.globalCompositeOperation = 'source-out';
                        imagecontext.drawImage(newImg, 0, 0, bodyW, bodyH);

                        $("#cut-mask").attr('src', ImageService.dataURLtoBlob(imagecanvas.toDataURL()));

                        $scope.$digest();
                    };
                    // masks.src = box.maskUrl;
                };
                newImg.src = 'content/images/zhezhao1.png';
            });
        };
        $scope.cutImage1 = function (page, pageI) {
            $scope.w = $('.bg-image1' + pageI).width();
            $scope.h = $('.bg-image1' + pageI).height();
            var pro = $scope.currentPage.scene.ratio;

            $scope.pageW = $scope.currentPage.mediabox.width*$scope.currentPage.scene.ratio;
            $scope.pageH = $scope.currentPage.mediabox.height*$scope.currentPage.scene.ratio;
            $scope.showCut = true;
            $scope.showImageMenu = false;
            $("#cut-mask").attr('src', '');

            var background = $scope.currentPage.background;
            background.width = $scope.w / pro;
            background.height = $scope.h / pro;

            // 显示区域（包含上/下页按钮）
            var bodyW = $(".body-content").width();
            var bodyH = $(".body-content").height();

            // 裁切框显示位置
            var left = $scope.l = parseFloat($(".page-item1").css('marginLeft')) + $scope.currentPage.scene.imagebox.geometry.x * pro;
            var top = $scope.t = parseFloat($(".page-item1").css('marginTop')) + $scope.currentPage.scene.imagebox.geometry.y * pro;
            $("#cut-img").css({left: left + background.offsetx * pro, top: top + background.offsety * pro});

            ImageService.convertImgToBase64('content/images/white.png', function (s) {
                var imagecanvas = $("#mask-canvas")[0];
                var imagecontext = imagecanvas.getContext('2d');
                var newImg = document.createElement('img');
                // newImg.crossOrigin = "Anonymous";
                newImg.src = 'content/images/zhezhao1.png';
                newImg.onload = function () {
                    newImg.onload = null;
                    var masks = document.createElement('img');
                    masks.src = 'content/images/white.png';
                    // masks.crossOrigin = "Anonymous";
                    masks.onload = function () {
                        masks.onload = null;
                        imagecanvas.width = bodyW;
                        imagecanvas.height = bodyH;
                        imagecontext.drawImage(masks, left, top, $scope.pageW, $scope.pageH);
                        imagecontext.globalCompositeOperation = 'source-out';
                        imagecontext.drawImage(newImg, 0, 0, bodyW, bodyH);

                        $("#cut-mask").attr('src', ImageService.dataURLtoBlob(imagecanvas.toDataURL()));

                        $scope.$digest();
                    };
                    // masks.src = box.maskUrl;
                };
                newImg.src = 'content/images/zhezhao1.png';
            });
        };

        var drag = false;
        var dragBox = {};
        /**
         * 拖拽编辑的图片
         */
        window.startEdit = function (e) {
            fn(e);

            dragBox.clientX = e.clientX ? e.clientX : 0;
            dragBox.clientY = e.clientY ? e.clientY : 0;
            dragBox.picW = $("#cut-img").width();
            dragBox.picH = $("#cut-img").height();
            var background = $scope.currentPage.background;
            var pro = $scope.currentPage.scale / $scope.currentPage.proportion
            dragBox.coordX = background.offsetx * pro;
            dragBox.coordY = background.offsety * pro;

            drag = true;
            document.addEventListener("mousemove", dragEdit, true);
            document.addEventListener("mouseup", stopEdit, true);
        };

        function dragEdit(e) {

            if (drag) {
                var background = $scope.currentPage.background;
                var x = 0, y = 0;

                //手指离开屏幕
                if (background.adaptation == 'Height') {    //宽图
                    x = (dragBox.coordX + (e.clientX - dragBox.clientX));
                    //向左滑动;        <-----
                    if (-x >= ($scope.w - $scope.pageW)) {
                        x = -($scope.w - $scope.pageW);
                    }
                    // 向右滑动;    ---->
                    if (x >= 0) {
                        x = 0;
                    }
                } else {     //高图
                    y = (dragBox.coordY + (e.clientY - dragBox.clientY));
                    //向上滑动;
                    if (-y >= ($scope.h - $scope.pageH)) {
                        y = -($scope.h - $scope.pageH);
                    }
                    //向下滑动;
                    if (y >= 0) {
                        y = 0;
                    }
                }

                $("#cut-img").css({left: x + $scope.l, top: y + $scope.t});

                var prp = $scope.currentPage.scale / $scope.currentPage.proportion
                background.offsetx = x / prp;
                background.offsety = y / prp;

                $scope.$digest();
                e.stopPropagation();
                e.preventDefault();
                return false;

            }

        };

        function stopEdit() {
            drag = false;
            dragBox = {};
            document.removeEventListener("mousemove", dragEdit, true);
            document.removeEventListener("mouseup", stopEdit, true);
        };

        $scope.chooseColor = function () {
            $scope.chooseBgColor(vm.bgColor);
        }

        $scope.chooseBgColor = function (color) {
            var currentPage = $scope.template.pages.page[$scope.template.pageI]
            currentPage.background = {
                resource: {
                    identifier: '',
                    provider: 'qiniu'
                },
                offsetx: 0,
                offsety: 0,
                type: 'Color',
                color: color,
                width: 0,
                height: 0,
                adaptation: null
            }
            $scope.currentPage = currentPage;
            updateHistorys();
        }


        window.contextMenuLeftArt = function (e) {
            e.preventDefault();
            //显示自定义菜单
            fn(e);
            var targ = e.target ? e.target : e.srcElement;
            var index = targ.dataset.index;
            var clipart = $scope.template.cliparts.clipart[index];
            if (clipart.type == 'SYSTEM') {
                return
            }
            var top = $(".leftPanel-head").height() + 50 + 20 + parseInt(index / 2) * 100 + 10;
            var left = 54 + 15 + (index % 2) * 100 + 10;
            for (var i = 0; i < $scope.template.cliparts.clipart.length; i++) {
                if (i == index) {
                    $('.clipart' + i).find('.art-click').show();
                } else {
                    $('.clipart' + i).find('.art-click').hide();
                }
            }
            $scope.artI = index;
        };

        function setOriginalWaH(width, height, i) {
            var currentPage = $scope.template.pages.page[i];
            var w = width;
            var h = height;

            originalScale = $con.width() * 0.8 / ($con.height() * 0.8);

            if (originalScale < width / height) {
                //宽定，高不定
                width = $con.width() * 0.8;
                height = $con.width() * 0.8 * h / w;
            } else {
                //高定，宽不动
                height = $con.height() * 0.8;
                width = $con.height() * 0.8 * w / h;
            }
            currentPage.width = width;
            currentPage.height = height;
            currentPage.proportion = (w / width);
            currentPage.proportionText = width / (unitTransformPx(w) / 25.4 * vm.windowDpiW);

            var pageNodeWidth = currentPage.mediabox.width / currentPage.proportion * 98 / (currentPage.mediabox.height / currentPage.proportion)

            currentPage.proportionTextSmalll = pageNodeWidth / (unitTransformPx(w) / 25.4 * vm.windowDpiW);
            $scope.currentPage = currentPage;
        }

        // 跨页
        $scope.pageIsSpread = function (flag) {
            var i = $scope.template.pageI;
            var currentPage = $scope.template.pages.page[i];
            if (flag) {
                currentPage.spread = true;
                if (currentPage.type == 'Cover') {
                    currentPage.type = 'FrontBack';
                }
                if (currentPage.type == 'BackCover') {
                    currentPage.type = undefined;
                }
            } else {
                currentPage.spread = false;
                if (currentPage.type == 'FrontBack') {
                    currentPage.type = 'Cover';
                }

            }
            updateHistorys();
        };

        // 设置封面封底
        $scope.pageIsCover = function (attr) {
            var i = $scope.template.pageI;
            var currentPage = $scope.template.pages.page[i];
            if (currentPage.type && currentPage.type == attr) {
                currentPage.type = null;
            } else {
                angular.forEach($scope.template.pages.page, function (p) {
                    if (attr == 'Cover') {
                        if (p.type == 'Cover' || p.type == 'FrontBack') {
                            p.type = null;
                        }
                    }
                    if (attr == 'BackCover') {
                        if (p.type == 'BackCover' || p.type == 'FrontBack') {
                            p.type = null;
                        }
                    }
                    if (attr == 'FrontBack') {
                        p.type = null;
                    }
                })
                if (attr == 'Cover') {
                    currentPage.type = attr;
                    var page = $scope.template.pages.page.splice(i, 1);
                    $scope.template.pages.page.unshift(page[0]);
                    $scope.template.pageI = 0;
                } else if (attr == 'BackCover') {
                    currentPage.type = attr;
                    var page = $scope.template.pages.page.splice(i, 1);
                    $scope.template.pages.page.push(page[0]);
                    $scope.template.pageI = $scope.template.pages.page.length - 1;
                } else if (attr == 'FrontBack') {
                    currentPage.type = attr;
                    var page = $scope.template.pages.page.splice(i, 1);
                    $scope.template.pages.page.unshift(page[0]);
                    $scope.template.pageI = 0;
                    $scope.pageIsSpread(1)
                }
            }

            $scope.template.pages.page.forEach(function (page, index) {
                page.seq = index + 1
            });
            $scope.currentPage = $scope.template.pages.page[$scope.template.pageI];

            updateHistorys();
        }

        // 可变数据
        $scope.setVariable = function (flag) {
            var i = $scope.template.pageI;
            var level = $scope.template.pages.page[i].levels.level[$scope.template.levelI]
            if (flag) {
                level.variable = true;
            } else {
                level.variable = false;
            }
        };

        $scope.pageIsBackup = function () {
            // var i = $scope.template.pageI;
            // var currentPage = $scope.template.pages.page[i];
            // if (flag) {
            //     currentPage.backup = true;
            // } else {
            //     currentPage.backup = false;
            // }
            // updateHistorys();

            var i = $scope.template.pageI;
            $scope.lastPage = $scope.template.pages.page[i];
            $scope.backupPage = angular.copy($scope.template.pages.page[i]);
            $scope.backupPage.backup = true;
            $scope.backupPage.uuid = UidService.get();
            $scope.template.pages.page.push($scope.backupPage);

            setTimeout(function () {
                var nodes = document.getElementsByClassName('page-item2');
                setThumbnailPic(nodes[0], $scope.backupPage,'cover');
                updateHistorys();
            })
        };

        function pageAnimate(){
            $(".page-item-cover").show()
            setTimeout(function () {
                $(".page-item-cover").addClass('cover-move2')
                $(".content-page-cover").addClass('cover-scale')
            })

            setTimeout(function () {
                $(".page-item-cover").hide().removeClass('cover-move2')
                $(".content-page-cover").removeClass('cover-scale')
            },1200)
        }

        $scope.deleteBackup = function(index){
            $scope.template.pages.page.splice(index,1);
        }

        // 备用页替换
        $scope.replaceBackupPage = function (e, page) {
            fn(e);
            var i = $scope.template.pageI;
            var seq = $scope.currentPage.seq;
            if (!page.loaded) {
                loadPageToPx(page, i, function(list) {
                    var p = angular.copy(page);
                    p.seq = seq
                    p.backup = false;
                    $scope.currentPage = $scope.template.pages.page[i] = p;
                    setOriginalWaH($scope.currentPage.trimbox.width, $scope.currentPage.trimbox.height, i);
                    updateHistorys();
                    pageSeq($scope.template.pages.page, UidService, function (page) {
                        $scope.template.pages.page = page;
                    });
                    $timeout(function() {
                        $scope.$digest();
                    }, 100);
                });
            } else {
                var p = angular.copy(page);
                p.seq = seq
                p.backup = false;
                $scope.currentPage = $scope.template.pages.page[i] = p;
                setOriginalWaH($scope.currentPage.trimbox.width, $scope.currentPage.trimbox.height, i);
                updateHistorys();
                pageSeq($scope.template.pages.page, UidService, function (page) {
                    $scope.template.pages.page = page;
                });
                $timeout(function() {
                    $scope.$digest();
                }, 100);
            }
        };

        $scope.pageIsReplace = function (flag) {
            var i = $scope.template.pageI;
            var currentPage = $scope.template.pages.page[i];
            if (flag) {
                currentPage.unreplace = false;
            } else {
                currentPage.unreplace = true;
            }
            updateHistorys();
        };

        // 删除场景
        $scope.deleteScene = function () {
            $scope.template.scene = null;
            var len = $scope.template.pages.page.length - 1;
            $scope.currentPage = $scope.template.pages.page[len];
        }

        $scope.selectSceneImg = function (e) {
            $scope.RightPanel = 'mask';
            $scope.template.angle = $scope.currentPage.imagebox.rotation.angle;

            $("#menus").fadeOut();
            // setZindex($index);
            $("#maskSelect").val("");
            e.stopPropagation();
        };

        // 删除场景内占位框
        $scope.deleteSceneimagebox = function () {
            $scope.currentPage.imagebox = {};
        }

        // 选择场景
        $scope.selectScene = function () {
            var _page = $scope.template.pages.page[$scope.template.pageI];
            $scope.currentPage = _page;

        }

        function setMargin() {
            var page0 = angular.copy($scope.template.pages.page[0]);
            if ($scope.template.scene&&$scope.template.scene.imagebox) {
                var w0 = page0.mediabox.width / page0.proportion * page0.scale,
                    h0 = page0.mediabox.height / page0.proportion * page0.scale,
                    w1 = $scope.currentPage.scene.imagebox.geometry.width * $scope.currentPage.scene.scale / $scope.currentPage.scene.proportion,
                    h1 = $scope.currentPage.scene.imagebox.geometry.height * $scope.currentPage.scene.scale / $scope.currentPage.scene.proportion;

                if ((w0 <= h0 || w1 <= h1) && (w0 / h0 < w1 / h1) || w0 >= h0 && w1 >= h1 && (w0 / h0 < w1 / h1)) {
                    $scope.imageboxConH = h1;
                    $scope.imageboxConW = h1 * w0 / h0;
                    $scope.proportion = $scope.imageboxConW / w0;
                } else {
                    $scope.imageboxConW = w1;
                    $scope.imageboxConH = w1 * h0 / w0;
                    $scope.proportion = $scope.imageboxConH / h0;
                }

                $scope.marginLeft = (w1 - $scope.imageboxConW) / 2;
                $scope.marginTop = (h1 - $scope.imageboxConH) / 2;
            }
        }


        /* ==========================================================================
         左边侧边栏拖动事件
         ========================================================================== */
        var content = $(".content-container")[0];
        content.ondragenter = ignoreDrag;
        // 拖动文件的鼠标指针位置放置区之上时发生
        content.ondragover = ignoreDrag;
        content.ondrop = drop;

        var content2 = $(".editing1")[0];
        content2.ondragenter = ignoreDrag;
        // 拖动文件的鼠标指针位置放置区之上时发生
        content2.ondragover = ignoreDrag;
        content2.ondrop = drop;

        function ignoreDrag(e) {
            // 确保其他元素不会取得该事件
            e.stopPropagation();
            e.preventDefault();
        }

        function drop(e) {
            ignoreDrag(e);
            var currentPage = $scope.currentPage = $scope.template.pages.page[$scope.template.pageI];
            var data = e.dataTransfer.getData("Text");
            var s = $('#' + data)[0].src;
            var mask = $('#' + data)[0].getAttribute('data-mask');
            var dataIndex = $('#' + data)[0].getAttribute('data-index');
            var s1 = s.split(/\//)[3];


            var offsetX = e.clientX - 300;
            var offsetY = e.clientY - 100;
            // 场景
            if (currentPage.scene) {
                offsetX -= parseFloat($($(".page-item")[1]).css('margin-left'));
                offsetY -= parseFloat($($(".page-item")[1]).css('margin-top'))
            } else {
                offsetX -= parseFloat($($(".page-item")[0]).css('margin-left'));
                offsetY -= parseFloat($($(".page-item")[0]).css('margin-top'))
            }
            if (data.indexOf('dragtargetPhoto') != '-1') {
                // console.log(e.target.dataset)
                var index = null;
                if (e.target.dataset.index) {
                    index = e.target.dataset.index;
                } else {
                    // 判读是否是照片
                    var mask = {
                        identifier: null,
                        provider: 'qiniu',
                        resource: {
                            identifier: '',
                            provider: 'qiniu'
                        }
                    }
                    addPlacement(e, mask, false, offsetX, offsetY);
                    index = $scope.template.levelI;
                }
                var imagebox = currentPage.levels.level[index].imagebox;
                s1 = $('#' + data).attr('data-mask');
                if (imagebox.current) {
                    var img = imagebox.imgUrl = s1 + '?imageMogr2/auto-orient/thumbnail/!40p';
                    var newImg = document.createElement('img');
                    newImg.crossOrigin = "Anonymous";
                    newImg.src = img;
                    newImg.onload = function () {
                        newImg.onload = null;
                        var _image = getImageSource(newImg, imagebox, s1, currentPage);
                        imagebox.image = _image;
                        imagebox.image.offsetx = 0;
                        imagebox.image.offsety = 0;
                        imageboxResourceCanvas(imagebox);
                        $scope.selectImg(e, index, imagebox);
                        $scope.$digest();
                    };
                }
            } else if (data.indexOf('dragtargetMask') != '-1') {
                // 判读是否是占位框
                s1 = $('#' + data).attr('data-mask');
                var mask = {
                    identifier: s1,
                    provider: 'qiniu',
                    resource: {
                        identifier: s1,
                        provider: 'qiniu'
                    }
                }
                addPlacement(e, mask, false, offsetX, offsetY);
                var index = $scope.template.levelI;
                var imagebox = currentPage.levels.level[index].imagebox;
                if (imagebox.current) {
                    imagebox.mask.resource.identifier = s1;
                    imagebox.mask.resource.provider = 'qiniu';
                    maskScale(e, imagebox, index, s1);
                    $scope.$digest();
                }
            } else if (data.indexOf('dragtargetClipArt') != '-1') {
                //判读是否是素材
                var identifier = $('#' + data).attr('data-art');
                $scope.addArt(identifier);

            } else {
                // var bgimg2Arr = vm.showBackgrounds.bgimg[dataIndex];
                var bgimg2Arr = $scope.template.bgimgs2.bgimg[dataIndex];

                var pageW = currentPage.mediabox.width / currentPage.proportion;
                var pageH = currentPage.mediabox.height / currentPage.proportion;
                currentPage.hasBgImg = true;

                $http({url: bgimg2Arr.identifier + '?imageInfo'}).success(function (data) {
                    var bgW = data.width;
                    var bgH = data.height;
                    if (data.orientation == "Left-bottom" || data.orientation == "Right-top" || data.orientation == "Left-top" || data.orientation == "Right-bottom") {
                        bgW = data.height;
                        bgH = data.width;
                    }

                    // 高适配
                    var adaptation = 'Height', h = pageH, w = pageH * bgW / bgH;
                    // 宽适配
                    if ((bgW <= bgH || pageW <= pageH) && (bgW / bgH < pageW / pageH) || bgW >= bgH && pageW >= pageH && (bgW / bgH < pageW / pageH)) {
                        w = pageW;
                        h = pageW * bgH / bgW;
                        adaptation = 'Width';
                    }
                    var pro = $scope.currentPage.scale / $scope.currentPage.proportion
                    $scope.currentPage.background = {
                        resource: {
                            identifier: bgimg2Arr.identifier,
                            provider: 'qiniu',
                            width: bgW,
                            height: bgH
                        },
                        offsetx: 0,
                        offsety: 0,
                        type: 'Pic',
                        color: '',
                        width: w / pro,
                        height: h / pro,
                        adaptation: adaptation,
                        scale: 1
                    }
                    // console.log($scope.currentPage.background)
                    updateHistorys();
                }).error(function (error) {
                    MessageService.error("获取图片信息失败");
                });
            }
        }

        function getBackgroundSource(res, pageW, pageH, arr) {
            var deferred = $q.defer();
            $http({url: res.identifier + '?imageInfo'}).success(function (data) {
                var bgW = data.width,
                    bgH = data.height;

                // 高适配
                var adaptation = 'Height', h = pageH, w = pageH * bgW / bgH;
                // 宽适配
                if ((bgW <= bgH || pageW <= pageH) && (bgW / bgH < pageW / pageH) || bgW >= bgH && pageW >= pageH && (bgW / bgH < pageW / pageH)) {
                    w = pageW;
                    h = pageW * bgH / bgW;
                    adaptation = 'Width';
                }
                arr.resource.width = bgW;
                arr.resource.height = bgH;
                arr.width = w;
                arr.height = h;
                arr.type = arr.type;
                arr.offsetXM = angular.copy(arr.offsetx);
                arr.offsetYM = angular.copy(arr.offsety);
                arr.offsetx = arr.offsetx;
                arr.offsety = arr.offsety;
                arr.adaptation = adaptation;
                deferred.resolve("ready");
            }).error(function (error) {
                MessageService.error("获取图片信息失败");
                deferred.resolve("error");
            });
            return deferred.promise;
        }
        function imageboxResourceCanvas(item) {
            var image = angular.copy(item)
            var imagecanvas = document.createElement('canvas');
            var imagecontext = imagecanvas.getContext('2d');
            var newImg = document.createElement('img');
            newImg.crossOrigin = "Anonymous";
            newImg.src = image.imgUrl;
            newImg.onload = function () {
                newImg.onload = null;
                var offsetx = image.image.offsetx;
                var offsety = image.image.offsety;
                var _image = getImageSource(newImg,image,image.image.resource.identifier)
                image.image = _image;
                var scaleW = _image.width / newImg.width;
                var scaleH = _image.height / newImg.height;
                image.image.scaleW = scaleW;
                image.image.scaleH = scaleH;
                image.image.offsetx = offsetx / scaleW;
                image.image.offsety = offsety / scaleH;
                // img.setAttribute('data-mask', s1);
                var masks = document.createElement('img');
                var maskUrl =  'content/images/mask_souce.png';
                if(image.mask&&image.mask.resource&&image.mask.resource.identifier){
                    maskUrl = image.mask.resource.identifier
                }
                image.maskUrl = maskUrl;
                masks.src = maskUrl;
                masks.crossOrigin = "anonymous";
                masks.onload = function () {
                    masks.onload = null;
                    masks.width = image.geometry.width;
                    masks.height = image.geometry.height;
                    imagecanvas.width = masks.width;
                    imagecanvas.height = masks.height;
                    imagecontext.drawImage(masks, 0, 0, masks.width, masks.height);
                    imagecontext.globalCompositeOperation = 'source-in';

                    imagecontext.scale(scaleW, scaleH);
                    imagecontext.drawImage(newImg, image.image.offsetx, image.image.offsety);
                    var pic = imagecanvas.toDataURL();
                    image.bgImg = ImageService.dataURLtoBlob(pic);
                    item.bgImg = ImageService.dataURLtoBlob(pic);
                    updateHistorys();
                    $scope.$digest();
                };
                masks.src = maskUrl;
            };
            newImg.src = image.imgUrl;
        }

        function maskScale(e, imageboxs, index, identifier, callback) {
            var imagebox = angular.copy(imageboxs);
            imagebox.mask.resource.identifier = identifier;

            var img = document.getElementsByClassName('page-item')[0].getElementsByClassName('mask')[index];
            var imgUrl =  'content/images/mask_souce.png';
            if(imagebox.image&&imagebox.image.resource&&imagebox.image.resource.identifier){
                imgUrl = imagebox.image.resource.identifier
            }

            var imagecanvas = document.createElement('canvas');
            var imagecontext = imagecanvas.getContext('2d');
            var newImg = document.createElement('img');
            newImg.crossOrigin = "Anonymous";
            newImg.src = imgUrl;
            newImg.onload = function () {
                newImg.onload = null;
                var width = newImg.width;
                var height = newImg.height;
                var scaleW = 1,scaleH = 1;
                if(imagebox.image&&imagebox.image.resource&&imagebox.image.resource.identifier){
                    var _image = getImageSource(newImg,imagebox,identifier);
                    width = imagebox.geometry.width;
                    height = imagebox.geometry.height;

                    scaleW = _image.width / newImg.width;
                    scaleH = _image.height / newImg.height;
                    imagebox.image.offsetx = 0;
                    imagebox.image.offsety = 0;
                }
                if(img){
                    img.setAttribute('data-mask', identifier);
                }

                var masks = document.createElement('img');
                masks.src = identifier;
                masks.crossOrigin = "anonymous";
                masks.onload = function () {
                    masks.onload = null;
                    imagecanvas.width = width;
                    imagecanvas.height = height;
                    imagecontext.drawImage(masks, 0, 0, width, height);
                    imagecontext.globalCompositeOperation = 'source-in';
                    imagecontext.scale(scaleW, scaleH);
                    imagecontext.drawImage(newImg, 0, 0);
                    var pic = imagecanvas.toDataURL();
                    imagebox.bgImg = ImageService.dataURLtoBlob(pic);
                    imageboxs.bgImg = ImageService.dataURLtoBlob(pic);
                    imagebox.mask.resource.identifier = identifier;
                    imagebox.mask.resource.provider = "qiniu";
                    imagebox.maskUrl = identifier;
                    $scope.selectImg(e, index, imagebox);
                    updateHistorys();
                    $scope.$digest();
                };
                if (callback) {
                    callback();
                }
                masks.src = identifier;
            };

        }
        function  getImageSource(newImg,imagebox,s1,currentPage) {
            var width = newImg.width;
            var height = newImg.height;

            var _w = imagebox.geometry.width;
            var _h = imagebox.geometry.height;
            var bgImgR = width/height;
            var bgImgR1 = _w/_h;
            var _image = {
                resource: {
                    provider: 'qiniu',
                    identifier: s1,
                },
                angle: 0,
                scale: 1
            }
            if(bgImgR >= bgImgR1){
                _image.adaptation = 'Height';
                _image.height = _h;
                _image.width = _h/height*width;
            }else {
                _image.adaptation = 'Width';
                _image.width = _w;
                _image.height = _w/width*height;
            }
            _image.imgWidth = width;
            _image.imgHeight = height;

            return _image
        }
        function getBackgroundSource1(res, pageW, pageH, arr) {
            var deferred = $q.defer();
            var img = new Image();
            img.src = res.identifier + '?imageMogr2/auto-orient';
            img.onload =function(){
                var bgW = img.width,
                    bgH = img.height;

                // 高适配
                var adaptation = 'Height', h = pageH, w = pageH * bgW / bgH;
                // 宽适配
                if ((bgW <= bgH || pageW <= pageH) && (bgW / bgH < pageW / pageH) || bgW >= bgH && pageW >= pageH && (bgW / bgH < pageW / pageH)) {
                    w = pageW;
                    h = pageW * bgH / bgW;
                    adaptation = 'Width';
                }
                arr.resource.width = bgW;
                arr.resource.height = bgH;
                arr.width = w;
                arr.height = h;
                arr.type = 'Pic';
                arr.adaptation = adaptation;
                $scope.$digest();
                deferred.resolve("ready");
            }

            return deferred.promise;
            // $http({url: res.identifier + '?imageInfo/imageMogr2/auto-orient'}).success(function (data) {
            //     // var bgW = data.width,
            //     //     bgH = data.height;
            //     var bgW = data.height,
            //         bgH = data.width;
            //
            //     // 高适配
            //     var adaptation = 'Height', h = pageH, w = pageH * bgW / bgH;
            //     // 宽适配
            //     if ((bgW <= bgH || pageW <= pageH) && (bgW / bgH < pageW / pageH) || bgW >= bgH && pageW >= pageH && (bgW / bgH < pageW / pageH)) {
            //         w = pageW;
            //         h = pageW * bgH / bgW;
            //         adaptation = 'Width';
            //     }
            //     arr.resource.width = bgW;
            //     arr.resource.height = bgH;
            //     arr.width = w;
            //     arr.height = h;
            //     arr.type = 'Pic';
            //     arr.adaptation = adaptation;
            // }).error(function (error) {
            //     MessageService.error("获取图片信息失败");
            // });
        }

        window.dragStart = function (event) {
            var target = event.target;
            event.dataTransfer.setData("Text", target.id);
            if (target.id.indexOf('dragtargetClipArt') != '-1') {
                event.dataTransfer.setData("Art", target.dataset.clipart);
            }
        };

        $scope.addArt = function (identifier) {
            var currentPage = $scope.template.pages.page[$scope.template.pageI];
            var currentLevel = addLevel(currentPage);

            vm.unit = 'mm';
            var newImg = document.createElement('img');
            newImg.crossOrigin = "Anonymous";
            newImg.src = identifier + '?imageView2';
            newImg.onload = function () {
                newImg.onload = null;
                var width = newImg.width;
                var height = newImg.height;
                var arr = ThreeHundredDpiToMm(width, height);

                var bgImgR = arr.mm1 / arr.mm2;
                if (bgImgR >= 1) {
                    if (arr.mm1 > currentPage.editboxM.width) {
                        $scope.pageValue.imageart = {
                            width: currentPage.editboxM.width,
                            height: currentPage.editboxM.width / arr.mm1 * arr.mm2,
                            x: currentPage.editboxM.x,
                            y: currentPage.editboxM.y
                        }
                    } else {
                        $scope.pageValue.imageart = {
                            height: arr.mm2,
                            width: arr.mm1,
                            x: currentPage.editboxM.x,
                            y: currentPage.editboxM.y
                        }
                    }
                } else {
                    if (arr.mm2 > currentPage.editboxM.height) {
                        $scope.pageValue.imageart = {
                            height: currentPage.editboxM.height,
                            width: currentPage.editboxM.height / arr.mm2 * arr.mm1,
                            x: currentPage.editboxM.x,
                            y: currentPage.editboxM.y
                        }
                    } else {
                        $scope.pageValue.imageart = {
                            height: arr.mm2,
                            width: arr.mm1,
                            x: currentPage.editboxM.x,
                            y: currentPage.editboxM.y
                        }
                    }
                }

                currentLevel.imageart = ({
                    geometry: {
                        width: unitTransform($scope.pageValue.imageart.width),
                        height: unitTransform($scope.pageValue.imageart.height),
                        x: unitTransform($scope.pageValue.imageart.x),
                        y: unitTransform($scope.pageValue.imageart.y)
                    },
                    rotation: {
                        angle: 0
                    },
                    resource: {
                        identifier: identifier,
                        provider: 'qiniu',
                        width: width,
                        height: height,
                    },
                    scale: 1,
                    transparency: 1,
                    onlyshow: false,
                    movable: true,
                    editable: true,
                    bgImg: '',
                    offsetx: 0,
                    offsety: 0,
                    unit: 'mm',
                    // index: currentPage.imagearts.imageart.length,
                    levelI: $scope.template.levelI,
                    pageI: $scope.template.pageI,
                    current: 'imageart',
                    lock: false
                });

                updateHistorys();
                $scope.currentPage = currentPage;
                $scope.RightPanel = 'material';
                $scope.selectBox = currentLevel.imageart;
                $scope.template.transparency = 100,
                    $scope.$digest();
            };
        }

        /* ==========================================================================
         占位框处理
         ========================================================================== */

        function addLevel(currentPage) {
            var arr = {
                seq: 1,
                imagebox: null,
                textbox: null,
                imageart: null,
                textdocument: null,
                variable:false
            };

            if (!currentPage.levels.level) {
                currentPage.levels.level = [arr];
            } else {
                currentPage.levels.level.push(arr);
            }

            $scope.template.levelI = currentPage.levels.level.length - 1;
            var currentLevel = currentPage.levels.level[$scope.template.levelI];

            currentLevel.seq = $scope.template.levelI + 1;
            vm.unit = 'mm';
            $scope.template.angle = 0;
            return currentLevel;
        }

        //增加图片占位框
        var addPlacement = function (e, mask, attr, offsetX, offsetY) {
            var currentPage = $scope.template.pages.page[$scope.template.pageI];
            var currentLevel = addLevel(currentPage);

            offsetX = offsetX / currentPage.scale * currentPage.proportion;
            offsetY = offsetY / currentPage.scale * currentPage.proportion;


            currentLevel.imagebox = ({
                geometry: {
                    width: unitTransform(50),
                    height: unitTransform(45),
                    x: unitTransform(unitTransformPx(offsetX) - 25),
                    y: unitTransform(unitTransformPx(offsetY) - 25)
                },
                rotation: {
                    angle: 0
                },
                mask: {
                    resource: {
                        identifier: mask.identifier,
                        provider: 'qiniu'
                    }
                },
                imgUrl: 'content/images/mask_souce.png',
                maskUrl: mask.identifier || 'content/images/mask_souce.png',
                bgImg: '',
                unit: 'mm',
                levelI: $scope.template.levelI,
                pageI: $scope.template.pageI,
                current: 'imagebox',
                lock: false
            });

            updateHistorys();

            $scope.currentPage = currentPage;
            $scope.selectBox = currentLevel.imagebox;
            getImageboxLen();
            if (vm.unit == 'mm') {
                $scope.pageValue.imagebox = {
                    width: 50,
                    height: 45,
                    x: unitTransformPx(offsetX) - 25,
                    y: unitTransformPx(offsetY) - 23
                }
            } else {
                $scope.pageValue.imagebox = currentPage.imagebox.geometry;
            }
            return
        };

        function getImageboxLen() {
            vm.count = 0;
            angular.forEach($scope.currentPage.levels.level, function (level) {
                if (level.imagebox && level.imagebox.geometry) {
                    vm.count++;
                }
            })
        }

        //图片占位框点击时
        $scope.selectImg = function (e, $index, img) {
            if (!e) {
                return
            }

            if (vm.unit == 'mm') {
                $scope.pageValue.imagebox = {
                    width: unitTransformPx(img.geometry.width).toFixed(2) - 0,
                    height: unitTransformPx(img.geometry.height).toFixed(2) - 0,
                    x: unitTransformPx(img.geometry.x).toFixed(2) - 0,
                    y: unitTransformPx(img.geometry.y).toFixed(2) - 0
                }
            } else {
                $scope.pageValue.imagebox = {
                    width: img.geometry.width,
                    height: img.geometry.height,
                    x: img.geometry.x,
                    y: img.geometry.y
                }
            }

            $scope.template.levelI = $index;
            $scope.RightPanel = 'mask';
            $scope.template.angle = img.rotation.angle;
            img.current = 'imagebox';
            $scope.selectBox = img;
            vm.selectItem = angular.copy(img);

            //如果是按住ctrl键 实现多选复制
            // var mm = $scope.currentPage.imageboxes.imagebox[$index];
            if (e.ctrlKey == true || e.metaKey == true) {
                if (img.lock) {
                    return
                }
                img.ctrlKey = true;
                vm.CtrlKeyArray.imageboxes[$index] = angular.copy(img);
                ctrlAddSingleArray();
            } else {
                $scope.clearCtrlKey();
                vm.singleArray = {imagebox: {}, textbox: {}, imageart: {}, barcode: {}, qrcode: {}};
                if (img.lock) {
                    return
                }
                vm.singleArray.imagebox = angular.copy(img);
            }
            $("#menus").fadeOut();
            // setZindex($index);
            $("#maskSelect").val("");
            e.stopPropagation();
        };
        //双击占位框
        $scope.doubleClickImagebox = function (e, index, item) {
            if(!item.image && !item.image.resource.identifier){
                return
            }
            vm.imageboxDouble1 = index;
            vm.imageboxDouble = angular.copy(item);
            vm.isImageboxTrim = true;
            $scope.scale = vm.imageboxDouble.image.scale;
        }
        $scope.imageboxFalseClick = function () {
            vm.isImageboxTrim = false;
        };
        $scope.imageboxTrueClick = function () {
            $scope.currentPage.levels.level[vm.imageboxDouble1].imagebox = vm.imageboxDouble;
            vm.isImageboxTrim = false;
            $scope.currentPage.levels.level[vm.imageboxDouble1].imagebox = vm.imageboxDouble;
            if ($scope.currentPage.levels.level[vm.imageboxDouble1].imagebox.mask && $scope.currentPage.levels.level[vm.imageboxDouble1].imagebox.mask.resource.identifier) {
                imageboxResourceCanvas($scope.currentPage.levels.level[vm.imageboxDouble1].imagebox);
            }
        };
        var isImageboxMouseDown = false;
        $scope.imageboxMouseDown = function ($event) {
            fn($event)
            var ratio = $scope.currentPage.scale / $scope.currentPage.proportion;
            var x = $event.clientX;
            var y = $event.clientY;
            var l = vm.imageboxDouble.image.offsetx * ratio * vm.imageboxDouble.image.scale;
            var t = vm.imageboxDouble.image.offsety * ratio * vm.imageboxDouble.image.scale;
            var r = -(vm.imageboxDouble.image.width * vm.imageboxDouble.image.scale - vm.imageboxDouble.geometry.width) * ratio;
            var b = -(vm.imageboxDouble.image.height * vm.imageboxDouble.image.scale - vm.imageboxDouble.geometry.height) * ratio;
            var angle = Number(vm.imageboxDouble.rotation.angle);
            //开关打开
            isImageboxMouseDown = true;
            //鼠标移动
            window.onmousemove = function (e) {
                if (isImageboxMouseDown == false) {
                    return;
                }
                fn(e);
                var cx = (l + r) / 2;
                var cy = (t + b) / 2;
                var pt0 = rotatePoint({x: x, y: y}, {x: cx, y: cy}, angle);
                var pt1 = rotatePoint({x: e.clientX, y: e.clientY}, {x: cx, y: cy}, angle);
                var deltaX = pt1.x - pt0.x;
                var deltaY = pt1.y - pt0.y;
                var nl = l + deltaX;
                var nt = t + deltaY;
                if (nl < r) {
                    nl = r
                };
                if (nl > 0) {
                    nl = 0
                };
                if (nt < b) {
                    nt = b
                };
                if (nt > 0) {
                    nt = 0
                };

                vm.imageboxDouble.image.offsetx = nl / ratio / vm.imageboxDouble.image.scale;
                vm.imageboxDouble.image.offsety = nt / ratio / vm.imageboxDouble.image.scale;
                $scope.$digest();
            }
            //鼠标抬起事件
            window.onmouseup = function ($event) {
                isImageboxMouseDown = false;
                $scope.$digest();
            }
        }
        $scope.imageboxMouseDown1 = function ($event) {
            fn($event)
            var ratio = $scope.currentPage.scale / $scope.currentPage.proportion;
            var x = $event.clientX;
            var y = $event.clientY;
            var l = vm.imageboxDouble.image.offsetx * ratio * vm.imageboxDouble.image.scale;
            var t = vm.imageboxDouble.image.offsety * ratio * vm.imageboxDouble.image.scale;
            var r = -(vm.imageboxDouble.image.width * vm.imageboxDouble.image.scale - vm.imageboxDouble.geometry.width) * ratio;
            var b = -(vm.imageboxDouble.image.height * vm.imageboxDouble.image.scale - vm.imageboxDouble.geometry.height) * ratio;
            var angle = Number(vm.imageboxDouble.rotation.angle);
            //开关打开
            isImageboxMouseDown = true;
            //鼠标移动
            window.onmousemove = function (e) {
                if (isImageboxMouseDown == false) {
                    return;
                }
                fn(e);
                var cx = (l + r) / 2;
                var cy = (t + b) / 2;
                var pt0 = rotatePoint({x: x, y: y}, {x: cx, y: cy}, angle);
                var pt1 = rotatePoint({x: e.clientX, y: e.clientY}, {x: cx, y: cy}, angle);
                var deltaX = pt1.x - pt0.x;
                var deltaY = pt1.y - pt0.y;
                var nl = l + deltaX;
                var nt = t + deltaY;
                if (nl < r) {
                    nl = r
                };
                if (nl > 0) {
                    nl = 0
                };
                if (nt < b) {
                    nt = b
                };
                if (nt > 0) {
                    nt = 0
                };

                vm.imageboxDouble.image.offsetx = nl / ratio / vm.imageboxDouble.image.scale;
                vm.imageboxDouble.image.offsety = nt / ratio / vm.imageboxDouble.image.scale;
                $scope.$digest();
            }
            //鼠标抬起事件
            window.onmouseup = function ($event) {
                isImageboxMouseDown = false;
                $scope.$digest();
            }
        }

        function ctrlAddSingleArray() {
            if (vm.singleArray.imagebox.index != undefined) {
                var index = vm.singleArray.imagebox.index;
                $scope.currentPage.imageboxes.imagebox[index].ctrlKey = true;
                vm.CtrlKeyArray.imageboxes[index] = vm.singleArray.imagebox;
            }
            if (vm.singleArray.textbox.index != undefined) {
                var index = vm.singleArray.textbox.index;
                $scope.currentPage.textboxes.textbox[index].ctrlKey = true;
                vm.CtrlKeyArray.textboxes[index] = vm.singleArray.textbox;
            }
            if (vm.singleArray.imageart.index != undefined) {
                var index = vm.singleArray.imageart.index;
                $scope.currentPage.imagearts.imageart[index].ctrlKey = true;
                vm.CtrlKeyArray.imagearts[index] = vm.singleArray.imageart;
            }
            if (vm.singleArray.barcode.index != undefined) {
                vm.singleArray.barcode.ctrlKey = true;
                vm.CtrlKeyArray.barcode[0] = vm.singleArray.barcode;
            }
            if (vm.singleArray.qrcode.index != undefined) {
                vm.singleArray.qrcode.ctrlKey = true;
                vm.CtrlKeyArray.qrcode[0] = vm.singleArray.qrcode;
            }
            vm.singleArray = {imagebox: {}, textbox: {}, imageart: {}, barcode: {}, qrcode: {}};
        }

        //图片占位框鼠标事件
        var drag;
        var dragBox = {};
        var dragMask = {};
        $scope.buttonShows = false;
        $scope.moveBoxStart = function (e,item,index) {
            fn(e);
            $scope.buttonShows = true;
            var targ = e.target ? e.target : e.srcElement;
            $scope.template.levelI = index;
            $scope.template.angle = item.rotation.angle;
            if (item.lock) {
                return
            }

            dragBox.clientX = e.clientX || 0;
            dragBox.clientY = e.clientY || 0;
            if(item.current=='page'){
                return
            }else if(item.current=='imagebox'){
                dragBox.coordX = item.geometry.x*$scope.currentPage.scale/$scope.currentPage.proportion;
                dragBox.coordY = item.geometry.y*$scope.currentPage.scale/$scope.currentPage.proportion;
            }else if(item.current=='textdocument'){
                dragBox.coordX = e.currentTarget.offsetLeft;
                dragBox.coordY = e.currentTarget.offsetTop;
            }else{
                dragBox.coordX = item.geometry.x * $scope.currentPage.scale / $scope.currentPage.proportion;
                dragBox.coordY = item.geometry.y * $scope.currentPage.scale / $scope.currentPage.proportion;
            }
            drag = true;
            var all = getAllCtrlKeyArray();
            if (all.length) {
                dragBox.ctrlKey = true;
            } else {
                dragBox.ctrlKey = false;
            }
            $scope.selectBox = item;
            document.addEventListener("mousemove", moveBoxOn, true);
            document.addEventListener("mouseup", moveBoxEnd, true);

        };
        //move 事件
        function moveBoxOn(e) {
            fn(e);
            $scope.$digest();
            if (e.target.nodeName == 'SPAN'&&$scope.selectBox.current!='textbox') {
                return;
            }
            if (drag) {
                var currentPage = $scope.template.pages.page[$scope.template.pageI];
                var angle = ($scope.selectBox.rotation.angle) * Math.PI / 180;

                var clientX = e.clientX - dragBox.clientX;
                var clientY = e.clientY - dragBox.clientY;

                var imgOffsetX = (dragBox.coordX + e.clientX - dragBox.clientX);
                var imgOffsetY = (dragBox.coordY + e.clientY - dragBox.clientY);
                var imgWidth = $scope.selectBox.geometry.width * currentPage.scale / currentPage.proportion;
                var imgHeight = $scope.selectBox.geometry.height * currentPage.scale / currentPage.proportion;

                if($scope.selectBox.current=='textbox'){
                    imgWidth = $(".textbox" + $scope.template.pageI + $scope.template.levelI).width();
                    imgHeight = $(".textbox" + $scope.template.pageI + $scope.template.levelI).height();
                }
                var height = currentPage.height * currentPage.scale;
                var width = currentPage.width * currentPage.scale;
                var lar = (currentPage.bloodPx.left + currentPage.bloodPx.right) * currentPage.scale / currentPage.proportion;
                var tab = (currentPage.bloodPx.top + currentPage.bloodPx.bottom) * currentPage.scale / currentPage.proportion;

                // if (imgOffsetX <= 0) {
                //     imgOffsetX = 0;
                // }
                //
                // if (imgOffsetX >= (width + lar - imgWidth)) {
                //     imgOffsetX = width + lar - imgWidth;
                // }
                // if (imgOffsetY <= 0) {
                //     imgOffsetY = 0;
                // }
                //
                // if (imgOffsetY >= (height + tab - imgHeight)) {
                //     imgOffsetY = height + tab - imgHeight;
                // }

                if (dragBox.ctrlKey) {
                    moveTogether(currentPage, clientX, clientY);
                } else {
                    $scope.selectBox.geometry.x = imgOffsetX / currentPage.scale * currentPage.proportion;
                    $scope.selectBox.geometry.y = imgOffsetY / currentPage.scale * currentPage.proportion;

                    var value = {};
                    if ($scope.selectBox.current == 'textbox') {
                        value = $scope.pageValue.textbox;
                    } else if ($scope.selectBox.current == 'imagebox') {
                        value = $scope.pageValue.imagebox;
                    } else if ($scope.selectBox.current == 'imageart') {
                        value = $scope.pageValue.imageart;
                    } else if ($scope.selectBox.current == 'textdocument') {
                        value = $scope.pageValue.textdocument;
                    }
                    if (vm.unit == 'mm') {
                        value.x = unitTransformPx($scope.selectBox.geometry.x).toFixed(2) - 0;//px-->mm
                        value.y = unitTransformPx($scope.selectBox.geometry.y).toFixed(2) - 0;//px-->mm
                    } else {
                        value.x = unitTransformPx($scope.selectBox.geometry.x / 25.4 * vm.windowDpiW);
                        value.y = unitTransformPx($scope.selectBox.geometry.y / 25.4 * vm.windowDpiW);
                    }
                }
                $scope.currentPage = currentPage;

            }
            return false;
        }

        //鼠标松开事件
        function moveBoxEnd() {
            if (dragBox.ctrlKey) {
                moveTogetherEnd();
            }
            drag = false;
            dragBox = {};
            document.removeEventListener("mousemove", moveBoxOn, true);
            document.removeEventListener("mouseup", moveBoxEnd, true);
            updateHistorys();
            $scope.$digest();
        }

        $scope.moveBoxStart1 = function (e,item,index) {
            fn(e);
            $scope.buttonShows = true;
            var targ = e.target ? e.target : e.srcElement;
            $scope.template.levelI = index;
            $scope.template.angle = item.rotation.angle;
            var currentPage = $scope.template.pages.page[$scope.template.pageI];
            if (item.lock) {
                return
            }

            dragBox.clientX = e.clientX || 0;
            dragBox.clientY = e.clientY || 0;
            if(item.current=='page'){
                return
            }else if(item.current=='imagebox'){
                dragBox.coordX = item.geometry.x*currentPage.scene.ratio;
                dragBox.coordY = item.geometry.y*currentPage.scene.ratio;
            }else if(item.current=='textdocument'){
                dragBox.coordX = item.geometry.x*currentPage.scene.ratio;
                dragBox.coordY = item.geometry.y*currentPage.scene.ratio;
            }else{
                dragBox.coordX = item.geometry.x*currentPage.scene.ratio;
                dragBox.coordY = item.geometry.y*currentPage.scene.ratio;
            }
            drag = true;
            var all = getAllCtrlKeyArray();
            if (all.length) {
                dragBox.ctrlKey = true;
            } else {
                dragBox.ctrlKey = false;
            }
            $scope.selectBox = item;
            document.addEventListener("mousemove", moveBoxOn1, true);
            document.addEventListener("mouseup", moveBoxEnd1, true);

        };
        //move 事件
        function moveBoxOn1(e) {
            fn(e);
            $scope.$digest();
            if (e.target.nodeName == 'SPAN'&&$scope.selectBox.current!='textbox') {
                return;
            }
            if (drag) {
                var currentPage = $scope.template.pages.page[$scope.template.pageI];
                var angle = ($scope.selectBox.rotation.angle) * Math.PI / 180;

                var clientX = e.clientX - dragBox.clientX;
                var clientY = e.clientY - dragBox.clientY;

                var imgOffsetX = (dragBox.coordX + e.clientX - dragBox.clientX);
                var imgOffsetY = (dragBox.coordY + e.clientY - dragBox.clientY);
                var imgWidth = $scope.selectBox.geometry.width * currentPage.scene.ratio;
                var imgHeight = $scope.selectBox.geometry.height * currentPage.scene.ratio;

                if($scope.selectBox.current=='textbox'){
                    imgWidth = $(".textbox1" + $scope.template.pageI + $scope.template.levelI).width();
                    imgHeight = $(".textbox1" + $scope.template.pageI + $scope.template.levelI).height();
                }
                var height = currentPage.mediabox.height * currentPage.scene.ratio;
                var width = currentPage.mediabox.width * currentPage.scene.ratio;
                var lar = (currentPage.bloodPx.left + currentPage.bloodPx.right) * currentPage.scene.ratio;
                var tab = (currentPage.bloodPx.top + currentPage.bloodPx.bottom) * currentPage.scene.ratio;

                // if (angle == 0) {
                //     if (imgOffsetX <= 0) {
                //         imgOffsetX = 0;
                //     }
                //
                //     if (imgOffsetX >= (width - imgWidth)) {
                //         imgOffsetX = width - imgWidth;
                //     }
                //     if (imgOffsetY <= 0) {
                //         imgOffsetY = 0;
                //     }
                //
                //     if (imgOffsetY >= (height - imgHeight)) {
                //         imgOffsetY = height - imgHeight;
                //     }
                // } else {
                //     if (imgOffsetX <= 0) {
                //         imgOffsetX = 0;
                //     }
                //
                //     if (imgOffsetX >= (width + lar)) {
                //         imgOffsetX = width + lar;
                //     }
                //     if (imgOffsetY <= 0) {
                //         imgOffsetY = 0;
                //     }
                //
                //     if (imgOffsetY >= (height + tab)) {
                //         imgOffsetY = height + tab;
                //     }
                //
                // }

                if (dragBox.ctrlKey) {
                    moveTogether(currentPage, clientX, clientY);
                } else {
                    $scope.selectBox.geometry.x = imgOffsetX / currentPage.scene.ratio;
                    $scope.selectBox.geometry.y = imgOffsetY / currentPage.scene.ratio;

                    var value = {};
                    if ($scope.selectBox.current == 'textbox') {
                        value = $scope.pageValue.textbox;
                    } else if ($scope.selectBox.current == 'imagebox') {
                        value = $scope.pageValue.imagebox;
                    } else if ($scope.selectBox.current == 'imageart') {
                        value = $scope.pageValue.imageart;
                    } else if ($scope.selectBox.current == 'textdocument') {
                        value = $scope.pageValue.textdocument;
                    }
                    if (vm.unit == 'mm') {
                        value.x = unitTransformPx($scope.selectBox.geometry.x).toFixed(2) - 0;//px-->mm
                        value.y = unitTransformPx($scope.selectBox.geometry.y).toFixed(2) - 0;//px-->mm
                    } else {
                        value.x = unitTransformPx($scope.selectBox.geometry.x / 25.4 * vm.windowDpiW);
                        value.y = unitTransformPx($scope.selectBox.geometry.y / 25.4 * vm.windowDpiW);
                    }
                }
                $scope.currentPage = currentPage;

            }
            return false;
        }

        //鼠标松开事件
        function moveBoxEnd1() {
            if (dragBox.ctrlKey) {
                moveTogetherEnd();
            }
            drag = false;
            dragBox = {};
            document.removeEventListener("mousemove", moveBoxOn1, true);
            document.removeEventListener("mouseup", moveBoxEnd1, true);
            updateHistorys();
            $scope.$digest();
        }
        $scope.rotateBoxStart = function (e,item,index) {
            fn(e);
            var targ = e.target ? e.target : e.srcElement;
            $scope.template.levelI = index;
            var currentLevel = $scope.currentPage.levels.level[$scope.template.levelI];
            if (item.lock) {
                return
            }
            drag = true;
            var all = getAllCtrlKeyArray();
            if (all.length) {
                dragBox.ctrlKey = true;
            } else {
                dragBox.ctrlKey = false;
            }

            dragBox.clientX = e.clientX || 0;
            dragBox.clientY = e.clientY || 0;



            if(item.current=='imagebox'){
                dragBox._top = $(e.target).parents('.imgBox').offset().top + (item.geometry.height * $scope.currentPage.scale/$scope.currentPage.proportion / 2);
                dragBox._left = $(e.target).parents('.imgBox').offset().left + (item.geometry.width * $scope.currentPage.scale/$scope.currentPage.proportion / 2);
                if ($scope.RightPanel == 'mask') {
                    $scope.RightPanel = 'mask';
                } else {
                    $scope.RightPanel = 'placement';
                }
            }else if(item.current=='imageart'){
                dragBox._top = $(e.target).parents('.img-art').offset().top + (item.geometry.height * $scope.currentPage.scale/$scope.currentPage.proportion / 2);
                dragBox._left = $(e.target).parents('.img-art').offset().left + (item.geometry.width * $scope.currentPage.scale/$scope.currentPage.proportion / 2);
                $scope.RightPanel = 'material';
            }else if(item.current=='textbox'){
                dragBox._top = $(e.target).parents('.c-xml-page-textboxe').offset().top + (item.geometry.height * $scope.currentPage.scale/$scope.currentPage.proportion / 2);
                dragBox._left = $(e.target).parents('.c-xml-page-textboxe').offset().left + (item.geometry.width * $scope.currentPage.scale/$scope.currentPage.proportion / 2);
                $scope.RightPanel = 'text';
            }else if(item.current=='textdocument'){
                dragBox._top = $(e.target).parents('#textdocument').offset().top + (item.geometry.height * $scope.currentPage.scale/$scope.currentPage.proportion / 2);
                dragBox._left = $(e.target).parents('#textdocument').offset().left + (item.geometry.width * $scope.currentPage.scale/$scope.currentPage.proportion / 2);
                $scope.RightPanel = 'textDoc';
            }

            document.addEventListener("mousemove", rotateBoxOn, true);
            document.addEventListener("mouseup", rotateBoxEnd, true);
        }

        function rotateBoxOn(e) {
            fn(e);
            if (drag) {
                var angle = getAngle(dragBox._left,dragBox._top, e.clientX, e.clientY);
                if($scope.selectBox.current == 'imagebox'||$scope.selectBox.current == 'textdocument'){
                    $scope.selectBox.rotation.angle = 360 - angle;
                }else{
                    $scope.selectBox.rotation.angle = angle;
                }
                $scope.template.angle = $scope.selectBox.rotation.angle;
            }
            $scope.$digest();
            // e.stopPropagation();
            // e.preventDefault();
            return false;
        }

        function rotateBoxEnd() {
            drag = false;
            dragBox = {};
            $(".rotate-icon" + $scope.template.levelI).removeClass('rotate-icon-active');
            document.removeEventListener("mousemove", rotateBoxOn, true);
            document.removeEventListener("mouseup", rotateBoxEnd, true);
            updateHistorys();
            $scope.$digest();
        }
        function getAngle(px,py,mx,my){//获得人物中心和鼠标坐标连线，与y轴正半轴之间的夹角
            var x = Math.abs(px-mx);
            var y = Math.abs(py-my);
            var z = Math.sqrt(Math.pow(x,2)+Math.pow(y,2));
            var cos = y/z;
            var radina = Math.acos(cos);//用反三角函数求弧度
            var angle = Math.floor(180/(Math.PI/radina));//将弧度转换成角度
            if(mx<px&&my>py){//鼠标在第三象限
                angle = angle;
            }
            if(mx<px&&my<py){
                angle = 180 - angle;
            }
            if(mx>px&&my<py){
                angle = 180 + angle;
            }
            if(mx>px&&my>py){
                angle = 360 - angle;
            }
            // console.log(angle)
            return angle;
        }

        function moveTogether(currentPage, clientX, clientY) {
            angular.forEach(vm.CtrlKeyArray.imageboxes, function (imagebox, i) {
                // 当前页所有占位框
                var box = currentPage.levels.level[imagebox.levelI].imagebox;
                boxSetting(box, imagebox);
            })

            angular.forEach(vm.CtrlKeyArray.imagearts, function (imageart, i) {
                // 当前页所有素材
                var box = currentPage.levels.level[imageart.levelI].imageart;
                boxSetting(box, imageart);
            })

            angular.forEach(vm.CtrlKeyArray.textboxes, function (textbox, i) {
                // 当前页所有文字
                var box = currentPage.levels.level[textbox.levelI].textbox;
                boxSetting(box, textbox);
            })

            angular.forEach(vm.CtrlKeyArray.textdocuments, function (textdocument, i) {
                // 当前页所有文字
                var box = currentPage.levels.level[textdocument.levelI].textdocument;
                boxSetting(box, textdocument);
            })

            var imgWidth = 0, imgHeight = 0, height = 0, width = 0, x = 0, y = 0;

            function boxSetting(box, CtrlKeyBox) {
                var lar = (currentPage.bloodPx.left + currentPage.bloodPx.right) * currentPage.scale / currentPage.proportion;
                var tab = (currentPage.bloodPx.top + currentPage.bloodPx.bottom) * currentPage.scale / currentPage.proportion;
                imgWidth = box.geometry.width * currentPage.scale / currentPage.proportion;
                imgHeight = box.geometry.height * currentPage.scale / currentPage.proportion;
                height = currentPage.height * currentPage.scale;
                width = currentPage.width * currentPage.scale;
                x = CtrlKeyBox.geometry.x / currentPage.proportion * currentPage.scale + clientX;
                y = CtrlKeyBox.geometry.y / currentPage.proportion * currentPage.scale + clientY;
                // if (x <= 0) {
                //     x = 0;
                // }
                // if (x >= (width + lar - imgWidth)) {
                //     x = width + lar - imgWidth;
                // }
                // if (y <= 0) {
                //     y = 0;
                // }
                //
                // if (y >= (height + tab - imgHeight)) {
                //     y = height + tab - imgHeight;
                // }
                box.geometry.x = x / currentPage.scale * currentPage.proportion
                box.geometry.y = y / currentPage.scale * currentPage.proportion
                box.offsetXM = unitTransformPx(box.geometry.x).toFixed(2) - 0;//px-->mm
                box.offsetYM = unitTransformPx(box.geometry.y).toFixed(2) - 0;//px-->mm
            }
        }


        function moveTogetherEnd() {
            angular.forEach(vm.CtrlKeyArray.imageboxes, function (imagebox, i) {
                // 当前页所有占位框
                var box = $scope.currentPage.levels.level[imagebox.levelI].imagebox;
                ctrlKeySetting(box, imagebox);
            })

            angular.forEach(vm.CtrlKeyArray.imagearts, function (imageart, i) {
                // 当前页所有素材
                var box = $scope.currentPage.levels.level[imageart.levelI].imageart;
                ctrlKeySetting(box, imageart);
            })

            angular.forEach(vm.CtrlKeyArray.textboxes, function (textbox, i) {
                // 当前页所有文字
                var box = $scope.currentPage.levels.level[textbox.levelI].textbox;
                ctrlKeySetting(box, textbox);
            })

            angular.forEach(vm.CtrlKeyArray.textdocuments, function (textdocument, i) {
                // 当前页所有文字
                var box = $scope.currentPage.levels.level[textdocument.levelI].textdocument;
                ctrlKeySetting(box, textdocument);
            })

            function ctrlKeySetting(box, CtrlKeyBox) {
                CtrlKeyBox.geometry.x = box.geometry.x;
                CtrlKeyBox.geometry.y = box.geometry.y;
                CtrlKeyBox.offsetXM = box.offsetXM;
                CtrlKeyBox.offsetYM = box.offsetYM;
            }
        }

        /**
         *放大占位框
         * @param e
         */
        var dragFlag = false;
        var isZoomDown = false;
        $scope.resizeStartRigth = function($event, item,pro,index){
            if(item.lock){return}
            fn($event);
            imageboxZoom($event, item, 'right',pro,index)
        }
        $scope.resizeStartLeft = function ($event, item,pro,index) {
            if(item.lock){return}
            fn($event);
            imageboxZoom($event, item, 'left',pro,index)
        }
        $scope.resizeStartTop = function ($event, item,pro,index) {
            if(item.lock){return}
            fn($event);
            imageboxZoom($event, item, 'top',pro,index)
        }
        $scope.resizeStartBottom = function ($event, item,pro,index) {
            if(item.lock){return}
            fn($event);
            imageboxZoom($event, item, 'bottom',pro,index)
        }
        $scope.resizeStartLeft1 = function ($event, item,pro,index) {
            if(item.lock){return}
            fn($event);
            imageboxZoom1($event, item, 'left',pro,index)
        }
        $scope.resizeStartTop1 = function ($event, item,pro,index) {
            if(item.lock){return}
            fn($event);
            imageboxZoom1($event, item, 'top',pro,index)
        }
        $scope.resizeStartRight1 = function ($event, item,pro,index) {
            if(item.lock){return}
            fn($event);
            imageboxZoom1($event, item, 'right',pro,index)
        }
        $scope.resizeStartBottom1 = function ($event, item,pro,index) {
            if(item.lock){return}
            fn($event);
            imageboxZoom1($event, item, 'bottom',pro,index)
        }
        function imageboxZoom($event, item, direction, pro, index) {
            var x = $event.clientX;
            var y = $event.clientY;
            //获取w和h
            var nw = angular.copy(item.geometry.width) * pro;
            var nh = angular.copy(item.geometry.height) * pro;
            var nw1 = item.image ? angular.copy(item.image.width) * pro : 0;
            var nh1 = item.image ? angular.copy(item.image.height) * pro : 0;
            var nw2 = item.image ? angular.copy(item.image.width) * pro : 1;
            var nh2 = item.image ? angular.copy(item.image.height) * pro : 1;
            var x1 = item.image ? angular.copy(item.image.offsetx * pro) : 0;
            var y1 = item.image ? angular.copy(item.image.offsety * pro) : 0;
            var x2 = item.geometry.x * pro;
            var y2 = item.geometry.y * pro;
            var _scale = item.image ? angular.copy(item.image.scale) : 1;
            if ($scope.currentPage.scene) {
                var _right = $($event.target).parents('.editing1').offset().left + ($scope.currentPage.mediabox.width * pro);
                var _bottom = $($event.target).parents('.editing1').offset().top + ($scope.currentPage.mediabox.height * pro);
            } else {
                var _right = $($event.target).parents('.page-item').offset().left + ($scope.currentPage.mediabox.width * pro);
                var _bottom = $($event.target).parents('.page-item').offset().top + ($scope.currentPage.mediabox.height * pro);
            }
            //开关打开
            isZoomDown = true;
            //鼠标移动
            window.onmousemove = function (e) {
                if (isZoomDown == false) {
                    return;
                }
                //获取x和y
                var nx = e.clientX;
                if (nx > _right) {
                    nx = _right
                }
                //计算移动后的左偏移量和顶部的偏移量
                var nl = nx - x;

                if (direction == 'bottom' || direction == 'left') {
                    var _w = (Number(nw) - Number(nl));
                }
                if (direction == 'top' || direction == 'right') {
                    var _w = (Number(nw) + Number(nl));
                }
                var _h = _w / nw * nh;
                if ($scope.currentPage.scene) {
                    if (_w > $scope.currentPage.mediabox.width * pro) {
                        _w = $scope.currentPage.mediabox.width * pro;
                        _h = _w / nw * nh;
                    }
                    if (_h > $scope.currentPage.mediabox.height * pro) {
                        _h = $scope.currentPage.mediabox.height * pro;
                        _w = _h / nh * nw;
                    }
                } else {
                    if (_w > ($scope.currentPage.mediabox.width / $scope.currentPage.proportion) * $scope.currentPage.scale) {
                        _w = ($scope.currentPage.mediabox.width / $scope.currentPage.proportion) * $scope.currentPage.scale;
                        _h = _w / nw * nh;
                    }
                    if (_h > ($scope.currentPage.mediabox.height / $scope.currentPage.proportion) * $scope.currentPage.scale) {
                        _h = ($scope.currentPage.mediabox.height / $scope.currentPage.proportion) * $scope.currentPage.scale;
                        _w = _h / nh * nw;
                    }
                }
                item.geometry.width = _w / pro;
                item.geometry.height = _h / pro;
                if (item.image) {
                    item.image.width = _w / nw * nw2 / pro;
                    item.image.height = _w / nw * nh2 / pro;
                    item.image.offsetx = (_w / (nw / nw1)) / (nw1 / x1) / pro;
                    item.image.offsety = (_h / (nh / nh1)) / (nh1 / y1) / pro;
                }
                if (direction == 'left') {
                    item.geometry.x = (Number(x2) - Number(_w - nw)) / pro;
                    item.geometry.y = (Number(y2) - Number(_h - nh)) / pro;
                    if (item.geometry.x < 0) {
                        item.geometry.x = 0;
                    }
                    if (item.geometry.y < 0) {
                        item.geometry.y = 0;
                    }
                }
                if (direction == 'top') {
                    item.geometry.y = (Number(y2) - Number(_h - nh)) / pro;
                    if (item.geometry.y < 0) {
                        item.geometry.y = 0;
                    }
                }
                if (direction == 'right') {
                    if ($scope.currentPage.scene) {
                        if (Number(item.geometry.height * pro) + Number(item.geometry.y * pro) > $scope.currentPage.mediabox.height * pro) {
                            item.geometry.height = ($scope.currentPage.mediabox.height * pro - Number(item.geometry.y * pro)) / pro;
                            item.geometry.width = item.geometry.height / nh * nw;
                            return;
                        }
                    } else {
                        if (Number(item.geometry.height * pro) + Number(item.geometry.y * pro) > ($scope.currentPage.height + $scope.currentPage.xayBorder / $scope.currentPage.proportion) * $scope.currentPage.scale) {
                            item.geometry.height = (($scope.currentPage.height + $scope.currentPage.xayBorder / $scope.currentPage.proportion) * $scope.currentPage.scale - Number(item.geometry.y * pro)) / pro;
                            item.geometry.width = item.geometry.height / nh * nw;
                            return;
                        }
                    }
                }
                if (direction == 'bottom') {
                    if ($scope.currentPage.scene) {
                        if (Number(item.geometry.height * pro) + Number(item.geometry.y * pro) > $scope.currentPage.mediabox.height * pro) {
                            item.geometry.height = ($scope.currentPage.mediabox.height * pro - Number(item.geometry.y * pro)) / pro;
                            item.geometry.width = item.geometry.height / nh * nw;
                            return;
                        }
                    } else {
                        if (Number(item.geometry.height * pro) + Number(item.geometry.y * pro) > ($scope.currentPage.height + $scope.currentPage.xayBorder / $scope.currentPage.proportion) * $scope.currentPage.scale) {
                            item.geometry.height = (($scope.currentPage.height + $scope.currentPage.xayBorder / $scope.currentPage.proportion) * $scope.currentPage.scale - Number(item.geometry.y * pro)) / pro;
                            item.geometry.width = item.geometry.height / nh * nw;
                            return;
                        }
                    }
                    item.geometry.x = (Number(x2) - Number(_w - nw)) / pro;
                    if (item.geometry.x < 0) {
                        item.geometry.x = 0;
                    }
                }
                $scope.template.levelI = index || $scope.template.levelI;
                $scope.currentPage.levels.level[$scope.template.levelI].imagebox = item;
                if (vm.unit == 'mm') {
                    $scope.pageValue.imagebox = {
                        width: unitTransformPx(item.geometry.width).toFixed(2) - 0,
                        height: unitTransformPx(item.geometry.height).toFixed(2) - 0,
                        x: unitTransformPx(item.geometry.x).toFixed(2) - 0,
                        y: unitTransformPx(item.geometry.y).toFixed(2) - 0,
                    }
                } else {
                    $scope.pageValue.imagebox = {
                        width: unitTransformPx(item.geometry.width / 25.4 * vm.windowDpiW),
                        height: unitTransformPx(item.geometry.height / 25.4 * vm.windowDpiW),
                        x: unitTransformPx(item.geometry.x / 25.4 * vm.windowDpiW),
                        y: unitTransformPx(item.geometry.y / 25.4 * vm.windowDpiW),
                    }
                }
                $scope.$digest();
            }
            //鼠标抬起事件
            window.onmouseup = function ($event) {
                $event.stopPropagation();
                isZoomDown = false;
                if($scope.currentPage.levels.level&&$scope.currentPage.levels.level[$scope.template.levelI]){
                    var level = $scope.currentPage.levels.level[$scope.template.levelI];
                    if (level.imagebox && level.imagebox.mask && level.imagebox.mask.resource && level.imagebox.mask.resource.identifier) {
                        if (level.imagebox.image && level.imagebox.image.resource.identifier) {
                            imageboxResourceCanvas(level.imagebox);
                        } else {
                            maskScale(null, level.imagebox, $scope.template.levelI, level.imagebox.mask.resource.identifier)
                        }
                    }
                }

            }
        }

        function imageboxZoom1($event, item, direction, pro, index) {
            var x = $event.clientX;
            var y = $event.clientY;
            //获取w和h
            var nw = angular.copy(item.geometry.width) * pro;
            var nh = angular.copy(item.geometry.height) * pro;
            var nw1 = item.image ? angular.copy(item.image.width) * pro : 0;
            var nh1 = item.image ? angular.copy(item.image.height) * pro : 0;
            var nw2 = item.image ? angular.copy(item.image.width) * pro : 1;
            var nh2 = item.image ? angular.copy(item.image.height) * pro : 1;
            var x1 = item.image ? angular.copy(item.image.offsetx * pro) : 0;
            var y1 = item.image ? angular.copy(item.image.offsety * pro) : 0;
            var x2 = item.geometry.x * pro;
            var y2 = item.geometry.y * pro;
            var _scale = item.image ? angular.copy(item.image.scale) : 1;

            if ($scope.currentPage.scene) {
                var _right = $($event.target).parents('.editing1').offset().left + ($scope.currentPage.mediabox.width * pro);
                var _bottom = $($event.target).parents('.editing1').offset().top + ($scope.currentPage.mediabox.height * pro);
            } else {
                var _right = $($event.target).parents('.page-item').offset().left + ($scope.currentPage.mediabox.width * pro);
                var _bottom = $($event.target).parents('.page-item').offset().top + ($scope.currentPage.mediabox.height * pro);
            }
            //开关打开
            isZoomDown = true;
            //鼠标移动
            window.onmousemove = function (e) {
                if (isZoomDown == false) {
                    return;
                }
                //获取x和y
                var nx = e.clientX;
                var ny = e.clientY;
                if (nx > _right) {
                    nx = _right
                }
                if (ny > _bottom) {
                    ny = _bottom
                }
                //计算移动后的左偏移量和顶部的偏移量
                var nl = nx - x;
                var nt = ny - y;

                if (direction == 'left') {
                    var _w = (Number(nw) - Number(nl));
                }
                if (direction == 'right') {
                    var _w = (Number(nw) + Number(nl));
                }
                if (direction == 'top') {
                    var _h = (Number(nh) - Number(nt));
                }
                if (direction == 'bottom') {
                    var _h = (Number(nh) + Number(nt));
                }
                if (_w > ($scope.currentPage.mediabox.width / $scope.currentPage.proportion) * $scope.currentPage.scale) {
                    _w = ($scope.currentPage.mediabox.width / $scope.currentPage.proportion) * $scope.currentPage.scale;
                }
                if (_h > ($scope.currentPage.mediabox.height / $scope.currentPage.proportion) * $scope.currentPage.scale) {
                    _h = ($scope.currentPage.mediabox.height / $scope.currentPage.proportion) * $scope.currentPage.scale;
                }


                if (item.image) {
                    item.image.offsetx = 0;
                    item.image.offsety = 0;
                }
                if (direction == 'left') {
                    if ((Number(x2) - Number(_w - nw)) / pro < 0) {
                        item.geometry.x = 0;
                    } else {
                        item.geometry.x = (Number(x2) - Number(_w - nw)) / pro;
                        item.geometry.width = _w / pro;
                    }
                }
                if (direction == 'top') {
                    if ((Number(y2) - Number(_h - nh)) / pro < 0) {
                        item.geometry.y = 0;
                    } else {
                        item.geometry.y = (Number(y2) - Number(_h - nh)) / pro;
                        item.geometry.height = _h / pro;
                    }
                }
                if (direction == 'right') {
                    item.geometry.width = _w / pro;
                }
                if (direction == 'bottom') {
                    item.geometry.height = _h / pro;
                }
                $scope.template.levelI = index || $scope.template.levelI;
                $scope.currentPage.levels.level[$scope.template.levelI].imagebox = item;
                $scope.$digest();
            }
            //鼠标抬起事件
            window.onmouseup = function ($event) {
                $event.stopPropagation();
                if (isZoomDown) {
                    vm.singleArray = {imagebox: {}, textbox: {}, imageart: {}, barcode: {}, qrcode: {}};
                    vm.singleArray.imagebox = angular.copy(item);
                    dragMask = {};
                    updateHistorys();
                    var pressImg = item;
                    if (pressImg.image && pressImg.image.resource.identifier) {
                        pressImg.image.offsetx = 0;
                        pressImg.image.offsety = 0;
                        getBackgroundSource1(pressImg.image.resource, pressImg.geometry.width, pressImg.geometry.height, pressImg.image);
                    }

                    if (pressImg.mask && pressImg.mask.resource && pressImg.mask.resource.identifier) {
                        if (pressImg.image && pressImg.image.resource.identifier) {
                            imageboxResourceCanvas(pressImg);
                        } else {
                            maskScale($event, pressImg, $scope.template.levelI, pressImg.mask.resource.identifier)
                        }
                    }
                    isZoomDown = false;
                    $scope.$digest();
                }
            }
        }

        $scope.updateBoxParameter = function (p1, p2) {
            var box = {}, boxW = null, boxH = null, value = {};
            var level = $scope.currentPage.levels.level[$scope.template.levelI];
            if ($scope.RightPanel == 'placement' || $scope.RightPanel == 'mask') {
                box = level.imagebox;
                value = $scope.pageValue.imagebox;
            } else if ($scope.RightPanel == 'material') {
                box = level.imageart;
                value = $scope.pageValue.imageart;
                boxW = angular.copy(box.resource.width);
                boxH = angular.copy(box.resource.height);
            } else if ($scope.RightPanel == 'text') {
                box = level.textbox;
                value = $scope.pageValue.textbox;
            } else if ($scope.RightPanel == 'textDoc') {
                box = level.textdocument;
                value = $scope.pageValue.textdocument;
            }
            if (box.lock) {
                return
            }

            if (vm.unit == 'mm') {
                box.geometry = {
                    width: unitTransform(value.width),
                    height: unitTransform(value.height),
                    x: unitTransform(value.x),
                    y: unitTransform(value.y)
                }
                if (p1 == 'width' && $scope.RightPanel == 'material') {
                    box.geometry.height = box.geometry.width * boxH / boxW;
                    value.height = unitTransformPx(box.geometry.height);
                    box.offsetx = 0;
                    box.offsety = 0;
                    box.scale = 1;
                } else if (p1 == 'height' && $scope.RightPanel == 'material') {
                    box.geometry.width = box.geometry.height * boxW / boxH;
                    value.width = unitTransformPx(box.geometry.width);
                    box.offsetx = 0;
                    box.offsety = 0;
                    box.scale = 1;
                }
            }
            if (vm.unit == 'px') {
                box.geometry = value;
                if (p1 == 'width' && $scope.RightPanel == 'material') {
                    box.geometry.height = box.geometry.width * boxH / boxW;
                    value.height = box.geometry.height;
                    box.offsetx = 0;
                    box.offsety = 0;
                    box.scale = 1;
                } else if (p1 == 'height' && $scope.RightPanel == 'material') {
                    box.geometry.width = box.geometry.height * boxW / boxH;
                    value.width = box.geometry.width;
                    box.offsetx = 0;
                    box.offsety = 0;
                    box.scale = 1;
                }
            }

            if ($scope.currentPage.scene) {
                $scope.selectScene();
            } else {
                updateHistorys();
            }
            // console.log($scope.currentPage.levels.level)
        };

        $scope.updatetextDocParameter = function (p1, p2) {
            var level = $scope.currentPage.levels.level[$scope.template.levelI];

            var box = level.textdocument;
            textdocW = angular.copy(box.geometry.width);
            textdocH = angular.copy(box.geometry.height);

            if (box.lock) {
                return
            }

            if (vm.unit == 'mm') {
                box.geometry = {
                    width: unitTransform($scope.pageValue.textdocument.width),
                    height: unitTransform($scope.pageValue.textdocument.height),
                    x: unitTransform($scope.pageValue.textdocument.x),
                    y: unitTransform($scope.pageValue.textdocument.y)
                }
                if (p1 == 'width') {
                    box.geometry.height = box.geometry.width * textdocH / textdocW;
                    $scope.pageValue.textdocument.height = unitTransformPx(box.geometry.height);
                } else {
                    box.geometry.width = box.geometry.height * textdocW / textdocH;
                    $scope.pageValue.textdocument.width = unitTransformPx(box.geometry.width);
                }
            }
            if (vm.unit == 'px') {
                box.geometry = {
                    width: $scope.pageValue.textdocument.width,
                    height: $scope.pageValue.textdocument.height,
                    x: $scope.pageValue.textdocument.x,
                    y: $scope.pageValue.textdocument.y
                }
                if (p1 == 'width') {
                    box.geometry.height = box.geometry.width * textdocH / textdocW;
                    $scope.pageValue.textdocument.height = box.geometry.height;
                } else {
                    box.geometry.width = box.geometry.height * textdocW / textdocH;
                    $scope.pageValue.textdocument.width = box.geometry.width;
                }
            }

            textdocument = angular.copy(box);
            resizeLevelWaH();

            if ($scope.currentPage.scene) {
                $scope.selectScene();
            } else {
                updateHistorys();
            }

        };

        //图片占位框旋转角度
        $scope.updateRotate = function () {
            var box = {};
            if (!$scope.currentPage.scene) {
                if ($scope.RightPanel == 'placement' || $scope.RightPanel == 'mask') {
                    box = $scope.currentPage.levels.level[$scope.template.levelI].imagebox.rotation;
                } else if ($scope.RightPanel == 'material') {
                    box = $scope.currentPage.levels.level[$scope.template.levelI].imageart.rotation;
                } else if ($scope.RightPanel == 'text') {
                    box = $scope.currentPage.levels.level[$scope.template.levelI].textbox.rotation;
                } else if ($scope.RightPanel == 'barcode') {
                    box = $scope.currentPage.barcode.rotation;
                } else if ($scope.RightPanel == 'qrcode') {
                    box = $scope.currentPage.qrcode.rotation;
                }

                if (box.lock) {
                    return
                }

                box.angle = $scope.template.angle;
                updateHistorys();
            } else {
                $scope.currentPage.imagebox.rotation.angle = $scope.template.angle;
            }
        };

        $scope.delPic = function(){
            // debugger
            // if (!$scope.currentPage.isScene) {
                var box = null;
                if ($scope.RightPanel == 'placement' || $scope.RightPanel == 'mask') {
                    box = $scope.currentPage.levels.level[$scope.template.levelI].imagebox;
                    if(box.image&&box.image.resource&&box.image.resource.identifier){
                        box.image = null;
                    }
                }
            // }
        }

        /* ==========================================================================
         素材处理
         ========================================================================== */
        // 素材点击时
        $scope.selectArt = function (e, $index, art) {
            fn(e);
            if (vm.unit == 'mm') {
                $scope.pageValue.imageart = {
                    width: unitTransformPx(art.geometry.width).toFixed(2) - 0,
                    height: unitTransformPx(art.geometry.height).toFixed(2) - 0,
                    x: unitTransformPx(art.geometry.x).toFixed(2) - 0,
                    y: unitTransformPx(art.geometry.y).toFixed(2) - 0
                }
            } else {
                $scope.pageValue.imageart = {
                    width: art.geometry.width,
                    height: art.geometry.height,
                    x: art.geometry.x,
                    y: art.geometry.y
                }
            }
            $scope.template.angle = art.rotation.angle;
            $scope.template.transparency = art.transparency * 100;
            $(elem).val(art.transparency);

            art.current = 'imageart';
            $scope.selectBox = art;

            $("#menus").fadeOut();
            //如果是按住ctrl键 实现多选复制
            if (e.ctrlKey == true || e.metaKey == true) {
                if (art.lock) {
                    return
                }
                art.ctrlKey = true;
                vm.CtrlKeyArray.imagearts[$index] = angular.copy(art);
                ctrlAddSingleArray();
            } else {
                $scope.clearCtrlKey();
                vm.singleArray = {imagebox: {}, textbox: {}, imageart: {}, barcode: {}, qrcode: {}};
                if (art.lock) {
                    return
                }
                vm.singleArray.imageart = angular.copy(art);
            }
            $scope.template.levelI = $index;
            $scope.RightPanel = 'material';
            e.stopPropagation();
        };

        window.doubleClickClipart = function (e, item) {
            fn(e);
            var targ = e.target ? e.target : e.srcElement;
            $scope.template.levelI = targ.dataset.index || $scope.template.levelI;
            var imageart = $scope.currentPage.levels.level[$scope.template.levelI].imageart;
            $scope.template.angle = imageart.rotation.angle;

            if (imageart.lock) {
                return
            }
            vm.pageMarginTop = 0;
            if($scope.currentPage.scene){
                vm.pageMarginTop = parseFloat($(".page-item1").css('margin-top'));
                vm.imageartTrimRatio = $scope.currentPage.scene.ratio;
            }else{
                vm.pageMarginTop = parseFloat($(".page-item").css('margin-top'));
                vm.imageartTrimRatio = $scope.currentPage.scale/$scope.currentPage.proportion;
            }

            // console.log(vm.pageMarginTop)
            vm.isImageartTrim = true;
            vm.imageartTrim = angular.copy(imageart);
            vm.imageartTrim.geometry.width1 = angular.copy(imageart.geometry.width);
            vm.imageartTrim.geometry.height1 = angular.copy(imageart.geometry.height);
            vm.imageartTrim.geometry.x1 = angular.copy(imageart.geometry.x);
            vm.imageartTrim.geometry.y1 = angular.copy(imageart.geometry.y);

            var pro = vm.imageartTrimRatio;
            if (vm.imageartTrim.geometry.width * pro == vm.imageartTrim.geometry.width1 * pro * vm.imageartTrim.scale) {
                vm.imageartTrim.geometry.width = vm.imageartTrim.geometry.width * 0.8;
                vm.imageartTrim.geometry.height = vm.imageartTrim.geometry.height * 0.8;
                vm.imageartTrim.geometry.x = Number(vm.imageartTrim.geometry.x) + Number(vm.imageartTrim.geometry.width / 0.8 * 0.2 / 2);
                vm.imageartTrim.geometry.y = Number(vm.imageartTrim.geometry.y) + Number(vm.imageartTrim.geometry.height / 0.8 * 0.2 / 2);
            }
            $scope.$digest();
        }

        //拖动素材裁切
        var isImageartTrim = false;
        $scope.imageartTrimdown = function ($event) {
            fn($event)
            var x = $event.clientX;
            var y = $event.clientY;
            var pro = vm.imageartTrimRatio;
            var l = vm.imageartTrim.geometry.x * pro;
            var t = vm.imageartTrim.geometry.y * pro;
            var r = (vm.imageartTrim.geometry.width1 * vm.imageartTrim.scale - vm.imageartTrim.geometry.width) * pro;
            var b = (($("#c-xml-imageart-trim-img").find('img').height()) / pro - vm.imageartTrim.geometry.height) * pro;

            var x1 = (Number(vm.imageartTrim.geometry.x1) + Number(vm.imageartTrim.offsetx)) * pro;
            var y1 = (Number(vm.imageartTrim.geometry.y1) + Number(vm.imageartTrim.offsety)) * pro;
            var x2 = vm.imageartTrim.geometry.x1 * pro;
            var y2 = vm.imageartTrim.geometry.y1 * pro;
            var x3 = vm.imageartTrim.offsetx * pro;
            var y3 = vm.imageartTrim.offsety * pro;
            //开关打开
            isImageartTrim = true;
            //鼠标移动
            window.onmousemove = function (e) {
                if (isImageartTrim == false) {
                    return;
                }
                //获取x和y
                var nx = e.clientX;
                var ny = e.clientY;
                //计算移动后的左偏移量和顶部的偏移量
                var nl = nx - (x - l);
                var nt = ny - (y - t);


                if (nl < x1) {
                    nl = x1
                }
                ;
                if (nl > Number(r) + Number(x1)) {
                    nl = Number(r) + Number(x1)
                }
                ;
                if (nt < y1) {
                    nt = y1
                }
                ;
                if (nt > Number(b) + Number(y1)) {
                    nt = Number(b) + Number(y1)
                }
                ;

                vm.imageartTrim.geometry.x = nl / pro;
                vm.imageartTrim.geometry.y = nt / pro;

                $("#c-xml-imageart-trim-frame").css({
                    left: nl + 'px',
                    top: nt + 'px',
                });
                $("#c-xml-imageart-trim-frame-img").css({
                    left: Number(x2 - nl) + Number(x3) + 'px',
                    top: Number(y2 - nt) + Number(y3) + 'px',
                });
            }
            //鼠标抬起事件
            window.onmouseup = function ($event) {
                isImageartTrim = false;
                $event.stopPropagation();
            }
        }

        //素材裁切放大缩小
        var isImageartTrimRight = false;
        $scope.imageartTrimRight = function ($event, item) {
            fn($event)
            var x = $event.clientX;
            var y = $event.clientY;
            var pro = vm.imageartTrimRatio;
            //获取w和h
            // var nw = $($event.target).parent().width();
            // var nh = $($event.target).parent().height();
            var nw = Number(item.geometry.width * pro) + Number(item.geometry.x * pro);
            var nh = Number(item.geometry.height * pro) + Number(item.geometry.y * pro);
            var _l = item.geometry.x * pro;
            var _t = item.geometry.y * pro;


            // var r = Number($("#c-xml-imageart-trim-div").offset().left) + Number(vm.imageartTrim.geometry.width1 * pro * vm.imageartTrim.scale);
            // var b = Number($("#c-xml-imageart-trim-div").offset().top) + Number($("#c-xml-imageart-trim-img").find('img').height());

            var r = Number(item.geometry.x1 * pro) + Number(item.offsetx * pro) + Number(item.geometry.width1 * pro * item.scale);
            var b = Number(item.geometry.y1 * pro) + Number(item.offsety * pro) + Number($("#imageartTrimRight1").height());
            //开关打开
            isImageartTrimRight = true;
            //鼠标移动
            window.onmousemove = function (e) {
                if (isImageartTrimRight == false) {
                    return;
                }

                //获取x和y
                var nx = e.clientX;
                var ny = e.clientY;
                //计算移动后的左偏移量和顶部的偏移量
                var nl = Number(nw) + Number(nx - x);
                var nt = Number(nh) + Number(ny - y);

                if (nl >= r) {
                    nl = r
                }
                if (nt >= b) {
                    nt = b
                }

                item.geometry.width = (nl - _l) / pro;
                item.geometry.height = (nt - _t) / pro;
                $scope.$digest();
            }
            //鼠标抬起事件
            window.onmouseup = function ($event) {
                isImageartTrimRight = false;
                $event.stopPropagation();
            }
        }
        $scope.imageartTrimTrueClick = function () {
            vm.isImageartTrim = false;
            var pro = vm.imageartTrimRatio
            vm.imageartTrim.scale = (vm.imageartTrim.geometry.width1 * pro * vm.imageartTrim.scale) / (vm.imageartTrim.geometry.width * pro);
            vm.imageartTrim.offsetx = (Number(-(vm.imageartTrim.geometry.x - vm.imageartTrim.geometry.x1)) + Number(vm.imageartTrim.offsetx)).toFixed(2) - 0;
            vm.imageartTrim.offsety = (Number(-(vm.imageartTrim.geometry.y - vm.imageartTrim.geometry.y1)) + Number(vm.imageartTrim.offsety)).toFixed(2) - 0;
            vm.imageartTrim.geometry.x = $scope.currentPage.levels.level[$scope.template.levelI].imageart.geometry.x;
            vm.imageartTrim.geometry.y = $scope.currentPage.levels.level[$scope.template.levelI].imageart.geometry.y;
            if (vm.imageartTrim.offsetx > 0) {
                vm.imageartTrim.offsetx = 0;
            }
            if (vm.imageartTrim.offsety > 0) {
                vm.imageartTrim.offsety = 0;
            }
            if (vm.imageartTrim.scale < 1) {
                vm.imageartTrim.scale = 1;
            }
            $scope.currentPage.levels.level[$scope.template.levelI].imageart = vm.imageartTrim;
        }
        $scope.imageartTrimFalseClick = function () {
            vm.isImageartTrim = false;
        }

        //素材缩放right
        var isZoomDown = false;
        $scope.imageartdownZoomRight = function ($event, item, boole) {
            // if(item.movable){return}
            fn($event)
            if (boole) {
                imageartZoom1($event, item, 'right')
            } else {
                imageartZoom($event, item, 'right')
            }
        }
        //素材缩放left
        $scope.imageartdownZoomLeft = function ($event, item, boole) {
            // if(item.movable){return}
            fn($event)
            if (boole) {
                imageartZoom1($event, item, 'left')
            } else {
                imageartZoom($event, item, 'left')
            }
        }
        //素材缩放top
        $scope.imageartdownZoomTop = function ($event, item, boole) {
            // if(item.movable){return}
            fn($event)
            if (boole) {
                imageartZoom1($event, item, 'top')
            } else {
                imageartZoom($event, item, 'top')
            }
        }
        //素材缩放bottom
        $scope.imageartdownZoomBottom = function ($event, item, boole) {
            // if(!item.movable){return}
            fn($event)
            if (boole) {
                imageartZoom1($event, item, 'bottom')
            } else {
                imageartZoom($event, item, 'bottom')
            }
        }

        function imageartZoom($event, item, direction) {
            var pageIndex = $scope.template.pages.page[$scope.template.pageI];
            if (pageIndex == null) {
                return;
            }
            $scope.RightPanel = 'material';
            var pro = pageIndex.scale / pageIndex.proportion;

            var maxX = $contain.width();
            var maxY = $contain.height();
            var x = $event.clientX;
            var y = $event.clientY;
            //获取w和h
            var nw = angular.copy(item.geometry.width) * pro;
            var nh = angular.copy(item.geometry.height) * pro;
            var nw1 = angular.copy(item.resource.width) * pro;
            var nh1 = angular.copy(item.resource.height) * pro;
            var x1 = angular.copy(item.offsetx * pro);
            var y1 = angular.copy(item.offsety * pro);
            var x2 = item.geometry.x * pro;
            var y2 = item.geometry.y * pro;
            var _scale = angular.copy(item.scale);
            //开关打开
            isZoomDown = true;
            //鼠标移动
            window.onmousemove = function (e) {
                if (isZoomDown == false) {
                    return;
                }
                //获取x和y
                var nx = e.clientX;
                //计算移动后的左偏移量和顶部的偏移量
                var nl = nx - x;

                if (direction == 'bottom' || direction == 'left') {
                    var _w = (Number(nw) - Number(nl));
                }
                if (direction == 'top' || direction == 'right') {
                    var _w = (Number(nw) + Number(nl));
                }
                var _h = _w / nw * nh;
                // if(item.geometry.x* pro<=0){
                //     item.geometry.x = 0;
                // }
                // if(item.geometry.y* pro<=0){
                //     item.geometry.y = 0;
                // }

                if (_w - 0 + x2 > maxX) {
                    _w = maxX - x2;
                    _h = _w / nw * nh;
                }
                if (_h - 0 + y2 > maxY) {
                    _h = maxY - y2;
                    _w = _h / nh * nw;
                }

                if (_w > 20) {
                    item.geometry.width = _w / pro;
                    item.geometry.height = _h / pro;
                    item.offsetx = (_w / (nw / nw1)) / (nw1 / x1) / pro;
                    item.offsety = (_h / (nh / nh1)) / (nh1 / y1) / pro;
                    $($event.target).parent().parent().find('.c-xml-page-material-img').css({
                        width: _w * _scale + 'px',
                        left: (_w / (nw / nw1)) / (nw1 / x1) + 'px',
                        top: (_h / (nh / nh1)) / (nh1 / y1) + 'px',
                    });

                    if (direction == 'left') {
                        item.geometry.x = (Number(x2) - Number(_w - nw)) / pro;
                        item.geometry.y = (Number(y2) - Number(_h - nh)) / pro;
                        $($event.target).parent().parent().css({
                            width: _w + 'px',
                            height: _h + 'px',
                            left: Number(x2) - Number(_w - nw) + 'px',
                            top: Number(y2) - Number(_h - nh) + 'px',
                        });
                    }
                    if (direction == 'top') {
                        item.geometry.y = (Number(y2) - Number(_h - nh)) / pro;
                        $($event.target).parent().parent().css({
                            width: _w + 'px',
                            height: _h + 'px',
                            top: Number(y2) - Number(_h - nh) + 'px',
                        });
                    }
                    if (direction == 'right') {
                        $($event.target).parent().parent().css({
                            width: _w + 'px',
                            height: _h + 'px'
                        });
                    }
                    if (direction == 'bottom') {
                        item.geometry.x = (Number(x2) - Number(_w - nw)) / pro;
                        $($event.target).parent().parent().css({
                            width: _w + 'px',
                            height: _h + 'px',
                            left: Number(x2) - Number(_w - nw) + 'px',
                        });
                    }
                    if (vm.unit == 'mm') {
                        $scope.pageValue.imageart = {
                            width: unitTransformPx(item.geometry.width).toFixed(2) - 0,
                            height: unitTransformPx(item.geometry.height).toFixed(2) - 0,
                            x: unitTransformPx(item.geometry.x).toFixed(2) - 0,
                            y: unitTransformPx(item.geometry.y).toFixed(2) - 0,
                        }
                    } else {
                        $scope.pageValue.imageart = {
                            width: unitTransformPx(item.geometry.width / 25.4 * vm.windowDpiW),
                            height: unitTransformPx(item.geometry.height / 25.4 * vm.windowDpiW),
                            x: unitTransformPx(item.geometry.x / 25.4 * vm.windowDpiW),
                            y: unitTransformPx(item.geometry.y / 25.4 * vm.windowDpiW),
                        }
                    }
                    $scope.$digest();
                }
            }
            //鼠标抬起事件
            window.onmouseup = function ($event) {
                vm.singleArray = {imagebox: {}, textbox: {}, imageart: {}, barcode: {}, qrcode: {}};
                vm.singleArray.imageart = angular.copy(item);
                isZoomDown = false;
                $event.stopPropagation();
            }
        }

        function imageartZoom1($event, item, direction) {
            var pageIndex = $scope.template.pages.page[$scope.template.pageI];
            if (pageIndex == null) {
                return;
            }
            $scope.RightPanel = 'material';
            // var pro = pageIndex.scene.scale / pageIndex.proportion;
            // var pro = pageIndex.scale / pageIndex.scene.proportion;
            var pro = pageIndex.scene.ratio;

            var maxX = $(".editing1").width();
            var maxY = $(".editing1").height();
            var x = $event.clientX;
            var y = $event.clientY;
            //获取w和h
            var nw = angular.copy(item.geometry.width) * pro;
            var nh = angular.copy(item.geometry.height) * pro;
            var nw1 = angular.copy(item.resource.width) * pro;
            var nh1 = angular.copy(item.resource.height) * pro;
            var x1 = angular.copy(item.offsetx * pro);
            var y1 = angular.copy(item.offsety * pro);
            var x2 = item.geometry.x * pro;
            var y2 = item.geometry.y * pro;
            var _scale = angular.copy(item.scale);
            //开关打开
            isZoomDown = true;
            //鼠标移动
            window.onmousemove = function (e) {
                if (isZoomDown == false) {
                    return;
                }
                //获取x和y
                var nx = e.clientX;
                //计算移动后的左偏移量和顶部的偏移量
                var nl = nx - x;

                if (direction == 'bottom' || direction == 'left') {
                    var _w = (Number(nw) - Number(nl));
                }
                if (direction == 'top' || direction == 'right') {
                    var _w = (Number(nw) + Number(nl));
                }
                var _h = _w / nw * nh;
                // if(item.geometry.x* pro<=0){
                //     item.geometry.x = 0;
                // }
                // if(item.geometry.y* pro<=0){
                //     item.geometry.y = 0;
                // }

                if (_w - 0 + x2 > maxX) {
                    _w = maxX - x2;
                    _h = _w / nw * nh;
                }
                if (_h - 0 + y2 > maxY) {
                    _h = maxY - y2;
                    _w = _h / nh * nw;
                }

                if (_w > 20) {
                    item.geometry.width = _w / pro;
                    item.geometry.height = _h / pro;
                    item.offsetx = (_w / (nw / nw1)) / (nw1 / x1) / pro;
                    item.offsety = (_h / (nh / nh1)) / (nh1 / y1) / pro;
                    $($event.target).parent().parent().find('.c-xml-page-material-img').css({
                        width: _w * _scale + 'px',
                        left: (_w / (nw / nw1)) / (nw1 / x1) + 'px',
                        top: (_h / (nh / nh1)) / (nh1 / y1) + 'px',
                    });

                    if (direction == 'left') {
                        item.geometry.x = (Number(x2) - Number(_w - nw)) / pro;
                        item.geometry.y = (Number(y2) - Number(_h - nh)) / pro;
                        $($event.target).parent().parent().css({
                            width: _w + 'px',
                            height: _h + 'px',
                            left: Number(x2) - Number(_w - nw) + 'px',
                            top: Number(y2) - Number(_h - nh) + 'px',
                        });
                    }
                    if (direction == 'top') {
                        item.geometry.y = (Number(y2) - Number(_h - nh)) / pro;
                        $($event.target).parent().parent().css({
                            width: _w + 'px',
                            height: _h + 'px',
                            top: Number(y2) - Number(_h - nh) + 'px',
                        });
                    }
                    if (direction == 'right') {
                        $($event.target).parent().parent().css({
                            width: _w + 'px',
                            height: _h + 'px'
                        });
                    }
                    if (direction == 'bottom') {
                        item.geometry.x = (Number(x2) - Number(_w - nw)) / pro;
                        $($event.target).parent().parent().css({
                            width: _w + 'px',
                            height: _h + 'px',
                            left: Number(x2) - Number(_w - nw) + 'px',
                        });
                    }
                    if (vm.unit == 'mm') {
                        $scope.pageValue.imageart = {
                            width: unitTransformPx(item.geometry.width).toFixed(2) - 0,
                            height: unitTransformPx(item.geometry.height).toFixed(2) - 0,
                            x: unitTransformPx(item.geometry.x).toFixed(2) - 0,
                            y: unitTransformPx(item.geometry.y).toFixed(2) - 0,
                        }
                    } else {
                        $scope.pageValue.imageart = {
                            width: unitTransformPx(item.geometry.width / 25.4 * vm.windowDpiW),
                            height: unitTransformPx(item.geometry.height / 25.4 * vm.windowDpiW),
                            x: unitTransformPx(item.geometry.x / 25.4 * vm.windowDpiW),
                            y: unitTransformPx(item.geometry.y / 25.4 * vm.windowDpiW),
                        }
                    }
                    $scope.$digest();
                }
            }
            //鼠标抬起事件
            window.onmouseup = function ($event) {
                isZoomDown = false;
                $event.stopPropagation();
            }
        }

        window.resizeArtStart1 = function (e) {
            fn(e);
            var targ = e.target ? e.target : e.srcElement;
            dragMask.clientX = e.clientX || 0;          //鼠标到页面左边的距离
            dragMask.clientY = e.clientY || 0;          //鼠标到页面顶部的距离
            dragMask.coordX = targ.offsetParent.offsetLeft + targ.offsetLeft;        //鼠标到模板左边的距离
            dragMask.coordY = targ.offsetParent.offsetTop + targ.offsetTop;         //鼠标到模板顶部的距离
            dragMask.maxX = $contain.width();
            dragMask.maxY = $contain.height();

            $scope.template.levelI = targ.dataset.index || $scope.template.levelI;
            var imageart = $scope.currentPage.levels.level[$scope.template.levelI].imageart;
            if (imageart.lock) {
                return
            }
            dragFlag = true;
            dragMask.orignW = imageart.geometry.width;
            dragMask.orignH = imageart.geometry.height;
            dragMask.orignOffsetx = imageart.offsetx;
            dragMask.orignOffsety = imageart.offsety;
            document.addEventListener("mousemove", resizeArtOn1, true);
            document.addEventListener("mouseup", resizeArtEnd1, true);
            // setZindex(e.target.dataset.index);
        };
        function resizeArtOn1(e) {
            if (dragFlag) {
                fn(e);
                // 是否按住shift键
                dragMask.shiftKey = e.shiftKey;
                $scope.RightPanel = 'material';
                var targ = e.target ? e.target : e.srcElement;
                if (targ == null) {
                    return;
                }
                var imgIndex = targ.dataset.index || $scope.template.levelI;
                if (imgIndex == null) {
                    return;
                }
                var pageIndex = $scope.template.pages.page[$scope.template.pageI];
                if (pageIndex == null) {
                    return;
                }
                var pressArt = pageIndex.levels.level[$scope.template.levelI].imageart;
                if (pressArt == null) {
                    return;
                }
                var pro = $scope.currentPage.scene.ratio;
                var x = pressArt.geometry.x* pro;
                var y = pressArt.geometry.y* pro;
                //20 小图标的宽高
                var w = (dragMask.coordX + 10 + e.clientX - dragMask.clientX - x);
                var h = w / pressArt.geometry.width * pressArt.geometry.height;

                if (w < 20 || h < 20) {
                    return
                }

                if(x+w>dragMask.maxX){
                    var maxW = dragMask.maxX-x;
                    pressArt.geometry.width = maxW/pro;
                    pressArt.geometry.height = (maxW / pressArt.geometry.width * pressArt.geometry.height)/pro;
                }else if(y+h>dragMask.maxY){
                    var maxH = dragMask.maxY-y;
                    pressArt.geometry.height = maxH/pro;
                    pressArt.geometry.width = (maxH/pressArt.geometry.height*pressArt.geometry.width)/pro;
                }else{
                    pressArt.geometry.width = w/pro;
                    pressArt.geometry.height = h/pro;
                }

                var scaleW = pressArt.geometry.width / dragMask.orignW;
                var scaleH = pressArt.geometry.height / dragMask.orignH
                pressArt.offsetx = scaleW * dragMask.orignOffsetx;
                pressArt.offsety = scaleH * dragMask.orignOffsety;
            }
            $scope.$digest();
            return false;
        }
        function resizeArtEnd1() {
            dragFlag = false;
            document.removeEventListener("mousemove", resizeArtOn1, true);
            document.removeEventListener("mouseup", resizeArtEnd1, true);
            updateHistorys();
            $scope.$digest();
        }

        /* ==========================================================================
         文字处理
         ========================================================================== */

        //编辑状态
        $scope.editableSel = function (box, attr) {
            $scope.currentPage.levels.level[$scope.template.levelI][box].editable = attr;
        }
        //不可编辑
        $scope.movableSel = function (box, attr) {
            $scope.currentPage.levels.level[$scope.template.levelI][box].movable = attr;
        }

        //文本框点击时

        $scope.selectDoc = function (e, $index, textdocument) {
            fn(e)
            $scope.template.levelI = $index;
            $scope.RightPanel = 'textDoc';
            if (vm.unit == 'mm') {
                $scope.pageValue.textdocument = {
                    width: unitTransformPx(textdocument.geometry.width).toFixed(2) - 0,
                    height: unitTransformPx(textdocument.geometry.height).toFixed(2) - 0,
                    x: unitTransformPx(textdocument.geometry.x).toFixed(2) - 0,
                    y: unitTransformPx(textdocument.geometry.y).toFixed(2) - 0
                }
            } else {
                $scope.pageValue.textdocument = {
                    width: textdocument.geometry.width,
                    height: textdocument.geometry.height,
                    x: textdocument.geometry.x,
                    y: textdocument.geometry.y
                }
            }

            $scope.template.angle = textdocument.rotation.angle;
            textdocument.current = 'textdocument';
            $scope.selectBox = textdocument;

            //如果是按住ctrl键 实现多选复制
            // var mm = $scope.currentPage.imageboxes.imagebox[$index];
            if (e.ctrlKey == true || e.metaKey == true) {
                if (textdocument.lock) {
                    return
                }
                textdocument.ctrlKey = true;
                vm.CtrlKeyArray.textdocuments[$index] = angular.copy(textdocument);
                ctrlAddSingleArray();
            } else {
                $scope.clearCtrlKey();
                vm.singleArray = {imagebox: {}, textbox: {}, imageart: {}, barcode: {}, qrcode: {}, textdocument: {}};
                if (textdocument.lock) {
                    return
                }
                vm.singleArray.textdocument = angular.copy(textdocument);
            }
            $("#menus").fadeOut();
            // setZindex($index);
            $("#maskSelect").val("");
            e.stopPropagation();
        };

        $scope.selectTextDocFont = function (e, levelIndex,docIndex, text) {
            fn(e);
            $scope.template.levelI = levelIndex;
            $scope.template.docI = docIndex;
            vm.textDocCon = text.text;

            $("#menus").fadeOut();
        };

        var dragTextDoc = {};
        window.moveTextDocStart = function (e) {
            var $event = e || window.event;
            if ($event && $event.preventDefault) {
                $event.preventDefault();
            }
            else {
                window.event.returnValue = false;
                return false;
            }
            $event.stopPropagation();
            $scope.buttonShows = true;
            var targ = e.target ? e.target : e.srcElement;
            $scope.template.levelI = targ.dataset.index;
            var currentLevel = $scope.currentPage.levels.level[$scope.template.levelI];
            var currentImg = currentLevel.textdocument;
            $scope.template.angle = currentImg.rotation.angle;
            if (!currentImg.movable) {
                return
            }

            dragTextDoc.clientX = e.clientX || 0;
            dragTextDoc.clientY = e.clientY || 0;
            dragTextDoc.coordX = targ.offsetLeft;
            dragTextDoc.coordY = targ.offsetTop;
            drag = true;
            var all = getAllCtrlKeyArray();
            if (all.length) {
                dragTextDoc.ctrlKey = true;
            } else {
                dragTextDoc.ctrlKey = false;
            }
            document.addEventListener("mousemove", moveTextDocOn, true);
            document.addEventListener("mouseup", moveTextDocEnd, true);

        };
        //move 事件
        function moveTextDocOn(e) {
            fn(e);
            $scope.$digest();
            if (e.target.nodeName == 'SPAN') {
                return;
            }
            if (drag) {
                var currentPage = $scope.template.pages.page[$scope.template.pageI];
                var currentLevel = currentPage.levels.level[$scope.template.levelI];
                var pressImg = currentLevel.textdocument;
                var angle = (pressImg.rotation.angle) * Math.PI / 180;

                var clientX = e.clientX - dragTextDoc.clientX;
                var clientY = e.clientY - dragTextDoc.clientY;

                var imgOffsetX = (dragTextDoc.coordX + e.clientX - dragTextDoc.clientX);
                var imgOffsetY = (dragTextDoc.coordY + e.clientY - dragTextDoc.clientY);
                var imgWidth = pressImg.geometry.width * currentPage.scale / currentPage.proportion;
                var imgHeight = pressImg.geometry.height * currentPage.scale / currentPage.proportion;
                var height = currentPage.height * currentPage.scale;
                var width = currentPage.width * currentPage.scale;
                var left = (currentPage.bloodPx.left + currentPage.bloodPx.right) * currentPage.scale / currentPage.proportion;
                var top = (currentPage.bloodPx.top + currentPage.bloodPx.bottom) * currentPage.scale / currentPage.proportion;

                if (angle == 0) {
                    if (imgOffsetX <= left) {
                        imgOffsetX = left;
                    }

                    if (imgOffsetX >= (width + left - imgWidth)) {
                        imgOffsetX = width + left - imgWidth;
                    }
                    if (imgOffsetY <= top) {
                        imgOffsetY = top;
                    }

                    if (imgOffsetY >= (height + top - imgHeight)) {
                        imgOffsetY = height + top - imgHeight;
                    }
                } else {
                    if (imgOffsetX <= left) {
                        imgOffsetX = left;
                    }

                    if (imgOffsetX >= (width + left)) {
                        imgOffsetX = width + left;
                    }
                    if (imgOffsetY <= top) {
                        imgOffsetY = top;
                    }

                    if (imgOffsetY >= (height + top)) {
                        imgOffsetY = height + top;
                    }

                }

                if (dragTextDoc.ctrlKey) {
                    moveTogether(currentPage, clientX, clientY);
                } else {
                    pressImg.geometry.x = imgOffsetX / currentPage.scale * currentPage.proportion;
                    pressImg.geometry.y = imgOffsetY / currentPage.scale * currentPage.proportion;
                    $scope.pageValue.px.x = unitTransformPx(pressImg.geometry.x / 25.4 * vm.windowDpiW);
                    $scope.pageValue.px.y = unitTransformPx(pressImg.geometry.y / 25.4 * vm.windowDpiH);
                    $scope.pageValue.mm.x = pressImg.offsetXM = unitTransformPx(pressImg.geometry.x).toFixed(2) - 0;//px-->mm
                    $scope.pageValue.mm.y = pressImg.offsetYM = unitTransformPx(pressImg.geometry.y).toFixed(2) - 0;//px-->mm
                }
                $scope.currentPage = currentPage;
            }
            return false;
        }

        //鼠标松开事件
        function moveTextDocEnd() {
            if (dragTextDoc.ctrlKey) {
                moveTogetherEnd();
            }
            drag = false;
            dragTextDoc = {};
            document.removeEventListener("mousemove", moveTextDocOn, true);
            document.removeEventListener("mouseup", moveTextDocEnd, true);
            updateHistorys();
            $scope.$digest();
        }

        /**
         *放大占位框
         * @param e
         */
        var dragDocFlag = false, dragDoc = {}, textdocW = 1, textdocH = 1, textdocument = null;
        window.resizeDocStart = function (e) {
            fn(e);
            var targ = e.target ? e.target : e.srcElement;

            $scope.template.levelI = targ.dataset.index || $scope.template.levelI;
            textdocument = angular.copy($scope.currentPage.levels.level[$scope.template.levelI].textdocument);

            if (textdocument.lock) {
                return
            }
            dragDoc.clientX = e.clientX || 0;          //鼠标到页面左边的距离
            dragDoc.clientY = e.clientY || 0;          //鼠标到页面顶部的距离
            dragDoc.coordX = targ.offsetParent.offsetLeft + targ.offsetLeft;        //鼠标到模板左边的距离
            dragDoc.coordY = targ.offsetParent.offsetTop + targ.offsetTop;         //鼠标到模板顶部的距离
            dragDoc.maxX = $contain.width();
            dragDoc.maxY = $contain.height();
            dragDocFlag = true;

            $scope.RightPanel = 'textDoc';

            textdocW = angular.copy(textdocument.geometry.width);
            textdocH = angular.copy(textdocument.geometry.height);

            document.addEventListener("mousemove", resizeDocOn, true);
            document.addEventListener("mouseup", resizeDocEnd, true);
            // setZindex(e.target.dataset.index);
        };
        function resizeDocOn(e) {
            if (dragDocFlag) {
                fn(e);
                // 是否按住shift键
                dragDoc.shiftKey = e.shiftKey;
                var targ = e.target ? e.target : e.srcElement;
                if (targ == null) {
                    return;
                }
                var imgIndex = $scope.template.levelI;
                if (imgIndex == null) {
                    return;
                }
                var pageIndex = $scope.template.pages.page[$scope.template.pageI];
                if (pageIndex == null) {
                    return;
                }
                var item = pageIndex.levels.level[$scope.template.levelI].textdocument;
                if (item == null) {
                    return;
                }

                var pro = pageIndex.scale / pageIndex.proportion
                var x = item.geometry.x* pro;
                var y = item.geometry.y* pro;
                //20 小图标的宽高
                var w = (dragDoc.coordX + 10 + e.clientX - dragDoc.clientX - x);
                // var w = (dragDoc.coordX + 10 + e.clientX - dragDoc.clientX - item.geometry.x *pro) /pro;
                var h = w / item.geometry.width * item.geometry.height

                if (w < 40 || h < 40) {
                    return
                }

                if (x + w > dragDoc.maxX) {
                    var maxW = dragDoc.maxX - x;
                    item.geometry.width = maxW / pro;
                    item.geometry.height = (maxW / item.geometry.width * item.geometry.height) / pro;
                } else if (y + h > dragDoc.maxY) {
                    var maxH = dragDoc.maxY - y;
                    item.geometry.height = maxH / pro;
                    item.geometry.width = (maxH / item.geometry.height * item.geometry.width) / pro;
                } else {
                    item.geometry.width = w / pro;
                    item.geometry.height = h / pro;
                }

                if (vm.unit == 'mm') {
                    $scope.pageValue.textdocument.width = unitTransformPx(item.geometry.width);
                    $scope.pageValue.textdocument.height = unitTransformPx(item.geometry.height);
                } else {
                    $scope.pageValue.textdocument.width = item.geometry.width;
                    $scope.pageValue.textdocument.height = item.geometry.height;
                }


                resizeLevelWaH();

            }
            $scope.$digest();
            return false;
        }
        function resizeDocEnd() {
            dragDocFlag = false;
            dragDoc = {};

            document.removeEventListener("mousemove", resizeDocOn, true);
            document.removeEventListener("mouseup", resizeDocEnd, true);
            updateHistorys();
            $scope.currentPage = $scope.template.pages.page[$scope.template.pageI];
            $scope.$digest();
        }
        window.resizeDocStart1 = function (e) {
            fn(e);
            var targ = e.target ? e.target : e.srcElement;

            $scope.template.levelI = targ.dataset.index || $scope.template.levelI;
            textdocument = angular.copy($scope.currentPage.levels.level[$scope.template.levelI].textdocument);

            if (textdocument.lock) {
                return
            }
            dragDoc.clientX = e.clientX || 0;          //鼠标到页面左边的距离
            dragDoc.clientY = e.clientY || 0;          //鼠标到页面顶部的距离
            dragDoc.coordX = targ.offsetParent.offsetLeft + targ.offsetLeft;        //鼠标到模板左边的距离
            dragDoc.coordY = targ.offsetParent.offsetTop + targ.offsetTop;         //鼠标到模板顶部的距离
            dragDoc.maxX = $contain.width();
            dragDoc.maxY = $contain.height();
            dragDocFlag = true;

            $scope.RightPanel = 'textDoc';

            textdocW = angular.copy(textdocument.geometry.width);
            textdocH = angular.copy(textdocument.geometry.height);

            document.addEventListener("mousemove", resizeDocOn1, true);
            document.addEventListener("mouseup", resizeDocEnd1, true);
            // setZindex(e.target.dataset.index);
        };
        function resizeDocOn1(e) {
            if (dragDocFlag) {
                fn(e);
                // 是否按住shift键
                dragDoc.shiftKey = e.shiftKey;
                var targ = e.target ? e.target : e.srcElement;
                if (targ == null) {
                    return;
                }
                var imgIndex = $scope.template.levelI;
                if (imgIndex == null) {
                    return;
                }
                var pageIndex = $scope.template.pages.page[$scope.template.pageI];
                if (pageIndex == null) {
                    return;
                }
                var item = pageIndex.levels.level[$scope.template.levelI].textdocument;
                if (item == null) {
                    return;
                }

                var pro = $scope.currentPage.scene.ratio;
                var x = item.geometry.x* pro;
                var y = item.geometry.y* pro;
                //20 小图标的宽高
                var w = (dragDoc.coordX + 10 + e.clientX - dragDoc.clientX - x);
                // var w = (dragDoc.coordX + 10 + e.clientX - dragDoc.clientX - item.geometry.x *pro) /pro;
                var h = w / item.geometry.width * item.geometry.height

                if (w < 40 || h < 40) {
                    return
                }

                if (x + w > dragDoc.maxX) {
                    var maxW = dragDoc.maxX - x;
                    item.geometry.width = maxW / pro;
                    item.geometry.height = (maxW / item.geometry.width * item.geometry.height) / pro;
                } else if (y + h > dragDoc.maxY) {
                    var maxH = dragDoc.maxY - y;
                    item.geometry.height = maxH / pro;
                    item.geometry.width = (maxH / item.geometry.height * item.geometry.width) / pro;
                } else {
                    item.geometry.width = w / pro;
                    item.geometry.height = h / pro;
                }

                if (vm.unit == 'mm') {
                    $scope.pageValue.textdocument.width = unitTransformPx(item.geometry.width);
                    $scope.pageValue.textdocument.height = unitTransformPx(item.geometry.height);
                } else {
                    $scope.pageValue.textdocument.width = item.geometry.width;
                    $scope.pageValue.textdocument.height = item.geometry.height;
                }

                resizeLevelWaH();

            }
            $scope.$digest();
            return false;
        }
        function resizeDocEnd1() {
            dragDocFlag = false;
            dragDoc = {};

            document.removeEventListener("mousemove", resizeDocOn, true);
            document.removeEventListener("mouseup", resizeDocEnd, true);
            updateHistorys();
            $scope.currentPage = $scope.template.pages.page[$scope.template.pageI];
            $scope.$digest();
        }

        function resizeLevelWaH() {
            var doc = $scope.template.pages.page[$scope.template.pageI].levels.level[$scope.template.levelI].textdocument;
            doc.background.offsetx = textdocument.background.offsetx * doc.geometry.width / textdocW;
            doc.background.offsety = textdocument.background.offsety * doc.geometry.height / textdocH;
            doc.background.width = textdocument.background.width * doc.geometry.width / textdocW;
            doc.background.height = textdocument.background.height * doc.geometry.height / textdocH;
            doc.background.offsetXM = unitTransformPx(doc.background.offsetx);
            doc.background.offsetYM = unitTransformPx(doc.background.offsety);

            angular.forEach(doc.levels.level, function (level,l) {
                var textdoc = textdocument.levels.level[l];
                if (level.imageart) {
                    var geo = {
                        width: textdoc.imageart.geometry.width * doc.geometry.width / textdocW,
                        height: textdoc.imageart.geometry.height * doc.geometry.height / textdocH,
                        x: textdoc.imageart.geometry.x * doc.geometry.width / textdocW,
                        y: textdoc.imageart.geometry.y * doc.geometry.height / textdocH,
                    }
                    level.imageart.geometry = geo;
                    level.imageart.widthM = unitTransformPx(geo.width);
                    level.imageart.heightM = unitTransformPx(geo.height);
                    level.imageart.offsetXM = unitTransformPx(geo.x);
                    level.imageart.offsetYM = unitTransformPx(geo.y);

                    level.imageart.offsetx = textdoc.imageart.offsetx * doc.geometry.width / textdocW;
                    level.imageart.offsety = textdoc.imageart.offsety * doc.geometry.height / textdocH;
                }
                if (level.textbox) {
                    var textGeo = {
                        width: textdoc.textbox.geometry.width * doc.geometry.width / textdocW,
                        height: textdoc.textbox.geometry.height * doc.geometry.height / textdocH,
                        x: textdoc.textbox.geometry.x * doc.geometry.width / textdocW,
                        y: textdoc.textbox.geometry.y * doc.geometry.height / textdocH,
                    }
                    level.textbox.geometry = textGeo;
                    level.textbox.widthM = unitTransformPx(textGeo.width);
                    level.textbox.heightM = unitTransformPx(textGeo.height);
                    level.textbox.offsetXM = unitTransformPx(textGeo.x);
                    level.textbox.offsetYM = unitTransformPx(textGeo.y);
                    level.textbox.style.size = textdoc.textbox.style.size*doc.geometry.width / textdocW;
                    level.textbox.style.lineheight = textdoc.textbox.style.lineheight*doc.geometry.width / textdocW;
                }
            })
        }

        $scope.slipGroup = function () {
            var currentPage = $scope.template.pages.page[$scope.template.pageI];
            var textdocument = angular.copy(currentPage.levels.level[$scope.template.levelI].textdocument);
            $scope.deleteBox();
            var textGeo = textdocument.geometry;
            vm.unit = 'mm';
            if (textdocument.background && textdocument.background.resource && textdocument.background.resource.identifier) {
                var currentPage = $scope.template.pages.page[$scope.template.pageI];
                var currentLevel = addLevel(currentPage);
                $scope.pageValue.textdocument = {
                    width: unitTransformPx(textGeo.width),
                    height: unitTransformPx(textGeo.height),
                    x: unitTransformPx(textGeo.x),
                    y: unitTransformPx(textGeo.y)
                }

                var angle = 0;
                if (textdocument.rotation.angle) {
                    angle = textdocument.rotation.angle;
                }
                var resource = textdocument.background.resource;
                var scale = 1;
                if (textdocument.background.adaptation == "Height") {
                    scale = textdocument.background.width / textdocument.geometry.width;
                }
                currentLevel.imageart = ({
                    geometry: {
                        width: textdocument.geometry.width,
                        height: textdocument.geometry.height,
                        x: textdocument.geometry.x,
                        y: textdocument.geometry.y
                    },
                    rotation: {
                        angle: angle
                    },
                    // 模板使用，微信端不可进行操作
                    // type: 'static',
                    resource: {
                        identifier: resource.identifier,
                        provider: 'qiniu',
                        width: resource.width,
                        height: resource.height
                    },
                    scale: scale,
                    offsetx: textdocument.background.offsetx,
                    offsety: textdocument.background.offsety,
                    transparency: 1,
                    onlyshow: false,
                    movable: textdocument.movable,
                    editable: textdocument.editable,
                    bgImg: '',
                    unit: 'mm',
                    // index: currentPage.imagearts.imageart.length,
                    levelI: $scope.template.levelI,
                    pageI: $scope.template.pageI,
                    current: 'imageart',
                    lock: false
                });

                $scope.selectBox = currentLevel.imageart;
            }
            angular.forEach(textdocument.levels.level, function (level, i) {
                if (level.imageart) {
                    var currentPage = $scope.template.pages.page[$scope.template.pageI];
                    var currentLevel = addLevel(currentPage);
                    var resource = level.imageart.resource;
                    currentLevel.imageart = ({
                        geometry: {
                            width: level.imageart.geometry.width,
                            height: level.imageart.geometry.height,
                            x: level.imageart.geometry.x + textGeo.x,
                            y: level.imageart.geometry.y + textGeo.y
                        },
                        rotation: {
                            angle: 0
                        },
                        // 模板使用，微信端不可进行操作
                        type: 'static',
                        resource: {
                            identifier: resource.identifier,
                            provider: 'qiniu',
                            width: resource.width,
                            height: resource.height
                        },
                        scale: level.imageart.scale,
                        offsetx: level.imageart.offsetx,
                        offsety: level.imageart.offsety,
                        transparency: level.imageart.transparency,
                        onlyshow: false,
                        movable: textdocument.movable,
                        editable: textdocument.editable,
                        bgImg: '',
                        unit: 'mm',
                        // index: currentPage.imagearts.imageart.length,
                        levelI: $scope.template.levelI,
                        pageI: $scope.template.pageI,
                        current: 'imageart',
                        lock: false
                    });
                }
                if (level.textbox) {
                    var currentPage = $scope.template.pages.page[$scope.template.pageI];
                    var currentLevel = addLevel(currentPage);
                    currentLevel.textbox = angular.copy(level.textbox);
                    currentLevel.textbox.movable = textdocument.movable;
                    currentLevel.textbox.editable = textdocument.editable;
                    currentLevel.textbox.unit = 'mm';
                    currentLevel.textbox.levelI = $scope.template.levelI;
                    currentLevel.textbox.pageI = $scope.template.pageI;
                    currentLevel.textbox.current = 'textbox';
                    currentLevel.textbox.lock = false;
                    currentLevel.textbox.geometry.x = level.textbox.geometry.x + textGeo.x;
                    currentLevel.textbox.geometry.y = level.textbox.geometry.y + textGeo.y;
                    fontStyle(currentLevel.textbox);
                }
            })
            updateHistorys();
            $scope.currentPage = currentPage;
            $scope.RightPanel = 'material';
            $scope.template.transparency = 100;
            // console.log($scope.currentPage)

        }

        //文本框点击时
        $scope.selectText = function (e, $index, text) {
            fn(e);

            fontStyle(text);

            $scope.template.text = text.text;
            $scope.size = text.style.size;
            $scope.template.angle = text.rotation.angle;
            // chargeFontPath(text.identifier);

            if (vm.unit == 'mm') {
                $scope.pageValue.textbox = {
                    width: unitTransformPx(text.geometry.width).toFixed(2) - 0,
                    height: unitTransformPx(text.geometry.height).toFixed(2) - 0,
                    x: unitTransformPx(text.geometry.x).toFixed(2) - 0,
                    y: unitTransformPx(text.geometry.y).toFixed(2) - 0
                }
            } else {
                $scope.pageValue.textbox = {
                    width: text.geometry.width,
                    height: text.geometry.height,
                    x: text.geometry.x,
                    y: text.geometry.y
                }
            }

            $scope.template.angle = text.rotation.angle;
            vm.text = text.text;

            $scope.template.letterspacing = text.style.letterspacing;
            $(".block-width").css({left: text.style.letterspacing});
            $scope.template.lineheight = text.style.lineheight;
            $(".block-height").css({left: text.style.lineheight});
            // console.log($scope.currentPage)

            text.current = 'textbox';
            $scope.selectBox = text;

            //如果是按住ctrl键 实现多选复制
            if (e.ctrlKey == true || e.metaKey == true) {
                if (text.lock) {
                    return
                }
                text.ctrlKey = true;
                vm.CtrlKeyArray.textboxes[$index] = angular.copy(text);
                ctrlAddSingleArray();
                $scope.RightPanel = '';
            } else {
                $scope.clearCtrlKey();
                vm.singleArray = {imagebox: {}, textbox: {}, imageart: {}, barcode: {}, qrcode: {}};
                if (text.lock) {
                    return
                }
                vm.singleArray.textbox = angular.copy(text);
                $scope.RightPanel = 'text';
            }
            $("#menus").fadeOut();
            $scope.template.levelI = $index;
            $scope.selPanel = 'text';
        };

        $scope.$watch("vm.text",function(newValue,oldValue){
            // if(newValue){
                sizeHeight();
            // }
        })

        $scope.$watch("vm.textDocCon",function(newValue,oldValue){
            if(oldValue){
                sizeTextDocHeight();
            }
        })

        function sizeTextDocHeight() {
            var _textbox = $scope.currentPage.levels.level[$scope.template.levelI].textdocument.levels.level[$scope.template.docI].textbox;
            _textbox.text = vm.textDocCon;
            var maxY = $contain.height();
            $timeout(function () {
                var _h = Number($(".textbox" + $scope.template.pageI + $scope.template.levelI+$scope.template.docI).find('.c-xml-page-textboxe-text').height()) + Number(5);
                var _top = Number($(".textbox" + $scope.template.pageI + $scope.template.levelI+$scope.template.docI)[0].offsetTop);
                if(_h+_top>maxY){
                    _textbox.offsetXM = _textbox.geometry.x = 0;
                    _textbox.offsetYM = _textbox.geometry.y = 0;;
                }
                _textbox.geometry.height = _h / ($scope.currentPage.scale / $scope.currentPage.proportion)
                _textbox.heightM = unitTransformPx(_textbox.geometry.height);
            })
        }

        var a = null;
        $scope.updateTextSize = function (value) {
            if (a !== null) {
                clearTimeout(a)
            }
            a = setTimeout(function () {
                $timeout(function () {
                    var text = $scope.template.pages.page[$scope.template.pageI].levels.level[$scope.template.levelI].textbox;
                    if (text.lock) {
                        return
                    }
                    var sizeValue = value < 6 ? 6 : value;
                    text.style.size = sizeValue;
                    text.style.lineheight = $scope.template.lineheight = sizeValue;
                    sizeHeight();
                    updateHistorys();
                })
            },500)
        };

        function fontStyle(font) {
            return
            var _fontStyle = [];
            for (var i = 0; i < vm.fontList.length; i++) {
                if (vm.fontList[i].uuid == font.fontuuid) {
                    for (var j = 0; j < vm.fontList[i].fontStyles.length; j++) {
                        _fontStyle.push(vm.fontList[i].fontStyles[j].style)
                    }
                }
            }
            font.style.bold1 = false;
            font.style.italic1 = false;
            if (_fontStyle.indexOf('BOLD_ITALIC') != '-1') {
                font.style.bold1 = true;
                font.style.italic1 = true;
            } else {
                if (_fontStyle.indexOf('ITALIC') != '-1') {
                    font.style.italic1 = true;
                }
                if (_fontStyle.indexOf('BOLD') != '-1') {
                    font.style.bold1 = true;
                }
            }
        }

        //文字放大缩小
        var isTextDown = false;
        $scope.textboxZoomRight = function($event, item, pro, index){
            textboxZoom($event, item, pro, index, 'right')
        }
        $scope.textboxZoomLeft = function($event, item, pro, index){
            textboxZoom($event, item, pro, index,'left')
        }
        function textboxZoom($event, item, pro, index, element){
            if(item.lock){return}
            fn($event);
            $scope.template.levelI = index || $scope.template.levelI;
            var x = $event.clientX;
            var nw = angular.copy(item.geometry.width) * pro;
            var left = angular.copy(item.geometry.x) * pro;
            //开关打开
            isTextDown = true;
            //鼠标移动
            window.onmousemove = function (e) {
                if (isTextDown == false) {
                    return;
                }
                //获取x和y
                var nx = e.clientX;
                //计算移动后的左偏移量和顶部的偏移量
                var nl = nx - x;
                var h = Number($($event.target).parent().find('.c-xml-page-textboxe-text').height()) + Number(5);
                if(element == 'left'){
                    item.geometry.x = (left + nl) / pro;
                    item.geometry.width = (Number(nw) - Number(nl)) / pro;
                    // if((Number(nw) - Number(nl)) < parseInt(item.style.size)){
                    //     item.geometry.width = (Number(parseInt(item.style.size)) + Number(5)) / pro;
                    //     item.geometry.x = (left + nl - Number(5)) / pro;
                    //     isTextDown = false;
                    //     return;
                    // }
                    // if((Number(nw) - Number(nl)) > $scope.currentPage.mediabox.width * pro){
                    //     item.geometry.width = $scope.currentPage.mediabox.width;
                    //     item.geometry.x = 0;
                    // }
                }
                if(element == 'right'){
                    item.geometry.width = (Number(nw) + Number(nl)) / pro;
                    // if((Number(nw) + Number(nl)) < parseInt(item.style.size)){
                    //     item.geometry.width = (Number(parseInt(item.style.size)) + Number(5)) / pro;
                    //     isTextDown = false;
                    //     return;
                    // }
                    // if((Number(nw) + Number(nl)) > $scope.currentPage.mediabox.width * pro){
                    //     item.geometry.width = $scope.currentPage.mediabox.width;
                    //     item.geometry.x = 0;
                    // }
                }
                item.geometry.height = h / pro;
                sizeHeight();
                $scope.$digest();
            }
            //鼠标抬起事件
            window.onmouseup = function ($event) {
                if(isTextDown){
                    $scope.currentPage.levels.level[$scope.template.levelI].textbox = item;
                    isTextDown = false;
                }
                $event.stopPropagation();
            }
        };
        $scope.textboxZoomLeft1 = function($event, item, pro, index){
            textboxZoom1($event, item, pro, index, 'left')
        };
        $scope.textboxZoomTop1 = function($event, item, pro, index){
            textboxZoom1($event, item, pro, index, 'top')
        };
        $scope.textboxZoomRight1 = function($event, item, pro, index){
            textboxZoom1($event, item, pro, index, 'right')
        };
        $scope.textboxZoomBottom1 = function($event, item, pro, index){
            textboxZoom1($event, item, pro, index, 'bottom')
        };
        function textboxZoom1($event, item, pro, index, element){
            if(item.lock){return}
            var $event = $event || window.event;                  // IE、火狐获取事件对象
            //防止浏览器默认行为(W3C)
            if($event && $event.preventDefault){
                $event.preventDefault();
            }
            //IE中组织浏览器行为
            else {
                window.event.returnValue = false;
                return false;
            }
            $event.stopPropagation();
            var x = $event.clientX;
            var y = $event.clientY;
            //获取w和h
            var nw = angular.copy(item.geometry.width);
            var nh = angular.copy(item.geometry.height);
            var _left = angular.copy(item.geometry.x);
            var _top = angular.copy(item.geometry.y);
            var _size = angular.copy(parseInt(item.style.size));
            var _lineheight = angular.copy(parseInt(item.style.lineheight));
            //开关打开
            isTextDown = true;
            //鼠标移动
            window.onmousemove = function (e) {
                if (isTextDown == false) {return;}
                if(item.style.size < 6){
                    item.style.size = 6;
                    item.style.lineheight = 6;
                    isTextDown = false;
                    return;
                }
                //获取x和y
                var nx = e.clientX;
                var ny = e.clientY;
                //计算移动后的左偏移量和顶部的偏移量
                var nl = (nx - x) / pro;
                var nt = (ny - y) / pro;

                if(element == 'left'){
                    item.geometry.width = (Number(nw) - Number(nl));
                    item.geometry.x = (Number(_left) + Number(nl));
                    item.style.size = Math.ceil(((Number(nw) - Number(nl)) / nw * _size));
                    item.style.lineheight = Math.ceil(((Number(nw) - Number(nl)) / nw * _lineheight));
                    item.geometry.y = (Number(_top) - Number(item.geometry.height - nh));
                }
                if(element == 'top'){
                    item.geometry.width = (Number(nw) + Number(nl));
                    item.style.size = Math.ceil(((Number(nw) + Number(nl)) / nw * _size));
                    item.style.lineheight = Math.ceil(((Number(nw) + Number(nl)) / nw * _lineheight));
                    item.geometry.y = (Number(_top) - Number(item.geometry.height - nh));
                }
                if(element == 'right'){
                    item.geometry.width = (Number(nw) + Number(nl) + Number(5));
                    item.style.size = Math.ceil(((Number(nw) + Number(nl)) / nw * _size));
                    item.style.lineheight = Math.ceil(((Number(nw) + Number(nl)) / nw * _lineheight));
                }
                if(element == 'bottom'){
                    item.geometry.width = (Number(nw) - Number(nl));
                    item.geometry.x = (Number(_left) + Number(nl));
                    item.style.size = Math.ceil(((Number(nw) - Number(nl)) / nw * _size));
                    item.style.lineheight = Math.ceil(((Number(nw) - Number(nl)) / nw * _lineheight));
                }
                sizeHeight();
                $scope.$digest();
            }
            //鼠标抬起事件
            window.onmouseup = function ($event) {
                isTextDown = false;
                $event.stopPropagation();
            }
        }



        function sizeHeight() {
            if ($scope.currentPage) {
                var _textbox = $scope.currentPage.levels.level[$scope.template.levelI].textbox;
                _textbox.text = vm.text;
                var maxY = $contain.height();
                vm.unit = 'mm';
                $timeout(function () {
                    var $boxDiv = $(".textbox" + $scope.template.pageI + $scope.template.levelI);
                    var pro = $scope.currentPage.scale / $scope.currentPage.proportion;
                    if ($scope.currentPage.scene) {
                        $boxDiv = $(".textbox1" + $scope.template.pageI + $scope.template.levelI);
                        pro = $scope.currentPage.scene.ratio;
                    }
                    var _h = Number($boxDiv.find('.c-xml-page-textboxe-span').height()) + Number(5);
                    // var _top = Number($boxDiv[0].offsetTop);
                    // if (_h + _top > maxY) {
                    //     $scope.pageValue.textbox.x = _textbox.geometry.x = 0;
                    //     $scope.pageValue.textbox.y = _textbox.geometry.y = 0;
                    // }
                    _textbox.geometry.height = _h / pro;
                })
            }
        }

        $scope.updateTextFont = function (data) {
            if (data == undefined) {
                MessageService.error("文字添加失败，请上传字体!");
                return
            }
            var text = $scope.template.pages.page[$scope.template.pageI].levels.level[$scope.template.levelI].textbox;
            if (text.lock) {
                return
            }

            FontManagement.fontSupport({
                uuid: data.uuid,
                bold: text.style.bold,
                italic: text.style.italic,
                content: text.text
            }, function (res) {
                var msg = res.message;
                if (res.status == 200) {
                    if (msg.success && !msg.supported) {
                        var message = "【" + msg.failed + "】" + "当前字体不支持这些文字！";
                        MessageService.error(message);
                    } else {
                        text.style.font = data.family;
                        text.fontuuid = data.uuid;
                        text.identifier = vm.url + data.fontStyles[0].identifier;
                        $scope.item = data;
                        fontStyle(text);
                        getFont(text,FontManagement);
                        sizeHeight()
                        text.characterWarning = false;
                        text.characterMessage = "";
                        text.loading = false;
                        updateHistorys();
                    }
                } else {
                    MessageService.error("检查字体字符异常");
                }
            });
        };

        $scope.showTextSpacing = function () {
            $(".space-slider").toggleClass('hide1');
            $(".nav_spacing").toggleClass('nav-spacing-active');
            $scope.isAlignHover = false;
            $scope.isDistriHover = false;
            toobarFlag1 = true;
            toobarFlag2 = true;
        }

        $scope.spacingClick = function (e) {
            fn(e);
            var text = $scope.template.pages.page[$scope.template.pageI].levels.level[[$scope.template.levelI]].textbox;
            var targ = e.target ? e.target : e.srcElement;
            var value = targ.dataset.value;
            var l = 120 - Math.abs(e.offsetX);
            if (value == 'width') {
                text.style.letterspacing = $scope.template.letterspacing = l;
                $(".block-width").css({left: l});

            } else {
                if (l < text.style.size) {
                    MessageService.error("行间距有效范围：" + text.style.size + "~110");
                    $scope.template.lineheight = text.style.size;
                    return
                }
                text.style.lineheight = $scope.template.lineheight = l;
                $(".block-height").css({left: l});
            }
        }

        $scope.spacingChange = function (attr) {
            var text = $scope.template.pages.page[$scope.template.pageI].levels.level[[$scope.template.levelI]].textbox;
            if (text.lock) {
                return
            }
            if (attr) {
                if ($scope.template.letterspacing > 110) {
                    MessageService.error("字间距有效范围：0~110");
                    $scope.template.letterspacing = 110;
                }
                text.style.letterspacing = $scope.template.letterspacing;
                $(".block-width").css({left: text.style.letterspacing});
            } else {
                if ($scope.template.lineheight > 110) {
                    MessageService.error("行间距有效范围：" + text.style.size + "~110");
                    $scope.template.lineheight = 110;
                }
                if ($scope.template.lineheight < 0.000001) {
                    MessageService.error("行间距有效范围：" + text.style.size + "~110");
                    $scope.template.lineheight = text.style.size;
                }
                text.style.lineheight = $scope.template.lineheight;
                $(".block-height").css({left: text.style.lineheight});
            }
            sizeHeight();
            updateHistorys();
        }

        // 字/行间距鼠标点击移动
        var spacingW = {};
        var flagSpacing = false
        window.resizeSpacingStart = function (e) {
            fn(e);
            var targ = e.target ? e.target : e.srcElement;
            spacingW.clientX = e.clientX || 0;
            spacingW.originLeft = targ.offsetLeft;
            spacingW.value = targ.dataset.value;
            var text = $scope.template.pages.page[$scope.template.pageI].levels.level[$scope.template.levelI].textbox;
            if (text.lock) {
                return
            }
            flagSpacing = true;
            document.addEventListener("mousemove", resizeSpacingOn, true);
            document.addEventListener("mouseup", resizeSpacingEnd, true);
        }

        function resizeSpacingOn(e) {
            if (flagSpacing) {
                var text = $scope.template.pages.page[$scope.template.pageI].levels.level[$scope.template.levelI].textbox;
                var l = spacingW.originLeft + e.clientX - spacingW.clientX;
                if (spacingW.value == 'height' && l < text.style.size) {
                    l = text.style.size;
                } else if (spacingW.value == 'width' && l < 0) {
                    l = 0;
                }
                if (l > 110) {
                    l = 110
                }
                if (spacingW.value == 'width') {
                    $(".block-width").css({left: l});
                    text.style.letterspacing = $scope.template.letterspacing = l;
                } else {
                    $(".block-height").css({left: l});
                    text.style.lineheight = $scope.template.lineheight = l;
                }

                sizeHeight();
                $scope.$digest();
            }
        }

        function resizeSpacingEnd() {
            spacingW = {}
            flagSpacing = false;
            updateHistorys();
            document.removeEventListener("mousemove", resizeSpacingOn, true);
            document.removeEventListener("mouseup", resizeSpacingEnd, true);
        }

        function fontEdit() {
            for (var i = 0; i < vm.data.textDocument.levels.level.length; i++) {
                var _font = vm.data.textDocument.levels.level[i].textbox;
                if (_font.selected) {
                    _font = vm.font;
                    break;
                }
            }
            cookie()
        }

        //字体family
        $scope.operationFontFamily = function () {
            getFont(vm.font,FontManagement)
            fontEdit();
        }

        //字体
        $scope.operationFont = function () {
            fontEdit()
        }
        //斜体
        $scope.operationItalic = function () {
            var level = $scope.currentPage.levels.level[$scope.template.levelI];
            if (level.textbox && level.textbox.current) {
                level.textbox.style.italic = !level.textbox.style.italic;
            }
            updateHistorys();
        }
        //粗体
        $scope.operationBold = function () {
            var level = $scope.currentPage.levels.level[$scope.template.levelI];
            if (level.textbox && level.textbox.current) {
                level.textbox.style.bold = !level.textbox.style.bold;
            }
            updateHistorys();
        }
        //间距
        vm.isOperationSpacing = false
        $scope.operationSpacing = function (attr) {
            toolbarStatus();
            vm.isOperationSpacing = attr;

            var text = $scope.currentPage.levels.level[[$scope.template.levelI]].textbox;
            $scope.template.letterspacing = text.style.letterspacing;
            $scope.template.lineheight = text.style.lineheight;
            setTimeout(function () {
                $(".block-width").css({left: text.style.letterspacing});
                $(".block-height").css({left: text.style.lineheight});
            }, 100)
            sizeHeight();
        }

        //对齐点击
        vm.isOperationDir = false
        $scope.operationDir = function (attr) {
            toolbarStatus();
            vm.isOperationDir = attr;
        }

        //左对齐
        $scope.operationBarLeft = function ($event) {
            var level = $scope.currentPage.levels.level[$scope.template.levelI];
            if (level.textbox && level.textbox.current) {
                level.textbox.style.align = 'left';
            }
            updateHistorys();
        }
        //居中对齐
        $scope.operationBarCenter = function ($event) {
            var level = $scope.currentPage.levels.level[$scope.template.levelI];
            if (level.textbox && level.textbox.current) {
                level.textbox.style.align = 'center';
            }
            updateHistorys();
        }
        //右对齐
        $scope.operationBarRight = function ($event) {
            var level = $scope.currentPage.levels.level[$scope.template.levelI];
            if (level.textbox && level.textbox.current) {
                level.textbox.style.align = 'right';
            }
            updateHistorys();
        }
        //两端对齐
        $scope.operationBarJustify = function ($event) {
            var level = $scope.currentPage.levels.level[$scope.template.levelI];
            if (level.textbox && level.textbox.current) {
                level.textbox.style.align = 'justify';
            }
            updateHistorys();
        }
        //颜色
        $scope.operationColorOpen = function ($event) {
            fn($event)
            vm.isOperationColor = !vm.isOperationColor;
        }

        $scope.operationColor = function (item) {
            var level = $scope.currentPage.levels.level[$scope.template.levelI];
            if (level.textbox && level.textbox.current) {
                level.textbox.style.color = item.id;
            }
            vm.textColor = null;
            updateHistorys();
        }

        $scope.chooseTextColor = function () {
            var level = $scope.currentPage.levels.level[$scope.template.levelI];
            level.textbox.style.color = vm.textColor;
            vm.textColor = null;
        }

        /* ==========================================================================
         条形码处理
         ========================================================================== */
        // 增加条形码
        $scope.addBarCode = function () {
            var currentPage = $scope.template.pages.page[$scope.template.pageI];
            if (currentPage.barcode && currentPage.barcode.geometry) {
                return
            }
            vm.unit = 'mm';

            currentPage.barcode = {
                rotation: {angle: 0},
                geometry: {
                    width: unitTransform(60),
                    height: unitTransform(30),
                    x: unitTransform(16),
                    y: unitTransform(16)
                },
                zoom: 1,
                unit: 'mm',
                lock: false,
                current: 'barcode'
            };
            $scope.currentPage = currentPage;

            $scope.selectBox = currentPage.barcode;
            if (vm.unit == 'mm') {
                $scope.pageValue.barcode = {
                    width: 60,
                    height: 30,
                    x: 16,
                    y: 16
                }
            } else {
                $scope.pageValue.barcode = currentPage.barcode.geometry;
            }

            updateHistorys();
        };
        // 增加二维码
        $scope.addQrCode = function () {
            var currentPage = $scope.template.pages.page[$scope.template.pageI];
            if (currentPage.qrcode && currentPage.qrcode.geometry) {
                return
            }
            vm.unit = 'mm';

            currentPage.qrcode = {
                rotation: {angle: 0},
                geometry: {
                    width: MmTurnPx(60),
                    height: MmTurnPx(60),
                    x: MmTurnPx(16),
                    y: MmTurnPx(16)
                },
                zoom: 1,
                unit: 'mm',
                lock: false,
                current: 'qrcode'
            };
            $scope.currentPage = currentPage;

            $scope.selectBox = currentPage.qrcode;
            if (vm.unit == 'mm') {
                $scope.pageValue.qrcode = {
                    width: 60,
                    height: 30,
                    x: 16,
                    y: 16
                }
            } else if(vm.unit == 'px') {
                $scope.pageValue.qrcode = currentPage.qrcode.geometry;
            } else if(vm.unit == 'in') {
                $scope.pageValue.qrcode = {
                    width: PxTurnIn(currentPage.qrcode.geometry.width),
                    height: PxTurnIn(currentPage.qrcode.geometry.height),
                    x: PxTurnIn(currentPage.qrcode.geometry.x),
                    y: PxTurnIn(currentPage.qrcode.geometry.y)
                };
            }

            updateHistorys();
        };

        $scope.updateBarParameter = function () {
            var currentPage = $scope.template.pages.page[$scope.template.pageI];
            if (currentPage.barcode.lock) {
                return
            }
            if(type == 'width'){
                if($scope.pageValue.barcode.width < 10){
                    $scope.pageValue.barcode.width = 10;
                }
            }
            if(type == 'height'){
                if($scope.pageValue.barcode.height < 5){
                    $scope.pageValue.barcode.height = 5;
                }
            }

            if (vm.unit == 'mm') {
                currentPage.barcode.geometry = {
                    width: unitTransform($scope.pageValue.barcode.width),
                    height: unitTransform($scope.pageValue.barcode.height),
                    x: unitTransform($scope.pageValue.barcode.x),
                    y: unitTransform($scope.pageValue.barcode.y)
                }
            }
            if (vm.unit == 'px') {
                currentPage.barcode.geometry = {
                    width: $scope.pageValue.barcode.width,
                    height: $scope.pageValue.barcode.height,
                    x: $scope.pageValue.barcode.x,
                    y: $scope.pageValue.barcode.y
                }
            }
            updateHistorys();
        };
        $scope.updateQrcodeParameter = function (item) {
            var currentPage = $scope.template.pages.page[$scope.template.pageI];
            if (currentPage.qrcode.lock) {
                return
            }
            if(item == 'width'){
                $scope.pageValue.qrcode.height = $scope.pageValue.qrcode.width;
            }
            if(item == 'height'){
                $scope.pageValue.qrcode.width = $scope.pageValue.qrcode.height;
            }

            if (vm.unit == 'mm') {
                currentPage.qrcode.geometry = {
                    width: MmTurnPx($scope.pageValue.qrcode.width),
                    height: MmTurnPx($scope.pageValue.qrcode.height),
                    x: MmTurnPx($scope.pageValue.qrcode.x),
                    y: MmTurnPx($scope.pageValue.qrcode.y)
                }
            }
            if (vm.unit == 'px') {
                currentPage.qrcode.geometry = {
                    width: $scope.pageValue.qrcode.width,
                    height: $scope.pageValue.qrcode.height,
                    x: $scope.pageValue.qrcode.x,
                    y: $scope.pageValue.qrcode.y
                }
            }
            updateHistorys();
        };

        //条形码点击时
        $scope.selectBar = function (e, currentPage, item) {
            fn(e);
            // $scope.selPanel = 'barcode';
            $scope.RightPanel = item;
            var barcode = currentPage[item];

            if (vm.unit == 'mm') {
                $scope.pageValue[item] = {
                    width: unitTransformPx(barcode.geometry.width).toFixed(2) - 0,
                    height: unitTransformPx(barcode.geometry.height).toFixed(2) - 0,
                    x: unitTransformPx(barcode.geometry.x).toFixed(2) - 0,
                    y: unitTransformPx(barcode.geometry.y).toFixed(2) - 0
                }
            } else {
                $scope.pageValue[item] = {
                    width: barcode.geometry.width,
                    height: barcode.geometry.height,
                    x: barcode.geometry.x,
                    y: barcode.geometry.y
                }
            }

            $scope.template.angle = currentPage[item].rotation.angle;
            barcode.current = item;
            $scope.selectBox = barcode;


            var mm = $scope.currentPage[item];
            //如果是按住ctrl键 实现多选复制
            if (e.ctrlKey == true || e.metaKey == true) {
                if (barcode.lock) {
                    return
                }
                mm.ctrlKey = true;
                vm.CtrlKeyArray[item][0] = angular.copy(mm);
                ctrlAddSingleArray();
            } else {
                mm.ctrlKey = false;
                $scope.clearCtrlKey();
                vm.singleArray = {imagebox: {}, textbox: {}, imageart: {}, barcode: {}, qrcode: {}};
                if (barcode.lock) {
                    return
                }
                vm.singleArray[item] = angular.copy(mm);
            }
            $("#menus").fadeOut();

        };

        //条形码移动事件
        var dragBar;
        var dragBarBox = {};
        window.moveBarcodeStart = function (e) {
            fn(e);
            var targ = e.currentTarget ? e.currentTarget : e.srcElement;
            dragBarBox.clientX = e.clientX || 0;
            dragBarBox.clientY = e.clientY || 0;
            dragBarBox.coordX = targ.offsetLeft;
            dragBarBox.coordY = targ.offsetTop;
            dragBar = true;
            var currentPage = $scope.template.pages.page[$scope.template.pageI];
            if (currentPage.barcode.lock) {
                return
            }
            var all = getAllCtrlKeyArray();
            if (all.length) {
                dragBarBox.ctrlKey = true;
            } else {
                dragBarBox.ctrlKey = false;
            }
            document.addEventListener("mousemove", moveBarcodeOn, true);
            document.addEventListener("mouseup", moveBarcodeOnEnd, true);
        };
        //条形码move事件
        function moveBarcodeOn(e) {
            $scope.$digest();
            e.stopPropagation();
            e.preventDefault();

            if (dragBar) {
                var currentPage = $scope.template.pages.page[$scope.template.pageI];

                var clientX = e.clientX - dragBarBox.clientX;
                var clientY = e.clientY - dragBarBox.clientY;

                var barOffsetX = (dragBarBox.coordX + clientX);
                var barOffsetY = (dragBarBox.coordY + clientY);
                var barWidth = currentPage.barcode.geometry.width * currentPage.scale / currentPage.proportion;
                var barHeight = currentPage.barcode.geometry.height * currentPage.scale / currentPage.proportion;
                var height = $scope.template.pages.page[$scope.template.pageI].height * currentPage.scale;
                var width = $scope.template.pages.page[$scope.template.pageI].width * currentPage.scale;
                var barcodeAngle = currentPage.barcode.rotation.angle;

                var lar = (currentPage.bloodPx.left + currentPage.bloodPx.right) * currentPage.scale / currentPage.proportion;
                var tab = (currentPage.bloodPx.top + currentPage.bloodPx.bottom) * currentPage.scale / currentPage.proportion;

                var barx = 0, bary = 0;

                //中心点
                var xcenter = barWidth / 2 + barOffsetX;
                var ycenter = barHeight / 2 + barOffsetY;


                if (barcodeAngle == 0) {
                    if (barOffsetX <= 0) {
                        barOffsetX = 0;
                    }

                    if (barOffsetX >= (width + lar - barWidth)) {
                        barOffsetX = width + lar - barWidth;
                    }
                    if (barOffsetY <= 0) {
                        barOffsetY = 0;
                    }

                    if (barOffsetY >= (height + tab - barHeight)) {
                        barOffsetY = height + tab - barHeight;
                    }

                    barx = barOffsetX / currentPage.scale * currentPage.proportion;
                    bary = barOffsetY / currentPage.scale * currentPage.proportion;
                } else {

                    if (xcenter <= 0) {
                        xcenter = 0;
                    }

                    if (xcenter >= (width + lar)) {
                        xcenter = width + lar;
                    }
                    if (ycenter <= 0) {
                        ycenter = 0;
                    }

                    if (ycenter >= (height + tab)) {
                        ycenter = height + tab;
                    }
                    barx = (xcenter - barWidth / 2) / currentPage.scale * currentPage.proportion;
                    bary = (ycenter - barHeight / 2) / currentPage.scale * currentPage.proportion;
                }

                currentPage.barcode.geometry.x = barx;
                currentPage.barcode.geometry.y = bary;

                if (vm.unit == 'mm') {
                    $scope.pageValue.barcode.x = unitTransformPx(barx).toFixed(2) - 0;//px-->mm
                    $scope.pageValue.barcode.y = unitTransformPx(bary).toFixed(2) - 0;//px-->mm
                } else {
                    $scope.pageValue.barcode.x = unitTransformPx(barx / 25.4 * vm.windowDpiW);
                    $scope.pageValue.barcode.y = unitTransformPx(barx / 25.4 * vm.windowDpiW);
                }
                // }
            }
            return false;
        }
        //条形码鼠标松开
        function moveBarcodeOnEnd() {
            $scope.$digest();
            dragBar = false;
            document.removeEventListener("mousemove", moveBarcodeOn, true);
            document.removeEventListener("mouseup", moveBarcodeOnEnd, true);
            dragBarBox = {};
            updateHistorys();
        }
        window.moveBarcodeStart1 = function (e) {
            fn(e);
            var targ = e.currentTarget ? e.currentTarget : e.srcElement;
            dragBarBox.clientX = e.clientX || 0;
            dragBarBox.clientY = e.clientY || 0;
            dragBarBox.coordX = targ.offsetLeft;
            dragBarBox.coordY = targ.offsetTop;
            dragBar = true;
            var currentPage = $scope.template.pages.page[$scope.template.pageI];
            if (currentPage.barcode.lock) {
                return
            }
            var all = getAllCtrlKeyArray();
            if (all.length) {
                dragBarBox.ctrlKey = true;
            } else {
                dragBarBox.ctrlKey = false;
            }
            document.addEventListener("mousemove", moveBarcodeOn1, true);
            document.addEventListener("mouseup", moveBarcodeOnEnd1, true);
        };
        //条形码move事件
        function moveBarcodeOn1(e) {
            $scope.$digest();
            e.stopPropagation();
            e.preventDefault();

            if (dragBar) {
                var currentPage = $scope.template.pages.page[$scope.template.pageI];

                var clientX = e.clientX - dragBarBox.clientX;
                var clientY = e.clientY - dragBarBox.clientY;

                var barOffsetX = (dragBarBox.coordX + clientX);
                var barOffsetY = (dragBarBox.coordY + clientY);
                var barWidth = currentPage.barcode.geometry.width * currentPage.scene.ratio;
                var barHeight = currentPage.barcode.geometry.height * currentPage.scene.ratio;
                // var height = $scope.template.pages.page[$scope.template.pageI].height * currentPage.scene.ratio;
                // var width = $scope.template.pages.page[$scope.template.pageI].width * currentPage.scene.ratio;
                var height = currentPage.mediabox.height * currentPage.scene.ratio;
                var width = currentPage.mediabox.width * currentPage.scene.ratio;
                var barcodeAngle = currentPage.barcode.rotation.angle;

                var lar = (currentPage.bloodPx.left + currentPage.bloodPx.right) * currentPage.scale / currentPage.proportion;
                var tab = (currentPage.bloodPx.top + currentPage.bloodPx.bottom) * currentPage.scale / currentPage.proportion;

                var barx = 0, bary = 0;

                //中心点
                var xcenter = barWidth / 2 + barOffsetX;
                var ycenter = barHeight / 2 + barOffsetY;


                if (barcodeAngle == 0) {
                    if (barOffsetX <= 0) {
                        barOffsetX = 0;
                    }

                    if (barOffsetX >= (width - barWidth)) {
                        barOffsetX = width - barWidth;
                    }
                    if (barOffsetY <= 0) {
                        barOffsetY = 0;
                    }

                    if (barOffsetY >= (height - barHeight)) {
                        barOffsetY = height - barHeight;
                    }

                    barx = barOffsetX / currentPage.scene.ratio;
                    bary = barOffsetY / currentPage.scene.ratio;
                } else {

                    if (xcenter <= 0) {
                        xcenter = 0;
                    }

                    if (xcenter >= (width + lar)) {
                        xcenter = width + lar;
                    }
                    if (ycenter <= 0) {
                        ycenter = 0;
                    }

                    if (ycenter >= (height + tab)) {
                        ycenter = height + tab;
                    }
                    barx = (xcenter - barWidth / 2) / currentPage.scene.ratio;
                    bary = (ycenter - barHeight / 2) / currentPage.scene.ratio;
                }

                currentPage.barcode.geometry.x = barx;
                currentPage.barcode.geometry.y = bary;

                if (vm.unit == 'mm') {
                    $scope.pageValue.barcode.x = unitTransformPx(barx).toFixed(2) - 0;//px-->mm
                    $scope.pageValue.barcode.y = unitTransformPx(bary).toFixed(2) - 0;//px-->mm
                } else {
                    $scope.pageValue.barcode.x = unitTransformPx(barx / 25.4 * vm.windowDpiW);
                    $scope.pageValue.barcode.y = unitTransformPx(barx / 25.4 * vm.windowDpiW);
                }
                // }
            }
            return false;
        }
        //条形码鼠标松开
        function moveBarcodeOnEnd1() {
            $scope.$digest();
            dragBar = false;
            document.removeEventListener("mousemove", moveBarcodeOn1, true);
            document.removeEventListener("mouseup", moveBarcodeOnEnd1, true);
            dragBarBox = {};
            updateHistorys();
        }

        //二维码移动事件
        var dragQrcodeTrue;
        var dragQrcode = {};
        window.moveQrcodeStart = function (e) {
            fn(e);
            var targ = e.currentTarget ? e.currentTarget : e.srcElement;
            dragQrcode.clientX = e.clientX || 0;
            dragQrcode.clientY = e.clientY || 0;
            dragQrcode.coordX = targ.offsetLeft;
            dragQrcode.coordY = targ.offsetTop;
            dragQrcodeTrue = true;
            var currentPage = $scope.template.pages.page[$scope.template.pageI];
            if (currentPage.qrcode.lock) {
                return
            }
            var all = getAllCtrlKeyArray();
            if (all.length) {
                dragQrcode.ctrlKey = true;
            } else {
                dragQrcode.ctrlKey = false;
            }
            document.addEventListener("mousemove", moveQrcodeOn, true);
            document.addEventListener("mouseup", moveQrcodeOnEnd, true);
        };

        //条形码move事件
        function moveQrcodeOn(e) {
            $scope.$digest();
            e.stopPropagation();
            e.preventDefault();

            if (dragQrcodeTrue) {
                var currentPage = $scope.template.pages.page[$scope.template.pageI];

                var clientX = e.clientX - dragQrcode.clientX;
                var clientY = e.clientY - dragQrcode.clientY;

                var barOffsetX = (dragQrcode.coordX + clientX);
                var barOffsetY = (dragQrcode.coordY + clientY);
                var barWidth = currentPage.qrcode.geometry.width * currentPage.scale / currentPage.proportion;
                var barHeight = currentPage.qrcode.geometry.height * currentPage.scale / currentPage.proportion;
                var height = $scope.template.pages.page[$scope.template.pageI].height * currentPage.scale;
                var width = $scope.template.pages.page[$scope.template.pageI].width * currentPage.scale;
                var qrcodeAngle = currentPage.qrcode.rotation.angle;

                var lar = (currentPage.bloodPx.left + currentPage.bloodPx.right) * currentPage.scale / currentPage.proportion;
                var tab = (currentPage.bloodPx.top + currentPage.bloodPx.bottom) * currentPage.scale / currentPage.proportion;

                var barx = 0, bary = 0;

                //中心点
                var xcenter = barWidth / 2 + barOffsetX;
                var ycenter = barHeight / 2 + barOffsetY;


                if (qrcodeAngle == 0) {
                    if (barOffsetX <= 0) {
                        barOffsetX = 0;
                    }

                    if (barOffsetX >= (width + lar - barWidth)) {
                        barOffsetX = width + lar - barWidth;
                    }
                    if (barOffsetY <= 0) {
                        barOffsetY = 0;
                    }

                    if (barOffsetY >= (height + tab - barHeight)) {
                        barOffsetY = height + tab - barHeight;
                    }

                    barx = barOffsetX / currentPage.scale * currentPage.proportion;
                    bary = barOffsetY / currentPage.scale * currentPage.proportion;
                } else {

                    if (xcenter <= 0) {
                        xcenter = 0;
                    }

                    if (xcenter >= (width + lar)) {
                        xcenter = width + lar;
                    }
                    if (ycenter <= 0) {
                        ycenter = 0;
                    }

                    if (ycenter >= (height + tab)) {
                        ycenter = height + tab;
                    }
                    barx = (xcenter - barWidth / 2) / currentPage.scale * currentPage.proportion;
                    bary = (ycenter - barHeight / 2) / currentPage.scale * currentPage.proportion;
                }

                currentPage.qrcode.geometry.x = barx;
                currentPage.qrcode.geometry.y = bary;

                if (vm.unit == 'mm') {
                    $scope.pageValue.qrcode.x = PxTurnMm(barx).toFixed(2) - 0;//px-->mm
                    $scope.pageValue.qrcode.y = PxTurnMm(bary).toFixed(2) - 0;//px-->mm
                } else if(vm.unit == 'px') {
                    $scope.pageValue.qrcode.x = PxTurnMm(barx / 25.4 * vm.windowDpiW);
                    $scope.pageValue.qrcode.y = PxTurnMm(barx / 25.4 * vm.windowDpiW);
                } else if(vm.unit == 'in') {
                    $scope.pageValue.qrcode.x = PxTurnIn(barx).toFixed(2) - 0;
                    $scope.pageValue.qrcode.y = PxTurnIn(bary).toFixed(2) - 0;
                }
            }
            return false;
        }

        //条形码鼠标松开
        function moveQrcodeOnEnd() {
            $scope.$digest();
            dragQrcode = false;
            document.removeEventListener("mousemove", moveQrcodeOn, true);
            document.removeEventListener("mouseup", moveQrcodeOnEnd, true);
            dragQrcode = {};
            updateHistorys();
        }

        window.moveQrcodeStart1 = function (e) {
            fn(e);
            var targ = e.currentTarget ? e.currentTarget : e.srcElement;
            dragQrcode.clientX = e.clientX || 0;
            dragQrcode.clientY = e.clientY || 0;
            dragQrcode.coordX = targ.offsetLeft;
            dragQrcode.coordY = targ.offsetTop;
            dragQrcodeTrue = true;
            var currentPage = $scope.template.pages.page[$scope.template.pageI];
            if (currentPage.qrcode.lock) {
                return
            }
            var all = getAllCtrlKeyArray();
            if (all.length) {
                dragQrcode.ctrlKey = true;
            } else {
                dragQrcode.ctrlKey = false;
            }
            document.addEventListener("mousemove", moveQrcodeOn1, true);
            document.addEventListener("mouseup", moveQrcodeOnEnd1, true);
        };

        //条形码move事件
        function moveQrcodeOn1(e) {
            $scope.$digest();
            e.stopPropagation();
            e.preventDefault();

            if (dragQrcodeTrue) {
                var currentPage = $scope.template.pages.page[$scope.template.pageI];

                var clientX = e.clientX - dragQrcode.clientX;
                var clientY = e.clientY - dragQrcode.clientY;

                var barOffsetX = (dragQrcode.coordX + clientX);
                var barOffsetY = (dragQrcode.coordY + clientY);
                var barWidth = currentPage.qrcode.geometry.width * currentPage.scale / currentPage.proportion;
                var barHeight = currentPage.qrcode.geometry.height * currentPage.scale / currentPage.proportion;
                var height = $scope.template.pages.page[$scope.template.pageI].height * currentPage.scale;
                var width = $scope.template.pages.page[$scope.template.pageI].width * currentPage.scale;
                var qrcodeAngle = currentPage.qrcode.rotation.angle;

                var lar = (currentPage.bloodPx.left + currentPage.bloodPx.right) * currentPage.scale / currentPage.proportion;
                var tab = (currentPage.bloodPx.top + currentPage.bloodPx.bottom) * currentPage.scale / currentPage.proportion;

                var barx = 0, bary = 0;

                //中心点
                var xcenter = barWidth / 2 + barOffsetX;
                var ycenter = barHeight / 2 + barOffsetY;


                if (qrcodeAngle == 0) {
                    if (barOffsetX <= 0) {
                        barOffsetX = 0;
                    }

                    if (barOffsetX >= (width + lar - barWidth)) {
                        barOffsetX = width + lar - barWidth;
                    }
                    if (barOffsetY <= 0) {
                        barOffsetY = 0;
                    }

                    if (barOffsetY >= (height + tab - barHeight)) {
                        barOffsetY = height + tab - barHeight;
                    }

                    barx = barOffsetX / currentPage.scale * currentPage.proportion / $scope.proportion;
                    bary = barOffsetY / currentPage.scale * currentPage.proportion / $scope.proportion;
                } else {

                    if (xcenter <= 0) {
                        xcenter = 0;
                    }

                    if (xcenter >= (width + lar)) {
                        xcenter = width + lar;
                    }
                    if (ycenter <= 0) {
                        ycenter = 0;
                    }

                    if (ycenter >= (height + tab)) {
                        ycenter = height + tab;
                    }
                    barx = (xcenter - barWidth / 2) / currentPage.scale * currentPage.proportion / $scope.proportion;
                    bary = (ycenter - barHeight / 2) / currentPage.scale * currentPage.proportion / $scope.proportion;
                }

                currentPage.qrcode.geometry.x = barx;
                currentPage.qrcode.geometry.y = bary;

                if (vm.unit == 'mm') {
                    $scope.pageValue.qrcode.x = PxTurnMm(barx).toFixed(2) - 0;//px-->mm
                    $scope.pageValue.qrcode.y = PxTurnMm(bary).toFixed(2) - 0;//px-->mm
                } else if(vm.unit == 'px') {
                    $scope.pageValue.qrcode.x = PxTurnMm(barx / 25.4 * vm.windowDpiW);
                    $scope.pageValue.qrcode.y = PxTurnMm(barx / 25.4 * vm.windowDpiW);
                } else if(vm.unit == 'in') {
                    $scope.pageValue.qrcode.x = PxTurnIn(barx).toFixed(2) - 0;
                    $scope.pageValue.qrcode.y = PxTurnIn(bary).toFixed(2) - 0;
                }
                // }
            }
            return false;
        }

        //条形码鼠标松开
        function moveQrcodeOnEnd1() {
            $scope.$digest();
            dragQrcode = false;
            document.removeEventListener("mousemove", moveQrcodeOn1, true);
            document.removeEventListener("mouseup", moveQrcodeOnEnd1, true);
            dragQrcode = {};
            updateHistorys();
        }

        /* ==========================================================================
         单位切换
         ========================================================================== */

        // mm---px
        function ThreeHundredDpi(attr1, attr2) {
            // Math.floor(px / 300 * 25.4)   (px--mm)
            // Math.ceil(mm / 25.4 * 300)   (mm---px)
            var px1 = parseFloat((attr1 / 25.4 * vm.windowDpiW - 0)).toFixed(2) - 0;
            var px2 = parseFloat((attr2 / 25.4 * vm.windowDpiH - 0)).toFixed(2) - 0;
            return {
                px1: px1,
                px2: px2
            }
        }

        // px---mm
        function ThreeHundredDpiToMm(attr1, attr2) {
            var mm1 = parseFloat((attr1 / vm.windowDpiW * 25.4 - 0)).toFixed(2) - 0;
            var mm2 = parseFloat((attr2 / vm.windowDpiH * 25.4 - 0)).toFixed(2) - 0;
            return {
                mm1: mm1,
                mm2: mm2
            }
        }

        $scope.selectPageo = function (e, $index, page) {
            if (page.unit == 'mm') {
                $scope.dpi = vm.dpiChoose[0];
            } else {
                $scope.dpi = vm.dpiChoose[1];
            }
        };


        /* ==========================================================================
         鼠标滑过事件
         ========================================================================== */

        $scope.isAlignHover = false;
        $scope.isDistriHover = false;
        var toobarFlag1 = true;
        var toobarFlag2 = true;
        $scope.toobarAlignment = function () {
            $(".space-slider").addClass('hide1');
            if (toobarFlag1) {
                $scope.isAlignHover = true;
                $scope.isDistriHover = false;
                toobarFlag1 = false;
                toobarFlag2 = true;
            } else {
                $scope.isAlignHover = false;
                toobarFlag1 = true;
            }
        }

        $scope.toolbarDistribution = function () {
            $(".space-slider").addClass('hide1');
            if (toobarFlag2) {
                $scope.isAlignHover = false;
                $scope.isDistriHover = true;
                toobarFlag2 = false;
                toobarFlag1 = true;
            } else {
                $scope.isDistriHover = false;
                toobarFlag2 = true;
            }
        }

        $scope.boxAlignment = function (attr) {
            var levels = $scope.currentPage.levels;
            var all = getAllCtrlKeyArray();

            if (attr == 'left') {
                all.sort(compare('offsetXM', true));
            } else if (attr == 'right') {
                all.sort(compare('offsetXM', false));
                all.sort(compare('widthM', false));
            } else if (attr == 'top') {
                all.sort(compare('offsetYM', true));
            } else if (attr == 'bottom') {
                all.sort(compare('offsetYM', false));
                all.sort(compare('heightM', false));
            }
            if(attr == 'vertical' && all.length>0){
                var verticalY = horizontalAndVerticalCenter(attr, all);
            }
            if(attr == 'standard' && all.length>0){
                var standardX = horizontalAndVerticalCenter(attr, all);
            }
            for (var i = 0; i < all.length; i++) {
                if (attr == 'left') {
                    all[i].geometry.x = all[0].geometry.x;

                } else if (attr == 'right') {
                    all[i].geometry.x = all[0].geometry.x + all[0].geometry.width - all[i].geometry.width;

                } else if (attr == 'top') {
                    all[i].geometry.y = all[0].geometry.y;

                } else if (attr == 'bottom') {
                    all[i].geometry.y = all[0].geometry.y + all[0].geometry.height - all[i].geometry.height;

                } else if (attr == 'vertical') {
                    all[i].geometry.y = verticalY - all[i].geometry.height / 2;
                } else {
                    all[i].geometry.x = standardX - all[i].geometry.width / 2;
                }


                if (all[i].current == 'imagebox') {
                    levels.level[all[i].levelI].imagebox = all[i];
                } else if (all[i].current == 'textbox') {
                    levels.level[all[i].levelI].textbox = all[i];
                } else {
                    levels.level[all[i].levelI].imageart = all[i];
                }
            }
            // moveTogetherEnd();
            updateHistorys();
            resetCtrlKeyArray();

        }

        $scope.boxDistribution = function (attr) {
            var all = getAllCtrlKeyArray();

            if (all.length < 3) {
                return
            }

            // 水平分布
            if (attr == 'standard') {
                setAllCtrlKeyArray(all, 'x', 'offsetXM');
            } else {
                // 垂直分布
                setAllCtrlKeyArray(all, 'y', 'offsetYM');

            }
            resetCtrlKeyArray();
            updateHistorys();
        }

        function setAllCtrlKeyArray(all, attr1, attr2) {
            var levels = $scope.currentPage.levels;

            var len = all.length - 1;
            all.sort(compare(attr2, true));
            var spacingPx = (all[len].geometry[attr1] - all[0].geometry[attr1]) / len;
            var spacingMm = (all[len][attr2] - all[0][attr2]) / len;
            for (var i = 1; i < len; i++) {
                all[i].geometry[attr1] = all[0].geometry[attr1] + spacingPx * i;
                all[i][attr2] = all[0][attr2] + spacingMm * i;

                if (all[i].current == 'imagebox') {
                    levels.level[all[i].levelI].imagebox = all[i];
                } else if (all[i].current == 'textbox') {
                    levels.level[all[i].levelI].textbox = all[i];
                } else {
                    levels.level[all[i].levelI].imageart = all[i];
                }
            }
        }
        //移动画布
        vm.moveCanvasView = false;
        canvasInfo();
        function canvasInfo(){
            vm.moveCanvasObj = {
                x:0,
                y:0
            };
        }
        $scope.moveCanvas = function(e){
            if(!vm.moveCanvasView){
                return
            }
            var _moveCanvasObj = angular.copy(vm.moveCanvasObj);
            moveCanvas(e, function (x, y) {
                vm.moveCanvasObj.x = _moveCanvasObj.x + x;
                vm.moveCanvasObj.y = _moveCanvasObj.y + y;
                $scope.$apply();
            })
        }

        /**
         *
         * 自定义元素右键菜单样式  复制、剪切、删除
         *
         */
        document.onkeyup = function (event) {
            if(event.keyCode == 32){
                $timeout(function () {
                    vm.moveCanvasView = false;
                })
                // console.log('空格键抬起');
            }
        }
        document.onkeydown = function (event) {
            if(event.keyCode == 32){
                $timeout(function () {
                    vm.moveCanvasView = true;
                })
                // console.log('空格键按下');
                return false
            }
            if (event.keyCode == 27) {
                //ESC
            }
            // 删除
            if (event.keyCode == 46) {
                $scope.deleteBox();
                $scope.$digest();
            }
            // ctrl+c
            if ((event.ctrlKey == true || event.metaKey == true) && event.keyCode == 67) {
                if(event.target.nodeName=='TEXTAREA'){
                    return
                }
                // localStorage.setItem('singleArray', JSON.stringify(vm.singleArray));

                // var levels = $scope.currentPage.levels;

                // for (var x = 0; x < levels.level.length; x++) {
                //     var l = levels.level[x];
                //     if (l.imagebox && l.imagebox.current) {
                //         l.imagebox.ctrlKey = false;
                //     }
                //     if (l.imageart && l.imageart.current) {
                //         l.imageart.ctrlKey = false;
                //     }
                //     if (l.textbox && l.textbox.current) {
                //         l.textbox.ctrlKey = false;
                //     }
                //     if (l.textdocument && l.textdocument.current) {
                //         l.textdocument.ctrlKey = false;
                //     }
                // }
                if(vm.CtrlKeyArray.imageboxes.length||vm.CtrlKeyArray.imagearts.length||vm.CtrlKeyArray.textboxes.length){
                    vm.copyArray = angular.copy(vm.CtrlKeyArray);
                }else{
                    var box = angular.copy($scope.selectBox)
                    if (box.current == 'imagebox') {
                        vm.CtrlKeyArray.imageboxes.push(box)
                    }
                    if (box.current == 'textbox') {
                        vm.CtrlKeyArray.textboxes.push(box)
                    }
                    if (box.current == 'imageart') {
                        vm.CtrlKeyArray.imagearts.push(box)
                    }
                    vm.copyArray = angular.copy(vm.CtrlKeyArray);
                }
            }
            //ctrl+v
            if ((event.ctrlKey == true || event.metaKey == true) && event.keyCode == 86) {
                if(event.target.nodeName=='TEXTAREA'){
                    return
                }
                var currentPage = $scope.currentPage;
                if(!vm.copyArray){
                    return
                }
                if(vm.copyArray.imageboxes.length||vm.copyArray.imagearts.length||vm.copyArray.textboxes.length){
                    copyTogether(currentPage);
                }
                // console.log($scope.currentPage.levels.level);
                $scope.$digest();
            }
            // ctrl+x
            if ((event.ctrlKey == true || event.metaKey == true) && event.keyCode == 88) {
                $scope.deleteBox();
                $scope.$digest();
            }

            if (event.target.tagName == 'INPUT') {
                return
            }
            // 上
            if (event.keyCode == 38) {
                keycodeArrow(38);
            }
            // 下
            if (event.keyCode == 40) {
                keycodeArrow(40);

            }
            // 左
            if (event.keyCode == 37) {
                keycodeArrow(37);
            }
            // 右
            if (event.keyCode == 39) {
                keycodeArrow(39);
            }
            event.returnvalue = false;
        };

        function copyTogether(currentPage){
            angular.forEach(vm.copyArray.imageboxes, function (imagebox, i) {
                // console.log("i: "+i)
                if(imagebox&&imagebox.geometry){
                    // 当前页所有占位框
                    var box = angular.copy(imagebox);
                    var currentLevel = addLevel(currentPage);
                    currentLevel.imagebox = copyDetail2(box);
                    updateHistorys();
                }

            })

            angular.forEach(vm.copyArray.imagearts, function (imageart, i) {
                if(imageart&&imageart.geometry){
                    // 当前页所有素材
                    var box = angular.copy(imageart);
                    var currentLevel = addLevel(currentPage);
                    currentLevel.imageart = copyDetail2(box);
                    updateHistorys();
                }

            })

            angular.forEach(vm.copyArray.textboxes, function (textbox, i) {
                if(textbox&&textbox.geometry){
                    // 当前页所有文字
                    var box = angular.copy(textbox);
                    var currentLevel = addLevel(currentPage);
                    currentLevel.textbox = copyDetail2(box);
                    updateHistorys();
                }

            })
        }

        function copyDetail2(box) {
            box.levelI = $scope.currentPage.levels.level.length-1;
            box.lock = false;
            var repeatEle = false;
            $scope.currentPage.levels.level.forEach(function(item){
                if(item.imagebox && item.imagebox.geometry.x == box.geometry.x && item.imagebox.geometry.y == box.geometry.y){
                    repeatEle = true;
                }
                if(item.imageart && item.imageart.geometry.x == box.geometry.x && item.imageart.geometry.y == box.geometry.y){
                    repeatEle = true;
                }
                if(item.textbox && item.textbox.geometry.x == box.geometry.x && item.textbox.geometry.y == box.geometry.y){
                    repeatEle = true;
                }
                if(item.code && item.code.geometry.x == box.geometry.x && item.code.geometry.y == box.geometry.y){
                    repeatEle = true;
                }
            })
            if(!repeatEle){
                return box
            }
            if (box.current == 'imagebox') {
                vm.copyArray.imageboxes.forEach(function(imagebox){
                    if(imagebox && imagebox.geometry.x == box.geometry.x && imagebox.geometry.y == box.geometry.y){
                        var x = PxTurnMm(imagebox.geometry.x) + 1;
                        var y = PxTurnMm(imagebox.geometry.y) + 1;
                        imagebox.geometry.x = MmTurnPx(x);
                        imagebox.geometry.y = MmTurnPx(y);
                    }
                })
            }
            if (box.current == 'imageart') {
                vm.copyArray.imagearts.forEach(function(imageart){
                    if(imageart && imageart.geometry.x == box.geometry.x && imageart.geometry.y == box.geometry.y){
                        var x = PxTurnMm(imageart.geometry.x) + 1;
                        var y = PxTurnMm(imageart.geometry.y) + 1;
                        imageart.geometry.x = MmTurnPx(x);
                        imageart.geometry.y = MmTurnPx(y);
                    }
                })
            }
            if(box.current == 'textbox'){
                vm.copyArray.textboxes.forEach(function(textbox){
                    if(textbox && textbox.geometry.x == box.geometry.x && textbox.geometry.y == box.geometry.y){
                        var x = PxTurnMm(textbox.geometry.x) + 1;
                        var y = PxTurnMm(textbox.geometry.y) + 1;
                        textbox.geometry.x = MmTurnPx(x);
                        textbox.geometry.y = MmTurnPx(y);
                    }
                })
            }
            var x = PxTurnMm(box.geometry.x) + 1;
            var y = PxTurnMm(box.geometry.y) + 1;
            box.geometry.x = MmTurnPx(x);
            box.geometry.y = MmTurnPx(y);
            // 判断边界
            if (box.geometry.y < 0) {
                box.geometry.y = 0;
            }
            if (box.geometry.y > $scope.currentPage.mediabox.height - box.geometry.height) {
                box.geometry.y = $scope.currentPage.mediabox.height - box.geometry.height;
            }
            if (box.geometry.x < 0) {
                box.geometry.x = 0;
            }
            if (box.geometry.x > $scope.currentPage.mediabox.width - box.geometry.width) {
                box.geometry.x = $scope.currentPage.mediabox.width - box.geometry.width;
            }
            return box
        }

        function keycodeArrow(keyCode) {
            var temp = JSON.parse(localStorage.getItem('singleArray'));
            var levels = $scope.currentPage.levels;
            var level = levels.level[$scope.template.levelI];
            var currentPage = $scope.template.pages.page[$scope.template.pageI];

            var all = getAllCtrlKeyArray(1);

            var len = all.length;
            var box = [], value = {};
            if (!len) {
                if ($scope.selectBox.current == 'imagebox') {
                    box = level.imagebox;
                    value = $scope.pageValue.imagebox;
                }
                if ($scope.selectBox.current == 'textbox') {
                    box = level.textbox;
                    value = $scope.pageValue.textbox;
                }
                if ($scope.selectBox.current == 'imageart') {
                    box = level.imageart;
                    value = $scope.pageValue.imageart;
                }
                if ($scope.selectBox.current == 'textdocument') {
                    box = level.textdocument;
                    value = $scope.pageValue.textdocument;
                }
                if (box.lock) {
                    return
                }

                var maxHeightPx = parseFloat(currentPage.mediabox.height - box.geometry.height).toFixed(2) - 0;
                var maxWidthPx = parseFloat(currentPage.mediabox.width - box.geometry.width).toFixed(2) - 0;
                // 上
                if (keyCode == 38) {
                    if (vm.unit == 'px') {
                        if (value.y >= 1) {
                            value.y--;
                            box.geometry.y = unitTransform(value.y / vm.windowDpiH * 25.4);
                        }
                    } else {
                        if (value.y >= 1) {
                            value.y -= 0.2;
                            box.geometry.y = unitTransform(value.y);
                        }
                    }
                }
                // 下
                if (keyCode == 40) {
                    if (vm.unit == 'px') {
                        if (value.y < maxHeightPx) {
                            value.y++;
                            box.geometry.y = unitTransform(value.y / vm.windowDpiH * 25.4);
                        }
                    } else {
                        if (value.y < unitTransformPx(currentPage.mediabox.height - box.geometry.height)) {
                            value.y += 0.2;
                            box.geometry.y = unitTransform(value.y);
                        }
                    }
                }
                // 左
                if (keyCode == 37) {
                    if (vm.unit == 'px') {
                        if (value.x >= 1) {
                            value.x--;
                            box.geometry.x = unitTransform(value.x / vm.windowDpiW * 25.4);
                        }
                    } else {
                        if (value.x >= 1) {
                            value.x -= 0.2;
                            box.geometry.x = unitTransform(value.x);
                        }
                    }
                }
                // 右
                if (keyCode == 39) {
                    if (vm.unit == 'px') {
                        if (value.x >= maxWidthPx) {
                            value.x++;
                            box.geometry.x = unitTransform(value.x / vm.windowDpiW * 25.4);
                        }
                    } else {
                        if (value.x < unitTransformPx(maxWidthPx)) {
                            value.x += 0.2;
                            box.geometry.x = unitTransform(value.x);
                        }
                    }
                }
                updateHistorys();
                $scope.$apply();
            } else {
                for (var i = len - 1; i >= 0; i--) {
                    if (!all[i]) {
                        continue;
                    }
                    var box = [];
                    if (all[i].current == 'imagebox') {
                        box = levels.level[all[i].levelI].imagebox;
                    } else if (all[i].current == 'textbox') {
                        box = levels.level[all[i].levelI].textbox;
                    } else if (all[i].current == 'imageart') {
                        box = levels.level[all[i].levelI].imageart;
                    }
                    if (box.lock) {
                        return
                    }
                    var maxHeightPx = parseFloat(currentPage.mediabox.height - box.geometry.height).toFixed(2) - 0;
                    var maxWidthPx = parseFloat(currentPage.mediabox.width - box.geometry.width).toFixed(2) - 0;
                    if (keyCode == 38) {
                        if (vm.unit == 'px') {
                            if (box.geometry.y >= 1) {
                                box.geometry.y--;
                            }
                        } else {
                            var y = unitTransformPx(box.geometry.y);
                            if (y >= 1) {
                                y -= 0.2;
                                box.geometry.y = unitTransform(y);
                            }
                        }
                    }
                    // 下
                    if (keyCode == 40) {
                        if (vm.unit == 'px') {
                            if (box.geometry.y < maxHeightPx) {
                                box.geometry.y++;
                            }
                        } else {
                            var y = unitTransformPx(box.geometry.y);
                            if (y < unitTransformPx(maxHeightPx)) {
                                y += 0.2;
                                box.geometry.y = unitTransform(y);
                            }
                        }
                    }
                    // 左
                    if (keyCode == 37) {
                        if (vm.unit == 'px') {
                            if (box.geometry.x >= 1) {
                                box.geometry.x--;
                            }
                        } else {
                            var x = unitTransformPx(box.geometry.x)
                            if (x >= 1) {
                                x -= 0.2;
                                box.geometry.x = unitTransform(x);
                            }
                        }
                    }
                    // 右
                    if (keyCode == 39) {
                        if (vm.unit == 'px') {
                            if (box.geometry.x < maxWidthPx) {
                                box.geometry.x++;
                            }
                        } else {
                            var x = unitTransformPx(box.geometry.x);
                            if (x < unitTransformPx(maxWidthPx)) {
                                x += 0.2;
                                box.geometry.x = unitTransform(x);
                            }
                        }
                    }
                    updateHistorys();
                    $scope.$apply();
                }
            }


            $scope.currentPage = currentPage;
        }

        //复制
        $scope.copying = function () {
            var temp = JSON.parse(localStorage.getItem('singleArray'));
            if (vm.singleArray) {
                temp = vm.singleArray;
            }
            var levels = $scope.currentPage.levels;
            var currentPage = $scope.template.pages.page[$scope.template.pageI];
            var all = getAllCtrlKeyArray(1);
            var len = all.length;
            // 单选状态
            if (!len) {
                var currentLevel = addLevel(currentPage);
                if ($scope.selectBox.current == 'imagebox') {
                    var box = angular.copy(temp.imagebox);
                    currentLevel.imagebox = copyDetail(box, temp.imagebox);
                    vm.singleArray.imagebox = currentLevel.imagebox;
                }
                if ($scope.selectBox.current == 'textbox') {
                    var box = angular.copy(temp.textbox);
                    currentLevel.textbox = copyDetail(box, temp.textbox);
                    vm.singleArray.textbox = currentLevel.textbox;

                }
                if ($scope.selectBox.current == 'imageart') {
                    var box = angular.copy(temp.imageart);
                    currentLevel.imageart = copyDetail(box, temp.imageart);
                    vm.singleArray.imageart = currentLevel.imageart;

                }
                if ($scope.selectBox.current == 'textdocument') {
                    var box = angular.copy(temp.textdocument);
                    currentLevel.textdocument = copyDetail(box, temp.textdocument);
                    vm.singleArray.textdocument = currentLevel.textdocument;

                }
                $scope.template.levelI = levels.level.length - 1;
            } else {
                // ctrl+点击
                for (var i = len - 1; i >= 0; i--) {
                    if (!all[i]) {
                        continue;
                    }
                    var box = angular.copy(all[i]);
                    var currentLevel = addLevel(currentPage);
                    if (all[i].current == 'imagebox') {
                        if (levels.level[box.levelI]) {
                            currentLevel.imagebox = copyDetail(box, all[i]);
                        } else {
                            box.levelI = levels.length;
                            currentLevel.imagebox = box;
                        }
                    } else if (all[i].current == 'textbox') {
                        if (levels.level[box.levelI]) {
                            currentLevel.textbox = copyDetail(box, all[i]);
                        } else {
                            box.index = levels.length;
                            currentLevel.textbox = box;
                        }
                    } else if (all[i].current == 'imageart') {
                        if (levels.level[box.levelI]) {
                            currentLevel.imageart = copyDetail(box, all[i]);
                        } else {
                            box.index = levels.length;
                            currentLevel.imageart = box;
                        }
                    } else if (all[i].current == 'textdocument') {
                        // console.log("???")
                        if (levels.level[box.levelI]) {
                            currentLevel.textdocument = copyDetail(box, all[i]);
                        } else {
                            box.index = levels.length;
                            currentLevel.textdocument = box;
                        }
                    }
                }
                $scope.clearCtrlKey();
                localStorage.removeItem('singleArray');
                $scope.selectBox = {}
            }
            getImageboxLen();
            getPagePx();
            updateHistorys();
        };

        // 剪切
        $scope.cuting = function () {
            var temp = JSON.parse(localStorage.getItem('singleArray'));

            var levels = $scope.currentPage.levels;
            var level = levels.level[$scope.template.levelI];
            var currentPage = $scope.template.pages.page[$scope.template.pageI]
            // 当前页所有占位框
            var currentImages = currentPage.imageboxes.imagebox;
            // 当前页所有文本
            var currentTexts = currentPage.textboxes.textbox;
            // 当前页所有素材
            var currentArts = currentPage.imagearts.imageart;
            var all = getAllCtrlKeyArray(1);

            var len = all.length;
            // 单选状态
            if (!len) {
                if ($scope.selectBox.current == 'imagebox') {
                    currentImages.splice($scope.template.imgI, 1);
                    // $scope.template.imgI = currentImages.length - 1;
                }
                if ($scope.selectBox.current == 'textbox') {
                    currentTexts.splice($scope.template.textI, 1);
                    // $scope.template.textI = currentTexts.length - 1;
                }
                if ($scope.selectBox.current == 'imageart') {
                    currentArts.splice($scope.template.artI, 1);
                    // $scope.template.artI = currentArts.length - 1;
                }
                localStorage.setItem('singleArray', JSON.stringify(vm.singleArray));
            } else {
                // ctrl+点击
                for (var i = len - 1; i >= 0; i--) {
                    if (!all[i]) {
                        continue;
                    }
                    var box = angular.copy(all[i]);
                    if (all[i].current == 'imagebox') {
                        currentImages.splice(box.index, 1);
                    } else if (all[i].current == 'textbox') {
                        currentTexts.splice(box.index, 1);
                    } else if (all[i].current == 'imageart') {
                        currentArts.splice(box.index, 1);
                    }
                }
            }
        }

        function copyDetail(box, currentbox) {
            box.geometry.x = unitTransform(12) + currentbox.geometry.x;
            box.geometry.y = unitTransform(12) + currentbox.geometry.y;
            box.levelI = $scope.currentPage.levels.level.length - 1;
            // 判断边界
            if (box.geometry.y < 0) {
                box.geometry.y = 0;
            }
            if (box.geometry.y > $scope.currentPage.mediabox.height - box.geometry.height) {
                box.geometry.y = $scope.currentPage.mediabox.height - box.geometry.height;
            }
            if (box.geometry.x < 0) {
                box.geometry.x = 0;
            }
            if (box.geometry.x > $scope.currentPage.mediabox.width - box.geometry.width) {
                box.geometry.x = $scope.currentPage.mediabox.width - box.geometry.width;
            }
            return box;
        }

        /**
         * 上一张，下一张
         */
        $scope.pageDirection = function (flag) {
            $scope.lastPage = $scope.template.pages.page[$scope.template.pageI];
            setTimeout(function () {
                checkPageCover();
            })
            // 上一张
            if (flag) {
                $scope.template.pageI = $scope.template.pageI - 1;
            } else {
                $scope.template.pageI = $scope.template.pageI + 1;
            }
            // $(".bg-image").attr('src', '');
            $scope.RightPanel = 'page';
            isCanLeftAndRightPage();
            loadAttribute();

            var w = 0;
            for (var i = 0; i < $scope.template.pageI - 3; i++) {
                var page = $scope.template.pages.page[i];
                w += page.width * 98 / page.height + 16;
            }
            $(".nav-ul").scrollLeft(w);
        };

        //点击页面显示左右方向
        function isCanLeftAndRightPage() {
            $scope.template.levelI = 0;
            $scope.currentPage = $scope.template.pages.page[$scope.template.pageI];

            setOriginalWaH($scope.currentPage.trimbox.width, $scope.currentPage.trimbox.height, $scope.template.pageI);

            if ($scope.template.pages.page.length == 1) {
                $scope.visibleLeft = false;
                $scope.visibleRight = false;
            } else if ($scope.template.pageI == 0) {
                $scope.visibleLeft = false;
                $scope.visibleRight = true;
            } else if ($scope.template.pageI == $scope.template.pages.page.length - 1) {
                $scope.visibleLeft = true;
                $scope.visibleRight = false;
            } else {
                $scope.visibleLeft = true;
                $scope.visibleRight = true;
            }
            getImageboxLen();
        }

        /**
         * 1.无封面则直接生成
         * 2.点击事件中先判断一下开始时间是否为空，为空时就把当前时间赋给开始时间（说明是第一次点击）
         * 否则就是第二次点击，把当前时间赋值给结束时间。
         * 第二次点击时就可以用结束时间减去开始时间，得到两次点击的时间间隔。
         */
        var first = 0;
        var second = 0;

        function checkPageCover() {
            if (!$scope.lastPage.pagecover || $scope.lastPage.pagecover && $scope.lastPage.pagecover.identifier == null) {
                // var nodes = document.getElementsByClassName('pageNode');
                var nodes = document.getElementsByClassName('page-item2');
                setThumbnailPic(nodes[0], $scope.lastPage);
                oldPage = angular.copy($scope.template.pages.page[$scope.template.pageI])
                return
            }

            var a = JSON.stringify(oldPage);
            var b = JSON.stringify($scope.lastPage);
            // console.log("是否相等："+(a==b))
            // console.log(oldPage)
            // console.log($scope.lastPage)
            if(a!=b){
                var nodes = document.getElementsByClassName('page-item2');
                setThumbnailPic(nodes[0], $scope.lastPage);
            }

            oldPage = angular.copy($scope.template.pages.page[$scope.template.pageI])
        }

        /**
         * 放大缩小及还原
         */
        $scope.changeShirnk = function (zoomIn) {
            var i = $scope.template.pageI;
            var currentPage = $scope.template.pages.page[i];
            var number = 0.02;
            var marTop = 0;

            // 还原
            if (zoomIn == 0) {
                currentPage.scale = 1;
                // $(".page-item").css({'margin': 'auto'});
            }

            // 缩小
            if (zoomIn == 1) {
                if (currentPage.scale <= 0.5) {
                    return;
                }
                currentPage.scale = Math.abs(currentPage.scale - number).toFixed(2);
                // setTimeout(function () {
                //     marTop = parseInt($(".page-item").css('margin-top'));
                //     if (marTop >= 0) {
                //         $(".page-item").css({'margin': 'auto'});
                //     } else {
                //         $(".page-item").css({'margin': '0 auto'});
                //     }
                // }, 10);
            }

            // 放大
            if (zoomIn == 2) {
                var scale = Math.abs(currentPage.scale - 0 + number).toFixed(2);
                //限制放大倍数
                if (scale > 1.5) {
                    return
                }
                currentPage.scale = scale;
                // setTimeout(function () {
                //     marTop = parseInt($(".page-item").css('margin-top'));
                //     if (marTop < 0) {
                //         $(".page-item").css({'margin': '0 auto'});
                //     }
                // }, 10);
            }
            // updateHistorys();
            $scope.currentPage = currentPage;
        }

        //删除模板
        $scope.deletePage = function (index, e) {
            fn(e)
            if ($scope.template.pages.page.length == 1 || $scope.template.pageI == null || $scope.template.pageI < 0) {
                return;
            }
            if (index == null && ($scope.template.pageI == null || $scope.template.pageI < 0)) {
                return;
            }


            $scope.template.pages.page.splice(index, 1);
            var len = $scope.template.pages.page.length;
            if (len > 1) {
                $scope.template.pages.page[len - 1].spread = false;
            }
            if (index == 0) {
                $scope.template.pageI = 0;
            }

            if (index == len && $scope.template.pageI == index) {
                $scope.template.pageI = index - 1;
            }
            $scope.currentPage = $scope.template.pages.page[$scope.template.pageI];

            setUlWidth();
        };

        // 窗口宽高变化
        window.onresize = function () {
            if ($scope.currentPage && $scope.currentPage.trimbox) {
                setOriginalWaH($scope.currentPage.trimbox.width, $scope.currentPage.trimbox.height, $scope.template.pageI);
                $scope.$digest();
            }
        };

        function compare(property, attr) {
            return function (a, b) {
                var value1 = a[property];
                var value2 = b[property];
                if (attr) {
                    return value1 - value2;
                }
                else {
                    return value2 - value1;
                }
            }
        }

        function getAllCtrlKeyArray() {
            var imageboxes = vm.CtrlKeyArray.imageboxes,
                textboxes = vm.CtrlKeyArray.textboxes,
                imagearts = vm.CtrlKeyArray.imagearts,
                all = [];
            var barcode = vm.CtrlKeyArray.barcode;
            var qrcode = vm.CtrlKeyArray.qrcode;
            //选中的占位框
            for (var i = 0; i < imageboxes.length; i++) {
                if (imageboxes[i]) {
                    all.push(imageboxes[i]);
                }
            }
            //选中的文本框
            for (var i = 0; i < textboxes.length; i++) {
                if (textboxes[i]) {
                    all.push(textboxes[i]);
                }
            }
            //选中的素材
            for (var i = 0; i < imagearts.length; i++) {
                if (imagearts[i]) {
                    all.push(imagearts[i]);
                }
            }
            //选中的条码
            for (var i = 0; i < barcode.length; i++) {
                all.push(barcode[i]);
            }
            //选中的二维码
            for (var i = 0; i < qrcode.length; i++) {
                all.push(qrcode[i]);
            }
            return all;
        }

        function resetCtrlKeyArray() {
            var levels = $scope.currentPage.levels;
            if(!levels.level){
                return
            }
            for (var x = 0; x < levels.level.length; x++) {
                var l = levels.level[x];
                if (l.imagebox && l.imagebox.current) {
                    l.imagebox.ctrlKey = false;
                }
                if (l.imageart && l.imageart.current) {
                    l.imageart.ctrlKey = false;
                }
                if (l.textbox && l.textbox.current) {
                    l.textbox.ctrlKey = false;
                }
                if (l.textdocument && l.textdocument.current) {
                    l.textdocument.ctrlKey = false;
                }
            }

            vm.CtrlKeyArray.imageboxes = [];
            vm.CtrlKeyArray.textboxes = [];
            vm.CtrlKeyArray.imagearts = [];
            vm.CtrlKeyArray.barcode = [];
            vm.CtrlKeyArray.qrcode = [];
        }

        $scope.clearCtrlKey = function (flag) {
            // if ($scope.currentPage.scene) {
            //     getPagePx();
            //     return
            // }
            // 点击页面内容
            if (flag) {
                getPagePx();
                $scope.shezhi = false;
                // 清空选中
                $scope.selectBox.current = 'page';
            }
            $scope.isAlignHover = false;
            $scope.isDistriHover = false;
            toobarFlag1 = true;
            toobarFlag2 = true;

            toolbarStatus();

            var levels = $scope.currentPage.levels;

            angular.forEach(levels.level, function (l, x) {
                if (l.imagebox && l.imagebox.current) {
                    l.imagebox.ctrlKey = false;
                }
                if (l.imageart && l.imageart.current) {
                    l.imageart.ctrlKey = false;
                }
                if (l.textbox && l.textbox.current) {
                    l.textbox.ctrlKey = false;
                }
                if (l.textdocument && l.textdocument.current) {
                    l.textdocument.ctrlKey = false;
                }
            })

            vm.CtrlKeyArray.imageboxes = [];
            vm.CtrlKeyArray.textboxes = [];
            vm.CtrlKeyArray.textdocument = [];
            vm.CtrlKeyArray.imagearts = [];
            vm.CtrlKeyArray.barcode = [];
            vm.CtrlKeyArray.qrcode = [];
        }

        function getPagePx() {
            $scope.RightPanel = 'page';
            loadAttribute();
        }

        $scope.editSize = function (attr) {
            var temp = $scope.template.pages.page[$scope.template.pageI];
            vm.unit = 'mm';
            unit();
            vm.page.editbox = angular.copy(temp.editbox);
            vm.page.editbox = {
                x: PxTurnMm(vm.page.editbox.x),
                y: PxTurnMm(vm.page.editbox.y),
                width: PxTurnMm(vm.page.editbox.width),
                height: PxTurnMm(vm.page.editbox.height),
            };
            vm.page.editboxs = angular.copy(temp.editboxes.editbox);
            vm.page.editboxs.forEach(function (editbox) {
                editbox.x= PxTurnMm(editbox.x);
                editbox.y= PxTurnMm(editbox.y);
                editbox.width= PxTurnMm(editbox.width);
                editbox.height= PxTurnMm(editbox.height);
            })
            vm.page.pageSize = angular.copy($scope.pageValue.mediabox);
            oldSizePx = angular.copy($scope.currentPage.bloodPx);
            oldSizeMm = angular.copy($scope.currentPage.blood);
            vm.page.pageBloodB = oldSizeMm.bottom - 0;
            vm.page.pageBloodL = oldSizeMm.left - 0;
            vm.page.pageBloodR = oldSizeMm.right - 0;
            vm.page.pageBloodT = oldSizeMm.top - 0;
            vm.page.pageSizeUnit = "mm";

            createModal('app/entities/page/page-edit.html', 'PageEditController', attr).result.then(
                function (data) {
                    // console.log(data)
                    vm.page = data;
                    vm.unit = vm.page.dpi.data;
                    var temp = $scope.template.pages.page;
                    var i = $scope.template.pageI;

                    if (vm.unit == 'px') {
                        $scope.pageValue.mediabox = data.pageSize;
                        temp[i].editbox = data.editbox;
                        temp[i].editboxes = {
                            editbox:data.editboxs
                        };
                        temp[i].mediabox.width = data.pageSize.width;
                        temp[i].mediabox.height = data.pageSize.height;
                        temp[i].trimbox.x = data.pageBloodL;
                        temp[i].trimbox.y = data.pageBloodT;
                    }
                    if (vm.unit == 'mm') {
                        $scope.pageValue.mediabox = data.pageSize;
                        temp[i].mediabox.width = MmTurnPx(data.pageSize.width);
                        temp[i].mediabox.height = MmTurnPx(data.pageSize.height);
                        temp[i].trimbox.x = MmTurnPx(data.pageBloodL);
                        temp[i].trimbox.y = MmTurnPx(data.pageBloodT);
                        temp[i].editbox = getGeometry(data.editbox);
                        temp[i].editboxes = {
                            editbox:data.editboxs
                        };
                        temp[i].editboxes.editbox.forEach(function (editbox) {
                            editbox.width = MmTurnPx(editbox.width);
                            editbox.height = MmTurnPx(editbox.height);
                            editbox.x = MmTurnPx(editbox.x);
                            editbox.y = MmTurnPx(editbox.y);
                        })
                    }
                    if (vm.unit == 'in') {
                        $scope.pageValue.mediabox = data.pageSize;
                        temp[i].mediabox.width = InTurnPx(data.pageSize.width);
                        temp[i].mediabox.height = InTurnPx(data.pageSize.height);
                        temp[i].trimbox.x = InTurnPx(data.pageBloodL);
                        temp[i].trimbox.y = InTurnPx(data.pageBloodT);
                        temp[i].editbox = {
                            height: InTurnPx(temp[i].editbox.height),
                            width: InTurnPx(temp[i].editbox.width),
                            x: InTurnPx(temp[i].editbox.x),
                            y: InTurnPx(temp[i].editbox.y)
                        };
                        temp[i].editboxes = {
                            editbox:data.editboxs
                        };
                        temp[i].editboxes.editbox.forEach(function (editbox) {
                            editbox.width = InTurnPx(editbox.width);
                            editbox.height = InTurnPx(editbox.height);
                            editbox.x = InTurnPx(editbox.x);
                            editbox.y = InTurnPx(editbox.y);
                        })
                    }
                    getBloodSize(temp[i],i);
                    setUlWidth();
                    resetBackground();
                    $scope.currentPage = temp[i];
                    // console.log(temp)
                });
        }

        var createModal = function (url, controller, attr) {
            return $uibModal.open({
                templateUrl: url,
                controller: controller,
                backdrop: 'static',
                keyboard: true,
                windowClass: "jh-modal-md",
                controllerAs: 'vm',
                resolve: {
                    pages: {page: vm.page, sizeSet: attr, token: vm.token, domain: vm.url},
                    documentpics: {arr: $scope.template.documentpics.documentpic, showPic: vm.showPic},
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page)
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('page');
                        return $translate.refresh();
                    }]
                }
            });
        };


        //撤销，重做按钮事件
        $scope.rollback = function (forward) {
            var i = $scope.template.pageI;
            if ((!forward && !$scope.pageHistory[i].currentHistoryIndex)) {
                return;
            }

            if (forward) {
                $scope.template.pages.page[i] = {
                    bgImg: '',
                    background: {resource: {}},
                    barcode: {},
                    qrcode: {},
                    scale: 1,
                    levels: {},
                    width: $scope.template.pages.page[i].width,
                    height: $scope.template.pages.page[i].height,
                    spread: $scope.template.pages.page[i].spread,
                    backup: $scope.template.pages.page[i].backup,
                    unreplace: $scope.template.pages.page[i].unreplace,
                    editbox: getGeometry($scope.template.pages.page[i].editbox),
                    editboxM: angular.copy($scope.template.pages.page[i].editboxM),
                    blood: angular.copy($scope.template.pages.page[i].blood),
                    bloodPx: angular.copy($scope.template.pages.page[i].bloodPx),
                    isScene: $scope.template.pages.page[i].isScene,
                    seq: $scope.template.pages.page[i].seq,
                    trimbox: $scope.template.pages.page[i].trimbox,
                    mediabox: $scope.template.pages.page[i].mediabox,
                    uuid: $scope.template.pages.page[i].uuid,
                    pagecover: $scope.template.pages.page[i].pagecover,
                    hasBgImg: false,
                    unit: 'mm'
                };
            } else {
                $scope.pageHistory[i].currentHistoryIndex = $scope.pageHistory[i].currentHistoryIndex - 1;
                $scope.pageHistory[i].history.pop();
                $scope.template.pages.page[i] = angular.copy($scope.pageHistory[i].history[$scope.pageHistory[i].currentHistoryIndex]);
            }
            $scope.RightPanel = 'page';
            $scope.currentPage = $scope.template.pages.page[i];
            vm.unit = 'mm';
            $scope.pageValue.mediabox = {
                width: unitTransformPx($scope.currentPage.mediabox.width),
                height: unitTransformPx($scope.currentPage.mediabox.height)
            }
            setOriginalWaH($scope.currentPage.trimbox.width, $scope.currentPage.trimbox.height, i);
            setUlWidth();
            angular.forEach($scope.template.pages.page, function (item, index) {
                if (!item.bgImg) {
                    $('#bgImg' + index).attr('src', '');            //添加src
                }
            });

            $scope.clearCtrlKey();
        };
        // 阴影设置
        vm.isShadowSet = false;
        $scope.shadowSet = function(attr){
            toolbarStatus();
            vm.isShadowSet = attr;
        }
        // 透明度
        $scope.transparencySelect = function (attr) {
            toolbarStatus();
            var current = $scope.selectBox.current;
            if (current == 'imageart' || current == 'textbox' || current == 'imagebox') {
                vm.isTransp = attr;
            }
            $scope.template.transparency = $scope.selectBox.transparency * 100;
            $(elem).val($scope.selectBox.transparency);
        }

        $scope.coverageSelect = function (attr) {
            toolbarStatus();
            var current = $scope.selectBox.current;
            if (current != 'page') {
                vm.isCoverage = attr;
            }
        }

        /**
         * 图层
         * @param attr----up,down,top,bottom
         */
        $scope.coverageMove = function (attr) {
            var levels = $scope.currentPage.levels.level;
            if (levels.length == 1) {
                return
            }

            var levelI = $scope.template.levelI;
            // 上移一层
            if (attr == 'up') {
                if (levelI == levels.length - 1) {
                    MessageService.error("已在最上层")
                    return
                }
                var seq = levels[levelI].seq;
                levels[levelI].seq = levels[levelI + 1].seq;
                levels[levelI + 1].seq = seq;
            }

            // 下移一层
            if (attr == 'down') {
                if (levelI == 0) {
                    MessageService.error("已在最下层");
                    return
                }
                var seq = levels[levelI].seq;
                levels[levelI].seq = levels[levelI - 1].seq;
                levels[levelI - 1].seq = seq;
            }

            // 置顶
            if (attr == 'top') {
                if (levelI == levels.length - 1) {
                    MessageService.error("已在最上层")
                    return
                }
                var seq = levels[levelI].seq;
                levels[levelI].seq = levels[levels.length - 1].seq;

                for (var i = levelI + 1; i < levels.length; i++) {
                    var item = levels[i];
                    item.seq = i;
                }
            }

            // 置底
            if (attr == 'bottom') {
                if (levelI == 0) {
                    MessageService.error("已在最下层");
                    return
                }
                var seq = levels[levelI].seq;
                levels[levelI].seq = levels[0].seq;

                for (var i = 0; i < levelI; i++) {
                    var item = levels[i];
                    item.seq += 1;
                }
            }

            $scope.template.levelI = levels[levelI].seq - 1;
            levels.sort(compare('seq', true));
        }

        // 锁定
        $scope.locking = function () {
            // 当前页所有占位框
            var currentImages = $scope.currentPage.levels.level[$scope.template.levelI].imagebox;
            // 当前页所有文本
            var currentTexts = $scope.currentPage.levels.level[$scope.template.levelI].textbox;
            // 当前页所有素材
            var currentArts = $scope.currentPage.levels.level[$scope.template.levelI].imageart;
            var all = getAllCtrlKeyArray(1);

            var len = all.length;
            // 单选状态
            if (!len) {
                $scope.selectBox.lock = !$scope.selectBox.lock;
            } else {
                // ctrl+点击
                for (var i = 0; i < len; i++) {
                    if (all[i].current == 'imagebox') {
                        // currentImages[all[i].index] = all[i];
                        currentImages[all[i].index].lock = !currentImages[all[i].index].lock;
                    } else if (all[i].current == 'textbox') {
                        // currentTexts[all[i].index] = all[i];
                        currentTexts[all[i].index].lock = !currentTexts[all[i].index].lock;
                    } else {
                        // currentArts[all[i].index] = all[i];
                        currentArts[all[i].index].lock = !currentArts[all[i].index].lock;
                    }
                }
            }
            updateHistorys();
        }

        // 删除
        $scope.deleteBox = function () {
            var all = getAllCtrlKeyArray(1);
            var len = all.length;
            if ($scope.selectBox.current == 'barcode') {
                if ($scope.currentPage.barcode.lock) {
                    return
                }
                $scope.currentPage.barcode = {};
                return
            }
            if ($scope.selectBox.current == 'qrcode') {
                if ($scope.currentPage.qrcode.lock) {
                    return
                }
                $scope.currentPage.qrcode = {};
                return
            }
            var levels = $scope.currentPage.levels;
            var level = levels.level[$scope.template.levelI];
            // 单选状态
            if (!len) {
                if ($scope.selectBox == undefined || $scope.selectBox.current == 'page') {
                    $scope.deleteBgImg();
                    return
                }
                if ($scope.selectBox.current == 'imagebox') {
                    if (level.imagebox.lock) {
                        return
                    }
                }
                if ($scope.selectBox.current == 'textbox') {
                    if (level.textbox.lock) {
                        return
                    }
                }
                if ($scope.selectBox.current == 'imageart') {
                    if (level.imageart.lock) {
                        return
                    }
                }
                if ($scope.selectBox.current == 'textdocument') {
                    if (level.textdocument.lock) {
                        return
                    }
                }
                levels.level.splice($scope.template.levelI, 1);

            } else {
                // ctrl+点击
                for (var i = len - 1; i >= 0; i--) {
                    if (!all[i]) {
                        continue;
                    }
                    if (all[i].current == 'barcode') {
                        $scope.currentPage.barcode = {};

                    } else if (all[i].current == 'qrcode') {
                        $scope.currentPage.qrcode = {};

                    } else {
                        levels.level.splice(all[i].levelI, 1);
                    }
                }
                $scope.clearCtrlKey();
            }

            for (var x = 0; x < levels.level.length; x++) {
                var l = levels.level[x];
                if (l.imagebox && l.imagebox.current) {
                    l.imagebox.levelI = x;
                }
                if (l.imageart && l.imageart.current) {
                    l.imageart.levelI = x;
                }
                if (l.textbox && l.textbox.current) {
                    l.textbox.levelI = x;
                }
                if (l.textdocument && l.textdocument.current) {
                    l.textdocument.levelI = x;
                }
                l.seq = x + 1;
            }

            $scope.RightPanel = 'page';
            $scope.selectBox = {};
            getPagePx();
            getImageboxLen();
            updateHistorys();
        };


        vm.watchSure = false;
        $scope.watchArticle = function (){

            var template = angular.copy($scope.template);
            var arr = getTemplate(template);
            // console.log(vm.previewArticle)
            // console.log(vm.page)
            if(modelType && modelType === 'THREE'){
                vm.threeView = true;
                vm.threeTemplate = arr.template;
                // vm.threeXmlId = xml.data.id;
                vm.threeProductXmlData = {
                    modelData:modelData,
                    modelPath:modelPath,
                };
            }else{
                vm.previewArticle = arr.template;
                vm.watchSure = true;
            }
            // console.log(vm.previewArticle)

            // var template = angular.copy($scope.template);
            // var arr = getTemplate(template);
            // // console.log(vm.previewArticle)
            // console.log(vm.page)
            // if(vm.page.modelType && vm.page.modelType === 'THREE'){
            //     vm.threeView = true;
            //     vm.threeTemplate = arr.template;
            //     vm.threeProductXmlData = {
            //         modelData:vm.page.modelData,
            //         modelPath:vm.page.modelPath,
            //     };
            // }else{
            //     vm.previewArticle = arr.template;
            //     vm.watchSure = true;
            // }
        }

        $scope.savePage = function (attr) {
            vm.isSaving = true;
            $scope.isHasGeometry = true;
            var template = angular.copy($scope.template);

            var arr = getTemplate(template);
            template = arr.template;
            var tipArr = arr.tipArr;
            // console.log($scope.template)
            // console.log(tipArr)
            // console.log(template)
            if(tipArr.length){
                var str = tipArr.join(',')
                MessageService.error("第"+str+"页需要设置为不可替换！");
                vm.isSaving = false;
                return
            }

            var _variableRepeat = isRepeat(arr.variableData)
            if(_variableRepeat){
                MessageService.error("可变数据不可重复");
                vm.isSaving = false;
                return
            }

            var i = $scope.template.pageI;
            var nodes = document.getElementsByClassName('page-item2');
            html2canvas_adapt(nodes[0], {
                onrendered: function (canvas) {
                    var url = canvas.toDataURL("image/png");
                    var blob = dataURLtoBlob(url);
                    var formData = new FormData();
                    formData.append('file', blob);
                    formData.append('key', 'cover-' + UidService.get());
                    formData.append('token', vm.token);
                    $.ajax({
                        cache: true,
                        type: "POST",
                        url: 'https://upload.qiniup.com/',
                        data: formData,
                        async: false,
                        contentType: false,
                        processData: false,
                        success: function (data) {
                            template.pages.page[i].pagecover = {
                                identifier: vm.url + data.key,
                                provider: 'qiniu'
                            }
                            // console.log(template);
                            if (!$scope.isHasGeometry) {
                                MessageService.error("请输入正确的占位框宽高！");
                                return
                            }
                            ProductXml.thirdXmlSave({
                                document: template,
                                key: $stateParams.key,
                                xmlId: $stateParams.xmlId,
                                version: '2.0'
                            }, success, error);

                            $scope.$digest();
                        },
                        error: function (request) {
                            MessageService.error("文件上传失败");
                        }
                    });
                },
                useCORS: true,
                logging: false
            });
        }

        function isRepeat(arr) {
            var hash = {};
            for (var i in arr) {
                if (hash[arr[i]]){
                    return true;
                }
                hash[arr[i]] = true;
            }
            return false;
        }

        function getTemplate(template, attr) {
            var isSave = true;
            template.bindingtype = vm.page.bindingtype;
            // template.pattern = vm.page.pattern;
            template.cover = angular.copy(vm.page.cover);
            template.replace = vm.page.replace;
            template.version = "2.0";
            template.addpage = vm.page.addpage;
            template.minpage = vm.page.minpage;
            template.maxpage = vm.page.maxpage;
            template.addunit = vm.page.addunit;
            var tipArr = [],variableData=[];
            angular.forEach(template.pages.page, function (item, i) {
                item.centerrotation = true;
                if (item.background) {
                    item.background.offsetx = unitTransformPx($scope.template.pages.page[i].background.offsetx);
                    item.background.offsety = unitTransformPx($scope.template.pages.page[i].background.offsety);
                }
                item.mediabox = {
                    width: unitTransformPx(item.mediabox.width),
                    height: unitTransformPx(item.mediabox.height),
                    x: 0,
                    y: 0
                };
                item.trimbox = {
                    width: unitTransformPx(item.trimbox.width),
                    height: unitTransformPx(item.trimbox.height),
                    x: unitTransformPx(item.trimbox.x),
                    y: unitTransformPx(item.trimbox.y)
                };

                item.editbox = {
                    width: unitTransformPx(item.editbox.width),
                    height: unitTransformPx(item.editbox.height),
                    x: unitTransformPx(item.editbox.x),
                    y: unitTransformPx(item.editbox.y)
                };
                if(item.editboxes && item.editboxes.editbox){
                    item.editboxes.editbox.forEach(function (editbox) {
                        editbox.width= PxTurnMm(editbox.width);
                        editbox.height= PxTurnMm(editbox.height);
                        editbox.x= PxTurnMm(editbox.x);
                        editbox.y= PxTurnMm(editbox.y);
                    })
                }
                if (item.scene) {
                    item.scene.resource = {
                        provider: 'qiniu',
                        identifier: item.scene.background.resource.identifier
                    }
                    item.scene.geometry = {
                        width: unitTransformPx(item.scene.geometry.width),
                        height: unitTransformPx(item.scene.geometry.height),
                        x: unitTransformPx(item.scene.geometry.x),
                        y: unitTransformPx(item.scene.geometry.y)
                    };
                    if (item.scene.imagebox) {
                        item.scene.imagebox.geometry = {
                            width: unitTransformPx(item.scene.imagebox.geometry.width),
                            height: unitTransformPx(item.scene.imagebox.geometry.height),
                            x: unitTransformPx(item.scene.imagebox.geometry.x),
                            y: unitTransformPx(item.scene.imagebox.geometry.y)
                        };
                        item.scene.imagebox.rotation = {
                            angle: item.scene.imagebox.rotation.angle
                        };
                    }
                    item.scene.hierarchy = item.scene.hierarchy;
                }

                if (item.barcode && item.barcode.geometry
                    && item.barcode.geometry.width > 0.01 && item.barcode.geometry.height > 0.01) {
                    item.barcode = {
                        geometry: {
                            width: unitTransformPx(item.barcode.geometry.width),
                            height: unitTransformPx(item.barcode.geometry.height),
                            x: unitTransformPx(item.barcode.geometry.x),
                            y: unitTransformPx(item.barcode.geometry.y)
                        },
                        rotation: angular.copy(item.barcode.rotation),
                    };
                    if (!item.unreplace) {
                        tipArr.push(i + 1);
                    }
                } else {
                    item.barcode = null;
                }
                if (item.qrcode && item.qrcode.geometry
                    && item.qrcode.geometry.width > 0.01 && item.qrcode.geometry.height > 0.01) {
                    item.qrcode = {
                        geometry: {
                            width: unitTransformPx(item.qrcode.geometry.width),
                            height: unitTransformPx(item.qrcode.geometry.height),
                            x: unitTransformPx(item.qrcode.geometry.x),
                            y: unitTransformPx(item.qrcode.geometry.y)
                        },
                        rotation: angular.copy(item.qrcode.rotation),
                    };
                    if (!item.unreplace) {
                        tipArr.push(i + 1);
                    }
                } else {
                    item.qrcode = null;
                }

                angular.forEach(item.levels.level, function (level, l) {
                    if(level.variable){
                        variableData.push(level.name)
                    }
                    if (level.imageart && level.imageart.current) {
                        var art = level.imageart;
                        art.geometry = {
                            width: unitTransformPx(art.geometry.width),
                            height: unitTransformPx(art.geometry.height),
                            x: unitTransformPx(art.geometry.x),
                            y: unitTransformPx(art.geometry.y)
                        };
                        art.offsetx = unitTransformPx(art.offsetx);
                        art.offsety = unitTransformPx(art.offsety);
                        art.rotation.angle = -art.rotation.angle;
                    }
                    if (level.imagebox && level.imagebox.current) {
                        var img = level.imagebox;
                        if (img.geometry.width <= 1 || img.geometry.height <= 1) {
                            $scope.isHasGeometry = false;
                        }
                        ;
                        img.geometry = {
                            width: unitTransformPx(img.geometry.width),
                            height: unitTransformPx(img.geometry.height),
                            x: unitTransformPx(img.geometry.x),
                            y: unitTransformPx(img.geometry.y)
                        };

                        if (img.image) {
                            img.image = {
                                offsetx: unitTransformPx(img.image.offsetx),
                                offsety: unitTransformPx(img.image.offsety),
                                scale: img.image.scale,
                                angle: img.image.angle,
                                resource: {
                                    identifier: img.image.resource ? img.image.resource.identifier : '',
                                    provider: img.image.resource ? img.image.resource.provider : ''
                                },
                                resourceid: img.image.resourceid
                            }
                        }
                        if (attr == 2) {
                            if (!img.image || img.image.resource.identifier == "")
                                isSave = false;
                        }
                    }
                    if (level.textbox && level.textbox.current) {
                        var text = level.textbox;
                        if (text.text == '') {
                            level.textbox = null;
                        } else {
                            text.geometry = {
                                width: unitTransformPx(text.geometry.width),
                                height: unitTransformPx(text.geometry.height),
                                x: unitTransformPx(text.geometry.x),
                                y: unitTransformPx(text.geometry.y)
                            }
                            text.rotation.angle = -text.rotation.angle;
                        }
                    }
                    if (level.textdocument && level.textdocument.current) {
                        var textdocument = level.textdocument;
                        textdocument.background.offsetx = unitTransformPx(textdocument.background.offsetx);
                        textdocument.background.offsety = unitTransformPx(textdocument.background.offsety);
                        textdocument.geometry = {
                            width: unitTransformPx(textdocument.geometry.width),
                            height: unitTransformPx(textdocument.geometry.height),
                            x: unitTransformPx(textdocument.geometry.x),
                            y: unitTransformPx(textdocument.geometry.y)
                        }
                        angular.forEach(textdocument.levels.level, function (l) {
                            if (l.imageart) {
                                var imageart = l.imageart;
                                imageart.geometry = {
                                    width: unitTransformPx(imageart.geometry.width),
                                    height: unitTransformPx(imageart.geometry.height),
                                    x: unitTransformPx(imageart.geometry.x),
                                    y: unitTransformPx(imageart.geometry.y)
                                };
                                imageart.offsetx = unitTransformPx(imageart.offsetx);
                                imageart.offsety = unitTransformPx(imageart.offsety);
                                imageart.rotation.angle = -imageart.rotation.angle;
                            }
                            if (l.textbox) {
                                if (l.textbox.text == '') {
                                    l.textbox = null;
                                } else {
                                    l.textbox.geometry = {
                                        width: unitTransformPx(l.textbox.geometry.width),
                                        height: unitTransformPx(l.textbox.geometry.height),
                                        x: unitTransformPx(l.textbox.geometry.x),
                                        y: unitTransformPx(l.textbox.geometry.y)
                                    }
                                    l.textbox.rotation.angle = -l.textbox.rotation.angle;
                                }
                            }
                        })
                    }
                })
            });

            if($scope.template.deletedPages&&$scope.template.deletedPages.page&&$scope.template.deletedPages.page.length){
                pageToMM(template.deletedPages.page,$scope.template.deletedPages);
            }
            return {
                tipArr: tipArr,
                template: template,
                isSave: isSave,
                variableData: variableData
            }
        }

        function pageToMM(pages,tempPages) {
            angular.forEach(pages, function (item, i) {
                item.centerrotation = true;
                if (item.background) {
                    item.background.offsetx = unitTransformPx(tempPages.page[i].background.offsetx);
                    item.background.offsety = unitTransformPx(tempPages.page[i].background.offsety);
                }
                item.mediabox = {
                    width: unitTransformPx(item.mediabox.width),
                    height: unitTransformPx(item.mediabox.height),
                    x: 0,
                    y: 0
                };
                item.trimbox = {
                    width: unitTransformPx(item.trimbox.width),
                    height: unitTransformPx(item.trimbox.height),
                    x: unitTransformPx(item.trimbox.x),
                    y: unitTransformPx(item.trimbox.y)
                };

                item.editbox = {
                    width: unitTransformPx(item.editbox.width),
                    height: unitTransformPx(item.editbox.height),
                    x: unitTransformPx(item.editbox.x),
                    y: unitTransformPx(item.editbox.y)
                };
                if (item.scene) {
                    item.scene.resource = {
                        provider: 'qiniu',
                        identifier: item.scene.background.resource.identifier
                    }
                    item.scene.geometry = {
                        width: unitTransformPx(item.scene.geometry.width),
                        height: unitTransformPx(item.scene.geometry.height),
                        x: unitTransformPx(item.scene.geometry.x),
                        y: unitTransformPx(item.scene.geometry.y)
                    };
                    if (item.scene.imagebox) {
                        item.scene.imagebox.geometry = {
                            width: unitTransformPx(item.scene.imagebox.geometry.width),
                            height: unitTransformPx(item.scene.imagebox.geometry.height),
                            x: unitTransformPx(item.scene.imagebox.geometry.x),
                            y: unitTransformPx(item.scene.imagebox.geometry.y)
                        };
                        item.scene.imagebox.rotation = {
                            angle: item.scene.imagebox.rotation.angle
                        };
                    }
                    item.scene.hierarchy = item.scene.hierarchy;
                }

                if (item.barcode && item.barcode.geometry) {
                    item.barcode = {
                        geometry: {
                            width: unitTransformPx(item.barcode.geometry.width),
                            height: unitTransformPx(item.barcode.geometry.height),
                            x: unitTransformPx(item.barcode.geometry.x),
                            y: unitTransformPx(item.barcode.geometry.y)
                        },
                        rotation: angular.copy(item.barcode.rotation),
                    };
                } else {
                    item.barcode = null;
                }
                if (item.qrcode && item.qrcode.geometry) {
                    item.qrcode = {
                        geometry: {
                            width: unitTransformPx(item.qrcode.geometry.width),
                            height: unitTransformPx(item.qrcode.geometry.height),
                            x: unitTransformPx(item.qrcode.geometry.x),
                            y: unitTransformPx(item.qrcode.geometry.y)
                        },
                        rotation: angular.copy(item.qrcode.rotation),
                    };
                } else {
                    item.qrcode = null;
                }

                angular.forEach(item.levels.level, function (level, l) {
                    if (level.imageart && level.imageart.current) {
                        var art = level.imageart;
                        art.geometry = {
                            width: unitTransformPx(art.geometry.width),
                            height: unitTransformPx(art.geometry.height),
                            x: unitTransformPx(art.geometry.x),
                            y: unitTransformPx(art.geometry.y)
                        };
                        art.offsetx = unitTransformPx(art.offsetx);
                        art.offsety = unitTransformPx(art.offsety);
                        art.rotation.angle = -art.rotation.angle;
                    }
                    if (level.imagebox && level.imagebox.current) {
                        var img = level.imagebox;
                        if (img.geometry.width <= 1 || img.geometry.height <= 1) {
                            $scope.isHasGeometry = false;
                        }
                        ;
                        img.geometry = {
                            width: unitTransformPx(img.geometry.width),
                            height: unitTransformPx(img.geometry.height),
                            x: unitTransformPx(img.geometry.x),
                            y: unitTransformPx(img.geometry.y)
                        };

                        if (img.image) {
                            img.image = {
                                offsetx: unitTransformPx(img.image.offsetx),
                                offsety: unitTransformPx(img.image.offsety),
                                scale: img.image.scale,
                                angle: img.image.angle,
                                resource: {
                                    identifier: img.image.resource ? img.image.resource.identifier : '',
                                    provider: img.image.resource ? img.image.resource.provider : ''
                                },
                                resourceid: img.image.resourceid
                            }
                        }
                    }
                    if (level.textbox && level.textbox.current) {
                        var text = level.textbox;
                        if (text.text == '') {
                            level.textbox = null;
                        } else {
                            text.geometry = {
                                width: unitTransformPx(text.geometry.width),
                                height: unitTransformPx(text.geometry.height),
                                x: unitTransformPx(text.geometry.x),
                                y: unitTransformPx(text.geometry.y)
                            }
                            text.rotation.angle = -text.rotation.angle;
                        }
                    }
                    if (level.textdocument && level.textdocument.current) {
                        var textdocument = level.textdocument;
                        textdocument.background.offsetx = unitTransformPx(textdocument.background.offsetx);
                        textdocument.background.offsety = unitTransformPx(textdocument.background.offsety);
                        textdocument.geometry = {
                            width: unitTransformPx(textdocument.geometry.width),
                            height: unitTransformPx(textdocument.geometry.height),
                            x: unitTransformPx(textdocument.geometry.x),
                            y: unitTransformPx(textdocument.geometry.y)
                        }
                        angular.forEach(textdocument.levels.level, function (l) {
                            if (l.imageart) {
                                var imageart = l.imageart;
                                imageart.geometry = {
                                    width: unitTransformPx(imageart.geometry.width),
                                    height: unitTransformPx(imageart.geometry.height),
                                    x: unitTransformPx(imageart.geometry.x),
                                    y: unitTransformPx(imageart.geometry.y)
                                };
                                imageart.offsetx = unitTransformPx(imageart.offsetx);
                                imageart.offsety = unitTransformPx(imageart.offsety);
                                imageart.rotation.angle = -imageart.rotation.angle;
                            }
                            if (l.textbox) {
                                if (l.textbox.text == '') {
                                    l.textbox = null;
                                } else {
                                    l.textbox.geometry = {
                                        width: unitTransformPx(l.textbox.geometry.width),
                                        height: unitTransformPx(l.textbox.geometry.height),
                                        x: unitTransformPx(l.textbox.geometry.x),
                                        y: unitTransformPx(l.textbox.geometry.y)
                                    }
                                    l.textbox.rotation.angle = -l.textbox.rotation.angle;
                                }
                            }
                        })
                    }
                })
            });
        }

        function loadPageToPx(templatePage, pageIndex, callback) {
            if (templatePage.loaded) {
                return;
            }
            if (templatePage.background && templatePage.background.resource && templatePage.background.resource.identifier) {
                var background = templatePage.background;
                var pageW = templatePage.mediabox.width,
                    pageH = templatePage.mediabox.height;
                if (background.resource && background.resource.identifier) {
                    getBackgroundSource(background.resource, pageW, pageH, background)
                }
            }
            var promise_list = [];
            if (templatePage.levels && templatePage.levels.level) {
                angular.forEach(templatePage.levels.level, function (level, n) {
                    if (level.imageart && level.imageart.geometry) {
                        var deferred = $q.defer();
                        var art = level.imageart;
                        $http({url: art.resource.identifier + '?imageInfo'}).success(function (data) {
                            templatePage.levels.level[n].imageart = {
                                geometry: art.geometry,
                                rotation: {
                                    angle: art.rotation.angle
                                },
                                type: art.type,
                                resource: {
                                    identifier: art.resource.identifier,
                                    provider: art.resource.provider,
                                    width: data.width,
                                    height: data.height
                                },
                                scale: art.scale,
                                offsetx: art.offsetx,
                                offsety: art.offsety,
                                unit: 'mm',
                                current: 'imageart',
                                levelI: n,
                                pageI: pageIndex,
                                lock: art.lock,
                                ctrlKey: false,
                                transparency: art.transparency,
                                onlyshow: art.onlyshow,
                                movable: art.movable,
                                editable: art.editable,
                            }
                            deferred.resolve("ok");
                        }).error(function (error) {
                            MessageService.error("获取图片信息失败");
                            deferred.resolve("error");
                        });
                        promise_list.push(deferred.promise);
                    }
                    if (level.imagebox && level.imagebox.geometry) {
                        var image = level.imagebox;
                        if (image.shadow == null) {
                            image.shadow = {
                                color:'#777777',
                                x:0,
                                y:0,
                                blur:0
                            }
                        }
                        if (image.border == null) {
                            image.border = {
                                shape: 'Rectangle',
                                radius: {
                                    lt: 0,
                                    rt: 0,
                                    rb: 0,
                                    lb: 0,
                                    all:0
                                },
                                "edge": {
                                    top: 0,
                                    right: 0,
                                    bottom: 0,
                                    left: 0
                                },
                                lineWidth: 0,
                                type: "Color",
                                lineType:"solid",
                                resource: {
                                    "identifier": ''
                                },
                                color: '#000000',
                            }
                        }
                        templatePage.levels.level[n].imagebox = {
                            geometry: image.geometry,
                            rotation: angular.copy(image.rotation),
                            mask: angular.copy(image.mask),
                            image: angular.copy(image.image),
                            maskUrl: 'content/images/mask_souce.png',
                            imgUrl: 'content/images/mask_souce.png',
                            unit: 'mm',
                            current: 'imagebox',
                            levelI: n,
                            pageI: pageIndex,
                            lock: image.lock,
                            border: image.border,
                            shadow: image.shadow,
                            ctrlKey: false,
                            transparency: isNaN(image.transparency) ? 1 : image.transparency
                        }


                        if (image.image && image.image.resource && image.image.resource.identifier) {       //qiniu
                            templatePage.levels.level[n].imagebox.image = {
                                resource: {
                                    identifier: image.image ? image.image.resource.identifier : '',
                                    provider: image.image ? image.image.resource.provider : 'qiniu'
                                },
                                imgSize: (!image.image) || image.image.imgSize == null ? '' : image.image.imgSize,
                                parameter: (!image.image) || image.image.parameter == null ? [] : angular.fromJson(image.image.parameter),
                                filter: (!image.image) || image.image.filter == null ? '' : image.image.filter,
                                offsetx: (!image.image) || image.image.offsetx == null ? 0 : image.image.offsetx,
                                offsety: (!image.image) || image.image.offsety == null ? 0 : image.image.offsety,
                                angle: image.image && image.image.angle ? image.image.angle : 0,
                                scale: (!image.image) || image.image.scale == 1 ? 1 : image.image.scale,
                                index: (!image.image) ? '' : image.image.index,
                                resourceid: (!image.image) ? '' : image.image.resourceid,
                            }
                            templatePage.levels.level[n].imagebox.imgUrl = image.image.resource.identifier + '?imageMogr2/auto-orient/thumbnail/!40p';
                            if (image.image.angle != 0) {
                                templatePage.levels.level[n].imagebox.imgUrl += '/rotate/' + image.image.angle
                            }
                            var promise = getBackgroundSource1(templatePage.levels.level[n].imagebox.image.resource, templatePage.levels.level[n].imagebox.geometry.width, templatePage.levels.level[n].imagebox.geometry.height, templatePage.levels.level[n].imagebox.image)
                            if (promise) {
                                promise_list.push(promise);
                            }
                        } else {
                            var deferred = $q.defer();
                            var imagecanvas = document.createElement('canvas');
                            var imagecontext = imagecanvas.getContext('2d');
                            var newImg = document.createElement('img');
                            newImg.crossOrigin = "Anonymous";
                            newImg.src = 'content/images/mask_souce.png';
                            newImg.onload = function () {
                                newImg.onload = null;
                                var width = newImg.width;
                                var height = newImg.height;
                                if (image.mask && image.mask.resource && image.mask.resource.identifier) {
                                    var masks = document.createElement('img');
                                    masks.crossOrigin = "anonymous";
                                    masks.onload = function () {
                                        masks.onload = null;
                                        imagecanvas.width = width;
                                        imagecanvas.height = height;
                                        imagecontext.drawImage(masks, 0, 0, width, height);
                                        imagecontext.globalCompositeOperation = 'source-in';
                                        imagecontext.drawImage(newImg, 0, 0);
                                        templatePage.levels.level[n].imagebox.bgImg = ImageService.dataURLtoBlob(imagecanvas.toDataURL());
                                        $scope.$apply();
                                    };
                                    masks.src = image.mask.resource.identifier;
                                }
                                deferred.resolve("ready");
                            };
                            newImg.src = 'content/images/mask_souce.png';
                            promise_list.push(deferred.promise);
                        }
                        if (templatePage.levels.level[n].imagebox.mask && templatePage.levels.level[n].imagebox.mask.resource && templatePage.levels.level[n].imagebox.mask.resource.identifier) {
                            // imageboxResourceCanvas(templatePage.levels.level[n].imagebox);
                            var deferred = $q.defer();
                            if (templatePage.levels.level[n].imagebox.image && templatePage.levels.level[n].imagebox.image.resource.identifier) {
                                imageboxResourceCanvas(templatePage.levels.level[n].imagebox, function() {
                                    deferred.resolve("ready");
                                });
                            } else {
                                maskScale(null, templatePage.levels.level[n].imagebox, n, templatePage.levels.level[n].imagebox.mask.resource.identifier, function() {
                                    deferred.resolve("ready");
                                });
                            }
                            promise_list.push(deferred.promise);
                        }
                    }
                    if (level.textbox && level.textbox.geometry) {
                        var text = level.textbox;
                        templatePage.levels.level[n].textbox = {
                            geometry: text.geometry,
                            identifier: text.identifier,
                            rotation: {
                                angle: text.rotation.angle
                            },
                            angle: angular.copy(text.angle),
                            status: angular.copy(text.status),
                            style: angular.copy(text.style),
                            type: angular.copy(text.type),
                            text: angular.copy(text.text),
                            version: text.version,
                            unit: 'mm',
                            current: 'textbox',
                            levelI: n,
                            pageI: pageIndex,
                            lock: text.lock,
                            ctrlKey: false,
                            transparency: text.transparency,
                            lineheight: text.style.lineheight,
                            letterspacing: text.style.letterspacing,
                            scale: 1,
                            movable: text.movable,
                            editable: text.editable,
                            fontuuid: text.fontuuid
                        }
                        if (text.fontuuid) {
                            //下载字体
                            var deferred = $q.defer();
                            getFont(templatePage.levels.level[n].textbox,FontManagement, function() {
                                deferred.resolve("ready");
                            });
                            promise_list.push(deferred.promise);
                        }
                    }
                    if (level.textdocument && level.textdocument.geometry) {
                        var textdocument = level.textdocument;
                        templatePage.levels.level[n].textdocument = {
                            background: textdocument.background,
                            geometry: textdocument.geometry,
                            rotation: {
                                angle: textdocument.rotation.angle || 0
                            },
                            unit: 'mm',
                            current: 'textdocument',
                            levels: angular.copy(textdocument.levels),
                            levelI: n,
                            pageI: pageIndex,
                            lock: textdocument.lock,
                            ctrlKey: false,
                            transparency: textdocument.transparency,
                            movable: textdocument.movable,
                            editable: textdocument.editable,
                            scale: textdocument.geometry.width / templatePage.mediabox.width
                        }

                        var backg = templatePage.levels.level[n].textdocument.background;
                        var pageW = templatePage.levels.level[n].textdocument.geometry.width,
                            pageH = templatePage.levels.level[n].textdocument.geometry.height;
                        if (backg.resource && backg.resource.identifier) {
                            var promise = getBackgroundSource(backg.resource, pageW, pageH, backg);
                            if (promise) {
                                promise_list.push(promise);
                            }
                        }

                        angular.forEach(textdocument.levels.level, function (lev, l) {
                            if (lev.imageart && lev.imageart.geometry) {
                                var deferred = $q.defer();
                                var art = lev.imageart;
                                $http({url: art.resource.identifier + '?imageInfo'}).success(function (data) {
                                    templatePage.levels.level[n].textdocument.levels.level[l].imageart = {
                                        geometry: art.geometry,
                                        rotation: {
                                            angle: art.rotation.angle
                                        },
                                        type: art.type,
                                        resource: {
                                            identifier: art.resource.identifier,
                                            provider: art.resource.provider,
                                            width: data.width,
                                            height: data.height
                                        },
                                        scale: art.scale,
                                        offsetx: art.offsetx,
                                        offsety: art.offsety,
                                        unit: 'mm',
                                        current: 'imageart',
                                        levelI: n,
                                        pageI: pageIndex,
                                        lock: false,
                                        transparency: art.transparency,
                                        onlyshow: art.onlyshow,
                                        movable: art.movable,
                                        editable: art.editable,
                                    }
                                    deferred.resolve("ready");
                                }).error(function (error) {
                                    MessageService.error("获取图片信息失败");
                                    deferred.resolve("error");
                                });
                                promise_list.push(deferred.promise);
                            }
                            if (lev.textbox && lev.textbox.geometry) {
                                var text = lev.textbox;
                                templatePage.levels.level[n].textdocument.levels.level[l].textbox = {
                                    geometry: text.geometry,
                                    identifier: text.identifier,
                                    rotation: {
                                        angle: text.rotation.angle
                                    },
                                    angle: angular.copy(text.angle),
                                    status: angular.copy(text.status),
                                    style: angular.copy(text.style),
                                    type: angular.copy(text.type),
                                    text: angular.copy(text.text),
                                    unit: 'mm',
                                    current: 'textbox',
                                    levelI: n,
                                    pageI: pageIndex,
                                    lock: false,
                                    transparency: text.transparency,
                                    lineheight: text.style.lineheight,
                                    letterspacing: text.style.letterspacing,
                                    fontuuid: text.fontuuid
                                }
                                //下载字体
                                if (text.fontuuid) {
                                    var deferred = $q.defer();
                                    getFont(text,FontManagement, function() {
                                        deferred.resolve("ready");
                                    });
                                    fontStyle(text);
                                    promise_list.push(deferred);
                                }
                            }
                        })
                    }
                });
            }

            if (callback) {
                if (promise_list.length == 0) {
                    callback();
                } else {
                    $q.all(promise_list).then(function(res) {
                        callback(res);
                    });
                }
            }

            templatePage.loaded = true;
        }

        function pagesToPx(pages,tempPages,flag) {
            var seq = 0;
            angular.forEach(pages, function (page, i) {
                if (!page.editbox) {
                    page.editbox = angular.copy(page.trimbox);
                }
                if(!page.backup){
                    seq++ ;
                }
                tempPages.page[i] = {
                    isScene: false,
                    seq: seq,
                    width: unitTransform(page.trimbox.width),
                    height: unitTransform(page.trimbox.height),
                    trimbox: getGeometry(page.trimbox),
                    mediabox: getGeometry(page.mediabox),
                    editbox: getGeometry(page.editbox),
                    editboxM: angular.copy(page.editbox),
                    editboxes: angular.copy(page.editboxes),
                    blood: {
                        top: page.trimbox.y,
                        bottom: page.mediabox.height - page.trimbox.y - page.trimbox.height,
                        left: page.trimbox.x,
                        right: page.mediabox.width - page.trimbox.x - page.trimbox.width,
                    },
                    bloodPx: {
                        top: unitTransform(page.trimbox.y),
                        bottom: unitTransform(page.mediabox.height - page.trimbox.y - page.trimbox.height),
                        left: unitTransform(page.trimbox.x),
                        right: unitTransform(page.mediabox.width - page.trimbox.x - page.trimbox.width),
                    },
                    spread: page.spread,
                    backup: page.backup,
                    type: page.type,
                    unreplace: page.unreplace || false,
                    scale: 1,
                    barcode: {},
                    qrcode: {},
                    uuid: page.uuid,
                    background: angular.copy(page.background),
                    pagecover: {
                        identifier: page.pagecover && page.pagecover.identifier ? page.pagecover.identifier : '',
                        provider: page.pagecover && page.pagecover.provider ? page.pagecover.provider : '',
                    },
                    hasBgImg: page.background && page.background.resource.identifier ? true : false,
                    bgImg: page.background.resource.identifier ? vm.url + page.background.resource.identifier + '?imageMogr2/interlace/1' : '',
                    levels: angular.copy(page.levels),
                    unit: 'mm'
                };
                tempPages.page[i].editboxes.editbox.forEach(function (editbox, index) {
                    tempPages.page[i].editboxes.editbox[index] = getGeometry(editbox);
                })
                if (page.scene) {
                    tempPages.page[i].scene = {
                        background: {
                            resource: {
                                provider: page.scene.resource.provider,
                                identifier: page.scene.resource.identifier
                            }
                        },
                        geometry: getGeometry(page.scene.geometry),
                        imagebox: {
                            geometry: getGeometry(page.scene.imagebox.geometry),
                            rotation: {angle: page.scene.imagebox.rotation.angle}
                        },
                        isScene: true,
                        scale: 1,
                        unit: 'mm',
                        hierarchy: page.scene.hierarchy,
                    }
                    tempPages.page[i].scene.isScene = true;
                    var w = tempPages.page[i].scene.geometry.width;
                    var h = tempPages.page[i].scene.geometry.height;
                    var originalScale = $con.width() * 0.8 / ($con.height() * 0.8);
                    if (originalScale < page.scene.geometry.width / page.scene.geometry.height) {
                        //宽定，高不定
                        tempPages.page[i].scene.width = $con.width() * 0.8;
                        tempPages.page[i].scene.height = $con.width() * 0.8 * h / w;
                    } else {

                        //高定，宽不动
                        tempPages.page[i].scene.height = $con.height() * 0.8;
                        tempPages.page[i].scene.width = $con.height() * 0.8 * w / h
                    }
                    tempPages.page[i].scene.proportion = (w / tempPages.page[i].scene.width);
                    var wah = ThreeHundredDpi(page.scene.geometry.width, page.scene.geometry.height);
                    tempPages.page[i].scene.widthPx = wah.px1;
                    tempPages.page[i].scene.heightPx = wah.px2;
                    if (vm.windowH / h >= vm.windowW / w) {
                        tempPages.page[i].scene.ratio = vm.windowW / w * 0.8;
                    } else {
                        tempPages.page[i].scene.ratio = vm.windowH / h * 0.8;
                    }
                    if (vm.windowH1 / h >= vm.windowW1 / w) {
                        tempPages.page[i].scene.ratio1 = vm.windowW1 / w;
                    } else {
                        tempPages.page[i].scene.ratio1 = vm.windowH1 / h;
                    }
                }
                if (tempPages.page[i].uuid == null) {
                    tempPages.page[i].uuid = UidService.get();
                }

                if (page.barcode&&page.barcode.geometry) {
                    var barcode = page.barcode.geometry;
                    var angle = 0;
                    if (page.barcode.rotation && page.barcode.rotation.angle) {
                        angle = page.barcode.rotation.angle
                    }
                    tempPages.page[i].barcode = {
                        current: 'barcode',
                        geometry: {
                            width: unitTransform(barcode.width),
                            height: unitTransform(barcode.height),
                            x: unitTransform(barcode.x),
                            y: unitTransform(barcode.y),
                        },
                        rotation: {
                            angle: angle
                        },
                        lock: false
                    }
                }
                if (page.qrcode&&page.qrcode.geometry) {
                    var qrcode = page.qrcode.geometry;
                    var angle = 0;
                    if (page.qrcode.rotation && page.qrcode.rotation.angle) {
                        angle = page.qrcode.rotation.angle
                    }
                    tempPages.page[i].qrcode = {
                        current: 'qrcode',
                        geometry: {
                            width: unitTransform(qrcode.width),
                            height: unitTransform(qrcode.height),
                            x: unitTransform(qrcode.x),
                            y: unitTransform(qrcode.y),
                        },
                        rotation: {
                            angle: angle
                        },
                        lock: false
                    }
                }
                angular.forEach(tempPages.page[i].levels.level, function (level, l) {
                    if (level.imageart && level.imageart.geometry) {
                        var art = level.imageart;
                        art.current = 'imageart';
                        art.geometry = {
                            width: MmTurnPx(art.geometry.width),
                            height: MmTurnPx(art.geometry.height),
                            x: MmTurnPx(art.geometry.x),
                            y: MmTurnPx(art.geometry.y)
                        };
                        art.offsetx = MmTurnPx(art.offsetx);
                        art.offsety = MmTurnPx(art.offsety);
                        art.rotation.angle = -art.rotation.angle;
                    }
                    if (level.imagebox && level.imagebox.geometry) {
                        var img = level.imagebox;
                        if (img.geometry.width <= 1 || img.geometry.height <= 1) {
                            $scope.isHasGeometry = false;
                        }
                        img.current = 'imagebox';
                        img.geometry = {
                            width: MmTurnPx(img.geometry.width),
                            height: MmTurnPx(img.geometry.height),
                            x: MmTurnPx(img.geometry.x),
                            y: MmTurnPx(img.geometry.y)
                        };

                        if (img.image) {
                            img.image = {
                                offsetx: MmTurnPx(img.image.offsetx),
                                offsety: MmTurnPx(img.image.offsety),
                                scale: img.image.scale,
                                angle: img.image.angle,
                                resource: {
                                    identifier: img.image.resource ? img.image.resource.identifier : '',
                                    provider: img.image.resource ? img.image.resource.provider : ''
                                },
                                resourceid: img.image.resourceid
                            }
                        }
                    }
                    if (level.textbox && level.textbox.geometry) {
                        var text = level.textbox;
                        if (text.text == '') {
                            level.textbox = null;
                        } else {
                            text.current = 'textbox';
                            text.geometry = {
                                width: MmTurnPx(text.geometry.width),
                                height: MmTurnPx(text.geometry.height),
                                x: MmTurnPx(text.geometry.x),
                                y: MmTurnPx(text.geometry.y)
                            }
                            text.rotation.angle = -text.rotation.angle;
                        }
                    }
                    if (level.textdocument && level.textdocument.geometry) {
                        var textdocument = level.textdocument;
                        textdocument.current = 'textdocument';
                        textdocument.background.offsetx = MmTurnPx(textdocument.background.offsetx);
                        textdocument.background.offsety = MmTurnPx(textdocument.background.offsety);
                        textdocument.geometry = {
                            width: MmTurnPx(textdocument.geometry.width),
                            height: MmTurnPx(textdocument.geometry.height),
                            x: MmTurnPx(textdocument.geometry.x),
                            y: MmTurnPx(textdocument.geometry.y)
                        }
                        angular.forEach(textdocument.levels.level, function (l) {
                            if (l.imageart && l.imageart.geometry) {
                                var imageart = l.imageart;
                                imageart.current = 'imageart';
                                imageart.geometry = {
                                    width: MmTurnPx(imageart.geometry.width),
                                    height: MmTurnPx(imageart.geometry.height),
                                    x: MmTurnPx(imageart.geometry.x),
                                    y: MmTurnPx(imageart.geometry.y)
                                };
                                imageart.offsetx = MmTurnPx(imageart.offsetx);
                                imageart.offsety = MmTurnPx(imageart.offsety);
                                imageart.rotation.angle = -imageart.rotation.angle;
                            }
                            if (l.textbox && l.textbox.geometry) {
                                if (l.textbox.text == '') {
                                    l.textbox = null;
                                } else {
                                    l.textbox.current = 'textbox';
                                    l.textbox.geometry = {
                                        width: MmTurnPx(l.textbox.geometry.width),
                                        height: MmTurnPx(l.textbox.geometry.height),
                                        x: MmTurnPx(l.textbox.geometry.x),
                                        y: MmTurnPx(l.textbox.geometry.y)
                                    }
                                    l.textbox.rotation.angle = -l.textbox.rotation.angle;
                                }
                            }
                        })
                    }
                });

                if (!page.backup) {
                    loadPageToPx(tempPages.page[i], i);
                }

                if(flag&&flag=='pages'){
                    setOriginalWaH(unitTransform(page.trimbox.width), unitTransform(page.trimbox.height), i);
                }
            });
        }

        function success(data) {
            vm.isSaving = false;
            MessageService.success("保存成功！");
            $scope.exitPage();
        }

        function error() {
            vm.isSaving = false;
            MessageService.error("保存失败！");
        }


        function success2(data) {
            vm.isSaving = false;
            MessageService.success("发布成功！");
            $state.go('product-xml', {reload: true})
        }

        function error2() {
            vm.isSaving = false;
            MessageService.error("发布失败！");
        }

        $scope.exitPage = function () {
            var url = vm.thirds.thirdUrl + '/#/product-xml';
            if(productXmlPage!=1){
                url+='?page='+productXmlPage
            }
            window.location.href = url;
        };

        vm.leftShow = true;
        vm.rightShow = true;
        $scope.hidePanel = function (attr) {
            $(".rightPanel").removeClass('rightPanel-big rightPanel-big1 rightPanel-big2 rightPanel-big3');
            $(".page-scale").removeClass('page-scale-39 page-scale-46 page-scale-52');
            if (attr == 1) {
                // 左边菜单栏
                $(".leftPanel-mainContent").toggleClass('hide1');
                vm.leftShow = !vm.leftShow;

            } else {
                // 右菜单栏
                $(".rightPanel-2").toggleClass('hide1');
                vm.rightShow = !vm.rightShow;
                $(".rightPanel-mainContent-toggle").toggleClass('rightPanel-toggle');
                $(".rightPanel-bottom").toggleClass('bottom-100');
            }

            if (vm.leftShow) {
                if (!vm.rightShow) {
                    $(".rightPanel").addClass('rightPanel-big2');
                    $(".page-scale").addClass('page-scale-52');
                }
            } else {
                if (vm.rightShow) {
                    $(".rightPanel").addClass('rightPanel-big3');
                    $(".page-scale").addClass('page-scale-39');
                } else {
                    $(".rightPanel").addClass('rightPanel-big1');
                    $(".page-scale").addClass('page-scale-46');
                }
            }
        }


        //历史纪录
        var updateHistorys = function () {
            $scope.history.push(angular.copy($scope.template));
            if ($scope.history.length > 50) {
                $scope.history.splice($scope.history.length - 4, $scope.history.length - 5)
            }
            $scope.currentHistoryIndex = $scope.history.length - 1;
            $scope.currentPage = $scope.template.pages.page[$scope.template.pageI];

            //每一页的历史记录
            if (!$scope.pageHistory[$scope.template.pageI]) {
                $scope.pageHistory[$scope.template.pageI] = {
                    history: []
                }
            }
            $scope.pageHistory[$scope.template.pageI].history.push(angular.copy($scope.template.pages.page[$scope.template.pageI]));
            if ($scope.pageHistory[$scope.template.pageI].history.length > 50) {
                $scope.pageHistory[$scope.template.pageI].history.splice($scope.pageHistory[$scope.template.pageI].history.length - 4, $scope.pageHistory[$scope.template.pageI].history.length - 5)
            }
            $scope.pageHistory[$scope.template.pageI].currentHistoryIndex = $scope.pageHistory[$scope.template.pageI].history.length - 1;

        };

        //防止事件冒泡，默认事件
        function fn(e) {
            // e = e || window.event;
            // e.cancelBubble = true;
            // e.stopPropagation();
            // e.returnValue = false;
            // e.preventDefault();
            if (e && e.stopPropagation) {
                // 因此它支持W3C的stopPropagation()方法
                e.stopPropagation();
            } else {
                // 否则，我们需要使用IE的方式来取消事件冒泡
                window.event.cancelBubble = true;
            }

            // 阻止默认浏览器动作(W3C)
            if (e && e.preventDefault) {
                e.preventDefault();
            } else {
                // IE中阻止函数器默认动作的方式
                window.event.returnValue = false;
            }
        }

        $scope.showThumbnailPic = function () {
            $scope.thumbnailPic = true;
            $scope.thumbnailType = 'one';
            var i = $scope.template.pageI;
            $scope.currentPage = $scope.template.pages.page[i];
            $scope.lastPage = $scope.template.pages.page[i];

            setTimeout(function () {
                var nodes = document.getElementsByClassName('page-item2');
                setThumbnailPic(nodes[0], $scope.lastPage)
            })
        }

        $scope.showAllThumbnailPic = function () {
            $scope.thumbnailPic = true;
            $scope.thumbnailType = 'all';
            var i = $scope.template.pageI;
            $scope.currentPage = $scope.template.pages.page[i];
            $scope.lastPage = $scope.template.pages.page[i];

            setTimeout(function () {
                var nodes = document.getElementsByClassName('page-item2');
                setThumbnailPic(nodes[0], $scope.lastPage)
            })
            // var nodes = document.getElementsByClassName('pageNode');
            // Qinius.get(function (msg) {
            //     vm.token = msg.token;
            //     angular.forEach($scope.template.pages.page, function (page, i) {
            //         setThumbnailPic(nodes[i], page)
            //     })
            setTimeout(function () {
                swiper();
            }, 1000);
            // });

        }

        function setThumbnailPic(node, page, flag) {
            page.pagecover = null;
            // domtoimage.toBlob(node).then(function (blob) {
            //     var formData = new FormData();
            //     formData.append('file', blob);
            //     formData.append('token', vm.token);
            //     $.ajax({
            //         cache: true,
            //         type: "POST",
            //         url: 'https://upload.qiniup.com/',
            //         data: formData,
            //         async: false,
            //         contentType: false,
            //         processData: false,
            //         success: function (data) {
            //             page.pagecover = {
            //                 identifier: vm.url + data.key,
            //                 provider: 'qiniu'
            //             }
            //             $scope.$digest();
            //         },
            //         error: function (request) {
            //             MessageService.error("文件上传失败");
            //         }
            //     });
            // });

            html2canvas_adapt(node, {
                onrendered: function (canvas) {
                    var url = canvas.toDataURL("image/png");
                    var blob = dataURLtoBlob(url);

                    var formData = new FormData();
                    formData.append('file', blob);
                    formData.append('key', 'cover-' + UidService.get());
                    formData.append('token', vm.token);
                    $.ajax({
                        cache: true,
                        type: "POST",
                        url: 'https://upload.qiniup.com/',
                        data: formData,
                        async: false,
                        contentType: false,
                        processData: false,
                        success: function (data) {
                            page.pagecover = {
                                identifier: vm.url + data.key,
                                provider: 'qiniu'
                            }
                            if(flag&&flag=='cover'){
                                pageAnimate();
                            }

                            if(flag&&flag=='all'){
                                for (var i = 1; i < $scope.template.pages.page.length; i++) {
                                    var page1 = $scope.template.pages.page[i];
                                    page1.pagecover = page.pagecover
                                }
                            }
                            $scope.$digest();
                        },
                        error: function (request) {
                            MessageService.error("文件上传失败");
                        }
                    });
                },
                useCORS: true,
                logging: false
            });
        }

        function dataURLtoBlob(dataurl) {
            var arr = dataurl.split(','), mime = arr[0].match(/:(.*?);/)[1],
                bstr = atob(arr[1]), n = bstr.length, u8arr = new Uint8Array(n);
            while (n--) {
                u8arr[n] = bstr.charCodeAt(n);
            }
            return new Blob([u8arr], {type: mime});
        }

        $scope.modalHide = function () {
            $scope.thumbnailPic = false;
        }

        //swiper
        function swiper() {
            var swiper = new Swiper('.swiper-container', {
                pagination: {
                    el: '.swiper-pagination',
                    type: 'fraction',
                },
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                },
            });
        }

        vm.fullFlag = false;
        $scope.toggleFullScreen = function () {
            if (!vm.fullFlag) {
                //进入全屏
                var de = document.documentElement;
                if (de.requestFullscreen) {
                    de.requestFullscreen();
                } else if (de.mozRequestFullScreen) {
                    de.mozRequestFullScreen();
                } else if (de.webkitRequestFullScreen) {
                    de.webkitRequestFullScreen();
                }
                vm.fullFlag = true;
            } else {
                //退出全屏
                var de = document;
                if (de.exitFullscreen) {
                    de.exitFullscreen();
                } else if (de.mozCancelFullScreen) {
                    de.mozCancelFullScreen();
                } else if (de.webkitCancelFullScreen) {
                    de.webkitCancelFullScreen();
                }
                vm.fullFlag = false;
            }

        }

        function toolbarStatus() {
            vm.isOperationDir = false;
            vm.isOperationSpacing = false;
            vm.isTransp = false;
            vm.isCoverage = false;
            // $scope.isDistriHover = false;
            // $scope.isAlignHover = false;
            vm.isOperationColor = false;
            vm.isShadowSet = false;
        }

        $scope.backupPages = function() {
            var pages = [];
            var index = 0;
            for (var i = 0; i < $scope.template.pages.page.length; i++) {
                if (index >= vm.backupPageSize) {
                    break;
                }
                var p = $scope.template.pages.page[i];
                if (!p.backup) {
                    continue;
                }
                p.index = i;
                pages.push(p);
                index++;
            }

            return pages;
        }

        $scope.loadMoreBackupPages = function() {
            if (vm.backupPageSize < $scope.template.pages.page.length) {
                vm.backupPageSize += 20;
            }
            if (vm.backupPageSize >= $scope.template.pages.page.length) {
                $timeout(function(){
                    $scope.$digest();
                }, 100);
            }
        }

        //边框
        $scope.imageboxW = function (imagebox) {
            if (!imagebox) {
                return
            }
            if (imagebox.border) {
                if (imagebox.border.type == 'Color') {
                    return Number(imagebox.geometry.width) + Number(imagebox.border.lineWidth) * 2
                }
                if (imagebox.border.type == 'Pic') {
                    return imagebox.geometry.width
                    // return Number(imagebox.geometry.width) + (Number(imagebox.geometry.width) * Number(imagebox.border.edge.left) / 100) + (Number(imagebox.geometry.width) * Number(imagebox.border.edge.right) / 100)
                }
            } else {
                return imagebox.geometry.width
            }
        }
        $scope.imageboxH = function (imagebox) {
            if (!imagebox) {
                return
            }
            if (imagebox.border) {
                if (imagebox.border.type == 'Color') {
                    return Number(imagebox.geometry.height) + Number(imagebox.border.lineWidth) * 2
                }
                if (imagebox.border.type == 'Pic') {
                    return imagebox.geometry.height
                    // return Number(imagebox.geometry.height) + (Number(imagebox.geometry.height) * Number(imagebox.border.edge.top) / 100) + (Number(imagebox.geometry.height) * Number(imagebox.border.edge.bottom) / 100)
                }
            } else {
                return imagebox.geometry.height
            }
        }
        $scope.imageboxL = function (imagebox) {
            if (!imagebox) {
                return
            }
            if (imagebox.border) {
                if (imagebox.border.type == 'Color') {
                    return Number(imagebox.geometry.x) - Number(imagebox.border.lineWidth)
                }
                if (imagebox.border.type == 'Pic') {
                    return imagebox.geometry.x
                    // return Number(imagebox.geometry.x) - (Number(imagebox.geometry.width) * Number(imagebox.border.edge.left) / 100)
                }
            } else {
                return imagebox.geometry.x
            }
        }
        $scope.imageboxT = function (imagebox) {
            if (!imagebox) {
                return
            }
            if (imagebox.border) {
                if (imagebox.border.type == 'Color') {
                    return Number(imagebox.geometry.y) - Number(imagebox.border.lineWidth)
                }
                if (imagebox.border.type == 'Pic') {
                    return imagebox.geometry.y
                    // return Number(imagebox.geometry.y) - (Number(imagebox.geometry.height) * Number(imagebox.border.edge.top) / 100)
                }
            } else {
                return imagebox.geometry.y
            }
        }
        $scope.imageboxWEdge = function (imagebox, edge) {
            if (!imagebox) {
                return
            }
            if (imagebox.border) {
                if (imagebox.border.type == 'Color') {
                    return Number(imagebox.border.lineWidth)
                }
                if (imagebox.border.type == 'Pic') {
                    if (edge == 'left') {
                        return Number(imagebox.geometry.width) * Number(imagebox.border.edge.left) / 100
                    }
                    if (edge == 'top') {
                        return Number(imagebox.geometry.width) * Number(imagebox.border.edge.top) / 100
                    }
                    if (edge == 'right') {
                        return Number(imagebox.geometry.width) * Number(imagebox.border.edge.right) / 100
                    }
                    if (edge == 'bottom') {
                        return Number(imagebox.geometry.width) * Number(imagebox.border.edge.bottom) / 100
                    }
                }
            } else {
                return 0
            }
        }
        $scope.imageboxWRadius = function (imagebox, radius, ratio) {
            if (!imagebox) {
                return
            }
            if (imagebox.border) {
                var radiusW = imagebox.geometry.width > imagebox.geometry.height ? imagebox.geometry.height : imagebox.geometry.width;
                radiusW = radiusW + Number(imagebox.border.lineWidth);
                if (imagebox.border.shape == 'Ellipse') {
                    return '50%'
                } else {
                    var _r = radiusW * imagebox.border.radius[radius] / 100;
                    return _r > 0 ? (_r + Number(imagebox.border.lineWidth)/2) * ratio : 0
                }
            } else {
                return 0
            }
        }
        $scope.imageboxWRadius1 = function (imagebox, radius, ratio) {
            if (!imagebox) {
                return
            }
            if (imagebox.border) {
                var radiusW = imagebox.geometry.width > imagebox.geometry.height ? imagebox.geometry.height : imagebox.geometry.width;
                if (imagebox.border.shape == 'Ellipse') {
                    return '50%'
                } else {
                    return 0
                }
            } else {
                return 0
            }
        }
        $scope.imageboxWRadius2 = function (imagebox, radius) {
            if (!imagebox) {
                return
            }
            if (imagebox.border) {
                if (imagebox.border.shape == 'Ellipse') {
                    return '200%'
                } else {
                    var radiusW = imagebox.geometry.width > imagebox.geometry.height ? imagebox.geometry.height : imagebox.geometry.width;
                    radiusW = radiusW + imagebox.border.lineWidth;
                    var _r = radiusW * imagebox.border.radius[radius] / 100;
                    return _r > 0 ? _r + Number(imagebox.border.lineWidth)/2 : 0
                }
            } else {
                return 0
            }
        }
        $scope.imageboxWRadius3 = function (imagebox, radius) {
            if (!imagebox) {
                return
            }
            if (imagebox.border) {
                if (imagebox.border.shape == 'Ellipse') {
                    return '200%'
                } else {
                    var radiusW = imagebox.geometry.width > imagebox.geometry.height ? imagebox.geometry.height : imagebox.geometry.width;
                    radiusW = radiusW + imagebox.border.lineWidth;
                    var _r = radiusW * imagebox.border.radius[radius] / 100;
                    return (_r - Number(imagebox.border.lineWidth)/2) > 0 ? _r - Number(imagebox.border.lineWidth)/2 : 0
                }
            } else {
                return 0
            }
        }
        $scope.borderRadius = function () {
            $scope.template.pages.page[$scope.template.pageI].levels.level[$scope.template.levelI].imagebox.border.radius = $scope.selectBox.border.radius;
        }
        $scope.lineTypeChenge = function(lineType){
            $scope.template.pages.page[$scope.template.pageI].levels.level[$scope.template.levelI].imagebox.border.lineType = lineType;
        }
        $scope.dropShadow = function(imagebox,radius){
            if (imagebox == null || imagebox.shadow == null) {
                return
            }
            var width = $scope.imageboxW(imagebox) * radius;
            var height =$scope.imageboxH(imagebox) * radius;
            return dropShadow(imagebox,width,height)
        }

        // 画布位置X
        $scope.canvasCoordX = function (width){
            vm.pageCenterWidth = $('#pageCenterSize').width();
            return (vm.pageCenterWidth-width)/2 + vm.moveCanvasObj.x;
            // +
        }
        // 画布位置Y
        $scope.canvasCoordY = function (height){
            vm.pageCenterHeight = $('#pageCenterSize').height();
            return (vm.pageCenterHeight-height)/2 + vm.moveCanvasObj.y ;
        }
    }

})();

(function () {
    'use strict';

    angular
        .module('platformApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('xml-center', {
                parent: 'app',
                url: '/xmlCenter',
                data: {
                    authorities: [],
                    pageTitle: 'platformAppTitle.xmlCenter'
                },
                views: {
                    'content': {
                        templateUrl: 'app/entities/page/xml-center.html',
                        controller: 'XmlCenterController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    },
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('title');
                        return $translate.refresh();
                    }]
                }
            })
            .state('purchased-template', {
                parent: 'app',
                url: '/purchased-template',
                data: {
                    authorities: [],
                    pageTitle: 'platformApp.page.home.title'
                },
                views: {
                    'content': {
                        templateUrl: 'app/entities/page/purchased-template.html',
                        controller: 'PurchasedTemplateController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    },
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        return $translate.refresh();
                    }]
                }
            })
            .state('page', {
                parent: 'app',
                url: '/page',
                data: {
                    authorities: [],
                    pageTitle: 'platformAppTitle.page'
                },
                views: {
                    'content': {
                        templateUrl: 'app/entities/page/page.html',
                        controller: 'PageController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    },
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('page');
                        $translatePartialLoader.addPart('global');
                        $translatePartialLoader.addPart('title');
                        return $translate.refresh();
                    }]
                }
            })
            .state('page-my-suffix', {
                url: '/page-my-suffix',
                data: {
                    authorities: [],
                    pageTitle: 'platformApp.page.home.title'
                },
                views: {
                    'navbar@': {
                        templateUrl: 'app/entities/page/pagesmySuffix.html',
                        controller: 'PageMySuffixController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    },
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('page');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            .state('page-my-suffix-edit', {
                url: '/page-my-suffix/{id}?new',
                data: {
                    authorities: [],
                    pageTitle: 'platformApp.page.home.title'
                },
                views: {
                    'navbar@': {
                        templateUrl: 'app/entities/page/pagesmySuffix.html',
                        controller: 'PageMySuffixController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    },
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('page');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })

            //先弹窗
            .state('xml-center-copy', {
                parent: 'xml-center',
                url: '/xml-center/{copy}/copy',
                data: {
                    authorities: [],
                    pageTitle: 'platformApp.page.home.title'
                },
                onEnter:['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal){
                    $uibModal.open({
                        templateUrl: 'app/entities/page/page-create.html',
                        controller: 'PageCreateController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            items:null,
                            translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                                $translatePartialLoader.addPart('page');
                                $translatePartialLoader.addPart('global');
                                return $translate.refresh();
                            }]
                        }
                    }).result.then(function() {
                        // $state.go('page-my-suffix-copy', null, { reload: true });
                    }, function() {
                        $state.go('xml-center');
                    });
                }]
            })
            .state('page-copy', {
                parent: 'templateList',
                url: '/page-copy/{copy}',
                data: {
                    authorities: [],
                    pageTitle: 'platformApp.page.home.title'
                },
                onEnter:['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal){
                    $uibModal.open({
                        templateUrl: 'app/entities/page/page-create.html',
                        controller: 'PageCreateController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            items: null,
                            translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                                $translatePartialLoader.addPart('page');
                                $translatePartialLoader.addPart('global');
                                return $translate.refresh();
                            }]
                        }
                    }).result.then(function() {
                        // $state.go('templateList', null, { reload: true });
                    }, function() {
                        $state.go('templateList');
                    });
                }]
            })
            .state('template-share', {
                parent: 'templateList',
                url: '/template-share/{id}',
                data: {
                    authorities: [],
                    pageTitle: 'platformApp.page.home.title'
                },
                onEnter:['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal){
                    $uibModal.open({
                        templateUrl: 'app/entities/page/template-share.html',
                        controller: 'PageShareController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: ['ProductXml',   function (ProductXml) {
                                return ProductXml.get({id: $stateParams.id}).$promise;
                            }],
                            translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                                return $translate.refresh();
                            }]
                        }
                    }).result.then(function() {
                        $state.go('templateList', null, { reload: true });
                    }, function() {
                        $state.go('templateList');
                    });
                }]
            })

            .state('template-opened-result', {
                parent: 'templateList',
                url: '/template-opened-result/{id}',
                data: {
                    authorities: [],
                    pageTitle: 'platformApp.page.home.title'
                },
                onEnter:['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal){
                    $uibModal.open({
                        templateUrl: 'app/entities/page/template-opened-result.html',
                        controller: 'PageShareController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: ['ProductXml',   function (ProductXml) {
                                return ProductXml.get({id: $stateParams.id}).$promise;
                            }],
                            translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                                return $translate.refresh();
                            }]
                        }
                    }).result.then(function() {
                        $state.go('templateList', null, { reload: true });
                    }, function() {
                        $state.go('templateList');
                    });
                }]
            })

            .state('page-edit', {
                parent: 'templateList',
                url: '/page/{id}',
                data: {
                    authorities: [],
                    pageTitle: 'platformApp.page.home.title'
                },
                onEnter:['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal){
                    $uibModal.open({
                        templateUrl: 'app/entities/page/page-create.html',
                        controller: 'PageCreateController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            items: null,
                            translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                                $translatePartialLoader.addPart('page');
                                $translatePartialLoader.addPart('global');
                                return $translate.refresh();
                            }]
                        }
                    }).result.then(function() {
                        // $state.go('templateList', null, { reload: true });
                    }, function() {
                        $state.go('templateList');
                    });
                }]
            })

            .state('page-edit3', {
                parent: 'page',
                url: '/page/{copy}/copy',
                data: {
                    authorities: [],
                    pageTitle: 'platformApp.page.home.title'
                },
                onEnter:['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal){
                    $uibModal.open({
                        templateUrl: 'app/entities/page/page-create.html',
                        controller: 'PageCreateController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            items:null,
                            translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                                $translatePartialLoader.addPart('page');
                                $translatePartialLoader.addPart('global');
                                return $translate.refresh();
                            }]
                        }
                    }).result.then(function() {
                        // $state.go('page-my-suffix-copy', null, { reload: true });
                    }, function() {
                        $state.go('xml-center');
                    });
                }]
            })


            .state('page-edit2', {
                parent: 'page',
                url: '/page/{id}',
                data: {
                    authorities: [],
                    pageTitle: 'platformApp.page.home.title'
                },
                onEnter:['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal){
                    $uibModal.open({
                        templateUrl: 'app/entities/page/page-create.html',
                        controller: 'PageCreateController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            items: null,
                            translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                                $translatePartialLoader.addPart('page');
                                $translatePartialLoader.addPart('global');
                                return $translate.refresh();
                            }]
                        }
                    }).result.then(function() {
                        // $state.go('templateList', null, { reload: true });
                    }, function() {
                        $state.go('page');
                    });
                }]
            })
        // vm.productXml.modelType+'/'+vm.productXml.modelData+'/'+vm.productXml.modelPath
            .state('page-my-suffix-check', {
                url: '/page-my-suffix/{identifier}/{key}/{xmlId}/{pattern}/{replace}/{pageIndex}/{modelType}/{modelData}?modelPath&xmlName',
                data: {
                    // authorities: ['ROLE_USER'],
                    authorities: [],
                    pageTitle: 'platformApp.page.home.title'
                },
                views: {
                    'navbar@': {
                        templateUrl: 'app/entities/page/pagesmySuffix.html',
                        controller: 'PageMySuffixController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    },
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('page');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            .state('page-my-suffix-check2', {
                url: '/page-my-suffix/{identifier}/{key}/{xmlId}/{pattern}/{replace}/{pageIndex}?xmlName',
                data: {
                    // authorities: ['ROLE_USER'],
                    authorities: [],
                    pageTitle: 'platformApp.page.home.title'
                },
                views: {
                    'navbar@': {
                        templateUrl: 'app/entities/page/pagesmySuffix.html',
                        controller: 'PageMySuffixController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    },
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('page');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            .state('page-my-suffix-check3', {
                url: '/page-my-suffix/{identifier}/{key}/{xmlId}/{replace}/{pageIndex}?xmlName',
                data: {
                    // authorities: ['ROLE_USER'],
                    authorities: [],
                    pageTitle: 'platformApp.page.home.title'
                },
                views: {
                    'navbar@': {
                        templateUrl: 'app/entities/page/pagesmySuffix.html',
                        controller: 'PageMySuffixController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    },
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('page');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            .state('catalog-management', {
                parent: 'app',
                url: '/catalog-management?catalogType',
                data: {
                    // authorities: ['ROLE_USER'],
                    authorities: [],
                    pageTitle: 'platformApp.page.home.title'
                },
                views: {
                    'content': {
                        templateUrl: 'app/entities/page/catalog-management.html',
                        controller: 'CatalogManagementController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    },
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('page');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            .state('catalog-management.new', {
                parent: 'catalog-management',
                url: '/new',
                data: {
                    // authorities: ['ROLE_USER'],
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/page/catalog-dialog.html',
                        controller: 'CatalogDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: function () {
                                return {
                                    name: null,
                                    id: null,
                                    catalogType:$stateParams.catalogType
                                };
                            }
                        }
                    }).result.then(function() {
                        $state.go('catalog-management', null, { reload: 'catalog-management' });
                    }, function() {
                        $state.go('catalog-management');
                    });
                }]
            })
            .state('catalog-management.edit', {
                parent: 'catalog-management',
                url: '/edit/{id}',
                data: {
                    // authorities: ['ROLE_USER'],
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/page/catalog-dialog.html',
                        controller: 'CatalogDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: ['Catalog', function(Catalog) {
                                return Catalog.get({id : $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function() {
                        $state.go('catalog-management', null, { reload: 'catalog-management' });
                    }, function() {
                        $state.go('^');
                    });
                }]
            })

            .state('catalog-management.edit2', {
                parent: 'catalog-management',
                url: '/edit2/{id}',
                data: {
                    // authorities: ['ROLE_USER'],
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/page/catalog-dialog.html',
                        controller: 'CatalogDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: ['ThemeClassify', function(ThemeClassify) {
                                return ThemeClassify.get({id : $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function() {
                        $state.go('catalog-management', null, { reload: 'catalog-management' });
                    }, function() {
                        $state.go('^');
                    });
                }]
            })
            .state('selfTemplateList', {
                parent: 'app',
                url: '/selfTemplateList?selectN&classify&shareStatus&source&product&upgradeStatus',
                data: {
                    authorities: [],
                    pageTitle: 'platformAppTitle.selfTemplateList'
                },
                views: {
                    'content': {
                        templateUrl: 'app/entities/page/templateList.html',
                        controller: 'TemplateListController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    },
                    search: null
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('fontManagement');
                        $translatePartialLoader.addPart('global');
                        $translatePartialLoader.addPart('frontStatus');
                        $translatePartialLoader.addPart('title');
                        return $translate.refresh();
                    }]
                }
            })


            .state('templateList', {
                parent: 'app',
                url: '/templateList',
                data: {
                    authorities: [],
                },
                views: {
                    'content': {
                        templateUrl: 'app/entities/page/templateList.html',
                        controller: 'TemplateListController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    },
                    search: null
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('fontManagement');
                        $translatePartialLoader.addPart('global');
                        $translatePartialLoader.addPart('frontStatus');
                        return $translate.refresh();
                    }]
                }
            })
            .state('templateList.new', {
                parent: 'templateList',
                url: '/{id}/new',
                data: {
                    authorities: []
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/page/template-dialog.html',
                        controller: 'TemplateDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: function () {
                                return {
                                    name: null,
                                    seq: null,
                                    type: null,
                                    usable: null,
                                    id: null
                                };
                            }
                        }
                    }).result.then(function() {
                        $state.go('templateList', null, { reload: 'templateList' });
                    }, function() {
                        $state.go('templateList');
                    });
                }]
            })
            .state('template', {
                parent: 'app',
                url: '/template/{id}/{self}',
                data: {
                    authorities: [],
                },
                views: {
                    'content': {
                        templateUrl: 'app/entities/page/templateList.html',
                        controller: 'TemplateListController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    },
                    search: null
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('fontManagement');
                        $translatePartialLoader.addPart('global');
                        $translatePartialLoader.addPart('frontStatus');
                        return $translate.refresh();
                    }]
                }
            })
            .state('alipayXml', {
                parent: 'app',
                url: '/alipayXml?item',
                data: {
                    authorities: [],
                },
                views: {
                    'navbar@': {
                        templateUrl: 'app/entities/page/alipay-xml.html',
                        controller: 'AlipayXMLController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function($stateParams, PaginationUtil) {
                        return {
                            item:$stateParams.item,
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('fontManagement');
                        $translatePartialLoader.addPart('global');
                        $translatePartialLoader.addPart('frontStatus');
                        return $translate.refresh();
                    }]
                }
            })
            .state('recommendTemplate', {
                parent: 'app',
                url: '/recommendTemplate?catalogId',
                data: {
                    authorities: [],
                    pageTitle: 'platformAppTitle.recommendTemplate'
                },
                views: {
                    'content': {
                        templateUrl: 'app/entities/page/recommendTemplate.html',
                        controller: 'RecommendTemplateController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('fontManagement');
                        $translatePartialLoader.addPart('global');
                        $translatePartialLoader.addPart('frontStatus');
                        $translatePartialLoader.addPart('title');
                        return $translate.refresh();
                    }]
                }
            })
        ;
    }

})();

(function () {
    'use strict';
    angular
        .module('platformApp')
        .factory('Qinius', Qinius)
        .factory('ClipArts', ClipArts)
        .factory('ThemeClassify', ThemeClassify)
        .factory('Backgrounds', Backgrounds)
        .factory('SourceMaterial', SourceMaterial)
        .factory('ProductTemplate', ProductTemplate)
        .factory('Catalog', Catalog)
        .factory('Hashtag', Hashtag)
        .factory('Category', Category)
        .factory('Galleries', Galleries)
        .factory('XmlToImg', XmlToImg)
        .factory('FrameConfig', FrameConfig)
        .factory("ImgprocContours", ImgprocContours);

    Qinius.$inject = ['$resource'];
    ThemeClassify.$inject = ['$resource'];
    ClipArts.$inject = ['$resource'];
    Backgrounds.$inject = ['$resource'];
    SourceMaterial.$inject = ['$resource'];
    Hashtag.$inject = ['$resource'];
    ProductTemplate.$inject = ['$resource'];
    Category.$inject = ['$resource'];
    Catalog.$inject = ['$resource'];
    Galleries.$inject = ['$resource'];
    XmlToImg.$inject = ['$resource'];
    FrameConfig.$inject = ['$resource'];
    ImgprocContours.$inject = ['$resource'];

    function ImgprocContours ($resource, DateUtils) {
        var resourceUrl =  'imgproc/' + 'api/contours/:path/:id';

        return $resource(resourceUrl, {}, {
            'buildServiceImage': {
                method: 'POST',
                params: {
                    path: 'buildServiceImage'
                }
            },
            'generateContour': {
                method: 'POST',
                params: {
                    path: 'generateContour'
                }
            },
            'parseContour': {
                method: 'POST',
                params: {
                    path: 'parseContour'
                }
            },
        });
    }

    function FrameConfig($resource) {
        var service = $resource('bunny/api/frame-config/:path/:id', {}, {
            "byCondition":{
                method:"POST",
                params:{
                    path:"byCondition"
                },
                isArray:true
            },
            "getAllByCondition":{
                method:"POST",
                params:{
                    path:"getAllByCondition"
                }
            },
        });
        return service;
    }
    function Qinius($resource) {
        var service = $resource('bunny/api/qiniu/:path/:id', {}, {
            'get': {
                method: 'GET',
                params: {
                    path: 'upload-token'
                }
            },
            'getDomain': {
                method: 'GET',
                params: {
                    path: 'bucket-domain'
                }
            }
        });
        return service;
    }

    function Backgrounds($resource) {
        var service = $resource('bunny/api/backgrounds/:path/:id', {}, {
            'getAll': {
                method: 'POST',
                params: {
                    path: 'getAll'
                },
                isArray: true
            },
            "byCondition":{
                method:"POST",
                params:{
                    path:"byCondition"
                },
                isArray:true
            },
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            "batchDelete":{
                method: 'delete',
                params:{
                    path:"batchDelete"
                },
            },
            "changeStatue":{
                method:"GET",
                params:{
                    path:"changeStatue"
                }
            },
            'update': { method:'PUT' },
            'updateImg': { method:'POST' },
            "batchList":{
                method:"POST",
                params:{
                    path:"batchList"
                },
                isArray:true
            },
        });
        return service;
    }

    function ThemeClassify ($resource) {
        var resourceUrl =  'bunny/' + 'api/theme-classify/:path/:id';
        return $resource(resourceUrl, {}, {
            "saveForUser":{
                method:"POST",
                params:{
                    path:"saveForUser"
                }
            },
            "byCondition1":{
                method:"POST",
                params:{
                    path:"byCondition1"
                },
                isArray:true
            },
            "getAllByCondition1":{
                method:"POST",
                params:{
                    path:"getAllByCondition1"
                },
                isArray:true
            },
            "byCondition":{
                method:"POST",
                params:{
                    path:"byCondition"
                },
                isArray:true
            },
            "byCondition3":{
                method:"POST",
                params:{
                    path:"byCondition3"
                },
                isArray:true
            },
            "byCondition4":{
                method:"GET",
                params:{
                    path:"byCondition4"
                }
            },
            "getAllByCondition":{
                method:"POST",
                params:{
                    path:"getAllByCondition"
                },
                isArray:true
            },
            "getAllByCondition2":{
                method:"POST",
                params:{
                    path:"getAllByCondition2"
                },
                isArray:true
            },
            "getAllByCondition3":{
                method:"POST",
                params:{
                    path:"getAllByCondition3"
                },
                isArray:true
            },
            "getAllByCondition4":{
                method:"GET",
                params:{
                    path:"getAllByCondition4"
                }
            },
            "del":{
                method:"DELETE"
            },
            "changeStatue":{
                method:"GET",
                params:{
                    path:"changeStatue"
                }
            },
            "get":{
                method:"GET"
            },
            "save":{
                method:"PUT"
            },
            'updateSeqByList':{
                method: 'POST',
                params:{
                    path:"updateSeqByList"
                },
            }
        });
    }

    function ClipArts($resource) {
        var service = $resource('bunny/api/clip-arts/:path/:id', {}, {
            'getAll': {
                method: 'POST',
                params: {
                    path: 'getAll'
                },
                isArray: true
            },
            'getAll2': {
                method: 'POST',
                params: {
                    path: 'getAll2'
                },
                isArray: true
            },
            "byCondition":{
                method:"POST",
                params:{
                    path:"byCondition"
                },
                isArray:true
            },
            "byConditionNew":{
                method:"POST",
                params:{
                    path:"byCondition-new"
                },
                isArray:true
            },
            "byCondition2":{
                method:"POST",
                params:{
                    path:"byCondition2"
                },
                isArray:true
            },
            "byCondition3":{
                method:"POST",
                params:{
                    path:"byCondition3"
                },
                isArray:true
            },
            "batchDelete":{
                method:"get",
                params:{
                    path:"batchDelete"
                },
            },
            'batchCreate': {
                method: 'POST',
                params:{
                    path:'batchCreate'
                },
                isArray:true
            },
            'createOne': {
                method: 'POST'
            },
            'update': {
                method: 'PUT'
            }
        });
        return service;
    }

    function SourceMaterial($resource) {
        var service = $resource('bunny/api/source-material/:path/:id', {}, {
            'getAll': {
                method: 'POST',
                params: {
                    path: 'getAll'
                },
                isArray: true
            },
            'getAll2': {
                method: 'POST',
                params: {
                    path: 'getAll2'
                },
                isArray: true
            },
            "byCondition":{
                method:"POST",
                params:{
                    path:"byCondition"
                },
                isArray:true
            },
            "byCondition3":{
                method:"POST",
                params:{
                    path:"byCondition3"
                },
                isArray:true
            },
            'createOne': {
                method: 'PUT'
            },
            'batchCreate': {
                method: 'POST',
                params:{
                    path:'batchCreate'
                },
                isArray:true
            },
            "batchDelete":{
                method:"GET",
                params:{
                    path:"batchDelete"
                },
            },
            'update': {
                method: 'PUT'
            }
        });
        return service;
    }

    function ProductTemplate($resource) {
        return $resource('bunny/api/product-templates/:path/:id', {}, {
            'updateVersion': {
                method: 'GET',
                params: {
                    path: 'updateVersion'
                }
            },
            'getAllByCondition': {
                method: 'POST',
                params: {
                    path: 'getAllByCondition'
                },
                isArray: true
            },
            "byCondition":{
                method:"POST",
                params:{
                    path:"byCondition"
                },
                isArray:true
            },
            "groupByCatalogAndOrderBySeq":{
                method:"GET",
                params:{
                    path:"groupByCatalogAndOrderBySeq"
                },
                isArray: true
            },
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
        });
    }

    function Catalog($resource) {
        return $resource('bunny/api/catalogs/:path/:id' , {}, {
            'quickLinks': {
                method: 'GET',
                params: {
                    path: 'quickLinks'
                },
                isArray: true
            },
            'getAll': {
                method: 'POST',
                params: {
                    path: 'getAll'
                },
                isArray: true
            },
            'getAll2': {
                method: 'POST',
                params: {
                    path: 'getAll2'
                },
                isArray: true
            },
            "getAll3": {
                method: 'POST',
                params:{
                    path:"getAll3"
                },
                isArray:true
            },
            'findCatalogByProductXml': {
                method: 'GET',
                params: {
                    path: 'findCatalogByProductXml'
                },
                isArray: false
            },
            'usable': {
                method: 'GET',
                params: {
                    path: 'usable'
                }
            },
            'deleteCatalog': {
                method: 'DELETE'
            },
            'get': {
                method: 'GET'
            },
            'createCatalog': {
                method: 'POST'
            },
            'updateCatalog': {
                method: 'PUT'
            },
            'updateSeqByList':{
                method: 'POST',
                params:{
                    path:"updateSeqByList"
                },
            }
        });
    }

    function Hashtag($resource) {
        return $resource('bunny/api/hashtags/:path/:id', {}, {
            "byCondition2": {
                method: "POST",
                params: {
                    path: "byCondition2"
                },
                isArray: true
            },
            "getAll2": {
                method: "POST",
                params: {
                    path: "getAll2"
                },
                isArray: true
            },
            'query': {method: 'GET', isArray: true},
            'get': {
                method: 'GET'
            },
            'update': {method: 'PUT'}
        });
    }

    function Category($resource) {
        return $resource('manager/api/categories/:path/:id', {}, {
            'byCondition': {
                method: 'POST',
                params: {
                    path: 'byCondition'
                },
                isArray: true
            },
            "getAllByCondition": {
                method: "POST",
                params: {
                    path: "getAllByCondition"
                },
                isArray: true
            },
            'query': {method: 'GET', isArray: true},
            'get': {
                method: 'GET'
            },
            'update': {method: 'PUT'}
        });
    }
    function Galleries($resource) {
        return $resource('bunny/api/galleries/:path/:id', {}, {
            'byConditionNew': {
                method: 'POST',
                params: {
                    path: 'byConditionNew'
                },
                isArray: true
            },
            "getAllByCondition": {
                method: "POST",
                params: {
                    path: "getAllByCondition"
                },
                isArray: true
            },
            'query': {method: 'GET', isArray: true},
            'delete': {method: 'DELETE'},
            'get': {
                method: 'GET'
            },
            'upload': {
                params: {
                    path: "upload"
                },
                method: 'GET'
            },
            "batchDelete":{
                method: 'GET',
                params:{
                    path:"batchDelete"
                },
            },
            'update': {method: 'PUT'},
            'uploadBatch':{
                method: 'POST',
                params:{
                    path:"uploadBatch"
                },
                isArray:true
            }
        });
    }

    function XmlToImg ($resource) {
        var resourceUrl = 'fileserves/' + 'api/convert/:path/:id';

        return $resource(resourceUrl, {}, {
            'get': {
                method: 'GET',
                params: {
                    path: 'xmlToImg'
                }
            },
            'documentToImg': {
                method: 'POST',
                params: {
                    path: 'documentToImg'
                }
            }
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('platformApp')
        .controller('PageMySuffixController', PageMySuffixController)
        .filter('reverse', function () {
            return function (items) {
                if (items) {
                    return items.slice().reverse();
                }
            };
        });

    PageMySuffixController.$inject = ['$state', '$scope', 'Qinius', '$uibModal', '$http', '$q', '$timeout', '$stateParams', 'ImageService', 'MessageService', 'PicLayoutXmls', 'ModulesService',
        'FontManagement', 'ProductXml', 'UidService', 'ClipArts', 'SourceMaterial', 'Backgrounds', 'FontXmls', 'Galleries', 'ThemeClassify', 'Catalog', 'ListService', 'PsdTemplateLoader',
        'ProductTemplate', 'GetSetDpi', 'FrameConfig','ThirdPartySetting','$localStorage','CalendarLayout','TitleWidget','MonthWidget'];

    function PageMySuffixController($state, $scope, Qinius, $uibModal, $http, $q, $timeout, $stateParams, ImageService, MessageService, PicLayoutXmls, ModulesService,
                                    FontManagement, ProductXml, UidService, ClipArts, SourceMaterial, Backgrounds, FontXmls, Galleries, ThemeClassify, Catalog, ListService, PsdTemplateLoader,
                                    ProductTemplate, GetSetDpi, FrameConfig, ThirdPartySetting,$localStorage,CalendarLayout,TitleWidget,MonthWidget) {
        var vm = this;

        vm.selectElementCopy = null;
        $(".navbar").hide();
        $(".nav-bg").show();
        $(".wrap").css({margin: 0});
        localStorage.removeItem('ctrlKeyArray');
        vm.isEditorTitle = false;
        $scope.thumbnailPic = false;
        vm.thirdparty = $stateParams.identifier ? true : false;
        vm.exitSure = false;
        var arrDPI = ModulesService.getDPI();
        vm.windowDpiW = arrDPI[0];
        vm.windowDpiH = arrDPI[1];
        if(!vm.thirdparty){
            GetSetDpi.getCurrent({}, function (res) {
                vm.gitDpi = res.message;
            });
        }
        vm.getAllCtrlKeyArray = getAllCtrlKeyArray;
        vm.menuImageView = menuImageView;
        vm.pageImageView = pageImageView;
        vm.pageImageViewOrient = pageImageViewOrient;

        var bigSizePics = [];
        vm.uploadType = "";

        // 监听顶部操作栏
        vm.moreDisplay = false;
        vm.moreIcon = false;
        vm.moreDisplayFont = false;
        vm.loadingImg = true;
        $(window).resize(function () {
            if ($('#nav-header').outerWidth() <= 1200) {
                vm.moreIcon = true;
            } else {
                vm.moreIcon = false;
                vm.moreDisplay = false;
                vm.moreDisplayFont = false;
            }
        })


        $scope.moreDisplay = function () {
            vm.moreDisplay = !vm.moreDisplay;
        }

        $scope.moreDisplayFont = function () {
            vm.moreDisplayFont = !vm.moreDisplayFont;
        }

        //键盘操作array
        vm.CtrlKeyArray = {imageboxes: [], textboxes: [], imagearts: [], barcode: [], qrcode: [], textdocuments: [], calMonthBoxs: [], calTitleBoxs: []};
        vm.singleArray = {imagebox: {}, textbox: {}, imageart: {}, barcode: {}, qrcode: {}, textdocument: {}, calMonthBox: {}, calTitleBox: {}};
        vm.windowH = window.innerHeight - 90;
        vm.bgimgs2Tab = 'all';
        vm.clipartTab = 'SYSTEM';
        vm.maskTab = 'all';
        vm.materialTab = 'SYSTEM';
        vm.borderTab = 'SYSTEM';
        vm.showClipartlabels = [];
        vm.colorArr1 = ['#ffffff', '#666666', '#7babaf', '#e69594', '#93a9da', '#eac8fb'];
        vm.colorArr2 = ['#000000', '#666666', '#a8a8a8', '#d9d9d9', '#ffffff', '#647c6e', '#ff5b5c', '#ffbd4a', '#fef952', '#99e264', '#36b72a', '#44d9e5', '#c27171', '#2fb3ff', '#b760a6'];

        vm.sizeList = [
            {name: '12', id: '12'},
            {name: '13', id: '13'},
            {name: '14', id: '14'},
            {name: '15', id: '15'},
            {name: '16', id: '16'},
            {name: '17', id: '17'},
            {name: '18', id: '18'},
            {name: '19', id: '19'},
            {name: '20', id: '20'},
            {name: '22', id: '22'},
            {name: '24', id: '24'},
            {name: '26', id: '26'},
            {name: '28', id: '28'},
            {name: '30', id: '30'},
        ]
        vm.colorList = [
            {name: '#000000', id: '#000000'},
            {name: '#666666', id: '#666666'},
            {name: '#a8a8a8', id: '#a8a8a8'},
            {name: '#d9d9d9', id: '#d9d9d9'},
            {name: '#ffffff', id: '#ffffff'},
            {name: '#647c6e', id: '#647c6e'},
            {name: '#ffbd4a', id: '#ffbd4a'},
            {name: '#fef952', id: '#fef952'},
            {name: '#99e264', id: '#99e264'},
            {name: '#36b72a', id: '#36b72a'},
            {name: '#44d9e5', id: '#44d9e5'},
            {name: '#c27171', id: '#c27171'},
            {name: '#2fb3ff', id: '#2fb3ff'},
            {name: '#b760a6', id: '#b760a6'},
        ]
        vm.navList = [
            {icon:'icon-bianjiqi-beijing', name: '背景', id:'page'},
            {icon:'icon-bianjiqi-xiangkuang', name: '相框', id:'mask'},
            {icon:'icon-bianjiqi-biankuang', name: '边框', id:'border'},
            {icon:'icon-bianjiqi-sucai', name: '素材', id:'material'},
            {icon:'icon-bianjiqi-wenben', name: '文字', id:'text',isShow:vm.thirdparty},
            {icon:'icon-bianjiqi-tupian', name: '图片', id:'img',isShow:vm.thirdparty},
            {icon:'icon-bianjiqi-erweima', name: '二维码', id:'barcode'},
            {icon:'icon-rili', name: '标题', id:'widgetTitle',isShow:true},
            {icon:'icon-rili', name: '日历', id:'widgetMonth',isShow:true},
            {icon:'icon-bianjiqi-buju', name: '布局库', id:'layout',isShow:vm.thirdparty},
            {icon:'icon-bianjiqi-beiyongye', name: '备用页', id:'backup'},
            {icon:'icon-bianjiqi-PSDdaoru', name: 'PSD导入', id:'psdimportor',isShow:vm.thirdparty},
            {icon:'icon-bianjiqi-biaozhunmoban', name: '标准模板', id:'productTemplate',isShow:vm.thirdparty},
            {icon:'icon-bianjiqi-huishouzhan', name: '回收站', id:'recycle',isShow:vm.thirdparty},
        ]

        /* ===============================================
         页面
        ================================================= */
        vm.page = {
            pageEdits: [],
            editboxes: [],
            pageTemplates: []
        };

        // 使用 $watch 监听 vm.page.name 的变化
        $scope.$watch(function() {
            return vm.page.name;
        }, function(newName, oldName) {
            if (newName!==undefined) {
                document.title = newName + '-设计页'
            }
        });
        vm.pageStoragePredefined = false;
        vm.units = [
            {name: 'px', id: 'px'},
            {name: 'mm', id: 'mm'},
            {name: '英寸', id: 'in'}
        ];
        vm.unit = 'mm';

        $scope.dWidth = document.documentElement.clientWidth || document.body.clientWidth;
        $scope.dHeight = document.documentElement.clientHeight || document.body.clientHeight;
        // 左边操作栏 显示规则
        $scope.selPanel = 'page';
        // 右侧边栏 显示规则
        $scope.RightPanel = '';

        $scope.template = {
            transparency: 1,
            cover: angular.copy(vm.page.cover),
            scene: null,
            pageI: 0,
            angle: 0,
            backup: false,
            spread: false,
            unreplace: false,
            letterspacing: 0,
            lineheight: 0,
            text: '',
            bgimgs: {bgimg: []},
            bgimgs2: {bgimg: []},
            masks: {mask: []},
            cliparts: {clipart: []},
            frameConfigs: {frameConfig: []},
            documentpics: {documentpic: []},
            pages: {
                page: []
            },
            backupPages: {
                "list": []
            },
            showPic: true,
            psdFiles: {psdFile: []}
        };
        $scope.selectBox = {
            current: 'page'
        }
        vm.count = 0;

        var mb = ModulesService.myBrowser();
        vm.productTemplates = [];
        vm.proTempIndexNum = 0;
        vm.tempCatalogId = 0;
        vm.backupPageSize = 0;


        /* ===============================================
         出血值
         ================================================= */
        var oldSizePx = 0, oldSizeMm = 0;

        function getBloodSize(page, i) {
            if (vm.unit == 'mm') {
                // mm
                page.blood = {
                    bottom: vm.page.pageBloodB,
                    left: vm.page.pageBloodL,
                    right: vm.page.pageBloodR,
                    top: vm.page.pageBloodT
                };
                page.bloodPx = {
                    top: MmTurnPx(vm.page.pageBloodT),
                    right: MmTurnPx(vm.page.pageBloodR),
                    bottom: MmTurnPx(vm.page.pageBloodB),
                    left: MmTurnPx(vm.page.pageBloodL),
                };
            } else if (vm.unit == 'px') {
                // px
                var tab = ThreeHundredDpiToMm(vm.page.pageBloodT, vm.page.pageBloodB);
                var lar = ThreeHundredDpiToMm(vm.page.pageBloodL, vm.page.pageBloodR);
                page.blood = {
                    top: tab.mm1,
                    bottom: tab.mm2,
                    left: lar.mm1,
                    right: lar.mm2,
                }
                page.bloodPx = {
                    top: MmTurnPx(tab.mm1),
                    bottom: MmTurnPx(tab.mm2),
                    left: MmTurnPx(lar.mm1),
                    right: MmTurnPx(lar.mm2),
                }
            } else if (vm.unit == 'in') {
                // in
                var tab = InTurnMm(vm.page.pageBloodT, vm.page.pageBloodB);
                var lar = InTurnMm(vm.page.pageBloodL, vm.page.pageBloodR);
                page.blood = {
                    top: tab.mm1,
                    bottom: tab.mm2,
                    left: lar.mm1,
                    right: lar.mm2,
                }
                page.bloodPx = {
                    top: MmTurnPx(tab.mm1),
                    bottom: MmTurnPx(tab.mm2),
                    left: MmTurnPx(lar.mm1),
                    right: MmTurnPx(lar.mm2),
                }
            }

            page.xayBorder = page.bloodPx.top + page.bloodPx.bottom;
            // page.mediabox.height = page.bloodPx.top + page.bloodPx.bottom + page.trimbox.height;
            // page.mediabox.width = page.bloodPx.left + page.bloodPx.right + page.trimbox.width;
            page.trimbox.height = page.mediabox.height - page.bloodPx.top - page.bloodPx.bottom;
            page.trimbox.width = page.mediabox.width - page.bloodPx.left - page.bloodPx.right;

            var mmL = page.blood.left - oldSizeMm.left;
            var mmT = page.blood.top - oldSizeMm.top;
            if (page.barcode && page.barcode.geometry) {
                page.barcode.geometry.x += MmTurnPx(mmL);
                page.barcode.geometry.y += MmTurnPx(mmT);
            }
            if (page.qrcode && page.qrcode.geometry) {
                page.qrcode.geometry.x += MmTurnPx(mmL);
                page.qrcode.geometry.y += MmTurnPx(mmT);
            }

            angular.forEach(page.levels.level, function (level) {
                if (level.imageart && level.imageart.current) {
                    level.imageart.geometry.x += MmTurnPx(mmL);
                    level.imageart.geometry.y += MmTurnPx(mmT);
                }
                if (level.imagebox && level.imagebox.current) {
                    level.imagebox.geometry.x += MmTurnPx(mmL);
                    level.imagebox.geometry.y += MmTurnPx(mmT);
                }
                if (level.textbox && level.textbox.current) {
                    level.textbox.geometry.x += MmTurnPx(mmL);
                    level.textbox.geometry.y += MmTurnPx(mmT);
                }
            })
            setOriginalWaH(page.trimbox.width, page.trimbox.height, i);
            vm.operation = true;
        }

        /* ===============================================
         文字
         ================================================= */
        vm.fontList = [];

        function fontSizeInit(size) {
            var _size = 101;
            var _size1 = Math.floor(size / 2);
            $scope.fontSizes = [];
            for (var f = 6; f < _size; f++) {
                $scope.fontSizes.push(f);
            }
            if (_size1 > _size) {
                $scope.fontSizes.push(_size1);
            }
            $scope.size = $scope.fontSizes[6];
        }

        vm.indexNum = 0;
        vm.clipartIndexNum = 0;
        vm.maskIndexNum = 0;
        vm.textIndexNum = 0;
        vm.itemsPerPage = 20;
        vm.allCliparts = {clipart: []};
        vm.showMasks = {mask: []};
        vm.picLayoutXmlsList = [];
        vm.picLayoutXmlGroup = [];
        var oldPage = null;


        //得到原始模板框中最大宽高比例
        var $con = $("#pageCenterSize");
        var $contain = $(".content-page-main");
        var originalScale = $con.width() * 0.8 / ($con.height() * 0.8);
        vm.sublinesX=[];
        vm.sublinesY=[];


        if(!vm.thirdparty){
            vm.tokenTime = 360000;
            Qinius.get(function (msg) {
                vm.token = msg.token;
                vm.tokenTime = parseInt((msg.expireAt - new Date().getTime()));
            });
            $scope.domains = Qinius.getDomain();
            $q.all([$scope.domains.$promise]).then(function () {
                // token过期
                setTimeout(function fn() {
                    Qinius.get(function (msg) {
                        vm.token = msg.token;
                        vm.tokenTime = parseInt((msg.expireAt - new Date().getTime()));
                    });
                    setTimeout(fn, vm.tokenTime);
                }, vm.tokenTime);
                vm.url = $scope.domains.domain;
                vm.bgimgs2 = {bgimg: []};
                // 背景的分类
                getBackgroundLabel();

                // 平台素材label
                ThemeClassify.getAllByCondition2({
                    items: [{key: "type", op: "=", value: 'CLIPART'}, {
                        key: "used",
                        op: "=",
                        value: true
                    }], sort: ["seq,asc"]
                }, function (res) {
                    vm.clipartIndexNum = 0;
                    vm.platformMaterialLabels = angular.copy(res);
                });
                // 设计师素材
                ThemeClassify.getAllByCondition1({
                    items: [{key: "type", op: "=", value: 'CLIPART'}, {
                        key: "used",
                        op: "=",
                        value: true
                    }], sort: ["seq,asc"]
                }, function (data) {
                    vm.designerMaterialLabels = angular.copy(data) || [];
                    vm.designerMaterialLabels.unshift({id: '', name: '全部', type: 'oldMaterials', themeClassifyId: ''})
                })

                vm.systemBorderClass = []
                vm.myBorderClass = []
                $scope.borderLabels = []
                // 平台边框label
                ThemeClassify.getAllByCondition2({
                    items: [{key: "type", op: "=", value: 'BORDER'}, {
                        key: "used",
                        op: "=",
                        value: true
                    }], sort: ["seq,asc"]
                }, function (res) {
                    vm.systemBorderClass = angular.copy(res)
                    $scope.borderLabels = angular.copy(res)
                });
                // 设计师边框
                ThemeClassify.getAllByCondition1({
                    items: [{key: "type", op: "=", value: 'BORDER'}, {
                        key: "used",
                        op: "=",
                        value: true
                    }], sort: ["seq,asc"]
                }, function (data) {
                    vm.myBorderClass = angular.copy(data)
                })

                FontXmls.byCondition({
                    items: [],
                    page: vm.textIndexNum,
                    size: vm.itemsPerPage,
                    sort: ["id,desc"]
                }, function (resp, headers) {
                    vm.totalTextItems = headers('X-Total-Count');
                    vm.fontDoc = angular.copy(resp);
                })

                vm.defaultFont = FontManagement.getDefaultShow();


                //标准模板
                Catalog.getAll3({items: [{key: "usable", op: "=", value: "true"}], sort: ["id,asc"]}, function (res) {
                    vm.catalogs = res;
                    if (vm.catalogs.length) {
                        vm.tempCatalogId = vm.catalogs[0].id;
                        loadProductTemplate(vm.tempCatalogId, 0);
                    }
                });

                vm.windowH = window.innerHeight - 50 - 42 - 110;
                vm.windowW = window.innerWidth - 500;
                vm.windowH1 = 100;
                vm.windowW1 = 100;
                if ($stateParams.id) {
                    var xmlId = $stateParams.id || $stateParams.copy;
                    ProductXml.get({id: xmlId}, function (resp) {
                        if(!resp.document.bgimgs2){resp.document.bgimgs2={}}
                        if(!resp.document.masks){resp.document.masks={}}
                        if(!resp.document.cliparts){resp.document.cliparts={}}
                        if(!resp.document.frameConfigs){resp.document.frameConfigs={}}
                        if(!resp.document.documentpics){resp.document.documentpics={}}
                        getDocumentXml(resp)
                    });
                }
            });
        }else{
            ThirdPartySetting.getByKey({key: $stateParams.key}, function (data) {
                vm.thirds = data;
            }, function () {
                MessageService.error("配置信息 获取失败");
            });
            ProductXml.getThirdData({key: $stateParams.key}, function (res) {
                vm.token = res.token;
                vm.url = res.domain + '/';
                $timeout(function () {
                    ProductXml.getDocumentByKey({
                        key: $stateParams.identifier,
                        domain: res.domain
                    }, function (res1) {
                        if(!res1.bgimgs2){res1.bgimgs2={}}
                        if(!res1.masks){res1.masks={}}
                        if(!res1.cliparts){res1.cliparts={}}
                        if(!res1.frameConfigs){res1.frameConfigs={}}
                        if(!res1.documentpics){res1.documentpics={}}
                        var resp = {
                            document: res1,
                            modelType: $stateParams.modelType,
                            modelData:decodeURIComponent($stateParams.modelData),
                            modelPath: decodeURIComponent($stateParams.modelPath),
                            name: $stateParams.xmlName,
                        }
                        if(res1.xLines && res1.xLines.line){
                            vm.sublinesX = res1.xLines.line
                        }
                        if(res1.yLines && res1.yLines.line){
                            vm.sublinesY = res1.yLines.line
                        }
                        vm.windowH = window.innerHeight - 50 - 42 - 110;
                        vm.windowW = window.innerWidth - 500;
                        vm.windowH1 = 100;
                        vm.windowW1 = 100;

                        vm.page = getPageFromProductXml(resp);
                        preparePageInfo();
                        vm.page.name = resp.name;
                        resp.document.pages.page.forEach(function (page) {
                            if (page.levels && page.levels.level && page.levels.level.length > 0) {
                                page.levels.level.sort(compare('seq', true));
                            }
                        })
                        vm.page.provider = 'qiniu';
                        vm.page.identifier = $stateParams.identifier;

                        vm.page.modelData = resp.modelData;
                        vm.page.modelBlendent = resp.modelBlendent;
                        vm.page.modelPath = resp.modelPath;
                        vm.page.modelType = resp.modelType;
                        // vm.hashtags = resp.hashtags;
                        // if (resp.productTemplateHasModel) {
                        //     vm.hasModel = true;
                        // } else {
                        //     vm.hasModel = false;
                        // }
                        if (resp.document.bgimgs) {
                            $scope.template.bgimgs.bgimg = angular.copy(resp.document.bgimgs.bgimg) || [];
                        }
                        if (resp.document.psdFiles) {
                            $scope.template.psdFiles.psdFile = angular.copy(resp.document.psdFiles.psdFile) || [];
                        }
                        $scope.template.bgimgs2.bgimg = angular.copy(resp.document.bgimgs2.bgimg) || [];
                        $scope.template.masks.mask = angular.copy(resp.document.masks.mask) || [];
                        $scope.template.cliparts.clipart = angular.copy(resp.document.cliparts.clipart) || [];
                        $scope.template.frameConfigs.frameConfig = angular.copy(resp.document.frameConfigs.frameConfig) || [];
                        $scope.template.documentpics.documentpic = angular.copy(resp.document.documentpics.documentpic) || [];
                        $scope.template.piclayouts = {piclayout: []};
                        if (resp.document.piclayouts && resp.document.piclayouts.piclayout) {
                            $scope.template.piclayouts.piclayout = angular.copy(resp.document.piclayouts.piclayout)
                        }

                        $scope.template.deletedPages = angular.copy(resp.document.deletedPages);
                        $scope.template.pages = angular.copy(resp.document.pages);
                        $scope.template.config = angular.copy(resp.document.config);

                        $scope.template.piclayouts.piclayout.some(function (data, i) {
                            data.identifier = data.resource.identifier
                        })
                        angular.forEach($scope.template.bgimgs2.bgimg, function (bgImg, i) {
                            bgImg.isRecommend = true;
                            if(vm.bgimgs2&&vm.bgimgs2.bgimg){
                                angular.forEach(vm.bgimgs2.bgimg, function (b) {
                                    if (b.identifier == bgImg.identifier) {
                                        b.isRecommend = true;
                                        bgImg.id = b.id;
                                    }
                                })
                            }
                        });
                        angular.forEach($scope.template.masks.mask, function (mask, i) {
                            mask.isRecommend = true;
                            angular.forEach(vm.showMasks.mask, function (m) {
                                if (m.identifier == mask.resource.identifier) {
                                    m.isRecommend = true;
                                    mask.id = m.id;
                                }
                            })
                        });
                        angular.forEach($scope.template.cliparts.clipart, function (clipart, i) {
                            clipart.isRecommend = true;
                        });
                        angular.forEach($scope.template.frameConfigs.frameConfig, function (frameConfig, i) {
                            frameConfig.isRecommend = true;
                        });

                        var page0 = resp.document.pages.page[0];
                        if (!page0.editbox) {
                            page0.editbox = page0.trimbox;
                        }
                        angular.forEach(resp.document.pages.page, function (page, i) {
                            var _pageItem = vm.page;
                            if(vm.page.pageTemplates[i]){
                                _pageItem = vm.page.pageTemplates[i];
                            }
                            var mediaboxW = angular.copy(resp.document.pages.page[i].mediabox.width);
                            var newPageScale = _pageItem.pageSizeW / mediaboxW;

                            page.blood = {
                                top: _pageItem.pageBloodT,
                                bottom: _pageItem.pageBloodB,
                                left: _pageItem.pageBloodL,
                                right: _pageItem.pageBloodR,
                            };


                            if (newPageScale != 1) {
                                if (page.background.resource && page.background.resource.identifier) {
                                    page.background.offsetx = page.background.offsetx * newPageScale;
                                    page.background.offsety = page.background.offsety * newPageScale;
                                }
                                if (page.barcode && page.barcode.geometry) {
                                    var barcode = angular.copy(page.barcode.geometry);
                                    page.barcode.geometry = {
                                        width: barcode.width * newPageScale,
                                        height: barcode.height * newPageScale,
                                        x: barcode.x * newPageScale,
                                        y: barcode.y * newPageScale,
                                    }

                                }
                                if (page.qrcode && page.qrcode.geometry) {
                                    var qrcode = angular.copy(page.qrcode.geometry);
                                    page.qrcode.geometry = {
                                        width: qrcode.width * newPageScale,
                                        height: qrcode.height * newPageScale,
                                        x: qrcode.x * newPageScale,
                                        y: qrcode.y * newPageScale,
                                    }

                                }
                                angular.forEach(page.levels.level, function (level, n) {
                                    if (level.imageart && level.imageart.geometry) {
                                        var art = angular.copy(level.imageart);
                                        level.imageart.geometry = {
                                            width: art.geometry.width * newPageScale,
                                            height: art.geometry.height * newPageScale,
                                            x: art.geometry.x * newPageScale,
                                            y: art.geometry.y * newPageScale,
                                        }
                                        level.imageart.offsetx = art.offsetx * newPageScale;
                                        level.imageart.offsety = art.offsety * newPageScale;
                                    }

                                    if (level.imagebox && level.imagebox.geometry) {
                                        var image = angular.copy(level.imagebox);
                                        level.imagebox.transparency = level.imagebox.transparency === null ? 1 : level.imagebox.transparency;
                                        level.imagebox.geometry = {
                                            width: image.geometry.width * newPageScale,
                                            height: image.geometry.height * newPageScale,
                                            x: image.geometry.x * newPageScale,
                                            y: image.geometry.y * newPageScale,
                                        };
                                        if (image.image && image.image.resource && image.image.resource.identifier) {
                                            level.imagebox.image.offsetx = image.image.offsetx * newPageScale;
                                            level.imagebox.image.offsety = image.image.offsety * newPageScale;
                                            level.imagebox.image.resource.width = image.image.resource.width * newPageScale;
                                            level.imagebox.image.resource.height = image.image.resource.height * newPageScale;
                                            level.imagebox.image.width = image.image.width * newPageScale;
                                            level.imagebox.image.height = image.image.height * newPageScale;
                                        }
                                    }
                                    if (level.textbox && level.textbox.geometry) {
                                        var text = angular.copy(level.textbox);
                                        level.textbox.geometry = {
                                            width: text.geometry.width * newPageScale,
                                            height: text.geometry.height * newPageScale,
                                            x: text.geometry.x * newPageScale,
                                            y: text.geometry.y * newPageScale,
                                        }
                                    }

                                    if (level.textdocument && level.textdocument.geometry) {
                                        var textdocument = angular.copy(level.textdocument);
                                        level.textdocument.geometry = {
                                            width: textdocument.geometry.width * newPageScale,
                                            height: textdocument.geometry.height * newPageScale,
                                            x: textdocument.geometry.x * newPageScale,
                                            y: textdocument.geometry.y * newPageScale,
                                        }
                                        var docBackground = level.textdocument.background;
                                        if (docBackground.resource && docBackground.resource.identifier) {
                                            docBackground.offsetx = 0;
                                            docBackground.offsety = 0;
                                        }

                                        angular.forEach(level.textdocument.levels.level, function (lev, l) {
                                            if (lev.imageart && lev.imageart.geometry) {
                                                var docArt = angular.copy(lev.imageart);
                                                lev.imageart.geometry = {
                                                    width: docArt.geometry.width * newPageScale,
                                                    height: docArt.geometry.height * newPageScale,
                                                    x: docArt.geometry.x * newPageScale,
                                                    y: docArt.geometry.y * newPageScale,
                                                }
                                                lev.imageart.offsetx = docArt.offsetx * newPageScale;
                                                lev.imageart.offsety = docArt.offsety * newPageScale;
                                            }
                                            if (lev.textbox && lev.textbox.geometry) {
                                                var docText = angular.copy(lev.textbox);
                                                lev.textbox.geometry = {
                                                    width: docText.geometry.width * newPageScale,
                                                    height: docText.geometry.height * newPageScale,
                                                    x: docText.geometry.x * newPageScale,
                                                    y: docText.geometry.y * newPageScale,
                                                }
                                            }
                                        })
                                    }
                                    if (level.calMonthBox && level.calMonthBox.geometry) {
                                        var calMonthBox = angular.copy(level.calMonthBox);
                                        level.calMonthBox.geometry = {
                                            width: calMonthBox.geometry.width * newPageScale,
                                            height: calMonthBox.geometry.height * newPageScale,
                                            x: calMonthBox.geometry.x * newPageScale,
                                            y: calMonthBox.geometry.y * newPageScale,
                                        }
                                    }
                                    if (level.calTitleBox && level.calTitleBox.geometry) {
                                        var calTitleBox = angular.copy(level.calTitleBox);
                                        level.calTitleBox.geometry = {
                                            width: calTitleBox.geometry.width * newPageScale,
                                            height: calTitleBox.geometry.height * newPageScale,
                                            x: calTitleBox.geometry.x * newPageScale,
                                            y: calTitleBox.geometry.y * newPageScale,
                                        }
                                    }
                                })
                            }
                        })

                        var trimbox = resp.document.pages.page[0].trimbox;

                        pagesToPx(resp.document.pages.page, $scope.template.pages, 'pages');
                        if (resp.document.deletedPages && resp.document.deletedPages.page && resp.document.deletedPages.page.length) {
                            pagesToPx(resp.document.deletedPages.page, $scope.template.deletedPages)
                        }

                        $scope.template.backupPages = angular.copy(resp.document.backupPages);
                        if (resp.document.backupPages && resp.document.backupPages.list && resp.document.backupPages.list.length) {
                            $scope.template.backupPages.page = $scope.template.backupPages.list;
                            pagesToPx(resp.document.backupPages.list, $scope.template.backupPages)
                        }
                        vm.productTemplatePageCount = $scope.template.pages.page.length-1;

                        $scope.template.width = MmTurnPx(trimbox.width);
                        $scope.template.height = MmTurnPx(trimbox.height);
                        $scope.template.pages.page.forEach(function (page) {
                            ratioInfo(page)
                        })
                        $scope.visibleRight = $scope.template.pages.page.length>1 ? true : false;
                        var pages = $scope.template.pages.page;
                        setMargin();
                        $scope.currentPage = pages[0];
                        $scope.lastPage = pages[0];
                        $scope.initializePage = angular.copy(pages[0]);
                        loadAttribute();
                        $scope.currentPage.isScene = $scope.currentPage.scene ? true : false;
                        fontSizeInit($scope.currentPage.editbox.height);
                        getImageboxLen();
                        oldSizePx = angular.copy(pages[0].bloodPx);
                        oldSizeMm = angular.copy(pages[0].blood);
                        oldSizeMm.left = trimbox.x;
                        oldSizeMm.top = trimbox.y;

                        if (vm.isCustom) {
                            vm.tempType = 'customize';
                        } else if (vm.hasModel) {
                            vm.tempType = 'hasModel';
                        } else {
                            vm.tempType = 'noModel';
                            pageValueAccount(resp.document.pages.page);
                        }

                        $scope.template.pageI = 0;
                        $scope.template.levelI = 0;
                        setTimeout(function () {
                            oldPage = angular.copy(pages[0]);
                            currentPageElement();
                            pageListDrag();
                            vm.templateCopy = angular.copy($scope.template);
                            vm.loadingImg = false;
                            partListDrag();
                            measureRulerInit();
                        }, 2000)
                        var tempPageCount = 0;
                        $scope.template.pages.page.forEach(function (page) {
                            if (!page.backup) {
                                tempPageCount++;
                            }
                        })
                        // if (tempPageCount < vm.productTemplatePageCount) {
                        //     var _page = vm.page.pageTemplates[0];
                        //     var pageSize = {
                        //         height: _page.pageSizeH,
                        //         width: _page.pageSizeW
                        //     };
                        //     var editSize = [];
                        //     _page.pageEdits.forEach(function (editbox) {
                        //         editSize.push({
                        //             height: MmTurnPx(editbox.pageEditH),
                        //             width: MmTurnPx(editbox.pageEditW),
                        //             x: MmTurnPx(editbox.pageEditX),
                        //             y: MmTurnPx(editbox.pageEditY)
                        //         })
                        //     });
                        //     for (var i = tempPageCount; i < vm.productTemplatePageCount; i++) {
                        //         $scope.template.pages.page.push(createPage(_page, editSize, i));
                        //     }
                        // }
                        //推荐素材
                        vm.showCliparts = $scope.template.cliparts;
                        vm.materialTab=='USER';
                        //推荐背景
                        vm.showBackgrounds = $scope.template.bgimgs2;
                        //推荐相框
                        vm.showMasks = $scope.template.masks;
                        //推荐边框
                        vm.frameConfigs = $scope.template.frameConfigs.frameConfig;
                        vm.borderTab=='RECOMMEND';
                    })
                },400)
            })
        }

        function getDocumentXml(resp,callback) {
            if(resp.document.xLines && resp.document.xLines.line){
                vm.sublinesX = resp.document.xLines.line
            }
            if(resp.document.yLines && resp.document.yLines.line){
                vm.sublinesY = resp.document.yLines.line
            }
            vm.page = getPageFromProductXml(resp);
            if(!vm.page.id){
                vm.navList[12].isShow = true;
            }
            preparePageInfo();
            vm.page.name = resp.name;
            vm.productTemplatePageCount = resp.pageCount;
            resp.document.pages.page.forEach(function (page) {
                if (page.levels && page.levels.level && page.levels.level.length > 0) {
                    page.levels.level.sort(compare('seq', true));
                }
            })
            vm.page.provider = resp.provider;
            vm.page.identifier = resp.identifier;

            vm.page.productType = resp.productType;
            vm.page.modelData = resp.modelData;
            vm.page.modelBlendent = resp.modelBlendent;
            vm.page.modelPath = resp.modelPath;
            vm.page.modelType = resp.modelType;
            vm.page.modelName = resp.modelName;
            vm.page.modelPic = resp.modelPic;
            vm.hashtags = resp.hashtags;
            if (resp.productTemplateHasModel) {
                vm.hasModel = true;
            } else {
                vm.hasModel = false;
            }
            if (resp.document.bgimgs) {
                $scope.template.bgimgs.bgimg = angular.copy(resp.document.bgimgs.bgimg) || [];
            }
            if (resp.document.psdFiles) {
                $scope.template.psdFiles.psdFile = angular.copy(resp.document.psdFiles.psdFile) || [];
            }
            $scope.template.bgimgs2.bgimg = angular.copy(resp.document.bgimgs2.bgimg) || [];
            $scope.template.masks.mask = angular.copy(resp.document.masks.mask) || [];
            $scope.template.cliparts.clipart = angular.copy(resp.document.cliparts.clipart) || [];
            $scope.template.frameConfigs.frameConfig = angular.copy(resp.document.frameConfigs.frameConfig) || [];
            $scope.template.documentpics.documentpic = angular.copy(resp.document.documentpics.documentpic) || [];
            $scope.template.piclayouts = {piclayout: []};
            if (resp.document.piclayouts && resp.document.piclayouts.piclayout) {
                $scope.template.piclayouts.piclayout = angular.copy(resp.document.piclayouts.piclayout)
            }

            $scope.template.deletedPages = angular.copy(resp.document.deletedPages);
            $scope.template.backupPages = angular.copy(resp.document.backupPages);
            $scope.template.pages = angular.copy(resp.document.pages);
            if(resp.document.config.parts.list){
                resp.document.config.parts.list.forEach(function (part) {
                    if(!part.editboxes){
                        part.editboxes={
                            editbox:[
                                angular.copy(part.mediabox)
                            ]
                        }
                    }
                })
            }
            $scope.template.config = angular.copy(resp.document.config);
            vm.backupPartId = $scope.template.config.parts.list[0].id;

            $scope.template.piclayouts.piclayout.some(function (data, i) {
                data.identifier = data.resource.identifier
            })
            angular.forEach($scope.template.bgimgs2.bgimg, function (bgImg, i) {
                bgImg.isRecommend = true;
                angular.forEach(vm.bgimgs2.bgimg, function (b) {
                    if (b.identifier == bgImg.identifier) {
                        b.isRecommend = true;
                        bgImg.id = b.id;
                    }
                })
            });
            angular.forEach($scope.template.masks.mask, function (mask, i) {
                mask.isRecommend = true;
                angular.forEach(vm.showMasks.mask, function (m) {
                    if (m.identifier == mask.resource.identifier) {
                        m.isRecommend = true;
                        mask.id = m.id;
                    }
                })
            });
            angular.forEach($scope.template.cliparts.clipart, function (clipart, i) {
                clipart.isRecommend = true;
            });
            angular.forEach($scope.template.frameConfigs.frameConfig, function (frameConfig, i) {
                frameConfig.isRecommend = true;
            });

            var page0 = resp.document.pages.page[0];
            if (!page0.editbox) {
                page0.editbox = page0.trimbox;
            }
            angular.forEach(resp.document.pages.page, function (page, i) {
                var _pageItem = vm.page;
                if(vm.page.pageTemplates[i]){
                    _pageItem = vm.page.pageTemplates[i];
                }
                var mediaboxW = angular.copy(resp.document.pages.page[i].mediabox.width);
                var newPageScale = _pageItem.pageSizeW / mediaboxW;

                page.blood = {
                    top: _pageItem.pageBloodT,
                    bottom: _pageItem.pageBloodB,
                    left: _pageItem.pageBloodL,
                    right: _pageItem.pageBloodR,
                };


                if (newPageScale != 1) {
                    if (page.background.resource && page.background.resource.identifier) {
                        page.background.offsetx = page.background.offsetx * newPageScale;
                        page.background.offsety = page.background.offsety * newPageScale;
                    }
                    if (page.barcode && page.barcode.geometry) {
                        var barcode = angular.copy(page.barcode.geometry);
                        page.barcode.geometry = {
                            width: barcode.width * newPageScale,
                            height: barcode.height * newPageScale,
                            x: barcode.x * newPageScale,
                            y: barcode.y * newPageScale,
                        }

                    }
                    if (page.qrcode && page.qrcode.geometry) {
                        var qrcode = angular.copy(page.qrcode.geometry);
                        page.qrcode.geometry = {
                            width: qrcode.width * newPageScale,
                            height: qrcode.height * newPageScale,
                            x: qrcode.x * newPageScale,
                            y: qrcode.y * newPageScale,
                        }

                    }
                    angular.forEach(page.levels.level, function (level, n) {
                        if (level.imageart && level.imageart.geometry) {
                            var art = angular.copy(level.imageart);
                            level.imageart.geometry = {
                                width: art.geometry.width * newPageScale,
                                height: art.geometry.height * newPageScale,
                                x: art.geometry.x * newPageScale,
                                y: art.geometry.y * newPageScale,
                            }
                            level.imageart.offsetx = art.offsetx * newPageScale;
                            level.imageart.offsety = art.offsety * newPageScale;
                        }

                        if (level.imagebox && level.imagebox.geometry) {
                            var image = angular.copy(level.imagebox);
                            level.imagebox.transparency = level.imagebox.transparency === null ? 1 : level.imagebox.transparency;
                            level.imagebox.geometry = {
                                width: image.geometry.width * newPageScale,
                                height: image.geometry.height * newPageScale,
                                x: image.geometry.x * newPageScale,
                                y: image.geometry.y * newPageScale,
                            };
                            if (image.image && image.image.resource && image.image.resource.identifier) {
                                level.imagebox.image.offsetx = image.image.offsetx * newPageScale;
                                level.imagebox.image.offsety = image.image.offsety * newPageScale;
                                level.imagebox.image.resource.width = image.image.resource.width * newPageScale;
                                level.imagebox.image.resource.height = image.image.resource.height * newPageScale;
                                level.imagebox.image.width = image.image.width * newPageScale;
                                level.imagebox.image.height = image.image.height * newPageScale;
                            }
                        }
                        if (level.textbox && level.textbox.geometry) {
                            var text = angular.copy(level.textbox);
                            level.textbox.geometry = {
                                width: text.geometry.width * newPageScale,
                                height: text.geometry.height * newPageScale,
                                x: text.geometry.x * newPageScale,
                                y: text.geometry.y * newPageScale,
                            }
                        }

                        if (level.textdocument && level.textdocument.geometry) {
                            var textdocument = angular.copy(level.textdocument);
                            level.textdocument.geometry = {
                                width: textdocument.geometry.width * newPageScale,
                                height: textdocument.geometry.height * newPageScale,
                                x: textdocument.geometry.x * newPageScale,
                                y: textdocument.geometry.y * newPageScale,
                            }
                            var docBackground = level.textdocument.background;
                            if (docBackground.resource && docBackground.resource.identifier) {
                                docBackground.offsetx = 0;
                                docBackground.offsety = 0;
                            }

                            angular.forEach(level.textdocument.levels.level, function (lev, l) {
                                if (lev.imageart && lev.imageart.geometry) {
                                    var docArt = angular.copy(lev.imageart);
                                    lev.imageart.geometry = {
                                        width: docArt.geometry.width * newPageScale,
                                        height: docArt.geometry.height * newPageScale,
                                        x: docArt.geometry.x * newPageScale,
                                        y: docArt.geometry.y * newPageScale,
                                    }
                                    lev.imageart.offsetx = docArt.offsetx * newPageScale;
                                    lev.imageart.offsety = docArt.offsety * newPageScale;
                                }
                                if (lev.textbox && lev.textbox.geometry) {
                                    var docText = angular.copy(lev.textbox);
                                    lev.textbox.geometry = {
                                        width: docText.geometry.width * newPageScale,
                                        height: docText.geometry.height * newPageScale,
                                        x: docText.geometry.x * newPageScale,
                                        y: docText.geometry.y * newPageScale,
                                    }
                                }
                            })
                        }
                        if (level.calMonthBox && level.calMonthBox.geometry) {
                            var calMonthBox = angular.copy(level.calMonthBox);
                            level.calMonthBox.geometry = {
                                width: calMonthBox.geometry.width * newPageScale,
                                height: calMonthBox.geometry.height * newPageScale,
                                x: calMonthBox.geometry.x * newPageScale,
                                y: calMonthBox.geometry.y * newPageScale,
                            }
                        }
                        if (level.calTitleBox && level.calTitleBox.geometry) {
                            var calTitleBox = angular.copy(level.calTitleBox);
                            level.calTitleBox.geometry = {
                                width: calTitleBox.geometry.width * newPageScale,
                                height: calTitleBox.geometry.height * newPageScale,
                                x: calTitleBox.geometry.x * newPageScale,
                                y: calTitleBox.geometry.y * newPageScale,
                            }
                        }
                    })
                }
            })

            var trimbox = resp.document.pages.page[0].trimbox;

            pagesToPx(resp.document.pages.page, $scope.template.pages, 'pages');
            if (resp.document.deletedPages && resp.document.deletedPages.page && resp.document.deletedPages.page.length) {
                pagesToPx(resp.document.deletedPages.page, $scope.template.deletedPages)
            }
            $scope.template.backupPages = angular.copy(resp.document.backupPages);
            if (resp.document.backupPages && resp.document.backupPages.list && resp.document.backupPages.list.length) {
                $scope.template.backupPages.page = $scope.template.backupPages.list;
                pagesToPx(resp.document.backupPages.list, $scope.template.backupPages)
            }

            $scope.template.width = MmTurnPx(trimbox.width);
            $scope.template.height = MmTurnPx(trimbox.height);
            $scope.template.pages.page.forEach(function (page) {
                ratioInfo(page)
            })
            $scope.visibleRight = $scope.template.pages.page.length>1 ? true : false;
            var pages = $scope.template.pages.page;
            setMargin();
            $scope.currentPage = pages[0];
            $scope.lastPage = pages[0];
            $scope.initializePage = angular.copy(pages[0]);
            loadAttribute();
            $scope.currentPage.isScene = $scope.currentPage.scene ? true : false;
            fontSizeInit($scope.currentPage.editbox.height);
            getImageboxLen();
            oldSizePx = angular.copy(pages[0].bloodPx);
            oldSizeMm = angular.copy(pages[0].blood);
            oldSizeMm.left = trimbox.x;
            oldSizeMm.top = trimbox.y;

            if (vm.isCustom) {
                vm.tempType = 'customize';
            } else if (vm.hasModel) {
                vm.tempType = 'hasModel';
            } else {
                vm.tempType = 'noModel';
                pageValueAccount(resp.document.pages.page);
            }

            $scope.template.pageI = 0;
            $scope.template.levelI = 0;
            setTimeout(function () {
                pageCoverInit(function () {
                    oldPage = angular.copy(pages[0]);
                    currentPageElement();
                    pageListDrag();
                    vm.templateCopy = angular.copy($scope.template);
                    partListDrag();
                    measureRulerInit();
                    vm.loadingImg = false;
                    if(callback){callback()}
                });
            }, 2000)
            var tempPageCount = 0;
            $scope.template.pages.page.forEach(function (page) {
                if (!page.backup) {
                    tempPageCount++;
                }
            })
            // if (tempPageCount < vm.productTemplatePageCount) {
            //     var _page = vm.page.pageTemplates[0];
            //     var pageSize = {
            //         height: _page.pageSizeH,
            //         width: _page.pageSizeW
            //     };
            //     var editSize = [];
            //     _page.pageEdits.forEach(function (editbox) {
            //         editSize.push({
            //             height: MmTurnPx(editbox.pageEditH),
            //             width: MmTurnPx(editbox.pageEditW),
            //             x: MmTurnPx(editbox.pageEditX),
            //             y: MmTurnPx(editbox.pageEditY)
            //         })
            //     });
            //     for (var i = tempPageCount; i < vm.productTemplatePageCount; i++) {
            //         $scope.template.pages.page.push(createPage(_page, editSize, i));
            //     }
            // }
        }
        function pageCoverInit(callback) {
            var _pageIndex = -1;
            for(var i=0; i<$scope.template.pages.page.length; i++){
                var page = $scope.template.pages.page[i];
                if(page.levels && page.levels.level && (!page.pagecover || !page.pagecover.identifier)){
                    page.levels.level.forEach(function (level) {
                        if(level.calMonthBox || level.calTitleBox){
                            _pageIndex = i;
                        }
                    })
                }
                if(_pageIndex > -1){
                    break
                }
            }
            if(_pageIndex>-1){
                $scope.thisThumbnailUpdate(_pageIndex,function () {
                    if($scope.template.pages.page[_pageIndex]&&$scope.template.pages.page[_pageIndex].pagecover&&$scope.template.pages.page[_pageIndex].pagecover.identifier){
                        var _pageCover = $scope.template.pages.page[_pageIndex].pagecover.identifier;
                        $scope.template.pages.page.forEach(function (page) {
                            var isUpdate = false;
                            if(page.levels && page.levels.level && (!page.pagecover || !page.pagecover.identifier)){
                                page.levels.level.forEach(function (level) {
                                    if(level.calMonthBox || level.calTitleBox){
                                        isUpdate = true;
                                    }
                                })
                            }
                            if(isUpdate){
                                page.updateThumbnail = true;
                                page.pagecover={
                                    identifier:_pageCover,
                                    provider:'qiniu'
                                }
                            }
                        })
                        callback()
                    }else{
                        callback()
                    }
                })
            }else{
                callback()
            }
        }

        function getPageFromProductXml(res) {
            var item = {
                id: res.productTemplateId,
                name: res.name,
                seq: 1,
                modelPath: res.modelPath,
                modelType: res.modelType,
                pageSizeH: '',
                pageSizeW: '',
                pageBloodT: '',
                pageBloodB: '',
                pageBloodL: '',
                pageBloodR: '',
                pageEdits: [],
                pageEditUnit: 'mm',
                pageSizeUnit: 'mm',
                pageBloodUnit: 'mm',
                pageEditUnit1: 'mm',
                pageSizeUnit1: 'mm',
                pageBloodUnit1: 'mm',
                cover: res.cover,
                status: true,
                pageCount: res.pageCount,
                catalog: {
                    id: res.catalogId,
                    name: res.catalogName
                },
                reuse: true,
                bindingType: res.bindingType,
                pattern: res.pattern,
                replace: res.replace,
                pageTemplates: [],
                addpage: res.document.addpage,
                minpage: res.document.minpage,
                maxpage: res.document.maxpage,
                addunit: res.document.addunit
            };
            var _page = res.document.pages.page;
            for(var i=0; i<_page.length; i++){
                var _data = {
                    seq:_page[i].seq,
                    pageSizeH:_page[i].mediabox.height,
                    pageSizeW:_page[i].mediabox.width,
                    pageBloodT:_page[i].trimbox.y,
                    pageBloodB:_page[i].mediabox.height - _page[i].trimbox.height - _page[i].trimbox.y,
                    pageBloodL:_page[i].trimbox.x,
                    pageBloodR:_page[i].mediabox.width - _page[i].trimbox.width - _page[i].trimbox.x,
                    pageEdits:[],
                    pageEditUnit: 'mm',
                    pageSizeUnit: 'mm',
                    pageBloodUnit: 'mm',
                    pageEditUnit1: 'mm',
                    pageSizeUnit1: 'mm',
                    pageBloodUnit1: 'mm',
                    cancelled:false,
                    productTemplateId:_page[i].productTemplateId,
                    mould:null,
                };
                if(_page[i].editboxes && _page[i].editboxes.editbox){
                    _page[i].editboxes.editbox.forEach(function (editbox) {
                        _data.pageEdits.push({
                            pageEditX:editbox.x,
                            pageEditY:editbox.y,
                            pageEditW:editbox.width,
                            pageEditH:editbox.height,
                        })
                    })
                }
                if(_page[i].scene){
                    _data.mould = {
                        cancelled: false,
                        gHeight: _page[i].scene.geometry.height,
                        gWidth: _page[i].scene.geometry.width,
                        height: _page[i].scene.imagebox.geometry.height,
                        hierarchy: _page[i].scene.hierarchy,
                        modelPic:  _page[i].scene.resource.identifier,
                        number: _page[i].scene.number,
                        sizeUnit: _page[i].scene.unit,
                        width: _page[i].scene.imagebox.geometry.width,
                        x: _page[i].scene.imagebox.geometry.x,
                        y: _page[i].scene.imagebox.geometry.y
                    }
                }
                item.pageTemplates.push(_data)
            }
            item.pageSizeH = item.pageTemplates[0].pageSizeH;
            item.pageSizeW = item.pageTemplates[0].pageSizeW;
            item.pageBloodT = item.pageTemplates[0].pageBloodT;
            item.pageBloodB = item.pageTemplates[0].pageBloodB;
            item.pageBloodL = item.pageTemplates[0].pageBloodL;
            item.pageBloodR = item.pageTemplates[0].pageBloodR;
            item.pageEdits = item.pageTemplates[0].pageEdits;

            return item;
        }

        function preparePageInfo() {
            vm.page.editboxs = [];
            vm.page.pageEdits.forEach(function (pageEdit) {
                vm.page.editboxs.push({
                    width: pageEdit.pageEditW,
                    height: pageEdit.pageEditH,
                    x: pageEdit.pageEditX,
                    y: pageEdit.pageEditY
                })
            });
            vm.page.pageSize = {
                width: vm.page.pageSizeW,
                height: vm.page.pageSizeH
            };
            vm.productTemplatePageCount = vm.page.pageCount;

            // 判断是否是标准模板
            if (vm.page.id) {
                vm.isCustom = false;
            } else {
                vm.isCustom = true;
            }
            if (!vm.page.pageTemplates || !vm.page.pageTemplates[0] || !vm.page.pageTemplates[0].mould) {
                vm.isMould = false;
            } else {
                vm.isMould = true;
            }
            // 判断标准模板是否选择模型
            if (vm.page.hasModel) {
                vm.hasModel = true;
            } else {
                vm.hasModel = false;
            }
        }

        function createPage(_page, editSize, i) {
            var _page1 = {
                uuid: UidService.get(),
                isScene: false,
                bgImg: '',
                background: {resource: {},color:'#ffffff', type: "Color"},
                pagecover: {},
                levels: {},
                barcode: {},
                qrcode: {},
                editbox: editSize[0],
                editboxes: {
                    editbox: editSize
                },
                mediabox: {
                    height: MmTurnPx(_page.pageSizeH),
                    width: MmTurnPx(_page.pageSizeW),
                },
                trimbox: {
                    height: MmTurnPx(_page.pageSizeH) - Number(MmTurnPx(_page.pageBloodB)) - Number(MmTurnPx(_page.pageBloodT)),
                    width: MmTurnPx(_page.pageSizeW) - Number(MmTurnPx(_page.pageBloodL)) - Number(MmTurnPx(_page.pageBloodR)),
                    x: MmTurnPx(_page.pageBloodL),
                    y: MmTurnPx(_page.pageBloodT)
                },
                blood: {
                    top: _page.pageBloodT,
                    bottom: _page.pageBloodB,
                    left: _page.pageBloodL,
                    right: _page.pageBloodR,
                },
                bloodPx: {
                    top: MmTurnPx(_page.pageBloodT),
                    bottom: MmTurnPx(_page.pageBloodB),
                    left: MmTurnPx(_page.pageBloodL),
                    right: MmTurnPx(_page.pageBloodR),
                },
                scale: 1,
                proportion: 1,
                seq: i + 1,
                spread: false,
                backup: false,
                unreplace: !vm.page.replace
            }
            return _page1;
        }

        function ratioInfo(page) {
            vm.windowWidth = 800;
            vm.windowHeight = 800;
            if (!page.isScene) {
                var ratio = page.mediabox.width / page.mediabox.height;
                var ratio1 = vm.windowWidth / vm.windowHeight;
                if (ratio >= ratio1) {
                    page.ratio = vm.windowWidth / page.mediabox.width;
                } else {
                    page.ratio = vm.windowHeight / page.mediabox.height;
                }
            } else {
                var ratio = page.scene.geometry.width / page.scene.geometry.height;
                var ratio1 = vm.windowWidth / vm.windowHeight;
                if (ratio >= ratio1) {
                    page.ratio = vm.windowWidth / page.scene.geometry.width;
                } else {
                    page.ratio = vm.windowHeight / page.scene.geometry.height;
                }
            }
        }

        function pageValueAccount(pages) {
            var list = [];
            if (pages) {
                for (var i = 0; i < pages.length; i++) {
                    var _page = pages[i];
                    var arr = {};
                    arr.id = i;
                    arr.value = '宽：' + _page.mediabox.width + 'mm 高：' + _page.mediabox.height + 'mm';
                    arr.mediabox = {
                        height: _page.mediabox.height,
                        width: _page.mediabox.width,
                        // name:'画布尺寸'
                    };
                    arr.editbox = {
                        height: _page.editbox.height,
                        width: _page.editbox.width,
                        x: _page.editbox.x,
                        y: _page.editbox.y,
                        // name:'编辑区域'
                    }
                    arr.blood = {
                        top: _page.trimbox.y,
                        bottom: _page.mediabox.height - _page.trimbox.y - _page.trimbox.height,
                        left: _page.trimbox.x,
                        right: _page.mediabox.width - _page.trimbox.x - _page.trimbox.width,
                        // name:'出血尺寸'
                    }
                    list.push(arr);

                }
            } else {
                for (var i = 0; i < vm.page.pageTemplates.length; i++) {
                    var _page = vm.page.pageTemplates[i];
                    var arr = {};
                    arr.id = i;
                    arr.value = '宽：' + _page.pageSizeW + 'mm 高：' + _page.pageSizeH + 'mm';
                    arr.mediabox = {
                        height: _page.pageSizeH,
                        width: _page.pageSizeW,
                        // name:'画布尺寸'
                    };
                    arr.editbox = {
                        height: _page.pageEditH,
                        width: _page.pageEditW,
                        x: _page.pageEditX,
                        y: _page.pageEditY,
                        // name:'编辑区域'
                    };
                    arr.blood = {
                        top: _page.pageBloodT,
                        bottom: _page.pageBloodB,
                        left: _page.pageBloodL,
                        right: _page.pageBloodR,
                        // name:'出血尺寸'
                    }
                    list.push(arr);
                }
            }

            //封装成方法，通过某个属性去重
            function filterRepeat(arr, prop) {
                if (arr == null || !(arr instanceof Array)) {
                    return arr;
                }
                return arr.filter(function (element, index, self) {
                    // return self.findIndex(el=>el[prop]==element[prop])===index
                    return self.findIndex(function (el) {
                        return el[prop] == element[prop]
                    }) === index
                })
            }

            //自定义去重方法
            function filterRepeat2(arr, compareFn) {
                return arr.filter(function (element, index, self) {
                    // return self.findIndex(el=>compareFn(el,element))===index
                    return self.findIndex(function (el) {
                        return compareFn(el, element)
                    }) === index
                })
            }

            //加载到数组原型上
            Array.prototype.filterRepeat = function () {
                if (typeof arguments[0] == 'string') return filterRepeat(this, arguments[0])
                return filterRepeat2(this, arguments[0])
            }

            vm.addPageValue = list.filterRepeat(function (a, b) {
                return a.mediabox.width == b.mediabox.width && a.mediabox.height == b.mediabox.height &&
                    a.editbox.width == b.editbox.width && a.editbox.height == b.editbox.height && a.editbox.x == b.editbox.x && a.editbox.y == b.editbox.y &&
                    a.blood.width == b.blood.width && a.blood.height == b.blood.height && a.blood.x == b.blood.x && a.blood.y == b.blood.y
            });
        }

        $scope.changeCatalog = function () {
            groupPicLayoutXmls();
        }

        function groupPicLayoutXmls() {
            vm.picLayoutXmlGroup = {};
            PicLayoutXmls.getAll({
                items: [{key: "catalog.id", op: "=", value: vm.catalogId}], sort: ["id,asc"]
            }, function (res) {
                vm.picLayoutXmlsList = [];
                var map = {}
                for (var i = 0; i < res.length; i++) {
                    var ai = res[i];
                    var quantity = ai.quantity;
                    if (ai.quantity > 8) {
                        quantity = 9;
                    }
                    if (!map[quantity]) {
                        map[quantity] = [ai]
                    } else {
                        map[quantity].push(ai)
                    }
                }

                Object.keys(map).forEach(function (key) {
                    var name = key + "张照片";
                    if (key == 9) {
                        name = key + "张及以上照片";
                    }
                    vm.picLayoutXmlsList.push({
                        name: name,
                        data: map[key],
                    })
                })
                if (vm.picLayoutXmlsList.length > 0) {
                    vm.picLayoutXmlGroup = vm.picLayoutXmlsList[0];
                    var len = 0;
                    angular.forEach(vm.picLayoutXmlGroup.data, function (data) {
                        var result = ListService.inList(data, $scope.template.piclayouts.piclayout, ["identifier"]);
                        if (result) {
                            data.isRecommend = true;
                            len++;
                        }
                        if (len == vm.picLayoutXmlGroup.data.length) {
                            vm.picLayoutXmlGroup.layoutChooseAll = true;
                        } else {
                            vm.picLayoutXmlGroup.layoutChooseAll = false;
                        }
                    })
                }

            });
        }

        $scope.selectLayoutLabel = function (label, index) {
            vm.picLayoutXmlGroup = label;
        };

        $scope.addLayout = function (data, index) {
            if(vm.textEditor){
                return
            }
            PicLayoutXmls.covert({key: data.identifier}, function (res) {
                var arr = getGeometry(res.mediabox);
                $scope.currentPage = $scope.template.pages.page[$scope.template.pageI];
                var scale1 = $scope.currentPage.mediabox.width / $scope.currentPage.mediabox.height;
                var scale2 = arr.width / arr.height;
                var newH = null, newW = null, pageScale = null;
                if (scale1 >= scale2) {
                    newH = $scope.currentPage.mediabox.height;
                    // newW = $scope.currentPage.mediabox.height / arr.height * arr.width;
                    pageScale = newH / arr.height;
                } else {
                    newW = $scope.currentPage.mediabox.width;
                    // newH = $scope.currentPage.mediabox.width / arr.width * arr.height;
                    pageScale = newW / arr.width;
                }

                var levels = res.levels.level;
                angular.forEach(levels, function (level, i) {
                    var imagebox = level.imagebox;
                    imagebox.geometry = getGeometry(imagebox.geometry);
                    if (imagebox.shadow == null) {
                        imagebox.shadow = {
                            color: '#777777',
                            x: 0,
                            y: 0,
                            blur: 0
                        }
                    }
                    if (imagebox.border == null) {
                        imagebox.border = {
                            shape: 'Rectangle',
                            radius: {
                                lt: 0,
                                rt: 0,
                                rb: 0,
                                lb: 0,
                                all: 0,
                                filletType: 'Fixed'
                            },
                            "edge": {
                                top: 0,
                                right: 0,
                                bottom: 0,
                                left: 0
                            },
                            lineWidth: 0,
                            type: "Color",
                            lineType: "solid",
                            resource: {
                                "identifier": ''
                            },
                            color: '#000000',
                        }
                    }
                    level.imagebox = ({
                        geometry: {
                            width: imagebox.geometry.width * pageScale,
                            height: imagebox.geometry.height * pageScale,
                            x: imagebox.geometry.x * pageScale,
                            y: imagebox.geometry.y * pageScale,
                        },
                        rotation: {
                            angle:360+Number(imagebox.rotation.angle)
                        },
                        mask: imagebox.mask,
                        imgUrl: 'content/images/mask_souce2.png',
                        maskUrl: imagebox.mask.resource.identifier || 'content/images/mask_souce2.png',
                        bgImg: '',
                        unit: 'mm',
                        levelI: $scope.template.levelI,
                        pageI: $scope.template.pageI,
                        current: 'imagebox',
                        lock: false,
                        border:angular.copy(imagebox.border),
                        shadow:angular.copy(imagebox.shadow),
                        transparency:isNaN(imagebox.transparency) ? 1 : imagebox.transparency
                    })
                    if (level.imagebox.image && level.imagebox.image.resource && level.imagebox.image.resource.identifier) {       //qiniu
                    } else {
                        var imagecanvas = document.createElement('canvas');
                        var imagecontext = imagecanvas.getContext('2d');
                        var newImg = document.createElement('img');
                        newImg.crossOrigin = "Anonymous";
                        newImg.src = 'content/images/mask_souce2.png';
                        newImg.onload = function () {
                            newImg.onload = null;
                            var width = newImg.width;
                            var height = newImg.height;
                            var masks = document.createElement('img');
                            masks.crossOrigin = "anonymous";
                            masks.onload = function () {
                                masks.onload = null;
                                imagecanvas.width = width;
                                imagecanvas.height = height;
                                imagecontext.drawImage(masks, 0, 0, width, height);
                                imagecontext.globalCompositeOperation = 'source-in';
                                imagecontext.drawImage(newImg, 0, 0);
                                level.imagebox.bgImg = ImageService.dataURLtoBlob(imagecanvas.toDataURL());
                                $scope.$apply();
                            };
                            masks.src = level.imagebox.mask.resource.identifier;
                        };
                        newImg.src = 'content/images/mask_souce2.png';
                    }
                })


                if ($scope.currentPage.levels.level && $scope.currentPage.levels.level.length) {
                    for (var i = $scope.currentPage.levels.level.length - 1; i >= 0; i--) {
                        var level = $scope.currentPage.levels.level[i];
                        if (level.imagebox && level.imagebox.geometry) {
                            $scope.currentPage.levels.level.splice(i, 1)
                        }
                    }
                }

                angular.forEach(levels, function (level, i) {
                    if ($scope.currentPage.levels.level && $scope.currentPage.levels.level.length) {
                        level.imagebox.levelI = $scope.currentPage.levels.level.length;
                        level.seq = $scope.currentPage.levels.level.length - 0 + 1;
                    } else {
                        $scope.currentPage.levels.level = [];
                        level.levelI = 0;
                    }

                    $scope.currentPage.levels.level.push(level);
                })
                updateHistorys();
            })
            return
        }

        $scope.recommendLayout = function (data) {
            data.isRecommend = !data.isRecommend;
            piclayoutToDoc(data);
            layoutChooseAll()
        };
        function layoutChooseAll(){
            vm.picLayoutXmlGroup.layoutChooseAll = true;
            vm.picLayoutXmlGroup.data.forEach(function (item) {
                if(!item.isRecommend){
                    vm.picLayoutXmlGroup.layoutChooseAll = false;
                }
            })
        }

        $scope.recommendAllLayout = function (e) {
            fn(e)
            vm.picLayoutXmlGroup.layoutChooseAll = !vm.picLayoutXmlGroup.layoutChooseAll
            vm.picLayoutXmlGroup.data.some(function (data) {
                data.isRecommend = vm.picLayoutXmlGroup.layoutChooseAll;
                var result = ListService.inList(data, $scope.template.piclayouts.piclayout, ["identifier"]);
                if (data.isRecommend) {
                    if (result) {

                    } else {
                        $scope.template.piclayouts.piclayout.push({
                            identifier: data.identifier,
                            resource: {
                                provider: 'qiniu',
                                identifier: data.identifier,
                            },
                            thumbnailresource: {
                                provider: 'qiniu',
                                identifier: data.cover,
                            },
                            quantity: data.quantity
                        })
                    }
                } else {
                    if (result) {
                        for (var i = $scope.template.piclayouts.piclayout.length - 1; i >= 0; i--) {
                            if ($scope.template.piclayouts.piclayout[i].identifier == result.identifier) {
                                $scope.template.piclayouts.piclayout.splice(i, 1);
                            }
                        }
                    } else {

                    }
                }
            })
        }

        function piclayoutToDoc(data) {
            var result = ListService.inList(data, $scope.template.piclayouts.piclayout, ["identifier"]);
            if (result) {
                for (var i = $scope.template.piclayouts.piclayout.length - 1; i >= 0; i--) {
                    if ($scope.template.piclayouts.piclayout[i].identifier == result.identifier) {
                        $scope.template.piclayouts.piclayout.splice(i, 1);
                    }
                }
            } else {
                $scope.template.piclayouts.piclayout.push({
                    identifier: data.identifier,
                    resource: {
                        provider: 'qiniu',
                        identifier: data.identifier,
                    },
                    thumbnailresource: {
                        provider: 'qiniu',
                        identifier: data.cover,
                    },
                    quantity: data.quantity
                })
            }
        }

        function imageboxResourceCanvas(item, callback) {

            var image = angular.copy(item);
            var imagecanvas = document.createElement('canvas');
            var imagecontext = imagecanvas.getContext('2d');
            var newImg = document.createElement('img');
            newImg.crossOrigin = "Anonymous";
            newImg.src = image.imgUrl;
            newImg.onload = function () {
                newImg.onload = null;
                var _image = getImageSource(newImg, image, image.image.resource.identifier);
                var scaleW = _image.width / newImg.width;
                var scaleH = _image.height / newImg.height;
                var masks = document.createElement('img');
                var maskUrl = 'content/images/mask_souce2.png';
                if (image.mask && image.mask.resource && image.mask.resource.identifier) {
                    maskUrl = image.mask.resource.identifier
                }
                image.maskUrl = maskUrl;
                masks.src = maskUrl;
                masks.crossOrigin = "anonymous";
                masks.onload = function () {
                    masks.onload = null;
                    masks.width = image.geometry.width;
                    masks.height = image.geometry.height;
                    imagecanvas.width = masks.width;
                    imagecanvas.height = masks.height;
                    imagecontext.drawImage(masks, 0, 0, masks.width, masks.height);
                    imagecontext.globalCompositeOperation = 'source-in';

                    imagecontext.scale(scaleW, scaleH);
                    imagecontext.scale(item.image.scale, item.image.scale);
                    imagecontext.drawImage(newImg, item.image.offsetx / scaleW, item.image.offsety / scaleH);
                    var pic = imagecanvas.toDataURL();
                    image.bgImg = ImageService.dataURLtoBlob(pic);
                    item.bgImg = ImageService.dataURLtoBlob(pic);
                    updateHistorys();
                    $scope.$digest();
                };
                masks.src = maskUrl;
                if (callback) {
                    callback()
                }
            };
            newImg.src = image.imgUrl;
        }

        /**
         * 宽高坐标从 mm 换算成 px
         * @param obj
         * @param index
         * @returns {{height: number, width: number, x: number, y: number}}
         */
        function getGeometry(obj) {
            return {
                height: MmTurnPx(obj.height),
                width: MmTurnPx(obj.width),
                x: MmTurnPx(obj.x),
                y: MmTurnPx(obj.y)
            }
        }

        var elem = document.querySelector('input[type="range"]');

        var rangeValue = function () {
            $(".transparency-num").val(elem.value);
            $scope.selectBox.transparency = parseFloat(elem.value);
            $scope.template.transparency = elem.value * 100;
            $scope.$digest();
        };

        elem.addEventListener("input", rangeValue);

        $scope.transparencyChange = function () {
            var level = $scope.currentPage.levels.level[$scope.template.levelI];
            if ($scope.template.transparency > 100) {
                MessageService.error("透明度有效范围：0~100");
                $scope.template.transparency = 100;
            }
            $(elem).val($scope.template.transparency / 100);
            level[$scope.selectBox.current].transparency = $scope.template.transparency / 100;
            updateHistorys();
        }

        // 左边侧边栏点击切换
        $scope.selectPanel = function (attr) {
            $scope.selPanel = attr;
            vm.leftShow = true;
            $(".leftPanel-mainContent").removeClass('hide1');
            $(".rightPanel").removeClass('rightPanel-big rightPanel-big1 rightPanel-big2 rightPanel-big3');
            if (attr == 'page') {
                if (vm.unit == 'mm') {
                    $scope.pageValue.mediabox.width = PxTurnMm($scope.currentPage.mediabox.width);
                    $scope.pageValue.mediabox.height = PxTurnMm($scope.currentPage.mediabox.height);
                } else if (vm.unit == 'px') {
                    $scope.pageValue.mediabox.width = $scope.currentPage.mediabox.width;
                    $scope.pageValue.mediabox.height = $scope.currentPage.mediabox.height;
                } else if (vm.unit == 'in') {
                    $scope.pageValue.mediabox.width = InTurnPx($scope.currentPage.mediabox.width);
                    $scope.pageValue.mediabox.height = InTurnPx($scope.currentPage.mediabox.height);
                }
                $scope.selPanel = attr;
            }

            if (attr == 'design') {
                if (vm.unit == 'mm') {
                    $scope.pageValue.mediabox.width = PxTurnMm($scope.currentPage.mediabox.width);
                    $scope.pageValue.mediabox.height = PxTurnMm($scope.currentPage.mediabox.height);
                } else if (vm.unit == 'px') {
                    $scope.pageValue.mediabox.width = $scope.currentPage.mediabox.width;
                    $scope.pageValue.mediabox.height = $scope.currentPage.mediabox.height;
                } else if (vm.unit == 'in') {
                    $scope.pageValue.mediabox.width = InTurnPx($scope.currentPage.mediabox.width);
                    $scope.pageValue.mediabox.height = InTurnPx($scope.currentPage.mediabox.height);
                }
                $scope.selPanel = attr;
            }

            if (attr == 'placement') {
                addPlacement();
            }

            if (attr == 'barcode') {
                $scope.selPanel = 'barcode';
            }
            if (attr == 'qrcode') {
                $scope.selPanel = 'qrcode';
            }

            if (attr == 'text') {
                $scope.selPanel = 'text';
            }

            if (attr == 'mask') {
                $scope.switchMaskTab('all');
            }

            if (attr == 'material') {
                vm.showCliparts = vm.allCliparts;
                vm.clipartTab = 'SYSTEM';
                $scope.selPanel = attr;
                $scope.chooseMaterialTab('SYSTEM');
            }
            if (attr == 'img') {
                $scope.selPanel = attr;
                setTimeout(function () {
                    userImg();
                }, 200);
            }
            if (attr == 'border') {
                if (!vm.frameConfigs || vm.frameConfigs.length == 0) {
                    getSystemBorders()
                }
            }
            if (attr == 'backup' && 0 == vm.backupPageSize) {
                vm.backupPageSize = 20;
            }
            if (attr == 'widgetTitle') {
                $scope.widgetTitleInit('SYSTEM');
            }
            if (attr == 'widgetMonth') {
                $scope.widgetMonthInit('SYSTEM');
            }
            if (attr == 'productTemplate') {
                if(vm.catalogs.length>0){
                    $scope.selectTempLabel(vm.catalogs[0],0)
                }
            }
            $timeout(function () {
                updateMeasureRuler();
            })
        }

        $scope.fillImgCb = function () {
            vm.imgIndexNum++;
            galleriesByCondition();
        }
        //删除图片
        $scope.fillImgDelete = function (data, index) {
            Galleries.delete({id: data.id}, function () {
                vm.userImgAll.splice(index, 1);
            })
        }

        //用户上传的图片
        vm.showImgLabel = false;
        function userImg() {
            ThemeClassify.getAllByCondition1({
                items: [{key: "type", op: "=", value: 'GALLERY'}, {
                    key: "used",
                    op: "=",
                    value: true
                }], sort: ["seq,asc"]
            }, function (res) {
                vm.imgLabels = angular.copy(res);
                vm.imgLabels.unshift({
                    id:'',
                    name:'全部'
                });
                $scope.setImgLabel(vm.imgLabels[0].id)
            });
        }
        $scope.setImgLabel = function(id){
            vm.imgLabel = id;
            vm.imgIndexNum = 0;
            vm.imgSum = 20;
            vm.isUserImg = true;
            vm.userImgAll = [];
            galleriesByCondition();
        }
        function galleriesByCondition(){
            Galleries.byConditionNew({
                items: [{key: "themeClassify.id", op: "=", value: vm.imgLabel}],
                page: vm.imgIndexNum,
                size: vm.imgSum,
                sort: ["id,desc"]
            }, function (res) {
                for (var i = 0; i < res.length; i++) {
                    res[i].identifier = vm.url + res[i].identifier;
                    vm.userImgAll.push(res[i])
                }
                if (res.length < vm.imgSum) {
                    vm.isUserImg = false;
                }
            })
        }

        //填充图片
        $scope.fillImg = function (item) {
            if (vm.selectItem) {
                $http({url: item.identifier + '?imageInfo'}).success(function (data) {
                    var _w = vm.selectItem.geometry.width;
                    var _h = vm.selectItem.geometry.height;
                    var bgImgW = data.width;
                    var bgImgH = data.height;
                    if (data.orientation == "Left-bottom" || data.orientation == "Right-top" || data.orientation == "Left-top" || data.orientation == "Right-bottom") {
                        bgImgW = data.height;
                        bgImgH = data.width;
                    }
                    var bgImgR = bgImgW / bgImgH;
                    var bgImgR1 = _w / _h;
                    var _image = {
                        resource: {
                            provider: 'qiniu',
                            identifier: item.identifier,
                        },
                        offsetx: 0,
                        offsety: 0,
                        angle: 0,
                        scale: 1
                    }
                    if (bgImgR >= bgImgR1) {
                        _image.adaptation = 'Height';
                        _image.height = _h;
                        _image.width = _h / bgImgH * bgImgW;
                    } else {
                        _image.adaptation = 'Width';
                        _image.width = _w;
                        _image.height = _w / bgImgW * bgImgH;
                    }
                    _image.imgWidth = bgImgW;
                    _image.imgHeight = bgImgH;
                    vm.selectItem.image = _image;
                }).error(function (error) {
                });
            } else {

            }
        }

        /* ==========================================================================
         模板处理
         ========================================================================== */
        //删除模板背景图片
        $scope.deleteBgImg = function () {
            if ($scope.template.pages.page[$scope.template.pageI].bgImg == '') {
                return;
            }
            $scope.template.pages.page[$scope.template.pageI].bgImg = '';
            $scope.template.pages.page[$scope.template.pageI].background.resource.identifier = '';
            $scope.template.pages.page[$scope.template.pageI].hasBgImg = false;
            updateHistorys();
        };

        //切换部件
        $scope.partCb = function(part, e){
            if(vm.textEditor){
                return;
            }
            var _index = 0;
            for(var i=0; i<$scope.template.pages.page.length; i++){
                var _page = $scope.template.pages.page[i];
                if(_page.config.partid == part.id){
                    _index = i;
                    break
                }
            }
            $scope.selectPages(_index, e,function(){
                pageListScroll();
            });
        }
        //部件顺序调整
        var sort2 = null;
        var sortArray2 = [];
        function partListDrag() {
            $timeout(function () {
                sort2 = new Sortable(document.getElementById('pageList2'), {
                    swap: false,
                    filter: '.filtered',
                    cancel: ".notDrag",
                    preventOnFilter: true,
                    animation: 150,
                    scroll:true,
                    onMove: function (/**Event*/evt, /**Event*/originalEvent) {
                        if($scope.template.config.productType == 'CALENDAR'){
                            $timeout(function () {
                                var order = sort2.toArray();
                                $scope.template.config.parts.list.forEach(function (part, index) {
                                    if (part.id =='P' || part.id == 'B1') {
                                        var _index = order.indexOf((index + 1).toString());
                                        order.splice(_index, 1)
                                    }
                                })
                                $scope.template.config.parts.list.forEach(function (part, index) {
                                    if (part.id =='P' || part.id == 'B1') {
                                        order.splice(index, 0, (index + 1).toString())
                                    }
                                })
                                sort.sort(order)
                            },150)
                            var _part = JSON.parse($(evt.related).attr("data-page"));
                            if(_part.id =='P' || _part.id == 'B1'){
                                return false
                            }
                        }
                    },
                    onEnd: function (/**Event*/evt) {
                        $timeout(function () {
                            vm.isPageList2 = true;
                            sortArray2 = [];
                            angular.forEach($('#pageList2').find(".sortingPageView"), function (item, index) {
                                var page = item.getAttribute("data-page");
                                sortArray2.push(JSON.parse(page));
                            });
                            if (sortArray2 && sortArray2.length > 0) {
                                $scope.template.config.parts.list = [];
                                $timeout(function () {
                                    $scope.template.config.parts.list = angular.copy(sortArray2);
                                    $scope.template.config.parts.list.forEach(function (value, index) {
                                        value.seq = index;
                                    })
                                    sortArray2 = [];
                                    pagesSort(function () {
                                        $scope.selectPages($scope.template.pageI);
                                        $scope.pageHistory = [];
                                        vm.isPageList2 = false;
                                        vm.operation = true;
                                        partListDrag();
                                    });
                                })
                            }
                        })
                    }
                });
            })
        }
        //获取部件名
        $scope.partName = function(partid){
            var _name = 0;
            $scope.template.config.parts.list.forEach(function (part) {
                if(part.id == partid){
                    _name = part.name;
                }
            })
            return _name
        }
        //新增部件
        $scope.addPart = function(){
            $uibModal.open({
                templateUrl: 'app/entities/page/modal/part-add.html',
                controller: 'PartAddController',
                backdrop: 'static',
                keyboard: true,
                windowClass: "jh-modal-md",
                controllerAs: 'vm',
                size:'lg',
                resolve: {
                    entity: [function () {
                        return {
                            productType: vm.page.productType,
                            modelData: vm.page.modelData,
                            modelType: vm.page.modelType,
                            modelName: vm.page.modelName,
                            modelPic: vm.page.modelPic,
                            parts:$scope.template.config.parts.list
                        };
                    }]
                }
            }).result.then(function (data) {
                if (data) {
                    vm.operation = true;
                    var _isPart = false;
                    $scope.template.config.parts.list.forEach(function (part) {
                        if(part.id == data.part.id){
                            part.counter = 1;
                            part.bleed = data.part.bleed;
                            part.editboxes = data.part.editboxes;
                            part.mediabox = data.part.mediabox;
                            _isPart = true;
                        }
                    })
                    if(!_isPart){
                        $scope.template.config.parts.list.push(data.part);
                    }
                    $scope.template.config.parts.list.sort(compare('seq', true));
                    //手动触发选中
                    $timeout(function(){
                        $scope.partCb(data.part,event);
                    })
                    var page = angular.copy(data.page);
                    page.seq = $scope.template.pages.page.length;
                    if(vm.page.modelType == 'THREE'){
                        var _modelData = JSON.parse(vm.page.modelData);
                        _modelData.forEach(function (modelItem) {
                            if(modelItem.materialName == data.materialName){
                                modelItem.page = page.seq;
                            }
                        })
                        vm.page.modelData = JSON.stringify(_modelData);
                    }
                    tempPageInfo(page, $scope.template.pages, "pages", page.seq,function () {
                        pagesSort(function () {
                            for(var i=0; i<$scope.template.pages.page.length; i++){
                                if($scope.currentPage.uuid == $scope.template.pages.page[i].uuid){
                                    $scope.selectPages(i);
                                    break;
                                }
                            }
                        })
                    });
                }
            });
        }
        function pagesSort(callback){
            var _pages = [];
            $scope.template.config.parts.list.forEach(function (part) {
                $scope.template.pages.page.forEach(function (page) {
                    if(part.id == page.config.partid){
                        page.seq = _pages.length+1;
                        ratioInfo(page)
                        _pages.push(page)
                    }
                })
            })
            $scope.template.pages.page = _pages;
            if(callback){callback()}
        }
        //编辑部件
        $scope.editorPart = function(){
            var part = angular.copy($scope.template.config.parts.list[getPartIndex()]);
            $uibModal.open({
                templateUrl: 'app/entities/page/modal/part-edit.html',
                controller: 'PartEditController',
                backdrop: 'static',
                keyboard: true,
                windowClass: "jh-modal-md",
                controllerAs: 'vm',
                size:'lg',
                resolve: {
                    entity: [function () {
                        return {
                            productType: vm.page.productType,
                            modelData: vm.page.modelData,
                            modelType: vm.page.modelType,
                            modelName: vm.page.modelName,
                            modelPic: vm.page.modelPic,
                            mouldid: $scope.currentPage.scene ? $scope.currentPage.scene.mouldid : "",
                            part:part,
                            pageIndex:$scope.template.pageI,
                            parts:$scope.template.config.parts.list
                        };
                    }]
                }
            }).result.then(function (callbackData) {
                if(callbackData){
                    var uuid = angular.copy($scope.currentPage.uuid);
                    var data = callbackData.data;
                    var _parts = callbackData.parts;
                    var _isisDeleteBackupPages = callbackData.isDeleteBackupPages;
                    if(callbackData.modelData){
                        vm.page.modelData = callbackData.modelData;
                    }
                    if (data) {
                        vm.operation = true;
                        var _part = angular.copy($scope.template.config.parts.list[getPartIndex()]);
                        if(vm.page.productType == 'PHOTO'){
                            $scope.template.config.parts.list.forEach(function (partItem) {
                                partItem.mediabox = data.mediabox;
                                partItem.bleed = data.bleed;
                                partItem.editboxes = data.editboxes;
                            })
                        }else{
                            // $scope.template.config.parts.list[getPartIndex()] = data;
                            $scope.template.config.parts.list.forEach(function (list) {
                                var _partItem = getParts(_parts,list.id);
                                if(_partItem.selected){
                                    list.mediabox = data.mediabox;
                                    list.bleed = data.bleed;
                                    list.editboxes = data.editboxes;
                                }
                            })
                        }
                        var pageIndex = 0;
                        $scope.template.pages.page.forEach(function (page, i) {
                            (function (item, index) {
                                var _partItem = getParts(_parts,item.config.partid);
                                if(_partItem.selected || vm.page.productType == 'PHOTO'){
                                    var scaleW = angular.copy(data.mediabox.width / _partItem.mediabox.width);
                                    if(page.spread){
                                        scaleW = angular.copy(data.mediabox.width*2 / _partItem.mediabox.width*2);
                                    }
                                    var scaleH = angular.copy(data.mediabox.height / _partItem.mediabox.height);
                                    var _data = angular.copy(data);
                                    if(vm.page.productType == 'PHOTO' && part.id != item.config.partid){
                                        _data.scene = null;
                                    }
                                    tempPageInfo1(_data, item,index,scaleW,scaleH,function () {
                                        if (!page.backup) {
                                            loadPageToPx(page, index, function () {
                                                pageIndex++
                                                if(pageIndex == $scope.template.pages.page.length){
                                                    for(var i=0; i<$scope.template.pages.page.length; i++){
                                                        if(uuid == $scope.template.pages.page[i].uuid){
                                                            $scope.selectPages(i);
                                                            break;
                                                        }
                                                    }
                                                }
                                            });
                                        }
                                    },false,true)
                                }else{
                                    pageIndex++
                                    if(pageIndex == $scope.template.pages.page.length){
                                        for(var i=0; i<$scope.template.pages.page.length; i++){
                                            if(uuid == $scope.template.pages.page[i].uuid){
                                                $scope.selectPages(i);
                                                break;
                                            }
                                        }
                                    }
                                }
                            })(page, i)
                        })
                        if (_isisDeleteBackupPages) {
                            for(var j=$scope.template.backupPages.list.length-1; j>=0; j--){
                                var _backupPage = $scope.template.backupPages.list[j];
                                var _partItem = getParts(_parts,_backupPage.config.partid);
                                if(_partItem.selected){
                                    $scope.template.backupPages.list.splice(j,1);
                                }
                            }
                        }

                    }
                }
            });
        }
        function getParts(parts,id){
            var _part = null;
            parts.forEach(function (part) {
                if(part.id == id){
                    _part = part;
                }
            })
            return _part
        }
        $scope.getPartIndex = getPartIndex;
        function getPartIndex(){
            if(!$scope.currentPage || !$scope.currentPage.config){
                return
            }
            var _partIndex = 0;
            for(var i=0; i<$scope.template.config.parts.list.length; i++){
                if($scope.template.config.parts.list[i].id == $scope.currentPage.config.partid){
                    _partIndex = i;
                    break
                }
            }
            return _partIndex
        }
        //根据每页的页面信息获取页面配置列表索引
        $scope.getItemPartIndex = function(page){
            if(page && page.config){
                var itemIndex = $scope.template.config.parts.list.findIndex(function(item){
                    return item.id === page.config.partid;
                })
                return itemIndex;
            }
        }
        //点击部件横向滚动条滚动
        function pageListScroll(){
            $timeout(function () {
                //获取当前选中页距离最左侧的距离
                var scrollLeft = $("#pageList").find(".selected").offset().left - $("#pageList").offset().left;
                //减去外边距
                scrollLeft = scrollLeft - 10;
                $(".c-editor-canvas-pagelist").animate({
                    scrollLeft:scrollLeft
                },200)
            })
        }
        //模板预览点击时
        $scope.selectPages = function (index, e, callback) {
            if(vm.textEditor){
                return;
            }
            if(vm.isSkip || $scope.lastPage.loading){
                // MessageService.error("其他页正在更新缩略图中，请稍后再试");
                setTimeout(function(){
                    //延迟递归调用
                    $scope.selectPages(index,e,callback);
                },100)
                return
            }
            $scope.canvasCb();
            if(e){
                fn(e)
            }
            if (index == null) {
                return;
            }
            vm.isSkip = true;
            $scope.selectBox = {
                current: 'page'
            }
            vm.loadingImg = true;
            $timeout(function () {
                checkPageCover(index,function () {
                    $scope.currentPage = null;
                    $timeout(function (){
                        $scope.template.pageI = index;
                        $scope.RightPanel = 'page';
                        $scope.lastPage = $scope.template.pages.page[$scope.template.pageI];
                        $scope.currentPage = $scope.template.pages.page[$scope.template.pageI];
                        isCanLeftAndRightPage();
                        getPagePx();
                        if ($scope.template.pages.page[index].scene) {
                            $scope.currentPage.isScene = true;
                            $scope.selectScene()
                        } else {
                            $scope.currentPage.isScene = false;
                        }
                        // var _page = angular.copy($scope.template.pages.page[$scope.template.pageI]);
                        // $scope.currentPage = _page;
                        vm.isSkip = false;
                        $scope.changeShirnk(0);
                        resetCtrlKeyArray();
                        vm.loadingImg = false;
                        $scope.pageHistory=[];
                        if(callback){callback()}
                    })
                });
            })

            canvasInfo();
            vm.isTransp = false;
            vm.isShadowSet = false;

        };
        //拖拽排序
        var sort = null;
        var sortArray = [];
        function pageListDrag() {
            $timeout(function () {
                vm.sortingPage = angular.copy($scope.template.pages.page);
                sort = new Sortable(document.getElementById('pageList'), {
                    swap: false,
                    filter: '.filtered',//'.filtered,.add-page-menu',//修复bug#8181 日历/照片书编辑器内最后一页无法移动到前面的位置(dom结构不支持,会导致加页按钮一起移动)
                    cancel: ".notDrag",
                    preventOnFilter: true,
                    animation: 150,
                    scroll:true,
                    draggable:'.sortingPageView',
                    onStart: function(evt){
                    },
                    onMove: function (/**Event*/evt, /**Event*/originalEvent) {
                        var currentPage = JSON.parse(evt.dragged.dataset.page);
                        var originalPage = JSON.parse(evt.related.dataset.page);
                        //不同部件不允许排序
                        if(currentPage.config.partid !== originalPage.config.partid) return false;
                    },
                    onEnd: function (/**Event*/evt) {
                        vm.operation = true;
                        $timeout(function () {
                            sortArray = [];
                            angular.forEach($('#pageList').find(".sortingPageView"), function (item, index) {
                                var page = item.getAttribute("data-page");
                                sortArray.push(JSON.parse(page));
                            });
                            if(sortArray && sortArray.length>0){
                                sortArray.forEach(function (value, index) {
                                    value.seq = index+1;
                                })
                                $timeout(function () {
                                    $scope.template.pages.page = angular.copy(sortArray);
                                    if($scope.template.pages.page[$scope.template.pageI].uuid != $scope.currentPage.uuid){
                                        $scope.selectPages($scope.template.pageI);
                                    }
                                    sortArray = [];
                                    vm.operation = true;
                                })
                            }
                        })
                    }
                });
            })
        }
        $scope.partPageLast = function(page, index){
            var _last = false;
            if(page.config.partid != 'P'){
                _last = true;
            }else{
                var _index = -1;
                var _isE = false;
                $scope.template.pages.page.forEach(function (page1) {
                    if(page1.config.partid == 'P'){
                        _index++;
                        _isE = true;
                    }else{
                        if(!_isE){
                            _index++;
                        }
                    }
                })
                if(index == _index){
                    _last = true;
                }
            }
            return _last
        }
        $scope.addNoModelPage = function () {
            $scope.value = vm.addPageValue[0]
            vm.isChoosePage = true;
        }

        $scope.updatePageValue = function (item) {
            $scope.value = item;
        }

        $scope.saveAddPageValue = function () {
            vm.isChoosePage = false;
            $scope.addPage($scope.value);
        }

        //增加模板
        var _addPage = false;
        $scope.addPage = function (item) {
            if(_addPage){
                return
            }
            var page = $scope.template.pages.page;
            var prevP = null;
            if (item) {
                prevP = angular.copy(page[item.id]);
            } else {
                prevP = angular.copy(page[$scope.template.pageI]);
            }
            if(!prevP){
                prevP = angular.copy($scope.initializePage);
            }
            prevP.config.monthIndex = "";
            prevP.config.partid = "P";
            vm.operation = true;
                _addPage = true;
                vm.loadingImg = true;
                var seq = 1;
                angular.forEach($scope.template.pages.page, function (p) {
                    if (!p.backup) {
                        seq++;
                    }
                })
                $timeout(function () {
                    var nodes = document.getElementsByClassName('page-item2');
                    setThumbnailPic(nodes[0], $scope.lastPage, null, function (pagecover) {
                        var standardAddPage = false;
                        if (!vm.isCustom && !vm.hasModel) {
                            standardAddPage = true;
                        }
                        //查找内页的索引
                        var pIndex = $scope.template.config.parts.list.findIndex(function(item){
                            return item.id === "P";
                        })
                        var part = $scope.template.config.parts.list[pIndex];
                        part.counter = Number(part.counter) + 1;
                        var mediabox = angular.copy(part.mediabox);
                        var trimbox = angular.copy({
                            height: part.mediabox.height - Number(part.bleed.bottom) - Number(part.bleed.top),
                            width: part.mediabox.width - Number(part.bleed.left) - Number(part.bleed.right),
                            x: part.bleed.left,
                            y: part.bleed.top
                        });
                        var editboxes = {
                            editbox:[]
                        };

                        part.editboxes.editbox.forEach(function (editbox) {
                            editboxes.editbox.push(getGeometry(angular.copy(editbox)))
                        })
                        var objData = {
                            isScene: false,
                            bgImg: null,
                            seq: seq,
                            background: {
                                resource: {},
                                color: "#ffffff",
                                type: "Color"
                            },
                            pagecover: {
                                identifier: null,
                                provider: 'qiniu'
                            },
                            levels: {
                                level:[]
                            },
                            barcode: {},
                            qrcode: {},
                            scale: 1,
                            uuid: UidService.get(),
                            width: MmTurnPx(trimbox.width),
                            height: MmTurnPx(trimbox.height),
                            editbox: editboxes.editbox[0],
                            editboxes: editboxes,
                            trimbox: getGeometry(trimbox),
                            mediabox: getGeometry(mediabox),
                            blood: part.bleed,
                            bloodPx: {
                                top: MmTurnPx(trimbox.y),
                                bottom: MmTurnPx(mediabox.height - trimbox.y - trimbox.height),
                                left: MmTurnPx(trimbox.x),
                                right: MmTurnPx(mediabox.width - trimbox.x - trimbox.width),
                            },
                            spread: part.spread,
                            backup: false,
                            unreplace: !vm.page.replace,
                            proportion: prevP.proportion,
                            ratio: prevP.ratio,
                            standardAddPage: standardAddPage,
                            config: prevP.config,
                        };
                        var obj = angular.copy(objData);
                        obj.custom = obj.mediabox;
                        ratioInfo(obj);
                        var pageI = page.length - 1;
                        for (var i = $scope.template.pages.page.length - 1; i >= 0; i--) {
                            var pa = $scope.template.pages.page[i];
                            if (!pa.backup && pa.type != 'BackCover') {
                                $scope.template.pages.page.splice(i + 1, 0, obj);
                                pageI = i + 1
                                break;
                            }
                        }
                        $scope.template.pageI = pageI;
                        $scope.template.levelI = 0;
                        $scope.selPanel = 'page';
                        $scope.visibleLeft = true;
                        $scope.visibleRight = false;
                        $scope.pageHistory = [];
                        // $scope.currentPage = prevP;
                        getPagePx();

                        $scope.currentPage = $scope.template.pages.page[$scope.template.pageI];
                        $scope.lastPage = $scope.template.pages.page[$scope.template.pageI];
                        setOriginalWaH($scope.currentPage.trimbox.width, $scope.currentPage.trimbox.height, $scope.template.pageI);
                        // updateHistorys();
                        getImageboxLen();
                        $timeout(function () {
                            var nodes = document.getElementsByClassName('page-item2');
                            setThumbnailPic(nodes[0], $scope.lastPage, null, function (pagecover) {
                                _addPage = false;
                                pagesSort(function () {
                                    for(var i=0; i<$scope.template.pages.page.length; i++){
                                        if($scope.currentPage.uuid == $scope.template.pages.page[i].uuid){
                                            $scope.selectPages(i);
                                            break;
                                        }
                                    }
                                    $timeout(function () {
                                        vm.loadingImg = false;
                                    },500)
                                })
                            });
                        },200)
                    });
                })

        };

        //模板宽高onchange
        $scope.updateTemplateHeightAndWidth = function () {
            if ($scope.pageValue.mediabox.width < 10) {
                $scope.pageValue.mediabox.width = 10
            }
            if ($scope.pageValue.mediabox.height < 10) {
                $scope.pageValue.mediabox.height = 10
            }
            var i = $scope.template.pageI;
            var currentPage = $scope.currentPage = $scope.template.pages.page[i];
            if (!currentPage) {
                return
            }
            if (vm.unit == 'px') {
                // px---mm
                vm.page.pageSize.width = PxTurnMm($scope.pageValue.mediabox.width);
                vm.page.pageSize.height = PxTurnMm($scope.pageValue.mediabox.height);
                currentPage.mediabox.width = $scope.pageValue.mediabox.width;
                currentPage.mediabox.height = $scope.pageValue.mediabox.height;

            } else if (vm.unit == 'mm') {

                vm.page.pageSize.width = $scope.pageValue.mediabox.width;
                vm.page.pageSize.height = $scope.pageValue.mediabox.height;
                currentPage.mediabox.width = MmTurnPx($scope.pageValue.mediabox.width);
                currentPage.mediabox.height = MmTurnPx($scope.pageValue.mediabox.height);
            } else if (vm.unit == 'in') {

                vm.page.pageSize.width = InTurnMm($scope.pageValue.mediabox.width);
                vm.page.pageSize.height = InTurnMm($scope.pageValue.mediabox.height);
                currentPage.mediabox.width = InTurnPx($scope.pageValue.mediabox.width);
                currentPage.mediabox.height = InTurnPx($scope.pageValue.mediabox.height);
            }
            currentPage.trimbox.width = currentPage.mediabox.width - currentPage.bloodPx.left - currentPage.bloodPx.right;
            currentPage.trimbox.height = currentPage.mediabox.height - currentPage.bloodPx.top - currentPage.bloodPx.bottom;
            setOriginalWaH(currentPage.trimbox.width, currentPage.trimbox.height, i);
            resetBackground();
        };

        //初始化像素
        function loadAttribute() {
            if (vm.unit == 'mm') {
                //属性栏
                $scope.pageValue = {
                    mediabox: {
                        width: PxTurnMm($scope.currentPage.mediabox.width),
                        height: PxTurnMm($scope.currentPage.mediabox.height)
                    },
                    editbox: {
                        width: PxTurnMm($scope.currentPage.editbox.width),
                        height: PxTurnMm($scope.currentPage.editbox.height),
                        x: PxTurnMm($scope.currentPage.editbox.x),
                        y: PxTurnMm($scope.currentPage.editbox.y)
                    },
                    barcode: {
                        width: '',
                        height: '',
                        x: '',
                        y: ''
                    },
                    qrcode: {
                        width: '',
                        height: '',
                        x: '',
                        y: ''
                    },
                    imagebox: {
                        width: '',
                        height: '',
                        x: '',
                        y: ''
                    },
                    imageart: {
                        width: '',
                        height: '',
                        x: '',
                        y: '',
                    },
                    textbox: {
                        width: '',
                        height: '',
                        x: '',
                        y: '',
                    },
                    textdocument: {
                        width: '',
                        height: '',
                        x: '',
                        y: '',
                    },
                    calMonthBox: {
                        width: '',
                        height: '',
                        x: '',
                        y: '',
                    },
                    calTitleBox: {
                        width: '',
                        height: '',
                        x: '',
                        y: '',
                    }
                }
            }
            if (vm.unit == 'in') {
                //属性栏
                $scope.pageValue = {
                    mediabox: {
                        width: PxTurnIn($scope.currentPage.mediabox.width),
                        height: PxTurnIn($scope.currentPage.mediabox.height)
                    },
                    editbox: {
                        width: PxTurnIn($scope.currentPage.editbox.width),
                        height: PxTurnIn($scope.currentPage.editbox.height),
                        x: PxTurnIn($scope.currentPage.editbox.x),
                        y: PxTurnIn($scope.currentPage.editbox.y)
                    },
                    barcode: {
                        width: '',
                        height: '',
                        x: '',
                        y: ''
                    },
                    qrcode: {
                        width: '',
                        height: '',
                        x: '',
                        y: ''
                    },
                    imagebox: {
                        width: '',
                        height: '',
                        x: '',
                        y: ''
                    },
                    imageart: {
                        width: '',
                        height: '',
                        x: '',
                        y: '',
                    },
                    textbox: {
                        width: '',
                        height: '',
                        x: '',
                        y: '',
                    },
                    textdocument: {
                        width: '',
                        height: '',
                        x: '',
                        y: '',
                    },
                    calMonthBox: {
                        width: '',
                        height: '',
                        x: '',
                        y: '',
                    },
                    calTitleBox: {
                        width: '',
                        height: '',
                        x: '',
                        y: '',
                    }
                }
            }
            if (vm.unit == 'px') {
                //属性栏
                $scope.pageValue = {
                    mediabox: {
                        width: $scope.currentPage.mediabox.width,
                        height: $scope.currentPage.mediabox.height
                    },
                    editbox: {
                        width: $scope.currentPage.editbox.width,
                        height: $scope.currentPage.editbox.height,
                        x: $scope.currentPage.editbox.x,
                        y: $scope.currentPage.editbox.y
                    },
                    barcode: {
                        width: '',
                        height: '',
                        x: '',
                        y: ''
                    },
                    qrcode: {
                        width: '',
                        height: '',
                        x: '',
                        y: ''
                    },
                    imagebox: {
                        width: '',
                        height: '',
                        x: '',
                        y: ''
                    },
                    imageart: {
                        width: '',
                        height: '',
                        x: '',
                        y: '',
                    },
                    textbox: {
                        width: '',
                        height: '',
                        x: '',
                        y: '',
                    },
                    textdocument: {
                        width: '',
                        height: '',
                        x: '',
                        y: '',
                    },
                    calMonthBox: {
                        width: '',
                        height: '',
                        x: '',
                        y: '',
                    },
                    calTitleBox: {
                        width: '',
                        height: '',
                        x: '',
                        y: '',
                    }
                }
            }
        }

        //单位换算
        $scope.unitConversion = function () {
            $scope.pageValue = "";
            $timeout(function () {
                unit()
            })
        }

        function unit() {
            if (vm.unit == 'mm') {
                $scope.pageValue = {
                    mediabox: {
                        width: PxTurnMm($scope.currentPage.mediabox.width),
                        height: PxTurnMm($scope.currentPage.mediabox.height)
                    },
                    editbox: {
                        width: PxTurnMm($scope.currentPage.editbox.width),
                        height: PxTurnMm($scope.currentPage.editbox.height),
                        x: PxTurnMm($scope.currentPage.editbox.x),
                        y: PxTurnMm($scope.currentPage.editbox.y)
                    },
                    barcode: (!$scope.currentPage.barcode || !$scope.currentPage.barcode.geometry) ? null : {
                        width: PxTurnMm($scope.currentPage.barcode.geometry.width),
                        height: PxTurnMm($scope.currentPage.barcode.geometry.height),
                        x: PxTurnMm($scope.currentPage.barcode.geometry.x),
                        y: PxTurnMm($scope.currentPage.barcode.geometry.y)
                    },
                    qrcode: (!$scope.currentPage.qrcode || !$scope.currentPage.qrcode.geometry) ? null : {
                        width: PxTurnMm($scope.currentPage.qrcode.geometry.width),
                        height: PxTurnMm($scope.currentPage.qrcode.geometry.height),
                        x: PxTurnMm($scope.currentPage.qrcode.geometry.x),
                        y: PxTurnMm($scope.currentPage.qrcode.geometry.y)
                    },
                    imagebox: (!$scope.currentPage.levels || !$scope.currentPage.levels.level || !$scope.currentPage.levels.level[$scope.template.levelI] || !$scope.currentPage.levels.level[$scope.template.levelI].imagebox || !$scope.currentPage.levels.level[$scope.template.levelI].imagebox.geometry) ? null : {
                        width: PxTurnMm($scope.currentPage.levels.level[$scope.template.levelI].imagebox.geometry.width),
                        height: PxTurnMm($scope.currentPage.levels.level[$scope.template.levelI].imagebox.geometry.height),
                        x: PxTurnMm($scope.currentPage.levels.level[$scope.template.levelI].imagebox.geometry.x),
                        y: PxTurnMm($scope.currentPage.levels.level[$scope.template.levelI].imagebox.geometry.y)
                    },
                    imageart: (!$scope.currentPage.levels || !$scope.currentPage.levels.level || !$scope.currentPage.levels.level[$scope.template.levelI] || !$scope.currentPage.levels.level[$scope.template.levelI].imageart || !$scope.currentPage.levels.level[$scope.template.levelI].imageart.geometry) ? null : {
                        width: PxTurnMm($scope.currentPage.levels.level[$scope.template.levelI].imageart.geometry.width),
                        height: PxTurnMm($scope.currentPage.levels.level[$scope.template.levelI].imageart.geometry.height),
                        x: PxTurnMm($scope.currentPage.levels.level[$scope.template.levelI].imageart.geometry.x),
                        y: PxTurnMm($scope.currentPage.levels.level[$scope.template.levelI].imageart.geometry.y)
                    },
                    textbox: (!$scope.currentPage.levels || !$scope.currentPage.levels.level || !$scope.currentPage.levels.level[$scope.template.levelI] || !$scope.currentPage.levels.level[$scope.template.levelI].textbox || !$scope.currentPage.levels.level[$scope.template.levelI].textbox.geometry) ? null : {
                        width: PxTurnMm($scope.currentPage.levels.level[$scope.template.levelI].textbox.geometry.width),
                        height: PxTurnMm($scope.currentPage.levels.level[$scope.template.levelI].textbox.geometry.height),
                        x: PxTurnMm($scope.currentPage.levels.level[$scope.template.levelI].textbox.geometry.x),
                        y: PxTurnMm($scope.currentPage.levels.level[$scope.template.levelI].textbox.geometry.y)
                    },
                    textdocument: (!$scope.currentPage.levels || !$scope.currentPage.levels.level || !$scope.currentPage.levels.level[$scope.template.levelI] || !$scope.currentPage.levels.level[$scope.template.levelI].textdocument || !$scope.currentPage.levels.level[$scope.template.levelI].textdocument.geometry) ? null : {
                        width: PxTurnMm($scope.currentPage.levels.level[$scope.template.levelI].textdocument.geometry.width),
                        height: PxTurnMm($scope.currentPage.levels.level[$scope.template.levelI].textdocument.geometry.height),
                        x: PxTurnMm($scope.currentPage.levels.level[$scope.template.levelI].textdocument.geometry.x),
                        y: PxTurnMm($scope.currentPage.levels.level[$scope.template.levelI].textdocument.geometry.y)
                    },
                    calTitleBox: (!$scope.currentPage.levels || !$scope.currentPage.levels.level || !$scope.currentPage.levels.level[$scope.template.levelI] || !$scope.currentPage.levels.level[$scope.template.levelI].calTitleBox || !$scope.currentPage.levels.level[$scope.template.levelI].calTitleBox.geometry) ? null : {
                        width: PxTurnMm($scope.currentPage.levels.level[$scope.template.levelI].calTitleBox.geometry.width),
                        height: PxTurnMm($scope.currentPage.levels.level[$scope.template.levelI].calTitleBox.geometry.height),
                        x: PxTurnMm($scope.currentPage.levels.level[$scope.template.levelI].calTitleBox.geometry.x),
                        y: PxTurnMm($scope.currentPage.levels.level[$scope.template.levelI].calTitleBox.geometry.y)
                    },
                    calMonthBox: (!$scope.currentPage.levels || !$scope.currentPage.levels.level || !$scope.currentPage.levels.level[$scope.template.levelI] || !$scope.currentPage.levels.level[$scope.template.levelI].calMonthBox || !$scope.currentPage.levels.level[$scope.template.levelI].calMonthBox.geometry) ? null : {
                        width: PxTurnMm($scope.currentPage.levels.level[$scope.template.levelI].calMonthBox.geometry.width),
                        height: PxTurnMm($scope.currentPage.levels.level[$scope.template.levelI].calMonthBox.geometry.height),
                        x: PxTurnMm($scope.currentPage.levels.level[$scope.template.levelI].calMonthBox.geometry.x),
                        y: PxTurnMm($scope.currentPage.levels.level[$scope.template.levelI].calMonthBox.geometry.y)
                    },
                }
            }
            if (vm.unit == 'in') {
                $scope.pageValue = {
                    mediabox: {
                        width: PxTurnIn($scope.currentPage.mediabox.width),
                        height: PxTurnIn($scope.currentPage.mediabox.height)
                    },
                    editbox: {
                        width: PxTurnIn($scope.currentPage.editbox.width),
                        height: PxTurnIn($scope.currentPage.editbox.height),
                        x: PxTurnIn($scope.currentPage.editbox.x),
                        y: PxTurnIn($scope.currentPage.editbox.y)
                    },
                    barcode: (!$scope.currentPage.barcode || !$scope.currentPage.barcode.geometry) ? null : {
                        width: PxTurnIn($scope.currentPage.barcode.geometry.width),
                        height: PxTurnIn($scope.currentPage.barcode.geometry.height),
                        x: PxTurnIn($scope.currentPage.barcode.geometry.x),
                        y: PxTurnIn($scope.currentPage.barcode.geometry.y)
                    },
                    qrcode: (!$scope.currentPage.qrcode || !$scope.currentPage.qrcode.geometry) ? null : {
                        width: PxTurnIn($scope.currentPage.qrcode.geometry.width),
                        height: PxTurnIn($scope.currentPage.qrcode.geometry.height),
                        x: PxTurnIn($scope.currentPage.qrcode.geometry.x),
                        y: PxTurnIn($scope.currentPage.qrcode.geometry.y)
                    },
                    imagebox: (!$scope.currentPage.levels || !$scope.currentPage.levels.level || !$scope.currentPage.levels.level[$scope.template.levelI] || !$scope.currentPage.levels.level[$scope.template.levelI].imagebox || !$scope.currentPage.levels.level[$scope.template.levelI].imagebox.geometry) ? null : {
                        width: PxTurnIn($scope.currentPage.levels.level[$scope.template.levelI].imagebox.geometry.width),
                        height: PxTurnIn($scope.currentPage.levels.level[$scope.template.levelI].imagebox.geometry.height),
                        x: PxTurnIn($scope.currentPage.levels.level[$scope.template.levelI].imagebox.geometry.x),
                        y: PxTurnIn($scope.currentPage.levels.level[$scope.template.levelI].imagebox.geometry.y)
                    },
                    imageart: (!$scope.currentPage.levels || !$scope.currentPage.levels.level || !$scope.currentPage.levels.level[$scope.template.levelI] || !$scope.currentPage.levels.level[$scope.template.levelI].imageart || !$scope.currentPage.levels.level[$scope.template.levelI].imageart.geometry) ? null : {
                        width: PxTurnIn($scope.currentPage.levels.level[$scope.template.levelI].imageart.geometry.width),
                        height: PxTurnIn($scope.currentPage.levels.level[$scope.template.levelI].imageart.geometry.height),
                        x: PxTurnIn($scope.currentPage.levels.level[$scope.template.levelI].imageart.geometry.x),
                        y: PxTurnIn($scope.currentPage.levels.level[$scope.template.levelI].imageart.geometry.y)
                    },
                    textbox: (!$scope.currentPage.levels || !$scope.currentPage.levels.level || !$scope.currentPage.levels.level[$scope.template.levelI] || !$scope.currentPage.levels.level[$scope.template.levelI].textbox || !$scope.currentPage.levels.level[$scope.template.levelI].textbox.geometry) ? null : {
                        width: PxTurnIn($scope.currentPage.levels.level[$scope.template.levelI].textbox.geometry.width),
                        height: PxTurnIn($scope.currentPage.levels.level[$scope.template.levelI].textbox.geometry.height),
                        x: PxTurnIn($scope.currentPage.levels.level[$scope.template.levelI].textbox.geometry.x),
                        y: PxTurnIn($scope.currentPage.levels.level[$scope.template.levelI].textbox.geometry.y)
                    },
                    textdocument: !$scope.currentPage.levels || !$scope.currentPage.levels.level || !$scope.currentPage.levels.level[$scope.template.levelI] || !$scope.currentPage.levels.level[$scope.template.levelI].textdocument || !$scope.currentPage.levels.level[$scope.template.levelI].textdocument.geometry ? null : {
                        width: PxTurnIn($scope.currentPage.levels.level[$scope.template.levelI].textdocument.geometry.width),
                        height: PxTurnIn($scope.currentPage.levels.level[$scope.template.levelI].textdocument.geometry.height),
                        x: PxTurnIn($scope.currentPage.levels.level[$scope.template.levelI].textdocument.geometry.x),
                        y: PxTurnIn($scope.currentPage.levels.level[$scope.template.levelI].textdocument.geometry.y)
                    },
                    calTitleBox: !$scope.currentPage.levels || !$scope.currentPage.levels.level || !$scope.currentPage.levels.level[$scope.template.levelI] || !$scope.currentPage.levels.level[$scope.template.levelI].calTitleBox || !$scope.currentPage.levels.level[$scope.template.levelI].calTitleBox.geometry ? null : {
                        width: PxTurnIn($scope.currentPage.levels.level[$scope.template.levelI].calTitleBox.geometry.width),
                        height: PxTurnIn($scope.currentPage.levels.level[$scope.template.levelI].calTitleBox.geometry.height),
                        x: PxTurnIn($scope.currentPage.levels.level[$scope.template.levelI].calTitleBox.geometry.x),
                        y: PxTurnIn($scope.currentPage.levels.level[$scope.template.levelI].calTitleBox.geometry.y)
                    },
                    calMonthBox: !$scope.currentPage.levels || !$scope.currentPage.levels.level || !$scope.currentPage.levels.level[$scope.template.levelI] || !$scope.currentPage.levels.level[$scope.template.levelI].calMonthBox || !$scope.currentPage.levels.level[$scope.template.levelI].calMonthBox.geometry ? null : {
                        width: PxTurnIn($scope.currentPage.levels.level[$scope.template.levelI].calMonthBox.geometry.width),
                        height: PxTurnIn($scope.currentPage.levels.level[$scope.template.levelI].calMonthBox.geometry.height),
                        x: PxTurnIn($scope.currentPage.levels.level[$scope.template.levelI].calMonthBox.geometry.x),
                        y: PxTurnIn($scope.currentPage.levels.level[$scope.template.levelI].calMonthBox.geometry.y)
                    },
                }
            }
            if (vm.unit == 'px') {
                $scope.pageValue = {
                    mediabox: {
                        width: $scope.currentPage.mediabox.width,
                        height: $scope.currentPage.mediabox.height
                    },
                    editbox: {
                        width: $scope.currentPage.editbox.width,
                        height: $scope.currentPage.editbox.height,
                        x: $scope.currentPage.editbox.x,
                        y: $scope.currentPage.editbox.y
                    },
                    barcode: !$scope.currentPage.barcode || !$scope.currentPage.barcode.geometry ? null : {
                        width: $scope.currentPage.barcode.geometry.width,
                        height: $scope.currentPage.barcode.geometry.height,
                        x: $scope.currentPage.barcode.geometry.x,
                        y: $scope.currentPage.barcode.geometry.y
                    },
                    qrcode: !$scope.currentPage.qrcode || !$scope.currentPage.qrcode.geometry ? null : {
                        width: $scope.currentPage.qrcode.geometry.width,
                        height: $scope.currentPage.qrcode.geometry.height,
                        x: $scope.currentPage.qrcode.geometry.x,
                        y: $scope.currentPage.qrcode.geometry.y
                    },
                    imagebox: !$scope.currentPage.levels || !$scope.currentPage.levels.level || !$scope.currentPage.levels.level[$scope.template.levelI] || !$scope.currentPage.levels.level[$scope.template.levelI].imagebox || !$scope.currentPage.levels.level[$scope.template.levelI].imagebox.geometry ? null : {
                        width: $scope.currentPage.levels.level[$scope.template.levelI].imagebox.geometry.width,
                        height: $scope.currentPage.levels.level[$scope.template.levelI].imagebox.geometry.height,
                        x: $scope.currentPage.levels.level[$scope.template.levelI].imagebox.geometry.x,
                        y: $scope.currentPage.levels.level[$scope.template.levelI].imagebox.geometry.y
                    },
                    imageart: !$scope.currentPage.levels || !$scope.currentPage.levels.level || !$scope.currentPage.levels.level[$scope.template.levelI] || !$scope.currentPage.levels.level[$scope.template.levelI].imageart || !$scope.currentPage.levels.level[$scope.template.levelI].imageart.geometry ? null : {
                        width: $scope.currentPage.levels.level[$scope.template.levelI].imageart.geometry.width,
                        height: $scope.currentPage.levels.level[$scope.template.levelI].imageart.geometry.height,
                        x: $scope.currentPage.levels.level[$scope.template.levelI].imageart.geometry.x,
                        y: $scope.currentPage.levels.level[$scope.template.levelI].imageart.geometry.y
                    },
                    textbox: !$scope.currentPage.levels || !$scope.currentPage.levels.level || !$scope.currentPage.levels.level[$scope.template.levelI] || !$scope.currentPage.levels.level[$scope.template.levelI].textbox || !$scope.currentPage.levels.level[$scope.template.levelI].textbox.geometry ? null : {
                        width: $scope.currentPage.levels.level[$scope.template.levelI].textbox.geometry.width,
                        height: $scope.currentPage.levels.level[$scope.template.levelI].textbox.geometry.height,
                        x: $scope.currentPage.levels.level[$scope.template.levelI].textbox.geometry.x,
                        y: $scope.currentPage.levels.level[$scope.template.levelI].textbox.geometry.y
                    },
                    textdocument: !$scope.currentPage.levels || !$scope.currentPage.levels.level || !$scope.currentPage.levels.level[$scope.template.levelI] || !$scope.currentPage.levels.level[$scope.template.levelI].textdocument || !$scope.currentPage.levels.level[$scope.template.levelI].textdocument.geometry ? null : {
                        width: $scope.currentPage.levels.level[$scope.template.levelI].textdocument.geometry.width,
                        height: $scope.currentPage.levels.level[$scope.template.levelI].textdocument.geometry.height,
                        x: $scope.currentPage.levels.level[$scope.template.levelI].textdocument.geometry.x,
                        y: $scope.currentPage.levels.level[$scope.template.levelI].textdocument.geometry.y
                    },
                    calTitleBox: !$scope.currentPage.levels || !$scope.currentPage.levels.level || !$scope.currentPage.levels.level[$scope.template.levelI] || !$scope.currentPage.levels.level[$scope.template.levelI].calTitleBox || !$scope.currentPage.levels.level[$scope.template.levelI].calTitleBox.geometry ? null : {
                        width: $scope.currentPage.levels.level[$scope.template.levelI].calTitleBox.geometry.width,
                        height: $scope.currentPage.levels.level[$scope.template.levelI].calTitleBox.geometry.height,
                        x: $scope.currentPage.levels.level[$scope.template.levelI].calTitleBox.geometry.x,
                        y: $scope.currentPage.levels.level[$scope.template.levelI].calTitleBox.geometry.y
                    },
                    calMonthBox: !$scope.currentPage.levels || !$scope.currentPage.levels.level || !$scope.currentPage.levels.level[$scope.template.levelI] || !$scope.currentPage.levels.level[$scope.template.levelI].calMonthBox || !$scope.currentPage.levels.level[$scope.template.levelI].calMonthBox.geometry ? null : {
                        width: $scope.currentPage.levels.level[$scope.template.levelI].calMonthBox.geometry.width,
                        height: $scope.currentPage.levels.level[$scope.template.levelI].calMonthBox.geometry.height,
                        x: $scope.currentPage.levels.level[$scope.template.levelI].calMonthBox.geometry.x,
                        y: $scope.currentPage.levels.level[$scope.template.levelI].calMonthBox.geometry.y
                    }
                }
            }
        }

        function resetBackground() {
            var background = $scope.currentPage.background;
            if (background.resource && background.resource.identifier) {
                var pageW = $scope.currentPage.mediabox.width / $scope.currentPage.proportion;
                var pageH = $scope.currentPage.mediabox.height / $scope.currentPage.proportion;

                var bgW = background.resource.width;
                var bgH = background.resource.height;
                // 高适配
                var adaptation = 'Height', h = pageH, w = pageH * bgW / bgH;
                // 宽适配
                if ((bgW <= bgH || pageW <= pageH) && (bgW / bgH < pageW / pageH) || bgW >= bgH && pageW >= pageH && (bgW / bgH < pageW / pageH)) {
                    w = pageW;
                    h = pageW * bgH / bgW;
                    adaptation = 'Width';
                }
                var pro = $scope.currentPage.scale / $scope.currentPage.proportion
                background.offsetx = 0;
                background.offsety = 0;
                background.width = w / pro;
                background.height = h / pro;
                background.resource.width = bgW;
                background.resource.height = bgH;
                background.adaptation = adaptation;
                background.scale = 1;
            }
        }

        //模板宽高onchange
        $scope.updateEditbox = function () {
            var i = $scope.template.pageI;
            var currentPage = $scope.template.pages.page[i];
            if (vm.unit == 'mm') {
                currentPage.editbox = {
                    width: MmTurnPx($scope.pageValue.editbox.width),
                    height: MmTurnPx($scope.pageValue.editbox.height),
                    x: MmTurnPx($scope.pageValue.editbox.x),
                    y: MmTurnPx($scope.pageValue.editbox.y)
                }
            }
            if (vm.unit == 'px') {
                currentPage.editbox = {
                    width: $scope.pageValue.editbox.width,
                    height: $scope.pageValue.editbox.height,
                    x: $scope.pageValue.editbox.x,
                    y: $scope.pageValue.editbox.y
                }
            }
            if (vm.unit == 'in') {
                currentPage.editbox = {
                    width: InTurnPx($scope.pageValue.editbox.width),
                    height: InTurnPx($scope.pageValue.editbox.height),
                    x: InTurnPx($scope.pageValue.editbox.x),
                    y: InTurnPx($scope.pageValue.editbox.y)
                }
            }

            $scope.currentPage = currentPage;
        };

        // 背景图和素材的上传
        window.updatePic = function ($event) {
            $scope.$digest();
            var files = $event.target.files;
            var len = $scope.template.bgimgs.bgimg.length;
            vm.uploadType = "BgImg";
            bigSizePics = [];
            for (var i = 0; i < files.length; i++) {
                var file = files[i];
                if (file.size >= 20 * 1024 * 1024) {
                    file.imageSize = Math.ceil(file.size / 1024 / 1024);
                    bigSizePics.push(file);
                } else {
                    getBgImg(files, i, len);
                    if (bigSizePics.length == 0 && i == (files.length - 1)) {
                        vm.picLoading = false;
                    }
                }
            }
            if (bigSizePics.length > 0) {
                thumbnailatorPic();
            }
            // $event.srcElement.value = ""
        };

        function getBgImg(files, i, len) {
            var url = window.URL || window.webkitURL;
            var img = new Image();              //手动创建一个Image对象
            img.src = url.createObjectURL(files[i]);//创建Image的对象的url
            img.crossOrigin = "Anonymous";
            var arr = [];

            arr = $scope.template.bgimgs.bgimg;
            arr.push({
                'identifier': 'https://pic-modele-dev.momentsgocdn.com/material-9627c267-5653-4ad2-a539-1d5cbe13e820', // 默认七牛占位
                'provider': 'qiniu'
            });

            //$scope.$digest();
            var formData = new FormData();
            formData.append('file', files[i]);
            formData.append('key', 'background-' + UidService.get());
            formData.append('token', vm.token);
            $.ajax({
                cache: true,
                type: "POST",
                url: 'https://upload.qiniup.com/',
                data: formData,
                async: true,
                contentType: false,
                processData: false,
                success: function (data) {
                    arr[parseInt(len + i)].identifier = vm.url + data.key;
                    i++;
                    if (i < files.length) {
                        //getBgImg(files, i, len);
                    }
                    $scope.$apply();
                },
                error: function (request) {
                }
            });

        }

        // 图片上传
        window.updatePic1 = function ($event) {
            $scope.$digest();
            var files = $event.target.files;
            vm.uploadType = "UserImg";
            bigSizePics = [];
            var _index = 0;
            for (var i = 0; i < files.length; i++) {
                var file = files[i];
                if (file.size >= 20 * 1024 * 1024) {
                    file.imageSize = Math.ceil(file.size / 1024 / 1024);
                    bigSizePics.push(file);
                    _index++
                    if(_index == files.length){
                        $timeout(function () {
                            $event.srcElement.value = ""
                        })
                    }
                } else {
                    getUserImg(files, i,function () {
                        _index++
                        if(_index == files.length){
                            $timeout(function () {
                                $event.srcElement.value = ""
                            })
                        }
                    });
                    if (bigSizePics.length == 0 && i == (files.length - 1)) {
                        vm.picLoading = false;
                    }
                }
            }
            if (bigSizePics.length > 0) {
                thumbnailatorPic();
            }
        };

        function getUserImg(files, i,callback) {
            var url = window.URL || window.webkitURL;
            var img = new Image();              //手动创建一个Image对象
            img.src = url.createObjectURL(files[i]);//创建Image的对象的url
            img.crossOrigin = "Anonymous";
            var arr = {
                'identifier': '',
                'provider': 'qiniu',
                'fileName': files[i].name,
                'imgSize': '',
                'width': '',
                'height': '',
                'userId': '',
            };
            var formData = new FormData();
            formData.append('file', files[i]);
            formData.append('key', 'gallery-' + UidService.get());
            formData.append('token', vm.token);
            $.ajax({
                cache: true,
                type: "POST",
                url: 'https://upload.qiniup.com/',
                data: formData,
                async: true,
                contentType: false,
                processData: false,
                success: function (data) {
                    arr.identifier = data.key;
                    $.ajax({
                        type: "GET",
                        url: vm.url + data.key + "?imageInfo",
                        success: function (img) {
                            arr.width = img.width;
                            arr.height = img.height;
                            arr.imgSize = img.size;
                            arr.themeClassifyId = vm.imgLabel;
                            Galleries.upload(arr, function (res) {
                                res.identifier = vm.url + res.identifier;
                                vm.userImgAll.unshift(res)
                                i++;
                                if (i < files.length) {
                                    //getUserImg(files, i);
                                } else {
                                    //$scope.$digest();
                                }
                                if(callback){callback()}
                            });
                        },
                        error: function (request) {
                            if(callback){callback()}
                        }
                    });
                },
                error: function (request) {
                    if(callback){callback()}
                }
            });

        }

        vm.showBackgroundsLabel = false;
        function getBackgroundLabel(){
            ThemeClassify.getAllByCondition1({
                items: [{key: "type", op: "=", value: 'BACKGROUND'}, {
                    key: "used",
                    op: "=",
                    value: true
                }], sort: ["seq,asc"]
            }, function (res) {
                vm.backgroundLabels = angular.copy(res);
                vm.backgroundLabels.unshift({
                    id:'',
                    name:'全部'
                });
                $scope.backgroundData(vm.backgroundLabels[0].id)
            });
        }

        $scope.backgroundData = function(id){
            vm.backgroundLabel = id;
            vm.indexNum = 0;
            vm.bgimgs2.bgimg=[];
            backgroundsByCondition();
        }
        function backgroundsByCondition(){
            Backgrounds.byCondition({
                items: [{key: "themeClassify.id", op: "=", value: vm.backgroundLabel}],
                page: vm.indexNum,
                size: vm.itemsPerPage,
                sort: ["id,desc"]
            }, function (res, headers) {
                vm.totalBgItems = headers('X-Total-Count');
                res.some(function (item, i) {
                    item.identifier = vm.url + item.identifier
                    vm.bgimgs2.bgimg.push(item);
                })
                vm.showBackgrounds = vm.bgimgs2;

                if($scope.template && $scope.template.bgimgs2 && $scope.template.bgimgs2.bgimg){
                    angular.forEach(vm.bgimgs2.bgimg, function (data) {
                        var result = ListService.inList(data, $scope.template.bgimgs2.bgimg, ["identifier"]);
                        if (result) {
                            data.isRecommend = true;
                        }
                    })
                }
            })
        }

        window.updateBackground = function ($event) {
            $scope.$digest();
            vm.uploadType = "BG";
            vm.bgimgs2Tab = 'all';
            var files = $event.target.files;
            var len = 0;
            bigSizePics = [];
            if (vm.showBackgrounds && vm.showBackgrounds.length) {
                len = vm.showBackgrounds.length;
            }
            var _index = 0;
            for (var i = 0; i < files.length; i++) {
                var file = files[i];
                if (file.size >= 20 * 1024 * 1024) {
                    file.imageSize = Math.ceil(file.size / 1024 / 1024);
                    bigSizePics.push(file);
                    _index++
                    if(_index == files.length){
                        $timeout(function () {
                            $event.srcElement.value = ""
                        })
                    }
                } else {
                    getBackground(files, i, len,function () {
                        _index++
                        if(_index == files.length){
                            $timeout(function () {
                                $event.srcElement.value = ""
                            })
                        }
                    });
                    if (bigSizePics.length == 0 && i == (files.length - 1)) {
                        vm.picLoading = false;
                    }
                }
            }
            if (bigSizePics.length > 0) {
                thumbnailatorPic();
            }
        };

        function getBackground(files, i, len,callback) {
            var url = window.URL || window.webkitURL;
            var img = new Image();              //手动创建一个Image对象
            img.src = url.createObjectURL(files[i]);//创建Image的对象的url
            img.crossOrigin = "Anonymous";
            var fileName = files[i].name;
            var formData = new FormData();
            formData.append('file', files[i]);
            formData.append('key', 'background-' + UidService.get());
            formData.append('token', vm.token);
            $.ajax({
                cache: true,
                type: "POST",
                url: 'https://upload.qiniup.com/',
                data: formData,
                async: true,
                contentType: false,
                processData: false,
                success: function (data) {
                    Backgrounds.save({
                        identifier: data.key,
                        provider: 'qiniu',
                        name: fileName,
                        type: 'ProductXml',
                        themeClassifyId:vm.backgroundLabel
                    }, function (resp) {
                        resp.identifier = vm.url + resp.identifier;
                        vm.bgimgs2.bgimg.unshift(resp)
                        $("#dragtarget" + parseInt(len + i)).attr('data-mask', data.key);
                        //i++;
                        //if (i < files.length) {
                        //    getBackground(files, i, len);
                        //}
                        vm.showBackgrounds = vm.bgimgs2;
                        if(callback){callback()}
                    },function () {
                        if(callback){callback()}
                    });
                },
                error: function (request) {
                    if(callback){callback()}
                }
            });

        }

        window.doubleClickbgImg = function (e) {
            fn(e);
            var currentPage = $scope.currentPage = $scope.template.pages.page[$scope.template.pageI];
            if (currentPage.background && currentPage.background.resource && currentPage.background.resource.identifier) {
                $scope.cutImage(currentPage, $scope.template.pageI);
            }
            return
        }

        /**
         * 进入图片编辑模式
         */
        $scope.cutImage = function (page, pageI) {
            $scope.w = $('.bg-image' + pageI).width();
            $scope.h = $('.bg-image' + pageI).height();
            var pro = $scope.currentPage.scale / $scope.currentPage.proportion;

            $scope.pageW = $scope.currentPage.mediabox.width / $scope.currentPage.proportion * $scope.currentPage.scale;
            $scope.pageH = $scope.currentPage.mediabox.height / $scope.currentPage.proportion * $scope.currentPage.scale;
            $scope.showCut = true;
            $scope.showImageMenu = false;
            $("#cut-mask").attr('src', '');

            var background = $scope.currentPage.background;
            background.width = $scope.w / pro;
            background.height = $scope.h / pro;

            // 显示区域（包含上/下页按钮）
            var bodyW = $(".c-editor-canvas").width();
            var bodyH = $(".c-editor-canvas").height();

            // 裁切框显示位置
            var left = $scope.l = parseFloat($(".page-item").css('marginLeft'));
            var top = $scope.t = parseFloat($(".page-item").css('marginTop'));
            $("#cut-img").css({left: left + background.offsetx * pro, top: top + background.offsety * pro});

            ImageService.convertImgToBase64('content/images/white.png', function (s) {
                var imagecanvas = $("#mask-canvas")[0];
                var imagecontext = imagecanvas.getContext('2d');
                var newImg = document.createElement('img');
                // newImg.crossOrigin = "Anonymous";
                newImg.src = 'content/images/zhezhao1.png';
                newImg.onload = function () {
                    newImg.onload = null;
                    var masks = document.createElement('img');
                    masks.src = 'content/images/white.png';
                    // masks.crossOrigin = "Anonymous";
                    masks.onload = function () {
                        masks.onload = null;
                        imagecanvas.width = bodyW;
                        imagecanvas.height = bodyH;
                        imagecontext.drawImage(masks, left, top, $scope.pageW, $scope.pageH);
                        imagecontext.globalCompositeOperation = 'source-out';
                        imagecontext.drawImage(newImg, 0, 0, bodyW, bodyH);

                        $("#cut-mask").attr('src', ImageService.dataURLtoBlob(imagecanvas.toDataURL()));

                        $scope.$digest();
                    };
                    // masks.src = box.maskUrl;
                };
                newImg.src = 'content/images/zhezhao1.png';
            });
        };

        var drag = false;
        var dragBox = {};
        /**
         * 拖拽编辑的图片
         */
        window.startEdit = function (e) {
            fn(e);

            dragBox.clientX = e.clientX ? e.clientX : 0;
            dragBox.clientY = e.clientY ? e.clientY : 0;
            dragBox.picW = $("#cut-img").width();
            dragBox.picH = $("#cut-img").height();
            var background = $scope.currentPage.background;
            var pro = $scope.currentPage.scale / $scope.currentPage.proportion
            dragBox.coordX = background.offsetx * pro;
            dragBox.coordY = background.offsety * pro;

            drag = true;
            document.addEventListener("mousemove", dragEdit, true);
            document.addEventListener("mouseup", stopEdit, true);
        };

        function dragEdit(e) {
            if (drag) {
                var background = $scope.currentPage.background;
                var x = 0, y = 0;

                //手指离开屏幕
                if (background.adaptation == 'Height') {    //宽图
                    x = (dragBox.coordX + (e.clientX - dragBox.clientX));
                    //向左滑动;        <-----
                    if (-x >= ($scope.w - $scope.pageW)) {
                        x = -($scope.w - $scope.pageW);
                    }
                    // 向右滑动;    ---->
                    if (x >= 0) {
                        x = 0;
                    }
                } else {     //高图
                    y = (dragBox.coordY + (e.clientY - dragBox.clientY));
                    //向上滑动;
                    if (-y >= ($scope.h - $scope.pageH)) {
                        y = -($scope.h - $scope.pageH);
                    }
                    //向下滑动;
                    if (y >= 0) {
                        y = 0;
                    }
                }

                $("#cut-img").css({left: x + $scope.l, top: y + $scope.t});

                var prp = $scope.currentPage.scale / $scope.currentPage.proportion
                background.offsetx = x / prp;
                background.offsety = y / prp;

                $scope.$digest();
                e.stopPropagation();
                e.preventDefault();
                return false;
            }

        };

        function stopEdit() {
            drag = false;
            dragBox = {};
            document.removeEventListener("mousemove", dragEdit, true);
            document.removeEventListener("mouseup", stopEdit, true);
        };

        $scope.chooseColor = function () {
            $scope.chooseBgColor($scope.template.pages.page[$scope.template.pageI].background.color);
        }

        $scope.chooseBgColor = function (color) {
            var currentPage = $scope.template.pages.page[$scope.template.pageI];
            currentPage.background = {
                resource: {
                    identifier: '',
                    provider: 'qiniu'
                },
                offsetx: 0,
                offsety: 0,
                type: 'Color',
                color: color,
                width: 0,
                height: 0,
                adaptation: null
            }
            $scope.currentPage.lowAccuracy=false;
            $scope.currentPage = currentPage;

            updateHistorys();
        }

        $scope.loadMoreBackgrounds = function () {
            if (vm.bgimgs2.bgimg.length == vm.totalBgItems) {
                MessageService.error("已全部加载完成");
                return
            }
            vm.indexNum++
            backgroundsByCondition();
        }

        $scope.loadMoreClipart = function () {
            if (vm.allCliparts.clipart.length >= vm.totalClipartItems) {
                MessageService.error("已全部加载完成");
                return
            } else if (vm.allCliparts.clipart.length == 0) {
                vm.clipartIndexNum = -1;
            }
            ++vm.clipartIndexNum;
            clickClipArtLabels(vm.allCliparts);
        }


        $scope.recommendBgImg2 = function (attr, arr) {
            var bgimgs = $scope.template.bgimgs2.bgimg;
            // 全部素材nav
            if (vm.bgimgs2Tab == 'all') {
                if (arr.isRecommend) {
                    bgimgs.some(function (item, i) {
                        if (item.identifier == arr.identifier) {
                            arr.isRecommend = false;
                            bgimgs.splice(i, 1);
                            return
                        }
                    })
                    return
                }
                arr.isRecommend = true;
                bgimgs.push(arr);
            }else{
                for(var j=0; j<vm.bgimgs2.bgimg.length; j++){
                    if(vm.bgimgs2.bgimg[j].identifier == arr.identifier){
                        vm.bgimgs2.bgimg[j].isRecommend = false;
                        break
                    }
                }
                for(var i=0; i<bgimgs.length; i++){
                    if(bgimgs[i].identifier == arr.identifier){
                        arr.isRecommend = false;
                        bgimgs.splice(i, 1);
                        break
                    }
                }
                $scope.switchBgTab();
            }
        }

        $scope.switchBgTab = function (attr) {
            vm.bgimgs2Tab = attr;
            if (attr == 'all') {
                getBackgroundLabel();
            } else {
                vm.showBackgrounds = $scope.template.bgimgs2;
            }
        }

        $scope.switchMaskTab = function (attr) {
            vm.maskTab = attr;
            vm.showMasks = {mask: []};
            $scope.masklabels = [];
            $scope.masklabelChooseId = null;
            vm.maskIndexNum = 0;
            if (attr == 'all') {
                ThemeClassify.getAllByCondition4({
                    type: "MASK"
                }, function (res) {
                    if (res.status == 200) {
                        vm.maskIndexNum = 0;
                        $scope.masklabels = angular.copy(res.message);
                        if (!$scope.masklabels.length) {
                            return
                        }
                        $scope.masklabelChooseId = $scope.masklabels[0].id || null;
                        var items = [
                            {key: "themeClassify.id", op: "=", value: $scope.masklabelChooseId},
                            {key: "opened", op: "=", value: "true"},
                            {key: "type", op: "=", value: "SYSTEM"}
                            ];
                        clickMaskLabels(items, vm.showMasks);
                    } else {
                        MessageService.error(res.message)
                    }
                });
            } else if(attr == 'recommend') {
                vm.showMasks = $scope.template.masks;
            } else{
                ThemeClassify.getAllByCondition1({
                    items:[{key: "type", value: "MASK", op: "="}, {key: "used", value: "true", op: "="}]
                }, function (res) {
                        vm.maskIndexNum = 0;
                        $scope.masklabels = angular.copy(res);
                        $scope.masklabels.unshift({
                            name:'全部',
                            id:null
                        })
                        $scope.masklabelChooseId = $scope.masklabels[0].id || null;
                        var items = [
                            {key: "themeClassify.id", op: "=", value: $scope.masklabelChooseId},
                            {key: "type", op: "=", value: "User"}
                        ];
                        clickMaskLabels(items, vm.showMasks);
                });
            }
        }
        $scope.loadMoreMask = function () {
            if (vm.maskTab == 'all') {
                if (vm.showMasks.mask.length == vm.totalMaskItems) {
                    MessageService.error("已全部加载完成");
                    return
                }
                vm.maskIndexNum++;
                var items = [{key: "themeClassify.id", op: "=", value: $scope.masklabelChooseId}, {
                    key: "opened",
                    op: "=",
                    value: "true"
                }];
                clickMaskLabels(items, vm.showMasks);
            } else if (vm.maskTab == 'my') {
                if (vm.showMasks.mask.length == vm.totalMaskItems) {
                    MessageService.error("已全部加载完成");
                    return
                }

                var items = [
                    {key: "themeClassify.id", op: "=", value: $scope.masklabelChooseId},
                    {key: "opened", op: "=", value: "true"},
                    {key: "type", op: "=", value: "USER"}
                ];
                ++vm.maskIndexNum;
                clickMaskLabels(items, vm.showMasks);
            }
        }

        $scope.selectMaskLabel = function (label, index) {
            $scope.masklabelChooseId = label.id;
            vm.maskIndexNum=0;
            vm.showMasks = {mask: []};
            if (vm.maskTab == 'all') {
                var items = [
                    {key: "themeClassify.id", op: "=", value: $scope.masklabelChooseId},
                    {key: "opened", op: "=", value: "true"},
                    {key: "type", op: "=", value: "SYSTEM"}];
                clickMaskLabels(items, vm.showMasks);
            } else if (vm.maskTab == 'my') {
                var items = [
                    {key: "themeClassify.id", op: "=", value: $scope.masklabelChooseId},
                    {key: "type", op: "=", value: "User"}
                ];
                clickMaskLabels(items, vm.showMasks);
            }
        };

        function clickMaskLabels(items, masks, attr) {
            SourceMaterial.byCondition({
                items: items,
                page: vm.maskIndexNum,
                size: vm.itemsPerPage,
                sort: ["id,desc"]
            }, function (resp, headers) {
                vm.totalMaskItems = headers('X-Total-Count');
                angular.forEach(resp, function (data, i) {
                    var arr = {
                        resource: {
                            identifier: vm.url + data.identifier,
                            provider: data.provider,
                        },
                        type: data.type,
                        id: data.id,
                        isRecommend: false,
                        identifier: vm.url + data.identifier,
                        provider: 'qiniu',
                        bgImg: '',
                    }
                    if($scope.template&&$scope.template.masks&&$scope.template.masks.mask.length>0){
                        for(var i=0; i<$scope.template.masks.mask.length; i++){
                            if($scope.template.masks.mask[i].id == arr.id){
                                arr.isRecommend = true;
                                break
                            }
                        }
                    }
                    masks.mask.push(arr);
                })
            })
        }

        $scope.recommendMask = function (attr, arr) {
            var masks = $scope.template.masks.mask;
            if (arr.isRecommend) {
                var _index = -1;
                angular.forEach(masks, function (item, i) {
                    if (item.id == arr.id) {
                        arr.isRecommend = false;
                        _index = i;
                    }
                })
                if(_index>-1){
                    masks.splice(_index, 1);
                }
                return
            }
            arr.isRecommend = true;
            masks.push(arr);
        }

        window.updateArts = function ($event) {
            $scope.$digest();
            var files = $event.target.files;
            var _files = [];
            bigSizePics = [];
            vm.uploadType = "CLIPART";
            for (var i = 0; i < files.length; i++) {
                var file = files[i];
                if (file.size >= 20 * 1024 * 1024) {
                    file.imageSize = Math.ceil(file.size / 1024 / 1024);
                    bigSizePics.push(file);
                }else {
                    _files.push(file)
                }
            }
            if(_files.length == 0){
                MessageService.error("请选择正确的图片");
                return
            }
            if (bigSizePics.length > 0) {
                thumbnailatorPic();
            }
            var len = vm.showCliparts.clipart.length;
            getArtImg(_files, 0, len,$event);

            vm.clipartTab = 'all';
        };

        function getArtImg(files, i, len,$event) {
            var url = window.URL || window.webkitURL;
            var img = new Image();              //手动创建一个Image对象
            img.src = url.createObjectURL(files[i]);//创建Image的对象的url
            img.crossOrigin = "Anonymous";
            var formData = new FormData();
            formData.append('file', files[i]);
            formData.append('key', 'clipArt-' + UidService.get());
            formData.append('token', vm.token);
            $.ajax({
                cache: true,
                type: "POST",
                url: 'https://upload.qiniup.com/',
                data: formData,
                async: true,
                contentType: false,
                processData: false,
                success: function (data) {
                    ClipArts.createOne({
                        identifier: data.key,
                        name:files[i].name,
                        provider: 'qiniu',
                        themeClassifyId: $scope.artlabelChooseId
                    }, function (resp) {
                        vm.showCliparts.clipart.unshift({
                            'bgImg': img.src,
                            resource: {
                                identifier: vm.url + data.key,
                                provider: 'qiniu'
                            },
                            type: resp.type,
                            id: resp.id
                        })
                        $("#dragtarget" + parseInt(len + i)).attr('data-mask', data.key);
                        i++;
                        if (i < files.length) {
                            getArtImg(files, i, len,$event);
                        } else {
                            vm.totalClipartItems = vm.totalClipartItems - 0 + i;
                            $timeout(function () {
                                $event.srcElement.value = ""
                            })
                        }
                    });
                },
                error: function (request) {
                }
            });

        }

        $scope.recommendArt = function (attr, arr) {
            var cliparts = $scope.template.cliparts.clipart || [];

            // 全部素材nav
            if (vm.clipartTab == 'all') {
                if (arr.isRecommend) {
                    cliparts.some(function (item, i) {
                        if (item.resource.identifier == arr.resource.identifier) {
                            arr.isRecommend = false;
                            cliparts.splice(i, 1);
                            return
                        }
                    })
                    return
                }
                arr.isRecommend = true;
                cliparts.push(arr);
                return
            }

            // 推荐素材nav
            cliparts.some(function (item, i) {
                if (item.resource.identifier == arr.resource.identifier) {
                    arr.isRecommend = false;
                    cliparts.splice(i, 1);
                    return
                }
            })
            vm.allCliparts.clipart.some(function (item) {
                if (item.resource.identifier == arr.resource.identifier) {
                    item.isRecommend = false;
                    return
                }
            })

        }

        $scope.deleteLeftPanelPic = function (index, e) {
            fn(e);
            $(".art-click").hide();
            if ($scope.selPanel == 'page') {
                var id = vm.bgimgs2.bgimg[index].id;
                vm.bgimgs2.bgimg.splice(index, 1);
                vm.showBackgrounds = vm.bgimgs2;
                Backgrounds.delete({id: id});
                if($scope.template.bgimgs2&&$scope.template.bgimgs2.bgimg){
                    var _index = -1;
                    for(var i=0; i<$scope.template.bgimgs2.bgimg.length; i++){
                        if($scope.template.bgimgs2.bgimg[i].id == id){
                            _index = i;
                            break
                        }
                    }
                    if(_index > -1){
                        $scope.template.bgimgs2.bgimg.splice(_index,1)
                    }
                }
                return

            }
            if ($scope.selPanel == 'design') {
                $scope.template.bgimgs.bgimg.splice(index, 1);
                return

            } else if ($scope.selPanel == 'mask') {
                if(vm.showMasks.mask[index].isRecommend){
                    $scope.recommendMask('',vm.showMasks.mask[index])
                }
                var id = vm.showMasks.mask[index].id;
                vm.showMasks.mask.splice(index, 1);
                SourceMaterial.delete({id: id});
                return
            } else {
                if(vm.showCliparts.clipart[index].isRecommend){
                    $scope.recommendArt('clipArts.clipArt',vm.showCliparts.clipart[index])
                }
                var id = vm.showCliparts.clipart[index].id;
                vm.showCliparts.clipart.splice(index, 1);
                ClipArts.delete({id: id});
            }
        };

        function setOriginalWaH(width, height, i) {
            var currentPage = $scope.template.pages.page[i];
            var w = width;
            var h = height;

            originalScale = $con.width() * 0.8 / ($con.height() * 0.8);

            if (originalScale < width / height) {
                //宽定，高不定
                width = $con.width() * 0.8;
                height = $con.width() * 0.8 * h / w;
            } else {
                //高定，宽不动
                height = $con.height() * 0.8;
                width = $con.height() * 0.8 * w / h;
            }
            currentPage.width = width;
            currentPage.height = height;
            currentPage.proportion = (w / width);
            currentPage.proportionText = width / (PxTurnMm(w) / 25.4 * vm.windowDpiW);

            var pageNodeWidth = currentPage.mediabox.width / currentPage.proportion * 98 / (currentPage.mediabox.height / currentPage.proportion)

            currentPage.proportionTextSmalll = pageNodeWidth / (PxTurnMm(w) / 25.4 * vm.windowDpiW);
            currentPage.proportion1 = currentPage.width*currentPage.scale/currentPage.custom.width;
            if(currentPage.scene){
                currentPage.minScale = 100/currentPage.scene.geometry.height;
            }else{
                currentPage.minScale = 100/currentPage.mediabox.height;
            }
            $scope.currentPage = currentPage;
            updateMeasureRuler();
        }

        // 跨页
        vm.spreadSize = false;
        $scope.pageIsSpread = function (flag) {
            var i = $scope.template.pageI;
            var currentPage = $scope.template.pages.page[i];
            if (flag) {
                if(currentPage.spread){
                    return
                }
                currentPage.spread = true;
                if (currentPage.type == 'Cover' || currentPage.type == 'BackCover') {
                    currentPage.type = undefined;
                }
            } else {
                if(!currentPage.spread){
                    return
                }
                currentPage.spread = false;
                if (currentPage.type == 'FrontBack') {
                    currentPage.type = undefined;
                }
            }
            if(vm.page.productType == 'BOOK' && $scope.currentPage.config.partid == 'P' && $scope.pageSeq($scope.currentPage) == 1 && !$scope.currentPage.spread){
                $scope.template.config.innerOffset = 0;vm.operation = true;
            }
            if(vm.spreadSize){
                var part = angular.copy($scope.template.config.parts.list[getPartIndex()]);
                var scaleW = 0.5;
                if(currentPage.spread){
                    scaleW = 2;
                }
                var scaleH = 1;
                tempPageInfo1(part, currentPage,i,scaleW,scaleH,function () {
                    if (!currentPage.backup) {
                        loadPageToPx(currentPage, $scope.template.pageI, function () {
                            for(var i=0; i<$scope.template.pages.page.length; i++){
                                if($scope.currentPage.uuid == $scope.template.pages.page[i].uuid){
                                    $scope.selectPages(i);
                                    break;
                                }
                            }
                            updateHistorys();
                        });
                    }
                },true,false)
            }
        };

        // 可变数据
        $scope.setVariable = function (flag) {
            var i = $scope.template.pageI;
            var level = $scope.template.pages.page[i].levels.level[$scope.template.levelI]
            if (flag) {
                level.variable = true;
            } else {
                level.variable = false;
            }
        };

        $scope.pageIsBackup = function (flag) {
            var i = $scope.template.pageI;
            $scope.lastPage = $scope.template.pages.page[i];
            var backupPage = angular.copy($scope.template.pages.page[i]);
            if(backupPage.scene){
                backupPage.isScene = true;
                $scope.lastPage.isScene = true;
            }
            backupPage.backup = true;
            backupPage.uuid = UidService.get();
            backupPage.type = null;
            $scope.template.backupPages.list.push(backupPage);


            $timeout(function () {
                var nodes = document.getElementsByClassName('page-item2');
                setThumbnailPic(nodes[0], backupPage, 'cover', function () {
                    updateHistorys();
                });
                updateMeasureRuler();
            })

        };

        function pageAnimate() {
            $(".page-item-cover").show()
            setTimeout(function () {
                $(".page-item-cover").addClass('cover-move')
                $(".content-page-cover").addClass('cover-scale')
            })

            setTimeout(function () {
                $(".page-item-cover").hide().removeClass('cover-move')
                $(".content-page-cover").removeClass('cover-scale')
            }, 1200)
        }

        $scope.deleteBackup = function (index) {
            var _list = angular.copy($scope.template.backupPages.list);
            $scope.template.backupPages.list = [];
            $timeout(function () {
                _list.splice(index, 1);
                $scope.template.backupPages.list = _list;
            },300)
        }

        // 备用页替换
        $scope.replaceBackupPage = function (e, item) {
            if(vm.isSkip || vm.textEditor){return}
            if(item.config.partid != $scope.currentPage.config.partid){
                MessageService.error("请选择当前部件的备用页");
                return;
            }
            monthIndexSet($scope.template.pages.page[$scope.template.pageI],function () {
                MessageService.confirm({
                    title:'提示',
                    cancel:'取消',
                    confirm:'确认',
                    msg:'应用本页后，将会覆盖原设计本页的所有现有内容哦。'
                },function(){
                    vm.isSkip = true;
                    fn(e);
                    var i = $scope.template.pageI;
                    var seq = $scope.currentPage.seq;
                    var page = angular.copy(item);
                    if(page.scene){
                        page.isScene = true;
                    }
                    page.uuid = UidService.get();
                    page.config.monthIndex = $scope.template.pages.page[i].config.monthIndex;
                    page.levels.level.forEach(function (level) {
                        if (level.calMonthBox && level.calMonthBox.geometry) {
                            var calMonthBox = level.calMonthBox;
                            calMonthBox.current = 'calMonthBox';
                            calMonthBox.obj = null;
                            calMonthBox.sampleYear = getDay('year',$scope.template.config.startYear,$scope.template.config.startMonth,page.config.monthIndex);
                            calMonthBox.sampleMonth = getDay('month',$scope.template.config.startYear,$scope.template.config.startMonth,page.config.monthIndex);
                        }
                        if (level.calTitleBox && level.calTitleBox.geometry) {
                            var calTitleBox = level.calTitleBox;
                            calTitleBox.current = 'calTitleBox';
                            calTitleBox.obj = null;
                            calTitleBox.sampleYear = getDay('year',$scope.template.config.startYear,$scope.template.config.startMonth,page.config.monthIndex);
                            calTitleBox.sampleMonth = getDay('month',$scope.template.config.startYear,$scope.template.config.startMonth,page.config.monthIndex);
                        }
                    })
                    $scope.currentPage = null;
                    $timeout(function () {
                        if (!page.loaded) {
                            loadPageToPx(page, i, function (_page) {
                                var p = _page;
                                p.seq = seq;
                                p.backup = false;
                                $scope.currentPage = $scope.template.pages.page[i] = p;
                                $scope.lastPage = $scope.template.pages.page[i];
                                setOriginalWaH($scope.currentPage.trimbox.width, $scope.currentPage.trimbox.height, i);
                                updateHistorys();
                                loadAttribute();
                                pageSeq($scope.template.pages.page, UidService, function (page) {
                                    $timeout(function () {
                                        $scope.template.pages.page = page;
                                    }, 100);
                                });
                                // 检查素材精度
                                $timeout(function () {
                                    currentPageElement();
                                }, 2000);
                                vm.isSkip = false;
                            });
                        } else {
                            var p = angular.copy(page);
                            p.seq = seq
                            p.backup = false;
                            $scope.currentPage = $scope.template.pages.page[i] = p;
                            $scope.lastPage = $scope.template.pages.page[i];
                            setOriginalWaH($scope.currentPage.trimbox.width, $scope.currentPage.trimbox.height, i);
                            updateHistorys();
                            loadAttribute();
                            pageSeq($scope.template.pages.page, UidService, function (page) {
                                $timeout(function () {
                                    $scope.template.pages.page = page;
                                }, 100);
                            });
                            $timeout(function () {
                                $scope.$digest();
                            }, 100);
                            // 检查素材精度
                            $timeout(function () {
                                currentPageElement();
                            }, 2000);
                            vm.isSkip = false;
                        }
                    })
                });
            })
        };

        $scope.pageIsReplace = function (flag) {
            var i = $scope.template.pageI;
            var currentPage = $scope.template.pages.page[i];
            if (flag) {
                currentPage.unreplace = false;
            } else {
                currentPage.unreplace = true;
            }
            updateHistorys();
        };
        $scope.onDragComplete = function (index, obj, e) {
            vm.dragIndex = index;
        };
        $scope.onDropComplete = function (index, obj, e) {
            // var otherObj = angular.copy($scope.template.pages.page[index]);
            var otherObj1 = angular.copy($scope.template.pages.page[vm.dragIndex]);
            // $scope.template.pages.page[index] = angular.copy(otherObj1);
            // $scope.template.pages.page[vm.dragIndex] = angular.copy(otherObj);
            var pages = angular.copy($scope.template.pages.page)
            pages.splice(vm.dragIndex,1)
            pages.splice(index,0,otherObj1)
            $scope.template.pages.page = angular.copy(pages);
            pageSeq($scope.template.pages.page, UidService, function (page) {
                $scope.template.pages.page = page;
                $scope.$apply()
            })
        }
        $scope.attributeTab = function (item) {
            vm.attributeTab = item;
            if(item == 'coverage'){
                pageListDrag1()
            }
        }
        //页面元素拖拽
        var sort1 = null;
        var sortArray1 = [];
        function pageListDrag1() {
            $timeout(function () {
                vm.sortingLevel = angular.copy($scope.currentPage.levels.level);
                sort1 = new Sortable(document.getElementById('pageList1'), {
                    swap: false,
                    filter: '.filtered',
                    cancel: ".notDrag",
                    preventOnFilter: true,
                    animation: 150,
                    onEnd: function (/**Event*/evt) {
                        vm.operation = true;
                        sortArray1 = [];
                        angular.forEach($('#pageList1').find(".sortingPageView"), function (item, index) {
                            var page = item.getAttribute("data-page");
                            sortArray1.push(JSON.parse(page));
                        });
                        if (sortArray1 && sortArray1.length > 0) {
                            $scope.currentPage.levels.level = [];
                            $timeout(function () {
                                $scope.currentPage.levels.level = angular.copy(sortArray1.reverse());
                                $scope.currentPage.levels.level.forEach(function (value, index) {
                                    value.seq = index + 1;
                                })
                                sortArray1 = [];
                                $scope.template.levelI = null;
                            })
                        }
                    }
                });
            })
        }

        // 设置封面封底
        $scope.pageIsCover = function (attr) {
            var i = $scope.template.pageI;
            var currentPage = $scope.template.pages.page[i];
            if (currentPage.type && currentPage.type == attr) {
                currentPage.type = null;
            } else {
                angular.forEach($scope.template.pages.page, function (p) {
                    if (attr == 'Cover') {
                        if (p.type == 'Cover' || p.type == 'FrontBack') {
                            p.type = null;
                        }
                    }
                    if (attr == 'BackCover') {
                        if (p.type == 'BackCover' || p.type == 'FrontBack') {
                            p.type = null;
                        }
                    }
                    if (attr == 'FrontBack') {
                        p.type = null;
                    }
                })
                if (attr == 'Cover') {
                    currentPage.type = attr;
                    var page = $scope.template.pages.page.splice(i, 1);
                    $scope.template.pages.page.unshift(page[0]);
                    $scope.template.pageI = 0;
                } else if (attr == 'BackCover') {
                    currentPage.type = attr;
                    var page = $scope.template.pages.page.splice(i, 1);
                    $scope.template.pages.page.push(page[0]);
                    $scope.template.pageI = $scope.template.pages.page.length - 1;
                } else if (attr == 'FrontBack') {
                    currentPage.type = attr;
                    var page = $scope.template.pages.page.splice(i, 1);
                    $scope.template.pages.page.unshift(page[0]);
                    $scope.template.pageI = 0;
                    $scope.pageIsSpread(1)
                }
            }

            $scope.template.pages.page.forEach(function (page, index) {
                page.seq = index + 1
            });
            $scope.currentPage = $scope.template.pages.page[$scope.template.pageI];

            updateHistorys();
        }

        $scope.selectSceneImgDblclick = function (e) {
            $scope.currentPage.isScene = $scope.template.pages.page[$scope.template.pageI].isScene = false;
            updateMeasureRuler();
        }

        // 选择场景
        $scope.selectScene = function () {
            var _page = $scope.template.pages.page[$scope.template.pageI];
            $scope.currentPage = _page;
        }

        function setMargin() {
            var page0 = angular.copy($scope.template.pages.page[$scope.template.pageI]);
            if (page0.scene && page0.scene.imagebox) {
                var w0 = page0.mediabox.width / page0.proportion * page0.scale,
                    h0 = page0.mediabox.height / page0.proportion * page0.scale,
                    w1 = $scope.currentPage.scene.imagebox.geometry.width * $scope.currentPage.scene.scale / $scope.currentPage.scene.proportion,
                    h1 = $scope.currentPage.scene.imagebox.geometry.height * $scope.currentPage.scene.scale / $scope.currentPage.scene.proportion;

                if ((w0 <= h0 || w1 <= h1) && (w0 / h0 < w1 / h1) || w0 >= h0 && w1 >= h1 && (w0 / h0 < w1 / h1)) {
                    $scope.imageboxConH = h1;
                    $scope.imageboxConW = h1 * w0 / h0;
                    $scope.proportion = $scope.imageboxConW / w0;
                } else {
                    $scope.imageboxConW = w1;
                    $scope.imageboxConH = w1 * h0 / w0;
                    $scope.proportion = $scope.imageboxConH / h0;
                }

                $scope.marginLeft = (w1 - $scope.imageboxConW) / 2;
                $scope.marginTop = (h1 - $scope.imageboxConH) / 2;
            }


            if(!vm.thirdparty){
                Catalog.getAll({
                    items: [{key: "type", op: "=", value: "User"}, {
                        key: "catalogType",
                        op: "=",
                        value: "LAYOUT"
                    }, {key: "usable", op: "=", value: true}],
                    sort: ["seq,asc"]
                }, function (res) {
                    vm.catalogList = angular.copy(res);
                    if (vm.catalogList.length > 0) {
                        vm.catalogId = vm.catalogList[0].id;
                    }
                    groupPicLayoutXmls();
                });
            }
        }

        // 增加样例图
        $scope.addSimple = function () {
            var i = $scope.template.pageI;
            $scope.currentPage = $scope.template.pages.page[i];
            $scope.lastPage = $scope.template.pages.page[i];

            setTimeout(function () {
                var nodes = document.getElementsByClassName('page-item2');
                setThumbnailPic(nodes[0], $scope.lastPage, 'addSimple');
            })

        }

        /* ==========================================================================
         左边侧边栏拖动事件
         ========================================================================== */
        $timeout(function () {
            var content = $(".content-container")[0];
            content.ondragenter = ignoreDrag;
            // 拖动文件的鼠标指针位置放置区之上时发生
            content.ondragover = ignoreDrag;
            content.ondrop = drop;


            // 场景
            var content2 = $(".editing1")[0];
            content2.ondragenter = ignoreDrag;
            // 拖动文件的鼠标指针位置放置区之上时发生
            content2.ondragover = ignoreDrag;
            content2.ondrop = drop;
        })

        function ignoreDrag(e) {
            // 确保其他元素不会取得该事件
            e.stopPropagation();
            e.preventDefault();
        }

        function drop(e) {
            ignoreDrag(e);
            var currentPage = $scope.currentPage = $scope.template.pages.page[$scope.template.pageI];
            var data = e.dataTransfer.getData("Text");
            var s = $('#' + data)[0].src;
            var mask = $('#' + data)[0].getAttribute('data-mask');
            var dataIndex = $('#' + data)[0].getAttribute('data-index');
            var s1 = s.split(/\//)[3];


            var offsetX = e.clientX - $("#pageCenterSize").offset().left;
            var offsetY = e.clientY - $("#pageCenterSize").offset().top;
            // 场景
            if (currentPage.isScene) {
                offsetX -= parseFloat($($(".page-item")[1]).css('margin-left'));
                offsetY -= parseFloat($($(".page-item")[1]).css('margin-top'))
            } else {
                offsetX -= parseFloat($($(".page-item")[0]).css('margin-left'));
                offsetY -= parseFloat($($(".page-item")[0]).css('margin-top'))
            }
            if (data.indexOf('dragtargetPhoto') != '-1') {
                var index = null;
                if (e.target.dataset.index) {
                    index = e.target.dataset.index;
                } else {
                    // 判读是否是照片
                    var mask = {
                        identifier: null,
                        provider: 'qiniu',
                        resource: {
                            identifier: '',
                            provider: 'qiniu'
                        }
                    }
                    addPlacement(e, mask, false, offsetX, offsetY);
                    index = $scope.template.levelI;
                }
                var imagebox = currentPage.levels.level[index].imagebox;
                s1 = $('#' + data).attr('data-mask');
                if (imagebox && imagebox.current) {
                    var img = imagebox.imgUrl = s1 + '?imageMogr2/auto-orient/thumbnail/!40p';
                    var newImg = document.createElement('img');
                    newImg.crossOrigin = "Anonymous";
                    newImg.src = img;
                    newImg.onload = function () {
                        newImg.onload = null;
                        var _image = getImageSource(newImg, imagebox, s1, currentPage);
                        imagebox.image = _image;
                        // imageboxResourceCanvas(imagebox);
                        $scope.selectImg(e, index, imagebox);
                        $scope.pxInsufficient(imagebox, 'imagebox');
                        updateHistorys();
                        $scope.$digest();
                    };
                }else{
                    updateHistorys();
                }
            } else if (data.indexOf('dragtargetMask') != '-1') {
                if (data.indexOf('Round') > '-1') {
                    addPlacement1(e, mask, false, offsetX, offsetY, 'Ellipse');
                } else if (data.indexOf('Rectangle') > '-1') {
                    addPlacement1(e, mask, false, offsetX, offsetY, 'Rectangle');
                } else if (data.indexOf('FrameConfig') > '-1') {
                    var index = null;
                    if (e.target.dataset.index) {
                        index = e.target.dataset.index;
                        var imagebox = currentPage.levels.level[index].imagebox;
                        var borderList = vm.frameConfigs[$('#' + data).attr('data-index')];
                        imagebox.border = {
                            shape: borderList.shape || 'Rectangle',
                            radius: {
                                lt: 0,
                                rt: 0,
                                rb: 0,
                                lb: 0,
                                all: 0,
                                filletType: 'Fixed'
                            },
                            "edge": {
                                top: borderList.marginTop,
                                right: borderList.marginRight,
                                bottom: borderList.marginBottom,
                                left: borderList.marginLeft
                            },
                            lineWidth: 0,
                            type: "Pic",
                            resource: {
                                "identifier": borderList.img
                            },
                            color: '',
                        }
                        $scope.$apply();
                    } else {
                        addPlacement1(e, mask, false, offsetX, offsetY, 'FrameConfig', data, function () {
                            var index = $scope.template.levelI;
                            var imagebox = currentPage.levels.level[index].imagebox;
                            if (imagebox.current) {
                                if (imagebox.mask && imagebox.mask.resource && imagebox.mask.resource.identifier && s1) {
                                    imagebox.mask.resource.identifier = s1;
                                    imagebox.mask.resource.provider = 'qiniu';
                                    // maskScale(e, imagebox, index, s1);
                                }
                            }
                        });
                    }
                    return
                } else {
                    // 判读是否是占位框
                    s1 = $('#' + data).attr('data-mask');
                    var mask = {
                        identifier: s1,
                        provider: 'qiniu',
                        resource: {
                            identifier: s1,
                            provider: 'qiniu'
                        }
                    }
                    addPlacement(e, mask, false, offsetX, offsetY);
                }
                var index = $scope.template.levelI;
                var imagebox = currentPage.levels.level[index].imagebox;
                if (imagebox.current) {
                    if (imagebox.mask && imagebox.mask.resource && imagebox.mask.resource.identifier && s1) {
                        imagebox.mask.resource.identifier = s1;
                        imagebox.mask.resource.provider = 'qiniu';
                        // maskScale(e, imagebox, index, s1);
                    }
                    updateHistorys();
                    $scope.$digest();
                }else{
                    updateHistorys();
                }
            } else if (data.indexOf('dragtargetClipArt') != '-1') {
                //判读是否是素材
                var identifier = $('#' + data).attr('data-art');
                $scope.addArt(identifier, offsetX, offsetY);

            } else {
                var bgimg2Arr = vm.showBackgrounds.bgimg[dataIndex];

                var pageW = currentPage.mediabox.width / currentPage.proportion;
                var pageH = currentPage.mediabox.height / currentPage.proportion;
                currentPage.hasBgImg = true;

                $http({url: bgimg2Arr.identifier + '?imageInfo'}).success(function (data) {
                    var bgW = data.width;
                    var bgH = data.height;
                    if (data.orientation == "Left-bottom" || data.orientation == "Right-top" || data.orientation == "Left-top" || data.orientation == "Right-bottom") {
                        bgW = data.height;
                        bgH = data.width;
                    }

                    // 高适配
                    var adaptation = 'Height', h = pageH, w = pageH * bgW / bgH;
                    // 宽适配
                    if ((bgW <= bgH || pageW <= pageH) && (bgW / bgH < pageW / pageH) || bgW >= bgH && pageW >= pageH && (bgW / bgH < pageW / pageH)) {
                        w = pageW;
                        h = pageW * bgH / bgW;
                        adaptation = 'Width';
                    }
                    var pro = $scope.currentPage.scale / $scope.currentPage.proportion
                    $scope.currentPage.background = {
                        resource: {
                            identifier: bgimg2Arr.identifier,
                            provider: 'qiniu',
                            width: bgW,
                            height: bgH
                        },
                        offsetx: 0,
                        offsety: 0,
                        type: 'Pic',
                        color: '',
                        width: w / pro,
                        height: h / pro,
                        adaptation: adaptation,
                        scale: 1
                    }
                    updateHistorys();

                    $scope.pxInsufficient($scope.currentPage, 'background');
                }).error(function (error) {
                    MessageService.error("获取图片信息失败");
                });
            }
        }


        function getImageSource(newImg, imagebox, s1, currentPage) {
            var width = newImg.width;
            var height = newImg.height;

            var _w = imagebox.geometry.width;
            var _h = imagebox.geometry.height;
            var bgImgR = width / height;
            var bgImgR1 = _w / _h;
            var _image = {
                resource: {
                    provider: 'qiniu',
                    identifier: s1,
                },
                angle: 0,
                scale: 1
            }
            if (bgImgR >= bgImgR1) {
                _image.adaptation = 'Height';
                _image.height = _h;
                _image.width = _h / height * width;
                _image.offsetx = -(_image.width - imagebox.geometry.width) / 2;
                _image.offsety = 0;
            } else {
                _image.adaptation = 'Width';
                _image.width = _w;
                _image.height = _w / width * height;
                _image.offsetx = 0;
                _image.offsety = -(_image.height - imagebox.geometry.height) / 2;
            }
            _image.imgWidth = width;
            _image.imgHeight = height;

            return _image
        }

        function getBackgroundSource(res, pageW, pageH, arr) {
            var deferred = $q.defer();
            $http({url: res.identifier + '?imageInfo'}).success(function (data) {
                var bgW = data.width,
                    bgH = data.height;
                if (data.orientation == "Left-bottom" || data.orientation == "Right-top" || data.orientation == "Left-top" || data.orientation == "Right-bottom") {
                    bgW = data.height;
                    bgH = data.width;
                }
                // 高适配
                var adaptation = 'Height', h = pageH, w = pageH * bgW / bgH;
                // 宽适配
                if ((bgW <= bgH || pageW <= pageH) && (bgW / bgH < pageW / pageH) || bgW >= bgH && pageW >= pageH && (bgW / bgH < pageW / pageH)) {
                    w = pageW;
                    h = pageW * bgH / bgW;
                    adaptation = 'Width';
                }
                arr.resource.width = bgW;
                arr.resource.height = bgH;
                arr.width = w;
                arr.height = h;
                arr.type = arr.type;
                arr.offsetx = arr.offsetx
                arr.offsety = arr.offsety
                arr.adaptation = adaptation;
                deferred.resolve("ready");
            }).error(function (error) {
                MessageService.error("获取图片信息失败");
                deferred.resolve("error");
            });
            return deferred.promise;
        }

        function getBackgroundSource1(res, pageW, pageH, arr) {
            var deferred = $q.defer();
            var img = new Image();
            img.src = res.identifier + '?imageMogr2/auto-orient';
            img.onload = function () {
                var bgW = img.width,
                    bgH = img.height;

                // 高适配
                var adaptation = 'Height', h = pageH, w = pageH * bgW / bgH;
                // 宽适配
                if ((bgW <= bgH || pageW <= pageH) && (bgW / bgH < pageW / pageH) || bgW >= bgH && pageW >= pageH && (bgW / bgH < pageW / pageH)) {
                    w = pageW;
                    h = pageW * bgH / bgW;
                    adaptation = 'Width';
                }
                arr.resource.width = bgW;
                arr.resource.height = bgH;
                arr.width = w;
                arr.height = h;
                arr.type = 'Pic';
                arr.adaptation = adaptation;
                $scope.$digest();
                deferred.resolve("ready");
            }
            return deferred.promise;
        }

        function maskScale(e, imageboxs, index, identifier, callback) {
            var imagebox = angular.copy(imageboxs);
            imagebox.mask.resource.identifier = identifier;

            var img = document.getElementsByClassName('page-item')[0].getElementsByClassName('mask')[index];
            var imgUrl = 'content/images/mask_souce2.png';
            if (imagebox.image && imagebox.image.resource && imagebox.image.resource.identifier) {
                imgUrl = imagebox.image.resource.identifier
            }

            var imagecanvas = document.createElement('canvas');
            var imagecontext = imagecanvas.getContext('2d');
            var newImg = document.createElement('img');
            newImg.crossOrigin = "Anonymous";
            newImg.src = imgUrl;
            newImg.onload = function () {
                newImg.onload = null;
                var width = newImg.width;
                var height = newImg.height;
                var scaleW = 1, scaleH = 1;
                if (imagebox.image && imagebox.image.resource && imagebox.image.resource.identifier) {
                    var _image = getImageSource(newImg, imagebox, identifier);
                    width = imagebox.geometry.width;
                    height = imagebox.geometry.height;

                    scaleW = _image.width / newImg.width;
                    scaleH = _image.height / newImg.height;
                    imagebox.image.offsetx = 0;
                    imagebox.image.offsety = 0;
                }
                if (img) {
                    img.setAttribute('data-mask', identifier);
                }
                var masks = document.createElement('img');
                masks.src = identifier;
                masks.crossOrigin = "anonymous";
                masks.onload = function () {
                    masks.onload = null;
                    imagecanvas.width = width;
                    imagecanvas.height = height;
                    imagecontext.drawImage(masks, 0, 0, width, height);
                    imagecontext.globalCompositeOperation = 'source-in';
                    imagecontext.scale(scaleW, scaleH);
                    imagecontext.drawImage(newImg, 0, 0);
                    var pic = imagecanvas.toDataURL();
                    imagebox.bgImg = ImageService.dataURLtoBlob(pic);
                    imageboxs.bgImg = ImageService.dataURLtoBlob(pic);
                    imagebox.mask.resource.identifier = identifier;
                    imagebox.mask.resource.provider = "qiniu";
                    imagebox.maskUrl = identifier;
                    $scope.selectImg(e, index, imagebox);
                    updateHistorys();
                    $scope.$digest();

                    if (callback) {
                        callback();
                    }
                };
                masks.src = identifier;
            };

        }

        window.doubleClickImg = function (e) {
            fn(e);
            $scope.hasText = false;
            $scope.hasImgUrl = true;
            var targ = e.target ? e.target : e.srcElement;
            var imgIndex = targ.dataset.index || $scope.template.levelI;
            $scope.template.levelI = imgIndex;
            var currentImg = $scope.currentPage.levels.level[imgIndex].imagebox;
            if (currentImg.image && currentImg.image.resource && currentImg.image.resource.identifier) {
                $scope.cutImagebox();
            }
        }


        /**
         * 进入图片编辑模式
         */
        $scope.cutImagebox = function () {
            var pro = $scope.currentPage.scale / $scope.currentPage.proportion;
            var box = $scope.currentPage.levels.level[$scope.template.levelI].imagebox;
            $scope.hasText = false;
            $scope.hasImgUrl = true;
            $scope.angle = box.image.angle;
            $scope.scale = box.image.scale;
            $scope.currentImage = box;
            if (!(box.image && box.image.resource && box.image.resource.identifier)) {
                return
            }

            $scope.imgUrl = box.imgUrl = box.image.resource.identifier + '?imageMogr2/auto-orient/thumbnail/!40p';
            $scope.imgBokehtype = box.bokehtype;
            $scope.showImageCut = true;
            $scope.showImageMenu = false;
            $("#cutImagebox-mask").attr('src', '');

            // 显示区域（包含上/下页按钮）
            var pageW = $(".body-content").width();
            var pageH = $(".body-content").height();
            // 选中的占位框位置
            var x = box.geometry.x * pro;
            var y = box.geometry.y * pro;
            // 裁切框显示位置
            var left = parseFloat($(".content-container").offset().left) - 300 + x;
            var top = parseFloat($(".content-container").offset().top) - 92 + y;

            var imageArr = getImageScale(box.image, box.geometry);

            var ww = angular.copy(box.geometry.width) * pro;
            var hh = angular.copy(box.geometry.height) * pro;

            $scope.originL = left;
            $scope.originT = top;
            if (box.image.adaptation == 'Width') {
                $scope.wOpacity = ww;
                $scope.hOpacity = '';
            } else {
                $scope.hOpacity = hh;
                $scope.wOpacity = '';
            }

            if (box.image.angle == 90 || box.image.angle == 270) {
                if (imageArr.isWidth) {
                    $scope.w = ww;
                    $scope.h = '';
                } else {
                    $scope.h = hh;
                    $scope.w = '';
                }
            } else {
                if (box.image.adaptation == 'Width') {
                    $scope.w = ww;
                    $scope.h = '';
                } else {
                    $scope.h = hh;
                    $scope.w = '';
                }
            }

            $scope.l = left;
            $scope.t = top;


            $scope.moveGeo = {
                width: ww,
                height: hh,
                scale: ww / box.geometry.width
            };

            var x = box.image.offsetx * box.image.scaleW * $scope.scale * $scope.moveGeo.scale;
            var y = box.image.offsety * box.image.scaleH * $scope.scale * $scope.moveGeo.scale;
            $("#cutImagebox-img").css({left: x + $scope.l, top: y + $scope.t});

            $scope.ww = ww;
            $scope.hh = hh;
            var s = box.maskUrl;
            ImageService.convertImgToBase64(s, function (s) {
                var imagecanvas = $("#mask-canvas")[0];
                var imagecontext = imagecanvas.getContext('2d');
                var newImg = document.createElement('img');
                // newImg.crossOrigin = "Anonymous";
                newImg.src = 'content/images/zhezhao1.png';
                newImg.onload = function () {
                    newImg.onload = null;
                    var masks = document.createElement('img');
                    masks.src = s;
                    // masks.crossOrigin = "Anonymous";
                    masks.onload = function () {
                        masks.onload = null;
                        imagecanvas.width = pageW;
                        imagecanvas.height = pageH;
                        imagecontext.drawImage(masks, left, top, ww, hh);
                        imagecontext.globalCompositeOperation = 'source-out';
                        imagecontext.drawImage(newImg, 0, 0, pageW, pageH);

                        var moveTime = setInterval(function () {
                            $scope.moveImg = {
                                width: $("#cut-opacity").width(),
                                height: $("#cut-opacity").height(),
                                angle: box.image.angle
                            };
                            $scope.imageArr = getImageScale($scope.moveImg, $scope.moveGeo);
                            if ($scope.moveImg.width != 0 && $scope.moveImg.height != 0) {
                                clearInterval(moveTime);
                            }
                        }, 600);

                        $("#cutImagebox-mask").attr('src', ImageService.dataURLtoBlob(imagecanvas.toDataURL()));

                        $scope.$digest();
                    };
                    // masks.src = box.maskUrl;
                };
                newImg.src = 'content/images/zhezhao1.png';
            });
        };

        function getImageScale(imagebox, images) {
            var w0 = angular.copy(imagebox.width);
            var h0 = angular.copy(imagebox.height);

            if (imagebox.angle == 90 || imagebox.angle == 270) {
                w0 = angular.copy(imagebox.height);
                h0 = angular.copy(imagebox.width);
            }
            var x = 0, y = 0;

            var w = angular.copy(w0);
            var h = angular.copy(h0);
            var maskWidth = images.width;
            var maskHight = images.height;
            var isWidth = true;
            if ((w0 <= h0 || maskWidth <= maskHight) && (w0 / h0 < maskWidth / maskHight) || w0 >= h0 && maskWidth >= maskHight && (w0 / h0 < maskWidth / maskHight)) {
                w0 = maskWidth;
                h0 = maskWidth * h / w;
                isWidth = true;
            } else {
                h0 = maskHight;
                w0 = maskHight * w / h;
                isWidth = false;
            }

            var scaleW = w0 / w;
            var scaleH = h0 / h;
            x = x / scaleW;
            y = y / scaleH;
            return {
                isWidth: isWidth,
                nWidth: w0,
                nHeight: h0,
                scaleW: scaleW,
                scaleH: scaleH,
                x: x,
                y: y
            }
        }


        var drag = false;
        var dragBox = {};
        /**
         * 拖拽编辑的图片
         */
        window.startImageEdit = function (e) {
            fn(e);
            // if ($scope.imgBokehtype != 'None') {
            //     return
            // }
            var box = $scope.currentImage;
            if ($scope.moveImg.width <= 0 || $scope.moveImg.height <= 0) {
                $scope.moveImg = {
                    width: $("#cut-opacity").width(),
                    height: $("#cut-opacity").height(),
                    angle: box.image.angle
                };
            }
            $scope.imageArr = getImageScale($scope.moveImg, $scope.moveGeo);
            dragBox.clientX = e.clientX ? e.clientX : 0;
            dragBox.clientY = e.clientY ? e.clientY : 0;
            dragBox.picW = $("#cutImagebox-img").width();
            dragBox.picH = $("#cutImagebox-img").height();
            // dragBox.coordX = box.image.offsetx * pro;
            // dragBox.coordY = box.image.offsety * pro;
            dragBox.coordX = box.image.offsetx * box.image.scaleW * $scope.scale * $scope.moveGeo.scale;
            dragBox.coordY = box.image.offsety * box.image.scaleH * $scope.scale * $scope.moveGeo.scale;
            drag = true;
            document.addEventListener("mousemove", dragImageEdit, true);
            document.addEventListener("mouseup", stopImageEdit, true);
        };

        function dragImageEdit(e) {
            var box = $scope.currentImage;
            if (drag) {
                var x = 0, y = 0;
                //乘以放大缩小倍数后的宽高
                var orignW = $scope.imageArr.nWidth * $scope.scale;
                var orignH = $scope.imageArr.nHeight * $scope.scale;
                var isWidth = $scope.imageArr.isWidth;
                //手指离开屏幕
                if (!isWidth && $scope.scale == 1) {    //宽图
                    x = (dragBox.coordX + (e.clientX - dragBox.clientX));
                } else if (isWidth && $scope.scale == 1) {     //高图
                    y = (dragBox.coordY + (e.clientY - dragBox.clientY));
                } else if ($scope.scale > 1) {
                    x = (dragBox.coordX + (e.clientX - dragBox.clientX));
                    y = (dragBox.coordY + (e.clientY - dragBox.clientY));
                }

                //向上滑动;
                if (-y >= (orignH - $scope.hh)) {
                    y = -(orignH - $scope.hh);
                }
                //向左滑动;        <-----
                if (-x >= (orignW - $scope.ww)) {
                    x = -(orignW - $scope.ww);
                }
                //向下滑动;
                if (y >= 0) {
                    y = 0;
                }
                // 向右滑动;    ---->
                if (x >= 0) {
                    x = 0;
                }

                var pro = $scope.currentPage.scale / $scope.currentPage.proportion;
                $("#cutImagebox-img").css({left: x + $scope.l, top: y + $scope.t});

                box.image.offsetx = x / $scope.scale / $scope.moveGeo.scale / box.image.scaleW;
                box.image.offsety = y / $scope.scale / $scope.moveGeo.scale / box.image.scaleH;
                // box.image.offsetx = x / pro;
                // box.image.offsety = y / pro;

                $scope.$digest();
                e.stopPropagation();
                e.preventDefault();
                return false;
            }

        };

        function stopImageEdit() {
            drag = false;
            dragBox = {};
            document.removeEventListener("mousemove", dragImageEdit, true);
            document.removeEventListener("mouseup", stopImageEdit, true);
        };


        /**
         * 素材蒙版分类
         * @type {boolean}
         */
        function clickClipArtLabels(cliparts) {
            var items = [{"key": "type", "op": "=", "value": vm.materialTab}];
            if($scope.artlabelChooseId){
                items.push({key: "themeClassify.id", op: "=", value: $scope.artlabelChooseId})
            }
            if(vm.materialTab=='SYSTEM'){
                items.push({"key": "opened", "op": "=", "value": true})
            }
            ClipArts.byCondition({
                items: items,
                page: vm.clipartIndexNum,
                size: vm.itemsPerPage,
                sort: ["id,desc"]
            }, function (resp, headers) {
                vm.totalClipartItems = headers('X-Total-Count');
                if(resp&&resp.length){
                    angular.forEach(resp, function (data, i1) {
                        var arr = {
                            resource: {
                                identifier: vm.url + data.identifier,
                                provider: data.provider,
                            },
                            identifier: data.identifier,
                            type: data.type,
                            id: data.id
                        }
                        if (data.type == 'USER' && $scope.template.cliparts && $scope.template.cliparts.clipart && $scope.template.cliparts.clipart.length) {
                            $scope.template.cliparts.clipart.some(function (cli) {
                                if (cli.resource.identifier == arr.resource.identifier) {
                                    arr.isRecommend = true;
                                    return
                                }
                            })
                        }
                        cliparts.clipart.push(arr);
                    })
                    vm.showCliparts = cliparts;
                } else {
                    vm.showCliparts = cliparts;
                }

            })
        }

        vm.loading = false;
        $scope.selectLabel = function (label, index) {
            $scope.artlabelChooseId = label.id;
            $scope.artlabelChooseIndex = index;
            vm.clipartIndexNum = 0;
            if (!label.firstClick) {
                vm.loading = true;
                label.firstClick = true;
            }
            vm.allCliparts = {clipart: []}
            clickClipArtLabels(vm.allCliparts);
        };

        $scope.chooseMaterialTab = function (attr) {
            vm.materialTab = attr;
            $scope.clipartlabels = [];
            if (attr == 'SYSTEM') {
                $scope.clipartlabels = vm.platformMaterialLabels;
                vm.clipartTab = 'SYSTEM';
                $scope.selectLabel($scope.clipartlabels[0],0);
            } else if(attr == 'USER') {
                $scope.clipartlabels = vm.designerMaterialLabels;
                vm.clipartTab = 'all';
                $scope.selectLabel($scope.clipartlabels[0],0);
            }else{
                vm.clipartTab = attr;
                vm.showCliparts = $scope.template.cliparts;
            }
        }


        $scope.showLabels = false;
        $scope.showMoreLabels = function () {
            $scope.showLabels = !$scope.showLabels;
        }

        $scope.showMaskLabels = false;
        $scope.showMoreMaskLabels = function () {
            $scope.showMaskLabels = !$scope.showMaskLabels;
        }
        /**
         * 保存所编辑过的图片
         */
        $scope.saveMove = function () {
            var box = $scope.currentImage;

            if (box.image.angle != 0) {
                box.imgUrl += '/rotate/' + box.image.angle;
            }
            box.image.scale = $scope.scale;
            $scope.scale = 1;

            var imagecanvas = document.createElement('canvas');
            var imagecontext = imagecanvas.getContext('2d');
            var newImg = document.createElement('img');
            newImg.crossOrigin = "Anonymous";
            newImg.onload = function () {
                newImg.onload = null;
                var _image = getImageSource(newImg, box, box.image.resource.identifier, $scope.currentPage)
                var scaleW = _image.width / newImg.width;
                var scaleH = _image.height / newImg.height;

                var masks = document.createElement('img');
                var maskUrl = 'content/images/mask_souce2.png';
                if (box.mask && box.mask.resource && box.mask.resource.identifier) {
                    maskUrl = box.mask.resource.identifier
                }
                masks.src = maskUrl;
                masks.crossOrigin = "anonymous";
                masks.onload = function () {
                    masks.onload = null;
                    masks.width = box.geometry.width;
                    masks.height = box.geometry.height
                    imagecanvas.width = masks.width;
                    imagecanvas.height = masks.height;
                    imagecontext.drawImage(masks, 0, 0, masks.width, masks.height);
                    imagecontext.globalCompositeOperation = 'source-in';

                    imagecontext.scale(scaleW, scaleH);
                    imagecontext.scale(box.image.scale, box.image.scale);
                    imagecontext.drawImage(newImg, box.image.offsetx, box.image.offsety);
                    var pic = imagecanvas.toDataURL();
                    box.bgImg = ImageService.dataURLtoBlob(pic);
                    updateHistorys();
                    $scope.$digest();
                };
                masks.src = maskUrl;
            };
            newImg.src = box.imgUrl;

            $scope.showImageCut = false;
            updateHistorys();
        };


        vm.isImageboxTrim = false;
        //编辑图片框图片
        $scope.doubleClickImagebox = function (e, index, item) {
            if (!item.image && !item.image.resource && !item.image.resource.identifier) {
                return
            }
            vm.imageboxDouble1 = index;
            vm.imageboxDouble = angular.copy(item);
            vm.isImageboxTrim = true;
            $scope.scale = vm.imageboxDouble.image.scale;
        };
        $scope.imageboxFalseClick = function () {
            vm.isImageboxTrim = false;
        };
        $scope.imageboxTrueClick = function () {
            $scope.currentPage.levels.level[vm.imageboxDouble1].imagebox = vm.imageboxDouble;
            vm.isImageboxTrim = false;
            $scope.currentPage.levels.level[vm.imageboxDouble1].imagebox = vm.imageboxDouble;
            // if ($scope.currentPage.levels.level[vm.imageboxDouble1].imagebox.mask && $scope.currentPage.levels.level[vm.imageboxDouble1].imagebox.mask.resource.identifier) {
            //     imageboxResourceCanvas($scope.currentPage.levels.level[vm.imageboxDouble1].imagebox);
            // }
            $scope.pxInsufficient($scope.currentPage.levels.level[vm.imageboxDouble1].imagebox, 'imagebox');
        };
        var isImageboxMouseDown = false;
        $scope.imageboxMouseDown = function ($event) {
            fn($event)
            var ratio = $scope.currentPage.scale / $scope.currentPage.proportion;
            var x = $event.clientX;
            var y = $event.clientY;
            var l = vm.imageboxDouble.image.offsetx * ratio * vm.imageboxDouble.image.scale;
            var t = vm.imageboxDouble.image.offsety * ratio * vm.imageboxDouble.image.scale;
            var r = -(vm.imageboxDouble.image.width * vm.imageboxDouble.image.scale - vm.imageboxDouble.geometry.width) * ratio;
            var b = -(vm.imageboxDouble.image.height * vm.imageboxDouble.image.scale - vm.imageboxDouble.geometry.height) * ratio;
            var angle = Number(vm.imageboxDouble.rotation.angle);
            //开关打开
            isImageboxMouseDown = true;
            //鼠标移动
            window.onmousemove = function (e) {
                if (isImageboxMouseDown == false) {
                    return;
                }
                fn(e);
                var cx = (l + r) / 2;
                var cy = (t + b) / 2;
                var pt0 = rotatePoint({x: x, y: y}, {x: cx, y: cy}, angle);
                var pt1 = rotatePoint({x: e.clientX, y: e.clientY}, {x: cx, y: cy}, angle);
                var deltaX = pt1.x - pt0.x;
                var deltaY = pt1.y - pt0.y;
                var nl = l + deltaX;
                var nt = t + deltaY;
                if (nl < r) {
                    nl = r
                }
                ;
                if (nl > 0) {
                    nl = 0
                }
                ;
                if (nt < b) {
                    nt = b
                }
                ;
                if (nt > 0) {
                    nt = 0
                }
                ;

                vm.imageboxDouble.image.offsetx = nl / ratio / vm.imageboxDouble.image.scale;
                vm.imageboxDouble.image.offsety = nt / ratio / vm.imageboxDouble.image.scale;
                $scope.$digest();
            }
            //鼠标抬起事件
            window.onmouseup = function ($event) {
                isImageboxMouseDown = false;
                $scope.$digest();
            }
        }


        // 滚动放大
        window.bbimg = function (delta) {
            if (vm.ctrlKey) {
                return
            }
            if (delta < 0 || delta == undefined && event.wheelDelta > 0) {
                $scope.scale *= 1.2;
            } else {
                $scope.scale /= 1.2;
                if ($scope.scale <= 1) {
                    $scope.scale = 1;
                }
            }
            vm.imageboxDouble.image.scale = $scope.scale;
            if (vm.imageboxDouble.image.offsetx * vm.imageboxDouble.image.scale < -(vm.imageboxDouble.image.width * vm.imageboxDouble.image.scale - vm.imageboxDouble.geometry.width)) {
                vm.imageboxDouble.image.offsetx = -(vm.imageboxDouble.image.width * vm.imageboxDouble.image.scale - vm.imageboxDouble.geometry.width) / vm.imageboxDouble.image.scale
            }
            if (vm.imageboxDouble.image.offsety * vm.imageboxDouble.image.scale < -(vm.imageboxDouble.image.height * vm.imageboxDouble.image.scale - vm.imageboxDouble.geometry.height)) {
                vm.imageboxDouble.image.offsety = -(vm.imageboxDouble.image.height * vm.imageboxDouble.image.scale - vm.imageboxDouble.geometry.height) / vm.imageboxDouble.image.scale
            }
            $scope.$digest();
            return false;
        }

        //Firefox只识别DOMMouseScroll
        var mousewheelevt = (/Firefox/i.test(navigator.userAgent)) ? "DOMMouseScroll" : "mousewheel";

        //判断是否是IE
        if (document.attachEvent) {
            $("#mouseWheel")[0].attachEvent("on" + mousewheelevt, function (e) {
                window.bbimg();
            });
        } else if (document.addEventListener) { //FireFox(DOMMouseScroll)、Chrome、Opera、safari
            $("#mouseWheel")[0].addEventListener(mousewheelevt, function (e) {
                e = e || window.event;
                if (e.detail) {//Firefox
                    window.bbimg(e.detail);
                } else if (e.wheelDelta) {
                    window.bbimg();
                }
            }, false);
        }
        originalEventRatio();

        function originalEventRatio() {
            window.addEventListener('mousewheel', function (event) {
                if (event.ctrlKey === true || event.metaKey) {
                    var wheelDelta = event.wheelDelta ? (event.wheelDelta / 120) : (-event.detail / 3);
                    if (wheelDelta > 0) {
                        $scope.changeShirnk(2);
                    } else {
                        $scope.changeShirnk(1);
                    }
                    $scope.$apply();
                    event.preventDefault();
                }
            }, {passive: false});
        }


        window.dragStart = function (event) {
            var target = event.target;
            event.dataTransfer.setData("Text", target.id);
            if (target.id.indexOf('dragtargetClipArt') != '-1') {
                event.dataTransfer.setData("Art", target.dataset.clipart);
            }
        };
        var _imageartOffset = 0;
        $scope.addArt = function (identifier, offsetX, offsetY) {
            if(vm.textEditor){
                return
            }
            var currentPage = $scope.template.pages.page[$scope.template.pageI];
            var currentLevel = addLevel(currentPage);

            vm.unit = 'mm';
            var newImg = document.createElement('img');
            newImg.crossOrigin = "Anonymous";
            newImg.src = identifier + '?imageView2';
            newImg.onload = function () {
                newImg.onload = null;
                var width = newImg.width;
                var height = newImg.height;

                var bgImgR = width / height;
                offsetX = offsetX / currentPage.scale * currentPage.proportion;
                offsetY = offsetY / currentPage.scale * currentPage.proportion;
                var _dx = 136;
                var _imageart = {};
                if (bgImgR >= 1) {
                    if (width > _dx) {
                        _imageart = {
                            width: _dx / currentPage.scale * currentPage.proportion,
                            height: _dx / width * height / currentPage.scale * currentPage.proportion,
                            x: offsetX,
                            y: offsetY
                        }
                    } else {
                        _imageart = {
                            height: height / currentPage.scale * currentPage.proportion,
                            width: width / currentPage.scale * currentPage.proportion,
                            x: offsetX,
                            y: offsetY
                        }
                    }
                } else {
                    if (height > _dx) {
                        _imageart = {
                            height: _dx / currentPage.scale * currentPage.proportion,
                            width: _dx / height * width / currentPage.scale * currentPage.proportion,
                            x: offsetX,
                            y: offsetY
                        }
                    } else {
                        _imageart = {
                            height: height / currentPage.scale * currentPage.proportion,
                            width: width / currentPage.scale * currentPage.proportion,
                            x: offsetX,
                            y: offsetY
                        }
                    }
                }
                if(offsetX && offsetY){
                    _imageart.x = _imageart.x - _imageart.width/2 + MmTurnPx(_imageartOffset);
                    _imageart.y = _imageart.y - _imageart.height/2 + MmTurnPx(_imageartOffset);
                }else{
                    _imageart.x = (currentPage.mediabox.width - _imageart.width)/2 + MmTurnPx(_imageartOffset);
                    _imageart.y = (currentPage.mediabox.height - _imageart.height)/2 + MmTurnPx(_imageartOffset);
                }
                _imageartOffset += 1;
                $scope.pageValue.imageart = {
                    width: PxTurnMm(_imageart.width),
                    height: PxTurnMm(_imageart.height),
                    x: PxTurnMm(_imageart.x),
                    y: PxTurnMm(_imageart.y)
                };
                currentLevel.imageart = ({
                    geometry: {
                        width: _imageart.width,
                        height: _imageart.height,
                        x: _imageart.x,
                        y: _imageart.y
                    },
                    rotation: {
                        angle: 0
                    },
                    resource: {
                        identifier: identifier,
                        provider: 'qiniu',
                        width: width,
                        height: height,
                    },
                    scale: 1,
                    transparency: 1,
                    onlyshow: false,
                    movable: true,
                    editable: true,
                    bgImg: '',
                    offsetx: 0,
                    offsety: 0,
                    unit: 'mm',
                    // index: currentPage.imagearts.imageart.length,
                    levelI: $scope.template.levelI,
                    pageI: $scope.template.pageI,
                    current: 'imageart',
                    lock: false
                });

                $scope.currentPage = currentPage;
                $scope.RightPanel = 'material';
                $scope.selectBox = currentLevel.imageart;
                $scope.template.transparency = 100;
                $scope.pxInsufficient(currentLevel.imageart, 'imageart');
                updateHistorys();
                $scope.$digest();
                vm.selectElementCopy = angular.copy($scope.currentPage.levels.level[$scope.template.levelI]);
            };
        }

        /* ==========================================================================
         占位框处理
         ========================================================================== */

        function addLevel(currentPage) {
            var arr = {
                seq: 1,
                imagebox: null,
                textbox: null,
                imageart: null,
                textdocument: null,
                variable: false
            };

            if (!currentPage.levels.level) {
                currentPage.levels.level = [arr];
            } else {
                currentPage.levels.level.push(arr);
            }

            $scope.template.levelI = currentPage.levels.level.length - 1;
            var currentLevel = currentPage.levels.level[$scope.template.levelI];

            currentLevel.seq = $scope.template.levelI + 1;
            vm.unit = 'mm';
            $scope.template.angle = 0;
            return currentLevel;
        }

        //增加图片占位框
        var addPlacement = function (e, mask, attr, offsetX, offsetY) {
            var currentPage = $scope.template.pages.page[$scope.template.pageI];
            var currentLevel = addLevel(currentPage);

            offsetX = offsetX / currentPage.scale * currentPage.proportion;
            offsetY = offsetY / currentPage.scale * currentPage.proportion;


            currentLevel.imagebox = ({
                geometry: {
                    width: MmTurnPx(50),
                    height: MmTurnPx(50),
                    x: MmTurnPx(PxTurnMm(offsetX) - 25),
                    y: MmTurnPx(PxTurnMm(offsetY) - 25)
                },
                rotation: {
                    angle: 0
                },
                mask: {
                    resource: {
                        identifier: mask.identifier,
                        provider: 'qiniu'
                    }
                },
                border: {
                    shape: 'Rectangle',
                    radius: {
                        lt: 0,
                        rt: 0,
                        rb: 0,
                        lb: 0,
                        all: 0,
                        filletType: 'Fixed'
                    },
                    "edge": {
                        top: 0,
                        right: 0,
                        bottom: 0,
                        left: 0
                    },
                    lineWidth: 0,
                    type: "Color",
                    lineType: "solid",
                    resource: {
                        "identifier": ''
                    },
                    color: '#000000',
                },
                shadow: {
                    color: '#777777',
                    x: 0,
                    y: 0,
                    blur: 0
                },
                imgUrl: 'content/images/mask_souce2.png',
                maskUrl: mask.identifier || 'content/images/mask_souce2.png',
                transparency: 1,
                bgImg: '',
                unit: 'mm',
                levelI: $scope.template.levelI,
                pageI: $scope.template.pageI,
                current: 'imagebox',
                lock: false
            });

            $scope.currentPage = currentPage;
            $scope.selectBox = currentLevel.imagebox;
            $scope.RightPanel = 'mask';
            getImageboxLen();
            if (vm.unit == 'mm') {
                $scope.pageValue.imagebox = {
                    width: 50,
                    height: 45,
                    x: PxTurnMm(offsetX) - 25,
                    y: PxTurnMm(offsetY) - 23
                }
            } else if (vm.unit == 'px') {
                $scope.pageValue.imagebox = currentPage.imagebox.geometry;
            } else if (vm.unit == 'in') {
                $scope.pageValue.imagebox = {
                    width: PxTurnIn(currentPage.imagebox.geometry.width),
                    height: PxTurnIn(currentPage.imagebox.geometry.height),
                    x: PxTurnIn(currentPage.imagebox.geometry.x),
                    y: PxTurnIn(currentPage.imagebox.geometry.y)
                }
            }
            $scope.pxInsufficient(currentLevel.imagebox, 'imagebox');
        };
        var addPlacement1 = function (e, mask, attr, offsetX, offsetY, shape, data, callback) {
            var currentPage = $scope.template.pages.page[$scope.template.pageI];
            var currentLevel = addLevel(currentPage);

            offsetX = offsetX / currentPage.scale * currentPage.proportion;
            offsetY = offsetY / currentPage.scale * currentPage.proportion;


            if (shape == 'FrameConfig') {
                var frameConfig = vm.frameConfigs[$('#' + data).attr('data-index')];

                $http({url: frameConfig.img + '?imageInfo'}).success(function (data) {
                    var imgZoom = 1;
                    if (data.width > data.height) {
                        imgZoom = 300 / data.width
                    } else {
                        imgZoom = 300 / data.height
                    }
                    var _w2 = (imgZoom * data.width) / (1 + frameConfig.marginLeft / 100 + frameConfig.marginRight / 100);
                    var _h2 = (imgZoom * data.height) / (1 + frameConfig.marginBottom / 100 + frameConfig.marginTop / 100);
                    currentLevel.imagebox = ({
                        geometry: {
                            width: _w2,
                            height: _h2,
                            x: offsetX - _w2 / 2,
                            y: offsetY - _h2 / 2
                        },
                        rotation: {
                            angle: 0
                        },
                        mask: {
                            resource: {
                                identifier: '',
                                provider: 'qiniu'
                            }
                        },
                        imgUrl: 'content/images/mask_souce2.png',
                        maskUrl: 'content/images/mask_souce2.png',
                        transparency: 1,
                        bgImg: '',
                        unit: 'mm',
                        levelI: $scope.template.levelI,
                        pageI: $scope.template.pageI,
                        current: 'imagebox',
                        lock: false,
                        border: {
                            shape: frameConfig.shape || 'Rectangle',
                            radius: {
                                lt: 0,
                                rt: 0,
                                rb: 0,
                                lb: 0,
                                all: 0,
                                filletType: 'Fixed'
                            },
                            "edge": {
                                top: frameConfig.marginTop,
                                right: frameConfig.marginRight,
                                bottom: frameConfig.marginBottom,
                                left: frameConfig.marginLeft
                            },
                            lineWidth: 0,
                            type: "Pic",
                            lineType: "solid",
                            resource: {
                                "identifier": frameConfig.img
                            },
                            color: '',
                        },
                        shadow: {
                            color: '#777777',
                            x: 0,
                            y: 0,
                            blur: 0
                        }
                    });

                    $scope.currentPage = currentPage;
                    $scope.selectBox = currentLevel.imagebox;
                    $scope.RightPanel = 'mask';
                    getImageboxLen();
                    if (vm.unit == 'mm') {
                        $scope.pageValue.imagebox = {
                            width: PxTurnMm(_w2),
                            height: PxTurnMm(_h2),
                            x: PxTurnMm(offsetX) - PxTurnMm(_w2) / 2,
                            y: PxTurnMm(offsetY) - PxTurnMm(_w2) / 2
                        }
                    } else if (vm.unit == 'px') {
                        $scope.pageValue.imagebox = currentPage.imagebox.geometry;
                    } else if (vm.unit == 'in') {
                        $scope.pageValue.imagebox = {
                            width: PxTurnIn(currentPage.imagebox.geometry.width),
                            height: PxTurnIn(currentPage.imagebox.geometry.height),
                            x: PxTurnIn(currentPage.imagebox.geometry.x),
                            y: PxTurnIn(currentPage.imagebox.geometry.y)
                        }
                    }
                    $scope.pxInsufficient(currentLevel.imagebox, 'imagebox');
                    updateHistorys();
                    if (callback) {
                        callback()
                    }
                })
            } else {
                currentLevel.imagebox = ({
                    geometry: {
                        width: MmTurnPx(50),
                        height: MmTurnPx(50),
                        x: MmTurnPx(PxTurnMm(offsetX) - 25),
                        y: MmTurnPx(PxTurnMm(offsetY) - 25)
                    },
                    rotation: {
                        angle: 0
                    },
                    mask: {
                        resource: {
                            identifier: mask.identifier,
                            provider: 'qiniu'
                        }
                    },
                    imgUrl: 'content/images/mask_souce2.png',
                    maskUrl: mask.identifier || 'content/images/mask_souce2.png',
                    transparency: 1,
                    bgImg: '',
                    unit: 'mm',
                    levelI: $scope.template.levelI,
                    pageI: $scope.template.pageI,
                    current: 'imagebox',
                    lock: false,
                    border: {
                        shape: shape,
                        radius: {
                            lt: 0,
                            rt: 0,
                            rb: 0,
                            lb: 0,
                            all: 0,
                            filletType: 'Fixed'
                        },
                        "edge": {
                            top: 0,
                            right: 0,
                            bottom: 0,
                            left: 0
                        },
                        lineWidth: 0,
                        type: "Color",
                        lineType: "solid",
                        resource: {
                            "identifier": ''
                        },
                        color: '#000000',
                    },
                    shadow: {
                        color: '#777777',
                        x: 0,
                        y: 0,
                        blur: 0
                    }
                });

                $scope.currentPage = currentPage;
                $scope.selectBox = currentLevel.imagebox;
                $scope.RightPanel = 'mask';
                getImageboxLen();
                if (vm.unit == 'mm') {
                    $scope.pageValue.imagebox = {
                        width: 50,
                        height: 45,
                        x: PxTurnMm(offsetX) - 25,
                        y: PxTurnMm(offsetY) - 23
                    }
                } else if (vm.unit == 'px') {
                    $scope.pageValue.imagebox = currentPage.imagebox.geometry;
                } else if (vm.unit == 'in') {
                    $scope.pageValue.imagebox = {
                        width: PxTurnIn(currentPage.imagebox.geometry.width),
                        height: PxTurnIn(currentPage.imagebox.geometry.height),
                        x: PxTurnIn(currentPage.imagebox.geometry.x),
                        y: PxTurnIn(currentPage.imagebox.geometry.y)
                    }
                }
                $scope.pxInsufficient(currentLevel.imagebox, 'imagebox');
            }
            vm.selectElementCopy = angular.copy($scope.currentPage.levels.level[$scope.template.levelI]);
            updateHistorys();
            return
        };

        function getImageboxLen() {
            vm.count = 0;
            angular.forEach($scope.currentPage.levels.level, function (level) {
                if (level.imagebox && level.imagebox.geometry) {
                    vm.count++;
                }
            })
        }

        // 占位框背景
        window.updateMask = function ($event) {
            var files = $event.target.files;
            bigSizePics = [];
            vm.uploadType = "MASK";
            var _index = 0;
            for (var i = 0; i < files.length; i++) {
                var file = files[i];
                if (file.size >= 20 * 1024 * 1024) {
                    file.imageSize = Math.ceil(file.size / 1024 / 1024);
                    bigSizePics.push(file);
                    _index++
                } else {
                    getMask(files,i,function () {
                        _index++
                        if(_index == files.length){
                            $timeout(function () {
                                $event.srcElement.value = "";
                            })
                        }
                    });
                    if (bigSizePics.length == 0 && i == (files.length - 1)) {
                        vm.picLoading = false;
                    }
                }
            }
            if (bigSizePics.length > 0) {
                thumbnailatorPic();
            }
        };

        function getMask(files,i,callback) {
                var url = window.URL || window.webkitURL;
                var pic = url.createObjectURL(files[i]);
                var formData = new FormData();
                formData.append('file', files[i]);
                formData.append('key', 'mask-' + UidService.get());
                formData.append('token', vm.token);
                $.ajax({
                    cache: true,
                    type: "POST",
                    url: 'https://upload.qiniup.com/',
                    data: formData,
                    async: true,
                    contentType: false,
                    processData: false,
                    success: function (data) {
                        SourceMaterial.createOne({
                            identifier: data.key,
                            provider: 'qiniu',
                            name: files[i].name,
                            type: 'User',
                            themeClassifyId: $scope.masklabelChooseId
                        }, function (resp) {
                            var arr = {
                                resource: {
                                    identifier: vm.url + resp.identifier,
                                    provider: resp.provider,
                                },
                                type: resp.type,
                                id: resp.id,
                                isRecommend: false,
                                identifier: vm.url + resp.identifier,
                                provider: 'qiniu',
                                bgImg: '',
                            }
                            vm.showMasks.mask.unshift(arr);
                            if(callback){callback()}
                        },function () {
                            if(callback){callback()}
                        });
                    },
                    error: function (request) {
                        if(callback){callback()}
                    }
                });
        };

        //图片占位框点击时
        $scope.selectImg = function (e, $index, img) {
            if (!e || vm.textEditor) {
                return
            }
            if (!img.border) {
                img.border = {
                    shape: 'Rectangle',
                    radius: {
                        lt: 0,
                        rt: 0,
                        rb: 0,
                        lb: 0,
                        all: 0,
                        filletType: 'Fixed'
                    },
                    "edge": {
                        top: 0,
                        right: 0,
                        bottom: 0,
                        left: 0
                    },
                    lineWidth: 0,
                    type: "Color",
                    resource: {
                        "identifier": ''
                    },
                    color: '',
                }
            }

            if (vm.unit == 'mm') {
                $scope.pageValue.imagebox = {
                    width: PxTurnMm(img.geometry.width).toFixed(2) - 0,
                    height: PxTurnMm(img.geometry.height).toFixed(2) - 0,
                    x: PxTurnMm(img.geometry.x).toFixed(2) - 0,
                    y: PxTurnMm(img.geometry.y).toFixed(2) - 0
                }
            } else if (vm.unit == 'px') {
                $scope.pageValue.imagebox = {
                    width: img.geometry.width,
                    height: img.geometry.height,
                    x: img.geometry.x,
                    y: img.geometry.y
                }
            } else if (vm.unit == 'in') {
                $scope.pageValue.imagebox = {
                    width: PxTurnIn(img.geometry.width),
                    height: PxTurnIn(img.geometry.height),
                    x: PxTurnIn(img.geometry.x),
                    y: PxTurnIn(img.geometry.y)
                }
            }

            $scope.template.angle = img.rotation.angle;
            img.current = 'imagebox';
            $scope.selectBox = img;
            vm.selectItem = angular.copy(img);

            //如果是按住ctrl键 实现多选复制
            if (e.ctrlKey == true || e.metaKey == true) {
                img.ctrlKey = true;
                img.levelI = $index;
                vm.CtrlKeyArray.imageboxes[$index] = angular.copy(img);
                ctrlAddSingleArray();
            } else {
                if (!img.ctrlKey) {
                    $scope.clearCtrlKey();
                    vm.singleArray = {imagebox: {}, textbox: {}, imageart: {}, barcode: {}, qrcode: {}, calMonthBox: {}, calTitleBox: {}};
                }
                vm.singleArray.imagebox = angular.copy(img);
            }
            $("#menus").fadeOut();
            $("#maskSelect").val("");
            $scope.template.levelI = $index;
            $scope.RightPanel = 'mask';
            e.stopPropagation();
            // 判断vm.borderRadiusAllbtn 给all输入框赋值
            if ($scope.selectBox.border.radius.lt == $scope.selectBox.border.radius.lb && $scope.selectBox.border.radius.lb == $scope.selectBox.border.radius.rt && $scope.selectBox.border.radius.rt == $scope.selectBox.border.radius.rb) {
                vm.borderRadiusAllbtn = true
                $scope.selectBox.border.radius.all = $scope.selectBox.border.radius.lt;
            } else {
                vm.borderRadiusAllbtn = false
            }

            vm.selectElementCopy = angular.copy($scope.currentPage.levels.level[$scope.template.levelI]);
        };

        function ctrlAddSingleArray() {
            if (vm.singleArray.imagebox.index != undefined) {
                var index = vm.singleArray.imagebox.index;
                $scope.currentPage.imageboxes.imagebox[index].ctrlKey = true;
                vm.CtrlKeyArray.imageboxes[index] = vm.singleArray.imagebox;
            }
            if (vm.singleArray.textbox.index != undefined) {
                var index = vm.singleArray.textbox.index;
                $scope.currentPage.textboxes.textbox[index].ctrlKey = true;
                vm.CtrlKeyArray.textboxes[index] = vm.singleArray.textbox;
            }
            if (vm.singleArray.imageart.index != undefined) {
                var index = vm.singleArray.imageart.index;
                $scope.currentPage.imagearts.imageart[index].ctrlKey = true;
                vm.CtrlKeyArray.imagearts[index] = vm.singleArray.imageart;
            }
            if (vm.singleArray.barcode.index != undefined) {
                vm.singleArray.barcode.ctrlKey = true;
                vm.CtrlKeyArray.barcode[0] = vm.singleArray.barcode;
            }
            if (vm.singleArray.qrcode.index != undefined) {
                vm.singleArray.qrcode.ctrlKey = true;
                vm.CtrlKeyArray.qrcode[0] = vm.singleArray.qrcode;
            }
            if (vm.singleArray.calMonthBox.index != undefined) {
                vm.singleArray.calMonthBox.ctrlKey = true;
                vm.CtrlKeyArray.calMonthBoxs[0] = vm.singleArray.calMonthBox;
            }
            if (vm.singleArray.calTitleBox && vm.singleArray.calTitleBox.index != undefined) {
                vm.singleArray.calTitleBox.ctrlKey = true;
                vm.CtrlKeyArray.calTitleBoxs[0] = vm.singleArray.calTitleBox;
            }
            vm.singleArray = {imagebox: {}, textbox: {}, imageart: {}, barcode: {}, qrcode: {}, calMonthBox: {}, calTitleBox: {}};
        }

        //图片占位框鼠标事件
        var drag;
        var dragBox = {};
        var dragMask = {};
        $scope.buttonShows = false;
        $scope.moveBoxStart = function (e, item, index) {
            if(vm.textEditor){
                return;
            }
            fn(e);
            // $timeout(function(){
            //     $('#focusInput').focus();//当属性栏有输入框聚焦时择强制失去焦点
            // },500)
            $scope.buttonShows = true;
            var targ = e.target ? e.target : e.srcElement;
            $scope.template.levelI = index;
            $scope.template.angle = item.rotation.angle;
            if (item.lock) {
                return
            }

            dragBox.clientX = e.clientX || 0;
            dragBox.clientY = e.clientY || 0;
            if (item.current == 'page') {
                return
            } else if (item.current == 'imagebox') {
                dragBox.coordX = item.geometry.x * $scope.currentPage.scale / $scope.currentPage.proportion;
                dragBox.coordY = item.geometry.y * $scope.currentPage.scale / $scope.currentPage.proportion;
            } else if (item.current == 'textdocument') {
                dragBox.coordX = e.currentTarget.offsetLeft;
                dragBox.coordY = e.currentTarget.offsetTop;
            } else {
                dragBox.coordX = item.geometry.x * $scope.currentPage.scale / $scope.currentPage.proportion;
                dragBox.coordY = item.geometry.y * $scope.currentPage.scale / $scope.currentPage.proportion;
            }
            drag = true;
            var all = getAllCtrlKeyArray();
            if (all.length) {
                dragBox.ctrlKey = true;
            } else {
                dragBox.ctrlKey = false;
            }
            $scope.selectBox = item;
            if(vm.staff){
                vm.coordinates = coordinates($scope.currentPage.levels.level,$scope.template.levelI);
                vm.coordinates.x = vm.coordinates.x.concat(vm.sublinesX);
                vm.coordinates.y = vm.coordinates.y.concat(vm.sublinesY);
            }
            document.addEventListener("mousemove", moveBoxOn, true);
            document.addEventListener("mouseup", moveBoxEnd, true);

        };
        //move 事件
        function moveBoxOn(e) {
            fn(e);
            $scope.$digest();
            if (e.target.nodeName == 'SPAN' && $scope.selectBox.current != 'textbox') {
                return;
            }
            if (drag) {
                var currentPage = $scope.template.pages.page[$scope.template.pageI];
                var angle = ($scope.selectBox.rotation.angle) * Math.PI / 180;

                var clientX = e.clientX - dragBox.clientX;
                var clientY = e.clientY - dragBox.clientY;

                var imgOffsetX = (dragBox.coordX + e.clientX - dragBox.clientX);
                var imgOffsetY = (dragBox.coordY + e.clientY - dragBox.clientY);
                var imgWidth = $scope.selectBox.geometry.width * currentPage.scale / currentPage.proportion;
                var imgHeight = $scope.selectBox.geometry.height * currentPage.scale / currentPage.proportion;

                if ($scope.selectBox.current == 'textbox') {
                    imgWidth = $(".textbox" + $scope.template.pageI + $scope.template.levelI).width();
                    imgHeight = $(".textbox" + $scope.template.pageI + $scope.template.levelI).height();
                }
                var height = currentPage.height * currentPage.scale;
                var width = currentPage.width * currentPage.scale;
                var lar = (currentPage.bloodPx.left + currentPage.bloodPx.right) * currentPage.scale / currentPage.proportion;
                var tab = (currentPage.bloodPx.top + currentPage.bloodPx.bottom) * currentPage.scale / currentPage.proportion;

                // if (imgOffsetX <= 0) {
                //     imgOffsetX = 0;
                // }
                //
                // if (imgOffsetX >= (width + lar - imgWidth)) {
                //     imgOffsetX = width + lar - imgWidth;
                // }
                // if (imgOffsetY <= 0) {
                //     imgOffsetY = 0;
                // }
                //
                // if (imgOffsetY >= (height + tab - imgHeight)) {
                //     imgOffsetY = height + tab - imgHeight;
                // }

                if (dragBox.ctrlKey) {
                    moveTogether(currentPage, clientX, clientY);
                } else {
                    $scope.selectBox.geometry.x = imgOffsetX / currentPage.scale * currentPage.proportion;
                    $scope.selectBox.geometry.y = imgOffsetY / currentPage.scale * currentPage.proportion;
                    if(vm.staff){
                        vm.lineReferenceX = null;
                        vm.lineReferenceY = null;
                        getItemCoordinates($scope.selectBox,vm.coordinates,function (item) {
                            if(item.x){
                                vm.lineReferenceX = item.x.closestNum;
                                $scope.selectBox.geometry.x = $scope.selectBox.geometry.x + item.x.diff;
                            }
                            if(item.y){
                                vm.lineReferenceY = item.y.closestNum;
                                $scope.selectBox.geometry.y = $scope.selectBox.geometry.y + item.y.diff;
                            }
                        });
                    }
                    var value = {};
                    if ($scope.selectBox.current == 'textbox') {
                        value = $scope.pageValue.textbox;
                    } else if ($scope.selectBox.current == 'imagebox') {
                        value = $scope.pageValue.imagebox;
                    } else if ($scope.selectBox.current == 'imageart') {
                        value = $scope.pageValue.imageart;
                    } else if ($scope.selectBox.current == 'textdocument') {
                        value = $scope.pageValue.textdocument;
                    } else if ($scope.selectBox.current == 'calMonthBox') {
                        value = $scope.pageValue.calMonthBox;
                    } else if ($scope.selectBox.current == 'calTitleBox') {
                        value = $scope.pageValue.calTitleBox;
                    }
                    if(value){
                        if (vm.unit == 'mm') {
                            value.x = PxTurnMm($scope.selectBox.geometry.x).toFixed(2) - 0;//px-->mm
                            value.y = PxTurnMm($scope.selectBox.geometry.y).toFixed(2) - 0;//px-->mm
                        } else if (vm.unit == 'px') {
                            value.x = PxTurnMm($scope.selectBox.geometry.x / 25.4 * vm.windowDpiW);
                            value.y = PxTurnMm($scope.selectBox.geometry.y / 25.4 * vm.windowDpiW);
                        } else if (vm.unit == 'In') {
                            value.x = PxTurnIn($scope.selectBox.geometry.x);
                            value.y = PxTurnIn($scope.selectBox.geometry.y);
                        }
                    }
                }
                $scope.currentPage = currentPage;

            }
            return false;
        }
        //鼠标松开事件
        function moveBoxEnd() {
            vm.lineReferenceX = null;
            vm.lineReferenceY = null;
            if (dragBox.ctrlKey) {
                moveTogetherEnd();
            }
            drag = false;
            dragBox = {};
            document.removeEventListener("mousemove", moveBoxOn, true);
            document.removeEventListener("mouseup", moveBoxEnd, true);
            updateHistorys();
            $scope.$digest();
        }

        $scope.moveBoxStart1 = function (e, item, index) {
            if(vm.textEditor){
                return;
            }
            fn(e);
            $scope.buttonShows = true;
            var targ = e.target ? e.target : e.srcElement;
            $scope.template.levelI = index;
            $scope.template.angle = item.rotation.angle;
            if (item.lock) {
                return
            }

            dragBox.clientX = e.clientX || 0;
            dragBox.clientY = e.clientY || 0;
            if (item.current == 'page') {
                return
            } else if (item.current == 'imagebox') {
                dragBox.coordX = item.geometry.x * $scope.currentPage.scale / $scope.currentPage.scene.proportion;
                dragBox.coordY = item.geometry.y * $scope.currentPage.scale / $scope.currentPage.scene.proportion;
            } else if (item.current == 'textdocument') {
                dragBox.coordX = e.currentTarget.offsetLeft;
                dragBox.coordY = e.currentTarget.offsetTop;
            } else {
                dragBox.coordX = item.geometry.x * $scope.currentPage.scale / $scope.currentPage.scene.proportion;
                dragBox.coordY = item.geometry.y * $scope.currentPage.scale / $scope.currentPage.scene.proportion;
            }
            drag = true;
            var all = getAllCtrlKeyArray();
            if (all.length) {
                dragBox.ctrlKey = true;
            } else {
                dragBox.ctrlKey = false;
            }
            $scope.selectBox = item;
            if(vm.staff){
                vm.coordinates = coordinates($scope.currentPage.levels.level,$scope.template.levelI);
                vm.coordinates.x = vm.coordinates.x.concat(vm.sublinesX);
                vm.coordinates.y = vm.coordinates.y.concat(vm.sublinesY);
            }
            document.addEventListener("mousemove", moveBoxOn1, true);
            document.addEventListener("mouseup", moveBoxEnd1, true);

        };

        //move 事件
        function moveBoxOn1(e) {
            fn(e);
            $scope.$digest();
            if (e.target.nodeName == 'SPAN' && $scope.selectBox.current != 'textbox') {
                return;
            }
            if (drag) {
                var currentPage = $scope.template.pages.page[$scope.template.pageI];
                var angle = ($scope.selectBox.rotation.angle) * Math.PI / 180;

                var clientX = e.clientX - dragBox.clientX;
                var clientY = e.clientY - dragBox.clientY;

                var imgOffsetX = (dragBox.coordX + e.clientX - dragBox.clientX);
                var imgOffsetY = (dragBox.coordY + e.clientY - dragBox.clientY);
                var imgWidth = $scope.selectBox.geometry.width * currentPage.scale / currentPage.scene.proportion;
                var imgHeight = $scope.selectBox.geometry.height * currentPage.scale / currentPage.scene.proportion;

                if ($scope.selectBox.current == 'textbox') {
                    imgWidth = $(".textbox1" + $scope.template.pageI + $scope.template.levelI).width();
                    imgHeight = $(".textbox1" + $scope.template.pageI + $scope.template.levelI).height();
                }
                var height = currentPage.mediabox.height * currentPage.scale / currentPage.scene.proportion;
                var width = currentPage.mediabox.width * currentPage.scale / currentPage.scene.proportion;
                var lar = (currentPage.bloodPx.left + currentPage.bloodPx.right) * currentPage.scale / currentPage.scene.proportion;
                var tab = (currentPage.bloodPx.top + currentPage.bloodPx.bottom) * currentPage.scale / currentPage.scene.proportion;

                // if (angle == 0) {
                //     if (imgOffsetX <= 0) {
                //         imgOffsetX = 0;
                //     }
                //
                //     if (imgOffsetX >= (width - imgWidth)) {
                //         imgOffsetX = width - imgWidth;
                //     }
                //     if (imgOffsetY <= 0) {
                //         imgOffsetY = 0;
                //     }
                //
                //     if (imgOffsetY >= (height - imgHeight)) {
                //         imgOffsetY = height - imgHeight;
                //     }
                // } else {
                //     if (imgOffsetX <= 0) {
                //         imgOffsetX = 0;
                //     }
                //
                //     if (imgOffsetX >= (width + lar)) {
                //         imgOffsetX = width + lar;
                //     }
                //     if (imgOffsetY <= 0) {
                //         imgOffsetY = 0;
                //     }
                //
                //     if (imgOffsetY >= (height + tab)) {
                //         imgOffsetY = height + tab;
                //     }
                //
                // }

                if (dragBox.ctrlKey) {
                    moveTogether(currentPage, clientX, clientY);
                } else {
                    $scope.selectBox.geometry.x = imgOffsetX / currentPage.scale * currentPage.scene.proportion;
                    $scope.selectBox.geometry.y = imgOffsetY / currentPage.scale * currentPage.scene.proportion;
                    if(vm.staff){
                        vm.lineReferenceX = null;
                        vm.lineReferenceY = null;
                        getItemCoordinates($scope.selectBox,vm.coordinates,function (item) {
                            if(item.x){
                                vm.lineReferenceX = item.x.closestNum;
                                $scope.selectBox.geometry.x = $scope.selectBox.geometry.x + item.x.diff;
                            }
                            if(item.y){
                                vm.lineReferenceY = item.y.closestNum;
                                $scope.selectBox.geometry.y = $scope.selectBox.geometry.y + item.y.diff;
                            }
                        });
                    }
                    var value = {};
                    if ($scope.selectBox.current == 'textbox') {
                        value = $scope.pageValue.textbox;
                    } else if ($scope.selectBox.current == 'imagebox') {
                        value = $scope.pageValue.imagebox;
                    } else if ($scope.selectBox.current == 'imageart') {
                        value = $scope.pageValue.imageart;
                    } else if ($scope.selectBox.current == 'textdocument') {
                        value = $scope.pageValue.textdocument;
                    }
                    if (vm.unit == 'mm') {
                        value.x = PxTurnMm($scope.selectBox.geometry.x).toFixed(2) - 0;//px-->mm
                        value.y = PxTurnMm($scope.selectBox.geometry.y).toFixed(2) - 0;//px-->mm
                    } else if (vm.unit == 'px') {
                        value.x = PxTurnMm($scope.selectBox.geometry.x / 25.4 * vm.windowDpiW);
                        value.y = PxTurnMm($scope.selectBox.geometry.y / 25.4 * vm.windowDpiW);
                    } else if (vm.unit == 'in') {
                        value.x = PxTurnIn($scope.selectBox.geometry.x);
                        value.y = PxTurnIn($scope.selectBox.geometry.y);
                    }
                }
                $scope.currentPage = currentPage;

            }
            return false;
        }

        //鼠标松开事件
        function moveBoxEnd1() {
            vm.lineReferenceX = null;
            vm.lineReferenceY = null;
            if (dragBox.ctrlKey) {
                moveTogetherEnd();
            }
            drag = false;
            dragBox = {};
            document.removeEventListener("mousemove", moveBoxOn1, true);
            document.removeEventListener("mouseup", moveBoxEnd1, true);
            updateHistorys();
            $scope.$digest();
        }

        var rotateDragDown = false;
        $scope.rotateBoxStart = function (e, item, index) {
            fn(e);
            var targ = e.target ? e.target : e.srcElement;
            $scope.template.levelI = index;
            if (item.lock) {
                return
            }
            rotateDragDown = true;
            var all = getAllCtrlKeyArray();
            if (all.length) {
                dragBox.ctrlKey = true;
            } else {
                dragBox.ctrlKey = false;
            }
            $scope.selectBox = item;
            if (item.current == 'imagebox') {
                var box = $(e.target).parents('.imgBox');
                dragBox._top = box.offset().top + box.height() / 2;
                dragBox._left = box.offset().left + box.width() / 2;
                if ($scope.RightPanel == 'mask') {
                    $scope.RightPanel = 'mask';
                } else {
                    $scope.RightPanel = 'placement';
                }
            } else if (item.current == 'imageart') {
                var box = $(e.target).parents('.img-art');
                dragBox._top = box.offset().top + box.height() / 2;
                dragBox._left = box.offset().left + box.width() / 2;
                $scope.RightPanel = 'material';
            } else if (item.current == 'textbox') {
                var box = $(e.target).parents('.c-xml-page-textboxe');
                dragBox._top = box.offset().top + box.height() / 2;
                dragBox._left = box.offset().left + box.width() / 2;
                $scope.RightPanel = 'text';
            } else if (item.current == 'textdocument') {
                var box = $(e.target).parents('.c-textdocument');
                dragBox._top = box.offset().top + box.height() / 2;
                dragBox._left = box.offset().left + box.width() / 2;
                $scope.RightPanel = 'textDoc';
            }

            document.addEventListener("mousemove", rotateBoxOn, true);
            document.addEventListener("mouseup", rotateBoxEnd, true);
        }

        function rotateBoxOn(e) {
            fn(e);
            if (rotateDragDown) {
                var angle = ModulesService.getAngle(dragBox._left, dragBox._top, e.clientX, e.clientY);
                if ($scope.selectBox.current == 'imagebox' || $scope.selectBox.current == 'textdocument') {
                    $scope.selectBox.rotation.angle = 360 - angle;
                } else {
                    $scope.selectBox.rotation.angle = angle;
                }
                $scope.selectBox.rotation.angle = adsorbAngle($scope.selectBox.rotation.angle)
                $scope.template.angle = $scope.selectBox.rotation.angle;
                $scope.$digest();
            }

            // e.stopPropagation();
            // e.preventDefault();
            return false;
        }

        function rotateBoxEnd(e) {
            fn(e);
            if (rotateDragDown) {
                // var angle = ModulesService.getAngle(dragBox._left, dragBox._top, e.clientX, e.clientY);
                // if ($scope.selectBox.current == 'imagebox' || $scope.selectBox.current == 'textdocument') {
                //     $scope.selectBox.rotation.angle = 360 - angle;
                // } else {
                //     $scope.selectBox.rotation.angle = angle;
                // }
                // $scope.template.angle = $scope.selectBox.rotation.angle;
            }
            rotateDragDown = false;
            dragBox = {};
            $(".rotate-icon" + $scope.template.levelI).removeClass('rotate-icon-active');
            document.removeEventListener("mousemove", rotateBoxOn, true);
            document.removeEventListener("mouseup", rotateBoxEnd, true);
            updateHistorys();
            $scope.$digest();
        }

        function moveTogether(currentPage, clientX, clientY) {
            angular.forEach(vm.CtrlKeyArray.imageboxes, function (imagebox, i) {
                // 当前页所有占位框
                var box = currentPage.levels.level[imagebox.levelI].imagebox;
                boxSetting(box, imagebox);
            })

            angular.forEach(vm.CtrlKeyArray.imagearts, function (imageart, i) {
                // 当前页所有素材
                var box = currentPage.levels.level[imageart.levelI].imageart;
                boxSetting(box, imageart);
            })

            angular.forEach(vm.CtrlKeyArray.textboxes, function (textbox, i) {
                // 当前页所有文字
                var box = currentPage.levels.level[textbox.levelI].textbox;
                boxSetting(box, textbox);
            })

            angular.forEach(vm.CtrlKeyArray.textdocuments, function (textdocument, i) {
                // 当前页所有文字
                var box = currentPage.levels.level[textdocument.levelI].textdocument;
                boxSetting(box, textdocument);
            })

            angular.forEach(vm.CtrlKeyArray.calTitleBoxs, function (calTitleBox, i) {
                // 当前页所有文字
                var box = currentPage.levels.level[calTitleBox.levelI].calTitleBox;
                boxSetting(box, calTitleBox);
            })

            angular.forEach(vm.CtrlKeyArray.calMonthBoxs, function (calMonthBox, i) {
                // 当前页所有文字
                var box = currentPage.levels.level[calMonthBox.levelI].calMonthBox;
                boxSetting(box, calMonthBox);
            })

            var imgWidth = 0, imgHeight = 0, height = 0, width = 0, x = 0, y = 0;

            function boxSetting(box, CtrlKeyBox) {
                if (!box || box.lock) {
                    return
                }
                var lar = (currentPage.bloodPx.left + currentPage.bloodPx.right) * currentPage.scale / currentPage.proportion;
                var tab = (currentPage.bloodPx.top + currentPage.bloodPx.bottom) * currentPage.scale / currentPage.proportion;
                imgWidth = box.geometry.width * currentPage.scale / currentPage.proportion;
                imgHeight = box.geometry.height * currentPage.scale / currentPage.proportion;
                height = currentPage.height * currentPage.scale;
                width = currentPage.width * currentPage.scale;
                x = CtrlKeyBox.geometry.x / currentPage.proportion * currentPage.scale + clientX;
                y = CtrlKeyBox.geometry.y / currentPage.proportion * currentPage.scale + clientY;
                // if (x <= 0) {
                //     x = 0;
                // }
                // if (x >= (width + lar - imgWidth)) {
                //     x = width + lar - imgWidth;
                // }
                // if (y <= 0) {
                //     y = 0;
                // }
                //
                // if (y >= (height + tab - imgHeight)) {
                //     y = height + tab - imgHeight;
                // }
                box.geometry.x = x / currentPage.scale * currentPage.proportion
                box.geometry.y = y / currentPage.scale * currentPage.proportion
            }
        }


        function moveTogetherEnd() {
            angular.forEach(vm.CtrlKeyArray.imageboxes, function (imagebox, i) {
                // 当前页所有占位框
                var box = $scope.currentPage.levels.level[imagebox.levelI].imagebox;
                ctrlKeySetting(box, imagebox);
            })

            angular.forEach(vm.CtrlKeyArray.imagearts, function (imageart, i) {
                // 当前页所有素材
                var box = $scope.currentPage.levels.level[imageart.levelI].imageart;
                ctrlKeySetting(box, imageart);
            })

            angular.forEach(vm.CtrlKeyArray.textboxes, function (textbox, i) {
                // 当前页所有文字
                var box = $scope.currentPage.levels.level[textbox.levelI].textbox;
                ctrlKeySetting(box, textbox);
            })

            angular.forEach(vm.CtrlKeyArray.textdocuments, function (textdocument, i) {
                // 当前页所有文字
                var box = $scope.currentPage.levels.level[textdocument.levelI].textdocument;
                ctrlKeySetting(box, textdocument);
            })

            angular.forEach(vm.CtrlKeyArray.calTitleBoxs, function (calTitleBox, i) {
                // 当前页所有文字
                var box = $scope.currentPage.levels.level[calTitleBox.levelI].calTitleBox;
                ctrlKeySetting(box, calTitleBox);
            })

            angular.forEach(vm.CtrlKeyArray.calMonthBoxs, function (calMonthBox, i) {
                // 当前页所有文字
                var box = $scope.currentPage.levels.level[calMonthBox.levelI].calMonthBox;
                ctrlKeySetting(box, calMonthBox);
            })

            function ctrlKeySetting(box, CtrlKeyBox) {
                if (!box) {
                    return
                }
                CtrlKeyBox.geometry.x = box.geometry.x;
                CtrlKeyBox.geometry.y = box.geometry.y;
            }
        }

        /**
         *放大占位框
         * @param e
         */
        var dragFlag = false;

        var isZoomDown = false;
        $scope.resizeStartRigth = function ($event, item, pro, index) {
            if (item.lock) {
                return
            }
            fn($event);
            editorBoxZoom($event, item, 'rightBottom', pro, $($event.target).parents('.selected'), function (it) {
                $scope.$apply();
            }, function (it) {
                imageboxCb(it, index)
                if ($scope.currentPage.levels.level && $scope.currentPage.levels.level[$scope.template.levelI]) {
                    var level = $scope.currentPage.levels.level[$scope.template.levelI];
                    if (level.imagebox && level.imagebox.mask && level.imagebox.mask.resource && level.imagebox.mask.resource.identifier) {
                        if (level.imagebox.image && level.imagebox.image.resource.identifier) {
                            imageboxImg(level.imagebox, function () {
                                // imageboxResourceCanvas(level.imagebox);
                            })
                        } else {
                            // maskScale(null, level.imagebox, $scope.template.levelI, level.imagebox.mask.resource.identifier)
                        }
                    } else {
                        if (level.imagebox.image && level.imagebox.image.resource.identifier) {
                            imageboxImg(level.imagebox, function () {
                                // imageboxResourceCanvas(level.imagebox);
                            })
                        }
                    }
                }
            });
            // imageboxZoom($event, item, 'right', pro, index)
        }
        $scope.pageLength = function(pages){
            var _index = 0;
            pages.forEach(function (page) {
                if(!page.backup){
                    _index++
                }
            })
            return _index
        }
        $scope.resizeStartLeft = function ($event, item, pro, index) {
            if (item.lock) {
                return
            }
            fn($event);
            editorBoxZoom($event, item, 'leftTop', pro, $($event.target).parents('.selected'), function (it) {
                $scope.$apply();
            }, function (it) {
                imageboxCb(it, index)
                if ($scope.currentPage.levels.level && $scope.currentPage.levels.level[$scope.template.levelI]) {
                    var level = $scope.currentPage.levels.level[$scope.template.levelI];
                    if (level.imagebox && level.imagebox.mask && level.imagebox.mask.resource && level.imagebox.mask.resource.identifier) {
                        if (level.imagebox.image && level.imagebox.image.resource.identifier) {
                            imageboxImg(level.imagebox, function () {
                                // imageboxResourceCanvas(level.imagebox);
                            })
                        } else {
                            // maskScale(null, level.imagebox, $scope.template.levelI, level.imagebox.mask.resource.identifier)
                        }
                    } else {
                        if (level.imagebox.image && level.imagebox.image.resource.identifier) {
                            imageboxImg(level.imagebox, function () {
                                // imageboxResourceCanvas(level.imagebox);
                            })
                        }
                    }
                }
            });
            // imageboxZoom($event, item, 'left', pro, index)
        }
        $scope.resizeStartTop = function ($event, item, pro, index) {
            if (item.lock) {
                return
            }
            fn($event);
            editorBoxZoom($event, item, 'rightTop', pro, $($event.target).parents('.selected'), function (it) {
                $scope.$apply();
            }, function (it) {
                imageboxCb(it, index)
                if ($scope.currentPage.levels.level && $scope.currentPage.levels.level[$scope.template.levelI]) {
                    var level = $scope.currentPage.levels.level[$scope.template.levelI];
                    if (level.imagebox && level.imagebox.mask && level.imagebox.mask.resource && level.imagebox.mask.resource.identifier) {
                        if (level.imagebox.image && level.imagebox.image.resource.identifier) {
                            imageboxImg(level.imagebox, function () {
                                // imageboxResourceCanvas(level.imagebox);
                            })
                        } else {
                            // maskScale(null, level.imagebox, $scope.template.levelI, level.imagebox.mask.resource.identifier)
                        }
                    } else {
                        if (level.imagebox.image && level.imagebox.image.resource.identifier) {
                            imageboxImg(level.imagebox, function () {
                                // imageboxResourceCanvas(level.imagebox);
                            })
                        }
                    }
                }
            });
            // imageboxZoom($event, item, 'top', pro, index)
        }
        $scope.resizeStartBottom = function ($event, item, pro, index) {
            if (item.lock) {
                return
            }
            fn($event);
            editorBoxZoom($event, item, 'leftBottom', pro, $($event.target).parents('.selected'), function (it) {
                $scope.$apply();
            }, function (it) {
                imageboxCb(it, index)
                if ($scope.currentPage.levels.level && $scope.currentPage.levels.level[$scope.template.levelI]) {
                    var level = $scope.currentPage.levels.level[$scope.template.levelI];
                    if (level.imagebox && level.imagebox.mask && level.imagebox.mask.resource && level.imagebox.mask.resource.identifier) {
                        if (level.imagebox.image && level.imagebox.image.resource.identifier) {
                            imageboxImg(level.imagebox, function () {
                                // imageboxResourceCanvas(level.imagebox);
                            })
                        } else {
                            // maskScale(null, level.imagebox, $scope.template.levelI, level.imagebox.mask.resource.identifier)
                        }
                    } else {
                        if (level.imagebox.image && level.imagebox.image.resource.identifier) {
                            imageboxImg(level.imagebox, function () {
                                // imageboxResourceCanvas(level.imagebox);
                            })
                        }
                    }
                }
            });
            // imageboxZoom($event, item, 'bottom', pro, index)
        }
        $scope.resizeStartLeft1 = function ($event, item, pro, index) {
            if (item.lock) {
                return
            }
            fn($event);
            editorBoxZoom($event, item, 'left', pro, $($event.target).parents('.selected'), function (it) {
                $scope.$apply();
            }, function (it) {
                imageboxCb(it, index)
                if ($scope.currentPage.levels.level && $scope.currentPage.levels.level[$scope.template.levelI]) {
                    var level = $scope.currentPage.levels.level[$scope.template.levelI];
                    if (level.imagebox && level.imagebox.mask && level.imagebox.mask.resource && level.imagebox.mask.resource.identifier) {
                        if (level.imagebox.image && level.imagebox.image.resource.identifier) {
                            imageboxImg(level.imagebox, function () {
                                // imageboxResourceCanvas(level.imagebox);
                            })
                        } else {
                            // maskScale(null, level.imagebox, $scope.template.levelI, level.imagebox.mask.resource.identifier)
                        }
                    } else {
                        if (level.imagebox.image && level.imagebox.image.resource.identifier) {
                            imageboxImg(level.imagebox, function () {
                                // imageboxResourceCanvas(level.imagebox);
                            })
                        }
                    }
                }
            });
            // imageboxZoom1($event, item, 'left', pro, index)
        }
        $scope.resizeStartTop1 = function ($event, item, pro, index) {
            if (item.lock) {
                return
            }
            fn($event);
            editorBoxZoom($event, item, 'top', pro, $($event.target).parents('.selected'), function (it) {
                $scope.$apply();
            }, function (it) {
                imageboxCb(it, index)
                if ($scope.currentPage.levels.level && $scope.currentPage.levels.level[$scope.template.levelI]) {
                    var level = $scope.currentPage.levels.level[$scope.template.levelI];
                    if (level.imagebox && level.imagebox.mask && level.imagebox.mask.resource && level.imagebox.mask.resource.identifier) {
                        if (level.imagebox.image && level.imagebox.image.resource.identifier) {
                            imageboxImg(level.imagebox, function () {
                                // imageboxResourceCanvas(level.imagebox);
                            })
                        } else {
                            // maskScale(null, level.imagebox, $scope.template.levelI, level.imagebox.mask.resource.identifier)
                        }
                    } else {
                        if (level.imagebox.image && level.imagebox.image.resource.identifier) {
                            imageboxImg(level.imagebox, function () {
                                // imageboxResourceCanvas(level.imagebox);
                            })
                        }
                    }
                }
            });
            // imageboxZoom1($event, item, 'top', pro, index)
        }
        $scope.resizeStartRight1 = function ($event, item, pro, index) {
            if (item.lock) {
                return
            }
            fn($event);
            editorBoxZoom($event, item, 'right', pro, $($event.target).parents('.selected'), function (it) {
                $scope.$apply();
            }, function (it) {
                imageboxCb(it, index)
                if ($scope.currentPage.levels.level && $scope.currentPage.levels.level[$scope.template.levelI]) {
                    var level = $scope.currentPage.levels.level[$scope.template.levelI];
                    if (level.imagebox && level.imagebox.mask && level.imagebox.mask.resource && level.imagebox.mask.resource.identifier) {
                        if (level.imagebox.image && level.imagebox.image.resource.identifier) {
                            imageboxImg(level.imagebox, function () {
                                // imageboxResourceCanvas(level.imagebox);
                            })
                        } else {
                            // maskScale(null, level.imagebox, $scope.template.levelI, level.imagebox.mask.resource.identifier)
                        }
                    } else {
                        if (level.imagebox.image && level.imagebox.image.resource.identifier) {
                            imageboxImg(level.imagebox, function () {
                                // imageboxResourceCanvas(level.imagebox);
                            })
                        }
                    }
                }
            });
            // imageboxZoom1($event, item, 'right', pro, index)
        }
        $scope.resizeStartBottom1 = function ($event, item, pro, index) {
            if (item.lock) {
                return
            }
            fn($event);
            editorBoxZoom($event, item, 'bottom', pro, $($event.target).parents('.selected'), function (it) {
                $scope.$apply();
            }, function (it) {
                imageboxCb(it, index)
                if ($scope.currentPage.levels.level && $scope.currentPage.levels.level[$scope.template.levelI]) {
                    var level = $scope.currentPage.levels.level[$scope.template.levelI];
                    if (level.imagebox && level.imagebox.mask && level.imagebox.mask.resource && level.imagebox.mask.resource.identifier) {
                        if (level.imagebox.image && level.imagebox.image.resource.identifier) {
                            imageboxImg(level.imagebox, function () {
                                // imageboxResourceCanvas(level.imagebox);
                            })
                        } else {
                            // maskScale(null, level.imagebox, $scope.template.levelI, level.imagebox.mask.resource.identifier)
                        }
                    } else {
                        if (level.imagebox.image && level.imagebox.image.resource.identifier) {
                            imageboxImg(level.imagebox, function () {
                                // imageboxResourceCanvas(level.imagebox);
                            })
                        }
                    }
                }
            });
            // imageboxZoom1($event, item, 'bottom', pro, index)
        }

        function imageboxCb(item, index) {
            $scope.template.levelI = index || $scope.template.levelI;
            $scope.currentPage.levels.level[$scope.template.levelI].imagebox = item;
            if (vm.unit == 'mm') {
                $scope.pageValue.imagebox = {
                    width: PxTurnMm(item.geometry.width).toFixed(2) - 0,
                    height: PxTurnMm(item.geometry.height).toFixed(2) - 0,
                    x: PxTurnMm(item.geometry.x).toFixed(2) - 0,
                    y: PxTurnMm(item.geometry.y).toFixed(2) - 0,
                }
            } else if (vm.unit == 'px') {
                $scope.pageValue.imagebox = {
                    width: PxTurnMm(item.geometry.width / 25.4 * vm.windowDpiW),
                    height: PxTurnMm(item.geometry.height / 25.4 * vm.windowDpiW),
                    x: PxTurnMm(item.geometry.x / 25.4 * vm.windowDpiW),
                    y: PxTurnMm(item.geometry.y / 25.4 * vm.windowDpiW),
                }
            } else if (vm.unit == 'in') {
                $scope.pageValue.imagebox = {
                    width: PxTurnIn(item.geometry.width),
                    height: PxTurnIn(item.geometry.height),
                    x: PxTurnIn(item.geometry.x),
                    y: PxTurnIn(item.geometry.y),
                }
            }
            $scope.pxInsufficient(item, 'imagebox');
        }

        function imageboxZoom($event, item, direction, pro, index) {
            var x = $event.clientX;
            var y = $event.clientY;
            //获取w和h
            var nw = angular.copy(item.geometry.width) * pro;
            var nh = angular.copy(item.geometry.height) * pro;
            var nw1 = item.image ? angular.copy(item.image.width) * pro : 0;
            var nh1 = item.image ? angular.copy(item.image.height) * pro : 0;
            var nw2 = item.image ? angular.copy(item.image.width) * pro : 1;
            var nh2 = item.image ? angular.copy(item.image.height) * pro : 1;
            var x1 = item.image ? angular.copy(item.image.offsetx * pro) : 0;
            var y1 = item.image ? angular.copy(item.image.offsety * pro) : 0;
            var x2 = item.geometry.x * pro;
            var y2 = item.geometry.y * pro;
            var _scale = item.image ? angular.copy(item.image.scale) : 1;
            var _left = $($event.target).parents('.selected').offset().left + (nw / 2);
            var _top = $($event.target).parents('.selected').offset().top + (nh / 2);

            var x3 = Math.abs(_left - $event.clientX);
            var y3 = Math.abs(_top - $event.clientY);
            var distance = Math.sqrt(Math.pow(x3, 2) + Math.pow(y3, 2));
            //开关打开
            isZoomDown = true;
            //鼠标移动
            window.onmousemove = function (e) {
                if (isZoomDown == false) {
                    return;
                }
                var nl = 0;
                var x = Math.abs(_left + nl - e.clientX);
                var y = Math.abs(_top - e.clientY);
                var z = Math.sqrt(Math.pow(x, 2) + Math.pow(y, 2));
                nl = (parseInt(z - distance)) / pro;
                var _w = (Number(nw) + Number(nl));
                var _h = _w / nw * nh;
                item.geometry.width = _w / pro;
                item.geometry.height = _h / pro;
                item.geometry.x = (x2 - (_w - nw) / 2) / pro;
                item.geometry.y = (y2 - (_h - nh) / 2) / pro;
                if (item.image) {
                    item.image.width = _w / nw * nw2 / pro;
                    item.image.height = _w / nw * nh2 / pro;
                    item.image.offsetx = (_w / (nw / nw1)) / (nw1 / x1) / pro;
                    item.image.offsety = (_h / (nh / nh1)) / (nh1 / y1) / pro;
                }
                $scope.template.levelI = index || $scope.template.levelI;
                $scope.currentPage.levels.level[$scope.template.levelI].imagebox = item;
                if (vm.unit == 'mm') {
                    $scope.pageValue.imagebox = {
                        width: PxTurnMm(item.geometry.width).toFixed(2) - 0,
                        height: PxTurnMm(item.geometry.height).toFixed(2) - 0,
                        x: PxTurnMm(item.geometry.x).toFixed(2) - 0,
                        y: PxTurnMm(item.geometry.y).toFixed(2) - 0,
                    }
                } else if (vm.unit == 'px') {
                    $scope.pageValue.imagebox = {
                        width: PxTurnMm(item.geometry.width / 25.4 * vm.windowDpiW),
                        height: PxTurnMm(item.geometry.height / 25.4 * vm.windowDpiW),
                        x: PxTurnMm(item.geometry.x / 25.4 * vm.windowDpiW),
                        y: PxTurnMm(item.geometry.y / 25.4 * vm.windowDpiW),
                    }
                } else if (vm.unit == 'in') {
                    $scope.pageValue.imagebox = {
                        width: PxTurnIn(item.geometry.width),
                        height: PxTurnIn(item.geometry.height),
                        x: PxTurnIn(item.geometry.x),
                        y: PxTurnIn(item.geometry.y),
                    }
                }
                $scope.pxInsufficient(item, 'imagebox');
                $scope.$digest();
            }
            //鼠标抬起事件
            window.onmouseup = function ($event) {
                $event.stopPropagation();
                isZoomDown = false;
                if ($scope.currentPage.levels.level && $scope.currentPage.levels.level[$scope.template.levelI]) {
                    var level = $scope.currentPage.levels.level[$scope.template.levelI];
                    if (level.imagebox && level.imagebox.mask && level.imagebox.mask.resource && level.imagebox.mask.resource.identifier) {
                        if (level.imagebox.image && level.imagebox.image.resource.identifier) {
                            // imageboxResourceCanvas(level.imagebox);
                        } else {
                            // maskScale(null, level.imagebox, $scope.template.levelI, level.imagebox.mask.resource.identifier)
                        }
                    }
                }

            }
        }

        function imageboxZoom1($event, item, direction, pro, index) {
            var x = $event.clientX;
            var y = $event.clientY;
            //获取w和h
            var nw = angular.copy(item.geometry.width) * pro;
            var nh = angular.copy(item.geometry.height) * pro;
            var nw1 = item.image ? angular.copy(item.image.width) * pro : 0;
            var nh1 = item.image ? angular.copy(item.image.height) * pro : 0;
            var nw2 = item.image ? angular.copy(item.image.width) * pro : 1;
            var nh2 = item.image ? angular.copy(item.image.height) * pro : 1;
            var x1 = item.image ? angular.copy(item.image.offsetx * pro) : 0;
            var y1 = item.image ? angular.copy(item.image.offsety * pro) : 0;
            var x2 = item.geometry.x * pro;
            var y2 = item.geometry.y * pro;
            var _scale = item.image ? angular.copy(item.image.scale) : 1;
            var _left = $($event.target).parents('.selected').offset().left + (nw / 2);
            var _top = $($event.target).parents('.selected').offset().top + (nh / 2);

            var x3 = Math.abs(_left - $event.clientX);
            var y3 = Math.abs(_top - $event.clientY);
            var distance = Math.sqrt(Math.pow(x3, 2) + Math.pow(y3, 2));
            //开关打开
            isZoomDown = true;
            //鼠标移动
            window.onmousemove = function (e) {
                if (isZoomDown == false) {
                    return;
                }
                //获取x和y
                var nl = 0;
                var x = Math.abs(_left + nl - e.clientX);
                var y = Math.abs(_top - e.clientY);
                var z = Math.sqrt(Math.pow(x, 2) + Math.pow(y, 2));
                nl = (parseInt(z - distance)) / pro;
                var _w = (Number(nw) + Number(nl));
                var _h = (Number(nh) + Number(nl));
                if (item.image) {
                    item.image.offsetx = 0;
                    item.image.offsety = 0;
                }
                if (direction == 'left' || direction == 'right') {
                    item.geometry.width = _w / pro;
                    item.geometry.x = (x2 - (_w - nw) / 2) / pro;
                }
                if (direction == 'top' || direction == 'bottom') {
                    item.geometry.height = _h / pro;
                    item.geometry.y = (y2 - (_h - nh) / 2) / pro;
                }
                $scope.template.levelI = index || $scope.template.levelI;
                $scope.currentPage.levels.level[$scope.template.levelI].imagebox = item;
                $scope.$digest();
            }
            //鼠标抬起事件
            window.onmouseup = function ($event) {
                $event.stopPropagation();
                if (isZoomDown) {
                    vm.singleArray = {imagebox: {}, textbox: {}, imageart: {}, barcode: {}, qrcode: {}, calMonthBox: {}, calTitleBox: {}};
                    vm.singleArray.imagebox = angular.copy(item);
                    dragMask = {};
                    updateHistorys();
                    var pressImg = item;
                    if (pressImg.image && pressImg.image.resource.identifier) {
                        pressImg.image.offsetx = 0;
                        pressImg.image.offsety = 0;
                        getBackgroundSource1(pressImg.image.resource, pressImg.geometry.width, pressImg.geometry.height, pressImg.image);
                    }

                    if (pressImg.mask && pressImg.mask.resource.identifier) {
                        if (pressImg.image && pressImg.image.resource.identifier) {
                            // imageboxResourceCanvas(pressImg);
                        } else {
                            // maskScale($event, pressImg, $scope.template.levelI, pressImg.mask.resource.identifier)
                        }
                    }
                    isZoomDown = false;
                    $scope.$digest();
                }
            }
        }
        $scope.updateBoxParameter = function (p1, p2) {
            var box = {}, boxW = null, boxH = null, value = {};
            var level = angular.copy($scope.currentPage.levels.level[$scope.template.levelI]);
            if ($scope.RightPanel == 'placement' || $scope.RightPanel == 'mask') {
                box = level.imagebox;
                value = $scope.pageValue.imagebox;
            } else if ($scope.RightPanel == 'material') {
                box = level.imageart;
                value = $scope.pageValue.imageart;
                boxW = angular.copy(box.resource.width);
                boxH = angular.copy(box.resource.height);
            } else if ($scope.RightPanel == 'text') {
                box = level.textbox;
                value = $scope.pageValue.textbox;
            } else if ($scope.RightPanel == 'textDoc') {
                box = level.textdocument;
                value = $scope.pageValue.textdocument;
            } else if ($scope.RightPanel == 'calTitleBox') {
                box = level.calTitleBox;
                value = $scope.pageValue.calTitleBox;
                boxW = angular.copy(box.geometry.width);
                boxH = angular.copy(box.geometry.height);
            } else if ($scope.RightPanel == 'calMonthBox') {
                box = level.calMonthBox;
                value = $scope.pageValue.calMonthBox;
                boxW = angular.copy(box.geometry.width);
                boxH = angular.copy(box.geometry.height);
            }
            if (box.lock) {
                return
            }

            if (vm.unit == 'mm') {
                box.geometry = {
                    width: MmTurnPx(value.width),
                    height: MmTurnPx(value.height),
                    x: MmTurnPx(value.x),
                    y: MmTurnPx(value.y)
                }
                if (p1 == 'width') {
                    if($scope.RightPanel == 'material'){
                        box.geometry.height = box.geometry.width * boxH / boxW;
                        value.height = PxTurnMm(box.geometry.height);
                        box.offsetx = 0;
                        box.offsety = 0;
                        box.scale = 1;
                    }else if($scope.RightPanel == 'calTitleBox'){
                        box.geometry.height = box.geometry.width * boxH / boxW;
                        value.height = PxTurnMm(box.geometry.height);
                    }else if($scope.RightPanel == 'calMonthBox'){
                        box.geometry.height = box.geometry.width * boxH / boxW;
                        var isCeil = box.geometry.height>boxH;
                        calMonthBoxW(box, isCeil);
                        value.height = PxTurnMm(box.geometry.height);
                        value.width = PxTurnMm(box.geometry.width);
                    }
                } else if (p1 == 'height') {
                    if($scope.RightPanel == 'material'){
                        box.geometry.width = box.geometry.height * boxW / boxH;
                        value.width = PxTurnMm(box.geometry.width);
                        box.offsetx = 0;
                        box.offsety = 0;
                        box.scale = 1;
                    }else if($scope.RightPanel == 'calTitleBox'){
                        box.geometry.width = box.geometry.height * boxW / boxH;
                        value.width = PxTurnMm(box.geometry.width);
                    }else if($scope.RightPanel == 'calMonthBox'){
                        box.geometry.width = box.geometry.height * boxW / boxH;
                        var isCeil = box.geometry.width>boxW;
                        calMonthBoxW(box, isCeil);
                        value.width = PxTurnMm(box.geometry.width);
                        value.height = PxTurnMm(box.geometry.height);
                    }
                }
            }
            if (vm.unit == 'px') {
                box.geometry = value;
                if (p1 == 'width') {
                    if($scope.RightPanel == 'material') {
                        box.geometry.height = box.geometry.width * boxH / boxW;
                        value.height = box.geometry.height;
                        box.offsetx = 0;
                        box.offsety = 0;
                        box.scale = 1;
                    }else if($scope.RightPanel == 'calTitleBox'){
                        box.geometry.height = box.geometry.width * boxH / boxW;
                        value.height = box.geometry.height;
                    }else if($scope.RightPanel == 'calMonthBox'){
                        box.geometry.height = box.geometry.width * boxH / boxW;
                        var isCeil = box.geometry.height>boxH;
                        calMonthBoxW(box, isCeil);
                        value.width = box.geometry.width;
                        value.height = box.geometry.height;
                    }
                } else if (p1 == 'height') {
                    if($scope.RightPanel == 'material') {
                        box.geometry.width = box.geometry.height * boxW / boxH;
                        value.width = box.geometry.width;
                        box.offsetx = 0;
                        box.offsety = 0;
                        box.scale = 1;
                    }else if($scope.RightPanel == 'calTitleBox'){
                        box.geometry.width = box.geometry.height * boxW / boxH;
                        value.width = box.geometry.width;
                    }else if($scope.RightPanel == 'calMonthBox'){
                        box.geometry.width = box.geometry.height * boxW / boxH;
                        var isCeil = box.geometry.width>boxW;
                        calMonthBoxW(box, isCeil);
                        value.width = box.geometry.width;
                        value.height = box.geometry.height;
                    }
                }
            }
            if (vm.unit == 'in') {
                box.geometry = {
                    width: InTurnPx(value.width),
                    height: InTurnPx(value.height),
                    x: InTurnPx(value.x),
                    y: InTurnPx(value.y)
                }
                if (p1 == 'width') {
                    if($scope.RightPanel == 'material') {
                        box.geometry.height = box.geometry.width * boxH / boxW;
                        value.height = PxTurnIn(box.geometry.height);
                        box.offsetx = 0;
                        box.offsety = 0;
                        box.scale = 1;
                    }else if($scope.RightPanel == 'calTitleBox'){
                        box.geometry.height = box.geometry.width * boxH / boxW;
                        value.height = PxTurnIn(box.geometry.height);
                    }else if($scope.RightPanel == 'calMonthBox'){
                        box.geometry.height = box.geometry.width * boxH / boxW;
                        var isCeil = box.geometry.height>boxH;
                        calMonthBoxW(box, isCeil);
                        value.width = PxTurnIn(box.geometry.width);
                        value.height = PxTurnIn(box.geometry.height);
                    }
                } else if (p1 == 'height') {
                    if($scope.RightPanel == 'material') {
                        box.geometry.width = box.geometry.height * boxW / boxH;
                        value.width = PxTurnIn(box.geometry.width);
                        box.offsetx = 0;
                        box.offsety = 0;
                        box.scale = 1;
                    }else if($scope.RightPanel == 'calTitleBox'){
                        box.geometry.width = box.geometry.height * boxW / boxH;
                        value.width = PxTurnIn(box.geometry.width);
                    }else if($scope.RightPanel == 'calMonthBox'){
                        box.geometry.width = box.geometry.height * boxW / boxH;
                        var isCeil = box.geometry.width>boxW;
                        calMonthBoxW(box, isCeil);
                        value.width = PxTurnIn(box.geometry.width);
                        value.height = PxTurnIn(box.geometry.height);
                    }
                }
            }
            $scope.currentPage.levels.level[$scope.template.levelI] = level;
            if (level.imagebox && level.imagebox.image) {
                imageboxImg(level.imagebox,function(){
                    $scope.$apply();
                })
            }
            var _pageValue = angular.copy($scope.pageValue);
            $scope.pageValue = "";
            $timeout(function () {
                $scope.pageValue = _pageValue;
                if ($scope.currentPage.isScene) {
                    $scope.selectScene();
                } else {
                    updateHistorys();
                }
            })
        };
        $scope.updatetextDocParameter = function (p1, p2) {
            var level = $scope.currentPage.levels.level[$scope.template.levelI];

            var box = level.textdocument;
            textdocW = angular.copy(box.geometry.width);
            textdocH = angular.copy(box.geometry.height);

            if (box.lock) {
                return
            }

            if (vm.unit == 'mm') {
                box.geometry = {
                    width: MmTurnPx($scope.pageValue.textdocument.width),
                    height: MmTurnPx($scope.pageValue.textdocument.height),
                    x: MmTurnPx($scope.pageValue.textdocument.x),
                    y: MmTurnPx($scope.pageValue.textdocument.y)
                }
                if (p1 == 'width') {
                    box.geometry.height = box.geometry.width * textdocH / textdocW;
                    $scope.pageValue.textdocument.height = PxTurnMm(box.geometry.height);
                } else {
                    box.geometry.width = box.geometry.height * textdocW / textdocH;
                    $scope.pageValue.textdocument.width = PxTurnMm(box.geometry.width);
                }
            }
            if (vm.unit == 'px') {
                box.geometry = {
                    width: $scope.pageValue.textdocument.width,
                    height: $scope.pageValue.textdocument.height,
                    x: $scope.pageValue.textdocument.x,
                    y: $scope.pageValue.textdocument.y
                }
                if (p1 == 'width') {
                    box.geometry.height = box.geometry.width * textdocH / textdocW;
                    $scope.pageValue.textdocument.height = box.geometry.height;
                } else {
                    box.geometry.width = box.geometry.height * textdocW / textdocH;
                    $scope.pageValue.textdocument.width = box.geometry.width;
                }
            }
            if (vm.unit == 'in') {
                box.geometry = {
                    width: InTurnPx($scope.pageValue.textdocument.width),
                    height: InTurnPx($scope.pageValue.textdocument.height),
                    x: InTurnPx($scope.pageValue.textdocument.x),
                    y: InTurnPx($scope.pageValue.textdocument.y)
                }
                if (p1 == 'width') {
                    box.geometry.height = box.geometry.width * textdocH / textdocW;
                    $scope.pageValue.textdocument.height = PxTurnIn(box.geometry.height);
                } else {
                    box.geometry.width = box.geometry.height * textdocW / textdocH;
                    $scope.pageValue.textdocument.width = PxTurnIn(box.geometry.width);
                }
            }

            textdocument = angular.copy(box);
            resizeLevelWaH();

            if ($scope.currentPage.isScene) {
                $scope.selectScene();
            } else {
                updateHistorys();
            }

        };

        //图片占位框旋转角度
        $scope.updateRotate = function () {
            var box = {};
            if ($scope.RightPanel == 'placement' || $scope.RightPanel == 'mask') {
                box = $scope.currentPage.levels.level[$scope.template.levelI].imagebox.rotation;
            } else if ($scope.RightPanel == 'material') {
                box = $scope.currentPage.levels.level[$scope.template.levelI].imageart.rotation;
            } else if ($scope.RightPanel == 'text') {
                box = $scope.currentPage.levels.level[$scope.template.levelI].textbox.rotation;
            } else if ($scope.RightPanel == 'barcode') {
                box = $scope.currentPage.barcode.rotation;
            } else if ($scope.RightPanel == 'qrcode') {
                box = $scope.currentPage.qrcode.rotation;
            } else if ($scope.RightPanel == 'textDoc') {
                box = $scope.currentPage.levels.level[$scope.template.levelI].textdocument.rotation;
            }

            if (box.lock) {
                return
            }

            box.angle = $scope.template.angle;
            updateHistorys();
        };

        $scope.imageartToImagebox = function () {
            var box = angular.copy($scope.currentPage.levels.level[$scope.template.levelI].imageart);
            var _seq = angular.copy($scope.currentPage.levels.level[$scope.template.levelI].seq);
            vm.unit = 'mm';
            $scope.currentPage.levels.level.splice($scope.template.levelI, 1);
            var currentLevel = addLevel($scope.currentPage);
            currentLevel.seq = _seq;

            var angle = 0;
            if (box.rotation.angle != 0) {
                angle = 360 - box.rotation.angle
            }

            currentLevel.imagebox = ({
                geometry: box.geometry,
                rotation: {
                    angle: angle
                },
                mask: {
                    resource: {
                        identifier: null,
                        provider: 'qiniu'
                    }
                },
                imgUrl: 'content/images/mask_souce2.png',
                maskUrl: 'content/images/mask_souce2.png',
                bgImg: '',
                unit: 'mm',
                levelI: $scope.template.levelI,
                pageI: $scope.template.pageI,
                current: 'imagebox',
                lock: false
            });

            $scope.selectBox = currentLevel.imagebox;
            $scope.RightPanel = 'placement'
            getImageboxLen();
            $scope.pageValue.imagebox = {
                width: PxTurnMm($scope.selectBox.geometry.width).toFixed(2) - 0,
                height: PxTurnMm($scope.selectBox.geometry.height).toFixed(2) - 0,
                x: PxTurnMm($scope.selectBox.geometry.x).toFixed(2) - 0,
                y: PxTurnMm($scope.selectBox.geometry.y).toFixed(2) - 0
            }

            updateHistorys();
        }

        $scope.delPic = function () {
            // if (!$scope.currentPage.isScene) {
            var box = null;
            if ($scope.RightPanel == 'placement' || $scope.RightPanel == 'mask') {
                box = $scope.currentPage.levels.level[$scope.template.levelI].imagebox;
                if (box.image && box.image.resource && box.image.resource.identifier) {
                    box.image = null;
                }
                if (box.mask && box.mask.resource && box.mask.resource.identifier) {
                }
                updateHistorys();
            }
        }

        /* ==========================================================================
         素材处理
         ========================================================================== */
        // 素材点击时
        $scope.selectArt = function (e, $index, art) {
            fn(e);
            if (vm.unit == 'mm') {
                $scope.pageValue.imageart = {
                    width: PxTurnMm(art.geometry.width).toFixed(2) - 0,
                    height: PxTurnMm(art.geometry.height).toFixed(2) - 0,
                    x: PxTurnMm(art.geometry.x).toFixed(2) - 0,
                    y: PxTurnMm(art.geometry.y).toFixed(2) - 0
                }
            } else if (vm.unit == 'px') {
                $scope.pageValue.imageart = {
                    width: art.geometry.width,
                    height: art.geometry.height,
                    x: art.geometry.x,
                    y: art.geometry.y
                }
            } else if (vm.unit == 'in') {
                $scope.pageValue.imageart = {
                    width: PxTurnIn(art.geometry.width).toFixed(2) - 0,
                    height: PxTurnIn(art.geometry.height).toFixed(2) - 0,
                    x: PxTurnIn(art.geometry.x).toFixed(2) - 0,
                    y: PxTurnIn(art.geometry.y).toFixed(2) - 0
                }
            }
            $scope.template.angle = art.rotation.angle;
            $scope.template.transparency = art.transparency * 100;
            $(elem).val(art.transparency);

            art.current = 'imageart';
            $scope.selectBox = art;

            $("#menus").fadeOut();
            //如果是按住ctrl键 实现多选复制
            if (e.ctrlKey == true || e.metaKey == true) {
                art.ctrlKey = true;
                art.levelI = $index;
                vm.CtrlKeyArray.imagearts[$index] = angular.copy(art);
                ctrlAddSingleArray();
            } else {
                if (!art.ctrlKey) {
                    $scope.clearCtrlKey();
                    vm.singleArray = {imagebox: {}, textbox: {}, imageart: {}, barcode: {}, qrcode: {}, calMonthBox: {}, calTitleBox: {}};
                }
                vm.singleArray.imageart = angular.copy(art);
            }
            $scope.template.levelI = $index;
            // $scope.selPanel = 'material';
            $scope.RightPanel = 'material';
            e.stopPropagation();
            vm.selectElementCopy = angular.copy($scope.currentPage.levels.level[$scope.template.levelI]);
        };

        window.doubleClickClipart = function (e, item) {
            fn(e);
            var targ = e.target ? e.target : e.srcElement;
            $scope.template.levelI = targ.dataset.index || $scope.template.levelI;
            var imageart = $scope.currentPage.levels.level[$scope.template.levelI].imageart;
            $scope.template.angle = imageart.rotation.angle;

            if (imageart.lock) {
                return
            }
            vm.pageMarginTop = parseFloat($(".page-item").css('margin-top'));
            vm.isImageartTrim = true;
            vm.imageartTrim = angular.copy(imageart);
            vm.imageartTrim.geometry.width1 = angular.copy(imageart.geometry.width);
            vm.imageartTrim.geometry.height1 = angular.copy(imageart.geometry.height);
            vm.imageartTrim.geometry.x1 = angular.copy(imageart.geometry.x);
            vm.imageartTrim.geometry.y1 = angular.copy(imageart.geometry.y);

            var pro = $scope.currentPage.scale / $scope.currentPage.proportion;
            if (vm.imageartTrim.geometry.width * pro == vm.imageartTrim.geometry.width1 * pro * vm.imageartTrim.scale) {
                vm.imageartTrim.geometry.width = vm.imageartTrim.geometry.width * 0.8;
                vm.imageartTrim.geometry.height = vm.imageartTrim.geometry.height * 0.8;
                vm.imageartTrim.geometry.x = Number(vm.imageartTrim.geometry.x) + Number(vm.imageartTrim.geometry.width / 0.8 * 0.2 / 2);
                vm.imageartTrim.geometry.y = Number(vm.imageartTrim.geometry.y) + Number(vm.imageartTrim.geometry.height / 0.8 * 0.2 / 2);
            }
            $scope.$digest();
        }

        //拖动素材裁切
        var isImageartTrim = false;
        $scope.imageartTrimdown = function ($event) {
            fn($event)
            var x = $event.clientX;
            var y = $event.clientY;
            var pro = $scope.currentPage.scale / $scope.currentPage.proportion;
            var l = vm.imageartTrim.geometry.x * pro;
            var t = vm.imageartTrim.geometry.y * pro;
            var r = (vm.imageartTrim.geometry.width1 * vm.imageartTrim.scale - vm.imageartTrim.geometry.width) * pro;
            var b = (($("#c-xml-imageart-trim-img").find('img').height()) / pro - vm.imageartTrim.geometry.height) * pro;

            var x1 = (Number(vm.imageartTrim.geometry.x1) + Number(vm.imageartTrim.offsetx)) * pro;
            var y1 = (Number(vm.imageartTrim.geometry.y1) + Number(vm.imageartTrim.offsety)) * pro;
            var x2 = vm.imageartTrim.geometry.x1 * pro;
            var y2 = vm.imageartTrim.geometry.y1 * pro;
            var x3 = vm.imageartTrim.offsetx * pro;
            var y3 = vm.imageartTrim.offsety * pro;
            //开关打开
            isImageartTrim = true;
            //鼠标移动
            window.onmousemove = function (e) {
                if (isImageartTrim == false) {
                    return;
                }
                //获取x和y
                var nx = e.clientX;
                var ny = e.clientY;
                //计算移动后的左偏移量和顶部的偏移量
                var nl = nx - (x - l);
                var nt = ny - (y - t);


                if (nl < x1) {
                    nl = x1
                }
                ;
                if (nl > Number(r) + Number(x1)) {
                    nl = Number(r) + Number(x1)
                }
                ;
                if (nt < y1) {
                    nt = y1
                }
                ;
                if (nt > Number(b) + Number(y1)) {
                    nt = Number(b) + Number(y1)
                }
                ;

                vm.imageartTrim.geometry.x = nl / pro;
                vm.imageartTrim.geometry.y = nt / pro;

                $("#c-xml-imageart-trim-frame").css({
                    left: nl + 'px',
                    top: nt + 'px',
                });
                $("#c-xml-imageart-trim-frame-img").css({
                    left: Number(x2 - nl) + Number(x3) + 'px',
                    top: Number(y2 - nt) + Number(y3) + 'px',
                });
            }
            //鼠标抬起事件
            window.onmouseup = function ($event) {
                isImageartTrim = false;
                $event.stopPropagation();
            }
        }

        //素材裁切放大缩小
        var isImageartTrimRight = false;
        $scope.imageartTrimRight = function ($event, item) {
            fn($event)
            var x = $event.clientX;
            var y = $event.clientY;
            var pro = $scope.currentPage.scale / $scope.currentPage.proportion;
            //获取w和h
            // var nw = $($event.target).parent().width();
            // var nh = $($event.target).parent().height();
            var nw = Number(item.geometry.width * pro) + Number(item.geometry.x * pro);
            var nh = Number(item.geometry.height * pro) + Number(item.geometry.y * pro);
            var _l = item.geometry.x * pro;
            var _t = item.geometry.y * pro;


            // var r = Number($("#c-xml-imageart-trim-div").offset().left) + Number(vm.imageartTrim.geometry.width1 * pro * vm.imageartTrim.scale);
            // var b = Number($("#c-xml-imageart-trim-div").offset().top) + Number($("#c-xml-imageart-trim-img").find('img').height());

            var r = Number(item.geometry.x1 * pro) + Number(item.offsetx * pro) + Number(item.geometry.width1 * pro * item.scale);
            var b = Number(item.geometry.y1 * pro) + Number(item.offsety * pro) + Number($("#imageartTrimRight1").height());
            //开关打开
            isImageartTrimRight = true;
            //鼠标移动
            window.onmousemove = function (e) {
                if (isImageartTrimRight == false) {
                    return;
                }

                //获取x和y
                var nx = e.clientX;
                var ny = e.clientY;
                //计算移动后的左偏移量和顶部的偏移量
                var nl = Number(nw) + Number(nx - x);
                var nt = Number(nh) + Number(ny - y);

                if (nl >= r) {
                    nl = r
                }
                if (nt >= b) {
                    nt = b
                }

                item.geometry.width = (nl - _l) / pro;
                item.geometry.height = (nt - _t) / pro;
                $scope.$digest();
            }
            //鼠标抬起事件
            window.onmouseup = function ($event) {
                isImageartTrimRight = false;
                $event.stopPropagation();
            }
        }
        $scope.imageartTrimTrueClick = function () {
            vm.isImageartTrim = false;
            var pro = $scope.currentPage.scale / $scope.currentPage.proportion
            vm.imageartTrim.scale = (vm.imageartTrim.geometry.width1 * pro * vm.imageartTrim.scale) / (vm.imageartTrim.geometry.width * pro);
            vm.imageartTrim.offsetx = (Number(-(vm.imageartTrim.geometry.x - vm.imageartTrim.geometry.x1)) + Number(vm.imageartTrim.offsetx)).toFixed(2) - 0;
            vm.imageartTrim.offsety = (Number(-(vm.imageartTrim.geometry.y - vm.imageartTrim.geometry.y1)) + Number(vm.imageartTrim.offsety)).toFixed(2) - 0;
            vm.imageartTrim.geometry.x = $scope.currentPage.levels.level[$scope.template.levelI].imageart.geometry.x;
            vm.imageartTrim.geometry.y = $scope.currentPage.levels.level[$scope.template.levelI].imageart.geometry.y;
            if (vm.imageartTrim.offsetx > 0) {
                vm.imageartTrim.offsetx = 0;
            }
            if (vm.imageartTrim.offsety > 0) {
                vm.imageartTrim.offsety = 0;
            }
            if (vm.imageartTrim.scale < 1) {
                vm.imageartTrim.scale = 1;
            }
            $scope.currentPage.levels.level[$scope.template.levelI].imageart = vm.imageartTrim;
        }
        $scope.imageartTrimFalseClick = function () {
            vm.isImageartTrim = false;
        }

        //素材缩放right
        var isZoomDown = false;
        $scope.imageartdownZoomRight = function ($event, item, pro) {
            // if(item.movable){return}
            fn($event)
            $timeout(function () {
                editorBoxZoom($event, item, 'rightBottom', pro, $($event.target).parents('.selected'), function (it) {
                    calMonthBoxW();
                    $scope.$apply();
                }, function (it) {
                    calMonthBoxW();
                    if (vm.unit == 'mm') {
                        $scope.pageValue.imageart = {
                            width: PxTurnMm(item.geometry.width).toFixed(2) - 0,
                            height: PxTurnMm(item.geometry.height).toFixed(2) - 0,
                            x: PxTurnMm(item.geometry.x).toFixed(2) - 0,
                            y: PxTurnMm(item.geometry.y).toFixed(2) - 0,
                        }
                    } else if (vm.unit == 'px') {
                        $scope.pageValue.imageart = {
                            width: PxTurnMm(item.geometry.width / 25.4 * vm.windowDpiW),
                            height: PxTurnMm(item.geometry.height / 25.4 * vm.windowDpiW),
                            x: PxTurnMm(item.geometry.x / 25.4 * vm.windowDpiW),
                            y: PxTurnMm(item.geometry.y / 25.4 * vm.windowDpiW),
                        }
                    } else if (vm.unit == 'in') {
                        $scope.pageValue.imageart = {
                            width: PxTurnIn(item.geometry.width).toFixed(2) - 0,
                            height: PxTurnIn(item.geometry.height).toFixed(2) - 0,
                            x: PxTurnIn(item.geometry.x).toFixed(2) - 0,
                            y: PxTurnIn(item.geometry.y).toFixed(2) - 0,
                        }
                    }
                    $scope.pxInsufficient(item, 'imageart');
                    $scope.$apply();
                });
            })
        }
        //素材缩放left
        $scope.imageartdownZoomLeft = function ($event, item, pro) {
            // if(item.movable){return}
            fn($event)
            editorBoxZoom($event, item, 'leftTop', pro, $($event.target).parents('.selected'), function (it) {
                calMonthBoxW();
                $scope.$apply();
            }, function (it) {
                calMonthBoxW();
                if (vm.unit == 'mm') {
                    $scope.pageValue.imageart = {
                        width: PxTurnMm(item.geometry.width).toFixed(2) - 0,
                        height: PxTurnMm(item.geometry.height).toFixed(2) - 0,
                        x: PxTurnMm(item.geometry.x).toFixed(2) - 0,
                        y: PxTurnMm(item.geometry.y).toFixed(2) - 0,
                    }
                } else if (vm.unit == 'px') {
                    $scope.pageValue.imageart = {
                        width: PxTurnMm(item.geometry.width / 25.4 * vm.windowDpiW),
                        height: PxTurnMm(item.geometry.height / 25.4 * vm.windowDpiW),
                        x: PxTurnMm(item.geometry.x / 25.4 * vm.windowDpiW),
                        y: PxTurnMm(item.geometry.y / 25.4 * vm.windowDpiW),
                    }
                } else if (vm.unit == 'in') {
                    $scope.pageValue.imageart = {
                        width: PxTurnIn(item.geometry.width).toFixed(2) - 0,
                        height: PxTurnIn(item.geometry.height).toFixed(2) - 0,
                        x: PxTurnIn(item.geometry.x).toFixed(2) - 0,
                        y: PxTurnIn(item.geometry.y).toFixed(2) - 0,
                    }
                }
                $scope.pxInsufficient(item, 'imageart');
            });
        }
        //素材缩放top
        $scope.imageartdownZoomTop = function ($event, item, pro) {
            // if(item.movable){return}
            fn($event)
            editorBoxZoom($event, item, 'rightTop', pro, $($event.target).parents('.selected'), function (it) {
                calMonthBoxW();
                $scope.$apply();
            }, function (it) {
                calMonthBoxW();
                if (vm.unit == 'mm') {
                    $scope.pageValue.imageart = {
                        width: PxTurnMm(item.geometry.width).toFixed(2) - 0,
                        height: PxTurnMm(item.geometry.height).toFixed(2) - 0,
                        x: PxTurnMm(item.geometry.x).toFixed(2) - 0,
                        y: PxTurnMm(item.geometry.y).toFixed(2) - 0,
                    }
                } else if (vm.unit == 'px') {
                    $scope.pageValue.imageart = {
                        width: PxTurnMm(item.geometry.width / 25.4 * vm.windowDpiW),
                        height: PxTurnMm(item.geometry.height / 25.4 * vm.windowDpiW),
                        x: PxTurnMm(item.geometry.x / 25.4 * vm.windowDpiW),
                        y: PxTurnMm(item.geometry.y / 25.4 * vm.windowDpiW),
                    }
                } else if (vm.unit == 'in') {
                    $scope.pageValue.imageart = {
                        width: PxTurnIn(item.geometry.width).toFixed(2) - 0,
                        height: PxTurnIn(item.geometry.height).toFixed(2) - 0,
                        x: PxTurnIn(item.geometry.x).toFixed(2) - 0,
                        y: PxTurnIn(item.geometry.y).toFixed(2) - 0,
                    }
                }
                $scope.pxInsufficient(item, 'imageart');
            });
        }
        //素材缩放bottom
        $scope.imageartdownZoomBottom = function ($event, item, pro) {
            // if(!item.movable){return}
            fn($event)
            editorBoxZoom($event, item, 'leftBottom', pro, $($event.target).parents('.selected'), function (it) {
                calMonthBoxW();
                $scope.$apply();
            }, function (it) {
                calMonthBoxW();
                if (vm.unit == 'mm') {
                    $scope.pageValue.imageart = {
                        width: PxTurnMm(item.geometry.width).toFixed(2) - 0,
                        height: PxTurnMm(item.geometry.height).toFixed(2) - 0,
                        x: PxTurnMm(item.geometry.x).toFixed(2) - 0,
                        y: PxTurnMm(item.geometry.y).toFixed(2) - 0,
                    }
                } else if (vm.unit == 'px') {
                    $scope.pageValue.imageart = {
                        width: PxTurnMm(item.geometry.width / 25.4 * vm.windowDpiW),
                        height: PxTurnMm(item.geometry.height / 25.4 * vm.windowDpiW),
                        x: PxTurnMm(item.geometry.x / 25.4 * vm.windowDpiW),
                        y: PxTurnMm(item.geometry.y / 25.4 * vm.windowDpiW),
                    }
                } else if (vm.unit == 'in') {
                    $scope.pageValue.imageart = {
                        width: PxTurnIn(item.geometry.width).toFixed(2) - 0,
                        height: PxTurnIn(item.geometry.height).toFixed(2) - 0,
                        x: PxTurnIn(item.geometry.x).toFixed(2) - 0,
                        y: PxTurnIn(item.geometry.y).toFixed(2) - 0,
                    }
                }
                $scope.pxInsufficient(item, 'imageart');
            });
        }
        function calMonthBoxW(item, isCeil){
            if(item && item.current == 'calMonthBox'){
                var _width = angular.copy(item.geometry.width);
                var _height = angular.copy(item.geometry.height);
                if(isCeil){
                    item.geometry.width = Math.ceil(item.geometry.width/7) * 7;
                }else{
                    item.geometry.width = Math.floor(item.geometry.width/7) * 7;
                }
                item.geometry.height = item.geometry.width*_height/_width;
            }
        }

        /* ==========================================================================
         文字处理
         ========================================================================== */
        //增加文本框
        $scope.addText = function (size) {
            if(vm.textEditor){
                return
            }
            var currentPage = $scope.template.pages.page[$scope.template.pageI];
            var currentLevel = addLevel(currentPage);
            $scope.RightPanel = 'text';

            vm.text = '请输入文字';
            $scope.size = size;

            currentLevel.textbox = ({
                transparency: 1,
                geometry: {
                    width: '',
                    height: '',
                    x: currentPage.trimbox.x + 20 + $scope.template.levelI * 2,
                    y: currentPage.trimbox.y + 20 + $scope.template.levelI * 2
                },
                rotation: {
                    angle: 0
                },
                style: {
                    font: vm.defaultFont.family,
                    size: size,
                    color: '#000000',
                    bold: false,
                    italic: false,
                    lineheight: size,
                    letterspacing: 0,
                    align: 'left',
                    writingmode: 'horizontal-tb'
                },
                fontuuid: vm.defaultFont.uuid,
                identifier: vm.url + vm.defaultFont.fontStyles[0].identifier,
                editable: true,
                movable: true,
                version: '2.0',
                text: '请输入文字',
                unit: 'mm',
                // index: currentPage.textboxes.textbox.length,
                levelI: $scope.template.levelI,
                pageI: $scope.template.pageI,
                current: 'textbox',
                lock: false
            });


            getFont(currentLevel.textbox,FontManagement);
            fontSupport(FontManagement, currentLevel.textbox);
            $(".block-width,.block-height").css({left: 0});
            $scope.template.letterspacing = $scope.template.lineheight = 0;

            $(".space-slider").addClass('hide1');
            $(".nav_spacing").removeClass('nav-spacing-active');

            vm.fontHide = currentLevel.textbox;
            fontStyle(currentLevel.textbox);
            $timeout(function () {
                var pro = currentPage.scale / currentPage.proportion;
                currentLevel.textbox.geometry.width = Number($("#c-xml-page-material-fontId").width()) + Number(10);
                currentLevel.textbox.geometry.height = Number($("#c-xml-page-material-fontId").height()) + Number(5);
                updateHistorys();
                $scope.currentPage = currentPage;
                $scope.selectBox = currentLevel.textbox;

                if (vm.unit == 'mm') {
                    $scope.pageValue.textbox = {
                        width: PxTurnMm(currentLevel.textbox.geometry.width),
                        height: PxTurnMm(currentLevel.textbox.geometry.height),
                        x: PxTurnMm(currentPage.trimbox.x + 20 + $scope.template.levelI * 2),
                        y: PxTurnMm(currentPage.trimbox.y + 20 + $scope.template.levelI * 2)
                    }
                } else if (vm.unit == 'px') {
                    $scope.pageValue.textbox = currentLevel.textbox.geometry;
                } else if (vm.unit == 'in') {
                    $scope.pageValue.textbox = {
                        width: PxTurnIn(currentLevel.textbox.geometry.width),
                        height: PxTurnIn(currentLevel.textbox.geometry.height),
                        x: PxTurnIn(currentPage.trimbox.x + 20 + $scope.template.levelI * 2),
                        y: PxTurnIn(currentPage.trimbox.y + 20 + $scope.template.levelI * 2)
                    }
                }
            })
            $scope.item = vm.fontList[0];

            vm.selectElementCopy = angular.copy($scope.currentPage.levels.level[$scope.template.levelI]);
        };

        $scope.$watch("vm.text", function (newValue, oldValue) {
            // if(oldValue){
            sizeHeight();
            // }
        })
        vm.verifyTextFocus = false;
        $scope.verifyTextFocus = function(){
            vm.verifyTextFocus = true;
        }
        $scope.verifyText = function (e) {
            fn(e);
            var _textbox = $scope.currentPage.levels.level[$scope.template.levelI].textbox;
            _textbox.characterWarning = false;
            _textbox.characterMessage = "";
            FontManagement.fontSupport({
                uuid: _textbox.fontuuid,
                bold: _textbox.style.bold,
                italic: _textbox.style.italic,
                content: vm.text
            }, function (res) {
                var msg = res.message;
                if (res.status == 200) {
                    _textbox.success = msg.success;
                    if (!msg.success) {
                        MessageService.error("当前字体不可用，请更换字体");
                        return
                    }
                    if (msg.success && !msg.supported) {
                        var message = "【" + msg.failed + "】" + "当前字体不支持这些文字！";
                        MessageService.error(message);
                        _textbox.characterWarning = true;
                        _textbox.characterMessage = message;
                    }
                    vm.text = msg.passed;
                    sizeHeight();
                }
                vm.verifyTextFocus = false;
            })
        }

        $scope.verifyTextFont = function (textbox) {
            if (!textbox) {
                return;
            }
            textbox.characterWarning = false;
            textbox.characterMessage = "";
            FontManagement.fontSupport({
                uuid: textbox.fontuuid,
                bold: textbox.style.bold,
                italic: textbox.style.italic,
                content: textbox.text
            }, function (res) {
                var msg = res.message;
                if (res.status == 200) {
                    textbox.success = msg.success;
                    if (msg.success && !msg.supported) {
                        var message = "【" + msg.failed + "】" + "当前字体不支持这些文字！";
                        textbox.characterWarning = true;
                        textbox.characterMessage = message;
                    }
                }
            })
        }

        $scope.$watch("vm.textDocCon", function (newValue, oldValue) {
            if (oldValue) {
                sizeTextDocHeight();
            }
        })

        function sizeTextDocHeight() {
            var _textbox = $scope.currentPage.levels.level[$scope.template.levelI].textdocument.levels.level[$scope.template.docI].textbox;
            _textbox.text = vm.textDocCon;
            var maxY = $contain.height();
            $timeout(function () {
                var _h = Number($(".textbox" + $scope.template.pageI + $scope.template.levelI + $scope.template.docI).find('.c-xml-page-textboxe-text').height()) + Number(5);
                var _top = Number($(".textbox" + $scope.template.pageI + $scope.template.levelI + $scope.template.docI)[0].offsetTop);
                if (_h + _top > maxY) {
                    _textbox.geometry.x = 0;
                    _textbox.geometry.y = 0;
                    ;
                }
                _textbox.geometry.height = _h / ($scope.currentPage.scale / $scope.currentPage.proportion)
            })
        }

        //编辑状态
        $scope.editableSel = function (box, attr) {
            $scope.currentPage.levels.level[$scope.template.levelI][box].editable = attr;
        }
        //不可编辑
        $scope.movableSel = function (box, attr) {
            $scope.currentPage.levels.level[$scope.template.levelI][box].movable = attr;
        }


        $scope.addTextDoc = function (text) {
            if(vm.textEditor){
                return
            }
            FontXmls.get({id: text.id}, function (res) {
                $scope.RightPanel = 'textDoc';
                vm.unit = 'mm';
                vm.data = res;
                // var level = $scope.currentPage.levels.level[$scope.template.levelI];
                var currentPage = $scope.template.pages.page[$scope.template.pageI];
                var currentLevel = addLevel(currentPage);
                currentLevel.textdocument = angular.copy(vm.data.textDocument);

                var geo = currentLevel.textdocument.geometry;

                $scope.pageValue.textdocument = {
                    width: geo.width,
                    height: geo.height,
                    x: geo.x + 12 + $scope.template.levelI * 2,
                    y: geo.y + 12 + $scope.template.levelI * 2
                }
                var dataBackground = vm.data.textDocument.background;
                var textdocument = currentLevel.textdocument;
                textdocument.geometry = getGeometry($scope.pageValue.textdocument);
                textdocument.current = 'textdocument';
                textdocument.rotation = {
                    angle: 0
                };
                textdocument.background.offsetx = MmTurnPx(dataBackground.offsetx);
                textdocument.background.offsety = MmTurnPx(dataBackground.offsety);
                var resource = textdocument.background.resource;
                if (resource.identifier) {
                    $http({url: resource.identifier + '?imageInfo'}).success(function (data) {
                        var pageW = textdocument.geometry.width,
                            pageH = textdocument.geometry.height,
                            bgW = data.width,
                            bgH = data.height;

                        // 高适配
                        var adaptation = 'Height', h = pageH, w = pageH * bgW / bgH;
                        // 宽适配
                        if ((bgW <= bgH || pageW <= pageH) && (bgW / bgH < pageW / pageH) || bgW >= bgH && pageW >= pageH && (bgW / bgH < pageW / pageH)) {
                            w = pageW;
                            h = pageW * bgH / bgW;
                            adaptation = 'Width';
                        }
                        textdocument.background.width = w;
                        textdocument.background.resource.width = bgW;
                        textdocument.background.resource.height = bgH;
                        textdocument.background.height = h;
                        textdocument.background.type = 'Pic';
                        textdocument.background.adaptation = adaptation
                    }).error(function (error) {
                        MessageService.error("获取图片信息失败");
                    });
                }

                angular.forEach(textdocument.levels.level, function (level, l) {
                    var dataLevel = vm.data.textDocument.levels.level[l];
                    if (level.imageart && level.imageart.geometry) {
                        level.imageart.current = 'imageart';
                        level.imageart.geometry = getGeometry(dataLevel.imageart.geometry);
                        var resource = dataLevel.imageart.resource;
                        var arr = ThreeHundredDpiToMm(resource.width, resource.height);
                        $http({url: resource.identifier + '?imageInfo'}).success(function (data) {
                            level.imageart.resource = {
                                identifier: resource.identifier,
                                provider: 'qiniu',
                                width: data.width,
                                height: data.height
                            }

                            level.imageart.offsetx = MmTurnPx(dataLevel.imageart.offsetx);
                            level.imageart.offsety = MmTurnPx(dataLevel.imageart.offsety);
                        }).error(function (error) {
                            MessageService.error("获取图片信息失败");
                        });
                    }
                    if (level.textbox && level.textbox.geometry) {
                        level.textbox.current = 'textbox';
                        level.textbox.geometry = getGeometry(dataLevel.textbox.geometry);
                        getFont(level.textbox,FontManagement);
                    }
                })
                updateHistorys();
                currentLevel.textdocument.levelI = $scope.template.levelI;
                currentLevel.textdocument.pageI = $scope.template.pageI;
                $scope.currentPage = currentPage;
                $scope.selectBox = currentLevel.textdocument;
                return
            });
        }


        //文本框点击时

        $scope.selectDoc = function (e, $index, textdocument) {
            if(vm.textEditor){
                return;
            }
            fn(e)
            if (vm.unit == 'mm') {
                $scope.pageValue.textdocument = {
                    width: PxTurnMm(textdocument.geometry.width).toFixed(2) - 0,
                    height: PxTurnMm(textdocument.geometry.height).toFixed(2) - 0,
                    x: PxTurnMm(textdocument.geometry.x).toFixed(2) - 0,
                    y: PxTurnMm(textdocument.geometry.y).toFixed(2) - 0
                }
            } else if (vm.unit == 'px') {
                $scope.pageValue.textdocument = {
                    width: textdocument.geometry.width,
                    height: textdocument.geometry.height,
                    x: textdocument.geometry.x,
                    y: textdocument.geometry.y
                }
            } else if (vm.unit == 'in') {
                $scope.pageValue.textdocument = {
                    width: PxTurnIn(textdocument.geometry.width).toFixed(2) - 0,
                    height: PxTurnIn(textdocument.geometry.height).toFixed(2) - 0,
                    x: PxTurnIn(textdocument.geometry.x).toFixed(2) - 0,
                    y: PxTurnIn(textdocument.geometry.y).toFixed(2) - 0
                }
            }
            $scope.template.angle = textdocument.rotation.angle;
            textdocument.current = 'textdocument';
            $scope.selectBox = textdocument;

            //如果是按住ctrl键 实现多选复制
            // var mm = $scope.currentPage.imageboxes.imagebox[$index];
            if (e.ctrlKey == true || e.metaKey == true) {
                if (textdocument.lock) {
                    return
                }
                textdocument.ctrlKey = true;
                textdocument.levelI = $index;
                vm.CtrlKeyArray.textdocuments[$index] = angular.copy(textdocument);
                ctrlAddSingleArray();
            } else {
                $scope.clearCtrlKey();
                vm.singleArray = {imagebox: {}, textbox: {}, imageart: {}, barcode: {}, qrcode: {}, textdocument: {}, calMonthBox: {}, calTitleBox: {}};
                vm.singleArray.textdocument = angular.copy(textdocument);
            }
            $("#menus").fadeOut();
            // setZindex($index);
            $("#maskSelect").val("");
            $scope.template.levelI = $index;
            $scope.RightPanel = 'textDoc';
            e.stopPropagation();
        };

        /**
         *放大占位框
         * @param e
         */
        var dragDocFlag = false, dragDoc = {}, textdocW = 1, textdocH = 1, textdocument = null;
        window.resizeDocStart = function (e) {
            fn(e);
            var targ = e.target ? e.target : e.srcElement;

            $scope.template.levelI = targ.dataset.index || $scope.template.levelI;
            textdocument = angular.copy($scope.currentPage.levels.level[$scope.template.levelI].textdocument);

            if (textdocument.lock) {
                return
            }
            dragDoc.clientX = e.clientX || 0;          //鼠标到页面左边的距离
            dragDoc.clientY = e.clientY || 0;          //鼠标到页面顶部的距离
            dragDoc.coordX = targ.offsetParent.offsetLeft + targ.offsetLeft;        //鼠标到模板左边的距离
            dragDoc.coordY = targ.offsetParent.offsetTop + targ.offsetTop;         //鼠标到模板顶部的距离
            dragDoc.maxX = $contain.width();
            dragDoc.maxY = $contain.height();
            dragDocFlag = true;

            $scope.RightPanel = 'textDoc';

            textdocW = angular.copy(textdocument.geometry.width);
            textdocH = angular.copy(textdocument.geometry.height);

            document.addEventListener("mousemove", resizeDocOn, true);
            document.addEventListener("mouseup", resizeDocEnd, true);
        };

        function resizeDocOn(e) {
            if (dragDocFlag) {
                fn(e);
                // 是否按住shift键
                dragDoc.shiftKey = e.shiftKey;
                var targ = e.target ? e.target : e.srcElement;
                if (targ == null) {
                    return;
                }
                var imgIndex = $scope.template.levelI;
                if (imgIndex == null) {
                    return;
                }
                var pageIndex = $scope.template.pages.page[$scope.template.pageI];
                if (pageIndex == null) {
                    return;
                }
                var item = pageIndex.levels.level[$scope.template.levelI].textdocument;
                if (item == null) {
                    return;
                }

                var pro = pageIndex.scale / pageIndex.proportion
                var x = item.geometry.x * pro;
                var y = item.geometry.y * pro;
                //20 小图标的宽高
                var w = (dragDoc.coordX + 10 + e.clientX - dragDoc.clientX - x);
                // var w = (dragDoc.coordX + 10 + e.clientX - dragDoc.clientX - item.geometry.x *pro) /pro;
                var h = w / item.geometry.width * item.geometry.height

                if (w < 40 || h < 40) {
                    return
                }

                if (x + w > dragDoc.maxX) {
                    var maxW = dragDoc.maxX - x;
                    item.geometry.width = maxW / pro;
                    item.geometry.height = (maxW / item.geometry.width * item.geometry.height) / pro;
                } else if (y + h > dragDoc.maxY) {
                    var maxH = dragDoc.maxY - y;
                    item.geometry.height = maxH / pro;
                    item.geometry.width = (maxH / item.geometry.height * item.geometry.width) / pro;
                } else {
                    item.geometry.width = w / pro;
                    item.geometry.height = h / pro;
                }

                if (vm.unit == 'mm') {
                    $scope.pageValue.textdocument.width = PxTurnMm(item.geometry.width);
                    $scope.pageValue.textdocument.height = PxTurnMm(item.geometry.height);
                } else if (vm.unit == 'px') {
                    $scope.pageValue.textdocument.width = item.geometry.width;
                    $scope.pageValue.textdocument.height = item.geometry.height;
                } else if (vm.unit == 'in') {
                    $scope.pageValue.textdocument.width = PxTurnIn(item.geometry.width);
                    $scope.pageValue.textdocument.height = PxTurnIn(item.geometry.height);
                }
                resizeLevelWaH();

            }
            $scope.$digest();
            return false;
        }

        function resizeDocEnd() {
            dragDocFlag = false;
            dragDoc = {};

            document.removeEventListener("mousemove", resizeDocOn, true);
            document.removeEventListener("mouseup", resizeDocEnd, true);
            updateHistorys();
            $scope.currentPage = $scope.template.pages.page[$scope.template.pageI];
            $scope.$digest();
        }

        window.resizeDocStart1 = function (e) {
            fn(e);
            var targ = e.target ? e.target : e.srcElement;

            $scope.template.levelI = targ.dataset.index || $scope.template.levelI;
            textdocument = angular.copy($scope.currentPage.levels.level[$scope.template.levelI].textdocument);

            if (textdocument.lock) {
                return
            }
            dragDoc.clientX = e.clientX || 0;          //鼠标到页面左边的距离
            dragDoc.clientY = e.clientY || 0;          //鼠标到页面顶部的距离
            dragDoc.coordX = targ.offsetParent.offsetLeft + targ.offsetLeft;        //鼠标到模板左边的距离
            dragDoc.coordY = targ.offsetParent.offsetTop + targ.offsetTop;         //鼠标到模板顶部的距离
            dragDoc.maxX = $contain.width();
            dragDoc.maxY = $contain.height();
            dragDocFlag = true;

            $scope.RightPanel = 'textDoc';

            textdocW = angular.copy(textdocument.geometry.width);
            textdocH = angular.copy(textdocument.geometry.height);

            document.addEventListener("mousemove", resizeDocOn1, true);
            document.addEventListener("mouseup", resizeDocEnd1, true);
        };

        function resizeDocOn1(e) {
            if (dragDocFlag) {
                fn(e);
                // 是否按住shift键
                dragDoc.shiftKey = e.shiftKey;
                var targ = e.target ? e.target : e.srcElement;
                if (targ == null) {
                    return;
                }
                var imgIndex = $scope.template.levelI;
                if (imgIndex == null) {
                    return;
                }
                var pageIndex = $scope.template.pages.page[$scope.template.pageI];
                if (pageIndex == null) {
                    return;
                }
                var item = pageIndex.levels.level[$scope.template.levelI].textdocument;
                if (item == null) {
                    return;
                }

                var pro = pageIndex.scale / pageIndex.proportion * $scope.proportion;
                var x = item.geometry.x * pro;
                var y = item.geometry.y * pro;
                //20 小图标的宽高
                var w = (dragDoc.coordX + 10 + e.clientX - dragDoc.clientX - x);
                // var w = (dragDoc.coordX + 10 + e.clientX - dragDoc.clientX - item.geometry.x *pro) /pro;
                var h = w / item.geometry.width * item.geometry.height;

                if (w < 10 || h < 10) {
                    return
                }

                if (x + w > dragDoc.maxX) {
                    var maxW = dragDoc.maxX - x;
                    item.geometry.width = maxW / pro;
                    item.geometry.height = (maxW / item.geometry.width * item.geometry.height) / pro;
                } else if (y + h > dragDoc.maxY) {
                    var maxH = dragDoc.maxY - y;
                    item.geometry.height = maxH / pro;
                    item.geometry.width = (maxH / item.geometry.height * item.geometry.width) / pro;
                } else {
                    item.geometry.width = w / pro;
                    item.geometry.height = h / pro;
                }

                if (vm.unit == 'mm') {
                    $scope.pageValue.textdocument.width = PxTurnMm(item.geometry.width);
                    $scope.pageValue.textdocument.height = PxTurnMm(item.geometry.height);
                } else if (vm.unit == 'px') {
                    $scope.pageValue.textdocument.width = item.geometry.width;
                    $scope.pageValue.textdocument.height = item.geometry.height;
                } else if (vm.unit == 'in') {
                    $scope.pageValue.textdocument.width = PxTurnIn(item.geometry.width);
                    $scope.pageValue.textdocument.height = PxTurnIn(item.geometry.height);
                }


                resizeLevelWaH();

            }
            $scope.$digest();
            return false;
        }

        function resizeDocEnd1() {
            dragDocFlag = false;
            dragDoc = {};

            document.removeEventListener("mousemove", resizeDocOn1, true);
            document.removeEventListener("mouseup", resizeDocEnd1, true);
            updateHistorys();
            $scope.currentPage = $scope.template.pages.page[$scope.template.pageI];
            $scope.$digest();
        }

        function resizeLevelWaH() {
            var doc = $scope.template.pages.page[$scope.template.pageI].levels.level[$scope.template.levelI].textdocument;
            doc.background.offsetx = textdocument.background.offsetx * doc.geometry.width / textdocW;
            doc.background.offsety = textdocument.background.offsety * doc.geometry.height / textdocH;
            doc.background.width = textdocument.background.width * doc.geometry.width / textdocW;
            doc.background.height = textdocument.background.height * doc.geometry.height / textdocH;

            angular.forEach(doc.levels.level, function (level, l) {
                var textdoc = textdocument.levels.level[l];
                if (level.imageart) {
                    var geo = {
                        width: textdoc.imageart.geometry.width * doc.geometry.width / textdocW,
                        height: textdoc.imageart.geometry.height * doc.geometry.height / textdocH,
                        x: textdoc.imageart.geometry.x * doc.geometry.width / textdocW,
                        y: textdoc.imageart.geometry.y * doc.geometry.height / textdocH,
                    }
                    level.imageart.geometry = geo;

                    level.imageart.offsetx = textdoc.imageart.offsetx * doc.geometry.width / textdocW;
                    level.imageart.offsety = textdoc.imageart.offsety * doc.geometry.height / textdocH;
                }
                if (level.textbox) {
                    var textGeo = {
                        width: textdoc.textbox.geometry.width * doc.geometry.width / textdocW,
                        height: textdoc.textbox.geometry.height * doc.geometry.height / textdocH,
                        x: textdoc.textbox.geometry.x * doc.geometry.width / textdocW,
                        y: textdoc.textbox.geometry.y * doc.geometry.height / textdocH,
                    }
                    level.textbox.geometry = textGeo;
                    level.textbox.style.size = textdoc.textbox.style.size * doc.geometry.width / textdocW;
                    level.textbox.style.lineheight = textdoc.textbox.style.lineheight * doc.geometry.width / textdocW;
                }
            })
        }

        $scope.slipGroup = function () {
            var currentPage = $scope.template.pages.page[$scope.template.pageI];
            var textdocument = angular.copy(currentPage.levels.level[$scope.template.levelI].textdocument);
            // var page = document.getElementById('pageContent');
            // var pageRect = page.getBoundingClientRect();
            // var pageLeft = pageRect.left;
            // var pageTop = pageRect.top;
            // var currentPage = $scope.template.pages.page[$scope.template.pageI];
            // var textdocument = angular.copy(currentPage.levels.level[$scope.template.levelI].textdocument);
            $scope.deleteBox();
            var textGeo = textdocument.geometry;
            vm.unit = 'mm';
            if (textdocument.background && textdocument.background.resource && textdocument.background.resource.identifier) {
                var currentPage = $scope.template.pages.page[$scope.template.pageI];
                var currentLevel = addLevel(currentPage);
                $scope.pageValue.textdocument = {
                    width: PxTurnMm(textGeo.width),
                    height: PxTurnMm(textGeo.height),
                    x: PxTurnMm(textGeo.x),
                    y: PxTurnMm(textGeo.y)
                }
                var angle = 0;
                if (textdocument.rotation.angle) {
                    angle = 360-textdocument.rotation.angle;
                }
                var resource = textdocument.background.resource;
                var scale = 1;
                if (textdocument.background.adaptation == "Height") {
                    scale = textdocument.background.width / textdocument.geometry.width;
                }
                currentLevel.imageart = ({
                    geometry: {
                        width: textdocument.geometry.width,
                        height: textdocument.geometry.height,
                        x: textdocument.geometry.x,
                        y: textdocument.geometry.y
                    },
                    rotation: {
                        angle: angle
                    },
                    // 模板使用，微信端不可进行操作
                    // type: 'static',
                    resource: {
                        identifier: resource.identifier,
                        provider: 'qiniu',
                        width: resource.width,
                        height: resource.height
                    },
                    scale: scale,
                    offsetx: textdocument.background.offsetx,
                    offsety: textdocument.background.offsety,
                    transparency: 1,
                    onlyshow: false,
                    movable: textdocument.movable,
                    editable: textdocument.editable,
                    bgImg: '',
                    unit: 'mm',
                    // index: currentPage.imagearts.imageart.length,
                    levelI: $scope.template.levelI,
                    pageI: $scope.template.pageI,
                    current: 'imageart',
                    lock: false
                });

                $scope.selectBox = currentLevel.imageart;
            }
            angular.forEach(textdocument.levels.level, function (level, i) {
                if (level.imageart) {
                    var rotateCenter = rotatePoint(
                        {
                            x:(level.imageart.geometry.x + textGeo.x + level.imageart.geometry.width * 0.5) ,
                            y:(level.imageart.geometry.y + textGeo.y + level.imageart.geometry.height * 0.5)
                        },
                        {
                            x:textGeo.x + textGeo.width * 0.5,
                            y:textGeo.y + textGeo.height *0.5
                        },
                        angle
                    )
                    var currentPage = $scope.template.pages.page[$scope.template.pageI];
                    var currentLevel = addLevel(currentPage);
                    var resource = level.imageart.resource;
                    currentLevel.imageart = ({
                        geometry: {
                            width: level.imageart.geometry.width,
                            height: level.imageart.geometry.height,
                            x: rotateCenter.x - level.imageart.geometry.width * 0.5,
                            y: rotateCenter.y - level.imageart.geometry.height * 0.5
                        },
                        rotation: {
                            angle:angle + level.imageart.rotation.angle
                        },
                        // 模板使用，微信端不可进行操作
                        type: 'static',
                        resource: {
                            identifier: resource.identifier,
                            provider: 'qiniu',
                            width: resource.width,
                            height: resource.height
                        },
                        scale: level.imageart.scale,
                        offsetx: level.imageart.offsetx,
                        offsety: level.imageart.offsety,
                        transparency: level.imageart.transparency,
                        onlyshow: false,
                        movable: textdocument.movable,
                        editable: textdocument.editable,
                        bgImg: '',
                        unit: 'mm',
                        // index: currentPage.imagearts.imageart.length,
                        levelI: $scope.template.levelI,
                        pageI: $scope.template.pageI,
                        current: 'imageart',
                        lock: false
                    });
                }
                if (level.textbox) {
                    var rotateCenter = rotatePoint(
                        {
                            x:(level.textbox.geometry.x + textGeo.x + level.textbox.geometry.width * 0.5) ,
                            y:(level.textbox.geometry.y + textGeo.y + level.textbox.geometry.height * 0.5)
                        },
                        {
                            x:textGeo.x + textGeo.width * 0.5,
                            y:textGeo.y + textGeo.height *0.5
                        },
                        angle
                    );
                    var currentPage = $scope.template.pages.page[$scope.template.pageI];
                    var currentLevel = addLevel(currentPage);
                    currentLevel.textbox = angular.copy(level.textbox);
                    currentLevel.textbox.movable = textdocument.movable;
                    currentLevel.textbox.editable = textdocument.editable;
                    currentLevel.textbox.unit = 'mm';
                    currentLevel.textbox.rotation.angle = angle + currentLevel.textbox.rotation.angle;
                    currentLevel.textbox.levelI = $scope.template.levelI;
                    currentLevel.textbox.pageI = $scope.template.pageI;
                    currentLevel.textbox.current = 'textbox';
                    currentLevel.textbox.lock = false;
                    currentLevel.textbox.geometry.x =  rotateCenter.x - level.textbox.geometry.width * 0.5;
                    currentLevel.textbox.geometry.y = rotateCenter.y - level.textbox.geometry.height * 0.5;
                    fontStyle(currentLevel.textbox);
                }
            })
            updateHistorys();
            $scope.currentPage = currentPage;
            $scope.RightPanel = 'material';
            $scope.template.transparency = 100;

        }

        //文本框点击时
        $scope.selectText = function (e, $index, text) {
            if(vm.textEditor){return}
            fn(e);

            angular.forEach(vm.fontList, function (list) {
                if (list.fontuuid == text.fontuuid) {
                    $scope.item = list
                }
            })

            $scope.template.text = text.text;
            $scope.size = text.style.size;
            $scope.template.angle = text.rotation.angle;

            fontStyle(text,true);
            if (vm.unit == 'mm') {
                $scope.pageValue.textbox = {
                    width: PxTurnMm(text.geometry.width).toFixed(2) - 0,
                    height: PxTurnMm(text.geometry.height).toFixed(2) - 0,
                    x: PxTurnMm(text.geometry.x).toFixed(2) - 0,
                    y: PxTurnMm(text.geometry.y).toFixed(2) - 0
                }
            } else if (vm.unit == 'px') {
                $scope.pageValue.textbox = {
                    width: text.geometry.width,
                    height: text.geometry.height,
                    x: text.geometry.x,
                    y: text.geometry.y
                }
            } else if (vm.unit == 'in') {
                $scope.pageValue.textbox = {
                    width: PxTurnIn(text.geometry.width).toFixed(2) - 0,
                    height: PxTurnIn(text.geometry.height).toFixed(2) - 0,
                    x: PxTurnIn(text.geometry.x).toFixed(2) - 0,
                    y: PxTurnIn(text.geometry.y).toFixed(2) - 0
                }
            }
            $scope.template.angle = text.rotation.angle;
            vm.text = text.text;

            $scope.template.letterspacing = text.style.letterspacing;
            $(".block-width").css({left: text.style.letterspacing});
            $scope.template.lineheight = text.style.lineheight;
            $(".block-height").css({left: text.style.lineheight});

            text.current = 'textbox';
            $scope.selectBox = text;

            //如果是按住ctrl键 实现多选复制
            if (e.ctrlKey == true || e.metaKey == true) {
                text.ctrlKey = true;
                text.levelI = $index;
                vm.CtrlKeyArray.textboxes[$index] = angular.copy(text);
                ctrlAddSingleArray();
                $scope.RightPanel = 'all';
            } else {
                if (!text.ctrlKey) {
                    $scope.clearCtrlKey();
                    vm.singleArray = {imagebox: {}, textbox: {}, imageart: {}, barcode: {}, qrcode: {}, calMonthBox: {}, calTitleBox: {}};
                }
                vm.singleArray.textbox = angular.copy(text);
                $scope.RightPanel = 'text';
            }
            $("#menus").fadeOut();
            $scope.template.levelI = $index;
            // $scope.selPanel = 'text';

            vm.selectElementCopy = angular.copy($scope.currentPage.levels.level[$scope.template.levelI]);
        };
        $scope.selectTextDocFont = function (e, levelIndex, docIndex, text) {
            fn(e);
            $scope.template.levelI = levelIndex;
            $scope.template.docI = docIndex;
            vm.textDocCon = text.text;

            $("#menus").fadeOut();
        };
        vm.textEditor = false;
        $scope.doubleClicktext = function (e, item) {
            fn(e);
            if (item.lock || vm.textEditor) {
                return
            }
            $timeout(function () {
                vm.textEditor = $scope.currentPage.levels.level[$scope.template.levelI].textbox;
                var span = $(e.target).parents('.c-xml-page-textboxe').find('span');
                span[0].innerHTML = '';
                span.focus();
                span[0].innerHTML = item.text;
                $(span[0]).css({'cursor':'text'});
                span[0].setAttribute("contenteditable", "true");

                if (document.selection) {
                    var range = document.body.createTextRange();
                    range.moveToElementText(span[0]);
                    range.select();
                } else if (window.getSelection) {
                    var range = document.createRange();
                    range.selectNodeContents(span[0]);
                    window.getSelection().removeAllRanges();
                    window.getSelection().addRange(range);
                }
            })
        }
        //去除所有html标签，只保留文字
        var textReg=/<\/?.+?\/?>/g;
        // 过滤style行内标签
        var textReg1=/ style\s*?=\s*?(['"])[\s\S]*?\1/g;
        $scope.textBlur = function (e, item, i) {
            fn(e);
            $timeout(function () {
                $(e.target).css({'cursor':'pointer'});
                $(e.target).attr({'contenteditable':'false'});
                item.text = angular.copy($(e.target).text());
                item.text = item.text.replace(/&nbsp;/g,' ').replace(textReg1,'').replace(/<br>/g,'\n').replace(textReg,'');
                item.characterWarning = false;
                item.characterMessage = "";
                FontManagement.fontSupport({
                    uuid: item.fontuuid,
                    bold: item.style.bold,
                    italic: item.style.italic,
                    content: item.text
                }, function (res) {
                    var msg = res.message;
                    if (res.status == 200) {
                        item.success = msg.success;
                        if (!msg.success) {
                            MessageService.error("当前字体不可用，请更换字体");
                            return
                        }
                        if (msg.success && !msg.supported) {
                            var message = "【" + msg.failed + "】" + "当前字体不支持这些文字！";
                            MessageService.error(message);
                            item.characterWarning = true;
                            item.characterMessage = message;
                        }
                        getTextHeight($scope.currentPage.levels.level[$scope.template.levelI].textbox);
                        vm.textEditor = false;
                    }
                })
            })
        }
        $scope.changeHeight = function(e,item){
            if(vm.textEditor){
                $scope.currentPage.levels.level[$scope.template.levelI].textbox.text = $(e.target).text();
                $scope.currentPage.levels.level[$scope.template.levelI].textbox.text = vm.textEditor.text.replace(/&nbsp;/g,' ').replace(textReg1,'').replace(/<br>/g,'\n').replace(textReg,'');
                getTextHeight($scope.currentPage.levels.level[$scope.template.levelI].textbox);
                console.log($scope.currentPage.levels.level[$scope.template.levelI].textbox.geometry.height);
            }
            fn(e)
        }
        // var a = null;
        $scope.updateTextSize = function (value) {
            // if (a !== null) {
            //     clearTimeout(a)
            // }
            // a = setTimeout(function () {
            //     $timeout(function () {
            //         var text = $scope.template.pages.page[$scope.template.pageI].levels.level[$scope.template.levelI].textbox;
            //         if (text.lock) {
            //             return
            //         }
            //         var sizeValue = value <= 6 ? 6 : value;
            //         text.style.size = sizeValue;
            //         text.style.lineheight = $scope.template.lineheight = sizeValue;
            //         sizeHeight();
            //         updateHistorys();
            //     })
            // },500)
            $timeout(function () {
                var text = $scope.template.pages.page[$scope.template.pageI].levels.level[$scope.template.levelI].textbox;
                if (text.lock) {
                    return
                }
                var sizeValue = value <= 6 ? 6 : value;
                text.style.size = sizeValue;
                text.style.lineheight = $scope.template.lineheight = sizeValue;
                if(text.geometry.width < ptToPx(text.style.size)){
                    text.geometry.width = ptToPx(text.style.size)+10;
                }
                $scope.template.pages.page[$scope.template.pageI].levels.level[$scope.template.levelI].textbox = angular.copy(text);
                sizeHeight();
                updateHistorys();
            })
        };

        function fontStyle(font,isSelect) {
            var _fontStyle = [];
            for (var i = 0; i < vm.fontList.length; i++) {
                if (vm.fontList[i].uuid == font.fontuuid) {
                    for (var j = 0; j < vm.fontList[i].fontStyles.length; j++) {
                        _fontStyle.push(vm.fontList[i].fontStyles[j].style)
                    }
                }
            }
            font.fontStyle = _fontStyle;
            font.style.bold1 = false;
            font.style.italic1 = false;
            if(!isSelect){
                if (_fontStyle.indexOf('NORMAL') != '-1') {
                    font.style.normal = true;
                    font.style.bold = false;
                    font.style.italic = false;
                } else {
                    font.style.normal = false;
                    if (_fontStyle.indexOf('BOLD_ITALIC') != '-1') {
                        font.style.bold = true;
                        font.style.italic = true;
                    } else {
                        if (_fontStyle.indexOf('ITALIC') != '-1') {
                            font.style.bold = false;
                            font.style.italic = true;
                        }
                        if (_fontStyle.indexOf('BOLD') != '-1') {
                            font.style.bold = true;
                            font.style.italic = false;
                        }
                    }
                }
            }
            if (_fontStyle.indexOf('BOLD_ITALIC') != '-1') {
                font.style.bold1 = true;
                font.style.italic1 = true;
            } else {
                if (_fontStyle.indexOf('ITALIC') != '-1') {
                    font.style.italic1 = true;
                }
                if (_fontStyle.indexOf('BOLD') != '-1') {
                    font.style.bold1 = true;
                }
            }
        }

        //文字放大缩小
        var isTextDown = false;
        $scope.textboxZoomRight = function ($event, item, pro, index) {
            fn($event)
            editorBoxZoom($event, item, 'right', pro, $($event.target).parents('.selected'), function (it) {
                sizeHeight();
                $scope.$apply();
            }, function (it) {
            });
        }
        $scope.textboxZoomLeft = function ($event, item, pro, index) {
            fn($event)
            editorBoxZoom($event, item, 'left', pro, $($event.target).parents('.selected'), function (it) {
                sizeHeight();
                $scope.$apply();
            }, function (it) {
            });
        }
        $scope.textboxZoomTop = function ($event, item, pro, index) {
            fn($event)
            editorBoxZoom($event, item, 'top', pro, $($event.target).parents('.selected'), function (it) {
                sizeHeight();
                $scope.$apply();
            }, function (it) {
            });
        }
        $scope.textboxZoomBottom = function ($event, item, pro, index) {
            fn($event)
            editorBoxZoom($event, item, 'bottom', pro, $($event.target).parents('.selected'), function (it) {
                sizeHeight();
                $scope.$apply();
            }, function (it) {
            });
        }
        $scope.textboxZoomLeft1 = function ($event, item, pro, index) {
            fn($event)
            editorBoxZoom($event, item, 'leftTop', pro, $($event.target).parents('.selected'), function (it) {
                sizeHeight();
                $scope.$apply();
            }, function (it) {
            });
        };
        $scope.textboxZoomTop1 = function ($event, item, pro, index) {
            fn($event)
            editorBoxZoom($event, item, 'rightTop', pro, $($event.target).parents('.selected'), function (it) {
                sizeHeight();
                $scope.$apply();
            }, function (it) {
            });
        };
        $scope.textboxZoomRight1 = function ($event, item, pro, index) {
            fn($event)
            editorBoxZoom($event, item, 'rightBottom', pro, $($event.target).parents('.selected'), function (it) {
                sizeHeight();
                $scope.$apply();
            }, function (it) {
            });
        };
        $scope.textboxZoomBottom1 = function ($event, item, pro, index) {
            fn($event)
            editorBoxZoom($event, item, 'leftBottom', pro, $($event.target).parents('.selected'), function (it) {
                sizeHeight();
                $scope.$apply();
            }, function (it) {
            });
        };


        vm.selectFont = '';
        vm.selectFontBtn = fontInit;
        vm.selectFontName = selectFontName;

        //获取字体
        vm.chineseSupport = true;
        fontInit(function () {
            vm.fontList1 = angular.copy(vm.fontList);
            $scope.item = vm.fontList[0];
        })
        function fontInit(callback) {
            if (a !== null) {
                clearTimeout(a)
            }
            a = setTimeout(function () {
                vm.fontList = [];
                FontManagement.getAll3({family: vm.selectFont}, function (res) {
                    vm.fontList = res;
                    if(callback){callback()}
                });
                $scope.$apply();
            },800)
        }

        vm.fontList1 = [];

        function selectFontName(item) {
            if (item) {
                for (var i = 0; i < vm.fontList1.length; i++) {
                    if (vm.fontList1[i].uuid == item) {
                        return vm.fontList1[i].family
                    }
                }
            }
        }

        $scope.updateTextFont = function (data) {
            if(vm.textEditor){return}
            if (data == undefined) {
                MessageService.error("文字添加失败，请上传字体!");
                return
            }
            if (!data.enable) {
                MessageService.error("当前字体不可用，请更换字体");
                return
            }
            var text = $scope.template.pages.page[$scope.template.pageI].levels.level[$scope.template.levelI].textbox;
            if (text.lock) {
                return
            }
            FontManagement.fontSupport({
                uuid: data.uuid,
                bold: text.style.bold,
                italic: text.style.italic,
                content: text.text
            }, function (res) {
                var msg = res.message;
                if (res.status == 200) {
                    text.success = msg.success;
                    if (!msg.success) {
                        MessageService.error("当前字体不可用，请更换字体");
                        return
                    }
                    if (msg.success && !msg.supported) {
                        var message = "【" + msg.failed + "】" + "当前字体不支持这些文字！";
                        MessageService.error(message);
                    } else {
                        text.style.font = data.family;
                        text.fontuuid = data.uuid;
                        text.identifier = vm.url + data.fontStyles[0].identifier;
                        $scope.item = data;
                        fontStyle(text);
                        text.loading = true;
                        getFont(text,FontManagement,function () {
                            text.loading = false;
                        });
                        sizeHeight()
                        text.characterWarning = false;
                        text.characterMessage = "";
                        updateHistorys();
                    }
                } else {
                    MessageService.error("检查字体字符异常");
                }
            })
        };

        $scope.showTextSpacing = function () {
            $(".space-slider").toggleClass('hide1');
            $(".nav_spacing").toggleClass('nav-spacing-active');
            $scope.isAlignHover = false;
            $scope.isDistriHover = false;
            toobarFlag1 = true;
            toobarFlag2 = true;
        }

        // 字/行间距鼠标点击移动
        var spacingW = {};
        var flagSpacing = false
        window.resizeSpacingStart = function (e) {
            fn(e);
            var targ = e.target ? e.target : e.srcElement;
            spacingW.clientX = e.clientX || 0;
            spacingW.originLeft = targ.offsetLeft;
            spacingW.value = targ.dataset.value;
            var text = $scope.template.pages.page[$scope.template.pageI].levels.level[$scope.template.levelI].textbox;
            if (text.lock) {
                return
            }
            flagSpacing = true;
            document.addEventListener("mousemove", resizeSpacingOn, true);
            document.addEventListener("mouseup", resizeSpacingEnd, true);
        }

        function resizeSpacingOn(e) {
            if (flagSpacing) {
                var text = $scope.template.pages.page[$scope.template.pageI].levels.level[$scope.template.levelI].textbox;
                var l = spacingW.originLeft + e.clientX - spacingW.clientX;
                if (spacingW.value == 'height' && l < text.style.size / 2) {
                    l = text.style.size / 2;
                } else if (spacingW.value == 'width' && l < 0) {
                    l = 0;
                }
                if (l > 110) {
                    l = 110
                }
                if (spacingW.value == 'width') {
                    $(".block-width").css({left: l});
                    text.style.letterspacing = $scope.template.letterspacing = l;
                } else {
                    $(".block-height").css({left: l});
                    text.style.lineheight = $scope.template.lineheight = l;
                }
                sizeHeight();
                $scope.$digest();
            }
        }

        function resizeSpacingEnd() {
            spacingW = {}
            flagSpacing = false;
            updateHistorys();
            document.removeEventListener("mousemove", resizeSpacingOn, true);
            document.removeEventListener("mouseup", resizeSpacingEnd, true);
        }

        function fontEdit() {
            for (var i = 0; i < vm.data.textDocument.levels.level.length; i++) {
                var _font = vm.data.textDocument.levels.level[i].textbox;
                if (_font.selected) {
                    _font = vm.font;
                    break;
                }
            }
        }

        //字体family
        $scope.operationFontFamily = function () {
            getFont(vm.font,FontManagement)
            fontEdit()
        }

        function sizeHeight(){
            $timeout(function () {
                if($scope.currentPage && $scope.currentPage.levels.level && $scope.currentPage.levels.level[$scope.template.levelI] && $scope.currentPage.levels.level[$scope.template.levelI].textbox){
                    getTextHeight($scope.currentPage.levels.level[$scope.template.levelI].textbox);
                }
                // if($scope.selectBox && $scope.selectBox.current == 'textbox'){
                //     var _h = Number($("#c-xml-page-material-fontId1").height()) + Number(10);
                //     var _w = Number($("#c-xml-page-material-fontId1").width()) + Number(10);
                //     if(!writingmodeInit($scope.selectBox.style.writingmode)){
                //         $scope.selectBox.geometry.height = _h;
                //     }
                //     if(writingmodeInit($scope.selectBox.style.writingmode)){
                //         $scope.selectBox.geometry.width = _w;
                //     }
                //     $scope.currentPage.levels.level[$scope.template.levelI].textbox = $scope.selectBox;
                //     $scope.$apply();
                // }
            })
        }
        function sizeHeight1(callback) {
            if (vm.textEditor) {
                $timeout(function () {
                    var _h = Number($("#c-xml-page-material-fontId2").height()) + Number(10);
                    var _w = Number($("#c-xml-page-material-fontId2").width()) + Number(10);
                    if(!writingmodeInit(vm.textEditor.style.writingmode)){
                        vm.textEditor.geometry.height = _h;
                    }
                    if(writingmodeInit(vm.textEditor.style.writingmode)){
                        vm.textEditor.geometry.width = _w;
                    }
                    $scope.currentPage.levels.level[$scope.template.levelI].textbox = vm.textEditor;
                    if(callback){callback()};
                })
            }
        }

        $scope.writingmodeInit = writingmodeInit;

        function writingmodeInit(item) {
            if (item == 'vertical-lr' || item == 'vertical-rl') {
                return true
            } else {
                return false
            }
        }

        //横版
        $scope.textHengban = function () {
            var text = $scope.template.pages.page[$scope.template.pageI].levels.level[$scope.template.levelI].textbox;
            var text1 = angular.copy(text);
            text.style.writingmode = 'horizontal-tb';
            $timeout(function () {
                text.geometry.width = text1.geometry.height;
                text.geometry.height = text1.geometry.width;
            }, 200)
        }
        //竖版
        $scope.textShuban = function (item) {
            var text = $scope.template.pages.page[$scope.template.pageI].levels.level[$scope.template.levelI].textbox;
            var text1 = angular.copy(text);
            var _writingmode = angular.copy(text.style.writingmode);
            text.style.writingmode = item;
            $timeout(function () {
                if (!_writingmode || _writingmode == 'horizontal-tb') {
                    text.geometry.width = text1.geometry.height;
                    text.geometry.height = text1.geometry.width;
                }
            }, 200)
        }

        //字体
        $scope.operationFont = function () {
            fontEdit()
        }
        //斜体
        $scope.operationItalic = function () {
            var level = $scope.currentPage.levels.level[$scope.template.levelI];
            if (level.textbox && level.textbox.current) {
                if(level.textbox.style.italic){
                    if(level.textbox.fontStyle.indexOf('NORMAL') > -1){
                        level.textbox.style.italic = false;
                        if (level.textbox.fontStyle.indexOf('BOLD') == '-1') {
                            level.textbox.style.bold = false;
                        }
                    }else{
                        if(level.textbox.style.bold){
                            level.textbox.style.italic = false;
                        }
                    }
                }else{
                    if(level.textbox.fontStyle.indexOf('ITALIC') > -1){
                        level.textbox.style.italic = true;
                        if(level.textbox.style.bold){
                            if(level.textbox.fontStyle.indexOf('BOLD_ITALIC') == -1){
                                level.textbox.style.bold = false;
                            }
                        }else{
                            // if( level.textbox.fontStyle.indexOf('BOLD_ITALIC') > -1){
                            //     level.textbox.style.bold = true;
                            // }
                        }
                    }else if (level.textbox.fontStyle.indexOf('BOLD_ITALIC') > -1) {
                        level.textbox.style.bold = true;
                        level.textbox.style.italic = true;
                    }
                }
                $timeout(function () {
                    sizeHeight();
                    updateHistorys();
                },200)
            }
        }
        //粗体
        $scope.operationBold = function () {
            var level = $scope.currentPage.levels.level[$scope.template.levelI];
            if (level.textbox && level.textbox.current) {
                if(level.textbox.style.bold){
                    if(level.textbox.fontStyle.indexOf('NORMAL') > -1){
                        level.textbox.style.bold = !level.textbox.style.bold;
                        if (level.textbox.fontStyle.indexOf('ITALIC') == '-1') {
                            level.textbox.style.italic = level.textbox.style.bold;
                        }
                    }else{
                        if(level.textbox.style.italic){
                            level.textbox.style.bold = !level.textbox.style.bold;
                        }
                    }
                }else{
                    if(level.textbox.fontStyle.indexOf('BOLD') > -1){
                        level.textbox.style.bold = true;
                        if(level.textbox.style.italic){
                            if(level.textbox.fontStyle.indexOf('BOLD_ITALIC') == -1){
                                level.textbox.style.italic = false;
                            }
                        }else{
                            // if( level.textbox.fontStyle.indexOf('BOLD_ITALIC') > -1){
                            //     level.textbox.style.italic = true;
                            // }
                        }
                    }else if (level.textbox.fontStyle.indexOf('BOLD_ITALIC') > -1) {
                        level.textbox.style.bold = true;
                        level.textbox.style.italic = true;
                    }
                }
                $timeout(function () {
                    sizeHeight();
                    updateHistorys();
                },200)
            }
        }
        //间距
        vm.isOperationSpacing = false
        $scope.operationSpacing = function ($event) {
            if (!vm.isOperationSpacing) {
                toolbarStatus();
            }
            vm.isOperationSpacing = !vm.isOperationSpacing;
            var $event = $event || window.event;
            //防止浏览器默认行为(W3C)
            if($event && $event.preventDefault){
                $event.preventDefault();
            }
            //IE中组织浏览器行为
            else {
                window.event.returnValue = false;
                return false;
            }
            $event.stopPropagation();
        }
        $scope.changeLetterspacing = function(){
            // if (a !== null) {
            //     clearTimeout(a)
            // }
            // a = setTimeout(function () {
            //     $timeout(function () {
            //         sizeHeight();
            //         updateHistorys();
            //     })
            // },500)
            $timeout(function () {
                $scope.currentPage.levels.level[$scope.template.levelI].textbox.style.letterspacing = angular.copy(vm.selectElementCopy.textbox.style.letterspacing);
                sizeHeight();
                updateHistorys();
            })
        }
        $scope.changeLineheight = function() {
            // if (a !== null) {
            //     clearTimeout(a)
            // }
            // a = setTimeout(function () {
            //     $timeout(function () {
            //         if($scope.currentPage.levels.level[$scope.template.levelI].textbox.style.lineheight < $scope.currentPage.levels.level[$scope.template.levelI].textbox.style.size){
            //             $scope.currentPage.levels.level[$scope.template.levelI].textbox.style.lineheight = $scope.currentPage.levels.level[$scope.template.levelI].textbox.style.size;
            //         }
            //         sizeHeight();
            //         updateHistorys();
            //     })
            // },500)
            $timeout(function () {
                if(vm.selectElementCopy.textbox.style.lineheight < $scope.currentPage.levels.level[$scope.template.levelI].textbox.style.size){
                    vm.selectElementCopy.textbox.style.lineheight = $scope.currentPage.levels.level[$scope.template.levelI].textbox.style.size;
                }
                $scope.currentPage.levels.level[$scope.template.levelI].textbox.style.lineheight = angular.copy(vm.selectElementCopy.textbox.style.lineheight);
                sizeHeight();
                updateHistorys();
            })
        }

        $scope.lineWidthChange = function(){
            $scope.currentPage.levels.level[$scope.template.levelI].imagebox.border.lineWidth = vm.selectElementCopy.imagebox.border.lineWidth;
        }

        function debounce(fn, wait) {
            var timer = null;
            return function () {
                if (timer !== null) {
                    clearTimeout(timer);
                }
                timer = setTimeout(function () {
                    fn()
                }, wait);
            }
        }

        // 画布对齐操作
        vm.isAlign = false;
        $scope.alignHover2 = function(attr){
            toolbarStatus();
            vm.isAlign = attr;
        }

        //对齐点击
        vm.isOperationDir = false
        $scope.operationDir = function () {
            if (!vm.isOperationDir) {
                toolbarStatus();
            }
            vm.isOperationDir = !vm.isOperationDir;
        }

        //左对齐
        $scope.operationBarLeft = function ($event) {
            var level = $scope.currentPage.levels.level[$scope.template.levelI];
            if (level.textbox && level.textbox.current) {
                level.textbox.style.align = 'left';
            }
            vm.isOperationDir = false;
            updateHistorys();
        }
        //居中对齐
        $scope.operationBarCenter = function ($event) {
            var level = $scope.currentPage.levels.level[$scope.template.levelI];
            if (level.textbox && level.textbox.current) {
                level.textbox.style.align = 'center';
            }

            vm.isOperationDir = false;
            updateHistorys();
        }
        //右对齐
        $scope.operationBarRight = function ($event) {
            var level = $scope.currentPage.levels.level[$scope.template.levelI];
            if (level.textbox && level.textbox.current) {
                level.textbox.style.align = 'right';
            }

            vm.isOperationDir = false;
            updateHistorys();
        }
        //两端对齐
        $scope.operationBarJustify = function ($event) {
            var level = $scope.currentPage.levels.level[$scope.template.levelI];
            if (level.textbox && level.textbox.current) {
                level.textbox.style.align = 'justify';
            }

            vm.isOperationDir = false;
            updateHistorys();
        }
        //颜色
        $scope.operationColorOpen = function ($event) {
            fn($event)
            vm.isOperationColor = !vm.isOperationColor;
        }

        $scope.operationColor = function (item) {
            var level = $scope.currentPage.levels.level[$scope.template.levelI];
            if (level.textbox && level.textbox.current) {
                level.textbox.style.color = item.id;
            }
            vm.textColor = null;
            updateHistorys();
        }

        $scope.chooseTextColor = function () {
            var level = $scope.currentPage.levels.level[$scope.template.levelI];
            level.textbox.style.color = vm.textColor;
            vm.textColor = null;
        }

        /* ==========================================================================
         条形码处理
         ========================================================================== */
        // 增加条形码
        $scope.addBarCode = function () {
            if(vm.textEditor){return}
            var currentPage = $scope.template.pages.page[$scope.template.pageI];
            if (currentPage.barcode && currentPage.barcode.geometry) {
                return
            }
            vm.unit = 'mm';

            currentPage.barcode = {
                rotation: {angle: 0},
                geometry: {
                    width: MmTurnPx(60),
                    height: MmTurnPx(30),
                    x: (currentPage.mediabox.width - MmTurnPx(60))/2,
                    y: (currentPage.mediabox.height - MmTurnPx(30))/2
                },
                zoom: 1,
                unit: 'mm',
                lock: false,
                current: 'barcode'
            };
            $scope.currentPage = currentPage;

            $scope.selectBox = currentPage.barcode;
            if (vm.unit == 'mm') {
                $scope.pageValue.barcode = {
                    width: 60,
                    height: 30,
                    x: 16,
                    y: 16
                }
            } else if (vm.unit == 'px') {
                $scope.pageValue.barcode = currentPage.barcode.geometry;
            } else if (vm.unit == 'in') {
                $scope.pageValue.barcode = {
                    width: PxTurnIn(currentPage.barcode.geometry.width),
                    height: PxTurnIn(currentPage.barcode.geometry.height),
                    x: PxTurnIn(currentPage.barcode.geometry.x),
                    y: PxTurnIn(currentPage.barcode.geometry.y)
                };
            }

            updateHistorys();
        };
        // 增加二维码
        $scope.addQrCode = function () {
            if(vm.textEditor){return}
            var currentPage = $scope.template.pages.page[$scope.template.pageI];
            if (currentPage.qrcode && currentPage.qrcode.geometry) {
                return
            }
            vm.unit = 'mm';

            currentPage.qrcode = {
                rotation: {angle: 0},
                geometry: {
                    width: MmTurnPx(60),
                    height: MmTurnPx(60),
                    x: (currentPage.mediabox.width - MmTurnPx(60))/2,
                    y: (currentPage.mediabox.height - MmTurnPx(60))/2
                },
                zoom: 1,
                unit: 'mm',
                lock: false,
                current: 'qrcode'
            };
            $scope.currentPage = currentPage;

            $scope.selectBox = currentPage.qrcode;
            if (vm.unit == 'mm') {
                $scope.pageValue.qrcode = {
                    width: 60,
                    height: 30,
                    x: 16,
                    y: 16
                }
            } else if (vm.unit == 'px') {
                $scope.pageValue.qrcode = currentPage.qrcode.geometry;
            } else if (vm.unit == 'in') {
                $scope.pageValue.qrcode = {
                    width: PxTurnIn(currentPage.qrcode.geometry.width),
                    height: PxTurnIn(currentPage.qrcode.geometry.height),
                    x: PxTurnIn(currentPage.qrcode.geometry.x),
                    y: PxTurnIn(currentPage.qrcode.geometry.y)
                };
            }

            updateHistorys();
        };

        $scope.updateBarParameter = function (type) {
            var currentPage = $scope.template.pages.page[$scope.template.pageI];
            if (currentPage.barcode.lock) {
                return
            }
            if (type == 'width') {
                if ($scope.pageValue.barcode.width < 10) {
                    $scope.pageValue.barcode.width = 10;
                }
                // $scope.pageValue.barcode.height = $scope.pageValue.barcode.width/2;
            }
            if (type == 'height') {
                if ($scope.pageValue.barcode.height < 5) {
                    $scope.pageValue.barcode.height = 5;
                }
                // $scope.pageValue.barcode.width = $scope.pageValue.barcode.height*2;
            }

            if (vm.unit == 'mm') {
                currentPage.barcode.geometry = {
                    width: MmTurnPx($scope.pageValue.barcode.width),
                    height: MmTurnPx($scope.pageValue.barcode.height),
                    x: MmTurnPx($scope.pageValue.barcode.x),
                    y: MmTurnPx($scope.pageValue.barcode.y)
                }
            }
            if (vm.unit == 'px') {
                currentPage.barcode.geometry = {
                    width: $scope.pageValue.barcode.width,
                    height: $scope.pageValue.barcode.height,
                    x: $scope.pageValue.barcode.x,
                    y: $scope.pageValue.barcode.y
                }
            }
            if (vm.unit == 'in') {
                currentPage.barcode.geometry = {
                    width: InTurnPx($scope.pageValue.barcode.width),
                    height: InTurnPx($scope.pageValue.barcode.height),
                    x: InTurnPx($scope.pageValue.barcode.x),
                    y: InTurnPx($scope.pageValue.barcode.y)
                }
            }
            updateHistorys();
        };
        $scope.updateQrcodeParameter = function (item) {
            var currentPage = $scope.template.pages.page[$scope.template.pageI];
            if (currentPage.qrcode.lock) {
                return
            }
            if (item == 'width') {
                if ($scope.pageValue.qrcode.width < 10) {
                    $scope.pageValue.qrcode.width = 10
                }
                $scope.pageValue.qrcode.height = $scope.pageValue.qrcode.width;
            }
            if (item == 'height') {
                if ($scope.pageValue.qrcode.height < 10) {
                    $scope.pageValue.qrcode.height = 10
                }
                $scope.pageValue.qrcode.width = $scope.pageValue.qrcode.height;
            }

            if (vm.unit == 'mm') {
                currentPage.qrcode.geometry = {
                    width: MmTurnPx($scope.pageValue.qrcode.width),
                    height: MmTurnPx($scope.pageValue.qrcode.height),
                    x: MmTurnPx($scope.pageValue.qrcode.x),
                    y: MmTurnPx($scope.pageValue.qrcode.y)
                }
            }
            if (vm.unit == 'px') {
                currentPage.qrcode.geometry = {
                    width: $scope.pageValue.qrcode.width,
                    height: $scope.pageValue.qrcode.height,
                    x: $scope.pageValue.qrcode.x,
                    y: $scope.pageValue.qrcode.y
                }
            }
            if (vm.unit == 'in') {
                currentPage.qrcode.geometry = {
                    width: InTurnPx($scope.pageValue.qrcode.width),
                    height: InTurnPx($scope.pageValue.qrcode.height),
                    x: InTurnPx($scope.pageValue.qrcode.x),
                    y: InTurnPx($scope.pageValue.qrcode.y)
                }
            }
            updateHistorys();
        };

        //条形码点击时
        $scope.selectBar = function (e, currentPage, item) {
            fn(e);
            $scope.RightPanel = item;
            var barcode = currentPage[item];

            if (vm.unit == 'mm') {
                $scope.pageValue[item] = {
                    width: PxTurnMm(barcode.geometry.width).toFixed(2) - 0,
                    height: PxTurnMm(barcode.geometry.height).toFixed(2) - 0,
                    x: PxTurnMm(barcode.geometry.x).toFixed(2) - 0,
                    y: PxTurnMm(barcode.geometry.y).toFixed(2) - 0
                }
            } else if (vm.unit == 'px') {
                $scope.pageValue[item] = {
                    width: barcode.geometry.width,
                    height: barcode.geometry.height,
                    x: barcode.geometry.x,
                    y: barcode.geometry.y
                }
            } else if (vm.unit == 'in') {
                $scope.pageValue[item] = {
                    width: PxTurnIn(barcode.geometry.width).toFixed(2) - 0,
                    height: PxTurnIn(barcode.geometry.height).toFixed(2) - 0,
                    x: PxTurnIn(barcode.geometry.x).toFixed(2) - 0,
                    y: PxTurnIn(barcode.geometry.y).toFixed(2) - 0
                }
            }

            $scope.template.angle = currentPage[item].rotation.angle;
            barcode.current = item;
            $scope.selectBox = barcode;


            var mm = $scope.currentPage[item];
            //如果是按住ctrl键 实现多选复制
            if (e.ctrlKey == true || e.metaKey == true) {
                if (barcode.lock) {
                    return
                }
                mm.ctrlKey = true;
                vm.CtrlKeyArray[item][0] = angular.copy(mm);
                ctrlAddSingleArray();
            } else {
                mm.ctrlKey = false;
                $scope.clearCtrlKey();
                vm.singleArray = {imagebox: {}, textbox: {}, imageart: {}, barcode: {}, qrcode: {}, calMonthBox: {}, calTitleBox: {}};
                if (barcode.lock) {
                    return
                }
                vm.singleArray[item] = angular.copy(mm);
            }
            $("#menus").fadeOut();

        };

        //条形码移动事件
        var dragBar;
        var dragBarBox = {};
        window.moveBarcodeStart = function (e) {
            fn(e);
            var targ = e.currentTarget ? e.currentTarget : e.srcElement;
            dragBarBox.clientX = e.clientX || 0;
            dragBarBox.clientY = e.clientY || 0;
            dragBarBox.coordX = targ.offsetLeft;
            dragBarBox.coordY = targ.offsetTop;
            dragBar = true;
            var currentPage = $scope.template.pages.page[$scope.template.pageI];
            if (currentPage.barcode.lock) {
                return
            }
            var all = getAllCtrlKeyArray();
            if (all.length) {
                dragBarBox.ctrlKey = true;
            } else {
                dragBarBox.ctrlKey = false;
            }
            document.addEventListener("mousemove", moveBarcodeOn, true);
            document.addEventListener("mouseup", moveBarcodeOnEnd, true);
        };

        //条形码move事件
        function moveBarcodeOn(e) {
            $scope.$digest();
            e.stopPropagation();
            e.preventDefault();

            if (dragBar) {
                var currentPage = $scope.template.pages.page[$scope.template.pageI];

                var clientX = e.clientX - dragBarBox.clientX;
                var clientY = e.clientY - dragBarBox.clientY;

                var barOffsetX = (dragBarBox.coordX + clientX);
                var barOffsetY = (dragBarBox.coordY + clientY);
                var barWidth = currentPage.barcode.geometry.width * currentPage.scale / currentPage.proportion;
                var barHeight = currentPage.barcode.geometry.height * currentPage.scale / currentPage.proportion;
                var height = $scope.template.pages.page[$scope.template.pageI].height * currentPage.scale;
                var width = $scope.template.pages.page[$scope.template.pageI].width * currentPage.scale;
                var barcodeAngle = currentPage.barcode.rotation.angle;

                var lar = (currentPage.bloodPx.left + currentPage.bloodPx.right) * currentPage.scale / currentPage.proportion;
                var tab = (currentPage.bloodPx.top + currentPage.bloodPx.bottom) * currentPage.scale / currentPage.proportion;

                var barx = 0, bary = 0;

                //中心点
                var xcenter = barWidth / 2 + barOffsetX;
                var ycenter = barHeight / 2 + barOffsetY;


                if (barcodeAngle == 0) {
                    if (barOffsetX <= 0) {
                        barOffsetX = 0;
                    }

                    if (barOffsetX >= (width + lar - barWidth)) {
                        barOffsetX = width + lar - barWidth;
                    }
                    if (barOffsetY <= 0) {
                        barOffsetY = 0;
                    }

                    if (barOffsetY >= (height + tab - barHeight)) {
                        barOffsetY = height + tab - barHeight;
                    }

                    barx = barOffsetX / currentPage.scale * currentPage.proportion;
                    bary = barOffsetY / currentPage.scale * currentPage.proportion;
                } else {

                    if (xcenter <= 0) {
                        xcenter = 0;
                    }

                    if (xcenter >= (width + lar)) {
                        xcenter = width + lar;
                    }
                    if (ycenter <= 0) {
                        ycenter = 0;
                    }

                    if (ycenter >= (height + tab)) {
                        ycenter = height + tab;
                    }
                    barx = (xcenter - barWidth / 2) / currentPage.scale * currentPage.proportion;
                    bary = (ycenter - barHeight / 2) / currentPage.scale * currentPage.proportion;
                }

                currentPage.barcode.geometry.x = barx;
                currentPage.barcode.geometry.y = bary;

                if (vm.unit == 'mm') {
                    $scope.pageValue.barcode.x = PxTurnMm(barx).toFixed(2) - 0;//px-->mm
                    $scope.pageValue.barcode.y = PxTurnMm(bary).toFixed(2) - 0;//px-->mm
                } else if (vm.unit == 'px') {
                    $scope.pageValue.barcode.x = PxTurnMm(barx / 25.4 * vm.windowDpiW);
                    $scope.pageValue.barcode.y = PxTurnMm(barx / 25.4 * vm.windowDpiW);
                } else if (vm.unit == 'in') {
                    $scope.pageValue.barcode.x = PxTurnIn(barx).toFixed(2) - 0;
                    $scope.pageValue.barcode.y = PxTurnIn(bary).toFixed(2) - 0;
                }
            }
            return false;
        }

        //条形码鼠标松开
        function moveBarcodeOnEnd() {
            $scope.$digest();
            dragBar = false;
            document.removeEventListener("mousemove", moveBarcodeOn, true);
            document.removeEventListener("mouseup", moveBarcodeOnEnd, true);
            dragBarBox = {};
            updateHistorys();
        }

        window.moveBarcodeStart1 = function (e) {
            fn(e);
            var targ = e.currentTarget ? e.currentTarget : e.srcElement;
            dragBarBox.clientX = e.clientX || 0;
            dragBarBox.clientY = e.clientY || 0;
            dragBarBox.coordX = targ.offsetLeft;
            dragBarBox.coordY = targ.offsetTop;
            dragBar = true;
            var currentPage = $scope.template.pages.page[$scope.template.pageI];
            if (currentPage.barcode.lock) {
                return
            }
            var all = getAllCtrlKeyArray();
            if (all.length) {
                dragBarBox.ctrlKey = true;
            } else {
                dragBarBox.ctrlKey = false;
            }
            document.addEventListener("mousemove", moveBarcodeOn1, true);
            document.addEventListener("mouseup", moveBarcodeOnEnd1, true);
        };

        //条形码move事件
        function moveBarcodeOn1(e) {
            $scope.$digest();
            e.stopPropagation();
            e.preventDefault();

            if (dragBar) {
                var currentPage = $scope.template.pages.page[$scope.template.pageI];

                var clientX = e.clientX - dragBarBox.clientX;
                var clientY = e.clientY - dragBarBox.clientY;

                var barOffsetX = (dragBarBox.coordX + clientX);
                var barOffsetY = (dragBarBox.coordY + clientY);
                var barWidth = currentPage.barcode.geometry.width * currentPage.scale / currentPage.proportion;
                var barHeight = currentPage.barcode.geometry.height * currentPage.scale / currentPage.proportion;
                var height = $scope.template.pages.page[$scope.template.pageI].height * currentPage.scale;
                var width = $scope.template.pages.page[$scope.template.pageI].width * currentPage.scale;
                var barcodeAngle = currentPage.barcode.rotation.angle;

                var lar = (currentPage.bloodPx.left + currentPage.bloodPx.right) * currentPage.scale / currentPage.proportion;
                var tab = (currentPage.bloodPx.top + currentPage.bloodPx.bottom) * currentPage.scale / currentPage.proportion;

                var barx = 0, bary = 0;

                //中心点
                var xcenter = barWidth / 2 + barOffsetX;
                var ycenter = barHeight / 2 + barOffsetY;


                if (barcodeAngle == 0) {
                    if (barOffsetX <= 0) {
                        barOffsetX = 0;
                    }

                    if (barOffsetX >= (width + lar - barWidth)) {
                        barOffsetX = width + lar - barWidth;
                    }
                    if (barOffsetY <= 0) {
                        barOffsetY = 0;
                    }

                    if (barOffsetY >= (height + tab - barHeight)) {
                        barOffsetY = height + tab - barHeight;
                    }

                    barx = barOffsetX / currentPage.scale * currentPage.proportion / $scope.proportion;
                    bary = barOffsetY / currentPage.scale * currentPage.proportion / $scope.proportion;
                } else {

                    if (xcenter <= 0) {
                        xcenter = 0;
                    }

                    if (xcenter >= (width + lar)) {
                        xcenter = width + lar;
                    }
                    if (ycenter <= 0) {
                        ycenter = 0;
                    }

                    if (ycenter >= (height + tab)) {
                        ycenter = height + tab;
                    }
                    barx = (xcenter - barWidth / 2) / currentPage.scale * currentPage.proportion / $scope.proportion;
                    bary = (ycenter - barHeight / 2) / currentPage.scale * currentPage.proportion / $scope.proportion;
                }

                currentPage.barcode.geometry.x = barx;
                currentPage.barcode.geometry.y = bary;

                if (vm.unit == 'mm') {
                    $scope.pageValue.barcode.x = PxTurnMm(barx).toFixed(2) - 0;//px-->mm
                    $scope.pageValue.barcode.y = PxTurnMm(bary).toFixed(2) - 0;//px-->mm
                } else if (vm.unit == 'px') {
                    $scope.pageValue.barcode.x = PxTurnMm(barx / 25.4 * vm.windowDpiW);
                    $scope.pageValue.barcode.y = PxTurnMm(barx / 25.4 * vm.windowDpiW);
                } else if (vm.unit == 'in') {
                    $scope.pageValue.barcode.x = PxTurnIn(barx).toFixed(2) - 0;
                    $scope.pageValue.barcode.y = PxTurnIn(bary).toFixed(2) - 0;
                }
                // }
            }
            return false;
        }

        //条形码鼠标松开
        function moveBarcodeOnEnd1() {
            $scope.$digest();
            dragBar = false;
            document.removeEventListener("mousemove", moveBarcodeOn, true);
            document.removeEventListener("mouseup", moveBarcodeOnEnd, true);
            dragBarBox = {};
            updateHistorys();
        }

        //二维码移动事件
        var dragQrcodeTrue;
        var dragQrcode = {};
        window.moveQrcodeStart = function (e) {
            fn(e);
            var targ = e.currentTarget ? e.currentTarget : e.srcElement;
            dragQrcode.clientX = e.clientX || 0;
            dragQrcode.clientY = e.clientY || 0;
            dragQrcode.coordX = targ.offsetLeft;
            dragQrcode.coordY = targ.offsetTop;
            dragQrcodeTrue = true;
            var currentPage = $scope.template.pages.page[$scope.template.pageI];
            if (currentPage.qrcode.lock) {
                return
            }
            var all = getAllCtrlKeyArray();
            if (all.length) {
                dragQrcode.ctrlKey = true;
            } else {
                dragQrcode.ctrlKey = false;
            }
            document.addEventListener("mousemove", moveQrcodeOn, true);
            document.addEventListener("mouseup", moveQrcodeOnEnd, true);
        };

        //条形码move事件
        function moveQrcodeOn(e) {
            $scope.$digest();
            e.stopPropagation();
            e.preventDefault();

            if (dragQrcodeTrue) {
                var currentPage = $scope.template.pages.page[$scope.template.pageI];

                var clientX = e.clientX - dragQrcode.clientX;
                var clientY = e.clientY - dragQrcode.clientY;

                var barOffsetX = (dragQrcode.coordX + clientX);
                var barOffsetY = (dragQrcode.coordY + clientY);
                var barWidth = currentPage.qrcode.geometry.width * currentPage.scale / currentPage.proportion;
                var barHeight = currentPage.qrcode.geometry.height * currentPage.scale / currentPage.proportion;
                var height = $scope.template.pages.page[$scope.template.pageI].height * currentPage.scale;
                var width = $scope.template.pages.page[$scope.template.pageI].width * currentPage.scale;
                var qrcodeAngle = currentPage.qrcode.rotation.angle;

                var lar = (currentPage.bloodPx.left + currentPage.bloodPx.right) * currentPage.scale / currentPage.proportion;
                var tab = (currentPage.bloodPx.top + currentPage.bloodPx.bottom) * currentPage.scale / currentPage.proportion;

                var barx = 0, bary = 0;

                //中心点
                var xcenter = barWidth / 2 + barOffsetX;
                var ycenter = barHeight / 2 + barOffsetY;


                if (qrcodeAngle == 0) {
                    if (barOffsetX <= 0) {
                        barOffsetX = 0;
                    }

                    if (barOffsetX >= (width + lar - barWidth)) {
                        barOffsetX = width + lar - barWidth;
                    }
                    if (barOffsetY <= 0) {
                        barOffsetY = 0;
                    }

                    if (barOffsetY >= (height + tab - barHeight)) {
                        barOffsetY = height + tab - barHeight;
                    }

                    barx = barOffsetX / currentPage.scale * currentPage.proportion;
                    bary = barOffsetY / currentPage.scale * currentPage.proportion;
                } else {

                    if (xcenter <= 0) {
                        xcenter = 0;
                    }

                    if (xcenter >= (width + lar)) {
                        xcenter = width + lar;
                    }
                    if (ycenter <= 0) {
                        ycenter = 0;
                    }

                    if (ycenter >= (height + tab)) {
                        ycenter = height + tab;
                    }
                    barx = (xcenter - barWidth / 2) / currentPage.scale * currentPage.proportion;
                    bary = (ycenter - barHeight / 2) / currentPage.scale * currentPage.proportion;
                }

                currentPage.qrcode.geometry.x = barx;
                currentPage.qrcode.geometry.y = bary;

                if (vm.unit == 'mm') {
                    $scope.pageValue.qrcode.x = PxTurnMm(barx).toFixed(2) - 0;//px-->mm
                    $scope.pageValue.qrcode.y = PxTurnMm(bary).toFixed(2) - 0;//px-->mm
                } else if (vm.unit == 'px') {
                    $scope.pageValue.qrcode.x = PxTurnMm(barx / 25.4 * vm.windowDpiW);
                    $scope.pageValue.qrcode.y = PxTurnMm(barx / 25.4 * vm.windowDpiW);
                } else if (vm.unit == 'in') {
                    $scope.pageValue.qrcode.x = PxTurnIn(barx).toFixed(2) - 0;
                    $scope.pageValue.qrcode.y = PxTurnIn(bary).toFixed(2) - 0;
                }
            }
            return false;
        }

        //条形码鼠标松开
        function moveQrcodeOnEnd() {
            $scope.$digest();
            dragQrcode = false;
            document.removeEventListener("mousemove", moveQrcodeOn, true);
            document.removeEventListener("mouseup", moveQrcodeOnEnd, true);
            dragQrcode = {};
            updateHistorys();
        }

        window.moveQrcodeStart1 = function (e) {
            fn(e);
            var targ = e.currentTarget ? e.currentTarget : e.srcElement;
            dragQrcode.clientX = e.clientX || 0;
            dragQrcode.clientY = e.clientY || 0;
            dragQrcode.coordX = targ.offsetLeft;
            dragQrcode.coordY = targ.offsetTop;
            dragQrcodeTrue = true;
            var currentPage = $scope.template.pages.page[$scope.template.pageI];
            if (currentPage.qrcode.lock) {
                return
            }
            var all = getAllCtrlKeyArray();
            if (all.length) {
                dragQrcode.ctrlKey = true;
            } else {
                dragQrcode.ctrlKey = false;
            }
            document.addEventListener("mousemove", moveQrcodeOn1, true);
            document.addEventListener("mouseup", moveQrcodeOnEnd1, true);
        };

        //条形码move事件
        function moveQrcodeOn1(e) {
            $scope.$digest();
            e.stopPropagation();
            e.preventDefault();

            if (dragQrcodeTrue) {
                var currentPage = $scope.template.pages.page[$scope.template.pageI];

                var clientX = e.clientX - dragQrcode.clientX;
                var clientY = e.clientY - dragQrcode.clientY;

                var barOffsetX = (dragQrcode.coordX + clientX);
                var barOffsetY = (dragQrcode.coordY + clientY);
                var barWidth = currentPage.qrcode.geometry.width * currentPage.scale / currentPage.proportion;
                var barHeight = currentPage.qrcode.geometry.height * currentPage.scale / currentPage.proportion;
                var height = $scope.template.pages.page[$scope.template.pageI].height * currentPage.scale;
                var width = $scope.template.pages.page[$scope.template.pageI].width * currentPage.scale;
                var qrcodeAngle = currentPage.qrcode.rotation.angle;

                var lar = (currentPage.bloodPx.left + currentPage.bloodPx.right) * currentPage.scale / currentPage.proportion;
                var tab = (currentPage.bloodPx.top + currentPage.bloodPx.bottom) * currentPage.scale / currentPage.proportion;

                var barx = 0, bary = 0;

                //中心点
                var xcenter = barWidth / 2 + barOffsetX;
                var ycenter = barHeight / 2 + barOffsetY;


                if (qrcodeAngle == 0) {
                    if (barOffsetX <= 0) {
                        barOffsetX = 0;
                    }

                    if (barOffsetX >= (width + lar - barWidth)) {
                        barOffsetX = width + lar - barWidth;
                    }
                    if (barOffsetY <= 0) {
                        barOffsetY = 0;
                    }

                    if (barOffsetY >= (height + tab - barHeight)) {
                        barOffsetY = height + tab - barHeight;
                    }

                    barx = barOffsetX / currentPage.scale * currentPage.proportion / $scope.proportion;
                    bary = barOffsetY / currentPage.scale * currentPage.proportion / $scope.proportion;
                } else {

                    if (xcenter <= 0) {
                        xcenter = 0;
                    }

                    if (xcenter >= (width + lar)) {
                        xcenter = width + lar;
                    }
                    if (ycenter <= 0) {
                        ycenter = 0;
                    }

                    if (ycenter >= (height + tab)) {
                        ycenter = height + tab;
                    }
                    barx = (xcenter - barWidth / 2) / currentPage.scale * currentPage.proportion / $scope.proportion;
                    bary = (ycenter - barHeight / 2) / currentPage.scale * currentPage.proportion / $scope.proportion;
                }

                currentPage.qrcode.geometry.x = barx;
                currentPage.qrcode.geometry.y = bary;

                if (vm.unit == 'mm') {
                    $scope.pageValue.qrcode.x = PxTurnMm(barx).toFixed(2) - 0;//px-->mm
                    $scope.pageValue.qrcode.y = PxTurnMm(bary).toFixed(2) - 0;//px-->mm
                } else if (vm.unit == 'px') {
                    $scope.pageValue.qrcode.x = PxTurnMm(barx / 25.4 * vm.windowDpiW);
                    $scope.pageValue.qrcode.y = PxTurnMm(barx / 25.4 * vm.windowDpiW);
                } else if (vm.unit == 'in') {
                    $scope.pageValue.qrcode.x = PxTurnIn(barx).toFixed(2) - 0;
                    $scope.pageValue.qrcode.y = PxTurnIn(bary).toFixed(2) - 0;
                }
                // }
            }
            return false;
        }

        //条形码鼠标松开
        function moveQrcodeOnEnd1() {
            $scope.$digest();
            dragQrcode = false;
            document.removeEventListener("mousemove", moveQrcodeOn1, true);
            document.removeEventListener("mouseup", moveQrcodeOnEnd1, true);
            dragQrcode = {};
            updateHistorys();
        }

        /* ==========================================================================
         单位切换
         ========================================================================== */

        // mm---px
        function ThreeHundredDpi(attr1, attr2) {
            // Math.floor(px / 300 * 25.4)   (px--mm)
            // Math.ceil(mm / 25.4 * 300)   (mm---px)
            var px1 = parseFloat((attr1 / 25.4 * vm.windowDpiW - 0)).toFixed(2) - 0;
            var px2 = parseFloat((attr2 / 25.4 * vm.windowDpiH - 0)).toFixed(2) - 0;
            return {
                px1: px1,
                px2: px2
            }
        }

        // px---mm
        function ThreeHundredDpiToMm(attr1, attr2) {
            var mm1 = parseFloat((attr1 / vm.windowDpiW * 25.4 - 0)).toFixed(2) - 0;
            var mm2 = parseFloat((attr2 / vm.windowDpiH * 25.4 - 0)).toFixed(2) - 0;
            return {
                mm1: mm1,
                mm2: mm2
            }
        }


        /* ==========================================================================
         鼠标滑过事件
         ========================================================================== */

        $scope.isAlignHover = false;
        $scope.isDistriHover = false;
        var toobarFlag1 = true;
        var toobarFlag2 = true;
        $scope.toobarAlignment = function () {
            $(".space-slider").addClass('hide1');
            if (toobarFlag1) {
                $scope.isAlignHover = true;
                $scope.isDistriHover = false;
                toobarFlag1 = false;
                toobarFlag2 = true;
            } else {
                $scope.isAlignHover = false;
                toobarFlag1 = true;
            }
        }

        $scope.toolbarDistribution = function () {
            $(".space-slider").addClass('hide1');
            if (toobarFlag2) {
                $scope.isAlignHover = false;
                $scope.isDistriHover = true;
                toobarFlag2 = false;
                toobarFlag1 = true;
            } else {
                $scope.isDistriHover = false;
                toobarFlag2 = true;
            }
        }
        $scope.canvasMiddle = function () {
            var all = getAllCtrlKeyArray();
            if (all.length > 0) {
                for (var i = 0; i < all.length; i++) {
                    if (!all[i].lock) {
                        all[i].geometry.x = ($scope.template.pages.page[$scope.template.pageI].mediabox.width - all[i].geometry.width) / 2;
                        all[i].geometry.y = ($scope.template.pages.page[$scope.template.pageI].mediabox.height - all[i].geometry.height) / 2;
                    }
                }
                resetCtrlKeyArray();
                return;
            }
            if (vm.CtrlKeyArray.imageboxes.length > 1) {
                $scope.template.pages.page[$scope.template.pageI].levels.level.forEach(function (item) {
                    if (!item.imagebox.lock && item.imagebox.ctrlKey) {
                        item.imagebox.geometry.x = ($scope.template.pages.page[$scope.template.pageI].mediabox.width - item.imagebox.geometry.width) / 2;
                        item.imagebox.geometry.y = ($scope.template.pages.page[$scope.template.pageI].mediabox.height - item.imagebox.geometry.height) / 2;
                    }
                    item.imagebox.ctrlKey = false
                })
                vm.CtrlKeyArray.imageboxes = [];
                resetCtrlKeyArray();
                return
            }
            var item = null;
            if ($scope.template.pages.page[$scope.template.pageI].levels.level[$scope.template.levelI].textbox) {
                item = $scope.template.pages.page[$scope.template.pageI].levels.level[$scope.template.levelI].textbox;
            }
            if ($scope.template.pages.page[$scope.template.pageI].levels.level[$scope.template.levelI].textdocument) {
                item = $scope.template.pages.page[$scope.template.pageI].levels.level[$scope.template.levelI].textdocument;
            }
            if ($scope.template.pages.page[$scope.template.pageI].levels.level[$scope.template.levelI].imagebox) {
                item = $scope.template.pages.page[$scope.template.pageI].levels.level[$scope.template.levelI].imagebox;
            }
            if ($scope.template.pages.page[$scope.template.pageI].levels.level[$scope.template.levelI].imageart) {
                item = $scope.template.pages.page[$scope.template.pageI].levels.level[$scope.template.levelI].imageart;
            }
            if ($scope.template.pages.page[$scope.template.pageI].levels.level[$scope.template.levelI].calTitleBox) {
                item = $scope.template.pages.page[$scope.template.pageI].levels.level[$scope.template.levelI].calTitleBox;
            }
            if ($scope.template.pages.page[$scope.template.pageI].levels.level[$scope.template.levelI].calMonthBox) {
                item = $scope.template.pages.page[$scope.template.pageI].levels.level[$scope.template.levelI].calMonthBox;
            }
            if (item && !item.lock) {
                item.geometry.x = ($scope.template.pages.page[$scope.template.pageI].mediabox.width - item.geometry.width) / 2;
                item.geometry.y = ($scope.template.pages.page[$scope.template.pageI].mediabox.height - item.geometry.height) / 2;
            }
            resetCtrlKeyArray();
        };

        $scope.boxAlignment = function (attr) {
            var levels = $scope.currentPage.levels;
            var all = getAllCtrlKeyArray();

            if (attr == 'left') {
                all.sort(compare2('x', true));
            } else if (attr == 'right') {
                all.sort(compare2('x', false, 'width'));
            } else if (attr == 'top') {
                all.sort(compare2('y', true));
            } else if (attr == 'bottom') {
                all.sort(compare2('y', false, 'height'));
            }
            if (attr == 'vertical' && all.length > 0) {
                var verticalY = horizontalAndVerticalCenter(attr, all);
            }
            if (attr == 'standard' && all.length > 0) {
                var standardX = horizontalAndVerticalCenter(attr, all);
            }
            var bigBoxCoord = null;
            if(['left','right','top','bottom'].includes(attr)){
                bigBoxCoord = getAllElemCoord(all);
            }
            for (var i = 0; i < all.length; i++) {
                if (!all[i].lock) {
                    if (attr == 'left') {
                        var coord = getElemMoveCoord('left',bigBoxCoord,all[i]);
                        all[i].geometry.x = coord;

                    } else if (attr == 'right') {
                        var coord = getElemMoveCoord('right',bigBoxCoord,all[i]);
                        all[i].geometry.x = coord;

                    } else if (attr == 'top') {
                        var coord = getElemMoveCoord('top',bigBoxCoord,all[i]);
                        all[i].geometry.y = coord;

                    } else if (attr == 'bottom') {
                        var coord = getElemMoveCoord('bottom',bigBoxCoord,all[i]);
                        all[i].geometry.y = coord;

                    } else if (attr == 'vertical') {
                        all[i].geometry.y = verticalY - all[i].geometry.height / 2;
                    } else {
                        all[i].geometry.x = standardX - all[i].geometry.width / 2;
                    }


                    if (all[i].current == 'imagebox') {
                        levels.level[all[i].levelI].imagebox = all[i];
                    } else if (all[i].current == 'textbox') {
                        levels.level[all[i].levelI].textbox = all[i];
                    } else if (all[i].current == 'calMonthBox') {
                        levels.level[all[i].levelI].calMonthBox = all[i];
                    } else if (all[i].current == 'calTitleBox') {
                        levels.level[all[i].levelI].calTitleBox = all[i];
                    } else {
                        levels.level[all[i].levelI].imageart = all[i];
                    }
                }
            }
            // moveTogetherEnd();
            updateHistorys();
            resetCtrlKeyArray();

        }

        $scope.boxDistribution = function (attr) {
            var all1 = getAllCtrlKeyArray();
            var all = [];
            all1.forEach(function(box){
                if (!box.lock) {
                    all.push(box)
                }
            })
            if (all.length < 3) {
                MessageService.error('请选择3个以上非锁定状态的元素！');
                return
            }

            // 水平分布
            if (attr == 'standard') {
                setAllCtrlKeyArray(all, 'x');
            } else {
                // 垂直分布
                setAllCtrlKeyArray(all, 'y');

            }
            resetCtrlKeyArray();
            updateHistorys();
        }

        function setAllCtrlKeyArray(all, attr) {
            var len = all.length - 1;
            all.sort(compare2(attr, true));
            if (attr == 'x') {
                var elementAllWidth = 0;
                for (var i = 1; i < len; i++) {
                    elementAllWidth+=all[i].geometry.width;
                }
                var spacingPx = (all[len].geometry.x - all[0].geometry.x - all[0].geometry.width - elementAllWidth) / len;
                for (var i = 1; i < len; i++) {
                    all[i].geometry.x = all[i-1].geometry.x + all[i-1].geometry.width + spacingPx;
                }
            }
            if (attr == 'y') {
                var elementAllHeight = 0;
                for (var i = 1; i < len; i++) {
                    elementAllHeight+=all[i].geometry.height;
                }
                var spacingPx = (all[len].geometry.y - all[0].geometry.y - all[0].geometry.height - elementAllHeight) / len;
                for (var i = 1; i < len; i++) {
                    all[i].geometry.y = all[i-1].geometry.y + all[i-1].geometry.height + spacingPx;
                }
            }
        }
        //移动画布
        vm.moveCanvasView = false;
        canvasInfo();
        function canvasInfo(){
            vm.moveCanvasObj = {
                x:0,
                y:0
            };
        }
        $scope.moveCanvas = function(e){
            if(!vm.moveCanvasView){
                return
            }
            var _moveCanvasObj = angular.copy(vm.moveCanvasObj);

            moveCanvas(e, function (x, y) {
                vm.moveCanvasObj.x = _moveCanvasObj.x + x;
                vm.moveCanvasObj.y = _moveCanvasObj.y + y;
                $timeout(function () {
                    updateMeasureRuler();
                    $scope.$apply();
                })

            })
        }

        /**
         *
         * 自定义元素右键菜单样式  复制、剪切、删除
         *
         */
        document.onkeydown = function (event) {
            // document.getElementById('#input')==document.activeElement
            var focus = false;
            document.querySelectorAll('input[type="text"]').forEach(function(input){
                if(input == document.activeElement){
                    focus = true;
                }
            })
            document.querySelectorAll('input[type="number"]').forEach(function(input){
                if(input == document.activeElement){
                    focus = true;
                }
            })
            document.querySelectorAll('textarea').forEach(function(textarea){
                if(textarea == document.activeElement){
                    focus = true;
                }
            })
            if(focus || vm.textEditor){
                return
            }
            // fn(event);
            if(event.keyCode == 32 && !vm.textEditor){
                $timeout(function () {
                    vm.moveCanvasView = true;
                })
                return false
            }
            if (event.keyCode == 13) {
                if (vm.isImageartTrim) {
                    $scope.imageartTrimTrueClick();
                    return false;
                }
                if (vm.isImageboxTrim) {
                    $scope.imageboxTrueClick();
                    return false;
                }
                if ($scope.showCut) {
                    $scope.showCut = false;
                    return false;
                }
            }
            //F11
            if (event.keyCode===122 && !vm.isFullScreen) {
                event.preventDefault();
                $scope.fullScreen();
            }
            $timeout(function () {
                vm.ctrlKey = true;
                if (event.keyCode == 27) {
                    if (vm.fullFlag) {
                        vm.fullFlag = false;
                    }
                    $scope.showCut = false;
                    vm.isImageartTrim = false;
                    $scope.imageboxFalseClick();
                }
                // 删除
                if (event.keyCode == 46) {
                    $scope.deleteBox();
                    $scope.$digest();
                }
                // ctrl+c
                if ((event.ctrlKey == true || event.metaKey == true) && event.keyCode == 67) {
                    if (event.target.nodeName == 'TEXTAREA') {
                        return
                    }

                    if(vm.CtrlKeyArray.imageboxes.length||vm.CtrlKeyArray.imagearts.length||vm.CtrlKeyArray.textboxes.length||vm.CtrlKeyArray.calMonthBoxs.length||vm.CtrlKeyArray.calTitleBoxs.length){
                        vm.copyArray = angular.copy(vm.CtrlKeyArray);
                    }
                }
                //ctrl+v
                if ((event.ctrlKey == true || event.metaKey == true) && event.keyCode == 86) {
                    if (event.target.nodeName == 'TEXTAREA') {
                        return
                    }
                    var currentPage = $scope.currentPage;
                    if(!vm.copyArray || vm.loadingImg){
                        return
                    }
                    if(vm.copyArray.imageboxes.length||vm.copyArray.imagearts.length||vm.copyArray.textboxes.length||vm.copyArray.calMonthBoxs.length||vm.copyArray.calTitleBoxs.length){
                        copyTogether(event,currentPage);
                    }
                    $scope.$digest();
                }
                // ctrl+x
                if ((event.ctrlKey == true || event.metaKey == true) && event.keyCode == 88 && !vm.textEditor) {
                    $scope.deleteBox();
                    $scope.$digest();
                }
                if (event.ctrlKey == true || event.metaKey == true) {
                    $timeout(function () {
                        if ($scope.RightPanel == 'mask' && $scope.currentPage.levels.level[$scope.template.levelI] && $scope.currentPage.levels.level[$scope.template.levelI].imagebox && !$scope.currentPage.levels.level[$scope.template.levelI].imagebox.ctrlKey) {
                            $scope.selectImg(event, $scope.template.levelI, $scope.currentPage.levels.level[$scope.template.levelI].imagebox)
                        }
                        if ($scope.RightPanel == 'material' && $scope.currentPage.levels.level[$scope.template.levelI] && $scope.currentPage.levels.level[$scope.template.levelI].imageart && !$scope.currentPage.levels.level[$scope.template.levelI].imageart.ctrlKey) {
                            $scope.selectArt(event, $scope.template.levelI, $scope.currentPage.levels.level[$scope.template.levelI].imageart)
                        }
                        if ($scope.RightPanel == 'text' && $scope.currentPage.levels.level[$scope.template.levelI] && $scope.currentPage.levels.level[$scope.template.levelI].textbox && !$scope.currentPage.levels.level[$scope.template.levelI].textbox.ctrlKey) {
                            $scope.selectText(event, $scope.template.levelI, $scope.currentPage.levels.level[$scope.template.levelI].textbox)
                        }
                        if ($scope.RightPanel == 'calMonthBox' && $scope.currentPage.levels.level[$scope.template.levelI] && $scope.currentPage.levels.level[$scope.template.levelI].calMonthBox && !$scope.currentPage.levels.level[$scope.template.levelI].calMonthBox.ctrlKey) {
                            $scope.selectCalMonthBox(event, $scope.template.levelI, $scope.currentPage.levels.level[$scope.template.levelI].calMonthBox)
                        }
                        if ($scope.RightPanel == 'calTitleBox' && $scope.currentPage.levels.level[$scope.template.levelI] && $scope.currentPage.levels.level[$scope.template.levelI].calTitleBox && !$scope.currentPage.levels.level[$scope.template.levelI].calTitleBox.ctrlKey) {
                            $scope.selectCalTitleBox(event, $scope.template.levelI, $scope.currentPage.levels.level[$scope.template.levelI].calTitleBox)
                        }
                    })
                }

                if (!vm.textEditor && event.target.tagName == 'INPUT') {
                    return
                }
            })
            // ctrl+z
            if (event.keyCode == 90 && event.ctrlKey && !vm.textEditor) {
                $scope.rollback(0);
                $scope.$digest();
            }
            // 上
            if (event.keyCode == 38 && !vm.textEditor) {
                keycodeArrow(38);
                fn(event)
            }
            // 下
            if (event.keyCode == 40 && !vm.textEditor) {
                keycodeArrow(40);
                fn(event)
            }
            // 左
            if (event.keyCode == 37 && !vm.textEditor) {
                keycodeArrow(37);
                fn(event)
            }
            // 右
            if (event.keyCode == 39 && !vm.textEditor) {
                keycodeArrow(39);
                fn(event)
            }
            event.returnvalue = false;
        };


        function copyTogether(e,currentPage){
            $scope.currentPage.updateThumbnail = true;
            angular.forEach(vm.copyArray.imageboxes, function (imagebox, i) {
                if(imagebox&&imagebox.geometry){
                    // 当前页所有占位框
                    var box = angular.copy(imagebox);
                    var currentLevel = addLevel(currentPage);
                    currentLevel.imagebox = copyDetail2(box);
                    updateHistorys();
                }

            })

            angular.forEach(vm.copyArray.imagearts, function (imageart, i) {
                if(imageart&&imageart.geometry){
                    // 当前页所有素材
                    var box = angular.copy(imageart);
                    var currentLevel = addLevel(currentPage);
                    currentLevel.imageart = copyDetail2(box);
                    updateHistorys();
                }

            })

            angular.forEach(vm.copyArray.textboxes, function (textbox, i) {
                if(textbox&&textbox.geometry){
                    // 当前页所有文字
                    var box = angular.copy(textbox);
                    var currentLevel = addLevel(currentPage);
                    currentLevel.textbox = copyDetail2(box);
                    updateHistorys();
                }

            })

            angular.forEach(vm.copyArray.calTitleBoxs, function (calTitleBox, i) {
                if(calTitleBox&&calTitleBox.geometry){
                    var currentPage = $scope.currentPage;
                    monthIndexSet(currentPage, function () {
                        // 当前页所有文字
                        var box = angular.copy(calTitleBox);
                        var currentLevel = addLevel(currentPage);
                        currentLevel.calTitleBox = copyDetail2(box);
                        dateUpdate()
                        updateHistorys();
                    })
                }

            })
            angular.forEach(vm.copyArray.calMonthBoxs, function (calMonthBox, i) {
                if(calMonthBox&&calMonthBox.geometry){
                    var currentPage = $scope.currentPage;
                    monthIndexSet(currentPage, function () {
                        // 当前页所有文字
                        var box = angular.copy(calMonthBox);
                        var currentLevel = addLevel(currentPage);
                        currentLevel.calMonthBox = copyDetail2(box);
                        dateUpdate()
                        updateHistorys();
                    })
                }

            });
            $scope.levelClick(e,$scope.currentPage.levels.level[$scope.currentPage.levels.level.length-1],0);
        }
        function dateUpdate() {
            if($scope.currentPage && $scope.currentPage.levels && $scope.currentPage.levels.level){
                $scope.currentPage.levels.level.forEach(function (level) {
                    if(level.calMonthBox){
                        level.calMonthBox.obj=null;
                        level.calMonthBox.sampleYear = getDay('year',$scope.template.config.startYear,$scope.template.config.startMonth,$scope.currentPage.config.monthIndex);
                        level.calMonthBox.sampleMonth = getDay('month',$scope.template.config.startYear,$scope.template.config.startMonth,$scope.currentPage.config.monthIndex);
                    }
                    if(level.calTitleBox){
                        level.calTitleBox.obj=null;
                        level.calTitleBox.sampleYear = getDay('year',$scope.template.config.startYear,$scope.template.config.startMonth,$scope.currentPage.config.monthIndex);
                        level.calTitleBox.sampleMonth = getDay('month',$scope.template.config.startYear,$scope.template.config.startMonth,$scope.currentPage.config.monthIndex);
                    }
                })
            }
        }


        function copyDetail2(box) {
            box.levelI = $scope.currentPage.levels.level.length-1;
            box.lock = false;
            var repeatEle = false;
            $scope.currentPage.levels.level.forEach(function(item){
                if(item.imagebox && item.imagebox.geometry.x == box.geometry.x && item.imagebox.geometry.y == box.geometry.y){
                    repeatEle = true;
                }
                if(item.imageart && item.imageart.geometry.x == box.geometry.x && item.imageart.geometry.y == box.geometry.y){
                    repeatEle = true;
                }
                if(item.textbox && item.textbox.geometry.x == box.geometry.x && item.textbox.geometry.y == box.geometry.y){
                    repeatEle = true;
                }
                if(item.code && item.code.geometry.x == box.geometry.x && item.code.geometry.y == box.geometry.y){
                    repeatEle = true;
                }
                if(item.calTitleBox && item.calTitleBox.geometry.x == box.geometry.x && item.calTitleBox.geometry.y == box.geometry.y){
                    repeatEle = true;
                }
                if(item.calMonthBox && item.calMonthBox.geometry.x == box.geometry.x && item.calMonthBox.geometry.y == box.geometry.y){
                    repeatEle = true;
                }
            })
            if(!repeatEle){
                return box
            }
            if (box.current == 'imagebox') {
                vm.copyArray.imageboxes.forEach(function(imagebox){
                    if(imagebox && imagebox.geometry.x == box.geometry.x && imagebox.geometry.y == box.geometry.y){
                        var x = PxTurnMm(imagebox.geometry.x) + 1;
                        var y = PxTurnMm(imagebox.geometry.y) + 1;
                        imagebox.geometry.x = MmTurnPx(x);
                        imagebox.geometry.y = MmTurnPx(y);
                    }
                })
            }
            if (box.current == 'imageart') {
                vm.copyArray.imagearts.forEach(function(imageart){
                    if(imageart && imageart.geometry.x == box.geometry.x && imageart.geometry.y == box.geometry.y){
                        var x = PxTurnMm(imageart.geometry.x) + 1;
                        var y = PxTurnMm(imageart.geometry.y) + 1;
                        imageart.geometry.x = MmTurnPx(x);
                        imageart.geometry.y = MmTurnPx(y);
                    }
                })
            }
            if(box.current == 'textbox'){
                vm.copyArray.textboxes.forEach(function(textbox){
                    if(textbox && textbox.geometry.x == box.geometry.x && textbox.geometry.y == box.geometry.y){
                        var x = PxTurnMm(textbox.geometry.x) + 1;
                        var y = PxTurnMm(textbox.geometry.y) + 1;
                        textbox.geometry.x = MmTurnPx(x);
                        textbox.geometry.y = MmTurnPx(y);
                    }
                })
            }
            if(box.current == 'calTitleBox'){
                vm.copyArray.calTitleBoxs.forEach(function(calTitleBox){
                    if(calTitleBox && calTitleBox.geometry.x == box.geometry.x && calTitleBox.geometry.y == box.geometry.y){
                        var x = PxTurnMm(calTitleBox.geometry.x) + 1;
                        var y = PxTurnMm(calTitleBox.geometry.y) + 1;
                        calTitleBox.geometry.x = MmTurnPx(x);
                        calTitleBox.geometry.y = MmTurnPx(y);
                    }
                })
            }
            if(box.current == 'calMonthBox'){
                vm.copyArray.calMonthBoxs.forEach(function(calMonthBox){
                    if(calMonthBox && calMonthBox.geometry.x == box.geometry.x && calMonthBox.geometry.y == box.geometry.y){
                        var x = PxTurnMm(calMonthBox.geometry.x) + 1;
                        var y = PxTurnMm(calMonthBox.geometry.y) + 1;
                        calMonthBox.geometry.x = MmTurnPx(x);
                        calMonthBox.geometry.y = MmTurnPx(y);
                    }
                })
            }
            var x = PxTurnMm(box.geometry.x) + 1;
            var y = PxTurnMm(box.geometry.y) + 1;
            box.geometry.x = MmTurnPx(x);
            box.geometry.y = MmTurnPx(y);
            // 判断边界
            if (box.geometry.y < 0) {
                box.geometry.y = 0;
            }
            if (box.geometry.y > $scope.currentPage.mediabox.height - box.geometry.height) {
                box.geometry.y = $scope.currentPage.mediabox.height - box.geometry.height;
            }
            if (box.geometry.x < 0) {
                box.geometry.x = 0;
            }
            if (box.geometry.x > $scope.currentPage.mediabox.width - box.geometry.width) {
                box.geometry.x = $scope.currentPage.mediabox.width - box.geometry.width;
            }
            return box
        }
        document.onkeyup = function(event){
            $timeout(function () {
                vm.ctrlKey = false;
            })
            if(event.keyCode == 32){
                $timeout(function () {
                    vm.moveCanvasView = false;
                })
            }
        }

        function keycodeArrow(keyCode) {
            var temp = JSON.parse(localStorage.getItem('singleArray'));
            var levels = $scope.currentPage.levels;
            var level = levels.level[$scope.template.levelI];
            var currentPage = $scope.template.pages.page[$scope.template.pageI];

            var all = getAllCtrlKeyArray(1);

            var len = all.length;
            var box = null, value = {};
            if (!len) {
                if ($scope.selectBox.current == 'imagebox') {
                    box = level.imagebox;
                    value = $scope.pageValue.imagebox;
                }
                if ($scope.selectBox.current == 'textbox') {
                    box = level.textbox;
                    value = $scope.pageValue.textbox;
                }
                if ($scope.selectBox.current == 'imageart') {
                    box = level.imageart;
                    value = $scope.pageValue.imageart;
                }
                if ($scope.selectBox.current == 'textdocument') {
                    box = level.textdocument;
                    value = $scope.pageValue.textdocument;
                }
                if ($scope.selectBox.current == 'calMonthBox') {
                    box = level.calMonthBox;
                    value = $scope.pageValue.calMonthBox;
                }
                if ($scope.selectBox.current == 'calTitleBox') {
                    box = level.calTitleBox;
                    value = $scope.pageValue.calTitleBox;
                }
                if (!box || box.lock) {
                    return
                }

                var maxHeightPx = parseFloat(currentPage.mediabox.height - box.geometry.height).toFixed(2) - 0;
                var maxWidthPx = parseFloat(currentPage.mediabox.width - box.geometry.width).toFixed(2) - 0;
                // 上
                if (keyCode == 38) {
                    if (vm.unit == 'px') {
                        if (value.y >= 1) {
                            value.y--;
                            box.geometry.y = MmTurnPx(value.y / vm.windowDpiH * 25.4);
                        }
                    } else if (vm.unit == 'mm') {
                        if (value.y >= 1) {
                            value.y -= 0.2;
                            box.geometry.y = MmTurnPx(value.y);
                        }
                    } else if (vm.unit == 'in') {
                        if (value.y >= 1) {
                            value.y -= 0.2;
                            box.geometry.y = InTurnPx(value.y);
                        }
                    }
                }
                // 下
                if (keyCode == 40) {
                    if (vm.unit == 'px') {
                        if (value.y < maxHeightPx) {
                            value.y++;
                            box.geometry.y = MmTurnPx(value.y / vm.windowDpiH * 25.4);
                        }
                    } else if (vm.unit == 'mm') {
                        if (value.y < PxTurnMm(currentPage.mediabox.height - box.geometry.height)) {
                            value.y += 0.2;
                            box.geometry.y = MmTurnPx(value.y);
                        }
                    } else if (vm.unit == 'in') {
                        if (value.y < PxTurnIn(currentPage.mediabox.height - box.geometry.height)) {
                            value.y += 0.2;
                            box.geometry.y = InTurnPx(value.y);
                        }
                    }
                }
                // 左
                if (keyCode == 37) {
                    if (vm.unit == 'px') {
                        if (value.x >= 1) {
                            value.x--;
                            box.geometry.x = MmTurnPx(value.x / vm.windowDpiW * 25.4);
                        }
                    } else if (vm.unit == 'mm') {
                        if (value.x >= 1) {
                            value.x -= 0.2;
                            box.geometry.x = MmTurnPx(value.x);
                        }
                    } else if (vm.unit == 'in') {
                        if (value.x >= 1) {
                            value.x -= 0.2;
                            box.geometry.x = InTurnPx(value.x);
                        }
                    }
                }
                // 右
                if (keyCode == 39) {
                    if (vm.unit == 'px') {
                        if (box.geometry.x < maxWidthPx) {
                            value.x++;
                            box.geometry.x = MmTurnPx(value.x / vm.windowDpiW * 25.4);
                        }
                    } else if (vm.unit == 'mm') {
                        if (value.x < PxTurnMm(maxWidthPx)) {
                            value.x += 0.2;
                            box.geometry.x = MmTurnPx(value.x);
                        }
                    } else if (vm.unit == 'in') {
                        if (value.x < PxTurnIn(maxWidthPx)) {
                            value.x += 0.2;
                            box.geometry.x = InTurnPx(value.x);
                        }
                    }
                }
                updateHistorys();
                $scope.$apply();
            } else {
                for (var i = len - 1; i >= 0; i--) {
                    if (!all[i]) {
                        continue;
                    }
                    var box = null;
                    if (all[i].current == 'imagebox') {
                        box = levels.level[all[i].levelI].imagebox;
                    } else if (all[i].current == 'textbox') {
                        box = levels.level[all[i].levelI].textbox;
                    } else if (all[i].current == 'imageart') {
                        box = levels.level[all[i].levelI].imageart;
                    } else if (all[i].current == 'calTitleBox') {
                        box = levels.level[all[i].levelI].calTitleBox;
                    } else if (all[i].current == 'calMonthBox') {
                        box = levels.level[all[i].levelI].calMonthBox;
                    }
                    if (!box || box.lock) {
                        return
                    }
                    var maxHeightPx = parseFloat(currentPage.mediabox.height - box.geometry.height).toFixed(2) - 0;
                    var maxWidthPx = parseFloat(currentPage.mediabox.width - box.geometry.width).toFixed(2) - 0;
                    if (keyCode == 38) {
                        if (vm.unit == 'px') {
                            if (box.geometry.y >= 1) {
                                box.geometry.y--;
                            }
                        } else if (vm.unit == 'mm') {
                            var y = PxTurnMm(box.geometry.y);
                            if (y >= 1) {
                                y -= 0.2;
                                box.geometry.y = MmTurnPx(y);
                            }
                        } else if (vm.unit == 'in') {
                            var y = PxTurnIn(box.geometry.y);
                            if (y >= 1) {
                                y -= 0.2;
                                box.geometry.y = InTurnPx(y);
                            }
                        }
                    }
                    // 下
                    if (keyCode == 40) {
                        if (vm.unit == 'px') {
                            if (box.geometry.y < maxHeightPx) {
                                box.geometry.y++;
                            }
                        } else if (vm.unit == 'mm') {
                            var y = PxTurnMm(box.geometry.y);
                            if (y < PxTurnMm(maxHeightPx)) {
                                y += 0.2;
                                box.geometry.y = MmTurnPx(y);
                            }
                        } else if (vm.unit == 'in') {
                            var y = PxTurnIn(box.geometry.y);
                            if (y < PxTurnIn(maxHeightPx)) {
                                y += 0.2;
                                box.geometry.y = InTurnPx(y);
                            }
                        }
                    }
                    // 左
                    if (keyCode == 37) {
                        if (vm.unit == 'px') {
                            if (box.geometry.x >= 1) {
                                box.geometry.x--;
                            }
                        } else if (vm.unit == 'mm') {
                            var x = PxTurnMm(box.geometry.x)
                            if (x >= 1) {
                                x -= 0.2;
                                box.geometry.x = MmTurnPx(x);
                            }
                        } else if (vm.unit == 'in') {
                            var x = PxTurnIn(box.geometry.x)
                            if (x >= 1) {
                                x -= 0.2;
                                box.geometry.x = InTurnPx(x);
                            }
                        }
                    }
                    // 右
                    if (keyCode == 39) {
                        if (vm.unit == 'px') {
                            if (box.geometry.x < maxWidthPx) {
                                box.geometry.x++;
                            }
                        } else if (vm.unit == 'mm') {
                            var x = PxTurnMm(box.geometry.x);
                            if (x < PxTurnMm(maxWidthPx)) {
                                x += 0.2;
                                box.geometry.x = MmTurnPx(x);
                            }
                        } else if (vm.unit == 'In') {
                            var x = PxTurnIn(box.geometry.x);
                            if (x < PxTurnIn(maxWidthPx)) {
                                x += 0.2;
                                box.geometry.x = InTurnPx(x);
                            }
                        }
                    }
                    updateHistorys();
                    $scope.$apply();
                }
            }


            $scope.currentPage = currentPage;
        }

        //复制
        $scope.copying = function () {
            var activeElement = document.activeElement.id;
            if ($scope.selectBox.current == 'textbox' && activeElement == "selectFontInput") {
                //如果当前选中是文本 且字体输入框获取了焦点 则不复制
                return;
            }
            var temp = JSON.parse(localStorage.getItem('singleArray'));
            if (vm.singleArray) {
                temp = vm.singleArray;
            }
            var all = getAllCtrlKeyArray(1);
            var len = all.length;
            if ((temp[$scope.selectBox.current] && temp[$scope.selectBox.current].geometry) || len > 0) {
                // if((!temp[$scope.selectBox.current] || !temp[$scope.selectBox.current].geometry)){
                //     return;
                // }
                var levels = $scope.currentPage.levels;
                var currentPage = $scope.template.pages.page[$scope.template.pageI];
                // 单选状态
                if (!len && $scope.selectBox.current) {
                    var currentLevel = addLevel(currentPage);
                    if ($scope.selectBox.current == 'imagebox' && temp.imagebox && temp.imagebox.geometry) {
                        var box = angular.copy(temp.imagebox);
                        currentLevel.imagebox = copyDetail(box, temp.imagebox);
                        vm.singleArray.imagebox = currentLevel.imagebox;
                    }
                    if ($scope.selectBox.current == 'textbox' && temp.textbox && temp.textbox.geometry) {
                        var box = angular.copy(temp.textbox);
                        currentLevel.textbox = copyDetail(box, temp.textbox);
                        vm.singleArray.textbox = currentLevel.textbox;

                    }
                    if ($scope.selectBox.current == 'imageart' && temp.imageart && temp.imageart.geometry) {
                        var box = angular.copy(temp.imageart);
                        currentLevel.imageart = copyDetail(box, temp.imageart);
                        vm.singleArray.imageart = currentLevel.imageart;

                    }
                    if ($scope.selectBox.current == 'textdocument' && temp.textdocument && temp.textdocument.geometry) {
                        var box = angular.copy(temp.textdocument);
                        currentLevel.textdocument = copyDetail(box, temp.textdocument);
                        vm.singleArray.textdocument = currentLevel.textdocument;

                    }
                    if ($scope.selectBox.current == 'calMonthBox' && temp.calMonthBox && temp.calMonthBox.geometry) {
                        var box = angular.copy(temp.calMonthBox);
                        currentLevel.calMonthBox = copyDetail(box, temp.calMonthBox);
                        vm.singleArray.calMonthBox = currentLevel.calMonthBox;

                    }
                    if ($scope.selectBox.current == 'calTitleBox' && temp.calTitleBox && temp.calTitleBox.geometry) {
                        var box = angular.copy(temp.calTitleBox);
                        currentLevel.calTitleBox = copyDetail(box, temp.calTitleBox);
                        vm.singleArray.calTitleBox = currentLevel.calTitleBox;

                    }
                    $scope.template.levelI = levels.level.length - 1;
                } else {
                    if (all.length == 0) {
                        return;
                    }
                    // ctrl+点击
                    for (var i = len - 1; i >= 0; i--) {
                        if (!all[i]) {
                            continue;
                        }
                        var box = angular.copy(all[i]);
                        var currentLevel = addLevel(currentPage);
                        if (all[i].current == 'imagebox') {
                            if (levels.level[box.levelI]) {
                                currentLevel.imagebox = copyDetail(box, all[i]);
                            } else {
                                box.levelI = levels.length;
                                currentLevel.imagebox = box;
                            }
                        } else if (all[i].current == 'textbox') {
                            if (levels.level[box.levelI]) {
                                currentLevel.textbox = copyDetail(box, all[i]);
                            } else {
                                box.index = levels.length;
                                currentLevel.textbox = box;
                            }
                        } else if (all[i].current == 'imageart') {
                            if (levels.level[box.levelI]) {
                                currentLevel.imageart = copyDetail(box, all[i]);
                            } else {
                                box.index = levels.length;
                                currentLevel.imageart = box;
                            }
                        } else if (all[i].current == 'textdocument') {
                            if (levels.level[box.levelI]) {
                                currentLevel.textdocument = copyDetail(box, all[i]);
                            } else {
                                box.index = levels.length;
                                currentLevel.textdocument = box;
                            }
                        }
                    }
                    $scope.clearCtrlKey();
                    localStorage.removeItem('singleArray');
                    $scope.selectBox = {}
                }
                getImageboxLen();
                getPagePx();
                updateHistorys();
            }
        };

        // 剪切
        $scope.cuting = function () {
            var temp = JSON.parse(localStorage.getItem('singleArray'));

            var levels = $scope.currentPage.levels;
            var level = levels.level[$scope.template.levelI];
            var currentPage = $scope.template.pages.page[$scope.template.pageI]
            // 当前页所有占位框
            var currentImages = currentPage.imageboxes.imagebox;
            // 当前页所有文本
            var currentTexts = currentPage.textboxes.textbox;
            // 当前页所有素材
            var currentArts = currentPage.imagearts.imageart;
            var all = getAllCtrlKeyArray(1);

            var len = all.length;
            // 单选状态
            if (!len) {
                if ($scope.selectBox.current == 'imagebox') {
                    currentImages.splice($scope.template.imgI, 1);
                    // $scope.template.imgI = currentImages.length - 1;
                }
                if ($scope.selectBox.current == 'textbox') {
                    currentTexts.splice($scope.template.textI, 1);
                    // $scope.template.textI = currentTexts.length - 1;
                }
                if ($scope.selectBox.current == 'imageart') {
                    currentArts.splice($scope.template.artI, 1);
                    // $scope.template.artI = currentArts.length - 1;
                }
                localStorage.setItem('singleArray', JSON.stringify(vm.singleArray));
            } else {
                // ctrl+点击
                for (var i = len - 1; i >= 0; i--) {
                    if (!all[i]) {
                        continue;
                    }
                    var box = angular.copy(all[i]);
                    if (all[i].current == 'imagebox') {
                        currentImages.splice(box.index, 1);
                    } else if (all[i].current == 'textbox') {
                        currentTexts.splice(box.index, 1);
                    } else if (all[i].current == 'imageart') {
                        currentArts.splice(box.index, 1);
                    }
                }
            }
        }

        function copyDetail(box, currentbox) {
            box.geometry.x = MmTurnPx(1) + currentbox.geometry.x;
            box.geometry.y = MmTurnPx(1) + currentbox.geometry.y;
            // box.geometry.x = PxTurnMm(currentbox.geometry.x) + 1;
            // box.geometry.y = PxTurnMm(currentbox.geometry.y) + 1;
            if ($scope.currentPage.levels.level == null) {
                $scope.currentPage.levels.level = [];
            }
            box.levelI = $scope.currentPage.levels.level.length - 1;
            // 判断边界
            if (box.geometry.y < 0) {
                box.geometry.y = 0;
            }
            if (box.geometry.y > $scope.currentPage.mediabox.height - box.geometry.height) {
                box.geometry.y = $scope.currentPage.mediabox.height - box.geometry.height;
            }
            if (box.geometry.x < 0) {
                box.geometry.x = 0;
            }
            if (box.geometry.x > $scope.currentPage.mediabox.width - box.geometry.width) {
                box.geometry.x = $scope.currentPage.mediabox.width - box.geometry.width;
            }
            return box;
        }

        /**
         * 上一张，下一张
         */
        vm.isSkip = false;
        $scope.pageDirection = function (flag) {
            if(vm.isSkip || (flag&&!$scope.visibleLeft) || (!flag&&!$scope.visibleRight) || vm.textEditor){
                return
            }
            vm.isSkip = true;
            $scope.selectBox = {
                current: 'page'
            }
            vm.loadingImg = true;
            $timeout(function () {
                var _pageIndex = null;
                if (flag) {
                    _pageIndex = $scope.template.pageI - 1;
                } else {
                    _pageIndex = $scope.template.pageI + 1;
                }
                checkPageCover(_pageIndex,function () {
                    $scope.currentPage = null;
                    $timeout(function (){
                        // 上一张
                        if (flag) {
                            $scope.template.pageI = $scope.template.pageI - 1;
                        } else {
                            $scope.template.pageI = $scope.template.pageI + 1;
                        }
                        $scope.lastPage = $scope.template.pages.page[$scope.template.pageI];
                        $scope.currentPage = $scope.template.pages.page[$scope.template.pageI];
                        // $(".bg-image").attr('src', '');
                        $scope.RightPanel = 'page';
                        isCanLeftAndRightPage();
                        loadAttribute();
                        $scope.pageHistory = [];

                        var w = 0;
                        for (var i = 0; i < $scope.template.pageI - 3; i++) {
                            var page = $scope.template.pages.page[i];
                            w += page.width * 98 / page.height + 16;
                        }
                        $(".nav-ul").scrollLeft(w);
                        vm.isSkip = false;
                        $scope.changeShirnk(0);
                        resetCtrlKeyArray();
                        vm.loadingImg = false;
                    })
                });
            })
            vm.isTransp = false;
            vm.isShadowSet = false;

        };

        //点击页面显示左右方向
        function isCanLeftAndRightPage() {
            $scope.template.levelI = 0;
            $scope.currentPage = $scope.template.pages.page[$scope.template.pageI];
            if ($scope.currentPage.scene) {
                $scope.currentPage.isScene = true;
            } else {
                $scope.currentPage.isScene = false;
            }
            setOriginalWaH($scope.currentPage.trimbox.width, $scope.currentPage.trimbox.height, $scope.template.pageI);
            var len = 0;
            angular.forEach($scope.template.pages.page, function (p) {
                if (!p.backup) {
                    len++;
                }
            })

            if ($scope.template.pages.page.length == 1) {
                $scope.visibleLeft = false;
                $scope.visibleRight = false;
            } else if ($scope.template.pageI == 0) {
                $scope.visibleLeft = false;
                $scope.visibleRight = true;
            } else if ($scope.template.pageI == len - 1) {
                $scope.visibleLeft = true;
                $scope.visibleRight = false;
            } else {
                $scope.visibleLeft = true;
                $scope.visibleRight = true;
            }
            getImageboxLen();
        }

        /**
         * 1.无封面则直接生成
         * 2.点击事件中先判断一下开始时间是否为空，为空时就把当前时间赋给开始时间（说明是第一次点击）
         * 否则就是第二次点击，把当前时间赋值给结束时间。
         * 第二次点击时就可以用结束时间减去开始时间，得到两次点击的时间间隔。
         */
        function checkPageCover(pageIndex, callback) {
            if(!$scope.lastPage.updateThumbnail){
                if(callback){callback()}
                return;
            }
            if (pageIndex != $scope.template.pageI) {
                var nodes = document.getElementsByClassName('page-item2');
                setThumbnailPic(nodes[0], $scope.lastPage, null, function () {
                    if (callback) {
                        callback()
                    }
                });
            }else{
                if(callback){callback()}
            }

            oldPage = angular.copy($scope.template.pages.page[$scope.template.pageI])
        }

        /**
         * 放大缩小及还原
         */
        $scope.changeShirnk = function (zoomIn) {
            var i = $scope.template.pageI;
            var currentPage = $scope.template.pages.page[i];
            var number = 0.02;
            var marTop = 0;

            // 还原
            if (zoomIn == 0) {
                currentPage.scale = 1;
                canvasInfo();
            }

            // 缩小
            if (zoomIn == 1) {
                if (currentPage.scale <= 0.5) {
                    return;
                }
                currentPage.scale = Math.abs(currentPage.scale - number).toFixed(2);
            }

            // 放大
            if (zoomIn == 2) {
                var scale = Math.abs(currentPage.scale - 0 + number).toFixed(2);
                //限制放大倍数
                if (scale > 1.5) {
                    return
                }
                currentPage.scale = scale;
            }
            // 原尺寸
            if (zoomIn == 3) {
                currentPage.scale = 1/currentPage.width*currentPage.mediabox.width;
            }
            currentPage.proportion1 = currentPage.width*currentPage.scale/currentPage.custom.width;
            $scope.currentPage = currentPage;
            updateMeasureRuler();
        }

        $scope.pageSeq = function(page){
            if(page && page.config){
                var _seq = 0;
                for(var i=0; i<$scope.template.pages.page.length; i++){
                    var _page = $scope.template.pages.page[i];
                    if(_page && _page.config &&_page.config.partid == page.config.partid){
                        _seq += 1;
                        if(_page.uuid == page.uuid){
                            break
                        }
                    }
                }
                return _seq;
            }
        }
        $scope.pageSeq1 = function(page){
            if(page && page.config){
                if(page.config.partid != 'P'){
                    return $scope.partNamt(page.config.partid)
                }else{
                    var _seq = 0;
                    for(var i=0; i<$scope.template.pages.page.length; i++){
                        var _page = $scope.template.pages.page[i];
                        if(_page && _page.config &&_page.config.partid == page.config.partid){
                            _seq += 1;
                            if(_page.uuid == page.uuid){
                                break
                            }
                        }
                    }
                    return '内页第'+ _seq + '页';
                }
            }
        }
        //删除模板
        $scope.deletePage = function (index, e) {
            fn(e)
            if($scope.template.pages.page.length == 1){
                MessageService.error("模板页最少为一页");
                return;
            }
            if (index == null && ($scope.template.pageI == null || $scope.template.pageI < 0)) {
                return;
            }

            vm.deleteSure = true;
            MessageService.confirm({
                title:'提示',
                cancel:'取消',
                confirm:'确定',
                msg:'确认要删除当前页面吗？'
            },function(){
                $scope.lastPage = angular.copy($scope.template.pages.page[index]);
                $scope.deletePageSure();
            });
            vm.deletaPageIndex = index;
            $scope.pageHistory = [];
        };
        $scope.deletePageSure = function (callback) {
            $timeout(function () {
                var nodes = document.getElementsByClassName('page-item2');
                setThumbnailPic(nodes[0], $scope.lastPage, null, function (identifier) {
                    if (!$scope.template.deletedPages) {
                        $scope.template.deletedPages = {page: []};
                    }
                    //取被删除页的部件索引
                    var delPartIndex = $scope.template.config.parts.list.findIndex(function(item){
                        return item.id === $scope.lastPage.config.partid
                    })
                    $scope.template.config.parts.list[delPartIndex].counter = $scope.template.config.parts.list[delPartIndex].counter-1;
                    if($scope.template.config.parts.list[delPartIndex].counter <= 0){
                        if($scope.template.backupPages.list){
                            for(var i=$scope.template.backupPages.list.length-1; i>=0; i-- ){
                                var backupPage = $scope.template.backupPages.list[i];
                                if(backupPage.config.partid == $scope.template.config.parts.list[delPartIndex].id){
                                    $scope.template.backupPages.list.splice(i,1);
                                }
                            }
                        }
                    };
                    if(vm.page.modelType == 'THREE'){
                        var _modelData = JSON.parse(vm.page.modelData);
                        _modelData.forEach(function (modelItem) {
                            if(modelItem.page == vm.deletaPageIndex){
                                modelItem.page = "";
                            }
                        })
                        vm.page.modelData = JSON.stringify(_modelData);
                    }
                    var partName = angular.copy($scope.template.pages.page[vm.deletaPageIndex].config.partid);
                    var p = angular.copy($scope.template.pages.page[vm.deletaPageIndex]);
                    p.pagecover.identifier = identifier;
                    if(vm.templateCopy){
                        vm.templateCopy.pages.page.splice(vm.deletaPageIndex, 1);
                    }
                    $scope.template.pages.page.splice(vm.deletaPageIndex, 1)
                    $scope.template.deletedPages.page.push(p);
                    if (vm.deletaPageIndex == 0) {
                        $scope.template.pageI = 0;
                    } else if ($scope.template.pageI >= vm.deletaPageIndex) {//当前选中页是被删除页或在被删除页之后，索引向前移动一位
                        $scope.template.pageI = $scope.template.pageI - 1;
                    } else {
                        for (var i = $scope.template.pages.page.length - 1; i >= 0; i--) {
                            var page = $scope.template.pages.page[i];
                            if (!page.backup) {
                                $scope.template.pageI = i;
                                break;
                            }
                        }
                    }
                    if(partName != $scope.template.pages.page[$scope.template.pageI].config.partid){
                        for (var i = 0; i < $scope.template.pages.page.length; i++) {
                            var page = $scope.template.pages.page[i];
                            if (page.config.partid == partName) {
                                $scope.template.pageI = i;
                            }
                        }
                    }
                    $timeout(function () {
                        $scope.currentPage = $scope.template.pages.page[$scope.template.pageI];
                        vm.deleteSure = false;
                        $scope.lastPage = $scope.currentPage;
                        // var nodes = document.getElementsByClassName('page-item2');
                        // setThumbnailPic(nodes[0], $scope.lastPage);
                        updateHistorys();
                        isCanLeftAndRightPage();
                        if(callback){callback()}
                    })
                })
            });

        }

        $scope.restorePage = function (item, index) {
            if(vm.textEditor){return}
            vm.deletaPageIndex = -1;
            $scope.template.config.parts.list.forEach(function (part,index) {
                if(part.id == item.config.partid){
                    if(part.id != 'P' && part.counter > 0){
                        for(var c=0; c<$scope.template.pages.page.length; c++){
                            if($scope.template.pages.page[c].config.partid == part.id){
                                vm.deletaPageIndex = c;
                            }
                        }
                    }
                }
            })
            if(vm.deletaPageIndex>-1){
                MessageService.confirm({
                    title:'提示',
                    cancel:'取消',
                    confirm:'确定',
                    msg:'已存在当前部件，如继续恢复会删除当前部件下的页，是否继续'
                },function(){
                    $scope.selectPages(vm.deletaPageIndex, null, function () {
                        $scope.deletePageSure(function () {
                            restorePageInit(item, index)
                        });
                    });
                });
            }else{
                restorePageInit(item, index)
            }
        }
        function restorePageInit(item, index){
            vm.operation = true;
            var nodes = document.getElementsByClassName('page-item2');
            setThumbnailPic(nodes[0], $scope.lastPage, null, function () {
                $scope.template.config.parts.list.forEach(function (part,index) {
                    if(part.id == item.config.partid){
                        part.counter = Number(part.counter) + 1;
                    }
                })
                $scope.template.pages.page.push(item);
                $scope.template.deletedPages.page.splice(index, 1);
                $scope.pageHistory = [];
                $timeout(function () {
                    pagesSort(function () {
                        $scope.selectPages($scope.template.pages.page.length-1);
                    })
                })
            })
        }

        // 窗口宽高变化
        window.onresize = function () {
            if (!$scope.currentPage) {
                return;
            }
            if ($scope.currentPage.trimbox) {
                setOriginalWaH($scope.currentPage.trimbox.width, $scope.currentPage.trimbox.height, $scope.template.pageI);
                $scope.$digest();
            }
            getFullState();
        };

        function compare2(property, attr, property2) {
            return function (a, b) {
                var value1 = a.geometry[property];
                var value2 = b.geometry[property];
                if (attr) {
                    return value1 - value2;
                } else {
                    var value12 = a.geometry[property2];
                    var value22 = b.geometry[property2];
                    return value2 + value22 - value1 - value12;
                }
            }
        }

        function getAllCtrlKeyArray() {
            var imageboxes = vm.CtrlKeyArray.imageboxes,
                textboxes = vm.CtrlKeyArray.textboxes,
                imagearts = vm.CtrlKeyArray.imagearts,
                all = [];
            var barcode = vm.CtrlKeyArray.barcode;
            var qrcode = vm.CtrlKeyArray.qrcode;
            // //选中的占位框
            // for (var i = 0; i < imageboxes.length; i++) {
            //     if (imageboxes[i]) {
            //         all.push(imageboxes[i]);
            //     }
            // }
            // //选中的文本框
            // for (var i = 0; i < textboxes.length; i++) {
            //     if (textboxes[i]) {
            //         all.push(textboxes[i]);
            //     }
            // }
            // //选中的素材
            // for (var i = 0; i < imagearts.length; i++) {
            //     if (imagearts[i]) {
            //         all.push(imagearts[i]);
            //     }
            // }
            // //选中的条码
            // for (var i = 0; i < barcode.length; i++) {
            //     all.push(barcode[i]);
            // }
            // //选中的二维码
            // for (var i = 0; i < qrcode.length; i++) {
            //     all.push(qrcode[i]);
            // }
            if ($scope.currentPage == null || !$scope.currentPage.levels || !$scope.currentPage.levels.level) {
                return all;
            }

            angular.forEach($scope.currentPage.levels.level, function (level, i) {
                if (level.imageart && level.imageart.ctrlKey) {
                    all.push(level.imageart)
                }
                if (level.imagebox && level.imagebox.ctrlKey) {
                    all.push(level.imagebox)
                }
                if (level.textbox && level.textbox.ctrlKey) {
                    all.push(level.textbox)
                }
                if (level.textdocument && level.textdocument.ctrlKey) {
                    all.push(level.textdocument)
                }
                if (level.calTitleBox && level.calTitleBox.ctrlKey) {
                    all.push(level.calTitleBox)
                }
                if (level.calMonthBox && level.calMonthBox.ctrlKey) {
                    all.push(level.calMonthBox)
                }
                if (level.code && level.code.ctrlKey) {
                    all.push(level.code)
                }
            })
            return all;
        }

        $scope.resetCtrlKeyArray = function (e) {
            if(!vm.textEditor){
                fn(e)
                resetCtrlKeyArray();
                $scope.template.levelI = null;
            }
        };

        function resetCtrlKeyArray() {
            $scope.RightPanel = "";
            var levels = $scope.currentPage.levels;
            if(!levels.level){
                return
            }
            for (var x = 0; x < levels.level.length; x++) {
                var l = levels.level[x];
                if (l.imagebox && l.imagebox.current) {
                    l.imagebox.ctrlKey = false;
                }
                if (l.imageart && l.imageart.current) {
                    l.imageart.ctrlKey = false;
                }
                if (l.textbox && l.textbox.current) {
                    l.textbox.ctrlKey = false;
                }
                if (l.textdocument && l.textdocument.current) {
                    l.textdocument.ctrlKey = false;
                }
                if (l.calTitleBox && l.calTitleBox.current) {
                    l.calTitleBox.ctrlKey = false;
                }
                if (l.calMonthBox && l.calMonthBox.current) {
                    l.calMonthBox.ctrlKey = false;
                }
            }

            vm.CtrlKeyArray.imageboxes = [];
            vm.CtrlKeyArray.textboxes = [];
            vm.CtrlKeyArray.imagearts = [];
            vm.CtrlKeyArray.barcode = [];
            vm.CtrlKeyArray.qrcode = [];
            vm.CtrlKeyArray.calMonthBoxs = [];
            vm.CtrlKeyArray.calTitleBoxs = [];
        }

        $scope.clearCtrlKey = function (flag, e) {
            if(vm.textEditor){
                return
            }
            fn(e)
            // 点击页面内容
            if (flag) {
                getPagePx();
                $scope.shezhi = false;
                // 清空选中
                // $scope.selectBox.current = 'page';
                vm.selectItem = null;
                $scope.selectBox = null;
            }
            $scope.isAlignHover = false;
            $scope.isDistriHover = false;
            toobarFlag1 = true;
            toobarFlag2 = true;
            toolbarStatus();

            vm.CtrlKeyArray.imageboxes = [];
            vm.CtrlKeyArray.textboxes = [];
            vm.CtrlKeyArray.textdocuments = [];
            vm.CtrlKeyArray.imagearts = [];
            vm.CtrlKeyArray.barcode = [];
            vm.CtrlKeyArray.qrcode = [];
            vm.CtrlKeyArray.calMonthBoxs = [];
            vm.CtrlKeyArray.calTitleBoxs = [];

            angular.forEach($scope.currentPage.levels.level, function (l, x) {
                if (l.imagebox && l.imagebox.current) {
                    l.imagebox.ctrlKey = false;
                }
                if (l.imageart && l.imageart.current) {
                    l.imageart.ctrlKey = false;
                }
                if (l.textbox && l.textbox.current) {
                    l.textbox.ctrlKey = false;
                }
                if (l.textdocument && l.textdocument.current) {
                    l.textdocument.ctrlKey = false;
                }
                if (l.calMonthBox && l.calMonthBox.current) {
                    l.calMonthBox.ctrlKey = false;
                }
                if (l.calTitleBox && l.calTitleBox.current) {
                    l.calTitleBox.ctrlKey = false;
                }
            })
        }

        function getPagePx() {
            $scope.RightPanel = 'page';
            loadAttribute();
        }

        $scope.editSize = function (attr) {
            var temp = $scope.template.pages.page[$scope.template.pageI];
            vm.unit = 'mm';
            unit();
            vm.page.editbox = angular.copy(temp.editbox);
            vm.page.editbox = {
                x: PxTurnMm(vm.page.editbox.x),
                y: PxTurnMm(vm.page.editbox.y),
                width: PxTurnMm(vm.page.editbox.width),
                height: PxTurnMm(vm.page.editbox.height),
            };
            vm.page.editboxs = angular.copy(temp.editboxes.editbox);
            vm.page.editboxs.forEach(function (editbox) {
                editbox.x = Number(PxTurnMm(editbox.x).toFixed(2));
                editbox.y = Number(PxTurnMm(editbox.y).toFixed(2))
                editbox.width = Number(PxTurnMm(editbox.width).toFixed(2));
                editbox.height = Number(PxTurnMm(editbox.height).toFixed(2));
            })
            vm.page.pageSize = angular.copy($scope.pageValue.mediabox);
            oldSizePx = angular.copy($scope.currentPage.bloodPx);
            oldSizeMm = angular.copy($scope.currentPage.blood);
            vm.page.pageBloodB = oldSizeMm.bottom - 0;
            vm.page.pageBloodL = oldSizeMm.left - 0;
            vm.page.pageBloodR = oldSizeMm.right - 0;
            vm.page.pageBloodT = oldSizeMm.top - 0;
            vm.page.pageSizeUnit = "mm";

            createModal('app/entities/page/page-edit.html', 'PageEditController', attr).result.then(
                function (data) {
                    vm.operation = true;
                    vm.page = data;
                    vm.unit = vm.page.dpi.data;
                    var temp = $scope.template.pages.page;
                    var i = $scope.template.pageI;

                    if (vm.unit == 'px') {
                        $scope.pageValue.mediabox = data.pageSize;
                        temp[i].editbox = data.editbox;
                        temp[i].editboxes = {
                            editbox: data.editboxs
                        };
                        temp[i].mediabox.width = data.pageSize.width;
                        temp[i].mediabox.height = data.pageSize.height;
                        temp[i].trimbox.x = data.pageBloodL;
                        temp[i].trimbox.y = data.pageBloodT;
                    }
                    if (vm.unit == 'mm') {
                        $scope.pageValue.mediabox = data.pageSize;
                        temp[i].mediabox.width = MmTurnPx(data.pageSize.width);
                        temp[i].mediabox.height = MmTurnPx(data.pageSize.height);
                        temp[i].trimbox.x = MmTurnPx(data.pageBloodL);
                        temp[i].trimbox.y = MmTurnPx(data.pageBloodT);
                        temp[i].editbox = getGeometry(data.editbox);
                        temp[i].editboxes = {
                            editbox: data.editboxs
                        };
                        temp[i].editboxes.editbox.forEach(function (editbox) {
                            editbox.width = MmTurnPx(editbox.width);
                            editbox.height = MmTurnPx(editbox.height);
                            editbox.x = MmTurnPx(editbox.x);
                            editbox.y = MmTurnPx(editbox.y);
                        })
                    }
                    if (vm.unit == 'in') {
                        $scope.pageValue.mediabox = data.pageSize;
                        temp[i].mediabox.width = InTurnPx(data.pageSize.width);
                        temp[i].mediabox.height = InTurnPx(data.pageSize.height);
                        temp[i].trimbox.x = InTurnPx(data.pageBloodL);
                        temp[i].trimbox.y = InTurnPx(data.pageBloodT);
                        temp[i].editbox = {
                            height: InTurnPx(temp[i].editbox.height),
                            width: InTurnPx(temp[i].editbox.width),
                            x: InTurnPx(temp[i].editbox.x),
                            y: InTurnPx(temp[i].editbox.y)
                        };
                        temp[i].editboxes = {
                            editbox: data.editboxs
                        };
                        temp[i].editboxes.editbox.forEach(function (editbox) {
                            editbox.width = InTurnPx(editbox.width);
                            editbox.height = InTurnPx(editbox.height);
                            editbox.x = InTurnPx(editbox.x);
                            editbox.y = InTurnPx(editbox.y);
                        })
                    }
                    getBloodSize(temp[i], i);
                    resetBackground();
                    $scope.currentPage = temp[i];
                });
        }

        var createModal = function (url, controller, attr) {
            return $uibModal.open({
                templateUrl: url,
                controller: controller,
                backdrop: 'static',
                keyboard: true,
                windowClass: "jh-modal-md",
                controllerAs: 'vm',
                size:'lg',
                resolve: {
                    pages: {page: vm.page, sizeSet: attr, token: vm.token, domain: vm.url, template: $scope.template},
                    documentpics: {arr: $scope.template.documentpics.documentpic},
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page)
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('page');
                        return $translate.refresh();
                    }]
                }
            });
        };

        //撤销，重做按钮事件
        $scope.rollback = function (forward) {
            var i = angular.copy($scope.template.pageI);
            if($scope.pageHistory.length  == 0){
                return
            }
            if (forward) {
                $scope.currentPage = null;
                $scope.lastPage = null;
                $timeout(function () {
                    if(vm.templateCopy && vm.templateCopy.pages.page[i]) {
                        $scope.template.pages.page[i] = angular.copy(vm.templateCopy.pages.page[i]);
                    }else{
                        $scope.template.pages.page[i] = {
                            bgImg: '',
                            background: {resource: {}},
                            barcode: {},
                            qrcode: {},
                            scale: 1,
                            levels: {},
                            width: $scope.template.pages.page[i].width,
                            height: $scope.template.pages.page[i].height,
                            spread: $scope.template.pages.page[i].spread,
                            backup: $scope.template.pages.page[i].backup,
                            unreplace: $scope.template.pages.page[i].unreplace,
                            editbox: getGeometry($scope.template.pages.page[i].editbox),
                            editboxes: angular.copy($scope.template.pages.page[i].editboxes),
                            blood: angular.copy($scope.template.pages.page[i].blood),
                            bloodPx: angular.copy($scope.template.pages.page[i].bloodPx),
                            isScene: $scope.template.pages.page[i].isScene,
                            seq: $scope.template.pages.page[i].seq,
                            trimbox: $scope.template.pages.page[i].trimbox,
                            mediabox: $scope.template.pages.page[i].mediabox,
                            uuid: $scope.template.pages.page[i].uuid,
                            pagecover: $scope.template.pages.page[i].pagecover,
                            scene: $scope.template.pages.page[i].scene,
                            hasBgImg: false,
                            unit: 'mm'
                        };
                    }
                    $scope.RightPanel = 'page';
                    $scope.currentPage = $scope.template.pages.page[i];
                    $scope.currentPage.updateThumbnail = true;
                    $scope.lastPage = $scope.currentPage;
                    vm.unit = 'mm';
                    $scope.pageValue.mediabox = {
                        width: PxTurnMm($scope.currentPage.mediabox.width),
                        height: PxTurnMm($scope.currentPage.mediabox.height)
                    }
                    setOriginalWaH($scope.currentPage.trimbox.width, $scope.currentPage.trimbox.height, i);
                    angular.forEach($scope.template.pages.page, function (item, index) {
                        if (!item.bgImg) {
                            $('#bgImg' + index).attr('src', '');            //添加src
                        }
                    });
                    $scope.clearCtrlKey();
                    var _template = angular.copy($scope.pageHistory[$scope.pageHistory.length-1]);
                    $scope.pageHistory = [vm.templateCopy,_template,_template];
                    $scope.changeShirnk(0);
                })
            } else {
                if($scope.pageHistory.length  < 2){
                    $scope.currentPage = null;
                    $scope.lastPage = null;
                    $timeout(function () {
                        $scope.template.pages.page[i] = angular.copy(vm.templateCopy.pages.page[i]);
                        $scope.currentPage = $scope.template.pages.page[i];
                        $scope.currentPage.updateThumbnail = true;
                        $scope.lastPage = $scope.currentPage;
                        $scope.pageHistory = [];
                        $scope.changeShirnk(0);
                    })
                    return
                }
                //$scope.template.pages.page[i] = null;
                $scope.currentPage = null;
                $scope.lastPage = null;
                $timeout(function () {
                    var _template = angular.copy($scope.pageHistory[$scope.pageHistory.length-2]);
                    $scope.template.pages.page[i] = _template.pages.page[i];
                    // $scope.template.pages.page[i] = angular.copy(vm.templateCopy.pages.page[i]);
                    $scope.pageHistory.splice($scope.pageHistory.length-1,1);
                    $scope.RightPanel = 'page';
                    $scope.currentPage = $scope.template.pages.page[i];
                    $scope.currentPage.updateThumbnail = true;
                    $scope.lastPage = $scope.currentPage;
                    vm.unit = 'mm';
                    $scope.pageValue.mediabox = {
                        width: PxTurnMm($scope.currentPage.mediabox.width),
                        height: PxTurnMm($scope.currentPage.mediabox.height)
                    }
                    setOriginalWaH($scope.currentPage.trimbox.width, $scope.currentPage.trimbox.height, i);
                    angular.forEach($scope.template.pages.page, function (item, index) {
                        if (!item.bgImg) {
                            $('#bgImg' + index).attr('src', '');            //添加src
                        }
                    });
                    $scope.clearCtrlKey();
                    $scope.changeShirnk(0);
                })
            }
        };
        // 圆角设置
        vm.isRoundedSet = false;
        $scope.roundedSet = function (attr) {
            toolbarStatus();
            vm.isRoundedSet = attr;
        }

        // 边框设置
        vm.isBorderSet = false;
        $scope.borderSet = function (attr) {
            toolbarStatus();
            vm.isBorderSet = attr;
        }

        // 阴影设置
        vm.isShadowSet = false;
        $scope.shadowSet = function (attr) {
            toolbarStatus();
            vm.isShadowSet = attr;
        }
        // 透明度
        $scope.transparencySelect = function (attr) {
            if (!$scope.selectBox || !$scope.RightPanel || $scope.RightPanel == 'calMonthBox' || $scope.RightPanel == 'calTitleBox') {
                MessageService.error("请选择一个图片或者素材、文字");
                return
            }
            toolbarStatus();
            var current = $scope.selectBox.current;
            if (current == 'imageart' || current == 'textbox' || current == 'imagebox') {
                vm.isTransp = attr;

            }
            $scope.template.transparency = $scope.selectBox.transparency * 100;
            $(elem).val($scope.selectBox.transparency);
        }
        $scope.transparencyChange1 = function(){
            $timeout(function () {
                if($scope.template.transparency === '' || $scope.template.transparency === null || $scope.template.transparency<0){
                    $scope.template.transparency = 0
                }
                if($scope.template.transparency > 100){
                    $scope.template.transparency = 100
                }
                $scope.selectBox.transparency = $scope.template.transparency / 100;
            })
        }
        $scope.$watch("selectBox.transparency", function (newValue, oldValue) {
            if($scope.selectBox){
                $scope.template.transparency = Math.round($scope.selectBox.transparency * 100);
            }
        },true)

        $scope.coverageSelect = function (attr) {
            toolbarStatus();
            var current = $scope.selectBox.current;
            if (current != 'page') {
                vm.isCoverage = attr;
            }
        }

        $scope.opacityElement = function (mediabox, geometry) {
            var opacity = 1;
            if (!geometry || !mediabox) {
                return 1
            }
            if (geometry.x > -geometry.width && geometry.y > -geometry.height && geometry.x < mediabox.width && geometry.y < mediabox.height) {
                opacity = 1;
            } else {
                opacity = 0.3;
            }
            return opacity
        }

        /**
         * 图层
         * @param attr----up,down,top,bottom
         */
        $scope.coverageMove = function (attr) {
            var currentPage = angular.copy($scope.currentPage);
            var levels = currentPage.levels.level;
            if (levels.length == 1) {
                return
            }

            var levelI = $scope.template.levelI;
            // 上移一层
            if (attr == 'up') {
                if (levelI == levels.length || !levels[levelI + 1]) {
                    MessageService.error("已在最上层")
                    return
                }
                var seq = levels[levelI].seq;
                levels[levelI].seq = levels[levelI + 1].seq;
                levels[levelI + 1].seq = seq;
            }

            // 下移一层
            if (attr == 'down') {
                if (levelI == 0 || !levels[levelI - 1]) {
                    MessageService.error("已在最下层");
                    return
                }
                var seq = levels[levelI].seq;
                levels[levelI].seq = levels[levelI - 1].seq;
                levels[levelI - 1].seq = seq;
            }

            // 置顶
            if (attr == 'top') {
                if (levelI == levels.length - 1) {
                    MessageService.error("已在最上层")
                    return
                }
                var seq = levels[levelI].seq;
                levels[levelI].seq = levels[levels.length - 1].seq;

                for (var i = levelI + 1; i < levels.length; i++) {
                    var item = levels[i];
                    item.seq = i;
                }
            }

            // 置底
            if (attr == 'bottom') {
                if (levelI == 0) {
                    MessageService.error("已在最下层");
                    return
                }
                var seq = levels[levelI].seq;
                levels[levelI].seq = levels[0].seq;

                for (var i = 0; i < levelI; i++) {
                    var item = levels[i];
                    item.seq += 1;
                }
            }

            $scope.template.levelI = levels[levelI].seq - 1;
            levels.sort(compare('seq', true));
            $scope.currentPage = {};
            $scope.template.pages.page[$scope.template.pageI] = {};
            $timeout(function () {
                $scope.currentPage = currentPage;
                $scope.template.pages.page[$scope.template.pageI] = currentPage;
                vm.CtrlKeyArray.imageboxes = [];
                vm.CtrlKeyArray.textboxes = [];
                vm.CtrlKeyArray.imagearts = [];
                vm.CtrlKeyArray.barcode = [];
                vm.CtrlKeyArray.qrcode = [];
                vm.CtrlKeyArray.calTitleBoxs = [];
                vm.CtrlKeyArray.calMonthBoxs = [];
            })
        }

        // 锁定
        $scope.locking = function () {
            if (!$scope.selectBox || !$scope.RightPanel || !$scope.currentPage.levels.level[$scope.template.levelI]) {
                MessageService.error("请先选择一个元素");
                return
            }
            // 当前页所有占位框
            var currentImages = $scope.currentPage.levels.level[$scope.template.levelI].imagebox;
            // 当前页所有文本
            var currentTexts = $scope.currentPage.levels.level[$scope.template.levelI].textbox;
            // 当前页所有素材
            var currentArts = $scope.currentPage.levels.level[$scope.template.levelI].imageart;
            var all = getAllCtrlKeyArray(1);

            var len = all.length;
            // 单选状态
            if (!len) {
                $scope.selectBox.lock = !$scope.selectBox.lock;
            } else {
                // ctrl+点击
                for (var i = 0; i < len; i++) {
                    if (all[i].current == 'imagebox') {
                        currentImages[all[i].index].lock = !currentImages[all[i].index].lock;
                    } else if (all[i].current == 'textbox') {
                        currentTexts[all[i].index].lock = !currentTexts[all[i].index].lock;
                    } else {
                        currentArts[all[i].index].lock = !currentArts[all[i].index].lock;
                    }
                }
            }
            updateHistorys();
        }

        // 删除
        $scope.deleteBox = function () {
            var all = getAllCtrlKeyArray(1);
            var len = all.length;
            if ($scope.selectBox.current == 'barcode') {
                if ($scope.currentPage.barcode.lock) {
                    return
                }
                $scope.currentPage.barcode = {};
                $scope.RightPanel="";
                return
            }
            if ($scope.selectBox.current == 'qrcode') {
                if ($scope.currentPage.qrcode.lock) {
                    return
                }
                $scope.currentPage.qrcode = {};
                $scope.RightPanel="";
                return
            }
            var levels = angular.copy($scope.currentPage.levels);
            if (!levels || !levels.level || !levels.level[$scope.template.levelI]) {
                return;
            }
            var level = levels.level[$scope.template.levelI];
            // 单选状态
            if (!len) {
                if ($scope.selectBox == undefined || $scope.selectBox.current == 'page') {
                    $scope.deleteBgImg();
                    return
                }
                if ($scope.selectBox.current == 'imagebox') {
                    if (level.imagebox.lock) {
                        return
                    }
                }
                if ($scope.selectBox.current == 'textbox') {
                    if (level.textbox.lock) {
                        return
                    }
                }
                if ($scope.selectBox.current == 'imageart') {
                    if (level.imageart.lock) {
                        return
                    }
                }
                if ($scope.selectBox.current == 'textdocument') {
                    if (level.textdocument.lock) {
                        return
                    }
                }
                if ($scope.selectBox.current == 'calMonthBox') {
                    if (level.calMonthBox.lock) {
                        return
                    }
                }
                if ($scope.selectBox.current == 'calTitleBox') {
                    if (level.calTitleBox.lock) {
                        return
                    }
                }
                levels.level.splice($scope.template.levelI, 1);

            } else {
                // ctrl+点击
                for (var i = len - 1; i >= 0; i--) {
                    if (!all[i]) {
                        continue;
                    }
                    if (all[i].current == 'barcode') {
                        $scope.currentPage.barcode = {};

                    } else if (all[i].current == 'qrcode') {
                        $scope.currentPage.qrcode = {};

                    } else {
                        if(!all[i].lock){
                            levels.level.splice(all[i].levelI, 1);
                        }
                    }
                }
                $scope.clearCtrlKey();
            }

            for (var x = 0; x < levels.level.length; x++) {
                var l = levels.level[x];
                if (l.imagebox && l.imagebox.current) {
                    l.imagebox.levelI = x;
                }
                if (l.imageart && l.imageart.current) {
                    l.imageart.levelI = x;
                }
                if (l.textbox && l.textbox.current) {
                    l.textbox.levelI = x;
                }
                if (l.textdocument && l.textdocument.current) {
                    l.textdocument.levelI = x;
                }
                if (l.calTitleBox && l.calTitleBox.current) {
                    l.calTitleBox.levelI = x;
                }
                if (l.calMonthBox && l.calMonthBox.current) {
                    l.calMonthBox.levelI = x;
                }
                l.seq = x + 1;
            }

            $scope.currentPage.levels = [];
            $timeout(function () {
                $scope.currentPage.levels = levels;
                $scope.RightPanel = 'page';
                $scope.selectBox = {};
                getPagePx();
                getImageboxLen();
                updateHistorys();
            })
        };

        $scope.codeDelete = function (type) {
            if (type == 'barcode') {
                if ($scope.currentPage.barcode.lock) {
                    return
                }
                $scope.currentPage.barcode = {};
                return
            }
            if (type == 'qrcode') {
                if ($scope.currentPage.qrcode.lock) {
                    return
                }
                $scope.currentPage.qrcode = {};
                return
            }
        }
        vm.watchSure = false;
        $scope.watchArticle = function () {
            if (vm.page.modelType && vm.page.modelType === 'THREE') {
                setThumbnailPic1(function () {
                    vm.threeTemplate = $scope.template;
                    vm.threeProductXmlData = {
                        modelBlendent: vm.page.modelBlendent,
                        modelData: vm.page.modelData,
                        modelPath: vm.page.modelPath,
                    };
                    vm.threeView = true;
                })
            } else {
                var template = angular.copy($scope.template);
                var arr = getTemplate(template);
                vm.previewArticle = arr.template;
                vm.watchSure = true;
            }
        }

        function checkPageFonts(pages) {
            if (!pages || pages.length == 0) {
                return true;
            }
            for (var i = 0; i < pages.length; i++) {
                var page = pages[i];
                if (page.levels && page.levels.level && page.levels.level.length > 0) {
                    for (var j = 0; j < page.levels.level.length; j++) {
                        var level = page.levels.level[j];
                        if (level && level.textbox) {
                            var textbox = level.textbox;
                            if (textbox.characterWarning) {
                                if (!page.backup) {
                                    MessageService.error("检测到页面文字中包含字体不支持的字符！");
                                } else {
                                    MessageService.error("检测到备用页面文字中包含字体不支持的字符！");
                                }
                                return false;
                            }
                        }
                    }
                }
            }
            return true;
        }

        function clearPageStorageInfo() {
            if (vm.pageStorageName && vm.pageStoragePredefined) {
                localStorage.removeItem(vm.pageStorageName);
            }
        }

        /*!
        *    attr - 场景值
        *       0 - 发布模版
        *       1 - 保存模版
        *       2 - 发布产品
        *       3 - 即时保存
        */
        vm.documentDetection = {
            pass: true
        };
        vm.documentDetectionTab="text";
        vm.saveDate = "";
        /**
         * 显示原创协议弹窗
         * @param {*} callback
         */
        function showOriginalAgreement(callback,attr){
            var userInfo = $localStorage.user;
            if(userInfo.original){
                return callback(attr);
            }
            $uibModal.open({
                templateUrl: 'app/entities/page/modal/original-agreement.html',
                controller: 'OriginalAgreementController',
                controllerAs: 'vm',
                backdrop: "static",
                size: 'lg',
                resolve: {

                }
            }).result.then(function (state) {
                if(state){
                    callback(attr);
                }

            })
        }
        var isCalendar = false;
        vm.issetMonth = false;
        $scope.savePage = function(attr){
            if(vm.textEditor){
                return;
            }
            //发布模板,先校验原创协议
            if(attr === 0 || attr === 2){
                if($scope.template.documentpics.documentpic.length === 0){
                    MessageService.error("请添加样例图！");
                    return
                }
                //判断动态日历是否有月序
                if($scope.template.config.dynamic){
                    vm.serialNumberPages=[];
                    vm.issetMonth = false;
                    $scope.template.pages.page.forEach(function (page) {
                        if(!$scope.isSetMonth(page)){
                            vm.serialNumberPages.push(page)
                        }
                    })
                    if(vm.serialNumberPages.length>0){
                        vm.issetMonth = true;
                        return
                    }
                }
                //判断动态日历月序是否连续
                if($scope.template.config.dynamic && !isCalendar){
                    var numbers = [];
                    $scope.template.pages.page.forEach(function (page) {
                        if(page.config.monthIndex>0){
                            numbers.push(page.config.monthIndex)
                        }
                    })
                    var result = findMissingNumbers(numbers);
                    if (result.length>0){
                        $uibModal.open({
                            templateUrl: 'app/entities/page/modal/calendar-modal.html',
                            controller: 'CalendarModalController',
                            backdrop: 'static',
                            keyboard: true,
                            windowClass: "jh-modal-md",
                            controllerAs: 'vm',
                            resolve: {
                                entity: [function () {
                                    return {
                                        numbers: numbers,
                                        templateConfig: $scope.template.config
                                    };
                                }]
                            }
                        }).result.then(function (data) {
                            if (data) {
                                isCalendar = true;
                                $scope.savePage(attr)
                            }
                        });
                        return
                    }
                }

            }
            if(attr === 0){
                showOriginalAgreement($scope.handleSavePage,attr);
            }else if(attr === 2){
                //先检查作品是否完成
                var template = angular.copy($scope.template);
                var c = 0;

                vm.documentDetection = documentTextDetection($scope.template);
                if(!vm.documentDetection.pass){
                    if(vm.documentDetection.isText){
                        vm.documentDetectionTab="text";
                    }else{
                        vm.documentDetectionTab="repetition";
                    }
                    return;
                }
                angular.forEach(template.pages.page, function (item, i) {
                    if (!item.backup) {
                        c++
                    }
                })

                if (vm.page.id && !vm.hasModel && vm.productTemplatePageCount < template.pages.page.length) {
                    if (c != vm.productTemplatePageCount) {
                        MessageService.error("模板非备用数量页与标准模板不符！");
                        return
                    }
                }

                if (vm.page.addpage && (vm.page.minpage > c || vm.page.maxpage < c)) {
                    MessageService.error("页数范围在" + vm.page.minpage + " ~ " + vm.page.maxpage + "之间");
                    return
                }

                // 当attr==2时， 将会检查相框内是否填充图片
                var arr = getTemplate(template, attr);
                template = arr.template;
                if (!arr.isSave) {
                    return MessageService.error("请先制作完作品！");

                }else{
                    showOriginalAgreement($scope.handleSavePage,attr);
                }
            }else{
                $scope.handleSavePage(attr);
            }
        }
        $scope.handleSavePage = function (attr) {
            var template = angular.copy($scope.template);
            var c = 0;

            vm.documentDetection = documentTextDetection($scope.template);
            if(!vm.documentDetection.pass){
                if(vm.documentDetection.isText){
                    vm.documentDetectionTab="text";
                }else{
                    vm.documentDetectionTab="repetition";
                }
                return;
            }
            angular.forEach(template.pages.page, function (item, i) {
                if (!item.backup) {
                    c++
                }
            })

            if (vm.page.id && !vm.hasModel && vm.productTemplatePageCount < template.pages.page.length) {
                if (c != vm.productTemplatePageCount) {
                    MessageService.error("模板非备用数量页与标准模板不符！");
                    return
                }
            }

            if (vm.page.addpage && (vm.page.minpage > c || vm.page.maxpage < c)) {
                MessageService.error("页数范围在" + vm.page.minpage + " ~ " + vm.page.maxpage + "之间");
                return
            }

            vm.isSaving = true;
            $scope.isHasGeometry = true;

            // 当attr==2时， 将会检查相框内是否填充图片
            var arr = getTemplate(template, attr);
            template = arr.template;
            var tipArr = arr.tipArr;
            if (!arr.isSave) {
                MessageService.error("发布产品失败，请先制作完作品！");
                vm.isSaving = false;
                return
            }
            if (tipArr.length) {
                var str = tipArr.join(',')
                MessageService.error("第" + str + "页需要设置为不可替换！");
                vm.isSaving = false;
                return
            }
            var _variableRepeat = isRepeat(arr.variableData)
            if (_variableRepeat) {
                MessageService.error("可变数据不可重复");
                vm.isSaving = false;
                return
            }
            // return
            // Qinius.get(function (msg) {
            var i = $scope.template.pageI;
            var nodes = document.getElementsByClassName('page-item2');
            // vm.token = msg.token;
            $scope.lastPage = $scope.template.pages.page[$scope.template.pageI];
            if (!$scope.isHasGeometry) {
                MessageService.error("请输入正确的占位框宽高！");
                vm.isSaving = false;
                return
            }
            $timeout(function () {
                var width = $scope.lastPage.mediabox.width;
                var height = $scope.lastPage.mediabox.height;
                if($scope.lastPage.scene){
                    $scope.lastPage.isScene = true;
                }
                if ($scope.lastPage.isScene) {
                    width = $scope.lastPage.scene.geometry.width;
                    height = $scope.lastPage.scene.geometry.height;
                }
                var _ratio = $scope.lastPage.ratio || 1;
                getDomOnload($scope,"pageThumbnail",function () {
                    html2canvas_adapt(nodes[0], {
                        onrendered: function (canvas) {
                            var url = canvas.toDataURL("image/png");
                            var blob = dataURLtoBlob(url);

                            var formData = new FormData();
                            formData.append('file', blob);
                            formData.append('key', 'clipArt-' + UidService.get());
                            formData.append('token', vm.token);
                            $.ajax({
                                cache: true,
                                type: "POST",
                                url: 'https://upload.qiniup.com/',
                                data: formData,
                                async: false,
                                contentType: false,
                                processData: false,
                                success: function (data) {
                                    template.pages.page[i].updateThumbnail=false;
                                    template.pages.page[i].pagecover = {
                                        identifier: vm.url + data.key,
                                        provider: 'qiniu'
                                    }
                                    $scope.template.pages.page[i].updateThumbnail=false;
                                    $scope.template.pages.page[i].pagecover = {
                                        identifier: vm.url + data.key,
                                        provider: 'qiniu'
                                    }
                                    for(var j=0; j<template.pages.page.length; j++){
                                        if(template.pages.page[j].updateThumbnail){
                                            vm.isSaving = false;
                                            MessageService.confirm({
                                                title:'提示',
                                                cancel:'取消',
                                                confirm:'去更新',
                                                msg:'当前模板存在需要更新的缩略图，是否现在更新'
                                            },function(){
                                                $scope.showAllThumbnailPic();
                                            });
                                            return;
                                        }
                                    }
                                    if (!$scope.isHasGeometry) {
                                        MessageService.error("请输入正确的占位框宽高！");
                                        vm.isSaving = false;
                                        return
                                    }
                                    if(vm.thirdparty){
                                        ProductXml.thirdXmlSave({
                                            document: template,
                                            key: $stateParams.key,
                                            xmlId: $stateParams.xmlId,
                                            version: '4.0'
                                        }, function () {
                                            vm.isSaving = false;
                                            MessageService.success("保存成功！");
                                            window.history.back()
                                        }, function () {
                                            vm.isSaving = false;
                                            MessageService.error("保存失败！");
                                        });
                                        return;
                                    }
                                    if (attr == 1 || attr == 3) {
                                        if (($stateParams.id && !$stateParams.copy) || vm.currentAid) {
                                            ProductXml.update({
                                                document: template,
                                                bindingType: vm.page.bindingType,
                                                pattern: vm.page.pattern,
                                                replace: vm.page.replace,
                                                name: vm.page.name,
                                                id: $stateParams.id || vm.currentAid,
                                                provider: vm.page.provider,
                                                catalogId: vm.page.catalog.id,
                                                showPic: true,
                                                version: '4.0',
                                                catalogName: vm.page.catalog.name,
                                                type: 'XML',
                                                productTemplateId: vm.page.id ? vm.page.id : '',
                                                hashtags: vm.hashtags,
                                                modelBlendent: vm.page.modelBlendent,
                                                modelData: vm.page.modelData,
                                                modelPath: vm.page.modelPath,
                                                modelType: vm.page.modelType,
                                                productType: vm.page.productType
                                            }, function () {
                                                var now = new Date();
                                                var hours = now.getHours();
                                                var minutes = now.getMinutes();
                                                vm.saveDate = hours + ":" + minutes + '已保存';
                                                vm.operation = false;
                                                vm.isSaving = false;

                                                if (attr == 1) {
                                                    MessageService.success("保存成功！");
                                                    if (!vm.isCustom) {
                                                        clearPageStorageInfo();
                                                        $state.go('selfTemplateList', {reload: true})
                                                    } else {
                                                        clearPageStorageInfo();
                                                        $state.go('selfTemplateList', {self: 'self'}, {reload: true})
                                                    }
                                                } else if (attr == 3) {
                                                }
                                            }, error);
                                        } else {
                                            ProductXml.save({
                                                document: template,
                                                bindingType: vm.page.bindingType,
                                                pattern: vm.page.pattern,
                                                replace: vm.page.replace,
                                                name: vm.page.name,
                                                catalogId: vm.page.catalog.id,
                                                catalogName: vm.page.catalog.name,
                                                showPic: true,
                                                version: '4.0',
                                                type: 'XML',
                                                productTemplateId: vm.page.id ? vm.page.id : '',
                                                hashtags: vm.hashtags,
                                                modelBlendent: vm.page.modelBlendent,
                                                modelData: vm.page.modelData,
                                                modelPath: vm.page.modelPath,
                                                modelType: vm.page.modelType
                                            }, function (resp) {
                                                vm.isSaving = false;
                                                MessageService.success("保存成功！");
                                                if (attr == 1) {
                                                    if (!vm.isCustom) {
                                                        clearPageStorageInfo();
                                                        $state.go('templateList', {reload: true})
                                                    } else {
                                                        clearPageStorageInfo();
                                                        $state.go('selfTemplateList', {self: 'self'}, {reload: true})
                                                    }
                                                } else if (attr == 3) {
                                                    vm.currentAid = resp.id
                                                }
                                            }, error);
                                        }
                                    }
                                    if (attr == 0) {
                                        vm.isSaving = false;
                                        $uibModal.open({
                                            templateUrl: 'app/entities/page/modal/document-detection.html',
                                            controller: 'DocumentDetectionController',
                                            controllerAs: 'vm',
                                            size: 'lg',
                                            resolve: {
                                                entity: [function () {
                                                    return {
                                                        document: template,
                                                        bindingType: vm.page.bindingType,
                                                        pattern: vm.page.pattern,
                                                        replace: vm.page.replace,
                                                        name: vm.page.name,
                                                        id: $stateParams.id,
                                                        provider: vm.page.provider,
                                                        catalogId: vm.page.catalog.id,
                                                        catalogName: vm.page.catalog.name,
                                                        showPic: true,
                                                        version: '4.0',
                                                        type: 'XML',
                                                        productTemplateId: vm.page.id ? vm.page.id : '',
                                                        hashtags: vm.hashtags,
                                                        modelBlendent: vm.page.modelBlendent,
                                                        modelData: vm.page.modelData,
                                                        modelPath: vm.page.modelPath,
                                                        modelType: vm.page.modelType,
                                                        storeIds: [],
                                                        source: 'editor',
                                                        productType: vm.page.productType
                                                    };
                                                }]
                                            }
                                        }).result.then(function (isReturn) {
                                            if (isReturn) {
                                                clearPageStorageInfo();
                                                MessageService.success("发布成功！");
                                                $state.go('templateList', {reload: true})
                                            }
                                            vm.isSaving = false;
                                        });
                                    }
                                    if (attr == 2) {
                                        // if (!checkPageFonts(template.pages.page)) {
                                        //     vm.isSaving = false;
                                        //     return;
                                        // }
                                        vm.isSaving = false;
                                        $uibModal.open({
                                            templateUrl: 'app/entities/page/modal/document-detection.html',
                                            controller: 'DocumentDetectionController',
                                            controllerAs: 'vm',
                                            size: 'lg',
                                            resolve: {
                                                entity: [function () {
                                                    return {
                                                        document: template,
                                                        bindingType: vm.page.bindingType,
                                                        pattern: vm.page.pattern,
                                                        replace: vm.page.replace,
                                                        name: vm.page.name,
                                                        id: $stateParams.id,
                                                        provider: vm.page.provider,
                                                        catalogId: vm.page.catalog.id,
                                                        catalogName: vm.page.catalog.name,
                                                        showPic: true,
                                                        version: '4.0',
                                                        type: 'PRODUCT',
                                                        productTemplateId: vm.page.id ? vm.page.id : '',
                                                        hashtags: vm.hashtags,
                                                        modelBlendent: vm.page.modelBlendent,
                                                        modelData: vm.page.modelData,
                                                        modelPath: vm.page.modelPath,
                                                        modelType: vm.page.modelType,
                                                        storeIds: [],
                                                        source: 'editor',
                                                        productType: vm.page.productType
                                                    };
                                                }]
                                            }
                                        }).result.then(function (isReturn) {
                                            if (isReturn) {
                                                clearPageStorageInfo();
                                                MessageService.success("发布成功！");
                                                $state.go('templateList', {reload: true})

                                            }
                                            vm.isSaving = false;
                                        });
                                    }
                                    $scope.$digest();
                                },
                                error: function (request) {
                                    MessageService.error("文件上传失败");
                                    vm.isSaving = false;
                                }
                            });
                        },
                        letterRendering: true,
                        useCORS: true,
                        width: width * _ratio,
                        height: height * _ratio,
                        windowWidth: document.body.scrollWidth,
                        windowHeight: document.body.scrollHeight,
                        x: $scope.lastPage.isScene ? (-($scope.lastPage.scene.geometry.width - $scope.lastPage.scene.geometry.width * _ratio) / 2) : -($scope.lastPage.mediabox.width - $scope.lastPage.mediabox.width * _ratio) / 2,
                        y: $scope.lastPage.isScene ? (-($scope.lastPage.scene.geometry.height - $scope.lastPage.scene.geometry.height * _ratio) / 2) : -($scope.lastPage.mediabox.height - $scope.lastPage.mediabox.height * _ratio) / 2,
                        ratio: _ratio || 1,
                        backgroundColor: "rgba(0, 0, 0, 0)"
                    });
                })
            },200)
            // });
        }
        $scope.exitSureCb = function(){
            if(!vm.operation){
                $scope.exitPageHide();
            }else{
                vm.exitSure = true;
                MessageService.confirm({
                    title:'温馨提示',
                    goback:'取消',
                    cancel:'不保存',
                    confirm:'保存',
                    msg:'退出前是否需要保存已变更的内容?'
                },function(){
                    $scope.exitPage();
                },function (flag) {
                    if (flag) {
                        $scope.exitPageHide();
                    }
                })
            }
        }
        function isRepeat(arr) {
            var hash = {};
            for (var i in arr) {
                if (hash[arr[i]]) {
                    return true;
                }
                hash[arr[i]] = true;
            }
            return false;
        }

        function getTemplate(template, attr) {
            var isSave = true;
            template.bindingtype = vm.page.bindingType;
            template.pattern = vm.page.pattern;
            template.cover = angular.copy(vm.page.cover);
            template.replace = vm.page.replace;
            template.version = "4.0";
            template.addpage = vm.page.addpage;
            template.minpage = vm.page.minpage;
            template.maxpage = vm.page.maxpage;
            template.addunit = vm.page.addunit;
            template.xLines={line:vm.sublinesX};
            template.yLines={line:vm.sublinesY};
            var tipArr = [], variableData = [];
            angular.forEach(template.pages.page, function (item, i) {
                item.centerrotation = true;
                if (item.background) {
                    item.background.offsetx = PxTurnMm(item.background.offsetx);
                    item.background.offsety = PxTurnMm(item.background.offsety);
                }
                item.mediabox = {
                    width: PxTurnMm(item.mediabox.width),
                    height: PxTurnMm(item.mediabox.height),
                    x: 0,
                    y: 0
                };
                item.trimbox = {
                    width: PxTurnMm(item.trimbox.width),
                    height: PxTurnMm(item.trimbox.height),
                    x: PxTurnMm(item.trimbox.x),
                    y: PxTurnMm(item.trimbox.y)
                };

                item.editbox = {
                    width: PxTurnMm(item.editbox.width),
                    height: PxTurnMm(item.editbox.height),
                    x: PxTurnMm(item.editbox.x),
                    y: PxTurnMm(item.editbox.y)
                };
                if (item.editboxes && item.editboxes.editbox) {
                    item.editboxes.editbox.forEach(function (editbox) {
                        editbox.width = PxTurnMm(editbox.width);
                        editbox.height = PxTurnMm(editbox.height);
                        editbox.x = PxTurnMm(editbox.x);
                        editbox.y = PxTurnMm(editbox.y);
                    })
                }
                if (item.scene) {
                    item.scene.resource = {
                        provider: 'qiniu',
                        identifier: item.scene.background.resource.identifier
                    }
                    item.scene.geometry = {
                        width: PxTurnMm(item.scene.geometry.width),
                        height: PxTurnMm(item.scene.geometry.height),
                        x: PxTurnMm(item.scene.geometry.x),
                        y: PxTurnMm(item.scene.geometry.y)
                    };
                    if (item.scene.imagebox) {
                        item.scene.imagebox.geometry = {
                            width: PxTurnMm(item.scene.imagebox.geometry.width),
                            height: PxTurnMm(item.scene.imagebox.geometry.height),
                            x: PxTurnMm(item.scene.imagebox.geometry.x),
                            y: PxTurnMm(item.scene.imagebox.geometry.y)
                        };
                        item.scene.imagebox.rotation = {
                            angle: item.scene.imagebox.rotation.angle
                        };
                    }
                    item.scene.hierarchy = item.scene.hierarchy;
                }

                if (item.barcode && item.barcode.geometry
                    && item.barcode.geometry.width > 0.01 && item.barcode.geometry.height > 0.01) {
                    item.barcode = {
                        geometry: {
                            width: PxTurnMm(item.barcode.geometry.width),
                            height: PxTurnMm(item.barcode.geometry.height),
                            x: PxTurnMm(item.barcode.geometry.x),
                            y: PxTurnMm(item.barcode.geometry.y)
                        },
                        rotation: angular.copy(item.barcode.rotation),
                    };
                    if (!item.unreplace) {
                        tipArr.push(i + 1);
                    }
                } else {
                    item.barcode = null;
                }
                if (item.qrcode && item.qrcode.geometry
                    && item.qrcode.geometry.width > 0.01 && item.qrcode.geometry.height > 0.01) {
                    item.qrcode = {
                        geometry: {
                            width: PxTurnMm(item.qrcode.geometry.width),
                            height: PxTurnMm(item.qrcode.geometry.height),
                            x: PxTurnMm(item.qrcode.geometry.x),
                            y: PxTurnMm(item.qrcode.geometry.y)
                        },
                        rotation: angular.copy(item.qrcode.rotation),
                    };
                    if (!item.unreplace) {
                        tipArr.push(i + 1);
                    }
                } else {
                    item.qrcode = null;
                }

                angular.forEach(item.levels.level, function (level, l) {
                    if (level.variable) {
                        variableData.push(level.name)
                    }
                    if (level.imageart && level.imageart.current) {
                        var art = level.imageart;
                        art.geometry = {
                            width: PxTurnMm(art.geometry.width),
                            height: PxTurnMm(art.geometry.height),
                            x: PxTurnMm(art.geometry.x),
                            y: PxTurnMm(art.geometry.y)
                        };
                        art.offsetx = PxTurnMm(art.offsetx);
                        art.offsety = PxTurnMm(art.offsety);
                        art.rotation.angle = -art.rotation.angle;
                    }
                    if (level.imagebox && level.imagebox.current) {
                        var img = level.imagebox;
                        if (img.geometry.width <= 1 || img.geometry.height <= 1) {
                            $scope.isHasGeometry = false;
                        }
                        ;
                        img.geometry = {
                            width: PxTurnMm(img.geometry.width),
                            height: PxTurnMm(img.geometry.height),
                            x: PxTurnMm(img.geometry.x),
                            y: PxTurnMm(img.geometry.y)
                        };

                        if (img.image) {
                            img.image = {
                                offsetx: PxTurnMm(img.image.offsetx),
                                offsety: PxTurnMm(img.image.offsety),
                                scale: img.image.scale,
                                angle: img.image.angle,
                                resource: {
                                    identifier: img.image.resource ? img.image.resource.identifier : '',
                                    provider: img.image.resource ? img.image.resource.provider : ''
                                },
                                resourceid: img.image.resourceid
                            }
                        }
                        if (attr == 2) {
                            if (!img.image || img.image.resource.identifier == "")
                                isSave = false;
                        }
                    }
                    if (level.textbox && level.textbox.current) {
                        var text = level.textbox;
                        if (text.text == '') {
                            level.textbox = null;
                        } else {
                            text.geometry = {
                                width: PxTurnMm(text.geometry.width),
                                height: PxTurnMm(text.geometry.height),
                                x: PxTurnMm(text.geometry.x),
                                y: PxTurnMm(text.geometry.y)
                            }
                            text.rotation.angle = -text.rotation.angle;
                        }
                    }
                    if (level.textdocument && level.textdocument.current) {
                        var textdocument = level.textdocument;
                        textdocument.background.offsetx = PxTurnMm(textdocument.background.offsetx);
                        textdocument.background.offsety = PxTurnMm(textdocument.background.offsety);
                        textdocument.geometry = {
                            width: PxTurnMm(textdocument.geometry.width),
                            height: PxTurnMm(textdocument.geometry.height),
                            x: PxTurnMm(textdocument.geometry.x),
                            y: PxTurnMm(textdocument.geometry.y)
                        }
                        angular.forEach(textdocument.levels.level, function (l) {
                            if (l.imageart) {
                                var imageart = l.imageart;
                                imageart.geometry = {
                                    width: PxTurnMm(imageart.geometry.width),
                                    height: PxTurnMm(imageart.geometry.height),
                                    x: PxTurnMm(imageart.geometry.x),
                                    y: PxTurnMm(imageart.geometry.y)
                                };
                                imageart.offsetx = PxTurnMm(imageart.offsetx);
                                imageart.offsety = PxTurnMm(imageart.offsety);
                                imageart.rotation.angle = -imageart.rotation.angle;
                            }
                            if (l.textbox) {
                                if (l.textbox.text == '') {
                                    l.textbox = null;
                                } else {
                                    l.textbox.geometry = {
                                        width: PxTurnMm(l.textbox.geometry.width),
                                        height: PxTurnMm(l.textbox.geometry.height),
                                        x: PxTurnMm(l.textbox.geometry.x),
                                        y: PxTurnMm(l.textbox.geometry.y)
                                    }
                                    l.textbox.rotation.angle = -l.textbox.rotation.angle;
                                }
                            }
                        })
                    }
                    if (level.calTitleBox && level.calTitleBox.current) {
                        var _calTitleBox = angular.copy(level.calTitleBox);
                        level.calTitleBox.geometry = {
                            width: PxTurnMm(level.calTitleBox.geometry.width),
                            height: PxTurnMm(level.calTitleBox.geometry.height),
                            x: PxTurnMm(level.calTitleBox.geometry.x),
                            y: PxTurnMm(level.calTitleBox.geometry.y)
                        };
                        level.calTitleBox.rotation.angle = -level.calTitleBox.rotation.angle;
                        level.calTitleBox.settings={
                            border:level.calTitleBox.settings.border,
                            items:{
                                item:angular.copy(_calTitleBox.settings.items.item?_calTitleBox.settings.items.item:_calTitleBox.settings.items)
                            }
                        };
                        level.calTitleBox.layout={
                            geometry: {
                                width:level.calTitleBox.layout.width>=0?level.calTitleBox.layout.width:level.calTitleBox.layout.geometry.width,
                                height:level.calTitleBox.layout.height>=0?level.calTitleBox.layout.height:level.calTitleBox.layout.geometry.height,
                                x:0,
                                y:0,
                            },
                            previewUrl:level.calTitleBox.layout.previewUrl,
                            type:level.calTitleBox.layout.type,
                            items:{
                                item:angular.copy(_calTitleBox.layout.items.item?_calTitleBox.layout.items.item:_calTitleBox.layout.items),
                            }
                        };
                        level.calTitleBox.layout.items.item.forEach(function (item) {
                            item.geometry = {
                                width:item.w>=0?item.w:item.geometry.width,
                                height:item.h>=0?item.h:item.geometry.height,
                                x:item.x>=0?item.x:item.geometry.x,
                                y:item.y>=0?item.y:item.geometry.y,
                            }
                        })
                    }
                    if (level.calMonthBox && level.calMonthBox.current) {
                        var _calMonthBox = angular.copy(level.calMonthBox);
                        level.calMonthBox.geometry = {
                            width: PxTurnMm(level.calMonthBox.geometry.width),
                            height: PxTurnMm(level.calMonthBox.geometry.height),
                            x: PxTurnMm(level.calMonthBox.geometry.x),
                            y: PxTurnMm(level.calMonthBox.geometry.y)
                        };
                        level.calMonthBox.rotation.angle = -level.calMonthBox.rotation.angle;

                        level.calMonthBox.weekStyles={item:angular.copy(_calMonthBox.weekStyles.item?_calMonthBox.weekStyles.item:_calMonthBox.weekStyles)};
                        level.calMonthBox.weekLayout={
                            geometry: {
                                width:level.calMonthBox.weekLayout.width>=0?level.calMonthBox.weekLayout.width:level.calMonthBox.weekLayout.geometry.width,
                                height:level.calMonthBox.weekLayout.height>=0?level.calMonthBox.weekLayout.height:level.calMonthBox.weekLayout.geometry.height,
                                x:0,
                                y:0,
                            },
                            items:{
                                item:angular.copy(_calMonthBox.weekLayout.items.item?_calMonthBox.weekLayout.items.item:_calMonthBox.weekLayout.items)
                            },
                            type:level.calMonthBox.weekLayout.type,
                            previewUrl:level.calMonthBox.weekLayout.previewUrl,
                        };
                        level.calMonthBox.weekLayout.items.item.forEach(function (weekLayout) {
                            weekLayout.geometry = {
                                width:weekLayout.w>=0?weekLayout.w:weekLayout.geometry.width,
                                height:weekLayout.h>=0?weekLayout.h:weekLayout.geometry.height,
                                x:weekLayout.x>=0?weekLayout.x:weekLayout.geometry.x,
                                y:weekLayout.y>=0?weekLayout.y:weekLayout.geometry.y,
                            }
                        })
                        level.calMonthBox.dateStyles={item:angular.copy(_calMonthBox.dateStyles.item?_calMonthBox.dateStyles.item:_calMonthBox.dateStyles)},
                        level.calMonthBox.dateLayout={
                            geometry: {
                                width:level.calMonthBox.dateLayout.width>=0?level.calMonthBox.dateLayout.width:level.calMonthBox.dateLayout.geometry.width,
                                height:level.calMonthBox.dateLayout.height>=0?level.calMonthBox.dateLayout.height:level.calMonthBox.dateLayout.geometry.height,
                                x:0,
                                y:0,
                            },
                            items:{
                                item:angular.copy(_calMonthBox.dateLayout.items.item?_calMonthBox.dateLayout.items.item:_calMonthBox.dateLayout.items)
                            },
                            type:level.calMonthBox.dateLayout.type,
                            previewUrl:level.calMonthBox.dateLayout.previewUrl
                        };
                        level.calMonthBox.dateLayout.items.item.forEach(function (dateLayout) {
                            dateLayout.geometry = {
                                width:dateLayout.w>=0?dateLayout.w:dateLayout.geometry.width,
                                height:dateLayout.h>=0?dateLayout.h:dateLayout.geometry.height,
                                x:dateLayout.x>=0?dateLayout.x:dateLayout.geometry.x,
                                y:dateLayout.y>=0?dateLayout.y:dateLayout.geometry.y,
                            }
                        })
                        level.calMonthBox.weekStyles.item.forEach(function (weekStyle) {
                            var _items = angular.copy(weekStyle.items.item?weekStyle.items.item:weekStyle.items);
                            _items.forEach(function (_item){
                                if(_item.w && _item.h){
                                    _item.geometry = {
                                        width:_item.w,
                                        height:_item.h,
                                        x:_item.x,
                                        y:_item.y,
                                    }
                                }
                            })
                            weekStyle.items = {
                                item:_items
                            }
                        })
                        level.calMonthBox.dateStyles.item.forEach(function (dateStyle) {
                            var _items = angular.copy(dateStyle.items.item?dateStyle.items.item:dateStyle.items);
                            _items.forEach(function (_item){
                                if(_item.w && _item.h){
                                    _item.geometry = {
                                        width:_item.w,
                                        height:_item.h,
                                        x:_item.x,
                                        y:_item.y,
                                    }
                                }
                            })
                            dateStyle.items = {
                                item:_items
                            }
                        })
                    }
                })
            });

            if ($scope.template.deletedPages && $scope.template.deletedPages.page && $scope.template.deletedPages.page.length) {
                pageToMM(template.deletedPages.page, $scope.template.deletedPages);
            }
            if ($scope.template.backupPages && $scope.template.backupPages.list && $scope.template.backupPages.list.length) {
                pageToMM(template.backupPages.list, $scope.template.backupPages.list);
            }
            return {
                tipArr: tipArr,
                template: template,
                isSave: isSave,
                variableData: variableData
            }
        }

        function pageToMM(pages, tempPages) {
            angular.forEach(pages, function (item, i) {
                item.centerrotation = true;
                if (item.background) {
                    item.background.offsetx = PxTurnMm(item.background.offsetx);
                    item.background.offsety = PxTurnMm(item.background.offsety);
                }
                item.mediabox = {
                    width: PxTurnMm(item.mediabox.width),
                    height: PxTurnMm(item.mediabox.height),
                    x: 0,
                    y: 0
                };
                item.trimbox = {
                    width: PxTurnMm(item.trimbox.width),
                    height: PxTurnMm(item.trimbox.height),
                    x: PxTurnMm(item.trimbox.x),
                    y: PxTurnMm(item.trimbox.y)
                };

                item.editbox = {
                    width: PxTurnMm(item.editbox.width),
                    height: PxTurnMm(item.editbox.height),
                    x: PxTurnMm(item.editbox.x),
                    y: PxTurnMm(item.editbox.y)
                };
                if (item.editboxes && item.editboxes.editbox) {
                    item.editboxes.editbox.forEach(function (editbox) {
                        editbox.width = PxTurnMm(editbox.width);
                        editbox.height = PxTurnMm(editbox.height);
                        editbox.x = PxTurnMm(editbox.x);
                        editbox.y = PxTurnMm(editbox.y);
                    })
                }
                if (item.scene) {
                    item.scene.resource = {
                        provider: 'qiniu',
                        identifier: item.scene.background.resource.identifier
                    }
                    item.scene.geometry = {
                        width: PxTurnMm(item.scene.geometry.width),
                        height: PxTurnMm(item.scene.geometry.height),
                        x: PxTurnMm(item.scene.geometry.x),
                        y: PxTurnMm(item.scene.geometry.y)
                    };
                    if (item.scene.imagebox) {
                        item.scene.imagebox.geometry = {
                            width: PxTurnMm(item.scene.imagebox.geometry.width),
                            height: PxTurnMm(item.scene.imagebox.geometry.height),
                            x: PxTurnMm(item.scene.imagebox.geometry.x),
                            y: PxTurnMm(item.scene.imagebox.geometry.y)
                        };
                        item.scene.imagebox.rotation = {
                            angle: item.scene.imagebox.rotation.angle
                        };
                    }
                    item.scene.hierarchy = item.scene.hierarchy;
                }

                if (item.barcode && item.barcode.geometry) {
                    item.barcode = {
                        geometry: {
                            width: PxTurnMm(item.barcode.geometry.width),
                            height: PxTurnMm(item.barcode.geometry.height),
                            x: PxTurnMm(item.barcode.geometry.x),
                            y: PxTurnMm(item.barcode.geometry.y)
                        },
                        rotation: angular.copy(item.barcode.rotation),
                    };
                } else {
                    item.barcode = null;
                }
                if (item.qrcode && item.qrcode.geometry) {
                    item.qrcode = {
                        geometry: {
                            width: PxTurnMm(item.qrcode.geometry.width),
                            height: PxTurnMm(item.qrcode.geometry.height),
                            x: PxTurnMm(item.qrcode.geometry.x),
                            y: PxTurnMm(item.qrcode.geometry.y)
                        },
                        rotation: angular.copy(item.qrcode.rotation),
                    };
                } else {
                    item.qrcode = null;
                }

                angular.forEach(item.levels.level, function (level, l) {
                    if (level.imageart && level.imageart.current) {
                        var art = level.imageart;
                        art.geometry = {
                            width: PxTurnMm(art.geometry.width),
                            height: PxTurnMm(art.geometry.height),
                            x: PxTurnMm(art.geometry.x),
                            y: PxTurnMm(art.geometry.y)
                        };
                        art.offsetx = PxTurnMm(art.offsetx);
                        art.offsety = PxTurnMm(art.offsety);
                        art.rotation.angle = -art.rotation.angle;
                    }
                    if (level.imagebox && level.imagebox.current) {
                        var img = level.imagebox;
                        if (img.geometry.width <= 1 || img.geometry.height <= 1) {
                            $scope.isHasGeometry = false;
                        }
                        ;
                        img.geometry = {
                            width: PxTurnMm(img.geometry.width),
                            height: PxTurnMm(img.geometry.height),
                            x: PxTurnMm(img.geometry.x),
                            y: PxTurnMm(img.geometry.y)
                        };

                        if (img.image) {
                            img.image = {
                                offsetx: PxTurnMm(img.image.offsetx),
                                offsety: PxTurnMm(img.image.offsety),
                                scale: img.image.scale,
                                angle: img.image.angle,
                                resource: {
                                    identifier: img.image.resource ? img.image.resource.identifier : '',
                                    provider: img.image.resource ? img.image.resource.provider : ''
                                },
                                resourceid: img.image.resourceid
                            }
                        }
                    }
                    if (level.textbox && level.textbox.current) {
                        var text = level.textbox;
                        if (text.text == '') {
                            level.textbox = null;
                        } else {
                            text.geometry = {
                                width: PxTurnMm(text.geometry.width),
                                height: PxTurnMm(text.geometry.height),
                                x: PxTurnMm(text.geometry.x),
                                y: PxTurnMm(text.geometry.y)
                            }
                            text.rotation.angle = -text.rotation.angle;
                        }
                    }
                    if (level.textdocument && level.textdocument.current) {
                        var textdocument = level.textdocument;
                        textdocument.background.offsetx = PxTurnMm(textdocument.background.offsetx);
                        textdocument.background.offsety = PxTurnMm(textdocument.background.offsety);
                        textdocument.geometry = {
                            width: PxTurnMm(textdocument.geometry.width),
                            height: PxTurnMm(textdocument.geometry.height),
                            x: PxTurnMm(textdocument.geometry.x),
                            y: PxTurnMm(textdocument.geometry.y)
                        }
                        angular.forEach(textdocument.levels.level, function (l) {
                            if (l.imageart) {
                                var imageart = l.imageart;
                                imageart.geometry = {
                                    width: PxTurnMm(imageart.geometry.width),
                                    height: PxTurnMm(imageart.geometry.height),
                                    x: PxTurnMm(imageart.geometry.x),
                                    y: PxTurnMm(imageart.geometry.y)
                                };
                                imageart.offsetx = PxTurnMm(imageart.offsetx);
                                imageart.offsety = PxTurnMm(imageart.offsety);
                                imageart.rotation.angle = -imageart.rotation.angle;
                            }
                            if (l.textbox) {
                                if (l.textbox.text == '') {
                                    l.textbox = null;
                                } else {
                                    l.textbox.geometry = {
                                        width: PxTurnMm(l.textbox.geometry.width),
                                        height: PxTurnMm(l.textbox.geometry.height),
                                        x: PxTurnMm(l.textbox.geometry.x),
                                        y: PxTurnMm(l.textbox.geometry.y)
                                    }
                                    l.textbox.rotation.angle = -l.textbox.rotation.angle;
                                }
                            }
                        })
                    }
                    if (level.calTitleBox && level.calTitleBox.current) {
                        var _calTitleBox = angular.copy(level.calTitleBox);
                        level.calTitleBox.geometry = {
                            width: PxTurnMm(level.calTitleBox.geometry.width),
                            height: PxTurnMm(level.calTitleBox.geometry.height),
                            x: PxTurnMm(level.calTitleBox.geometry.x),
                            y: PxTurnMm(level.calTitleBox.geometry.y)
                        };
                        level.calTitleBox.rotation.angle = -level.calTitleBox.rotation.angle;
                        level.calTitleBox.settings={
                            border:level.calTitleBox.settings.border,
                            items:{
                                item:angular.copy(_calTitleBox.settings.items.item?_calTitleBox.settings.items.item:_calTitleBox.settings.items)
                            }
                        };
                        level.calTitleBox.layout={
                            geometry: {
                                width:level.calTitleBox.layout.width>=0?level.calTitleBox.layout.width:level.calTitleBox.layout.geometry.width,
                                height:level.calTitleBox.layout.height>=0?level.calTitleBox.layout.height:level.calTitleBox.layout.geometry.height,
                                x:0,
                                y:0,
                            },
                            previewUrl:level.calTitleBox.layout.previewUrl,
                            type:level.calTitleBox.layout.type,
                            items:{
                                item:angular.copy(_calTitleBox.layout.items.item?_calTitleBox.layout.items.item:_calTitleBox.layout.items),
                            }
                        };
                        level.calTitleBox.layout.items.item.forEach(function (item) {
                            item.geometry = {
                                width:item.w>=0?item.w:item.geometry.width,
                                height:item.h>=0?item.h:item.geometry.height,
                                x:item.x>=0?item.x:item.geometry.x,
                                y:item.y>=0?item.y:item.geometry.y,
                            }
                        })
                    }
                    if (level.calMonthBox && level.calMonthBox.current) {
                        var _calMonthBox = angular.copy(level.calMonthBox);
                        level.calMonthBox.geometry = {
                            width: PxTurnMm(level.calMonthBox.geometry.width),
                            height: PxTurnMm(level.calMonthBox.geometry.height),
                            x: PxTurnMm(level.calMonthBox.geometry.x),
                            y: PxTurnMm(level.calMonthBox.geometry.y)
                        };
                        level.calMonthBox.rotation.angle = -level.calMonthBox.rotation.angle;

                        level.calMonthBox.weekStyles={item:angular.copy(_calMonthBox.weekStyles.item?_calMonthBox.weekStyles.item:_calMonthBox.weekStyles)};
                        level.calMonthBox.weekLayout={
                            geometry: {
                                width:level.calMonthBox.weekLayout.width>=0?level.calMonthBox.weekLayout.width:level.calMonthBox.weekLayout.geometry.width,
                                height:level.calMonthBox.weekLayout.height>=0?level.calMonthBox.weekLayout.height:level.calMonthBox.weekLayout.geometry.height,
                                x:0,
                                y:0,
                            },
                            items:{
                                item:angular.copy(_calMonthBox.weekLayout.items.item?_calMonthBox.weekLayout.items.item:_calMonthBox.weekLayout.items)
                            },
                            type:level.calMonthBox.weekLayout.type,
                            previewUrl:level.calMonthBox.weekLayout.previewUrl,
                        };
                        level.calMonthBox.weekLayout.items.item.forEach(function (weekLayout) {
                            weekLayout.geometry = {
                                width:weekLayout.w>=0?weekLayout.w:weekLayout.geometry.width,
                                height:weekLayout.h>=0?weekLayout.h:weekLayout.geometry.height,
                                x:weekLayout.x>=0?weekLayout.x:weekLayout.geometry.x,
                                y:weekLayout.y>=0?weekLayout.y:weekLayout.geometry.y,
                            }
                        })
                        level.calMonthBox.dateStyles={item:angular.copy(_calMonthBox.dateStyles.item?_calMonthBox.dateStyles.item:_calMonthBox.dateStyles)},
                            level.calMonthBox.dateLayout={
                                geometry: {
                                    width:level.calMonthBox.dateLayout.width>=0?level.calMonthBox.dateLayout.width:level.calMonthBox.dateLayout.geometry.width,
                                    height:level.calMonthBox.dateLayout.height>=0?level.calMonthBox.dateLayout.height:level.calMonthBox.dateLayout.geometry.height,
                                    x:0,
                                    y:0,
                                },
                                items:{
                                    item:angular.copy(_calMonthBox.dateLayout.items.item?_calMonthBox.dateLayout.items.item:_calMonthBox.dateLayout.items)
                                },
                                type:level.calMonthBox.dateLayout.type,
                                previewUrl:level.calMonthBox.dateLayout.previewUrl
                            };
                        level.calMonthBox.dateLayout.items.item.forEach(function (dateLayout) {
                            dateLayout.geometry = {
                                width:dateLayout.w>=0?dateLayout.w:dateLayout.geometry.width,
                                height:dateLayout.h>=0?dateLayout.h:dateLayout.geometry.height,
                                x:dateLayout.x>=0?dateLayout.x:dateLayout.geometry.x,
                                y:dateLayout.y>=0?dateLayout.y:dateLayout.geometry.y,
                            }
                        })
                        level.calMonthBox.weekStyles.item.forEach(function (weekStyle) {
                            var _items = angular.copy(weekStyle.items.item?weekStyle.items.item:weekStyle.items);
                            weekStyle.items = {
                                item:_items
                            }
                        })
                        level.calMonthBox.dateStyles.item.forEach(function (dateStyle) {
                            var _items = angular.copy(dateStyle.items.item?dateStyle.items.item:dateStyle.items);
                            dateStyle.items = {
                                item:_items
                            }
                        })
                    }
                })
            });
        }

        function loadPageToPx(templatePage, pageIndex, callback) {
            if (templatePage.loaded) {
                return;
            }
            if (templatePage.background && templatePage.background.resource && templatePage.background.resource.identifier) {
                var background = templatePage.background;
                var pageW = templatePage.mediabox.width,
                    pageH = templatePage.mediabox.height;
                if (background.resource && background.resource.identifier) {
                    getBackgroundSource(background.resource, pageW, pageH, background)
                }
            }
            var promise_list = [];
            if (templatePage.levels && templatePage.levels.level) {
                angular.forEach(templatePage.levels.level, function (level, n) {
                    if (level.imageart && level.imageart.geometry) {
                        var deferred = $q.defer();
                        var art = level.imageart;
                        $http({url: art.resource.identifier + '?imageInfo'}).success(function (data) {
                            templatePage.levels.level[n].imageart = {
                                geometry: art.geometry,
                                rotation: {
                                    angle: art.rotation.angle
                                },
                                type: art.type,
                                resource: {
                                    identifier: art.resource.identifier,
                                    provider: art.resource.provider,
                                    width: data.width,
                                    height: data.height
                                },
                                scale: art.scale,
                                offsetx: art.offsetx,
                                offsety: art.offsety,
                                unit: 'mm',
                                current: 'imageart',
                                levelI: n,
                                pageI: pageIndex,
                                lock: art.lock,
                                ctrlKey: false,
                                transparency: art.transparency,
                                onlyshow: art.onlyshow,
                                movable: art.movable,
                                editable: art.editable,
                            }
                            deferred.resolve("ok");
                        }).error(function (error) {
                            MessageService.error("获取图片信息失败");
                            deferred.resolve("error");
                        });
                        promise_list.push(deferred.promise);
                    }
                    if (level.imagebox && level.imagebox.geometry) {
                        var image = level.imagebox;
                        if (image.shadow == null) {
                            image.shadow = {
                                color: '#777777',
                                x: 0,
                                y: 0,
                                blur: 0
                            }
                        }
                        if (image.border == null) {
                            image.border = {
                                shape: 'Rectangle',
                                radius: {
                                    lt: 0,
                                    rt: 0,
                                    rb: 0,
                                    lb: 0,
                                    all: 0,
                                    filletType: 'Fixed'
                                },
                                "edge": {
                                    top: 0,
                                    right: 0,
                                    bottom: 0,
                                    left: 0
                                },
                                lineWidth: 0,
                                type: "Color",
                                lineType: "solid",
                                resource: {
                                    "identifier": ''
                                },
                                color: '#000000',
                            }
                        }
                        templatePage.levels.level[n].imagebox = {
                            geometry: image.geometry,
                            rotation: angular.copy(image.rotation),
                            mask: angular.copy(image.mask),
                            image: angular.copy(image.image),
                            maskUrl: 'content/images/mask_souce2.png',
                            imgUrl: 'content/images/mask_souce2.png',
                            unit: 'mm',
                            current: 'imagebox',
                            levelI: n,
                            pageI: pageIndex,
                            lock: image.lock,
                            border: image.border,
                            shadow: image.shadow,
                            ctrlKey: false,
                            transparency: isNaN(image.transparency) ? 1 : image.transparency
                        }


                        if (image.image && image.image.resource && image.image.resource.identifier) {       //qiniu
                            templatePage.levels.level[n].imagebox.image = {
                                resource: {
                                    identifier: image.image ? image.image.resource.identifier : '',
                                    provider: image.image ? image.image.resource.provider : 'qiniu'
                                },
                                imgSize: (!image.image) || image.image.imgSize == null ? '' : image.image.imgSize,
                                parameter: (!image.image) || image.image.parameter == null ? [] : angular.fromJson(image.image.parameter),
                                filter: (!image.image) || image.image.filter == null ? '' : image.image.filter,
                                offsetx: (!image.image) || image.image.offsetx == null ? 0 : image.image.offsetx,
                                offsety: (!image.image) || image.image.offsety == null ? 0 : image.image.offsety,
                                angle: image.image && image.image.angle ? image.image.angle : 0,
                                scale: (!image.image) || image.image.scale == 1 ? 1 : image.image.scale,
                                index: (!image.image) ? '' : image.image.index,
                                resourceid: (!image.image) ? '' : image.image.resourceid,
                            }
                            templatePage.levels.level[n].imagebox.imgUrl = image.image.resource.identifier + '?imageMogr2/auto-orient/thumbnail/!40p';
                            if (image.image.angle != 0) {
                                templatePage.levels.level[n].imagebox.imgUrl += '/rotate/' + image.image.angle
                            }
                            var promise = getBackgroundSource1(templatePage.levels.level[n].imagebox.image.resource, templatePage.levels.level[n].imagebox.geometry.width, templatePage.levels.level[n].imagebox.geometry.height, templatePage.levels.level[n].imagebox.image)
                            if (promise) {
                                promise_list.push(promise);
                            }
                        } else {
                            var deferred = $q.defer();
                            var imagecanvas = document.createElement('canvas');
                            var imagecontext = imagecanvas.getContext('2d');
                            var newImg = document.createElement('img');
                            newImg.crossOrigin = "Anonymous";
                            newImg.src = 'content/images/mask_souce2.png';
                            newImg.onload = function () {
                                newImg.onload = null;
                                var width = newImg.width;
                                var height = newImg.height;
                                if (image.mask && image.mask.resource && image.mask.resource.identifier) {
                                    var masks = document.createElement('img');
                                    masks.crossOrigin = "anonymous";
                                    masks.onload = function () {
                                        masks.onload = null;
                                        imagecanvas.width = width;
                                        imagecanvas.height = height;
                                        imagecontext.drawImage(masks, 0, 0, width, height);
                                        imagecontext.globalCompositeOperation = 'source-in';
                                        imagecontext.drawImage(newImg, 0, 0);
                                        templatePage.levels.level[n].imagebox.bgImg = ImageService.dataURLtoBlob(imagecanvas.toDataURL());
                                        deferred.resolve("ready");
                                        $scope.$apply();
                                    };
                                    masks.src = image.mask.resource.identifier;
                                }else{
                                    deferred.resolve("ready");
                                }
                            };
                            newImg.src = 'content/images/mask_souce2.png';
                            // promise_list.push(deferred.promise);
                        }
                        if (templatePage.levels.level[n].imagebox.mask && templatePage.levels.level[n].imagebox.mask.resource && templatePage.levels.level[n].imagebox.mask.resource.identifier) {
                            // imageboxResourceCanvas(templatePage.levels.level[n].imagebox);
                            // var deferred = $q.defer();
                            if (templatePage.levels.level[n].imagebox.image && templatePage.levels.level[n].imagebox.image.resource.identifier) {
                                // imageboxResourceCanvas(templatePage.levels.level[n].imagebox, function () {
                                //     // deferred.resolve("ready");
                                // });
                            } else {
                                // maskScale(null, templatePage.levels.level[n].imagebox, n, templatePage.levels.level[n].imagebox.mask.resource.identifier, function () {
                                //     // deferred.resolve("ready");
                                // });
                            }
                            // promise_list.push(deferred.promise);
                        }
                    }
                    if (level.textbox && level.textbox.geometry) {
                        var text = level.textbox;
                        templatePage.levels.level[n].textbox = {
                            geometry: text.geometry,
                            identifier: text.identifier,
                            rotation: {
                                angle: text.rotation.angle
                            },
                            angle: angular.copy(text.angle),
                            status: angular.copy(text.status),
                            style: angular.copy(text.style),
                            type: angular.copy(text.type),
                            text: angular.copy(text.text),
                            version: text.version,
                            unit: 'mm',
                            current: 'textbox',
                            levelI: n,
                            pageI: pageIndex,
                            lock: text.lock,
                            ctrlKey: false,
                            transparency: text.transparency,
                            lineheight: text.style.lineheight,
                            letterspacing: text.style.letterspacing,
                            scale: 1,
                            movable: text.movable,
                            editable: text.editable,
                            fontuuid: text.fontuuid
                        }
                        if (text.fontuuid) {
                            //下载字体
                            var deferred = $q.defer();
                            getFont(templatePage.levels.level[n].textbox,FontManagement, function () {
                                deferred.resolve("ready");
                            });
                            promise_list.push(deferred.promise);
                        }
                    }
                    if (level.textdocument && level.textdocument.geometry) {
                        var textdocument = level.textdocument;
                        templatePage.levels.level[n].textdocument = {
                            background: textdocument.background,
                            geometry: textdocument.geometry,
                            rotation: {
                                angle: textdocument.rotation.angle || 0
                            },
                            unit: 'mm',
                            current: 'textdocument',
                            levels: angular.copy(textdocument.levels),
                            levelI: n,
                            pageI: pageIndex,
                            lock: textdocument.lock,
                            ctrlKey: false,
                            transparency: textdocument.transparency,
                            movable: textdocument.movable,
                            editable: textdocument.editable,
                            scale: textdocument.geometry.width / templatePage.mediabox.width
                        }

                        var backg = templatePage.levels.level[n].textdocument.background;
                        var pageW = templatePage.levels.level[n].textdocument.geometry.width,
                            pageH = templatePage.levels.level[n].textdocument.geometry.height;
                        if (backg.resource && backg.resource.identifier) {
                            var promise = getBackgroundSource(backg.resource, pageW, pageH, backg);
                            if (promise) {
                                promise_list.push(promise);
                            }
                        }

                        angular.forEach(textdocument.levels.level, function (lev, l) {
                            if (lev.imageart && lev.imageart.geometry) {
                                var deferred = $q.defer();
                                var art = lev.imageart;
                                $http({url: art.resource.identifier + '?imageInfo'}).success(function (data) {
                                    templatePage.levels.level[n].textdocument.levels.level[l].imageart = {
                                        geometry: art.geometry,
                                        rotation: {
                                            angle: art.rotation.angle
                                        },
                                        type: art.type,
                                        resource: {
                                            identifier: art.resource.identifier,
                                            provider: art.resource.provider,
                                            width: data.width,
                                            height: data.height
                                        },
                                        scale: art.scale,
                                        offsetx: art.offsetx,
                                        offsety: art.offsety,
                                        unit: 'mm',
                                        current: 'imageart',
                                        levelI: n,
                                        pageI: pageIndex,
                                        lock: false,
                                        transparency: art.transparency,
                                        onlyshow: art.onlyshow,
                                        movable: art.movable,
                                        editable: art.editable,
                                    }
                                    deferred.resolve("ready");
                                }).error(function (error) {
                                    MessageService.error("获取图片信息失败");
                                    deferred.resolve("error");
                                });
                                promise_list.push(deferred.promise);
                            }
                            if (lev.textbox && lev.textbox.geometry) {
                                var text = lev.textbox;
                                templatePage.levels.level[n].textdocument.levels.level[l].textbox = {
                                    geometry: text.geometry,
                                    identifier: text.identifier,
                                    rotation: {
                                        angle: text.rotation.angle
                                    },
                                    angle: angular.copy(text.angle),
                                    status: angular.copy(text.status),
                                    style: angular.copy(text.style),
                                    type: angular.copy(text.type),
                                    text: angular.copy(text.text),
                                    unit: 'mm',
                                    current: 'textbox',
                                    levelI: n,
                                    pageI: pageIndex,
                                    lock: false,
                                    transparency: text.transparency,
                                    lineheight: text.style.lineheight,
                                    letterspacing: text.style.letterspacing,
                                    fontuuid: text.fontuuid
                                }
                                //下载字体
                                if (text.fontuuid) {
                                    var deferred = $q.defer();
                                    getFont(text,FontManagement, function () {
                                        deferred.resolve("ready");
                                    });
                                    fontStyle(text);
                                    promise_list.push(deferred);
                                }
                            }
                        })
                    }
                });
            }

            if (callback) {
                if (promise_list.length == 0) {
                    callback(templatePage);
                } else {
                    $q.all(promise_list).then(function (res) {
                        callback(templatePage);
                    });
                }
            }

            templatePage.loaded = true;
        }

        var seq = 0;
        function pagesToPx(pages, tempPages, flag) {
            angular.forEach(pages, function (page, i) {
                tempPageInfo(page, tempPages, flag,i)
            });
        }
        function tempPageInfo(page, tempPages, flag,i,callback) {
            if (!page.editbox) {
                page.editbox = angular.copy(page.trimbox);
            }
            if (!page.editboxes || !page.editboxes.editbox) {
                page.editboxes = {
                    editbox: [page.editbox]
                };
            }
            if (!page.backup) {
                seq++;
            }
            tempPages.page[i] = {

                isScene: false,
                seq: seq,
                width: MmTurnPx(page.trimbox.width),
                height: MmTurnPx(page.trimbox.height),
                trimbox: getGeometry(page.trimbox),
                mediabox: getGeometry(page.mediabox),
                editbox: getGeometry(page.editbox),
                editboxes: angular.copy(page.editboxes),
                config: angular.copy(page.config),
                outline: angular.copy(page.outline),
                blood: {
                    top: page.trimbox.y,
                    bottom: page.mediabox.height - page.trimbox.y - page.trimbox.height,
                    left: page.trimbox.x,
                    right: page.mediabox.width - page.trimbox.x - page.trimbox.width,
                },
                bloodPx: {
                    top: MmTurnPx(page.trimbox.y),
                    bottom: MmTurnPx(page.mediabox.height - page.trimbox.y - page.trimbox.height),
                    left: MmTurnPx(page.trimbox.x),
                    right: MmTurnPx(page.mediabox.width - page.trimbox.x - page.trimbox.width),
                },
                spread: page.spread,
                backup: page.backup,
                type: page.type,
                standardAddPage: !vm.isCustom && !vm.hasModel && page.backup ? true : false,
                unreplace: page.unreplace || false,
                scale: 1,
                barcode: {},
                qrcode: {},
                uuid: page.uuid,
                background: angular.copy(page.background),
                pagecover: {
                    identifier: page.pagecover && page.pagecover.identifier ? page.pagecover.identifier : '',
                    provider: page.pagecover && page.pagecover.provider ? page.pagecover.provider : '',
                },
                hasBgImg: page.background && page.background.resource.identifier ? true : false,
                bgImg: page.background.resource.identifier ? vm.url + page.background.resource.identifier + '?imageMogr2/interlace/1' : '',
                levels: angular.copy(page.levels),
                unit: 'mm',
                index: i
            };
            tempPages.page[i].editboxes.editbox.forEach(function (editbox, index) {
                tempPages.page[i].editboxes.editbox[index] = getGeometry(editbox);
            })
            tempPages.page[i].custom = {};
            if (page.scene) {
                tempPages.page[i].scene = {
                    background: {
                        resource: {
                            provider: page.scene.resource.provider,
                            identifier: page.scene.resource.identifier
                        }
                    },
                    geometry: getGeometry(page.scene.geometry),
                    imagebox: {
                        geometry: getGeometry(page.scene.imagebox.geometry),
                        rotation: {angle: page.scene.imagebox.rotation.angle}
                    },
                    isScene: true,
                    scale: 1,
                    unit: 'mm',
                    hierarchy: page.scene.hierarchy,
                    mouldid: page.scene.mouldid,
                }
                tempPages.page[i].scene.isScene = true;
                var w = tempPages.page[i].scene.geometry.width;
                var h = tempPages.page[i].scene.geometry.height;
                var originalScale = $con.width() * 0.8 / ($con.height() * 0.8);
                if (originalScale < page.scene.geometry.width / page.scene.geometry.height) {
                    //宽定，高不定
                    tempPages.page[i].scene.width = $con.width() * 0.8;
                    tempPages.page[i].scene.height = $con.width() * 0.8 * h / w;
                } else {

                    //高定，宽不动
                    tempPages.page[i].scene.height = $con.height() * 0.8;
                    tempPages.page[i].scene.width = $con.height() * 0.8 * w / h
                }
                tempPages.page[i].scene.proportion = (w / tempPages.page[i].scene.width);
                var wah = ThreeHundredDpi(page.scene.geometry.width, page.scene.geometry.height);
                tempPages.page[i].scene.widthPx = wah.px1;
                tempPages.page[i].scene.heightPx = wah.px2;
                if (vm.windowH / h >= vm.windowW / w) {
                    tempPages.page[i].scene.ratio = vm.windowW / w * 0.8;
                } else {
                    tempPages.page[i].scene.ratio = vm.windowH / h * 0.8;
                }
                if (vm.windowH1 / h >= vm.windowW1 / w) {
                    tempPages.page[i].scene.ratio1 = vm.windowW1 / w;
                } else {
                    tempPages.page[i].scene.ratio1 = vm.windowH1 / h;
                }
                tempPages.page[i].custom.width = tempPages.page[i].scene.geometry.width;
                tempPages.page[i].custom.height = tempPages.page[i].scene.geometry.height;
            }else{
                tempPages.page[i].custom.width = tempPages.page[i].mediabox.width;
                tempPages.page[i].custom.height = tempPages.page[i].mediabox.height;
            }
            if (tempPages.page[i].uuid == null) {
                tempPages.page[i].uuid = UidService.get();
            }

            if (page.barcode && page.barcode.geometry) {
                var barcode = page.barcode.geometry;
                var angle = 0;
                if (page.barcode.rotation && page.barcode.rotation.angle) {
                    angle = page.barcode.rotation.angle
                }
                tempPages.page[i].barcode = {
                    current: 'barcode',
                    geometry: {
                        width: MmTurnPx(barcode.width),
                        height: MmTurnPx(barcode.height),
                        x: MmTurnPx(barcode.x),
                        y: MmTurnPx(barcode.y),
                    },
                    rotation: {
                        angle: angle
                    },
                    lock: barcode.lock,
                }
            }

            if (page.qrcode && page.qrcode.geometry) {
                var qrcode = page.qrcode.geometry;
                var angle = 0;
                if (page.qrcode.rotation && page.qrcode.rotation.angle) {
                    angle = page.qrcode.rotation.angle
                }
                tempPages.page[i].qrcode = {
                    current: 'qrcode',
                    geometry: {
                        width: MmTurnPx(qrcode.width),
                        height: MmTurnPx(qrcode.height),
                        x: MmTurnPx(qrcode.x),
                        y: MmTurnPx(qrcode.y),
                    },
                    rotation: {
                        angle: angle
                    },
                    lock: qrcode.lock,
                }
            }
            if (page.background && page.background.resource && page.background.resource.identifier) {
                tempPages.page[i].background.offsetx = MmTurnPx(page.background.offsetx);
                tempPages.page[i].background.offsety = MmTurnPx(page.background.offsety);
            }

            angular.forEach(tempPages.page[i].levels.level, function (level, l) {
                if (level.imageart && level.imageart.geometry) {
                    var art = level.imageart;
                    art.current = 'imageart';
                    art.geometry = {
                        width: MmTurnPx(art.geometry.width),
                        height: MmTurnPx(art.geometry.height),
                        x: MmTurnPx(art.geometry.x),
                        y: MmTurnPx(art.geometry.y)
                    };
                    art.offsetx = MmTurnPx(art.offsetx);
                    art.offsety = MmTurnPx(art.offsety);
                    art.rotation.angle = -art.rotation.angle;
                }
                if (level.imagebox && level.imagebox.geometry) {
                    var img = level.imagebox;
                    if (img.geometry.width <= 1 || img.geometry.height <= 1) {
                        $scope.isHasGeometry = false;
                    }
                    img.current = 'imagebox';
                    img.geometry = {
                        width: MmTurnPx(img.geometry.width),
                        height: MmTurnPx(img.geometry.height),
                        x: MmTurnPx(img.geometry.x),
                        y: MmTurnPx(img.geometry.y)
                    };

                    if (img.image) {
                        img.image = {
                            offsetx: MmTurnPx(img.image.offsetx),
                            offsety: MmTurnPx(img.image.offsety),
                            scale: img.image.scale,
                            angle: img.image.angle,
                            resource: {
                                identifier: img.image.resource ? img.image.resource.identifier : '',
                                provider: img.image.resource ? img.image.resource.provider : ''
                            },
                            resourceid: img.image.resourceid
                        }
                    }
                }
                if (level.textbox && level.textbox.geometry) {
                    var text = level.textbox;
                    if (text.text == '') {
                        level.textbox = null;
                    } else {
                        text.current = 'textbox';
                        text.geometry = {
                            width: MmTurnPx(text.geometry.width),
                            height: MmTurnPx(text.geometry.height),
                            x: MmTurnPx(text.geometry.x),
                            y: MmTurnPx(text.geometry.y)
                        }
                        text.rotation.angle = -text.rotation.angle;
                    }
                }
                if (level.textdocument && level.textdocument.geometry) {
                    var textdocument = level.textdocument;
                    textdocument.current = 'textdocument';
                    textdocument.background.offsetx = MmTurnPx(textdocument.background.offsetx);
                    textdocument.background.offsety = MmTurnPx(textdocument.background.offsety);
                    textdocument.geometry = {
                        width: MmTurnPx(textdocument.geometry.width),
                        height: MmTurnPx(textdocument.geometry.height),
                        x: MmTurnPx(textdocument.geometry.x),
                        y: MmTurnPx(textdocument.geometry.y)
                    }
                    angular.forEach(textdocument.levels.level, function (l) {
                        if (l.imageart && l.imageart.geometry) {
                            var imageart = l.imageart;
                            imageart.current = 'imageart';
                            imageart.geometry = {
                                width: MmTurnPx(imageart.geometry.width),
                                height: MmTurnPx(imageart.geometry.height),
                                x: MmTurnPx(imageart.geometry.x),
                                y: MmTurnPx(imageart.geometry.y)
                            };
                            imageart.offsetx = MmTurnPx(imageart.offsetx);
                            imageart.offsety = MmTurnPx(imageart.offsety);
                            imageart.rotation.angle = -imageart.rotation.angle;
                        }
                        if (l.textbox && l.textbox.geometry) {
                            if (l.textbox.text == '') {
                                l.textbox = null;
                            } else {
                                l.textbox.current = 'textbox';
                                l.textbox.geometry = {
                                    width: MmTurnPx(l.textbox.geometry.width),
                                    height: MmTurnPx(l.textbox.geometry.height),
                                    x: MmTurnPx(l.textbox.geometry.x),
                                    y: MmTurnPx(l.textbox.geometry.y)
                                }
                                l.textbox.rotation.angle = -l.textbox.rotation.angle;
                            }
                        }
                    })
                }
                if (level.calMonthBox && level.calMonthBox.geometry) {
                    var calMonthBox = level.calMonthBox;
                    calMonthBox.rotation = {angle:0};
                    calMonthBox.current = 'calMonthBox';
                    calMonthBox.sampleYear = getDay('year',$scope.template.config.startYear,$scope.template.config.startMonth,tempPages.page[i].config.monthIndex);
                    calMonthBox.sampleMonth = getDay('month',$scope.template.config.startYear,$scope.template.config.startMonth,tempPages.page[i].config.monthIndex);
                    calMonthBox.geometry = {
                        width: MmTurnPx(calMonthBox.geometry.width),
                        height: MmTurnPx(calMonthBox.geometry.height),
                        x: MmTurnPx(calMonthBox.geometry.x),
                        y: MmTurnPx(calMonthBox.geometry.y)
                    };
                    // calMonthBox.rotation.angle = -calMonthBox.rotation.angle;
                }
                if (level.calTitleBox && level.calTitleBox.geometry) {
                    var calTitleBox = level.calTitleBox;
                    calTitleBox.rotation = {angle:0};
                    calTitleBox.current = 'calTitleBox';
                    calTitleBox.sampleYear = getDay('year',$scope.template.config.startYear,$scope.template.config.startMonth,tempPages.page[i].config.monthIndex);
                    calTitleBox.sampleMonth = getDay('month',$scope.template.config.startYear,$scope.template.config.startMonth,tempPages.page[i].config.monthIndex);
                    calTitleBox.geometry = {
                        width: MmTurnPx(calTitleBox.geometry.width),
                        height: MmTurnPx(calTitleBox.geometry.height),
                        x: MmTurnPx(calTitleBox.geometry.x),
                        y: MmTurnPx(calTitleBox.geometry.y)
                    };
                    // calTitleBox.rotation.angle = -calTitleBox.rotation.angle;
                }
            });


            if (!page.backup) {
                loadPageToPx(tempPages.page[i], i,function () {
                    if(callback){callback()}
                });
            }
            if (flag && flag == 'pages') {
                setOriginalWaH(MmTurnPx(page.trimbox.width), MmTurnPx(page.trimbox.height), i);
            }

            ratioInfo(tempPages.page[i])
        }
        function tempPageInfo1(partData, tempPage,pageIndex,scaleW,scaleH,callback,spread,usePartEditbox) {
            var part = angular.copy(partData);
            tempPage.updateThumbnail=true;
            tempPage.loaded = false;
            var _scale = scaleW > scaleH ? scaleH : scaleW;
            if((partData.spread && !tempPage.spread) || (!partData.spread && tempPage.spread)){
                if(spread) {
                    _scale = scaleW > scaleH ? scaleW : scaleH;
                }
                if (partData.spread) {
                    part.mediabox.width = (part.mediabox.width - Number(part.bleed.left) - Number(part.bleed.right)) / 2 + Number(part.bleed.left) + Number(part.bleed.right);
                }else{
                    part.mediabox.width = (part.mediabox.width - Number(part.bleed.left) - Number(part.bleed.right)) * 2 + Number(part.bleed.left) + Number(part.bleed.right);
                }
                var mediabox = angular.copy(part.mediabox);
                var trimbox = angular.copy({
                    height: part.mediabox.height - Number(part.bleed.bottom) - Number(part.bleed.top),
                    width: part.mediabox.width - Number(part.bleed.left) - Number(part.bleed.right),
                    x: part.bleed.left,
                    y: part.bleed.top
                });
            }else{
                var mediabox = angular.copy(part.mediabox);
                var trimbox = angular.copy({
                    height: part.mediabox.height - Number(part.bleed.bottom) - Number(part.bleed.top),
                    width: part.mediabox.width - Number(part.bleed.left) - Number(part.bleed.right),
                    x: part.bleed.left,
                    y: part.bleed.top
                });
            }
            var _oldMediabox = angular.copy(tempPage.mediabox);
            tempPage.width= MmTurnPx(trimbox.width);
            tempPage.height= MmTurnPx(trimbox.height);
            tempPage.trimbox= getGeometry(trimbox);
            tempPage.mediabox= getGeometry(mediabox);
            if (usePartEditbox) {
                // 修改部件上的数据页面需要同步
                tempPage.editboxes= getEditboxesFromPart(partData);
                tempPage.editboxes= getEditboxes(tempPage,getGeometry(partData.mediabox));
            }else{
                //不看部件上的设置，只针对当前页面变化做判断处理
                tempPage.editboxes= getEditboxes(tempPage,_oldMediabox);
            }

            tempPage.editbox= tempPage.editboxes.editbox[0];

            tempPage.blood= part.bleed;
            tempPage.bloodPx= {
                top: MmTurnPx(trimbox.y),
                bottom: MmTurnPx(mediabox.height - trimbox.y - trimbox.height),
                left: MmTurnPx(trimbox.x),
                right: MmTurnPx(mediabox.width - trimbox.x - trimbox.width),
            };
            tempPage.custom= {};
            if (part.scene) {
                tempPage.scene = angular.copy(part.scene);
                tempPage.scene = {
                    background: {
                        resource: {
                            provider: part.scene.resource.provider,
                            identifier: part.scene.resource.identifier
                        }
                    },
                    geometry: getGeometry(part.scene.geometry),
                    imagebox: {
                        geometry: getGeometry(part.scene.imagebox.geometry),
                        rotation: {angle: part.scene.imagebox.rotation.angle}
                    },
                    isScene: true,
                    scale: 1,
                    unit: 'mm',
                    hierarchy: part.scene.hierarchy,
                    mouldid: part.scene.mouldid,
                }
                tempPage.scene.isScene = true;
                var w = tempPage.scene.geometry.width;
                var h = tempPage.scene.geometry.height;
                var originalScale = $con.width() * 0.8 / ($con.height() * 0.8);
                if (originalScale < part.scene.geometry.width / part.scene.geometry.height) {
                    //宽定，高不定
                    tempPage.scene.width = $con.width() * 0.8;
                    tempPage.scene.height = $con.width() * 0.8 * h / w;
                } else {

                    //高定，宽不动
                    tempPage.scene.height = $con.height() * 0.8;
                    tempPage.scene.width = $con.height() * 0.8 * w / h
                }
                tempPage.scene.proportion = (w / tempPage.scene.width);
                var wah = ThreeHundredDpi(part.scene.geometry.width, part.scene.geometry.height);
                tempPage.scene.widthPx = wah.px1;
                tempPage.scene.heightPx = wah.px2;
                if (vm.windowH / h >= vm.windowW / w) {
                    tempPage.scene.ratio = vm.windowW / w * 0.8;
                } else {
                    tempPage.scene.ratio = vm.windowH / h * 0.8;
                }
                if (vm.windowH1 / h >= vm.windowW1 / w) {
                    tempPage.scene.ratio1 = vm.windowW1 / w;
                } else {
                    tempPage.scene.ratio1 = vm.windowH1 / h;
                }
                tempPage.custom.width = tempPage.scene.geometry.width;
                tempPage.custom.height = tempPage.scene.geometry.height;
            }else{
                tempPage.custom.width = tempPage.mediabox.width;
                tempPage.custom.height = tempPage.mediabox.height;
            }
            if (tempPage.barcode && tempPage.barcode.geometry) {
                tempPage.barcode.geometry= {
                    width: tempPage.barcode.geometry.width * _scale,
                    height: tempPage.barcode.geometry.height * _scale,
                    x: tempPage.barcode.geometry.x * _scale,
                    y: tempPage.barcode.geometry.y * _scale,
                };
            }

            if (tempPage.qrcode && tempPage.qrcode.geometry) {
                tempPage.qrcode.geometry= {
                    width: tempPage.qrcode.geometry.width * _scale,
                    height: tempPage.qrcode.geometry.height * _scale,
                    x: tempPage.qrcode.geometry.x * _scale,
                    y: tempPage.qrcode.geometry.y * _scale,
                };
            }
            if (tempPage.background && tempPage.background.resource && tempPage.background.resource.identifier) {
                var background = angular.copy(tempPage.background)
                resetBackground();
                if(scaleW == scaleH){
                    tempPage.background.offsetx = background.offsetx * _scale;
                    tempPage.background.offsety = background.offsety * _scale;
                }
            }
            if(!spread){
                angular.forEach(tempPage.levels.level, function (level, l) {
                    if (level.imageart && level.imageart.geometry) {
                        var nw = angular.copy(level.imageart.geometry.width);
                        var nh = angular.copy(level.imageart.geometry.height);
                        if(_scale > 1) {
                            level.imageart.geometry.x= level.imageart.geometry.x * _scale;
                            level.imageart.geometry.y= level.imageart.geometry.y * _scale;
                            level.imageart.geometry.height= level.imageart.geometry.height * _scale;
                            level.imageart.geometry.width = level.imageart.geometry.height * nw / nh;
                            level.imageart.offsetx = level.imageart.offsetx * _scale;
                            level.imageart.offsety = level.imageart.offsety * _scale;
                        }else{
                            level.imageart.geometry.x= level.imageart.geometry.x * _scale;
                            level.imageart.geometry.y= level.imageart.geometry.y * _scale;
                            level.imageart.geometry.width= level.imageart.geometry.width * _scale;
                            level.imageart.geometry.height = level.imageart.geometry.width * nh / nw;
                            level.imageart.offsetx = level.imageart.offsetx * _scale;
                            level.imageart.offsety = level.imageart.offsety * _scale;
                        }
                    }
                    if (level.imagebox && level.imagebox.geometry) {
                        level.imagebox.geometry = {
                            width: level.imagebox.geometry.width * _scale,
                            height: level.imagebox.geometry.height * _scale,
                            x: level.imagebox.geometry.x * _scale,
                            y: level.imagebox.geometry.y * _scale
                        };
                        if (level.imagebox.image && level.imagebox.image.resource && level.imagebox.image.resource.identifier) {
                            level.imagebox.image.offsetx = 0;
                            level.imagebox.image.offsety = 0;
                            level.imagebox.image.scale = 1;
                            imageboxImg(level.imagebox, function () {
                                $scope.$apply();
                            })
                        }
                    }
                    if (level.textbox && level.textbox.geometry) {
                        if (level.textbox.text == '') {
                            level.textbox = null;
                        } else {
                            level.textbox.geometry = {
                                width: level.textbox.geometry.width * _scale,
                                height: level.textbox.geometry.height * _scale,
                                x: level.textbox.geometry.x * _scale,
                                y: level.textbox.geometry.y * _scale
                            };
                            level.textbox.style.size = level.textbox.style.size * _scale;
                            level.textbox.style.lineheight = level.textbox.style.lineheight * _scale;
                            level.textbox.style.letterspacing = level.textbox.style.letterspacing * _scale;
                        }
                    }
                    if (level.textdocument && level.textdocument.geometry) {
                        var textdocument = level.textdocument;
                        var textdocW = angular.copy(textdocument.geometry.width);
                        var textdocH = angular.copy(textdocument.geometry.height);
                        textdocument.geometry = {
                            width: textdocument.geometry.width * _scale,
                            height: textdocument.geometry.height * _scale,
                            x: textdocument.geometry.x * _scale,
                            y: textdocument.geometry.y * _scale
                        };
                        textdocument.background.offsetx = textdocument.background.offsetx * textdocument.geometry.width / textdocW;
                        textdocument.background.offsety = textdocument.background.offsety * textdocument.geometry.height / textdocH;
                        textdocument.background.width = textdocument.background.width * textdocument.geometry.width / textdocW;
                        textdocument.background.height = textdocument.background.height * textdocument.geometry.height / textdocH;

                        angular.forEach(textdocument.levels.level, function (level, l) {
                            var textdoc = textdocument.levels.level[l];
                            if (level.imageart) {
                                var geo = {
                                    width: textdoc.imageart.geometry.width * textdocument.geometry.width / textdocW,
                                    height: textdoc.imageart.geometry.height * textdocument.geometry.height / textdocH,
                                    x: textdoc.imageart.geometry.x * textdocument.geometry.width / textdocW,
                                    y: textdoc.imageart.geometry.y * textdocument.geometry.height / textdocH,
                                }
                                level.imageart.geometry = geo;

                                level.imageart.offsetx = textdoc.imageart.offsetx * textdocument.geometry.width / textdocW;
                                level.imageart.offsety = textdoc.imageart.offsety * textdocument.geometry.height / textdocH;
                            }
                            if (level.textbox) {
                                var textGeo = {
                                    width: textdoc.textbox.geometry.width * textdocument.geometry.width / textdocW,
                                    height: textdoc.textbox.geometry.height * textdocument.geometry.height / textdocH,
                                    x: textdoc.textbox.geometry.x * textdocument.geometry.width / textdocW,
                                    y: textdoc.textbox.geometry.y * textdocument.geometry.height / textdocH,
                                }
                                level.textbox.geometry = textGeo;
                                level.textbox.style.size = textdoc.textbox.style.size * textdocument.geometry.width / textdocW;
                                level.textbox.style.lineheight = textdoc.textbox.style.lineheight * textdocument.geometry.width / textdocW;
                            }
                        })
                    }
                    if (level.calMonthBox && level.calMonthBox.geometry) {
                        level.calMonthBox.geometry = {
                            width: level.calMonthBox.geometry.width * _scale,
                            height: level.calMonthBox.geometry.height * _scale,
                            x: level.calMonthBox.geometry.x * _scale,
                            y: level.calMonthBox.geometry.y * _scale
                        };
                    }
                    if (level.calTitleBox && level.calTitleBox.geometry) {
                        level.calTitleBox.geometry = {
                            width: level.calTitleBox.geometry.width * _scale,
                            height: level.calTitleBox.geometry.height * _scale,
                            x: level.calTitleBox.geometry.x * _scale,
                            y: level.calTitleBox.geometry.y * _scale
                        };
                    }
                });
            }
            setOriginalWaH(MmTurnPx(tempPage.trimbox.width), MmTurnPx(tempPage.trimbox.height), pageIndex);
            if(callback){
                callback()
            }
        }

        function getEditboxes(tempPage,oldMediabox){
            var editboxes = {
                editbox:[]
            };
            var _tempPage = angular.copy(tempPage)
            var xLeftMinValue = null; //距离画布左侧的值
            var xRightMinValue = null; //距离画布右侧的值
            for (var i = 0; i < _tempPage.editboxes.editbox.length; i++) {
                var item = _tempPage.editboxes.editbox[i];
                if (xLeftMinValue == null) {
                    xLeftMinValue = Number(item.x);
                }else if (xLeftMinValue > Number(item.x)) {
                    xLeftMinValue = Number(item.x);
                }
                var _xRightMinValue = Number(oldMediabox.width) - (Number(item.x) + Number(item.width));
                if (xRightMinValue == null) {
                    xRightMinValue = _xRightMinValue;
                }else if (xRightMinValue > _xRightMinValue) {
                    xRightMinValue = _xRightMinValue;
                }
            }
            // var _s = (_tempPage.mediabox.width - xRightMinValue - xLeftMinValue) / (oldMediabox.width -xRightMinValue - xLeftMinValue);
            var _s = (_tempPage.mediabox.width) / (oldMediabox.width);
            _tempPage.editboxes.editbox.forEach(function (editbox) {
                editbox.width = editbox.width*_s;
                editbox.height = editbox.height;
                // editbox.x = (editbox.x - xLeftMinValue) *_s + xLeftMinValue;
                editbox.x = editbox.x*_s;
                editbox.y = editbox.y;
                editboxes.editbox.push(angular.copy(editbox))
            })
            return editboxes
        }

        function getEditboxesFromPart(partData){
            var part = angular.copy(partData)
            var editboxes = {
                editbox:[]
            };
            part.editboxes.editbox.forEach(function(editbox){
                editboxes.editbox.push(getGeometry(editbox));
            })
            return editboxes;
        }

        function success(data) {
            vm.isSaving = false;
            MessageService.success("保存成功！");
            clearPageStorageInfo();
            if (!vm.isCustom) {
                $state.go('templateList', {reload: true})
            } else {
                $state.go('selfTemplateList', {self: 'self'}, {reload: true})
            }
        }

        function error() {
            vm.isSaving = false;
            MessageService.error("保存失败！");
        }


        function success2(data) {
            vm.isSaving = false;
            clearPageStorageInfo();
            MessageService.success("发布成功！");
            $state.go('templateList', {reload: true})
        }

        function error2() {
            vm.isSaving = false;
            MessageService.error("发布失败，请联系管理员配置发布路径！");
        }

        $scope.exitPage = function (item) {
            vm.exitSure = false;
            if(!vm.thirdparty){
                clearPageStorageInfo();
            }
            if(!item){
                $scope.savePage(1)
            }
        };
        $scope.exitPageHide = function () {
            vm.exitSure = false;
            if(!vm.thirdparty){
                clearPageStorageInfo();
            }
            window.history.back()
        };

        vm.leftShow = true;
        vm.rightShow = true;
        vm.bottomShow = true;
        $scope.hidePanel = function (attr) {
            if(attr === 1){vm.leftShow = !vm.leftShow};
            if(attr === 0){vm.rightShow = !vm.rightShow};
            if(attr === 2){vm.bottomShow = !vm.bottomShow};
            $timeout(function () {
                updateMeasureRuler();
            })
        }


        //历史纪录
        $scope.pageHistory = [];
        vm.operation = false;
        var updateHistorys = function () {
            $scope.currentPage.updateThumbnail = true;
            vm.operation = true;
            $scope.template.pages.page[$scope.template.pageI] = $scope.currentPage;
            $scope.pageHistory.push(angular.copy($scope.template));
            if ($scope.pageHistory.length > 50) {
                $scope.pageHistory.splice($scope.pageHistory.length - 4, $scope.pageHistory.length - 5)
            }
        };

        //防止事件冒泡，默认事件
        $scope.fn = fn1;
        function fn($event) {
            if($event){
                var $event = $event || window.event;
                if($event && $event.preventDefault){
                    $event.preventDefault();
                }
                else {
                    window.event.returnValue = false;
                    return false;
                }
                $event.stopPropagation();
            }
        }
        function fn1($event) {
            var $event = $event || window.event;
            // if($event && $event.preventDefault){
            //     $event.preventDefault();
            // }
            // else {
            //     window.event.returnValue = false;
            //     return false;
            // }
            $event.stopPropagation();
        }

        $scope.showThumbnailPic = function () {
            var i = $scope.template.pageI;
            $scope.currentPage = $scope.template.pages.page[i];
            $scope.lastPage = $scope.template.pages.page[i];
            vm.loadingImg = true;
            $timeout(function () {
                var nodes = document.getElementsByClassName('page-item2');
                setThumbnailPic(nodes[0], $scope.lastPage, null, function () {
                    vm.loadingImg = false;
                    $scope.thumbnailPic = true;
                    $scope.thumbnailType = 'one';
                })
                updateMeasureRuler();
            })
        }
        $scope.allThumbnailUpdate = function (index) {
            if(!$scope.thumbnailPic){
                return;
            }
            if($scope.lastPage.loading){
                MessageService.error("缩略图正在生成中，请稍后再试");
                return
            }
            var _i =index > -1 ? index : 0;
            $scope.template.pages.page.forEach(function (page,index1) {
                if(index1 >= _i && page.updateThumbnail){
                    page.loading = true;
                }
            });
            if($scope.template.pages.page[_i]){
                if(!$scope.template.pages.page[_i].updateThumbnail){
                    _i++
                    $scope.allThumbnailUpdate(_i)
                    return
                }else{
                    $scope.template.pages.page[_i].loading = false;
                    $scope.thisThumbnailUpdate(_i, function () {
                        _i++
                        if(_i == $scope.template.pages.page.length){
                            MessageService.success("缩略图已更新完成");
                        }else{
                            $scope.allThumbnailUpdate(_i)
                        }
                    })
                }
            }
        }
        $scope.thisThumbnailUpdate = function(index,callback){
            if($scope.lastPage.loading){
                MessageService.error("缩略图正在生成中，请稍后再试");
                return
            }
            $scope.lastPage = $scope.template.pages.page[index];
            $scope.lastPage.loading = true;
            $scope.lastPage.isPrompt = false;
            $timeout(function () {
                var nodes = document.getElementsByClassName('page-item2');
                setThumbnailPic(nodes[0], $scope.lastPage, null, function () {
                    $scope.lastPage.loading = false;
                    $scope.lastPage = $scope.template.pages.page[$scope.template.pageI];
                    if(callback){callback()}
                })
            },1000)
        }

        $scope.showAllThumbnailPic = function (callback) {
            if(vm.isSkip){return}
            var i = $scope.template.pageI;
            $scope.currentPage = $scope.template.pages.page[i];
            $scope.lastPage = $scope.template.pages.page[i];

            $timeout(function () {
                var nodes = document.getElementsByClassName('page-item2');
                setThumbnailPic(nodes[0], $scope.lastPage, null, function () {
                    $scope.template.pages.page.forEach(function (page) {
                        page.loading = false;
                    });
                    $scope.thumbnailPic = true;
                    $scope.thumbnailType = 'all';
                })
                updateMeasureRuler();
            });

            // var nodes = document.getElementsByClassName('pageNode');
            // Qinius.get(function (msg) {
            //     vm.token = msg.token;
            //     angular.forEach($scope.template.pages.page, function (page, i) {
            //         setThumbnailPic(nodes[i], page)
            //     })
            setTimeout(function () {
                swiper();
            }, 1000);
            // });
        }


        function setThumbnailPic1(callback) {
            var i = $scope.template.pageI;
            $scope.currentPage = $scope.template.pages.page[i];
            $scope.lastPage = $scope.template.pages.page[i];
            setTimeout(function () {
                var nodes = document.getElementsByClassName('page-item2');
                setThumbnailPic(nodes[0], $scope.lastPage, null, function () {
                    if (callback) {
                        callback()
                    }
                })
            })
        }

        function setThumbnailPic(node, page, flag, callback) {
            getDomOnload($scope, "pageThumbnail",function () {
                page.pagecover = null;
                var width = $scope.lastPage.mediabox.width;
                var height = $scope.lastPage.mediabox.height;
                if($scope.lastPage.scene){
                    $scope.lastPage.isScene = true;
                }
                if ($scope.lastPage.isScene) {
                    width = $scope.lastPage.scene.geometry.width;
                    height = $scope.lastPage.scene.geometry.height;
                }
                var _complete = false;
                $timeout(function () {
                    if(!_complete){
                        _complete = true;
                        if(callback){callback()}
                        page.isPrompt = true;
                    }
                },10000)
                var _ratio = $scope.lastPage.ratio || 1;
                html2canvas_adapt(node, {
                    onrendered: function (canvas) {
                        var url = canvas.toDataURL("image/png");
                        var blob = dataURLtoBlob(url);

                        var formData = new FormData();
                        formData.append('file', blob);
                        formData.append('key', 'cover-' + UidService.get());
                        formData.append('token', vm.token);
                        $.ajax({
                            cache: true,
                            type: "POST",
                            url: 'https://upload.qiniup.com/',
                            data: formData,
                            async: false,
                            contentType: false,
                            processData: false,
                            success: function (data) {
                                if(_complete){
                                    return;
                                }
                                _complete = true;
                                page.updateThumbnail=false;
                                page.pagecover = {
                                    identifier: vm.url + data.key,
                                    provider: 'qiniu'
                                }
                                if (flag && flag == 'cover') {
                                    pageAnimate();
                                }
                                if (flag && flag == 'addSimple') {
                                    createModal('app/entities/page/page-simple.html', 'PageSimpleController').result.then(
                                        function (data) {
                                            $scope.template.documentpics.documentpic = data.documentpic;
                                            vm.operation = true;
                                        });
                                    return
                                }
                                if (flag && flag == 'all') {
                                    for (var i = 1; i < $scope.template.pages.page.length; i++) {
                                        var page1 = $scope.template.pages.page[i];
                                        if (!page1.scene) {
                                            page1.pagecover = page.pagecover;
                                        } else {
                                            page1.pagecover = {
                                                identifier: "",
                                                provider: 'qiniu'
                                            };
                                        }
                                    }
                                }
                                if (callback) {
                                    callback(vm.url + data.key)
                                }
                                $scope.$digest();
                            },
                            error: function (request) {
                                MessageService.error("文件上传失败");
                            }
                        });
                    },
                    letterRendering: true,
                    useCORS: true,
                    width: width * _ratio,
                    height: height * _ratio,
                    windowWidth: document.body.scrollWidth,
                    windowHeight: document.body.scrollHeight,
                    x: $scope.lastPage.isScene ? (-($scope.lastPage.scene.geometry.width - $scope.lastPage.scene.geometry.width * _ratio) / 2) : -($scope.lastPage.mediabox.width - $scope.lastPage.mediabox.width * _ratio) / 2,
                    y: $scope.lastPage.isScene ? (-($scope.lastPage.scene.geometry.height - $scope.lastPage.scene.geometry.height * _ratio) / 2) : -($scope.lastPage.mediabox.height - $scope.lastPage.mediabox.height * _ratio) / 2,
                    ratio: _ratio || 1,
                    backgroundColor: "rgba(0, 0, 0, 0)",
                });
            })
        }

        function dataURLtoBlob(dataurl) {
            var arr = dataurl.split(','), mime = arr[0].match(/:(.*?);/) ? arr[0].match(/:(.*?);/)[1] : null,
                bstr = atob(arr[1]), n = bstr.length, u8arr = new Uint8Array(n);
            while (n--) {
                u8arr[n] = bstr.charCodeAt(n);
            }
            return new Blob([u8arr], {type: mime});
        }

        $scope.modalHide = function () {
            var _loading = false;
            for(var i=0; i<$scope.template.pages.page.length; i++){
                var _page = $scope.template.pages.page[i];
                if(_page.loading){
                    _loading = true;
                    break
                }
            }
            if(_loading){
                MessageService.confirm({
                    title:'提示',
                    cancel:'取消',
                    confirm:'确认',
                    msg:'是否停止缩略图生成？'
                },function(){
                    for(var i=0; i<$scope.template.pages.page.length; i++){
                        var _page = $scope.template.pages.page[i];
                        _page.loading = false;
                    }
                    $scope.thumbnailPic = false;
                }, function () {
                });
            }else{
                $scope.thumbnailPic = false;
            }
        };

        //swiper
        function swiper() {
            var swiper = new Swiper('.swiper-container', {
                pagination: {
                    el: '.swiper-pagination',
                    type: 'fraction',
                },
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                },
            });
        }

        vm.isFullScreen = false;
        function getFullState(){
            $timeout(function () {
                vm.isFullScreen = Math.abs(window.screen.height-window.document.documentElement.clientHeight) <= 17;
            })
        }
        getFullState();
        //全屏
        $scope.fullScreen = function(){
            var el = document.documentElement
            var rfs = el.requestFullScreen || el.webkitRequestFullScreen || el.mozRequestFullScreen || el.msRequestFullscreen
            if (rfs) { // typeof rfs != "undefined" && rfs
                rfs.call(el)
            }else if (typeof window.ActiveXObject !== 'undefined') {
                // for IE，这里其实就是模拟了按下键盘的F11，使浏览器全屏
                var wscript = new ActiveXObject('WScript.Shell')
                if (wscript != null) {
                    wscript.SendKeys('{F11}')
                }
            }
        }
        $scope.exitScreen = function(){
            var el = document
            var cfs = el.cancelFullScreen || el.mozCancelFullScreen || el.msExitFullscreen || el.webkitExitFullscreen || el.exitFullscreen
            if (cfs) { // typeof cfs != "undefined" && cfs
                cfs.call(el)
            } else if (typeof window.ActiveXObject !== 'undefined') {
                // for IE，这里和fullScreen相同，模拟按下F11键退出全屏
                var wscript = new ActiveXObject('WScript.Shell')
                if (wscript != null) {
                    wscript.SendKeys('{F11}')
                }
            }
        }

        function toolbarStatus() {
            vm.isOperationDir = false;
            vm.isOperationSpacing = false;
            vm.isTransp = false;
            vm.isCoverage = false;
            vm.isRoundedSet = false;
            vm.isBorderSet = false;
            vm.isShadowSet = false;
            vm.isAlign = false;
            // $scope.isDistriHover = false;
            // $scope.isAlignHover = false;
            vm.isOperationColor = false;
        }


        /********************************************PSD操作**********************start*************************************/
        $scope.showPsdModal = function () {
            $uibModal.open({
                templateUrl: 'app/entities/page/modal/psd-upload.html',
                controller: 'PsdUploadController',
                backdrop: 'static',
                keyboard: true,
                windowClass: "jh-modal-md",
                controllerAs: 'vm',
                resolve: {
                    entity: [function () {
                        return {
                            defaultFont: vm.defaultFont,
                            token: vm.token,
                            url: vm.url,
                            showMasks: vm.showMasks,
                            totalClipartItems: vm.totalClipartItems,
                        };
                    }]
                }
            }).result.then(function (data) {
                if (data) {
                    if(!$scope.template.psdFiles.psdFile){
                        $scope.template.psdFiles.psdFile = [];
                    }
                    data.forEach(function (itme) {
                        $scope.template.psdFiles.psdFile.push(itme);
                    })
                    vm.operation = true;
                }
            });
        }

        $scope.delPsdFile = function ($event, item) {
            $event.stopPropagation();
            var itemToDelete = item;
            MessageService.confirm({
                title:'删除提示',
                cancel:'取消',
                confirm:'确认',
                msg:'请确认是否要删除PSD文件？'
            },function(){
                var _index = -1;
                $scope.template.psdFiles.psdFile.forEach(function (psd, index) {
                    if (psd.name == itemToDelete.name && itemToDelete.cover.identifier == psd.cover.identifier) {
                        _index = index;
                    }
                })
                $scope.template.psdFiles.psdFile.splice(_index, 1);
            });
        }

        $scope.editPsdFontMapping = function($event, $index, item) {
            $event.stopPropagation();
            var itemIndex = $index;
            $uibModal.open({
                templateUrl: 'app/entities/page/modal/psd-font-mapping.html',
                controller: 'PsdFontMappingController',
                backdrop: 'static',
                keyboard: true,
                windowClass: "jh-modal-md",
                size: "lg",
                controllerAs: 'vm',
                resolve: {
                    entity: [function () {
                        return {
                            psdFile: item,
                            fontList: vm.fontList
                        };
                    }]
                }
            }).result.then(function (data) {
                if (data) {
                    console.log(data);
                    var psdFile = $scope.template.psdFiles.psdFile[itemIndex];
                    if (psdFile) {
                        psdFile.fontMapping = data || { items: []}
                    }

                    vm.operation = true;
                }
            });
        }

        var loading = null;
        $scope.insertPsdFile = function (item, index) {
            loading = MessageService.loading();
            var page = $scope.template.pages.page[$scope.template.pageI];
            page.levels.level = [];
            var template = angular.copy(JSON.parse(item.data));
            // 将PSD模版应用到当前页
            for (var i = 0; i < template.layers.length; i++) {
                var layer = template.layers[i];
                if (layer.type === 'Image') {
                    if (layer.hasMask && layer.mask) {
                        addLayerAsImagebox(layer, i, true, page);
                    } else {
                        addLayerAsImageart(layer, i, true, page);
                    }
                } else if (layer.type === 'Text') {
                    addLayerAsText(layer, true, page, item.fontMapping);
                }
            }
            // 检查素材精度
            $timeout(function () {
                currentPageElement();
                loading.close();
            }, 2000);
        }

        function addLayerAsImagebox(layer, i, isHistory, page) {
            var mask = layer.mask;
            var currentPage = page;
            var currentLevel = addLevel(currentPage);
            var maskIdentifier = mask.imageUrl;
            var imageIdentifier = layer.imageUrl;
            var offsetX = layer.geometry.x - mask.geometry.x;
            var offsetY = layer.geometry.y - mask.geometry.y;
            vm.unit = 'mm';

            currentLevel.imagebox = {
                geometry: mask.geometry,
                rotation: {
                    angle: 0
                },
                transparency: layer.opacity || 1.0,
                image: {
                    resource: {
                        identifier: imageIdentifier,
                        provider: 'qiniu',
                    },
                    width: layer.geometry.width,
                    height: layer.geometry.height,
                    offsetx: offsetX,
                    offsety: offsetY,
                    scale: layer.geometry.width/mask.geometry.width || 1
                },
                mask: {
                    resource: {
                        identifier: maskIdentifier,
                        provider: 'qiniu'
                    },
                    width: mask.geometry.width,
                    height: mask.geometry.height
                },
                border: {
                    shape: 'Rectangle',
                    radius: {
                        lt: 0,
                        rt: 0,
                        rb: 0,
                        lb: 0,
                        all: 0,
                        filletType: 'Fixed'
                    },
                    "edge": {
                        top: 0,
                        right: 0,
                        bottom: 0,
                        left: 0
                    },
                    lineWidth: 0,
                    type: "Color",
                    lineType: "solid",
                    resource: {
                        "identifier": ''
                    },
                    color: '#000000',
                },
                shadow: {
                    color: '#777777',
                    x: 0,
                    y: 0,
                    blur: 0
                },
                imgUrl: imageIdentifier || 'content/images/mask_souce2.png',
                maskUrl: maskIdentifier || 'content/images/mask_souce2.png',
                bgImg: '',
                unit: 'mm',
                levelI: $scope.template.levelI,
                pageI: $scope.template.pageI,
                current: 'imagebox',
                lock: false
            };
            if (currentLevel.imagebox.image && currentLevel.imagebox.image.resource.identifier) {
                imageboxImg1(currentLevel.imagebox, layer.geometry.width, layer.geometry.height);
                if(currentLevel.imagebox.image.offsetx>0){currentLevel.imagebox.image.offsetx=0};
                if(currentLevel.imagebox.image.offsety>0){currentLevel.imagebox.image.offsety=0};
                if(currentLevel.imagebox.image.offsetx*currentLevel.imagebox.image.scale<(currentLevel.imagebox.geometry.width-currentLevel.imagebox.image.width*currentLevel.imagebox.image.scale)){
                    currentLevel.imagebox.image.offsetx=(currentLevel.imagebox.geometry.width-currentLevel.imagebox.image.width*currentLevel.imagebox.image.scale)/currentLevel.imagebox.image.scale
                }
                if(currentLevel.imagebox.image.offsety*currentLevel.imagebox.image.scale<(currentLevel.imagebox.geometry.height-currentLevel.imagebox.image.height*currentLevel.imagebox.image.scale)){
                    currentLevel.imagebox.image.offsety=(currentLevel.imagebox.geometry.height-currentLevel.imagebox.image.height*currentLevel.imagebox.image.scale)/currentLevel.imagebox.image.scale
                }
            }
            // imageboxResourceCanvas(currentLevel.imagebox, function () {
                currentLevel.seq = i - 0 + 1;
                $scope.currentPage = currentPage;
                $scope.RightPanel = 'material';
                $scope.selectBox = currentLevel.imageart;
                $scope.template.transparency = 100;
                // if(!isHistory){
                    setTimeout(function () {
                        updateHistorys();
                        $scope.$digest();
                    }, 1000);
                // }
            // });

        }
        function imageboxImg1(imagebox, imgW, imgH) {
            var imgR = imagebox.geometry.width / imagebox.geometry.height;
            var imgR1 = imgW / imgH;
            if (imgR >= imgR1) {
                imagebox.image.resource.adaptation = 'Height';
                imagebox.image.width = imagebox.geometry.width;
                imagebox.image.height = imagebox.geometry.width / imgW * imgH;
            } else {
                imagebox.image.resource.adaptation = 'Width';
                imagebox.image.width = imagebox.geometry.height / imgH * imgW;
                imagebox.image.height = imagebox.geometry.height;
            }
        }

        function addLayerAsImageart(layer, i, isHistory, page) {
            var currentPage = page;
            var currentLevel = addLevel(currentPage);
            var identifier = layer.imageUrl;
            vm.unit = 'mm';
            var newImg = document.createElement('img');
            newImg.crossOrigin = "Anonymous";
            newImg.src = identifier + '?imageView2';
            newImg.onload = function () {
                newImg.onload = null;
                var width = newImg.width;
                var height = newImg.height;
                var arr = ThreeHundredDpiToMm(width, height);

                var bgImgR = width / height;
                var _imageart = {};
                if (bgImgR >= 1) {
                    if (width > currentPage.trimbox.width) {
                        _imageart = {
                            width: currentPage.trimbox.width - 0,
                            height: currentPage.trimbox.width / width * height,
                            x: currentPage.trimbox.x - 0,
                            y: currentPage.trimbox.y - 0
                        }
                    } else {
                        _imageart = {
                            height: height,
                            width: width,
                            x: currentPage.trimbox.x - 0,
                            y: currentPage.trimbox.y - 0
                        }
                    }
                } else {
                    if (height > currentPage.trimbox.height) {
                        _imageart = {
                            height: currentPage.trimbox.height - 0,
                            width: currentPage.trimbox.height / height * width,
                            x: currentPage.trimbox.x - 0,
                            y: currentPage.trimbox.y - 0
                        }
                    } else {
                        _imageart = {
                            height: height,
                            width: width,
                            x: currentPage.trimbox.x - 0,
                            y: currentPage.trimbox.y - 0
                        }
                    }
                }
                $scope.pageValue.imageart = {
                    height: PxTurnMm(_imageart.height),
                    width: PxTurnMm(_imageart.width),
                    x: PxTurnMm(_imageart.x),
                    y: PxTurnMm(_imageart.y)
                }

                currentLevel.imageart = ({
                    geometry: layer.geometry,
                    rotation: {
                        angle: 0
                    },
                    transparency: layer.opacity || 1.0,
                    resource: {
                        identifier: identifier,
                        provider: 'qiniu',
                        width: width,
                        height: height,
                    },
                    scale: 1,
                    onlyshow: false,
                    movable: true,
                    editable: true,
                    bgImg: '',
                    offsetx: 0,
                    offsety: 0,
                    unit: 'mm',
                    // index: currentPage.imagearts.imageart.length,
                    levelI: i,
                    pageI: $scope.template.pageI,
                    current: 'imageart',
                    lock: false
                });

                currentLevel.seq = i - 0 + 1;
                // if(!isHistory){
                    updateHistorys();
                // }
                $scope.currentPage = currentPage;
                $scope.RightPanel = 'material';
                $scope.selectBox = currentLevel.imageart;
                $scope.template.transparency = 100;
                $scope.$digest();
            };
        }

        function checkFontBold(font, flag) {
            if (!font || !font.fontStyles) {
                return false;
            }
            var supportNormal = false;
            var supportBold = false;
            var supportItalic = false;
            for (var i = 0; i < font.fontStyles.length; i++) {
                var s = font.fontStyles[i];
                if (s.style == "NORMAL") {
                    supportNormal = true;
                } else if (s.style == "BOLD") {
                    supportBold = true;
                } else if (s.style == "ITALIC") {
                    supportItalic = true;
                } else if (s.style == "BOLD_ITALIC") {
                    supportItalic = true;
                    supportBold = true;
                }
            }
            if (flag && supportBold) {
                return true;
            }
            if (!supportNormal && !supportItalic && supportBold) {
                // 该字体只支持bold
                return true;
            }
            return false;
        }

        function checkFontItalic(font, flag) {
            if (!font || !font.fontStyles) {
                return false;
            }
            var supportNormal = false;
            var supportBold = false;
            var supportItalic = false;
            for (var i = 0; i < font.fontStyles.length; i++) {
                var s = font.fontStyles[i];
                if (s.style == "NORMAL") {
                    supportNormal = true;
                } else if (s.style == "BOLD") {
                    supportBold = true;
                } else if (s.style == "ITALIC") {
                    supportItalic = true;
                } else if (s.style == "BOLD_ITALIC") {
                    supportItalic = true;
                    supportBold = true;
                }
            }
            if (flag && supportItalic) {
                return true;
            }
            if (!supportNormal && !supportBold && supportItalic) {
                // 该字体只支持斜体
                return true;
            }
            return false;
        }

        function getPsdFontFromMapping(fontName, fontMapping) {
            if (!fontName) {
                return vm.defaultFont;
            }
            if (!fontMapping || !fontMapping.items || !fontMapping.items.length) {
                return vm.defaultFont;
            }
            var targetFontId = null;
            for (var i = 0; i < fontMapping.items.length; i++) {
                var fontItem = fontMapping.items[i];
                if (fontName == fontItem.name) {
                    targetFontId = fontItem.fontId;
                    break;
                }
            }
            if (!targetFontId) {
                return vm.defaultFont;
            }
            for (var i =0; i < vm.fontList.length; i++) {
                var font = vm.fontList[i];
                if (font.id == targetFontId) {
                    return font;
                }
            }
            return vm.defaultFont;
        }

        function addLayerAsText(layer, isHistory, page, fontMapping) {
            var currentPage = page;
            var currentLevel = addLevel(currentPage);

            $scope.RightPanel = 'text';

            // vm.text = '请输入文字';
            $scope.size = layer.style.size;

            var font = getPsdFontFromMapping(layer.style.font, fontMapping);
            var fontBold = checkFontBold(font, layer.style.bold);
            var fontItalic = checkFontItalic(font, layer.style.italic);
            currentLevel.textbox = ({
                transparency: layer.opacity || 1.0,
                geometry: {
                    x: layer.geometry.x,
                    y: layer.geometry.y,
                    width: layer.geometry.width,
                    height: layer.geometry.height
                },
                rotation: layer.rotation,
                style: {
                    font: font.family,
                    size: layer.style.size,
                    color: layer.style.color,
                    bold: fontBold,
                    italic: fontItalic,
                    lineheight: layer.style.lineheight,
                    letterspacing: layer.style.letterspace,
                    align: layer.style.align || 'left',
                    writingmode: layer.style.writemode
                },
                fontuuid: font.uuid,
                identifier: vm.url + font.fontStyles[0].identifier,
                editable: true,
                movable: true,
                version: '2.0',
                text: layer.value,
                unit: 'mm',
                // index: currentPage.textboxes.textbox.length,
                levelI: $scope.template.levelI,
                pageI: $scope.template.pageI,
                current: 'textbox',
                lock: false
            });

            var textbox = currentLevel.textbox;
            FontManagement.fontSupport({
                uuid: font.uuid,
                bold: fontBold,
                italic: fontItalic,
                content: layer.value
            }, function (res) {
                var msg = res.message;
                if (res.status == 200) {
                    font.success = msg.success;
                    if (msg.success && !msg.supported) {
                        var message = "【" + msg.failed + "】" + "当前字体不支持这些文字！"
                        MessageService.error(message);
                        textbox.characterWarning = true;
                        textbox.characterMessage = message;
                    }
                }
            });

            currentLevel.seq = currentPage.levels.level.length;

            getFont(currentLevel.textbox,FontManagement);
            $(".block-width,.block-height").css({left: 0});
            $scope.template.letterspacing = $scope.template.lineheight = 0;

            $(".space-slider").addClass('hide1');
            $(".nav_spacing").removeClass('nav-spacing-active');

            vm.fontHide = currentLevel.textbox;
            fontStyle(currentLevel.textbox);
            // $timeout(function () {
            //     var pro = currentPage.scale / currentPage.proportion;
            //     currentLevel.textbox.geometry.width = Number($("#c-xml-page-material-fontId").width() / pro) + Number(10);
            //     currentLevel.textbox.geometry.height = Number($("#c-xml-page-material-fontId").height() / pro) + Number(5);
            // if(!isHistory){
                updateHistorys();
            // }
            $scope.currentPage = currentPage;
            $scope.selectBox = currentLevel.textbox;

            if (vm.unit == 'mm') {
                $scope.pageValue.textbox = {
                    width: PxTurnMm(currentLevel.textbox.geometry.width),
                    height: PxTurnMm(currentLevel.textbox.geometry.height),
                    x: PxTurnMm(currentPage.trimbox.x - 0 + 20 + $scope.template.levelI * 2),
                    y: PxTurnMm(currentPage.trimbox.y - 0 + 20 + $scope.template.levelI * 2)
                }
            } else if (vm.unit == 'px') {
                $scope.pageValue.textbox = currentLevel.textbox.geometry;
            } else if (vm.unit == 'In') {
                $scope.pageValue.textbox = {
                    width: PxTurnIn(currentLevel.textbox.geometry.width),
                    height: PxTurnIn(currentLevel.textbox.geometry.height),
                    x: PxTurnIn(currentPage.trimbox.x - 0 + 20 + $scope.template.levelI * 2),
                    y: PxTurnIn(currentPage.trimbox.y - 0 + 20 + $scope.template.levelI * 2)
                }
            }
            // })
            $scope.item = vm.fontList[0];
        }

        /********************************************PSD操作**********************end*************************************/


        /********************************************重复生成**********************start*************************************/

        $scope.generBox = function (e, box) {
            fn(e)
            if (!box || !$scope.RightPanel) {
                MessageService.error("请先选择一个图片或者素材！");
                return
            }
            if (box.current != 'imagebox' && box.current != 'imageart' && box.current != 'calMonthBox' && box.current != 'calTitleBox') {
                MessageService.error("请选择一个图片、素材、日历、日历标题");
                return;
            }
            if (box.lock) {
                MessageService.error("请先解锁");
                return;
            }
            $uibModal.open({
                templateUrl: 'app/entities/page/modal/box-copy.html',
                controller: 'BoxCopyController',
                controllerAs: 'vm',
                size: 'md',
                resolve: {
                    entity: [function () {
                        return {
                            box: box,
                            pageI: $scope.template.pageI
                        };
                    }]
                }
            }).result.then(function (data) {
                var box2 = angular.copy(box);
                if (data) {
                    //从当前页：this  ;   从第一页：one
                    var index = 0, arrI = 1;
                    if (data.range == 'this') {
                        index = $scope.template.pageI;
                    }

                    for (var i = index; i < $scope.template.pages.page.length; i++) {
                        var page = $scope.template.pages.page[i];
                        if(page.config.partid == $scope.currentPage.config.partid){
                            if (!page.levels.level) {
                                page.levels.level = [];
                            }
                            var arr = {
                                seq: page.levels.level.length - 0 + 1,
                                imagebox: null,
                                textbox: null,
                                imageart: null,
                                textdocument: null,
                                calMonthBox: null,
                                calTitleBox: null,
                                variable: false
                            }
                            arr[box.current] = box2;
                            arr[box.current].pageI = i;
                            arr[box.current].levelI = page.levels.level.length;

                            //从第一页开始,全部增加
                            if (data.generLoc == 'all') {
                                if (i != $scope.template.pageI) {
                                    var arr2 = angular.copy(arr)
                                    if(box.current == 'calMonthBox' || box.current == 'calTitleBox'){
                                        arr2[box.current].obj=null;
                                        arr2[box.current].sampleYear = getDay('year',$scope.template.config.startYear,$scope.template.config.startMonth,page.config.monthIndex);
                                        arr2[box.current].sampleMonth = getDay('month',$scope.template.config.startYear,$scope.template.config.startMonth,page.config.monthIndex);
                                        if(box.current == 'calMonthBox'){
                                            arr2[box.current].width=arr2[box.current].geometry.width;
                                            arr2[box.current].height=arr2[box.current].geometry.height;
                                        }
                                    }
                                    page.levels.level.push(arr2);
                                    page.updateThumbnail=true;
                                }
                            } else if (data.generLoc == 'next') {
                                var boxSeq = $scope.template.pages.page[$scope.template.pageI].seq;
                                if (i != $scope.template.pageI) {
                                    if (page.seq % 2 == boxSeq % 2) {
                                        var arr2 = angular.copy(arr)
                                        if(box.current == 'calMonthBox' || box.current == 'calTitleBox'){
                                            arr2[box.current].obj=null;
                                            arr2[box.current].sampleYear = getDay('year',$scope.template.config.startYear,$scope.template.config.startMonth,page.config.monthIndex);
                                            arr2[box.current].sampleMonth = getDay('month',$scope.template.config.startYear,$scope.template.config.startMonth,page.config.monthIndex);
                                            if(box.current == 'calMonthBox'){
                                                arr2[box.current].width=arr2[box.current].geometry.width;
                                                arr2[box.current].height=arr2[box.current].geometry.height;
                                            }
                                        }
                                        page.levels.level.push(arr2);
                                        page.updateThumbnail=true;
                                    }
                                }
                            }
                        }
                    }
                }
            });
        }

        /********************************************重复生成**********************end*************************************/


        /********************************************标准模板**********************start*************************************/

        function loadProductTemplate(tempCatalogId, pageIndex) {
            var items = [
                {key: "status", op: "=", value: true},
                {key: "cancelled", op: "=", value: "false"},
                {key: "type", op: "=", value: vm.page.productType},
                {key: "version", op: ">", value: 1},
                ];
            items.push({key: "catalog.id", op: "=", value: tempCatalogId})
            ProductTemplate.byCondition({
                items: items,
                page: pageIndex,
                size: 20,
                sort: ["seq,asc"]
            }, function (data, headers) {
                vm.productTemplatesCount = headers('X-Total-Count');
                if (data && data.length) {
                    angular.forEach(data, function (arr, i) {
                        vm.productTemplates.push(arr);
                    })
                }
            })
        }

        $scope.selectTempLabel = function (label, index) {
            vm.tempCatalogId = label.id;
            vm.proTempIndexNum = 0;
            vm.productTemplates = [];
            // if (!label.firstClick) {
            //     vm.loading = true;
            //     label.firstClick = true;
            // }

            loadProductTemplate(vm.tempCatalogId, vm.proTempIndexNum)
            $timeout(function () {
                // vm.loading = false;
                var h = $scope.dHeight - $(".c-productTemplate-view1").height() - 100;
                $(".productTemplate-con1").height(h);
            }, 1500)
        };

        $scope.showTempLabels = false;
        $scope.showTempMoreLabels = function () {
            $scope.showTempLabels = !$scope.showTempLabels;
            setTimeout(function () {
                var h = $scope.dHeight - $(".c-productTemplate-view1").height() - 100;
                $(".productTemplate-con1").height(h);
            }, 800);
        }

        $scope.loadMoreProductTemplates = function () {
            if (vm.productTemplates.length >= vm.productTemplatesCount) {
                MessageService.error("已全部加载完成");
                return
            } else if (vm.productTemplates.length == 0) {
                vm.proTempIndexNum = -1;
            }
            ++vm.proTempIndexNum;

            loadProductTemplate(vm.tempCatalogId, vm.proTempIndexNum)
        }

        vm.proTempPage = null;
        vm.changeProTempSure = false;
        vm.changeProTempLen = $scope.template.pages.page.length;
        var proTempTips = ['确认要更换模板吗？若尺寸不一致，系统将根据画布尺寸自动缩放','系统检测到您选择替换的模版页数大于当前模版页数','系统检测到您选择替换的模版页数少于当前模版页数']
        $scope.changeProductTemplate = function (item, index) {
            vm.proTempPage = angular.copy(item);
            vm.changeProTempLen = $scope.template.pages.page.length;
            if (item.pageCount == $scope.template.pages.page.length) {
                vm.proTempTitle = proTempTips[0];
                vm.proTempText = null;
            } else if (item.pageCount > $scope.template.pages.page.length) {
                vm.proTempTitle = proTempTips[1];
                vm.proTempText = '，系统将默认应用至新模板前' + $scope.template.pages.page.length + '页';
            } else if (item.pageCount < $scope.template.pages.page.length) {
                vm.proTempTitle = proTempTips[2];
                vm.proTempText = '，系统将默认保留前' + (item.pageCount) + '页'
                vm.changeProTempLen = ($scope.template.pages.page.length - item.pageCount);
            }
            vm.changeProTempSure = true;
        }

        $scope.exitChangeProTemp = function () {
            var pagesData = angular.copy($scope.template.pages.page);
            vm.changeProTempSure = false;
            vm.operation = true;
            var _template = {
                "addpage":false,
                "addunit":0,
                "maxpage":0,
                "minpage":0,
                "replace":"",
                "cover":"",
                backupPages:{
                    list:[]
                },
                config:{
                    innerOffset:0,
                    parts:{
                        list:[]
                    },
                    productType:''
                },
                deletedPages:{
                    page:[]
                },
                "frameConfigs":{
                    "frameConfig":[]
                },
                pages: {
                    page: []
                },
                "version":"4.0",
                transparency: 1,
                scene: null,
                pageI: 0,
                angle: 0,
                backup: false,
                spread: false,
                unreplace: false,
                letterspacing: 0,
                lineheight: 0,
                text: '',
                bgimgs: {bgimg: []},
                bgimgs2: {bgimg: []},
                masks: {mask: []},
                cliparts: {clipart: []},
                documentpics: {documentpic: []},
                showPic: false,
                psdFiles: {psdFile: []}
            };
            var _seq = 0;
            vm.proTempPage.parts.sort(compare('seq', true));
            vm.proTempPage.parts.forEach(function (part,index) {
                var editboxes = {
                    editbox:[{
                        height: part.pageEditH,
                        width: part.pageEditW,
                        x: part.pageEditX,
                        y: part.pageEditY
                    }]
                };
                _template.config.parts.list.push({
                    "bleed":{
                        "bottom":part.pageBloodB,
                        "left":part.pageBloodL,
                        "right":part.pageBloodR,
                        "top":part.pageBloodT
                    },
                    "editboxes":editboxes,
                    "mediabox":{
                        height: part.pageSizeH,
                        width: part.pageSizeW,
                    },
                    "counter":part.pageCount,
                    "id":part.code,
                    "name":part.name,
                    "required":(part.code == 'P' || part.code == 'P0') ? true : false,
                    "seq":index,
                    "spread":part.spread
                })
                var _page = createPage1(vm.proTempPage, part, editboxes);
                for(var i=0;i<part.pageCount; i++){
                    _page.uuid = UidService.get();
                    _page.seq = _seq;
                    if(vm.proTempPage.type == 'BOOK'){
                        _template.pages.page.push(angular.copy(_page));
                        _seq++
                    }
                    if(vm.proTempPage.type == 'PHOTO'){
                        _template.pages.page.push(angular.copy(_page));
                        _seq++
                    }
                    if(vm.proTempPage.type == 'CALENDAR'){
                        if(vm.proTempPage.pageCount == 14){
                            for(var i=0; i<(vm.proTempPage.pageCount-1); i++){
                                _page.config.monthIndex=i;
                            }
                        }
                        if(vm.proTempPage.pageCount == 26){
                            for(var i=0; i<(vm.proTempPage.pageCount-1); i++){
                                _page.config.monthIndex=i%2 === 1 ? Math.ceil(i/2) : 0;
                                _template.pages.page.push(angular.copy(_page));
                                _seq++
                            }
                        }
                    }
                    if(vm.proTempPage.type == 'THING'){
                        _template.pages.page.push(angular.copy(_page));
                        _seq++;
                    }
                }
            })
            vm.hashtags = '';
            if(vm.proTempPage.catalog.hashtags){
                for (var i = 0; i < vm.proTempPage.catalog.hashtags.length; i++) {
                    vm.hashtags += vm.proTempPage.catalog.hashtags[i].name + ','
                }
            }
            _template.config.innerOffset = vm.proTempPage.innerOffset;
            _template.config.productType = vm.proTempPage.type;
            _template.config.dynamic = vm.proTempPage.dynamic;
            if(_template.config.dynamic){
                _template.config.startYear = (vm.proTempPage.month.split("-"))[0];
                _template.config.startMonth = (vm.proTempPage.month.split("-"))[1];
            }
            _template.cover = vm.proTempPage.cover;
            _template.replace = vm.proTempPage.replace;
            _template.addpage = vm.proTempPage.addpage;
            _template.minpage = vm.proTempPage.minpage;
            _template.maxpage = vm.proTempPage.maxpage;
            _template.addunit = vm.proTempPage.addunit;
            var _resp = {
                document: _template,
                replace: vm.proTempPage.replace,
                name: vm.proTempPage.name,
                catalogId: vm.proTempPage.catalog.id,
                catalogName: vm.proTempPage.catalog.name,
                version: '4.0',
                type: 'XML',
                productTemplateId: vm.proTempPage.id,
                hashtags: vm.hashtags,
                modelBlendent: vm.proTempPage.modelBlendent,
                modelData: vm.proTempPage.modelData,
                modelPath: vm.proTempPage.modelPath,
                modelType: vm.proTempPage.modelType,
                productType: vm.proTempPage.type
            }
            vm.changeProTempSure = false;
            vm.loadingImg = true;
            getDocumentXml(_resp,function () {
                $scope.template.pages.page.forEach(function (page, index) {
                    if(pagesData[index]){
                        page.background = angular.copy(pagesData[index].background);
                        page.levels = angular.copy(pagesData[index].levels);
                        page.qrcode = angular.copy(pagesData[index].qrcode);
                        page.barcode = angular.copy(pagesData[index].barcode);
                            (function (index1) {
                                if($scope.template.pages.page[index1].background.type == 'Pic' && $scope.template.pages.page[index1].background.resource && $scope.template.pages.page[index1].background.resource.identifier){
                                    var background = $scope.template.pages.page[index1].background;
                                    var pageW = $scope.template.pages.page[index1].mediabox.width,
                                        pageH = $scope.template.pages.page[index1].mediabox.height;
                                    getBackgroundSource(background.resource, pageW, pageH, background)
                                }
                            })(index)
                    }
                })
            })
        }
        function createPage1(data, part, editboxes) {
            var _page = {
                config:{
                    "dynamic":(data.dynamic ? true : false),
                    "monthIndex":data.monthIndex || 0,
                    "monthMultiple":false,
                    "partid":part.code
                },
                isScene: false,
                bgImg: '',
                background: {resource: {},color:'#ffffff', type: "Color"},
                pagecover: {},
                levels: {},
                barcode: {},
                qrcode: {},
                editbox: editboxes.editbox[0],
                editboxes: editboxes,
                mediabox: {
                    height: part.pageSizeH,
                    width: part.pageSizeW,
                },
                trimbox: {
                    height: part.pageSizeH - Number(part.pageBloodB) - Number(part.pageBloodT),
                    width: part.pageSizeW - Number(part.pageBloodL) - Number(part.pageBloodR),
                    x: part.pageBloodL,
                    y: part.pageBloodT
                },
                scale: 1,
                proportion: 1,
                seq: 0,
                spread: part.spread,
                backup: false,
                unreplace: !data.replace
            }
            if (part.mould) {
                if(part.mould.modelType == 'TWO' || part.mould.modelType == 'NONE'){
                    part.mould.modelType = 'TWO';
                    _page.scene = {
                        background: {
                            resource: {
                                identifier: part.mould.modelPic.indexOf('http') > -1 ? part.mould.modelPic : vm.domainQ + part.mould.modelPic,
                                provider: "qiniu"
                            }
                        },
                        geometry: {
                            width: part.mould.gWidth,
                            height: part.mould.gHeight,
                            x: 0,
                            y: 0
                        },
                        imagebox: {
                            geometry: {
                                width: part.mould.width,
                                height: part.mould.height,
                                x: part.mould.x,
                                y: part.mould.y
                            },
                            rotation: {angle: 0},
                            transparency: 1,
                        },
                        hierarchy: part.mould.hierarchy,
                        mouldid: part.mould.id,
                        isScene: true,
                        scale: 1,
                        unit: "mm",
                        resource:{
                            identifier: part.mould.modelPic.indexOf('http') > -1 ? part.mould.modelPic : vm.domainQ + part.mould.modelPic,
                            provider: "qiniu"
                        }
                    }
                }
            }
            return _page;
        }

        /********************************************标准模板**********************end*************************************/

        function currentPageElement() {
            $scope.pxInsufficient($scope.currentPage, 'background');
            if ($scope.currentPage && $scope.currentPage.levels && $scope.currentPage.levels.level) {
                $scope.currentPage.levels.level.forEach(function (level) {
                    if (level.imagebox && level.imagebox.current) {
                        $scope.pxInsufficient(level.imagebox, 'imagebox');
                    }
                    if (level.imageart && level.imageart.current) {
                        $scope.pxInsufficient(level.imageart, 'imageart');
                    }
                    if (level.textbox && level.textbox.current) {
                        $scope.verifyTextFont(level.textbox);
                    }
                })
            }
        }
        $scope.completeIndex = function(index) {
            return ($scope.currentPage.levels.level.length-1-index)
        }

        $scope.levelClick = function(e, level, index){
            var index = $scope.completeIndex(index)
            if (level.imagebox&&level.imagebox.current) {
                $scope.selectImg(e, index, level.imagebox)
            }
            if (level.imageart&&level.imageart.current) {
                $scope.selectArt(e, index, level.imageart)
            }
            if (level.textbox&&level.textbox.current) {
                $scope.selectText(e, index, level.textbox)
            }
            if (level.textdocument&&level.textdocument.current) {
                $scope.selectDoc(e, index, level.textdocument)
            }
            if (level.calMonthBox&&level.calMonthBox.current) {
                $scope.selectCalMonthBox(e, index, level.calMonthBox)
            }
            if (level.calTitleBox&&level.calTitleBox.current) {
                $scope.selectCalTitleBox(e, index, level.calTitleBox)
            }
            fn(e)
        }
        $scope.levelInfo = function (level, index) {
            var item = "";
            index = $scope.currentPage.levels.level.length - 1 - index;
            var i = index + 1;
            if (level.imagebox) {
                item += "相框"
            }
            if (level.imageart) {
                item += "素材"
            }
            if (level.textbox) {
                item += level.textbox.text || ""
            }
            if (level.textdocument) {
                item += "文本模板"
            }
            if (level.calTitleBox) {
                item += "日历标题"
            }
            if (level.calMonthBox) {
                item += "日历组件"
            }
            return item
        };
        $scope.warnInfo = function (level) {
            if (level) {
                if (level.imagebox) {
                    if (level.imagebox.lowAccuracy || level.imagebox.lowAccuracyMask) {
                        return true
                    } else {
                        return false
                    }
                }
                if (level.imageart) {
                    return level.imageart.lowAccuracy
                }
                if (level.textbox) {
                    return !level.textbox.success
                }
                if (level.textdocument) {
                    return level.textdocument.lowAccuracy
                }
            }
        };
        $scope.warnMessage = function (level) {
            if (level) {
                var lowAccuracyMessage = "像素精度较低";
                if (level.imagebox) {
                    if (level.imagebox.lowAccuracy || level.imagebox.lowAccuracyMask) {
                        return lowAccuracyMessage;
                    } else {
                        return ""
                    }
                }
                if (level.imageart) {
                    if (level.imageart.lowAccuracy) {
                        return lowAccuracyMessage;
                    }
                }
                if (level.textbox) {
                    if (level.textbox.characterWarning) {
                        return level.textbox.characterMessage;
                    }
                    if (level.textbox.lowAccuracy) {
                        return lowAccuracyMessage;
                    }
                }
                if (level.textdocument) {
                    if (level.textdocument.lowAccuracy) {
                        return lowAccuracyMessage;
                    }
                }
            }
            return '';
        };
        $scope.levelDelete = function (index) {
            index = $scope.currentPage.levels.level.length - 1 - index;
            $scope.currentPage.levels.level.splice(index, 1);
            updateHistorys();
        };
        $scope.clearPage = function () {
            $scope.currentPage.levels.level = [];
            $scope.currentPage.barcode = null;
            $scope.currentPage.qrcode = null;
            updateHistorys();
        }
        $scope.PxTurnMm = function (item) {
            return PxTurnMm(item)
        }
        $scope.pageLook = function (index) {
            vm.isPageThumbnail = true;
            vm.pageThumbnails = [];
            vm.pageThumbnailsIndex = null;
            $scope.template.backupPages.list.forEach(function (page, i) {
                vm.pageThumbnails.push(page)
                if (index === i) {
                    vm.pageThumbnailsIndex = vm.pageThumbnails.length - 1;
                }
            })
        }

        $scope.pageThumbnailHide = function (e) {
            e.stopPropagation();
            vm.isPageThumbnail = false;
        }
        $scope.pageThumbnailHide1 = function (e) {
            e.stopPropagation();
        }
        //元素精度检测
        $scope.pxInsufficient = function (item, type) {
            if(!vm.gitDpi){
                return
            }
            item.lowAccuracy = false;
            if (type == 'background') {
                if (item.background.type == 'Pic' && item.background.resource && item.background.resource.identifier) {
                    var _width = PxTurnMm(item.mediabox.width);
                    var _height = PxTurnMm(item.mediabox.height);
                    var _data = pxInsufficient(item.background.resource.width, item.background.resource.height, item.background.scale, _width, _height);
                    if (_data < vm.gitDpi.bgDpi - 0.01) {
                        item.lowAccuracy = true;
                    }
                }
                $timeout(function () {
                    $scope.currentPage.lowAccuracy = item.lowAccuracy;
                }, 300)
            }
            if (type == 'imageart' && $scope.template.pages.page[$scope.template.pageI].levels.level[$scope.template.levelI].imageart) {
                $scope.template.pages.page[$scope.template.pageI].levels.level[$scope.template.levelI].imageart.lowAccuracy = false;
                if (item.resource.width && item.resource.height) {
                    var _width = PxTurnMm(item.geometry.width);
                    var _height = PxTurnMm(item.geometry.height);
                    var _data = pxInsufficient(item.resource.width, item.resource.height, item.scale, _width, _height);
                    if (_data < vm.gitDpi.clipArtDpi - 0.01) {
                        item.lowAccuracy = true;
                    }
                } else {
                    imageInfo($http, item.resource, function () {
                        var _width = PxTurnMm(item.geometry.width);
                        var _height = PxTurnMm(item.geometry.height);
                        var _data = pxInsufficient(item.resource.width, item.resource.height, item.scale, _width, _height);
                        if (_data < vm.gitDpi.clipArtDpi - 0.01) {
                            item.lowAccuracy = true;
                            $scope.template.pages.page[$scope.template.pageI].levels.level[$scope.template.levelI].imageart.lowAccuracy = true;
                        }
                    })
                }
                var imageart = $scope.template.pages.page[$scope.template.pageI].levels.level[$scope.template.levelI].imageart;
                $timeout(function () {
                    if (imageart) {
                        imageart.lowAccuracy = item.lowAccuracy;
                    }
                }, 300)
            }

            if (type == 'imagebox') {
                if (item && item.image && item.image.resource && item.image.resource.identifier) {
                    if (item.image.resource.width && item.image.resource.height) {
                        var _width = PxTurnMm(item.geometry.width);
                        var _height = PxTurnMm(item.geometry.height);
                        var _data = pxInsufficient(item.image.resource.width, item.image.resource.height, item.image.scale, _width, _height);
                        if (_data < vm.gitDpi.imgDpi - 0.01) {
                            item.lowAccuracy = true;
                        }
                    } else {
                        imageInfo($http, item.image.resource, function () {
                            var _width = PxTurnMm(item.geometry.width);
                            var _height = PxTurnMm(item.geometry.height);
                            var _data = pxInsufficient(item.image.resource.width, item.image.resource.height, item.image.scale, _width, _height);
                            if (_data < vm.gitDpi.imgDpi - 0.01) {
                                item.lowAccuracy = true;
                            }
                        })
                    }
                    var imagebox = $scope.template.pages.page[$scope.template.pageI].levels.level[$scope.template.levelI].imagebox;
                    $timeout(function () {
                        if (imagebox) {
                            imagebox.lowAccuracy = item.lowAccuracy;
                        }
                    }, 300)
                }
                if (item && item.mask && item.mask.resource && item.mask.resource.identifier) {
                    item.lowAccuracyMask = false;
                    if (item.mask.resource.width && item.mask.resource.height) {
                        var _width = PxTurnMm(item.geometry.width);
                        var _height = PxTurnMm(item.geometry.height);
                        var _data = pxInsufficient(item.mask.resource.width, item.mask.resource.height, item.mask.scale, _width, _height);
                        if (_data < vm.gitDpi.maskDpi - 0.01) {
                            item.lowAccuracyMask = true;
                        }
                    } else {
                        imageInfo($http, item.mask.resource, function () {
                            var _width = PxTurnMm(item.geometry.width);
                            var _height = PxTurnMm(item.geometry.height);
                            var _data = pxInsufficient(item.mask.resource.width, item.mask.resource.height, item.mask.scale, _width, _height);
                            if (_data < vm.gitDpi.maskDpi - 0.01) {
                                item.lowAccuracyMask = true;
                            }
                        })
                    }
                    var imagebox = $scope.template.pages.page[$scope.template.pageI].levels.level[$scope.template.levelI].imagebox;
                    $timeout(function () {
                        if (imagebox) {
                            imagebox.lowAccuracyMask = item.lowAccuracyMask;
                        }
                    }, 300)
                }
            }
        }

        //元素四角拖拽
        $scope.cursor = function (angle, source, boolean) {
            var _cursor = '';
            if (angle > 0 && !boolean) {
                angle = 360 - angle;
            }
            if (source == 'left' || source == 'right') {
                if (337 <= angle || angle < 22) {
                    _cursor = 'se-resize';
                }
                if (22 <= angle && angle < 67) {
                    _cursor = 'n-resize';
                }
                if (67 <= angle && angle < 112) {
                    _cursor = 'sw-resize';
                }
                if (112 <= angle && angle < 157) {
                    _cursor = 'e-resize';
                }
                if (157 <= angle && angle < 202) {
                    _cursor = 'se-resize';
                }
                if (202 <= angle && angle < 247) {
                    _cursor = 'n-resize';
                }
                if (247 <= angle && angle < 292) {
                    _cursor = 'sw-resize';
                }
                if (292 <= angle && angle < 337) {
                    _cursor = 'e-resize';
                }
            }
            if (source == 'top' || source == 'bottom') {
                if (337 <= angle || angle < 22) {
                    _cursor = 'sw-resize';
                }
                if (22 <= angle && angle < 67) {
                    _cursor = 'e-resize';
                }
                if (67 <= angle && angle < 112) {
                    _cursor = 'se-resize';
                }
                if (112 <= angle && angle < 157) {
                    _cursor = 'n-resize';
                }
                if (157 <= angle && angle < 202) {
                    _cursor = 'sw-resize';
                }
                if (202 <= angle && angle < 247) {
                    _cursor = 'e-resize';
                }
                if (247 <= angle && angle < 292) {
                    _cursor = 'se-resize';
                }
                if (292 <= angle && angle < 337) {
                    _cursor = 'n-resize';
                }
            }
            if (source == 'left1' || source == 'right1') {
                if (337 <= angle || angle < 22) {
                    _cursor = 'e-resize';
                }
                if (22 <= angle && angle < 67) {
                    _cursor = 'se-resize';
                }
                if (67 <= angle && angle < 112) {
                    _cursor = 'n-resize';
                }
                if (112 <= angle && angle < 157) {
                    _cursor = 'sw-resize';
                }
                if (157 <= angle && angle < 202) {
                    _cursor = 'e-resize';
                }
                if (202 <= angle && angle < 247) {
                    _cursor = 'se-resize';
                }
                if (247 <= angle && angle < 292) {
                    _cursor = 'n-resize';
                }
                if (292 <= angle && angle < 337) {
                    _cursor = 'sw-resize';
                }
            }
            if (source == 'top1' || source == 'bottom1') {
                if (337 <= angle || angle < 22) {
                    _cursor = 'n-resize';
                }
                if (22 <= angle && angle < 67) {
                    _cursor = 'sw-resize';
                }
                if (67 <= angle && angle < 112) {
                    _cursor = 'e-resize';
                }
                if (112 <= angle && angle < 157) {
                    _cursor = 'se-resize';
                }
                if (157 <= angle && angle < 202) {
                    _cursor = 'n-resize';
                }
                if (202 <= angle && angle < 247) {
                    _cursor = 'sw-resize';
                }
                if (247 <= angle && angle < 292) {
                    _cursor = 'e-resize';
                }
                if (292 <= angle && angle < 337) {
                    _cursor = 'se-resize';
                }
            }
            return _cursor
        }

        //备用页
        $scope.backupPartCb = function(item){
            vm.backupPartId = item.id;
        }

        //边框
        $scope.imageboxW = function (imagebox) {
            if (!imagebox) {
                return
            }
            if (imagebox.border) {
                if (imagebox.border.type == 'Color') {
                    return Number(imagebox.geometry.width) + Number(imagebox.border.lineWidth) * 2
                }
                if (imagebox.border.type == 'Pic') {
                    return imagebox.geometry.width
                    // return Number(imagebox.geometry.width) + (Number(imagebox.geometry.width) * Number(imagebox.border.edge.left) / 100) + (Number(imagebox.geometry.width) * Number(imagebox.border.edge.right) / 100)
                }
            } else {
                return imagebox.geometry.width
            }
        }
        $scope.imageboxH = function (imagebox) {
            if (!imagebox) {
                return
            }
            if (imagebox.border) {
                if (imagebox.border.type == 'Color') {
                    return Number(imagebox.geometry.height) + Number(imagebox.border.lineWidth) * 2
                }
                if (imagebox.border.type == 'Pic') {
                    return imagebox.geometry.height
                    // return Number(imagebox.geometry.height) + (Number(imagebox.geometry.height) * Number(imagebox.border.edge.top) / 100) + (Number(imagebox.geometry.height) * Number(imagebox.border.edge.bottom) / 100)
                }
            } else {
                return imagebox.geometry.height
            }
        }
        $scope.imageboxL = function (imagebox) {
            if (!imagebox) {
                return
            }
            if (imagebox.border) {
                if (imagebox.border.type == 'Color') {
                    return Number(imagebox.geometry.x) - Number(imagebox.border.lineWidth)
                }
                if (imagebox.border.type == 'Pic') {
                    return imagebox.geometry.x
                    // return Number(imagebox.geometry.x) - (Number(imagebox.geometry.width) * Number(imagebox.border.edge.left) / 100)
                }
            } else {
                return imagebox.geometry.x
            }
        }
        $scope.imageboxT = function (imagebox) {
            if (!imagebox) {
                return
            }
            if (imagebox.border) {
                if (imagebox.border.type == 'Color') {
                    return Number(imagebox.geometry.y) - Number(imagebox.border.lineWidth)
                }
                if (imagebox.border.type == 'Pic') {
                    return imagebox.geometry.y
                    // return Number(imagebox.geometry.y) - (Number(imagebox.geometry.height) * Number(imagebox.border.edge.top) / 100)
                }
            } else {
                return imagebox.geometry.y
            }
        }
        $scope.imageboxWEdge = function (imagebox, edge) {
            if (!imagebox) {
                return
            }
            if (imagebox.border) {
                if (imagebox.border.type == 'Color') {
                    return Number(imagebox.border.lineWidth)
                }
                if (imagebox.border.type == 'Pic') {
                    if (edge == 'left') {
                        return Number(imagebox.geometry.width) * Number(imagebox.border.edge.left) / 100
                    }
                    if (edge == 'top') {
                        return Number(imagebox.geometry.height) * Number(imagebox.border.edge.top) / 100
                    }
                    if (edge == 'right') {
                        return Number(imagebox.geometry.width) * Number(imagebox.border.edge.right) / 100
                    }
                    if (edge == 'bottom') {
                        return Number(imagebox.geometry.height) * Number(imagebox.border.edge.bottom) / 100
                    }
                }
            } else {
                return 0
            }
        }
        $scope.imageboxWRadius = function (imagebox, radius, ratio) {
            if (!imagebox) {
                return
            }
            if (imagebox.border) {
                if (imagebox.border.shape == 'Ellipse') {
                    return '50%'
                }
                if (imagebox.border.radius.filletType == 'Fixed') {//圆角固定值
                    var _radius = imagebox.border.radius[radius];
                    return _radius > 0 ? (_radius + Number(imagebox.border.lineWidth)/2) * ratio : 0;
                }else{
                    var radiusW = imagebox.geometry.width > imagebox.geometry.height ? imagebox.geometry.height : imagebox.geometry.width;
                    radiusW = radiusW + imagebox.border.lineWidth;
                    var _r = radiusW * imagebox.border.radius[radius] / 100;
                    return _r > 0 ? (_r + Number(imagebox.border.lineWidth)/2) * ratio : 0
                }
            } else {
                return 0
            }
        }
        $scope.imageboxWRadius1 = function (imagebox, radius, ratio) {
            if (!imagebox) {
                return
            }
            if (imagebox.border) {
                var radiusW = imagebox.geometry.width > imagebox.geometry.height ? imagebox.geometry.height : imagebox.geometry.width;
                if (imagebox.border.shape == 'Ellipse') {
                    return '50%'
                } else {
                    return 0
                }
            } else {
                return 0
            }
        }

        $scope.imageboxWRadius2 = function (imagebox, radius) {
            if (!imagebox) {
                return
            }
            if (imagebox.border) {
                if (imagebox.border.shape == 'Ellipse') {
                    return '50%'
                } else {
                    var radiusW = imagebox.geometry.width > imagebox.geometry.height ? imagebox.geometry.height : imagebox.geometry.width;
                    radiusW = radiusW + imagebox.border.lineWidth;
                    var _r = radiusW * imagebox.border.radius[radius] / 100;
                    return _r > 0 ? _r + Number(imagebox.border.lineWidth) / 2 : 0
                }
            } else {
                return 0
            }
        }
        $scope.imageboxWRadius3 = function (imagebox, radius) {
            if (!imagebox) {
                return
            }
            if (imagebox.border) {
                if (imagebox.border.shape == 'Ellipse') {
                    return '50%'
                } else {
                    var radiusW = imagebox.geometry.width > imagebox.geometry.height ? imagebox.geometry.height : imagebox.geometry.width;
                    radiusW = radiusW + imagebox.border.lineWidth;
                    var _r = radiusW * imagebox.border.radius[radius] / 100;
                    return (_r - Number(imagebox.border.lineWidth) / 2) > 0 ? _r - Number(imagebox.border.lineWidth) / 2 : 0
                }
            } else {
                return 0
            }
        }
        $scope.borderRadius = function () {
            $scope.template.pages.page[$scope.template.pageI].levels.level[$scope.template.levelI].imagebox.border.radius = angular.copy(vm.selectElementCopy.imagebox.border.radius);
        }
        vm.borderRadiusAllbtn = true
        $scope.borderRadiusAll = function () {
            vm.selectElementCopy.imagebox.border.radius.lt = vm.selectElementCopy.imagebox.border.radius.all;
            vm.selectElementCopy.imagebox.border.radius.rt = vm.selectElementCopy.imagebox.border.radius.all;
            vm.selectElementCopy.imagebox.border.radius.rb = vm.selectElementCopy.imagebox.border.radius.all;
            vm.selectElementCopy.imagebox.border.radius.lb = vm.selectElementCopy.imagebox.border.radius.all;
            $scope.borderRadius();
        }
        $scope.borderRadiusAllbtn = function () {
            vm.borderRadiusAllbtn = true;
            vm.selectElementCopy.imagebox.border.radius.rt = vm.selectElementCopy.imagebox.border.radius.lt;
            vm.selectElementCopy.imagebox.border.radius.rb = vm.selectElementCopy.imagebox.border.radius.lt;
            vm.selectElementCopy.imagebox.border.radius.lb = vm.selectElementCopy.imagebox.border.radius.lt;
            vm.selectElementCopy.imagebox.border.radius.all = vm.selectElementCopy.imagebox.border.radius.lt;
            $scope.borderRadius();
        }

        $scope.changeFilletType = function(type){
            if (vm.selectElementCopy.imagebox.border.radius.filletType == type) {
                return
            }
            vm.selectElementCopy.imagebox.border.radius.filletType = type;
            switchToRoundedMode(vm.selectElementCopy.imagebox,vm.borderRadiusAllbtn);//切换圆角显示模式
            $scope.borderRadius();
        }

        vm.showBorderLabels = false;
        vm.chooseBorderClassId = null;
        $scope.showLabels = false;
        // 切换
        $scope.chooseBorderTab = function (attr) {
            if (vm.borderTab == attr) {
                return
            }
            vm.borderTab = attr;
            vm.chooseBorderClassId = null;
            vm.showBorderLabels = false;
            vm.frameConfigs = [];
            vm.borderItems = [];
            vm.borderPage = 0;
            $timeout(function () {
                vm.borderListHeight = $scope.dHeight - $('#borderLabelsHeight').height() - 50 - 40;
            })
            if (vm.borderTab == 'USER') {
                $scope.borderLabels = vm.myBorderClass;
                getUserBorders()
            }
            if (vm.borderTab == 'SYSTEM') {
                $scope.borderLabels = vm.systemBorderClass;
                getSystemBorders()
            }
            if (vm.borderTab == 'RECOMMEND') {
                vm.frameConfigs = $scope.template.frameConfigs.frameConfig;
            }

        }

        vm.frameConfigs = [];
        vm.borderListHeight = 0;
        vm.borderPage = 0;
        vm.borderSize = 20;
        vm.borderItems = [];
        vm.borderDataCount = 0;
        function getSystemBorders() {
            vm.borderItems.push({key: "enable", op: "=", value: true})
            FrameConfig.byCondition({
                items: vm.borderItems,
                sort: ["id,desc"],
                size: vm.borderSize,
                page: vm.borderPage,
            }, function (res,headers) {
                vm.borderDataCount = headers('X-Total-Count');
                if (res.message instanceof Array) {
                    res.message.forEach(function (item) {
                        if($scope.template.frameConfigs && $scope.template.frameConfigs.frameConfig && $scope.template.frameConfigs.frameConfig.length>0){
                            for(var i=0; i<$scope.template.frameConfigs.frameConfig.length; i++){
                                if($scope.template.frameConfigs.frameConfig[i].id == item.id){
                                    item.isRecommend = true;
                                    break
                                }
                            }
                        }
                        vm.frameConfigs.push(item)
                    })
                    vm.borderListHeight = $scope.dHeight - $('#borderLabelsHeight').height() - 50 - 40;
                }


            })
        }

        function getUserBorders() {
            vm.borderItems.push({key: "enable", op: "=", value: true})
            FrameConfig.byCondition1({
                items: vm.borderItems,
                sort: ["id,desc"],
                size: vm.borderSize,
                page: vm.borderPage,
            }, function (res,headers) {
                vm.borderDataCount = headers('X-Total-Count');
                if (res.message instanceof Array) {
                    res.message.forEach(function (item) {
                        if ($scope.template.frameConfigs && $scope.template.frameConfigs.frameConfig && $scope.template.frameConfigs.frameConfig.length > 0) {
                            $scope.template.frameConfigs.frameConfig.forEach(function (recommend) {
                                if (recommend.id == item.id) {
                                    item.isRecommend = true;
                                }
                            })
                        }
                        vm.frameConfigs.push(item)
                    })
                }
            })
        }

        $scope.showMoreLabels = function () {
            $scope.showLabels = !$scope.showLabels;
        }
        $scope.selectBorderLabelAll = function () {
            vm.chooseBorderClassId = null;
            vm.frameConfigs = [];
            vm.borderItems = [];
            if (vm.borderTab == 'SYSTEM') {
                getSystemBorders()
            }

            if (vm.borderTab == 'USER') {
                getUserBorders()
            }
        }
        // 点击分类
        $scope.selectBorderLabel = function (label, index) {
            vm.chooseBorderClassId = label.id;
            vm.frameConfigs = [];
            vm.borderItems = [];
            vm.borderPage = 0;
            vm.borderItems.push({key: "themeClassify.id", op: "=", value: label.id})
            if (vm.borderTab == 'SYSTEM') {
                getSystemBorders()
            }

            if (vm.borderTab == 'USER') {
                getUserBorders()
            }
        };

        // 计算边框内容的高度
        $scope.showMoreBorderLabels = function () {
            vm.showBorderLabels = !vm.showBorderLabels;
            $timeout(function () {
                vm.borderListHeight = $scope.dHeight - $('#borderLabelsHeight').height() - 110;
            })
        }

        // 点击加载更多
        $scope.loadMoreBorder = function () {
            if (vm.borderDataLength < vm.borderSize) {
                MessageService.error('没有更多的边框了')
                return
            }
            vm.borderPage++;

            if (vm.borderTab == 'SYSTEM') {
                getSystemBorders()
            }

            if (vm.borderTab == 'USER') {
                getUserBorders()
            }
        }
        $scope.recommendBorder = function (item) {
            var recommendBorder = $scope.template.frameConfigs.frameConfig || [];
            item.isRecommend = !item.isRecommend;
            if (item.isRecommend) {
                recommendBorder.push(item);
            } else {
                recommendBorder.some(function (recommend, i) {
                    if (recommend.id == item.id) {
                        recommendBorder.splice(i, 1)
                        return
                    }
                })
            }
        }
        $scope.canvasCb = function (e) {
            $scope.showCut = false;
            vm.isImageartTrim = false;
            $scope.imageboxFalseClick();
            fn(e)
        }
        $scope.lineTypeChenge = function (lineType) {
            $scope.template.pages.page[$scope.template.pageI].levels.level[$scope.template.levelI].imagebox.border.lineType = lineType;
        }
        $scope.dropShadow = function (imagebox, radius) {
            if (imagebox == null || imagebox.shadow == null) {
                return
            }
            var width = $scope.imageboxW(imagebox) * radius;
            var height = $scope.imageboxH(imagebox) * radius;
            return dropShadow(imagebox, width, height)
        }

        function thumbnailatorPic() {
            $uibModal.open({
                templateUrl: 'app/entities/page/thumbnailator.html',
                controller: 'ThumbnailatorController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'md',
                resolve: {
                    entity: [function () {
                        return {
                            files: bigSizePics
                        };
                    }]
                }
            }).result.then(function (values) {
                bigSizePics = [];
                if (values) {
                    //for (var j = 0; j < values.length; j++) {
                        //var value = values[j];
                        //var data = {key: value.key};
                        if (vm.uploadType == "BG"){
                            var len = 0;
                            if (vm.showBackgrounds && vm.showBackgrounds.length) {
                                len = vm.showBackgrounds.length;
                            }
                            for (var i = 0; i < values.length; i++) {
                                getBackground(values, i, len);
                            }
                        }else if (vm.uploadType == "MASK"){
                            for (var i = 0; i < values.length; i++) {
                                getMask(values,i);
                            }
                        }else if (vm.uploadType == "CLIPART"){
                            for (var i = 0; i < values.length; i++){
                                var len = vm.showCliparts.clipart.length;
                                getArtImg(values, i, len);
                                vm.clipartTab = 'all';
                            }
                        }else if (vm.uploadType == "BgImg"){
                            var len = $scope.template.bgimgs.bgimg.length;
                            for (var i = 0; i < values.length; i++) {
                                getBgImg(values,i,len);
                            }
                        }else if (vm.uploadType == "UserImg"){
                            for (var i = 0; i < values.length; i++) {
                                getUserImg(values,i);
                            }
                        }
                    //}
                    vm.picLoading = false;
                }
                vm.uploadType = "";
            }, function () {
                vm.picLoading = false;
            });false
        }
        // 画布位置X
        $scope.canvasCoordX = function (width){
            if (!width) {
                return 0;
            }
            vm.pageCenterWidth = $('#pageCenterSize').width();
            var x = (vm.pageCenterWidth-(width || 0))/2 + vm.moveCanvasObj.x;
            return x;
        }
        // 画布位置Y
        $scope.canvasCoordY = function (height){
            if (!height) {
                return 0;
            }
            vm.pageCenterHeight = $('#pageCenterSize').height();
            var y = (vm.pageCenterHeight-(height || 0))/2  + vm.moveCanvasObj.y;
            return y;
        }
        vm.getAllCtrlKeyArray = getAllCtrlKeyArray;
        $scope.singleBoxAlignment = function (attr) {
            var all = getAllCtrlKeyArray();
            if(all.length >= 2){
                $scope.boxAlignment(attr)
                return
            }
            if (!$scope.selectBox.geometry) {
                MessageService.error("请选择一个元素");
                return
            }
            if ($scope.selectBox.lock) {
                MessageService.error("请先解锁该元素");
                return
            }
            if (attr == 'left') {
                $scope.selectBox.geometry.x = elementAlign($scope.selectBox.geometry , $scope.selectBox.rotation.angle , 'left' , $scope.template.pages.page[$scope.template.pageI].mediabox.width , $scope.template.pages.page[$scope.template.pageI].mediabox.height);
            } else if (attr == 'right') {
                $scope.selectBox.geometry.x = elementAlign($scope.selectBox.geometry , $scope.selectBox.rotation.angle , 'right' , $scope.template.pages.page[$scope.template.pageI].mediabox.width , $scope.template.pages.page[$scope.template.pageI].mediabox.height);
            } else if (attr == 'top') {
                $scope.selectBox.geometry.y = elementAlign($scope.selectBox.geometry , $scope.selectBox.rotation.angle , 'top' , $scope.template.pages.page[$scope.template.pageI].mediabox.width , $scope.template.pages.page[$scope.template.pageI].mediabox.height);
            } else if (attr == 'bottom') {
                $scope.selectBox.geometry.y = elementAlign($scope.selectBox.geometry , $scope.selectBox.rotation.angle , 'bottom' , $scope.template.pages.page[$scope.template.pageI].mediabox.width , $scope.template.pages.page[$scope.template.pageI].mediabox.height);
            } else if (attr == 'vertical') {
                $scope.selectBox.geometry.y = ($scope.template.pages.page[$scope.template.pageI].mediabox.height - $scope.selectBox.geometry.height) / 2;
            } else {
                $scope.selectBox.geometry.x = ($scope.template.pages.page[$scope.template.pageI].mediabox.width - $scope.selectBox.geometry.width) / 2;
            }
            updateHistorys()
        }

        //备用页拖拽standbyPage
        var standbyPageSort = null;
        var oldPageIndex = null;
        var newPageIndex = null;
        standbyPageDrag();
        function standbyPageDrag() {
            $timeout(function () {
                standbyPageSort = new Sortable(document.getElementById('standbyPage'), {
                    swap: false,
                    filter: '.filtered',
                    cancel: ".notDrag",
                    preventOnFilter: true,
                    animation: 150,
                    onStart: function (/**Event*/evt) {
                        // 拿到当前拖拽的pageIndex
                        oldPageIndex = evt.oldIndex+$scope.template.backupPages.list.length - $('#standbyPage').find(".standbyPageLi").length;
                    },
                    onEnd: function (/**Event*/evt) {
                        vm.loadingImg = true;
                        // 拿到当前拖拽后的pageIndex
                        newPageIndex = evt.newIndex+$scope.template.backupPages.list.length - $('#standbyPage').find(".standbyPageLi").length;
                        $timeout(function(){
                            var otherObj1 = angular.copy($scope.template.backupPages.list[oldPageIndex]);
                            var pages = angular.copy($scope.template.backupPages.list)
                            pages.splice(oldPageIndex,1)
                            pages.splice(newPageIndex,0,otherObj1)
                            var _page = angular.copy(pages);
                            $scope.template.backupPages.list = [];
                            $timeout(function () {
                                pageSeq(_page, UidService, function (page) {
                                    $scope.template.backupPages.list = page;
                                    vm.loadingImg = false;
                                    $scope.$apply()
                                })
                            },100)
                        })

                    }
                });
            })
        }

        $scope.productType = function(item) {
            switch (item) {
                case 'BOOK':
                    return '照片书';
                case 'PHOTO':
                    return '冲印';
                case 'CALENDAR':
                    return '台历';
                case 'THING':
                    return '万物';
                default:
                    return ''
            }
        };
        vm.attributeTab='page';
        /*刻度尺*/
        vm.staff = true;
        var measureRuler = null;
        var measureRuler2 = null;
        function measureRulerInit() {
            var _w = PxTurnMm($scope.currentPage.custom.width) < 1000 ? 1000 : PxTurnMm($scope.currentPage.custom.width);
            var _h = PxTurnMm($scope.currentPage.custom.height) < 1000 ? 1000 : PxTurnMm($scope.currentPage.custom.height);
            var _mult = MmTurnPx(1)/$scope.currentPage.proportion*$scope.currentPage.scale/10;
            var w = $scope.currentPage.mediabox.width/$scope.currentPage.proportion*$scope.currentPage.scale;
            var h = $scope.currentPage.mediabox.height/$scope.currentPage.proportion*$scope.currentPage.scale;
            if($scope.currentPage.isScene){
                _mult = MmTurnPx(1)*$scope.currentPage.scale/$scope.currentPage.scene.proportion/10;
                w = $scope.currentPage.scene.geometry.width*$scope.currentPage.scale/$scope.currentPage.scene.proportion;
                h = $scope.currentPage.scene.geometry.height*$scope.currentPage.scale/$scope.currentPage.scene.proportion;
            }
            var _left = $scope.canvasCoordX(w);
            var _top = $scope.canvasCoordY(h);
            measureRuler =new MeasureRuler({
                wrapperId:"graduatedScale-cross",     //容器ID，页面中写一个DIV就行 (必须)
                max:_w,  //刻度尺最大的刻度    (非必须，默认为1000)
                unitSet:unitInit(_mult),//刻度尺单元长度    (非必须，默认是10)
                mult:_mult,  //刻度值倍数，默认是最小刻度值为10px，如果定mult为3则最小刻度为30px (非必须，默认为1)
                left:_left,
                click:function (item) {
                    var _item = item*$scope.currentPage.proportion/$scope.currentPage.scale;
                    if($scope.currentPage.isScene){
                        _item = item/$scope.currentPage.scale*$scope.currentPage.scene.proportion;
                    }
                    _item -= ($scope.currentPage.isScene?$scope.currentPage.scene.imagebox.geometry.x:0);
                    if(sublinesInfo(_item,'x')){
                        vm.sublinesX.push(_item);
                    }
                    $scope.$apply();
                }
            })
            measureRuler2 =new MeasureRuler({
                wrapperId:"graduatedScale-vertical",     //容器ID，页面中写一个DIV就行 (必须)
                max:_h,                     //刻度尺最大的刻度    (非必须，默认为1000)
                unitSet:unitInit(_mult),                   //刻度尺单元长度    (非必须，默认是10)
                mult:_mult,                   //刻度值倍数，默认是最小刻度值为10px，如果定mult为3则最小刻度为30px (非必须，默认为1)
                vertical:true,
                top:_top,
                yClick:function (item) {
                    var _item = item*$scope.currentPage.proportion/$scope.currentPage.scale;
                    if($scope.currentPage.isScene){
                        _item = item/$scope.currentPage.scale*$scope.currentPage.scene.proportion;
                    }
                    _item -= ($scope.currentPage.isScene?$scope.currentPage.scene.imagebox.geometry.y:0);
                    if(sublinesInfo(_item,'y')){
                        vm.sublinesY.push(_item);
                    }
                    $scope.$apply();
                }
            })
        }
        function updateMeasureRuler() {
            if(measureRuler&&measureRuler2){
                var _mult = MmTurnPx(1)/$scope.currentPage.proportion*$scope.currentPage.scale/10;
                var w = $scope.currentPage.mediabox.width/$scope.currentPage.proportion*$scope.currentPage.scale;
                var h = $scope.currentPage.mediabox.height/$scope.currentPage.proportion*$scope.currentPage.scale;
                if($scope.currentPage.isScene){
                    _mult = MmTurnPx(1)*$scope.currentPage.scale/$scope.currentPage.scene.proportion/10;
                    w = $scope.currentPage.scene.geometry.width*$scope.currentPage.scale/$scope.currentPage.scene.proportion;
                    h = $scope.currentPage.scene.geometry.height*$scope.currentPage.scale/$scope.currentPage.scene.proportion;
                }
                var _left = $scope.canvasCoordX(w);
                var _top = $scope.canvasCoordY(h);
                measureRuler.reDrawRuler({
                    unitSet:unitInit(_mult),//刻度尺单元长度    (非必须，默认是10)
                    mult:_mult,  //刻度值倍数，默认是最小刻度值为10px，如果定mult为3则最小刻度为30px (非必须，默认为1)
                    left:_left,
                    click:function (item) {
                        if (a !== null) {
                            clearTimeout(a)
                        }
                        a = setTimeout(function () {
                            var _item = item*$scope.currentPage.proportion/$scope.currentPage.scale;
                            if($scope.currentPage.isScene){
                                _item = item/$scope.currentPage.scale*$scope.currentPage.scene.proportion;
                            }
                            _item -= ($scope.currentPage.isScene?$scope.currentPage.scene.imagebox.geometry.x:0);
                            if(sublinesInfo(_item,'x')){
                                vm.sublinesX.push(_item);
                            }
                            $scope.$apply();
                        },200)
                    }
                });
                measureRuler2.reDrawRuler({
                    unitSet:unitInit(_mult),
                    mult:_mult,
                    top:_top,
                    yClick:function (item) {
                        if (a !== null) {
                            clearTimeout(a)
                        }
                        a = setTimeout(function () {
                            var _item = item*$scope.currentPage.proportion/$scope.currentPage.scale;
                            if($scope.currentPage.isScene){
                                _item = item/$scope.currentPage.scale*$scope.currentPage.scene.proportion;
                            }
                            _item -= ($scope.currentPage.isScene?$scope.currentPage.scene.imagebox.geometry.y:0);
                            if(sublinesInfo(_item,'y')){
                                vm.sublinesY.push(_item);
                            }
                            $scope.$apply();
                        },200)
                    }
                });
            }
        }

        //新增参考线
        $scope.addLineReference = function () {
            createModal('app/entities/page/modal/reference.html', 'ReferenceController').result.then(
                function (data) {
                    if(data){
                        if(data.direction == 'x' && sublinesInfo(data.place,'x')){
                            data.place -= ($scope.currentPage.isScene?$scope.currentPage.scene.imagebox.geometry.x:0);
                        }
                        if(data.direction == 'y'){
                            data.place -= ($scope.currentPage.isScene?$scope.currentPage.scene.imagebox.geometry.y:0);
                        }
                        if(data.direction == 'x' && sublinesInfo(data.place,'x')){
                            vm.sublinesX.push(data.place);
                        }
                        if(data.direction == 'y' && sublinesInfo(data.place,'y')){
                            vm.sublinesY.push(data.place);
                        }
                        vm.staff = true;
                    }
                })
        }

        function unitInit(_mult) {
            var _unitSet = 10;
            if(_mult>0.6){
                _unitSet = 10;
            }
            if(_mult<0.6){
                _unitSet = 30;
            }
            if(_mult<0.5){
                _unitSet = 30;
            }
            if(_mult<0.4){
                _unitSet = 50;
            }
            if(_mult<0.3){
                _unitSet = 80;
            }
            if(_mult<0.2){
                _unitSet = 100;
            }
            if(_mult<0.1){
                _unitSet = 200;
            }
            return _unitSet
        }
        //--------------------------------------------------日历标题--------------------------------------------
        vm.widgetTitleTab='SYSTEM';
        vm.widgetTitleList=[];
        vm.widgetTitlePage = 0;
        $scope.widgetTitleInit = function(item) {
            vm.widgetTitleTab=item;
            vm.widgetTitleList=[];
            vm.widgetTitlePage = 0;
            widgetTitleInit1();
        }
        $scope.widgetTitleNext = function () {
            vm.widgetTitlePage++;
            widgetTitleInit1();
        }
        function widgetTitleInit1() {
            if(vm.widgetTitleTab=='SYSTEM'){
                TitleWidget.byCondition2({
                    items:[{key:"enabled", op:"=", value:"true"},{key:"userId", op:"isNull",value:""},{key:"builtin", op:"=", value:"false"}],
                    page: vm.widgetTitlePage,
                    size: 20,
                    sort: ["id,desc"]
                }, function (res,headers) {
                    vm.widgetTitleCount = headers('X-Total-Count');
                    if(res){
                        res.forEach(function (item) {
                            vm.widgetTitleList.push(item)
                        })
                    }
                });
            }
            if(vm.widgetTitleTab=='USER'){
                TitleWidget.byCondition({
                    items:[{key:"enabled", op:"=", value:"true"},{key:"builtin", op:"=", value:"false"}],
                    page: vm.widgetTitlePage,
                    size: 20,
                    sort: ["id,desc"]
                }, function (res,headers) {
                    vm.widgetTitleCount = headers('X-Total-Count');
                    if(res){
                        res.forEach(function (item) {
                            vm.widgetTitleList.push(item)
                        })
                    }
                });
            }
        }
        $scope.widgetTitleAdd = function (e, item) {
            if(vm.textEditor){
                return
            }
            var currentPage = $scope.template.pages.page[$scope.template.pageI];
            var currentLevel = addLevel(currentPage);
            monthIndexSet(currentPage, function () {
                currentLevel.calTitleBox = getTitleWidget(currentLevel.seq,item,true,currentPage.trimbox.x,currentPage.trimbox.y).calTitleBox;
                currentLevel.calTitleBox.sampleYear = getDay('year',$scope.template.config.startYear,$scope.template.config.startMonth,currentPage.config.monthIndex);
                currentLevel.calTitleBox.sampleMonth = getDay('month',$scope.template.config.startYear,$scope.template.config.startMonth,currentPage.config.monthIndex);
                $scope.currentPage = currentPage;
                $scope.RightPanel = 'calTitleBox';
                $scope.selectBox = currentLevel.calTitleBox;
                $scope.template.transparency = 100;
                var index = $scope.currentPage.levels.level.length-1;
                $scope.selectCalTitleBox(e,index,$scope.currentPage.levels.level[index].calTitleBox);
                updateHistorys();
            })
        }
        $scope.selectCalTitleBox = function (e, $index, art) {
            if(vm.textEditor){
                return
            }
            fn(e);
            $scope.template.angle = art.rotation.angle;
            art.current = 'calTitleBox';
            vm.calTitleBoxLoading = true;

            if (vm.unit == 'mm') {
                $scope.pageValue.calTitleBox = {
                    width: PxTurnMm(art.geometry.width).toFixed(2) - 0,
                    height: PxTurnMm(art.geometry.height).toFixed(2) - 0,
                    x: PxTurnMm(art.geometry.x).toFixed(2) - 0,
                    y: PxTurnMm(art.geometry.y).toFixed(2) - 0
                }
            } else if (vm.unit == 'px') {
                $scope.pageValue.calTitleBox = {
                    width: art.geometry.width,
                    height: art.geometry.height,
                    x: art.geometry.x,
                    y: art.geometry.y
                }
            } else if (vm.unit == 'in') {
                $scope.pageValue.calTitleBox = {
                    width: PxTurnIn(art.geometry.width),
                    height: PxTurnIn(art.geometry.height),
                    x: PxTurnIn(art.geometry.x),
                    y: PxTurnIn(art.geometry.y)
                }
            }
            $scope.selectBox = art;
            //如果是按住ctrl键 实现多选复制
            if (e.ctrlKey == true || e.metaKey == true) {
                art.ctrlKey = true;
                art.levelI = $index;
                vm.CtrlKeyArray.calTitleBoxs[$index] = angular.copy(art);
                ctrlAddSingleArray();
            } else {
                if (!art.ctrlKey) {
                    $scope.clearCtrlKey();
                    vm.singleArray = {imagebox: {}, textbox: {}, imageart: {}, barcode: {}, qrcode: {}, calMonthBox: {}, calTitleBox: {}};
                }
                vm.singleArray.calTitleBox = angular.copy(art);
            }
            $scope.template.levelI = $index;
            // $scope.selPanel = 'calTitleBox';
            $scope.RightPanel = 'calTitleBox';
            e.stopPropagation();
            $timeout(function(){
                vm.calTitleBoxLoading = false;
            },100)
        };
        $scope.onSettingsChange = function (text) {
            if (text) {
                $scope.currentPage = null;
                $scope.lastPage = null;
                $scope.template.pages.page[$scope.template.pageI].levels.level[$scope.template.levelI].calTitleBox.settings = "";
                $scope.template.pages.page[$scope.template.pageI].update = true;
                $timeout(function() {
                    var data = JSON.parse(text);
                    $scope.template.pages.page[$scope.template.pageI].levels.level[$scope.template.levelI].calTitleBox.settings = data;
                    $scope.template.pages.page[$scope.template.pageI].update = false;
                    $scope.currentPage = $scope.template.pages.page[$scope.template.pageI];
                    $scope.lastPage = $scope.template.pages.page[$scope.template.pageI];
                    updateHistorys();
                });
            }
        }
        //--------------------------------------------------日历--------------------------------------------
        vm.widgetMonthTab='SYSTEM';
        vm.widgetMonthList=[];
        vm.widgetMonthPage = 0;
        $scope.widgetMonthInit = function(item) {
            vm.widgetMonthTab=item;
            vm.widgetMonthList=[];
            vm.widgetMonthPage = 0;
            widgetMonthInit1();
        }
        $scope.widgetMonthNext = function () {
            vm.widgetMonthPage++;
            widgetMonthInit1();
        }
        function widgetMonthInit1() {
            if(vm.widgetMonthTab=='SYSTEM'){
                MonthWidget.byCondition2({
                    items:[{key:"enabled", op:"=", value:"true"},{key:"userId", op:"isNull",value:""},{key:"builtin", op:"=", value:"false"}],
                    page: vm.widgetMonthPage,
                    size: 20,
                    sort: ["id,desc"]
                }, function (res,headers) {
                    vm.widgetMonthCount = headers('X-Total-Count');
                    if(res){
                        res.forEach(function (item) {
                            vm.widgetMonthList.push(item)
                        })
                    }
                });
            }
            if(vm.widgetMonthTab=='USER'){
                MonthWidget.byCondition({
                    items:[{key:"enabled", op:"=", value:"true"},{key:"builtin", op:"=", value:"false"}],
                    page: vm.widgetMonthPage,
                    size: 20,
                    sort: ["id,desc"]
                }, function (res,headers) {
                    vm.widgetMonthCount = headers('X-Total-Count');
                    if(res){
                        res.forEach(function (item) {
                            vm.widgetMonthList.push(item)
                        })
                    }
                });
            }
        }
        $scope.widgetMonthAdd = function (e, item) {
            if(vm.textEditor){
                return
            }
            var currentPage = $scope.template.pages.page[$scope.template.pageI];
            var currentLevel = addLevel(currentPage);
            monthIndexSet(currentPage, function () {
                currentLevel.calMonthBox = getMonthWidget(currentLevel.seq,item,true,currentPage.trimbox.x,currentPage.trimbox.y).calMonthBox;
                currentLevel.calMonthBox.sampleYear = getDay('year',$scope.template.config.startYear,$scope.template.config.startMonth,currentPage.config.monthIndex);
                currentLevel.calMonthBox.sampleMonth = getDay('month',$scope.template.config.startYear,$scope.template.config.startMonth,currentPage.config.monthIndex);
                $scope.currentPage = currentPage;
                $scope.RightPanel = 'calMonthBox';
                $scope.selectBox = currentLevel.calMonthBox;
                $scope.template.transparency = 100;
                var index = $scope.currentPage.levels.level.length-1;
                $scope.selectCalMonthBox(e,index,$scope.currentPage.levels.level[index].calMonthBox);
                updateHistorys();
            })
        }
        $scope.selectCalMonthBox = function (e, $index, art) {
            if(vm.textEditor){
                return
            }
            fn(e);
            $scope.template.angle = art.rotation.angle;
            art.current = 'calMonthBox';
            if (vm.unit == 'mm') {
                $scope.pageValue.calMonthBox = {
                    width: PxTurnMm(art.geometry.width).toFixed(2) - 0,
                    height: PxTurnMm(art.geometry.height).toFixed(2) - 0,
                    x: PxTurnMm(art.geometry.x).toFixed(2) - 0,
                    y: PxTurnMm(art.geometry.y).toFixed(2) - 0
                }
            } else if (vm.unit == 'px') {
                $scope.pageValue.calMonthBox = {
                    width: art.geometry.width,
                    height: art.geometry.height,
                    x: art.geometry.x,
                    y: art.geometry.y
                }
            } else if (vm.unit == 'in') {
                $scope.pageValue.calMonthBox = {
                    width: PxTurnIn(art.geometry.width),
                    height: PxTurnIn(art.geometry.height),
                    x: PxTurnIn(art.geometry.x),
                    y: PxTurnIn(art.geometry.y)
                }
            }
            $scope.selectBox = art;
            //如果是按住ctrl键 实现多选复制
            if (e.ctrlKey == true || e.metaKey == true) {
                art.ctrlKey = true;
                art.levelI = $index;
                vm.CtrlKeyArray.calMonthBoxs[$index] = angular.copy(art);
                ctrlAddSingleArray();
            } else {
                if (!art.ctrlKey) {
                    $scope.clearCtrlKey();
                    vm.singleArray = {imagebox: {}, textbox: {}, imageart: {}, barcode: {}, qrcode: {}, calMonthBox: {}, calTitleBox: {}};
                }
                vm.singleArray.calMonthBox = angular.copy(art);
            }
            $scope.template.levelI = $index;
            // $scope.selPanel = 'calMonthBox';
            $scope.RightPanel = 'calMonthBox';
            e.stopPropagation();
        };
        $scope.onMonthChange = function (text) {
            if (text) {
                $scope.currentPage.levels.level[$scope.template.levelI].calMonthBox = "";
                $scope.lastPage = null;
                $scope.template.pages.page[$scope.template.pageI].levels.level[$scope.template.levelI].calMonthBox = "";
                $scope.template.pages.page[$scope.template.pageI].update = true;
                $timeout(function() {
                    var data = JSON.parse(text);
                    $scope.template.pages.page[$scope.template.pageI].levels.level[$scope.template.levelI].calMonthBox = data;
                    $scope.template.pages.page[$scope.template.pageI].update = false;
                    $scope.currentPage = $scope.template.pages.page[$scope.template.pageI];
                    $scope.lastPage = $scope.template.pages.page[$scope.template.pageI];
                    $timeout(function () {
                        unit()
                    })
                    updateHistorys();
                });
                // $scope.currentPage.levels.level[$scope.template.levelI].calMonthBox = "";
                // $timeout(function() {
                //     var data = JSON.parse(text);
                //     $scope.currentPage.levels.level[$scope.template.levelI].calMonthBox = data;
                //     updateHistorys();
                // });
            }
        }
        var a = null;
        $scope.monthIndexUpdate = function () {
            vm.loadingImg = true;
            if($scope.currentPage) {
                $scope.currentPage.updateThumbnail = true;
            }
            if (a !== null) {
                clearTimeout(a)
            }
            a = setTimeout(function () {
                if($scope.currentPage){
                    if($scope.currentPage.config.monthIndex>24){
                        MessageService.error("最大不能超过24个月");
                        $scope.currentPage.config.monthIndex = 1;
                    }
                    if($scope.currentPage.levels && $scope.currentPage.levels.level){
                        $scope.currentPage.levels.level.forEach(function (level) {
                            if (level.calMonthBox && level.calMonthBox.geometry) {
                                var calMonthBox = level.calMonthBox;
                                calMonthBox.sampleYear = getDay('year',$scope.template.config.startYear,$scope.template.config.startMonth,$scope.currentPage.config.monthIndex);
                                calMonthBox.sampleMonth = getDay('month',$scope.template.config.startYear,$scope.template.config.startMonth,$scope.currentPage.config.monthIndex);
                                calMonthBox.obj=null;
                            }
                            if (level.calTitleBox && level.calTitleBox.geometry) {
                                var calTitleBox = level.calTitleBox;
                                calTitleBox.sampleYear = getDay('year',$scope.template.config.startYear,$scope.template.config.startMonth,$scope.currentPage.config.monthIndex);
                                calTitleBox.sampleMonth = getDay('month',$scope.template.config.startYear,$scope.template.config.startMonth,$scope.currentPage.config.monthIndex);
                            }
                        })
                    }
                    $timeout(function () {
                        vm.loadingImg = false;
                    },500)
                }
                $scope.$apply();
            },500)
        }
        $scope.$watch("currentPage", function (newValue, oldValue) {
            if($scope.currentPage && $scope.currentPage.config && $scope.currentPage.config.monthIndex == 0){
                $scope.currentPage.config.monthIndex = "";
            }
        },true)
        function monthIndexSet(page,callback) {
            if($scope.template.config.dynamic && !page.config.monthIndex){
                $uibModal.open({
                    templateUrl: 'app/entities/page/modal/month-index-set.html',
                    controller: 'MonthIndexSetController',
                    backdrop: 'static',
                    keyboard: true,
                    windowClass: "jh-modal-md",
                    controllerAs: 'vm',
                }).result.then(function (data) {
                    if (data) {
                        page.config.monthIndex = data;
                        callback()
                    }
                });
            }else{
                callback()
            }
        }
        $scope.pageNameCb = function () {
            vm.isPageName = true;
            vm.operation = true;
            $timeout(function () {
                $("#c-editor-head-name").focus();
            })
        }
        $scope.pageNameCb1 = function () {
            vm.isPageName1 = true;
            vm.operation = true;
            $timeout(function () {
                $("#c-editor-head-name1").focus();
            })
        }
        $scope.isSetMonth = function (page) {//判断是否设置月
            var _return = true;
            if(page && page.levels && page.levels.level){
                var isExist = false;
                page.levels.level.forEach(function (level) {
                    if((level.calMonthBox && level.calMonthBox.geometry) || (level.calTitleBox && level.calTitleBox.geometry)){
                        isExist = true;
                    }
                })
                if(isExist && !page.config.monthIndex){
                    _return = false;
                }
            }
            return _return
        }
        //参考线移动
        vm.lineReferenceIndex = 0;
        vm.lineReferenceType = null;
        vm.lineReferenceData = {};
        vm.isLineReference = false;
        $scope.moveLineReference = function (e, item, index, type) {
            if(vm.textEditor){
                return;
            }
            fn(e);
            vm.lineReferenceIndex = index;
            vm.lineReferenceType = type;
            vm.lineReferenceData.clientX = e.clientX || 0;
            vm.lineReferenceData.clientY = e.clientY || 0;
            if($scope.currentPage.isScene){
                vm.lineReferenceData.coordinates = item*$scope.currentPage.scale/$scope.currentPage.scene.proportion;
            }else{
                vm.lineReferenceData.coordinates = item/$scope.currentPage.proportion*$scope.currentPage.scale;
            }
            vm.isLineReference = true;
            document.addEventListener("mousemove", moveLineReferenceOn, true);
            document.addEventListener("mouseup", moveLineReferenceEnd, true);

        };
        //move 事件
        function moveLineReferenceOn(e) {
            fn(e);
            if (vm.isLineReference) {
                if(vm.lineReferenceType == 'x'){
                    var _item = (Number(vm.lineReferenceData.coordinates) + (e.clientX - vm.lineReferenceData.clientX));
                    if($scope.currentPage.isScene){
                        vm.sublinesX[vm.lineReferenceIndex] = _item/$scope.currentPage.scale*$scope.currentPage.scene.proportion;
                    }else{
                        vm.sublinesX[vm.lineReferenceIndex] = _item*$scope.currentPage.proportion/$scope.currentPage.scale;
                    }
                }
                if(vm.lineReferenceType == 'y'){
                    var _item = Number(vm.lineReferenceData.coordinates) + (e.clientY - vm.lineReferenceData.clientY);
                    if($scope.currentPage.isScene){
                        vm.sublinesY[vm.lineReferenceIndex] = _item/$scope.currentPage.scale*$scope.currentPage.scene.proportion;
                    }else{
                        vm.sublinesY[vm.lineReferenceIndex] = _item * $scope.currentPage.proportion/$scope.currentPage.scale;
                    }
                }
            }
            $scope.$apply();
        }
        //鼠标松开事件
        function moveLineReferenceEnd() {
            if(vm.lineReferenceType == 'x'){
                if(!sublinesInfo(vm.sublinesX[vm.lineReferenceIndex],'x')){
                    vm.sublinesX.splice(vm.lineReferenceIndex,1)
                }
            }
            if(vm.lineReferenceType == 'y'){
                if(!sublinesInfo(vm.sublinesY[vm.lineReferenceIndex],'y')){
                    vm.sublinesY.splice(vm.lineReferenceIndex,1)
                }
            }
            vm.lineReferenceIndex = 0;
            vm.lineReferenceType = null;
            vm.lineReferenceData = {};
            vm.isLineReference = false;
            document.removeEventListener("mousemove", moveLineReferenceOn, true);
            document.removeEventListener("mouseup", moveLineReferenceEnd, true);
            $scope.$apply();
        }
        function sublinesInfo(item, type) {
            var _isS = true;
            if(type == 'x'){
                if(item<0 || item>$scope.currentPage.mediabox.width){
                    _isS = false
                }
            }
            if(type == 'y'){
                if(item<0 || item>$scope.currentPage.mediabox.height){
                    _isS = false
                }
            }
            return _isS
        }

        //判断查看缩略图距离浏览器底部距离
        $scope.attributeViewBtn3 = function (e) {
            var _dom = $(".c-editor-attribute");
            if (_dom.scrollTop() + _dom.innerHeight() < _dom[0].scrollHeight) {
                return true
            } else {
                return false
            }
        }
        //一键清除当前页相框
        $scope.clearImageboxImg = function () {
            if ($scope.currentPage && $scope.currentPage.levels && $scope.currentPage.levels.level && $scope.currentPage.levels.level.length) {
                for (var i = $scope.currentPage.levels.level.length - 1; i >= 0; i--) {
                    var level = $scope.currentPage.levels.level[i];
                    if (level.imagebox && level.imagebox.geometry && level.imagebox.image) {
                        level.imagebox.image = null;
                        $scope.currentPage.updateThumbnail = true;
                    }
                }
                $timeout(function () {
                    updateHistorys();
                })
            }
        }
        //一键清除所有页相框
        $scope.clearAllImageboxImg = function () {
            MessageService.confirm({
                title:'温馨提示',
                cancel:'取消',
                confirm:'确认',
                msg:'是否清除所有相框里的图片？'
            },function(){
                $scope.template.pages.page.forEach(function (page) {
                    if (page && page.levels && page.levels.level && page.levels.level.length) {
                        for (var i = page.levels.level.length - 1; i >= 0; i--) {
                            var level = page.levels.level[i];
                            if (level.imagebox && level.imagebox.geometry && level.imagebox.image) {
                                level.imagebox.image = null;
                                page.updateThumbnail = true;
                            }
                        }
                    }
                })
                $timeout(function () {
                    updateHistorys();
                })
            })
        }
        //刀线设置
        vm.isOutline = false;
        $scope.setOutline = function(){
            vm.isOutline = true;
        }
        $scope.outlineChange = function(text){
            vm.isOutline = false;
            if(text){
                $scope.currentPage.outline = text.outline;
                $scope.template.pages.page.forEach(function(page){
                    if(page.config.partid === 'P1'){
                        if(text.outline && text.outline.mirrorCutline){
                            var outline = angular.copy(text.outline);
                            outline.cutline = outline.mirrorCutline;
                            page.outline = outline;
                        }else{
                            page.outline = null;
                        }
                    }
                })
            }
        }
    }

})();

(function () {
    'use strict';

    angular
        .module('platformApp')
        .controller('PageEditController', PageEditController);

    PageEditController.$inject = ['$scope', '$uibModalInstance', '$state', '$stateParams','pages', 'MessageService'];

    function PageEditController($scope, $uibModalInstance, $state, $stateParams, pages, MessageService) {

        var vm = this;

        vm.clear = clear;
        vm.save = save;
        $scope.isPageSize = 1;
        var originPage = angular.copy(pages.page);
        vm.page = pages.page;
        console.log(vm.page)
        var dpId = 0;
        if(pages.sizeSet=='bloodSize'){
            $scope.isPageSize = 2;
        }else if(pages.sizeSet=='editbox'){
            $scope.isPageSize = 0;
        }

        vm.dpiChoose = [{data: 'mm', id: 0}, {data: 'px', id: 1}, {data: '英寸', id: 2}];
        if(vm.page.pageSizeUnit == 'px'){
            dpId = 1;
        }
        vm.page.dpi = vm.dpiChoose[dpId];
        vm.page.dpi1 = vm.dpiChoose[dpId];
        console.log(vm.page)

        js_getDPI()
        function js_getDPI() {
            var arrDPI = new Array();
            if (window.screen.deviceXDPI != undefined) {
                arrDPI[0] = window.screen.deviceXDPI;
                arrDPI[1] = window.screen.deviceYDPI;
            }
            else {
                var tmpNode = document.createElement("DIV");
                tmpNode.style.cssText = "width:1in;height:1in;position:absolute;left:0px;top:0px;z-index:99;visibility:hidden";
                document.body.appendChild(tmpNode);
                arrDPI[0] = parseInt(tmpNode.offsetWidth);
                arrDPI[1] = parseInt(tmpNode.offsetHeight);
                tmpNode.parentNode.removeChild(tmpNode);
            }
            vm.windowDpiW = arrDPI[0];
            vm.windowDpiH = arrDPI[1];
            // vm.windowDpiW = 300;
            // vm.windowDpiH = 300;
            return arrDPI;
        }
        $scope.addPageEdit = function () {
            vm.page.editboxs.unshift({
                x:'',
                y:'',
                width:'',
                height:''
            })
        }
        $scope.removePageEdit = function(index){
            vm.page.editboxs.splice(index, 1);
        };
        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        $scope.customStoreChange = function () {
            if (vm.customStore == null) {
                vm.page.customStore = null;
            }
            for (var i = vm.stores.length - 1; i >= 0; i--) {
                var s = vm.stores[i];
                if (s.id == vm.customStore) {
                    vm.page.customStore = s;
                }
            }
        }

        $scope.updateDpi = function (data) {
            console.log(data)
            if(vm.page.dpi.id == 1){
                vm.page.pageSize = {
                    width: PxTurnMm(vm.page.pageSize.width),
                    height: PxTurnMm(vm.page.pageSize.height),
                }
                vm.page.pageBloodT = PxTurnMm(vm.page.pageBloodT);
                vm.page.pageBloodB = PxTurnMm(vm.page.pageBloodB);
                vm.page.pageBloodL = PxTurnMm(vm.page.pageBloodL);
                vm.page.pageBloodR = PxTurnMm(vm.page.pageBloodR);

                vm.page.editboxs.forEach(function (editbox, editboxIndex) {
                    vm.page.editboxs[editboxIndex] = {
                        width: PxTurnMm(editbox.width),
                        height: PxTurnMm(editbox.height),
                        x: PxTurnMm(editbox.x),
                        y: PxTurnMm(editbox.y),
                    }
                })
            }else if(vm.page.dpi.id == 2){
                vm.page.pageSize = {
                    width: InTurnMm(vm.page.pageSize.width),
                    height: InTurnMm(vm.page.pageSize.height),
                }
                vm.page.pageBloodT = InTurnMm(vm.page.pageBloodT);
                vm.page.pageBloodB = InTurnMm(vm.page.pageBloodB);
                vm.page.pageBloodL = InTurnMm(vm.page.pageBloodL);
                vm.page.pageBloodR = InTurnMm(vm.page.pageBloodR);

                vm.page.editboxs.forEach(function (editbox, editboxIndex) {
                    vm.page.editboxs[editboxIndex] = {
                        width: InTurnMm(editbox.width),
                        height: InTurnMm(editbox.height),
                        x: InTurnMm(editbox.x),
                        y: InTurnMm(editbox.y),
                    }
                })
            }
            if (data.id == 1) {
                vm.page.pageSize = {
                    width: MmTurnPx(vm.page.pageSize.width),
                    height: MmTurnPx(vm.page.pageSize.height),
                }
                vm.page.pageBloodT = MmTurnPx(vm.page.pageBloodT);
                vm.page.pageBloodB = MmTurnPx(vm.page.pageBloodB);
                vm.page.pageBloodL = MmTurnPx(vm.page.pageBloodL);
                vm.page.pageBloodR = MmTurnPx(vm.page.pageBloodR);

                vm.page.editboxs.forEach(function (editbox, editboxIndex) {
                    vm.page.editboxs[editboxIndex] = {
                        width: MmTurnPx(editbox.width),
                        height: MmTurnPx(editbox.height),
                        x: MmTurnPx(editbox.x),
                        y: MmTurnPx(editbox.y),
                    }
                })
            } else if(data.id == 2) {
                vm.page.pageSize = {
                    width: MmTurnIn(vm.page.pageSize.width),
                    height: MmTurnIn(vm.page.pageSize.height),
                }
                vm.page.pageBloodT = MmTurnIn(vm.page.pageBloodT);
                vm.page.pageBloodB = MmTurnIn(vm.page.pageBloodB);
                vm.page.pageBloodL = MmTurnIn(vm.page.pageBloodL);
                vm.page.pageBloodR = MmTurnIn(vm.page.pageBloodR);

                vm.page.editboxs.forEach(function (editbox, editboxIndex) {
                    vm.page.editboxs[editboxIndex] = {
                        width: MmTurnIn(editbox.width),
                        height: MmTurnIn(editbox.height),
                        x: MmTurnIn(editbox.x),
                        y: MmTurnIn(editbox.y),
                    }
                })
            }
            vm.page.dpi = data;

        }

        $scope.validate = function () {
            if($scope.isPageSize==0){
                for(var i=0; i<vm.page.editboxs.length; i++){
                    var _editbox = vm.page.editboxs[i];
                    if(_editbox.width === ""){
                        MessageService.error("请输入宽度");
                        return false
                    }
                    if(_editbox.height === ""){
                        MessageService.error("请输入高度");
                        return false
                    }
                    if(_editbox.x === ""){
                        MessageService.error("请输入X");
                        return false
                    }
                    if(_editbox.y === ""){
                        MessageService.error("请输入Y");
                        return false
                    }
                }
            }

            // if (vm.page.pageSize == null || vm.page.pageSize == "") {
            //     MessageService.error("请设置页面尺寸");
            //     return false;
            // }
            // if (vm.page.bloodSize == null || vm.page.bloodSize == "") {
            //     MessageService.error("请设置出血尺寸");
            //     return false;
            // }
            // if (vm.page.name == null || vm.page.name == "") {
            //     MessageService.error("请输入作品名称");
            //     return false;
            // }
            // if (vm.page.pageNum == null || vm.page.pageNum == "") {
            //     MessageService.error("请输入页数");
            //     return false;
            // }
            return true;
        };

        function save() {
            if (!$scope.validate()) {
                return;
            }
            onSaveSuccess(vm.page);
        }


        function onSaveSuccess(result) {
            console.log(result)
            MessageService.confirm({
                title:'提示',
                cancel:'取消',
                confirm:'确认',
                msg:'修改尺寸将会将会影响当前编辑内容，超出原画布尺寸的元素将会丢失，是否继续调整？'
            },function(){
                vm.isSaving = false;
                $scope.updateDpi(vm.dpiChoose[0]);
                $uibModalInstance.close(result);
            }, function () {
                vm.isSaving = false;
                $uibModalInstance.dismiss();
            });

        }

        function onSaveError() {
            vm.isSaving = false;
        }

    }

})();

(function () {
    'use strict';

    angular
        .module('platformApp')
        .controller('PageCreateController', PageCreateController);

    PageCreateController.$inject = ['$scope', '$uibModalInstance', '$state', 'MessageService', '$stateParams', 'ProductXml', 'items', 'Catalog','$timeout',
        'UidService','Qinius','$q'];

    function PageCreateController($scope, $uibModalInstance, $state, MessageService, $stateParams, ProductXml, items, Catalog, $timeout,
                                  UidService,Qinius,$q) {

        var vm = this;

        vm.clear = clear;
        vm.save = save;
        vm.domains = Qinius.getDomain();
        vm.tokens = Qinius.get();
        $q.all([vm.domains.$promise, vm.tokens.$promise]).then(function(){
            $scope.domain = vm.domains.domain;
            vm.token = vm.tokens.token;
        })

        vm.dpiChoose = [{data: 'mm', id: 0}, {data: 'px', id: 1}];
        $scope.dpi = vm.dpiChoose[0];
        vm.aid = $stateParams.id || $stateParams.copy;
        vm.catalogs = Catalog.getAll({items: [{key: "usable", op: "=", value: "true"}]});

        if (vm.aid) {
            ProductXml.get({id: vm.aid}, function (resp) {
                if (resp.document && resp.document.pages && resp.document.pages.page) {
                    var pages = resp.document.pages.page;
                    var page = pages[0];
                    vm.top = page.trimbox.y;
                    vm.bottom = page.mediabox.height - page.trimbox.height - page.trimbox.y;
                    vm.left = page.trimbox.x;
                    vm.right = page.mediabox.width - page.trimbox.width - page.trimbox.x;

                    vm.page = {
                        name: resp.name,
                        pageSize: {width: page.trimbox.width, height: page.trimbox.height},
                        editbox: {
                            width: page.editbox?page.editbox.width:(page.trimbox.width+vm.left+vm.right),
                            height: page.editbox?page.editbox.height:(page.trimbox.height+vm.top+vm.bottom),
                            x: page.editbox?page.editbox.x:0,
                            y: page.editbox?page.editbox.y:0
                        },
                        cover:resp.document.cover,
                        bloodSize: {top: vm.top, bottom: vm.bottom, left: vm.left, right: vm.right},
                        pageNum: pages.length,
                        dpi: $scope.dpi,
                        bindingType: resp.bindingType,
                        pattern: resp.pattern,
                        replace: resp.replace + "",
                        catalogId: resp.catalogId
                    };
                    console.log(vm.page);
                }
            })
        } else {
            if (items != null && items != "") {
                vm.page = {
                    name: items.name,
                    pageSize: {width: items.pageSizeW, height: items.pageSizeH},
                    bloodSize: {
                        top: items.pageBloodT,
                        bottom: items.pageBloodB,
                        left: items.pageBloodL,
                        right: items.pageBloodR
                    },
                    editbox: {
                        width: items.pageSizeW+items.pageBloodL+items.pageBloodR,
                        height: items.pageSizeH+items.pageBloodT+items.pageBloodB,
                        x: 0,
                        y: 0
                    },
                    pageNum: 1,
                    dpi: $scope.dpi,
                    bindingType: 'Left',
                    pattern: 'BOOK',
                    replace: "true",
                    catalogId: ""
                };
            } else {
                vm.page = {
                    name: '',
                    pageSize: {width: 420, height: 285},
                    editbox: {width: 426, height: 264, x: 0, y: 0},
                    bloodSize: {top: 3, bottom: 3, left: 3, right: 3},
                    pageNum: 1,
                    dpi: $scope.dpi,
                    bindingType: 'Left',
                    pattern: 'BOOK',
                    replace: "true",
                    catalogId: ""
                };
            }
        }

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        $scope.isGuanlian = false;
        $scope.guanlian = function (attr) {
            if (!attr) {
                $scope.scale = vm.page.pageSize.width / vm.page.pageSize.height;
            }

            $scope.isGuanlian = !$scope.isGuanlian;
        }
        $scope.updateTemplateHeightAndWidth = function (attr) {
            if ($scope.isGuanlian) {
                if (attr) {
                    vm.page.pageSize.width = Math.floor(vm.page.pageSize.height * $scope.scale)
                } else {
                    vm.page.pageSize.height = Math.floor(vm.page.pageSize.width / $scope.scale)
                }
            }
        };

        $scope.updateDpi = function (data) {

            vm.page.dpi = data;

            if (data.id == 1) {
                var wah = ThreeHundredDpi(vm.page.pageSize.width, vm.page.pageSize.height);
                vm.page.pageSize = {
                    width: wah.px1,
                    height: wah.px2,
                }
                var tab = ThreeHundredDpi(vm.page.bloodSize.top, vm.page.bloodSize.bottom);
                var lar = ThreeHundredDpi(vm.page.bloodSize.left, vm.page.bloodSize.right);
                vm.page.bloodSize = {
                    top: tab.px1,
                    bottom: tab.px2,
                    left: lar.px1,
                    right: lar.px2,
                }
                var editWah = ThreeHundredDpi(vm.page.editbox.width, vm.page.editbox.height);
                var editXay = ThreeHundredDpi(vm.page.editbox.x, vm.page.editbox.y);
                vm.page.editbox = {
                    width: editWah.px1,
                    height: editWah.px2,
                    x: editXay.px1,
                    y: editXay.px2,
                }
            } else {
                var wah = ThreeHundredDpiToMm(vm.page.pageSize.width, vm.page.pageSize.height);
                vm.page.pageSize = {
                    width: wah.mm1,
                    height: wah.mm2,
                }
                var tab = ThreeHundredDpiToMm(vm.page.bloodSize.top, vm.page.bloodSize.bottom);
                var lar = ThreeHundredDpiToMm(vm.page.bloodSize.left, vm.page.bloodSize.right);
                vm.page.bloodSize = {
                    top: tab.mm1,
                    bottom: tab.mm2,
                    left: lar.mm1,
                    right: lar.mm2,
                }

                var editWah = ThreeHundredDpiToMm(vm.page.editbox.width, vm.page.editbox.height);
                var editXay = ThreeHundredDpiToMm(vm.page.editbox.x, vm.page.editbox.y);
                vm.page.editbox = {
                    width: editWah.mm1,
                    height: editWah.mm2,
                    x: editXay.mm1,
                    y: editXay.mm2,
                }

            }


        }

        // mm---px
        function ThreeHundredDpi(attr1, attr2) {
            // Math.floor(px / 300 * 25.4)   (px--mm)
            // Math.ceil(mm / 25.4 * 300)   (mm---px)
            var px1 = parseFloat((attr1 / 25.4 * 300 - 0)).toFixed(2) - 0;
            var px2 = parseFloat((attr2 / 25.4 * 300 - 0)).toFixed(2) - 0;
            return {
                px1: px1,
                px2: px2
            }
        }

        // px---mm
        function ThreeHundredDpiToMm(attr1, attr2) {
            var mm1 = parseFloat((attr1 / 300 * 25.4 - 0)).toFixed(2) - 0;
            var mm2 = parseFloat((attr2 / 300 * 25.4 - 0)).toFixed(2) - 0;
            return {
                mm1: mm1,
                mm2: mm2
            }
        }

        $scope.validate = function () {
            if (vm.page.pageSize == null || vm.page.pageSize == "" || vm.page.pageSize.width == null || vm.page.pageSize.width == "" || vm.page.pageSize.height == null || vm.page.pageSize.height == "") {
                MessageService.error("请设置页面尺寸");
                return false;
            }
            if (vm.page.dpi == 1) {
                var wah = ThreeHundredDpi(10, 10);
                if (vm.page.pageSize.width < wah.px1 || vm.page.pageSize.height < wah.px2) {
                    MessageService.error("请设置页面尺寸");
                    return false;
                }
            } else {
                if (vm.page.pageSize.width < 0 || vm.page.pageSize.height < 0) {
                    MessageService.error("页面尺寸太小，建议修改画布尺寸为10以上");
                    return false;
                }
            }

            if (vm.page.bloodSize == null || vm.page.bloodSize == "") {
                MessageService.error("请设置出血尺寸");
                return false;
            }

            if (vm.page.editbox == null || vm.page.editbox == "") {
                MessageService.error("请设置可编辑区域");
                return false;
            }
            if (vm.page.name == null || vm.page.name == "") {
                MessageService.error("请输入作品名称");
                return false;
            }
            if (vm.page.pageNum == null || vm.page.pageNum == "") {
                MessageService.error("请输入页数");
                return false;
            }
            return true;
        };

        function save() {
            if (!$scope.validate()) {
                return;
            }
            onSaveSuccess(vm.page);
        }


        function onSaveSuccess(result) {
            $uibModalInstance.close(result);
            console.log(result)
            vm.isSaving = false;
            var pageStorageName = 'page-new';
            if ($stateParams.id) {
                pageStorageName = 'page-' + $stateParams.id;
                localStorage.setItem(pageStorageName, JSON.stringify(result));
                $state.go('page-my-suffix-edit', {id: $stateParams.id}, {reload: true})
                // var url = window.location.href.slice(0, -window.location.hash.length) + '#/page-my-suffix/' + $stateParams.id;
                // window.location.href = url
                // console.log(window.location.href);
            } else if ($stateParams.copy) {
                pageStorageName = 'page-' + $stateParams.copy + "-copy";
                localStorage.setItem(pageStorageName, JSON.stringify(result));
                $state.go('page-my-suffix-copy', {copy: $stateParams.copy}, {reload: true})
            } else {
                localStorage.setItem(pageStorageName, JSON.stringify(result));
                $state.go('page-my-suffix', {reload: true});
            }

        }

        function onSaveError() {
            vm.isSaving = false;
        }

        $scope.removeFile = function () {
            vm.page.cover = {};
        };

        vm.detailImgs = [];
        window.updateImgFile = function ($event) {
            $timeout(function () {
                var file = $event.target.files[0];
                var getBase64 = function (file, callback) {
                    var reader = new FileReader(); //用来把文件读入内存，并且读取文件中的数据
                    reader.readAsDataURL(file); //将文件读取为DataURL,存在result中
                    reader.onload = function () { //  成功读取
                        $('.sweet-alert .confirm').trigger("click"); //trigger触发被选元素的指定事件类型
                    };
                    reader.onerror = function (error) { //  出错
                    };
                };
                getBase64(file, function (result) {
                });
                var formData = new FormData();
                formData.append('file', file);
                formData.append('unique_names', false);
                formData.append('key', 'cover-' + UidService.get());
                formData.append('token', vm.token);
                $("#file").val("");
                $.ajax({
                    cache: true,
                    type: "POST",
                    url: 'https://upload.qiniup.com/',
                    data: formData,
                    async: false,
                    contentType: false,
                    processData: false,
                    success: function (data) {
                        vm.page.cover = {
                            identifier:data.key,
                            provider:'qiniu'
                        };
                        var flag = true;        //是否可以添加
                        if (vm.detailImgs.length > 0 && vm.detailImgs.length < 5) {
                            for (var i = vm.detailImgs.length - 1; i >= 0; i--) {
                                if (vm.detailImgs[i] == data.key) {
                                    // 不建议上传相同的图片，没有意义
                                    flag = false;
                                }
                            }
                        }
                        if (vm.detailImgs.length + 1 > 4) {
                            MessageService.error("最多上传四张附件");
                            return;
                        }
                        if (flag) {
                            vm.detailImgs.push(data.key);
                        }
                    },
                    error: function (request) {
                        MessageService.error("文件上传失败");
                    }
                });
            });
        };
    }

})();

(function () {
    'use strict';

    angular
        .module('platformApp')
        .controller('PageAddLabelController', PageAddLabelController);

    PageAddLabelController.$inject = ['$scope', '$uibModalInstance', '$state', '$stateParams','pages', 'MessageService'];

    function PageAddLabelController($scope, $uibModalInstance, $state, $stateParams, pages, MessageService) {

        var vm = this;

        vm.clear = clear;
        vm.save = save;
        vm.label = ''


        function clear() {
            $uibModalInstance.dismiss('cancel');
        }


        $scope.validate = function () {
            if (vm.label == null || vm.label == "") {
                MessageService.error("请输入主题分类");
                return false;
            }
            return true;
        };

        function save() {
            if (!$scope.validate()) {
                return;
            }
            onSaveSuccess(vm.label);
        }


        function onSaveSuccess(result) {
            $uibModalInstance.close(result);
        }

        function onSaveError() {
            vm.isSaving = false;
        }

    }

})();

(function () {
    'use strict';

    angular
        .module('platformApp')
        .controller('PageController', PageController);

    PageController.$inject = ['$state', '$scope', '$timeout', '$uibModal', '$http', 'Qinius','$q', 'pagingParams', 'paginationConstants', '$stateParams','ProductTemplate',
        "ProductXml", "Catalog", "UidService",'MessageService','$localStorage'];

    function PageController($state, $scope, $timeout, $uibModal, $http, Qinius,$q, pagingParams, paginationConstants, $stateParams,ProductTemplate,
                            ProductXml, Catalog, UidService,MessageService,$localStorage) {

        var vm = this;
        $(".navbar").show();
        $(".wrap").css({margin: '40px 0 10px 254px'});
        vm.domain = Qinius.getDomain();
        vm.hotxmls = ProductXml.byCondition2({items:[{key:"hotspot", op:"=", value:"true"},{key:"status", op:"=", value:"Approved"}],size:12});
        vm.latexmls = ProductXml.byCondition({sort: ["createdDate,desc"],size:12});
        $q.all([vm.domain.$promise, vm.hotxmls.$promise, vm.latexmls.$promise]).then(function(){
            vm.domainQ  =vm.domain.domain;
            timeoutInit();
            $timeout(function () {
                new Swiper('.c-page-5-swiper', {
                    slidesPerView: 6,
                    spaceBetween: 30,
                    slidesPerGroup: 6,
                    navigation: {
                        nextEl: '.c-page-5-swiper-next',
                        prevEl: '.c-page-5-swiper-prev',
                    },
                });
                new Swiper('.c-page-6-swiper', {
                    slidesPerView: 6,
                    spaceBetween: 30,
                    slidesPerGroup: 6,
                    navigation: {
                        nextEl: '.c-page-6-swiper-next',
                        prevEl: '.c-page-6-swiper-prev',
                    },
                });
            })
        });
        showUpgradeDialog();
        //新版UI升级提示弹窗
        function showUpgradeDialog() {
            var userInfo = $localStorage.user;
            if(userInfo.upgrade) return;
            $uibModal
                .open({
                    templateUrl: "app/entities/page/modal/upgrade-prompt.html",
                    controller: "UpgradePromptController",
                    controllerAs: "vm",
                    backdrop: "static",
                    size: "lg",
                    resolve: {}
                })
                .result.then(function () {});
        }
        $scope.gotoCreate = function (item, custom, productType) {
            console.log(item)
            // return
            if(custom){
                createModal('app/entities/page/modal/template-add.html', 'TemplateAddController',item, custom,productType).result.then(
                    function (data) {
                    });
            }else {
                if(item.version == 1){
                    MessageService.error("当前模板暂不能使用，请联系运营人员")
                    // MessageService.confirm({
                    //     title:'提示',
                    //     cancel:'取消',
                    //     confirm:'确认',
                    //     msg:'系统全面更新，模板需升级方可使用，确认升级?'
                    // },function(){
                    //     createModal('app/entities/page/modal/template-upgrade.html', 'TemplateUpgradeController',item, custom).result.then(
                    //         function (data) {
                    //             if(data){
                    //                 loadAll();
                    //                 saveTemplate(data)
                    //             }
                    //         });
                    // })
                }else{
                    saveTemplate(item)
                }
            }
        };
        function saveTemplate(data) {
            if(vm.isSaving){
                return
            }
            vm.isSaving = true;
            $scope.template = {
                "addpage":false,
                "addunit":0,
                "maxpage":0,
                "minpage":0,
                "replace":"",
                "cover":"",
                backupPages:{
                    list:[]
                },
                config:{
                    innerOffset:0,
                    parts:{
                        list:[]
                    },
                    productType:''
                },
                deletedPages:{
                    page:[]
                },
                "frameConfigs":{
                    "frameConfig":[]
                },
                pages: {
                    page: []
                },
                "version":"4.0",
                transparency: 1,
                scene: null,
                pageI: 0,
                angle: 0,
                backup: false,
                spread: false,
                unreplace: false,
                letterspacing: 0,
                lineheight: 0,
                text: '',
                bgimgs: {bgimg: []},
                bgimgs2: {bgimg: []},
                masks: {mask: []},
                cliparts: {clipart: []},
                documentpics: {documentpic: []},
                showPic: false,
                psdFiles: {psdFile: []}
            };
            var _seq = 0;
            data.parts.sort(compare('seq', true));
            data.parts.forEach(function (part,index) {
                var editboxes = {
                    editbox:[{
                        height: part.pageEditH,
                        width: part.pageEditW,
                        x: part.pageEditX,
                        y: part.pageEditY
                    }]
                };
                $scope.template.config.parts.list.push({
                    "bleed":{
                        "bottom":part.pageBloodB,
                        "left":part.pageBloodL,
                        "right":part.pageBloodR,
                        "top":part.pageBloodT
                    },
                    "editboxes":editboxes,
                    "mediabox":{
                        height: part.pageSizeH,
                        width: part.pageSizeW,
                    },
                    "counter":part.pageCount,
                    "id":part.code,
                    "name":part.name,
                    "required":(part.code == 'P' || part.code == 'P0') ? true : false,
                    "seq":index,
                    "spread":part.spread
                })
                var _page = createPage(data, part, editboxes);
                for(var i=0;i<part.pageCount; i++){
                    _page.uuid = UidService.get();
                    _page.seq = _seq;
                    if(data.type == 'BOOK'){
                        $scope.template.pages.page.push(angular.copy(_page));
                        _seq++
                    }
                    if(data.type == 'PHOTO'){
                        $scope.template.pages.page.push(angular.copy(_page));
                        _seq++
                    }
                    if(data.type == 'CALENDAR'){
                        $scope.template.pages.page.push(angular.copy(_page));
                        _seq++
                    }
                    if(data.type == 'THING'){
                        $scope.template.pages.page.push(angular.copy(_page));
                        _seq++;
                    }
                }
            })
            vm.hashtags = '';
            if(data.catalog.hashtags){
                for (var i = 0; i < data.catalog.hashtags.length; i++) {
                    vm.hashtags += data.catalog.hashtags[i].name + ','
                }
            }
            $scope.template.config.innerOffset = data.innerOffset;
            $scope.template.config.productType = data.type;
            $scope.template.config.dynamic = data.dynamic;
            if($scope.template.config.dynamic){
                $scope.template.config.startYear = (data.month.split("-"))[0];
                $scope.template.config.startMonth = (data.month.split("-"))[1];
            }
            $scope.template.cover = data.cover;
            $scope.template.replace = data.replace;
            $scope.template.addpage = data.addpage;
            $scope.template.minpage = data.minpage;
            $scope.template.maxpage = data.maxpage;
            $scope.template.addunit = data.addunit;
            ProductXml.save({
                document: $scope.template,
                replace: data.replace,
                name: data.name,
                catalogId: data.catalog.id,
                catalogName: data.catalog.name,
                version: '4.0',
                type: 'XML',
                productTemplateId: data.id,
                hashtags: vm.hashtags,
                modelBlendent: data.modelBlendent,
                modelData: data.modelData,
                modelPath: data.modelPath,
                modelType: data.modelType,
                productType: data.type
            }, function (res) {
                vm.isSaving = false;
                $state.go('page-my-suffix-edit', {id: res.id}, {reload: true})
            }, function () {
                vm.isSaving = false;
            });
        }
        function createPage(data, part, editboxes) {
            var _page = {
                config:{
                    "dynamic":(data.dynamic ? true : false),
                    "monthIndex":0,
                    "monthMultiple":false,
                    "partid":part.code
                },
                isScene: false,
                bgImg: '',
                background: {resource: {},color:'#ffffff', type: "Color"},
                pagecover: {},
                levels: {},
                barcode: {},
                qrcode: {},
                editbox: editboxes.editbox[0],
                editboxes: editboxes,
                mediabox: {
                    height: part.pageSizeH,
                    width: part.pageSizeW,
                },
                trimbox: {
                    height: part.pageSizeH - Number(part.pageBloodB) - Number(part.pageBloodT),
                    width: part.pageSizeW - Number(part.pageBloodL) - Number(part.pageBloodR),
                    x: part.pageBloodL,
                    y: part.pageBloodT
                },
                scale: 1,
                proportion: 1,
                seq: 0,
                spread: part.spread,
                backup: false,
                unreplace: !data.replace
            }
            if (part.mould) {
                if(part.mould.modelType == 'TWO' || part.mould.modelType == 'NONE'){
                    part.mould.modelType = 'TWO';
                    _page.scene = {
                        background: {
                            resource: {
                                identifier: part.mould.modelPic.indexOf('http') > -1 ? part.mould.modelPic : vm.domainQ + part.mould.modelPic,
                                provider: "qiniu"
                            }
                        },
                        geometry: {
                            width: part.mould.gWidth,
                            height: part.mould.gHeight,
                            x: 0,
                            y: 0
                        },
                        imagebox: {
                            geometry: {
                                width: part.mould.width,
                                height: part.mould.height,
                                x: part.mould.x,
                                y: part.mould.y
                            },
                            rotation: {angle: 0},
                            transparency: 1,
                        },
                        hierarchy: part.mould.hierarchy,
                        mouldid: part.mould.id,
                        isScene: true,
                        scale: 1,
                        unit: "mm",
                        resource:{
                            identifier: part.mould.modelPic.indexOf('http') > -1 ? part.mould.modelPic : vm.domainQ + part.mould.modelPic,
                            provider: "qiniu"
                        }
                    }
                }
            }
            return _page;
        }
        $scope.gotoCreate1 = function (item, custom) {
            if(custom){
                $uibModal.open({
                    templateUrl: 'app/entities/page/modal/template-modal.html',
                    controller: 'TemplateModalController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    resolve: {
                        entity: [function() {
                            return {
                                type: 'add',
                                data: ''
                            };
                        }]
                    }
                }).result.then(function(data) {
                    if(data){}
                });
            }else {
                var _item = item;
                for(var j=_item.pageTemplates.length-1; j>=0; j--){
                    if(!_item.pageTemplates[j].pageEdits){
                        _item.pageTemplates[j].pageEdits=[{
                            pageEditX:parseInt(_item.pageTemplates[j].pageEditX),
                            pageEditY:parseInt(_item.pageTemplates[j].pageEditY),
                            pageEditW:parseInt(_item.pageTemplates[j].pageEditW),
                            pageEditH:parseInt(_item.pageTemplates[j].pageEditH),
                        }]
                    }
                    if(_item.pageTemplates[j].cancelled){
                        _item.pageTemplates.splice(j, 1)
                    }
                }

                _item.pageSizeH=parseInt(_item.pageSizeH)-0;
                _item.pageSizeW=parseInt(_item.pageSizeW)-0;
                _item.pageBloodT=parseInt(_item.pageBloodT)-0;
                _item.pageBloodB=parseInt(_item.pageBloodB)-0;
                _item.pageBloodL=parseInt(_item.pageBloodL)-0;
                _item.pageBloodR=parseInt(_item.pageBloodR)-0;
                _item.pageEdits=parseInt(_item.pageEdits)-0;
                if(!_item.pageEdits){
                    _item.pageEdits=[{
                        pageEditX:parseInt(_item.pageEditX),
                        pageEditY:parseInt(_item.pageEditY),
                        pageEditW:parseInt(_item.pageEditW),
                        pageEditH:parseInt(_item.pageEditH),
                    }]
                }
                _item.custom = vm.type;
                localStorage.setItem('page-new', JSON.stringify(_item));
                $state.go('page-my-suffix', {reload: true});
            }
        };

        $scope.productType = function(item) {
            switch (item) {
                case 'BOOK':
                    return ' (照片书)';
                case 'PHOTO':
                    return ' (冲印)';
                case 'CALENDAR':
                    return ' (台历)';
                case 'THING':
                    return ' (万物)';
                default:
                    return ''
            }
        }
        var createModal = function (url, controller,item, custom,productType) {
            return $uibModal.open({
                templateUrl: url,
                controller: controller,
                backdrop: 'static',
                keyboard: true,
                windowClass: "jh-modal-md",
                controllerAs: 'vm',
                size: 'lg',
                resolve: {
                    items: function(){
                        return {
                            type: 'add',
                            data: item,
                            custom: custom,
                            productType:productType
                        }
                    },
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page)
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('page');
                        return $translate.refresh();
                    }]
                }
            });
        };


        //    分类显示
        vm.userDefinedPage = 1;
        vm.userDefinedSize = paginationConstants.itemsPerPage;
        vm.search = search;
        vm.jump = jump;
        vm.pageCb = pageCb;
        vm.clear = clear;
        function jump () {
            vm.userDefinedPage = vm.jumpText<=0?1:vm.jumpText;
            loadAll();
        }
        function pageCb() {
            loadAll();
        }
        function clear() {
            vm.searchQuery = "";
            loadAll();
        }
        function loadAll () {
            var items = [{key: "status", op: "=", value: true},{key: "cancelled", op: "=", value: "false"}];
            if(vm.searchQuery){
                items.push({key: "name", op: "like", value: vm.searchQuery})
            }
            items.push({key: "catalog.id", op: "=", value: vm.catalogView.id})
            ProductTemplate.byCondition({
                items:items,
                page:vm.userDefinedPage-1,
                size: 12,
                sort: ["id,desc"]
            }, function (data, headers) {
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.userDefined = data;
                swiper()
            })
        }
        function swiper() {
            $timeout(function () {
                new Swiper('.c-page-4-swiper', {
                    slidesPerView: 6,
                    spaceBetween: 30,
                    slidesPerGroup: 6,
                    navigation: {
                        nextEl: '.c-page-4-swiper-next',
                        prevEl: '.c-page-4-swiper-prev',
                    }
                });
            })
        }
        vm.catalogView = "";

        function timeoutInit(){
            Catalog.quickLinks({}, function (res) {
                vm.kingKong = res || [];
            });
            Catalog.getAll3({items: [{key: "usable", op: "=", value: "true"}],sort: ["id,desc"]}, function (res) {
                vm.catalogs = [];
                res.forEach(function(item,index){
                    if (index <= 5) {
                        vm.catalogs.push(item)
                    }
                })
                loadAll();
            });
        }
        $scope.catalogCb = function (item) {
            if(item == "all"){
                vm.catalogView = "";
            }else {
                vm.catalogView = item;
            }
            vm.userDefinedPage = 1;
            loadAll();
        }


        function search(){
            loadAll();
        }
        $scope.operateLi = function (tempItem) {
            tempVersion(tempItem,function (temp) {
                $state.go('page-my-suffix-edit', {id: temp.id}, {reload: true})
            })
        };

        function tempVersion(temp,callback){
            if(temp.version != '4.0'){
                MessageService.confirm({
                    title:'提示',
                    cancel:'取消',
                    confirm:'确认',
                    msg:'系统全面更新，模板需升级方可使用，确认升级?',
                    isThemecolor:true
                },function(){
                    $uibModal.open({
                        templateUrl: 'app/entities/page/modal/template-upgrade.html',
                        controller: 'TemplateUpgradeController',
                        backdrop: 'static',
                        keyboard: true,
                        windowClass: "jh-modal-md",
                        controllerAs: 'vm',
                        size:'lg',
                        resolve: {
                            entity: function(){
                                return temp
                            },
                            pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                                return {
                                    page: PaginationUtil.parsePage($stateParams.page)
                                };
                            }],
                            translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                                $translatePartialLoader.addPart('page');
                                return $translate.refresh();
                            }]
                        }
                    }).result.then(
                        function (data) {
                            if(data){
                                ProductXml.get({id: temp.id}, function (res) {
                                    callback(res)
                                })
                            }
                        })
                })
            }else{
                callback(temp)
            }
        }
    }

})();

window.angular.module('modules.service', []).factory('ModulesService', ['FontManagement', 'MessageService', '$timeout', '$rootScope', '$state', '$uibModal', '$stateParams',
    function (FontManagement, MessageService, $timeout, $rootScope, $state, $uibModal, $stateParams) {

        var vm = this;

        this.sorts = function (predicate, reverse) {
            // return ["createdDate,desc"];
            return [predicate + ',' + (reverse ? 'asc' : 'desc')];
        }

        this.fn = function (e) {
            // e = e || window.event;
            // e.cancelBubble = true;
            // e.stopPropagation();
            // e.returnValue = false;
            // e.preventDefault();
            if (e && e.stopPropagation) {
                // 因此它支持W3C的stopPropagation()方法
                e.stopPropagation();
            } else {
                // 否则，我们需要使用IE的方式来取消事件冒泡
                window.event.cancelBubble = true;
            }

            // 阻止默认浏览器动作(W3C)
            if (e && e.preventDefault) {
                e.preventDefault();
            } else {
                // IE中阻止函数器默认动作的方式
                window.event.returnValue = false;
            }
        }

        // 得到浏览器dpi
        this.getDPI = function () {
            var arrDPI = new Array();
            if (window.screen.deviceXDPI != undefined) {
                arrDPI[0] = window.screen.deviceXDPI;
                arrDPI[1] = window.screen.deviceYDPI;
            } else {
                var tmpNode = document.createElement("DIV");
                tmpNode.style.cssText = "width:1in;height:1in;position:absolute;left:0px;top:0px;z-index:99;visibility:hidden";
                document.body.appendChild(tmpNode);
                arrDPI[0] = parseInt(tmpNode.offsetWidth);
                arrDPI[1] = parseInt(tmpNode.offsetHeight);
                tmpNode.parentNode.removeChild(tmpNode);
            }
            // vm.windowDpiW = 300;
            // vm.windowDpiH = 300;
            return arrDPI;
        }

        // 判断是哪个浏览器
        this.myBrowser = function () {
            var userAgent = navigator.userAgent; //取得浏览器的userAgent字符串
            var isOpera = userAgent.indexOf("Opera") > -1;
            if (isOpera) {
                return "Opera"
            }
            ; //判断是否Opera浏览器
            if (userAgent.indexOf("Firefox") > -1) {
                return "FF";
            } //判断是否Firefox浏览器
            if (userAgent.indexOf("Chrome") > -1) {
                return "Chrome";
            }
            if (userAgent.indexOf("Safari") > -1) {
                return "Safari";
            } //判断是否Safari浏览器
            if (userAgent.indexOf("compatible") > -1 && userAgent.indexOf("MSIE") > -1 && !isOpera) {
                return "IE";
            }
            ; //判断是否IE浏览器
        }

        // 全屏
        this.toggleFullScreen = function (attr) {
            if (!attr) {
                //进入全屏
                var de = document.documentElement;
                if (de.requestFullscreen) {
                    de.requestFullscreen();
                } else if (de.mozRequestFullScreen) {
                    de.mozRequestFullScreen();
                } else if (de.webkitRequestFullScreen) {
                    de.webkitRequestFullScreen();
                }
                return true
            } else {
                //退出全屏
                var de = document;
                if (de.exitFullscreen) {
                    de.exitFullscreen();
                } else if (de.mozCancelFullScreen) {
                    de.mozCancelFullScreen();
                } else if (de.webkitCancelFullScreen) {
                    de.webkitCancelFullScreen();
                }
                return false
            }
        }

        // 旋转角度
        this.getAngle = function (px, py, mx, my) {//获得人物中心和鼠标坐标连线，与y轴正半轴之间的夹角
            var x = Math.abs(px - mx);
            var y = Math.abs(py - my);
            var z = Math.sqrt(Math.pow(x, 2) + Math.pow(y, 2));
            var cos = y / z;
            var radina = Math.acos(cos);//用反三角函数求弧度
            var angle = Math.floor(180 / (Math.PI / radina));//将弧度转换成角度
            if (mx < px && my > py) {//鼠标在第三象限
                angle = angle;
            }
            if (mx < px && my < py) {
                angle = 180 - angle;
            }
            if (mx > px && my < py) {
                angle = 180 + angle;
            }
            if (mx > px && my > py) {
                angle = 360 - angle;
            }
            return angle;

        }

        // 进度条
        this.rangeValue = function (elem) {
            return elem.value
        }

        // mm换算成px
        this.unitTransform = function (mm) {
            // mm换算成px  Math.ceil(mm / 25.4 * 300);
            // return (mm * 3) - 0;
            var dpi = this.getDPI();
            return mm / 25.4 * dpi[0];
        }

        // px换算成mm
        this.unitTransformPx = function (px) {
            // px换算成mm  Math.floor(px / 300 * 25.4)
            // return (px * 1 / 3).toFixed(2) - 0;
            var dpi = this.getDPI();
            return px / dpi[0] * 25.4;
        }

        this.getGeometryToPx = function (obj) {
            return {
                height: this.unitTransform(obj.height),
                width: this.unitTransform(obj.width),
                x: this.unitTransform(obj.x),
                y: this.unitTransform(obj.y)
            }
        }

        // px---mm
        this.threeHundredDpiToMm = function (attr1, attr2) {
            var dpi = this.getDPI();
            var mm1 = parseFloat((attr1 / dpi[0] * 25.4 - 0)).toFixed(2) - 0;
            var mm2 = parseFloat((attr2 / dpi[0] * 25.4 - 0)).toFixed(2) - 0;
            return {
                mm1: mm1,
                mm2: mm2
            }
        }

        this.splitFileName = function (text) {
            var pattern = /\.{1}[a-z]{1,}$/;
            if (pattern.exec(text) !== null) {
                return (text.slice(0, pattern.exec(text).index));
            } else {
                return text;
            }
        }

        this.compare = function (property) {
            return function (a, b) {
                var value1 = a[property];
                var value2 = b[property];
                return value1 - value2;
            }
        }

        return this;

    }]);

(function() {
    'use strict';

    angular
        .module('platformApp')
        .controller('WidgetSelectController', WidgetSelectController);

    WidgetSelectController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'items', '$state', 'MessageService', 'Catalog','Qinius', '$q', 'UidService',
        '$uibModal','TitleWidget','MonthWidget','ProductXml'];

    function WidgetSelectController ($timeout, $scope, $stateParams, $uibModalInstance, items, $state, MessageService, Catalog,Qinius, $q, UidService,
                                    $uibModal,TitleWidget,MonthWidget,ProductXml) {
        var vm = this;

        vm.type = items.type;
        vm.list = [];
        vm.selected = null;
        vm.searchQuery = "";
        vm.getTitle = function (){
            if(vm.type === "titleWidget"){
                return "选择标题组件";
            }
            if(vm.type === "monthWidget"){
                return "选择布局组件";
            }
            return '';
        }
        getSelectList();
        //获取列表
         function getSelectList(){
            var items = [
                {key:"enabled", op:"=", value:"true"}
            ];
            if(vm.searchQuery){
                items.push({key: "name", value: vm.searchQuery, op: "like"});
            }
            if(vm.type === "titleWidget"){
                TitleWidget.getAllUsable({name:vm.searchQuery}, function (res) {
                    vm.list = res;
                });
            }
            if(vm.type === "monthWidget"){
                MonthWidget.getAllUsable({name:vm.searchQuery}, function (res) {
                    vm.list = res;
                });
            }
        }
        //搜索
        $scope.search = function (){
            getSelectList();
        }
        //取消
        $scope.cancel = function (){
            $uibModalInstance.close();
        }
        //确定
        $scope.confirm = function(){
            if(!vm.selected){
                return MessageService.error("请选择组件");
            }
            var Item = vm.list.find(function(item){
                return item.id === vm.selected;
            })
            $uibModalInstance.close(Item);
        }
        //选择
        $scope.selectItem = function(e){
            vm.selected = e;
        }


    }
})();

(function () {
    "use strict";

    angular.module("platformApp").controller("UpgradePromptController", UpgradePromptController);

    UpgradePromptController.$inject = ["$scope", "$timeout", "$uibModalInstance","$localStorage","FrontUser","MessageService"];

    function UpgradePromptController($scope, $timeout, $uibModalInstance,$localStorage,FrontUser,MessageService) {
        var vm = this;
        vm.loading = false;
        vm.swiperList = [
            { src: "content/images/upgrade-swiper1.png" },
            { src: "content/images/upgrade-swiper2.png" },
            { src: "content/images/upgrade-swiper3.png" }
        ];
        init();
        function init() {
            $timeout(function () {
                new Swiper(".upgrade-swiper", {
                    autoplay: true,
                    loop: true
                });
            });
        }
        vm.close = function () {
            $uibModalInstance.close();
        };
        //点击开启按钮
        vm.submitOpen = function(){
            if(vm.loading) return;
            vm.loading = true;
            FrontUser.upgrade({},function(res){
                vm.loading = false;
                $localStorage.user = res;
                vm.close();
            },function(){
                vm.loading = false;
                MessageService.error("网络错误，请重试");
            })

        }
    }
})();

(function () {
    'use strict';

    var threePreview1 = {
        restrict: 'EAC',
        replace: true,
        transclude: true,
        templateUrl: 'app/entities/page/modal/three-preview1.html',
        // controller: 'articlePreviewController',
        controllerAs: 'vm',
        bindings: {
            height: '=',
            width: '=',
            modelPath: '=',
            modelData: '<',
        },

        controller: ['$scope', '$stateParams', 'Qinius', '$http', '$q',
            'MessageService','$state', '$compile','$timeout', 'ThreeEnv',
            function ($scope, $stateParams, Qinius, $http, $q,
                       MessageService,$state, $compile,$timeout, ThreeEnv) {
                var vm = this;
                vm.loading = true;
                vm.error = false;
                vm.data = "";
                vm.viewWidth = vm.width;
                vm.viewHeight = vm.height;
                vm.$onChanges = function(data) {
                    console.log(data)
                    if (data.modelData) {
                        vm.modelData = data.modelData.currentValue;
                        initContent1();
                    }
                };
                vm.$onDestroy = function(){
                    cancelAnimationFrame(vm.animateFrame);
                }
                $q.all().then(function () {
                    init();
                });

                function loaddingError(message) {
                    vm.loading = false;
                    vm.error = true;
                    vm.errorText = message;
                }
                function loaddingSuccess() {
                    vm.loading = false;
                    vm.error = false;
                }

                var scene, camera, renderer, controls, guiControls;
                // var stats = initStats();

                /* 场景 */
                function initScene() {
                    scene = new THREE.Scene();
                    // scene.background = new THREE.Color(0xB3CEFB);
                    // scene.fog = new THREE.Fog(scene.background, 0.1, 1);
                }

                /* 相机 */
                function initCamera(clientWidth, clientHeight) {
                    // camera = new THREE.PerspectiveCamera(45, vm.viewWidth / vm.viewHeight, 0.1, 100000);
                    // camera.position.z = 15;
                    // camera.lookAt(new THREE.Vector3(0, 10, 0));


                    camera = new THREE.PerspectiveCamera(50, clientWidth / clientHeight, 0.1, 1000);
                    var l1 = new THREE.AmbientLight(0xffffff, 0.3);
                    l1.name = 'a-light';
                    camera.add(l1);
                    var l2 = new THREE.DirectionalLight(0xffffff, 0.8 * Math.PI);
                    l2.position.set(6, 0, 6); // ~60º
                    l2.name = 'm-light';
                    l2.castShadow = true;
                    camera.add(l2);
                    var l3 = new THREE.HemisphereLight(0xffffff, 0x000000, 1);
                    l3.name = 'h-light';
                    camera.add(l3);
                    scene.add(camera);

                }

                /* 渲染器 */
                function initRender() {
                    renderer = new THREE.WebGLRenderer({
                        antialias: true,
                        alpha:true,
                        precision: 'highp',
                        preserveDrawingBuffer: true
                    });
                    renderer.setClearColor(new THREE.Color(0xf3f3f3),0.0);
                    renderer.setSize(vm.viewWidth, vm.viewHeight);
                    renderer.shadowMap.enabled = true;
                    renderer.physicallyCorrectLights = true;
                    renderer.outputEncoding = THREE.sRGBEncoding;
                    renderer.minFilter = THREE.LinearFilter;
                    renderer.gammaOutput = true;
                    renderer.setPixelRatio( window.devicePixelRatio );

                    $timeout(function () {
                        document.getElementById("threeView").appendChild(renderer.domElement);
                        onWindowResize()
                        initContent();
                        loaddingSuccess();
                        $scope.$apply();
                    })
                }

                /* 灯光 */
                function initLight() {
                    scene.add(new THREE.AmbientLight(0xdddddd));
                    var directionalLight = new THREE.DirectionalLight(0xdddddd, 0.1);
                    directionalLight.position.set(-4, 8, 4);
                    var dhelper = new THREE.DirectionalLightHelper(directionalLight, 5, 0xff0000);

                    var hemisphereLight = new THREE.HemisphereLight(0xffffff, 0xffffff, 0.6);
                    hemisphereLight.position.set(0, 8, 0);
                    var hHelper = new THREE.HemisphereLightHelper(hemisphereLight, 5);

                    // directionalLight.castShadow = true;
                    // directionalLight.shadow.mapSize = new THREE.Vector2(100000, 100);
                    // directionalLight.shadow.bias = -0.1;
                    // scene.add(hemisphereLight);
                    scene.add(directionalLight);


                    // let floorGeometry = new THREE.PlaneGeometry(500, 500, 32);
                    // var material = new THREE.MeshBasicMaterial( {color: 0xffff00, side: THREE.DoubleSide} );
                    // let floorMaterial = new THREE.MeshPhongMaterial({
                    //     color: 0xffff00,
                    //     shininess: 0,
                    //     // wireframe: true
                    // });
                    // let floor = new THREE.Mesh(floorGeometry, material);
                    // floor.rotation.x = -0.5 * Math.PI;
                    // floor.position.y = -120;
                    // floor.receiveShadow = true;
                    // scene.add(floor);
                }

                /* 控制器 */
                function initControls() {
                    controls = new THREE.OrbitControls(camera, renderer.domElement);
                    controls.autoRotate = true;
                    controls.autoRotateSpeed = -6;
                }

                /* 场景中的内容 */
                function initContent() {
                    // 加载 glTF 格式的模型
                    var loader = new THREE.GLTFLoader();
                    if (THREE.DRACOLoader) {
                        var dracoLoader = new THREE.DRACOLoader();
                        if (dracoLoader) {
                            dracoLoader.setDecoderPath("lib/three/draco/");
                            loader.setDRACOLoader( dracoLoader );
                        }
                    }
                    loader.load(vm.modelPath, function (gltf) {
                        // console.log(gltf);
                        var metalness = checkGltfMetalness(gltf);
                        var gltfScene = gltf.scene || gltf.scenes[0];
                        var clips = gltf.animations || [];
                        gltfScene.updateMatrixWorld();
                        var box = new THREE.Box3().setFromObject(gltfScene);
                        var size = box.getSize(new THREE.Vector3()).length();
                        var center = box.getCenter(new THREE.Vector3());
                        // controls.reset();
                        gltfScene.position.x += gltfScene.position.x - center.x;
                        gltfScene.position.y += gltfScene.position.y - center.y;
                        gltfScene.position.z += gltfScene.position.z - center.z;

                        // 重新设置相机参数
                        controls.maxDistance = size * 10;
                        camera.near = size / 80;
                        camera.far = size * 80;
                        camera.updateProjectionMatrix();

                        camera.position.copy(center);
                        camera.position.x += size / 1.0;
                        camera.position.y += size / 1.0;
                        camera.position.z += size / 1.0;
                        camera.lookAt(center);

                        gltf.scene.traverse(function(child){
                            if (child.isMesh) {
                                child.material.depthWrite = !child.material.transparent;
                                // child.material.emissive =  child.material.color;
                                // child.material.emissiveMap = child.material.map;

                                var materials = Array.isArray(child.material) ? child.material : [child.material];
                                materials.forEach(function (node) {
                                    for(var i=0; i<vm.modelData.length; i++){
                                        if(vm.modelData[i].materialName === node.name){
                                            if(vm.modelData[i].img){
                                                var textureLoader = new THREE.TextureLoader();
                                                var map = textureLoader.load(vm.modelData[i].img);
                                                map.minFilter = THREE.LinearFilter;
                                                map.flipY = false;

                                                if (node.map) {
                                                    // copy current map repeat and offset to the new map
                                                    // this is for gltfpack (meshoptimizer) compressed models
                                                    // Also, in the model, you need to embed a texture image so that we can retrieve it here.
                                                    map.repeat.copy(node.map.repeat);
                                                    map.offset.copy(node.map.offset);
                                                }

                                                // copy texture encoding from existing one to the loaded texture
                                                map.encoding = node.map ? node.map.encoding : THREE.sRGBEncoding;

                                                node.map = map;
                                                node.needsUpdate = true;
                                            }

                                            if(vm.modelData[i].color){
                                                node.color = new THREE.Color(vm.modelData[i].color);
                                            }
                                        }
                                    }
                                });
                            }
                        })
                        scene.add(gltfScene);
                        if (metalness > 0) {
                            console.log("metalness=" + metalness);
                            updateEnvironment();
                        }
                        // 判断当前的gltf问价中是否有动画
                        if (clips.length !== 0) {
                            var mixer = new THREE.AnimationMixer(gltfScene);
                            mixer.clipAction(gltf.animations[0]).play();
                        }
                    }, function (xhr) {
                        // console.log((xhr.loaded / xhr.total * 100) + '% loaded');
                    }, function (error) {
                        // console.log(error)
                        loaddingError();
                    })

                }
                function initContent1() {
                    // 加载 glTF 格式的模型
                    var loader = new THREE.GLTFLoader();
                    if (THREE.DRACOLoader) {
                        var dracoLoader = new THREE.DRACOLoader();
                        if (dracoLoader) {
                            dracoLoader.setDecoderPath("lib/three/draco/");
                            loader.setDRACOLoader( dracoLoader );
                        }
                    }
                    loader.load(vm.modelPath, function (gltf) {
                        var gltfScene = gltf.scene || gltf.scenes[0];
                        var clips = gltf.animations || [];
                        gltfScene.updateMatrixWorld();
                        var box = new THREE.Box3().setFromObject(gltfScene);
                        var size = box.getSize(new THREE.Vector3()).length();
                        var center = box.getCenter(new THREE.Vector3());
                        gltfScene.position.x += gltfScene.position.x - center.x;
                        gltfScene.position.y += gltfScene.position.y - center.y;
                        gltfScene.position.z += gltfScene.position.z - center.z;

                        gltf.scene.traverse(function(child){
                            if (child.isMesh) {
                                var materials = Array.isArray(child.material) ? child.material : [child.material];
                                materials.forEach(function (node) {
                                    for(var i=0; i<vm.modelData.length; i++){
                                        if(vm.modelData[i].materialName === node.name){
                                            if(vm.modelData[i].img){
                                                var textureLoader = new THREE.TextureLoader();
                                                var map = textureLoader.load(vm.modelData[i].img);
                                                map.minFilter = THREE.LinearFilter;
                                                map.flipY = false;

                                                if (node.map) {
                                                    // copy current map repeat and offset to the new map
                                                    // this is for gltfpack (meshoptimizer) compressed models
                                                    // Also, in the model, you need to embed a texture image so that we can retrieve it here.
                                                    map.repeat.copy(node.map.repeat);
                                                    map.offset.copy(node.map.offset);
                                                }

                                                // copy texture encoding from existing one to the loaded texture
                                                map.encoding = node.map ? node.map.encoding : THREE.sRGBEncoding;

                                                node.map = map;
                                                node.needsUpdate = true;
                                            }

                                            if(vm.modelData[i].color){
                                                node.color = new THREE.Color(vm.modelData[i].color);
                                            }
                                        }
                                    }
                                });
                            }
                        })
                        scene.add(gltf.scene);
                    }, function (xhr) {
                        // console.log((xhr.loaded / xhr.total * 100) + '% loaded');
                    }, function (error) {
                        // console.log(error)
                        loaddingError();
                    })

                }

                /* 窗口变动触发 */
                function onWindowResize() {
                    var width =vm.viewWidth;
                    var height = vm.viewHeight;
                    camera.aspect = width / height;
                    camera.updateProjectionMatrix();
                    renderer.setSize(width, height);
                }

                /* 数据更新 */
                // function update() {
                //     stats.update();
                // }
                /* 初始化 */
                function init() {
                    var container = document.getElementById("threeView");
                    initScene();
                    initCamera(container.clientWidth, container.clientHeight);
                    initRender();
                    // initLight();
                    initControls();
                    // initGui();
                    /* 监听事件 */
                    window.addEventListener('resize', onWindowResize, false);
                    animate();
                }

                /* 循环渲染 */
                function animate() {
                    // 每次取消动画
                    cancelAnimationFrame(vm.animateFrame);

                    var r = function (){
                        if (!renderer) {
                            return;
                        }
                        vm.animateFrame = requestAnimationFrame(r);
                        renderer.render(scene, camera);
                        controls.update();
                    };
                    r();
                }

                $scope.onMouseOver = function () {
                    controls.autoRotate = false;
                }
                $scope.onMouseOut = function () {
                    controls.autoRotate = true;
                }

                function checkGltfMetalness(gltf) {
                    var metalness = 0;
                    if (gltf && gltf.scene) {
                        metalness = parseGroupMetalness(gltf.scene);
                    }
                    return metalness;
                }

                function parseGroupMetalness(group) {
                    var metalness = 0;
                    if (!group.children) {
                        return metalness;
                    }
                    for (var i = 0; i < group.children.length; i++) {
                        var child = group.children[i];
                        if (child.type == 'Mesh') {
                            if (child.material && child.material.metalness > metalness) {
                                metalness = child.material.metalness;
                            }
                        }
                        else if (child.type == 'Group') {
                            var val = parseGroupMetalness(child);
                            if (val > metalness) {
                                metalness = val;
                            }
                        }
                    }
                    return metalness;
                }

                function updateEnvironment () {
                    ThreeEnv.getEnvMap(renderer).then(
                        function (data) {
                            if (data && data.envMap) {
                                scene.environment = data.envMap;
                            }
                        }
                    );
                }
            }
        ]
    };

    angular
        .module('platformApp')
        .component('threePreview1', threePreview1);
})();

(function() {
    'use strict';

    angular
        .module('platformApp')
        .controller('TemplateUpgradeController', TemplateUpgradeController);

    TemplateUpgradeController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'ProductXml','MessageService'];

    function TemplateUpgradeController ($timeout, $scope, $stateParams, $uibModalInstance, entity, ProductXml,MessageService) {
        var vm = this;
        vm.template = entity;
        vm.isCover = true;
        vm.pages = [];
        init()
        function init(){
            ProductXml.get({id: vm.template.id}, function (resp) {
                vm.pages = resp.document.pages.page;
                $timeout(function(){
                    swiper();
                })
            })
        }
        vm.productList = [
            {name:'照片书', id:'BOOK',},
            {name:'冲印', id:'PHOTO',},
            {name:'台历', id:'CALENDAR'},
            {name:'万物',id:'THING'},
        ];
        vm.productSeq=0;
        $scope.productCb = function(index){
            vm.productSeq=index;
        };
        vm.cancel = function () {
            $uibModalInstance.close(false);
        };
        vm.save = function () {
            console.log(vm.template)
            console.log(vm.productList[vm.productSeq])
            var data ={id:vm.template.id,productType:vm.productList[vm.productSeq].id};
            if (vm.productList[vm.productSeq].id == 'BOOK' && vm.isCover) {
                data.patternType = 'BOOK';
            }
            ProductXml.upgradeProductXml(data,function (res) {
                if(res.status == 200){
                    $uibModalInstance.close(true);
                }else{
                    MessageService.error(res.message || "模板升级失败，请稍后重试");
                    $uibModalInstance.close(false);
                }
            },function (error) {
                MessageService.error(error.data.message || "模板升级失败，请稍后重试");
                $uibModalInstance.close(false);
            })
        }
        function swiper() {
            var swiper = new Swiper('.swiper-container-modal', {
                pagination: {
                    el: '.swiper-pagination',
                    type: 'fraction',
                },
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                },
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('platformApp')
        .controller('TemplateRenameController', TemplateRenameController);

    TemplateRenameController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', '$state', 'MessageService','ProductXml'];

    function TemplateRenameController ($timeout, $scope, $stateParams, $uibModalInstance, entity, $state, MessageService,ProductXml) {
        var vm = this;
        vm.save = save;
        vm.cancel = cancel;
        vm.data = entity || {
            id: null,
            name: '错误'
        }
        
        //返回
        function cancel() {
            $uibModalInstance.close();
        }

        function save() {
            if (!vm.data.name) {
                MessageService.error("请输入模版名称！");
                return ;
            }
            ProductXml.rename(vm.data, function(res) {
                MessageService.success("更新数据成功！");
                $uibModalInstance.close(res);
            }, function(res) {
                MessageService.error("保存数据失败！")
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('platformApp')
        .controller('TemplateModalController', TemplateModalController);

    TemplateModalController.$inject = ['$timeout', '$scope', 'UidService', '$stateParams', '$uibModalInstance', 'entity', '$state', 'Moulds', 'MessageService', 'Qinius', 'ProductTemplate', 'Catalog', '$uibModal','ProductXml'];

    function TemplateModalController ($timeout, $scope, UidService, $stateParams, $uibModalInstance, entity, $state, Moulds, MessageService, Qinius, ProductTemplate, Catalog, $uibModal,ProductXml) {
        var vm = this;
        vm.cancel = cancel;
        vm.save = save;
        vm.type = entity.type;
        vm.id = entity.id;
        vm.data = entity.data;
        vm.statusCheck = statusCheck;
        vm.reuseCheck = reuseCheck;
        vm.selectModel = selectModel;
        vm.cutPage = cutPage;
        $scope.domains = Qinius.getDomain();
        vm.tokens = Qinius.get();
        vm.page = 0;
        vm.pageList = [{index:0, name:'第1页'}];
        vm.units = [
            {name:'px', id:'px'},
            {name:'mm', id:'mm'},
            {name:'英寸', id:'in'},
        ]
        vm.replaces = [
            {id: true, value: '可替换'},
            {id: false, value: '不可替换'}
        ];
        vm.modelTypeList=[
            {name:'2D模型', value:'TWO'},
            {name:'3D模型', value:'THREE'},
        ];
        $scope.template = {
            transparency: 1,
            cover: null,
            scene: null,
            pageI: 0,
            angle: 0,
            backup: false,
            spread: false,
            unreplace: false,
            letterspacing: 0,
            lineheight: 0,
            text: '',
            bgimgs: {bgimg: []},
            bgimgs2: {bgimg: []},
            masks: {mask: []},
            cliparts: {clipart: []},
            frameConfigs: {frameConfig: []},
            documentpics: {documentpic: []},
            pages: {
                page: []
            },
            showPic: false,
            psdFiles: {psdFile: []}
        };
        vm.isEdit = true;
        if(vm.type == 'look'){
            vm.isEdit = false;
        }
        if(vm.type == 'add'){
            vm.data = {
                name: '',
                seq: 1,
                modelPath: '',
                modelType: 'TWO',
                pageSizeH: '',
                pageSizeW: '',
                pageBloodT: '',
                pageBloodB: '',
                pageBloodL: '',
                pageBloodR: '',
                pageEdits:[{
                    pageEditX:'',
                    pageEditY:'',
                    pageEditW:'',
                    pageEditH:'',
                }],
                pageEditUnit: 'mm',
                pageSizeUnit: 'mm',
                pageBloodUnit: 'mm',
                pageEditUnit1: 'mm',
                pageSizeUnit1: 'mm',
                pageBloodUnit1: 'mm',
                modelBlendent:[],
                cover: '',
                status: true,
                pageCount: 1,
                catalog: {
                    name: '',
                    type: '',
                    cancelled: false,
                    usable: true,
                    seq: 1,
                },
                reuse: true,
                hasModel: true,
                pageTemplates: [
                    {
                        id:'',
                        seq:1,
                        added:true,
                        deleted:false,
                        pageSizeH:'',
                        pageSizeW:'',
                        pageBloodT:'',
                        pageBloodB:'',
                        pageBloodL:'',
                        pageBloodR:'',
                        pageEdits:[{
                            pageEditX:'',
                            pageEditY:'',
                            pageEditW:'',
                            pageEditH:'',
                        }],
                        pageEditUnit: 'mm',
                        pageSizeUnit: 'mm',
                        pageBloodUnit: 'mm',
                        pageEditUnit1: 'mm',
                        pageSizeUnit1: 'mm',
                        pageBloodUnit1: 'mm',
                        cancelled:false,
                        productTemplateId:'',
                        mould:null,
                    }
                ],
            };
            vm.pageCount = 1;
        }else {
            vm.abolishData = [];
            vm.pageCount = 0;
            for(var i=(vm.data.pageTemplates.length - 1); i>=0; i--){
                if(vm.data.pageTemplates[i].cancelled){
                    vm.abolishData.push(vm.data.pageTemplates[i]);
                    vm.data.pageTemplates.splice(i, 1)
                }else{
                    vm.pageCount++;
                }
            }
        }
        //模板分类
        Catalog.getAll({items:[{key:"usable", op:"=", value:"true"},{key:"catalogType", op:"=", value:"XML"}]}, function (res) {
            vm.catalogs = res;
            if(vm.type != 'add'){
                for(var i=0; i<res.length; i++){
                    if(res[i].id == vm.data.catalog.id){
                        vm.data.catalog = res[i];
                    }
                }
            }
        });

        //配色管理
        $scope.modelBlendentAdd = function () {
            if(!vm.data.modelBlendent){
                vm.data.modelBlendent = [];
            }
            vm.data.modelBlendent.push({
                name:'',
                modelData:angular.copy(vm.modelData),
                uuid:getUuid(16, 16),
                cancelled: false,
            })
        }
        $scope.modelBlendentSet = function (data) {
            vm.modelData.forEach(function (modelData2){
                data.modelData.forEach(function (modelData1){
                    if(modelData1.materialName == modelData2.materialName){
                        modelData1.page = modelData2.page;
                        if(modelData1.page>0 || modelData1.page === 0){
                            modelData1.color = null;
                        }
                    }
                })
            })
            $uibModal.open({
                templateUrl: 'app/entities/page/modal/blendent-modal.html',
                controller: 'BlendentModalController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'lg',
                resolve: {
                    entity: [function() {
                        return {
                            modelData: data.modelData,
                            modelPath: vm.data.modelPath
                        };
                    }]
                }
            }).result.then(function(res) {
                if(res){
                    data.modelData = res;
                }
            });
        }
        $scope.removeModelBlendent = function (index) {
            vm.data.modelBlendent.splice(index, 1)
        }
        //改变页的总数
        $scope.pageCountTab = function(){
            if(vm.data.pageCount == vm.pageCount){
                return;
            }
            if(Number(vm.pageCount) < 1){
                MessageService.error("请输入有效的数值");
                return
            }
            if(Number(vm.pageCount) > Number(vm.data.pageCount)){
                var _pageCount = vm.pageCount - vm.data.pageCount;
                var thisPageData = {
                    id:'',
                    seq:Number(vm.page) + Number(1),
                    added:true,
                    deleted:false,
                    pageSizeH:'',
                    pageSizeW:'',
                    pageBloodT:'',
                    pageBloodB:'',
                    pageBloodL:'',
                    pageBloodR:'',
                    pageEdits:[{
                        pageEditX:'',
                        pageEditY:'',
                        pageEditW:'',
                        pageEditH:'',
                    }],
                    pageEditUnit: 'mm',
                    pageSizeUnit: 'mm',
                    pageBloodUnit: 'mm',
                    pageEditUnit1: 'mm',
                    pageSizeUnit1: 'mm',
                    pageBloodUnit1: 'mm',
                    cancelled:false,
                    productTemplateId:'',
                    mould:null,
                }
                for(var i=0; i<_pageCount; i++){
                    thisPageData.seq = Number(vm.data.pageCount) + Number(i);
                    var _thisPageData = angular.copy(thisPageData)
                    vm.data.pageTemplates.push(_thisPageData);
                }
                vm.data.pageCount = angular.copy(vm.pageCount);
            }
            if(Number(vm.pageCount) < Number(vm.data.pageCount)){
                var _pageCount = Number(vm.pageCount) - Number(1);
                for(var i=(vm.data.pageTemplates.length - 1); i > _pageCount; i--){
                    if(vm.data.pageTemplates[i].added){
                        vm.data.pageTemplates.splice(i,1);
                    }else {
                        vm.data.pageTemplates[i].deleted = true;
                        vm.data.pageTemplates[i].cancelled = true;
                        if(vm.data.pageTemplates[i].pageSizeUnit == 'px'){
                            unit1(vm.data.pageTemplates[i])
                        }
                        vm.abolishData.push(vm.data.pageTemplates[i]);
                        vm.data.pageTemplates.splice(i,1);
                    }
                }
                vm.data.pageCount = angular.copy(vm.pageCount);
            }
            pageListInfo();
        }
        function pageListInfo(){
            vm.pageList = [];
            for(var i=0; i<vm.data.pageCount; i++){
                vm.pageList.push({
                    index:i,
                    name: '第'+(i+1)+'页'
                })
            }
        };

        //选择模型类型
        $scope.modelTypeTab = function () {
            if(vm.data.modelType == 'THREE'){
                vm.data.bindingType = 'None';
                vm.data.pattern = 'OTHER';
                vm.data.replace = false;
            }else {
                vm.data.modelPath = "";
                vm.data.modelData = "";
                vm.modelData = [];
            }
        }

        //选择模型
        vm.modelPathTab = modelPathTab;
        vm.modelPathTabEdit = modelPathTabEdit;
        function modelPathTab() {
            $uibModal.open({
                templateUrl: 'app/entities/page/modal/model-select.html',
                controller: 'ModelSelectController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'lg',
                resolve: {
                    entity: [function() {
                        return {
                            type: 'add',
                            data: vm.data,
                            modelType:'THREE'
                        };
                    }]
                }
            }).result.then(function(res) {
                if(res){
                    vm.data.modelData= res.modelData;
                    vm.data.modelPath= res.modelPath;
                    vm.data.mould= res;
                    modelDataInfo(vm.data.modelData);
                }
            });
        }
        function modelPathTabEdit() {
            $uibModal.open({
                templateUrl: 'app/entities/page/modal/model-select.html',
                controller: 'ModelSelectController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'lg',
                resolve: {
                    entity: [function() {
                        return {
                            type: 'edit',
                            data: vm.data,
                            modelType:'THREE'
                        };
                    }]
                }
            }).result.then(function(res) {
                if(res){
                    vm.data.modelData= res.modelData;
                    vm.data.modelPath= res.modelPath;
                    vm.data.mould= res;
                    modelDataInfo(vm.data.modelData);
                }
            });
        }
        function modelDataInfo(item) {
            vm.modelData = JSON.parse(item);
        }
        function selectModel(data){
            $uibModal.open({
                templateUrl: 'app/entities/page/modal/model-select.html',
                controller: 'ModelSelectController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'lg',
                resolve: {
                    entity: [function() {
                        return {
                            type: 'add',
                            data: data,
                            modelType:'TWO'
                        };
                    }]
                }
            }).result.then(function(res) {
                if(res){
                    res.modelPic = $scope.domains.domain + res.modelPic;
                    data.mould = res;
                }
            });
        }
        //编辑模型
        vm.selectModelEdit = selectModelEdit;
        function selectModelEdit(data){
            $uibModal.open({
                templateUrl: 'app/entities/page/modal/model-select.html',
                controller: 'ModelSelectController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'lg',
                resolve: {
                    entity: [function() {
                        return {
                            type: 'edit',
                            data: data,
                            modelType:'TWO'
                        };
                    }]
                }
            }).result.then(function(res) {
                if(res){
                    res.modelPic = $scope.domains.domain + res.modelPic;
                    data.mould = res;
                }
            });
        }
        //切换页
        function cutPage(item){
            if(item == 'next'){
                vm.page++;
                if(vm.data.reuse && vm.isEdit){
                    vm.data.pageTemplates[vm.page].pageSizeH = angular.copy(vm.data.pageTemplates[vm.page-1].pageSizeH);
                    vm.data.pageTemplates[vm.page].pageSizeW = angular.copy(vm.data.pageTemplates[vm.page-1].pageSizeW);
                    vm.data.pageTemplates[vm.page].pageBloodT = angular.copy(vm.data.pageTemplates[vm.page-1].pageBloodT);
                    vm.data.pageTemplates[vm.page].pageBloodB = angular.copy(vm.data.pageTemplates[vm.page-1].pageBloodB);
                    vm.data.pageTemplates[vm.page].pageBloodL = angular.copy(vm.data.pageTemplates[vm.page-1].pageBloodL);
                    vm.data.pageTemplates[vm.page].pageBloodR = angular.copy(vm.data.pageTemplates[vm.page-1].pageBloodR);
                    vm.data.pageTemplates[vm.page].pageEdits = angular.copy(vm.data.pageTemplates[vm.page-1].pageEdits);
                    vm.data.pageTemplates[vm.page].pageEditUnit = angular.copy(vm.data.pageTemplates[vm.page-1].pageEditUnit);
                    vm.data.pageTemplates[vm.page].pageSizeUnit = angular.copy(vm.data.pageTemplates[vm.page-1].pageSizeUnit);
                    vm.data.pageTemplates[vm.page].pageBloodUnit = angular.copy(vm.data.pageTemplates[vm.page-1].pageBloodUnit);
                    vm.data.pageTemplates[vm.page].pageEditUnit1 = angular.copy(vm.data.pageTemplates[vm.page-1].pageEditUnit1);
                    vm.data.pageTemplates[vm.page].pageSizeUnit1 = angular.copy(vm.data.pageTemplates[vm.page-1].pageSizeUnit1);
                    vm.data.pageTemplates[vm.page].pageBloodUnit1 = angular.copy(vm.data.pageTemplates[vm.page-1].pageBloodUnit1);
                    vm.data.pageTemplates[vm.page].mould = angular.copy(vm.data.pageTemplates[vm.page-1].mould);
                }
            }
            if(item == 'up'){
                vm.page--;
            }
        }
        function homePageData(){
            vm.data.pageSizeH = vm.data.pageTemplates[0].pageSizeH;
            vm.data.pageSizeW = vm.data.pageTemplates[0].pageSizeW;
            vm.data.pageBloodT = vm.data.pageTemplates[0].pageBloodT;
            vm.data.pageBloodB = vm.data.pageTemplates[0].pageBloodB;
            vm.data.pageBloodL = vm.data.pageTemplates[0].pageBloodL;
            vm.data.pageBloodR = vm.data.pageTemplates[0].pageBloodR;
            vm.data.pageEdits = vm.data.pageTemplates[0].pageEdits;
            vm.data.pageEditUnit = vm.data.pageTemplates[0].pageEditUnit;
            vm.data.pageSizeUnit = vm.data.pageTemplates[0].pageSizeUnit;
            vm.data.pageBloodUnit = vm.data.pageTemplates[0].pageBloodUnit;
            vm.data.pageEditUnit1 = vm.data.pageTemplates[0].pageEditUnit1;
            vm.data.pageSizeUnit1 = vm.data.pageTemplates[0].pageSizeUnit1;
            vm.data.pageBloodUnit1 = vm.data.pageTemplates[0].pageBloodUnit1;
        }

        //预览图
        window.uploadPic = function ($event) {
            var files = $event.target.files;
            if (files != null && files.length > 0) {
                qiniuUpload(files[0]);
            }
        }
        function qiniuUpload(file) {
            var formData = new FormData();
            formData.append('file', file);
            formData.append('unique_names', false);
            formData.append('key', 'template-' + UidService.get());
            formData.append('token', vm.tokens.token);
            $.ajax({
                cache: true,
                type: "POST",
                url: 'https://upload.qiniup.com/',
                data: formData,
                async: true,
                contentType: false,
                processData: false,
                success: function (data) {
                    vm.data.cover = data.key;
                    $scope.$apply();
                },
                error: function (request) {
                    MessageService.error("图片上传失败");
                }
            });
        }
        $scope.removeFile = function () {
            vm.data.cover = "";
        }

        //是否启用
        function statusCheck(item) {
            vm.data.status = item;
        }
        //页面复用
        function reuseCheck(item) {
            vm.data.reuse = item;
        }

        function checkFloatNum(str){
            var reg_zs = /^[0-9]\d*(\.\d+)?$/i;
            if (!reg_zs.test(str)) {
                return false;
            }
            return true;
        }
        function checkFloatNum1(str){
            var reg_zs = /^[1-9]\d*(\.\d+)?$/i;
            if (!reg_zs.test(str)) {
                return false;
            }
            return true;
        }
        //保存
        function save() {
            if(!vm.data.name){
                MessageService.error("请输入模板名称！");
                return
            }
            if(!vm.data.cover){
                MessageService.error("请上传预览图");
                return
            }
            if(!vm.data.bindingType){
                MessageService.error("请选择预览翻页方式！");
                return
            }
            if(!vm.data.pattern){
                MessageService.error("请选择编辑模式！");
                return
            }
            if(vm.data.modelType == 'THREE' && !vm.data.modelPath){
                MessageService.error("请选择第" + _pageIndex + "页的模型");
                return false
            }
            var _pageIndex = 1;
            for(var i=0; i<vm.data.pageTemplates.length; i++){
                var _pageTemplates = vm.data.pageTemplates[i];
                if(!_pageTemplates.cancelled){
                    if(vm.data.modelType == 'TWO' && !_pageTemplates.mould){
                        MessageService.error("请选择第" + _pageIndex + "页的模型");
                        return false
                    }
                    if(!checkFloatNum(_pageTemplates.pageSizeW) || !checkFloatNum(_pageTemplates.pageSizeH)){
                        MessageService.error("第" + _pageIndex + "页的尺寸必须大于等于0");
                        return false
                    }
                    if(!checkFloatNum(_pageTemplates.pageBloodT) || !checkFloatNum(_pageTemplates.pageBloodB) || !checkFloatNum(_pageTemplates.pageBloodL) || !checkFloatNum(_pageTemplates.pageBloodR)){
                        MessageService.error("第" + _pageIndex + "页的出血尺寸必须大于等于0");
                        return false
                    }
                    if(!_pageTemplates.pageEdits || _pageTemplates.pageEdits.length == 0){
                        MessageService.error("第" + _pageIndex + "页的编辑区域不能为空");
                        return false
                    }
                    for(var k=0; k<_pageTemplates.pageEdits.length; k++){
                        var _pageEdit = _pageTemplates.pageEdits[k];
                        if(!checkFloatNum(_pageEdit.pageEditX) || !checkFloatNum(_pageEdit.pageEditY) || !checkFloatNum(_pageEdit.pageEditW) || !checkFloatNum(_pageEdit.pageEditH)){
                            MessageService.error("第" + _pageIndex + "页的编辑区域必须大于等于0");
                            return false
                        }
                    }
                    _pageIndex++
                }
            }
            if(vm.data.pageTemplates[0].pageSizeUnit == 'px'){
                unit('mm');
            }
            homePageData();
            vm.data.modelData = JSON.stringify(vm.modelData);
            vm.data.modelBlendent = JSON.stringify(vm.data.modelBlendent);
            var _item = vm.data;
            for(var j=_item.pageTemplates.length-1; j>=0; j--){
                if(_item.pageTemplates[j].cancelled){
                    _item.pageTemplates.splice(j, 1)
                }
            }
            _item.pageSizeH=parseInt(_item.pageSizeH)-0;
            _item.pageSizeW=parseInt(_item.pageSizeW)-0;
            _item.pageBloodT=parseInt(_item.pageBloodT)-0;
            _item.pageBloodB=parseInt(_item.pageBloodB)-0;
            _item.pageBloodL=parseInt(_item.pageBloodL)-0;
            _item.pageBloodR=parseInt(_item.pageBloodR)-0;
            _item.pageEdits.forEach(function (pageEdit) {
                pageEdit.pageEditX = parseInt(pageEdit.pageEditX)-0;
                pageEdit.pageEditY = parseInt(pageEdit.pageEditY)-0;
                pageEdit.pageEditW = parseInt(pageEdit.pageEditW)-0;
                pageEdit.pageEditH = parseInt(pageEdit.pageEditH)-0;
            })
            _item.custom = vm.type;
            addSave(_item)
            return
            var pageStorageName = "page-new";
            if (vm.type == 'edit') {
                pageStorageName = "page-" + vm.id;
                localStorage.setItem(pageStorageName, JSON.stringify(_item));
                $state.go('page-my-suffix-edit', {id: vm.id}, {reload: true})
            } else if (vm.type == 'copy') {
                pageStorageName = "page-" + vm.id + "-copy";
                localStorage.setItem(pageStorageName, JSON.stringify(_item));
                $state.go('page-my-suffix-copy', {copy: vm.id}, {reload: true})
                // _item.id = null;
                // localStorage.setItem('page', JSON.stringify(_item));
                // $state.go('page-my-suffix', {reload: true})
            } else {
                localStorage.setItem(pageStorageName, JSON.stringify(_item));
                $state.go('page-my-suffix', {reload: true});
            }
            cancel()
        }
        function addSave(item) {
            if(vm.isSaving){
                return
            }
            vm.isSaving = true;
            vm.hashtags = '';
            if(item.catalog.hashtags){
                for (var i = 0; i < item.catalog.hashtags.length; i++) {
                    vm.hashtags += item.catalog.hashtags[i].name + ','
                }
            }
            $scope.template.pages.page=[];
            for (var i = 0; i < item.pageTemplates.length; i++) {
                var _page = item.pageTemplates[i];
                var editSize = [];
                _page.pageEdits.forEach(function (editbox) {
                    editSize.push({
                        height: editbox.pageEditH,
                        width: editbox.pageEditW,
                        x: editbox.pageEditX,
                        y: editbox.pageEditY
                    })
                });
                var _page1 = createPage(_page, editSize, i);
                if (_page.mould) {
                    _page1.scene = {
                        background: {
                            resource: {
                                identifier: _page.mould.modelPic.indexOf('http') > -1 ? _page.mould.modelPic : $scope.domains.domain + _page.mould.modelPic,
                                provider: "qiniu"
                            }
                        },
                        geometry: {
                            width: _page.mould.gWidth,
                            height: _page.mould.gHeight,
                            x: 0,
                            y: 0
                        },
                        imagebox: {
                            geometry: {
                                width: _page.mould.width,
                                height: _page.mould.height,
                                x: _page.mould.x,
                                y: _page.mould.y
                            },
                            rotation: {angle: 0},
                            transparency: 1,
                        },
                        hierarchy: _page.mould.hierarchy,
                        isScene: true,
                        scale: 1,
                        unit: "mm",
                        resource:{
                            identifier: _page.mould.modelPic.indexOf('http') > -1 ? _page.mould.modelPic : $scope.domains.domain + _page.mould.modelPic,
                            provider: "qiniu"
                        }
                    }
                }
                $scope.template.pages.page.push(_page1);
            }
            $scope.template.bindingtype = item.bindingType;
            $scope.template.pattern = item.pattern;
            $scope.template.cover = angular.copy(item.cover);
            $scope.template.replace = item.replace;
            $scope.template.version = "2.0";
            $scope.template.addpage = item.addpage;
            $scope.template.minpage = item.minpage;
            $scope.template.maxpage = item.maxpage;
            $scope.template.addunit = item.addunit;
            ProductXml.save({
                document: $scope.template,
                bindingType: item.bindingType,
                pattern: item.pattern,
                replace: item.replace,
                name: item.name,
                catalogId: item.catalog.id,
                catalogName: item.catalog.name,
                version: '2.0',
                type: 'XML',
                productTemplateId: '',
                hashtags: vm.hashtags,
                modelBlendent: item.modelBlendent,
                modelData: item.modelData,
                modelPath: item.modelPath,
                modelType: item.modelType
            }, function (res) {
                vm.isSaving = false;
                $uibModalInstance.close();
                $state.go('page-my-suffix-edit', {id: res.id}, {reload: true})
            }, function () {
                vm.isSaving = false;
            });
        }
        function createPage(_page, editSize, i) {
            var _page1 = {
                uuid: UidService.get(),
                isScene: false,
                bgImg: '',
                background: {resource: {},color:'#ffffff', type: "Color"},
                pagecover: {},
                levels: {},
                barcode: {},
                qrcode: {},
                editbox: editSize[0],
                editboxes: {
                    editbox: editSize
                },
                mediabox: {
                    height: _page.pageSizeH,
                    width: _page.pageSizeW,
                },
                trimbox: {
                    height: _page.pageSizeH - Number(_page.pageBloodB) - Number(_page.pageBloodT),
                    width: _page.pageSizeW - Number(_page.pageBloodL) - Number(_page.pageBloodR),
                    x: _page.pageBloodL,
                    y: _page.pageBloodT
                },
                scale: 1,
                proportion: 1,
                seq: i + 1,
                spread: false,
                backup: false,
                unreplace: !vm.data.replace
            }
            return _page1;
        }
        //返回
        function cancel() {
            $uibModalInstance.close(false);
        }
        //dpi
        js_getDPI()
        function js_getDPI() {
            var arrDPI = new Array();
            if (window.screen.deviceXDPI != undefined) {
                arrDPI[0] = window.screen.deviceXDPI;
                arrDPI[1] = window.screen.deviceYDPI;
            }
            else {
                var tmpNode = document.createElement("DIV");
                tmpNode.style.cssText = "width:1in;height:1in;position:absolute;left:0px;top:0px;z-index:99;visibility:hidden";
                document.body.appendChild(tmpNode);
                arrDPI[0] = parseInt(tmpNode.offsetWidth);
                arrDPI[1] = parseInt(tmpNode.offsetHeight);
                tmpNode.parentNode.removeChild(tmpNode);
            }
            vm.windowDpi = arrDPI[0];
            return arrDPI;
        }

        $scope.addPageEdit = function () {
            vm.data.pageTemplates[vm.page].pageEdits.push({
                pageEditX:'',
                pageEditY:'',
                pageEditW:'',
                pageEditH:''
            })
        };
        $scope.removePageEdit = function(index){
            vm.data.pageTemplates[vm.page].pageEdits.splice(index, 1);
        };
        //单位换算
        $scope.unitConversion = function (item) {
            console.log(vm.data)
            unit(item)
        }
        function unit(item){
            for(var i=0; i<vm.data.pageTemplates.length; i++){
                var _data = vm.data.pageTemplates[i];
                if(_data.pageSizeUnit == 'mm'){
                    _data.pageSizeW = MmTurnPx(_data.pageSizeW).toFixed(2) - 0;
                    _data.pageSizeH = MmTurnPx(_data.pageSizeH).toFixed(2) - 0;
                    _data.pageBloodT = MmTurnPx(_data.pageBloodT).toFixed(2) - 0;
                    _data.pageBloodB = MmTurnPx(_data.pageBloodB).toFixed(2) - 0;
                    _data.pageBloodL = MmTurnPx(_data.pageBloodL).toFixed(2) - 0;
                    _data.pageBloodR = MmTurnPx(_data.pageBloodR).toFixed(2) - 0;
                    _data.pageEdits.forEach(function (pageEdit) {
                        pageEdit.pageEditX = MmTurnPx(pageEdit.pageEditX).toFixed(2) - 0;
                        pageEdit.pageEditY = MmTurnPx(pageEdit.pageEditY).toFixed(2) - 0;
                        pageEdit.pageEditW = MmTurnPx(pageEdit.pageEditW).toFixed(2) - 0;
                        pageEdit.pageEditH = MmTurnPx(pageEdit.pageEditH).toFixed(2) - 0;
                    })
                }
                if (_data.pageSizeUnit == 'in'){
                    _data.pageSizeW = InTurnPx(_data.pageSizeW).toFixed(2) - 0;
                    _data.pageSizeH = InTurnPx(_data.pageSizeH).toFixed(2) - 0;
                    _data.pageBloodT = InTurnPx(_data.pageBloodT).toFixed(2) - 0;
                    _data.pageBloodB = InTurnPx(_data.pageBloodB).toFixed(2) - 0;
                    _data.pageBloodL = InTurnPx(_data.pageBloodL).toFixed(2) - 0;
                    _data.pageBloodR = InTurnPx(_data.pageBloodR).toFixed(2) - 0;
                    _data.pageEdits.forEach(function (pageEdit) {
                        pageEdit.pageEditX = InTurnPx(pageEdit.pageEditX).toFixed(2) - 0;
                        pageEdit.pageEditY = InTurnPx(pageEdit.pageEditY).toFixed(2) - 0;
                        pageEdit.pageEditW = InTurnPx(pageEdit.pageEditW).toFixed(2) - 0;
                        pageEdit.pageEditH = InTurnPx(pageEdit.pageEditH).toFixed(2) - 0;
                    })
                }
                if(item == 'mm'){
                    _data.pageSizeW = PxTurnMm(_data.pageSizeW).toFixed(2) - 0;
                    _data.pageSizeH = PxTurnMm(_data.pageSizeH).toFixed(2) - 0;
                    _data.pageBloodT = PxTurnMm(_data.pageBloodT).toFixed(2) - 0;
                    _data.pageBloodB = PxTurnMm(_data.pageBloodB).toFixed(2) - 0;
                    _data.pageBloodL = PxTurnMm(_data.pageBloodL).toFixed(2) - 0;
                    _data.pageBloodR = PxTurnMm(_data.pageBloodR).toFixed(2) - 0;
                    _data.pageEdits.forEach(function (pageEdit) {
                        pageEdit.pageEditX = PxTurnMm(pageEdit.pageEditX).toFixed(2) - 0;
                        pageEdit.pageEditY = PxTurnMm(pageEdit.pageEditY).toFixed(2) - 0;
                        pageEdit.pageEditW = PxTurnMm(pageEdit.pageEditW).toFixed(2) - 0;
                        pageEdit.pageEditH = PxTurnMm(pageEdit.pageEditH).toFixed(2) - 0;
                    })
                }
                if(item == 'in'){
                    _data.pageSizeW = PxTurnIn(_data.pageSizeW).toFixed(2) - 0;
                    _data.pageSizeH = PxTurnIn(_data.pageSizeH).toFixed(2) - 0;
                    _data.pageBloodT = PxTurnIn(_data.pageBloodT).toFixed(2) - 0;
                    _data.pageBloodB = PxTurnIn(_data.pageBloodB).toFixed(2) - 0;
                    _data.pageBloodL = PxTurnIn(_data.pageBloodL).toFixed(2) - 0;
                    _data.pageBloodR = PxTurnIn(_data.pageBloodR).toFixed(2) - 0;
                    _data.pageEdits.forEach(function (pageEdit) {
                        pageEdit.pageEditX = PxTurnIn(pageEdit.pageEditX).toFixed(2) - 0;
                        pageEdit.pageEditY = PxTurnIn(pageEdit.pageEditY).toFixed(2) - 0;
                        pageEdit.pageEditW = PxTurnIn(pageEdit.pageEditW).toFixed(2) - 0;
                        pageEdit.pageEditH = PxTurnIn(pageEdit.pageEditH).toFixed(2) - 0;
                    })
                }
                _data.pageSizeUnit = item;
                _data.pageBloodUnit = item;
                _data.pageEditUnit = item;
                _data.pageSizeUnit1 = item;
                _data.pageBloodUnit1 = item;
                _data.pageEditUnit1 = item;
            }
        }
        function unit1(item){
            item.pageSizeUnit = 'mm';
            item.pageBloodUnit = 'mm';
            item.pageEditUnit = 'mm';
            item.pageSizeUnit1 = 'mm';
            item.pageBloodUnit1 = 'mm';
            item.pageEditUnit1 = 'mm';
            item.pageSizeW = (item.pageSizeW/vm.windowDpi*25.4).toFixed(2);
            item.pageSizeH = (item.pageSizeH/vm.windowDpi*25.4).toFixed(2);
            item.pageBloodT = (item.pageBloodT/vm.windowDpi*25.4).toFixed(2);
            item.pageBloodB = (item.pageBloodB/vm.windowDpi*25.4).toFixed(2);
            item.pageBloodL = (item.pageBloodL/vm.windowDpi*25.4).toFixed(2);
            item.pageBloodR = (item.pageBloodR/vm.windowDpi*25.4).toFixed(2);
            item.pageEdits.forEach(function (pageEdit) {
                pageEdit.pageEditX = (pageEdit.pageEditX/vm.windowDpi*25.4).toFixed(2);
                pageEdit.pageEditY = (pageEdit.pageEditY/vm.windowDpi*25.4).toFixed(2);
                pageEdit.pageEditW = (pageEdit.pageEditW/vm.windowDpi*25.4).toFixed(2);
                pageEdit.pageEditH = (pageEdit.pageEditH/vm.windowDpi*25.4).toFixed(2);
            })
        };

        $scope.bindingTypeInfo = function (item) {
            switch (item) {
                case 'Left':
                    return '左右滑动（含封面）';
                case 'Top':
                    return '上下滑动';
                case 'None':
                    return '单页展示';
                case 'Left2':
                    return '左右滑动（不含封面）';
                default:
                    return '';
            }
        }
        $scope.patternInfo = function (item) {
            switch (item) {
                case 'BOOK':
                    return '书刊模式';
                case 'OTHER':
                    return '普通模式';
                case 'BOOK2':
                    return '书刊（不含封面）';
                default:
                    return '';
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('platformApp')
        .controller('TemplateAddController', TemplateAddController);

    TemplateAddController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'items', '$state', 'MessageService', 'Catalog','Qinius', '$q', 'UidService',
        '$uibModal','TitleWidget','MonthWidget','ProductXml','$sce'];

    function TemplateAddController ($timeout, $scope, $stateParams, $uibModalInstance, items, $state, MessageService, Catalog,Qinius, $q, UidService,
                                    $uibModal,TitleWidget,MonthWidget,ProductXml,$sce) {
        var vm = this;

        $scope.domains = Qinius.getDomain();
        vm.tokens = Qinius.get();
        $q.all([$scope.domains.$promise, vm.tokens.$promise]).then(function () {
            vm.url = $scope.domains.domain;
            vm.token = vm.tokens.token;
        })
        console.log(items)
        vm.productType = items.productType;
        vm.data={
            modelType:"NONE",
            productType: vm.productType || "BOOK",
            pictureType:"P0",
            parts:[],
            photoPage:'14',
            photoType:'ordinary',
            catalog:{},
            innerOffset:0,
            unit:'mm',
            unit1:'mm',
            pageEdits:[{
                pageEditX:'',
                pageEditY:'',
                pageEditW:'',
                pageEditH:'',
            }],
            cover:"",
            addpage:false,
            replace:false,
            spread:false
        };
        vm.modelData = [];
        vm.step = 1;
        vm.titleWidget = "";
        vm.monthWidget = "";
        getData();
        function getData(){
            Catalog.getAll({items:[{key:"usable", op:"=", value:"true"},{key:"catalogType", op:"=", value:"XML"}]}, function (res) {
                vm.catalogs = res;
            });

            TitleWidget.byCondition({
                items:[{key:"enabled", op:"=", value:"true"},{key:"enabled", op:"=", value:"true"}],
                page: 0,
                size: 100,
                sort: ["id,desc"]
            }, function (res) {
                vm.titleWidgets = res;
            });
            MonthWidget.byCondition({
                items:[{key:"enabled", op:"=", value:"true"},{key:"enabled", op:"=", value:"true"}],
                page: 0,
                size: 100,
                sort: ["id,desc"]
            }, function (res) {
                vm.monthWidgets = res;
            });
        }

        $scope.getTilte = function () {
            if (vm.step == 1) {
                return vm.productType == 'THING' ? '创建万物模板' : '创建标准模板'
            }
            if (vm.step == 2) {
                return vm.productList[vm.productSeq].id == 'BOOK' ? '创建照片书模板' : $scope.typeReturn() == 'P0' ? '创建单面冲印模板' : $scope.typeReturn() == 'P1' ? '创建双面冲印模板' : $scope.typeReturn() == 'ordinary' ? '创建普通台历模板' : $scope.typeReturn() == 'dynamic' ? '创建动态台历模板' : $scope.typeReturn() == 'TWO' ? '创建2D模型模板' : $scope.typeReturn() == 'THREE' ? '创建3D模型模板' : '创建模板';
            }
        }

        vm.productList = [
            {
                name:'照片书',
                id:'BOOK',
                describe:'支持腰封/护封/封面/封底/内页多部件',
                icon:'content/images/page-icon5.png',
                parts:[
                    {name:'腰封',id:'B4',seq:0,required:false,counter:1},
                    {name:'护封',id:'B3',seq:1,required:false,counter:1},
                    {name:'封面',id:'B1',seq:2,required:false,counter:1},
                    {name:'内页',id:'P',seq:3,required:true,selected:true},
                    {name:'封底',id:'B2',seq:4,required:false,counter:1},
                ]
            },
            {
                name:'冲印/卡牌',
                id:'PHOTO',
                describe:'支持制作单面/双面冲印模版',
                icon:'content/images/page-icon4.png',
                types:[
                    {name:'单面',id:'P0',seq:0,required:false,counter:1},
                    {name:'双面',id:'P1',seq:0,required:false,counter:2},
                ]
            },
            {
                name:'日历',
                id:'CALENDAR',
                describe:'支持静态日历和动态日期日历',
                icon:'content/images/page-icon3.png',
                pages:[
                    {name:'7张14面',id:'14',seq:0,required:false,counter:14},
                    {name:'13张26面',id:'26',seq:0,required:false,counter:26},
                ],
                types:[
                    {name:'普通台历',id:'ordinary'},
                    {name:'动态台历',id:'dynamic'},
                ]
            },
            {
                name:'万物',
                id:'THING',
                describe:'支持2D模型和3D模型',
                types:[
                    {name:'2D模型',id:'TWO', icon:'content/images/page-icon6.png',},
                    {name:'3D模型',id:'THREE', icon:'content/images/page-icon7.png'},
                    {name:'无模型',id:'NONE', icon:'content/images/page-icon8.png'},
                ],
                parts:[]
            },
        ];
        vm.productSeq=0;
        if(items.productType == 'THING'){
            vm.productSeq=3;
        }
        $scope.productCb = function(index){
            vm.productSeq=index;
            if(vm.productList[vm.productSeq].id == "THING"){
                vm.data.modelType = "TWO";
            }else{
                vm.data.modelType = "NONE";
            }
        }
        $scope.typeCb = function(item){
            if(vm.productList[vm.productSeq].id == 'PHOTO'){
                vm.data.pictureType = item.id;
            }
            if(vm.productList[vm.productSeq].id == 'CALENDAR'){
                vm.data.photoType = item.id
            }
            if(vm.productList[vm.productSeq].id == 'THING'){
                vm.data.modelType = item.id
            }
        }
        $scope.typeReturn = function(){
            if(vm.productList[vm.productSeq].id == 'PHOTO'){
                return vm.data.pictureType
            }
            if(vm.productList[vm.productSeq].id == 'CALENDAR'){
                return vm.data.photoType
            }
            if(vm.productList[vm.productSeq].id == 'THING'){
                return vm.data.modelType
            }
        }
        $scope.deleteWidget = function (type){
            if(!type) return;
            vm[type] = null;
        }
        //显示标题预选、布局预选选择弹窗
        $scope.showWidgetModal = function (type) {
            $uibModal.open({
                templateUrl: "app/entities/page/modal/widget-select.html",
                controller: "WidgetSelectController",
                backdrop: 'static',
                keyboard: true,
                windowClass: "jh-modal-md",
                controllerAs: 'vm',
                size: 'md',
                resolve:{
                    items:function (){
                        return {
                            type:type
                        }
                    }
                }
            }).result.then(function(res){
                if(!res) return;
                if(type === "titleWidget"){
                    vm.titleWidget = res;
                }else if(type === "monthWidget"){
                    vm.monthWidget = res;
                }
            })
        }
        vm.isPart = false;
        $scope.addPart = function(){
            vm.part = "";
            vm.isPart = true;
            $timeout(function () {
                $("#partInput").focus();
            })
        }
        $scope.partBlur = function(){
            if(vm.part){
                vm.productList[vm.productSeq].parts.push({
                    seq:vm.productList[vm.productSeq].parts.length || 0,
                    name: vm.part,
                    id:UidService.get(),
                    pageCount:1,
                    page:[{
                        pageEdits:[{
                            pageEditX:'',
                            pageEditY:'',
                            pageEditW:'',
                            pageEditH:''
                        }]
                    }],
                    pageIndex:0,
                    partIndex:0,
                })
            }
            vm.part = "";
            vm.isPart = false;
        }
        $scope.deletePart = function(index){
            vm.productList[vm.productSeq].parts.splice(index,1);
        }
        vm.next = function () {
            if(vm.productList[vm.productSeq].id == 'THING'){
                if(!vm.productList[vm.productSeq].parts || vm.productList[vm.productSeq].parts.length == 0){
                    MessageService.error("请添加部件");
                    return
                }
                vm.productList[vm.productSeq].parts[0].pageIndex = 0;
                vm.productList[vm.productSeq].parts[0].partIndex = 0;
                vm.thingPart = vm.productList[vm.productSeq].parts[0];
            }
            vm.data.addpage = false;
            vm.data.minpage = 1;
            vm.data.maxpage = 1;
            vm.data.addunit = 1;
            vm.step = 2;
        }
        $scope.modelTypeInfo = function () {
            switch (vm.data.modelType)
            {
                case "TWO":
                    return "2D模型";
                    break;
                case "THREE":
                    return "3D模型";
                    break;
                case "NONE":
                    return "自定义模板";
                    break;
                default:
                    return "自定义模板"
            }
        }

        //单位换算
        vm.units = [
            {name:'px', id:'px'},
            {name:'mm', id:'mm'},
            {name:'英寸', id:'in'},
        ]
        vm.catalogId = null;
        $scope.changeCatalog = function () {
            for (var i = 0;i < vm.catalogs.length;i++){
                if(vm.catalogs[i].id === vm.catalogId){
                    vm.data.catalog = angular.copy(vm.catalogs[i]);
                    return;
                }
            }
        }
        $scope.unitConversion = unit;
        function unit(item){
            if(vm.data.unit == 'mm'){
                vm.data.pageSizeW = MmTurnPx(vm.data.pageSizeW).toFixed(2) - 0;
                vm.data.pageSizeH = MmTurnPx(vm.data.pageSizeH).toFixed(2) - 0;
                vm.data.pageBloodT = MmTurnPx(vm.data.pageBloodT).toFixed(2) - 0;
                vm.data.pageBloodB = MmTurnPx(vm.data.pageBloodB).toFixed(2) - 0;
                vm.data.pageBloodL = MmTurnPx(vm.data.pageBloodL).toFixed(2) - 0;
                vm.data.pageBloodR = MmTurnPx(vm.data.pageBloodR).toFixed(2) - 0;
                vm.data.pageEdits.forEach(function (pageEdit) {
                    pageEdit.pageEditX = MmTurnPx(pageEdit.pageEditX).toFixed(2) - 0;
                    pageEdit.pageEditY = MmTurnPx(pageEdit.pageEditY).toFixed(2) - 0;
                    pageEdit.pageEditW = MmTurnPx(pageEdit.pageEditW).toFixed(2) - 0;
                    pageEdit.pageEditH = MmTurnPx(pageEdit.pageEditH).toFixed(2) - 0;
                })
            }
            if (vm.data.unit == 'in'){
                vm.data.pageSizeW = InTurnPx(vm.data.pageSizeW).toFixed(2) - 0;
                vm.data.pageSizeH = InTurnPx(vm.data.pageSizeH).toFixed(2) - 0;
                vm.data.pageBloodT = InTurnPx(vm.data.pageBloodT).toFixed(2) - 0;
                vm.data.pageBloodB = InTurnPx(vm.data.pageBloodB).toFixed(2) - 0;
                vm.data.pageBloodL = InTurnPx(vm.data.pageBloodL).toFixed(2) - 0;
                vm.data.pageBloodR = InTurnPx(vm.data.pageBloodR).toFixed(2) - 0;
                vm.data.pageEdits.forEach(function (pageEdit) {
                    pageEdit.pageEditX = InTurnPx(pageEdit.pageEditX).toFixed(2) - 0;
                    pageEdit.pageEditY = InTurnPx(pageEdit.pageEditY).toFixed(2) - 0;
                    pageEdit.pageEditW = InTurnPx(pageEdit.pageEditW).toFixed(2) - 0;
                    pageEdit.pageEditH = InTurnPx(pageEdit.pageEditH).toFixed(2) - 0;
                })
            }
            if(item == 'mm'){
                vm.data.pageSizeW = Math.round(PxTurnMm(vm.data.pageSizeW) - 0);
                vm.data.pageSizeH = Math.round(PxTurnMm(vm.data.pageSizeH) - 0);
                vm.data.pageBloodT = Math.round(PxTurnMm(vm.data.pageBloodT) - 0);
                vm.data.pageBloodB = Math.round(PxTurnMm(vm.data.pageBloodB) - 0);
                vm.data.pageBloodL = Math.round(PxTurnMm(vm.data.pageBloodL) - 0);
                vm.data.pageBloodR = Math.round(PxTurnMm(vm.data.pageBloodR) - 0);
                vm.data.pageEdits.forEach(function (pageEdit) {
                    pageEdit.pageEditX = Math.round(PxTurnMm(pageEdit.pageEditX) - 0);
                    pageEdit.pageEditY = Math.round(PxTurnMm(pageEdit.pageEditY) - 0);
                    pageEdit.pageEditW = Math.round(PxTurnMm(pageEdit.pageEditW) - 0);
                    pageEdit.pageEditH = Math.round(PxTurnMm(pageEdit.pageEditH) - 0);
                })
            }
            if(item == 'in'){
                vm.data.pageSizeW = PxTurnIn(vm.data.pageSizeW).toFixed(2) - 0;
                vm.data.pageSizeH = PxTurnIn(vm.data.pageSizeH).toFixed(2) - 0;
                vm.data.pageBloodT = PxTurnIn(vm.data.pageBloodT).toFixed(2) - 0;
                vm.data.pageBloodB = PxTurnIn(vm.data.pageBloodB).toFixed(2) - 0;
                vm.data.pageBloodL = PxTurnIn(vm.data.pageBloodL).toFixed(2) - 0;
                vm.data.pageBloodR = PxTurnIn(vm.data.pageBloodR).toFixed(2) - 0;
                vm.data.pageEdits.forEach(function (pageEdit) {
                    pageEdit.pageEditX = PxTurnIn(pageEdit.pageEditX).toFixed(2) - 0;
                    pageEdit.pageEditY = PxTurnIn(pageEdit.pageEditY).toFixed(2) - 0;
                    pageEdit.pageEditW = PxTurnIn(pageEdit.pageEditW).toFixed(2) - 0;
                    pageEdit.pageEditH = PxTurnIn(pageEdit.pageEditH).toFixed(2) - 0;
                })
            }
            vm.data.unit = item;
            vm.data.unit1 = item;
        }
        $scope.unitConversion1 = unit1;
        function unit1(item){
            vm.productList[vm.productSeq].parts.forEach(function (part) {
                for(var i=0; i<part.page.length; i++){
                    var _data = part.page[i];
                    if(vm.data.unit == 'mm'){
                        _data.pageSizeW = MmTurnPx(_data.pageSizeW).toFixed(2) - 0;
                        _data.pageSizeH = MmTurnPx(_data.pageSizeH).toFixed(2) - 0;
                        _data.pageBloodT = MmTurnPx(_data.pageBloodT).toFixed(2) - 0;
                        _data.pageBloodB = MmTurnPx(_data.pageBloodB).toFixed(2) - 0;
                        _data.pageBloodL = MmTurnPx(_data.pageBloodL).toFixed(2) - 0;
                        _data.pageBloodR = MmTurnPx(_data.pageBloodR).toFixed(2) - 0;
                        _data.pageEdits.forEach(function (pageEdit) {
                            pageEdit.pageEditX = MmTurnPx(pageEdit.pageEditX).toFixed(2) - 0;
                            pageEdit.pageEditY = MmTurnPx(pageEdit.pageEditY).toFixed(2) - 0;
                            pageEdit.pageEditW = MmTurnPx(pageEdit.pageEditW).toFixed(2) - 0;
                            pageEdit.pageEditH = MmTurnPx(pageEdit.pageEditH).toFixed(2) - 0;
                        })
                    }
                    if (vm.data.unit == 'in'){
                        _data.pageSizeW = InTurnPx(_data.pageSizeW).toFixed(2) - 0;
                        _data.pageSizeH = InTurnPx(_data.pageSizeH).toFixed(2) - 0;
                        _data.pageBloodT = InTurnPx(_data.pageBloodT).toFixed(2) - 0;
                        _data.pageBloodB = InTurnPx(_data.pageBloodB).toFixed(2) - 0;
                        _data.pageBloodL = InTurnPx(_data.pageBloodL).toFixed(2) - 0;
                        _data.pageBloodR = InTurnPx(_data.pageBloodR).toFixed(2) - 0;
                        _data.pageEdits.forEach(function (pageEdit) {
                            pageEdit.pageEditX = InTurnPx(pageEdit.pageEditX).toFixed(2) - 0;
                            pageEdit.pageEditY = InTurnPx(pageEdit.pageEditY).toFixed(2) - 0;
                            pageEdit.pageEditW = InTurnPx(pageEdit.pageEditW).toFixed(2) - 0;
                            pageEdit.pageEditH = InTurnPx(pageEdit.pageEditH).toFixed(2) - 0;
                        })
                    }
                    if(item == 'mm'){
                        _data.pageSizeW = Math.round(PxTurnMm(_data.pageSizeW) - 0);
                        _data.pageSizeH = Math.round(PxTurnMm(_data.pageSizeH) - 0);
                        _data.pageBloodT = Math.round(PxTurnMm(_data.pageBloodT) - 0);
                        _data.pageBloodB = Math.round(PxTurnMm(_data.pageBloodB) - 0);
                        _data.pageBloodL = Math.round(PxTurnMm(_data.pageBloodL) - 0);
                        _data.pageBloodR = Math.round(PxTurnMm(_data.pageBloodR) - 0);
                        _data.pageEdits.forEach(function (pageEdit) {
                            pageEdit.pageEditX = Math.round(PxTurnMm(pageEdit.pageEditX) - 0);
                            pageEdit.pageEditY = Math.round(PxTurnMm(pageEdit.pageEditY) - 0);
                            pageEdit.pageEditW = Math.round(PxTurnMm(pageEdit.pageEditW) - 0);
                            pageEdit.pageEditH = Math.round(PxTurnMm(pageEdit.pageEditH) - 0);
                        })
                    }
                    if(item == 'in'){
                        _data.pageSizeW = PxTurnIn(_data.pageSizeW).toFixed(2) - 0;
                        _data.pageSizeH = PxTurnIn(_data.pageSizeH).toFixed(2) - 0;
                        _data.pageBloodT = PxTurnIn(_data.pageBloodT).toFixed(2) - 0;
                        _data.pageBloodB = PxTurnIn(_data.pageBloodB).toFixed(2) - 0;
                        _data.pageBloodL = PxTurnIn(_data.pageBloodL).toFixed(2) - 0;
                        _data.pageBloodR = PxTurnIn(_data.pageBloodR).toFixed(2) - 0;
                        _data.pageEdits.forEach(function (pageEdit) {
                            pageEdit.pageEditX = PxTurnIn(pageEdit.pageEditX).toFixed(2) - 0;
                            pageEdit.pageEditY = PxTurnIn(pageEdit.pageEditY).toFixed(2) - 0;
                            pageEdit.pageEditW = PxTurnIn(pageEdit.pageEditW).toFixed(2) - 0;
                            pageEdit.pageEditH = PxTurnIn(pageEdit.pageEditH).toFixed(2) - 0;
                        })
                    }
                }
            })
            vm.data.unit = item;
            vm.data.unit1 = item;
        }
        js_getDPI()
        function js_getDPI() {
            var arrDPI = new Array();
            if (window.screen.deviceXDPI != undefined) {
                arrDPI[0] = window.screen.deviceXDPI;
                arrDPI[1] = window.screen.deviceYDPI;
            }
            else {
                var tmpNode = document.createElement("DIV");
                tmpNode.style.cssText = "width:1in;height:1in;position:absolute;left:0px;top:0px;z-index:99;visibility:hidden";
                document.body.appendChild(tmpNode);
                arrDPI[0] = parseInt(tmpNode.offsetWidth);
                arrDPI[1] = parseInt(tmpNode.offsetHeight);
                tmpNode.parentNode.removeChild(tmpNode);
            }
            vm.windowDpi = arrDPI[0];
            return arrDPI;
        };

        $scope.addPageEdit = function (pageEdits) {
            pageEdits.push({
                pageEditX:'',
                pageEditY:'',
                pageEditW:'',
                pageEditH:''
            })
        }
        $scope.removePageEdit = function(index,pageEdits){
            pageEdits.splice(index, 1);
        };
        vm.replaces = [
            {id: true, value: '可替换'},
            {id: false, value: '不可替换'}
        ]
        vm.addpages = [
            {id: true, value: '可加页'},
            {id: false, value: '不可加页'}
        ];
        vm.isMonth = false;
        vm.dateformat = 'yyyy/MM';
        $scope.options = {minMode:'month'};

        //预览图
        window.uploadPic = function ($event) {
            var files = $event.target.files;
            if (files != null && files.length > 0) {
                qiniuUpload(files[0]);
            }
        }
        function qiniuUpload(file) {
            var formData = new FormData();
            formData.append('file', file);
            formData.append('unique_names', false);
            formData.append('key', 'template-' + UidService.get());
            formData.append('token', vm.token);
            $.ajax({
                cache: true,
                type: "POST",
                url: 'https://upload.qiniup.com/',
                data: formData,
                async: true,
                contentType: false,
                processData: false,
                success: function (data) {
                    vm.data.cover = data.key;
                    $scope.$apply();
                },
                error: function (request) {
                    MessageService.error("图片上传失败");
                }
            });
        }
        $scope.removeFile = function () {
            vm.data.cover = "";
        }
        $scope.thingPartCb = function(index){
            vm.thingPart = vm.productList[vm.productSeq].parts[index];
            vm.thingPart.pageIndex = 0;
            vm.thingPart.partIndex = index;
        }
        vm.reuse = function(){
            var _page = angular.copy(vm.productList[vm.productSeq].parts[vm.thingPart.partIndex].page[vm.thingPart.pageIndex]);
            vm.productList[vm.productSeq].parts.forEach(function (part) {
                part.page.forEach(function (page) {
                    page.pageSizeH = angular.copy(_page.pageSizeH);
                    page.pageSizeW = angular.copy(_page.pageSizeW);
                    page.pageBloodT = angular.copy(_page.pageBloodT);
                    page.pageBloodB = angular.copy(_page.pageBloodB);
                    page.pageBloodL = angular.copy(_page.pageBloodL);
                    page.pageBloodR = angular.copy(_page.pageBloodR);
                    page.pageEdits = angular.copy(_page.pageEdits);
                    page.mould = angular.copy(_page.mould);
                })
            })
        }
        //关联模型
        vm.selectModel = selectModel;
        function selectModel(data){
            $uibModal.open({
                templateUrl: 'app/entities/page/modal/model-select.html',
                controller: 'ModelSelectController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'lg',
                resolve: {
                    entity: [function() {
                        return {
                            type: 'add',
                            data: data,
                            modelType:'TWO'
                        };
                    }]
                }
            }).result.then(function(res) {
                if(res){
                    res.modelPic = vm.url + res.modelPic;
                    data.mould = res;
                }
            });
        }
        //编辑模型
        vm.selectModelEdit = selectModelEdit;
        function selectModelEdit(data){
            $uibModal.open({
                templateUrl: 'app/entities/page/modal/model-select.html',
                controller: 'ModelSelectController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'lg',
                resolve: {
                    entity: [function() {
                        return {
                            type: 'edit',
                            data: data,
                            modelType:'TWO'
                        };
                    }]
                }
            }).result.then(function(res) {
                if(res){
                    res.modelPic = vm.url + res.modelPic;
                    data.mould = res;
                }
            });
        }
        //3D模型
        vm.modelPathTab = modelPathTab;
        vm.modelPathTabEdit = modelPathTabEdit;
        function modelPathTab() {
            $uibModal.open({
                templateUrl: 'app/entities/page/modal/model-select.html',
                controller: 'ModelSelectController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'lg',
                resolve: {
                    entity: [function() {
                        return {
                            type: 'add',
                            data: vm.data,
                            modelType:'THREE'
                        };
                    }]
                }
            }).result.then(function(res) {
                if(res){
                    vm.data.modelName= res.name;
                    vm.data.modelPic= res.modelPic;
                    vm.data.modelData= res.modelData;
                    vm.data.modelPath= res.modelPath;
                    vm.data.mould= res;
                    modelDataInfo(vm.data.modelData);
                }
            });
        }
        function modelPathTabEdit() {
            $uibModal.open({
                templateUrl: 'app/entities/page/modal/model-select.html',
                controller: 'ModelSelectController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'lg',
                resolve: {
                    entity: [function() {
                        return {
                            type: 'edit',
                            data: vm.data,
                            modelType:'THREE'
                        };
                    }]
                }
            }).result.then(function(res) {
                if(res){
                    vm.data.modelName= res.name;
                    vm.data.modelPic= res.modelPic;
                    vm.data.modelData= res.modelData;
                    vm.data.modelPath= res.modelPath;
                    vm.data.mould= res;
                    modelDataInfo(vm.data.modelData);
                }
            });
        }
        function modelDataInfo(item) {
            vm.modelData = JSON.parse(item);
        }
        //配色管理
        $scope.modelBlendentAdd = function () {
            if(!vm.data.modelPath) return MessageService.error("请先关联模型");
            if(!vm.data.modelBlendent){
                vm.data.modelBlendent = [];
            }
            vm.data.modelBlendent.push({
                name:'',
                modelData:angular.copy(vm.modelData),
                uuid:getUuid(16, 16),
                cancelled: false,
            })
        }
        $scope.modelBlendentSet = function (data) {
            vm.modelData.forEach(function (modelData2){
                data.modelData.forEach(function (modelData1){
                    if(modelData1.materialName == modelData2.materialName){
                        modelData1.page = modelData2.page;
                        if(modelData1.page>0 || modelData1.page === 0){
                            modelData1.color = null;
                        }
                    }
                })
            })
            $uibModal.open({
                templateUrl: 'app/entities/page/modal/blendent-modal.html',
                controller: 'BlendentModalController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'lg',
                resolve: {
                    entity: [function() {
                        return {
                            modelData: data.modelData,
                            modelPath: vm.data.modelPath
                        };
                    }]
                }
            }).result.then(function(res) {
                if(res){
                    data.modelData = res;
                }
            });
        }
        $scope.removeModelBlendent = function (index) {
            vm.data.modelBlendent.splice(index, 1)
        }
        vm.cancel = function () {
            $uibModalInstance.close();
        }
        vm.save = function () {
            var _data = angular.copy(vm.data);
            if(!_data.name){
                MessageService.error("模板名称不能为空");
                return
            }
            if(_data.addpage){
                if(!_data.minpage || !_data.maxpage){
                    MessageService.error("页数范围必须大于0");
                    return
                }
                if(_data.minpage > _data.maxpage){
                    MessageService.error("结束页数不能小于开始页数，请重新设置页数范围");
                    return
                }
                if(!_data.addunit){
                    MessageService.error("加页单位必须大于0");
                    return
                }
            }
            $scope.template.pages.page=[];
            $scope.template.config.parts.list=[];
            var _seq = 0;
            if(vm.productList[vm.productSeq].id == 'BOOK' || vm.productList[vm.productSeq].id == 'CALENDAR' || vm.productList[vm.productSeq].id == 'PHOTO'){
                if(vm.productList[vm.productSeq].id == 'CALENDAR' && _data.photoType == 'dynamic'){
                    _data.month = $("#startTime").val();
                    if(!_data.month){
                        MessageService.error("开始月份不能为空");
                        return;
                    }
                }
                if (!_data.pageSizeW || !_data.pageSizeH) {
                    return MessageService.error("请填写画布尺寸");
                }
                if(!checkFloatNum(_data.pageSizeW) || !checkFloatNum(_data.pageSizeH)){
                    MessageService.error("请填写正确的画布尺寸");
                    return
                }
                if(!_data.catalog){
                    MessageService.error("请选择模板分类");
                    return
                }
                if (!_data.pageBloodT || !_data.pageBloodB || !_data.pageBloodL || !_data.pageBloodR) {
                    MessageService.error("请填写出血尺寸");
                    return
                }
                if(!checkFloatNum(_data.pageBloodT) || !checkFloatNum(_data.pageBloodB) || !checkFloatNum(_data.pageBloodL) || !checkFloatNum(_data.pageBloodR)){
                    MessageService.error("请填写正确的出血尺寸");
                    return
                }
                // for(var i=0; i<_data.pageEdits.length; i++){
                //     var pageEdit = _data.pageEdits[i];
                //     if(!checkFloatNum(pageEdit.pageEditX) || !checkFloatNum(pageEdit.pageEditY) || !checkFloatNum(pageEdit.pageEditW) || !checkFloatNum(pageEdit.pageEditH)){
                //         MessageService.error("请填写正确的编辑区域");
                //         return false
                //     }
                // }
                if(vm.productList[vm.productSeq].id == 'BOOK' || (vm.productList[vm.productSeq].id == 'CALENDAR' && _data.photoType == 'ordinary')){
                    if(_data.replace === "" || _data.replace === null){
                        MessageService.error("请选择模板替换");
                        return false
                    }
                }
                if(vm.productList[vm.productSeq].id == 'BOOK'){
                    if(!_data.pageCount){
                        MessageService.error("内页页数不能为空");
                        return
                    }
                    if(!checkFloatNum(_data.pageCount)){
                        MessageService.error("请填写正确的内页页数");
                        return
                    }
                }
                if(_data.unit1 == 'px'){
                    unit('mm');
                }
                var editSize = [];
                _data.pageEdits.forEach(function (editbox) {
                    editSize.push({
                        height: editbox.pageEditH,
                        width: editbox.pageEditW,
                        x: editbox.pageEditX,
                        y: editbox.pageEditY
                    })
                });
                var _page1 = createPage(_data, editSize);
                if(vm.productList[vm.productSeq].id == 'BOOK'){
                    vm.productList[vm.productSeq].parts.forEach(function (part) {
                        if(part.selected){
                            $scope.template.config.parts.list.push({
                                "bleed":{
                                    "bottom":_data.pageBloodB,
                                    "left":_data.pageBloodL,
                                    "right":_data.pageBloodR,
                                    "top":_data.pageBloodT
                                },
                                "editboxes":_page1.editboxes,
                                "mediabox":_page1.mediabox,
                                "counter":part.id == 'P' ? _data.pageCount : part.counter,
                                "id":part.id,
                                "name":part.name,
                                "required":part.required,
                                "seq":part.seq,
                                "spread":_data.spread
                            })
                            if(part.id == 'P'){
                                for(var i=0; i<_data.pageCount; i++){
                                    _page1.seq = _seq;
                                    _page1.uuid= UidService.get();
                                    _page1.config={
                                        "dynamic":false,
                                        "monthIndex":0,
                                        "monthMultiple":false,
                                        "partid":part.id
                                    }
                                    $scope.template.pages.page.push(angular.copy(_page1));
                                    _seq++
                                }
                            }else{
                                _page1.seq = _seq;
                                _page1.uuid= UidService.get();
                                _page1.config={
                                    "dynamic":false,
                                    "monthIndex":0,
                                    "monthMultiple":false,
                                    "partid":part.id
                                }
                                $scope.template.pages.page.push(angular.copy(_page1));
                                _seq++
                            }
                        }
                    })
                }
                if(vm.productList[vm.productSeq].id == 'PHOTO'){
                    $scope.template.config.parts.list.push({
                        "bleed":{
                            "bottom":_data.pageBloodB,
                            "left":_data.pageBloodL,
                            "right":_data.pageBloodR,
                            "top":_data.pageBloodT
                        },
                        "editboxes":_page1.editboxes,
                        "mediabox":_page1.mediabox,
                        "counter":1,
                        "id":"P0",
                        "name":"正面",
                        "required":true,
                        "seq":0
                    })
                    _page1.seq = _seq;
                    _page1.uuid= UidService.get();
                    _page1.config={
                        "dynamic":false,
                        "monthIndex":0,
                        "monthMultiple":false,
                        "partid":"P0"
                    }
                    $scope.template.pages.page.push(angular.copy(_page1));
                    _seq++
                    if($scope.typeReturn() == "P1"){
                        $scope.template.config.parts.list.push({
                            "bleed":{
                                "bottom":_data.pageBloodB,
                                "left":_data.pageBloodL,
                                "right":_data.pageBloodR,
                                "top":_data.pageBloodT
                            },
                            "editboxes":_page1.editboxes,
                            "mediabox":_page1.mediabox,
                            "counter":1,
                            "id":"P1",
                            "name":"反面",
                            "required":false,
                            "seq":1
                        })
                        _page1.seq = _seq;
                        _page1.uuid= UidService.get();
                        _page1.config={
                            "dynamic":false,
                            "monthIndex":0,
                            "monthMultiple":false,
                            "partid":"P1"
                        }
                        $scope.template.pages.page.push(angular.copy(_page1));
                        _seq++
                    }
                }
                if(vm.productList[vm.productSeq].id == 'CALENDAR'){
                    var _list = {
                        "bleed":{
                            "bottom":_data.pageBloodB,
                            "left":_data.pageBloodL,
                            "right":_data.pageBloodR,
                            "top":_data.pageBloodT
                        },
                        "editboxes":_page1.editboxes,
                        "mediabox":_page1.mediabox,
                        "counter":1,
                        "id":"B1",
                        "name":"封面",
                        "required":false,
                        "seq":0
                    }
                    $scope.template.config.parts.list.push(angular.copy(_list));
                    _page1.seq = _seq;
                    _page1.uuid= UidService.get();
                    _page1.config={
                        "dynamic":false,
                        "monthIndex":0,
                        "monthMultiple":false,
                        "partid":"B1"
                    }
                    $scope.template.pages.page.push(angular.copy(_page1));
                    _seq++;
                    if(_data.photoPage == "14"){
                        _list.name = "内页";
                        _list.counter=_data.photoPage-1;
                        _list.id = "P";
                        _list.seq = 1;
                        _list.required = true;
                        $scope.template.config.parts.list.push(angular.copy(_list));
                        for(var i=0; i<(_data.photoPage-1); i++){
                            var __page1 = angular.copy(_page1);
                            __page1.seq = _seq;
                            __page1.uuid= UidService.get();
                            __page1.config={
                                "dynamic":$scope.typeReturn() == 'dynamic' ? true : false,
                                "monthIndex":i,
                                "monthMultiple":false,
                                "partid":"P"
                            }
                            if(__page1.config.monthIndex>0&&$scope.typeReturn() == 'dynamic'){
                                __page1.levels.level=[];
                                if(vm.titleWidget){
                                    __page1.levels.level.push(getTitleWidget(1,vm.titleWidget,false,MmTurnPx(vm.data.pageBloodL),MmTurnPx(vm.data.pageBloodT)));
                                }
                                if(vm.monthWidget){
                                    var _y = vm.titleWidget && vm.titleWidget.height ? vm.titleWidget.height : 0;
                                    _y = Number(_y)+MmTurnPx(vm.data.pageBloodT);
                                    __page1.levels.level.push(getMonthWidget(2,vm.monthWidget,false,MmTurnPx(vm.data.pageBloodL),_y));
                                }
                            }
                            $scope.template.pages.page.push(angular.copy(__page1));
                            _seq++
                        }
                    }
                    if(_data.photoPage == "26"){
                        _list.name = "内页";
                        _list.counter=_data.photoPage-1;
                        _list.id = "P";
                        _list.seq = 1;
                        _list.required = true;
                        $scope.template.config.parts.list.push(angular.copy(_list));
                        for(var i=0; i<(_data.photoPage-1); i++){
                            var __page1 = angular.copy(_page1);
                            __page1.seq = _seq;
                            __page1.uuid= UidService.get();
                            var _i = i+1;
                            __page1.config={
                                "dynamic":($scope.typeReturn() == 'dynamic' && Math.ceil(_i/2)<13) ? true : false,
                                "monthIndex":Math.ceil(_i/2)<13?Math.ceil(_i/2):0,
                                "monthIndex1":i%2 === 1 ? Math.ceil(i/2) : 0,
                                "monthMultiple":false,
                                "partid":"P"
                            }
                            if(__page1.config.monthIndex1>0&&$scope.typeReturn() == 'dynamic'){
                                __page1.levels.level=[];
                                if(vm.titleWidget){
                                    __page1.levels.level.push(getTitleWidget(1,vm.titleWidget,false,MmTurnPx(vm.data.pageBloodL),MmTurnPx(vm.data.pageBloodT)));
                                }
                                if(vm.monthWidget){
                                    var _y = vm.titleWidget && vm.titleWidget.height ? vm.titleWidget.height : 0;
                                    _y = Number(_y)+MmTurnPx(vm.data.pageBloodT);
                                    __page1.levels.level.push(getMonthWidget(2,vm.monthWidget,false,MmTurnPx(vm.data.pageBloodL),_y));
                                }
                            }
                            $scope.template.pages.page.push(angular.copy(__page1));
                            _seq++
                        }
                        // _list.name = "封底";
                        // _list.counter=1;
                        // _list.id = "B2";
                        // _list.seq = 2;
                        // _list.required = false;
                        // $scope.template.config.parts.list.push(angular.copy(_list));
                        // _page1.seq = _seq;
                        // _page1.uuid= UidService.get();
                        // _page1.config={
                        //     "dynamic":false,
                        //     "monthIndex":0,
                        //     "monthMultiple":false,
                        //     "partid":"B2"
                        // }
                        // $scope.template.pages.page.push(angular.copy(_page1));
                        // _seq++;
                    }
                }
            }
            if(vm.productList[vm.productSeq].id == 'THING'){
                if(!_data.cover){
                    MessageService.error("请上传预览图");
                    return
                }
                if(!_data.catalog){
                    MessageService.error("请选择模板分类");
                    return
                }
                if(_data.replace === "" || _data.replace === null){
                    MessageService.error("请选择模板替换");
                    return false
                }
                if(_data.modelType == 'THREE'){
                    if(!_data.modelPath){
                        MessageService.error("请关联模型");
                        return
                    }
                }
                for(var i=0; i<vm.productList[vm.productSeq].parts.length; i++){
                    var _part = vm.productList[vm.productSeq].parts[i];
                    for(var j=0; j<_part.page.length; j++){
                        var _page = _part.page[j];
                        if (!_page.pageSizeW || !_page.pageSizeH) {
                            return MessageService.error(_part.name + "的第" + (j+1) + "页的尺寸不能为空");
                        }
                        if(!checkFloatNum(_page.pageSizeW) || !checkFloatNum(_page.pageSizeH)){
                            MessageService.error(_part.name + "的第" + (j+1) + "页的尺寸必须大于等于0");
                            return false
                        }
                        if (!_page.pageBloodT || !_page.pageBloodB || !_page.pageBloodL || !_page.pageBloodR) {
                            return MessageService.error(_part.name + "的第" + (j+1) + "页的出血尺寸不能为空");
                        }
                        if(!checkFloatNum(_page.pageBloodT) || !checkFloatNum(_page.pageBloodB) || !checkFloatNum(_page.pageBloodL) || !checkFloatNum(_page.pageBloodR)){
                            MessageService.error(_part.name + "的第" + (j+1) + "页的出血尺寸必须大于等于0");
                            return false
                        }
                        // if(!_page.pageEdits || _page.pageEdits.length == 0){
                        //     MessageService.error(_part.name + "的第" + (j+1) + "页的编辑区域不能为空");
                        //     return false
                        // }
                        // for(var k=0; k<_page.pageEdits.length; k++){
                        //     var _pageEdit = _page.pageEdits[k];
                        //     if(!checkFloatNum(_pageEdit.pageEditX) || !checkFloatNum(_pageEdit.pageEditY) || !checkFloatNum(_pageEdit.pageEditW) || !checkFloatNum(_pageEdit.pageEditH)){
                        //         MessageService.error(_part.name + "的第" + (j+1) + "页的编辑区域必须大于等于0");
                        //         return false
                        //     }
                        // }
                        if(_data.modelType == 'TWO' && !_page.mould){
                            MessageService.error(_part.name + "的第" + (j+1) + "页的模型不能为空");
                            return false
                        }
                    }
                }
                if(_data.unit1 == 'px'){
                    unit1('mm');
                }
                vm.productList[vm.productSeq].parts.forEach(function (part,partIndex) {
                    part.page.forEach(function (_page) {
                        var editSize = [];
                        _page.pageEdits.forEach(function (editbox) {
                            editSize.push({
                                height: editbox.pageEditH,
                                width: editbox.pageEditW,
                                x: editbox.pageEditX,
                                y: editbox.pageEditY
                            })
                        });
                        var _page1 = createPage(_page, editSize);
                        if (_page.mould) {
                            _page1.scene = {
                                background: {
                                    resource: {
                                        identifier: _page.mould.modelPic.indexOf('http') > -1 ? _page.mould.modelPic : vm.url + _page.mould.modelPic,
                                        provider: "qiniu"
                                    }
                                },
                                geometry: {
                                    width: _page.mould.gWidth,
                                    height: _page.mould.gHeight,
                                    x: 0,
                                    y: 0
                                },
                                imagebox: {
                                    geometry: {
                                        width: _page.mould.width,
                                        height: _page.mould.height,
                                        x: _page.mould.x,
                                        y: _page.mould.y
                                    },
                                    rotation: {angle: 0},
                                    transparency: 1,
                                },
                                hierarchy: _page.mould.hierarchy,
                                mouldid: _page.mould.id,
                                isScene: true,
                                scale: 1,
                                unit: "mm",
                                resource:{
                                    identifier: _page.mould.modelPic.indexOf('http') > -1 ? _page.mould.modelPic : vm.url + _page.mould.modelPic,
                                    provider: "qiniu"
                                }
                            }
                        }
                        $scope.template.config.parts.list.push({
                            "bleed":{
                                "bottom":_page.pageBloodB,
                                "left":_page.pageBloodL,
                                "right":_page.pageBloodR,
                                "top":_page.pageBloodT
                            },
                            "editboxes":_page1.editboxes,
                            "mediabox":_page1.mediabox,
                            "counter":part.page.length,
                            "id":part.id,
                            "name":part.name,
                            "required":false,
                            "seq":partIndex
                        })
                        _page1.seq = _seq;
                        _page1.uuid= UidService.get();
                        _page1.config={
                            partid:part.id,
                            "dynamic":false,
                            "monthIndex":0,
                            "monthMultiple":false,
                        }
                        $scope.template.pages.page.push(angular.copy(_page1));
                        _seq++
                    })
                })
            }
            vm.hashtags = '';
            if(_data.catalog.hashtags){
                for (var i = 0; i < _data.catalog.hashtags.length; i++) {
                    vm.hashtags += _data.catalog.hashtags[i].name + ','
                }
            }
            $scope.template.config.innerOffset = _data.innerOffset;
            $scope.template.config.productType = vm.productList[vm.productSeq].id;
            $scope.template.config.dynamic = $scope.typeReturn() == 'dynamic' ? true : false;
            if($scope.template.config.dynamic){
                $scope.template.config.startYear = (_data.month.split("-"))[0];
                $scope.template.config.startMonth = (_data.month.split("-"))[1];
            }
            $scope.template.replace = _data.replace;
            $scope.template.addpage = _data.addpage;
            $scope.template.minpage = _data.minpage;
            $scope.template.maxpage = _data.maxpage;
            $scope.template.addunit = _data.addunit;
            ProductXml.save({
                cover: _data.cover,
                document: $scope.template,
                replace: _data.replace,
                name: _data.name,
                catalogId: _data.catalog.id,
                catalogName: _data.catalog.name,
                version: '4.0',
                type: 'XML',
                productTemplateId: '',
                hashtags: vm.hashtags,
                modelBlendent: JSON.stringify(_data.modelBlendent),
                modelData: _data.modelType != "NONE" ? JSON.stringify(vm.modelData) : "",
                modelPath: _data.modelPath,
                modelType: _data.modelType,
                modelName: _data.modelName,
                modelPic: _data.modelPic,
                productType: vm.productList[vm.productSeq].id
            }, function (res) {
                vm.isSaving = false;
                $uibModalInstance.close();
                $state.go('page-my-suffix-edit', {id: res.id,new:1}, {reload: true})
            }, function () {
                vm.isSaving = false;
            });
        }
        $scope.template = {
            "addpage":false,
            "addunit":0,
            "maxpage":0,
            "minpage":0,
            "replace":"",
            "cover":"",
            backupPages:{
                list:[]
            },
            config:{
                innerOffset:0,
                parts:{
                    list:[]
                },
                productType:''
            },
            deletedPages:{
                page:[]
            },
            "frameConfigs":{
                "frameConfig":[]
            },
            pages: {
                page: []
            },
            "version":"4.0",
            transparency: 1,
            scene: null,
            pageI: 0,
            angle: 0,
            backup: false,
            spread: false,
            unreplace: false,
            letterspacing: 0,
            lineheight: 0,
            text: '',
            bgimgs: {bgimg: []},
            bgimgs2: {bgimg: []},
            masks: {mask: []},
            cliparts: {clipart: []},
            documentpics: {documentpic: []},
            showPic: false,
            psdFiles: {psdFile: []}
        };
        function createPage(_page, editSize) {
            var _page1 = {
                uuid: UidService.get(),
                isScene: false,
                bgImg: '',
                background: {resource: {},color:'#ffffff', type: "Color"},
                pagecover: {},
                levels: {
                    level:[]
                },
                barcode: {},
                qrcode: {},
                editbox: {
                        x:0,
                        y:0,
                        width: _page.pageSizeW,
                        height: _page.pageSizeH,
                    },
                editboxes: {
                    editbox: [
                        {
                            x:0,
                            y:0,
                            width: _page.pageSizeW,
                            height: _page.pageSizeH,
                        }
                    ]
                },
                mediabox: {
                    height: _page.pageSizeH,
                    width: _page.pageSizeW,
                },
                trimbox: {
                    height: _page.pageSizeH - Number(_page.pageBloodB) - Number(_page.pageBloodT),
                    width: _page.pageSizeW - Number(_page.pageBloodL) - Number(_page.pageBloodR),
                    x: _page.pageBloodL,
                    y: _page.pageBloodT
                },
                scale: 1,
                proportion: 1,
                seq: 0,
                spread: _page.spread,
                backup: false,
                unreplace: !vm.data.replace
            }
            return _page1;
        }

        $scope.removeMould = function(event){
            fn(event);
            vm.productList[vm.productSeq].parts[vm.thingPart.partIndex].page[vm.thingPart.pageIndex].mould = null;
        }


        $scope.addPageTppltip = $sce.trustAsHtml('<div style="text-align:left;"><span>决定用户使用模板时，内页<br>部件是否可加页；加页功能<br>仅限API商户使用。</span></div>');
        $scope.replaceTppltip = $sce.trustAsHtml('<div style="text-align:left;"><span style="text-align:left;">决定用户使用模板时，内页<br>是否可替换以及排序。</span></div>');
    }
})();

(function () {
    'use strict';

    angular
        .module('platformApp')
        .controller('ReferenceController', ReferenceController);

    ReferenceController.$inject = ['$scope', '$uibModalInstance', '$state', '$stateParams','pages', 'MessageService'];

    function ReferenceController($scope, $uibModalInstance, $state, $stateParams, pages, MessageService) {
        var vm = this;
        vm.clear = clear;
        vm.save = save;
        vm.dpiChoose = [{data: 'mm', id: 0}, {data: 'px', id: 1}, {data: '英寸', id: 2}];
        vm.dpi = vm.dpiChoose[0];
        vm.dpi1 = vm.dpiChoose[0];
        vm.direction = 'y';
        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        $scope.updateDpi = function (data) {
            if(vm.dpi.id == 1){
                vm.place = PxTurnMm(vm.place);
            }else if(vm.dpi.id == 2){
                vm.place = InTurnMm(vm.place);
            }
            if (data.id == 1) {
                vm.place = MmTurnPx(vm.place);
            } else if(data.id == 2) {
                vm.place = MmTurnIn(vm.place);
            }
            vm.dpi = data;
        }

        function save() {
            if (!vm.place) {
                MessageService.error("请输入位置");
                return;
            }
            $scope.updateDpi(vm.dpiChoose[1]);
            $uibModalInstance.close({
                direction:vm.direction,
                place:vm.place
            });
        }

    }

})();

(function() {
    'use strict';

    angular
        .module('platformApp')
        .controller('RecommendLookController', RecommendLookController);

    RecommendLookController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', '$state', 'MessageService'];

    function RecommendLookController ($timeout, $scope, $stateParams, $uibModalInstance, entity, $state, MessageService) {
        var vm = this;
        vm.cancel = cancel;
        vm.url = entity.url;

        //返回
        function cancel() {
            $uibModalInstance.close();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('platformApp')
        .controller('PsdUploadController', PsdUploadController);

    PsdUploadController.$inject = ['Auth', 'Principal', '$scope', '$q', 'MessageService', '$state', '$uibModalInstance','PsdTemplateLoader','UidService','entity','ClipArts','SourceMaterial','$timeout'];

    function PsdUploadController (Auth, Principal, $scope, $q, MessageService, $state, $uibModalInstance,PsdTemplateLoader,UidService,entity,ClipArts,SourceMaterial,$timeout) {
        var vm = this;
        var errorPsdIndex = 0, upPsdNum = 0;
        vm.psdFiles = [];
        vm.templatePsdFiles = [];
        vm.isCanUpload = true;
        vm.defaultFont = entity.defaultFont;
        vm.token = entity.token;
        vm.url = entity.url;
        vm.showMasks = entity.showMasks;

        $(document).ready(function () {
            if (window.history && window.history.pushState) {
                $(window).on("popstate", function () {
                    // clear();
                });
            }
            //文件拖曳上传
            $("#upload-psd-box").bind("dragenter", function (event) {
                event.preventDefault();
            });
            $("#upload-psd-box").bind("dragover", function (event) {
                event.preventDefault();
            });
            $("#upload-psd-box").bind("drop", function (event) {
                event.preventDefault();
                var files = event.originalEvent.dataTransfer.files;
                for (var i = 0; i < files.length; i++) {
                    var file = files[i];
                    if (file.size < 100) {
                        MessageService.error(file.name + "不是有效的psd文件");
                        continue;
                    }
                    file.status = 'wait';
                    vm.psdFiles.push(file);
                }
                $scope.$digest();
            });
        });
        window.uploadPsd = function ($event) {
            for (var i = 0; i < $event.target.files.length; i++) {
                var file = $event.target.files[i];
                if (file.size < 100) {
                    MessageService.error(file.name + "不是有效的psd文件");
                    continue;
                }
                file.status = 'wait';
                vm.psdFiles.push(file);
            }
            $scope.$digest();
        };
        $scope.savePsdFile = function () {
            if (!vm.isCanUpload) {
                return
            }
            if (vm.psdFiles.length > 0) {
                errorPsdIndex = 0;
                upPsdNum = 0;
                vm.isCanUpload = false;
                for (var i = 0; i < vm.psdFiles.length; i++) {
                    if (vm.psdFiles[i].status != 'success') {
                        vm.psdFiles[i].status = 'loading';
                        loadPsdFile(vm.psdFiles[i], i)
                    }
                }
            } else {
                MessageService.notice("请选择文件");
            }
        }
        function loadPsdFile(file, i) {
            PsdTemplateLoader.loadPsdFile(file).then(function (template) {
                // console.log("i: "+i)
                // console.log('template', template);
                file.status = 'success';
                template.name = file.name;
                processPsdToArtclipAndTemplate(template);
                var haveCompressed = false;
                for (var i = 0; i < template.layers.length; i++) {
                    var layer = template.layers[i];
                    if (layer.compressed) {
                        haveCompressed = true;
                        break;
                    }
                }
                if (haveCompressed) {
                    MessageService.notice("PSD文件中有素材超过20MB, 已被压缩处理");
                }
                MessageService.success("PSD文件解析完成, 正在处理素材...");
            }, function (err) {
                errorPsdIndex++;
                upPsdNum++;
                file.status = 'error';
                if (upPsdNum == vm.psdFiles.length) {
                    vm.isCanUpload = true;
                }
            });
        }
        function processPsdToArtclipAndTemplate(psdTemplate) {
            var template = psdTemplate;
            var promise_list = [];
            // for PSD cover image
            promise_list.push(uploadPsdCoverImage(template));
            for (var i = 0; i < template.layers.length; i++) {
                var layer = template.layers[i];
                if (layer.type === 'Image' && layer.imageData) {
                    promise_list.push(updatePsdLayerImage(layer));
                    if (layer.hasMask && layer.mask) {
                        promise_list.push(uploadPsdLayerMask(layer.mask));
                    }
                } else if (layer.type === 'Text') {
                    // layer.style.family = vm.defaultFont.family;
                }
            }

            // console.log(promise_list)
            // 等待上传封面图喝创建素材
            $q.all(promise_list).then(function () {
                console.log(template);
                var _data = {
                    cover: {
                        identifier: template.imageUrl,
                        provider: 'qiniu'
                    },
                    name: template.name,
                    data: JSON.stringify(template)
                }
                upPsdNum++;
                vm.templatePsdFiles.push(_data);
                if (!errorPsdIndex) {
                    // vm.psdUploadShow = false;
                }
                if (upPsdNum == vm.psdFiles.length) {
                    vm.isCanUpload = true;
                    vm.psdUploadShow = false;
                    $uibModalInstance.close(vm.templatePsdFiles);
                }
            });
        }
        function uploadPsdCoverImage(psdTemplate) {
            var template = psdTemplate;

            var deferred = $q.defer();

            var blob = dataURLtoBlob(template.imageData);

            var formData = new FormData();
            formData.append('file', blob);
            formData.append('key', 'thumbnail-' + UidService.get());
            formData.append('token', vm.token);
            $.ajax({
                cache: true,
                type: "POST",
                url: 'https://upload.qiniup.com/',
                data: formData,
                async: true,
                contentType: false,
                processData: false,
                success: function (data) {
                    template.imageKey = data.key;
                    template.imageUrl = vm.url + data.key;
                    template.imageData = null;

                    deferred.resolve(template);
                },
                error: function (request) {
                    console.log("error");
                    deferred.reject('err');
                }
            });

            return deferred.promise;
        }
        function updatePsdLayerImage(psdLayer) {
            var layer = psdLayer;

            var deferred = $q.defer();

            var blob = dataURLtoBlob(layer.imageData);
            var formData = new FormData();
            formData.append('file', blob);
            formData.append('key', 'clipArt-' + UidService.get());
            formData.append('token', vm.token);
            $.ajax({
                cache: true,
                type: "POST",
                url: 'https://upload.qiniup.com/',
                data: formData,
                async: true,
                contentType: false,
                processData: false,
                success: function (data) {
                    layer.imageKey = data.key;
                    layer.imageUrl = vm.url + data.key;
                    layer.imageData = null;

                    ClipArts.createOne({
                        identifier: data.key,
                        provider: 'qiniu',
                        themeClassifyId: ''
                    }, function (resp) {
                        vm.totalClipartItems = vm.totalClipartItems - 0 + 1;
                        deferred.resolve(layer);
                    }, function (err) {
                        deferred.reject('err');
                    });

                },
                error: function (request) {
                    console.log("error");
                    deferred.reject('err');
                }
            });

            return deferred.promise;
        }
        function uploadPsdLayerMask(layerMask) {
            var layer = layerMask;

            var deferred = $q.defer();

            var blob = dataURLtoBlob(layer.imageData);
            var formData = new FormData();
            formData.append('file', blob);
            formData.append('key', 'mask-' + UidService.get());
            formData.append('token', vm.token);
            $.ajax({
                cache: true,
                type: "POST",
                url: 'https://upload.qiniup.com/',
                data: formData,
                async: true,
                contentType: false,
                processData: false,
                success: function (data) {
                    layer.imageKey = data.key;
                    layer.imageUrl = vm.url + data.key;
                    layer.imageData = null;

                    var arr = {
                        resource: {
                            identifier: vm.url + data.key,
                            provider: 'qiniu'
                        },
                        identifier: vm.url + data.key,
                        provider: 'qiniu',
                        bgImg: '',
                        type: 'User',
                        isRecommend: false
                    }

                    SourceMaterial.createOne({
                        identifier: data.key,
                        provider: 'qiniu',
                        type: 'User'
                    }, function (resp) {
                        arr.id = resp.id;
                        vm.showMasks.mask.unshift(arr);
                        deferred.resolve(layer);
                    }, function (err) {
                        deferred.reject('err');
                    });

                },
                error: function (request) {
                    console.log("error");
                    deferred.reject('err');
                }
            });

            return deferred.promise;
        }
        $scope.deletePsd = function(index){
            vm.psdFiles.splice(index, 1);
        }
        vm.cancel = function () {
            if (!vm.isCanUpload) {
                MessageService.error("psd上传中");
                return
            }
            $uibModalInstance.dismiss();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('platformApp')
        .controller('PsdFontMappingController', PsdFontMappingController);

    PsdFontMappingController.$inject = ['Auth', 'Principal', '$scope', '$q', 'MessageService', '$state', '$uibModalInstance','UidService','$timeout', 'entity'];

    function PsdFontMappingController (Auth, Principal, $scope, $q, MessageService, $state, $uibModalInstance,UidService,$timeout, entity) {
        var vm = this;
        vm.fontList = entity.fontList || [];
        vm.psdFile = entity.psdFile || {};
        vm.psdData = JSON.parse(vm.psdFile.data);
        vm.fontMapping = { items: [] }
        if (vm.psdFile.fontMapping) {
        	vm.fontMapping = angular.copy(entity.psdFile.fontMapping) || { items: []}
    	}
        if (!vm.fontMapping) {
        	vm.fontMapping = {};
        }
        if (!vm.fontMapping.items) {
        	vm.fontMapping.items = [];
        }
        if (!vm.fontMapping.items.length) {
        	loadFromPsd();
        }

        vm.addFontItem = function() {
        	vm.fontMapping.items.push({
        		name: "",
        		fontId: null,
        		fontName: null,
        		fontUuid: null
        	});
        }

        vm.deleteFontItem = function($index) {
        	if ($index < 0 || $index >= vm.fontMapping.items.length) {
        		return;
        	}
        	vm.fontMapping.items.splice($index, 1);
        }

        vm.loadFromPsd = loadFromPsd;
        function loadFromPsd() {
        	if (vm.psdData && vm.psdData.layers) {
        		for (var i = 0; i < vm.psdData.layers.length; i++) {
        			var layer = vm.psdData.layers[i];
        			if (layer.type != "Text") {
        				continue;
        			}
        			var font = layer.style.font;
        			if (!font) {
        				continue;
        			}
        			var found = false;
        			for (var j = 0; j < vm.fontMapping.items.length; j++) {
        				var item = vm.fontMapping.items[j];
        				var itemName = item.name ? item.name.trim() : "";
        				if (font == itemName) {
        					found = true;
        					break;
        				}
        			}
        			if (!found) {
        				vm.fontMapping.items.push({
			        		name: font,
			        		fontId: null,
			        		fontName: null,
			        		fontUuid: null
			        	});
        			}
        		}
        	}
        }

        vm.onMappingItemChange = function ($index) {
        	if ($index < 0 || $index >= vm.fontMapping.items.length) {
        		return;
        	}
        	var item = vm.fontMapping.items[$index];
        	if (item.fontId) {
        		for (var i =0; i < vm.fontList.length; i++) {
        			var font = vm.fontList[i];
        			if (item.fontId == font.id) {
        				item.fontName = font.family;
        				item.fontUuid = font.uuid;
        				break;
        			}
        		}
        	}
        	else {
        		item.fontName = null;
        		item.fontUuid = null;
        	}
        }

        vm.save = function() {
        	if (vm.fontMapping.items.length > 0) {
        		for (var i = 0; i < vm.fontMapping.items.length; i++) {
        			var item = vm.fontMapping.items[i];
        			if (!item.name) {
        				MessageService.error("第" + (i + 1) + "个字体名称无效");
        				return
        			}
        			if (!item.fontId) {
        				MessageService.error("第" + (i + 1) + "个映射字体未选择");
        				return
        			}
        		}
        	}
        	$uibModalInstance.close(vm.fontMapping);
        }


        vm.cancel = function () {
            $uibModalInstance.dismiss();
        }

    }
})();
(function() {
    'use strict';

    angular
        .module('platformApp')
        .controller('PartEditController', PartEditController);

    PartEditController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', '$state', 'MessageService', 'Catalog','Qinius', '$q', 'UidService',
        '$uibModal','TitleWidget','MonthWidget','ProductXml','entity','Moulds'];

    function PartEditController ($timeout, $scope, $stateParams, $uibModalInstance, $state, MessageService, Catalog,Qinius, $q, UidService,
                                    $uibModal,TitleWidget,MonthWidget,ProductXml,entity,Moulds) {
        var vm = this;
        $scope.domains = Qinius.getDomain();
        vm.tokens = Qinius.get();
        vm.step = 1;
        vm.data = {
            unit:'mm',
            unit1:'mm',
            productType: entity.productType,
            modelData: entity.modelData&&entity.modelData!='undefined'?JSON.parse(entity.modelData):null,
            modelType: entity.modelType,
            part:angular.copy(entity.part),
            pageIndex:entity.pageIndex,
            modelName:entity.modelName,
            modelPic:entity.modelPic,
            parts:angular.copy(entity.parts)
        }
        vm.data.parts.forEach(function (part) {
            if(part.id == vm.data.part.id){
                part.selected = true;
            }
        })
        console.log(vm.data)
        vm.modelData = [];
        if(vm.data.modelData){
            vm.data.modelData.forEach(function (item) {
                if(item.page === "" || item.page === null || vm.data.pageIndex === item.page){
                    vm.modelData.push(item);
                    if(vm.data.pageIndex === item.page){
                        vm.materialName = item.materialName;
                        item.page="";
                    }
                }
            })
        }
        $q.all([$scope.domains.$promise, vm.tokens.$promise]).then(function () {
            vm.url = $scope.domains.domain;
            vm.token = vm.tokens.token;
            if (entity.mouldid){
                Moulds.getAllByCondition2({
                    items: [{key: "id", op: "=", value: entity.mouldid},
                        {key: "modelType", op: "=", value: "TWO"}],
                }, function (res) {
                    if(res.length>0){
                        res[0].modelPic = vm.url + res[0].modelPic;
                        vm.data.mould = res[0];
                    }
                }, function (error) {
                    MessageService.error("获取列表失败！");
                });
            }
        })
        vm.equalRatio = false;
        vm.isEqualRatio = false;
        $scope.$watch("vm.data.part.mediabox.width", function (newValue, oldValue) {
            if(vm.equalRatio && !vm.isEqualRatio){
                vm.isEqualRatio = true;
                vm.data.part.mediabox.height = newValue/oldValue * vm.data.part.mediabox.height || 0;
            }else{
                vm.isEqualRatio = false;
            }
        })
        $scope.$watch("vm.data.part.mediabox.height", function (newValue, oldValue) {
            if(vm.equalRatio && !vm.isEqualRatio){
                vm.isEqualRatio = true;
                vm.data.part.mediabox.width = newValue/oldValue * vm.data.part.mediabox.width || 0;
            }else{
                vm.isEqualRatio = false;
            }
        })
        //单位换算
        vm.units = [
            {name:'px', id:'px'},
            {name:'mm', id:'mm'},
            {name:'英寸', id:'in'},
        ]
        $scope.unitConversion = unit;
        function unit(item){
            if(vm.data.unit == 'mm'){
                vm.data.part.mediabox.width = MmTurnPx(vm.data.part.mediabox.width).toFixed(2) - 0;
                vm.data.part.mediabox.height = MmTurnPx(vm.data.part.mediabox.height).toFixed(2) - 0;
                vm.data.part.bleed.top = MmTurnPx(vm.data.part.bleed.top).toFixed(2) - 0;
                vm.data.part.bleed.bottom = MmTurnPx(vm.data.part.bleed.bottom).toFixed(2) - 0;
                vm.data.part.bleed.left = MmTurnPx(vm.data.part.bleed.left).toFixed(2) - 0;
                vm.data.part.bleed.right = MmTurnPx(vm.data.part.bleed.right).toFixed(2) - 0;
                vm.data.part.editboxes.editbox.forEach(function (pageEdit) {
                    pageEdit.x = MmTurnPx(pageEdit.x).toFixed(2) - 0;
                    pageEdit.y = MmTurnPx(pageEdit.y).toFixed(2) - 0;
                    pageEdit.width = MmTurnPx(pageEdit.width).toFixed(2) - 0;
                    pageEdit.height = MmTurnPx(pageEdit.height).toFixed(2) - 0;
                })
            }
            if (vm.data.unit == 'in'){
                vm.data.part.mediabox.width = InTurnPx(vm.data.part.mediabox.width).toFixed(2) - 0;
                vm.data.part.mediabox.height = InTurnPx(vm.data.part.mediabox.height).toFixed(2) - 0;
                vm.data.part.bleed.top = InTurnPx(vm.data.part.bleed.top).toFixed(2) - 0;
                vm.data.part.bleed.bottom = InTurnPx(vm.data.part.bleed.bottom).toFixed(2) - 0;
                vm.data.part.bleed.left = InTurnPx(vm.data.part.bleed.left).toFixed(2) - 0;
                vm.data.part.bleed.right = InTurnPx(vm.data.part.bleed.right).toFixed(2) - 0;
                vm.data.part.editboxes.editbox.forEach(function (pageEdit) {
                    pageEdit.x = InTurnPx(pageEdit.x).toFixed(2) - 0;
                    pageEdit.y = InTurnPx(pageEdit.y).toFixed(2) - 0;
                    pageEdit.width = InTurnPx(pageEdit.width).toFixed(2) - 0;
                    pageEdit.height = InTurnPx(pageEdit.height).toFixed(2) - 0;
                })
            }
            if(item == 'mm'){
                vm.data.part.mediabox.width = Math.round(PxTurnMm(vm.data.part.mediabox.width) - 0);
                vm.data.part.mediabox.height = Math.round(PxTurnMm(vm.data.part.mediabox.height) - 0);
                vm.data.part.bleed.top = Math.round(PxTurnMm(vm.data.part.bleed.top) - 0);
                vm.data.part.bleed.bottom = Math.round(PxTurnMm(vm.data.part.bleed.bottom) - 0);
                vm.data.part.bleed.left = Math.round(PxTurnMm(vm.data.part.bleed.left) - 0);
                vm.data.part.bleed.right = Math.round(PxTurnMm(vm.data.part.bleed.right) - 0);
                vm.data.part.editboxes.editbox.forEach(function (pageEdit) {
                    pageEdit.x = Math.round(PxTurnMm(pageEdit.x) - 0);
                    pageEdit.y = Math.round(PxTurnMm(pageEdit.y) - 0);
                    pageEdit.width = Math.round(PxTurnMm(pageEdit.width) - 0);
                    pageEdit.height = Math.round(PxTurnMm(pageEdit.height) - 0);
                })
            }
            if(item == 'in'){
                vm.data.part.mediabox.width = PxTurnIn(vm.data.part.mediabox.width).toFixed(2) - 0;
                vm.data.part.mediabox.height = PxTurnIn(vm.data.part.mediabox.height).toFixed(2) - 0;
                vm.data.part.bleed.top = PxTurnIn(vm.data.part.bleed.top).toFixed(2) - 0;
                vm.data.part.bleed.bottom = PxTurnIn(vm.data.part.bleed.bottom).toFixed(2) - 0;
                vm.data.part.bleed.left = PxTurnIn(vm.data.part.bleed.left).toFixed(2) - 0;
                vm.data.part.bleed.right = PxTurnIn(vm.data.part.bleed.right).toFixed(2) - 0;
                vm.data.part.editboxes.editbox.forEach(function (pageEdit) {
                    pageEdit.x = PxTurnIn(pageEdit.x).toFixed(2) - 0;
                    pageEdit.y = PxTurnIn(pageEdit.y).toFixed(2) - 0;
                    pageEdit.width = PxTurnIn(pageEdit.width).toFixed(2) - 0;
                    pageEdit.height = PxTurnIn(pageEdit.height).toFixed(2) - 0;
                })
            }
            vm.data.unit = item;
            vm.data.unit1 = item;
        }
        js_getDPI()
        function js_getDPI() {
            var arrDPI = new Array();
            if (window.screen.deviceXDPI != undefined) {
                arrDPI[0] = window.screen.deviceXDPI;
                arrDPI[1] = window.screen.deviceYDPI;
            }
            else {
                var tmpNode = document.createElement("DIV");
                tmpNode.style.cssText = "width:1in;height:1in;position:absolute;left:0px;top:0px;z-index:99;visibility:hidden";
                document.body.appendChild(tmpNode);
                arrDPI[0] = parseInt(tmpNode.offsetWidth);
                arrDPI[1] = parseInt(tmpNode.offsetHeight);
                tmpNode.parentNode.removeChild(tmpNode);
            }
            vm.windowDpi = arrDPI[0];
            return arrDPI;
        };

        $scope.addPageEdit = function () {
            vm.data.part.editboxes.editbox.push({
                x:'',
                y:'',
                width:'',
                height:''
            })
        };
        $scope.removePageEdit = function(index){
            vm.data.part.editboxes.editbox.splice(index, 1);
        };
        //关联模型
        vm.selectModel = selectModel;
        function selectModel(data){
            $uibModal.open({
                templateUrl: 'app/entities/page/modal/model-select.html',
                controller: 'ModelSelectController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'lg',
                resolve: {
                    entity: [function() {
                        return {
                            type: !data.mould ? 'add' : 'edit',
                            data: data,
                            modelType:'TWO'
                        };
                    }]
                }
            }).result.then(function(res) {
                if(res){
                    res.modelPic = vm.url + res.modelPic;
                    data.mould = res;
                }
            });
        }
        $scope.removeMould = function(e){
            vm.data.mould = null;
        }
        //编辑模型
        // vm.selectModelEdit = selectModelEdit;
        // function selectModelEdit(data){
        //     $uibModal.open({
        //         templateUrl: 'app/entities/page/modal/model-select.html',
        //         controller: 'ModelSelectController',
        //         controllerAs: 'vm',
        //         backdrop: 'static',
        //         size: 'lg',
        //         resolve: {
        //             entity: [function() {
        //                 return {
        //                     type: 'edit',
        //                     data: data,
        //                     modelType:'TWO'
        //                 };
        //             }]
        //         }
        //     }).result.then(function(res) {
        //         if(res){
        //             res.modelPic = vm.url + res.modelPic;
        //             data.mould = res;
        //         }
        //     });
        // }
        vm.cancel = function () {
            $uibModalInstance.close();
        }
        vm.next = function () {
            if(!vm.data.part.id){
                MessageService.error("请选择部件");
                return
            }
            vm.step = 2;
        };
        // vm.hint = '当前部件下所有页面都将应用新尺寸，相关部件备用页将被清空，是否确认修改?';
        vm.hint = '';
        vm.isEditbox = false;
        $scope.updateEditbox = function(){
            vm.isEditbox = true;
        }
        vm.isMediabox = false;
        $scope.updateMediabox = function(){
            vm.isMediabox = true;
        }
        vm.save = function () {
            if (!vm.data.part.name) {
                MessageService.error('部件名称不能为空');
                return
            }
            if(vm.isEditbox){
                vm.hint = '当前部件下所有页面都将应用新编辑区域，相关部件备用页将被清空，是否确认修改?';
            }
            if(vm.isMediabox){
                vm.hint = '当前部件下所有页面都将应用新尺寸，相关部件备用页将被清空，是否确认修改?';
            }
            var _data = vm.data;
            if(!checkFloatNum(_data.part.mediabox.width) || !checkFloatNum(_data.part.mediabox.height)){
                MessageService.error("请填写正确的画布尺寸");
                return
            }
            if(!checkFloatNum(_data.part.bleed.top) || !checkFloatNum(_data.part.bleed.bottom) || !checkFloatNum(_data.part.bleed.left) || !checkFloatNum(_data.part.bleed.right)){
                MessageService.error("请填写正确的出血尺寸");
                return
            }
            for(var i=0; i<_data.part.editboxes.editbox.length; i++){
                var pageEdit = _data.part.editboxes.editbox[i];
                if(!checkFloatNum(pageEdit.x) || !checkFloatNum(pageEdit.y) || !checkFloatNum(pageEdit.width) || !checkFloatNum(pageEdit.height)){
                    MessageService.error("请填写正确的编辑区域");
                    return false
                }
            }
            if(_data.modelType == 'TWO' && !_data.mould){
                MessageService.error("请选择模型");
                return false
            }
            if(_data.modelType == 'THREE'){
                if(!vm.materialName){
                    MessageService.error("请关联模型页");
                    return
                }
                var _modelData = angular.copy(_data.modelData);
                _modelData.forEach(function (modelItem) {
                    if(modelItem.materialName == vm.materialName){
                        modelItem.page = _data.pageIndex;
                    }
                })
                vm.modelData1 = JSON.stringify(_modelData);
            }
            if(_data.unit1 == 'px' || _data.unit1 == 'in'){
                unit('mm');
            }
            if (_data.mould) {
                _data.part.scene = {
                    background: {
                        resource: {
                            identifier: _data.mould.modelPic.indexOf('http') > -1 ? _data.mould.modelPic : vm.url + _data.mould.modelPic,
                            provider: "qiniu"
                        }
                    },
                    geometry: {
                        width: _data.mould.gWidth,
                        height: _data.mould.gHeight,
                        x: 0,
                        y: 0
                    },
                    imagebox: {
                        geometry: {
                            width: _data.mould.width,
                            height: _data.mould.height,
                            x: _data.mould.x,
                            y: _data.mould.y
                        },
                        rotation: {angle: 0},
                        transparency: 1,
                    },
                    hierarchy: _data.mould.hierarchy,
                    mouldid: _data.mould.id,
                    isScene: true,
                    scale: 1,
                    unit: "mm",
                    resource:{
                        identifier: _data.mould.modelPic.indexOf('http') > -1 ? _data.mould.modelPic : vm.url + _data.mould.modelPic,
                        provider: "qiniu"
                    }
                }
            }

            if(vm.isEditbox || vm.isMediabox){
                MessageService.confirm({
                    title:'温馨提示',
                    cancel:'取消',
                    confirm:'确认',
                    msg:vm.hint,
                },function(){
                    $uibModalInstance.close({data:_data.part,isDeleteBackupPages:true,modelData:vm.modelData1,parts:vm.data.parts});
                },function () {
                    $uibModalInstance.close();
                })
            }else{
                $uibModalInstance.close({data:_data.part,isDeleteBackupPages:false,modelData:vm.modelData1,parts:vm.data.parts});
            }
        }
        function checkFloatNum(str){
            str = Number(str);
            var reg_zs = /^[0-9]\d*(\.\d+)?$/i;
            if (!reg_zs.test(str)) {
                return false;
            }
            return true;
        }
        vm.partsListShow = false;
        vm.partsListX = 0;
        vm.partsListY = 0;
        var timer = null;
        $scope.mouseenter = function(){
            var view = document.getElementById("c-model-body-view");
            var div = document.getElementById("select-div");
            var x = div.offsetLeft;
            var y = view.offsetTop + div.offsetTop + 40;
            vm.partsListX = x;
            vm.partsListY = y;
            vm.partsListShow = true;
            if (timer !== null) {
                clearTimeout(timer)
            }
        }

        $scope.mouseleave = function(){
            if (timer !== null) {
                clearTimeout(timer)
            }
            timer = setTimeout(function () {
                $timeout(function () {
                    vm.partsListShow = false;
                })
            },100)
        }

        $scope.delete = function(item){
            item.selected = false;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('platformApp')
        .controller('PartAddController', PartAddController);

    PartAddController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', '$state', 'MessageService', 'Catalog','Qinius', '$q', 'UidService',
        '$uibModal','TitleWidget','MonthWidget','ProductXml','entity'];

    function PartAddController ($timeout, $scope, $stateParams, $uibModalInstance, $state, MessageService, Catalog,Qinius, $q, UidService,
                                    $uibModal,TitleWidget,MonthWidget,ProductXml,entity) {
        var vm = this;
        $scope.domains = Qinius.getDomain();
        vm.tokens = Qinius.get();
        $q.all([$scope.domains.$promise, vm.tokens.$promise]).then(function () {
            vm.url = $scope.domains.domain;
            vm.token = vm.tokens.token;
        })
        vm.data = {
            unit:'mm',
            unit1:'mm',
            productType: entity.productType,
            modelData: entity.modelData?angular.copy(JSON.parse(entity.modelData)):[],
            modelType: entity.modelType,
            modelName: entity.modelName,
            modelPic: entity.modelPic,
            parts:entity.parts,
            part:{
                counter:1,
                mediabox:{},
                bleed:{},
                editboxes:{
                    editbox:[
                        {x:"",y:"",width:"",height:"",}
                    ]
                },
            },
        }
        console.log(vm.data)
        vm.modelData = [];
        if(vm.data.modelData){
            vm.data.modelData.forEach(function (item) {
                if(item.page === "" || item.page === null){
                    vm.modelData.push(item);
                }
            })
        }
        vm.parts=[];
        if(vm.data.productType == "BOOK"){
            vm.parts=[
                {name:'腰封',id:'B4',seq:0,exist:false,custom:false,},
                {name:'护封',id:'B3',seq:1,exist:false,custom:false,},
                {name:'封面',id:'B1',seq:2,exist:false,custom:false,},
                {name:'内页',id:'P',seq:3,exist:false,custom:false,},
                {name:'封底',id:'B2',seq:4,exist:false,custom:false,}];
        }
        if(vm.data.productType == "PHOTO"){
            vm.parts=[
                {name:'正面',id:'P0',seq:0,exist:false,custom:false},
                {name:'反面',id:'P1',seq:1,exist:false,custom:false}];
        }
        if(vm.data.productType == "CALENDAR"){
            vm.parts=[
                {name:'封面',id:'B1',seq:2,exist:false,custom:false,},
                {name:'内页',id:'P',seq:3,exist:false,custom:false,},];
        }
        vm.data.parts.forEach(function (part) {
            var _exist = false;
            vm.parts.forEach(function (part1) {
                if(part.id == part1.id){
                    part1.exist = true;
                    _exist = true;
                    if((part.counter<1 || !part.counter)){
                        part1.exist = false;
                    }
                }
            })
            if(!_exist){
                vm.parts.push({
                    name:part.name,
                    id:part.id,
                    seq:part.seq,
                    exist:true,
                    custom:part.custom
                })
            }
        })
        $scope.partCb = function(item){
            if(item.exist){
                return
            }
            vm.data.part.custom = item.custom;
            vm.data.part.id = item.id;
            vm.data.part.name = item.name;
            vm.data.part.seq = item.seq;
            vm.data.part.required = false;
        }

        vm.isPart = false;
        $scope.addPart = function(){
            vm.part = "";
            vm.isPart = true;
            $timeout(function () {
                $("#partInput").focus();
            })
        }
        $scope.partNameChange = function(){
            var _seq = vm.parts[vm.parts.length-1] ? angular.copy(vm.parts[vm.parts.length-1].seq) : 10;
            vm.data.part.seq=angular.copy(_seq<9 ? 10 : (Number(_seq)+1));
            vm.data.part.id=UidService.get();
            vm.data.part.pageCount=1;
            vm.data.part.exist=false;
            vm.data.part.required= false;// 是否必需部件
            vm.data.part.custom= true; // 是否自定义部件
        }
        $scope.partBlur = function(){
            if(vm.part){
                var _seq = vm.parts[vm.parts.length-1] ? angular.copy(vm.parts[vm.parts.length-1].seq) : 10;
                vm.parts.push({
                    seq:angular.copy(_seq<9 ? 10 : (Number(_seq)+1)),
                    name: vm.part,
                    id:UidService.get(),
                    pageCount:1,
                    exist:false,
                    required: false,// 是否必需部件
                    custom: true, // 是否自定义部件
                })
                $scope.partCb(vm.parts[vm.parts.length-1])
            }
            vm.part = "";
            vm.isPart = false;
        }
        $scope.deletePart = function(index){
            vm.parts.splice(index,1);
        }

        vm.equalRatio = false;
        vm.isEqualRatio = false;
        $scope.$watch("vm.data.part.mediabox.width", function (newValue, oldValue) {
            newValue = newValue || 0;
            oldValue = oldValue || 0;
            if(vm.equalRatio && !vm.isEqualRatio){
                vm.isEqualRatio = true;
                vm.data.part.mediabox.height = (newValue/oldValue||0) * vm.data.part.mediabox.height || 0;
            }else{
                vm.isEqualRatio = false;
            }
        })
        $scope.$watch("vm.data.part.mediabox.height", function (newValue, oldValue) {
            newValue = newValue || 0;
            oldValue = oldValue || 0;
            if(vm.equalRatio && !vm.isEqualRatio){
                vm.isEqualRatio = true;
                vm.data.part.mediabox.width = (newValue/oldValue||0) * vm.data.part.mediabox.width || 0;
            }else{
                vm.isEqualRatio = false;
            }
        })
        //单位换算
        vm.units = [
            {name:'px', id:'px'},
            {name:'mm', id:'mm'},
            {name:'英寸', id:'in'},
        ]
        $scope.unitConversion = unit;
        function unit(item){
            if(vm.data.unit == 'mm'){
                vm.data.part.mediabox.width = MmTurnPx(vm.data.part.mediabox.width).toFixed(2) - 0;
                vm.data.part.mediabox.height = MmTurnPx(vm.data.part.mediabox.height).toFixed(2) - 0;
                vm.data.part.bleed.top = MmTurnPx(vm.data.part.bleed.top).toFixed(2) - 0;
                vm.data.part.bleed.bottom = MmTurnPx(vm.data.part.bleed.bottom).toFixed(2) - 0;
                vm.data.part.bleed.left = MmTurnPx(vm.data.part.bleed.left).toFixed(2) - 0;
                vm.data.part.bleed.right = MmTurnPx(vm.data.part.bleed.right).toFixed(2) - 0;
                vm.data.part.editboxes.editbox.forEach(function (pageEdit) {
                    pageEdit.x = MmTurnPx(pageEdit.x).toFixed(2) - 0;
                    pageEdit.y = MmTurnPx(pageEdit.y).toFixed(2) - 0;
                    pageEdit.width = MmTurnPx(pageEdit.width).toFixed(2) - 0;
                    pageEdit.height = MmTurnPx(pageEdit.height).toFixed(2) - 0;
                })
            }
            if (vm.data.unit == 'in'){
                vm.data.part.mediabox.width = InTurnPx(vm.data.part.mediabox.width).toFixed(2) - 0;
                vm.data.part.mediabox.height = InTurnPx(vm.data.part.mediabox.height).toFixed(2) - 0;
                vm.data.part.bleed.top = InTurnPx(vm.data.part.bleed.top).toFixed(2) - 0;
                vm.data.part.bleed.bottom = InTurnPx(vm.data.part.bleed.bottom).toFixed(2) - 0;
                vm.data.part.bleed.left = InTurnPx(vm.data.part.bleed.left).toFixed(2) - 0;
                vm.data.part.bleed.right = InTurnPx(vm.data.part.bleed.right).toFixed(2) - 0;
                vm.data.part.editboxes.editbox.forEach(function (pageEdit) {
                    pageEdit.x = InTurnPx(pageEdit.x).toFixed(2) - 0;
                    pageEdit.y = InTurnPx(pageEdit.y).toFixed(2) - 0;
                    pageEdit.width = InTurnPx(pageEdit.width).toFixed(2) - 0;
                    pageEdit.height = InTurnPx(pageEdit.height).toFixed(2) - 0;
                })
            }
            if(item == 'mm'){
                vm.data.part.mediabox.width = Math.round(PxTurnMm(vm.data.part.mediabox.width) - 0);
                vm.data.part.mediabox.height = Math.round(PxTurnMm(vm.data.part.mediabox.height) - 0);
                vm.data.part.bleed.top = Math.round(PxTurnMm(vm.data.part.bleed.top) - 0);
                vm.data.part.bleed.bottom = Math.round(PxTurnMm(vm.data.part.bleed.bottom) - 0);
                vm.data.part.bleed.left = Math.round(PxTurnMm(vm.data.part.bleed.left) - 0);
                vm.data.part.bleed.right = Math.round(PxTurnMm(vm.data.part.bleed.right) - 0);
                vm.data.part.editboxes.editbox.forEach(function (pageEdit) {
                    pageEdit.x = Math.round(PxTurnMm(pageEdit.x) - 0);
                    pageEdit.y = Math.round(PxTurnMm(pageEdit.y) - 0);
                    pageEdit.width = Math.round(PxTurnMm(pageEdit.width) - 0);
                    pageEdit.height = Math.round(PxTurnMm(pageEdit.height) - 0);
                })
            }
            if(item == 'in'){
                vm.data.part.mediabox.width = PxTurnIn(vm.data.part.mediabox.width).toFixed(2) - 0;
                vm.data.part.mediabox.height = PxTurnIn(vm.data.part.mediabox.height).toFixed(2) - 0;
                vm.data.part.bleed.top = PxTurnIn(vm.data.part.bleed.top).toFixed(2) - 0;
                vm.data.part.bleed.bottom = PxTurnIn(vm.data.part.bleed.bottom).toFixed(2) - 0;
                vm.data.part.bleed.left = PxTurnIn(vm.data.part.bleed.left).toFixed(2) - 0;
                vm.data.part.bleed.right = PxTurnIn(vm.data.part.bleed.right).toFixed(2) - 0;
                vm.data.part.editboxes.editbox.forEach(function (pageEdit) {
                    pageEdit.x = PxTurnIn(pageEdit.x).toFixed(2) - 0;
                    pageEdit.y = PxTurnIn(pageEdit.y).toFixed(2) - 0;
                    pageEdit.width = PxTurnIn(pageEdit.width).toFixed(2) - 0;
                    pageEdit.height = PxTurnIn(pageEdit.height).toFixed(2) - 0;
                })
            }
            vm.data.unit = item;
            vm.data.unit1 = item;
        }
        js_getDPI()
        function js_getDPI() {
            var arrDPI = new Array();
            if (window.screen.deviceXDPI != undefined) {
                arrDPI[0] = window.screen.deviceXDPI;
                arrDPI[1] = window.screen.deviceYDPI;
            }
            else {
                var tmpNode = document.createElement("DIV");
                tmpNode.style.cssText = "width:1in;height:1in;position:absolute;left:0px;top:0px;z-index:99;visibility:hidden";
                document.body.appendChild(tmpNode);
                arrDPI[0] = parseInt(tmpNode.offsetWidth);
                arrDPI[1] = parseInt(tmpNode.offsetHeight);
                tmpNode.parentNode.removeChild(tmpNode);
            }
            vm.windowDpi = arrDPI[0];
            return arrDPI;
        };

        $scope.addPageEdit = function () {
            vm.data.part.editboxes.editbox.push({
                x:'',
                y:'',
                width:'',
                height:''
            })
        };
        $scope.removePageEdit = function(index){
            vm.data.part.editboxes.editbox.splice(index, 1);
        };
        //关联模型
        vm.selectModel = selectModel;
        function selectModel(data){
            $uibModal.open({
                templateUrl: 'app/entities/page/modal/model-select.html',
                controller: 'ModelSelectController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'lg',
                resolve: {
                    entity: [function() {
                        return {
                            type: 'add',
                            data: data,
                            modelType:'TWO'
                        };
                    }]
                }
            }).result.then(function(res) {
                if(res){
                    res.modelPic = vm.url + res.modelPic;
                    data.mould = res;
                }
            });
        }
        //编辑模型
        vm.selectModelEdit = selectModelEdit;
        function selectModelEdit(data){
            $uibModal.open({
                templateUrl: 'app/entities/page/modal/model-select.html',
                controller: 'ModelSelectController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'lg',
                resolve: {
                    entity: [function() {
                        return {
                            type: 'edit',
                            data: data,
                            modelType:'TWO'
                        };
                    }]
                }
            }).result.then(function(res) {
                if(res){
                    res.modelPic = vm.url + res.modelPic;
                    data.mould = res;
                }
            });
        }
        vm.cancel = function () {
            $uibModalInstance.close();
        }
        vm.next = function () {
            if(!vm.data.part.id){
                MessageService.error("请选择部件");
                return
            }
        };
        vm.save = function () {
            var _data = angular.copy(vm.data);
            if(!checkFloatNum(_data.part.mediabox.width) || !checkFloatNum(_data.part.mediabox.height)){
                MessageService.error("请填写正确的画布尺寸");
                return
            }
            if(!checkFloatNum(_data.part.bleed.top) || !checkFloatNum(_data.part.bleed.bottom) || !checkFloatNum(_data.part.bleed.left) || !checkFloatNum(_data.part.bleed.right)){
                MessageService.error("请填写正确的出血尺寸");
                return
            }
            // for(var i=0; i<_data.part.editboxes.editbox.length; i++){
            //     var pageEdit = _data.part.editboxes.editbox[i];
            //     if(!checkFloatNum(pageEdit.x) || !checkFloatNum(pageEdit.y) || !checkFloatNum(pageEdit.width) || !checkFloatNum(pageEdit.height)){
            //         MessageService.error("请填写正确的编辑区域");
            //         return false
            //     }
            // }
            if(_data.modelType == 'TWO' && !_data.mould){
                MessageService.error("请选择模型");
                return false
            }
            if(_data.modelType == 'THREE' && !vm.materialName){
                MessageService.error("请关联模型页");
                return false
            }
            if(_data.unit1 == 'px'){
                unit('mm');
            }
            var page = createPage();
            if (_data.mould) {
                page.scene = {
                    background: {
                        resource: {
                            identifier: _data.mould.modelPic.indexOf('http') > -1 ? _data.mould.modelPic : vm.url + _data.mould.modelPic,
                            provider: "qiniu"
                        }
                    },
                    geometry: {
                        width: _data.mould.gWidth,
                        height: _data.mould.gHeight,
                        x: 0,
                        y: 0
                    },
                    imagebox: {
                        geometry: {
                            width: _data.mould.width,
                            height: _data.mould.height,
                            x: _data.mould.x,
                            y: _data.mould.y
                        },
                        rotation: {angle: 0},
                        transparency: 1,
                    },
                    hierarchy: _data.mould.hierarchy,
                    mouldid: _data.mould.id,
                    isScene: true,
                    scale: 1,
                    unit: "mm",
                    resource:{
                        identifier: _data.mould.modelPic.indexOf('http') > -1 ? _data.mould.modelPic : vm.url + _data.mould.modelPic,
                        provider: "qiniu"
                    }
                }
            }
            _data.part.editboxes = vm.data.part.editboxes;
            page.seq = 1;
            page.uuid= UidService.get();
            vm.data.part.mediabox.x=0;
            vm.data.part.mediabox.y=0;
            page.config={
                "dynamic":false,
                "monthIndex":0,
                "monthMultiple":false,
                "partid":_data.part.id,
                "parts":{
                    list:[_data.part]
                }
            }
            console.log(page)
            $uibModalInstance.close({
                page:page,
                part:_data.part,
                materialName:vm.materialName,
            });
        }
        function createPage() {
            vm.data.part.editboxes = {
                editbox:[{
                    x:0,
                    y:0,
                    width:vm.data.part.mediabox.width,
                    height:vm.data.part.mediabox.height,
                }]
            }
            var _page1 = {
                uuid: UidService.get(),
                isScene: false,
                bgImg: '',
                background: {resource: {},color:'#ffffff', type: "Color"},
                pagecover: {},
                levels: {},
                barcode: {},
                qrcode: {},
                editbox: vm.data.part.editboxes.editbox[0],
                editboxes: {
                    editbox: vm.data.part.editboxes.editbox
                },
                mediabox: vm.data.part.mediabox,
                trimbox: {
                    height: vm.data.part.mediabox.height - Number(vm.data.part.bleed.bottom) - Number(vm.data.part.bleed.top),
                    width: vm.data.part.mediabox.width - Number(vm.data.part.bleed.left) - Number(vm.data.part.bleed.right),
                    x: vm.data.part.bleed.left,
                    y: vm.data.part.bleed.top
                },
                scale: 1,
                proportion: 1,
                seq: 0,
                spread: false,
                backup: false,
                unreplace: !vm.data.replace
            }
            return _page1;
        }
        function checkFloatNum(str){
            str = Number(str);
            var reg_zs = /^[0-9]\d*(\.\d+)?$/i;
            if (!reg_zs.test(str)) {
                return false;
            }
            return true;
        }
    }
})();

// (function() {
//     'use strict';
//     angular
//         .module('platformApp')
//         .factory('Catalogs', Catalogs);

//     Catalogs.$inject = ['$resource'];

//     function Catalogs ($resource) {
//         var resourceUrl =  'bunny/' + 'api/catalogs/:path/:id';

//         return $resource(resourceUrl, {}, {
//             "createBySYS2": {
//                 method: 'POST',
//                 params:{
//                     path:"createBySYS2"
//                 },
//             },
//             "get": {
//                 method: 'GET'
//             },
//             "update": {
//                 method: 'PUT'
//             },
//             "delete": {
//                 method: 'DELETE'
//             },
//             "getAll3": {
//                 method: 'POST',
//                 params:{
//                     path:"getAll3"
//                 },
//                 isArray:true
//             },
//             "byCondition3": {
//                 method: 'POST',
//                 params:{
//                     path:"byCondition3"
//                 },
//                 isArray:true
//             },
//         });
//     }
// })();

(function() {
    'use strict';

    angular
        .module('platformApp')
        .controller('PageStandardController', PageStandardController);

    PageStandardController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'items', '$state', 'MessageService', 'Catalog','Qinius', '$q', 'UidService','ProductXml'];

    function PageStandardController ($timeout, $scope, $stateParams, $uibModalInstance, items, $state, MessageService, Catalog,Qinius, $q, UidService, ProductXml) {
        var vm = this;
        console.log(items)
        $scope.domains = Qinius.getDomain();
        $q.all([$scope.domains.$promise]).then(function () {
            vm.url = $scope.domains.domain;
        })
        vm.cancel = cancel;
        vm.save = save;
        vm.itemType = items.type;
        vm.hideModal = items.hideModal || false;
        vm.catalogId = null;
        $scope.changeCatalogId = function () {
            var Item = vm.catalogs.find(function(item){
                return item.id === vm.catalogId;
            })
            if(Item){
                vm.data.catalog = Item;
            }
        }
        vm.title = function () {
            if(items.type == 'add'){return '新建'};
            if(items.type == 'edit'){return '编辑'};
            if(items.type == 'copy'){return '复制'};
        }
        vm.isMonth = false;
        vm.dateformat = 'yyyy/MM';
        $scope.options = {minMode:'month'};
        vm.month = "";
        if(items.type == 'add'){
            if(items.custom){
                vm.type = false;
                vm.data = {
                    pageSizeH:'',
                    pageSizeW:'',
                    pageBloodT:'',
                    pageBloodB:'',
                    pageBloodL:'',
                    pageBloodR:'',
                    pageEdits:[{
                        pageEditX:'',
                        pageEditY:'',
                        pageEditW:'',
                        pageEditH:'',
                    }],
                    pageEditUnit: 'mm',
                    pageSizeUnit: 'mm',
                    pageBloodUnit: 'mm',
                    pageEditUnit1: 'mm',
                    pageSizeUnit1: 'mm',
                    pageBloodUnit1: 'mm',
                    pageCount: 1,
                    bindingType: '',
                    pattern: '',
                    replace: '',
                    addpage: false,
                }
            }else {
                vm.type = true;
                vm.data = items.data;
            }
            getCatalog()
        }else {
            ProductXml.get({id: items.id}, function (res) {
                if(items.type == 'copy' && !vm.hideModal){
                    res.name+='_副本'
                }
                vm.data = res;
                vm.data.catalog = {
                    id: res.catalogId,
                    name: res.catalogName,
                }
                vm.data.bindingType = res.document.bindingtype;
                vm.data.pattern = res.document.pattern;
                vm.data.replace = res.document.replace;
                vm.data.addpage = res.document.addpage;
                vm.data.minpage = res.document.minpage;
                vm.data.maxpage = res.document.maxpage;
                vm.data.addunit = res.document.addunit;
                vm.data.productXmlId = items.id;
                if(res.document.config.dynamic){
                    $timeout(function () {
                        vm.month = res.document.config.startYear + '-' + (res.document.config.startMonth>9?res.document.config.startMonth:'0'+res.document.config.startMonth);
                        $("#startTime").val(vm.month)
                    },200)
                }
                getCatalog()
                vm.catalogId = vm.data.catalogId;
                //隐藏弹窗，直接调用提交接口
                if(vm.itemType === 'copy' && vm.hideModal){
                    vm.save();
                }
            })
            // if(items.type == 'copy'&&!vm.data.id){
            //     vm.type = false;
            // }else{
            //     vm.type = true;
            // }
        }
        $scope.template = {
            transparency: 1,
            cover: null,
            scene: null,
            pageI: 0,
            angle: 0,
            backup: false,
            spread: false,
            unreplace: false,
            letterspacing: 0,
            lineheight: 0,
            text: '',
            bgimgs: {bgimg: []},
            bgimgs2: {bgimg: []},
            masks: {mask: []},
            cliparts: {clipart: []},
            frameConfigs: {frameConfig: []},
            documentpics: {documentpic: []},
            pages: {
                page: []
            },
            showPic: false,
            psdFiles: {psdFile: []}
        };
        vm.units = [
            {name:'px', id:'px'},
            {name:'mm', id:'mm'},
            {name:'英寸', id:'in'},
        ]
        function getCatalog(){
            Catalog.getAll({items:[{key:"usable", op:"=", value:"true"},{key:"catalogType", op:"=", value:"XML"}]}, function (res) {
                vm.catalogs = res;
                if(items.type != 'add'){
                    for(var i=0; i<res.length; i++){
                        if(res[i].id == vm.data.catalog.id){
                            vm.data.catalog = res[i];
                        }
                    }
                }
            });
        }
        vm.replaces = [
            {id: true, value: '可替换'},
            {id: false, value: '不可替换'}
        ]
        vm.addpages = [
            {id: true, value: '可加页'},
            {id: false, value: '不可加页'}
        ];
        $scope.addPageEdit = function () {
            vm.data.pageEdits.push({
                pageEditX:'',
                pageEditY:'',
                pageEditW:'',
                pageEditH:''
            })
        }
        $scope.removePageEdit = function(index){
            vm.data.pageEdits.splice(index, 1);
        };

        function checkFloatNum(str){
            var reg_zs = /^[0-9]\d*(\.\d+)?$/i;
            if (!reg_zs.test(str)) {
                return false;
            }
            return true;
        }
        //保存
        function save(whether) {
            if(vm.isSaving){
                return
            }
            if(items.type == 'add') {
                if(!vm.data.name){
                    MessageService.error("模板名称不能为空");
                    return
                }
                if(!checkFloatNum(vm.data.pageSizeW) || !checkFloatNum(vm.data.pageSizeH)){
                    MessageService.error("请填写正确的画布尺寸");
                    return
                }
                if(!vm.data.catalog){
                    MessageService.error("请选择产品");
                    return
                }
                if(!checkFloatNum(vm.data.pageBloodT) || !checkFloatNum(vm.data.pageBloodB) || !checkFloatNum(vm.data.pageBloodL) || !checkFloatNum(vm.data.pageBloodR)){
                    MessageService.error("请填写正确的出血尺寸");
                    return
                }
                for(var i=0; i<vm.data.pageEdits.length; i++){
                    var pageEdit = vm.data.pageEdits[i];
                    if(!checkFloatNum(pageEdit.pageEditX) || !checkFloatNum(pageEdit.pageEditY) || !checkFloatNum(pageEdit.pageEditW) || !checkFloatNum(pageEdit.pageEditH)){
                        MessageService.error("请填写正确的编辑区域");
                        return false
                    }
                }
                if(vm.data.pageCount<1){
                    MessageService.error("页数必须大于0");
                    return
                }
                if(typeof vm.data.replace != 'boolean'){
                    MessageService.error("请选择模板替换");
                    return
                }
                if(items.custom){
                    if(vm.data.pageSizeUnit != 'mm'){
                        unit('mm')
                    }
                    vm.data.pageTemplates = [];
                    for(var i=0; i<vm.data.pageCount; i++){
                        var _data = {
                            id:'',
                            seq:i+1,
                            added:true,
                            deleted:false,
                            pageSizeH:vm.data.pageSizeH,
                            pageSizeW:vm.data.pageSizeW,
                            pageBloodT:vm.data.pageBloodT,
                            pageBloodB:vm.data.pageBloodB,
                            pageBloodL:vm.data.pageBloodL,
                            pageBloodR:vm.data.pageBloodR,
                            pageEdits:vm.data.pageEdits,
                            pageEditUnit: vm.data.pageEditUnit,
                            pageSizeUnit: vm.data.pageSizeUnit,
                            pageBloodUnit: vm.data.pageBloodUnit,
                            cancelled:false,
                            productTemplateId:vm.data.id,
                            mould:vm.data.mould
                        }
                        vm.data.pageTemplates.push(_data)
                    }
                }else{
                    for(var i=0; i<vm.data.pageTemplates.length; i++){
                        vm.data.pageTemplates[i].pageEdits = vm.data.pageEdits;
                    }
                }
                for(var j=vm.data.pageTemplates.length-1; j>=0; j--){
                    if(vm.data.pageTemplates[j].cancelled){
                        vm.data.pageTemplates.splice(j, 1)
                    }
                }
                addSave();
            }
            if (items.type == 'edit' || items.type == 'copy') {
                if(!vm.data.name){
                    MessageService.error("模板名称不能为空");
                    return
                }
                if(!vm.data.catalog){
                    MessageService.error("请选择产品");
                    return
                }
                if(typeof vm.data.replace != 'boolean'){
                    MessageService.error("请选择模板替换");
                    return
                }
                if(vm.data.productType == 'BOOK' || (vm.data.productType == 'CALENDAR'&&!vm.data.document.config.dynamic)){

                    if(vm.data.addpage){
                        if(!vm.data.minpage || !vm.data.maxpage){
                            MessageService.error("页数范围必须大于0");
                            return
                        }
                        if(vm.data.minpage > vm.data.maxpage){
                            MessageService.error("结束页数不能小于开始页数，请重新设置页数范围");
                            return
                        }
                        if(!vm.data.addunit){
                            MessageService.error("加页单位必须大于0");
                            return
                        }
                    }
                }
                vm.isSaving = true;
                vm.data.document.bindingtype = vm.data.bindingType;
                vm.data.document.pattern = vm.data.pattern;
                vm.data.document.replace = vm.data.replace;
                vm.data.document.addpage = vm.data.addpage;
                vm.data.document.minpage = vm.data.minpage;
                vm.data.document.maxpage = vm.data.maxpage;
                vm.data.document.addunit = vm.data.addunit;
                vm.data.catalogId = vm.data.catalog.id;
                vm.data.catalogName = vm.data.catalog.name;
                if(vm.data.document.config.dynamic){
                    vm.month = $("#startTime").val();
                    if (!!vm.month) {
                        vm.data.document.config.startYear = (vm.month.split("-"))[0];
                        vm.data.document.config.startMonth = (vm.month.split("-"))[1];
                    }
                }
                if(items.type == 'edit'){
                    ProductXml.update(vm.data, function (res) {
                        vm.isSaving = false;
                        $uibModalInstance.close(true);
                        if(whether){
                            $state.go('page-my-suffix-edit', {id: res.id}, {reload: true})
                        }else{
                            MessageService.success("保存成功");
                        }
                    }, function () {
                        vm.isSaving = false;
                    });
                }else{
                    vm.data.id = null;
                    ProductXml.save(vm.data, function (res) {
                        vm.isSaving = false;
                        $uibModalInstance.close();
                        $state.go('page-my-suffix-edit', {id: res.id}, {reload: true})
                    }, function () {
                        vm.isSaving = false;
                    });
                }
            }
        }
        function addSave() {
            vm.isSaving = true;
            vm.hashtags = '';
            if(vm.data.catalog.hashtags){
                for (var i = 0; i < vm.data.catalog.hashtags.length; i++) {
                    vm.hashtags += vm.data.catalog.hashtags[i].name + ','
                }
            }
            $scope.template.pages.page=[];
            for (var i = 0; i < vm.data.pageTemplates.length; i++) {
                var _page = vm.data.pageTemplates[i];
                var editSize = [];
                _page.pageEdits.forEach(function (editbox) {
                    editSize.push({
                        height: editbox.pageEditH,
                        width: editbox.pageEditW,
                        x: editbox.pageEditX,
                        y: editbox.pageEditY
                    })
                });
                var _page1 = createPage(_page, editSize, i);
                if (_page.mould) {
                    _page1.scene = {
                        background: {
                            resource: {
                                identifier: _page.mould.modelPic.indexOf('http') > -1 ? _page.mould.modelPic : vm.url + _page.mould.modelPic,
                                provider: "qiniu"
                            }
                        },
                        geometry: {
                            width: _page.mould.gWidth,
                            height: _page.mould.gHeight,
                            x: 0,
                            y: 0
                        },
                        imagebox: {
                            geometry: {
                                width: _page.mould.width,
                                height: _page.mould.height,
                                x: _page.mould.x,
                                y: _page.mould.y
                            },
                            rotation: {angle: 0},
                            transparency: 1,
                        },
                        hierarchy: _page.mould.hierarchy,
                        isScene: true,
                        scale: 1,
                        unit: "mm",
                    }
                }
                $scope.template.pages.page.push(_page1);
            }
            $scope.template.bindingtype = vm.data.bindingType;
            $scope.template.pattern = vm.data.pattern;
            $scope.template.cover = angular.copy(vm.data.cover);
            $scope.template.replace = vm.data.replace;
            $scope.template.version = "2.0";
            $scope.template.addpage = vm.data.addpage;
            $scope.template.minpage = vm.data.minpage;
            $scope.template.maxpage = vm.data.maxpage;
            $scope.template.addunit = vm.data.addunit;
            ProductXml.save({
                document: $scope.template,
                bindingType: vm.data.bindingType,
                pattern: vm.data.pattern,
                replace: vm.data.replace,
                name: vm.data.name,
                catalogId: vm.data.catalog.id,
                catalogName: vm.data.catalog.name,
                version: '2.0',
                type: 'XML',
                productTemplateId: '',
                hashtags: vm.hashtags,
                modelBlendent: vm.data.modelBlendent,
                modelData: vm.data.modelData,
                modelPath: vm.data.modelPath,
                modelType: vm.data.modelType
            }, function (res) {
                vm.isSaving = false;
                $uibModalInstance.close();
                $state.go('page-my-suffix-edit', {id: res.id}, {reload: true})
            }, function () {
                vm.isSaving = false;
            });
        }
        function createPage(_page, editSize, i) {
            var _page1 = {
                uuid: UidService.get(),
                isScene: false,
                bgImg: '',
                background: {resource: {},color:'#ffffff', type: "Color"},
                pagecover: {},
                levels: {},
                barcode: {},
                qrcode: {},
                editbox: editSize[0],
                editboxes: {
                    editbox: editSize
                },
                mediabox: {
                    height: _page.pageSizeH,
                    width: _page.pageSizeW,
                },
                trimbox: {
                    height: _page.pageSizeH - Number(_page.pageBloodB) - Number(_page.pageBloodT),
                    width: _page.pageSizeW - Number(_page.pageBloodL) - Number(_page.pageBloodR),
                    x: _page.pageBloodL,
                    y: _page.pageBloodT
                },
                scale: 1,
                proportion: 1,
                seq: i + 1,
                spread: false,
                backup: false,
                unreplace: !vm.data.replace
            }
            return _page1;
        }
        //返回
        function cancel() {
            $uibModalInstance.close();
        }
        //单位换算
        $scope.unitConversion = function (item) {
            unit(item)
        }
        function unit(item){
            if(vm.data.pageSizeUnit == 'mm'){
                vm.data.pageSizeW = MmTurnPx(vm.data.pageSizeW).toFixed(2) - 0;
                vm.data.pageSizeH = MmTurnPx(vm.data.pageSizeH).toFixed(2) - 0;
                vm.data.pageBloodT = MmTurnPx(vm.data.pageBloodT).toFixed(2) - 0;
                vm.data.pageBloodB = MmTurnPx(vm.data.pageBloodB).toFixed(2) - 0;
                vm.data.pageBloodL = MmTurnPx(vm.data.pageBloodL).toFixed(2) - 0;
                vm.data.pageBloodR = MmTurnPx(vm.data.pageBloodR).toFixed(2) - 0;
                vm.data.pageEdits.forEach(function (pageEdit) {
                    pageEdit.pageEditX = MmTurnPx(pageEdit.pageEditX).toFixed(2) - 0;
                    pageEdit.pageEditY = MmTurnPx(pageEdit.pageEditY).toFixed(2) - 0;
                    pageEdit.pageEditW = MmTurnPx(pageEdit.pageEditW).toFixed(2) - 0;
                    pageEdit.pageEditH = MmTurnPx(pageEdit.pageEditH).toFixed(2) - 0;
                })
            }
            if (vm.data.pageSizeUnit == 'in'){
                vm.data.pageSizeW = InTurnPx(vm.data.pageSizeW).toFixed(2) - 0;
                vm.data.pageSizeH = InTurnPx(vm.data.pageSizeH).toFixed(2) - 0;
                vm.data.pageBloodT = InTurnPx(vm.data.pageBloodT).toFixed(2) - 0;
                vm.data.pageBloodB = InTurnPx(vm.data.pageBloodB).toFixed(2) - 0;
                vm.data.pageBloodL = InTurnPx(vm.data.pageBloodL).toFixed(2) - 0;
                vm.data.pageBloodR = InTurnPx(vm.data.pageBloodR).toFixed(2) - 0;
                vm.data.pageEdits.forEach(function (pageEdit) {
                    pageEdit.pageEditX = InTurnPx(pageEdit.pageEditX).toFixed(2) - 0;
                    pageEdit.pageEditY = InTurnPx(pageEdit.pageEditY).toFixed(2) - 0;
                    pageEdit.pageEditW = InTurnPx(pageEdit.pageEditW).toFixed(2) - 0;
                    pageEdit.pageEditH = InTurnPx(pageEdit.pageEditH).toFixed(2) - 0;
                })
            }
            if(item == 'mm'){
                vm.data.pageSizeW = PxTurnMm(vm.data.pageSizeW).toFixed(2) - 0;
                vm.data.pageSizeH = PxTurnMm(vm.data.pageSizeH).toFixed(2) - 0;
                vm.data.pageBloodT = PxTurnMm(vm.data.pageBloodT).toFixed(2) - 0;
                vm.data.pageBloodB = PxTurnMm(vm.data.pageBloodB).toFixed(2) - 0;
                vm.data.pageBloodL = PxTurnMm(vm.data.pageBloodL).toFixed(2) - 0;
                vm.data.pageBloodR = PxTurnMm(vm.data.pageBloodR).toFixed(2) - 0;
                vm.data.pageEdits.forEach(function (pageEdit) {
                    pageEdit.pageEditX = PxTurnMm(pageEdit.pageEditX).toFixed(2) - 0;
                    pageEdit.pageEditY = PxTurnMm(pageEdit.pageEditY).toFixed(2) - 0;
                    pageEdit.pageEditW = PxTurnMm(pageEdit.pageEditW).toFixed(2) - 0;
                    pageEdit.pageEditH = PxTurnMm(pageEdit.pageEditH).toFixed(2) - 0;
                })
            }
            if(item == 'in'){
                vm.data.pageSizeW = PxTurnIn(vm.data.pageSizeW).toFixed(2) - 0;
                vm.data.pageSizeH = PxTurnIn(vm.data.pageSizeH).toFixed(2) - 0;
                vm.data.pageBloodT = PxTurnIn(vm.data.pageBloodT).toFixed(2) - 0;
                vm.data.pageBloodB = PxTurnIn(vm.data.pageBloodB).toFixed(2) - 0;
                vm.data.pageBloodL = PxTurnIn(vm.data.pageBloodL).toFixed(2) - 0;
                vm.data.pageBloodR = PxTurnIn(vm.data.pageBloodR).toFixed(2) - 0;
                vm.data.pageEdits.forEach(function (pageEdit) {
                    pageEdit.pageEditX = PxTurnIn(pageEdit.pageEditX).toFixed(2) - 0;
                    pageEdit.pageEditY = PxTurnIn(pageEdit.pageEditY).toFixed(2) - 0;
                    pageEdit.pageEditW = PxTurnIn(pageEdit.pageEditW).toFixed(2) - 0;
                    pageEdit.pageEditH = PxTurnIn(pageEdit.pageEditH).toFixed(2) - 0;
                })
            }
            vm.data.pageSizeUnit = item;
            vm.data.pageBloodUnit = item;
            vm.data.pageEditUnit = item;
            vm.data.pageSizeUnit1 = item;
            vm.data.pageBloodUnit1 = item;
            vm.data.pageEditUnit1 = item;
        }
        js_getDPI()
        function js_getDPI() {
            var arrDPI = new Array();
            if (window.screen.deviceXDPI != undefined) {
                arrDPI[0] = window.screen.deviceXDPI;
                arrDPI[1] = window.screen.deviceYDPI;
            }
            else {
                var tmpNode = document.createElement("DIV");
                tmpNode.style.cssText = "width:1in;height:1in;position:absolute;left:0px;top:0px;z-index:99;visibility:hidden";
                document.body.appendChild(tmpNode);
                arrDPI[0] = parseInt(tmpNode.offsetWidth);
                arrDPI[1] = parseInt(tmpNode.offsetHeight);
                tmpNode.parentNode.removeChild(tmpNode);
            }
            vm.windowDpi = arrDPI[0];
            return arrDPI;
        }
    }
})();

(function () {
    "use strict";

    angular.module("platformApp").controller("OriginalAgreementController", OriginalAgreementController);

    OriginalAgreementController.$inject = ["$scope","$uibModalInstance","FrontUser","$localStorage","MessageService"];

    function OriginalAgreementController($scope,$uibModalInstance,FrontUser,$localStorage,MessageService) {
        var vm = this;
        vm.loading = false;
        //同意协议
        $scope.submitAgree = function(){
            if(vm.loading) return;
            vm.loading = true;
            FrontUser.original({},function(res){
                vm.loading = false;
                $localStorage.user = res;
                $uibModalInstance.close(true);
            },function(){
                vm.loading = false;
                MessageService.error("网络错误，请重试");
            });
        };
        $scope.close = function (isAgree) {
            $uibModalInstance.close(isAgree);
        };
    }
})();

(function () {
    'use strict';

    angular
        .module('platformApp')
        .controller('MonthIndexSetController', MonthIndexSetController);

    MonthIndexSetController.$inject = ['$scope', '$uibModalInstance', 'MessageService'];

    function MonthIndexSetController( $scope, $uibModalInstance, MessageService) {
        var vm = this;
        vm.clear = clear;
        vm.save = save;
        vm.monthIndex="";

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function save() {
            if (!vm.monthIndex) {
                MessageService.error('第几个月只能为正整数')
                return;
            }
            if (vm.monthIndex>24) {
                MessageService.error('最大不能超过24个月')
                return;
            }
            if (vm.monthIndex<1) {
                MessageService.error('不能小于1个月')
                return;
            }
            $uibModalInstance.close(vm.monthIndex);
        }

    }

})();

(function() {
    'use strict';

    angular
        .module('platformApp')
        .controller('ModelSelectController', ModelSelectController);

    ModelSelectController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', '$state', 'Moulds', 'MessageService', 'Qinius'];

    function ModelSelectController ($timeout, $scope, $stateParams, $uibModalInstance, entity, $state, Moulds, MessageService, Qinius) {
        var vm = this;
        vm.type = entity.type;
        vm.modelData = entity.data;
        vm.modelType = entity.modelType;
        vm.cancel = cancel;
        vm.save = save;
        vm.search = "";
        $scope.domains = Qinius.getDomain();
        vm.model = null;
        vm.data = [];


        init()
        function init(){
            vm.data = [];
            var items = [{key: "name", op: "like", value: vm.search},
                {key: "sourceType", op: "=", value: 'front'}];
            if(vm.modelType == 'THREE'){
                items.push({key: "modelType", op: "=", value: 'THREE'})
            }
            if(vm.modelType == 'TWO'){
                items.push({key: "modelType", op: "=", value: 'TWO'})
            }
            Moulds.getAllUsable({
                name: vm.search,
                modelType: vm.modelType
            }, function (res) {
                if(vm.modelType == 'TWO'){
                    for(var i=0; i<res.length; i++){
                        if(!res[i].cancelled){
                            if(vm.type == 'edit'){
                                if(vm.modelData.mould && res[i].id == vm.modelData.mould.id){
                                    res[i].selected = true;
                                    vm.model = res[i];
                                }
                            }
                            vm.data.push(res[i]);
                        }
                    }
                }
                if(vm.modelType == 'THREE'){
                    for(var i=0; i<res.length; i++){
                        if(!res[i].cancelled){
                            if(vm.type == 'edit'){
                                if(vm.modelData.mould && res[i].id == vm.modelData.mould.id){
                                    res[i].selected = true;
                                    vm.model = res[i];
                                }
                            }
                            vm.data.push(res[i]);
                        }
                    }
                }
            }, function (error) {
                MessageService.error("获取列表失败！");
            });
        }
        vm.selectTable = selectTable;
        function selectTable(event){
            if (!event.which === 13) {
                return
            }
            init()
        }

        vm.check = check;
        function check(item) {
            for(var i=0; i<vm.data.length; i++){
                if(vm.data[i].id != item.id){
                    vm.data[i].selected = false;
                }
            }
            item.selected = !item.selected ? true : false;
            if(item.selected){
                vm.model = item;
            }else {
                vm.model = null;
            }
        }
        //保存
        function save() {
            if(!vm.model){
                MessageService.error("请选择模型！");
                return
            }
            $uibModalInstance.close(vm.model);
        }
        //返回
        function cancel() {
            $uibModalInstance.close(false);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('platformApp')
        .controller('DocumentDetectionController', DocumentDetectionController);

    DocumentDetectionController.$inject = ['$timeout', '$scope', 'GetSetDpi', '$stateParams', '$uibModalInstance', 'entity', '$state', '$q', 'MessageService', 'Qinius', '$http', 'Catalog', '$uibModal','ProductXml', 'FontManagement'];

    function DocumentDetectionController ($timeout, $scope, GetSetDpi, $stateParams, $uibModalInstance, entity, $state, $q, MessageService, Qinius, $http, Catalog, $uibModal, ProductXml, FontManagement) {
        var vm = this;
        vm.loading=true;
        vm.platform2User = JSON.parse(localStorage.getItem('platform2-user'));
        vm.saveData = angular.copy(entity);
        vm.source = angular.copy(vm.saveData.source);
        vm.document = angular.copy(vm.saveData.document);
        vm.gitDpi = GetSetDpi.getCurrent();
        vm.backup = false;
        vm.data=[];
        vm.tapIndex = 1;
        vm.checkAll = false;
        vm.isDocumentDetection=false;
        vm.documentDetection = {
            pass: true
        };
        vm.documentDetectionTab="text";
        $q.all([vm.gitDpi.$promise, vm.document.$promise]).then(function () {
            vm.documentDetection = documentTextDetection(vm.document);
            if(!vm.documentDetection.pass){
                if(vm.documentDetection.isText){
                    vm.documentDetectionTab="text";
                }else{
                    vm.documentDetectionTab="repetition";
                }
                return;
            }
            vm.isDocumentDetection=true;

            vm.thirdPartySettings = vm.platform2User.thirdPartySettings || [];
            vm.gitDpi = vm.gitDpi.message;
            vm.pages=[];
            vm.backupPages=[];
            vm.document.pages.page.forEach(function (page) {
                pageDetection(page)
            });
            if(vm.document.backupPages&&vm.document.backupPages.list){
                vm.document.backupPages.list.forEach(function (page) {
                    pageDetection(page)
                });
            }
            $timeout(function () {
                pageInit();
            },1000)
        })

        $scope.backupFn = function (item) {
            vm.backup = item;
            pageInit();
        }
        function verifyTextfont(textbox, failCallback) {
            if (!textbox) {
                return;
            }
            textbox.characterWarning = false;
            textbox.characterMessage = "";
            FontManagement.fontSupport({
                uuid: textbox.fontuuid,
                bold: textbox.style.bold,
                italic: textbox.style.italic,
                content: textbox.text
            }, function (res) {
                var msg = res.message;
                if (res.status == 200) {
                    if (msg.success && !msg.supported) {
                        var message = "【" + msg.failed + "】" + "当前字体不支持这些文字！";
                        if (failCallback) {
                            failCallback(message);
                        }
                    }
                }
            })
        }
        function pageDetection(page){
            page.dpiResult = [];
            page.fontResult = [];
            if(page.background.type == 'Pic' && page.background.resource && page.background.resource.identifier){
                var _data = pxInsufficient(page.background.resource.width, page.background.resource.height, page.background.scale, page.mediabox.width, page.mediabox.height);
                if(_data < vm.gitDpi.bgDpi - 0.01){
                    page.dpiResult.push({
                        type: 'background',
                        img: page.background.resource.identifier,
                        dpi: _data,
                        expectDpi: vm.gitDpi.bgDpi,
                        name: '背景'
                    })
                }
            }
            if(page.levels && page.levels.level && page.levels.level.length>0){
                page.levels.level.forEach(function (level, i) {
                    var index = i+1;
                    if(level.imagebox && level.imagebox.image && level.imagebox.image.resource && level.imagebox.image.resource.identifier){
                        if(level.imagebox.image.resource.width && level.imagebox.image.resource.height){
                            var _data = pxInsufficient(level.imagebox.image.resource.width, level.imagebox.image.resource.height, level.imagebox.image.scale, level.imagebox.geometry.width, level.imagebox.geometry.height);
                            if(_data < vm.gitDpi.imgDpi - 0.01){
                                page.dpiResult.push({
                                    type: 'imagebox',
                                    img: level.imagebox.image.resource.identifier,
                                    dpi: _data,
                                    expectDpi: vm.gitDpi.imgDpi,
                                    name: '图片' + index
                                })
                            }
                        }else{
                            imageInfo($http, level.imagebox.image.resource, function () {
                                var _data = pxInsufficient(level.imagebox.image.resource.width, level.imagebox.image.resource.height, level.imagebox.image.scale, level.imagebox.geometry.width, level.imagebox.geometry.height);
                                if(_data < vm.gitDpi.imgDpi - 0.01){
                                    page.dpiResult.push({
                                        type: 'imagebox',
                                        img: level.imagebox.image.resource.identifier,
                                        dpi: _data,
                                        expectDpi: vm.gitDpi.imgDpi,
                                        name: '图片' + index
                                    })
                                }
                            })
                        }
                    }
                    if(level.imagebox && level.imagebox.mask && level.imagebox.mask.resource && level.imagebox.mask.resource.identifier){
                        if(level.imagebox.mask.resource.width && level.imagebox.mask.resource.height){
                            var _data = pxInsufficient(level.imagebox.mask.resource.width, level.imagebox.mask.resource.height, level.imagebox.mask.scale, level.imagebox.geometry.width, level.imagebox.geometry.height);
                            if(_data < vm.gitDpi.maskDpi - 0.01){
                                page.dpiResult.push({
                                    type: 'imageboxMask',
                                    img: level.imagebox.mask.resource.identifier,
                                    dpi: _data,
                                    expectDpi: vm.gitDpi.maskDpi,
                                    name: '相框' + index
                                })
                            }
                        }else{
                            imageInfo($http, level.imagebox.mask.resource, function () {
                                var _data = pxInsufficient(level.imagebox.mask.resource.width, level.imagebox.mask.resource.height, level.imagebox.mask.scale, level.imagebox.geometry.width, level.imagebox.geometry.height);
                                if(_data < vm.gitDpi.maskDpi - 0.01){
                                    page.dpiResult.push({
                                        type: 'imageboxMask',
                                        img: level.imagebox.mask.resource.identifier,
                                        dpi: _data,
                                        expectDpi: vm.gitDpi.maskDpi,
                                        name: '相框' + index
                                    })
                                }
                            })
                        }
                    }
                    if(level.imageart && level.imageart.resource && level.imageart.resource.identifier){
                        if(level.imageart.resource.width && level.imageart.resource.height){
                            var _data = pxInsufficient(level.imageart.resource.width, level.imageart.resource.height, level.imageart.scale, level.imageart.geometry.width, level.imageart.geometry.height);
                            if(_data < vm.gitDpi.clipArtDpi - 0.01){
                                page.dpiResult.push({
                                    type: 'imageart',
                                    img: level.imageart.resource.identifier,
                                    dpi: _data,
                                    expectDpi: vm.gitDpi.clipArtDpi,
                                    name: '素材' + index
                                })
                            }
                        }else{
                            imageInfo($http, level.imageart.resource, function () {
                                var _data = pxInsufficient(level.imageart.resource.width, level.imageart.resource.height, level.imageart.scale, level.imageart.geometry.width, level.imageart.geometry.height);
                                if(_data < vm.gitDpi.clipArtDpi - 0.01){
                                    page.dpiResult.push({
                                        type: 'imageart',
                                        img: level.imageart.resource.identifier,
                                        dpi: _data,
                                        expectDpi: vm.gitDpi.clipArtDpi,
                                        name: '素材' + index
                                    })
                                }
                            })
                        }
                    }
                    if (level.textbox && level.textbox.text && level.textbox.fontuuid) {
                        verifyTextfont(level.textbox, function (message) {
                            page.fontResult.push({
                                type: 'textbox',
                                message: message,
                                name: '文字' + index
                            })
                        });

                    }
                })
            }
        }


        function pageInit(){
            vm.pages=[];
            vm.disqualification = false;
            if(!vm.backup){
                vm.document.pages.page.forEach(function (page) {
                    vm.pages.push(page);
                })
            }else{
                if(vm.document.backupPages&&vm.document.backupPages.list){
                    vm.document.backupPages.list.forEach(function (page) {
                        if(page.backup == vm.backup){
                            vm.pages.push(page);
                        }
                    })
                }
            }
            vm.pages.forEach(function (item) {
                if(item.dpiResult && item.dpiResult.length>0){
                    vm.disqualification = true;
                }
                if (item.fontResult && item.fontResult.length > 0) {
                    vm.disqualification = true;
                }
            })
            vm.loading=false;
        }

        vm.checkAllFn = function(){
            vm.checkAll = !vm.checkAll;
            vm.thirdPartySettings.forEach(function (item) {
                item.selected = vm.checkAll;
            })
        };
        vm.checkFn = function(item){
            item.selected = !item.selected;
            vm.checkAll = true;
            vm.thirdPartySettings.forEach(function (item) {
                if(!item.selected){
                    vm.checkAll = false;
                }
            })
        };
        //返回
        vm.cancel = function() {
            $uibModalInstance.close(false);
        };
        function checkPageFonts() {
            if (vm.pages.length > 0) {
                for (var i = 0; i < vm.pages.length; i++) {
                    var page = vm.pages[i];
                    if (page.fontResult && page.fontResult.length > 0) {
                        if (!page.backup) {
                            MessageService.error("检测到页面文字中包含字体不支持的字符！");
                        } else {
                            MessageService.error("检测到备用页面文字中包含字体不支持的字符！");
                        }
                        return false;
                    }
                }
            }

            return true;
        }
        $scope.save1 = function(){
            if (!checkPageFonts()) {
                // 文字检查不通过
                return;
            }
            if(vm.thirdPartySettings.length>1){
                vm.tapIndex = 2;
            }else{
                vm.thirdPartySettings.forEach(function (item) {
                    item.selected = true;
                })
                save()
            }
        };
        $scope.cancel2 = function(){
            vm.tapIndex = 1;
        };
        $scope.save2 = function () {
            save()
        };
        $scope.save3 = function () {
            $uibModalInstance.close(true);
        }

        function save() {
            vm.storeIds = [];
            vm.thirdPartySettings.forEach(function (item) {
                if(item.selected){
                    vm.storeIds.push(item.id);
                }
            })
            if(vm.storeIds.length == 0){
                MessageService.error("请选择发布的渠道");
                return
            }
            vm.tapIndex = 3;
            if(vm.source == 'editor'){
                vm.saveData.storeIds = vm.storeIds;
                vm.saveLoading = true;
                ProductXml.release(vm.saveData, function (res) {
                    vm.releaseData = res;
                    vm.saveLoading = false;
                }, function () {
                    MessageService.error("发布失败");
                    vm.saveLoading = false;
                });
            }
            if(vm.source == 'list'){
                vm.saveData.storeIds = vm.storeIds.toString();
                vm.saveLoading = true;
                ProductXml.onlyRelease(
                    {
                        id: vm.saveData.id,
                        storeIds: vm.saveData.storeIds,
                        type: vm.saveData.type,
                    }, function (res) {
                    vm.releaseData = res;
                    vm.saveLoading = false;
                }, function () {
                    MessageService.error("发布失败");
                    vm.saveLoading = false;
                });
            }
        }
        $scope.levelInfo = function (level) {
            var item = "";
            if (level.imagebox) {
                item += "相框"
            }
            if (level.imageart) {
                item += "素材"
            }
            if (level.textbox) {
                item += level.textbox.text || ""
            }
            if (level.textdocument) {
                item += "文本模板"
            }
            return item
        };

        $scope.getIndex = function(index){
            if(vm.pageData && vm.pageData.length>0){
                var _index = 0;
                for(var i=0; i<vm.pageData.length; i++){
                    var _page = vm.pageData[i];
                    if(_page && _page.config && _page.config.partid == 'P'){
                        _index+=1;
                        if(index == i){
                            break
                        }
                    }
                }
                if (_index < 10) {
                    return "0"+ _index;
                }
                return _index;
            }
        }

        $scope.pageSeq = function(page){
            if(page && page.config){
                if(page.config.partid != 'P'){
                    return $scope.partNamt(page.config.partid)
                }else{
                    var _seq = 0;
                    for(var i=0; i<vm.pages.length; i++){
                        var _page = vm.pages[i];
                        if(_page && _page.config &&_page.config.partid == page.config.partid){
                            _seq += 1;
                            if(_page.uuid == page.uuid){
                                break
                            }
                        }
                    }
                    return '内页第'+ _seq + '页';
                }
            }
        }
        //部件名
        $scope.partNamt = function (partid) {
            var partName = "";
            for(var i=0; i<vm.document.config.parts.list.length; i++){
                if(vm.document.config.parts.list[i].id == partid){
                    partName = vm.document.config.parts.list[i].name;
                }
            }
            return partName
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('platformApp')
        .controller('CalendarModalController', CalendarModalController);

    CalendarModalController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity'];

    function CalendarModalController ($timeout, $scope, $stateParams, $uibModalInstance, entity) {
        var vm = this;
        vm.cancel = cancel;
        vm.save = save;
        vm.numbers = entity.numbers;
        vm.templateConfig = entity.templateConfig;
        var result = findMissingNumbers(vm.numbers);
        var max = Math.max.apply(null, vm.numbers);
        var min = Math.min.apply(null, vm.numbers);
        vm.startYear = getDay('year',vm.templateConfig.startYear,vm.templateConfig.startMonth,min);
        vm.startMonth = getDay('month',vm.templateConfig.startYear,vm.templateConfig.startMonth,min);
        vm.endYear = getDay('year',vm.templateConfig.startYear,vm.templateConfig.startMonth,max);
        vm.endMonth = getDay('month',vm.templateConfig.startYear,vm.templateConfig.startMonth,max);
        vm.defaultDate = [];
        result.forEach(function (item) {
            var year = getDay('year',vm.templateConfig.startYear,vm.templateConfig.startMonth,item);
            var month = getDay('month',vm.templateConfig.startYear,vm.templateConfig.startMonth,item);
            if(vm.defaultDate.length == 0){
                vm.defaultDate.push({
                    year:year,
                    months:[month]
                })
            }else{
                var exist = false;
                for(var i=0; i<vm.defaultDate.length; i++){
                    if(vm.defaultDate[i].year == year){
                        vm.defaultDate[i].months.push(month);
                        exist = true;
                        break
                    }
                }
                if(!exist){
                    vm.defaultDate.push({
                        year:year,
                        months:[month]
                    })
                }
            }
        })

        //保存
        function save() {
            $uibModalInstance.close(true);
        }
        //返回
        function cancel() {
            $uibModalInstance.close(false);
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('platformApp')
        .controller('BoxCopyController', BoxCopyController);

    BoxCopyController.$inject = ['$scope', '$uibModalInstance', 'MessageService','entity'];

    function BoxCopyController( $scope, $uibModalInstance, MessageService,entity) {

        var vm = this;

        vm.clear = clear;
        vm.save = save;
        vm.types = [
            {name: '从当前页开始', page: 'this'},
            {name: '从第一页开始', page: 'first'}
        ];

        vm.data={
            range:'this',
            generLoc:'all'
        }

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        $scope.validate = function () {
            console.log(vm.data)
            if (vm.data.range == null || vm.data.range == "") {
                MessageService.error("请选择范围");
                return false;
            }
            if (vm.data.generLoc == null || vm.data.generLoc == "") {
                MessageService.error("请选择生成位置");
                return false;
            }
            return true;
        };

        function save() {
            if (!$scope.validate()) {
                return;
            }
            onSaveSuccess(vm.data);
        }


        function onSaveSuccess(result) {
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError() {
            vm.isSaving = false;
        }

    }

})();

(function() {
    'use strict';

    angular
        .module('platformApp')
        .controller('BlendentModalController', BlendentModalController);

    BlendentModalController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity'];

    function BlendentModalController ($timeout, $scope, $stateParams, $uibModalInstance, entity) {
        var vm = this;
        vm.cancel = cancel;
        vm.save = save;
        vm.modelData = entity.modelData;
        vm.modelPath = entity.modelPath;
        vm.modelData1 = angular.copy(vm.modelData);

        $scope.colorChange = function () {
            vm.modelData1 = angular.copy(vm.modelData);
        }
        //保存
        function save() {
            $uibModalInstance.close(vm.modelData);
        }
        //返回
        function cancel() {
            $uibModalInstance.close(false);
        }
    }
})();

(function () {
    "use strict";

    angular.module("platformApp").controller("CatalogManagementController", CatalogManagementController);

    CatalogManagementController.$inject = [
        "$state",
        "$scope",
        "$uibModal",
        "$http",
        "$q",
        "Catalog",
        "MessageService",
        "$stateParams",
        "ThemeClassify",
        "entity",
        "$uibModalInstance",
        "$timeout"
    ];

    function CatalogManagementController(
        $state,
        $scope,
        $uibModal,
        $http,
        $q,
        Catalog,
        MessageService,
        $stateParams,
        ThemeClassify,
        entity,
        $uibModalInstance,
        $timeout
    ) {
        var vm = this;
        vm.catalogs = [];
        vm.catalogType = $stateParams.catalogType || entity.catalogType;
        vm.name = "";
        if(vm.catalogType === "CLIPART" || vm.catalogType === "BORDER" || vm.catalogType === "MASK" || vm.catalogType == "BACKGROUND" || vm.catalogType == "GALLERY"){
            vm.name = "标签";
        }else if(vm.catalogType === "LAYOUT"){
            vm.name = "主题";
        }else{
            vm.name = "分类";
        }
        console.log(vm.catalogType);
        $scope.close = function () {
            $uibModalInstance.close();
        };
        //    分类显示
        loadAll();
        function loadAll() {
            if (vm.catalogType == "CLIPART" || vm.catalogType == "BORDER" || vm.catalogType == "MASK" || vm.catalogType == "BACKGROUND" || vm.catalogType == "GALLERY") {
                ThemeClassify.getAllByCondition1(
                    {
                        items: [{ key: "type", op: "=", value: vm.catalogType }]
                    },
                    function (data) {
                        vm.catalogs = data;
                        vm.catalogs.sort(function (a, b) {return a.seq - b.seq;});
                    }
                );
            } else {
                Catalog.getAll(
                    {
                        items: [
                            {
                                key: "catalogType",
                                op: "=",
                                value: vm.catalogType
                            }
                        ]
                    },
                    function (data) {
                        vm.catalogs = data;
                        vm.catalogs.sort(function (a, b) {return a.seq - b.seq;});
                    }
                );
            }
        }
        var sort = null;
        function sortInit(){
            $timeout(function(){
                sort = new Sortable(document.getElementById('pageList'), {
                    swap: false,
                    preventOnFilter: true,
                    animation: 150,
                    onEnd: function (/**Event*/evt) {
                        var item = angular.copy(vm.catalogs[evt.oldIndex])
                        vm.catalogs.splice(evt.oldIndex,1);
                        vm.catalogs.splice(evt.newIndex,0,item);
                        $scope.$apply();
                    }
                });
            },800)
        }
        vm.sortCatalog = false;
        $scope.sortCatalog = function(){
            vm.sortCatalog = true;
            sortInit()
        }

        $scope.sortSave = function(){
            vm.sortCatalog = false;
            vm.catalogs.forEach(function(catalog,index){
                catalog.seq = index;
            })
            if (vm.catalogType == "CLIPART" || vm.catalogType == "BORDER" || vm.catalogType == "MASK" || vm.catalogType == "BACKGROUND" || vm.catalogType == "GALLERY") {
                ThemeClassify.updateSeqByList(vm.catalogs,function (data) {
                    data.status == 200 ? MessageService.success('排序成功') : MessageService.error(data.message || '排序失败');
                    loadAll();
                });
            } else {
                Catalog.updateSeqByList(vm.catalogs,function (data) {
                    data.status == 200 ? MessageService.success('排序成功') : MessageService.error(data.message || '排序失败')
                    loadAll();
                });
            }
        }
        $scope.sortCancel = function(){
            vm.sortCatalog = false;
            loadAll();
        }
        $scope.useCatalog = function (item) {
            if (vm.catalogType == "CLIPART" || vm.catalogType == "BORDER" || vm.catalogType == "MASK" || vm.catalogType == "BACKGROUND" || vm.catalogType == "GALLERY") {
                ThemeClassify.changeStatue({ id: item.id }, onSaveSuccess, onSaveError);
            } else {
                Catalog.usable({ id: item.id }, onSaveSuccess, onSaveError);
            }
        };
        vm.addCatalog = false;
        $scope.addCatalog = function () {
            if (vm.catalogs.length > 0 && vm.catalogs[vm.catalogs.length - 1].id == null) {
                return MessageService.notice("请将新添加的" + vm.name + "保存");
            }
            vm.addCatalog = true;
            if (vm.catalogType == "CLIPART" || vm.catalogType == "BORDER" || vm.catalogType == "MASK" || vm.catalogType == "BACKGROUND" || vm.catalogType == "GALLERY") {
                ThemeClassify.getAllByCondition1(
                    {
                        items: [{ key: "type", op: "=", value: vm.catalogType }]
                    },
                    function (data) {
                        vm.catalogs = data;
                        vm.catalogs.sort(function (a, b) {return a.seq - b.seq;});
                        vm.catalogs.push({
                            used: true,
                            edit: true,
                            type: vm.catalogType,
                            seq: vm.catalogs.length
                        });
                        $("#model-body").animate(
                            {
                                scrollTop: $("#model-body").prop("scrollHeight")
                            },
                            1000
                        );
                        $timeout(function () {
                            $("#model-body .catalog-input:last").focus();
                        }, 500);
                    }
                );
            } else {
                Catalog.getAll(
                    {
                        items: [
                            {
                                key: "catalogType",
                                op: "=",
                                value: vm.catalogType
                            }
                        ]
                    },
                    function (data) {
                        vm.catalogs = data;
                        vm.catalogs.sort(function (a, b) {return a.seq - b.seq;});
                        vm.catalogs.push({
                            usable: true,
                            edit: true,
                            catalogType: vm.catalogType,
                            seq: vm.catalogs.length -1
                        });
                        $("#model-body").animate(
                            {
                                scrollTop: $("#model-body").prop("scrollHeight")
                            },
                            500
                        );
                        $timeout(function () {
                            $("#model-body .catalog-input:last").focus();
                        }, 500);
                    }
                );
            }
        };

        $scope.useCatalog2 = function (item) {
            ThemeClassify.changeStatue({ id: item.id }, onSaveSuccess, onSaveError);
        };
        function onSaveSuccess() {
            loadAll();
            MessageService.success("启停成功");
        }

        function onSaveError() {
            MessageService.error("启停失败");
        }

        $scope.cancel = function (data) {
            loadAll();
            vm.addCatalog = false;
        };

        $scope.edit = function (catalog) {
            if (vm.catalogs[vm.catalogs.length - 1].id == null) {
                MessageService.notice("请将新添加的" + vm.name + "保存");
                return;
            }
            var catalogId = catalog.id;
            if (vm.catalogType == "CLIPART" || vm.catalogType == "BORDER" || vm.catalogType == "MASK"  || vm.catalogType == "BACKGROUND" || vm.catalogType == "GALLERY") {
                ThemeClassify.getAllByCondition1(
                    {
                        items: [{ key: "type", op: "=", value: vm.catalogType }]
                    },
                    function (data) {
                        vm.catalogs = data;
                        vm.catalogs.sort(function (a, b) {return a.seq - b.seq;});
                        vm.catalogs.forEach(function (catalog) {
                            if (catalog.id == catalogId) {
                                catalog.edit = true;
                            }
                        });
                    }
                );
            } else {
                Catalog.getAll(
                    {
                        items: [
                            {
                                key: "catalogType",
                                op: "=",
                                value: vm.catalogType
                            }
                        ]
                    },
                    function (data) {
                        vm.catalogs = data;
                        vm.catalogs.sort(function (a, b) {return a.seq - b.seq;});
                        vm.catalogs.forEach(function (catalog) {
                            if (catalog.id == catalogId) {
                                catalog.edit = true;
                            }
                        });
                    }
                );
            }
        };

        $scope.save = function (data) {
            if (!data.name) {
                MessageService.notice("请输入" + vm.name + "名称");
                return;
            }
            if (data.name.length > 22) {
                MessageService.notice("输入的" + vm.name + "名称长度超出");
                return;
            }
            if (data.id == null) {
                if (vm.catalogType == "CLIPART" || vm.catalogType == "BORDER" || vm.catalogType == "MASK"  || vm.catalogType == "BACKGROUND" || vm.catalogType == "GALLERY") {
                    ThemeClassify.saveForUser(data, function (data) {
                        MessageService.success("保存成功");
                        loadAll();
                        vm.addCatalog = false;
                    });
                } else {
                    Catalog.save(data, function (data) {
                        MessageService.success("保存成功");
                        loadAll();
                        vm.addCatalog = false;
                    });
                }
            } else {
                if (vm.catalogType == "CLIPART" || vm.catalogType == "BORDER" || vm.catalogType == "MASK"  || vm.catalogType == "BACKGROUND" || vm.catalogType == "GALLERY") {
                    ThemeClassify.save(data, function (data) {
                        MessageService.success("保存成功");
                        loadAll();
                        vm.addCatalog = false;
                    });
                } else {
                    Catalog.updateCatalog(data, function (data) {
                        MessageService.success("保存成功");
                        loadAll();
                        vm.addCatalog = false;
                    });
                }
            }
        };

        $scope.delete = function (item, event) {
            event.stopPropagation();
            if (vm.catalogType == "CLIPART" || vm.catalogType == "BORDER" || vm.catalogType == "MASK"  || vm.catalogType == "BACKGROUND" || vm.catalogType == "GALLERY") {
                MessageService.confirm(
                    {
                        title: "提示",
                        cancel: "取消",
                        confirm: "确认",
                        msg: "确认删除该" + vm.name +"吗？",
                        isDelete: true
                    },
                    function () {
                        ThemeClassify.del({ id: item.id }, function (data) {
                            loadAll();
                        });
                    },
                    function () {},
                    true
                );
            } else {
                MessageService.confirm(
                    {
                        title: "提示",
                        cancel: "取消",
                        confirm: "确认",
                        msg: "确认删除该"+ vm.name +"吗？",
                        isDelete: true
                    },
                    function () {
                        Catalog.deleteCatalog({ id: item.id }, function (data) {
                            loadAll();
                        });
                    },
                    function () {},
                    true
                );
            }
        };
    }
})();

(function() {
    'use strict';

    angular
        .module('platformApp')
        .controller('CatalogDialogController', CatalogDialogController);

    CatalogDialogController.$inject = ['$timeout', '$q', '$scope', '$stateParams', '$uibModalInstance','Catalog','entity','MessageService', 'ThemeClassify'];

    function CatalogDialogController ($timeout, $q, $scope, $stateParams, $uibModalInstance, Catalog,entity, MessageService, ThemeClassify) {
        var vm = this;

        vm.catalog = entity;
        vm.clear = clear;
        vm.catalogType = $stateParams.catalogType
        vm.save = save;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        $scope.validate = function(){
            if(vm.catalog.name == null || vm.catalog.name==""){
                MessageService.error("请输入品类名称");
                return false;
            }
            if(vm.catalog.seq == null || vm.catalog.seq==""){
                MessageService.error("请输入序号");
                return false;
            }
            return true;
        };

        function save () {
            if(!$scope.validate()){
                return;
            }
            vm.isSaving = true;
            if(vm.catalogType=='CLIPART' || vm.catalogType=='BORDER'){
                vm.catalog.type = vm.catalogType;
                ThemeClassify.saveForUser(vm.catalog, onSaveSuccess, onSaveError);
                return;
            }

            if($stateParams.id){
                Catalog.updateCatalog({
                    id:$stateParams.id,
                    name:vm.catalog.name,
                    type:'User',
                    seq:vm.catalog.seq,
                    catalogType:vm.catalog.catalogType
                }, onSaveSuccess, onSaveError);
            }else{
                Catalog.createCatalog({
                    name:vm.catalog.name,
                    type:'User',
                    seq:vm.catalog.seq,
                    catalogType:vm.catalog.catalogType
                }, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            MessageService.success("成功");
            $scope.$emit('backApp:catalogUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            MessageService.error("失败");
            vm.isSaving = false;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('platformApp')
        .controller('BuyProductXMLController', BuyProductXMLController);

    BuyProductXMLController.$inject = ['$timeout', '$scope', '$stateParams', 'item', 'ProductXmlPurchase', 'MessageService',
    '$http', '$sce', '$state',  '$uibModalInstance','$localStorage'];

    function BuyProductXMLController ($timeout, $scope, $stateParams,  item, ProductXmlPurchase, MessageService,
        $http, $sce, $state, $uibModalInstance,$localStorage) {
        var vm = this;

        vm.xml = item;
        vm.prepare = false;
        vm.payMethod = "WeChat";
        vm.paymentState = false;
        init();
        function init(){
            var data = {
                productXmlId:vm.xml.id,
                productXmlName:vm.xml.name,
                type: vm.payMethod,
                amount: vm.xml.price,
                name: "模板购买"
            }
            ProductXmlPurchase.create(data ,function(result){
                vm.purchaseId = result.id;
                payInfo();
                $http({
                    url: '/bunny/api/product-xml-purchases/createQRCode/'+vm.purchaseId,
                    method: 'POST',
                    responseType: 'blob'
                }).success(function(res) {
                    vm.prepare = true;
                    var blob = new Blob([res], {
                        type: "image/jpeg"
                    });
                    $scope.image = URL.createObjectURL(blob);
                })
            },function(){
                MessageService.error("创建充值订单失败，请稍后再试");
            })
        }
        $scope.rechargeAlipay = function(){
            vm.paymentState = true;
            var url = $state.href("alipayXml", {item:JSON.stringify(vm.xml)}, {reload: true});
            window.open(url,'_blank');
        }
        $scope.changePayMethod = function(method){
            if (method == null) {
                return;
            }
            vm.payMethod = method;
        }

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        $scope.reback = function(){
            vm.prepare = false;
            if ($scope.timer) {
                clearInterval($scope.timer);
            }
            $uibModalInstance.close();
        }
        vm.user = $localStorage.user;
        if (vm.user == null) {
            Account.get( {}, function(data){
                if (data.status == 200) {
                    vm.user = data.data;
                }
            });
        }
        function payInfo() {
            //启动一个定时器判断是否完成支付，完成则关闭页面 取消定时器
            $scope.timer = setInterval(function() {
                vm.paid = false;
                ProductXmlPurchase.getAllByCondition({items:[{key:"paid", op:"=", value:"true"} ,{key:"userId", op:"=", value:vm.user.id}]}, function (res) {
                    if(res.length>0){
                        for(var i = 0; i<res.length ; i++){
                            var purchase = res[i];
                            if (vm.xml.id == purchase.productXmlId) {
                                vm.paid = true;
                                clearInterval($scope.timer);
                                MessageService.success("支付完成");
                                $uibModalInstance.close();
                                break;
                            }
                        }
                    }
                });
                // ProductXmlPurchase.get({
                //     id: vm.purchaseId
                // }, function(val) {
                //     if (!!val && val.paid) {
                //         vm.paid = true;
                //         clearInterval($scope.timer);
                //         MessageService.success("支付完成");
                //         $uibModalInstance.close(val);
                //     }
                // }, function() {});
            }, 2000);
        }
    }
})();

(function () {
    'use strict';

    var articlePreview = {
        restrict: 'EAC',
        replace: true,
        transclude: true,
        templateUrl: 'app/entities/page/article-preview.html',
        // controller: 'articlePreviewController',
        controllerAs: 'vm',
        bindings: {
            previewArticle: '<',
            domain: '<',
        },

        controller: ['$scope', '$stateParams', '$q', '$http', 'FontManagement', '$timeout', 'MessageService',
            function ($scope, $stateParams, $q, $http, FontManagement, $timeout, MessageService) {
                var vm = this;
                $scope.domain = vm.domain + '/';
                vm.loading = true;
                vm.insidePages = [];
                vm.bindingtypes = [{id:'Tile',name:'平铺模式'}];
                vm.bindingtype = "Tile";
                vm.thisPage = 0;
                editorInit()
                function editorInit() {
                    vm.windowH = window.innerHeight-300;
                    vm.windowW = window.innerWidth*0.8;
                    vm.windowW1 = window.innerWidth*0.5;
                    $scope.template = angular.copy(vm.previewArticle);
                    vm.parts = $scope.template.config.parts.list;
                    vm.productType = $scope.template.config.productType;
                    if(vm.productType == 'BOOK'){
                        vm.bindingtypes = [
                            {id:'Left',name:'左右滑动'},
                            {id:'Tile',name:'平铺模式'},
                        ]
                    }
                    if(vm.productType == 'CALENDAR'){
                        vm.bindingtypes = [
                            {id:'Top',name:'上下滑动'},
                            {id:'Tile',name:'平铺模式'},
                        ]
                    }
                    vm.bindingtype = vm.bindingtypes[0].id;
                    $scope.template.pages.page=[];
                    vm.previewArticle.pages.page.forEach(function (page) {
                        $scope.template.pages.page.push(angular.copy(page));
                    })
                    documentAnalysis($scope, $http, $scope.template,FontManagement, function(page){
                    }, function () {
                        $scope.template.pages.page.forEach(function (page) {
                            if (!page.scene) {
                                pageTrimbox(page)
                            }
                        })
                        ratioInfo()
                        $timeout(function () {
                            if(vm.bindingtype == 'Left'||vm.bindingtype == 'Top'){
                                Page.init();
                            }
                            $timeout(function () {
                                vm.loading = false;
                            },100)
                        },1000)
                    })
                }
                function ratioInfo() {
                    vm.pageMaxWidth = 0;
                    vm.pageMaxHeight = 0;
                    var pageMaxWidtTile = 0;
                    var pageMaxHeightTile = 0;
                    $scope.template.pages.page.forEach(function (page) {
                        page.isUse = false;
                        if (pageMaxWidtTile < page.custom.width && page.config.partid == 'P') {
                            pageMaxWidtTile = page.custom.width;
                        }
                        if (pageMaxHeightTile < page.custom.height) {
                            pageMaxHeightTile = page.custom.height;
                        }
                    })
                    if(pageMaxWidtTile == 0){
                        $scope.template.pages.page.forEach(function (page) {
                            if (pageMaxWidtTile < page.custom.width) {
                                pageMaxWidtTile = page.custom.width;
                            }
                        })
                    }
                    if(vm.bindingtype == "Top"){
                        vm.ratio1 = 80 / pageMaxHeightTile;
                    }else{
                        vm.ratio1 = 80 / pageMaxHeightTile;
                    }
                    vm.ratioTile = vm.windowW1 / pageMaxWidtTile ;
                    if(vm.bindingtype == "Left" || vm.bindingtype == "Tile"){
                        $scope.template.pages.page.forEach(function (page) {
                            page.isUse = false;
                            if(page.config.partid != 'P'){
                                if(page.config.partid == 'B1' || page.config.partid == 'B2') {
                                    if (vm.pageMaxWidth < page.custom.width) {
                                        vm.pageMaxWidth = page.custom.width;
                                    }
                                    if (vm.pageMaxHeight < page.custom.height) {
                                        vm.pageMaxHeight = page.custom.height;
                                    }
                                }
                            }else{
                                if(vm.pageMaxWidth < (page.spread ? page.custom.width : page.custom.width*2)){
                                    vm.pageMaxWidth = (page.spread ? page.custom.width : page.custom.width*2);
                                }
                                if(vm.pageMaxHeight < page.custom.height){
                                    vm.pageMaxHeight = page.custom.height;
                                }
                            }
                        })
                    }
                    if(vm.bindingtype == "Top"){
                        $scope.template.pages.page.forEach(function (page) {
                            page.isUse = false;
                            if(vm.pageMaxWidth < page.custom.width){
                                vm.pageMaxWidth = page.custom.width;
                            }
                            if(vm.pageMaxHeight < (page.spread ? page.custom.height : page.custom.height*2)){
                                vm.pageMaxHeight = (page.spread ? page.custom.height : page.custom.height*2);
                            }
                        })
                    }
                    if(vm.windowH / vm.pageMaxHeight >= vm.windowW / vm.pageMaxWidth ){
                        vm.ratio = vm.windowW / vm.pageMaxWidth;
                    }else {
                        vm.ratio = vm.windowH / vm.pageMaxHeight;
                    }
                    vm.pageMaxWidth = vm.pageMaxWidth*vm.ratio;
                    vm.pageMaxHeight = vm.pageMaxHeight*vm.ratio;
                    $scope.template.pages.page.forEach(function (page, index) {
                        if(page.config.partid == 'P' || page.config.partid == 'B1' || page.config.partid == 'B2'){
                            page.ratio = vm.ratio;
                        }else{
                            var _width = (page.spread || page.config.partid != 'P' ? page.custom.width : page.custom.width*2);
                            var _height = page.custom.height;
                            if(vm.bindingtype == "Top"){
                                _width = page.custom.width;
                                _height = page.custom.height*2
                            }
                            if(!vm.landscape){
                                if(vm.windowH / _height >= vm.windowW / _width ){
                                    page.ratio = vm.windowW / _width;
                                }else {
                                    page.ratio = vm.windowH / _height;
                                }
                            }else{
                                if(vm.windowH / _width >= vm.windowW / _height ){
                                    page.ratio = vm.windowW / _height;
                                }else {
                                    page.ratio = vm.windowH / _width;
                                }
                            }
                        }
                        // if(index == 0){
                        //     vm.pageMaxWidth = _width * page.ratio;
                        //     vm.pageMaxHeight = _height * page.ratio;
                        // }else{
                        if(vm.pageMaxWidth < _width * page.ratio){
                            vm.pageMaxWidth = _width * page.ratio;
                        }
                        if(vm.pageMaxHeight < _height * page.ratio){
                            vm.pageMaxHeight = _height * page.ratio;
                        }
                        // }
                        for(var i=0; i<vm.parts.length; i++){
                            if(vm.parts[i].id == page.config.partid){
                                if(!vm.parts[i].pages){
                                    vm.parts[i].pages = [];
                                }
                                vm.parts[i].pages.push(page)
                                break
                            }
                        }
                    })
                    if(vm.productType == 'BOOK'||vm.productType == 'CALENDAR'){
                        for(var i=0; i<vm.parts.length; i++){
                            if(vm.parts[i].pages){
                                if(vm.parts[i].id == 'P'){
                                    vm.parts[i].pages.forEach(function (page, index) {
                                        var emptyPage = angular.copy(page);
                                        if(!emptyPage.background){
                                            emptyPage.background = {
                                                color:'#000000',
                                                resource:{
                                                    identifier:''
                                                }
                                            }
                                        }else{
                                            emptyPage.background.color = "#000000";
                                            emptyPage.background.resource.identifier="";
                                        }
                                        emptyPage.barcode = null;
                                        emptyPage.qrcode = null;
                                        emptyPage.pagecover = null;
                                        emptyPage.levels = {
                                            level: []
                                        };
                                        emptyPage.marginLeft = 0;
                                        if(!page.isUse){
                                            if(index == 0 && $scope.template.config.innerOffset == 1 && !page.spread){
                                                page.isUse = true;
                                                page.marginLeft = 0;
                                                if(page.spread){
                                                    page.custom.width = page.custom.width/2;
                                                    page.spread = false;
                                                }
                                                if(emptyPage.spread){
                                                    emptyPage.custom.width = emptyPage.custom.width/2;
                                                    emptyPage.spread = false;
                                                }
                                                emptyPage.marginLeft = vm.bindingtype == 'Left' ? vm.pageMaxWidth/2-emptyPage.custom.width * emptyPage.ratio : vm.pageMaxHeight/2-emptyPage.custom.height * emptyPage.ratio;
                                                setPageOrder(page)
                                                vm.insidePages.push({
                                                    page1:emptyPage,
                                                    page2:page,
                                                    partid: vm.parts[i].id,
                                                    spread:false
                                                })
                                            }else{
                                                if(page.spread){
                                                    page.isUse = true;
                                                    page.marginLeft = vm.bindingtype == 'Left' ? (vm.pageMaxWidth-page.custom.width * page.ratio) / 2 : (vm.pageMaxHeight-page.custom.height * page.ratio) / 2;
                                                    var _page = angular.copy(page);
                                                    _page.marginLeft = vm.bindingtype == 'Left' ? -_page.custom.width*_page.ratio/2 : -_page.custom.height*_page.ratio/2;
                                                    setPageOrder(page)
                                                    setPageOrder(_page)
                                                    vm.insidePages.push({
                                                        page1:page,
                                                        page2:_page,
                                                        partid: vm.parts[i].id,
                                                        spread:true
                                                    })
                                                }else{
                                                    var _page1 = vm.parts[i].pages[index];
                                                    var _page2 = index+1 >= vm.parts[i].pages.length ? null : vm.parts[i].pages[index+1];
                                                    _page1.isUse = true;
                                                    _page1.marginLeft = vm.bindingtype == 'Left' ? vm.pageMaxWidth/2-_page1.custom.width * _page1.ratio : vm.pageMaxHeight/2-_page1.custom.height * _page1.ratio;
                                                    setPageOrder(_page1)
                                                    if(_page2 && !_page2.spread){
                                                        _page2.isUse = true;
                                                        _page2.marginLeft = 0;
                                                        setPageOrder(_page2)
                                                        vm.insidePages.push({
                                                            page1:_page1,
                                                            page2:_page2,
                                                            partid: vm.parts[i].id,
                                                            spread:false
                                                        })
                                                    }else{
                                                        emptyPage.marginLeft = 0;
                                                        vm.insidePages.push({
                                                            page1:_page1,
                                                            page2:emptyPage,
                                                            partid: vm.parts[i].id,
                                                            spread:false
                                                        })
                                                    }
                                                }
                                            }
                                        }
                                    });
                                }else{
                                    vm.parts[i].pages.forEach(function (page, index) {
                                        if(vm.productType == 'CALENDAR' && (vm.parts[i].id == 'B1' || vm.parts[i].id == 'B2')){
                                            if(page.spread){
                                                page.isUse = true;
                                                page.marginLeft = vm.bindingtype == 'Left' ? (vm.pageMaxWidth-page.custom.width * page.ratio) / 2 : (vm.pageMaxHeight-page.custom.height * page.ratio) / 2;
                                                var _page = angular.copy(page);
                                                _page.marginLeft = vm.bindingtype == 'Left' ? -_page.custom.width*_page.ratio/2 : -_page.custom.height*_page.ratio/2;
                                                vm.insidePages.push({
                                                    page1:page,
                                                    page2:_page,
                                                    partid: vm.parts[i].id,
                                                    spread:true
                                                })
                                            }else{
                                                var emptyPage = angular.copy(page);
                                                if(!emptyPage.background){
                                                    emptyPage.background = {
                                                        color:'',
                                                        resource:{
                                                            identifier:''
                                                        }
                                                    }
                                                }else{
                                                    emptyPage.background.color = "";
                                                    emptyPage.background.resource.identifier="";
                                                }
                                                emptyPage.boxShadow = true;
                                                emptyPage.barcode = null;
                                                emptyPage.qrcode = null;
                                                emptyPage.levels = {
                                                    level: []
                                                };
                                                emptyPage.marginLeft = 0;
                                                page.isUse = true;
                                                if(vm.parts[i].id == 'B1'){
                                                    page.marginLeft = 0;
                                                    emptyPage.marginLeft = vm.bindingtype == 'Left' ? vm.pageMaxWidth/2-emptyPage.custom.width * emptyPage.ratio : vm.pageMaxHeight/2-emptyPage.custom.height * emptyPage.ratio;
                                                    emptyPage.pagecover = null; // 修复bug #8182 日历上下滑动预览多了一页封面
                                                    vm.insidePages.push({
                                                        page1:emptyPage,
                                                        page2:page,
                                                        partid: vm.parts[i].id,
                                                        spread:false
                                                    })
                                                }
                                                if(vm.parts[i].id == 'B2'){
                                                    emptyPage.marginLeft = 0;
                                                    page.marginLeft = vm.bindingtype == 'Left' ? vm.pageMaxWidth/2-page.custom.width * page.ratio : vm.pageMaxHeight/2-page.custom.height * page.ratio;
                                                    vm.insidePages.push({
                                                        page1:page,
                                                        page2:emptyPage,
                                                        partid: vm.parts[i].id,
                                                        spread:false
                                                    })
                                                }
                                            }
                                        }else{
                                            page.pageNumber=index;
                                            page.isUse = true;
                                            page.marginLeft = vm.bindingtype == 'Left' ? (vm.pageMaxWidth-page.custom.width * page.ratio) / 2 : (vm.pageMaxHeight-page.custom.height * page.ratio) / 2;
                                            var _page = angular.copy(page);
                                            _page.marginLeft = vm.bindingtype == 'Left' ? -_page.custom.width*_page.ratio/2 : -_page.custom.height*_page.ratio/2;
                                            vm.insidePages.push({
                                                page1:page,
                                                page2:_page,
                                                partid: vm.parts[i].id,
                                                spread:false
                                            })
                                        }
                                    })
                                }
                            }
                        }
                    }
                }
                var pageOrder = 0;
                function setPageOrder(page){
                    pageOrder++;
                    page.pageNumber=pageOrder<10?'0'+pageOrder:pageOrder;
                }
                $scope.bindingtypeInfo = function () {
                    var _name = "";
                    vm.bindingtypes.forEach(function (item) {
                        if(vm.bindingtype == item.id){
                            _name = item.name;
                        }
                    })
                    return _name
                };
                $scope.bindingtypeSelect = function (item) {
                    if(item.id === vm.bindingtype) return;
                    vm.bindingtype = item.id;
                    if(vm.bindingtype == 'Left'||vm.bindingtype == 'Top'){
                        vm.loading = true;
                        $timeout(function () {
                            vm.thisPage = 0;
                            config.$bookBlock.bookblock('update');
                            config.$bookBlock.bookblock('jump', (vm.thisPage-0+1));
                            vm.loading = false;
                        },100)
                    }
                }

                var config = {
                    $bookBlock: $('#bb-bookblock'),
                    $navNext: $('#bb-nav-next'),
                    $navPrev: $('#bb-nav-prev'),
                    $slide1: $('#slide1'),
                    $slide2: $('#slide2')
                };
                var Page = (function() {
                    var config = {
                            $bookBlock : $( '#bb-bookblock' ),
                            $navNext : $( '#bb-nav-next' ),
                            $navPrev : $( '#bb-nav-prev' )
                        },
                        init = function() {
                            config.$bookBlock.bookblock( {
                                orientation : vm.bindingtype == "Left" ? 'vertical' : 'horizontal',
                                speed : 800,
                                shadowSides : 0.8,
                                shadowFlip : 0.7,
                                onBeforeFlip: function(page) {
                                    vm.isBefore = true;
                                },
                                onEndFlip: function(page, isLimit) {
                                    vm.isBefore = false;
                                    return false;
                                },
                            } );
                            initEvents();
                            $scope.$apply();
                        },
                        initEvents = function() {
                            var $slides = config.$bookBlock.children();
                            // add navigation events
                            config.$navNext.on( 'click touchstart', function() {
                                config.$bookBlock.bookblock( 'next' );
                                return false;
                            } );

                            config.$navPrev.on( 'click touchstart', function() {
                                config.$bookBlock.bookblock( 'prev' );
                                return false;
                            } );

                            // add keyboard events
                            $( document ).keydown( function(e) {
                                var keyCode = e.keyCode || e.which,
                                    arrow = {
                                        left : 37,
                                        up : 38,
                                        right : 39,
                                        down : 40
                                    };

                                if(vm.bindingtype =='Top') {
                                    switch (keyCode) {
                                        case arrow.up:
                                            config.$bookBlock.bookblock('prev');
                                            e.preventDefault();
                                            break;
                                        case arrow.down:
                                            config.$bookBlock.bookblock('next');
                                            e.preventDefault();
                                            break;
                                    }
                                }
                                if(vm.bindingtype =='Left'){
                                    switch (keyCode) {
                                        case arrow.left:
                                            config.$bookBlock.bookblock( 'prev' );
                                            e.preventDefault();
                                            break;
                                        case arrow.right:
                                            config.$bookBlock.bookblock( 'next' );
                                            e.preventDefault();
                                            break;
                                    }
                                }

                            } );
                        };

                    return { init : init };

                })();
                $scope.flipPage = function(event,index, bindingtype){
                    var element = $("#bb-bookblock");
                    if(!bindingtype){
                        var clickX = event.clientX;
                        var elementX = element.offset().left;
                        var halfWidth = element.outerWidth() / 2;
                    }else{
                        var clickX = event.clientY;
                        var elementX = element.offset().top;
                        var halfWidth = element.outerHeight() / 2;
                    }
                    if (clickX < elementX + halfWidth) {
                        $scope.prevPage(index)
                    } else {
                        $scope.nextPage(index)
                    }
                }
                $scope.nextPage = function(index){
                    if(vm.isBefore){
                        return
                    }
                    if(index==vm.insidePages.length-1){
                        MessageService.error("最后一页");
                        return
                    }
                    vm.thisPage = index+1;
                    config.$bookBlock.bookblock('next');
                    firstPageInit()
                };
                $scope.prevPage = function(index){
                    if(vm.isBefore){
                        return
                    }
                    if(index==0){
                        if(window.innerWidth>1000){
                            MessageService.error("第一页");
                        }
                        return
                    }
                    vm.thisPage = index-1;
                    config.$bookBlock.bookblock('prev');
                    firstPageInit()
                };
                $scope.landscape = function (item) {
                    vm.landscape = item;
                    ratioInfo();
                    $timeout(function () {
                        Page.init();
                    })
                };

                $scope.firstPageCb = function () {
                    if(vm.thisPage==0){
                        MessageService.error("第一页");
                        return
                    }
                    vm.thisPage = 0;
                    config.$bookBlock.bookblock('first');
                    firstPageInit()
                };
                $scope.lastPageCb = function () {
                    if(vm.thisPage==vm.insidePages.length-1){
                        MessageService.error("最后一页");
                        return
                    }
                    vm.thisPage = vm.insidePages.length-1;
                    config.$bookBlock.bookblock('last');
                    firstPageInit()
                };
                function firstPageInit(){
                }
                $scope.jumpPage = function (partid, index) {
                    if(vm.isBefore){
                        return
                    }
                    var _pageIndex = 0;
                    if(partid != 'P'){
                        for(var i=0; i<vm.insidePages.length; i++){
                            if(vm.insidePages[i].partid == partid){
                                _pageIndex = i;
                                break
                            }
                        }
                    }else{
                        _pageIndex = index;
                    }
                    vm.thisPage = _pageIndex;
                    config.$bookBlock.bookblock('jump', (_pageIndex-0+1));
                    firstPageInit()
                }
                $scope.prevPartShow = function (item) {
                    if(!vm.insidePages[vm.thisPage]){
                        return
                    }
                    var _part = vm.insidePages[vm.thisPage].partid;
                    var _returnItem = false;
                    if(item == 'prev'){
                        for(var i=0; i<vm.thisPage; i++){
                            if(vm.insidePages[i].partid != _part){
                                _returnItem = true;
                                break
                            }
                        }
                    }
                    if(item == 'next'){
                        for(var i=vm.thisPage; i<vm.insidePages.length; i++){
                            if(vm.insidePages[i].partid != _part){
                                _returnItem = true;
                                break
                            }
                        }
                    }
                    return _returnItem
                }
                $scope.prevPart = function () {
                    if(vm.isBefore){
                        return
                    }
                    var _part = vm.insidePages[vm.thisPage].partid;
                    for(var i=vm.thisPage; i>=0; i--){
                        if(vm.insidePages[i].partid != _part){
                            vm.thisPage = i;
                            config.$bookBlock.bookblock('jump', (vm.thisPage-0+1));
                            break
                        }
                    }
                }
                $scope.nextPart = function () {
                    if(vm.isBefore){
                        return
                    }
                    var _part = vm.insidePages[vm.thisPage].partid;
                    for(var i=vm.thisPage; i<vm.insidePages.length; i++){
                        if(vm.insidePages[i].partid != _part){
                            vm.thisPage = i;
                            config.$bookBlock.bookblock('jump', (vm.thisPage-0+1));
                            break
                        }
                    }
                }
            }]
    };

    angular
        .module('platformApp')
        .component('articlePreview', articlePreview);
})();

(function() {
    'use strict';

    angular
        .module('platformApp')
        .controller('AlipayXMLController', AlipayXMLController);

    AlipayXMLController.$inject = ['$timeout', '$scope', '$stateParams', 'ProductXmlPurchase', 'MessageService',
    '$http', '$sce', '$state'];

    function AlipayXMLController ($timeout, $scope, $stateParams, ProductXmlPurchase, MessageService,
        $http, $sce, $state) {
        var vm = this;

        if($stateParams.item){
            vm.prepare = false;
            vm.xml = JSON.parse($stateParams.item);
        }else {
            window.close();
            vm.prepare = true;
        }
        vm.payMethod = "Alipay";
        init();
        function init(){
            var data = {
                productXmlId:vm.xml.id,
                productXmlName:vm.xml.name,
                type: vm.payMethod,
                amount: vm.xml.price,
                name: "模板购买"
            }
            ProductXmlPurchase.create(data ,function(result){
                vm.purchaseId = result.id;
                ProductXmlPurchase.get({
                    id: vm.purchaseId
                }, function(val) {
                    if (!!val && val.paid) {
                        vm.prepare = true;
                        MessageService.success("支付完成");
                        window.close()
                    }else {
                        ProductXmlPurchase.aliPay({
                            id:vm.purchaseId,
                            returnUrl: window.location.href.substring(0,window.location.href.indexOf("?"))
                        },function(data){
                            if(!!data && data.status == 200){
                                $scope.trustHtml = $sce.trustAsHtml(data.message);
                            }
                        },function(){
                        });
                    }
                }, function() {});
            },function(){
                MessageService.error("创建充值订单失败，请稍后再试");
            })
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('platformApp')
        .controller('NoticeDetailController', NoticeDetailController);

    NoticeDetailController.$inject = ['$state', '$scope', 'Notice', 'ParseLinks', 'paginationConstants',  'entity', '$uibModalInstance'];

    function NoticeDetailController($state, $scope, Notice, ParseLinks, paginationConstants, entity, $uibModalInstance) {

        var vm = this;
        vm.notice = entity; 
        $scope.$emit('platformApp:noticeUpdate');

        $scope.cancel = function(){
            $uibModalInstance.close(vm.notice);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('platformApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('notice', {
            parent: 'app2',
            url: '/notice',
            data: {
                authorities: [],
                pageTitle: 'platformAppTitle.notice'
            },
            views: {
                'content2': {
                    templateUrl: 'app/entities/notice/notice.html',
                    controller: 'NoticeController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
    }

})();

(function() {
    'use strict';

    angular
        .module('platformApp')
        .controller('NoticeController', NoticeController);

    NoticeController.$inject = ['$state', '$scope', 'Notice', 'ParseLinks', 'paginationConstants', 'MessageService', '$uibModal'];

    function NoticeController($state, $scope, Notice, ParseLinks, paginationConstants, MessageService, $uibModal) {

        var vm = this;
        $(".sidebar1").hide();
        $(".navbar").show();
        $(".nav-bg").show();
        $(".wrap").css({margin: 0});
        vm.tab = ""

        loadAll();

        $scope.checkoutTab = function(tab){
            vm.tab = tab
            var items=[];
            if (!!vm.tab) {
                items.push({key:"noticeType", op:"=", value:tab});
            }
            Notice.getAllByCondition1({items: items}, onSuccess, onError);
        }

        $scope.giveNoticeCb = function(data){
            if (!data.read) {
                Notice.read({id:data.id});
            }
            $uibModal.open({
                templateUrl: 'app/entities/notice/notice-detail.html',
                controller: 'NoticeDetailController',
                backdrop: 'static',
                keyboard: true,
                windowClass: "jh-modal-md",
                controllerAs: 'vm',
                size:'lg',
                resolve: {
                    entity: data,
                }
            }).result.then(function(res) {
                data.read = true; 
            });
        }

        function onSuccess(data, headers) {
            vm.data = data.message;
        }
        function onError(error) {
            MessageService.error("数据加载失败");
        }

        function loadAll () { 
            Notice.getAllByCondition1({ }, onSuccess, onError);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('platformApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('mycenter', {
                parent: 'app',
                url: '/mycenter?page&sort&search&modelType',
                data: {
                    authorities: [],
                    pageTitle: 'platformAppTitle.mycenter'
                },
                views: {
                    'content': {
                        templateUrl: 'app/entities/mycenter/mycenter.html',
                        controller: 'MycenterController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    },
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search,
                            modelType: $stateParams.modelType,
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('productXml');
                        $translatePartialLoader.addPart('reprintType');
                        $translatePartialLoader.addPart('frontStatus');
                        $translatePartialLoader.addPart('patternType');
                        $translatePartialLoader.addPart('global');
                        $translatePartialLoader.addPart('title');
                        return $translate.refresh();
                    }]
                }
            });
    }

})();

(function() {
    'use strict';
    angular
        .module('platformApp')
        .factory('GetSetDpi', GetSetDpi)
        .factory('GetSetDpi2', GetSetDpi2);

    GetSetDpi.$inject = ['$resource'];
    GetSetDpi2.$inject = ['$resource'];

    function GetSetDpi($resource) {
        var resourceUrl = 'bunny/' + 'api/precision-settings/:path/:id';

        return $resource(resourceUrl, {}, {

            "getCurrent": {
                method: 'GET',
                params: {
                    path: "getCurrent"
                },
            },
            "submitDpi": {
                method: 'PUT',
            },
        });
    }

    function GetSetDpi2($resource) {
        var resourceUrl = 'bunny/' + 'api/precision-items/:path/:id';

        return $resource(resourceUrl, {}, {
            "getAllByCondition": {
                method: 'POST',
                params: {
                    path: "getAllByCondition"
                },
            },
        });
    }
})();
(function() {
    'use strict';

    angular
        .module('platformApp')
        .controller('MycenterController', MycenterController);

    MycenterController.$inject = ['$scope', '$timeout', '$state', "$q", 'Moulds', 'ParseLinks', 'AlertService', 'paginationConstants',
        'pagingParams', 'MessageService', 'Qinius', '$uibModal', 'GetSetDpi', 'GetSetDpi2'
    ];

    function MycenterController($scope, $timeout, $state, $q, Moulds, ParseLinks, AlertService, paginationConstants,
        pagingParams, MessageService, Qinius, $uibModal, GetSetDpi, GetSetDpi2) {
        var vm = this;
        vm.edit = false;
         
        vm.gitDpi = GetSetDpi.getCurrent()
        vm.gitDpiOptions;
        // 请求页面数据
        $q.all([vm.gitDpi.$promise]).then(function() {
            $scope.store = vm.gitDpi.message;
        }).then(function() {
            GetSetDpi2.getAllByCondition({"sort":["value,asc"]}, function(res) {
                vm.gitDpiOptions = res.message
            })
        });

        // 确认提交
        $scope.submitDpi = function() {
            GetSetDpi.submitDpi($scope.store, function(res) {
                if (res.status == 200) {
                    vm.edit = false;
                    MessageService.success("保存成功");
                } else {
                    MessageService.error("失败");
                }
            })
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('platformApp')
        .controller('PicDetailController', PicDetailController);

        PicDetailController.$inject = ['$timeout', "$q", '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Galleries',
            'MessageService','ThemeClassify','$http','$uibModal'];

    function PicDetailController ($timeout, $q, $scope, $stateParams, $uibModalInstance, entity, Galleries,
        MessageService,ThemeClassify, $http,$uibModal) {

        var vm = this;
        vm.data = entity;
        vm.save = save;
        vm.themeClassifies = ThemeClassify.getAllByCondition1({items:[{key:"type",value:"GALLERY", op:"="},{key:"used",value:"true", op:"="}]});

        $scope.cancel = function(){
            $uibModalInstance.dismiss('cancel');
        }

        function save (){
            Galleries.update(vm.data, function(res){
                MessageService.success("保存成功");
                $uibModalInstance.close(res);
            }, function(ers){
                MessageService.error("保存失败,请稍后再试");
                $uibModalInstance.dismiss('cancel');
            })
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('platformApp')
        .controller('PicController', PicController);

    PicController.$inject = ['$scope', '$state', 'Galleries', 'ParseLinks', 'paginationConstants',
     'pagingParams', 'MessageService', 'Qinius', '$q', '$uibModal', 'UidService', '$timeout','ThemeClassify'];

    function PicController ($scope, $state, Galleries, ParseLinks, paginationConstants,
     pagingParams, MessageService, Qinius, $q, $uibModal, UidService, $timeout,ThemeClassify) {
        var vm = this;

        vm.tabs = [{key:"background", value:"背景", url:'background'},
        {key:"imageBox", value:"相框", url:'mask'},
        {key:"borderBox", value:"边框", url:'frame-control'},
        {key:"font", value:"字体", url:'font-management'},
        {key:"clipArt", value:"素材", url:'clip-art'},
        {key:"image", value:"图片", url:'pic'}];
        vm.currentName = "image";
        vm.count = 0;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.clear = clear;
        vm.search = search;
        vm.loadAll = loadAll;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;
        vm.jump = jump;
        vm.exitSure = false;
        vm.galleries = [];
        vm.size = 15;
        var bigSizePics= [];
        vm.totalItems = 0;
        vm.tagScreenIsOpen = false;
        vm.tokenTime = 360000;
        // Qinius.get(function (msg) {
        //     vm.token = msg.token;
        //     vm.tokenTime = parseInt((msg.expireAt - new Date().getTime()));
        // });
        vm.themeClassifies = ThemeClassify.getAllByCondition1({items:[
            {key:"type",value:"GALLERY", op:"="},
            {key:"used",value:"true", op:"="}]});
        vm.domain = Qinius.getDomain();
        vm.themeClassifyId = pagingParams.c - 0;

        $scope.domains = Qinius.getDomain();
        $q.all([$scope.domains.$promise]).then(function () {
            // token过期
            setTimeout(function fn() {
                Qinius.get(function (msg) {
                    vm.token = msg.token;
                    vm.tokenTime = parseInt((msg.expireAt - new Date().getTime()));
                });
                setTimeout(fn, vm.tokenTime);
            }, vm.tokenTime);
            vm.url = $scope.domains.domain;
            // loadAll();
            vm.themeClassifies.unshift({name:"全部", id:"全部", seq:-1});
            $scope.selectTag(vm.themeClassifies[0]);
        });


        $scope.view = function(data){
            $uibModal.open({
                templateUrl: 'app/entities/my-upload/background-view.html',
                controller: 'BackGroundViewController',
                backdrop: 'static',
                keyboard: true,
                windowClass: "jh-modal-md",
                controllerAs: 'vm',
                resolve: {
                    entity: data,
                }
            }).result.then(function(res) {
            });
        }

        $scope.delete = function(item){
            MessageService.confirm({
                    title:'提示',
                    cancel:'取消',
                    confirm:'确认',
                    msg:'确定要删除该图片？'
                }, function(){
                Galleries.delete({id:item.id}, function(res){
                    MessageService.success("删除成功");
                    loadAll();
                }, function(va){
                    MessageService.error("删除失败，请稍后再试");
                })
            })
        }

        $scope.more = function(item){
            vm.galleries.forEach(function(it){
                it.more = false;
            });
            item.more = true;
        }

        $scope.batchDelet = function(){
            var ids = [];
            vm.galleries.forEach(function(it){
                if (it.selected) {
                    ids.push(it.id);
                }
            });
            if (ids.length>0) {
                MessageService.confirm({
                    title:'提示',
                    cancel:'取消',
                    confirm:'确认',
                    msg:'确定要删除所选图片？'
                }, function(){
                    Galleries.batchDelete({ids_:ids}, function(res){
                        MessageService.success("删除成功");
                        loadAll();
                        vm.batch = false;
                        vm.count = 0;
                    }, function(va){
                        MessageService.error("删除失败，请稍后再试");
                    })
                })
            }else{
                MessageService.error("未勾选任何有效的背景，请确认后再操作");
            }
        }


        $scope.exitBatch = function(){
            vm.galleries.forEach(function(it){
                it.selected = false;
            })
            vm.batch = false;
            vm.count = 0;
        }

        $scope.itemSelect = function(item){
            if (!vm.batch) {
                return
            }
            item.selected = !item.selected;
            vm.count = 0;
            vm.galleries.forEach(function(it){
                if (it.selected) {
                    vm.count ++;
                }
            })
        }

        function thumbnailatorPic() {
            $uibModal.open({
                templateUrl: 'app/entities/page/thumbnailator.html',
                controller: 'ThumbnailatorController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'md',
                resolve: {
                    entity: [function () {
                        return {
                            files: bigSizePics
                        };
                    }]
                }
            }).result.then(function (values) {
                bigSizePics = [];
                if (values) {
                    var len = 0;
                    if (vm.showBackgrounds && vm.showBackgrounds.length) {
                        len = vm.showBackgrounds.length;
                    }
                    for (var i = 0; i < values.length; i++) {
                        getUserImg(values, i);
                    }
                }
            }, function () {
            });
        }
        var addTimer = null;
        function getUserImg(files, i) {
            var url = window.URL || window.webkitURL;
            var img = new Image();              //手动创建一个Image对象
            img.src = url.createObjectURL(files[i]);//创建Image的对象的url
            img.crossOrigin = "Anonymous";
            var arr = {
                'identifier': '',
                'provider': 'qiniu',
                'fileName': '',
                'imgSize': 0,
                'width': 0,
                'height': 0,
                'userId': '',
            };
            var formData = new FormData();
            formData.append('file', files[i]);
            formData.append('key', 'gallery-' + UidService.get());
            formData.append('token', vm.token);
            $.ajax({
                cache: true,
                type: "POST",
                url: 'https://upload.qiniup.com/',
                data: formData,
                async: true,
                contentType: false,
                processData: false,
                success: function (data) {
                    arr.identifier = data.key;
                    Galleries.upload(arr, function (res) {
                        res.identifier = vm.url + res.identifier;
                        vm.galleries.unshift(res)
                        if(addTimer){
                            clearTimeout(addTimer);
                            addTimer = null;
                        }
                        addTimer = setTimeout(function(){
                            vm.page = 1;
                            loadAll();
                        },200)
                    });
                },
                error: function (request) {
                    console.log("error");
                }
            });

        }

        // 当前页变更
        vm.currentChange = function(){
            $timeout(function(){
                loadAll();
            })
        }

        function loadAll () {
            var items = [];
            vm.galleries = [];
            if (vm.themeClassifyId) {
                items.push({key:"themeClassify.id",value:vm.themeClassifyId, op:"="})
            }
            if (pagingParams.search) {
                items.push({key:"name",value:pagingParams.search, op:"like"})

            }
            Galleries.byConditionNew({
                items: items,
                page: vm.page-1,
                size: vm.size,
                sort: ["id,desc"]
            }, function (res, headers) {
                vm.totalItems = headers('X-Total-Count');
                res.some(function (item, i) {
                    item.identifier = vm.url + item.identifier
                    vm.galleries.push(item);
                })
                vm.count = 0;

            })
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'desc' : 'asc'),
                search: vm.currentSearch
            });
        }

        function search(searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear() {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }

        function jump () {
            vm.page = vm.jumpText<=0?1:vm.jumpText;
            vm.transition();
        }

        $scope.selectTag = function(item){
            vm.themeClassifies.forEach(function(it){
                it.active = false;
            })
            item.active = true;
            if (item.id == '全部') {
                vm.themeClassifyId = null;
            }else{
                vm.themeClassifyId = item.id;
            }
            loadAll();
        }
        $scope.editTag = function(){
            $uibModal.open({
                templateUrl: 'app/entities/page/catalog-management.html',
                controller: 'CatalogManagementController',
                backdrop: 'static',
                keyboard: true,
                windowClass: "jh-modal-md",
                controllerAs: 'vm',
                resolve: {
                    entity: function () {
                        return {catalogType: "GALLERY"}
                    }
                }
            }).result.then(function(res) {
                ThemeClassify.getAllByCondition1({items:[
                    {key:"type",value:"GALLERY", op:"="},
                    {key:"used",value:"true", op:"="}]}, function(data){
                        vm.themeClassifies = data;
                        vm.themeClassifies.unshift({name:"全部", id:"全部" , seq:-1});
                        $scope.selectTag(vm.themeClassifies[0]);
                    });
            });
        }

        $scope.addPic = function () {
            $uibModal.open({
                templateUrl: 'app/entities/my-upload/modal/pic-add.html',
                controller: 'PicAddController',
                backdrop: 'static',
                keyboard: true,
                windowClass: "jh-modal-md",
                controllerAs: 'vm',
                resolve: {
                    entity: [function () {
                        return {};
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        return $translate.refresh();
                    }]
                }
            }).result.then(function(state) {
                if(state){
                    vm.page = 1;
                    vm.loadAll();
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('platformApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('background', {
            parent: 'app',
            url: '/background?page&sort&search',
            data: {
                authorities: [],
                pageTitle: 'platformAppTitle.myUpload'
            },
            views: {
                'content': {
                    templateUrl: 'app/entities/my-upload/background.html',
                    controller: 'BackGroundController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('productXmlPurchase');
                    $translatePartialLoader.addPart('global');
                    $translatePartialLoader.addPart('title');
                    return $translate.refresh();
                }]
            }
        })
        .state('background.updateTag', {
            parent: 'background',
            url: '/{id}/updateTag',
            data: {
                authorities: []
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/my-upload/update-tag.html',
                    controller: 'BackgroundDetailController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                        entity: ['Backgrounds', function(Backgrounds) {
                            return Backgrounds.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('background', {}, {reload: true});
                }, function() {
                    $state.go('background');
                });
            }]
        })

        .state('pic', {
            parent: 'app',
            url: '/pic?page&sort&search',
            data: {
                authorities: [],
                pageTitle: 'platformAppTitle.myUpload'
            },
            views: {
                'content': {
                    templateUrl: 'app/entities/my-upload/pic.html',
                    controller: 'PicController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('productXmlPurchase');
                    $translatePartialLoader.addPart('global');
                    $translatePartialLoader.addPart('title');
                    return $translate.refresh();
                }]
            }
        })
        .state('pic.updateTag', {
            parent: 'pic',
            url: '/{id}/updateTag',
            data: {
                authorities: []
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/my-upload/update-tag.html',
                    controller: 'PicDetailController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                        entity: ['Galleries', function(Galleries) {
                            return Galleries.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('pic', {}, {reload: true});
                }, function() {
                    $state.go('pic');
                });
            }]
        })

        .state('mask', {
            parent: 'app',
            url: '/mask?page&sort&search',
            data: {
                authorities: [],
                pageTitle: 'platformAppTitle.myUpload'
            },
            views: {
                'content': {
                    templateUrl: 'app/entities/my-upload/mask.html',
                    controller: 'MaskController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('productXmlPurchase');
                    $translatePartialLoader.addPart('global');
                    $translatePartialLoader.addPart('title');
                    return $translate.refresh();
                }]
            }
        })
        .state('mask.updateTag', {
            parent: 'mask',
            url: '/{id}/updateTag',
            data: {
                authorities: []
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/my-upload/update-tag.html',
                    controller: 'MaskDetailController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                        entity: ['SourceMaterial', function(SourceMaterial) {
                            return SourceMaterial.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('mask', {}, {reload: true});
                }, function() {
                    $state.go('mask');
                });
            }]
        })

        .state('clip-art', {
            parent: 'app',
            url: '/clip-art?page&sort&search',
            data: {
                authorities: [],
                pageTitle: 'platformAppTitle.myUpload'
            },
            views: {
                'content': {
                    templateUrl: 'app/entities/my-upload/clipArt.html',
                    controller: 'ClipArtController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('productXmlPurchase');
                    $translatePartialLoader.addPart('global');
                    $translatePartialLoader.addPart('title');
                    return $translate.refresh();
                }]
            }
        })
        .state('clip-art.updateTag', {
            parent: 'clip-art',
            url: '/{id}/updateTag',
            data: {
                authorities: []
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/my-upload/update-tag.html',
                    controller: 'ClipArtDetailController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                        entity: ['ClipArts', function(ClipArts) {
                            return ClipArts.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('clip-art', {}, {reload: true});
                }, function() {
                    $state.go('clip-art');
                });
            }]
        })
         ;
    }

})();

(function() {
    'use strict';

    angular
        .module('platformApp')
        .controller('PicAddController', PicAddController);

    PicAddController.$inject = ['$timeout', '$scope', '$stateParams','Qinius','$uibModal', '$uibModalInstance', 'entity', '$state', 'MessageService','ThemeClassify','SourceMaterial','UidService','ClipArts','Galleries'];

    function PicAddController ($timeout, $scope, $stateParams,Qinius,$uibModal, $uibModalInstance, entity, $state, MessageService,ThemeClassify,SourceMaterial,UidService,ClipArts,Galleries) {
        var vm = this;
        //上传的文件列表
        vm.fileList = [];
        //关闭弹窗
        vm.cancel = function () {
            $uibModalInstance.close();
        }
        //标签
        vm.themeClassifyId = null;
        vm.themeClassifies = ThemeClassify.getAllByCondition1({items:[{key:"type",value:"GALLERY", op:"="},{key:"used",value:"true", op:"="}]});
        vm.tokenTime = 360000;
        Qinius.get(function (msg) {
            vm.token = msg.token;
            vm.tokenTime = parseInt((msg.expireAt - new Date().getTime()));
        });
        vm.domain = Qinius.getDomain();
        var bigSizePics = [];
        vm.fileInfo = null;
        window.updateBackground = function ($event) {
            $scope.$digest();
            var files = $event.target.files;
            if(files.length > 50 || files.length + vm.fileList.length > 50){
                return MessageService.error("一次上传不能超过50张图片");
            }
            bigSizePics = [];
            for (var i = 0; i < files.length; i++) {
                var file = files[i];
                if (file.size >= 20 * 1024 * 1024) {
                    file.imageSize = Math.ceil(file.size / 1024 / 1024);
                    bigSizePics.push(file);
                } else {
                    file.key = 'clipArt-' + UidService.get();
                    file.loadState = 0;// 0：等待上传 1：上传中，2：上传成功 3:上传失败
                    vm.fileList.push(file);
                }
            }
            getBackground();
            if (bigSizePics.length > 0) {
                thumbnailatorPic();
            }
            $event.srcElement.value = "";
            $scope.$apply();
        };
        //删除图片
        $scope.deleteItem = function (index) {
            MessageService.confirm({
                title:'提示',
                cancel:'取消',
                confirm:'确认',
                msg:'确定要删除此图片？'
            },function(){
                vm.fileList.splice(index,1);
            },function(){});

        }
        function thumbnailatorPic() {
            $uibModal.open({
                templateUrl: 'app/entities/page/thumbnailator.html',
                controller: 'ThumbnailatorController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'md',
                resolve: {
                    entity: [function () {
                        return {
                            files: bigSizePics
                        };
                    }]
                }
            }).result.then(function (values) {
                bigSizePics = [];
                if (values) {
                    for (var i = 0; i < values.length; i++) {
                        values[i].key = 'clipArt-' +  UidService.get();
                        values[i].loadState = 0;// 0：等待上传 1：上传中，2：上传成功 3:上传失败
                        vm.fileList.push(values[i]);
                    }
                    getBackground();
                }
            }, function () {
            });
        }
        var upladingNum = 0;
        function getBackground() {
            angular.forEach(vm.fileList,function(item){
                if(upladingNum >= 5) return;
                if(item.loadState === 0){
                    upladingNum++;
                    item.loadState = 1;
                    var url = window.URL || window.webkitURL;
                    var img = new Image();              //手动创建一个Image对象
                    img.src = url.createObjectURL(item);//创建Image的对象的url
                    img.crossOrigin = "Anonymous";
                    var fileName = item.name;
                    var formData = new FormData();
                    formData.append('file', item);
                    formData.append('key', item.key);
                    formData.append('token', vm.token);
                    $.ajax({
                        cache: true,
                        type: "POST",
                        url: 'https://upload.qiniup.com/',
                        data: formData,
                        async: true,
                        contentType: false,
                        processData: false,
                        success: function (data) {
                            item.loadState = 2;
                            item.fileName = fileName;
                            item.img = vm.domain.domain + data.key + '?imageView2';
                            item.preview = vm.domain.domain + data.key + '?imageMogr2/interlace/1/thumbnail/192x192';
                            upladingNum--;
                            if(upladingNum <=0){
                                getBackground();
                            }
                            $scope.$apply();
                        },
                        error: function (request) {
                            item.loadState = 3;
                            upladingNum--;
                            if(upladingNum <=0){
                                getBackground();
                            }
                            var reader = new FileReader();
                            reader.readAsDataURL(item);
                            reader.onload = function(e){
                                item.preview = e.target.result
                                $scope.$apply();
                            }

                        }
                    });
                }
            });

        }
        vm.subLoading = false;
        vm.subAdd = function (){
            if(vm.subLoading) return;
            if(!vm.themeClassifyId) return MessageService.error("请选择标签");
            var flag = vm.fileList.find(function(item){
                return item.loadState !== 2;
            })
            if(flag) return MessageService.error("图片正在上传或上传失败，请确认后重试");
            vm.subLoading = true;
            var data = [];
            angular.forEach(vm.fileList,function (item) {
                var obj = {
                    name: item.name,
                    identifier:item.key,
                    provider: 'qiniu',
                    type: 'USER',
                    themeClassifyId: vm.themeClassifyId
                }
                data.push(obj)
            })
            Galleries.uploadBatch(data, function (resp) {
                vm.subLoading = false;
                MessageService.success("添加成功");
                $uibModalInstance.close(true);
            },function () {
                vm.subLoading = false;
            });
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('platformApp')
        .controller('MaskAddController', MaskAddController);

    MaskAddController.$inject = ['$timeout', '$scope', '$stateParams','Qinius','$uibModal', '$uibModalInstance', 'entity', '$state', 'MessageService','ThemeClassify','SourceMaterial','UidService'];

    function MaskAddController ($timeout, $scope, $stateParams,Qinius,$uibModal, $uibModalInstance, entity, $state, MessageService,ThemeClassify,SourceMaterial,UidService) {
        var vm = this;
        //文件列表
        vm.fileList = [];
        //关闭弹窗
        vm.cancel = function () {
            $uibModalInstance.close();
        }

        //标签
        vm.themeClassifyId = null;
        vm.themeClassifies = ThemeClassify.getAllByCondition1({items:[{key:"type",value:"MASK", op:"="},{key:"used",value:"true", op:"="}]});
        vm.tokenTime = 360000;
        Qinius.get(function (msg) {
            vm.token = msg.token;
            vm.tokenTime = parseInt((msg.expireAt - new Date().getTime()));
        });
        vm.domain = Qinius.getDomain();
        var bigSizePics = [];
        vm.fileInfo = null;
        window.updateBackground = function ($event) {
            $scope.$digest();
            var files = $event.target.files;
            if(files.length > 50 || files.length + vm.fileList.length > 50){
                return MessageService.error("一次上传不能超过50张相框");
            }
            bigSizePics = [];
            for (var i = 0; i < files.length; i++) {
                var file = files[i];
                if (file.size >= 20 * 1024 * 1024) {
                    file.imageSize = Math.ceil(file.size / 1024 / 1024);
                    bigSizePics.push(file);
                } else {
                    file.key = 'clipArt-' + UidService.get();
                    file.loadState = 0;// 0：等待上传 1：上传中，2：上传成功 3:上传失败
                    vm.fileList.push(file);
                }
            }
            getBackground();
            if (bigSizePics.length > 0) {
                thumbnailatorPic();
            }
            $event.srcElement.value = "";
            $scope.$apply();
        };
        //删除图片
        $scope.deleteItem = function (index) {
            MessageService.confirm({
                title:'提示',
                cancel:'取消',
                confirm:'确认',
                msg:'确定要删除此图片？'
            },function(){
                vm.fileList.splice(index,1);
            },function(){});

        }
        function thumbnailatorPic() {
            $uibModal.open({
                templateUrl: 'app/entities/page/thumbnailator.html',
                controller: 'ThumbnailatorController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'md',
                resolve: {
                    entity: [function () {
                        return {
                            files: bigSizePics
                        };
                    }]
                }
            }).result.then(function (values) {
                bigSizePics = [];
                if (values) {
                    for (var i = 0; i < values.length; i++) {
                        values[i].key = 'clipArt-' +  UidService.get();
                        values[i].loadState = 0;// 0：等待上传 1：上传中，2：上传成功 3:上传失败
                        vm.fileList.push(values[i]);
                    }
                    getBackground();
                }
            }, function () {
            });
        }
        var upladingNum = 0;
        function getBackground(files, i) {
            console.log(upladingNum);
            angular.forEach(vm.fileList,function(item){
                if(upladingNum >= 5) return;
                if(item.loadState === 0){
                    upladingNum++;
                    item.loadState = 1;
                    var url = window.URL || window.webkitURL;
                    var img = new Image();              //手动创建一个Image对象
                    img.src = url.createObjectURL(item);//创建Image的对象的url
                    img.crossOrigin = "Anonymous";
                    var fileName = item.name;
                    var formData = new FormData();
                    formData.append('file', item);
                    formData.append('key', item.key);
                    formData.append('token', vm.token);
                    $.ajax({
                        cache: true,
                        type: "POST",
                        url: 'https://upload.qiniup.com/',
                        data: formData,
                        async: true,
                        contentType: false,
                        processData: false,
                        success: function (data) {
                            item.loadState = 2;
                            item.fileName = fileName;
                            item.img = vm.domain.domain + data.key + '?imageView2';
                            item.preview = vm.domain.domain + data.key + '?imageMogr2/interlace/1/thumbnail/192x192';
                            upladingNum--;
                            if(upladingNum <=0){
                                getBackground();
                            }
                            $scope.$apply();
                        },
                        error: function (request) {
                            item.loadState = 3;
                            var reader = new FileReader();
                            reader.readAsDataURL(item);
                            upladingNum--;
                            console.log(upladingNum);
                            if(upladingNum <=0){
                                getBackground();
                            }
                            reader.onload = function(e){
                                item.preview = e.target.result
                                $scope.$apply();
                            }

                        }
                    });
                }
            });
        }
        var subLoading = false;
        vm.subAdd = function (){
            if(subLoading) return;
            if(!vm.themeClassifyId) return MessageService.error("请选择标签");
            var flag = vm.fileList.find(function(item){
                return item.loadState !== 2;
            })
            if(flag) return MessageService.error("图片正在上传或上传失败，请确认后重试");
            subLoading = true;
            var data = [];
            angular.forEach(vm.fileList,function (item) {
                var obj = {
                    name: item.name,
                    identifier:item.key,
                    provider: 'qiniu',
                    type: 'User',
                    themeClassifyId: vm.themeClassifyId
                }
                data.push(obj)
            })
            SourceMaterial.batchCreate(data, function (resp) {
                subLoading = false;
                MessageService.success("添加成功");
                $uibModalInstance.close(true);
            },function (){
                subLoading = false;
                MessageService.error("网络错误,请稍后重试");
            });
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('platformApp')
        .controller('ClipArtAddController', ClipArtAddController);

    ClipArtAddController.$inject = ['$timeout', '$scope', '$stateParams','Qinius','$uibModal', '$uibModalInstance', 'entity', '$state', 'MessageService','ThemeClassify','SourceMaterial','UidService','ClipArts'];

    function ClipArtAddController ($timeout, $scope, $stateParams,Qinius,$uibModal, $uibModalInstance, entity, $state, MessageService,ThemeClassify,SourceMaterial,UidService,ClipArts) {
        var vm = this;
        //上传的文件列表
        vm.fileList = [];
        //关闭弹窗
        vm.cancel = function () {
            $uibModalInstance.close();
        }
        //标签
        vm.themeClassifyId = null;
        vm.themeClassifies = ThemeClassify.getAllByCondition1({items:[{key:"type",value:"CLIPART", op:"="},{key:"used",value:"true", op:"="}]});
        vm.tokenTime = 360000;
        Qinius.get(function (msg) {
            vm.token = msg.token;
            vm.tokenTime = parseInt((msg.expireAt - new Date().getTime()));
        });
        vm.domain = Qinius.getDomain();
        var bigSizePics = [];
        vm.fileInfo = null;
        window.updateBackground = function ($event) {
            $scope.$digest();
            var files = $event.target.files;
            if(files.length > 50 || files.length + vm.fileList.length > 50){
                return MessageService.error("一次上传不能超过50张素材");
            }
            bigSizePics = [];
            for (var i = 0; i < files.length; i++) {
                var file = files[i];
                if (file.size >= 20 * 1024 * 1024) {
                    file.imageSize = Math.ceil(file.size / 1024 / 1024);
                    bigSizePics.push(file);
                } else {
                    file.key = 'clipArt-' + UidService.get();
                    file.loadState = 0;// 0：等待上传 1：上传中，2：上传成功 3:上传失败
                    vm.fileList.push(file);
                }
            }
            getBackground();
            if (bigSizePics.length > 0) {
                thumbnailatorPic();
            }
            $event.srcElement.value = "";
            $scope.$apply();
        };
        //删除图片
        $scope.deleteItem = function (index) {
            MessageService.confirm({
                title:'提示',
                cancel:'取消',
                confirm:'确认',
                msg:'确定要删除此图片？'
            },function(){
                vm.fileList.splice(index,1);
            },function(){});

        }
        function thumbnailatorPic() {
            $uibModal.open({
                templateUrl: 'app/entities/page/thumbnailator.html',
                controller: 'ThumbnailatorController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'md',
                resolve: {
                    entity: [function () {
                        return {
                            files: bigSizePics
                        };
                    }]
                }
            }).result.then(function (values) {
                bigSizePics = [];
                if (values) {
                    console.log(values);
                    for (var i = 0; i < values.length; i++) {
                        values[i].key = 'clipArt-' +  UidService.get();
                        values[i].loadState = 0;// 0：等待上传 1：上传中，2：上传成功 3:上传失败
                        vm.fileList.push(values[i]);
                    }
                    getBackground();
                }
            }, function () {
            });
        }
        var upladingNum = 0;
        function getBackground() {
            angular.forEach(vm.fileList,function(item){
                if(upladingNum >= 5) return;
                if(item.loadState === 0){
                    upladingNum++;
                    item.loadState = 1;
                    var url = window.URL || window.webkitURL;
                    var img = new Image();              //手动创建一个Image对象
                    img.src = url.createObjectURL(item);//创建Image的对象的url
                    img.crossOrigin = "Anonymous";
                    var fileName = item.name;
                    var formData = new FormData();
                    formData.append('file', item);
                    formData.append('key', item.key);
                    formData.append('token', vm.token);
                    $.ajax({
                        cache: true,
                        type: "POST",
                        url: 'https://upload.qiniup.com/',
                        data: formData,
                        async: true,
                        contentType: false,
                        processData: false,
                        success: function (data) {
                            item.loadState = 2;
                            item.fileName = fileName;
                            item.img = vm.domain.domain + data.key + '?imageView2';
                            item.preview = vm.domain.domain + data.key + '?imageMogr2/interlace/1/thumbnail/192x192';
                            upladingNum--;
                            if(upladingNum <=0){
                                getBackground();
                            }
                            $scope.$apply();
                        },
                        error: function (request) {
                            item.loadState = 3;
                            upladingNum--;
                            if(upladingNum <=0){
                                getBackground();
                            }
                            var reader = new FileReader();
                            reader.readAsDataURL(item);
                            reader.onload = function(e){
                                item.preview = e.target.result
                                $scope.$apply();
                            }

                        }
                    });
                }
            });

        }
        vm.subLoading = false;
        vm.subAdd = function (){
            if(vm.subLoading) return;
            if(!vm.themeClassifyId) return MessageService.error("请选择标签");
            var flag = vm.fileList.find(function(item){
                return item.loadState !== 2;
            })
            if(flag) return MessageService.error("图片正在上传或上传失败，请确认后重试");
            vm.subLoading = true;
            var data = [];
            angular.forEach(vm.fileList,function (item) {
                var obj = {
                    name: item.name,
                    identifier:item.key,
                    provider: 'qiniu',
                    type: 'USER',
                    themeClassifyId: vm.themeClassifyId
                }
                data.push(obj)
            })
            ClipArts.batchCreate(data, function (resp) {
                vm.subLoading = false;
                MessageService.success("添加成功");
                $uibModalInstance.close(true);
            },function () {
                vm.subLoading = false;
            });
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('platformApp')
        .controller('BackgroundAddController', BackgroundAddController);

    BackgroundAddController.$inject = ['$timeout', '$scope', '$stateParams','Qinius','$uibModal', '$uibModalInstance', 'entity', '$state', 'MessageService','ThemeClassify','SourceMaterial','UidService','ClipArts','Backgrounds'];

    function BackgroundAddController ($timeout, $scope, $stateParams,Qinius,$uibModal, $uibModalInstance, entity, $state, MessageService,ThemeClassify,SourceMaterial,UidService,ClipArts,Backgrounds) {
        var vm = this;
        //上传的文件列表
        vm.fileList = [];
        //关闭弹窗
        vm.cancel = function () {
            $uibModalInstance.close();
        }
        //标签
        vm.themeClassifyId = null;
        vm.themeClassifies = ThemeClassify.getAllByCondition1({items:[{key:"type",value:"BACKGROUND", op:"="},{key:"used",value:"true", op:"="}]});
        vm.tokenTime = 360000;
        Qinius.get(function (msg) {
            vm.token = msg.token;
            vm.tokenTime = parseInt((msg.expireAt - new Date().getTime()));
        });
        vm.domain = Qinius.getDomain();
        var bigSizePics = [];
        vm.fileInfo = null;
        window.updateBackground = function ($event) {
            $scope.$digest();
            var files = $event.target.files;
            if(files.length > 50 || files.length + vm.fileList.length > 50){
                return MessageService.error("一次上传不能超过50张背景");
            }
            bigSizePics = [];
            for (var i = 0; i < files.length; i++) {
                var file = files[i];
                if (file.size >= 20 * 1024 * 1024) {
                    file.imageSize = Math.ceil(file.size / 1024 / 1024);
                    bigSizePics.push(file);
                } else {
                    file.key = 'clipArt-' + UidService.get();
                    file.loadState = 0;// 0：等待上传 1：上传中，2：上传成功 3:上传失败
                    vm.fileList.push(file);
                }
            }
            getBackground();
            if (bigSizePics.length > 0) {
                thumbnailatorPic();
            }
            $event.srcElement.value = "";
            $scope.$apply();
        };
        //删除图片
        $scope.deleteItem = function (index) {
            MessageService.confirm({
                title:'提示',
                cancel:'取消',
                confirm:'确认',
                msg:'确定要删除此图片？'
            },function(){
                vm.fileList.splice(index,1);
            },function(){});

        }
        function thumbnailatorPic() {
            $uibModal.open({
                templateUrl: 'app/entities/page/thumbnailator.html',
                controller: 'ThumbnailatorController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'md',
                resolve: {
                    entity: [function () {
                        return {
                            files: bigSizePics
                        };
                    }]
                }
            }).result.then(function (values) {
                bigSizePics = [];
                if (values) {
                    for (var i = 0; i < values.length; i++) {
                        values[i].key = 'clipArt-' +  UidService.get();
                        values[i].loadState = 0;// 0：等待上传 1：上传中，2：上传成功 3:上传失败
                        vm.fileList.push(values[i]);
                    }
                    getBackground();
                }
            }, function () {
            });
        }
        var upladingNum = 0;
        function getBackground() {
            angular.forEach(vm.fileList,function(item){
                if(upladingNum >= 5) return;
                if(item.loadState === 0){
                    upladingNum++;
                    item.loadState = 1;
                    var url = window.URL || window.webkitURL;
                    var img = new Image();              //手动创建一个Image对象
                    img.src = url.createObjectURL(item);//创建Image的对象的url
                    img.crossOrigin = "Anonymous";
                    var fileName = item.name;
                    var formData = new FormData();
                    formData.append('file', item);
                    formData.append('key', item.key);
                    formData.append('token', vm.token);
                    $.ajax({
                        cache: true,
                        type: "POST",
                        url: 'https://upload.qiniup.com/',
                        data: formData,
                        async: true,
                        contentType: false,
                        processData: false,
                        success: function (data) {
                            item.loadState = 2;
                            item.fileName = fileName;
                            item.img = vm.domain.domain + data.key + '?imageView2';
                            item.preview = vm.domain.domain + data.key + '?imageMogr2/interlace/1/thumbnail/192x192';
                            upladingNum--;
                            if(upladingNum <=0){
                                getBackground();
                            }
                            $scope.$apply();
                        },
                        error: function (request) {
                            item.loadState = 3;
                            upladingNum--;
                            if(upladingNum <=0){
                                getBackground();
                            }
                            var reader = new FileReader();
                            reader.readAsDataURL(item);
                            reader.onload = function(e){
                                item.preview = e.target.result
                                $scope.$apply();
                            }

                        }
                    });
                }
            });

        }
        vm.subLoading = false;
        vm.subAdd = function (){
            if(vm.subLoading) return;
            if(!vm.themeClassifyId) return MessageService.error("请选择标签");
            var flag = vm.fileList.find(function(item){
                return item.loadState !== 2;
            })
            if(flag) return MessageService.error("图片正在上传或上传失败，请确认后重试");
            vm.subLoading = true;
            var data = [];
            angular.forEach(vm.fileList,function (item) {
                var obj = {
                    name: item.name,
                    identifier:item.key,
                    provider: 'qiniu',
                    roleType: 'USER',
                    themeClassifyId: vm.themeClassifyId
                }
                data.push(obj)
            })
            Backgrounds.batchList(data, function (resp) {
                vm.subLoading = false;
                MessageService.success("添加成功");
                $uibModalInstance.close(true);
            },function () {
                vm.subLoading = false;
            });
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('platformApp')
        .controller('MaskDetailController', MaskDetailController); 

    MaskDetailController.$inject = ['$timeout', "$q", '$scope', '$stateParams', '$uibModalInstance', 'entity', 'SourceMaterial',
            'MessageService','ThemeClassify','$http','$uibModal'];

    function MaskDetailController ($timeout, $q, $scope, $stateParams, $uibModalInstance, entity, SourceMaterial, 
        MessageService,ThemeClassify, $http,$uibModal) {

        var vm = this;
        vm.data = entity;
        vm.save = save;
        vm.themeClassifies = ThemeClassify.getAllByCondition1({items:[{key:"type",value:"MASK", op:"="},{key:"used",value:"true", op:"="}]});

        $scope.cancel = function(){
            $uibModalInstance.dismiss('cancel');
        }

        function save (){
            SourceMaterial.update(vm.data, function(res){
                MessageService.success("保存成功");
                $uibModalInstance.close(res);
            }, function(ers){
                MessageService.error("保存失败,请稍后再试");
                $uibModalInstance.dismiss('cancel');
            })
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('platformApp')
        .controller('MaskController', MaskController);

    MaskController.$inject = ['$scope', '$state', 'SourceMaterial', 'ParseLinks', 'paginationConstants',
     'pagingParams', 'MessageService', 'Qinius', '$q', '$uibModal', 'UidService', '$timeout', 'ThemeClassify'];

    function MaskController ($scope, $state, SourceMaterial, ParseLinks, paginationConstants,
     pagingParams, MessageService, Qinius, $q, $uibModal, UidService, $timeout, ThemeClassify) {
        var vm = this;

        vm.tabs = [{key:"background", value:"背景", url:'background'},
        {key:"imageBox", value:"相框", url:'mask'},
        {key:"borderBox", value:"边框", url:'frame-control'},
        {key:"font", value:"字体", url:'font-management'},
        {key:"clipArt", value:"素材", url:'clip-art'},
        {key:"image", value:"图片", url:'pic'}];
        vm.currentName = "imageBox";

        vm.count = 0;
        vm.totalItems = 0;
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.size = 15;
        vm.page = 1;
        var bigSizePics= [];

        vm.clear = clear;
        vm.search = search;
        vm.loadAll = loadAll;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;
        vm.jump = jump;
        //标签筛选项是否展开
        vm.tagScreenIsOpen = false;
        vm.tokenTime = 360000;
        Qinius.get(function (msg) {
            vm.token = msg.token;
            vm.tokenTime = parseInt((msg.expireAt - new Date().getTime()));
        });

        vm.themeClassifies = ThemeClassify.getAllByCondition1({items:[
            {key:"type",value:"MASK", op:"="},
            {key:"used",value:"true", op:"="}]});
        vm.domain = Qinius.getDomain();
        vm.themeClassifyId = pagingParams.c - 0;

        $q.all([ vm.domain.$promise, vm.themeClassifies.$promise]).then(function(){
           setTimeout(function fn() {
                Qinius.get(function (msg) {
                    vm.token = msg.token;
                    vm.tokenTime = parseInt((msg.expireAt - new Date().getTime()));
                });
                setTimeout(fn, vm.tokenTime);
            }, vm.tokenTime);
            vm.url = vm.domain.domain;

            vm.themeClassifies.unshift({name:"全部", id:"全部",seq:-1});
            $scope.selectTag(vm.themeClassifies[0]);
        })

        $scope.delete = function(id){
            MessageService.confirm({
                title:'提示',
                cancel:'取消',
                confirm:'确认',
                msg:'确定要删除该相框？'
            },function(){
                SourceMaterial.delete({id: id},function () {
                    loadAll();
                });
            },function(){});
        };


        $scope.editTag = function(){
            $uibModal.open({
                templateUrl: 'app/entities/page/catalog-management.html',
                controller: 'CatalogManagementController',
                backdrop: 'static',
                keyboard: true,
                windowClass: "jh-modal-md",
                controllerAs: 'vm',
                resolve: {
                    entity: function () {
                        return {catalogType: "MASK"}
                    }
                }
            }).result.then(function(res) {
                ThemeClassify.getAllByCondition1({items:[
                    {key:"type",value:"MASK", op:"="},
                    {key:"used",value:"true", op:"="}]}, function(data){
                        vm.themeClassifies = data;
                        vm.themeClassifies.unshift({name:"全部", id:"全部",seq:-1});
                        $scope.selectTag(vm.themeClassifies[0]);
                    });
            });
        }

        $scope.batchDelet = function(){
            var ids = [];
            vm.resources.forEach(function(it){
                if (it.selected) {
                    ids.push(it.id);
                }
            });
            if (ids.length>0) {
                MessageService.confirm({
                    title:'提示',
                    cancel:'取消',
                    confirm:'确认',
                    msg:'确定要删除所选相框？'
                }, function(){
                    SourceMaterial.batchDelete({ids_:ids}, function(res){
                        MessageService.success("删除成功");
                        loadAll();
                        vm.batch = false;
                        vm.count = 0;
                    }, function(va){
                        MessageService.error("删除失败，请稍后再试");
                    })
                })
            }else{
                MessageService.error("未勾选任何有效的背景，请确认后再操作");
            }
        }

        $scope.itemSelect = function(item){
            if (!vm.batch) {
                return
            }
            item.selected = !item.selected;
            vm.count = 0;
            vm.resources.forEach(function(it){
                if (it.selected) {
                    vm.count ++;
                }
            })
        }

        $scope.exitBatch = function(){
            vm.resources.forEach(function(it){
                it.selected = false;
            })
            vm.batch = false;
            vm.count = 0;
        }

         //更改展开收起状态
        $scope.changeMoreState = function(key){
            vm[key] = !vm[key]
        }

        // 当前页变更
        vm.currentChange = function(){
            $timeout(function(){
                loadAll();
            })
        }

        $scope.selectTag = function(item){
            vm.themeClassifies.forEach(function(it){
                it.active = false;
            })
            item.active = true;
            if (item.id == '全部') {
                vm.themeClassifyId = null;
            }else{
                vm.themeClassifyId = item.id;
            }
            loadAll();
        }

        $scope.more = function(item){
            vm.resources.forEach(function(it){
                it.more = false;
            });
            item.more = true;
        }

        $scope.view = function(data){
            vm.resources.forEach(function(it){
                it.more = false;
            });
            $uibModal.open({
                templateUrl: 'app/entities/my-upload/background-view.html',
                controller: 'BackGroundViewController',
                backdrop: 'static',
                keyboard: true,
                windowClass: "jh-modal-md",
                controllerAs: 'vm',
                resolve: {
                    entity: data,
                }
            }).result.then(function(res) {
            });
        }



        function loadAll () {
            var items = []
            vm.resources = [];
            if (vm.themeClassifyId) {
                items.push({key:"themeClassify.id",value:vm.themeClassifyId, op:"="})
            }
            if (pagingParams.search) {
                items.push({key:"name",value:pagingParams.search, op:"like"})

            }
            SourceMaterial.byCondition3({
                items:items,
                page: vm.page - 1,
                size: vm.size,
                sort: ["id,desc"]
            }, onSuccess, onError);

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                data.some(function (item, i) {
                    item.identifier = vm.url + item.identifier
                    vm.resources.push(item);
                })
            }
            function onError(error) {
                MessageService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch,
                c: vm.themeClassifyId
            });
        }

        function search(searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear() {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.themeClassifyId = null;
            vm.currentSearch = null;
            vm.transition();
        }

        function jump () {
            vm.page = vm.jumpText<=0?1:vm.jumpText;
            loadPage(vm.page);
        }

        $scope.searchClass = function(){
            vm.transition()
        }
        $scope.addMask = function () {
            $uibModal.open({
                templateUrl: 'app/entities/my-upload/modal/mask-add.html',
                controller: 'MaskAddController',
                backdrop: 'static',
                keyboard: true,
                windowClass: "jh-modal-md",
                controllerAs: 'vm',
                resolve: {
                    entity: [function () {
                        return {};
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        return $translate.refresh();
                    }]
                }
            }).result.then(function(state) {
                console.log(state)
                if(state){
                    vm.page = 1;
                    vm.loadAll();
                }
            });
        }

    }
})();


(function() {
    'use strict';

    angular
        .module('platformApp')
        .controller('ClipArtDetailController', ClipArtDetailController);

    ClipArtDetailController.$inject = ['$timeout', "$q", '$scope', '$stateParams', '$uibModalInstance', 'entity', 'ClipArts',
            'MessageService','ThemeClassify','$http','$uibModal'];

    function ClipArtDetailController ($timeout, $q, $scope, $stateParams, $uibModalInstance, entity, ClipArts,
        MessageService,ThemeClassify, $http,$uibModal) {

        var vm = this;
        vm.data = entity;
        vm.save = save;
        vm.themeClassifies = ThemeClassify.getAllByCondition1({items:[{key:"type",value:"CLIPART", op:"="},{key:"used",value:"true", op:"="}]});

        $scope.cancel = function(){
            $uibModalInstance.dismiss('cancel');
        }
        function save (){
            if(!vm.data.themeClassifyId) return MessageService.error("请选择标签");
            ClipArts.update(vm.data, function(res){
                MessageService.success("保存成功");
                $uibModalInstance.close(res);
            }, function(ers){
                MessageService.error("保存失败,请稍后再试");
                $uibModalInstance.dismiss('cancel');
            })
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('platformApp')
        .controller('ClipArtController', ClipArtController);

    ClipArtController.$inject = ['$scope', '$state', 'ClipArts', 'ParseLinks', 'paginationConstants',
     'pagingParams', 'MessageService', 'Qinius', '$q', '$uibModal', 'UidService', '$timeout', 'ThemeClassify'];

    function ClipArtController ($scope, $state, ClipArts, ParseLinks, paginationConstants,
     pagingParams, MessageService, Qinius, $q, $uibModal, UidService, $timeout, ThemeClassify) {
        var vm = this;

        vm.tabs = [{key:"background", value:"背景", url:'background'},
        {key:"imageBox", value:"相框", url:'mask'},
        {key:"borderBox", value:"边框", url:'frame-control'},
        {key:"font", value:"字体", url:'font-management'},
        {key:"clipArt", value:"素材", url:'clip-art'},
        {key:"image", value:"图片", url:'pic'}];
        vm.currentName = "clipArt";

        vm.count = 0;
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.size = 15;
        var bigSizePics= [];

        vm.clear = clear;
        vm.search = search;
        vm.loadAll = loadAll;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;
        vm.jump = jump;
        //标签筛选项是否展开
        vm.tagScreenIsOpen = false;
        vm.tokenTime = 360000;
        Qinius.get(function (msg) {
            vm.token = msg.token;
            vm.tokenTime = parseInt((msg.expireAt - new Date().getTime()));
        });

        vm.themeClassifies = ThemeClassify.getAllByCondition1({items:[
            {key:"type",value:"CLIPART", op:"="},
            {key:"used",value:"true", op:"="}]});
        vm.domain = Qinius.getDomain();
        vm.themeClassifyId = pagingParams.c - 0;

        $q.all([ vm.domain.$promise, vm.themeClassifies.$promise]).then(function(){
           setTimeout(function fn() {
                Qinius.get(function (msg) {
                    vm.token = msg.token;
                    vm.tokenTime = parseInt((msg.expireAt - new Date().getTime()));
                });
                setTimeout(fn, vm.tokenTime);
            }, vm.tokenTime);
            vm.url = vm.domain.domain;
            vm.themeClassifies.unshift({name:"全部", id:"全部", seq:-1});
            $scope.selectTag(vm.themeClassifies[0]);
        })

        $scope.delete = function(id){
            MessageService.confirm({
                title:'提示',
                cancel:'取消',
                confirm:'确认',
                msg:'确定要删除该素材？'
            },function(){
                ClipArts.delete({id: id},function () {
                    loadAll();
                });
            },function(){});
        };


        $scope.editTag = function(){
            $uibModal.open({
                templateUrl: 'app/entities/page/catalog-management.html',
                controller: 'CatalogManagementController',
                backdrop: 'static',
                keyboard: true,
                windowClass: "jh-modal-md",
                controllerAs: 'vm',
                resolve: {
                    entity: function () {
                        return {catalogType: "CLIPART"}
                    }
                }
            }).result.then(function(res) {
                ThemeClassify.getAllByCondition1({items:[
                    {key:"type",value:"CLIPART", op:"="},
                    {key:"used",value:"true", op:"="}]}, function(data){
                        vm.themeClassifies = data;
                        vm.themeClassifies.unshift({name:"全部", id:"全部" , seq:-1});
                        $scope.selectTag(vm.themeClassifies[0]);
                    });
            });
        }

        $scope.batchDelet = function(){
            var ids = [];
            vm.resources.forEach(function(it){
                if (it.selected) {
                    ids.push(it.id);
                }
            });
            if (ids.length>0) {
                MessageService.confirm({
                title:'提示',
                cancel:'取消',
                confirm:'确认',
                msg:'确定要删除所选素材？'
            }, function(){
                    ClipArts.batchDelete({ids_:ids}, function(res){
                        MessageService.success("删除成功");
                        vm.batch = false;
                        vm.count = 0;
                        loadAll();
                    }, function(va){
                        MessageService.error("删除失败，请稍后再试");
                    })
                })
            }else{
                MessageService.error("未勾选任何有效的背景，请确认后再操作");
            }
        }

        $scope.itemSelect = function(item){
            if (!vm.batch) {
                return
            }
            item.selected = !item.selected;
            vm.count = 0;
            vm.resources.forEach(function(it){
                if (it.selected) {
                    vm.count ++;
                }
            })
        }

        $scope.exitBatch = function(){
            vm.resources.forEach(function(it){
                it.selected = false;
            })
            vm.batch = false;
            vm.count = 0;
        }

         //更改展开收起状态
        $scope.changeMoreState = function(key){
            vm[key] = !vm[key]
        }

        // 当前页变更
        vm.currentChange = function(){
            $timeout(function(){
                loadAll();
            })
        }

        $scope.selectTag = function(item){
            vm.themeClassifies.forEach(function(it){
                it.active = false;
            })
            item.active = true;
            if (item.id == '全部') {
                vm.themeClassifyId = null;
            }else{
                vm.themeClassifyId = item.id;
            }
            loadAll();
        }

        $scope.more = function(item){
            vm.resources.forEach(function(it){
                it.more = false;
            });
            item.more = true;
        }

        $scope.view = function(data){
            $uibModal.open({
                templateUrl: 'app/entities/my-upload/background-view.html',
                controller: 'BackGroundViewController',
                backdrop: 'static',
                keyboard: true,
                windowClass: "jh-modal-md",
                controllerAs: 'vm',
                resolve: {
                    entity: data,
                }
            }).result.then(function(res) {
            });
        }

        function loadAll () {
            var items = []
            vm.resources = [];
            if (vm.themeClassifyId) {
                items.push({key:"themeClassify.id",value:vm.themeClassifyId, op:"="})
            }
            if (pagingParams.search) {
                items.push({key:"name",value:pagingParams.search, op:"like"})

            }
            ClipArts.byCondition3({
                items:items,
                page: vm.page - 1,
                size: vm.size,
                sort: ["id,desc"]
            }, onSuccess, onError);

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                data.some(function (item, i) {
                    item.identifier = vm.url + item.identifier
                    vm.resources.push(item);
                })
                vm.page = pagingParams.page;
                vm.count = 0;
            }
            function onError(error) {
                MessageService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch,
                c: vm.themeClassifyId
            });
        }

        function search(searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear() {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.themeClassifyId = null;
            vm.currentSearch = null;
            vm.transition();
        }

        function jump () {
            vm.page = vm.jumpText<=0?1:vm.jumpText;
            loadPage(vm.page);
        }

        $scope.searchClass = function(){
            vm.transition()
        }

        $scope.addClipArt = function () {
            $uibModal.open({
                templateUrl: 'app/entities/my-upload/modal/clipArt-add.html',
                controller: 'ClipArtAddController',
                backdrop: 'static',
                keyboard: true,
                windowClass: "jh-modal-md",
                controllerAs: 'vm',
                resolve: {
                    entity: [function () {
                        return {};
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        return $translate.refresh();
                    }]
                }
            }).result.then(function(state) {
                if(state){
                    vm.page = 1;
                    vm.loadAll();
                }
            });
        }

    }
})();


(function() {
    'use strict';

    angular
        .module('platformApp')
        .controller('BackGroundViewController', BackGroundViewController);

    BackGroundViewController.$inject = ['$scope', '$uibModalInstance', 'MessageService','entity'];

    function BackGroundViewController( $scope, $uibModalInstance, MessageService,entity) {
        var vm = this;
        vm.data = entity;

        $scope.cancel = function(){
            $uibModalInstance.dismiss('cancel');
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('platformApp')
        .controller('BackgroundDetailController', BackgroundDetailController);

        BackgroundDetailController.$inject = ['$timeout', "$q", '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Backgrounds',
            'MessageService','ThemeClassify','$http','$uibModal'];

    function BackgroundDetailController ($timeout, $q, $scope, $stateParams, $uibModalInstance, entity, Backgrounds,
        MessageService,ThemeClassify, $http,$uibModal) {

        var vm = this;
        vm.data = entity;
        vm.save = save;
        vm.themeClassifies = ThemeClassify.getAllByCondition1({items:[{key:"type",value:"BACKGROUND", op:"="},{key:"used",value:"true", op:"="}]});

        $scope.cancel = function(){
            $uibModalInstance.dismiss('cancel');
        }

        function save (){
            Backgrounds.update(vm.data, function(res){
                MessageService.success("保存成功");
                $uibModalInstance.close(res);
            }, function(ers){
                MessageService.error("保存失败,请稍后再试");
                $uibModalInstance.dismiss('cancel');
            })
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('platformApp')
        .controller('BackGroundController', BackGroundController)
        .filter('sizeTransition', function () {
            return function(bytes){
                if (bytes === 0) return '0 B';
                var k = 1024, // or 1024
                    sizes = ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'],
                    i = Math.floor(Math.log(bytes) / Math.log(k));
                return (bytes / Math.pow(k, i)).toPrecision(3) + ' ' + sizes[i];

            }
        });

    BackGroundController.$inject = ['$scope', '$state', 'Backgrounds', 'ParseLinks', 'paginationConstants',
     'pagingParams', 'MessageService', 'Qinius', '$q', '$uibModal', 'UidService', '$timeout','ThemeClassify'];

    function BackGroundController ($scope, $state, Backgrounds, ParseLinks, paginationConstants,
     pagingParams, MessageService, Qinius, $q, $uibModal, UidService, $timeout,ThemeClassify) {
        var vm = this;

        vm.tabs = [{key:"background", value:"背景", url:'background'},
        {key:"imageBox", value:"相框", url:'mask'},
        {key:"borderBox", value:"边框", url:'frame-control'},
        {key:"font", value:"字体", url:'font-management'},
        {key:"clipArt", value:"素材", url:'clip-art'},
        {key:"image", value:"图片", url:'pic'}];
        vm.currentName = "background";
        vm.count = 0;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.clear = clear;
        vm.search = search;
        vm.loadAll = loadAll;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;
        vm.jump = jump;
        vm.exitSure = false;
        vm.bgimgs = [];
        vm.size = 15;
        vm.page = 1;
        vm.totalItems = 0;
        var bigSizePics= [];
        vm.tagScreenIsOpen = false;


        vm.tokenTime = 360000;

        vm.themeClassifies = ThemeClassify.getAllByCondition1({items:[
            {key:"type",value:"BACKGROUND", op:"="},
            {key:"used",value:"true", op:"="}]});
        vm.domain = Qinius.getDomain();
        vm.themeClassifyId = pagingParams.c - 0;
        // Qinius.get(function (msg) {
        //     vm.token = msg.token;
        //     vm.tokenTime = parseInt((msg.expireAt - new Date().getTime()));
        // });
        $scope.domains = Qinius.getDomain();
        $q.all([$scope.domains.$promise]).then(function () {
            // token过期
            setTimeout(function fn() {
                Qinius.get(function (msg) {
                    vm.token = msg.token;
                    vm.tokenTime = parseInt((msg.expireAt - new Date().getTime()));
                });
                setTimeout(fn, vm.tokenTime);
            }, vm.tokenTime);
            vm.url = $scope.domains.domain;
            // loadAll();
            vm.themeClassifies.unshift({name:"全部", id:"全部", seq:-1});
            $scope.selectTag(vm.themeClassifies[0]);
        });


        $scope.view = function(data){
            vm.bgimgs.forEach(function(it){
                it.more = false;
            });
            $uibModal.open({
                templateUrl: 'app/entities/my-upload/background-view.html',
                controller: 'BackGroundViewController',
                backdrop: 'static',
                keyboard: true,
                windowClass: "jh-modal-md",
                controllerAs: 'vm',
                resolve: {
                    entity: data,
                }
            }).result.then(function(res) {
            });
        }

        $scope.delete = function(item){
             MessageService.confirm({
                title:'提示',
                cancel:'取消',
                confirm:'确认',
                msg:'确定要删除该背景？'
            },function(){
                Backgrounds.delete({id:item.id}, function(res){
                    MessageService.success("删除成功");
                    loadAll();
                }, function(va){
                    MessageService.error("删除失败，请稍后再试");
                })
            },function(){});
        }

        $scope.more = function(item){
            vm.bgimgs.forEach(function(it){
                it.more = false;
            });
            item.more = true;
        }

        $scope.batchDelet = function(){
            var ids = [];
            vm.bgimgs.forEach(function(it){
                if (it.selected) {
                    ids.push(it.id);
                }
            });
            if (ids.length>0) {
                MessageService.confirm(
                    {
                        title:'提示',
                        cancel:'取消',
                        confirm:'确认',
                        msg:'确定要删除所选背景？'
                    }, function(){
                    Backgrounds.batchDelete({ids_:ids}, function(res){
                        MessageService.success("删除成功");
                        vm.batch = false;
                        vm.count = 0;
                        loadAll();
                    }, function(va){
                        MessageService.error("删除失败，请稍后再试");
                    })
                })
            }else{
                MessageService.error("未勾选任何有效的背景，请确认后再操作");
            }
        }


        $scope.exitBatch = function(){
            vm.bgimgs.forEach(function(it){
                it.selected = false;
            })
            vm.batch = false;
            vm.count = 0;
        }

        $scope.itemSelect = function(item){
            if (!vm.batch) {
                return
            }
            item.selected = !item.selected;
            vm.count = 0;
            vm.bgimgs.forEach(function(it){
                if (it.selected) {
                    vm.count ++;
                }
            })
        }

        function thumbnailatorPic() {
            $uibModal.open({
                templateUrl: 'app/entities/page/thumbnailator.html',
                controller: 'ThumbnailatorController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'md',
                resolve: {
                    entity: [function () {
                        return {
                            files: bigSizePics
                        };
                    }]
                }
            }).result.then(function (values) {
                bigSizePics = [];
                if (values) {
                    var len = 0;
                    if (vm.showBackgrounds && vm.showBackgrounds.length) {
                        len = vm.showBackgrounds.length;
                    }
                    for (var i = 0; i < values.length; i++) {
                        getBackground(values, i, len);
                    }
                }
            }, function () {
            });
        }
        var addTimer = null;
        function getBackground(files, i, len) {
            var url = window.URL || window.webkitURL;
            var img = new Image();              //手动创建一个Image对象
            img.src = url.createObjectURL(files[i]);//创建Image的对象的url
            img.crossOrigin = "Anonymous";
            var fileName = files[i].name;
            var formData = new FormData();
            formData.append('file', files[i]);
            formData.append('key', 'background-' + UidService.get());
            formData.append('token', vm.token);
            $.ajax({
                cache: true,
                type: "POST",
                url: 'https://upload.qiniup.com/',
                data: formData,
                async: true,
                contentType: false,
                processData: false,
                success: function (data) {
                    Backgrounds.save({
                        identifier: data.key,
                        provider: 'qiniu',
                        name: fileName,
                        type: 'ProductXml'
                    }, function (resp) {
                        resp.identifier = vm.url + resp.identifier;
                        if(addTimer){
                            clearTimeout(addTimer);
                            addTimer = null;
                        }
                        addTimer = setTimeout(function () {
                            vm.page = 1;
                            loadAll();
                        },200)

                    });
                },
                error: function (request) {
                    console.log("error");
                }
            });
        }

        // 当前页变更
        vm.currentChange = function(){
            $timeout(function(){
                loadAll();
            })
        }

        function loadAll () {
            var items = [];
            vm.bgimgs = [];
            if (vm.themeClassifyId) {
                items.push({key:"themeClassify.id",value:vm.themeClassifyId, op:"="})
            }
            if (pagingParams.search) {
                items.push({key:"name",value:pagingParams.search, op:"like"})

            }
            Backgrounds.byCondition({
                items: items,
                page: vm.page-1,
                size: vm.size,
                sort: ["id,desc"]
            }, function (res, headers) {
                vm.totalItems = headers('X-Total-Count');
                res.some(function (item, i) {
                    item.identifier = vm.url + item.identifier
                    vm.bgimgs.push(item);
                })
            })
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'desc' : 'asc'),
                search: vm.currentSearch
            });
        }

        function search(searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear() {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }

        function jump () {
            vm.page = vm.jumpText<=0?1:vm.jumpText;
            vm.transition();
        }

        $scope.selectTag = function(item){
            vm.themeClassifies.forEach(function(it){
                it.active = false;
            })
            item.active = true;
            if (item.id == '全部') {
                vm.themeClassifyId = null;
            }else{
                vm.themeClassifyId = item.id;
            }
            loadAll();
        }
        $scope.editTag = function(){
            $uibModal.open({
                templateUrl: 'app/entities/page/catalog-management.html',
                controller: 'CatalogManagementController',
                backdrop: 'static',
                keyboard: true,
                windowClass: "jh-modal-md",
                controllerAs: 'vm',
                resolve: {
                    entity: function () {
                        return {catalogType: "BACKGROUND"}
                    }
                }
            }).result.then(function(res) {
                ThemeClassify.getAllByCondition1({items:[
                    {key:"type",value:"BACKGROUND", op:"="},
                    {key:"used",value:"true", op:"="}]}, function(data){
                        vm.themeClassifies = data;
                        vm.themeClassifies.unshift({name:"全部", id:"全部" , seq:-1});
                        $scope.selectTag(vm.themeClassifies[0]);
                    });
            });
        }

        $scope.addBackground = function () {
            $uibModal.open({
                templateUrl: 'app/entities/my-upload/modal/background-add.html',
                controller: 'BackgroundAddController',
                backdrop: 'static',
                keyboard: true,
                windowClass: "jh-modal-md",
                controllerAs: 'vm',
                resolve: {
                    entity: [function () {
                        return {};
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        return $translate.refresh();
                    }]
                }
            }).result.then(function(state) {
                if(state){
                    vm.page = 1;
                    vm.loadAll();
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('platformApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('homeFirst', {
            parent: 'app',
            url: '/homeFirst?key&uuid&phone',
            data: {
                authorities: []
            },
            views: {
                'navbar@': {
                    templateUrl: 'app/entities/home-first/home-first.html',
                    controller: 'HomeFirstController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    $translatePartialLoader.addPart('home');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function () {
    "use strict";

    angular.module("platformApp").controller("HomeFirstController", HomeFirstController);

    HomeFirstController.$inject = [
        "$scope",
        "$timeout",
        "MessageService",
        "$state",
        "Auth",
        "$rootScope",
        "$stateParams",
        "$localStorage",
        "FrontUser",
        "Verify",
        "Account"
    ];

    function HomeFirstController(
        $scope,
        $timeout,
        MessageService,
        $state,
        Auth,
        $rootScope,
        $stateParams,
        $localStorage,
        FrontUser,
        Verify,
        Account
    ) {
        var vm = this;
        $(".navbar").hide();
        $(".wrap").css({ margin: 0 });
        vm.key = $stateParams.key;
        vm.uuid = $stateParams.uuid;
        vm.phone = $stateParams.phone;
        vm.loading = true;
        vm.codeDisable = false;
        //密码框类型
        vm.passType = "password";
        vm.confirmPassType = "password";
        //手机号校验错误状态
        vm.checkPhoneErr = false;
        init();
        function init() {
            FrontUser.authByThird(
                {
                    key: vm.key,
                    uuid: vm.uuid,
                    phone: vm.phone
                },
                function (res) {
                    if (res.status == 200) {
                        goPage(res.message);
                    }
                    vm.loading = false;
                }
            );
        }

        vm.page1 = true;
        vm.page2 = false;
        vm.data = {
            isAccount: false
        };
        vm.data1 = {
            key: vm.key,
            uuid: vm.uuid
        };
        vm.codeName = "获取验证码";
        vm.code = "";
        $scope.accountSelect = function (item) {
            vm.data.isAccount = item;
            vm.codeName = "获取验证码";
        };
        //更改密码框类型
        $scope.changePassType = function (passType, type) {
            vm[passType] = type;
        };
        $scope.changePhone = function () {
            vm.checkPhoneErr = false;
        };
        $scope.getCode = function () {
            if (vm.codeDisable) return;
            if (vm.phone == null || vm.phone == "") {
                MessageService.error("请先输入手机号码");
                return;
            }
            //手机号不合规
            if (!checkPhone(vm.phone)) {
                vm.checkPhoneErr = true;
                return MessageService.error("您的手机号不合规，请检查重新输入");
            }
            if (vm.codeName != "获取验证码") {
                return;
            }
            vm.codeDisable = true;
            // 发送验证码到手机
            Verify.getVerifyCode(
                {
                    tel: vm.phone,
                    incident: "用户注册"
                },
                function (msg) {
                    codeInit(60);
                },
                function () {
                    vm.codeDisable = false;
                }
            );
        };

        function codeInit(time) {
            if (time == 0) {
                vm.codeName = "获取验证码";
                vm.codeDisable = false;
                return;
            }
            vm.codeName = time + "s";
            time--;
            $timeout(function () {
                codeInit(time);
            }, 1000);
        }

        $scope.save1 = function () {
            if (!vm.data.isAccount) {
                vm.loading = true;
                FrontUser.checkUser(
                    {
                        items: [
                            { key: "phone", op: "=", value: vm.phone },
                            { key: "cancelled", op: "=", value: "false" },
                            { key: "status", op: "!=", value: "Rejected" }
                        ]
                    },
                    function (data) {
                        vm.loading = false;
                        if (data.length > 0) {
                            MessageService.error("系统检测到手机号已注册，请点击‘是’进行数据同步");
                        } else {
                            vm.page1 = false;
                            vm.page2 = true;
                        }
                    },
                    function () {
                        MessageService.error("检测手机号失败");
                        vm.loading = false;
                    }
                );
            } else {
                if (!vm.phone) {
                    MessageService.error("手机号不能为空");
                    return;
                }
                if (!vm.code) {
                    MessageService.error("验证码不能为空");
                    return;
                }
                vm.loading = true;
                Verify.checkVerifyCode(
                    {
                        tel: vm.phone,
                        code: vm.code,
                        incident: "用户注册"
                    },
                    function (msg) {
                        if (msg.status == 200 && msg.message == true) {
                            FrontUser.bindByThird(
                                {
                                    key: vm.key,
                                    uuid: vm.uuid,
                                    phone: vm.phone
                                },
                                function (res) {
                                    if (res.status == 200) {
                                        goPage(res.message);
                                    } else {
                                        MessageService.error(res.message || "数据校验失败");
                                    }
                                    vm.loading = false;
                                },
                                function (error) {
                                    MessageService.error(error.data.message || "数据校验失败");
                                    vm.loading = false;
                                }
                            );
                        } else {
                            vm.loading = false;
                            MessageService.error("手机号验证失败");
                        }
                    },
                    function () {
                        vm.loading = false;
                        MessageService.error("手机号验证失败");
                    }
                );
            }
        };

        $scope.registerByThird = function () {
            if (!vm.data1.name) {
                MessageService.error("账号不能为空");
                return;
            }
            if (!vm.phone) {
                MessageService.error("手机号不能为空");
                return;
            }
            if (!vm.code) {
                MessageService.error("验证码不能为空");
                return;
            }
            if (!vm.data1.password) {
                MessageService.error("密码不能为空");
                return;
            }
            if (vm.data1.password1 != vm.data1.password) {
                MessageService.error("确认密码不一致");
                return;
            }
            vm.loading = true;
            Verify.checkVerifyCode(
                {
                    tel: vm.phone,
                    code: vm.code,
                    incident: "用户注册"
                },
                function (msg) {
                    if (msg.status == 200 && msg.message == true) {
                        vm.data1.key = vm.key;
                        vm.data1.phone = vm.phone;
                        FrontUser.registerByThird(
                            vm.data1,
                            function (res) {
                                if (res.status == 200) {
                                    goPage(res.message);
                                } else {
                                    MessageService.error(res.message);
                                }
                                vm.loading = false;
                            },
                            function (error) {
                                MessageService.error(error.data.message || "数据校验失败");
                                vm.loading = false;
                            }
                        );
                    } else {
                        MessageService.error("手机号验证失败");
                        vm.loading = false;
                    }
                },
                function () {
                    MessageService.error("手机号验证失败");
                    vm.loading = false;
                }
            );
        };

        function goPage(token) {
            $localStorage.authenticationToken = token;

            Account.get(
                {},
                function (data) {
                    if (data.status == 200) {
                        $localStorage.user = data.data;
                        $(".navbar").show();
                        vm.account = $localStorage.user;
                        $(".users-a").html(vm.account.name);
                        $state.go("page");
                        $(".wrap").css({ margin: "48px 0 10px 254px" });
                        delete $localStorage.menu1;
                        delete $localStorage.menu2;
                        delete $localStorage.pageName;
                        $rootScope.$broadcast("authenticationSuccess");
                    }
                },
                function () {}
            );
        }
    }
})();

(function () {
    "use strict";

    angular.module("platformApp").controller("FrameControlIssueDialogController", FrameControlIssueDialogController);

    FrameControlIssueDialogController.$inject = [
        "$timeout",
        "$q",
        "$scope",
        "UidService",
        "$stateParams",
        "$uibModalInstance",
        "FrameConfig",
        "Qinius",
        "MessageService",
        "ThemeClassify",
        "$http",
        "entity",
        "borderId"
    ];

    function FrameControlIssueDialogController(
        $timeout,
        $q,
        $scope,
        UidService,
        $stateParams,
        $uibModalInstance,
        FrameConfig,
        Qinius,
        MessageService,
        ThemeClassify,
        $http,
        entity,
        borderId
    ) {
        var vm = this;
        //是否全选
        vm.checkAll = false;
        vm.clear = clear;
        vm.save = save;
        vm.thirdPartySettings = angular.copy(entity.thirdPartySettings) || [];
        vm.checkFn = function (item) {
            item.selected = !item.selected;
            //判断是否全选
            var selectedList = vm.thirdPartySettings.filter(function (item) {
                return item.selected;
            });
            if (selectedList.length === vm.thirdPartySettings.length) {
                vm.checkAll = true;
            } else {
                vm.checkAll = false;
            }
        };
        vm.step = "firstStep";
        //发布提交Loading
        vm.saveLoading = false;
        vm.checkAllFn = function () {
            vm.checkAll = !vm.checkAll;
            vm.thirdPartySettings.forEach(function (item) {
                item.selected = vm.checkAll;
            });
        };

        function save() {
            vm.storeIds = [];
            vm.thirdPartySettings.forEach(function (item) {
                if (item.selected) {
                    vm.storeIds.push(item.id);
                }
            });
            if (vm.storeIds.length == 0) {
                MessageService.error("请选择发布的渠道");
                return;
            }
            vm.storeIds = vm.storeIds.toString();
            vm.step = "secondStep";
            vm.saveLoading = true;
            FrameConfig.onlyRelease(
                { id: borderId, storeIds: vm.storeIds },
                function (res) {
                    vm.releaseData = res;
                    vm.saveLoading = false;
                    if (vm.releaseData.status == 400) {
                        vm.releaseData.message.forEach(function (item) {
                            vm.thirdPartySettings.forEach(function (it) {
                                if (item.storeId == it.id) {
                                    item.name = it.name;
                                }
                            });
                        });
                    }
                },
                function () {
                    MessageService.error("发布失败");
                    vm.saveLoading = false;
                }
            );
        }
        function clear() {
            $uibModalInstance.dismiss();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('platformApp')
        .controller('FrameControlDialogController', FrameControlDialogController);

        FrameControlDialogController.$inject = ['$state','$timeout', "$q", '$scope', 'UidService', '$stateParams', '$uibModalInstance', 'entity', 'FrameConfig', 'Qinius',
            'MessageService','ThemeClassify','$http','$uibModal'];

    function FrameControlDialogController ($state,$timeout, $q, $scope, UidService, $stateParams, $uibModalInstance, entity, FrameConfig, Qinius, MessageService,ThemeClassify, $http,$uibModal) {
        var vm = this;
        //是否是编辑模式
        vm.frameCopy = null;
        vm.isEdit = false;
        if (entity.message) {
            vm.isEdit = true;
            vm.frame = entity.message;
            $http({url: vm.frame.img + '?imageInfo'}).success(function (data) {
                vm.imgHeight = data.height;
                vm.imgWidth = data.width;
                vm.imgZoom = 236 / vm.imgWidth
                vm.frame.marginTop1 =Math.round( vm.frame.marginTop * (vm.imgZoom * vm.imgHeight) / (1 + vm.frame.marginBottom /100 + vm.frame.marginTop /100) / (vm.imgZoom * vm.imgHeight) );
                vm.frame.marginBottom1 =Math.round( vm.frame.marginBottom * (vm.imgZoom * vm.imgHeight) / (1 + vm.frame.marginBottom /100 + vm.frame.marginTop /100) / (vm.imgZoom * vm.imgHeight) );
                vm.frame.marginLeft1 =Math.round( vm.frame.marginLeft * (vm.imgZoom * vm.imgWidth) / (1 + vm.frame.marginLeft /100 + vm.frame.marginRight /100) / (vm.imgZoom * vm.imgWidth) );
                vm.frame.marginRight1 =Math.round( vm.frame.marginRight * (vm.imgZoom * vm.imgWidth) / (1 + vm.frame.marginLeft /100 + vm.frame.marginRight /100) / (vm.imgZoom * vm.imgWidth) );
                vm.frameCopy = angular.copy( vm.frame );
            }).error(function (error) {});

        }else{
            vm.frame = entity
            vm.frame.marginTop1 = 15;
            vm.frame.marginBottom1 = 15;
            vm.frame.marginLeft1 = 15;
            vm.frame.marginRight1 = 15;
            vm.frameCopy = angular.copy( vm.frame );
        }

        vm.clear = clear;
        vm.save = save;
        vm.openedCheck = openedCheck;
        vm.step='first';
        vm.shape=[
            {name:'圆形',value:'Ellipse'},
            {name:'方型',value:'Rectangle'}
        ]
        vm.attachments =[];
        vm.imgs = [];
        vm.keys = [];
        vm.themeClassifies = ThemeClassify.getAllByCondition1({items:[{key:"type",value:"BORDER", op:"="},{key:"used",value:"true", op:"="}]});

        Qinius.get(function (msg) {
            vm.token = msg.token;
        });

        vm.domain = Qinius.getDomain();
        $q.all([ vm.domain.$promise]).then(function(){
            vm.domainQ =   vm.domain.domain;
        })

        function openedCheck(flag) {
            vm.frame.enable = flag;
        }

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }


        function onSaveSuccess (result) {
            MessageService.success("边框素材保存成功");
            $uibModalInstance.close(result);
            vm.isSaving = false;
        };

        function onSaveError () {
            MessageService.error("边框素材保存失败");
            vm.isSaving = false;
        };

        var bigSizePics = [];
        //批量上传素材
        window.updateImgFile = function ($event) {
            $timeout(function () {
                bigSizePics = [];
                for(var i=0;i<$event.target.files.length;i++){
                    var file = $event.target.files[i];
                    vm.imgs.push(file.name);
                    if (file.size >= 20 * 1024 * 1024) {
                        file.imageSize = Math.ceil(file.size / 1024 / 1024);
                        bigSizePics.push(file);
                    } else {
                        fileGet(file,i);
                    }
                }
                if (bigSizePics.length > 0) {
                    thumbnailatorPic();
                }
                $event.srcElement.value = ""
            });
        };
        function fileGet(file,i) {
            var formData = new FormData();
            formData.append('file', file);
            formData.append('unique_names', false);
            formData.append('key', 'mask-' + UidService.get());
            formData.append('token', vm.token);
            $.ajax({
                cache: true,
                type: "POST",
                url: 'https://upload.qiniup.com/',
                data: formData,
                async: false,
                contentType: false,
                processData: false,
                success: function (data) {
                    vm.attachments.push({identifier:data.key,fileName:vm.imgs[i]});
                    vm.keys.push(data.key);
                    vm.frame.img = vm.domainQ + data.key;
                    $http({url: vm.frame.img + '?imageInfo'}).success(function (data) {
                        vm.imgHeight = data.height;
                        vm.imgWidth = data.width;
                        vm.imgZoom = 236 / vm.imgWidth
                    }).error(function (error) {});
                    },
                error: function (request) {
                    MessageService.error("文件上传失败");
                }
            });
        }

        $scope.nextStep=function(){
            if (!vm.frame.themeClassifyId) {
                MessageService.error('请选择边框分类')
                return;
            }
            if (!vm.frame.name) {
                MessageService.error('请输入名称')
                return;
            }
            if (!vm.frame.seq) {
                MessageService.error('请输入排序')
                return;
            }
            if (!vm.frame.img) {
                MessageService.error('请上传边框')
                return;
            }
            vm.step='second'
        }
        function save () {
            //修改标签
            if($state.current.name === "frame-control.updateTag"){
               return FrameConfig.put(vm.frame,onSaveSuccess,onSaveError)
            }
            var photoFrame = document.getElementById('photoFrame');
            var width = photoFrame.offsetWidth;
            var height = photoFrame.offsetHeight;
            var x = $('#photoFrame').offset().top;
            var y = $('#photoFrame').offset().left;
            html2canvas_adapt(photoFrame,{
                onrendered: function (canvas) {
                    var url = canvas.toDataURL("image/png");
                    var blob = dataURLtoBlob(url);
                    var formData = new FormData();
                    formData.append('file', blob);
                    formData.append('key', 'cover-' + UidService.get());
                    formData.append('token', vm.token);
                    $.ajax({
                        cache: true,
                        type: "POST",
                        url: 'https://upload.qiniup.com/',
                        data: formData,
                        async: false,
                        contentType: false,
                        processData: false,
                        success: function (data) {
                            vm.frame.cover=vm.domainQ + data.key
                            console.log(vm.frame.cover);
                            vm.frame.marginBottom = $scope.HeightBottom() /$scope.photoHeight() *100
                            vm.frame.marginTop = $scope.HeightTop() /$scope.photoHeight() *100
                            vm.frame.marginLeft = $scope.WidthLeft() /$scope.photoWidth() *100
                            vm.frame.marginRight = $scope.WidthRight() /$scope.photoWidth() *100
                            vm.frame.type='USER';
                            if (entity.message) {
                                FrameConfig.put(vm.frame,onSaveSuccess,onSaveError)
                            }else{
                                FrameConfig.forUser(vm.frame,onSaveSuccess,onSaveError)
                            }
                        }
                    })
                },
                letterRendering: true,
                useCORS: true,
                width: width,
                height: height,
                windowWidth: document.body.scrollWidth,
                windowHeight: document.body.scrollHeight,
                x:x,
                y:y,
                backgroundColor: "rgba(0, 0, 0, 0)"
            })
        };

        function dataURLtoBlob(dataurl) {
            var arr = dataurl.split(','), mime = arr[0].match(/:(.*?);/) ? arr[0].match(/:(.*?);/)[1] : null,
                bstr = atob(arr[1]), n = bstr.length, u8arr = new Uint8Array(n);
            while (n--) {
                u8arr[n] = bstr.charCodeAt(n);
            }
            return new Blob([u8arr], {type: mime});
        }
        // 计算照片孔宽高
        $scope.photoWidth = function(){
            return (vm.imgZoom * vm.imgWidth) * (1  - vm.frame.marginLeft1 /100 - vm.frame.marginRight1 /100)
        }
        $scope.photoHeight = function(){
            return (vm.imgZoom * vm.imgHeight) * (1  - vm.frame.marginTop1 /100 - vm.frame.marginBottom1 /100)
        }
        $scope.HeightTop  = function(){
            return (vm.imgZoom * vm.imgHeight) * vm.frame.marginTop1 /100;
        }
        $scope.HeightBottom  = function(){
            return (vm.imgZoom * vm.imgHeight) * vm.frame.marginBottom1 /100;
        }
        $scope.WidthLeft  = function(){
            return (vm.imgZoom * vm.imgWidth) * vm.frame.marginLeft1 /100;
        }
        $scope.WidthRight  = function(){
            return (vm.imgZoom * vm.imgWidth) * vm.frame.marginRight1 /100;
        }
        // 换算
        $scope.marginTop = function(){
            if (vm.frameCopy.marginTop1 + vm.frameCopy.marginBottom1 >= 100) {
                vm.frameCopy.marginTop1 = 100 - vm.frameCopy.marginBottom1
                MessageService.error('上下边距之和不能大于100,当前上边距最大值是：'+vm.frameCopy.marginTop1)
            }
            vm.frame.marginTop1 = vm.frameCopy.marginTop1;
        }
        $scope.marginBottom = function(){
            if (vm.frameCopy.marginTop1 + vm.frameCopy.marginBottom1 >= 100) {
                vm.frameCopy.marginBottom1 = 100 - vm.frameCopy.marginTop1
                MessageService.error('上下边距之和不能大于100,当前下边距最大值是：'+vm.frameCopy.marginBottom1)
            }
            vm.frame.marginBottom1 = vm.frameCopy.marginBottom1;
        }
        $scope.marginLeft = function(){
            if (vm.frameCopy.marginLeft1 + vm.frameCopy.marginRight1 >= 100) {
                vm.frameCopy.marginLeft1 = 100 - vm.frameCopy.marginRight1;
                MessageService.error('左右边距之和不能大于100,当前左边距最大值是：'+vm.frameCopy.marginLeft1)
            }
            vm.frame.marginLeft1 = vm.frameCopy.marginLeft1;
        }
        $scope.marginRight = function(){
            if (vm.frameCopy.marginLeft1 + vm.frameCopy.marginRight1 >= 100) {
                vm.frameCopy.marginRight1 = 100 - vm.frameCopy.marginLeft1
                MessageService.error('左右边距之和不能大于100,当前右边距最大值是：'+vm.frameCopy.marginRight1)
            }
            vm.frame.marginRight1 = vm.frameCopy.marginRight1;
        }

        function thumbnailatorPic(){
            $uibModal.open({
                templateUrl: 'app/entities/page/thumbnailator.html',
                controller: 'ThumbnailatorController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'md',
                resolve: {
                    entity: [function() {
                        return {
                            files: bigSizePics
                        };
                    }]
                }
            }).result.then(function (values) {
                bigSizePics = [];
                if (values) {
                    //for (var j = 0; j < values.length; j++) {

                    //var data = {key: value.key};
                    for (var i = 0; i < values.length; i++) {
                        var value = values[i];
                        fileGet(value,i);
                    }
                    //}
                }
            }, function () {
            });false
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('platformApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('frame-control', {
            parent: 'app',
            url: '/frame-control?page&sort&search&c',
            data: {
                authorities: [],
                pageTitle: 'platformAppTitle.myUpload'
            },
            views: {
                'content': {
                    templateUrl: 'app/entities/frame-control/frame-control.html',
                    controller: 'FrameControlController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null,
                c:null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search,
                        c: $stateParams.c
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('frame');
                    $translatePartialLoader.addPart('global');
                    $translatePartialLoader.addPart('title');
                    return $translate.refresh();
                }]
            }
        })
        .state('frame-control.new', {
            parent: 'frame-control',
            url: '/new',
            data: {
                authorities: []
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/frame-control/frame-control-dialog.html',
                    controller: 'FrameControlDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                enable:true,
                                seq:null,
                                img:null,
                                shape:null,
                                marginTop:15,
                                marginBottom:15,
                                marginLeft:15,
                                marginRight:15,
                                themeClassifyId:null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('frame-control', {}, {reload: true});
                }, function() {
                    $state.go('frame-control');
                });
            }]
        })
        .state('frame-control.edit', {
            parent: 'frame-control',
            url: '/{id}/edit',
            data: {
                authorities: []
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/frame-control/frame-control-dialog.html',
                    controller: 'FrameControlDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                        entity: ['FrameConfig', function(FrameConfig) {
                            return FrameConfig.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('frame-control', {}, {reload: true});
                }, function() {
                    $state.go('frame-control');
                });
            }]
        })

        .state('frame-control.updateTag', {
            parent: 'frame-control',
            url: '/{id}/updateTag',
            data: {
                authorities: []
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/frame-control/update-tag.html',
                    controller: 'FrameControlDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                        entity: ['FrameConfig', function(FrameConfig) {
                            return FrameConfig.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('frame-control', {}, {reload: true});
                }, function() {
                    $state.go('frame-control');
                });
            }]
        })
         ;


    }

})();

(function() {
    'use strict';
    angular
        .module('platformApp')
        .factory('FrameConfig', FrameConfig);

        FrameConfig.$inject = ['$resource'];

    function FrameConfig ($resource) {
        var resourceUrl =  'bunny/' + 'api/frame-config/:path/:id';

        return $resource(resourceUrl, {}, {
            
            "forUser": {
                method: "POST",
                params: {
                    path: "forUser"
                }
            },
            'put': {
                method:'PUT' ,
                params: {
                    path: "forUser"
                }
            },
            'delete': {
                method:'DELETE' 
            },
            'get': {
                method:'GET' 
            },
            'onlyRelease': {
                method: 'GET',
                params:{
                    path:"onlyRelease"
                },
            },
            "byCondition1": {
                method: 'POST',
                params: {
                    path: "byCondition1"
                }
            },
            "byCondition": {
                method: 'POST',
                params: {
                    path: "byCondition"
                }
            },
            "batchDelete":{
                method: 'delete',
                params:{
                    path:"batchDelete"
                },
            },
            "getAllByCondition": {
                method: 'POST',
                params: {
                    path: "getAllByCondition"
                }
            } 
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('platformApp')
        .controller('FrameControlController', FrameControlController);

    FrameControlController.$inject = ['$scope', '$q', '$state', 'ParseLinks', 'paginationConstants', 'pagingParams', 'Qinius',
    'MessageService','FrameConfig','ThemeClassify', '$uibModal', '$timeout'];

    function FrameControlController ($scope, $q, $state, ParseLinks,  paginationConstants, pagingParams, Qinius,
     MessageService , FrameConfig, ThemeClassify, $uibModal, $timeout) {
        var vm = this;

        vm.tabs = [{key:"background", value:"背景", url:'background'},
        {key:"imageBox", value:"相框", url:'mask'},
        {key:"borderBox", value:"边框", url:'frame-control'},
        {key:"font", value:"字体", url:'font-management'},
        {key:"clipArt", value:"素材", url:'clip-art'},
        {key:"image", value:"图片", url:'pic'}];
        vm.currentName = "borderBox";

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = 15;
        vm.clear = clear;
        vm.search = search;
        vm.loadAll = loadAll;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;
        vm.jump = jump;
        vm.page = pagingParams.page;
        //标签筛选项是否展开
        vm.tagScreenIsOpen = false;

        vm.themeClassifies = ThemeClassify.getAllByCondition1({items:[
            {key:"type",value:"BORDER", op:"="},
            {key:"used",value:"true", op:"="}]});
        vm.domain = Qinius.getDomain();
        vm.themeClassifyId = pagingParams.c - 0;
        $q.all([ vm.domain.$promise, vm.themeClassifies.$promise]).then(function(){
            vm.domainQ =   vm.domain.domain;
            vm.themeClassifies.unshift({name:"全部", id:"全部", seq:-1});
            $scope.selectTag(vm.themeClassifies[0]);
        })

        $scope.delete = function(id){
            MessageService.confirm({
                title:'提示',
                cancel:'取消',
                confirm:'确认',
                msg:'确定要删除该边框？'
            },function(){
                FrameConfig.delete({id: id},function () {
                    loadAll();
                });
            },function(){});
        };


        $scope.editTag = function(){
            $uibModal.open({
                templateUrl: 'app/entities/page/catalog-management.html',
                controller: 'CatalogManagementController',
                backdrop: 'static',
                keyboard: true,
                windowClass: "jh-modal-md",
                controllerAs: 'vm',
                resolve: {
                    entity: function () {
                        return {catalogType: "BORDER"}
                    }
                }
            }).result.then(function(res) {
                ThemeClassify.getAllByCondition1({items:[
                    {key:"type",value:"BORDER", op:"="},
                    {key:"used",value:"true", op:"="}]}, function(data){
                        vm.themeClassifies = data;
                        vm.themeClassifies.unshift({name:"全部", id:"全部", seq:-1});
                        $scope.selectTag(vm.themeClassifies[0]);
                    });
            });
        }

        $scope.batchDelet = function(){
            var ids = [];
            vm.sourceMaterials.forEach(function(it){
                if (it.selected) {
                    ids.push(it.id);
                }
            });
            if (ids.length>0) {
                MessageService.confirm({
                title:'提示',
                cancel:'取消',
                confirm:'确认',
                msg:'确定要删除所选边框？'
            }, function(){
                    FrameConfig.batchDelete({ids_:ids}, function(res){
                        MessageService.success("删除成功");
                        vm.batch = false;
                        vm.count = 0;
                        loadAll();
                    }, function(va){
                        MessageService.error("删除失败，请稍后再试");
                    })
                })
            }else{
                MessageService.error("未勾选任何有效的背景，请确认后再操作");
            }
        }

        $scope.itemSelect = function(item){
            if (!vm.batch) {
                return
            }
            item.selected = !item.selected;
            vm.count = 0;
            vm.sourceMaterials.forEach(function(it){
                if (it.selected) {
                    vm.count ++;
                }
            })
        }

        $scope.exitBatch = function(){
            vm.sourceMaterials.forEach(function(it){
                it.selected = false;
            })
            vm.batch = false;
            vm.count = 0;
        }

         //更改展开收起状态
        $scope.changeMoreState = function(key){
            vm[key] = !vm[key]
        }

        // 当前页变更
        vm.currentChange = function(){
            $timeout(function(){
                loadAll();
            })
        }

        $scope.selectTag = function(item){
            vm.themeClassifies.forEach(function(it){
                it.active = false;
            })
            item.active = true;
            if (item.id == '全部') {
                vm.themeClassifyId = null;
            }else{
                vm.themeClassifyId = item.id;
            }
            loadAll();
        }

        $scope.more = function(item){
            vm.sourceMaterials.forEach(function(it){
                it.more = false;
            });
            item.more = true;
        }

        function loadAll () {
            var items = []
            if (vm.themeClassifyId) {
                items.push({key:"themeClassify.id",value:vm.themeClassifyId, op:"="})
            }
            if (pagingParams.search) {
                items.push({key:"name",value:pagingParams.search, op:"like"})

            }
            FrameConfig.byCondition1({
                items:items,
                page: vm.page - 1,
                size: vm.itemsPerPage,
                sort: ["lastModifiedDate,desc"]
            }, onSuccess, onError);

            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.sourceMaterials = data.message;
                vm.count = 0;
            }
            function onError(error) {
                MessageService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch,
                c: vm.themeClassifyId
            });
        }

        function search(searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear() {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.themeClassifyId = null;
            vm.currentSearch = null;
            vm.transition();
        }

        function jump () {
            vm.page = vm.jumpText<=0?1:vm.jumpText;
            loadPage(vm.page);
        }

        $scope.searchClass = function(){
            vm.transition()
        }

        $scope.issue = function(item){
            $uibModal.open({
                templateUrl: 'app/entities/frame-control/frame-control-issue-dialog.html',
                controller: 'FrameControlIssueDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'lg',
                resolve: {
                    entity: function () {
                        return JSON.parse(localStorage.getItem('platform2-user'))
                    },
                    borderId: function () {
                        return item.id
                    }
                }
            }).result.then(function() {

            }, function() {

            });
        }
    }
})();

(function () {
    "use strict";

    angular.module("platformApp").controller("FontManagementDialogController", FontManagementDialogController);

    FontManagementDialogController.$inject = [
        "$timeout",
        "$scope",
        "$stateParams",
        "$uibModalInstance",
        "entity",
        "FontManagement",
        "Upload",
        "MessageService"
    ];

    function FontManagementDialogController(
        $timeout,
        $scope,
        $stateParams,
        $uibModalInstance,
        entity,
        FontManagement,
        Upload,
        MessageService
    ) {
        var vm = this;
        //选择的文件
        vm.files = [];
        //上传Loading
        vm.uploading = false;
        //是否展示导入按钮
        vm.showUpload = true;
        vm.saveText = "上传";
        vm.clear = clear;
        $timeout(function () {
            angular.element(".form-group:eq(1)>input").focus();
        });
        $(document).ready(function () {
            if (window.history && window.history.pushState) {
                $(window).on("popstate", function () {
                    clear();
                });
            }
            //文件拖曳上传
            $("#upload-font-box").bind("dragenter", function (event) {
                event.preventDefault();
            });
            $("#upload-font-box").bind("dragover", function (event) {
                event.preventDefault();
            });
            $("#upload-font-box").bind("drop", function (event) {
                event.preventDefault();
                var files = event.originalEvent.dataTransfer.files;
                var reg = /\.(otf|ttf|fon)$/i; // 使用正则表达式来忽略后缀的大小写
                if (files.length > 30) return MessageService.error("选择文件不能超过30个");
                $timeout(function () {
                    var isOver20M = false;
                    for (var i = 0; i < files.length; i++) {
                        // 判断文件类型与文件大小符合要求，并且忽略后缀的大小写
                        if (reg.test(files[i].name) && files[i].size < 20 * 1024 * 1024) {
                            files[i].status = "wait";
                            vm.files.push(files[i]);
                        }
                        if (files[i].size >= 20 * 1024 * 1024) {
                            isOver20M = true;
                        }
                    }
                    var text = isOver20M ? '请选择小于20M的字体文件' : '请选择正确的字体文件';
                    if (vm.files.length === 0) return MessageService.error(text);
                });
            });
        });

        function clear() {
            if (vm.uploading) {
                MessageService.info("正在上传字体，请稍后再关闭窗口");
                return;
            }
            $uibModalInstance.dismiss("cancel");
        }

        function fileGet(index) {
            if (vm.uploading || index > vm.files.length - 1) return;
            vm.uploading = true;
            vm.showUpload = false;
            var file = vm.files[index];
            file.status = "loading";
            Upload.upload({
                type: "POST",
                url: "bunny/api/font-managements/upload", //上传路径
                data: {
                    file: file,
                    name: file.name,
                    type: "User"
                }
            }).then(
                function successCallback(res) {
                    vm.uploading = false;
                    if (res.status && res.status == 200) {
                        file.status = "success";
                    } else {
                        file.status = "error";
                    }
                    if (vm.files && vm.files.length - 1 > index) {
                        fileGet(index + 1);
                    }

                    $scope.$emit("platformApp:bFontManagementUpdate");
                },
                function errorCallback(response) {
                    file.status = "error";
                    vm.uploading = false;
                    if (vm.files && vm.files.length - 1 > index) {
                        fileGet(index + 1);
                    }
                }
            );
        }

        //字体上传
        window.updateImgFile = function ($event) {
            $scope.$digest();
            if ($event.target.files.length > 30 || vm.files.length + $event.target.files.length > 30) {
                MessageService.error("选择文件太多，请重新选择");
                return;
            }
            vm.saveText = "上传";
            $timeout(function () {
                for (var i = 0; i < $event.target.files.length; i++) {
                    var file = $event.target.files[i];
                    if (file.size < 20 * 1024 * 1024) {
                        file.status = "wait";
                        vm.files.push(file);
                    } else {
                        MessageService.error("选择的文件不能大于20M");
                    }
                }
            });
        };
        //删除字体
        $scope.deleteFont = function (index) {
            vm.files.splice(index, 1);
        };
        $scope.save = function () {
            if (vm.files.length === 0) return;
            fileGet(0);
        };
    }
})();

(function() {
    'use strict';

    angular
        .module('platformApp')
        .controller('FontManagementDetailController', FontManagementDetailController);

    FontManagementDetailController.$inject = ['$scope', '$rootScope', '$stateParams', '$uibModalInstance', 'entity', 'FontManagement'];

    function FontManagementDetailController($scope, $rootScope, $stateParams, $uibModalInstance, entity, FontManagement) {
        var vm = this;

        vm.fontManagement = entity;
        vm.clear = clear;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        var unsubscribe = $rootScope.$on('platformApp:fontManagementUpdate', function(event, result) {
            vm.fontManagement = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('platformApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('font-management', {
            parent: 'app',
            url: '/font-management?page&sort&search',
            data: {
                authorities: [],
                pageTitle: 'platformAppTitle.myUpload'
            },
            views: {
                'content': {
                    templateUrl: 'app/entities/font-management/font-managements.html',
                    controller: 'FontManagementController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('fontManagement');
                    $translatePartialLoader.addPart('global');
                    $translatePartialLoader.addPart('title');
                    return $translate.refresh();
                }]
            }
        })
        .state('font-management-detail', {
            parent: 'font-management',
            url: '/font-management/{id}',
            data: {
                authorities: [],
                pageTitle: 'platformApp.fontManagement.detail.title'
            },
            onEnter:['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal){
                $uibModal.open({
                    templateUrl: 'app/entities/font-management/font-management-detail.html',
                    controller: 'FontManagementDetailController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {

                        entity: ['FontManagement', function(FontManagement) {
                            return FontManagement.get({id : $stateParams.id}).$promise;
                        }],
                        translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                            $translatePartialLoader.addPart('fontManagement');
                            $translatePartialLoader.addPart('style');
                            $translatePartialLoader.addPart('global');
                            return $translate.refresh();
                        }]
                    }
                }).result.then(function() {
                    $state.go('font-management', null, { reload: 'font-management' });
                }, function() {
                    $state.go('font-management');
                });
            }]
        })

        .state('font-management.new', {
            parent: 'font-management',
            url: '/new',
            data: {
                authorities: []
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/font-management/font-management-dialog.html',
                    controller: 'FontManagementDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                family: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('font-management', null, { reload: 'font-management' });
                }, function() {
                    $state.go('font-management');
                });
            }]
        })
        .state('font-management.edit', {
            parent: 'font-management',
            url: '/{id}/edit',
            data: {
                authorities: []
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/font-management/font-management-dialog.html',
                    controller: 'FontManagementDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['FontManagement', function(FontManagement) {
                            return FontManagement.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('font-management', null, { reload: 'font-management' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
         ;
    }

})();

(function() {
    'use strict';
    angular
        .module('platformApp')
        .factory('FontManagement', FontManagement);

    FontManagement.$inject = ['$resource'];

    function FontManagement ($resource) {
        var resourceUrl =  'bunny/' + 'api/font-managements/:path/:id';

        return $resource(resourceUrl, {}, {
            "fontSupport":{
                method:"GET",
                params:{
                    path:"font-support"
                }
            },
            "getDefaultShow":{
                method:"GET",
                params:{
                    path:"getDefaultShow"
                }
            },
            "byCondition":{
                method:"POST",
                params:{
                    path:"byCondition"
                },
                isArray:true
            },
            "upload": {
                method: "POST",
                params: {
                    path: "upload"
                }
            },
            "getAll": {
                method: "POST",
                params: {
                    path: "getAll"
                },
                isArray: true
            },
            "getAll2": {
                method: "POST",
                params: {
                    path: "getAll2"
                },
                isArray: true
            },
            "getAll3": {
                method: "GET",
                params: {
                    path: "getAll3"
                },
                isArray: true
            },
            "updateType": {
                method: "GET",
                params: {
                    path: "updateType"
                }
            },
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
            "getCss": {
                method: "GET",
                params: {
                    path: "getCss2"
                }
            },
            "getFormat": {
                method: "GET",
                params: {
                    path: "getFormat"
                }
            },
            "batchDelete": {
                method: "DELETE",
                params: {
                    path: "batchDelete"
                }
            },
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('platformApp')
        .controller('FontManagementController', FontManagementController);

    FontManagementController.$inject = ['$scope', '$state', 'FontManagement', 'ParseLinks', 'paginationConstants', 'pagingParams', 'MessageService', "$rootScope",
    '$localStorage', 'Qinius', '$q', '$timeout'];

    function FontManagementController ($scope, $state, FontManagement, ParseLinks, paginationConstants, pagingParams, MessageService, $rootScope,
        $localStorage, Qinius, $q, $timeout) {
        var vm = this;


        vm.tabs = [{key:"background", value:"背景", url:'background'},
        {key:"imageBox", value:"相框", url:'frame-control'},
        {key:"borderBox", value:"边框", url:'frame-control'},
        {key:"font", value:"字体", url:'font-management'},
        {key:"clipArt", value:"素材", url:'clip-art'},
        {key:"image", value:"图片", url:'pic'}];
        vm.currentName = "font";


        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.clear = clear;
        vm.search = search;
        vm.loadAll = loadAll;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;
        vm.jump = jump;
        vm.account = $localStorage.user;

        var unsubscribe = $rootScope.$on('platformApp:bFontManagementUpdate', function(event) {
            loadAll();
        });
        $scope.$on('$destroy', unsubscribe);

        loadAll();

        // 当前页变更
        vm.currentChange = function(){
            $timeout(function(){
                loadAll();
            })
        }

        $scope.exitBatch = function(){
            vm.fontManagements.forEach(function(it){
                it.selected = false;
            })
            vm.batch = false;
            vm.count = 0;
            vm.selecteAll = false;
        }



        $scope.batchDelet = function(){
            var ids = [];
            vm.fontManagements.forEach(function(it){
                if (it.selected) {
                    ids.push(it.id);
                }
            });
            if (ids.length>0) {
                MessageService.confirm({
                    title:'提示',
                    cancel:'取消',
                    confirm:'确认',
                    msg:'确定删除所选字体？',
                }, function(){
                    FontManagement.batchDelete({ids_:ids}, function(res){
                        MessageService.success("删除成功");
                        loadAll();
                        vm.batch = false;
                        vm.count = 0;
                        vm.selecteAll = false;
                    }, function(va){
                        MessageService.error("删除失败，请稍后再试");
                    })
                })
            }else{
                MessageService.error("未勾选任何有效的背景，请确认后再操作");
            }
        }


        $scope.selecteAll = function(){
            vm.count = 0;
            if (vm.selecteAll) {
                vm.fontManagements.forEach(function(it){
                    it.selected = false;
                })
                vm.selecteAll = false;
            }else{
                vm.fontManagements.forEach(function(it){
                    it.selected = true;
                    vm.count ++;
                })
                vm.selecteAll = true;
            }
        }

        $scope.itemSelect = function(item){
            if (!vm.batch) {
                return
            }
            item.selected = !item.selected;
            vm.count = 0;
            vm.fontManagements.forEach(function(it){
                if (it.selected) {
                    vm.count ++;
                }
            });
            vm.selecteAll = vm.count == vm.fontManagements;
        }

        vm.domain = Qinius.getDomain();
        $q.all([ vm.domain.$promise]).then(function(){
            vm.domainQ =   vm.domain.domain;
        })

        $scope.delete = function(id){
            if (vm.batch) {
                MessageService.info('请先退出批量操作')
                return
            }
            MessageService.confirm({
                title:'提示',
                cancel:'取消',
                confirm:'确认',
                msg:'确定删除该字体？'
            },function(){
                FontManagement.delete({id: id},function () {
                    loadAll();
                });
            },function(){});
        };

        function loadAll () {
            if (vm.account == undefined || vm.account == null) {
                $state.go('home');
                return;
            }
            var items = [];
            if (pagingParams.search) {
                items.push({key:"name",value:pagingParams.search, op:"like"});
            }
            FontManagement.byCondition({
                items:items,
                page: vm.page - 1,
                size: vm.itemsPerPage,
                sort: ["id,desc"]
            }, onSuccess, onError);

            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.fontManagements = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                console.log(2);
                MessageService.error("字体获取失败");
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search(searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear() {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }

        function jump () {
            vm.page = vm.jumpText<=0?1:vm.jumpText;
            loadPage(vm.page);
        }

        $scope.viewFont = function(fontManagement){
            if (vm.batch) {
                MessageService.info('请先退出批量操作')
                return
            }
            $state.go('font-management-detail',{id:fontManagement.id})
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('platformApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('entity', {
            abstract: true,
            parent: 'app'
        });
    }
})();

(function () {
    'use strict';

    var PagePreviewControl = {
    	restrict: 'EAC',
        replace: true,
        transclude: true,
        templateUrl: 'app/entities/components/page-preview.html',
        controllerAs: 'vm',
        bindings: {
            page: '<',
            scale: '<',
            cover: '<',
            pageIndex: '<',
            imgSize: '<',
            imgDpi: '<',
            isCover: '<',
            isImageboxNot: '<',
            thumbnail:'<',
            isMin:'<'
        },

        controller: ['$scope', function ($scope) {
            var vm = this;
            //边框
            $scope.imageboxW = function (imagebox) {
                if (!imagebox) {
                    return
                }
                if (imagebox.border) {
                    if (imagebox.border.type == 'Color') {
                        return Number(imagebox.geometry.width) + Number(imagebox.border.lineWidth) * 2
                    }
                    if (imagebox.border.type == 'Pic') {
                        return imagebox.geometry.width
                        // return Number(imagebox.geometry.width) + (Number(imagebox.geometry.width) * Number(imagebox.border.edge.left) / 100) + (Number(imagebox.geometry.width) * Number(imagebox.border.edge.right) / 100)
                    }
                } else {
                    return imagebox.geometry.width
                }
            }
            $scope.imageboxH = function (imagebox) {
                if (!imagebox) {
                    return
                }
                if (imagebox.border) {
                    if (imagebox.border.type == 'Color') {
                        return Number(imagebox.geometry.height) + Number(imagebox.border.lineWidth) * 2
                    }
                    if (imagebox.border.type == 'Pic') {
                        return imagebox.geometry.height
                        // return Number(imagebox.geometry.height) + (Number(imagebox.geometry.height) * Number(imagebox.border.edge.top) / 100) + (Number(imagebox.geometry.height) * Number(imagebox.border.edge.bottom) / 100)
                    }
                } else {
                    return imagebox.geometry.height
                }
            }
            $scope.imageboxL = function (imagebox) {
                if (!imagebox) {
                    return
                }
                if (imagebox.border) {
                    if (imagebox.border.type == 'Color') {
                        return Number(imagebox.geometry.x) - Number(imagebox.border.lineWidth)
                    }
                    if (imagebox.border.type == 'Pic') {
                        return imagebox.geometry.x
                        // return Number(imagebox.geometry.x) - (Number(imagebox.geometry.width) * Number(imagebox.border.edge.left) / 100)
                    }
                } else {
                    return imagebox.geometry.x
                }
            }
            $scope.imageboxT = function (imagebox) {
                if (!imagebox) {
                    return
                }
                if (imagebox.border) {
                    if (imagebox.border.type == 'Color') {
                        return Number(imagebox.geometry.y) - Number(imagebox.border.lineWidth)
                    }
                    if (imagebox.border.type == 'Pic') {
                        return imagebox.geometry.y
                        // return Number(imagebox.geometry.y) - (Number(imagebox.geometry.height) * Number(imagebox.border.edge.top) / 100)
                    }
                } else {
                    return imagebox.geometry.y
                }
            }
            $scope.imageboxWEdge = function (imagebox, edge) {
                if (!imagebox) {
                    return
                }
                if (imagebox.border) {
                    if (imagebox.border.type == 'Color') {
                        return Number(imagebox.border.lineWidth)
                    }
                    if (imagebox.border.type == 'Pic') {
                        if (edge == 'left') {
                            return Number(imagebox.geometry.width) * Number(imagebox.border.edge.left) / 100
                        }
                        if (edge == 'top') {
                            return Number(imagebox.geometry.height) * Number(imagebox.border.edge.top) / 100
                        }
                        if (edge == 'right') {
                            return Number(imagebox.geometry.width) * Number(imagebox.border.edge.right) / 100
                        }
                        if (edge == 'bottom') {
                            return Number(imagebox.geometry.height) * Number(imagebox.border.edge.bottom) / 100
                        }
                    }
                } else {
                    return 0
                }
            }
            $scope.imageboxWRadius = function (imagebox, radius, ratio, ratio1) {
                if (!imagebox) {
                    return
                }
                if (imagebox.border) {
                    var _ratio = 1;
                    if(ratio && ratio1){
                        if(imagebox.geometry.width > imagebox.geometry.height){
                            _ratio = ratio1
                        }else{
                            _ratio = ratio
                        }
                    }
                    if(ratio && !ratio1){
                        _ratio = ratio
                    }
                    if (imagebox.border.shape == 'Ellipse') {
                        return '50%'
                    }
                    if (imagebox.border.radius.filletType == 'Fixed') {//圆角固定值
                        var _radius = imagebox.border.radius[radius];
                        return _radius > 0 ? (_radius + Number(imagebox.border.lineWidth)/2) * _ratio : 0;
                    }else{
                        var radiusW = imagebox.geometry.width > imagebox.geometry.height ? imagebox.geometry.height : imagebox.geometry.width;
                        radiusW = radiusW + imagebox.border.lineWidth;
                        var _r = radiusW * imagebox.border.radius[radius] / 100;
                        return _r > 0 ? (_r + Number(imagebox.border.lineWidth)/2) * _ratio : 0
                    }
                } else {
                    return 0
                }
            }
            $scope.imageboxWRadius1 = function (imagebox, radius, ratio, ratio1) {
                if (!imagebox) {
                    return
                }
                if (imagebox.border) {
                    var _ratio = 1;
                    if(ratio && ratio1){
                        if(imagebox.geometry.width > imagebox.geometry.height){
                            _ratio = ratio1
                        }else{
                            _ratio = ratio
                        }
                    }
                    if(ratio && !ratio1){
                        _ratio = ratio
                    }
                    if (imagebox.border.shape == 'Ellipse') {
                        return '50%'
                    }
                    if (imagebox.border.radius.filletType == 'Fixed') {//圆角固定值
                        var _radius = imagebox.border.radius[radius];
                        return  (_radius - Number(imagebox.border.lineWidth)/2) > 0 ? (_radius - Number(imagebox.border.lineWidth)/2) * _ratio : 0;
                    }else{
                        var radiusW = imagebox.geometry.width > imagebox.geometry.height ? imagebox.geometry.height : imagebox.geometry.width;
                        radiusW = radiusW + imagebox.border.lineWidth;
                        var _r = radiusW * imagebox.border.radius[radius] / 100;
                        return (_r - Number(imagebox.border.lineWidth)/2) > 0 ? (_r - Number(imagebox.border.lineWidth)/2) * _ratio : 0
                    }
                } else {
                    return 0
                }
            }
            $scope.imageboxWRadius2 = function (imagebox, radius) {
                if (!imagebox) {
                    return
                }
                if (imagebox.border) {
                    if (imagebox.border.shape == 'Ellipse') {
                        return '200%'
                    } else {
                        var radiusW = imagebox.geometry.width > imagebox.geometry.height ? imagebox.geometry.height : imagebox.geometry.width;
                        radiusW = radiusW + imagebox.border.lineWidth;
                        var _r = radiusW * imagebox.border.radius[radius] / 100;
                        return _r > 0 ? _r + Number(imagebox.border.lineWidth)/2 : 0
                    }
                } else {
                    return 0
                }
            }
            $scope.imageboxWRadius3 = function (imagebox, radius) {
                if (!imagebox) {
                    return
                }
                if (imagebox.border) {
                    if (imagebox.border.shape == 'Ellipse') {
                        return '200%'
                    } else {
                        var radiusW = imagebox.geometry.width > imagebox.geometry.height ? imagebox.geometry.height : imagebox.geometry.width;
                        radiusW = radiusW + imagebox.border.lineWidth;
                        var _r = radiusW * imagebox.border.radius[radius] / 100;
                        return (_r - Number(imagebox.border.lineWidth)/2) > 0 ? _r - Number(imagebox.border.lineWidth)/2 : 0
                    }
                } else {
                    return 0
                }
            }
            $scope.dropShadow = function(imagebox,ratio){
                if (imagebox.shadow == null) {
                    imagebox.shadow={
                        color:'#777777',
                        x:0,
                        y:0,
                        blur:0
                    }
                }
                var width = $scope.imageboxW(imagebox) * ratio;
                var height =$scope.imageboxH(imagebox) * ratio;
                return dropShadow(imagebox,width,height)
            }
        }]
    };
    angular.module('platformApp')
    	.component('pagePreview', PagePreviewControl);

})();

(function () {
    'use strict';

    var OutlineViewControl = {
        restrict: 'EAC',
        replace: true,
        transclude: true,
        templateUrl: 'app/entities/components/outline-view.html',
        controllerAs: 'vm',
        bindings: {
            page: '<',
            onChange: '&'
        },
        controller: ['$scope', '$timeout', 'Qinius', 'MessageService', 'UidService','ImgprocContours', '$q',
            function ($scope, $timeout, Qinius, MessageService, UidService, ImgprocContours, $q) {
                var vm = this;
                vm.page = angular.copy(vm.page);
                vm.page.background = null;
                vm.outlineWidth = 2;
                vm.errorImage = null;
                if(vm.page.levels.level && vm.page.levels.level.length > 0){
                    vm.page.levels.level = vm.page.levels.level.filter(function(item){
                        return item.imagebox
                    });
                    if(!vm.page.levels.level.length){
                        MessageService.error('没有图片框，不能生成刀线');
                        vm.onChange();
                        return false;
                    }
                }else{
                    MessageService.error("空白页无法生成刀线");
                    vm.onChange();
                    return false;
                }
                vm.width = PxTurnMm(vm.page.mediabox.width);
                vm.height = PxTurnMm(vm.page.mediabox.height);
                vm.threeLoading=false;
                vm.threeLoadingText = "刀线图生成中...";
                $scope.domain = Qinius.getDomain();
                vm.token = Qinius.get();
                vm.scale = 1;
                vm.scale1 = 1;
                vm.thumbnailScale = 1;
                vm.windowWidth = 600;
                if (vm.page.mediabox.width > vm.page.mediabox.height) {
                    vm.scale = vm.windowWidth / vm.page.mediabox.width;
                } else {
                    vm.scale = vm.windowWidth / vm.page.mediabox.height;
                }
                vm.windowWidth1 = vm.isMobile ? 260 : 360;
                if (vm.page.mediabox.width > vm.page.mediabox.height) {
                    vm.scale1 = vm.windowWidth1 / vm.page.mediabox.width;
                } else {
                    vm.scale1 = vm.windowWidth1 / vm.page.mediabox.height;
                }
                
                $q.all([$scope.domain.$promise, vm.token.$promise]).then(function () {
                    vm.token = vm.token.token;
                    $scope.domain = $scope.domain.domain;
                    $scope.page = vm.page;
                    $scope.page.notTrimbox = true;
                    if($scope.page.outline && $scope.page.outline.contourWidth >= 0){
                        vm.outlineWidth = $scope.page.outline.contourWidth || 0;
                    }
                    // if(!$scope.page.outline){
                    //     vm.threeLoading=true;
                    //     thumbnailInit(function(url){
                    //         generateContour(url);
                    //     })
                    // }
                });
                function generateContour(url){
                    ImgprocContours.generateContour({
                        "page": {
                            "front": url  // 必填，图像URL或base64数据
                        },
                        "pageSize": {          // 可选，期望输出尺寸（毫米）
                            "width": vm.width,
                            "height": vm.height
                        },
                        "contourWidth": Number(vm.outlineWidth),   // 可选，描边宽度（毫米），默认2.0
                        "smoothFactor": 3,      // 可选，平滑因子，默认0
                        "mirrorable": true
                    },function(res){
                        if(res && res.data){
                            res.data.image = url;
                        }
                        imgprocSuccess(res,'cutline');
                    },imgprocError)
                }
                function imgprocSuccess(res,type) {
                    vm.threeLoading=false;
                    if(res.success){
                        if(res.data && res.data.success){
                            $scope.page.outline = {
                                type: type,
                                contourWidth: vm.outlineWidth,
                                geometry: res.data.mmRect,
                                cutline:{
                                    resource:{
                                        identifier: res.data.contourUrl
                                    },
                                },
                            }
                            if(res.data.mirror){
                                $scope.page.outline.mirrorCutline = {
                                    resource:{
                                        identifier: res.data.mirror.contourUrl
                                    }
                                }
                            }
                            console.log($scope.page)
                            $scope.$apply();
                        }else{
                            vm.errorImage = res.data;
                        }
                    }else{
                        MessageService.error(res.error);
                    }
                }
                function imgprocError(err) {
                    if($scope.page.outline && $scope.page.outline.contourWidth >= 0){
                        vm.outlineWidth = $scope.page.outline.contourWidth;
                    }
                    vm.threeLoading=false;
                    MessageService.error(err.data.error || "刀线生成失败");
                }
                //生成封面图
                function thumbnailInit(callback) {
                    $timeout(function () {
                        html2canvas_adapt(document.getElementById('thumbnail-outline'), {
                            onrendered: function (canvas) {
                                if(canvas){
                                    var url = canvas.toDataURL("image/png");
                                    var blob = dataURLtoBlob(url);
                                    var formData = new FormData();
                                    formData.append('file', blob);
                                    formData.append('key', '3dThumbnail-' + UidService.get());
                                    formData.append('token', vm.token);
                                    $.ajax({
                                        cache: true,
                                        type: "POST",
                                        url: 'https://upload.qiniup.com/',
                                        data: formData,
                                        async: false,
                                        contentType: false,
                                        processData: false,
                                        success: function (data) {
                                            callback($scope.domain + data.key)
                                        },
                                        error: function () {
                                            callback()
                                        }
                                    })
                                }else{
                                    callback()
                                }
                            },
                            error:function(){
                                callback()
                            },
                            letterRendering: true,
                            useCORS: true,
                            width: $scope.page.custom.width * vm.thumbnailScale,
                            height: $scope.page.custom.height * vm.thumbnailScale,
                            windowWidth: document.body.scrollWidth,
                            windowHeight: document.body.scrollHeight,
                            x: 0,
                            y: 0,
                            backgroundColor: "rgba(0, 0, 0, 0)",
                            dpi:300
                        });
                    })
                }
                $scope.resetOutline = function () {
                    $scope.page.outline = null;
                    $scope.page.outlineSpread = null;
                    vm.threeLoading=true;
                    thumbnailInit(function(url){
                        generateContour(url,'cutline');
                    })
                }
                $scope.removeOutline = function () {
                    $scope.page.outline = null;
                    $scope.page.outlineSpread = null;
                }
                window.updatePic = function ($event) {
                    $timeout(function () {
                        vm.errorImage = null;
                        var file = $event.target.files[0]; // 获取上传的文件
                        if (!file.type.startsWith('image/png')) {
                            MessageService.error("您上传的图片格式为"+file.type+"，刀线图仅支持png格式，请重新上传");
                            return;
                        }
                        vm.threeLoading=true;
                        vm.threeLoadingText = "刀线图生成中...";
                        uploadImage(file, function(data){
                            if(data && data.key){
                                ImgprocContours.parseContour({
                                    "page": {
                                        "contour": $scope.domain + data.key
                                    },
                                    "pageSize": {          // 可选，期望输出尺寸（毫米）
                                        "width": vm.width,
                                        "height": vm.height
                                    },
                                    "contourWidth": vm.outlineWidth,   // 可选，描边宽度（毫米），默认2.0
                                    "smoothFactor": 3,      // 可选，平滑因子，默认0
                                    "mirrorable": true
                                },function(res){
                                    if(res && res.data){
                                        res.data.image = $scope.domain + data.key
                                    }
                                    $scope.page.outline = null;
                                    $scope.page.outlineSpread = null;
                                    imgprocSuccess(res,'customized');
                                },imgprocError)
                            }else{
                                vm.threeLoading=false;
                                MessageService.error("上传失败");
                                $scope.$apply();
                            }
                        },function(err){
                            vm.threeLoading=false;
                            MessageService.error("上传失败");
                            $scope.$apply();
                        })
                    })
                };
                
                function uploadImage(file, callback) {
                    var formData = new FormData();
                    formData.append('file', file);
                    formData.append('key', 'gallery-' + UidService.get());
                    formData.append('token', vm.token);
                    $.ajax({
                        cache: true,
                        type: "POST",
                        url: 'https://upload.qiniup.com/',
                        data: formData,
                        async: true,
                        contentType: false,
                        processData: false,
                        success: function (data) {
                            if(callback){callback(data)}
                        },
                        error: function (request) {
                            if(callback){callback()}
                        }
                    });
                }
                var outlineWidthDebounce;
                vm.changeOutlineWidth = function () {
                    var outlineWidth = Number(vm.outlineWidth);
                    if (!$scope.page || outlineWidth < 0 || outlineWidth > 5 || isNaN(outlineWidth)) {
                        return;
                    }
                    if (outlineWidthDebounce) {
                        $timeout.cancel(outlineWidthDebounce);
                    }
                    outlineWidthDebounce = $timeout(function () {
                        vm.threeLoading = true;
                        thumbnailInit(function(url){
                            generateContour(url);
                        });
                    }, 500);
                };
                $scope.modalHide = function () {
                    vm.onChange();
                }
                $scope.save = function(){
                    vm.onChange({text:$scope.page});
                }
            }]
    };

    angular.module('platformApp')
        .component('outlineView', OutlineViewControl);

})();

(function () {
    "use strict";

    var ModeleSelect = {
        restrict: "EAC",
        replace: true,
        transclude: true,
        templateUrl: "app/entities/components/modele-select.html",
        controllerAs: "vm",
        scope: {},
        bindings: {
            ngModel: "=",
            placeholder: "@",
            prefix: "@", //前缀
            options: "<",
            labelKey: "@",
            valueKey: "@",
            ngChange: "&",
            style:"@",
        },
        controller: [
            "$scope",
            "$timeout",
            "$element",
            "$compile",
            function ($scope, $timeout, $element, $compile) {
                var vm = this;
                //创建option节点
                var template = '<div class="modele-select-option scrollbar-main"></div>';
                var linkFn = $compile(template);
                var content = linkFn($scope);
                // 插入到 body 元素下面
                angular.element(document.body).append(content);
                //options选项点击
                $(content).on("click", ".option-item", function (e) {
                    var itemIndex = $(this).index();
                    if (vm.ngModel === vm.options[itemIndex][vm.valueKey]) return;
                    vm.ngModel = vm.options[itemIndex][vm.valueKey];
                    $timeout(function () {
                        if (typeof vm.ngChange === "function") {
                            vm.ngChange();
                        }
                    },20);
                });

                //下拉框是否展示
                vm.showOption = false;
                var selectEle = $element.find(".modele-select")[0];
                //下拉框默认位置
                $timeout(function () {
                    $(content).css({
                        left: selectEle.getBoundingClientRect().left + "px",
                        top: selectEle.getBoundingClientRect().bottom + 4 + "px"
                    });
                });
                //select框宽度
                vm.selectWidth = selectEle.getBoundingClientRect().width;
                //设置默认值
                if (!vm.placeholder) vm.placeholder = "请选择";
                if (!vm.labelKey) vm.labelKey = "label";
                if (!vm.valueKey) vm.valueKey = "value";
                if(!vm.options) vm.options = [];
                vm.$onChanges = function () {
                    vm.createOptions();
                };
                //组装option
                vm.createOptions = function () {
                    var optionDom = "";
                    angular.forEach(vm.options, function (item) {
                        optionDom +=
                            '<div class="option-item" ' +
                            'data-value="' +
                            item[vm.valueKey] +
                            '">' +
                            item[vm.labelKey] +
                            "</div>";
                    });
                    $(content).html(optionDom);
                    if (vm.showOption) {
                        vm.getOptionPlace();
                    }
                }
                //获取选择框展示的名称
                vm.getShowName = function () {
                    if(vm.ngModel === "" || vm.ngModel === null){
                        return '';
                    }else{
                        var selectIndex = vm.options.findIndex(function(item){
                            return item[vm.valueKey] === vm.ngModel;
                        })
                        if(selectIndex >= 0){
                            //修改页面状态
                            $(content).find(".option-item").removeClass("active");
                            $(content).find(".option-item").eq(selectIndex).addClass("active");
                            return vm.options[selectIndex][vm.labelKey];
                        }
                        return '';
                    }
                };
                //判断下拉框展示位置
                vm.getOptionPlace = function () {
                    if (!vm.showOption) return;
                    $timeout(function () {
                        var windowHeight = document.documentElement.clientHeight || document.body.clientHeight;
                        var windowWidth = document.documentElement.clientWidth || document.body.clientWidth;
                        var selectInfo = selectEle.getBoundingClientRect();
                        var optionHeight = $(content)[0].getBoundingClientRect().height;
                        vm.selectWidth = selectInfo.width;
                        //为美观考虑，暂时跟选择框宽度保持一致（产品）
                        $(content).css({
                            width: vm.selectWidth + 'px'
                            // minWidth: vm.selectWidth + "px",
                            // maxWidth: windowHeight + "px"
                        })
                        //判断右侧距离是否足够
                        if($(content)[0].getBoundingClientRect().right >= windowWidth){
                            $(content).css({
                                right: 0,
                                left:'auto'
                            });
                        }else{
                            $(content).css({
                                left: selectInfo.left + "px",
                                right:'auto'
                            });
                        }



                        //判断下方高度是否足够
                        if (windowHeight - selectInfo.bottom > optionHeight + 4) {
                            $(content).css({
                                top: selectInfo.bottom + 4 + "px",
                                bottom: "auto",
                                transform:"none"
                            });
                            return;
                        }
                        //判断上方高度是否足够
                        if (selectInfo.top > optionHeight + 4) {
                            $(content).css({
                                bottom: windowHeight - selectInfo.top + 4 + "px",
                                top: "auto",
                                transform:"none"
                            });
                            return;
                        }
                        //距离不够，居中显示
                        $(content).css({
                            top: "50%",
                            transform: "translate(0, -50%)"
                        });
                        console.log($(content)[0].getBoundingClientRect());
                    });
                };
                //点击输入框，展示或隐藏下拉列表
                $scope.clickInput = function () {
                    if (vm.showOption) {
                        $scope.hide();
                    } else {
                        $scope.show();
                    }
                };
                $scope.show = function () {
                    vm.createOptions();
                    $timeout(function () {
                        vm.showOption = true;
                        $(content).show();
                        vm.getOptionPlace();
                    });
                };
                $scope.hide = function () {
                    $timeout(function () {
                        vm.showOption = false;
                        $(content).hide();
                    });
                };
                //页面点击
                function docClick() {
                    if (vm.showOption) {
                        $scope.hide();
                    }
                }
                //键盘事件
                function onKeyDown() {
                    var keyCode = event.keyCode;
                    if (keyCode === 27 || keyCode === 9) {
                        $scope.hide();
                    }
                }

                vm.resizeTimer = null;
                //屏幕大小变化或页面滚动
                function onResizeOrScroll() {
                    if (vm.showOption) {
                        if (!vm.resizeTimer) {
                            vm.resizeTimer = setTimeout(function () {
                                //重新计算下拉框展示位置
                                vm.getOptionPlace();
                                vm.resizeTimer = null;
                            }, 100);
                        }
                    }
                }
                document.addEventListener("click", docClick);
                document.addEventListener("keydown", onKeyDown);
                window.addEventListener("resize", onResizeOrScroll);
                window.addEventListener("scroll", onResizeOrScroll);
                window.addEventListener("mousewheel",onResizeOrScroll);

                vm.$onDestroy = function () {
                    //删除插入元素，取消监听事件
                    content.remove();
                    document.removeEventListener("click", docClick);
                    document.removeEventListener("keydown", onKeyDown);
                    window.removeEventListener("resize", onResizeOrScroll);
                    window.removeEventListener("scroll", onResizeOrScroll);
                    window.removeEventListener("mousewheel",onResizeOrScroll);
                };
            }
        ]
    };
    angular.module("platformApp").component("modeleSelect", ModeleSelect);
})();

(function () {
    "use strict";

    var ModelePagination = {
        restrict: "EAC",
        replace: true,
        transclude: true,
        templateUrl: "app/entities/components/modele-pagination.html",
        controllerAs: "vm",
        scope: {},
        bindings: {
            page: "=",
            total:"<",
            size:"<",
            currentChange:"&"

        },
        controller: [
            "$scope",
            "$timeout",
            function ($scope,$timeout) {
                var vm = this;
                vm.pages = 1;
                vm.$onInit = function(){
                    // console.log(vm.page);
                    // console.log(this.total);

                }
                vm.$onChanges = function(){
                    if(vm.total > 0){
                        vm.pages = Math.ceil(vm.total / vm.size);
                    }else{
                        vm.pages = 1
                    }
                    if(vm.page > vm.pages){
                        vm.page = vm.pages;
                        $timeout(function(){
                            vm.currentChange({page: vm.page});
                        })
                    }
                    $timeout(function(){
                        vm.initPage();
                    })


                }
                vm.initPage = function () {
                    laypage({
                        cont: "modele-pagination",
                        curr:vm.page,
                        pages: vm.pages,
                        skip: true, //是否开启跳页
                        first: false,
                        last: false,
                        limit: true,
                        prev: '<i class="iconfont icon-left"></i>',
                        next: '<i class="iconfont icon-right"></i>',
                        jump: function (obj,first) {
                            if(!first){
                                vm.page = obj.curr;
                                //当前页变更事件
                                if(vm.currentChange){
                                    $timeout(function(){
                                        vm.currentChange({page: vm.page});
                                        //页面滚动到顶部
                                        $(".c-home-body").animate({scrollTop:0},200);
                                    })

                                }
                            }

                        },
                    });
                };

            },
        ],
    };
    angular
        .module("platformApp")
        .component("modelePagination", ModelePagination);
})();

(function () {
    "use strict";

    var ModeleColorPicker = {
        restrict: "EAC",
        replace: true,
        transclude: true,
        templateUrl: "app/entities/components/modele-color-picker.html",
        controllerAs: "vm",
        scope: {},
        bindings: {
            color: '=',
            onChange:'&',
            themeColors:'<',
            transparent:'<',//是否可以设置透明色，默认true

        },
        controller: [
            "$scope",
            "$timeout",
            "$element",
            function ($scope, $timeout, $element) {
                var vm = this;
                vm.$onInit = function () {
                    if (!$element.data('$isolateScope')) {
                        $element.data('$isolateScope', $scope);
                    }
                }
                //如果没设置transparent 属性，默认为true
                if(vm.transparent === undefined){
                    vm.transparent = true;
                }
                var changeTimer = null;
                var defaultColorList = ['#000000','#666666','#A8A8A8','#D9D9D9','#FFFFFF',''];
                if(!vm.transparent){//不支持透明色，删掉最后一个
                    defaultColorList.splice(defaultColorList.length-1,1);
                }
                var colorpicker =  Colorpicker.create({
                    bindElem:$element.find(".color-box")[0],
                    initColor:vm.color ? vm.color : 'rgb(255,255,255)',
                    themeColorList:vm.themeColors || [],
                    defaultColorList:defaultColorList,
                    change: function (elem,hex) {
                        if(changeTimer !== null){
                            clearTimeout(changeTimer);
                        }
                        changeTimer = setTimeout(function () {
                            $scope.onChange(angular.element(elem).scope(),hex);
                        },150)

                    },
                    show: function (_this){
                        _this.changeThemeView(vm.themeColors || []);
                    }
                })
                $scope.onChange = function (e,hex) {
                    e.vm.color = hex;
                    $timeout(function () {
                        if(e.vm.onChange){
                            e.vm.onChange();
                        }
                    },100)
                }

            }
        ]
    };
    angular.module("platformApp").component("modeleColorPicker", ModeleColorPicker);
})();

(function () {
    "use strict";
    var localLoading = {
        restrict: "EAC",
        replace: true,
        transclude: true,
        templateUrl: "app/entities/components/local-loading.html",
        controllerAs: "vm",
        scope: {},
        bindings: {
            title: "@",
            show: "<"
        },
        controller: [
            "$scope",
            "$timeout",
            function ($scope, $timeout) {
                var vm = this;
                console.log(vm);
            }
        ]
    };
    angular.module("platformApp").component("localLoading", localLoading);
})();

(function () {
    "use strict";

    var InputNumber = {
        restrict: "EAC",
        replace: true,
        transclude: true,
        templateUrl: "app/entities/components/input-number.html",
        controllerAs: "vm",
        scope: {},
        bindings: {
            ngModel: "=",
            onChange:"&",
            step:"<",
            typeStyle:"<",
            min:"<",
            max:"<"
        },
        controller: ["$scope","$timeout","$element",
            function ($scope, $timeout, $element) {
                var vm = this;
                vm.$onInit = function() {
                    if (!$element.data('$isolateScope')) {
                        $element.data('$isolateScope', $scope);
                    }
                }
                $scope.ngKeypress = function (that) {
                    var _vm = angular.element(that)[0].vm;
                    if (_vm.min != null && _vm.ngModel < _vm.min) {
                        _vm.ngModel = _vm.min
                    }
                    if (_vm.max != null && _vm.ngModel > _vm.max) {
                        _vm.ngModel = _vm.max
                    }
                    if (_vm.onChange) {
                        $timeout(function(){
                            _vm.onChange();
                            $element.find('.focusInput')[0].focus();
                        })
                    }
                }
                $scope.ngBlur = function(that){
                    var _vm = angular.element(that)[0].vm;
                    if (_vm.min != null && _vm.ngModel < _vm.min) {
                        _vm.ngModel = _vm.min
                    }
                    if (_vm.max != null && _vm.ngModel > _vm.max) {
                        _vm.ngModel = _vm.max
                    }
                    if (_vm.onChange) {
                        $timeout(function(){
                            _vm.onChange();
                        })
                    }
                }
                $scope.up = function(that){
                    var _vm = angular.element(that)[0].vm;
                    _vm.ngModel = Number(_vm.ngModel);
                    if (_vm.step) {
                        _vm.ngModel+=Number(_vm.step);
                    }else{
                        _vm.ngModel++;
                    }
                    if (_vm.max != null && _vm.ngModel > _vm.max) {
                        _vm.ngModel = _vm.max
                    }
                    $timeout(function(){
                        _vm.onChange();
                    })
                }
                $scope.down = function(that){
                    var _vm = angular.element(that)[0].vm;
                    _vm.ngModel = Number(vm.ngModel);
                    if (_vm.step) {
                        _vm.ngModel-=Number(_vm.step);
                    }else{
                        _vm.ngModel--;
                    }
                    if (_vm.min != null && _vm.ngModel < _vm.min) {
                        _vm.ngModel = _vm.min
                    }
                    $timeout(function(){
                        _vm.onChange();
                    })
                }
            }
        ]
    };
    angular.module("platformApp").component("inputNumber", InputNumber);
})();

(function() {
    'use strict';

    angular
        .module('platformApp')
        .controller('CalendarCenterTitlePreviewModalController', CalendarCenterTitlePreviewModalController);

        CalendarCenterTitlePreviewModalController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', '$state', 'MessageService','CalendarService'];

    function CalendarCenterTitlePreviewModalController ($timeout, $scope, $stateParams, $uibModalInstance, entity, $state, MessageService,CalendarService) {
        var vm = this;
        vm.cancel = cancel;
        vm.widget = entity.data;
        vm.titleObj = {};
        init();

        function init() {
            if (vm.widget.sampleYear) {
                vm.widget.sampleYear = String(vm.widget.sampleYear);
            }
            if (vm.widget.sampleMonth) {
                vm.widget.sampleMonth = String(vm.widget.sampleMonth);
            }
            if (!vm.widget.width) {
                vm.widget.width = vm.widget.layout.width;
            }
            if (!vm.widget.height) {
                vm.widget.height = vm.widget.layout.height;
            }
            queryYearMonthDataset();
        }

        function queryYearMonthDataset() {
            var req = {
                year: vm.widget.sampleYear || 2023,
                month: vm.widget.sampleMonth || 1
            };
            var formats = [];
            var layout = vm.widget.layout || {};
            if (layout.items && layout.items.length) {
                for (var i = 0; i < layout.items.length; i++) {
                    var item = layout.items[i];
                    if (item.type == 'year' || item.type == 'month') {
                        formats.push({type: item.type, format: item.format});
                    }
                }
            }
            req.formats = formats;
            CalendarService.queryYearMonthSet(req, function (res) {
                vm.titleObj = res.data || {};
            });

        }
        //返回
        function cancel() {
            $uibModalInstance.close();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('platformApp')
        .controller('CalendarCenterTitleController', CalendarCenterTitleController);

        CalendarCenterTitleController.$inject = ['$state', '$scope', 'ProductXml', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams', 'MessageService', 'TitleWidget', '$localStorage', 'Qinius', '$uibModal'];

    function CalendarCenterTitleController($state, $scope, ProductXml, ParseLinks, AlertService, paginationConstants, pagingParams, MessageService, TitleWidget, $localStorage, Qinius, $uibModal) {
        var vm = this;
        $(".sidebar1").hide();
        $(".navbar").show();
        $(".nav-bg").show();
        $(".wrap").css({margin: 0});

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.clear = clear;
        vm.search = search;
        vm.loadAll = loadAll;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;
        vm.jump = jump;
        vm.account = $localStorage.user;
        $scope.domains = Qinius.getDomain();

        loadAll();

        $scope.delete = function(id){
            MessageService.confirm({
                title:'提示',
                cancel:'取消',
                confirm:'确认',
                msg:'确定要删除该数据？'
            },function(){
                TitleWidget.delete({id: id},function () {
                    loadAll();
                });
            },function(){});
        };

        function loadAll () {
            if (vm.account == undefined || vm.account == null) {
                $state.go('home');
                return;
            }
            if (pagingParams.search) {
                TitleWidget.byCondition3({
                    items:[{key:"family",value:pagingParams.search, op:"like"},{key:"status", op:"=", value:'Approved'}],
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                TitleWidget.byCondition3({
                        items:[{key:"status", op:"=", value:'Approved'}],
                        page: pagingParams.page - 1,
                        size: vm.itemsPerPage,
                        sort: sort()
                    },
                    onSuccess, onError);

            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.titleList = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                console.log(2);
                MessageService.error("字体获取失败");
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search(searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear() {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }

        function jump () {
            vm.page = vm.jumpText<=0?1:vm.jumpText;
            loadPage(vm.page);
        }

        //查看
        $scope.look = function (data) {
            $uibModal.open({
                templateUrl: 'app/entities/calendar-center/calendar-center-title-preview-model.html',
                controller: 'CalendarCenterTitlePreviewModalController',
                controllerAs: 'vm',
                backdrop: 'static',
                resolve: {
                    entity: [function() {
                        return {
                            data:data
                        };
                    }]
                }
            });
        }
        $scope.save = function(data){
            TitleWidget.get({id: data.id}, function (res) {
                console.log(res)
                res.id = "";
                res.opened = false;
                res.status = null;
                TitleWidget.save(res, function (res) {
                    MessageService.success("使用成功");
                })
            })
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('platformApp')
        .controller('CalendarCenterBodyPreviewModalController', CalendarCenterBodyPreviewModalController);

        CalendarCenterBodyPreviewModalController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', '$state', 'MessageService', 'CalendarService'];

    function CalendarCenterBodyPreviewModalController($timeout, $scope, $stateParams, $uibModalInstance, entity, $state, MessageService, CalendarService) {
        var vm = this;
        vm.cancel = cancel;
        vm.width = 400;
        vm.height = 400;
        vm.widget = entity.data || {};
        vm.monthObj = {};

        init();

        function init() {
            vm.data = angular.copy(vm.widget);

            if (vm.data.sampleYear) {
                vm.data.sampleYear = String(vm.data.sampleYear);
            }
            if (vm.data.sampleMonth) {
                vm.data.sampleMonth = String(vm.data.sampleMonth);
            }
            if (vm.data.width) {
                vm.height = vm.data.height * 400 / vm.data.width;
            }
            queryMonthdaysDataset();
        }

        function queryMonthdaysDataset() {
            var req = {
                year: vm.data.sampleYear || 2023,
                month: vm.data.sampleMonth || 1,
                startOfWeek: vm.data.startOfWeek || 0,
            };
            var dateFormats = [];
            var dateLayout = vm.data.dateLayout || {};
            if (dateLayout.items && dateLayout.items.length) {
                for (var i = 0; i < dateLayout.items.length; i++) {
                    var item = dateLayout.items[i];
                    if (item.type == 'date') {
                        dateFormats.push({ type: item.type, format: item.format });
                    }
                }
            }
            var weekFormats = [];
            var weekLayout = vm.data.weekLayout || {};
            if (weekLayout.items && weekLayout.items.length) {
                for (var i = 0; i < weekLayout.items.length; i++) {
                    var item = weekLayout.items[i];
                    if (item.type == 'week') {
                        weekFormats.push({ type: item.type, format: item.format });
                    }
                }
            }

            req.dateFormats = dateFormats;
            req.weekFormats = weekFormats;
            CalendarService.queryMonthTable(req, function (res) {
                vm.monthObj = res.data || {};
            });

        }

        //返回
        function cancel() {
            $uibModalInstance.close();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('platformApp')
        .controller('CalendarCenterBodyController', CalendarCenterBodyController);

        CalendarCenterBodyController.$inject = ['$state', '$scope', 'ProductXml', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams', 'MessageService', 'MonthWidget', 'TitleWidget', '$localStorage', 'Qinius', '$uibModal','$timeout'];

    function CalendarCenterBodyController($state, $scope, ProductXml, ParseLinks, AlertService, paginationConstants, pagingParams, MessageService, MonthWidget, TitleWidget, $localStorage, Qinius, $uibModal,$timeout) {
        var vm = this;
        //搜索防抖定时器
        vm.timer = null;
        //分页信息
        vm.pageInfo = {
            page:1,
            size:20,
            total:0,
        }
        //分类
        vm.viewType = "calendar";
        vm.loadPage = loadPage;
        vm.predicate = "id";
        vm.reverse = false;
        vm.transition = transition;
        vm.search = search;
        vm.getList = getList;
        vm.searchQuery = "";
        vm.currentSearch = pagingParams.search;
        vm.account = $localStorage.user;
        $scope.domains = Qinius.getDomain();

        vm.getList();

        $scope.delete = function(id){
            MessageService.confirm({
                title:'提示',
                cancel:'取消',
                confirm:'确认',
                msg:'确定要删除该数据？'
            },function(){
                MonthWidget.delete({id: id},function () {
                    vm.getList();
                });
            },function(){});
        };
        //当前页变更
        vm.currentChange = function(){
            $timeout(function(){
                vm.getList();
            })
        }
        function getList(){
            if(!vm.account){
                return $state.go('home');
            }
            var items = [
                {key:"status", op:"=", value:'Approved'}
            ];
            if (vm.searchQuery) {
                items.push({key:"name",value:vm.searchQuery, op:"like"})
            }
            //日历组件
            if(vm.viewType == "calendar"){
                MonthWidget.byCondition3({
                    items:items,
                    page: vm.pageInfo.page - 1,
                    size: vm.pageInfo.size,
                    sort: ["lastModifiedDate,desc"]
                },
                onSuccess, onError);
            }else if(vm.viewType == "title"){
                //标题组件
                TitleWidget.byCondition3({
                    items:items,
                    page: vm.pageInfo.page -1,
                    size: vm.pageInfo.size,
                    sort: ["lastModifiedDate,desc"]
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.pageInfo.total = headers('X-Total-Count');
                vm.titleList = data;
            }
            function onError(error) {
                MessageService.error("请求失败");
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search() {
            if(event.keyCode === 13){
                vm.links = null;
                vm.pageInfo.page = 1;
                vm.predicate = 'id';
                vm.reverse = false;
                vm.getList();
            }
        }

        //分类点击
        $scope.clickTypeItem = function(data){
            if(vm.viewType == data) return;
            vm.viewType = data;
            vm.pageInfo.page = 1;
            $timeout(function(){
                vm.getList();
            })

        }
        //查看
        $scope.look = function (data) {
            //日历组件
            if(vm.viewType == "calendar"){
                $uibModal.open({
                    templateUrl: 'app/entities/calendar-center/calendar-center-body-preview-model.html',
                    controller: 'CalendarCenterBodyPreviewModalController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    resolve: {
                        entity: [function() {
                            return {
                                data:data
                            };
                        }]
                    }
                });
            }
            //标记组件
            if(vm.viewType == "title"){
                $uibModal.open({
                    templateUrl: 'app/entities/calendar-center/calendar-center-title-preview-model.html',
                    controller: 'CalendarCenterTitlePreviewModalController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    resolve: {
                        entity: [function() {
                            return {
                                data:data
                            };
                        }]
                    }
                });
            }


        }
        $scope.save = function(data){
            //日历插件
            if(vm.viewType == "calendar"){
                MonthWidget.get({id: data.id}, function (res) {
                    console.log(res)
                    res.id = "";
                    res.opened = false;
                    res.status = null;
                    MonthWidget.create(res, function (res) {
                        MessageService.success("使用成功");
                        $state.go('calendar-xml',{id: res.message.id})
                    })
                })
            }
            //标题插件
            if(vm.viewType == "title"){
                TitleWidget.get({id: data.id}, function (res) {
                    console.log(res)
                    res.id = "";
                    res.opened = false;
                    res.status = null;
                    TitleWidget.create(res, function (res) {
                        MessageService.success("使用成功");
                        $state.go('calendar-title-xml',{id: res.message.id})
                    })
                })
            }

        }
    }
})();

(function() {
    'use strict';

    angular
        .module('platformApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('calendar-center-title', {
            parent: 'app1',
            url: '/calendar-center-title',
            data: {
                authorities: [],
                pageTitle: 'platformApp.productXml.home.title'
            },
            views: {
                'content1': {
                    templateUrl: 'app/entities/calendar-center/calendar-center-title.html',
                    controller: 'CalendarCenterTitleController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,desc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('fontManagement');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('calendar-center-body', {
            parent: 'app1',
            url: '/calendar-center-body',
            data: {
                authorities: [],
                pageTitle: 'platformAppTitle.calendar-center-body'
            },
            views: {
                'content1': {
                    templateUrl: 'app/entities/calendar-center/calendar-center-body.html',
                    controller: 'CalendarCenterBodyController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,desc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('fontManagement');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })

    }

})();

(function() {
    'use strict';

    angular
        .module('platformApp')
        .controller('CalendarTitleDataController', CalendarTitleDataController);

    CalendarTitleDataController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', '$state', 'MessageService','CalendarLayout'];

    function CalendarTitleDataController ($timeout, $scope, $stateParams, $uibModalInstance, entity, $state, MessageService,CalendarLayout) {
        var vm = this;
        vm.save = save;
        vm.cancel = cancel;
        vm.layouts = [];
        vm.data = entity || {};
        CalendarLayout.getLayouts({type: 'TITLE',available: true}, function (res) {
            if (res.status == 200 && res.message && res.message.length) {
                vm.layouts = res.message;
            }
        }, function (res) {
            MessageService.error("加载失败");
        });
        vm.onLayoutSelect = function (item) {
            vm.data = item;
        }
        //返回
        function cancel() {
            $uibModalInstance.close();
        }
        function save() {
            if(!vm.data.id){
                MessageService.error("请选择默认标题组件");
                return
            }
            $uibModalInstance.close(vm.data);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('platformApp')
        .controller('CalendarTitleAddController', CalendarTitleAddController);

    CalendarTitleAddController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', '$state', 'MessageService','$uibModal','TitleWidget','FontManagement'];

    function CalendarTitleAddController ($timeout, $scope, $stateParams, $uibModalInstance, entity, $state, MessageService,$uibModal,TitleWidget,FontManagement) {
        var vm = this;
        vm.save = save;
        vm.cancel = cancel;
        vm.data = {
            name: "",
            layout:{},
            layoutId:""
        };
        vm.isCopy = false;
        if(entity){
            vm.data = entity;
            vm.isCopy = true;
        }else{
            var date = new Date();
            vm.data = {
                name: "",
                layout:{},
                layoutId:"",
                sampleYear: date.getFullYear(),
                sampleMonth: date.getMonth() + 1,
            };
            console.log(vm.data)
        }

        $scope.selectLayout = function() {
            $uibModal.open({
                templateUrl: 'app/entities/calendar/modal/calendar-title-data.html',
                controller: 'CalendarTitleDataController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'lg',
                resolve: {
                    entity: function() {
                        return vm.data.layout;
                    }
                }
            }).result.then(function(res) {
                if (res.id != vm.data.dateLayoutId) {
                    vm.data.layout = res;
                    vm.data.layoutId = res.id;
                    vm.data.previewUrl = res.previewUrl;
                }
            });
        }
        FontManagement.getAll2({items: [{key: "defaultShow", op: "=", value: true}], sort: ["id,asc"]}, function (res) {
            vm.data.defaultFontUuid = res[0].uuid;
        });
        //返回
        function cancel() {
            $uibModalInstance.close();
        }
        function save() {
            if(!vm.data.name){
                MessageService.error("标题组件名称不能为空");
                return
            }
            if (!vm.data.layoutId) {
                MessageService.error("请选择类型");
                return;
            }
            vm.isSaving = true;
            if (vm.isCopy) {
                TitleWidget.copy({id:vm.data.id, name:vm.data.name}, function (res) {
                    if (res && res.status == "200") {
                        $state.go('calendar-title-xml',{id:res.message.id});
                        $uibModalInstance.close(res);
                    } else {
                        MessageService.error("复制失败");
                    }
                    vm.isSaving = false;
                }, function (res) {
                    vm.isSaving = false;
                    MessageService.error(res.data.message || "复制失败")
                });
            }else{
                vm.data.width = vm.data.layout.width;
                vm.data.height = vm.data.layout.height;
                TitleWidget.create(vm.data, function (res) {
                    if (res && res.status == "200") {
                        $state.go('calendar-title-xml',{id:res.message.id});
                        $uibModalInstance.close(res);
                    } else {
                        MessageService.error("创建失败");
                    }
                    vm.isSaving = false;
                }, function (res) {
                    vm.isSaving = false;
                    MessageService.error(res.data.message || "提交失败")
                });
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('platformApp')
        .controller('CalendarAddController', CalendarAddController);

    CalendarAddController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', '$state', 'MessageService','CalendarLayout','MonthWidget','FontManagement'];

    function CalendarAddController ($timeout, $scope, $stateParams, $uibModalInstance, entity, $state, MessageService,CalendarLayout,MonthWidget,FontManagement) {
        var vm = this;
        vm.save = save;
        vm.cancel = cancel;
        vm.types = [
            { name: '一行7列', id: 'C7'},
            { name: '一行14列', id: 'C14'},
            { name: '一行21列', id: 'C21'},
        ];
        vm.isCopy = false;
        if(entity){
            vm.data = entity;
            vm.isCopy = true;
        }else{
            var date = new Date();
            vm.data = {
                name: "",
                sampleYear: date.getFullYear(),
                sampleMonth: date.getMonth() + 1,
                weekLayoutId: null,
                dateLayoutId: null,
                displayType: 'C7',
            };
        }
        CalendarLayout.getLayouts({type: 'WEEK'}, function (res) {
            if (res.status == 200 && res.message && res.message.length) {
                vm.data.weekLayout = res.message[0];
                vm.data.weekLayoutId = res.message[0].id;
                onLayoutChange()
            }
        }, function (res) {
            MessageService.error("加载失败");
        });
        CalendarLayout.getLayouts({type: 'DATE'}, function (res) {
            if (res.status == 200 && res.message && res.message.length) {
                vm.data.dateLayout = res.message[0];
                vm.data.dateLayoutId = res.message[0].id;
                onLayoutChange()
            }
        }, function (res) {
            MessageService.error("加载失败");
        });
        function onLayoutChange() {
            var wc = vm.data.weekConfig || {};
            var dc = vm.data.dateConfig || {};
            var headWidth = (Number.parseInt(wc.cellWidth || 40) + Number.parseInt(wc.margin || 0)) * displayType(vm.data.displayType);
            var bodyWidth = (Number.parseInt(dc.cellWidth || 40) + Number.parseInt(dc.margin || 0)) * displayType(vm.data.displayType);

            var tableHeight = Number.parseInt(wc.cellHeight ||20) + (Number.parseInt(dc.cellHeight || 40) + Number.parseInt(dc.margin || 0)) * 5;

            var width = Math.max(headWidth, bodyWidth);

            vm.data.width = width;
            vm.data.height = tableHeight;
            vm.height = vm.data.height * vm.width / vm.data.width;
        }
        $scope.displayTypeUpdate = onLayoutChange;

        FontManagement.getAll2({items: [{key: "defaultShow", op: "=", value: true}], sort: ["id,asc"]}, function (res) {
            vm.data.defaultFontUuid = res[0].uuid;
        });
        //返回
        function cancel() {
            $uibModalInstance.close();
        }
        function save() {
            if(!vm.data.name){
                MessageService.error("日历组件名称不能为空");
                return
            }
            if (!vm.data.weekLayoutId) {
                MessageService.error("数据错误");
                return;
            }
            if (!vm.data.dateLayoutId) {
                MessageService.error("数据错误");
                return;
            }
            vm.isSaving = true;
            if (vm.isCopy) {
                MonthWidget.copy({id:vm.data.id, name:vm.data.name, displayType:vm.data.displayType}, function (res) {
                    if (res && res.status == "200") {
                        $state.go('calendar-xml',{id:res.message.id});
                        $uibModalInstance.close(res);
                    } else {
                        MessageService.error("复制失败");
                    }
                    vm.isSaving = false;
                }, function (res) {
                    vm.isSaving = false;
                    MessageService.error(res.data.message || "复制失败")
                });
            }else{
                MonthWidget.create(vm.data, function (res) {
                    if (res && res.status == "200") {
                        $state.go('calendar-xml',{id:res.message.id});
                        $uibModalInstance.close(res);
                    } else {
                        MessageService.error("创建失败");
                    }
                    vm.isSaving = false;
                }, function (res) {
                    vm.isSaving = false;
                    MessageService.error(res.data.message || "提交失败")
                });
            }
        }
    }
})();

(function () {
    'use strict';

    var weekCellControl = {
    	restrict: 'EAC',
        replace: true,
        transclude: true,
        templateUrl: 'app/entities/calendar/controls/week-cell.control.html',
        controllerAs: 'vm',
        bindings: {
            obj: "<",
            layout: "<",
            settings: "<",
            width: "<",
            height: "<",
            isMin: "<",
            index: "<",
            weekConfig: "<"
        },

        controller: ['$scope', 'FontManagement','$timeout', function ($scope, FontManagement,$timeout) {
            var vm = this;
            vm.data = {
                width: 100,
                height: 50,
                items: []
            };

            vm.$onInit = function() {
                // var settings = vm.settings || {};
                // constructCell(vm.layout, settings, vm.obj);
            }
            // 每當 one-way binding 更新時，changesObj 就是改變前後的差異
            vm.$onChanges = function(data) {
                if (data.layout && data.layout.currentValue) {
                    vm.layout = data.layout.currentValue;
                }
                if (data.settings && data.settings.currentValue) {
                    vm.settings = data.settings.currentValue;
                }
                if (data.obj && data.obj.currentValue) {
                    vm.obj = data.obj.currentValue;
                }
                if (data.weekConfig && data.weekConfig.currentValue) {
                    vm.weekConfig = data.weekConfig.currentValue;
                }
                constructCell(vm.layout, vm.settings, vm.obj);
            }
            vm.$postLink = function () {

            }
            vm.$doCheck = function() {
                // deep watch
            }
            vm.$onDestroy = function () {

            }

            function textStyleObj(obj) {
                var styles = {
                    'position': 'absolute',
                    'left': obj.x + 'px',
                    'top': obj.y + 'px',
                    'line-height': (obj.textSize > 12 ? obj.h : obj.h / (1 / 12 * obj.textSize)) + 'px',
                    'fontSize': (obj.textSize > 12 ? obj.textSize : 12) + 'px',
                    'font-family': obj.textFontUuid,
                    'color': obj.textColor,
                    'text-align': obj.textAlign || 'center',
                    'transform':'scale('+(1 / 12 * obj.textSize > 1 ? 1 : 1 / 12 * obj.textSize)+')',
                    'transform-origin': '0 0',
                    'width': obj.textSize > 12 ? obj.w : obj.w / (1 / 12 * obj.textSize) + 'px',
                    'height': obj.textSize > 12 ? obj.h : obj.h / (1 / 12 * obj.textSize) + 'px',
                };
                if (obj.textWeight) {
                    styles['font-weight'] = obj.textWeight;
                }
                if (obj.textStyle) {
                    styles['font-style'] = obj.textStyle;
                }
                if (obj.backgroundColor) {
                    styles['background-color'] = obj.backgroundColor;
                }
                if (obj.debug) {
                    styles['border'] = '1px dotted #ccc';
                }
                return styles;
            }
            function imageStyleObj(obj) {
                var styles = {
                    'position': 'absolute',
                    'left': obj.x + 'px',
                    'top': obj.y + 'px',
                    'width': obj.w + 'px',
                    'height': obj.h + 'px'
                };
                if (obj.debug) {
                    styles['border'] = '1px dotted #ccc';
                }

                return styles;
            }

            function findItemFromSettings(settings, itemName) {
                if (!settings || !settings.items || !settings.items.length || !itemName) {
                    return {};
                }
                for (var i = 0; i < settings.items.length; i++) {
                    var item = settings.items[i];
                    if (item.name == itemName) {
                        return item;
                    }
                }

                return {};
            }

            function findDataFromObj(obj, type, format) {
                if (!obj || !obj.items || !obj.items.length) {
                    return {};
                }
                for (var i = 0; i < obj.items.length; i++) {
                    var item = obj.items[i];
                    if (item.type == type && item.format == format) {
                        return item;
                    }
                }
                return {};
            }

            function constructCell(layout, settings, myObj) {
                var cw = layout.width || 100;
                var ch = layout.height || 50;
                var width = vm.width || 100;
                var height = vm.height || 50;
                vm.data = {
                    width: width,
                    height: height,
                    styles: {
                        width: angular.copy(width),
                        height: angular.copy(height)
                    },
                    items: []
                };
                if (settings.backgroundColor) {
                    vm.data.styles['background-color'] = settings.backgroundColor;
                }
                var lineW = 0;
                if (settings && settings.items && settings.items.length) {
                    var border = settings.border;
                    if (settings.border && settings.border.lineType && settings.border.lineWidth && border.color) {
                        lineW = (border.lineWidth)*2;
                        vm.data.styles['border'] = (border.lineWidth) + 'px ' + border.lineType + " "  + border.color;
                        if(vm.weekConfig){
                            if(vm.weekConfig.removeBorderOverlap){
                                if(vm.index > 0){
                                    lineW = border.lineWidth;
                                    vm.data.styles['border-left'] = 0 + 'px ' + border.lineType + " "  + border.color;
                                }
                            }
                            if(vm.weekConfig.removeBorderBottom){
                                vm.data.styles['border-bottom'] = 0 + 'px ' + border.lineType + " "  + border.color;
                            }
                        }
                    }
                    if (border.tlRadius) {
                        vm.data.styles['border-top-left-radius'] = border.tlRadius * Math.min(width / cw, height / ch) + 'px';
                    }
                    if (border.trRadius) {
                        vm.data.styles['border-top-right-radius'] = border.trRadius * Math.min(width / cw, height / ch) + 'px';
                    }
                    if (border.blRadius) {
                        vm.data.styles['border-bottom-left-radius'] = border.blRadius * Math.min(width / cw, height / ch) + 'px';
                    }
                    if (border.brRadius) {
                        vm.data.styles['border-bottom-right-radius'] = border.brRadius * Math.min(width / cw, height / ch) + 'px';
                    }
                    width = width - lineW;
                    height = height - lineW;
                    for (var i = 0; i < settings.items.length; i++) {
                        var ci = settings.items[i];
                        var ci1 = layout.items[i];
                        if (ci.type == "image" || ci.type == 'userimage') {
                            var element = {
                                x: ci.x * width / cw,
                                y: ci.y * height / ch,
                                w: ci.w * width / cw,
                                h: ci.h * height / ch
                            };
                            if (settings.debug) {
                                element.debug = true;
                            }
                            var img = {
                                type: ci.type,
                                url: ci.url,
                                styles: imageStyleObj(element)
                            };
                            vm.data.items.push(img);
                        }
                        else if (ci.type) {
                            var element = {
                                x: ci.x * width / cw,
                                y: ci.y * height / ch,
                                w: ci.w * width / cw,
                                h: ci.h * height / ch,
                                textSize: Number.parseInt(ci.textSize) * width / cw,
                                textFont: ci.textFont,
                                textColor: ci.textColor,
                                textAlign: ci.textAlign,
                                textWeight: ci.textWeight,
                                textFontUuid: ci.textFontUuid,
                                backgroundColor: ci.backgroundColor
                            };
                            var item = findItemFromSettings(settings, ci.name) || {};
                            if (item.textFontUuid) {
                                element.textFontUuid = item.textFontUuid;
                                getFont({
                                    fontuuid: element.textFontUuid
                                },FontManagement);
                            }
                            if (item.textSize) {
                                element.textSize = Number.parseInt(item.textSize) * width / cw;
                            }
                            if (item.textFont) {
                                element.textFont = item.textFont;
                            }
                            if (item.textColor) {
                                element.textColor = item.textColor;
                            }
                            if (item.textAlign) {
                                element.textAlign = item.textAlign;
                            }
                            if (item.textBold) {
                                element.textWeight = "600";
                            }
                            if (item.textItalic) {
                                element.textStyle = "italic";
                            }
                            if (item.backgroundColor) {
                                element.backgroundColor = item.backgroundColor;
                            }
                            if (settings.debug) {
                                element.debug = true;
                            }

                            var data = findDataFromObj(myObj || vm.obj, ci.type, ci1.format) || {};
                            var text = {
                                type: ci.type,
                                format: ci1.format,
                                value: data.value || ci.value || ci.sample || '一',
                                styles: textStyleObj(element)
                            };
                            vm.data.items.push(text);
                        }

                    }
                } else {
                    var t = {
                        type: "week",
                        format: "$cnWeek",
                        value: "星期日",
                        textSize: 18 * width / 100,
                        textFont: '',
                        textFontUuid: '',
                        textColor: '#000000',
                        textWeight: 600,
                        x: 5 * width / 100,
                        y: 10 * height / 50,
                        w: 90 * width / 100,
                        h: 30  * height / 50,
                        fixedTo: ''
                    };
                    vm.data.items.push({
                        type: t.type,
                        format: t.format,
                        value: t.value || t.sample,
                        styles: textStyleObj(t)
                    });
                }
            }
            $scope.itemValue = function (item) {
                if(item&&item.value){
                    return item.value
                }
            }
        }]
    };
    angular.module('platformApp')
        .component('weekCell', weekCellControl);

})();

(function () {
    'use strict';

    var titleCellControl = {
    	restrict: 'EAC',
        replace: true,
        transclude: true,
        templateUrl: 'app/entities/calendar/controls/title-cell.control.html',
        controllerAs: 'vm',
        bindings: {
            widget: "=",
            width: "<",
            height: "<",
            year: "<",
            month: "<",
            scale: "<"
        },

        controller: ['$scope', '$timeout','FontManagement','CalendarService', function ($scope, $timeout,FontManagement,CalendarService) {
            var vm = this;
            vm.data = {
                width: 200,
                height: 80,
                items: []
            };

            vm.$onInit = function() {
            }
            // 每當 one-way binding 更新時，changesObj 就是改變前後的差異
            vm.$onChanges = function(data) {
                if(data.year&&data.year.currentValue&&data.year.previousValue>0){vm.year = data.year.currentValue; vm.widget.obj = null;}
                if(data.month&&data.month.currentValue&&data.month.previousValue>0){vm.month = data.month.currentValue; vm.widget.obj = null;}
                if (data.widget && data.widget.currentValue) {
                    vm.widget = data.widget.currentValue;
                }
                if(vm.widget){
                    if(!vm.widget.ctrl){
                        vm.widget.ctrl = {}
                    }
                    if(vm.widget.geometry){
                        vm.widget.width = vm.widget.geometry.width;
                        vm.widget.height = vm.widget.geometry.height;
                        if(vm.widget.layout){
                            vm.widget.layout.width = vm.widget.layout.geometry.width;
                            vm.widget.layout.height = vm.widget.layout.geometry.height;
                            if(vm.widget.layout.items&&vm.widget.layout.items.item){
                                vm.widget.layout.items = vm.widget.layout.items.item;
                                vm.widget.layout.items.forEach(function (item) {
                                    item.w = item.geometry.width;
                                    item.h = item.geometry.height;
                                    item.x = item.geometry.x;
                                    item.y = item.geometry.y;
                                })
                            }
                        }
                        if(vm.widget.settings){
                            if(vm.widget.settings.items&&vm.widget.settings.items.item){
                                vm.widget.settings.items = vm.widget.settings.items.item;
                                vm.widget.settings.items.forEach(function (item) {
                                    if(item.geometry){
                                        item.w = item.geometry.width;
                                        item.h = item.geometry.height;
                                        item.x = item.geometry.x;
                                        item.y = item.geometry.y;
                                    }
                                })
                            }
                        }
                    }
                    queryYearMonthDataset( function () {
                        vm.widget.ctrl.settings = vm.widget.settings;
                        vm.widget.ctrl.obj = vm.widget.obj || [];
                        if(vm.widget.layout){
                            constructCell(vm.widget.layout, vm.widget.ctrl.settings, vm.widget.ctrl.obj);
                        }
                    })
                }
            }
            vm.$postLink = function () {

            }
            vm.$doCheck = function() {
                // deep watch
            }
            vm.$onDestroy = function () {

            }
            function queryYearMonthDataset(callback) {
                if(vm.widget.obj){
                    if(callback){callback()}
                    return
                }
                vm.widget.obj = null;
                var req = {
                    year: vm.widget.sampleYear || 2023,
                    month: vm.widget.sampleMonth || 1
                };
                var formats = [];
                var layout = vm.widget.layout || {};
                if (layout.items && layout.items.length) {
                    for (var i = 0; i < layout.items.length; i++) {
                        var item = layout.items[i];
                        if (item.type == 'year' || item.type == 'month') {
                            formats.push({type: item.type, format: item.format});
                        }
                    }
                }
                req.formats = formats;
                CalendarService.queryYearMonthSet(req, function (res) {
                    vm.widget.obj = res.data || null;
                    if(callback){callback()}
                });
            }

            function textStyleObj(obj) {
                var styles = {
                    'position': 'absolute',
                    'left': obj.x + 'px',
                    'top': obj.y + 'px',
                    'width': obj.textSize > 12 ? obj.w : obj.w / (1 / 12 * obj.textSize) + 'px',
                    'height': obj.textSize > 12 ? obj.h : obj.h / (1 / 12 * obj.textSize) + 'px',
                    // 'line-height': (obj.textSize > 12 ? obj.h : obj.h / (1 / 12 * obj.textSize)) + 'px',
                    'fontSize': (obj.textSize > 12 ? obj.textSize : 12) + 'px',
                    'font-family': obj.textFontUuid,
                    'color': obj.textColor,
                    // 'text-align': obj.textAlign || 'center',
                    'transform':'scale('+(1 / 12 * obj.textSize > 1 ? 1 : 1 / 12 * obj.textSize)+')',
                    'transform-origin': '0 0',
                    'display':'flex',
                    'align-items':'center',
                    'justify-content':obj.textAlign || 'center',
                    'overflow': 'hidden'
                };
                if (obj.textWeight) {
                    styles['font-weight'] = obj.textWeight;
                }
                if (obj.textStyle) {
                    styles['font-style'] = obj.textStyle;
                }
                if (obj.backgroundColor) {
                    styles['background-color'] = obj.backgroundColor;
                }
                if (obj.debug) {
                    styles['border'] = '1px dotted #ccc';
                }
                if (obj.vertical) {
                    styles['writing-mode'] = "vertical-lr";
                    // styles['line-height'] = (obj.textSize > 12 ? obj.w : obj.w / (1 / 12 * obj.textSize)) + 'px';
                }
                return styles;
            }
            function imageStyleObj(obj) {
                var styles = {
                    'position': 'absolute',
                    'left': obj.x + 'px',
                    'top': obj.y + 'px',
                    'width': obj.w + 'px',
                    'height': obj.h + 'px'
                };
                if (obj.debug) {
                    styles['border'] = '1px dotted #ccc';
                }

                return styles;
            }

            function findItemFromSettings(settings, itemName) {
                if (!settings || !settings.items || !settings.items.length || !itemName) {
                    return {};
                }
                for (var i = 0; i < settings.items.length; i++) {
                    var item = settings.items[i];
                    if (item.name == itemName) {
                        return item;
                    }
                }

                return {};
            }

            function findDataFromObj(obj, type, format) {
                if (!obj || !obj.items || !obj.items.length) {
                    return {};
                }
                for (var i = 0; i < obj.items.length; i++) {
                    var item = obj.items[i];
                    if (item.type == type && item.format == format) {
                        return item;
                    }
                }
                return {};
            }

            function constructCell(layout, settings, myObj) {
                settings.width = layout.width;
                settings.height = layout.height;
                var width = vm.width || settings.width || 200;
                var height = vm.height || settings.height || 80;
                vm.data = {
                    width: width,
                    height: height,
                    styles: {
                        width: width + 'px',
                        height: height + 'px',
                        'transform' : 'scale('+(vm.scale || 1) + ')',
                        'transform-origin' : '0px 0px',
                        'overflow': 'hidden'
                    },
                    items: []
                };
                if (settings.backgroundColor) {
                    vm.data.styles['background-color'] = settings.backgroundColor;
                }
                if (settings.border && settings.border.lineType && settings.border.lineWidth) {
                    var border = settings.border;
                    vm.data.styles['border'] = border.lineWidth + 'px ' + border.lineType + " " + border.color;
                    if (border.tlRadius) {
                        vm.data.styles['border-top-left-radius'] = border.tlRadius + 'px';
                    }
                    if (border.trRadius) {
                        vm.data.styles['border-top-right-radius'] = border.trRadius + 'px';
                    }
                    if (border.blRadius) {
                        vm.data.styles['border-bottom-left-radius'] = border.blRadius + 'px';
                    }
                    if (border.brRadius) {
                        vm.data.styles['border-bottom-right-radius'] = border.brRadius + 'px';
                    }
                }
                if (settings && settings.items && settings.items.length) {
                    var cw = settings.width || 200;
                    var ch = settings.height || 80;
                    for (var i = 0; i < settings.items.length; i++) {
                        var ci = settings.items[i];
                        if(!ci.format){
                            ci.format = layout.items[i].format;
                        }
                        if(!ci.w || !ci.h){
                            ci.w = layout.items[i].w;
                            ci.h = layout.items[i].h;
                            ci.x = layout.items[i].x;
                            ci.y = layout.items[i].y;
                        }
                        if (ci.type == "image") {
                            var element = {
                                x: ci.x * width / cw,
                                y: ci.y * height / ch,
                                w: ci.w * width / cw,
                                h: ci.h * height / ch
                            };
                            if (settings.debug) {
                                element.debug = true;
                            }
                            var img = {
                                type: ci.type,
                                url: ci.url,
                                styles: imageStyleObj(element)
                            };
                            vm.data.items.push(img);
                        }
                        else if (ci.type) {
                            var element = {
                                x: ci.x * width / cw,
                                y: ci.y * height / ch,
                                w: ci.w * width / cw,
                                h: ci.h * height / ch,
                                textSize: ci.textSize * Math.min(width / cw, height / ch),
                                textFont: ci.textFont,
                                textColor: ci.textColor,
                                textAlign: ci.textAlign,
                                textWeight: ci.textWeight,
                                textFontUuid: ci.textFontUuid,
                                vertical:ci.vertical
                            };
                            var item = findItemFromSettings(settings, ci.name) || {};
                            if (item.textFontUuid) {
                                element.textFontUuid = item.textFontUuid;
                                getFont({
                                    fontuuid: element.textFontUuid
                                },FontManagement);
                            }
                            if (item.textSize) {
                                element.textSize = item.textSize * Math.min(width / cw, height / ch);
                            }
                            if (item.textFont) {
                                element.textFont = item.textFont;
                            }
                            if (item.textColor) {
                                element.textColor = item.textColor;
                            }
                            if (item.textAlign) {
                                element.textAlign = item.textAlign;
                            }
                            if (item.textBold) {
                                element.textWeight = "600";
                            }
                            if (item.textItalic) {
                                element.textStyle = "italic";
                            }
                            if (item.backgroundColor) {
                                element.backgroundColor = item.backgroundColor;
                            }

                            if (settings.debug) {
                                element.debug = true;
                            }

                            var data = findDataFromObj(myObj, ci.type, ci.format) || {};

                            var text = {
                                type: ci.type,
                                format: ci.format,
                                value: data.value || ci.value || ci.sample,
                                styles: textStyleObj(element)
                            };
                            vm.data.items.push(text);
                        }

                    }
                } else {
                    var t = {
                        type: "year",
                        format: "$yyyy",
                        value: "2023",
                        textSize: 18 * width / 100,
                        textFont: '',
                        textFontUuid: '',
                        textColor: '#000000',
                        x: 5 * width / 200,
                        y: 10 * height / 80,
                        w: 90 * width / 200,
                        h: 30  * height / 80,
                        fixedTo: '',
                        vertical:false
                    };
                    vm.data.items.push({
                        type: t.type,
                        format: t.format,
                        value: t.value || t.sample,
                        styles: textStyleObj(t)
                    });
                }
            } // end of constructCell

        }]
    };
    angular.module('platformApp')
        .component('titleCell', titleCellControl);

})();

(function () {
    'use strict';

    var styleSettingControl = {
    	restrict: 'EAC',
        replace: true,
        transclude: true,
        templateUrl: 'app/entities/calendar/controls/style-setting.control.html',
        controllerAs: 'vm',
        bindings: {
            style:'<',
            options:'<',
            obj:'<',
            settings:'<',
            config:'<',
            fontList:'<',
            themeColors:'<',
            title:'<',
            onChange:'&'
        },

        controller: ['$scope','$timeout','FontManagement', function ($scope,$timeout,FontManagement) {
            var vm = this;
            vm.data = {};
            $scope.$watch(function() {
                return vm.themeColors;
            }, function(newlist,oldList) {
                vm.themeColors = newlist;
            });
            vm.textAligns=[
                {id:'left',value:'左对齐'},
                {id:'center',value:'居中'},
                {id:'right',value:'右对齐'},
            ]
            vm.lineWidths=[
                {id:0,value:'0'},
                {id:1,value:'1'},
                {id:2,value:'2'},
                {id:3,value:'3'},
            ]
            vm.$onInit = function() {
                if(vm.data&&vm.data.settings&&vm.data.settings.items){
                    vm.data.settings.items.forEach(function (item) {
                        fontStyle(item,true)
                    })
                }
            }
            // 每當 one-way binding 更新時，changesObj 就是改變前後的差異
            vm.$onChanges = function(data) {
                if(data.settings&&data.settings.currentValue){
                    vm.data.settings = data.settings.currentValue;
                    if(!vm.data.settings.border.lineWidth){
                        vm.data.settings.border.lineWidth = 0;
                    }
                }
                if (vm.data.settings && !vm.data.settings.border.lineType) {
                    vm.data.settings.border.lineType = 'solid';
                }
            }
            vm.$postLink = function () {

            }
            vm.$doCheck = function() {
                // deep watch
            }
            vm.$onDestroy = function () {

            }

            $scope.onCheckboxChange = function() {
                onSettingsChange();
            }

            $scope.onBorderInputChange = function(num) {
                onSettingsChange();
            }

            $scope.onColorChange = function(text) {
                $scope.$apply();
                onSettingsChange();
            }
            var a = null;
            $scope.onInputChange = function(num, index) {
                if (a !== null) {
                    clearTimeout(a)
                }
                a = setTimeout(function () {
                    if(!num || num == 'undefined'){
                        vm.data.settings.items[index].textSize = 12;
                    }
                    $scope.onItemChange();
                },800)
            }
            $scope.onFontChange = function(text,item){
                $timeout(function () {
                    fontStyle(item)
                    onSettingsChange();
                })
            }
            function fontStyle(font,initialize) {
                var _fontStyle = [];
                for (var i = 0; i < vm.fontList.length; i++) {
                    if (vm.fontList[i].uuid == font.textFontUuid) {
                        for (var j = 0; j < vm.fontList[i].fontStyles.length; j++) {
                            _fontStyle.push(vm.fontList[i].fontStyles[j].style)
                        }
                    }
                }
                font.fontStyle = _fontStyle;
                font.textBold1 = false;
                font.textItalic1 = false;
                if(!initialize){
                    if (_fontStyle.indexOf('NORMAL') != '-1') {
                        font.textBold = false;
                        font.textItalic = false;
                    } else {
                        if (_fontStyle.indexOf('BOLD_ITALIC') != '-1') {
                            font.textBold = true;
                            font.textItalic = true;
                        } else {
                            if (_fontStyle.indexOf('ITALIC') != '-1') {
                                font.textBold = false;
                                font.textItalic = true;
                            }
                            if (_fontStyle.indexOf('BOLD') != '-1') {
                                font.textBold = true;
                                font.textItalic = false;
                            }
                        }
                    }
                }
                if (_fontStyle.indexOf('BOLD_ITALIC') != '-1') {
                    font.textBold1 = true;
                    font.textItalic1 = true;
                } else {
                    if (_fontStyle.indexOf('ITALIC') != '-1') {
                        font.textItalic1 = true;
                    }
                    if (_fontStyle.indexOf('BOLD') != '-1') {
                        font.textBold1 = true;
                    }
                }
            }

            //斜体
            $scope.operationItalic = function (e,font) {
                e.preventDefault();
                $timeout(function () {
                    if(font.textItalic){
                        if(font.fontStyle.indexOf('NORMAL') > -1){
                            font.textItalic = false;
                            if (font.fontStyle.indexOf('BOLD') == '-1') {
                                font.textBold = false;
                            }
                        }else{
                            if(font.textBold){
                                font.textItalic = false;
                            }
                        }
                    }else{
                        if(font.fontStyle.indexOf('ITALIC') > -1){
                            font.textItalic = true;
                            if(font.textBold){
                                if(font.fontStyle.indexOf('BOLD_ITALIC') == -1){
                                    font.textBold = false;
                                }
                            }else{
                                // if( font.fontStyle.indexOf('BOLD_ITALIC') > -1){
                                //     font.textBold = true;
                                // }
                            }
                        }else if (font.fontStyle.indexOf('BOLD_ITALIC') > -1) {
                            font.textBold = true;
                            font.textItalic = true;
                        }
                    }
                    $scope.onItemChange()
                })
            }
            //粗体
            $scope.operationBold = function (e,font) {
                e.preventDefault();
                $timeout(function () {
                    if(font.textBold){
                        if(font.fontStyle.indexOf('NORMAL') > -1){
                            font.textBold = !font.textBold;
                            if (font.fontStyle.indexOf('ITALIC') == '-1') {
                                font.textItalic = font.textBold;
                            }
                        }else{
                            if(font.textItalic){
                                font.textBold = !font.textBold;
                            }
                        }
                    }else{
                        if(font.fontStyle.indexOf('BOLD') > -1){
                            font.textBold = true;
                            if(font.textItalic){
                                if(font.fontStyle.indexOf('BOLD_ITALIC') == -1){
                                    font.textItalic = false;
                                }
                            }else{
                                // if( font.fontStyle.indexOf('BOLD_ITALIC') > -1){
                                //     font.textItalic = true;
                                // }
                            }
                        }else if (font.fontStyle.indexOf('BOLD_ITALIC') > -1) {
                            font.textBold = true;
                            font.textItalic = true;
                        }
                    }
                    $scope.onItemChange();
                })
            }
            $scope.onItemChange = function() {
                $timeout(function () {
                    onSettingsChange();
                })
            }

            function onSettingsChange() {
                if (vm.onChange) {
                    vm.data.settings.items.forEach(function (item){
                        item.geometry={
                            width:item.w,
                            height:item.h,
                            x:item.x,
                            y:item.y,
                        }
                    })
                    vm.onChange({text: JSON.stringify(vm.data.settings)});
                }
            }

        }]
    };
    angular.module('platformApp')
        .component('styleSetting', styleSettingControl);

})();

(function () {
    'use strict';

    var monthTableControl = {
    	restrict: 'EAC',
        replace: true,
        transclude: true,
        templateUrl: 'app/entities/calendar/controls/month-table.html',
        controllerAs: 'vm',
        bindings: {
            widget: "=",
            year:'<',
            month:'<',
            week:'<',
            scale:'<',
            width:'<',
            height:'<',
            thumbnail:'<',
            update:'=',
            isMin:'<',
        },

        controller: ['$scope', '$timeout','CalendarService','$rootScope', function ($scope, $timeout,CalendarService,$rootScope) {
            var vm = this;
            vm.data = {
                cols: 7,
                rows: 5,
                clientWidth: 426,
                clientHeight: 396,
                headCellWidth: 60,
                headCellHeight: 30,
                headCellMargin: 0,
                dateCellWidth: 60,
                dateCellHeight: 60,
                dateCellMargin: 0,
                heads: [],
                dates: []
            };

            vm.$onInit = function() {
                if(vm.widget){
                    dataInfo()
                    vm.widget.ctrl.displayType = vm.widget.displayType || "C7";
                    vm.widget.ctrl.width = vm.widget.width || 426;
                    vm.widget.ctrl.height = vm.widget.height || 396;
                    vm.widget.ctrl.weekLayout = orMockWeekLayout(vm.widget.weekLayout);
                    vm.widget.ctrl.dateLayout = orMockDateLayout(vm.widget.dateLayout);
                    queryMonthdaysDataset(function () {
                        reconstructTable();
                    })
                }
            }
            // 每當 one-way binding 更新時，changesObj 就是改變前後的差異
            vm.$onChanges = function(data) {
                if(vm.widget){
                    if(!vm.widget.ctrl){
                        vm.widget.ctrl={}
                    }
                    if(data.year&&data.year.currentValue&&data.year.previousValue>0){vm.year = data.year.currentValue; vm.widget.obj=null;}
                    if(data.month&&data.month.currentValue&&data.month.previousValue>0){vm.month = data.month.currentValue; vm.widget.obj=null;}
                    if(data.week&&data.week.currentValue){vm.week = data.week.currentValue}
                    if(data.widget&&data.widget.currentValue){vm.widget = data.widget.currentValue}

                    if(data.width&&data.width.currentValue&&data.width.previousValue>0&&data.height&&data.height.currentValue&&data.height.previousValue>0){
                        vm.widget.ctrl.width = data.width.currentValue;
                        vm.widget.ctrl.height = data.height.currentValue;
                    }
                    queryMonthdaysDataset(function () {
                        reconstructTable();
                    })
                }
            }
            vm.$postLink = function () {

            }
            vm.$doCheck = function() {
                // deep watch
            }
            vm.$onDestroy = function () {

            }

            function dataInfo() {
                if(vm.widget.geometry){
                    vm.widget.width = vm.widget.geometry.width;
                    vm.widget.height = vm.widget.geometry.height;
                    if(vm.widget.weekLayout.geometry){
                        vm.widget.weekLayout.width = vm.widget.weekLayout.geometry.width;
                        vm.widget.weekLayout.height = vm.widget.weekLayout.geometry.height;
                    }
                    if(vm.widget.weekLayout.items&&vm.widget.weekLayout.items.item){
                        vm.widget.weekLayout.items = vm.widget.weekLayout.items.item;
                        vm.widget.weekLayout.items.forEach(function (weekLayout) {
                            weekLayout.w = weekLayout.geometry.width;
                            weekLayout.h = weekLayout.geometry.height;
                            weekLayout.x = weekLayout.geometry.x;
                            weekLayout.y = weekLayout.geometry.y;
                        })
                    }
                    if(vm.widget.dateLayout.geometry){
                        vm.widget.dateLayout.width = vm.widget.dateLayout.geometry.width;
                        vm.widget.dateLayout.height = vm.widget.dateLayout.geometry.height;
                    }
                    if(vm.widget.dateLayout.items&&vm.widget.dateLayout.items.item){
                        vm.widget.dateLayout.items = vm.widget.dateLayout.items.item;
                        vm.widget.dateLayout.items.forEach(function (dateLayout) {
                            dateLayout.w = dateLayout.geometry.width;
                            dateLayout.h = dateLayout.geometry.height;
                            dateLayout.x = dateLayout.geometry.x;
                            dateLayout.y = dateLayout.geometry.y;
                        })
                    }
                    if(vm.widget.weekStyles&&vm.widget.weekStyles.item){
                        vm.widget.weekStyles = vm.widget.weekStyles.item;
                    }
                    if(vm.widget.weekStyles){
                        vm.widget.weekStyles.forEach(function (weekStyle) {
                            if(weekStyle.items.item){
                                weekStyle.items = weekStyle.items.item;
                                weekStyle.items.forEach(function (item){
                                    if(item.geometry){
                                        item.w = item.geometry.width;
                                        item.h = item.geometry.height;
                                        item.x = item.geometry.x;
                                        item.y = item.geometry.y;
                                    }
                                })
                            }
                        })
                    }
                    if(vm.widget.dateStyles&&vm.widget.dateStyles.item){
                        vm.widget.dateStyles = vm.widget.dateStyles.item;
                    }
                    if(vm.widget.dateStyles){
                        vm.widget.dateStyles.forEach(function (dateStyle) {
                            if(dateStyle.items.item){
                                dateStyle.items = dateStyle.items.item;
                                dateStyle.items.forEach(function (item,index){
                                    if(item.geometry){
                                        item.w = item.geometry.width;
                                        item.h = item.geometry.height;
                                        item.x = item.geometry.x;
                                        item.y = item.geometry.y;
                                    }
                                })
                            }
                        })
                    }
                }
                if(!vm.widget.ctrl){
                    vm.widget.ctrl={}
                }
            }
            function onCellSizeChange(callback,isNew) {
                if(vm.widget.obj&&vm.widget.obj.heads&&vm.widget.obj.days){
                    var column = vm.widget.obj.heads.length || 7;
                    var row = Math.ceil(vm.widget.obj.days.length/column);
                    var wc = vm.widget.weekConfig;
                    var dc = vm.widget.dateConfig;
                    var headWidth = Number.parseInt(wc.cellWidth || 40) * column + Number.parseInt(wc.margin || 0) * (column-1);
                    var bodyWidth = Number.parseInt(dc.cellWidth || 40) * column + Number.parseInt(dc.margin || 0) * (column-1);
                    var bodyHeight = (Number(dc.cellHeight || 40)) * row + Number(dc.margin || 0) * (row-1);
                    var headHeight = (Number(wc.cellHeight || 20)) + Number(dc.headSpacing || 0);

                    var tableHeight = bodyHeight + headHeight;
                    var width = Math.max(headWidth, bodyWidth);

                    var old = angular.copy(vm.widget);

                    vm.widget.width = width;
                    vm.widget.height = tableHeight;
                    vm.widget.headWidth = headWidth;
                    vm.widget.bodyWidth = bodyWidth;
                    vm.widget.headHeight = headHeight;
                    vm.widget.bodyHeight = bodyHeight;
                    if(isNew && !vm.widget.geometry){
                        vm.widget.ctrl.width = vm.widget.width;
                        vm.widget.ctrl.height = vm.widget.height;
                    }
                    if(vm.update && vm.widget.geometry){
                        vm.widget.geometry.width = vm.widget.width / old.width * vm.widget.geometry.width;
                        vm.widget.geometry.height = vm.widget.height / old.height * vm.widget.geometry.height;
                        vm.update = false;
                    }else{
                        if(callback){callback()}
                    }
                }
            }
            vm.isSize = false;
            function queryMonthdaysDataset(callback) {
                if(vm.widget.ctrl.dateLayout && vm.widget.ctrl.weekLayout){
                    if(vm.widget.obj){
                        vm.isSize = false;
                        onCellSizeChange(function () {
                            if(callback){callback()}
                        })
                        return
                    }
                    vm.isSize = true;
                    vm.widget.obj = null;
                    var req = {
                        year: vm.year || 2023,
                        month: vm.month || 1,
                        startOfWeek: vm.week || 0,
                    };
                    var dateFormats = [];
                    var dateLayout = vm.widget.dateLayout || {};
                    if (dateLayout.items && dateLayout.items.length) {
                        for (var i = 0; i < dateLayout.items.length; i++) {
                            var item = dateLayout.items[i];
                            if (item.type == 'date') {
                                dateFormats.push({type: item.type, format: item.format});
                            }
                        }
                    }
                    var weekFormats = [];
                    var weekLayout = vm.widget.weekLayout || {};
                    if (weekLayout.items && weekLayout.items.length) {
                        for (var i = 0; i < weekLayout.items.length; i++) {
                            var item = weekLayout.items[i];
                            if (item.type == 'week') {
                                weekFormats.push({type: item.type, format: item.format});
                            }
                        }
                    }

                    req.dateFormats = dateFormats;
                    req.weekFormats = weekFormats;
                    CalendarService.queryMonthTable(req, function (res) {
                        var _heads = [];
                        for(var i=0; i<displayType(vm.widget.displayType)/7; i++){
                            res.data.heads.forEach(function (item) {
                                _heads.push(item)
                            })
                        }
                        res.data.heads = _heads;
                        vm.widget.obj = res.data || {};
                        onCellSizeChange(function () {
                            if(callback){callback()}
                        },true)
                    });
                }
            }
            var a = null;
            function reconstructTable() {
                if (!vm.widget.obj) {
                    return;
                }
                if (!vm.widget.obj.heads || !vm.widget.obj.heads.length) {
                    return;
                }
                if (!vm.widget.obj.days || !vm.widget.obj.days.length) {
                    return;
                }
                if (!vm.widget) {
                    return;
                }
                if (!vm.widget.weekConfig || !vm.widget.dateConfig) {
                    return;
                }
                var scaleW = vm.widget.ctrl.width / vm.widget.width;
                vm.data.clientWidth = vm.widget.ctrl.width;
                vm.data.clientHeight = vm.widget.ctrl.height;
                vm.data.headCellWidth = (vm.widget.weekConfig.cellWidth || 60) * scaleW;
                vm.data.headCellMargin = (vm.widget.weekConfig.margin || 0) * scaleW;
                vm.data.headCellHeight = (vm.widget.weekConfig.cellHeight || 30) * scaleW;
                vm.data.headSpacing = (vm.widget.dateConfig.headSpacing || 0) * scaleW;
                var bodyHeight = vm.widget.ctrl.height - vm.data.headCellHeight - vm.data.headSpacing;
                var scaleH = bodyHeight / vm.widget.bodyHeight;
                vm.data.dateCellWidth = (vm.widget.dateConfig.cellWidth || 60) * scaleW;
                vm.data.dateCellHeight = (vm.widget.dateConfig.cellHeight || 60) * scaleH;
                vm.data.dateCellMargin = (vm.widget.dateConfig.margin || 0) * scaleW;
                vm.data.dateCellMarginH = (vm.widget.dateConfig.margin || 0) * scaleH;
                var column = vm.widget.obj.heads.length || 7;
                vm.data.headWidth = Number(vm.data.headCellWidth) * column + vm.data.headCellMargin * (column-1);
                vm.data.bodyWidth = Number(vm.data.dateCellWidth) * column + vm.data.dateCellMargin * (column-1);

                var dayCount = vm.widget.obj.days.length;
                var cols = displayType(vm.widget.displayType);
                var rows = Math.ceil(dayCount / cols);

                vm.data.cols = cols;
                vm.data.rows = rows;
                vm.data.heads = [];
                vm.data.dates = [];

                var index = 0;
                for (var r = 0; r < rows; r++) {

                    var dateRow = [];
                    for (var c = 0; c < cols; c++) {

                        if (r == 0) {
                            var headObj = vm.widget.obj.heads[c];
                            var headSettings = findHeadSettings(c, headObj);
                            var head = {
                                width: vm.data.headCellWidth,
                                height: vm.data.headCellHeight,
                                margin: vm.data.headCellMargin,
                                obj: headObj,
                                settings: headSettings,
                                layout: vm.widget.ctrl.weekLayout
                            };
                            vm.data.heads.push(head);
                        }

                        // for dates
                        index = r * cols + c;
                        var dateObj = vm.widget.obj.days[index];
                        if(dateObj){
                            var dateSettings = findDateSettings(c, dateObj);
                            var date = {
                                width: vm.data.dateCellWidth,
                                height: vm.data.dateCellHeight,
                                margin: vm.data.dateCellMargin,
                                marginH: vm.data.dateCellMarginH,
                                obj: dateObj,
                                settings: dateSettings,
                                layout: vm.widget.ctrl.dateLayout
                            };
                            dateRow.push(date);
                        }else{
                            var date = {
                                width: vm.data.dateCellWidth,
                                height: vm.data.dateCellHeight,
                                margin: vm.data.dateCellMargin,
                                marginH: vm.data.dateCellMarginH,
                                obj: null,
                                settings: null,
                                layout: vm.widget.ctrl.dateLayout
                            };
                            dateRow.push(date);
                        }
                    }
                    vm.data.dates.push(dateRow);
                }

                vm.data.bodyHeight = vm.data.dateCellHeight * rows + vm.data.dateCellMarginH * (rows-1);
                vm.data.clientHeight = vm.data.bodyHeight + vm.data.headCellHeight + vm.data.headSpacing;
                if(vm.widget.geometry){
                    vm.widget.geometry.height = vm.data.clientHeight;
                }
                if(vm.thumbnail){
                    vm.data.styles = {
                        width: vm.data.clientWidth + 'px',
                        height: vm.data.clientHeight + 'px',
                        'transform' : 'scale('+(vm.scale || 1) + ')',
                        'transform-origin' : '0px 0px',
                    };
                }else{
                    vm.data.styles = {
                        width: vm.data.clientWidth + 'px',
                        height: vm.data.clientHeight + 'px',
                        zoom:vm.scale || 1,
                    };
                }
                if (vm.widget.backgroundColor) {
                    vm.data.styles['background-color'] = vm.widget.backgroundColor;
                }
                vm.loading = true;
                if (a !== null) {
                    clearTimeout(a)
                }
                a = setTimeout(function () {
                    vm.loading = false;
                    $scope.$apply();
                },500)
            }

            function findHeadSettings (indexOfWeek, headObj) {
                var styleUuid;

                if (vm.widget && vm.widget.weekConfig) {
                    var w = indexOfWeek;
                    if (vm.widget.startOfWeek == 1) {
                        // 每周从周一开始
                        w += 1;
                    }
                    else if (indexOfWeek == 0) {
                        // 周日
                        w = 7;
                    }
                    w = w - Math.trunc((w-1)/7)*7;
                    styleUuid = vm.widget.weekConfig["w" + w];
                }
                if (!styleUuid) {
                    styleUuid = "default";
                }
                var defaultStyle;
                if (vm.widget.weekStyles && vm.widget.weekStyles.length) {
                    for (var i = 0; i < vm.widget.weekStyles.length; i++) {
                        var style = vm.widget.weekStyles[i];
                        if (style.defaultStyle) {
                            defaultStyle = style;
                            if ("default" == styleUuid) {
                                return style;
                            }
                        }
                        if (style.uuid == styleUuid) {
                            return style;
                        }
                    }
                    if (!defaultStyle) {
                        defaultStyle = vm.widget.weekStyles[0];
                    }
                }
                if (defaultStyle) {
                    return defaultStyle;
                }
                return { debug: true};
            }

            function findDateSettings (indexOfWeek, dateObj) {
                var others = false;
                if (dateObj.year != vm.widget.obj.year || dateObj.month != vm.widget.obj.month) {
                    others = true;
                }
                var styleUuid;
                if (vm.widget && vm.widget.dateConfig) {
                    if (others) {
                        styleUuid = vm.widget.dateConfig.others;
                    } else {
                        var w = indexOfWeek;
                        if (vm.widget.startOfWeek == 1) {
                            // 每周从周一开始
                            w += 1;
                        }
                        else if (indexOfWeek == 0) {
                            // 周日
                            w = 7;
                        }
                        w = w - Math.trunc((w-1)/7)*7;
                        styleUuid = vm.widget.dateConfig["w" + w];
                    }
                }
                if (!styleUuid) {
                    styleUuid = "default";
                }
                if(dateObj.holiday && !others && dateObj.dayOfWeek!=7 && dateObj.dayOfWeek!=6){
                    styleUuid = vm.widget.dateConfig.holiday;
                }
                var defaultStyle;
                if (vm.widget.dateStyles && vm.widget.dateStyles.length) {
                    for (var i = 0; i < vm.widget.dateStyles.length; i++) {
                        var style = vm.widget.dateStyles[i];
                        if (style.defaultStyle) {
                            if ("default" == styleUuid) {
                                defaultStyle = angular.copy(style);
                                break
                            }
                        }
                        if (style.uuid == styleUuid) {
                            defaultStyle = angular.copy(style);
                            break
                        }
                    }
                    if (!defaultStyle) {
                        defaultStyle = angular.copy(vm.widget.dateStyles[0]);
                    }
                }
                if (defaultStyle) {
                    defaultStyle.showOthers = true;
                    if(others){
                        defaultStyle.showOthers = vm.widget.showOthers;
                    }
                    if(!others && (dateObj.dayOfWeek==7 || dateObj.dayOfWeek==6) && dateObj.holiday){
                        var lunarStyle=null;
                        for (var i = 0; i < vm.widget.dateStyles.length; i++) {
                            var style = vm.widget.dateStyles[i];
                            if (style.uuid == vm.widget.dateConfig.holiday) {
                                style.items.forEach(function(item){
                                    if(item.name == '农历日'){
                                        lunarStyle = angular.copy(item);
                                    }
                                })
                                break
                            }
                        }
                        if(lunarStyle){
                            defaultStyle.items.forEach(function(item,index){
                                if(item.name == '农历日'){
                                    defaultStyle.items[index] = angular.copy(lunarStyle);
                                }
                            })
                        }
                    }
                    return angular.copy(defaultStyle);
                }
                return { debug: true};
            }

            function orMockWeekLayout(layout) {
                if (layout) {
                    return layout;
                }
                else {
                    var l = {
                        type: "WEEK",
                        width: 100,
                        height: 50,
                        items: [{
                            type: "week",
                            format: "$cnWeek",
                            value: "星期日",
                            textSize: 18,
                            textFont: '',
                            textColor: '#000000',
                            textWeight: 500,
                            x: 5,
                            y: 10,
                            w: 90,
                            h: 30
                        }]
                    };
                    return l;
                }
            }
            function orMockDateLayout(layout) {
                if (layout) {
                    return layout;
                }
                else {
                    var l = {
                        type: "DATE",
                        width: 100,
                        height: 100,
                        items: [{
                            type: "date",
                            format: "$dd",
                            value: "01",
                            textSize: 18,
                            textFont: '',
                            textColor: '#ff0000',
                            textWeight: 500,
                            x: 5,
                            y: 15,
                            w: 90,
                            h: 40
                        }]
                    };
                    return l;
                }
            }

        }]
    };
    angular.module('platformApp')
        .component('monthTable', monthTableControl);

})();

(function() {
    'use strict';

    angular
        .module('platformApp')
        .controller('LayoutSelectController', LayoutSelectController);

    LayoutSelectController.$inject = ['$timeout', '$scope', 'MessageService', '$uibModalInstance', 'msg', 'CalendarLayout', 'Qinius', 'UidService', '$q'];

    function LayoutSelectController ($timeout, $scope, MessageService, $uibModalInstance, msg, CalendarLayout, Qinius, UidService, $q) {
        var vm = this;

        vm.type = msg.type || 'DATE';
        vm.layouts = [];
        vm.selectedId = null;
        vm.selectedLayout = null;

        vm.clear = clear;
        vm.save = save;
        vm.onLayoutSelect = onLayoutSelect;

        init();

        function init() {
        	CalendarLayout.getLayouts({type: vm.type, available: true}, function (res) {
                if (res.status == 200 && res.message && res.message.length) {
                    vm.layouts = res.message || [];
                }
            });
        }

        function onLayoutSelect(item) {
        	if (item) {
        		vm.selectedId = item.id;
        		vm.selectedLayout = item;
        	} else {
        		vm.selectedId = null;
        		vm.selectedLayout = null;
        	}
        }

        function clear() {
        	$uibModalInstance.dismiss();
        }

        function save() {
        	if (!vm.selectedLayout) {
        		MessageService.error("请选择一个布局");
        		return;
        	}
            MessageService.confirm({
                title:'温馨提示',
                cancel:'取消',
                confirm:'确认',
                msg:'切换单元格，布局样式将重置，是否确认切换?'
            },function(){
                $uibModalInstance.close(vm.selectedLayout);
            })
        }

    }
})();

(function () {
    'use strict';

    var FontFamilyControl = {
    	restrict: 'EAC',
        replace: true,
        transclude: true,
        templateUrl: 'app/entities/calendar/controls/font-family.html',
        controllerAs: 'vm',
        bindings: {
            family: "=",
            onChange:'&',
            isCalendar:"<",//是否是日历
        },

        controller: ['$scope', 'FontManagement', '$q', 'Qinius','MessageService', function ($scope, FontManagement, $q, Qinius,MessageService) {
            var vm = this;
            $scope.domains = Qinius.getDomain();
            $q.all([$scope.domains.$promise]).then(function () {
                vm.url = $scope.domains.domain;
            })
            //获取字体
            vm.fontList = [];
            vm.fontList1 = [];
            FontManagement.getAll3({}, function (resp) {
                if(vm.isCalendar){
                    resp.forEach(function (item) {
                        if(item.calendarSupport){
                            vm.fontList.push(item);
                        }
                    })
                }else{
                    vm.fontList = angular.copy(resp);
                }
                vm.fontList1 = angular.copy(vm.fontList);
            })
            $scope.selectFontName = function (item) {
                if (item) {
                    for (var i = 0; i < vm.fontList1.length; i++) {
                        if (vm.fontList1[i].uuid == item) {
                            return vm.fontList1[i].family
                        }
                    }
                }
            }
            vm.selectFont = '';
            vm.selectFontBtn = fontInit;
            var a = null;
            function fontInit() {
                if (a !== null) {
                    clearTimeout(a)
                }
                a = setTimeout(function () {
                    vm.fontList = [];
                    var item = [];
                    if (vm.selectFont) {
                        item.push({key: "family", op: "like", value: vm.selectFont});
                    }
                    if(vm.isCalendar){
                        item.push({
                            key:'calendarSupport',
                            op:'=',
                            value:true
                        })
                    }
                    FontManagement.getAll3({family:vm.selectFont}, function (resp) {
                        if(vm.isCalendar){
                            resp.forEach(function (item) {
                                if(item.calendarSupport){
                                    vm.fontList.push(item);
                                }
                            })
                        }else{
                            vm.fontList = angular.copy(resp);
                        }
                    })
                },800)
            }

            $scope.updateTextFont = function (data) {
                fontManagement(data,function () {
                    vm.family = data.uuid;
                    vm.onChange({text: vm.family});
                    getFont({
                        fontuuid: vm.family
                    },FontManagement);
                })
            }
            function fontManagement(data,callback) {
                var text="〇一二三四五六七八九十零壹贰叁肆伍陆柒捌玖拾年月日子丑寅卯辰巳午未申酉戌亥甲乙丙丁戊己庚辛壬贵鼠牛虎兔龙蛇马羊猴鸡狗猪abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ廿 公农历周星期";
                //普通
                var normalFlag = data.fontStyles.find(function (item) {
                    return item.style === 'NORMAL';
                });
                //粗体
                var boldFlag = data.fontStyles.find(function (item) {
                    return item.style === 'BOLD';
                });
                //斜体
                var italtcFlag = data.fontStyles.find(function (item) {
                    return item.style === 'ITALIC';
                });
                //粗斜体
                var boldItaltcFlag = data.fontStyles.find(function (item) {
                    return item.style === 'BOLD_ITALIC';
                });
                var bold = false;
                var italic = false;
                if(!normalFlag && boldFlag){
                    bold = true;
                }
                if(!normalFlag && italtcFlag){
                    italic = true;
                }
                if(!normalFlag && boldItaltcFlag){
                    bold = true;
                    italic = true;
                }
                FontManagement.fontSupport({
                    uuid: data.uuid,
                    bold: bold,
                    italic: italic,
                    content: text
                }, function (res) {
                    var msg = res.message;
                    if (res.status == 200&&msg.success&&msg.supported) {
                        callback()
                    } else {
                        MessageService.error("当前字体不可用");
                    }
                },function () {
                    MessageService.error("当前字体不可用");
                })
            }

        }]
    };
    angular.module('platformApp')
        .component('fontFamily', FontFamilyControl);

})();

(function () {
    'use strict';

    var dateCellControl = {
    	restrict: 'EAC',
        replace: true,
        transclude: true,
        templateUrl: 'app/entities/calendar/controls/date-cell.control.html',
        controllerAs: 'vm',
        bindings: {
            obj: "<",
            layout: "<",
            settings: "<",
            width: "<",
            height: "<",
            isSet: "<",
            isMin: "<",
            trIndex: "<",
            tdIndex: "<",
            dateConfig: "<",
        },

        controller: ['$scope','FontManagement', function ($scope, FontManagement) {
            var vm = this;
            vm.data = {
                width: 100,
                height: 100,
                items: []
            };

            vm.$onInit = function() {
                var settings = vm.settings || {};
                constructCell(vm.layout, settings, vm.obj);

            }
            // 每當 one-way binding 更新時，changesObj 就是改變前後的差異
            vm.$onChanges = function(data) {
                if (data.settings && data.settings.currentValue) {
                    constructCell(vm.layout, vm.settings, vm.obj);
                }
                else if (data.obj && data.obj.currentValue) {
                    constructCell(vm.layout, vm.settings, vm.obj);
                }

            }
            vm.$postLink = function () {

            }
            vm.$doCheck = function() {
                // deep watch
            }
            vm.$onDestroy = function () {

            }

            function textStyleObj(obj) {
                var styles = {
                    'position': 'absolute',
                    'left': obj.x + 'px',
                    'top': obj.y + 'px',
                    'line-height': (obj.textSize > 12 ? obj.h : obj.h / (1 / 12 * obj.textSize)) + 'px',
                    'fontSize': (obj.textSize > 12 ? obj.textSize : 12) + 'px',
                    'font-family': obj.textFontUuid,
                    'color': obj.textColor,
                    'text-align': obj.textAlign || 'center',
                    'transform':'scale('+(1 / 12 * obj.textSize > 1 ? 1 : 1 / 12 * obj.textSize)+')',
                    'transform-origin': '0 0',
                    'width': obj.textSize > 12 ? obj.w : obj.w / (1 / 12 * obj.textSize) + 'px',
                    'height': obj.textSize > 12 ? obj.h : obj.h / (1 / 12 * obj.textSize) + 'px',
                };
                if (obj.textFontUuid) {
                    styles['font-family'] = obj.textFontUuid;
                }
                if (obj.textWeight) {
                    styles['font-weight'] = obj.textWeight;
                }
                if (obj.textStyle) {
                    styles['font-style'] = obj.textStyle;
                }
                if (obj.backgroundColor) {
                    styles['background-color'] = obj.backgroundColor;
                }
                if (obj.debug) {
                    styles['border'] = '1px dotted #ccc';
                }
                return styles;
            }
            function imageStyleObj(obj) {
                var styles = {
                    'position': 'absolute',
                    'left': obj.x + 'px',
                    'top': obj.y + 'px',
                    'width': obj.w + 'px',
                    'height': obj.h + 'px'
                };
                if (obj.debug) {
                    styles['border'] = '1px dotted #ccc';
                }

                return styles;
            }

            function findItemFromSettings(settings, itemName) {
                if (!settings || !settings.items || !settings.items.length || !itemName) {
                    return {};
                }
                for (var i = 0; i < settings.items.length; i++) {
                    var item = settings.items[i];
                    if (item.name == itemName) {
                        return item;
                    }
                }

                return {};
            }

            function findDataFromObj(obj, type, format) {
                if (!obj || !obj.items || !obj.items.length) {
                    return {};
                }
                for (var i = 0; i < obj.items.length; i++) {
                    var item = obj.items[i];
                    if (item.type == type && item.format == format) {
                        return item;
                    }
                }
                return {};
            }

            function constructCell(layout, settings, myObj) {
                var cw = layout.width || 100;
                var ch = layout.height || 50;
                var width = vm.width || 100;
                var height = vm.height || 100;
                vm.data = {
                    width: width,
                    height: height,
                    styles: {
                        width: width + 'px',
                        height: height + 'px'
                    },
                    showOthers:settings.showOthers,
                    items: []
                };
                if (settings.backgroundColor) {
                    vm.data.styles['background-color'] = settings.backgroundColor;
                }
                var lineW = 0;
                if (settings.border && settings.border.lineType) {
                    var border = settings.border;
                    if (settings.border && settings.border.lineType && settings.border.lineWidth && border.color) {
                        vm.data.styles['border'] = (border.lineWidth) + 'px ' + border.lineType + " "  + border.color;
                        lineW = (border.lineWidth)*2;
                        if(vm.dateConfig && vm.dateConfig.removeBorderOverlap){
                            if(vm.trIndex > 0){
                                vm.data.styles['border-top'] = 0 + 'px ' + border.lineType + " "  + border.color;
                            }
                            if(vm.tdIndex > 0){
                                lineW = border.lineWidth;
                                vm.data.styles['border-left'] = 0 + 'px ' + border.lineType + " "  + border.color;
                            }
                        }
                    }
                    if (border.tlRadius) {
                        vm.data.styles['border-top-left-radius'] = border.tlRadius * Math.min(width / cw, height / ch) + 'px';
                    }
                    if (border.trRadius) {
                        vm.data.styles['border-top-right-radius'] = border.trRadius * Math.min(width / cw, height / ch) + 'px';
                    }
                    if (border.blRadius) {
                        vm.data.styles['border-bottom-left-radius'] = border.blRadius * Math.min(width / cw, height / ch) + 'px';
                    }
                    if (border.brRadius) {
                        vm.data.styles['border-bottom-right-radius'] = border.brRadius * Math.min(width / cw, height / ch) + 'px';
                    }
                }
                if (settings && settings.items && settings.items.length) {
                    width = width - lineW;
                    height = height - lineW;
                    for (var i = 0; i < settings.items.length; i++) {
                        var ci = settings.items[i];
                        var ci1 = layout.items[i];
                        if (ci.type == "image" || ci.type == 'userimage') {
                            var element = {
                                x: ci.x * width / cw,
                                y: ci.y * height / ch,
                                w: ci.w * width / cw,
                                h: ci.h * height / ch
                            };
                            if (settings.debug) {
                                element.debug = true;
                            }
                            var img = {
                                type: ci.type,
                                url: ci.url,
                                styles: imageStyleObj(element)
                            };

                            vm.data.items.push(img);
                        }
                        else if (ci.type) {
                            var element = {
                                x: ci.x * width / cw,
                                y: ci.y * height / ch,
                                w: ci.w * width / cw,
                                h: ci.h * height / ch,
                                textSize: Number.parseInt(ci.textSize) * width / cw,
                                textFont: ci.textFont,
                                textColor: ci.textColor,
                                textAlign: ci.textAlign,
                                textWeight: ci.textWeight,
                                textFontUuid: ci.textFontUuid
                            };
                            var item = findItemFromSettings(settings, ci.name) || {};
                            if (item.textSize) {
                                element.textSize = Number.parseInt(item.textSize) * width / cw;
                            }
                            if (item.textFontUuid) {
                                element.textFontUuid = item.textFontUuid;
                                getFont({
                                    fontuuid: element.textFontUuid
                                },FontManagement);
                            }
                            if (item.textFont) {
                                element.textFont = item.textFont;
                            }
                            if (item.textColor) {
                                element.textColor = item.textColor;
                            }
                            if (item.textAlign) {
                                element.textAlign = item.textAlign;
                            }
                            if (item.textBold) {
                                element.textWeight = "600";
                            }
                            if (item.textItalic) {
                                element.textStyle = "italic";
                            }
                            if (item.backgroundColor) {
                                element.backgroundColor = item.backgroundColor;
                            }

                            if (settings.debug) {
                                element.debug = true;
                            }

                            var data = findDataFromObj(myObj || vm.obj, ci.type, ci1.format) || {};
                            if (!data.type && ci.type == 'event' && !vm.isSet) {
                                data = {
                                    value: ' '
                                };
                            }

                            var text = {
                                type: ci.type,
                                format: ci1.format,
                                value: data.value || ci.value || ci.sample || '01',
                                styles: textStyleObj(element)
                            };
                            vm.data.items.push(text);
                        }

                    }
                } else {
                    var t = {
                        type: "date",
                        format: "$dd",
                        value: "01",
                        textSize: 18 * width / 100,
                        textFont: '',
                        textFontUuid: '',
                        textColor: '#ff0000',
                        textWeight: 600,
                        x: 5 * width / 100,
                        y: 15 * height / 100,
                        w: 90 * width / 100,
                        h: 40  * height / 100,
                        fixedTo: ''
                    };
                    vm.data.items.push({
                        type: t.type,
                        format: t.format,
                        value: t.value || t.sample,
                        styles: textStyleObj(t)
                    });
                }
            } // end of constructCell

        }]
    };
    angular.module('platformApp')
        .component('dateCell', dateCellControl);

})();

(function () {
    'use strict';

    var colorPickControl = {
    	restrict: 'EAC',
        replace: true,
        transclude: true,
        templateUrl: 'app/entities/calendar/controls/color-pick.control.html',
        controllerAs: 'vm',
        bindings: {
            color: '=',
            colors:"<",
            transparent: '<',
            onUpdate:'&'
        },

        controller: ['$scope', '$timeout', function ($scope, $timeout) {
            var vm = this;
            vm.colorOptions = [
                {value: "#FFFFFF"},
                {value: "#FFECBF"},
                {value: "#F5D351"},
                {value: "#F58B48"},
                {value: "#F55B1D"},
                {value: "#9ED969"},

                {value: "#819E22"},

                {value: "#6BCBA4"},
                {value: "#2C7FD3"},
                {value: "#272792"},
                {value: "#F2A5E1"},
                {value: "#AF6DF3"},
            ];
            vm.data = {
                color: null
            };

            vm.$onInit = function() {
                vm.data.color = vm.color;
                vm.data.transparent = !!vm.transparent;

            }
            // 每當 one-way binding 更新時，changesObj 就是改變前後的差異
            vm.$onChanges = function(data) {

            }
            vm.$postLink = function () {

            }
            vm.$doCheck = function() {
                // deep watch
            }
            vm.$onDestroy = function () {

            }

            $scope.onClick = function (color) {
                vm.data.color = color.value;
                vm.color = vm.data.color;
                $timeout(function() {
                    if (vm.onUpdate) {
                        vm.onUpdate({text: vm.data.color});
                    }
                }, 100);
            }
            $scope.onClean = function () {
                vm.data.color = null;
                vm.color = null;
                $timeout(function() {
                    if (vm.onUpdate) {
                        vm.onUpdate({text: null});
                    }
                }, 100);
            }
            var a = null;
            $scope.onInputChange = function() {
                if (a !== null) {
                    clearTimeout(a)
                }
                a = setTimeout(function () {
                    vm.color = vm.data.color;
                    $timeout(function() {
                        if (vm.onUpdate) {
                            vm.onUpdate({text: vm.data.color});
                        }
                    }, 100);
                    $scope.$apply();
                },500)
            }

        }]
    };
    angular.module('platformApp')
        .component('colorPick', colorPickControl);

})();

(function() {
    'use strict';

    angular
        .module('platformApp')
        .controller('CellSettingsModalController', CellSettingsModalController);

    CellSettingsModalController.$inject = ['$timeout', '$scope', 'MessageService', '$uibModalInstance', 'msg','FontManagement'];

    function CellSettingsModalController ($timeout, $scope, MessageService, $uibModalInstance, msg,FontManagement) {
        var vm = this;
        vm.data = {
            obj: msg.obj || {type: '', value: null},
            layout: msg.layout,
            config: msg.config,
            settings: buildSettings(msg.settings || {}, msg.layout),
            name: msg.name,
            colors:msg.colors
        };
        vm.clear = clear;
        vm.save = save;

        vm.fontList = [];
        vm.isFontList = false;
        FontManagement.getAll({items: [{key:'calendarSupport',op:'=',value:true}], sort: ["id,asc"]}, function (res) {
            for (var i = 0; i < res.length; i++) {
                if(res[i].calendarSupport){
                    vm.fontList.push(res[i]);
                }

            }
            FontManagement.getAll2({items: [{key:'calendarSupport',op:'=',value:true}], sort: ["id,asc"]}, function (resp) {
                for (var i = 0; i < resp.length; i++) {
                    if(resp[i].calendarSupport){
                        vm.fontList.push(resp[i]);
                    }

                }
                vm.isFontList = true;
            })
        });
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            $uibModalInstance.close(vm.data);
        }

        function buildSettings(intial, layout) {
            var settings = angular.copy(intial);
            if (!settings.items) {
                settings.items = [];
            }

            if (layout || layout.items && layout.items.length) {
                for (var i = 0; i < layout.items.length; i++) {
                    var ti = layout.items[i];
                    if (!ti.name) {
                        continue;
                    }

                    var found = null;
                    for (var j = 0; j < settings.items.length; j++) {
                        var sj = settings.items[j];
                        if (ti.name == sj.name) {
                            found = sj;
                            break;
                        }
                    }

                    if (!found) {
                        var item = {
                            name: ti.name,
                            type: ti.type,
                            textSize: ti.textSize,
                            textFont: ti.textFont,
                            textColor: ti.textColor,
                            textAlign: ti.textAlign || 'center',
                            textBold: ti.textWeight && (ti.textWeight >= 500 || ti.textWeight == 'bold'),
                            textItalic: undefined
                        };
                        settings.items.push(item);
                    }
                }
            }
            if (!settings.border) {
                settings.border = {
                    lineType: 'solid',
                    lineWidth: 0,
                    color: '#000000',
                    tlRadius: 0,
                    trRadius: 0,
                    blRadius: 0,
                    brRadius: 0
                };
            }
            settings.showOthers = true;
            return settings;
        }

        $scope.onSettingsChange = function (text) {
            var data = JSON.parse(text);
            if (data) {
                vm.data.settings = data;
                $timeout(function() {
                    $scope.$apply();
                }, 100);

            }
        }

    }
})();


(function () {
    'use strict';

    var calendarSetControl = {
    	restrict: 'EAC',
        replace: true,
        transclude: true,
        templateUrl: 'app/entities/calendar/controls/calendar-set.control.html',
        controllerAs: 'vm',
        bindings: {
            data: '=',
            pageValue: '=',
            unit: '=',
            units: '<',
            onChange:'&',
            onUnit:'&',
            onUpdatePageValue:'&'
        },

        controller: ['$scope', '$timeout', '$uibModal','UidService','MessageService','FontManagement', function ($scope, $timeout, $uibModal,UidService,MessageService,FontManagement) {
            var vm = this;
            vm.weekStyleKeys = [
                {id:'w1',value:'星期一'},
                {id:'w2',value:'星期二'},
                {id:'w3',value:'星期三'},
                {id:'w4',value:'星期四'},
                {id:'w5',value:'星期五'},
                {id:'w6',value:'星期六'},
                {id:'w7',value:'星期日'},
            ];
            vm.weekStyleKey = "w1";
            vm.dateConfigKeys = [
                {id:'w1',value:'星期一'},
                {id:'w2',value:'星期二'},
                {id:'w3',value:'星期三'},
                {id:'w4',value:'星期四'},
                {id:'w5',value:'星期五'},
                {id:'w6',value:'星期六'},
                {id:'w7',value:'星期日'},
                {id:'others',value:'其它月'},
                {id:'holiday',value:'节假日'},
            ];
            vm.sampleYears = [
                {id:'2020',value:'2020'},
                {id:'2021',value:'2021'},
                {id:'2022',value:'2022'},
                {id:'2023',value:'2023'},
                {id:'2024',value:'2024'},
                {id:'2025',value:'2025'},
                {id:'2026',value:'2026'},
                {id:'2027',value:'2027'},
                {id:'2028',value:'2028'},
                {id:'2029',value:'2029'},
                {id:'2030',value:'2030'},
            ];
            vm.sampleMonths = [
                {id:'1',value:'1'},
                {id:'2',value:'2'},
                {id:'3',value:'3'},
                {id:'4',value:'4'},
                {id:'5',value:'5'},
                {id:'6',value:'6'},
                {id:'7',value:'7'},
                {id:'8',value:'8'},
                {id:'9',value:'9'},
                {id:'10',value:'10'},
                {id:'11',value:'11'},
                {id:'12',value:'12'},
            ];
            vm.displayTypes = [
                { name: '一行7列', id: 'C7'},
                { name: '一行14列', id: 'C14'},
                { name: '一行21列', id: 'C21'},
            ];
            vm.dateConfigKey = "w1";
            FontManagement.getAll2({items: [{key: "defaultShow", op: "=", value: true},{key: "enable", op: "=", value: true},{key: "cancelled", op: "=", value: false}], sort: ["id,asc"]}, function (res) {
                if(res && res.length>0){
                    vm.defaultFontUuid = res[0].uuid;
                }
            });
            vm.$onInit = function(data) {
                updateWeekStyleOptions();
                updateDateStyleOptions();
                colorInit()
            }
            vm.$onChanges = function(data) {
                if(data.data&&data.data.currentValue){
                    vm.data = data.data.currentValue;
                }
                if(data.unit&&data.unit.currentValue){
                    vm.unit = data.unit.currentValue;
                }
                if(data.pageValue&&data.pageValue.currentValue){
                    vm.pageValue = data.pageValue.currentValue;
                }
            }
            function colorInit() {
                vm.colors={
                    backgroundColors:[],
                    borderColors:[],
                    fontColors:[],
                    fontBackgroundColors:[]
                }
                if(vm.data.backgroundColor){
                    vm.colors.backgroundColors.push(vm.data.backgroundColor)
                }
                if(vm.data.dateStyles instanceof Array){
                    vm.data.dateStyles.forEach(function (item) {
                        if(item.backgroundColor){
                            vm.colors.backgroundColors.push(item.backgroundColor)
                        }
                        if(item.border&&item.border.color){
                            vm.colors.borderColors.push(item.border.color)
                        }
                        if(item.items&&item.items.length>0){
                            item.items.forEach(function (item1) {
                                if(item1.backgroundColor){
                                    vm.colors.fontBackgroundColors.push(item1.backgroundColor)
                                }
                                if(item1.textColor){
                                    vm.colors.fontColors.push(item1.textColor)
                                }
                            })
                        }
                    })
                }
            }

            function updateWeekStyleOptions() {
                vm.weekStyleOptions = [];
                $timeout(function () {
                    var options = [];
                    for (var i = 0; i < vm.data.weekStyles.length; i++) {
                        var style = vm.data.weekStyles[i];
                        options.push({name: style.name, uuid: style.uuid});
                    }
                    vm.weekStyleOptions = options;
                })
            }

            function updateDateStyleOptions() {
                vm.dateStyleOptions = [];
                $timeout(function () {
                    var options = [];
                    for (var i = 0; i < vm.data.dateStyles.length; i++) {
                        var style = vm.data.dateStyles[i];
                        options.push({name: style.name, uuid: style.uuid});
                    }
                    vm.dateStyleOptions = options;
                })
            }
            //属性栏
            vm.tag = 1;
            $scope.tagClick = function(item){
                vm.tag = item;
            }
            $scope.showOthersCb = function(item){
                vm.data.showOthers = item;
                $scope.widgetUpdate();
            }
            //周设置
            $scope.selectWeekLayout = function() {
                $uibModal.open({
                    templateUrl: 'app/entities/calendar/controls/layout-select.html',
                    controller: 'LayoutSelectController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                        msg: function() {
                            return {
                                type: 'WEEK'
                            };
                        }
                    }
                }).result.then(function(res) {
                    if (res.id != vm.data.weekLayoutId) {
                        vm.data.weekLayout = res;
                        vm.data.weekLayoutId = res.id;
                        vm.data.obj=null;
                        resetWeekStyles();
                    }
                });
            }
            function resetWeekStyles() {
                for (var k = 0; k < vm.data.weekStyles.length; k++) {
                    var style = vm.data.weekStyles[k];

                    style.items = [];
                    if (vm.data.weekLayout && vm.data.weekLayout.items) {
                        for (var i = 0; i < vm.data.weekLayout.items.length; i++) {
                            var item = vm.data.weekLayout.items[i];


                            style.items.push({
                                name: item.name,
                                type: item.type,
                                format: item.format,
                                sample: item.sample,
                                textFontUuid: vm.defaultFontUuid,
                                textFamily: "",
                                textSize: item.textSize,
                                textColor: item.textColor,
                                textAlign: item.textAlign,
                                url: item.url,
                                w:item.w,
                                h:item.h,
                                x:item.x,
                                y:item.y,
                                geometry:{
                                    width:item.w,
                                    height:item.h,
                                    x:item.x,
                                    y:item.y,
                                },
                            });
                        }
                    }
                }
                $scope.widgetUpdate();
            }
            vm.addWeekStyle = function () {
                var style = {
                    name: "样式" + randomString(),
                    uuid: UidService.get(),
                    backgroundColor: null,
                    border: {
                        lineType: null,
                        lineWidth: 0,
                        color: "#000000",
                        blRadius: 0,
                        brRadius: 0,
                        tlRadius: 0,
                        trRadius: 0
                    },
                    items:[]
                };
                if(vm.data.geometry){
                    if (vm.data.weekStyles[0] && vm.data.weekStyles[0].items) {
                        for (var i = 0; i < vm.data.weekStyles[0].items.length; i++) {
                            var item = vm.data.weekStyles[0].items[i];
                            style.items.push({
                                backgroundColor:null,
                                name: item.name,
                                type: item.type,
                                format: item.format,
                                sample: item.sample,
                                textFontUuid: vm.defaultFontUuid,
                                textFamily: "",
                                textSize: item.textSize,
                                textColor: item.textColor || "#000000",
                                textAlign: item.textAlign,
                                url: item.url,
                                w:item.w,
                                h:item.h,
                                x:item.x,
                                y:item.y,
                                geometry:{
                                    width:item.w,
                                    height:item.h,
                                    x:item.x,
                                    y:item.y,
                                },
                            });
                        }
                    }
                }else{
                    if (vm.data.weekLayout && vm.data.weekLayout.items) {
                        for (var i = 0; i < vm.data.weekLayout.items.length; i++) {
                            var item = vm.data.weekLayout.items[i];

                            style.items.push({
                                backgroundColor:null,
                                name: item.name,
                                type: item.type,
                                format: item.format,
                                sample: item.sample,
                                textFontUuid: vm.defaultFontUuid,
                                textFamily: "",
                                textSize: item.textSize,
                                textColor: item.textColor || "#000000",
                                textAlign: item.textAlign,
                                url: item.url,
                                geometry:{
                                    width:item.w,
                                    height:item.h,
                                    x:item.x,
                                    y:item.y,
                                },
                                w:item.w,
                                h:item.h,
                                x:item.x,
                                y:item.y,
                            });
                        }
                    }
                }
                vm.data.weekStyles.push(style);
                updateWeekStyleOptions();
            }
            vm.editWeekStyle = function (style, $index) {
                var layout = vm.data.weekLayout;
                var myStyle = vm.data.weekStyles[$index];
                var data = {
                    obj: null,
                    settings: myStyle,
                    layout: layout,
                    config: vm.data.weekConfig,
                    name:style.name,
                    colors:vm.getPageColors()
                };
                $uibModal.open({
                    templateUrl: 'app/entities/calendar/controls/cell-settings-modal.html',
                    controller: 'CellSettingsModalController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        msg: function() {
                            return data;
                        }
                    }
                }).result.then(function(res) {
                    style.name = res.name;
                    if (res.settings) {
                        vm.data.weekStyles[$index].debug = res.settings.debug;
                        vm.data.weekStyles[$index].backgroundColor = res.settings.backgroundColor;
                        if (res.settings.border) {
                            vm.data.weekStyles[$index].border = res.settings.border;
                        }
                        if (res.settings.items) {
                            vm.data.weekStyles[$index].items = res.settings.items || style.items;
                        }
                        updateWeekStyleOptions();
                        $scope.widgetUpdate();
                    }
                });
            }
            vm.removeWeekStyle = function ($index) {
                MessageService.confirm({
                    title:'提示',
                    cancel:'取消',
                    confirm:'确认',
                    msg:'确认删除？'
                },function(){
                    var wc = vm.data.weekConfig;
                    var s = vm.data.weekStyles[$index];
                    if (!wc.w1 || wc.w1 == s.uuid) {
                        wc.w1 = 'default';
                    }
                    if (!wc.w2 || wc.w2 == s.uuid) {
                        wc.w2 = 'default';
                    }
                    if (!wc.w3 || wc.w3 == s.uuid) {
                        wc.w3 = 'default';
                    }
                    if (!wc.w4 || wc.w4 == s.uuid) {
                        wc.w4 = 'default';
                    }
                    if (!wc.w5 || wc.w5 == s.uuid) {
                        wc.w5 = 'default';
                    }
                    if (!wc.w6 || wc.w6 == s.uuid) {
                        wc.w6 = 'default';
                    }
                    if (!wc.w7 || wc.w7 == s.uuid) {
                        wc.w7 = 'default';
                    }
                    vm.data.weekStyles.splice($index, 1);
                    updateWeekStyleOptions();
                    $scope.widgetUpdate();
                })
            }
            //复制周样式
            vm.copyWeekStyle = function (index) {
                var style = angular.copy(vm.data.weekStyles[index]);
                style.id = null;
                style.uuid = UidService.get();
                style.name = style.name + "_副本";
                vm.data.weekStyles.push(style);
                updateWeekStyleOptions();

            }
            //日设置
            $scope.selectDateLayout = function() {
                $uibModal.open({
                    templateUrl: 'app/entities/calendar/controls/layout-select.html',
                    controller: 'LayoutSelectController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                        msg: function() {
                            return {
                                type: 'DATE'
                            };
                        }
                    }
                }).result.then(function(res) {
                    if (res.id != vm.data.dateLayoutId) {
                        vm.data.obj=null;
                        vm.data.dateLayout = res;
                        vm.data.dateLayoutId = res.id;
                        resetDateStyles();
                    }
                });
            }
            function resetDateStyles() {
                for (var k = 0; k < vm.data.dateStyles.length; k++) {
                    var style = vm.data.dateStyles[k];

                    style.items = [];
                    if (vm.data.dateLayout && vm.data.dateLayout.items) {
                        for (var i = 0; i < vm.data.dateLayout.items.length; i++) {
                            var item = vm.data.dateLayout.items[i];
                            style.items.push({
                                name: item.name,
                                type: item.type,
                                format: item.format,
                                sample: item.sample,
                                textFontUuid: vm.defaultFontUuid,
                                textFamily: "",
                                textSize: item.textSize,
                                textColor: item.textColor,
                                textAlign: item.textAlign,
                                url: item.url,
                                w:item.w,
                                h:item.h,
                                x:item.x,
                                y:item.y,
                                geometry:{
                                    width:item.w,
                                    height:item.h,
                                    x:item.x,
                                    y:item.y,
                                },
                            });
                        }
                    }
                }
                $scope.widgetUpdate();
            }
            vm.addDateStyle = function () {
                var style = {
                    name: "样式" + randomString(),
                    uuid: UidService.get(),
                    backgroundColor: null,
                    border: {
                        lineType: null,
                        lineWidth: 0,
                        color: "#000000",
                        blRadius: 0,
                        brRadius: 0,
                        tlRadius: 0,
                        trRadius: 0
                    },
                    items:[]
                };

                if(vm.data.geometry){
                    if (vm.data.dateStyles[0] && vm.data.dateStyles[0].items) {
                        for (var i = 0; i < vm.data.dateStyles[0].items.length; i++) {
                            var item = vm.data.dateStyles[0].items[i];
                            style.items.push({
                                backgroundColor: null,
                                name: item.name,
                                type: item.type,
                                format: item.format,
                                sample: item.sample,
                                textFontUuid: vm.defaultFontUuid,
                                textFamily: "",
                                textSize: item.textSize || 14,
                                textColor: item.textColor || "#000000",
                                textAlign: item.textAlign || "center",
                                url: item.url,
                                w:item.w,
                                h:item.h,
                                x:item.x,
                                y:item.y,
                                geometry:{
                                    width:item.w,
                                    height:item.h,
                                    x:item.x,
                                    y:item.y,
                                },
                            });
                        }
                    }
                }else{
                    if (vm.data.dateLayout && vm.data.dateLayout.items) {
                        for (var i = 0; i < vm.data.dateLayout.items.length; i++) {
                            var item = vm.data.dateLayout.items[i];
                            style.items.push({
                                backgroundColor: null,
                                name: item.name,
                                type: item.type,
                                format: item.format,
                                sample: item.sample,
                                textFontUuid: vm.defaultFontUuid,
                                textFamily: "",
                                textSize: item.textSize || 14,
                                textColor: item.textColor || "#000000",
                                textAlign: item.textAlign || "center",
                                url: item.url,
                                w:item.w,
                                h:item.h,
                                x:item.x,
                                y:item.y,
                                geometry:{
                                    width:item.w,
                                    height:item.h,
                                    x:item.x,
                                    y:item.y,
                                },
                            });
                        }
                    }
                }
                vm.data.dateStyles.push(style);
                updateDateStyleOptions();
            }
            vm.editDateStyle = function (style, $index) {
                var layout = vm.data.dateLayout;
                var myStyle = vm.data.dateStyles[$index];

                var data = {
                    obj: null,
                    settings: myStyle,
                    layout: layout,
                    config: vm.data.dateConfig,
                    name:style.name,
                    colors:vm.getPageColors()
                };
                $uibModal.open({
                    templateUrl: 'app/entities/calendar/controls/cell-settings-modal.html',
                    controller: 'CellSettingsModalController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        msg: function() {
                            return data;
                        }
                    }
                }).result.then(function(res) {
                    style.name = res.name;
                    if (res.settings) {
                        vm.data.dateStyles[$index].debug = res.settings.debug;
                        vm.data.dateStyles[$index].backgroundColor = res.settings.backgroundColor;
                        if (res.settings.border) {
                            vm.data.dateStyles[$index].border = res.settings.border;
                        }
                        if (res.settings.items) {
                            vm.data.dateStyles[$index].items = res.settings.items || style.items;
                        }
                        updateDateStyleOptions();
                        $scope.widgetUpdate();
                    }
                });
            }
            vm.removeDateStyle = function ($index) {
                MessageService.confirm({
                    title:'提示',
                    cancel:'取消',
                    confirm:'确认',
                    msg:'确认删除？'
                },function(){
                    var dc = vm.data.dateConfig;
                    var s = vm.data.dateStyles[$index];
                    if (!dc.w1 || dc.w1 == s.uuid) {
                        dc.w1 = 'default';
                    }
                    if (!dc.w2 || dc.w2 == s.uuid) {
                        dc.w2 = 'default';
                    }
                    if (!dc.w3 || dc.w3 == s.uuid) {
                        dc.w3 = 'default';
                    }
                    if (!dc.w4 || dc.w4 == s.uuid) {
                        dc.w4 = 'default';
                    }
                    if (!dc.w5 || dc.w5 == s.uuid) {
                        dc.w5 = 'default';
                    }
                    if (!dc.w6 || dc.w6 == s.uuid) {
                        dc.w6 = 'default';
                    }
                    if (!dc.w7 || dc.w7 == s.uuid) {
                        dc.w7 = 'default';
                    }
                    if (!dc.others || dc.others == s.uuid) {
                        dc.others = 'default';
                    }
                    if (!dc.holiday || dc.holiday == s.uuid) {
                        dc.holiday = 'default';
                    }
                    vm.data.dateStyles.splice($index, 1);
                    updateDateStyleOptions();
                    $scope.widgetUpdate();
                })
            }
            //复制日样式
            vm.copyDateStyle = function (index) {
                var style = angular.copy(vm.data.dateStyles[index]);
                style.id = null;
                style.uuid = UidService.get();
                style.name = style.name + "_副本";
                vm.data.dateStyles.push(style);
                updateDateStyleOptions();

            }
            function randomString() {
                return Math.random().toString(36).slice(-5);
            }
            $scope.onYearMonthChnage = function () {
                vm.data.obj=null;
                $scope.widgetUpdate();
            }
            $scope.dateConfigMargin = function (){
                vm.data.dateConfig.margin = parseInt(vm.data.dateConfig.margin);
                $scope.sizeUpdate();
            }
            $scope.dateConfigHeadSpacing = function (){
                vm.data.dateConfig.headSpacing = parseInt(vm.data.dateConfig.headSpacing);
                $scope.sizeUpdate();
            }
            $scope.weekConfigMargin = function (){
                vm.data.weekConfig.margin = parseInt(vm.data.weekConfig.margin);
                $scope.sizeUpdate();
            }
            $scope.sizeUpdate = function(){
                vm.data.update = true;
                $scope.widgetUpdate();
            }
            $scope.dateRemoveBorderOverlap = function (){
                vm.data.dateConfig.margin = 0;
                if(vm.data.dateStyles){
                    vm.data.dateStyles.forEach(function (item){
                        item.border.blRadius = 0;
                        item.border.brRadius = 0;
                        item.border.tlRadius = 0;
                        item.border.trRadius = 0;
                    })
                }
                $scope.widgetUpdate();
            }
            $scope.weekRemoveBorderOverlap = function (){
                vm.data.weekConfig.margin = 0;
                if(vm.data.weekStyles){
                    vm.data.weekStyles.forEach(function (item){
                        item.border.blRadius = 0;
                        item.border.brRadius = 0;
                        item.border.tlRadius = 0;
                        item.border.trRadius = 0;
                    })
                }
                $scope.widgetUpdate();
            }
            $scope.weekRemoveBorderBottom = function (){
                vm.data.dateConfig.headSpacing = 0;
                if(vm.data.weekStyles){
                    vm.data.weekStyles.forEach(function (item){
                        item.border.blRadius = 0;
                        item.border.brRadius = 0;
                        item.border.tlRadius = 0;
                        item.border.trRadius = 0;
                    })
                }
                $scope.widgetUpdate();
            }
            $scope.widgetUpdate = function() {
                verify(function () {
                    $timeout(function () {
                        colorInit()
                        vm.onChange({text: JSON.stringify(vm.data)});
                    })
                });
            }
            var a = null;
            function verify(callback){
                if (a !== null) {
                    clearTimeout(a)
                }
                a = setTimeout(function () {
                    $timeout(function () {
                        if(vm.data.weekConfig.cellWidth<10 || vm.data.weekConfig.cellWidth == undefined){
                            vm.data.weekConfig.cellWidth = 10;
                        }
                        if(vm.data.weekConfig.cellHeight<10 || vm.data.weekConfig.cellHeight == undefined){
                            vm.data.weekConfig.cellHeight = 10;
                        }
                        // if(vm.data.weekConfig.margin<0 || vm.data.weekConfig.margin == undefined){
                        //     vm.data.weekConfig.margin = 0;
                        // }
                        if(vm.data.dateConfig.cellWidth<10 || vm.data.dateConfig.cellWidth == undefined){
                            vm.data.dateConfig.cellWidth = 10;
                        }
                        if(vm.data.dateConfig.cellHeight<10 || vm.data.dateConfig.cellHeight == undefined){
                            vm.data.dateConfig.cellHeight = 10;
                        }
                        // if(vm.data.dateConfig.margin<0 || vm.data.dateConfig.margin == undefined){
                        //     vm.data.dateConfig.margin = 0;
                        // }
                        callback()
                    })
                },500)
            }

            $scope.unitConversion = function () {
                vm.onUnit({text: vm.unit});
            }
            $scope.updateBoxParameter = function (item) {
                vm.onUpdatePageValue({text:item})
            }
            //获取当前组件上所有用到的颜色
            vm.getPageColors = function () {
                var colors = [];
                colors.push(vm.data.backgroundColor);
                //日单元格
                vm.dateConfigKeys.forEach(function (item) {
                    var dateStyle = vm.data.dateStyles.find(function (styleItem) {
                        return vm.data.dateConfig[item.id] === styleItem.uuid
                    })
                    if(dateStyle){
                        colors.push(dateStyle.backgroundColor)
                        colors.push(dateStyle.border.color);
                        dateStyle.items.forEach(function (val) {
                            colors.push(val.backgroundColor);
                            colors.push(val.textColor);

                        })

                    }
                })
                //周单元格
                vm.weekStyleKeys.forEach(function (item) {
                    var weekStyle = vm.data.weekStyles.find(function (styleItem) {
                        return vm.data.weekConfig[item.id] === styleItem.uuid
                    })
                    if(weekStyle){
                        colors.push(weekStyle.backgroundColor)
                        colors.push(weekStyle.border.color);
                        weekStyle.items.forEach(function (val) {
                            colors.push(val.backgroundColor);
                            colors.push(val.textColor);

                        })

                    }
                })

                return colorsRemoveDuplicates(colors);
            }
            //colors去重
            function colorsRemoveDuplicates(colors) {
                var list = [];
                colors.forEach(function (item) {
                    if(item && list.indexOf(item.toLowerCase()) < 0){
                        list.push(item.toLowerCase())
                    }
                });
                return list;
            }
        }]
    };
    angular.module('platformApp')
        .component('calendarSet', calendarSetControl);

})();

(function() {
    'use strict';

    angular
        .module('platformApp')
        .controller('CalendarXmlController', CalendarXmlController);

    CalendarXmlController.$inject = ['$state', '$scope', 'UidService', 'ProductXml', 'ParseLinks', 'AlertService', 'MessageService', '$uibModal', 'FontManagement', 'Qinius',
        '$q', '$timeout', 'MonthWidget', '$stateParams', 'CalendarService', 'ModulesService'];

    function CalendarXmlController($state, $scope, UidService, ProductXml, ParseLinks, AlertService, MessageService, $uibModal, FontManagement, Qinius,
                                   $q, $timeout, MonthWidget, $stateParams, CalendarService, ModulesService) {
        var vm = this;
        if($stateParams.id){
            vm.data = MonthWidget.get({id : $stateParams.id});
        }
        $scope.domains = Qinius.getDomain();
        vm.width = 400;
        vm.height = 400;
        vm.monthObj= null;
        vm.isLoading = true;
        //获取token
        Qinius.get(function (msg) {
            vm.token = msg.token;
        });
        //初始缩放比
        vm.scale = 1;
        //是否是拖曳画布状态
        vm.moveCanvasView = false;
        vm.moveCanvasInfo = {
            x:0,
            y:0
        }
        //初始化画布移动信息
        vm.initMoveCanvasInfo = function(){
            vm.moveCanvasInfo = {
                x:0,
                y:0
            }
        }
        vm.navList = [
            {icon:'icon-rili', name: '日历', id:'calendar'},
        ]
        vm.navPitch = 'calendar';
        $scope.$watch(function() {
            return vm.data.name;
        }, function(newName, oldName) {
            if (newName!==undefined) {
                document.title = newName + '-设计页'
            }
        });
        $q.all([$scope.domains.$promise, vm.data.$promise]).then(function () {

            vm.dataInit = angular.copy(vm.data);
            vm.url = $scope.domains.domain;
            init();
            vm.isLoading = false;
        })
        $scope.navCb = function (data) {
            vm.navPitch = data.id;
        };
        $scope.unfoldRight = function(){
            vm.isUnfoldRight = !vm.isUnfoldRight;
        }
        function init() {
            if (vm.data.sampleYear) {
                vm.data.sampleYear = String(vm.data.sampleYear);
            }
            if (vm.data.sampleMonth) {
                vm.data.sampleMonth = String(vm.data.sampleMonth);
            }
            if (vm.data.width) {
                vm.height = vm.data.height * 400 / vm.data.width;
            }
        }
        window.onresize = function(){
            $scope.$apply();
            getFullState();
        }
        //计算画布距离左边距离
        $scope.canvasCoordX = function(){
            if($("#layout-wrapper") && $(".c-editor-content") && vm.moveCanvasInfo && !vm.isLoading){
                var width = $("#layout-wrapper").width();
                var contentWidth = $(".c-editor-content").width();
                var x = (contentWidth - (width / vm.scale)) / 2 + vm.moveCanvasInfo.x;
                return x;
            }
        }
        //计算画布距离顶部距离
        $scope.canvasCoordY = function(){
            if($("#layout-wrapper") && $(".c-editor-content") && vm.moveCanvasInfo && !vm.isLoading){
                var height = $("#layout-wrapper").height();
                var contentHeight = $(".c-editor-content").height();
                var y = (contentHeight - (height / vm.scale)) / 2 + vm.moveCanvasInfo.y;
                return y;
            }
        }
        $scope.onYearMonthChnage = function () {
        }
        //键盘事件
        document.onkeydown = function(event){
            if(event.keyCode === 32){
                if(vm.moveCanvasView) return false;
                $timeout(function(){
                    vm.moveCanvasView = true;
                    $scope.$apply();
                })
                return false;
            }
            //F11
            if (event.keyCode===122 && !vm.isFullScreen) {
                event.preventDefault();
                $scope.fullScreen();
            }
            // ctrl+z
            if (event.keyCode == 90 && event.ctrlKey) {
                $scope.lastStep();
                $scope.$digest();
            }
        }
        document.onkeyup = function(){
            if(event.keyCode === 32){
                $timeout(function(){
                    vm.moveCanvasView = false;
                    $scope.$apply();
                })
            }

        }
        //移动画布
        $scope.moveCanvas = function(e){
            if(!vm.moveCanvasView) return;
            var moveCanvasInfo = angular.copy(vm.moveCanvasInfo);
            moveCanvas(e,function(x,y){
                $timeout(function(){
                    vm.moveCanvasInfo.x = moveCanvasInfo.x + x;
                    vm.moveCanvasInfo.y = moveCanvasInfo.y + y;
                })

            })
        }
        /**
         * 画布放大、缩小、还原
         * @param {*} type  0 还原 1缩小 2放大  3原尺寸
         */
        $scope.changeCanvasSize = function(type){
            $timeout(function(){
                //步长
                var stepSize = 0.02;
                //还原 或原尺寸
                if(type === 0 || type === 3){
                    vm.scale = 1;
                    vm.initMoveCanvasInfo();
                }
                // 缩小
                if(type === 1){
                    vm.scale = vm.scale - stepSize;
                    //限制最小缩放比不能小于0.5倍的初始尺寸
                    if(vm.scale < 0.5) vm.scale = 0.5;
                }
                //放大
                if(type === 2){
                    vm.scale = vm.scale + stepSize;
                    //限制放大倍数不能大于1.5倍的初始尺寸
                    // if(vm.scale > 1.5) vm.scale = 1.5;
                }
            })
        }
        //鼠标滚轮事件
        function originalEventRatio(){
            if (event.ctrlKey === true || event.metaKey) {
                var wheelDelta = event.wheelDelta ? (event.wheelDelta / 120) : (-event.detail / 3);
                if (wheelDelta > 0) {
                    $scope.changeCanvasSize(2);
                } else {
                    $scope.changeCanvasSize(1);
                }
                $scope.$apply();
                event.preventDefault();
            }
        }
        //鼠标滚轮事件
        window.addEventListener('mousewheel',originalEventRatio,{passive: false});
        $scope.$on('$destroy',function () {
            //取消监听事件
            window.removeEventListener('mousewheel',originalEventRatio)
        });
        $scope.widgetUpdate = function(item){
            vm.isLoading = true;
            $timeout(function () {
                if(!item){
                    lastData();
                }
                vm.isLoading = false;
            })
        }
        $scope.onSettingsChange = function (text) {
            if (text) {
                var data = JSON.parse(text);
                vm.data = data;
                $scope.widgetUpdate();
            }
        }

        //保存
        $scope.save = function () {
            for(var i=0; i<vm.data.dateStyles.length; i++){
                var _dateStyle = vm.data.dateStyles[i];
                for(var i1 = 0; i1<_dateStyle.items.length; i1++){
                    var _item = _dateStyle.items[i1];
                    if(!_item.textFontUuid){
                        MessageService.error('日单元格的' + _dateStyle.name + "文字字体不能为空");
                        return false
                    }
                }
            }
            for(var j=0; j<vm.data.weekStyles.length; j++){
                var _weekStyle = vm.data.weekStyles[j];
                for(var j1 = 0; j1<_weekStyle.items.length; j1++){
                    var _item = _weekStyle.items[j1];
                    if(!_item.textFontUuid){
                        MessageService.error('周单元格的' + _weekStyle.name + "文字字体不能为空");
                        return false
                    }
                }
            }
            var loading = MessageService.loading();
            $(".layout-wrapper-view").css({'background':'#fff'});
            $timeout(function () {
                var nodes = document.getElementById('page-item2');
                html2canvas_adapt(nodes, {
                    onrendered: function(canvas) {
                        $(".layout-wrapper-view").css({'background':'none'});
                        var url = canvas.toDataURL("image/png");
                        var blob = dataURLtoBlob(url);

                        var formData = new FormData();
                        formData.append('file', blob);
                        formData.append('key', 'cover-' + UidService.get());
                        formData.append('token', vm.token);
                        $.ajax({
                            cache: true,
                            type: "POST",
                            url: 'https://upload.qiniup.com/',
                            data: formData,
                            async: false,
                            contentType: false,
                            processData: false,
                            success: function (data) {
                                vm.data.previewUrl = vm.url + data.key;
                                if(vm.data.id){
                                    MonthWidget.update(vm.data, function (res) {
                                        loading.close();
                                        MessageService.success("保存成功");
                                        history.go(-1)
                                    })
                                }else{
                                    MonthWidget.create(vm.data, function (res) {
                                        loading.close();
                                        MessageService.success("保存成功");
                                        history.go(-1)
                                    })
                                }
                                $scope.$digest();
                            },
                            error: function (request) {
                                loading.close();
                                MessageService.error("文件上传失败");
                            }
                        });
                    },
                    letterRendering: true,
                    useCORS: true,
                    width: $("#page-item2").width(),
                    height: $("#page-item2").height(),
                    windowWidth: document.body.scrollWidth,
                    windowHeight: document.body.scrollHeight,
                    x: nodes.getBoundingClientRect().left,
                    y: nodes.getBoundingClientRect().top,
                    ratio:1,
                    backgroundColor: "rgba(0,0,0,0)"
                });
            })
        }
        //退出
        $scope.out = function () {
            if(!vm.operation){
                history.go(-1)
            }else{
                MessageService.confirm({
                    title:'温馨提示',
                    goback:'取消',
                    cancel:'不保存',
                    confirm:'保存',
                    msg:'退出前是否需要保存已变更的内容?',
                },function(){
                    $scope.save();
                },function (flag) {
                    if(flag){
                        history.go(-1)
                    }
                })
            }
        }
        //上一步
        vm.datas = [];
        vm.operation = false;
        function lastData(){
            vm.operation = true;
            vm.datas.push(angular.copy(vm.data));
        }
        $scope.lastStep = function(){
            if(vm.datas.length > 0){
                if(vm.datas.length > 1){
                    var _data = angular.copy(vm.datas[vm.datas.length-2 > 0 ? vm.datas.length-2 : 0]);
                    vm.data = _data;
                }else{
                    vm.data = angular.copy(vm.dataInit);
                }
                vm.datas.splice(vm.datas.length-1, 1);
                $scope.widgetUpdate(true);
            }
        }
        //还原
        $scope.initData = function () {
            if(vm.datas.length > 0){
                vm.data = angular.copy(vm.dataInit);
                $scope.widgetUpdate();
            }
        }
        //全屏
        vm.isFullScreen = false;
        function getFullState(){
            $timeout(function () {
                vm.isFullScreen = Math.abs(window.screen.height-window.document.documentElement.clientHeight) <= 17;
            })
        }
        getFullState();
        $scope.fullScreen = function () {
            var el = document.documentElement
            var rfs = el.requestFullScreen || el.webkitRequestFullScreen || el.mozRequestFullScreen || el.msRequestFullscreen
            if (rfs) { // typeof rfs != "undefined" && rfs
                rfs.call(el)
            }else if (typeof window.ActiveXObject !== 'undefined') {
                // for IE，这里其实就是模拟了按下键盘的F11，使浏览器全屏
                var wscript = new ActiveXObject('WScript.Shell')
                if (wscript != null) {
                    wscript.SendKeys('{F11}')
                }
            }
        }
        $scope.exitScreen = function(){
            var el = document
            var cfs = el.cancelFullScreen || el.mozCancelFullScreen || el.msExitFullscreen || el.webkitExitFullscreen || el.exitFullscreen
            if (cfs) { // typeof cfs != "undefined" && cfs
                cfs.call(el)
            } else if (typeof window.ActiveXObject !== 'undefined') {
                // for IE，这里和fullScreen相同，模拟按下F11键退出全屏
                var wscript = new ActiveXObject('WScript.Shell')
                if (wscript != null) {
                    wscript.SendKeys('{F11}')
                }
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('platformApp')
        .controller('CalendarTitleXmlController', CalendarTitleXmlController);

    CalendarTitleXmlController.$inject = ['$state', '$scope', 'UidService', 'ProductXml', 'ParseLinks', 'AlertService', 'MessageService', '$uibModal', 'FontManagement', 'Qinius',
        '$q', '$timeout', 'TitleWidget', '$stateParams', 'CalendarService','ModulesService'];

    function CalendarTitleXmlController($state, $scope, UidService, ProductXml, ParseLinks, AlertService, MessageService, $uibModal, FontManagement, Qinius,
                                   $q, $timeout, TitleWidget, $stateParams, CalendarService,ModulesService) {
        var vm = this;
        if($stateParams.id){
            vm.widget = TitleWidget.get({id : $stateParams.id});

        }
        $scope.domains = Qinius.getDomain();
        vm.themeColors = [];//当前组件用到的所有颜色
        vm.width = 400;
        vm.height = 400;
        vm.monthObj= null;
        vm.isLoading = true;
        //获取token
        Qinius.get(function (msg) {
            vm.token = msg.token;
        });
        //初始缩放比
        vm.scale = 1;
        //是否是拖曳画布状态
        vm.moveCanvasView = false;
        vm.moveCanvasInfo = {
            x:0,
            y:0
        }
        //初始化画布移动信息
        vm.initMoveCanvasInfo = function(){
            vm.moveCanvasInfo = {
                x:0,
                y:0
            }
        }
        vm.fontList = [];
        vm.isFontList = false;
        FontManagement.getAll3({items: [], sort: ["id,asc"]}, function (resp) {
            for (var i = 0; i < resp.length; i++) {
                if(resp[i].calendarSupport){
                    vm.fontList.push(resp[i]);
                }

            }
            vm.isFontList = true;
        })
        vm.navList = [
            {icon:'icon-rili', name: '日历', id:'calendar'},
        ]
        vm.navPitch = 'calendar';

        vm.sampleYears = [
            {id:'2020',value:'2020'},
            {id:'2021',value:'2021'},
            {id:'2022',value:'2022'},
            {id:'2023',value:'2023'},
            {id:'2024',value:'2024'},
            {id:'2025',value:'2025'},
            {id:'2026',value:'2026'},
            {id:'2027',value:'2027'},
            {id:'2028',value:'2028'},
            {id:'2029',value:'2029'},
            {id:'2030',value:'2030'},
        ];
        vm.sampleMonths = [
            {id:'1',value:'1'},
            {id:'2',value:'2'},
            {id:'3',value:'3'},
            {id:'4',value:'4'},
            {id:'5',value:'5'},
            {id:'6',value:'6'},
            {id:'7',value:'7'},
            {id:'8',value:'8'},
            {id:'9',value:'9'},
            {id:'10',value:'10'},
            {id:'11',value:'11'},
            {id:'12',value:'12'},
        ];
        $scope.$watch(function() {
            return vm.widget.name;
        }, function(newName, oldName) {
            if (newName!==undefined) {
                document.title = newName + '-设计页'
            }
        });
        $q.all([$scope.domains.$promise, vm.widget.$promise]).then(function () {
            vm.dataInit = angular.copy(vm.widget);
            vm.url = $scope.domains.domain;
            init();
        })
        $scope.navCb = function (data) {
            vm.navPitch = data.id;
        };
        $scope.unfoldRight = function(){
            vm.isUnfoldRight = !vm.isUnfoldRight;
        }
        function init() {
            if (vm.widget.sampleYear) {
                vm.widget.sampleYear = String(vm.widget.sampleYear);
            }
            if (vm.widget.sampleMonth) {
                vm.widget.sampleMonth = String(vm.widget.sampleMonth);
            }
            if (!vm.widget.width) {
                vm.widget.width = vm.widget.layout.width;
            }
            if (!vm.widget.height) {
                vm.widget.height = vm.widget.layout.height;
            }
            getPageColors();
        }
        window.onresize = function(){
            $scope.$apply();
            getFullState();
        }
        //计算画布距离左边距离
        $scope.canvasCoordX = function(){
            var width = $("#layout-wrapper").width();
            var contentWidth = $(".c-editor-content").width();
            var x = (contentWidth - (width / vm.scale)) / 2 + vm.moveCanvasInfo.x;
            return x;
        }
        //计算画布距离顶部距离
        $scope.canvasCoordY = function(){
            var height = $("#layout-wrapper").height();
            var contentHeight = $(".c-editor-content").height();
            var y = (contentHeight - (height / vm.scale)) / 2 + vm.moveCanvasInfo.y;

            return y;
        }
        //键盘事件
        document.onkeydown = function(){
            if(event.keyCode === 32){
                if(vm.moveCanvasView) return false;
                $timeout(function(){
                    vm.moveCanvasView = true;
                    $scope.$apply();
                })
                return false;
            }
            //F11
            if (event.keyCode===122 && !vm.isFullScreen) {
                event.preventDefault();
                $scope.fullScreen();
            }
            // ctrl+z
            if (event.keyCode == 90 && event.ctrlKey) {
                $scope.lastStep();
                $scope.$digest();
            }
        }
        document.onkeyup = function(){
            if(event.keyCode === 32){
                $timeout(function(){
                    vm.moveCanvasView = false;
                    $scope.$apply();
                })
            }

        }
        //移动画布
        $scope.moveCanvas = function(e){
            if(!vm.moveCanvasView) return;
            var moveCanvasInfo = angular.copy(vm.moveCanvasInfo);
            moveCanvas(e,function(x,y){
                $timeout(function(){
                    vm.moveCanvasInfo.x = moveCanvasInfo.x + x;
                    vm.moveCanvasInfo.y = moveCanvasInfo.y + y;
                })

            })
        }
        /**
         * 画布放大、缩小、还原
         * @param {*} type  0 还原 1缩小 2放大  3原尺寸
         */
        $scope.changeCanvasSize = function(type){
            $timeout(function(){
                //步长
                var stepSize = 0.02;
                //还原 或原尺寸
                if(type === 0 || type === 3){
                    vm.scale = 1;
                    vm.initMoveCanvasInfo();
                }
                // 缩小
                if(type === 1){
                    vm.scale = vm.scale - stepSize;
                    //限制最小缩放比不能小于0.5倍的初始尺寸
                    if(vm.scale < 0.5) vm.scale = 0.5;
                }
                //放大
                if(type === 2){
                    vm.scale = vm.scale + stepSize;
                    //限制放大倍数不能大于1.5倍的初始尺寸
                    if(vm.scale > 1.5) vm.scale = 1.5;
                }
            })
        }
        //鼠标滚轮事件
        function originalEventRatio(){
            if (event.ctrlKey === true || event.metaKey) {
                var wheelDelta = event.wheelDelta ? (event.wheelDelta / 120) : (-event.detail / 3);
                if (wheelDelta > 0) {
                    $scope.changeCanvasSize(2);
                } else {
                    $scope.changeCanvasSize(1);
                }
                $scope.$apply();
                event.preventDefault();
            }
        }
        //鼠标滚轮事件
        window.addEventListener('mousewheel',originalEventRatio,{passive: false});
        $scope.$on('$destroy',function () {
            //取消监听事件
            window.removeEventListener('mousewheel',originalEventRatio)
        });

        $scope.onSettingsChange = function (text) {
            if (text) {
                vm.loading1 = true;
                var data = JSON.parse(text);
                vm.widget.settings = data;
                $timeout(function() {
                    lastData();
                    vm.loading1 = false;
                    getPageColors();
                });
            }
        }

        $scope.onYearMonthChnage = function () {
            lastData()
        }
        //保存
        $scope.save = function () {
            for(var i=0; i<vm.widget.settings.items.length; i++){
                var _item = vm.widget.settings.items[i];
                if(!_item.textFontUuid){
                    MessageService.error(_item.name + "的文字字体不能为空");
                    return false
                }
            }
            vm.loading = true;
            $timeout(function () {
                var nodes = document.getElementById('page-item2');
                html2canvas_adapt(nodes, {
                    onrendered: function(canvas) {
                        var url = canvas.toDataURL("image/png");
                        var blob = dataURLtoBlob(url);

                        var formData = new FormData();
                        formData.append('file', blob);
                        formData.append('key', 'cover-' + UidService.get());
                        formData.append('token', vm.token);
                        $.ajax({
                            cache: true,
                            type: "POST",
                            url: 'https://upload.qiniup.com/',
                            data: formData,
                            async: false,
                            contentType: false,
                            processData: false,
                            success: function (data) {
                                vm.loading = false;
                                vm.widget.previewUrl = vm.url + data.key;
                                if(vm.widget.id){
                                    TitleWidget.update(vm.widget, function (res) {
                                        MessageService.success("保存成功");
                                        history.go(-1)
                                    })
                                }else{
                                    TitleWidget.create(vm.widget, function (res) {
                                        MessageService.success("保存成功");
                                        history.go(-1)
                                    })
                                }
                                $scope.$digest();
                            },
                            error: function (request) {
                                vm.loading = false;
                                MessageService.error("文件上传失败");
                            }
                        });
                    },
                    letterRendering: true,
                    useCORS: true,
                    width: $("#page-item2").width(),
                    height: $("#page-item2").height(),
                    windowWidth: document.body.scrollWidth,
                    windowHeight: document.body.scrollHeight,
                    x: nodes.getBoundingClientRect().left,
                    y: nodes.getBoundingClientRect().top,
                    ratio:1,
                    backgroundColor: "rgba(0,0,0,0)"
                });
            })
        }
        //退出
        $scope.out = function () {
            if(!vm.operation){
                history.go(-1)
            }else{
                MessageService.confirm({
                    title:'温馨提示',
                    goback:'取消',
                    cancel:'不保存',
                    confirm:'保存',
                    msg:'退出前是否需要保存已变更的内容?',
                },function(){
                    $scope.save();
                },function (flag) {
                    if(flag){
                        history.go(-1)
                    }
                })
            }
        }
        //上一步
        vm.datas = [];
        vm.operation = false;
        function lastData(){
            vm.operation = true;
            vm.datas.push(angular.copy(vm.widget));
        }
        $scope.lastStep = function(){
            if(vm.datas.length > 0){
                if(vm.datas.length > 1){
                    var _data = angular.copy(vm.datas[vm.datas.length-2 > 0 ? vm.datas.length-2 : 0]);
                    vm.widget = _data;
                }else{
                    vm.widget = angular.copy(vm.dataInit);
                }
                init();
                vm.datas.splice(vm.datas.length-1, 1);
                vm.loading1 = true;
                $timeout(function() {
                    vm.loading1 = false;
                });
            }
        }
        //还原
        $scope.initData = function () {
            if(vm.datas.length > 0){
                vm.widget = angular.copy(vm.dataInit);
                init();
                vm.loading1 = true;
                $timeout(function() {
                    vm.loading1 = false;
                });
            }
        }
        //全屏

        vm.isFullScreen = false;
        function getFullState(){
            $timeout(function () {
                vm.isFullScreen = Math.abs(window.screen.height-window.document.documentElement.clientHeight) <= 17;
            })
        }
        getFullState();
        $scope.fullScreen = function () {
            var el = document.documentElement
            var rfs = el.requestFullScreen || el.webkitRequestFullScreen || el.mozRequestFullScreen || el.msRequestFullscreen
            if (rfs) { // typeof rfs != "undefined" && rfs
                rfs.call(el)
            }else if (typeof window.ActiveXObject !== 'undefined') {
                // for IE，这里其实就是模拟了按下键盘的F11，使浏览器全屏
                var wscript = new ActiveXObject('WScript.Shell')
                if (wscript != null) {
                    wscript.SendKeys('{F11}')
                }
            }
        }
        $scope.exitScreen = function(){
            var el = document
            var cfs = el.cancelFullScreen || el.mozCancelFullScreen || el.msExitFullscreen || el.webkitExitFullscreen || el.exitFullscreen
            if (cfs) { // typeof cfs != "undefined" && cfs
                cfs.call(el)
            } else if (typeof window.ActiveXObject !== 'undefined') {
                // for IE，这里和fullScreen相同，模拟按下F11键退出全屏
                var wscript = new ActiveXObject('WScript.Shell')
                if (wscript != null) {
                    wscript.SendKeys('{F11}')
                }
            }
        }
        //获取当前组件上所有用到的颜色
        function getPageColors() {
            var colors = [];
            if(!vm.widget.settings) return [];
            vm.widget.settings.items.forEach(function (item) {
                colors.push(item.backgroundColor);
                colors.push(item.textColor);
            })
            $timeout(function () {
                vm.themeColors = colorsRemoveDuplicates(colors);
                $scope.$apply();
            })
        }
        function colorsRemoveDuplicates(colors) {
            var list = [];
            colors.forEach(function (item) {
                if(item && list.indexOf(item.toLowerCase()) < 0){
                    list.push(item.toLowerCase())
                }
            });
            return list;
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('platformApp')
        .controller('CalendarTitleController', CalendarTitleController);

    CalendarTitleController.$inject = ['$state', '$scope', 'ProductXml', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams', 'MessageService', 'TitleWidget', '$localStorage', 'Qinius', '$uibModal'];

    function CalendarTitleController($state, $scope, ProductXml, ParseLinks, AlertService, paginationConstants, pagingParams, MessageService, TitleWidget, $localStorage, Qinius, $uibModal) {
        var vm = this;
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.clear = clear;
        vm.search = search;
        vm.loadAll = loadAll;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;
        vm.jump = jump;
        vm.account = $localStorage.user;
        $scope.domains = Qinius.getDomain();
        vm.status = status;

        loadAll();

        $scope.delete = function(id){
            MessageService.confirm({
                title:'提示',
                cancel:'取消',
                confirm:'确认',
                msg:'确定要删除该数据？'
            },function(){
                TitleWidget.delete({id: id},function () {
                    loadAll();
                });
            },function(){});
        };

        function loadAll () {
            if (vm.account == undefined || vm.account == null) {
                $state.go('home');
                return;
            }
            TitleWidget.byCondition({
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
        }
        function sort() {
            var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
            if (vm.predicate !== 'id') {
                result.push('id');
            }
            return result;
        }
        function onSuccess(data, headers) {
            vm.links = ParseLinks.parse(headers('link'));
            vm.totalItems = headers('X-Total-Count');
            vm.queryCount = vm.totalItems;
            vm.textList = data;
            vm.page = pagingParams.page;
        }
        function onError(error) {
            MessageService.error("文字模板获取失败");
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search(searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear() {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }

        function jump () {
            vm.page = vm.jumpText<=0?1:vm.jumpText;
            loadPage(vm.page);
        }

        $scope.release = function (data) {
            TitleWidget.get({id:data.id}, function (res) {
                $uibModal.open({
                    templateUrl: 'app/entities/text/modal/text-detection.html',
                    controller: 'TextDetectionController',
                    controllerAs: 'vm',
                    size: 'lg',
                    resolve: {
                        entity: [function() {
                            return {
                                textDocument: res.textDocument,
                                id:res.id,
                                storeIds:[],
                            };
                        }]
                    }
                }).result.then(function (isReturn) {
                })
            })



            // TitleWidget.onlyRelease({id: data.id}, function (res) {
            //     MessageService.success("发布成功");
            //     loadAll();
            // }, function (error) {
            //     MessageService.error("发布失败，请稍后重试！");
            // })
        }


        $scope.share = function (data) {
            TitleWidget.share({id: data.id}, function (res) {
                MessageService.success("分享成功");
                loadAll();
            })
        }
        $scope.delete = function (data) {
            MessageService.confirm({
                title:'提示',
                cancel:'取消',
                confirm:'确认',
                msg:'确定要删除该数据？'
            },function(){
                TitleWidget.delete({id: data.id}, function (res) {
                    MessageService.success("删除成功");
                    loadAll();
                })
            },function(){});
        }
        //查看
        $scope.look = function (data) {
            $uibModal.open({
                templateUrl: 'app/entities/text/modal/text-xml-look.html',
                controller: 'TextXmlLookController',
                controllerAs: 'vm',
                backdrop: 'static',
                resolve: {
                    entity: [function() {
                        return {
                            url: data.previewUrl,
                            domain: $scope.domains.domain
                        };
                    }]
                }
            });
        }
        //新增
        $scope.add = function () {
            $uibModal.open({
                templateUrl: 'app/entities/calendar/modal/calendar-title-add.html',
                controller: 'CalendarTitleAddController',
                controllerAs: 'vm',
                backdrop: 'static',
                resolve: {
                    entity: [function() {
                        return null;
                    }]
                }
            }).result.then(function(res) {
                if (res) {
                    loadAll();
                }
            });
        }
        //复制
        $scope.copy = function (item) {
            var _data = angular.copy(item);
            _data.name = _data.name + '_副本';
            $uibModal.open({
                templateUrl: 'app/entities/calendar/modal/calendar-title-add.html',
                controller: 'CalendarTitleAddController',
                controllerAs: 'vm',
                backdrop: 'static',
                resolve: {
                    entity: [function() {
                        return _data;
                    }]
                }
            });
        }
        function status(item) {
            switch (item) {
                case 'Created':
                    return '已分享';
                    break;
                case 'Approved':
                    return '已通过';
                    break;
                case 'Rejected':
                    return '已拒绝';
                    break;
                default:
                    return '未分享'
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('platformApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('calendar', {
            parent: 'app',
            url: '/calendar?type',
            data: {
                authorities: [],
                pageTitle: 'platformAppTitle.calendar'
            },
            views: {
                'content': {
                    templateUrl: 'app/entities/calendar/calendar.html',
                    controller: 'CalendarController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,desc',
                    squash: true
                },
                type: {
                    value: 'calendar',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('fontManagement');
                    $translatePartialLoader.addPart('global');
                    $translatePartialLoader.addPart('title');
                    return $translate.refresh();
                }]
            }
        })
        .state('calendar-xml', {
            url: '/calendar-xml/{id}',
            data: {
                authorities: [],
                pageTitle: 'platformAppTitle.calendar-xml'
            },
            views: {
                'navbar@': {
                    templateUrl: 'app/entities/calendar/calendar-xml.html',
                    controller: 'CalendarXmlController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('global');
                    $translatePartialLoader.addPart('title');
                    return $translate.refresh();
                }]
            }
        })
            .state('calendarTitle', {
                parent: 'app',
                url: '/calendarTitle',
                data: {
                    authorities: [],
                    pageTitle: 'platformApp.productXml.home.title'
                },
                views: {
                    'content': {
                        templateUrl: 'app/entities/calendar/calendar-title.html',
                        controller: 'CalendarTitleController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,desc',
                        squash: true
                    },
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('fontManagement');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            .state('calendar-title-xml', {
                url: '/calendar-title-xml/{id}',
                data: {
                    authorities: [],
                    pageTitle: 'platformAppTitle.calendar-title-xml'
                },
                views: {
                    'navbar@': {
                        templateUrl: 'app/entities/calendar/calendar-title-xml.html',
                        controller: 'CalendarTitleXmlController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('global');
                        $translatePartialLoader.addPart('title');
                        return $translate.refresh();
                    }]
                }
            });
    }

})();

(function() {
    'use strict';
    angular
        .module('platformApp')
        .factory('CalendarLayout', CalendarLayout)
        .factory('CalendarService', CalendarService)
        .factory('TitleWidget', TitleWidget)
        .factory('MonthWidget', MonthWidget)
        .factory('CalendarConfig', CalendarConfig);

    CalendarLayout.$inject = ['$resource'];
    function CalendarLayout ($resource) {
        var resourceUrl =  'bunny/' + 'api/cal-layouts/:path';

        return $resource(resourceUrl, {}, {
            "getLayouts":{
                method:"GET",
                params:{
                    path:"getLayouts"
                }
            },
            "byCondition":{
                method:"POST",
                params:{
                    path:"byCondition"
                }
            },
            "updatePreview": {
                method: "POST",
                params: {
                    path: "updatePreview"
                }
            }
        });
    }

    TitleWidget.$inject = ['$resource'];
    function TitleWidget ($resource) {
        var resourceUrl =  'bunny/' + 'api/cal-title-widgets/:path/:id';

        return $resource(resourceUrl, {}, {
            'update': {
                method: "POST",
                params: {
                    path: "edit"
                }
            },
            "share": {
                method: "GET",
                params: {
                    path: "share"
                }
            },
            "copy": {
                method: "GET",
                params: {
                    path: "copy"
                }
            },
            "batchShare":{//批量分享标题
                method: "POST",
                params:{
                    path:'batchShare'
                }
            },
            "create": {
                method: "POST",
                params: {
                    path: "create"
                }
            },
            "edit": {
                method: "POST",
                params: {
                    path: "edit"
                }
            },
            "getWidgets":{
                method:"GET",
                params:{
                    path:"getWidgets"
                }
            },
            "getAllUsable":{
                method:"GET",
                params:{
                    path:"getAllUsable"
                },
                isArray: true
            },
            "byCondition":{
                method:"POST",
                params:{
                    path:"byCondition"
                },
                isArray:true
            },
            "updatePreview": {
                method: "POST",
                params: {
                    path: "updatePreview"
                }
            },
            "byCondition2":{
                method:"POST",
                params:{
                    path:"byCondition2"
                },
                isArray: true
            },
            "byCondition3":{//用于分享
                method:"POST",
                params:{
                    path:"byCondition3"
                },
                isArray: true
            },
            'auditing': {
                method: 'GET',
                params:{
                    path:"auditing"
                },
            },
            'get': {
                method: 'GET',
                transformResponse: function(data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            "delete": {
                method: 'DELETE'
            },
            "batchDelete":{//批量删除标题
                method: "POST",
                params:{
                    path:'batchDelete'
                }
            },
            "save": {
                method: 'POST'
            },
        });
    }

    MonthWidget.$inject = ['$resource'];
    function MonthWidget ($resource) {
        var resourceUrl =  'bunny/' + 'api/cal-month-widgets/:path/:id';

        return $resource(resourceUrl, {}, {
            'get': {
                method: 'GET',
                transformResponse: function(data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            "share": {
                method: "GET",
                params: {
                    path: "share"
                }
            },
            "copy": {
                method: "GET",
                params: {
                    path: "copy"
                }
            },
            "batchShare":{//批量分享日历
                method: "POST",
                params:{
                    path:'batchShare'
                }
            },
            "create": {
                method: "POST",
                params: {
                    path: "create"
                }
            },
            'update': {
                method: "POST",
                params: {
                    path: "edit"
                }
            },
            "edit": {
                method: "POST",
                params: {
                    path: "edit"
                }
            },
            "getWidgets":{
                method:"GET",
                params:{
                    path:"getWidgets"
                }
            },
            "getAllUsable":{
                method:"GET",
                params:{
                    path:"getAllUsable"
                },
                isArray: true
            },
            "byCondition":{
                method:"POST",
                params:{
                    path:"byCondition"
                },
                isArray:true
            },
            "updatePreview": {
                method: "POST",
                params: {
                    path: "updatePreview"
                }
            },
            "byCondition2":{
                method:"POST",
                params:{
                    path:"byCondition2"
                },
                isArray: true
            },
            "byCondition3":{//用于分享
                method:"POST",
                params:{
                    path:"byCondition3"
                },
                isArray: true
            },
            'auditing': {
                method: 'GET',
                params:{
                    path:"auditing"
                },
            },
            "delete": {
                method: 'DELETE'
            },
            "batchDelete":{//批量删除日历
                method: "POST",
                params:{
                    path:'batchDelete'
                }
            },
            "save": {
                method: "POST",
                params: {
                    path: "save"
                }
            }
        });
    }

    CalendarConfig.$inject = ['$resource'];
    function CalendarConfig ($resource) {
        var resourceUrl =  'bunny/' + 'api/cal-config/:path';

        return $resource(resourceUrl, {}, {
            "getDefault": {
                method: "GET",
                params: {
                    path: "getDefault"
                }
            },
            "save": {
                method: "POST",
                params: {
                    path: "save"
                }
            }
        });
    }

    CalendarService.$inject = ['$resource'];
    function CalendarService($resource) {
        var resourceUrl = 'bunny/api/calendar-service/:path';
        return $resource(resourceUrl, {}, {
            "getYear":{
                method:"GET",
                params:{
                    path:"getYear"
                },
                isArray:true
            },
            "getYears":{
                method:"GET",
                params:{
                    path:"getYears"
                },
                isArray:true
            },
            "getMonth":{
                method:"GET",
                params:{
                    path:"getMonth"
                }
            },
            'getMonthsOfYear': {
                method: 'GET',
                params:{
                    path:'getMonthsOfYear'
                }
            },
            'getDate': {
                method: 'GET',
                params:{
                    path:'getDate'
                }
            },
            'getDatesOfMonth': {
                method: 'GET',
                params:{
                    path:'getDatesOfMonth'
                }
            },
            'getDatesOfTable': {
                method: 'GET',
                params:{
                    path:'getDatesOfTable'
                }
            },
            'getWeekday': {
                method: 'GET',
                params:{
                    path:'getWeekday'
                }
            },
            'getWeekdays': {
                method: 'GET',
                params:{
                    path:'getWeekdays'
                }
            },
            'queryYearMonthSet': {
                method: "POST",
                params: {
                    path: "queryYearMonthSet"
                }
            },
            'queryWeekdaysSet': {
                method: "POST",
                params: {
                    path: "queryWeekdaysSet"
                }
            },
            'queryMonthdaysSet': {
                method: "POST",
                params: {
                    path: "queryMonthdaysSet"
                }
            },
            'queryMonthTable': {
                method: "POST",
                params: {
                    path: "queryMonthTable"
                }
            }
        });
    }
})();

(function () {
    "use strict";

    angular
        .module("platformApp")
        .controller("CalendarController", CalendarController);

    CalendarController.$inject = [
        "$state",
        "$scope",
        "ProductXml",
        "ParseLinks",
        "AlertService",
        "paginationConstants",
        "pagingParams",
        "MessageService",
        "MonthWidget",
        "$localStorage",
        "Qinius",
        "$uibModal",
        "TitleWidget",
        "$timeout",
        "$stateParams"
    ];

    function CalendarController(
        $state,
        $scope,
        ProductXml,
        ParseLinks,
        AlertService,
        paginationConstants,
        pagingParams,
        MessageService,
        MonthWidget,
        $localStorage,
        Qinius,
        $uibModal,
        TitleWidget,
        $timeout,
        $stateParams
    ) {
        var vm = this;
        vm.oldView = false;
        //搜索防抖定时器
        vm.timer = null;
        //分页信息
        vm.pageInfo = {
            page: 1,
            size: 20,
            total: 0,
        };
        //批量操作状态
        vm.batchState = false;
        vm.statusList = [
            { label: "全部", value: "", op: "=" },
            { label: "未分享", value: null, op: "isnull" },
            { label: "审核中", value: "Created", op: "=" },
            { label: "已分享", value: "Approved", op: "=" },
            { label: "已驳回", value: "Rejected", op: "=" },
        ];
        vm.pageView = $stateParams.type || "calendar";
        //分类
        vm.genreList = [
            { label: "日历组件", value: "calendar" },
            { label: "标题组件", value: "calendarTitle" },
        ];
        //选中的状态
        vm.selectStatus = "";
        vm.selectCount = 0;
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.search = search;
        vm.loadAll = loadAll;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;
        vm.jump = jump;
        vm.account = $localStorage.user;
        $scope.domains = Qinius.getDomain();
        vm.status = status;

        loadAll();

        $scope.delete = function (item) {
            MessageService.confirm(
                {
                    title: "提示",
                    cancel: "取消",
                    confirm: "确认",
                    msg: "确定要删除该数据？"
                },
                function () {
                    if (vm.pageView == "calendar") {
                        MonthWidget.delete({ id: item.id }, function () {
                            loadAll();
                        });
                    } else if (vm.pageView == "calendarTitle") {
                        TitleWidget.delete({ id: item.id }, function () {
                            loadAll();
                        });
                    }
                },
                function () {}
            );
        };
        $scope.batchDelete = function(){
            if (vm.batchDeleteLoading) return;
            //获取选中的
            var selectList = vm.textList.filter(function (item) {
                return item.selected === true;
            })
            if(selectList.length === 0 ) return MessageService.error("至少选择一条数据");
            var ids = selectList.map(function (item) {
                return item.id;
            });
            MessageService.confirm(
                {
                    title: "提示",
                    cancel: "取消",
                    confirm: "确认",
                    msg: "确定要删除选中的数据？",
                },
                function () {
                    vm.batchDeleteLoading = true;
                    if (vm.pageView == "calendar") {
                        MonthWidget.batchDelete(ids,function(){
                            MessageService.success("删除成功");
                            vm.batchDeleteLoading = false;
                            vm.loadAll();
                        },function(){
                            MessageService.error("网络异常，请重试");
                            vm.batchDeleteLoading = false;
                        })
                    } else if (vm.pageView == "calendarTitle") {
                        TitleWidget.batchDelete(ids,function(){
                            MessageService.success("删除成功");
                            vm.batchDeleteLoading = false;
                            vm.loadAll();
                        },function(){
                            MessageService.error("网络异常，请重试");
                            vm.batchDeleteLoading = false;
                        })
                    }
                },
                function () {}
            );
        }
        //分页变更
        vm.currentChange = function () {
            $timeout(function () {
                vm.loadAll();
            });
        };
        //批量操作选择
        $scope.checkItem = function(item){
            if (!vm.batchState) {
                return
            }
            if(!item.selected){
                item.selected = true;
            }else{
                item.selected = false;
            }
            //获取选中的数量
            var selectList = vm.textList.filter(function (item) {
                return item.selected === true;
            })
            vm.selectCount = selectList.length;
        };
        function loadAll() {
            if (vm.account == undefined || vm.account == null) {
                $state.go("home");
                return;
            }
            var items = [{key:"builtin", op:"=", value:"false"}];
            var status = vm.statusList.find(function (item) {
                return item.value === vm.selectStatus;
            });
            if (status.value !== "") {
                items.push({
                    key: "status",
                    value: status.value,
                    op: status.op,
                });
            }
            if (vm.searchQuery) {
                items.push({
                    key: "name",
                    value: vm.searchQuery,
                    op: "like",
                });
            }
            if (vm.pageView == "calendar") {
                //日历
                MonthWidget.byCondition(
                    {
                        items: items,
                        page: vm.pageInfo.page - 1,
                        size: vm.pageInfo.size,
                        sort: ["lastModifiedDate,desc"],
                    },
                    onSuccess,
                    onError
                );
            } else if (vm.pageView == "calendarTitle") {
                TitleWidget.byCondition(
                    {
                        items: items,
                        page: vm.pageInfo.page - 1,
                        size: vm.pageInfo.size,
                        sort: ["lastModifiedDate,desc"],
                    },
                    onSuccess,
                    onError
                );
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers("link"));
                vm.pageInfo.total = headers("X-Total-Count");
                vm.textList = data;
                //退出编辑模式
                vm.batchState = false;
                vm.selectCount = 0;
            }

            function onError(error) {
                MessageService.error("文字模板获取失败");
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + "," + (vm.reverse ? "asc" : "desc"),
                search: vm.currentSearch,
                type:vm.pageView
            });
        }
        //状态点击
        $scope.statusCheck = function (e) {
            if (e === vm.selectStatus) return;
            vm.selectStatus = e;
            vm.pageInfo.page = 1;
            vm.loadAll();
        };
        function search() {
            if(event.keyCode === 13){
                vm.links = null;
                vm.pageInfo.page = 1;
                vm.predicate = "id";
                vm.reverse = false;
                vm.loadAll();
            }
        }
        function jump() {
            vm.page = vm.jumpText <= 0 ? 1 : vm.jumpText;
            loadPage(vm.page);
        }

        $scope.release = function (data) {
            MonthWidget.get({ id: data.id }, function (res) {
                $uibModal
                    .open({
                        templateUrl:
                            "app/entities/text/modal/text-detection.html",
                        controller: "TextDetectionController",
                        controllerAs: "vm",
                        size: "lg",
                        resolve: {
                            entity: [
                                function () {
                                    return {
                                        textDocument: res.textDocument,
                                        id: res.id,
                                        storeIds: [],
                                    };
                                },
                            ],
                        },
                    })
                    .result.then(function (isReturn) {});
            });

            // MonthWidget.onlyRelease({id: data.id}, function (res) {
            //     MessageService.success("发布成功");
            //     loadAll();
            // }, function (error) {
            //     MessageService.error("发布失败，请稍后重试！");
            // })
        };
        //分类切换
        $scope.selectGenre = function (e) {
            if (vm.pageView === e.value) return;
            vm.pageView = e.value;
            vm.pageInfo.page = 1;
            //vm.loadAll();
            transition();
        };
        //查看驳回原因
        $scope.showReason = function (item) {
            MessageService.confirm({
                title:'驳回理由',
                cancel:'取消',
                hideCancel:true,
                confirm:'知道了',
                msg:'理由： '+ (item.rejectReason || '') ,
            },function(){

            })
        }
        //分享
        $scope.share = function (data) {
            if (vm.pageView == "calendar") {
                MonthWidget.share({ id: data.id }, function (res) {
                    MessageService.success("分享成功");
                    loadAll();
                });
            } else if (vm.pageView == "calendarTitle") {
                TitleWidget.share({ id: data.id }, function (res) {
                    MessageService.success("分享成功");
                    loadAll();
                });
            }
        };
        //批量分享
        $scope.batchShare = function() {
            if (vm.batchShareLoading) return;
            //获取选中的
            var selectList = vm.textList.filter(function (item) {
                return item.selected === true ;
            })
            if(selectList.length === 0 ) return MessageService.error("至少选择一条数据");
            //过滤掉已分享的数据
            selectList = selectList.filter(function (item) {
                return item.status !== 'Approved';
            });
            var ids = selectList.map(function (item) {
                return item.id;
            });
            vm.batchShareLoading = true;
            if (ids.length > 0){
                if(vm.pageView === 'calendar'){
                    MonthWidget.batchShare(ids,function(){
                        MessageService.success("分享成功");
                        vm.batchShareLoading = false;
                        vm.loadAll();
                    },function(){
                        MessageService.error("网络异常，请重试");
                        vm.batchShareLoading = false;
                    })
                }else if(vm.pageView === 'calendarTitle'){
                    TitleWidget.batchShare(ids,function(){
                        MessageService.success("分享成功");
                        vm.batchShareLoading = false;
                        vm.loadAll();
                    },function(){
                        MessageService.error("网络异常，请重试");
                        vm.batchShareLoading = false;
                    })
                }

            }else{
                vm.batchShareLoading = false;
                vm.loadAll();
            }
        }
        //查看
        $scope.look = function (data) {
            if(vm.pageView == "calendar" && !data.previewUrl){
                return MessageService.error("暂无预览图");
            }
            $uibModal.open({
                templateUrl: "app/entities/text/modal/text-xml-look.html",
                controller: "TextXmlLookController",
                controllerAs: "vm",
                backdrop: "static",
                resolve: {
                    entity: [
                        function () {
                            return {
                                url: data.previewUrl,
                                domain: $scope.domains.domain,
                            };
                        },
                    ],
                },
            });

        };
        //新增
        $scope.add = function (type) {
            if(type == "calendar"){
                $uibModal.open({
                    templateUrl: "app/entities/calendar/modal/calendar-add.html",
                    controller: "CalendarAddController",
                    controllerAs: "vm",
                    backdrop: "static",
                    size:'lg',
                    resolve: {
                        entity: [
                            function () {
                                return null;
                            },
                        ],
                    },
                }).result.then(function() {
                    loadAll();
                });;
            }else if(type == "calendarTitle"){
                $uibModal.open({
                    templateUrl: 'app/entities/calendar/modal/calendar-title-add.html',
                    controller: 'CalendarTitleAddController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size:'lg',
                    resolve: {
                        entity: [function() {
                            return null;
                        }]
                    }
                }).result.then(function(res) {
                    if (res) {
                        loadAll();
                    }
                });
            }

        };
        //复制
        $scope.copy = function (item) {
            var _data = angular.copy(item);
            _data.name = _data.name + "_副本";
            if (vm.pageView == "calendar") {
                $uibModal.open({
                    templateUrl:
                        "app/entities/calendar/modal/calendar-add.html",
                    controller: "CalendarAddController",
                    controllerAs: "vm",
                    backdrop: "static",
                    size:'lg',
                    resolve: {
                        entity: [
                            function () {
                                return _data;
                            },
                        ],
                    },
                });
            } else if (vm.pageView == "calendarTitle") {
                $uibModal.open({
                    templateUrl:
                        "app/entities/calendar/modal/calendar-title-add.html",
                    controller: "CalendarTitleAddController",
                    controllerAs: "vm",
                    backdrop: "static",
                    size:'lg',
                    resolve: {
                        entity: [
                            function () {
                                return _data;
                            },
                        ],
                    },
                });
            }
        };

        function status(item) {
            switch (item) {
                case "Created":
                    return "已分享";
                    break;
                case "Approved":
                    return "已通过";
                    break;
                case "Rejected":
                    return "已拒绝";
                    break;
                default:
                    return "未分享";
            }
        }
    }
})();

(function(){
	'use strict';
	angular
	.module('platformApp')
	.factory('UidService',UidService);

    UidService.$inject = [];

    function UidService(){
        var service={
            get:get
        }
        return service;
    }
    function get(){
        var d = new Date().getTime();
        var uid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
            var r = (d + Math.random() * 16) % 16 | 0;
            d = Math.floor(d / 16);
            return (c == 'x' ? r : (r & 0x7 | 0x8)).toString(16);
        });
        return uid;
    }

})();

(function() {
    'use strict';

    angular
        .module('platformApp')
        .filter('words', words);

    function words() {
        return wordsFilter;

        function wordsFilter(input, words) {
            if (isNaN(words)) {
                return input;
            }
            if (words <= 0) {
                return '';
            }
            if (input) {
                var inputWords = input.split(/\s+/);
                if (inputWords.length > words) {
                    input = inputWords.slice(0, words).join(' ') + '...';
                }
            }
            return input;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('platformApp')
        .filter('characters', characters);

    function characters () {
        return charactersFilter;

        function charactersFilter(input, chars, breakOnWord) {
            if (isNaN(chars)) {
                return input;
            }
            if (chars <= 0) {
                return '';
            }
            if (input && input.length > chars) {
                input = input.substring(0, chars);

                if (!breakOnWord) {
                    var lastspace = input.lastIndexOf(' ');
                    // Get last space
                    if (lastspace !== -1) {
                        input = input.substr(0, lastspace);
                    }
                } else {
                    while (input.charAt(input.length-1) === ' ') {
                        input = input.substr(0, input.length - 1);
                    }
                }
                return input + '...';
            }
            return input;
        }
    }
})();

(function() {
    /*jshint bitwise: false*/
    'use strict';

    angular
        .module('platformApp')
        .factory('TextUtilService', TextUtilService);

    function TextUtilService () {
        var NO_PRINTABLES = [
            '\x01',     // SOH
            '\x02',     // STX
            '\x03',     // ETX
            '\x04',     // EOT
            '\x05',     // ENQ
            '\x06',     // ACK
            '\x07',     // BEL
            '\x08',     // BS
            // '\x09',     // HT | Tab
            // '\x0A',     // LF
            '\x0B',     // VT
            '\x0C',     // FF
            // '\x0D',     // CR
            '\x0E',     // SO
            '\x0F',     // SI
            '\x10',     // DLE
            '\x11',     // DC1
            '\x12',     // DC2
            '\x13',     // DC3
            '\x14',     // DC4
            '\x15',     // NAK
            '\x16',     // SYN
            '\x17',     // ETB
            '\x18',     // CAN
            '\x19',     // EM
            '\x1A',     // SUB
            '\x1B',     // ESC
            '\x1C',     // FS
            '\x1D',     // GS
            '\x1E',     // RS
            '\x1F',     // US
        ];

        var service = {
            escapeNoPrintables: escapeNoPrintables
        };

        return service;

        function toHex(num) {
            if (!num) {
                return undefined;
            }
            return num.toString(16).padStart(2, '0');
        }

        

        function escapeNoPrintables(text) {
            if (!text) {
                return text;
            }
            var result = text;
            try {
                for (var i = 0; i < NO_PRINTABLES.length; i++) {
                    var ch = NO_PRINTABLES[i];
                    if (result.indexOf(ch) != -1) {
                        result = result.replaceAll(ch, '');
                    }
                }
            }
            catch (error) {
                console.log("Error to escapeNoPrintables", error);
                result = text;
            }
            return result;
        }

    }
})();
// stats.js - http://github.com/mrdoob/stats.js
var Stats = function() {
    function h(a) {
        c.appendChild(a.dom);
        return a
    }
    function k(a) {
        for (var d = 0; d < c.children.length; d++)
            c.children[d].style.display = d === a ? "block" : "none";
        l = a
    }
    var l = 0
        , c = document.createElement("div");
    c.style.cssText = "position:fixed;top:0;left:0;cursor:pointer;opacity:0.9;z-index:10000";
    c.addEventListener("click", function(a) {
        a.preventDefault();
        k(++l % c.children.length)
    }, !1);
    var g = (performance || Date).now()
        , e = g
        , a = 0
        , r = h(new Stats.Panel("FPS","#0ff","#002"))
        , f = h(new Stats.Panel("MS","#0f0","#020"));
    if (self.performance && self.performance.memory)
        var t = h(new Stats.Panel("MB","#f08","#201"));
    k(0);
    return {
        REVISION: 16,
        dom: c,
        addPanel: h,
        showPanel: k,
        begin: function() {
            g = (performance || Date).now()
        },
        end: function() {
            a++;
            var c = (performance || Date).now();
            f.update(c - g, 200);
            if (c > e + 1E3 && (r.update(1E3 * a / (c - e), 100),
                e = c,
                a = 0,
                t)) {
                var d = performance.memory;
                t.update(d.usedJSHeapSize / 1048576, d.jsHeapSizeLimit / 1048576)
            }
            return c
        },
        update: function() {
            g = this.end()
        },
        domElement: c,
        setMode: k
    }
};
Stats.Panel = function(h, k, l) {
    var c = Infinity
        , g = 0
        , e = Math.round
        , a = e(window.devicePixelRatio || 1)
        , r = 80 * a
        , f = 48 * a
        , t = 3 * a
        , u = 2 * a
        , d = 3 * a
        , m = 15 * a
        , n = 74 * a
        , p = 30 * a
        , q = document.createElement("canvas");
    q.width = r;
    q.height = f;
    q.style.cssText = "width:80px;height:48px";
    var b = q.getContext("2d");
    b.font = "bold " + 9 * a + "px Helvetica,Arial,sans-serif";
    b.textBaseline = "top";
    b.fillStyle = l;
    b.fillRect(0, 0, r, f);
    b.fillStyle = k;
    b.fillText(h, t, u);
    b.fillRect(d, m, n, p);
    b.fillStyle = l;
    b.globalAlpha = .9;
    b.fillRect(d, m, n, p);
    return {
        dom: q,
        update: function(f, v) {
            c = Math.min(c, f);
            g = Math.max(g, f);
            b.fillStyle = l;
            b.globalAlpha = 1;
            b.fillRect(0, 0, r, m);
            b.fillStyle = k;
            b.fillText(e(f) + " " + h + " (" + e(c) + "-" + e(g) + ")", t, u);
            b.drawImage(q, d + a, m, n - a, p, d, m, n - a, p);
            b.fillRect(d + n - a, m, a, p);
            b.fillStyle = l;
            b.globalAlpha = .9;
            b.fillRect(d + n - a, m, a, e((1 - f / v) * p))
        }
    }
}
;
"object" === typeof module && (module.exports = Stats);

/*
 jQuery UI Sortable plugin wrapper

 @param [ui-sortable] {object} Options to pass to $.fn.sortable() merged onto ui.config
 */
angular.module('ui.sortable', [])
  .value('uiSortableConfig', {
    // the default for jquery-ui sortable is "> *", we need to restrict this to
    // ng-repeat items
    // if the user uses
    items: '> [ng-repeat],> [data-ng-repeat],> [x-ng-repeat]'
  })
  .directive('uiSortable', [
    'uiSortableConfig',
    '$timeout',
    '$log',
    function(uiSortableConfig, $timeout, $log) {
      return {
        require: '?ngModel',
        scope: {
          ngModel: '=',
          uiSortable: '=',
          ////Expression bindings from html.
          create: '&uiSortableCreate',
          // helper:'&uiSortableHelper',
          start: '&uiSortableStart',
          activate: '&uiSortableActivate',
          // sort:'&uiSortableSort',
          // change:'&uiSortableChange',
          // over:'&uiSortableOver',
          // out:'&uiSortableOut',
          beforeStop: '&uiSortableBeforeStop',
          update: '&uiSortableUpdate',
          remove: '&uiSortableRemove',
          receive: '&uiSortableReceive',
          deactivate: '&uiSortableDeactivate',
          stop: '&uiSortableStop'
        },
        link: function(scope, element, attrs, ngModel) {
          var savedNodes;
          var helper;

          function combineCallbacks(first, second) {
            var firstIsFunc = typeof first === 'function';
            var secondIsFunc = typeof second === 'function';
            if (firstIsFunc && secondIsFunc) {
              return function() {
                first.apply(this, arguments);
                second.apply(this, arguments);
              };
            } else if (secondIsFunc) {
              return second;
            }
            return first;
          }

          function getSortableWidgetInstance(element) {
            // this is a fix to support jquery-ui prior to v1.11.x
            // otherwise we should be using `element.sortable('instance')`
            var data = element.data('ui-sortable');
            if (
              data &&
              typeof data === 'object' &&
              data.widgetFullName === 'ui-sortable'
            ) {
              return data;
            }
            return null;
          }

          function setItemChildrenWidth(item) {
            item.children().each(function() {
              var $el = angular.element(this);

              // Preserve the with of the element
              $el.width($el.width());
            });
          }

          function dummyHelper(e, item) {
            return item;
          }

          function patchSortableOption(key, value) {
            if (callbacks[key]) {
              if (key === 'stop') {
                // call apply after stop
                value = combineCallbacks(value, function() {
                  scope.$apply();
                });

                value = combineCallbacks(value, afterStop);
              }
              // wrap the callback
              value = combineCallbacks(callbacks[key], value);
            } else if (wrappers[key]) {
              value = wrappers[key](value);
            }

            // patch the options that need to have values set
            if (!value && (key === 'items' || key === 'ui-model-items')) {
              value = uiSortableConfig.items;
            }

            return value;
          }

          function patchUISortableOptions(
            newOpts,
            oldOpts,
            sortableWidgetInstance
          ) {
            function addDummyOptionKey(value, key) {
              if (!(key in opts)) {
                // add the key in the opts object so that
                // the patch function detects and handles it
                opts[key] = null;
              }
            }
            // for this directive to work we have to attach some callbacks
            angular.forEach(callbacks, addDummyOptionKey);

            // only initialize it in case we have to
            // update some options of the sortable
            var optsDiff = null;

            if (oldOpts) {
              // reset deleted options to default
              var defaultOptions;
              angular.forEach(oldOpts, function(oldValue, key) {
                if (!newOpts || !(key in newOpts)) {
                  if (key in directiveOpts) {
                    if (key === 'ui-floating') {
                      opts[key] = 'auto';
                    } else {
                      opts[key] = patchSortableOption(key, undefined);
                    }
                    return;
                  }

                  if (!defaultOptions) {
                    defaultOptions = angular.element.ui.sortable().options;
                  }
                  var defaultValue = defaultOptions[key];
                  defaultValue = patchSortableOption(key, defaultValue);

                  if (!optsDiff) {
                    optsDiff = {};
                  }
                  optsDiff[key] = defaultValue;
                  opts[key] = defaultValue;
                }
              });
            }

            newOpts = angular.extend({}, newOpts);
            // update changed options
            // handle the custom option of the directive first
            angular.forEach(newOpts, function(value, key) {
              if (key in directiveOpts) {
                if (
                  key === 'ui-floating' &&
                  (value === false || value === true) &&
                  sortableWidgetInstance
                ) {
                  sortableWidgetInstance.floating = value;
                }

                if (
                  key === 'ui-preserve-size' &&
                  (value === false || value === true)
                ) {
                  var userProvidedHelper = opts.helper;
                  newOpts.helper = function(e, item) {
                    if (opts['ui-preserve-size'] === true) {
                      setItemChildrenWidth(item);
                    }
                    return (userProvidedHelper || dummyHelper).apply(
                      this,
                      arguments
                    );
                  };
                }

                opts[key] = patchSortableOption(key, value);
              }
            });

            // handle the normal option of the directive
            angular.forEach(newOpts, function(value, key) {
              if (key in directiveOpts) {
                // the custom option of the directive are already handled
                return;
              }

              value = patchSortableOption(key, value);

              if (!optsDiff) {
                optsDiff = {};
              }
              optsDiff[key] = value;
              opts[key] = value;
            });

            return optsDiff;
          }

          function getPlaceholderElement(element) {
            var placeholder = element.sortable('option', 'placeholder');

            // placeholder.element will be a function if the placeholder, has
            // been created (placeholder will be an object).  If it hasn't
            // been created, either placeholder will be false if no
            // placeholder class was given or placeholder.element will be
            // undefined if a class was given (placeholder will be a string)
            if (
              placeholder &&
              placeholder.element &&
              typeof placeholder.element === 'function'
            ) {
              var result = placeholder.element();
              // workaround for jquery ui 1.9.x,
              // not returning jquery collection
              result = angular.element(result);
              return result;
            }
            return null;
          }

          function getPlaceholderExcludesludes(element, placeholder) {
            // exact match with the placeholder's class attribute to handle
            // the case that multiple connected sortables exist and
            // the placeholder option equals the class of sortable items
            var notCssSelector = opts['ui-model-items'].replace(/[^,]*>/g, '');
            var excludes = element.find(
              '[class="' +
                placeholder.attr('class') +
                '"]:not(' +
                notCssSelector +
                ')'
            );
            return excludes;
          }

          function hasSortingHelper(element, ui) {
            var helperOption = element.sortable('option', 'helper');
            return (
              helperOption === 'clone' ||
              (typeof helperOption === 'function' &&
                ui.item.sortable.isCustomHelperUsed())
            );
          }

          function getSortingHelper(element, ui /*, savedNodes*/) {
            var result = null;
            if (
              hasSortingHelper(element, ui) &&
              element.sortable('option', 'appendTo') === 'parent'
            ) {
              // The .ui-sortable-helper element (that's the default class name)
              result = helper;
            }
            return result;
          }

          // thanks jquery-ui
          function isFloating(item) {
            return (
              /left|right/.test(item.css('float')) ||
              /inline|table-cell/.test(item.css('display'))
            );
          }

          function getElementContext(elementScopes, element) {
            for (var i = 0; i < elementScopes.length; i++) {
              var c = elementScopes[i];
              if (c.element[0] === element[0]) {
                return c;
              }
            }
          }

          function afterStop(e, ui) {
            ui.item.sortable._destroy();
          }

          // return the index of ui.item among the items
          // we can't just do ui.item.index() because there it might have siblings
          // which are not items
          function getItemIndex(item) {
            return item
              .parent()
              .find(opts['ui-model-items'])
              .index(item);
          }

          var opts = {};

          // directive specific options
          var directiveOpts = {
            'ui-floating': undefined,
            'ui-model-items': uiSortableConfig.items,
            'ui-preserve-size': undefined
          };

          var callbacks = {
            create: null,
            start: null,
            activate: null,
            // sort: null,
            // change: null,
            // over: null,
            // out: null,
            beforeStop: null,
            update: null,
            remove: null,
            receive: null,
            deactivate: null,
            stop: null
          };

          var wrappers = {
            helper: null
          };

          angular.extend(
            opts,
            directiveOpts,
            uiSortableConfig,
            scope.uiSortable
          );

          if (!angular.element.fn || !angular.element.fn.jquery) {
            $log.error(
              'ui.sortable: jQuery should be included before AngularJS!'
            );
            return;
          }

          function wireUp() {
            // When we add or remove elements, we need the sortable to 'refresh'
            // so it can find the new/removed elements.
            scope.$watchCollection('ngModel', function() {
              // Timeout to let ng-repeat modify the DOM
              $timeout(
                function() {
                  // ensure that the jquery-ui-sortable widget instance
                  // is still bound to the directive's element
                  if (!!getSortableWidgetInstance(element)) {
                    element.sortable('refresh');
                  }
                },
                0,
                false
              );
            });

            callbacks.start = function(e, ui) {
              if (opts['ui-floating'] === 'auto') {
                // since the drag has started, the element will be
                // absolutely positioned, so we check its siblings
                var siblings = ui.item.siblings();
                var sortableWidgetInstance = getSortableWidgetInstance(
                  angular.element(e.target)
                );
                sortableWidgetInstance.floating = isFloating(siblings);
              }

              // Save the starting position of dragged item
              var index = getItemIndex(ui.item);
              ui.item.sortable = {
                model: ngModel.$modelValue[index],
                index: index,
                source: element,
                sourceList: ui.item.parent(),
                sourceModel: ngModel.$modelValue,
                cancel: function() {
                  ui.item.sortable._isCanceled = true;
                },
                isCanceled: function() {
                  return ui.item.sortable._isCanceled;
                },
                isCustomHelperUsed: function() {
                  return !!ui.item.sortable._isCustomHelperUsed;
                },
                _isCanceled: false,
                _isCustomHelperUsed: ui.item.sortable._isCustomHelperUsed,
                _destroy: function() {
                  angular.forEach(ui.item.sortable, function(value, key) {
                    ui.item.sortable[key] = undefined;
                  });
                },
                _connectedSortables: [],
                _getElementContext: function(element) {
                  return getElementContext(this._connectedSortables, element);
                }
              };
            };

            callbacks.activate = function(e, ui) {
              var isSourceContext = ui.item.sortable.source === element;
              var savedNodesOrigin = isSourceContext
                ? ui.item.sortable.sourceList
                : element;
              var elementContext = {
                element: element,
                scope: scope,
                isSourceContext: isSourceContext,
                savedNodesOrigin: savedNodesOrigin
              };
              // save the directive's scope so that it is accessible from ui.item.sortable
              ui.item.sortable._connectedSortables.push(elementContext);

              // We need to make a copy of the current element's contents so
              // we can restore it after sortable has messed it up.
              // This is inside activate (instead of start) in order to save
              // both lists when dragging between connected lists.
              savedNodes = savedNodesOrigin.contents();
              helper = ui.helper;

              // If this list has a placeholder (the connected lists won't),
              // don't inlcude it in saved nodes.
              var placeholder = getPlaceholderElement(element);
              if (placeholder && placeholder.length) {
                var excludes = getPlaceholderExcludesludes(
                  element,
                  placeholder
                );
                savedNodes = savedNodes.not(excludes);
              }
            };

            callbacks.update = function(e, ui) {
              // Save current drop position but only if this is not a second
              // update that happens when moving between lists because then
              // the value will be overwritten with the old value
              if (!ui.item.sortable.received) {
                ui.item.sortable.dropindex = getItemIndex(ui.item);
                var droptarget = ui.item
                  .parent()
                  .closest(
                    '[ui-sortable], [data-ui-sortable], [x-ui-sortable]'
                  );
                ui.item.sortable.droptarget = droptarget;
                ui.item.sortable.droptargetList = ui.item.parent();

                var droptargetContext = ui.item.sortable._getElementContext(
                  droptarget
                );
                ui.item.sortable.droptargetModel =
                  droptargetContext.scope.ngModel;

                // Cancel the sort (let ng-repeat do the sort for us)
                // Don't cancel if this is the received list because it has
                // already been canceled in the other list, and trying to cancel
                // here will mess up the DOM.
                element.sortable('cancel');
              }

              // Put the nodes back exactly the way they started (this is very
              // important because ng-repeat uses comment elements to delineate
              // the start and stop of repeat sections and sortable doesn't
              // respect their order (even if we cancel, the order of the
              // comments are still messed up).
              var sortingHelper =
                !ui.item.sortable.received &&
                getSortingHelper(element, ui, savedNodes);
              if (sortingHelper && sortingHelper.length) {
                // Restore all the savedNodes except from the sorting helper element.
                // That way it will be garbage collected.
                savedNodes = savedNodes.not(sortingHelper);
              }
              var elementContext = ui.item.sortable._getElementContext(element);
              savedNodes.appendTo(elementContext.savedNodesOrigin);

              // If this is the target connected list then
              // it's safe to clear the restored nodes since:
              // update is currently running and
              // stop is not called for the target list.
              if (ui.item.sortable.received) {
                savedNodes = null;
              }

              // If received is true (an item was dropped in from another list)
              // then we add the new item to this list otherwise wait until the
              // stop event where we will know if it was a sort or item was
              // moved here from another list
              if (ui.item.sortable.received && !ui.item.sortable.isCanceled()) {
                scope.$apply(function() {
                  ngModel.$modelValue.splice(
                    ui.item.sortable.dropindex,
                    0,
                    ui.item.sortable.moved
                  );
                });
                scope.$emit('ui-sortable:moved', ui);
              }
            };

            callbacks.stop = function(e, ui) {
              // If the received flag hasn't be set on the item, this is a
              // normal sort, if dropindex is set, the item was moved, so move
              // the items in the list.
              var wasMoved =
                'dropindex' in ui.item.sortable &&
                !ui.item.sortable.isCanceled();

              if (wasMoved && !ui.item.sortable.received) {
                scope.$apply(function() {
                  ngModel.$modelValue.splice(
                    ui.item.sortable.dropindex,
                    0,
                    ngModel.$modelValue.splice(ui.item.sortable.index, 1)[0]
                  );
                });
                scope.$emit('ui-sortable:moved', ui);
              } else if (
                !wasMoved &&
                !angular.equals(
                  element.contents().toArray(),
                  savedNodes.toArray()
                )
              ) {
                // if the item was not moved
                // and the DOM element order has changed,
                // then restore the elements
                // so that the ngRepeat's comment are correct.

                var sortingHelper = getSortingHelper(element, ui, savedNodes);
                if (sortingHelper && sortingHelper.length) {
                  // Restore all the savedNodes except from the sorting helper element.
                  // That way it will be garbage collected.
                  savedNodes = savedNodes.not(sortingHelper);
                }
                var elementContext = ui.item.sortable._getElementContext(
                  element
                );
                savedNodes.appendTo(elementContext.savedNodesOrigin);
              }

              // It's now safe to clear the savedNodes and helper
              // since stop is the last callback.
              savedNodes = null;
              helper = null;
            };

            callbacks.receive = function(e, ui) {
              // An item was dropped here from another list, set a flag on the
              // item.
              ui.item.sortable.received = true;
            };

            callbacks.remove = function(e, ui) {
              // Workaround for a problem observed in nested connected lists.
              // There should be an 'update' event before 'remove' when moving
              // elements. If the event did not fire, cancel sorting.
              if (!('dropindex' in ui.item.sortable)) {
                element.sortable('cancel');
                ui.item.sortable.cancel();
              }

              // Remove the item from this list's model and copy data into item,
              // so the next list can retrive it
              if (!ui.item.sortable.isCanceled()) {
                scope.$apply(function() {
                  ui.item.sortable.moved = ngModel.$modelValue.splice(
                    ui.item.sortable.index,
                    1
                  )[0];
                });
              }
            };

            // setup attribute handlers
            angular.forEach(callbacks, function(value, key) {
              callbacks[key] = combineCallbacks(callbacks[key], function() {
                var attrHandler = scope[key];
                var attrHandlerFn;
                if (
                  typeof attrHandler === 'function' &&
                  (
                    'uiSortable' +
                    key.substring(0, 1).toUpperCase() +
                    key.substring(1)
                  ).length &&
                  typeof (attrHandlerFn = attrHandler()) === 'function'
                ) {
                  attrHandlerFn.apply(this, arguments);
                }
              });
            });

            wrappers.helper = function(inner) {
              if (inner && typeof inner === 'function') {
                return function(e, item) {
                  var oldItemSortable = item.sortable;
                  var index = getItemIndex(item);

                  item.sortable = {
                    model: ngModel.$modelValue[index],
                    index: index,
                    source: element,
                    sourceList: item.parent(),
                    sourceModel: ngModel.$modelValue,
                    _restore: function() {
                      angular.forEach(item.sortable, function(value, key) {
                        item.sortable[key] = undefined;
                      });

                      item.sortable = oldItemSortable;
                    }
                  };

                  var innerResult = inner.apply(this, arguments);
                  item.sortable._restore();
                  item.sortable._isCustomHelperUsed = item !== innerResult;
                  return innerResult;
                };
              }
              return inner;
            };

            scope.$watchCollection(
              'uiSortable',
              function(newOpts, oldOpts) {
                // ensure that the jquery-ui-sortable widget instance
                // is still bound to the directive's element
                var sortableWidgetInstance = getSortableWidgetInstance(element);
                if (!!sortableWidgetInstance) {
                  var optsDiff = patchUISortableOptions(
                    newOpts,
                    oldOpts,
                    sortableWidgetInstance
                  );

                  if (optsDiff) {
                    element.sortable('option', optsDiff);
                  }
                }
              },
              true
            );

            patchUISortableOptions(opts);
          }

          function init() {
            if (ngModel) {
              wireUp();
            } else {
              $log.info('ui.sortable: ngModel not provided!', element);
            }

            // Create sortable
            element.sortable(opts);
          }

          function initIfEnabled() {
            if (scope.uiSortable && scope.uiSortable.disabled) {
              return false;
            }

            init();

            // Stop Watcher
            initIfEnabled.cancelWatcher();
            initIfEnabled.cancelWatcher = angular.noop;

            return true;
          }

          initIfEnabled.cancelWatcher = angular.noop;

          if (!initIfEnabled()) {
            initIfEnabled.cancelWatcher = scope.$watch(
              'uiSortable.disabled',
              initIfEnabled
            );
          }
        }
      };
    }
  ]);

(function() {
    'use strict';

    angular
        .module('platformApp')
        .directive('jhSortBy', jhSortBy);

    function jhSortBy() {
        var directive = {
            restrict: 'A',
            scope: false,
            require: '^jhSort',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs, parentCtrl) {
            element.bind('click', function () {
                parentCtrl.sort(attrs.jhSortBy);
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('platformApp')
        .directive('jhSort', jhSort);

    function jhSort () {
        var directive = {
            restrict: 'A',
            scope: {
                predicate: '=jhSort',
                ascending: '=',
                callback: '&'
            },
            controller: SortController,
            controllerAs: 'vm',
            bindToController: true
        };

        return directive;
    }

    SortController.$inject = ['$scope', '$element'];

    function SortController ($scope, $element) {
        var vm = this;

        vm.applyClass = applyClass;
        vm.resetClasses = resetClasses;
        vm.sort = sort;
        vm.triggerApply = triggerApply;

        $scope.$watchGroup(['vm.predicate', 'vm.ascending'], vm.triggerApply);
        vm.triggerApply();

        function applyClass (element) {
            var thisIcon = element.find('span.glyphicon'),
                sortIcon = 'glyphicon-sort',
                sortAsc = 'glyphicon-sort-by-attributes',
                sortDesc = 'glyphicon-sort-by-attributes-alt',
                remove = sortIcon + ' ' + sortDesc,
                add = sortAsc;
            if (!vm.ascending) {
                remove = sortIcon + ' ' + sortAsc;
                add = sortDesc;
            }
            vm.resetClasses();
            thisIcon.removeClass(remove);
            thisIcon.addClass(add);
        }

        function resetClasses () {
            var allThIcons = $element.find('span.glyphicon'),
                sortIcon = 'glyphicon-sort',
                sortAsc = 'glyphicon-sort-by-attributes',
                sortDesc = 'glyphicon-sort-by-attributes-alt';
            allThIcons.removeClass(sortAsc + ' ' + sortDesc);
            allThIcons.addClass(sortIcon);
        }

        function sort (field) {
            if (field !== vm.predicate) {
                vm.ascending = true;
            } else {
                vm.ascending = !vm.ascending;
            }
            vm.predicate = field;
            $scope.$apply();
            vm.callback();
        }

        function triggerApply (values)  {
            vm.resetClasses();
            if (values && values[0] !== '_score') {
                vm.applyClass($element.find('th[jh-sort-by=\'' + values[0] + '\']'));
            }
        }
    }
})();

function MeasureRuler(dParam){
    var param={
        wrapperId:"rulerWrapper",   //标尺ID
        max:1000,      //标尺最大刻度
        minUnit:1,     //标尺最小单位刻度
        unitSet:10,    //标尺单位单位刻度组
        min:0,         //最小值
        mult:1,         //标尺单位刻度的倍数 最小是1 即每一刻度占10px
        vertical:false, //是否垂直
        left:0,
        topOffset:0,
        click:function () {},
        yClick:function () {},
    }
    $.extend(param,dParam);

    var limitLeft=0;
    var scrollerWidth=0;
    var wrapperWidth=0;
    var pleft=0;
    var firstRand=true;
    var self=this;
    var fixedLen=param.minUnit.toString().split(".")[1]?param.minUnit.toString().split(".")[1].length:0;
    this.initRuler=function(){
        if(param.min>param.max) param.min=0
        var nhtml="";
        limitLeft=0;
        scrollerWidth=0;
        wrapperWidth=0;
        if(!param.vertical){
            $("#"+param.wrapperId).addClass("rulerWrapper")
            $("#"+param.wrapperId).append('<div class="rulerScroller"></div><div class="rulerPointer"></div>')
            var setLen=Math.ceil((param.max-param.min)/(param.unitSet*param.minUnit))+6;
            var setWidth=param.unitSet*10*param.mult;
            param.left = param.left-setWidth;
            for(var i=0;i<setLen;i++){
                nhtml+="<span class='sizeNo' style='left:"+(i*setWidth-setWidth/2)+"px;width:"+setWidth+"px'></span><ul  style='width:"+setWidth+"px'>";
                if(10*param.mult > 4) {
                    for (var j = 0; j < (param.unitSet - 1); j++) {
                        nhtml += "<li style='width:" + 10 * param.mult + "px'></li>";
                    }
                }
                nhtml+="<div class='rulerPointer-hr'></div></ul>";
            }
        }else{
            $("#"+param.wrapperId).addClass("rulerWrapper1")
            $("#"+param.wrapperId).append('<div class="rulerScroller"></div><div class="rulerPointer"></div>')
            var setLen=Math.ceil((param.max-param.min)/(param.unitSet*param.minUnit))+6;
            var setWidth=param.unitSet*10*param.mult;
            param.top = param.top-setWidth;
            for(var i=0;i<setLen;i++){
                nhtml+="<span class='sizeNo' style='top:"+(i*setWidth-setWidth/2)+"px;height:"+setWidth+"px'></span><ul  style='height:"+setWidth+"px'>";
                if(10*param.mult > 4){
                    for(var j=0;j<(param.unitSet-1);j++){
                        nhtml+="<li style='height:"+10*param.mult+"px'></li>";
                    }
                }
                nhtml+="<div class='rulerPointer-hr'></div></ul>";
            }
        }
        $("#"+param.wrapperId+" .rulerScroller").append(nhtml);
        var st;
        wrapperWidth=$("#"+param.wrapperId).width();
        scrollerWidth=setLen*10*param.unitSet*param.mult;

        // $("#"+param.wrapperId).on('touchstart',function(e){
        //     var touch = e.originalEvent.targetTouches[0];
        //     st = touch.pageX;
        // })

        // $("#"+param.wrapperId).on('touchmove',function(e){
        //     var touch = e.originalEvent.targetTouches[0];
        //     var x = touch.pageX;
        //     var lf=$("#"+param.wrapperId+" .rulerScroller").position().left;
        //     var nlf=lf+x-st;
        //
        //     //超过最左或者最右标尺不可滑动
        //     if(lf-50 > limitLeft || wrapperWidth-scrollerWidth>lf+50){
        //         return;
        //     }
        //     var pointerVal=Math.floor((limitLeft-nlf)/(10*param.mult))>0?Math.floor((limitLeft-nlf)/(10*param.mult)):0;
        //         pointerVal=param.minUnit*pointerVal+param.min;
        //
        //     if(fixedLen) pointerVal=pointerVal.toFixed(fixedLen);
        //     if(param.callback)  param.callback(pointerVal)
        //     $("#"+param.wrapperId+" .rulerScroller").css("left",nlf);
        //
        // })
        //
        // $("#"+param.wrapperId).on('touchend',function(e){
        //
        //     var lf=$("#"+param.wrapperId+" .rulerScroller").position().left;
        //     if(lf > limitLeft){
        //         $("#"+param.wrapperId+" .rulerScroller").css("left",limitLeft);
        //         if(param.callback) param.callback(param.min);
        //         return;
        //     }else if(wrapperWidth-scrollerWidth>lf){
        //         self.setValue(param.max);
        //         return;
        //     }
        //     var lf=$("#"+param.wrapperId+" .rulerScroller").position().left;
        //     var disNo=Math.round((lf-pleft)/(10*param.mult));
        //     var nDis=disNo*10*param.mult+pleft;
        //     $("#"+param.wrapperId+" .rulerScroller").css("left",nDis);
        //     var pointerVal=Math.floor((limitLeft-nDis)/(10*param.mult));
        //     pointerVal=param.minUnit*pointerVal+param.min;
        //     if(fixedLen) pointerVal=pointerVal.toFixed(fixedLen);
        //     if(param.callback)  param.callback(pointerVal)
        // })

        //中间标志的位置
        // if(firstRand){
        //     pleft=$("#"+param.wrapperId+" .rulerPointer").position().left;
        // }
        var rulerLNo=0;
        for(var z=1;z<setLen;z++){
            if(z*setWidth>pleft) {
                limitLeft=pleft-z*setWidth;
                rulerLNo=z;
                break;
            }
        }

        //标尺初始化数值
        this.setValue(param.value);

        //标尺刻度值
        $("#"+param.wrapperId+" .sizeNo").each(function(idx,ele){
            if(idx>=rulerLNo && idx<setLen-1){
                var iv=(idx-rulerLNo)*param.minUnit*param.unitSet+param.min;
                if(fixedLen) iv=iv.toFixed(fixedLen);
                $(ele).html(iv);
            }
        })
        //刻度尺鼠标移入事件
        $("#"+param.wrapperId).on('mousemove',function (e) {
            if(!param.vertical){
                $('.c-ruler-left').remove()
                var _value = (e.pageX - $(this).offset().left - param.left - param.unitSet*10*param.mult)/param.mult/10;
                var _li = '<span class="c-ruler-left" style="left:'+ (e.pageX - $(this).offset().left) +'px">'+Math.round(_value)+'</span>';
                $(this).append(_li);
            }else{
                $('.c-ruler-y').remove()
                var _value = (e.pageY - $(this).offset().top - param.top - param.unitSet*10*param.mult)/param.mult/10;
                var _li = '<span class="c-ruler-y" style="top:'+ (e.pageY - $(this).offset().top - 20) +'px">'+Math.round(_value)+'</span>';
                $(this).append(_li);
            }
        })
        $("#"+param.wrapperId).on('mouseleave',function (e) {
            $('.c-ruler-left').remove()
            $('.c-ruler-y').remove()
        })
        $("#"+param.wrapperId).on('click',function (e) {
            if(!param.vertical) {
                param.click((e.pageX - $(this).offset().left - param.left - param.unitSet * 10 * param.mult))
            }else{
                param.yClick((e.pageY - $(this).offset().top - param.top - param.unitSet * 10 * param.mult))
            }
        })
    }
    this.setValue=function(val){
        var nval=val?val:param.min;
        if(nval>param.max) nval=param.max;
        if(nval<param.min) nval=param.min;

        var nlval=nval-param.min;

        if(!param.vertical){
            $("#"+param.wrapperId+" .rulerScroller").css("left",param.left);
        }else{
            $("#"+param.wrapperId+" .rulerScroller").css("top",param.top);
        }
         if(param.callback)  param.callback(nval)
    };

    this.reDrawRuler=function(nParam){
        nParam.value=nParam.value?nParam.value:0;
        firstRand=false;
        if(nParam){
            $.extend(param,nParam)
        }

        fixedLen=param.minUnit.toString().split(".")[1]?param.minUnit.toString().split(".")[1].length:0;
        $("#"+param.wrapperId).html("");
        $("#"+param.wrapperId).unbind('touchstart');
        $("#"+param.wrapperId).unbind('touchend');
        $("#"+param.wrapperId).unbind('touchmove');
        this.initRuler();
    };

    this.initRuler();

}

(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else {
		var a = factory();
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1);


/***/ },
/* 1 */
/***/ function(module, exports, __webpack_require__) {

	// Generated by CoffeeScript 1.11.1
	(function() {
	  var File, Header, Image, LayerMask, LazyExecute, Module, PSD, RSVP, Resources,
	    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
	    hasProp = {}.hasOwnProperty;
	
	  RSVP = __webpack_require__(2);
	
	  Module = __webpack_require__(6).Module;
	
	  File = __webpack_require__(8);
	
	  LazyExecute = __webpack_require__(58);
	
	  Header = __webpack_require__(59);
	
	  Resources = __webpack_require__(60);
	
	  LayerMask = __webpack_require__(76);
	
	  Image = __webpack_require__(114);

	  console.log('Trying to export PSD ...')
	
	  module.exports = PSD = (function(superClass) {
	    extend(PSD, superClass);
		console.log('In PSD ...', superClass);
	    PSD.Node2 = {
	      Root: __webpack_require__(130)
	    };
	
	    PSD["extends"](__webpack_require__(137));
	
	    function PSD(data) {
	      this.file = new File(data);
	      this.parsed = false;
	      this.header = null;
	      Object.defineProperty(this, 'layers', {
	        get: function() {
	          return this.layerMask.layers;
	        }
	      });
	      RSVP.on('error', function(reason) {
	        return console.error(reason);
	      });
	    }
	
	    PSD.prototype.parse = function() {
	      if (this.parsed) {
	        return;
	      }
	      this.parseHeader();
	      this.parseResources();
	      this.parseLayerMask();
	      this.parseImage();
	      return this.parsed = true;
	    };
	
	    PSD.prototype.parseHeader = function() {
	      this.header = new Header(this.file);
	      return this.header.parse();
	    };
	
	    PSD.prototype.parseResources = function() {
	      var resources;
	      resources = new Resources(this.file);
	      return this.resources = new LazyExecute(resources, this.file).now('skip').later('parse').get();
	    };
	
	    PSD.prototype.parseLayerMask = function() {
	      var layerMask;
	      layerMask = new LayerMask(this.file, this.header);
	      return this.layerMask = new LazyExecute(layerMask, this.file).now('skip').later('parse').get();
	    };
	
	    PSD.prototype.parseImage = function() {
	      var image;
	      image = new Image(this.file, this.header);
	      return this.image = new LazyExecute(image, this.file).later('parse').ignore('width', 'height').get();
	    };
	
	    PSD.prototype.tree = function() {
	      return new PSD.Node2.Root(this);
	    };
	
	    return PSD;
	
	  })(Module);

	  window.PSD = PSD;
	
	}).call(this);


/***/ },
/* 2 */
/***/ function(module, exports, __webpack_require__) {

	var require;/* WEBPACK VAR INJECTION */(function(process, setImmediate, global) {/*!
	 * @overview RSVP - a tiny implementation of Promises/A+.
	 * @copyright Copyright (c) 2016 Yehuda Katz, Tom Dale, Stefan Penner and contributors
	 * @license   Licensed under MIT license
	 *            See https://raw.githubusercontent.com/tildeio/rsvp.js/master/LICENSE
	 * @version   3.6.2
	 */
	
	(function (global, factory) {
		 true ? factory(exports) :
		typeof define === 'function' && define.amd ? define(['exports'], factory) :
		(factory((global.RSVP = global.RSVP || {})));
	}(this, (function (exports) { 'use strict';
	
	function indexOf(callbacks, callback) {
	  for (var i = 0, l = callbacks.length; i < l; i++) {
	    if (callbacks[i] === callback) {
	      return i;
	    }
	  }
	
	  return -1;
	}
	
	function callbacksFor(object) {
	  var callbacks = object._promiseCallbacks;
	
	  if (!callbacks) {
	    callbacks = object._promiseCallbacks = {};
	  }
	
	  return callbacks;
	}
	
	/**
	  @class RSVP.EventTarget
	*/
	var EventTarget = {
	
	  /**
	    `RSVP.EventTarget.mixin` extends an object with EventTarget methods. For
	    Example:
	     ```javascript
	    let object = {};
	     RSVP.EventTarget.mixin(object);
	     object.on('finished', function(event) {
	      // handle event
	    });
	     object.trigger('finished', { detail: value });
	    ```
	     `EventTarget.mixin` also works with prototypes:
	     ```javascript
	    let Person = function() {};
	    RSVP.EventTarget.mixin(Person.prototype);
	     let yehuda = new Person();
	    let tom = new Person();
	     yehuda.on('poke', function(event) {
	      console.log('Yehuda says OW');
	    });
	     tom.on('poke', function(event) {
	      console.log('Tom says OW');
	    });
	     yehuda.trigger('poke');
	    tom.trigger('poke');
	    ```
	     @method mixin
	    @for RSVP.EventTarget
	    @private
	    @param {Object} object object to extend with EventTarget methods
	  */
	  mixin: function (object) {
	    object['on'] = this['on'];
	    object['off'] = this['off'];
	    object['trigger'] = this['trigger'];
	    object._promiseCallbacks = undefined;
	    return object;
	  },
	
	
	  /**
	    Registers a callback to be executed when `eventName` is triggered
	     ```javascript
	    object.on('event', function(eventInfo){
	      // handle the event
	    });
	     object.trigger('event');
	    ```
	     @method on
	    @for RSVP.EventTarget
	    @private
	    @param {String} eventName name of the event to listen for
	    @param {Function} callback function to be called when the event is triggered.
	  */
	  on: function (eventName, callback) {
	    if (typeof callback !== 'function') {
	      throw new TypeError('Callback must be a function');
	    }
	
	    var allCallbacks = callbacksFor(this),
	        callbacks = void 0;
	
	    callbacks = allCallbacks[eventName];
	
	    if (!callbacks) {
	      callbacks = allCallbacks[eventName] = [];
	    }
	
	    if (indexOf(callbacks, callback) === -1) {
	      callbacks.push(callback);
	    }
	  },
	
	
	  /**
	    You can use `off` to stop firing a particular callback for an event:
	     ```javascript
	    function doStuff() { // do stuff! }
	    object.on('stuff', doStuff);
	     object.trigger('stuff'); // doStuff will be called
	     // Unregister ONLY the doStuff callback
	    object.off('stuff', doStuff);
	    object.trigger('stuff'); // doStuff will NOT be called
	    ```
	     If you don't pass a `callback` argument to `off`, ALL callbacks for the
	    event will not be executed when the event fires. For example:
	     ```javascript
	    let callback1 = function(){};
	    let callback2 = function(){};
	     object.on('stuff', callback1);
	    object.on('stuff', callback2);
	     object.trigger('stuff'); // callback1 and callback2 will be executed.
	     object.off('stuff');
	    object.trigger('stuff'); // callback1 and callback2 will not be executed!
	    ```
	     @method off
	    @for RSVP.EventTarget
	    @private
	    @param {String} eventName event to stop listening to
	    @param {Function} callback optional argument. If given, only the function
	    given will be removed from the event's callback queue. If no `callback`
	    argument is given, all callbacks will be removed from the event's callback
	    queue.
	  */
	  off: function (eventName, callback) {
	    var allCallbacks = callbacksFor(this),
	        callbacks = void 0,
	        index = void 0;
	
	    if (!callback) {
	      allCallbacks[eventName] = [];
	      return;
	    }
	
	    callbacks = allCallbacks[eventName];
	
	    index = indexOf(callbacks, callback);
	
	    if (index !== -1) {
	      callbacks.splice(index, 1);
	    }
	  },
	
	
	  /**
	    Use `trigger` to fire custom events. For example:
	     ```javascript
	    object.on('foo', function(){
	      console.log('foo event happened!');
	    });
	    object.trigger('foo');
	    // 'foo event happened!' logged to the console
	    ```
	     You can also pass a value as a second argument to `trigger` that will be
	    passed as an argument to all event listeners for the event:
	     ```javascript
	    object.on('foo', function(value){
	      console.log(value.name);
	    });
	     object.trigger('foo', { name: 'bar' });
	    // 'bar' logged to the console
	    ```
	     @method trigger
	    @for RSVP.EventTarget
	    @private
	    @param {String} eventName name of the event to be triggered
	    @param {*} options optional value to be passed to any event handlers for
	    the given `eventName`
	  */
	  trigger: function (eventName, options, label) {
	    var allCallbacks = callbacksFor(this),
	        callbacks = void 0,
	        callback = void 0;
	
	    if (callbacks = allCallbacks[eventName]) {
	      // Don't cache the callbacks.length since it may grow
	      for (var i = 0; i < callbacks.length; i++) {
	        callback = callbacks[i];
	
	        callback(options, label);
	      }
	    }
	  }
	};
	
	var config = {
	  instrument: false
	};
	
	EventTarget['mixin'](config);
	
	function configure(name, value) {
	  if (arguments.length === 2) {
	    config[name] = value;
	  } else {
	    return config[name];
	  }
	}
	
	function objectOrFunction(x) {
	  var type = typeof x;
	  return x !== null && (type === 'object' || type === 'function');
	}
	
	function isFunction(x) {
	  return typeof x === 'function';
	}
	
	function isObject(x) {
	  return x !== null && typeof x === 'object';
	}
	
	function isMaybeThenable(x) {
	  return x !== null && typeof x === 'object';
	}
	
	var _isArray = void 0;
	if (Array.isArray) {
	  _isArray = Array.isArray;
	} else {
	  _isArray = function (x) {
	    return Object.prototype.toString.call(x) === '[object Array]';
	  };
	}
	
	var isArray = _isArray;
	
	// Date.now is not available in browsers < IE9
	// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date/now#Compatibility
	var now = Date.now || function () {
	  return new Date().getTime();
	};
	
	var queue = [];
	
	function scheduleFlush() {
	  setTimeout(function () {
	    for (var i = 0; i < queue.length; i++) {
	      var entry = queue[i];
	
	      var payload = entry.payload;
	
	      payload.guid = payload.key + payload.id;
	      payload.childGuid = payload.key + payload.childId;
	      if (payload.error) {
	        payload.stack = payload.error.stack;
	      }
	
	      config['trigger'](entry.name, entry.payload);
	    }
	    queue.length = 0;
	  }, 50);
	}
	
	function instrument(eventName, promise, child) {
	  if (1 === queue.push({
	    name: eventName,
	    payload: {
	      key: promise._guidKey,
	      id: promise._id,
	      eventName: eventName,
	      detail: promise._result,
	      childId: child && child._id,
	      label: promise._label,
	      timeStamp: now(),
	      error: config["instrument-with-stack"] ? new Error(promise._label) : null
	    } })) {
	    scheduleFlush();
	  }
	}
	
	/**
	  `RSVP.Promise.resolve` returns a promise that will become resolved with the
	  passed `value`. It is shorthand for the following:
	
	  ```javascript
	  let promise = new RSVP.Promise(function(resolve, reject){
	    resolve(1);
	  });
	
	  promise.then(function(value){
	    // value === 1
	  });
	  ```
	
	  Instead of writing the above, your code now simply becomes the following:
	
	  ```javascript
	  let promise = RSVP.Promise.resolve(1);
	
	  promise.then(function(value){
	    // value === 1
	  });
	  ```
	
	  @method resolve
	  @static
	  @param {*} object value that the returned promise will be resolved with
	  @param {String} label optional string for identifying the returned promise.
	  Useful for tooling.
	  @return {Promise} a promise that will become fulfilled with the given
	  `value`
	*/
	function resolve$1(object, label) {
	  /*jshint validthis:true */
	  var Constructor = this;
	
	  if (object && typeof object === 'object' && object.constructor === Constructor) {
	    return object;
	  }
	
	  var promise = new Constructor(noop, label);
	  resolve(promise, object);
	  return promise;
	}
	
	function withOwnPromise() {
	  return new TypeError('A promises callback cannot return that same promise.');
	}
	
	function noop() {}
	
	var PENDING = void 0;
	var FULFILLED = 1;
	var REJECTED = 2;
	
	var GET_THEN_ERROR = new ErrorObject();
	
	function getThen(promise) {
	  try {
	    return promise.then;
	  } catch (error) {
	    GET_THEN_ERROR.error = error;
	    return GET_THEN_ERROR;
	  }
	}
	
	function tryThen(then$$1, value, fulfillmentHandler, rejectionHandler) {
	  try {
	    then$$1.call(value, fulfillmentHandler, rejectionHandler);
	  } catch (e) {
	    return e;
	  }
	}
	
	function handleForeignThenable(promise, thenable, then$$1) {
	  config.async(function (promise) {
	    var sealed = false;
	    var error = tryThen(then$$1, thenable, function (value) {
	      if (sealed) {
	        return;
	      }
	      sealed = true;
	      if (thenable !== value) {
	        resolve(promise, value, undefined);
	      } else {
	        fulfill(promise, value);
	      }
	    }, function (reason) {
	      if (sealed) {
	        return;
	      }
	      sealed = true;
	
	      reject(promise, reason);
	    }, 'Settle: ' + (promise._label || ' unknown promise'));
	
	    if (!sealed && error) {
	      sealed = true;
	      reject(promise, error);
	    }
	  }, promise);
	}
	
	function handleOwnThenable(promise, thenable) {
	  if (thenable._state === FULFILLED) {
	    fulfill(promise, thenable._result);
	  } else if (thenable._state === REJECTED) {
	    thenable._onError = null;
	    reject(promise, thenable._result);
	  } else {
	    subscribe(thenable, undefined, function (value) {
	      if (thenable !== value) {
	        resolve(promise, value, undefined);
	      } else {
	        fulfill(promise, value);
	      }
	    }, function (reason) {
	      return reject(promise, reason);
	    });
	  }
	}
	
	function handleMaybeThenable(promise, maybeThenable, then$$1) {
	  var isOwnThenable = maybeThenable.constructor === promise.constructor && then$$1 === then && promise.constructor.resolve === resolve$1;
	
	  if (isOwnThenable) {
	    handleOwnThenable(promise, maybeThenable);
	  } else if (then$$1 === GET_THEN_ERROR) {
	    reject(promise, GET_THEN_ERROR.error);
	    GET_THEN_ERROR.error = null;
	  } else if (isFunction(then$$1)) {
	    handleForeignThenable(promise, maybeThenable, then$$1);
	  } else {
	    fulfill(promise, maybeThenable);
	  }
	}
	
	function resolve(promise, value) {
	  if (promise === value) {
	    fulfill(promise, value);
	  } else if (objectOrFunction(value)) {
	    handleMaybeThenable(promise, value, getThen(value));
	  } else {
	    fulfill(promise, value);
	  }
	}
	
	function publishRejection(promise) {
	  if (promise._onError) {
	    promise._onError(promise._result);
	  }
	
	  publish(promise);
	}
	
	function fulfill(promise, value) {
	  if (promise._state !== PENDING) {
	    return;
	  }
	
	  promise._result = value;
	  promise._state = FULFILLED;
	
	  if (promise._subscribers.length === 0) {
	    if (config.instrument) {
	      instrument('fulfilled', promise);
	    }
	  } else {
	    config.async(publish, promise);
	  }
	}
	
	function reject(promise, reason) {
	  if (promise._state !== PENDING) {
	    return;
	  }
	  promise._state = REJECTED;
	  promise._result = reason;
	  config.async(publishRejection, promise);
	}
	
	function subscribe(parent, child, onFulfillment, onRejection) {
	  var subscribers = parent._subscribers;
	  var length = subscribers.length;
	
	  parent._onError = null;
	
	  subscribers[length] = child;
	  subscribers[length + FULFILLED] = onFulfillment;
	  subscribers[length + REJECTED] = onRejection;
	
	  if (length === 0 && parent._state) {
	    config.async(publish, parent);
	  }
	}
	
	function publish(promise) {
	  var subscribers = promise._subscribers;
	  var settled = promise._state;
	
	  if (config.instrument) {
	    instrument(settled === FULFILLED ? 'fulfilled' : 'rejected', promise);
	  }
	
	  if (subscribers.length === 0) {
	    return;
	  }
	
	  var child = void 0,
	      callback = void 0,
	      result = promise._result;
	
	  for (var i = 0; i < subscribers.length; i += 3) {
	    child = subscribers[i];
	    callback = subscribers[i + settled];
	
	    if (child) {
	      invokeCallback(settled, child, callback, result);
	    } else {
	      callback(result);
	    }
	  }
	
	  promise._subscribers.length = 0;
	}
	
	function ErrorObject() {
	  this.error = null;
	}
	
	var TRY_CATCH_ERROR = new ErrorObject();
	
	function tryCatch(callback, result) {
	  try {
	    return callback(result);
	  } catch (e) {
	    TRY_CATCH_ERROR.error = e;
	    return TRY_CATCH_ERROR;
	  }
	}
	
	function invokeCallback(state, promise, callback, result) {
	  var hasCallback = isFunction(callback);
	  var value = void 0,
	      error = void 0;
	
	  if (hasCallback) {
	    value = tryCatch(callback, result);
	
	    if (value === TRY_CATCH_ERROR) {
	      error = value.error;
	      value.error = null; // release
	    } else if (value === promise) {
	      reject(promise, withOwnPromise());
	      return;
	    }
	  } else {
	    value = result;
	  }
	
	  if (promise._state !== PENDING) {
	    // noop
	  } else if (hasCallback && error === undefined) {
	    resolve(promise, value);
	  } else if (error !== undefined) {
	    reject(promise, error);
	  } else if (state === FULFILLED) {
	    fulfill(promise, value);
	  } else if (state === REJECTED) {
	    reject(promise, value);
	  }
	}
	
	function initializePromise(promise, resolver) {
	  var resolved = false;
	  try {
	    resolver(function (value) {
	      if (resolved) {
	        return;
	      }
	      resolved = true;
	      resolve(promise, value);
	    }, function (reason) {
	      if (resolved) {
	        return;
	      }
	      resolved = true;
	      reject(promise, reason);
	    });
	  } catch (e) {
	    reject(promise, e);
	  }
	}
	
	function then(onFulfillment, onRejection, label) {
	  var parent = this;
	  var state = parent._state;
	
	  if (state === FULFILLED && !onFulfillment || state === REJECTED && !onRejection) {
	    config.instrument && instrument('chained', parent, parent);
	    return parent;
	  }
	
	  parent._onError = null;
	
	  var child = new parent.constructor(noop, label);
	  var result = parent._result;
	
	  config.instrument && instrument('chained', parent, child);
	
	  if (state === PENDING) {
	    subscribe(parent, child, onFulfillment, onRejection);
	  } else {
	    var callback = state === FULFILLED ? onFulfillment : onRejection;
	    config.async(function () {
	      return invokeCallback(state, child, callback, result);
	    });
	  }
	
	  return child;
	}
	
	var Enumerator = function () {
	  function Enumerator(Constructor, input, abortOnReject, label) {
	    this._instanceConstructor = Constructor;
	    this.promise = new Constructor(noop, label);
	    this._abortOnReject = abortOnReject;
	
	    this._init.apply(this, arguments);
	  }
	
	  Enumerator.prototype._init = function _init(Constructor, input) {
	    var len = input.length || 0;
	    this.length = len;
	    this._remaining = len;
	    this._result = new Array(len);
	
	    this._enumerate(input);
	    if (this._remaining === 0) {
	      fulfill(this.promise, this._result);
	    }
	  };
	
	  Enumerator.prototype._enumerate = function _enumerate(input) {
	    var length = this.length;
	    var promise = this.promise;
	
	    for (var i = 0; promise._state === PENDING && i < length; i++) {
	      this._eachEntry(input[i], i);
	    }
	  };
	
	  Enumerator.prototype._settleMaybeThenable = function _settleMaybeThenable(entry, i) {
	    var c = this._instanceConstructor;
	    var resolve$$1 = c.resolve;
	
	    if (resolve$$1 === resolve$1) {
	      var then$$1 = getThen(entry);
	
	      if (then$$1 === then && entry._state !== PENDING) {
	        entry._onError = null;
	        this._settledAt(entry._state, i, entry._result);
	      } else if (typeof then$$1 !== 'function') {
	        this._remaining--;
	        this._result[i] = this._makeResult(FULFILLED, i, entry);
	      } else if (c === Promise) {
	        var promise = new c(noop);
	        handleMaybeThenable(promise, entry, then$$1);
	        this._willSettleAt(promise, i);
	      } else {
	        this._willSettleAt(new c(function (resolve$$1) {
	          return resolve$$1(entry);
	        }), i);
	      }
	    } else {
	      this._willSettleAt(resolve$$1(entry), i);
	    }
	  };
	
	  Enumerator.prototype._eachEntry = function _eachEntry(entry, i) {
	    if (isMaybeThenable(entry)) {
	      this._settleMaybeThenable(entry, i);
	    } else {
	      this._remaining--;
	      this._result[i] = this._makeResult(FULFILLED, i, entry);
	    }
	  };
	
	  Enumerator.prototype._settledAt = function _settledAt(state, i, value) {
	    var promise = this.promise;
	
	    if (promise._state === PENDING) {
	      if (this._abortOnReject && state === REJECTED) {
	        reject(promise, value);
	      } else {
	        this._remaining--;
	        this._result[i] = this._makeResult(state, i, value);
	        if (this._remaining === 0) {
	          fulfill(promise, this._result);
	        }
	      }
	    }
	  };
	
	  Enumerator.prototype._makeResult = function _makeResult(state, i, value) {
	    return value;
	  };
	
	  Enumerator.prototype._willSettleAt = function _willSettleAt(promise, i) {
	    var enumerator = this;
	
	    subscribe(promise, undefined, function (value) {
	      return enumerator._settledAt(FULFILLED, i, value);
	    }, function (reason) {
	      return enumerator._settledAt(REJECTED, i, reason);
	    });
	  };
	
	  return Enumerator;
	}();
	
	function makeSettledResult(state, position, value) {
	  if (state === FULFILLED) {
	    return {
	      state: 'fulfilled',
	      value: value
	    };
	  } else {
	    return {
	      state: 'rejected',
	      reason: value
	    };
	  }
	}
	
	/**
	  `RSVP.Promise.all` accepts an array of promises, and returns a new promise which
	  is fulfilled with an array of fulfillment values for the passed promises, or
	  rejected with the reason of the first passed promise to be rejected. It casts all
	  elements of the passed iterable to promises as it runs this algorithm.
	
	  Example:
	
	  ```javascript
	  let promise1 = RSVP.resolve(1);
	  let promise2 = RSVP.resolve(2);
	  let promise3 = RSVP.resolve(3);
	  let promises = [ promise1, promise2, promise3 ];
	
	  RSVP.Promise.all(promises).then(function(array){
	    // The array here would be [ 1, 2, 3 ];
	  });
	  ```
	
	  If any of the `promises` given to `RSVP.all` are rejected, the first promise
	  that is rejected will be given as an argument to the returned promises's
	  rejection handler. For example:
	
	  Example:
	
	  ```javascript
	  let promise1 = RSVP.resolve(1);
	  let promise2 = RSVP.reject(new Error("2"));
	  let promise3 = RSVP.reject(new Error("3"));
	  let promises = [ promise1, promise2, promise3 ];
	
	  RSVP.Promise.all(promises).then(function(array){
	    // Code here never runs because there are rejected promises!
	  }, function(error) {
	    // error.message === "2"
	  });
	  ```
	
	  @method all
	  @static
	  @param {Array} entries array of promises
	  @param {String} label optional string for labeling the promise.
	  Useful for tooling.
	  @return {Promise} promise that is fulfilled when all `promises` have been
	  fulfilled, or rejected if any of them become rejected.
	  @static
	*/
	function all(entries, label) {
	  if (!isArray(entries)) {
	    return this.reject(new TypeError("Promise.all must be called with an array"), label);
	  }
	  return new Enumerator(this, entries, true /* abort on reject */, label).promise;
	}
	
	/**
	  `RSVP.Promise.race` returns a new promise which is settled in the same way as the
	  first passed promise to settle.
	
	  Example:
	
	  ```javascript
	  let promise1 = new RSVP.Promise(function(resolve, reject){
	    setTimeout(function(){
	      resolve('promise 1');
	    }, 200);
	  });
	
	  let promise2 = new RSVP.Promise(function(resolve, reject){
	    setTimeout(function(){
	      resolve('promise 2');
	    }, 100);
	  });
	
	  RSVP.Promise.race([promise1, promise2]).then(function(result){
	    // result === 'promise 2' because it was resolved before promise1
	    // was resolved.
	  });
	  ```
	
	  `RSVP.Promise.race` is deterministic in that only the state of the first
	  settled promise matters. For example, even if other promises given to the
	  `promises` array argument are resolved, but the first settled promise has
	  become rejected before the other promises became fulfilled, the returned
	  promise will become rejected:
	
	  ```javascript
	  let promise1 = new RSVP.Promise(function(resolve, reject){
	    setTimeout(function(){
	      resolve('promise 1');
	    }, 200);
	  });
	
	  let promise2 = new RSVP.Promise(function(resolve, reject){
	    setTimeout(function(){
	      reject(new Error('promise 2'));
	    }, 100);
	  });
	
	  RSVP.Promise.race([promise1, promise2]).then(function(result){
	    // Code here never runs
	  }, function(reason){
	    // reason.message === 'promise 2' because promise 2 became rejected before
	    // promise 1 became fulfilled
	  });
	  ```
	
	  An example real-world use case is implementing timeouts:
	
	  ```javascript
	  RSVP.Promise.race([ajax('foo.json'), timeout(5000)])
	  ```
	
	  @method race
	  @static
	  @param {Array} entries array of promises to observe
	  @param {String} label optional string for describing the promise returned.
	  Useful for tooling.
	  @return {Promise} a promise which settles in the same way as the first passed
	  promise to settle.
	*/
	function race(entries, label) {
	  /*jshint validthis:true */
	  var Constructor = this;
	
	  var promise = new Constructor(noop, label);
	
	  if (!isArray(entries)) {
	    reject(promise, new TypeError('Promise.race must be called with an array'));
	    return promise;
	  }
	
	  for (var i = 0; promise._state === PENDING && i < entries.length; i++) {
	    subscribe(Constructor.resolve(entries[i]), undefined, function (value) {
	      return resolve(promise, value);
	    }, function (reason) {
	      return reject(promise, reason);
	    });
	  }
	
	  return promise;
	}
	
	/**
	  `RSVP.Promise.reject` returns a promise rejected with the passed `reason`.
	  It is shorthand for the following:
	
	  ```javascript
	  let promise = new RSVP.Promise(function(resolve, reject){
	    reject(new Error('WHOOPS'));
	  });
	
	  promise.then(function(value){
	    // Code here doesn't run because the promise is rejected!
	  }, function(reason){
	    // reason.message === 'WHOOPS'
	  });
	  ```
	
	  Instead of writing the above, your code now simply becomes the following:
	
	  ```javascript
	  let promise = RSVP.Promise.reject(new Error('WHOOPS'));
	
	  promise.then(function(value){
	    // Code here doesn't run because the promise is rejected!
	  }, function(reason){
	    // reason.message === 'WHOOPS'
	  });
	  ```
	
	  @method reject
	  @static
	  @param {*} reason value that the returned promise will be rejected with.
	  @param {String} label optional string for identifying the returned promise.
	  Useful for tooling.
	  @return {Promise} a promise rejected with the given `reason`.
	*/
	function reject$1(reason, label) {
	  /*jshint validthis:true */
	  var Constructor = this;
	  var promise = new Constructor(noop, label);
	  reject(promise, reason);
	  return promise;
	}
	
	var guidKey = 'rsvp_' + now() + '-';
	var counter = 0;
	
	function needsResolver() {
	  throw new TypeError('You must pass a resolver function as the first argument to the promise constructor');
	}
	
	function needsNew() {
	  throw new TypeError("Failed to construct 'Promise': Please use the 'new' operator, this object constructor cannot be called as a function.");
	}
	
	/**
	  Promise objects represent the eventual result of an asynchronous operation. The
	  primary way of interacting with a promise is through its `then` method, which
	  registers callbacks to receive either a promise’s eventual value or the reason
	  why the promise cannot be fulfilled.
	
	  Terminology
	  -----------
	
	  - `promise` is an object or function with a `then` method whose behavior conforms to this specification.
	  - `thenable` is an object or function that defines a `then` method.
	  - `value` is any legal JavaScript value (including undefined, a thenable, or a promise).
	  - `exception` is a value that is thrown using the throw statement.
	  - `reason` is a value that indicates why a promise was rejected.
	  - `settled` the final resting state of a promise, fulfilled or rejected.
	
	  A promise can be in one of three states: pending, fulfilled, or rejected.
	
	  Promises that are fulfilled have a fulfillment value and are in the fulfilled
	  state.  Promises that are rejected have a rejection reason and are in the
	  rejected state.  A fulfillment value is never a thenable.
	
	  Promises can also be said to *resolve* a value.  If this value is also a
	  promise, then the original promise's settled state will match the value's
	  settled state.  So a promise that *resolves* a promise that rejects will
	  itself reject, and a promise that *resolves* a promise that fulfills will
	  itself fulfill.
	
	
	  Basic Usage:
	  ------------
	
	  ```js
	  let promise = new Promise(function(resolve, reject) {
	    // on success
	    resolve(value);
	
	    // on failure
	    reject(reason);
	  });
	
	  promise.then(function(value) {
	    // on fulfillment
	  }, function(reason) {
	    // on rejection
	  });
	  ```
	
	  Advanced Usage:
	  ---------------
	
	  Promises shine when abstracting away asynchronous interactions such as
	  `XMLHttpRequest`s.
	
	  ```js
	  function getJSON(url) {
	    return new Promise(function(resolve, reject){
	      let xhr = new XMLHttpRequest();
	
	      xhr.open('GET', url);
	      xhr.onreadystatechange = handler;
	      xhr.responseType = 'json';
	      xhr.setRequestHeader('Accept', 'application/json');
	      xhr.send();
	
	      function handler() {
	        if (this.readyState === this.DONE) {
	          if (this.status === 200) {
	            resolve(this.response);
	          } else {
	            reject(new Error('getJSON: `' + url + '` failed with status: [' + this.status + ']'));
	          }
	        }
	      };
	    });
	  }
	
	  getJSON('/posts.json').then(function(json) {
	    // on fulfillment
	  }, function(reason) {
	    // on rejection
	  });
	  ```
	
	  Unlike callbacks, promises are great composable primitives.
	
	  ```js
	  Promise.all([
	    getJSON('/posts'),
	    getJSON('/comments')
	  ]).then(function(values){
	    values[0] // => postsJSON
	    values[1] // => commentsJSON
	
	    return values;
	  });
	  ```
	
	  @class RSVP.Promise
	  @param {function} resolver
	  @param {String} label optional string for labeling the promise.
	  Useful for tooling.
	  @constructor
	*/
	
	var Promise = function () {
	  function Promise(resolver, label) {
	    this._id = counter++;
	    this._label = label;
	    this._state = undefined;
	    this._result = undefined;
	    this._subscribers = [];
	
	    config.instrument && instrument('created', this);
	
	    if (noop !== resolver) {
	      typeof resolver !== 'function' && needsResolver();
	      this instanceof Promise ? initializePromise(this, resolver) : needsNew();
	    }
	  }
	
	  Promise.prototype._onError = function _onError(reason) {
	    var _this = this;
	
	    config.after(function () {
	      if (_this._onError) {
	        config.trigger('error', reason, _this._label);
	      }
	    });
	  };
	
	  /**
	    `catch` is simply sugar for `then(undefined, onRejection)` which makes it the same
	    as the catch block of a try/catch statement.
	  
	    ```js
	    function findAuthor(){
	      throw new Error('couldn\'t find that author');
	    }
	  
	    // synchronous
	    try {
	      findAuthor();
	    } catch(reason) {
	      // something went wrong
	    }
	  
	    // async with promises
	    findAuthor().catch(function(reason){
	      // something went wrong
	    });
	    ```
	  
	    @method catch
	    @param {Function} onRejection
	    @param {String} label optional string for labeling the promise.
	    Useful for tooling.
	    @return {Promise}
	  */
	
	
	  Promise.prototype.catch = function _catch(onRejection, label) {
	    return this.then(undefined, onRejection, label);
	  };
	
	  /**
	    `finally` will be invoked regardless of the promise's fate just as native
	    try/catch/finally behaves
	  
	    Synchronous example:
	  
	    ```js
	    findAuthor() {
	      if (Math.random() > 0.5) {
	        throw new Error();
	      }
	      return new Author();
	    }
	  
	    try {
	      return findAuthor(); // succeed or fail
	    } catch(error) {
	      return findOtherAuthor();
	    } finally {
	      // always runs
	      // doesn't affect the return value
	    }
	    ```
	  
	    Asynchronous example:
	  
	    ```js
	    findAuthor().catch(function(reason){
	      return findOtherAuthor();
	    }).finally(function(){
	      // author was either found, or not
	    });
	    ```
	  
	    @method finally
	    @param {Function} callback
	    @param {String} label optional string for labeling the promise.
	    Useful for tooling.
	    @return {Promise}
	  */
	
	
	  Promise.prototype.finally = function _finally(callback, label) {
	    var promise = this;
	    var constructor = promise.constructor;
	
	    return promise.then(function (value) {
	      return constructor.resolve(callback()).then(function () {
	        return value;
	      });
	    }, function (reason) {
	      return constructor.resolve(callback()).then(function () {
	        throw reason;
	      });
	    }, label);
	  };
	
	  return Promise;
	}();
	
	
	
	Promise.cast = resolve$1; // deprecated
	Promise.all = all;
	Promise.race = race;
	Promise.resolve = resolve$1;
	Promise.reject = reject$1;
	
	Promise.prototype._guidKey = guidKey;
	
	/**
	  The primary way of interacting with a promise is through its `then` method,
	  which registers callbacks to receive either a promise's eventual value or the
	  reason why the promise cannot be fulfilled.
	
	  ```js
	  findUser().then(function(user){
	    // user is available
	  }, function(reason){
	    // user is unavailable, and you are given the reason why
	  });
	  ```
	
	  Chaining
	  --------
	
	  The return value of `then` is itself a promise.  This second, 'downstream'
	  promise is resolved with the return value of the first promise's fulfillment
	  or rejection handler, or rejected if the handler throws an exception.
	
	  ```js
	  findUser().then(function (user) {
	    return user.name;
	  }, function (reason) {
	    return 'default name';
	  }).then(function (userName) {
	    // If `findUser` fulfilled, `userName` will be the user's name, otherwise it
	    // will be `'default name'`
	  });
	
	  findUser().then(function (user) {
	    throw new Error('Found user, but still unhappy');
	  }, function (reason) {
	    throw new Error('`findUser` rejected and we\'re unhappy');
	  }).then(function (value) {
	    // never reached
	  }, function (reason) {
	    // if `findUser` fulfilled, `reason` will be 'Found user, but still unhappy'.
	    // If `findUser` rejected, `reason` will be '`findUser` rejected and we\'re unhappy'.
	  });
	  ```
	  If the downstream promise does not specify a rejection handler, rejection reasons will be propagated further downstream.
	
	  ```js
	  findUser().then(function (user) {
	    throw new PedagogicalException('Upstream error');
	  }).then(function (value) {
	    // never reached
	  }).then(function (value) {
	    // never reached
	  }, function (reason) {
	    // The `PedgagocialException` is propagated all the way down to here
	  });
	  ```
	
	  Assimilation
	  ------------
	
	  Sometimes the value you want to propagate to a downstream promise can only be
	  retrieved asynchronously. This can be achieved by returning a promise in the
	  fulfillment or rejection handler. The downstream promise will then be pending
	  until the returned promise is settled. This is called *assimilation*.
	
	  ```js
	  findUser().then(function (user) {
	    return findCommentsByAuthor(user);
	  }).then(function (comments) {
	    // The user's comments are now available
	  });
	  ```
	
	  If the assimliated promise rejects, then the downstream promise will also reject.
	
	  ```js
	  findUser().then(function (user) {
	    return findCommentsByAuthor(user);
	  }).then(function (comments) {
	    // If `findCommentsByAuthor` fulfills, we'll have the value here
	  }, function (reason) {
	    // If `findCommentsByAuthor` rejects, we'll have the reason here
	  });
	  ```
	
	  Simple Example
	  --------------
	
	  Synchronous Example
	
	  ```javascript
	  let result;
	
	  try {
	    result = findResult();
	    // success
	  } catch(reason) {
	    // failure
	  }
	  ```
	
	  Errback Example
	
	  ```js
	  findResult(function(result, err){
	    if (err) {
	      // failure
	    } else {
	      // success
	    }
	  });
	  ```
	
	  Promise Example;
	
	  ```javascript
	  findResult().then(function(result){
	    // success
	  }, function(reason){
	    // failure
	  });
	  ```
	
	  Advanced Example
	  --------------
	
	  Synchronous Example
	
	  ```javascript
	  let author, books;
	
	  try {
	    author = findAuthor();
	    books  = findBooksByAuthor(author);
	    // success
	  } catch(reason) {
	    // failure
	  }
	  ```
	
	  Errback Example
	
	  ```js
	
	  function foundBooks(books) {
	
	  }
	
	  function failure(reason) {
	
	  }
	
	  findAuthor(function(author, err){
	    if (err) {
	      failure(err);
	      // failure
	    } else {
	      try {
	        findBoooksByAuthor(author, function(books, err) {
	          if (err) {
	            failure(err);
	          } else {
	            try {
	              foundBooks(books);
	            } catch(reason) {
	              failure(reason);
	            }
	          }
	        });
	      } catch(error) {
	        failure(err);
	      }
	      // success
	    }
	  });
	  ```
	
	  Promise Example;
	
	  ```javascript
	  findAuthor().
	    then(findBooksByAuthor).
	    then(function(books){
	      // found books
	  }).catch(function(reason){
	    // something went wrong
	  });
	  ```
	
	  @method then
	  @param {Function} onFulfillment
	  @param {Function} onRejection
	  @param {String} label optional string for labeling the promise.
	  Useful for tooling.
	  @return {Promise}
	*/
	Promise.prototype.then = then;
	
	function Result() {
	  this.value = undefined;
	}
	
	var ERROR = new Result();
	var GET_THEN_ERROR$1 = new Result();
	
	function getThen$1(obj) {
	  try {
	    return obj.then;
	  } catch (error) {
	    ERROR.value = error;
	    return ERROR;
	  }
	}
	
	function tryApply(f, s, a) {
	  try {
	    f.apply(s, a);
	  } catch (error) {
	    ERROR.value = error;
	    return ERROR;
	  }
	}
	
	function makeObject(_, argumentNames) {
	  var obj = {};
	  var length = _.length;
	  var args = new Array(length);
	
	  for (var x = 0; x < length; x++) {
	    args[x] = _[x];
	  }
	
	  for (var i = 0; i < argumentNames.length; i++) {
	    var name = argumentNames[i];
	    obj[name] = args[i + 1];
	  }
	
	  return obj;
	}
	
	function arrayResult(_) {
	  var length = _.length;
	  var args = new Array(length - 1);
	
	  for (var i = 1; i < length; i++) {
	    args[i - 1] = _[i];
	  }
	
	  return args;
	}
	
	function wrapThenable(then, promise) {
	  return {
	    then: function (onFulFillment, onRejection) {
	      return then.call(promise, onFulFillment, onRejection);
	    }
	  };
	}
	
	/**
	  `RSVP.denodeify` takes a 'node-style' function and returns a function that
	  will return an `RSVP.Promise`. You can use `denodeify` in Node.js or the
	  browser when you'd prefer to use promises over using callbacks. For example,
	  `denodeify` transforms the following:
	
	  ```javascript
	  let fs = require('fs');
	
	  fs.readFile('myfile.txt', function(err, data){
	    if (err) return handleError(err);
	    handleData(data);
	  });
	  ```
	
	  into:
	
	  ```javascript
	  let fs = require('fs');
	  let readFile = RSVP.denodeify(fs.readFile);
	
	  readFile('myfile.txt').then(handleData, handleError);
	  ```
	
	  If the node function has multiple success parameters, then `denodeify`
	  just returns the first one:
	
	  ```javascript
	  let request = RSVP.denodeify(require('request'));
	
	  request('http://example.com').then(function(res) {
	    // ...
	  });
	  ```
	
	  However, if you need all success parameters, setting `denodeify`'s
	  second parameter to `true` causes it to return all success parameters
	  as an array:
	
	  ```javascript
	  let request = RSVP.denodeify(require('request'), true);
	
	  request('http://example.com').then(function(result) {
	    // result[0] -> res
	    // result[1] -> body
	  });
	  ```
	
	  Or if you pass it an array with names it returns the parameters as a hash:
	
	  ```javascript
	  let request = RSVP.denodeify(require('request'), ['res', 'body']);
	
	  request('http://example.com').then(function(result) {
	    // result.res
	    // result.body
	  });
	  ```
	
	  Sometimes you need to retain the `this`:
	
	  ```javascript
	  let app = require('express')();
	  let render = RSVP.denodeify(app.render.bind(app));
	  ```
	
	  The denodified function inherits from the original function. It works in all
	  environments, except IE 10 and below. Consequently all properties of the original
	  function are available to you. However, any properties you change on the
	  denodeified function won't be changed on the original function. Example:
	
	  ```javascript
	  let request = RSVP.denodeify(require('request')),
	      cookieJar = request.jar(); // <- Inheritance is used here
	
	  request('http://example.com', {jar: cookieJar}).then(function(res) {
	    // cookieJar.cookies holds now the cookies returned by example.com
	  });
	  ```
	
	  Using `denodeify` makes it easier to compose asynchronous operations instead
	  of using callbacks. For example, instead of:
	
	  ```javascript
	  let fs = require('fs');
	
	  fs.readFile('myfile.txt', function(err, data){
	    if (err) { ... } // Handle error
	    fs.writeFile('myfile2.txt', data, function(err){
	      if (err) { ... } // Handle error
	      console.log('done')
	    });
	  });
	  ```
	
	  you can chain the operations together using `then` from the returned promise:
	
	  ```javascript
	  let fs = require('fs');
	  let readFile = RSVP.denodeify(fs.readFile);
	  let writeFile = RSVP.denodeify(fs.writeFile);
	
	  readFile('myfile.txt').then(function(data){
	    return writeFile('myfile2.txt', data);
	  }).then(function(){
	    console.log('done')
	  }).catch(function(error){
	    // Handle error
	  });
	  ```
	
	  @method denodeify
	  @static
	  @for RSVP
	  @param {Function} nodeFunc a 'node-style' function that takes a callback as
	  its last argument. The callback expects an error to be passed as its first
	  argument (if an error occurred, otherwise null), and the value from the
	  operation as its second argument ('function(err, value){ }').
	  @param {Boolean|Array} [options] An optional paramter that if set
	  to `true` causes the promise to fulfill with the callback's success arguments
	  as an array. This is useful if the node function has multiple success
	  paramters. If you set this paramter to an array with names, the promise will
	  fulfill with a hash with these names as keys and the success parameters as
	  values.
	  @return {Function} a function that wraps `nodeFunc` to return an
	  `RSVP.Promise`
	  @static
	*/
	function denodeify(nodeFunc, options) {
	  var fn = function () {
	    var self = this;
	    var l = arguments.length;
	    var args = new Array(l + 1);
	    var promiseInput = false;
	
	    for (var i = 0; i < l; ++i) {
	      var arg = arguments[i];
	
	      if (!promiseInput) {
	        // TODO: clean this up
	        promiseInput = needsPromiseInput(arg);
	        if (promiseInput === GET_THEN_ERROR$1) {
	          var p = new Promise(noop);
	          reject(p, GET_THEN_ERROR$1.value);
	          return p;
	        } else if (promiseInput && promiseInput !== true) {
	          arg = wrapThenable(promiseInput, arg);
	        }
	      }
	      args[i] = arg;
	    }
	
	    var promise = new Promise(noop);
	
	    args[l] = function (err, val) {
	      if (err) reject(promise, err);else if (options === undefined) resolve(promise, val);else if (options === true) resolve(promise, arrayResult(arguments));else if (isArray(options)) resolve(promise, makeObject(arguments, options));else resolve(promise, val);
	    };
	
	    if (promiseInput) {
	      return handlePromiseInput(promise, args, nodeFunc, self);
	    } else {
	      return handleValueInput(promise, args, nodeFunc, self);
	    }
	  };
	
	  fn.__proto__ = nodeFunc;
	
	  return fn;
	}
	
	function handleValueInput(promise, args, nodeFunc, self) {
	  var result = tryApply(nodeFunc, self, args);
	  if (result === ERROR) {
	    reject(promise, result.value);
	  }
	  return promise;
	}
	
	function handlePromiseInput(promise, args, nodeFunc, self) {
	  return Promise.all(args).then(function (args) {
	    var result = tryApply(nodeFunc, self, args);
	    if (result === ERROR) {
	      reject(promise, result.value);
	    }
	    return promise;
	  });
	}
	
	function needsPromiseInput(arg) {
	  if (arg && typeof arg === 'object') {
	    if (arg.constructor === Promise) {
	      return true;
	    } else {
	      return getThen$1(arg);
	    }
	  } else {
	    return false;
	  }
	}
	
	/**
	  This is a convenient alias for `RSVP.Promise.all`.
	
	  @method all
	  @static
	  @for RSVP
	  @param {Array} array Array of promises.
	  @param {String} label An optional label. This is useful
	  for tooling.
	*/
	function all$1(array, label) {
	  return Promise.all(array, label);
	}
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AllSettled = function (_Enumerator) {
	  _inherits(AllSettled, _Enumerator);
	
	  function AllSettled(Constructor, entries, label) {
	    return _possibleConstructorReturn(this, _Enumerator.call(this, Constructor, entries, false /* don't abort on reject */, label));
	  }
	
	  return AllSettled;
	}(Enumerator);
	
	AllSettled.prototype._makeResult = makeSettledResult;
	
	/**
	`RSVP.allSettled` is similar to `RSVP.all`, but instead of implementing
	a fail-fast method, it waits until all the promises have returned and
	shows you all the results. This is useful if you want to handle multiple
	promises' failure states together as a set.
	 Returns a promise that is fulfilled when all the given promises have been
	settled. The return promise is fulfilled with an array of the states of
	the promises passed into the `promises` array argument.
	 Each state object will either indicate fulfillment or rejection, and
	provide the corresponding value or reason. The states will take one of
	the following formats:
	 ```javascript
	{ state: 'fulfilled', value: value }
	  or
	{ state: 'rejected', reason: reason }
	```
	 Example:
	 ```javascript
	let promise1 = RSVP.Promise.resolve(1);
	let promise2 = RSVP.Promise.reject(new Error('2'));
	let promise3 = RSVP.Promise.reject(new Error('3'));
	let promises = [ promise1, promise2, promise3 ];
	 RSVP.allSettled(promises).then(function(array){
	  // array == [
	  //   { state: 'fulfilled', value: 1 },
	  //   { state: 'rejected', reason: Error },
	  //   { state: 'rejected', reason: Error }
	  // ]
	  // Note that for the second item, reason.message will be '2', and for the
	  // third item, reason.message will be '3'.
	}, function(error) {
	  // Not run. (This block would only be called if allSettled had failed,
	  // for instance if passed an incorrect argument type.)
	});
	```
	 @method allSettled
	@static
	@for RSVP
	@param {Array} entries
	@param {String} label - optional string that describes the promise.
	Useful for tooling.
	@return {Promise} promise that is fulfilled with an array of the settled
	states of the constituent promises.
	*/
	
	function allSettled(entries, label) {
	  if (!isArray(entries)) {
	    return Promise.reject(new TypeError("Promise.allSettled must be called with an array"), label);
	  }
	
	  return new AllSettled(Promise, entries, label).promise;
	}
	
	/**
	  This is a convenient alias for `RSVP.Promise.race`.
	
	  @method race
	  @static
	  @for RSVP
	  @param {Array} array Array of promises.
	  @param {String} label An optional label. This is useful
	  for tooling.
	 */
	function race$1(array, label) {
	  return Promise.race(array, label);
	}
	
	function _possibleConstructorReturn$1(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits$1(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	var PromiseHash = function (_Enumerator) {
	  _inherits$1(PromiseHash, _Enumerator);
	
	  function PromiseHash(Constructor, object) {
	    var abortOnReject = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
	    var label = arguments[3];
	    return _possibleConstructorReturn$1(this, _Enumerator.call(this, Constructor, object, abortOnReject, label));
	  }
	
	  PromiseHash.prototype._init = function _init(Constructor, object) {
	    this._result = {};
	
	    this._enumerate(object);
	    if (this._remaining === 0) {
	      fulfill(this.promise, this._result);
	    }
	  };
	
	  PromiseHash.prototype._enumerate = function _enumerate(input) {
	    var promise = this.promise;
	    var results = [];
	
	    for (var key in input) {
	      if (hasOwnProperty.call(input, key)) {
	        results.push({
	          position: key,
	          entry: input[key]
	        });
	      }
	    }
	
	    var length = results.length;
	    this._remaining = length;
	    var result = void 0;
	
	    for (var i = 0; promise._state === PENDING && i < length; i++) {
	      result = results[i];
	      this._eachEntry(result.entry, result.position);
	    }
	  };
	
	  return PromiseHash;
	}(Enumerator);
	
	/**
	  `RSVP.hash` is similar to `RSVP.all`, but takes an object instead of an array
	  for its `promises` argument.
	
	  Returns a promise that is fulfilled when all the given promises have been
	  fulfilled, or rejected if any of them become rejected. The returned promise
	  is fulfilled with a hash that has the same key names as the `promises` object
	  argument. If any of the values in the object are not promises, they will
	  simply be copied over to the fulfilled object.
	
	  Example:
	
	  ```javascript
	  let promises = {
	    myPromise: RSVP.resolve(1),
	    yourPromise: RSVP.resolve(2),
	    theirPromise: RSVP.resolve(3),
	    notAPromise: 4
	  };
	
	  RSVP.hash(promises).then(function(hash){
	    // hash here is an object that looks like:
	    // {
	    //   myPromise: 1,
	    //   yourPromise: 2,
	    //   theirPromise: 3,
	    //   notAPromise: 4
	    // }
	  });
	  ````
	
	  If any of the `promises` given to `RSVP.hash` are rejected, the first promise
	  that is rejected will be given as the reason to the rejection handler.
	
	  Example:
	
	  ```javascript
	  let promises = {
	    myPromise: RSVP.resolve(1),
	    rejectedPromise: RSVP.reject(new Error('rejectedPromise')),
	    anotherRejectedPromise: RSVP.reject(new Error('anotherRejectedPromise')),
	  };
	
	  RSVP.hash(promises).then(function(hash){
	    // Code here never runs because there are rejected promises!
	  }, function(reason) {
	    // reason.message === 'rejectedPromise'
	  });
	  ```
	
	  An important note: `RSVP.hash` is intended for plain JavaScript objects that
	  are just a set of keys and values. `RSVP.hash` will NOT preserve prototype
	  chains.
	
	  Example:
	
	  ```javascript
	  function MyConstructor(){
	    this.example = RSVP.resolve('Example');
	  }
	
	  MyConstructor.prototype = {
	    protoProperty: RSVP.resolve('Proto Property')
	  };
	
	  let myObject = new MyConstructor();
	
	  RSVP.hash(myObject).then(function(hash){
	    // protoProperty will not be present, instead you will just have an
	    // object that looks like:
	    // {
	    //   example: 'Example'
	    // }
	    //
	    // hash.hasOwnProperty('protoProperty'); // false
	    // 'undefined' === typeof hash.protoProperty
	  });
	  ```
	
	  @method hash
	  @static
	  @for RSVP
	  @param {Object} object
	  @param {String} label optional string that describes the promise.
	  Useful for tooling.
	  @return {Promise} promise that is fulfilled when all properties of `promises`
	  have been fulfilled, or rejected if any of them become rejected.
	*/
	function hash(object, label) {
	  if (!isObject(object)) {
	    return Promise.reject(new TypeError("Promise.hash must be called with an object"), label);
	  }
	
	  return new PromiseHash(Promise, object, label).promise;
	}
	
	function _possibleConstructorReturn$2(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits$2(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var HashSettled = function (_PromiseHash) {
	  _inherits$2(HashSettled, _PromiseHash);
	
	  function HashSettled(Constructor, object, label) {
	    return _possibleConstructorReturn$2(this, _PromiseHash.call(this, Constructor, object, false, label));
	  }
	
	  return HashSettled;
	}(PromiseHash);
	
	HashSettled.prototype._makeResult = makeSettledResult;
	
	/**
	  `RSVP.hashSettled` is similar to `RSVP.allSettled`, but takes an object
	  instead of an array for its `promises` argument.
	
	  Unlike `RSVP.all` or `RSVP.hash`, which implement a fail-fast method,
	  but like `RSVP.allSettled`, `hashSettled` waits until all the
	  constituent promises have returned and then shows you all the results
	  with their states and values/reasons. This is useful if you want to
	  handle multiple promises' failure states together as a set.
	
	  Returns a promise that is fulfilled when all the given promises have been
	  settled, or rejected if the passed parameters are invalid.
	
	  The returned promise is fulfilled with a hash that has the same key names as
	  the `promises` object argument. If any of the values in the object are not
	  promises, they will be copied over to the fulfilled object and marked with state
	  'fulfilled'.
	
	  Example:
	
	  ```javascript
	  let promises = {
	    myPromise: RSVP.Promise.resolve(1),
	    yourPromise: RSVP.Promise.resolve(2),
	    theirPromise: RSVP.Promise.resolve(3),
	    notAPromise: 4
	  };
	
	  RSVP.hashSettled(promises).then(function(hash){
	    // hash here is an object that looks like:
	    // {
	    //   myPromise: { state: 'fulfilled', value: 1 },
	    //   yourPromise: { state: 'fulfilled', value: 2 },
	    //   theirPromise: { state: 'fulfilled', value: 3 },
	    //   notAPromise: { state: 'fulfilled', value: 4 }
	    // }
	  });
	  ```
	
	  If any of the `promises` given to `RSVP.hash` are rejected, the state will
	  be set to 'rejected' and the reason for rejection provided.
	
	  Example:
	
	  ```javascript
	  let promises = {
	    myPromise: RSVP.Promise.resolve(1),
	    rejectedPromise: RSVP.Promise.reject(new Error('rejection')),
	    anotherRejectedPromise: RSVP.Promise.reject(new Error('more rejection')),
	  };
	
	  RSVP.hashSettled(promises).then(function(hash){
	    // hash here is an object that looks like:
	    // {
	    //   myPromise:              { state: 'fulfilled', value: 1 },
	    //   rejectedPromise:        { state: 'rejected', reason: Error },
	    //   anotherRejectedPromise: { state: 'rejected', reason: Error },
	    // }
	    // Note that for rejectedPromise, reason.message == 'rejection',
	    // and for anotherRejectedPromise, reason.message == 'more rejection'.
	  });
	  ```
	
	  An important note: `RSVP.hashSettled` is intended for plain JavaScript objects that
	  are just a set of keys and values. `RSVP.hashSettled` will NOT preserve prototype
	  chains.
	
	  Example:
	
	  ```javascript
	  function MyConstructor(){
	    this.example = RSVP.Promise.resolve('Example');
	  }
	
	  MyConstructor.prototype = {
	    protoProperty: RSVP.Promise.resolve('Proto Property')
	  };
	
	  let myObject = new MyConstructor();
	
	  RSVP.hashSettled(myObject).then(function(hash){
	    // protoProperty will not be present, instead you will just have an
	    // object that looks like:
	    // {
	    //   example: { state: 'fulfilled', value: 'Example' }
	    // }
	    //
	    // hash.hasOwnProperty('protoProperty'); // false
	    // 'undefined' === typeof hash.protoProperty
	  });
	  ```
	
	  @method hashSettled
	  @for RSVP
	  @param {Object} object
	  @param {String} label optional string that describes the promise.
	  Useful for tooling.
	  @return {Promise} promise that is fulfilled when when all properties of `promises`
	  have been settled.
	  @static
	*/
	
	function hashSettled(object, label) {
	  if (!isObject(object)) {
	    return Promise.reject(new TypeError("RSVP.hashSettled must be called with an object"), label);
	  }
	
	  return new HashSettled(Promise, object, false, label).promise;
	}
	
	/**
	  `RSVP.rethrow` will rethrow an error on the next turn of the JavaScript event
	  loop in order to aid debugging.
	
	  Promises A+ specifies that any exceptions that occur with a promise must be
	  caught by the promises implementation and bubbled to the last handler. For
	  this reason, it is recommended that you always specify a second rejection
	  handler function to `then`. However, `RSVP.rethrow` will throw the exception
	  outside of the promise, so it bubbles up to your console if in the browser,
	  or domain/cause uncaught exception in Node. `rethrow` will also throw the
	  error again so the error can be handled by the promise per the spec.
	
	  ```javascript
	  function throws(){
	    throw new Error('Whoops!');
	  }
	
	  let promise = new RSVP.Promise(function(resolve, reject){
	    throws();
	  });
	
	  promise.catch(RSVP.rethrow).then(function(){
	    // Code here doesn't run because the promise became rejected due to an
	    // error!
	  }, function (err){
	    // handle the error here
	  });
	  ```
	
	  The 'Whoops' error will be thrown on the next turn of the event loop
	  and you can watch for it in your console. You can also handle it using a
	  rejection handler given to `.then` or `.catch` on the returned promise.
	
	  @method rethrow
	  @static
	  @for RSVP
	  @param {Error} reason reason the promise became rejected.
	  @throws Error
	  @static
	*/
	function rethrow(reason) {
	  setTimeout(function () {
	    throw reason;
	  });
	  throw reason;
	}
	
	/**
	  `RSVP.defer` returns an object similar to jQuery's `$.Deferred`.
	  `RSVP.defer` should be used when porting over code reliant on `$.Deferred`'s
	  interface. New code should use the `RSVP.Promise` constructor instead.
	
	  The object returned from `RSVP.defer` is a plain object with three properties:
	
	  * promise - an `RSVP.Promise`.
	  * reject - a function that causes the `promise` property on this object to
	    become rejected
	  * resolve - a function that causes the `promise` property on this object to
	    become fulfilled.
	
	  Example:
	
	   ```javascript
	   let deferred = RSVP.defer();
	
	   deferred.resolve("Success!");
	
	   deferred.promise.then(function(value){
	     // value here is "Success!"
	   });
	   ```
	
	  @method defer
	  @static
	  @for RSVP
	  @param {String} label optional string for labeling the promise.
	  Useful for tooling.
	  @return {Object}
	 */
	
	function defer(label) {
	  var deferred = { resolve: undefined, reject: undefined };
	
	  deferred.promise = new Promise(function (resolve, reject) {
	    deferred.resolve = resolve;
	    deferred.reject = reject;
	  }, label);
	
	  return deferred;
	}
	
	/**
	 `RSVP.map` is similar to JavaScript's native `map` method, except that it
	  waits for all promises to become fulfilled before running the `mapFn` on
	  each item in given to `promises`. `RSVP.map` returns a promise that will
	  become fulfilled with the result of running `mapFn` on the values the promises
	  become fulfilled with.
	
	  For example:
	
	  ```javascript
	
	  let promise1 = RSVP.resolve(1);
	  let promise2 = RSVP.resolve(2);
	  let promise3 = RSVP.resolve(3);
	  let promises = [ promise1, promise2, promise3 ];
	
	  let mapFn = function(item){
	    return item + 1;
	  };
	
	  RSVP.map(promises, mapFn).then(function(result){
	    // result is [ 2, 3, 4 ]
	  });
	  ```
	
	  If any of the `promises` given to `RSVP.map` are rejected, the first promise
	  that is rejected will be given as an argument to the returned promise's
	  rejection handler. For example:
	
	  ```javascript
	  let promise1 = RSVP.resolve(1);
	  let promise2 = RSVP.reject(new Error('2'));
	  let promise3 = RSVP.reject(new Error('3'));
	  let promises = [ promise1, promise2, promise3 ];
	
	  let mapFn = function(item){
	    return item + 1;
	  };
	
	  RSVP.map(promises, mapFn).then(function(array){
	    // Code here never runs because there are rejected promises!
	  }, function(reason) {
	    // reason.message === '2'
	  });
	  ```
	
	  `RSVP.map` will also wait if a promise is returned from `mapFn`. For example,
	  say you want to get all comments from a set of blog posts, but you need
	  the blog posts first because they contain a url to those comments.
	
	  ```javscript
	
	  let mapFn = function(blogPost){
	    // getComments does some ajax and returns an RSVP.Promise that is fulfilled
	    // with some comments data
	    return getComments(blogPost.comments_url);
	  };
	
	  // getBlogPosts does some ajax and returns an RSVP.Promise that is fulfilled
	  // with some blog post data
	  RSVP.map(getBlogPosts(), mapFn).then(function(comments){
	    // comments is the result of asking the server for the comments
	    // of all blog posts returned from getBlogPosts()
	  });
	  ```
	
	  @method map
	  @static
	  @for RSVP
	  @param {Array} promises
	  @param {Function} mapFn function to be called on each fulfilled promise.
	  @param {String} label optional string for labeling the promise.
	  Useful for tooling.
	  @return {Promise} promise that is fulfilled with the result of calling
	  `mapFn` on each fulfilled promise or value when they become fulfilled.
	   The promise will be rejected if any of the given `promises` become rejected.
	  @static
	*/
	function map(promises, mapFn, label) {
	  if (!isArray(promises)) {
	    return Promise.reject(new TypeError("RSVP.map must be called with an array"), label);
	  }
	
	  if (!isFunction(mapFn)) {
	    return Promise.reject(new TypeError("RSVP.map expects a function as a second argument"), label);
	  }
	
	  return Promise.all(promises, label).then(function (values) {
	    var length = values.length;
	    var results = new Array(length);
	
	    for (var i = 0; i < length; i++) {
	      results[i] = mapFn(values[i]);
	    }
	
	    return Promise.all(results, label);
	  });
	}
	
	/**
	  This is a convenient alias for `RSVP.Promise.resolve`.
	
	  @method resolve
	  @static
	  @for RSVP
	  @param {*} value value that the returned promise will be resolved with
	  @param {String} label optional string for identifying the returned promise.
	  Useful for tooling.
	  @return {Promise} a promise that will become fulfilled with the given
	  `value`
	*/
	function resolve$2(value, label) {
	  return Promise.resolve(value, label);
	}
	
	/**
	  This is a convenient alias for `RSVP.Promise.reject`.
	
	  @method reject
	  @static
	  @for RSVP
	  @param {*} reason value that the returned promise will be rejected with.
	  @param {String} label optional string for identifying the returned promise.
	  Useful for tooling.
	  @return {Promise} a promise rejected with the given `reason`.
	*/
	function reject$2(reason, label) {
	  return Promise.reject(reason, label);
	}
	
	/**
	 `RSVP.filter` is similar to JavaScript's native `filter` method, except that it
	  waits for all promises to become fulfilled before running the `filterFn` on
	  each item in given to `promises`. `RSVP.filter` returns a promise that will
	  become fulfilled with the result of running `filterFn` on the values the
	  promises become fulfilled with.
	
	  For example:
	
	  ```javascript
	
	  let promise1 = RSVP.resolve(1);
	  let promise2 = RSVP.resolve(2);
	  let promise3 = RSVP.resolve(3);
	
	  let promises = [promise1, promise2, promise3];
	
	  let filterFn = function(item){
	    return item > 1;
	  };
	
	  RSVP.filter(promises, filterFn).then(function(result){
	    // result is [ 2, 3 ]
	  });
	  ```
	
	  If any of the `promises` given to `RSVP.filter` are rejected, the first promise
	  that is rejected will be given as an argument to the returned promise's
	  rejection handler. For example:
	
	  ```javascript
	  let promise1 = RSVP.resolve(1);
	  let promise2 = RSVP.reject(new Error('2'));
	  let promise3 = RSVP.reject(new Error('3'));
	  let promises = [ promise1, promise2, promise3 ];
	
	  let filterFn = function(item){
	    return item > 1;
	  };
	
	  RSVP.filter(promises, filterFn).then(function(array){
	    // Code here never runs because there are rejected promises!
	  }, function(reason) {
	    // reason.message === '2'
	  });
	  ```
	
	  `RSVP.filter` will also wait for any promises returned from `filterFn`.
	  For instance, you may want to fetch a list of users then return a subset
	  of those users based on some asynchronous operation:
	
	  ```javascript
	
	  let alice = { name: 'alice' };
	  let bob   = { name: 'bob' };
	  let users = [ alice, bob ];
	
	  let promises = users.map(function(user){
	    return RSVP.resolve(user);
	  });
	
	  let filterFn = function(user){
	    // Here, Alice has permissions to create a blog post, but Bob does not.
	    return getPrivilegesForUser(user).then(function(privs){
	      return privs.can_create_blog_post === true;
	    });
	  };
	  RSVP.filter(promises, filterFn).then(function(users){
	    // true, because the server told us only Alice can create a blog post.
	    users.length === 1;
	    // false, because Alice is the only user present in `users`
	    users[0] === bob;
	  });
	  ```
	
	  @method filter
	  @static
	  @for RSVP
	  @param {Array} promises
	  @param {Function} filterFn - function to be called on each resolved value to
	  filter the final results.
	  @param {String} label optional string describing the promise. Useful for
	  tooling.
	  @return {Promise}
	*/
	
	function resolveAll(promises, label) {
	  return Promise.all(promises, label);
	}
	
	function resolveSingle(promise, label) {
	  return Promise.resolve(promise, label).then(function (promises) {
	    return resolveAll(promises, label);
	  });
	}
	
	function filter(promises, filterFn, label) {
	  if (!isArray(promises) && !(isObject(promises) && promises.then !== undefined)) {
	    return Promise.reject(new TypeError("RSVP.filter must be called with an array or promise"), label);
	  }
	
	  if (!isFunction(filterFn)) {
	    return Promise.reject(new TypeError("RSVP.filter expects function as a second argument"), label);
	  }
	
	  var promise = isArray(promises) ? resolveAll(promises, label) : resolveSingle(promises, label);
	  return promise.then(function (values) {
	    var length = values.length;
	    var filtered = new Array(length);
	
	    for (var i = 0; i < length; i++) {
	      filtered[i] = filterFn(values[i]);
	    }
	
	    return resolveAll(filtered, label).then(function (filtered) {
	      var results = new Array(length);
	      var newLength = 0;
	
	      for (var _i = 0; _i < length; _i++) {
	        if (filtered[_i]) {
	          results[newLength] = values[_i];
	          newLength++;
	        }
	      }
	
	      results.length = newLength;
	
	      return results;
	    });
	  });
	}
	
	var len = 0;
	var vertxNext = void 0;
	function asap(callback, arg) {
	  queue$1[len] = callback;
	  queue$1[len + 1] = arg;
	  len += 2;
	  if (len === 2) {
	    // If len is 1, that means that we need to schedule an async flush.
	    // If additional callbacks are queued before the queue is flushed, they
	    // will be processed by this flush that we are scheduling.
	    scheduleFlush$1();
	  }
	}
	
	var browserWindow = typeof window !== 'undefined' ? window : undefined;
	var browserGlobal = browserWindow || {};
	var BrowserMutationObserver = browserGlobal.MutationObserver || browserGlobal.WebKitMutationObserver;
	var isNode = typeof self === 'undefined' && typeof process !== 'undefined' && {}.toString.call(process) === '[object process]';
	
	// test for web worker but not in IE10
	// var isWorker = typeof Uint8ClampedArray !== 'undefined' && typeof importScripts !== 'undefined' && typeof MessageChannel !== 'undefined';
	var isWorker = typeof Uint8ClampedArray !== 'undefined' && window && window.Worker && typeof MessageChannel !== 'undefined';
	
	// node
	function useNextTick() {
	  var nextTick = process.nextTick;
	  // node version 0.10.x displays a deprecation warning when nextTick is used recursively
	  // setImmediate should be used instead instead
	  var version = process.versions.node.match(/^(?:(\d+)\.)?(?:(\d+)\.)?(\*|\d+)$/);
	  if (Array.isArray(version) && version[1] === '0' && version[2] === '10') {
	    nextTick = setImmediate;
	  }
	  return function () {
	    return nextTick(flush);
	  };
	}
	
	// vertx
	function useVertxTimer() {
	  if (typeof vertxNext !== 'undefined') {
	    return function () {
	      vertxNext(flush);
	    };
	  }
	  return useSetTimeout();
	}
	
	function useMutationObserver() {
	  var iterations = 0;
	  var observer = new BrowserMutationObserver(flush);
	  var node = document.createTextNode('');
	  observer.observe(node, { characterData: true });
	
	  return function () {
	    return node.data = iterations = ++iterations % 2;
	  };
	}
	
	// web worker
	function useMessageChannel() {
	  var channel = new MessageChannel();
	  channel.port1.onmessage = flush;
	  return function () {
	    return channel.port2.postMessage(0);
	  };
	}
	
	function useSetTimeout() {
	  return function () {
	    return setTimeout(flush, 1);
	  };
	}
	
	var queue$1 = new Array(1000);
	
	function flush() {
	  for (var i = 0; i < len; i += 2) {
	    var callback = queue$1[i];
	    var arg = queue$1[i + 1];
	
	    callback(arg);
	
	    queue$1[i] = undefined;
	    queue$1[i + 1] = undefined;
	  }
	
	  len = 0;
	}
	
	function attemptVertex() {
	  try {
	    var r = require;
	    var vertx = __webpack_require__(5);
	    vertxNext = vertx.runOnLoop || vertx.runOnContext;
	    return useVertxTimer();
	  } catch (e) {
	    return useSetTimeout();
	  }
	}
	
	var scheduleFlush$1 = void 0;
	// Decide what async method to use to triggering processing of queued callbacks:
	if (isNode) {
	  scheduleFlush$1 = useNextTick();
	} else if (isWorker) {
	  scheduleFlush$1 = useMessageChannel();
	} else if (BrowserMutationObserver) {
	  scheduleFlush$1 = useMutationObserver();
	} else if (browserWindow === undefined && "function" === 'function') {
	  scheduleFlush$1 = attemptVertex();
	} else {
	  scheduleFlush$1 = useSetTimeout();
	}
	
	var platform = void 0;
	
	/* global self */
	if (typeof self === 'object') {
	  platform = self;
	
	  /* global global */
	} else if (typeof global === 'object') {
	  platform = global;
	} else {
	  throw new Error('no global: `self` or `global` found');
	}
	
	var _asap$cast$Promise$Ev;
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	// defaults
	config.async = asap;
	config.after = function (cb) {
	  return setTimeout(cb, 0);
	};
	var cast = resolve$2;
	
	var async = function (callback, arg) {
	  return config.async(callback, arg);
	};
	
	function on() {
	  config['on'].apply(config, arguments);
	}
	
	function off() {
	  config['off'].apply(config, arguments);
	}
	
	// Set up instrumentation through `window.__PROMISE_INTRUMENTATION__`
	if (typeof window !== 'undefined' && typeof window['__PROMISE_INSTRUMENTATION__'] === 'object') {
	  var callbacks = window['__PROMISE_INSTRUMENTATION__'];
	  configure('instrument', true);
	  for (var eventName in callbacks) {
	    if (callbacks.hasOwnProperty(eventName)) {
	      on(eventName, callbacks[eventName]);
	    }
	  }
	}
	
	// the default export here is for backwards compat:
	//   https://github.com/tildeio/rsvp.js/issues/434
	var rsvp = (_asap$cast$Promise$Ev = {
	  asap: asap,
	  cast: cast,
	  Promise: Promise,
	  EventTarget: EventTarget,
	  all: all$1,
	  allSettled: allSettled,
	  race: race$1,
	  hash: hash,
	  hashSettled: hashSettled,
	  rethrow: rethrow,
	  defer: defer,
	  denodeify: denodeify,
	  configure: configure,
	  on: on,
	  off: off,
	  resolve: resolve$2,
	  reject: reject$2,
	  map: map
	}, _defineProperty(_asap$cast$Promise$Ev, 'async', async), _defineProperty(_asap$cast$Promise$Ev, 'filter', filter), _asap$cast$Promise$Ev);
	
	exports['default'] = rsvp;
	exports.asap = asap;
	exports.cast = cast;
	exports.Promise = Promise;
	exports.EventTarget = EventTarget;
	exports.all = all$1;
	exports.allSettled = allSettled;
	exports.race = race$1;
	exports.hash = hash;
	exports.hashSettled = hashSettled;
	exports.rethrow = rethrow;
	exports.defer = defer;
	exports.denodeify = denodeify;
	exports.configure = configure;
	exports.on = on;
	exports.off = off;
	exports.resolve = resolve$2;
	exports.reject = reject$2;
	exports.map = map;
	exports.async = async;
	exports.filter = filter;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));
	
	
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3), __webpack_require__(4).setImmediate, (function() { return this; }())))

/***/ },
/* 3 */
/***/ function(module, exports) {

	// shim for using process in browser
	var process = module.exports = {};
	
	// cached from whatever global is present so that test runners that stub it
	// don't break things.  But we need to wrap it in a try catch in case it is
	// wrapped in strict mode code which doesn't define any globals.  It's inside a
	// function because try/catches deoptimize in certain engines.
	
	var cachedSetTimeout;
	var cachedClearTimeout;
	
	function defaultSetTimout() {
	    throw new Error('setTimeout has not been defined');
	}
	function defaultClearTimeout () {
	    throw new Error('clearTimeout has not been defined');
	}
	(function () {
	    try {
	        if (typeof setTimeout === 'function') {
	            cachedSetTimeout = setTimeout;
	        } else {
	            cachedSetTimeout = defaultSetTimout;
	        }
	    } catch (e) {
	        cachedSetTimeout = defaultSetTimout;
	    }
	    try {
	        if (typeof clearTimeout === 'function') {
	            cachedClearTimeout = clearTimeout;
	        } else {
	            cachedClearTimeout = defaultClearTimeout;
	        }
	    } catch (e) {
	        cachedClearTimeout = defaultClearTimeout;
	    }
	} ())
	function runTimeout(fun) {
	    if (cachedSetTimeout === setTimeout) {
	        //normal enviroments in sane situations
	        return setTimeout(fun, 0);
	    }
	    // if setTimeout wasn't available but was latter defined
	    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
	        cachedSetTimeout = setTimeout;
	        return setTimeout(fun, 0);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedSetTimeout(fun, 0);
	    } catch(e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
	            return cachedSetTimeout.call(null, fun, 0);
	        } catch(e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
	            return cachedSetTimeout.call(this, fun, 0);
	        }
	    }
	
	
	}
	function runClearTimeout(marker) {
	    if (cachedClearTimeout === clearTimeout) {
	        //normal enviroments in sane situations
	        return clearTimeout(marker);
	    }
	    // if clearTimeout wasn't available but was latter defined
	    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
	        cachedClearTimeout = clearTimeout;
	        return clearTimeout(marker);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedClearTimeout(marker);
	    } catch (e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
	            return cachedClearTimeout.call(null, marker);
	        } catch (e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
	            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
	            return cachedClearTimeout.call(this, marker);
	        }
	    }
	
	
	
	}
	var queue = [];
	var draining = false;
	var currentQueue;
	var queueIndex = -1;
	
	function cleanUpNextTick() {
	    if (!draining || !currentQueue) {
	        return;
	    }
	    draining = false;
	    if (currentQueue.length) {
	        queue = currentQueue.concat(queue);
	    } else {
	        queueIndex = -1;
	    }
	    if (queue.length) {
	        drainQueue();
	    }
	}
	
	function drainQueue() {
	    if (draining) {
	        return;
	    }
	    var timeout = runTimeout(cleanUpNextTick);
	    draining = true;
	
	    var len = queue.length;
	    while(len) {
	        currentQueue = queue;
	        queue = [];
	        while (++queueIndex < len) {
	            if (currentQueue) {
	                currentQueue[queueIndex].run();
	            }
	        }
	        queueIndex = -1;
	        len = queue.length;
	    }
	    currentQueue = null;
	    draining = false;
	    runClearTimeout(timeout);
	}
	
	process.nextTick = function (fun) {
	    var args = new Array(arguments.length - 1);
	    if (arguments.length > 1) {
	        for (var i = 1; i < arguments.length; i++) {
	            args[i - 1] = arguments[i];
	        }
	    }
	    queue.push(new Item(fun, args));
	    if (queue.length === 1 && !draining) {
	        runTimeout(drainQueue);
	    }
	};
	
	// v8 likes predictible objects
	function Item(fun, array) {
	    this.fun = fun;
	    this.array = array;
	}
	Item.prototype.run = function () {
	    this.fun.apply(null, this.array);
	};
	process.title = 'browser';
	process.browser = true;
	process.env = {};
	process.argv = [];
	process.version = ''; // empty string to avoid regexp issues
	process.versions = {};
	
	function noop() {}
	
	process.on = noop;
	process.addListener = noop;
	process.once = noop;
	process.off = noop;
	process.removeListener = noop;
	process.removeAllListeners = noop;
	process.emit = noop;
	
	process.binding = function (name) {
	    throw new Error('process.binding is not supported');
	};
	
	process.cwd = function () { return '/' };
	process.chdir = function (dir) {
	    throw new Error('process.chdir is not supported');
	};
	process.umask = function() { return 0; };


/***/ },
/* 4 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(setImmediate, clearImmediate) {var nextTick = __webpack_require__(3).nextTick;
	var apply = Function.prototype.apply;
	var slice = Array.prototype.slice;
	var immediateIds = {};
	var nextImmediateId = 0;
	
	// DOM APIs, for completeness
	
	exports.setTimeout = function() {
	  return new Timeout(apply.call(setTimeout, window, arguments), clearTimeout);
	};
	exports.setInterval = function() {
	  return new Timeout(apply.call(setInterval, window, arguments), clearInterval);
	};
	exports.clearTimeout =
	exports.clearInterval = function(timeout) { timeout.close(); };
	
	function Timeout(id, clearFn) {
	  this._id = id;
	  this._clearFn = clearFn;
	}
	Timeout.prototype.unref = Timeout.prototype.ref = function() {};
	Timeout.prototype.close = function() {
	  this._clearFn.call(window, this._id);
	};
	
	// Does not start the time, just sets up the members needed.
	exports.enroll = function(item, msecs) {
	  clearTimeout(item._idleTimeoutId);
	  item._idleTimeout = msecs;
	};
	
	exports.unenroll = function(item) {
	  clearTimeout(item._idleTimeoutId);
	  item._idleTimeout = -1;
	};
	
	exports._unrefActive = exports.active = function(item) {
	  clearTimeout(item._idleTimeoutId);
	
	  var msecs = item._idleTimeout;
	  if (msecs >= 0) {
	    item._idleTimeoutId = setTimeout(function onTimeout() {
	      if (item._onTimeout)
	        item._onTimeout();
	    }, msecs);
	  }
	};
	
	// That's not how node.js implements it but the exposed api is the same.
	exports.setImmediate = typeof setImmediate === "function" ? setImmediate : function(fn) {
	  var id = nextImmediateId++;
	  var args = arguments.length < 2 ? false : slice.call(arguments, 1);
	
	  immediateIds[id] = true;
	
	  nextTick(function onNextTick() {
	    if (immediateIds[id]) {
	      // fn.call() is faster so we optimize for the common use-case
	      // @see http://jsperf.com/call-apply-segu
	      if (args) {
	        fn.apply(null, args);
	      } else {
	        fn.call(null);
	      }
	      // Prevent ids from leaking
	      exports.clearImmediate(id);
	    }
	  });
	
	  return id;
	};
	
	exports.clearImmediate = typeof clearImmediate === "function" ? clearImmediate : function(id) {
	  delete immediateIds[id];
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4).setImmediate, __webpack_require__(4).clearImmediate))

/***/ },
/* 5 */
/***/ function(module, exports) {

	/* (ignored) */

/***/ },
/* 6 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(7);

/***/ },
/* 7 */
/***/ function(module, exports) {

	// Generated by CoffeeScript 1.7.1
	var Module, moduleKeywords,
	  __indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; },
	  __slice = [].slice;
	
	moduleKeywords = ['extended', 'included'];
	
	exports.Module = Module = (function() {
	  function Module() {}
	
	  Module["extends"] = function(obj) {
	    var key, value, _ref;
	    for (key in obj) {
	      value = obj[key];
	      if (__indexOf.call(moduleKeywords, key) < 0) {
	        this[key] = value;
	      }
	    }
	    if ((_ref = obj.extended) != null) {
	      _ref.call(this, this);
	    }
	    return this;
	  };
	
	  Module.includes = function(obj) {
	    var key, value, _ref;
	    for (key in obj) {
	      value = obj[key];
	      if (__indexOf.call(moduleKeywords, key) < 0) {
	        this.prototype[key] = value;
	      }
	    }
	    if ((_ref = obj.included) != null) {
	      _ref.call(this, this);
	    }
	    return this;
	  };
	
	  Module.delegate = function() {
	    var args, source, target, _i, _len, _results;
	    args = 1 <= arguments.length ? __slice.call(arguments, 0) : [];
	    target = args.pop();
	    _results = [];
	    for (_i = 0, _len = args.length; _i < _len; _i++) {
	      source = args[_i];
	      _results.push(this.prototype[source] = target.prototype[source]);
	    }
	    return _results;
	  };
	
	  Module.aliasFunction = function(to, from) {
	    return this.prototype[to] = (function(_this) {
	      return function() {
	        var args;
	        args = 1 <= arguments.length ? __slice.call(arguments, 0) : [];
	        return _this.prototype[from].apply(_this, args);
	      };
	    })(this);
	  };
	
	  Module.aliasProperty = function(to, from) {
	    return Object.defineProperty(this.prototype, to, {
	      get: function() {
	        return this[from];
	      },
	      set: function(val) {
	        return this[from] = val;
	      }
	    });
	  };
	
	  Module.included = function(func) {
	    return func.call(this, this.prototype);
	  };
	
	  return Module;
	
	})();


/***/ },
/* 8 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {// Generated by CoffeeScript 1.11.1
	(function() {
	  var Color, File, Long, Util, iconv, jspack,
	    hasProp = {}.hasOwnProperty;
	
	  jspack = __webpack_require__(13).jspack;
	
	  Long = __webpack_require__(14);
	
	  iconv = __webpack_require__(15);
	
	  Color = __webpack_require__(56);
	
	  Util = __webpack_require__(57);
	
	  module.exports = File = (function() {
	    var FORMATS, fn, format, info;
	
	    FORMATS = {
	      Int: {
	        code: '>i',
	        length: 4
	      },
	      UInt: {
	        code: '>I',
	        length: 4
	      },
	      Short: {
	        code: '>h',
	        length: 2
	      },
	      UShort: {
	        code: '>H',
	        length: 2
	      },
	      Float: {
	        code: '>f',
	        length: 4
	      },
	      Double: {
	        code: '>d',
	        length: 8
	      },
	      LongLong: {
	        code: '>q',
	        length: 8
	      }
	    };
	
	    fn = function(format, info) {
	      return File.prototype["read" + format] = function() {
	        return this.readf(info.code, info.length);
	      };
	    };
	    for (format in FORMATS) {
	      if (!hasProp.call(FORMATS, format)) continue;
	      info = FORMATS[format];
	      fn(format, info);
	    }
	
	    File.prototype.pos = 0;
	
	    function File(data) {
	      this.data = data;
	    }
	
	    File.prototype.tell = function() {
	      return this.pos;
	    };
	
	    File.prototype.read = function(length) {
	      var i, j, ref, results;
	      results = [];
	      for (i = j = 0, ref = length; 0 <= ref ? j < ref : j > ref; i = 0 <= ref ? ++j : --j) {
	        results.push(this.data[this.pos++]);
	      }
	      return results;
	    };
	
	    File.prototype.readf = function(format, len) {
	      var value;
	      if (len == null) {
	        len = null;
	      }
	      value = jspack.Unpack(format, this.read(len || jspack.CalcLength(format)));
	      value = value[0];
	      if (format === '>q') {
	        value = new Long(value[0], value[1], value[2]);
	        if (value.getNumBitsAbs() > 32) {
	          throw "PSB is too large";
	        } else {
	          value = value.toInt();
	        }
	      }
	      return value;
	    };
	
	    File.prototype.seek = function(amt, rel) {
	      if (rel == null) {
	        rel = false;
	      }
	      if (rel) {
	        return this.pos = this.pos + amt;
	      } else {
	        return this.pos = amt;
	      }
	    };
	
	    File.prototype.readString = function(length) {
	      return String.fromCharCode.apply(null, this.read(length)).replace(/\u0000/g, "");
	    };
	
	    File.prototype.readUnicodeString = function(length) {
	      if (length == null) {
	        length = null;
	      }
	      length || (length = this.readInt());
	      return iconv.decode(new Buffer(this.read(length * 2)), 'utf-16be').replace(/\u0000/g, "");
	    };
	
	    File.prototype.readByte = function() {
	      return this.read(1)[0];
	    };
	
	    File.prototype.readBoolean = function() {
	      return this.readByte() !== 0;
	    };
	
	    File.prototype.readSpaceColor = function() {
	      var colorComponent, colorSpace, i, j;
	      colorSpace = this.readShort();
	      for (i = j = 0; j < 4; i = ++j) {
	        colorComponent = this.readShort() >> 8;
	      }
	      return {
	        colorSpace: colorSpace,
	        components: colorComponent
	      };
	    };
	
	    File.prototype.readPathNumber = function() {
	      var a, arr, b, b1, b2, b3;
	      a = this.readByte();
	      arr = this.read(3);
	      b1 = arr[0] << 16;
	      b2 = arr[1] << 8;
	      b3 = arr[2];
	      b = b1 | b2 | b3;
	      return parseFloat(a, 10) + parseFloat(b / Math.pow(2, 24), 10);
	    };
	
	    return File;
	
	  })();
	
	}).call(this);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(9).Buffer))

/***/ },
/* 9 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer, global) {/*!
	 * The buffer module from node.js, for the browser.
	 *
	 * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
	 * @license  MIT
	 */
	/* eslint-disable no-proto */
	
	'use strict'
	
	var base64 = __webpack_require__(10)
	var ieee754 = __webpack_require__(11)
	var isArray = __webpack_require__(12)
	
	exports.Buffer = Buffer
	exports.SlowBuffer = SlowBuffer
	exports.INSPECT_MAX_BYTES = 50
	
	/**
	 * If `Buffer.TYPED_ARRAY_SUPPORT`:
	 *   === true    Use Uint8Array implementation (fastest)
	 *   === false   Use Object implementation (most compatible, even IE6)
	 *
	 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
	 * Opera 11.6+, iOS 4.2+.
	 *
	 * Due to various browser bugs, sometimes the Object implementation will be used even
	 * when the browser supports typed arrays.
	 *
	 * Note:
	 *
	 *   - Firefox 4-29 lacks support for adding new properties to `Uint8Array` instances,
	 *     See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438.
	 *
	 *   - Chrome 9-10 is missing the `TypedArray.prototype.subarray` function.
	 *
	 *   - IE10 has a broken `TypedArray.prototype.subarray` function which returns arrays of
	 *     incorrect length in some situations.
	
	 * We detect these buggy browsers and set `Buffer.TYPED_ARRAY_SUPPORT` to `false` so they
	 * get the Object implementation, which is slower but behaves correctly.
	 */
	Buffer.TYPED_ARRAY_SUPPORT = global.TYPED_ARRAY_SUPPORT !== undefined
	  ? global.TYPED_ARRAY_SUPPORT
	  : typedArraySupport()
	
	/*
	 * Export kMaxLength after typed array support is determined.
	 */
	exports.kMaxLength = kMaxLength()
	
	function typedArraySupport () {
	  try {
	    var arr = new Uint8Array(1)
	    arr.__proto__ = {__proto__: Uint8Array.prototype, foo: function () { return 42 }}
	    return arr.foo() === 42 && // typed array instances can be augmented
	        typeof arr.subarray === 'function' && // chrome 9-10 lack `subarray`
	        arr.subarray(1, 1).byteLength === 0 // ie10 has broken `subarray`
	  } catch (e) {
	    return false
	  }
	}
	
	function kMaxLength () {
	  return Buffer.TYPED_ARRAY_SUPPORT
	    ? 0x7fffffff
	    : 0x3fffffff
	}
	
	function createBuffer (that, length) {
	  if (kMaxLength() < length) {
	    throw new RangeError('Invalid typed array length')
	  }
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    // Return an augmented `Uint8Array` instance, for best performance
	    that = new Uint8Array(length)
	    that.__proto__ = Buffer.prototype
	  } else {
	    // Fallback: Return an object instance of the Buffer class
	    if (that === null) {
	      that = new Buffer(length)
	    }
	    that.length = length
	  }
	
	  return that
	}
	
	/**
	 * The Buffer constructor returns instances of `Uint8Array` that have their
	 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
	 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
	 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
	 * returns a single octet.
	 *
	 * The `Uint8Array` prototype remains unmodified.
	 */
	
	function Buffer (arg, encodingOrOffset, length) {
	  if (!Buffer.TYPED_ARRAY_SUPPORT && !(this instanceof Buffer)) {
	    return new Buffer(arg, encodingOrOffset, length)
	  }
	
	  // Common case.
	  if (typeof arg === 'number') {
	    if (typeof encodingOrOffset === 'string') {
	      throw new Error(
	        'If encoding is specified then the first argument must be a string'
	      )
	    }
	    return allocUnsafe(this, arg)
	  }
	  return from(this, arg, encodingOrOffset, length)
	}
	
	Buffer.poolSize = 8192 // not used by this implementation
	
	// TODO: Legacy, not needed anymore. Remove in next major version.
	Buffer._augment = function (arr) {
	  arr.__proto__ = Buffer.prototype
	  return arr
	}
	
	function from (that, value, encodingOrOffset, length) {
	  if (typeof value === 'number') {
	    throw new TypeError('"value" argument must not be a number')
	  }
	
	  if (typeof ArrayBuffer !== 'undefined' && value instanceof ArrayBuffer) {
	    return fromArrayBuffer(that, value, encodingOrOffset, length)
	  }
	
	  if (typeof value === 'string') {
	    return fromString(that, value, encodingOrOffset)
	  }
	
	  return fromObject(that, value)
	}
	
	/**
	 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
	 * if value is a number.
	 * Buffer.from(str[, encoding])
	 * Buffer.from(array)
	 * Buffer.from(buffer)
	 * Buffer.from(arrayBuffer[, byteOffset[, length]])
	 **/
	Buffer.from = function (value, encodingOrOffset, length) {
	  return from(null, value, encodingOrOffset, length)
	}
	
	if (Buffer.TYPED_ARRAY_SUPPORT) {
	  Buffer.prototype.__proto__ = Uint8Array.prototype
	  Buffer.__proto__ = Uint8Array
	  if (typeof Symbol !== 'undefined' && Symbol.species &&
	      Buffer[Symbol.species] === Buffer) {
	    // Fix subarray() in ES2016. See: https://github.com/feross/buffer/pull/97
	    Object.defineProperty(Buffer, Symbol.species, {
	      value: null,
	      configurable: true
	    })
	  }
	}
	
	function assertSize (size) {
	  if (typeof size !== 'number') {
	    throw new TypeError('"size" argument must be a number')
	  } else if (size < 0) {
	    throw new RangeError('"size" argument must not be negative')
	  }
	}
	
	function alloc (that, size, fill, encoding) {
	  assertSize(size)
	  if (size <= 0) {
	    return createBuffer(that, size)
	  }
	  if (fill !== undefined) {
	    // Only pay attention to encoding if it's a string. This
	    // prevents accidentally sending in a number that would
	    // be interpretted as a start offset.
	    return typeof encoding === 'string'
	      ? createBuffer(that, size).fill(fill, encoding)
	      : createBuffer(that, size).fill(fill)
	  }
	  return createBuffer(that, size)
	}
	
	/**
	 * Creates a new filled Buffer instance.
	 * alloc(size[, fill[, encoding]])
	 **/
	Buffer.alloc = function (size, fill, encoding) {
	  return alloc(null, size, fill, encoding)
	}
	
	function allocUnsafe (that, size) {
	  assertSize(size)
	  that = createBuffer(that, size < 0 ? 0 : checked(size) | 0)
	  if (!Buffer.TYPED_ARRAY_SUPPORT) {
	    for (var i = 0; i < size; ++i) {
	      that[i] = 0
	    }
	  }
	  return that
	}
	
	/**
	 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
	 * */
	Buffer.allocUnsafe = function (size) {
	  return allocUnsafe(null, size)
	}
	/**
	 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
	 */
	Buffer.allocUnsafeSlow = function (size) {
	  return allocUnsafe(null, size)
	}
	
	function fromString (that, string, encoding) {
	  if (typeof encoding !== 'string' || encoding === '') {
	    encoding = 'utf8'
	  }
	
	  if (!Buffer.isEncoding(encoding)) {
	    throw new TypeError('"encoding" must be a valid string encoding')
	  }
	
	  var length = byteLength(string, encoding) | 0
	  that = createBuffer(that, length)
	
	  var actual = that.write(string, encoding)
	
	  if (actual !== length) {
	    // Writing a hex string, for example, that contains invalid characters will
	    // cause everything after the first invalid character to be ignored. (e.g.
	    // 'abxxcd' will be treated as 'ab')
	    that = that.slice(0, actual)
	  }
	
	  return that
	}
	
	function fromArrayLike (that, array) {
	  var length = array.length < 0 ? 0 : checked(array.length) | 0
	  that = createBuffer(that, length)
	  for (var i = 0; i < length; i += 1) {
	    that[i] = array[i] & 255
	  }
	  return that
	}
	
	function fromArrayBuffer (that, array, byteOffset, length) {
	  array.byteLength // this throws if `array` is not a valid ArrayBuffer
	
	  if (byteOffset < 0 || array.byteLength < byteOffset) {
	    throw new RangeError('\'offset\' is out of bounds')
	  }
	
	  if (array.byteLength < byteOffset + (length || 0)) {
	    throw new RangeError('\'length\' is out of bounds')
	  }
	
	  if (byteOffset === undefined && length === undefined) {
	    array = new Uint8Array(array)
	  } else if (length === undefined) {
	    array = new Uint8Array(array, byteOffset)
	  } else {
	    array = new Uint8Array(array, byteOffset, length)
	  }
	
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    // Return an augmented `Uint8Array` instance, for best performance
	    that = array
	    that.__proto__ = Buffer.prototype
	  } else {
	    // Fallback: Return an object instance of the Buffer class
	    that = fromArrayLike(that, array)
	  }
	  return that
	}
	
	function fromObject (that, obj) {
	  if (Buffer.isBuffer(obj)) {
	    var len = checked(obj.length) | 0
	    that = createBuffer(that, len)
	
	    if (that.length === 0) {
	      return that
	    }
	
	    obj.copy(that, 0, 0, len)
	    return that
	  }
	
	  if (obj) {
	    if ((typeof ArrayBuffer !== 'undefined' &&
	        obj.buffer instanceof ArrayBuffer) || 'length' in obj) {
	      if (typeof obj.length !== 'number' || isnan(obj.length)) {
	        return createBuffer(that, 0)
	      }
	      return fromArrayLike(that, obj)
	    }
	
	    if (obj.type === 'Buffer' && isArray(obj.data)) {
	      return fromArrayLike(that, obj.data)
	    }
	  }
	
	  throw new TypeError('First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.')
	}
	
	function checked (length) {
	  // Note: cannot use `length < kMaxLength()` here because that fails when
	  // length is NaN (which is otherwise coerced to zero.)
	  if (length >= kMaxLength()) {
	    throw new RangeError('Attempt to allocate Buffer larger than maximum ' +
	                         'size: 0x' + kMaxLength().toString(16) + ' bytes')
	  }
	  return length | 0
	}
	
	function SlowBuffer (length) {
	  if (+length != length) { // eslint-disable-line eqeqeq
	    length = 0
	  }
	  return Buffer.alloc(+length)
	}
	
	Buffer.isBuffer = function isBuffer (b) {
	  return !!(b != null && b._isBuffer)
	}
	
	Buffer.compare = function compare (a, b) {
	  if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) {
	    throw new TypeError('Arguments must be Buffers')
	  }
	
	  if (a === b) return 0
	
	  var x = a.length
	  var y = b.length
	
	  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
	    if (a[i] !== b[i]) {
	      x = a[i]
	      y = b[i]
	      break
	    }
	  }
	
	  if (x < y) return -1
	  if (y < x) return 1
	  return 0
	}
	
	Buffer.isEncoding = function isEncoding (encoding) {
	  switch (String(encoding).toLowerCase()) {
	    case 'hex':
	    case 'utf8':
	    case 'utf-8':
	    case 'ascii':
	    case 'latin1':
	    case 'binary':
	    case 'base64':
	    case 'ucs2':
	    case 'ucs-2':
	    case 'utf16le':
	    case 'utf-16le':
	      return true
	    default:
	      return false
	  }
	}
	
	Buffer.concat = function concat (list, length) {
	  if (!isArray(list)) {
	    throw new TypeError('"list" argument must be an Array of Buffers')
	  }
	
	  if (list.length === 0) {
	    return Buffer.alloc(0)
	  }
	
	  var i
	  if (length === undefined) {
	    length = 0
	    for (i = 0; i < list.length; ++i) {
	      length += list[i].length
	    }
	  }
	
	  var buffer = Buffer.allocUnsafe(length)
	  var pos = 0
	  for (i = 0; i < list.length; ++i) {
	    var buf = list[i]
	    if (!Buffer.isBuffer(buf)) {
	      throw new TypeError('"list" argument must be an Array of Buffers')
	    }
	    buf.copy(buffer, pos)
	    pos += buf.length
	  }
	  return buffer
	}
	
	function byteLength (string, encoding) {
	  if (Buffer.isBuffer(string)) {
	    return string.length
	  }
	  if (typeof ArrayBuffer !== 'undefined' && typeof ArrayBuffer.isView === 'function' &&
	      (ArrayBuffer.isView(string) || string instanceof ArrayBuffer)) {
	    return string.byteLength
	  }
	  if (typeof string !== 'string') {
	    string = '' + string
	  }
	
	  var len = string.length
	  if (len === 0) return 0
	
	  // Use a for loop to avoid recursion
	  var loweredCase = false
	  for (;;) {
	    switch (encoding) {
	      case 'ascii':
	      case 'latin1':
	      case 'binary':
	        return len
	      case 'utf8':
	      case 'utf-8':
	      case undefined:
	        return utf8ToBytes(string).length
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return len * 2
	      case 'hex':
	        return len >>> 1
	      case 'base64':
	        return base64ToBytes(string).length
	      default:
	        if (loweredCase) return utf8ToBytes(string).length // assume utf8
	        encoding = ('' + encoding).toLowerCase()
	        loweredCase = true
	    }
	  }
	}
	Buffer.byteLength = byteLength
	
	function slowToString (encoding, start, end) {
	  var loweredCase = false
	
	  // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
	  // property of a typed array.
	
	  // This behaves neither like String nor Uint8Array in that we set start/end
	  // to their upper/lower bounds if the value passed is out of range.
	  // undefined is handled specially as per ECMA-262 6th Edition,
	  // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
	  if (start === undefined || start < 0) {
	    start = 0
	  }
	  // Return early if start > this.length. Done here to prevent potential uint32
	  // coercion fail below.
	  if (start > this.length) {
	    return ''
	  }
	
	  if (end === undefined || end > this.length) {
	    end = this.length
	  }
	
	  if (end <= 0) {
	    return ''
	  }
	
	  // Force coersion to uint32. This will also coerce falsey/NaN values to 0.
	  end >>>= 0
	  start >>>= 0
	
	  if (end <= start) {
	    return ''
	  }
	
	  if (!encoding) encoding = 'utf8'
	
	  while (true) {
	    switch (encoding) {
	      case 'hex':
	        return hexSlice(this, start, end)
	
	      case 'utf8':
	      case 'utf-8':
	        return utf8Slice(this, start, end)
	
	      case 'ascii':
	        return asciiSlice(this, start, end)
	
	      case 'latin1':
	      case 'binary':
	        return latin1Slice(this, start, end)
	
	      case 'base64':
	        return base64Slice(this, start, end)
	
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return utf16leSlice(this, start, end)
	
	      default:
	        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
	        encoding = (encoding + '').toLowerCase()
	        loweredCase = true
	    }
	  }
	}
	
	// The property is used by `Buffer.isBuffer` and `is-buffer` (in Safari 5-7) to detect
	// Buffer instances.
	Buffer.prototype._isBuffer = true
	
	function swap (b, n, m) {
	  var i = b[n]
	  b[n] = b[m]
	  b[m] = i
	}
	
	Buffer.prototype.swap16 = function swap16 () {
	  var len = this.length
	  if (len % 2 !== 0) {
	    throw new RangeError('Buffer size must be a multiple of 16-bits')
	  }
	  for (var i = 0; i < len; i += 2) {
	    swap(this, i, i + 1)
	  }
	  return this
	}
	
	Buffer.prototype.swap32 = function swap32 () {
	  var len = this.length
	  if (len % 4 !== 0) {
	    throw new RangeError('Buffer size must be a multiple of 32-bits')
	  }
	  for (var i = 0; i < len; i += 4) {
	    swap(this, i, i + 3)
	    swap(this, i + 1, i + 2)
	  }
	  return this
	}
	
	Buffer.prototype.swap64 = function swap64 () {
	  var len = this.length
	  if (len % 8 !== 0) {
	    throw new RangeError('Buffer size must be a multiple of 64-bits')
	  }
	  for (var i = 0; i < len; i += 8) {
	    swap(this, i, i + 7)
	    swap(this, i + 1, i + 6)
	    swap(this, i + 2, i + 5)
	    swap(this, i + 3, i + 4)
	  }
	  return this
	}
	
	Buffer.prototype.toString = function toString () {
	  var length = this.length | 0
	  if (length === 0) return ''
	  if (arguments.length === 0) return utf8Slice(this, 0, length)
	  return slowToString.apply(this, arguments)
	}
	
	Buffer.prototype.equals = function equals (b) {
	  if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer')
	  if (this === b) return true
	  return Buffer.compare(this, b) === 0
	}
	
	Buffer.prototype.inspect = function inspect () {
	  var str = ''
	  var max = exports.INSPECT_MAX_BYTES
	  if (this.length > 0) {
	    str = this.toString('hex', 0, max).match(/.{2}/g).join(' ')
	    if (this.length > max) str += ' ... '
	  }
	  return '<Buffer ' + str + '>'
	}
	
	Buffer.prototype.compare = function compare (target, start, end, thisStart, thisEnd) {
	  if (!Buffer.isBuffer(target)) {
	    throw new TypeError('Argument must be a Buffer')
	  }
	
	  if (start === undefined) {
	    start = 0
	  }
	  if (end === undefined) {
	    end = target ? target.length : 0
	  }
	  if (thisStart === undefined) {
	    thisStart = 0
	  }
	  if (thisEnd === undefined) {
	    thisEnd = this.length
	  }
	
	  if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
	    throw new RangeError('out of range index')
	  }
	
	  if (thisStart >= thisEnd && start >= end) {
	    return 0
	  }
	  if (thisStart >= thisEnd) {
	    return -1
	  }
	  if (start >= end) {
	    return 1
	  }
	
	  start >>>= 0
	  end >>>= 0
	  thisStart >>>= 0
	  thisEnd >>>= 0
	
	  if (this === target) return 0
	
	  var x = thisEnd - thisStart
	  var y = end - start
	  var len = Math.min(x, y)
	
	  var thisCopy = this.slice(thisStart, thisEnd)
	  var targetCopy = target.slice(start, end)
	
	  for (var i = 0; i < len; ++i) {
	    if (thisCopy[i] !== targetCopy[i]) {
	      x = thisCopy[i]
	      y = targetCopy[i]
	      break
	    }
	  }
	
	  if (x < y) return -1
	  if (y < x) return 1
	  return 0
	}
	
	// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
	// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
	//
	// Arguments:
	// - buffer - a Buffer to search
	// - val - a string, Buffer, or number
	// - byteOffset - an index into `buffer`; will be clamped to an int32
	// - encoding - an optional encoding, relevant is val is a string
	// - dir - true for indexOf, false for lastIndexOf
	function bidirectionalIndexOf (buffer, val, byteOffset, encoding, dir) {
	  // Empty buffer means no match
	  if (buffer.length === 0) return -1
	
	  // Normalize byteOffset
	  if (typeof byteOffset === 'string') {
	    encoding = byteOffset
	    byteOffset = 0
	  } else if (byteOffset > 0x7fffffff) {
	    byteOffset = 0x7fffffff
	  } else if (byteOffset < -0x80000000) {
	    byteOffset = -0x80000000
	  }
	  byteOffset = +byteOffset  // Coerce to Number.
	  if (isNaN(byteOffset)) {
	    // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
	    byteOffset = dir ? 0 : (buffer.length - 1)
	  }
	
	  // Normalize byteOffset: negative offsets start from the end of the buffer
	  if (byteOffset < 0) byteOffset = buffer.length + byteOffset
	  if (byteOffset >= buffer.length) {
	    if (dir) return -1
	    else byteOffset = buffer.length - 1
	  } else if (byteOffset < 0) {
	    if (dir) byteOffset = 0
	    else return -1
	  }
	
	  // Normalize val
	  if (typeof val === 'string') {
	    val = Buffer.from(val, encoding)
	  }
	
	  // Finally, search either indexOf (if dir is true) or lastIndexOf
	  if (Buffer.isBuffer(val)) {
	    // Special case: looking for empty string/buffer always fails
	    if (val.length === 0) {
	      return -1
	    }
	    return arrayIndexOf(buffer, val, byteOffset, encoding, dir)
	  } else if (typeof val === 'number') {
	    val = val & 0xFF // Search for a byte value [0-255]
	    if (Buffer.TYPED_ARRAY_SUPPORT &&
	        typeof Uint8Array.prototype.indexOf === 'function') {
	      if (dir) {
	        return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset)
	      } else {
	        return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset)
	      }
	    }
	    return arrayIndexOf(buffer, [ val ], byteOffset, encoding, dir)
	  }
	
	  throw new TypeError('val must be string, number or Buffer')
	}
	
	function arrayIndexOf (arr, val, byteOffset, encoding, dir) {
	  var indexSize = 1
	  var arrLength = arr.length
	  var valLength = val.length
	
	  if (encoding !== undefined) {
	    encoding = String(encoding).toLowerCase()
	    if (encoding === 'ucs2' || encoding === 'ucs-2' ||
	        encoding === 'utf16le' || encoding === 'utf-16le') {
	      if (arr.length < 2 || val.length < 2) {
	        return -1
	      }
	      indexSize = 2
	      arrLength /= 2
	      valLength /= 2
	      byteOffset /= 2
	    }
	  }
	
	  function read (buf, i) {
	    if (indexSize === 1) {
	      return buf[i]
	    } else {
	      return buf.readUInt16BE(i * indexSize)
	    }
	  }
	
	  var i
	  if (dir) {
	    var foundIndex = -1
	    for (i = byteOffset; i < arrLength; i++) {
	      if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
	        if (foundIndex === -1) foundIndex = i
	        if (i - foundIndex + 1 === valLength) return foundIndex * indexSize
	      } else {
	        if (foundIndex !== -1) i -= i - foundIndex
	        foundIndex = -1
	      }
	    }
	  } else {
	    if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength
	    for (i = byteOffset; i >= 0; i--) {
	      var found = true
	      for (var j = 0; j < valLength; j++) {
	        if (read(arr, i + j) !== read(val, j)) {
	          found = false
	          break
	        }
	      }
	      if (found) return i
	    }
	  }
	
	  return -1
	}
	
	Buffer.prototype.includes = function includes (val, byteOffset, encoding) {
	  return this.indexOf(val, byteOffset, encoding) !== -1
	}
	
	Buffer.prototype.indexOf = function indexOf (val, byteOffset, encoding) {
	  return bidirectionalIndexOf(this, val, byteOffset, encoding, true)
	}
	
	Buffer.prototype.lastIndexOf = function lastIndexOf (val, byteOffset, encoding) {
	  return bidirectionalIndexOf(this, val, byteOffset, encoding, false)
	}
	
	function hexWrite (buf, string, offset, length) {
	  offset = Number(offset) || 0
	  var remaining = buf.length - offset
	  if (!length) {
	    length = remaining
	  } else {
	    length = Number(length)
	    if (length > remaining) {
	      length = remaining
	    }
	  }
	
	  // must be an even number of digits
	  var strLen = string.length
	  if (strLen % 2 !== 0) throw new TypeError('Invalid hex string')
	
	  if (length > strLen / 2) {
	    length = strLen / 2
	  }
	  for (var i = 0; i < length; ++i) {
	    var parsed = parseInt(string.substr(i * 2, 2), 16)
	    if (isNaN(parsed)) return i
	    buf[offset + i] = parsed
	  }
	  return i
	}
	
	function utf8Write (buf, string, offset, length) {
	  return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length)
	}
	
	function asciiWrite (buf, string, offset, length) {
	  return blitBuffer(asciiToBytes(string), buf, offset, length)
	}
	
	function latin1Write (buf, string, offset, length) {
	  return asciiWrite(buf, string, offset, length)
	}
	
	function base64Write (buf, string, offset, length) {
	  return blitBuffer(base64ToBytes(string), buf, offset, length)
	}
	
	function ucs2Write (buf, string, offset, length) {
	  return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length)
	}
	
	Buffer.prototype.write = function write (string, offset, length, encoding) {
	  // Buffer#write(string)
	  if (offset === undefined) {
	    encoding = 'utf8'
	    length = this.length
	    offset = 0
	  // Buffer#write(string, encoding)
	  } else if (length === undefined && typeof offset === 'string') {
	    encoding = offset
	    length = this.length
	    offset = 0
	  // Buffer#write(string, offset[, length][, encoding])
	  } else if (isFinite(offset)) {
	    offset = offset | 0
	    if (isFinite(length)) {
	      length = length | 0
	      if (encoding === undefined) encoding = 'utf8'
	    } else {
	      encoding = length
	      length = undefined
	    }
	  // legacy write(string, encoding, offset, length) - remove in v0.13
	  } else {
	    throw new Error(
	      'Buffer.write(string, encoding, offset[, length]) is no longer supported'
	    )
	  }
	
	  var remaining = this.length - offset
	  if (length === undefined || length > remaining) length = remaining
	
	  if ((string.length > 0 && (length < 0 || offset < 0)) || offset > this.length) {
	    throw new RangeError('Attempt to write outside buffer bounds')
	  }
	
	  if (!encoding) encoding = 'utf8'
	
	  var loweredCase = false
	  for (;;) {
	    switch (encoding) {
	      case 'hex':
	        return hexWrite(this, string, offset, length)
	
	      case 'utf8':
	      case 'utf-8':
	        return utf8Write(this, string, offset, length)
	
	      case 'ascii':
	        return asciiWrite(this, string, offset, length)
	
	      case 'latin1':
	      case 'binary':
	        return latin1Write(this, string, offset, length)
	
	      case 'base64':
	        // Warning: maxLength not taken into account in base64Write
	        return base64Write(this, string, offset, length)
	
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return ucs2Write(this, string, offset, length)
	
	      default:
	        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
	        encoding = ('' + encoding).toLowerCase()
	        loweredCase = true
	    }
	  }
	}
	
	Buffer.prototype.toJSON = function toJSON () {
	  return {
	    type: 'Buffer',
	    data: Array.prototype.slice.call(this._arr || this, 0)
	  }
	}
	
	function base64Slice (buf, start, end) {
	  if (start === 0 && end === buf.length) {
	    return base64.fromByteArray(buf)
	  } else {
	    return base64.fromByteArray(buf.slice(start, end))
	  }
	}
	
	function utf8Slice (buf, start, end) {
	  end = Math.min(buf.length, end)
	  var res = []
	
	  var i = start
	  while (i < end) {
	    var firstByte = buf[i]
	    var codePoint = null
	    var bytesPerSequence = (firstByte > 0xEF) ? 4
	      : (firstByte > 0xDF) ? 3
	      : (firstByte > 0xBF) ? 2
	      : 1
	
	    if (i + bytesPerSequence <= end) {
	      var secondByte, thirdByte, fourthByte, tempCodePoint
	
	      switch (bytesPerSequence) {
	        case 1:
	          if (firstByte < 0x80) {
	            codePoint = firstByte
	          }
	          break
	        case 2:
	          secondByte = buf[i + 1]
	          if ((secondByte & 0xC0) === 0x80) {
	            tempCodePoint = (firstByte & 0x1F) << 0x6 | (secondByte & 0x3F)
	            if (tempCodePoint > 0x7F) {
	              codePoint = tempCodePoint
	            }
	          }
	          break
	        case 3:
	          secondByte = buf[i + 1]
	          thirdByte = buf[i + 2]
	          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
	            tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | (thirdByte & 0x3F)
	            if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) {
	              codePoint = tempCodePoint
	            }
	          }
	          break
	        case 4:
	          secondByte = buf[i + 1]
	          thirdByte = buf[i + 2]
	          fourthByte = buf[i + 3]
	          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
	            tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | (fourthByte & 0x3F)
	            if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) {
	              codePoint = tempCodePoint
	            }
	          }
	      }
	    }
	
	    if (codePoint === null) {
	      // we did not generate a valid codePoint so insert a
	      // replacement char (U+FFFD) and advance only 1 byte
	      codePoint = 0xFFFD
	      bytesPerSequence = 1
	    } else if (codePoint > 0xFFFF) {
	      // encode to utf16 (surrogate pair dance)
	      codePoint -= 0x10000
	      res.push(codePoint >>> 10 & 0x3FF | 0xD800)
	      codePoint = 0xDC00 | codePoint & 0x3FF
	    }
	
	    res.push(codePoint)
	    i += bytesPerSequence
	  }
	
	  return decodeCodePointsArray(res)
	}
	
	// Based on http://stackoverflow.com/a/22747272/680742, the browser with
	// the lowest limit is Chrome, with 0x10000 args.
	// We go 1 magnitude less, for safety
	var MAX_ARGUMENTS_LENGTH = 0x1000
	
	function decodeCodePointsArray (codePoints) {
	  var len = codePoints.length
	  if (len <= MAX_ARGUMENTS_LENGTH) {
	    return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
	  }
	
	  // Decode in chunks to avoid "call stack size exceeded".
	  var res = ''
	  var i = 0
	  while (i < len) {
	    res += String.fromCharCode.apply(
	      String,
	      codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH)
	    )
	  }
	  return res
	}
	
	function asciiSlice (buf, start, end) {
	  var ret = ''
	  end = Math.min(buf.length, end)
	
	  for (var i = start; i < end; ++i) {
	    ret += String.fromCharCode(buf[i] & 0x7F)
	  }
	  return ret
	}
	
	function latin1Slice (buf, start, end) {
	  var ret = ''
	  end = Math.min(buf.length, end)
	
	  for (var i = start; i < end; ++i) {
	    ret += String.fromCharCode(buf[i])
	  }
	  return ret
	}
	
	function hexSlice (buf, start, end) {
	  var len = buf.length
	
	  if (!start || start < 0) start = 0
	  if (!end || end < 0 || end > len) end = len
	
	  var out = ''
	  for (var i = start; i < end; ++i) {
	    out += toHex(buf[i])
	  }
	  return out
	}
	
	function utf16leSlice (buf, start, end) {
	  var bytes = buf.slice(start, end)
	  var res = ''
	  for (var i = 0; i < bytes.length; i += 2) {
	    res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256)
	  }
	  return res
	}
	
	Buffer.prototype.slice = function slice (start, end) {
	  var len = this.length
	  start = ~~start
	  end = end === undefined ? len : ~~end
	
	  if (start < 0) {
	    start += len
	    if (start < 0) start = 0
	  } else if (start > len) {
	    start = len
	  }
	
	  if (end < 0) {
	    end += len
	    if (end < 0) end = 0
	  } else if (end > len) {
	    end = len
	  }
	
	  if (end < start) end = start
	
	  var newBuf
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    newBuf = this.subarray(start, end)
	    newBuf.__proto__ = Buffer.prototype
	  } else {
	    var sliceLen = end - start
	    newBuf = new Buffer(sliceLen, undefined)
	    for (var i = 0; i < sliceLen; ++i) {
	      newBuf[i] = this[i + start]
	    }
	  }
	
	  return newBuf
	}
	
	/*
	 * Need to make sure that buffer isn't trying to write out of bounds.
	 */
	function checkOffset (offset, ext, length) {
	  if ((offset % 1) !== 0 || offset < 0) throw new RangeError('offset is not uint')
	  if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length')
	}
	
	Buffer.prototype.readUIntLE = function readUIntLE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) checkOffset(offset, byteLength, this.length)
	
	  var val = this[offset]
	  var mul = 1
	  var i = 0
	  while (++i < byteLength && (mul *= 0x100)) {
	    val += this[offset + i] * mul
	  }
	
	  return val
	}
	
	Buffer.prototype.readUIntBE = function readUIntBE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) {
	    checkOffset(offset, byteLength, this.length)
	  }
	
	  var val = this[offset + --byteLength]
	  var mul = 1
	  while (byteLength > 0 && (mul *= 0x100)) {
	    val += this[offset + --byteLength] * mul
	  }
	
	  return val
	}
	
	Buffer.prototype.readUInt8 = function readUInt8 (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 1, this.length)
	  return this[offset]
	}
	
	Buffer.prototype.readUInt16LE = function readUInt16LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  return this[offset] | (this[offset + 1] << 8)
	}
	
	Buffer.prototype.readUInt16BE = function readUInt16BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  return (this[offset] << 8) | this[offset + 1]
	}
	
	Buffer.prototype.readUInt32LE = function readUInt32LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return ((this[offset]) |
	      (this[offset + 1] << 8) |
	      (this[offset + 2] << 16)) +
	      (this[offset + 3] * 0x1000000)
	}
	
	Buffer.prototype.readUInt32BE = function readUInt32BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return (this[offset] * 0x1000000) +
	    ((this[offset + 1] << 16) |
	    (this[offset + 2] << 8) |
	    this[offset + 3])
	}
	
	Buffer.prototype.readIntLE = function readIntLE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) checkOffset(offset, byteLength, this.length)
	
	  var val = this[offset]
	  var mul = 1
	  var i = 0
	  while (++i < byteLength && (mul *= 0x100)) {
	    val += this[offset + i] * mul
	  }
	  mul *= 0x80
	
	  if (val >= mul) val -= Math.pow(2, 8 * byteLength)
	
	  return val
	}
	
	Buffer.prototype.readIntBE = function readIntBE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) checkOffset(offset, byteLength, this.length)
	
	  var i = byteLength
	  var mul = 1
	  var val = this[offset + --i]
	  while (i > 0 && (mul *= 0x100)) {
	    val += this[offset + --i] * mul
	  }
	  mul *= 0x80
	
	  if (val >= mul) val -= Math.pow(2, 8 * byteLength)
	
	  return val
	}
	
	Buffer.prototype.readInt8 = function readInt8 (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 1, this.length)
	  if (!(this[offset] & 0x80)) return (this[offset])
	  return ((0xff - this[offset] + 1) * -1)
	}
	
	Buffer.prototype.readInt16LE = function readInt16LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  var val = this[offset] | (this[offset + 1] << 8)
	  return (val & 0x8000) ? val | 0xFFFF0000 : val
	}
	
	Buffer.prototype.readInt16BE = function readInt16BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  var val = this[offset + 1] | (this[offset] << 8)
	  return (val & 0x8000) ? val | 0xFFFF0000 : val
	}
	
	Buffer.prototype.readInt32LE = function readInt32LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return (this[offset]) |
	    (this[offset + 1] << 8) |
	    (this[offset + 2] << 16) |
	    (this[offset + 3] << 24)
	}
	
	Buffer.prototype.readInt32BE = function readInt32BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return (this[offset] << 24) |
	    (this[offset + 1] << 16) |
	    (this[offset + 2] << 8) |
	    (this[offset + 3])
	}
	
	Buffer.prototype.readFloatLE = function readFloatLE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	  return ieee754.read(this, offset, true, 23, 4)
	}
	
	Buffer.prototype.readFloatBE = function readFloatBE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	  return ieee754.read(this, offset, false, 23, 4)
	}
	
	Buffer.prototype.readDoubleLE = function readDoubleLE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 8, this.length)
	  return ieee754.read(this, offset, true, 52, 8)
	}
	
	Buffer.prototype.readDoubleBE = function readDoubleBE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 8, this.length)
	  return ieee754.read(this, offset, false, 52, 8)
	}
	
	function checkInt (buf, value, offset, ext, max, min) {
	  if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance')
	  if (value > max || value < min) throw new RangeError('"value" argument is out of bounds')
	  if (offset + ext > buf.length) throw new RangeError('Index out of range')
	}
	
	Buffer.prototype.writeUIntLE = function writeUIntLE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) {
	    var maxBytes = Math.pow(2, 8 * byteLength) - 1
	    checkInt(this, value, offset, byteLength, maxBytes, 0)
	  }
	
	  var mul = 1
	  var i = 0
	  this[offset] = value & 0xFF
	  while (++i < byteLength && (mul *= 0x100)) {
	    this[offset + i] = (value / mul) & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeUIntBE = function writeUIntBE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) {
	    var maxBytes = Math.pow(2, 8 * byteLength) - 1
	    checkInt(this, value, offset, byteLength, maxBytes, 0)
	  }
	
	  var i = byteLength - 1
	  var mul = 1
	  this[offset + i] = value & 0xFF
	  while (--i >= 0 && (mul *= 0x100)) {
	    this[offset + i] = (value / mul) & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeUInt8 = function writeUInt8 (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0)
	  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
	  this[offset] = (value & 0xff)
	  return offset + 1
	}
	
	function objectWriteUInt16 (buf, value, offset, littleEndian) {
	  if (value < 0) value = 0xffff + value + 1
	  for (var i = 0, j = Math.min(buf.length - offset, 2); i < j; ++i) {
	    buf[offset + i] = (value & (0xff << (8 * (littleEndian ? i : 1 - i)))) >>>
	      (littleEndian ? i : 1 - i) * 8
	  }
	}
	
	Buffer.prototype.writeUInt16LE = function writeUInt16LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value & 0xff)
	    this[offset + 1] = (value >>> 8)
	  } else {
	    objectWriteUInt16(this, value, offset, true)
	  }
	  return offset + 2
	}
	
	Buffer.prototype.writeUInt16BE = function writeUInt16BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 8)
	    this[offset + 1] = (value & 0xff)
	  } else {
	    objectWriteUInt16(this, value, offset, false)
	  }
	  return offset + 2
	}
	
	function objectWriteUInt32 (buf, value, offset, littleEndian) {
	  if (value < 0) value = 0xffffffff + value + 1
	  for (var i = 0, j = Math.min(buf.length - offset, 4); i < j; ++i) {
	    buf[offset + i] = (value >>> (littleEndian ? i : 3 - i) * 8) & 0xff
	  }
	}
	
	Buffer.prototype.writeUInt32LE = function writeUInt32LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset + 3] = (value >>> 24)
	    this[offset + 2] = (value >>> 16)
	    this[offset + 1] = (value >>> 8)
	    this[offset] = (value & 0xff)
	  } else {
	    objectWriteUInt32(this, value, offset, true)
	  }
	  return offset + 4
	}
	
	Buffer.prototype.writeUInt32BE = function writeUInt32BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 24)
	    this[offset + 1] = (value >>> 16)
	    this[offset + 2] = (value >>> 8)
	    this[offset + 3] = (value & 0xff)
	  } else {
	    objectWriteUInt32(this, value, offset, false)
	  }
	  return offset + 4
	}
	
	Buffer.prototype.writeIntLE = function writeIntLE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) {
	    var limit = Math.pow(2, 8 * byteLength - 1)
	
	    checkInt(this, value, offset, byteLength, limit - 1, -limit)
	  }
	
	  var i = 0
	  var mul = 1
	  var sub = 0
	  this[offset] = value & 0xFF
	  while (++i < byteLength && (mul *= 0x100)) {
	    if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) {
	      sub = 1
	    }
	    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeIntBE = function writeIntBE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) {
	    var limit = Math.pow(2, 8 * byteLength - 1)
	
	    checkInt(this, value, offset, byteLength, limit - 1, -limit)
	  }
	
	  var i = byteLength - 1
	  var mul = 1
	  var sub = 0
	  this[offset + i] = value & 0xFF
	  while (--i >= 0 && (mul *= 0x100)) {
	    if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) {
	      sub = 1
	    }
	    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeInt8 = function writeInt8 (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -0x80)
	  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
	  if (value < 0) value = 0xff + value + 1
	  this[offset] = (value & 0xff)
	  return offset + 1
	}
	
	Buffer.prototype.writeInt16LE = function writeInt16LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value & 0xff)
	    this[offset + 1] = (value >>> 8)
	  } else {
	    objectWriteUInt16(this, value, offset, true)
	  }
	  return offset + 2
	}
	
	Buffer.prototype.writeInt16BE = function writeInt16BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 8)
	    this[offset + 1] = (value & 0xff)
	  } else {
	    objectWriteUInt16(this, value, offset, false)
	  }
	  return offset + 2
	}
	
	Buffer.prototype.writeInt32LE = function writeInt32LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value & 0xff)
	    this[offset + 1] = (value >>> 8)
	    this[offset + 2] = (value >>> 16)
	    this[offset + 3] = (value >>> 24)
	  } else {
	    objectWriteUInt32(this, value, offset, true)
	  }
	  return offset + 4
	}
	
	Buffer.prototype.writeInt32BE = function writeInt32BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
	  if (value < 0) value = 0xffffffff + value + 1
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 24)
	    this[offset + 1] = (value >>> 16)
	    this[offset + 2] = (value >>> 8)
	    this[offset + 3] = (value & 0xff)
	  } else {
	    objectWriteUInt32(this, value, offset, false)
	  }
	  return offset + 4
	}
	
	function checkIEEE754 (buf, value, offset, ext, max, min) {
	  if (offset + ext > buf.length) throw new RangeError('Index out of range')
	  if (offset < 0) throw new RangeError('Index out of range')
	}
	
	function writeFloat (buf, value, offset, littleEndian, noAssert) {
	  if (!noAssert) {
	    checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -3.4028234663852886e+38)
	  }
	  ieee754.write(buf, value, offset, littleEndian, 23, 4)
	  return offset + 4
	}
	
	Buffer.prototype.writeFloatLE = function writeFloatLE (value, offset, noAssert) {
	  return writeFloat(this, value, offset, true, noAssert)
	}
	
	Buffer.prototype.writeFloatBE = function writeFloatBE (value, offset, noAssert) {
	  return writeFloat(this, value, offset, false, noAssert)
	}
	
	function writeDouble (buf, value, offset, littleEndian, noAssert) {
	  if (!noAssert) {
	    checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -1.7976931348623157E+308)
	  }
	  ieee754.write(buf, value, offset, littleEndian, 52, 8)
	  return offset + 8
	}
	
	Buffer.prototype.writeDoubleLE = function writeDoubleLE (value, offset, noAssert) {
	  return writeDouble(this, value, offset, true, noAssert)
	}
	
	Buffer.prototype.writeDoubleBE = function writeDoubleBE (value, offset, noAssert) {
	  return writeDouble(this, value, offset, false, noAssert)
	}
	
	// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
	Buffer.prototype.copy = function copy (target, targetStart, start, end) {
	  if (!start) start = 0
	  if (!end && end !== 0) end = this.length
	  if (targetStart >= target.length) targetStart = target.length
	  if (!targetStart) targetStart = 0
	  if (end > 0 && end < start) end = start
	
	  // Copy 0 bytes; we're done
	  if (end === start) return 0
	  if (target.length === 0 || this.length === 0) return 0
	
	  // Fatal error conditions
	  if (targetStart < 0) {
	    throw new RangeError('targetStart out of bounds')
	  }
	  if (start < 0 || start >= this.length) throw new RangeError('sourceStart out of bounds')
	  if (end < 0) throw new RangeError('sourceEnd out of bounds')
	
	  // Are we oob?
	  if (end > this.length) end = this.length
	  if (target.length - targetStart < end - start) {
	    end = target.length - targetStart + start
	  }
	
	  var len = end - start
	  var i
	
	  if (this === target && start < targetStart && targetStart < end) {
	    // descending copy from end
	    for (i = len - 1; i >= 0; --i) {
	      target[i + targetStart] = this[i + start]
	    }
	  } else if (len < 1000 || !Buffer.TYPED_ARRAY_SUPPORT) {
	    // ascending copy from start
	    for (i = 0; i < len; ++i) {
	      target[i + targetStart] = this[i + start]
	    }
	  } else {
	    Uint8Array.prototype.set.call(
	      target,
	      this.subarray(start, start + len),
	      targetStart
	    )
	  }
	
	  return len
	}
	
	// Usage:
	//    buffer.fill(number[, offset[, end]])
	//    buffer.fill(buffer[, offset[, end]])
	//    buffer.fill(string[, offset[, end]][, encoding])
	Buffer.prototype.fill = function fill (val, start, end, encoding) {
	  // Handle string cases:
	  if (typeof val === 'string') {
	    if (typeof start === 'string') {
	      encoding = start
	      start = 0
	      end = this.length
	    } else if (typeof end === 'string') {
	      encoding = end
	      end = this.length
	    }
	    if (val.length === 1) {
	      var code = val.charCodeAt(0)
	      if (code < 256) {
	        val = code
	      }
	    }
	    if (encoding !== undefined && typeof encoding !== 'string') {
	      throw new TypeError('encoding must be a string')
	    }
	    if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) {
	      throw new TypeError('Unknown encoding: ' + encoding)
	    }
	  } else if (typeof val === 'number') {
	    val = val & 255
	  }
	
	  // Invalid ranges are not set to a default, so can range check early.
	  if (start < 0 || this.length < start || this.length < end) {
	    throw new RangeError('Out of range index')
	  }
	
	  if (end <= start) {
	    return this
	  }
	
	  start = start >>> 0
	  end = end === undefined ? this.length : end >>> 0
	
	  if (!val) val = 0
	
	  var i
	  if (typeof val === 'number') {
	    for (i = start; i < end; ++i) {
	      this[i] = val
	    }
	  } else {
	    var bytes = Buffer.isBuffer(val)
	      ? val
	      : utf8ToBytes(new Buffer(val, encoding).toString())
	    var len = bytes.length
	    for (i = 0; i < end - start; ++i) {
	      this[i + start] = bytes[i % len]
	    }
	  }
	
	  return this
	}
	
	// HELPER FUNCTIONS
	// ================
	
	var INVALID_BASE64_RE = /[^+\/0-9A-Za-z-_]/g
	
	function base64clean (str) {
	  // Node strips out invalid characters like \n and \t from the string, base64-js does not
	  str = stringtrim(str).replace(INVALID_BASE64_RE, '')
	  // Node converts strings with length < 2 to ''
	  if (str.length < 2) return ''
	  // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
	  while (str.length % 4 !== 0) {
	    str = str + '='
	  }
	  return str
	}
	
	function stringtrim (str) {
	  if (str.trim) return str.trim()
	  return str.replace(/^\s+|\s+$/g, '')
	}
	
	function toHex (n) {
	  if (n < 16) return '0' + n.toString(16)
	  return n.toString(16)
	}
	
	function utf8ToBytes (string, units) {
	  units = units || Infinity
	  var codePoint
	  var length = string.length
	  var leadSurrogate = null
	  var bytes = []
	
	  for (var i = 0; i < length; ++i) {
	    codePoint = string.charCodeAt(i)
	
	    // is surrogate component
	    if (codePoint > 0xD7FF && codePoint < 0xE000) {
	      // last char was a lead
	      if (!leadSurrogate) {
	        // no lead yet
	        if (codePoint > 0xDBFF) {
	          // unexpected trail
	          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	          continue
	        } else if (i + 1 === length) {
	          // unpaired lead
	          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	          continue
	        }
	
	        // valid lead
	        leadSurrogate = codePoint
	
	        continue
	      }
	
	      // 2 leads in a row
	      if (codePoint < 0xDC00) {
	        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	        leadSurrogate = codePoint
	        continue
	      }
	
	      // valid surrogate pair
	      codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000
	    } else if (leadSurrogate) {
	      // valid bmp char, but last char was a lead
	      if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	    }
	
	    leadSurrogate = null
	
	    // encode utf8
	    if (codePoint < 0x80) {
	      if ((units -= 1) < 0) break
	      bytes.push(codePoint)
	    } else if (codePoint < 0x800) {
	      if ((units -= 2) < 0) break
	      bytes.push(
	        codePoint >> 0x6 | 0xC0,
	        codePoint & 0x3F | 0x80
	      )
	    } else if (codePoint < 0x10000) {
	      if ((units -= 3) < 0) break
	      bytes.push(
	        codePoint >> 0xC | 0xE0,
	        codePoint >> 0x6 & 0x3F | 0x80,
	        codePoint & 0x3F | 0x80
	      )
	    } else if (codePoint < 0x110000) {
	      if ((units -= 4) < 0) break
	      bytes.push(
	        codePoint >> 0x12 | 0xF0,
	        codePoint >> 0xC & 0x3F | 0x80,
	        codePoint >> 0x6 & 0x3F | 0x80,
	        codePoint & 0x3F | 0x80
	      )
	    } else {
	      throw new Error('Invalid code point')
	    }
	  }
	
	  return bytes
	}
	
	function asciiToBytes (str) {
	  var byteArray = []
	  for (var i = 0; i < str.length; ++i) {
	    // Node's code seems to be doing this and not & 0x7F..
	    byteArray.push(str.charCodeAt(i) & 0xFF)
	  }
	  return byteArray
	}
	
	function utf16leToBytes (str, units) {
	  var c, hi, lo
	  var byteArray = []
	  for (var i = 0; i < str.length; ++i) {
	    if ((units -= 2) < 0) break
	
	    c = str.charCodeAt(i)
	    hi = c >> 8
	    lo = c % 256
	    byteArray.push(lo)
	    byteArray.push(hi)
	  }
	
	  return byteArray
	}
	
	function base64ToBytes (str) {
	  return base64.toByteArray(base64clean(str))
	}
	
	function blitBuffer (src, dst, offset, length) {
	  for (var i = 0; i < length; ++i) {
	    if ((i + offset >= dst.length) || (i >= src.length)) break
	    dst[i + offset] = src[i]
	  }
	  return i
	}
	
	function isnan (val) {
	  return val !== val // eslint-disable-line no-self-compare
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(9).Buffer, (function() { return this; }())))

/***/ },
/* 10 */
/***/ function(module, exports) {

	'use strict'
	
	exports.byteLength = byteLength
	exports.toByteArray = toByteArray
	exports.fromByteArray = fromByteArray
	
	var lookup = []
	var revLookup = []
	var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array
	
	var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'
	for (var i = 0, len = code.length; i < len; ++i) {
	  lookup[i] = code[i]
	  revLookup[code.charCodeAt(i)] = i
	}
	
	revLookup['-'.charCodeAt(0)] = 62
	revLookup['_'.charCodeAt(0)] = 63
	
	function placeHoldersCount (b64) {
	  var len = b64.length
	  if (len % 4 > 0) {
	    throw new Error('Invalid string. Length must be a multiple of 4')
	  }
	
	  // the number of equal signs (place holders)
	  // if there are two placeholders, than the two characters before it
	  // represent one byte
	  // if there is only one, then the three characters before it represent 2 bytes
	  // this is just a cheap hack to not do indexOf twice
	  return b64[len - 2] === '=' ? 2 : b64[len - 1] === '=' ? 1 : 0
	}
	
	function byteLength (b64) {
	  // base64 is 4/3 + up to two characters of the original data
	  return b64.length * 3 / 4 - placeHoldersCount(b64)
	}
	
	function toByteArray (b64) {
	  var i, j, l, tmp, placeHolders, arr
	  var len = b64.length
	  placeHolders = placeHoldersCount(b64)
	
	  arr = new Arr(len * 3 / 4 - placeHolders)
	
	  // if there are placeholders, only get up to the last complete 4 chars
	  l = placeHolders > 0 ? len - 4 : len
	
	  var L = 0
	
	  for (i = 0, j = 0; i < l; i += 4, j += 3) {
	    tmp = (revLookup[b64.charCodeAt(i)] << 18) | (revLookup[b64.charCodeAt(i + 1)] << 12) | (revLookup[b64.charCodeAt(i + 2)] << 6) | revLookup[b64.charCodeAt(i + 3)]
	    arr[L++] = (tmp >> 16) & 0xFF
	    arr[L++] = (tmp >> 8) & 0xFF
	    arr[L++] = tmp & 0xFF
	  }
	
	  if (placeHolders === 2) {
	    tmp = (revLookup[b64.charCodeAt(i)] << 2) | (revLookup[b64.charCodeAt(i + 1)] >> 4)
	    arr[L++] = tmp & 0xFF
	  } else if (placeHolders === 1) {
	    tmp = (revLookup[b64.charCodeAt(i)] << 10) | (revLookup[b64.charCodeAt(i + 1)] << 4) | (revLookup[b64.charCodeAt(i + 2)] >> 2)
	    arr[L++] = (tmp >> 8) & 0xFF
	    arr[L++] = tmp & 0xFF
	  }
	
	  return arr
	}
	
	function tripletToBase64 (num) {
	  return lookup[num >> 18 & 0x3F] + lookup[num >> 12 & 0x3F] + lookup[num >> 6 & 0x3F] + lookup[num & 0x3F]
	}
	
	function encodeChunk (uint8, start, end) {
	  var tmp
	  var output = []
	  for (var i = start; i < end; i += 3) {
	    tmp = (uint8[i] << 16) + (uint8[i + 1] << 8) + (uint8[i + 2])
	    output.push(tripletToBase64(tmp))
	  }
	  return output.join('')
	}
	
	function fromByteArray (uint8) {
	  var tmp
	  var len = uint8.length
	  var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
	  var output = ''
	  var parts = []
	  var maxChunkLength = 16383 // must be multiple of 3
	
	  // go through the array every three bytes, we'll deal with trailing stuff later
	  for (var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength) {
	    parts.push(encodeChunk(uint8, i, (i + maxChunkLength) > len2 ? len2 : (i + maxChunkLength)))
	  }
	
	  // pad the end with zeros, but make sure to not forget the extra bytes
	  if (extraBytes === 1) {
	    tmp = uint8[len - 1]
	    output += lookup[tmp >> 2]
	    output += lookup[(tmp << 4) & 0x3F]
	    output += '=='
	  } else if (extraBytes === 2) {
	    tmp = (uint8[len - 2] << 8) + (uint8[len - 1])
	    output += lookup[tmp >> 10]
	    output += lookup[(tmp >> 4) & 0x3F]
	    output += lookup[(tmp << 2) & 0x3F]
	    output += '='
	  }
	
	  parts.push(output)
	
	  return parts.join('')
	}


/***/ },
/* 11 */
/***/ function(module, exports) {

	exports.read = function (buffer, offset, isLE, mLen, nBytes) {
	  var e, m
	  var eLen = nBytes * 8 - mLen - 1
	  var eMax = (1 << eLen) - 1
	  var eBias = eMax >> 1
	  var nBits = -7
	  var i = isLE ? (nBytes - 1) : 0
	  var d = isLE ? -1 : 1
	  var s = buffer[offset + i]
	
	  i += d
	
	  e = s & ((1 << (-nBits)) - 1)
	  s >>= (-nBits)
	  nBits += eLen
	  for (; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8) {}
	
	  m = e & ((1 << (-nBits)) - 1)
	  e >>= (-nBits)
	  nBits += mLen
	  for (; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8) {}
	
	  if (e === 0) {
	    e = 1 - eBias
	  } else if (e === eMax) {
	    return m ? NaN : ((s ? -1 : 1) * Infinity)
	  } else {
	    m = m + Math.pow(2, mLen)
	    e = e - eBias
	  }
	  return (s ? -1 : 1) * m * Math.pow(2, e - mLen)
	}
	
	exports.write = function (buffer, value, offset, isLE, mLen, nBytes) {
	  var e, m, c
	  var eLen = nBytes * 8 - mLen - 1
	  var eMax = (1 << eLen) - 1
	  var eBias = eMax >> 1
	  var rt = (mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0)
	  var i = isLE ? 0 : (nBytes - 1)
	  var d = isLE ? 1 : -1
	  var s = value < 0 || (value === 0 && 1 / value < 0) ? 1 : 0
	
	  value = Math.abs(value)
	
	  if (isNaN(value) || value === Infinity) {
	    m = isNaN(value) ? 1 : 0
	    e = eMax
	  } else {
	    e = Math.floor(Math.log(value) / Math.LN2)
	    if (value * (c = Math.pow(2, -e)) < 1) {
	      e--
	      c *= 2
	    }
	    if (e + eBias >= 1) {
	      value += rt / c
	    } else {
	      value += rt * Math.pow(2, 1 - eBias)
	    }
	    if (value * c >= 2) {
	      e++
	      c /= 2
	    }
	
	    if (e + eBias >= eMax) {
	      m = 0
	      e = eMax
	    } else if (e + eBias >= 1) {
	      m = (value * c - 1) * Math.pow(2, mLen)
	      e = e + eBias
	    } else {
	      m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen)
	      e = 0
	    }
	  }
	
	  for (; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8) {}
	
	  e = (e << mLen) | m
	  eLen += mLen
	  for (; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8) {}
	
	  buffer[offset + i - d] |= s * 128
	}


/***/ },
/* 12 */
/***/ function(module, exports) {

	var toString = {}.toString;
	
	module.exports = Array.isArray || function (arr) {
	  return toString.call(arr) == '[object Array]';
	};


/***/ },
/* 13 */
/***/ function(module, exports) {

	/*!
	 *  Copyright © 2008 Fair Oaks Labs, Inc.
	 *  All rights reserved.
	 */
	
	// Utility object:  Encode/Decode C-style binary primitives to/from octet arrays
	function JSPack()
	{
		// Module-level (private) variables
		var el,  bBE = false, m = this;
	
	
		// Raw byte arrays
		m._DeArray = function (a, p, l)
		{
			return [a.slice(p,p+l)];
		};
		m._EnArray = function (a, p, l, v)
		{
			for (var i = 0; i < l; a[p+i] = v[i]?v[i]:0, i++);
		};
	
		// ASCII characters
		m._DeChar = function (a, p)
		{
			return String.fromCharCode(a[p]);
		};
		m._EnChar = function (a, p, v)
		{
			a[p] = v.charCodeAt(0);
		};
	
		// Little-endian (un)signed N-byte integers
		m._DeInt = function (a, p)
		{
			var lsb = bBE?(el.len-1):0, nsb = bBE?-1:1, stop = lsb+nsb*el.len, rv, i, f;
			for (rv = 0, i = lsb, f = 1; i != stop; rv+=(a[p+i]*f), i+=nsb, f*=256);
			if (el.bSigned && (rv & Math.pow(2, el.len*8-1))) { rv -= Math.pow(2, el.len*8); }
			return rv;
		};
		m._EnInt = function (a, p, v)
		{
			var lsb = bBE?(el.len-1):0, nsb = bBE?-1:1, stop = lsb+nsb*el.len, i;
			v = (v<el.min)?el.min:(v>el.max)?el.max:v;
			for (i = lsb; i != stop; a[p+i]=v&0xff, i+=nsb, v>>=8);
		};
	
		// ASCII character strings
		m._DeString = function (a, p, l)
		{
			for (var rv = new Array(l), i = 0; i < l; rv[i] = String.fromCharCode(a[p+i]), i++);
			return rv.join('');
		};
		m._EnString = function (a, p, l, v)
		{
			for (var t, i = 0; i < l; a[p+i] = (t=v.charCodeAt(i))?t:0, i++);
		};
	
		// Little-endian N-bit IEEE 754 floating point
		m._De754 = function (a, p)
		{
			var s, e, m, i, d, nBits, mLen, eLen, eBias, eMax;
			mLen = el.mLen, eLen = el.len*8-el.mLen-1, eMax = (1<<eLen)-1, eBias = eMax>>1;
	
			i = bBE?0:(el.len-1); d = bBE?1:-1; s = a[p+i]; i+=d; nBits = -7;
			for (e = s&((1<<(-nBits))-1), s>>=(-nBits), nBits += eLen; nBits > 0; e=e*256+a[p+i], i+=d, nBits-=8);
			for (m = e&((1<<(-nBits))-1), e>>=(-nBits), nBits += mLen; nBits > 0; m=m*256+a[p+i], i+=d, nBits-=8);
	
			switch (e)
			{
				case 0:
					// Zero, or denormalized number
					e = 1-eBias;
					break;
				case eMax:
					// NaN, or +/-Infinity
					return m?NaN:((s?-1:1)*Infinity);
				default:
					// Normalized number
					m = m + Math.pow(2, mLen);
					e = e - eBias;
					break;
			}
			return (s?-1:1) * m * Math.pow(2, e-mLen);
		};
		m._En754 = function (a, p, v)
		{
			var s, e, m, i, d, c, mLen, eLen, eBias, eMax;
			mLen = el.mLen, eLen = el.len*8-el.mLen-1, eMax = (1<<eLen)-1, eBias = eMax>>1;
	
			s = v<0?1:0;
			v = Math.abs(v);
			if (isNaN(v) || (v == Infinity))
			{
				m = isNaN(v)?1:0;
				e = eMax;
			}
			else
			{
				e = Math.floor(Math.log(v)/Math.LN2);			// Calculate log2 of the value
				if (v*(c = Math.pow(2, -e)) < 1) { e--; c*=2; }		// Math.log() isn't 100% reliable
	
				// Round by adding 1/2 the significand's LSD
				if (e+eBias >= 1) { v += el.rt/c; }			// Normalized:  mLen significand digits
				else { v += el.rt*Math.pow(2, 1-eBias); } 		// Denormalized:  <= mLen significand digits
				if (v*c >= 2) { e++; c/=2; }				// Rounding can increment the exponent
	
				if (e+eBias >= eMax)
				{
					// Overflow
					m = 0;
					e = eMax;
				}
				else if (e+eBias >= 1)
				{
					// Normalized - term order matters, as Math.pow(2, 52-e) and v*Math.pow(2, 52) can overflow
					m = (v*c-1)*Math.pow(2, mLen);
					e = e + eBias;
				}
				else
				{
					// Denormalized - also catches the '0' case, somewhat by chance
					m = v*Math.pow(2, eBias-1)*Math.pow(2, mLen);
					e = 0;
				}
			}
	
			for (i = bBE?(el.len-1):0, d=bBE?-1:1; mLen >= 8; a[p+i]=m&0xff, i+=d, m/=256, mLen-=8);
			for (e=(e<<mLen)|m, eLen+=mLen; eLen > 0; a[p+i]=e&0xff, i+=d, e/=256, eLen-=8);
			a[p+i-d] |= s*128;
		};
	
		// Convert int64 to array with 3 elements: [lowBits, highBits, unsignedFlag]
		// '>>>' trick to convert signed 32bit int to unsigned int (because << always results in a signed 32bit int)
		m._DeInt64 = function (a, p) {
			var start = bBE ? 0 : 7, nsb = bBE ? 1 : -1, stop = start + nsb * 8, rv = [0,0, !el.bSigned], i, f, rvi;
			for (i = start, rvi = 1, f = 0;
				i != stop;
				rv[rvi] = (((rv[rvi]<<8)>>>0) + a[p + i]), i += nsb, f++, rvi = (f < 4 ? 1 : 0));
			return rv;
		};
		m._EnInt64 = function (a, p, v) {
			var start = bBE ? 0 : 7, nsb = bBE ? 1 : -1, stop = start + nsb * 8, i, f, rvi, s;
			for (i = start, rvi = 1, f = 0, s = 24;
				i != stop;
				a[p + i] = v[rvi]>>s & 0xff, i += nsb, f++, rvi = (f < 4 ? 1 : 0), s = 24 - (8 * (f % 4)));
		};
		
	
		// Class data
		m._sPattern	= '(\\d+)?([AxcbBhHsfdiIlLqQ])';
		m._lenLut	= {'A':1, 'x':1, 'c':1, 'b':1, 'B':1, 'h':2, 'H':2, 's':1, 'f':4, 'd':8, 'i':4, 'I':4, 'l':4, 'L':4, 'q':8, 'Q':8};
		m._elLut	= {	'A': {en:m._EnArray, de:m._DeArray},
					's': {en:m._EnString, de:m._DeString},
					'c': {en:m._EnChar, de:m._DeChar},
					'b': {en:m._EnInt, de:m._DeInt, len:1, bSigned:true, min:-Math.pow(2, 7), max:Math.pow(2, 7)-1},
					'B': {en:m._EnInt, de:m._DeInt, len:1, bSigned:false, min:0, max:Math.pow(2, 8)-1},
					'h': {en:m._EnInt, de:m._DeInt, len:2, bSigned:true, min:-Math.pow(2, 15), max:Math.pow(2, 15)-1},
					'H': {en:m._EnInt, de:m._DeInt, len:2, bSigned:false, min:0, max:Math.pow(2, 16)-1},
					'i': {en:m._EnInt, de:m._DeInt, len:4, bSigned:true, min:-Math.pow(2, 31), max:Math.pow(2, 31)-1},
					'I': {en:m._EnInt, de:m._DeInt, len:4, bSigned:false, min:0, max:Math.pow(2, 32)-1},
					'l': {en:m._EnInt, de:m._DeInt, len:4, bSigned:true, min:-Math.pow(2, 31), max:Math.pow(2, 31)-1},
					'L': {en:m._EnInt, de:m._DeInt, len:4, bSigned:false, min:0, max:Math.pow(2, 32)-1},
					'f': {en:m._En754, de:m._De754, len:4, mLen:23, rt:Math.pow(2, -24)-Math.pow(2, -77)},
					'd': {en:m._En754, de:m._De754, len:8, mLen:52, rt:0},
					'q': {en:m._EnInt64, de:m._DeInt64, bSigned:true},
					'Q': {en:m._EnInt64, de:m._DeInt64, bSigned:false}};
	
		// Unpack a series of n elements of size s from array a at offset p with fxn
		m._UnpackSeries = function (n, s, a, p)
		{
			for (var fxn = el.de, rv = [], i = 0; i < n; rv.push(fxn(a, p+i*s)), i++);
			return rv;
		};
	
		// Pack a series of n elements of size s from array v at offset i to array a at offset p with fxn
		m._PackSeries = function (n, s, a, p, v, i)
		{
			for (var fxn = el.en, o = 0; o < n; fxn(a, p+o*s, v[i+o]), o++);
		};
	
		// Unpack the octet array a, beginning at offset p, according to the fmt string
		m.Unpack = function (fmt, a, p)
		{
			// Set the private bBE flag based on the format string - assume big-endianness
			bBE = (fmt.charAt(0) != '<');
	
			p = p?p:0;
			var re = new RegExp(this._sPattern, 'g'), m, n, s, rv = [];
			while (m = re.exec(fmt))
			{
				n = ((m[1]==undefined)||(m[1]==''))?1:parseInt(m[1]);
				s = this._lenLut[m[2]];
				if ((p + n*s) > a.length)
				{
					return undefined;
				}
				switch (m[2])
				{
					case 'A': case 's':
						rv.push(this._elLut[m[2]].de(a, p, n));
						break;
					case 'c': case 'b': case 'B': case 'h': case 'H':
					case 'i': case 'I': case 'l': case 'L': case 'f': case 'd': case 'q': case 'Q':
						el = this._elLut[m[2]];
						rv.push(this._UnpackSeries(n, s, a, p));
						break;
				}
				p += n*s;
			}
			return Array.prototype.concat.apply([], rv);
		};
	
		// Pack the supplied values into the octet array a, beginning at offset p, according to the fmt string
		m.PackTo = function (fmt, a, p, values)
		{
			// Set the private bBE flag based on the format string - assume big-endianness
			bBE = (fmt.charAt(0) != '<');
	
			var re = new RegExp(this._sPattern, 'g'), m, n, s, i = 0, j;
			while (m = re.exec(fmt))
			{
				n = ((m[1]==undefined)||(m[1]==''))?1:parseInt(m[1]);
				s = this._lenLut[m[2]];
				if ((p + n*s) > a.length)
				{
					return false;
				}
				switch (m[2])
				{
					case 'A': case 's':
						if ((i + 1) > values.length) { return false; }
						this._elLut[m[2]].en(a, p, n, values[i]);
						i += 1;
						break;
					case 'c': case 'b': case 'B': case 'h': case 'H':
					case 'i': case 'I': case 'l': case 'L': case 'f': case 'd': case 'q': case 'Q':
						el = this._elLut[m[2]];
						if ((i + n) > values.length) { return false; }
						this._PackSeries(n, s, a, p, values, i);
						i += n;
						break;
					case 'x':
						for (j = 0; j < n; j++) { a[p+j] = 0; }
						break;
				}
				p += n*s;
			}
			return a;
		};
	
		// Pack the supplied values into a new octet array, according to the fmt string
		m.Pack = function (fmt, values)
		{
			return this.PackTo(fmt, new Array(this.CalcLength(fmt)), 0, values);
		};
	
		// Determine the number of bytes represented by the format string
		m.CalcLength = function (fmt)
		{
			var re = new RegExp(this._sPattern, 'g'), m, sum = 0;
			while (m = re.exec(fmt))
			{
				sum += (((m[1]==undefined)||(m[1]==''))?1:parseInt(m[1])) * this._lenLut[m[2]];
			}
			return sum;
		};
	};
	
	exports.jspack = new JSPack();


/***/ },
/* 14 */
/***/ function(module, exports) {

	module.exports = Long;
	
	/**
	 * wasm optimizations, to do native i64 multiplication and divide
	 */
	var wasm = null;
	
	try {
	  wasm = new WebAssembly.Instance(new WebAssembly.Module(new Uint8Array([
	    0, 97, 115, 109, 1, 0, 0, 0, 1, 13, 2, 96, 0, 1, 127, 96, 4, 127, 127, 127, 127, 1, 127, 3, 7, 6, 0, 1, 1, 1, 1, 1, 6, 6, 1, 127, 1, 65, 0, 11, 7, 50, 6, 3, 109, 117, 108, 0, 1, 5, 100, 105, 118, 95, 115, 0, 2, 5, 100, 105, 118, 95, 117, 0, 3, 5, 114, 101, 109, 95, 115, 0, 4, 5, 114, 101, 109, 95, 117, 0, 5, 8, 103, 101, 116, 95, 104, 105, 103, 104, 0, 0, 10, 191, 1, 6, 4, 0, 35, 0, 11, 36, 1, 1, 126, 32, 0, 173, 32, 1, 173, 66, 32, 134, 132, 32, 2, 173, 32, 3, 173, 66, 32, 134, 132, 126, 34, 4, 66, 32, 135, 167, 36, 0, 32, 4, 167, 11, 36, 1, 1, 126, 32, 0, 173, 32, 1, 173, 66, 32, 134, 132, 32, 2, 173, 32, 3, 173, 66, 32, 134, 132, 127, 34, 4, 66, 32, 135, 167, 36, 0, 32, 4, 167, 11, 36, 1, 1, 126, 32, 0, 173, 32, 1, 173, 66, 32, 134, 132, 32, 2, 173, 32, 3, 173, 66, 32, 134, 132, 128, 34, 4, 66, 32, 135, 167, 36, 0, 32, 4, 167, 11, 36, 1, 1, 126, 32, 0, 173, 32, 1, 173, 66, 32, 134, 132, 32, 2, 173, 32, 3, 173, 66, 32, 134, 132, 129, 34, 4, 66, 32, 135, 167, 36, 0, 32, 4, 167, 11, 36, 1, 1, 126, 32, 0, 173, 32, 1, 173, 66, 32, 134, 132, 32, 2, 173, 32, 3, 173, 66, 32, 134, 132, 130, 34, 4, 66, 32, 135, 167, 36, 0, 32, 4, 167, 11
	  ])), {}).exports;
	} catch (e) {
	  // no wasm support :(
	}
	
	/**
	 * Constructs a 64 bit two's-complement integer, given its low and high 32 bit values as *signed* integers.
	 *  See the from* functions below for more convenient ways of constructing Longs.
	 * @exports Long
	 * @class A Long class for representing a 64 bit two's-complement integer value.
	 * @param {number} low The low (signed) 32 bits of the long
	 * @param {number} high The high (signed) 32 bits of the long
	 * @param {boolean=} unsigned Whether unsigned or not, defaults to signed
	 * @constructor
	 */
	function Long(low, high, unsigned) {
	
	    /**
	     * The low 32 bits as a signed value.
	     * @type {number}
	     */
	    this.low = low | 0;
	
	    /**
	     * The high 32 bits as a signed value.
	     * @type {number}
	     */
	    this.high = high | 0;
	
	    /**
	     * Whether unsigned or not.
	     * @type {boolean}
	     */
	    this.unsigned = !!unsigned;
	}
	
	// The internal representation of a long is the two given signed, 32-bit values.
	// We use 32-bit pieces because these are the size of integers on which
	// Javascript performs bit-operations.  For operations like addition and
	// multiplication, we split each number into 16 bit pieces, which can easily be
	// multiplied within Javascript's floating-point representation without overflow
	// or change in sign.
	//
	// In the algorithms below, we frequently reduce the negative case to the
	// positive case by negating the input(s) and then post-processing the result.
	// Note that we must ALWAYS check specially whether those values are MIN_VALUE
	// (-2^63) because -MIN_VALUE == MIN_VALUE (since 2^63 cannot be represented as
	// a positive number, it overflows back into a negative).  Not handling this
	// case would often result in infinite recursion.
	//
	// Common constant values ZERO, ONE, NEG_ONE, etc. are defined below the from*
	// methods on which they depend.
	
	/**
	 * An indicator used to reliably determine if an object is a Long or not.
	 * @type {boolean}
	 * @const
	 * @private
	 */
	Long.prototype.__isLong__;
	
	Object.defineProperty(Long.prototype, "__isLong__", { value: true });
	
	/**
	 * @function
	 * @param {*} obj Object
	 * @returns {boolean}
	 * @inner
	 */
	function isLong(obj) {
	    return (obj && obj["__isLong__"]) === true;
	}
	
	/**
	 * Tests if the specified object is a Long.
	 * @function
	 * @param {*} obj Object
	 * @returns {boolean}
	 */
	Long.isLong = isLong;
	
	/**
	 * A cache of the Long representations of small integer values.
	 * @type {!Object}
	 * @inner
	 */
	var INT_CACHE = {};
	
	/**
	 * A cache of the Long representations of small unsigned integer values.
	 * @type {!Object}
	 * @inner
	 */
	var UINT_CACHE = {};
	
	/**
	 * @param {number} value
	 * @param {boolean=} unsigned
	 * @returns {!Long}
	 * @inner
	 */
	function fromInt(value, unsigned) {
	    var obj, cachedObj, cache;
	    if (unsigned) {
	        value >>>= 0;
	        if (cache = (0 <= value && value < 256)) {
	            cachedObj = UINT_CACHE[value];
	            if (cachedObj)
	                return cachedObj;
	        }
	        obj = fromBits(value, (value | 0) < 0 ? -1 : 0, true);
	        if (cache)
	            UINT_CACHE[value] = obj;
	        return obj;
	    } else {
	        value |= 0;
	        if (cache = (-128 <= value && value < 128)) {
	            cachedObj = INT_CACHE[value];
	            if (cachedObj)
	                return cachedObj;
	        }
	        obj = fromBits(value, value < 0 ? -1 : 0, false);
	        if (cache)
	            INT_CACHE[value] = obj;
	        return obj;
	    }
	}
	
	/**
	 * Returns a Long representing the given 32 bit integer value.
	 * @function
	 * @param {number} value The 32 bit integer in question
	 * @param {boolean=} unsigned Whether unsigned or not, defaults to signed
	 * @returns {!Long} The corresponding Long value
	 */
	Long.fromInt = fromInt;
	
	/**
	 * @param {number} value
	 * @param {boolean=} unsigned
	 * @returns {!Long}
	 * @inner
	 */
	function fromNumber(value, unsigned) {
	    if (isNaN(value))
	        return unsigned ? UZERO : ZERO;
	    if (unsigned) {
	        if (value < 0)
	            return UZERO;
	        if (value >= TWO_PWR_64_DBL)
	            return MAX_UNSIGNED_VALUE;
	    } else {
	        if (value <= -TWO_PWR_63_DBL)
	            return MIN_VALUE;
	        if (value + 1 >= TWO_PWR_63_DBL)
	            return MAX_VALUE;
	    }
	    if (value < 0)
	        return fromNumber(-value, unsigned).neg();
	    return fromBits((value % TWO_PWR_32_DBL) | 0, (value / TWO_PWR_32_DBL) | 0, unsigned);
	}
	
	/**
	 * Returns a Long representing the given value, provided that it is a finite number. Otherwise, zero is returned.
	 * @function
	 * @param {number} value The number in question
	 * @param {boolean=} unsigned Whether unsigned or not, defaults to signed
	 * @returns {!Long} The corresponding Long value
	 */
	Long.fromNumber = fromNumber;
	
	/**
	 * @param {number} lowBits
	 * @param {number} highBits
	 * @param {boolean=} unsigned
	 * @returns {!Long}
	 * @inner
	 */
	function fromBits(lowBits, highBits, unsigned) {
	    return new Long(lowBits, highBits, unsigned);
	}
	
	/**
	 * Returns a Long representing the 64 bit integer that comes by concatenating the given low and high bits. Each is
	 *  assumed to use 32 bits.
	 * @function
	 * @param {number} lowBits The low 32 bits
	 * @param {number} highBits The high 32 bits
	 * @param {boolean=} unsigned Whether unsigned or not, defaults to signed
	 * @returns {!Long} The corresponding Long value
	 */
	Long.fromBits = fromBits;
	
	/**
	 * @function
	 * @param {number} base
	 * @param {number} exponent
	 * @returns {number}
	 * @inner
	 */
	var pow_dbl = Math.pow; // Used 4 times (4*8 to 15+4)
	
	/**
	 * @param {string} str
	 * @param {(boolean|number)=} unsigned
	 * @param {number=} radix
	 * @returns {!Long}
	 * @inner
	 */
	function fromString(str, unsigned, radix) {
	    if (str.length === 0)
	        throw Error('empty string');
	    if (str === "NaN" || str === "Infinity" || str === "+Infinity" || str === "-Infinity")
	        return ZERO;
	    if (typeof unsigned === 'number') {
	        // For goog.math.long compatibility
	        radix = unsigned,
	        unsigned = false;
	    } else {
	        unsigned = !! unsigned;
	    }
	    radix = radix || 10;
	    if (radix < 2 || 36 < radix)
	        throw RangeError('radix');
	
	    var p;
	    if ((p = str.indexOf('-')) > 0)
	        throw Error('interior hyphen');
	    else if (p === 0) {
	        return fromString(str.substring(1), unsigned, radix).neg();
	    }
	
	    // Do several (8) digits each time through the loop, so as to
	    // minimize the calls to the very expensive emulated div.
	    var radixToPower = fromNumber(pow_dbl(radix, 8));
	
	    var result = ZERO;
	    for (var i = 0; i < str.length; i += 8) {
	        var size = Math.min(8, str.length - i),
	            value = parseInt(str.substring(i, i + size), radix);
	        if (size < 8) {
	            var power = fromNumber(pow_dbl(radix, size));
	            result = result.mul(power).add(fromNumber(value));
	        } else {
	            result = result.mul(radixToPower);
	            result = result.add(fromNumber(value));
	        }
	    }
	    result.unsigned = unsigned;
	    return result;
	}
	
	/**
	 * Returns a Long representation of the given string, written using the specified radix.
	 * @function
	 * @param {string} str The textual representation of the Long
	 * @param {(boolean|number)=} unsigned Whether unsigned or not, defaults to signed
	 * @param {number=} radix The radix in which the text is written (2-36), defaults to 10
	 * @returns {!Long} The corresponding Long value
	 */
	Long.fromString = fromString;
	
	/**
	 * @function
	 * @param {!Long|number|string|!{low: number, high: number, unsigned: boolean}} val
	 * @param {boolean=} unsigned
	 * @returns {!Long}
	 * @inner
	 */
	function fromValue(val, unsigned) {
	    if (typeof val === 'number')
	        return fromNumber(val, unsigned);
	    if (typeof val === 'string')
	        return fromString(val, unsigned);
	    // Throws for non-objects, converts non-instanceof Long:
	    return fromBits(val.low, val.high, typeof unsigned === 'boolean' ? unsigned : val.unsigned);
	}
	
	/**
	 * Converts the specified value to a Long using the appropriate from* function for its type.
	 * @function
	 * @param {!Long|number|string|!{low: number, high: number, unsigned: boolean}} val Value
	 * @param {boolean=} unsigned Whether unsigned or not, defaults to signed
	 * @returns {!Long}
	 */
	Long.fromValue = fromValue;
	
	// NOTE: the compiler should inline these constant values below and then remove these variables, so there should be
	// no runtime penalty for these.
	
	/**
	 * @type {number}
	 * @const
	 * @inner
	 */
	var TWO_PWR_16_DBL = 1 << 16;
	
	/**
	 * @type {number}
	 * @const
	 * @inner
	 */
	var TWO_PWR_24_DBL = 1 << 24;
	
	/**
	 * @type {number}
	 * @const
	 * @inner
	 */
	var TWO_PWR_32_DBL = TWO_PWR_16_DBL * TWO_PWR_16_DBL;
	
	/**
	 * @type {number}
	 * @const
	 * @inner
	 */
	var TWO_PWR_64_DBL = TWO_PWR_32_DBL * TWO_PWR_32_DBL;
	
	/**
	 * @type {number}
	 * @const
	 * @inner
	 */
	var TWO_PWR_63_DBL = TWO_PWR_64_DBL / 2;
	
	/**
	 * @type {!Long}
	 * @const
	 * @inner
	 */
	var TWO_PWR_24 = fromInt(TWO_PWR_24_DBL);
	
	/**
	 * @type {!Long}
	 * @inner
	 */
	var ZERO = fromInt(0);
	
	/**
	 * Signed zero.
	 * @type {!Long}
	 */
	Long.ZERO = ZERO;
	
	/**
	 * @type {!Long}
	 * @inner
	 */
	var UZERO = fromInt(0, true);
	
	/**
	 * Unsigned zero.
	 * @type {!Long}
	 */
	Long.UZERO = UZERO;
	
	/**
	 * @type {!Long}
	 * @inner
	 */
	var ONE = fromInt(1);
	
	/**
	 * Signed one.
	 * @type {!Long}
	 */
	Long.ONE = ONE;
	
	/**
	 * @type {!Long}
	 * @inner
	 */
	var UONE = fromInt(1, true);
	
	/**
	 * Unsigned one.
	 * @type {!Long}
	 */
	Long.UONE = UONE;
	
	/**
	 * @type {!Long}
	 * @inner
	 */
	var NEG_ONE = fromInt(-1);
	
	/**
	 * Signed negative one.
	 * @type {!Long}
	 */
	Long.NEG_ONE = NEG_ONE;
	
	/**
	 * @type {!Long}
	 * @inner
	 */
	var MAX_VALUE = fromBits(0xFFFFFFFF|0, 0x7FFFFFFF|0, false);
	
	/**
	 * Maximum signed value.
	 * @type {!Long}
	 */
	Long.MAX_VALUE = MAX_VALUE;
	
	/**
	 * @type {!Long}
	 * @inner
	 */
	var MAX_UNSIGNED_VALUE = fromBits(0xFFFFFFFF|0, 0xFFFFFFFF|0, true);
	
	/**
	 * Maximum unsigned value.
	 * @type {!Long}
	 */
	Long.MAX_UNSIGNED_VALUE = MAX_UNSIGNED_VALUE;
	
	/**
	 * @type {!Long}
	 * @inner
	 */
	var MIN_VALUE = fromBits(0, 0x80000000|0, false);
	
	/**
	 * Minimum signed value.
	 * @type {!Long}
	 */
	Long.MIN_VALUE = MIN_VALUE;
	
	/**
	 * @alias Long.prototype
	 * @inner
	 */
	var LongPrototype = Long.prototype;
	
	/**
	 * Converts the Long to a 32 bit integer, assuming it is a 32 bit integer.
	 * @returns {number}
	 */
	LongPrototype.toInt = function toInt() {
	    return this.unsigned ? this.low >>> 0 : this.low;
	};
	
	/**
	 * Converts the Long to a the nearest floating-point representation of this value (double, 53 bit mantissa).
	 * @returns {number}
	 */
	LongPrototype.toNumber = function toNumber() {
	    if (this.unsigned)
	        return ((this.high >>> 0) * TWO_PWR_32_DBL) + (this.low >>> 0);
	    return this.high * TWO_PWR_32_DBL + (this.low >>> 0);
	};
	
	/**
	 * Converts the Long to a string written in the specified radix.
	 * @param {number=} radix Radix (2-36), defaults to 10
	 * @returns {string}
	 * @override
	 * @throws {RangeError} If `radix` is out of range
	 */
	LongPrototype.toString = function toString(radix) {
	    radix = radix || 10;
	    if (radix < 2 || 36 < radix)
	        throw RangeError('radix');
	    if (this.isZero())
	        return '0';
	    if (this.isNegative()) { // Unsigned Longs are never negative
	        if (this.eq(MIN_VALUE)) {
	            // We need to change the Long value before it can be negated, so we remove
	            // the bottom-most digit in this base and then recurse to do the rest.
	            var radixLong = fromNumber(radix),
	                div = this.div(radixLong),
	                rem1 = div.mul(radixLong).sub(this);
	            return div.toString(radix) + rem1.toInt().toString(radix);
	        } else
	            return '-' + this.neg().toString(radix);
	    }
	
	    // Do several (6) digits each time through the loop, so as to
	    // minimize the calls to the very expensive emulated div.
	    var radixToPower = fromNumber(pow_dbl(radix, 6), this.unsigned),
	        rem = this;
	    var result = '';
	    while (true) {
	        var remDiv = rem.div(radixToPower),
	            intval = rem.sub(remDiv.mul(radixToPower)).toInt() >>> 0,
	            digits = intval.toString(radix);
	        rem = remDiv;
	        if (rem.isZero())
	            return digits + result;
	        else {
	            while (digits.length < 6)
	                digits = '0' + digits;
	            result = '' + digits + result;
	        }
	    }
	};
	
	/**
	 * Gets the high 32 bits as a signed integer.
	 * @returns {number} Signed high bits
	 */
	LongPrototype.getHighBits = function getHighBits() {
	    return this.high;
	};
	
	/**
	 * Gets the high 32 bits as an unsigned integer.
	 * @returns {number} Unsigned high bits
	 */
	LongPrototype.getHighBitsUnsigned = function getHighBitsUnsigned() {
	    return this.high >>> 0;
	};
	
	/**
	 * Gets the low 32 bits as a signed integer.
	 * @returns {number} Signed low bits
	 */
	LongPrototype.getLowBits = function getLowBits() {
	    return this.low;
	};
	
	/**
	 * Gets the low 32 bits as an unsigned integer.
	 * @returns {number} Unsigned low bits
	 */
	LongPrototype.getLowBitsUnsigned = function getLowBitsUnsigned() {
	    return this.low >>> 0;
	};
	
	/**
	 * Gets the number of bits needed to represent the absolute value of this Long.
	 * @returns {number}
	 */
	LongPrototype.getNumBitsAbs = function getNumBitsAbs() {
	    if (this.isNegative()) // Unsigned Longs are never negative
	        return this.eq(MIN_VALUE) ? 64 : this.neg().getNumBitsAbs();
	    var val = this.high != 0 ? this.high : this.low;
	    for (var bit = 31; bit > 0; bit--)
	        if ((val & (1 << bit)) != 0)
	            break;
	    return this.high != 0 ? bit + 33 : bit + 1;
	};
	
	/**
	 * Tests if this Long's value equals zero.
	 * @returns {boolean}
	 */
	LongPrototype.isZero = function isZero() {
	    return this.high === 0 && this.low === 0;
	};
	
	/**
	 * Tests if this Long's value equals zero. This is an alias of {@link Long#isZero}.
	 * @returns {boolean}
	 */
	LongPrototype.eqz = LongPrototype.isZero;
	
	/**
	 * Tests if this Long's value is negative.
	 * @returns {boolean}
	 */
	LongPrototype.isNegative = function isNegative() {
	    return !this.unsigned && this.high < 0;
	};
	
	/**
	 * Tests if this Long's value is positive.
	 * @returns {boolean}
	 */
	LongPrototype.isPositive = function isPositive() {
	    return this.unsigned || this.high >= 0;
	};
	
	/**
	 * Tests if this Long's value is odd.
	 * @returns {boolean}
	 */
	LongPrototype.isOdd = function isOdd() {
	    return (this.low & 1) === 1;
	};
	
	/**
	 * Tests if this Long's value is even.
	 * @returns {boolean}
	 */
	LongPrototype.isEven = function isEven() {
	    return (this.low & 1) === 0;
	};
	
	/**
	 * Tests if this Long's value equals the specified's.
	 * @param {!Long|number|string} other Other value
	 * @returns {boolean}
	 */
	LongPrototype.equals = function equals(other) {
	    if (!isLong(other))
	        other = fromValue(other);
	    if (this.unsigned !== other.unsigned && (this.high >>> 31) === 1 && (other.high >>> 31) === 1)
	        return false;
	    return this.high === other.high && this.low === other.low;
	};
	
	/**
	 * Tests if this Long's value equals the specified's. This is an alias of {@link Long#equals}.
	 * @function
	 * @param {!Long|number|string} other Other value
	 * @returns {boolean}
	 */
	LongPrototype.eq = LongPrototype.equals;
	
	/**
	 * Tests if this Long's value differs from the specified's.
	 * @param {!Long|number|string} other Other value
	 * @returns {boolean}
	 */
	LongPrototype.notEquals = function notEquals(other) {
	    return !this.eq(/* validates */ other);
	};
	
	/**
	 * Tests if this Long's value differs from the specified's. This is an alias of {@link Long#notEquals}.
	 * @function
	 * @param {!Long|number|string} other Other value
	 * @returns {boolean}
	 */
	LongPrototype.neq = LongPrototype.notEquals;
	
	/**
	 * Tests if this Long's value differs from the specified's. This is an alias of {@link Long#notEquals}.
	 * @function
	 * @param {!Long|number|string} other Other value
	 * @returns {boolean}
	 */
	LongPrototype.ne = LongPrototype.notEquals;
	
	/**
	 * Tests if this Long's value is less than the specified's.
	 * @param {!Long|number|string} other Other value
	 * @returns {boolean}
	 */
	LongPrototype.lessThan = function lessThan(other) {
	    return this.comp(/* validates */ other) < 0;
	};
	
	/**
	 * Tests if this Long's value is less than the specified's. This is an alias of {@link Long#lessThan}.
	 * @function
	 * @param {!Long|number|string} other Other value
	 * @returns {boolean}
	 */
	LongPrototype.lt = LongPrototype.lessThan;
	
	/**
	 * Tests if this Long's value is less than or equal the specified's.
	 * @param {!Long|number|string} other Other value
	 * @returns {boolean}
	 */
	LongPrototype.lessThanOrEqual = function lessThanOrEqual(other) {
	    return this.comp(/* validates */ other) <= 0;
	};
	
	/**
	 * Tests if this Long's value is less than or equal the specified's. This is an alias of {@link Long#lessThanOrEqual}.
	 * @function
	 * @param {!Long|number|string} other Other value
	 * @returns {boolean}
	 */
	LongPrototype.lte = LongPrototype.lessThanOrEqual;
	
	/**
	 * Tests if this Long's value is less than or equal the specified's. This is an alias of {@link Long#lessThanOrEqual}.
	 * @function
	 * @param {!Long|number|string} other Other value
	 * @returns {boolean}
	 */
	LongPrototype.le = LongPrototype.lessThanOrEqual;
	
	/**
	 * Tests if this Long's value is greater than the specified's.
	 * @param {!Long|number|string} other Other value
	 * @returns {boolean}
	 */
	LongPrototype.greaterThan = function greaterThan(other) {
	    return this.comp(/* validates */ other) > 0;
	};
	
	/**
	 * Tests if this Long's value is greater than the specified's. This is an alias of {@link Long#greaterThan}.
	 * @function
	 * @param {!Long|number|string} other Other value
	 * @returns {boolean}
	 */
	LongPrototype.gt = LongPrototype.greaterThan;
	
	/**
	 * Tests if this Long's value is greater than or equal the specified's.
	 * @param {!Long|number|string} other Other value
	 * @returns {boolean}
	 */
	LongPrototype.greaterThanOrEqual = function greaterThanOrEqual(other) {
	    return this.comp(/* validates */ other) >= 0;
	};
	
	/**
	 * Tests if this Long's value is greater than or equal the specified's. This is an alias of {@link Long#greaterThanOrEqual}.
	 * @function
	 * @param {!Long|number|string} other Other value
	 * @returns {boolean}
	 */
	LongPrototype.gte = LongPrototype.greaterThanOrEqual;
	
	/**
	 * Tests if this Long's value is greater than or equal the specified's. This is an alias of {@link Long#greaterThanOrEqual}.
	 * @function
	 * @param {!Long|number|string} other Other value
	 * @returns {boolean}
	 */
	LongPrototype.ge = LongPrototype.greaterThanOrEqual;
	
	/**
	 * Compares this Long's value with the specified's.
	 * @param {!Long|number|string} other Other value
	 * @returns {number} 0 if they are the same, 1 if the this is greater and -1
	 *  if the given one is greater
	 */
	LongPrototype.compare = function compare(other) {
	    if (!isLong(other))
	        other = fromValue(other);
	    if (this.eq(other))
	        return 0;
	    var thisNeg = this.isNegative(),
	        otherNeg = other.isNegative();
	    if (thisNeg && !otherNeg)
	        return -1;
	    if (!thisNeg && otherNeg)
	        return 1;
	    // At this point the sign bits are the same
	    if (!this.unsigned)
	        return this.sub(other).isNegative() ? -1 : 1;
	    // Both are positive if at least one is unsigned
	    return (other.high >>> 0) > (this.high >>> 0) || (other.high === this.high && (other.low >>> 0) > (this.low >>> 0)) ? -1 : 1;
	};
	
	/**
	 * Compares this Long's value with the specified's. This is an alias of {@link Long#compare}.
	 * @function
	 * @param {!Long|number|string} other Other value
	 * @returns {number} 0 if they are the same, 1 if the this is greater and -1
	 *  if the given one is greater
	 */
	LongPrototype.comp = LongPrototype.compare;
	
	/**
	 * Negates this Long's value.
	 * @returns {!Long} Negated Long
	 */
	LongPrototype.negate = function negate() {
	    if (!this.unsigned && this.eq(MIN_VALUE))
	        return MIN_VALUE;
	    return this.not().add(ONE);
	};
	
	/**
	 * Negates this Long's value. This is an alias of {@link Long#negate}.
	 * @function
	 * @returns {!Long} Negated Long
	 */
	LongPrototype.neg = LongPrototype.negate;
	
	/**
	 * Returns the sum of this and the specified Long.
	 * @param {!Long|number|string} addend Addend
	 * @returns {!Long} Sum
	 */
	LongPrototype.add = function add(addend) {
	    if (!isLong(addend))
	        addend = fromValue(addend);
	
	    // Divide each number into 4 chunks of 16 bits, and then sum the chunks.
	
	    var a48 = this.high >>> 16;
	    var a32 = this.high & 0xFFFF;
	    var a16 = this.low >>> 16;
	    var a00 = this.low & 0xFFFF;
	
	    var b48 = addend.high >>> 16;
	    var b32 = addend.high & 0xFFFF;
	    var b16 = addend.low >>> 16;
	    var b00 = addend.low & 0xFFFF;
	
	    var c48 = 0, c32 = 0, c16 = 0, c00 = 0;
	    c00 += a00 + b00;
	    c16 += c00 >>> 16;
	    c00 &= 0xFFFF;
	    c16 += a16 + b16;
	    c32 += c16 >>> 16;
	    c16 &= 0xFFFF;
	    c32 += a32 + b32;
	    c48 += c32 >>> 16;
	    c32 &= 0xFFFF;
	    c48 += a48 + b48;
	    c48 &= 0xFFFF;
	    return fromBits((c16 << 16) | c00, (c48 << 16) | c32, this.unsigned);
	};
	
	/**
	 * Returns the difference of this and the specified Long.
	 * @param {!Long|number|string} subtrahend Subtrahend
	 * @returns {!Long} Difference
	 */
	LongPrototype.subtract = function subtract(subtrahend) {
	    if (!isLong(subtrahend))
	        subtrahend = fromValue(subtrahend);
	    return this.add(subtrahend.neg());
	};
	
	/**
	 * Returns the difference of this and the specified Long. This is an alias of {@link Long#subtract}.
	 * @function
	 * @param {!Long|number|string} subtrahend Subtrahend
	 * @returns {!Long} Difference
	 */
	LongPrototype.sub = LongPrototype.subtract;
	
	/**
	 * Returns the product of this and the specified Long.
	 * @param {!Long|number|string} multiplier Multiplier
	 * @returns {!Long} Product
	 */
	LongPrototype.multiply = function multiply(multiplier) {
	    if (this.isZero())
	        return ZERO;
	    if (!isLong(multiplier))
	        multiplier = fromValue(multiplier);
	
	    // use wasm support if present
	    if (wasm) {
	        var low = wasm.mul(this.low,
	                           this.high,
	                           multiplier.low,
	                           multiplier.high);
	        return fromBits(low, wasm.get_high(), this.unsigned);
	    }
	
	    if (multiplier.isZero())
	        return ZERO;
	    if (this.eq(MIN_VALUE))
	        return multiplier.isOdd() ? MIN_VALUE : ZERO;
	    if (multiplier.eq(MIN_VALUE))
	        return this.isOdd() ? MIN_VALUE : ZERO;
	
	    if (this.isNegative()) {
	        if (multiplier.isNegative())
	            return this.neg().mul(multiplier.neg());
	        else
	            return this.neg().mul(multiplier).neg();
	    } else if (multiplier.isNegative())
	        return this.mul(multiplier.neg()).neg();
	
	    // If both longs are small, use float multiplication
	    if (this.lt(TWO_PWR_24) && multiplier.lt(TWO_PWR_24))
	        return fromNumber(this.toNumber() * multiplier.toNumber(), this.unsigned);
	
	    // Divide each long into 4 chunks of 16 bits, and then add up 4x4 products.
	    // We can skip products that would overflow.
	
	    var a48 = this.high >>> 16;
	    var a32 = this.high & 0xFFFF;
	    var a16 = this.low >>> 16;
	    var a00 = this.low & 0xFFFF;
	
	    var b48 = multiplier.high >>> 16;
	    var b32 = multiplier.high & 0xFFFF;
	    var b16 = multiplier.low >>> 16;
	    var b00 = multiplier.low & 0xFFFF;
	
	    var c48 = 0, c32 = 0, c16 = 0, c00 = 0;
	    c00 += a00 * b00;
	    c16 += c00 >>> 16;
	    c00 &= 0xFFFF;
	    c16 += a16 * b00;
	    c32 += c16 >>> 16;
	    c16 &= 0xFFFF;
	    c16 += a00 * b16;
	    c32 += c16 >>> 16;
	    c16 &= 0xFFFF;
	    c32 += a32 * b00;
	    c48 += c32 >>> 16;
	    c32 &= 0xFFFF;
	    c32 += a16 * b16;
	    c48 += c32 >>> 16;
	    c32 &= 0xFFFF;
	    c32 += a00 * b32;
	    c48 += c32 >>> 16;
	    c32 &= 0xFFFF;
	    c48 += a48 * b00 + a32 * b16 + a16 * b32 + a00 * b48;
	    c48 &= 0xFFFF;
	    return fromBits((c16 << 16) | c00, (c48 << 16) | c32, this.unsigned);
	};
	
	/**
	 * Returns the product of this and the specified Long. This is an alias of {@link Long#multiply}.
	 * @function
	 * @param {!Long|number|string} multiplier Multiplier
	 * @returns {!Long} Product
	 */
	LongPrototype.mul = LongPrototype.multiply;
	
	/**
	 * Returns this Long divided by the specified. The result is signed if this Long is signed or
	 *  unsigned if this Long is unsigned.
	 * @param {!Long|number|string} divisor Divisor
	 * @returns {!Long} Quotient
	 */
	LongPrototype.divide = function divide(divisor) {
	    if (!isLong(divisor))
	        divisor = fromValue(divisor);
	    if (divisor.isZero())
	        throw Error('division by zero');
	
	    // use wasm support if present
	    if (wasm) {
	        // guard against signed division overflow: the largest
	        // negative number / -1 would be 1 larger than the largest
	        // positive number, due to two's complement.
	        if (!this.unsigned &&
	            this.high === -0x80000000 &&
	            divisor.low === -1 && divisor.high === -1) {
	            // be consistent with non-wasm code path
	            return this;
	        }
	        var low = (this.unsigned ? wasm.div_u : wasm.div_s)(
	            this.low,
	            this.high,
	            divisor.low,
	            divisor.high
	        );
	        return fromBits(low, wasm.get_high(), this.unsigned);
	    }
	
	    if (this.isZero())
	        return this.unsigned ? UZERO : ZERO;
	    var approx, rem, res;
	    if (!this.unsigned) {
	        // This section is only relevant for signed longs and is derived from the
	        // closure library as a whole.
	        if (this.eq(MIN_VALUE)) {
	            if (divisor.eq(ONE) || divisor.eq(NEG_ONE))
	                return MIN_VALUE;  // recall that -MIN_VALUE == MIN_VALUE
	            else if (divisor.eq(MIN_VALUE))
	                return ONE;
	            else {
	                // At this point, we have |other| >= 2, so |this/other| < |MIN_VALUE|.
	                var halfThis = this.shr(1);
	                approx = halfThis.div(divisor).shl(1);
	                if (approx.eq(ZERO)) {
	                    return divisor.isNegative() ? ONE : NEG_ONE;
	                } else {
	                    rem = this.sub(divisor.mul(approx));
	                    res = approx.add(rem.div(divisor));
	                    return res;
	                }
	            }
	        } else if (divisor.eq(MIN_VALUE))
	            return this.unsigned ? UZERO : ZERO;
	        if (this.isNegative()) {
	            if (divisor.isNegative())
	                return this.neg().div(divisor.neg());
	            return this.neg().div(divisor).neg();
	        } else if (divisor.isNegative())
	            return this.div(divisor.neg()).neg();
	        res = ZERO;
	    } else {
	        // The algorithm below has not been made for unsigned longs. It's therefore
	        // required to take special care of the MSB prior to running it.
	        if (!divisor.unsigned)
	            divisor = divisor.toUnsigned();
	        if (divisor.gt(this))
	            return UZERO;
	        if (divisor.gt(this.shru(1))) // 15 >>> 1 = 7 ; with divisor = 8 ; true
	            return UONE;
	        res = UZERO;
	    }
	
	    // Repeat the following until the remainder is less than other:  find a
	    // floating-point that approximates remainder / other *from below*, add this
	    // into the result, and subtract it from the remainder.  It is critical that
	    // the approximate value is less than or equal to the real value so that the
	    // remainder never becomes negative.
	    rem = this;
	    while (rem.gte(divisor)) {
	        // Approximate the result of division. This may be a little greater or
	        // smaller than the actual value.
	        approx = Math.max(1, Math.floor(rem.toNumber() / divisor.toNumber()));
	
	        // We will tweak the approximate result by changing it in the 48-th digit or
	        // the smallest non-fractional digit, whichever is larger.
	        var log2 = Math.ceil(Math.log(approx) / Math.LN2),
	            delta = (log2 <= 48) ? 1 : pow_dbl(2, log2 - 48),
	
	        // Decrease the approximation until it is smaller than the remainder.  Note
	        // that if it is too large, the product overflows and is negative.
	            approxRes = fromNumber(approx),
	            approxRem = approxRes.mul(divisor);
	        while (approxRem.isNegative() || approxRem.gt(rem)) {
	            approx -= delta;
	            approxRes = fromNumber(approx, this.unsigned);
	            approxRem = approxRes.mul(divisor);
	        }
	
	        // We know the answer can't be zero... and actually, zero would cause
	        // infinite recursion since we would make no progress.
	        if (approxRes.isZero())
	            approxRes = ONE;
	
	        res = res.add(approxRes);
	        rem = rem.sub(approxRem);
	    }
	    return res;
	};
	
	/**
	 * Returns this Long divided by the specified. This is an alias of {@link Long#divide}.
	 * @function
	 * @param {!Long|number|string} divisor Divisor
	 * @returns {!Long} Quotient
	 */
	LongPrototype.div = LongPrototype.divide;
	
	/**
	 * Returns this Long modulo the specified.
	 * @param {!Long|number|string} divisor Divisor
	 * @returns {!Long} Remainder
	 */
	LongPrototype.modulo = function modulo(divisor) {
	    if (!isLong(divisor))
	        divisor = fromValue(divisor);
	
	    // use wasm support if present
	    if (wasm) {
	        var low = (this.unsigned ? wasm.rem_u : wasm.rem_s)(
	            this.low,
	            this.high,
	            divisor.low,
	            divisor.high
	        );
	        return fromBits(low, wasm.get_high(), this.unsigned);
	    }
	
	    return this.sub(this.div(divisor).mul(divisor));
	};
	
	/**
	 * Returns this Long modulo the specified. This is an alias of {@link Long#modulo}.
	 * @function
	 * @param {!Long|number|string} divisor Divisor
	 * @returns {!Long} Remainder
	 */
	LongPrototype.mod = LongPrototype.modulo;
	
	/**
	 * Returns this Long modulo the specified. This is an alias of {@link Long#modulo}.
	 * @function
	 * @param {!Long|number|string} divisor Divisor
	 * @returns {!Long} Remainder
	 */
	LongPrototype.rem = LongPrototype.modulo;
	
	/**
	 * Returns the bitwise NOT of this Long.
	 * @returns {!Long}
	 */
	LongPrototype.not = function not() {
	    return fromBits(~this.low, ~this.high, this.unsigned);
	};
	
	/**
	 * Returns the bitwise AND of this Long and the specified.
	 * @param {!Long|number|string} other Other Long
	 * @returns {!Long}
	 */
	LongPrototype.and = function and(other) {
	    if (!isLong(other))
	        other = fromValue(other);
	    return fromBits(this.low & other.low, this.high & other.high, this.unsigned);
	};
	
	/**
	 * Returns the bitwise OR of this Long and the specified.
	 * @param {!Long|number|string} other Other Long
	 * @returns {!Long}
	 */
	LongPrototype.or = function or(other) {
	    if (!isLong(other))
	        other = fromValue(other);
	    return fromBits(this.low | other.low, this.high | other.high, this.unsigned);
	};
	
	/**
	 * Returns the bitwise XOR of this Long and the given one.
	 * @param {!Long|number|string} other Other Long
	 * @returns {!Long}
	 */
	LongPrototype.xor = function xor(other) {
	    if (!isLong(other))
	        other = fromValue(other);
	    return fromBits(this.low ^ other.low, this.high ^ other.high, this.unsigned);
	};
	
	/**
	 * Returns this Long with bits shifted to the left by the given amount.
	 * @param {number|!Long} numBits Number of bits
	 * @returns {!Long} Shifted Long
	 */
	LongPrototype.shiftLeft = function shiftLeft(numBits) {
	    if (isLong(numBits))
	        numBits = numBits.toInt();
	    if ((numBits &= 63) === 0)
	        return this;
	    else if (numBits < 32)
	        return fromBits(this.low << numBits, (this.high << numBits) | (this.low >>> (32 - numBits)), this.unsigned);
	    else
	        return fromBits(0, this.low << (numBits - 32), this.unsigned);
	};
	
	/**
	 * Returns this Long with bits shifted to the left by the given amount. This is an alias of {@link Long#shiftLeft}.
	 * @function
	 * @param {number|!Long} numBits Number of bits
	 * @returns {!Long} Shifted Long
	 */
	LongPrototype.shl = LongPrototype.shiftLeft;
	
	/**
	 * Returns this Long with bits arithmetically shifted to the right by the given amount.
	 * @param {number|!Long} numBits Number of bits
	 * @returns {!Long} Shifted Long
	 */
	LongPrototype.shiftRight = function shiftRight(numBits) {
	    if (isLong(numBits))
	        numBits = numBits.toInt();
	    if ((numBits &= 63) === 0)
	        return this;
	    else if (numBits < 32)
	        return fromBits((this.low >>> numBits) | (this.high << (32 - numBits)), this.high >> numBits, this.unsigned);
	    else
	        return fromBits(this.high >> (numBits - 32), this.high >= 0 ? 0 : -1, this.unsigned);
	};
	
	/**
	 * Returns this Long with bits arithmetically shifted to the right by the given amount. This is an alias of {@link Long#shiftRight}.
	 * @function
	 * @param {number|!Long} numBits Number of bits
	 * @returns {!Long} Shifted Long
	 */
	LongPrototype.shr = LongPrototype.shiftRight;
	
	/**
	 * Returns this Long with bits logically shifted to the right by the given amount.
	 * @param {number|!Long} numBits Number of bits
	 * @returns {!Long} Shifted Long
	 */
	LongPrototype.shiftRightUnsigned = function shiftRightUnsigned(numBits) {
	    if (isLong(numBits))
	        numBits = numBits.toInt();
	    numBits &= 63;
	    if (numBits === 0)
	        return this;
	    else {
	        var high = this.high;
	        if (numBits < 32) {
	            var low = this.low;
	            return fromBits((low >>> numBits) | (high << (32 - numBits)), high >>> numBits, this.unsigned);
	        } else if (numBits === 32)
	            return fromBits(high, 0, this.unsigned);
	        else
	            return fromBits(high >>> (numBits - 32), 0, this.unsigned);
	    }
	};
	
	/**
	 * Returns this Long with bits logically shifted to the right by the given amount. This is an alias of {@link Long#shiftRightUnsigned}.
	 * @function
	 * @param {number|!Long} numBits Number of bits
	 * @returns {!Long} Shifted Long
	 */
	LongPrototype.shru = LongPrototype.shiftRightUnsigned;
	
	/**
	 * Returns this Long with bits logically shifted to the right by the given amount. This is an alias of {@link Long#shiftRightUnsigned}.
	 * @function
	 * @param {number|!Long} numBits Number of bits
	 * @returns {!Long} Shifted Long
	 */
	LongPrototype.shr_u = LongPrototype.shiftRightUnsigned;
	
	/**
	 * Converts this Long to signed.
	 * @returns {!Long} Signed long
	 */
	LongPrototype.toSigned = function toSigned() {
	    if (!this.unsigned)
	        return this;
	    return fromBits(this.low, this.high, false);
	};
	
	/**
	 * Converts this Long to unsigned.
	 * @returns {!Long} Unsigned long
	 */
	LongPrototype.toUnsigned = function toUnsigned() {
	    if (this.unsigned)
	        return this;
	    return fromBits(this.low, this.high, true);
	};
	
	/**
	 * Converts this Long to its byte representation.
	 * @param {boolean=} le Whether little or big endian, defaults to big endian
	 * @returns {!Array.<number>} Byte representation
	 */
	LongPrototype.toBytes = function toBytes(le) {
	    return le ? this.toBytesLE() : this.toBytesBE();
	};
	
	/**
	 * Converts this Long to its little endian byte representation.
	 * @returns {!Array.<number>} Little endian byte representation
	 */
	LongPrototype.toBytesLE = function toBytesLE() {
	    var hi = this.high,
	        lo = this.low;
	    return [
	        lo        & 0xff,
	        lo >>>  8 & 0xff,
	        lo >>> 16 & 0xff,
	        lo >>> 24       ,
	        hi        & 0xff,
	        hi >>>  8 & 0xff,
	        hi >>> 16 & 0xff,
	        hi >>> 24
	    ];
	};
	
	/**
	 * Converts this Long to its big endian byte representation.
	 * @returns {!Array.<number>} Big endian byte representation
	 */
	LongPrototype.toBytesBE = function toBytesBE() {
	    var hi = this.high,
	        lo = this.low;
	    return [
	        hi >>> 24       ,
	        hi >>> 16 & 0xff,
	        hi >>>  8 & 0xff,
	        hi        & 0xff,
	        lo >>> 24       ,
	        lo >>> 16 & 0xff,
	        lo >>>  8 & 0xff,
	        lo        & 0xff
	    ];
	};
	
	/**
	 * Creates a Long from its byte representation.
	 * @param {!Array.<number>} bytes Byte representation
	 * @param {boolean=} unsigned Whether unsigned or not, defaults to signed
	 * @param {boolean=} le Whether little or big endian, defaults to big endian
	 * @returns {Long} The corresponding Long value
	 */
	Long.fromBytes = function fromBytes(bytes, unsigned, le) {
	    return le ? Long.fromBytesLE(bytes, unsigned) : Long.fromBytesBE(bytes, unsigned);
	};
	
	/**
	 * Creates a Long from its little endian byte representation.
	 * @param {!Array.<number>} bytes Little endian byte representation
	 * @param {boolean=} unsigned Whether unsigned or not, defaults to signed
	 * @returns {Long} The corresponding Long value
	 */
	Long.fromBytesLE = function fromBytesLE(bytes, unsigned) {
	    return new Long(
	        bytes[0]       |
	        bytes[1] <<  8 |
	        bytes[2] << 16 |
	        bytes[3] << 24,
	        bytes[4]       |
	        bytes[5] <<  8 |
	        bytes[6] << 16 |
	        bytes[7] << 24,
	        unsigned
	    );
	};
	
	/**
	 * Creates a Long from its big endian byte representation.
	 * @param {!Array.<number>} bytes Big endian byte representation
	 * @param {boolean=} unsigned Whether unsigned or not, defaults to signed
	 * @returns {Long} The corresponding Long value
	 */
	Long.fromBytesBE = function fromBytesBE(bytes, unsigned) {
	    return new Long(
	        bytes[4] << 24 |
	        bytes[5] << 16 |
	        bytes[6] <<  8 |
	        bytes[7],
	        bytes[0] << 24 |
	        bytes[1] << 16 |
	        bytes[2] <<  8 |
	        bytes[3],
	        unsigned
	    );
	};


/***/ },
/* 15 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer, process) {"use strict"
	
	var bomHandling = __webpack_require__(16),
	    iconv = module.exports;
	
	// All codecs and aliases are kept here, keyed by encoding name/alias.
	// They are lazy loaded in `iconv.getCodec` from `encodings/index.js`.
	iconv.encodings = null;
	
	// Characters emitted in case of error.
	iconv.defaultCharUnicode = '�';
	iconv.defaultCharSingleByte = '?';
	
	// Public API.
	iconv.encode = function encode(str, encoding, options) {
	    str = "" + (str || ""); // Ensure string.
	
	    var encoder = iconv.getEncoder(encoding, options);
	
	    var res = encoder.write(str);
	    var trail = encoder.end();
	    
	    return (trail && trail.length > 0) ? Buffer.concat([res, trail]) : res;
	}
	
	iconv.decode = function decode(buf, encoding, options) {
	    if (typeof buf === 'string') {
	        if (!iconv.skipDecodeWarning) {
	            console.error('Iconv-lite warning: decode()-ing strings is deprecated. Refer to https://github.com/ashtuchkin/iconv-lite/wiki/Use-Buffers-when-decoding');
	            iconv.skipDecodeWarning = true;
	        }
	
	        buf = new Buffer("" + (buf || ""), "binary"); // Ensure buffer.
	    }
	
	    var decoder = iconv.getDecoder(encoding, options);
	
	    var res = decoder.write(buf);
	    var trail = decoder.end();
	
	    return trail ? (res + trail) : res;
	}
	
	iconv.encodingExists = function encodingExists(enc) {
	    try {
	        iconv.getCodec(enc);
	        return true;
	    } catch (e) {
	        return false;
	    }
	}
	
	// Legacy aliases to convert functions
	iconv.toEncoding = iconv.encode;
	iconv.fromEncoding = iconv.decode;
	
	// Search for a codec in iconv.encodings. Cache codec data in iconv._codecDataCache.
	iconv._codecDataCache = {};
	iconv.getCodec = function getCodec(encoding) {
	    if (!iconv.encodings)
	        iconv.encodings = __webpack_require__(17); // Lazy load all encoding definitions.
	    
	    // Canonicalize encoding name: strip all non-alphanumeric chars and appended year.
	    var enc = (''+encoding).toLowerCase().replace(/[^0-9a-z]|:\d{4}$/g, "");
	
	    // Traverse iconv.encodings to find actual codec.
	    var codecOptions = {};
	    while (true) {
	        var codec = iconv._codecDataCache[enc];
	        if (codec)
	            return codec;
	
	        var codecDef = iconv.encodings[enc];
	
	        switch (typeof codecDef) {
	            case "string": // Direct alias to other encoding.
	                enc = codecDef;
	                break;
	
	            case "object": // Alias with options. Can be layered.
	                for (var key in codecDef)
	                    codecOptions[key] = codecDef[key];
	
	                if (!codecOptions.encodingName)
	                    codecOptions.encodingName = enc;
	                
	                enc = codecDef.type;
	                break;
	
	            case "function": // Codec itself.
	                if (!codecOptions.encodingName)
	                    codecOptions.encodingName = enc;
	
	                // The codec function must load all tables and return object with .encoder and .decoder methods.
	                // It'll be called only once (for each different options object).
	                codec = new codecDef(codecOptions, iconv);
	
	                iconv._codecDataCache[codecOptions.encodingName] = codec; // Save it to be reused later.
	                return codec;
	
	            default:
	                throw new Error("Encoding not recognized: '" + encoding + "' (searched as: '"+enc+"')");
	        }
	    }
	}
	
	iconv.getEncoder = function getEncoder(encoding, options) {
	    var codec = iconv.getCodec(encoding),
	        encoder = new codec.encoder(options, codec);
	
	    if (codec.bomAware && options && options.addBOM)
	        encoder = new bomHandling.PrependBOM(encoder, options);
	
	    return encoder;
	}
	
	iconv.getDecoder = function getDecoder(encoding, options) {
	    var codec = iconv.getCodec(encoding),
	        decoder = new codec.decoder(options, codec);
	
	    if (codec.bomAware && !(options && options.stripBOM === false))
	        decoder = new bomHandling.StripBOM(decoder, options);
	
	    return decoder;
	}
	
	
	// Load extensions in Node. All of them are omitted in Browserify build via 'browser' field in package.json.
	var nodeVer = typeof process !== 'undefined' && process.versions && process.versions.node;
	if (nodeVer) {
	
	    // Load streaming support in Node v0.10+
	    var nodeVerArr = nodeVer.split(".").map(Number);
	    if (nodeVerArr[0] > 0 || nodeVerArr[1] >= 10) {
	        __webpack_require__(38)(iconv);
	    }
	
	    // Load Node primitive extensions.
	    __webpack_require__(55)(iconv);
	}
	
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(9).Buffer, __webpack_require__(3)))

/***/ },
/* 16 */
/***/ function(module, exports) {

	"use strict"
	
	var BOMChar = '\uFEFF';
	
	exports.PrependBOM = PrependBOMWrapper
	function PrependBOMWrapper(encoder, options) {
	    this.encoder = encoder;
	    this.addBOM = true;
	}
	
	PrependBOMWrapper.prototype.write = function(str) {
	    if (this.addBOM) {
	        str = BOMChar + str;
	        this.addBOM = false;
	    }
	
	    return this.encoder.write(str);
	}
	
	PrependBOMWrapper.prototype.end = function() {
	    return this.encoder.end();
	}
	
	
	//------------------------------------------------------------------------------
	
	exports.StripBOM = StripBOMWrapper;
	function StripBOMWrapper(decoder, options) {
	    this.decoder = decoder;
	    this.pass = false;
	    this.options = options || {};
	}
	
	StripBOMWrapper.prototype.write = function(buf) {
	    var res = this.decoder.write(buf);
	    if (this.pass || !res)
	        return res;
	
	    if (res[0] === BOMChar) {
	        res = res.slice(1);
	        if (typeof this.options.stripBOM === 'function')
	            this.options.stripBOM();
	    }
	
	    this.pass = true;
	    return res;
	}
	
	StripBOMWrapper.prototype.end = function() {
	    return this.decoder.end();
	}
	


/***/ },
/* 17 */
/***/ function(module, exports, __webpack_require__) {

	"use strict"
	
	// Update this array if you add/rename/remove files in this directory.
	// We support Browserify by skipping automatic module discovery and requiring modules directly.
	var modules = [
	    __webpack_require__(18),
	    __webpack_require__(23),
	    __webpack_require__(24),
	    __webpack_require__(25),
	    __webpack_require__(26),
	    __webpack_require__(27),
	    __webpack_require__(28),
	    __webpack_require__(29),
	];
	
	// Put all encoding/alias/codec definitions to single object and export it. 
	for (var i = 0; i < modules.length; i++) {
	    var module = modules[i];
	    for (var enc in module)
	        if (Object.prototype.hasOwnProperty.call(module, enc))
	            exports[enc] = module[enc];
	}


/***/ },
/* 18 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {"use strict"
	
	// Export Node.js internal encodings.
	
	module.exports = {
	    // Encodings
	    utf8:   { type: "_internal", bomAware: true},
	    cesu8:  { type: "_internal", bomAware: true},
	    unicode11utf8: "utf8",
	
	    ucs2:   { type: "_internal", bomAware: true},
	    utf16le: "ucs2",
	
	    binary: { type: "_internal" },
	    base64: { type: "_internal" },
	    hex:    { type: "_internal" },
	
	    // Codec.
	    _internal: InternalCodec,
	};
	
	//------------------------------------------------------------------------------
	
	function InternalCodec(codecOptions, iconv) {
	    this.enc = codecOptions.encodingName;
	    this.bomAware = codecOptions.bomAware;
	
	    if (this.enc === "base64")
	        this.encoder = InternalEncoderBase64;
	    else if (this.enc === "cesu8") {
	        this.enc = "utf8"; // Use utf8 for decoding.
	        this.encoder = InternalEncoderCesu8;
	
	        // Add decoder for versions of Node not supporting CESU-8
	        if (new Buffer("eda080", 'hex').toString().length == 3) {
	            this.decoder = InternalDecoderCesu8;
	            this.defaultCharUnicode = iconv.defaultCharUnicode;
	        }
	    }
	}
	
	InternalCodec.prototype.encoder = InternalEncoder;
	InternalCodec.prototype.decoder = InternalDecoder;
	
	//------------------------------------------------------------------------------
	
	// We use node.js internal decoder. Its signature is the same as ours.
	var StringDecoder = __webpack_require__(19).StringDecoder;
	
	if (!StringDecoder.prototype.end) // Node v0.8 doesn't have this method.
	    StringDecoder.prototype.end = function() {};
	
	
	function InternalDecoder(options, codec) {
	    StringDecoder.call(this, codec.enc);
	}
	
	InternalDecoder.prototype = StringDecoder.prototype;
	
	
	//------------------------------------------------------------------------------
	// Encoder is mostly trivial
	
	function InternalEncoder(options, codec) {
	    this.enc = codec.enc;
	}
	
	InternalEncoder.prototype.write = function(str) {
	    return new Buffer(str, this.enc);
	}
	
	InternalEncoder.prototype.end = function() {
	}
	
	
	//------------------------------------------------------------------------------
	// Except base64 encoder, which must keep its state.
	
	function InternalEncoderBase64(options, codec) {
	    this.prevStr = '';
	}
	
	InternalEncoderBase64.prototype.write = function(str) {
	    str = this.prevStr + str;
	    var completeQuads = str.length - (str.length % 4);
	    this.prevStr = str.slice(completeQuads);
	    str = str.slice(0, completeQuads);
	
	    return new Buffer(str, "base64");
	}
	
	InternalEncoderBase64.prototype.end = function() {
	    return new Buffer(this.prevStr, "base64");
	}
	
	
	//------------------------------------------------------------------------------
	// CESU-8 encoder is also special.
	
	function InternalEncoderCesu8(options, codec) {
	}
	
	InternalEncoderCesu8.prototype.write = function(str) {
	    var buf = new Buffer(str.length * 3), bufIdx = 0;
	    for (var i = 0; i < str.length; i++) {
	        var charCode = str.charCodeAt(i);
	        // Naive implementation, but it works because CESU-8 is especially easy
	        // to convert from UTF-16 (which all JS strings are encoded in).
	        if (charCode < 0x80)
	            buf[bufIdx++] = charCode;
	        else if (charCode < 0x800) {
	            buf[bufIdx++] = 0xC0 + (charCode >>> 6);
	            buf[bufIdx++] = 0x80 + (charCode & 0x3f);
	        }
	        else { // charCode will always be < 0x10000 in javascript.
	            buf[bufIdx++] = 0xE0 + (charCode >>> 12);
	            buf[bufIdx++] = 0x80 + ((charCode >>> 6) & 0x3f);
	            buf[bufIdx++] = 0x80 + (charCode & 0x3f);
	        }
	    }
	    return buf.slice(0, bufIdx);
	}
	
	InternalEncoderCesu8.prototype.end = function() {
	}
	
	//------------------------------------------------------------------------------
	// CESU-8 decoder is not implemented in Node v4.0+
	
	function InternalDecoderCesu8(options, codec) {
	    this.acc = 0;
	    this.contBytes = 0;
	    this.accBytes = 0;
	    this.defaultCharUnicode = codec.defaultCharUnicode;
	}
	
	InternalDecoderCesu8.prototype.write = function(buf) {
	    var acc = this.acc, contBytes = this.contBytes, accBytes = this.accBytes, 
	        res = '';
	    for (var i = 0; i < buf.length; i++) {
	        var curByte = buf[i];
	        if ((curByte & 0xC0) !== 0x80) { // Leading byte
	            if (contBytes > 0) { // Previous code is invalid
	                res += this.defaultCharUnicode;
	                contBytes = 0;
	            }
	
	            if (curByte < 0x80) { // Single-byte code
	                res += String.fromCharCode(curByte);
	            } else if (curByte < 0xE0) { // Two-byte code
	                acc = curByte & 0x1F;
	                contBytes = 1; accBytes = 1;
	            } else if (curByte < 0xF0) { // Three-byte code
	                acc = curByte & 0x0F;
	                contBytes = 2; accBytes = 1;
	            } else { // Four or more are not supported for CESU-8.
	                res += this.defaultCharUnicode;
	            }
	        } else { // Continuation byte
	            if (contBytes > 0) { // We're waiting for it.
	                acc = (acc << 6) | (curByte & 0x3f);
	                contBytes--; accBytes++;
	                if (contBytes === 0) {
	                    // Check for overlong encoding, but support Modified UTF-8 (encoding NULL as C0 80)
	                    if (accBytes === 2 && acc < 0x80 && acc > 0)
	                        res += this.defaultCharUnicode;
	                    else if (accBytes === 3 && acc < 0x800)
	                        res += this.defaultCharUnicode;
	                    else
	                        // Actually add character.
	                        res += String.fromCharCode(acc);
	                }
	            } else { // Unexpected continuation byte
	                res += this.defaultCharUnicode;
	            }
	        }
	    }
	    this.acc = acc; this.contBytes = contBytes; this.accBytes = accBytes;
	    return res;
	}
	
	InternalDecoderCesu8.prototype.end = function() {
	    var res = 0;
	    if (this.contBytes > 0)
	        res += this.defaultCharUnicode;
	    return res;
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(9).Buffer))

/***/ },
/* 19 */
/***/ function(module, exports, __webpack_require__) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	var Buffer = __webpack_require__(20).Buffer;
	
	var isBufferEncoding = Buffer.isEncoding
	  || function(encoding) {
	       switch (encoding && encoding.toLowerCase()) {
	         case 'hex': case 'utf8': case 'utf-8': case 'ascii': case 'binary': case 'base64': case 'ucs2': case 'ucs-2': case 'utf16le': case 'utf-16le': case 'raw': return true;
	         default: return false;
	       }
	     }
	
	
	function assertEncoding(encoding) {
	  if (encoding && !isBufferEncoding(encoding)) {
	    throw new Error('Unknown encoding: ' + encoding);
	  }
	}
	
	// StringDecoder provides an interface for efficiently splitting a series of
	// buffers into a series of JS strings without breaking apart multi-byte
	// characters. CESU-8 is handled as part of the UTF-8 encoding.
	//
	// @TODO Handling all encodings inside a single object makes it very difficult
	// to reason about this code, so it should be split up in the future.
	// @TODO There should be a utf8-strict encoding that rejects invalid UTF-8 code
	// points as used by CESU-8.
	var StringDecoder = exports.StringDecoder = function(encoding) {
	  this.encoding = (encoding || 'utf8').toLowerCase().replace(/[-_]/, '');
	  assertEncoding(encoding);
	  switch (this.encoding) {
	    case 'utf8':
	      // CESU-8 represents each of Surrogate Pair by 3-bytes
	      this.surrogateSize = 3;
	      break;
	    case 'ucs2':
	    case 'utf16le':
	      // UTF-16 represents each of Surrogate Pair by 2-bytes
	      this.surrogateSize = 2;
	      this.detectIncompleteChar = utf16DetectIncompleteChar;
	      break;
	    case 'base64':
	      // Base-64 stores 3 bytes in 4 chars, and pads the remainder.
	      this.surrogateSize = 3;
	      this.detectIncompleteChar = base64DetectIncompleteChar;
	      break;
	    default:
	      this.write = passThroughWrite;
	      return;
	  }
	
	  // Enough space to store all bytes of a single character. UTF-8 needs 4
	  // bytes, but CESU-8 may require up to 6 (3 bytes per surrogate).
	  this.charBuffer = new Buffer(6);
	  // Number of bytes received for the current incomplete multi-byte character.
	  this.charReceived = 0;
	  // Number of bytes expected for the current incomplete multi-byte character.
	  this.charLength = 0;
	};
	
	
	// write decodes the given buffer and returns it as JS string that is
	// guaranteed to not contain any partial multi-byte characters. Any partial
	// character found at the end of the buffer is buffered up, and will be
	// returned when calling write again with the remaining bytes.
	//
	// Note: Converting a Buffer containing an orphan surrogate to a String
	// currently works, but converting a String to a Buffer (via `new Buffer`, or
	// Buffer#write) will replace incomplete surrogates with the unicode
	// replacement character. See https://codereview.chromium.org/121173009/ .
	StringDecoder.prototype.write = function(buffer) {
	  var charStr = '';
	  // if our last write ended with an incomplete multibyte character
	  while (this.charLength) {
	    // determine how many remaining bytes this buffer has to offer for this char
	    var available = (buffer.length >= this.charLength - this.charReceived) ?
	        this.charLength - this.charReceived :
	        buffer.length;
	
	    // add the new bytes to the char buffer
	    buffer.copy(this.charBuffer, this.charReceived, 0, available);
	    this.charReceived += available;
	
	    if (this.charReceived < this.charLength) {
	      // still not enough chars in this buffer? wait for more ...
	      return '';
	    }
	
	    // remove bytes belonging to the current character from the buffer
	    buffer = buffer.slice(available, buffer.length);
	
	    // get the character that was split
	    charStr = this.charBuffer.slice(0, this.charLength).toString(this.encoding);
	
	    // CESU-8: lead surrogate (D800-DBFF) is also the incomplete character
	    var charCode = charStr.charCodeAt(charStr.length - 1);
	    if (charCode >= 0xD800 && charCode <= 0xDBFF) {
	      this.charLength += this.surrogateSize;
	      charStr = '';
	      continue;
	    }
	    this.charReceived = this.charLength = 0;
	
	    // if there are no more bytes in this buffer, just emit our char
	    if (buffer.length === 0) {
	      return charStr;
	    }
	    break;
	  }
	
	  // determine and set charLength / charReceived
	  this.detectIncompleteChar(buffer);
	
	  var end = buffer.length;
	  if (this.charLength) {
	    // buffer the incomplete character bytes we got
	    buffer.copy(this.charBuffer, 0, buffer.length - this.charReceived, end);
	    end -= this.charReceived;
	  }
	
	  charStr += buffer.toString(this.encoding, 0, end);
	
	  var end = charStr.length - 1;
	  var charCode = charStr.charCodeAt(end);
	  // CESU-8: lead surrogate (D800-DBFF) is also the incomplete character
	  if (charCode >= 0xD800 && charCode <= 0xDBFF) {
	    var size = this.surrogateSize;
	    this.charLength += size;
	    this.charReceived += size;
	    this.charBuffer.copy(this.charBuffer, size, 0, size);
	    buffer.copy(this.charBuffer, 0, 0, size);
	    return charStr.substring(0, end);
	  }
	
	  // or just emit the charStr
	  return charStr;
	};
	
	// detectIncompleteChar determines if there is an incomplete UTF-8 character at
	// the end of the given buffer. If so, it sets this.charLength to the byte
	// length that character, and sets this.charReceived to the number of bytes
	// that are available for this character.
	StringDecoder.prototype.detectIncompleteChar = function(buffer) {
	  // determine how many bytes we have to check at the end of this buffer
	  var i = (buffer.length >= 3) ? 3 : buffer.length;
	
	  // Figure out if one of the last i bytes of our buffer announces an
	  // incomplete char.
	  for (; i > 0; i--) {
	    var c = buffer[buffer.length - i];
	
	    // See http://en.wikipedia.org/wiki/UTF-8#Description
	
	    // 110XXXXX
	    if (i == 1 && c >> 5 == 0x06) {
	      this.charLength = 2;
	      break;
	    }
	
	    // 1110XXXX
	    if (i <= 2 && c >> 4 == 0x0E) {
	      this.charLength = 3;
	      break;
	    }
	
	    // 11110XXX
	    if (i <= 3 && c >> 3 == 0x1E) {
	      this.charLength = 4;
	      break;
	    }
	  }
	  this.charReceived = i;
	};
	
	StringDecoder.prototype.end = function(buffer) {
	  var res = '';
	  if (buffer && buffer.length)
	    res = this.write(buffer);
	
	  if (this.charReceived) {
	    var cr = this.charReceived;
	    var buf = this.charBuffer;
	    var enc = this.encoding;
	    res += buf.slice(0, cr).toString(enc);
	  }
	
	  return res;
	};
	
	function passThroughWrite(buffer) {
	  return buffer.toString(this.encoding);
	}
	
	function utf16DetectIncompleteChar(buffer) {
	  this.charReceived = buffer.length % 2;
	  this.charLength = this.charReceived ? 2 : 0;
	}
	
	function base64DetectIncompleteChar(buffer) {
	  this.charReceived = buffer.length % 3;
	  this.charLength = this.charReceived ? 3 : 0;
	}


/***/ },
/* 20 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer, global) {/*!
	 * The buffer module from node.js, for the browser.
	 *
	 * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
	 * @license  MIT
	 */
	/* eslint-disable no-proto */
	
	'use strict'
	
	var base64 = __webpack_require__(21)
	var ieee754 = __webpack_require__(11)
	var isArray = __webpack_require__(22)
	
	exports.Buffer = Buffer
	exports.SlowBuffer = SlowBuffer
	exports.INSPECT_MAX_BYTES = 50
	Buffer.poolSize = 8192 // not used by this implementation
	
	var rootParent = {}
	
	/**
	 * If `Buffer.TYPED_ARRAY_SUPPORT`:
	 *   === true    Use Uint8Array implementation (fastest)
	 *   === false   Use Object implementation (most compatible, even IE6)
	 *
	 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
	 * Opera 11.6+, iOS 4.2+.
	 *
	 * Due to various browser bugs, sometimes the Object implementation will be used even
	 * when the browser supports typed arrays.
	 *
	 * Note:
	 *
	 *   - Firefox 4-29 lacks support for adding new properties to `Uint8Array` instances,
	 *     See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438.
	 *
	 *   - Safari 5-7 lacks support for changing the `Object.prototype.constructor` property
	 *     on objects.
	 *
	 *   - Chrome 9-10 is missing the `TypedArray.prototype.subarray` function.
	 *
	 *   - IE10 has a broken `TypedArray.prototype.subarray` function which returns arrays of
	 *     incorrect length in some situations.
	
	 * We detect these buggy browsers and set `Buffer.TYPED_ARRAY_SUPPORT` to `false` so they
	 * get the Object implementation, which is slower but behaves correctly.
	 */
	Buffer.TYPED_ARRAY_SUPPORT = global.TYPED_ARRAY_SUPPORT !== undefined
	  ? global.TYPED_ARRAY_SUPPORT
	  : typedArraySupport()
	
	function typedArraySupport () {
	  function Bar () {}
	  try {
	    var arr = new Uint8Array(1)
	    arr.foo = function () { return 42 }
	    arr.constructor = Bar
	    return arr.foo() === 42 && // typed array instances can be augmented
	        arr.constructor === Bar && // constructor can be set
	        typeof arr.subarray === 'function' && // chrome 9-10 lack `subarray`
	        arr.subarray(1, 1).byteLength === 0 // ie10 has broken `subarray`
	  } catch (e) {
	    return false
	  }
	}
	
	function kMaxLength () {
	  return Buffer.TYPED_ARRAY_SUPPORT
	    ? 0x7fffffff
	    : 0x3fffffff
	}
	
	/**
	 * Class: Buffer
	 * =============
	 *
	 * The Buffer constructor returns instances of `Uint8Array` that are augmented
	 * with function properties for all the node `Buffer` API functions. We use
	 * `Uint8Array` so that square bracket notation works as expected -- it returns
	 * a single octet.
	 *
	 * By augmenting the instances, we can avoid modifying the `Uint8Array`
	 * prototype.
	 */
	function Buffer (arg) {
	  if (!(this instanceof Buffer)) {
	    // Avoid going through an ArgumentsAdaptorTrampoline in the common case.
	    if (arguments.length > 1) return new Buffer(arg, arguments[1])
	    return new Buffer(arg)
	  }
	
	  if (!Buffer.TYPED_ARRAY_SUPPORT) {
	    this.length = 0
	    this.parent = undefined
	  }
	
	  // Common case.
	  if (typeof arg === 'number') {
	    return fromNumber(this, arg)
	  }
	
	  // Slightly less common case.
	  if (typeof arg === 'string') {
	    return fromString(this, arg, arguments.length > 1 ? arguments[1] : 'utf8')
	  }
	
	  // Unusual.
	  return fromObject(this, arg)
	}
	
	function fromNumber (that, length) {
	  that = allocate(that, length < 0 ? 0 : checked(length) | 0)
	  if (!Buffer.TYPED_ARRAY_SUPPORT) {
	    for (var i = 0; i < length; i++) {
	      that[i] = 0
	    }
	  }
	  return that
	}
	
	function fromString (that, string, encoding) {
	  if (typeof encoding !== 'string' || encoding === '') encoding = 'utf8'
	
	  // Assumption: byteLength() return value is always < kMaxLength.
	  var length = byteLength(string, encoding) | 0
	  that = allocate(that, length)
	
	  that.write(string, encoding)
	  return that
	}
	
	function fromObject (that, object) {
	  if (Buffer.isBuffer(object)) return fromBuffer(that, object)
	
	  if (isArray(object)) return fromArray(that, object)
	
	  if (object == null) {
	    throw new TypeError('must start with number, buffer, array or string')
	  }
	
	  if (typeof ArrayBuffer !== 'undefined') {
	    if (object.buffer instanceof ArrayBuffer) {
	      return fromTypedArray(that, object)
	    }
	    if (object instanceof ArrayBuffer) {
	      return fromArrayBuffer(that, object)
	    }
	  }
	
	  if (object.length) return fromArrayLike(that, object)
	
	  return fromJsonObject(that, object)
	}
	
	function fromBuffer (that, buffer) {
	  var length = checked(buffer.length) | 0
	  that = allocate(that, length)
	  buffer.copy(that, 0, 0, length)
	  return that
	}
	
	function fromArray (that, array) {
	  var length = checked(array.length) | 0
	  that = allocate(that, length)
	  for (var i = 0; i < length; i += 1) {
	    that[i] = array[i] & 255
	  }
	  return that
	}
	
	// Duplicate of fromArray() to keep fromArray() monomorphic.
	function fromTypedArray (that, array) {
	  var length = checked(array.length) | 0
	  that = allocate(that, length)
	  // Truncating the elements is probably not what people expect from typed
	  // arrays with BYTES_PER_ELEMENT > 1 but it's compatible with the behavior
	  // of the old Buffer constructor.
	  for (var i = 0; i < length; i += 1) {
	    that[i] = array[i] & 255
	  }
	  return that
	}
	
	function fromArrayBuffer (that, array) {
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    // Return an augmented `Uint8Array` instance, for best performance
	    array.byteLength
	    that = Buffer._augment(new Uint8Array(array))
	  } else {
	    // Fallback: Return an object instance of the Buffer class
	    that = fromTypedArray(that, new Uint8Array(array))
	  }
	  return that
	}
	
	function fromArrayLike (that, array) {
	  var length = checked(array.length) | 0
	  that = allocate(that, length)
	  for (var i = 0; i < length; i += 1) {
	    that[i] = array[i] & 255
	  }
	  return that
	}
	
	// Deserialize { type: 'Buffer', data: [1,2,3,...] } into a Buffer object.
	// Returns a zero-length buffer for inputs that don't conform to the spec.
	function fromJsonObject (that, object) {
	  var array
	  var length = 0
	
	  if (object.type === 'Buffer' && isArray(object.data)) {
	    array = object.data
	    length = checked(array.length) | 0
	  }
	  that = allocate(that, length)
	
	  for (var i = 0; i < length; i += 1) {
	    that[i] = array[i] & 255
	  }
	  return that
	}
	
	if (Buffer.TYPED_ARRAY_SUPPORT) {
	  Buffer.prototype.__proto__ = Uint8Array.prototype
	  Buffer.__proto__ = Uint8Array
	} else {
	  // pre-set for values that may exist in the future
	  Buffer.prototype.length = undefined
	  Buffer.prototype.parent = undefined
	}
	
	function allocate (that, length) {
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    // Return an augmented `Uint8Array` instance, for best performance
	    that = Buffer._augment(new Uint8Array(length))
	    that.__proto__ = Buffer.prototype
	  } else {
	    // Fallback: Return an object instance of the Buffer class
	    that.length = length
	    that._isBuffer = true
	  }
	
	  var fromPool = length !== 0 && length <= Buffer.poolSize >>> 1
	  if (fromPool) that.parent = rootParent
	
	  return that
	}
	
	function checked (length) {
	  // Note: cannot use `length < kMaxLength` here because that fails when
	  // length is NaN (which is otherwise coerced to zero.)
	  if (length >= kMaxLength()) {
	    throw new RangeError('Attempt to allocate Buffer larger than maximum ' +
	                         'size: 0x' + kMaxLength().toString(16) + ' bytes')
	  }
	  return length | 0
	}
	
	function SlowBuffer (subject, encoding) {
	  if (!(this instanceof SlowBuffer)) return new SlowBuffer(subject, encoding)
	
	  var buf = new Buffer(subject, encoding)
	  delete buf.parent
	  return buf
	}
	
	Buffer.isBuffer = function isBuffer (b) {
	  return !!(b != null && b._isBuffer)
	}
	
	Buffer.compare = function compare (a, b) {
	  if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) {
	    throw new TypeError('Arguments must be Buffers')
	  }
	
	  if (a === b) return 0
	
	  var x = a.length
	  var y = b.length
	
	  var i = 0
	  var len = Math.min(x, y)
	  while (i < len) {
	    if (a[i] !== b[i]) break
	
	    ++i
	  }
	
	  if (i !== len) {
	    x = a[i]
	    y = b[i]
	  }
	
	  if (x < y) return -1
	  if (y < x) return 1
	  return 0
	}
	
	Buffer.isEncoding = function isEncoding (encoding) {
	  switch (String(encoding).toLowerCase()) {
	    case 'hex':
	    case 'utf8':
	    case 'utf-8':
	    case 'ascii':
	    case 'binary':
	    case 'base64':
	    case 'raw':
	    case 'ucs2':
	    case 'ucs-2':
	    case 'utf16le':
	    case 'utf-16le':
	      return true
	    default:
	      return false
	  }
	}
	
	Buffer.concat = function concat (list, length) {
	  if (!isArray(list)) throw new TypeError('list argument must be an Array of Buffers.')
	
	  if (list.length === 0) {
	    return new Buffer(0)
	  }
	
	  var i
	  if (length === undefined) {
	    length = 0
	    for (i = 0; i < list.length; i++) {
	      length += list[i].length
	    }
	  }
	
	  var buf = new Buffer(length)
	  var pos = 0
	  for (i = 0; i < list.length; i++) {
	    var item = list[i]
	    item.copy(buf, pos)
	    pos += item.length
	  }
	  return buf
	}
	
	function byteLength (string, encoding) {
	  if (typeof string !== 'string') string = '' + string
	
	  var len = string.length
	  if (len === 0) return 0
	
	  // Use a for loop to avoid recursion
	  var loweredCase = false
	  for (;;) {
	    switch (encoding) {
	      case 'ascii':
	      case 'binary':
	      // Deprecated
	      case 'raw':
	      case 'raws':
	        return len
	      case 'utf8':
	      case 'utf-8':
	        return utf8ToBytes(string).length
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return len * 2
	      case 'hex':
	        return len >>> 1
	      case 'base64':
	        return base64ToBytes(string).length
	      default:
	        if (loweredCase) return utf8ToBytes(string).length // assume utf8
	        encoding = ('' + encoding).toLowerCase()
	        loweredCase = true
	    }
	  }
	}
	Buffer.byteLength = byteLength
	
	function slowToString (encoding, start, end) {
	  var loweredCase = false
	
	  start = start | 0
	  end = end === undefined || end === Infinity ? this.length : end | 0
	
	  if (!encoding) encoding = 'utf8'
	  if (start < 0) start = 0
	  if (end > this.length) end = this.length
	  if (end <= start) return ''
	
	  while (true) {
	    switch (encoding) {
	      case 'hex':
	        return hexSlice(this, start, end)
	
	      case 'utf8':
	      case 'utf-8':
	        return utf8Slice(this, start, end)
	
	      case 'ascii':
	        return asciiSlice(this, start, end)
	
	      case 'binary':
	        return binarySlice(this, start, end)
	
	      case 'base64':
	        return base64Slice(this, start, end)
	
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return utf16leSlice(this, start, end)
	
	      default:
	        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
	        encoding = (encoding + '').toLowerCase()
	        loweredCase = true
	    }
	  }
	}
	
	Buffer.prototype.toString = function toString () {
	  var length = this.length | 0
	  if (length === 0) return ''
	  if (arguments.length === 0) return utf8Slice(this, 0, length)
	  return slowToString.apply(this, arguments)
	}
	
	Buffer.prototype.equals = function equals (b) {
	  if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer')
	  if (this === b) return true
	  return Buffer.compare(this, b) === 0
	}
	
	Buffer.prototype.inspect = function inspect () {
	  var str = ''
	  var max = exports.INSPECT_MAX_BYTES
	  if (this.length > 0) {
	    str = this.toString('hex', 0, max).match(/.{2}/g).join(' ')
	    if (this.length > max) str += ' ... '
	  }
	  return '<Buffer ' + str + '>'
	}
	
	Buffer.prototype.compare = function compare (b) {
	  if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer')
	  if (this === b) return 0
	  return Buffer.compare(this, b)
	}
	
	Buffer.prototype.indexOf = function indexOf (val, byteOffset) {
	  if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff
	  else if (byteOffset < -0x80000000) byteOffset = -0x80000000
	  byteOffset >>= 0
	
	  if (this.length === 0) return -1
	  if (byteOffset >= this.length) return -1
	
	  // Negative offsets start from the end of the buffer
	  if (byteOffset < 0) byteOffset = Math.max(this.length + byteOffset, 0)
	
	  if (typeof val === 'string') {
	    if (val.length === 0) return -1 // special case: looking for empty string always fails
	    return String.prototype.indexOf.call(this, val, byteOffset)
	  }
	  if (Buffer.isBuffer(val)) {
	    return arrayIndexOf(this, val, byteOffset)
	  }
	  if (typeof val === 'number') {
	    if (Buffer.TYPED_ARRAY_SUPPORT && Uint8Array.prototype.indexOf === 'function') {
	      return Uint8Array.prototype.indexOf.call(this, val, byteOffset)
	    }
	    return arrayIndexOf(this, [ val ], byteOffset)
	  }
	
	  function arrayIndexOf (arr, val, byteOffset) {
	    var foundIndex = -1
	    for (var i = 0; byteOffset + i < arr.length; i++) {
	      if (arr[byteOffset + i] === val[foundIndex === -1 ? 0 : i - foundIndex]) {
	        if (foundIndex === -1) foundIndex = i
	        if (i - foundIndex + 1 === val.length) return byteOffset + foundIndex
	      } else {
	        foundIndex = -1
	      }
	    }
	    return -1
	  }
	
	  throw new TypeError('val must be string, number or Buffer')
	}
	
	// `get` is deprecated
	Buffer.prototype.get = function get (offset) {
	  console.log('.get() is deprecated. Access using array indexes instead.')
	  return this.readUInt8(offset)
	}
	
	// `set` is deprecated
	Buffer.prototype.set = function set (v, offset) {
	  console.log('.set() is deprecated. Access using array indexes instead.')
	  return this.writeUInt8(v, offset)
	}
	
	function hexWrite (buf, string, offset, length) {
	  offset = Number(offset) || 0
	  var remaining = buf.length - offset
	  if (!length) {
	    length = remaining
	  } else {
	    length = Number(length)
	    if (length > remaining) {
	      length = remaining
	    }
	  }
	
	  // must be an even number of digits
	  var strLen = string.length
	  if (strLen % 2 !== 0) throw new Error('Invalid hex string')
	
	  if (length > strLen / 2) {
	    length = strLen / 2
	  }
	  for (var i = 0; i < length; i++) {
	    var parsed = parseInt(string.substr(i * 2, 2), 16)
	    if (isNaN(parsed)) throw new Error('Invalid hex string')
	    buf[offset + i] = parsed
	  }
	  return i
	}
	
	function utf8Write (buf, string, offset, length) {
	  return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length)
	}
	
	function asciiWrite (buf, string, offset, length) {
	  return blitBuffer(asciiToBytes(string), buf, offset, length)
	}
	
	function binaryWrite (buf, string, offset, length) {
	  return asciiWrite(buf, string, offset, length)
	}
	
	function base64Write (buf, string, offset, length) {
	  return blitBuffer(base64ToBytes(string), buf, offset, length)
	}
	
	function ucs2Write (buf, string, offset, length) {
	  return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length)
	}
	
	Buffer.prototype.write = function write (string, offset, length, encoding) {
	  // Buffer#write(string)
	  if (offset === undefined) {
	    encoding = 'utf8'
	    length = this.length
	    offset = 0
	  // Buffer#write(string, encoding)
	  } else if (length === undefined && typeof offset === 'string') {
	    encoding = offset
	    length = this.length
	    offset = 0
	  // Buffer#write(string, offset[, length][, encoding])
	  } else if (isFinite(offset)) {
	    offset = offset | 0
	    if (isFinite(length)) {
	      length = length | 0
	      if (encoding === undefined) encoding = 'utf8'
	    } else {
	      encoding = length
	      length = undefined
	    }
	  // legacy write(string, encoding, offset, length) - remove in v0.13
	  } else {
	    var swap = encoding
	    encoding = offset
	    offset = length | 0
	    length = swap
	  }
	
	  var remaining = this.length - offset
	  if (length === undefined || length > remaining) length = remaining
	
	  if ((string.length > 0 && (length < 0 || offset < 0)) || offset > this.length) {
	    throw new RangeError('attempt to write outside buffer bounds')
	  }
	
	  if (!encoding) encoding = 'utf8'
	
	  var loweredCase = false
	  for (;;) {
	    switch (encoding) {
	      case 'hex':
	        return hexWrite(this, string, offset, length)
	
	      case 'utf8':
	      case 'utf-8':
	        return utf8Write(this, string, offset, length)
	
	      case 'ascii':
	        return asciiWrite(this, string, offset, length)
	
	      case 'binary':
	        return binaryWrite(this, string, offset, length)
	
	      case 'base64':
	        // Warning: maxLength not taken into account in base64Write
	        return base64Write(this, string, offset, length)
	
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return ucs2Write(this, string, offset, length)
	
	      default:
	        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
	        encoding = ('' + encoding).toLowerCase()
	        loweredCase = true
	    }
	  }
	}
	
	Buffer.prototype.toJSON = function toJSON () {
	  return {
	    type: 'Buffer',
	    data: Array.prototype.slice.call(this._arr || this, 0)
	  }
	}
	
	function base64Slice (buf, start, end) {
	  if (start === 0 && end === buf.length) {
	    return base64.fromByteArray(buf)
	  } else {
	    return base64.fromByteArray(buf.slice(start, end))
	  }
	}
	
	function utf8Slice (buf, start, end) {
	  end = Math.min(buf.length, end)
	  var res = []
	
	  var i = start
	  while (i < end) {
	    var firstByte = buf[i]
	    var codePoint = null
	    var bytesPerSequence = (firstByte > 0xEF) ? 4
	      : (firstByte > 0xDF) ? 3
	      : (firstByte > 0xBF) ? 2
	      : 1
	
	    if (i + bytesPerSequence <= end) {
	      var secondByte, thirdByte, fourthByte, tempCodePoint
	
	      switch (bytesPerSequence) {
	        case 1:
	          if (firstByte < 0x80) {
	            codePoint = firstByte
	          }
	          break
	        case 2:
	          secondByte = buf[i + 1]
	          if ((secondByte & 0xC0) === 0x80) {
	            tempCodePoint = (firstByte & 0x1F) << 0x6 | (secondByte & 0x3F)
	            if (tempCodePoint > 0x7F) {
	              codePoint = tempCodePoint
	            }
	          }
	          break
	        case 3:
	          secondByte = buf[i + 1]
	          thirdByte = buf[i + 2]
	          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
	            tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | (thirdByte & 0x3F)
	            if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) {
	              codePoint = tempCodePoint
	            }
	          }
	          break
	        case 4:
	          secondByte = buf[i + 1]
	          thirdByte = buf[i + 2]
	          fourthByte = buf[i + 3]
	          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
	            tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | (fourthByte & 0x3F)
	            if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) {
	              codePoint = tempCodePoint
	            }
	          }
	      }
	    }
	
	    if (codePoint === null) {
	      // we did not generate a valid codePoint so insert a
	      // replacement char (U+FFFD) and advance only 1 byte
	      codePoint = 0xFFFD
	      bytesPerSequence = 1
	    } else if (codePoint > 0xFFFF) {
	      // encode to utf16 (surrogate pair dance)
	      codePoint -= 0x10000
	      res.push(codePoint >>> 10 & 0x3FF | 0xD800)
	      codePoint = 0xDC00 | codePoint & 0x3FF
	    }
	
	    res.push(codePoint)
	    i += bytesPerSequence
	  }
	
	  return decodeCodePointsArray(res)
	}
	
	// Based on http://stackoverflow.com/a/22747272/680742, the browser with
	// the lowest limit is Chrome, with 0x10000 args.
	// We go 1 magnitude less, for safety
	var MAX_ARGUMENTS_LENGTH = 0x1000
	
	function decodeCodePointsArray (codePoints) {
	  var len = codePoints.length
	  if (len <= MAX_ARGUMENTS_LENGTH) {
	    return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
	  }
	
	  // Decode in chunks to avoid "call stack size exceeded".
	  var res = ''
	  var i = 0
	  while (i < len) {
	    res += String.fromCharCode.apply(
	      String,
	      codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH)
	    )
	  }
	  return res
	}
	
	function asciiSlice (buf, start, end) {
	  var ret = ''
	  end = Math.min(buf.length, end)
	
	  for (var i = start; i < end; i++) {
	    ret += String.fromCharCode(buf[i] & 0x7F)
	  }
	  return ret
	}
	
	function binarySlice (buf, start, end) {
	  var ret = ''
	  end = Math.min(buf.length, end)
	
	  for (var i = start; i < end; i++) {
	    ret += String.fromCharCode(buf[i])
	  }
	  return ret
	}
	
	function hexSlice (buf, start, end) {
	  var len = buf.length
	
	  if (!start || start < 0) start = 0
	  if (!end || end < 0 || end > len) end = len
	
	  var out = ''
	  for (var i = start; i < end; i++) {
	    out += toHex(buf[i])
	  }
	  return out
	}
	
	function utf16leSlice (buf, start, end) {
	  var bytes = buf.slice(start, end)
	  var res = ''
	  for (var i = 0; i < bytes.length; i += 2) {
	    res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256)
	  }
	  return res
	}
	
	Buffer.prototype.slice = function slice (start, end) {
	  var len = this.length
	  start = ~~start
	  end = end === undefined ? len : ~~end
	
	  if (start < 0) {
	    start += len
	    if (start < 0) start = 0
	  } else if (start > len) {
	    start = len
	  }
	
	  if (end < 0) {
	    end += len
	    if (end < 0) end = 0
	  } else if (end > len) {
	    end = len
	  }
	
	  if (end < start) end = start
	
	  var newBuf
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    newBuf = Buffer._augment(this.subarray(start, end))
	  } else {
	    var sliceLen = end - start
	    newBuf = new Buffer(sliceLen, undefined)
	    for (var i = 0; i < sliceLen; i++) {
	      newBuf[i] = this[i + start]
	    }
	  }
	
	  if (newBuf.length) newBuf.parent = this.parent || this
	
	  return newBuf
	}
	
	/*
	 * Need to make sure that buffer isn't trying to write out of bounds.
	 */
	function checkOffset (offset, ext, length) {
	  if ((offset % 1) !== 0 || offset < 0) throw new RangeError('offset is not uint')
	  if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length')
	}
	
	Buffer.prototype.readUIntLE = function readUIntLE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) checkOffset(offset, byteLength, this.length)
	
	  var val = this[offset]
	  var mul = 1
	  var i = 0
	  while (++i < byteLength && (mul *= 0x100)) {
	    val += this[offset + i] * mul
	  }
	
	  return val
	}
	
	Buffer.prototype.readUIntBE = function readUIntBE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) {
	    checkOffset(offset, byteLength, this.length)
	  }
	
	  var val = this[offset + --byteLength]
	  var mul = 1
	  while (byteLength > 0 && (mul *= 0x100)) {
	    val += this[offset + --byteLength] * mul
	  }
	
	  return val
	}
	
	Buffer.prototype.readUInt8 = function readUInt8 (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 1, this.length)
	  return this[offset]
	}
	
	Buffer.prototype.readUInt16LE = function readUInt16LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  return this[offset] | (this[offset + 1] << 8)
	}
	
	Buffer.prototype.readUInt16BE = function readUInt16BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  return (this[offset] << 8) | this[offset + 1]
	}
	
	Buffer.prototype.readUInt32LE = function readUInt32LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return ((this[offset]) |
	      (this[offset + 1] << 8) |
	      (this[offset + 2] << 16)) +
	      (this[offset + 3] * 0x1000000)
	}
	
	Buffer.prototype.readUInt32BE = function readUInt32BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return (this[offset] * 0x1000000) +
	    ((this[offset + 1] << 16) |
	    (this[offset + 2] << 8) |
	    this[offset + 3])
	}
	
	Buffer.prototype.readIntLE = function readIntLE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) checkOffset(offset, byteLength, this.length)
	
	  var val = this[offset]
	  var mul = 1
	  var i = 0
	  while (++i < byteLength && (mul *= 0x100)) {
	    val += this[offset + i] * mul
	  }
	  mul *= 0x80
	
	  if (val >= mul) val -= Math.pow(2, 8 * byteLength)
	
	  return val
	}
	
	Buffer.prototype.readIntBE = function readIntBE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) checkOffset(offset, byteLength, this.length)
	
	  var i = byteLength
	  var mul = 1
	  var val = this[offset + --i]
	  while (i > 0 && (mul *= 0x100)) {
	    val += this[offset + --i] * mul
	  }
	  mul *= 0x80
	
	  if (val >= mul) val -= Math.pow(2, 8 * byteLength)
	
	  return val
	}
	
	Buffer.prototype.readInt8 = function readInt8 (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 1, this.length)
	  if (!(this[offset] & 0x80)) return (this[offset])
	  return ((0xff - this[offset] + 1) * -1)
	}
	
	Buffer.prototype.readInt16LE = function readInt16LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  var val = this[offset] | (this[offset + 1] << 8)
	  return (val & 0x8000) ? val | 0xFFFF0000 : val
	}
	
	Buffer.prototype.readInt16BE = function readInt16BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  var val = this[offset + 1] | (this[offset] << 8)
	  return (val & 0x8000) ? val | 0xFFFF0000 : val
	}
	
	Buffer.prototype.readInt32LE = function readInt32LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return (this[offset]) |
	    (this[offset + 1] << 8) |
	    (this[offset + 2] << 16) |
	    (this[offset + 3] << 24)
	}
	
	Buffer.prototype.readInt32BE = function readInt32BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return (this[offset] << 24) |
	    (this[offset + 1] << 16) |
	    (this[offset + 2] << 8) |
	    (this[offset + 3])
	}
	
	Buffer.prototype.readFloatLE = function readFloatLE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	  return ieee754.read(this, offset, true, 23, 4)
	}
	
	Buffer.prototype.readFloatBE = function readFloatBE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	  return ieee754.read(this, offset, false, 23, 4)
	}
	
	Buffer.prototype.readDoubleLE = function readDoubleLE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 8, this.length)
	  return ieee754.read(this, offset, true, 52, 8)
	}
	
	Buffer.prototype.readDoubleBE = function readDoubleBE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 8, this.length)
	  return ieee754.read(this, offset, false, 52, 8)
	}
	
	function checkInt (buf, value, offset, ext, max, min) {
	  if (!Buffer.isBuffer(buf)) throw new TypeError('buffer must be a Buffer instance')
	  if (value > max || value < min) throw new RangeError('value is out of bounds')
	  if (offset + ext > buf.length) throw new RangeError('index out of range')
	}
	
	Buffer.prototype.writeUIntLE = function writeUIntLE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) checkInt(this, value, offset, byteLength, Math.pow(2, 8 * byteLength), 0)
	
	  var mul = 1
	  var i = 0
	  this[offset] = value & 0xFF
	  while (++i < byteLength && (mul *= 0x100)) {
	    this[offset + i] = (value / mul) & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeUIntBE = function writeUIntBE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) checkInt(this, value, offset, byteLength, Math.pow(2, 8 * byteLength), 0)
	
	  var i = byteLength - 1
	  var mul = 1
	  this[offset + i] = value & 0xFF
	  while (--i >= 0 && (mul *= 0x100)) {
	    this[offset + i] = (value / mul) & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeUInt8 = function writeUInt8 (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0)
	  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
	  this[offset] = (value & 0xff)
	  return offset + 1
	}
	
	function objectWriteUInt16 (buf, value, offset, littleEndian) {
	  if (value < 0) value = 0xffff + value + 1
	  for (var i = 0, j = Math.min(buf.length - offset, 2); i < j; i++) {
	    buf[offset + i] = (value & (0xff << (8 * (littleEndian ? i : 1 - i)))) >>>
	      (littleEndian ? i : 1 - i) * 8
	  }
	}
	
	Buffer.prototype.writeUInt16LE = function writeUInt16LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value & 0xff)
	    this[offset + 1] = (value >>> 8)
	  } else {
	    objectWriteUInt16(this, value, offset, true)
	  }
	  return offset + 2
	}
	
	Buffer.prototype.writeUInt16BE = function writeUInt16BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 8)
	    this[offset + 1] = (value & 0xff)
	  } else {
	    objectWriteUInt16(this, value, offset, false)
	  }
	  return offset + 2
	}
	
	function objectWriteUInt32 (buf, value, offset, littleEndian) {
	  if (value < 0) value = 0xffffffff + value + 1
	  for (var i = 0, j = Math.min(buf.length - offset, 4); i < j; i++) {
	    buf[offset + i] = (value >>> (littleEndian ? i : 3 - i) * 8) & 0xff
	  }
	}
	
	Buffer.prototype.writeUInt32LE = function writeUInt32LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset + 3] = (value >>> 24)
	    this[offset + 2] = (value >>> 16)
	    this[offset + 1] = (value >>> 8)
	    this[offset] = (value & 0xff)
	  } else {
	    objectWriteUInt32(this, value, offset, true)
	  }
	  return offset + 4
	}
	
	Buffer.prototype.writeUInt32BE = function writeUInt32BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 24)
	    this[offset + 1] = (value >>> 16)
	    this[offset + 2] = (value >>> 8)
	    this[offset + 3] = (value & 0xff)
	  } else {
	    objectWriteUInt32(this, value, offset, false)
	  }
	  return offset + 4
	}
	
	Buffer.prototype.writeIntLE = function writeIntLE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) {
	    var limit = Math.pow(2, 8 * byteLength - 1)
	
	    checkInt(this, value, offset, byteLength, limit - 1, -limit)
	  }
	
	  var i = 0
	  var mul = 1
	  var sub = value < 0 ? 1 : 0
	  this[offset] = value & 0xFF
	  while (++i < byteLength && (mul *= 0x100)) {
	    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeIntBE = function writeIntBE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) {
	    var limit = Math.pow(2, 8 * byteLength - 1)
	
	    checkInt(this, value, offset, byteLength, limit - 1, -limit)
	  }
	
	  var i = byteLength - 1
	  var mul = 1
	  var sub = value < 0 ? 1 : 0
	  this[offset + i] = value & 0xFF
	  while (--i >= 0 && (mul *= 0x100)) {
	    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeInt8 = function writeInt8 (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -0x80)
	  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
	  if (value < 0) value = 0xff + value + 1
	  this[offset] = (value & 0xff)
	  return offset + 1
	}
	
	Buffer.prototype.writeInt16LE = function writeInt16LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value & 0xff)
	    this[offset + 1] = (value >>> 8)
	  } else {
	    objectWriteUInt16(this, value, offset, true)
	  }
	  return offset + 2
	}
	
	Buffer.prototype.writeInt16BE = function writeInt16BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 8)
	    this[offset + 1] = (value & 0xff)
	  } else {
	    objectWriteUInt16(this, value, offset, false)
	  }
	  return offset + 2
	}
	
	Buffer.prototype.writeInt32LE = function writeInt32LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value & 0xff)
	    this[offset + 1] = (value >>> 8)
	    this[offset + 2] = (value >>> 16)
	    this[offset + 3] = (value >>> 24)
	  } else {
	    objectWriteUInt32(this, value, offset, true)
	  }
	  return offset + 4
	}
	
	Buffer.prototype.writeInt32BE = function writeInt32BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
	  if (value < 0) value = 0xffffffff + value + 1
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 24)
	    this[offset + 1] = (value >>> 16)
	    this[offset + 2] = (value >>> 8)
	    this[offset + 3] = (value & 0xff)
	  } else {
	    objectWriteUInt32(this, value, offset, false)
	  }
	  return offset + 4
	}
	
	function checkIEEE754 (buf, value, offset, ext, max, min) {
	  if (value > max || value < min) throw new RangeError('value is out of bounds')
	  if (offset + ext > buf.length) throw new RangeError('index out of range')
	  if (offset < 0) throw new RangeError('index out of range')
	}
	
	function writeFloat (buf, value, offset, littleEndian, noAssert) {
	  if (!noAssert) {
	    checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -3.4028234663852886e+38)
	  }
	  ieee754.write(buf, value, offset, littleEndian, 23, 4)
	  return offset + 4
	}
	
	Buffer.prototype.writeFloatLE = function writeFloatLE (value, offset, noAssert) {
	  return writeFloat(this, value, offset, true, noAssert)
	}
	
	Buffer.prototype.writeFloatBE = function writeFloatBE (value, offset, noAssert) {
	  return writeFloat(this, value, offset, false, noAssert)
	}
	
	function writeDouble (buf, value, offset, littleEndian, noAssert) {
	  if (!noAssert) {
	    checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -1.7976931348623157E+308)
	  }
	  ieee754.write(buf, value, offset, littleEndian, 52, 8)
	  return offset + 8
	}
	
	Buffer.prototype.writeDoubleLE = function writeDoubleLE (value, offset, noAssert) {
	  return writeDouble(this, value, offset, true, noAssert)
	}
	
	Buffer.prototype.writeDoubleBE = function writeDoubleBE (value, offset, noAssert) {
	  return writeDouble(this, value, offset, false, noAssert)
	}
	
	// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
	Buffer.prototype.copy = function copy (target, targetStart, start, end) {
	  if (!start) start = 0
	  if (!end && end !== 0) end = this.length
	  if (targetStart >= target.length) targetStart = target.length
	  if (!targetStart) targetStart = 0
	  if (end > 0 && end < start) end = start
	
	  // Copy 0 bytes; we're done
	  if (end === start) return 0
	  if (target.length === 0 || this.length === 0) return 0
	
	  // Fatal error conditions
	  if (targetStart < 0) {
	    throw new RangeError('targetStart out of bounds')
	  }
	  if (start < 0 || start >= this.length) throw new RangeError('sourceStart out of bounds')
	  if (end < 0) throw new RangeError('sourceEnd out of bounds')
	
	  // Are we oob?
	  if (end > this.length) end = this.length
	  if (target.length - targetStart < end - start) {
	    end = target.length - targetStart + start
	  }
	
	  var len = end - start
	  var i
	
	  if (this === target && start < targetStart && targetStart < end) {
	    // descending copy from end
	    for (i = len - 1; i >= 0; i--) {
	      target[i + targetStart] = this[i + start]
	    }
	  } else if (len < 1000 || !Buffer.TYPED_ARRAY_SUPPORT) {
	    // ascending copy from start
	    for (i = 0; i < len; i++) {
	      target[i + targetStart] = this[i + start]
	    }
	  } else {
	    target._set(this.subarray(start, start + len), targetStart)
	  }
	
	  return len
	}
	
	// fill(value, start=0, end=buffer.length)
	Buffer.prototype.fill = function fill (value, start, end) {
	  if (!value) value = 0
	  if (!start) start = 0
	  if (!end) end = this.length
	
	  if (end < start) throw new RangeError('end < start')
	
	  // Fill 0 bytes; we're done
	  if (end === start) return
	  if (this.length === 0) return
	
	  if (start < 0 || start >= this.length) throw new RangeError('start out of bounds')
	  if (end < 0 || end > this.length) throw new RangeError('end out of bounds')
	
	  var i
	  if (typeof value === 'number') {
	    for (i = start; i < end; i++) {
	      this[i] = value
	    }
	  } else {
	    var bytes = utf8ToBytes(value.toString())
	    var len = bytes.length
	    for (i = start; i < end; i++) {
	      this[i] = bytes[i % len]
	    }
	  }
	
	  return this
	}
	
	/**
	 * Creates a new `ArrayBuffer` with the *copied* memory of the buffer instance.
	 * Added in Node 0.12. Only available in browsers that support ArrayBuffer.
	 */
	Buffer.prototype.toArrayBuffer = function toArrayBuffer () {
	  if (typeof Uint8Array !== 'undefined') {
	    if (Buffer.TYPED_ARRAY_SUPPORT) {
	      return (new Buffer(this)).buffer
	    } else {
	      var buf = new Uint8Array(this.length)
	      for (var i = 0, len = buf.length; i < len; i += 1) {
	        buf[i] = this[i]
	      }
	      return buf.buffer
	    }
	  } else {
	    throw new TypeError('Buffer.toArrayBuffer not supported in this browser')
	  }
	}
	
	// HELPER FUNCTIONS
	// ================
	
	var BP = Buffer.prototype
	
	/**
	 * Augment a Uint8Array *instance* (not the Uint8Array class!) with Buffer methods
	 */
	Buffer._augment = function _augment (arr) {
	  arr.constructor = Buffer
	  arr._isBuffer = true
	
	  // save reference to original Uint8Array set method before overwriting
	  arr._set = arr.set
	
	  // deprecated
	  arr.get = BP.get
	  arr.set = BP.set
	
	  arr.write = BP.write
	  arr.toString = BP.toString
	  arr.toLocaleString = BP.toString
	  arr.toJSON = BP.toJSON
	  arr.equals = BP.equals
	  arr.compare = BP.compare
	  arr.indexOf = BP.indexOf
	  arr.copy = BP.copy
	  arr.slice = BP.slice
	  arr.readUIntLE = BP.readUIntLE
	  arr.readUIntBE = BP.readUIntBE
	  arr.readUInt8 = BP.readUInt8
	  arr.readUInt16LE = BP.readUInt16LE
	  arr.readUInt16BE = BP.readUInt16BE
	  arr.readUInt32LE = BP.readUInt32LE
	  arr.readUInt32BE = BP.readUInt32BE
	  arr.readIntLE = BP.readIntLE
	  arr.readIntBE = BP.readIntBE
	  arr.readInt8 = BP.readInt8
	  arr.readInt16LE = BP.readInt16LE
	  arr.readInt16BE = BP.readInt16BE
	  arr.readInt32LE = BP.readInt32LE
	  arr.readInt32BE = BP.readInt32BE
	  arr.readFloatLE = BP.readFloatLE
	  arr.readFloatBE = BP.readFloatBE
	  arr.readDoubleLE = BP.readDoubleLE
	  arr.readDoubleBE = BP.readDoubleBE
	  arr.writeUInt8 = BP.writeUInt8
	  arr.writeUIntLE = BP.writeUIntLE
	  arr.writeUIntBE = BP.writeUIntBE
	  arr.writeUInt16LE = BP.writeUInt16LE
	  arr.writeUInt16BE = BP.writeUInt16BE
	  arr.writeUInt32LE = BP.writeUInt32LE
	  arr.writeUInt32BE = BP.writeUInt32BE
	  arr.writeIntLE = BP.writeIntLE
	  arr.writeIntBE = BP.writeIntBE
	  arr.writeInt8 = BP.writeInt8
	  arr.writeInt16LE = BP.writeInt16LE
	  arr.writeInt16BE = BP.writeInt16BE
	  arr.writeInt32LE = BP.writeInt32LE
	  arr.writeInt32BE = BP.writeInt32BE
	  arr.writeFloatLE = BP.writeFloatLE
	  arr.writeFloatBE = BP.writeFloatBE
	  arr.writeDoubleLE = BP.writeDoubleLE
	  arr.writeDoubleBE = BP.writeDoubleBE
	  arr.fill = BP.fill
	  arr.inspect = BP.inspect
	  arr.toArrayBuffer = BP.toArrayBuffer
	
	  return arr
	}
	
	var INVALID_BASE64_RE = /[^+\/0-9A-Za-z-_]/g
	
	function base64clean (str) {
	  // Node strips out invalid characters like \n and \t from the string, base64-js does not
	  str = stringtrim(str).replace(INVALID_BASE64_RE, '')
	  // Node converts strings with length < 2 to ''
	  if (str.length < 2) return ''
	  // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
	  while (str.length % 4 !== 0) {
	    str = str + '='
	  }
	  return str
	}
	
	function stringtrim (str) {
	  if (str.trim) return str.trim()
	  return str.replace(/^\s+|\s+$/g, '')
	}
	
	function toHex (n) {
	  if (n < 16) return '0' + n.toString(16)
	  return n.toString(16)
	}
	
	function utf8ToBytes (string, units) {
	  units = units || Infinity
	  var codePoint
	  var length = string.length
	  var leadSurrogate = null
	  var bytes = []
	
	  for (var i = 0; i < length; i++) {
	    codePoint = string.charCodeAt(i)
	
	    // is surrogate component
	    if (codePoint > 0xD7FF && codePoint < 0xE000) {
	      // last char was a lead
	      if (!leadSurrogate) {
	        // no lead yet
	        if (codePoint > 0xDBFF) {
	          // unexpected trail
	          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	          continue
	        } else if (i + 1 === length) {
	          // unpaired lead
	          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	          continue
	        }
	
	        // valid lead
	        leadSurrogate = codePoint
	
	        continue
	      }
	
	      // 2 leads in a row
	      if (codePoint < 0xDC00) {
	        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	        leadSurrogate = codePoint
	        continue
	      }
	
	      // valid surrogate pair
	      codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000
	    } else if (leadSurrogate) {
	      // valid bmp char, but last char was a lead
	      if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	    }
	
	    leadSurrogate = null
	
	    // encode utf8
	    if (codePoint < 0x80) {
	      if ((units -= 1) < 0) break
	      bytes.push(codePoint)
	    } else if (codePoint < 0x800) {
	      if ((units -= 2) < 0) break
	      bytes.push(
	        codePoint >> 0x6 | 0xC0,
	        codePoint & 0x3F | 0x80
	      )
	    } else if (codePoint < 0x10000) {
	      if ((units -= 3) < 0) break
	      bytes.push(
	        codePoint >> 0xC | 0xE0,
	        codePoint >> 0x6 & 0x3F | 0x80,
	        codePoint & 0x3F | 0x80
	      )
	    } else if (codePoint < 0x110000) {
	      if ((units -= 4) < 0) break
	      bytes.push(
	        codePoint >> 0x12 | 0xF0,
	        codePoint >> 0xC & 0x3F | 0x80,
	        codePoint >> 0x6 & 0x3F | 0x80,
	        codePoint & 0x3F | 0x80
	      )
	    } else {
	      throw new Error('Invalid code point')
	    }
	  }
	
	  return bytes
	}
	
	function asciiToBytes (str) {
	  var byteArray = []
	  for (var i = 0; i < str.length; i++) {
	    // Node's code seems to be doing this and not & 0x7F..
	    byteArray.push(str.charCodeAt(i) & 0xFF)
	  }
	  return byteArray
	}
	
	function utf16leToBytes (str, units) {
	  var c, hi, lo
	  var byteArray = []
	  for (var i = 0; i < str.length; i++) {
	    if ((units -= 2) < 0) break
	
	    c = str.charCodeAt(i)
	    hi = c >> 8
	    lo = c % 256
	    byteArray.push(lo)
	    byteArray.push(hi)
	  }
	
	  return byteArray
	}
	
	function base64ToBytes (str) {
	  return base64.toByteArray(base64clean(str))
	}
	
	function blitBuffer (src, dst, offset, length) {
	  for (var i = 0; i < length; i++) {
	    if ((i + offset >= dst.length) || (i >= src.length)) break
	    dst[i + offset] = src[i]
	  }
	  return i
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(9).Buffer, (function() { return this; }())))

/***/ },
/* 21 */
/***/ function(module, exports, __webpack_require__) {

	var lookup = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
	
	;(function (exports) {
		'use strict';
	
	  var Arr = (typeof Uint8Array !== 'undefined')
	    ? Uint8Array
	    : Array
	
		var PLUS   = '+'.charCodeAt(0)
		var SLASH  = '/'.charCodeAt(0)
		var NUMBER = '0'.charCodeAt(0)
		var LOWER  = 'a'.charCodeAt(0)
		var UPPER  = 'A'.charCodeAt(0)
		var PLUS_URL_SAFE = '-'.charCodeAt(0)
		var SLASH_URL_SAFE = '_'.charCodeAt(0)
	
		function decode (elt) {
			var code = elt.charCodeAt(0)
			if (code === PLUS ||
			    code === PLUS_URL_SAFE)
				return 62 // '+'
			if (code === SLASH ||
			    code === SLASH_URL_SAFE)
				return 63 // '/'
			if (code < NUMBER)
				return -1 //no match
			if (code < NUMBER + 10)
				return code - NUMBER + 26 + 26
			if (code < UPPER + 26)
				return code - UPPER
			if (code < LOWER + 26)
				return code - LOWER + 26
		}
	
		function b64ToByteArray (b64) {
			var i, j, l, tmp, placeHolders, arr
	
			if (b64.length % 4 > 0) {
				throw new Error('Invalid string. Length must be a multiple of 4')
			}
	
			// the number of equal signs (place holders)
			// if there are two placeholders, than the two characters before it
			// represent one byte
			// if there is only one, then the three characters before it represent 2 bytes
			// this is just a cheap hack to not do indexOf twice
			var len = b64.length
			placeHolders = '=' === b64.charAt(len - 2) ? 2 : '=' === b64.charAt(len - 1) ? 1 : 0
	
			// base64 is 4/3 + up to two characters of the original data
			arr = new Arr(b64.length * 3 / 4 - placeHolders)
	
			// if there are placeholders, only get up to the last complete 4 chars
			l = placeHolders > 0 ? b64.length - 4 : b64.length
	
			var L = 0
	
			function push (v) {
				arr[L++] = v
			}
	
			for (i = 0, j = 0; i < l; i += 4, j += 3) {
				tmp = (decode(b64.charAt(i)) << 18) | (decode(b64.charAt(i + 1)) << 12) | (decode(b64.charAt(i + 2)) << 6) | decode(b64.charAt(i + 3))
				push((tmp & 0xFF0000) >> 16)
				push((tmp & 0xFF00) >> 8)
				push(tmp & 0xFF)
			}
	
			if (placeHolders === 2) {
				tmp = (decode(b64.charAt(i)) << 2) | (decode(b64.charAt(i + 1)) >> 4)
				push(tmp & 0xFF)
			} else if (placeHolders === 1) {
				tmp = (decode(b64.charAt(i)) << 10) | (decode(b64.charAt(i + 1)) << 4) | (decode(b64.charAt(i + 2)) >> 2)
				push((tmp >> 8) & 0xFF)
				push(tmp & 0xFF)
			}
	
			return arr
		}
	
		function uint8ToBase64 (uint8) {
			var i,
				extraBytes = uint8.length % 3, // if we have 1 byte left, pad 2 bytes
				output = "",
				temp, length
	
			function encode (num) {
				return lookup.charAt(num)
			}
	
			function tripletToBase64 (num) {
				return encode(num >> 18 & 0x3F) + encode(num >> 12 & 0x3F) + encode(num >> 6 & 0x3F) + encode(num & 0x3F)
			}
	
			// go through the array every three bytes, we'll deal with trailing stuff later
			for (i = 0, length = uint8.length - extraBytes; i < length; i += 3) {
				temp = (uint8[i] << 16) + (uint8[i + 1] << 8) + (uint8[i + 2])
				output += tripletToBase64(temp)
			}
	
			// pad the end with zeros, but make sure to not forget the extra bytes
			switch (extraBytes) {
				case 1:
					temp = uint8[uint8.length - 1]
					output += encode(temp >> 2)
					output += encode((temp << 4) & 0x3F)
					output += '=='
					break
				case 2:
					temp = (uint8[uint8.length - 2] << 8) + (uint8[uint8.length - 1])
					output += encode(temp >> 10)
					output += encode((temp >> 4) & 0x3F)
					output += encode((temp << 2) & 0x3F)
					output += '='
					break
			}
	
			return output
		}
	
		exports.toByteArray = b64ToByteArray
		exports.fromByteArray = uint8ToBase64
	}( false ? (this.base64js = {}) : exports))


/***/ },
/* 22 */
/***/ function(module, exports) {

	var toString = {}.toString;
	
	module.exports = Array.isArray || function (arr) {
	  return toString.call(arr) == '[object Array]';
	};


/***/ },
/* 23 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {"use strict"
	
	// == UTF16-BE codec. ==========================================================
	
	exports.utf16be = Utf16BECodec;
	function Utf16BECodec() {
	}
	
	Utf16BECodec.prototype.encoder = Utf16BEEncoder;
	Utf16BECodec.prototype.decoder = Utf16BEDecoder;
	Utf16BECodec.prototype.bomAware = true;
	
	
	// -- Encoding
	
	function Utf16BEEncoder() {
	}
	
	Utf16BEEncoder.prototype.write = function(str) {
	    var buf = new Buffer(str, 'ucs2');
	    for (var i = 0; i < buf.length; i += 2) {
	        var tmp = buf[i]; buf[i] = buf[i+1]; buf[i+1] = tmp;
	    }
	    return buf;
	}
	
	Utf16BEEncoder.prototype.end = function() {
	}
	
	
	// -- Decoding
	
	function Utf16BEDecoder() {
	    this.overflowByte = -1;
	}
	
	Utf16BEDecoder.prototype.write = function(buf) {
	    if (buf.length == 0)
	        return '';
	
	    var buf2 = new Buffer(buf.length + 1),
	        i = 0, j = 0;
	
	    if (this.overflowByte !== -1) {
	        buf2[0] = buf[0];
	        buf2[1] = this.overflowByte;
	        i = 1; j = 2;
	    }
	
	    for (; i < buf.length-1; i += 2, j+= 2) {
	        buf2[j] = buf[i+1];
	        buf2[j+1] = buf[i];
	    }
	
	    this.overflowByte = (i == buf.length-1) ? buf[buf.length-1] : -1;
	
	    return buf2.slice(0, j).toString('ucs2');
	}
	
	Utf16BEDecoder.prototype.end = function() {
	}
	
	
	// == UTF-16 codec =============================================================
	// Decoder chooses automatically from UTF-16LE and UTF-16BE using BOM and space-based heuristic.
	// Defaults to UTF-16LE, as it's prevalent and default in Node.
	// http://en.wikipedia.org/wiki/UTF-16 and http://encoding.spec.whatwg.org/#utf-16le
	// Decoder default can be changed: iconv.decode(buf, 'utf16', {defaultEncoding: 'utf-16be'});
	
	// Encoder uses UTF-16LE and prepends BOM (which can be overridden with addBOM: false).
	
	exports.utf16 = Utf16Codec;
	function Utf16Codec(codecOptions, iconv) {
	    this.iconv = iconv;
	}
	
	Utf16Codec.prototype.encoder = Utf16Encoder;
	Utf16Codec.prototype.decoder = Utf16Decoder;
	
	
	// -- Encoding (pass-through)
	
	function Utf16Encoder(options, codec) {
	    options = options || {};
	    if (options.addBOM === undefined)
	        options.addBOM = true;
	    this.encoder = codec.iconv.getEncoder('utf-16le', options);
	}
	
	Utf16Encoder.prototype.write = function(str) {
	    return this.encoder.write(str);
	}
	
	Utf16Encoder.prototype.end = function() {
	    return this.encoder.end();
	}
	
	
	// -- Decoding
	
	function Utf16Decoder(options, codec) {
	    this.decoder = null;
	    this.initialBytes = [];
	    this.initialBytesLen = 0;
	
	    this.options = options || {};
	    this.iconv = codec.iconv;
	}
	
	Utf16Decoder.prototype.write = function(buf) {
	    if (!this.decoder) {
	        // Codec is not chosen yet. Accumulate initial bytes.
	        this.initialBytes.push(buf);
	        this.initialBytesLen += buf.length;
	        
	        if (this.initialBytesLen < 16) // We need more bytes to use space heuristic (see below)
	            return '';
	
	        // We have enough bytes -> detect endianness.
	        var buf = Buffer.concat(this.initialBytes),
	            encoding = detectEncoding(buf, this.options.defaultEncoding);
	        this.decoder = this.iconv.getDecoder(encoding, this.options);
	        this.initialBytes.length = this.initialBytesLen = 0;
	    }
	
	    return this.decoder.write(buf);
	}
	
	Utf16Decoder.prototype.end = function() {
	    if (!this.decoder) {
	        var buf = Buffer.concat(this.initialBytes),
	            encoding = detectEncoding(buf, this.options.defaultEncoding);
	        this.decoder = this.iconv.getDecoder(encoding, this.options);
	
	        var res = this.decoder.write(buf),
	            trail = this.decoder.end();
	
	        return trail ? (res + trail) : res;
	    }
	    return this.decoder.end();
	}
	
	function detectEncoding(buf, defaultEncoding) {
	    var enc = defaultEncoding || 'utf-16le';
	
	    if (buf.length >= 2) {
	        // Check BOM.
	        if (buf[0] == 0xFE && buf[1] == 0xFF) // UTF-16BE BOM
	            enc = 'utf-16be';
	        else if (buf[0] == 0xFF && buf[1] == 0xFE) // UTF-16LE BOM
	            enc = 'utf-16le';
	        else {
	            // No BOM found. Try to deduce encoding from initial content.
	            // Most of the time, the content has ASCII chars (U+00**), but the opposite (U+**00) is uncommon.
	            // So, we count ASCII as if it was LE or BE, and decide from that.
	            var asciiCharsLE = 0, asciiCharsBE = 0, // Counts of chars in both positions
	                _len = Math.min(buf.length - (buf.length % 2), 64); // Len is always even.
	
	            for (var i = 0; i < _len; i += 2) {
	                if (buf[i] === 0 && buf[i+1] !== 0) asciiCharsBE++;
	                if (buf[i] !== 0 && buf[i+1] === 0) asciiCharsLE++;
	            }
	
	            if (asciiCharsBE > asciiCharsLE)
	                enc = 'utf-16be';
	            else if (asciiCharsBE < asciiCharsLE)
	                enc = 'utf-16le';
	        }
	    }
	
	    return enc;
	}
	
	
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(9).Buffer))

/***/ },
/* 24 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {"use strict"
	
	// UTF-7 codec, according to https://tools.ietf.org/html/rfc2152
	// See also below a UTF-7-IMAP codec, according to http://tools.ietf.org/html/rfc3501#section-5.1.3
	
	exports.utf7 = Utf7Codec;
	exports.unicode11utf7 = 'utf7'; // Alias UNICODE-1-1-UTF-7
	function Utf7Codec(codecOptions, iconv) {
	    this.iconv = iconv;
	};
	
	Utf7Codec.prototype.encoder = Utf7Encoder;
	Utf7Codec.prototype.decoder = Utf7Decoder;
	Utf7Codec.prototype.bomAware = true;
	
	
	// -- Encoding
	
	var nonDirectChars = /[^A-Za-z0-9'\(\),-\.\/:\? \n\r\t]+/g;
	
	function Utf7Encoder(options, codec) {
	    this.iconv = codec.iconv;
	}
	
	Utf7Encoder.prototype.write = function(str) {
	    // Naive implementation.
	    // Non-direct chars are encoded as "+<base64>-"; single "+" char is encoded as "+-".
	    return new Buffer(str.replace(nonDirectChars, function(chunk) {
	        return "+" + (chunk === '+' ? '' : 
	            this.iconv.encode(chunk, 'utf16-be').toString('base64').replace(/=+$/, '')) 
	            + "-";
	    }.bind(this)));
	}
	
	Utf7Encoder.prototype.end = function() {
	}
	
	
	// -- Decoding
	
	function Utf7Decoder(options, codec) {
	    this.iconv = codec.iconv;
	    this.inBase64 = false;
	    this.base64Accum = '';
	}
	
	var base64Regex = /[A-Za-z0-9\/+]/;
	var base64Chars = [];
	for (var i = 0; i < 256; i++)
	    base64Chars[i] = base64Regex.test(String.fromCharCode(i));
	
	var plusChar = '+'.charCodeAt(0), 
	    minusChar = '-'.charCodeAt(0),
	    andChar = '&'.charCodeAt(0);
	
	Utf7Decoder.prototype.write = function(buf) {
	    var res = "", lastI = 0,
	        inBase64 = this.inBase64,
	        base64Accum = this.base64Accum;
	
	    // The decoder is more involved as we must handle chunks in stream.
	
	    for (var i = 0; i < buf.length; i++) {
	        if (!inBase64) { // We're in direct mode.
	            // Write direct chars until '+'
	            if (buf[i] == plusChar) {
	                res += this.iconv.decode(buf.slice(lastI, i), "ascii"); // Write direct chars.
	                lastI = i+1;
	                inBase64 = true;
	            }
	        } else { // We decode base64.
	            if (!base64Chars[buf[i]]) { // Base64 ended.
	                if (i == lastI && buf[i] == minusChar) {// "+-" -> "+"
	                    res += "+";
	                } else {
	                    var b64str = base64Accum + buf.slice(lastI, i).toString();
	                    res += this.iconv.decode(new Buffer(b64str, 'base64'), "utf16-be");
	                }
	
	                if (buf[i] != minusChar) // Minus is absorbed after base64.
	                    i--;
	
	                lastI = i+1;
	                inBase64 = false;
	                base64Accum = '';
	            }
	        }
	    }
	
	    if (!inBase64) {
	        res += this.iconv.decode(buf.slice(lastI), "ascii"); // Write direct chars.
	    } else {
	        var b64str = base64Accum + buf.slice(lastI).toString();
	
	        var canBeDecoded = b64str.length - (b64str.length % 8); // Minimal chunk: 2 quads -> 2x3 bytes -> 3 chars.
	        base64Accum = b64str.slice(canBeDecoded); // The rest will be decoded in future.
	        b64str = b64str.slice(0, canBeDecoded);
	
	        res += this.iconv.decode(new Buffer(b64str, 'base64'), "utf16-be");
	    }
	
	    this.inBase64 = inBase64;
	    this.base64Accum = base64Accum;
	
	    return res;
	}
	
	Utf7Decoder.prototype.end = function() {
	    var res = "";
	    if (this.inBase64 && this.base64Accum.length > 0)
	        res = this.iconv.decode(new Buffer(this.base64Accum, 'base64'), "utf16-be");
	
	    this.inBase64 = false;
	    this.base64Accum = '';
	    return res;
	}
	
	
	// UTF-7-IMAP codec.
	// RFC3501 Sec. 5.1.3 Modified UTF-7 (http://tools.ietf.org/html/rfc3501#section-5.1.3)
	// Differences:
	//  * Base64 part is started by "&" instead of "+"
	//  * Direct characters are 0x20-0x7E, except "&" (0x26)
	//  * In Base64, "," is used instead of "/"
	//  * Base64 must not be used to represent direct characters.
	//  * No implicit shift back from Base64 (should always end with '-')
	//  * String must end in non-shifted position.
	//  * "-&" while in base64 is not allowed.
	
	
	exports.utf7imap = Utf7IMAPCodec;
	function Utf7IMAPCodec(codecOptions, iconv) {
	    this.iconv = iconv;
	};
	
	Utf7IMAPCodec.prototype.encoder = Utf7IMAPEncoder;
	Utf7IMAPCodec.prototype.decoder = Utf7IMAPDecoder;
	Utf7IMAPCodec.prototype.bomAware = true;
	
	
	// -- Encoding
	
	function Utf7IMAPEncoder(options, codec) {
	    this.iconv = codec.iconv;
	    this.inBase64 = false;
	    this.base64Accum = new Buffer(6);
	    this.base64AccumIdx = 0;
	}
	
	Utf7IMAPEncoder.prototype.write = function(str) {
	    var inBase64 = this.inBase64,
	        base64Accum = this.base64Accum,
	        base64AccumIdx = this.base64AccumIdx,
	        buf = new Buffer(str.length*5 + 10), bufIdx = 0;
	
	    for (var i = 0; i < str.length; i++) {
	        var uChar = str.charCodeAt(i);
	        if (0x20 <= uChar && uChar <= 0x7E) { // Direct character or '&'.
	            if (inBase64) {
	                if (base64AccumIdx > 0) {
	                    bufIdx += buf.write(base64Accum.slice(0, base64AccumIdx).toString('base64').replace(/\//g, ',').replace(/=+$/, ''), bufIdx);
	                    base64AccumIdx = 0;
	                }
	
	                buf[bufIdx++] = minusChar; // Write '-', then go to direct mode.
	                inBase64 = false;
	            }
	
	            if (!inBase64) {
	                buf[bufIdx++] = uChar; // Write direct character
	
	                if (uChar === andChar)  // Ampersand -> '&-'
	                    buf[bufIdx++] = minusChar;
	            }
	
	        } else { // Non-direct character
	            if (!inBase64) {
	                buf[bufIdx++] = andChar; // Write '&', then go to base64 mode.
	                inBase64 = true;
	            }
	            if (inBase64) {
	                base64Accum[base64AccumIdx++] = uChar >> 8;
	                base64Accum[base64AccumIdx++] = uChar & 0xFF;
	
	                if (base64AccumIdx == base64Accum.length) {
	                    bufIdx += buf.write(base64Accum.toString('base64').replace(/\//g, ','), bufIdx);
	                    base64AccumIdx = 0;
	                }
	            }
	        }
	    }
	
	    this.inBase64 = inBase64;
	    this.base64AccumIdx = base64AccumIdx;
	
	    return buf.slice(0, bufIdx);
	}
	
	Utf7IMAPEncoder.prototype.end = function() {
	    var buf = new Buffer(10), bufIdx = 0;
	    if (this.inBase64) {
	        if (this.base64AccumIdx > 0) {
	            bufIdx += buf.write(this.base64Accum.slice(0, this.base64AccumIdx).toString('base64').replace(/\//g, ',').replace(/=+$/, ''), bufIdx);
	            this.base64AccumIdx = 0;
	        }
	
	        buf[bufIdx++] = minusChar; // Write '-', then go to direct mode.
	        this.inBase64 = false;
	    }
	
	    return buf.slice(0, bufIdx);
	}
	
	
	// -- Decoding
	
	function Utf7IMAPDecoder(options, codec) {
	    this.iconv = codec.iconv;
	    this.inBase64 = false;
	    this.base64Accum = '';
	}
	
	var base64IMAPChars = base64Chars.slice();
	base64IMAPChars[','.charCodeAt(0)] = true;
	
	Utf7IMAPDecoder.prototype.write = function(buf) {
	    var res = "", lastI = 0,
	        inBase64 = this.inBase64,
	        base64Accum = this.base64Accum;
	
	    // The decoder is more involved as we must handle chunks in stream.
	    // It is forgiving, closer to standard UTF-7 (for example, '-' is optional at the end).
	
	    for (var i = 0; i < buf.length; i++) {
	        if (!inBase64) { // We're in direct mode.
	            // Write direct chars until '&'
	            if (buf[i] == andChar) {
	                res += this.iconv.decode(buf.slice(lastI, i), "ascii"); // Write direct chars.
	                lastI = i+1;
	                inBase64 = true;
	            }
	        } else { // We decode base64.
	            if (!base64IMAPChars[buf[i]]) { // Base64 ended.
	                if (i == lastI && buf[i] == minusChar) { // "&-" -> "&"
	                    res += "&";
	                } else {
	                    var b64str = base64Accum + buf.slice(lastI, i).toString().replace(/,/g, '/');
	                    res += this.iconv.decode(new Buffer(b64str, 'base64'), "utf16-be");
	                }
	
	                if (buf[i] != minusChar) // Minus may be absorbed after base64.
	                    i--;
	
	                lastI = i+1;
	                inBase64 = false;
	                base64Accum = '';
	            }
	        }
	    }
	
	    if (!inBase64) {
	        res += this.iconv.decode(buf.slice(lastI), "ascii"); // Write direct chars.
	    } else {
	        var b64str = base64Accum + buf.slice(lastI).toString().replace(/,/g, '/');
	
	        var canBeDecoded = b64str.length - (b64str.length % 8); // Minimal chunk: 2 quads -> 2x3 bytes -> 3 chars.
	        base64Accum = b64str.slice(canBeDecoded); // The rest will be decoded in future.
	        b64str = b64str.slice(0, canBeDecoded);
	
	        res += this.iconv.decode(new Buffer(b64str, 'base64'), "utf16-be");
	    }
	
	    this.inBase64 = inBase64;
	    this.base64Accum = base64Accum;
	
	    return res;
	}
	
	Utf7IMAPDecoder.prototype.end = function() {
	    var res = "";
	    if (this.inBase64 && this.base64Accum.length > 0)
	        res = this.iconv.decode(new Buffer(this.base64Accum, 'base64'), "utf16-be");
	
	    this.inBase64 = false;
	    this.base64Accum = '';
	    return res;
	}
	
	
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(9).Buffer))

/***/ },
/* 25 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {"use strict"
	
	// Single-byte codec. Needs a 'chars' string parameter that contains 256 or 128 chars that
	// correspond to encoded bytes (if 128 - then lower half is ASCII). 
	
	exports._sbcs = SBCSCodec;
	function SBCSCodec(codecOptions, iconv) {
	    if (!codecOptions)
	        throw new Error("SBCS codec is called without the data.")
	    
	    // Prepare char buffer for decoding.
	    if (!codecOptions.chars || (codecOptions.chars.length !== 128 && codecOptions.chars.length !== 256))
	        throw new Error("Encoding '"+codecOptions.type+"' has incorrect 'chars' (must be of len 128 or 256)");
	    
	    if (codecOptions.chars.length === 128) {
	        var asciiString = "";
	        for (var i = 0; i < 128; i++)
	            asciiString += String.fromCharCode(i);
	        codecOptions.chars = asciiString + codecOptions.chars;
	    }
	
	    this.decodeBuf = new Buffer(codecOptions.chars, 'ucs2');
	    
	    // Encoding buffer.
	    var encodeBuf = new Buffer(65536);
	    encodeBuf.fill(iconv.defaultCharSingleByte.charCodeAt(0));
	
	    for (var i = 0; i < codecOptions.chars.length; i++)
	        encodeBuf[codecOptions.chars.charCodeAt(i)] = i;
	
	    this.encodeBuf = encodeBuf;
	}
	
	SBCSCodec.prototype.encoder = SBCSEncoder;
	SBCSCodec.prototype.decoder = SBCSDecoder;
	
	
	function SBCSEncoder(options, codec) {
	    this.encodeBuf = codec.encodeBuf;
	}
	
	SBCSEncoder.prototype.write = function(str) {
	    var buf = new Buffer(str.length);
	    for (var i = 0; i < str.length; i++)
	        buf[i] = this.encodeBuf[str.charCodeAt(i)];
	    
	    return buf;
	}
	
	SBCSEncoder.prototype.end = function() {
	}
	
	
	function SBCSDecoder(options, codec) {
	    this.decodeBuf = codec.decodeBuf;
	}
	
	SBCSDecoder.prototype.write = function(buf) {
	    // Strings are immutable in JS -> we use ucs2 buffer to speed up computations.
	    var decodeBuf = this.decodeBuf;
	    var newBuf = new Buffer(buf.length*2);
	    var idx1 = 0, idx2 = 0;
	    for (var i = 0; i < buf.length; i++) {
	        idx1 = buf[i]*2; idx2 = i*2;
	        newBuf[idx2] = decodeBuf[idx1];
	        newBuf[idx2+1] = decodeBuf[idx1+1];
	    }
	    return newBuf.toString('ucs2');
	}
	
	SBCSDecoder.prototype.end = function() {
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(9).Buffer))

/***/ },
/* 26 */
/***/ function(module, exports) {

	"use strict"
	
	// Manually added data to be used by sbcs codec in addition to generated one.
	
	module.exports = {
	    // Not supported by iconv, not sure why.
	    "10029": "maccenteuro",
	    "maccenteuro": {
	        "type": "_sbcs",
	        "chars": "ÄĀāÉĄÖÜáąČäčĆćéŹźĎíďĒēĖóėôöõúĚěü†°Ę£§•¶ß®©™ę¨≠ģĮįĪ≤≥īĶ∂∑łĻļĽľĹĺŅņŃ¬√ńŇ∆«»… ňŐÕőŌ–—“”‘’÷◊ōŔŕŘ‹›řŖŗŠ‚„šŚśÁŤťÍŽžŪÓÔūŮÚůŰűŲųÝýķŻŁżĢˇ"
	    },
	
	    "808": "cp808",
	    "ibm808": "cp808",
	    "cp808": {
	        "type": "_sbcs",
	        "chars": "АБВГДЕЖЗИЙКЛМНОПРСТУФХЦЧШЩЪЫЬЭЮЯабвгдежзийклмноп░▒▓│┤╡╢╖╕╣║╗╝╜╛┐└┴┬├─┼╞╟╚╔╩╦╠═╬╧╨╤╥╙╘╒╓╫╪┘┌█▄▌▐▀рстуфхцчшщъыьэюяЁёЄєЇїЎў°∙·√№€■ "
	    },
	
	    // Aliases of generated encodings.
	    "ascii8bit": "ascii",
	    "usascii": "ascii",
	    "ansix34": "ascii",
	    "ansix341968": "ascii",
	    "ansix341986": "ascii",
	    "csascii": "ascii",
	    "cp367": "ascii",
	    "ibm367": "ascii",
	    "isoir6": "ascii",
	    "iso646us": "ascii",
	    "iso646irv": "ascii",
	    "us": "ascii",
	
	    "latin1": "iso88591",
	    "latin2": "iso88592",
	    "latin3": "iso88593",
	    "latin4": "iso88594",
	    "latin5": "iso88599",
	    "latin6": "iso885910",
	    "latin7": "iso885913",
	    "latin8": "iso885914",
	    "latin9": "iso885915",
	    "latin10": "iso885916",
	
	    "csisolatin1": "iso88591",
	    "csisolatin2": "iso88592",
	    "csisolatin3": "iso88593",
	    "csisolatin4": "iso88594",
	    "csisolatincyrillic": "iso88595",
	    "csisolatinarabic": "iso88596",
	    "csisolatingreek" : "iso88597",
	    "csisolatinhebrew": "iso88598",
	    "csisolatin5": "iso88599",
	    "csisolatin6": "iso885910",
	
	    "l1": "iso88591",
	    "l2": "iso88592",
	    "l3": "iso88593",
	    "l4": "iso88594",
	    "l5": "iso88599",
	    "l6": "iso885910",
	    "l7": "iso885913",
	    "l8": "iso885914",
	    "l9": "iso885915",
	    "l10": "iso885916",
	
	    "isoir14": "iso646jp",
	    "isoir57": "iso646cn",
	    "isoir100": "iso88591",
	    "isoir101": "iso88592",
	    "isoir109": "iso88593",
	    "isoir110": "iso88594",
	    "isoir144": "iso88595",
	    "isoir127": "iso88596",
	    "isoir126": "iso88597",
	    "isoir138": "iso88598",
	    "isoir148": "iso88599",
	    "isoir157": "iso885910",
	    "isoir166": "tis620",
	    "isoir179": "iso885913",
	    "isoir199": "iso885914",
	    "isoir203": "iso885915",
	    "isoir226": "iso885916",
	
	    "cp819": "iso88591",
	    "ibm819": "iso88591",
	
	    "cyrillic": "iso88595",
	
	    "arabic": "iso88596",
	    "arabic8": "iso88596",
	    "ecma114": "iso88596",
	    "asmo708": "iso88596",
	
	    "greek" : "iso88597",
	    "greek8" : "iso88597",
	    "ecma118" : "iso88597",
	    "elot928" : "iso88597",
	
	    "hebrew": "iso88598",
	    "hebrew8": "iso88598",
	
	    "turkish": "iso88599",
	    "turkish8": "iso88599",
	
	    "thai": "iso885911",
	    "thai8": "iso885911",
	
	    "celtic": "iso885914",
	    "celtic8": "iso885914",
	    "isoceltic": "iso885914",
	
	    "tis6200": "tis620",
	    "tis62025291": "tis620",
	    "tis62025330": "tis620",
	
	    "10000": "macroman",
	    "10006": "macgreek",
	    "10007": "maccyrillic",
	    "10079": "maciceland",
	    "10081": "macturkish",
	
	    "cspc8codepage437": "cp437",
	    "cspc775baltic": "cp775",
	    "cspc850multilingual": "cp850",
	    "cspcp852": "cp852",
	    "cspc862latinhebrew": "cp862",
	    "cpgr": "cp869",
	
	    "msee": "cp1250",
	    "mscyrl": "cp1251",
	    "msansi": "cp1252",
	    "msgreek": "cp1253",
	    "msturk": "cp1254",
	    "mshebr": "cp1255",
	    "msarab": "cp1256",
	    "winbaltrim": "cp1257",
	
	    "cp20866": "koi8r",
	    "20866": "koi8r",
	    "ibm878": "koi8r",
	    "cskoi8r": "koi8r",
	
	    "cp21866": "koi8u",
	    "21866": "koi8u",
	    "ibm1168": "koi8u",
	
	    "strk10482002": "rk1048",
	
	    "tcvn5712": "tcvn",
	    "tcvn57121": "tcvn",
	
	    "gb198880": "iso646cn",
	    "cn": "iso646cn",
	
	    "csiso14jisc6220ro": "iso646jp",
	    "jisc62201969ro": "iso646jp",
	    "jp": "iso646jp",
	
	    "cshproman8": "hproman8",
	    "r8": "hproman8",
	    "roman8": "hproman8",
	    "xroman8": "hproman8",
	    "ibm1051": "hproman8",
	
	    "mac": "macintosh",
	    "csmacintosh": "macintosh",
	};
	


/***/ },
/* 27 */
/***/ function(module, exports) {

	"use strict"
	
	// Generated data for sbcs codec. Don't edit manually. Regenerate using generation/gen-sbcs.js script.
	module.exports = {
	  "437": "cp437",
	  "737": "cp737",
	  "775": "cp775",
	  "850": "cp850",
	  "852": "cp852",
	  "855": "cp855",
	  "856": "cp856",
	  "857": "cp857",
	  "858": "cp858",
	  "860": "cp860",
	  "861": "cp861",
	  "862": "cp862",
	  "863": "cp863",
	  "864": "cp864",
	  "865": "cp865",
	  "866": "cp866",
	  "869": "cp869",
	  "874": "windows874",
	  "922": "cp922",
	  "1046": "cp1046",
	  "1124": "cp1124",
	  "1125": "cp1125",
	  "1129": "cp1129",
	  "1133": "cp1133",
	  "1161": "cp1161",
	  "1162": "cp1162",
	  "1163": "cp1163",
	  "1250": "windows1250",
	  "1251": "windows1251",
	  "1252": "windows1252",
	  "1253": "windows1253",
	  "1254": "windows1254",
	  "1255": "windows1255",
	  "1256": "windows1256",
	  "1257": "windows1257",
	  "1258": "windows1258",
	  "28591": "iso88591",
	  "28592": "iso88592",
	  "28593": "iso88593",
	  "28594": "iso88594",
	  "28595": "iso88595",
	  "28596": "iso88596",
	  "28597": "iso88597",
	  "28598": "iso88598",
	  "28599": "iso88599",
	  "28600": "iso885910",
	  "28601": "iso885911",
	  "28603": "iso885913",
	  "28604": "iso885914",
	  "28605": "iso885915",
	  "28606": "iso885916",
	  "windows874": {
	    "type": "_sbcs",
	    "chars": "€����…�����������‘’“”•–—�������� กขฃคฅฆงจฉชซฌญฎฏฐฑฒณดตถทธนบปผฝพฟภมยรฤลฦวศษสหฬอฮฯะัาำิีึืฺุู����฿เแโใไๅๆ็่้๊๋์ํ๎๏๐๑๒๓๔๕๖๗๘๙๚๛����"
	  },
	  "win874": "windows874",
	  "cp874": "windows874",
	  "windows1250": {
	    "type": "_sbcs",
	    "chars": "€�‚�„…†‡�‰Š‹ŚŤŽŹ�‘’“”•–—�™š›śťžź ˇ˘Ł¤Ą¦§¨©Ş«¬­®Ż°±˛ł´µ¶·¸ąş»Ľ˝ľżŔÁÂĂÄĹĆÇČÉĘËĚÍÎĎĐŃŇÓÔŐÖ×ŘŮÚŰÜÝŢßŕáâăäĺćçčéęëěíîďđńňóôőö÷řůúűüýţ˙"
	  },
	  "win1250": "windows1250",
	  "cp1250": "windows1250",
	  "windows1251": {
	    "type": "_sbcs",
	    "chars": "ЂЃ‚ѓ„…†‡€‰Љ‹ЊЌЋЏђ‘’“”•–—�™љ›њќћџ ЎўЈ¤Ґ¦§Ё©Є«¬­®Ї°±Ііґµ¶·ё№є»јЅѕїАБВГДЕЖЗИЙКЛМНОПРСТУФХЦЧШЩЪЫЬЭЮЯабвгдежзийклмнопрстуфхцчшщъыьэюя"
	  },
	  "win1251": "windows1251",
	  "cp1251": "windows1251",
	  "windows1252": {
	    "type": "_sbcs",
	    "chars": "€�‚ƒ„…†‡ˆ‰Š‹Œ�Ž��‘’“”•–—˜™š›œ�žŸ ¡¢£¤¥¦§¨©ª«¬­®¯°±²³´µ¶·¸¹º»¼½¾¿ÀÁÂÃÄÅÆÇÈÉÊËÌÍÎÏÐÑÒÓÔÕÖ×ØÙÚÛÜÝÞßàáâãäåæçèéêëìíîïðñòóôõö÷øùúûüýþÿ"
	  },
	  "win1252": "windows1252",
	  "cp1252": "windows1252",
	  "windows1253": {
	    "type": "_sbcs",
	    "chars": "€�‚ƒ„…†‡�‰�‹�����‘’“”•–—�™�›���� ΅Ά£¤¥¦§¨©�«¬­®―°±²³΄µ¶·ΈΉΊ»Ό½ΎΏΐΑΒΓΔΕΖΗΘΙΚΛΜΝΞΟΠΡ�ΣΤΥΦΧΨΩΪΫάέήίΰαβγδεζηθικλμνξοπρςστυφχψωϊϋόύώ�"
	  },
	  "win1253": "windows1253",
	  "cp1253": "windows1253",
	  "windows1254": {
	    "type": "_sbcs",
	    "chars": "€�‚ƒ„…†‡ˆ‰Š‹Œ����‘’“”•–—˜™š›œ��Ÿ ¡¢£¤¥¦§¨©ª«¬­®¯°±²³´µ¶·¸¹º»¼½¾¿ÀÁÂÃÄÅÆÇÈÉÊËÌÍÎÏĞÑÒÓÔÕÖ×ØÙÚÛÜİŞßàáâãäåæçèéêëìíîïğñòóôõö÷øùúûüışÿ"
	  },
	  "win1254": "windows1254",
	  "cp1254": "windows1254",
	  "windows1255": {
	    "type": "_sbcs",
	    "chars": "€�‚ƒ„…†‡ˆ‰�‹�����‘’“”•–—˜™�›���� ¡¢£₪¥¦§¨©×«¬­®¯°±²³´µ¶·¸¹÷»¼½¾¿ְֱֲֳִֵֶַָֹ�ֻּֽ־ֿ׀ׁׂ׃װױײ׳״�������אבגדהוזחטיךכלםמןנסעףפץצקרשת��‎‏�"
	  },
	  "win1255": "windows1255",
	  "cp1255": "windows1255",
	  "windows1256": {
	    "type": "_sbcs",
	    "chars": "€پ‚ƒ„…†‡ˆ‰ٹ‹Œچژڈگ‘’“”•–—ک™ڑ›œ‌‍ں ،¢£¤¥¦§¨©ھ«¬­®¯°±²³´µ¶·¸¹؛»¼½¾؟ہءآأؤإئابةتثجحخدذرزسشصض×طظعغـفقكàلâمنهوçèéêëىيîïًٌٍَôُِ÷ّùْûü‎‏ے"
	  },
	  "win1256": "windows1256",
	  "cp1256": "windows1256",
	  "windows1257": {
	    "type": "_sbcs",
	    "chars": "€�‚�„…†‡�‰�‹�¨ˇ¸�‘’“”•–—�™�›�¯˛� �¢£¤�¦§Ø©Ŗ«¬­®Æ°±²³´µ¶·ø¹ŗ»¼½¾æĄĮĀĆÄÅĘĒČÉŹĖĢĶĪĻŠŃŅÓŌÕÖ×ŲŁŚŪÜŻŽßąįāćäåęēčéźėģķīļšńņóōõö÷ųłśūüżž˙"
	  },
	  "win1257": "windows1257",
	  "cp1257": "windows1257",
	  "windows1258": {
	    "type": "_sbcs",
	    "chars": "€�‚ƒ„…†‡ˆ‰�‹Œ����‘’“”•–—˜™�›œ��Ÿ ¡¢£¤¥¦§¨©ª«¬­®¯°±²³´µ¶·¸¹º»¼½¾¿ÀÁÂĂÄÅÆÇÈÉÊË̀ÍÎÏĐÑ̉ÓÔƠÖ×ØÙÚÛÜỮßàáâăäåæçèéêë́íîïđṇ̃óôơö÷øùúûüư₫ÿ"
	  },
	  "win1258": "windows1258",
	  "cp1258": "windows1258",
	  "iso88591": {
	    "type": "_sbcs",
	    "chars": " ¡¢£¤¥¦§¨©ª«¬­®¯°±²³´µ¶·¸¹º»¼½¾¿ÀÁÂÃÄÅÆÇÈÉÊËÌÍÎÏÐÑÒÓÔÕÖ×ØÙÚÛÜÝÞßàáâãäåæçèéêëìíîïðñòóôõö÷øùúûüýþÿ"
	  },
	  "cp28591": "iso88591",
	  "iso88592": {
	    "type": "_sbcs",
	    "chars": " Ą˘Ł¤ĽŚ§¨ŠŞŤŹ­ŽŻ°ą˛ł´ľśˇ¸šşťź˝žżŔÁÂĂÄĹĆÇČÉĘËĚÍÎĎĐŃŇÓÔŐÖ×ŘŮÚŰÜÝŢßŕáâăäĺćçčéęëěíîďđńňóôőö÷řůúűüýţ˙"
	  },
	  "cp28592": "iso88592",
	  "iso88593": {
	    "type": "_sbcs",
	    "chars": " Ħ˘£¤�Ĥ§¨İŞĞĴ­�Ż°ħ²³´µĥ·¸ışğĵ½�żÀÁÂ�ÄĊĈÇÈÉÊËÌÍÎÏ�ÑÒÓÔĠÖ×ĜÙÚÛÜŬŜßàáâ�äċĉçèéêëìíîï�ñòóôġö÷ĝùúûüŭŝ˙"
	  },
	  "cp28593": "iso88593",
	  "iso88594": {
	    "type": "_sbcs",
	    "chars": " ĄĸŖ¤ĨĻ§¨ŠĒĢŦ­Ž¯°ą˛ŗ´ĩļˇ¸šēģŧŊžŋĀÁÂÃÄÅÆĮČÉĘËĖÍÎĪĐŅŌĶÔÕÖ×ØŲÚÛÜŨŪßāáâãäåæįčéęëėíîīđņōķôõö÷øųúûüũū˙"
	  },
	  "cp28594": "iso88594",
	  "iso88595": {
	    "type": "_sbcs",
	    "chars": " ЁЂЃЄЅІЇЈЉЊЋЌ­ЎЏАБВГДЕЖЗИЙКЛМНОПРСТУФХЦЧШЩЪЫЬЭЮЯабвгдежзийклмнопрстуфхцчшщъыьэюя№ёђѓєѕіїјљњћќ§ўџ"
	  },
	  "cp28595": "iso88595",
	  "iso88596": {
	    "type": "_sbcs",
	    "chars": " ���¤�������،­�������������؛���؟�ءآأؤإئابةتثجحخدذرزسشصضطظعغ�����ـفقكلمنهوىيًٌٍَُِّْ�������������"
	  },
	  "cp28596": "iso88596",
	  "iso88597": {
	    "type": "_sbcs",
	    "chars": " ‘’£€₯¦§¨©ͺ«¬­�―°±²³΄΅Ά·ΈΉΊ»Ό½ΎΏΐΑΒΓΔΕΖΗΘΙΚΛΜΝΞΟΠΡ�ΣΤΥΦΧΨΩΪΫάέήίΰαβγδεζηθικλμνξοπρςστυφχψωϊϋόύώ�"
	  },
	  "cp28597": "iso88597",
	  "iso88598": {
	    "type": "_sbcs",
	    "chars": " �¢£¤¥¦§¨©×«¬­®¯°±²³´µ¶·¸¹÷»¼½¾��������������������������������‗אבגדהוזחטיךכלםמןנסעףפץצקרשת��‎‏�"
	  },
	  "cp28598": "iso88598",
	  "iso88599": {
	    "type": "_sbcs",
	    "chars": " ¡¢£¤¥¦§¨©ª«¬­®¯°±²³´µ¶·¸¹º»¼½¾¿ÀÁÂÃÄÅÆÇÈÉÊËÌÍÎÏĞÑÒÓÔÕÖ×ØÙÚÛÜİŞßàáâãäåæçèéêëìíîïğñòóôõö÷øùúûüışÿ"
	  },
	  "cp28599": "iso88599",
	  "iso885910": {
	    "type": "_sbcs",
	    "chars": " ĄĒĢĪĨĶ§ĻĐŠŦŽ­ŪŊ°ąēģīĩķ·ļđšŧž―ūŋĀÁÂÃÄÅÆĮČÉĘËĖÍÎÏÐŅŌÓÔÕÖŨØŲÚÛÜÝÞßāáâãäåæįčéęëėíîïðņōóôõöũøųúûüýþĸ"
	  },
	  "cp28600": "iso885910",
	  "iso885911": {
	    "type": "_sbcs",
	    "chars": " กขฃคฅฆงจฉชซฌญฎฏฐฑฒณดตถทธนบปผฝพฟภมยรฤลฦวศษสหฬอฮฯะัาำิีึืฺุู����฿เแโใไๅๆ็่้๊๋์ํ๎๏๐๑๒๓๔๕๖๗๘๙๚๛����"
	  },
	  "cp28601": "iso885911",
	  "iso885913": {
	    "type": "_sbcs",
	    "chars": " ”¢£¤„¦§Ø©Ŗ«¬­®Æ°±²³“µ¶·ø¹ŗ»¼½¾æĄĮĀĆÄÅĘĒČÉŹĖĢĶĪĻŠŃŅÓŌÕÖ×ŲŁŚŪÜŻŽßąįāćäåęēčéźėģķīļšńņóōõö÷ųłśūüżž’"
	  },
	  "cp28603": "iso885913",
	  "iso885914": {
	    "type": "_sbcs",
	    "chars": " Ḃḃ£ĊċḊ§Ẁ©ẂḋỲ­®ŸḞḟĠġṀṁ¶ṖẁṗẃṠỳẄẅṡÀÁÂÃÄÅÆÇÈÉÊËÌÍÎÏŴÑÒÓÔÕÖṪØÙÚÛÜÝŶßàáâãäåæçèéêëìíîïŵñòóôõöṫøùúûüýŷÿ"
	  },
	  "cp28604": "iso885914",
	  "iso885915": {
	    "type": "_sbcs",
	    "chars": " ¡¢£€¥Š§š©ª«¬­®¯°±²³Žµ¶·ž¹º»ŒœŸ¿ÀÁÂÃÄÅÆÇÈÉÊËÌÍÎÏÐÑÒÓÔÕÖ×ØÙÚÛÜÝÞßàáâãäåæçèéêëìíîïðñòóôõö÷øùúûüýþÿ"
	  },
	  "cp28605": "iso885915",
	  "iso885916": {
	    "type": "_sbcs",
	    "chars": " ĄąŁ€„Š§š©Ș«Ź­źŻ°±ČłŽ”¶·žčș»ŒœŸżÀÁÂĂÄĆÆÇÈÉÊËÌÍÎÏĐŃÒÓÔŐÖŚŰÙÚÛÜĘȚßàáâăäćæçèéêëìíîïđńòóôőöśűùúûüęțÿ"
	  },
	  "cp28606": "iso885916",
	  "cp437": {
	    "type": "_sbcs",
	    "chars": "ÇüéâäàåçêëèïîìÄÅÉæÆôöòûùÿÖÜ¢£¥₧ƒáíóúñÑªº¿⌐¬½¼¡«»░▒▓│┤╡╢╖╕╣║╗╝╜╛┐└┴┬├─┼╞╟╚╔╩╦╠═╬╧╨╤╥╙╘╒╓╫╪┘┌█▄▌▐▀αßΓπΣσµτΦΘΩδ∞φε∩≡±≥≤⌠⌡÷≈°∙·√ⁿ²■ "
	  },
	  "ibm437": "cp437",
	  "csibm437": "cp437",
	  "cp737": {
	    "type": "_sbcs",
	    "chars": "ΑΒΓΔΕΖΗΘΙΚΛΜΝΞΟΠΡΣΤΥΦΧΨΩαβγδεζηθικλμνξοπρσςτυφχψ░▒▓│┤╡╢╖╕╣║╗╝╜╛┐└┴┬├─┼╞╟╚╔╩╦╠═╬╧╨╤╥╙╘╒╓╫╪┘┌█▄▌▐▀ωάέήϊίόύϋώΆΈΉΊΌΎΏ±≥≤ΪΫ÷≈°∙·√ⁿ²■ "
	  },
	  "ibm737": "cp737",
	  "csibm737": "cp737",
	  "cp775": {
	    "type": "_sbcs",
	    "chars": "ĆüéāäģåćłēŖŗīŹÄÅÉæÆōöĢ¢ŚśÖÜø£Ø×¤ĀĪóŻżź”¦©®¬½¼Ł«»░▒▓│┤ĄČĘĖ╣║╗╝ĮŠ┐└┴┬├─┼ŲŪ╚╔╩╦╠═╬Žąčęėįšųūž┘┌█▄▌▐▀ÓßŌŃõÕµńĶķĻļņĒŅ’­±“¾¶§÷„°∙·¹³²■ "
	  },
	  "ibm775": "cp775",
	  "csibm775": "cp775",
	  "cp850": {
	    "type": "_sbcs",
	    "chars": "ÇüéâäàåçêëèïîìÄÅÉæÆôöòûùÿÖÜø£Ø×ƒáíóúñÑªº¿®¬½¼¡«»░▒▓│┤ÁÂÀ©╣║╗╝¢¥┐└┴┬├─┼ãÃ╚╔╩╦╠═╬¤ðÐÊËÈıÍÎÏ┘┌█▄¦Ì▀ÓßÔÒõÕµþÞÚÛÙýÝ¯´­±‗¾¶§÷¸°¨·¹³²■ "
	  },
	  "ibm850": "cp850",
	  "csibm850": "cp850",
	  "cp852": {
	    "type": "_sbcs",
	    "chars": "ÇüéâäůćçłëŐőîŹÄĆÉĹĺôöĽľŚśÖÜŤťŁ×čáíóúĄąŽžĘę¬źČş«»░▒▓│┤ÁÂĚŞ╣║╗╝Żż┐└┴┬├─┼Ăă╚╔╩╦╠═╬¤đĐĎËďŇÍÎě┘┌█▄ŢŮ▀ÓßÔŃńňŠšŔÚŕŰýÝţ´­˝˛ˇ˘§÷¸°¨˙űŘř■ "
	  },
	  "ibm852": "cp852",
	  "csibm852": "cp852",
	  "cp855": {
	    "type": "_sbcs",
	    "chars": "ђЂѓЃёЁєЄѕЅіІїЇјЈљЉњЊћЋќЌўЎџЏюЮъЪаАбБцЦдДеЕфФгГ«»░▒▓│┤хХиИ╣║╗╝йЙ┐└┴┬├─┼кК╚╔╩╦╠═╬¤лЛмМнНоОп┘┌█▄Пя▀ЯрРсСтТуУжЖвВьЬ№­ыЫзЗшШэЭщЩчЧ§■ "
	  },
	  "ibm855": "cp855",
	  "csibm855": "cp855",
	  "cp856": {
	    "type": "_sbcs",
	    "chars": "אבגדהוזחטיךכלםמןנסעףפץצקרשת�£�×����������®¬½¼�«»░▒▓│┤���©╣║╗╝¢¥┐└┴┬├─┼��╚╔╩╦╠═╬¤���������┘┌█▄¦�▀������µ�������¯´­±‗¾¶§÷¸°¨·¹³²■ "
	  },
	  "ibm856": "cp856",
	  "csibm856": "cp856",
	  "cp857": {
	    "type": "_sbcs",
	    "chars": "ÇüéâäàåçêëèïîıÄÅÉæÆôöòûùİÖÜø£ØŞşáíóúñÑĞğ¿®¬½¼¡«»░▒▓│┤ÁÂÀ©╣║╗╝¢¥┐└┴┬├─┼ãÃ╚╔╩╦╠═╬¤ºªÊËÈ�ÍÎÏ┘┌█▄¦Ì▀ÓßÔÒõÕµ�×ÚÛÙìÿ¯´­±�¾¶§÷¸°¨·¹³²■ "
	  },
	  "ibm857": "cp857",
	  "csibm857": "cp857",
	  "cp858": {
	    "type": "_sbcs",
	    "chars": "ÇüéâäàåçêëèïîìÄÅÉæÆôöòûùÿÖÜø£Ø×ƒáíóúñÑªº¿®¬½¼¡«»░▒▓│┤ÁÂÀ©╣║╗╝¢¥┐└┴┬├─┼ãÃ╚╔╩╦╠═╬¤ðÐÊËÈ€ÍÎÏ┘┌█▄¦Ì▀ÓßÔÒõÕµþÞÚÛÙýÝ¯´­±‗¾¶§÷¸°¨·¹³²■ "
	  },
	  "ibm858": "cp858",
	  "csibm858": "cp858",
	  "cp860": {
	    "type": "_sbcs",
	    "chars": "ÇüéâãàÁçêÊèÍÔìÃÂÉÀÈôõòÚùÌÕÜ¢£Ù₧ÓáíóúñÑªº¿Ò¬½¼¡«»░▒▓│┤╡╢╖╕╣║╗╝╜╛┐└┴┬├─┼╞╟╚╔╩╦╠═╬╧╨╤╥╙╘╒╓╫╪┘┌█▄▌▐▀αßΓπΣσµτΦΘΩδ∞φε∩≡±≥≤⌠⌡÷≈°∙·√ⁿ²■ "
	  },
	  "ibm860": "cp860",
	  "csibm860": "cp860",
	  "cp861": {
	    "type": "_sbcs",
	    "chars": "ÇüéâäàåçêëèÐðÞÄÅÉæÆôöþûÝýÖÜø£Ø₧ƒáíóúÁÍÓÚ¿⌐¬½¼¡«»░▒▓│┤╡╢╖╕╣║╗╝╜╛┐└┴┬├─┼╞╟╚╔╩╦╠═╬╧╨╤╥╙╘╒╓╫╪┘┌█▄▌▐▀αßΓπΣσµτΦΘΩδ∞φε∩≡±≥≤⌠⌡÷≈°∙·√ⁿ²■ "
	  },
	  "ibm861": "cp861",
	  "csibm861": "cp861",
	  "cp862": {
	    "type": "_sbcs",
	    "chars": "אבגדהוזחטיךכלםמןנסעףפץצקרשת¢£¥₧ƒáíóúñÑªº¿⌐¬½¼¡«»░▒▓│┤╡╢╖╕╣║╗╝╜╛┐└┴┬├─┼╞╟╚╔╩╦╠═╬╧╨╤╥╙╘╒╓╫╪┘┌█▄▌▐▀αßΓπΣσµτΦΘΩδ∞φε∩≡±≥≤⌠⌡÷≈°∙·√ⁿ²■ "
	  },
	  "ibm862": "cp862",
	  "csibm862": "cp862",
	  "cp863": {
	    "type": "_sbcs",
	    "chars": "ÇüéâÂà¶çêëèïî‗À§ÉÈÊôËÏûù¤ÔÜ¢£ÙÛƒ¦´óú¨¸³¯Î⌐¬½¼¾«»░▒▓│┤╡╢╖╕╣║╗╝╜╛┐└┴┬├─┼╞╟╚╔╩╦╠═╬╧╨╤╥╙╘╒╓╫╪┘┌█▄▌▐▀αßΓπΣσµτΦΘΩδ∞φε∩≡±≥≤⌠⌡÷≈°∙·√ⁿ²■ "
	  },
	  "ibm863": "cp863",
	  "csibm863": "cp863",
	  "cp864": {
	    "type": "_sbcs",
	    "chars": "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$٪&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~°·∙√▒─│┼┤┬├┴┐┌└┘β∞φ±½¼≈«»ﻷﻸ��ﻻﻼ� ­ﺂ£¤ﺄ��ﺎﺏﺕﺙ،ﺝﺡﺥ٠١٢٣٤٥٦٧٨٩ﻑ؛ﺱﺵﺹ؟¢ﺀﺁﺃﺅﻊﺋﺍﺑﺓﺗﺛﺟﺣﺧﺩﺫﺭﺯﺳﺷﺻﺿﻁﻅﻋﻏ¦¬÷×ﻉـﻓﻗﻛﻟﻣﻧﻫﻭﻯﻳﺽﻌﻎﻍﻡﹽّﻥﻩﻬﻰﻲﻐﻕﻵﻶﻝﻙﻱ■�"
	  },
	  "ibm864": "cp864",
	  "csibm864": "cp864",
	  "cp865": {
	    "type": "_sbcs",
	    "chars": "ÇüéâäàåçêëèïîìÄÅÉæÆôöòûùÿÖÜø£Ø₧ƒáíóúñÑªº¿⌐¬½¼¡«¤░▒▓│┤╡╢╖╕╣║╗╝╜╛┐└┴┬├─┼╞╟╚╔╩╦╠═╬╧╨╤╥╙╘╒╓╫╪┘┌█▄▌▐▀αßΓπΣσµτΦΘΩδ∞φε∩≡±≥≤⌠⌡÷≈°∙·√ⁿ²■ "
	  },
	  "ibm865": "cp865",
	  "csibm865": "cp865",
	  "cp866": {
	    "type": "_sbcs",
	    "chars": "АБВГДЕЖЗИЙКЛМНОПРСТУФХЦЧШЩЪЫЬЭЮЯабвгдежзийклмноп░▒▓│┤╡╢╖╕╣║╗╝╜╛┐└┴┬├─┼╞╟╚╔╩╦╠═╬╧╨╤╥╙╘╒╓╫╪┘┌█▄▌▐▀рстуфхцчшщъыьэюяЁёЄєЇїЎў°∙·√№¤■ "
	  },
	  "ibm866": "cp866",
	  "csibm866": "cp866",
	  "cp869": {
	    "type": "_sbcs",
	    "chars": "������Ά�·¬¦‘’Έ―ΉΊΪΌ��ΎΫ©Ώ²³ά£έήίϊΐόύΑΒΓΔΕΖΗ½ΘΙ«»░▒▓│┤ΚΛΜΝ╣║╗╝ΞΟ┐└┴┬├─┼ΠΡ╚╔╩╦╠═╬ΣΤΥΦΧΨΩαβγ┘┌█▄δε▀ζηθικλμνξοπρσςτ΄­±υφχ§ψ΅°¨ωϋΰώ■ "
	  },
	  "ibm869": "cp869",
	  "csibm869": "cp869",
	  "cp922": {
	    "type": "_sbcs",
	    "chars": " ¡¢£¤¥¦§¨©ª«¬­®‾°±²³´µ¶·¸¹º»¼½¾¿ÀÁÂÃÄÅÆÇÈÉÊËÌÍÎÏŠÑÒÓÔÕÖ×ØÙÚÛÜÝŽßàáâãäåæçèéêëìíîïšñòóôõö÷øùúûüýžÿ"
	  },
	  "ibm922": "cp922",
	  "csibm922": "cp922",
	  "cp1046": {
	    "type": "_sbcs",
	    "chars": "ﺈ×÷ﹱ■│─┐┌└┘ﹹﹻﹽﹿﹷﺊﻰﻳﻲﻎﻏﻐﻶﻸﻺﻼ ¤ﺋﺑﺗﺛﺟﺣ،­ﺧﺳ٠١٢٣٤٥٦٧٨٩ﺷ؛ﺻﺿﻊ؟ﻋءآأؤإئابةتثجحخدذرزسشصضطﻇعغﻌﺂﺄﺎﻓـفقكلمنهوىيًٌٍَُِّْﻗﻛﻟﻵﻷﻹﻻﻣﻧﻬﻩ�"
	  },
	  "ibm1046": "cp1046",
	  "csibm1046": "cp1046",
	  "cp1124": {
	    "type": "_sbcs",
	    "chars": " ЁЂҐЄЅІЇЈЉЊЋЌ­ЎЏАБВГДЕЖЗИЙКЛМНОПРСТУФХЦЧШЩЪЫЬЭЮЯабвгдежзийклмнопрстуфхцчшщъыьэюя№ёђґєѕіїјљњћќ§ўџ"
	  },
	  "ibm1124": "cp1124",
	  "csibm1124": "cp1124",
	  "cp1125": {
	    "type": "_sbcs",
	    "chars": "АБВГДЕЖЗИЙКЛМНОПРСТУФХЦЧШЩЪЫЬЭЮЯабвгдежзийклмноп░▒▓│┤╡╢╖╕╣║╗╝╜╛┐└┴┬├─┼╞╟╚╔╩╦╠═╬╧╨╤╥╙╘╒╓╫╪┘┌█▄▌▐▀рстуфхцчшщъыьэюяЁёҐґЄєІіЇї·√№¤■ "
	  },
	  "ibm1125": "cp1125",
	  "csibm1125": "cp1125",
	  "cp1129": {
	    "type": "_sbcs",
	    "chars": " ¡¢£¤¥¦§œ©ª«¬­®¯°±²³Ÿµ¶·Œ¹º»¼½¾¿ÀÁÂĂÄÅÆÇÈÉÊË̀ÍÎÏĐÑ̉ÓÔƠÖ×ØÙÚÛÜỮßàáâăäåæçèéêë́íîïđṇ̃óôơö÷øùúûüư₫ÿ"
	  },
	  "ibm1129": "cp1129",
	  "csibm1129": "cp1129",
	  "cp1133": {
	    "type": "_sbcs",
	    "chars": " ກຂຄງຈສຊຍດຕຖທນບປຜຝພຟມຢຣລວຫອຮ���ຯະາຳິີຶືຸູຼັົຽ���ເແໂໃໄ່້໊໋໌ໍໆ�ໜໝ₭����������������໐໑໒໓໔໕໖໗໘໙��¢¬¦�"
	  },
	  "ibm1133": "cp1133",
	  "csibm1133": "cp1133",
	  "cp1161": {
	    "type": "_sbcs",
	    "chars": "��������������������������������่กขฃคฅฆงจฉชซฌญฎฏฐฑฒณดตถทธนบปผฝพฟภมยรฤลฦวศษสหฬอฮฯะัาำิีึืฺุู้๊๋€฿เแโใไๅๆ็่้๊๋์ํ๎๏๐๑๒๓๔๕๖๗๘๙๚๛¢¬¦ "
	  },
	  "ibm1161": "cp1161",
	  "csibm1161": "cp1161",
	  "cp1162": {
	    "type": "_sbcs",
	    "chars": "€…‘’“”•–— กขฃคฅฆงจฉชซฌญฎฏฐฑฒณดตถทธนบปผฝพฟภมยรฤลฦวศษสหฬอฮฯะัาำิีึืฺุู����฿เแโใไๅๆ็่้๊๋์ํ๎๏๐๑๒๓๔๕๖๗๘๙๚๛����"
	  },
	  "ibm1162": "cp1162",
	  "csibm1162": "cp1162",
	  "cp1163": {
	    "type": "_sbcs",
	    "chars": " ¡¢£€¥¦§œ©ª«¬­®¯°±²³Ÿµ¶·Œ¹º»¼½¾¿ÀÁÂĂÄÅÆÇÈÉÊË̀ÍÎÏĐÑ̉ÓÔƠÖ×ØÙÚÛÜỮßàáâăäåæçèéêë́íîïđṇ̃óôơö÷øùúûüư₫ÿ"
	  },
	  "ibm1163": "cp1163",
	  "csibm1163": "cp1163",
	  "maccroatian": {
	    "type": "_sbcs",
	    "chars": "ÄÅÇÉÑÖÜáàâäãåçéèêëíìîïñóòôöõúùûü†°¢£§•¶ß®Š™´¨≠ŽØ∞±≤≥∆µ∂∑∏š∫ªºΩžø¿¡¬√ƒ≈Ć«Č… ÀÃÕŒœĐ—“”‘’÷◊�©⁄¤‹›Æ»–·‚„‰ÂćÁčÈÍÎÏÌÓÔđÒÚÛÙıˆ˜¯πË˚¸Êæˇ"
	  },
	  "maccyrillic": {
	    "type": "_sbcs",
	    "chars": "АБВГДЕЖЗИЙКЛМНОПРСТУФХЦЧШЩЪЫЬЭЮЯ†°¢£§•¶І®©™Ђђ≠Ѓѓ∞±≤≥іµ∂ЈЄєЇїЉљЊњјЅ¬√ƒ≈∆«»… ЋћЌќѕ–—“”‘’÷„ЎўЏџ№Ёёяабвгдежзийклмнопрстуфхцчшщъыьэю¤"
	  },
	  "macgreek": {
	    "type": "_sbcs",
	    "chars": "Ä¹²É³ÖÜ΅àâä΄¨çéèêë£™îï•½‰ôö¦­ùûü†ΓΔΘΛΞΠß®©ΣΪ§≠°·Α±≤≥¥ΒΕΖΗΙΚΜΦΫΨΩάΝ¬ΟΡ≈Τ«»… ΥΧΆΈœ–―“”‘’÷ΉΊΌΎέήίόΏύαβψδεφγηιξκλμνοπώρστθωςχυζϊϋΐΰ�"
	  },
	  "maciceland": {
	    "type": "_sbcs",
	    "chars": "ÄÅÇÉÑÖÜáàâäãåçéèêëíìîïñóòôöõúùûüÝ°¢£§•¶ß®©™´¨≠ÆØ∞±≤≥¥µ∂∑∏π∫ªºΩæø¿¡¬√ƒ≈∆«»… ÀÃÕŒœ–—“”‘’÷◊ÿŸ⁄¤ÐðÞþý·‚„‰ÂÊÁËÈÍÎÏÌÓÔ�ÒÚÛÙıˆ˜¯˘˙˚¸˝˛ˇ"
	  },
	  "macroman": {
	    "type": "_sbcs",
	    "chars": "ÄÅÇÉÑÖÜáàâäãåçéèêëíìîïñóòôöõúùûü†°¢£§•¶ß®©™´¨≠ÆØ∞±≤≥¥µ∂∑∏π∫ªºΩæø¿¡¬√ƒ≈∆«»… ÀÃÕŒœ–—“”‘’÷◊ÿŸ⁄¤‹›ﬁﬂ‡·‚„‰ÂÊÁËÈÍÎÏÌÓÔ�ÒÚÛÙıˆ˜¯˘˙˚¸˝˛ˇ"
	  },
	  "macromania": {
	    "type": "_sbcs",
	    "chars": "ÄÅÇÉÑÖÜáàâäãåçéèêëíìîïñóòôöõúùûü†°¢£§•¶ß®©™´¨≠ĂŞ∞±≤≥¥µ∂∑∏π∫ªºΩăş¿¡¬√ƒ≈∆«»… ÀÃÕŒœ–—“”‘’÷◊ÿŸ⁄¤‹›Ţţ‡·‚„‰ÂÊÁËÈÍÎÏÌÓÔ�ÒÚÛÙıˆ˜¯˘˙˚¸˝˛ˇ"
	  },
	  "macthai": {
	    "type": "_sbcs",
	    "chars": "«»…“”�•‘’� กขฃคฅฆงจฉชซฌญฎฏฐฑฒณดตถทธนบปผฝพฟภมยรฤลฦวศษสหฬอฮฯะัาำิีึืฺุู﻿​–—฿เแโใไๅๆ็่้๊๋์ํ™๏๐๑๒๓๔๕๖๗๘๙®©����"
	  },
	  "macturkish": {
	    "type": "_sbcs",
	    "chars": "ÄÅÇÉÑÖÜáàâäãåçéèêëíìîïñóòôöõúùûü†°¢£§•¶ß®©™´¨≠ÆØ∞±≤≥¥µ∂∑∏π∫ªºΩæø¿¡¬√ƒ≈∆«»… ÀÃÕŒœ–—“”‘’÷◊ÿŸĞğİıŞş‡·‚„‰ÂÊÁËÈÍÎÏÌÓÔ�ÒÚÛÙ�ˆ˜¯˘˙˚¸˝˛ˇ"
	  },
	  "macukraine": {
	    "type": "_sbcs",
	    "chars": "АБВГДЕЖЗИЙКЛМНОПРСТУФХЦЧШЩЪЫЬЭЮЯ†°Ґ£§•¶І®©™Ђђ≠Ѓѓ∞±≤≥іµґЈЄєЇїЉљЊњјЅ¬√ƒ≈∆«»… ЋћЌќѕ–—“”‘’÷„ЎўЏџ№Ёёяабвгдежзийклмнопрстуфхцчшщъыьэю¤"
	  },
	  "koi8r": {
	    "type": "_sbcs",
	    "chars": "─│┌┐└┘├┤┬┴┼▀▄█▌▐░▒▓⌠■∙√≈≤≥ ⌡°²·÷═║╒ё╓╔╕╖╗╘╙╚╛╜╝╞╟╠╡Ё╢╣╤╥╦╧╨╩╪╫╬©юабцдефгхийклмнопярстужвьызшэщчъЮАБЦДЕФГХИЙКЛМНОПЯРСТУЖВЬЫЗШЭЩЧЪ"
	  },
	  "koi8u": {
	    "type": "_sbcs",
	    "chars": "─│┌┐└┘├┤┬┴┼▀▄█▌▐░▒▓⌠■∙√≈≤≥ ⌡°²·÷═║╒ёє╔ії╗╘╙╚╛ґ╝╞╟╠╡ЁЄ╣ІЇ╦╧╨╩╪Ґ╬©юабцдефгхийклмнопярстужвьызшэщчъЮАБЦДЕФГХИЙКЛМНОПЯРСТУЖВЬЫЗШЭЩЧЪ"
	  },
	  "koi8ru": {
	    "type": "_sbcs",
	    "chars": "─│┌┐└┘├┤┬┴┼▀▄█▌▐░▒▓⌠■∙√≈≤≥ ⌡°²·÷═║╒ёє╔ії╗╘╙╚╛ґў╞╟╠╡ЁЄ╣ІЇ╦╧╨╩╪ҐЎ©юабцдефгхийклмнопярстужвьызшэщчъЮАБЦДЕФГХИЙКЛМНОПЯРСТУЖВЬЫЗШЭЩЧЪ"
	  },
	  "koi8t": {
	    "type": "_sbcs",
	    "chars": "қғ‚Ғ„…†‡�‰ҳ‹ҲҷҶ�Қ‘’“”•–—�™�›�����ӯӮё¤ӣ¦§���«¬­®�°±²Ё�Ӣ¶·�№�»���©юабцдефгхийклмнопярстужвьызшэщчъЮАБЦДЕФГХИЙКЛМНОПЯРСТУЖВЬЫЗШЭЩЧЪ"
	  },
	  "armscii8": {
	    "type": "_sbcs",
	    "chars": " �և։)(»«—.՝,-֊…՜՛՞ԱաԲբԳգԴդԵեԶզԷէԸըԹթԺժԻիԼլԽխԾծԿկՀհՁձՂղՃճՄմՅյՆնՇշՈոՉչՊպՋջՌռՍսՎվՏտՐրՑցՒւՓփՔքՕօՖֆ՚�"
	  },
	  "rk1048": {
	    "type": "_sbcs",
	    "chars": "ЂЃ‚ѓ„…†‡€‰Љ‹ЊҚҺЏђ‘’“”•–—�™љ›њқһџ ҰұӘ¤Ө¦§Ё©Ғ«¬­®Ү°±Ііөµ¶·ё№ғ»әҢңүАБВГДЕЖЗИЙКЛМНОПРСТУФХЦЧШЩЪЫЬЭЮЯабвгдежзийклмнопрстуфхцчшщъыьэюя"
	  },
	  "tcvn": {
	    "type": "_sbcs",
	    "chars": "\u0000ÚỤ\u0003ỪỬỮ\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010ỨỰỲỶỸÝỴ\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~ÀẢÃÁẠẶẬÈẺẼÉẸỆÌỈĨÍỊÒỎÕÓỌỘỜỞỠỚỢÙỦŨ ĂÂÊÔƠƯĐăâêôơưđẶ̀̀̉̃́àảãáạẲằẳẵắẴẮẦẨẪẤỀặầẩẫấậèỂẻẽéẹềểễếệìỉỄẾỒĩíịòỔỏõóọồổỗốộờởỡớợùỖủũúụừửữứựỳỷỹýỵỐ"
	  },
	  "georgianacademy": {
	    "type": "_sbcs",
	    "chars": "‚ƒ„…†‡ˆ‰Š‹Œ‘’“”•–—˜™š›œŸ ¡¢£¤¥¦§¨©ª«¬­®¯°±²³´µ¶·¸¹º»¼½¾¿აბგდევზთიკლმნოპჟრსტუფქღყშჩცძწჭხჯჰჱჲჳჴჵჶçèéêëìíîïðñòóôõö÷øùúûüýþÿ"
	  },
	  "georgianps": {
	    "type": "_sbcs",
	    "chars": "‚ƒ„…†‡ˆ‰Š‹Œ‘’“”•–—˜™š›œŸ ¡¢£¤¥¦§¨©ª«¬­®¯°±²³´µ¶·¸¹º»¼½¾¿აბგდევზჱთიკლმნჲოპჟრსტჳუფქღყშჩცძწჭხჴჯჰჵæçèéêëìíîïðñòóôõö÷øùúûüýþÿ"
	  },
	  "pt154": {
	    "type": "_sbcs",
	    "chars": "ҖҒӮғ„…ҶҮҲүҠӢҢҚҺҸҗ‘’“”•–—ҳҷҡӣңқһҹ ЎўЈӨҘҰ§Ё©Ә«¬ӯ®Ҝ°ұІіҙө¶·ё№ә»јҪҫҝАБВГДЕЖЗИЙКЛМНОПРСТУФХЦЧШЩЪЫЬЭЮЯабвгдежзийклмнопрстуфхцчшщъыьэюя"
	  },
	  "viscii": {
	    "type": "_sbcs",
	    "chars": "\u0000\u0001Ẳ\u0003\u0004ẴẪ\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013Ỷ\u0015\u0016\u0017\u0018Ỹ\u001a\u001b\u001c\u001dỴ\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~ẠẮẰẶẤẦẨẬẼẸẾỀỂỄỆỐỒỔỖỘỢỚỜỞỊỎỌỈỦŨỤỲÕắằặấầẩậẽẹếềểễệốồổỗỠƠộờởịỰỨỪỬơớƯÀÁÂÃẢĂẳẵÈÉÊẺÌÍĨỳĐứÒÓÔạỷừửÙÚỹỵÝỡưàáâãảăữẫèéêẻìíĩỉđựòóôõỏọụùúũủýợỮ"
	  },
	  "iso646cn": {
	    "type": "_sbcs",
	    "chars": "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#¥%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}‾��������������������������������������������������������������������������������������������������������������������������������"
	  },
	  "iso646jp": {
	    "type": "_sbcs",
	    "chars": "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[¥]^_`abcdefghijklmnopqrstuvwxyz{|}‾��������������������������������������������������������������������������������������������������������������������������������"
	  },
	  "hproman8": {
	    "type": "_sbcs",
	    "chars": " ÀÂÈÊËÎÏ´ˋˆ¨˜ÙÛ₤¯Ýý°ÇçÑñ¡¿¤£¥§ƒ¢âêôûáéóúàèòùäëöüÅîØÆåíøæÄìÖÜÉïßÔÁÃãÐðÍÌÓÒÕõŠšÚŸÿÞþ·µ¶¾—¼½ªº«■»±�"
	  },
	  "macintosh": {
	    "type": "_sbcs",
	    "chars": "ÄÅÇÉÑÖÜáàâäãåçéèêëíìîïñóòôöõúùûü†°¢£§•¶ß®©™´¨≠ÆØ∞±≤≥¥µ∂∑∏π∫ªºΩæø¿¡¬√ƒ≈∆«»… ÀÃÕŒœ–—“”‘’÷◊ÿŸ⁄¤‹›ﬁﬂ‡·‚„‰ÂÊÁËÈÍÎÏÌÓÔ�ÒÚÛÙıˆ˜¯˘˙˚¸˝˛ˇ"
	  },
	  "ascii": {
	    "type": "_sbcs",
	    "chars": "��������������������������������������������������������������������������������������������������������������������������������"
	  },
	  "tis620": {
	    "type": "_sbcs",
	    "chars": "���������������������������������กขฃคฅฆงจฉชซฌญฎฏฐฑฒณดตถทธนบปผฝพฟภมยรฤลฦวศษสหฬอฮฯะัาำิีึืฺุู����฿เแโใไๅๆ็่้๊๋์ํ๎๏๐๑๒๓๔๕๖๗๘๙๚๛����"
	  }
	}

/***/ },
/* 28 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {"use strict"
	
	// Multibyte codec. In this scheme, a character is represented by 1 or more bytes.
	// Our codec supports UTF-16 surrogates, extensions for GB18030 and unicode sequences.
	// To save memory and loading time, we read table files only when requested.
	
	exports._dbcs = DBCSCodec;
	
	var UNASSIGNED = -1,
	    GB18030_CODE = -2,
	    SEQ_START  = -10,
	    NODE_START = -1000,
	    UNASSIGNED_NODE = new Array(0x100),
	    DEF_CHAR = -1;
	
	for (var i = 0; i < 0x100; i++)
	    UNASSIGNED_NODE[i] = UNASSIGNED;
	
	
	// Class DBCSCodec reads and initializes mapping tables.
	function DBCSCodec(codecOptions, iconv) {
	    this.encodingName = codecOptions.encodingName;
	    if (!codecOptions)
	        throw new Error("DBCS codec is called without the data.")
	    if (!codecOptions.table)
	        throw new Error("Encoding '" + this.encodingName + "' has no data.");
	
	    // Load tables.
	    var mappingTable = codecOptions.table();
	
	
	    // Decode tables: MBCS -> Unicode.
	
	    // decodeTables is a trie, encoded as an array of arrays of integers. Internal arrays are trie nodes and all have len = 256.
	    // Trie root is decodeTables[0].
	    // Values: >=  0 -> unicode character code. can be > 0xFFFF
	    //         == UNASSIGNED -> unknown/unassigned sequence.
	    //         == GB18030_CODE -> this is the end of a GB18030 4-byte sequence.
	    //         <= NODE_START -> index of the next node in our trie to process next byte.
	    //         <= SEQ_START  -> index of the start of a character code sequence, in decodeTableSeq.
	    this.decodeTables = [];
	    this.decodeTables[0] = UNASSIGNED_NODE.slice(0); // Create root node.
	
	    // Sometimes a MBCS char corresponds to a sequence of unicode chars. We store them as arrays of integers here. 
	    this.decodeTableSeq = [];
	
	    // Actual mapping tables consist of chunks. Use them to fill up decode tables.
	    for (var i = 0; i < mappingTable.length; i++)
	        this._addDecodeChunk(mappingTable[i]);
	
	    this.defaultCharUnicode = iconv.defaultCharUnicode;
	
	    
	    // Encode tables: Unicode -> DBCS.
	
	    // `encodeTable` is array mapping from unicode char to encoded char. All its values are integers for performance.
	    // Because it can be sparse, it is represented as array of buckets by 256 chars each. Bucket can be null.
	    // Values: >=  0 -> it is a normal char. Write the value (if <=256 then 1 byte, if <=65536 then 2 bytes, etc.).
	    //         == UNASSIGNED -> no conversion found. Output a default char.
	    //         <= SEQ_START  -> it's an index in encodeTableSeq, see below. The character starts a sequence.
	    this.encodeTable = [];
	    
	    // `encodeTableSeq` is used when a sequence of unicode characters is encoded as a single code. We use a tree of
	    // objects where keys correspond to characters in sequence and leafs are the encoded dbcs values. A special DEF_CHAR key
	    // means end of sequence (needed when one sequence is a strict subsequence of another).
	    // Objects are kept separately from encodeTable to increase performance.
	    this.encodeTableSeq = [];
	
	    // Some chars can be decoded, but need not be encoded.
	    var skipEncodeChars = {};
	    if (codecOptions.encodeSkipVals)
	        for (var i = 0; i < codecOptions.encodeSkipVals.length; i++) {
	            var val = codecOptions.encodeSkipVals[i];
	            if (typeof val === 'number')
	                skipEncodeChars[val] = true;
	            else
	                for (var j = val.from; j <= val.to; j++)
	                    skipEncodeChars[j] = true;
	        }
	        
	    // Use decode trie to recursively fill out encode tables.
	    this._fillEncodeTable(0, 0, skipEncodeChars);
	
	    // Add more encoding pairs when needed.
	    if (codecOptions.encodeAdd) {
	        for (var uChar in codecOptions.encodeAdd)
	            if (Object.prototype.hasOwnProperty.call(codecOptions.encodeAdd, uChar))
	                this._setEncodeChar(uChar.charCodeAt(0), codecOptions.encodeAdd[uChar]);
	    }
	
	    this.defCharSB  = this.encodeTable[0][iconv.defaultCharSingleByte.charCodeAt(0)];
	    if (this.defCharSB === UNASSIGNED) this.defCharSB = this.encodeTable[0]['?'];
	    if (this.defCharSB === UNASSIGNED) this.defCharSB = "?".charCodeAt(0);
	
	
	    // Load & create GB18030 tables when needed.
	    if (typeof codecOptions.gb18030 === 'function') {
	        this.gb18030 = codecOptions.gb18030(); // Load GB18030 ranges.
	
	        // Add GB18030 decode tables.
	        var thirdByteNodeIdx = this.decodeTables.length;
	        var thirdByteNode = this.decodeTables[thirdByteNodeIdx] = UNASSIGNED_NODE.slice(0);
	
	        var fourthByteNodeIdx = this.decodeTables.length;
	        var fourthByteNode = this.decodeTables[fourthByteNodeIdx] = UNASSIGNED_NODE.slice(0);
	
	        for (var i = 0x81; i <= 0xFE; i++) {
	            var secondByteNodeIdx = NODE_START - this.decodeTables[0][i];
	            var secondByteNode = this.decodeTables[secondByteNodeIdx];
	            for (var j = 0x30; j <= 0x39; j++)
	                secondByteNode[j] = NODE_START - thirdByteNodeIdx;
	        }
	        for (var i = 0x81; i <= 0xFE; i++)
	            thirdByteNode[i] = NODE_START - fourthByteNodeIdx;
	        for (var i = 0x30; i <= 0x39; i++)
	            fourthByteNode[i] = GB18030_CODE
	    }        
	}
	
	DBCSCodec.prototype.encoder = DBCSEncoder;
	DBCSCodec.prototype.decoder = DBCSDecoder;
	
	// Decoder helpers
	DBCSCodec.prototype._getDecodeTrieNode = function(addr) {
	    var bytes = [];
	    for (; addr > 0; addr >>= 8)
	        bytes.push(addr & 0xFF);
	    if (bytes.length == 0)
	        bytes.push(0);
	
	    var node = this.decodeTables[0];
	    for (var i = bytes.length-1; i > 0; i--) { // Traverse nodes deeper into the trie.
	        var val = node[bytes[i]];
	
	        if (val == UNASSIGNED) { // Create new node.
	            node[bytes[i]] = NODE_START - this.decodeTables.length;
	            this.decodeTables.push(node = UNASSIGNED_NODE.slice(0));
	        }
	        else if (val <= NODE_START) { // Existing node.
	            node = this.decodeTables[NODE_START - val];
	        }
	        else
	            throw new Error("Overwrite byte in " + this.encodingName + ", addr: " + addr.toString(16));
	    }
	    return node;
	}
	
	
	DBCSCodec.prototype._addDecodeChunk = function(chunk) {
	    // First element of chunk is the hex mbcs code where we start.
	    var curAddr = parseInt(chunk[0], 16);
	
	    // Choose the decoding node where we'll write our chars.
	    var writeTable = this._getDecodeTrieNode(curAddr);
	    curAddr = curAddr & 0xFF;
	
	    // Write all other elements of the chunk to the table.
	    for (var k = 1; k < chunk.length; k++) {
	        var part = chunk[k];
	        if (typeof part === "string") { // String, write as-is.
	            for (var l = 0; l < part.length;) {
	                var code = part.charCodeAt(l++);
	                if (0xD800 <= code && code < 0xDC00) { // Decode surrogate
	                    var codeTrail = part.charCodeAt(l++);
	                    if (0xDC00 <= codeTrail && codeTrail < 0xE000)
	                        writeTable[curAddr++] = 0x10000 + (code - 0xD800) * 0x400 + (codeTrail - 0xDC00);
	                    else
	                        throw new Error("Incorrect surrogate pair in "  + this.encodingName + " at chunk " + chunk[0]);
	                }
	                else if (0x0FF0 < code && code <= 0x0FFF) { // Character sequence (our own encoding used)
	                    var len = 0xFFF - code + 2;
	                    var seq = [];
	                    for (var m = 0; m < len; m++)
	                        seq.push(part.charCodeAt(l++)); // Simple variation: don't support surrogates or subsequences in seq.
	
	                    writeTable[curAddr++] = SEQ_START - this.decodeTableSeq.length;
	                    this.decodeTableSeq.push(seq);
	                }
	                else
	                    writeTable[curAddr++] = code; // Basic char
	            }
	        } 
	        else if (typeof part === "number") { // Integer, meaning increasing sequence starting with prev character.
	            var charCode = writeTable[curAddr - 1] + 1;
	            for (var l = 0; l < part; l++)
	                writeTable[curAddr++] = charCode++;
	        }
	        else
	            throw new Error("Incorrect type '" + typeof part + "' given in "  + this.encodingName + " at chunk " + chunk[0]);
	    }
	    if (curAddr > 0xFF)
	        throw new Error("Incorrect chunk in "  + this.encodingName + " at addr " + chunk[0] + ": too long" + curAddr);
	}
	
	// Encoder helpers
	DBCSCodec.prototype._getEncodeBucket = function(uCode) {
	    var high = uCode >> 8; // This could be > 0xFF because of astral characters.
	    if (this.encodeTable[high] === undefined)
	        this.encodeTable[high] = UNASSIGNED_NODE.slice(0); // Create bucket on demand.
	    return this.encodeTable[high];
	}
	
	DBCSCodec.prototype._setEncodeChar = function(uCode, dbcsCode) {
	    var bucket = this._getEncodeBucket(uCode);
	    var low = uCode & 0xFF;
	    if (bucket[low] <= SEQ_START)
	        this.encodeTableSeq[SEQ_START-bucket[low]][DEF_CHAR] = dbcsCode; // There's already a sequence, set a single-char subsequence of it.
	    else if (bucket[low] == UNASSIGNED)
	        bucket[low] = dbcsCode;
	}
	
	DBCSCodec.prototype._setEncodeSequence = function(seq, dbcsCode) {
	    
	    // Get the root of character tree according to first character of the sequence.
	    var uCode = seq[0];
	    var bucket = this._getEncodeBucket(uCode);
	    var low = uCode & 0xFF;
	
	    var node;
	    if (bucket[low] <= SEQ_START) {
	        // There's already a sequence with  - use it.
	        node = this.encodeTableSeq[SEQ_START-bucket[low]];
	    }
	    else {
	        // There was no sequence object - allocate a new one.
	        node = {};
	        if (bucket[low] !== UNASSIGNED) node[DEF_CHAR] = bucket[low]; // If a char was set before - make it a single-char subsequence.
	        bucket[low] = SEQ_START - this.encodeTableSeq.length;
	        this.encodeTableSeq.push(node);
	    }
	
	    // Traverse the character tree, allocating new nodes as needed.
	    for (var j = 1; j < seq.length-1; j++) {
	        var oldVal = node[uCode];
	        if (typeof oldVal === 'object')
	            node = oldVal;
	        else {
	            node = node[uCode] = {}
	            if (oldVal !== undefined)
	                node[DEF_CHAR] = oldVal
	        }
	    }
	
	    // Set the leaf to given dbcsCode.
	    uCode = seq[seq.length-1];
	    node[uCode] = dbcsCode;
	}
	
	DBCSCodec.prototype._fillEncodeTable = function(nodeIdx, prefix, skipEncodeChars) {
	    var node = this.decodeTables[nodeIdx];
	    for (var i = 0; i < 0x100; i++) {
	        var uCode = node[i];
	        var mbCode = prefix + i;
	        if (skipEncodeChars[mbCode])
	            continue;
	
	        if (uCode >= 0)
	            this._setEncodeChar(uCode, mbCode);
	        else if (uCode <= NODE_START)
	            this._fillEncodeTable(NODE_START - uCode, mbCode << 8, skipEncodeChars);
	        else if (uCode <= SEQ_START)
	            this._setEncodeSequence(this.decodeTableSeq[SEQ_START - uCode], mbCode);
	    }
	}
	
	
	
	// == Encoder ==================================================================
	
	function DBCSEncoder(options, codec) {
	    // Encoder state
	    this.leadSurrogate = -1;
	    this.seqObj = undefined;
	    
	    // Static data
	    this.encodeTable = codec.encodeTable;
	    this.encodeTableSeq = codec.encodeTableSeq;
	    this.defaultCharSingleByte = codec.defCharSB;
	    this.gb18030 = codec.gb18030;
	}
	
	DBCSEncoder.prototype.write = function(str) {
	    var newBuf = new Buffer(str.length * (this.gb18030 ? 4 : 3)), 
	        leadSurrogate = this.leadSurrogate,
	        seqObj = this.seqObj, nextChar = -1,
	        i = 0, j = 0;
	
	    while (true) {
	        // 0. Get next character.
	        if (nextChar === -1) {
	            if (i == str.length) break;
	            var uCode = str.charCodeAt(i++);
	        }
	        else {
	            var uCode = nextChar;
	            nextChar = -1;    
	        }
	
	        // 1. Handle surrogates.
	        if (0xD800 <= uCode && uCode < 0xE000) { // Char is one of surrogates.
	            if (uCode < 0xDC00) { // We've got lead surrogate.
	                if (leadSurrogate === -1) {
	                    leadSurrogate = uCode;
	                    continue;
	                } else {
	                    leadSurrogate = uCode;
	                    // Double lead surrogate found.
	                    uCode = UNASSIGNED;
	                }
	            } else { // We've got trail surrogate.
	                if (leadSurrogate !== -1) {
	                    uCode = 0x10000 + (leadSurrogate - 0xD800) * 0x400 + (uCode - 0xDC00);
	                    leadSurrogate = -1;
	                } else {
	                    // Incomplete surrogate pair - only trail surrogate found.
	                    uCode = UNASSIGNED;
	                }
	                
	            }
	        }
	        else if (leadSurrogate !== -1) {
	            // Incomplete surrogate pair - only lead surrogate found.
	            nextChar = uCode; uCode = UNASSIGNED; // Write an error, then current char.
	            leadSurrogate = -1;
	        }
	
	        // 2. Convert uCode character.
	        var dbcsCode = UNASSIGNED;
	        if (seqObj !== undefined && uCode != UNASSIGNED) { // We are in the middle of the sequence
	            var resCode = seqObj[uCode];
	            if (typeof resCode === 'object') { // Sequence continues.
	                seqObj = resCode;
	                continue;
	
	            } else if (typeof resCode == 'number') { // Sequence finished. Write it.
	                dbcsCode = resCode;
	
	            } else if (resCode == undefined) { // Current character is not part of the sequence.
	
	                // Try default character for this sequence
	                resCode = seqObj[DEF_CHAR];
	                if (resCode !== undefined) {
	                    dbcsCode = resCode; // Found. Write it.
	                    nextChar = uCode; // Current character will be written too in the next iteration.
	
	                } else {
	                    // TODO: What if we have no default? (resCode == undefined)
	                    // Then, we should write first char of the sequence as-is and try the rest recursively.
	                    // Didn't do it for now because no encoding has this situation yet.
	                    // Currently, just skip the sequence and write current char.
	                }
	            }
	            seqObj = undefined;
	        }
	        else if (uCode >= 0) {  // Regular character
	            var subtable = this.encodeTable[uCode >> 8];
	            if (subtable !== undefined)
	                dbcsCode = subtable[uCode & 0xFF];
	            
	            if (dbcsCode <= SEQ_START) { // Sequence start
	                seqObj = this.encodeTableSeq[SEQ_START-dbcsCode];
	                continue;
	            }
	
	            if (dbcsCode == UNASSIGNED && this.gb18030) {
	                // Use GB18030 algorithm to find character(s) to write.
	                var idx = findIdx(this.gb18030.uChars, uCode);
	                if (idx != -1) {
	                    var dbcsCode = this.gb18030.gbChars[idx] + (uCode - this.gb18030.uChars[idx]);
	                    newBuf[j++] = 0x81 + Math.floor(dbcsCode / 12600); dbcsCode = dbcsCode % 12600;
	                    newBuf[j++] = 0x30 + Math.floor(dbcsCode / 1260); dbcsCode = dbcsCode % 1260;
	                    newBuf[j++] = 0x81 + Math.floor(dbcsCode / 10); dbcsCode = dbcsCode % 10;
	                    newBuf[j++] = 0x30 + dbcsCode;
	                    continue;
	                }
	            }
	        }
	
	        // 3. Write dbcsCode character.
	        if (dbcsCode === UNASSIGNED)
	            dbcsCode = this.defaultCharSingleByte;
	        
	        if (dbcsCode < 0x100) {
	            newBuf[j++] = dbcsCode;
	        }
	        else if (dbcsCode < 0x10000) {
	            newBuf[j++] = dbcsCode >> 8;   // high byte
	            newBuf[j++] = dbcsCode & 0xFF; // low byte
	        }
	        else {
	            newBuf[j++] = dbcsCode >> 16;
	            newBuf[j++] = (dbcsCode >> 8) & 0xFF;
	            newBuf[j++] = dbcsCode & 0xFF;
	        }
	    }
	
	    this.seqObj = seqObj;
	    this.leadSurrogate = leadSurrogate;
	    return newBuf.slice(0, j);
	}
	
	DBCSEncoder.prototype.end = function() {
	    if (this.leadSurrogate === -1 && this.seqObj === undefined)
	        return; // All clean. Most often case.
	
	    var newBuf = new Buffer(10), j = 0;
	
	    if (this.seqObj) { // We're in the sequence.
	        var dbcsCode = this.seqObj[DEF_CHAR];
	        if (dbcsCode !== undefined) { // Write beginning of the sequence.
	            if (dbcsCode < 0x100) {
	                newBuf[j++] = dbcsCode;
	            }
	            else {
	                newBuf[j++] = dbcsCode >> 8;   // high byte
	                newBuf[j++] = dbcsCode & 0xFF; // low byte
	            }
	        } else {
	            // See todo above.
	        }
	        this.seqObj = undefined;
	    }
	
	    if (this.leadSurrogate !== -1) {
	        // Incomplete surrogate pair - only lead surrogate found.
	        newBuf[j++] = this.defaultCharSingleByte;
	        this.leadSurrogate = -1;
	    }
	    
	    return newBuf.slice(0, j);
	}
	
	// Export for testing
	DBCSEncoder.prototype.findIdx = findIdx;
	
	
	// == Decoder ==================================================================
	
	function DBCSDecoder(options, codec) {
	    // Decoder state
	    this.nodeIdx = 0;
	    this.prevBuf = new Buffer(0);
	
	    // Static data
	    this.decodeTables = codec.decodeTables;
	    this.decodeTableSeq = codec.decodeTableSeq;
	    this.defaultCharUnicode = codec.defaultCharUnicode;
	    this.gb18030 = codec.gb18030;
	}
	
	DBCSDecoder.prototype.write = function(buf) {
	    var newBuf = new Buffer(buf.length*2),
	        nodeIdx = this.nodeIdx, 
	        prevBuf = this.prevBuf, prevBufOffset = this.prevBuf.length,
	        seqStart = -this.prevBuf.length, // idx of the start of current parsed sequence.
	        uCode;
	
	    if (prevBufOffset > 0) // Make prev buf overlap a little to make it easier to slice later.
	        prevBuf = Buffer.concat([prevBuf, buf.slice(0, 10)]);
	    
	    for (var i = 0, j = 0; i < buf.length; i++) {
	        var curByte = (i >= 0) ? buf[i] : prevBuf[i + prevBufOffset];
	
	        // Lookup in current trie node.
	        var uCode = this.decodeTables[nodeIdx][curByte];
	
	        if (uCode >= 0) { 
	            // Normal character, just use it.
	        }
	        else if (uCode === UNASSIGNED) { // Unknown char.
	            // TODO: Callback with seq.
	            //var curSeq = (seqStart >= 0) ? buf.slice(seqStart, i+1) : prevBuf.slice(seqStart + prevBufOffset, i+1 + prevBufOffset);
	            i = seqStart; // Try to parse again, after skipping first byte of the sequence ('i' will be incremented by 'for' cycle).
	            uCode = this.defaultCharUnicode.charCodeAt(0);
	        }
	        else if (uCode === GB18030_CODE) {
	            var curSeq = (seqStart >= 0) ? buf.slice(seqStart, i+1) : prevBuf.slice(seqStart + prevBufOffset, i+1 + prevBufOffset);
	            var ptr = (curSeq[0]-0x81)*12600 + (curSeq[1]-0x30)*1260 + (curSeq[2]-0x81)*10 + (curSeq[3]-0x30);
	            var idx = findIdx(this.gb18030.gbChars, ptr);
	            uCode = this.gb18030.uChars[idx] + ptr - this.gb18030.gbChars[idx];
	        }
	        else if (uCode <= NODE_START) { // Go to next trie node.
	            nodeIdx = NODE_START - uCode;
	            continue;
	        }
	        else if (uCode <= SEQ_START) { // Output a sequence of chars.
	            var seq = this.decodeTableSeq[SEQ_START - uCode];
	            for (var k = 0; k < seq.length - 1; k++) {
	                uCode = seq[k];
	                newBuf[j++] = uCode & 0xFF;
	                newBuf[j++] = uCode >> 8;
	            }
	            uCode = seq[seq.length-1];
	        }
	        else
	            throw new Error("iconv-lite internal error: invalid decoding table value " + uCode + " at " + nodeIdx + "/" + curByte);
	
	        // Write the character to buffer, handling higher planes using surrogate pair.
	        if (uCode > 0xFFFF) { 
	            uCode -= 0x10000;
	            var uCodeLead = 0xD800 + Math.floor(uCode / 0x400);
	            newBuf[j++] = uCodeLead & 0xFF;
	            newBuf[j++] = uCodeLead >> 8;
	
	            uCode = 0xDC00 + uCode % 0x400;
	        }
	        newBuf[j++] = uCode & 0xFF;
	        newBuf[j++] = uCode >> 8;
	
	        // Reset trie node.
	        nodeIdx = 0; seqStart = i+1;
	    }
	
	    this.nodeIdx = nodeIdx;
	    this.prevBuf = (seqStart >= 0) ? buf.slice(seqStart) : prevBuf.slice(seqStart + prevBufOffset);
	    return newBuf.slice(0, j).toString('ucs2');
	}
	
	DBCSDecoder.prototype.end = function() {
	    var ret = '';
	
	    // Try to parse all remaining chars.
	    while (this.prevBuf.length > 0) {
	        // Skip 1 character in the buffer.
	        ret += this.defaultCharUnicode;
	        var buf = this.prevBuf.slice(1);
	
	        // Parse remaining as usual.
	        this.prevBuf = new Buffer(0);
	        this.nodeIdx = 0;
	        if (buf.length > 0)
	            ret += this.write(buf);
	    }
	
	    this.nodeIdx = 0;
	    return ret;
	}
	
	// Binary search for GB18030. Returns largest i such that table[i] <= val.
	function findIdx(table, val) {
	    if (table[0] > val)
	        return -1;
	
	    var l = 0, r = table.length;
	    while (l < r-1) { // always table[l] <= val < table[r]
	        var mid = l + Math.floor((r-l+1)/2);
	        if (table[mid] <= val)
	            l = mid;
	        else
	            r = mid;
	    }
	    return l;
	}
	
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(9).Buffer))

/***/ },
/* 29 */
/***/ function(module, exports, __webpack_require__) {

	"use strict"
	
	// Description of supported double byte encodings and aliases.
	// Tables are not require()-d until they are needed to speed up library load.
	// require()-s are direct to support Browserify.
	
	module.exports = {
	    
	    // == Japanese/ShiftJIS ====================================================
	    // All japanese encodings are based on JIS X set of standards:
	    // JIS X 0201 - Single-byte encoding of ASCII + ¥ + Kana chars at 0xA1-0xDF.
	    // JIS X 0208 - Main set of 6879 characters, placed in 94x94 plane, to be encoded by 2 bytes. 
	    //              Has several variations in 1978, 1983, 1990 and 1997.
	    // JIS X 0212 - Supplementary plane of 6067 chars in 94x94 plane. 1990. Effectively dead.
	    // JIS X 0213 - Extension and modern replacement of 0208 and 0212. Total chars: 11233.
	    //              2 planes, first is superset of 0208, second - revised 0212.
	    //              Introduced in 2000, revised 2004. Some characters are in Unicode Plane 2 (0x2xxxx)
	
	    // Byte encodings are:
	    //  * Shift_JIS: Compatible with 0201, uses not defined chars in top half as lead bytes for double-byte
	    //               encoding of 0208. Lead byte ranges: 0x81-0x9F, 0xE0-0xEF; Trail byte ranges: 0x40-0x7E, 0x80-0x9E, 0x9F-0xFC.
	    //               Windows CP932 is a superset of Shift_JIS. Some companies added more chars, notably KDDI.
	    //  * EUC-JP:    Up to 3 bytes per character. Used mostly on *nixes.
	    //               0x00-0x7F       - lower part of 0201
	    //               0x8E, 0xA1-0xDF - upper part of 0201
	    //               (0xA1-0xFE)x2   - 0208 plane (94x94).
	    //               0x8F, (0xA1-0xFE)x2 - 0212 plane (94x94).
	    //  * JIS X 208: 7-bit, direct encoding of 0208. Byte ranges: 0x21-0x7E (94 values). Uncommon.
	    //               Used as-is in ISO2022 family.
	    //  * ISO2022-JP: Stateful encoding, with escape sequences to switch between ASCII, 
	    //                0201-1976 Roman, 0208-1978, 0208-1983.
	    //  * ISO2022-JP-1: Adds esc seq for 0212-1990.
	    //  * ISO2022-JP-2: Adds esc seq for GB2313-1980, KSX1001-1992, ISO8859-1, ISO8859-7.
	    //  * ISO2022-JP-3: Adds esc seq for 0201-1976 Kana set, 0213-2000 Planes 1, 2.
	    //  * ISO2022-JP-2004: Adds 0213-2004 Plane 1.
	    //
	    // After JIS X 0213 appeared, Shift_JIS-2004, EUC-JISX0213 and ISO2022-JP-2004 followed, with just changing the planes.
	    //
	    // Overall, it seems that it's a mess :( http://www8.plala.or.jp/tkubota1/unicode-symbols-map2.html
	
	
	    'shiftjis': {
	        type: '_dbcs',
	        table: function() { return __webpack_require__(30) },
	        encodeAdd: {'\u00a5': 0x5C, '\u203E': 0x7E},
	        encodeSkipVals: [{from: 0xED40, to: 0xF940}],
	    },
	    'csshiftjis': 'shiftjis',
	    'mskanji': 'shiftjis',
	    'sjis': 'shiftjis',
	    'windows31j': 'shiftjis',
	    'xsjis': 'shiftjis',
	    'windows932': 'shiftjis',
	    '932': 'shiftjis',
	    'cp932': 'shiftjis',
	
	    'eucjp': {
	        type: '_dbcs',
	        table: function() { return __webpack_require__(31) },
	        encodeAdd: {'\u00a5': 0x5C, '\u203E': 0x7E},
	    },
	
	    // TODO: KDDI extension to Shift_JIS
	    // TODO: IBM CCSID 942 = CP932, but F0-F9 custom chars and other char changes.
	    // TODO: IBM CCSID 943 = Shift_JIS = CP932 with original Shift_JIS lower 128 chars.
	
	    // == Chinese/GBK ==========================================================
	    // http://en.wikipedia.org/wiki/GBK
	
	    // Oldest GB2312 (1981, ~7600 chars) is a subset of CP936
	    'gb2312': 'cp936',
	    'gb231280': 'cp936',
	    'gb23121980': 'cp936',
	    'csgb2312': 'cp936',
	    'csiso58gb231280': 'cp936',
	    'euccn': 'cp936',
	    'isoir58': 'gbk',
	
	    // Microsoft's CP936 is a subset and approximation of GBK.
	    // TODO: Euro = 0x80 in cp936, but not in GBK (where it's valid but undefined)
	    'windows936': 'cp936',
	    '936': 'cp936',
	    'cp936': {
	        type: '_dbcs',
	        table: function() { return __webpack_require__(32) },
	    },
	
	    // GBK (~22000 chars) is an extension of CP936 that added user-mapped chars and some other.
	    'gbk': {
	        type: '_dbcs',
	        table: function() { return __webpack_require__(32).concat(__webpack_require__(33)) },
	    },
	    'xgbk': 'gbk',
	
	    // GB18030 is an algorithmic extension of GBK.
	    'gb18030': {
	        type: '_dbcs',
	        table: function() { return __webpack_require__(32).concat(__webpack_require__(33)) },
	        gb18030: function() { return __webpack_require__(34) },
	    },
	
	    'chinese': 'gb18030',
	
	    // TODO: Support GB18030 (~27000 chars + whole unicode mapping, cp54936)
	    // http://icu-project.org/docs/papers/gb18030.html
	    // http://source.icu-project.org/repos/icu/data/trunk/charset/data/xml/gb-18030-2000.xml
	    // http://www.khngai.com/chinese/charmap/tblgbk.php?page=0
	
	    // == Korean ===============================================================
	    // EUC-KR, KS_C_5601 and KS X 1001 are exactly the same.
	    'windows949': 'cp949',
	    '949': 'cp949',
	    'cp949': {
	        type: '_dbcs',
	        table: function() { return __webpack_require__(35) },
	    },
	
	    'cseuckr': 'cp949',
	    'csksc56011987': 'cp949',
	    'euckr': 'cp949',
	    'isoir149': 'cp949',
	    'korean': 'cp949',
	    'ksc56011987': 'cp949',
	    'ksc56011989': 'cp949',
	    'ksc5601': 'cp949',
	
	
	    // == Big5/Taiwan/Hong Kong ================================================
	    // There are lots of tables for Big5 and cp950. Please see the following links for history:
	    // http://moztw.org/docs/big5/  http://www.haible.de/bruno/charsets/conversion-tables/Big5.html
	    // Variations, in roughly number of defined chars:
	    //  * Windows CP 950: Microsoft variant of Big5. Canonical: http://www.unicode.org/Public/MAPPINGS/VENDORS/MICSFT/WINDOWS/CP950.TXT
	    //  * Windows CP 951: Microsoft variant of Big5-HKSCS-2001. Seems to be never public. http://me.abelcheung.org/articles/research/what-is-cp951/
	    //  * Big5-2003 (Taiwan standard) almost superset of cp950.
	    //  * Unicode-at-on (UAO) / Mozilla 1.8. Falling out of use on the Web. Not supported by other browsers.
	    //  * Big5-HKSCS (-2001, -2004, -2008). Hong Kong standard. 
	    //    many unicode code points moved from PUA to Supplementary plane (U+2XXXX) over the years.
	    //    Plus, it has 4 combining sequences.
	    //    Seems that Mozilla refused to support it for 10 yrs. https://bugzilla.mozilla.org/show_bug.cgi?id=162431 https://bugzilla.mozilla.org/show_bug.cgi?id=310299
	    //    because big5-hkscs is the only encoding to include astral characters in non-algorithmic way.
	    //    Implementations are not consistent within browsers; sometimes labeled as just big5.
	    //    MS Internet Explorer switches from big5 to big5-hkscs when a patch applied.
	    //    Great discussion & recap of what's going on https://bugzilla.mozilla.org/show_bug.cgi?id=912470#c31
	    //    In the encoder, it might make sense to support encoding old PUA mappings to Big5 bytes seq-s.
	    //    Official spec: http://www.ogcio.gov.hk/en/business/tech_promotion/ccli/terms/doc/2003cmp_2008.txt
	    //                   http://www.ogcio.gov.hk/tc/business/tech_promotion/ccli/terms/doc/hkscs-2008-big5-iso.txt
	    // 
	    // Current understanding of how to deal with Big5(-HKSCS) is in the Encoding Standard, http://encoding.spec.whatwg.org/#big5-encoder
	    // Unicode mapping (http://www.unicode.org/Public/MAPPINGS/OBSOLETE/EASTASIA/OTHER/BIG5.TXT) is said to be wrong.
	
	    'windows950': 'cp950',
	    '950': 'cp950',
	    'cp950': {
	        type: '_dbcs',
	        table: function() { return __webpack_require__(36) },
	    },
	
	    // Big5 has many variations and is an extension of cp950. We use Encoding Standard's as a consensus.
	    'big5': 'big5hkscs',
	    'big5hkscs': {
	        type: '_dbcs',
	        table: function() { return __webpack_require__(36).concat(__webpack_require__(37)) },
	        encodeSkipVals: [0xa2cc],
	    },
	
	    'cnbig5': 'big5hkscs',
	    'csbig5': 'big5hkscs',
	    'xxbig5': 'big5hkscs',
	
	};


/***/ },
/* 30 */
/***/ function(module, exports) {

	module.exports = [
		[
			"0",
			"\u0000",
			128
		],
		[
			"a1",
			"｡",
			62
		],
		[
			"8140",
			"　、。，．・：；？！゛゜´｀¨＾￣＿ヽヾゝゞ〃仝々〆〇ー―‐／＼～∥｜…‥‘’“”（）〔〕［］｛｝〈",
			9,
			"＋－±×"
		],
		[
			"8180",
			"÷＝≠＜＞≦≧∞∴♂♀°′″℃￥＄￠￡％＃＆＊＠§☆★○●◎◇◆□■△▲▽▼※〒→←↑↓〓"
		],
		[
			"81b8",
			"∈∋⊆⊇⊂⊃∪∩"
		],
		[
			"81c8",
			"∧∨￢⇒⇔∀∃"
		],
		[
			"81da",
			"∠⊥⌒∂∇≡≒≪≫√∽∝∵∫∬"
		],
		[
			"81f0",
			"Å‰♯♭♪†‡¶"
		],
		[
			"81fc",
			"◯"
		],
		[
			"824f",
			"０",
			9
		],
		[
			"8260",
			"Ａ",
			25
		],
		[
			"8281",
			"ａ",
			25
		],
		[
			"829f",
			"ぁ",
			82
		],
		[
			"8340",
			"ァ",
			62
		],
		[
			"8380",
			"ム",
			22
		],
		[
			"839f",
			"Α",
			16,
			"Σ",
			6
		],
		[
			"83bf",
			"α",
			16,
			"σ",
			6
		],
		[
			"8440",
			"А",
			5,
			"ЁЖ",
			25
		],
		[
			"8470",
			"а",
			5,
			"ёж",
			7
		],
		[
			"8480",
			"о",
			17
		],
		[
			"849f",
			"─│┌┐┘└├┬┤┴┼━┃┏┓┛┗┣┳┫┻╋┠┯┨┷┿┝┰┥┸╂"
		],
		[
			"8740",
			"①",
			19,
			"Ⅰ",
			9
		],
		[
			"875f",
			"㍉㌔㌢㍍㌘㌧㌃㌶㍑㍗㌍㌦㌣㌫㍊㌻㎜㎝㎞㎎㎏㏄㎡"
		],
		[
			"877e",
			"㍻"
		],
		[
			"8780",
			"〝〟№㏍℡㊤",
			4,
			"㈱㈲㈹㍾㍽㍼≒≡∫∮∑√⊥∠∟⊿∵∩∪"
		],
		[
			"889f",
			"亜唖娃阿哀愛挨姶逢葵茜穐悪握渥旭葦芦鯵梓圧斡扱宛姐虻飴絢綾鮎或粟袷安庵按暗案闇鞍杏以伊位依偉囲夷委威尉惟意慰易椅為畏異移維緯胃萎衣謂違遺医井亥域育郁磯一壱溢逸稲茨芋鰯允印咽員因姻引飲淫胤蔭"
		],
		[
			"8940",
			"院陰隠韻吋右宇烏羽迂雨卯鵜窺丑碓臼渦嘘唄欝蔚鰻姥厩浦瓜閏噂云運雲荏餌叡営嬰影映曳栄永泳洩瑛盈穎頴英衛詠鋭液疫益駅悦謁越閲榎厭円"
		],
		[
			"8980",
			"園堰奄宴延怨掩援沿演炎焔煙燕猿縁艶苑薗遠鉛鴛塩於汚甥凹央奥往応押旺横欧殴王翁襖鴬鴎黄岡沖荻億屋憶臆桶牡乙俺卸恩温穏音下化仮何伽価佳加可嘉夏嫁家寡科暇果架歌河火珂禍禾稼箇花苛茄荷華菓蝦課嘩貨迦過霞蚊俄峨我牙画臥芽蛾賀雅餓駕介会解回塊壊廻快怪悔恢懐戒拐改"
		],
		[
			"8a40",
			"魁晦械海灰界皆絵芥蟹開階貝凱劾外咳害崖慨概涯碍蓋街該鎧骸浬馨蛙垣柿蛎鈎劃嚇各廓拡撹格核殻獲確穫覚角赫較郭閣隔革学岳楽額顎掛笠樫"
		],
		[
			"8a80",
			"橿梶鰍潟割喝恰括活渇滑葛褐轄且鰹叶椛樺鞄株兜竃蒲釜鎌噛鴨栢茅萱粥刈苅瓦乾侃冠寒刊勘勧巻喚堪姦完官寛干幹患感慣憾換敢柑桓棺款歓汗漢澗潅環甘監看竿管簡緩缶翰肝艦莞観諌貫還鑑間閑関陥韓館舘丸含岸巌玩癌眼岩翫贋雁頑顔願企伎危喜器基奇嬉寄岐希幾忌揮机旗既期棋棄"
		],
		[
			"8b40",
			"機帰毅気汽畿祈季稀紀徽規記貴起軌輝飢騎鬼亀偽儀妓宜戯技擬欺犠疑祇義蟻誼議掬菊鞠吉吃喫桔橘詰砧杵黍却客脚虐逆丘久仇休及吸宮弓急救"
		],
		[
			"8b80",
			"朽求汲泣灸球究窮笈級糾給旧牛去居巨拒拠挙渠虚許距鋸漁禦魚亨享京供侠僑兇競共凶協匡卿叫喬境峡強彊怯恐恭挟教橋況狂狭矯胸脅興蕎郷鏡響饗驚仰凝尭暁業局曲極玉桐粁僅勤均巾錦斤欣欽琴禁禽筋緊芹菌衿襟謹近金吟銀九倶句区狗玖矩苦躯駆駈駒具愚虞喰空偶寓遇隅串櫛釧屑屈"
		],
		[
			"8c40",
			"掘窟沓靴轡窪熊隈粂栗繰桑鍬勲君薫訓群軍郡卦袈祁係傾刑兄啓圭珪型契形径恵慶慧憩掲携敬景桂渓畦稽系経継繋罫茎荊蛍計詣警軽頚鶏芸迎鯨"
		],
		[
			"8c80",
			"劇戟撃激隙桁傑欠決潔穴結血訣月件倹倦健兼券剣喧圏堅嫌建憲懸拳捲検権牽犬献研硯絹県肩見謙賢軒遣鍵険顕験鹸元原厳幻弦減源玄現絃舷言諺限乎個古呼固姑孤己庫弧戸故枯湖狐糊袴股胡菰虎誇跨鈷雇顧鼓五互伍午呉吾娯後御悟梧檎瑚碁語誤護醐乞鯉交佼侯候倖光公功効勾厚口向"
		],
		[
			"8d40",
			"后喉坑垢好孔孝宏工巧巷幸広庚康弘恒慌抗拘控攻昂晃更杭校梗構江洪浩港溝甲皇硬稿糠紅紘絞綱耕考肯肱腔膏航荒行衡講貢購郊酵鉱砿鋼閤降"
		],
		[
			"8d80",
			"項香高鴻剛劫号合壕拷濠豪轟麹克刻告国穀酷鵠黒獄漉腰甑忽惚骨狛込此頃今困坤墾婚恨懇昏昆根梱混痕紺艮魂些佐叉唆嵯左差査沙瑳砂詐鎖裟坐座挫債催再最哉塞妻宰彩才採栽歳済災采犀砕砦祭斎細菜裁載際剤在材罪財冴坂阪堺榊肴咲崎埼碕鷺作削咋搾昨朔柵窄策索錯桜鮭笹匙冊刷"
		],
		[
			"8e40",
			"察拶撮擦札殺薩雑皐鯖捌錆鮫皿晒三傘参山惨撒散桟燦珊産算纂蚕讃賛酸餐斬暫残仕仔伺使刺司史嗣四士始姉姿子屍市師志思指支孜斯施旨枝止"
		],
		[
			"8e80",
			"死氏獅祉私糸紙紫肢脂至視詞詩試誌諮資賜雌飼歯事似侍児字寺慈持時次滋治爾璽痔磁示而耳自蒔辞汐鹿式識鴫竺軸宍雫七叱執失嫉室悉湿漆疾質実蔀篠偲柴芝屡蕊縞舎写射捨赦斜煮社紗者謝車遮蛇邪借勺尺杓灼爵酌釈錫若寂弱惹主取守手朱殊狩珠種腫趣酒首儒受呪寿授樹綬需囚収周"
		],
		[
			"8f40",
			"宗就州修愁拾洲秀秋終繍習臭舟蒐衆襲讐蹴輯週酋酬集醜什住充十従戎柔汁渋獣縦重銃叔夙宿淑祝縮粛塾熟出術述俊峻春瞬竣舜駿准循旬楯殉淳"
		],
		[
			"8f80",
			"準潤盾純巡遵醇順処初所暑曙渚庶緒署書薯藷諸助叙女序徐恕鋤除傷償勝匠升召哨商唱嘗奨妾娼宵将小少尚庄床廠彰承抄招掌捷昇昌昭晶松梢樟樵沼消渉湘焼焦照症省硝礁祥称章笑粧紹肖菖蒋蕉衝裳訟証詔詳象賞醤鉦鍾鐘障鞘上丈丞乗冗剰城場壌嬢常情擾条杖浄状畳穣蒸譲醸錠嘱埴飾"
		],
		[
			"9040",
			"拭植殖燭織職色触食蝕辱尻伸信侵唇娠寝審心慎振新晋森榛浸深申疹真神秦紳臣芯薪親診身辛進針震人仁刃塵壬尋甚尽腎訊迅陣靭笥諏須酢図厨"
		],
		[
			"9080",
			"逗吹垂帥推水炊睡粋翠衰遂酔錐錘随瑞髄崇嵩数枢趨雛据杉椙菅頗雀裾澄摺寸世瀬畝是凄制勢姓征性成政整星晴棲栖正清牲生盛精聖声製西誠誓請逝醒青静斉税脆隻席惜戚斥昔析石積籍績脊責赤跡蹟碩切拙接摂折設窃節説雪絶舌蝉仙先千占宣専尖川戦扇撰栓栴泉浅洗染潜煎煽旋穿箭線"
		],
		[
			"9140",
			"繊羨腺舛船薦詮賎践選遷銭銑閃鮮前善漸然全禅繕膳糎噌塑岨措曾曽楚狙疏疎礎祖租粗素組蘇訴阻遡鼠僧創双叢倉喪壮奏爽宋層匝惣想捜掃挿掻"
		],
		[
			"9180",
			"操早曹巣槍槽漕燥争痩相窓糟総綜聡草荘葬蒼藻装走送遭鎗霜騒像増憎臓蔵贈造促側則即息捉束測足速俗属賊族続卒袖其揃存孫尊損村遜他多太汰詑唾堕妥惰打柁舵楕陀駄騨体堆対耐岱帯待怠態戴替泰滞胎腿苔袋貸退逮隊黛鯛代台大第醍題鷹滝瀧卓啄宅托択拓沢濯琢託鐸濁諾茸凧蛸只"
		],
		[
			"9240",
			"叩但達辰奪脱巽竪辿棚谷狸鱈樽誰丹単嘆坦担探旦歎淡湛炭短端箪綻耽胆蛋誕鍛団壇弾断暖檀段男談値知地弛恥智池痴稚置致蜘遅馳築畜竹筑蓄"
		],
		[
			"9280",
			"逐秩窒茶嫡着中仲宙忠抽昼柱注虫衷註酎鋳駐樗瀦猪苧著貯丁兆凋喋寵帖帳庁弔張彫徴懲挑暢朝潮牒町眺聴脹腸蝶調諜超跳銚長頂鳥勅捗直朕沈珍賃鎮陳津墜椎槌追鎚痛通塚栂掴槻佃漬柘辻蔦綴鍔椿潰坪壷嬬紬爪吊釣鶴亭低停偵剃貞呈堤定帝底庭廷弟悌抵挺提梯汀碇禎程締艇訂諦蹄逓"
		],
		[
			"9340",
			"邸鄭釘鼎泥摘擢敵滴的笛適鏑溺哲徹撤轍迭鉄典填天展店添纏甜貼転顛点伝殿澱田電兎吐堵塗妬屠徒斗杜渡登菟賭途都鍍砥砺努度土奴怒倒党冬"
		],
		[
			"9380",
			"凍刀唐塔塘套宕島嶋悼投搭東桃梼棟盗淘湯涛灯燈当痘祷等答筒糖統到董蕩藤討謄豆踏逃透鐙陶頭騰闘働動同堂導憧撞洞瞳童胴萄道銅峠鴇匿得徳涜特督禿篤毒独読栃橡凸突椴届鳶苫寅酉瀞噸屯惇敦沌豚遁頓呑曇鈍奈那内乍凪薙謎灘捺鍋楢馴縄畷南楠軟難汝二尼弐迩匂賑肉虹廿日乳入"
		],
		[
			"9440",
			"如尿韮任妊忍認濡禰祢寧葱猫熱年念捻撚燃粘乃廼之埜嚢悩濃納能脳膿農覗蚤巴把播覇杷波派琶破婆罵芭馬俳廃拝排敗杯盃牌背肺輩配倍培媒梅"
		],
		[
			"9480",
			"楳煤狽買売賠陪這蝿秤矧萩伯剥博拍柏泊白箔粕舶薄迫曝漠爆縛莫駁麦函箱硲箸肇筈櫨幡肌畑畠八鉢溌発醗髪伐罰抜筏閥鳩噺塙蛤隼伴判半反叛帆搬斑板氾汎版犯班畔繁般藩販範釆煩頒飯挽晩番盤磐蕃蛮匪卑否妃庇彼悲扉批披斐比泌疲皮碑秘緋罷肥被誹費避非飛樋簸備尾微枇毘琵眉美"
		],
		[
			"9540",
			"鼻柊稗匹疋髭彦膝菱肘弼必畢筆逼桧姫媛紐百謬俵彪標氷漂瓢票表評豹廟描病秒苗錨鋲蒜蛭鰭品彬斌浜瀕貧賓頻敏瓶不付埠夫婦富冨布府怖扶敷"
		],
		[
			"9580",
			"斧普浮父符腐膚芙譜負賦赴阜附侮撫武舞葡蕪部封楓風葺蕗伏副復幅服福腹複覆淵弗払沸仏物鮒分吻噴墳憤扮焚奮粉糞紛雰文聞丙併兵塀幣平弊柄並蔽閉陛米頁僻壁癖碧別瞥蔑箆偏変片篇編辺返遍便勉娩弁鞭保舗鋪圃捕歩甫補輔穂募墓慕戊暮母簿菩倣俸包呆報奉宝峰峯崩庖抱捧放方朋"
		],
		[
			"9640",
			"法泡烹砲縫胞芳萌蓬蜂褒訪豊邦鋒飽鳳鵬乏亡傍剖坊妨帽忘忙房暴望某棒冒紡肪膨謀貌貿鉾防吠頬北僕卜墨撲朴牧睦穆釦勃没殆堀幌奔本翻凡盆"
		],
		[
			"9680",
			"摩磨魔麻埋妹昧枚毎哩槙幕膜枕鮪柾鱒桝亦俣又抹末沫迄侭繭麿万慢満漫蔓味未魅巳箕岬密蜜湊蓑稔脈妙粍民眠務夢無牟矛霧鵡椋婿娘冥名命明盟迷銘鳴姪牝滅免棉綿緬面麺摸模茂妄孟毛猛盲網耗蒙儲木黙目杢勿餅尤戻籾貰問悶紋門匁也冶夜爺耶野弥矢厄役約薬訳躍靖柳薮鑓愉愈油癒"
		],
		[
			"9740",
			"諭輸唯佑優勇友宥幽悠憂揖有柚湧涌猶猷由祐裕誘遊邑郵雄融夕予余与誉輿預傭幼妖容庸揚揺擁曜楊様洋溶熔用窯羊耀葉蓉要謡踊遥陽養慾抑欲"
		],
		[
			"9780",
			"沃浴翌翼淀羅螺裸来莱頼雷洛絡落酪乱卵嵐欄濫藍蘭覧利吏履李梨理璃痢裏裡里離陸律率立葎掠略劉流溜琉留硫粒隆竜龍侶慮旅虜了亮僚両凌寮料梁涼猟療瞭稜糧良諒遼量陵領力緑倫厘林淋燐琳臨輪隣鱗麟瑠塁涙累類令伶例冷励嶺怜玲礼苓鈴隷零霊麗齢暦歴列劣烈裂廉恋憐漣煉簾練聯"
		],
		[
			"9840",
			"蓮連錬呂魯櫓炉賂路露労婁廊弄朗楼榔浪漏牢狼篭老聾蝋郎六麓禄肋録論倭和話歪賄脇惑枠鷲亙亘鰐詫藁蕨椀湾碗腕"
		],
		[
			"989f",
			"弌丐丕个丱丶丼丿乂乖乘亂亅豫亊舒弍于亞亟亠亢亰亳亶从仍仄仆仂仗仞仭仟价伉佚估佛佝佗佇佶侈侏侘佻佩佰侑佯來侖儘俔俟俎俘俛俑俚俐俤俥倚倨倔倪倥倅伜俶倡倩倬俾俯們倆偃假會偕偐偈做偖偬偸傀傚傅傴傲"
		],
		[
			"9940",
			"僉僊傳僂僖僞僥僭僣僮價僵儉儁儂儖儕儔儚儡儺儷儼儻儿兀兒兌兔兢竸兩兪兮冀冂囘册冉冏冑冓冕冖冤冦冢冩冪冫决冱冲冰况冽凅凉凛几處凩凭"
		],
		[
			"9980",
			"凰凵凾刄刋刔刎刧刪刮刳刹剏剄剋剌剞剔剪剴剩剳剿剽劍劔劒剱劈劑辨辧劬劭劼劵勁勍勗勞勣勦飭勠勳勵勸勹匆匈甸匍匐匏匕匚匣匯匱匳匸區卆卅丗卉卍凖卞卩卮夘卻卷厂厖厠厦厥厮厰厶參簒雙叟曼燮叮叨叭叺吁吽呀听吭吼吮吶吩吝呎咏呵咎呟呱呷呰咒呻咀呶咄咐咆哇咢咸咥咬哄哈咨"
		],
		[
			"9a40",
			"咫哂咤咾咼哘哥哦唏唔哽哮哭哺哢唹啀啣啌售啜啅啖啗唸唳啝喙喀咯喊喟啻啾喘喞單啼喃喩喇喨嗚嗅嗟嗄嗜嗤嗔嘔嗷嘖嗾嗽嘛嗹噎噐營嘴嘶嘲嘸"
		],
		[
			"9a80",
			"噫噤嘯噬噪嚆嚀嚊嚠嚔嚏嚥嚮嚶嚴囂嚼囁囃囀囈囎囑囓囗囮囹圀囿圄圉圈國圍圓團圖嗇圜圦圷圸坎圻址坏坩埀垈坡坿垉垓垠垳垤垪垰埃埆埔埒埓堊埖埣堋堙堝塲堡塢塋塰毀塒堽塹墅墹墟墫墺壞墻墸墮壅壓壑壗壙壘壥壜壤壟壯壺壹壻壼壽夂夊夐夛梦夥夬夭夲夸夾竒奕奐奎奚奘奢奠奧奬奩"
		],
		[
			"9b40",
			"奸妁妝佞侫妣妲姆姨姜妍姙姚娥娟娑娜娉娚婀婬婉娵娶婢婪媚媼媾嫋嫂媽嫣嫗嫦嫩嫖嫺嫻嬌嬋嬖嬲嫐嬪嬶嬾孃孅孀孑孕孚孛孥孩孰孳孵學斈孺宀"
		],
		[
			"9b80",
			"它宦宸寃寇寉寔寐寤實寢寞寥寫寰寶寳尅將專對尓尠尢尨尸尹屁屆屎屓屐屏孱屬屮乢屶屹岌岑岔妛岫岻岶岼岷峅岾峇峙峩峽峺峭嶌峪崋崕崗嵜崟崛崑崔崢崚崙崘嵌嵒嵎嵋嵬嵳嵶嶇嶄嶂嶢嶝嶬嶮嶽嶐嶷嶼巉巍巓巒巖巛巫已巵帋帚帙帑帛帶帷幄幃幀幎幗幔幟幢幤幇幵并幺麼广庠廁廂廈廐廏"
		],
		[
			"9c40",
			"廖廣廝廚廛廢廡廨廩廬廱廳廰廴廸廾弃弉彝彜弋弑弖弩弭弸彁彈彌彎弯彑彖彗彙彡彭彳彷徃徂彿徊很徑徇從徙徘徠徨徭徼忖忻忤忸忱忝悳忿怡恠"
		],
		[
			"9c80",
			"怙怐怩怎怱怛怕怫怦怏怺恚恁恪恷恟恊恆恍恣恃恤恂恬恫恙悁悍惧悃悚悄悛悖悗悒悧悋惡悸惠惓悴忰悽惆悵惘慍愕愆惶惷愀惴惺愃愡惻惱愍愎慇愾愨愧慊愿愼愬愴愽慂慄慳慷慘慙慚慫慴慯慥慱慟慝慓慵憙憖憇憬憔憚憊憑憫憮懌懊應懷懈懃懆憺懋罹懍懦懣懶懺懴懿懽懼懾戀戈戉戍戌戔戛"
		],
		[
			"9d40",
			"戞戡截戮戰戲戳扁扎扞扣扛扠扨扼抂抉找抒抓抖拔抃抔拗拑抻拏拿拆擔拈拜拌拊拂拇抛拉挌拮拱挧挂挈拯拵捐挾捍搜捏掖掎掀掫捶掣掏掉掟掵捫"
		],
		[
			"9d80",
			"捩掾揩揀揆揣揉插揶揄搖搴搆搓搦搶攝搗搨搏摧摯摶摎攪撕撓撥撩撈撼據擒擅擇撻擘擂擱擧舉擠擡抬擣擯攬擶擴擲擺攀擽攘攜攅攤攣攫攴攵攷收攸畋效敖敕敍敘敞敝敲數斂斃變斛斟斫斷旃旆旁旄旌旒旛旙无旡旱杲昊昃旻杳昵昶昴昜晏晄晉晁晞晝晤晧晨晟晢晰暃暈暎暉暄暘暝曁暹曉暾暼"
		],
		[
			"9e40",
			"曄暸曖曚曠昿曦曩曰曵曷朏朖朞朦朧霸朮朿朶杁朸朷杆杞杠杙杣杤枉杰枩杼杪枌枋枦枡枅枷柯枴柬枳柩枸柤柞柝柢柮枹柎柆柧檜栞框栩桀桍栲桎"
		],
		[
			"9e80",
			"梳栫桙档桷桿梟梏梭梔條梛梃檮梹桴梵梠梺椏梍桾椁棊椈棘椢椦棡椌棍棔棧棕椶椒椄棗棣椥棹棠棯椨椪椚椣椡棆楹楷楜楸楫楔楾楮椹楴椽楙椰楡楞楝榁楪榲榮槐榿槁槓榾槎寨槊槝榻槃榧樮榑榠榜榕榴槞槨樂樛槿權槹槲槧樅榱樞槭樔槫樊樒櫁樣樓橄樌橲樶橸橇橢橙橦橈樸樢檐檍檠檄檢檣"
		],
		[
			"9f40",
			"檗蘗檻櫃櫂檸檳檬櫞櫑櫟檪櫚櫪櫻欅蘖櫺欒欖鬱欟欸欷盜欹飮歇歃歉歐歙歔歛歟歡歸歹歿殀殄殃殍殘殕殞殤殪殫殯殲殱殳殷殼毆毋毓毟毬毫毳毯"
		],
		[
			"9f80",
			"麾氈氓气氛氤氣汞汕汢汪沂沍沚沁沛汾汨汳沒沐泄泱泓沽泗泅泝沮沱沾沺泛泯泙泪洟衍洶洫洽洸洙洵洳洒洌浣涓浤浚浹浙涎涕濤涅淹渕渊涵淇淦涸淆淬淞淌淨淒淅淺淙淤淕淪淮渭湮渮渙湲湟渾渣湫渫湶湍渟湃渺湎渤滿渝游溂溪溘滉溷滓溽溯滄溲滔滕溏溥滂溟潁漑灌滬滸滾漿滲漱滯漲滌"
		],
		[
			"e040",
			"漾漓滷澆潺潸澁澀潯潛濳潭澂潼潘澎澑濂潦澳澣澡澤澹濆澪濟濕濬濔濘濱濮濛瀉瀋濺瀑瀁瀏濾瀛瀚潴瀝瀘瀟瀰瀾瀲灑灣炙炒炯烱炬炸炳炮烟烋烝"
		],
		[
			"e080",
			"烙焉烽焜焙煥煕熈煦煢煌煖煬熏燻熄熕熨熬燗熹熾燒燉燔燎燠燬燧燵燼燹燿爍爐爛爨爭爬爰爲爻爼爿牀牆牋牘牴牾犂犁犇犒犖犢犧犹犲狃狆狄狎狒狢狠狡狹狷倏猗猊猜猖猝猴猯猩猥猾獎獏默獗獪獨獰獸獵獻獺珈玳珎玻珀珥珮珞璢琅瑯琥珸琲琺瑕琿瑟瑙瑁瑜瑩瑰瑣瑪瑶瑾璋璞璧瓊瓏瓔珱"
		],
		[
			"e140",
			"瓠瓣瓧瓩瓮瓲瓰瓱瓸瓷甄甃甅甌甎甍甕甓甞甦甬甼畄畍畊畉畛畆畚畩畤畧畫畭畸當疆疇畴疊疉疂疔疚疝疥疣痂疳痃疵疽疸疼疱痍痊痒痙痣痞痾痿"
		],
		[
			"e180",
			"痼瘁痰痺痲痳瘋瘍瘉瘟瘧瘠瘡瘢瘤瘴瘰瘻癇癈癆癜癘癡癢癨癩癪癧癬癰癲癶癸發皀皃皈皋皎皖皓皙皚皰皴皸皹皺盂盍盖盒盞盡盥盧盪蘯盻眈眇眄眩眤眞眥眦眛眷眸睇睚睨睫睛睥睿睾睹瞎瞋瞑瞠瞞瞰瞶瞹瞿瞼瞽瞻矇矍矗矚矜矣矮矼砌砒礦砠礪硅碎硴碆硼碚碌碣碵碪碯磑磆磋磔碾碼磅磊磬"
		],
		[
			"e240",
			"磧磚磽磴礇礒礑礙礬礫祀祠祗祟祚祕祓祺祿禊禝禧齋禪禮禳禹禺秉秕秧秬秡秣稈稍稘稙稠稟禀稱稻稾稷穃穗穉穡穢穩龝穰穹穽窈窗窕窘窖窩竈窰"
		],
		[
			"e280",
			"窶竅竄窿邃竇竊竍竏竕竓站竚竝竡竢竦竭竰笂笏笊笆笳笘笙笞笵笨笶筐筺笄筍笋筌筅筵筥筴筧筰筱筬筮箝箘箟箍箜箚箋箒箏筝箙篋篁篌篏箴篆篝篩簑簔篦篥籠簀簇簓篳篷簗簍篶簣簧簪簟簷簫簽籌籃籔籏籀籐籘籟籤籖籥籬籵粃粐粤粭粢粫粡粨粳粲粱粮粹粽糀糅糂糘糒糜糢鬻糯糲糴糶糺紆"
		],
		[
			"e340",
			"紂紜紕紊絅絋紮紲紿紵絆絳絖絎絲絨絮絏絣經綉絛綏絽綛綺綮綣綵緇綽綫總綢綯緜綸綟綰緘緝緤緞緻緲緡縅縊縣縡縒縱縟縉縋縢繆繦縻縵縹繃縷"
		],
		[
			"e380",
			"縲縺繧繝繖繞繙繚繹繪繩繼繻纃緕繽辮繿纈纉續纒纐纓纔纖纎纛纜缸缺罅罌罍罎罐网罕罔罘罟罠罨罩罧罸羂羆羃羈羇羌羔羞羝羚羣羯羲羹羮羶羸譱翅翆翊翕翔翡翦翩翳翹飜耆耄耋耒耘耙耜耡耨耿耻聊聆聒聘聚聟聢聨聳聲聰聶聹聽聿肄肆肅肛肓肚肭冐肬胛胥胙胝胄胚胖脉胯胱脛脩脣脯腋"
		],
		[
			"e440",
			"隋腆脾腓腑胼腱腮腥腦腴膃膈膊膀膂膠膕膤膣腟膓膩膰膵膾膸膽臀臂膺臉臍臑臙臘臈臚臟臠臧臺臻臾舁舂舅與舊舍舐舖舩舫舸舳艀艙艘艝艚艟艤"
		],
		[
			"e480",
			"艢艨艪艫舮艱艷艸艾芍芒芫芟芻芬苡苣苟苒苴苳苺莓范苻苹苞茆苜茉苙茵茴茖茲茱荀茹荐荅茯茫茗茘莅莚莪莟莢莖茣莎莇莊荼莵荳荵莠莉莨菴萓菫菎菽萃菘萋菁菷萇菠菲萍萢萠莽萸蔆菻葭萪萼蕚蒄葷葫蒭葮蒂葩葆萬葯葹萵蓊葢蒹蒿蒟蓙蓍蒻蓚蓐蓁蓆蓖蒡蔡蓿蓴蔗蔘蔬蔟蔕蔔蓼蕀蕣蕘蕈"
		],
		[
			"e540",
			"蕁蘂蕋蕕薀薤薈薑薊薨蕭薔薛藪薇薜蕷蕾薐藉薺藏薹藐藕藝藥藜藹蘊蘓蘋藾藺蘆蘢蘚蘰蘿虍乕虔號虧虱蚓蚣蚩蚪蚋蚌蚶蚯蛄蛆蚰蛉蠣蚫蛔蛞蛩蛬"
		],
		[
			"e580",
			"蛟蛛蛯蜒蜆蜈蜀蜃蛻蜑蜉蜍蛹蜊蜴蜿蜷蜻蜥蜩蜚蝠蝟蝸蝌蝎蝴蝗蝨蝮蝙蝓蝣蝪蠅螢螟螂螯蟋螽蟀蟐雖螫蟄螳蟇蟆螻蟯蟲蟠蠏蠍蟾蟶蟷蠎蟒蠑蠖蠕蠢蠡蠱蠶蠹蠧蠻衄衂衒衙衞衢衫袁衾袞衵衽袵衲袂袗袒袮袙袢袍袤袰袿袱裃裄裔裘裙裝裹褂裼裴裨裲褄褌褊褓襃褞褥褪褫襁襄褻褶褸襌褝襠襞"
		],
		[
			"e640",
			"襦襤襭襪襯襴襷襾覃覈覊覓覘覡覩覦覬覯覲覺覽覿觀觚觜觝觧觴觸訃訖訐訌訛訝訥訶詁詛詒詆詈詼詭詬詢誅誂誄誨誡誑誥誦誚誣諄諍諂諚諫諳諧"
		],
		[
			"e680",
			"諤諱謔諠諢諷諞諛謌謇謚諡謖謐謗謠謳鞫謦謫謾謨譁譌譏譎證譖譛譚譫譟譬譯譴譽讀讌讎讒讓讖讙讚谺豁谿豈豌豎豐豕豢豬豸豺貂貉貅貊貍貎貔豼貘戝貭貪貽貲貳貮貶賈賁賤賣賚賽賺賻贄贅贊贇贏贍贐齎贓賍贔贖赧赭赱赳趁趙跂趾趺跏跚跖跌跛跋跪跫跟跣跼踈踉跿踝踞踐踟蹂踵踰踴蹊"
		],
		[
			"e740",
			"蹇蹉蹌蹐蹈蹙蹤蹠踪蹣蹕蹶蹲蹼躁躇躅躄躋躊躓躑躔躙躪躡躬躰軆躱躾軅軈軋軛軣軼軻軫軾輊輅輕輒輙輓輜輟輛輌輦輳輻輹轅轂輾轌轉轆轎轗轜"
		],
		[
			"e780",
			"轢轣轤辜辟辣辭辯辷迚迥迢迪迯邇迴逅迹迺逑逕逡逍逞逖逋逧逶逵逹迸遏遐遑遒逎遉逾遖遘遞遨遯遶隨遲邂遽邁邀邊邉邏邨邯邱邵郢郤扈郛鄂鄒鄙鄲鄰酊酖酘酣酥酩酳酲醋醉醂醢醫醯醪醵醴醺釀釁釉釋釐釖釟釡釛釼釵釶鈞釿鈔鈬鈕鈑鉞鉗鉅鉉鉤鉈銕鈿鉋鉐銜銖銓銛鉚鋏銹銷鋩錏鋺鍄錮"
		],
		[
			"e840",
			"錙錢錚錣錺錵錻鍜鍠鍼鍮鍖鎰鎬鎭鎔鎹鏖鏗鏨鏥鏘鏃鏝鏐鏈鏤鐚鐔鐓鐃鐇鐐鐶鐫鐵鐡鐺鑁鑒鑄鑛鑠鑢鑞鑪鈩鑰鑵鑷鑽鑚鑼鑾钁鑿閂閇閊閔閖閘閙"
		],
		[
			"e880",
			"閠閨閧閭閼閻閹閾闊濶闃闍闌闕闔闖關闡闥闢阡阨阮阯陂陌陏陋陷陜陞陝陟陦陲陬隍隘隕隗險隧隱隲隰隴隶隸隹雎雋雉雍襍雜霍雕雹霄霆霈霓霎霑霏霖霙霤霪霰霹霽霾靄靆靈靂靉靜靠靤靦靨勒靫靱靹鞅靼鞁靺鞆鞋鞏鞐鞜鞨鞦鞣鞳鞴韃韆韈韋韜韭齏韲竟韶韵頏頌頸頤頡頷頽顆顏顋顫顯顰"
		],
		[
			"e940",
			"顱顴顳颪颯颱颶飄飃飆飩飫餃餉餒餔餘餡餝餞餤餠餬餮餽餾饂饉饅饐饋饑饒饌饕馗馘馥馭馮馼駟駛駝駘駑駭駮駱駲駻駸騁騏騅駢騙騫騷驅驂驀驃"
		],
		[
			"e980",
			"騾驕驍驛驗驟驢驥驤驩驫驪骭骰骼髀髏髑髓體髞髟髢髣髦髯髫髮髴髱髷髻鬆鬘鬚鬟鬢鬣鬥鬧鬨鬩鬪鬮鬯鬲魄魃魏魍魎魑魘魴鮓鮃鮑鮖鮗鮟鮠鮨鮴鯀鯊鮹鯆鯏鯑鯒鯣鯢鯤鯔鯡鰺鯲鯱鯰鰕鰔鰉鰓鰌鰆鰈鰒鰊鰄鰮鰛鰥鰤鰡鰰鱇鰲鱆鰾鱚鱠鱧鱶鱸鳧鳬鳰鴉鴈鳫鴃鴆鴪鴦鶯鴣鴟鵄鴕鴒鵁鴿鴾鵆鵈"
		],
		[
			"ea40",
			"鵝鵞鵤鵑鵐鵙鵲鶉鶇鶫鵯鵺鶚鶤鶩鶲鷄鷁鶻鶸鶺鷆鷏鷂鷙鷓鷸鷦鷭鷯鷽鸚鸛鸞鹵鹹鹽麁麈麋麌麒麕麑麝麥麩麸麪麭靡黌黎黏黐黔黜點黝黠黥黨黯"
		],
		[
			"ea80",
			"黴黶黷黹黻黼黽鼇鼈皷鼕鼡鼬鼾齊齒齔齣齟齠齡齦齧齬齪齷齲齶龕龜龠堯槇遙瑤凜熙"
		],
		[
			"ed40",
			"纊褜鍈銈蓜俉炻昱棈鋹曻彅丨仡仼伀伃伹佖侒侊侚侔俍偀倢俿倞偆偰偂傔僴僘兊兤冝冾凬刕劜劦勀勛匀匇匤卲厓厲叝﨎咜咊咩哿喆坙坥垬埈埇﨏"
		],
		[
			"ed80",
			"塚增墲夋奓奛奝奣妤妺孖寀甯寘寬尞岦岺峵崧嵓﨑嵂嵭嶸嶹巐弡弴彧德忞恝悅悊惞惕愠惲愑愷愰憘戓抦揵摠撝擎敎昀昕昻昉昮昞昤晥晗晙晴晳暙暠暲暿曺朎朗杦枻桒柀栁桄棏﨓楨﨔榘槢樰橫橆橳橾櫢櫤毖氿汜沆汯泚洄涇浯涖涬淏淸淲淼渹湜渧渼溿澈澵濵瀅瀇瀨炅炫焏焄煜煆煇凞燁燾犱"
		],
		[
			"ee40",
			"犾猤猪獷玽珉珖珣珒琇珵琦琪琩琮瑢璉璟甁畯皂皜皞皛皦益睆劯砡硎硤硺礰礼神祥禔福禛竑竧靖竫箞精絈絜綷綠緖繒罇羡羽茁荢荿菇菶葈蒴蕓蕙"
		],
		[
			"ee80",
			"蕫﨟薰蘒﨡蠇裵訒訷詹誧誾諟諸諶譓譿賰賴贒赶﨣軏﨤逸遧郞都鄕鄧釚釗釞釭釮釤釥鈆鈐鈊鈺鉀鈼鉎鉙鉑鈹鉧銧鉷鉸鋧鋗鋙鋐﨧鋕鋠鋓錥錡鋻﨨錞鋿錝錂鍰鍗鎤鏆鏞鏸鐱鑅鑈閒隆﨩隝隯霳霻靃靍靏靑靕顗顥飯飼餧館馞驎髙髜魵魲鮏鮱鮻鰀鵰鵫鶴鸙黑"
		],
		[
			"eeef",
			"ⅰ",
			9,
			"￢￤＇＂"
		],
		[
			"f040",
			"",
			62
		],
		[
			"f080",
			"",
			124
		],
		[
			"f140",
			"",
			62
		],
		[
			"f180",
			"",
			124
		],
		[
			"f240",
			"",
			62
		],
		[
			"f280",
			"",
			124
		],
		[
			"f340",
			"",
			62
		],
		[
			"f380",
			"",
			124
		],
		[
			"f440",
			"",
			62
		],
		[
			"f480",
			"",
			124
		],
		[
			"f540",
			"",
			62
		],
		[
			"f580",
			"",
			124
		],
		[
			"f640",
			"",
			62
		],
		[
			"f680",
			"",
			124
		],
		[
			"f740",
			"",
			62
		],
		[
			"f780",
			"",
			124
		],
		[
			"f840",
			"",
			62
		],
		[
			"f880",
			"",
			124
		],
		[
			"f940",
			""
		],
		[
			"fa40",
			"ⅰ",
			9,
			"Ⅰ",
			9,
			"￢￤＇＂㈱№℡∵纊褜鍈銈蓜俉炻昱棈鋹曻彅丨仡仼伀伃伹佖侒侊侚侔俍偀倢俿倞偆偰偂傔僴僘兊"
		],
		[
			"fa80",
			"兤冝冾凬刕劜劦勀勛匀匇匤卲厓厲叝﨎咜咊咩哿喆坙坥垬埈埇﨏塚增墲夋奓奛奝奣妤妺孖寀甯寘寬尞岦岺峵崧嵓﨑嵂嵭嶸嶹巐弡弴彧德忞恝悅悊惞惕愠惲愑愷愰憘戓抦揵摠撝擎敎昀昕昻昉昮昞昤晥晗晙晴晳暙暠暲暿曺朎朗杦枻桒柀栁桄棏﨓楨﨔榘槢樰橫橆橳橾櫢櫤毖氿汜沆汯泚洄涇浯"
		],
		[
			"fb40",
			"涖涬淏淸淲淼渹湜渧渼溿澈澵濵瀅瀇瀨炅炫焏焄煜煆煇凞燁燾犱犾猤猪獷玽珉珖珣珒琇珵琦琪琩琮瑢璉璟甁畯皂皜皞皛皦益睆劯砡硎硤硺礰礼神"
		],
		[
			"fb80",
			"祥禔福禛竑竧靖竫箞精絈絜綷綠緖繒罇羡羽茁荢荿菇菶葈蒴蕓蕙蕫﨟薰蘒﨡蠇裵訒訷詹誧誾諟諸諶譓譿賰賴贒赶﨣軏﨤逸遧郞都鄕鄧釚釗釞釭釮釤釥鈆鈐鈊鈺鉀鈼鉎鉙鉑鈹鉧銧鉷鉸鋧鋗鋙鋐﨧鋕鋠鋓錥錡鋻﨨錞鋿錝錂鍰鍗鎤鏆鏞鏸鐱鑅鑈閒隆﨩隝隯霳霻靃靍靏靑靕顗顥飯飼餧館馞驎髙"
		],
		[
			"fc40",
			"髜魵魲鮏鮱鮻鰀鵰鵫鶴鸙黑"
		]
	];

/***/ },
/* 31 */
/***/ function(module, exports) {

	module.exports = [
		[
			"0",
			"\u0000",
			127
		],
		[
			"8ea1",
			"｡",
			62
		],
		[
			"a1a1",
			"　、。，．・：；？！゛゜´｀¨＾￣＿ヽヾゝゞ〃仝々〆〇ー―‐／＼～∥｜…‥‘’“”（）〔〕［］｛｝〈",
			9,
			"＋－±×÷＝≠＜＞≦≧∞∴♂♀°′″℃￥＄￠￡％＃＆＊＠§☆★○●◎◇"
		],
		[
			"a2a1",
			"◆□■△▲▽▼※〒→←↑↓〓"
		],
		[
			"a2ba",
			"∈∋⊆⊇⊂⊃∪∩"
		],
		[
			"a2ca",
			"∧∨￢⇒⇔∀∃"
		],
		[
			"a2dc",
			"∠⊥⌒∂∇≡≒≪≫√∽∝∵∫∬"
		],
		[
			"a2f2",
			"Å‰♯♭♪†‡¶"
		],
		[
			"a2fe",
			"◯"
		],
		[
			"a3b0",
			"０",
			9
		],
		[
			"a3c1",
			"Ａ",
			25
		],
		[
			"a3e1",
			"ａ",
			25
		],
		[
			"a4a1",
			"ぁ",
			82
		],
		[
			"a5a1",
			"ァ",
			85
		],
		[
			"a6a1",
			"Α",
			16,
			"Σ",
			6
		],
		[
			"a6c1",
			"α",
			16,
			"σ",
			6
		],
		[
			"a7a1",
			"А",
			5,
			"ЁЖ",
			25
		],
		[
			"a7d1",
			"а",
			5,
			"ёж",
			25
		],
		[
			"a8a1",
			"─│┌┐┘└├┬┤┴┼━┃┏┓┛┗┣┳┫┻╋┠┯┨┷┿┝┰┥┸╂"
		],
		[
			"ada1",
			"①",
			19,
			"Ⅰ",
			9
		],
		[
			"adc0",
			"㍉㌔㌢㍍㌘㌧㌃㌶㍑㍗㌍㌦㌣㌫㍊㌻㎜㎝㎞㎎㎏㏄㎡"
		],
		[
			"addf",
			"㍻〝〟№㏍℡㊤",
			4,
			"㈱㈲㈹㍾㍽㍼≒≡∫∮∑√⊥∠∟⊿∵∩∪"
		],
		[
			"b0a1",
			"亜唖娃阿哀愛挨姶逢葵茜穐悪握渥旭葦芦鯵梓圧斡扱宛姐虻飴絢綾鮎或粟袷安庵按暗案闇鞍杏以伊位依偉囲夷委威尉惟意慰易椅為畏異移維緯胃萎衣謂違遺医井亥域育郁磯一壱溢逸稲茨芋鰯允印咽員因姻引飲淫胤蔭"
		],
		[
			"b1a1",
			"院陰隠韻吋右宇烏羽迂雨卯鵜窺丑碓臼渦嘘唄欝蔚鰻姥厩浦瓜閏噂云運雲荏餌叡営嬰影映曳栄永泳洩瑛盈穎頴英衛詠鋭液疫益駅悦謁越閲榎厭円園堰奄宴延怨掩援沿演炎焔煙燕猿縁艶苑薗遠鉛鴛塩於汚甥凹央奥往応"
		],
		[
			"b2a1",
			"押旺横欧殴王翁襖鴬鴎黄岡沖荻億屋憶臆桶牡乙俺卸恩温穏音下化仮何伽価佳加可嘉夏嫁家寡科暇果架歌河火珂禍禾稼箇花苛茄荷華菓蝦課嘩貨迦過霞蚊俄峨我牙画臥芽蛾賀雅餓駕介会解回塊壊廻快怪悔恢懐戒拐改"
		],
		[
			"b3a1",
			"魁晦械海灰界皆絵芥蟹開階貝凱劾外咳害崖慨概涯碍蓋街該鎧骸浬馨蛙垣柿蛎鈎劃嚇各廓拡撹格核殻獲確穫覚角赫較郭閣隔革学岳楽額顎掛笠樫橿梶鰍潟割喝恰括活渇滑葛褐轄且鰹叶椛樺鞄株兜竃蒲釜鎌噛鴨栢茅萱"
		],
		[
			"b4a1",
			"粥刈苅瓦乾侃冠寒刊勘勧巻喚堪姦完官寛干幹患感慣憾換敢柑桓棺款歓汗漢澗潅環甘監看竿管簡緩缶翰肝艦莞観諌貫還鑑間閑関陥韓館舘丸含岸巌玩癌眼岩翫贋雁頑顔願企伎危喜器基奇嬉寄岐希幾忌揮机旗既期棋棄"
		],
		[
			"b5a1",
			"機帰毅気汽畿祈季稀紀徽規記貴起軌輝飢騎鬼亀偽儀妓宜戯技擬欺犠疑祇義蟻誼議掬菊鞠吉吃喫桔橘詰砧杵黍却客脚虐逆丘久仇休及吸宮弓急救朽求汲泣灸球究窮笈級糾給旧牛去居巨拒拠挙渠虚許距鋸漁禦魚亨享京"
		],
		[
			"b6a1",
			"供侠僑兇競共凶協匡卿叫喬境峡強彊怯恐恭挟教橋況狂狭矯胸脅興蕎郷鏡響饗驚仰凝尭暁業局曲極玉桐粁僅勤均巾錦斤欣欽琴禁禽筋緊芹菌衿襟謹近金吟銀九倶句区狗玖矩苦躯駆駈駒具愚虞喰空偶寓遇隅串櫛釧屑屈"
		],
		[
			"b7a1",
			"掘窟沓靴轡窪熊隈粂栗繰桑鍬勲君薫訓群軍郡卦袈祁係傾刑兄啓圭珪型契形径恵慶慧憩掲携敬景桂渓畦稽系経継繋罫茎荊蛍計詣警軽頚鶏芸迎鯨劇戟撃激隙桁傑欠決潔穴結血訣月件倹倦健兼券剣喧圏堅嫌建憲懸拳捲"
		],
		[
			"b8a1",
			"検権牽犬献研硯絹県肩見謙賢軒遣鍵険顕験鹸元原厳幻弦減源玄現絃舷言諺限乎個古呼固姑孤己庫弧戸故枯湖狐糊袴股胡菰虎誇跨鈷雇顧鼓五互伍午呉吾娯後御悟梧檎瑚碁語誤護醐乞鯉交佼侯候倖光公功効勾厚口向"
		],
		[
			"b9a1",
			"后喉坑垢好孔孝宏工巧巷幸広庚康弘恒慌抗拘控攻昂晃更杭校梗構江洪浩港溝甲皇硬稿糠紅紘絞綱耕考肯肱腔膏航荒行衡講貢購郊酵鉱砿鋼閤降項香高鴻剛劫号合壕拷濠豪轟麹克刻告国穀酷鵠黒獄漉腰甑忽惚骨狛込"
		],
		[
			"baa1",
			"此頃今困坤墾婚恨懇昏昆根梱混痕紺艮魂些佐叉唆嵯左差査沙瑳砂詐鎖裟坐座挫債催再最哉塞妻宰彩才採栽歳済災采犀砕砦祭斎細菜裁載際剤在材罪財冴坂阪堺榊肴咲崎埼碕鷺作削咋搾昨朔柵窄策索錯桜鮭笹匙冊刷"
		],
		[
			"bba1",
			"察拶撮擦札殺薩雑皐鯖捌錆鮫皿晒三傘参山惨撒散桟燦珊産算纂蚕讃賛酸餐斬暫残仕仔伺使刺司史嗣四士始姉姿子屍市師志思指支孜斯施旨枝止死氏獅祉私糸紙紫肢脂至視詞詩試誌諮資賜雌飼歯事似侍児字寺慈持時"
		],
		[
			"bca1",
			"次滋治爾璽痔磁示而耳自蒔辞汐鹿式識鴫竺軸宍雫七叱執失嫉室悉湿漆疾質実蔀篠偲柴芝屡蕊縞舎写射捨赦斜煮社紗者謝車遮蛇邪借勺尺杓灼爵酌釈錫若寂弱惹主取守手朱殊狩珠種腫趣酒首儒受呪寿授樹綬需囚収周"
		],
		[
			"bda1",
			"宗就州修愁拾洲秀秋終繍習臭舟蒐衆襲讐蹴輯週酋酬集醜什住充十従戎柔汁渋獣縦重銃叔夙宿淑祝縮粛塾熟出術述俊峻春瞬竣舜駿准循旬楯殉淳準潤盾純巡遵醇順処初所暑曙渚庶緒署書薯藷諸助叙女序徐恕鋤除傷償"
		],
		[
			"bea1",
			"勝匠升召哨商唱嘗奨妾娼宵将小少尚庄床廠彰承抄招掌捷昇昌昭晶松梢樟樵沼消渉湘焼焦照症省硝礁祥称章笑粧紹肖菖蒋蕉衝裳訟証詔詳象賞醤鉦鍾鐘障鞘上丈丞乗冗剰城場壌嬢常情擾条杖浄状畳穣蒸譲醸錠嘱埴飾"
		],
		[
			"bfa1",
			"拭植殖燭織職色触食蝕辱尻伸信侵唇娠寝審心慎振新晋森榛浸深申疹真神秦紳臣芯薪親診身辛進針震人仁刃塵壬尋甚尽腎訊迅陣靭笥諏須酢図厨逗吹垂帥推水炊睡粋翠衰遂酔錐錘随瑞髄崇嵩数枢趨雛据杉椙菅頗雀裾"
		],
		[
			"c0a1",
			"澄摺寸世瀬畝是凄制勢姓征性成政整星晴棲栖正清牲生盛精聖声製西誠誓請逝醒青静斉税脆隻席惜戚斥昔析石積籍績脊責赤跡蹟碩切拙接摂折設窃節説雪絶舌蝉仙先千占宣専尖川戦扇撰栓栴泉浅洗染潜煎煽旋穿箭線"
		],
		[
			"c1a1",
			"繊羨腺舛船薦詮賎践選遷銭銑閃鮮前善漸然全禅繕膳糎噌塑岨措曾曽楚狙疏疎礎祖租粗素組蘇訴阻遡鼠僧創双叢倉喪壮奏爽宋層匝惣想捜掃挿掻操早曹巣槍槽漕燥争痩相窓糟総綜聡草荘葬蒼藻装走送遭鎗霜騒像増憎"
		],
		[
			"c2a1",
			"臓蔵贈造促側則即息捉束測足速俗属賊族続卒袖其揃存孫尊損村遜他多太汰詑唾堕妥惰打柁舵楕陀駄騨体堆対耐岱帯待怠態戴替泰滞胎腿苔袋貸退逮隊黛鯛代台大第醍題鷹滝瀧卓啄宅托択拓沢濯琢託鐸濁諾茸凧蛸只"
		],
		[
			"c3a1",
			"叩但達辰奪脱巽竪辿棚谷狸鱈樽誰丹単嘆坦担探旦歎淡湛炭短端箪綻耽胆蛋誕鍛団壇弾断暖檀段男談値知地弛恥智池痴稚置致蜘遅馳築畜竹筑蓄逐秩窒茶嫡着中仲宙忠抽昼柱注虫衷註酎鋳駐樗瀦猪苧著貯丁兆凋喋寵"
		],
		[
			"c4a1",
			"帖帳庁弔張彫徴懲挑暢朝潮牒町眺聴脹腸蝶調諜超跳銚長頂鳥勅捗直朕沈珍賃鎮陳津墜椎槌追鎚痛通塚栂掴槻佃漬柘辻蔦綴鍔椿潰坪壷嬬紬爪吊釣鶴亭低停偵剃貞呈堤定帝底庭廷弟悌抵挺提梯汀碇禎程締艇訂諦蹄逓"
		],
		[
			"c5a1",
			"邸鄭釘鼎泥摘擢敵滴的笛適鏑溺哲徹撤轍迭鉄典填天展店添纏甜貼転顛点伝殿澱田電兎吐堵塗妬屠徒斗杜渡登菟賭途都鍍砥砺努度土奴怒倒党冬凍刀唐塔塘套宕島嶋悼投搭東桃梼棟盗淘湯涛灯燈当痘祷等答筒糖統到"
		],
		[
			"c6a1",
			"董蕩藤討謄豆踏逃透鐙陶頭騰闘働動同堂導憧撞洞瞳童胴萄道銅峠鴇匿得徳涜特督禿篤毒独読栃橡凸突椴届鳶苫寅酉瀞噸屯惇敦沌豚遁頓呑曇鈍奈那内乍凪薙謎灘捺鍋楢馴縄畷南楠軟難汝二尼弐迩匂賑肉虹廿日乳入"
		],
		[
			"c7a1",
			"如尿韮任妊忍認濡禰祢寧葱猫熱年念捻撚燃粘乃廼之埜嚢悩濃納能脳膿農覗蚤巴把播覇杷波派琶破婆罵芭馬俳廃拝排敗杯盃牌背肺輩配倍培媒梅楳煤狽買売賠陪這蝿秤矧萩伯剥博拍柏泊白箔粕舶薄迫曝漠爆縛莫駁麦"
		],
		[
			"c8a1",
			"函箱硲箸肇筈櫨幡肌畑畠八鉢溌発醗髪伐罰抜筏閥鳩噺塙蛤隼伴判半反叛帆搬斑板氾汎版犯班畔繁般藩販範釆煩頒飯挽晩番盤磐蕃蛮匪卑否妃庇彼悲扉批披斐比泌疲皮碑秘緋罷肥被誹費避非飛樋簸備尾微枇毘琵眉美"
		],
		[
			"c9a1",
			"鼻柊稗匹疋髭彦膝菱肘弼必畢筆逼桧姫媛紐百謬俵彪標氷漂瓢票表評豹廟描病秒苗錨鋲蒜蛭鰭品彬斌浜瀕貧賓頻敏瓶不付埠夫婦富冨布府怖扶敷斧普浮父符腐膚芙譜負賦赴阜附侮撫武舞葡蕪部封楓風葺蕗伏副復幅服"
		],
		[
			"caa1",
			"福腹複覆淵弗払沸仏物鮒分吻噴墳憤扮焚奮粉糞紛雰文聞丙併兵塀幣平弊柄並蔽閉陛米頁僻壁癖碧別瞥蔑箆偏変片篇編辺返遍便勉娩弁鞭保舗鋪圃捕歩甫補輔穂募墓慕戊暮母簿菩倣俸包呆報奉宝峰峯崩庖抱捧放方朋"
		],
		[
			"cba1",
			"法泡烹砲縫胞芳萌蓬蜂褒訪豊邦鋒飽鳳鵬乏亡傍剖坊妨帽忘忙房暴望某棒冒紡肪膨謀貌貿鉾防吠頬北僕卜墨撲朴牧睦穆釦勃没殆堀幌奔本翻凡盆摩磨魔麻埋妹昧枚毎哩槙幕膜枕鮪柾鱒桝亦俣又抹末沫迄侭繭麿万慢満"
		],
		[
			"cca1",
			"漫蔓味未魅巳箕岬密蜜湊蓑稔脈妙粍民眠務夢無牟矛霧鵡椋婿娘冥名命明盟迷銘鳴姪牝滅免棉綿緬面麺摸模茂妄孟毛猛盲網耗蒙儲木黙目杢勿餅尤戻籾貰問悶紋門匁也冶夜爺耶野弥矢厄役約薬訳躍靖柳薮鑓愉愈油癒"
		],
		[
			"cda1",
			"諭輸唯佑優勇友宥幽悠憂揖有柚湧涌猶猷由祐裕誘遊邑郵雄融夕予余与誉輿預傭幼妖容庸揚揺擁曜楊様洋溶熔用窯羊耀葉蓉要謡踊遥陽養慾抑欲沃浴翌翼淀羅螺裸来莱頼雷洛絡落酪乱卵嵐欄濫藍蘭覧利吏履李梨理璃"
		],
		[
			"cea1",
			"痢裏裡里離陸律率立葎掠略劉流溜琉留硫粒隆竜龍侶慮旅虜了亮僚両凌寮料梁涼猟療瞭稜糧良諒遼量陵領力緑倫厘林淋燐琳臨輪隣鱗麟瑠塁涙累類令伶例冷励嶺怜玲礼苓鈴隷零霊麗齢暦歴列劣烈裂廉恋憐漣煉簾練聯"
		],
		[
			"cfa1",
			"蓮連錬呂魯櫓炉賂路露労婁廊弄朗楼榔浪漏牢狼篭老聾蝋郎六麓禄肋録論倭和話歪賄脇惑枠鷲亙亘鰐詫藁蕨椀湾碗腕"
		],
		[
			"d0a1",
			"弌丐丕个丱丶丼丿乂乖乘亂亅豫亊舒弍于亞亟亠亢亰亳亶从仍仄仆仂仗仞仭仟价伉佚估佛佝佗佇佶侈侏侘佻佩佰侑佯來侖儘俔俟俎俘俛俑俚俐俤俥倚倨倔倪倥倅伜俶倡倩倬俾俯們倆偃假會偕偐偈做偖偬偸傀傚傅傴傲"
		],
		[
			"d1a1",
			"僉僊傳僂僖僞僥僭僣僮價僵儉儁儂儖儕儔儚儡儺儷儼儻儿兀兒兌兔兢竸兩兪兮冀冂囘册冉冏冑冓冕冖冤冦冢冩冪冫决冱冲冰况冽凅凉凛几處凩凭凰凵凾刄刋刔刎刧刪刮刳刹剏剄剋剌剞剔剪剴剩剳剿剽劍劔劒剱劈劑辨"
		],
		[
			"d2a1",
			"辧劬劭劼劵勁勍勗勞勣勦飭勠勳勵勸勹匆匈甸匍匐匏匕匚匣匯匱匳匸區卆卅丗卉卍凖卞卩卮夘卻卷厂厖厠厦厥厮厰厶參簒雙叟曼燮叮叨叭叺吁吽呀听吭吼吮吶吩吝呎咏呵咎呟呱呷呰咒呻咀呶咄咐咆哇咢咸咥咬哄哈咨"
		],
		[
			"d3a1",
			"咫哂咤咾咼哘哥哦唏唔哽哮哭哺哢唹啀啣啌售啜啅啖啗唸唳啝喙喀咯喊喟啻啾喘喞單啼喃喩喇喨嗚嗅嗟嗄嗜嗤嗔嘔嗷嘖嗾嗽嘛嗹噎噐營嘴嘶嘲嘸噫噤嘯噬噪嚆嚀嚊嚠嚔嚏嚥嚮嚶嚴囂嚼囁囃囀囈囎囑囓囗囮囹圀囿圄圉"
		],
		[
			"d4a1",
			"圈國圍圓團圖嗇圜圦圷圸坎圻址坏坩埀垈坡坿垉垓垠垳垤垪垰埃埆埔埒埓堊埖埣堋堙堝塲堡塢塋塰毀塒堽塹墅墹墟墫墺壞墻墸墮壅壓壑壗壙壘壥壜壤壟壯壺壹壻壼壽夂夊夐夛梦夥夬夭夲夸夾竒奕奐奎奚奘奢奠奧奬奩"
		],
		[
			"d5a1",
			"奸妁妝佞侫妣妲姆姨姜妍姙姚娥娟娑娜娉娚婀婬婉娵娶婢婪媚媼媾嫋嫂媽嫣嫗嫦嫩嫖嫺嫻嬌嬋嬖嬲嫐嬪嬶嬾孃孅孀孑孕孚孛孥孩孰孳孵學斈孺宀它宦宸寃寇寉寔寐寤實寢寞寥寫寰寶寳尅將專對尓尠尢尨尸尹屁屆屎屓"
		],
		[
			"d6a1",
			"屐屏孱屬屮乢屶屹岌岑岔妛岫岻岶岼岷峅岾峇峙峩峽峺峭嶌峪崋崕崗嵜崟崛崑崔崢崚崙崘嵌嵒嵎嵋嵬嵳嵶嶇嶄嶂嶢嶝嶬嶮嶽嶐嶷嶼巉巍巓巒巖巛巫已巵帋帚帙帑帛帶帷幄幃幀幎幗幔幟幢幤幇幵并幺麼广庠廁廂廈廐廏"
		],
		[
			"d7a1",
			"廖廣廝廚廛廢廡廨廩廬廱廳廰廴廸廾弃弉彝彜弋弑弖弩弭弸彁彈彌彎弯彑彖彗彙彡彭彳彷徃徂彿徊很徑徇從徙徘徠徨徭徼忖忻忤忸忱忝悳忿怡恠怙怐怩怎怱怛怕怫怦怏怺恚恁恪恷恟恊恆恍恣恃恤恂恬恫恙悁悍惧悃悚"
		],
		[
			"d8a1",
			"悄悛悖悗悒悧悋惡悸惠惓悴忰悽惆悵惘慍愕愆惶惷愀惴惺愃愡惻惱愍愎慇愾愨愧慊愿愼愬愴愽慂慄慳慷慘慙慚慫慴慯慥慱慟慝慓慵憙憖憇憬憔憚憊憑憫憮懌懊應懷懈懃懆憺懋罹懍懦懣懶懺懴懿懽懼懾戀戈戉戍戌戔戛"
		],
		[
			"d9a1",
			"戞戡截戮戰戲戳扁扎扞扣扛扠扨扼抂抉找抒抓抖拔抃抔拗拑抻拏拿拆擔拈拜拌拊拂拇抛拉挌拮拱挧挂挈拯拵捐挾捍搜捏掖掎掀掫捶掣掏掉掟掵捫捩掾揩揀揆揣揉插揶揄搖搴搆搓搦搶攝搗搨搏摧摯摶摎攪撕撓撥撩撈撼"
		],
		[
			"daa1",
			"據擒擅擇撻擘擂擱擧舉擠擡抬擣擯攬擶擴擲擺攀擽攘攜攅攤攣攫攴攵攷收攸畋效敖敕敍敘敞敝敲數斂斃變斛斟斫斷旃旆旁旄旌旒旛旙无旡旱杲昊昃旻杳昵昶昴昜晏晄晉晁晞晝晤晧晨晟晢晰暃暈暎暉暄暘暝曁暹曉暾暼"
		],
		[
			"dba1",
			"曄暸曖曚曠昿曦曩曰曵曷朏朖朞朦朧霸朮朿朶杁朸朷杆杞杠杙杣杤枉杰枩杼杪枌枋枦枡枅枷柯枴柬枳柩枸柤柞柝柢柮枹柎柆柧檜栞框栩桀桍栲桎梳栫桙档桷桿梟梏梭梔條梛梃檮梹桴梵梠梺椏梍桾椁棊椈棘椢椦棡椌棍"
		],
		[
			"dca1",
			"棔棧棕椶椒椄棗棣椥棹棠棯椨椪椚椣椡棆楹楷楜楸楫楔楾楮椹楴椽楙椰楡楞楝榁楪榲榮槐榿槁槓榾槎寨槊槝榻槃榧樮榑榠榜榕榴槞槨樂樛槿權槹槲槧樅榱樞槭樔槫樊樒櫁樣樓橄樌橲樶橸橇橢橙橦橈樸樢檐檍檠檄檢檣"
		],
		[
			"dda1",
			"檗蘗檻櫃櫂檸檳檬櫞櫑櫟檪櫚櫪櫻欅蘖櫺欒欖鬱欟欸欷盜欹飮歇歃歉歐歙歔歛歟歡歸歹歿殀殄殃殍殘殕殞殤殪殫殯殲殱殳殷殼毆毋毓毟毬毫毳毯麾氈氓气氛氤氣汞汕汢汪沂沍沚沁沛汾汨汳沒沐泄泱泓沽泗泅泝沮沱沾"
		],
		[
			"dea1",
			"沺泛泯泙泪洟衍洶洫洽洸洙洵洳洒洌浣涓浤浚浹浙涎涕濤涅淹渕渊涵淇淦涸淆淬淞淌淨淒淅淺淙淤淕淪淮渭湮渮渙湲湟渾渣湫渫湶湍渟湃渺湎渤滿渝游溂溪溘滉溷滓溽溯滄溲滔滕溏溥滂溟潁漑灌滬滸滾漿滲漱滯漲滌"
		],
		[
			"dfa1",
			"漾漓滷澆潺潸澁澀潯潛濳潭澂潼潘澎澑濂潦澳澣澡澤澹濆澪濟濕濬濔濘濱濮濛瀉瀋濺瀑瀁瀏濾瀛瀚潴瀝瀘瀟瀰瀾瀲灑灣炙炒炯烱炬炸炳炮烟烋烝烙焉烽焜焙煥煕熈煦煢煌煖煬熏燻熄熕熨熬燗熹熾燒燉燔燎燠燬燧燵燼"
		],
		[
			"e0a1",
			"燹燿爍爐爛爨爭爬爰爲爻爼爿牀牆牋牘牴牾犂犁犇犒犖犢犧犹犲狃狆狄狎狒狢狠狡狹狷倏猗猊猜猖猝猴猯猩猥猾獎獏默獗獪獨獰獸獵獻獺珈玳珎玻珀珥珮珞璢琅瑯琥珸琲琺瑕琿瑟瑙瑁瑜瑩瑰瑣瑪瑶瑾璋璞璧瓊瓏瓔珱"
		],
		[
			"e1a1",
			"瓠瓣瓧瓩瓮瓲瓰瓱瓸瓷甄甃甅甌甎甍甕甓甞甦甬甼畄畍畊畉畛畆畚畩畤畧畫畭畸當疆疇畴疊疉疂疔疚疝疥疣痂疳痃疵疽疸疼疱痍痊痒痙痣痞痾痿痼瘁痰痺痲痳瘋瘍瘉瘟瘧瘠瘡瘢瘤瘴瘰瘻癇癈癆癜癘癡癢癨癩癪癧癬癰"
		],
		[
			"e2a1",
			"癲癶癸發皀皃皈皋皎皖皓皙皚皰皴皸皹皺盂盍盖盒盞盡盥盧盪蘯盻眈眇眄眩眤眞眥眦眛眷眸睇睚睨睫睛睥睿睾睹瞎瞋瞑瞠瞞瞰瞶瞹瞿瞼瞽瞻矇矍矗矚矜矣矮矼砌砒礦砠礪硅碎硴碆硼碚碌碣碵碪碯磑磆磋磔碾碼磅磊磬"
		],
		[
			"e3a1",
			"磧磚磽磴礇礒礑礙礬礫祀祠祗祟祚祕祓祺祿禊禝禧齋禪禮禳禹禺秉秕秧秬秡秣稈稍稘稙稠稟禀稱稻稾稷穃穗穉穡穢穩龝穰穹穽窈窗窕窘窖窩竈窰窶竅竄窿邃竇竊竍竏竕竓站竚竝竡竢竦竭竰笂笏笊笆笳笘笙笞笵笨笶筐"
		],
		[
			"e4a1",
			"筺笄筍笋筌筅筵筥筴筧筰筱筬筮箝箘箟箍箜箚箋箒箏筝箙篋篁篌篏箴篆篝篩簑簔篦篥籠簀簇簓篳篷簗簍篶簣簧簪簟簷簫簽籌籃籔籏籀籐籘籟籤籖籥籬籵粃粐粤粭粢粫粡粨粳粲粱粮粹粽糀糅糂糘糒糜糢鬻糯糲糴糶糺紆"
		],
		[
			"e5a1",
			"紂紜紕紊絅絋紮紲紿紵絆絳絖絎絲絨絮絏絣經綉絛綏絽綛綺綮綣綵緇綽綫總綢綯緜綸綟綰緘緝緤緞緻緲緡縅縊縣縡縒縱縟縉縋縢繆繦縻縵縹繃縷縲縺繧繝繖繞繙繚繹繪繩繼繻纃緕繽辮繿纈纉續纒纐纓纔纖纎纛纜缸缺"
		],
		[
			"e6a1",
			"罅罌罍罎罐网罕罔罘罟罠罨罩罧罸羂羆羃羈羇羌羔羞羝羚羣羯羲羹羮羶羸譱翅翆翊翕翔翡翦翩翳翹飜耆耄耋耒耘耙耜耡耨耿耻聊聆聒聘聚聟聢聨聳聲聰聶聹聽聿肄肆肅肛肓肚肭冐肬胛胥胙胝胄胚胖脉胯胱脛脩脣脯腋"
		],
		[
			"e7a1",
			"隋腆脾腓腑胼腱腮腥腦腴膃膈膊膀膂膠膕膤膣腟膓膩膰膵膾膸膽臀臂膺臉臍臑臙臘臈臚臟臠臧臺臻臾舁舂舅與舊舍舐舖舩舫舸舳艀艙艘艝艚艟艤艢艨艪艫舮艱艷艸艾芍芒芫芟芻芬苡苣苟苒苴苳苺莓范苻苹苞茆苜茉苙"
		],
		[
			"e8a1",
			"茵茴茖茲茱荀茹荐荅茯茫茗茘莅莚莪莟莢莖茣莎莇莊荼莵荳荵莠莉莨菴萓菫菎菽萃菘萋菁菷萇菠菲萍萢萠莽萸蔆菻葭萪萼蕚蒄葷葫蒭葮蒂葩葆萬葯葹萵蓊葢蒹蒿蒟蓙蓍蒻蓚蓐蓁蓆蓖蒡蔡蓿蓴蔗蔘蔬蔟蔕蔔蓼蕀蕣蕘蕈"
		],
		[
			"e9a1",
			"蕁蘂蕋蕕薀薤薈薑薊薨蕭薔薛藪薇薜蕷蕾薐藉薺藏薹藐藕藝藥藜藹蘊蘓蘋藾藺蘆蘢蘚蘰蘿虍乕虔號虧虱蚓蚣蚩蚪蚋蚌蚶蚯蛄蛆蚰蛉蠣蚫蛔蛞蛩蛬蛟蛛蛯蜒蜆蜈蜀蜃蛻蜑蜉蜍蛹蜊蜴蜿蜷蜻蜥蜩蜚蝠蝟蝸蝌蝎蝴蝗蝨蝮蝙"
		],
		[
			"eaa1",
			"蝓蝣蝪蠅螢螟螂螯蟋螽蟀蟐雖螫蟄螳蟇蟆螻蟯蟲蟠蠏蠍蟾蟶蟷蠎蟒蠑蠖蠕蠢蠡蠱蠶蠹蠧蠻衄衂衒衙衞衢衫袁衾袞衵衽袵衲袂袗袒袮袙袢袍袤袰袿袱裃裄裔裘裙裝裹褂裼裴裨裲褄褌褊褓襃褞褥褪褫襁襄褻褶褸襌褝襠襞"
		],
		[
			"eba1",
			"襦襤襭襪襯襴襷襾覃覈覊覓覘覡覩覦覬覯覲覺覽覿觀觚觜觝觧觴觸訃訖訐訌訛訝訥訶詁詛詒詆詈詼詭詬詢誅誂誄誨誡誑誥誦誚誣諄諍諂諚諫諳諧諤諱謔諠諢諷諞諛謌謇謚諡謖謐謗謠謳鞫謦謫謾謨譁譌譏譎證譖譛譚譫"
		],
		[
			"eca1",
			"譟譬譯譴譽讀讌讎讒讓讖讙讚谺豁谿豈豌豎豐豕豢豬豸豺貂貉貅貊貍貎貔豼貘戝貭貪貽貲貳貮貶賈賁賤賣賚賽賺賻贄贅贊贇贏贍贐齎贓賍贔贖赧赭赱赳趁趙跂趾趺跏跚跖跌跛跋跪跫跟跣跼踈踉跿踝踞踐踟蹂踵踰踴蹊"
		],
		[
			"eda1",
			"蹇蹉蹌蹐蹈蹙蹤蹠踪蹣蹕蹶蹲蹼躁躇躅躄躋躊躓躑躔躙躪躡躬躰軆躱躾軅軈軋軛軣軼軻軫軾輊輅輕輒輙輓輜輟輛輌輦輳輻輹轅轂輾轌轉轆轎轗轜轢轣轤辜辟辣辭辯辷迚迥迢迪迯邇迴逅迹迺逑逕逡逍逞逖逋逧逶逵逹迸"
		],
		[
			"eea1",
			"遏遐遑遒逎遉逾遖遘遞遨遯遶隨遲邂遽邁邀邊邉邏邨邯邱邵郢郤扈郛鄂鄒鄙鄲鄰酊酖酘酣酥酩酳酲醋醉醂醢醫醯醪醵醴醺釀釁釉釋釐釖釟釡釛釼釵釶鈞釿鈔鈬鈕鈑鉞鉗鉅鉉鉤鉈銕鈿鉋鉐銜銖銓銛鉚鋏銹銷鋩錏鋺鍄錮"
		],
		[
			"efa1",
			"錙錢錚錣錺錵錻鍜鍠鍼鍮鍖鎰鎬鎭鎔鎹鏖鏗鏨鏥鏘鏃鏝鏐鏈鏤鐚鐔鐓鐃鐇鐐鐶鐫鐵鐡鐺鑁鑒鑄鑛鑠鑢鑞鑪鈩鑰鑵鑷鑽鑚鑼鑾钁鑿閂閇閊閔閖閘閙閠閨閧閭閼閻閹閾闊濶闃闍闌闕闔闖關闡闥闢阡阨阮阯陂陌陏陋陷陜陞"
		],
		[
			"f0a1",
			"陝陟陦陲陬隍隘隕隗險隧隱隲隰隴隶隸隹雎雋雉雍襍雜霍雕雹霄霆霈霓霎霑霏霖霙霤霪霰霹霽霾靄靆靈靂靉靜靠靤靦靨勒靫靱靹鞅靼鞁靺鞆鞋鞏鞐鞜鞨鞦鞣鞳鞴韃韆韈韋韜韭齏韲竟韶韵頏頌頸頤頡頷頽顆顏顋顫顯顰"
		],
		[
			"f1a1",
			"顱顴顳颪颯颱颶飄飃飆飩飫餃餉餒餔餘餡餝餞餤餠餬餮餽餾饂饉饅饐饋饑饒饌饕馗馘馥馭馮馼駟駛駝駘駑駭駮駱駲駻駸騁騏騅駢騙騫騷驅驂驀驃騾驕驍驛驗驟驢驥驤驩驫驪骭骰骼髀髏髑髓體髞髟髢髣髦髯髫髮髴髱髷"
		],
		[
			"f2a1",
			"髻鬆鬘鬚鬟鬢鬣鬥鬧鬨鬩鬪鬮鬯鬲魄魃魏魍魎魑魘魴鮓鮃鮑鮖鮗鮟鮠鮨鮴鯀鯊鮹鯆鯏鯑鯒鯣鯢鯤鯔鯡鰺鯲鯱鯰鰕鰔鰉鰓鰌鰆鰈鰒鰊鰄鰮鰛鰥鰤鰡鰰鱇鰲鱆鰾鱚鱠鱧鱶鱸鳧鳬鳰鴉鴈鳫鴃鴆鴪鴦鶯鴣鴟鵄鴕鴒鵁鴿鴾鵆鵈"
		],
		[
			"f3a1",
			"鵝鵞鵤鵑鵐鵙鵲鶉鶇鶫鵯鵺鶚鶤鶩鶲鷄鷁鶻鶸鶺鷆鷏鷂鷙鷓鷸鷦鷭鷯鷽鸚鸛鸞鹵鹹鹽麁麈麋麌麒麕麑麝麥麩麸麪麭靡黌黎黏黐黔黜點黝黠黥黨黯黴黶黷黹黻黼黽鼇鼈皷鼕鼡鼬鼾齊齒齔齣齟齠齡齦齧齬齪齷齲齶龕龜龠"
		],
		[
			"f4a1",
			"堯槇遙瑤凜熙"
		],
		[
			"f9a1",
			"纊褜鍈銈蓜俉炻昱棈鋹曻彅丨仡仼伀伃伹佖侒侊侚侔俍偀倢俿倞偆偰偂傔僴僘兊兤冝冾凬刕劜劦勀勛匀匇匤卲厓厲叝﨎咜咊咩哿喆坙坥垬埈埇﨏塚增墲夋奓奛奝奣妤妺孖寀甯寘寬尞岦岺峵崧嵓﨑嵂嵭嶸嶹巐弡弴彧德"
		],
		[
			"faa1",
			"忞恝悅悊惞惕愠惲愑愷愰憘戓抦揵摠撝擎敎昀昕昻昉昮昞昤晥晗晙晴晳暙暠暲暿曺朎朗杦枻桒柀栁桄棏﨓楨﨔榘槢樰橫橆橳橾櫢櫤毖氿汜沆汯泚洄涇浯涖涬淏淸淲淼渹湜渧渼溿澈澵濵瀅瀇瀨炅炫焏焄煜煆煇凞燁燾犱"
		],
		[
			"fba1",
			"犾猤猪獷玽珉珖珣珒琇珵琦琪琩琮瑢璉璟甁畯皂皜皞皛皦益睆劯砡硎硤硺礰礼神祥禔福禛竑竧靖竫箞精絈絜綷綠緖繒罇羡羽茁荢荿菇菶葈蒴蕓蕙蕫﨟薰蘒﨡蠇裵訒訷詹誧誾諟諸諶譓譿賰賴贒赶﨣軏﨤逸遧郞都鄕鄧釚"
		],
		[
			"fca1",
			"釗釞釭釮釤釥鈆鈐鈊鈺鉀鈼鉎鉙鉑鈹鉧銧鉷鉸鋧鋗鋙鋐﨧鋕鋠鋓錥錡鋻﨨錞鋿錝錂鍰鍗鎤鏆鏞鏸鐱鑅鑈閒隆﨩隝隯霳霻靃靍靏靑靕顗顥飯飼餧館馞驎髙髜魵魲鮏鮱鮻鰀鵰鵫鶴鸙黑"
		],
		[
			"fcf1",
			"ⅰ",
			9,
			"￢￤＇＂"
		],
		[
			"8fa2af",
			"˘ˇ¸˙˝¯˛˚～΄΅"
		],
		[
			"8fa2c2",
			"¡¦¿"
		],
		[
			"8fa2eb",
			"ºª©®™¤№"
		],
		[
			"8fa6e1",
			"ΆΈΉΊΪ"
		],
		[
			"8fa6e7",
			"Ό"
		],
		[
			"8fa6e9",
			"ΎΫ"
		],
		[
			"8fa6ec",
			"Ώ"
		],
		[
			"8fa6f1",
			"άέήίϊΐόςύϋΰώ"
		],
		[
			"8fa7c2",
			"Ђ",
			10,
			"ЎЏ"
		],
		[
			"8fa7f2",
			"ђ",
			10,
			"ўџ"
		],
		[
			"8fa9a1",
			"ÆĐ"
		],
		[
			"8fa9a4",
			"Ħ"
		],
		[
			"8fa9a6",
			"Ĳ"
		],
		[
			"8fa9a8",
			"ŁĿ"
		],
		[
			"8fa9ab",
			"ŊØŒ"
		],
		[
			"8fa9af",
			"ŦÞ"
		],
		[
			"8fa9c1",
			"æđðħıĳĸłŀŉŋøœßŧþ"
		],
		[
			"8faaa1",
			"ÁÀÄÂĂǍĀĄÅÃĆĈČÇĊĎÉÈËÊĚĖĒĘ"
		],
		[
			"8faaba",
			"ĜĞĢĠĤÍÌÏÎǏİĪĮĨĴĶĹĽĻŃŇŅÑÓÒÖÔǑŐŌÕŔŘŖŚŜŠŞŤŢÚÙÜÛŬǓŰŪŲŮŨǗǛǙǕŴÝŸŶŹŽŻ"
		],
		[
			"8faba1",
			"áàäâăǎāąåãćĉčçċďéèëêěėēęǵĝğ"
		],
		[
			"8fabbd",
			"ġĥíìïîǐ"
		],
		[
			"8fabc5",
			"īįĩĵķĺľļńňņñóòöôǒőōõŕřŗśŝšşťţúùüûŭǔűūųůũǘǜǚǖŵýÿŷźžż"
		],
		[
			"8fb0a1",
			"丂丄丅丌丒丟丣两丨丫丮丯丰丵乀乁乄乇乑乚乜乣乨乩乴乵乹乿亍亖亗亝亯亹仃仐仚仛仠仡仢仨仯仱仳仵份仾仿伀伂伃伈伋伌伒伕伖众伙伮伱你伳伵伷伹伻伾佀佂佈佉佋佌佒佔佖佘佟佣佪佬佮佱佷佸佹佺佽佾侁侂侄"
		],
		[
			"8fb1a1",
			"侅侉侊侌侎侐侒侓侔侗侙侚侞侟侲侷侹侻侼侽侾俀俁俅俆俈俉俋俌俍俏俒俜俠俢俰俲俼俽俿倀倁倄倇倊倌倎倐倓倗倘倛倜倝倞倢倧倮倰倲倳倵偀偁偂偅偆偊偌偎偑偒偓偗偙偟偠偢偣偦偧偪偭偰偱倻傁傃傄傆傊傎傏傐"
		],
		[
			"8fb2a1",
			"傒傓傔傖傛傜傞",
			4,
			"傪傯傰傹傺傽僀僃僄僇僌僎僐僓僔僘僜僝僟僢僤僦僨僩僯僱僶僺僾儃儆儇儈儋儌儍儎僲儐儗儙儛儜儝儞儣儧儨儬儭儯儱儳儴儵儸儹兂兊兏兓兕兗兘兟兤兦兾冃冄冋冎冘冝冡冣冭冸冺冼冾冿凂"
		],
		[
			"8fb3a1",
			"凈减凑凒凓凕凘凞凢凥凮凲凳凴凷刁刂刅划刓刕刖刘刢刨刱刲刵刼剅剉剕剗剘剚剜剟剠剡剦剮剷剸剹劀劂劅劊劌劓劕劖劗劘劚劜劤劥劦劧劯劰劶劷劸劺劻劽勀勄勆勈勌勏勑勔勖勛勜勡勥勨勩勪勬勰勱勴勶勷匀匃匊匋"
		],
		[
			"8fb4a1",
			"匌匑匓匘匛匜匞匟匥匧匨匩匫匬匭匰匲匵匼匽匾卂卌卋卙卛卡卣卥卬卭卲卹卾厃厇厈厎厓厔厙厝厡厤厪厫厯厲厴厵厷厸厺厽叀叅叏叒叓叕叚叝叞叠另叧叵吂吓吚吡吧吨吪启吱吴吵呃呄呇呍呏呞呢呤呦呧呩呫呭呮呴呿"
		],
		[
			"8fb5a1",
			"咁咃咅咈咉咍咑咕咖咜咟咡咦咧咩咪咭咮咱咷咹咺咻咿哆哊响哎哠哪哬哯哶哼哾哿唀唁唅唈唉唌唍唎唕唪唫唲唵唶唻唼唽啁啇啉啊啍啐啑啘啚啛啞啠啡啤啦啿喁喂喆喈喎喏喑喒喓喔喗喣喤喭喲喿嗁嗃嗆嗉嗋嗌嗎嗑嗒"
		],
		[
			"8fb6a1",
			"嗓嗗嗘嗛嗞嗢嗩嗶嗿嘅嘈嘊嘍",
			5,
			"嘙嘬嘰嘳嘵嘷嘹嘻嘼嘽嘿噀噁噃噄噆噉噋噍噏噔噞噠噡噢噣噦噩噭噯噱噲噵嚄嚅嚈嚋嚌嚕嚙嚚嚝嚞嚟嚦嚧嚨嚩嚫嚬嚭嚱嚳嚷嚾囅囉囊囋囏囐囌囍囙囜囝囟囡囤",
			4,
			"囱囫园"
		],
		[
			"8fb7a1",
			"囶囷圁圂圇圊圌圑圕圚圛圝圠圢圣圤圥圩圪圬圮圯圳圴圽圾圿坅坆坌坍坒坢坥坧坨坫坭",
			4,
			"坳坴坵坷坹坺坻坼坾垁垃垌垔垗垙垚垜垝垞垟垡垕垧垨垩垬垸垽埇埈埌埏埕埝埞埤埦埧埩埭埰埵埶埸埽埾埿堃堄堈堉埡"
		],
		[
			"8fb8a1",
			"堌堍堛堞堟堠堦堧堭堲堹堿塉塌塍塏塐塕塟塡塤塧塨塸塼塿墀墁墇墈墉墊墌墍墏墐墔墖墝墠墡墢墦墩墱墲壄墼壂壈壍壎壐壒壔壖壚壝壡壢壩壳夅夆夋夌夒夓夔虁夝夡夣夤夨夯夰夳夵夶夿奃奆奒奓奙奛奝奞奟奡奣奫奭"
		],
		[
			"8fb9a1",
			"奯奲奵奶她奻奼妋妌妎妒妕妗妟妤妧妭妮妯妰妳妷妺妼姁姃姄姈姊姍姒姝姞姟姣姤姧姮姯姱姲姴姷娀娄娌娍娎娒娓娞娣娤娧娨娪娭娰婄婅婇婈婌婐婕婞婣婥婧婭婷婺婻婾媋媐媓媖媙媜媞媟媠媢媧媬媱媲媳媵媸媺媻媿"
		],
		[
			"8fbaa1",
			"嫄嫆嫈嫏嫚嫜嫠嫥嫪嫮嫵嫶嫽嬀嬁嬈嬗嬴嬙嬛嬝嬡嬥嬭嬸孁孋孌孒孖孞孨孮孯孼孽孾孿宁宄宆宊宎宐宑宓宔宖宨宩宬宭宯宱宲宷宺宼寀寁寍寏寖",
			4,
			"寠寯寱寴寽尌尗尞尟尣尦尩尫尬尮尰尲尵尶屙屚屜屢屣屧屨屩"
		],
		[
			"8fbba1",
			"屭屰屴屵屺屻屼屽岇岈岊岏岒岝岟岠岢岣岦岪岲岴岵岺峉峋峒峝峗峮峱峲峴崁崆崍崒崫崣崤崦崧崱崴崹崽崿嵂嵃嵆嵈嵕嵑嵙嵊嵟嵠嵡嵢嵤嵪嵭嵰嵹嵺嵾嵿嶁嶃嶈嶊嶒嶓嶔嶕嶙嶛嶟嶠嶧嶫嶰嶴嶸嶹巃巇巋巐巎巘巙巠巤"
		],
		[
			"8fbca1",
			"巩巸巹帀帇帍帒帔帕帘帟帠帮帨帲帵帾幋幐幉幑幖幘幛幜幞幨幪",
			4,
			"幰庀庋庎庢庤庥庨庪庬庱庳庽庾庿廆廌廋廎廑廒廔廕廜廞廥廫异弆弇弈弎弙弜弝弡弢弣弤弨弫弬弮弰弴弶弻弽弿彀彄彅彇彍彐彔彘彛彠彣彤彧"
		],
		[
			"8fbda1",
			"彯彲彴彵彸彺彽彾徉徍徏徖徜徝徢徧徫徤徬徯徰徱徸忄忇忈忉忋忐",
			4,
			"忞忡忢忨忩忪忬忭忮忯忲忳忶忺忼怇怊怍怓怔怗怘怚怟怤怭怳怵恀恇恈恉恌恑恔恖恗恝恡恧恱恾恿悂悆悈悊悎悑悓悕悘悝悞悢悤悥您悰悱悷"
		],
		[
			"8fbea1",
			"悻悾惂惄惈惉惊惋惎惏惔惕惙惛惝惞惢惥惲惵惸惼惽愂愇愊愌愐",
			4,
			"愖愗愙愜愞愢愪愫愰愱愵愶愷愹慁慅慆慉慞慠慬慲慸慻慼慿憀憁憃憄憋憍憒憓憗憘憜憝憟憠憥憨憪憭憸憹憼懀懁懂懎懏懕懜懝懞懟懡懢懧懩懥"
		],
		[
			"8fbfa1",
			"懬懭懯戁戃戄戇戓戕戜戠戢戣戧戩戫戹戽扂扃扄扆扌扐扑扒扔扖扚扜扤扭扯扳扺扽抍抎抏抐抦抨抳抶抷抺抾抿拄拎拕拖拚拪拲拴拼拽挃挄挊挋挍挐挓挖挘挩挪挭挵挶挹挼捁捂捃捄捆捊捋捎捒捓捔捘捛捥捦捬捭捱捴捵"
		],
		[
			"8fc0a1",
			"捸捼捽捿掂掄掇掊掐掔掕掙掚掞掤掦掭掮掯掽揁揅揈揎揑揓揔揕揜揠揥揪揬揲揳揵揸揹搉搊搐搒搔搘搞搠搢搤搥搩搪搯搰搵搽搿摋摏摑摒摓摔摚摛摜摝摟摠摡摣摭摳摴摻摽撅撇撏撐撑撘撙撛撝撟撡撣撦撨撬撳撽撾撿"
		],
		[
			"8fc1a1",
			"擄擉擊擋擌擎擐擑擕擗擤擥擩擪擭擰擵擷擻擿攁攄攈攉攊攏攓攔攖攙攛攞攟攢攦攩攮攱攺攼攽敃敇敉敐敒敔敟敠敧敫敺敽斁斅斊斒斕斘斝斠斣斦斮斲斳斴斿旂旈旉旎旐旔旖旘旟旰旲旴旵旹旾旿昀昄昈昉昍昑昒昕昖昝"
		],
		[
			"8fc2a1",
			"昞昡昢昣昤昦昩昪昫昬昮昰昱昳昹昷晀晅晆晊晌晑晎晗晘晙晛晜晠晡曻晪晫晬晾晳晵晿晷晸晹晻暀晼暋暌暍暐暒暙暚暛暜暟暠暤暭暱暲暵暻暿曀曂曃曈曌曎曏曔曛曟曨曫曬曮曺朅朇朎朓朙朜朠朢朳朾杅杇杈杌杔杕杝"
		],
		[
			"8fc3a1",
			"杦杬杮杴杶杻极构枎枏枑枓枖枘枙枛枰枱枲枵枻枼枽柹柀柂柃柅柈柉柒柗柙柜柡柦柰柲柶柷桒栔栙栝栟栨栧栬栭栯栰栱栳栻栿桄桅桊桌桕桗桘桛桫桮",
			4,
			"桵桹桺桻桼梂梄梆梈梖梘梚梜梡梣梥梩梪梮梲梻棅棈棌棏"
		],
		[
			"8fc4a1",
			"棐棑棓棖棙棜棝棥棨棪棫棬棭棰棱棵棶棻棼棽椆椉椊椐椑椓椖椗椱椳椵椸椻楂楅楉楎楗楛楣楤楥楦楨楩楬楰楱楲楺楻楿榀榍榒榖榘榡榥榦榨榫榭榯榷榸榺榼槅槈槑槖槗槢槥槮槯槱槳槵槾樀樁樃樏樑樕樚樝樠樤樨樰樲"
		],
		[
			"8fc5a1",
			"樴樷樻樾樿橅橆橉橊橎橐橑橒橕橖橛橤橧橪橱橳橾檁檃檆檇檉檋檑檛檝檞檟檥檫檯檰檱檴檽檾檿櫆櫉櫈櫌櫐櫔櫕櫖櫜櫝櫤櫧櫬櫰櫱櫲櫼櫽欂欃欆欇欉欏欐欑欗欛欞欤欨欫欬欯欵欶欻欿歆歊歍歒歖歘歝歠歧歫歮歰歵歽"
		],
		[
			"8fc6a1",
			"歾殂殅殗殛殟殠殢殣殨殩殬殭殮殰殸殹殽殾毃毄毉毌毖毚毡毣毦毧毮毱毷毹毿氂氄氅氉氍氎氐氒氙氟氦氧氨氬氮氳氵氶氺氻氿汊汋汍汏汒汔汙汛汜汫汭汯汴汶汸汹汻沅沆沇沉沔沕沗沘沜沟沰沲沴泂泆泍泏泐泑泒泔泖"
		],
		[
			"8fc7a1",
			"泚泜泠泧泩泫泬泮泲泴洄洇洊洎洏洑洓洚洦洧洨汧洮洯洱洹洼洿浗浞浟浡浥浧浯浰浼涂涇涑涒涔涖涗涘涪涬涴涷涹涽涿淄淈淊淎淏淖淛淝淟淠淢淥淩淯淰淴淶淼渀渄渞渢渧渲渶渹渻渼湄湅湈湉湋湏湑湒湓湔湗湜湝湞"
		],
		[
			"8fc8a1",
			"湢湣湨湳湻湽溍溓溙溠溧溭溮溱溳溻溿滀滁滃滇滈滊滍滎滏滫滭滮滹滻滽漄漈漊漌漍漖漘漚漛漦漩漪漯漰漳漶漻漼漭潏潑潒潓潗潙潚潝潞潡潢潨潬潽潾澃澇澈澋澌澍澐澒澓澔澖澚澟澠澥澦澧澨澮澯澰澵澶澼濅濇濈濊"
		],
		[
			"8fc9a1",
			"濚濞濨濩濰濵濹濼濽瀀瀅瀆瀇瀍瀗瀠瀣瀯瀴瀷瀹瀼灃灄灈灉灊灋灔灕灝灞灎灤灥灬灮灵灶灾炁炅炆炔",
			4,
			"炛炤炫炰炱炴炷烊烑烓烔烕烖烘烜烤烺焃",
			4,
			"焋焌焏焞焠焫焭焯焰焱焸煁煅煆煇煊煋煐煒煗煚煜煞煠"
		],
		[
			"8fcaa1",
			"煨煹熀熅熇熌熒熚熛熠熢熯熰熲熳熺熿燀燁燄燋燌燓燖燙燚燜燸燾爀爇爈爉爓爗爚爝爟爤爫爯爴爸爹牁牂牃牅牎牏牐牓牕牖牚牜牞牠牣牨牫牮牯牱牷牸牻牼牿犄犉犍犎犓犛犨犭犮犱犴犾狁狇狉狌狕狖狘狟狥狳狴狺狻"
		],
		[
			"8fcba1",
			"狾猂猄猅猇猋猍猒猓猘猙猞猢猤猧猨猬猱猲猵猺猻猽獃獍獐獒獖獘獝獞獟獠獦獧獩獫獬獮獯獱獷獹獼玀玁玃玅玆玎玐玓玕玗玘玜玞玟玠玢玥玦玪玫玭玵玷玹玼玽玿珅珆珉珋珌珏珒珓珖珙珝珡珣珦珧珩珴珵珷珹珺珻珽"
		],
		[
			"8fcca1",
			"珿琀琁琄琇琊琑琚琛琤琦琨",
			9,
			"琹瑀瑃瑄瑆瑇瑋瑍瑑瑒瑗瑝瑢瑦瑧瑨瑫瑭瑮瑱瑲璀璁璅璆璇璉璏璐璑璒璘璙璚璜璟璠璡璣璦璨璩璪璫璮璯璱璲璵璹璻璿瓈瓉瓌瓐瓓瓘瓚瓛瓞瓟瓤瓨瓪瓫瓯瓴瓺瓻瓼瓿甆"
		],
		[
			"8fcda1",
			"甒甖甗甠甡甤甧甩甪甯甶甹甽甾甿畀畃畇畈畎畐畒畗畞畟畡畯畱畹",
			5,
			"疁疅疐疒疓疕疙疜疢疤疴疺疿痀痁痄痆痌痎痏痗痜痟痠痡痤痧痬痮痯痱痹瘀瘂瘃瘄瘇瘈瘊瘌瘏瘒瘓瘕瘖瘙瘛瘜瘝瘞瘣瘥瘦瘩瘭瘲瘳瘵瘸瘹"
		],
		[
			"8fcea1",
			"瘺瘼癊癀癁癃癄癅癉癋癕癙癟癤癥癭癮癯癱癴皁皅皌皍皕皛皜皝皟皠皢",
			6,
			"皪皭皽盁盅盉盋盌盎盔盙盠盦盨盬盰盱盶盹盼眀眆眊眎眒眔眕眗眙眚眜眢眨眭眮眯眴眵眶眹眽眾睂睅睆睊睍睎睏睒睖睗睜睞睟睠睢"
		],
		[
			"8fcfa1",
			"睤睧睪睬睰睲睳睴睺睽瞀瞄瞌瞍瞔瞕瞖瞚瞟瞢瞧瞪瞮瞯瞱瞵瞾矃矉矑矒矕矙矞矟矠矤矦矪矬矰矱矴矸矻砅砆砉砍砎砑砝砡砢砣砭砮砰砵砷硃硄硇硈硌硎硒硜硞硠硡硣硤硨硪确硺硾碊碏碔碘碡碝碞碟碤碨碬碭碰碱碲碳"
		],
		[
			"8fd0a1",
			"碻碽碿磇磈磉磌磎磒磓磕磖磤磛磟磠磡磦磪磲磳礀磶磷磺磻磿礆礌礐礚礜礞礟礠礥礧礩礭礱礴礵礻礽礿祄祅祆祊祋祏祑祔祘祛祜祧祩祫祲祹祻祼祾禋禌禑禓禔禕禖禘禛禜禡禨禩禫禯禱禴禸离秂秄秇秈秊秏秔秖秚秝秞"
		],
		[
			"8fd1a1",
			"秠秢秥秪秫秭秱秸秼稂稃稇稉稊稌稑稕稛稞稡稧稫稭稯稰稴稵稸稹稺穄穅穇穈穌穕穖穙穜穝穟穠穥穧穪穭穵穸穾窀窂窅窆窊窋窐窑窔窞窠窣窬窳窵窹窻窼竆竉竌竎竑竛竨竩竫竬竱竴竻竽竾笇笔笟笣笧笩笪笫笭笮笯笰"
		],
		[
			"8fd2a1",
			"笱笴笽笿筀筁筇筎筕筠筤筦筩筪筭筯筲筳筷箄箉箎箐箑箖箛箞箠箥箬箯箰箲箵箶箺箻箼箽篂篅篈篊篔篖篗篙篚篛篨篪篲篴篵篸篹篺篼篾簁簂簃簄簆簉簋簌簎簏簙簛簠簥簦簨簬簱簳簴簶簹簺籆籊籕籑籒籓籙",
			5
		],
		[
			"8fd3a1",
			"籡籣籧籩籭籮籰籲籹籼籽粆粇粏粔粞粠粦粰粶粷粺粻粼粿糄糇糈糉糍糏糓糔糕糗糙糚糝糦糩糫糵紃紇紈紉紏紑紒紓紖紝紞紣紦紪紭紱紼紽紾絀絁絇絈絍絑絓絗絙絚絜絝絥絧絪絰絸絺絻絿綁綂綃綅綆綈綋綌綍綑綖綗綝"
		],
		[
			"8fd4a1",
			"綞綦綧綪綳綶綷綹緂",
			4,
			"緌緍緎緗緙縀緢緥緦緪緫緭緱緵緶緹緺縈縐縑縕縗縜縝縠縧縨縬縭縯縳縶縿繄繅繇繎繐繒繘繟繡繢繥繫繮繯繳繸繾纁纆纇纊纍纑纕纘纚纝纞缼缻缽缾缿罃罄罇罏罒罓罛罜罝罡罣罤罥罦罭"
		],
		[
			"8fd5a1",
			"罱罽罾罿羀羋羍羏羐羑羖羗羜羡羢羦羪羭羴羼羿翀翃翈翎翏翛翟翣翥翨翬翮翯翲翺翽翾翿耇耈耊耍耎耏耑耓耔耖耝耞耟耠耤耦耬耮耰耴耵耷耹耺耼耾聀聄聠聤聦聭聱聵肁肈肎肜肞肦肧肫肸肹胈胍胏胒胔胕胗胘胠胭胮"
		],
		[
			"8fd6a1",
			"胰胲胳胶胹胺胾脃脋脖脗脘脜脞脠脤脧脬脰脵脺脼腅腇腊腌腒腗腠腡腧腨腩腭腯腷膁膐膄膅膆膋膎膖膘膛膞膢膮膲膴膻臋臃臅臊臎臏臕臗臛臝臞臡臤臫臬臰臱臲臵臶臸臹臽臿舀舃舏舓舔舙舚舝舡舢舨舲舴舺艃艄艅艆"
		],
		[
			"8fd7a1",
			"艋艎艏艑艖艜艠艣艧艭艴艻艽艿芀芁芃芄芇芉芊芎芑芔芖芘芚芛芠芡芣芤芧芨芩芪芮芰芲芴芷芺芼芾芿苆苐苕苚苠苢苤苨苪苭苯苶苷苽苾茀茁茇茈茊茋荔茛茝茞茟茡茢茬茭茮茰茳茷茺茼茽荂荃荄荇荍荎荑荕荖荗荰荸"
		],
		[
			"8fd8a1",
			"荽荿莀莂莄莆莍莒莔莕莘莙莛莜莝莦莧莩莬莾莿菀菇菉菏菐菑菔菝荓菨菪菶菸菹菼萁萆萊萏萑萕萙莭萯萹葅葇葈葊葍葏葑葒葖葘葙葚葜葠葤葥葧葪葰葳葴葶葸葼葽蒁蒅蒒蒓蒕蒞蒦蒨蒩蒪蒯蒱蒴蒺蒽蒾蓀蓂蓇蓈蓌蓏蓓"
		],
		[
			"8fd9a1",
			"蓜蓧蓪蓯蓰蓱蓲蓷蔲蓺蓻蓽蔂蔃蔇蔌蔎蔐蔜蔞蔢蔣蔤蔥蔧蔪蔫蔯蔳蔴蔶蔿蕆蕏",
			4,
			"蕖蕙蕜",
			6,
			"蕤蕫蕯蕹蕺蕻蕽蕿薁薅薆薉薋薌薏薓薘薝薟薠薢薥薧薴薶薷薸薼薽薾薿藂藇藊藋藎薭藘藚藟藠藦藨藭藳藶藼"
		],
		[
			"8fdaa1",
			"藿蘀蘄蘅蘍蘎蘐蘑蘒蘘蘙蘛蘞蘡蘧蘩蘶蘸蘺蘼蘽虀虂虆虒虓虖虗虘虙虝虠",
			4,
			"虩虬虯虵虶虷虺蚍蚑蚖蚘蚚蚜蚡蚦蚧蚨蚭蚱蚳蚴蚵蚷蚸蚹蚿蛀蛁蛃蛅蛑蛒蛕蛗蛚蛜蛠蛣蛥蛧蚈蛺蛼蛽蜄蜅蜇蜋蜎蜏蜐蜓蜔蜙蜞蜟蜡蜣"
		],
		[
			"8fdba1",
			"蜨蜮蜯蜱蜲蜹蜺蜼蜽蜾蝀蝃蝅蝍蝘蝝蝡蝤蝥蝯蝱蝲蝻螃",
			6,
			"螋螌螐螓螕螗螘螙螞螠螣螧螬螭螮螱螵螾螿蟁蟈蟉蟊蟎蟕蟖蟙蟚蟜蟟蟢蟣蟤蟪蟫蟭蟱蟳蟸蟺蟿蠁蠃蠆蠉蠊蠋蠐蠙蠒蠓蠔蠘蠚蠛蠜蠞蠟蠨蠭蠮蠰蠲蠵"
		],
		[
			"8fdca1",
			"蠺蠼衁衃衅衈衉衊衋衎衑衕衖衘衚衜衟衠衤衩衱衹衻袀袘袚袛袜袟袠袨袪袺袽袾裀裊",
			4,
			"裑裒裓裛裞裧裯裰裱裵裷褁褆褍褎褏褕褖褘褙褚褜褠褦褧褨褰褱褲褵褹褺褾襀襂襅襆襉襏襒襗襚襛襜襡襢襣襫襮襰襳襵襺"
		],
		[
			"8fdda1",
			"襻襼襽覉覍覐覔覕覛覜覟覠覥覰覴覵覶覷覼觔",
			4,
			"觥觩觫觭觱觳觶觹觽觿訄訅訇訏訑訒訔訕訞訠訢訤訦訫訬訯訵訷訽訾詀詃詅詇詉詍詎詓詖詗詘詜詝詡詥詧詵詶詷詹詺詻詾詿誀誃誆誋誏誐誒誖誗誙誟誧誩誮誯誳"
		],
		[
			"8fdea1",
			"誶誷誻誾諃諆諈諉諊諑諓諔諕諗諝諟諬諰諴諵諶諼諿謅謆謋謑謜謞謟謊謭謰謷謼譂",
			4,
			"譈譒譓譔譙譍譞譣譭譶譸譹譼譾讁讄讅讋讍讏讔讕讜讞讟谸谹谽谾豅豇豉豋豏豑豓豔豗豘豛豝豙豣豤豦豨豩豭豳豵豶豻豾貆"
		],
		[
			"8fdfa1",
			"貇貋貐貒貓貙貛貜貤貹貺賅賆賉賋賏賖賕賙賝賡賨賬賯賰賲賵賷賸賾賿贁贃贉贒贗贛赥赩赬赮赿趂趄趈趍趐趑趕趞趟趠趦趫趬趯趲趵趷趹趻跀跅跆跇跈跊跎跑跔跕跗跙跤跥跧跬跰趼跱跲跴跽踁踄踅踆踋踑踔踖踠踡踢"
		],
		[
			"8fe0a1",
			"踣踦踧踱踳踶踷踸踹踽蹀蹁蹋蹍蹎蹏蹔蹛蹜蹝蹞蹡蹢蹩蹬蹭蹯蹰蹱蹹蹺蹻躂躃躉躐躒躕躚躛躝躞躢躧躩躭躮躳躵躺躻軀軁軃軄軇軏軑軔軜軨軮軰軱軷軹軺軭輀輂輇輈輏輐輖輗輘輞輠輡輣輥輧輨輬輭輮輴輵輶輷輺轀轁"
		],
		[
			"8fe1a1",
			"轃轇轏轑",
			4,
			"轘轝轞轥辝辠辡辤辥辦辵辶辸达迀迁迆迊迋迍运迒迓迕迠迣迤迨迮迱迵迶迻迾适逄逈逌逘逛逨逩逯逪逬逭逳逴逷逿遃遄遌遛遝遢遦遧遬遰遴遹邅邈邋邌邎邐邕邗邘邙邛邠邡邢邥邰邲邳邴邶邽郌邾郃"
		],
		[
			"8fe2a1",
			"郄郅郇郈郕郗郘郙郜郝郟郥郒郶郫郯郰郴郾郿鄀鄄鄅鄆鄈鄍鄐鄔鄖鄗鄘鄚鄜鄞鄠鄥鄢鄣鄧鄩鄮鄯鄱鄴鄶鄷鄹鄺鄼鄽酃酇酈酏酓酗酙酚酛酡酤酧酭酴酹酺酻醁醃醅醆醊醎醑醓醔醕醘醞醡醦醨醬醭醮醰醱醲醳醶醻醼醽醿"
		],
		[
			"8fe3a1",
			"釂釃釅釓釔釗釙釚釞釤釥釩釪釬",
			5,
			"釷釹釻釽鈀鈁鈄鈅鈆鈇鈉鈊鈌鈐鈒鈓鈖鈘鈜鈝鈣鈤鈥鈦鈨鈮鈯鈰鈳鈵鈶鈸鈹鈺鈼鈾鉀鉂鉃鉆鉇鉊鉍鉎鉏鉑鉘鉙鉜鉝鉠鉡鉥鉧鉨鉩鉮鉯鉰鉵",
			4,
			"鉻鉼鉽鉿銈銉銊銍銎銒銗"
		],
		[
			"8fe4a1",
			"銙銟銠銤銥銧銨銫銯銲銶銸銺銻銼銽銿",
			4,
			"鋅鋆鋇鋈鋋鋌鋍鋎鋐鋓鋕鋗鋘鋙鋜鋝鋟鋠鋡鋣鋥鋧鋨鋬鋮鋰鋹鋻鋿錀錂錈錍錑錔錕錜錝錞錟錡錤錥錧錩錪錳錴錶錷鍇鍈鍉鍐鍑鍒鍕鍗鍘鍚鍞鍤鍥鍧鍩鍪鍭鍯鍰鍱鍳鍴鍶"
		],
		[
			"8fe5a1",
			"鍺鍽鍿鎀鎁鎂鎈鎊鎋鎍鎏鎒鎕鎘鎛鎞鎡鎣鎤鎦鎨鎫鎴鎵鎶鎺鎩鏁鏄鏅鏆鏇鏉",
			4,
			"鏓鏙鏜鏞鏟鏢鏦鏧鏹鏷鏸鏺鏻鏽鐁鐂鐄鐈鐉鐍鐎鐏鐕鐖鐗鐟鐮鐯鐱鐲鐳鐴鐻鐿鐽鑃鑅鑈鑊鑌鑕鑙鑜鑟鑡鑣鑨鑫鑭鑮鑯鑱鑲钄钃镸镹"
		],
		[
			"8fe6a1",
			"镾閄閈閌閍閎閝閞閟閡閦閩閫閬閴閶閺閽閿闆闈闉闋闐闑闒闓闙闚闝闞闟闠闤闦阝阞阢阤阥阦阬阱阳阷阸阹阺阼阽陁陒陔陖陗陘陡陮陴陻陼陾陿隁隂隃隄隉隑隖隚隝隟隤隥隦隩隮隯隳隺雊雒嶲雘雚雝雞雟雩雯雱雺霂"
		],
		[
			"8fe7a1",
			"霃霅霉霚霛霝霡霢霣霨霱霳靁靃靊靎靏靕靗靘靚靛靣靧靪靮靳靶靷靸靻靽靿鞀鞉鞕鞖鞗鞙鞚鞞鞟鞢鞬鞮鞱鞲鞵鞶鞸鞹鞺鞼鞾鞿韁韄韅韇韉韊韌韍韎韐韑韔韗韘韙韝韞韠韛韡韤韯韱韴韷韸韺頇頊頙頍頎頔頖頜頞頠頣頦"
		],
		[
			"8fe8a1",
			"頫頮頯頰頲頳頵頥頾顄顇顊顑顒顓顖顗顙顚顢顣顥顦顪顬颫颭颮颰颴颷颸颺颻颿飂飅飈飌飡飣飥飦飧飪飳飶餂餇餈餑餕餖餗餚餛餜餟餢餦餧餫餱",
			4,
			"餹餺餻餼饀饁饆饇饈饍饎饔饘饙饛饜饞饟饠馛馝馟馦馰馱馲馵"
		],
		[
			"8fe9a1",
			"馹馺馽馿駃駉駓駔駙駚駜駞駧駪駫駬駰駴駵駹駽駾騂騃騄騋騌騐騑騖騞騠騢騣騤騧騭騮騳騵騶騸驇驁驄驊驋驌驎驑驔驖驝骪骬骮骯骲骴骵骶骹骻骾骿髁髃髆髈髎髐髒髕髖髗髛髜髠髤髥髧髩髬髲髳髵髹髺髽髿",
			4
		],
		[
			"8feaa1",
			"鬄鬅鬈鬉鬋鬌鬍鬎鬐鬒鬖鬙鬛鬜鬠鬦鬫鬭鬳鬴鬵鬷鬹鬺鬽魈魋魌魕魖魗魛魞魡魣魥魦魨魪",
			4,
			"魳魵魷魸魹魿鮀鮄鮅鮆鮇鮉鮊鮋鮍鮏鮐鮔鮚鮝鮞鮦鮧鮩鮬鮰鮱鮲鮷鮸鮻鮼鮾鮿鯁鯇鯈鯎鯐鯗鯘鯝鯟鯥鯧鯪鯫鯯鯳鯷鯸"
		],
		[
			"8feba1",
			"鯹鯺鯽鯿鰀鰂鰋鰏鰑鰖鰘鰙鰚鰜鰞鰢鰣鰦",
			4,
			"鰱鰵鰶鰷鰽鱁鱃鱄鱅鱉鱊鱎鱏鱐鱓鱔鱖鱘鱛鱝鱞鱟鱣鱩鱪鱜鱫鱨鱮鱰鱲鱵鱷鱻鳦鳲鳷鳹鴋鴂鴑鴗鴘鴜鴝鴞鴯鴰鴲鴳鴴鴺鴼鵅鴽鵂鵃鵇鵊鵓鵔鵟鵣鵢鵥鵩鵪鵫鵰鵶鵷鵻"
		],
		[
			"8feca1",
			"鵼鵾鶃鶄鶆鶊鶍鶎鶒鶓鶕鶖鶗鶘鶡鶪鶬鶮鶱鶵鶹鶼鶿鷃鷇鷉鷊鷔鷕鷖鷗鷚鷞鷟鷠鷥鷧鷩鷫鷮鷰鷳鷴鷾鸊鸂鸇鸎鸐鸑鸒鸕鸖鸙鸜鸝鹺鹻鹼麀麂麃麄麅麇麎麏麖麘麛麞麤麨麬麮麯麰麳麴麵黆黈黋黕黟黤黧黬黭黮黰黱黲黵"
		],
		[
			"8feda1",
			"黸黿鼂鼃鼉鼏鼐鼑鼒鼔鼖鼗鼙鼚鼛鼟鼢鼦鼪鼫鼯鼱鼲鼴鼷鼹鼺鼼鼽鼿齁齃",
			4,
			"齓齕齖齗齘齚齝齞齨齩齭",
			4,
			"齳齵齺齽龏龐龑龒龔龖龗龞龡龢龣龥"
		]
	];

/***/ },
/* 32 */
/***/ function(module, exports) {

	module.exports = [
		[
			"0",
			"\u0000",
			127,
			"€"
		],
		[
			"8140",
			"丂丄丅丆丏丒丗丟丠両丣並丩丮丯丱丳丵丷丼乀乁乂乄乆乊乑乕乗乚乛乢乣乤乥乧乨乪",
			5,
			"乲乴",
			9,
			"乿",
			6,
			"亇亊"
		],
		[
			"8180",
			"亐亖亗亙亜亝亞亣亪亯亰亱亴亶亷亸亹亼亽亾仈仌仏仐仒仚仛仜仠仢仦仧仩仭仮仯仱仴仸仹仺仼仾伀伂",
			6,
			"伋伌伒",
			4,
			"伜伝伡伣伨伩伬伭伮伱伳伵伷伹伻伾",
			4,
			"佄佅佇",
			5,
			"佒佔佖佡佢佦佨佪佫佭佮佱佲併佷佸佹佺佽侀侁侂侅來侇侊侌侎侐侒侓侕侖侘侙侚侜侞侟価侢"
		],
		[
			"8240",
			"侤侫侭侰",
			4,
			"侶",
			8,
			"俀俁係俆俇俈俉俋俌俍俒",
			4,
			"俙俛俠俢俤俥俧俫俬俰俲俴俵俶俷俹俻俼俽俿",
			11
		],
		[
			"8280",
			"個倎倐們倓倕倖倗倛倝倞倠倢倣値倧倫倯",
			10,
			"倻倽倿偀偁偂偄偅偆偉偊偋偍偐",
			4,
			"偖偗偘偙偛偝",
			7,
			"偦",
			5,
			"偭",
			8,
			"偸偹偺偼偽傁傂傃傄傆傇傉傊傋傌傎",
			20,
			"傤傦傪傫傭",
			4,
			"傳",
			6,
			"傼"
		],
		[
			"8340",
			"傽",
			17,
			"僐",
			5,
			"僗僘僙僛",
			10,
			"僨僩僪僫僯僰僱僲僴僶",
			4,
			"僼",
			9,
			"儈"
		],
		[
			"8380",
			"儉儊儌",
			5,
			"儓",
			13,
			"儢",
			28,
			"兂兇兊兌兎兏児兒兓兗兘兙兛兝",
			4,
			"兣兤兦內兩兪兯兲兺兾兿冃冄円冇冊冋冎冏冐冑冓冔冘冚冝冞冟冡冣冦",
			4,
			"冭冮冴冸冹冺冾冿凁凂凃凅凈凊凍凎凐凒",
			5
		],
		[
			"8440",
			"凘凙凚凜凞凟凢凣凥",
			5,
			"凬凮凱凲凴凷凾刄刅刉刋刌刏刐刓刔刕刜刞刟刡刢刣別刦刧刪刬刯刱刲刴刵刼刾剄",
			5,
			"剋剎剏剒剓剕剗剘"
		],
		[
			"8480",
			"剙剚剛剝剟剠剢剣剤剦剨剫剬剭剮剰剱剳",
			9,
			"剾劀劃",
			4,
			"劉",
			6,
			"劑劒劔",
			6,
			"劜劤劥劦劧劮劯劰労",
			9,
			"勀勁勂勄勅勆勈勊勌勍勎勏勑勓勔動勗務",
			5,
			"勠勡勢勣勥",
			10,
			"勱",
			7,
			"勻勼勽匁匂匃匄匇匉匊匋匌匎"
		],
		[
			"8540",
			"匑匒匓匔匘匛匜匞匟匢匤匥匧匨匩匫匬匭匯",
			9,
			"匼匽區卂卄卆卋卌卍卐協単卙卛卝卥卨卪卬卭卲卶卹卻卼卽卾厀厁厃厇厈厊厎厏"
		],
		[
			"8580",
			"厐",
			4,
			"厖厗厙厛厜厞厠厡厤厧厪厫厬厭厯",
			6,
			"厷厸厹厺厼厽厾叀參",
			4,
			"収叏叐叒叓叕叚叜叝叞叡叢叧叴叺叾叿吀吂吅吇吋吔吘吙吚吜吢吤吥吪吰吳吶吷吺吽吿呁呂呄呅呇呉呌呍呎呏呑呚呝",
			4,
			"呣呥呧呩",
			7,
			"呴呹呺呾呿咁咃咅咇咈咉咊咍咑咓咗咘咜咞咟咠咡"
		],
		[
			"8640",
			"咢咥咮咰咲咵咶咷咹咺咼咾哃哅哊哋哖哘哛哠",
			4,
			"哫哬哯哰哱哴",
			5,
			"哻哾唀唂唃唄唅唈唊",
			4,
			"唒唓唕",
			5,
			"唜唝唞唟唡唥唦"
		],
		[
			"8680",
			"唨唩唫唭唲唴唵唶唸唹唺唻唽啀啂啅啇啈啋",
			4,
			"啑啒啓啔啗",
			4,
			"啝啞啟啠啢啣啨啩啫啯",
			5,
			"啹啺啽啿喅喆喌喍喎喐喒喓喕喖喗喚喛喞喠",
			6,
			"喨",
			8,
			"喲喴営喸喺喼喿",
			4,
			"嗆嗇嗈嗊嗋嗎嗏嗐嗕嗗",
			4,
			"嗞嗠嗢嗧嗩嗭嗮嗰嗱嗴嗶嗸",
			4,
			"嗿嘂嘃嘄嘅"
		],
		[
			"8740",
			"嘆嘇嘊嘋嘍嘐",
			7,
			"嘙嘚嘜嘝嘠嘡嘢嘥嘦嘨嘩嘪嘫嘮嘯嘰嘳嘵嘷嘸嘺嘼嘽嘾噀",
			11,
			"噏",
			4,
			"噕噖噚噛噝",
			4
		],
		[
			"8780",
			"噣噥噦噧噭噮噯噰噲噳噴噵噷噸噹噺噽",
			7,
			"嚇",
			6,
			"嚐嚑嚒嚔",
			14,
			"嚤",
			10,
			"嚰",
			6,
			"嚸嚹嚺嚻嚽",
			12,
			"囋",
			8,
			"囕囖囘囙囜団囥",
			5,
			"囬囮囯囲図囶囷囸囻囼圀圁圂圅圇國",
			6
		],
		[
			"8840",
			"園",
			9,
			"圝圞圠圡圢圤圥圦圧圫圱圲圴",
			4,
			"圼圽圿坁坃坄坅坆坈坉坋坒",
			4,
			"坘坙坢坣坥坧坬坮坰坱坲坴坵坸坹坺坽坾坿垀"
		],
		[
			"8880",
			"垁垇垈垉垊垍",
			4,
			"垔",
			6,
			"垜垝垞垟垥垨垪垬垯垰垱垳垵垶垷垹",
			8,
			"埄",
			6,
			"埌埍埐埑埓埖埗埛埜埞埡埢埣埥",
			7,
			"埮埰埱埲埳埵埶執埻埼埾埿堁堃堄堅堈堉堊堌堎堏堐堒堓堔堖堗堘堚堛堜堝堟堢堣堥",
			4,
			"堫",
			4,
			"報堲堳場堶",
			7
		],
		[
			"8940",
			"堾",
			5,
			"塅",
			6,
			"塎塏塐塒塓塕塖塗塙",
			4,
			"塟",
			5,
			"塦",
			4,
			"塭",
			16,
			"塿墂墄墆墇墈墊墋墌"
		],
		[
			"8980",
			"墍",
			4,
			"墔",
			4,
			"墛墜墝墠",
			7,
			"墪",
			17,
			"墽墾墿壀壂壃壄壆",
			10,
			"壒壓壔壖",
			13,
			"壥",
			5,
			"壭壯壱売壴壵壷壸壺",
			7,
			"夃夅夆夈",
			4,
			"夎夐夑夒夓夗夘夛夝夞夠夡夢夣夦夨夬夰夲夳夵夶夻"
		],
		[
			"8a40",
			"夽夾夿奀奃奅奆奊奌奍奐奒奓奙奛",
			4,
			"奡奣奤奦",
			12,
			"奵奷奺奻奼奾奿妀妅妉妋妌妎妏妐妑妔妕妘妚妛妜妝妟妠妡妢妦"
		],
		[
			"8a80",
			"妧妬妭妰妱妳",
			5,
			"妺妼妽妿",
			6,
			"姇姈姉姌姍姎姏姕姖姙姛姞",
			4,
			"姤姦姧姩姪姫姭",
			11,
			"姺姼姽姾娀娂娊娋娍娎娏娐娒娔娕娖娗娙娚娛娝娞娡娢娤娦娧娨娪",
			6,
			"娳娵娷",
			4,
			"娽娾娿婁",
			4,
			"婇婈婋",
			9,
			"婖婗婘婙婛",
			5
		],
		[
			"8b40",
			"婡婣婤婥婦婨婩婫",
			8,
			"婸婹婻婼婽婾媀",
			17,
			"媓",
			6,
			"媜",
			13,
			"媫媬"
		],
		[
			"8b80",
			"媭",
			4,
			"媴媶媷媹",
			4,
			"媿嫀嫃",
			5,
			"嫊嫋嫍",
			4,
			"嫓嫕嫗嫙嫚嫛嫝嫞嫟嫢嫤嫥嫧嫨嫪嫬",
			4,
			"嫲",
			22,
			"嬊",
			11,
			"嬘",
			25,
			"嬳嬵嬶嬸",
			7,
			"孁",
			6
		],
		[
			"8c40",
			"孈",
			7,
			"孒孖孞孠孡孧孨孫孭孮孯孲孴孶孷學孹孻孼孾孿宂宆宊宍宎宐宑宒宔宖実宧宨宩宬宭宮宯宱宲宷宺宻宼寀寁寃寈寉寊寋寍寎寏"
		],
		[
			"8c80",
			"寑寔",
			8,
			"寠寢寣實寧審",
			4,
			"寯寱",
			6,
			"寽対尀専尃尅將專尋尌對導尐尒尓尗尙尛尞尟尠尡尣尦尨尩尪尫尭尮尯尰尲尳尵尶尷屃屄屆屇屌屍屒屓屔屖屗屘屚屛屜屝屟屢層屧",
			6,
			"屰屲",
			6,
			"屻屼屽屾岀岃",
			4,
			"岉岊岋岎岏岒岓岕岝",
			4,
			"岤",
			4
		],
		[
			"8d40",
			"岪岮岯岰岲岴岶岹岺岻岼岾峀峂峃峅",
			5,
			"峌",
			5,
			"峓",
			5,
			"峚",
			6,
			"峢峣峧峩峫峬峮峯峱",
			9,
			"峼",
			4
		],
		[
			"8d80",
			"崁崄崅崈",
			5,
			"崏",
			4,
			"崕崗崘崙崚崜崝崟",
			4,
			"崥崨崪崫崬崯",
			4,
			"崵",
			7,
			"崿",
			7,
			"嵈嵉嵍",
			10,
			"嵙嵚嵜嵞",
			10,
			"嵪嵭嵮嵰嵱嵲嵳嵵",
			12,
			"嶃",
			21,
			"嶚嶛嶜嶞嶟嶠"
		],
		[
			"8e40",
			"嶡",
			21,
			"嶸",
			12,
			"巆",
			6,
			"巎",
			12,
			"巜巟巠巣巤巪巬巭"
		],
		[
			"8e80",
			"巰巵巶巸",
			4,
			"巿帀帄帇帉帊帋帍帎帒帓帗帞",
			7,
			"帨",
			4,
			"帯帰帲",
			4,
			"帹帺帾帿幀幁幃幆",
			5,
			"幍",
			6,
			"幖",
			4,
			"幜幝幟幠幣",
			14,
			"幵幷幹幾庁庂広庅庈庉庌庍庎庒庘庛庝庡庢庣庤庨",
			4,
			"庮",
			4,
			"庴庺庻庼庽庿",
			6
		],
		[
			"8f40",
			"廆廇廈廋",
			5,
			"廔廕廗廘廙廚廜",
			11,
			"廩廫",
			8,
			"廵廸廹廻廼廽弅弆弇弉弌弍弎弐弒弔弖弙弚弜弝弞弡弢弣弤"
		],
		[
			"8f80",
			"弨弫弬弮弰弲",
			6,
			"弻弽弾弿彁",
			14,
			"彑彔彙彚彛彜彞彟彠彣彥彧彨彫彮彯彲彴彵彶彸彺彽彾彿徃徆徍徎徏徑従徔徖徚徛徝從徟徠徢",
			5,
			"復徫徬徯",
			5,
			"徶徸徹徺徻徾",
			4,
			"忇忈忊忋忎忓忔忕忚忛応忞忟忢忣忥忦忨忩忬忯忰忲忳忴忶忷忹忺忼怇"
		],
		[
			"9040",
			"怈怉怋怌怐怑怓怗怘怚怞怟怢怣怤怬怭怮怰",
			4,
			"怶",
			4,
			"怽怾恀恄",
			6,
			"恌恎恏恑恓恔恖恗恘恛恜恞恟恠恡恥恦恮恱恲恴恵恷恾悀"
		],
		[
			"9080",
			"悁悂悅悆悇悈悊悋悎悏悐悑悓悕悗悘悙悜悞悡悢悤悥悧悩悪悮悰悳悵悶悷悹悺悽",
			7,
			"惇惈惉惌",
			4,
			"惒惓惔惖惗惙惛惞惡",
			4,
			"惪惱惲惵惷惸惻",
			4,
			"愂愃愄愅愇愊愋愌愐",
			4,
			"愖愗愘愙愛愜愝愞愡愢愥愨愩愪愬",
			18,
			"慀",
			6
		],
		[
			"9140",
			"慇慉態慍慏慐慒慓慔慖",
			6,
			"慞慟慠慡慣慤慥慦慩",
			6,
			"慱慲慳慴慶慸",
			18,
			"憌憍憏",
			4,
			"憕"
		],
		[
			"9180",
			"憖",
			6,
			"憞",
			8,
			"憪憫憭",
			9,
			"憸",
			5,
			"憿懀懁懃",
			4,
			"應懌",
			4,
			"懓懕",
			16,
			"懧",
			13,
			"懶",
			8,
			"戀",
			5,
			"戇戉戓戔戙戜戝戞戠戣戦戧戨戩戫戭戯戰戱戲戵戶戸",
			4,
			"扂扄扅扆扊"
		],
		[
			"9240",
			"扏扐払扖扗扙扚扜",
			6,
			"扤扥扨扱扲扴扵扷扸扺扻扽抁抂抃抅抆抇抈抋",
			5,
			"抔抙抜抝択抣抦抧抩抪抭抮抯抰抲抳抴抶抷抸抺抾拀拁"
		],
		[
			"9280",
			"拃拋拏拑拕拝拞拠拡拤拪拫拰拲拵拸拹拺拻挀挃挄挅挆挊挋挌挍挏挐挒挓挔挕挗挘挙挜挦挧挩挬挭挮挰挱挳",
			5,
			"挻挼挾挿捀捁捄捇捈捊捑捒捓捔捖",
			7,
			"捠捤捥捦捨捪捫捬捯捰捲捳捴捵捸捹捼捽捾捿掁掃掄掅掆掋掍掑掓掔掕掗掙",
			6,
			"採掤掦掫掯掱掲掵掶掹掻掽掿揀"
		],
		[
			"9340",
			"揁揂揃揅揇揈揊揋揌揑揓揔揕揗",
			6,
			"揟揢揤",
			4,
			"揫揬揮揯揰揱揳揵揷揹揺揻揼揾搃搄搆",
			4,
			"損搎搑搒搕",
			5,
			"搝搟搢搣搤"
		],
		[
			"9380",
			"搥搧搨搩搫搮",
			5,
			"搵",
			4,
			"搻搼搾摀摂摃摉摋",
			6,
			"摓摕摖摗摙",
			4,
			"摟",
			7,
			"摨摪摫摬摮",
			9,
			"摻",
			6,
			"撃撆撈",
			8,
			"撓撔撗撘撚撛撜撝撟",
			4,
			"撥撦撧撨撪撫撯撱撲撳撴撶撹撻撽撾撿擁擃擄擆",
			6,
			"擏擑擓擔擕擖擙據"
		],
		[
			"9440",
			"擛擜擝擟擠擡擣擥擧",
			24,
			"攁",
			7,
			"攊",
			7,
			"攓",
			4,
			"攙",
			8
		],
		[
			"9480",
			"攢攣攤攦",
			4,
			"攬攭攰攱攲攳攷攺攼攽敀",
			4,
			"敆敇敊敋敍敎敐敒敓敔敗敘敚敜敟敠敡敤敥敧敨敩敪敭敮敯敱敳敵敶數",
			14,
			"斈斉斊斍斎斏斒斔斕斖斘斚斝斞斠斢斣斦斨斪斬斮斱",
			7,
			"斺斻斾斿旀旂旇旈旉旊旍旐旑旓旔旕旘",
			7,
			"旡旣旤旪旫"
		],
		[
			"9540",
			"旲旳旴旵旸旹旻",
			4,
			"昁昄昅昇昈昉昋昍昐昑昒昖昗昘昚昛昜昞昡昢昣昤昦昩昪昫昬昮昰昲昳昷",
			4,
			"昽昿晀時晄",
			6,
			"晍晎晐晑晘"
		],
		[
			"9580",
			"晙晛晜晝晞晠晢晣晥晧晩",
			4,
			"晱晲晳晵晸晹晻晼晽晿暀暁暃暅暆暈暉暊暋暍暎暏暐暒暓暔暕暘",
			4,
			"暞",
			8,
			"暩",
			4,
			"暯",
			4,
			"暵暶暷暸暺暻暼暽暿",
			25,
			"曚曞",
			7,
			"曧曨曪",
			5,
			"曱曵曶書曺曻曽朁朂會"
		],
		[
			"9640",
			"朄朅朆朇朌朎朏朑朒朓朖朘朙朚朜朞朠",
			5,
			"朧朩朮朰朲朳朶朷朸朹朻朼朾朿杁杄杅杇杊杋杍杒杔杕杗",
			4,
			"杝杢杣杤杦杧杫杬杮東杴杶"
		],
		[
			"9680",
			"杸杹杺杻杽枀枂枃枅枆枈枊枌枍枎枏枑枒枓枔枖枙枛枟枠枡枤枦枩枬枮枱枲枴枹",
			7,
			"柂柅",
			9,
			"柕柖柗柛柟柡柣柤柦柧柨柪柫柭柮柲柵",
			7,
			"柾栁栂栃栄栆栍栐栒栔栕栘",
			4,
			"栞栟栠栢",
			6,
			"栫",
			6,
			"栴栵栶栺栻栿桇桋桍桏桒桖",
			5
		],
		[
			"9740",
			"桜桝桞桟桪桬",
			7,
			"桵桸",
			8,
			"梂梄梇",
			7,
			"梐梑梒梔梕梖梘",
			9,
			"梣梤梥梩梪梫梬梮梱梲梴梶梷梸"
		],
		[
			"9780",
			"梹",
			6,
			"棁棃",
			5,
			"棊棌棎棏棐棑棓棔棖棗棙棛",
			4,
			"棡棢棤",
			9,
			"棯棲棳棴棶棷棸棻棽棾棿椀椂椃椄椆",
			4,
			"椌椏椑椓",
			11,
			"椡椢椣椥",
			7,
			"椮椯椱椲椳椵椶椷椸椺椻椼椾楀楁楃",
			16,
			"楕楖楘楙楛楜楟"
		],
		[
			"9840",
			"楡楢楤楥楧楨楩楪楬業楯楰楲",
			4,
			"楺楻楽楾楿榁榃榅榊榋榌榎",
			5,
			"榖榗榙榚榝",
			9,
			"榩榪榬榮榯榰榲榳榵榶榸榹榺榼榽"
		],
		[
			"9880",
			"榾榿槀槂",
			7,
			"構槍槏槑槒槓槕",
			5,
			"槜槝槞槡",
			11,
			"槮槯槰槱槳",
			9,
			"槾樀",
			9,
			"樋",
			11,
			"標",
			5,
			"樠樢",
			5,
			"権樫樬樭樮樰樲樳樴樶",
			6,
			"樿",
			4,
			"橅橆橈",
			7,
			"橑",
			6,
			"橚"
		],
		[
			"9940",
			"橜",
			4,
			"橢橣橤橦",
			10,
			"橲",
			6,
			"橺橻橽橾橿檁檂檃檅",
			8,
			"檏檒",
			4,
			"檘",
			7,
			"檡",
			5
		],
		[
			"9980",
			"檧檨檪檭",
			114,
			"欥欦欨",
			6
		],
		[
			"9a40",
			"欯欰欱欳欴欵欶欸欻欼欽欿歀歁歂歄歅歈歊歋歍",
			11,
			"歚",
			7,
			"歨歩歫",
			13,
			"歺歽歾歿殀殅殈"
		],
		[
			"9a80",
			"殌殎殏殐殑殔殕殗殘殙殜",
			4,
			"殢",
			7,
			"殫",
			7,
			"殶殸",
			6,
			"毀毃毄毆",
			4,
			"毌毎毐毑毘毚毜",
			4,
			"毢",
			7,
			"毬毭毮毰毱毲毴毶毷毸毺毻毼毾",
			6,
			"氈",
			4,
			"氎氒気氜氝氞氠氣氥氫氬氭氱氳氶氷氹氺氻氼氾氿汃汄汅汈汋",
			4,
			"汑汒汓汖汘"
		],
		[
			"9b40",
			"汙汚汢汣汥汦汧汫",
			4,
			"汱汳汵汷汸決汻汼汿沀沄沇沊沋沍沎沑沒沕沖沗沘沚沜沝沞沠沢沨沬沯沰沴沵沶沷沺泀況泂泃泆泇泈泋泍泎泏泑泒泘"
		],
		[
			"9b80",
			"泙泚泜泝泟泤泦泧泩泬泭泲泴泹泿洀洂洃洅洆洈洉洊洍洏洐洑洓洔洕洖洘洜洝洟",
			5,
			"洦洨洩洬洭洯洰洴洶洷洸洺洿浀浂浄浉浌浐浕浖浗浘浛浝浟浡浢浤浥浧浨浫浬浭浰浱浲浳浵浶浹浺浻浽",
			4,
			"涃涄涆涇涊涋涍涏涐涒涖",
			4,
			"涜涢涥涬涭涰涱涳涴涶涷涹",
			5,
			"淁淂淃淈淉淊"
		],
		[
			"9c40",
			"淍淎淏淐淒淓淔淕淗淚淛淜淟淢淣淥淧淨淩淪淭淯淰淲淴淵淶淸淺淽",
			7,
			"渆渇済渉渋渏渒渓渕渘渙減渜渞渟渢渦渧渨渪測渮渰渱渳渵"
		],
		[
			"9c80",
			"渶渷渹渻",
			7,
			"湅",
			7,
			"湏湐湑湒湕湗湙湚湜湝湞湠",
			10,
			"湬湭湯",
			14,
			"満溁溂溄溇溈溊",
			4,
			"溑",
			6,
			"溙溚溛溝溞溠溡溣溤溦溨溩溫溬溭溮溰溳溵溸溹溼溾溿滀滃滄滅滆滈滉滊滌滍滎滐滒滖滘滙滛滜滝滣滧滪",
			5
		],
		[
			"9d40",
			"滰滱滲滳滵滶滷滸滺",
			7,
			"漃漄漅漇漈漊",
			4,
			"漐漑漒漖",
			9,
			"漡漢漣漥漦漧漨漬漮漰漲漴漵漷",
			6,
			"漿潀潁潂"
		],
		[
			"9d80",
			"潃潄潅潈潉潊潌潎",
			9,
			"潙潚潛潝潟潠潡潣潤潥潧",
			5,
			"潯潰潱潳潵潶潷潹潻潽",
			6,
			"澅澆澇澊澋澏",
			12,
			"澝澞澟澠澢",
			4,
			"澨",
			10,
			"澴澵澷澸澺",
			5,
			"濁濃",
			5,
			"濊",
			6,
			"濓",
			10,
			"濟濢濣濤濥"
		],
		[
			"9e40",
			"濦",
			7,
			"濰",
			32,
			"瀒",
			7,
			"瀜",
			6,
			"瀤",
			6
		],
		[
			"9e80",
			"瀫",
			9,
			"瀶瀷瀸瀺",
			17,
			"灍灎灐",
			13,
			"灟",
			11,
			"灮灱灲灳灴灷灹灺灻災炁炂炃炄炆炇炈炋炌炍炏炐炑炓炗炘炚炛炞",
			12,
			"炰炲炴炵炶為炾炿烄烅烆烇烉烋",
			12,
			"烚"
		],
		[
			"9f40",
			"烜烝烞烠烡烢烣烥烪烮烰",
			6,
			"烸烺烻烼烾",
			10,
			"焋",
			4,
			"焑焒焔焗焛",
			10,
			"焧",
			7,
			"焲焳焴"
		],
		[
			"9f80",
			"焵焷",
			13,
			"煆煇煈煉煋煍煏",
			12,
			"煝煟",
			4,
			"煥煩",
			4,
			"煯煰煱煴煵煶煷煹煻煼煾",
			5,
			"熅",
			4,
			"熋熌熍熎熐熑熒熓熕熖熗熚",
			4,
			"熡",
			6,
			"熩熪熫熭",
			5,
			"熴熶熷熸熺",
			8,
			"燄",
			9,
			"燏",
			4
		],
		[
			"a040",
			"燖",
			9,
			"燡燢燣燤燦燨",
			5,
			"燯",
			9,
			"燺",
			11,
			"爇",
			19
		],
		[
			"a080",
			"爛爜爞",
			9,
			"爩爫爭爮爯爲爳爴爺爼爾牀",
			6,
			"牉牊牋牎牏牐牑牓牔牕牗牘牚牜牞牠牣牤牥牨牪牫牬牭牰牱牳牴牶牷牸牻牼牽犂犃犅",
			4,
			"犌犎犐犑犓",
			11,
			"犠",
			11,
			"犮犱犲犳犵犺",
			6,
			"狅狆狇狉狊狋狌狏狑狓狔狕狖狘狚狛"
		],
		[
			"a1a1",
			"　、。·ˉˇ¨〃々—～‖…‘’“”〔〕〈",
			7,
			"〖〗【】±×÷∶∧∨∑∏∪∩∈∷√⊥∥∠⌒⊙∫∮≡≌≈∽∝≠≮≯≤≥∞∵∴♂♀°′″℃＄¤￠￡‰§№☆★○●◎◇◆□■△▲※→←↑↓〓"
		],
		[
			"a2a1",
			"ⅰ",
			9
		],
		[
			"a2b1",
			"⒈",
			19,
			"⑴",
			19,
			"①",
			9
		],
		[
			"a2e5",
			"㈠",
			9
		],
		[
			"a2f1",
			"Ⅰ",
			11
		],
		[
			"a3a1",
			"！＂＃￥％",
			88,
			"￣"
		],
		[
			"a4a1",
			"ぁ",
			82
		],
		[
			"a5a1",
			"ァ",
			85
		],
		[
			"a6a1",
			"Α",
			16,
			"Σ",
			6
		],
		[
			"a6c1",
			"α",
			16,
			"σ",
			6
		],
		[
			"a6e0",
			"︵︶︹︺︿﹀︽︾﹁﹂﹃﹄"
		],
		[
			"a6ee",
			"︻︼︷︸︱"
		],
		[
			"a6f4",
			"︳︴"
		],
		[
			"a7a1",
			"А",
			5,
			"ЁЖ",
			25
		],
		[
			"a7d1",
			"а",
			5,
			"ёж",
			25
		],
		[
			"a840",
			"ˊˋ˙–―‥‵℅℉↖↗↘↙∕∟∣≒≦≧⊿═",
			35,
			"▁",
			6
		],
		[
			"a880",
			"█",
			7,
			"▓▔▕▼▽◢◣◤◥☉⊕〒〝〞"
		],
		[
			"a8a1",
			"āáǎàēéěèīíǐìōóǒòūúǔùǖǘǚǜüêɑ"
		],
		[
			"a8bd",
			"ńň"
		],
		[
			"a8c0",
			"ɡ"
		],
		[
			"a8c5",
			"ㄅ",
			36
		],
		[
			"a940",
			"〡",
			8,
			"㊣㎎㎏㎜㎝㎞㎡㏄㏎㏑㏒㏕︰￢￤"
		],
		[
			"a959",
			"℡㈱"
		],
		[
			"a95c",
			"‐"
		],
		[
			"a960",
			"ー゛゜ヽヾ〆ゝゞ﹉",
			9,
			"﹔﹕﹖﹗﹙",
			8
		],
		[
			"a980",
			"﹢",
			4,
			"﹨﹩﹪﹫"
		],
		[
			"a996",
			"〇"
		],
		[
			"a9a4",
			"─",
			75
		],
		[
			"aa40",
			"狜狝狟狢",
			5,
			"狪狫狵狶狹狽狾狿猀猂猄",
			5,
			"猋猌猍猏猐猑猒猔猘猙猚猟猠猣猤猦猧猨猭猯猰猲猳猵猶猺猻猼猽獀",
			8
		],
		[
			"aa80",
			"獉獊獋獌獎獏獑獓獔獕獖獘",
			7,
			"獡",
			10,
			"獮獰獱"
		],
		[
			"ab40",
			"獲",
			11,
			"獿",
			4,
			"玅玆玈玊玌玍玏玐玒玓玔玕玗玘玙玚玜玝玞玠玡玣",
			5,
			"玪玬玭玱玴玵玶玸玹玼玽玾玿珁珃",
			4
		],
		[
			"ab80",
			"珋珌珎珒",
			6,
			"珚珛珜珝珟珡珢珣珤珦珨珪珫珬珮珯珰珱珳",
			4
		],
		[
			"ac40",
			"珸",
			10,
			"琄琇琈琋琌琍琎琑",
			8,
			"琜",
			5,
			"琣琤琧琩琫琭琯琱琲琷",
			4,
			"琽琾琿瑀瑂",
			11
		],
		[
			"ac80",
			"瑎",
			6,
			"瑖瑘瑝瑠",
			12,
			"瑮瑯瑱",
			4,
			"瑸瑹瑺"
		],
		[
			"ad40",
			"瑻瑼瑽瑿璂璄璅璆璈璉璊璌璍璏璑",
			10,
			"璝璟",
			7,
			"璪",
			15,
			"璻",
			12
		],
		[
			"ad80",
			"瓈",
			9,
			"瓓",
			8,
			"瓝瓟瓡瓥瓧",
			6,
			"瓰瓱瓲"
		],
		[
			"ae40",
			"瓳瓵瓸",
			6,
			"甀甁甂甃甅",
			7,
			"甎甐甒甔甕甖甗甛甝甞甠",
			4,
			"甦甧甪甮甴甶甹甼甽甿畁畂畃畄畆畇畉畊畍畐畑畒畓畕畖畗畘"
		],
		[
			"ae80",
			"畝",
			7,
			"畧畨畩畫",
			6,
			"畳畵當畷畺",
			4,
			"疀疁疂疄疅疇"
		],
		[
			"af40",
			"疈疉疊疌疍疎疐疓疕疘疛疜疞疢疦",
			4,
			"疭疶疷疺疻疿痀痁痆痋痌痎痏痐痑痓痗痙痚痜痝痟痠痡痥痩痬痭痮痯痲痳痵痶痷痸痺痻痽痾瘂瘄瘆瘇"
		],
		[
			"af80",
			"瘈瘉瘋瘍瘎瘏瘑瘒瘓瘔瘖瘚瘜瘝瘞瘡瘣瘧瘨瘬瘮瘯瘱瘲瘶瘷瘹瘺瘻瘽癁療癄"
		],
		[
			"b040",
			"癅",
			6,
			"癎",
			5,
			"癕癗",
			4,
			"癝癟癠癡癢癤",
			6,
			"癬癭癮癰",
			7,
			"癹発發癿皀皁皃皅皉皊皌皍皏皐皒皔皕皗皘皚皛"
		],
		[
			"b080",
			"皜",
			7,
			"皥",
			8,
			"皯皰皳皵",
			9,
			"盀盁盃啊阿埃挨哎唉哀皑癌蔼矮艾碍爱隘鞍氨安俺按暗岸胺案肮昂盎凹敖熬翱袄傲奥懊澳芭捌扒叭吧笆八疤巴拔跋靶把耙坝霸罢爸白柏百摆佰败拜稗斑班搬扳般颁板版扮拌伴瓣半办绊邦帮梆榜膀绑棒磅蚌镑傍谤苞胞包褒剥"
		],
		[
			"b140",
			"盄盇盉盋盌盓盕盙盚盜盝盞盠",
			4,
			"盦",
			7,
			"盰盳盵盶盷盺盻盽盿眀眂眃眅眆眊県眎",
			10,
			"眛眜眝眞眡眣眤眥眧眪眫"
		],
		[
			"b180",
			"眬眮眰",
			4,
			"眹眻眽眾眿睂睄睅睆睈",
			7,
			"睒",
			7,
			"睜薄雹保堡饱宝抱报暴豹鲍爆杯碑悲卑北辈背贝钡倍狈备惫焙被奔苯本笨崩绷甭泵蹦迸逼鼻比鄙笔彼碧蓖蔽毕毙毖币庇痹闭敝弊必辟壁臂避陛鞭边编贬扁便变卞辨辩辫遍标彪膘表鳖憋别瘪彬斌濒滨宾摈兵冰柄丙秉饼炳"
		],
		[
			"b240",
			"睝睞睟睠睤睧睩睪睭",
			11,
			"睺睻睼瞁瞂瞃瞆",
			5,
			"瞏瞐瞓",
			11,
			"瞡瞣瞤瞦瞨瞫瞭瞮瞯瞱瞲瞴瞶",
			4
		],
		[
			"b280",
			"瞼瞾矀",
			12,
			"矎",
			8,
			"矘矙矚矝",
			4,
			"矤病并玻菠播拨钵波博勃搏铂箔伯帛舶脖膊渤泊驳捕卜哺补埠不布步簿部怖擦猜裁材才财睬踩采彩菜蔡餐参蚕残惭惨灿苍舱仓沧藏操糙槽曹草厕策侧册测层蹭插叉茬茶查碴搽察岔差诧拆柴豺搀掺蝉馋谗缠铲产阐颤昌猖"
		],
		[
			"b340",
			"矦矨矪矯矰矱矲矴矵矷矹矺矻矼砃",
			5,
			"砊砋砎砏砐砓砕砙砛砞砠砡砢砤砨砪砫砮砯砱砲砳砵砶砽砿硁硂硃硄硆硈硉硊硋硍硏硑硓硔硘硙硚"
		],
		[
			"b380",
			"硛硜硞",
			11,
			"硯",
			7,
			"硸硹硺硻硽",
			6,
			"场尝常长偿肠厂敞畅唱倡超抄钞朝嘲潮巢吵炒车扯撤掣彻澈郴臣辰尘晨忱沉陈趁衬撑称城橙成呈乘程惩澄诚承逞骋秤吃痴持匙池迟弛驰耻齿侈尺赤翅斥炽充冲虫崇宠抽酬畴踌稠愁筹仇绸瞅丑臭初出橱厨躇锄雏滁除楚"
		],
		[
			"b440",
			"碄碅碆碈碊碋碏碐碒碔碕碖碙碝碞碠碢碤碦碨",
			7,
			"碵碶碷碸確碻碼碽碿磀磂磃磄磆磇磈磌磍磎磏磑磒磓磖磗磘磚",
			9
		],
		[
			"b480",
			"磤磥磦磧磩磪磫磭",
			4,
			"磳磵磶磸磹磻",
			5,
			"礂礃礄礆",
			6,
			"础储矗搐触处揣川穿椽传船喘串疮窗幢床闯创吹炊捶锤垂春椿醇唇淳纯蠢戳绰疵茨磁雌辞慈瓷词此刺赐次聪葱囱匆从丛凑粗醋簇促蹿篡窜摧崔催脆瘁粹淬翠村存寸磋撮搓措挫错搭达答瘩打大呆歹傣戴带殆代贷袋待逮"
		],
		[
			"b540",
			"礍",
			5,
			"礔",
			9,
			"礟",
			4,
			"礥",
			14,
			"礵",
			4,
			"礽礿祂祃祄祅祇祊",
			8,
			"祔祕祘祙祡祣"
		],
		[
			"b580",
			"祤祦祩祪祫祬祮祰",
			6,
			"祹祻",
			4,
			"禂禃禆禇禈禉禋禌禍禎禐禑禒怠耽担丹单郸掸胆旦氮但惮淡诞弹蛋当挡党荡档刀捣蹈倒岛祷导到稻悼道盗德得的蹬灯登等瞪凳邓堤低滴迪敌笛狄涤翟嫡抵底地蒂第帝弟递缔颠掂滇碘点典靛垫电佃甸店惦奠淀殿碉叼雕凋刁掉吊钓调跌爹碟蝶迭谍叠"
		],
		[
			"b640",
			"禓",
			6,
			"禛",
			11,
			"禨",
			10,
			"禴",
			4,
			"禼禿秂秄秅秇秈秊秌秎秏秐秓秔秖秗秙",
			5,
			"秠秡秢秥秨秪"
		],
		[
			"b680",
			"秬秮秱",
			6,
			"秹秺秼秾秿稁稄稅稇稈稉稊稌稏",
			4,
			"稕稖稘稙稛稜丁盯叮钉顶鼎锭定订丢东冬董懂动栋侗恫冻洞兜抖斗陡豆逗痘都督毒犊独读堵睹赌杜镀肚度渡妒端短锻段断缎堆兑队对墩吨蹲敦顿囤钝盾遁掇哆多夺垛躲朵跺舵剁惰堕蛾峨鹅俄额讹娥恶厄扼遏鄂饿恩而儿耳尔饵洱二"
		],
		[
			"b740",
			"稝稟稡稢稤",
			14,
			"稴稵稶稸稺稾穀",
			5,
			"穇",
			9,
			"穒",
			4,
			"穘",
			16
		],
		[
			"b780",
			"穩",
			6,
			"穱穲穳穵穻穼穽穾窂窅窇窉窊窋窌窎窏窐窓窔窙窚窛窞窡窢贰发罚筏伐乏阀法珐藩帆番翻樊矾钒繁凡烦反返范贩犯饭泛坊芳方肪房防妨仿访纺放菲非啡飞肥匪诽吠肺废沸费芬酚吩氛分纷坟焚汾粉奋份忿愤粪丰封枫蜂峰锋风疯烽逢冯缝讽奉凤佛否夫敷肤孵扶拂辐幅氟符伏俘服"
		],
		[
			"b840",
			"窣窤窧窩窪窫窮",
			4,
			"窴",
			10,
			"竀",
			10,
			"竌",
			9,
			"竗竘竚竛竜竝竡竢竤竧",
			5,
			"竮竰竱竲竳"
		],
		[
			"b880",
			"竴",
			4,
			"竻竼竾笀笁笂笅笇笉笌笍笎笐笒笓笖笗笘笚笜笝笟笡笢笣笧笩笭浮涪福袱弗甫抚辅俯釜斧脯腑府腐赴副覆赋复傅付阜父腹负富讣附妇缚咐噶嘎该改概钙盖溉干甘杆柑竿肝赶感秆敢赣冈刚钢缸肛纲岗港杠篙皋高膏羔糕搞镐稿告哥歌搁戈鸽胳疙割革葛格蛤阁隔铬个各给根跟耕更庚羹"
		],
		[
			"b940",
			"笯笰笲笴笵笶笷笹笻笽笿",
			5,
			"筆筈筊筍筎筓筕筗筙筜筞筟筡筣",
			10,
			"筯筰筳筴筶筸筺筼筽筿箁箂箃箄箆",
			6,
			"箎箏"
		],
		[
			"b980",
			"箑箒箓箖箘箙箚箛箞箟箠箣箤箥箮箯箰箲箳箵箶箷箹",
			7,
			"篂篃範埂耿梗工攻功恭龚供躬公宫弓巩汞拱贡共钩勾沟苟狗垢构购够辜菇咕箍估沽孤姑鼓古蛊骨谷股故顾固雇刮瓜剐寡挂褂乖拐怪棺关官冠观管馆罐惯灌贯光广逛瑰规圭硅归龟闺轨鬼诡癸桂柜跪贵刽辊滚棍锅郭国果裹过哈"
		],
		[
			"ba40",
			"篅篈築篊篋篍篎篏篐篒篔",
			4,
			"篛篜篞篟篠篢篣篤篧篨篩篫篬篭篯篰篲",
			4,
			"篸篹篺篻篽篿",
			7,
			"簈簉簊簍簎簐",
			5,
			"簗簘簙"
		],
		[
			"ba80",
			"簚",
			4,
			"簠",
			5,
			"簨簩簫",
			12,
			"簹",
			5,
			"籂骸孩海氦亥害骇酣憨邯韩含涵寒函喊罕翰撼捍旱憾悍焊汗汉夯杭航壕嚎豪毫郝好耗号浩呵喝荷菏核禾和何合盒貉阂河涸赫褐鹤贺嘿黑痕很狠恨哼亨横衡恒轰哄烘虹鸿洪宏弘红喉侯猴吼厚候后呼乎忽瑚壶葫胡蝴狐糊湖"
		],
		[
			"bb40",
			"籃",
			9,
			"籎",
			36,
			"籵",
			5,
			"籾",
			9
		],
		[
			"bb80",
			"粈粊",
			6,
			"粓粔粖粙粚粛粠粡粣粦粧粨粩粫粬粭粯粰粴",
			4,
			"粺粻弧虎唬护互沪户花哗华猾滑画划化话槐徊怀淮坏欢环桓还缓换患唤痪豢焕涣宦幻荒慌黄磺蝗簧皇凰惶煌晃幌恍谎灰挥辉徽恢蛔回毁悔慧卉惠晦贿秽会烩汇讳诲绘荤昏婚魂浑混豁活伙火获或惑霍货祸击圾基机畸稽积箕"
		],
		[
			"bc40",
			"粿糀糂糃糄糆糉糋糎",
			6,
			"糘糚糛糝糞糡",
			6,
			"糩",
			5,
			"糰",
			7,
			"糹糺糼",
			13,
			"紋",
			5
		],
		[
			"bc80",
			"紑",
			14,
			"紡紣紤紥紦紨紩紪紬紭紮細",
			6,
			"肌饥迹激讥鸡姬绩缉吉极棘辑籍集及急疾汲即嫉级挤几脊己蓟技冀季伎祭剂悸济寄寂计记既忌际妓继纪嘉枷夹佳家加荚颊贾甲钾假稼价架驾嫁歼监坚尖笺间煎兼肩艰奸缄茧检柬碱硷拣捡简俭剪减荐槛鉴践贱见键箭件"
		],
		[
			"bd40",
			"紷",
			54,
			"絯",
			7
		],
		[
			"bd80",
			"絸",
			32,
			"健舰剑饯渐溅涧建僵姜将浆江疆蒋桨奖讲匠酱降蕉椒礁焦胶交郊浇骄娇嚼搅铰矫侥脚狡角饺缴绞剿教酵轿较叫窖揭接皆秸街阶截劫节桔杰捷睫竭洁结解姐戒藉芥界借介疥诫届巾筋斤金今津襟紧锦仅谨进靳晋禁近烬浸"
		],
		[
			"be40",
			"継",
			12,
			"綧",
			6,
			"綯",
			42
		],
		[
			"be80",
			"線",
			32,
			"尽劲荆兢茎睛晶鲸京惊精粳经井警景颈静境敬镜径痉靖竟竞净炯窘揪究纠玖韭久灸九酒厩救旧臼舅咎就疚鞠拘狙疽居驹菊局咀矩举沮聚拒据巨具距踞锯俱句惧炬剧捐鹃娟倦眷卷绢撅攫抉掘倔爵觉决诀绝均菌钧军君峻"
		],
		[
			"bf40",
			"緻",
			62
		],
		[
			"bf80",
			"縺縼",
			4,
			"繂",
			4,
			"繈",
			21,
			"俊竣浚郡骏喀咖卡咯开揩楷凯慨刊堪勘坎砍看康慷糠扛抗亢炕考拷烤靠坷苛柯棵磕颗科壳咳可渴克刻客课肯啃垦恳坑吭空恐孔控抠口扣寇枯哭窟苦酷库裤夸垮挎跨胯块筷侩快宽款匡筐狂框矿眶旷况亏盔岿窥葵奎魁傀"
		],
		[
			"c040",
			"繞",
			35,
			"纃",
			23,
			"纜纝纞"
		],
		[
			"c080",
			"纮纴纻纼绖绤绬绹缊缐缞缷缹缻",
			6,
			"罃罆",
			9,
			"罒罓馈愧溃坤昆捆困括扩廓阔垃拉喇蜡腊辣啦莱来赖蓝婪栏拦篮阑兰澜谰揽览懒缆烂滥琅榔狼廊郎朗浪捞劳牢老佬姥酪烙涝勒乐雷镭蕾磊累儡垒擂肋类泪棱楞冷厘梨犁黎篱狸离漓理李里鲤礼莉荔吏栗丽厉励砾历利傈例俐"
		],
		[
			"c140",
			"罖罙罛罜罝罞罠罣",
			4,
			"罫罬罭罯罰罳罵罶罷罸罺罻罼罽罿羀羂",
			7,
			"羋羍羏",
			4,
			"羕",
			4,
			"羛羜羠羢羣羥羦羨",
			6,
			"羱"
		],
		[
			"c180",
			"羳",
			4,
			"羺羻羾翀翂翃翄翆翇翈翉翋翍翏",
			4,
			"翖翗翙",
			5,
			"翢翣痢立粒沥隶力璃哩俩联莲连镰廉怜涟帘敛脸链恋炼练粮凉梁粱良两辆量晾亮谅撩聊僚疗燎寥辽潦了撂镣廖料列裂烈劣猎琳林磷霖临邻鳞淋凛赁吝拎玲菱零龄铃伶羚凌灵陵岭领另令溜琉榴硫馏留刘瘤流柳六龙聋咙笼窿"
		],
		[
			"c240",
			"翤翧翨翪翫翬翭翯翲翴",
			6,
			"翽翾翿耂耇耈耉耊耎耏耑耓耚耛耝耞耟耡耣耤耫",
			5,
			"耲耴耹耺耼耾聀聁聄聅聇聈聉聎聏聐聑聓聕聖聗"
		],
		[
			"c280",
			"聙聛",
			13,
			"聫",
			5,
			"聲",
			11,
			"隆垄拢陇楼娄搂篓漏陋芦卢颅庐炉掳卤虏鲁麓碌露路赂鹿潞禄录陆戮驴吕铝侣旅履屡缕虑氯律率滤绿峦挛孪滦卵乱掠略抡轮伦仑沦纶论萝螺罗逻锣箩骡裸落洛骆络妈麻玛码蚂马骂嘛吗埋买麦卖迈脉瞒馒蛮满蔓曼慢漫"
		],
		[
			"c340",
			"聾肁肂肅肈肊肍",
			5,
			"肔肕肗肙肞肣肦肧肨肬肰肳肵肶肸肹肻胅胇",
			4,
			"胏",
			6,
			"胘胟胠胢胣胦胮胵胷胹胻胾胿脀脁脃脄脅脇脈脋"
		],
		[
			"c380",
			"脌脕脗脙脛脜脝脟",
			12,
			"脭脮脰脳脴脵脷脹",
			4,
			"脿谩芒茫盲氓忙莽猫茅锚毛矛铆卯茂冒帽貌贸么玫枚梅酶霉煤没眉媒镁每美昧寐妹媚门闷们萌蒙檬盟锰猛梦孟眯醚靡糜迷谜弥米秘觅泌蜜密幂棉眠绵冕免勉娩缅面苗描瞄藐秒渺庙妙蔑灭民抿皿敏悯闽明螟鸣铭名命谬摸"
		],
		[
			"c440",
			"腀",
			5,
			"腇腉腍腎腏腒腖腗腘腛",
			4,
			"腡腢腣腤腦腨腪腫腬腯腲腳腵腶腷腸膁膃",
			4,
			"膉膋膌膍膎膐膒",
			5,
			"膙膚膞",
			4,
			"膤膥"
		],
		[
			"c480",
			"膧膩膫",
			7,
			"膴",
			5,
			"膼膽膾膿臄臅臇臈臉臋臍",
			6,
			"摹蘑模膜磨摩魔抹末莫墨默沫漠寞陌谋牟某拇牡亩姆母墓暮幕募慕木目睦牧穆拿哪呐钠那娜纳氖乃奶耐奈南男难囊挠脑恼闹淖呢馁内嫩能妮霓倪泥尼拟你匿腻逆溺蔫拈年碾撵捻念娘酿鸟尿捏聂孽啮镊镍涅您柠狞凝宁"
		],
		[
			"c540",
			"臔",
			14,
			"臤臥臦臨臩臫臮",
			4,
			"臵",
			5,
			"臽臿舃與",
			4,
			"舎舏舑舓舕",
			5,
			"舝舠舤舥舦舧舩舮舲舺舼舽舿"
		],
		[
			"c580",
			"艀艁艂艃艅艆艈艊艌艍艎艐",
			7,
			"艙艛艜艝艞艠",
			7,
			"艩拧泞牛扭钮纽脓浓农弄奴努怒女暖虐疟挪懦糯诺哦欧鸥殴藕呕偶沤啪趴爬帕怕琶拍排牌徘湃派攀潘盘磐盼畔判叛乓庞旁耪胖抛咆刨炮袍跑泡呸胚培裴赔陪配佩沛喷盆砰抨烹澎彭蓬棚硼篷膨朋鹏捧碰坯砒霹批披劈琵毗"
		],
		[
			"c640",
			"艪艫艬艭艱艵艶艷艸艻艼芀芁芃芅芆芇芉芌芐芓芔芕芖芚芛芞芠芢芣芧芲芵芶芺芻芼芿苀苂苃苅苆苉苐苖苙苚苝苢苧苨苩苪苬苭苮苰苲苳苵苶苸"
		],
		[
			"c680",
			"苺苼",
			4,
			"茊茋茍茐茒茓茖茘茙茝",
			9,
			"茩茪茮茰茲茷茻茽啤脾疲皮匹痞僻屁譬篇偏片骗飘漂瓢票撇瞥拼频贫品聘乒坪苹萍平凭瓶评屏坡泼颇婆破魄迫粕剖扑铺仆莆葡菩蒲埔朴圃普浦谱曝瀑期欺栖戚妻七凄漆柒沏其棋奇歧畦崎脐齐旗祈祁骑起岂乞企启契砌器气迄弃汽泣讫掐"
		],
		[
			"c740",
			"茾茿荁荂荄荅荈荊",
			4,
			"荓荕",
			4,
			"荝荢荰",
			6,
			"荹荺荾",
			6,
			"莇莈莊莋莌莍莏莐莑莔莕莖莗莙莚莝莟莡",
			6,
			"莬莭莮"
		],
		[
			"c780",
			"莯莵莻莾莿菂菃菄菆菈菉菋菍菎菐菑菒菓菕菗菙菚菛菞菢菣菤菦菧菨菫菬菭恰洽牵扦钎铅千迁签仟谦乾黔钱钳前潜遣浅谴堑嵌欠歉枪呛腔羌墙蔷强抢橇锹敲悄桥瞧乔侨巧鞘撬翘峭俏窍切茄且怯窃钦侵亲秦琴勤芹擒禽寝沁青轻氢倾卿清擎晴氰情顷请庆琼穷秋丘邱球求囚酋泅趋区蛆曲躯屈驱渠"
		],
		[
			"c840",
			"菮華菳",
			4,
			"菺菻菼菾菿萀萂萅萇萈萉萊萐萒",
			5,
			"萙萚萛萞",
			5,
			"萩",
			7,
			"萲",
			5,
			"萹萺萻萾",
			7,
			"葇葈葉"
		],
		[
			"c880",
			"葊",
			6,
			"葒",
			4,
			"葘葝葞葟葠葢葤",
			4,
			"葪葮葯葰葲葴葷葹葻葼取娶龋趣去圈颧权醛泉全痊拳犬券劝缺炔瘸却鹊榷确雀裙群然燃冉染瓤壤攘嚷让饶扰绕惹热壬仁人忍韧任认刃妊纫扔仍日戎茸蓉荣融熔溶容绒冗揉柔肉茹蠕儒孺如辱乳汝入褥软阮蕊瑞锐闰润若弱撒洒萨腮鳃塞赛三叁"
		],
		[
			"c940",
			"葽",
			4,
			"蒃蒄蒅蒆蒊蒍蒏",
			7,
			"蒘蒚蒛蒝蒞蒟蒠蒢",
			12,
			"蒰蒱蒳蒵蒶蒷蒻蒼蒾蓀蓂蓃蓅蓆蓇蓈蓋蓌蓎蓏蓒蓔蓕蓗"
		],
		[
			"c980",
			"蓘",
			4,
			"蓞蓡蓢蓤蓧",
			4,
			"蓭蓮蓯蓱",
			10,
			"蓽蓾蔀蔁蔂伞散桑嗓丧搔骚扫嫂瑟色涩森僧莎砂杀刹沙纱傻啥煞筛晒珊苫杉山删煽衫闪陕擅赡膳善汕扇缮墒伤商赏晌上尚裳梢捎稍烧芍勺韶少哨邵绍奢赊蛇舌舍赦摄射慑涉社设砷申呻伸身深娠绅神沈审婶甚肾慎渗声生甥牲升绳"
		],
		[
			"ca40",
			"蔃",
			8,
			"蔍蔎蔏蔐蔒蔔蔕蔖蔘蔙蔛蔜蔝蔞蔠蔢",
			8,
			"蔭",
			9,
			"蔾",
			4,
			"蕄蕅蕆蕇蕋",
			10
		],
		[
			"ca80",
			"蕗蕘蕚蕛蕜蕝蕟",
			4,
			"蕥蕦蕧蕩",
			8,
			"蕳蕵蕶蕷蕸蕼蕽蕿薀薁省盛剩胜圣师失狮施湿诗尸虱十石拾时什食蚀实识史矢使屎驶始式示士世柿事拭誓逝势是嗜噬适仕侍释饰氏市恃室视试收手首守寿授售受瘦兽蔬枢梳殊抒输叔舒淑疏书赎孰熟薯暑曙署蜀黍鼠属术述树束戍竖墅庶数漱"
		],
		[
			"cb40",
			"薂薃薆薈",
			6,
			"薐",
			10,
			"薝",
			6,
			"薥薦薧薩薫薬薭薱",
			5,
			"薸薺",
			6,
			"藂",
			6,
			"藊",
			4,
			"藑藒"
		],
		[
			"cb80",
			"藔藖",
			5,
			"藝",
			6,
			"藥藦藧藨藪",
			14,
			"恕刷耍摔衰甩帅栓拴霜双爽谁水睡税吮瞬顺舜说硕朔烁斯撕嘶思私司丝死肆寺嗣四伺似饲巳松耸怂颂送宋讼诵搜艘擞嗽苏酥俗素速粟僳塑溯宿诉肃酸蒜算虽隋随绥髓碎岁穗遂隧祟孙损笋蓑梭唆缩琐索锁所塌他它她塔"
		],
		[
			"cc40",
			"藹藺藼藽藾蘀",
			4,
			"蘆",
			10,
			"蘒蘓蘔蘕蘗",
			15,
			"蘨蘪",
			13,
			"蘹蘺蘻蘽蘾蘿虀"
		],
		[
			"cc80",
			"虁",
			11,
			"虒虓處",
			4,
			"虛虜虝號虠虡虣",
			7,
			"獭挞蹋踏胎苔抬台泰酞太态汰坍摊贪瘫滩坛檀痰潭谭谈坦毯袒碳探叹炭汤塘搪堂棠膛唐糖倘躺淌趟烫掏涛滔绦萄桃逃淘陶讨套特藤腾疼誊梯剔踢锑提题蹄啼体替嚏惕涕剃屉天添填田甜恬舔腆挑条迢眺跳贴铁帖厅听烃"
		],
		[
			"cd40",
			"虭虯虰虲",
			6,
			"蚃",
			6,
			"蚎",
			4,
			"蚔蚖",
			5,
			"蚞",
			4,
			"蚥蚦蚫蚭蚮蚲蚳蚷蚸蚹蚻",
			4,
			"蛁蛂蛃蛅蛈蛌蛍蛒蛓蛕蛖蛗蛚蛜"
		],
		[
			"cd80",
			"蛝蛠蛡蛢蛣蛥蛦蛧蛨蛪蛫蛬蛯蛵蛶蛷蛺蛻蛼蛽蛿蜁蜄蜅蜆蜋蜌蜎蜏蜐蜑蜔蜖汀廷停亭庭挺艇通桐酮瞳同铜彤童桶捅筒统痛偷投头透凸秃突图徒途涂屠土吐兔湍团推颓腿蜕褪退吞屯臀拖托脱鸵陀驮驼椭妥拓唾挖哇蛙洼娃瓦袜歪外豌弯湾玩顽丸烷完碗挽晚皖惋宛婉万腕汪王亡枉网往旺望忘妄威"
		],
		[
			"ce40",
			"蜙蜛蜝蜟蜠蜤蜦蜧蜨蜪蜫蜬蜭蜯蜰蜲蜳蜵蜶蜸蜹蜺蜼蜽蝀",
			6,
			"蝊蝋蝍蝏蝐蝑蝒蝔蝕蝖蝘蝚",
			5,
			"蝡蝢蝦",
			7,
			"蝯蝱蝲蝳蝵"
		],
		[
			"ce80",
			"蝷蝸蝹蝺蝿螀螁螄螆螇螉螊螌螎",
			4,
			"螔螕螖螘",
			6,
			"螠",
			4,
			"巍微危韦违桅围唯惟为潍维苇萎委伟伪尾纬未蔚味畏胃喂魏位渭谓尉慰卫瘟温蚊文闻纹吻稳紊问嗡翁瓮挝蜗涡窝我斡卧握沃巫呜钨乌污诬屋无芜梧吾吴毋武五捂午舞伍侮坞戊雾晤物勿务悟误昔熙析西硒矽晰嘻吸锡牺"
		],
		[
			"cf40",
			"螥螦螧螩螪螮螰螱螲螴螶螷螸螹螻螼螾螿蟁",
			4,
			"蟇蟈蟉蟌",
			4,
			"蟔",
			6,
			"蟜蟝蟞蟟蟡蟢蟣蟤蟦蟧蟨蟩蟫蟬蟭蟯",
			9
		],
		[
			"cf80",
			"蟺蟻蟼蟽蟿蠀蠁蠂蠄",
			5,
			"蠋",
			7,
			"蠔蠗蠘蠙蠚蠜",
			4,
			"蠣稀息希悉膝夕惜熄烯溪汐犀檄袭席习媳喜铣洗系隙戏细瞎虾匣霞辖暇峡侠狭下厦夏吓掀锨先仙鲜纤咸贤衔舷闲涎弦嫌显险现献县腺馅羡宪陷限线相厢镶香箱襄湘乡翔祥详想响享项巷橡像向象萧硝霄削哮嚣销消宵淆晓"
		],
		[
			"d040",
			"蠤",
			13,
			"蠳",
			5,
			"蠺蠻蠽蠾蠿衁衂衃衆",
			5,
			"衎",
			5,
			"衕衖衘衚",
			6,
			"衦衧衪衭衯衱衳衴衵衶衸衹衺"
		],
		[
			"d080",
			"衻衼袀袃袆袇袉袊袌袎袏袐袑袓袔袕袗",
			4,
			"袝",
			4,
			"袣袥",
			5,
			"小孝校肖啸笑效楔些歇蝎鞋协挟携邪斜胁谐写械卸蟹懈泄泻谢屑薪芯锌欣辛新忻心信衅星腥猩惺兴刑型形邢行醒幸杏性姓兄凶胸匈汹雄熊休修羞朽嗅锈秀袖绣墟戌需虚嘘须徐许蓄酗叙旭序畜恤絮婿绪续轩喧宣悬旋玄"
		],
		[
			"d140",
			"袬袮袯袰袲",
			4,
			"袸袹袺袻袽袾袿裀裃裄裇裈裊裋裌裍裏裐裑裓裖裗裚",
			4,
			"裠裡裦裧裩",
			6,
			"裲裵裶裷裺裻製裿褀褁褃",
			5
		],
		[
			"d180",
			"褉褋",
			4,
			"褑褔",
			4,
			"褜",
			4,
			"褢褣褤褦褧褨褩褬褭褮褯褱褲褳褵褷选癣眩绚靴薛学穴雪血勋熏循旬询寻驯巡殉汛训讯逊迅压押鸦鸭呀丫芽牙蚜崖衙涯雅哑亚讶焉咽阉烟淹盐严研蜒岩延言颜阎炎沿奄掩眼衍演艳堰燕厌砚雁唁彦焰宴谚验殃央鸯秧杨扬佯疡羊洋阳氧仰痒养样漾邀腰妖瑶"
		],
		[
			"d240",
			"褸",
			8,
			"襂襃襅",
			24,
			"襠",
			5,
			"襧",
			19,
			"襼"
		],
		[
			"d280",
			"襽襾覀覂覄覅覇",
			26,
			"摇尧遥窑谣姚咬舀药要耀椰噎耶爷野冶也页掖业叶曳腋夜液一壹医揖铱依伊衣颐夷遗移仪胰疑沂宜姨彝椅蚁倚已乙矣以艺抑易邑屹亿役臆逸肄疫亦裔意毅忆义益溢诣议谊译异翼翌绎茵荫因殷音阴姻吟银淫寅饮尹引隐"
		],
		[
			"d340",
			"覢",
			30,
			"觃觍觓觔觕觗觘觙觛觝觟觠觡觢觤觧觨觩觪觬觭觮觰觱觲觴",
			6
		],
		[
			"d380",
			"觻",
			4,
			"訁",
			5,
			"計",
			21,
			"印英樱婴鹰应缨莹萤营荧蝇迎赢盈影颖硬映哟拥佣臃痈庸雍踊蛹咏泳涌永恿勇用幽优悠忧尤由邮铀犹油游酉有友右佑釉诱又幼迂淤于盂榆虞愚舆余俞逾鱼愉渝渔隅予娱雨与屿禹宇语羽玉域芋郁吁遇喻峪御愈欲狱育誉"
		],
		[
			"d440",
			"訞",
			31,
			"訿",
			8,
			"詉",
			21
		],
		[
			"d480",
			"詟",
			25,
			"詺",
			6,
			"浴寓裕预豫驭鸳渊冤元垣袁原援辕园员圆猿源缘远苑愿怨院曰约越跃钥岳粤月悦阅耘云郧匀陨允运蕴酝晕韵孕匝砸杂栽哉灾宰载再在咱攒暂赞赃脏葬遭糟凿藻枣早澡蚤躁噪造皂灶燥责择则泽贼怎增憎曾赠扎喳渣札轧"
		],
		[
			"d540",
			"誁",
			7,
			"誋",
			7,
			"誔",
			46
		],
		[
			"d580",
			"諃",
			32,
			"铡闸眨栅榨咋乍炸诈摘斋宅窄债寨瞻毡詹粘沾盏斩辗崭展蘸栈占战站湛绽樟章彰漳张掌涨杖丈帐账仗胀瘴障招昭找沼赵照罩兆肇召遮折哲蛰辙者锗蔗这浙珍斟真甄砧臻贞针侦枕疹诊震振镇阵蒸挣睁征狰争怔整拯正政"
		],
		[
			"d640",
			"諤",
			34,
			"謈",
			27
		],
		[
			"d680",
			"謤謥謧",
			30,
			"帧症郑证芝枝支吱蜘知肢脂汁之织职直植殖执值侄址指止趾只旨纸志挚掷至致置帜峙制智秩稚质炙痔滞治窒中盅忠钟衷终种肿重仲众舟周州洲诌粥轴肘帚咒皱宙昼骤珠株蛛朱猪诸诛逐竹烛煮拄瞩嘱主著柱助蛀贮铸筑"
		],
		[
			"d740",
			"譆",
			31,
			"譧",
			4,
			"譭",
			25
		],
		[
			"d780",
			"讇",
			24,
			"讬讱讻诇诐诪谉谞住注祝驻抓爪拽专砖转撰赚篆桩庄装妆撞壮状椎锥追赘坠缀谆准捉拙卓桌琢茁酌啄着灼浊兹咨资姿滋淄孜紫仔籽滓子自渍字鬃棕踪宗综总纵邹走奏揍租足卒族祖诅阻组钻纂嘴醉最罪尊遵昨左佐柞做作坐座"
		],
		[
			"d840",
			"谸",
			8,
			"豂豃豄豅豈豊豋豍",
			7,
			"豖豗豘豙豛",
			5,
			"豣",
			6,
			"豬",
			6,
			"豴豵豶豷豻",
			6,
			"貃貄貆貇"
		],
		[
			"d880",
			"貈貋貍",
			6,
			"貕貖貗貙",
			20,
			"亍丌兀丐廿卅丕亘丞鬲孬噩丨禺丿匕乇夭爻卮氐囟胤馗毓睾鼗丶亟鼐乜乩亓芈孛啬嘏仄厍厝厣厥厮靥赝匚叵匦匮匾赜卦卣刂刈刎刭刳刿剀剌剞剡剜蒯剽劂劁劐劓冂罔亻仃仉仂仨仡仫仞伛仳伢佤仵伥伧伉伫佞佧攸佚佝"
		],
		[
			"d940",
			"貮",
			62
		],
		[
			"d980",
			"賭",
			32,
			"佟佗伲伽佶佴侑侉侃侏佾佻侪佼侬侔俦俨俪俅俚俣俜俑俟俸倩偌俳倬倏倮倭俾倜倌倥倨偾偃偕偈偎偬偻傥傧傩傺僖儆僭僬僦僮儇儋仝氽佘佥俎龠汆籴兮巽黉馘冁夔勹匍訇匐凫夙兕亠兖亳衮袤亵脔裒禀嬴蠃羸冫冱冽冼"
		],
		[
			"da40",
			"贎",
			14,
			"贠赑赒赗赟赥赨赩赪赬赮赯赱赲赸",
			8,
			"趂趃趆趇趈趉趌",
			4,
			"趒趓趕",
			9,
			"趠趡"
		],
		[
			"da80",
			"趢趤",
			12,
			"趲趶趷趹趻趽跀跁跂跅跇跈跉跊跍跐跒跓跔凇冖冢冥讠讦讧讪讴讵讷诂诃诋诏诎诒诓诔诖诘诙诜诟诠诤诨诩诮诰诳诶诹诼诿谀谂谄谇谌谏谑谒谔谕谖谙谛谘谝谟谠谡谥谧谪谫谮谯谲谳谵谶卩卺阝阢阡阱阪阽阼陂陉陔陟陧陬陲陴隈隍隗隰邗邛邝邙邬邡邴邳邶邺"
		],
		[
			"db40",
			"跕跘跙跜跠跡跢跥跦跧跩跭跮跰跱跲跴跶跼跾",
			6,
			"踆踇踈踋踍踎踐踑踒踓踕",
			7,
			"踠踡踤",
			4,
			"踫踭踰踲踳踴踶踷踸踻踼踾"
		],
		[
			"db80",
			"踿蹃蹅蹆蹌",
			4,
			"蹓",
			5,
			"蹚",
			11,
			"蹧蹨蹪蹫蹮蹱邸邰郏郅邾郐郄郇郓郦郢郜郗郛郫郯郾鄄鄢鄞鄣鄱鄯鄹酃酆刍奂劢劬劭劾哿勐勖勰叟燮矍廴凵凼鬯厶弁畚巯坌垩垡塾墼壅壑圩圬圪圳圹圮圯坜圻坂坩垅坫垆坼坻坨坭坶坳垭垤垌垲埏垧垴垓垠埕埘埚埙埒垸埴埯埸埤埝"
		],
		[
			"dc40",
			"蹳蹵蹷",
			4,
			"蹽蹾躀躂躃躄躆躈",
			6,
			"躑躒躓躕",
			6,
			"躝躟",
			11,
			"躭躮躰躱躳",
			6,
			"躻",
			7
		],
		[
			"dc80",
			"軃",
			10,
			"軏",
			21,
			"堋堍埽埭堀堞堙塄堠塥塬墁墉墚墀馨鼙懿艹艽艿芏芊芨芄芎芑芗芙芫芸芾芰苈苊苣芘芷芮苋苌苁芩芴芡芪芟苄苎芤苡茉苷苤茏茇苜苴苒苘茌苻苓茑茚茆茔茕苠苕茜荑荛荜茈莒茼茴茱莛荞茯荏荇荃荟荀茗荠茭茺茳荦荥"
		],
		[
			"dd40",
			"軥",
			62
		],
		[
			"dd80",
			"輤",
			32,
			"荨茛荩荬荪荭荮莰荸莳莴莠莪莓莜莅荼莶莩荽莸荻莘莞莨莺莼菁萁菥菘堇萘萋菝菽菖萜萸萑萆菔菟萏萃菸菹菪菅菀萦菰菡葜葑葚葙葳蒇蒈葺蒉葸萼葆葩葶蒌蒎萱葭蓁蓍蓐蓦蒽蓓蓊蒿蒺蓠蒡蒹蒴蒗蓥蓣蔌甍蔸蓰蔹蔟蔺"
		],
		[
			"de40",
			"轅",
			32,
			"轪辀辌辒辝辠辡辢辤辥辦辧辪辬辭辮辯農辳辴辵辷辸辺辻込辿迀迃迆"
		],
		[
			"de80",
			"迉",
			4,
			"迏迒迖迗迚迠迡迣迧迬迯迱迲迴迵迶迺迻迼迾迿逇逈逌逎逓逕逘蕖蔻蓿蓼蕙蕈蕨蕤蕞蕺瞢蕃蕲蕻薤薨薇薏蕹薮薜薅薹薷薰藓藁藜藿蘧蘅蘩蘖蘼廾弈夼奁耷奕奚奘匏尢尥尬尴扌扪抟抻拊拚拗拮挢拶挹捋捃掭揶捱捺掎掴捭掬掊捩掮掼揲揸揠揿揄揞揎摒揆掾摅摁搋搛搠搌搦搡摞撄摭撖"
		],
		[
			"df40",
			"這逜連逤逥逧",
			5,
			"逰",
			4,
			"逷逹逺逽逿遀遃遅遆遈",
			4,
			"過達違遖遙遚遜",
			5,
			"遤遦遧適遪遫遬遯",
			4,
			"遶",
			6,
			"遾邁"
		],
		[
			"df80",
			"還邅邆邇邉邊邌",
			4,
			"邒邔邖邘邚邜邞邟邠邤邥邧邨邩邫邭邲邷邼邽邿郀摺撷撸撙撺擀擐擗擤擢攉攥攮弋忒甙弑卟叱叽叩叨叻吒吖吆呋呒呓呔呖呃吡呗呙吣吲咂咔呷呱呤咚咛咄呶呦咝哐咭哂咴哒咧咦哓哔呲咣哕咻咿哌哙哚哜咩咪咤哝哏哞唛哧唠哽唔哳唢唣唏唑唧唪啧喏喵啉啭啁啕唿啐唼"
		],
		[
			"e040",
			"郂郃郆郈郉郋郌郍郒郔郕郖郘郙郚郞郟郠郣郤郥郩郪郬郮郰郱郲郳郵郶郷郹郺郻郼郿鄀鄁鄃鄅",
			19,
			"鄚鄛鄜"
		],
		[
			"e080",
			"鄝鄟鄠鄡鄤",
			10,
			"鄰鄲",
			6,
			"鄺",
			8,
			"酄唷啖啵啶啷唳唰啜喋嗒喃喱喹喈喁喟啾嗖喑啻嗟喽喾喔喙嗪嗷嗉嘟嗑嗫嗬嗔嗦嗝嗄嗯嗥嗲嗳嗌嗍嗨嗵嗤辔嘞嘈嘌嘁嘤嘣嗾嘀嘧嘭噘嘹噗嘬噍噢噙噜噌噔嚆噤噱噫噻噼嚅嚓嚯囔囗囝囡囵囫囹囿圄圊圉圜帏帙帔帑帱帻帼"
		],
		[
			"e140",
			"酅酇酈酑酓酔酕酖酘酙酛酜酟酠酦酧酨酫酭酳酺酻酼醀",
			4,
			"醆醈醊醎醏醓",
			6,
			"醜",
			5,
			"醤",
			5,
			"醫醬醰醱醲醳醶醷醸醹醻"
		],
		[
			"e180",
			"醼",
			10,
			"釈釋釐釒",
			9,
			"針",
			8,
			"帷幄幔幛幞幡岌屺岍岐岖岈岘岙岑岚岜岵岢岽岬岫岱岣峁岷峄峒峤峋峥崂崃崧崦崮崤崞崆崛嵘崾崴崽嵬嵛嵯嵝嵫嵋嵊嵩嵴嶂嶙嶝豳嶷巅彳彷徂徇徉後徕徙徜徨徭徵徼衢彡犭犰犴犷犸狃狁狎狍狒狨狯狩狲狴狷猁狳猃狺"
		],
		[
			"e240",
			"釦",
			62
		],
		[
			"e280",
			"鈥",
			32,
			"狻猗猓猡猊猞猝猕猢猹猥猬猸猱獐獍獗獠獬獯獾舛夥飧夤夂饣饧",
			5,
			"饴饷饽馀馄馇馊馍馐馑馓馔馕庀庑庋庖庥庠庹庵庾庳赓廒廑廛廨廪膺忄忉忖忏怃忮怄忡忤忾怅怆忪忭忸怙怵怦怛怏怍怩怫怊怿怡恸恹恻恺恂"
		],
		[
			"e340",
			"鉆",
			45,
			"鉵",
			16
		],
		[
			"e380",
			"銆",
			7,
			"銏",
			24,
			"恪恽悖悚悭悝悃悒悌悛惬悻悱惝惘惆惚悴愠愦愕愣惴愀愎愫慊慵憬憔憧憷懔懵忝隳闩闫闱闳闵闶闼闾阃阄阆阈阊阋阌阍阏阒阕阖阗阙阚丬爿戕氵汔汜汊沣沅沐沔沌汨汩汴汶沆沩泐泔沭泷泸泱泗沲泠泖泺泫泮沱泓泯泾"
		],
		[
			"e440",
			"銨",
			5,
			"銯",
			24,
			"鋉",
			31
		],
		[
			"e480",
			"鋩",
			32,
			"洹洧洌浃浈洇洄洙洎洫浍洮洵洚浏浒浔洳涑浯涞涠浞涓涔浜浠浼浣渚淇淅淞渎涿淠渑淦淝淙渖涫渌涮渫湮湎湫溲湟溆湓湔渲渥湄滟溱溘滠漭滢溥溧溽溻溷滗溴滏溏滂溟潢潆潇漤漕滹漯漶潋潴漪漉漩澉澍澌潸潲潼潺濑"
		],
		[
			"e540",
			"錊",
			51,
			"錿",
			10
		],
		[
			"e580",
			"鍊",
			31,
			"鍫濉澧澹澶濂濡濮濞濠濯瀚瀣瀛瀹瀵灏灞宀宄宕宓宥宸甯骞搴寤寮褰寰蹇謇辶迓迕迥迮迤迩迦迳迨逅逄逋逦逑逍逖逡逵逶逭逯遄遑遒遐遨遘遢遛暹遴遽邂邈邃邋彐彗彖彘尻咫屐屙孱屣屦羼弪弩弭艴弼鬻屮妁妃妍妩妪妣"
		],
		[
			"e640",
			"鍬",
			34,
			"鎐",
			27
		],
		[
			"e680",
			"鎬",
			29,
			"鏋鏌鏍妗姊妫妞妤姒妲妯姗妾娅娆姝娈姣姘姹娌娉娲娴娑娣娓婀婧婊婕娼婢婵胬媪媛婷婺媾嫫媲嫒嫔媸嫠嫣嫱嫖嫦嫘嫜嬉嬗嬖嬲嬷孀尕尜孚孥孳孑孓孢驵驷驸驺驿驽骀骁骅骈骊骐骒骓骖骘骛骜骝骟骠骢骣骥骧纟纡纣纥纨纩"
		],
		[
			"e740",
			"鏎",
			7,
			"鏗",
			54
		],
		[
			"e780",
			"鐎",
			32,
			"纭纰纾绀绁绂绉绋绌绐绔绗绛绠绡绨绫绮绯绱绲缍绶绺绻绾缁缂缃缇缈缋缌缏缑缒缗缙缜缛缟缡",
			6,
			"缪缫缬缭缯",
			4,
			"缵幺畿巛甾邕玎玑玮玢玟珏珂珑玷玳珀珉珈珥珙顼琊珩珧珞玺珲琏琪瑛琦琥琨琰琮琬"
		],
		[
			"e840",
			"鐯",
			14,
			"鐿",
			43,
			"鑬鑭鑮鑯"
		],
		[
			"e880",
			"鑰",
			20,
			"钑钖钘铇铏铓铔铚铦铻锜锠琛琚瑁瑜瑗瑕瑙瑷瑭瑾璜璎璀璁璇璋璞璨璩璐璧瓒璺韪韫韬杌杓杞杈杩枥枇杪杳枘枧杵枨枞枭枋杷杼柰栉柘栊柩枰栌柙枵柚枳柝栀柃枸柢栎柁柽栲栳桠桡桎桢桄桤梃栝桕桦桁桧桀栾桊桉栩梵梏桴桷梓桫棂楮棼椟椠棹"
		],
		[
			"e940",
			"锧锳锽镃镈镋镕镚镠镮镴镵長",
			7,
			"門",
			42
		],
		[
			"e980",
			"閫",
			32,
			"椤棰椋椁楗棣椐楱椹楠楂楝榄楫榀榘楸椴槌榇榈槎榉楦楣楹榛榧榻榫榭槔榱槁槊槟榕槠榍槿樯槭樗樘橥槲橄樾檠橐橛樵檎橹樽樨橘橼檑檐檩檗檫猷獒殁殂殇殄殒殓殍殚殛殡殪轫轭轱轲轳轵轶轸轷轹轺轼轾辁辂辄辇辋"
		],
		[
			"ea40",
			"闌",
			27,
			"闬闿阇阓阘阛阞阠阣",
			6,
			"阫阬阭阯阰阷阸阹阺阾陁陃陊陎陏陑陒陓陖陗"
		],
		[
			"ea80",
			"陘陙陚陜陝陞陠陣陥陦陫陭",
			4,
			"陳陸",
			12,
			"隇隉隊辍辎辏辘辚軎戋戗戛戟戢戡戥戤戬臧瓯瓴瓿甏甑甓攴旮旯旰昊昙杲昃昕昀炅曷昝昴昱昶昵耆晟晔晁晏晖晡晗晷暄暌暧暝暾曛曜曦曩贲贳贶贻贽赀赅赆赈赉赇赍赕赙觇觊觋觌觎觏觐觑牮犟牝牦牯牾牿犄犋犍犏犒挈挲掰"
		],
		[
			"eb40",
			"隌階隑隒隓隕隖隚際隝",
			9,
			"隨",
			7,
			"隱隲隴隵隷隸隺隻隿雂雃雈雊雋雐雑雓雔雖",
			9,
			"雡",
			6,
			"雫"
		],
		[
			"eb80",
			"雬雭雮雰雱雲雴雵雸雺電雼雽雿霂霃霅霊霋霌霐霑霒霔霕霗",
			4,
			"霝霟霠搿擘耄毪毳毽毵毹氅氇氆氍氕氘氙氚氡氩氤氪氲攵敕敫牍牒牖爰虢刖肟肜肓肼朊肽肱肫肭肴肷胧胨胩胪胛胂胄胙胍胗朐胝胫胱胴胭脍脎胲胼朕脒豚脶脞脬脘脲腈腌腓腴腙腚腱腠腩腼腽腭腧塍媵膈膂膑滕膣膪臌朦臊膻"
		],
		[
			"ec40",
			"霡",
			8,
			"霫霬霮霯霱霳",
			4,
			"霺霻霼霽霿",
			18,
			"靔靕靗靘靚靜靝靟靣靤靦靧靨靪",
			7
		],
		[
			"ec80",
			"靲靵靷",
			4,
			"靽",
			7,
			"鞆",
			4,
			"鞌鞎鞏鞐鞓鞕鞖鞗鞙",
			4,
			"臁膦欤欷欹歃歆歙飑飒飓飕飙飚殳彀毂觳斐齑斓於旆旄旃旌旎旒旖炀炜炖炝炻烀炷炫炱烨烊焐焓焖焯焱煳煜煨煅煲煊煸煺熘熳熵熨熠燠燔燧燹爝爨灬焘煦熹戾戽扃扈扉礻祀祆祉祛祜祓祚祢祗祠祯祧祺禅禊禚禧禳忑忐"
		],
		[
			"ed40",
			"鞞鞟鞡鞢鞤",
			6,
			"鞬鞮鞰鞱鞳鞵",
			46
		],
		[
			"ed80",
			"韤韥韨韮",
			4,
			"韴韷",
			23,
			"怼恝恚恧恁恙恣悫愆愍慝憩憝懋懑戆肀聿沓泶淼矶矸砀砉砗砘砑斫砭砜砝砹砺砻砟砼砥砬砣砩硎硭硖硗砦硐硇硌硪碛碓碚碇碜碡碣碲碹碥磔磙磉磬磲礅磴礓礤礞礴龛黹黻黼盱眄眍盹眇眈眚眢眙眭眦眵眸睐睑睇睃睚睨"
		],
		[
			"ee40",
			"頏",
			62
		],
		[
			"ee80",
			"顎",
			32,
			"睢睥睿瞍睽瞀瞌瞑瞟瞠瞰瞵瞽町畀畎畋畈畛畲畹疃罘罡罟詈罨罴罱罹羁罾盍盥蠲钅钆钇钋钊钌钍钏钐钔钗钕钚钛钜钣钤钫钪钭钬钯钰钲钴钶",
			4,
			"钼钽钿铄铈",
			6,
			"铐铑铒铕铖铗铙铘铛铞铟铠铢铤铥铧铨铪"
		],
		[
			"ef40",
			"顯",
			5,
			"颋颎颒颕颙颣風",
			37,
			"飏飐飔飖飗飛飜飝飠",
			4
		],
		[
			"ef80",
			"飥飦飩",
			30,
			"铩铫铮铯铳铴铵铷铹铼铽铿锃锂锆锇锉锊锍锎锏锒",
			4,
			"锘锛锝锞锟锢锪锫锩锬锱锲锴锶锷锸锼锾锿镂锵镄镅镆镉镌镎镏镒镓镔镖镗镘镙镛镞镟镝镡镢镤",
			8,
			"镯镱镲镳锺矧矬雉秕秭秣秫稆嵇稃稂稞稔"
		],
		[
			"f040",
			"餈",
			4,
			"餎餏餑",
			28,
			"餯",
			26
		],
		[
			"f080",
			"饊",
			9,
			"饖",
			12,
			"饤饦饳饸饹饻饾馂馃馉稹稷穑黏馥穰皈皎皓皙皤瓞瓠甬鸠鸢鸨",
			4,
			"鸲鸱鸶鸸鸷鸹鸺鸾鹁鹂鹄鹆鹇鹈鹉鹋鹌鹎鹑鹕鹗鹚鹛鹜鹞鹣鹦",
			6,
			"鹱鹭鹳疒疔疖疠疝疬疣疳疴疸痄疱疰痃痂痖痍痣痨痦痤痫痧瘃痱痼痿瘐瘀瘅瘌瘗瘊瘥瘘瘕瘙"
		],
		[
			"f140",
			"馌馎馚",
			10,
			"馦馧馩",
			47
		],
		[
			"f180",
			"駙",
			32,
			"瘛瘼瘢瘠癀瘭瘰瘿瘵癃瘾瘳癍癞癔癜癖癫癯翊竦穸穹窀窆窈窕窦窠窬窨窭窳衤衩衲衽衿袂袢裆袷袼裉裢裎裣裥裱褚裼裨裾裰褡褙褓褛褊褴褫褶襁襦襻疋胥皲皴矜耒耔耖耜耠耢耥耦耧耩耨耱耋耵聃聆聍聒聩聱覃顸颀颃"
		],
		[
			"f240",
			"駺",
			62
		],
		[
			"f280",
			"騹",
			32,
			"颉颌颍颏颔颚颛颞颟颡颢颥颦虍虔虬虮虿虺虼虻蚨蚍蚋蚬蚝蚧蚣蚪蚓蚩蚶蛄蚵蛎蚰蚺蚱蚯蛉蛏蚴蛩蛱蛲蛭蛳蛐蜓蛞蛴蛟蛘蛑蜃蜇蛸蜈蜊蜍蜉蜣蜻蜞蜥蜮蜚蜾蝈蜴蜱蜩蜷蜿螂蜢蝽蝾蝻蝠蝰蝌蝮螋蝓蝣蝼蝤蝙蝥螓螯螨蟒"
		],
		[
			"f340",
			"驚",
			17,
			"驲骃骉骍骎骔骕骙骦骩",
			6,
			"骲骳骴骵骹骻骽骾骿髃髄髆",
			4,
			"髍髎髏髐髒體髕髖髗髙髚髛髜"
		],
		[
			"f380",
			"髝髞髠髢髣髤髥髧髨髩髪髬髮髰",
			8,
			"髺髼",
			6,
			"鬄鬅鬆蟆螈螅螭螗螃螫蟥螬螵螳蟋蟓螽蟑蟀蟊蟛蟪蟠蟮蠖蠓蟾蠊蠛蠡蠹蠼缶罂罄罅舐竺竽笈笃笄笕笊笫笏筇笸笪笙笮笱笠笥笤笳笾笞筘筚筅筵筌筝筠筮筻筢筲筱箐箦箧箸箬箝箨箅箪箜箢箫箴篑篁篌篝篚篥篦篪簌篾篼簏簖簋"
		],
		[
			"f440",
			"鬇鬉",
			5,
			"鬐鬑鬒鬔",
			10,
			"鬠鬡鬢鬤",
			10,
			"鬰鬱鬳",
			7,
			"鬽鬾鬿魀魆魊魋魌魎魐魒魓魕",
			5
		],
		[
			"f480",
			"魛",
			32,
			"簟簪簦簸籁籀臾舁舂舄臬衄舡舢舣舭舯舨舫舸舻舳舴舾艄艉艋艏艚艟艨衾袅袈裘裟襞羝羟羧羯羰羲籼敉粑粝粜粞粢粲粼粽糁糇糌糍糈糅糗糨艮暨羿翎翕翥翡翦翩翮翳糸絷綦綮繇纛麸麴赳趄趔趑趱赧赭豇豉酊酐酎酏酤"
		],
		[
			"f540",
			"魼",
			62
		],
		[
			"f580",
			"鮻",
			32,
			"酢酡酰酩酯酽酾酲酴酹醌醅醐醍醑醢醣醪醭醮醯醵醴醺豕鹾趸跫踅蹙蹩趵趿趼趺跄跖跗跚跞跎跏跛跆跬跷跸跣跹跻跤踉跽踔踝踟踬踮踣踯踺蹀踹踵踽踱蹉蹁蹂蹑蹒蹊蹰蹶蹼蹯蹴躅躏躔躐躜躞豸貂貊貅貘貔斛觖觞觚觜"
		],
		[
			"f640",
			"鯜",
			62
		],
		[
			"f680",
			"鰛",
			32,
			"觥觫觯訾謦靓雩雳雯霆霁霈霏霎霪霭霰霾龀龃龅",
			5,
			"龌黾鼋鼍隹隼隽雎雒瞿雠銎銮鋈錾鍪鏊鎏鐾鑫鱿鲂鲅鲆鲇鲈稣鲋鲎鲐鲑鲒鲔鲕鲚鲛鲞",
			5,
			"鲥",
			4,
			"鲫鲭鲮鲰",
			7,
			"鲺鲻鲼鲽鳄鳅鳆鳇鳊鳋"
		],
		[
			"f740",
			"鰼",
			62
		],
		[
			"f780",
			"鱻鱽鱾鲀鲃鲄鲉鲊鲌鲏鲓鲖鲗鲘鲙鲝鲪鲬鲯鲹鲾",
			4,
			"鳈鳉鳑鳒鳚鳛鳠鳡鳌",
			4,
			"鳓鳔鳕鳗鳘鳙鳜鳝鳟鳢靼鞅鞑鞒鞔鞯鞫鞣鞲鞴骱骰骷鹘骶骺骼髁髀髅髂髋髌髑魅魃魇魉魈魍魑飨餍餮饕饔髟髡髦髯髫髻髭髹鬈鬏鬓鬟鬣麽麾縻麂麇麈麋麒鏖麝麟黛黜黝黠黟黢黩黧黥黪黯鼢鼬鼯鼹鼷鼽鼾齄"
		],
		[
			"f840",
			"鳣",
			62
		],
		[
			"f880",
			"鴢",
			32
		],
		[
			"f940",
			"鵃",
			62
		],
		[
			"f980",
			"鶂",
			32
		],
		[
			"fa40",
			"鶣",
			62
		],
		[
			"fa80",
			"鷢",
			32
		],
		[
			"fb40",
			"鸃",
			27,
			"鸤鸧鸮鸰鸴鸻鸼鹀鹍鹐鹒鹓鹔鹖鹙鹝鹟鹠鹡鹢鹥鹮鹯鹲鹴",
			9,
			"麀"
		],
		[
			"fb80",
			"麁麃麄麅麆麉麊麌",
			5,
			"麔",
			8,
			"麞麠",
			5,
			"麧麨麩麪"
		],
		[
			"fc40",
			"麫",
			8,
			"麵麶麷麹麺麼麿",
			4,
			"黅黆黇黈黊黋黌黐黒黓黕黖黗黙黚點黡黣黤黦黨黫黬黭黮黰",
			8,
			"黺黽黿",
			6
		],
		[
			"fc80",
			"鼆",
			4,
			"鼌鼏鼑鼒鼔鼕鼖鼘鼚",
			5,
			"鼡鼣",
			8,
			"鼭鼮鼰鼱"
		],
		[
			"fd40",
			"鼲",
			4,
			"鼸鼺鼼鼿",
			4,
			"齅",
			10,
			"齒",
			38
		],
		[
			"fd80",
			"齹",
			5,
			"龁龂龍",
			11,
			"龜龝龞龡",
			4,
			"郎凉秊裏隣"
		],
		[
			"fe40",
			"兀嗀﨎﨏﨑﨓﨔礼﨟蘒﨡﨣﨤﨧﨨﨩"
		]
	];

/***/ },
/* 33 */
/***/ function(module, exports) {

	module.exports = [
		[
			"a140",
			"",
			62
		],
		[
			"a180",
			"",
			32
		],
		[
			"a240",
			"",
			62
		],
		[
			"a280",
			"",
			32
		],
		[
			"a2ab",
			"",
			5
		],
		[
			"a2e3",
			"€"
		],
		[
			"a2ef",
			""
		],
		[
			"a2fd",
			""
		],
		[
			"a340",
			"",
			62
		],
		[
			"a380",
			"",
			31,
			"　"
		],
		[
			"a440",
			"",
			62
		],
		[
			"a480",
			"",
			32
		],
		[
			"a4f4",
			"",
			10
		],
		[
			"a540",
			"",
			62
		],
		[
			"a580",
			"",
			32
		],
		[
			"a5f7",
			"",
			7
		],
		[
			"a640",
			"",
			62
		],
		[
			"a680",
			"",
			32
		],
		[
			"a6b9",
			"",
			7
		],
		[
			"a6d9",
			"",
			6
		],
		[
			"a6ec",
			""
		],
		[
			"a6f3",
			""
		],
		[
			"a6f6",
			"",
			8
		],
		[
			"a740",
			"",
			62
		],
		[
			"a780",
			"",
			32
		],
		[
			"a7c2",
			"",
			14
		],
		[
			"a7f2",
			"",
			12
		],
		[
			"a896",
			"",
			10
		],
		[
			"a8bc",
			""
		],
		[
			"a8bf",
			"ǹ"
		],
		[
			"a8c1",
			""
		],
		[
			"a8ea",
			"",
			20
		],
		[
			"a958",
			""
		],
		[
			"a95b",
			""
		],
		[
			"a95d",
			""
		],
		[
			"a989",
			"〾⿰",
			11
		],
		[
			"a997",
			"",
			12
		],
		[
			"a9f0",
			"",
			14
		],
		[
			"aaa1",
			"",
			93
		],
		[
			"aba1",
			"",
			93
		],
		[
			"aca1",
			"",
			93
		],
		[
			"ada1",
			"",
			93
		],
		[
			"aea1",
			"",
			93
		],
		[
			"afa1",
			"",
			93
		],
		[
			"d7fa",
			"",
			4
		],
		[
			"f8a1",
			"",
			93
		],
		[
			"f9a1",
			"",
			93
		],
		[
			"faa1",
			"",
			93
		],
		[
			"fba1",
			"",
			93
		],
		[
			"fca1",
			"",
			93
		],
		[
			"fda1",
			"",
			93
		],
		[
			"fe50",
			"⺁⺄㑳㑇⺈⺋㖞㘚㘎⺌⺗㥮㤘㧏㧟㩳㧐㭎㱮㳠⺧⺪䁖䅟⺮䌷⺳⺶⺷䎱䎬⺻䏝䓖䙡䙌"
		],
		[
			"fe80",
			"䜣䜩䝼䞍⻊䥇䥺䥽䦂䦃䦅䦆䦟䦛䦷䦶䲣䲟䲠䲡䱷䲢䴓",
			6,
			"䶮",
			93
		]
	];

/***/ },
/* 34 */
/***/ function(module, exports) {

	module.exports = {
		"uChars": [
			128,
			165,
			169,
			178,
			184,
			216,
			226,
			235,
			238,
			244,
			248,
			251,
			253,
			258,
			276,
			284,
			300,
			325,
			329,
			334,
			364,
			463,
			465,
			467,
			469,
			471,
			473,
			475,
			477,
			506,
			594,
			610,
			712,
			716,
			730,
			930,
			938,
			962,
			970,
			1026,
			1104,
			1106,
			8209,
			8215,
			8218,
			8222,
			8231,
			8241,
			8244,
			8246,
			8252,
			8365,
			8452,
			8454,
			8458,
			8471,
			8482,
			8556,
			8570,
			8596,
			8602,
			8713,
			8720,
			8722,
			8726,
			8731,
			8737,
			8740,
			8742,
			8748,
			8751,
			8760,
			8766,
			8777,
			8781,
			8787,
			8802,
			8808,
			8816,
			8854,
			8858,
			8870,
			8896,
			8979,
			9322,
			9372,
			9548,
			9588,
			9616,
			9622,
			9634,
			9652,
			9662,
			9672,
			9676,
			9680,
			9702,
			9735,
			9738,
			9793,
			9795,
			11906,
			11909,
			11913,
			11917,
			11928,
			11944,
			11947,
			11951,
			11956,
			11960,
			11964,
			11979,
			12284,
			12292,
			12312,
			12319,
			12330,
			12351,
			12436,
			12447,
			12535,
			12543,
			12586,
			12842,
			12850,
			12964,
			13200,
			13215,
			13218,
			13253,
			13263,
			13267,
			13270,
			13384,
			13428,
			13727,
			13839,
			13851,
			14617,
			14703,
			14801,
			14816,
			14964,
			15183,
			15471,
			15585,
			16471,
			16736,
			17208,
			17325,
			17330,
			17374,
			17623,
			17997,
			18018,
			18212,
			18218,
			18301,
			18318,
			18760,
			18811,
			18814,
			18820,
			18823,
			18844,
			18848,
			18872,
			19576,
			19620,
			19738,
			19887,
			40870,
			59244,
			59336,
			59367,
			59413,
			59417,
			59423,
			59431,
			59437,
			59443,
			59452,
			59460,
			59478,
			59493,
			63789,
			63866,
			63894,
			63976,
			63986,
			64016,
			64018,
			64021,
			64025,
			64034,
			64037,
			64042,
			65074,
			65093,
			65107,
			65112,
			65127,
			65132,
			65375,
			65510,
			65536
		],
		"gbChars": [
			0,
			36,
			38,
			45,
			50,
			81,
			89,
			95,
			96,
			100,
			103,
			104,
			105,
			109,
			126,
			133,
			148,
			172,
			175,
			179,
			208,
			306,
			307,
			308,
			309,
			310,
			311,
			312,
			313,
			341,
			428,
			443,
			544,
			545,
			558,
			741,
			742,
			749,
			750,
			805,
			819,
			820,
			7922,
			7924,
			7925,
			7927,
			7934,
			7943,
			7944,
			7945,
			7950,
			8062,
			8148,
			8149,
			8152,
			8164,
			8174,
			8236,
			8240,
			8262,
			8264,
			8374,
			8380,
			8381,
			8384,
			8388,
			8390,
			8392,
			8393,
			8394,
			8396,
			8401,
			8406,
			8416,
			8419,
			8424,
			8437,
			8439,
			8445,
			8482,
			8485,
			8496,
			8521,
			8603,
			8936,
			8946,
			9046,
			9050,
			9063,
			9066,
			9076,
			9092,
			9100,
			9108,
			9111,
			9113,
			9131,
			9162,
			9164,
			9218,
			9219,
			11329,
			11331,
			11334,
			11336,
			11346,
			11361,
			11363,
			11366,
			11370,
			11372,
			11375,
			11389,
			11682,
			11686,
			11687,
			11692,
			11694,
			11714,
			11716,
			11723,
			11725,
			11730,
			11736,
			11982,
			11989,
			12102,
			12336,
			12348,
			12350,
			12384,
			12393,
			12395,
			12397,
			12510,
			12553,
			12851,
			12962,
			12973,
			13738,
			13823,
			13919,
			13933,
			14080,
			14298,
			14585,
			14698,
			15583,
			15847,
			16318,
			16434,
			16438,
			16481,
			16729,
			17102,
			17122,
			17315,
			17320,
			17402,
			17418,
			17859,
			17909,
			17911,
			17915,
			17916,
			17936,
			17939,
			17961,
			18664,
			18703,
			18814,
			18962,
			19043,
			33469,
			33470,
			33471,
			33484,
			33485,
			33490,
			33497,
			33501,
			33505,
			33513,
			33520,
			33536,
			33550,
			37845,
			37921,
			37948,
			38029,
			38038,
			38064,
			38065,
			38066,
			38069,
			38075,
			38076,
			38078,
			39108,
			39109,
			39113,
			39114,
			39115,
			39116,
			39265,
			39394,
			189000
		]
	};

/***/ },
/* 35 */
/***/ function(module, exports) {

	module.exports = [
		[
			"0",
			"\u0000",
			127
		],
		[
			"8141",
			"갂갃갅갆갋",
			4,
			"갘갞갟갡갢갣갥",
			6,
			"갮갲갳갴"
		],
		[
			"8161",
			"갵갶갷갺갻갽갾갿걁",
			9,
			"걌걎",
			5,
			"걕"
		],
		[
			"8181",
			"걖걗걙걚걛걝",
			18,
			"걲걳걵걶걹걻",
			4,
			"겂겇겈겍겎겏겑겒겓겕",
			6,
			"겞겢",
			5,
			"겫겭겮겱",
			6,
			"겺겾겿곀곂곃곅곆곇곉곊곋곍",
			7,
			"곖곘",
			7,
			"곢곣곥곦곩곫곭곮곲곴곷",
			4,
			"곾곿괁괂괃괅괇",
			4,
			"괎괐괒괓"
		],
		[
			"8241",
			"괔괕괖괗괙괚괛괝괞괟괡",
			7,
			"괪괫괮",
			5
		],
		[
			"8261",
			"괶괷괹괺괻괽",
			6,
			"굆굈굊",
			5,
			"굑굒굓굕굖굗"
		],
		[
			"8281",
			"굙",
			7,
			"굢굤",
			7,
			"굮굯굱굲굷굸굹굺굾궀궃",
			4,
			"궊궋궍궎궏궑",
			10,
			"궞",
			5,
			"궥",
			17,
			"궸",
			7,
			"귂귃귅귆귇귉",
			6,
			"귒귔",
			7,
			"귝귞귟귡귢귣귥",
			18
		],
		[
			"8341",
			"귺귻귽귾긂",
			5,
			"긊긌긎",
			5,
			"긕",
			7
		],
		[
			"8361",
			"긝",
			18,
			"긲긳긵긶긹긻긼"
		],
		[
			"8381",
			"긽긾긿깂깄깇깈깉깋깏깑깒깓깕깗",
			4,
			"깞깢깣깤깦깧깪깫깭깮깯깱",
			6,
			"깺깾",
			5,
			"꺆",
			5,
			"꺍",
			46,
			"꺿껁껂껃껅",
			6,
			"껎껒",
			5,
			"껚껛껝",
			8
		],
		[
			"8441",
			"껦껧껩껪껬껮",
			5,
			"껵껶껷껹껺껻껽",
			8
		],
		[
			"8461",
			"꼆꼉꼊꼋꼌꼎꼏꼑",
			18
		],
		[
			"8481",
			"꼤",
			7,
			"꼮꼯꼱꼳꼵",
			6,
			"꼾꽀꽄꽅꽆꽇꽊",
			5,
			"꽑",
			10,
			"꽞",
			5,
			"꽦",
			18,
			"꽺",
			5,
			"꾁꾂꾃꾅꾆꾇꾉",
			6,
			"꾒꾓꾔꾖",
			5,
			"꾝",
			26,
			"꾺꾻꾽꾾"
		],
		[
			"8541",
			"꾿꿁",
			5,
			"꿊꿌꿏",
			4,
			"꿕",
			6,
			"꿝",
			4
		],
		[
			"8561",
			"꿢",
			5,
			"꿪",
			5,
			"꿲꿳꿵꿶꿷꿹",
			6,
			"뀂뀃"
		],
		[
			"8581",
			"뀅",
			6,
			"뀍뀎뀏뀑뀒뀓뀕",
			6,
			"뀞",
			9,
			"뀩",
			26,
			"끆끇끉끋끍끏끐끑끒끖끘끚끛끜끞",
			29,
			"끾끿낁낂낃낅",
			6,
			"낎낐낒",
			5,
			"낛낝낞낣낤"
		],
		[
			"8641",
			"낥낦낧낪낰낲낶낷낹낺낻낽",
			6,
			"냆냊",
			5,
			"냒"
		],
		[
			"8661",
			"냓냕냖냗냙",
			6,
			"냡냢냣냤냦",
			10
		],
		[
			"8681",
			"냱",
			22,
			"넊넍넎넏넑넔넕넖넗넚넞",
			4,
			"넦넧넩넪넫넭",
			6,
			"넶넺",
			5,
			"녂녃녅녆녇녉",
			6,
			"녒녓녖녗녙녚녛녝녞녟녡",
			22,
			"녺녻녽녾녿놁놃",
			4,
			"놊놌놎놏놐놑놕놖놗놙놚놛놝"
		],
		[
			"8741",
			"놞",
			9,
			"놩",
			15
		],
		[
			"8761",
			"놹",
			18,
			"뇍뇎뇏뇑뇒뇓뇕"
		],
		[
			"8781",
			"뇖",
			5,
			"뇞뇠",
			7,
			"뇪뇫뇭뇮뇯뇱",
			7,
			"뇺뇼뇾",
			5,
			"눆눇눉눊눍",
			6,
			"눖눘눚",
			5,
			"눡",
			18,
			"눵",
			6,
			"눽",
			26,
			"뉙뉚뉛뉝뉞뉟뉡",
			6,
			"뉪",
			4
		],
		[
			"8841",
			"뉯",
			4,
			"뉶",
			5,
			"뉽",
			6,
			"늆늇늈늊",
			4
		],
		[
			"8861",
			"늏늒늓늕늖늗늛",
			4,
			"늢늤늧늨늩늫늭늮늯늱늲늳늵늶늷"
		],
		[
			"8881",
			"늸",
			15,
			"닊닋닍닎닏닑닓",
			4,
			"닚닜닞닟닠닡닣닧닩닪닰닱닲닶닼닽닾댂댃댅댆댇댉",
			6,
			"댒댖",
			5,
			"댝",
			54,
			"덗덙덚덝덠덡덢덣"
		],
		[
			"8941",
			"덦덨덪덬덭덯덲덳덵덶덷덹",
			6,
			"뎂뎆",
			5,
			"뎍"
		],
		[
			"8961",
			"뎎뎏뎑뎒뎓뎕",
			10,
			"뎢",
			5,
			"뎩뎪뎫뎭"
		],
		[
			"8981",
			"뎮",
			21,
			"돆돇돉돊돍돏돑돒돓돖돘돚돜돞돟돡돢돣돥돦돧돩",
			18,
			"돽",
			18,
			"됑",
			6,
			"됙됚됛됝됞됟됡",
			6,
			"됪됬",
			7,
			"됵",
			15
		],
		[
			"8a41",
			"둅",
			10,
			"둒둓둕둖둗둙",
			6,
			"둢둤둦"
		],
		[
			"8a61",
			"둧",
			4,
			"둭",
			18,
			"뒁뒂"
		],
		[
			"8a81",
			"뒃",
			4,
			"뒉",
			19,
			"뒞",
			5,
			"뒥뒦뒧뒩뒪뒫뒭",
			7,
			"뒶뒸뒺",
			5,
			"듁듂듃듅듆듇듉",
			6,
			"듑듒듓듔듖",
			5,
			"듞듟듡듢듥듧",
			4,
			"듮듰듲",
			5,
			"듹",
			26,
			"딖딗딙딚딝"
		],
		[
			"8b41",
			"딞",
			5,
			"딦딫",
			4,
			"딲딳딵딶딷딹",
			6,
			"땂땆"
		],
		[
			"8b61",
			"땇땈땉땊땎땏땑땒땓땕",
			6,
			"땞땢",
			8
		],
		[
			"8b81",
			"땫",
			52,
			"떢떣떥떦떧떩떬떭떮떯떲떶",
			4,
			"떾떿뗁뗂뗃뗅",
			6,
			"뗎뗒",
			5,
			"뗙",
			18,
			"뗭",
			18
		],
		[
			"8c41",
			"똀",
			15,
			"똒똓똕똖똗똙",
			4
		],
		[
			"8c61",
			"똞",
			6,
			"똦",
			5,
			"똭",
			6,
			"똵",
			5
		],
		[
			"8c81",
			"똻",
			12,
			"뙉",
			26,
			"뙥뙦뙧뙩",
			50,
			"뚞뚟뚡뚢뚣뚥",
			5,
			"뚭뚮뚯뚰뚲",
			16
		],
		[
			"8d41",
			"뛃",
			16,
			"뛕",
			8
		],
		[
			"8d61",
			"뛞",
			17,
			"뛱뛲뛳뛵뛶뛷뛹뛺"
		],
		[
			"8d81",
			"뛻",
			4,
			"뜂뜃뜄뜆",
			33,
			"뜪뜫뜭뜮뜱",
			6,
			"뜺뜼",
			7,
			"띅띆띇띉띊띋띍",
			6,
			"띖",
			9,
			"띡띢띣띥띦띧띩",
			6,
			"띲띴띶",
			5,
			"띾띿랁랂랃랅",
			6,
			"랎랓랔랕랚랛랝랞"
		],
		[
			"8e41",
			"랟랡",
			6,
			"랪랮",
			5,
			"랶랷랹",
			8
		],
		[
			"8e61",
			"럂",
			4,
			"럈럊",
			19
		],
		[
			"8e81",
			"럞",
			13,
			"럮럯럱럲럳럵",
			6,
			"럾렂",
			4,
			"렊렋렍렎렏렑",
			6,
			"렚렜렞",
			5,
			"렦렧렩렪렫렭",
			6,
			"렶렺",
			5,
			"롁롂롃롅",
			11,
			"롒롔",
			7,
			"롞롟롡롢롣롥",
			6,
			"롮롰롲",
			5,
			"롹롺롻롽",
			7
		],
		[
			"8f41",
			"뢅",
			7,
			"뢎",
			17
		],
		[
			"8f61",
			"뢠",
			7,
			"뢩",
			6,
			"뢱뢲뢳뢵뢶뢷뢹",
			4
		],
		[
			"8f81",
			"뢾뢿룂룄룆",
			5,
			"룍룎룏룑룒룓룕",
			7,
			"룞룠룢",
			5,
			"룪룫룭룮룯룱",
			6,
			"룺룼룾",
			5,
			"뤅",
			18,
			"뤙",
			6,
			"뤡",
			26,
			"뤾뤿륁륂륃륅",
			6,
			"륍륎륐륒",
			5
		],
		[
			"9041",
			"륚륛륝륞륟륡",
			6,
			"륪륬륮",
			5,
			"륶륷륹륺륻륽"
		],
		[
			"9061",
			"륾",
			5,
			"릆릈릋릌릏",
			15
		],
		[
			"9081",
			"릟",
			12,
			"릮릯릱릲릳릵",
			6,
			"릾맀맂",
			5,
			"맊맋맍맓",
			4,
			"맚맜맟맠맢맦맧맩맪맫맭",
			6,
			"맶맻",
			4,
			"먂",
			5,
			"먉",
			11,
			"먖",
			33,
			"먺먻먽먾먿멁멃멄멅멆"
		],
		[
			"9141",
			"멇멊멌멏멐멑멒멖멗멙멚멛멝",
			6,
			"멦멪",
			5
		],
		[
			"9161",
			"멲멳멵멶멷멹",
			9,
			"몆몈몉몊몋몍",
			5
		],
		[
			"9181",
			"몓",
			20,
			"몪몭몮몯몱몳",
			4,
			"몺몼몾",
			5,
			"뫅뫆뫇뫉",
			14,
			"뫚",
			33,
			"뫽뫾뫿묁묂묃묅",
			7,
			"묎묐묒",
			5,
			"묙묚묛묝묞묟묡",
			6
		],
		[
			"9241",
			"묨묪묬",
			7,
			"묷묹묺묿",
			4,
			"뭆뭈뭊뭋뭌뭎뭑뭒"
		],
		[
			"9261",
			"뭓뭕뭖뭗뭙",
			7,
			"뭢뭤",
			7,
			"뭭",
			4
		],
		[
			"9281",
			"뭲",
			21,
			"뮉뮊뮋뮍뮎뮏뮑",
			18,
			"뮥뮦뮧뮩뮪뮫뮭",
			6,
			"뮵뮶뮸",
			7,
			"믁믂믃믅믆믇믉",
			6,
			"믑믒믔",
			35,
			"믺믻믽믾밁"
		],
		[
			"9341",
			"밃",
			4,
			"밊밎밐밒밓밙밚밠밡밢밣밦밨밪밫밬밮밯밲밳밵"
		],
		[
			"9361",
			"밶밷밹",
			6,
			"뱂뱆뱇뱈뱊뱋뱎뱏뱑",
			8
		],
		[
			"9381",
			"뱚뱛뱜뱞",
			37,
			"벆벇벉벊벍벏",
			4,
			"벖벘벛",
			4,
			"벢벣벥벦벩",
			6,
			"벲벶",
			5,
			"벾벿볁볂볃볅",
			7,
			"볎볒볓볔볖볗볙볚볛볝",
			22,
			"볷볹볺볻볽"
		],
		[
			"9441",
			"볾",
			5,
			"봆봈봊",
			5,
			"봑봒봓봕",
			8
		],
		[
			"9461",
			"봞",
			5,
			"봥",
			6,
			"봭",
			12
		],
		[
			"9481",
			"봺",
			5,
			"뵁",
			6,
			"뵊뵋뵍뵎뵏뵑",
			6,
			"뵚",
			9,
			"뵥뵦뵧뵩",
			22,
			"붂붃붅붆붋",
			4,
			"붒붔붖붗붘붛붝",
			6,
			"붥",
			10,
			"붱",
			6,
			"붹",
			24
		],
		[
			"9541",
			"뷒뷓뷖뷗뷙뷚뷛뷝",
			11,
			"뷪",
			5,
			"뷱"
		],
		[
			"9561",
			"뷲뷳뷵뷶뷷뷹",
			6,
			"븁븂븄븆",
			5,
			"븎븏븑븒븓"
		],
		[
			"9581",
			"븕",
			6,
			"븞븠",
			35,
			"빆빇빉빊빋빍빏",
			4,
			"빖빘빜빝빞빟빢빣빥빦빧빩빫",
			4,
			"빲빶",
			4,
			"빾빿뺁뺂뺃뺅",
			6,
			"뺎뺒",
			5,
			"뺚",
			13,
			"뺩",
			14
		],
		[
			"9641",
			"뺸",
			23,
			"뻒뻓"
		],
		[
			"9661",
			"뻕뻖뻙",
			6,
			"뻡뻢뻦",
			5,
			"뻭",
			8
		],
		[
			"9681",
			"뻶",
			10,
			"뼂",
			5,
			"뼊",
			13,
			"뼚뼞",
			33,
			"뽂뽃뽅뽆뽇뽉",
			6,
			"뽒뽓뽔뽖",
			44
		],
		[
			"9741",
			"뾃",
			16,
			"뾕",
			8
		],
		[
			"9761",
			"뾞",
			17,
			"뾱",
			7
		],
		[
			"9781",
			"뾹",
			11,
			"뿆",
			5,
			"뿎뿏뿑뿒뿓뿕",
			6,
			"뿝뿞뿠뿢",
			89,
			"쀽쀾쀿"
		],
		[
			"9841",
			"쁀",
			16,
			"쁒",
			5,
			"쁙쁚쁛"
		],
		[
			"9861",
			"쁝쁞쁟쁡",
			6,
			"쁪",
			15
		],
		[
			"9881",
			"쁺",
			21,
			"삒삓삕삖삗삙",
			6,
			"삢삤삦",
			5,
			"삮삱삲삷",
			4,
			"삾샂샃샄샆샇샊샋샍샎샏샑",
			6,
			"샚샞",
			5,
			"샦샧샩샪샫샭",
			6,
			"샶샸샺",
			5,
			"섁섂섃섅섆섇섉",
			6,
			"섑섒섓섔섖",
			5,
			"섡섢섥섨섩섪섫섮"
		],
		[
			"9941",
			"섲섳섴섵섷섺섻섽섾섿셁",
			6,
			"셊셎",
			5,
			"셖셗"
		],
		[
			"9961",
			"셙셚셛셝",
			6,
			"셦셪",
			5,
			"셱셲셳셵셶셷셹셺셻"
		],
		[
			"9981",
			"셼",
			8,
			"솆",
			5,
			"솏솑솒솓솕솗",
			4,
			"솞솠솢솣솤솦솧솪솫솭솮솯솱",
			11,
			"솾",
			5,
			"쇅쇆쇇쇉쇊쇋쇍",
			6,
			"쇕쇖쇙",
			6,
			"쇡쇢쇣쇥쇦쇧쇩",
			6,
			"쇲쇴",
			7,
			"쇾쇿숁숂숃숅",
			6,
			"숎숐숒",
			5,
			"숚숛숝숞숡숢숣"
		],
		[
			"9a41",
			"숤숥숦숧숪숬숮숰숳숵",
			16
		],
		[
			"9a61",
			"쉆쉇쉉",
			6,
			"쉒쉓쉕쉖쉗쉙",
			6,
			"쉡쉢쉣쉤쉦"
		],
		[
			"9a81",
			"쉧",
			4,
			"쉮쉯쉱쉲쉳쉵",
			6,
			"쉾슀슂",
			5,
			"슊",
			5,
			"슑",
			6,
			"슙슚슜슞",
			5,
			"슦슧슩슪슫슮",
			5,
			"슶슸슺",
			33,
			"싞싟싡싢싥",
			5,
			"싮싰싲싳싴싵싷싺싽싾싿쌁",
			6,
			"쌊쌋쌎쌏"
		],
		[
			"9b41",
			"쌐쌑쌒쌖쌗쌙쌚쌛쌝",
			6,
			"쌦쌧쌪",
			8
		],
		[
			"9b61",
			"쌳",
			17,
			"썆",
			7
		],
		[
			"9b81",
			"썎",
			25,
			"썪썫썭썮썯썱썳",
			4,
			"썺썻썾",
			5,
			"쎅쎆쎇쎉쎊쎋쎍",
			50,
			"쏁",
			22,
			"쏚"
		],
		[
			"9c41",
			"쏛쏝쏞쏡쏣",
			4,
			"쏪쏫쏬쏮",
			5,
			"쏶쏷쏹",
			5
		],
		[
			"9c61",
			"쏿",
			8,
			"쐉",
			6,
			"쐑",
			9
		],
		[
			"9c81",
			"쐛",
			8,
			"쐥",
			6,
			"쐭쐮쐯쐱쐲쐳쐵",
			6,
			"쐾",
			9,
			"쑉",
			26,
			"쑦쑧쑩쑪쑫쑭",
			6,
			"쑶쑷쑸쑺",
			5,
			"쒁",
			18,
			"쒕",
			6,
			"쒝",
			12
		],
		[
			"9d41",
			"쒪",
			13,
			"쒹쒺쒻쒽",
			8
		],
		[
			"9d61",
			"쓆",
			25
		],
		[
			"9d81",
			"쓠",
			8,
			"쓪",
			5,
			"쓲쓳쓵쓶쓷쓹쓻쓼쓽쓾씂",
			9,
			"씍씎씏씑씒씓씕",
			6,
			"씝",
			10,
			"씪씫씭씮씯씱",
			6,
			"씺씼씾",
			5,
			"앆앇앋앏앐앑앒앖앚앛앜앟앢앣앥앦앧앩",
			6,
			"앲앶",
			5,
			"앾앿얁얂얃얅얆얈얉얊얋얎얐얒얓얔"
		],
		[
			"9e41",
			"얖얙얚얛얝얞얟얡",
			7,
			"얪",
			9,
			"얶"
		],
		[
			"9e61",
			"얷얺얿",
			4,
			"엋엍엏엒엓엕엖엗엙",
			6,
			"엢엤엦엧"
		],
		[
			"9e81",
			"엨엩엪엫엯엱엲엳엵엸엹엺엻옂옃옄옉옊옋옍옎옏옑",
			6,
			"옚옝",
			6,
			"옦옧옩옪옫옯옱옲옶옸옺옼옽옾옿왂왃왅왆왇왉",
			6,
			"왒왖",
			5,
			"왞왟왡",
			10,
			"왭왮왰왲",
			5,
			"왺왻왽왾왿욁",
			6,
			"욊욌욎",
			5,
			"욖욗욙욚욛욝",
			6,
			"욦"
		],
		[
			"9f41",
			"욨욪",
			5,
			"욲욳욵욶욷욻",
			4,
			"웂웄웆",
			5,
			"웎"
		],
		[
			"9f61",
			"웏웑웒웓웕",
			6,
			"웞웟웢",
			5,
			"웪웫웭웮웯웱웲"
		],
		[
			"9f81",
			"웳",
			4,
			"웺웻웼웾",
			5,
			"윆윇윉윊윋윍",
			6,
			"윖윘윚",
			5,
			"윢윣윥윦윧윩",
			6,
			"윲윴윶윸윹윺윻윾윿읁읂읃읅",
			4,
			"읋읎읐읙읚읛읝읞읟읡",
			6,
			"읩읪읬",
			7,
			"읶읷읹읺읻읿잀잁잂잆잋잌잍잏잒잓잕잙잛",
			4,
			"잢잧",
			4,
			"잮잯잱잲잳잵잶잷"
		],
		[
			"a041",
			"잸잹잺잻잾쟂",
			5,
			"쟊쟋쟍쟏쟑",
			6,
			"쟙쟚쟛쟜"
		],
		[
			"a061",
			"쟞",
			5,
			"쟥쟦쟧쟩쟪쟫쟭",
			13
		],
		[
			"a081",
			"쟻",
			4,
			"젂젃젅젆젇젉젋",
			4,
			"젒젔젗",
			4,
			"젞젟젡젢젣젥",
			6,
			"젮젰젲",
			5,
			"젹젺젻젽젾젿졁",
			6,
			"졊졋졎",
			5,
			"졕",
			26,
			"졲졳졵졶졷졹졻",
			4,
			"좂좄좈좉좊좎",
			5,
			"좕",
			7,
			"좞좠좢좣좤"
		],
		[
			"a141",
			"좥좦좧좩",
			18,
			"좾좿죀죁"
		],
		[
			"a161",
			"죂죃죅죆죇죉죊죋죍",
			6,
			"죖죘죚",
			5,
			"죢죣죥"
		],
		[
			"a181",
			"죦",
			14,
			"죶",
			5,
			"죾죿줁줂줃줇",
			4,
			"줎　、。·‥…¨〃­―∥＼∼‘’“”〔〕〈",
			9,
			"±×÷≠≤≥∞∴°′″℃Å￠￡￥♂♀∠⊥⌒∂∇≡≒§※☆★○●◎◇◆□■△▲▽▼→←↑↓↔〓≪≫√∽∝∵∫∬∈∋⊆⊇⊂⊃∪∩∧∨￢"
		],
		[
			"a241",
			"줐줒",
			5,
			"줙",
			18
		],
		[
			"a261",
			"줭",
			6,
			"줵",
			18
		],
		[
			"a281",
			"쥈",
			7,
			"쥒쥓쥕쥖쥗쥙",
			6,
			"쥢쥤",
			7,
			"쥭쥮쥯⇒⇔∀∃´～ˇ˘˝˚˙¸˛¡¿ː∮∑∏¤℉‰◁◀▷▶♤♠♡♥♧♣⊙◈▣◐◑▒▤▥▨▧▦▩♨☏☎☜☞¶†‡↕↗↙↖↘♭♩♪♬㉿㈜№㏇™㏂㏘℡€®"
		],
		[
			"a341",
			"쥱쥲쥳쥵",
			6,
			"쥽",
			10,
			"즊즋즍즎즏"
		],
		[
			"a361",
			"즑",
			6,
			"즚즜즞",
			16
		],
		[
			"a381",
			"즯",
			16,
			"짂짃짅짆짉짋",
			4,
			"짒짔짗짘짛！",
			58,
			"￦］",
			32,
			"￣"
		],
		[
			"a441",
			"짞짟짡짣짥짦짨짩짪짫짮짲",
			5,
			"짺짻짽짾짿쨁쨂쨃쨄"
		],
		[
			"a461",
			"쨅쨆쨇쨊쨎",
			5,
			"쨕쨖쨗쨙",
			12
		],
		[
			"a481",
			"쨦쨧쨨쨪",
			28,
			"ㄱ",
			93
		],
		[
			"a541",
			"쩇",
			4,
			"쩎쩏쩑쩒쩓쩕",
			6,
			"쩞쩢",
			5,
			"쩩쩪"
		],
		[
			"a561",
			"쩫",
			17,
			"쩾",
			5,
			"쪅쪆"
		],
		[
			"a581",
			"쪇",
			16,
			"쪙",
			14,
			"ⅰ",
			9
		],
		[
			"a5b0",
			"Ⅰ",
			9
		],
		[
			"a5c1",
			"Α",
			16,
			"Σ",
			6
		],
		[
			"a5e1",
			"α",
			16,
			"σ",
			6
		],
		[
			"a641",
			"쪨",
			19,
			"쪾쪿쫁쫂쫃쫅"
		],
		[
			"a661",
			"쫆",
			5,
			"쫎쫐쫒쫔쫕쫖쫗쫚",
			5,
			"쫡",
			6
		],
		[
			"a681",
			"쫨쫩쫪쫫쫭",
			6,
			"쫵",
			18,
			"쬉쬊─│┌┐┘└├┬┤┴┼━┃┏┓┛┗┣┳┫┻╋┠┯┨┷┿┝┰┥┸╂┒┑┚┙┖┕┎┍┞┟┡┢┦┧┩┪┭┮┱┲┵┶┹┺┽┾╀╁╃",
			7
		],
		[
			"a741",
			"쬋",
			4,
			"쬑쬒쬓쬕쬖쬗쬙",
			6,
			"쬢",
			7
		],
		[
			"a761",
			"쬪",
			22,
			"쭂쭃쭄"
		],
		[
			"a781",
			"쭅쭆쭇쭊쭋쭍쭎쭏쭑",
			6,
			"쭚쭛쭜쭞",
			5,
			"쭥",
			7,
			"㎕㎖㎗ℓ㎘㏄㎣㎤㎥㎦㎙",
			9,
			"㏊㎍㎎㎏㏏㎈㎉㏈㎧㎨㎰",
			9,
			"㎀",
			4,
			"㎺",
			5,
			"㎐",
			4,
			"Ω㏀㏁㎊㎋㎌㏖㏅㎭㎮㎯㏛㎩㎪㎫㎬㏝㏐㏓㏃㏉㏜㏆"
		],
		[
			"a841",
			"쭭",
			10,
			"쭺",
			14
		],
		[
			"a861",
			"쮉",
			18,
			"쮝",
			6
		],
		[
			"a881",
			"쮤",
			19,
			"쮹",
			11,
			"ÆÐªĦ"
		],
		[
			"a8a6",
			"Ĳ"
		],
		[
			"a8a8",
			"ĿŁØŒºÞŦŊ"
		],
		[
			"a8b1",
			"㉠",
			27,
			"ⓐ",
			25,
			"①",
			14,
			"½⅓⅔¼¾⅛⅜⅝⅞"
		],
		[
			"a941",
			"쯅",
			14,
			"쯕",
			10
		],
		[
			"a961",
			"쯠쯡쯢쯣쯥쯦쯨쯪",
			18
		],
		[
			"a981",
			"쯽",
			14,
			"찎찏찑찒찓찕",
			6,
			"찞찟찠찣찤æđðħıĳĸŀłøœßþŧŋŉ㈀",
			27,
			"⒜",
			25,
			"⑴",
			14,
			"¹²³⁴ⁿ₁₂₃₄"
		],
		[
			"aa41",
			"찥찦찪찫찭찯찱",
			6,
			"찺찿",
			4,
			"챆챇챉챊챋챍챎"
		],
		[
			"aa61",
			"챏",
			4,
			"챖챚",
			5,
			"챡챢챣챥챧챩",
			6,
			"챱챲"
		],
		[
			"aa81",
			"챳챴챶",
			29,
			"ぁ",
			82
		],
		[
			"ab41",
			"첔첕첖첗첚첛첝첞첟첡",
			6,
			"첪첮",
			5,
			"첶첷첹"
		],
		[
			"ab61",
			"첺첻첽",
			6,
			"쳆쳈쳊",
			5,
			"쳑쳒쳓쳕",
			5
		],
		[
			"ab81",
			"쳛",
			8,
			"쳥",
			6,
			"쳭쳮쳯쳱",
			12,
			"ァ",
			85
		],
		[
			"ac41",
			"쳾쳿촀촂",
			5,
			"촊촋촍촎촏촑",
			6,
			"촚촜촞촟촠"
		],
		[
			"ac61",
			"촡촢촣촥촦촧촩촪촫촭",
			11,
			"촺",
			4
		],
		[
			"ac81",
			"촿",
			28,
			"쵝쵞쵟А",
			5,
			"ЁЖ",
			25
		],
		[
			"acd1",
			"а",
			5,
			"ёж",
			25
		],
		[
			"ad41",
			"쵡쵢쵣쵥",
			6,
			"쵮쵰쵲",
			5,
			"쵹",
			7
		],
		[
			"ad61",
			"춁",
			6,
			"춉",
			10,
			"춖춗춙춚춛춝춞춟"
		],
		[
			"ad81",
			"춠춡춢춣춦춨춪",
			5,
			"춱",
			18,
			"췅"
		],
		[
			"ae41",
			"췆",
			5,
			"췍췎췏췑",
			16
		],
		[
			"ae61",
			"췢",
			5,
			"췩췪췫췭췮췯췱",
			6,
			"췺췼췾",
			4
		],
		[
			"ae81",
			"츃츅츆츇츉츊츋츍",
			6,
			"츕츖츗츘츚",
			5,
			"츢츣츥츦츧츩츪츫"
		],
		[
			"af41",
			"츬츭츮츯츲츴츶",
			19
		],
		[
			"af61",
			"칊",
			13,
			"칚칛칝칞칢",
			5,
			"칪칬"
		],
		[
			"af81",
			"칮",
			5,
			"칶칷칹칺칻칽",
			6,
			"캆캈캊",
			5,
			"캒캓캕캖캗캙"
		],
		[
			"b041",
			"캚",
			5,
			"캢캦",
			5,
			"캮",
			12
		],
		[
			"b061",
			"캻",
			5,
			"컂",
			19
		],
		[
			"b081",
			"컖",
			13,
			"컦컧컩컪컭",
			6,
			"컶컺",
			5,
			"가각간갇갈갉갊감",
			7,
			"같",
			4,
			"갠갤갬갭갯갰갱갸갹갼걀걋걍걔걘걜거걱건걷걸걺검겁것겄겅겆겉겊겋게겐겔겜겝겟겠겡겨격겪견겯결겸겹겻겼경곁계곈곌곕곗고곡곤곧골곪곬곯곰곱곳공곶과곽관괄괆"
		],
		[
			"b141",
			"켂켃켅켆켇켉",
			6,
			"켒켔켖",
			5,
			"켝켞켟켡켢켣"
		],
		[
			"b161",
			"켥",
			6,
			"켮켲",
			5,
			"켹",
			11
		],
		[
			"b181",
			"콅",
			14,
			"콖콗콙콚콛콝",
			6,
			"콦콨콪콫콬괌괍괏광괘괜괠괩괬괭괴괵괸괼굄굅굇굉교굔굘굡굣구국군굳굴굵굶굻굼굽굿궁궂궈궉권궐궜궝궤궷귀귁귄귈귐귑귓규균귤그극근귿글긁금급긋긍긔기긱긴긷길긺김깁깃깅깆깊까깍깎깐깔깖깜깝깟깠깡깥깨깩깬깰깸"
		],
		[
			"b241",
			"콭콮콯콲콳콵콶콷콹",
			6,
			"쾁쾂쾃쾄쾆",
			5,
			"쾍"
		],
		[
			"b261",
			"쾎",
			18,
			"쾢",
			5,
			"쾩"
		],
		[
			"b281",
			"쾪",
			5,
			"쾱",
			18,
			"쿅",
			6,
			"깹깻깼깽꺄꺅꺌꺼꺽꺾껀껄껌껍껏껐껑께껙껜껨껫껭껴껸껼꼇꼈꼍꼐꼬꼭꼰꼲꼴꼼꼽꼿꽁꽂꽃꽈꽉꽐꽜꽝꽤꽥꽹꾀꾄꾈꾐꾑꾕꾜꾸꾹꾼꿀꿇꿈꿉꿋꿍꿎꿔꿜꿨꿩꿰꿱꿴꿸뀀뀁뀄뀌뀐뀔뀜뀝뀨끄끅끈끊끌끎끓끔끕끗끙"
		],
		[
			"b341",
			"쿌",
			19,
			"쿢쿣쿥쿦쿧쿩"
		],
		[
			"b361",
			"쿪",
			5,
			"쿲쿴쿶",
			5,
			"쿽쿾쿿퀁퀂퀃퀅",
			5
		],
		[
			"b381",
			"퀋",
			5,
			"퀒",
			5,
			"퀙",
			19,
			"끝끼끽낀낄낌낍낏낑나낙낚난낟날낡낢남납낫",
			4,
			"낱낳내낵낸낼냄냅냇냈냉냐냑냔냘냠냥너넉넋넌널넒넓넘넙넛넜넝넣네넥넨넬넴넵넷넸넹녀녁년녈념녑녔녕녘녜녠노녹논놀놂놈놉놋농높놓놔놘놜놨뇌뇐뇔뇜뇝"
		],
		[
			"b441",
			"퀮",
			5,
			"퀶퀷퀹퀺퀻퀽",
			6,
			"큆큈큊",
			5
		],
		[
			"b461",
			"큑큒큓큕큖큗큙",
			6,
			"큡",
			10,
			"큮큯"
		],
		[
			"b481",
			"큱큲큳큵",
			6,
			"큾큿킀킂",
			18,
			"뇟뇨뇩뇬뇰뇹뇻뇽누눅눈눋눌눔눕눗눙눠눴눼뉘뉜뉠뉨뉩뉴뉵뉼늄늅늉느늑는늘늙늚늠늡늣능늦늪늬늰늴니닉닌닐닒님닙닛닝닢다닥닦단닫",
			4,
			"닳담답닷",
			4,
			"닿대댁댄댈댐댑댓댔댕댜더덕덖던덛덜덞덟덤덥"
		],
		[
			"b541",
			"킕",
			14,
			"킦킧킩킪킫킭",
			5
		],
		[
			"b561",
			"킳킶킸킺",
			5,
			"탂탃탅탆탇탊",
			5,
			"탒탖",
			4
		],
		[
			"b581",
			"탛탞탟탡탢탣탥",
			6,
			"탮탲",
			5,
			"탹",
			11,
			"덧덩덫덮데덱덴델뎀뎁뎃뎄뎅뎌뎐뎔뎠뎡뎨뎬도독돈돋돌돎돐돔돕돗동돛돝돠돤돨돼됐되된될됨됩됫됴두둑둔둘둠둡둣둥둬뒀뒈뒝뒤뒨뒬뒵뒷뒹듀듄듈듐듕드득든듣들듦듬듭듯등듸디딕딘딛딜딤딥딧딨딩딪따딱딴딸"
		],
		[
			"b641",
			"턅",
			7,
			"턎",
			17
		],
		[
			"b661",
			"턠",
			15,
			"턲턳턵턶턷턹턻턼턽턾"
		],
		[
			"b681",
			"턿텂텆",
			5,
			"텎텏텑텒텓텕",
			6,
			"텞텠텢",
			5,
			"텩텪텫텭땀땁땃땄땅땋때땍땐땔땜땝땟땠땡떠떡떤떨떪떫떰떱떳떴떵떻떼떽뗀뗄뗌뗍뗏뗐뗑뗘뗬또똑똔똘똥똬똴뙈뙤뙨뚜뚝뚠뚤뚫뚬뚱뛔뛰뛴뛸뜀뜁뜅뜨뜩뜬뜯뜰뜸뜹뜻띄띈띌띔띕띠띤띨띰띱띳띵라락란랄람랍랏랐랑랒랖랗"
		],
		[
			"b741",
			"텮",
			13,
			"텽",
			6,
			"톅톆톇톉톊"
		],
		[
			"b761",
			"톋",
			20,
			"톢톣톥톦톧"
		],
		[
			"b781",
			"톩",
			6,
			"톲톴톶톷톸톹톻톽톾톿퇁",
			14,
			"래랙랜랠램랩랫랬랭랴략랸럇량러럭런럴럼럽럿렀렁렇레렉렌렐렘렙렛렝려력련렬렴렵렷렸령례롄롑롓로록론롤롬롭롯롱롸롼뢍뢨뢰뢴뢸룀룁룃룅료룐룔룝룟룡루룩룬룰룸룹룻룽뤄뤘뤠뤼뤽륀륄륌륏륑류륙륜률륨륩"
		],
		[
			"b841",
			"퇐",
			7,
			"퇙",
			17
		],
		[
			"b861",
			"퇫",
			8,
			"퇵퇶퇷퇹",
			13
		],
		[
			"b881",
			"툈툊",
			5,
			"툑",
			24,
			"륫륭르륵른를름릅릇릉릊릍릎리릭린릴림립릿링마막만많",
			4,
			"맘맙맛망맞맡맣매맥맨맬맴맵맷맸맹맺먀먁먈먕머먹먼멀멂멈멉멋멍멎멓메멕멘멜멤멥멧멨멩며멱면멸몃몄명몇몌모목몫몬몰몲몸몹못몽뫄뫈뫘뫙뫼"
		],
		[
			"b941",
			"툪툫툮툯툱툲툳툵",
			6,
			"툾퉀퉂",
			5,
			"퉉퉊퉋퉌"
		],
		[
			"b961",
			"퉍",
			14,
			"퉝",
			6,
			"퉥퉦퉧퉨"
		],
		[
			"b981",
			"퉩",
			22,
			"튂튃튅튆튇튉튊튋튌묀묄묍묏묑묘묜묠묩묫무묵묶문묻물묽묾뭄뭅뭇뭉뭍뭏뭐뭔뭘뭡뭣뭬뮈뮌뮐뮤뮨뮬뮴뮷므믄믈믐믓미믹민믿밀밂밈밉밋밌밍및밑바",
			4,
			"받",
			4,
			"밤밥밧방밭배백밴밸뱀뱁뱃뱄뱅뱉뱌뱍뱐뱝버벅번벋벌벎범법벗"
		],
		[
			"ba41",
			"튍튎튏튒튓튔튖",
			5,
			"튝튞튟튡튢튣튥",
			6,
			"튭"
		],
		[
			"ba61",
			"튮튯튰튲",
			5,
			"튺튻튽튾틁틃",
			4,
			"틊틌",
			5
		],
		[
			"ba81",
			"틒틓틕틖틗틙틚틛틝",
			6,
			"틦",
			9,
			"틲틳틵틶틷틹틺벙벚베벡벤벧벨벰벱벳벴벵벼벽변별볍볏볐병볕볘볜보복볶본볼봄봅봇봉봐봔봤봬뵀뵈뵉뵌뵐뵘뵙뵤뵨부북분붇불붉붊붐붑붓붕붙붚붜붤붰붸뷔뷕뷘뷜뷩뷰뷴뷸븀븃븅브븍븐블븜븝븟비빅빈빌빎빔빕빗빙빚빛빠빡빤"
		],
		[
			"bb41",
			"틻",
			4,
			"팂팄팆",
			5,
			"팏팑팒팓팕팗",
			4,
			"팞팢팣"
		],
		[
			"bb61",
			"팤팦팧팪팫팭팮팯팱",
			6,
			"팺팾",
			5,
			"퍆퍇퍈퍉"
		],
		[
			"bb81",
			"퍊",
			31,
			"빨빪빰빱빳빴빵빻빼빽뺀뺄뺌뺍뺏뺐뺑뺘뺙뺨뻐뻑뻔뻗뻘뻠뻣뻤뻥뻬뼁뼈뼉뼘뼙뼛뼜뼝뽀뽁뽄뽈뽐뽑뽕뾔뾰뿅뿌뿍뿐뿔뿜뿟뿡쀼쁑쁘쁜쁠쁨쁩삐삑삔삘삠삡삣삥사삭삯산삳살삵삶삼삽삿샀상샅새색샌샐샘샙샛샜생샤"
		],
		[
			"bc41",
			"퍪",
			17,
			"퍾퍿펁펂펃펅펆펇"
		],
		[
			"bc61",
			"펈펉펊펋펎펒",
			5,
			"펚펛펝펞펟펡",
			6,
			"펪펬펮"
		],
		[
			"bc81",
			"펯",
			4,
			"펵펶펷펹펺펻펽",
			6,
			"폆폇폊",
			5,
			"폑",
			5,
			"샥샨샬샴샵샷샹섀섄섈섐섕서",
			4,
			"섣설섦섧섬섭섯섰성섶세섹센셀셈셉셋셌셍셔셕션셜셤셥셧셨셩셰셴셸솅소속솎손솔솖솜솝솟송솥솨솩솬솰솽쇄쇈쇌쇔쇗쇘쇠쇤쇨쇰쇱쇳쇼쇽숀숄숌숍숏숑수숙순숟술숨숩숫숭"
		],
		[
			"bd41",
			"폗폙",
			7,
			"폢폤",
			7,
			"폮폯폱폲폳폵폶폷"
		],
		[
			"bd61",
			"폸폹폺폻폾퐀퐂",
			5,
			"퐉",
			13
		],
		[
			"bd81",
			"퐗",
			5,
			"퐞",
			25,
			"숯숱숲숴쉈쉐쉑쉔쉘쉠쉥쉬쉭쉰쉴쉼쉽쉿슁슈슉슐슘슛슝스슥슨슬슭슴습슷승시식신싣실싫심십싯싱싶싸싹싻싼쌀쌈쌉쌌쌍쌓쌔쌕쌘쌜쌤쌥쌨쌩썅써썩썬썰썲썸썹썼썽쎄쎈쎌쏀쏘쏙쏜쏟쏠쏢쏨쏩쏭쏴쏵쏸쐈쐐쐤쐬쐰"
		],
		[
			"be41",
			"퐸",
			7,
			"푁푂푃푅",
			14
		],
		[
			"be61",
			"푔",
			7,
			"푝푞푟푡푢푣푥",
			7,
			"푮푰푱푲"
		],
		[
			"be81",
			"푳",
			4,
			"푺푻푽푾풁풃",
			4,
			"풊풌풎",
			5,
			"풕",
			8,
			"쐴쐼쐽쑈쑤쑥쑨쑬쑴쑵쑹쒀쒔쒜쒸쒼쓩쓰쓱쓴쓸쓺쓿씀씁씌씐씔씜씨씩씬씰씸씹씻씽아악안앉않알앍앎앓암압앗았앙앝앞애액앤앨앰앱앳앴앵야약얀얄얇얌얍얏양얕얗얘얜얠얩어억언얹얻얼얽얾엄",
			6,
			"엌엎"
		],
		[
			"bf41",
			"풞",
			10,
			"풪",
			14
		],
		[
			"bf61",
			"풹",
			18,
			"퓍퓎퓏퓑퓒퓓퓕"
		],
		[
			"bf81",
			"퓖",
			5,
			"퓝퓞퓠",
			7,
			"퓩퓪퓫퓭퓮퓯퓱",
			6,
			"퓹퓺퓼에엑엔엘엠엡엣엥여역엮연열엶엷염",
			5,
			"옅옆옇예옌옐옘옙옛옜오옥온올옭옮옰옳옴옵옷옹옻와왁완왈왐왑왓왔왕왜왝왠왬왯왱외왹왼욀욈욉욋욍요욕욘욜욤욥욧용우욱운울욹욺움웁웃웅워웍원월웜웝웠웡웨"
		],
		[
			"c041",
			"퓾",
			5,
			"픅픆픇픉픊픋픍",
			6,
			"픖픘",
			5
		],
		[
			"c061",
			"픞",
			25
		],
		[
			"c081",
			"픸픹픺픻픾픿핁핂핃핅",
			6,
			"핎핐핒",
			5,
			"핚핛핝핞핟핡핢핣웩웬웰웸웹웽위윅윈윌윔윕윗윙유육윤율윰윱윳융윷으윽은을읊음읍읏응",
			7,
			"읜읠읨읫이익인일읽읾잃임입잇있잉잊잎자작잔잖잗잘잚잠잡잣잤장잦재잭잰잴잼잽잿쟀쟁쟈쟉쟌쟎쟐쟘쟝쟤쟨쟬저적전절젊"
		],
		[
			"c141",
			"핤핦핧핪핬핮",
			5,
			"핶핷핹핺핻핽",
			6,
			"햆햊햋"
		],
		[
			"c161",
			"햌햍햎햏햑",
			19,
			"햦햧"
		],
		[
			"c181",
			"햨",
			31,
			"점접젓정젖제젝젠젤젬젭젯젱져젼졀졈졉졌졍졔조족존졸졺좀좁좃종좆좇좋좌좍좔좝좟좡좨좼좽죄죈죌죔죕죗죙죠죡죤죵주죽준줄줅줆줌줍줏중줘줬줴쥐쥑쥔쥘쥠쥡쥣쥬쥰쥴쥼즈즉즌즐즘즙즛증지직진짇질짊짐집짓"
		],
		[
			"c241",
			"헊헋헍헎헏헑헓",
			4,
			"헚헜헞",
			5,
			"헦헧헩헪헫헭헮"
		],
		[
			"c261",
			"헯",
			4,
			"헶헸헺",
			5,
			"혂혃혅혆혇혉",
			6,
			"혒"
		],
		[
			"c281",
			"혖",
			5,
			"혝혞혟혡혢혣혥",
			7,
			"혮",
			9,
			"혺혻징짖짙짚짜짝짠짢짤짧짬짭짯짰짱째짹짼쨀쨈쨉쨋쨌쨍쨔쨘쨩쩌쩍쩐쩔쩜쩝쩟쩠쩡쩨쩽쪄쪘쪼쪽쫀쫄쫌쫍쫏쫑쫓쫘쫙쫠쫬쫴쬈쬐쬔쬘쬠쬡쭁쭈쭉쭌쭐쭘쭙쭝쭤쭸쭹쮜쮸쯔쯤쯧쯩찌찍찐찔찜찝찡찢찧차착찬찮찰참찹찻"
		],
		[
			"c341",
			"혽혾혿홁홂홃홄홆홇홊홌홎홏홐홒홓홖홗홙홚홛홝",
			4
		],
		[
			"c361",
			"홢",
			4,
			"홨홪",
			5,
			"홲홳홵",
			11
		],
		[
			"c381",
			"횁횂횄횆",
			5,
			"횎횏횑횒횓횕",
			7,
			"횞횠횢",
			5,
			"횩횪찼창찾채책챈챌챔챕챗챘챙챠챤챦챨챰챵처척천철첨첩첫첬청체첵첸첼쳄쳅쳇쳉쳐쳔쳤쳬쳰촁초촉촌촐촘촙촛총촤촨촬촹최쵠쵤쵬쵭쵯쵱쵸춈추축춘출춤춥춧충춰췄췌췐취췬췰췸췹췻췽츄츈츌츔츙츠측츤츨츰츱츳층"
		],
		[
			"c441",
			"횫횭횮횯횱",
			7,
			"횺횼",
			7,
			"훆훇훉훊훋"
		],
		[
			"c461",
			"훍훎훏훐훒훓훕훖훘훚",
			5,
			"훡훢훣훥훦훧훩",
			4
		],
		[
			"c481",
			"훮훯훱훲훳훴훶",
			5,
			"훾훿휁휂휃휅",
			11,
			"휒휓휔치칙친칟칠칡침칩칫칭카칵칸칼캄캅캇캉캐캑캔캘캠캡캣캤캥캬캭컁커컥컨컫컬컴컵컷컸컹케켁켄켈켐켑켓켕켜켠켤켬켭켯켰켱켸코콕콘콜콤콥콧콩콰콱콴콸쾀쾅쾌쾡쾨쾰쿄쿠쿡쿤쿨쿰쿱쿳쿵쿼퀀퀄퀑퀘퀭퀴퀵퀸퀼"
		],
		[
			"c541",
			"휕휖휗휚휛휝휞휟휡",
			6,
			"휪휬휮",
			5,
			"휶휷휹"
		],
		[
			"c561",
			"휺휻휽",
			6,
			"흅흆흈흊",
			5,
			"흒흓흕흚",
			4
		],
		[
			"c581",
			"흟흢흤흦흧흨흪흫흭흮흯흱흲흳흵",
			6,
			"흾흿힀힂",
			5,
			"힊힋큄큅큇큉큐큔큘큠크큭큰클큼큽킁키킥킨킬킴킵킷킹타탁탄탈탉탐탑탓탔탕태택탠탤탬탭탯탰탱탸턍터턱턴털턺텀텁텃텄텅테텍텐텔템텝텟텡텨텬텼톄톈토톡톤톨톰톱톳통톺톼퇀퇘퇴퇸툇툉툐투툭툰툴툼툽툿퉁퉈퉜"
		],
		[
			"c641",
			"힍힎힏힑",
			6,
			"힚힜힞",
			5
		],
		[
			"c6a1",
			"퉤튀튁튄튈튐튑튕튜튠튤튬튱트특튼튿틀틂틈틉틋틔틘틜틤틥티틱틴틸팀팁팃팅파팍팎판팔팖팜팝팟팠팡팥패팩팬팰팸팹팻팼팽퍄퍅퍼퍽펀펄펌펍펏펐펑페펙펜펠펨펩펫펭펴편펼폄폅폈평폐폘폡폣포폭폰폴폼폽폿퐁"
		],
		[
			"c7a1",
			"퐈퐝푀푄표푠푤푭푯푸푹푼푿풀풂품풉풋풍풔풩퓌퓐퓔퓜퓟퓨퓬퓰퓸퓻퓽프픈플픔픕픗피픽핀필핌핍핏핑하학한할핥함합핫항해핵핸핼햄햅햇했행햐향허헉헌헐헒험헙헛헝헤헥헨헬헴헵헷헹혀혁현혈혐협혓혔형혜혠"
		],
		[
			"c8a1",
			"혤혭호혹혼홀홅홈홉홋홍홑화확환활홧황홰홱홴횃횅회획횐횔횝횟횡효횬횰횹횻후훅훈훌훑훔훗훙훠훤훨훰훵훼훽휀휄휑휘휙휜휠휨휩휫휭휴휵휸휼흄흇흉흐흑흔흖흗흘흙흠흡흣흥흩희흰흴흼흽힁히힉힌힐힘힙힛힝"
		],
		[
			"caa1",
			"伽佳假價加可呵哥嘉嫁家暇架枷柯歌珂痂稼苛茄街袈訶賈跏軻迦駕刻却各恪慤殼珏脚覺角閣侃刊墾奸姦干幹懇揀杆柬桿澗癎看磵稈竿簡肝艮艱諫間乫喝曷渴碣竭葛褐蝎鞨勘坎堪嵌感憾戡敢柑橄減甘疳監瞰紺邯鑑鑒龕"
		],
		[
			"cba1",
			"匣岬甲胛鉀閘剛堈姜岡崗康强彊慷江畺疆糠絳綱羌腔舡薑襁講鋼降鱇介价個凱塏愷愾慨改槪漑疥皆盖箇芥蓋豈鎧開喀客坑更粳羹醵倨去居巨拒据據擧渠炬祛距踞車遽鉅鋸乾件健巾建愆楗腱虔蹇鍵騫乞傑杰桀儉劍劒檢"
		],
		[
			"cca1",
			"瞼鈐黔劫怯迲偈憩揭擊格檄激膈覡隔堅牽犬甄絹繭肩見譴遣鵑抉決潔結缺訣兼慊箝謙鉗鎌京俓倞傾儆勁勍卿坰境庚徑慶憬擎敬景暻更梗涇炅烱璟璥瓊痙硬磬竟競絅經耕耿脛莖警輕逕鏡頃頸驚鯨係啓堺契季屆悸戒桂械"
		],
		[
			"cda1",
			"棨溪界癸磎稽系繫繼計誡谿階鷄古叩告呱固姑孤尻庫拷攷故敲暠枯槁沽痼皐睾稿羔考股膏苦苽菰藁蠱袴誥賈辜錮雇顧高鼓哭斛曲梏穀谷鵠困坤崑昆梱棍滾琨袞鯤汨滑骨供公共功孔工恐恭拱控攻珙空蚣貢鞏串寡戈果瓜"
		],
		[
			"cea1",
			"科菓誇課跨過鍋顆廓槨藿郭串冠官寬慣棺款灌琯瓘管罐菅觀貫關館刮恝括适侊光匡壙廣曠洸炚狂珖筐胱鑛卦掛罫乖傀塊壞怪愧拐槐魁宏紘肱轟交僑咬喬嬌嶠巧攪敎校橋狡皎矯絞翹膠蕎蛟較轎郊餃驕鮫丘久九仇俱具勾"
		],
		[
			"cfa1",
			"區口句咎嘔坵垢寇嶇廐懼拘救枸柩構歐毆毬求溝灸狗玖球瞿矩究絿耉臼舅舊苟衢謳購軀逑邱鉤銶駒驅鳩鷗龜國局菊鞠鞫麴君窘群裙軍郡堀屈掘窟宮弓穹窮芎躬倦券勸卷圈拳捲權淃眷厥獗蕨蹶闕机櫃潰詭軌饋句晷歸貴"
		],
		[
			"d0a1",
			"鬼龜叫圭奎揆槻珪硅窺竅糾葵規赳逵閨勻均畇筠菌鈞龜橘克剋劇戟棘極隙僅劤勤懃斤根槿瑾筋芹菫覲謹近饉契今妗擒昑檎琴禁禽芩衾衿襟金錦伋及急扱汲級給亘兢矜肯企伎其冀嗜器圻基埼夔奇妓寄岐崎己幾忌技旗旣"
		],
		[
			"d1a1",
			"朞期杞棋棄機欺氣汽沂淇玘琦琪璂璣畸畿碁磯祁祇祈祺箕紀綺羈耆耭肌記譏豈起錡錤飢饑騎騏驥麒緊佶吉拮桔金喫儺喇奈娜懦懶拏拿癩",
			5,
			"那樂",
			4,
			"諾酪駱亂卵暖欄煖爛蘭難鸞捏捺南嵐枏楠湳濫男藍襤拉"
		],
		[
			"d2a1",
			"納臘蠟衲囊娘廊",
			4,
			"乃來內奈柰耐冷女年撚秊念恬拈捻寧寗努勞奴弩怒擄櫓爐瑙盧",
			5,
			"駑魯",
			10,
			"濃籠聾膿農惱牢磊腦賂雷尿壘",
			7,
			"嫩訥杻紐勒",
			5,
			"能菱陵尼泥匿溺多茶"
		],
		[
			"d3a1",
			"丹亶但單團壇彖斷旦檀段湍短端簞緞蛋袒鄲鍛撻澾獺疸達啖坍憺擔曇淡湛潭澹痰聃膽蕁覃談譚錟沓畓答踏遝唐堂塘幢戇撞棠當糖螳黨代垈坮大對岱帶待戴擡玳臺袋貸隊黛宅德悳倒刀到圖堵塗導屠島嶋度徒悼挑掉搗桃"
		],
		[
			"d4a1",
			"棹櫂淘渡滔濤燾盜睹禱稻萄覩賭跳蹈逃途道都鍍陶韜毒瀆牘犢獨督禿篤纛讀墩惇敦旽暾沌焞燉豚頓乭突仝冬凍動同憧東桐棟洞潼疼瞳童胴董銅兜斗杜枓痘竇荳讀豆逗頭屯臀芚遁遯鈍得嶝橙燈登等藤謄鄧騰喇懶拏癩羅"
		],
		[
			"d5a1",
			"蘿螺裸邏樂洛烙珞絡落諾酪駱丹亂卵欄欒瀾爛蘭鸞剌辣嵐擥攬欖濫籃纜藍襤覽拉臘蠟廊朗浪狼琅瑯螂郞來崍徠萊冷掠略亮倆兩凉梁樑粮粱糧良諒輛量侶儷勵呂廬慮戾旅櫚濾礪藜蠣閭驢驪麗黎力曆歷瀝礫轢靂憐戀攣漣"
		],
		[
			"d6a1",
			"煉璉練聯蓮輦連鍊冽列劣洌烈裂廉斂殮濂簾獵令伶囹寧岺嶺怜玲笭羚翎聆逞鈴零靈領齡例澧禮醴隷勞怒撈擄櫓潞瀘爐盧老蘆虜路輅露魯鷺鹵碌祿綠菉錄鹿麓論壟弄朧瀧瓏籠聾儡瀨牢磊賂賚賴雷了僚寮廖料燎療瞭聊蓼"
		],
		[
			"d7a1",
			"遼鬧龍壘婁屢樓淚漏瘻累縷蔞褸鏤陋劉旒柳榴流溜瀏琉瑠留瘤硫謬類六戮陸侖倫崙淪綸輪律慄栗率隆勒肋凜凌楞稜綾菱陵俚利厘吏唎履悧李梨浬犁狸理璃異痢籬罹羸莉裏裡里釐離鯉吝潾燐璘藺躪隣鱗麟林淋琳臨霖砬"
		],
		[
			"d8a1",
			"立笠粒摩瑪痲碼磨馬魔麻寞幕漠膜莫邈万卍娩巒彎慢挽晩曼滿漫灣瞞萬蔓蠻輓饅鰻唜抹末沫茉襪靺亡妄忘忙望網罔芒茫莽輞邙埋妹媒寐昧枚梅每煤罵買賣邁魅脈貊陌驀麥孟氓猛盲盟萌冪覓免冕勉棉沔眄眠綿緬面麵滅"
		],
		[
			"d9a1",
			"蔑冥名命明暝椧溟皿瞑茗蓂螟酩銘鳴袂侮冒募姆帽慕摸摹暮某模母毛牟牡瑁眸矛耗芼茅謀謨貌木沐牧目睦穆鶩歿沒夢朦蒙卯墓妙廟描昴杳渺猫竗苗錨務巫憮懋戊拇撫无楙武毋無珷畝繆舞茂蕪誣貿霧鵡墨默們刎吻問文"
		],
		[
			"daa1",
			"汶紊紋聞蚊門雯勿沕物味媚尾嵋彌微未梶楣渼湄眉米美薇謎迷靡黴岷悶愍憫敏旻旼民泯玟珉緡閔密蜜謐剝博拍搏撲朴樸泊珀璞箔粕縛膊舶薄迫雹駁伴半反叛拌搬攀斑槃泮潘班畔瘢盤盼磐磻礬絆般蟠返頒飯勃拔撥渤潑"
		],
		[
			"dba1",
			"發跋醱鉢髮魃倣傍坊妨尨幇彷房放方旁昉枋榜滂磅紡肪膀舫芳蒡蚌訪謗邦防龐倍俳北培徘拜排杯湃焙盃背胚裴裵褙賠輩配陪伯佰帛柏栢白百魄幡樊煩燔番磻繁蕃藩飜伐筏罰閥凡帆梵氾汎泛犯範范法琺僻劈壁擘檗璧癖"
		],
		[
			"dca1",
			"碧蘗闢霹便卞弁變辨辯邊別瞥鱉鼈丙倂兵屛幷昞昺柄棅炳甁病秉竝輧餠騈保堡報寶普步洑湺潽珤甫菩補褓譜輔伏僕匐卜宓復服福腹茯蔔複覆輹輻馥鰒本乶俸奉封峯峰捧棒烽熢琫縫蓬蜂逢鋒鳳不付俯傅剖副否咐埠夫婦"
		],
		[
			"dda1",
			"孚孵富府復扶敷斧浮溥父符簿缶腐腑膚艀芙莩訃負賦賻赴趺部釜阜附駙鳧北分吩噴墳奔奮忿憤扮昐汾焚盆粉糞紛芬賁雰不佛弗彿拂崩朋棚硼繃鵬丕備匕匪卑妃婢庇悲憊扉批斐枇榧比毖毗毘沸泌琵痺砒碑秕秘粃緋翡肥"
		],
		[
			"dea1",
			"脾臂菲蜚裨誹譬費鄙非飛鼻嚬嬪彬斌檳殯浜濱瀕牝玭貧賓頻憑氷聘騁乍事些仕伺似使俟僿史司唆嗣四士奢娑寫寺射巳師徙思捨斜斯柶査梭死沙泗渣瀉獅砂社祀祠私篩紗絲肆舍莎蓑蛇裟詐詞謝賜赦辭邪飼駟麝削數朔索"
		],
		[
			"dfa1",
			"傘刪山散汕珊産疝算蒜酸霰乷撒殺煞薩三參杉森渗芟蔘衫揷澁鈒颯上傷像償商喪嘗孀尙峠常床庠廂想桑橡湘爽牀狀相祥箱翔裳觴詳象賞霜塞璽賽嗇塞穡索色牲生甥省笙墅壻嶼序庶徐恕抒捿敍暑曙書栖棲犀瑞筮絮緖署"
		],
		[
			"e0a1",
			"胥舒薯西誓逝鋤黍鼠夕奭席惜昔晳析汐淅潟石碩蓆釋錫仙僊先善嬋宣扇敾旋渲煽琁瑄璇璿癬禪線繕羨腺膳船蘚蟬詵跣選銑鐥饍鮮卨屑楔泄洩渫舌薛褻設說雪齧剡暹殲纖蟾贍閃陝攝涉燮葉城姓宬性惺成星晟猩珹盛省筬"
		],
		[
			"e1a1",
			"聖聲腥誠醒世勢歲洗稅笹細說貰召嘯塑宵小少巢所掃搔昭梳沼消溯瀟炤燒甦疏疎瘙笑篠簫素紹蔬蕭蘇訴逍遡邵銷韶騷俗屬束涑粟續謖贖速孫巽損蓀遜飡率宋悚松淞訟誦送頌刷殺灑碎鎖衰釗修受嗽囚垂壽嫂守岫峀帥愁"
		],
		[
			"e2a1",
			"戍手授搜收數樹殊水洙漱燧狩獸琇璲瘦睡秀穗竪粹綏綬繡羞脩茱蒐蓚藪袖誰讐輸遂邃酬銖銹隋隧隨雖需須首髓鬚叔塾夙孰宿淑潚熟琡璹肅菽巡徇循恂旬栒楯橓殉洵淳珣盾瞬筍純脣舜荀蓴蕣詢諄醇錞順馴戌術述鉥崇崧"
		],
		[
			"e3a1",
			"嵩瑟膝蝨濕拾習褶襲丞乘僧勝升承昇繩蠅陞侍匙嘶始媤尸屎屍市弑恃施是時枾柴猜矢示翅蒔蓍視試詩諡豕豺埴寔式息拭植殖湜熄篒蝕識軾食飾伸侁信呻娠宸愼新晨燼申神紳腎臣莘薪藎蜃訊身辛辰迅失室實悉審尋心沁"
		],
		[
			"e4a1",
			"沈深瀋甚芯諶什十拾雙氏亞俄兒啞娥峨我牙芽莪蛾衙訝阿雅餓鴉鵝堊岳嶽幄惡愕握樂渥鄂鍔顎鰐齷安岸按晏案眼雁鞍顔鮟斡謁軋閼唵岩巖庵暗癌菴闇壓押狎鴨仰央怏昻殃秧鴦厓哀埃崖愛曖涯碍艾隘靄厄扼掖液縊腋額"
		],
		[
			"e5a1",
			"櫻罌鶯鸚也倻冶夜惹揶椰爺耶若野弱掠略約若葯蒻藥躍亮佯兩凉壤孃恙揚攘敭暘梁楊樣洋瀁煬痒瘍禳穰糧羊良襄諒讓釀陽量養圄御於漁瘀禦語馭魚齬億憶抑檍臆偃堰彦焉言諺孼蘖俺儼嚴奄掩淹嶪業円予余勵呂女如廬"
		],
		[
			"e6a1",
			"旅歟汝濾璵礖礪與艅茹輿轝閭餘驪麗黎亦力域役易曆歷疫繹譯轢逆驛嚥堧姸娟宴年延憐戀捐挻撚椽沇沿涎涓淵演漣烟然煙煉燃燕璉硏硯秊筵緣練縯聯衍軟輦蓮連鉛鍊鳶列劣咽悅涅烈熱裂說閱厭廉念捻染殮炎焰琰艶苒"
		],
		[
			"e7a1",
			"簾閻髥鹽曄獵燁葉令囹塋寧嶺嶸影怜映暎楹榮永泳渶潁濚瀛瀯煐營獰玲瑛瑩瓔盈穎纓羚聆英詠迎鈴鍈零霙靈領乂倪例刈叡曳汭濊猊睿穢芮藝蘂禮裔詣譽豫醴銳隸霓預五伍俉傲午吾吳嗚塢墺奧娛寤悟惡懊敖旿晤梧汚澳"
		],
		[
			"e8a1",
			"烏熬獒筽蜈誤鰲鼇屋沃獄玉鈺溫瑥瘟穩縕蘊兀壅擁瓮甕癰翁邕雍饔渦瓦窩窪臥蛙蝸訛婉完宛梡椀浣玩琓琬碗緩翫脘腕莞豌阮頑曰往旺枉汪王倭娃歪矮外嵬巍猥畏了僚僥凹堯夭妖姚寥寮尿嶢拗搖撓擾料曜樂橈燎燿瑤療"
		],
		[
			"e9a1",
			"窈窯繇繞耀腰蓼蟯要謠遙遼邀饒慾欲浴縟褥辱俑傭冗勇埇墉容庸慂榕涌湧溶熔瑢用甬聳茸蓉踊鎔鏞龍于佑偶優又友右宇寓尤愚憂旴牛玗瑀盂祐禑禹紆羽芋藕虞迂遇郵釪隅雨雩勖彧旭昱栯煜稶郁頊云暈橒殞澐熉耘芸蕓"
		],
		[
			"eaa1",
			"運隕雲韻蔚鬱亐熊雄元原員圓園垣媛嫄寃怨愿援沅洹湲源爰猿瑗苑袁轅遠阮院願鴛月越鉞位偉僞危圍委威尉慰暐渭爲瑋緯胃萎葦蔿蝟衛褘謂違韋魏乳侑儒兪劉唯喩孺宥幼幽庾悠惟愈愉揄攸有杻柔柚柳楡楢油洧流游溜"
		],
		[
			"eba1",
			"濡猶猷琉瑜由留癒硫紐維臾萸裕誘諛諭踰蹂遊逾遺酉釉鍮類六堉戮毓肉育陸倫允奫尹崙淪潤玧胤贇輪鈗閏律慄栗率聿戎瀜絨融隆垠恩慇殷誾銀隱乙吟淫蔭陰音飮揖泣邑凝應膺鷹依倚儀宜意懿擬椅毅疑矣義艤薏蟻衣誼"
		],
		[
			"eca1",
			"議醫二以伊利吏夷姨履已弛彛怡易李梨泥爾珥理異痍痢移罹而耳肄苡荑裏裡貽貳邇里離飴餌匿溺瀷益翊翌翼謚人仁刃印吝咽因姻寅引忍湮燐璘絪茵藺蚓認隣靭靷鱗麟一佚佾壹日溢逸鎰馹任壬妊姙恁林淋稔臨荏賃入卄"
		],
		[
			"eda1",
			"立笠粒仍剩孕芿仔刺咨姉姿子字孜恣慈滋炙煮玆瓷疵磁紫者自茨蔗藉諮資雌作勺嚼斫昨灼炸爵綽芍酌雀鵲孱棧殘潺盞岑暫潛箴簪蠶雜丈仗匠場墻壯奬將帳庄張掌暲杖樟檣欌漿牆狀獐璋章粧腸臟臧莊葬蔣薔藏裝贓醬長"
		],
		[
			"eea1",
			"障再哉在宰才材栽梓渽滓災縡裁財載齋齎爭箏諍錚佇低儲咀姐底抵杵楮樗沮渚狙猪疽箸紵苧菹著藷詛貯躇這邸雎齟勣吊嫡寂摘敵滴狄炙的積笛籍績翟荻謫賊赤跡蹟迪迹適鏑佃佺傳全典前剪塡塼奠專展廛悛戰栓殿氈澱"
		],
		[
			"efa1",
			"煎琠田甸畑癲筌箋箭篆纏詮輾轉鈿銓錢鐫電顚顫餞切截折浙癤竊節絶占岾店漸点粘霑鮎點接摺蝶丁井亭停偵呈姃定幀庭廷征情挺政整旌晶晸柾楨檉正汀淀淨渟湞瀞炡玎珽町睛碇禎程穽精綎艇訂諪貞鄭酊釘鉦鋌錠霆靖"
		],
		[
			"f0a1",
			"靜頂鼎制劑啼堤帝弟悌提梯濟祭第臍薺製諸蹄醍除際霽題齊俎兆凋助嘲弔彫措操早晁曺曹朝條棗槽漕潮照燥爪璪眺祖祚租稠窕粗糟組繰肇藻蚤詔調趙躁造遭釣阻雕鳥族簇足鏃存尊卒拙猝倧宗從悰慫棕淙琮種終綜縱腫"
		],
		[
			"f1a1",
			"踪踵鍾鐘佐坐左座挫罪主住侏做姝胄呪周嗾奏宙州廚晝朱柱株注洲湊澍炷珠疇籌紂紬綢舟蛛註誅走躊輳週酎酒鑄駐竹粥俊儁准埈寯峻晙樽浚準濬焌畯竣蠢逡遵雋駿茁中仲衆重卽櫛楫汁葺增憎曾拯烝甑症繒蒸證贈之只"
		],
		[
			"f2a1",
			"咫地址志持指摯支旨智枝枳止池沚漬知砥祉祗紙肢脂至芝芷蜘誌識贄趾遲直稙稷織職唇嗔塵振搢晉晋桭榛殄津溱珍瑨璡畛疹盡眞瞋秦縉縝臻蔯袗診賑軫辰進鎭陣陳震侄叱姪嫉帙桎瓆疾秩窒膣蛭質跌迭斟朕什執潗緝輯"
		],
		[
			"f3a1",
			"鏶集徵懲澄且侘借叉嗟嵯差次此磋箚茶蹉車遮捉搾着窄錯鑿齪撰澯燦璨瓚竄簒纂粲纘讚贊鑽餐饌刹察擦札紮僭參塹慘慙懺斬站讒讖倉倡創唱娼廠彰愴敞昌昶暢槍滄漲猖瘡窓脹艙菖蒼債埰寀寨彩採砦綵菜蔡采釵冊柵策"
		],
		[
			"f4a1",
			"責凄妻悽處倜刺剔尺慽戚拓擲斥滌瘠脊蹠陟隻仟千喘天川擅泉淺玔穿舛薦賤踐遷釧闡阡韆凸哲喆徹撤澈綴輟轍鐵僉尖沾添甛瞻簽籤詹諂堞妾帖捷牒疊睫諜貼輒廳晴淸聽菁請靑鯖切剃替涕滯締諦逮遞體初剿哨憔抄招梢"
		],
		[
			"f5a1",
			"椒楚樵炒焦硝礁礎秒稍肖艸苕草蕉貂超酢醋醮促囑燭矗蜀觸寸忖村邨叢塚寵悤憁摠總聰蔥銃撮催崔最墜抽推椎楸樞湫皺秋芻萩諏趨追鄒酋醜錐錘鎚雛騶鰍丑畜祝竺筑築縮蓄蹙蹴軸逐春椿瑃出朮黜充忠沖蟲衝衷悴膵萃"
		],
		[
			"f6a1",
			"贅取吹嘴娶就炊翠聚脆臭趣醉驟鷲側仄厠惻測層侈値嗤峙幟恥梔治淄熾痔痴癡稚穉緇緻置致蚩輜雉馳齒則勅飭親七柒漆侵寢枕沈浸琛砧針鍼蟄秤稱快他咤唾墮妥惰打拖朶楕舵陀馱駝倬卓啄坼度托拓擢晫柝濁濯琢琸託"
		],
		[
			"f7a1",
			"鐸呑嘆坦彈憚歎灘炭綻誕奪脫探眈耽貪塔搭榻宕帑湯糖蕩兌台太怠態殆汰泰笞胎苔跆邰颱宅擇澤撑攄兎吐土討慟桶洞痛筒統通堆槌腿褪退頹偸套妬投透鬪慝特闖坡婆巴把播擺杷波派爬琶破罷芭跛頗判坂板版瓣販辦鈑"
		],
		[
			"f8a1",
			"阪八叭捌佩唄悖敗沛浿牌狽稗覇貝彭澎烹膨愎便偏扁片篇編翩遍鞭騙貶坪平枰萍評吠嬖幣廢弊斃肺蔽閉陛佈包匍匏咆哺圃布怖抛抱捕暴泡浦疱砲胞脯苞葡蒲袍褒逋鋪飽鮑幅暴曝瀑爆輻俵剽彪慓杓標漂瓢票表豹飇飄驃"
		],
		[
			"f9a1",
			"品稟楓諷豊風馮彼披疲皮被避陂匹弼必泌珌畢疋筆苾馝乏逼下何厦夏廈昰河瑕荷蝦賀遐霞鰕壑學虐謔鶴寒恨悍旱汗漢澣瀚罕翰閑閒限韓割轄函含咸啣喊檻涵緘艦銜陷鹹合哈盒蛤閤闔陜亢伉姮嫦巷恒抗杭桁沆港缸肛航"
		],
		[
			"faa1",
			"行降項亥偕咳垓奚孩害懈楷海瀣蟹解該諧邂駭骸劾核倖幸杏荇行享向嚮珦鄕響餉饗香噓墟虛許憲櫶獻軒歇險驗奕爀赫革俔峴弦懸晛泫炫玄玹現眩睍絃絢縣舷衒見賢鉉顯孑穴血頁嫌俠協夾峽挾浹狹脅脇莢鋏頰亨兄刑型"
		],
		[
			"fba1",
			"形泂滎瀅灐炯熒珩瑩荊螢衡逈邢鎣馨兮彗惠慧暳蕙蹊醯鞋乎互呼壕壺好岵弧戶扈昊晧毫浩淏湖滸澔濠濩灝狐琥瑚瓠皓祜糊縞胡芦葫蒿虎號蝴護豪鎬頀顥惑或酷婚昏混渾琿魂忽惚笏哄弘汞泓洪烘紅虹訌鴻化和嬅樺火畵"
		],
		[
			"fca1",
			"禍禾花華話譁貨靴廓擴攫確碻穫丸喚奐宦幻患換歡晥桓渙煥環紈還驩鰥活滑猾豁闊凰幌徨恍惶愰慌晃晄榥況湟滉潢煌璜皇篁簧荒蝗遑隍黃匯回廻徊恢悔懷晦會檜淮澮灰獪繪膾茴蛔誨賄劃獲宖橫鐄哮嚆孝效斅曉梟涍淆"
		],
		[
			"fda1",
			"爻肴酵驍侯候厚后吼喉嗅帿後朽煦珝逅勛勳塤壎焄熏燻薰訓暈薨喧暄煊萱卉喙毁彙徽揮暉煇諱輝麾休携烋畦虧恤譎鷸兇凶匈洶胸黑昕欣炘痕吃屹紇訖欠欽歆吸恰洽翕興僖凞喜噫囍姬嬉希憙憘戱晞曦熙熹熺犧禧稀羲詰"
		]
	];

/***/ },
/* 36 */
/***/ function(module, exports) {

	module.exports = [
		[
			"0",
			"\u0000",
			127
		],
		[
			"a140",
			"　，、。．‧；：？！︰…‥﹐﹑﹒·﹔﹕﹖﹗｜–︱—︳╴︴﹏（）︵︶｛｝︷︸〔〕︹︺【】︻︼《》︽︾〈〉︿﹀「」﹁﹂『』﹃﹄﹙﹚"
		],
		[
			"a1a1",
			"﹛﹜﹝﹞‘’“”〝〞‵′＃＆＊※§〃○●△▲◎☆★◇◆□■▽▼㊣℅¯￣＿ˍ﹉﹊﹍﹎﹋﹌﹟﹠﹡＋－×÷±√＜＞＝≦≧≠∞≒≡﹢",
			4,
			"～∩∪⊥∠∟⊿㏒㏑∫∮∵∴♀♂⊕⊙↑↓←→↖↗↙↘∥∣／"
		],
		[
			"a240",
			"＼∕﹨＄￥〒￠￡％＠℃℉﹩﹪﹫㏕㎜㎝㎞㏎㎡㎎㎏㏄°兙兛兞兝兡兣嗧瓩糎▁",
			7,
			"▏▎▍▌▋▊▉┼┴┬┤├▔─│▕┌┐└┘╭"
		],
		[
			"a2a1",
			"╮╰╯═╞╪╡◢◣◥◤╱╲╳０",
			9,
			"Ⅰ",
			9,
			"〡",
			8,
			"十卄卅Ａ",
			25,
			"ａ",
			21
		],
		[
			"a340",
			"ｗｘｙｚΑ",
			16,
			"Σ",
			6,
			"α",
			16,
			"σ",
			6,
			"ㄅ",
			10
		],
		[
			"a3a1",
			"ㄐ",
			25,
			"˙ˉˊˇˋ"
		],
		[
			"a3e1",
			"€"
		],
		[
			"a440",
			"一乙丁七乃九了二人儿入八几刀刁力匕十卜又三下丈上丫丸凡久么也乞于亡兀刃勺千叉口土士夕大女子孑孓寸小尢尸山川工己已巳巾干廾弋弓才"
		],
		[
			"a4a1",
			"丑丐不中丰丹之尹予云井互五亢仁什仃仆仇仍今介仄元允內六兮公冗凶分切刈勻勾勿化匹午升卅卞厄友及反壬天夫太夭孔少尤尺屯巴幻廿弔引心戈戶手扎支文斗斤方日曰月木欠止歹毋比毛氏水火爪父爻片牙牛犬王丙"
		],
		[
			"a540",
			"世丕且丘主乍乏乎以付仔仕他仗代令仙仞充兄冉冊冬凹出凸刊加功包匆北匝仟半卉卡占卯卮去可古右召叮叩叨叼司叵叫另只史叱台句叭叻四囚外"
		],
		[
			"a5a1",
			"央失奴奶孕它尼巨巧左市布平幼弁弘弗必戊打扔扒扑斥旦朮本未末札正母民氐永汁汀氾犯玄玉瓜瓦甘生用甩田由甲申疋白皮皿目矛矢石示禾穴立丞丟乒乓乩亙交亦亥仿伉伙伊伕伍伐休伏仲件任仰仳份企伋光兇兆先全"
		],
		[
			"a640",
			"共再冰列刑划刎刖劣匈匡匠印危吉吏同吊吐吁吋各向名合吃后吆吒因回囝圳地在圭圬圯圩夙多夷夸妄奸妃好她如妁字存宇守宅安寺尖屹州帆并年"
		],
		[
			"a6a1",
			"式弛忙忖戎戌戍成扣扛托收早旨旬旭曲曳有朽朴朱朵次此死氖汝汗汙江池汐汕污汛汍汎灰牟牝百竹米糸缶羊羽老考而耒耳聿肉肋肌臣自至臼舌舛舟艮色艾虫血行衣西阡串亨位住佇佗佞伴佛何估佐佑伽伺伸佃佔似但佣"
		],
		[
			"a740",
			"作你伯低伶余佝佈佚兌克免兵冶冷別判利刪刨劫助努劬匣即卵吝吭吞吾否呎吧呆呃吳呈呂君吩告吹吻吸吮吵吶吠吼呀吱含吟听囪困囤囫坊坑址坍"
		],
		[
			"a7a1",
			"均坎圾坐坏圻壯夾妝妒妨妞妣妙妖妍妤妓妊妥孝孜孚孛完宋宏尬局屁尿尾岐岑岔岌巫希序庇床廷弄弟彤形彷役忘忌志忍忱快忸忪戒我抄抗抖技扶抉扭把扼找批扳抒扯折扮投抓抑抆改攻攸旱更束李杏材村杜杖杞杉杆杠"
		],
		[
			"a840",
			"杓杗步每求汞沙沁沈沉沅沛汪決沐汰沌汨沖沒汽沃汲汾汴沆汶沍沔沘沂灶灼災灸牢牡牠狄狂玖甬甫男甸皂盯矣私秀禿究系罕肖肓肝肘肛肚育良芒"
		],
		[
			"a8a1",
			"芋芍見角言谷豆豕貝赤走足身車辛辰迂迆迅迄巡邑邢邪邦那酉釆里防阮阱阪阬並乖乳事些亞享京佯依侍佳使佬供例來侃佰併侈佩佻侖佾侏侑佺兔兒兕兩具其典冽函刻券刷刺到刮制剁劾劻卒協卓卑卦卷卸卹取叔受味呵"
		],
		[
			"a940",
			"咖呸咕咀呻呷咄咒咆呼咐呱呶和咚呢周咋命咎固垃坷坪坩坡坦坤坼夜奉奇奈奄奔妾妻委妹妮姑姆姐姍始姓姊妯妳姒姅孟孤季宗定官宜宙宛尚屈居"
		],
		[
			"a9a1",
			"屆岷岡岸岩岫岱岳帘帚帖帕帛帑幸庚店府底庖延弦弧弩往征彿彼忝忠忽念忿怏怔怯怵怖怪怕怡性怩怫怛或戕房戾所承拉拌拄抿拂抹拒招披拓拔拋拈抨抽押拐拙拇拍抵拚抱拘拖拗拆抬拎放斧於旺昔易昌昆昂明昀昏昕昊"
		],
		[
			"aa40",
			"昇服朋杭枋枕東果杳杷枇枝林杯杰板枉松析杵枚枓杼杪杲欣武歧歿氓氛泣注泳沱泌泥河沽沾沼波沫法泓沸泄油況沮泗泅泱沿治泡泛泊沬泯泜泖泠"
		],
		[
			"aaa1",
			"炕炎炒炊炙爬爭爸版牧物狀狎狙狗狐玩玨玟玫玥甽疝疙疚的盂盲直知矽社祀祁秉秈空穹竺糾罔羌羋者肺肥肢肱股肫肩肴肪肯臥臾舍芳芝芙芭芽芟芹花芬芥芯芸芣芰芾芷虎虱初表軋迎返近邵邸邱邶采金長門阜陀阿阻附"
		],
		[
			"ab40",
			"陂隹雨青非亟亭亮信侵侯便俠俑俏保促侶俘俟俊俗侮俐俄係俚俎俞侷兗冒冑冠剎剃削前剌剋則勇勉勃勁匍南卻厚叛咬哀咨哎哉咸咦咳哇哂咽咪品"
		],
		[
			"aba1",
			"哄哈咯咫咱咻咩咧咿囿垂型垠垣垢城垮垓奕契奏奎奐姜姘姿姣姨娃姥姪姚姦威姻孩宣宦室客宥封屎屏屍屋峙峒巷帝帥帟幽庠度建弈弭彥很待徊律徇後徉怒思怠急怎怨恍恰恨恢恆恃恬恫恪恤扁拜挖按拼拭持拮拽指拱拷"
		],
		[
			"ac40",
			"拯括拾拴挑挂政故斫施既春昭映昧是星昨昱昤曷柿染柱柔某柬架枯柵柩柯柄柑枴柚查枸柏柞柳枰柙柢柝柒歪殃殆段毒毗氟泉洋洲洪流津洌洱洞洗"
		],
		[
			"aca1",
			"活洽派洶洛泵洹洧洸洩洮洵洎洫炫為炳炬炯炭炸炮炤爰牲牯牴狩狠狡玷珊玻玲珍珀玳甚甭畏界畎畋疫疤疥疢疣癸皆皇皈盈盆盃盅省盹相眉看盾盼眇矜砂研砌砍祆祉祈祇禹禺科秒秋穿突竿竽籽紂紅紀紉紇約紆缸美羿耄"
		],
		[
			"ad40",
			"耐耍耑耶胖胥胚胃胄背胡胛胎胞胤胝致舢苧范茅苣苛苦茄若茂茉苒苗英茁苜苔苑苞苓苟苯茆虐虹虻虺衍衫要觔計訂訃貞負赴赳趴軍軌述迦迢迪迥"
		],
		[
			"ada1",
			"迭迫迤迨郊郎郁郃酋酊重閂限陋陌降面革韋韭音頁風飛食首香乘亳倌倍倣俯倦倥俸倩倖倆值借倚倒們俺倀倔倨俱倡個候倘俳修倭倪俾倫倉兼冤冥冢凍凌准凋剖剜剔剛剝匪卿原厝叟哨唐唁唷哼哥哲唆哺唔哩哭員唉哮哪"
		],
		[
			"ae40",
			"哦唧唇哽唏圃圄埂埔埋埃堉夏套奘奚娑娘娜娟娛娓姬娠娣娩娥娌娉孫屘宰害家宴宮宵容宸射屑展屐峭峽峻峪峨峰島崁峴差席師庫庭座弱徒徑徐恙"
		],
		[
			"aea1",
			"恣恥恐恕恭恩息悄悟悚悍悔悌悅悖扇拳挈拿捎挾振捕捂捆捏捉挺捐挽挪挫挨捍捌效敉料旁旅時晉晏晃晒晌晅晁書朔朕朗校核案框桓根桂桔栩梳栗桌桑栽柴桐桀格桃株桅栓栘桁殊殉殷氣氧氨氦氤泰浪涕消涇浦浸海浙涓"
		],
		[
			"af40",
			"浬涉浮浚浴浩涌涊浹涅浥涔烊烘烤烙烈烏爹特狼狹狽狸狷玆班琉珮珠珪珞畔畝畜畚留疾病症疲疳疽疼疹痂疸皋皰益盍盎眩真眠眨矩砰砧砸砝破砷"
		],
		[
			"afa1",
			"砥砭砠砟砲祕祐祠祟祖神祝祗祚秤秣秧租秦秩秘窄窈站笆笑粉紡紗紋紊素索純紐紕級紜納紙紛缺罟羔翅翁耆耘耕耙耗耽耿胱脂胰脅胭胴脆胸胳脈能脊胼胯臭臬舀舐航舫舨般芻茫荒荔荊茸荐草茵茴荏茲茹茶茗荀茱茨荃"
		],
		[
			"b040",
			"虔蚊蚪蚓蚤蚩蚌蚣蚜衰衷袁袂衽衹記訐討訌訕訊託訓訖訏訑豈豺豹財貢起躬軒軔軏辱送逆迷退迺迴逃追逅迸邕郡郝郢酒配酌釘針釗釜釙閃院陣陡"
		],
		[
			"b0a1",
			"陛陝除陘陞隻飢馬骨高鬥鬲鬼乾偺偽停假偃偌做偉健偶偎偕偵側偷偏倏偯偭兜冕凰剪副勒務勘動匐匏匙匿區匾參曼商啪啦啄啞啡啃啊唱啖問啕唯啤唸售啜唬啣唳啁啗圈國圉域堅堊堆埠埤基堂堵執培夠奢娶婁婉婦婪婀"
		],
		[
			"b140",
			"娼婢婚婆婊孰寇寅寄寂宿密尉專將屠屜屝崇崆崎崛崖崢崑崩崔崙崤崧崗巢常帶帳帷康庸庶庵庾張強彗彬彩彫得徙從徘御徠徜恿患悉悠您惋悴惦悽"
		],
		[
			"b1a1",
			"情悻悵惜悼惘惕惆惟悸惚惇戚戛扈掠控捲掖探接捷捧掘措捱掩掉掃掛捫推掄授掙採掬排掏掀捻捩捨捺敝敖救教敗啟敏敘敕敔斜斛斬族旋旌旎晝晚晤晨晦晞曹勗望梁梯梢梓梵桿桶梱梧梗械梃棄梭梆梅梔條梨梟梡梂欲殺"
		],
		[
			"b240",
			"毫毬氫涎涼淳淙液淡淌淤添淺清淇淋涯淑涮淞淹涸混淵淅淒渚涵淚淫淘淪深淮淨淆淄涪淬涿淦烹焉焊烽烯爽牽犁猜猛猖猓猙率琅琊球理現琍瓠瓶"
		],
		[
			"b2a1",
			"瓷甜產略畦畢異疏痔痕疵痊痍皎盔盒盛眷眾眼眶眸眺硫硃硎祥票祭移窒窕笠笨笛第符笙笞笮粒粗粕絆絃統紮紹紼絀細紳組累終紲紱缽羞羚翌翎習耜聊聆脯脖脣脫脩脰脤舂舵舷舶船莎莞莘荸莢莖莽莫莒莊莓莉莠荷荻荼"
		],
		[
			"b340",
			"莆莧處彪蛇蛀蚶蛄蚵蛆蛋蚱蚯蛉術袞袈被袒袖袍袋覓規訪訝訣訥許設訟訛訢豉豚販責貫貨貪貧赧赦趾趺軛軟這逍通逗連速逝逐逕逞造透逢逖逛途"
		],
		[
			"b3a1",
			"部郭都酗野釵釦釣釧釭釩閉陪陵陳陸陰陴陶陷陬雀雪雩章竟頂頃魚鳥鹵鹿麥麻傢傍傅備傑傀傖傘傚最凱割剴創剩勞勝勛博厥啻喀喧啼喊喝喘喂喜喪喔喇喋喃喳單喟唾喲喚喻喬喱啾喉喫喙圍堯堪場堤堰報堡堝堠壹壺奠"
		],
		[
			"b440",
			"婷媚婿媒媛媧孳孱寒富寓寐尊尋就嵌嵐崴嵇巽幅帽幀幃幾廊廁廂廄弼彭復循徨惑惡悲悶惠愜愣惺愕惰惻惴慨惱愎惶愉愀愒戟扉掣掌描揀揩揉揆揍"
		],
		[
			"b4a1",
			"插揣提握揖揭揮捶援揪換摒揚揹敞敦敢散斑斐斯普晰晴晶景暑智晾晷曾替期朝棺棕棠棘棗椅棟棵森棧棹棒棲棣棋棍植椒椎棉棚楮棻款欺欽殘殖殼毯氮氯氬港游湔渡渲湧湊渠渥渣減湛湘渤湖湮渭渦湯渴湍渺測湃渝渾滋"
		],
		[
			"b540",
			"溉渙湎湣湄湲湩湟焙焚焦焰無然煮焜牌犄犀猶猥猴猩琺琪琳琢琥琵琶琴琯琛琦琨甥甦畫番痢痛痣痙痘痞痠登發皖皓皴盜睏短硝硬硯稍稈程稅稀窘"
		],
		[
			"b5a1",
			"窗窖童竣等策筆筐筒答筍筋筏筑粟粥絞結絨絕紫絮絲絡給絢絰絳善翔翕耋聒肅腕腔腋腑腎脹腆脾腌腓腴舒舜菩萃菸萍菠菅萋菁華菱菴著萊菰萌菌菽菲菊萸萎萄菜萇菔菟虛蛟蛙蛭蛔蛛蛤蛐蛞街裁裂袱覃視註詠評詞証詁"
		],
		[
			"b640",
			"詔詛詐詆訴診訶詖象貂貯貼貳貽賁費賀貴買貶貿貸越超趁跎距跋跚跑跌跛跆軻軸軼辜逮逵週逸進逶鄂郵鄉郾酣酥量鈔鈕鈣鈉鈞鈍鈐鈇鈑閔閏開閑"
		],
		[
			"b6a1",
			"間閒閎隊階隋陽隅隆隍陲隄雁雅雄集雇雯雲韌項順須飧飪飯飩飲飭馮馭黃黍黑亂傭債傲傳僅傾催傷傻傯僇剿剷剽募勦勤勢勣匯嗟嗨嗓嗦嗎嗜嗇嗑嗣嗤嗯嗚嗡嗅嗆嗥嗉園圓塞塑塘塗塚塔填塌塭塊塢塒塋奧嫁嫉嫌媾媽媼"
		],
		[
			"b740",
			"媳嫂媲嵩嵯幌幹廉廈弒彙徬微愚意慈感想愛惹愁愈慎慌慄慍愾愴愧愍愆愷戡戢搓搾搞搪搭搽搬搏搜搔損搶搖搗搆敬斟新暗暉暇暈暖暄暘暍會榔業"
		],
		[
			"b7a1",
			"楚楷楠楔極椰概楊楨楫楞楓楹榆楝楣楛歇歲毀殿毓毽溢溯滓溶滂源溝滇滅溥溘溼溺溫滑準溜滄滔溪溧溴煎煙煩煤煉照煜煬煦煌煥煞煆煨煖爺牒猷獅猿猾瑯瑚瑕瑟瑞瑁琿瑙瑛瑜當畸瘀痰瘁痲痱痺痿痴痳盞盟睛睫睦睞督"
		],
		[
			"b840",
			"睹睪睬睜睥睨睢矮碎碰碗碘碌碉硼碑碓硿祺祿禁萬禽稜稚稠稔稟稞窟窠筷節筠筮筧粱粳粵經絹綑綁綏絛置罩罪署義羨群聖聘肆肄腱腰腸腥腮腳腫"
		],
		[
			"b8a1",
			"腹腺腦舅艇蒂葷落萱葵葦葫葉葬葛萼萵葡董葩葭葆虞虜號蛹蜓蜈蜇蜀蛾蛻蜂蜃蜆蜊衙裟裔裙補裘裝裡裊裕裒覜解詫該詳試詩詰誇詼詣誠話誅詭詢詮詬詹詻訾詨豢貊貉賊資賈賄貲賃賂賅跡跟跨路跳跺跪跤跦躲較載軾輊"
		],
		[
			"b940",
			"辟農運遊道遂達逼違遐遇遏過遍遑逾遁鄒鄗酬酪酩釉鈷鉗鈸鈽鉀鈾鉛鉋鉤鉑鈴鉉鉍鉅鈹鈿鉚閘隘隔隕雍雋雉雊雷電雹零靖靴靶預頑頓頊頒頌飼飴"
		],
		[
			"b9a1",
			"飽飾馳馱馴髡鳩麂鼎鼓鼠僧僮僥僖僭僚僕像僑僱僎僩兢凳劃劂匱厭嗾嘀嘛嘗嗽嘔嘆嘉嘍嘎嗷嘖嘟嘈嘐嗶團圖塵塾境墓墊塹墅塽壽夥夢夤奪奩嫡嫦嫩嫗嫖嫘嫣孵寞寧寡寥實寨寢寤察對屢嶄嶇幛幣幕幗幔廓廖弊彆彰徹慇"
		],
		[
			"ba40",
			"愿態慷慢慣慟慚慘慵截撇摘摔撤摸摟摺摑摧搴摭摻敲斡旗旖暢暨暝榜榨榕槁榮槓構榛榷榻榫榴槐槍榭槌榦槃榣歉歌氳漳演滾漓滴漩漾漠漬漏漂漢"
		],
		[
			"baa1",
			"滿滯漆漱漸漲漣漕漫漯澈漪滬漁滲滌滷熔熙煽熊熄熒爾犒犖獄獐瑤瑣瑪瑰瑭甄疑瘧瘍瘋瘉瘓盡監瞄睽睿睡磁碟碧碳碩碣禎福禍種稱窪窩竭端管箕箋筵算箝箔箏箸箇箄粹粽精綻綰綜綽綾綠緊綴網綱綺綢綿綵綸維緒緇綬"
		],
		[
			"bb40",
			"罰翠翡翟聞聚肇腐膀膏膈膊腿膂臧臺與舔舞艋蓉蒿蓆蓄蒙蒞蒲蒜蓋蒸蓀蓓蒐蒼蓑蓊蜿蜜蜻蜢蜥蜴蜘蝕蜷蜩裳褂裴裹裸製裨褚裯誦誌語誣認誡誓誤"
		],
		[
			"bba1",
			"說誥誨誘誑誚誧豪貍貌賓賑賒赫趙趕跼輔輒輕輓辣遠遘遜遣遙遞遢遝遛鄙鄘鄞酵酸酷酴鉸銀銅銘銖鉻銓銜銨鉼銑閡閨閩閣閥閤隙障際雌雒需靼鞅韶頗領颯颱餃餅餌餉駁骯骰髦魁魂鳴鳶鳳麼鼻齊億儀僻僵價儂儈儉儅凜"
		],
		[
			"bc40",
			"劇劈劉劍劊勰厲嘮嘻嘹嘲嘿嘴嘩噓噎噗噴嘶嘯嘰墀墟增墳墜墮墩墦奭嬉嫻嬋嫵嬌嬈寮寬審寫層履嶝嶔幢幟幡廢廚廟廝廣廠彈影德徵慶慧慮慝慕憂"
		],
		[
			"bca1",
			"慼慰慫慾憧憐憫憎憬憚憤憔憮戮摩摯摹撞撲撈撐撰撥撓撕撩撒撮播撫撚撬撙撢撳敵敷數暮暫暴暱樣樟槨樁樞標槽模樓樊槳樂樅槭樑歐歎殤毅毆漿潼澄潑潦潔澆潭潛潸潮澎潺潰潤澗潘滕潯潠潟熟熬熱熨牖犛獎獗瑩璋璃"
		],
		[
			"bd40",
			"瑾璀畿瘠瘩瘟瘤瘦瘡瘢皚皺盤瞎瞇瞌瞑瞋磋磅確磊碾磕碼磐稿稼穀稽稷稻窯窮箭箱範箴篆篇篁箠篌糊締練緯緻緘緬緝編緣線緞緩綞緙緲緹罵罷羯"
		],
		[
			"bda1",
			"翩耦膛膜膝膠膚膘蔗蔽蔚蓮蔬蔭蔓蔑蔣蔡蔔蓬蔥蓿蔆螂蝴蝶蝠蝦蝸蝨蝙蝗蝌蝓衛衝褐複褒褓褕褊誼諒談諄誕請諸課諉諂調誰論諍誶誹諛豌豎豬賠賞賦賤賬賭賢賣賜質賡赭趟趣踫踐踝踢踏踩踟踡踞躺輝輛輟輩輦輪輜輞"
		],
		[
			"be40",
			"輥適遮遨遭遷鄰鄭鄧鄱醇醉醋醃鋅銻銷鋪銬鋤鋁銳銼鋒鋇鋰銲閭閱霄霆震霉靠鞍鞋鞏頡頫頜颳養餓餒餘駝駐駟駛駑駕駒駙骷髮髯鬧魅魄魷魯鴆鴉"
		],
		[
			"bea1",
			"鴃麩麾黎墨齒儒儘儔儐儕冀冪凝劑劓勳噙噫噹噩噤噸噪器噥噱噯噬噢噶壁墾壇壅奮嬝嬴學寰導彊憲憑憩憊懍憶憾懊懈戰擅擁擋撻撼據擄擇擂操撿擒擔撾整曆曉暹曄曇暸樽樸樺橙橫橘樹橄橢橡橋橇樵機橈歙歷氅濂澱澡"
		],
		[
			"bf40",
			"濃澤濁澧澳激澹澶澦澠澴熾燉燐燒燈燕熹燎燙燜燃燄獨璜璣璘璟璞瓢甌甍瘴瘸瘺盧盥瞠瞞瞟瞥磨磚磬磧禦積穎穆穌穋窺篙簑築篤篛篡篩篦糕糖縊"
		],
		[
			"bfa1",
			"縑縈縛縣縞縝縉縐罹羲翰翱翮耨膳膩膨臻興艘艙蕊蕙蕈蕨蕩蕃蕉蕭蕪蕞螃螟螞螢融衡褪褲褥褫褡親覦諦諺諫諱謀諜諧諮諾謁謂諷諭諳諶諼豫豭貓賴蹄踱踴蹂踹踵輻輯輸輳辨辦遵遴選遲遼遺鄴醒錠錶鋸錳錯錢鋼錫錄錚"
		],
		[
			"c040",
			"錐錦錡錕錮錙閻隧隨險雕霎霑霖霍霓霏靛靜靦鞘頰頸頻頷頭頹頤餐館餞餛餡餚駭駢駱骸骼髻髭鬨鮑鴕鴣鴦鴨鴒鴛默黔龍龜優償儡儲勵嚎嚀嚐嚅嚇"
		],
		[
			"c0a1",
			"嚏壕壓壑壎嬰嬪嬤孺尷屨嶼嶺嶽嶸幫彌徽應懂懇懦懋戲戴擎擊擘擠擰擦擬擱擢擭斂斃曙曖檀檔檄檢檜櫛檣橾檗檐檠歜殮毚氈濘濱濟濠濛濤濫濯澀濬濡濩濕濮濰燧營燮燦燥燭燬燴燠爵牆獰獲璩環璦璨癆療癌盪瞳瞪瞰瞬"
		],
		[
			"c140",
			"瞧瞭矯磷磺磴磯礁禧禪穗窿簇簍篾篷簌篠糠糜糞糢糟糙糝縮績繆縷縲繃縫總縱繅繁縴縹繈縵縿縯罄翳翼聱聲聰聯聳臆臃膺臂臀膿膽臉膾臨舉艱薪"
		],
		[
			"c1a1",
			"薄蕾薜薑薔薯薛薇薨薊虧蟀蟑螳蟒蟆螫螻螺蟈蟋褻褶襄褸褽覬謎謗謙講謊謠謝謄謐豁谿豳賺賽購賸賻趨蹉蹋蹈蹊轄輾轂轅輿避遽還邁邂邀鄹醣醞醜鍍鎂錨鍵鍊鍥鍋錘鍾鍬鍛鍰鍚鍔闊闋闌闈闆隱隸雖霜霞鞠韓顆颶餵騁"
		],
		[
			"c240",
			"駿鮮鮫鮪鮭鴻鴿麋黏點黜黝黛鼾齋叢嚕嚮壙壘嬸彝懣戳擴擲擾攆擺擻擷斷曜朦檳檬櫃檻檸櫂檮檯歟歸殯瀉瀋濾瀆濺瀑瀏燻燼燾燸獷獵璧璿甕癖癘"
		],
		[
			"c2a1",
			"癒瞽瞿瞻瞼礎禮穡穢穠竄竅簫簧簪簞簣簡糧織繕繞繚繡繒繙罈翹翻職聶臍臏舊藏薩藍藐藉薰薺薹薦蟯蟬蟲蟠覆覲觴謨謹謬謫豐贅蹙蹣蹦蹤蹟蹕軀轉轍邇邃邈醫醬釐鎔鎊鎖鎢鎳鎮鎬鎰鎘鎚鎗闔闖闐闕離雜雙雛雞霤鞣鞦"
		],
		[
			"c340",
			"鞭韹額顏題顎顓颺餾餿餽餮馥騎髁鬃鬆魏魎魍鯊鯉鯽鯈鯀鵑鵝鵠黠鼕鼬儳嚥壞壟壢寵龐廬懲懷懶懵攀攏曠曝櫥櫝櫚櫓瀛瀟瀨瀚瀝瀕瀘爆爍牘犢獸"
		],
		[
			"c3a1",
			"獺璽瓊瓣疇疆癟癡矇礙禱穫穩簾簿簸簽簷籀繫繭繹繩繪羅繳羶羹羸臘藩藝藪藕藤藥藷蟻蠅蠍蟹蟾襠襟襖襞譁譜識證譚譎譏譆譙贈贊蹼蹲躇蹶蹬蹺蹴轔轎辭邊邋醱醮鏡鏑鏟鏃鏈鏜鏝鏖鏢鏍鏘鏤鏗鏨關隴難霪霧靡韜韻類"
		],
		[
			"c440",
			"願顛颼饅饉騖騙鬍鯨鯧鯖鯛鶉鵡鵲鵪鵬麒麗麓麴勸嚨嚷嚶嚴嚼壤孀孃孽寶巉懸懺攘攔攙曦朧櫬瀾瀰瀲爐獻瓏癢癥礦礪礬礫竇競籌籃籍糯糰辮繽繼"
		],
		[
			"c4a1",
			"纂罌耀臚艦藻藹蘑藺蘆蘋蘇蘊蠔蠕襤覺觸議譬警譯譟譫贏贍躉躁躅躂醴釋鐘鐃鏽闡霰飄饒饑馨騫騰騷騵鰓鰍鹹麵黨鼯齟齣齡儷儸囁囀囂夔屬巍懼懾攝攜斕曩櫻欄櫺殲灌爛犧瓖瓔癩矓籐纏續羼蘗蘭蘚蠣蠢蠡蠟襪襬覽譴"
		],
		[
			"c540",
			"護譽贓躊躍躋轟辯醺鐮鐳鐵鐺鐸鐲鐫闢霸霹露響顧顥饗驅驃驀騾髏魔魑鰭鰥鶯鶴鷂鶸麝黯鼙齜齦齧儼儻囈囊囉孿巔巒彎懿攤權歡灑灘玀瓤疊癮癬"
		],
		[
			"c5a1",
			"禳籠籟聾聽臟襲襯觼讀贖贗躑躓轡酈鑄鑑鑒霽霾韃韁顫饕驕驍髒鬚鱉鰱鰾鰻鷓鷗鼴齬齪龔囌巖戀攣攫攪曬欐瓚竊籤籣籥纓纖纔臢蘸蘿蠱變邐邏鑣鑠鑤靨顯饜驚驛驗髓體髑鱔鱗鱖鷥麟黴囑壩攬灞癱癲矗罐羈蠶蠹衢讓讒"
		],
		[
			"c640",
			"讖艷贛釀鑪靂靈靄韆顰驟鬢魘鱟鷹鷺鹼鹽鼇齷齲廳欖灣籬籮蠻觀躡釁鑲鑰顱饞髖鬣黌灤矚讚鑷韉驢驥纜讜躪釅鑽鑾鑼鱷鱸黷豔鑿鸚爨驪鬱鸛鸞籲"
		],
		[
			"c940",
			"乂乜凵匚厂万丌乇亍囗兀屮彳丏冇与丮亓仂仉仈冘勼卬厹圠夃夬尐巿旡殳毌气爿丱丼仨仜仩仡仝仚刌匜卌圢圣夗夯宁宄尒尻屴屳帄庀庂忉戉扐氕"
		],
		[
			"c9a1",
			"氶汃氿氻犮犰玊禸肊阞伎优伬仵伔仱伀价伈伝伂伅伢伓伄仴伒冱刓刉刐劦匢匟卍厊吇囡囟圮圪圴夼妀奼妅奻奾奷奿孖尕尥屼屺屻屾巟幵庄异弚彴忕忔忏扜扞扤扡扦扢扙扠扚扥旯旮朾朹朸朻机朿朼朳氘汆汒汜汏汊汔汋"
		],
		[
			"ca40",
			"汌灱牞犴犵玎甪癿穵网艸艼芀艽艿虍襾邙邗邘邛邔阢阤阠阣佖伻佢佉体佤伾佧佒佟佁佘伭伳伿佡冏冹刜刞刡劭劮匉卣卲厎厏吰吷吪呔呅吙吜吥吘"
		],
		[
			"caa1",
			"吽呏呁吨吤呇囮囧囥坁坅坌坉坋坒夆奀妦妘妠妗妎妢妐妏妧妡宎宒尨尪岍岏岈岋岉岒岊岆岓岕巠帊帎庋庉庌庈庍弅弝彸彶忒忑忐忭忨忮忳忡忤忣忺忯忷忻怀忴戺抃抌抎抏抔抇扱扻扺扰抁抈扷扽扲扴攷旰旴旳旲旵杅杇"
		],
		[
			"cb40",
			"杙杕杌杈杝杍杚杋毐氙氚汸汧汫沄沋沏汱汯汩沚汭沇沕沜汦汳汥汻沎灴灺牣犿犽狃狆狁犺狅玕玗玓玔玒町甹疔疕皁礽耴肕肙肐肒肜芐芏芅芎芑芓"
		],
		[
			"cba1",
			"芊芃芄豸迉辿邟邡邥邞邧邠阰阨阯阭丳侘佼侅佽侀侇佶佴侉侄佷佌侗佪侚佹侁佸侐侜侔侞侒侂侕佫佮冞冼冾刵刲刳剆刱劼匊匋匼厒厔咇呿咁咑咂咈呫呺呾呥呬呴呦咍呯呡呠咘呣呧呤囷囹坯坲坭坫坱坰坶垀坵坻坳坴坢"
		],
		[
			"cc40",
			"坨坽夌奅妵妺姏姎妲姌姁妶妼姃姖妱妽姀姈妴姇孢孥宓宕屄屇岮岤岠岵岯岨岬岟岣岭岢岪岧岝岥岶岰岦帗帔帙弨弢弣弤彔徂彾彽忞忥怭怦怙怲怋"
		],
		[
			"cca1",
			"怴怊怗怳怚怞怬怢怍怐怮怓怑怌怉怜戔戽抭抴拑抾抪抶拊抮抳抯抻抩抰抸攽斨斻昉旼昄昒昈旻昃昋昍昅旽昑昐曶朊枅杬枎枒杶杻枘枆构杴枍枌杺枟枑枙枃杽极杸杹枔欥殀歾毞氝沓泬泫泮泙沶泔沭泧沷泐泂沺泃泆泭泲"
		],
		[
			"cd40",
			"泒泝沴沊沝沀泞泀洰泍泇沰泹泏泩泑炔炘炅炓炆炄炑炖炂炚炃牪狖狋狘狉狜狒狔狚狌狑玤玡玭玦玢玠玬玝瓝瓨甿畀甾疌疘皯盳盱盰盵矸矼矹矻矺"
		],
		[
			"cda1",
			"矷祂礿秅穸穻竻籵糽耵肏肮肣肸肵肭舠芠苀芫芚芘芛芵芧芮芼芞芺芴芨芡芩苂芤苃芶芢虰虯虭虮豖迒迋迓迍迖迕迗邲邴邯邳邰阹阽阼阺陃俍俅俓侲俉俋俁俔俜俙侻侳俛俇俖侺俀侹俬剄剉勀勂匽卼厗厖厙厘咺咡咭咥哏"
		],
		[
			"ce40",
			"哃茍咷咮哖咶哅哆咠呰咼咢咾呲哞咰垵垞垟垤垌垗垝垛垔垘垏垙垥垚垕壴复奓姡姞姮娀姱姝姺姽姼姶姤姲姷姛姩姳姵姠姾姴姭宨屌峐峘峌峗峋峛"
		],
		[
			"cea1",
			"峞峚峉峇峊峖峓峔峏峈峆峎峟峸巹帡帢帣帠帤庰庤庢庛庣庥弇弮彖徆怷怹恔恲恞恅恓恇恉恛恌恀恂恟怤恄恘恦恮扂扃拏挍挋拵挎挃拫拹挏挌拸拶挀挓挔拺挕拻拰敁敃斪斿昶昡昲昵昜昦昢昳昫昺昝昴昹昮朏朐柁柲柈枺"
		],
		[
			"cf40",
			"柜枻柸柘柀枷柅柫柤柟枵柍枳柷柶柮柣柂枹柎柧柰枲柼柆柭柌枮柦柛柺柉柊柃柪柋欨殂殄殶毖毘毠氠氡洨洴洭洟洼洿洒洊泚洳洄洙洺洚洑洀洝浂"
		],
		[
			"cfa1",
			"洁洘洷洃洏浀洇洠洬洈洢洉洐炷炟炾炱炰炡炴炵炩牁牉牊牬牰牳牮狊狤狨狫狟狪狦狣玅珌珂珈珅玹玶玵玴珫玿珇玾珃珆玸珋瓬瓮甮畇畈疧疪癹盄眈眃眄眅眊盷盻盺矧矨砆砑砒砅砐砏砎砉砃砓祊祌祋祅祄秕种秏秖秎窀"
		],
		[
			"d040",
			"穾竑笀笁籺籸籹籿粀粁紃紈紁罘羑羍羾耇耎耏耔耷胘胇胠胑胈胂胐胅胣胙胜胊胕胉胏胗胦胍臿舡芔苙苾苹茇苨茀苕茺苫苖苴苬苡苲苵茌苻苶苰苪"
		],
		[
			"d0a1",
			"苤苠苺苳苭虷虴虼虳衁衎衧衪衩觓訄訇赲迣迡迮迠郱邽邿郕郅邾郇郋郈釔釓陔陏陑陓陊陎倞倅倇倓倢倰倛俵俴倳倷倬俶俷倗倜倠倧倵倯倱倎党冔冓凊凄凅凈凎剡剚剒剞剟剕剢勍匎厞唦哢唗唒哧哳哤唚哿唄唈哫唑唅哱"
		],
		[
			"d140",
			"唊哻哷哸哠唎唃唋圁圂埌堲埕埒垺埆垽垼垸垶垿埇埐垹埁夎奊娙娖娭娮娕娏娗娊娞娳孬宧宭宬尃屖屔峬峿峮峱峷崀峹帩帨庨庮庪庬弳弰彧恝恚恧"
		],
		[
			"d1a1",
			"恁悢悈悀悒悁悝悃悕悛悗悇悜悎戙扆拲挐捖挬捄捅挶捃揤挹捋捊挼挩捁挴捘捔捙挭捇挳捚捑挸捗捀捈敊敆旆旃旄旂晊晟晇晑朒朓栟栚桉栲栳栻桋桏栖栱栜栵栫栭栯桎桄栴栝栒栔栦栨栮桍栺栥栠欬欯欭欱欴歭肂殈毦毤"
		],
		[
			"d240",
			"毨毣毢毧氥浺浣浤浶洍浡涒浘浢浭浯涑涍淯浿涆浞浧浠涗浰浼浟涂涘洯浨涋浾涀涄洖涃浻浽浵涐烜烓烑烝烋缹烢烗烒烞烠烔烍烅烆烇烚烎烡牂牸"
		],
		[
			"d2a1",
			"牷牶猀狺狴狾狶狳狻猁珓珙珥珖玼珧珣珩珜珒珛珔珝珚珗珘珨瓞瓟瓴瓵甡畛畟疰痁疻痄痀疿疶疺皊盉眝眛眐眓眒眣眑眕眙眚眢眧砣砬砢砵砯砨砮砫砡砩砳砪砱祔祛祏祜祓祒祑秫秬秠秮秭秪秜秞秝窆窉窅窋窌窊窇竘笐"
		],
		[
			"d340",
			"笄笓笅笏笈笊笎笉笒粄粑粊粌粈粍粅紞紝紑紎紘紖紓紟紒紏紌罜罡罞罠罝罛羖羒翃翂翀耖耾耹胺胲胹胵脁胻脀舁舯舥茳茭荄茙荑茥荖茿荁茦茜茢"
		],
		[
			"d3a1",
			"荂荎茛茪茈茼荍茖茤茠茷茯茩荇荅荌荓茞茬荋茧荈虓虒蚢蚨蚖蚍蚑蚞蚇蚗蚆蚋蚚蚅蚥蚙蚡蚧蚕蚘蚎蚝蚐蚔衃衄衭衵衶衲袀衱衿衯袃衾衴衼訒豇豗豻貤貣赶赸趵趷趶軑軓迾迵适迿迻逄迼迶郖郠郙郚郣郟郥郘郛郗郜郤酐"
		],
		[
			"d440",
			"酎酏釕釢釚陜陟隼飣髟鬯乿偰偪偡偞偠偓偋偝偲偈偍偁偛偊偢倕偅偟偩偫偣偤偆偀偮偳偗偑凐剫剭剬剮勖勓匭厜啵啶唼啍啐唴唪啑啢唶唵唰啒啅"
		],
		[
			"d4a1",
			"唌唲啥啎唹啈唭唻啀啋圊圇埻堔埢埶埜埴堀埭埽堈埸堋埳埏堇埮埣埲埥埬埡堎埼堐埧堁堌埱埩埰堍堄奜婠婘婕婧婞娸娵婭婐婟婥婬婓婤婗婃婝婒婄婛婈媎娾婍娹婌婰婩婇婑婖婂婜孲孮寁寀屙崞崋崝崚崠崌崨崍崦崥崏"
		],
		[
			"d540",
			"崰崒崣崟崮帾帴庱庴庹庲庳弶弸徛徖徟悊悐悆悾悰悺惓惔惏惤惙惝惈悱惛悷惊悿惃惍惀挲捥掊掂捽掽掞掭掝掗掫掎捯掇掐据掯捵掜捭掮捼掤挻掟"
		],
		[
			"d5a1",
			"捸掅掁掑掍捰敓旍晥晡晛晙晜晢朘桹梇梐梜桭桮梮梫楖桯梣梬梩桵桴梲梏桷梒桼桫桲梪梀桱桾梛梖梋梠梉梤桸桻梑梌梊桽欶欳欷欸殑殏殍殎殌氪淀涫涴涳湴涬淩淢涷淶淔渀淈淠淟淖涾淥淜淝淛淴淊涽淭淰涺淕淂淏淉"
		],
		[
			"d640",
			"淐淲淓淽淗淍淣涻烺焍烷焗烴焌烰焄烳焐烼烿焆焓焀烸烶焋焂焎牾牻牼牿猝猗猇猑猘猊猈狿猏猞玈珶珸珵琄琁珽琇琀珺珼珿琌琋珴琈畤畣痎痒痏"
		],
		[
			"d6a1",
			"痋痌痑痐皏皉盓眹眯眭眱眲眴眳眽眥眻眵硈硒硉硍硊硌砦硅硐祤祧祩祪祣祫祡离秺秸秶秷窏窔窐笵筇笴笥笰笢笤笳笘笪笝笱笫笭笯笲笸笚笣粔粘粖粣紵紽紸紶紺絅紬紩絁絇紾紿絊紻紨罣羕羜羝羛翊翋翍翐翑翇翏翉耟"
		],
		[
			"d740",
			"耞耛聇聃聈脘脥脙脛脭脟脬脞脡脕脧脝脢舑舸舳舺舴舲艴莐莣莨莍荺荳莤荴莏莁莕莙荵莔莩荽莃莌莝莛莪莋荾莥莯莈莗莰荿莦莇莮荶莚虙虖蚿蚷"
		],
		[
			"d7a1",
			"蛂蛁蛅蚺蚰蛈蚹蚳蚸蛌蚴蚻蚼蛃蚽蚾衒袉袕袨袢袪袚袑袡袟袘袧袙袛袗袤袬袌袓袎覂觖觙觕訰訧訬訞谹谻豜豝豽貥赽赻赹趼跂趹趿跁軘軞軝軜軗軠軡逤逋逑逜逌逡郯郪郰郴郲郳郔郫郬郩酖酘酚酓酕釬釴釱釳釸釤釹釪"
		],
		[
			"d840",
			"釫釷釨釮镺閆閈陼陭陫陱陯隿靪頄飥馗傛傕傔傞傋傣傃傌傎傝偨傜傒傂傇兟凔匒匑厤厧喑喨喥喭啷噅喢喓喈喏喵喁喣喒喤啽喌喦啿喕喡喎圌堩堷"
		],
		[
			"d8a1",
			"堙堞堧堣堨埵塈堥堜堛堳堿堶堮堹堸堭堬堻奡媯媔媟婺媢媞婸媦婼媥媬媕媮娷媄媊媗媃媋媩婻婽媌媜媏媓媝寪寍寋寔寑寊寎尌尰崷嵃嵫嵁嵋崿崵嵑嵎嵕崳崺嵒崽崱嵙嵂崹嵉崸崼崲崶嵀嵅幄幁彘徦徥徫惉悹惌惢惎惄愔"
		],
		[
			"d940",
			"惲愊愖愅惵愓惸惼惾惁愃愘愝愐惿愄愋扊掔掱掰揎揥揨揯揃撝揳揊揠揶揕揲揵摡揟掾揝揜揄揘揓揂揇揌揋揈揰揗揙攲敧敪敤敜敨敥斌斝斞斮旐旒"
		],
		[
			"d9a1",
			"晼晬晻暀晱晹晪晲朁椌棓椄棜椪棬棪棱椏棖棷棫棤棶椓椐棳棡椇棌椈楰梴椑棯棆椔棸棐棽棼棨椋椊椗棎棈棝棞棦棴棑椆棔棩椕椥棇欹欻欿欼殔殗殙殕殽毰毲毳氰淼湆湇渟湉溈渼渽湅湢渫渿湁湝湳渜渳湋湀湑渻渃渮湞"
		],
		[
			"da40",
			"湨湜湡渱渨湠湱湫渹渢渰湓湥渧湸湤湷湕湹湒湦渵渶湚焠焞焯烻焮焱焣焥焢焲焟焨焺焛牋牚犈犉犆犅犋猒猋猰猢猱猳猧猲猭猦猣猵猌琮琬琰琫琖"
		],
		[
			"daa1",
			"琚琡琭琱琤琣琝琩琠琲瓻甯畯畬痧痚痡痦痝痟痤痗皕皒盚睆睇睄睍睅睊睎睋睌矞矬硠硤硥硜硭硱硪确硰硩硨硞硢祴祳祲祰稂稊稃稌稄窙竦竤筊笻筄筈筌筎筀筘筅粢粞粨粡絘絯絣絓絖絧絪絏絭絜絫絒絔絩絑絟絎缾缿罥"
		],
		[
			"db40",
			"罦羢羠羡翗聑聏聐胾胔腃腊腒腏腇脽腍脺臦臮臷臸臹舄舼舽舿艵茻菏菹萣菀菨萒菧菤菼菶萐菆菈菫菣莿萁菝菥菘菿菡菋菎菖菵菉萉萏菞萑萆菂菳"
		],
		[
			"dba1",
			"菕菺菇菑菪萓菃菬菮菄菻菗菢萛菛菾蛘蛢蛦蛓蛣蛚蛪蛝蛫蛜蛬蛩蛗蛨蛑衈衖衕袺裗袹袸裀袾袶袼袷袽袲褁裉覕覘覗觝觚觛詎詍訹詙詀詗詘詄詅詒詈詑詊詌詏豟貁貀貺貾貰貹貵趄趀趉跘跓跍跇跖跜跏跕跙跈跗跅軯軷軺"
		],
		[
			"dc40",
			"軹軦軮軥軵軧軨軶軫軱軬軴軩逭逴逯鄆鄬鄄郿郼鄈郹郻鄁鄀鄇鄅鄃酡酤酟酢酠鈁鈊鈥鈃鈚鈦鈏鈌鈀鈒釿釽鈆鈄鈧鈂鈜鈤鈙鈗鈅鈖镻閍閌閐隇陾隈"
		],
		[
			"dca1",
			"隉隃隀雂雈雃雱雰靬靰靮頇颩飫鳦黹亃亄亶傽傿僆傮僄僊傴僈僂傰僁傺傱僋僉傶傸凗剺剸剻剼嗃嗛嗌嗐嗋嗊嗝嗀嗔嗄嗩喿嗒喍嗏嗕嗢嗖嗈嗲嗍嗙嗂圔塓塨塤塏塍塉塯塕塎塝塙塥塛堽塣塱壼嫇嫄嫋媺媸媱媵媰媿嫈媻嫆"
		],
		[
			"dd40",
			"媷嫀嫊媴媶嫍媹媐寖寘寙尟尳嵱嵣嵊嵥嵲嵬嵞嵨嵧嵢巰幏幎幊幍幋廅廌廆廋廇彀徯徭惷慉慊愫慅愶愲愮慆愯慏愩慀戠酨戣戥戤揅揱揫搐搒搉搠搤"
		],
		[
			"dda1",
			"搳摃搟搕搘搹搷搢搣搌搦搰搨摁搵搯搊搚摀搥搧搋揧搛搮搡搎敯斒旓暆暌暕暐暋暊暙暔晸朠楦楟椸楎楢楱椿楅楪椹楂楗楙楺楈楉椵楬椳椽楥棰楸椴楩楀楯楄楶楘楁楴楌椻楋椷楜楏楑椲楒椯楻椼歆歅歃歂歈歁殛嗀毻毼"
		],
		[
			"de40",
			"毹毷毸溛滖滈溏滀溟溓溔溠溱溹滆滒溽滁溞滉溷溰滍溦滏溲溾滃滜滘溙溒溎溍溤溡溿溳滐滊溗溮溣煇煔煒煣煠煁煝煢煲煸煪煡煂煘煃煋煰煟煐煓"
		],
		[
			"dea1",
			"煄煍煚牏犍犌犑犐犎猼獂猻猺獀獊獉瑄瑊瑋瑒瑑瑗瑀瑏瑐瑎瑂瑆瑍瑔瓡瓿瓾瓽甝畹畷榃痯瘏瘃痷痾痼痹痸瘐痻痶痭痵痽皙皵盝睕睟睠睒睖睚睩睧睔睙睭矠碇碚碔碏碄碕碅碆碡碃硹碙碀碖硻祼禂祽祹稑稘稙稒稗稕稢稓"
		],
		[
			"df40",
			"稛稐窣窢窞竫筦筤筭筴筩筲筥筳筱筰筡筸筶筣粲粴粯綈綆綀綍絿綅絺綎絻綃絼綌綔綄絽綒罭罫罧罨罬羦羥羧翛翜耡腤腠腷腜腩腛腢腲朡腞腶腧腯"
		],
		[
			"dfa1",
			"腄腡舝艉艄艀艂艅蓱萿葖葶葹蒏蒍葥葑葀蒆葧萰葍葽葚葙葴葳葝蔇葞萷萺萴葺葃葸萲葅萩菙葋萯葂萭葟葰萹葎葌葒葯蓅蒎萻葇萶萳葨葾葄萫葠葔葮葐蜋蜄蛷蜌蛺蛖蛵蝍蛸蜎蜉蜁蛶蜍蜅裖裋裍裎裞裛裚裌裐覅覛觟觥觤"
		],
		[
			"e040",
			"觡觠觢觜触詶誆詿詡訿詷誂誄詵誃誁詴詺谼豋豊豥豤豦貆貄貅賌赨赩趑趌趎趏趍趓趔趐趒跰跠跬跱跮跐跩跣跢跧跲跫跴輆軿輁輀輅輇輈輂輋遒逿"
		],
		[
			"e0a1",
			"遄遉逽鄐鄍鄏鄑鄖鄔鄋鄎酮酯鉈鉒鈰鈺鉦鈳鉥鉞銃鈮鉊鉆鉭鉬鉏鉠鉧鉯鈶鉡鉰鈱鉔鉣鉐鉲鉎鉓鉌鉖鈲閟閜閞閛隒隓隑隗雎雺雽雸雵靳靷靸靲頏頍頎颬飶飹馯馲馰馵骭骫魛鳪鳭鳧麀黽僦僔僗僨僳僛僪僝僤僓僬僰僯僣僠"
		],
		[
			"e140",
			"凘劀劁勩勫匰厬嘧嘕嘌嘒嗼嘏嘜嘁嘓嘂嗺嘝嘄嗿嗹墉塼墐墘墆墁塿塴墋塺墇墑墎塶墂墈塻墔墏壾奫嫜嫮嫥嫕嫪嫚嫭嫫嫳嫢嫠嫛嫬嫞嫝嫙嫨嫟孷寠"
		],
		[
			"e1a1",
			"寣屣嶂嶀嵽嶆嵺嶁嵷嶊嶉嶈嵾嵼嶍嵹嵿幘幙幓廘廑廗廎廜廕廙廒廔彄彃彯徶愬愨慁慞慱慳慒慓慲慬憀慴慔慺慛慥愻慪慡慖戩戧戫搫摍摛摝摴摶摲摳摽摵摦撦摎撂摞摜摋摓摠摐摿搿摬摫摙摥摷敳斠暡暠暟朅朄朢榱榶槉"
		],
		[
			"e240",
			"榠槎榖榰榬榼榑榙榎榧榍榩榾榯榿槄榽榤槔榹槊榚槏榳榓榪榡榞槙榗榐槂榵榥槆歊歍歋殞殟殠毃毄毾滎滵滱漃漥滸漷滻漮漉潎漙漚漧漘漻漒滭漊"
		],
		[
			"e2a1",
			"漶潳滹滮漭潀漰漼漵滫漇漎潃漅滽滶漹漜滼漺漟漍漞漈漡熇熐熉熀熅熂熏煻熆熁熗牄牓犗犕犓獃獍獑獌瑢瑳瑱瑵瑲瑧瑮甀甂甃畽疐瘖瘈瘌瘕瘑瘊瘔皸瞁睼瞅瞂睮瞀睯睾瞃碲碪碴碭碨硾碫碞碥碠碬碢碤禘禊禋禖禕禔禓"
		],
		[
			"e340",
			"禗禈禒禐稫穊稰稯稨稦窨窫窬竮箈箜箊箑箐箖箍箌箛箎箅箘劄箙箤箂粻粿粼粺綧綷緂綣綪緁緀緅綝緎緄緆緋緌綯綹綖綼綟綦綮綩綡緉罳翢翣翥翞"
		],
		[
			"e3a1",
			"耤聝聜膉膆膃膇膍膌膋舕蒗蒤蒡蒟蒺蓎蓂蒬蒮蒫蒹蒴蓁蓍蒪蒚蒱蓐蒝蒧蒻蒢蒔蓇蓌蒛蒩蒯蒨蓖蒘蒶蓏蒠蓗蓔蓒蓛蒰蒑虡蜳蜣蜨蝫蝀蜮蜞蜡蜙蜛蝃蜬蝁蜾蝆蜠蜲蜪蜭蜼蜒蜺蜱蜵蝂蜦蜧蜸蜤蜚蜰蜑裷裧裱裲裺裾裮裼裶裻"
		],
		[
			"e440",
			"裰裬裫覝覡覟覞觩觫觨誫誙誋誒誏誖谽豨豩賕賏賗趖踉踂跿踍跽踊踃踇踆踅跾踀踄輐輑輎輍鄣鄜鄠鄢鄟鄝鄚鄤鄡鄛酺酲酹酳銥銤鉶銛鉺銠銔銪銍"
		],
		[
			"e4a1",
			"銦銚銫鉹銗鉿銣鋮銎銂銕銢鉽銈銡銊銆銌銙銧鉾銇銩銝銋鈭隞隡雿靘靽靺靾鞃鞀鞂靻鞄鞁靿韎韍頖颭颮餂餀餇馝馜駃馹馻馺駂馽駇骱髣髧鬾鬿魠魡魟鳱鳲鳵麧僿儃儰僸儆儇僶僾儋儌僽儊劋劌勱勯噈噂噌嘵噁噊噉噆噘"
		],
		[
			"e540",
			"噚噀嘳嘽嘬嘾嘸嘪嘺圚墫墝墱墠墣墯墬墥墡壿嫿嫴嫽嫷嫶嬃嫸嬂嫹嬁嬇嬅嬏屧嶙嶗嶟嶒嶢嶓嶕嶠嶜嶡嶚嶞幩幝幠幜緳廛廞廡彉徲憋憃慹憱憰憢憉"
		],
		[
			"e5a1",
			"憛憓憯憭憟憒憪憡憍慦憳戭摮摰撖撠撅撗撜撏撋撊撌撣撟摨撱撘敶敺敹敻斲斳暵暰暩暲暷暪暯樀樆樗槥槸樕槱槤樠槿槬槢樛樝槾樧槲槮樔槷槧橀樈槦槻樍槼槫樉樄樘樥樏槶樦樇槴樖歑殥殣殢殦氁氀毿氂潁漦潾澇濆澒"
		],
		[
			"e640",
			"澍澉澌潢潏澅潚澖潶潬澂潕潲潒潐潗澔澓潝漀潡潫潽潧澐潓澋潩潿澕潣潷潪潻熲熯熛熰熠熚熩熵熝熥熞熤熡熪熜熧熳犘犚獘獒獞獟獠獝獛獡獚獙"
		],
		[
			"e6a1",
			"獢璇璉璊璆璁瑽璅璈瑼瑹甈甇畾瘥瘞瘙瘝瘜瘣瘚瘨瘛皜皝皞皛瞍瞏瞉瞈磍碻磏磌磑磎磔磈磃磄磉禚禡禠禜禢禛歶稹窲窴窳箷篋箾箬篎箯箹篊箵糅糈糌糋緷緛緪緧緗緡縃緺緦緶緱緰緮緟罶羬羰羭翭翫翪翬翦翨聤聧膣膟"
		],
		[
			"e740",
			"膞膕膢膙膗舖艏艓艒艐艎艑蔤蔻蔏蔀蔩蔎蔉蔍蔟蔊蔧蔜蓻蔫蓺蔈蔌蓴蔪蓲蔕蓷蓫蓳蓼蔒蓪蓩蔖蓾蔨蔝蔮蔂蓽蔞蓶蔱蔦蓧蓨蓰蓯蓹蔘蔠蔰蔋蔙蔯虢"
		],
		[
			"e7a1",
			"蝖蝣蝤蝷蟡蝳蝘蝔蝛蝒蝡蝚蝑蝞蝭蝪蝐蝎蝟蝝蝯蝬蝺蝮蝜蝥蝏蝻蝵蝢蝧蝩衚褅褌褔褋褗褘褙褆褖褑褎褉覢覤覣觭觰觬諏諆誸諓諑諔諕誻諗誾諀諅諘諃誺誽諙谾豍貏賥賟賙賨賚賝賧趠趜趡趛踠踣踥踤踮踕踛踖踑踙踦踧"
		],
		[
			"e840",
			"踔踒踘踓踜踗踚輬輤輘輚輠輣輖輗遳遰遯遧遫鄯鄫鄩鄪鄲鄦鄮醅醆醊醁醂醄醀鋐鋃鋄鋀鋙銶鋏鋱鋟鋘鋩鋗鋝鋌鋯鋂鋨鋊鋈鋎鋦鋍鋕鋉鋠鋞鋧鋑鋓"
		],
		[
			"e8a1",
			"銵鋡鋆銴镼閬閫閮閰隤隢雓霅霈霂靚鞊鞎鞈韐韏頞頝頦頩頨頠頛頧颲餈飺餑餔餖餗餕駜駍駏駓駔駎駉駖駘駋駗駌骳髬髫髳髲髱魆魃魧魴魱魦魶魵魰魨魤魬鳼鳺鳽鳿鳷鴇鴀鳹鳻鴈鴅鴄麃黓鼏鼐儜儓儗儚儑凞匴叡噰噠噮"
		],
		[
			"e940",
			"噳噦噣噭噲噞噷圜圛壈墽壉墿墺壂墼壆嬗嬙嬛嬡嬔嬓嬐嬖嬨嬚嬠嬞寯嶬嶱嶩嶧嶵嶰嶮嶪嶨嶲嶭嶯嶴幧幨幦幯廩廧廦廨廥彋徼憝憨憖懅憴懆懁懌憺"
		],
		[
			"e9a1",
			"憿憸憌擗擖擐擏擉撽撉擃擛擳擙攳敿敼斢曈暾曀曊曋曏暽暻暺曌朣樴橦橉橧樲橨樾橝橭橶橛橑樨橚樻樿橁橪橤橐橏橔橯橩橠樼橞橖橕橍橎橆歕歔歖殧殪殫毈毇氄氃氆澭濋澣濇澼濎濈潞濄澽澞濊澨瀄澥澮澺澬澪濏澿澸"
		],
		[
			"ea40",
			"澢濉澫濍澯澲澰燅燂熿熸燖燀燁燋燔燊燇燏熽燘熼燆燚燛犝犞獩獦獧獬獥獫獪瑿璚璠璔璒璕璡甋疀瘯瘭瘱瘽瘳瘼瘵瘲瘰皻盦瞚瞝瞡瞜瞛瞢瞣瞕瞙"
		],
		[
			"eaa1",
			"瞗磝磩磥磪磞磣磛磡磢磭磟磠禤穄穈穇窶窸窵窱窷篞篣篧篝篕篥篚篨篹篔篪篢篜篫篘篟糒糔糗糐糑縒縡縗縌縟縠縓縎縜縕縚縢縋縏縖縍縔縥縤罃罻罼罺羱翯耪耩聬膱膦膮膹膵膫膰膬膴膲膷膧臲艕艖艗蕖蕅蕫蕍蕓蕡蕘"
		],
		[
			"eb40",
			"蕀蕆蕤蕁蕢蕄蕑蕇蕣蔾蕛蕱蕎蕮蕵蕕蕧蕠薌蕦蕝蕔蕥蕬虣虥虤螛螏螗螓螒螈螁螖螘蝹螇螣螅螐螑螝螄螔螜螚螉褞褦褰褭褮褧褱褢褩褣褯褬褟觱諠"
		],
		[
			"eba1",
			"諢諲諴諵諝謔諤諟諰諈諞諡諨諿諯諻貑貒貐賵賮賱賰賳赬赮趥趧踳踾踸蹀蹅踶踼踽蹁踰踿躽輶輮輵輲輹輷輴遶遹遻邆郺鄳鄵鄶醓醐醑醍醏錧錞錈錟錆錏鍺錸錼錛錣錒錁鍆錭錎錍鋋錝鋺錥錓鋹鋷錴錂錤鋿錩錹錵錪錔錌"
		],
		[
			"ec40",
			"錋鋾錉錀鋻錖閼闍閾閹閺閶閿閵閽隩雔霋霒霐鞙鞗鞔韰韸頵頯頲餤餟餧餩馞駮駬駥駤駰駣駪駩駧骹骿骴骻髶髺髹髷鬳鮀鮅鮇魼魾魻鮂鮓鮒鮐魺鮕"
		],
		[
			"eca1",
			"魽鮈鴥鴗鴠鴞鴔鴩鴝鴘鴢鴐鴙鴟麈麆麇麮麭黕黖黺鼒鼽儦儥儢儤儠儩勴嚓嚌嚍嚆嚄嚃噾嚂噿嚁壖壔壏壒嬭嬥嬲嬣嬬嬧嬦嬯嬮孻寱寲嶷幬幪徾徻懃憵憼懧懠懥懤懨懞擯擩擣擫擤擨斁斀斶旚曒檍檖檁檥檉檟檛檡檞檇檓檎"
		],
		[
			"ed40",
			"檕檃檨檤檑橿檦檚檅檌檒歛殭氉濌澩濴濔濣濜濭濧濦濞濲濝濢濨燡燱燨燲燤燰燢獳獮獯璗璲璫璐璪璭璱璥璯甐甑甒甏疄癃癈癉癇皤盩瞵瞫瞲瞷瞶"
		],
		[
			"eda1",
			"瞴瞱瞨矰磳磽礂磻磼磲礅磹磾礄禫禨穜穛穖穘穔穚窾竀竁簅簏篲簀篿篻簎篴簋篳簂簉簃簁篸篽簆篰篱簐簊糨縭縼繂縳顈縸縪繉繀繇縩繌縰縻縶繄縺罅罿罾罽翴翲耬膻臄臌臊臅臇膼臩艛艚艜薃薀薏薧薕薠薋薣蕻薤薚薞"
		],
		[
			"ee40",
			"蕷蕼薉薡蕺蕸蕗薎薖薆薍薙薝薁薢薂薈薅蕹蕶薘薐薟虨螾螪螭蟅螰螬螹螵螼螮蟉蟃蟂蟌螷螯蟄蟊螴螶螿螸螽蟞螲褵褳褼褾襁襒褷襂覭覯覮觲觳謞"
		],
		[
			"eea1",
			"謘謖謑謅謋謢謏謒謕謇謍謈謆謜謓謚豏豰豲豱豯貕貔賹赯蹎蹍蹓蹐蹌蹇轃轀邅遾鄸醚醢醛醙醟醡醝醠鎡鎃鎯鍤鍖鍇鍼鍘鍜鍶鍉鍐鍑鍠鍭鎏鍌鍪鍹鍗鍕鍒鍏鍱鍷鍻鍡鍞鍣鍧鎀鍎鍙闇闀闉闃闅閷隮隰隬霠霟霘霝霙鞚鞡鞜"
		],
		[
			"ef40",
			"鞞鞝韕韔韱顁顄顊顉顅顃餥餫餬餪餳餲餯餭餱餰馘馣馡騂駺駴駷駹駸駶駻駽駾駼騃骾髾髽鬁髼魈鮚鮨鮞鮛鮦鮡鮥鮤鮆鮢鮠鮯鴳鵁鵧鴶鴮鴯鴱鴸鴰"
		],
		[
			"efa1",
			"鵅鵂鵃鴾鴷鵀鴽翵鴭麊麉麍麰黈黚黻黿鼤鼣鼢齔龠儱儭儮嚘嚜嚗嚚嚝嚙奰嬼屩屪巀幭幮懘懟懭懮懱懪懰懫懖懩擿攄擽擸攁攃擼斔旛曚曛曘櫅檹檽櫡櫆檺檶檷櫇檴檭歞毉氋瀇瀌瀍瀁瀅瀔瀎濿瀀濻瀦濼濷瀊爁燿燹爃燽獶"
		],
		[
			"f040",
			"璸瓀璵瓁璾璶璻瓂甔甓癜癤癙癐癓癗癚皦皽盬矂瞺磿礌礓礔礉礐礒礑禭禬穟簜簩簙簠簟簭簝簦簨簢簥簰繜繐繖繣繘繢繟繑繠繗繓羵羳翷翸聵臑臒"
		],
		[
			"f0a1",
			"臐艟艞薴藆藀藃藂薳薵薽藇藄薿藋藎藈藅薱薶藒蘤薸薷薾虩蟧蟦蟢蟛蟫蟪蟥蟟蟳蟤蟔蟜蟓蟭蟘蟣螤蟗蟙蠁蟴蟨蟝襓襋襏襌襆襐襑襉謪謧謣謳謰謵譇謯謼謾謱謥謷謦謶謮謤謻謽謺豂豵貙貘貗賾贄贂贀蹜蹢蹠蹗蹖蹞蹥蹧"
		],
		[
			"f140",
			"蹛蹚蹡蹝蹩蹔轆轇轈轋鄨鄺鄻鄾醨醥醧醯醪鎵鎌鎒鎷鎛鎝鎉鎧鎎鎪鎞鎦鎕鎈鎙鎟鎍鎱鎑鎲鎤鎨鎴鎣鎥闒闓闑隳雗雚巂雟雘雝霣霢霥鞬鞮鞨鞫鞤鞪"
		],
		[
			"f1a1",
			"鞢鞥韗韙韖韘韺顐顑顒颸饁餼餺騏騋騉騍騄騑騊騅騇騆髀髜鬈鬄鬅鬩鬵魊魌魋鯇鯆鯃鮿鯁鮵鮸鯓鮶鯄鮹鮽鵜鵓鵏鵊鵛鵋鵙鵖鵌鵗鵒鵔鵟鵘鵚麎麌黟鼁鼀鼖鼥鼫鼪鼩鼨齌齕儴儵劖勷厴嚫嚭嚦嚧嚪嚬壚壝壛夒嬽嬾嬿巃幰"
		],
		[
			"f240",
			"徿懻攇攐攍攉攌攎斄旞旝曞櫧櫠櫌櫑櫙櫋櫟櫜櫐櫫櫏櫍櫞歠殰氌瀙瀧瀠瀖瀫瀡瀢瀣瀩瀗瀤瀜瀪爌爊爇爂爅犥犦犤犣犡瓋瓅璷瓃甖癠矉矊矄矱礝礛"
		],
		[
			"f2a1",
			"礡礜礗礞禰穧穨簳簼簹簬簻糬糪繶繵繸繰繷繯繺繲繴繨罋罊羃羆羷翽翾聸臗臕艤艡艣藫藱藭藙藡藨藚藗藬藲藸藘藟藣藜藑藰藦藯藞藢蠀蟺蠃蟶蟷蠉蠌蠋蠆蟼蠈蟿蠊蠂襢襚襛襗襡襜襘襝襙覈覷覶觶譐譈譊譀譓譖譔譋譕"
		],
		[
			"f340",
			"譑譂譒譗豃豷豶貚贆贇贉趬趪趭趫蹭蹸蹳蹪蹯蹻軂轒轑轏轐轓辴酀鄿醰醭鏞鏇鏏鏂鏚鏐鏹鏬鏌鏙鎩鏦鏊鏔鏮鏣鏕鏄鏎鏀鏒鏧镽闚闛雡霩霫霬霨霦"
		],
		[
			"f3a1",
			"鞳鞷鞶韝韞韟顜顙顝顗颿颽颻颾饈饇饃馦馧騚騕騥騝騤騛騢騠騧騣騞騜騔髂鬋鬊鬎鬌鬷鯪鯫鯠鯞鯤鯦鯢鯰鯔鯗鯬鯜鯙鯥鯕鯡鯚鵷鶁鶊鶄鶈鵱鶀鵸鶆鶋鶌鵽鵫鵴鵵鵰鵩鶅鵳鵻鶂鵯鵹鵿鶇鵨麔麑黀黼鼭齀齁齍齖齗齘匷嚲"
		],
		[
			"f440",
			"嚵嚳壣孅巆巇廮廯忀忁懹攗攖攕攓旟曨曣曤櫳櫰櫪櫨櫹櫱櫮櫯瀼瀵瀯瀷瀴瀱灂瀸瀿瀺瀹灀瀻瀳灁爓爔犨獽獼璺皫皪皾盭矌矎矏矍矲礥礣礧礨礤礩"
		],
		[
			"f4a1",
			"禲穮穬穭竷籉籈籊籇籅糮繻繾纁纀羺翿聹臛臙舋艨艩蘢藿蘁藾蘛蘀藶蘄蘉蘅蘌藽蠙蠐蠑蠗蠓蠖襣襦覹觷譠譪譝譨譣譥譧譭趮躆躈躄轙轖轗轕轘轚邍酃酁醷醵醲醳鐋鐓鏻鐠鐏鐔鏾鐕鐐鐨鐙鐍鏵鐀鏷鐇鐎鐖鐒鏺鐉鏸鐊鏿"
		],
		[
			"f540",
			"鏼鐌鏶鐑鐆闞闠闟霮霯鞹鞻韽韾顠顢顣顟飁飂饐饎饙饌饋饓騲騴騱騬騪騶騩騮騸騭髇髊髆鬐鬒鬑鰋鰈鯷鰅鰒鯸鱀鰇鰎鰆鰗鰔鰉鶟鶙鶤鶝鶒鶘鶐鶛"
		],
		[
			"f5a1",
			"鶠鶔鶜鶪鶗鶡鶚鶢鶨鶞鶣鶿鶩鶖鶦鶧麙麛麚黥黤黧黦鼰鼮齛齠齞齝齙龑儺儹劘劗囃嚽嚾孈孇巋巏廱懽攛欂櫼欃櫸欀灃灄灊灈灉灅灆爝爚爙獾甗癪矐礭礱礯籔籓糲纊纇纈纋纆纍罍羻耰臝蘘蘪蘦蘟蘣蘜蘙蘧蘮蘡蘠蘩蘞蘥"
		],
		[
			"f640",
			"蠩蠝蠛蠠蠤蠜蠫衊襭襩襮襫觺譹譸譅譺譻贐贔趯躎躌轞轛轝酆酄酅醹鐿鐻鐶鐩鐽鐼鐰鐹鐪鐷鐬鑀鐱闥闤闣霵霺鞿韡顤飉飆飀饘饖騹騽驆驄驂驁騺"
		],
		[
			"f6a1",
			"騿髍鬕鬗鬘鬖鬺魒鰫鰝鰜鰬鰣鰨鰩鰤鰡鶷鶶鶼鷁鷇鷊鷏鶾鷅鷃鶻鶵鷎鶹鶺鶬鷈鶱鶭鷌鶳鷍鶲鹺麜黫黮黭鼛鼘鼚鼱齎齥齤龒亹囆囅囋奱孋孌巕巑廲攡攠攦攢欋欈欉氍灕灖灗灒爞爟犩獿瓘瓕瓙瓗癭皭礵禴穰穱籗籜籙籛籚"
		],
		[
			"f740",
			"糴糱纑罏羇臞艫蘴蘵蘳蘬蘲蘶蠬蠨蠦蠪蠥襱覿覾觻譾讄讂讆讅譿贕躕躔躚躒躐躖躗轠轢酇鑌鑐鑊鑋鑏鑇鑅鑈鑉鑆霿韣顪顩飋饔饛驎驓驔驌驏驈驊"
		],
		[
			"f7a1",
			"驉驒驐髐鬙鬫鬻魖魕鱆鱈鰿鱄鰹鰳鱁鰼鰷鰴鰲鰽鰶鷛鷒鷞鷚鷋鷐鷜鷑鷟鷩鷙鷘鷖鷵鷕鷝麶黰鼵鼳鼲齂齫龕龢儽劙壨壧奲孍巘蠯彏戁戃戄攩攥斖曫欑欒欏毊灛灚爢玂玁玃癰矔籧籦纕艬蘺虀蘹蘼蘱蘻蘾蠰蠲蠮蠳襶襴襳觾"
		],
		[
			"f840",
			"讌讎讋讈豅贙躘轤轣醼鑢鑕鑝鑗鑞韄韅頀驖驙鬞鬟鬠鱒鱘鱐鱊鱍鱋鱕鱙鱌鱎鷻鷷鷯鷣鷫鷸鷤鷶鷡鷮鷦鷲鷰鷢鷬鷴鷳鷨鷭黂黐黲黳鼆鼜鼸鼷鼶齃齏"
		],
		[
			"f8a1",
			"齱齰齮齯囓囍孎屭攭曭曮欓灟灡灝灠爣瓛瓥矕礸禷禶籪纗羉艭虃蠸蠷蠵衋讔讕躞躟躠躝醾醽釂鑫鑨鑩雥靆靃靇韇韥驞髕魙鱣鱧鱦鱢鱞鱠鸂鷾鸇鸃鸆鸅鸀鸁鸉鷿鷽鸄麠鼞齆齴齵齶囔攮斸欘欙欗欚灢爦犪矘矙礹籩籫糶纚"
		],
		[
			"f940",
			"纘纛纙臠臡虆虇虈襹襺襼襻觿讘讙躥躤躣鑮鑭鑯鑱鑳靉顲饟鱨鱮鱭鸋鸍鸐鸏鸒鸑麡黵鼉齇齸齻齺齹圞灦籯蠼趲躦釃鑴鑸鑶鑵驠鱴鱳鱱鱵鸔鸓黶鼊"
		],
		[
			"f9a1",
			"龤灨灥糷虪蠾蠽蠿讞貜躩軉靋顳顴飌饡馫驤驦驧鬤鸕鸗齈戇欞爧虌躨钂钀钁驩驨鬮鸙爩虋讟钃鱹麷癵驫鱺鸝灩灪麤齾齉龘碁銹裏墻恒粧嫺╔╦╗╠╬╣╚╩╝╒╤╕╞╪╡╘╧╛╓╥╖╟╫╢╙╨╜║═╭╮╰╯▓"
		]
	];

/***/ },
/* 37 */
/***/ function(module, exports) {

	module.exports = [
		[
			"8740",
			"䏰䰲䘃䖦䕸𧉧䵷䖳𧲱䳢𧳅㮕䜶䝄䱇䱀𤊿𣘗𧍒𦺋𧃒䱗𪍑䝏䗚䲅𧱬䴇䪤䚡𦬣爥𥩔𡩣𣸆𣽡晍囻"
		],
		[
			"8767",
			"綕夝𨮹㷴霴𧯯寛𡵞媤㘥𩺰嫑宷峼杮薓𩥅瑡璝㡵𡵓𣚞𦀡㻬"
		],
		[
			"87a1",
			"𥣞㫵竼龗𤅡𨤍𣇪𠪊𣉞䌊蒄龖鐯䤰蘓墖靊鈘秐稲晠権袝瑌篅枂稬剏遆㓦珄𥶹瓆鿇垳䤯呌䄱𣚎堘穲𧭥讏䚮𦺈䆁𥶙箮𢒼鿈𢓁𢓉𢓌鿉蔄𣖻䂴鿊䓡𪷿拁灮鿋"
		],
		[
			"8840",
			"㇀",
			4,
			"𠄌㇅𠃑𠃍㇆㇇𠃋𡿨㇈𠃊㇉㇊㇋㇌𠄎㇍㇎ĀÁǍÀĒÉĚÈŌÓǑÒ࿿Ê̄Ế࿿Ê̌ỀÊāáǎàɑēéěèīíǐìōóǒòūúǔùǖǘǚ"
		],
		[
			"88a1",
			"ǜü࿿ê̄ế࿿ê̌ềêɡ⏚⏛"
		],
		[
			"8940",
			"𪎩𡅅"
		],
		[
			"8943",
			"攊"
		],
		[
			"8946",
			"丽滝鵎釟"
		],
		[
			"894c",
			"𧜵撑会伨侨兖兴农凤务动医华发变团声处备夲头学实実岚庆总斉柾栄桥济炼电纤纬纺织经统缆缷艺苏药视设询车轧轮"
		],
		[
			"89a1",
			"琑糼緍楆竉刧"
		],
		[
			"89ab",
			"醌碸酞肼"
		],
		[
			"89b0",
			"贋胶𠧧"
		],
		[
			"89b5",
			"肟黇䳍鷉鸌䰾𩷶𧀎鸊𪄳㗁"
		],
		[
			"89c1",
			"溚舾甙"
		],
		[
			"89c5",
			"䤑马骏龙禇𨑬𡷊𠗐𢫦两亁亀亇亿仫伷㑌侽㹈倃傈㑽㒓㒥円夅凛凼刅争剹劐匧㗇厩㕑厰㕓参吣㕭㕲㚁咓咣咴咹哐哯唘唣唨㖘唿㖥㖿嗗㗅"
		],
		[
			"8a40",
			"𧶄唥"
		],
		[
			"8a43",
			"𠱂𠴕𥄫喐𢳆㧬𠍁蹆𤶸𩓥䁓𨂾睺𢰸㨴䟕𨅝𦧲𤷪擝𠵼𠾴𠳕𡃴撍蹾𠺖𠰋𠽤𢲩𨉖𤓓"
		],
		[
			"8a64",
			"𠵆𩩍𨃩䟴𤺧𢳂骲㩧𩗴㿭㔆𥋇𩟔𧣈𢵄鵮頕"
		],
		[
			"8a76",
			"䏙𦂥撴哣𢵌𢯊𡁷㧻𡁯"
		],
		[
			"8aa1",
			"𦛚𦜖𧦠擪𥁒𠱃蹨𢆡𨭌𠜱"
		],
		[
			"8aac",
			"䠋𠆩㿺塳𢶍"
		],
		[
			"8ab2",
			"𤗈𠓼𦂗𠽌𠶖啹䂻䎺"
		],
		[
			"8abb",
			"䪴𢩦𡂝膪飵𠶜捹㧾𢝵跀嚡摼㹃"
		],
		[
			"8ac9",
			"𪘁𠸉𢫏𢳉"
		],
		[
			"8ace",
			"𡃈𣧂㦒㨆𨊛㕸𥹉𢃇噒𠼱𢲲𩜠㒼氽𤸻"
		],
		[
			"8adf",
			"𧕴𢺋𢈈𪙛𨳍𠹺𠰴𦠜羓𡃏𢠃𢤹㗻𥇣𠺌𠾍𠺪㾓𠼰𠵇𡅏𠹌"
		],
		[
			"8af6",
			"𠺫𠮩𠵈𡃀𡄽㿹𢚖搲𠾭"
		],
		[
			"8b40",
			"𣏴𧘹𢯎𠵾𠵿𢱑𢱕㨘𠺘𡃇𠼮𪘲𦭐𨳒𨶙𨳊閪哌苄喹"
		],
		[
			"8b55",
			"𩻃鰦骶𧝞𢷮煀腭胬尜𦕲脴㞗卟𨂽醶𠻺𠸏𠹷𠻻㗝𤷫㘉𠳖嚯𢞵𡃉𠸐𠹸𡁸𡅈𨈇𡑕𠹹𤹐𢶤婔𡀝𡀞𡃵𡃶垜𠸑"
		],
		[
			"8ba1",
			"𧚔𨋍𠾵𠹻𥅾㜃𠾶𡆀𥋘𪊽𤧚𡠺𤅷𨉼墙剨㘚𥜽箲孨䠀䬬鼧䧧鰟鮍𥭴𣄽嗻㗲嚉丨夂𡯁屮靑𠂆乛亻㔾尣彑忄㣺扌攵歺氵氺灬爫丬犭𤣩罒礻糹罓𦉪㓁"
		],
		[
			"8bde",
			"𦍋耂肀𦘒𦥑卝衤见𧢲讠贝钅镸长门𨸏韦页风飞饣𩠐鱼鸟黄歯龜丷𠂇阝户钢"
		],
		[
			"8c40",
			"倻淾𩱳龦㷉袏𤅎灷峵䬠𥇍㕙𥴰愢𨨲辧釶熑朙玺𣊁𪄇㲋𡦀䬐磤琂冮𨜏䀉橣𪊺䈣蘏𠩯稪𩥇𨫪靕灍匤𢁾鏴盙𨧣龧矝亣俰傼丯众龨吴綋墒壐𡶶庒庙忂𢜒斋"
		],
		[
			"8ca1",
			"𣏹椙橃𣱣泿"
		],
		[
			"8ca7",
			"爀𤔅玌㻛𤨓嬕璹讃𥲤𥚕窓篬糃繬苸薗龩袐龪躹龫迏蕟駠鈡龬𨶹𡐿䁱䊢娚"
		],
		[
			"8cc9",
			"顨杫䉶圽"
		],
		[
			"8cce",
			"藖𤥻芿𧄍䲁𦵴嵻𦬕𦾾龭龮宖龯曧繛湗秊㶈䓃𣉖𢞖䎚䔶"
		],
		[
			"8ce6",
			"峕𣬚諹屸㴒𣕑嵸龲煗䕘𤃬𡸣䱷㥸㑊𠆤𦱁諌侴𠈹妿腬顖𩣺弻"
		],
		[
			"8d40",
			"𠮟"
		],
		[
			"8d42",
			"𢇁𨥭䄂䚻𩁹㼇龳𪆵䃸㟖䛷𦱆䅼𨚲𧏿䕭㣔𥒚䕡䔛䶉䱻䵶䗪㿈𤬏㙡䓞䒽䇭崾嵈嵖㷼㠏嶤嶹㠠㠸幂庽弥徃㤈㤔㤿㥍惗愽峥㦉憷憹懏㦸戬抐拥挘㧸嚱"
		],
		[
			"8da1",
			"㨃揢揻搇摚㩋擀崕嘡龟㪗斆㪽旿晓㫲暒㬢朖㭂枤栀㭘桊梄㭲㭱㭻椉楃牜楤榟榅㮼槖㯝橥橴橱檂㯬檙㯲檫檵櫔櫶殁毁毪汵沪㳋洂洆洦涁㳯涤涱渕渘温溆𨧀溻滢滚齿滨滩漤漴㵆𣽁澁澾㵪㵵熷岙㶊瀬㶑灐灔灯灿炉𠌥䏁㗱𠻘"
		],
		[
			"8e40",
			"𣻗垾𦻓焾𥟠㙎榢𨯩孴穉𥣡𩓙穥穽𥦬窻窰竂竃燑𦒍䇊竚竝竪䇯咲𥰁笋筕笩𥌎𥳾箢筯莜𥮴𦱿篐萡箒箸𥴠㶭𥱥蒒篺簆簵𥳁籄粃𤢂粦晽𤕸糉糇糦籴糳糵糎"
		],
		[
			"8ea1",
			"繧䔝𦹄絝𦻖璍綉綫焵綳緒𤁗𦀩緤㴓緵𡟹緥𨍭縝𦄡𦅚繮纒䌫鑬縧罀罁罇礶𦋐駡羗𦍑羣𡙡𠁨䕜𣝦䔃𨌺翺𦒉者耈耝耨耯𪂇𦳃耻耼聡𢜔䦉𦘦𣷣𦛨朥肧𨩈脇脚墰𢛶汿𦒘𤾸擧𡒊舘𡡞橓𤩥𤪕䑺舩𠬍𦩒𣵾俹𡓽蓢荢𦬊𤦧𣔰𡝳𣷸芪椛芳䇛"
		],
		[
			"8f40",
			"蕋苐茚𠸖𡞴㛁𣅽𣕚艻苢茘𣺋𦶣𦬅𦮗𣗎㶿茝嗬莅䔋𦶥莬菁菓㑾𦻔橗蕚㒖𦹂𢻯葘𥯤葱㷓䓤檧葊𣲵祘蒨𦮖𦹷𦹃蓞萏莑䒠蒓蓤𥲑䉀𥳀䕃蔴嫲𦺙䔧蕳䔖枿蘖"
		],
		[
			"8fa1",
			"𨘥𨘻藁𧂈蘂𡖂𧃍䕫䕪蘨㙈𡢢号𧎚虾蝱𪃸蟮𢰧螱蟚蠏噡虬桖䘏衅衆𧗠𣶹𧗤衞袜䙛袴袵揁装睷𧜏覇覊覦覩覧覼𨨥觧𧤤𧪽誜瞓釾誐𧩙竩𧬺𣾏䜓𧬸煼謌謟𥐰𥕥謿譌譍誩𤩺讐讛誯𡛟䘕衏貛𧵔𧶏貫㜥𧵓賖𧶘𧶽贒贃𡤐賛灜贑𤳉㻐起"
		],
		[
			"9040",
			"趩𨀂𡀔𤦊㭼𨆼𧄌竧躭躶軃鋔輙輭𨍥𨐒辥錃𪊟𠩐辳䤪𨧞𨔽𣶻廸𣉢迹𪀔𨚼𨔁𢌥㦀𦻗逷𨔼𧪾遡𨕬𨘋邨𨜓郄𨛦邮都酧㫰醩釄粬𨤳𡺉鈎沟鉁鉢𥖹銹𨫆𣲛𨬌𥗛"
		],
		[
			"90a1",
			"𠴱錬鍫𨫡𨯫炏嫃𨫢𨫥䥥鉄𨯬𨰹𨯿鍳鑛躼閅閦鐦閠濶䊹𢙺𨛘𡉼𣸮䧟氜陻隖䅬隣𦻕懚隶磵𨫠隽双䦡𦲸𠉴𦐐𩂯𩃥𤫑𡤕𣌊霱虂霶䨏䔽䖅𤫩灵孁霛靜𩇕靗孊𩇫靟鐥僐𣂷𣂼鞉鞟鞱鞾韀韒韠𥑬韮琜𩐳響韵𩐝𧥺䫑頴頳顋顦㬎𧅵㵑𠘰𤅜"
		],
		[
			"9140",
			"𥜆飊颷飈飇䫿𦴧𡛓喰飡飦飬鍸餹𤨩䭲𩡗𩤅駵騌騻騐驘𥜥㛄𩂱𩯕髠髢𩬅髴䰎鬔鬭𨘀倴鬴𦦨㣃𣁽魐魀𩴾婅𡡣鮎𤉋鰂鯿鰌𩹨鷔𩾷𪆒𪆫𪃡𪄣𪇟鵾鶃𪄴鸎梈"
		],
		[
			"91a1",
			"鷄𢅛𪆓𪈠𡤻𪈳鴹𪂹𪊴麐麕麞麢䴴麪麯𤍤黁㭠㧥㴝伲㞾𨰫鼂鼈䮖鐤𦶢鼗鼖鼹嚟嚊齅馸𩂋韲葿齢齩竜龎爖䮾𤥵𤦻煷𤧸𤍈𤩑玞𨯚𡣺禟𨥾𨸶鍩鏳𨩄鋬鎁鏋𨥬𤒹爗㻫睲穃烐𤑳𤏸煾𡟯炣𡢾𣖙㻇𡢅𥐯𡟸㜢𡛻𡠹㛡𡝴𡣑𥽋㜣𡛀坛𤨥𡏾𡊨"
		],
		[
			"9240",
			"𡏆𡒶蔃𣚦蔃葕𤦔𧅥𣸱𥕜𣻻𧁒䓴𣛮𩦝𦼦柹㜳㰕㷧塬𡤢栐䁗𣜿𤃡𤂋𤄏𦰡哋嚞𦚱嚒𠿟𠮨𠸍鏆𨬓鎜仸儫㠙𤐶亼𠑥𠍿佋侊𥙑婨𠆫𠏋㦙𠌊𠐔㐵伩𠋀𨺳𠉵諚𠈌亘"
		],
		[
			"92a1",
			"働儍侢伃𤨎𣺊佂倮偬傁俌俥偘僼兙兛兝兞湶𣖕𣸹𣺿浲𡢄𣺉冨凃𠗠䓝𠒣𠒒𠒑赺𨪜𠜎剙劤𠡳勡鍮䙺熌𤎌𠰠𤦬𡃤槑𠸝瑹㻞璙琔瑖玘䮎𤪼𤂍叐㖄爏𤃉喴𠍅响𠯆圝鉝雴鍦埝垍坿㘾壋媙𨩆𡛺𡝯𡜐娬妸銏婾嫏娒𥥆𡧳𡡡𤊕㛵洅瑃娡𥺃"
		],
		[
			"9340",
			"媁𨯗𠐓鏠璌𡌃焅䥲鐈𨧻鎽㞠尞岞幞幈𡦖𡥼𣫮廍孏𡤃𡤄㜁𡢠㛝𡛾㛓脪𨩇𡶺𣑲𨦨弌弎𡤧𡞫婫𡜻孄蘔𧗽衠恾𢡠𢘫忛㺸𢖯𢖾𩂈𦽳懀𠀾𠁆𢘛憙憘恵𢲛𢴇𤛔𩅍"
		],
		[
			"93a1",
			"摱𤙥𢭪㨩𢬢𣑐𩣪𢹸挷𪑛撶挱揑𤧣𢵧护𢲡搻敫楲㯴𣂎𣊭𤦉𣊫唍𣋠𡣙𩐿曎𣊉𣆳㫠䆐𥖄𨬢𥖏𡛼𥕛𥐥磮𣄃𡠪𣈴㑤𣈏𣆂𤋉暎𦴤晫䮓昰𧡰𡷫晣𣋒𣋡昞𥡲㣑𣠺𣞼㮙𣞢𣏾瓐㮖枏𤘪梶栞㯄檾㡣𣟕𤒇樳橒櫉欅𡤒攑梘橌㯗橺歗𣿀𣲚鎠鋲𨯪𨫋"
		],
		[
			"9440",
			"銉𨀞𨧜鑧涥漋𤧬浧𣽿㶏渄𤀼娽渊塇洤硂焻𤌚𤉶烱牐犇犔𤞏𤜥兹𤪤𠗫瑺𣻸𣙟𤩊𤤗𥿡㼆㺱𤫟𨰣𣼵悧㻳瓌琼鎇琷䒟𦷪䕑疃㽣𤳙𤴆㽘畕癳𪗆㬙瑨𨫌𤦫𤦎㫻"
		],
		[
			"94a1",
			"㷍𤩎㻿𤧅𤣳釺圲鍂𨫣𡡤僟𥈡𥇧睸𣈲眎眏睻𤚗𣞁㩞𤣰琸璛㺿𤪺𤫇䃈𤪖𦆮錇𥖁砞碍碈磒珐祙𧝁𥛣䄎禛蒖禥樭𣻺稺秴䅮𡛦䄲鈵秱𠵌𤦌𠊙𣶺𡝮㖗啫㕰㚪𠇔𠰍竢婙𢛵𥪯𥪜娍𠉛磰娪𥯆竾䇹籝籭䈑𥮳𥺼𥺦糍𤧹𡞰粎籼粮檲緜縇緓罎𦉡"
		],
		[
			"9540",
			"𦅜𧭈綗𥺂䉪𦭵𠤖柖𠁎𣗏埄𦐒𦏸𤥢翝笧𠠬𥫩𥵃笌𥸎駦虅驣樜𣐿㧢𤧷𦖭騟𦖠蒀𧄧𦳑䓪脷䐂胆脉腂𦞴飃𦩂艢艥𦩑葓𦶧蘐𧈛媆䅿𡡀嬫𡢡嫤𡣘蚠蜨𣶏蠭𧐢娂"
		],
		[
			"95a1",
			"衮佅袇袿裦襥襍𥚃襔𧞅𧞄𨯵𨯙𨮜𨧹㺭蒣䛵䛏㟲訽訜𩑈彍鈫𤊄旔焩烄𡡅鵭貟賩𧷜妚矃姰䍮㛔踪躧𤰉輰轊䋴汘澻𢌡䢛潹溋𡟚鯩㚵𤤯邻邗啱䤆醻鐄𨩋䁢𨫼鐧𨰝𨰻蓥訫閙閧閗閖𨴴瑅㻂𤣿𤩂𤏪㻧𣈥随𨻧𨹦𨹥㻌𤧭𤩸𣿮琒瑫㻼靁𩂰"
		],
		[
			"9640",
			"桇䨝𩂓𥟟靝鍨𨦉𨰦𨬯𦎾銺嬑譩䤼珹𤈛鞛靱餸𠼦巁𨯅𤪲頟𩓚鋶𩗗釥䓀𨭐𤩧𨭤飜𨩅㼀鈪䤥萔餻饍𧬆㷽馛䭯馪驜𨭥𥣈檏騡嫾騯𩣱䮐𩥈馼䮽䮗鍽塲𡌂堢𤦸"
		],
		[
			"96a1",
			"𡓨硄𢜟𣶸棅㵽鑘㤧慐𢞁𢥫愇鱏鱓鱻鰵鰐魿鯏𩸭鮟𪇵𪃾鴡䲮𤄄鸘䲰鴌𪆴𪃭𪃳𩤯鶥蒽𦸒𦿟𦮂藼䔳𦶤𦺄𦷰萠藮𦸀𣟗𦁤秢𣖜𣙀䤭𤧞㵢鏛銾鍈𠊿碹鉷鑍俤㑀遤𥕝砽硔碶硋𡝗𣇉𤥁㚚佲濚濙瀞瀞吔𤆵垻壳垊鴖埗焴㒯𤆬燫𦱀𤾗嬨𡞵𨩉"
		],
		[
			"9740",
			"愌嫎娋䊼𤒈㜬䭻𨧼鎻鎸𡣖𠼝葲𦳀𡐓𤋺𢰦𤏁妔𣶷𦝁綨𦅛𦂤𤦹𤦋𨧺鋥珢㻩璴𨭣𡢟㻡𤪳櫘珳珻㻖𤨾𤪔𡟙𤩦𠎧𡐤𤧥瑈𤤖炥𤥶銄珦鍟𠓾錱𨫎𨨖鎆𨯧𥗕䤵𨪂煫"
		],
		[
			"97a1",
			"𤥃𠳿嚤𠘚𠯫𠲸唂秄𡟺緾𡛂𤩐𡡒䔮鐁㜊𨫀𤦭妰𡢿𡢃𧒄媡㛢𣵛㚰鉟婹𨪁𡡢鍴㳍𠪴䪖㦊僴㵩㵌𡎜煵䋻𨈘渏𩃤䓫浗𧹏灧沯㳖𣿭𣸭渂漌㵯𠏵畑㚼㓈䚀㻚䡱姄鉮䤾轁𨰜𦯀堒埈㛖𡑒烾𤍢𤩱𢿣𡊰𢎽梹楧𡎘𣓥𧯴𣛟𨪃𣟖𣏺𤲟樚𣚭𦲷萾䓟䓎"
		],
		[
			"9840",
			"𦴦𦵑𦲂𦿞漗𧄉茽𡜺菭𦲀𧁓𡟛妉媂𡞳婡婱𡤅𤇼㜭姯𡜼㛇熎鎐暚𤊥婮娫𤊓樫𣻹𧜶𤑛𤋊焝𤉙𨧡侰𦴨峂𤓎𧹍𤎽樌𤉖𡌄炦焳𤏩㶥泟勇𤩏繥姫崯㷳彜𤩝𡟟綤萦"
		],
		[
			"98a1",
			"咅𣫺𣌀𠈔坾𠣕𠘙㿥𡾞𪊶瀃𩅛嵰玏糓𨩙𩐠俈翧狍猐𧫴猸猹𥛶獁獈㺩𧬘遬燵𤣲珡臶㻊県㻑沢国琙琞琟㻢㻰㻴㻺瓓㼎㽓畂畭畲疍㽼痈痜㿀癍㿗癴㿜発𤽜熈嘣覀塩䀝睃䀹条䁅㗛瞘䁪䁯属瞾矋売砘点砜䂨砹硇硑硦葈𥔵礳栃礲䄃"
		],
		[
			"9940",
			"䄉禑禙辻稆込䅧窑䆲窼艹䇄竏竛䇏両筢筬筻簒簛䉠䉺类粜䊌粸䊔糭输烀𠳏総緔緐緽羮羴犟䎗耠耥笹耮耱联㷌垴炠肷胩䏭脌猪脎脒畠脔䐁㬹腖腙腚"
		],
		[
			"99a1",
			"䐓堺腼膄䐥膓䐭膥埯臁臤艔䒏芦艶苊苘苿䒰荗险榊萅烵葤惣蒈䔄蒾蓡蓸蔐蔸蕒䔻蕯蕰藠䕷虲蚒蚲蛯际螋䘆䘗袮裿褤襇覑𧥧訩訸誔誴豑賔賲贜䞘塟跃䟭仮踺嗘坔蹱嗵躰䠷軎転軤軭軲辷迁迊迌逳駄䢭飠鈓䤞鈨鉘鉫銱銮銿"
		],
		[
			"9a40",
			"鋣鋫鋳鋴鋽鍃鎄鎭䥅䥑麿鐗匁鐝鐭鐾䥪鑔鑹锭関䦧间阳䧥枠䨤靀䨵鞲韂噔䫤惨颹䬙飱塄餎餙冴餜餷饂饝饢䭰駅䮝騼鬏窃魩鮁鯝鯱鯴䱭鰠㝯𡯂鵉鰺"
		],
		[
			"9aa1",
			"黾噐鶓鶽鷀鷼银辶鹻麬麱麽黆铜黢黱黸竈齄𠂔𠊷𠎠椚铃妬𠓗塀铁㞹𠗕𠘕𠙶𡚺块煳𠫂𠫍𠮿呪吆𠯋咞𠯻𠰻𠱓𠱥𠱼惧𠲍噺𠲵𠳝𠳭𠵯𠶲𠷈楕鰯螥𠸄𠸎𠻗𠾐𠼭𠹳尠𠾼帋𡁜𡁏𡁶朞𡁻𡂈𡂖㙇𡂿𡃓𡄯𡄻卤蒭𡋣𡍵𡌶讁𡕷𡘙𡟃𡟇乸炻𡠭𡥪"
		],
		[
			"9b40",
			"𡨭𡩅𡰪𡱰𡲬𡻈拃𡻕𡼕熘桕𢁅槩㛈𢉼𢏗𢏺𢜪𢡱𢥏苽𢥧𢦓𢫕覥𢫨辠𢬎鞸𢬿顇骽𢱌"
		],
		[
			"9b62",
			"𢲈𢲷𥯨𢴈𢴒𢶷𢶕𢹂𢽴𢿌𣀳𣁦𣌟𣏞徱晈暿𧩹𣕧𣗳爁𤦺矗𣘚𣜖纇𠍆墵朎"
		],
		[
			"9ba1",
			"椘𣪧𧙗𥿢𣸑𣺹𧗾𢂚䣐䪸𤄙𨪚𤋮𤌍𤀻𤌴𤎖𤩅𠗊凒𠘑妟𡺨㮾𣳿𤐄𤓖垈𤙴㦛𤜯𨗨𩧉㝢𢇃譞𨭎駖𤠒𤣻𤨕爉𤫀𠱸奥𤺥𤾆𠝹軚𥀬劏圿煱𥊙𥐙𣽊𤪧喼𥑆𥑮𦭒釔㑳𥔿𧘲𥕞䜘𥕢𥕦𥟇𤤿𥡝偦㓻𣏌惞𥤃䝼𨥈𥪮𥮉𥰆𡶐垡煑澶𦄂𧰒遖𦆲𤾚譢𦐂𦑊"
		],
		[
			"9c40",
			"嵛𦯷輶𦒄𡤜諪𤧶𦒈𣿯𦔒䯀𦖿𦚵𢜛鑥𥟡憕娧晉侻嚹𤔡𦛼乪𤤴陖涏𦲽㘘襷𦞙𦡮𦐑𦡞營𦣇筂𩃀𠨑𦤦鄄𦤹穅鷰𦧺騦𦨭㙟𦑩𠀡禃𦨴𦭛崬𣔙菏𦮝䛐𦲤画补𦶮墶"
		],
		[
			"9ca1",
			"㜜𢖍𧁋𧇍㱔𧊀𧊅銁𢅺𧊋錰𧋦𤧐氹钟𧑐𠻸蠧裵𢤦𨑳𡞱溸𤨪𡠠㦤㚹尐秣䔿暶𩲭𩢤襃𧟌𧡘囖䃟𡘊㦡𣜯𨃨𡏅熭荦𧧝𩆨婧䲷𧂯𨦫𧧽𧨊𧬋𧵦𤅺筃祾𨀉澵𪋟樃𨌘厢𦸇鎿栶靝𨅯𨀣𦦵𡏭𣈯𨁈嶅𨰰𨂃圕頣𨥉嶫𤦈斾槕叒𤪥𣾁㰑朶𨂐𨃴𨄮𡾡𨅏"
		],
		[
			"9d40",
			"𨆉𨆯𨈚𨌆𨌯𨎊㗊𨑨𨚪䣺揦𨥖砈鉕𨦸䏲𨧧䏟𨧨𨭆𨯔姸𨰉輋𨿅𩃬筑𩄐𩄼㷷𩅞𤫊运犏嚋𩓧𩗩𩖰𩖸𩜲𩣑𩥉𩥪𩧃𩨨𩬎𩵚𩶛纟𩻸𩼣䲤镇𪊓熢𪋿䶑递𪗋䶜𠲜达嗁"
		],
		[
			"9da1",
			"辺𢒰边𤪓䔉繿潖檱仪㓤𨬬𧢝㜺躀𡟵𨀤𨭬𨮙𧨾𦚯㷫𧙕𣲷𥘵𥥖亚𥺁𦉘嚿𠹭踎孭𣺈𤲞揞拐𡟶𡡻攰嘭𥱊吚𥌑㷆𩶘䱽嘢嘞罉𥻘奵𣵀蝰东𠿪𠵉𣚺脗鵞贘瘻鱅癎瞹鍅吲腈苷嘥脲萘肽嗪祢噃吖𠺝㗎嘅嗱曱𨋢㘭甴嗰喺咗啲𠱁𠲖廐𥅈𠹶𢱢"
		],
		[
			"9e40",
			"𠺢麫絚嗞𡁵抝靭咔賍燶酶揼掹揾啩𢭃鱲𢺳冚㓟𠶧冧呍唞唓癦踭𦢊疱肶蠄螆裇膶萜𡃁䓬猄𤜆宐茋𦢓噻𢛴𧴯𤆣𧵳𦻐𧊶酰𡇙鈈𣳼𪚩𠺬𠻹牦𡲢䝎𤿂𧿹𠿫䃺"
		],
		[
			"9ea1",
			"鱝攟𢶠䣳𤟠𩵼𠿬𠸊恢𧖣𠿭"
		],
		[
			"9ead",
			"𦁈𡆇熣纎鵐业丄㕷嬍沲卧㚬㧜卽㚥𤘘墚𤭮舭呋垪𥪕𠥹"
		],
		[
			"9ec5",
			"㩒𢑥獴𩺬䴉鯭𣳾𩼰䱛𤾩𩖞𩿞葜𣶶𧊲𦞳𣜠挮紥𣻷𣸬㨪逈勌㹴㙺䗩𠒎癀嫰𠺶硺𧼮墧䂿噼鮋嵴癔𪐴麅䳡痹㟻愙𣃚𤏲"
		],
		[
			"9ef5",
			"噝𡊩垧𤥣𩸆刴𧂮㖭汊鵼"
		],
		[
			"9f40",
			"籖鬹埞𡝬屓擓𩓐𦌵𧅤蚭𠴨𦴢𤫢𠵱"
		],
		[
			"9f4f",
			"凾𡼏嶎霃𡷑麁遌笟鬂峑箣扨挵髿篏鬪籾鬮籂粆鰕篼鬉鼗鰛𤤾齚啳寃俽麘俲剠㸆勑坧偖妷帒韈鶫轜呩鞴饀鞺匬愰"
		],
		[
			"9fa1",
			"椬叚鰊鴂䰻陁榀傦畆𡝭駚剳"
		],
		[
			"9fae",
			"酙隁酜"
		],
		[
			"9fb2",
			"酑𨺗捿𦴣櫊嘑醎畺抅𠏼獏籰𥰡𣳽"
		],
		[
			"9fc1",
			"𤤙盖鮝个𠳔莾衂"
		],
		[
			"9fc9",
			"届槀僭坺刟巵从氱𠇲伹咜哚劚趂㗾弌㗳"
		],
		[
			"9fdb",
			"歒酼龥鮗頮颴骺麨麄煺笔"
		],
		[
			"9fe7",
			"毺蠘罸"
		],
		[
			"9feb",
			"嘠𪙊蹷齓"
		],
		[
			"9ff0",
			"跔蹏鸜踁抂𨍽踨蹵竓𤩷稾磘泪詧瘇"
		],
		[
			"a040",
			"𨩚鼦泎蟖痃𪊲硓咢贌狢獱謭猂瓱賫𤪻蘯徺袠䒷"
		],
		[
			"a055",
			"𡠻𦸅"
		],
		[
			"a058",
			"詾𢔛"
		],
		[
			"a05b",
			"惽癧髗鵄鍮鮏蟵"
		],
		[
			"a063",
			"蠏賷猬霡鮰㗖犲䰇籑饊𦅙慙䰄麖慽"
		],
		[
			"a073",
			"坟慯抦戹拎㩜懢厪𣏵捤栂㗒"
		],
		[
			"a0a1",
			"嵗𨯂迚𨸹"
		],
		[
			"a0a6",
			"僙𡵆礆匲阸𠼻䁥"
		],
		[
			"a0ae",
			"矾"
		],
		[
			"a0b0",
			"糂𥼚糚稭聦聣絍甅瓲覔舚朌聢𧒆聛瓰脃眤覉𦟌畓𦻑螩蟎臈螌詉貭譃眫瓸蓚㘵榲趦"
		],
		[
			"a0d4",
			"覩瑨涹蟁𤀑瓧㷛煶悤憜㳑煢恷"
		],
		[
			"a0e2",
			"罱𨬭牐惩䭾删㰘𣳇𥻗𧙖𥔱𡥄𡋾𩤃𦷜𧂭峁𦆭𨨏𣙷𠃮𦡆𤼎䕢嬟𦍌齐麦𦉫"
		],
		[
			"a3c0",
			"␀",
			31,
			"␡"
		],
		[
			"c6a1",
			"①",
			9,
			"⑴",
			9,
			"ⅰ",
			9,
			"丶丿亅亠冂冖冫勹匸卩厶夊宀巛⼳广廴彐彡攴无疒癶辵隶¨ˆヽヾゝゞ〃仝々〆〇ー［］✽ぁ",
			23
		],
		[
			"c740",
			"す",
			58,
			"ァアィイ"
		],
		[
			"c7a1",
			"ゥ",
			81,
			"А",
			5,
			"ЁЖ",
			4
		],
		[
			"c840",
			"Л",
			26,
			"ёж",
			25,
			"⇧↸↹㇏𠃌乚𠂊刂䒑"
		],
		[
			"c8a1",
			"龰冈龱𧘇"
		],
		[
			"c8cd",
			"￢￤＇＂㈱№℡゛゜⺀⺄⺆⺇⺈⺊⺌⺍⺕⺜⺝⺥⺧⺪⺬⺮⺶⺼⺾⻆⻊⻌⻍⻏⻖⻗⻞⻣"
		],
		[
			"c8f5",
			"ʃɐɛɔɵœøŋʊɪ"
		],
		[
			"f9fe",
			"￭"
		],
		[
			"fa40",
			"𠕇鋛𠗟𣿅蕌䊵珯况㙉𤥂𨧤鍄𡧛苮𣳈砼杄拟𤤳𨦪𠊠𦮳𡌅侫𢓭倈𦴩𧪄𣘀𤪱𢔓倩𠍾徤𠎀𠍇滛𠐟偽儁㑺儎顬㝃萖𤦤𠒇兠𣎴兪𠯿𢃼𠋥𢔰𠖎𣈳𡦃宂蝽𠖳𣲙冲冸"
		],
		[
			"faa1",
			"鴴凉减凑㳜凓𤪦决凢卂凭菍椾𣜭彻刋刦刼劵剗劔効勅簕蕂勠蘍𦬓包𨫞啉滙𣾀𠥔𣿬匳卄𠯢泋𡜦栛珕恊㺪㣌𡛨燝䒢卭却𨚫卾卿𡖖𡘓矦厓𨪛厠厫厮玧𥝲㽙玜叁叅汉义埾叙㪫𠮏叠𣿫𢶣叶𠱷吓灹唫晗浛呭𦭓𠵴啝咏咤䞦𡜍𠻝㶴𠵍"
		],
		[
			"fb40",
			"𨦼𢚘啇䳭启琗喆喩嘅𡣗𤀺䕒𤐵暳𡂴嘷曍𣊊暤暭噍噏磱囱鞇叾圀囯园𨭦㘣𡉏坆𤆥汮炋坂㚱𦱾埦𡐖堃𡑔𤍣堦𤯵塜墪㕡壠壜𡈼壻寿坃𪅐𤉸鏓㖡够梦㛃湙"
		],
		[
			"fba1",
			"𡘾娤啓𡚒蔅姉𠵎𦲁𦴪𡟜姙𡟻𡞲𦶦浱𡠨𡛕姹𦹅媫婣㛦𤦩婷㜈媖瑥嫓𦾡𢕔㶅𡤑㜲𡚸広勐孶斈孼𧨎䀄䡝𠈄寕慠𡨴𥧌𠖥寳宝䴐尅𡭄尓珎尔𡲥𦬨屉䣝岅峩峯嶋𡷹𡸷崐崘嵆𡺤岺巗苼㠭𤤁𢁉𢅳芇㠶㯂帮檊幵幺𤒼𠳓厦亷廐厨𡝱帉廴𨒂"
		],
		[
			"fc40",
			"廹廻㢠廼栾鐛弍𠇁弢㫞䢮𡌺强𦢈𢏐彘𢑱彣鞽𦹮彲鍀𨨶徧嶶㵟𥉐𡽪𧃸𢙨釖𠊞𨨩怱暅𡡷㥣㷇㘹垐𢞴祱㹀悞悤悳𤦂𤦏𧩓璤僡媠慤萤慂慈𦻒憁凴𠙖憇宪𣾷"
		],
		[
			"fca1",
			"𢡟懓𨮝𩥝懐㤲𢦀𢣁怣慜攞掋𠄘担𡝰拕𢸍捬𤧟㨗搸揸𡎎𡟼撐澊𢸶頔𤂌𥜝擡擥鑻㩦携㩗敍漖𤨨𤨣斅敭敟𣁾斵𤥀䬷旑䃘𡠩无旣忟𣐀昘𣇷𣇸晄𣆤𣆥晋𠹵晧𥇦晳晴𡸽𣈱𨗴𣇈𥌓矅𢣷馤朂𤎜𤨡㬫槺𣟂杞杧杢𤇍𩃭柗䓩栢湐鈼栁𣏦𦶠桝"
		],
		[
			"fd40",
			"𣑯槡樋𨫟楳棃𣗍椁椀㴲㨁𣘼㮀枬楡𨩊䋼椶榘㮡𠏉荣傐槹𣙙𢄪橅𣜃檝㯳枱櫈𩆜㰍欝𠤣惞欵歴𢟍溵𣫛𠎵𡥘㝀吡𣭚毡𣻼毜氷𢒋𤣱𦭑汚舦汹𣶼䓅𣶽𤆤𤤌𤤀"
		],
		[
			"fda1",
			"𣳉㛥㳫𠴲鮃𣇹𢒑羏样𦴥𦶡𦷫涖浜湼漄𤥿𤂅𦹲蔳𦽴凇沜渝萮𨬡港𣸯瑓𣾂秌湏媑𣁋濸㜍澝𣸰滺𡒗𤀽䕕鏰潄潜㵎潴𩅰㴻澟𤅄濓𤂑𤅕𤀹𣿰𣾴𤄿凟𤅖𤅗𤅀𦇝灋灾炧炁烌烕烖烟䄄㷨熴熖𤉷焫煅媈煊煮岜𤍥煏鍢𤋁焬𤑚𤨧𤨢熺𨯨炽爎"
		],
		[
			"fe40",
			"鑂爕夑鑃爤鍁𥘅爮牀𤥴梽牕牗㹕𣁄栍漽犂猪猫𤠣𨠫䣭𨠄猨献珏玪𠰺𦨮珉瑉𤇢𡛧𤨤昣㛅𤦷𤦍𤧻珷琕椃𤨦琹𠗃㻗瑜𢢭瑠𨺲瑇珤瑶莹瑬㜰瑴鏱樬璂䥓𤪌"
		],
		[
			"fea1",
			"𤅟𤩹𨮏孆𨰃𡢞瓈𡦈甎瓩甞𨻙𡩋寗𨺬鎅畍畊畧畮𤾂㼄𤴓疎瑝疞疴瘂瘬癑癏癯癶𦏵皐臯㟸𦤑𦤎皡皥皷盌𦾟葢𥂝𥅽𡸜眞眦着撯𥈠睘𣊬瞯𨥤𨥨𡛁矴砉𡍶𤨒棊碯磇磓隥礮𥗠磗礴碱𧘌辸袄𨬫𦂃𢘜禆褀椂禀𥡗禝𧬹礼禩渪𧄦㺨秆𩄍秔"
		]
	];

/***/ },
/* 38 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {"use strict"
	
	var Transform = __webpack_require__(39).Transform;
	
	
	// == Exports ==================================================================
	module.exports = function(iconv) {
	    
	    // Additional Public API.
	    iconv.encodeStream = function encodeStream(encoding, options) {
	        return new IconvLiteEncoderStream(iconv.getEncoder(encoding, options), options);
	    }
	
	    iconv.decodeStream = function decodeStream(encoding, options) {
	        return new IconvLiteDecoderStream(iconv.getDecoder(encoding, options), options);
	    }
	
	    iconv.supportsStreams = true;
	
	
	    // Not published yet.
	    iconv.IconvLiteEncoderStream = IconvLiteEncoderStream;
	    iconv.IconvLiteDecoderStream = IconvLiteDecoderStream;
	    iconv._collect = IconvLiteDecoderStream.prototype.collect;
	};
	
	
	// == Encoder stream =======================================================
	function IconvLiteEncoderStream(conv, options) {
	    this.conv = conv;
	    options = options || {};
	    options.decodeStrings = false; // We accept only strings, so we don't need to decode them.
	    Transform.call(this, options);
	}
	
	IconvLiteEncoderStream.prototype = Object.create(Transform.prototype, {
	    constructor: { value: IconvLiteEncoderStream }
	});
	
	IconvLiteEncoderStream.prototype._transform = function(chunk, encoding, done) {
	    if (typeof chunk != 'string')
	        return done(new Error("Iconv encoding stream needs strings as its input."));
	    try {
	        var res = this.conv.write(chunk);
	        if (res && res.length) this.push(res);
	        done();
	    }
	    catch (e) {
	        done(e);
	    }
	}
	
	IconvLiteEncoderStream.prototype._flush = function(done) {
	    try {
	        var res = this.conv.end();
	        if (res && res.length) this.push(res);
	        done();
	    }
	    catch (e) {
	        done(e);
	    }
	}
	
	IconvLiteEncoderStream.prototype.collect = function(cb) {
	    var chunks = [];
	    this.on('error', cb);
	    this.on('data', function(chunk) { chunks.push(chunk); });
	    this.on('end', function() {
	        cb(null, Buffer.concat(chunks));
	    });
	    return this;
	}
	
	
	// == Decoder stream =======================================================
	function IconvLiteDecoderStream(conv, options) {
	    this.conv = conv;
	    options = options || {};
	    options.encoding = this.encoding = 'utf8'; // We output strings.
	    Transform.call(this, options);
	}
	
	IconvLiteDecoderStream.prototype = Object.create(Transform.prototype, {
	    constructor: { value: IconvLiteDecoderStream }
	});
	
	IconvLiteDecoderStream.prototype._transform = function(chunk, encoding, done) {
	    if (!Buffer.isBuffer(chunk))
	        return done(new Error("Iconv decoding stream needs buffers as its input."));
	    try {
	        var res = this.conv.write(chunk);
	        if (res && res.length) this.push(res, this.encoding);
	        done();
	    }
	    catch (e) {
	        done(e);
	    }
	}
	
	IconvLiteDecoderStream.prototype._flush = function(done) {
	    try {
	        var res = this.conv.end();
	        if (res && res.length) this.push(res, this.encoding);                
	        done();
	    }
	    catch (e) {
	        done(e);
	    }
	}
	
	IconvLiteDecoderStream.prototype.collect = function(cb) {
	    var res = '';
	    this.on('error', cb);
	    this.on('data', function(chunk) { res += chunk; });
	    this.on('end', function() {
	        cb(null, res);
	    });
	    return this;
	}
	
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(9).Buffer))

/***/ },
/* 39 */
/***/ function(module, exports, __webpack_require__) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	module.exports = Stream;
	
	var EE = __webpack_require__(40).EventEmitter;
	var inherits = __webpack_require__(41);
	
	inherits(Stream, EE);
	Stream.Readable = __webpack_require__(42);
	Stream.Writable = __webpack_require__(51);
	Stream.Duplex = __webpack_require__(52);
	Stream.Transform = __webpack_require__(53);
	Stream.PassThrough = __webpack_require__(54);
	
	// Backwards-compat with node 0.4.x
	Stream.Stream = Stream;
	
	
	
	// old-style streams.  Note that the pipe method (the only relevant
	// part of this class) is overridden in the Readable class.
	
	function Stream() {
	  EE.call(this);
	}
	
	Stream.prototype.pipe = function(dest, options) {
	  var source = this;
	
	  function ondata(chunk) {
	    if (dest.writable) {
	      if (false === dest.write(chunk) && source.pause) {
	        source.pause();
	      }
	    }
	  }
	
	  source.on('data', ondata);
	
	  function ondrain() {
	    if (source.readable && source.resume) {
	      source.resume();
	    }
	  }
	
	  dest.on('drain', ondrain);
	
	  // If the 'end' option is not supplied, dest.end() will be called when
	  // source gets the 'end' or 'close' events.  Only dest.end() once.
	  if (!dest._isStdio && (!options || options.end !== false)) {
	    source.on('end', onend);
	    source.on('close', onclose);
	  }
	
	  var didOnEnd = false;
	  function onend() {
	    if (didOnEnd) return;
	    didOnEnd = true;
	
	    dest.end();
	  }
	
	
	  function onclose() {
	    if (didOnEnd) return;
	    didOnEnd = true;
	
	    if (typeof dest.destroy === 'function') dest.destroy();
	  }
	
	  // don't leave dangling pipes when there are errors.
	  function onerror(er) {
	    cleanup();
	    if (EE.listenerCount(this, 'error') === 0) {
	      throw er; // Unhandled stream error in pipe.
	    }
	  }
	
	  source.on('error', onerror);
	  dest.on('error', onerror);
	
	  // remove all the event listeners that were added.
	  function cleanup() {
	    source.removeListener('data', ondata);
	    dest.removeListener('drain', ondrain);
	
	    source.removeListener('end', onend);
	    source.removeListener('close', onclose);
	
	    source.removeListener('error', onerror);
	    dest.removeListener('error', onerror);
	
	    source.removeListener('end', cleanup);
	    source.removeListener('close', cleanup);
	
	    dest.removeListener('close', cleanup);
	  }
	
	  source.on('end', cleanup);
	  source.on('close', cleanup);
	
	  dest.on('close', cleanup);
	
	  dest.emit('pipe', source);
	
	  // Allow for unix-like usage: A.pipe(B).pipe(C)
	  return dest;
	};


/***/ },
/* 40 */
/***/ function(module, exports) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	function EventEmitter() {
	  this._events = this._events || {};
	  this._maxListeners = this._maxListeners || undefined;
	}
	module.exports = EventEmitter;
	
	// Backwards-compat with node 0.10.x
	EventEmitter.EventEmitter = EventEmitter;
	
	EventEmitter.prototype._events = undefined;
	EventEmitter.prototype._maxListeners = undefined;
	
	// By default EventEmitters will print a warning if more than 10 listeners are
	// added to it. This is a useful default which helps finding memory leaks.
	EventEmitter.defaultMaxListeners = 10;
	
	// Obviously not all Emitters should be limited to 10. This function allows
	// that to be increased. Set to zero for unlimited.
	EventEmitter.prototype.setMaxListeners = function(n) {
	  if (!isNumber(n) || n < 0 || isNaN(n))
	    throw TypeError('n must be a positive number');
	  this._maxListeners = n;
	  return this;
	};
	
	EventEmitter.prototype.emit = function(type) {
	  var er, handler, len, args, i, listeners;
	
	  if (!this._events)
	    this._events = {};
	
	  // If there is no 'error' event listener then throw.
	  if (type === 'error') {
	    if (!this._events.error ||
	        (isObject(this._events.error) && !this._events.error.length)) {
	      er = arguments[1];
	      if (er instanceof Error) {
	        throw er; // Unhandled 'error' event
	      }
	      throw TypeError('Uncaught, unspecified "error" event.');
	    }
	  }
	
	  handler = this._events[type];
	
	  if (isUndefined(handler))
	    return false;
	
	  if (isFunction(handler)) {
	    switch (arguments.length) {
	      // fast cases
	      case 1:
	        handler.call(this);
	        break;
	      case 2:
	        handler.call(this, arguments[1]);
	        break;
	      case 3:
	        handler.call(this, arguments[1], arguments[2]);
	        break;
	      // slower
	      default:
	        len = arguments.length;
	        args = new Array(len - 1);
	        for (i = 1; i < len; i++)
	          args[i - 1] = arguments[i];
	        handler.apply(this, args);
	    }
	  } else if (isObject(handler)) {
	    len = arguments.length;
	    args = new Array(len - 1);
	    for (i = 1; i < len; i++)
	      args[i - 1] = arguments[i];
	
	    listeners = handler.slice();
	    len = listeners.length;
	    for (i = 0; i < len; i++)
	      listeners[i].apply(this, args);
	  }
	
	  return true;
	};
	
	EventEmitter.prototype.addListener = function(type, listener) {
	  var m;
	
	  if (!isFunction(listener))
	    throw TypeError('listener must be a function');
	
	  if (!this._events)
	    this._events = {};
	
	  // To avoid recursion in the case that type === "newListener"! Before
	  // adding it to the listeners, first emit "newListener".
	  if (this._events.newListener)
	    this.emit('newListener', type,
	              isFunction(listener.listener) ?
	              listener.listener : listener);
	
	  if (!this._events[type])
	    // Optimize the case of one listener. Don't need the extra array object.
	    this._events[type] = listener;
	  else if (isObject(this._events[type]))
	    // If we've already got an array, just append.
	    this._events[type].push(listener);
	  else
	    // Adding the second element, need to change to array.
	    this._events[type] = [this._events[type], listener];
	
	  // Check for listener leak
	  if (isObject(this._events[type]) && !this._events[type].warned) {
	    var m;
	    if (!isUndefined(this._maxListeners)) {
	      m = this._maxListeners;
	    } else {
	      m = EventEmitter.defaultMaxListeners;
	    }
	
	    if (m && m > 0 && this._events[type].length > m) {
	      this._events[type].warned = true;
	      console.error('(node) warning: possible EventEmitter memory ' +
	                    'leak detected. %d listeners added. ' +
	                    'Use emitter.setMaxListeners() to increase limit.',
	                    this._events[type].length);
	      if (typeof console.trace === 'function') {
	        // not supported in IE 10
	        console.trace();
	      }
	    }
	  }
	
	  return this;
	};
	
	EventEmitter.prototype.on = EventEmitter.prototype.addListener;
	
	EventEmitter.prototype.once = function(type, listener) {
	  if (!isFunction(listener))
	    throw TypeError('listener must be a function');
	
	  var fired = false;
	
	  function g() {
	    this.removeListener(type, g);
	
	    if (!fired) {
	      fired = true;
	      listener.apply(this, arguments);
	    }
	  }
	
	  g.listener = listener;
	  this.on(type, g);
	
	  return this;
	};
	
	// emits a 'removeListener' event iff the listener was removed
	EventEmitter.prototype.removeListener = function(type, listener) {
	  var list, position, length, i;
	
	  if (!isFunction(listener))
	    throw TypeError('listener must be a function');
	
	  if (!this._events || !this._events[type])
	    return this;
	
	  list = this._events[type];
	  length = list.length;
	  position = -1;
	
	  if (list === listener ||
	      (isFunction(list.listener) && list.listener === listener)) {
	    delete this._events[type];
	    if (this._events.removeListener)
	      this.emit('removeListener', type, listener);
	
	  } else if (isObject(list)) {
	    for (i = length; i-- > 0;) {
	      if (list[i] === listener ||
	          (list[i].listener && list[i].listener === listener)) {
	        position = i;
	        break;
	      }
	    }
	
	    if (position < 0)
	      return this;
	
	    if (list.length === 1) {
	      list.length = 0;
	      delete this._events[type];
	    } else {
	      list.splice(position, 1);
	    }
	
	    if (this._events.removeListener)
	      this.emit('removeListener', type, listener);
	  }
	
	  return this;
	};
	
	EventEmitter.prototype.removeAllListeners = function(type) {
	  var key, listeners;
	
	  if (!this._events)
	    return this;
	
	  // not listening for removeListener, no need to emit
	  if (!this._events.removeListener) {
	    if (arguments.length === 0)
	      this._events = {};
	    else if (this._events[type])
	      delete this._events[type];
	    return this;
	  }
	
	  // emit removeListener for all listeners on all events
	  if (arguments.length === 0) {
	    for (key in this._events) {
	      if (key === 'removeListener') continue;
	      this.removeAllListeners(key);
	    }
	    this.removeAllListeners('removeListener');
	    this._events = {};
	    return this;
	  }
	
	  listeners = this._events[type];
	
	  if (isFunction(listeners)) {
	    this.removeListener(type, listeners);
	  } else {
	    // LIFO order
	    while (listeners.length)
	      this.removeListener(type, listeners[listeners.length - 1]);
	  }
	  delete this._events[type];
	
	  return this;
	};
	
	EventEmitter.prototype.listeners = function(type) {
	  var ret;
	  if (!this._events || !this._events[type])
	    ret = [];
	  else if (isFunction(this._events[type]))
	    ret = [this._events[type]];
	  else
	    ret = this._events[type].slice();
	  return ret;
	};
	
	EventEmitter.listenerCount = function(emitter, type) {
	  var ret;
	  if (!emitter._events || !emitter._events[type])
	    ret = 0;
	  else if (isFunction(emitter._events[type]))
	    ret = 1;
	  else
	    ret = emitter._events[type].length;
	  return ret;
	};
	
	function isFunction(arg) {
	  return typeof arg === 'function';
	}
	
	function isNumber(arg) {
	  return typeof arg === 'number';
	}
	
	function isObject(arg) {
	  return typeof arg === 'object' && arg !== null;
	}
	
	function isUndefined(arg) {
	  return arg === void 0;
	}


/***/ },
/* 41 */
/***/ function(module, exports) {

	if (typeof Object.create === 'function') {
	  // implementation from standard node.js 'util' module
	  module.exports = function inherits(ctor, superCtor) {
	    ctor.super_ = superCtor
	    ctor.prototype = Object.create(superCtor.prototype, {
	      constructor: {
	        value: ctor,
	        enumerable: false,
	        writable: true,
	        configurable: true
	      }
	    });
	  };
	} else {
	  // old school shim for old browsers
	  module.exports = function inherits(ctor, superCtor) {
	    ctor.super_ = superCtor
	    var TempCtor = function () {}
	    TempCtor.prototype = superCtor.prototype
	    ctor.prototype = new TempCtor()
	    ctor.prototype.constructor = ctor
	  }
	}


/***/ },
/* 42 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {exports = module.exports = __webpack_require__(43);
	exports.Stream = __webpack_require__(39);
	exports.Readable = exports;
	exports.Writable = __webpack_require__(48);
	exports.Duplex = __webpack_require__(47);
	exports.Transform = __webpack_require__(49);
	exports.PassThrough = __webpack_require__(50);
	if (!process.browser && process.env.READABLE_STREAM === 'disable') {
	  module.exports = __webpack_require__(39);
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3)))

/***/ },
/* 43 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	module.exports = Readable;
	
	/*<replacement>*/
	var isArray = __webpack_require__(44);
	/*</replacement>*/
	
	
	/*<replacement>*/
	var Buffer = __webpack_require__(20).Buffer;
	/*</replacement>*/
	
	Readable.ReadableState = ReadableState;
	
	var EE = __webpack_require__(40).EventEmitter;
	
	/*<replacement>*/
	if (!EE.listenerCount) EE.listenerCount = function(emitter, type) {
	  return emitter.listeners(type).length;
	};
	/*</replacement>*/
	
	var Stream = __webpack_require__(39);
	
	/*<replacement>*/
	var util = __webpack_require__(45);
	util.inherits = __webpack_require__(41);
	/*</replacement>*/
	
	var StringDecoder;
	
	
	/*<replacement>*/
	var debug = __webpack_require__(46);
	if (debug && debug.debuglog) {
	  debug = debug.debuglog('stream');
	} else {
	  debug = function () {};
	}
	/*</replacement>*/
	
	
	util.inherits(Readable, Stream);
	
	function ReadableState(options, stream) {
	  var Duplex = __webpack_require__(47);
	
	  options = options || {};
	
	  // the point at which it stops calling _read() to fill the buffer
	  // Note: 0 is a valid value, means "don't call _read preemptively ever"
	  var hwm = options.highWaterMark;
	  var defaultHwm = options.objectMode ? 16 : 16 * 1024;
	  this.highWaterMark = (hwm || hwm === 0) ? hwm : defaultHwm;
	
	  // cast to ints.
	  this.highWaterMark = ~~this.highWaterMark;
	
	  this.buffer = [];
	  this.length = 0;
	  this.pipes = null;
	  this.pipesCount = 0;
	  this.flowing = null;
	  this.ended = false;
	  this.endEmitted = false;
	  this.reading = false;
	
	  // a flag to be able to tell if the onwrite cb is called immediately,
	  // or on a later tick.  We set this to true at first, because any
	  // actions that shouldn't happen until "later" should generally also
	  // not happen before the first write call.
	  this.sync = true;
	
	  // whenever we return null, then we set a flag to say
	  // that we're awaiting a 'readable' event emission.
	  this.needReadable = false;
	  this.emittedReadable = false;
	  this.readableListening = false;
	
	
	  // object stream flag. Used to make read(n) ignore n and to
	  // make all the buffer merging and length checks go away
	  this.objectMode = !!options.objectMode;
	
	  if (stream instanceof Duplex)
	    this.objectMode = this.objectMode || !!options.readableObjectMode;
	
	  // Crypto is kind of old and crusty.  Historically, its default string
	  // encoding is 'binary' so we have to make this configurable.
	  // Everything else in the universe uses 'utf8', though.
	  this.defaultEncoding = options.defaultEncoding || 'utf8';
	
	  // when piping, we only care about 'readable' events that happen
	  // after read()ing all the bytes and not getting any pushback.
	  this.ranOut = false;
	
	  // the number of writers that are awaiting a drain event in .pipe()s
	  this.awaitDrain = 0;
	
	  // if true, a maybeReadMore has been scheduled
	  this.readingMore = false;
	
	  this.decoder = null;
	  this.encoding = null;
	  if (options.encoding) {
	    if (!StringDecoder)
	      StringDecoder = __webpack_require__(19).StringDecoder;
	    this.decoder = new StringDecoder(options.encoding);
	    this.encoding = options.encoding;
	  }
	}
	
	function Readable(options) {
	  var Duplex = __webpack_require__(47);
	
	  if (!(this instanceof Readable))
	    return new Readable(options);
	
	  this._readableState = new ReadableState(options, this);
	
	  // legacy
	  this.readable = true;
	
	  Stream.call(this);
	}
	
	// Manually shove something into the read() buffer.
	// This returns true if the highWaterMark has not been hit yet,
	// similar to how Writable.write() returns true if you should
	// write() some more.
	Readable.prototype.push = function(chunk, encoding) {
	  var state = this._readableState;
	
	  if (util.isString(chunk) && !state.objectMode) {
	    encoding = encoding || state.defaultEncoding;
	    if (encoding !== state.encoding) {
	      chunk = new Buffer(chunk, encoding);
	      encoding = '';
	    }
	  }
	
	  return readableAddChunk(this, state, chunk, encoding, false);
	};
	
	// Unshift should *always* be something directly out of read()
	Readable.prototype.unshift = function(chunk) {
	  var state = this._readableState;
	  return readableAddChunk(this, state, chunk, '', true);
	};
	
	function readableAddChunk(stream, state, chunk, encoding, addToFront) {
	  var er = chunkInvalid(state, chunk);
	  if (er) {
	    stream.emit('error', er);
	  } else if (util.isNullOrUndefined(chunk)) {
	    state.reading = false;
	    if (!state.ended)
	      onEofChunk(stream, state);
	  } else if (state.objectMode || chunk && chunk.length > 0) {
	    if (state.ended && !addToFront) {
	      var e = new Error('stream.push() after EOF');
	      stream.emit('error', e);
	    } else if (state.endEmitted && addToFront) {
	      var e = new Error('stream.unshift() after end event');
	      stream.emit('error', e);
	    } else {
	      if (state.decoder && !addToFront && !encoding)
	        chunk = state.decoder.write(chunk);
	
	      if (!addToFront)
	        state.reading = false;
	
	      // if we want the data now, just emit it.
	      if (state.flowing && state.length === 0 && !state.sync) {
	        stream.emit('data', chunk);
	        stream.read(0);
	      } else {
	        // update the buffer info.
	        state.length += state.objectMode ? 1 : chunk.length;
	        if (addToFront)
	          state.buffer.unshift(chunk);
	        else
	          state.buffer.push(chunk);
	
	        if (state.needReadable)
	          emitReadable(stream);
	      }
	
	      maybeReadMore(stream, state);
	    }
	  } else if (!addToFront) {
	    state.reading = false;
	  }
	
	  return needMoreData(state);
	}
	
	
	
	// if it's past the high water mark, we can push in some more.
	// Also, if we have no data yet, we can stand some
	// more bytes.  This is to work around cases where hwm=0,
	// such as the repl.  Also, if the push() triggered a
	// readable event, and the user called read(largeNumber) such that
	// needReadable was set, then we ought to push more, so that another
	// 'readable' event will be triggered.
	function needMoreData(state) {
	  return !state.ended &&
	         (state.needReadable ||
	          state.length < state.highWaterMark ||
	          state.length === 0);
	}
	
	// backwards compatibility.
	Readable.prototype.setEncoding = function(enc) {
	  if (!StringDecoder)
	    StringDecoder = __webpack_require__(19).StringDecoder;
	  this._readableState.decoder = new StringDecoder(enc);
	  this._readableState.encoding = enc;
	  return this;
	};
	
	// Don't raise the hwm > 128MB
	var MAX_HWM = 0x800000;
	function roundUpToNextPowerOf2(n) {
	  if (n >= MAX_HWM) {
	    n = MAX_HWM;
	  } else {
	    // Get the next highest power of 2
	    n--;
	    for (var p = 1; p < 32; p <<= 1) n |= n >> p;
	    n++;
	  }
	  return n;
	}
	
	function howMuchToRead(n, state) {
	  if (state.length === 0 && state.ended)
	    return 0;
	
	  if (state.objectMode)
	    return n === 0 ? 0 : 1;
	
	  if (isNaN(n) || util.isNull(n)) {
	    // only flow one buffer at a time
	    if (state.flowing && state.buffer.length)
	      return state.buffer[0].length;
	    else
	      return state.length;
	  }
	
	  if (n <= 0)
	    return 0;
	
	  // If we're asking for more than the target buffer level,
	  // then raise the water mark.  Bump up to the next highest
	  // power of 2, to prevent increasing it excessively in tiny
	  // amounts.
	  if (n > state.highWaterMark)
	    state.highWaterMark = roundUpToNextPowerOf2(n);
	
	  // don't have that much.  return null, unless we've ended.
	  if (n > state.length) {
	    if (!state.ended) {
	      state.needReadable = true;
	      return 0;
	    } else
	      return state.length;
	  }
	
	  return n;
	}
	
	// you can override either this method, or the async _read(n) below.
	Readable.prototype.read = function(n) {
	  debug('read', n);
	  var state = this._readableState;
	  var nOrig = n;
	
	  if (!util.isNumber(n) || n > 0)
	    state.emittedReadable = false;
	
	  // if we're doing read(0) to trigger a readable event, but we
	  // already have a bunch of data in the buffer, then just trigger
	  // the 'readable' event and move on.
	  if (n === 0 &&
	      state.needReadable &&
	      (state.length >= state.highWaterMark || state.ended)) {
	    debug('read: emitReadable', state.length, state.ended);
	    if (state.length === 0 && state.ended)
	      endReadable(this);
	    else
	      emitReadable(this);
	    return null;
	  }
	
	  n = howMuchToRead(n, state);
	
	  // if we've ended, and we're now clear, then finish it up.
	  if (n === 0 && state.ended) {
	    if (state.length === 0)
	      endReadable(this);
	    return null;
	  }
	
	  // All the actual chunk generation logic needs to be
	  // *below* the call to _read.  The reason is that in certain
	  // synthetic stream cases, such as passthrough streams, _read
	  // may be a completely synchronous operation which may change
	  // the state of the read buffer, providing enough data when
	  // before there was *not* enough.
	  //
	  // So, the steps are:
	  // 1. Figure out what the state of things will be after we do
	  // a read from the buffer.
	  //
	  // 2. If that resulting state will trigger a _read, then call _read.
	  // Note that this may be asynchronous, or synchronous.  Yes, it is
	  // deeply ugly to write APIs this way, but that still doesn't mean
	  // that the Readable class should behave improperly, as streams are
	  // designed to be sync/async agnostic.
	  // Take note if the _read call is sync or async (ie, if the read call
	  // has returned yet), so that we know whether or not it's safe to emit
	  // 'readable' etc.
	  //
	  // 3. Actually pull the requested chunks out of the buffer and return.
	
	  // if we need a readable event, then we need to do some reading.
	  var doRead = state.needReadable;
	  debug('need readable', doRead);
	
	  // if we currently have less than the highWaterMark, then also read some
	  if (state.length === 0 || state.length - n < state.highWaterMark) {
	    doRead = true;
	    debug('length less than watermark', doRead);
	  }
	
	  // however, if we've ended, then there's no point, and if we're already
	  // reading, then it's unnecessary.
	  if (state.ended || state.reading) {
	    doRead = false;
	    debug('reading or ended', doRead);
	  }
	
	  if (doRead) {
	    debug('do read');
	    state.reading = true;
	    state.sync = true;
	    // if the length is currently zero, then we *need* a readable event.
	    if (state.length === 0)
	      state.needReadable = true;
	    // call internal read method
	    this._read(state.highWaterMark);
	    state.sync = false;
	  }
	
	  // If _read pushed data synchronously, then `reading` will be false,
	  // and we need to re-evaluate how much data we can return to the user.
	  if (doRead && !state.reading)
	    n = howMuchToRead(nOrig, state);
	
	  var ret;
	  if (n > 0)
	    ret = fromList(n, state);
	  else
	    ret = null;
	
	  if (util.isNull(ret)) {
	    state.needReadable = true;
	    n = 0;
	  }
	
	  state.length -= n;
	
	  // If we have nothing in the buffer, then we want to know
	  // as soon as we *do* get something into the buffer.
	  if (state.length === 0 && !state.ended)
	    state.needReadable = true;
	
	  // If we tried to read() past the EOF, then emit end on the next tick.
	  if (nOrig !== n && state.ended && state.length === 0)
	    endReadable(this);
	
	  if (!util.isNull(ret))
	    this.emit('data', ret);
	
	  return ret;
	};
	
	function chunkInvalid(state, chunk) {
	  var er = null;
	  if (!util.isBuffer(chunk) &&
	      !util.isString(chunk) &&
	      !util.isNullOrUndefined(chunk) &&
	      !state.objectMode) {
	    er = new TypeError('Invalid non-string/buffer chunk');
	  }
	  return er;
	}
	
	
	function onEofChunk(stream, state) {
	  if (state.decoder && !state.ended) {
	    var chunk = state.decoder.end();
	    if (chunk && chunk.length) {
	      state.buffer.push(chunk);
	      state.length += state.objectMode ? 1 : chunk.length;
	    }
	  }
	  state.ended = true;
	
	  // emit 'readable' now to make sure it gets picked up.
	  emitReadable(stream);
	}
	
	// Don't emit readable right away in sync mode, because this can trigger
	// another read() call => stack overflow.  This way, it might trigger
	// a nextTick recursion warning, but that's not so bad.
	function emitReadable(stream) {
	  var state = stream._readableState;
	  state.needReadable = false;
	  if (!state.emittedReadable) {
	    debug('emitReadable', state.flowing);
	    state.emittedReadable = true;
	    if (state.sync)
	      process.nextTick(function() {
	        emitReadable_(stream);
	      });
	    else
	      emitReadable_(stream);
	  }
	}
	
	function emitReadable_(stream) {
	  debug('emit readable');
	  stream.emit('readable');
	  flow(stream);
	}
	
	
	// at this point, the user has presumably seen the 'readable' event,
	// and called read() to consume some data.  that may have triggered
	// in turn another _read(n) call, in which case reading = true if
	// it's in progress.
	// However, if we're not ended, or reading, and the length < hwm,
	// then go ahead and try to read some more preemptively.
	function maybeReadMore(stream, state) {
	  if (!state.readingMore) {
	    state.readingMore = true;
	    process.nextTick(function() {
	      maybeReadMore_(stream, state);
	    });
	  }
	}
	
	function maybeReadMore_(stream, state) {
	  var len = state.length;
	  while (!state.reading && !state.flowing && !state.ended &&
	         state.length < state.highWaterMark) {
	    debug('maybeReadMore read 0');
	    stream.read(0);
	    if (len === state.length)
	      // didn't get any data, stop spinning.
	      break;
	    else
	      len = state.length;
	  }
	  state.readingMore = false;
	}
	
	// abstract method.  to be overridden in specific implementation classes.
	// call cb(er, data) where data is <= n in length.
	// for virtual (non-string, non-buffer) streams, "length" is somewhat
	// arbitrary, and perhaps not very meaningful.
	Readable.prototype._read = function(n) {
	  this.emit('error', new Error('not implemented'));
	};
	
	Readable.prototype.pipe = function(dest, pipeOpts) {
	  var src = this;
	  var state = this._readableState;
	
	  switch (state.pipesCount) {
	    case 0:
	      state.pipes = dest;
	      break;
	    case 1:
	      state.pipes = [state.pipes, dest];
	      break;
	    default:
	      state.pipes.push(dest);
	      break;
	  }
	  state.pipesCount += 1;
	  debug('pipe count=%d opts=%j', state.pipesCount, pipeOpts);
	
	  var doEnd = (!pipeOpts || pipeOpts.end !== false) &&
	              dest !== process.stdout &&
	              dest !== process.stderr;
	
	  var endFn = doEnd ? onend : cleanup;
	  if (state.endEmitted)
	    process.nextTick(endFn);
	  else
	    src.once('end', endFn);
	
	  dest.on('unpipe', onunpipe);
	  function onunpipe(readable) {
	    debug('onunpipe');
	    if (readable === src) {
	      cleanup();
	    }
	  }
	
	  function onend() {
	    debug('onend');
	    dest.end();
	  }
	
	  // when the dest drains, it reduces the awaitDrain counter
	  // on the source.  This would be more elegant with a .once()
	  // handler in flow(), but adding and removing repeatedly is
	  // too slow.
	  var ondrain = pipeOnDrain(src);
	  dest.on('drain', ondrain);
	
	  function cleanup() {
	    debug('cleanup');
	    // cleanup event handlers once the pipe is broken
	    dest.removeListener('close', onclose);
	    dest.removeListener('finish', onfinish);
	    dest.removeListener('drain', ondrain);
	    dest.removeListener('error', onerror);
	    dest.removeListener('unpipe', onunpipe);
	    src.removeListener('end', onend);
	    src.removeListener('end', cleanup);
	    src.removeListener('data', ondata);
	
	    // if the reader is waiting for a drain event from this
	    // specific writer, then it would cause it to never start
	    // flowing again.
	    // So, if this is awaiting a drain, then we just call it now.
	    // If we don't know, then assume that we are waiting for one.
	    if (state.awaitDrain &&
	        (!dest._writableState || dest._writableState.needDrain))
	      ondrain();
	  }
	
	  src.on('data', ondata);
	  function ondata(chunk) {
	    debug('ondata');
	    var ret = dest.write(chunk);
	    if (false === ret) {
	      debug('false write response, pause',
	            src._readableState.awaitDrain);
	      src._readableState.awaitDrain++;
	      src.pause();
	    }
	  }
	
	  // if the dest has an error, then stop piping into it.
	  // however, don't suppress the throwing behavior for this.
	  function onerror(er) {
	    debug('onerror', er);
	    unpipe();
	    dest.removeListener('error', onerror);
	    if (EE.listenerCount(dest, 'error') === 0)
	      dest.emit('error', er);
	  }
	  // This is a brutally ugly hack to make sure that our error handler
	  // is attached before any userland ones.  NEVER DO THIS.
	  if (!dest._events || !dest._events.error)
	    dest.on('error', onerror);
	  else if (isArray(dest._events.error))
	    dest._events.error.unshift(onerror);
	  else
	    dest._events.error = [onerror, dest._events.error];
	
	
	
	  // Both close and finish should trigger unpipe, but only once.
	  function onclose() {
	    dest.removeListener('finish', onfinish);
	    unpipe();
	  }
	  dest.once('close', onclose);
	  function onfinish() {
	    debug('onfinish');
	    dest.removeListener('close', onclose);
	    unpipe();
	  }
	  dest.once('finish', onfinish);
	
	  function unpipe() {
	    debug('unpipe');
	    src.unpipe(dest);
	  }
	
	  // tell the dest that it's being piped to
	  dest.emit('pipe', src);
	
	  // start the flow if it hasn't been started already.
	  if (!state.flowing) {
	    debug('pipe resume');
	    src.resume();
	  }
	
	  return dest;
	};
	
	function pipeOnDrain(src) {
	  return function() {
	    var state = src._readableState;
	    debug('pipeOnDrain', state.awaitDrain);
	    if (state.awaitDrain)
	      state.awaitDrain--;
	    if (state.awaitDrain === 0 && EE.listenerCount(src, 'data')) {
	      state.flowing = true;
	      flow(src);
	    }
	  };
	}
	
	
	Readable.prototype.unpipe = function(dest) {
	  var state = this._readableState;
	
	  // if we're not piping anywhere, then do nothing.
	  if (state.pipesCount === 0)
	    return this;
	
	  // just one destination.  most common case.
	  if (state.pipesCount === 1) {
	    // passed in one, but it's not the right one.
	    if (dest && dest !== state.pipes)
	      return this;
	
	    if (!dest)
	      dest = state.pipes;
	
	    // got a match.
	    state.pipes = null;
	    state.pipesCount = 0;
	    state.flowing = false;
	    if (dest)
	      dest.emit('unpipe', this);
	    return this;
	  }
	
	  // slow case. multiple pipe destinations.
	
	  if (!dest) {
	    // remove all.
	    var dests = state.pipes;
	    var len = state.pipesCount;
	    state.pipes = null;
	    state.pipesCount = 0;
	    state.flowing = false;
	
	    for (var i = 0; i < len; i++)
	      dests[i].emit('unpipe', this);
	    return this;
	  }
	
	  // try to find the right one.
	  var i = indexOf(state.pipes, dest);
	  if (i === -1)
	    return this;
	
	  state.pipes.splice(i, 1);
	  state.pipesCount -= 1;
	  if (state.pipesCount === 1)
	    state.pipes = state.pipes[0];
	
	  dest.emit('unpipe', this);
	
	  return this;
	};
	
	// set up data events if they are asked for
	// Ensure readable listeners eventually get something
	Readable.prototype.on = function(ev, fn) {
	  var res = Stream.prototype.on.call(this, ev, fn);
	
	  // If listening to data, and it has not explicitly been paused,
	  // then call resume to start the flow of data on the next tick.
	  if (ev === 'data' && false !== this._readableState.flowing) {
	    this.resume();
	  }
	
	  if (ev === 'readable' && this.readable) {
	    var state = this._readableState;
	    if (!state.readableListening) {
	      state.readableListening = true;
	      state.emittedReadable = false;
	      state.needReadable = true;
	      if (!state.reading) {
	        var self = this;
	        process.nextTick(function() {
	          debug('readable nexttick read 0');
	          self.read(0);
	        });
	      } else if (state.length) {
	        emitReadable(this, state);
	      }
	    }
	  }
	
	  return res;
	};
	Readable.prototype.addListener = Readable.prototype.on;
	
	// pause() and resume() are remnants of the legacy readable stream API
	// If the user uses them, then switch into old mode.
	Readable.prototype.resume = function() {
	  var state = this._readableState;
	  if (!state.flowing) {
	    debug('resume');
	    state.flowing = true;
	    if (!state.reading) {
	      debug('resume read 0');
	      this.read(0);
	    }
	    resume(this, state);
	  }
	  return this;
	};
	
	function resume(stream, state) {
	  if (!state.resumeScheduled) {
	    state.resumeScheduled = true;
	    process.nextTick(function() {
	      resume_(stream, state);
	    });
	  }
	}
	
	function resume_(stream, state) {
	  state.resumeScheduled = false;
	  stream.emit('resume');
	  flow(stream);
	  if (state.flowing && !state.reading)
	    stream.read(0);
	}
	
	Readable.prototype.pause = function() {
	  debug('call pause flowing=%j', this._readableState.flowing);
	  if (false !== this._readableState.flowing) {
	    debug('pause');
	    this._readableState.flowing = false;
	    this.emit('pause');
	  }
	  return this;
	};
	
	function flow(stream) {
	  var state = stream._readableState;
	  debug('flow', state.flowing);
	  if (state.flowing) {
	    do {
	      var chunk = stream.read();
	    } while (null !== chunk && state.flowing);
	  }
	}
	
	// wrap an old-style stream as the async data source.
	// This is *not* part of the readable stream interface.
	// It is an ugly unfortunate mess of history.
	Readable.prototype.wrap = function(stream) {
	  var state = this._readableState;
	  var paused = false;
	
	  var self = this;
	  stream.on('end', function() {
	    debug('wrapped end');
	    if (state.decoder && !state.ended) {
	      var chunk = state.decoder.end();
	      if (chunk && chunk.length)
	        self.push(chunk);
	    }
	
	    self.push(null);
	  });
	
	  stream.on('data', function(chunk) {
	    debug('wrapped data');
	    if (state.decoder)
	      chunk = state.decoder.write(chunk);
	    if (!chunk || !state.objectMode && !chunk.length)
	      return;
	
	    var ret = self.push(chunk);
	    if (!ret) {
	      paused = true;
	      stream.pause();
	    }
	  });
	
	  // proxy all the other methods.
	  // important when wrapping filters and duplexes.
	  for (var i in stream) {
	    if (util.isFunction(stream[i]) && util.isUndefined(this[i])) {
	      this[i] = function(method) { return function() {
	        return stream[method].apply(stream, arguments);
	      }}(i);
	    }
	  }
	
	  // proxy certain important events.
	  var events = ['error', 'close', 'destroy', 'pause', 'resume'];
	  forEach(events, function(ev) {
	    stream.on(ev, self.emit.bind(self, ev));
	  });
	
	  // when we try to consume some more bytes, simply unpause the
	  // underlying stream.
	  self._read = function(n) {
	    debug('wrapped _read', n);
	    if (paused) {
	      paused = false;
	      stream.resume();
	    }
	  };
	
	  return self;
	};
	
	
	
	// exposed for testing purposes only.
	Readable._fromList = fromList;
	
	// Pluck off n bytes from an array of buffers.
	// Length is the combined lengths of all the buffers in the list.
	function fromList(n, state) {
	  var list = state.buffer;
	  var length = state.length;
	  var stringMode = !!state.decoder;
	  var objectMode = !!state.objectMode;
	  var ret;
	
	  // nothing in the list, definitely empty.
	  if (list.length === 0)
	    return null;
	
	  if (length === 0)
	    ret = null;
	  else if (objectMode)
	    ret = list.shift();
	  else if (!n || n >= length) {
	    // read it all, truncate the array.
	    if (stringMode)
	      ret = list.join('');
	    else
	      ret = Buffer.concat(list, length);
	    list.length = 0;
	  } else {
	    // read just some of it.
	    if (n < list[0].length) {
	      // just take a part of the first list item.
	      // slice is the same for buffers and strings.
	      var buf = list[0];
	      ret = buf.slice(0, n);
	      list[0] = buf.slice(n);
	    } else if (n === list[0].length) {
	      // first list is a perfect match
	      ret = list.shift();
	    } else {
	      // complex case.
	      // we have enough to cover it, but it spans past the first buffer.
	      if (stringMode)
	        ret = '';
	      else
	        ret = new Buffer(n);
	
	      var c = 0;
	      for (var i = 0, l = list.length; i < l && c < n; i++) {
	        var buf = list[0];
	        var cpy = Math.min(n - c, buf.length);
	
	        if (stringMode)
	          ret += buf.slice(0, cpy);
	        else
	          buf.copy(ret, c, 0, cpy);
	
	        if (cpy < buf.length)
	          list[0] = buf.slice(cpy);
	        else
	          list.shift();
	
	        c += cpy;
	      }
	    }
	  }
	
	  return ret;
	}
	
	function endReadable(stream) {
	  var state = stream._readableState;
	
	  // If we get here before consuming all the bytes, then that is a
	  // bug in node.  Should never happen.
	  if (state.length > 0)
	    throw new Error('endReadable called on non-empty stream');
	
	  if (!state.endEmitted) {
	    state.ended = true;
	    process.nextTick(function() {
	      // Check that we didn't get one last unshift.
	      if (!state.endEmitted && state.length === 0) {
	        state.endEmitted = true;
	        stream.readable = false;
	        stream.emit('end');
	      }
	    });
	  }
	}
	
	function forEach (xs, f) {
	  for (var i = 0, l = xs.length; i < l; i++) {
	    f(xs[i], i);
	  }
	}
	
	function indexOf (xs, x) {
	  for (var i = 0, l = xs.length; i < l; i++) {
	    if (xs[i] === x) return i;
	  }
	  return -1;
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3)))

/***/ },
/* 44 */
/***/ function(module, exports) {

	module.exports = Array.isArray || function (arr) {
	  return Object.prototype.toString.call(arr) == '[object Array]';
	};


/***/ },
/* 45 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	// NOTE: These type checking functions intentionally don't use `instanceof`
	// because it is fragile and can be easily faked with `Object.create()`.
	
	function isArray(arg) {
	  if (Array.isArray) {
	    return Array.isArray(arg);
	  }
	  return objectToString(arg) === '[object Array]';
	}
	exports.isArray = isArray;
	
	function isBoolean(arg) {
	  return typeof arg === 'boolean';
	}
	exports.isBoolean = isBoolean;
	
	function isNull(arg) {
	  return arg === null;
	}
	exports.isNull = isNull;
	
	function isNullOrUndefined(arg) {
	  return arg == null;
	}
	exports.isNullOrUndefined = isNullOrUndefined;
	
	function isNumber(arg) {
	  return typeof arg === 'number';
	}
	exports.isNumber = isNumber;
	
	function isString(arg) {
	  return typeof arg === 'string';
	}
	exports.isString = isString;
	
	function isSymbol(arg) {
	  return typeof arg === 'symbol';
	}
	exports.isSymbol = isSymbol;
	
	function isUndefined(arg) {
	  return arg === void 0;
	}
	exports.isUndefined = isUndefined;
	
	function isRegExp(re) {
	  return objectToString(re) === '[object RegExp]';
	}
	exports.isRegExp = isRegExp;
	
	function isObject(arg) {
	  return typeof arg === 'object' && arg !== null;
	}
	exports.isObject = isObject;
	
	function isDate(d) {
	  return objectToString(d) === '[object Date]';
	}
	exports.isDate = isDate;
	
	function isError(e) {
	  return (objectToString(e) === '[object Error]' || e instanceof Error);
	}
	exports.isError = isError;
	
	function isFunction(arg) {
	  return typeof arg === 'function';
	}
	exports.isFunction = isFunction;
	
	function isPrimitive(arg) {
	  return arg === null ||
	         typeof arg === 'boolean' ||
	         typeof arg === 'number' ||
	         typeof arg === 'string' ||
	         typeof arg === 'symbol' ||  // ES6 symbol
	         typeof arg === 'undefined';
	}
	exports.isPrimitive = isPrimitive;
	
	exports.isBuffer = Buffer.isBuffer;
	
	function objectToString(o) {
	  return Object.prototype.toString.call(o);
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(9).Buffer))

/***/ },
/* 46 */
/***/ function(module, exports) {

	/* (ignored) */

/***/ },
/* 47 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	// a duplex stream is just a stream that is both readable and writable.
	// Since JS doesn't have multiple prototypal inheritance, this class
	// prototypally inherits from Readable, and then parasitically from
	// Writable.
	
	module.exports = Duplex;
	
	/*<replacement>*/
	var objectKeys = Object.keys || function (obj) {
	  var keys = [];
	  for (var key in obj) keys.push(key);
	  return keys;
	}
	/*</replacement>*/
	
	
	/*<replacement>*/
	var util = __webpack_require__(45);
	util.inherits = __webpack_require__(41);
	/*</replacement>*/
	
	var Readable = __webpack_require__(43);
	var Writable = __webpack_require__(48);
	
	util.inherits(Duplex, Readable);
	
	forEach(objectKeys(Writable.prototype), function(method) {
	  if (!Duplex.prototype[method])
	    Duplex.prototype[method] = Writable.prototype[method];
	});
	
	function Duplex(options) {
	  if (!(this instanceof Duplex))
	    return new Duplex(options);
	
	  Readable.call(this, options);
	  Writable.call(this, options);
	
	  if (options && options.readable === false)
	    this.readable = false;
	
	  if (options && options.writable === false)
	    this.writable = false;
	
	  this.allowHalfOpen = true;
	  if (options && options.allowHalfOpen === false)
	    this.allowHalfOpen = false;
	
	  this.once('end', onend);
	}
	
	// the no-half-open enforcer
	function onend() {
	  // if we allow half-open state, or if the writable side ended,
	  // then we're ok.
	  if (this.allowHalfOpen || this._writableState.ended)
	    return;
	
	  // no more data can be written.
	  // But allow more writes to happen in this tick.
	  process.nextTick(this.end.bind(this));
	}
	
	function forEach (xs, f) {
	  for (var i = 0, l = xs.length; i < l; i++) {
	    f(xs[i], i);
	  }
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3)))

/***/ },
/* 48 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	// A bit simpler than readable streams.
	// Implement an async ._write(chunk, cb), and it'll handle all
	// the drain event emission and buffering.
	
	module.exports = Writable;
	
	/*<replacement>*/
	var Buffer = __webpack_require__(20).Buffer;
	/*</replacement>*/
	
	Writable.WritableState = WritableState;
	
	
	/*<replacement>*/
	var util = __webpack_require__(45);
	util.inherits = __webpack_require__(41);
	/*</replacement>*/
	
	var Stream = __webpack_require__(39);
	
	util.inherits(Writable, Stream);
	
	function WriteReq(chunk, encoding, cb) {
	  this.chunk = chunk;
	  this.encoding = encoding;
	  this.callback = cb;
	}
	
	function WritableState(options, stream) {
	  var Duplex = __webpack_require__(47);
	
	  options = options || {};
	
	  // the point at which write() starts returning false
	  // Note: 0 is a valid value, means that we always return false if
	  // the entire buffer is not flushed immediately on write()
	  var hwm = options.highWaterMark;
	  var defaultHwm = options.objectMode ? 16 : 16 * 1024;
	  this.highWaterMark = (hwm || hwm === 0) ? hwm : defaultHwm;
	
	  // object stream flag to indicate whether or not this stream
	  // contains buffers or objects.
	  this.objectMode = !!options.objectMode;
	
	  if (stream instanceof Duplex)
	    this.objectMode = this.objectMode || !!options.writableObjectMode;
	
	  // cast to ints.
	  this.highWaterMark = ~~this.highWaterMark;
	
	  this.needDrain = false;
	  // at the start of calling end()
	  this.ending = false;
	  // when end() has been called, and returned
	  this.ended = false;
	  // when 'finish' is emitted
	  this.finished = false;
	
	  // should we decode strings into buffers before passing to _write?
	  // this is here so that some node-core streams can optimize string
	  // handling at a lower level.
	  var noDecode = options.decodeStrings === false;
	  this.decodeStrings = !noDecode;
	
	  // Crypto is kind of old and crusty.  Historically, its default string
	  // encoding is 'binary' so we have to make this configurable.
	  // Everything else in the universe uses 'utf8', though.
	  this.defaultEncoding = options.defaultEncoding || 'utf8';
	
	  // not an actual buffer we keep track of, but a measurement
	  // of how much we're waiting to get pushed to some underlying
	  // socket or file.
	  this.length = 0;
	
	  // a flag to see when we're in the middle of a write.
	  this.writing = false;
	
	  // when true all writes will be buffered until .uncork() call
	  this.corked = 0;
	
	  // a flag to be able to tell if the onwrite cb is called immediately,
	  // or on a later tick.  We set this to true at first, because any
	  // actions that shouldn't happen until "later" should generally also
	  // not happen before the first write call.
	  this.sync = true;
	
	  // a flag to know if we're processing previously buffered items, which
	  // may call the _write() callback in the same tick, so that we don't
	  // end up in an overlapped onwrite situation.
	  this.bufferProcessing = false;
	
	  // the callback that's passed to _write(chunk,cb)
	  this.onwrite = function(er) {
	    onwrite(stream, er);
	  };
	
	  // the callback that the user supplies to write(chunk,encoding,cb)
	  this.writecb = null;
	
	  // the amount that is being written when _write is called.
	  this.writelen = 0;
	
	  this.buffer = [];
	
	  // number of pending user-supplied write callbacks
	  // this must be 0 before 'finish' can be emitted
	  this.pendingcb = 0;
	
	  // emit prefinish if the only thing we're waiting for is _write cbs
	  // This is relevant for synchronous Transform streams
	  this.prefinished = false;
	
	  // True if the error was already emitted and should not be thrown again
	  this.errorEmitted = false;
	}
	
	function Writable(options) {
	  var Duplex = __webpack_require__(47);
	
	  // Writable ctor is applied to Duplexes, though they're not
	  // instanceof Writable, they're instanceof Readable.
	  if (!(this instanceof Writable) && !(this instanceof Duplex))
	    return new Writable(options);
	
	  this._writableState = new WritableState(options, this);
	
	  // legacy.
	  this.writable = true;
	
	  Stream.call(this);
	}
	
	// Otherwise people can pipe Writable streams, which is just wrong.
	Writable.prototype.pipe = function() {
	  this.emit('error', new Error('Cannot pipe. Not readable.'));
	};
	
	
	function writeAfterEnd(stream, state, cb) {
	  var er = new Error('write after end');
	  // TODO: defer error events consistently everywhere, not just the cb
	  stream.emit('error', er);
	  process.nextTick(function() {
	    cb(er);
	  });
	}
	
	// If we get something that is not a buffer, string, null, or undefined,
	// and we're not in objectMode, then that's an error.
	// Otherwise stream chunks are all considered to be of length=1, and the
	// watermarks determine how many objects to keep in the buffer, rather than
	// how many bytes or characters.
	function validChunk(stream, state, chunk, cb) {
	  var valid = true;
	  if (!util.isBuffer(chunk) &&
	      !util.isString(chunk) &&
	      !util.isNullOrUndefined(chunk) &&
	      !state.objectMode) {
	    var er = new TypeError('Invalid non-string/buffer chunk');
	    stream.emit('error', er);
	    process.nextTick(function() {
	      cb(er);
	    });
	    valid = false;
	  }
	  return valid;
	}
	
	Writable.prototype.write = function(chunk, encoding, cb) {
	  var state = this._writableState;
	  var ret = false;
	
	  if (util.isFunction(encoding)) {
	    cb = encoding;
	    encoding = null;
	  }
	
	  if (util.isBuffer(chunk))
	    encoding = 'buffer';
	  else if (!encoding)
	    encoding = state.defaultEncoding;
	
	  if (!util.isFunction(cb))
	    cb = function() {};
	
	  if (state.ended)
	    writeAfterEnd(this, state, cb);
	  else if (validChunk(this, state, chunk, cb)) {
	    state.pendingcb++;
	    ret = writeOrBuffer(this, state, chunk, encoding, cb);
	  }
	
	  return ret;
	};
	
	Writable.prototype.cork = function() {
	  var state = this._writableState;
	
	  state.corked++;
	};
	
	Writable.prototype.uncork = function() {
	  var state = this._writableState;
	
	  if (state.corked) {
	    state.corked--;
	
	    if (!state.writing &&
	        !state.corked &&
	        !state.finished &&
	        !state.bufferProcessing &&
	        state.buffer.length)
	      clearBuffer(this, state);
	  }
	};
	
	function decodeChunk(state, chunk, encoding) {
	  if (!state.objectMode &&
	      state.decodeStrings !== false &&
	      util.isString(chunk)) {
	    chunk = new Buffer(chunk, encoding);
	  }
	  return chunk;
	}
	
	// if we're already writing something, then just put this
	// in the queue, and wait our turn.  Otherwise, call _write
	// If we return false, then we need a drain event, so set that flag.
	function writeOrBuffer(stream, state, chunk, encoding, cb) {
	  chunk = decodeChunk(state, chunk, encoding);
	  if (util.isBuffer(chunk))
	    encoding = 'buffer';
	  var len = state.objectMode ? 1 : chunk.length;
	
	  state.length += len;
	
	  var ret = state.length < state.highWaterMark;
	  // we must ensure that previous needDrain will not be reset to false.
	  if (!ret)
	    state.needDrain = true;
	
	  if (state.writing || state.corked)
	    state.buffer.push(new WriteReq(chunk, encoding, cb));
	  else
	    doWrite(stream, state, false, len, chunk, encoding, cb);
	
	  return ret;
	}
	
	function doWrite(stream, state, writev, len, chunk, encoding, cb) {
	  state.writelen = len;
	  state.writecb = cb;
	  state.writing = true;
	  state.sync = true;
	  if (writev)
	    stream._writev(chunk, state.onwrite);
	  else
	    stream._write(chunk, encoding, state.onwrite);
	  state.sync = false;
	}
	
	function onwriteError(stream, state, sync, er, cb) {
	  if (sync)
	    process.nextTick(function() {
	      state.pendingcb--;
	      cb(er);
	    });
	  else {
	    state.pendingcb--;
	    cb(er);
	  }
	
	  stream._writableState.errorEmitted = true;
	  stream.emit('error', er);
	}
	
	function onwriteStateUpdate(state) {
	  state.writing = false;
	  state.writecb = null;
	  state.length -= state.writelen;
	  state.writelen = 0;
	}
	
	function onwrite(stream, er) {
	  var state = stream._writableState;
	  var sync = state.sync;
	  var cb = state.writecb;
	
	  onwriteStateUpdate(state);
	
	  if (er)
	    onwriteError(stream, state, sync, er, cb);
	  else {
	    // Check if we're actually ready to finish, but don't emit yet
	    var finished = needFinish(stream, state);
	
	    if (!finished &&
	        !state.corked &&
	        !state.bufferProcessing &&
	        state.buffer.length) {
	      clearBuffer(stream, state);
	    }
	
	    if (sync) {
	      process.nextTick(function() {
	        afterWrite(stream, state, finished, cb);
	      });
	    } else {
	      afterWrite(stream, state, finished, cb);
	    }
	  }
	}
	
	function afterWrite(stream, state, finished, cb) {
	  if (!finished)
	    onwriteDrain(stream, state);
	  state.pendingcb--;
	  cb();
	  finishMaybe(stream, state);
	}
	
	// Must force callback to be called on nextTick, so that we don't
	// emit 'drain' before the write() consumer gets the 'false' return
	// value, and has a chance to attach a 'drain' listener.
	function onwriteDrain(stream, state) {
	  if (state.length === 0 && state.needDrain) {
	    state.needDrain = false;
	    stream.emit('drain');
	  }
	}
	
	
	// if there's something in the buffer waiting, then process it
	function clearBuffer(stream, state) {
	  state.bufferProcessing = true;
	
	  if (stream._writev && state.buffer.length > 1) {
	    // Fast case, write everything using _writev()
	    var cbs = [];
	    for (var c = 0; c < state.buffer.length; c++)
	      cbs.push(state.buffer[c].callback);
	
	    // count the one we are adding, as well.
	    // TODO(isaacs) clean this up
	    state.pendingcb++;
	    doWrite(stream, state, true, state.length, state.buffer, '', function(err) {
	      for (var i = 0; i < cbs.length; i++) {
	        state.pendingcb--;
	        cbs[i](err);
	      }
	    });
	
	    // Clear buffer
	    state.buffer = [];
	  } else {
	    // Slow case, write chunks one-by-one
	    for (var c = 0; c < state.buffer.length; c++) {
	      var entry = state.buffer[c];
	      var chunk = entry.chunk;
	      var encoding = entry.encoding;
	      var cb = entry.callback;
	      var len = state.objectMode ? 1 : chunk.length;
	
	      doWrite(stream, state, false, len, chunk, encoding, cb);
	
	      // if we didn't call the onwrite immediately, then
	      // it means that we need to wait until it does.
	      // also, that means that the chunk and cb are currently
	      // being processed, so move the buffer counter past them.
	      if (state.writing) {
	        c++;
	        break;
	      }
	    }
	
	    if (c < state.buffer.length)
	      state.buffer = state.buffer.slice(c);
	    else
	      state.buffer.length = 0;
	  }
	
	  state.bufferProcessing = false;
	}
	
	Writable.prototype._write = function(chunk, encoding, cb) {
	  cb(new Error('not implemented'));
	
	};
	
	Writable.prototype._writev = null;
	
	Writable.prototype.end = function(chunk, encoding, cb) {
	  var state = this._writableState;
	
	  if (util.isFunction(chunk)) {
	    cb = chunk;
	    chunk = null;
	    encoding = null;
	  } else if (util.isFunction(encoding)) {
	    cb = encoding;
	    encoding = null;
	  }
	
	  if (!util.isNullOrUndefined(chunk))
	    this.write(chunk, encoding);
	
	  // .end() fully uncorks
	  if (state.corked) {
	    state.corked = 1;
	    this.uncork();
	  }
	
	  // ignore unnecessary end() calls.
	  if (!state.ending && !state.finished)
	    endWritable(this, state, cb);
	};
	
	
	function needFinish(stream, state) {
	  return (state.ending &&
	          state.length === 0 &&
	          !state.finished &&
	          !state.writing);
	}
	
	function prefinish(stream, state) {
	  if (!state.prefinished) {
	    state.prefinished = true;
	    stream.emit('prefinish');
	  }
	}
	
	function finishMaybe(stream, state) {
	  var need = needFinish(stream, state);
	  if (need) {
	    if (state.pendingcb === 0) {
	      prefinish(stream, state);
	      state.finished = true;
	      stream.emit('finish');
	    } else
	      prefinish(stream, state);
	  }
	  return need;
	}
	
	function endWritable(stream, state, cb) {
	  state.ending = true;
	  finishMaybe(stream, state);
	  if (cb) {
	    if (state.finished)
	      process.nextTick(cb);
	    else
	      stream.once('finish', cb);
	  }
	  state.ended = true;
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3)))

/***/ },
/* 49 */
/***/ function(module, exports, __webpack_require__) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	
	// a transform stream is a readable/writable stream where you do
	// something with the data.  Sometimes it's called a "filter",
	// but that's not a great name for it, since that implies a thing where
	// some bits pass through, and others are simply ignored.  (That would
	// be a valid example of a transform, of course.)
	//
	// While the output is causally related to the input, it's not a
	// necessarily symmetric or synchronous transformation.  For example,
	// a zlib stream might take multiple plain-text writes(), and then
	// emit a single compressed chunk some time in the future.
	//
	// Here's how this works:
	//
	// The Transform stream has all the aspects of the readable and writable
	// stream classes.  When you write(chunk), that calls _write(chunk,cb)
	// internally, and returns false if there's a lot of pending writes
	// buffered up.  When you call read(), that calls _read(n) until
	// there's enough pending readable data buffered up.
	//
	// In a transform stream, the written data is placed in a buffer.  When
	// _read(n) is called, it transforms the queued up data, calling the
	// buffered _write cb's as it consumes chunks.  If consuming a single
	// written chunk would result in multiple output chunks, then the first
	// outputted bit calls the readcb, and subsequent chunks just go into
	// the read buffer, and will cause it to emit 'readable' if necessary.
	//
	// This way, back-pressure is actually determined by the reading side,
	// since _read has to be called to start processing a new chunk.  However,
	// a pathological inflate type of transform can cause excessive buffering
	// here.  For example, imagine a stream where every byte of input is
	// interpreted as an integer from 0-255, and then results in that many
	// bytes of output.  Writing the 4 bytes {ff,ff,ff,ff} would result in
	// 1kb of data being output.  In this case, you could write a very small
	// amount of input, and end up with a very large amount of output.  In
	// such a pathological inflating mechanism, there'd be no way to tell
	// the system to stop doing the transform.  A single 4MB write could
	// cause the system to run out of memory.
	//
	// However, even in such a pathological case, only a single written chunk
	// would be consumed, and then the rest would wait (un-transformed) until
	// the results of the previous transformed chunk were consumed.
	
	module.exports = Transform;
	
	var Duplex = __webpack_require__(47);
	
	/*<replacement>*/
	var util = __webpack_require__(45);
	util.inherits = __webpack_require__(41);
	/*</replacement>*/
	
	util.inherits(Transform, Duplex);
	
	
	function TransformState(options, stream) {
	  this.afterTransform = function(er, data) {
	    return afterTransform(stream, er, data);
	  };
	
	  this.needTransform = false;
	  this.transforming = false;
	  this.writecb = null;
	  this.writechunk = null;
	}
	
	function afterTransform(stream, er, data) {
	  var ts = stream._transformState;
	  ts.transforming = false;
	
	  var cb = ts.writecb;
	
	  if (!cb)
	    return stream.emit('error', new Error('no writecb in Transform class'));
	
	  ts.writechunk = null;
	  ts.writecb = null;
	
	  if (!util.isNullOrUndefined(data))
	    stream.push(data);
	
	  if (cb)
	    cb(er);
	
	  var rs = stream._readableState;
	  rs.reading = false;
	  if (rs.needReadable || rs.length < rs.highWaterMark) {
	    stream._read(rs.highWaterMark);
	  }
	}
	
	
	function Transform(options) {
	  if (!(this instanceof Transform))
	    return new Transform(options);
	
	  Duplex.call(this, options);
	
	  this._transformState = new TransformState(options, this);
	
	  // when the writable side finishes, then flush out anything remaining.
	  var stream = this;
	
	  // start out asking for a readable event once data is transformed.
	  this._readableState.needReadable = true;
	
	  // we have implemented the _read method, and done the other things
	  // that Readable wants before the first _read call, so unset the
	  // sync guard flag.
	  this._readableState.sync = false;
	
	  this.once('prefinish', function() {
	    if (util.isFunction(this._flush))
	      this._flush(function(er) {
	        done(stream, er);
	      });
	    else
	      done(stream);
	  });
	}
	
	Transform.prototype.push = function(chunk, encoding) {
	  this._transformState.needTransform = false;
	  return Duplex.prototype.push.call(this, chunk, encoding);
	};
	
	// This is the part where you do stuff!
	// override this function in implementation classes.
	// 'chunk' is an input chunk.
	//
	// Call `push(newChunk)` to pass along transformed output
	// to the readable side.  You may call 'push' zero or more times.
	//
	// Call `cb(err)` when you are done with this chunk.  If you pass
	// an error, then that'll put the hurt on the whole operation.  If you
	// never call cb(), then you'll never get another chunk.
	Transform.prototype._transform = function(chunk, encoding, cb) {
	  throw new Error('not implemented');
	};
	
	Transform.prototype._write = function(chunk, encoding, cb) {
	  var ts = this._transformState;
	  ts.writecb = cb;
	  ts.writechunk = chunk;
	  ts.writeencoding = encoding;
	  if (!ts.transforming) {
	    var rs = this._readableState;
	    if (ts.needTransform ||
	        rs.needReadable ||
	        rs.length < rs.highWaterMark)
	      this._read(rs.highWaterMark);
	  }
	};
	
	// Doesn't matter what the args are here.
	// _transform does all the work.
	// That we got here means that the readable side wants more data.
	Transform.prototype._read = function(n) {
	  var ts = this._transformState;
	
	  if (!util.isNull(ts.writechunk) && ts.writecb && !ts.transforming) {
	    ts.transforming = true;
	    this._transform(ts.writechunk, ts.writeencoding, ts.afterTransform);
	  } else {
	    // mark that we need a transform, so that any data that comes in
	    // will get processed, now that we've asked for it.
	    ts.needTransform = true;
	  }
	};
	
	
	function done(stream, er) {
	  if (er)
	    return stream.emit('error', er);
	
	  // if there's nothing in the write buffer, then that means
	  // that nothing more will ever be provided
	  var ws = stream._writableState;
	  var ts = stream._transformState;
	
	  if (ws.length)
	    throw new Error('calling transform done when ws.length != 0');
	
	  if (ts.transforming)
	    throw new Error('calling transform done when still transforming');
	
	  return stream.push(null);
	}


/***/ },
/* 50 */
/***/ function(module, exports, __webpack_require__) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	// a passthrough stream.
	// basically just the most minimal sort of Transform stream.
	// Every written chunk gets output as-is.
	
	module.exports = PassThrough;
	
	var Transform = __webpack_require__(49);
	
	/*<replacement>*/
	var util = __webpack_require__(45);
	util.inherits = __webpack_require__(41);
	/*</replacement>*/
	
	util.inherits(PassThrough, Transform);
	
	function PassThrough(options) {
	  if (!(this instanceof PassThrough))
	    return new PassThrough(options);
	
	  Transform.call(this, options);
	}
	
	PassThrough.prototype._transform = function(chunk, encoding, cb) {
	  cb(null, chunk);
	};


/***/ },
/* 51 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(48)


/***/ },
/* 52 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(47)


/***/ },
/* 53 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(49)


/***/ },
/* 54 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(50)


/***/ },
/* 55 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {"use strict"
	
	// == Extend Node primitives to use iconv-lite =================================
	
	module.exports = function (iconv) {
	    var original = undefined; // Place to keep original methods.
	
	    // Node authors rewrote Buffer internals to make it compatible with
	    // Uint8Array and we cannot patch key functions since then.
	    iconv.supportsNodeEncodingsExtension = !(new Buffer(0) instanceof Uint8Array);
	
	    iconv.extendNodeEncodings = function extendNodeEncodings() {
	        if (original) return;
	        original = {};
	
	        if (!iconv.supportsNodeEncodingsExtension) {
	            console.error("ACTION NEEDED: require('iconv-lite').extendNodeEncodings() is not supported in your version of Node");
	            console.error("See more info at https://github.com/ashtuchkin/iconv-lite/wiki/Node-v4-compatibility");
	            return;
	        }
	
	        var nodeNativeEncodings = {
	            'hex': true, 'utf8': true, 'utf-8': true, 'ascii': true, 'binary': true, 
	            'base64': true, 'ucs2': true, 'ucs-2': true, 'utf16le': true, 'utf-16le': true,
	        };
	
	        Buffer.isNativeEncoding = function(enc) {
	            return enc && nodeNativeEncodings[enc.toLowerCase()];
	        }
	
	        // -- SlowBuffer -----------------------------------------------------------
	        var SlowBuffer = __webpack_require__(20).SlowBuffer;
	
	        original.SlowBufferToString = SlowBuffer.prototype.toString;
	        SlowBuffer.prototype.toString = function(encoding, start, end) {
	            encoding = String(encoding || 'utf8').toLowerCase();
	
	            // Use native conversion when possible
	            if (Buffer.isNativeEncoding(encoding))
	                return original.SlowBufferToString.call(this, encoding, start, end);
	
	            // Otherwise, use our decoding method.
	            if (typeof start == 'undefined') start = 0;
	            if (typeof end == 'undefined') end = this.length;
	            return iconv.decode(this.slice(start, end), encoding);
	        }
	
	        original.SlowBufferWrite = SlowBuffer.prototype.write;
	        SlowBuffer.prototype.write = function(string, offset, length, encoding) {
	            // Support both (string, offset, length, encoding)
	            // and the legacy (string, encoding, offset, length)
	            if (isFinite(offset)) {
	                if (!isFinite(length)) {
	                    encoding = length;
	                    length = undefined;
	                }
	            } else {  // legacy
	                var swap = encoding;
	                encoding = offset;
	                offset = length;
	                length = swap;
	            }
	
	            offset = +offset || 0;
	            var remaining = this.length - offset;
	            if (!length) {
	                length = remaining;
	            } else {
	                length = +length;
	                if (length > remaining) {
	                    length = remaining;
	                }
	            }
	            encoding = String(encoding || 'utf8').toLowerCase();
	
	            // Use native conversion when possible
	            if (Buffer.isNativeEncoding(encoding))
	                return original.SlowBufferWrite.call(this, string, offset, length, encoding);
	
	            if (string.length > 0 && (length < 0 || offset < 0))
	                throw new RangeError('attempt to write beyond buffer bounds');
	
	            // Otherwise, use our encoding method.
	            var buf = iconv.encode(string, encoding);
	            if (buf.length < length) length = buf.length;
	            buf.copy(this, offset, 0, length);
	            return length;
	        }
	
	        // -- Buffer ---------------------------------------------------------------
	
	        original.BufferIsEncoding = Buffer.isEncoding;
	        Buffer.isEncoding = function(encoding) {
	            return Buffer.isNativeEncoding(encoding) || iconv.encodingExists(encoding);
	        }
	
	        original.BufferByteLength = Buffer.byteLength;
	        Buffer.byteLength = SlowBuffer.byteLength = function(str, encoding) {
	            encoding = String(encoding || 'utf8').toLowerCase();
	
	            // Use native conversion when possible
	            if (Buffer.isNativeEncoding(encoding))
	                return original.BufferByteLength.call(this, str, encoding);
	
	            // Slow, I know, but we don't have a better way yet.
	            return iconv.encode(str, encoding).length;
	        }
	
	        original.BufferToString = Buffer.prototype.toString;
	        Buffer.prototype.toString = function(encoding, start, end) {
	            encoding = String(encoding || 'utf8').toLowerCase();
	
	            // Use native conversion when possible
	            if (Buffer.isNativeEncoding(encoding))
	                return original.BufferToString.call(this, encoding, start, end);
	
	            // Otherwise, use our decoding method.
	            if (typeof start == 'undefined') start = 0;
	            if (typeof end == 'undefined') end = this.length;
	            return iconv.decode(this.slice(start, end), encoding);
	        }
	
	        original.BufferWrite = Buffer.prototype.write;
	        Buffer.prototype.write = function(string, offset, length, encoding) {
	            var _offset = offset, _length = length, _encoding = encoding;
	            // Support both (string, offset, length, encoding)
	            // and the legacy (string, encoding, offset, length)
	            if (isFinite(offset)) {
	                if (!isFinite(length)) {
	                    encoding = length;
	                    length = undefined;
	                }
	            } else {  // legacy
	                var swap = encoding;
	                encoding = offset;
	                offset = length;
	                length = swap;
	            }
	
	            encoding = String(encoding || 'utf8').toLowerCase();
	
	            // Use native conversion when possible
	            if (Buffer.isNativeEncoding(encoding))
	                return original.BufferWrite.call(this, string, _offset, _length, _encoding);
	
	            offset = +offset || 0;
	            var remaining = this.length - offset;
	            if (!length) {
	                length = remaining;
	            } else {
	                length = +length;
	                if (length > remaining) {
	                    length = remaining;
	                }
	            }
	
	            if (string.length > 0 && (length < 0 || offset < 0))
	                throw new RangeError('attempt to write beyond buffer bounds');
	
	            // Otherwise, use our encoding method.
	            var buf = iconv.encode(string, encoding);
	            if (buf.length < length) length = buf.length;
	            buf.copy(this, offset, 0, length);
	            return length;
	
	            // TODO: Set _charsWritten.
	        }
	
	
	        // -- Readable -------------------------------------------------------------
	        if (iconv.supportsStreams) {
	            var Readable = __webpack_require__(39).Readable;
	
	            original.ReadableSetEncoding = Readable.prototype.setEncoding;
	            Readable.prototype.setEncoding = function setEncoding(enc, options) {
	                // Use our own decoder, it has the same interface.
	                // We cannot use original function as it doesn't handle BOM-s.
	                this._readableState.decoder = iconv.getDecoder(enc, options);
	                this._readableState.encoding = enc;
	            }
	
	            Readable.prototype.collect = iconv._collect;
	        }
	    }
	
	    // Remove iconv-lite Node primitive extensions.
	    iconv.undoExtendNodeEncodings = function undoExtendNodeEncodings() {
	        if (!iconv.supportsNodeEncodingsExtension)
	            return;
	        if (!original)
	            throw new Error("require('iconv-lite').undoExtendNodeEncodings(): Nothing to undo; extendNodeEncodings() is not called.")
	
	        delete Buffer.isNativeEncoding;
	
	        var SlowBuffer = __webpack_require__(20).SlowBuffer;
	
	        SlowBuffer.prototype.toString = original.SlowBufferToString;
	        SlowBuffer.prototype.write = original.SlowBufferWrite;
	
	        Buffer.isEncoding = original.BufferIsEncoding;
	        Buffer.byteLength = original.BufferByteLength;
	        Buffer.prototype.toString = original.BufferToString;
	        Buffer.prototype.write = original.BufferWrite;
	
	        if (iconv.supportsStreams) {
	            var Readable = __webpack_require__(39).Readable;
	
	            Readable.prototype.setEncoding = original.ReadableSetEncoding;
	            delete Readable.prototype.collect;
	        }
	
	        original = undefined;
	    }
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(9).Buffer))

/***/ },
/* 56 */
/***/ function(module, exports, __webpack_require__) {

	// Generated by CoffeeScript 1.11.1
	(function() {
	  var Util;
	
	  Util = __webpack_require__(57);
	
	  module.exports = {
	    cmykToRgb: function(c, m, y, k) {
	      var b, g, r;
	      r = Util.clamp((65535 - (c * (255 - k) + (k << 8))) >> 8, 0, 255);
	      g = Util.clamp((65535 - (m * (255 - k) + (k << 8))) >> 8, 0, 255);
	      b = Util.clamp((65535 - (y * (255 - k) + (k << 8))) >> 8, 0, 255);
	      return [r, g, b];
	    }
	  };
	
	}).call(this);


/***/ },
/* 57 */
/***/ function(module, exports) {

	// Generated by CoffeeScript 1.11.1
	(function() {
	  module.exports = {
	    pad2: function(i) {
	      return (i + 1) & ~0x01;
	    },
	    pad4: function(i) {
	      return ((i + 4) & ~0x03) - 1;
	    },
	    getUnicodeCharacter: function(cp) {
	      var first, second;
	      if (cp >= 0 && cp <= 0xD7FF || cp >= 0xE000 && cp <= 0xFFFF) {
	        return String.fromCharCode(cp);
	      } else if (cp >= 0x10000 && cp <= 0x10FFFF) {
	        cp -= 0x10000;
	        first = ((0xffc00 & cp) >> 10) + 0xD800;
	        second = (0x3ff & cp) + 0xDC00;
	        return String.fromCharCode(first) + String.fromCharCode(second);
	      }
	    },
	    clamp: function(num, min, max) {
	      return Math.min(Math.max(num, min), max);
	    }
	  };
	
	}).call(this);


/***/ },
/* 58 */
/***/ function(module, exports) {

	// Generated by CoffeeScript 1.11.1
	(function() {
	  var LazyExecute,
	    slice = [].slice,
	    indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };
	
	  module.exports = LazyExecute = (function() {
	    function LazyExecute(obj, file) {
	      this.obj = obj;
	      this.file = file;
	      this.startPos = this.file.tell();
	      this.loaded = false;
	      this.loadMethod = null;
	      this.loadArgs = [];
	      this.passthru = [];
	    }
	
	    LazyExecute.prototype.now = function() {
	      var args, method;
	      method = arguments[0], args = 2 <= arguments.length ? slice.call(arguments, 1) : [];
	      this.obj[method].apply(this.obj, args);
	      return this;
	    };
	
	    LazyExecute.prototype.later = function() {
	      var args, method;
	      method = arguments[0], args = 2 <= arguments.length ? slice.call(arguments, 1) : [];
	      this.loadMethod = method;
	      this.loadArgs = args;
	      return this;
	    };
	
	    LazyExecute.prototype.ignore = function() {
	      var args;
	      args = 1 <= arguments.length ? slice.call(arguments, 0) : [];
	      this.passthru.concat(args);
	      return this;
	    };
	
	    LazyExecute.prototype.get = function() {
	      var fn, key, ref, val;
	      ref = this.obj;
	      fn = (function(_this) {
	        return function(key, val) {
	          if (_this[key] != null) {
	            return;
	          }
	          return Object.defineProperty(_this, key, {
	            get: function() {
	              if (!this.loaded && !(indexOf.call(this.passthru, key) >= 0)) {
	                this.load();
	              }
	              return this.obj[key];
	            }
	          });
	        };
	      })(this);
	      for (key in ref) {
	        val = ref[key];
	        fn(key, val);
	      }
	      return this;
	    };
	
	    LazyExecute.prototype.load = function() {
	      var origPos;
	      origPos = this.file.tell();
	      this.file.seek(this.startPos);
	      this.obj[this.loadMethod].apply(this.obj, this.loadArgs);
	      this.file.seek(origPos);
	      return this.loaded = true;
	    };
	
	    return LazyExecute;
	
	  })();
	
	}).call(this);


/***/ },
/* 59 */
/***/ function(module, exports, __webpack_require__) {

	// Generated by CoffeeScript 1.11.1
	(function() {
	  var Header, Module,
	    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
	    hasProp = {}.hasOwnProperty;
	
	  Module = __webpack_require__(6).Module;
	
	  module.exports = Header = (function(superClass) {
	    var MODES;
	
	    extend(Header, superClass);
	
	    Header.aliasProperty('height', 'rows');
	
	    Header.aliasProperty('width', 'cols');
	
	    MODES = ['Bitmap', 'GrayScale', 'IndexedColor', 'RGBColor', 'CMYKColor', 'HSLColor', 'HSBColor', 'Multichannel', 'Duotone', 'LabColor', 'Gray16', 'RGB48', 'Lab48', 'CMYK64', 'DeepMultichannel', 'Duotone16'];
	
	    Header.prototype.sig = null;
	
	    Header.prototype.version = null;
	
	    Header.prototype.channels = null;
	
	    Header.prototype.rows = null;
	
	    Header.prototype.cols = null;
	
	    Header.prototype.depth = null;
	
	    Header.prototype.mode = null;
	
	    function Header(file) {
	      this.file = file;
	    }
	
	    Header.prototype.parse = function() {
	      var colorDataLen;
	      this.sig = this.file.readString(4);
	      if (this.sig !== '8BPS') {
	        throw new Error('Invalid file signature detected. Got: ' + this.sig + '. Expected 8BPS.');
	      }
	      this.version = this.file.readUShort();
	      this.file.seek(6, true);
	      this.channels = this.file.readUShort();
	      this.rows = this.height = this.file.readUInt();
	      this.cols = this.width = this.file.readUInt();
	      this.depth = this.file.readUShort();
	      this.mode = this.file.readUShort();
	      colorDataLen = this.file.readUInt();
	      return this.file.seek(colorDataLen, true);
	    };
	
	    Header.prototype.modeName = function() {
	      return MODES[this.mode];
	    };
	
	    Header.prototype["export"] = function() {
	      var data, i, key, len, ref;
	      data = {};
	      ref = ['sig', 'version', 'channels', 'rows', 'cols', 'depth', 'mode'];
	      for (i = 0, len = ref.length; i < len; i++) {
	        key = ref[i];
	        data[key] = this[key];
	      }
	      return data;
	    };
	
	    return Header;
	
	  })(Module);
	
	}).call(this);


/***/ },
/* 60 */
/***/ function(module, exports, __webpack_require__) {

	// Generated by CoffeeScript 1.11.1
	(function() {
	  var Resource, Resources;
	
	  Resource = __webpack_require__(61);
	
	  module.exports = Resources = (function() {
	    function Resources(file) {
	      this.file = file;
	      this.resources = {};
	      this.typeIndex = {};
	      this.length = null;
	    }
	
	    Resources.prototype.skip = function() {
	      this.length = this.file.readInt();
	      return this.file.seek(this.length, true);
	    };
	
	    Resources.prototype.parse = function() {
	      var finish, resource, resourceEnd, section;
	      this.length = this.file.readInt();
	      finish = this.length + this.file.tell();
	      while (this.file.tell() < finish) {
	        resource = new Resource(this.file);
	        resource.parse();
	        resourceEnd = this.file.tell() + resource.length;
	        section = Resource.Section.factory(resource);
	        if (section == null) {
	          this.file.seek(resourceEnd);
	          continue;
	        }
	        this.resources[section.id] = section;
	        if (section.name != null) {
	          this.typeIndex[section.name] = section.id;
	        }
	        this.file.seek(resourceEnd);
	      }
	      return this.file.seek(finish);
	    };
	
	    Resources.prototype.resource = function(search) {
	      if (typeof search === 'string') {
	        return this.byType(search);
	      } else {
	        return this.resources[search];
	      }
	    };
	
	    Resources.prototype.byType = function(name) {
	      return this.resources[this.typeIndex[name]];
	    };
	
	    return Resources;
	
	  })();
	
	}).call(this);


/***/ },
/* 61 */
/***/ function(module, exports, __webpack_require__) {

	// Generated by CoffeeScript 1.11.1
	(function() {
	  var Resource, Util;
	
	  Util = __webpack_require__(57);
	
	  module.exports = Resource = (function() {
	    Resource.Section = __webpack_require__(62);
	
	    function Resource(file) {
	      this.file = file;
	      this.id = null;
	      this.type = null;
	      this.length = 0;
	    }
	
	    Resource.prototype.parse = function() {
	      var nameLength;
	      this.type = this.file.readString(4);
	      this.id = this.file.readShort();
	      nameLength = Util.pad2(this.file.readByte() + 1) - 1;
	      this.name = this.file.readString(nameLength);
	      return this.length = Util.pad2(this.file.readInt());
	    };
	
	    return Resource;
	
	  })();
	
	}).call(this);


/***/ },
/* 62 */
/***/ function(module, exports, __webpack_require__) {

	// Generated by CoffeeScript 1.11.1
	(function() {
	  var ResourceSection, _,
	    indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };
	
	  _ = __webpack_require__(63);
	
	  module.exports = ResourceSection = (function() {
	    var RESOURCES;
	
	    function ResourceSection() {}
	
	    RESOURCES = [__webpack_require__(65), __webpack_require__(67), __webpack_require__(68), __webpack_require__(69), __webpack_require__(70), __webpack_require__(71), __webpack_require__(72), __webpack_require__(73), __webpack_require__(75)];
	
	    ResourceSection.factory = function(resource) {
	      var Section, i, j, len, ref, results;
	      for (i = 0, len = RESOURCES.length; i < len; i++) {
	        Section = RESOURCES[i];
	        if (Section.prototype.id === resource.id) {
	          return _.tap(new Section(resource), function(s) {
	            return s.parse();
	          });
	        }
	        if ((ref = resource.id, indexOf.call((function() {
	          results = [];
	          for (j = 2000; j < 2998; j++){ results.push(j); }
	          return results;
	        }).apply(this), ref) >= 0) && Section.prototype.id === 2000) {
	          return _.tap(new Section(resource), function(s) {
	            return s.parse();
	          });
	        }
	        continue;
	      }
	      return null;
	    };
	
	    return ResourceSection;
	
	  })();
	
	}).call(this);


/***/ },
/* 63 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(global, module) {/**
	 * @license
	 * Lodash <https://lodash.com/>
	 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
	 * Released under MIT license <https://lodash.com/license>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 */
	;(function() {
	
	  /** Used as a safe reference for `undefined` in pre-ES5 environments. */
	  var undefined;
	
	  /** Used as the semantic version number. */
	  var VERSION = '4.17.15';
	
	  /** Used as the size to enable large array optimizations. */
	  var LARGE_ARRAY_SIZE = 200;
	
	  /** Error message constants. */
	  var CORE_ERROR_TEXT = 'Unsupported core-js use. Try https://npms.io/search?q=ponyfill.',
	      FUNC_ERROR_TEXT = 'Expected a function';
	
	  /** Used to stand-in for `undefined` hash values. */
	  var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	  /** Used as the maximum memoize cache size. */
	  var MAX_MEMOIZE_SIZE = 500;
	
	  /** Used as the internal argument placeholder. */
	  var PLACEHOLDER = '__lodash_placeholder__';
	
	  /** Used to compose bitmasks for cloning. */
	  var CLONE_DEEP_FLAG = 1,
	      CLONE_FLAT_FLAG = 2,
	      CLONE_SYMBOLS_FLAG = 4;
	
	  /** Used to compose bitmasks for value comparisons. */
	  var COMPARE_PARTIAL_FLAG = 1,
	      COMPARE_UNORDERED_FLAG = 2;
	
	  /** Used to compose bitmasks for function metadata. */
	  var WRAP_BIND_FLAG = 1,
	      WRAP_BIND_KEY_FLAG = 2,
	      WRAP_CURRY_BOUND_FLAG = 4,
	      WRAP_CURRY_FLAG = 8,
	      WRAP_CURRY_RIGHT_FLAG = 16,
	      WRAP_PARTIAL_FLAG = 32,
	      WRAP_PARTIAL_RIGHT_FLAG = 64,
	      WRAP_ARY_FLAG = 128,
	      WRAP_REARG_FLAG = 256,
	      WRAP_FLIP_FLAG = 512;
	
	  /** Used as default options for `_.truncate`. */
	  var DEFAULT_TRUNC_LENGTH = 30,
	      DEFAULT_TRUNC_OMISSION = '...';
	
	  /** Used to detect hot functions by number of calls within a span of milliseconds. */
	  var HOT_COUNT = 800,
	      HOT_SPAN = 16;
	
	  /** Used to indicate the type of lazy iteratees. */
	  var LAZY_FILTER_FLAG = 1,
	      LAZY_MAP_FLAG = 2,
	      LAZY_WHILE_FLAG = 3;
	
	  /** Used as references for various `Number` constants. */
	  var INFINITY = 1 / 0,
	      MAX_SAFE_INTEGER = 9007199254740991,
	      MAX_INTEGER = 1.7976931348623157e+308,
	      NAN = 0 / 0;
	
	  /** Used as references for the maximum length and index of an array. */
	  var MAX_ARRAY_LENGTH = 4294967295,
	      MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1,
	      HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;
	
	  /** Used to associate wrap methods with their bit flags. */
	  var wrapFlags = [
	    ['ary', WRAP_ARY_FLAG],
	    ['bind', WRAP_BIND_FLAG],
	    ['bindKey', WRAP_BIND_KEY_FLAG],
	    ['curry', WRAP_CURRY_FLAG],
	    ['curryRight', WRAP_CURRY_RIGHT_FLAG],
	    ['flip', WRAP_FLIP_FLAG],
	    ['partial', WRAP_PARTIAL_FLAG],
	    ['partialRight', WRAP_PARTIAL_RIGHT_FLAG],
	    ['rearg', WRAP_REARG_FLAG]
	  ];
	
	  /** `Object#toString` result references. */
	  var argsTag = '[object Arguments]',
	      arrayTag = '[object Array]',
	      asyncTag = '[object AsyncFunction]',
	      boolTag = '[object Boolean]',
	      dateTag = '[object Date]',
	      domExcTag = '[object DOMException]',
	      errorTag = '[object Error]',
	      funcTag = '[object Function]',
	      genTag = '[object GeneratorFunction]',
	      mapTag = '[object Map]',
	      numberTag = '[object Number]',
	      nullTag = '[object Null]',
	      objectTag = '[object Object]',
	      promiseTag = '[object Promise]',
	      proxyTag = '[object Proxy]',
	      regexpTag = '[object RegExp]',
	      setTag = '[object Set]',
	      stringTag = '[object String]',
	      symbolTag = '[object Symbol]',
	      undefinedTag = '[object Undefined]',
	      weakMapTag = '[object WeakMap]',
	      weakSetTag = '[object WeakSet]';
	
	  var arrayBufferTag = '[object ArrayBuffer]',
	      dataViewTag = '[object DataView]',
	      float32Tag = '[object Float32Array]',
	      float64Tag = '[object Float64Array]',
	      int8Tag = '[object Int8Array]',
	      int16Tag = '[object Int16Array]',
	      int32Tag = '[object Int32Array]',
	      uint8Tag = '[object Uint8Array]',
	      uint8ClampedTag = '[object Uint8ClampedArray]',
	      uint16Tag = '[object Uint16Array]',
	      uint32Tag = '[object Uint32Array]';
	
	  /** Used to match empty string literals in compiled template source. */
	  var reEmptyStringLeading = /\b__p \+= '';/g,
	      reEmptyStringMiddle = /\b(__p \+=) '' \+/g,
	      reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;
	
	  /** Used to match HTML entities and HTML characters. */
	  var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g,
	      reUnescapedHtml = /[&<>"']/g,
	      reHasEscapedHtml = RegExp(reEscapedHtml.source),
	      reHasUnescapedHtml = RegExp(reUnescapedHtml.source);
	
	  /** Used to match template delimiters. */
	  var reEscape = /<%-([\s\S]+?)%>/g,
	      reEvaluate = /<%([\s\S]+?)%>/g,
	      reInterpolate = /<%=([\s\S]+?)%>/g;
	
	  /** Used to match property names within property paths. */
	  var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
	      reIsPlainProp = /^\w*$/,
	      rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
	
	  /**
	   * Used to match `RegExp`
	   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
	   */
	  var reRegExpChar = /[\\^$.*+?()[\]{}|]/g,
	      reHasRegExpChar = RegExp(reRegExpChar.source);
	
	  /** Used to match leading and trailing whitespace. */
	  var reTrim = /^\s+|\s+$/g,
	      reTrimStart = /^\s+/,
	      reTrimEnd = /\s+$/;
	
	  /** Used to match wrap detail comments. */
	  var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/,
	      reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/,
	      reSplitDetails = /,? & /;
	
	  /** Used to match words composed of alphanumeric characters. */
	  var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
	
	  /** Used to match backslashes in property paths. */
	  var reEscapeChar = /\\(\\)?/g;
	
	  /**
	   * Used to match
	   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
	   */
	  var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;
	
	  /** Used to match `RegExp` flags from their coerced string values. */
	  var reFlags = /\w*$/;
	
	  /** Used to detect bad signed hexadecimal string values. */
	  var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
	
	  /** Used to detect binary string values. */
	  var reIsBinary = /^0b[01]+$/i;
	
	  /** Used to detect host constructors (Safari). */
	  var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	  /** Used to detect octal string values. */
	  var reIsOctal = /^0o[0-7]+$/i;
	
	  /** Used to detect unsigned integer values. */
	  var reIsUint = /^(?:0|[1-9]\d*)$/;
	
	  /** Used to match Latin Unicode letters (excluding mathematical operators). */
	  var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
	
	  /** Used to ensure capturing order of template delimiters. */
	  var reNoMatch = /($^)/;
	
	  /** Used to match unescaped characters in compiled string literals. */
	  var reUnescapedString = /['\n\r\u2028\u2029\\]/g;
	
	  /** Used to compose unicode character classes. */
	  var rsAstralRange = '\\ud800-\\udfff',
	      rsComboMarksRange = '\\u0300-\\u036f',
	      reComboHalfMarksRange = '\\ufe20-\\ufe2f',
	      rsComboSymbolsRange = '\\u20d0-\\u20ff',
	      rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
	      rsDingbatRange = '\\u2700-\\u27bf',
	      rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff',
	      rsMathOpRange = '\\xac\\xb1\\xd7\\xf7',
	      rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf',
	      rsPunctuationRange = '\\u2000-\\u206f',
	      rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000',
	      rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde',
	      rsVarRange = '\\ufe0e\\ufe0f',
	      rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;
	
	  /** Used to compose unicode capture groups. */
	  var rsApos = "['\u2019]",
	      rsAstral = '[' + rsAstralRange + ']',
	      rsBreak = '[' + rsBreakRange + ']',
	      rsCombo = '[' + rsComboRange + ']',
	      rsDigits = '\\d+',
	      rsDingbat = '[' + rsDingbatRange + ']',
	      rsLower = '[' + rsLowerRange + ']',
	      rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']',
	      rsFitz = '\\ud83c[\\udffb-\\udfff]',
	      rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
	      rsNonAstral = '[^' + rsAstralRange + ']',
	      rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
	      rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
	      rsUpper = '[' + rsUpperRange + ']',
	      rsZWJ = '\\u200d';
	
	  /** Used to compose unicode regexes. */
	  var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')',
	      rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')',
	      rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?',
	      rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?',
	      reOptMod = rsModifier + '?',
	      rsOptVar = '[' + rsVarRange + ']?',
	      rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
	      rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])',
	      rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])',
	      rsSeq = rsOptVar + reOptMod + rsOptJoin,
	      rsEmoji = '(?:' + [rsDingbat, rsRegional, rsSurrPair].join('|') + ')' + rsSeq,
	      rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';
	
	  /** Used to match apostrophes. */
	  var reApos = RegExp(rsApos, 'g');
	
	  /**
	   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
	   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
	   */
	  var reComboMark = RegExp(rsCombo, 'g');
	
	  /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
	  var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');
	
	  /** Used to match complex or compound words. */
	  var reUnicodeWord = RegExp([
	    rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [rsBreak, rsUpper, '$'].join('|') + ')',
	    rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [rsBreak, rsUpper + rsMiscLower, '$'].join('|') + ')',
	    rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
	    rsUpper + '+' + rsOptContrUpper,
	    rsOrdUpper,
	    rsOrdLower,
	    rsDigits,
	    rsEmoji
	  ].join('|'), 'g');
	
	  /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
	  var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange  + rsComboRange + rsVarRange + ']');
	
	  /** Used to detect strings that need a more robust regexp to match words. */
	  var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
	
	  /** Used to assign default `context` object properties. */
	  var contextProps = [
	    'Array', 'Buffer', 'DataView', 'Date', 'Error', 'Float32Array', 'Float64Array',
	    'Function', 'Int8Array', 'Int16Array', 'Int32Array', 'Map', 'Math', 'Object',
	    'Promise', 'RegExp', 'Set', 'String', 'Symbol', 'TypeError', 'Uint8Array',
	    'Uint8ClampedArray', 'Uint16Array', 'Uint32Array', 'WeakMap',
	    '_', 'clearTimeout', 'isFinite', 'parseInt', 'setTimeout'
	  ];
	
	  /** Used to make template sourceURLs easier to identify. */
	  var templateCounter = -1;
	
	  /** Used to identify `toStringTag` values of typed arrays. */
	  var typedArrayTags = {};
	  typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
	  typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
	  typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
	  typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
	  typedArrayTags[uint32Tag] = true;
	  typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
	  typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
	  typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
	  typedArrayTags[errorTag] = typedArrayTags[funcTag] =
	  typedArrayTags[mapTag] = typedArrayTags[numberTag] =
	  typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
	  typedArrayTags[setTag] = typedArrayTags[stringTag] =
	  typedArrayTags[weakMapTag] = false;
	
	  /** Used to identify `toStringTag` values supported by `_.clone`. */
	  var cloneableTags = {};
	  cloneableTags[argsTag] = cloneableTags[arrayTag] =
	  cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
	  cloneableTags[boolTag] = cloneableTags[dateTag] =
	  cloneableTags[float32Tag] = cloneableTags[float64Tag] =
	  cloneableTags[int8Tag] = cloneableTags[int16Tag] =
	  cloneableTags[int32Tag] = cloneableTags[mapTag] =
	  cloneableTags[numberTag] = cloneableTags[objectTag] =
	  cloneableTags[regexpTag] = cloneableTags[setTag] =
	  cloneableTags[stringTag] = cloneableTags[symbolTag] =
	  cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
	  cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
	  cloneableTags[errorTag] = cloneableTags[funcTag] =
	  cloneableTags[weakMapTag] = false;
	
	  /** Used to map Latin Unicode letters to basic Latin letters. */
	  var deburredLetters = {
	    // Latin-1 Supplement block.
	    '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
	    '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
	    '\xc7': 'C',  '\xe7': 'c',
	    '\xd0': 'D',  '\xf0': 'd',
	    '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
	    '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
	    '\xcc': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
	    '\xec': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
	    '\xd1': 'N',  '\xf1': 'n',
	    '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
	    '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
	    '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
	    '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
	    '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
	    '\xc6': 'Ae', '\xe6': 'ae',
	    '\xde': 'Th', '\xfe': 'th',
	    '\xdf': 'ss',
	    // Latin Extended-A block.
	    '\u0100': 'A',  '\u0102': 'A', '\u0104': 'A',
	    '\u0101': 'a',  '\u0103': 'a', '\u0105': 'a',
	    '\u0106': 'C',  '\u0108': 'C', '\u010a': 'C', '\u010c': 'C',
	    '\u0107': 'c',  '\u0109': 'c', '\u010b': 'c', '\u010d': 'c',
	    '\u010e': 'D',  '\u0110': 'D', '\u010f': 'd', '\u0111': 'd',
	    '\u0112': 'E',  '\u0114': 'E', '\u0116': 'E', '\u0118': 'E', '\u011a': 'E',
	    '\u0113': 'e',  '\u0115': 'e', '\u0117': 'e', '\u0119': 'e', '\u011b': 'e',
	    '\u011c': 'G',  '\u011e': 'G', '\u0120': 'G', '\u0122': 'G',
	    '\u011d': 'g',  '\u011f': 'g', '\u0121': 'g', '\u0123': 'g',
	    '\u0124': 'H',  '\u0126': 'H', '\u0125': 'h', '\u0127': 'h',
	    '\u0128': 'I',  '\u012a': 'I', '\u012c': 'I', '\u012e': 'I', '\u0130': 'I',
	    '\u0129': 'i',  '\u012b': 'i', '\u012d': 'i', '\u012f': 'i', '\u0131': 'i',
	    '\u0134': 'J',  '\u0135': 'j',
	    '\u0136': 'K',  '\u0137': 'k', '\u0138': 'k',
	    '\u0139': 'L',  '\u013b': 'L', '\u013d': 'L', '\u013f': 'L', '\u0141': 'L',
	    '\u013a': 'l',  '\u013c': 'l', '\u013e': 'l', '\u0140': 'l', '\u0142': 'l',
	    '\u0143': 'N',  '\u0145': 'N', '\u0147': 'N', '\u014a': 'N',
	    '\u0144': 'n',  '\u0146': 'n', '\u0148': 'n', '\u014b': 'n',
	    '\u014c': 'O',  '\u014e': 'O', '\u0150': 'O',
	    '\u014d': 'o',  '\u014f': 'o', '\u0151': 'o',
	    '\u0154': 'R',  '\u0156': 'R', '\u0158': 'R',
	    '\u0155': 'r',  '\u0157': 'r', '\u0159': 'r',
	    '\u015a': 'S',  '\u015c': 'S', '\u015e': 'S', '\u0160': 'S',
	    '\u015b': 's',  '\u015d': 's', '\u015f': 's', '\u0161': 's',
	    '\u0162': 'T',  '\u0164': 'T', '\u0166': 'T',
	    '\u0163': 't',  '\u0165': 't', '\u0167': 't',
	    '\u0168': 'U',  '\u016a': 'U', '\u016c': 'U', '\u016e': 'U', '\u0170': 'U', '\u0172': 'U',
	    '\u0169': 'u',  '\u016b': 'u', '\u016d': 'u', '\u016f': 'u', '\u0171': 'u', '\u0173': 'u',
	    '\u0174': 'W',  '\u0175': 'w',
	    '\u0176': 'Y',  '\u0177': 'y', '\u0178': 'Y',
	    '\u0179': 'Z',  '\u017b': 'Z', '\u017d': 'Z',
	    '\u017a': 'z',  '\u017c': 'z', '\u017e': 'z',
	    '\u0132': 'IJ', '\u0133': 'ij',
	    '\u0152': 'Oe', '\u0153': 'oe',
	    '\u0149': "'n", '\u017f': 's'
	  };
	
	  /** Used to map characters to HTML entities. */
	  var htmlEscapes = {
	    '&': '&amp;',
	    '<': '&lt;',
	    '>': '&gt;',
	    '"': '&quot;',
	    "'": '&#39;'
	  };
	
	  /** Used to map HTML entities to characters. */
	  var htmlUnescapes = {
	    '&amp;': '&',
	    '&lt;': '<',
	    '&gt;': '>',
	    '&quot;': '"',
	    '&#39;': "'"
	  };
	
	  /** Used to escape characters for inclusion in compiled string literals. */
	  var stringEscapes = {
	    '\\': '\\',
	    "'": "'",
	    '\n': 'n',
	    '\r': 'r',
	    '\u2028': 'u2028',
	    '\u2029': 'u2029'
	  };
	
	  /** Built-in method references without a dependency on `root`. */
	  var freeParseFloat = parseFloat,
	      freeParseInt = parseInt;
	
	  /** Detect free variable `global` from Node.js. */
	  var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	  /** Detect free variable `self`. */
	  var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	  /** Used as a reference to the global object. */
	  var root = freeGlobal || freeSelf || Function('return this')();
	
	  /** Detect free variable `exports`. */
	  var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	  /** Detect free variable `module`. */
	  var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	  /** Detect the popular CommonJS extension `module.exports`. */
	  var moduleExports = freeModule && freeModule.exports === freeExports;
	
	  /** Detect free variable `process` from Node.js. */
	  var freeProcess = moduleExports && freeGlobal.process;
	
	  /** Used to access faster Node.js helpers. */
	  var nodeUtil = (function() {
	    try {
	      // Use `util.types` for Node.js 10+.
	      var types = freeModule && freeModule.require && freeModule.require('util').types;
	
	      if (types) {
	        return types;
	      }
	
	      // Legacy `process.binding('util')` for Node.js < 10.
	      return freeProcess && freeProcess.binding && freeProcess.binding('util');
	    } catch (e) {}
	  }());
	
	  /* Node.js helper references. */
	  var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer,
	      nodeIsDate = nodeUtil && nodeUtil.isDate,
	      nodeIsMap = nodeUtil && nodeUtil.isMap,
	      nodeIsRegExp = nodeUtil && nodeUtil.isRegExp,
	      nodeIsSet = nodeUtil && nodeUtil.isSet,
	      nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
	
	  /*--------------------------------------------------------------------------*/
	
	  /**
	   * A faster alternative to `Function#apply`, this function invokes `func`
	   * with the `this` binding of `thisArg` and the arguments of `args`.
	   *
	   * @private
	   * @param {Function} func The function to invoke.
	   * @param {*} thisArg The `this` binding of `func`.
	   * @param {Array} args The arguments to invoke `func` with.
	   * @returns {*} Returns the result of `func`.
	   */
	  function apply(func, thisArg, args) {
	    switch (args.length) {
	      case 0: return func.call(thisArg);
	      case 1: return func.call(thisArg, args[0]);
	      case 2: return func.call(thisArg, args[0], args[1]);
	      case 3: return func.call(thisArg, args[0], args[1], args[2]);
	    }
	    return func.apply(thisArg, args);
	  }
	
	  /**
	   * A specialized version of `baseAggregator` for arrays.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} setter The function to set `accumulator` values.
	   * @param {Function} iteratee The iteratee to transform keys.
	   * @param {Object} accumulator The initial aggregated object.
	   * @returns {Function} Returns `accumulator`.
	   */
	  function arrayAggregator(array, setter, iteratee, accumulator) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    while (++index < length) {
	      var value = array[index];
	      setter(accumulator, value, iteratee(value), array);
	    }
	    return accumulator;
	  }
	
	  /**
	   * A specialized version of `_.forEach` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns `array`.
	   */
	  function arrayEach(array, iteratee) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    while (++index < length) {
	      if (iteratee(array[index], index, array) === false) {
	        break;
	      }
	    }
	    return array;
	  }
	
	  /**
	   * A specialized version of `_.forEachRight` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns `array`.
	   */
	  function arrayEachRight(array, iteratee) {
	    var length = array == null ? 0 : array.length;
	
	    while (length--) {
	      if (iteratee(array[length], length, array) === false) {
	        break;
	      }
	    }
	    return array;
	  }
	
	  /**
	   * A specialized version of `_.every` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} predicate The function invoked per iteration.
	   * @returns {boolean} Returns `true` if all elements pass the predicate check,
	   *  else `false`.
	   */
	  function arrayEvery(array, predicate) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    while (++index < length) {
	      if (!predicate(array[index], index, array)) {
	        return false;
	      }
	    }
	    return true;
	  }
	
	  /**
	   * A specialized version of `_.filter` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} predicate The function invoked per iteration.
	   * @returns {Array} Returns the new filtered array.
	   */
	  function arrayFilter(array, predicate) {
	    var index = -1,
	        length = array == null ? 0 : array.length,
	        resIndex = 0,
	        result = [];
	
	    while (++index < length) {
	      var value = array[index];
	      if (predicate(value, index, array)) {
	        result[resIndex++] = value;
	      }
	    }
	    return result;
	  }
	
	  /**
	   * A specialized version of `_.includes` for arrays without support for
	   * specifying an index to search from.
	   *
	   * @private
	   * @param {Array} [array] The array to inspect.
	   * @param {*} target The value to search for.
	   * @returns {boolean} Returns `true` if `target` is found, else `false`.
	   */
	  function arrayIncludes(array, value) {
	    var length = array == null ? 0 : array.length;
	    return !!length && baseIndexOf(array, value, 0) > -1;
	  }
	
	  /**
	   * This function is like `arrayIncludes` except that it accepts a comparator.
	   *
	   * @private
	   * @param {Array} [array] The array to inspect.
	   * @param {*} target The value to search for.
	   * @param {Function} comparator The comparator invoked per element.
	   * @returns {boolean} Returns `true` if `target` is found, else `false`.
	   */
	  function arrayIncludesWith(array, value, comparator) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    while (++index < length) {
	      if (comparator(value, array[index])) {
	        return true;
	      }
	    }
	    return false;
	  }
	
	  /**
	   * A specialized version of `_.map` for arrays without support for iteratee
	   * shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns the new mapped array.
	   */
	  function arrayMap(array, iteratee) {
	    var index = -1,
	        length = array == null ? 0 : array.length,
	        result = Array(length);
	
	    while (++index < length) {
	      result[index] = iteratee(array[index], index, array);
	    }
	    return result;
	  }
	
	  /**
	   * Appends the elements of `values` to `array`.
	   *
	   * @private
	   * @param {Array} array The array to modify.
	   * @param {Array} values The values to append.
	   * @returns {Array} Returns `array`.
	   */
	  function arrayPush(array, values) {
	    var index = -1,
	        length = values.length,
	        offset = array.length;
	
	    while (++index < length) {
	      array[offset + index] = values[index];
	    }
	    return array;
	  }
	
	  /**
	   * A specialized version of `_.reduce` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @param {*} [accumulator] The initial value.
	   * @param {boolean} [initAccum] Specify using the first element of `array` as
	   *  the initial value.
	   * @returns {*} Returns the accumulated value.
	   */
	  function arrayReduce(array, iteratee, accumulator, initAccum) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    if (initAccum && length) {
	      accumulator = array[++index];
	    }
	    while (++index < length) {
	      accumulator = iteratee(accumulator, array[index], index, array);
	    }
	    return accumulator;
	  }
	
	  /**
	   * A specialized version of `_.reduceRight` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @param {*} [accumulator] The initial value.
	   * @param {boolean} [initAccum] Specify using the last element of `array` as
	   *  the initial value.
	   * @returns {*} Returns the accumulated value.
	   */
	  function arrayReduceRight(array, iteratee, accumulator, initAccum) {
	    var length = array == null ? 0 : array.length;
	    if (initAccum && length) {
	      accumulator = array[--length];
	    }
	    while (length--) {
	      accumulator = iteratee(accumulator, array[length], length, array);
	    }
	    return accumulator;
	  }
	
	  /**
	   * A specialized version of `_.some` for arrays without support for iteratee
	   * shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} predicate The function invoked per iteration.
	   * @returns {boolean} Returns `true` if any element passes the predicate check,
	   *  else `false`.
	   */
	  function arraySome(array, predicate) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    while (++index < length) {
	      if (predicate(array[index], index, array)) {
	        return true;
	      }
	    }
	    return false;
	  }
	
	  /**
	   * Gets the size of an ASCII `string`.
	   *
	   * @private
	   * @param {string} string The string inspect.
	   * @returns {number} Returns the string size.
	   */
	  var asciiSize = baseProperty('length');
	
	  /**
	   * Converts an ASCII `string` to an array.
	   *
	   * @private
	   * @param {string} string The string to convert.
	   * @returns {Array} Returns the converted array.
	   */
	  function asciiToArray(string) {
	    return string.split('');
	  }
	
	  /**
	   * Splits an ASCII `string` into an array of its words.
	   *
	   * @private
	   * @param {string} The string to inspect.
	   * @returns {Array} Returns the words of `string`.
	   */
	  function asciiWords(string) {
	    return string.match(reAsciiWord) || [];
	  }
	
	  /**
	   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
	   * without support for iteratee shorthands, which iterates over `collection`
	   * using `eachFunc`.
	   *
	   * @private
	   * @param {Array|Object} collection The collection to inspect.
	   * @param {Function} predicate The function invoked per iteration.
	   * @param {Function} eachFunc The function to iterate over `collection`.
	   * @returns {*} Returns the found element or its key, else `undefined`.
	   */
	  function baseFindKey(collection, predicate, eachFunc) {
	    var result;
	    eachFunc(collection, function(value, key, collection) {
	      if (predicate(value, key, collection)) {
	        result = key;
	        return false;
	      }
	    });
	    return result;
	  }
	
	  /**
	   * The base implementation of `_.findIndex` and `_.findLastIndex` without
	   * support for iteratee shorthands.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {Function} predicate The function invoked per iteration.
	   * @param {number} fromIndex The index to search from.
	   * @param {boolean} [fromRight] Specify iterating from right to left.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function baseFindIndex(array, predicate, fromIndex, fromRight) {
	    var length = array.length,
	        index = fromIndex + (fromRight ? 1 : -1);
	
	    while ((fromRight ? index-- : ++index < length)) {
	      if (predicate(array[index], index, array)) {
	        return index;
	      }
	    }
	    return -1;
	  }
	
	  /**
	   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function baseIndexOf(array, value, fromIndex) {
	    return value === value
	      ? strictIndexOf(array, value, fromIndex)
	      : baseFindIndex(array, baseIsNaN, fromIndex);
	  }
	
	  /**
	   * This function is like `baseIndexOf` except that it accepts a comparator.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @param {Function} comparator The comparator invoked per element.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function baseIndexOfWith(array, value, fromIndex, comparator) {
	    var index = fromIndex - 1,
	        length = array.length;
	
	    while (++index < length) {
	      if (comparator(array[index], value)) {
	        return index;
	      }
	    }
	    return -1;
	  }
	
	  /**
	   * The base implementation of `_.isNaN` without support for number objects.
	   *
	   * @private
	   * @param {*} value The value to check.
	   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
	   */
	  function baseIsNaN(value) {
	    return value !== value;
	  }
	
	  /**
	   * The base implementation of `_.mean` and `_.meanBy` without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} array The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {number} Returns the mean.
	   */
	  function baseMean(array, iteratee) {
	    var length = array == null ? 0 : array.length;
	    return length ? (baseSum(array, iteratee) / length) : NAN;
	  }
	
	  /**
	   * The base implementation of `_.property` without support for deep paths.
	   *
	   * @private
	   * @param {string} key The key of the property to get.
	   * @returns {Function} Returns the new accessor function.
	   */
	  function baseProperty(key) {
	    return function(object) {
	      return object == null ? undefined : object[key];
	    };
	  }
	
	  /**
	   * The base implementation of `_.propertyOf` without support for deep paths.
	   *
	   * @private
	   * @param {Object} object The object to query.
	   * @returns {Function} Returns the new accessor function.
	   */
	  function basePropertyOf(object) {
	    return function(key) {
	      return object == null ? undefined : object[key];
	    };
	  }
	
	  /**
	   * The base implementation of `_.reduce` and `_.reduceRight`, without support
	   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
	   *
	   * @private
	   * @param {Array|Object} collection The collection to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @param {*} accumulator The initial value.
	   * @param {boolean} initAccum Specify using the first or last element of
	   *  `collection` as the initial value.
	   * @param {Function} eachFunc The function to iterate over `collection`.
	   * @returns {*} Returns the accumulated value.
	   */
	  function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
	    eachFunc(collection, function(value, index, collection) {
	      accumulator = initAccum
	        ? (initAccum = false, value)
	        : iteratee(accumulator, value, index, collection);
	    });
	    return accumulator;
	  }
	
	  /**
	   * The base implementation of `_.sortBy` which uses `comparer` to define the
	   * sort order of `array` and replaces criteria objects with their corresponding
	   * values.
	   *
	   * @private
	   * @param {Array} array The array to sort.
	   * @param {Function} comparer The function to define sort order.
	   * @returns {Array} Returns `array`.
	   */
	  function baseSortBy(array, comparer) {
	    var length = array.length;
	
	    array.sort(comparer);
	    while (length--) {
	      array[length] = array[length].value;
	    }
	    return array;
	  }
	
	  /**
	   * The base implementation of `_.sum` and `_.sumBy` without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} array The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {number} Returns the sum.
	   */
	  function baseSum(array, iteratee) {
	    var result,
	        index = -1,
	        length = array.length;
	
	    while (++index < length) {
	      var current = iteratee(array[index]);
	      if (current !== undefined) {
	        result = result === undefined ? current : (result + current);
	      }
	    }
	    return result;
	  }
	
	  /**
	   * The base implementation of `_.times` without support for iteratee shorthands
	   * or max array length checks.
	   *
	   * @private
	   * @param {number} n The number of times to invoke `iteratee`.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns the array of results.
	   */
	  function baseTimes(n, iteratee) {
	    var index = -1,
	        result = Array(n);
	
	    while (++index < n) {
	      result[index] = iteratee(index);
	    }
	    return result;
	  }
	
	  /**
	   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
	   * of key-value pairs for `object` corresponding to the property names of `props`.
	   *
	   * @private
	   * @param {Object} object The object to query.
	   * @param {Array} props The property names to get values for.
	   * @returns {Object} Returns the key-value pairs.
	   */
	  function baseToPairs(object, props) {
	    return arrayMap(props, function(key) {
	      return [key, object[key]];
	    });
	  }
	
	  /**
	   * The base implementation of `_.unary` without support for storing metadata.
	   *
	   * @private
	   * @param {Function} func The function to cap arguments for.
	   * @returns {Function} Returns the new capped function.
	   */
	  function baseUnary(func) {
	    return function(value) {
	      return func(value);
	    };
	  }
	
	  /**
	   * The base implementation of `_.values` and `_.valuesIn` which creates an
	   * array of `object` property values corresponding to the property names
	   * of `props`.
	   *
	   * @private
	   * @param {Object} object The object to query.
	   * @param {Array} props The property names to get values for.
	   * @returns {Object} Returns the array of property values.
	   */
	  function baseValues(object, props) {
	    return arrayMap(props, function(key) {
	      return object[key];
	    });
	  }
	
	  /**
	   * Checks if a `cache` value for `key` exists.
	   *
	   * @private
	   * @param {Object} cache The cache to query.
	   * @param {string} key The key of the entry to check.
	   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	   */
	  function cacheHas(cache, key) {
	    return cache.has(key);
	  }
	
	  /**
	   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
	   * that is not found in the character symbols.
	   *
	   * @private
	   * @param {Array} strSymbols The string symbols to inspect.
	   * @param {Array} chrSymbols The character symbols to find.
	   * @returns {number} Returns the index of the first unmatched string symbol.
	   */
	  function charsStartIndex(strSymbols, chrSymbols) {
	    var index = -1,
	        length = strSymbols.length;
	
	    while (++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
	    return index;
	  }
	
	  /**
	   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
	   * that is not found in the character symbols.
	   *
	   * @private
	   * @param {Array} strSymbols The string symbols to inspect.
	   * @param {Array} chrSymbols The character symbols to find.
	   * @returns {number} Returns the index of the last unmatched string symbol.
	   */
	  function charsEndIndex(strSymbols, chrSymbols) {
	    var index = strSymbols.length;
	
	    while (index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
	    return index;
	  }
	
	  /**
	   * Gets the number of `placeholder` occurrences in `array`.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} placeholder The placeholder to search for.
	   * @returns {number} Returns the placeholder count.
	   */
	  function countHolders(array, placeholder) {
	    var length = array.length,
	        result = 0;
	
	    while (length--) {
	      if (array[length] === placeholder) {
	        ++result;
	      }
	    }
	    return result;
	  }
	
	  /**
	   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
	   * letters to basic Latin letters.
	   *
	   * @private
	   * @param {string} letter The matched letter to deburr.
	   * @returns {string} Returns the deburred letter.
	   */
	  var deburrLetter = basePropertyOf(deburredLetters);
	
	  /**
	   * Used by `_.escape` to convert characters to HTML entities.
	   *
	   * @private
	   * @param {string} chr The matched character to escape.
	   * @returns {string} Returns the escaped character.
	   */
	  var escapeHtmlChar = basePropertyOf(htmlEscapes);
	
	  /**
	   * Used by `_.template` to escape characters for inclusion in compiled string literals.
	   *
	   * @private
	   * @param {string} chr The matched character to escape.
	   * @returns {string} Returns the escaped character.
	   */
	  function escapeStringChar(chr) {
	    return '\\' + stringEscapes[chr];
	  }
	
	  /**
	   * Gets the value at `key` of `object`.
	   *
	   * @private
	   * @param {Object} [object] The object to query.
	   * @param {string} key The key of the property to get.
	   * @returns {*} Returns the property value.
	   */
	  function getValue(object, key) {
	    return object == null ? undefined : object[key];
	  }
	
	  /**
	   * Checks if `string` contains Unicode symbols.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
	   */
	  function hasUnicode(string) {
	    return reHasUnicode.test(string);
	  }
	
	  /**
	   * Checks if `string` contains a word composed of Unicode symbols.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @returns {boolean} Returns `true` if a word is found, else `false`.
	   */
	  function hasUnicodeWord(string) {
	    return reHasUnicodeWord.test(string);
	  }
	
	  /**
	   * Converts `iterator` to an array.
	   *
	   * @private
	   * @param {Object} iterator The iterator to convert.
	   * @returns {Array} Returns the converted array.
	   */
	  function iteratorToArray(iterator) {
	    var data,
	        result = [];
	
	    while (!(data = iterator.next()).done) {
	      result.push(data.value);
	    }
	    return result;
	  }
	
	  /**
	   * Converts `map` to its key-value pairs.
	   *
	   * @private
	   * @param {Object} map The map to convert.
	   * @returns {Array} Returns the key-value pairs.
	   */
	  function mapToArray(map) {
	    var index = -1,
	        result = Array(map.size);
	
	    map.forEach(function(value, key) {
	      result[++index] = [key, value];
	    });
	    return result;
	  }
	
	  /**
	   * Creates a unary function that invokes `func` with its argument transformed.
	   *
	   * @private
	   * @param {Function} func The function to wrap.
	   * @param {Function} transform The argument transform.
	   * @returns {Function} Returns the new function.
	   */
	  function overArg(func, transform) {
	    return function(arg) {
	      return func(transform(arg));
	    };
	  }
	
	  /**
	   * Replaces all `placeholder` elements in `array` with an internal placeholder
	   * and returns an array of their indexes.
	   *
	   * @private
	   * @param {Array} array The array to modify.
	   * @param {*} placeholder The placeholder to replace.
	   * @returns {Array} Returns the new array of placeholder indexes.
	   */
	  function replaceHolders(array, placeholder) {
	    var index = -1,
	        length = array.length,
	        resIndex = 0,
	        result = [];
	
	    while (++index < length) {
	      var value = array[index];
	      if (value === placeholder || value === PLACEHOLDER) {
	        array[index] = PLACEHOLDER;
	        result[resIndex++] = index;
	      }
	    }
	    return result;
	  }
	
	  /**
	   * Converts `set` to an array of its values.
	   *
	   * @private
	   * @param {Object} set The set to convert.
	   * @returns {Array} Returns the values.
	   */
	  function setToArray(set) {
	    var index = -1,
	        result = Array(set.size);
	
	    set.forEach(function(value) {
	      result[++index] = value;
	    });
	    return result;
	  }
	
	  /**
	   * Converts `set` to its value-value pairs.
	   *
	   * @private
	   * @param {Object} set The set to convert.
	   * @returns {Array} Returns the value-value pairs.
	   */
	  function setToPairs(set) {
	    var index = -1,
	        result = Array(set.size);
	
	    set.forEach(function(value) {
	      result[++index] = [value, value];
	    });
	    return result;
	  }
	
	  /**
	   * A specialized version of `_.indexOf` which performs strict equality
	   * comparisons of values, i.e. `===`.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function strictIndexOf(array, value, fromIndex) {
	    var index = fromIndex - 1,
	        length = array.length;
	
	    while (++index < length) {
	      if (array[index] === value) {
	        return index;
	      }
	    }
	    return -1;
	  }
	
	  /**
	   * A specialized version of `_.lastIndexOf` which performs strict equality
	   * comparisons of values, i.e. `===`.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function strictLastIndexOf(array, value, fromIndex) {
	    var index = fromIndex + 1;
	    while (index--) {
	      if (array[index] === value) {
	        return index;
	      }
	    }
	    return index;
	  }
	
	  /**
	   * Gets the number of symbols in `string`.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @returns {number} Returns the string size.
	   */
	  function stringSize(string) {
	    return hasUnicode(string)
	      ? unicodeSize(string)
	      : asciiSize(string);
	  }
	
	  /**
	   * Converts `string` to an array.
	   *
	   * @private
	   * @param {string} string The string to convert.
	   * @returns {Array} Returns the converted array.
	   */
	  function stringToArray(string) {
	    return hasUnicode(string)
	      ? unicodeToArray(string)
	      : asciiToArray(string);
	  }
	
	  /**
	   * Used by `_.unescape` to convert HTML entities to characters.
	   *
	   * @private
	   * @param {string} chr The matched character to unescape.
	   * @returns {string} Returns the unescaped character.
	   */
	  var unescapeHtmlChar = basePropertyOf(htmlUnescapes);
	
	  /**
	   * Gets the size of a Unicode `string`.
	   *
	   * @private
	   * @param {string} string The string inspect.
	   * @returns {number} Returns the string size.
	   */
	  function unicodeSize(string) {
	    var result = reUnicode.lastIndex = 0;
	    while (reUnicode.test(string)) {
	      ++result;
	    }
	    return result;
	  }
	
	  /**
	   * Converts a Unicode `string` to an array.
	   *
	   * @private
	   * @param {string} string The string to convert.
	   * @returns {Array} Returns the converted array.
	   */
	  function unicodeToArray(string) {
	    return string.match(reUnicode) || [];
	  }
	
	  /**
	   * Splits a Unicode `string` into an array of its words.
	   *
	   * @private
	   * @param {string} The string to inspect.
	   * @returns {Array} Returns the words of `string`.
	   */
	  function unicodeWords(string) {
	    return string.match(reUnicodeWord) || [];
	  }
	
	  /*--------------------------------------------------------------------------*/
	
	  /**
	   * Create a new pristine `lodash` function using the `context` object.
	   *
	   * @static
	   * @memberOf _
	   * @since 1.1.0
	   * @category Util
	   * @param {Object} [context=root] The context object.
	   * @returns {Function} Returns a new `lodash` function.
	   * @example
	   *
	   * _.mixin({ 'foo': _.constant('foo') });
	   *
	   * var lodash = _.runInContext();
	   * lodash.mixin({ 'bar': lodash.constant('bar') });
	   *
	   * _.isFunction(_.foo);
	   * // => true
	   * _.isFunction(_.bar);
	   * // => false
	   *
	   * lodash.isFunction(lodash.foo);
	   * // => false
	   * lodash.isFunction(lodash.bar);
	   * // => true
	   *
	   * // Create a suped-up `defer` in Node.js.
	   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
	   */
	  var runInContext = (function runInContext(context) {
	    context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));
	
	    /** Built-in constructor references. */
	    var Array = context.Array,
	        Date = context.Date,
	        Error = context.Error,
	        Function = context.Function,
	        Math = context.Math,
	        Object = context.Object,
	        RegExp = context.RegExp,
	        String = context.String,
	        TypeError = context.TypeError;
	
	    /** Used for built-in method references. */
	    var arrayProto = Array.prototype,
	        funcProto = Function.prototype,
	        objectProto = Object.prototype;
	
	    /** Used to detect overreaching core-js shims. */
	    var coreJsData = context['__core-js_shared__'];
	
	    /** Used to resolve the decompiled source of functions. */
	    var funcToString = funcProto.toString;
	
	    /** Used to check objects for own properties. */
	    var hasOwnProperty = objectProto.hasOwnProperty;
	
	    /** Used to generate unique IDs. */
	    var idCounter = 0;
	
	    /** Used to detect methods masquerading as native. */
	    var maskSrcKey = (function() {
	      var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
	      return uid ? ('Symbol(src)_1.' + uid) : '';
	    }());
	
	    /**
	     * Used to resolve the
	     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	     * of values.
	     */
	    var nativeObjectToString = objectProto.toString;
	
	    /** Used to infer the `Object` constructor. */
	    var objectCtorString = funcToString.call(Object);
	
	    /** Used to restore the original `_` reference in `_.noConflict`. */
	    var oldDash = root._;
	
	    /** Used to detect if a method is native. */
	    var reIsNative = RegExp('^' +
	      funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
	      .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	    );
	
	    /** Built-in value references. */
	    var Buffer = moduleExports ? context.Buffer : undefined,
	        Symbol = context.Symbol,
	        Uint8Array = context.Uint8Array,
	        allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined,
	        getPrototype = overArg(Object.getPrototypeOf, Object),
	        objectCreate = Object.create,
	        propertyIsEnumerable = objectProto.propertyIsEnumerable,
	        splice = arrayProto.splice,
	        spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined,
	        symIterator = Symbol ? Symbol.iterator : undefined,
	        symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	    var defineProperty = (function() {
	      try {
	        var func = getNative(Object, 'defineProperty');
	        func({}, '', {});
	        return func;
	      } catch (e) {}
	    }());
	
	    /** Mocked built-ins. */
	    var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout,
	        ctxNow = Date && Date.now !== root.Date.now && Date.now,
	        ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;
	
	    /* Built-in method references for those with the same name as other `lodash` methods. */
	    var nativeCeil = Math.ceil,
	        nativeFloor = Math.floor,
	        nativeGetSymbols = Object.getOwnPropertySymbols,
	        nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
	        nativeIsFinite = context.isFinite,
	        nativeJoin = arrayProto.join,
	        nativeKeys = overArg(Object.keys, Object),
	        nativeMax = Math.max,
	        nativeMin = Math.min,
	        nativeNow = Date.now,
	        nativeParseInt = context.parseInt,
	        nativeRandom = Math.random,
	        nativeReverse = arrayProto.reverse;
	
	    /* Built-in method references that are verified to be native. */
	    var DataView = getNative(context, 'DataView'),
	        Map = getNative(context, 'Map'),
	        Promise = getNative(context, 'Promise'),
	        Set = getNative(context, 'Set'),
	        WeakMap = getNative(context, 'WeakMap'),
	        nativeCreate = getNative(Object, 'create');
	
	    /** Used to store function metadata. */
	    var metaMap = WeakMap && new WeakMap;
	
	    /** Used to lookup unminified function names. */
	    var realNames = {};
	
	    /** Used to detect maps, sets, and weakmaps. */
	    var dataViewCtorString = toSource(DataView),
	        mapCtorString = toSource(Map),
	        promiseCtorString = toSource(Promise),
	        setCtorString = toSource(Set),
	        weakMapCtorString = toSource(WeakMap);
	
	    /** Used to convert symbols to primitives and strings. */
	    var symbolProto = Symbol ? Symbol.prototype : undefined,
	        symbolValueOf = symbolProto ? symbolProto.valueOf : undefined,
	        symbolToString = symbolProto ? symbolProto.toString : undefined;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a `lodash` object which wraps `value` to enable implicit method
	     * chain sequences. Methods that operate on and return arrays, collections,
	     * and functions can be chained together. Methods that retrieve a single value
	     * or may return a primitive value will automatically end the chain sequence
	     * and return the unwrapped value. Otherwise, the value must be unwrapped
	     * with `_#value`.
	     *
	     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
	     * enabled using `_.chain`.
	     *
	     * The execution of chained methods is lazy, that is, it's deferred until
	     * `_#value` is implicitly or explicitly called.
	     *
	     * Lazy evaluation allows several methods to support shortcut fusion.
	     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
	     * the creation of intermediate arrays and can greatly reduce the number of
	     * iteratee executions. Sections of a chain sequence qualify for shortcut
	     * fusion if the section is applied to an array and iteratees accept only
	     * one argument. The heuristic for whether a section qualifies for shortcut
	     * fusion is subject to change.
	     *
	     * Chaining is supported in custom builds as long as the `_#value` method is
	     * directly or indirectly included in the build.
	     *
	     * In addition to lodash methods, wrappers have `Array` and `String` methods.
	     *
	     * The wrapper `Array` methods are:
	     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
	     *
	     * The wrapper `String` methods are:
	     * `replace` and `split`
	     *
	     * The wrapper methods that support shortcut fusion are:
	     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
	     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
	     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
	     *
	     * The chainable wrapper methods are:
	     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
	     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
	     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
	     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
	     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
	     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
	     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
	     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
	     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
	     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
	     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
	     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
	     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
	     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
	     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
	     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
	     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
	     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
	     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
	     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
	     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
	     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
	     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
	     * `zipObject`, `zipObjectDeep`, and `zipWith`
	     *
	     * The wrapper methods that are **not** chainable by default are:
	     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
	     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
	     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
	     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
	     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
	     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
	     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
	     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
	     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
	     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
	     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
	     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
	     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
	     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
	     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
	     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
	     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
	     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
	     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
	     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
	     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
	     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
	     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
	     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
	     * `upperFirst`, `value`, and `words`
	     *
	     * @name _
	     * @constructor
	     * @category Seq
	     * @param {*} value The value to wrap in a `lodash` instance.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var wrapped = _([1, 2, 3]);
	     *
	     * // Returns an unwrapped value.
	     * wrapped.reduce(_.add);
	     * // => 6
	     *
	     * // Returns a wrapped value.
	     * var squares = wrapped.map(square);
	     *
	     * _.isArray(squares);
	     * // => false
	     *
	     * _.isArray(squares.value());
	     * // => true
	     */
	    function lodash(value) {
	      if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
	        if (value instanceof LodashWrapper) {
	          return value;
	        }
	        if (hasOwnProperty.call(value, '__wrapped__')) {
	          return wrapperClone(value);
	        }
	      }
	      return new LodashWrapper(value);
	    }
	
	    /**
	     * The base implementation of `_.create` without support for assigning
	     * properties to the created object.
	     *
	     * @private
	     * @param {Object} proto The object to inherit from.
	     * @returns {Object} Returns the new object.
	     */
	    var baseCreate = (function() {
	      function object() {}
	      return function(proto) {
	        if (!isObject(proto)) {
	          return {};
	        }
	        if (objectCreate) {
	          return objectCreate(proto);
	        }
	        object.prototype = proto;
	        var result = new object;
	        object.prototype = undefined;
	        return result;
	      };
	    }());
	
	    /**
	     * The function whose prototype chain sequence wrappers inherit from.
	     *
	     * @private
	     */
	    function baseLodash() {
	      // No operation performed.
	    }
	
	    /**
	     * The base constructor for creating `lodash` wrapper objects.
	     *
	     * @private
	     * @param {*} value The value to wrap.
	     * @param {boolean} [chainAll] Enable explicit method chain sequences.
	     */
	    function LodashWrapper(value, chainAll) {
	      this.__wrapped__ = value;
	      this.__actions__ = [];
	      this.__chain__ = !!chainAll;
	      this.__index__ = 0;
	      this.__values__ = undefined;
	    }
	
	    /**
	     * By default, the template delimiters used by lodash are like those in
	     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
	     * following template settings to use alternative delimiters.
	     *
	     * @static
	     * @memberOf _
	     * @type {Object}
	     */
	    lodash.templateSettings = {
	
	      /**
	       * Used to detect `data` property values to be HTML-escaped.
	       *
	       * @memberOf _.templateSettings
	       * @type {RegExp}
	       */
	      'escape': reEscape,
	
	      /**
	       * Used to detect code to be evaluated.
	       *
	       * @memberOf _.templateSettings
	       * @type {RegExp}
	       */
	      'evaluate': reEvaluate,
	
	      /**
	       * Used to detect `data` property values to inject.
	       *
	       * @memberOf _.templateSettings
	       * @type {RegExp}
	       */
	      'interpolate': reInterpolate,
	
	      /**
	       * Used to reference the data object in the template text.
	       *
	       * @memberOf _.templateSettings
	       * @type {string}
	       */
	      'variable': '',
	
	      /**
	       * Used to import variables into the compiled template.
	       *
	       * @memberOf _.templateSettings
	       * @type {Object}
	       */
	      'imports': {
	
	        /**
	         * A reference to the `lodash` function.
	         *
	         * @memberOf _.templateSettings.imports
	         * @type {Function}
	         */
	        '_': lodash
	      }
	    };
	
	    // Ensure wrappers are instances of `baseLodash`.
	    lodash.prototype = baseLodash.prototype;
	    lodash.prototype.constructor = lodash;
	
	    LodashWrapper.prototype = baseCreate(baseLodash.prototype);
	    LodashWrapper.prototype.constructor = LodashWrapper;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
	     *
	     * @private
	     * @constructor
	     * @param {*} value The value to wrap.
	     */
	    function LazyWrapper(value) {
	      this.__wrapped__ = value;
	      this.__actions__ = [];
	      this.__dir__ = 1;
	      this.__filtered__ = false;
	      this.__iteratees__ = [];
	      this.__takeCount__ = MAX_ARRAY_LENGTH;
	      this.__views__ = [];
	    }
	
	    /**
	     * Creates a clone of the lazy wrapper object.
	     *
	     * @private
	     * @name clone
	     * @memberOf LazyWrapper
	     * @returns {Object} Returns the cloned `LazyWrapper` object.
	     */
	    function lazyClone() {
	      var result = new LazyWrapper(this.__wrapped__);
	      result.__actions__ = copyArray(this.__actions__);
	      result.__dir__ = this.__dir__;
	      result.__filtered__ = this.__filtered__;
	      result.__iteratees__ = copyArray(this.__iteratees__);
	      result.__takeCount__ = this.__takeCount__;
	      result.__views__ = copyArray(this.__views__);
	      return result;
	    }
	
	    /**
	     * Reverses the direction of lazy iteration.
	     *
	     * @private
	     * @name reverse
	     * @memberOf LazyWrapper
	     * @returns {Object} Returns the new reversed `LazyWrapper` object.
	     */
	    function lazyReverse() {
	      if (this.__filtered__) {
	        var result = new LazyWrapper(this);
	        result.__dir__ = -1;
	        result.__filtered__ = true;
	      } else {
	        result = this.clone();
	        result.__dir__ *= -1;
	      }
	      return result;
	    }
	
	    /**
	     * Extracts the unwrapped value from its lazy wrapper.
	     *
	     * @private
	     * @name value
	     * @memberOf LazyWrapper
	     * @returns {*} Returns the unwrapped value.
	     */
	    function lazyValue() {
	      var array = this.__wrapped__.value(),
	          dir = this.__dir__,
	          isArr = isArray(array),
	          isRight = dir < 0,
	          arrLength = isArr ? array.length : 0,
	          view = getView(0, arrLength, this.__views__),
	          start = view.start,
	          end = view.end,
	          length = end - start,
	          index = isRight ? end : (start - 1),
	          iteratees = this.__iteratees__,
	          iterLength = iteratees.length,
	          resIndex = 0,
	          takeCount = nativeMin(length, this.__takeCount__);
	
	      if (!isArr || (!isRight && arrLength == length && takeCount == length)) {
	        return baseWrapperValue(array, this.__actions__);
	      }
	      var result = [];
	
	      outer:
	      while (length-- && resIndex < takeCount) {
	        index += dir;
	
	        var iterIndex = -1,
	            value = array[index];
	
	        while (++iterIndex < iterLength) {
	          var data = iteratees[iterIndex],
	              iteratee = data.iteratee,
	              type = data.type,
	              computed = iteratee(value);
	
	          if (type == LAZY_MAP_FLAG) {
	            value = computed;
	          } else if (!computed) {
	            if (type == LAZY_FILTER_FLAG) {
	              continue outer;
	            } else {
	              break outer;
	            }
	          }
	        }
	        result[resIndex++] = value;
	      }
	      return result;
	    }
	
	    // Ensure `LazyWrapper` is an instance of `baseLodash`.
	    LazyWrapper.prototype = baseCreate(baseLodash.prototype);
	    LazyWrapper.prototype.constructor = LazyWrapper;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a hash object.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [entries] The key-value pairs to cache.
	     */
	    function Hash(entries) {
	      var index = -1,
	          length = entries == null ? 0 : entries.length;
	
	      this.clear();
	      while (++index < length) {
	        var entry = entries[index];
	        this.set(entry[0], entry[1]);
	      }
	    }
	
	    /**
	     * Removes all key-value entries from the hash.
	     *
	     * @private
	     * @name clear
	     * @memberOf Hash
	     */
	    function hashClear() {
	      this.__data__ = nativeCreate ? nativeCreate(null) : {};
	      this.size = 0;
	    }
	
	    /**
	     * Removes `key` and its value from the hash.
	     *
	     * @private
	     * @name delete
	     * @memberOf Hash
	     * @param {Object} hash The hash to modify.
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */
	    function hashDelete(key) {
	      var result = this.has(key) && delete this.__data__[key];
	      this.size -= result ? 1 : 0;
	      return result;
	    }
	
	    /**
	     * Gets the hash value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf Hash
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */
	    function hashGet(key) {
	      var data = this.__data__;
	      if (nativeCreate) {
	        var result = data[key];
	        return result === HASH_UNDEFINED ? undefined : result;
	      }
	      return hasOwnProperty.call(data, key) ? data[key] : undefined;
	    }
	
	    /**
	     * Checks if a hash value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf Hash
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function hashHas(key) {
	      var data = this.__data__;
	      return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
	    }
	
	    /**
	     * Sets the hash `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf Hash
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the hash instance.
	     */
	    function hashSet(key, value) {
	      var data = this.__data__;
	      this.size += this.has(key) ? 0 : 1;
	      data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
	      return this;
	    }
	
	    // Add methods to `Hash`.
	    Hash.prototype.clear = hashClear;
	    Hash.prototype['delete'] = hashDelete;
	    Hash.prototype.get = hashGet;
	    Hash.prototype.has = hashHas;
	    Hash.prototype.set = hashSet;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates an list cache object.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [entries] The key-value pairs to cache.
	     */
	    function ListCache(entries) {
	      var index = -1,
	          length = entries == null ? 0 : entries.length;
	
	      this.clear();
	      while (++index < length) {
	        var entry = entries[index];
	        this.set(entry[0], entry[1]);
	      }
	    }
	
	    /**
	     * Removes all key-value entries from the list cache.
	     *
	     * @private
	     * @name clear
	     * @memberOf ListCache
	     */
	    function listCacheClear() {
	      this.__data__ = [];
	      this.size = 0;
	    }
	
	    /**
	     * Removes `key` and its value from the list cache.
	     *
	     * @private
	     * @name delete
	     * @memberOf ListCache
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */
	    function listCacheDelete(key) {
	      var data = this.__data__,
	          index = assocIndexOf(data, key);
	
	      if (index < 0) {
	        return false;
	      }
	      var lastIndex = data.length - 1;
	      if (index == lastIndex) {
	        data.pop();
	      } else {
	        splice.call(data, index, 1);
	      }
	      --this.size;
	      return true;
	    }
	
	    /**
	     * Gets the list cache value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf ListCache
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */
	    function listCacheGet(key) {
	      var data = this.__data__,
	          index = assocIndexOf(data, key);
	
	      return index < 0 ? undefined : data[index][1];
	    }
	
	    /**
	     * Checks if a list cache value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf ListCache
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function listCacheHas(key) {
	      return assocIndexOf(this.__data__, key) > -1;
	    }
	
	    /**
	     * Sets the list cache `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf ListCache
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the list cache instance.
	     */
	    function listCacheSet(key, value) {
	      var data = this.__data__,
	          index = assocIndexOf(data, key);
	
	      if (index < 0) {
	        ++this.size;
	        data.push([key, value]);
	      } else {
	        data[index][1] = value;
	      }
	      return this;
	    }
	
	    // Add methods to `ListCache`.
	    ListCache.prototype.clear = listCacheClear;
	    ListCache.prototype['delete'] = listCacheDelete;
	    ListCache.prototype.get = listCacheGet;
	    ListCache.prototype.has = listCacheHas;
	    ListCache.prototype.set = listCacheSet;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a map cache object to store key-value pairs.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [entries] The key-value pairs to cache.
	     */
	    function MapCache(entries) {
	      var index = -1,
	          length = entries == null ? 0 : entries.length;
	
	      this.clear();
	      while (++index < length) {
	        var entry = entries[index];
	        this.set(entry[0], entry[1]);
	      }
	    }
	
	    /**
	     * Removes all key-value entries from the map.
	     *
	     * @private
	     * @name clear
	     * @memberOf MapCache
	     */
	    function mapCacheClear() {
	      this.size = 0;
	      this.__data__ = {
	        'hash': new Hash,
	        'map': new (Map || ListCache),
	        'string': new Hash
	      };
	    }
	
	    /**
	     * Removes `key` and its value from the map.
	     *
	     * @private
	     * @name delete
	     * @memberOf MapCache
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */
	    function mapCacheDelete(key) {
	      var result = getMapData(this, key)['delete'](key);
	      this.size -= result ? 1 : 0;
	      return result;
	    }
	
	    /**
	     * Gets the map value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf MapCache
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */
	    function mapCacheGet(key) {
	      return getMapData(this, key).get(key);
	    }
	
	    /**
	     * Checks if a map value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf MapCache
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function mapCacheHas(key) {
	      return getMapData(this, key).has(key);
	    }
	
	    /**
	     * Sets the map `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf MapCache
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the map cache instance.
	     */
	    function mapCacheSet(key, value) {
	      var data = getMapData(this, key),
	          size = data.size;
	
	      data.set(key, value);
	      this.size += data.size == size ? 0 : 1;
	      return this;
	    }
	
	    // Add methods to `MapCache`.
	    MapCache.prototype.clear = mapCacheClear;
	    MapCache.prototype['delete'] = mapCacheDelete;
	    MapCache.prototype.get = mapCacheGet;
	    MapCache.prototype.has = mapCacheHas;
	    MapCache.prototype.set = mapCacheSet;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     *
	     * Creates an array cache object to store unique values.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [values] The values to cache.
	     */
	    function SetCache(values) {
	      var index = -1,
	          length = values == null ? 0 : values.length;
	
	      this.__data__ = new MapCache;
	      while (++index < length) {
	        this.add(values[index]);
	      }
	    }
	
	    /**
	     * Adds `value` to the array cache.
	     *
	     * @private
	     * @name add
	     * @memberOf SetCache
	     * @alias push
	     * @param {*} value The value to cache.
	     * @returns {Object} Returns the cache instance.
	     */
	    function setCacheAdd(value) {
	      this.__data__.set(value, HASH_UNDEFINED);
	      return this;
	    }
	
	    /**
	     * Checks if `value` is in the array cache.
	     *
	     * @private
	     * @name has
	     * @memberOf SetCache
	     * @param {*} value The value to search for.
	     * @returns {number} Returns `true` if `value` is found, else `false`.
	     */
	    function setCacheHas(value) {
	      return this.__data__.has(value);
	    }
	
	    // Add methods to `SetCache`.
	    SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
	    SetCache.prototype.has = setCacheHas;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a stack cache object to store key-value pairs.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [entries] The key-value pairs to cache.
	     */
	    function Stack(entries) {
	      var data = this.__data__ = new ListCache(entries);
	      this.size = data.size;
	    }
	
	    /**
	     * Removes all key-value entries from the stack.
	     *
	     * @private
	     * @name clear
	     * @memberOf Stack
	     */
	    function stackClear() {
	      this.__data__ = new ListCache;
	      this.size = 0;
	    }
	
	    /**
	     * Removes `key` and its value from the stack.
	     *
	     * @private
	     * @name delete
	     * @memberOf Stack
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */
	    function stackDelete(key) {
	      var data = this.__data__,
	          result = data['delete'](key);
	
	      this.size = data.size;
	      return result;
	    }
	
	    /**
	     * Gets the stack value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf Stack
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */
	    function stackGet(key) {
	      return this.__data__.get(key);
	    }
	
	    /**
	     * Checks if a stack value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf Stack
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function stackHas(key) {
	      return this.__data__.has(key);
	    }
	
	    /**
	     * Sets the stack `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf Stack
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the stack cache instance.
	     */
	    function stackSet(key, value) {
	      var data = this.__data__;
	      if (data instanceof ListCache) {
	        var pairs = data.__data__;
	        if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
	          pairs.push([key, value]);
	          this.size = ++data.size;
	          return this;
	        }
	        data = this.__data__ = new MapCache(pairs);
	      }
	      data.set(key, value);
	      this.size = data.size;
	      return this;
	    }
	
	    // Add methods to `Stack`.
	    Stack.prototype.clear = stackClear;
	    Stack.prototype['delete'] = stackDelete;
	    Stack.prototype.get = stackGet;
	    Stack.prototype.has = stackHas;
	    Stack.prototype.set = stackSet;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates an array of the enumerable property names of the array-like `value`.
	     *
	     * @private
	     * @param {*} value The value to query.
	     * @param {boolean} inherited Specify returning inherited property names.
	     * @returns {Array} Returns the array of property names.
	     */
	    function arrayLikeKeys(value, inherited) {
	      var isArr = isArray(value),
	          isArg = !isArr && isArguments(value),
	          isBuff = !isArr && !isArg && isBuffer(value),
	          isType = !isArr && !isArg && !isBuff && isTypedArray(value),
	          skipIndexes = isArr || isArg || isBuff || isType,
	          result = skipIndexes ? baseTimes(value.length, String) : [],
	          length = result.length;
	
	      for (var key in value) {
	        if ((inherited || hasOwnProperty.call(value, key)) &&
	            !(skipIndexes && (
	               // Safari 9 has enumerable `arguments.length` in strict mode.
	               key == 'length' ||
	               // Node.js 0.10 has enumerable non-index properties on buffers.
	               (isBuff && (key == 'offset' || key == 'parent')) ||
	               // PhantomJS 2 has enumerable non-index properties on typed arrays.
	               (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
	               // Skip index properties.
	               isIndex(key, length)
	            ))) {
	          result.push(key);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * A specialized version of `_.sample` for arrays.
	     *
	     * @private
	     * @param {Array} array The array to sample.
	     * @returns {*} Returns the random element.
	     */
	    function arraySample(array) {
	      var length = array.length;
	      return length ? array[baseRandom(0, length - 1)] : undefined;
	    }
	
	    /**
	     * A specialized version of `_.sampleSize` for arrays.
	     *
	     * @private
	     * @param {Array} array The array to sample.
	     * @param {number} n The number of elements to sample.
	     * @returns {Array} Returns the random elements.
	     */
	    function arraySampleSize(array, n) {
	      return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
	    }
	
	    /**
	     * A specialized version of `_.shuffle` for arrays.
	     *
	     * @private
	     * @param {Array} array The array to shuffle.
	     * @returns {Array} Returns the new shuffled array.
	     */
	    function arrayShuffle(array) {
	      return shuffleSelf(copyArray(array));
	    }
	
	    /**
	     * This function is like `assignValue` except that it doesn't assign
	     * `undefined` values.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {string} key The key of the property to assign.
	     * @param {*} value The value to assign.
	     */
	    function assignMergeValue(object, key, value) {
	      if ((value !== undefined && !eq(object[key], value)) ||
	          (value === undefined && !(key in object))) {
	        baseAssignValue(object, key, value);
	      }
	    }
	
	    /**
	     * Assigns `value` to `key` of `object` if the existing value is not equivalent
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {string} key The key of the property to assign.
	     * @param {*} value The value to assign.
	     */
	    function assignValue(object, key, value) {
	      var objValue = object[key];
	      if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
	          (value === undefined && !(key in object))) {
	        baseAssignValue(object, key, value);
	      }
	    }
	
	    /**
	     * Gets the index at which the `key` is found in `array` of key-value pairs.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {*} key The key to search for.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     */
	    function assocIndexOf(array, key) {
	      var length = array.length;
	      while (length--) {
	        if (eq(array[length][0], key)) {
	          return length;
	        }
	      }
	      return -1;
	    }
	
	    /**
	     * Aggregates elements of `collection` on `accumulator` with keys transformed
	     * by `iteratee` and values set by `setter`.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} setter The function to set `accumulator` values.
	     * @param {Function} iteratee The iteratee to transform keys.
	     * @param {Object} accumulator The initial aggregated object.
	     * @returns {Function} Returns `accumulator`.
	     */
	    function baseAggregator(collection, setter, iteratee, accumulator) {
	      baseEach(collection, function(value, key, collection) {
	        setter(accumulator, value, iteratee(value), collection);
	      });
	      return accumulator;
	    }
	
	    /**
	     * The base implementation of `_.assign` without support for multiple sources
	     * or `customizer` functions.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @returns {Object} Returns `object`.
	     */
	    function baseAssign(object, source) {
	      return object && copyObject(source, keys(source), object);
	    }
	
	    /**
	     * The base implementation of `_.assignIn` without support for multiple sources
	     * or `customizer` functions.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @returns {Object} Returns `object`.
	     */
	    function baseAssignIn(object, source) {
	      return object && copyObject(source, keysIn(source), object);
	    }
	
	    /**
	     * The base implementation of `assignValue` and `assignMergeValue` without
	     * value checks.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {string} key The key of the property to assign.
	     * @param {*} value The value to assign.
	     */
	    function baseAssignValue(object, key, value) {
	      if (key == '__proto__' && defineProperty) {
	        defineProperty(object, key, {
	          'configurable': true,
	          'enumerable': true,
	          'value': value,
	          'writable': true
	        });
	      } else {
	        object[key] = value;
	      }
	    }
	
	    /**
	     * The base implementation of `_.at` without support for individual paths.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {string[]} paths The property paths to pick.
	     * @returns {Array} Returns the picked elements.
	     */
	    function baseAt(object, paths) {
	      var index = -1,
	          length = paths.length,
	          result = Array(length),
	          skip = object == null;
	
	      while (++index < length) {
	        result[index] = skip ? undefined : get(object, paths[index]);
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.clamp` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {number} number The number to clamp.
	     * @param {number} [lower] The lower bound.
	     * @param {number} upper The upper bound.
	     * @returns {number} Returns the clamped number.
	     */
	    function baseClamp(number, lower, upper) {
	      if (number === number) {
	        if (upper !== undefined) {
	          number = number <= upper ? number : upper;
	        }
	        if (lower !== undefined) {
	          number = number >= lower ? number : lower;
	        }
	      }
	      return number;
	    }
	
	    /**
	     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
	     * traversed objects.
	     *
	     * @private
	     * @param {*} value The value to clone.
	     * @param {boolean} bitmask The bitmask flags.
	     *  1 - Deep clone
	     *  2 - Flatten inherited properties
	     *  4 - Clone symbols
	     * @param {Function} [customizer] The function to customize cloning.
	     * @param {string} [key] The key of `value`.
	     * @param {Object} [object] The parent object of `value`.
	     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
	     * @returns {*} Returns the cloned value.
	     */
	    function baseClone(value, bitmask, customizer, key, object, stack) {
	      var result,
	          isDeep = bitmask & CLONE_DEEP_FLAG,
	          isFlat = bitmask & CLONE_FLAT_FLAG,
	          isFull = bitmask & CLONE_SYMBOLS_FLAG;
	
	      if (customizer) {
	        result = object ? customizer(value, key, object, stack) : customizer(value);
	      }
	      if (result !== undefined) {
	        return result;
	      }
	      if (!isObject(value)) {
	        return value;
	      }
	      var isArr = isArray(value);
	      if (isArr) {
	        result = initCloneArray(value);
	        if (!isDeep) {
	          return copyArray(value, result);
	        }
	      } else {
	        var tag = getTag(value),
	            isFunc = tag == funcTag || tag == genTag;
	
	        if (isBuffer(value)) {
	          return cloneBuffer(value, isDeep);
	        }
	        if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
	          result = (isFlat || isFunc) ? {} : initCloneObject(value);
	          if (!isDeep) {
	            return isFlat
	              ? copySymbolsIn(value, baseAssignIn(result, value))
	              : copySymbols(value, baseAssign(result, value));
	          }
	        } else {
	          if (!cloneableTags[tag]) {
	            return object ? value : {};
	          }
	          result = initCloneByTag(value, tag, isDeep);
	        }
	      }
	      // Check for circular references and return its corresponding clone.
	      stack || (stack = new Stack);
	      var stacked = stack.get(value);
	      if (stacked) {
	        return stacked;
	      }
	      stack.set(value, result);
	
	      if (isSet(value)) {
	        value.forEach(function(subValue) {
	          result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
	        });
	      } else if (isMap(value)) {
	        value.forEach(function(subValue, key) {
	          result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
	        });
	      }
	
	      var keysFunc = isFull
	        ? (isFlat ? getAllKeysIn : getAllKeys)
	        : (isFlat ? keysIn : keys);
	
	      var props = isArr ? undefined : keysFunc(value);
	      arrayEach(props || value, function(subValue, key) {
	        if (props) {
	          key = subValue;
	          subValue = value[key];
	        }
	        // Recursively populate clone (susceptible to call stack limits).
	        assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.conforms` which doesn't clone `source`.
	     *
	     * @private
	     * @param {Object} source The object of property predicates to conform to.
	     * @returns {Function} Returns the new spec function.
	     */
	    function baseConforms(source) {
	      var props = keys(source);
	      return function(object) {
	        return baseConformsTo(object, source, props);
	      };
	    }
	
	    /**
	     * The base implementation of `_.conformsTo` which accepts `props` to check.
	     *
	     * @private
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property predicates to conform to.
	     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
	     */
	    function baseConformsTo(object, source, props) {
	      var length = props.length;
	      if (object == null) {
	        return !length;
	      }
	      object = Object(object);
	      while (length--) {
	        var key = props[length],
	            predicate = source[key],
	            value = object[key];
	
	        if ((value === undefined && !(key in object)) || !predicate(value)) {
	          return false;
	        }
	      }
	      return true;
	    }
	
	    /**
	     * The base implementation of `_.delay` and `_.defer` which accepts `args`
	     * to provide to `func`.
	     *
	     * @private
	     * @param {Function} func The function to delay.
	     * @param {number} wait The number of milliseconds to delay invocation.
	     * @param {Array} args The arguments to provide to `func`.
	     * @returns {number|Object} Returns the timer id or timeout object.
	     */
	    function baseDelay(func, wait, args) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      return setTimeout(function() { func.apply(undefined, args); }, wait);
	    }
	
	    /**
	     * The base implementation of methods like `_.difference` without support
	     * for excluding multiple arrays or iteratee shorthands.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {Array} values The values to exclude.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     */
	    function baseDifference(array, values, iteratee, comparator) {
	      var index = -1,
	          includes = arrayIncludes,
	          isCommon = true,
	          length = array.length,
	          result = [],
	          valuesLength = values.length;
	
	      if (!length) {
	        return result;
	      }
	      if (iteratee) {
	        values = arrayMap(values, baseUnary(iteratee));
	      }
	      if (comparator) {
	        includes = arrayIncludesWith;
	        isCommon = false;
	      }
	      else if (values.length >= LARGE_ARRAY_SIZE) {
	        includes = cacheHas;
	        isCommon = false;
	        values = new SetCache(values);
	      }
	      outer:
	      while (++index < length) {
	        var value = array[index],
	            computed = iteratee == null ? value : iteratee(value);
	
	        value = (comparator || value !== 0) ? value : 0;
	        if (isCommon && computed === computed) {
	          var valuesIndex = valuesLength;
	          while (valuesIndex--) {
	            if (values[valuesIndex] === computed) {
	              continue outer;
	            }
	          }
	          result.push(value);
	        }
	        else if (!includes(values, computed, comparator)) {
	          result.push(value);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.forEach` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     */
	    var baseEach = createBaseEach(baseForOwn);
	
	    /**
	     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     */
	    var baseEachRight = createBaseEach(baseForOwnRight, true);
	
	    /**
	     * The base implementation of `_.every` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {boolean} Returns `true` if all elements pass the predicate check,
	     *  else `false`
	     */
	    function baseEvery(collection, predicate) {
	      var result = true;
	      baseEach(collection, function(value, index, collection) {
	        result = !!predicate(value, index, collection);
	        return result;
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of methods like `_.max` and `_.min` which accepts a
	     * `comparator` to determine the extremum value.
	     *
	     * @private
	     * @param {Array} array The array to iterate over.
	     * @param {Function} iteratee The iteratee invoked per iteration.
	     * @param {Function} comparator The comparator used to compare values.
	     * @returns {*} Returns the extremum value.
	     */
	    function baseExtremum(array, iteratee, comparator) {
	      var index = -1,
	          length = array.length;
	
	      while (++index < length) {
	        var value = array[index],
	            current = iteratee(value);
	
	        if (current != null && (computed === undefined
	              ? (current === current && !isSymbol(current))
	              : comparator(current, computed)
	            )) {
	          var computed = current,
	              result = value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.fill` without an iteratee call guard.
	     *
	     * @private
	     * @param {Array} array The array to fill.
	     * @param {*} value The value to fill `array` with.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns `array`.
	     */
	    function baseFill(array, value, start, end) {
	      var length = array.length;
	
	      start = toInteger(start);
	      if (start < 0) {
	        start = -start > length ? 0 : (length + start);
	      }
	      end = (end === undefined || end > length) ? length : toInteger(end);
	      if (end < 0) {
	        end += length;
	      }
	      end = start > end ? 0 : toLength(end);
	      while (start < end) {
	        array[start++] = value;
	      }
	      return array;
	    }
	
	    /**
	     * The base implementation of `_.filter` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {Array} Returns the new filtered array.
	     */
	    function baseFilter(collection, predicate) {
	      var result = [];
	      baseEach(collection, function(value, index, collection) {
	        if (predicate(value, index, collection)) {
	          result.push(value);
	        }
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.flatten` with support for restricting flattening.
	     *
	     * @private
	     * @param {Array} array The array to flatten.
	     * @param {number} depth The maximum recursion depth.
	     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
	     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
	     * @param {Array} [result=[]] The initial result value.
	     * @returns {Array} Returns the new flattened array.
	     */
	    function baseFlatten(array, depth, predicate, isStrict, result) {
	      var index = -1,
	          length = array.length;
	
	      predicate || (predicate = isFlattenable);
	      result || (result = []);
	
	      while (++index < length) {
	        var value = array[index];
	        if (depth > 0 && predicate(value)) {
	          if (depth > 1) {
	            // Recursively flatten arrays (susceptible to call stack limits).
	            baseFlatten(value, depth - 1, predicate, isStrict, result);
	          } else {
	            arrayPush(result, value);
	          }
	        } else if (!isStrict) {
	          result[result.length] = value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `baseForOwn` which iterates over `object`
	     * properties returned by `keysFunc` and invokes `iteratee` for each property.
	     * Iteratee functions may exit iteration early by explicitly returning `false`.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @param {Function} keysFunc The function to get the keys of `object`.
	     * @returns {Object} Returns `object`.
	     */
	    var baseFor = createBaseFor();
	
	    /**
	     * This function is like `baseFor` except that it iterates over properties
	     * in the opposite order.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @param {Function} keysFunc The function to get the keys of `object`.
	     * @returns {Object} Returns `object`.
	     */
	    var baseForRight = createBaseFor(true);
	
	    /**
	     * The base implementation of `_.forOwn` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     */
	    function baseForOwn(object, iteratee) {
	      return object && baseFor(object, iteratee, keys);
	    }
	
	    /**
	     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     */
	    function baseForOwnRight(object, iteratee) {
	      return object && baseForRight(object, iteratee, keys);
	    }
	
	    /**
	     * The base implementation of `_.functions` which creates an array of
	     * `object` function property names filtered from `props`.
	     *
	     * @private
	     * @param {Object} object The object to inspect.
	     * @param {Array} props The property names to filter.
	     * @returns {Array} Returns the function names.
	     */
	    function baseFunctions(object, props) {
	      return arrayFilter(props, function(key) {
	        return isFunction(object[key]);
	      });
	    }
	
	    /**
	     * The base implementation of `_.get` without support for default values.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the property to get.
	     * @returns {*} Returns the resolved value.
	     */
	    function baseGet(object, path) {
	      path = castPath(path, object);
	
	      var index = 0,
	          length = path.length;
	
	      while (object != null && index < length) {
	        object = object[toKey(path[index++])];
	      }
	      return (index && index == length) ? object : undefined;
	    }
	
	    /**
	     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
	     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
	     * symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Function} keysFunc The function to get the keys of `object`.
	     * @param {Function} symbolsFunc The function to get the symbols of `object`.
	     * @returns {Array} Returns the array of property names and symbols.
	     */
	    function baseGetAllKeys(object, keysFunc, symbolsFunc) {
	      var result = keysFunc(object);
	      return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
	    }
	
	    /**
	     * The base implementation of `getTag` without fallbacks for buggy environments.
	     *
	     * @private
	     * @param {*} value The value to query.
	     * @returns {string} Returns the `toStringTag`.
	     */
	    function baseGetTag(value) {
	      if (value == null) {
	        return value === undefined ? undefinedTag : nullTag;
	      }
	      return (symToStringTag && symToStringTag in Object(value))
	        ? getRawTag(value)
	        : objectToString(value);
	    }
	
	    /**
	     * The base implementation of `_.gt` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is greater than `other`,
	     *  else `false`.
	     */
	    function baseGt(value, other) {
	      return value > other;
	    }
	
	    /**
	     * The base implementation of `_.has` without support for deep paths.
	     *
	     * @private
	     * @param {Object} [object] The object to query.
	     * @param {Array|string} key The key to check.
	     * @returns {boolean} Returns `true` if `key` exists, else `false`.
	     */
	    function baseHas(object, key) {
	      return object != null && hasOwnProperty.call(object, key);
	    }
	
	    /**
	     * The base implementation of `_.hasIn` without support for deep paths.
	     *
	     * @private
	     * @param {Object} [object] The object to query.
	     * @param {Array|string} key The key to check.
	     * @returns {boolean} Returns `true` if `key` exists, else `false`.
	     */
	    function baseHasIn(object, key) {
	      return object != null && key in Object(object);
	    }
	
	    /**
	     * The base implementation of `_.inRange` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {number} number The number to check.
	     * @param {number} start The start of the range.
	     * @param {number} end The end of the range.
	     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
	     */
	    function baseInRange(number, start, end) {
	      return number >= nativeMin(start, end) && number < nativeMax(start, end);
	    }
	
	    /**
	     * The base implementation of methods like `_.intersection`, without support
	     * for iteratee shorthands, that accepts an array of arrays to inspect.
	     *
	     * @private
	     * @param {Array} arrays The arrays to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of shared values.
	     */
	    function baseIntersection(arrays, iteratee, comparator) {
	      var includes = comparator ? arrayIncludesWith : arrayIncludes,
	          length = arrays[0].length,
	          othLength = arrays.length,
	          othIndex = othLength,
	          caches = Array(othLength),
	          maxLength = Infinity,
	          result = [];
	
	      while (othIndex--) {
	        var array = arrays[othIndex];
	        if (othIndex && iteratee) {
	          array = arrayMap(array, baseUnary(iteratee));
	        }
	        maxLength = nativeMin(array.length, maxLength);
	        caches[othIndex] = !comparator && (iteratee || (length >= 120 && array.length >= 120))
	          ? new SetCache(othIndex && array)
	          : undefined;
	      }
	      array = arrays[0];
	
	      var index = -1,
	          seen = caches[0];
	
	      outer:
	      while (++index < length && result.length < maxLength) {
	        var value = array[index],
	            computed = iteratee ? iteratee(value) : value;
	
	        value = (comparator || value !== 0) ? value : 0;
	        if (!(seen
	              ? cacheHas(seen, computed)
	              : includes(result, computed, comparator)
	            )) {
	          othIndex = othLength;
	          while (--othIndex) {
	            var cache = caches[othIndex];
	            if (!(cache
	                  ? cacheHas(cache, computed)
	                  : includes(arrays[othIndex], computed, comparator))
	                ) {
	              continue outer;
	            }
	          }
	          if (seen) {
	            seen.push(computed);
	          }
	          result.push(value);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.invert` and `_.invertBy` which inverts
	     * `object` with values transformed by `iteratee` and set by `setter`.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} setter The function to set `accumulator` values.
	     * @param {Function} iteratee The iteratee to transform values.
	     * @param {Object} accumulator The initial inverted object.
	     * @returns {Function} Returns `accumulator`.
	     */
	    function baseInverter(object, setter, iteratee, accumulator) {
	      baseForOwn(object, function(value, key, object) {
	        setter(accumulator, iteratee(value), key, object);
	      });
	      return accumulator;
	    }
	
	    /**
	     * The base implementation of `_.invoke` without support for individual
	     * method arguments.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the method to invoke.
	     * @param {Array} args The arguments to invoke the method with.
	     * @returns {*} Returns the result of the invoked method.
	     */
	    function baseInvoke(object, path, args) {
	      path = castPath(path, object);
	      object = parent(object, path);
	      var func = object == null ? object : object[toKey(last(path))];
	      return func == null ? undefined : apply(func, object, args);
	    }
	
	    /**
	     * The base implementation of `_.isArguments`.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	     */
	    function baseIsArguments(value) {
	      return isObjectLike(value) && baseGetTag(value) == argsTag;
	    }
	
	    /**
	     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
	     */
	    function baseIsArrayBuffer(value) {
	      return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
	    }
	
	    /**
	     * The base implementation of `_.isDate` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
	     */
	    function baseIsDate(value) {
	      return isObjectLike(value) && baseGetTag(value) == dateTag;
	    }
	
	    /**
	     * The base implementation of `_.isEqual` which supports partial comparisons
	     * and tracks traversed objects.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @param {boolean} bitmask The bitmask flags.
	     *  1 - Unordered comparison
	     *  2 - Partial comparison
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     */
	    function baseIsEqual(value, other, bitmask, customizer, stack) {
	      if (value === other) {
	        return true;
	      }
	      if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
	        return value !== value && other !== other;
	      }
	      return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
	    }
	
	    /**
	     * A specialized version of `baseIsEqual` for arrays and objects which performs
	     * deep comparisons and tracks traversed objects enabling objects with circular
	     * references to be compared.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	     * @param {Function} customizer The function to customize comparisons.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
	     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	     */
	    function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
	      var objIsArr = isArray(object),
	          othIsArr = isArray(other),
	          objTag = objIsArr ? arrayTag : getTag(object),
	          othTag = othIsArr ? arrayTag : getTag(other);
	
	      objTag = objTag == argsTag ? objectTag : objTag;
	      othTag = othTag == argsTag ? objectTag : othTag;
	
	      var objIsObj = objTag == objectTag,
	          othIsObj = othTag == objectTag,
	          isSameTag = objTag == othTag;
	
	      if (isSameTag && isBuffer(object)) {
	        if (!isBuffer(other)) {
	          return false;
	        }
	        objIsArr = true;
	        objIsObj = false;
	      }
	      if (isSameTag && !objIsObj) {
	        stack || (stack = new Stack);
	        return (objIsArr || isTypedArray(object))
	          ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
	          : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
	      }
	      if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
	        var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
	            othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
	
	        if (objIsWrapped || othIsWrapped) {
	          var objUnwrapped = objIsWrapped ? object.value() : object,
	              othUnwrapped = othIsWrapped ? other.value() : other;
	
	          stack || (stack = new Stack);
	          return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
	        }
	      }
	      if (!isSameTag) {
	        return false;
	      }
	      stack || (stack = new Stack);
	      return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
	    }
	
	    /**
	     * The base implementation of `_.isMap` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
	     */
	    function baseIsMap(value) {
	      return isObjectLike(value) && getTag(value) == mapTag;
	    }
	
	    /**
	     * The base implementation of `_.isMatch` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property values to match.
	     * @param {Array} matchData The property names, values, and compare flags to match.
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	     */
	    function baseIsMatch(object, source, matchData, customizer) {
	      var index = matchData.length,
	          length = index,
	          noCustomizer = !customizer;
	
	      if (object == null) {
	        return !length;
	      }
	      object = Object(object);
	      while (index--) {
	        var data = matchData[index];
	        if ((noCustomizer && data[2])
	              ? data[1] !== object[data[0]]
	              : !(data[0] in object)
	            ) {
	          return false;
	        }
	      }
	      while (++index < length) {
	        data = matchData[index];
	        var key = data[0],
	            objValue = object[key],
	            srcValue = data[1];
	
	        if (noCustomizer && data[2]) {
	          if (objValue === undefined && !(key in object)) {
	            return false;
	          }
	        } else {
	          var stack = new Stack;
	          if (customizer) {
	            var result = customizer(objValue, srcValue, key, object, source, stack);
	          }
	          if (!(result === undefined
	                ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
	                : result
	              )) {
	            return false;
	          }
	        }
	      }
	      return true;
	    }
	
	    /**
	     * The base implementation of `_.isNative` without bad shim checks.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a native function,
	     *  else `false`.
	     */
	    function baseIsNative(value) {
	      if (!isObject(value) || isMasked(value)) {
	        return false;
	      }
	      var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
	      return pattern.test(toSource(value));
	    }
	
	    /**
	     * The base implementation of `_.isRegExp` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
	     */
	    function baseIsRegExp(value) {
	      return isObjectLike(value) && baseGetTag(value) == regexpTag;
	    }
	
	    /**
	     * The base implementation of `_.isSet` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
	     */
	    function baseIsSet(value) {
	      return isObjectLike(value) && getTag(value) == setTag;
	    }
	
	    /**
	     * The base implementation of `_.isTypedArray` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	     */
	    function baseIsTypedArray(value) {
	      return isObjectLike(value) &&
	        isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
	    }
	
	    /**
	     * The base implementation of `_.iteratee`.
	     *
	     * @private
	     * @param {*} [value=_.identity] The value to convert to an iteratee.
	     * @returns {Function} Returns the iteratee.
	     */
	    function baseIteratee(value) {
	      // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
	      // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
	      if (typeof value == 'function') {
	        return value;
	      }
	      if (value == null) {
	        return identity;
	      }
	      if (typeof value == 'object') {
	        return isArray(value)
	          ? baseMatchesProperty(value[0], value[1])
	          : baseMatches(value);
	      }
	      return property(value);
	    }
	
	    /**
	     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     */
	    function baseKeys(object) {
	      if (!isPrototype(object)) {
	        return nativeKeys(object);
	      }
	      var result = [];
	      for (var key in Object(object)) {
	        if (hasOwnProperty.call(object, key) && key != 'constructor') {
	          result.push(key);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     */
	    function baseKeysIn(object) {
	      if (!isObject(object)) {
	        return nativeKeysIn(object);
	      }
	      var isProto = isPrototype(object),
	          result = [];
	
	      for (var key in object) {
	        if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
	          result.push(key);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.lt` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is less than `other`,
	     *  else `false`.
	     */
	    function baseLt(value, other) {
	      return value < other;
	    }
	
	    /**
	     * The base implementation of `_.map` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array} Returns the new mapped array.
	     */
	    function baseMap(collection, iteratee) {
	      var index = -1,
	          result = isArrayLike(collection) ? Array(collection.length) : [];
	
	      baseEach(collection, function(value, key, collection) {
	        result[++index] = iteratee(value, key, collection);
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.matches` which doesn't clone `source`.
	     *
	     * @private
	     * @param {Object} source The object of property values to match.
	     * @returns {Function} Returns the new spec function.
	     */
	    function baseMatches(source) {
	      var matchData = getMatchData(source);
	      if (matchData.length == 1 && matchData[0][2]) {
	        return matchesStrictComparable(matchData[0][0], matchData[0][1]);
	      }
	      return function(object) {
	        return object === source || baseIsMatch(object, source, matchData);
	      };
	    }
	
	    /**
	     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
	     *
	     * @private
	     * @param {string} path The path of the property to get.
	     * @param {*} srcValue The value to match.
	     * @returns {Function} Returns the new spec function.
	     */
	    function baseMatchesProperty(path, srcValue) {
	      if (isKey(path) && isStrictComparable(srcValue)) {
	        return matchesStrictComparable(toKey(path), srcValue);
	      }
	      return function(object) {
	        var objValue = get(object, path);
	        return (objValue === undefined && objValue === srcValue)
	          ? hasIn(object, path)
	          : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
	      };
	    }
	
	    /**
	     * The base implementation of `_.merge` without support for multiple sources.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @param {number} srcIndex The index of `source`.
	     * @param {Function} [customizer] The function to customize merged values.
	     * @param {Object} [stack] Tracks traversed source values and their merged
	     *  counterparts.
	     */
	    function baseMerge(object, source, srcIndex, customizer, stack) {
	      if (object === source) {
	        return;
	      }
	      baseFor(source, function(srcValue, key) {
	        stack || (stack = new Stack);
	        if (isObject(srcValue)) {
	          baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
	        }
	        else {
	          var newValue = customizer
	            ? customizer(safeGet(object, key), srcValue, (key + ''), object, source, stack)
	            : undefined;
	
	          if (newValue === undefined) {
	            newValue = srcValue;
	          }
	          assignMergeValue(object, key, newValue);
	        }
	      }, keysIn);
	    }
	
	    /**
	     * A specialized version of `baseMerge` for arrays and objects which performs
	     * deep merges and tracks traversed objects enabling objects with circular
	     * references to be merged.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @param {string} key The key of the value to merge.
	     * @param {number} srcIndex The index of `source`.
	     * @param {Function} mergeFunc The function to merge values.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @param {Object} [stack] Tracks traversed source values and their merged
	     *  counterparts.
	     */
	    function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
	      var objValue = safeGet(object, key),
	          srcValue = safeGet(source, key),
	          stacked = stack.get(srcValue);
	
	      if (stacked) {
	        assignMergeValue(object, key, stacked);
	        return;
	      }
	      var newValue = customizer
	        ? customizer(objValue, srcValue, (key + ''), object, source, stack)
	        : undefined;
	
	      var isCommon = newValue === undefined;
	
	      if (isCommon) {
	        var isArr = isArray(srcValue),
	            isBuff = !isArr && isBuffer(srcValue),
	            isTyped = !isArr && !isBuff && isTypedArray(srcValue);
	
	        newValue = srcValue;
	        if (isArr || isBuff || isTyped) {
	          if (isArray(objValue)) {
	            newValue = objValue;
	          }
	          else if (isArrayLikeObject(objValue)) {
	            newValue = copyArray(objValue);
	          }
	          else if (isBuff) {
	            isCommon = false;
	            newValue = cloneBuffer(srcValue, true);
	          }
	          else if (isTyped) {
	            isCommon = false;
	            newValue = cloneTypedArray(srcValue, true);
	          }
	          else {
	            newValue = [];
	          }
	        }
	        else if (isPlainObject(srcValue) || isArguments(srcValue)) {
	          newValue = objValue;
	          if (isArguments(objValue)) {
	            newValue = toPlainObject(objValue);
	          }
	          else if (!isObject(objValue) || isFunction(objValue)) {
	            newValue = initCloneObject(srcValue);
	          }
	        }
	        else {
	          isCommon = false;
	        }
	      }
	      if (isCommon) {
	        // Recursively merge objects and arrays (susceptible to call stack limits).
	        stack.set(srcValue, newValue);
	        mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
	        stack['delete'](srcValue);
	      }
	      assignMergeValue(object, key, newValue);
	    }
	
	    /**
	     * The base implementation of `_.nth` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {Array} array The array to query.
	     * @param {number} n The index of the element to return.
	     * @returns {*} Returns the nth element of `array`.
	     */
	    function baseNth(array, n) {
	      var length = array.length;
	      if (!length) {
	        return;
	      }
	      n += n < 0 ? length : 0;
	      return isIndex(n, length) ? array[n] : undefined;
	    }
	
	    /**
	     * The base implementation of `_.orderBy` without param guards.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
	     * @param {string[]} orders The sort orders of `iteratees`.
	     * @returns {Array} Returns the new sorted array.
	     */
	    function baseOrderBy(collection, iteratees, orders) {
	      var index = -1;
	      iteratees = arrayMap(iteratees.length ? iteratees : [identity], baseUnary(getIteratee()));
	
	      var result = baseMap(collection, function(value, key, collection) {
	        var criteria = arrayMap(iteratees, function(iteratee) {
	          return iteratee(value);
	        });
	        return { 'criteria': criteria, 'index': ++index, 'value': value };
	      });
	
	      return baseSortBy(result, function(object, other) {
	        return compareMultiple(object, other, orders);
	      });
	    }
	
	    /**
	     * The base implementation of `_.pick` without support for individual
	     * property identifiers.
	     *
	     * @private
	     * @param {Object} object The source object.
	     * @param {string[]} paths The property paths to pick.
	     * @returns {Object} Returns the new object.
	     */
	    function basePick(object, paths) {
	      return basePickBy(object, paths, function(value, path) {
	        return hasIn(object, path);
	      });
	    }
	
	    /**
	     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The source object.
	     * @param {string[]} paths The property paths to pick.
	     * @param {Function} predicate The function invoked per property.
	     * @returns {Object} Returns the new object.
	     */
	    function basePickBy(object, paths, predicate) {
	      var index = -1,
	          length = paths.length,
	          result = {};
	
	      while (++index < length) {
	        var path = paths[index],
	            value = baseGet(object, path);
	
	        if (predicate(value, path)) {
	          baseSet(result, castPath(path, object), value);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * A specialized version of `baseProperty` which supports deep paths.
	     *
	     * @private
	     * @param {Array|string} path The path of the property to get.
	     * @returns {Function} Returns the new accessor function.
	     */
	    function basePropertyDeep(path) {
	      return function(object) {
	        return baseGet(object, path);
	      };
	    }
	
	    /**
	     * The base implementation of `_.pullAllBy` without support for iteratee
	     * shorthands.
	     *
	     * @private
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns `array`.
	     */
	    function basePullAll(array, values, iteratee, comparator) {
	      var indexOf = comparator ? baseIndexOfWith : baseIndexOf,
	          index = -1,
	          length = values.length,
	          seen = array;
	
	      if (array === values) {
	        values = copyArray(values);
	      }
	      if (iteratee) {
	        seen = arrayMap(array, baseUnary(iteratee));
	      }
	      while (++index < length) {
	        var fromIndex = 0,
	            value = values[index],
	            computed = iteratee ? iteratee(value) : value;
	
	        while ((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1) {
	          if (seen !== array) {
	            splice.call(seen, fromIndex, 1);
	          }
	          splice.call(array, fromIndex, 1);
	        }
	      }
	      return array;
	    }
	
	    /**
	     * The base implementation of `_.pullAt` without support for individual
	     * indexes or capturing the removed elements.
	     *
	     * @private
	     * @param {Array} array The array to modify.
	     * @param {number[]} indexes The indexes of elements to remove.
	     * @returns {Array} Returns `array`.
	     */
	    function basePullAt(array, indexes) {
	      var length = array ? indexes.length : 0,
	          lastIndex = length - 1;
	
	      while (length--) {
	        var index = indexes[length];
	        if (length == lastIndex || index !== previous) {
	          var previous = index;
	          if (isIndex(index)) {
	            splice.call(array, index, 1);
	          } else {
	            baseUnset(array, index);
	          }
	        }
	      }
	      return array;
	    }
	
	    /**
	     * The base implementation of `_.random` without support for returning
	     * floating-point numbers.
	     *
	     * @private
	     * @param {number} lower The lower bound.
	     * @param {number} upper The upper bound.
	     * @returns {number} Returns the random number.
	     */
	    function baseRandom(lower, upper) {
	      return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
	    }
	
	    /**
	     * The base implementation of `_.range` and `_.rangeRight` which doesn't
	     * coerce arguments.
	     *
	     * @private
	     * @param {number} start The start of the range.
	     * @param {number} end The end of the range.
	     * @param {number} step The value to increment or decrement by.
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Array} Returns the range of numbers.
	     */
	    function baseRange(start, end, step, fromRight) {
	      var index = -1,
	          length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
	          result = Array(length);
	
	      while (length--) {
	        result[fromRight ? length : ++index] = start;
	        start += step;
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.repeat` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {string} string The string to repeat.
	     * @param {number} n The number of times to repeat the string.
	     * @returns {string} Returns the repeated string.
	     */
	    function baseRepeat(string, n) {
	      var result = '';
	      if (!string || n < 1 || n > MAX_SAFE_INTEGER) {
	        return result;
	      }
	      // Leverage the exponentiation by squaring algorithm for a faster repeat.
	      // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
	      do {
	        if (n % 2) {
	          result += string;
	        }
	        n = nativeFloor(n / 2);
	        if (n) {
	          string += string;
	        }
	      } while (n);
	
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
	     *
	     * @private
	     * @param {Function} func The function to apply a rest parameter to.
	     * @param {number} [start=func.length-1] The start position of the rest parameter.
	     * @returns {Function} Returns the new function.
	     */
	    function baseRest(func, start) {
	      return setToString(overRest(func, start, identity), func + '');
	    }
	
	    /**
	     * The base implementation of `_.sample`.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to sample.
	     * @returns {*} Returns the random element.
	     */
	    function baseSample(collection) {
	      return arraySample(values(collection));
	    }
	
	    /**
	     * The base implementation of `_.sampleSize` without param guards.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to sample.
	     * @param {number} n The number of elements to sample.
	     * @returns {Array} Returns the random elements.
	     */
	    function baseSampleSize(collection, n) {
	      var array = values(collection);
	      return shuffleSelf(array, baseClamp(n, 0, array.length));
	    }
	
	    /**
	     * The base implementation of `_.set`.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {*} value The value to set.
	     * @param {Function} [customizer] The function to customize path creation.
	     * @returns {Object} Returns `object`.
	     */
	    function baseSet(object, path, value, customizer) {
	      if (!isObject(object)) {
	        return object;
	      }
	      path = castPath(path, object);
	
	      var index = -1,
	          length = path.length,
	          lastIndex = length - 1,
	          nested = object;
	
	      while (nested != null && ++index < length) {
	        var key = toKey(path[index]),
	            newValue = value;
	
	        if (index != lastIndex) {
	          var objValue = nested[key];
	          newValue = customizer ? customizer(objValue, key, nested) : undefined;
	          if (newValue === undefined) {
	            newValue = isObject(objValue)
	              ? objValue
	              : (isIndex(path[index + 1]) ? [] : {});
	          }
	        }
	        assignValue(nested, key, newValue);
	        nested = nested[key];
	      }
	      return object;
	    }
	
	    /**
	     * The base implementation of `setData` without support for hot loop shorting.
	     *
	     * @private
	     * @param {Function} func The function to associate metadata with.
	     * @param {*} data The metadata.
	     * @returns {Function} Returns `func`.
	     */
	    var baseSetData = !metaMap ? identity : function(func, data) {
	      metaMap.set(func, data);
	      return func;
	    };
	
	    /**
	     * The base implementation of `setToString` without support for hot loop shorting.
	     *
	     * @private
	     * @param {Function} func The function to modify.
	     * @param {Function} string The `toString` result.
	     * @returns {Function} Returns `func`.
	     */
	    var baseSetToString = !defineProperty ? identity : function(func, string) {
	      return defineProperty(func, 'toString', {
	        'configurable': true,
	        'enumerable': false,
	        'value': constant(string),
	        'writable': true
	      });
	    };
	
	    /**
	     * The base implementation of `_.shuffle`.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to shuffle.
	     * @returns {Array} Returns the new shuffled array.
	     */
	    function baseShuffle(collection) {
	      return shuffleSelf(values(collection));
	    }
	
	    /**
	     * The base implementation of `_.slice` without an iteratee call guard.
	     *
	     * @private
	     * @param {Array} array The array to slice.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns the slice of `array`.
	     */
	    function baseSlice(array, start, end) {
	      var index = -1,
	          length = array.length;
	
	      if (start < 0) {
	        start = -start > length ? 0 : (length + start);
	      }
	      end = end > length ? length : end;
	      if (end < 0) {
	        end += length;
	      }
	      length = start > end ? 0 : ((end - start) >>> 0);
	      start >>>= 0;
	
	      var result = Array(length);
	      while (++index < length) {
	        result[index] = array[index + start];
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.some` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {boolean} Returns `true` if any element passes the predicate check,
	     *  else `false`.
	     */
	    function baseSome(collection, predicate) {
	      var result;
	
	      baseEach(collection, function(value, index, collection) {
	        result = predicate(value, index, collection);
	        return !result;
	      });
	      return !!result;
	    }
	
	    /**
	     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
	     * performs a binary search of `array` to determine the index at which `value`
	     * should be inserted into `array` in order to maintain its sort order.
	     *
	     * @private
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {boolean} [retHighest] Specify returning the highest qualified index.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     */
	    function baseSortedIndex(array, value, retHighest) {
	      var low = 0,
	          high = array == null ? low : array.length;
	
	      if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
	        while (low < high) {
	          var mid = (low + high) >>> 1,
	              computed = array[mid];
	
	          if (computed !== null && !isSymbol(computed) &&
	              (retHighest ? (computed <= value) : (computed < value))) {
	            low = mid + 1;
	          } else {
	            high = mid;
	          }
	        }
	        return high;
	      }
	      return baseSortedIndexBy(array, value, identity, retHighest);
	    }
	
	    /**
	     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
	     * which invokes `iteratee` for `value` and each element of `array` to compute
	     * their sort ranking. The iteratee is invoked with one argument; (value).
	     *
	     * @private
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {Function} iteratee The iteratee invoked per element.
	     * @param {boolean} [retHighest] Specify returning the highest qualified index.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     */
	    function baseSortedIndexBy(array, value, iteratee, retHighest) {
	      value = iteratee(value);
	
	      var low = 0,
	          high = array == null ? 0 : array.length,
	          valIsNaN = value !== value,
	          valIsNull = value === null,
	          valIsSymbol = isSymbol(value),
	          valIsUndefined = value === undefined;
	
	      while (low < high) {
	        var mid = nativeFloor((low + high) / 2),
	            computed = iteratee(array[mid]),
	            othIsDefined = computed !== undefined,
	            othIsNull = computed === null,
	            othIsReflexive = computed === computed,
	            othIsSymbol = isSymbol(computed);
	
	        if (valIsNaN) {
	          var setLow = retHighest || othIsReflexive;
	        } else if (valIsUndefined) {
	          setLow = othIsReflexive && (retHighest || othIsDefined);
	        } else if (valIsNull) {
	          setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
	        } else if (valIsSymbol) {
	          setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
	        } else if (othIsNull || othIsSymbol) {
	          setLow = false;
	        } else {
	          setLow = retHighest ? (computed <= value) : (computed < value);
	        }
	        if (setLow) {
	          low = mid + 1;
	        } else {
	          high = mid;
	        }
	      }
	      return nativeMin(high, MAX_ARRAY_INDEX);
	    }
	
	    /**
	     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
	     * support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     */
	    function baseSortedUniq(array, iteratee) {
	      var index = -1,
	          length = array.length,
	          resIndex = 0,
	          result = [];
	
	      while (++index < length) {
	        var value = array[index],
	            computed = iteratee ? iteratee(value) : value;
	
	        if (!index || !eq(computed, seen)) {
	          var seen = computed;
	          result[resIndex++] = value === 0 ? 0 : value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.toNumber` which doesn't ensure correct
	     * conversions of binary, hexadecimal, or octal string values.
	     *
	     * @private
	     * @param {*} value The value to process.
	     * @returns {number} Returns the number.
	     */
	    function baseToNumber(value) {
	      if (typeof value == 'number') {
	        return value;
	      }
	      if (isSymbol(value)) {
	        return NAN;
	      }
	      return +value;
	    }
	
	    /**
	     * The base implementation of `_.toString` which doesn't convert nullish
	     * values to empty strings.
	     *
	     * @private
	     * @param {*} value The value to process.
	     * @returns {string} Returns the string.
	     */
	    function baseToString(value) {
	      // Exit early for strings to avoid a performance hit in some environments.
	      if (typeof value == 'string') {
	        return value;
	      }
	      if (isArray(value)) {
	        // Recursively convert values (susceptible to call stack limits).
	        return arrayMap(value, baseToString) + '';
	      }
	      if (isSymbol(value)) {
	        return symbolToString ? symbolToString.call(value) : '';
	      }
	      var result = (value + '');
	      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	    }
	
	    /**
	     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     */
	    function baseUniq(array, iteratee, comparator) {
	      var index = -1,
	          includes = arrayIncludes,
	          length = array.length,
	          isCommon = true,
	          result = [],
	          seen = result;
	
	      if (comparator) {
	        isCommon = false;
	        includes = arrayIncludesWith;
	      }
	      else if (length >= LARGE_ARRAY_SIZE) {
	        var set = iteratee ? null : createSet(array);
	        if (set) {
	          return setToArray(set);
	        }
	        isCommon = false;
	        includes = cacheHas;
	        seen = new SetCache;
	      }
	      else {
	        seen = iteratee ? [] : result;
	      }
	      outer:
	      while (++index < length) {
	        var value = array[index],
	            computed = iteratee ? iteratee(value) : value;
	
	        value = (comparator || value !== 0) ? value : 0;
	        if (isCommon && computed === computed) {
	          var seenIndex = seen.length;
	          while (seenIndex--) {
	            if (seen[seenIndex] === computed) {
	              continue outer;
	            }
	          }
	          if (iteratee) {
	            seen.push(computed);
	          }
	          result.push(value);
	        }
	        else if (!includes(seen, computed, comparator)) {
	          if (seen !== result) {
	            seen.push(computed);
	          }
	          result.push(value);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.unset`.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The property path to unset.
	     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
	     */
	    function baseUnset(object, path) {
	      path = castPath(path, object);
	      object = parent(object, path);
	      return object == null || delete object[toKey(last(path))];
	    }
	
	    /**
	     * The base implementation of `_.update`.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to update.
	     * @param {Function} updater The function to produce the updated value.
	     * @param {Function} [customizer] The function to customize path creation.
	     * @returns {Object} Returns `object`.
	     */
	    function baseUpdate(object, path, updater, customizer) {
	      return baseSet(object, path, updater(baseGet(object, path)), customizer);
	    }
	
	    /**
	     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
	     * without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array} array The array to query.
	     * @param {Function} predicate The function invoked per iteration.
	     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Array} Returns the slice of `array`.
	     */
	    function baseWhile(array, predicate, isDrop, fromRight) {
	      var length = array.length,
	          index = fromRight ? length : -1;
	
	      while ((fromRight ? index-- : ++index < length) &&
	        predicate(array[index], index, array)) {}
	
	      return isDrop
	        ? baseSlice(array, (fromRight ? 0 : index), (fromRight ? index + 1 : length))
	        : baseSlice(array, (fromRight ? index + 1 : 0), (fromRight ? length : index));
	    }
	
	    /**
	     * The base implementation of `wrapperValue` which returns the result of
	     * performing a sequence of actions on the unwrapped `value`, where each
	     * successive action is supplied the return value of the previous.
	     *
	     * @private
	     * @param {*} value The unwrapped value.
	     * @param {Array} actions Actions to perform to resolve the unwrapped value.
	     * @returns {*} Returns the resolved value.
	     */
	    function baseWrapperValue(value, actions) {
	      var result = value;
	      if (result instanceof LazyWrapper) {
	        result = result.value();
	      }
	      return arrayReduce(actions, function(result, action) {
	        return action.func.apply(action.thisArg, arrayPush([result], action.args));
	      }, result);
	    }
	
	    /**
	     * The base implementation of methods like `_.xor`, without support for
	     * iteratee shorthands, that accepts an array of arrays to inspect.
	     *
	     * @private
	     * @param {Array} arrays The arrays to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of values.
	     */
	    function baseXor(arrays, iteratee, comparator) {
	      var length = arrays.length;
	      if (length < 2) {
	        return length ? baseUniq(arrays[0]) : [];
	      }
	      var index = -1,
	          result = Array(length);
	
	      while (++index < length) {
	        var array = arrays[index],
	            othIndex = -1;
	
	        while (++othIndex < length) {
	          if (othIndex != index) {
	            result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
	          }
	        }
	      }
	      return baseUniq(baseFlatten(result, 1), iteratee, comparator);
	    }
	
	    /**
	     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
	     *
	     * @private
	     * @param {Array} props The property identifiers.
	     * @param {Array} values The property values.
	     * @param {Function} assignFunc The function to assign values.
	     * @returns {Object} Returns the new object.
	     */
	    function baseZipObject(props, values, assignFunc) {
	      var index = -1,
	          length = props.length,
	          valsLength = values.length,
	          result = {};
	
	      while (++index < length) {
	        var value = index < valsLength ? values[index] : undefined;
	        assignFunc(result, props[index], value);
	      }
	      return result;
	    }
	
	    /**
	     * Casts `value` to an empty array if it's not an array like object.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @returns {Array|Object} Returns the cast array-like object.
	     */
	    function castArrayLikeObject(value) {
	      return isArrayLikeObject(value) ? value : [];
	    }
	
	    /**
	     * Casts `value` to `identity` if it's not a function.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @returns {Function} Returns cast function.
	     */
	    function castFunction(value) {
	      return typeof value == 'function' ? value : identity;
	    }
	
	    /**
	     * Casts `value` to a path array if it's not one.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @param {Object} [object] The object to query keys on.
	     * @returns {Array} Returns the cast property path array.
	     */
	    function castPath(value, object) {
	      if (isArray(value)) {
	        return value;
	      }
	      return isKey(value, object) ? [value] : stringToPath(toString(value));
	    }
	
	    /**
	     * A `baseRest` alias which can be replaced with `identity` by module
	     * replacement plugins.
	     *
	     * @private
	     * @type {Function}
	     * @param {Function} func The function to apply a rest parameter to.
	     * @returns {Function} Returns the new function.
	     */
	    var castRest = baseRest;
	
	    /**
	     * Casts `array` to a slice if it's needed.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {number} start The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns the cast slice.
	     */
	    function castSlice(array, start, end) {
	      var length = array.length;
	      end = end === undefined ? length : end;
	      return (!start && end >= length) ? array : baseSlice(array, start, end);
	    }
	
	    /**
	     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
	     *
	     * @private
	     * @param {number|Object} id The timer id or timeout object of the timer to clear.
	     */
	    var clearTimeout = ctxClearTimeout || function(id) {
	      return root.clearTimeout(id);
	    };
	
	    /**
	     * Creates a clone of  `buffer`.
	     *
	     * @private
	     * @param {Buffer} buffer The buffer to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Buffer} Returns the cloned buffer.
	     */
	    function cloneBuffer(buffer, isDeep) {
	      if (isDeep) {
	        return buffer.slice();
	      }
	      var length = buffer.length,
	          result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
	
	      buffer.copy(result);
	      return result;
	    }
	
	    /**
	     * Creates a clone of `arrayBuffer`.
	     *
	     * @private
	     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
	     * @returns {ArrayBuffer} Returns the cloned array buffer.
	     */
	    function cloneArrayBuffer(arrayBuffer) {
	      var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
	      new Uint8Array(result).set(new Uint8Array(arrayBuffer));
	      return result;
	    }
	
	    /**
	     * Creates a clone of `dataView`.
	     *
	     * @private
	     * @param {Object} dataView The data view to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Object} Returns the cloned data view.
	     */
	    function cloneDataView(dataView, isDeep) {
	      var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
	      return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
	    }
	
	    /**
	     * Creates a clone of `regexp`.
	     *
	     * @private
	     * @param {Object} regexp The regexp to clone.
	     * @returns {Object} Returns the cloned regexp.
	     */
	    function cloneRegExp(regexp) {
	      var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
	      result.lastIndex = regexp.lastIndex;
	      return result;
	    }
	
	    /**
	     * Creates a clone of the `symbol` object.
	     *
	     * @private
	     * @param {Object} symbol The symbol object to clone.
	     * @returns {Object} Returns the cloned symbol object.
	     */
	    function cloneSymbol(symbol) {
	      return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
	    }
	
	    /**
	     * Creates a clone of `typedArray`.
	     *
	     * @private
	     * @param {Object} typedArray The typed array to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Object} Returns the cloned typed array.
	     */
	    function cloneTypedArray(typedArray, isDeep) {
	      var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
	      return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
	    }
	
	    /**
	     * Compares values to sort them in ascending order.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {number} Returns the sort order indicator for `value`.
	     */
	    function compareAscending(value, other) {
	      if (value !== other) {
	        var valIsDefined = value !== undefined,
	            valIsNull = value === null,
	            valIsReflexive = value === value,
	            valIsSymbol = isSymbol(value);
	
	        var othIsDefined = other !== undefined,
	            othIsNull = other === null,
	            othIsReflexive = other === other,
	            othIsSymbol = isSymbol(other);
	
	        if ((!othIsNull && !othIsSymbol && !valIsSymbol && value > other) ||
	            (valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol) ||
	            (valIsNull && othIsDefined && othIsReflexive) ||
	            (!valIsDefined && othIsReflexive) ||
	            !valIsReflexive) {
	          return 1;
	        }
	        if ((!valIsNull && !valIsSymbol && !othIsSymbol && value < other) ||
	            (othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol) ||
	            (othIsNull && valIsDefined && valIsReflexive) ||
	            (!othIsDefined && valIsReflexive) ||
	            !othIsReflexive) {
	          return -1;
	        }
	      }
	      return 0;
	    }
	
	    /**
	     * Used by `_.orderBy` to compare multiple properties of a value to another
	     * and stable sort them.
	     *
	     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
	     * specify an order of "desc" for descending or "asc" for ascending sort order
	     * of corresponding values.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {boolean[]|string[]} orders The order to sort by for each property.
	     * @returns {number} Returns the sort order indicator for `object`.
	     */
	    function compareMultiple(object, other, orders) {
	      var index = -1,
	          objCriteria = object.criteria,
	          othCriteria = other.criteria,
	          length = objCriteria.length,
	          ordersLength = orders.length;
	
	      while (++index < length) {
	        var result = compareAscending(objCriteria[index], othCriteria[index]);
	        if (result) {
	          if (index >= ordersLength) {
	            return result;
	          }
	          var order = orders[index];
	          return result * (order == 'desc' ? -1 : 1);
	        }
	      }
	      // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
	      // that causes it, under certain circumstances, to provide the same value for
	      // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
	      // for more details.
	      //
	      // This also ensures a stable sort in V8 and other engines.
	      // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
	      return object.index - other.index;
	    }
	
	    /**
	     * Creates an array that is the composition of partially applied arguments,
	     * placeholders, and provided arguments into a single array of arguments.
	     *
	     * @private
	     * @param {Array} args The provided arguments.
	     * @param {Array} partials The arguments to prepend to those provided.
	     * @param {Array} holders The `partials` placeholder indexes.
	     * @params {boolean} [isCurried] Specify composing for a curried function.
	     * @returns {Array} Returns the new array of composed arguments.
	     */
	    function composeArgs(args, partials, holders, isCurried) {
	      var argsIndex = -1,
	          argsLength = args.length,
	          holdersLength = holders.length,
	          leftIndex = -1,
	          leftLength = partials.length,
	          rangeLength = nativeMax(argsLength - holdersLength, 0),
	          result = Array(leftLength + rangeLength),
	          isUncurried = !isCurried;
	
	      while (++leftIndex < leftLength) {
	        result[leftIndex] = partials[leftIndex];
	      }
	      while (++argsIndex < holdersLength) {
	        if (isUncurried || argsIndex < argsLength) {
	          result[holders[argsIndex]] = args[argsIndex];
	        }
	      }
	      while (rangeLength--) {
	        result[leftIndex++] = args[argsIndex++];
	      }
	      return result;
	    }
	
	    /**
	     * This function is like `composeArgs` except that the arguments composition
	     * is tailored for `_.partialRight`.
	     *
	     * @private
	     * @param {Array} args The provided arguments.
	     * @param {Array} partials The arguments to append to those provided.
	     * @param {Array} holders The `partials` placeholder indexes.
	     * @params {boolean} [isCurried] Specify composing for a curried function.
	     * @returns {Array} Returns the new array of composed arguments.
	     */
	    function composeArgsRight(args, partials, holders, isCurried) {
	      var argsIndex = -1,
	          argsLength = args.length,
	          holdersIndex = -1,
	          holdersLength = holders.length,
	          rightIndex = -1,
	          rightLength = partials.length,
	          rangeLength = nativeMax(argsLength - holdersLength, 0),
	          result = Array(rangeLength + rightLength),
	          isUncurried = !isCurried;
	
	      while (++argsIndex < rangeLength) {
	        result[argsIndex] = args[argsIndex];
	      }
	      var offset = argsIndex;
	      while (++rightIndex < rightLength) {
	        result[offset + rightIndex] = partials[rightIndex];
	      }
	      while (++holdersIndex < holdersLength) {
	        if (isUncurried || argsIndex < argsLength) {
	          result[offset + holders[holdersIndex]] = args[argsIndex++];
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Copies the values of `source` to `array`.
	     *
	     * @private
	     * @param {Array} source The array to copy values from.
	     * @param {Array} [array=[]] The array to copy values to.
	     * @returns {Array} Returns `array`.
	     */
	    function copyArray(source, array) {
	      var index = -1,
	          length = source.length;
	
	      array || (array = Array(length));
	      while (++index < length) {
	        array[index] = source[index];
	      }
	      return array;
	    }
	
	    /**
	     * Copies properties of `source` to `object`.
	     *
	     * @private
	     * @param {Object} source The object to copy properties from.
	     * @param {Array} props The property identifiers to copy.
	     * @param {Object} [object={}] The object to copy properties to.
	     * @param {Function} [customizer] The function to customize copied values.
	     * @returns {Object} Returns `object`.
	     */
	    function copyObject(source, props, object, customizer) {
	      var isNew = !object;
	      object || (object = {});
	
	      var index = -1,
	          length = props.length;
	
	      while (++index < length) {
	        var key = props[index];
	
	        var newValue = customizer
	          ? customizer(object[key], source[key], key, object, source)
	          : undefined;
	
	        if (newValue === undefined) {
	          newValue = source[key];
	        }
	        if (isNew) {
	          baseAssignValue(object, key, newValue);
	        } else {
	          assignValue(object, key, newValue);
	        }
	      }
	      return object;
	    }
	
	    /**
	     * Copies own symbols of `source` to `object`.
	     *
	     * @private
	     * @param {Object} source The object to copy symbols from.
	     * @param {Object} [object={}] The object to copy symbols to.
	     * @returns {Object} Returns `object`.
	     */
	    function copySymbols(source, object) {
	      return copyObject(source, getSymbols(source), object);
	    }
	
	    /**
	     * Copies own and inherited symbols of `source` to `object`.
	     *
	     * @private
	     * @param {Object} source The object to copy symbols from.
	     * @param {Object} [object={}] The object to copy symbols to.
	     * @returns {Object} Returns `object`.
	     */
	    function copySymbolsIn(source, object) {
	      return copyObject(source, getSymbolsIn(source), object);
	    }
	
	    /**
	     * Creates a function like `_.groupBy`.
	     *
	     * @private
	     * @param {Function} setter The function to set accumulator values.
	     * @param {Function} [initializer] The accumulator object initializer.
	     * @returns {Function} Returns the new aggregator function.
	     */
	    function createAggregator(setter, initializer) {
	      return function(collection, iteratee) {
	        var func = isArray(collection) ? arrayAggregator : baseAggregator,
	            accumulator = initializer ? initializer() : {};
	
	        return func(collection, setter, getIteratee(iteratee, 2), accumulator);
	      };
	    }
	
	    /**
	     * Creates a function like `_.assign`.
	     *
	     * @private
	     * @param {Function} assigner The function to assign values.
	     * @returns {Function} Returns the new assigner function.
	     */
	    function createAssigner(assigner) {
	      return baseRest(function(object, sources) {
	        var index = -1,
	            length = sources.length,
	            customizer = length > 1 ? sources[length - 1] : undefined,
	            guard = length > 2 ? sources[2] : undefined;
	
	        customizer = (assigner.length > 3 && typeof customizer == 'function')
	          ? (length--, customizer)
	          : undefined;
	
	        if (guard && isIterateeCall(sources[0], sources[1], guard)) {
	          customizer = length < 3 ? undefined : customizer;
	          length = 1;
	        }
	        object = Object(object);
	        while (++index < length) {
	          var source = sources[index];
	          if (source) {
	            assigner(object, source, index, customizer);
	          }
	        }
	        return object;
	      });
	    }
	
	    /**
	     * Creates a `baseEach` or `baseEachRight` function.
	     *
	     * @private
	     * @param {Function} eachFunc The function to iterate over a collection.
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new base function.
	     */
	    function createBaseEach(eachFunc, fromRight) {
	      return function(collection, iteratee) {
	        if (collection == null) {
	          return collection;
	        }
	        if (!isArrayLike(collection)) {
	          return eachFunc(collection, iteratee);
	        }
	        var length = collection.length,
	            index = fromRight ? length : -1,
	            iterable = Object(collection);
	
	        while ((fromRight ? index-- : ++index < length)) {
	          if (iteratee(iterable[index], index, iterable) === false) {
	            break;
	          }
	        }
	        return collection;
	      };
	    }
	
	    /**
	     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
	     *
	     * @private
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new base function.
	     */
	    function createBaseFor(fromRight) {
	      return function(object, iteratee, keysFunc) {
	        var index = -1,
	            iterable = Object(object),
	            props = keysFunc(object),
	            length = props.length;
	
	        while (length--) {
	          var key = props[fromRight ? length : ++index];
	          if (iteratee(iterable[key], key, iterable) === false) {
	            break;
	          }
	        }
	        return object;
	      };
	    }
	
	    /**
	     * Creates a function that wraps `func` to invoke it with the optional `this`
	     * binding of `thisArg`.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createBind(func, bitmask, thisArg) {
	      var isBind = bitmask & WRAP_BIND_FLAG,
	          Ctor = createCtor(func);
	
	      function wrapper() {
	        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	        return fn.apply(isBind ? thisArg : this, arguments);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates a function like `_.lowerFirst`.
	     *
	     * @private
	     * @param {string} methodName The name of the `String` case method to use.
	     * @returns {Function} Returns the new case function.
	     */
	    function createCaseFirst(methodName) {
	      return function(string) {
	        string = toString(string);
	
	        var strSymbols = hasUnicode(string)
	          ? stringToArray(string)
	          : undefined;
	
	        var chr = strSymbols
	          ? strSymbols[0]
	          : string.charAt(0);
	
	        var trailing = strSymbols
	          ? castSlice(strSymbols, 1).join('')
	          : string.slice(1);
	
	        return chr[methodName]() + trailing;
	      };
	    }
	
	    /**
	     * Creates a function like `_.camelCase`.
	     *
	     * @private
	     * @param {Function} callback The function to combine each word.
	     * @returns {Function} Returns the new compounder function.
	     */
	    function createCompounder(callback) {
	      return function(string) {
	        return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
	      };
	    }
	
	    /**
	     * Creates a function that produces an instance of `Ctor` regardless of
	     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
	     *
	     * @private
	     * @param {Function} Ctor The constructor to wrap.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createCtor(Ctor) {
	      return function() {
	        // Use a `switch` statement to work with class constructors. See
	        // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
	        // for more details.
	        var args = arguments;
	        switch (args.length) {
	          case 0: return new Ctor;
	          case 1: return new Ctor(args[0]);
	          case 2: return new Ctor(args[0], args[1]);
	          case 3: return new Ctor(args[0], args[1], args[2]);
	          case 4: return new Ctor(args[0], args[1], args[2], args[3]);
	          case 5: return new Ctor(args[0], args[1], args[2], args[3], args[4]);
	          case 6: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
	          case 7: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
	        }
	        var thisBinding = baseCreate(Ctor.prototype),
	            result = Ctor.apply(thisBinding, args);
	
	        // Mimic the constructor's `return` behavior.
	        // See https://es5.github.io/#x13.2.2 for more details.
	        return isObject(result) ? result : thisBinding;
	      };
	    }
	
	    /**
	     * Creates a function that wraps `func` to enable currying.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {number} arity The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createCurry(func, bitmask, arity) {
	      var Ctor = createCtor(func);
	
	      function wrapper() {
	        var length = arguments.length,
	            args = Array(length),
	            index = length,
	            placeholder = getHolder(wrapper);
	
	        while (index--) {
	          args[index] = arguments[index];
	        }
	        var holders = (length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder)
	          ? []
	          : replaceHolders(args, placeholder);
	
	        length -= holders.length;
	        if (length < arity) {
	          return createRecurry(
	            func, bitmask, createHybrid, wrapper.placeholder, undefined,
	            args, holders, undefined, undefined, arity - length);
	        }
	        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	        return apply(fn, this, args);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates a `_.find` or `_.findLast` function.
	     *
	     * @private
	     * @param {Function} findIndexFunc The function to find the collection index.
	     * @returns {Function} Returns the new find function.
	     */
	    function createFind(findIndexFunc) {
	      return function(collection, predicate, fromIndex) {
	        var iterable = Object(collection);
	        if (!isArrayLike(collection)) {
	          var iteratee = getIteratee(predicate, 3);
	          collection = keys(collection);
	          predicate = function(key) { return iteratee(iterable[key], key, iterable); };
	        }
	        var index = findIndexFunc(collection, predicate, fromIndex);
	        return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
	      };
	    }
	
	    /**
	     * Creates a `_.flow` or `_.flowRight` function.
	     *
	     * @private
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new flow function.
	     */
	    function createFlow(fromRight) {
	      return flatRest(function(funcs) {
	        var length = funcs.length,
	            index = length,
	            prereq = LodashWrapper.prototype.thru;
	
	        if (fromRight) {
	          funcs.reverse();
	        }
	        while (index--) {
	          var func = funcs[index];
	          if (typeof func != 'function') {
	            throw new TypeError(FUNC_ERROR_TEXT);
	          }
	          if (prereq && !wrapper && getFuncName(func) == 'wrapper') {
	            var wrapper = new LodashWrapper([], true);
	          }
	        }
	        index = wrapper ? index : length;
	        while (++index < length) {
	          func = funcs[index];
	
	          var funcName = getFuncName(func),
	              data = funcName == 'wrapper' ? getData(func) : undefined;
	
	          if (data && isLaziable(data[0]) &&
	                data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) &&
	                !data[4].length && data[9] == 1
	              ) {
	            wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
	          } else {
	            wrapper = (func.length == 1 && isLaziable(func))
	              ? wrapper[funcName]()
	              : wrapper.thru(func);
	          }
	        }
	        return function() {
	          var args = arguments,
	              value = args[0];
	
	          if (wrapper && args.length == 1 && isArray(value)) {
	            return wrapper.plant(value).value();
	          }
	          var index = 0,
	              result = length ? funcs[index].apply(this, args) : value;
	
	          while (++index < length) {
	            result = funcs[index].call(this, result);
	          }
	          return result;
	        };
	      });
	    }
	
	    /**
	     * Creates a function that wraps `func` to invoke it with optional `this`
	     * binding of `thisArg`, partial application, and currying.
	     *
	     * @private
	     * @param {Function|string} func The function or method name to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @param {Array} [partials] The arguments to prepend to those provided to
	     *  the new function.
	     * @param {Array} [holders] The `partials` placeholder indexes.
	     * @param {Array} [partialsRight] The arguments to append to those provided
	     *  to the new function.
	     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
	     * @param {Array} [argPos] The argument positions of the new function.
	     * @param {number} [ary] The arity cap of `func`.
	     * @param {number} [arity] The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
	      var isAry = bitmask & WRAP_ARY_FLAG,
	          isBind = bitmask & WRAP_BIND_FLAG,
	          isBindKey = bitmask & WRAP_BIND_KEY_FLAG,
	          isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG),
	          isFlip = bitmask & WRAP_FLIP_FLAG,
	          Ctor = isBindKey ? undefined : createCtor(func);
	
	      function wrapper() {
	        var length = arguments.length,
	            args = Array(length),
	            index = length;
	
	        while (index--) {
	          args[index] = arguments[index];
	        }
	        if (isCurried) {
	          var placeholder = getHolder(wrapper),
	              holdersCount = countHolders(args, placeholder);
	        }
	        if (partials) {
	          args = composeArgs(args, partials, holders, isCurried);
	        }
	        if (partialsRight) {
	          args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
	        }
	        length -= holdersCount;
	        if (isCurried && length < arity) {
	          var newHolders = replaceHolders(args, placeholder);
	          return createRecurry(
	            func, bitmask, createHybrid, wrapper.placeholder, thisArg,
	            args, newHolders, argPos, ary, arity - length
	          );
	        }
	        var thisBinding = isBind ? thisArg : this,
	            fn = isBindKey ? thisBinding[func] : func;
	
	        length = args.length;
	        if (argPos) {
	          args = reorder(args, argPos);
	        } else if (isFlip && length > 1) {
	          args.reverse();
	        }
	        if (isAry && ary < length) {
	          args.length = ary;
	        }
	        if (this && this !== root && this instanceof wrapper) {
	          fn = Ctor || createCtor(fn);
	        }
	        return fn.apply(thisBinding, args);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates a function like `_.invertBy`.
	     *
	     * @private
	     * @param {Function} setter The function to set accumulator values.
	     * @param {Function} toIteratee The function to resolve iteratees.
	     * @returns {Function} Returns the new inverter function.
	     */
	    function createInverter(setter, toIteratee) {
	      return function(object, iteratee) {
	        return baseInverter(object, setter, toIteratee(iteratee), {});
	      };
	    }
	
	    /**
	     * Creates a function that performs a mathematical operation on two values.
	     *
	     * @private
	     * @param {Function} operator The function to perform the operation.
	     * @param {number} [defaultValue] The value used for `undefined` arguments.
	     * @returns {Function} Returns the new mathematical operation function.
	     */
	    function createMathOperation(operator, defaultValue) {
	      return function(value, other) {
	        var result;
	        if (value === undefined && other === undefined) {
	          return defaultValue;
	        }
	        if (value !== undefined) {
	          result = value;
	        }
	        if (other !== undefined) {
	          if (result === undefined) {
	            return other;
	          }
	          if (typeof value == 'string' || typeof other == 'string') {
	            value = baseToString(value);
	            other = baseToString(other);
	          } else {
	            value = baseToNumber(value);
	            other = baseToNumber(other);
	          }
	          result = operator(value, other);
	        }
	        return result;
	      };
	    }
	
	    /**
	     * Creates a function like `_.over`.
	     *
	     * @private
	     * @param {Function} arrayFunc The function to iterate over iteratees.
	     * @returns {Function} Returns the new over function.
	     */
	    function createOver(arrayFunc) {
	      return flatRest(function(iteratees) {
	        iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
	        return baseRest(function(args) {
	          var thisArg = this;
	          return arrayFunc(iteratees, function(iteratee) {
	            return apply(iteratee, thisArg, args);
	          });
	        });
	      });
	    }
	
	    /**
	     * Creates the padding for `string` based on `length`. The `chars` string
	     * is truncated if the number of characters exceeds `length`.
	     *
	     * @private
	     * @param {number} length The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padding for `string`.
	     */
	    function createPadding(length, chars) {
	      chars = chars === undefined ? ' ' : baseToString(chars);
	
	      var charsLength = chars.length;
	      if (charsLength < 2) {
	        return charsLength ? baseRepeat(chars, length) : chars;
	      }
	      var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
	      return hasUnicode(chars)
	        ? castSlice(stringToArray(result), 0, length).join('')
	        : result.slice(0, length);
	    }
	
	    /**
	     * Creates a function that wraps `func` to invoke it with the `this` binding
	     * of `thisArg` and `partials` prepended to the arguments it receives.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {*} thisArg The `this` binding of `func`.
	     * @param {Array} partials The arguments to prepend to those provided to
	     *  the new function.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createPartial(func, bitmask, thisArg, partials) {
	      var isBind = bitmask & WRAP_BIND_FLAG,
	          Ctor = createCtor(func);
	
	      function wrapper() {
	        var argsIndex = -1,
	            argsLength = arguments.length,
	            leftIndex = -1,
	            leftLength = partials.length,
	            args = Array(leftLength + argsLength),
	            fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	
	        while (++leftIndex < leftLength) {
	          args[leftIndex] = partials[leftIndex];
	        }
	        while (argsLength--) {
	          args[leftIndex++] = arguments[++argsIndex];
	        }
	        return apply(fn, isBind ? thisArg : this, args);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates a `_.range` or `_.rangeRight` function.
	     *
	     * @private
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new range function.
	     */
	    function createRange(fromRight) {
	      return function(start, end, step) {
	        if (step && typeof step != 'number' && isIterateeCall(start, end, step)) {
	          end = step = undefined;
	        }
	        // Ensure the sign of `-0` is preserved.
	        start = toFinite(start);
	        if (end === undefined) {
	          end = start;
	          start = 0;
	        } else {
	          end = toFinite(end);
	        }
	        step = step === undefined ? (start < end ? 1 : -1) : toFinite(step);
	        return baseRange(start, end, step, fromRight);
	      };
	    }
	
	    /**
	     * Creates a function that performs a relational operation on two values.
	     *
	     * @private
	     * @param {Function} operator The function to perform the operation.
	     * @returns {Function} Returns the new relational operation function.
	     */
	    function createRelationalOperation(operator) {
	      return function(value, other) {
	        if (!(typeof value == 'string' && typeof other == 'string')) {
	          value = toNumber(value);
	          other = toNumber(other);
	        }
	        return operator(value, other);
	      };
	    }
	
	    /**
	     * Creates a function that wraps `func` to continue currying.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {Function} wrapFunc The function to create the `func` wrapper.
	     * @param {*} placeholder The placeholder value.
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @param {Array} [partials] The arguments to prepend to those provided to
	     *  the new function.
	     * @param {Array} [holders] The `partials` placeholder indexes.
	     * @param {Array} [argPos] The argument positions of the new function.
	     * @param {number} [ary] The arity cap of `func`.
	     * @param {number} [arity] The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
	      var isCurry = bitmask & WRAP_CURRY_FLAG,
	          newHolders = isCurry ? holders : undefined,
	          newHoldersRight = isCurry ? undefined : holders,
	          newPartials = isCurry ? partials : undefined,
	          newPartialsRight = isCurry ? undefined : partials;
	
	      bitmask |= (isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG);
	      bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);
	
	      if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) {
	        bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
	      }
	      var newData = [
	        func, bitmask, thisArg, newPartials, newHolders, newPartialsRight,
	        newHoldersRight, argPos, ary, arity
	      ];
	
	      var result = wrapFunc.apply(undefined, newData);
	      if (isLaziable(func)) {
	        setData(result, newData);
	      }
	      result.placeholder = placeholder;
	      return setWrapToString(result, func, bitmask);
	    }
	
	    /**
	     * Creates a function like `_.round`.
	     *
	     * @private
	     * @param {string} methodName The name of the `Math` method to use when rounding.
	     * @returns {Function} Returns the new round function.
	     */
	    function createRound(methodName) {
	      var func = Math[methodName];
	      return function(number, precision) {
	        number = toNumber(number);
	        precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
	        if (precision && nativeIsFinite(number)) {
	          // Shift with exponential notation to avoid floating-point issues.
	          // See [MDN](https://mdn.io/round#Examples) for more details.
	          var pair = (toString(number) + 'e').split('e'),
	              value = func(pair[0] + 'e' + (+pair[1] + precision));
	
	          pair = (toString(value) + 'e').split('e');
	          return +(pair[0] + 'e' + (+pair[1] - precision));
	        }
	        return func(number);
	      };
	    }
	
	    /**
	     * Creates a set object of `values`.
	     *
	     * @private
	     * @param {Array} values The values to add to the set.
	     * @returns {Object} Returns the new set.
	     */
	    var createSet = !(Set && (1 / setToArray(new Set([,-0]))[1]) == INFINITY) ? noop : function(values) {
	      return new Set(values);
	    };
	
	    /**
	     * Creates a `_.toPairs` or `_.toPairsIn` function.
	     *
	     * @private
	     * @param {Function} keysFunc The function to get the keys of a given object.
	     * @returns {Function} Returns the new pairs function.
	     */
	    function createToPairs(keysFunc) {
	      return function(object) {
	        var tag = getTag(object);
	        if (tag == mapTag) {
	          return mapToArray(object);
	        }
	        if (tag == setTag) {
	          return setToPairs(object);
	        }
	        return baseToPairs(object, keysFunc(object));
	      };
	    }
	
	    /**
	     * Creates a function that either curries or invokes `func` with optional
	     * `this` binding and partially applied arguments.
	     *
	     * @private
	     * @param {Function|string} func The function or method name to wrap.
	     * @param {number} bitmask The bitmask flags.
	     *    1 - `_.bind`
	     *    2 - `_.bindKey`
	     *    4 - `_.curry` or `_.curryRight` of a bound function
	     *    8 - `_.curry`
	     *   16 - `_.curryRight`
	     *   32 - `_.partial`
	     *   64 - `_.partialRight`
	     *  128 - `_.rearg`
	     *  256 - `_.ary`
	     *  512 - `_.flip`
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @param {Array} [partials] The arguments to be partially applied.
	     * @param {Array} [holders] The `partials` placeholder indexes.
	     * @param {Array} [argPos] The argument positions of the new function.
	     * @param {number} [ary] The arity cap of `func`.
	     * @param {number} [arity] The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
	      var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
	      if (!isBindKey && typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      var length = partials ? partials.length : 0;
	      if (!length) {
	        bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
	        partials = holders = undefined;
	      }
	      ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
	      arity = arity === undefined ? arity : toInteger(arity);
	      length -= holders ? holders.length : 0;
	
	      if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
	        var partialsRight = partials,
	            holdersRight = holders;
	
	        partials = holders = undefined;
	      }
	      var data = isBindKey ? undefined : getData(func);
	
	      var newData = [
	        func, bitmask, thisArg, partials, holders, partialsRight, holdersRight,
	        argPos, ary, arity
	      ];
	
	      if (data) {
	        mergeData(newData, data);
	      }
	      func = newData[0];
	      bitmask = newData[1];
	      thisArg = newData[2];
	      partials = newData[3];
	      holders = newData[4];
	      arity = newData[9] = newData[9] === undefined
	        ? (isBindKey ? 0 : func.length)
	        : nativeMax(newData[9] - length, 0);
	
	      if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) {
	        bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
	      }
	      if (!bitmask || bitmask == WRAP_BIND_FLAG) {
	        var result = createBind(func, bitmask, thisArg);
	      } else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) {
	        result = createCurry(func, bitmask, arity);
	      } else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) {
	        result = createPartial(func, bitmask, thisArg, partials);
	      } else {
	        result = createHybrid.apply(undefined, newData);
	      }
	      var setter = data ? baseSetData : setData;
	      return setWrapToString(setter(result, newData), func, bitmask);
	    }
	
	    /**
	     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
	     * of source objects to the destination object for all destination properties
	     * that resolve to `undefined`.
	     *
	     * @private
	     * @param {*} objValue The destination value.
	     * @param {*} srcValue The source value.
	     * @param {string} key The key of the property to assign.
	     * @param {Object} object The parent object of `objValue`.
	     * @returns {*} Returns the value to assign.
	     */
	    function customDefaultsAssignIn(objValue, srcValue, key, object) {
	      if (objValue === undefined ||
	          (eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key))) {
	        return srcValue;
	      }
	      return objValue;
	    }
	
	    /**
	     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
	     * objects into destination objects that are passed thru.
	     *
	     * @private
	     * @param {*} objValue The destination value.
	     * @param {*} srcValue The source value.
	     * @param {string} key The key of the property to merge.
	     * @param {Object} object The parent object of `objValue`.
	     * @param {Object} source The parent object of `srcValue`.
	     * @param {Object} [stack] Tracks traversed source values and their merged
	     *  counterparts.
	     * @returns {*} Returns the value to assign.
	     */
	    function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
	      if (isObject(objValue) && isObject(srcValue)) {
	        // Recursively merge objects and arrays (susceptible to call stack limits).
	        stack.set(srcValue, objValue);
	        baseMerge(objValue, srcValue, undefined, customDefaultsMerge, stack);
	        stack['delete'](srcValue);
	      }
	      return objValue;
	    }
	
	    /**
	     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
	     * objects.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @param {string} key The key of the property to inspect.
	     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
	     */
	    function customOmitClone(value) {
	      return isPlainObject(value) ? undefined : value;
	    }
	
	    /**
	     * A specialized version of `baseIsEqualDeep` for arrays with support for
	     * partial deep comparisons.
	     *
	     * @private
	     * @param {Array} array The array to compare.
	     * @param {Array} other The other array to compare.
	     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	     * @param {Function} customizer The function to customize comparisons.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Object} stack Tracks traversed `array` and `other` objects.
	     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
	     */
	    function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
	      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
	          arrLength = array.length,
	          othLength = other.length;
	
	      if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
	        return false;
	      }
	      // Assume cyclic values are equal.
	      var stacked = stack.get(array);
	      if (stacked && stack.get(other)) {
	        return stacked == other;
	      }
	      var index = -1,
	          result = true,
	          seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;
	
	      stack.set(array, other);
	      stack.set(other, array);
	
	      // Ignore non-index properties.
	      while (++index < arrLength) {
	        var arrValue = array[index],
	            othValue = other[index];
	
	        if (customizer) {
	          var compared = isPartial
	            ? customizer(othValue, arrValue, index, other, array, stack)
	            : customizer(arrValue, othValue, index, array, other, stack);
	        }
	        if (compared !== undefined) {
	          if (compared) {
	            continue;
	          }
	          result = false;
	          break;
	        }
	        // Recursively compare arrays (susceptible to call stack limits).
	        if (seen) {
	          if (!arraySome(other, function(othValue, othIndex) {
	                if (!cacheHas(seen, othIndex) &&
	                    (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
	                  return seen.push(othIndex);
	                }
	              })) {
	            result = false;
	            break;
	          }
	        } else if (!(
	              arrValue === othValue ||
	                equalFunc(arrValue, othValue, bitmask, customizer, stack)
	            )) {
	          result = false;
	          break;
	        }
	      }
	      stack['delete'](array);
	      stack['delete'](other);
	      return result;
	    }
	
	    /**
	     * A specialized version of `baseIsEqualDeep` for comparing objects of
	     * the same `toStringTag`.
	     *
	     * **Note:** This function only supports comparing values with tags of
	     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {string} tag The `toStringTag` of the objects to compare.
	     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	     * @param {Function} customizer The function to customize comparisons.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Object} stack Tracks traversed `object` and `other` objects.
	     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	     */
	    function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
	      switch (tag) {
	        case dataViewTag:
	          if ((object.byteLength != other.byteLength) ||
	              (object.byteOffset != other.byteOffset)) {
	            return false;
	          }
	          object = object.buffer;
	          other = other.buffer;
	
	        case arrayBufferTag:
	          if ((object.byteLength != other.byteLength) ||
	              !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
	            return false;
	          }
	          return true;
	
	        case boolTag:
	        case dateTag:
	        case numberTag:
	          // Coerce booleans to `1` or `0` and dates to milliseconds.
	          // Invalid dates are coerced to `NaN`.
	          return eq(+object, +other);
	
	        case errorTag:
	          return object.name == other.name && object.message == other.message;
	
	        case regexpTag:
	        case stringTag:
	          // Coerce regexes to strings and treat strings, primitives and objects,
	          // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
	          // for more details.
	          return object == (other + '');
	
	        case mapTag:
	          var convert = mapToArray;
	
	        case setTag:
	          var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
	          convert || (convert = setToArray);
	
	          if (object.size != other.size && !isPartial) {
	            return false;
	          }
	          // Assume cyclic values are equal.
	          var stacked = stack.get(object);
	          if (stacked) {
	            return stacked == other;
	          }
	          bitmask |= COMPARE_UNORDERED_FLAG;
	
	          // Recursively compare objects (susceptible to call stack limits).
	          stack.set(object, other);
	          var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
	          stack['delete'](object);
	          return result;
	
	        case symbolTag:
	          if (symbolValueOf) {
	            return symbolValueOf.call(object) == symbolValueOf.call(other);
	          }
	      }
	      return false;
	    }
	
	    /**
	     * A specialized version of `baseIsEqualDeep` for objects with support for
	     * partial deep comparisons.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	     * @param {Function} customizer The function to customize comparisons.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Object} stack Tracks traversed `object` and `other` objects.
	     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	     */
	    function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
	      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
	          objProps = getAllKeys(object),
	          objLength = objProps.length,
	          othProps = getAllKeys(other),
	          othLength = othProps.length;
	
	      if (objLength != othLength && !isPartial) {
	        return false;
	      }
	      var index = objLength;
	      while (index--) {
	        var key = objProps[index];
	        if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
	          return false;
	        }
	      }
	      // Assume cyclic values are equal.
	      var stacked = stack.get(object);
	      if (stacked && stack.get(other)) {
	        return stacked == other;
	      }
	      var result = true;
	      stack.set(object, other);
	      stack.set(other, object);
	
	      var skipCtor = isPartial;
	      while (++index < objLength) {
	        key = objProps[index];
	        var objValue = object[key],
	            othValue = other[key];
	
	        if (customizer) {
	          var compared = isPartial
	            ? customizer(othValue, objValue, key, other, object, stack)
	            : customizer(objValue, othValue, key, object, other, stack);
	        }
	        // Recursively compare objects (susceptible to call stack limits).
	        if (!(compared === undefined
	              ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
	              : compared
	            )) {
	          result = false;
	          break;
	        }
	        skipCtor || (skipCtor = key == 'constructor');
	      }
	      if (result && !skipCtor) {
	        var objCtor = object.constructor,
	            othCtor = other.constructor;
	
	        // Non `Object` object instances with different constructors are not equal.
	        if (objCtor != othCtor &&
	            ('constructor' in object && 'constructor' in other) &&
	            !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
	              typeof othCtor == 'function' && othCtor instanceof othCtor)) {
	          result = false;
	        }
	      }
	      stack['delete'](object);
	      stack['delete'](other);
	      return result;
	    }
	
	    /**
	     * A specialized version of `baseRest` which flattens the rest array.
	     *
	     * @private
	     * @param {Function} func The function to apply a rest parameter to.
	     * @returns {Function} Returns the new function.
	     */
	    function flatRest(func) {
	      return setToString(overRest(func, undefined, flatten), func + '');
	    }
	
	    /**
	     * Creates an array of own enumerable property names and symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names and symbols.
	     */
	    function getAllKeys(object) {
	      return baseGetAllKeys(object, keys, getSymbols);
	    }
	
	    /**
	     * Creates an array of own and inherited enumerable property names and
	     * symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names and symbols.
	     */
	    function getAllKeysIn(object) {
	      return baseGetAllKeys(object, keysIn, getSymbolsIn);
	    }
	
	    /**
	     * Gets metadata for `func`.
	     *
	     * @private
	     * @param {Function} func The function to query.
	     * @returns {*} Returns the metadata for `func`.
	     */
	    var getData = !metaMap ? noop : function(func) {
	      return metaMap.get(func);
	    };
	
	    /**
	     * Gets the name of `func`.
	     *
	     * @private
	     * @param {Function} func The function to query.
	     * @returns {string} Returns the function name.
	     */
	    function getFuncName(func) {
	      var result = (func.name + ''),
	          array = realNames[result],
	          length = hasOwnProperty.call(realNames, result) ? array.length : 0;
	
	      while (length--) {
	        var data = array[length],
	            otherFunc = data.func;
	        if (otherFunc == null || otherFunc == func) {
	          return data.name;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Gets the argument placeholder value for `func`.
	     *
	     * @private
	     * @param {Function} func The function to inspect.
	     * @returns {*} Returns the placeholder value.
	     */
	    function getHolder(func) {
	      var object = hasOwnProperty.call(lodash, 'placeholder') ? lodash : func;
	      return object.placeholder;
	    }
	
	    /**
	     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
	     * this function returns the custom method, otherwise it returns `baseIteratee`.
	     * If arguments are provided, the chosen function is invoked with them and
	     * its result is returned.
	     *
	     * @private
	     * @param {*} [value] The value to convert to an iteratee.
	     * @param {number} [arity] The arity of the created iteratee.
	     * @returns {Function} Returns the chosen function or its result.
	     */
	    function getIteratee() {
	      var result = lodash.iteratee || iteratee;
	      result = result === iteratee ? baseIteratee : result;
	      return arguments.length ? result(arguments[0], arguments[1]) : result;
	    }
	
	    /**
	     * Gets the data for `map`.
	     *
	     * @private
	     * @param {Object} map The map to query.
	     * @param {string} key The reference key.
	     * @returns {*} Returns the map data.
	     */
	    function getMapData(map, key) {
	      var data = map.__data__;
	      return isKeyable(key)
	        ? data[typeof key == 'string' ? 'string' : 'hash']
	        : data.map;
	    }
	
	    /**
	     * Gets the property names, values, and compare flags of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the match data of `object`.
	     */
	    function getMatchData(object) {
	      var result = keys(object),
	          length = result.length;
	
	      while (length--) {
	        var key = result[length],
	            value = object[key];
	
	        result[length] = [key, value, isStrictComparable(value)];
	      }
	      return result;
	    }
	
	    /**
	     * Gets the native function at `key` of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {string} key The key of the method to get.
	     * @returns {*} Returns the function if it's native, else `undefined`.
	     */
	    function getNative(object, key) {
	      var value = getValue(object, key);
	      return baseIsNative(value) ? value : undefined;
	    }
	
	    /**
	     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
	     *
	     * @private
	     * @param {*} value The value to query.
	     * @returns {string} Returns the raw `toStringTag`.
	     */
	    function getRawTag(value) {
	      var isOwn = hasOwnProperty.call(value, symToStringTag),
	          tag = value[symToStringTag];
	
	      try {
	        value[symToStringTag] = undefined;
	        var unmasked = true;
	      } catch (e) {}
	
	      var result = nativeObjectToString.call(value);
	      if (unmasked) {
	        if (isOwn) {
	          value[symToStringTag] = tag;
	        } else {
	          delete value[symToStringTag];
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Creates an array of the own enumerable symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of symbols.
	     */
	    var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
	      if (object == null) {
	        return [];
	      }
	      object = Object(object);
	      return arrayFilter(nativeGetSymbols(object), function(symbol) {
	        return propertyIsEnumerable.call(object, symbol);
	      });
	    };
	
	    /**
	     * Creates an array of the own and inherited enumerable symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of symbols.
	     */
	    var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
	      var result = [];
	      while (object) {
	        arrayPush(result, getSymbols(object));
	        object = getPrototype(object);
	      }
	      return result;
	    };
	
	    /**
	     * Gets the `toStringTag` of `value`.
	     *
	     * @private
	     * @param {*} value The value to query.
	     * @returns {string} Returns the `toStringTag`.
	     */
	    var getTag = baseGetTag;
	
	    // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
	    if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
	        (Map && getTag(new Map) != mapTag) ||
	        (Promise && getTag(Promise.resolve()) != promiseTag) ||
	        (Set && getTag(new Set) != setTag) ||
	        (WeakMap && getTag(new WeakMap) != weakMapTag)) {
	      getTag = function(value) {
	        var result = baseGetTag(value),
	            Ctor = result == objectTag ? value.constructor : undefined,
	            ctorString = Ctor ? toSource(Ctor) : '';
	
	        if (ctorString) {
	          switch (ctorString) {
	            case dataViewCtorString: return dataViewTag;
	            case mapCtorString: return mapTag;
	            case promiseCtorString: return promiseTag;
	            case setCtorString: return setTag;
	            case weakMapCtorString: return weakMapTag;
	          }
	        }
	        return result;
	      };
	    }
	
	    /**
	     * Gets the view, applying any `transforms` to the `start` and `end` positions.
	     *
	     * @private
	     * @param {number} start The start of the view.
	     * @param {number} end The end of the view.
	     * @param {Array} transforms The transformations to apply to the view.
	     * @returns {Object} Returns an object containing the `start` and `end`
	     *  positions of the view.
	     */
	    function getView(start, end, transforms) {
	      var index = -1,
	          length = transforms.length;
	
	      while (++index < length) {
	        var data = transforms[index],
	            size = data.size;
	
	        switch (data.type) {
	          case 'drop':      start += size; break;
	          case 'dropRight': end -= size; break;
	          case 'take':      end = nativeMin(end, start + size); break;
	          case 'takeRight': start = nativeMax(start, end - size); break;
	        }
	      }
	      return { 'start': start, 'end': end };
	    }
	
	    /**
	     * Extracts wrapper details from the `source` body comment.
	     *
	     * @private
	     * @param {string} source The source to inspect.
	     * @returns {Array} Returns the wrapper details.
	     */
	    function getWrapDetails(source) {
	      var match = source.match(reWrapDetails);
	      return match ? match[1].split(reSplitDetails) : [];
	    }
	
	    /**
	     * Checks if `path` exists on `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path to check.
	     * @param {Function} hasFunc The function to check properties.
	     * @returns {boolean} Returns `true` if `path` exists, else `false`.
	     */
	    function hasPath(object, path, hasFunc) {
	      path = castPath(path, object);
	
	      var index = -1,
	          length = path.length,
	          result = false;
	
	      while (++index < length) {
	        var key = toKey(path[index]);
	        if (!(result = object != null && hasFunc(object, key))) {
	          break;
	        }
	        object = object[key];
	      }
	      if (result || ++index != length) {
	        return result;
	      }
	      length = object == null ? 0 : object.length;
	      return !!length && isLength(length) && isIndex(key, length) &&
	        (isArray(object) || isArguments(object));
	    }
	
	    /**
	     * Initializes an array clone.
	     *
	     * @private
	     * @param {Array} array The array to clone.
	     * @returns {Array} Returns the initialized clone.
	     */
	    function initCloneArray(array) {
	      var length = array.length,
	          result = new array.constructor(length);
	
	      // Add properties assigned by `RegExp#exec`.
	      if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
	        result.index = array.index;
	        result.input = array.input;
	      }
	      return result;
	    }
	
	    /**
	     * Initializes an object clone.
	     *
	     * @private
	     * @param {Object} object The object to clone.
	     * @returns {Object} Returns the initialized clone.
	     */
	    function initCloneObject(object) {
	      return (typeof object.constructor == 'function' && !isPrototype(object))
	        ? baseCreate(getPrototype(object))
	        : {};
	    }
	
	    /**
	     * Initializes an object clone based on its `toStringTag`.
	     *
	     * **Note:** This function only supports cloning values with tags of
	     * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
	     *
	     * @private
	     * @param {Object} object The object to clone.
	     * @param {string} tag The `toStringTag` of the object to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Object} Returns the initialized clone.
	     */
	    function initCloneByTag(object, tag, isDeep) {
	      var Ctor = object.constructor;
	      switch (tag) {
	        case arrayBufferTag:
	          return cloneArrayBuffer(object);
	
	        case boolTag:
	        case dateTag:
	          return new Ctor(+object);
	
	        case dataViewTag:
	          return cloneDataView(object, isDeep);
	
	        case float32Tag: case float64Tag:
	        case int8Tag: case int16Tag: case int32Tag:
	        case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
	          return cloneTypedArray(object, isDeep);
	
	        case mapTag:
	          return new Ctor;
	
	        case numberTag:
	        case stringTag:
	          return new Ctor(object);
	
	        case regexpTag:
	          return cloneRegExp(object);
	
	        case setTag:
	          return new Ctor;
	
	        case symbolTag:
	          return cloneSymbol(object);
	      }
	    }
	
	    /**
	     * Inserts wrapper `details` in a comment at the top of the `source` body.
	     *
	     * @private
	     * @param {string} source The source to modify.
	     * @returns {Array} details The details to insert.
	     * @returns {string} Returns the modified source.
	     */
	    function insertWrapDetails(source, details) {
	      var length = details.length;
	      if (!length) {
	        return source;
	      }
	      var lastIndex = length - 1;
	      details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
	      details = details.join(length > 2 ? ', ' : ' ');
	      return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
	    }
	
	    /**
	     * Checks if `value` is a flattenable `arguments` object or array.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
	     */
	    function isFlattenable(value) {
	      return isArray(value) || isArguments(value) ||
	        !!(spreadableSymbol && value && value[spreadableSymbol]);
	    }
	
	    /**
	     * Checks if `value` is a valid array-like index.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	     */
	    function isIndex(value, length) {
	      var type = typeof value;
	      length = length == null ? MAX_SAFE_INTEGER : length;
	
	      return !!length &&
	        (type == 'number' ||
	          (type != 'symbol' && reIsUint.test(value))) &&
	            (value > -1 && value % 1 == 0 && value < length);
	    }
	
	    /**
	     * Checks if the given arguments are from an iteratee call.
	     *
	     * @private
	     * @param {*} value The potential iteratee value argument.
	     * @param {*} index The potential iteratee index or key argument.
	     * @param {*} object The potential iteratee object argument.
	     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
	     *  else `false`.
	     */
	    function isIterateeCall(value, index, object) {
	      if (!isObject(object)) {
	        return false;
	      }
	      var type = typeof index;
	      if (type == 'number'
	            ? (isArrayLike(object) && isIndex(index, object.length))
	            : (type == 'string' && index in object)
	          ) {
	        return eq(object[index], value);
	      }
	      return false;
	    }
	
	    /**
	     * Checks if `value` is a property name and not a property path.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @param {Object} [object] The object to query keys on.
	     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
	     */
	    function isKey(value, object) {
	      if (isArray(value)) {
	        return false;
	      }
	      var type = typeof value;
	      if (type == 'number' || type == 'symbol' || type == 'boolean' ||
	          value == null || isSymbol(value)) {
	        return true;
	      }
	      return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
	        (object != null && value in Object(object));
	    }
	
	    /**
	     * Checks if `value` is suitable for use as unique object key.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
	     */
	    function isKeyable(value) {
	      var type = typeof value;
	      return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
	        ? (value !== '__proto__')
	        : (value === null);
	    }
	
	    /**
	     * Checks if `func` has a lazy counterpart.
	     *
	     * @private
	     * @param {Function} func The function to check.
	     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
	     *  else `false`.
	     */
	    function isLaziable(func) {
	      var funcName = getFuncName(func),
	          other = lodash[funcName];
	
	      if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) {
	        return false;
	      }
	      if (func === other) {
	        return true;
	      }
	      var data = getData(other);
	      return !!data && func === data[0];
	    }
	
	    /**
	     * Checks if `func` has its source masked.
	     *
	     * @private
	     * @param {Function} func The function to check.
	     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
	     */
	    function isMasked(func) {
	      return !!maskSrcKey && (maskSrcKey in func);
	    }
	
	    /**
	     * Checks if `func` is capable of being masked.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
	     */
	    var isMaskable = coreJsData ? isFunction : stubFalse;
	
	    /**
	     * Checks if `value` is likely a prototype object.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
	     */
	    function isPrototype(value) {
	      var Ctor = value && value.constructor,
	          proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;
	
	      return value === proto;
	    }
	
	    /**
	     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` if suitable for strict
	     *  equality comparisons, else `false`.
	     */
	    function isStrictComparable(value) {
	      return value === value && !isObject(value);
	    }
	
	    /**
	     * A specialized version of `matchesProperty` for source values suitable
	     * for strict equality comparisons, i.e. `===`.
	     *
	     * @private
	     * @param {string} key The key of the property to get.
	     * @param {*} srcValue The value to match.
	     * @returns {Function} Returns the new spec function.
	     */
	    function matchesStrictComparable(key, srcValue) {
	      return function(object) {
	        if (object == null) {
	          return false;
	        }
	        return object[key] === srcValue &&
	          (srcValue !== undefined || (key in Object(object)));
	      };
	    }
	
	    /**
	     * A specialized version of `_.memoize` which clears the memoized function's
	     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
	     *
	     * @private
	     * @param {Function} func The function to have its output memoized.
	     * @returns {Function} Returns the new memoized function.
	     */
	    function memoizeCapped(func) {
	      var result = memoize(func, function(key) {
	        if (cache.size === MAX_MEMOIZE_SIZE) {
	          cache.clear();
	        }
	        return key;
	      });
	
	      var cache = result.cache;
	      return result;
	    }
	
	    /**
	     * Merges the function metadata of `source` into `data`.
	     *
	     * Merging metadata reduces the number of wrappers used to invoke a function.
	     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
	     * may be applied regardless of execution order. Methods like `_.ary` and
	     * `_.rearg` modify function arguments, making the order in which they are
	     * executed important, preventing the merging of metadata. However, we make
	     * an exception for a safe combined case where curried functions have `_.ary`
	     * and or `_.rearg` applied.
	     *
	     * @private
	     * @param {Array} data The destination metadata.
	     * @param {Array} source The source metadata.
	     * @returns {Array} Returns `data`.
	     */
	    function mergeData(data, source) {
	      var bitmask = data[1],
	          srcBitmask = source[1],
	          newBitmask = bitmask | srcBitmask,
	          isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);
	
	      var isCombo =
	        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_CURRY_FLAG)) ||
	        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_REARG_FLAG) && (data[7].length <= source[8])) ||
	        ((srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG)) && (source[7].length <= source[8]) && (bitmask == WRAP_CURRY_FLAG));
	
	      // Exit early if metadata can't be merged.
	      if (!(isCommon || isCombo)) {
	        return data;
	      }
	      // Use source `thisArg` if available.
	      if (srcBitmask & WRAP_BIND_FLAG) {
	        data[2] = source[2];
	        // Set when currying a bound function.
	        newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
	      }
	      // Compose partial arguments.
	      var value = source[3];
	      if (value) {
	        var partials = data[3];
	        data[3] = partials ? composeArgs(partials, value, source[4]) : value;
	        data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
	      }
	      // Compose partial right arguments.
	      value = source[5];
	      if (value) {
	        partials = data[5];
	        data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
	        data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
	      }
	      // Use source `argPos` if available.
	      value = source[7];
	      if (value) {
	        data[7] = value;
	      }
	      // Use source `ary` if it's smaller.
	      if (srcBitmask & WRAP_ARY_FLAG) {
	        data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
	      }
	      // Use source `arity` if one is not provided.
	      if (data[9] == null) {
	        data[9] = source[9];
	      }
	      // Use source `func` and merge bitmasks.
	      data[0] = source[0];
	      data[1] = newBitmask;
	
	      return data;
	    }
	
	    /**
	     * This function is like
	     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	     * except that it includes inherited enumerable properties.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     */
	    function nativeKeysIn(object) {
	      var result = [];
	      if (object != null) {
	        for (var key in Object(object)) {
	          result.push(key);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Converts `value` to a string using `Object.prototype.toString`.
	     *
	     * @private
	     * @param {*} value The value to convert.
	     * @returns {string} Returns the converted string.
	     */
	    function objectToString(value) {
	      return nativeObjectToString.call(value);
	    }
	
	    /**
	     * A specialized version of `baseRest` which transforms the rest array.
	     *
	     * @private
	     * @param {Function} func The function to apply a rest parameter to.
	     * @param {number} [start=func.length-1] The start position of the rest parameter.
	     * @param {Function} transform The rest array transform.
	     * @returns {Function} Returns the new function.
	     */
	    function overRest(func, start, transform) {
	      start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
	      return function() {
	        var args = arguments,
	            index = -1,
	            length = nativeMax(args.length - start, 0),
	            array = Array(length);
	
	        while (++index < length) {
	          array[index] = args[start + index];
	        }
	        index = -1;
	        var otherArgs = Array(start + 1);
	        while (++index < start) {
	          otherArgs[index] = args[index];
	        }
	        otherArgs[start] = transform(array);
	        return apply(func, this, otherArgs);
	      };
	    }
	
	    /**
	     * Gets the parent value at `path` of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array} path The path to get the parent value of.
	     * @returns {*} Returns the parent value.
	     */
	    function parent(object, path) {
	      return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
	    }
	
	    /**
	     * Reorder `array` according to the specified indexes where the element at
	     * the first index is assigned as the first element, the element at
	     * the second index is assigned as the second element, and so on.
	     *
	     * @private
	     * @param {Array} array The array to reorder.
	     * @param {Array} indexes The arranged array indexes.
	     * @returns {Array} Returns `array`.
	     */
	    function reorder(array, indexes) {
	      var arrLength = array.length,
	          length = nativeMin(indexes.length, arrLength),
	          oldArray = copyArray(array);
	
	      while (length--) {
	        var index = indexes[length];
	        array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
	      }
	      return array;
	    }
	
	    /**
	     * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {string} key The key of the property to get.
	     * @returns {*} Returns the property value.
	     */
	    function safeGet(object, key) {
	      if (key === 'constructor' && typeof object[key] === 'function') {
	        return;
	      }
	
	      if (key == '__proto__') {
	        return;
	      }
	
	      return object[key];
	    }
	
	    /**
	     * Sets metadata for `func`.
	     *
	     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
	     * period of time, it will trip its breaker and transition to an identity
	     * function to avoid garbage collection pauses in V8. See
	     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
	     * for more details.
	     *
	     * @private
	     * @param {Function} func The function to associate metadata with.
	     * @param {*} data The metadata.
	     * @returns {Function} Returns `func`.
	     */
	    var setData = shortOut(baseSetData);
	
	    /**
	     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
	     *
	     * @private
	     * @param {Function} func The function to delay.
	     * @param {number} wait The number of milliseconds to delay invocation.
	     * @returns {number|Object} Returns the timer id or timeout object.
	     */
	    var setTimeout = ctxSetTimeout || function(func, wait) {
	      return root.setTimeout(func, wait);
	    };
	
	    /**
	     * Sets the `toString` method of `func` to return `string`.
	     *
	     * @private
	     * @param {Function} func The function to modify.
	     * @param {Function} string The `toString` result.
	     * @returns {Function} Returns `func`.
	     */
	    var setToString = shortOut(baseSetToString);
	
	    /**
	     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
	     * with wrapper details in a comment at the top of the source body.
	     *
	     * @private
	     * @param {Function} wrapper The function to modify.
	     * @param {Function} reference The reference function.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @returns {Function} Returns `wrapper`.
	     */
	    function setWrapToString(wrapper, reference, bitmask) {
	      var source = (reference + '');
	      return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
	    }
	
	    /**
	     * Creates a function that'll short out and invoke `identity` instead
	     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
	     * milliseconds.
	     *
	     * @private
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new shortable function.
	     */
	    function shortOut(func) {
	      var count = 0,
	          lastCalled = 0;
	
	      return function() {
	        var stamp = nativeNow(),
	            remaining = HOT_SPAN - (stamp - lastCalled);
	
	        lastCalled = stamp;
	        if (remaining > 0) {
	          if (++count >= HOT_COUNT) {
	            return arguments[0];
	          }
	        } else {
	          count = 0;
	        }
	        return func.apply(undefined, arguments);
	      };
	    }
	
	    /**
	     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
	     *
	     * @private
	     * @param {Array} array The array to shuffle.
	     * @param {number} [size=array.length] The size of `array`.
	     * @returns {Array} Returns `array`.
	     */
	    function shuffleSelf(array, size) {
	      var index = -1,
	          length = array.length,
	          lastIndex = length - 1;
	
	      size = size === undefined ? length : size;
	      while (++index < size) {
	        var rand = baseRandom(index, lastIndex),
	            value = array[rand];
	
	        array[rand] = array[index];
	        array[index] = value;
	      }
	      array.length = size;
	      return array;
	    }
	
	    /**
	     * Converts `string` to a property path array.
	     *
	     * @private
	     * @param {string} string The string to convert.
	     * @returns {Array} Returns the property path array.
	     */
	    var stringToPath = memoizeCapped(function(string) {
	      var result = [];
	      if (string.charCodeAt(0) === 46 /* . */) {
	        result.push('');
	      }
	      string.replace(rePropName, function(match, number, quote, subString) {
	        result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
	      });
	      return result;
	    });
	
	    /**
	     * Converts `value` to a string key if it's not a string or symbol.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @returns {string|symbol} Returns the key.
	     */
	    function toKey(value) {
	      if (typeof value == 'string' || isSymbol(value)) {
	        return value;
	      }
	      var result = (value + '');
	      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	    }
	
	    /**
	     * Converts `func` to its source code.
	     *
	     * @private
	     * @param {Function} func The function to convert.
	     * @returns {string} Returns the source code.
	     */
	    function toSource(func) {
	      if (func != null) {
	        try {
	          return funcToString.call(func);
	        } catch (e) {}
	        try {
	          return (func + '');
	        } catch (e) {}
	      }
	      return '';
	    }
	
	    /**
	     * Updates wrapper `details` based on `bitmask` flags.
	     *
	     * @private
	     * @returns {Array} details The details to modify.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @returns {Array} Returns `details`.
	     */
	    function updateWrapDetails(details, bitmask) {
	      arrayEach(wrapFlags, function(pair) {
	        var value = '_.' + pair[0];
	        if ((bitmask & pair[1]) && !arrayIncludes(details, value)) {
	          details.push(value);
	        }
	      });
	      return details.sort();
	    }
	
	    /**
	     * Creates a clone of `wrapper`.
	     *
	     * @private
	     * @param {Object} wrapper The wrapper to clone.
	     * @returns {Object} Returns the cloned wrapper.
	     */
	    function wrapperClone(wrapper) {
	      if (wrapper instanceof LazyWrapper) {
	        return wrapper.clone();
	      }
	      var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
	      result.__actions__ = copyArray(wrapper.__actions__);
	      result.__index__  = wrapper.__index__;
	      result.__values__ = wrapper.__values__;
	      return result;
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates an array of elements split into groups the length of `size`.
	     * If `array` can't be split evenly, the final chunk will be the remaining
	     * elements.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to process.
	     * @param {number} [size=1] The length of each chunk
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the new array of chunks.
	     * @example
	     *
	     * _.chunk(['a', 'b', 'c', 'd'], 2);
	     * // => [['a', 'b'], ['c', 'd']]
	     *
	     * _.chunk(['a', 'b', 'c', 'd'], 3);
	     * // => [['a', 'b', 'c'], ['d']]
	     */
	    function chunk(array, size, guard) {
	      if ((guard ? isIterateeCall(array, size, guard) : size === undefined)) {
	        size = 1;
	      } else {
	        size = nativeMax(toInteger(size), 0);
	      }
	      var length = array == null ? 0 : array.length;
	      if (!length || size < 1) {
	        return [];
	      }
	      var index = 0,
	          resIndex = 0,
	          result = Array(nativeCeil(length / size));
	
	      while (index < length) {
	        result[resIndex++] = baseSlice(array, index, (index += size));
	      }
	      return result;
	    }
	
	    /**
	     * Creates an array with all falsey values removed. The values `false`, `null`,
	     * `0`, `""`, `undefined`, and `NaN` are falsey.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to compact.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * _.compact([0, 1, false, 2, '', 3]);
	     * // => [1, 2, 3]
	     */
	    function compact(array) {
	      var index = -1,
	          length = array == null ? 0 : array.length,
	          resIndex = 0,
	          result = [];
	
	      while (++index < length) {
	        var value = array[index];
	        if (value) {
	          result[resIndex++] = value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Creates a new array concatenating `array` with any additional arrays
	     * and/or values.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to concatenate.
	     * @param {...*} [values] The values to concatenate.
	     * @returns {Array} Returns the new concatenated array.
	     * @example
	     *
	     * var array = [1];
	     * var other = _.concat(array, 2, [3], [[4]]);
	     *
	     * console.log(other);
	     * // => [1, 2, 3, [4]]
	     *
	     * console.log(array);
	     * // => [1]
	     */
	    function concat() {
	      var length = arguments.length;
	      if (!length) {
	        return [];
	      }
	      var args = Array(length - 1),
	          array = arguments[0],
	          index = length;
	
	      while (index--) {
	        args[index - 1] = arguments[index];
	      }
	      return arrayPush(isArray(array) ? copyArray(array) : [array], baseFlatten(args, 1));
	    }
	
	    /**
	     * Creates an array of `array` values not included in the other given arrays
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons. The order and references of result values are
	     * determined by the first array.
	     *
	     * **Note:** Unlike `_.pullAll`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...Array} [values] The values to exclude.
	     * @returns {Array} Returns the new array of filtered values.
	     * @see _.without, _.xor
	     * @example
	     *
	     * _.difference([2, 1], [2, 3]);
	     * // => [1]
	     */
	    var difference = baseRest(function(array, values) {
	      return isArrayLikeObject(array)
	        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true))
	        : [];
	    });
	
	    /**
	     * This method is like `_.difference` except that it accepts `iteratee` which
	     * is invoked for each element of `array` and `values` to generate the criterion
	     * by which they're compared. The order and references of result values are
	     * determined by the first array. The iteratee is invoked with one argument:
	     * (value).
	     *
	     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...Array} [values] The values to exclude.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
	     * // => [1.2]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
	     * // => [{ 'x': 2 }]
	     */
	    var differenceBy = baseRest(function(array, values) {
	      var iteratee = last(values);
	      if (isArrayLikeObject(iteratee)) {
	        iteratee = undefined;
	      }
	      return isArrayLikeObject(array)
	        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee, 2))
	        : [];
	    });
	
	    /**
	     * This method is like `_.difference` except that it accepts `comparator`
	     * which is invoked to compare elements of `array` to `values`. The order and
	     * references of result values are determined by the first array. The comparator
	     * is invoked with two arguments: (arrVal, othVal).
	     *
	     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...Array} [values] The values to exclude.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     *
	     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
	     * // => [{ 'x': 2, 'y': 1 }]
	     */
	    var differenceWith = baseRest(function(array, values) {
	      var comparator = last(values);
	      if (isArrayLikeObject(comparator)) {
	        comparator = undefined;
	      }
	      return isArrayLikeObject(array)
	        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined, comparator)
	        : [];
	    });
	
	    /**
	     * Creates a slice of `array` with `n` elements dropped from the beginning.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.5.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to drop.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.drop([1, 2, 3]);
	     * // => [2, 3]
	     *
	     * _.drop([1, 2, 3], 2);
	     * // => [3]
	     *
	     * _.drop([1, 2, 3], 5);
	     * // => []
	     *
	     * _.drop([1, 2, 3], 0);
	     * // => [1, 2, 3]
	     */
	    function drop(array, n, guard) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      n = (guard || n === undefined) ? 1 : toInteger(n);
	      return baseSlice(array, n < 0 ? 0 : n, length);
	    }
	
	    /**
	     * Creates a slice of `array` with `n` elements dropped from the end.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to drop.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.dropRight([1, 2, 3]);
	     * // => [1, 2]
	     *
	     * _.dropRight([1, 2, 3], 2);
	     * // => [1]
	     *
	     * _.dropRight([1, 2, 3], 5);
	     * // => []
	     *
	     * _.dropRight([1, 2, 3], 0);
	     * // => [1, 2, 3]
	     */
	    function dropRight(array, n, guard) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      n = (guard || n === undefined) ? 1 : toInteger(n);
	      n = length - n;
	      return baseSlice(array, 0, n < 0 ? 0 : n);
	    }
	
	    /**
	     * Creates a slice of `array` excluding elements dropped from the end.
	     * Elements are dropped until `predicate` returns falsey. The predicate is
	     * invoked with three arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': true },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': false }
	     * ];
	     *
	     * _.dropRightWhile(users, function(o) { return !o.active; });
	     * // => objects for ['barney']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
	     * // => objects for ['barney', 'fred']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.dropRightWhile(users, ['active', false]);
	     * // => objects for ['barney']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.dropRightWhile(users, 'active');
	     * // => objects for ['barney', 'fred', 'pebbles']
	     */
	    function dropRightWhile(array, predicate) {
	      return (array && array.length)
	        ? baseWhile(array, getIteratee(predicate, 3), true, true)
	        : [];
	    }
	
	    /**
	     * Creates a slice of `array` excluding elements dropped from the beginning.
	     * Elements are dropped until `predicate` returns falsey. The predicate is
	     * invoked with three arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': false },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': true }
	     * ];
	     *
	     * _.dropWhile(users, function(o) { return !o.active; });
	     * // => objects for ['pebbles']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.dropWhile(users, { 'user': 'barney', 'active': false });
	     * // => objects for ['fred', 'pebbles']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.dropWhile(users, ['active', false]);
	     * // => objects for ['pebbles']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.dropWhile(users, 'active');
	     * // => objects for ['barney', 'fred', 'pebbles']
	     */
	    function dropWhile(array, predicate) {
	      return (array && array.length)
	        ? baseWhile(array, getIteratee(predicate, 3), true)
	        : [];
	    }
	
	    /**
	     * Fills elements of `array` with `value` from `start` up to, but not
	     * including, `end`.
	     *
	     * **Note:** This method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.2.0
	     * @category Array
	     * @param {Array} array The array to fill.
	     * @param {*} value The value to fill `array` with.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [1, 2, 3];
	     *
	     * _.fill(array, 'a');
	     * console.log(array);
	     * // => ['a', 'a', 'a']
	     *
	     * _.fill(Array(3), 2);
	     * // => [2, 2, 2]
	     *
	     * _.fill([4, 6, 8, 10], '*', 1, 3);
	     * // => [4, '*', '*', 10]
	     */
	    function fill(array, value, start, end) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
	        start = 0;
	        end = length;
	      }
	      return baseFill(array, value, start, end);
	    }
	
	    /**
	     * This method is like `_.find` except that it returns the index of the first
	     * element `predicate` returns truthy for instead of the element itself.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @returns {number} Returns the index of the found element, else `-1`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': false },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': true }
	     * ];
	     *
	     * _.findIndex(users, function(o) { return o.user == 'barney'; });
	     * // => 0
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findIndex(users, { 'user': 'fred', 'active': false });
	     * // => 1
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findIndex(users, ['active', false]);
	     * // => 0
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findIndex(users, 'active');
	     * // => 2
	     */
	    function findIndex(array, predicate, fromIndex) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return -1;
	      }
	      var index = fromIndex == null ? 0 : toInteger(fromIndex);
	      if (index < 0) {
	        index = nativeMax(length + index, 0);
	      }
	      return baseFindIndex(array, getIteratee(predicate, 3), index);
	    }
	
	    /**
	     * This method is like `_.findIndex` except that it iterates over elements
	     * of `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param {number} [fromIndex=array.length-1] The index to search from.
	     * @returns {number} Returns the index of the found element, else `-1`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': true },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': false }
	     * ];
	     *
	     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
	     * // => 2
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
	     * // => 0
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findLastIndex(users, ['active', false]);
	     * // => 2
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findLastIndex(users, 'active');
	     * // => 0
	     */
	    function findLastIndex(array, predicate, fromIndex) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return -1;
	      }
	      var index = length - 1;
	      if (fromIndex !== undefined) {
	        index = toInteger(fromIndex);
	        index = fromIndex < 0
	          ? nativeMax(length + index, 0)
	          : nativeMin(index, length - 1);
	      }
	      return baseFindIndex(array, getIteratee(predicate, 3), index, true);
	    }
	
	    /**
	     * Flattens `array` a single level deep.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to flatten.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * _.flatten([1, [2, [3, [4]], 5]]);
	     * // => [1, 2, [3, [4]], 5]
	     */
	    function flatten(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? baseFlatten(array, 1) : [];
	    }
	
	    /**
	     * Recursively flattens `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to flatten.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * _.flattenDeep([1, [2, [3, [4]], 5]]);
	     * // => [1, 2, 3, 4, 5]
	     */
	    function flattenDeep(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? baseFlatten(array, INFINITY) : [];
	    }
	
	    /**
	     * Recursively flatten `array` up to `depth` times.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.4.0
	     * @category Array
	     * @param {Array} array The array to flatten.
	     * @param {number} [depth=1] The maximum recursion depth.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * var array = [1, [2, [3, [4]], 5]];
	     *
	     * _.flattenDepth(array, 1);
	     * // => [1, 2, [3, [4]], 5]
	     *
	     * _.flattenDepth(array, 2);
	     * // => [1, 2, 3, [4], 5]
	     */
	    function flattenDepth(array, depth) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      depth = depth === undefined ? 1 : toInteger(depth);
	      return baseFlatten(array, depth);
	    }
	
	    /**
	     * The inverse of `_.toPairs`; this method returns an object composed
	     * from key-value `pairs`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} pairs The key-value pairs.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * _.fromPairs([['a', 1], ['b', 2]]);
	     * // => { 'a': 1, 'b': 2 }
	     */
	    function fromPairs(pairs) {
	      var index = -1,
	          length = pairs == null ? 0 : pairs.length,
	          result = {};
	
	      while (++index < length) {
	        var pair = pairs[index];
	        result[pair[0]] = pair[1];
	      }
	      return result;
	    }
	
	    /**
	     * Gets the first element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @alias first
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {*} Returns the first element of `array`.
	     * @example
	     *
	     * _.head([1, 2, 3]);
	     * // => 1
	     *
	     * _.head([]);
	     * // => undefined
	     */
	    function head(array) {
	      return (array && array.length) ? array[0] : undefined;
	    }
	
	    /**
	     * Gets the index at which the first occurrence of `value` is found in `array`
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons. If `fromIndex` is negative, it's used as the
	     * offset from the end of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {*} value The value to search for.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.indexOf([1, 2, 1, 2], 2);
	     * // => 1
	     *
	     * // Search from the `fromIndex`.
	     * _.indexOf([1, 2, 1, 2], 2, 2);
	     * // => 3
	     */
	    function indexOf(array, value, fromIndex) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return -1;
	      }
	      var index = fromIndex == null ? 0 : toInteger(fromIndex);
	      if (index < 0) {
	        index = nativeMax(length + index, 0);
	      }
	      return baseIndexOf(array, value, index);
	    }
	
	    /**
	     * Gets all but the last element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.initial([1, 2, 3]);
	     * // => [1, 2]
	     */
	    function initial(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? baseSlice(array, 0, -1) : [];
	    }
	
	    /**
	     * Creates an array of unique values that are included in all given arrays
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons. The order and references of result values are
	     * determined by the first array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @returns {Array} Returns the new array of intersecting values.
	     * @example
	     *
	     * _.intersection([2, 1], [2, 3]);
	     * // => [2]
	     */
	    var intersection = baseRest(function(arrays) {
	      var mapped = arrayMap(arrays, castArrayLikeObject);
	      return (mapped.length && mapped[0] === arrays[0])
	        ? baseIntersection(mapped)
	        : [];
	    });
	
	    /**
	     * This method is like `_.intersection` except that it accepts `iteratee`
	     * which is invoked for each element of each `arrays` to generate the criterion
	     * by which they're compared. The order and references of result values are
	     * determined by the first array. The iteratee is invoked with one argument:
	     * (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new array of intersecting values.
	     * @example
	     *
	     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
	     * // => [2.1]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 1 }]
	     */
	    var intersectionBy = baseRest(function(arrays) {
	      var iteratee = last(arrays),
	          mapped = arrayMap(arrays, castArrayLikeObject);
	
	      if (iteratee === last(mapped)) {
	        iteratee = undefined;
	      } else {
	        mapped.pop();
	      }
	      return (mapped.length && mapped[0] === arrays[0])
	        ? baseIntersection(mapped, getIteratee(iteratee, 2))
	        : [];
	    });
	
	    /**
	     * This method is like `_.intersection` except that it accepts `comparator`
	     * which is invoked to compare elements of `arrays`. The order and references
	     * of result values are determined by the first array. The comparator is
	     * invoked with two arguments: (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of intersecting values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
	     *
	     * _.intersectionWith(objects, others, _.isEqual);
	     * // => [{ 'x': 1, 'y': 2 }]
	     */
	    var intersectionWith = baseRest(function(arrays) {
	      var comparator = last(arrays),
	          mapped = arrayMap(arrays, castArrayLikeObject);
	
	      comparator = typeof comparator == 'function' ? comparator : undefined;
	      if (comparator) {
	        mapped.pop();
	      }
	      return (mapped.length && mapped[0] === arrays[0])
	        ? baseIntersection(mapped, undefined, comparator)
	        : [];
	    });
	
	    /**
	     * Converts all elements in `array` into a string separated by `separator`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to convert.
	     * @param {string} [separator=','] The element separator.
	     * @returns {string} Returns the joined string.
	     * @example
	     *
	     * _.join(['a', 'b', 'c'], '~');
	     * // => 'a~b~c'
	     */
	    function join(array, separator) {
	      return array == null ? '' : nativeJoin.call(array, separator);
	    }
	
	    /**
	     * Gets the last element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {*} Returns the last element of `array`.
	     * @example
	     *
	     * _.last([1, 2, 3]);
	     * // => 3
	     */
	    function last(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? array[length - 1] : undefined;
	    }
	
	    /**
	     * This method is like `_.indexOf` except that it iterates over elements of
	     * `array` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {*} value The value to search for.
	     * @param {number} [fromIndex=array.length-1] The index to search from.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.lastIndexOf([1, 2, 1, 2], 2);
	     * // => 3
	     *
	     * // Search from the `fromIndex`.
	     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
	     * // => 1
	     */
	    function lastIndexOf(array, value, fromIndex) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return -1;
	      }
	      var index = length;
	      if (fromIndex !== undefined) {
	        index = toInteger(fromIndex);
	        index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
	      }
	      return value === value
	        ? strictLastIndexOf(array, value, index)
	        : baseFindIndex(array, baseIsNaN, index, true);
	    }
	
	    /**
	     * Gets the element at index `n` of `array`. If `n` is negative, the nth
	     * element from the end is returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.11.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=0] The index of the element to return.
	     * @returns {*} Returns the nth element of `array`.
	     * @example
	     *
	     * var array = ['a', 'b', 'c', 'd'];
	     *
	     * _.nth(array, 1);
	     * // => 'b'
	     *
	     * _.nth(array, -2);
	     * // => 'c';
	     */
	    function nth(array, n) {
	      return (array && array.length) ? baseNth(array, toInteger(n)) : undefined;
	    }
	
	    /**
	     * Removes all given values from `array` using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
	     * to remove elements from an array by predicate.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {...*} [values] The values to remove.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
	     *
	     * _.pull(array, 'a', 'c');
	     * console.log(array);
	     * // => ['b', 'b']
	     */
	    var pull = baseRest(pullAll);
	
	    /**
	     * This method is like `_.pull` except that it accepts an array of values to remove.
	     *
	     * **Note:** Unlike `_.difference`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
	     *
	     * _.pullAll(array, ['a', 'c']);
	     * console.log(array);
	     * // => ['b', 'b']
	     */
	    function pullAll(array, values) {
	      return (array && array.length && values && values.length)
	        ? basePullAll(array, values)
	        : array;
	    }
	
	    /**
	     * This method is like `_.pullAll` except that it accepts `iteratee` which is
	     * invoked for each element of `array` and `values` to generate the criterion
	     * by which they're compared. The iteratee is invoked with one argument: (value).
	     *
	     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
	     *
	     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
	     * console.log(array);
	     * // => [{ 'x': 2 }]
	     */
	    function pullAllBy(array, values, iteratee) {
	      return (array && array.length && values && values.length)
	        ? basePullAll(array, values, getIteratee(iteratee, 2))
	        : array;
	    }
	
	    /**
	     * This method is like `_.pullAll` except that it accepts `comparator` which
	     * is invoked to compare elements of `array` to `values`. The comparator is
	     * invoked with two arguments: (arrVal, othVal).
	     *
	     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.6.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
	     *
	     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
	     * console.log(array);
	     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
	     */
	    function pullAllWith(array, values, comparator) {
	      return (array && array.length && values && values.length)
	        ? basePullAll(array, values, undefined, comparator)
	        : array;
	    }
	
	    /**
	     * Removes elements from `array` corresponding to `indexes` and returns an
	     * array of removed elements.
	     *
	     * **Note:** Unlike `_.at`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
	     * @returns {Array} Returns the new array of removed elements.
	     * @example
	     *
	     * var array = ['a', 'b', 'c', 'd'];
	     * var pulled = _.pullAt(array, [1, 3]);
	     *
	     * console.log(array);
	     * // => ['a', 'c']
	     *
	     * console.log(pulled);
	     * // => ['b', 'd']
	     */
	    var pullAt = flatRest(function(array, indexes) {
	      var length = array == null ? 0 : array.length,
	          result = baseAt(array, indexes);
	
	      basePullAt(array, arrayMap(indexes, function(index) {
	        return isIndex(index, length) ? +index : index;
	      }).sort(compareAscending));
	
	      return result;
	    });
	
	    /**
	     * Removes all elements from `array` that `predicate` returns truthy for
	     * and returns an array of the removed elements. The predicate is invoked
	     * with three arguments: (value, index, array).
	     *
	     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
	     * to pull elements from an array by value.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new array of removed elements.
	     * @example
	     *
	     * var array = [1, 2, 3, 4];
	     * var evens = _.remove(array, function(n) {
	     *   return n % 2 == 0;
	     * });
	     *
	     * console.log(array);
	     * // => [1, 3]
	     *
	     * console.log(evens);
	     * // => [2, 4]
	     */
	    function remove(array, predicate) {
	      var result = [];
	      if (!(array && array.length)) {
	        return result;
	      }
	      var index = -1,
	          indexes = [],
	          length = array.length;
	
	      predicate = getIteratee(predicate, 3);
	      while (++index < length) {
	        var value = array[index];
	        if (predicate(value, index, array)) {
	          result.push(value);
	          indexes.push(index);
	        }
	      }
	      basePullAt(array, indexes);
	      return result;
	    }
	
	    /**
	     * Reverses `array` so that the first element becomes the last, the second
	     * element becomes the second to last, and so on.
	     *
	     * **Note:** This method mutates `array` and is based on
	     * [`Array#reverse`](https://mdn.io/Array/reverse).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [1, 2, 3];
	     *
	     * _.reverse(array);
	     * // => [3, 2, 1]
	     *
	     * console.log(array);
	     * // => [3, 2, 1]
	     */
	    function reverse(array) {
	      return array == null ? array : nativeReverse.call(array);
	    }
	
	    /**
	     * Creates a slice of `array` from `start` up to, but not including, `end`.
	     *
	     * **Note:** This method is used instead of
	     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
	     * returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to slice.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns the slice of `array`.
	     */
	    function slice(array, start, end) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
	        start = 0;
	        end = length;
	      }
	      else {
	        start = start == null ? 0 : toInteger(start);
	        end = end === undefined ? length : toInteger(end);
	      }
	      return baseSlice(array, start, end);
	    }
	
	    /**
	     * Uses a binary search to determine the lowest index at which `value`
	     * should be inserted into `array` in order to maintain its sort order.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * _.sortedIndex([30, 50], 40);
	     * // => 1
	     */
	    function sortedIndex(array, value) {
	      return baseSortedIndex(array, value);
	    }
	
	    /**
	     * This method is like `_.sortedIndex` except that it accepts `iteratee`
	     * which is invoked for `value` and each element of `array` to compute their
	     * sort ranking. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * var objects = [{ 'x': 4 }, { 'x': 5 }];
	     *
	     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
	     * // => 0
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
	     * // => 0
	     */
	    function sortedIndexBy(array, value, iteratee) {
	      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
	    }
	
	    /**
	     * This method is like `_.indexOf` except that it performs a binary
	     * search on a sorted `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {*} value The value to search for.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
	     * // => 1
	     */
	    function sortedIndexOf(array, value) {
	      var length = array == null ? 0 : array.length;
	      if (length) {
	        var index = baseSortedIndex(array, value);
	        if (index < length && eq(array[index], value)) {
	          return index;
	        }
	      }
	      return -1;
	    }
	
	    /**
	     * This method is like `_.sortedIndex` except that it returns the highest
	     * index at which `value` should be inserted into `array` in order to
	     * maintain its sort order.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
	     * // => 4
	     */
	    function sortedLastIndex(array, value) {
	      return baseSortedIndex(array, value, true);
	    }
	
	    /**
	     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
	     * which is invoked for `value` and each element of `array` to compute their
	     * sort ranking. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * var objects = [{ 'x': 4 }, { 'x': 5 }];
	     *
	     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
	     * // => 1
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
	     * // => 1
	     */
	    function sortedLastIndexBy(array, value, iteratee) {
	      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
	    }
	
	    /**
	     * This method is like `_.lastIndexOf` except that it performs a binary
	     * search on a sorted `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {*} value The value to search for.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
	     * // => 3
	     */
	    function sortedLastIndexOf(array, value) {
	      var length = array == null ? 0 : array.length;
	      if (length) {
	        var index = baseSortedIndex(array, value, true) - 1;
	        if (eq(array[index], value)) {
	          return index;
	        }
	      }
	      return -1;
	    }
	
	    /**
	     * This method is like `_.uniq` except that it's designed and optimized
	     * for sorted arrays.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.sortedUniq([1, 1, 2]);
	     * // => [1, 2]
	     */
	    function sortedUniq(array) {
	      return (array && array.length)
	        ? baseSortedUniq(array)
	        : [];
	    }
	
	    /**
	     * This method is like `_.uniqBy` except that it's designed and optimized
	     * for sorted arrays.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
	     * // => [1.1, 2.3]
	     */
	    function sortedUniqBy(array, iteratee) {
	      return (array && array.length)
	        ? baseSortedUniq(array, getIteratee(iteratee, 2))
	        : [];
	    }
	
	    /**
	     * Gets all but the first element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.tail([1, 2, 3]);
	     * // => [2, 3]
	     */
	    function tail(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? baseSlice(array, 1, length) : [];
	    }
	
	    /**
	     * Creates a slice of `array` with `n` elements taken from the beginning.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to take.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.take([1, 2, 3]);
	     * // => [1]
	     *
	     * _.take([1, 2, 3], 2);
	     * // => [1, 2]
	     *
	     * _.take([1, 2, 3], 5);
	     * // => [1, 2, 3]
	     *
	     * _.take([1, 2, 3], 0);
	     * // => []
	     */
	    function take(array, n, guard) {
	      if (!(array && array.length)) {
	        return [];
	      }
	      n = (guard || n === undefined) ? 1 : toInteger(n);
	      return baseSlice(array, 0, n < 0 ? 0 : n);
	    }
	
	    /**
	     * Creates a slice of `array` with `n` elements taken from the end.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to take.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.takeRight([1, 2, 3]);
	     * // => [3]
	     *
	     * _.takeRight([1, 2, 3], 2);
	     * // => [2, 3]
	     *
	     * _.takeRight([1, 2, 3], 5);
	     * // => [1, 2, 3]
	     *
	     * _.takeRight([1, 2, 3], 0);
	     * // => []
	     */
	    function takeRight(array, n, guard) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      n = (guard || n === undefined) ? 1 : toInteger(n);
	      n = length - n;
	      return baseSlice(array, n < 0 ? 0 : n, length);
	    }
	
	    /**
	     * Creates a slice of `array` with elements taken from the end. Elements are
	     * taken until `predicate` returns falsey. The predicate is invoked with
	     * three arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': true },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': false }
	     * ];
	     *
	     * _.takeRightWhile(users, function(o) { return !o.active; });
	     * // => objects for ['fred', 'pebbles']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
	     * // => objects for ['pebbles']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.takeRightWhile(users, ['active', false]);
	     * // => objects for ['fred', 'pebbles']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.takeRightWhile(users, 'active');
	     * // => []
	     */
	    function takeRightWhile(array, predicate) {
	      return (array && array.length)
	        ? baseWhile(array, getIteratee(predicate, 3), false, true)
	        : [];
	    }
	
	    /**
	     * Creates a slice of `array` with elements taken from the beginning. Elements
	     * are taken until `predicate` returns falsey. The predicate is invoked with
	     * three arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': false },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': true }
	     * ];
	     *
	     * _.takeWhile(users, function(o) { return !o.active; });
	     * // => objects for ['barney', 'fred']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.takeWhile(users, { 'user': 'barney', 'active': false });
	     * // => objects for ['barney']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.takeWhile(users, ['active', false]);
	     * // => objects for ['barney', 'fred']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.takeWhile(users, 'active');
	     * // => []
	     */
	    function takeWhile(array, predicate) {
	      return (array && array.length)
	        ? baseWhile(array, getIteratee(predicate, 3))
	        : [];
	    }
	
	    /**
	     * Creates an array of unique values, in order, from all given arrays using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @returns {Array} Returns the new array of combined values.
	     * @example
	     *
	     * _.union([2], [1, 2]);
	     * // => [2, 1]
	     */
	    var union = baseRest(function(arrays) {
	      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
	    });
	
	    /**
	     * This method is like `_.union` except that it accepts `iteratee` which is
	     * invoked for each element of each `arrays` to generate the criterion by
	     * which uniqueness is computed. Result values are chosen from the first
	     * array in which the value occurs. The iteratee is invoked with one argument:
	     * (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new array of combined values.
	     * @example
	     *
	     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
	     * // => [2.1, 1.2]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 1 }, { 'x': 2 }]
	     */
	    var unionBy = baseRest(function(arrays) {
	      var iteratee = last(arrays);
	      if (isArrayLikeObject(iteratee)) {
	        iteratee = undefined;
	      }
	      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2));
	    });
	
	    /**
	     * This method is like `_.union` except that it accepts `comparator` which
	     * is invoked to compare elements of `arrays`. Result values are chosen from
	     * the first array in which the value occurs. The comparator is invoked
	     * with two arguments: (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of combined values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
	     *
	     * _.unionWith(objects, others, _.isEqual);
	     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
	     */
	    var unionWith = baseRest(function(arrays) {
	      var comparator = last(arrays);
	      comparator = typeof comparator == 'function' ? comparator : undefined;
	      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator);
	    });
	
	    /**
	     * Creates a duplicate-free version of an array, using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons, in which only the first occurrence of each element
	     * is kept. The order of result values is determined by the order they occur
	     * in the array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.uniq([2, 1, 2]);
	     * // => [2, 1]
	     */
	    function uniq(array) {
	      return (array && array.length) ? baseUniq(array) : [];
	    }
	
	    /**
	     * This method is like `_.uniq` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the criterion by which
	     * uniqueness is computed. The order of result values is determined by the
	     * order they occur in the array. The iteratee is invoked with one argument:
	     * (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
	     * // => [2.1, 1.2]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 1 }, { 'x': 2 }]
	     */
	    function uniqBy(array, iteratee) {
	      return (array && array.length) ? baseUniq(array, getIteratee(iteratee, 2)) : [];
	    }
	
	    /**
	     * This method is like `_.uniq` except that it accepts `comparator` which
	     * is invoked to compare elements of `array`. The order of result values is
	     * determined by the order they occur in the array.The comparator is invoked
	     * with two arguments: (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
	     *
	     * _.uniqWith(objects, _.isEqual);
	     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
	     */
	    function uniqWith(array, comparator) {
	      comparator = typeof comparator == 'function' ? comparator : undefined;
	      return (array && array.length) ? baseUniq(array, undefined, comparator) : [];
	    }
	
	    /**
	     * This method is like `_.zip` except that it accepts an array of grouped
	     * elements and creates an array regrouping the elements to their pre-zip
	     * configuration.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.2.0
	     * @category Array
	     * @param {Array} array The array of grouped elements to process.
	     * @returns {Array} Returns the new array of regrouped elements.
	     * @example
	     *
	     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
	     * // => [['a', 1, true], ['b', 2, false]]
	     *
	     * _.unzip(zipped);
	     * // => [['a', 'b'], [1, 2], [true, false]]
	     */
	    function unzip(array) {
	      if (!(array && array.length)) {
	        return [];
	      }
	      var length = 0;
	      array = arrayFilter(array, function(group) {
	        if (isArrayLikeObject(group)) {
	          length = nativeMax(group.length, length);
	          return true;
	        }
	      });
	      return baseTimes(length, function(index) {
	        return arrayMap(array, baseProperty(index));
	      });
	    }
	
	    /**
	     * This method is like `_.unzip` except that it accepts `iteratee` to specify
	     * how regrouped values should be combined. The iteratee is invoked with the
	     * elements of each group: (...group).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.8.0
	     * @category Array
	     * @param {Array} array The array of grouped elements to process.
	     * @param {Function} [iteratee=_.identity] The function to combine
	     *  regrouped values.
	     * @returns {Array} Returns the new array of regrouped elements.
	     * @example
	     *
	     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
	     * // => [[1, 10, 100], [2, 20, 200]]
	     *
	     * _.unzipWith(zipped, _.add);
	     * // => [3, 30, 300]
	     */
	    function unzipWith(array, iteratee) {
	      if (!(array && array.length)) {
	        return [];
	      }
	      var result = unzip(array);
	      if (iteratee == null) {
	        return result;
	      }
	      return arrayMap(result, function(group) {
	        return apply(iteratee, undefined, group);
	      });
	    }
	
	    /**
	     * Creates an array excluding all given values using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * **Note:** Unlike `_.pull`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...*} [values] The values to exclude.
	     * @returns {Array} Returns the new array of filtered values.
	     * @see _.difference, _.xor
	     * @example
	     *
	     * _.without([2, 1, 2, 3], 1, 2);
	     * // => [3]
	     */
	    var without = baseRest(function(array, values) {
	      return isArrayLikeObject(array)
	        ? baseDifference(array, values)
	        : [];
	    });
	
	    /**
	     * Creates an array of unique values that is the
	     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
	     * of the given arrays. The order of result values is determined by the order
	     * they occur in the arrays.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @returns {Array} Returns the new array of filtered values.
	     * @see _.difference, _.without
	     * @example
	     *
	     * _.xor([2, 1], [2, 3]);
	     * // => [1, 3]
	     */
	    var xor = baseRest(function(arrays) {
	      return baseXor(arrayFilter(arrays, isArrayLikeObject));
	    });
	
	    /**
	     * This method is like `_.xor` except that it accepts `iteratee` which is
	     * invoked for each element of each `arrays` to generate the criterion by
	     * which by which they're compared. The order of result values is determined
	     * by the order they occur in the arrays. The iteratee is invoked with one
	     * argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
	     * // => [1.2, 3.4]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 2 }]
	     */
	    var xorBy = baseRest(function(arrays) {
	      var iteratee = last(arrays);
	      if (isArrayLikeObject(iteratee)) {
	        iteratee = undefined;
	      }
	      return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2));
	    });
	
	    /**
	     * This method is like `_.xor` except that it accepts `comparator` which is
	     * invoked to compare elements of `arrays`. The order of result values is
	     * determined by the order they occur in the arrays. The comparator is invoked
	     * with two arguments: (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
	     *
	     * _.xorWith(objects, others, _.isEqual);
	     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
	     */
	    var xorWith = baseRest(function(arrays) {
	      var comparator = last(arrays);
	      comparator = typeof comparator == 'function' ? comparator : undefined;
	      return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined, comparator);
	    });
	
	    /**
	     * Creates an array of grouped elements, the first of which contains the
	     * first elements of the given arrays, the second of which contains the
	     * second elements of the given arrays, and so on.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to process.
	     * @returns {Array} Returns the new array of grouped elements.
	     * @example
	     *
	     * _.zip(['a', 'b'], [1, 2], [true, false]);
	     * // => [['a', 1, true], ['b', 2, false]]
	     */
	    var zip = baseRest(unzip);
	
	    /**
	     * This method is like `_.fromPairs` except that it accepts two arrays,
	     * one of property identifiers and one of corresponding values.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.4.0
	     * @category Array
	     * @param {Array} [props=[]] The property identifiers.
	     * @param {Array} [values=[]] The property values.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * _.zipObject(['a', 'b'], [1, 2]);
	     * // => { 'a': 1, 'b': 2 }
	     */
	    function zipObject(props, values) {
	      return baseZipObject(props || [], values || [], assignValue);
	    }
	
	    /**
	     * This method is like `_.zipObject` except that it supports property paths.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.1.0
	     * @category Array
	     * @param {Array} [props=[]] The property identifiers.
	     * @param {Array} [values=[]] The property values.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
	     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
	     */
	    function zipObjectDeep(props, values) {
	      return baseZipObject(props || [], values || [], baseSet);
	    }
	
	    /**
	     * This method is like `_.zip` except that it accepts `iteratee` to specify
	     * how grouped values should be combined. The iteratee is invoked with the
	     * elements of each group: (...group).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.8.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to process.
	     * @param {Function} [iteratee=_.identity] The function to combine
	     *  grouped values.
	     * @returns {Array} Returns the new array of grouped elements.
	     * @example
	     *
	     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
	     *   return a + b + c;
	     * });
	     * // => [111, 222]
	     */
	    var zipWith = baseRest(function(arrays) {
	      var length = arrays.length,
	          iteratee = length > 1 ? arrays[length - 1] : undefined;
	
	      iteratee = typeof iteratee == 'function' ? (arrays.pop(), iteratee) : undefined;
	      return unzipWith(arrays, iteratee);
	    });
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
	     * chain sequences enabled. The result of such sequences must be unwrapped
	     * with `_#value`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.3.0
	     * @category Seq
	     * @param {*} value The value to wrap.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'age': 36 },
	     *   { 'user': 'fred',    'age': 40 },
	     *   { 'user': 'pebbles', 'age': 1 }
	     * ];
	     *
	     * var youngest = _
	     *   .chain(users)
	     *   .sortBy('age')
	     *   .map(function(o) {
	     *     return o.user + ' is ' + o.age;
	     *   })
	     *   .head()
	     *   .value();
	     * // => 'pebbles is 1'
	     */
	    function chain(value) {
	      var result = lodash(value);
	      result.__chain__ = true;
	      return result;
	    }
	
	    /**
	     * This method invokes `interceptor` and returns `value`. The interceptor
	     * is invoked with one argument; (value). The purpose of this method is to
	     * "tap into" a method chain sequence in order to modify intermediate results.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Seq
	     * @param {*} value The value to provide to `interceptor`.
	     * @param {Function} interceptor The function to invoke.
	     * @returns {*} Returns `value`.
	     * @example
	     *
	     * _([1, 2, 3])
	     *  .tap(function(array) {
	     *    // Mutate input array.
	     *    array.pop();
	     *  })
	     *  .reverse()
	     *  .value();
	     * // => [2, 1]
	     */
	    function tap(value, interceptor) {
	      interceptor(value);
	      return value;
	    }
	
	    /**
	     * This method is like `_.tap` except that it returns the result of `interceptor`.
	     * The purpose of this method is to "pass thru" values replacing intermediate
	     * results in a method chain sequence.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Seq
	     * @param {*} value The value to provide to `interceptor`.
	     * @param {Function} interceptor The function to invoke.
	     * @returns {*} Returns the result of `interceptor`.
	     * @example
	     *
	     * _('  abc  ')
	     *  .chain()
	     *  .trim()
	     *  .thru(function(value) {
	     *    return [value];
	     *  })
	     *  .value();
	     * // => ['abc']
	     */
	    function thru(value, interceptor) {
	      return interceptor(value);
	    }
	
	    /**
	     * This method is the wrapper version of `_.at`.
	     *
	     * @name at
	     * @memberOf _
	     * @since 1.0.0
	     * @category Seq
	     * @param {...(string|string[])} [paths] The property paths to pick.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
	     *
	     * _(object).at(['a[0].b.c', 'a[1]']).value();
	     * // => [3, 4]
	     */
	    var wrapperAt = flatRest(function(paths) {
	      var length = paths.length,
	          start = length ? paths[0] : 0,
	          value = this.__wrapped__,
	          interceptor = function(object) { return baseAt(object, paths); };
	
	      if (length > 1 || this.__actions__.length ||
	          !(value instanceof LazyWrapper) || !isIndex(start)) {
	        return this.thru(interceptor);
	      }
	      value = value.slice(start, +start + (length ? 1 : 0));
	      value.__actions__.push({
	        'func': thru,
	        'args': [interceptor],
	        'thisArg': undefined
	      });
	      return new LodashWrapper(value, this.__chain__).thru(function(array) {
	        if (length && !array.length) {
	          array.push(undefined);
	        }
	        return array;
	      });
	    });
	
	    /**
	     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
	     *
	     * @name chain
	     * @memberOf _
	     * @since 0.1.0
	     * @category Seq
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36 },
	     *   { 'user': 'fred',   'age': 40 }
	     * ];
	     *
	     * // A sequence without explicit chaining.
	     * _(users).head();
	     * // => { 'user': 'barney', 'age': 36 }
	     *
	     * // A sequence with explicit chaining.
	     * _(users)
	     *   .chain()
	     *   .head()
	     *   .pick('user')
	     *   .value();
	     * // => { 'user': 'barney' }
	     */
	    function wrapperChain() {
	      return chain(this);
	    }
	
	    /**
	     * Executes the chain sequence and returns the wrapped result.
	     *
	     * @name commit
	     * @memberOf _
	     * @since 3.2.0
	     * @category Seq
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var array = [1, 2];
	     * var wrapped = _(array).push(3);
	     *
	     * console.log(array);
	     * // => [1, 2]
	     *
	     * wrapped = wrapped.commit();
	     * console.log(array);
	     * // => [1, 2, 3]
	     *
	     * wrapped.last();
	     * // => 3
	     *
	     * console.log(array);
	     * // => [1, 2, 3]
	     */
	    function wrapperCommit() {
	      return new LodashWrapper(this.value(), this.__chain__);
	    }
	
	    /**
	     * Gets the next value on a wrapped object following the
	     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
	     *
	     * @name next
	     * @memberOf _
	     * @since 4.0.0
	     * @category Seq
	     * @returns {Object} Returns the next iterator value.
	     * @example
	     *
	     * var wrapped = _([1, 2]);
	     *
	     * wrapped.next();
	     * // => { 'done': false, 'value': 1 }
	     *
	     * wrapped.next();
	     * // => { 'done': false, 'value': 2 }
	     *
	     * wrapped.next();
	     * // => { 'done': true, 'value': undefined }
	     */
	    function wrapperNext() {
	      if (this.__values__ === undefined) {
	        this.__values__ = toArray(this.value());
	      }
	      var done = this.__index__ >= this.__values__.length,
	          value = done ? undefined : this.__values__[this.__index__++];
	
	      return { 'done': done, 'value': value };
	    }
	
	    /**
	     * Enables the wrapper to be iterable.
	     *
	     * @name Symbol.iterator
	     * @memberOf _
	     * @since 4.0.0
	     * @category Seq
	     * @returns {Object} Returns the wrapper object.
	     * @example
	     *
	     * var wrapped = _([1, 2]);
	     *
	     * wrapped[Symbol.iterator]() === wrapped;
	     * // => true
	     *
	     * Array.from(wrapped);
	     * // => [1, 2]
	     */
	    function wrapperToIterator() {
	      return this;
	    }
	
	    /**
	     * Creates a clone of the chain sequence planting `value` as the wrapped value.
	     *
	     * @name plant
	     * @memberOf _
	     * @since 3.2.0
	     * @category Seq
	     * @param {*} value The value to plant.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var wrapped = _([1, 2]).map(square);
	     * var other = wrapped.plant([3, 4]);
	     *
	     * other.value();
	     * // => [9, 16]
	     *
	     * wrapped.value();
	     * // => [1, 4]
	     */
	    function wrapperPlant(value) {
	      var result,
	          parent = this;
	
	      while (parent instanceof baseLodash) {
	        var clone = wrapperClone(parent);
	        clone.__index__ = 0;
	        clone.__values__ = undefined;
	        if (result) {
	          previous.__wrapped__ = clone;
	        } else {
	          result = clone;
	        }
	        var previous = clone;
	        parent = parent.__wrapped__;
	      }
	      previous.__wrapped__ = value;
	      return result;
	    }
	
	    /**
	     * This method is the wrapper version of `_.reverse`.
	     *
	     * **Note:** This method mutates the wrapped array.
	     *
	     * @name reverse
	     * @memberOf _
	     * @since 0.1.0
	     * @category Seq
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var array = [1, 2, 3];
	     *
	     * _(array).reverse().value()
	     * // => [3, 2, 1]
	     *
	     * console.log(array);
	     * // => [3, 2, 1]
	     */
	    function wrapperReverse() {
	      var value = this.__wrapped__;
	      if (value instanceof LazyWrapper) {
	        var wrapped = value;
	        if (this.__actions__.length) {
	          wrapped = new LazyWrapper(this);
	        }
	        wrapped = wrapped.reverse();
	        wrapped.__actions__.push({
	          'func': thru,
	          'args': [reverse],
	          'thisArg': undefined
	        });
	        return new LodashWrapper(wrapped, this.__chain__);
	      }
	      return this.thru(reverse);
	    }
	
	    /**
	     * Executes the chain sequence to resolve the unwrapped value.
	     *
	     * @name value
	     * @memberOf _
	     * @since 0.1.0
	     * @alias toJSON, valueOf
	     * @category Seq
	     * @returns {*} Returns the resolved unwrapped value.
	     * @example
	     *
	     * _([1, 2, 3]).value();
	     * // => [1, 2, 3]
	     */
	    function wrapperValue() {
	      return baseWrapperValue(this.__wrapped__, this.__actions__);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates an object composed of keys generated from the results of running
	     * each element of `collection` thru `iteratee`. The corresponding value of
	     * each key is the number of times the key was returned by `iteratee`. The
	     * iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.5.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
	     * @returns {Object} Returns the composed aggregate object.
	     * @example
	     *
	     * _.countBy([6.1, 4.2, 6.3], Math.floor);
	     * // => { '4': 1, '6': 2 }
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.countBy(['one', 'two', 'three'], 'length');
	     * // => { '3': 2, '5': 1 }
	     */
	    var countBy = createAggregator(function(result, value, key) {
	      if (hasOwnProperty.call(result, key)) {
	        ++result[key];
	      } else {
	        baseAssignValue(result, key, 1);
	      }
	    });
	
	    /**
	     * Checks if `predicate` returns truthy for **all** elements of `collection`.
	     * Iteration is stopped once `predicate` returns falsey. The predicate is
	     * invoked with three arguments: (value, index|key, collection).
	     *
	     * **Note:** This method returns `true` for
	     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
	     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
	     * elements of empty collections.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {boolean} Returns `true` if all elements pass the predicate check,
	     *  else `false`.
	     * @example
	     *
	     * _.every([true, 1, null, 'yes'], Boolean);
	     * // => false
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': false },
	     *   { 'user': 'fred',   'age': 40, 'active': false }
	     * ];
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.every(users, { 'user': 'barney', 'active': false });
	     * // => false
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.every(users, ['active', false]);
	     * // => true
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.every(users, 'active');
	     * // => false
	     */
	    function every(collection, predicate, guard) {
	      var func = isArray(collection) ? arrayEvery : baseEvery;
	      if (guard && isIterateeCall(collection, predicate, guard)) {
	        predicate = undefined;
	      }
	      return func(collection, getIteratee(predicate, 3));
	    }
	
	    /**
	     * Iterates over elements of `collection`, returning an array of all elements
	     * `predicate` returns truthy for. The predicate is invoked with three
	     * arguments: (value, index|key, collection).
	     *
	     * **Note:** Unlike `_.remove`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new filtered array.
	     * @see _.reject
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': true },
	     *   { 'user': 'fred',   'age': 40, 'active': false }
	     * ];
	     *
	     * _.filter(users, function(o) { return !o.active; });
	     * // => objects for ['fred']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.filter(users, { 'age': 36, 'active': true });
	     * // => objects for ['barney']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.filter(users, ['active', false]);
	     * // => objects for ['fred']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.filter(users, 'active');
	     * // => objects for ['barney']
	     */
	    function filter(collection, predicate) {
	      var func = isArray(collection) ? arrayFilter : baseFilter;
	      return func(collection, getIteratee(predicate, 3));
	    }
	
	    /**
	     * Iterates over elements of `collection`, returning the first element
	     * `predicate` returns truthy for. The predicate is invoked with three
	     * arguments: (value, index|key, collection).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @returns {*} Returns the matched element, else `undefined`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'age': 36, 'active': true },
	     *   { 'user': 'fred',    'age': 40, 'active': false },
	     *   { 'user': 'pebbles', 'age': 1,  'active': true }
	     * ];
	     *
	     * _.find(users, function(o) { return o.age < 40; });
	     * // => object for 'barney'
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.find(users, { 'age': 1, 'active': true });
	     * // => object for 'pebbles'
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.find(users, ['active', false]);
	     * // => object for 'fred'
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.find(users, 'active');
	     * // => object for 'barney'
	     */
	    var find = createFind(findIndex);
	
	    /**
	     * This method is like `_.find` except that it iterates over elements of
	     * `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param {number} [fromIndex=collection.length-1] The index to search from.
	     * @returns {*} Returns the matched element, else `undefined`.
	     * @example
	     *
	     * _.findLast([1, 2, 3, 4], function(n) {
	     *   return n % 2 == 1;
	     * });
	     * // => 3
	     */
	    var findLast = createFind(findLastIndex);
	
	    /**
	     * Creates a flattened array of values by running each element in `collection`
	     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
	     * with three arguments: (value, index|key, collection).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * function duplicate(n) {
	     *   return [n, n];
	     * }
	     *
	     * _.flatMap([1, 2], duplicate);
	     * // => [1, 1, 2, 2]
	     */
	    function flatMap(collection, iteratee) {
	      return baseFlatten(map(collection, iteratee), 1);
	    }
	
	    /**
	     * This method is like `_.flatMap` except that it recursively flattens the
	     * mapped results.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * function duplicate(n) {
	     *   return [[[n, n]]];
	     * }
	     *
	     * _.flatMapDeep([1, 2], duplicate);
	     * // => [1, 1, 2, 2]
	     */
	    function flatMapDeep(collection, iteratee) {
	      return baseFlatten(map(collection, iteratee), INFINITY);
	    }
	
	    /**
	     * This method is like `_.flatMap` except that it recursively flattens the
	     * mapped results up to `depth` times.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {number} [depth=1] The maximum recursion depth.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * function duplicate(n) {
	     *   return [[[n, n]]];
	     * }
	     *
	     * _.flatMapDepth([1, 2], duplicate, 2);
	     * // => [[1, 1], [2, 2]]
	     */
	    function flatMapDepth(collection, iteratee, depth) {
	      depth = depth === undefined ? 1 : toInteger(depth);
	      return baseFlatten(map(collection, iteratee), depth);
	    }
	
	    /**
	     * Iterates over elements of `collection` and invokes `iteratee` for each element.
	     * The iteratee is invoked with three arguments: (value, index|key, collection).
	     * Iteratee functions may exit iteration early by explicitly returning `false`.
	     *
	     * **Note:** As with other "Collections" methods, objects with a "length"
	     * property are iterated like arrays. To avoid this behavior use `_.forIn`
	     * or `_.forOwn` for object iteration.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @alias each
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     * @see _.forEachRight
	     * @example
	     *
	     * _.forEach([1, 2], function(value) {
	     *   console.log(value);
	     * });
	     * // => Logs `1` then `2`.
	     *
	     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
	     */
	    function forEach(collection, iteratee) {
	      var func = isArray(collection) ? arrayEach : baseEach;
	      return func(collection, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * This method is like `_.forEach` except that it iterates over elements of
	     * `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @alias eachRight
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     * @see _.forEach
	     * @example
	     *
	     * _.forEachRight([1, 2], function(value) {
	     *   console.log(value);
	     * });
	     * // => Logs `2` then `1`.
	     */
	    function forEachRight(collection, iteratee) {
	      var func = isArray(collection) ? arrayEachRight : baseEachRight;
	      return func(collection, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * Creates an object composed of keys generated from the results of running
	     * each element of `collection` thru `iteratee`. The order of grouped values
	     * is determined by the order they occur in `collection`. The corresponding
	     * value of each key is an array of elements responsible for generating the
	     * key. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
	     * @returns {Object} Returns the composed aggregate object.
	     * @example
	     *
	     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
	     * // => { '4': [4.2], '6': [6.1, 6.3] }
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.groupBy(['one', 'two', 'three'], 'length');
	     * // => { '3': ['one', 'two'], '5': ['three'] }
	     */
	    var groupBy = createAggregator(function(result, value, key) {
	      if (hasOwnProperty.call(result, key)) {
	        result[key].push(value);
	      } else {
	        baseAssignValue(result, key, [value]);
	      }
	    });
	
	    /**
	     * Checks if `value` is in `collection`. If `collection` is a string, it's
	     * checked for a substring of `value`, otherwise
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * is used for equality comparisons. If `fromIndex` is negative, it's used as
	     * the offset from the end of `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to inspect.
	     * @param {*} value The value to search for.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
	     * @returns {boolean} Returns `true` if `value` is found, else `false`.
	     * @example
	     *
	     * _.includes([1, 2, 3], 1);
	     * // => true
	     *
	     * _.includes([1, 2, 3], 1, 2);
	     * // => false
	     *
	     * _.includes({ 'a': 1, 'b': 2 }, 1);
	     * // => true
	     *
	     * _.includes('abcd', 'bc');
	     * // => true
	     */
	    function includes(collection, value, fromIndex, guard) {
	      collection = isArrayLike(collection) ? collection : values(collection);
	      fromIndex = (fromIndex && !guard) ? toInteger(fromIndex) : 0;
	
	      var length = collection.length;
	      if (fromIndex < 0) {
	        fromIndex = nativeMax(length + fromIndex, 0);
	      }
	      return isString(collection)
	        ? (fromIndex <= length && collection.indexOf(value, fromIndex) > -1)
	        : (!!length && baseIndexOf(collection, value, fromIndex) > -1);
	    }
	
	    /**
	     * Invokes the method at `path` of each element in `collection`, returning
	     * an array of the results of each invoked method. Any additional arguments
	     * are provided to each invoked method. If `path` is a function, it's invoked
	     * for, and `this` bound to, each element in `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Array|Function|string} path The path of the method to invoke or
	     *  the function invoked per iteration.
	     * @param {...*} [args] The arguments to invoke each method with.
	     * @returns {Array} Returns the array of results.
	     * @example
	     *
	     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
	     * // => [[1, 5, 7], [1, 2, 3]]
	     *
	     * _.invokeMap([123, 456], String.prototype.split, '');
	     * // => [['1', '2', '3'], ['4', '5', '6']]
	     */
	    var invokeMap = baseRest(function(collection, path, args) {
	      var index = -1,
	          isFunc = typeof path == 'function',
	          result = isArrayLike(collection) ? Array(collection.length) : [];
	
	      baseEach(collection, function(value) {
	        result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
	      });
	      return result;
	    });
	
	    /**
	     * Creates an object composed of keys generated from the results of running
	     * each element of `collection` thru `iteratee`. The corresponding value of
	     * each key is the last element responsible for generating the key. The
	     * iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
	     * @returns {Object} Returns the composed aggregate object.
	     * @example
	     *
	     * var array = [
	     *   { 'dir': 'left', 'code': 97 },
	     *   { 'dir': 'right', 'code': 100 }
	     * ];
	     *
	     * _.keyBy(array, function(o) {
	     *   return String.fromCharCode(o.code);
	     * });
	     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
	     *
	     * _.keyBy(array, 'dir');
	     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
	     */
	    var keyBy = createAggregator(function(result, value, key) {
	      baseAssignValue(result, key, value);
	    });
	
	    /**
	     * Creates an array of values by running each element in `collection` thru
	     * `iteratee`. The iteratee is invoked with three arguments:
	     * (value, index|key, collection).
	     *
	     * Many lodash methods are guarded to work as iteratees for methods like
	     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
	     *
	     * The guarded methods are:
	     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
	     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
	     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
	     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new mapped array.
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * _.map([4, 8], square);
	     * // => [16, 64]
	     *
	     * _.map({ 'a': 4, 'b': 8 }, square);
	     * // => [16, 64] (iteration order is not guaranteed)
	     *
	     * var users = [
	     *   { 'user': 'barney' },
	     *   { 'user': 'fred' }
	     * ];
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.map(users, 'user');
	     * // => ['barney', 'fred']
	     */
	    function map(collection, iteratee) {
	      var func = isArray(collection) ? arrayMap : baseMap;
	      return func(collection, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * This method is like `_.sortBy` except that it allows specifying the sort
	     * orders of the iteratees to sort by. If `orders` is unspecified, all values
	     * are sorted in ascending order. Otherwise, specify an order of "desc" for
	     * descending or "asc" for ascending sort order of corresponding values.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
	     *  The iteratees to sort by.
	     * @param {string[]} [orders] The sort orders of `iteratees`.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
	     * @returns {Array} Returns the new sorted array.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'fred',   'age': 48 },
	     *   { 'user': 'barney', 'age': 34 },
	     *   { 'user': 'fred',   'age': 40 },
	     *   { 'user': 'barney', 'age': 36 }
	     * ];
	     *
	     * // Sort by `user` in ascending order and by `age` in descending order.
	     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
	     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
	     */
	    function orderBy(collection, iteratees, orders, guard) {
	      if (collection == null) {
	        return [];
	      }
	      if (!isArray(iteratees)) {
	        iteratees = iteratees == null ? [] : [iteratees];
	      }
	      orders = guard ? undefined : orders;
	      if (!isArray(orders)) {
	        orders = orders == null ? [] : [orders];
	      }
	      return baseOrderBy(collection, iteratees, orders);
	    }
	
	    /**
	     * Creates an array of elements split into two groups, the first of which
	     * contains elements `predicate` returns truthy for, the second of which
	     * contains elements `predicate` returns falsey for. The predicate is
	     * invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the array of grouped elements.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'age': 36, 'active': false },
	     *   { 'user': 'fred',    'age': 40, 'active': true },
	     *   { 'user': 'pebbles', 'age': 1,  'active': false }
	     * ];
	     *
	     * _.partition(users, function(o) { return o.active; });
	     * // => objects for [['fred'], ['barney', 'pebbles']]
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.partition(users, { 'age': 1, 'active': false });
	     * // => objects for [['pebbles'], ['barney', 'fred']]
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.partition(users, ['active', false]);
	     * // => objects for [['barney', 'pebbles'], ['fred']]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.partition(users, 'active');
	     * // => objects for [['fred'], ['barney', 'pebbles']]
	     */
	    var partition = createAggregator(function(result, value, key) {
	      result[key ? 0 : 1].push(value);
	    }, function() { return [[], []]; });
	
	    /**
	     * Reduces `collection` to a value which is the accumulated result of running
	     * each element in `collection` thru `iteratee`, where each successive
	     * invocation is supplied the return value of the previous. If `accumulator`
	     * is not given, the first element of `collection` is used as the initial
	     * value. The iteratee is invoked with four arguments:
	     * (accumulator, value, index|key, collection).
	     *
	     * Many lodash methods are guarded to work as iteratees for methods like
	     * `_.reduce`, `_.reduceRight`, and `_.transform`.
	     *
	     * The guarded methods are:
	     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
	     * and `sortBy`
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [accumulator] The initial value.
	     * @returns {*} Returns the accumulated value.
	     * @see _.reduceRight
	     * @example
	     *
	     * _.reduce([1, 2], function(sum, n) {
	     *   return sum + n;
	     * }, 0);
	     * // => 3
	     *
	     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
	     *   (result[value] || (result[value] = [])).push(key);
	     *   return result;
	     * }, {});
	     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
	     */
	    function reduce(collection, iteratee, accumulator) {
	      var func = isArray(collection) ? arrayReduce : baseReduce,
	          initAccum = arguments.length < 3;
	
	      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
	    }
	
	    /**
	     * This method is like `_.reduce` except that it iterates over elements of
	     * `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [accumulator] The initial value.
	     * @returns {*} Returns the accumulated value.
	     * @see _.reduce
	     * @example
	     *
	     * var array = [[0, 1], [2, 3], [4, 5]];
	     *
	     * _.reduceRight(array, function(flattened, other) {
	     *   return flattened.concat(other);
	     * }, []);
	     * // => [4, 5, 2, 3, 0, 1]
	     */
	    function reduceRight(collection, iteratee, accumulator) {
	      var func = isArray(collection) ? arrayReduceRight : baseReduce,
	          initAccum = arguments.length < 3;
	
	      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
	    }
	
	    /**
	     * The opposite of `_.filter`; this method returns the elements of `collection`
	     * that `predicate` does **not** return truthy for.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new filtered array.
	     * @see _.filter
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': false },
	     *   { 'user': 'fred',   'age': 40, 'active': true }
	     * ];
	     *
	     * _.reject(users, function(o) { return !o.active; });
	     * // => objects for ['fred']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.reject(users, { 'age': 40, 'active': true });
	     * // => objects for ['barney']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.reject(users, ['active', false]);
	     * // => objects for ['fred']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.reject(users, 'active');
	     * // => objects for ['barney']
	     */
	    function reject(collection, predicate) {
	      var func = isArray(collection) ? arrayFilter : baseFilter;
	      return func(collection, negate(getIteratee(predicate, 3)));
	    }
	
	    /**
	     * Gets a random element from `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to sample.
	     * @returns {*} Returns the random element.
	     * @example
	     *
	     * _.sample([1, 2, 3, 4]);
	     * // => 2
	     */
	    function sample(collection) {
	      var func = isArray(collection) ? arraySample : baseSample;
	      return func(collection);
	    }
	
	    /**
	     * Gets `n` random elements at unique keys from `collection` up to the
	     * size of `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to sample.
	     * @param {number} [n=1] The number of elements to sample.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the random elements.
	     * @example
	     *
	     * _.sampleSize([1, 2, 3], 2);
	     * // => [3, 1]
	     *
	     * _.sampleSize([1, 2, 3], 4);
	     * // => [2, 3, 1]
	     */
	    function sampleSize(collection, n, guard) {
	      if ((guard ? isIterateeCall(collection, n, guard) : n === undefined)) {
	        n = 1;
	      } else {
	        n = toInteger(n);
	      }
	      var func = isArray(collection) ? arraySampleSize : baseSampleSize;
	      return func(collection, n);
	    }
	
	    /**
	     * Creates an array of shuffled values, using a version of the
	     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to shuffle.
	     * @returns {Array} Returns the new shuffled array.
	     * @example
	     *
	     * _.shuffle([1, 2, 3, 4]);
	     * // => [4, 1, 3, 2]
	     */
	    function shuffle(collection) {
	      var func = isArray(collection) ? arrayShuffle : baseShuffle;
	      return func(collection);
	    }
	
	    /**
	     * Gets the size of `collection` by returning its length for array-like
	     * values or the number of own enumerable string keyed properties for objects.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to inspect.
	     * @returns {number} Returns the collection size.
	     * @example
	     *
	     * _.size([1, 2, 3]);
	     * // => 3
	     *
	     * _.size({ 'a': 1, 'b': 2 });
	     * // => 2
	     *
	     * _.size('pebbles');
	     * // => 7
	     */
	    function size(collection) {
	      if (collection == null) {
	        return 0;
	      }
	      if (isArrayLike(collection)) {
	        return isString(collection) ? stringSize(collection) : collection.length;
	      }
	      var tag = getTag(collection);
	      if (tag == mapTag || tag == setTag) {
	        return collection.size;
	      }
	      return baseKeys(collection).length;
	    }
	
	    /**
	     * Checks if `predicate` returns truthy for **any** element of `collection`.
	     * Iteration is stopped once `predicate` returns truthy. The predicate is
	     * invoked with three arguments: (value, index|key, collection).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {boolean} Returns `true` if any element passes the predicate check,
	     *  else `false`.
	     * @example
	     *
	     * _.some([null, 0, 'yes', false], Boolean);
	     * // => true
	     *
	     * var users = [
	     *   { 'user': 'barney', 'active': true },
	     *   { 'user': 'fred',   'active': false }
	     * ];
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.some(users, { 'user': 'barney', 'active': false });
	     * // => false
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.some(users, ['active', false]);
	     * // => true
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.some(users, 'active');
	     * // => true
	     */
	    function some(collection, predicate, guard) {
	      var func = isArray(collection) ? arraySome : baseSome;
	      if (guard && isIterateeCall(collection, predicate, guard)) {
	        predicate = undefined;
	      }
	      return func(collection, getIteratee(predicate, 3));
	    }
	
	    /**
	     * Creates an array of elements, sorted in ascending order by the results of
	     * running each element in a collection thru each iteratee. This method
	     * performs a stable sort, that is, it preserves the original sort order of
	     * equal elements. The iteratees are invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {...(Function|Function[])} [iteratees=[_.identity]]
	     *  The iteratees to sort by.
	     * @returns {Array} Returns the new sorted array.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'fred',   'age': 48 },
	     *   { 'user': 'barney', 'age': 36 },
	     *   { 'user': 'fred',   'age': 40 },
	     *   { 'user': 'barney', 'age': 34 }
	     * ];
	     *
	     * _.sortBy(users, [function(o) { return o.user; }]);
	     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
	     *
	     * _.sortBy(users, ['user', 'age']);
	     * // => objects for [['barney', 34], ['barney', 36], ['fred', 40], ['fred', 48]]
	     */
	    var sortBy = baseRest(function(collection, iteratees) {
	      if (collection == null) {
	        return [];
	      }
	      var length = iteratees.length;
	      if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
	        iteratees = [];
	      } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
	        iteratees = [iteratees[0]];
	      }
	      return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
	    });
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Gets the timestamp of the number of milliseconds that have elapsed since
	     * the Unix epoch (1 January 1970 00:00:00 UTC).
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Date
	     * @returns {number} Returns the timestamp.
	     * @example
	     *
	     * _.defer(function(stamp) {
	     *   console.log(_.now() - stamp);
	     * }, _.now());
	     * // => Logs the number of milliseconds it took for the deferred invocation.
	     */
	    var now = ctxNow || function() {
	      return root.Date.now();
	    };
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * The opposite of `_.before`; this method creates a function that invokes
	     * `func` once it's called `n` or more times.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {number} n The number of calls before `func` is invoked.
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new restricted function.
	     * @example
	     *
	     * var saves = ['profile', 'settings'];
	     *
	     * var done = _.after(saves.length, function() {
	     *   console.log('done saving!');
	     * });
	     *
	     * _.forEach(saves, function(type) {
	     *   asyncSave({ 'type': type, 'complete': done });
	     * });
	     * // => Logs 'done saving!' after the two async saves have completed.
	     */
	    function after(n, func) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      n = toInteger(n);
	      return function() {
	        if (--n < 1) {
	          return func.apply(this, arguments);
	        }
	      };
	    }
	
	    /**
	     * Creates a function that invokes `func`, with up to `n` arguments,
	     * ignoring any additional arguments.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {Function} func The function to cap arguments for.
	     * @param {number} [n=func.length] The arity cap.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Function} Returns the new capped function.
	     * @example
	     *
	     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
	     * // => [6, 8, 10]
	     */
	    function ary(func, n, guard) {
	      n = guard ? undefined : n;
	      n = (func && n == null) ? func.length : n;
	      return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
	    }
	
	    /**
	     * Creates a function that invokes `func`, with the `this` binding and arguments
	     * of the created function, while it's called less than `n` times. Subsequent
	     * calls to the created function return the result of the last `func` invocation.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {number} n The number of calls at which `func` is no longer invoked.
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new restricted function.
	     * @example
	     *
	     * jQuery(element).on('click', _.before(5, addContactToList));
	     * // => Allows adding up to 4 contacts to the list.
	     */
	    function before(n, func) {
	      var result;
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      n = toInteger(n);
	      return function() {
	        if (--n > 0) {
	          result = func.apply(this, arguments);
	        }
	        if (n <= 1) {
	          func = undefined;
	        }
	        return result;
	      };
	    }
	
	    /**
	     * Creates a function that invokes `func` with the `this` binding of `thisArg`
	     * and `partials` prepended to the arguments it receives.
	     *
	     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
	     * may be used as a placeholder for partially applied arguments.
	     *
	     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
	     * property of bound functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to bind.
	     * @param {*} thisArg The `this` binding of `func`.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new bound function.
	     * @example
	     *
	     * function greet(greeting, punctuation) {
	     *   return greeting + ' ' + this.user + punctuation;
	     * }
	     *
	     * var object = { 'user': 'fred' };
	     *
	     * var bound = _.bind(greet, object, 'hi');
	     * bound('!');
	     * // => 'hi fred!'
	     *
	     * // Bound with placeholders.
	     * var bound = _.bind(greet, object, _, '!');
	     * bound('hi');
	     * // => 'hi fred!'
	     */
	    var bind = baseRest(function(func, thisArg, partials) {
	      var bitmask = WRAP_BIND_FLAG;
	      if (partials.length) {
	        var holders = replaceHolders(partials, getHolder(bind));
	        bitmask |= WRAP_PARTIAL_FLAG;
	      }
	      return createWrap(func, bitmask, thisArg, partials, holders);
	    });
	
	    /**
	     * Creates a function that invokes the method at `object[key]` with `partials`
	     * prepended to the arguments it receives.
	     *
	     * This method differs from `_.bind` by allowing bound functions to reference
	     * methods that may be redefined or don't yet exist. See
	     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
	     * for more details.
	     *
	     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for partially applied arguments.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.10.0
	     * @category Function
	     * @param {Object} object The object to invoke the method on.
	     * @param {string} key The key of the method.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new bound function.
	     * @example
	     *
	     * var object = {
	     *   'user': 'fred',
	     *   'greet': function(greeting, punctuation) {
	     *     return greeting + ' ' + this.user + punctuation;
	     *   }
	     * };
	     *
	     * var bound = _.bindKey(object, 'greet', 'hi');
	     * bound('!');
	     * // => 'hi fred!'
	     *
	     * object.greet = function(greeting, punctuation) {
	     *   return greeting + 'ya ' + this.user + punctuation;
	     * };
	     *
	     * bound('!');
	     * // => 'hiya fred!'
	     *
	     * // Bound with placeholders.
	     * var bound = _.bindKey(object, 'greet', _, '!');
	     * bound('hi');
	     * // => 'hiya fred!'
	     */
	    var bindKey = baseRest(function(object, key, partials) {
	      var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
	      if (partials.length) {
	        var holders = replaceHolders(partials, getHolder(bindKey));
	        bitmask |= WRAP_PARTIAL_FLAG;
	      }
	      return createWrap(key, bitmask, object, partials, holders);
	    });
	
	    /**
	     * Creates a function that accepts arguments of `func` and either invokes
	     * `func` returning its result, if at least `arity` number of arguments have
	     * been provided, or returns a function that accepts the remaining `func`
	     * arguments, and so on. The arity of `func` may be specified if `func.length`
	     * is not sufficient.
	     *
	     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
	     * may be used as a placeholder for provided arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of curried functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Function
	     * @param {Function} func The function to curry.
	     * @param {number} [arity=func.length] The arity of `func`.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Function} Returns the new curried function.
	     * @example
	     *
	     * var abc = function(a, b, c) {
	     *   return [a, b, c];
	     * };
	     *
	     * var curried = _.curry(abc);
	     *
	     * curried(1)(2)(3);
	     * // => [1, 2, 3]
	     *
	     * curried(1, 2)(3);
	     * // => [1, 2, 3]
	     *
	     * curried(1, 2, 3);
	     * // => [1, 2, 3]
	     *
	     * // Curried with placeholders.
	     * curried(1)(_, 3)(2);
	     * // => [1, 2, 3]
	     */
	    function curry(func, arity, guard) {
	      arity = guard ? undefined : arity;
	      var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
	      result.placeholder = curry.placeholder;
	      return result;
	    }
	
	    /**
	     * This method is like `_.curry` except that arguments are applied to `func`
	     * in the manner of `_.partialRight` instead of `_.partial`.
	     *
	     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for provided arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of curried functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {Function} func The function to curry.
	     * @param {number} [arity=func.length] The arity of `func`.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Function} Returns the new curried function.
	     * @example
	     *
	     * var abc = function(a, b, c) {
	     *   return [a, b, c];
	     * };
	     *
	     * var curried = _.curryRight(abc);
	     *
	     * curried(3)(2)(1);
	     * // => [1, 2, 3]
	     *
	     * curried(2, 3)(1);
	     * // => [1, 2, 3]
	     *
	     * curried(1, 2, 3);
	     * // => [1, 2, 3]
	     *
	     * // Curried with placeholders.
	     * curried(3)(1, _)(2);
	     * // => [1, 2, 3]
	     */
	    function curryRight(func, arity, guard) {
	      arity = guard ? undefined : arity;
	      var result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
	      result.placeholder = curryRight.placeholder;
	      return result;
	    }
	
	    /**
	     * Creates a debounced function that delays invoking `func` until after `wait`
	     * milliseconds have elapsed since the last time the debounced function was
	     * invoked. The debounced function comes with a `cancel` method to cancel
	     * delayed `func` invocations and a `flush` method to immediately invoke them.
	     * Provide `options` to indicate whether `func` should be invoked on the
	     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
	     * with the last arguments provided to the debounced function. Subsequent
	     * calls to the debounced function return the result of the last `func`
	     * invocation.
	     *
	     * **Note:** If `leading` and `trailing` options are `true`, `func` is
	     * invoked on the trailing edge of the timeout only if the debounced function
	     * is invoked more than once during the `wait` timeout.
	     *
	     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
	     *
	     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	     * for details over the differences between `_.debounce` and `_.throttle`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to debounce.
	     * @param {number} [wait=0] The number of milliseconds to delay.
	     * @param {Object} [options={}] The options object.
	     * @param {boolean} [options.leading=false]
	     *  Specify invoking on the leading edge of the timeout.
	     * @param {number} [options.maxWait]
	     *  The maximum time `func` is allowed to be delayed before it's invoked.
	     * @param {boolean} [options.trailing=true]
	     *  Specify invoking on the trailing edge of the timeout.
	     * @returns {Function} Returns the new debounced function.
	     * @example
	     *
	     * // Avoid costly calculations while the window size is in flux.
	     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
	     *
	     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
	     * jQuery(element).on('click', _.debounce(sendMail, 300, {
	     *   'leading': true,
	     *   'trailing': false
	     * }));
	     *
	     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
	     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
	     * var source = new EventSource('/stream');
	     * jQuery(source).on('message', debounced);
	     *
	     * // Cancel the trailing debounced invocation.
	     * jQuery(window).on('popstate', debounced.cancel);
	     */
	    function debounce(func, wait, options) {
	      var lastArgs,
	          lastThis,
	          maxWait,
	          result,
	          timerId,
	          lastCallTime,
	          lastInvokeTime = 0,
	          leading = false,
	          maxing = false,
	          trailing = true;
	
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      wait = toNumber(wait) || 0;
	      if (isObject(options)) {
	        leading = !!options.leading;
	        maxing = 'maxWait' in options;
	        maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
	        trailing = 'trailing' in options ? !!options.trailing : trailing;
	      }
	
	      function invokeFunc(time) {
	        var args = lastArgs,
	            thisArg = lastThis;
	
	        lastArgs = lastThis = undefined;
	        lastInvokeTime = time;
	        result = func.apply(thisArg, args);
	        return result;
	      }
	
	      function leadingEdge(time) {
	        // Reset any `maxWait` timer.
	        lastInvokeTime = time;
	        // Start the timer for the trailing edge.
	        timerId = setTimeout(timerExpired, wait);
	        // Invoke the leading edge.
	        return leading ? invokeFunc(time) : result;
	      }
	
	      function remainingWait(time) {
	        var timeSinceLastCall = time - lastCallTime,
	            timeSinceLastInvoke = time - lastInvokeTime,
	            timeWaiting = wait - timeSinceLastCall;
	
	        return maxing
	          ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
	          : timeWaiting;
	      }
	
	      function shouldInvoke(time) {
	        var timeSinceLastCall = time - lastCallTime,
	            timeSinceLastInvoke = time - lastInvokeTime;
	
	        // Either this is the first call, activity has stopped and we're at the
	        // trailing edge, the system time has gone backwards and we're treating
	        // it as the trailing edge, or we've hit the `maxWait` limit.
	        return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
	          (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
	      }
	
	      function timerExpired() {
	        var time = now();
	        if (shouldInvoke(time)) {
	          return trailingEdge(time);
	        }
	        // Restart the timer.
	        timerId = setTimeout(timerExpired, remainingWait(time));
	      }
	
	      function trailingEdge(time) {
	        timerId = undefined;
	
	        // Only invoke if we have `lastArgs` which means `func` has been
	        // debounced at least once.
	        if (trailing && lastArgs) {
	          return invokeFunc(time);
	        }
	        lastArgs = lastThis = undefined;
	        return result;
	      }
	
	      function cancel() {
	        if (timerId !== undefined) {
	          clearTimeout(timerId);
	        }
	        lastInvokeTime = 0;
	        lastArgs = lastCallTime = lastThis = timerId = undefined;
	      }
	
	      function flush() {
	        return timerId === undefined ? result : trailingEdge(now());
	      }
	
	      function debounced() {
	        var time = now(),
	            isInvoking = shouldInvoke(time);
	
	        lastArgs = arguments;
	        lastThis = this;
	        lastCallTime = time;
	
	        if (isInvoking) {
	          if (timerId === undefined) {
	            return leadingEdge(lastCallTime);
	          }
	          if (maxing) {
	            // Handle invocations in a tight loop.
	            clearTimeout(timerId);
	            timerId = setTimeout(timerExpired, wait);
	            return invokeFunc(lastCallTime);
	          }
	        }
	        if (timerId === undefined) {
	          timerId = setTimeout(timerExpired, wait);
	        }
	        return result;
	      }
	      debounced.cancel = cancel;
	      debounced.flush = flush;
	      return debounced;
	    }
	
	    /**
	     * Defers invoking the `func` until the current call stack has cleared. Any
	     * additional arguments are provided to `func` when it's invoked.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to defer.
	     * @param {...*} [args] The arguments to invoke `func` with.
	     * @returns {number} Returns the timer id.
	     * @example
	     *
	     * _.defer(function(text) {
	     *   console.log(text);
	     * }, 'deferred');
	     * // => Logs 'deferred' after one millisecond.
	     */
	    var defer = baseRest(function(func, args) {
	      return baseDelay(func, 1, args);
	    });
	
	    /**
	     * Invokes `func` after `wait` milliseconds. Any additional arguments are
	     * provided to `func` when it's invoked.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to delay.
	     * @param {number} wait The number of milliseconds to delay invocation.
	     * @param {...*} [args] The arguments to invoke `func` with.
	     * @returns {number} Returns the timer id.
	     * @example
	     *
	     * _.delay(function(text) {
	     *   console.log(text);
	     * }, 1000, 'later');
	     * // => Logs 'later' after one second.
	     */
	    var delay = baseRest(function(func, wait, args) {
	      return baseDelay(func, toNumber(wait) || 0, args);
	    });
	
	    /**
	     * Creates a function that invokes `func` with arguments reversed.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Function
	     * @param {Function} func The function to flip arguments for.
	     * @returns {Function} Returns the new flipped function.
	     * @example
	     *
	     * var flipped = _.flip(function() {
	     *   return _.toArray(arguments);
	     * });
	     *
	     * flipped('a', 'b', 'c', 'd');
	     * // => ['d', 'c', 'b', 'a']
	     */
	    function flip(func) {
	      return createWrap(func, WRAP_FLIP_FLAG);
	    }
	
	    /**
	     * Creates a function that memoizes the result of `func`. If `resolver` is
	     * provided, it determines the cache key for storing the result based on the
	     * arguments provided to the memoized function. By default, the first argument
	     * provided to the memoized function is used as the map cache key. The `func`
	     * is invoked with the `this` binding of the memoized function.
	     *
	     * **Note:** The cache is exposed as the `cache` property on the memoized
	     * function. Its creation may be customized by replacing the `_.memoize.Cache`
	     * constructor with one whose instances implement the
	     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
	     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to have its output memoized.
	     * @param {Function} [resolver] The function to resolve the cache key.
	     * @returns {Function} Returns the new memoized function.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2 };
	     * var other = { 'c': 3, 'd': 4 };
	     *
	     * var values = _.memoize(_.values);
	     * values(object);
	     * // => [1, 2]
	     *
	     * values(other);
	     * // => [3, 4]
	     *
	     * object.a = 2;
	     * values(object);
	     * // => [1, 2]
	     *
	     * // Modify the result cache.
	     * values.cache.set(object, ['a', 'b']);
	     * values(object);
	     * // => ['a', 'b']
	     *
	     * // Replace `_.memoize.Cache`.
	     * _.memoize.Cache = WeakMap;
	     */
	    function memoize(func, resolver) {
	      if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      var memoized = function() {
	        var args = arguments,
	            key = resolver ? resolver.apply(this, args) : args[0],
	            cache = memoized.cache;
	
	        if (cache.has(key)) {
	          return cache.get(key);
	        }
	        var result = func.apply(this, args);
	        memoized.cache = cache.set(key, result) || cache;
	        return result;
	      };
	      memoized.cache = new (memoize.Cache || MapCache);
	      return memoized;
	    }
	
	    // Expose `MapCache`.
	    memoize.Cache = MapCache;
	
	    /**
	     * Creates a function that negates the result of the predicate `func`. The
	     * `func` predicate is invoked with the `this` binding and arguments of the
	     * created function.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {Function} predicate The predicate to negate.
	     * @returns {Function} Returns the new negated function.
	     * @example
	     *
	     * function isEven(n) {
	     *   return n % 2 == 0;
	     * }
	     *
	     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
	     * // => [1, 3, 5]
	     */
	    function negate(predicate) {
	      if (typeof predicate != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      return function() {
	        var args = arguments;
	        switch (args.length) {
	          case 0: return !predicate.call(this);
	          case 1: return !predicate.call(this, args[0]);
	          case 2: return !predicate.call(this, args[0], args[1]);
	          case 3: return !predicate.call(this, args[0], args[1], args[2]);
	        }
	        return !predicate.apply(this, args);
	      };
	    }
	
	    /**
	     * Creates a function that is restricted to invoking `func` once. Repeat calls
	     * to the function return the value of the first invocation. The `func` is
	     * invoked with the `this` binding and arguments of the created function.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new restricted function.
	     * @example
	     *
	     * var initialize = _.once(createApplication);
	     * initialize();
	     * initialize();
	     * // => `createApplication` is invoked once
	     */
	    function once(func) {
	      return before(2, func);
	    }
	
	    /**
	     * Creates a function that invokes `func` with its arguments transformed.
	     *
	     * @static
	     * @since 4.0.0
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to wrap.
	     * @param {...(Function|Function[])} [transforms=[_.identity]]
	     *  The argument transforms.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * function doubled(n) {
	     *   return n * 2;
	     * }
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var func = _.overArgs(function(x, y) {
	     *   return [x, y];
	     * }, [square, doubled]);
	     *
	     * func(9, 3);
	     * // => [81, 6]
	     *
	     * func(10, 5);
	     * // => [100, 10]
	     */
	    var overArgs = castRest(function(func, transforms) {
	      transforms = (transforms.length == 1 && isArray(transforms[0]))
	        ? arrayMap(transforms[0], baseUnary(getIteratee()))
	        : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));
	
	      var funcsLength = transforms.length;
	      return baseRest(function(args) {
	        var index = -1,
	            length = nativeMin(args.length, funcsLength);
	
	        while (++index < length) {
	          args[index] = transforms[index].call(this, args[index]);
	        }
	        return apply(func, this, args);
	      });
	    });
	
	    /**
	     * Creates a function that invokes `func` with `partials` prepended to the
	     * arguments it receives. This method is like `_.bind` except it does **not**
	     * alter the `this` binding.
	     *
	     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for partially applied arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of partially
	     * applied functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.2.0
	     * @category Function
	     * @param {Function} func The function to partially apply arguments to.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new partially applied function.
	     * @example
	     *
	     * function greet(greeting, name) {
	     *   return greeting + ' ' + name;
	     * }
	     *
	     * var sayHelloTo = _.partial(greet, 'hello');
	     * sayHelloTo('fred');
	     * // => 'hello fred'
	     *
	     * // Partially applied with placeholders.
	     * var greetFred = _.partial(greet, _, 'fred');
	     * greetFred('hi');
	     * // => 'hi fred'
	     */
	    var partial = baseRest(function(func, partials) {
	      var holders = replaceHolders(partials, getHolder(partial));
	      return createWrap(func, WRAP_PARTIAL_FLAG, undefined, partials, holders);
	    });
	
	    /**
	     * This method is like `_.partial` except that partially applied arguments
	     * are appended to the arguments it receives.
	     *
	     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for partially applied arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of partially
	     * applied functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.0.0
	     * @category Function
	     * @param {Function} func The function to partially apply arguments to.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new partially applied function.
	     * @example
	     *
	     * function greet(greeting, name) {
	     *   return greeting + ' ' + name;
	     * }
	     *
	     * var greetFred = _.partialRight(greet, 'fred');
	     * greetFred('hi');
	     * // => 'hi fred'
	     *
	     * // Partially applied with placeholders.
	     * var sayHelloTo = _.partialRight(greet, 'hello', _);
	     * sayHelloTo('fred');
	     * // => 'hello fred'
	     */
	    var partialRight = baseRest(function(func, partials) {
	      var holders = replaceHolders(partials, getHolder(partialRight));
	      return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined, partials, holders);
	    });
	
	    /**
	     * Creates a function that invokes `func` with arguments arranged according
	     * to the specified `indexes` where the argument value at the first index is
	     * provided as the first argument, the argument value at the second index is
	     * provided as the second argument, and so on.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {Function} func The function to rearrange arguments for.
	     * @param {...(number|number[])} indexes The arranged argument indexes.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var rearged = _.rearg(function(a, b, c) {
	     *   return [a, b, c];
	     * }, [2, 0, 1]);
	     *
	     * rearged('b', 'c', 'a')
	     * // => ['a', 'b', 'c']
	     */
	    var rearg = flatRest(function(func, indexes) {
	      return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
	    });
	
	    /**
	     * Creates a function that invokes `func` with the `this` binding of the
	     * created function and arguments from `start` and beyond provided as
	     * an array.
	     *
	     * **Note:** This method is based on the
	     * [rest parameter](https://mdn.io/rest_parameters).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Function
	     * @param {Function} func The function to apply a rest parameter to.
	     * @param {number} [start=func.length-1] The start position of the rest parameter.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var say = _.rest(function(what, names) {
	     *   return what + ' ' + _.initial(names).join(', ') +
	     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
	     * });
	     *
	     * say('hello', 'fred', 'barney', 'pebbles');
	     * // => 'hello fred, barney, & pebbles'
	     */
	    function rest(func, start) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      start = start === undefined ? start : toInteger(start);
	      return baseRest(func, start);
	    }
	
	    /**
	     * Creates a function that invokes `func` with the `this` binding of the
	     * create function and an array of arguments much like
	     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
	     *
	     * **Note:** This method is based on the
	     * [spread operator](https://mdn.io/spread_operator).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.2.0
	     * @category Function
	     * @param {Function} func The function to spread arguments over.
	     * @param {number} [start=0] The start position of the spread.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var say = _.spread(function(who, what) {
	     *   return who + ' says ' + what;
	     * });
	     *
	     * say(['fred', 'hello']);
	     * // => 'fred says hello'
	     *
	     * var numbers = Promise.all([
	     *   Promise.resolve(40),
	     *   Promise.resolve(36)
	     * ]);
	     *
	     * numbers.then(_.spread(function(x, y) {
	     *   return x + y;
	     * }));
	     * // => a Promise of 76
	     */
	    function spread(func, start) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      start = start == null ? 0 : nativeMax(toInteger(start), 0);
	      return baseRest(function(args) {
	        var array = args[start],
	            otherArgs = castSlice(args, 0, start);
	
	        if (array) {
	          arrayPush(otherArgs, array);
	        }
	        return apply(func, this, otherArgs);
	      });
	    }
	
	    /**
	     * Creates a throttled function that only invokes `func` at most once per
	     * every `wait` milliseconds. The throttled function comes with a `cancel`
	     * method to cancel delayed `func` invocations and a `flush` method to
	     * immediately invoke them. Provide `options` to indicate whether `func`
	     * should be invoked on the leading and/or trailing edge of the `wait`
	     * timeout. The `func` is invoked with the last arguments provided to the
	     * throttled function. Subsequent calls to the throttled function return the
	     * result of the last `func` invocation.
	     *
	     * **Note:** If `leading` and `trailing` options are `true`, `func` is
	     * invoked on the trailing edge of the timeout only if the throttled function
	     * is invoked more than once during the `wait` timeout.
	     *
	     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
	     *
	     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	     * for details over the differences between `_.throttle` and `_.debounce`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to throttle.
	     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
	     * @param {Object} [options={}] The options object.
	     * @param {boolean} [options.leading=true]
	     *  Specify invoking on the leading edge of the timeout.
	     * @param {boolean} [options.trailing=true]
	     *  Specify invoking on the trailing edge of the timeout.
	     * @returns {Function} Returns the new throttled function.
	     * @example
	     *
	     * // Avoid excessively updating the position while scrolling.
	     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
	     *
	     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
	     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
	     * jQuery(element).on('click', throttled);
	     *
	     * // Cancel the trailing throttled invocation.
	     * jQuery(window).on('popstate', throttled.cancel);
	     */
	    function throttle(func, wait, options) {
	      var leading = true,
	          trailing = true;
	
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      if (isObject(options)) {
	        leading = 'leading' in options ? !!options.leading : leading;
	        trailing = 'trailing' in options ? !!options.trailing : trailing;
	      }
	      return debounce(func, wait, {
	        'leading': leading,
	        'maxWait': wait,
	        'trailing': trailing
	      });
	    }
	
	    /**
	     * Creates a function that accepts up to one argument, ignoring any
	     * additional arguments.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Function
	     * @param {Function} func The function to cap arguments for.
	     * @returns {Function} Returns the new capped function.
	     * @example
	     *
	     * _.map(['6', '8', '10'], _.unary(parseInt));
	     * // => [6, 8, 10]
	     */
	    function unary(func) {
	      return ary(func, 1);
	    }
	
	    /**
	     * Creates a function that provides `value` to `wrapper` as its first
	     * argument. Any additional arguments provided to the function are appended
	     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
	     * binding of the created function.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {*} value The value to wrap.
	     * @param {Function} [wrapper=identity] The wrapper function.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var p = _.wrap(_.escape, function(func, text) {
	     *   return '<p>' + func(text) + '</p>';
	     * });
	     *
	     * p('fred, barney, & pebbles');
	     * // => '<p>fred, barney, &amp; pebbles</p>'
	     */
	    function wrap(value, wrapper) {
	      return partial(castFunction(wrapper), value);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Casts `value` as an array if it's not one.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.4.0
	     * @category Lang
	     * @param {*} value The value to inspect.
	     * @returns {Array} Returns the cast array.
	     * @example
	     *
	     * _.castArray(1);
	     * // => [1]
	     *
	     * _.castArray({ 'a': 1 });
	     * // => [{ 'a': 1 }]
	     *
	     * _.castArray('abc');
	     * // => ['abc']
	     *
	     * _.castArray(null);
	     * // => [null]
	     *
	     * _.castArray(undefined);
	     * // => [undefined]
	     *
	     * _.castArray();
	     * // => []
	     *
	     * var array = [1, 2, 3];
	     * console.log(_.castArray(array) === array);
	     * // => true
	     */
	    function castArray() {
	      if (!arguments.length) {
	        return [];
	      }
	      var value = arguments[0];
	      return isArray(value) ? value : [value];
	    }
	
	    /**
	     * Creates a shallow clone of `value`.
	     *
	     * **Note:** This method is loosely based on the
	     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
	     * and supports cloning arrays, array buffers, booleans, date objects, maps,
	     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
	     * arrays. The own enumerable properties of `arguments` objects are cloned
	     * as plain objects. An empty object is returned for uncloneable values such
	     * as error objects, functions, DOM nodes, and WeakMaps.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to clone.
	     * @returns {*} Returns the cloned value.
	     * @see _.cloneDeep
	     * @example
	     *
	     * var objects = [{ 'a': 1 }, { 'b': 2 }];
	     *
	     * var shallow = _.clone(objects);
	     * console.log(shallow[0] === objects[0]);
	     * // => true
	     */
	    function clone(value) {
	      return baseClone(value, CLONE_SYMBOLS_FLAG);
	    }
	
	    /**
	     * This method is like `_.clone` except that it accepts `customizer` which
	     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
	     * cloning is handled by the method instead. The `customizer` is invoked with
	     * up to four arguments; (value [, index|key, object, stack]).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to clone.
	     * @param {Function} [customizer] The function to customize cloning.
	     * @returns {*} Returns the cloned value.
	     * @see _.cloneDeepWith
	     * @example
	     *
	     * function customizer(value) {
	     *   if (_.isElement(value)) {
	     *     return value.cloneNode(false);
	     *   }
	     * }
	     *
	     * var el = _.cloneWith(document.body, customizer);
	     *
	     * console.log(el === document.body);
	     * // => false
	     * console.log(el.nodeName);
	     * // => 'BODY'
	     * console.log(el.childNodes.length);
	     * // => 0
	     */
	    function cloneWith(value, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
	    }
	
	    /**
	     * This method is like `_.clone` except that it recursively clones `value`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.0.0
	     * @category Lang
	     * @param {*} value The value to recursively clone.
	     * @returns {*} Returns the deep cloned value.
	     * @see _.clone
	     * @example
	     *
	     * var objects = [{ 'a': 1 }, { 'b': 2 }];
	     *
	     * var deep = _.cloneDeep(objects);
	     * console.log(deep[0] === objects[0]);
	     * // => false
	     */
	    function cloneDeep(value) {
	      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
	    }
	
	    /**
	     * This method is like `_.cloneWith` except that it recursively clones `value`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to recursively clone.
	     * @param {Function} [customizer] The function to customize cloning.
	     * @returns {*} Returns the deep cloned value.
	     * @see _.cloneWith
	     * @example
	     *
	     * function customizer(value) {
	     *   if (_.isElement(value)) {
	     *     return value.cloneNode(true);
	     *   }
	     * }
	     *
	     * var el = _.cloneDeepWith(document.body, customizer);
	     *
	     * console.log(el === document.body);
	     * // => false
	     * console.log(el.nodeName);
	     * // => 'BODY'
	     * console.log(el.childNodes.length);
	     * // => 20
	     */
	    function cloneDeepWith(value, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
	    }
	
	    /**
	     * Checks if `object` conforms to `source` by invoking the predicate
	     * properties of `source` with the corresponding property values of `object`.
	     *
	     * **Note:** This method is equivalent to `_.conforms` when `source` is
	     * partially applied.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.14.0
	     * @category Lang
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property predicates to conform to.
	     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2 };
	     *
	     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
	     * // => true
	     *
	     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
	     * // => false
	     */
	    function conformsTo(object, source) {
	      return source == null || baseConformsTo(object, source, keys(source));
	    }
	
	    /**
	     * Performs a
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * comparison between two values to determine if they are equivalent.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     * @example
	     *
	     * var object = { 'a': 1 };
	     * var other = { 'a': 1 };
	     *
	     * _.eq(object, object);
	     * // => true
	     *
	     * _.eq(object, other);
	     * // => false
	     *
	     * _.eq('a', 'a');
	     * // => true
	     *
	     * _.eq('a', Object('a'));
	     * // => false
	     *
	     * _.eq(NaN, NaN);
	     * // => true
	     */
	    function eq(value, other) {
	      return value === other || (value !== value && other !== other);
	    }
	
	    /**
	     * Checks if `value` is greater than `other`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.9.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is greater than `other`,
	     *  else `false`.
	     * @see _.lt
	     * @example
	     *
	     * _.gt(3, 1);
	     * // => true
	     *
	     * _.gt(3, 3);
	     * // => false
	     *
	     * _.gt(1, 3);
	     * // => false
	     */
	    var gt = createRelationalOperation(baseGt);
	
	    /**
	     * Checks if `value` is greater than or equal to `other`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.9.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is greater than or equal to
	     *  `other`, else `false`.
	     * @see _.lte
	     * @example
	     *
	     * _.gte(3, 1);
	     * // => true
	     *
	     * _.gte(3, 3);
	     * // => true
	     *
	     * _.gte(1, 3);
	     * // => false
	     */
	    var gte = createRelationalOperation(function(value, other) {
	      return value >= other;
	    });
	
	    /**
	     * Checks if `value` is likely an `arguments` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	     *  else `false`.
	     * @example
	     *
	     * _.isArguments(function() { return arguments; }());
	     * // => true
	     *
	     * _.isArguments([1, 2, 3]);
	     * // => false
	     */
	    var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
	      return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
	        !propertyIsEnumerable.call(value, 'callee');
	    };
	
	    /**
	     * Checks if `value` is classified as an `Array` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
	     * @example
	     *
	     * _.isArray([1, 2, 3]);
	     * // => true
	     *
	     * _.isArray(document.body.children);
	     * // => false
	     *
	     * _.isArray('abc');
	     * // => false
	     *
	     * _.isArray(_.noop);
	     * // => false
	     */
	    var isArray = Array.isArray;
	
	    /**
	     * Checks if `value` is classified as an `ArrayBuffer` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
	     * @example
	     *
	     * _.isArrayBuffer(new ArrayBuffer(2));
	     * // => true
	     *
	     * _.isArrayBuffer(new Array(2));
	     * // => false
	     */
	    var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;
	
	    /**
	     * Checks if `value` is array-like. A value is considered array-like if it's
	     * not a function and has a `value.length` that's an integer greater than or
	     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	     * @example
	     *
	     * _.isArrayLike([1, 2, 3]);
	     * // => true
	     *
	     * _.isArrayLike(document.body.children);
	     * // => true
	     *
	     * _.isArrayLike('abc');
	     * // => true
	     *
	     * _.isArrayLike(_.noop);
	     * // => false
	     */
	    function isArrayLike(value) {
	      return value != null && isLength(value.length) && !isFunction(value);
	    }
	
	    /**
	     * This method is like `_.isArrayLike` except that it also checks if `value`
	     * is an object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an array-like object,
	     *  else `false`.
	     * @example
	     *
	     * _.isArrayLikeObject([1, 2, 3]);
	     * // => true
	     *
	     * _.isArrayLikeObject(document.body.children);
	     * // => true
	     *
	     * _.isArrayLikeObject('abc');
	     * // => false
	     *
	     * _.isArrayLikeObject(_.noop);
	     * // => false
	     */
	    function isArrayLikeObject(value) {
	      return isObjectLike(value) && isArrayLike(value);
	    }
	
	    /**
	     * Checks if `value` is classified as a boolean primitive or object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
	     * @example
	     *
	     * _.isBoolean(false);
	     * // => true
	     *
	     * _.isBoolean(null);
	     * // => false
	     */
	    function isBoolean(value) {
	      return value === true || value === false ||
	        (isObjectLike(value) && baseGetTag(value) == boolTag);
	    }
	
	    /**
	     * Checks if `value` is a buffer.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
	     * @example
	     *
	     * _.isBuffer(new Buffer(2));
	     * // => true
	     *
	     * _.isBuffer(new Uint8Array(2));
	     * // => false
	     */
	    var isBuffer = nativeIsBuffer || stubFalse;
	
	    /**
	     * Checks if `value` is classified as a `Date` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
	     * @example
	     *
	     * _.isDate(new Date);
	     * // => true
	     *
	     * _.isDate('Mon April 23 2012');
	     * // => false
	     */
	    var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;
	
	    /**
	     * Checks if `value` is likely a DOM element.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
	     * @example
	     *
	     * _.isElement(document.body);
	     * // => true
	     *
	     * _.isElement('<body>');
	     * // => false
	     */
	    function isElement(value) {
	      return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
	    }
	
	    /**
	     * Checks if `value` is an empty object, collection, map, or set.
	     *
	     * Objects are considered empty if they have no own enumerable string keyed
	     * properties.
	     *
	     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
	     * jQuery-like collections are considered empty if they have a `length` of `0`.
	     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
	     * @example
	     *
	     * _.isEmpty(null);
	     * // => true
	     *
	     * _.isEmpty(true);
	     * // => true
	     *
	     * _.isEmpty(1);
	     * // => true
	     *
	     * _.isEmpty([1, 2, 3]);
	     * // => false
	     *
	     * _.isEmpty({ 'a': 1 });
	     * // => false
	     */
	    function isEmpty(value) {
	      if (value == null) {
	        return true;
	      }
	      if (isArrayLike(value) &&
	          (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' ||
	            isBuffer(value) || isTypedArray(value) || isArguments(value))) {
	        return !value.length;
	      }
	      var tag = getTag(value);
	      if (tag == mapTag || tag == setTag) {
	        return !value.size;
	      }
	      if (isPrototype(value)) {
	        return !baseKeys(value).length;
	      }
	      for (var key in value) {
	        if (hasOwnProperty.call(value, key)) {
	          return false;
	        }
	      }
	      return true;
	    }
	
	    /**
	     * Performs a deep comparison between two values to determine if they are
	     * equivalent.
	     *
	     * **Note:** This method supports comparing arrays, array buffers, booleans,
	     * date objects, error objects, maps, numbers, `Object` objects, regexes,
	     * sets, strings, symbols, and typed arrays. `Object` objects are compared
	     * by their own, not inherited, enumerable properties. Functions and DOM
	     * nodes are compared by strict equality, i.e. `===`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     * @example
	     *
	     * var object = { 'a': 1 };
	     * var other = { 'a': 1 };
	     *
	     * _.isEqual(object, other);
	     * // => true
	     *
	     * object === other;
	     * // => false
	     */
	    function isEqual(value, other) {
	      return baseIsEqual(value, other);
	    }
	
	    /**
	     * This method is like `_.isEqual` except that it accepts `customizer` which
	     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
	     * are handled by the method instead. The `customizer` is invoked with up to
	     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     * @example
	     *
	     * function isGreeting(value) {
	     *   return /^h(?:i|ello)$/.test(value);
	     * }
	     *
	     * function customizer(objValue, othValue) {
	     *   if (isGreeting(objValue) && isGreeting(othValue)) {
	     *     return true;
	     *   }
	     * }
	     *
	     * var array = ['hello', 'goodbye'];
	     * var other = ['hi', 'goodbye'];
	     *
	     * _.isEqualWith(array, other, customizer);
	     * // => true
	     */
	    function isEqualWith(value, other, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      var result = customizer ? customizer(value, other) : undefined;
	      return result === undefined ? baseIsEqual(value, other, undefined, customizer) : !!result;
	    }
	
	    /**
	     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
	     * `SyntaxError`, `TypeError`, or `URIError` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
	     * @example
	     *
	     * _.isError(new Error);
	     * // => true
	     *
	     * _.isError(Error);
	     * // => false
	     */
	    function isError(value) {
	      if (!isObjectLike(value)) {
	        return false;
	      }
	      var tag = baseGetTag(value);
	      return tag == errorTag || tag == domExcTag ||
	        (typeof value.message == 'string' && typeof value.name == 'string' && !isPlainObject(value));
	    }
	
	    /**
	     * Checks if `value` is a finite primitive number.
	     *
	     * **Note:** This method is based on
	     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
	     * @example
	     *
	     * _.isFinite(3);
	     * // => true
	     *
	     * _.isFinite(Number.MIN_VALUE);
	     * // => true
	     *
	     * _.isFinite(Infinity);
	     * // => false
	     *
	     * _.isFinite('3');
	     * // => false
	     */
	    function isFinite(value) {
	      return typeof value == 'number' && nativeIsFinite(value);
	    }
	
	    /**
	     * Checks if `value` is classified as a `Function` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	     * @example
	     *
	     * _.isFunction(_);
	     * // => true
	     *
	     * _.isFunction(/abc/);
	     * // => false
	     */
	    function isFunction(value) {
	      if (!isObject(value)) {
	        return false;
	      }
	      // The use of `Object#toString` avoids issues with the `typeof` operator
	      // in Safari 9 which returns 'object' for typed arrays and other constructors.
	      var tag = baseGetTag(value);
	      return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
	    }
	
	    /**
	     * Checks if `value` is an integer.
	     *
	     * **Note:** This method is based on
	     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
	     * @example
	     *
	     * _.isInteger(3);
	     * // => true
	     *
	     * _.isInteger(Number.MIN_VALUE);
	     * // => false
	     *
	     * _.isInteger(Infinity);
	     * // => false
	     *
	     * _.isInteger('3');
	     * // => false
	     */
	    function isInteger(value) {
	      return typeof value == 'number' && value == toInteger(value);
	    }
	
	    /**
	     * Checks if `value` is a valid array-like length.
	     *
	     * **Note:** This method is loosely based on
	     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	     * @example
	     *
	     * _.isLength(3);
	     * // => true
	     *
	     * _.isLength(Number.MIN_VALUE);
	     * // => false
	     *
	     * _.isLength(Infinity);
	     * // => false
	     *
	     * _.isLength('3');
	     * // => false
	     */
	    function isLength(value) {
	      return typeof value == 'number' &&
	        value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	    }
	
	    /**
	     * Checks if `value` is the
	     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	     * @example
	     *
	     * _.isObject({});
	     * // => true
	     *
	     * _.isObject([1, 2, 3]);
	     * // => true
	     *
	     * _.isObject(_.noop);
	     * // => true
	     *
	     * _.isObject(null);
	     * // => false
	     */
	    function isObject(value) {
	      var type = typeof value;
	      return value != null && (type == 'object' || type == 'function');
	    }
	
	    /**
	     * Checks if `value` is object-like. A value is object-like if it's not `null`
	     * and has a `typeof` result of "object".
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	     * @example
	     *
	     * _.isObjectLike({});
	     * // => true
	     *
	     * _.isObjectLike([1, 2, 3]);
	     * // => true
	     *
	     * _.isObjectLike(_.noop);
	     * // => false
	     *
	     * _.isObjectLike(null);
	     * // => false
	     */
	    function isObjectLike(value) {
	      return value != null && typeof value == 'object';
	    }
	
	    /**
	     * Checks if `value` is classified as a `Map` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
	     * @example
	     *
	     * _.isMap(new Map);
	     * // => true
	     *
	     * _.isMap(new WeakMap);
	     * // => false
	     */
	    var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;
	
	    /**
	     * Performs a partial deep comparison between `object` and `source` to
	     * determine if `object` contains equivalent property values.
	     *
	     * **Note:** This method is equivalent to `_.matches` when `source` is
	     * partially applied.
	     *
	     * Partial comparisons will match empty array and empty object `source`
	     * values against any array or object value, respectively. See `_.isEqual`
	     * for a list of supported value comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property values to match.
	     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2 };
	     *
	     * _.isMatch(object, { 'b': 2 });
	     * // => true
	     *
	     * _.isMatch(object, { 'b': 1 });
	     * // => false
	     */
	    function isMatch(object, source) {
	      return object === source || baseIsMatch(object, source, getMatchData(source));
	    }
	
	    /**
	     * This method is like `_.isMatch` except that it accepts `customizer` which
	     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
	     * are handled by the method instead. The `customizer` is invoked with five
	     * arguments: (objValue, srcValue, index|key, object, source).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property values to match.
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	     * @example
	     *
	     * function isGreeting(value) {
	     *   return /^h(?:i|ello)$/.test(value);
	     * }
	     *
	     * function customizer(objValue, srcValue) {
	     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
	     *     return true;
	     *   }
	     * }
	     *
	     * var object = { 'greeting': 'hello' };
	     * var source = { 'greeting': 'hi' };
	     *
	     * _.isMatchWith(object, source, customizer);
	     * // => true
	     */
	    function isMatchWith(object, source, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return baseIsMatch(object, source, getMatchData(source), customizer);
	    }
	
	    /**
	     * Checks if `value` is `NaN`.
	     *
	     * **Note:** This method is based on
	     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
	     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
	     * `undefined` and other non-number values.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
	     * @example
	     *
	     * _.isNaN(NaN);
	     * // => true
	     *
	     * _.isNaN(new Number(NaN));
	     * // => true
	     *
	     * isNaN(undefined);
	     * // => true
	     *
	     * _.isNaN(undefined);
	     * // => false
	     */
	    function isNaN(value) {
	      // An `NaN` primitive is the only value that is not equal to itself.
	      // Perform the `toStringTag` check first to avoid errors with some
	      // ActiveX objects in IE.
	      return isNumber(value) && value != +value;
	    }
	
	    /**
	     * Checks if `value` is a pristine native function.
	     *
	     * **Note:** This method can't reliably detect native functions in the presence
	     * of the core-js package because core-js circumvents this kind of detection.
	     * Despite multiple requests, the core-js maintainer has made it clear: any
	     * attempt to fix the detection will be obstructed. As a result, we're left
	     * with little choice but to throw an error. Unfortunately, this also affects
	     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
	     * which rely on core-js.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a native function,
	     *  else `false`.
	     * @example
	     *
	     * _.isNative(Array.prototype.push);
	     * // => true
	     *
	     * _.isNative(_);
	     * // => false
	     */
	    function isNative(value) {
	      if (isMaskable(value)) {
	        throw new Error(CORE_ERROR_TEXT);
	      }
	      return baseIsNative(value);
	    }
	
	    /**
	     * Checks if `value` is `null`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
	     * @example
	     *
	     * _.isNull(null);
	     * // => true
	     *
	     * _.isNull(void 0);
	     * // => false
	     */
	    function isNull(value) {
	      return value === null;
	    }
	
	    /**
	     * Checks if `value` is `null` or `undefined`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
	     * @example
	     *
	     * _.isNil(null);
	     * // => true
	     *
	     * _.isNil(void 0);
	     * // => true
	     *
	     * _.isNil(NaN);
	     * // => false
	     */
	    function isNil(value) {
	      return value == null;
	    }
	
	    /**
	     * Checks if `value` is classified as a `Number` primitive or object.
	     *
	     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
	     * classified as numbers, use the `_.isFinite` method.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
	     * @example
	     *
	     * _.isNumber(3);
	     * // => true
	     *
	     * _.isNumber(Number.MIN_VALUE);
	     * // => true
	     *
	     * _.isNumber(Infinity);
	     * // => true
	     *
	     * _.isNumber('3');
	     * // => false
	     */
	    function isNumber(value) {
	      return typeof value == 'number' ||
	        (isObjectLike(value) && baseGetTag(value) == numberTag);
	    }
	
	    /**
	     * Checks if `value` is a plain object, that is, an object created by the
	     * `Object` constructor or one with a `[[Prototype]]` of `null`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.8.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     * }
	     *
	     * _.isPlainObject(new Foo);
	     * // => false
	     *
	     * _.isPlainObject([1, 2, 3]);
	     * // => false
	     *
	     * _.isPlainObject({ 'x': 0, 'y': 0 });
	     * // => true
	     *
	     * _.isPlainObject(Object.create(null));
	     * // => true
	     */
	    function isPlainObject(value) {
	      if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
	        return false;
	      }
	      var proto = getPrototype(value);
	      if (proto === null) {
	        return true;
	      }
	      var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
	      return typeof Ctor == 'function' && Ctor instanceof Ctor &&
	        funcToString.call(Ctor) == objectCtorString;
	    }
	
	    /**
	     * Checks if `value` is classified as a `RegExp` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
	     * @example
	     *
	     * _.isRegExp(/abc/);
	     * // => true
	     *
	     * _.isRegExp('/abc/');
	     * // => false
	     */
	    var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;
	
	    /**
	     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
	     * double precision number which isn't the result of a rounded unsafe integer.
	     *
	     * **Note:** This method is based on
	     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
	     * @example
	     *
	     * _.isSafeInteger(3);
	     * // => true
	     *
	     * _.isSafeInteger(Number.MIN_VALUE);
	     * // => false
	     *
	     * _.isSafeInteger(Infinity);
	     * // => false
	     *
	     * _.isSafeInteger('3');
	     * // => false
	     */
	    function isSafeInteger(value) {
	      return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
	    }
	
	    /**
	     * Checks if `value` is classified as a `Set` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
	     * @example
	     *
	     * _.isSet(new Set);
	     * // => true
	     *
	     * _.isSet(new WeakSet);
	     * // => false
	     */
	    var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;
	
	    /**
	     * Checks if `value` is classified as a `String` primitive or object.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
	     * @example
	     *
	     * _.isString('abc');
	     * // => true
	     *
	     * _.isString(1);
	     * // => false
	     */
	    function isString(value) {
	      return typeof value == 'string' ||
	        (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
	    }
	
	    /**
	     * Checks if `value` is classified as a `Symbol` primitive or object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
	     * @example
	     *
	     * _.isSymbol(Symbol.iterator);
	     * // => true
	     *
	     * _.isSymbol('abc');
	     * // => false
	     */
	    function isSymbol(value) {
	      return typeof value == 'symbol' ||
	        (isObjectLike(value) && baseGetTag(value) == symbolTag);
	    }
	
	    /**
	     * Checks if `value` is classified as a typed array.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	     * @example
	     *
	     * _.isTypedArray(new Uint8Array);
	     * // => true
	     *
	     * _.isTypedArray([]);
	     * // => false
	     */
	    var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
	
	    /**
	     * Checks if `value` is `undefined`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
	     * @example
	     *
	     * _.isUndefined(void 0);
	     * // => true
	     *
	     * _.isUndefined(null);
	     * // => false
	     */
	    function isUndefined(value) {
	      return value === undefined;
	    }
	
	    /**
	     * Checks if `value` is classified as a `WeakMap` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
	     * @example
	     *
	     * _.isWeakMap(new WeakMap);
	     * // => true
	     *
	     * _.isWeakMap(new Map);
	     * // => false
	     */
	    function isWeakMap(value) {
	      return isObjectLike(value) && getTag(value) == weakMapTag;
	    }
	
	    /**
	     * Checks if `value` is classified as a `WeakSet` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
	     * @example
	     *
	     * _.isWeakSet(new WeakSet);
	     * // => true
	     *
	     * _.isWeakSet(new Set);
	     * // => false
	     */
	    function isWeakSet(value) {
	      return isObjectLike(value) && baseGetTag(value) == weakSetTag;
	    }
	
	    /**
	     * Checks if `value` is less than `other`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.9.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is less than `other`,
	     *  else `false`.
	     * @see _.gt
	     * @example
	     *
	     * _.lt(1, 3);
	     * // => true
	     *
	     * _.lt(3, 3);
	     * // => false
	     *
	     * _.lt(3, 1);
	     * // => false
	     */
	    var lt = createRelationalOperation(baseLt);
	
	    /**
	     * Checks if `value` is less than or equal to `other`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.9.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is less than or equal to
	     *  `other`, else `false`.
	     * @see _.gte
	     * @example
	     *
	     * _.lte(1, 3);
	     * // => true
	     *
	     * _.lte(3, 3);
	     * // => true
	     *
	     * _.lte(3, 1);
	     * // => false
	     */
	    var lte = createRelationalOperation(function(value, other) {
	      return value <= other;
	    });
	
	    /**
	     * Converts `value` to an array.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {Array} Returns the converted array.
	     * @example
	     *
	     * _.toArray({ 'a': 1, 'b': 2 });
	     * // => [1, 2]
	     *
	     * _.toArray('abc');
	     * // => ['a', 'b', 'c']
	     *
	     * _.toArray(1);
	     * // => []
	     *
	     * _.toArray(null);
	     * // => []
	     */
	    function toArray(value) {
	      if (!value) {
	        return [];
	      }
	      if (isArrayLike(value)) {
	        return isString(value) ? stringToArray(value) : copyArray(value);
	      }
	      if (symIterator && value[symIterator]) {
	        return iteratorToArray(value[symIterator]());
	      }
	      var tag = getTag(value),
	          func = tag == mapTag ? mapToArray : (tag == setTag ? setToArray : values);
	
	      return func(value);
	    }
	
	    /**
	     * Converts `value` to a finite number.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.12.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {number} Returns the converted number.
	     * @example
	     *
	     * _.toFinite(3.2);
	     * // => 3.2
	     *
	     * _.toFinite(Number.MIN_VALUE);
	     * // => 5e-324
	     *
	     * _.toFinite(Infinity);
	     * // => 1.7976931348623157e+308
	     *
	     * _.toFinite('3.2');
	     * // => 3.2
	     */
	    function toFinite(value) {
	      if (!value) {
	        return value === 0 ? value : 0;
	      }
	      value = toNumber(value);
	      if (value === INFINITY || value === -INFINITY) {
	        var sign = (value < 0 ? -1 : 1);
	        return sign * MAX_INTEGER;
	      }
	      return value === value ? value : 0;
	    }
	
	    /**
	     * Converts `value` to an integer.
	     *
	     * **Note:** This method is loosely based on
	     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.toInteger(3.2);
	     * // => 3
	     *
	     * _.toInteger(Number.MIN_VALUE);
	     * // => 0
	     *
	     * _.toInteger(Infinity);
	     * // => 1.7976931348623157e+308
	     *
	     * _.toInteger('3.2');
	     * // => 3
	     */
	    function toInteger(value) {
	      var result = toFinite(value),
	          remainder = result % 1;
	
	      return result === result ? (remainder ? result - remainder : result) : 0;
	    }
	
	    /**
	     * Converts `value` to an integer suitable for use as the length of an
	     * array-like object.
	     *
	     * **Note:** This method is based on
	     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.toLength(3.2);
	     * // => 3
	     *
	     * _.toLength(Number.MIN_VALUE);
	     * // => 0
	     *
	     * _.toLength(Infinity);
	     * // => 4294967295
	     *
	     * _.toLength('3.2');
	     * // => 3
	     */
	    function toLength(value) {
	      return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
	    }
	
	    /**
	     * Converts `value` to a number.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to process.
	     * @returns {number} Returns the number.
	     * @example
	     *
	     * _.toNumber(3.2);
	     * // => 3.2
	     *
	     * _.toNumber(Number.MIN_VALUE);
	     * // => 5e-324
	     *
	     * _.toNumber(Infinity);
	     * // => Infinity
	     *
	     * _.toNumber('3.2');
	     * // => 3.2
	     */
	    function toNumber(value) {
	      if (typeof value == 'number') {
	        return value;
	      }
	      if (isSymbol(value)) {
	        return NAN;
	      }
	      if (isObject(value)) {
	        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
	        value = isObject(other) ? (other + '') : other;
	      }
	      if (typeof value != 'string') {
	        return value === 0 ? value : +value;
	      }
	      value = value.replace(reTrim, '');
	      var isBinary = reIsBinary.test(value);
	      return (isBinary || reIsOctal.test(value))
	        ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
	        : (reIsBadHex.test(value) ? NAN : +value);
	    }
	
	    /**
	     * Converts `value` to a plain object flattening inherited enumerable string
	     * keyed properties of `value` to own properties of the plain object.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {Object} Returns the converted plain object.
	     * @example
	     *
	     * function Foo() {
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.assign({ 'a': 1 }, new Foo);
	     * // => { 'a': 1, 'b': 2 }
	     *
	     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
	     * // => { 'a': 1, 'b': 2, 'c': 3 }
	     */
	    function toPlainObject(value) {
	      return copyObject(value, keysIn(value));
	    }
	
	    /**
	     * Converts `value` to a safe integer. A safe integer can be compared and
	     * represented correctly.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.toSafeInteger(3.2);
	     * // => 3
	     *
	     * _.toSafeInteger(Number.MIN_VALUE);
	     * // => 0
	     *
	     * _.toSafeInteger(Infinity);
	     * // => 9007199254740991
	     *
	     * _.toSafeInteger('3.2');
	     * // => 3
	     */
	    function toSafeInteger(value) {
	      return value
	        ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER)
	        : (value === 0 ? value : 0);
	    }
	
	    /**
	     * Converts `value` to a string. An empty string is returned for `null`
	     * and `undefined` values. The sign of `-0` is preserved.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {string} Returns the converted string.
	     * @example
	     *
	     * _.toString(null);
	     * // => ''
	     *
	     * _.toString(-0);
	     * // => '-0'
	     *
	     * _.toString([1, 2, 3]);
	     * // => '1,2,3'
	     */
	    function toString(value) {
	      return value == null ? '' : baseToString(value);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Assigns own enumerable string keyed properties of source objects to the
	     * destination object. Source objects are applied from left to right.
	     * Subsequent sources overwrite property assignments of previous sources.
	     *
	     * **Note:** This method mutates `object` and is loosely based on
	     * [`Object.assign`](https://mdn.io/Object/assign).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.10.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @see _.assignIn
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     * }
	     *
	     * function Bar() {
	     *   this.c = 3;
	     * }
	     *
	     * Foo.prototype.b = 2;
	     * Bar.prototype.d = 4;
	     *
	     * _.assign({ 'a': 0 }, new Foo, new Bar);
	     * // => { 'a': 1, 'c': 3 }
	     */
	    var assign = createAssigner(function(object, source) {
	      if (isPrototype(source) || isArrayLike(source)) {
	        copyObject(source, keys(source), object);
	        return;
	      }
	      for (var key in source) {
	        if (hasOwnProperty.call(source, key)) {
	          assignValue(object, key, source[key]);
	        }
	      }
	    });
	
	    /**
	     * This method is like `_.assign` except that it iterates over own and
	     * inherited source properties.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @alias extend
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @see _.assign
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     * }
	     *
	     * function Bar() {
	     *   this.c = 3;
	     * }
	     *
	     * Foo.prototype.b = 2;
	     * Bar.prototype.d = 4;
	     *
	     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
	     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
	     */
	    var assignIn = createAssigner(function(object, source) {
	      copyObject(source, keysIn(source), object);
	    });
	
	    /**
	     * This method is like `_.assignIn` except that it accepts `customizer`
	     * which is invoked to produce the assigned values. If `customizer` returns
	     * `undefined`, assignment is handled by the method instead. The `customizer`
	     * is invoked with five arguments: (objValue, srcValue, key, object, source).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @alias extendWith
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} sources The source objects.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @see _.assignWith
	     * @example
	     *
	     * function customizer(objValue, srcValue) {
	     *   return _.isUndefined(objValue) ? srcValue : objValue;
	     * }
	     *
	     * var defaults = _.partialRight(_.assignInWith, customizer);
	     *
	     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
	     * // => { 'a': 1, 'b': 2 }
	     */
	    var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
	      copyObject(source, keysIn(source), object, customizer);
	    });
	
	    /**
	     * This method is like `_.assign` except that it accepts `customizer`
	     * which is invoked to produce the assigned values. If `customizer` returns
	     * `undefined`, assignment is handled by the method instead. The `customizer`
	     * is invoked with five arguments: (objValue, srcValue, key, object, source).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} sources The source objects.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @see _.assignInWith
	     * @example
	     *
	     * function customizer(objValue, srcValue) {
	     *   return _.isUndefined(objValue) ? srcValue : objValue;
	     * }
	     *
	     * var defaults = _.partialRight(_.assignWith, customizer);
	     *
	     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
	     * // => { 'a': 1, 'b': 2 }
	     */
	    var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
	      copyObject(source, keys(source), object, customizer);
	    });
	
	    /**
	     * Creates an array of values corresponding to `paths` of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.0.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {...(string|string[])} [paths] The property paths to pick.
	     * @returns {Array} Returns the picked values.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
	     *
	     * _.at(object, ['a[0].b.c', 'a[1]']);
	     * // => [3, 4]
	     */
	    var at = flatRest(baseAt);
	
	    /**
	     * Creates an object that inherits from the `prototype` object. If a
	     * `properties` object is given, its own enumerable string keyed properties
	     * are assigned to the created object.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.3.0
	     * @category Object
	     * @param {Object} prototype The object to inherit from.
	     * @param {Object} [properties] The properties to assign to the object.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * function Shape() {
	     *   this.x = 0;
	     *   this.y = 0;
	     * }
	     *
	     * function Circle() {
	     *   Shape.call(this);
	     * }
	     *
	     * Circle.prototype = _.create(Shape.prototype, {
	     *   'constructor': Circle
	     * });
	     *
	     * var circle = new Circle;
	     * circle instanceof Circle;
	     * // => true
	     *
	     * circle instanceof Shape;
	     * // => true
	     */
	    function create(prototype, properties) {
	      var result = baseCreate(prototype);
	      return properties == null ? result : baseAssign(result, properties);
	    }
	
	    /**
	     * Assigns own and inherited enumerable string keyed properties of source
	     * objects to the destination object for all destination properties that
	     * resolve to `undefined`. Source objects are applied from left to right.
	     * Once a property is set, additional values of the same property are ignored.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @see _.defaultsDeep
	     * @example
	     *
	     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
	     * // => { 'a': 1, 'b': 2 }
	     */
	    var defaults = baseRest(function(object, sources) {
	      object = Object(object);
	
	      var index = -1;
	      var length = sources.length;
	      var guard = length > 2 ? sources[2] : undefined;
	
	      if (guard && isIterateeCall(sources[0], sources[1], guard)) {
	        length = 1;
	      }
	
	      while (++index < length) {
	        var source = sources[index];
	        var props = keysIn(source);
	        var propsIndex = -1;
	        var propsLength = props.length;
	
	        while (++propsIndex < propsLength) {
	          var key = props[propsIndex];
	          var value = object[key];
	
	          if (value === undefined ||
	              (eq(value, objectProto[key]) && !hasOwnProperty.call(object, key))) {
	            object[key] = source[key];
	          }
	        }
	      }
	
	      return object;
	    });
	
	    /**
	     * This method is like `_.defaults` except that it recursively assigns
	     * default properties.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.10.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @see _.defaults
	     * @example
	     *
	     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
	     * // => { 'a': { 'b': 2, 'c': 3 } }
	     */
	    var defaultsDeep = baseRest(function(args) {
	      args.push(undefined, customDefaultsMerge);
	      return apply(mergeWith, undefined, args);
	    });
	
	    /**
	     * This method is like `_.find` except that it returns the key of the first
	     * element `predicate` returns truthy for instead of the element itself.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.1.0
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {string|undefined} Returns the key of the matched element,
	     *  else `undefined`.
	     * @example
	     *
	     * var users = {
	     *   'barney':  { 'age': 36, 'active': true },
	     *   'fred':    { 'age': 40, 'active': false },
	     *   'pebbles': { 'age': 1,  'active': true }
	     * };
	     *
	     * _.findKey(users, function(o) { return o.age < 40; });
	     * // => 'barney' (iteration order is not guaranteed)
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findKey(users, { 'age': 1, 'active': true });
	     * // => 'pebbles'
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findKey(users, ['active', false]);
	     * // => 'fred'
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findKey(users, 'active');
	     * // => 'barney'
	     */
	    function findKey(object, predicate) {
	      return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
	    }
	
	    /**
	     * This method is like `_.findKey` except that it iterates over elements of
	     * a collection in the opposite order.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {string|undefined} Returns the key of the matched element,
	     *  else `undefined`.
	     * @example
	     *
	     * var users = {
	     *   'barney':  { 'age': 36, 'active': true },
	     *   'fred':    { 'age': 40, 'active': false },
	     *   'pebbles': { 'age': 1,  'active': true }
	     * };
	     *
	     * _.findLastKey(users, function(o) { return o.age < 40; });
	     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findLastKey(users, { 'age': 36, 'active': true });
	     * // => 'barney'
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findLastKey(users, ['active', false]);
	     * // => 'fred'
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findLastKey(users, 'active');
	     * // => 'pebbles'
	     */
	    function findLastKey(object, predicate) {
	      return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
	    }
	
	    /**
	     * Iterates over own and inherited enumerable string keyed properties of an
	     * object and invokes `iteratee` for each property. The iteratee is invoked
	     * with three arguments: (value, key, object). Iteratee functions may exit
	     * iteration early by explicitly returning `false`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.3.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @see _.forInRight
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forIn(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
	     */
	    function forIn(object, iteratee) {
	      return object == null
	        ? object
	        : baseFor(object, getIteratee(iteratee, 3), keysIn);
	    }
	
	    /**
	     * This method is like `_.forIn` except that it iterates over properties of
	     * `object` in the opposite order.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @see _.forIn
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forInRight(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
	     */
	    function forInRight(object, iteratee) {
	      return object == null
	        ? object
	        : baseForRight(object, getIteratee(iteratee, 3), keysIn);
	    }
	
	    /**
	     * Iterates over own enumerable string keyed properties of an object and
	     * invokes `iteratee` for each property. The iteratee is invoked with three
	     * arguments: (value, key, object). Iteratee functions may exit iteration
	     * early by explicitly returning `false`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.3.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @see _.forOwnRight
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forOwn(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
	     */
	    function forOwn(object, iteratee) {
	      return object && baseForOwn(object, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * This method is like `_.forOwn` except that it iterates over properties of
	     * `object` in the opposite order.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @see _.forOwn
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forOwnRight(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
	     */
	    function forOwnRight(object, iteratee) {
	      return object && baseForOwnRight(object, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * Creates an array of function property names from own enumerable properties
	     * of `object`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @returns {Array} Returns the function names.
	     * @see _.functionsIn
	     * @example
	     *
	     * function Foo() {
	     *   this.a = _.constant('a');
	     *   this.b = _.constant('b');
	     * }
	     *
	     * Foo.prototype.c = _.constant('c');
	     *
	     * _.functions(new Foo);
	     * // => ['a', 'b']
	     */
	    function functions(object) {
	      return object == null ? [] : baseFunctions(object, keys(object));
	    }
	
	    /**
	     * Creates an array of function property names from own and inherited
	     * enumerable properties of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @returns {Array} Returns the function names.
	     * @see _.functions
	     * @example
	     *
	     * function Foo() {
	     *   this.a = _.constant('a');
	     *   this.b = _.constant('b');
	     * }
	     *
	     * Foo.prototype.c = _.constant('c');
	     *
	     * _.functionsIn(new Foo);
	     * // => ['a', 'b', 'c']
	     */
	    function functionsIn(object) {
	      return object == null ? [] : baseFunctions(object, keysIn(object));
	    }
	
	    /**
	     * Gets the value at `path` of `object`. If the resolved value is
	     * `undefined`, the `defaultValue` is returned in its place.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.7.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the property to get.
	     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
	     * @returns {*} Returns the resolved value.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	     *
	     * _.get(object, 'a[0].b.c');
	     * // => 3
	     *
	     * _.get(object, ['a', '0', 'b', 'c']);
	     * // => 3
	     *
	     * _.get(object, 'a.b.c', 'default');
	     * // => 'default'
	     */
	    function get(object, path, defaultValue) {
	      var result = object == null ? undefined : baseGet(object, path);
	      return result === undefined ? defaultValue : result;
	    }
	
	    /**
	     * Checks if `path` is a direct property of `object`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path to check.
	     * @returns {boolean} Returns `true` if `path` exists, else `false`.
	     * @example
	     *
	     * var object = { 'a': { 'b': 2 } };
	     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
	     *
	     * _.has(object, 'a');
	     * // => true
	     *
	     * _.has(object, 'a.b');
	     * // => true
	     *
	     * _.has(object, ['a', 'b']);
	     * // => true
	     *
	     * _.has(other, 'a');
	     * // => false
	     */
	    function has(object, path) {
	      return object != null && hasPath(object, path, baseHas);
	    }
	
	    /**
	     * Checks if `path` is a direct or inherited property of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path to check.
	     * @returns {boolean} Returns `true` if `path` exists, else `false`.
	     * @example
	     *
	     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
	     *
	     * _.hasIn(object, 'a');
	     * // => true
	     *
	     * _.hasIn(object, 'a.b');
	     * // => true
	     *
	     * _.hasIn(object, ['a', 'b']);
	     * // => true
	     *
	     * _.hasIn(object, 'b');
	     * // => false
	     */
	    function hasIn(object, path) {
	      return object != null && hasPath(object, path, baseHasIn);
	    }
	
	    /**
	     * Creates an object composed of the inverted keys and values of `object`.
	     * If `object` contains duplicate values, subsequent values overwrite
	     * property assignments of previous values.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.7.0
	     * @category Object
	     * @param {Object} object The object to invert.
	     * @returns {Object} Returns the new inverted object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2, 'c': 1 };
	     *
	     * _.invert(object);
	     * // => { '1': 'c', '2': 'b' }
	     */
	    var invert = createInverter(function(result, value, key) {
	      if (value != null &&
	          typeof value.toString != 'function') {
	        value = nativeObjectToString.call(value);
	      }
	
	      result[value] = key;
	    }, constant(identity));
	
	    /**
	     * This method is like `_.invert` except that the inverted object is generated
	     * from the results of running each element of `object` thru `iteratee`. The
	     * corresponding inverted value of each inverted key is an array of keys
	     * responsible for generating the inverted value. The iteratee is invoked
	     * with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.1.0
	     * @category Object
	     * @param {Object} object The object to invert.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Object} Returns the new inverted object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2, 'c': 1 };
	     *
	     * _.invertBy(object);
	     * // => { '1': ['a', 'c'], '2': ['b'] }
	     *
	     * _.invertBy(object, function(value) {
	     *   return 'group' + value;
	     * });
	     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
	     */
	    var invertBy = createInverter(function(result, value, key) {
	      if (value != null &&
	          typeof value.toString != 'function') {
	        value = nativeObjectToString.call(value);
	      }
	
	      if (hasOwnProperty.call(result, value)) {
	        result[value].push(key);
	      } else {
	        result[value] = [key];
	      }
	    }, getIteratee);
	
	    /**
	     * Invokes the method at `path` of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the method to invoke.
	     * @param {...*} [args] The arguments to invoke the method with.
	     * @returns {*} Returns the result of the invoked method.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
	     *
	     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
	     * // => [2, 3]
	     */
	    var invoke = baseRest(baseInvoke);
	
	    /**
	     * Creates an array of the own enumerable property names of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects. See the
	     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	     * for more details.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.keys(new Foo);
	     * // => ['a', 'b'] (iteration order is not guaranteed)
	     *
	     * _.keys('hi');
	     * // => ['0', '1']
	     */
	    function keys(object) {
	      return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
	    }
	
	    /**
	     * Creates an array of the own and inherited enumerable property names of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.keysIn(new Foo);
	     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
	     */
	    function keysIn(object) {
	      return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
	    }
	
	    /**
	     * The opposite of `_.mapValues`; this method creates an object with the
	     * same values as `object` and keys generated by running each own enumerable
	     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
	     * with three arguments: (value, key, object).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.8.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns the new mapped object.
	     * @see _.mapValues
	     * @example
	     *
	     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
	     *   return key + value;
	     * });
	     * // => { 'a1': 1, 'b2': 2 }
	     */
	    function mapKeys(object, iteratee) {
	      var result = {};
	      iteratee = getIteratee(iteratee, 3);
	
	      baseForOwn(object, function(value, key, object) {
	        baseAssignValue(result, iteratee(value, key, object), value);
	      });
	      return result;
	    }
	
	    /**
	     * Creates an object with the same keys as `object` and values generated
	     * by running each own enumerable string keyed property of `object` thru
	     * `iteratee`. The iteratee is invoked with three arguments:
	     * (value, key, object).
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns the new mapped object.
	     * @see _.mapKeys
	     * @example
	     *
	     * var users = {
	     *   'fred':    { 'user': 'fred',    'age': 40 },
	     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
	     * };
	     *
	     * _.mapValues(users, function(o) { return o.age; });
	     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.mapValues(users, 'age');
	     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
	     */
	    function mapValues(object, iteratee) {
	      var result = {};
	      iteratee = getIteratee(iteratee, 3);
	
	      baseForOwn(object, function(value, key, object) {
	        baseAssignValue(result, key, iteratee(value, key, object));
	      });
	      return result;
	    }
	
	    /**
	     * This method is like `_.assign` except that it recursively merges own and
	     * inherited enumerable string keyed properties of source objects into the
	     * destination object. Source properties that resolve to `undefined` are
	     * skipped if a destination value exists. Array and plain object properties
	     * are merged recursively. Other objects and value types are overridden by
	     * assignment. Source objects are applied from left to right. Subsequent
	     * sources overwrite property assignments of previous sources.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.5.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = {
	     *   'a': [{ 'b': 2 }, { 'd': 4 }]
	     * };
	     *
	     * var other = {
	     *   'a': [{ 'c': 3 }, { 'e': 5 }]
	     * };
	     *
	     * _.merge(object, other);
	     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
	     */
	    var merge = createAssigner(function(object, source, srcIndex) {
	      baseMerge(object, source, srcIndex);
	    });
	
	    /**
	     * This method is like `_.merge` except that it accepts `customizer` which
	     * is invoked to produce the merged values of the destination and source
	     * properties. If `customizer` returns `undefined`, merging is handled by the
	     * method instead. The `customizer` is invoked with six arguments:
	     * (objValue, srcValue, key, object, source, stack).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} sources The source objects.
	     * @param {Function} customizer The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * function customizer(objValue, srcValue) {
	     *   if (_.isArray(objValue)) {
	     *     return objValue.concat(srcValue);
	     *   }
	     * }
	     *
	     * var object = { 'a': [1], 'b': [2] };
	     * var other = { 'a': [3], 'b': [4] };
	     *
	     * _.mergeWith(object, other, customizer);
	     * // => { 'a': [1, 3], 'b': [2, 4] }
	     */
	    var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
	      baseMerge(object, source, srcIndex, customizer);
	    });
	
	    /**
	     * The opposite of `_.pick`; this method creates an object composed of the
	     * own and inherited enumerable property paths of `object` that are not omitted.
	     *
	     * **Note:** This method is considerably slower than `_.pick`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {...(string|string[])} [paths] The property paths to omit.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.omit(object, ['a', 'c']);
	     * // => { 'b': '2' }
	     */
	    var omit = flatRest(function(object, paths) {
	      var result = {};
	      if (object == null) {
	        return result;
	      }
	      var isDeep = false;
	      paths = arrayMap(paths, function(path) {
	        path = castPath(path, object);
	        isDeep || (isDeep = path.length > 1);
	        return path;
	      });
	      copyObject(object, getAllKeysIn(object), result);
	      if (isDeep) {
	        result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
	      }
	      var length = paths.length;
	      while (length--) {
	        baseUnset(result, paths[length]);
	      }
	      return result;
	    });
	
	    /**
	     * The opposite of `_.pickBy`; this method creates an object composed of
	     * the own and inherited enumerable string keyed properties of `object` that
	     * `predicate` doesn't return truthy for. The predicate is invoked with two
	     * arguments: (value, key).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {Function} [predicate=_.identity] The function invoked per property.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.omitBy(object, _.isNumber);
	     * // => { 'b': '2' }
	     */
	    function omitBy(object, predicate) {
	      return pickBy(object, negate(getIteratee(predicate)));
	    }
	
	    /**
	     * Creates an object composed of the picked `object` properties.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {...(string|string[])} [paths] The property paths to pick.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.pick(object, ['a', 'c']);
	     * // => { 'a': 1, 'c': 3 }
	     */
	    var pick = flatRest(function(object, paths) {
	      return object == null ? {} : basePick(object, paths);
	    });
	
	    /**
	     * Creates an object composed of the `object` properties `predicate` returns
	     * truthy for. The predicate is invoked with two arguments: (value, key).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {Function} [predicate=_.identity] The function invoked per property.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.pickBy(object, _.isNumber);
	     * // => { 'a': 1, 'c': 3 }
	     */
	    function pickBy(object, predicate) {
	      if (object == null) {
	        return {};
	      }
	      var props = arrayMap(getAllKeysIn(object), function(prop) {
	        return [prop];
	      });
	      predicate = getIteratee(predicate);
	      return basePickBy(object, props, function(value, path) {
	        return predicate(value, path[0]);
	      });
	    }
	
	    /**
	     * This method is like `_.get` except that if the resolved value is a
	     * function it's invoked with the `this` binding of its parent object and
	     * its result is returned.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the property to resolve.
	     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
	     * @returns {*} Returns the resolved value.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
	     *
	     * _.result(object, 'a[0].b.c1');
	     * // => 3
	     *
	     * _.result(object, 'a[0].b.c2');
	     * // => 4
	     *
	     * _.result(object, 'a[0].b.c3', 'default');
	     * // => 'default'
	     *
	     * _.result(object, 'a[0].b.c3', _.constant('default'));
	     * // => 'default'
	     */
	    function result(object, path, defaultValue) {
	      path = castPath(path, object);
	
	      var index = -1,
	          length = path.length;
	
	      // Ensure the loop is entered when path is empty.
	      if (!length) {
	        length = 1;
	        object = undefined;
	      }
	      while (++index < length) {
	        var value = object == null ? undefined : object[toKey(path[index])];
	        if (value === undefined) {
	          index = length;
	          value = defaultValue;
	        }
	        object = isFunction(value) ? value.call(object) : value;
	      }
	      return object;
	    }
	
	    /**
	     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
	     * it's created. Arrays are created for missing index properties while objects
	     * are created for all other missing properties. Use `_.setWith` to customize
	     * `path` creation.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.7.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	     *
	     * _.set(object, 'a[0].b.c', 4);
	     * console.log(object.a[0].b.c);
	     * // => 4
	     *
	     * _.set(object, ['x', '0', 'y', 'z'], 5);
	     * console.log(object.x[0].y.z);
	     * // => 5
	     */
	    function set(object, path, value) {
	      return object == null ? object : baseSet(object, path, value);
	    }
	
	    /**
	     * This method is like `_.set` except that it accepts `customizer` which is
	     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
	     * path creation is handled by the method instead. The `customizer` is invoked
	     * with three arguments: (nsValue, key, nsObject).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {*} value The value to set.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = {};
	     *
	     * _.setWith(object, '[0][1]', 'a', Object);
	     * // => { '0': { '1': 'a' } }
	     */
	    function setWith(object, path, value, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return object == null ? object : baseSet(object, path, value, customizer);
	    }
	
	    /**
	     * Creates an array of own enumerable string keyed-value pairs for `object`
	     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
	     * entries are returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @alias entries
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the key-value pairs.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.toPairs(new Foo);
	     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
	     */
	    var toPairs = createToPairs(keys);
	
	    /**
	     * Creates an array of own and inherited enumerable string keyed-value pairs
	     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
	     * or set, its entries are returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @alias entriesIn
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the key-value pairs.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.toPairsIn(new Foo);
	     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
	     */
	    var toPairsIn = createToPairs(keysIn);
	
	    /**
	     * An alternative to `_.reduce`; this method transforms `object` to a new
	     * `accumulator` object which is the result of running each of its own
	     * enumerable string keyed properties thru `iteratee`, with each invocation
	     * potentially mutating the `accumulator` object. If `accumulator` is not
	     * provided, a new object with the same `[[Prototype]]` will be used. The
	     * iteratee is invoked with four arguments: (accumulator, value, key, object).
	     * Iteratee functions may exit iteration early by explicitly returning `false`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.3.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [accumulator] The custom accumulator value.
	     * @returns {*} Returns the accumulated value.
	     * @example
	     *
	     * _.transform([2, 3, 4], function(result, n) {
	     *   result.push(n *= n);
	     *   return n % 2 == 0;
	     * }, []);
	     * // => [4, 9]
	     *
	     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
	     *   (result[value] || (result[value] = [])).push(key);
	     * }, {});
	     * // => { '1': ['a', 'c'], '2': ['b'] }
	     */
	    function transform(object, iteratee, accumulator) {
	      var isArr = isArray(object),
	          isArrLike = isArr || isBuffer(object) || isTypedArray(object);
	
	      iteratee = getIteratee(iteratee, 4);
	      if (accumulator == null) {
	        var Ctor = object && object.constructor;
	        if (isArrLike) {
	          accumulator = isArr ? new Ctor : [];
	        }
	        else if (isObject(object)) {
	          accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
	        }
	        else {
	          accumulator = {};
	        }
	      }
	      (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
	        return iteratee(accumulator, value, index, object);
	      });
	      return accumulator;
	    }
	
	    /**
	     * Removes the property at `path` of `object`.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to unset.
	     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
	     * _.unset(object, 'a[0].b.c');
	     * // => true
	     *
	     * console.log(object);
	     * // => { 'a': [{ 'b': {} }] };
	     *
	     * _.unset(object, ['a', '0', 'b', 'c']);
	     * // => true
	     *
	     * console.log(object);
	     * // => { 'a': [{ 'b': {} }] };
	     */
	    function unset(object, path) {
	      return object == null ? true : baseUnset(object, path);
	    }
	
	    /**
	     * This method is like `_.set` except that accepts `updater` to produce the
	     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
	     * is invoked with one argument: (value).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.6.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {Function} updater The function to produce the updated value.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	     *
	     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
	     * console.log(object.a[0].b.c);
	     * // => 9
	     *
	     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
	     * console.log(object.x[0].y.z);
	     * // => 0
	     */
	    function update(object, path, updater) {
	      return object == null ? object : baseUpdate(object, path, castFunction(updater));
	    }
	
	    /**
	     * This method is like `_.update` except that it accepts `customizer` which is
	     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
	     * path creation is handled by the method instead. The `customizer` is invoked
	     * with three arguments: (nsValue, key, nsObject).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.6.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {Function} updater The function to produce the updated value.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = {};
	     *
	     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
	     * // => { '0': { '1': 'a' } }
	     */
	    function updateWith(object, path, updater, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
	    }
	
	    /**
	     * Creates an array of the own enumerable string keyed property values of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property values.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.values(new Foo);
	     * // => [1, 2] (iteration order is not guaranteed)
	     *
	     * _.values('hi');
	     * // => ['h', 'i']
	     */
	    function values(object) {
	      return object == null ? [] : baseValues(object, keys(object));
	    }
	
	    /**
	     * Creates an array of the own and inherited enumerable string keyed property
	     * values of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property values.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.valuesIn(new Foo);
	     * // => [1, 2, 3] (iteration order is not guaranteed)
	     */
	    function valuesIn(object) {
	      return object == null ? [] : baseValues(object, keysIn(object));
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Clamps `number` within the inclusive `lower` and `upper` bounds.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Number
	     * @param {number} number The number to clamp.
	     * @param {number} [lower] The lower bound.
	     * @param {number} upper The upper bound.
	     * @returns {number} Returns the clamped number.
	     * @example
	     *
	     * _.clamp(-10, -5, 5);
	     * // => -5
	     *
	     * _.clamp(10, -5, 5);
	     * // => 5
	     */
	    function clamp(number, lower, upper) {
	      if (upper === undefined) {
	        upper = lower;
	        lower = undefined;
	      }
	      if (upper !== undefined) {
	        upper = toNumber(upper);
	        upper = upper === upper ? upper : 0;
	      }
	      if (lower !== undefined) {
	        lower = toNumber(lower);
	        lower = lower === lower ? lower : 0;
	      }
	      return baseClamp(toNumber(number), lower, upper);
	    }
	
	    /**
	     * Checks if `n` is between `start` and up to, but not including, `end`. If
	     * `end` is not specified, it's set to `start` with `start` then set to `0`.
	     * If `start` is greater than `end` the params are swapped to support
	     * negative ranges.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.3.0
	     * @category Number
	     * @param {number} number The number to check.
	     * @param {number} [start=0] The start of the range.
	     * @param {number} end The end of the range.
	     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
	     * @see _.range, _.rangeRight
	     * @example
	     *
	     * _.inRange(3, 2, 4);
	     * // => true
	     *
	     * _.inRange(4, 8);
	     * // => true
	     *
	     * _.inRange(4, 2);
	     * // => false
	     *
	     * _.inRange(2, 2);
	     * // => false
	     *
	     * _.inRange(1.2, 2);
	     * // => true
	     *
	     * _.inRange(5.2, 4);
	     * // => false
	     *
	     * _.inRange(-3, -2, -6);
	     * // => true
	     */
	    function inRange(number, start, end) {
	      start = toFinite(start);
	      if (end === undefined) {
	        end = start;
	        start = 0;
	      } else {
	        end = toFinite(end);
	      }
	      number = toNumber(number);
	      return baseInRange(number, start, end);
	    }
	
	    /**
	     * Produces a random number between the inclusive `lower` and `upper` bounds.
	     * If only one argument is provided a number between `0` and the given number
	     * is returned. If `floating` is `true`, or either `lower` or `upper` are
	     * floats, a floating-point number is returned instead of an integer.
	     *
	     * **Note:** JavaScript follows the IEEE-754 standard for resolving
	     * floating-point values which can produce unexpected results.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.7.0
	     * @category Number
	     * @param {number} [lower=0] The lower bound.
	     * @param {number} [upper=1] The upper bound.
	     * @param {boolean} [floating] Specify returning a floating-point number.
	     * @returns {number} Returns the random number.
	     * @example
	     *
	     * _.random(0, 5);
	     * // => an integer between 0 and 5
	     *
	     * _.random(5);
	     * // => also an integer between 0 and 5
	     *
	     * _.random(5, true);
	     * // => a floating-point number between 0 and 5
	     *
	     * _.random(1.2, 5.2);
	     * // => a floating-point number between 1.2 and 5.2
	     */
	    function random(lower, upper, floating) {
	      if (floating && typeof floating != 'boolean' && isIterateeCall(lower, upper, floating)) {
	        upper = floating = undefined;
	      }
	      if (floating === undefined) {
	        if (typeof upper == 'boolean') {
	          floating = upper;
	          upper = undefined;
	        }
	        else if (typeof lower == 'boolean') {
	          floating = lower;
	          lower = undefined;
	        }
	      }
	      if (lower === undefined && upper === undefined) {
	        lower = 0;
	        upper = 1;
	      }
	      else {
	        lower = toFinite(lower);
	        if (upper === undefined) {
	          upper = lower;
	          lower = 0;
	        } else {
	          upper = toFinite(upper);
	        }
	      }
	      if (lower > upper) {
	        var temp = lower;
	        lower = upper;
	        upper = temp;
	      }
	      if (floating || lower % 1 || upper % 1) {
	        var rand = nativeRandom();
	        return nativeMin(lower + (rand * (upper - lower + freeParseFloat('1e-' + ((rand + '').length - 1)))), upper);
	      }
	      return baseRandom(lower, upper);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the camel cased string.
	     * @example
	     *
	     * _.camelCase('Foo Bar');
	     * // => 'fooBar'
	     *
	     * _.camelCase('--foo-bar--');
	     * // => 'fooBar'
	     *
	     * _.camelCase('__FOO_BAR__');
	     * // => 'fooBar'
	     */
	    var camelCase = createCompounder(function(result, word, index) {
	      word = word.toLowerCase();
	      return result + (index ? capitalize(word) : word);
	    });
	
	    /**
	     * Converts the first character of `string` to upper case and the remaining
	     * to lower case.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to capitalize.
	     * @returns {string} Returns the capitalized string.
	     * @example
	     *
	     * _.capitalize('FRED');
	     * // => 'Fred'
	     */
	    function capitalize(string) {
	      return upperFirst(toString(string).toLowerCase());
	    }
	
	    /**
	     * Deburrs `string` by converting
	     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
	     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
	     * letters to basic Latin letters and removing
	     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to deburr.
	     * @returns {string} Returns the deburred string.
	     * @example
	     *
	     * _.deburr('déjà vu');
	     * // => 'deja vu'
	     */
	    function deburr(string) {
	      string = toString(string);
	      return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
	    }
	
	    /**
	     * Checks if `string` ends with the given target string.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to inspect.
	     * @param {string} [target] The string to search for.
	     * @param {number} [position=string.length] The position to search up to.
	     * @returns {boolean} Returns `true` if `string` ends with `target`,
	     *  else `false`.
	     * @example
	     *
	     * _.endsWith('abc', 'c');
	     * // => true
	     *
	     * _.endsWith('abc', 'b');
	     * // => false
	     *
	     * _.endsWith('abc', 'b', 2);
	     * // => true
	     */
	    function endsWith(string, target, position) {
	      string = toString(string);
	      target = baseToString(target);
	
	      var length = string.length;
	      position = position === undefined
	        ? length
	        : baseClamp(toInteger(position), 0, length);
	
	      var end = position;
	      position -= target.length;
	      return position >= 0 && string.slice(position, end) == target;
	    }
	
	    /**
	     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
	     * corresponding HTML entities.
	     *
	     * **Note:** No other characters are escaped. To escape additional
	     * characters use a third-party library like [_he_](https://mths.be/he).
	     *
	     * Though the ">" character is escaped for symmetry, characters like
	     * ">" and "/" don't need escaping in HTML and have no special meaning
	     * unless they're part of a tag or unquoted attribute value. See
	     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
	     * (under "semi-related fun fact") for more details.
	     *
	     * When working with HTML you should always
	     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
	     * XSS vectors.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to escape.
	     * @returns {string} Returns the escaped string.
	     * @example
	     *
	     * _.escape('fred, barney, & pebbles');
	     * // => 'fred, barney, &amp; pebbles'
	     */
	    function escape(string) {
	      string = toString(string);
	      return (string && reHasUnescapedHtml.test(string))
	        ? string.replace(reUnescapedHtml, escapeHtmlChar)
	        : string;
	    }
	
	    /**
	     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
	     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to escape.
	     * @returns {string} Returns the escaped string.
	     * @example
	     *
	     * _.escapeRegExp('[lodash](https://lodash.com/)');
	     * // => '\[lodash\]\(https://lodash\.com/\)'
	     */
	    function escapeRegExp(string) {
	      string = toString(string);
	      return (string && reHasRegExpChar.test(string))
	        ? string.replace(reRegExpChar, '\\$&')
	        : string;
	    }
	
	    /**
	     * Converts `string` to
	     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the kebab cased string.
	     * @example
	     *
	     * _.kebabCase('Foo Bar');
	     * // => 'foo-bar'
	     *
	     * _.kebabCase('fooBar');
	     * // => 'foo-bar'
	     *
	     * _.kebabCase('__FOO_BAR__');
	     * // => 'foo-bar'
	     */
	    var kebabCase = createCompounder(function(result, word, index) {
	      return result + (index ? '-' : '') + word.toLowerCase();
	    });
	
	    /**
	     * Converts `string`, as space separated words, to lower case.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the lower cased string.
	     * @example
	     *
	     * _.lowerCase('--Foo-Bar--');
	     * // => 'foo bar'
	     *
	     * _.lowerCase('fooBar');
	     * // => 'foo bar'
	     *
	     * _.lowerCase('__FOO_BAR__');
	     * // => 'foo bar'
	     */
	    var lowerCase = createCompounder(function(result, word, index) {
	      return result + (index ? ' ' : '') + word.toLowerCase();
	    });
	
	    /**
	     * Converts the first character of `string` to lower case.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the converted string.
	     * @example
	     *
	     * _.lowerFirst('Fred');
	     * // => 'fred'
	     *
	     * _.lowerFirst('FRED');
	     * // => 'fRED'
	     */
	    var lowerFirst = createCaseFirst('toLowerCase');
	
	    /**
	     * Pads `string` on the left and right sides if it's shorter than `length`.
	     * Padding characters are truncated if they can't be evenly divided by `length`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to pad.
	     * @param {number} [length=0] The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padded string.
	     * @example
	     *
	     * _.pad('abc', 8);
	     * // => '  abc   '
	     *
	     * _.pad('abc', 8, '_-');
	     * // => '_-abc_-_'
	     *
	     * _.pad('abc', 3);
	     * // => 'abc'
	     */
	    function pad(string, length, chars) {
	      string = toString(string);
	      length = toInteger(length);
	
	      var strLength = length ? stringSize(string) : 0;
	      if (!length || strLength >= length) {
	        return string;
	      }
	      var mid = (length - strLength) / 2;
	      return (
	        createPadding(nativeFloor(mid), chars) +
	        string +
	        createPadding(nativeCeil(mid), chars)
	      );
	    }
	
	    /**
	     * Pads `string` on the right side if it's shorter than `length`. Padding
	     * characters are truncated if they exceed `length`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to pad.
	     * @param {number} [length=0] The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padded string.
	     * @example
	     *
	     * _.padEnd('abc', 6);
	     * // => 'abc   '
	     *
	     * _.padEnd('abc', 6, '_-');
	     * // => 'abc_-_'
	     *
	     * _.padEnd('abc', 3);
	     * // => 'abc'
	     */
	    function padEnd(string, length, chars) {
	      string = toString(string);
	      length = toInteger(length);
	
	      var strLength = length ? stringSize(string) : 0;
	      return (length && strLength < length)
	        ? (string + createPadding(length - strLength, chars))
	        : string;
	    }
	
	    /**
	     * Pads `string` on the left side if it's shorter than `length`. Padding
	     * characters are truncated if they exceed `length`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to pad.
	     * @param {number} [length=0] The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padded string.
	     * @example
	     *
	     * _.padStart('abc', 6);
	     * // => '   abc'
	     *
	     * _.padStart('abc', 6, '_-');
	     * // => '_-_abc'
	     *
	     * _.padStart('abc', 3);
	     * // => 'abc'
	     */
	    function padStart(string, length, chars) {
	      string = toString(string);
	      length = toInteger(length);
	
	      var strLength = length ? stringSize(string) : 0;
	      return (length && strLength < length)
	        ? (createPadding(length - strLength, chars) + string)
	        : string;
	    }
	
	    /**
	     * Converts `string` to an integer of the specified radix. If `radix` is
	     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
	     * hexadecimal, in which case a `radix` of `16` is used.
	     *
	     * **Note:** This method aligns with the
	     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.1.0
	     * @category String
	     * @param {string} string The string to convert.
	     * @param {number} [radix=10] The radix to interpret `value` by.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.parseInt('08');
	     * // => 8
	     *
	     * _.map(['6', '08', '10'], _.parseInt);
	     * // => [6, 8, 10]
	     */
	    function parseInt(string, radix, guard) {
	      if (guard || radix == null) {
	        radix = 0;
	      } else if (radix) {
	        radix = +radix;
	      }
	      return nativeParseInt(toString(string).replace(reTrimStart, ''), radix || 0);
	    }
	
	    /**
	     * Repeats the given string `n` times.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to repeat.
	     * @param {number} [n=1] The number of times to repeat the string.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {string} Returns the repeated string.
	     * @example
	     *
	     * _.repeat('*', 3);
	     * // => '***'
	     *
	     * _.repeat('abc', 2);
	     * // => 'abcabc'
	     *
	     * _.repeat('abc', 0);
	     * // => ''
	     */
	    function repeat(string, n, guard) {
	      if ((guard ? isIterateeCall(string, n, guard) : n === undefined)) {
	        n = 1;
	      } else {
	        n = toInteger(n);
	      }
	      return baseRepeat(toString(string), n);
	    }
	
	    /**
	     * Replaces matches for `pattern` in `string` with `replacement`.
	     *
	     * **Note:** This method is based on
	     * [`String#replace`](https://mdn.io/String/replace).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to modify.
	     * @param {RegExp|string} pattern The pattern to replace.
	     * @param {Function|string} replacement The match replacement.
	     * @returns {string} Returns the modified string.
	     * @example
	     *
	     * _.replace('Hi Fred', 'Fred', 'Barney');
	     * // => 'Hi Barney'
	     */
	    function replace() {
	      var args = arguments,
	          string = toString(args[0]);
	
	      return args.length < 3 ? string : string.replace(args[1], args[2]);
	    }
	
	    /**
	     * Converts `string` to
	     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the snake cased string.
	     * @example
	     *
	     * _.snakeCase('Foo Bar');
	     * // => 'foo_bar'
	     *
	     * _.snakeCase('fooBar');
	     * // => 'foo_bar'
	     *
	     * _.snakeCase('--FOO-BAR--');
	     * // => 'foo_bar'
	     */
	    var snakeCase = createCompounder(function(result, word, index) {
	      return result + (index ? '_' : '') + word.toLowerCase();
	    });
	
	    /**
	     * Splits `string` by `separator`.
	     *
	     * **Note:** This method is based on
	     * [`String#split`](https://mdn.io/String/split).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to split.
	     * @param {RegExp|string} separator The separator pattern to split by.
	     * @param {number} [limit] The length to truncate results to.
	     * @returns {Array} Returns the string segments.
	     * @example
	     *
	     * _.split('a-b-c', '-', 2);
	     * // => ['a', 'b']
	     */
	    function split(string, separator, limit) {
	      if (limit && typeof limit != 'number' && isIterateeCall(string, separator, limit)) {
	        separator = limit = undefined;
	      }
	      limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
	      if (!limit) {
	        return [];
	      }
	      string = toString(string);
	      if (string && (
	            typeof separator == 'string' ||
	            (separator != null && !isRegExp(separator))
	          )) {
	        separator = baseToString(separator);
	        if (!separator && hasUnicode(string)) {
	          return castSlice(stringToArray(string), 0, limit);
	        }
	      }
	      return string.split(separator, limit);
	    }
	
	    /**
	     * Converts `string` to
	     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.1.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the start cased string.
	     * @example
	     *
	     * _.startCase('--foo-bar--');
	     * // => 'Foo Bar'
	     *
	     * _.startCase('fooBar');
	     * // => 'Foo Bar'
	     *
	     * _.startCase('__FOO_BAR__');
	     * // => 'FOO BAR'
	     */
	    var startCase = createCompounder(function(result, word, index) {
	      return result + (index ? ' ' : '') + upperFirst(word);
	    });
	
	    /**
	     * Checks if `string` starts with the given target string.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to inspect.
	     * @param {string} [target] The string to search for.
	     * @param {number} [position=0] The position to search from.
	     * @returns {boolean} Returns `true` if `string` starts with `target`,
	     *  else `false`.
	     * @example
	     *
	     * _.startsWith('abc', 'a');
	     * // => true
	     *
	     * _.startsWith('abc', 'b');
	     * // => false
	     *
	     * _.startsWith('abc', 'b', 1);
	     * // => true
	     */
	    function startsWith(string, target, position) {
	      string = toString(string);
	      position = position == null
	        ? 0
	        : baseClamp(toInteger(position), 0, string.length);
	
	      target = baseToString(target);
	      return string.slice(position, position + target.length) == target;
	    }
	
	    /**
	     * Creates a compiled template function that can interpolate data properties
	     * in "interpolate" delimiters, HTML-escape interpolated data properties in
	     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
	     * properties may be accessed as free variables in the template. If a setting
	     * object is given, it takes precedence over `_.templateSettings` values.
	     *
	     * **Note:** In the development build `_.template` utilizes
	     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
	     * for easier debugging.
	     *
	     * For more information on precompiling templates see
	     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
	     *
	     * For more information on Chrome extension sandboxes see
	     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The template string.
	     * @param {Object} [options={}] The options object.
	     * @param {RegExp} [options.escape=_.templateSettings.escape]
	     *  The HTML "escape" delimiter.
	     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
	     *  The "evaluate" delimiter.
	     * @param {Object} [options.imports=_.templateSettings.imports]
	     *  An object to import into the template as free variables.
	     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
	     *  The "interpolate" delimiter.
	     * @param {string} [options.sourceURL='lodash.templateSources[n]']
	     *  The sourceURL of the compiled template.
	     * @param {string} [options.variable='obj']
	     *  The data object variable name.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Function} Returns the compiled template function.
	     * @example
	     *
	     * // Use the "interpolate" delimiter to create a compiled template.
	     * var compiled = _.template('hello <%= user %>!');
	     * compiled({ 'user': 'fred' });
	     * // => 'hello fred!'
	     *
	     * // Use the HTML "escape" delimiter to escape data property values.
	     * var compiled = _.template('<b><%- value %></b>');
	     * compiled({ 'value': '<script>' });
	     * // => '<b>&lt;script&gt;</b>'
	     *
	     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
	     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
	     * compiled({ 'users': ['fred', 'barney'] });
	     * // => '<li>fred</li><li>barney</li>'
	     *
	     * // Use the internal `print` function in "evaluate" delimiters.
	     * var compiled = _.template('<% print("hello " + user); %>!');
	     * compiled({ 'user': 'barney' });
	     * // => 'hello barney!'
	     *
	     * // Use the ES template literal delimiter as an "interpolate" delimiter.
	     * // Disable support by replacing the "interpolate" delimiter.
	     * var compiled = _.template('hello ${ user }!');
	     * compiled({ 'user': 'pebbles' });
	     * // => 'hello pebbles!'
	     *
	     * // Use backslashes to treat delimiters as plain text.
	     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
	     * compiled({ 'value': 'ignored' });
	     * // => '<%- value %>'
	     *
	     * // Use the `imports` option to import `jQuery` as `jq`.
	     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
	     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
	     * compiled({ 'users': ['fred', 'barney'] });
	     * // => '<li>fred</li><li>barney</li>'
	     *
	     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
	     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
	     * compiled(data);
	     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
	     *
	     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
	     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
	     * compiled.source;
	     * // => function(data) {
	     * //   var __t, __p = '';
	     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
	     * //   return __p;
	     * // }
	     *
	     * // Use custom template delimiters.
	     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
	     * var compiled = _.template('hello {{ user }}!');
	     * compiled({ 'user': 'mustache' });
	     * // => 'hello mustache!'
	     *
	     * // Use the `source` property to inline compiled templates for meaningful
	     * // line numbers in error messages and stack traces.
	     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
	     *   var JST = {\
	     *     "main": ' + _.template(mainText).source + '\
	     *   };\
	     * ');
	     */
	    function template(string, options, guard) {
	      // Based on John Resig's `tmpl` implementation
	      // (http://ejohn.org/blog/javascript-micro-templating/)
	      // and Laura Doktorova's doT.js (https://github.com/olado/doT).
	      var settings = lodash.templateSettings;
	
	      if (guard && isIterateeCall(string, options, guard)) {
	        options = undefined;
	      }
	      string = toString(string);
	      options = assignInWith({}, options, settings, customDefaultsAssignIn);
	
	      var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn),
	          importsKeys = keys(imports),
	          importsValues = baseValues(imports, importsKeys);
	
	      var isEscaping,
	          isEvaluating,
	          index = 0,
	          interpolate = options.interpolate || reNoMatch,
	          source = "__p += '";
	
	      // Compile the regexp to match each delimiter.
	      var reDelimiters = RegExp(
	        (options.escape || reNoMatch).source + '|' +
	        interpolate.source + '|' +
	        (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' +
	        (options.evaluate || reNoMatch).source + '|$'
	      , 'g');
	
	      // Use a sourceURL for easier debugging.
	      // The sourceURL gets injected into the source that's eval-ed, so be careful
	      // with lookup (in case of e.g. prototype pollution), and strip newlines if any.
	      // A newline wouldn't be a valid sourceURL anyway, and it'd enable code injection.
	      var sourceURL = '//# sourceURL=' +
	        (hasOwnProperty.call(options, 'sourceURL')
	          ? (options.sourceURL + '').replace(/[\r\n]/g, ' ')
	          : ('lodash.templateSources[' + (++templateCounter) + ']')
	        ) + '\n';
	
	      string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
	        interpolateValue || (interpolateValue = esTemplateValue);
	
	        // Escape characters that can't be included in string literals.
	        source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);
	
	        // Replace delimiters with snippets.
	        if (escapeValue) {
	          isEscaping = true;
	          source += "' +\n__e(" + escapeValue + ") +\n'";
	        }
	        if (evaluateValue) {
	          isEvaluating = true;
	          source += "';\n" + evaluateValue + ";\n__p += '";
	        }
	        if (interpolateValue) {
	          source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
	        }
	        index = offset + match.length;
	
	        // The JS engine embedded in Adobe products needs `match` returned in
	        // order to produce the correct `offset` value.
	        return match;
	      });
	
	      source += "';\n";
	
	      // If `variable` is not specified wrap a with-statement around the generated
	      // code to add the data object to the top of the scope chain.
	      // Like with sourceURL, we take care to not check the option's prototype,
	      // as this configuration is a code injection vector.
	      var variable = hasOwnProperty.call(options, 'variable') && options.variable;
	      if (!variable) {
	        source = 'with (obj) {\n' + source + '\n}\n';
	      }
	      // Cleanup code by stripping empty strings.
	      source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source)
	        .replace(reEmptyStringMiddle, '$1')
	        .replace(reEmptyStringTrailing, '$1;');
	
	      // Frame code as the function body.
	      source = 'function(' + (variable || 'obj') + ') {\n' +
	        (variable
	          ? ''
	          : 'obj || (obj = {});\n'
	        ) +
	        "var __t, __p = ''" +
	        (isEscaping
	           ? ', __e = _.escape'
	           : ''
	        ) +
	        (isEvaluating
	          ? ', __j = Array.prototype.join;\n' +
	            "function print() { __p += __j.call(arguments, '') }\n"
	          : ';\n'
	        ) +
	        source +
	        'return __p\n}';
	
	      var result = attempt(function() {
	        return Function(importsKeys, sourceURL + 'return ' + source)
	          .apply(undefined, importsValues);
	      });
	
	      // Provide the compiled function's source by its `toString` method or
	      // the `source` property as a convenience for inlining compiled templates.
	      result.source = source;
	      if (isError(result)) {
	        throw result;
	      }
	      return result;
	    }
	
	    /**
	     * Converts `string`, as a whole, to lower case just like
	     * [String#toLowerCase](https://mdn.io/toLowerCase).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the lower cased string.
	     * @example
	     *
	     * _.toLower('--Foo-Bar--');
	     * // => '--foo-bar--'
	     *
	     * _.toLower('fooBar');
	     * // => 'foobar'
	     *
	     * _.toLower('__FOO_BAR__');
	     * // => '__foo_bar__'
	     */
	    function toLower(value) {
	      return toString(value).toLowerCase();
	    }
	
	    /**
	     * Converts `string`, as a whole, to upper case just like
	     * [String#toUpperCase](https://mdn.io/toUpperCase).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the upper cased string.
	     * @example
	     *
	     * _.toUpper('--foo-bar--');
	     * // => '--FOO-BAR--'
	     *
	     * _.toUpper('fooBar');
	     * // => 'FOOBAR'
	     *
	     * _.toUpper('__foo_bar__');
	     * // => '__FOO_BAR__'
	     */
	    function toUpper(value) {
	      return toString(value).toUpperCase();
	    }
	
	    /**
	     * Removes leading and trailing whitespace or specified characters from `string`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to trim.
	     * @param {string} [chars=whitespace] The characters to trim.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {string} Returns the trimmed string.
	     * @example
	     *
	     * _.trim('  abc  ');
	     * // => 'abc'
	     *
	     * _.trim('-_-abc-_-', '_-');
	     * // => 'abc'
	     *
	     * _.map(['  foo  ', '  bar  '], _.trim);
	     * // => ['foo', 'bar']
	     */
	    function trim(string, chars, guard) {
	      string = toString(string);
	      if (string && (guard || chars === undefined)) {
	        return string.replace(reTrim, '');
	      }
	      if (!string || !(chars = baseToString(chars))) {
	        return string;
	      }
	      var strSymbols = stringToArray(string),
	          chrSymbols = stringToArray(chars),
	          start = charsStartIndex(strSymbols, chrSymbols),
	          end = charsEndIndex(strSymbols, chrSymbols) + 1;
	
	      return castSlice(strSymbols, start, end).join('');
	    }
	
	    /**
	     * Removes trailing whitespace or specified characters from `string`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to trim.
	     * @param {string} [chars=whitespace] The characters to trim.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {string} Returns the trimmed string.
	     * @example
	     *
	     * _.trimEnd('  abc  ');
	     * // => '  abc'
	     *
	     * _.trimEnd('-_-abc-_-', '_-');
	     * // => '-_-abc'
	     */
	    function trimEnd(string, chars, guard) {
	      string = toString(string);
	      if (string && (guard || chars === undefined)) {
	        return string.replace(reTrimEnd, '');
	      }
	      if (!string || !(chars = baseToString(chars))) {
	        return string;
	      }
	      var strSymbols = stringToArray(string),
	          end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;
	
	      return castSlice(strSymbols, 0, end).join('');
	    }
	
	    /**
	     * Removes leading whitespace or specified characters from `string`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to trim.
	     * @param {string} [chars=whitespace] The characters to trim.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {string} Returns the trimmed string.
	     * @example
	     *
	     * _.trimStart('  abc  ');
	     * // => 'abc  '
	     *
	     * _.trimStart('-_-abc-_-', '_-');
	     * // => 'abc-_-'
	     */
	    function trimStart(string, chars, guard) {
	      string = toString(string);
	      if (string && (guard || chars === undefined)) {
	        return string.replace(reTrimStart, '');
	      }
	      if (!string || !(chars = baseToString(chars))) {
	        return string;
	      }
	      var strSymbols = stringToArray(string),
	          start = charsStartIndex(strSymbols, stringToArray(chars));
	
	      return castSlice(strSymbols, start).join('');
	    }
	
	    /**
	     * Truncates `string` if it's longer than the given maximum string length.
	     * The last characters of the truncated string are replaced with the omission
	     * string which defaults to "...".
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to truncate.
	     * @param {Object} [options={}] The options object.
	     * @param {number} [options.length=30] The maximum string length.
	     * @param {string} [options.omission='...'] The string to indicate text is omitted.
	     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
	     * @returns {string} Returns the truncated string.
	     * @example
	     *
	     * _.truncate('hi-diddly-ho there, neighborino');
	     * // => 'hi-diddly-ho there, neighbo...'
	     *
	     * _.truncate('hi-diddly-ho there, neighborino', {
	     *   'length': 24,
	     *   'separator': ' '
	     * });
	     * // => 'hi-diddly-ho there,...'
	     *
	     * _.truncate('hi-diddly-ho there, neighborino', {
	     *   'length': 24,
	     *   'separator': /,? +/
	     * });
	     * // => 'hi-diddly-ho there...'
	     *
	     * _.truncate('hi-diddly-ho there, neighborino', {
	     *   'omission': ' [...]'
	     * });
	     * // => 'hi-diddly-ho there, neig [...]'
	     */
	    function truncate(string, options) {
	      var length = DEFAULT_TRUNC_LENGTH,
	          omission = DEFAULT_TRUNC_OMISSION;
	
	      if (isObject(options)) {
	        var separator = 'separator' in options ? options.separator : separator;
	        length = 'length' in options ? toInteger(options.length) : length;
	        omission = 'omission' in options ? baseToString(options.omission) : omission;
	      }
	      string = toString(string);
	
	      var strLength = string.length;
	      if (hasUnicode(string)) {
	        var strSymbols = stringToArray(string);
	        strLength = strSymbols.length;
	      }
	      if (length >= strLength) {
	        return string;
	      }
	      var end = length - stringSize(omission);
	      if (end < 1) {
	        return omission;
	      }
	      var result = strSymbols
	        ? castSlice(strSymbols, 0, end).join('')
	        : string.slice(0, end);
	
	      if (separator === undefined) {
	        return result + omission;
	      }
	      if (strSymbols) {
	        end += (result.length - end);
	      }
	      if (isRegExp(separator)) {
	        if (string.slice(end).search(separator)) {
	          var match,
	              substring = result;
	
	          if (!separator.global) {
	            separator = RegExp(separator.source, toString(reFlags.exec(separator)) + 'g');
	          }
	          separator.lastIndex = 0;
	          while ((match = separator.exec(substring))) {
	            var newEnd = match.index;
	          }
	          result = result.slice(0, newEnd === undefined ? end : newEnd);
	        }
	      } else if (string.indexOf(baseToString(separator), end) != end) {
	        var index = result.lastIndexOf(separator);
	        if (index > -1) {
	          result = result.slice(0, index);
	        }
	      }
	      return result + omission;
	    }
	
	    /**
	     * The inverse of `_.escape`; this method converts the HTML entities
	     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
	     * their corresponding characters.
	     *
	     * **Note:** No other HTML entities are unescaped. To unescape additional
	     * HTML entities use a third-party library like [_he_](https://mths.be/he).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.6.0
	     * @category String
	     * @param {string} [string=''] The string to unescape.
	     * @returns {string} Returns the unescaped string.
	     * @example
	     *
	     * _.unescape('fred, barney, &amp; pebbles');
	     * // => 'fred, barney, & pebbles'
	     */
	    function unescape(string) {
	      string = toString(string);
	      return (string && reHasEscapedHtml.test(string))
	        ? string.replace(reEscapedHtml, unescapeHtmlChar)
	        : string;
	    }
	
	    /**
	     * Converts `string`, as space separated words, to upper case.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the upper cased string.
	     * @example
	     *
	     * _.upperCase('--foo-bar');
	     * // => 'FOO BAR'
	     *
	     * _.upperCase('fooBar');
	     * // => 'FOO BAR'
	     *
	     * _.upperCase('__foo_bar__');
	     * // => 'FOO BAR'
	     */
	    var upperCase = createCompounder(function(result, word, index) {
	      return result + (index ? ' ' : '') + word.toUpperCase();
	    });
	
	    /**
	     * Converts the first character of `string` to upper case.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the converted string.
	     * @example
	     *
	     * _.upperFirst('fred');
	     * // => 'Fred'
	     *
	     * _.upperFirst('FRED');
	     * // => 'FRED'
	     */
	    var upperFirst = createCaseFirst('toUpperCase');
	
	    /**
	     * Splits `string` into an array of its words.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to inspect.
	     * @param {RegExp|string} [pattern] The pattern to match words.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the words of `string`.
	     * @example
	     *
	     * _.words('fred, barney, & pebbles');
	     * // => ['fred', 'barney', 'pebbles']
	     *
	     * _.words('fred, barney, & pebbles', /[^, ]+/g);
	     * // => ['fred', 'barney', '&', 'pebbles']
	     */
	    function words(string, pattern, guard) {
	      string = toString(string);
	      pattern = guard ? undefined : pattern;
	
	      if (pattern === undefined) {
	        return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
	      }
	      return string.match(pattern) || [];
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Attempts to invoke `func`, returning either the result or the caught error
	     * object. Any additional arguments are provided to `func` when it's invoked.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Util
	     * @param {Function} func The function to attempt.
	     * @param {...*} [args] The arguments to invoke `func` with.
	     * @returns {*} Returns the `func` result or error object.
	     * @example
	     *
	     * // Avoid throwing errors for invalid selectors.
	     * var elements = _.attempt(function(selector) {
	     *   return document.querySelectorAll(selector);
	     * }, '>_>');
	     *
	     * if (_.isError(elements)) {
	     *   elements = [];
	     * }
	     */
	    var attempt = baseRest(function(func, args) {
	      try {
	        return apply(func, undefined, args);
	      } catch (e) {
	        return isError(e) ? e : new Error(e);
	      }
	    });
	
	    /**
	     * Binds methods of an object to the object itself, overwriting the existing
	     * method.
	     *
	     * **Note:** This method doesn't set the "length" property of bound functions.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {Object} object The object to bind and assign the bound methods to.
	     * @param {...(string|string[])} methodNames The object method names to bind.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var view = {
	     *   'label': 'docs',
	     *   'click': function() {
	     *     console.log('clicked ' + this.label);
	     *   }
	     * };
	     *
	     * _.bindAll(view, ['click']);
	     * jQuery(element).on('click', view.click);
	     * // => Logs 'clicked docs' when clicked.
	     */
	    var bindAll = flatRest(function(object, methodNames) {
	      arrayEach(methodNames, function(key) {
	        key = toKey(key);
	        baseAssignValue(object, key, bind(object[key], object));
	      });
	      return object;
	    });
	
	    /**
	     * Creates a function that iterates over `pairs` and invokes the corresponding
	     * function of the first predicate to return truthy. The predicate-function
	     * pairs are invoked with the `this` binding and arguments of the created
	     * function.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {Array} pairs The predicate-function pairs.
	     * @returns {Function} Returns the new composite function.
	     * @example
	     *
	     * var func = _.cond([
	     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
	     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
	     *   [_.stubTrue,                      _.constant('no match')]
	     * ]);
	     *
	     * func({ 'a': 1, 'b': 2 });
	     * // => 'matches A'
	     *
	     * func({ 'a': 0, 'b': 1 });
	     * // => 'matches B'
	     *
	     * func({ 'a': '1', 'b': '2' });
	     * // => 'no match'
	     */
	    function cond(pairs) {
	      var length = pairs == null ? 0 : pairs.length,
	          toIteratee = getIteratee();
	
	      pairs = !length ? [] : arrayMap(pairs, function(pair) {
	        if (typeof pair[1] != 'function') {
	          throw new TypeError(FUNC_ERROR_TEXT);
	        }
	        return [toIteratee(pair[0]), pair[1]];
	      });
	
	      return baseRest(function(args) {
	        var index = -1;
	        while (++index < length) {
	          var pair = pairs[index];
	          if (apply(pair[0], this, args)) {
	            return apply(pair[1], this, args);
	          }
	        }
	      });
	    }
	
	    /**
	     * Creates a function that invokes the predicate properties of `source` with
	     * the corresponding property values of a given object, returning `true` if
	     * all predicates return truthy, else `false`.
	     *
	     * **Note:** The created function is equivalent to `_.conformsTo` with
	     * `source` partially applied.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {Object} source The object of property predicates to conform to.
	     * @returns {Function} Returns the new spec function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': 2, 'b': 1 },
	     *   { 'a': 1, 'b': 2 }
	     * ];
	     *
	     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
	     * // => [{ 'a': 1, 'b': 2 }]
	     */
	    function conforms(source) {
	      return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
	    }
	
	    /**
	     * Creates a function that returns `value`.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Util
	     * @param {*} value The value to return from the new function.
	     * @returns {Function} Returns the new constant function.
	     * @example
	     *
	     * var objects = _.times(2, _.constant({ 'a': 1 }));
	     *
	     * console.log(objects);
	     * // => [{ 'a': 1 }, { 'a': 1 }]
	     *
	     * console.log(objects[0] === objects[1]);
	     * // => true
	     */
	    function constant(value) {
	      return function() {
	        return value;
	      };
	    }
	
	    /**
	     * Checks `value` to determine whether a default value should be returned in
	     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
	     * or `undefined`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.14.0
	     * @category Util
	     * @param {*} value The value to check.
	     * @param {*} defaultValue The default value.
	     * @returns {*} Returns the resolved value.
	     * @example
	     *
	     * _.defaultTo(1, 10);
	     * // => 1
	     *
	     * _.defaultTo(undefined, 10);
	     * // => 10
	     */
	    function defaultTo(value, defaultValue) {
	      return (value == null || value !== value) ? defaultValue : value;
	    }
	
	    /**
	     * Creates a function that returns the result of invoking the given functions
	     * with the `this` binding of the created function, where each successive
	     * invocation is supplied the return value of the previous.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Util
	     * @param {...(Function|Function[])} [funcs] The functions to invoke.
	     * @returns {Function} Returns the new composite function.
	     * @see _.flowRight
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var addSquare = _.flow([_.add, square]);
	     * addSquare(1, 2);
	     * // => 9
	     */
	    var flow = createFlow();
	
	    /**
	     * This method is like `_.flow` except that it creates a function that
	     * invokes the given functions from right to left.
	     *
	     * @static
	     * @since 3.0.0
	     * @memberOf _
	     * @category Util
	     * @param {...(Function|Function[])} [funcs] The functions to invoke.
	     * @returns {Function} Returns the new composite function.
	     * @see _.flow
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var addSquare = _.flowRight([square, _.add]);
	     * addSquare(1, 2);
	     * // => 9
	     */
	    var flowRight = createFlow(true);
	
	    /**
	     * This method returns the first argument it receives.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {*} value Any value.
	     * @returns {*} Returns `value`.
	     * @example
	     *
	     * var object = { 'a': 1 };
	     *
	     * console.log(_.identity(object) === object);
	     * // => true
	     */
	    function identity(value) {
	      return value;
	    }
	
	    /**
	     * Creates a function that invokes `func` with the arguments of the created
	     * function. If `func` is a property name, the created function returns the
	     * property value for a given element. If `func` is an array or object, the
	     * created function returns `true` for elements that contain the equivalent
	     * source properties, otherwise it returns `false`.
	     *
	     * @static
	     * @since 4.0.0
	     * @memberOf _
	     * @category Util
	     * @param {*} [func=_.identity] The value to convert to a callback.
	     * @returns {Function} Returns the callback.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': true },
	     *   { 'user': 'fred',   'age': 40, 'active': false }
	     * ];
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
	     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.filter(users, _.iteratee(['user', 'fred']));
	     * // => [{ 'user': 'fred', 'age': 40 }]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.map(users, _.iteratee('user'));
	     * // => ['barney', 'fred']
	     *
	     * // Create custom iteratee shorthands.
	     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
	     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
	     *     return func.test(string);
	     *   };
	     * });
	     *
	     * _.filter(['abc', 'def'], /ef/);
	     * // => ['def']
	     */
	    function iteratee(func) {
	      return baseIteratee(typeof func == 'function' ? func : baseClone(func, CLONE_DEEP_FLAG));
	    }
	
	    /**
	     * Creates a function that performs a partial deep comparison between a given
	     * object and `source`, returning `true` if the given object has equivalent
	     * property values, else `false`.
	     *
	     * **Note:** The created function is equivalent to `_.isMatch` with `source`
	     * partially applied.
	     *
	     * Partial comparisons will match empty array and empty object `source`
	     * values against any array or object value, respectively. See `_.isEqual`
	     * for a list of supported value comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Util
	     * @param {Object} source The object of property values to match.
	     * @returns {Function} Returns the new spec function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': 1, 'b': 2, 'c': 3 },
	     *   { 'a': 4, 'b': 5, 'c': 6 }
	     * ];
	     *
	     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
	     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
	     */
	    function matches(source) {
	      return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
	    }
	
	    /**
	     * Creates a function that performs a partial deep comparison between the
	     * value at `path` of a given object to `srcValue`, returning `true` if the
	     * object value is equivalent, else `false`.
	     *
	     * **Note:** Partial comparisons will match empty array and empty object
	     * `srcValue` values against any array or object value, respectively. See
	     * `_.isEqual` for a list of supported value comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.2.0
	     * @category Util
	     * @param {Array|string} path The path of the property to get.
	     * @param {*} srcValue The value to match.
	     * @returns {Function} Returns the new spec function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': 1, 'b': 2, 'c': 3 },
	     *   { 'a': 4, 'b': 5, 'c': 6 }
	     * ];
	     *
	     * _.find(objects, _.matchesProperty('a', 4));
	     * // => { 'a': 4, 'b': 5, 'c': 6 }
	     */
	    function matchesProperty(path, srcValue) {
	      return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
	    }
	
	    /**
	     * Creates a function that invokes the method at `path` of a given object.
	     * Any additional arguments are provided to the invoked method.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.7.0
	     * @category Util
	     * @param {Array|string} path The path of the method to invoke.
	     * @param {...*} [args] The arguments to invoke the method with.
	     * @returns {Function} Returns the new invoker function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': { 'b': _.constant(2) } },
	     *   { 'a': { 'b': _.constant(1) } }
	     * ];
	     *
	     * _.map(objects, _.method('a.b'));
	     * // => [2, 1]
	     *
	     * _.map(objects, _.method(['a', 'b']));
	     * // => [2, 1]
	     */
	    var method = baseRest(function(path, args) {
	      return function(object) {
	        return baseInvoke(object, path, args);
	      };
	    });
	
	    /**
	     * The opposite of `_.method`; this method creates a function that invokes
	     * the method at a given path of `object`. Any additional arguments are
	     * provided to the invoked method.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.7.0
	     * @category Util
	     * @param {Object} object The object to query.
	     * @param {...*} [args] The arguments to invoke the method with.
	     * @returns {Function} Returns the new invoker function.
	     * @example
	     *
	     * var array = _.times(3, _.constant),
	     *     object = { 'a': array, 'b': array, 'c': array };
	     *
	     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
	     * // => [2, 0]
	     *
	     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
	     * // => [2, 0]
	     */
	    var methodOf = baseRest(function(object, args) {
	      return function(path) {
	        return baseInvoke(object, path, args);
	      };
	    });
	
	    /**
	     * Adds all own enumerable string keyed function properties of a source
	     * object to the destination object. If `object` is a function, then methods
	     * are added to its prototype as well.
	     *
	     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
	     * avoid conflicts caused by modifying the original.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {Function|Object} [object=lodash] The destination object.
	     * @param {Object} source The object of functions to add.
	     * @param {Object} [options={}] The options object.
	     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
	     * @returns {Function|Object} Returns `object`.
	     * @example
	     *
	     * function vowels(string) {
	     *   return _.filter(string, function(v) {
	     *     return /[aeiou]/i.test(v);
	     *   });
	     * }
	     *
	     * _.mixin({ 'vowels': vowels });
	     * _.vowels('fred');
	     * // => ['e']
	     *
	     * _('fred').vowels().value();
	     * // => ['e']
	     *
	     * _.mixin({ 'vowels': vowels }, { 'chain': false });
	     * _('fred').vowels();
	     * // => ['e']
	     */
	    function mixin(object, source, options) {
	      var props = keys(source),
	          methodNames = baseFunctions(source, props);
	
	      if (options == null &&
	          !(isObject(source) && (methodNames.length || !props.length))) {
	        options = source;
	        source = object;
	        object = this;
	        methodNames = baseFunctions(source, keys(source));
	      }
	      var chain = !(isObject(options) && 'chain' in options) || !!options.chain,
	          isFunc = isFunction(object);
	
	      arrayEach(methodNames, function(methodName) {
	        var func = source[methodName];
	        object[methodName] = func;
	        if (isFunc) {
	          object.prototype[methodName] = function() {
	            var chainAll = this.__chain__;
	            if (chain || chainAll) {
	              var result = object(this.__wrapped__),
	                  actions = result.__actions__ = copyArray(this.__actions__);
	
	              actions.push({ 'func': func, 'args': arguments, 'thisArg': object });
	              result.__chain__ = chainAll;
	              return result;
	            }
	            return func.apply(object, arrayPush([this.value()], arguments));
	          };
	        }
	      });
	
	      return object;
	    }
	
	    /**
	     * Reverts the `_` variable to its previous value and returns a reference to
	     * the `lodash` function.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @returns {Function} Returns the `lodash` function.
	     * @example
	     *
	     * var lodash = _.noConflict();
	     */
	    function noConflict() {
	      if (root._ === this) {
	        root._ = oldDash;
	      }
	      return this;
	    }
	
	    /**
	     * This method returns `undefined`.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.3.0
	     * @category Util
	     * @example
	     *
	     * _.times(2, _.noop);
	     * // => [undefined, undefined]
	     */
	    function noop() {
	      // No operation performed.
	    }
	
	    /**
	     * Creates a function that gets the argument at index `n`. If `n` is negative,
	     * the nth argument from the end is returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {number} [n=0] The index of the argument to return.
	     * @returns {Function} Returns the new pass-thru function.
	     * @example
	     *
	     * var func = _.nthArg(1);
	     * func('a', 'b', 'c', 'd');
	     * // => 'b'
	     *
	     * var func = _.nthArg(-2);
	     * func('a', 'b', 'c', 'd');
	     * // => 'c'
	     */
	    function nthArg(n) {
	      n = toInteger(n);
	      return baseRest(function(args) {
	        return baseNth(args, n);
	      });
	    }
	
	    /**
	     * Creates a function that invokes `iteratees` with the arguments it receives
	     * and returns their results.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {...(Function|Function[])} [iteratees=[_.identity]]
	     *  The iteratees to invoke.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var func = _.over([Math.max, Math.min]);
	     *
	     * func(1, 2, 3, 4);
	     * // => [4, 1]
	     */
	    var over = createOver(arrayMap);
	
	    /**
	     * Creates a function that checks if **all** of the `predicates` return
	     * truthy when invoked with the arguments it receives.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {...(Function|Function[])} [predicates=[_.identity]]
	     *  The predicates to check.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var func = _.overEvery([Boolean, isFinite]);
	     *
	     * func('1');
	     * // => true
	     *
	     * func(null);
	     * // => false
	     *
	     * func(NaN);
	     * // => false
	     */
	    var overEvery = createOver(arrayEvery);
	
	    /**
	     * Creates a function that checks if **any** of the `predicates` return
	     * truthy when invoked with the arguments it receives.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {...(Function|Function[])} [predicates=[_.identity]]
	     *  The predicates to check.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var func = _.overSome([Boolean, isFinite]);
	     *
	     * func('1');
	     * // => true
	     *
	     * func(null);
	     * // => true
	     *
	     * func(NaN);
	     * // => false
	     */
	    var overSome = createOver(arraySome);
	
	    /**
	     * Creates a function that returns the value at `path` of a given object.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Util
	     * @param {Array|string} path The path of the property to get.
	     * @returns {Function} Returns the new accessor function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': { 'b': 2 } },
	     *   { 'a': { 'b': 1 } }
	     * ];
	     *
	     * _.map(objects, _.property('a.b'));
	     * // => [2, 1]
	     *
	     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
	     * // => [1, 2]
	     */
	    function property(path) {
	      return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
	    }
	
	    /**
	     * The opposite of `_.property`; this method creates a function that returns
	     * the value at a given path of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Util
	     * @param {Object} object The object to query.
	     * @returns {Function} Returns the new accessor function.
	     * @example
	     *
	     * var array = [0, 1, 2],
	     *     object = { 'a': array, 'b': array, 'c': array };
	     *
	     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
	     * // => [2, 0]
	     *
	     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
	     * // => [2, 0]
	     */
	    function propertyOf(object) {
	      return function(path) {
	        return object == null ? undefined : baseGet(object, path);
	      };
	    }
	
	    /**
	     * Creates an array of numbers (positive and/or negative) progressing from
	     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
	     * `start` is specified without an `end` or `step`. If `end` is not specified,
	     * it's set to `start` with `start` then set to `0`.
	     *
	     * **Note:** JavaScript follows the IEEE-754 standard for resolving
	     * floating-point values which can produce unexpected results.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {number} [start=0] The start of the range.
	     * @param {number} end The end of the range.
	     * @param {number} [step=1] The value to increment or decrement by.
	     * @returns {Array} Returns the range of numbers.
	     * @see _.inRange, _.rangeRight
	     * @example
	     *
	     * _.range(4);
	     * // => [0, 1, 2, 3]
	     *
	     * _.range(-4);
	     * // => [0, -1, -2, -3]
	     *
	     * _.range(1, 5);
	     * // => [1, 2, 3, 4]
	     *
	     * _.range(0, 20, 5);
	     * // => [0, 5, 10, 15]
	     *
	     * _.range(0, -4, -1);
	     * // => [0, -1, -2, -3]
	     *
	     * _.range(1, 4, 0);
	     * // => [1, 1, 1]
	     *
	     * _.range(0);
	     * // => []
	     */
	    var range = createRange();
	
	    /**
	     * This method is like `_.range` except that it populates values in
	     * descending order.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {number} [start=0] The start of the range.
	     * @param {number} end The end of the range.
	     * @param {number} [step=1] The value to increment or decrement by.
	     * @returns {Array} Returns the range of numbers.
	     * @see _.inRange, _.range
	     * @example
	     *
	     * _.rangeRight(4);
	     * // => [3, 2, 1, 0]
	     *
	     * _.rangeRight(-4);
	     * // => [-3, -2, -1, 0]
	     *
	     * _.rangeRight(1, 5);
	     * // => [4, 3, 2, 1]
	     *
	     * _.rangeRight(0, 20, 5);
	     * // => [15, 10, 5, 0]
	     *
	     * _.rangeRight(0, -4, -1);
	     * // => [-3, -2, -1, 0]
	     *
	     * _.rangeRight(1, 4, 0);
	     * // => [1, 1, 1]
	     *
	     * _.rangeRight(0);
	     * // => []
	     */
	    var rangeRight = createRange(true);
	
	    /**
	     * This method returns a new empty array.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {Array} Returns the new empty array.
	     * @example
	     *
	     * var arrays = _.times(2, _.stubArray);
	     *
	     * console.log(arrays);
	     * // => [[], []]
	     *
	     * console.log(arrays[0] === arrays[1]);
	     * // => false
	     */
	    function stubArray() {
	      return [];
	    }
	
	    /**
	     * This method returns `false`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {boolean} Returns `false`.
	     * @example
	     *
	     * _.times(2, _.stubFalse);
	     * // => [false, false]
	     */
	    function stubFalse() {
	      return false;
	    }
	
	    /**
	     * This method returns a new empty object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {Object} Returns the new empty object.
	     * @example
	     *
	     * var objects = _.times(2, _.stubObject);
	     *
	     * console.log(objects);
	     * // => [{}, {}]
	     *
	     * console.log(objects[0] === objects[1]);
	     * // => false
	     */
	    function stubObject() {
	      return {};
	    }
	
	    /**
	     * This method returns an empty string.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {string} Returns the empty string.
	     * @example
	     *
	     * _.times(2, _.stubString);
	     * // => ['', '']
	     */
	    function stubString() {
	      return '';
	    }
	
	    /**
	     * This method returns `true`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {boolean} Returns `true`.
	     * @example
	     *
	     * _.times(2, _.stubTrue);
	     * // => [true, true]
	     */
	    function stubTrue() {
	      return true;
	    }
	
	    /**
	     * Invokes the iteratee `n` times, returning an array of the results of
	     * each invocation. The iteratee is invoked with one argument; (index).
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {number} n The number of times to invoke `iteratee`.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the array of results.
	     * @example
	     *
	     * _.times(3, String);
	     * // => ['0', '1', '2']
	     *
	     *  _.times(4, _.constant(0));
	     * // => [0, 0, 0, 0]
	     */
	    function times(n, iteratee) {
	      n = toInteger(n);
	      if (n < 1 || n > MAX_SAFE_INTEGER) {
	        return [];
	      }
	      var index = MAX_ARRAY_LENGTH,
	          length = nativeMin(n, MAX_ARRAY_LENGTH);
	
	      iteratee = getIteratee(iteratee);
	      n -= MAX_ARRAY_LENGTH;
	
	      var result = baseTimes(length, iteratee);
	      while (++index < n) {
	        iteratee(index);
	      }
	      return result;
	    }
	
	    /**
	     * Converts `value` to a property path array.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {*} value The value to convert.
	     * @returns {Array} Returns the new property path array.
	     * @example
	     *
	     * _.toPath('a.b.c');
	     * // => ['a', 'b', 'c']
	     *
	     * _.toPath('a[0].b.c');
	     * // => ['a', '0', 'b', 'c']
	     */
	    function toPath(value) {
	      if (isArray(value)) {
	        return arrayMap(value, toKey);
	      }
	      return isSymbol(value) ? [value] : copyArray(stringToPath(toString(value)));
	    }
	
	    /**
	     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {string} [prefix=''] The value to prefix the ID with.
	     * @returns {string} Returns the unique ID.
	     * @example
	     *
	     * _.uniqueId('contact_');
	     * // => 'contact_104'
	     *
	     * _.uniqueId();
	     * // => '105'
	     */
	    function uniqueId(prefix) {
	      var id = ++idCounter;
	      return toString(prefix) + id;
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Adds two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.4.0
	     * @category Math
	     * @param {number} augend The first number in an addition.
	     * @param {number} addend The second number in an addition.
	     * @returns {number} Returns the total.
	     * @example
	     *
	     * _.add(6, 4);
	     * // => 10
	     */
	    var add = createMathOperation(function(augend, addend) {
	      return augend + addend;
	    }, 0);
	
	    /**
	     * Computes `number` rounded up to `precision`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.10.0
	     * @category Math
	     * @param {number} number The number to round up.
	     * @param {number} [precision=0] The precision to round up to.
	     * @returns {number} Returns the rounded up number.
	     * @example
	     *
	     * _.ceil(4.006);
	     * // => 5
	     *
	     * _.ceil(6.004, 2);
	     * // => 6.01
	     *
	     * _.ceil(6040, -2);
	     * // => 6100
	     */
	    var ceil = createRound('ceil');
	
	    /**
	     * Divide two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Math
	     * @param {number} dividend The first number in a division.
	     * @param {number} divisor The second number in a division.
	     * @returns {number} Returns the quotient.
	     * @example
	     *
	     * _.divide(6, 4);
	     * // => 1.5
	     */
	    var divide = createMathOperation(function(dividend, divisor) {
	      return dividend / divisor;
	    }, 1);
	
	    /**
	     * Computes `number` rounded down to `precision`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.10.0
	     * @category Math
	     * @param {number} number The number to round down.
	     * @param {number} [precision=0] The precision to round down to.
	     * @returns {number} Returns the rounded down number.
	     * @example
	     *
	     * _.floor(4.006);
	     * // => 4
	     *
	     * _.floor(0.046, 2);
	     * // => 0.04
	     *
	     * _.floor(4060, -2);
	     * // => 4000
	     */
	    var floor = createRound('floor');
	
	    /**
	     * Computes the maximum value of `array`. If `array` is empty or falsey,
	     * `undefined` is returned.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {*} Returns the maximum value.
	     * @example
	     *
	     * _.max([4, 2, 8, 6]);
	     * // => 8
	     *
	     * _.max([]);
	     * // => undefined
	     */
	    function max(array) {
	      return (array && array.length)
	        ? baseExtremum(array, identity, baseGt)
	        : undefined;
	    }
	
	    /**
	     * This method is like `_.max` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the criterion by which
	     * the value is ranked. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {*} Returns the maximum value.
	     * @example
	     *
	     * var objects = [{ 'n': 1 }, { 'n': 2 }];
	     *
	     * _.maxBy(objects, function(o) { return o.n; });
	     * // => { 'n': 2 }
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.maxBy(objects, 'n');
	     * // => { 'n': 2 }
	     */
	    function maxBy(array, iteratee) {
	      return (array && array.length)
	        ? baseExtremum(array, getIteratee(iteratee, 2), baseGt)
	        : undefined;
	    }
	
	    /**
	     * Computes the mean of the values in `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {number} Returns the mean.
	     * @example
	     *
	     * _.mean([4, 2, 8, 6]);
	     * // => 5
	     */
	    function mean(array) {
	      return baseMean(array, identity);
	    }
	
	    /**
	     * This method is like `_.mean` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the value to be averaged.
	     * The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {number} Returns the mean.
	     * @example
	     *
	     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
	     *
	     * _.meanBy(objects, function(o) { return o.n; });
	     * // => 5
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.meanBy(objects, 'n');
	     * // => 5
	     */
	    function meanBy(array, iteratee) {
	      return baseMean(array, getIteratee(iteratee, 2));
	    }
	
	    /**
	     * Computes the minimum value of `array`. If `array` is empty or falsey,
	     * `undefined` is returned.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {*} Returns the minimum value.
	     * @example
	     *
	     * _.min([4, 2, 8, 6]);
	     * // => 2
	     *
	     * _.min([]);
	     * // => undefined
	     */
	    function min(array) {
	      return (array && array.length)
	        ? baseExtremum(array, identity, baseLt)
	        : undefined;
	    }
	
	    /**
	     * This method is like `_.min` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the criterion by which
	     * the value is ranked. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {*} Returns the minimum value.
	     * @example
	     *
	     * var objects = [{ 'n': 1 }, { 'n': 2 }];
	     *
	     * _.minBy(objects, function(o) { return o.n; });
	     * // => { 'n': 1 }
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.minBy(objects, 'n');
	     * // => { 'n': 1 }
	     */
	    function minBy(array, iteratee) {
	      return (array && array.length)
	        ? baseExtremum(array, getIteratee(iteratee, 2), baseLt)
	        : undefined;
	    }
	
	    /**
	     * Multiply two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Math
	     * @param {number} multiplier The first number in a multiplication.
	     * @param {number} multiplicand The second number in a multiplication.
	     * @returns {number} Returns the product.
	     * @example
	     *
	     * _.multiply(6, 4);
	     * // => 24
	     */
	    var multiply = createMathOperation(function(multiplier, multiplicand) {
	      return multiplier * multiplicand;
	    }, 1);
	
	    /**
	     * Computes `number` rounded to `precision`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.10.0
	     * @category Math
	     * @param {number} number The number to round.
	     * @param {number} [precision=0] The precision to round to.
	     * @returns {number} Returns the rounded number.
	     * @example
	     *
	     * _.round(4.006);
	     * // => 4
	     *
	     * _.round(4.006, 2);
	     * // => 4.01
	     *
	     * _.round(4060, -2);
	     * // => 4100
	     */
	    var round = createRound('round');
	
	    /**
	     * Subtract two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {number} minuend The first number in a subtraction.
	     * @param {number} subtrahend The second number in a subtraction.
	     * @returns {number} Returns the difference.
	     * @example
	     *
	     * _.subtract(6, 4);
	     * // => 2
	     */
	    var subtract = createMathOperation(function(minuend, subtrahend) {
	      return minuend - subtrahend;
	    }, 0);
	
	    /**
	     * Computes the sum of the values in `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.4.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {number} Returns the sum.
	     * @example
	     *
	     * _.sum([4, 2, 8, 6]);
	     * // => 20
	     */
	    function sum(array) {
	      return (array && array.length)
	        ? baseSum(array, identity)
	        : 0;
	    }
	
	    /**
	     * This method is like `_.sum` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the value to be summed.
	     * The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {number} Returns the sum.
	     * @example
	     *
	     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
	     *
	     * _.sumBy(objects, function(o) { return o.n; });
	     * // => 20
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.sumBy(objects, 'n');
	     * // => 20
	     */
	    function sumBy(array, iteratee) {
	      return (array && array.length)
	        ? baseSum(array, getIteratee(iteratee, 2))
	        : 0;
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    // Add methods that return wrapped values in chain sequences.
	    lodash.after = after;
	    lodash.ary = ary;
	    lodash.assign = assign;
	    lodash.assignIn = assignIn;
	    lodash.assignInWith = assignInWith;
	    lodash.assignWith = assignWith;
	    lodash.at = at;
	    lodash.before = before;
	    lodash.bind = bind;
	    lodash.bindAll = bindAll;
	    lodash.bindKey = bindKey;
	    lodash.castArray = castArray;
	    lodash.chain = chain;
	    lodash.chunk = chunk;
	    lodash.compact = compact;
	    lodash.concat = concat;
	    lodash.cond = cond;
	    lodash.conforms = conforms;
	    lodash.constant = constant;
	    lodash.countBy = countBy;
	    lodash.create = create;
	    lodash.curry = curry;
	    lodash.curryRight = curryRight;
	    lodash.debounce = debounce;
	    lodash.defaults = defaults;
	    lodash.defaultsDeep = defaultsDeep;
	    lodash.defer = defer;
	    lodash.delay = delay;
	    lodash.difference = difference;
	    lodash.differenceBy = differenceBy;
	    lodash.differenceWith = differenceWith;
	    lodash.drop = drop;
	    lodash.dropRight = dropRight;
	    lodash.dropRightWhile = dropRightWhile;
	    lodash.dropWhile = dropWhile;
	    lodash.fill = fill;
	    lodash.filter = filter;
	    lodash.flatMap = flatMap;
	    lodash.flatMapDeep = flatMapDeep;
	    lodash.flatMapDepth = flatMapDepth;
	    lodash.flatten = flatten;
	    lodash.flattenDeep = flattenDeep;
	    lodash.flattenDepth = flattenDepth;
	    lodash.flip = flip;
	    lodash.flow = flow;
	    lodash.flowRight = flowRight;
	    lodash.fromPairs = fromPairs;
	    lodash.functions = functions;
	    lodash.functionsIn = functionsIn;
	    lodash.groupBy = groupBy;
	    lodash.initial = initial;
	    lodash.intersection = intersection;
	    lodash.intersectionBy = intersectionBy;
	    lodash.intersectionWith = intersectionWith;
	    lodash.invert = invert;
	    lodash.invertBy = invertBy;
	    lodash.invokeMap = invokeMap;
	    lodash.iteratee = iteratee;
	    lodash.keyBy = keyBy;
	    lodash.keys = keys;
	    lodash.keysIn = keysIn;
	    lodash.map = map;
	    lodash.mapKeys = mapKeys;
	    lodash.mapValues = mapValues;
	    lodash.matches = matches;
	    lodash.matchesProperty = matchesProperty;
	    lodash.memoize = memoize;
	    lodash.merge = merge;
	    lodash.mergeWith = mergeWith;
	    lodash.method = method;
	    lodash.methodOf = methodOf;
	    lodash.mixin = mixin;
	    lodash.negate = negate;
	    lodash.nthArg = nthArg;
	    lodash.omit = omit;
	    lodash.omitBy = omitBy;
	    lodash.once = once;
	    lodash.orderBy = orderBy;
	    lodash.over = over;
	    lodash.overArgs = overArgs;
	    lodash.overEvery = overEvery;
	    lodash.overSome = overSome;
	    lodash.partial = partial;
	    lodash.partialRight = partialRight;
	    lodash.partition = partition;
	    lodash.pick = pick;
	    lodash.pickBy = pickBy;
	    lodash.property = property;
	    lodash.propertyOf = propertyOf;
	    lodash.pull = pull;
	    lodash.pullAll = pullAll;
	    lodash.pullAllBy = pullAllBy;
	    lodash.pullAllWith = pullAllWith;
	    lodash.pullAt = pullAt;
	    lodash.range = range;
	    lodash.rangeRight = rangeRight;
	    lodash.rearg = rearg;
	    lodash.reject = reject;
	    lodash.remove = remove;
	    lodash.rest = rest;
	    lodash.reverse = reverse;
	    lodash.sampleSize = sampleSize;
	    lodash.set = set;
	    lodash.setWith = setWith;
	    lodash.shuffle = shuffle;
	    lodash.slice = slice;
	    lodash.sortBy = sortBy;
	    lodash.sortedUniq = sortedUniq;
	    lodash.sortedUniqBy = sortedUniqBy;
	    lodash.split = split;
	    lodash.spread = spread;
	    lodash.tail = tail;
	    lodash.take = take;
	    lodash.takeRight = takeRight;
	    lodash.takeRightWhile = takeRightWhile;
	    lodash.takeWhile = takeWhile;
	    lodash.tap = tap;
	    lodash.throttle = throttle;
	    lodash.thru = thru;
	    lodash.toArray = toArray;
	    lodash.toPairs = toPairs;
	    lodash.toPairsIn = toPairsIn;
	    lodash.toPath = toPath;
	    lodash.toPlainObject = toPlainObject;
	    lodash.transform = transform;
	    lodash.unary = unary;
	    lodash.union = union;
	    lodash.unionBy = unionBy;
	    lodash.unionWith = unionWith;
	    lodash.uniq = uniq;
	    lodash.uniqBy = uniqBy;
	    lodash.uniqWith = uniqWith;
	    lodash.unset = unset;
	    lodash.unzip = unzip;
	    lodash.unzipWith = unzipWith;
	    lodash.update = update;
	    lodash.updateWith = updateWith;
	    lodash.values = values;
	    lodash.valuesIn = valuesIn;
	    lodash.without = without;
	    lodash.words = words;
	    lodash.wrap = wrap;
	    lodash.xor = xor;
	    lodash.xorBy = xorBy;
	    lodash.xorWith = xorWith;
	    lodash.zip = zip;
	    lodash.zipObject = zipObject;
	    lodash.zipObjectDeep = zipObjectDeep;
	    lodash.zipWith = zipWith;
	
	    // Add aliases.
	    lodash.entries = toPairs;
	    lodash.entriesIn = toPairsIn;
	    lodash.extend = assignIn;
	    lodash.extendWith = assignInWith;
	
	    // Add methods to `lodash.prototype`.
	    mixin(lodash, lodash);
	
	    /*------------------------------------------------------------------------*/
	
	    // Add methods that return unwrapped values in chain sequences.
	    lodash.add = add;
	    lodash.attempt = attempt;
	    lodash.camelCase = camelCase;
	    lodash.capitalize = capitalize;
	    lodash.ceil = ceil;
	    lodash.clamp = clamp;
	    lodash.clone = clone;
	    lodash.cloneDeep = cloneDeep;
	    lodash.cloneDeepWith = cloneDeepWith;
	    lodash.cloneWith = cloneWith;
	    lodash.conformsTo = conformsTo;
	    lodash.deburr = deburr;
	    lodash.defaultTo = defaultTo;
	    lodash.divide = divide;
	    lodash.endsWith = endsWith;
	    lodash.eq = eq;
	    lodash.escape = escape;
	    lodash.escapeRegExp = escapeRegExp;
	    lodash.every = every;
	    lodash.find = find;
	    lodash.findIndex = findIndex;
	    lodash.findKey = findKey;
	    lodash.findLast = findLast;
	    lodash.findLastIndex = findLastIndex;
	    lodash.findLastKey = findLastKey;
	    lodash.floor = floor;
	    lodash.forEach = forEach;
	    lodash.forEachRight = forEachRight;
	    lodash.forIn = forIn;
	    lodash.forInRight = forInRight;
	    lodash.forOwn = forOwn;
	    lodash.forOwnRight = forOwnRight;
	    lodash.get = get;
	    lodash.gt = gt;
	    lodash.gte = gte;
	    lodash.has = has;
	    lodash.hasIn = hasIn;
	    lodash.head = head;
	    lodash.identity = identity;
	    lodash.includes = includes;
	    lodash.indexOf = indexOf;
	    lodash.inRange = inRange;
	    lodash.invoke = invoke;
	    lodash.isArguments = isArguments;
	    lodash.isArray = isArray;
	    lodash.isArrayBuffer = isArrayBuffer;
	    lodash.isArrayLike = isArrayLike;
	    lodash.isArrayLikeObject = isArrayLikeObject;
	    lodash.isBoolean = isBoolean;
	    lodash.isBuffer = isBuffer;
	    lodash.isDate = isDate;
	    lodash.isElement = isElement;
	    lodash.isEmpty = isEmpty;
	    lodash.isEqual = isEqual;
	    lodash.isEqualWith = isEqualWith;
	    lodash.isError = isError;
	    lodash.isFinite = isFinite;
	    lodash.isFunction = isFunction;
	    lodash.isInteger = isInteger;
	    lodash.isLength = isLength;
	    lodash.isMap = isMap;
	    lodash.isMatch = isMatch;
	    lodash.isMatchWith = isMatchWith;
	    lodash.isNaN = isNaN;
	    lodash.isNative = isNative;
	    lodash.isNil = isNil;
	    lodash.isNull = isNull;
	    lodash.isNumber = isNumber;
	    lodash.isObject = isObject;
	    lodash.isObjectLike = isObjectLike;
	    lodash.isPlainObject = isPlainObject;
	    lodash.isRegExp = isRegExp;
	    lodash.isSafeInteger = isSafeInteger;
	    lodash.isSet = isSet;
	    lodash.isString = isString;
	    lodash.isSymbol = isSymbol;
	    lodash.isTypedArray = isTypedArray;
	    lodash.isUndefined = isUndefined;
	    lodash.isWeakMap = isWeakMap;
	    lodash.isWeakSet = isWeakSet;
	    lodash.join = join;
	    lodash.kebabCase = kebabCase;
	    lodash.last = last;
	    lodash.lastIndexOf = lastIndexOf;
	    lodash.lowerCase = lowerCase;
	    lodash.lowerFirst = lowerFirst;
	    lodash.lt = lt;
	    lodash.lte = lte;
	    lodash.max = max;
	    lodash.maxBy = maxBy;
	    lodash.mean = mean;
	    lodash.meanBy = meanBy;
	    lodash.min = min;
	    lodash.minBy = minBy;
	    lodash.stubArray = stubArray;
	    lodash.stubFalse = stubFalse;
	    lodash.stubObject = stubObject;
	    lodash.stubString = stubString;
	    lodash.stubTrue = stubTrue;
	    lodash.multiply = multiply;
	    lodash.nth = nth;
	    lodash.noConflict = noConflict;
	    lodash.noop = noop;
	    lodash.now = now;
	    lodash.pad = pad;
	    lodash.padEnd = padEnd;
	    lodash.padStart = padStart;
	    lodash.parseInt = parseInt;
	    lodash.random = random;
	    lodash.reduce = reduce;
	    lodash.reduceRight = reduceRight;
	    lodash.repeat = repeat;
	    lodash.replace = replace;
	    lodash.result = result;
	    lodash.round = round;
	    lodash.runInContext = runInContext;
	    lodash.sample = sample;
	    lodash.size = size;
	    lodash.snakeCase = snakeCase;
	    lodash.some = some;
	    lodash.sortedIndex = sortedIndex;
	    lodash.sortedIndexBy = sortedIndexBy;
	    lodash.sortedIndexOf = sortedIndexOf;
	    lodash.sortedLastIndex = sortedLastIndex;
	    lodash.sortedLastIndexBy = sortedLastIndexBy;
	    lodash.sortedLastIndexOf = sortedLastIndexOf;
	    lodash.startCase = startCase;
	    lodash.startsWith = startsWith;
	    lodash.subtract = subtract;
	    lodash.sum = sum;
	    lodash.sumBy = sumBy;
	    lodash.template = template;
	    lodash.times = times;
	    lodash.toFinite = toFinite;
	    lodash.toInteger = toInteger;
	    lodash.toLength = toLength;
	    lodash.toLower = toLower;
	    lodash.toNumber = toNumber;
	    lodash.toSafeInteger = toSafeInteger;
	    lodash.toString = toString;
	    lodash.toUpper = toUpper;
	    lodash.trim = trim;
	    lodash.trimEnd = trimEnd;
	    lodash.trimStart = trimStart;
	    lodash.truncate = truncate;
	    lodash.unescape = unescape;
	    lodash.uniqueId = uniqueId;
	    lodash.upperCase = upperCase;
	    lodash.upperFirst = upperFirst;
	
	    // Add aliases.
	    lodash.each = forEach;
	    lodash.eachRight = forEachRight;
	    lodash.first = head;
	
	    mixin(lodash, (function() {
	      var source = {};
	      baseForOwn(lodash, function(func, methodName) {
	        if (!hasOwnProperty.call(lodash.prototype, methodName)) {
	          source[methodName] = func;
	        }
	      });
	      return source;
	    }()), { 'chain': false });
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * The semantic version number.
	     *
	     * @static
	     * @memberOf _
	     * @type {string}
	     */
	    lodash.VERSION = VERSION;
	
	    // Assign default placeholders.
	    arrayEach(['bind', 'bindKey', 'curry', 'curryRight', 'partial', 'partialRight'], function(methodName) {
	      lodash[methodName].placeholder = lodash;
	    });
	
	    // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
	    arrayEach(['drop', 'take'], function(methodName, index) {
	      LazyWrapper.prototype[methodName] = function(n) {
	        n = n === undefined ? 1 : nativeMax(toInteger(n), 0);
	
	        var result = (this.__filtered__ && !index)
	          ? new LazyWrapper(this)
	          : this.clone();
	
	        if (result.__filtered__) {
	          result.__takeCount__ = nativeMin(n, result.__takeCount__);
	        } else {
	          result.__views__.push({
	            'size': nativeMin(n, MAX_ARRAY_LENGTH),
	            'type': methodName + (result.__dir__ < 0 ? 'Right' : '')
	          });
	        }
	        return result;
	      };
	
	      LazyWrapper.prototype[methodName + 'Right'] = function(n) {
	        return this.reverse()[methodName](n).reverse();
	      };
	    });
	
	    // Add `LazyWrapper` methods that accept an `iteratee` value.
	    arrayEach(['filter', 'map', 'takeWhile'], function(methodName, index) {
	      var type = index + 1,
	          isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;
	
	      LazyWrapper.prototype[methodName] = function(iteratee) {
	        var result = this.clone();
	        result.__iteratees__.push({
	          'iteratee': getIteratee(iteratee, 3),
	          'type': type
	        });
	        result.__filtered__ = result.__filtered__ || isFilter;
	        return result;
	      };
	    });
	
	    // Add `LazyWrapper` methods for `_.head` and `_.last`.
	    arrayEach(['head', 'last'], function(methodName, index) {
	      var takeName = 'take' + (index ? 'Right' : '');
	
	      LazyWrapper.prototype[methodName] = function() {
	        return this[takeName](1).value()[0];
	      };
	    });
	
	    // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
	    arrayEach(['initial', 'tail'], function(methodName, index) {
	      var dropName = 'drop' + (index ? '' : 'Right');
	
	      LazyWrapper.prototype[methodName] = function() {
	        return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
	      };
	    });
	
	    LazyWrapper.prototype.compact = function() {
	      return this.filter(identity);
	    };
	
	    LazyWrapper.prototype.find = function(predicate) {
	      return this.filter(predicate).head();
	    };
	
	    LazyWrapper.prototype.findLast = function(predicate) {
	      return this.reverse().find(predicate);
	    };
	
	    LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
	      if (typeof path == 'function') {
	        return new LazyWrapper(this);
	      }
	      return this.map(function(value) {
	        return baseInvoke(value, path, args);
	      });
	    });
	
	    LazyWrapper.prototype.reject = function(predicate) {
	      return this.filter(negate(getIteratee(predicate)));
	    };
	
	    LazyWrapper.prototype.slice = function(start, end) {
	      start = toInteger(start);
	
	      var result = this;
	      if (result.__filtered__ && (start > 0 || end < 0)) {
	        return new LazyWrapper(result);
	      }
	      if (start < 0) {
	        result = result.takeRight(-start);
	      } else if (start) {
	        result = result.drop(start);
	      }
	      if (end !== undefined) {
	        end = toInteger(end);
	        result = end < 0 ? result.dropRight(-end) : result.take(end - start);
	      }
	      return result;
	    };
	
	    LazyWrapper.prototype.takeRightWhile = function(predicate) {
	      return this.reverse().takeWhile(predicate).reverse();
	    };
	
	    LazyWrapper.prototype.toArray = function() {
	      return this.take(MAX_ARRAY_LENGTH);
	    };
	
	    // Add `LazyWrapper` methods to `lodash.prototype`.
	    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
	      var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName),
	          isTaker = /^(?:head|last)$/.test(methodName),
	          lodashFunc = lodash[isTaker ? ('take' + (methodName == 'last' ? 'Right' : '')) : methodName],
	          retUnwrapped = isTaker || /^find/.test(methodName);
	
	      if (!lodashFunc) {
	        return;
	      }
	      lodash.prototype[methodName] = function() {
	        var value = this.__wrapped__,
	            args = isTaker ? [1] : arguments,
	            isLazy = value instanceof LazyWrapper,
	            iteratee = args[0],
	            useLazy = isLazy || isArray(value);
	
	        var interceptor = function(value) {
	          var result = lodashFunc.apply(lodash, arrayPush([value], args));
	          return (isTaker && chainAll) ? result[0] : result;
	        };
	
	        if (useLazy && checkIteratee && typeof iteratee == 'function' && iteratee.length != 1) {
	          // Avoid lazy use if the iteratee has a "length" value other than `1`.
	          isLazy = useLazy = false;
	        }
	        var chainAll = this.__chain__,
	            isHybrid = !!this.__actions__.length,
	            isUnwrapped = retUnwrapped && !chainAll,
	            onlyLazy = isLazy && !isHybrid;
	
	        if (!retUnwrapped && useLazy) {
	          value = onlyLazy ? value : new LazyWrapper(this);
	          var result = func.apply(value, args);
	          result.__actions__.push({ 'func': thru, 'args': [interceptor], 'thisArg': undefined });
	          return new LodashWrapper(result, chainAll);
	        }
	        if (isUnwrapped && onlyLazy) {
	          return func.apply(this, args);
	        }
	        result = this.thru(interceptor);
	        return isUnwrapped ? (isTaker ? result.value()[0] : result.value()) : result;
	      };
	    });
	
	    // Add `Array` methods to `lodash.prototype`.
	    arrayEach(['pop', 'push', 'shift', 'sort', 'splice', 'unshift'], function(methodName) {
	      var func = arrayProto[methodName],
	          chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru',
	          retUnwrapped = /^(?:pop|shift)$/.test(methodName);
	
	      lodash.prototype[methodName] = function() {
	        var args = arguments;
	        if (retUnwrapped && !this.__chain__) {
	          var value = this.value();
	          return func.apply(isArray(value) ? value : [], args);
	        }
	        return this[chainName](function(value) {
	          return func.apply(isArray(value) ? value : [], args);
	        });
	      };
	    });
	
	    // Map minified method names to their real names.
	    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
	      var lodashFunc = lodash[methodName];
	      if (lodashFunc) {
	        var key = lodashFunc.name + '';
	        if (!hasOwnProperty.call(realNames, key)) {
	          realNames[key] = [];
	        }
	        realNames[key].push({ 'name': methodName, 'func': lodashFunc });
	      }
	    });
	
	    realNames[createHybrid(undefined, WRAP_BIND_KEY_FLAG).name] = [{
	      'name': 'wrapper',
	      'func': undefined
	    }];
	
	    // Add methods to `LazyWrapper`.
	    LazyWrapper.prototype.clone = lazyClone;
	    LazyWrapper.prototype.reverse = lazyReverse;
	    LazyWrapper.prototype.value = lazyValue;
	
	    // Add chain sequence methods to the `lodash` wrapper.
	    lodash.prototype.at = wrapperAt;
	    lodash.prototype.chain = wrapperChain;
	    lodash.prototype.commit = wrapperCommit;
	    lodash.prototype.next = wrapperNext;
	    lodash.prototype.plant = wrapperPlant;
	    lodash.prototype.reverse = wrapperReverse;
	    lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;
	
	    // Add lazy aliases.
	    lodash.prototype.first = lodash.prototype.head;
	
	    if (symIterator) {
	      lodash.prototype[symIterator] = wrapperToIterator;
	    }
	    return lodash;
	  });
	
	  /*--------------------------------------------------------------------------*/
	
	  // Export lodash.
	  var _ = runInContext();
	
	  // Some AMD build optimizers, like r.js, check for condition patterns like:
	  if (true) {
	    // Expose Lodash on the global object to prevent errors when Lodash is
	    // loaded by a script tag in the presence of an AMD loader.
	    // See http://requirejs.org/docs/errors.html#mismatch for more details.
	    // Use `_.noConflict` to remove Lodash from the global object.
	    root._ = _;
	
	    // Define as an anonymous module so, through path mapping, it can be
	    // referenced as the "underscore" module.
	    !(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
	      return _;
	    }.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  }
	  // Check for `exports` after `define` in case a build optimizer adds it.
	  else if (freeModule) {
	    // Export for Node.js.
	    (freeModule.exports = _)._ = _;
	    // Export for CommonJS support.
	    freeExports._ = _;
	  }
	  else {
	    // Export to the global object.
	    root._ = _;
	  }
	}.call(this));
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(64)(module)))

/***/ },
/* 64 */
/***/ function(module, exports) {

	module.exports = function(module) {
		if(!module.webpackPolyfill) {
			module.deprecate = function() {};
			module.paths = [];
			// module.parent = undefined by default
			module.children = [];
			module.webpackPolyfill = 1;
		}
		return module;
	}


/***/ },
/* 65 */
/***/ function(module, exports, __webpack_require__) {

	// Generated by CoffeeScript 1.11.1
	(function() {
	  var Descriptor, LayerComps;
	
	  Descriptor = __webpack_require__(66);
	
	  module.exports = LayerComps = (function() {
	    LayerComps.prototype.id = 1065;
	
	    LayerComps.prototype.name = 'layerComps';
	
	    LayerComps.visibilityCaptured = function(comp) {
	      return comp.capturedInfo & parseInt('001', 2) > 0;
	    };
	
	    LayerComps.positionCaptured = function(comp) {
	      return comp.positionCaptured & parseInt('010', 2) > 0;
	    };
	
	    LayerComps.appearanceCaptured = function(comp) {
	      return comp.appearanceCaptured & parseInt('100', 2) > 0;
	    };
	
	    function LayerComps(resource) {
	      this.resource = resource;
	      this.file = this.resource.file;
	    }
	
	    LayerComps.prototype.parse = function() {
	      this.file.seek(4, true);
	      return this.data = new Descriptor(this.file).parse();
	    };
	
	    LayerComps.prototype.names = function() {
	      return this.data.list.map(function(comp) {
	        return comp['Nm  '];
	      });
	    };
	
	    LayerComps.prototype["export"] = function() {
	      return this.data.list.map(function(comp) {
	        return {
	          id: comp.compID,
	          name: comp['Nm  '],
	          capturedInfo: comp.capturedInfo
	        };
	      });
	    };
	
	    return LayerComps;
	
	  })();
	
	}).call(this);


/***/ },
/* 66 */
/***/ function(module, exports) {

	// Generated by CoffeeScript 1.11.1
	(function() {
	  var Descriptor;
	
	  module.exports = Descriptor = (function() {
	    function Descriptor(file) {
	      this.file = file;
	      this.data = {};
	    }
	
	    Descriptor.prototype.parse = function() {
	      var i, id, j, numItems, ref, ref1, value;
	      this.data["class"] = this.parseClass();
	      numItems = this.file.readInt();
	      for (i = j = 0, ref = numItems; 0 <= ref ? j < ref : j > ref; i = 0 <= ref ? ++j : --j) {
	        ref1 = this.parseKeyItem(), id = ref1[0], value = ref1[1];
	        this.data[id] = value;
	      }
	      return this.data;
	    };
	
	    Descriptor.prototype.parseClass = function() {
	      return {
	        name: this.file.readUnicodeString(),
	        id: this.parseId()
	      };
	    };
	
	    Descriptor.prototype.parseId = function() {
	      var len;
	      len = this.file.readInt();
	      if (len === 0) {
	        return this.file.readString(4);
	      } else {
	        return this.file.readString(len);
	      }
	    };
	
	    Descriptor.prototype.parseKeyItem = function() {
	      var id, value;
	      id = this.parseId();
	      value = this.parseItem();
	      return [id, value];
	    };
	
	    Descriptor.prototype.parseItem = function(type) {
	      if (type == null) {
	        type = null;
	      }
	      if (type == null) {
	        type = this.file.readString(4);
	      }
	      switch (type) {
	        case 'bool':
	          return this.parseBoolean();
	        case 'type':
	        case 'GlbC':
	          return this.parseClass();
	        case 'Objc':
	        case 'GlbO':
	          return new Descriptor(this.file).parse();
	        case 'doub':
	          return this.parseDouble();
	        case 'enum':
	          return this.parseEnum();
	        case 'alis':
	          return this.parseAlias();
	        case 'Pth':
	          return this.parseFilePath();
	        case 'long':
	          return this.parseInteger();
	        case 'comp':
	          return this.parseLargeInteger();
	        case 'VlLs':
	          return this.parseList();
	        case 'ObAr':
	          return this.parseObjectArray();
	        case 'tdta':
	          return this.parseRawData();
	        case 'obj ':
	          return this.parseReference();
	        case 'TEXT':
	          return this.file.readUnicodeString();
	        case 'UntF':
	          return this.parseUnitDouble();
	        case 'UnFl':
	          return this.parseUnitFloat();
	        case 'uglg':
	          return this.parseBoolean();
	      }
	    };
	
	    Descriptor.prototype.parseBoolean = function() {
	      return this.file.readBoolean();
	    };
	
	    Descriptor.prototype.parseDouble = function() {
	      return this.file.readDouble();
	    };
	
	    Descriptor.prototype.parseInteger = function() {
	      return this.file.readInt();
	    };
	
	    Descriptor.prototype.parseLargeInteger = function() {
	      return this.file.readLongLong();
	    };
	
	    Descriptor.prototype.parseIdentifier = function() {
	      return this.file.readInt();
	    };
	
	    Descriptor.prototype.parseIndex = function() {
	      return this.file.readInt();
	    };
	
	    Descriptor.prototype.parseOffset = function() {
	      return this.file.readInt();
	    };
	
	    Descriptor.prototype.parseProperty = function() {
	      return {
	        "class": this.parseClass(),
	        id: this.parseId()
	      };
	    };
	
	    Descriptor.prototype.parseEnum = function() {
	      return {
	        type: this.parseId(),
	        value: this.parseId()
	      };
	    };
	
	    Descriptor.prototype.parseEnumReference = function() {
	      return {
	        "class": this.parseClass(),
	        type: this.parseId(),
	        value: this.parseId()
	      };
	    };
	
	    Descriptor.prototype.parseAlias = function() {
	      var len;
	      len = this.file.readInt();
	      return this.file.readString(len);
	    };
	
	    Descriptor.prototype.parseFilePath = function() {
	      var len, numChars, path, pathSize, sig;
	      len = this.file.readInt();
	      sig = this.file.readString(4);
	      pathSize = this.file.read('<i');
	      numChars = this.file.read('<i');
	      path = this.file.readUnicodeString(numChars);
	      return {
	        sig: sig,
	        path: path
	      };
	    };
	
	    Descriptor.prototype.parseList = function() {
	      var count, i, items, j, ref;
	      count = this.file.readInt();
	      items = [];
	      for (i = j = 0, ref = count; 0 <= ref ? j < ref : j > ref; i = 0 <= ref ? ++j : --j) {
	        items.push(this.parseItem());
	      }
	      return items;
	    };
	
	    Descriptor.prototype.parseObjectArray = function() {
	      throw "Descriptor object array not implemented yet @ " + (this.file.tell());
	    };
	
	    Descriptor.prototype.parseRawData = function() {
	      var len;
	      len = this.file.readInt();
	      return this.file.read(len);
	    };
	
	    Descriptor.prototype.parseReference = function() {
	      var i, items, j, numItems, ref, type, value;
	      numItems = this.file.readInt();
	      items = [];
	      for (i = j = 0, ref = numItems; 0 <= ref ? j < ref : j > ref; i = 0 <= ref ? ++j : --j) {
	        type = this.file.readString(4);
	        value = (function() {
	          switch (type) {
	            case 'prop':
	              return this.parseProperty();
	            case 'Clss':
	              return this.parseClass();
	            case 'Enmr':
	              return this.parseEnumReference();
	            case 'Idnt':
	              return this.parseIdentifier();
	            case 'indx':
	              return this.parseIndex();
	            case 'name':
	              return this.file.readUnicodeString();
	            case 'rele':
	              return this.parseOffset();
	          }
	        }).call(this);
	        items.push({
	          type: type,
	          value: value
	        });
	      }
	      return items;
	    };
	
	    Descriptor.prototype.parseUnitDouble = function() {
	      var unit, unitId, value;
	      unitId = this.file.readString(4);
	      unit = (function() {
	        switch (unitId) {
	          case '#Ang':
	            return 'Angle';
	          case '#Rsl':
	            return 'Density';
	          case '#Rlt':
	            return 'Distance';
	          case '#Nne':
	            return 'None';
	          case '#Prc':
	            return 'Percent';
	          case '#Pxl':
	            return 'Pixels';
	          case '#Mlm':
	            return 'Millimeters';
	          case '#Pnt':
	            return 'Points';
	        }
	      })();
	      value = this.file.readDouble();
	      return {
	        id: unitId,
	        unit: unit,
	        value: value
	      };
	    };
	
	    Descriptor.prototype.parseUnitFloat = function() {
	      var unit, unitId, value;
	      unitId = this.file.readString(4);
	      unit = (function() {
	        switch (unitId) {
	          case '#Ang':
	            return 'Angle';
	          case '#Rsl':
	            return 'Density';
	          case '#Rlt':
	            return 'Distance';
	          case '#Nne':
	            return 'None';
	          case '#Prc':
	            return 'Percent';
	          case '#Pxl':
	            return 'Pixels';
	          case '#Mlm':
	            return 'Millimeters';
	          case '#Pnt':
	            return 'Points';
	        }
	      })();
	      value = this.file.readFloat();
	      return {
	        id: unitId,
	        unit: unit,
	        value: value
	      };
	    };
	
	    return Descriptor;
	
	  })();
	
	}).call(this);


/***/ },
/* 67 */
/***/ function(module, exports) {

	// Generated by CoffeeScript 1.11.1
	(function() {
	  var LinkLayers;
	
	  module.exports = LinkLayers = (function() {
	    LinkLayers.prototype.id = 1026;
	
	    LinkLayers.prototype.name = 'LinkLayers';
	
	    function LinkLayers(resource) {
	      this.resource = resource;
	      this.file = this.resource.file;
	      this.linkArray = [];
	    }
	
	    LinkLayers.prototype.parse = function() {
	      var end;
	      end = this.file.tell() + this.resource.length;
	      while (end > this.file.tell()) {
	        this.linkArray.push(this.file.readShort());
	      }
	      return this.linkArray.reverse();
	    };
	
	    return LinkLayers;
	
	  })();
	
	}).call(this);


/***/ },
/* 68 */
/***/ function(module, exports) {

	// Generated by CoffeeScript 1.11.1
	(function() {
	  var ResolutionInfo;
	
	  module.exports = ResolutionInfo = (function() {
	    ResolutionInfo.prototype.id = 1005;
	
	    ResolutionInfo.prototype.name = 'resolutionInfo';
	
	    function ResolutionInfo(resource) {
	      this.resource = resource;
	      this.file = this.resource.file;
	    }
	
	    ResolutionInfo.prototype.parse = function() {
	      this.h_res = this.file.readInt() / 65536;
	      this.h_res_unit = this.file.readShort();
	      this.width_unit = this.file.readShort();
	      this.v_res = this.file.readInt() / 65536;
	      this.v_res_unit = this.file.readShort();
	      this.height_unit = this.file.readShort();
	      return this.resource.data = this;
	    };
	
	    ResolutionInfo.prototype["export"] = function() {
	      var data, i, key, len, ref;
	      data = {};
	      ref = ['h_res', 'h_res_unit', 'width_unit', 'v_res', 'v_res_unit', 'height_unit'];
	      for (i = 0, len = ref.length; i < len; i++) {
	        key = ref[i];
	        data[key] = this[key];
	      }
	      return data;
	    };
	
	    return ResolutionInfo;
	
	  })();
	
	}).call(this);


/***/ },
/* 69 */
/***/ function(module, exports) {

	// Generated by CoffeeScript 1.11.1
	(function() {
	  var GlobalLight;
	
	  module.exports = GlobalLight = (function() {
	    GlobalLight.prototype.id = 1037;
	
	    GlobalLight.prototype.name = 'globalLightAngle';
	
	    function GlobalLight(resource) {
	      this.resource = resource;
	      this.file = this.resource.file;
	    }
	
	    GlobalLight.prototype.parse = function() {
	      return this.angle = this.file.readInt();
	    };
	
	    return GlobalLight;
	
	  })();
	
	}).call(this);


/***/ },
/* 70 */
/***/ function(module, exports) {

	// Generated by CoffeeScript 1.11.1
	(function() {
	  var GlobalLight;
	
	  module.exports = GlobalLight = (function() {
	    GlobalLight.prototype.id = 1049;
	
	    GlobalLight.prototype.name = 'globalLightAngle';
	
	    function GlobalLight(resource) {
	      this.resource = resource;
	      this.file = this.resource.file;
	    }
	
	    GlobalLight.prototype.parse = function() {
	      return this.altitude = this.file.readInt();
	    };
	
	    return GlobalLight;
	
	  })();
	
	}).call(this);


/***/ },
/* 71 */
/***/ function(module, exports, __webpack_require__) {

	// Generated by CoffeeScript 1.11.1
	(function() {
	  var Descriptor, OriginPathInfo;
	
	  Descriptor = __webpack_require__(66);
	
	  module.exports = OriginPathInfo = (function() {
	    OriginPathInfo.prototype.id = 3000;
	
	    OriginPathInfo.prototype.name = 'originPathInfo';
	
	    function OriginPathInfo(resource) {
	      this.resource = resource;
	      this.file = this.resource.file;
	    }
	
	    OriginPathInfo.prototype.parse = function() {
	      this.file.seek(4, true);
	      return this.data = new Descriptor(this.file).parse();
	    };
	
	    return OriginPathInfo;
	
	  })();
	
	}).call(this);


/***/ },
/* 72 */
/***/ function(module, exports, __webpack_require__) {

	// Generated by CoffeeScript 1.11.1
	(function() {
	  var Descriptor, PathSelection;
	
	  Descriptor = __webpack_require__(66);
	
	  module.exports = PathSelection = (function() {
	    PathSelection.prototype.id = 1088;
	
	    PathSelection.prototype.name = 'pathSelection';
	
	    function PathSelection(resource) {
	      this.resource = resource;
	      this.file = this.resource.file;
	    }
	
	    PathSelection.prototype.parse = function() {
	      this.file.seek(4, true);
	      return this.data = new Descriptor(this.file).parse();
	    };
	
	    return PathSelection;
	
	  })();
	
	}).call(this);


/***/ },
/* 73 */
/***/ function(module, exports, __webpack_require__) {

	// Generated by CoffeeScript 1.11.1
	(function() {
	  var Path, PathRecord;
	
	  PathRecord = __webpack_require__(74);
	
	  module.exports = Path = (function() {
	    Path.prototype.id = 2000;
	
	    Path.prototype.name = 'path';
	
	    function Path(resource) {
	      this.resource = resource;
	      this.file = this.resource.file;
	      this.paths = [];
	    }
	
	    Path.prototype.parse = function() {
	      var i, j, numRecords, record, ref, results;
	      numRecords = this.resource.length / 26;
	      results = [];
	      for (i = j = 0, ref = numRecords; 0 <= ref ? j < ref : j > ref; i = 0 <= ref ? ++j : --j) {
	        record = new PathRecord(this.file);
	        record.parse();
	        results.push(this.paths.push(record));
	      }
	      return results;
	    };
	
	    Path.prototype["export"] = function() {
	      return this.paths;
	    };
	
	    return Path;
	
	  })();
	
	}).call(this);


/***/ },
/* 74 */
/***/ function(module, exports, __webpack_require__) {

	// Generated by CoffeeScript 1.11.1
	(function() {
	  var PathRecord, _;
	
	  _ = __webpack_require__(63);
	
	  module.exports = PathRecord = (function() {
	    function PathRecord(file) {
	      this.file = file;
	      this.recordType = null;
	    }
	
	    PathRecord.prototype.parse = function() {
	      this.recordType = this.file.readShort();
	      switch (this.recordType) {
	        case 0:
	        case 3:
	          return this._readPathRecord();
	        case 1:
	        case 2:
	        case 4:
	        case 5:
	          return this._readBezierPoint();
	        case 7:
	          return this._readClipboardRecord();
	        case 8:
	          return this._readInitialFill();
	        default:
	          return this.file.seek(24, true);
	      }
	    };
	
	    PathRecord.prototype["export"] = function() {
	      return _.merge({
	        recordType: this.recordType
	      }, (function() {
	        var ref;
	        switch (this.recordType) {
	          case 0:
	          case 3:
	            return {
	              numPoints: this.numPoints,
	              operation: this.operation
	            };
	          case 1:
	          case 2:
	          case 4:
	          case 5:
	            return {
	              linked: this.linked,
	              closed: ((ref = this.recordType) === 1 || ref === 2),
	              preceding: {
	                vert: this.precedingVert,
	                horiz: this.precedingHoriz
	              },
	              anchor: {
	                vert: this.anchorVert,
	                horiz: this.anchorHoriz
	              },
	              leaving: {
	                vert: this.leavingVert,
	                horiz: this.leavingHoriz
	              }
	            };
	          case 7:
	            return {
	              clipboard: {
	                top: this.clipboardTop,
	                left: this.clipboardLeft,
	                bottom: this.clipboardBottom,
	                right: this.clipboardRight,
	                resolution: this.clipboardResolution
	              }
	            };
	          case 8:
	            return {
	              initialFill: this.initialFill
	            };
	          default:
	            return {};
	        }
	      }).call(this));
	    };
	
	    PathRecord.prototype.isBezierPoint = function() {
	      var ref;
	      return (ref = this.recordType) === 1 || ref === 2 || ref === 4 || ref === 5;
	    };
	
	    PathRecord.prototype._readPathRecord = function() {
	      this.numPoints = this.file.readShort();
	      this.operation = this.file.readShort();
	      return this.file.seek(20, true);
	    };
	
	    PathRecord.prototype._readBezierPoint = function() {
	      var ref;
	      this.linked = (ref = this.recordType) === 1 || ref === 4;
	      this.precedingVert = this.file.readPathNumber();
	      this.precedingHoriz = this.file.readPathNumber();
	      this.anchorVert = this.file.readPathNumber();
	      this.anchorHoriz = this.file.readPathNumber();
	      this.leavingVert = this.file.readPathNumber();
	      return this.leavingHoriz = this.file.readPathNumber();
	    };
	
	    PathRecord.prototype._readClipboardRecord = function() {
	      this.clipboardTop = this.file.readPathNumber();
	      this.clipboardLeft = this.file.readPathNumber();
	      this.clipboardBottom = this.file.readPathNumber();
	      this.clipboardRight = this.file.readPathNumber();
	      this.clipboardResolution = this.file.readPathNumber();
	      return this.file.seek(4, true);
	    };
	
	    PathRecord.prototype._readInitialFill = function() {
	      this.initialFill = this.file.readShort();
	      return this.file.seek(22, true);
	    };
	
	    return PathRecord;
	
	  })();
	
	}).call(this);


/***/ },
/* 75 */
/***/ function(module, exports) {

	// Generated by CoffeeScript 1.11.1
	(function() {
	  var Thumbnail;
	
	  module.exports = Thumbnail = (function() {
	    Thumbnail.prototype.id = 1036;
	
	    Thumbnail.prototype.name = 'thumbnail';
	
	    function Thumbnail(resource) {
	      this.resource = resource;
	      this.file = this.resource.file;
	    }
	
	    Thumbnail.prototype.parse = function() {
	      var binaryString;
	      this.format = this.file.readString(4);
	      this.width = this.file.readInt();
	      this.height = this.file.readInt();
	      this.widthBytes = this.file.readInt();
	      this.totalSize = this.file.readInt();
	      this.compressedSize = this.file.readInt();
	      this.bitsPerPixel = this.file.readShort();
	      this.numberOfPlanes = this.file.readShort();
	      this.jfif = this.file.read(this.compressedSize);
	      binaryString = String.fromCharCode.apply(null, this.jfif);
	      return this.url = 'data:image/jpeg;base64,' + btoa(binaryString);
	    };
	
	    return Thumbnail;
	
	  })();
	
	}).call(this);


/***/ },
/* 76 */
/***/ function(module, exports, __webpack_require__) {

	// Generated by CoffeeScript 1.11.1
	(function() {
	  var LAYER_INFO, Layer, LayerMask, LazyExecute, Module, Util, _,
	    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
	    hasProp = {}.hasOwnProperty;
	
	  Module = __webpack_require__(6).Module;
	
	  _ = __webpack_require__(63);
	
	  Util = __webpack_require__(57);
	
	  Layer = __webpack_require__(77);
	
	  LazyExecute = __webpack_require__(58);
	
	  LAYER_INFO = {
	    linkedLayer: __webpack_require__(109),
	    unicodePath: __webpack_require__(126),
	    textEngineData: __webpack_require__(127),
	    filterMask: __webpack_require__(129)
	  };
	
	  module.exports = LayerMask = (function(superClass) {
	    extend(LayerMask, superClass);
	
	    LayerMask.includes(__webpack_require__(85));
	
	    function LayerMask(file, header) {
	      this.file = file;
	      this.header = header;
	      this.layers = [];
	      this.mergedAlpha = false;
	      this.globalMask = null;
	      this.infoKeys = [];
	      this.adjustments = {};
	    }
	
	    LayerMask.prototype.skip = function() {
	      return this.file.seek(this.file.readInt(), true);
	    };
	
	    LayerMask.prototype.parse = function() {
	      var maskSize;
	      if (this.header.version === 1) {
	        maskSize = this.file.readInt();
	      } else {
	        maskSize = this.file.readLongLong();
	      }
	      this.layerEnd = maskSize + this.file.tell();
	      if (maskSize <= 0) {
	        return;
	      }
	      this.parseLayers();
	      this.parseGlobalMask();
	      this.layers.reverse();
	      this.parseAdditionalLayerInformation();
	      return this.file.seek(this.layerEnd);
	    };
	
	    LayerMask.prototype.parseLayers = function() {
	      var i, j, k, layer, layerCount, layerEnd, layerInfoSize, len, ref, ref1;
	      if (this.header.version === 1) {
	        layerInfoSize = Util.pad2(this.file.readInt());
	      } else {
	        layerInfoSize = Util.pad2(this.file.readLongLong());
	      }
	      layerEnd = this.file.tell() + layerInfoSize;
	      if (layerInfoSize > 0) {
	        layerCount = this.file.readShort();
	        if (layerCount < 0) {
	          layerCount = Math.abs(layerCount);
	          this.mergedAlpha = true;
	        }
	        for (i = j = 0, ref = layerCount; 0 <= ref ? j < ref : j > ref; i = 0 <= ref ? ++j : --j) {
	          this.layers.push(new Layer(this.file, this.header).parse());
	        }
	        ref1 = this.layers;
	        for (k = 0, len = ref1.length; k < len; k++) {
	          layer = ref1[k];
	          layer.parseChannelImage();
	        }
	      }
	      return this.file.seek(layerEnd);
	    };
	
	    LayerMask.prototype.parseGlobalMask = function() {
	      var length, maskEnd;
	      length = this.file.readInt();
	      if (length <= 0) {
	        return;
	      }
	      maskEnd = Util.pad2(this.file.tell() + length);
	      this.globalMask = _({}).tap((function(_this) {
	        return function(mask) {
	          mask.overlayColorSpace = _this.file.readShort();
	          mask.colorComponents = [_this.file.readShort() >> 8, _this.file.readShort() >> 8, _this.file.readShort() >> 8, _this.file.readShort() >> 8];
	          mask.opacity = _this.file.readShort() / 16.0;
	          return mask.kind = _this.file.readByte();
	        };
	      })(this));
	      return this.file.seek(maskEnd);
	    };
	
	    LayerMask.prototype.parseAdditionalLayerInformation = function() {
	      var i, key, keyParseable, klass, length, name, pos, results;
	      results = [];
	      while (this.file.tell() < this.layerEnd) {
	        this.file.seek(4, true);
	        key = this.file.readString(4);
	        length = Util.pad2(this.file.readInt());
	        pos = this.file.tell();
	        if (length <= 0) {
	          continue;
	        }
	        keyParseable = false;
	        for (name in LAYER_INFO) {
	          if (!hasProp.call(LAYER_INFO, name)) continue;
	          klass = LAYER_INFO[name];
	          if (!klass.shouldParse(key)) {
	            continue;
	          }
	          i = new klass(this, length);
	          this.adjustments[name] = new LazyExecute(i, this.file).now('skip').later('parse').get();
	          if (this[name] == null) {
	            (function(_this) {
	              return (function(name) {
	                return _this[name] = function() {
	                  return _this.adjustments[name];
	                };
	              });
	            })(this)(name);
	          }
	          this.infoKeys.push(key);
	          keyParseable = true;
	          break;
	        }
	        if (!keyParseable) {
	          results.push(this.file.seek(length, true));
	        } else {
	          results.push(void 0);
	        }
	      }
	      return results;
	    };
	
	    return LayerMask;
	
	  })(Module);
	
	}).call(this);


/***/ },
/* 77 */
/***/ function(module, exports, __webpack_require__) {

	// Generated by CoffeeScript 1.11.1
	(function() {
	  var Layer, Module,
	    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
	    hasProp = {}.hasOwnProperty;
	
	  Module = __webpack_require__(6).Module;
	
	  module.exports = Layer = (function(superClass) {
	    extend(Layer, superClass);
	
	    Layer.includes(__webpack_require__(78));
	
	    Layer.includes(__webpack_require__(79));
	
	    Layer.includes(__webpack_require__(81));
	
	    Layer.includes(__webpack_require__(83));
	
	    Layer.includes(__webpack_require__(84));
	
	    Layer.includes(__webpack_require__(85));
	
	    Layer.includes(__webpack_require__(111));
	
	    Layer.includes(__webpack_require__(112));
	
	    function Layer(file, header) {
	      this.file = file;
	      this.header = header;
	      this.mask = {};
	      this.blendingRanges = {};
	      this.adjustments = {};
	      this.channelsInfo = [];
	      this.blendMode = {};
	      this.groupLayer = null;
	      this.infoKeys = [];
	      Object.defineProperty(this, 'name', {
	        get: function() {
	          if (this.adjustments['name'] != null) {
	            return this.adjustments['name'].data;
	          } else {
	            return this.legacyName;
	          }
	        }
	      });
	    }
	
	    Layer.prototype.parse = function() {
	      var extraLen;
	      this.parsePositionAndChannels();
	      this.parseBlendModes();
	      extraLen = this.file.readInt();
	      this.layerEnd = this.file.tell() + extraLen;
	      this.parseMaskData();
	      this.parseBlendingRanges();
	      this.parseLegacyLayerName();
	      this.parseLayerInfo();
	      this.file.seek(this.layerEnd);
	      return this;
	    };
	
	    Layer.prototype["export"] = function() {
	      return {
	        name: this.name,
	        top: this.top,
	        right: this.right,
	        bottom: this.bottom,
	        left: this.left,
	        width: this.width,
	        height: this.height,
	        opacity: this.opacity,
	        visible: this.visible,
	        clipped: this.clipped,
	        mask: this.mask["export"]()
	      };
	    };
	
	    return Layer;
	
	  })(Module);
	
	}).call(this);


/***/ },
/* 78 */
/***/ function(module, exports) {

	// Generated by CoffeeScript 1.11.1
	(function() {
	  module.exports = {
	    parsePositionAndChannels: function() {
	      var i, id, j, length, ref, results;
	      this.top = this.file.readInt();
	      this.left = this.file.readInt();
	      this.bottom = this.file.readInt();
	      this.right = this.file.readInt();
	      this.channels = this.file.readShort();
	      this.rows = this.height = this.bottom - this.top;
	      this.cols = this.width = this.right - this.left;
	      results = [];
	      for (i = j = 0, ref = this.channels; 0 <= ref ? j < ref : j > ref; i = 0 <= ref ? ++j : --j) {
	        id = this.file.readShort();
	        if (this.header.version === 1) {
	          length = this.file.readInt();
	        } else {
	          length = this.file.readLongLong();
	        }
	        results.push(this.channelsInfo.push({
	          id: id,
	          length: length
	        }));
	      }
	      return results;
	    }
	  };
	
	}).call(this);


/***/ },
/* 79 */
/***/ function(module, exports, __webpack_require__) {

	// Generated by CoffeeScript 1.11.1
	(function() {
	  var BlendMode;
	
	  BlendMode = __webpack_require__(80);
	
	  module.exports = {
	    parseBlendModes: function() {
	      this.blendMode = new BlendMode(this.file);
	      this.blendMode.parse();
	      this.opacity = this.blendMode.opacity;
	      this.visible = this.blendMode.visible;
	      return this.clipped = this.blendMode.clipped;
	    },
	    hidden: function() {
	      return !this.visible;
	    },
	    blendingMode: function() {
	      return this.blendMode.mode;
	    }
	  };
	
	}).call(this);


/***/ },
/* 80 */
/***/ function(module, exports, __webpack_require__) {

	// Generated by CoffeeScript 1.11.1
	(function() {
	  var BlendMode, Module,
	    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
	    hasProp = {}.hasOwnProperty;
	
	  Module = __webpack_require__(6).Module;
	
	  module.exports = BlendMode = (function(superClass) {
	    var BLEND_MODES;
	
	    extend(BlendMode, superClass);
	
	    BlendMode.aliasProperty('blendingMode', 'mode');
	
	    BLEND_MODES = {
	      norm: 'normal',
	      dark: 'darken',
	      lite: 'lighten',
	      hue: 'hue',
	      sat: 'saturation',
	      colr: 'color',
	      lum: 'luminosity',
	      mul: 'multiply',
	      scrn: 'screen',
	      diss: 'dissolve',
	      over: 'overlay',
	      hLit: 'hard_light',
	      sLit: 'soft_light',
	      diff: 'difference',
	      smud: 'exclusion',
	      div: 'color_dodge',
	      idiv: 'color_burn',
	      lbrn: 'linear_burn',
	      lddg: 'linear_dodge',
	      vLit: 'vivid_light',
	      lLit: 'linear_light',
	      pLit: 'pin_light',
	      hMix: 'hard_mix',
	      pass: 'passthru',
	      dkCl: 'darker_color',
	      lgCl: 'lighter_color',
	      fsub: 'subtract',
	      fdiv: 'divide'
	    };
	
	    function BlendMode(file) {
	      this.file = file;
	      this.blendKey = null;
	      this.opacity = null;
	      this.clipping = null;
	      this.clipped = null;
	      this.flags = null;
	      this.mode = null;
	      this.visible = null;
	    }
	
	    BlendMode.prototype.parse = function() {
	      this.file.seek(4, true);
	      this.blendKey = this.file.readString(4).trim();
	      this.opacity = this.file.readByte();
	      this.clipping = this.file.readByte();
	      this.flags = this.file.readByte();
	      this.mode = BLEND_MODES[this.blendKey];
	      this.clipped = this.clipping === 1;
	      this.visible = !((this.flags & (0x01 << 1)) > 0);
	      return this.file.seek(1, true);
	    };
	
	    BlendMode.prototype.opacityPercentage = function() {
	      return this.opacity * 100 / 255;
	    };
	
	    return BlendMode;
	
	  })(Module);
	
	}).call(this);


/***/ },
/* 81 */
/***/ function(module, exports, __webpack_require__) {

	// Generated by CoffeeScript 1.11.1
	(function() {
	  var Mask;
	
	  Mask = __webpack_require__(82);
	
	  module.exports = {
	    parseMaskData: function() {
	      return this.mask = new Mask(this.file).parse();
	    }
	  };
	
	}).call(this);


/***/ },
/* 82 */
/***/ function(module, exports) {

	// Generated by CoffeeScript 1.11.1
	(function() {
	  var Mask;
	
	  module.exports = Mask = (function() {
	    function Mask(file) {
	      this.file = file;
	      this.top = 0;
	      this.right = 0;
	      this.bottom = 0;
	      this.left = 0;
	    }
	
	    Mask.prototype.parse = function() {
	      var maskEnd;
	      this.size = this.file.readInt();
	      if (this.size === 0) {
	        return this;
	      }
	      maskEnd = this.file.tell() + this.size;
	      this.top = this.file.readInt();
	      this.left = this.file.readInt();
	      this.bottom = this.file.readInt();
	      this.right = this.file.readInt();
	      this.defaultColor = this.file.readByte();
	      this.flags = this.file.readByte();
	      if (this.size === 20) {
	        this.padding = this.file.readShort();
	      }
	      if (this.size >= 36) {
	        this.flags = this.file.readByte();
	        this.defaultColor = this.file.readByte();
	        this.top = this.file.readInt();
	        this.left = this.file.readInt();
	        this.bottom = this.file.readInt();
	        this.right = this.file.readInt();
	      }
	      this.width = this.right - this.left;
	      this.height = this.bottom - this.top;
	      this.relative = (this.flags & 0x01) > 0;
	      this.disabled = (this.flags & (0x01 << 1)) > 0;
	      this.invert = (this.flags & (0x01 << 2)) > 0;
	      this.external = (this.flags & (0x01 << 3)) > 0;
	      this.file.seek(maskEnd);
	      return this;
	    };
	
	    Mask.prototype["export"] = function() {
	      if (this.size === 0) {
	        return {};
	      }
	      return {
	        top: this.top,
	        left: this.left,
	        bottom: this.bottom,
	        right: this.right,
	        width: this.width,
	        height: this.height,
	        defaultColor: this.defaultColor,
	        relative: this.relative,
	        disabled: this.disabled,
	        invert: this.invert,
	        padding: this.padding,
	        external: this.external
	      };
	    };
	
	    return Mask;
	
	  })();
	
	}).call(this);


/***/ },
/* 83 */
/***/ function(module, exports) {

	// Generated by CoffeeScript 1.11.1
	(function() {
	  module.exports = {
	    parseBlendingRanges: function() {
	      var i, j, length, numChannels, ref, results;
	      length = this.file.readInt();
	      if (length === 0) {
	        return;
	      }
	      this.blendingRanges.grey = {
	        source: {
	          black: [this.file.readByte(), this.file.readByte()],
	          white: [this.file.readByte(), this.file.readByte()]
	        },
	        dest: {
	          black: [this.file.readByte(), this.file.readByte()],
	          white: [this.file.readByte(), this.file.readByte()]
	        }
	      };
	      numChannels = (length - 8) / 8;
	      this.blendingRanges.channels = [];
	      results = [];
	      for (i = j = 0, ref = numChannels; 0 <= ref ? j < ref : j > ref; i = 0 <= ref ? ++j : --j) {
	        results.push(this.blendingRanges.channels.push({
	          source: {
	            black: [this.file.readByte(), this.file.readByte()],
	            white: [this.file.readByte(), this.file.readByte()]
	          },
	          dest: {
	            black: [this.file.readByte(), this.file.readByte()],
	            white: [this.file.readByte(), this.file.readByte()]
	          }
	        }));
	      }
	      return results;
	    }
	  };
	
	}).call(this);


/***/ },
/* 84 */
/***/ function(module, exports, __webpack_require__) {

	// Generated by CoffeeScript 1.11.1
	(function() {
	  var Util;
	
	  Util = __webpack_require__(57);
	
	  module.exports = {
	    parseLegacyLayerName: function() {
	      var len;
	      len = Util.pad4(this.file.readByte());
	      return this.legacyName = this.file.readString(len);
	    }
	  };
	
	}).call(this);


/***/ },
/* 85 */
/***/ function(module, exports, __webpack_require__) {

	// Generated by CoffeeScript 1.11.1
	(function() {
	  var INFO_BYTES_8, LAYER_INFO, LazyExecute, Util,
	    hasProp = {}.hasOwnProperty;
	
	  LazyExecute = __webpack_require__(58);
	
	  Util = __webpack_require__(57);
	
	  LAYER_INFO = {
	    artboard: __webpack_require__(86),
	    blendClippingElements: __webpack_require__(88),
	    blendInteriorElements: __webpack_require__(89),
	    fillOpacity: __webpack_require__(90),
	    gradientFill: __webpack_require__(91),
	    layerId: __webpack_require__(92),
	    layerNameSource: __webpack_require__(93),
	    legacyTypetool: __webpack_require__(94),
	    locked: __webpack_require__(97),
	    metadata: __webpack_require__(98),
	    name: __webpack_require__(99),
	    nestedSectionDivider: __webpack_require__(100),
	    objectEffects: __webpack_require__(101),
	    sectionDivider: __webpack_require__(102),
	    solidColor: __webpack_require__(103),
	    typeTool: __webpack_require__(95),
	    vectorMask: __webpack_require__(104),
	    vectorOrigination: __webpack_require__(105),
	    vectorStroke: __webpack_require__(106),
	    vectorStrokeContent: __webpack_require__(107),
	    placedLayer: __webpack_require__(108),
	    linkedLayer: __webpack_require__(109),
	    smartObject: __webpack_require__(110)
	  };
	
	  INFO_BYTES_8 = ['LMsk', 'Lr16', 'Lr32', 'Layr', 'Mt16', 'Mt32', 'Mtrn', 'Alph', 'FMsk', 'Ink2', 'FEid', 'FXid', 'PxSD'];
	
	  module.exports = {
	    parseLayerInfo: function() {
	      var i, key, keyParseable, klass, length, name, pos, results;
	      results = [];
	      while (this.file.tell() < this.layerEnd) {
	        this.file.seek(4, true);
	        key = this.file.readString(4);
	        if (this.header.version === 2 && INFO_BYTES_8.includes(key)) {
	          length = Util.pad2(this.file.readLongLong());
	        } else {
	          length = Util.pad2(this.file.readInt());
	        }
	        pos = this.file.tell();
	        if (length <= 0) {
	          continue;
	        }
	        keyParseable = false;
	        for (name in LAYER_INFO) {
	          if (!hasProp.call(LAYER_INFO, name)) continue;
	          klass = LAYER_INFO[name];
	          if (!klass.shouldParse(key)) {
	            continue;
	          }
	          i = new klass(this, length);
	          if (this.externalFiles && key === 'lnk2') {
	            this.externalFiles.push(i.parse());
	            break;
	          }
	          this.adjustments[name] = new LazyExecute(i, this.file).now('skip').later('parse').get();
	          if (this[name] == null) {
	            (function(_this) {
	              return (function(name) {
	                return _this[name] = function() {
	                  return _this.adjustments[name];
	                };
	              });
	            })(this)(name);
	          }
	          this.infoKeys.push(key);
	          keyParseable = true;
	          break;
	        }
	        if (!keyParseable) {
	          results.push(this.file.seek(length, true));
	        } else {
	          results.push(void 0);
	        }
	      }
	      return results;
	    }
	  };
	
	}).call(this);


/***/ },
/* 86 */
/***/ function(module, exports, __webpack_require__) {

	// Generated by CoffeeScript 1.11.1
	(function() {
	  var Artboard, Descriptor, LayerInfo,
	    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
	    hasProp = {}.hasOwnProperty;
	
	  LayerInfo = __webpack_require__(87);
	
	  Descriptor = __webpack_require__(66);
	
	  module.exports = Artboard = (function(superClass) {
	    extend(Artboard, superClass);
	
	    function Artboard() {
	      return Artboard.__super__.constructor.apply(this, arguments);
	    }
	
	    Artboard.shouldParse = function(key) {
	      return key === 'artb';
	    };
	
	    Artboard.prototype.parse = function() {
	      this.file.seek(4, true);
	      return this.data = new Descriptor(this.file).parse();
	    };
	
	    Artboard.prototype["export"] = function() {
	      return {
	        coords: {
	          left: this.data.artboardRect['Left'],
	          top: this.data.artboardRect['Top '],
	          right: this.data.artboardRect['Rght'],
	          bottom: this.data.artboardRect['Btom']
	        }
	      };
	    };
	
	    return Artboard;
	
	  })(LayerInfo);
	
	}).call(this);


/***/ },
/* 87 */
/***/ function(module, exports) {

	// Generated by CoffeeScript 1.11.1
	(function() {
	  var LayerInfo;
	
	  module.exports = LayerInfo = (function() {
	    function LayerInfo(layer, length) {
	      this.layer = layer;
	      this.length = length;
	      this.file = this.layer.file;
	      this.section_end = this.file.tell() + this.length;
	      this.data = {};
	    }
	
	    LayerInfo.prototype.skip = function() {
	      return this.file.seek(this.section_end);
	    };
	
	    LayerInfo.prototype.parse = function() {
	      return this.skip();
	    };
	
	    return LayerInfo;
	
	  })();
	
	}).call(this);


/***/ },
/* 88 */
/***/ function(module, exports, __webpack_require__) {

	// Generated by CoffeeScript 1.11.1
	(function() {
	  var BlendClippingElements, LayerInfo,
	    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
	    hasProp = {}.hasOwnProperty;
	
	  LayerInfo = __webpack_require__(87);
	
	  module.exports = BlendClippingElements = (function(superClass) {
	    extend(BlendClippingElements, superClass);
	
	    function BlendClippingElements() {
	      return BlendClippingElements.__super__.constructor.apply(this, arguments);
	    }
	
	    BlendClippingElements.shouldParse = function(key) {
	      return key === 'clbl';
	    };
	
	    BlendClippingElements.prototype.parse = function() {
	      this.enabled = this.file.readBoolean();
	      return this.file.seek(3, true);
	    };
	
	    return BlendClippingElements;
	
	  })(LayerInfo);
	
	}).call(this);


/***/ },
/* 89 */
/***/ function(module, exports, __webpack_require__) {

	// Generated by CoffeeScript 1.11.1
	(function() {
	  var BlendInteriorElements, LayerInfo,
	    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
	    hasProp = {}.hasOwnProperty;
	
	  LayerInfo = __webpack_require__(87);
	
	  module.exports = BlendInteriorElements = (function(superClass) {
	    extend(BlendInteriorElements, superClass);
	
	    function BlendInteriorElements() {
	      return BlendInteriorElements.__super__.constructor.apply(this, arguments);
	    }
	
	    BlendInteriorElements.shouldParse = function(key) {
	      return key === 'infx';
	    };
	
	    BlendInteriorElements.prototype.parse = function() {
	      this.enabled = this.file.readBoolean();
	      return this.file.seek(3, true);
	    };
	
	    return BlendInteriorElements;
	
	  })(LayerInfo);
	
	}).call(this);


/***/ },
/* 90 */
/***/ function(module, exports, __webpack_require__) {

	// Generated by CoffeeScript 1.11.1
	(function() {
	  var FillOpacity, LayerInfo,
	    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
	    hasProp = {}.hasOwnProperty;
	
	  LayerInfo = __webpack_require__(87);
	
	  module.exports = FillOpacity = (function(superClass) {
	    extend(FillOpacity, superClass);
	
	    function FillOpacity() {
	      return FillOpacity.__super__.constructor.apply(this, arguments);
	    }
	
	    FillOpacity.shouldParse = function(key) {
	      return key === 'iOpa';
	    };
	
	    FillOpacity.prototype.parse = function() {
	      var opacity, unit, value;
	      value = this.file.readByte();
	      opacity = Math.round(value * 100 / 255);
	      unit = 'Percent';
	      this.data.opacity = opacity;
	      return this.data.unit = unit;
	    };
	
	    return FillOpacity;
	
	  })(LayerInfo);
	
	}).call(this);


/***/ },
/* 91 */
/***/ function(module, exports, __webpack_require__) {

	// Generated by CoffeeScript 1.11.1
	(function() {
	  var Descriptor, GradientFill, LayerInfo,
	    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
	    hasProp = {}.hasOwnProperty;
	
	  LayerInfo = __webpack_require__(87);
	
	  Descriptor = __webpack_require__(66);
	
	  module.exports = GradientFill = (function(superClass) {
	    extend(GradientFill, superClass);
	
	    function GradientFill() {
	      return GradientFill.__super__.constructor.apply(this, arguments);
	    }
	
	    GradientFill.shouldParse = function(key) {
	      return key === 'GdFl';
	    };
	
	    GradientFill.prototype.parse = function() {
	      this.file.seek(4, true);
	      return this.data = new Descriptor(this.file).parse();
	    };
	
	    return GradientFill;
	
	  })(LayerInfo);
	
	}).call(this);


/***/ },
/* 92 */
/***/ function(module, exports, __webpack_require__) {

	// Generated by CoffeeScript 1.11.1
	(function() {
	  var LayerId, LayerInfo,
	    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
	    hasProp = {}.hasOwnProperty;
	
	  LayerInfo = __webpack_require__(87);
	
	  module.exports = LayerId = (function(superClass) {
	    extend(LayerId, superClass);
	
	    function LayerId() {
	      return LayerId.__super__.constructor.apply(this, arguments);
	    }
	
	    LayerId.shouldParse = function(key) {
	      return key === 'lyid';
	    };
	
	    LayerId.prototype.parse = function() {
	      return this.id = this.file.readInt();
	    };
	
	    return LayerId;
	
	  })(LayerInfo);
	
	}).call(this);


/***/ },
/* 93 */
/***/ function(module, exports, __webpack_require__) {

	// Generated by CoffeeScript 1.11.1
	(function() {
	  var LayerInfo, LayerNameSource,
	    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
	    hasProp = {}.hasOwnProperty;
	
	  LayerInfo = __webpack_require__(87);
	
	  module.exports = LayerNameSource = (function(superClass) {
	    extend(LayerNameSource, superClass);
	
	    function LayerNameSource() {
	      return LayerNameSource.__super__.constructor.apply(this, arguments);
	    }
	
	    LayerNameSource.shouldParse = function(key) {
	      return key === 'lnsr';
	    };
	
	    LayerNameSource.prototype.parse = function() {
	      return this.id = this.file.readString(4);
	    };
	
	    return LayerNameSource;
	
	  })(LayerInfo);
	
	}).call(this);


/***/ },
/* 94 */
/***/ function(module, exports, __webpack_require__) {

	// Generated by CoffeeScript 1.11.1
	(function() {
	  var LegacyTypeTool, TypeTool, _,
	    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
	    hasProp = {}.hasOwnProperty;
	
	  _ = __webpack_require__(63);
	
	  TypeTool = __webpack_require__(95);
	
	  module.exports = LegacyTypeTool = (function(superClass) {
	    extend(LegacyTypeTool, superClass);
	
	    LegacyTypeTool.shouldParse = function(key) {
	      return key === 'tySh';
	    };
	
	    function LegacyTypeTool(layer, length) {
	      LegacyTypeTool.__super__.constructor.call(this, layer, length);
	      this.transform = {};
	      this.faces = [];
	      this.styles = [];
	      this.lines = [];
	      this.type = 0;
	      this.scalingFactor = 0;
	      this.characterCount = 0;
	      this.horzPlace = 0;
	      this.vertPlace = 0;
	      this.selectStart = 0;
	      this.selectEnd = 0;
	      this.color = null;
	      this.antialias = null;
	    }
	
	    LegacyTypeTool.prototype.parse = function() {
	      var facesCount, i, k, l, linesCount, m, ref, ref1, ref2, stylesCount;
	      this.file.seek(2, true);
	      this.parseTransformInfo();
	      this.file.seek(2, true);
	      facesCount = this.file.readShort();
	      for (i = k = 0, ref = facesCount; 0 <= ref ? k < ref : k > ref; i = 0 <= ref ? ++k : --k) {
	        this.faces.push(_({}).tap((function(_this) {
	          return function(face) {
	            var j, l, ref1, results;
	            face.mark = _this.file.readShort();
	            face.fontType = _this.file.readInt();
	            face.fontName = _this.file.readString();
	            face.fontFamilyName = _this.file.readString();
	            face.fontStyleName = _this.file.readString();
	            face.script = _this.file.readShort();
	            face.numberAxesVector = _this.file.readInt();
	            face.vector = [];
	            results = [];
	            for (j = l = 0, ref1 = face.numberAxesVector; 0 <= ref1 ? l < ref1 : l > ref1; j = 0 <= ref1 ? ++l : --l) {
	              results.push(face.vector.push(_this.file.readInt()));
	            }
	            return results;
	          };
	        })(this)));
	      }
	      stylesCount = this.file.readShort();
	      for (i = l = 0, ref1 = stylesCount; 0 <= ref1 ? l < ref1 : l > ref1; i = 0 <= ref1 ? ++l : --l) {
	        this.styles.push(_({}).tap((function(_this) {
	          return function(style) {
	            style.mark = _this.file.readShort();
	            style.faceMark = _this.file.readShort();
	            style.size = _this.file.readInt();
	            style.tracking = _this.file.readInt();
	            style.kerning = _this.file.readInt();
	            style.leading = _this.file.readInt();
	            style.baseShift = _this.file.readInt();
	            style.autoKern = _this.file.readBoolean();
	            _this.file.seek(1, true);
	            return style.rotate = _this.file.readBoolean();
	          };
	        })(this)));
	      }
	      this.type = this.file.readShort();
	      this.scalingFactor = this.file.readInt();
	      this.characterCount = this.file.readInt();
	      this.horzPlace = this.file.readInt();
	      this.vertPlace = this.file.readInt();
	      this.selectStart = this.file.readInt();
	      this.selectEnd = this.file.readInt();
	      linesCount = this.file.readShort();
	      for (i = m = 0, ref2 = linesCount; 0 <= ref2 ? m < ref2 : m > ref2; i = 0 <= ref2 ? ++m : --m) {
	        this.lines.push(_({}).tap(function(line) {
	          line.charCount = this.file.readInt();
	          line.orientation = this.file.readShort();
	          line.alignment = this.file.readShort();
	          line.actualChar = this.file.readShort();
	          return line.style = this.file.readShort();
	        }));
	      }
	      this.color = this.file.readSpaceColor();
	      return this.antialias = this.file.readBoolean();
	    };
	
	    return LegacyTypeTool;
	
	  })(TypeTool);
	
	}).call(this);


/***/ },
/* 95 */
/***/ function(module, exports, __webpack_require__) {

	// Generated by CoffeeScript 1.11.1
	(function() {
	  var Descriptor, LayerInfo, TextElements, _, parseEngineData,
	    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
	    hasProp = {}.hasOwnProperty;
	
	  _ = __webpack_require__(63);
	
	  parseEngineData = __webpack_require__(96);
	
	  LayerInfo = __webpack_require__(87);
	
	  Descriptor = __webpack_require__(66);
	
	  module.exports = TextElements = (function(superClass) {
	    var COORDS_VALUE, TRANSFORM_VALUE;
	
	    extend(TextElements, superClass);
	
	    TextElements.shouldParse = function(key) {
	      return key === 'TySh';
	    };
	
	    TRANSFORM_VALUE = ['xx', 'xy', 'yx', 'yy', 'tx', 'ty'];
	
	    COORDS_VALUE = ['left', 'top', 'right', 'bottom'];
	
	    function TextElements(layer, length) {
	      TextElements.__super__.constructor.call(this, layer, length);
	      this.version = null;
	      this.transform = {};
	      this.textVersion = null;
	      this.descriptorVersion = null;
	      this.textData = null;
	      this.engineData = null;
	      this.textValue = null;
	      this.warpVersion = null;
	      this.descriptorVersion = null;
	      this.warpData = null;
	      this.coords = {};
	    }
	
	    TextElements.prototype.parse = function() {
	      var i, index, len, name, results;
	      this.version = this.file.readShort();
	      this.parseTransformInfo();
	      this.textVersion = this.file.readShort();
	      this.descriptorVersion = this.file.readInt();
	      this.textData = new Descriptor(this.file).parse();
	      this.textValue = this.textData['Txt '];
	      this.engineData = parseEngineData(this.textData.EngineData);
	      this.warpVersion = this.file.readShort();
	      this.descriptorVersion = this.file.readInt();
	      this.warpData = new Descriptor(this.file).parse();
	      results = [];
	      for (index = i = 0, len = COORDS_VALUE.length; i < len; index = ++i) {
	        name = COORDS_VALUE[index];
	        results.push(this.coords[name] = this.file.readInt());
	      }
	      return results;
	    };
	
	    TextElements.prototype.parseTransformInfo = function() {
	      var i, index, len, name, results;
	      results = [];
	      for (index = i = 0, len = TRANSFORM_VALUE.length; i < len; index = ++i) {
	        name = TRANSFORM_VALUE[index];
	        results.push(this.transform[name] = this.file.readDouble());
	      }
	      return results;
	    };
	
	    TextElements.prototype.fonts = function() {
	      if (this.engineData == null) {
	        return [];
	      }
	      return this.engineData.ResourceDict.FontSet.map(function(f) {
	        return f.Name;
	      });
	    };
	
	    TextElements.prototype.lengthArray = function() {
	      var arr, sum;
	      arr = this.engineData.EngineDict.StyleRun.RunLengthArray;
	      sum = _.reduce(arr, function(m, o) {
	        return m + o;
	      });
	      if (sum - this.textValue.length === 1) {
	        arr[arr.length - 1] = arr[arr.length - 1] - 1;
	      }
	      return arr;
	    };
	
	    TextElements.prototype.fontStyles = function() {
	      var data;
	      data = this.engineData.EngineDict.StyleRun.RunArray.map(function(r) {
	        return r.StyleSheet.StyleSheetData;
	      });
	      return data.map(function(f) {
	        var style;
	        if (f.FauxItalic) {
	          style = 'italic';
	        } else {
	          style = 'normal';
	        }
	        return style;
	      });
	    };
	
	    TextElements.prototype.fontWeights = function() {
	      var data;
	      data = this.engineData.EngineDict.StyleRun.RunArray.map(function(r) {
	        return r.StyleSheet.StyleSheetData;
	      });
	      return data.map(function(f) {
	        var weight;
	        if (f.FauxBold) {
	          weight = 'bold';
	        } else {
	          weight = 'normal';
	        }
	        return weight;
	      });
	    };
	
	    TextElements.prototype.textDecoration = function() {
	      var data;
	      data = this.engineData.EngineDict.StyleRun.RunArray.map(function(r) {
	        return r.StyleSheet.StyleSheetData;
	      });
	      return data.map(function(f) {
	        var decoration;
	        if (f.Underline) {
	          decoration = 'underline';
	        } else {
	          decoration = 'none';
	        }
	        return decoration;
	      });
	    };
	
	    TextElements.prototype.leading = function() {
	      var data;
	      data = this.engineData.EngineDict.StyleRun.RunArray.map(function(r) {
	        return r.StyleSheet.StyleSheetData;
	      });
	      return data.map(function(f) {
	        var leading;
	        if (f.Leading) {
	          leading = f.Leading;
	        } else {
	          leading = 'auto';
	        }
	        return leading;
	      });
	    };
	
	    TextElements.prototype.sizes = function() {
	      if ((this.engineData == null) && (this.styles().FontSize == null)) {
	        return [];
	      }
	      return this.styles().FontSize;
	    };
	
	    TextElements.prototype.alignment = function() {
	      var alignments;
	      if (this.engineData == null) {
	        return [];
	      }
	      alignments = ['left', 'right', 'center', 'justify'];
	      return this.engineData.EngineDict.ParagraphRun.RunArray.map(function(s) {
	        return alignments[Math.min(parseInt(s.ParagraphSheet.Properties.Justification, 10), 3)];
	      });
	    };
	
	    TextElements.prototype.colors = function() {
	      if ((this.engineData == null) || (this.styles().FillColor == null)) {
	        return [[0, 0, 0, 255]];
	      }
	      return this.styles().FillColor.map(function(s) {
	        var values;
	        values = s.Values.map(function(v) {
	          return Math.round(v * 255);
	        });
	        values.push(values.shift());
	        return values;
	      });
	    };
	
	    TextElements.prototype.fillTypes = function() {
	      if (this.styles().FillColor) {
	        return this.styles().FillColor.map(function(s) {
	          return s.Type;
	        });
	      } else {
	        return 1;
	      }
	    };
	
	    TextElements.prototype.styles = function() {
	      var data;
	      if (this.engineData == null) {
	        return {};
	      }
	      if (this._styles != null) {
	        return this._styles;
	      }
	      data = this.engineData.EngineDict.StyleRun.RunArray.map(function(r) {
	        return r.StyleSheet.StyleSheetData;
	      });
	      return this._styles = _.reduce(data, function(m, o) {
	        var k, v;
	        for (k in o) {
	          if (!hasProp.call(o, k)) continue;
	          v = o[k];
	          m[k] || (m[k] = []);
	          m[k].push(v);
	        }
	        return m;
	      }, {});
	    };
	
	    TextElements.prototype.toCSS = function() {
	      var css, definition, k, v;
	      definition = {
	        'font-family': this.fonts().join(', '),
	        'font-size': (this.sizes()[0]) + "pt",
	        'color': "rgba(" + (this.colors()[0].join(', ')) + ")",
	        'text-align': this.alignment()[0]
	      };
	      css = [];
	      for (k in definition) {
	        v = definition[k];
	        if (v == null) {
	          continue;
	        }
	        css.push(k + ": " + v + ";");
	      }
	      return css.join("\n");
	    };
	
	    TextElements.prototype["export"] = function() {
	      return {
	        value: this.textValue,
	        font: {
	          lengthArray: this.lengthArray(),
	          styles: this.fontStyles(),
	          weights: this.fontWeights(),
	          names: this.fonts(),
	          sizes: this.sizes(),
	          colors: this.colors(),
	          alignment: this.alignment(),
	          textDecoration: this.textDecoration(),
	          leading: this.leading()
	        },
	        left: this.coords.left,
	        top: this.coords.top,
	        right: this.coords.right,
	        bottom: this.coords.bottom,
	        transform: this.transform
	      };
	    };
	
	    return TextElements;
	
	  })(LayerInfo);
	
	}).call(this);


/***/ },
/* 96 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {var iconv = __webpack_require__(15)
	// engineData is an array form descriptor.coffee
	
	var MATCH_TYPE = [  hashStart,
	                    hashEnd,
	                    multiLineArrayStart,
	                    multiLineArrayEnd,
	                    property, 
	                    propertyWithData,
	                    singleLineArray,
	                    boolean,
	                    number,
	                    numberWithDecimal,
	                    string];
	
	var nodeStack = [], propertyStack = [];
	var currentNode = [];
	
	var paresr = function(engineData){
	
	    nodeStack = propertyStack = currentNode = [];//reset
	    textReg(textSegment(codeToString(engineData)));
		if (!(currentNode instanceof Array)) {
			throw new Error('PSD文本错误');
		}
	    return currentNode.shift();
	}
	
	
	function codeToString(engineData){
	    return String.fromCharCode.apply(null, engineData);
	}
	
	function textSegment(text){
	    return text.split('\n');
	}
	
	function textReg(textArr){
	    textArr.map(function(currentText){
	        typeMatch(currentText.replace(/^\t+/g, ''));
	    });
	
	}
	
	function typeMatch(currentText){
	
	    for (var currentType in MATCH_TYPE) {
	        var t = new MATCH_TYPE[currentType](currentText);
	        if (t.match){
	            return t.parse();
	        }
	    }
	
	    return currentText;
	}
	
	// helper fun
	function Match(reg, text){
	    return reg.test(text);
	}
	function isArray(o){
	    return Object.prototype.toString.call(o) === '[object Array]';
	}
	
	// tyep reg
	function hashStart(text){
	    var reg = /^<<$/;
	
	    return {
	        match: Match(reg, text),
	        parse: function(){
	            stackPush({});
	        }
	    }
	}
	function hashEnd(text){
	    var reg = /^>>$/;
	
	    return {
	        match: Match(reg, text),
	        parse: function(){
	            updateNode();
	        }
	    }
	}
	function multiLineArrayStart(text){
	    var reg = /^\/(\w+) \[$/;
	
	    return {
	        match: Match(reg, text),
	        parse: function(){
	            propertyStack.push(text.match(reg)[1]);
	            stackPush([]);
	        }
	    }
	}
	function multiLineArrayEnd(text){
	    var reg = /^\]$/;
	
	    return {
	        match: Match(reg, text),
	        parse: function(){
	            updateNode();
	        }
	    }
	}
	function property(text){
	    var reg = /^\/([A-Z0-9]+)$/i;
	
	    return {
	        match: Match(reg, text),
	        parse: function(){
	            propertyStack.push(text.match(reg)[1]);
	        }
	    }
	}
	function propertyWithData(text){
	    var reg = /^\/([A-Z0-9]+)\s((.|\r)*)$/i;
	
	    return {
	        match: Match(reg, text),
	        parse: function(){
	            var match = text.match(reg);
	            pushKeyValue(match[1], typeMatch(match[2]));
	        }
	    }
	}
	// value reg
	function boolean(text){
	    var reg = /^(true|false)$/;
	    return {
	        match: Match(reg, text),
	        parse: function(){
	            return text === 'true'? true:false;
	        }
	    }
	}
	function number(text){
	    var reg = /^-?\d+$/;
	    return {
	        match: Match(reg, text),
	        parse: function(){
	            return Number(text);
	        }
	    }
	}
	function numberWithDecimal(text){
	    var reg = /^(-?\d*)\.(\d+)$/;
	    return {
	        match: Match(reg, text),
	        parse: function(){
	            return Number(text);
	        }
	    }
	}
	function singleLineArray(text){
	    //单行数组似乎只有数字数组的情况
	    var reg = /^\[(.*)\]$/;
	    return {
	        match: Match(reg, text),
	        parse: function(){
	            var items = text.match(reg)[1].trim().split(' ');
	            var tempArr = [];
	            for (var i=0, l=items.length; i<l; i++){
	                tempArr.push(typeMatch(items[i]));
	            }
	            return tempArr;
	        }
	    }
	}
	
	function string(text){
	    //the text in editor has some encoding issues
	    var reg = /^\(((.|\r)*)\)$/;
	    return {
	        match: Match(reg, text),
	        parse: function(){
	            var txt = text.match(reg)[1];
	            var bf = [];
	            for (var i=0,l=txt.length;i<l;i++){
	                bf.push(txt.charCodeAt(i));
	            }
	            return iconv.decode(new Buffer(bf), 'utf-16');//it`s utf-16 with bom
	        }
	    }
	}
	
	// node handle
	function stackPush(node){
	    nodeStack.push(currentNode);
	    currentNode = node;
	}
	function updateNode(){
	    var node = nodeStack.pop();
	    if (isArray(node)){
	        node.push(currentNode);
	    } else {
	        node[propertyStack.pop()] = currentNode;
	    }
	    currentNode = node;
	}
	function pushKeyValue(key,value){
	    currentNode[key] = value;
	}
	
	module.exports = paresr;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(9).Buffer))

/***/ },
/* 97 */
/***/ function(module, exports, __webpack_require__) {

	// Generated by CoffeeScript 1.11.1
	(function() {
	  var LayerInfo, Locked,
	    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
	    hasProp = {}.hasOwnProperty;
	
	  LayerInfo = __webpack_require__(87);
	
	  module.exports = Locked = (function(superClass) {
	    extend(Locked, superClass);
	
	    Locked.shouldParse = function(key) {
	      return key === 'lspf';
	    };
	
	    function Locked(layer, length) {
	      Locked.__super__.constructor.call(this, layer, length);
	      this.transparencyLocked = false;
	      this.compositeLocked = false;
	      this.positionLocked = false;
	      this.allLocked = false;
	    }
	
	    Locked.prototype.parse = function() {
	      var locked;
	      locked = this.file.readInt();
	      this.transparencyLocked = (locked & (0x01 << 0)) > 0 || locked === -2147483648;
	      this.compositeLocked = (locked & (0x01 << 1)) > 0 || locked === -2147483648;
	      this.positionLocked = (locked & (0x01 << 2)) > 0 || locked === -2147483648;
	      return this.allLocked = this.transparencyLocked && this.compositeLocked && this.positionLocked;
	    };
	
	    return Locked;
	
	  })(LayerInfo);
	
	}).call(this);


/***/ },
/* 98 */
/***/ function(module, exports, __webpack_require__) {

	// Generated by CoffeeScript 1.11.1
	(function() {
	  var Descriptor, LayerInfo, Metadata,
	    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
	    hasProp = {}.hasOwnProperty;
	
	  LayerInfo = __webpack_require__(87);
	
	  Descriptor = __webpack_require__(66);
	
	  module.exports = Metadata = (function(superClass) {
	    extend(Metadata, superClass);
	
	    function Metadata() {
	      return Metadata.__super__.constructor.apply(this, arguments);
	    }
	
	    Metadata.shouldParse = function(key) {
	      return key === 'shmd';
	    };
	
	    Metadata.prototype.parse = function() {
	      var copyOnSheetDup, count, end, i, j, key, len, ref, results;
	      count = this.file.readInt();
	      results = [];
	      for (i = j = 0, ref = count; 0 <= ref ? j < ref : j > ref; i = 0 <= ref ? ++j : --j) {
	        this.file.seek(4, true);
	        key = this.file.readString(4);
	        copyOnSheetDup = this.file.readByte();
	        this.file.seek(3, true);
	        len = this.file.readInt();
	        end = this.file.tell() + len;
	        if (key === 'cmls') {
	          this.parseLayerComps();
	        }
	        results.push(this.file.seek(end));
	      }
	      return results;
	    };
	
	    Metadata.prototype.parseLayerComps = function() {
	      this.file.seek(4, true);
	      return this.data.layerComp = new Descriptor(this.file).parse();
	    };
	
	    return Metadata;
	
	  })(LayerInfo);
	
	}).call(this);


/***/ },
/* 99 */
/***/ function(module, exports, __webpack_require__) {

	// Generated by CoffeeScript 1.11.1
	(function() {
	  var LayerInfo, UnicodeName,
	    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
	    hasProp = {}.hasOwnProperty;
	
	  LayerInfo = __webpack_require__(87);
	
	  module.exports = UnicodeName = (function(superClass) {
	    extend(UnicodeName, superClass);
	
	    function UnicodeName() {
	      return UnicodeName.__super__.constructor.apply(this, arguments);
	    }
	
	    UnicodeName.shouldParse = function(key) {
	      return key === 'luni';
	    };
	
	    UnicodeName.prototype.parse = function() {
	      var pos;
	      pos = this.file.tell();
	      this.data = this.file.readUnicodeString();
	      this.file.seek(pos + this.length);
	      return this;
	    };
	
	    return UnicodeName;
	
	  })(LayerInfo);
	
	}).call(this);


/***/ },
/* 100 */
/***/ function(module, exports, __webpack_require__) {

	// Generated by CoffeeScript 1.11.1
	(function() {
	  var LayerInfo, NestedSectionDivider,
	    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
	    hasProp = {}.hasOwnProperty;
	
	  LayerInfo = __webpack_require__(87);
	
	  module.exports = NestedSectionDivider = (function(superClass) {
	    extend(NestedSectionDivider, superClass);
	
	    NestedSectionDivider.shouldParse = function(key) {
	      return key === 'lsdk';
	    };
	
	    function NestedSectionDivider(layer, length) {
	      NestedSectionDivider.__super__.constructor.call(this, layer, length);
	      this.isFolder = false;
	      this.isHidden = false;
	    }
	
	    NestedSectionDivider.prototype.parse = function() {
	      var code;
	      code = this.file.readInt();
	      switch (code) {
	        case 1:
	        case 2:
	          return this.isFolder = true;
	        case 3:
	          return this.isHidden = true;
	      }
	    };
	
	    return NestedSectionDivider;
	
	  })(LayerInfo);
	
	}).call(this);


/***/ },
/* 101 */
/***/ function(module, exports, __webpack_require__) {

	// Generated by CoffeeScript 1.11.1
	(function() {
	  var Descriptor, LayerInfo, ObjectEffects,
	    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
	    hasProp = {}.hasOwnProperty;
	
	  LayerInfo = __webpack_require__(87);
	
	  Descriptor = __webpack_require__(66);
	
	  module.exports = ObjectEffects = (function(superClass) {
	    extend(ObjectEffects, superClass);
	
	    function ObjectEffects() {
	      return ObjectEffects.__super__.constructor.apply(this, arguments);
	    }
	
	    ObjectEffects.shouldParse = function(key) {
	      return key === 'lfx2' || key === 'lmfx';
	    };
	
	    ObjectEffects.prototype.parse = function() {
	      this.file.seek(8, true);
	      return this.data = new Descriptor(this.file).parse();
	    };
	
	    return ObjectEffects;
	
	  })(LayerInfo);
	
	}).call(this);


/***/ },
/* 102 */
/***/ function(module, exports, __webpack_require__) {

	// Generated by CoffeeScript 1.11.1
	(function() {
	  var LayerInfo, NestedSectionDivider,
	    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
	    hasProp = {}.hasOwnProperty;
	
	  LayerInfo = __webpack_require__(87);
	
	  module.exports = NestedSectionDivider = (function(superClass) {
	    var SECTION_DIVIDER_TYPES;
	
	    extend(NestedSectionDivider, superClass);
	
	    NestedSectionDivider.shouldParse = function(key) {
	      return key === 'lsct';
	    };
	
	    SECTION_DIVIDER_TYPES = ['other', 'open folder', 'closed folder', 'bounding section divider'];
	
	    function NestedSectionDivider(layer, length) {
	      NestedSectionDivider.__super__.constructor.call(this, layer, length);
	      this.isFolder = false;
	      this.isHidden = false;
	      this.layerType = null;
	      this.blendMode = null;
	      this.subType = null;
	    }
	
	    NestedSectionDivider.prototype.parse = function() {
	      var code;
	      code = this.file.readInt();
	      this.layerType = SECTION_DIVIDER_TYPES[code];
	      switch (code) {
	        case 1:
	        case 2:
	          this.isFolder = true;
	          break;
	        case 3:
	          this.isHidden = true;
	      }
	      if (!(this.length >= 12)) {
	        return;
	      }
	      this.file.seek(4, true);
	      this.blendMode = this.file.readString(4);
	      if (!(this.length >= 16)) {
	        return;
	      }
	      return this.subType = this.file.readInt() === 0 ? 'normal' : 'scene group';
	    };
	
	    return NestedSectionDivider;
	
	  })(LayerInfo);
	
	}).call(this);


/***/ },
/* 103 */
/***/ function(module, exports, __webpack_require__) {

	// Generated by CoffeeScript 1.11.1
	(function() {
	  var Descriptor, LayerInfo, SolidColor,
	    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
	    hasProp = {}.hasOwnProperty;
	
	  LayerInfo = __webpack_require__(87);
	
	  Descriptor = __webpack_require__(66);
	
	  module.exports = SolidColor = (function(superClass) {
	    extend(SolidColor, superClass);
	
	    SolidColor.shouldParse = function(key) {
	      return key === 'SoCo';
	    };
	
	    function SolidColor(layer, length) {
	      SolidColor.__super__.constructor.call(this, layer, length);
	      this.r = this.g = this.b = 0;
	    }
	
	    SolidColor.prototype.parse = function() {
	      this.file.seek(4, true);
	      this.data = new Descriptor(this.file).parse();
	      this.r = Math.round(this.colorData()['Rd  ']);
	      this.g = Math.round(this.colorData()['Grn ']);
	      return this.b = Math.round(this.colorData()['Bl  ']);
	    };
	
	    SolidColor.prototype.colorData = function() {
	      return this.data['Clr '];
	    };
	
	    SolidColor.prototype.color = function() {
	      return [this.r, this.g, this.b];
	    };
	
	    return SolidColor;
	
	  })(LayerInfo);
	
	}).call(this);


/***/ },
/* 104 */
/***/ function(module, exports, __webpack_require__) {

	// Generated by CoffeeScript 1.11.1
	(function() {
	  var LayerInfo, PathRecord, VectorMask,
	    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
	    hasProp = {}.hasOwnProperty;
	
	  LayerInfo = __webpack_require__(87);
	
	  PathRecord = __webpack_require__(74);
	
	  module.exports = VectorMask = (function(superClass) {
	    extend(VectorMask, superClass);
	
	    VectorMask.shouldParse = function(key) {
	      return key === 'vmsk' || key === 'vsms';
	    };
	
	    function VectorMask(layer, length) {
	      VectorMask.__super__.constructor.call(this, layer, length);
	      this.invert = null;
	      this.notLink = null;
	      this.disable = null;
	      this.paths = [];
	    }
	
	    VectorMask.prototype.parse = function() {
	      var i, j, numRecords, record, ref, results, tag;
	      this.file.seek(4, true);
	      tag = this.file.readInt();
	      this.invert = (tag & 0x01) > 0;
	      this.notLink = (tag & (0x01 << 1)) > 0;
	      this.disable = (tag & (0x01 << 2)) > 0;
	      numRecords = (this.length - 10) / 26;
	      results = [];
	      for (i = j = 0, ref = numRecords; 0 <= ref ? j < ref : j > ref; i = 0 <= ref ? ++j : --j) {
	        record = new PathRecord(this.file);
	        record.parse();
	        results.push(this.paths.push(record));
	      }
	      return results;
	    };
	
	    VectorMask.prototype["export"] = function() {
	      return {
	        invert: this.invert,
	        notLink: this.notLink,
	        disable: this.disable,
	        paths: this.paths.map(function(p) {
	          return p["export"]();
	        })
	      };
	    };
	
	    return VectorMask;
	
	  })(LayerInfo);
	
	}).call(this);


/***/ },
/* 105 */
/***/ function(module, exports, __webpack_require__) {

	// Generated by CoffeeScript 1.11.1
	(function() {
	  var Descriptor, LayerInfo, VectorOrigination,
	    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
	    hasProp = {}.hasOwnProperty;
	
	  LayerInfo = __webpack_require__(87);
	
	  Descriptor = __webpack_require__(66);
	
	  module.exports = VectorOrigination = (function(superClass) {
	    extend(VectorOrigination, superClass);
	
	    function VectorOrigination() {
	      return VectorOrigination.__super__.constructor.apply(this, arguments);
	    }
	
	    VectorOrigination.shouldParse = function(key) {
	      return key === 'vogk';
	    };
	
	    VectorOrigination.prototype.parse = function() {
	      this.file.seek(8, true);
	      return this.data = new Descriptor(this.file).parse();
	    };
	
	    return VectorOrigination;
	
	  })(LayerInfo);
	
	}).call(this);


/***/ },
/* 106 */
/***/ function(module, exports, __webpack_require__) {

	// Generated by CoffeeScript 1.11.1
	(function() {
	  var Descriptor, LayerInfo, VectorStroke,
	    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
	    hasProp = {}.hasOwnProperty;
	
	  LayerInfo = __webpack_require__(87);
	
	  Descriptor = __webpack_require__(66);
	
	  module.exports = VectorStroke = (function(superClass) {
	    extend(VectorStroke, superClass);
	
	    function VectorStroke() {
	      return VectorStroke.__super__.constructor.apply(this, arguments);
	    }
	
	    VectorStroke.shouldParse = function(key) {
	      return key === 'vstk';
	    };
	
	    VectorStroke.prototype.parse = function() {
	      this.file.seek(4, true);
	      return this.data = new Descriptor(this.file).parse();
	    };
	
	    return VectorStroke;
	
	  })(LayerInfo);
	
	}).call(this);


/***/ },
/* 107 */
/***/ function(module, exports, __webpack_require__) {

	// Generated by CoffeeScript 1.11.1
	(function() {
	  var Descriptor, LayerInfo, VectorStrokeContent,
	    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
	    hasProp = {}.hasOwnProperty;
	
	  LayerInfo = __webpack_require__(87);
	
	  Descriptor = __webpack_require__(66);
	
	  module.exports = VectorStrokeContent = (function(superClass) {
	    extend(VectorStrokeContent, superClass);
	
	    function VectorStrokeContent() {
	      return VectorStrokeContent.__super__.constructor.apply(this, arguments);
	    }
	
	    VectorStrokeContent.shouldParse = function(key) {
	      return key === 'vscg';
	    };
	
	    VectorStrokeContent.prototype.parse = function() {
	      this.file.seek(8, true);
	      return this.data = new Descriptor(this.file).parse();
	    };
	
	    return VectorStrokeContent;
	
	  })(LayerInfo);
	
	}).call(this);


/***/ },
/* 108 */
/***/ function(module, exports, __webpack_require__) {

	// Generated by CoffeeScript 1.11.1
	(function() {
	  var Descriptor, LayerInfo, UnicodeName, Util,
	    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
	    hasProp = {}.hasOwnProperty;
	
	  LayerInfo = __webpack_require__(87);
	
	  Util = __webpack_require__(57);
	
	  Descriptor = __webpack_require__(66);
	
	  module.exports = UnicodeName = (function(superClass) {
	    extend(UnicodeName, superClass);
	
	    UnicodeName.shouldParse = function(key) {
	      return key === 'PlLd';
	    };
	
	    function UnicodeName(layer, length) {
	      UnicodeName.__super__.constructor.call(this, layer, length);
	      this.Trnf = [];
	    }
	
	    UnicodeName.prototype.parse = function() {
	      var len;
	      this.identifier = this.file.readString();
	      this.version = this.file.readInt();
	      len = Util.pad2(this.file.readByte());
	      this.Idnt = this.file.readString(len);
	      this.PgNm = this.file.parseInt();
	      this.totalPages = this.file.parseInt();
	      this.Annt = this.file.readInt();
	      this.Type = this.file.readInt();
	      this.parseTransformInfo();
	      this.warpValue = this.file.readInt();
	      this.file.seek(4, true);
	      this.warpData = new Descriptor(this.file).parse();
	      return this;
	    };
	
	    UnicodeName.prototype.parseTransformInfo = function() {
	      var count, i, j, ref, results;
	      count = 8;
	      results = [];
	      for (i = j = 0, ref = count; 0 <= ref ? j < ref : j > ref; i = 0 <= ref ? ++j : --j) {
	        results.push(this.Trnf.push(this.file.readDouble()));
	      }
	      return results;
	    };
	
	    return UnicodeName;
	
	  })(LayerInfo);
	
	}).call(this);


/***/ },
/* 109 */
/***/ function(module, exports, __webpack_require__) {

	// Generated by CoffeeScript 1.11.1
	(function() {
	  var Descriptor, LayerInfo, LinkedLayer, Util,
	    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
	    hasProp = {}.hasOwnProperty;
	
	  LayerInfo = __webpack_require__(87);
	
	  Descriptor = __webpack_require__(66);
	
	  Util = __webpack_require__(57);
	
	  module.exports = LinkedLayer = (function(superClass) {
	    extend(LinkedLayer, superClass);
	
	    LinkedLayer.shouldParse = function(key) {
	      return key === 'lnk2';
	    };
	
	    function LinkedLayer(layer, length) {
	      LinkedLayer.__super__.constructor.call(this, layer, length);
	    }
	
	    LinkedLayer.prototype.parse = function() {
	      var creator, end, fileEnd, kind, length, obj, version;
	      end = this.file.tell() + this.length;
	      this.files = [];
	      while (this.file.tell() < end) {
	        obj = {};
	        this.file.seek(4, true);
	        length = 1 + Util.pad4(this.file.readInt());
	        fileEnd = length + this.file.tell();
	        kind = this.file.readString(4);
	        version = this.file.readInt();
	        obj.uuid = this.file.readString(this.file.readByte());
	        obj.fileName = this.file.readUnicodeString();
	        obj.fileType = this.file.readString(4);
	        creator = this.file.readString(4);
	        this.file.seek(4, true);
	        obj.datasize = this.file.readInt();
	        obj.openFile = this.file.readBoolean();
	        if (obj.openFile === true) {
	          this.file.seek(4, true);
	          obj.openFile = new Descriptor(this.file).parse();
	        }
	        if (kind === 'liFD') {
	          obj.fileData = this.file.read(obj.datasize);
	        }
	        if (version >= 5) {
	          obj.childId = this.file.readUnicodeString();
	        }
	        if (version >= 6) {
	          obj.modTime = this.file.readDouble();
	        }
	        if (version >= 7) {
	          obj.lockedState = this.file.readBoolean();
	        }
	        this.files.push(obj);
	        this.file.seek(fileEnd);
	      }
	      this.file.seek(end);
	      return this.files;
	    };
	
	    return LinkedLayer;
	
	  })(LayerInfo);
	
	}).call(this);


/***/ },
/* 110 */
/***/ function(module, exports, __webpack_require__) {

	// Generated by CoffeeScript 1.11.1
	(function() {
	  var Descriptor, LayerInfo, SmartObject,
	    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
	    hasProp = {}.hasOwnProperty;
	
	  LayerInfo = __webpack_require__(87);
	
	  Descriptor = __webpack_require__(66);
	
	  module.exports = SmartObject = (function(superClass) {
	    extend(SmartObject, superClass);
	
	    SmartObject.shouldParse = function(key) {
	      return key === 'SoLd';
	    };
	
	    function SmartObject(layer, length) {
	      SmartObject.__super__.constructor.call(this, layer, length);
	    }
	
	    SmartObject.prototype.parse = function() {
	      this.identifier = this.file.readString();
	      this.version = this.file.readInt();
	      this.file.seek(4, true);
	      this.data = new Descriptor(this.file).parse();
	      return this;
	    };
	
	    return SmartObject;
	
	  })(LayerInfo);
	
	}).call(this);


/***/ },
/* 111 */
/***/ function(module, exports) {

	// Generated by CoffeeScript 1.11.1
	(function() {
	  module.exports = {
	    isFolder: function() {
	      if (this.adjustments['sectionDivider'] != null) {
	        return this.adjustments['sectionDivider'].isFolder;
	      } else if (this.adjustments['nestedSectionDivider'] != null) {
	        return this.adjustments['nestedSectionDivider'].isFolder;
	      } else {
	        return this.name === "<Layer group>";
	      }
	    },
	    isFolderEnd: function() {
	      if (this.adjustments['sectionDivider'] != null) {
	        return this.adjustments['sectionDivider'].isHidden;
	      } else if (this.adjustments['nestedSectionDivider'] != null) {
	        return this.adjustments['nestedSectionDivider'].isHidden;
	      } else {
	        return this.name === "</Layer group>";
	      }
	    }
	  };
	
	}).call(this);


/***/ },
/* 112 */
/***/ function(module, exports, __webpack_require__) {

	// Generated by CoffeeScript 1.11.1
	(function() {
	  var ChannelImage, LazyExecute;
	
	  ChannelImage = __webpack_require__(113);
	
	  LazyExecute = __webpack_require__(58);
	
	  module.exports = {
	    parseChannelImage: function() {
	      var image;
	      image = new ChannelImage(this.file, this.header, this);
	      return this.image = new LazyExecute(image, this.file).now('skip').later('parse').get();
	    }
	  };
	
	}).call(this);


/***/ },
/* 113 */
/***/ function(module, exports, __webpack_require__) {

	// Generated by CoffeeScript 1.11.1
	(function() {
	  var ChannelImage, Image, ImageFormat, _,
	    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
	    hasProp = {}.hasOwnProperty;
	
	  _ = __webpack_require__(63);
	
	  Image = __webpack_require__(114);
	
	  ImageFormat = __webpack_require__(115);
	
	  module.exports = ChannelImage = (function(superClass) {
	    extend(ChannelImage, superClass);
	
	    ChannelImage.includes(ImageFormat.LayerRAW);
	
	    ChannelImage.includes(ImageFormat.LayerRLE);
	
	    function ChannelImage(file, header, layer) {
	      this.layer = layer;
	      this._width = this.layer.width;
	      this._height = this.layer.height;
	      ChannelImage.__super__.constructor.call(this, file, header);
	      this.channelsInfo = this.layer.channelsInfo;
	      this.hasMask = _.some(this.channelsInfo, function(c) {
	        return c.id < -1;
	      });
	      this.opacity = this.layer.opacity / 255.0;
	    }
	
	    ChannelImage.prototype.skip = function() {
	      var chan, i, len, ref, results;
	      ref = this.channelsInfo;
	      results = [];
	      for (i = 0, len = ref.length; i < len; i++) {
	        chan = ref[i];
	        results.push(this.file.seek(chan.length, true));
	      }
	      return results;
	    };
	
	    ChannelImage.prototype.width = function() {
	      return this._width;
	    };
	
	    ChannelImage.prototype.height = function() {
	      return this._height;
	    };
	
	    ChannelImage.prototype.channels = function() {
	      return this.layer.channels;
	    };
	
	    ChannelImage.prototype.parse = function() {
	      var chan, finish, i, len, ref, start;
	      this.chanPos = 0;
	      ref = this.channelsInfo;
	      for (i = 0, len = ref.length; i < len; i++) {
	        chan = ref[i];
	        if (chan.length <= 0) {
	          this.parseCompression();
	          continue;
	        }
	        this.chan = chan;
	        if (chan.id < -1) {
	          this._width = this.layer.mask.width;
	          this._height = this.layer.mask.height;
	        } else {
	          this._width = this.layer.width;
	          this._height = this.layer.height;
	        }
	        this.length = this._width * this._height;
	        start = this.file.tell();
	        this.parseImageData();
	        finish = this.file.tell();
	        if (finish !== start + this.chan.length) {
	          this.file.seek(start + this.chan.length);
	        }
	      }
	      this._width = this.layer.width;
	      this._height = this.layer.height;
	      return this.processImageData();
	    };
	
	    ChannelImage.prototype.parseImageData = function() {
	      this.compression = this.parseCompression();
	      switch (this.compression) {
	        case 0:
	          return this.parseRaw();
	        case 1:
	          return this.parseRLE();
	        case 2:
	        case 3:
	          return this.parseZip();
	        default:
	          return this.file.seek(this.endPos);
	      }
	    };
	
	    return ChannelImage;
	
	  })(Image);
	
	}).call(this);


/***/ },
/* 114 */
/***/ function(module, exports, __webpack_require__) {

	// Generated by CoffeeScript 1.11.1
	(function() {
	  var Export, Image, ImageFormat, ImageMode, Module,
	    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
	    hasProp = {}.hasOwnProperty;
	
	  Module = __webpack_require__(6).Module;
	
	  ImageFormat = __webpack_require__(115);
	
	  ImageMode = __webpack_require__(120);
	
	  Export = __webpack_require__(124);
	
	  module.exports = Image = (function(superClass) {
	    var COMPRESSIONS, attr, fn, i, len, ref;
	
	    extend(Image, superClass);
	
	    Image.includes(ImageFormat.RAW);
	
	    Image.includes(ImageFormat.RLE);
	
	    Image.includes(ImageMode.Greyscale);
	
	    Image.includes(ImageMode.RGB);
	
	    Image.includes(ImageMode.CMYK);
	
	    Image.includes(Export.PNG);
	
	    COMPRESSIONS = ['Raw', 'RLE', 'ZIP', 'ZIPPrediction'];
	
	    function Image(file, header) {
	      this.file = file;
	      this.header = header;
	      this.numPixels = this.width() * this.height();
	      if (this.depth() === 16) {
	        this.numPixels *= 2;
	      }
	      this.calculateLength();
	      this.pixelData = new Uint8Array(this.channelLength * 4);
	      this.maskData = new Uint8Array(this.maskLength * 4);
	      this.channelData = new Uint8Array(this.length + this.maskLength);
	      this.opacity = 1.0;
	      this.hasMask = false;
	      this.startPos = this.file.tell();
	      this.endPos = this.startPos + this.length;
	      this.setChannelsInfo();
	    }
	
	    ref = ['width', 'height', 'channels', 'depth', 'mode'];
	    fn = function(attr) {
	      return Image.prototype[attr] = function() {
	        return this.header[attr];
	      };
	    };
	    for (i = 0, len = ref.length; i < len; i++) {
	      attr = ref[i];
	      fn(attr);
	    }
	
	    Image.prototype.setChannelsInfo = function() {
	      switch (this.mode()) {
	        case 1:
	          return this.setGreyscaleChannels();
	        case 3:
	          return this.setRgbChannels();
	        case 4:
	          return this.setCmykChannels();
	      }
	    };
	
	    Image.prototype.calculateLength = function() {
	      this.length = (function() {
	        switch (this.depth()) {
	          case 1:
	            return (this.width() + 7) / 8 * this.height();
	          case 16:
	            return this.width() * this.height() * 2;
	          default:
	            return this.width() * this.height();
	        }
	      }).call(this);
	      this.channelLength = this.length;
	      this.length *= this.channels();
	      if (this.layer && this.layer.mask.size) {
	        return this.maskLength = this.layer.mask.width * this.layer.mask.height;
	      } else {
	        return this.maskLength = 0;
	      }
	    };
	
	    Image.prototype.parse = function() {
	      var ref1;
	      this.compression = this.parseCompression();
	      if ((ref1 = this.compression) === 2 || ref1 === 3) {
	        this.file.seek(this.endPos);
	        return;
	      }
	      return this.parseImageData();
	    };
	
	    Image.prototype.parseCompression = function() {
	      return this.file.readShort();
	    };
	
	    Image.prototype.parseImageData = function() {
	      switch (this.compression) {
	        case 0:
	          this.parseRaw();
	          break;
	        case 1:
	          this.parseRLE();
	          break;
	        case 2:
	        case 3:
	          this.parseZip();
	          break;
	        default:
	          this.file.seek(this.endPos);
	      }
	      return this.processImageData();
	    };
	
	    Image.prototype.processImageData = function() {
	      switch (this.mode()) {
	        case 1:
	          this.combineGreyscaleChannel();
	          break;
	        case 3:
	          this.combineRgbChannel();
	          break;
	        case 4:
	          this.combineCmykChannel();
	      }
	      return this.channelData = null;
	    };
	
	    return Image;
	
	  })(Module);
	
	}).call(this);


/***/ },
/* 115 */
/***/ function(module, exports, __webpack_require__) {

	// Generated by CoffeeScript 1.11.1
	(function() {
	  module.exports = {
	    RAW: __webpack_require__(116),
	    RLE: __webpack_require__(117),
	    LayerRLE: __webpack_require__(118),
	    LayerRAW: __webpack_require__(119)
	  };
	
	}).call(this);


/***/ },
/* 116 */
/***/ function(module, exports) {

	// Generated by CoffeeScript 1.11.1
	(function() {
	  module.exports = {
	    parseRaw: function() {
	      return this.channelData.set(this.file.read(this.length));
	    }
	  };
	
	}).call(this);


/***/ },
/* 117 */
/***/ function(module, exports) {

	// Generated by CoffeeScript 1.11.1
	(function() {
	  module.exports = {
	    parseRLE: function() {
	      this.byteCounts = this.parseByteCounts();
	      return this.parseChannelData();
	    },
	    parseByteCounts: function() {
	      var i, k, ref, results;
	      results = [];
	      for (i = k = 0, ref = this.channels() * this.height(); 0 <= ref ? k < ref : k > ref; i = 0 <= ref ? ++k : --k) {
	        if (this.header.version === 1) {
	          results.push(this.file.readShort());
	        } else {
	          results.push(this.file.readInt());
	        }
	      }
	      return results;
	    },
	    parseChannelData: function() {
	      var i, k, ref, results;
	      this.chanPos = 0;
	      this.lineIndex = 0;
	      results = [];
	      for (i = k = 0, ref = this.channels(); 0 <= ref ? k < ref : k > ref; i = 0 <= ref ? ++k : --k) {
	        this.decodeRLEChannel();
	        results.push(this.lineIndex += this.height());
	      }
	      return results;
	    },
	    decodeRLEChannel: function() {
	      var byteCount, data, finish, j, k, len, ref, results, val;
	      results = [];
	      for (j = k = 0, ref = this.height(); 0 <= ref ? k < ref : k > ref; j = 0 <= ref ? ++k : --k) {
	        byteCount = this.byteCounts[this.lineIndex + j];
	        finish = this.file.tell() + byteCount;
	        results.push((function() {
	          var results1;
	          results1 = [];
	          while (this.file.tell() < finish) {
	            len = this.file.read(1)[0];
	            if (len < 128) {
	              len += 1;
	              data = this.file.read(len);
	              this.channelData.set(data, this.chanPos);
	              results1.push(this.chanPos += len);
	            } else if (len > 128) {
	              len ^= 0xff;
	              len += 2;
	              val = this.file.read(1)[0];
	              this.channelData.fill(val, this.chanPos, this.chanPos + len);
	              results1.push(this.chanPos += len);
	            } else {
	              results1.push(void 0);
	            }
	          }
	          return results1;
	        }).call(this));
	      }
	      return results;
	    }
	  };
	
	}).call(this);


/***/ },
/* 118 */
/***/ function(module, exports) {

	// Generated by CoffeeScript 1.11.1
	(function() {
	  module.exports = {
	    parseByteCounts: function() {
	      var i, j, ref, results;
	      results = [];
	      for (i = j = 0, ref = this.height(); 0 <= ref ? j < ref : j > ref; i = 0 <= ref ? ++j : --j) {
	        if (this.header.version === 1) {
	          results.push(this.file.readShort());
	        } else {
	          results.push(this.file.readInt());
	        }
	      }
	      return results;
	    },
	    parseChannelData: function() {
	      this.lineIndex = 0;
	      return this.decodeRLEChannel();
	    }
	  };
	
	}).call(this);


/***/ },
/* 119 */
/***/ function(module, exports) {

	// Generated by CoffeeScript 1.11.1
	(function() {
	  module.exports = {
	    parseRaw: function() {
	      var i, j, ref, ref1;
	      for (i = j = ref = this.chanPos, ref1 = this.chanPos + this.chan.length - 2; ref <= ref1 ? j < ref1 : j > ref1; i = ref <= ref1 ? ++j : --j) {
	        this.channelData[i] = this.file.readByte();
	      }
	      return this.chanPos += this.chan.length - 2;
	    }
	  };
	
	}).call(this);


/***/ },
/* 120 */
/***/ function(module, exports, __webpack_require__) {

	// Generated by CoffeeScript 1.11.1
	(function() {
	  module.exports = {
	    Greyscale: __webpack_require__(121),
	    RGB: __webpack_require__(122),
	    CMYK: __webpack_require__(123)
	  };
	
	}).call(this);


/***/ },
/* 121 */
/***/ function(module, exports) {

	// Generated by CoffeeScript 1.11.1
	(function() {
	  module.exports = {
	    setGreyscaleChannels: function() {
	      this.channelsInfo = [
	        {
	          id: 0
	        }
	      ];
	      if (this.channels() === 2) {
	        return this.channelsInfo.push({
	          id: -1
	        });
	      }
	    },
	    combineGreyscaleChannel: function() {
	      var alpha, grey, i, j, ref, results;
	      results = [];
	      for (i = j = 0, ref = this.numPixels; 0 <= ref ? j < ref : j > ref; i = 0 <= ref ? ++j : --j) {
	        grey = this.channelData[i];
	        alpha = this.channels() === 2 ? this.channelData[this.channelLength + i] : 255;
	        results.push(this.pixelData.set([grey, grey, grey, alpha], i * 4));
	      }
	      return results;
	    }
	  };
	
	}).call(this);


/***/ },
/* 122 */
/***/ function(module, exports) {

	// Generated by CoffeeScript 1.11.1
	(function() {
	  module.exports = {
	    setRgbChannels: function() {
	      this.channelsInfo = [
	        {
	          id: 0
	        }, {
	          id: 1
	        }, {
	          id: 2
	        }
	      ];
	      if (this.channels() === 4) {
	        return this.channelsInfo.push({
	          id: -1
	        });
	      }
	    },
	    combineRgbChannel: function() {
	      var a, b, chan, g, i, index, j, k, len, r, ref, rgbChannels, val;
	      rgbChannels = this.channelsInfo.map(function(ch) {
	        return ch.id;
	      }).filter(function(ch) {
	        return ch >= -1;
	      });
	      for (i = j = 0, ref = this.numPixels; 0 <= ref ? j < ref : j > ref; i = 0 <= ref ? ++j : --j) {
	        r = g = b = 0;
	        a = 255;
	        for (index = k = 0, len = rgbChannels.length; k < len; index = ++k) {
	          chan = rgbChannels[index];
	          val = this.channelData[i + (this.channelLength * index)];
	          switch (chan) {
	            case -1:
	              a = val;
	              break;
	            case 0:
	              r = val;
	              break;
	            case 1:
	              g = val;
	              break;
	            case 2:
	              b = val;
	          }
	        }
	        this.pixelData.set([r, g, b, a], i * 4);
	      }
	      return this.readMaskData(rgbChannels);
	    },
	    readMaskData: function(rgbChannels) {
	      var i, j, maskPixels, offset, ref, results, val;
	      if (this.hasMask) {
	        maskPixels = this.layer.mask.width * this.layer.mask.height;
	        offset = this.channelLength * rgbChannels.length;
	        results = [];
	        for (i = j = 0, ref = maskPixels; 0 <= ref ? j < ref : j > ref; i = 0 <= ref ? ++j : --j) {
	          val = this.channelData[i + offset];
	          results.push(this.maskData.set([0, 0, 0, val], i * 4));
	        }
	        return results;
	      }
	    }
	  };
	
	}).call(this);


/***/ },
/* 123 */
/***/ function(module, exports, __webpack_require__) {

	// Generated by CoffeeScript 1.11.1
	(function() {
	  var Color;
	
	  Color = __webpack_require__(56);
	
	  module.exports = {
	    setCmykChannels: function() {
	      this.channelsInfo = [
	        {
	          id: 0
	        }, {
	          id: 1
	        }, {
	          id: 2
	        }, {
	          id: 3
	        }
	      ];
	      if (this.channels() === 5) {
	        return this.channelsInfo.push({
	          id: -1
	        });
	      }
	    },
	    combineCmykChannel: function() {
	      var a, b, c, chan, cmykChannels, g, i, index, j, k, l, len, m, r, ref, ref1, val, y;
	      cmykChannels = this.channelsInfo.map(function(ch) {
	        return ch.id;
	      }).filter(function(ch) {
	        return ch >= -1;
	      });
	      for (i = j = 0, ref = this.numPixels; 0 <= ref ? j < ref : j > ref; i = 0 <= ref ? ++j : --j) {
	        c = m = y = k = 0;
	        a = 255;
	        for (index = l = 0, len = cmykChannels.length; l < len; index = ++l) {
	          chan = cmykChannels[index];
	          val = this.channelData[i + (this.channelLength * index)];
	          switch (chan) {
	            case -1:
	              a = val;
	              break;
	            case 0:
	              c = val;
	              break;
	            case 1:
	              m = val;
	              break;
	            case 2:
	              y = val;
	              break;
	            case 3:
	              k = val;
	          }
	        }
	        ref1 = Color.cmykToRgb(255 - c, 255 - m, 255 - y, 255 - k), r = ref1[0], g = ref1[1], b = ref1[2];
	        this.pixelData.set([r, g, b, a], i * 4);
	      }
	      return this.readMaskData(cmykChannels);
	    }
	  };
	
	}).call(this);


/***/ },
/* 124 */
/***/ function(module, exports, __webpack_require__) {

	// Generated by CoffeeScript 1.11.1
	(function() {
	  module.exports = {
	    PNG: __webpack_require__(125)
	  };
	
	}).call(this);


/***/ },
/* 125 */
/***/ function(module, exports, __webpack_require__) {

	// Generated by CoffeeScript 1.11.1
	(function() {
	  var RSVP;
	
	  RSVP = __webpack_require__(2);
	
	  module.exports = {
	    toBase64: function() {
	      var canvas, context, i, imageData, j, len, pixel, pixelData, ref;
	      canvas = document.createElement('canvas');
	      canvas.width = this.width();
	      canvas.height = this.height();
	      context = canvas.getContext('2d');
	      imageData = context.getImageData(0, 0, this.width(), this.height());
	      pixelData = imageData.data;
	      ref = this.pixelData;
	      for (i = j = 0, len = ref.length; j < len; i = ++j) {
	        pixel = ref[i];
	        pixelData[i] = pixel;
	      }
	      context.putImageData(imageData, 0, 0);
	      return canvas.toDataURL('image/png');
	    },
	    toPng: function() {
	      var dataUrl, image;
	      dataUrl = this.toBase64();
	      image = new Image();
	      image.width = this.width();
	      image.height = this.height();
	      image.src = dataUrl;
	      return image;
	    },
	    saveAsPng: function() {
	      throw "Not available in the browser. Use toPng() instead.";
	    }
	  };
	
	}).call(this);


/***/ },
/* 126 */
/***/ function(module, exports, __webpack_require__) {

	// Generated by CoffeeScript 1.11.1
	(function() {
	  var Descriptor, LayerInfo, UnicodePath,
	    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
	    hasProp = {}.hasOwnProperty;
	
	  LayerInfo = __webpack_require__(87);
	
	  Descriptor = __webpack_require__(66);
	
	  module.exports = UnicodePath = (function(superClass) {
	    extend(UnicodePath, superClass);
	
	    function UnicodePath() {
	      return UnicodePath.__super__.constructor.apply(this, arguments);
	    }
	
	    UnicodePath.shouldParse = function(key) {
	      return key === 'pths';
	    };
	
	    UnicodePath.prototype.parse = function() {
	      this.file.seek(4);
	      this.data = new Descriptor(this.file).parse();
	      return this;
	    };
	
	    return UnicodePath;
	
	  })(LayerInfo);
	
	}).call(this);


/***/ },
/* 127 */
/***/ function(module, exports, __webpack_require__) {

	// Generated by CoffeeScript 1.11.1
	(function() {
	  var LayerInfo, TextEngineData, parseEngineData,
	    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
	    hasProp = {}.hasOwnProperty;
	
	  LayerInfo = __webpack_require__(87);
	
	  parseEngineData = __webpack_require__(128);
	
	  module.exports = TextEngineData = (function(superClass) {
	    extend(TextEngineData, superClass);
	
	    TextEngineData.shouldParse = function(key) {
	      return key === 'Txt2';
	    };
	
	    function TextEngineData(layer, length) {
	      TextEngineData.__super__.constructor.call(this, layer, length);
	      this.textEngineData = null;
	    }
	
	    TextEngineData.prototype.parse = function() {
	      var data;
	      data = this.file.read(this.length);
	      return this.textEngineData = parseEngineData(data);
	    };
	
	    TextEngineData.prototype["export"] = function() {
	      return {
	        textEngineData: this.textEngineData
	      };
	    };
	
	    return TextEngineData;
	
	  })(LayerInfo);
	
	}).call(this);


/***/ },
/* 128 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {// Generated by CoffeeScript 1.11.1
	(function() {
	  var MATCH_TYPE, Match, boolean, codeToString, hashEnd, hashStart, iconv, index, multiLineArrayEnd, multiLineArrayStart, number, numberWithDecimal, originText, parseEngineData, parseToken, property, string, unknownTag;
	
	  iconv = __webpack_require__(15);
	
	  index = 0;
	
	  originText = '';
	
	  parseEngineData = function(engineData) {
	    var result;
	    originText = codeToString(engineData);
	    result = hashStart(originText).parse();
	    return result;
	  };
	
	  codeToString = function(engineData) {
	    return String.fromCharCode.apply(null, engineData);
	  };
	
	  Match = function(reg, text) {
	    return reg.test(text);
	  };
	
	  hashStart = function(text) {
	    var reg;
	    reg = /^<<$/;
	    return {
	      type: 'hashStart',
	      match: Match(reg, text),
	      parse: function() {
	        var kParser, kResult, key, obj, vParser, vResult, value;
	        obj = {};
	        while (index < originText.length) {
	          kResult = parseToken(originText.substring(index));
	          kParser = kResult.parser;
	          key = '';
	          value = '';
	          if (kParser.type === 'property') {
	            key = kParser.parse();
	            vResult = parseToken(originText.substring(index));
	            vParser = vResult.parser;
	            if (vParser.type === 'multiLineArrayStart' || vParser.type === 'hashStart') {
	              value = vParser.parse(originText.substring(index));
	            } else if (vParser) {
	              value = vParser.parse();
	            }
	            obj[key] = value;
	          } else if (kParser.type === 'hashEnd') {
	            break;
	          }
	        }
	        return obj;
	      }
	    };
	  };
	
	  hashEnd = function(text) {
	    var reg;
	    reg = /^>>(\x00)*$/;
	    return {
	      type: 'hashEnd',
	      match: Match(reg, text)
	    };
	  };
	
	  multiLineArrayStart = function(text) {
	    var reg;
	    reg = /^\[$/;
	    return {
	      type: 'multiLineArrayStart',
	      match: Match(reg, text),
	      parse: function() {
	        var dataArray, vParser, vResult, value;
	        dataArray = [];
	        while (index < originText.length) {
	          vResult = parseToken(originText.substring(index));
	          vParser = vResult.parser;
	          value = '';
	          if (vParser.type === 'multiLineArrayEnd') {
	            break;
	          }
	          if (vParser.type === 'multiLineArrayStart' || vParser.type === 'hashStart') {
	            value = vParser.parse(originText.substring(index));
	          } else if (vParser) {
	            value = vParser.parse();
	          }
	          dataArray.push(value);
	        }
	        return dataArray;
	      }
	    };
	  };
	
	  multiLineArrayEnd = function(text) {
	    var reg;
	    reg = /^\]$/;
	    return {
	      type: 'multiLineArrayEnd',
	      match: Match(reg, text)
	    };
	  };
	
	  property = function(text) {
	    var reg;
	    reg = /^\/([a-zA-Z0-9]+)$/i;
	    return {
	      type: 'property',
	      match: Match(reg, text),
	      parse: function() {
	        return text.match(reg)[1];
	      }
	    };
	  };
	
	  boolean = function(text) {
	    var reg;
	    reg = /^(true|false)$/;
	    return {
	      type: 'boolean',
	      match: Match(reg, text),
	      parse: function() {
	        if (text === 'true') {
	          return true;
	        } else {
	          return false;
	        }
	      }
	    };
	  };
	
	  number = function(text) {
	    var reg;
	    reg = /^-?\d+$/;
	    return {
	      type: 'number',
	      match: Match(reg, text),
	      parse: function() {
	        return Number(text);
	      }
	    };
	  };
	
	  numberWithDecimal = function(text) {
	    var reg;
	    reg = /^(-?\d*)\.(\d+)$/;
	    return {
	      type: 'numberWithDecimal',
	      match: Match(reg, text),
	      parse: function() {
	        return Number(text);
	      }
	    };
	  };
	
	  unknownTag = function(text) {
	    var reg;
	    reg = /^\([a-zA-Z0-9]*\)$/;
	    return {
	      type: 'unknownTag',
	      match: Match(reg, text),
	      parse: function() {
	        return text;
	      }
	    };
	  };
	
	  string = function(text) {
	    var reg;
	    reg = /^\((\xfe\xff([^\)]|\\\))*)\)$/;
	    return {
	      name: 'string',
	      match: Match(reg, text),
	      parse: function() {
	        var bf, i, l, txt;
	        txt = text.match(reg)[1];
	        bf = [];
	        i = 0;
	        l = txt.length;
	        while (i < l) {
	          bf.push(txt.charCodeAt(i));
	          i++;
	        }
	        return iconv.decode(new Buffer(bf), 'utf-16');
	      }
	    };
	  };
	
	  MATCH_TYPE = [hashStart, hashEnd, multiLineArrayStart, multiLineArrayEnd, property, unknownTag, boolean, number, numberWithDecimal, string];
	
	  parseToken = function(text) {
	    var divider, getText, subIndex, utf16_end, utf16_start;
	    divider = /[ \n\t]+/;
	    utf16_start = /\(\xfe\xff/;
	    utf16_end = /[^\\]\)/;
	    subIndex = 0;
	    getText = function() {
	      var currentType, end, lastIndex, match, parser, start, subText, token;
	      subText = text.substring(subIndex);
	      token = '';
	      start = utf16_start.exec(subText);
	      if (start && start.index === 0) {
	        end = utf16_end.exec(subText);
	        if (end.index > 0) {
	          lastIndex = end.index + end[0].length;
	          token = subText.substring(0, lastIndex);
	          subIndex += lastIndex;
	        }
	      } else {
	        match = divider.exec(subText);
	        if (match) {
	          token = subText.substring(0, match.index);
	          subIndex = subIndex + match.index + match[0].length;
	          if (token === '') {
	            return getText();
	          }
	        } else {
	          token = subText.substring(subIndex);
	          index += subText.length;
	        }
	      }
	      index += subIndex;
	      for (currentType in MATCH_TYPE) {
	        parser = new MATCH_TYPE[currentType](token);
	        if (parser.match) {
	          return {
	            parser: parser,
	            token: token
	          };
	        }
	      }
	    };
	    return getText();
	  };
	
	  module.exports = parseEngineData;
	
	}).call(this);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(9).Buffer))

/***/ },
/* 129 */
/***/ function(module, exports, __webpack_require__) {

	// Generated by CoffeeScript 1.11.1
	(function() {
	  var FilterMask, LayerInfo,
	    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
	    hasProp = {}.hasOwnProperty;
	
	  LayerInfo = __webpack_require__(87);
	
	  module.exports = FilterMask = (function(superClass) {
	    extend(FilterMask, superClass);
	
	    FilterMask.shouldParse = function(key) {
	      return key === 'FMsk';
	    };
	
	    function FilterMask(layer, length) {
	      FilterMask.__super__.constructor.call(this, layer, length);
	    }
	
	    FilterMask.prototype.parse = function() {
	      this.color = this.file.readSpaceColor();
	      return this.opacity = this.file.readShort();
	    };
	
	    return FilterMask;
	
	  })(LayerInfo);
	
	}).call(this);


/***/ },
/* 130 */
/***/ function(module, exports, __webpack_require__) {

	// Generated by CoffeeScript 1.11.1
	(function() {
	  var Group, Layer, Node, Root, _,
	    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
	    hasProp = {}.hasOwnProperty;
	
	  _ = __webpack_require__(63);
	
	  Node = __webpack_require__(131);
	
	  Group = __webpack_require__(135);
	
	  Layer = __webpack_require__(136);
	
	  module.exports = Root = (function(superClass) {
	    extend(Root, superClass);
	
	    Root.layerForPsd = function(psd) {
	      var i, layer, len, prop, ref;
	      layer = {};
	      ref = Node.PROPERTIES;
	      for (i = 0, len = ref.length; i < len; i++) {
	        prop = ref[i];
	        layer[prop] = null;
	      }
	      layer.top = 0;
	      layer.left = 0;
	      layer.right = psd.header.width;
	      layer.bottom = psd.header.height;
	      return layer;
	    };
	
	    Root.prototype.type = 'root';
	
	    function Root(psd1) {
	      this.psd = psd1;
	      Root.__super__.constructor.call(this, Root.layerForPsd(this.psd));
	      this.buildHeirarchy();
	    }
	
	    Root.prototype.documentDimensions = function() {
	      return [this.width, this.height];
	    };
	
	    Root.prototype.depth = function() {
	      return 0;
	    };
	
	    Root.prototype.opacity = function() {
	      return 255;
	    };
	
	    Root.prototype.fillOpacity = function() {
	      return 255;
	    };
	
	    Root.prototype["export"] = function() {
	      var ref, ref1;
	      return {
	        children: this._children.map(function(c) {
	          return c["export"]();
	        }),
	        document: {
	          width: this.width,
	          height: this.height,
	          resources: {
	            layerComps: ((ref = this.psd.resources.resource('layerComps')) != null ? ref["export"]() : void 0) || [],
	            resolutionInfo: ((ref1 = this.psd.resources.resource('resolutionInfo')) != null ? ref1["export"]() : void 0) || [],
	            guides: [],
	            slices: []
	          }
	        }
	      };
	    };
	
	    Root.prototype.buildHeirarchy = function() {
	      var currentGroup, i, layer, len, parent, parseStack, ref;
	      currentGroup = this;
	      parseStack = [];
	      ref = this.psd.layers;
	      for (i = 0, len = ref.length; i < len; i++) {
	        layer = ref[i];
	        if (layer.isFolder()) {
	          parseStack.push(currentGroup);
	          currentGroup = new Group(layer, _.last(parseStack));
	        } else if (layer.isFolderEnd()) {
	          parent = parseStack.pop();
	          parent.children().push(currentGroup);
	          currentGroup = parent;
	        } else {
	          currentGroup.children().push(new Layer(layer, currentGroup));
	        }
	      }
	      return this.updateDimensions();
	    };
	
	    return Root;
	
	  })(Node);
	
	}).call(this);


/***/ },
/* 131 */
/***/ function(module, exports, __webpack_require__) {

	// Generated by CoffeeScript 1.11.1
	(function() {
	  var Module, Node, _,
	    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
	    hasProp = {}.hasOwnProperty;
	
	  _ = __webpack_require__(63);
	
	  Module = __webpack_require__(6).Module;
	
	  module.exports = Node = (function(superClass) {
	    extend(Node, superClass);
	
	    Node.includes(__webpack_require__(132));
	
	    Node.includes(__webpack_require__(133));
	
	    Node.includes(__webpack_require__(134));
	
	    Node.PROPERTIES = ['name', 'left', 'right', 'top', 'bottom', 'height', 'width'];
	
	    Node.prototype.type = 'node';
	
	    function Node(layer, parent) {
	      this.layer = layer;
	      this.parent = parent != null ? parent : null;
	      this.layer.node = this;
	      this._children = [];
	      this.name = this.layer.name;
	      this.forceVisible = null;
	      this.coords = {
	        top: this.layer.top,
	        bottom: this.layer.bottom,
	        left: this.layer.left,
	        right: this.layer.right
	      };
	      this.topOffset = 0;
	      this.leftOffset = 0;
	      this.createProperties();
	    }
	
	    Node.prototype.createProperties = function() {
	      Object.defineProperty(this, 'top', {
	        get: function() {
	          return this.coords.top + this.topOffset;
	        },
	        set: function(val) {
	          return this.coords.top = val;
	        }
	      });
	      Object.defineProperty(this, 'right', {
	        get: function() {
	          return this.coords.right + this.leftOffset;
	        },
	        set: function(val) {
	          return this.coords.right = val;
	        }
	      });
	      Object.defineProperty(this, 'bottom', {
	        get: function() {
	          return this.coords.bottom + this.topOffset;
	        },
	        set: function(val) {
	          return this.coords.bottom = val;
	        }
	      });
	      Object.defineProperty(this, 'left', {
	        get: function() {
	          return this.coords.left + this.leftOffset;
	        },
	        set: function(val) {
	          return this.coords.left = val;
	        }
	      });
	      Object.defineProperty(this, 'width', {
	        get: function() {
	          return this.right - this.left;
	        }
	      });
	      return Object.defineProperty(this, 'height', {
	        get: function() {
	          return this.bottom - this.top;
	        }
	      });
	    };
	
	    Node.prototype.get = function(prop) {
	      var value;
	      value = this[prop] != null ? this[prop] : this.layer[prop];
	      if (typeof value === 'function') {
	        return value();
	      } else {
	        return value;
	      }
	    };
	
	    Node.prototype.visible = function() {
	      if (this.layer.clipped && !this.clippingMask().visible()) {
	        return false;
	      }
	      if (this.forceVisible != null) {
	        return this.forceVisible;
	      } else {
	        return this.layer.visible;
	      }
	    };
	
	    Node.prototype.hidden = function() {
	      return !this.visible();
	    };
	
	    Node.prototype.isLayer = function() {
	      return this.type === 'layer';
	    };
	
	    Node.prototype.isGroup = function() {
	      return this.type === 'group';
	    };
	
	    Node.prototype.isRoot = function() {
	      return this.type === 'root';
	    };
	
	    Node.prototype.clippingMask = function() {
	      var maskNode;
	      if (!this.layer.clipped) {
	        return null;
	      }
	      return this.clippingMaskCached || (this.clippingMaskCached = ((function() {
	        maskNode = this.nextSibling();
	        while (maskNode.clipped) {
	          maskNode = maskNode.nextSibling();
	        }
	        return maskNode;
	      }).call(this)));
	    };
	
	    Node.prototype.clippedBy = function() {
	      return this.clippingMask();
	    };
	
	    Node.prototype["export"] = function() {
	      var hash, i, len, prop, ref;
	      hash = {
	        type: null,
	        visible: this.visible(),
	        opacity: this.layer.opacity / 255.0,
	        blendingMode: this.layer.blendingMode()
	      };
	      ref = Node.PROPERTIES;
	      for (i = 0, len = ref.length; i < len; i++) {
	        prop = ref[i];
	        hash[prop] = this[prop];
	      }
	      return hash;
	    };
	
	    Node.prototype.updateDimensions = function() {
	      var child, i, len, nonEmptyChildren, ref;
	      if (this.isLayer()) {
	        return;
	      }
	      ref = this._children;
	      for (i = 0, len = ref.length; i < len; i++) {
	        child = ref[i];
	        child.updateDimensions();
	      }
	      if (this.isRoot()) {
	        return;
	      }
	      nonEmptyChildren = this._children.filter(function(c) {
	        return !c.isEmpty();
	      });
	      this.left = _.min(nonEmptyChildren.map(function(c) {
	        return c.left;
	      })) || 0;
	      this.top = _.min(nonEmptyChildren.map(function(c) {
	        return c.top;
	      })) || 0;
	      this.bottom = _.max(nonEmptyChildren.map(function(c) {
	        return c.bottom;
	      })) || 0;
	      return this.right = _.max(nonEmptyChildren.map(function(c) {
	        return c.right;
	      })) || 0;
	    };
	
	    return Node;
	
	  })(Module);
	
	}).call(this);


/***/ },
/* 132 */
/***/ function(module, exports, __webpack_require__) {

	// Generated by CoffeeScript 1.11.1
	(function() {
	  var _;
	
	  _ = __webpack_require__(63);
	
	  module.exports = {
	    root: function() {
	      if (this.isRoot()) {
	        return this;
	      }
	      return this.parent.root();
	    },
	    isRoot: function() {
	      return this.depth() === 0;
	    },
	    children: function() {
	      return this._children;
	    },
	    ancestors: function() {
	      if ((this.parent == null) || this.parent.isRoot()) {
	        return [];
	      }
	      return this.parent.ancestors().concat([this.parent]);
	    },
	    hasChildren: function() {
	      return this._children.length > 0;
	    },
	    childless: function() {
	      return !this.hasChildren();
	    },
	    siblings: function() {
	      if (this.parent == null) {
	        return [];
	      }
	      return this.parent.children();
	    },
	    nextSibling: function() {
	      var index;
	      if (this.parent == null) {
	        return null;
	      }
	      index = this.siblings().indexOf(this);
	      return this.siblings()[index + 1];
	    },
	    prevSibling: function() {
	      var index;
	      if (this.parent == null) {
	        return null;
	      }
	      index = this.siblings().indexOf(this);
	      return this.siblings()[index - 1];
	    },
	    hasSiblings: function() {
	      return this.siblings().length > 1;
	    },
	    onlyChild: function() {
	      return !this.hasSiblings();
	    },
	    descendants: function() {
	      return _.flatten(this._children.map(function(n) {
	        return n.subtree();
	      }));
	    },
	    subtree: function() {
	      return [this].concat(this.descendants());
	    },
	    depth: function() {
	      return this.ancestors().length + 1;
	    },
	    path: function(asArray) {
	      var path;
	      if (asArray == null) {
	        asArray = false;
	      }
	      path = this.ancestors().map(function(n) {
	        return n.name;
	      }).concat([this.name]);
	      if (asArray) {
	        return path;
	      } else {
	        return path.join('/');
	      }
	    }
	  };
	
	}).call(this);


/***/ },
/* 133 */
/***/ function(module, exports, __webpack_require__) {

	// Generated by CoffeeScript 1.11.1
	(function() {
	  var _;
	
	  _ = __webpack_require__(63);
	
	  module.exports = {
	    childrenAtPath: function(path, opts) {
	      var matches, query;
	      if (opts == null) {
	        opts = {};
	      }
	      if (!Array.isArray(path)) {
	        path = path.split('/').filter(function(p) {
	          return p.length > 0;
	        });
	      }
	      path = _.clone(path);
	      query = path.shift();
	      matches = this.children().filter(function(c) {
	        if (opts.caseSensitive) {
	          return c.name === query;
	        } else {
	          return c.name.toLowerCase() === query.toLowerCase();
	        }
	      });
	      if (path.length === 0) {
	        return matches;
	      } else {
	        return _.flatten(matches.map(function(m) {
	          return m.childrenAtPath(_.clone(path), opts);
	        }));
	      }
	    }
	  };
	
	}).call(this);


/***/ },
/* 134 */
/***/ function(module, exports) {

	// Generated by CoffeeScript 1.11.1
	(function() {
	  module.exports = {
	    toPng: function() {
	      return this.layer.image.toPng();
	    },
	    saveAsPng: function(output) {
	      return this.layer.image.saveAsPng(output);
	    }
	  };
	
	}).call(this);


/***/ },
/* 135 */
/***/ function(module, exports, __webpack_require__) {

	// Generated by CoffeeScript 1.11.1
	(function() {
	  var Group, Node, _,
	    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
	    hasProp = {}.hasOwnProperty;
	
	  _ = __webpack_require__(63);
	
	  Node = __webpack_require__(131);
	
	  module.exports = Group = (function(superClass) {
	    extend(Group, superClass);
	
	    function Group() {
	      return Group.__super__.constructor.apply(this, arguments);
	    }
	
	    Group.prototype.type = 'group';
	
	    Group.prototype.passthruBlending = function() {
	      return this.get('blendingMode') === 'passthru';
	    };
	
	    Group.prototype.isEmpty = function() {
	      var child;
	      if (!(function() {
	        var i, len, ref, results;
	        ref = this._children;
	        results = [];
	        for (i = 0, len = ref.length; i < len; i++) {
	          child = ref[i];
	          results.push(child.isEmpty());
	        }
	        return results;
	      }).call(this)) {
	        return false;
	      }
	    };
	
	    Group.prototype["export"] = function() {
	      return _.merge(Group.__super__["export"].call(this), {
	        type: 'group',
	        children: this._children.map(function(c) {
	          return c["export"]();
	        })
	      });
	    };
	
	    return Group;
	
	  })(Node);
	
	}).call(this);


/***/ },
/* 136 */
/***/ function(module, exports, __webpack_require__) {

	// Generated by CoffeeScript 1.11.1
	(function() {
	  var Layer, Node, _,
	    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
	    hasProp = {}.hasOwnProperty;
	
	  _ = __webpack_require__(63);
	
	  Node = __webpack_require__(131);
	
	  module.exports = Layer = (function(superClass) {
	    extend(Layer, superClass);
	
	    function Layer() {
	      return Layer.__super__.constructor.apply(this, arguments);
	    }
	
	    Layer.prototype.type = 'layer';
	
	    Layer.prototype.hasMask = function() {
	      var vectorMask, vectorStroke;
	      if (!this.layer.adjustments) {
	        return false;
	      }
	      vectorMask = this.layer.adjustments.vectorMask;
	      vectorStroke = this.layer.adjustments.vectorStroke;
	      return vectorMask || vectorStroke;
	    };
	
	    Layer.prototype.isEmpty = function() {
	      return (this.width === 0 || this.height === 0) && !this.hasMask();
	    };
	
	    Layer.prototype["export"] = function() {
	      var ref;
	      return _.merge(Layer.__super__["export"].call(this), {
	        type: 'layer',
	        mask: this.layer.mask["export"](),
	        text: (ref = this.get('typeTool')) != null ? ref["export"]() : void 0,
	        image: {}
	      });
	    };
	
	    return Layer;
	
	  })(Node);
	
	}).call(this);


/***/ },
/* 137 */
/***/ function(module, exports, __webpack_require__) {

	// Generated by CoffeeScript 1.11.1
	(function() {
	  var RSVP;
	
	  RSVP = __webpack_require__(2);
	
	  module.exports = {
	    extended: function(PSD) {
	      this.fromURL = function(url) {
	        return new RSVP.Promise(function(resolve, reject) {
	          var xhr;
	          xhr = new XMLHttpRequest();
	          xhr.open("GET", url, true);
	          xhr.responseType = "arraybuffer";
	          xhr.onload = function() {
	            var data, err, psd;
	            data = new Uint8Array(xhr.response || xhr.mozResponseArrayBuffer);
	            try {
	              psd = new PSD(data);
	              psd.parse();
	              return resolve(psd);
	            } catch (error) {
	              err = error;
	              return reject(err);
	            }
	          };
	          return xhr.send(null);
	        });
	      };
	      this.fromEvent = function(e) {
	        return new RSVP.Promise(function(resolve, reject) {
	          var file, reader;
	          file = e.dataTransfer.files[0];
	          reader = new FileReader();
	          reader.onload = function(e) {
	            var err, psd;
	            try {
	              psd = new PSD(new Uint8Array(e.target.result));
	              psd.parse();
	              return resolve(psd);
	            } catch (error) {
	              err = error;
	              return reject(err);
	            }
	          };
	          reader.onerror = reject;
	          return reader.readAsArrayBuffer(file);
	        });
	      };
	      return this.fromDroppedFile = function(file) {
	        return new RSVP.Promise(function(resolve, reject) {
	          var reader;
	          reader = new FileReader();
	          reader.onload = function(e) {
	            var err, psd;
	            try {
	              psd = new PSD(new Uint8Array(e.target.result));
	              psd.parse();
	              return resolve(psd);
	            } catch (error) {
	              err = error;
	              return reject(err);
	            }
	          };
	          reader.onerror = reject;
	          return reader.readAsArrayBuffer(file);
	        });
	      };
	    }
	  };
	
	}).call(this);


/***/ }
/******/ ])
});
;

(function(){
    'use strict';

    angular
        .module('platformApp')
        .factory('ParseLinks', ParseLinks);

    function ParseLinks () {

        var service = {
            parse : parse
        };

        return service;

        function parse(header) {
            if (header.length === 0) {
                throw new Error('input must not be of zero length');
            }

            // Split parts by comma
            var parts = header.split(',');
            var links = {};
            // Parse each part into a named link
            angular.forEach(parts, function(p) {
                var section = p.split('>;');
                if (section.length !== 2) {
                    throw new Error('section could not be split on ">;"');
                }
                var url = section[0].replace(/<(.*)/, '$1').trim();
                var queryString = {};
                url.replace(
                    new RegExp('([^?=&]+)(=([^&]*))?', 'g'),
                    function($0, $1, $2, $3) { queryString[$1] = $3; }
                );
                var page = queryString.page;
                if (angular.isString(page)) {
                    page = parseInt(page);
                }
                var name = section[1].replace(/rel="(.*)"/, '$1').trim();
                links[name] = page;
            });
            return links;
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('platformApp')
        .factory('PaginationUtil', PaginationUtil);

    function PaginationUtil () {

        var service = {
            parseAscending : parseAscending,
            parsePage : parsePage,
            parsePredicate : parsePredicate
        };

        return service;

        function parseAscending (sort) {
            var sortArray = sort.split(',');
            if (sortArray.length > 1){
                return sort.split(',').slice(-1)[0] === 'asc';
            } else {
                // default to true if no sort defined
                return true;
            }
        }

        // query params are strings, and need to be parsed
        function parsePage (page) {
            return parseInt(page);
        }

        // sort can be in the format `id,asc` or `id`
        function parsePredicate (sort) {
            var sortArray = sort.split(',');
            if (sortArray.length > 1){
                sortArray.pop();
            }
            return sortArray.join(',');
        }
    }
})();

/*
 *
 * https://github.com/fatlinesofcode/ngDraggable
 */
angular.module("ngDraggable", [])
    .service('ngDraggable', [function() {


        var scope = this;
        scope.inputEvent = function(event) {
            if (angular.isDefined(event.touches)) {
                return event.touches[0];
            }
            //Checking both is not redundent. If only check if touches isDefined, angularjs isDefnied will return error and stop the remaining scripty if event.originalEvent is not defined.
            else if (angular.isDefined(event.originalEvent) && angular.isDefined(event.originalEvent.touches)) {
                return event.originalEvent.touches[0];
            }
            return event;
        };

        scope.touchTimeout = 100;

    }])
    .directive('ngDrag', ['$rootScope', '$parse', '$document', '$window', 'ngDraggable', function ($rootScope, $parse, $document, $window, ngDraggable) {
        return {
            restrict: 'A',
            link: function (scope, element, attrs) {
                scope.value = attrs.ngDrag;
                var offset,_centerAnchor=false,_mx,_my,_tx,_ty,_mrx,_mry;
                var _hasTouch = ('ontouchstart' in window) || window.DocumentTouch && document instanceof DocumentTouch;
                var _pressEvents = 'touchstart mousedown';
                var _moveEvents = 'touchmove mousemove';
                var _releaseEvents = 'touchend mouseup';
                var _dragHandle;

                // to identify the element in order to prevent getting superflous events when a single element has both drag and drop directives on it.
                var _myid = scope.$id;
                var _data = null;

                var _dragOffset = null;

                var _dragEnabled = false;

                var _pressTimer = null;

                var onDragStartCallback = $parse(attrs.ngDragStart) || null;
                var onDragStopCallback = $parse(attrs.ngDragStop) || null;
                var onDragSuccessCallback = $parse(attrs.ngDragSuccess) || null;
                var allowTransform = angular.isDefined(attrs.allowTransform) ? scope.$eval(attrs.allowTransform) : true;

                var getDragData = $parse(attrs.ngDragData);

                // deregistration function for mouse move events in $rootScope triggered by jqLite trigger handler
                var _deregisterRootMoveListener = angular.noop;

                var initialize = function () {
                    element.attr('draggable', 'false'); // prevent native drag
                    // check to see if drag handle(s) was specified
                    // if querySelectorAll is available, we use this instead of find
                    // as JQLite find is limited to tagnames
                    if (element[0].querySelectorAll) {
                        var dragHandles = angular.element(element[0].querySelectorAll('[ng-drag-handle]'));
                    } else {
                        var dragHandles = element.find('[ng-drag-handle]');
                    }
                    if (dragHandles.length) {
                        _dragHandle = dragHandles;
                    }
                    toggleListeners(true);
                };

                var toggleListeners = function (enable) {
                    if (!enable)return;
                    // add listeners.

                    scope.$on('$destroy', onDestroy);
                    scope.$watch(attrs.ngDrag, onEnableChange);
                    scope.$watch(attrs.ngCenterAnchor, onCenterAnchor);
                    // wire up touch events
                    if (_dragHandle) {
                        // handle(s) specified, use those to initiate drag
                        _dragHandle.on(_pressEvents, onpress);
                    } else {
                        // no handle(s) specified, use the element as the handle
                        element.on(_pressEvents, onpress);
                    }
                    // if(! _hasTouch && element[0].nodeName.toLowerCase() == "img"){
                    if( element[0].nodeName.toLowerCase() == "img"){
                        element.on('mousedown', function(){ return false;}); // prevent native drag for images
                    }
                };
                var onDestroy = function (enable) {
                    toggleListeners(false);
                };
                var onEnableChange = function (newVal, oldVal) {
                    _dragEnabled = (newVal);
                };
                var onCenterAnchor = function (newVal, oldVal) {
                    if(angular.isDefined(newVal))
                        _centerAnchor = (newVal || 'true');
                };

                var isClickableElement = function (evt) {
                    return (
                        angular.isDefined(angular.element(evt.target).attr("ng-cancel-drag"))
                    );
                };
                /*
                 * When the element is clicked start the drag behaviour
                 * On touch devices as a small delay so as not to prevent native window scrolling
                 */
                var onpress = function(evt) {
                    // console.log("110"+" onpress: "+Math.random()+" "+ evt.type);
                    if(! _dragEnabled)return;

                    if (isClickableElement(evt)) {
                        return;
                    }

                    if (evt.type == "mousedown" && evt.button != 0) {
                        // Do not start dragging on right-click
                        return;
                    }

                    var useTouch = evt.type === 'touchstart' ? true : false;


                    if(useTouch){
                        cancelPress();
                        _pressTimer = setTimeout(function(){
                            cancelPress();
                            onlongpress(evt);
                        },ngDraggable.touchTimeout);
                        $document.on(_moveEvents, cancelPress);
                        $document.on(_releaseEvents, cancelPress);
                    }else{
                        onlongpress(evt);
                    }

                };

                var cancelPress = function() {
                    clearTimeout(_pressTimer);
                    $document.off(_moveEvents, cancelPress);
                    $document.off(_releaseEvents, cancelPress);
                };

                var onlongpress = function(evt) {
                    if(! _dragEnabled)return;
                    evt.preventDefault();

                    offset = element[0].getBoundingClientRect();
                    if(allowTransform)
                        _dragOffset = offset;
                    else{
                        _dragOffset = {left:document.body.scrollLeft, top:document.body.scrollTop};
                    }


                    element.centerX = element[0].offsetWidth / 2;
                    element.centerY = element[0].offsetHeight / 2;

                    _mx = ngDraggable.inputEvent(evt).pageX;//ngDraggable.getEventProp(evt, 'pageX');
                    _my = ngDraggable.inputEvent(evt).pageY;//ngDraggable.getEventProp(evt, 'pageY');
                    _mrx = _mx - offset.left;
                    _mry = _my - offset.top;
                    if (_centerAnchor) {
                        _tx = _mx - element.centerX - $window.pageXOffset;
                        _ty = _my - element.centerY - $window.pageYOffset;
                    } else {
                        _tx = _mx - _mrx - $window.pageXOffset;
                        _ty = _my - _mry - $window.pageYOffset;
                    }

                    $document.on(_moveEvents, onmove);
                    $document.on(_releaseEvents, onrelease);
                    // This event is used to receive manually triggered mouse move events
                    // jqLite unfortunately only supports triggerHandler(...)
                    // See http://api.jquery.com/triggerHandler/
                    // _deregisterRootMoveListener = $rootScope.$on('draggable:_triggerHandlerMove', onmove);
                    _deregisterRootMoveListener = $rootScope.$on('draggable:_triggerHandlerMove', function(event, origEvent) {
                        onmove(origEvent);
                    });
                };

                var onmove = function (evt) {
                    if (!_dragEnabled)return;
                    evt.preventDefault();

                    if (!element.hasClass('dragging')) {
                        _data = getDragData(scope);
                        element.addClass('dragging');
                        $rootScope.$broadcast('draggable:start', {x:_mx, y:_my, tx:_tx, ty:_ty, event:evt, element:element, data:_data});

                        if (onDragStartCallback ){
                            scope.$apply(function () {
                                onDragStartCallback(scope, {$data: _data, $event: evt});
                            });
                        }
                    }

                    _mx = ngDraggable.inputEvent(evt).pageX;//ngDraggable.getEventProp(evt, 'pageX');
                    _my = ngDraggable.inputEvent(evt).pageY;//ngDraggable.getEventProp(evt, 'pageY');

                    if (_centerAnchor) {
                        _tx = _mx - element.centerX - _dragOffset.left;
                        _ty = _my - element.centerY - _dragOffset.top;
                    } else {
                        _tx = _mx - _mrx - _dragOffset.left;
                        _ty = _my - _mry - _dragOffset.top;
                    }

                    moveElement(_tx, _ty);

                    $rootScope.$broadcast('draggable:move', { x: _mx, y: _my, tx: _tx, ty: _ty, event: evt, element: element, data: _data, uid: _myid, dragOffset: _dragOffset });
                };

                var onrelease = function(evt) {
                    if (!_dragEnabled)
                        return;
                    evt.preventDefault();
                    $rootScope.$broadcast('draggable:end', {x:_mx, y:_my, tx:_tx, ty:_ty, event:evt, element:element, data:_data, callback:onDragComplete, uid: _myid});
                    element.removeClass('dragging');
                    element.parent().find('.drag-enter').removeClass('drag-enter');
                    reset();
                    $document.off(_moveEvents, onmove);
                    $document.off(_releaseEvents, onrelease);

                    if (onDragStopCallback ){
                        scope.$apply(function () {
                            onDragStopCallback(scope, {$data: _data, $event: evt});
                        });
                    }

                    _deregisterRootMoveListener();
                };

                var onDragComplete = function(evt) {


                    if (!onDragSuccessCallback )return;

                    scope.$apply(function () {
                        onDragSuccessCallback(scope, {$data: _data, $event: evt});
                    });
                };

                var reset = function() {
                    if(allowTransform)
                        element.css({transform:'', 'z-index':'', '-webkit-transform':'', '-ms-transform':''});
                    else
                        element.css({'position':'',top:'',left:''});
                };

                var moveElement = function (x, y) {
                    if(allowTransform) {
                        element.css({
                            transform: 'matrix3d(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, ' + x + ', ' + y + ', 0, 1)',
                            'z-index': 99999,
                            '-webkit-transform': 'matrix3d(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, ' + x + ', ' + y + ', 0, 1)',
                            '-ms-transform': 'matrix(1, 0, 0, 1, ' + x + ', ' + y + ')'
                        });
                    }else{
                        element.css({'left':x+'px','top':y+'px', 'position':'fixed'});
                    }
                };
                initialize();
            }
        };
    }])

    .directive('ngDrop', ['$parse', '$timeout', '$window', '$document', 'ngDraggable', function ($parse, $timeout, $window, $document, ngDraggable) {
        return {
            restrict: 'A',
            link: function (scope, element, attrs) {
                scope.value = attrs.ngDrop;
                scope.isTouching = false;

                var _lastDropTouch=null;

                var _myid = scope.$id;

                var _dropEnabled=false;

                var onDropCallback = $parse(attrs.ngDropSuccess);// || function(){};

                var onDragStartCallback = $parse(attrs.ngDragStart);
                var onDragStopCallback = $parse(attrs.ngDragStop);
                var onDragMoveCallback = $parse(attrs.ngDragMove);

                var initialize = function () {
                    toggleListeners(true);
                };

                var toggleListeners = function (enable) {
                    // remove listeners

                    if (!enable)return;
                    // add listeners.
                    scope.$watch(attrs.ngDrop, onEnableChange);
                    scope.$on('$destroy', onDestroy);
                    scope.$on('draggable:start', onDragStart);
                    scope.$on('draggable:move', onDragMove);
                    scope.$on('draggable:end', onDragEnd);
                };

                var onDestroy = function (enable) {
                    toggleListeners(false);
                };
                var onEnableChange = function (newVal, oldVal) {
                    _dropEnabled=newVal;
                };
                var onDragStart = function(evt, obj) {
                    if(! _dropEnabled)return;
                    isTouching(obj.x,obj.y,obj.element);

                    if (attrs.ngDragStart) {
                        $timeout(function(){
                            onDragStartCallback(scope, {$data: obj.data, $event: obj});
                        });
                    }
                };
                var onDragMove = function(evt, obj) {
                    if(! _dropEnabled)return;
                    isTouching(obj.x,obj.y,obj.element);

                    if (attrs.ngDragMove) {
                        $timeout(function(){
                            onDragMoveCallback(scope, {$data: obj.data, $event: obj});
                        });
                    }
                };

                var onDragEnd = function (evt, obj) {

                    // don't listen to drop events if this is the element being dragged
                    // only update the styles and return
                    if (!_dropEnabled || _myid === obj.uid) {
                        updateDragStyles(false, obj.element);
                        return;
                    }
                    if (isTouching(obj.x, obj.y, obj.element)) {
                        // call the ngDraggable ngDragSuccess element callback
                        if(obj.callback){
                            obj.callback(obj);
                        }

                        if (attrs.ngDropSuccess) {
                            $timeout(function(){
                                onDropCallback(scope, {$data: obj.data, $event: obj, $target: scope.$eval(scope.value)});
                            });
                        }
                    }

                    if (attrs.ngDragStop) {
                        $timeout(function(){
                            onDragStopCallback(scope, {$data: obj.data, $event: obj});
                        });
                    }

                    updateDragStyles(false, obj.element);
                };

                var isTouching = function(mouseX, mouseY, dragElement) {
                    var touching= hitTest(mouseX, mouseY);
                    scope.isTouching = touching;
                    if(touching){
                        _lastDropTouch = element;
                    }
                    updateDragStyles(touching, dragElement);
                    return touching;
                };

                var updateDragStyles = function(touching, dragElement) {
                    if(touching){
                        element.addClass('drag-enter');
                        dragElement.addClass('drag-over');
                    }else if(_lastDropTouch == element){
                        _lastDropTouch=null;
                        element.removeClass('drag-enter');
                        dragElement.removeClass('drag-over');
                    }
                };

                var hitTest = function(x, y) {
                    var bounds = element[0].getBoundingClientRect();// ngDraggable.getPrivOffset(element);
                    x -= $document[0].body.scrollLeft + $document[0].documentElement.scrollLeft;
                    y -= $document[0].body.scrollTop + $document[0].documentElement.scrollTop;
                    return  x >= bounds.left
                        && x <= bounds.right
                        && y <= bounds.bottom
                        && y >= bounds.top;
                };

                initialize();
            }
        };
    }])
    .directive('ngDragClone', ['$parse', '$timeout', 'ngDraggable', function ($parse, $timeout, ngDraggable) {
        return {
            restrict: 'A',
            link: function (scope, element, attrs) {
                var img, _allowClone=true;
                var _dragOffset = null;
                scope.clonedData = {};
                var initialize = function () {

                    img = element.find('img');
                    element.attr('draggable', 'false');
                    img.attr('draggable', 'false');
                    reset();
                    toggleListeners(true);
                };


                var toggleListeners = function (enable) {
                    // remove listeners

                    if (!enable)return;
                    // add listeners.
                    scope.$on('draggable:start', onDragStart);
                    scope.$on('draggable:move', onDragMove);
                    scope.$on('draggable:end', onDragEnd);
                    preventContextMenu();

                };
                var preventContextMenu = function() {
                    //  element.off('mousedown touchstart touchmove touchend touchcancel', absorbEvent_);
                    img.off('mousedown touchstart touchmove touchend touchcancel', absorbEvent_);
                    //  element.on('mousedown touchstart touchmove touchend touchcancel', absorbEvent_);
                    img.on('mousedown touchstart touchmove touchend touchcancel', absorbEvent_);
                };
                var onDragStart = function(evt, obj, elm) {
                    _allowClone=true;
                    if(angular.isDefined(obj.data.allowClone)){
                        _allowClone=obj.data.allowClone;
                    }
                    if(_allowClone) {
                        scope.$apply(function () {
                            scope.clonedData = obj.data;
                        });
                        element.css('width', obj.element[0].offsetWidth);
                        element.css('height', obj.element[0].offsetHeight);

                        moveElement(obj.tx, obj.ty);
                    }

                };
                var onDragMove = function(evt, obj) {
                    if(_allowClone) {

                        _tx = obj.tx + obj.dragOffset.left;
                        _ty = obj.ty + obj.dragOffset.top;

                        moveElement(_tx, _ty);
                    }
                };
                var onDragEnd = function(evt, obj) {
                    //moveElement(obj.tx,obj.ty);
                    if(_allowClone) {
                        reset();
                    }
                };

                var reset = function() {
                    element.css({left:0,top:0, position:'fixed', 'z-index':-1, visibility:'hidden'});
                };
                var moveElement = function(x,y) {
                    element.css({
                        transform: 'matrix3d(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, '+x+', '+y+', 0, 1)', 'z-index': 99999, 'visibility': 'visible',
                        '-webkit-transform': 'matrix3d(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, '+x+', '+y+', 0, 1)',
                        '-ms-transform': 'matrix(1, 0, 0, 1, '+x+', '+y+')'
                        //,margin: '0'  don't monkey with the margin,
                    });
                };

                var absorbEvent_ = function (event) {
                    var e = event;//.originalEvent;
                    e.preventDefault && e.preventDefault();
                    e.stopPropagation && e.stopPropagation();
                    e.cancelBubble = true;
                    e.returnValue = false;
                    return false;
                };

                initialize();
            }
        };
    }])
    .directive('ngPreventDrag', ['$parse', '$timeout', function ($parse, $timeout) {
        return {
            restrict: 'A',
            link: function (scope, element, attrs) {
                var initialize = function () {

                    element.attr('draggable', 'false');
                    toggleListeners(true);
                };


                var toggleListeners = function (enable) {
                    // remove listeners

                    if (!enable)return;
                    // add listeners.
                    element.on('mousedown touchstart touchmove touchend touchcancel', absorbEvent_);
                };


                var absorbEvent_ = function (event) {
                    var e = event.originalEvent;
                    e.preventDefault && e.preventDefault();
                    e.stopPropagation && e.stopPropagation();
                    e.cancelBubble = true;
                    e.returnValue = false;
                    return false;
                };

                initialize();
            }
        };
    }])
    .directive('ngCancelDrag', [function () {
        return {
            restrict: 'A',
            link: function (scope, element, attrs) {
                element.find('*').attr('ng-cancel-drag', 'ng-cancel-drag');
            }
        };
    }])
    .directive('ngDragScroll', ['$window', '$interval', '$timeout', '$document', '$rootScope', function($window, $interval, $timeout, $document, $rootScope) {
        return {
            restrict: 'A',
            link: function(scope, element, attrs) {
                var intervalPromise = null;
                var lastMouseEvent = null;

                var config = {
                    verticalScroll: attrs.verticalScroll || true,
                    horizontalScroll: attrs.horizontalScroll || true,
                    activationDistance: attrs.activationDistance || 75,
                    scrollDistance: attrs.scrollDistance || 15
                };


                var reqAnimFrame = (function() {
                    return window.requestAnimationFrame ||
                        window.webkitRequestAnimationFrame ||
                        window.mozRequestAnimationFrame ||
                        window.oRequestAnimationFrame ||
                        window.msRequestAnimationFrame ||
                        function( /* function FrameRequestCallback */ callback, /* DOMElement Element */ element ) {
                            window.setTimeout(callback, 1000 / 60);
                        };
                })();

                var animationIsOn = false;
                var createInterval = function() {
                    animationIsOn = true;

                    function nextFrame(callback) {
                        var args = Array.prototype.slice.call(arguments);
                        if(animationIsOn) {
                            reqAnimFrame(function () {
                                $rootScope.$apply(function () {
                                    callback.apply(null, args);
                                    nextFrame(callback);
                                });
                            })
                        }
                    }

                    nextFrame(function() {
                        if (!lastMouseEvent) return;

                        var viewportWidth = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
                        var viewportHeight = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);

                        var scrollX = 0;
                        var scrollY = 0;

                        if (config.horizontalScroll) {
                            // If horizontal scrolling is active.
                            if (lastMouseEvent.clientX < config.activationDistance) {
                                // If the mouse is on the left of the viewport within the activation distance.
                                scrollX = -config.scrollDistance;
                            }
                            else if (lastMouseEvent.clientX > viewportWidth - config.activationDistance) {
                                // If the mouse is on the right of the viewport within the activation distance.
                                scrollX = config.scrollDistance;
                            }
                        }

                        if (config.verticalScroll) {
                            // If vertical scrolling is active.
                            if (lastMouseEvent.clientY < config.activationDistance) {
                                // If the mouse is on the top of the viewport within the activation distance.
                                scrollY = -config.scrollDistance;
                            }
                            else if (lastMouseEvent.clientY > viewportHeight - config.activationDistance) {
                                // If the mouse is on the bottom of the viewport within the activation distance.
                                scrollY = config.scrollDistance;
                            }
                        }



                        if (scrollX !== 0 || scrollY !== 0) {
                            // Record the current scroll position.
                            var currentScrollLeft = ($window.pageXOffset || $document[0].documentElement.scrollLeft);
                            var currentScrollTop = ($window.pageYOffset || $document[0].documentElement.scrollTop);

                            // Remove the transformation from the element, scroll the window by the scroll distance
                            // record how far we scrolled, then reapply the element transformation.
                            var elementTransform = element.css('transform');
                            element.css('transform', 'initial');

                            $window.scrollBy(scrollX, scrollY);

                            var horizontalScrollAmount = ($window.pageXOffset || $document[0].documentElement.scrollLeft) - currentScrollLeft;
                            var verticalScrollAmount =  ($window.pageYOffset || $document[0].documentElement.scrollTop) - currentScrollTop;

                            element.css('transform', elementTransform);

                            lastMouseEvent.pageX += horizontalScrollAmount;
                            lastMouseEvent.pageY += verticalScrollAmount;

                            $rootScope.$emit('draggable:_triggerHandlerMove', lastMouseEvent);
                        }

                    });
                };

                var clearInterval = function() {
                    animationIsOn = false;
                };

                scope.$on('draggable:start', function(event, obj) {
                    // Ignore this event if it's not for this element.
                    if (obj.element[0] !== element[0]) return;

                    if (!animationIsOn) createInterval();
                });

                scope.$on('draggable:end', function(event, obj) {
                    // Ignore this event if it's not for this element.
                    if (obj.element[0] !== element[0]) return;

                    if (animationIsOn) clearInterval();
                });

                scope.$on('draggable:move', function(event, obj) {
                    // Ignore this event if it's not for this element.
                    if (obj.element[0] !== element[0]) return;

                    lastMouseEvent = obj.event;
                });
            }
        };
    }]);

/* Modernizr 2.6.2 (Custom Build) | MIT & BSD
 * Build: http://modernizr.com/download/#-csstransforms3d-csstransitions-shiv-cssclasses-prefixed-teststyles-testprop-testallprops-prefixes-domprefixes-load
 */
;window.Modernizr = function (a, b, c) {
    function z(a) {
        j.cssText = a
    }

    function A(a, b) {
        return z(m.join(a + ";") + (b || ""))
    }

    function B(a, b) {
        return typeof a === b
    }

    function C(a, b) {
        return !!~("" + a).indexOf(b)
    }

    function D(a, b) {
        for (var d in a) {
            var e = a[d];
            if (!C(e, "-") && j[e] !== c)return b == "pfx" ? e : !0
        }
        return !1
    }

    function E(a, b, d) {
        for (var e in a) {
            var f = b[a[e]];
            if (f !== c)return d === !1 ? a[e] : B(f, "function") ? f.bind(d || b) : f
        }
        return !1
    }

    function F(a, b, c) {
        var d = a.charAt(0).toUpperCase() + a.slice(1), e = (a + " " + o.join(d + " ") + d).split(" ");
        return B(b, "string") || B(b, "undefined") ? D(e, b) : (e = (a + " " + p.join(d + " ") + d).split(" "), E(e, b, c))
    }

    var d = "2.6.2", e = {}, f = !0, g = b.documentElement, h = "modernizr", i = b.createElement(h), j = i.style, k, l = {}.toString, m = " -webkit- -moz- -o- -ms- ".split(" "), n = "Webkit Moz O ms", o = n.split(" "), p = n.toLowerCase().split(" "), q = {}, r = {}, s = {}, t = [], u = t.slice, v, w = function (a, c, d, e) {
        var f, i, j, k, l = b.createElement("div"), m = b.body, n = m || b.createElement("body");
        if (parseInt(d, 10))while (d--)j = b.createElement("div"), j.id = e ? e[d] : h + (d + 1), l.appendChild(j);
        return f = ["&#173;", '<style id="s', h, '">', a, "</style>"].join(""), l.id = h, (m ? l : n).innerHTML += f, n.appendChild(l), m || (n.style.background = "", n.style.overflow = "hidden", k = g.style.overflow, g.style.overflow = "hidden", g.appendChild(n)), i = c(l, a), m ? l.parentNode.removeChild(l) : (n.parentNode.removeChild(n), g.style.overflow = k), !!i
    }, x = {}.hasOwnProperty, y;
    !B(x, "undefined") && !B(x.call, "undefined") ? y = function (a, b) {
            return x.call(a, b)
        } : y = function (a, b) {
            return b in a && B(a.constructor.prototype[b], "undefined")
        }, Function.prototype.bind || (Function.prototype.bind = function (b) {
        var c = this;
        if (typeof c != "function")throw new TypeError;
        var d = u.call(arguments, 1), e = function () {
            if (this instanceof e) {
                var a = function () {
                };
                a.prototype = c.prototype;
                var f = new a, g = c.apply(f, d.concat(u.call(arguments)));
                return Object(g) === g ? g : f
            }
            return c.apply(b, d.concat(u.call(arguments)))
        };
        return e
    }), q.csstransforms3d = function () {
        var a = !!F("perspective");
        return a && "webkitPerspective" in g.style && w("@media (transform-3d),(-webkit-transform-3d){#modernizr{left:9px;position:absolute;height:3px;}}", function (b, c) {
            a = b.offsetLeft === 9 && b.offsetHeight === 3
        }), a
    }, q.csstransitions = function () {
        return F("transition")
    };
    for (var G in q)y(q, G) && (v = G.toLowerCase(), e[v] = q[G](), t.push((e[v] ? "" : "no-") + v));
    return e.addTest = function (a, b) {
        if (typeof a == "object")for (var d in a)y(a, d) && e.addTest(d, a[d]); else {
            a = a.toLowerCase();
            if (e[a] !== c)return e;
            b = typeof b == "function" ? b() : b, typeof f != "undefined" && f && (g.className += " " + (b ? "" : "no-") + a), e[a] = b
        }
        return e
    }, z(""), i = k = null, function (a, b) {
        function k(a, b) {
            var c = a.createElement("p"), d = a.getElementsByTagName("head")[0] || a.documentElement;
            return c.innerHTML = "x<style>" + b + "</style>", d.insertBefore(c.lastChild, d.firstChild)
        }

        function l() {
            var a = r.elements;
            return typeof a == "string" ? a.split(" ") : a
        }

        function m(a) {
            var b = i[a[g]];
            return b || (b = {}, h++, a[g] = h, i[h] = b), b
        }

        function n(a, c, f) {
            c || (c = b);
            if (j)return c.createElement(a);
            f || (f = m(c));
            var g;
            return f.cache[a] ? g = f.cache[a].cloneNode() : e.test(a) ? g = (f.cache[a] = f.createElem(a)).cloneNode() : g = f.createElem(a), g.canHaveChildren && !d.test(a) ? f.frag.appendChild(g) : g
        }

        function o(a, c) {
            a || (a = b);
            if (j)return a.createDocumentFragment();
            c = c || m(a);
            var d = c.frag.cloneNode(), e = 0, f = l(), g = f.length;
            for (; e < g; e++)d.createElement(f[e]);
            return d
        }

        function p(a, b) {
            b.cache || (b.cache = {}, b.createElem = a.createElement, b.createFrag = a.createDocumentFragment, b.frag = b.createFrag()), a.createElement = function (c) {
                return r.shivMethods ? n(c, a, b) : b.createElem(c)
            }, a.createDocumentFragment = Function("h,f", "return function(){var n=f.cloneNode(),c=n.createElement;h.shivMethods&&(" + l().join().replace(/\w+/g, function (a) {
                    return b.createElem(a), b.frag.createElement(a), 'c("' + a + '")'
                }) + ");return n}")(r, b.frag)
        }

        function q(a) {
            a || (a = b);
            var c = m(a);
            return r.shivCSS && !f && !c.hasCSS && (c.hasCSS = !!k(a, "article,aside,figcaption,figure,footer,header,hgroup,nav,section{display:block}mark{background:#FF0;color:#000}")), j || p(a, c), a
        }

        var c = a.html5 || {}, d = /^<|^(?:button|map|select|textarea|object|iframe|option|optgroup)$/i, e = /^(?:a|b|code|div|fieldset|h1|h2|h3|h4|h5|h6|i|label|li|ol|p|q|span|strong|style|table|tbody|td|th|tr|ul)$/i, f, g = "_html5shiv", h = 0, i = {}, j;
        (function () {
            try {
                var a = b.createElement("a");
                a.innerHTML = "<xyz></xyz>", f = "hidden" in a, j = a.childNodes.length == 1 || function () {
                        b.createElement("a");
                        var a = b.createDocumentFragment();
                        return typeof a.cloneNode == "undefined" || typeof a.createDocumentFragment == "undefined" || typeof a.createElement == "undefined"
                    }()
            } catch (c) {
                f = !0, j = !0
            }
        })();
        var r = {
            elements: c.elements || "abbr article aside audio bdi canvas data datalist details figcaption figure footer header hgroup mark meter nav output progress section summary time video",
            shivCSS: c.shivCSS !== !1,
            supportsUnknownElements: j,
            shivMethods: c.shivMethods !== !1,
            type: "default",
            shivDocument: q,
            createElement: n,
            createDocumentFragment: o
        };
        a.html5 = r, q(b)
    }(this, b), e._version = d, e._prefixes = m, e._domPrefixes = p, e._cssomPrefixes = o, e.testProp = function (a) {
        return D([a])
    }, e.testAllProps = F, e.testStyles = w, e.prefixed = function (a, b, c) {
        return b ? F(a, b, c) : F(a, "pfx")
    }, g.className = g.className.replace(/(^|\s)no-js(\s|$)/, "$1$2") + (f ? " js " + t.join(" ") : ""), e
}(this, this.document), function (a, b, c) {
    function d(a) {
        return "[object Function]" == o.call(a)
    }

    function e(a) {
        return "string" == typeof a
    }

    function f() {
    }

    function g(a) {
        return !a || "loaded" == a || "complete" == a || "uninitialized" == a
    }

    function h() {
        var a = p.shift();
        q = 1, a ? a.t ? m(function () {
                    ("c" == a.t ? B.injectCss : B.injectJs)(a.s, 0, a.a, a.x, a.e, 1)
                }, 0) : (a(), h()) : q = 0
    }

    function i(a, c, d, e, f, i, j) {
        function k(b) {
            if (!o && g(l.readyState) && (u.r = o = 1, !q && h(), l.onload = l.onreadystatechange = null, b)) {
                "img" != a && m(function () {
                    t.removeChild(l)
                }, 50);
                for (var d in y[c])y[c].hasOwnProperty(d) && y[c][d].onload()
            }
        }

        var j = j || B.errorTimeout, l = b.createElement(a), o = 0, r = 0, u = {t: d, s: c, e: f, a: i, x: j};
        1 === y[c] && (r = 1, y[c] = []), "object" == a ? l.data = c : (l.src = c, l.type = a), l.width = l.height = "0", l.onerror = l.onload = l.onreadystatechange = function () {
            k.call(this, r)
        }, p.splice(e, 0, u), "img" != a && (r || 2 === y[c] ? (t.insertBefore(l, s ? null : n), m(k, j)) : y[c].push(l))
    }

    function j(a, b, c, d, f) {
        return q = 0, b = b || "j", e(a) ? i("c" == b ? v : u, a, b, this.i++, c, d, f) : (p.splice(this.i++, 0, a), 1 == p.length && h()), this
    }

    function k() {
        var a = B;
        return a.loader = {load: j, i: 0}, a
    }

    var l = b.documentElement, m = a.setTimeout, n = b.getElementsByTagName("script")[0], o = {}.toString, p = [], q = 0, r = "MozAppearance" in l.style, s = r && !!b.createRange().compareNode, t = s ? l : n.parentNode, l = a.opera && "[object Opera]" == o.call(a.opera), l = !!b.attachEvent && !l, u = r ? "object" : l ? "script" : "img", v = l ? "script" : u, w = Array.isArray || function (a) {
            return "[object Array]" == o.call(a)
        }, x = [], y = {}, z = {
        timeout: function (a, b) {
            return b.length && (a.timeout = b[0]), a
        }
    }, A, B;
    B = function (a) {
        function b(a) {
            var a = a.split("!"), b = x.length, c = a.pop(), d = a.length, c = {
                url: c,
                origUrl: c,
                prefixes: a
            }, e, f, g;
            for (f = 0; f < d; f++)g = a[f].split("="), (e = z[g.shift()]) && (c = e(c, g));
            for (f = 0; f < b; f++)c = x[f](c);
            return c
        }

        function g(a, e, f, g, h) {
            var i = b(a), j = i.autoCallback;
            i.url.split(".").pop().split("?").shift(), i.bypass || (e && (e = d(e) ? e : e[a] || e[g] || e[a.split("/").pop().split("?")[0]]), i.instead ? i.instead(a, e, f, g, h) : (y[i.url] ? i.noexec = !0 : y[i.url] = 1, f.load(i.url, i.forceCSS || !i.forceJS && "css" == i.url.split(".").pop().split("?").shift() ? "c" : c, i.noexec, i.attrs, i.timeout), (d(e) || d(j)) && f.load(function () {
                    k(), e && e(i.origUrl, h, g), j && j(i.origUrl, h, g), y[i.url] = 2
                })))
        }

        function h(a, b) {
            function c(a, c) {
                if (a) {
                    if (e(a)) c || (j = function () {
                        var a = [].slice.call(arguments);
                        k.apply(this, a), l()
                    }), g(a, j, b, 0, h); else if (Object(a) === a)for (n in m = function () {
                        var b = 0, c;
                        for (c in a)a.hasOwnProperty(c) && b++;
                        return b
                    }(), a)a.hasOwnProperty(n) && (!c && !--m && (d(j) ? j = function () {
                            var a = [].slice.call(arguments);
                            k.apply(this, a), l()
                        } : j[n] = function (a) {
                            return function () {
                                var b = [].slice.call(arguments);
                                a && a.apply(this, b), l()
                            }
                        }(k[n])), g(a[n], j, b, n, h))
                } else!c && l()
            }

            var h = !!a.test, i = a.load || a.both, j = a.callback || f, k = j, l = a.complete || f, m, n;
            c(h ? a.yep : a.nope, !!i), i && c(i)
        }

        var i, j, l = this.yepnope.loader;
        if (e(a)) g(a, 0, l, 0); else if (w(a))for (i = 0; i < a.length; i++)j = a[i], e(j) ? g(j, 0, l, 0) : w(j) ? B(j) : Object(j) === j && h(j, l); else Object(a) === a && h(a, l)
    }, B.addPrefix = function (a, b) {
        z[a] = b
    }, B.addFilter = function (a) {
        x.push(a)
    }, B.errorTimeout = 1e4, null == b.readyState && b.addEventListener && (b.readyState = "loading", b.addEventListener("DOMContentLoaded", A = function () {
        b.removeEventListener("DOMContentLoaded", A, 0), b.readyState = "complete"
    }, 0)), a.yepnope = k(), a.yepnope.executeStack = h, a.yepnope.injectJs = function (a, c, d, e, i, j) {
        var k = b.createElement("script"), l, o, e = e || B.errorTimeout;
        k.src = a;
        for (o in d)k.setAttribute(o, d[o]);
        c = j ? h : c || f, k.onreadystatechange = k.onload = function () {
            !l && g(k.readyState) && (l = 1, c(), k.onload = k.onreadystatechange = null)
        }, m(function () {
            l || (l = 1, c(1))
        }, e), i ? k.onload() : n.parentNode.insertBefore(k, n)
    }, a.yepnope.injectCss = function (a, c, d, e, g, i) {
        var e = b.createElement("link"), j, c = i ? h : c || f;
        e.href = a, e.rel = "stylesheet", e.type = "text/css";
        for (j in d)e.setAttribute(j, d[j]);
        g || (n.parentNode.insertBefore(e, n), m(c, 0))
    }
}(this, document), Modernizr.load = function () {
    yepnope.apply(window, [].slice.call(arguments, 0))
};
(function() {
    'use strict';
    angular
        .module('platformApp')
        .factory('MessageService', MessageService);

    MessageService.$inject = ['$uibModal'];

    function MessageService($uibModal) {
        var service = {
            confirm: confirm,
            successConfirm: successConfirm,
            comment:comment,
            loading:loading,
            error:error,
            notice:notice,
            info:info,
            success:success,
            notify:notify


        };

        var settings = {
            title: 'The notice title.', // The notice's title.
            title_escape: false, // Whether to escape the content of the title. (Not allow HTML.)
            // text: 'The notice text.', // The notice's text.
            text_escape: false, // Whether to escape the content of the text. (Not allow HTML.)
            styling: "bootstrap3", // What styling classes to use. (Can be either jqueryui or bootstrap or bootstrap3.)
            addclass: "stack-topcenter", // Additional classes to be added to the notice. (For custom styling.)
            // cornerclass: "", // Class to be added to the notice for corner styling.
            // nonblock: false, // Create a non-blocking notice. It lets the user click elements underneath it.
            // nonblock_opacity: .2, // The opacity of the notice (if it's non-blocking) when the mouse is over it.
            history: false, // Display a pull down menu to redisplay previous notices, and place the notice in the history.
            width: "640px", // Width of the notice.
            // min_height: "16px", // Minimum height of the notice. It will expand to fit content.
            type: "notice", // Type of the notice. "notice", "info", "success", or "error".
            icon: '', // Set icon to true to use the default icon for the selected style/type, false for no icon, or a string for your own icon class.
            // animation: "fade", // The animation to use when displaying and hiding the notice. "none", "show", "fade", and "slide" are built in to jQuery. Others require jQuery UI. Use an object with effect_in and effect_out to use different effects.
            // animate_speed: "slow", // Speed at which the notice animates in and out. "slow", "def" or "normal", "fast" or number of milliseconds.
            // opacity: 1, // Opacity of the notice.
            // shadow: true, // Display a drop shadow.
            closer: true, // Provide a button for the user to manually close the notice.
            closer_hover: false, // Only show the closer button on hover.
            // sticker: true, // Provide a button for the user to manually stick the notice.
            // sticker_hover: true, // Only show the sticker button on hover.
            // hide: true, // After a delay, remove the notice.
            delay: 2500 // Delay in milliseconds before the notice is removed.
                // mouse_reset: true, // Reset the hide timer if the mouse moves over the notice.
                // remove: true, // Remove the notice's elements from the DOM after it is removed.
                // insert_brs: true, // Change new lines to br tags.
                // stack: {"dir1": "down", "dir2": "left", "push": "bottom", "spacing1": 25, "spacing2": 25}
        };
        var current;

        function notice(content) {
            var hash = angular.copy(settings);
            hash.type = 'notice';
            hash.title = content;
            hash.icon = 'iconfont icon-gantanhao';
            return this.notify(hash);
        };

        function info(content) {
            var hash = angular.copy(settings);
            hash.type = 'info';
            hash.title = content;
            hash.icon = 'iconfont icon-info';
            return this.notify(hash);
        };

        function success(content) {
            var hash = angular.copy(settings);
            hash.type = 'success';
            hash.title = content;
            hash.icon = 'iconfont icon-chenggong';
            return this.notify(hash);
        };

        function error(content) {
            var hash = angular.copy(settings);
            hash.type = 'error';
            hash.icon = 'iconfont icon-shixinguanbi'
            hash.title = content;
            return this.notify(hash);
        };

        function notify(hash) {
            if (current) {
                var old = current;
                setTimeout(function() {
                    old.remove();
                }, 5000);
            }
            current = new PNotify(hash);
            return current;

            var modalInstance = $uibModal.open({
                template: '<div class="modal-body">' + //
                    '<div class="row" style="text-align:center;">' + //
                    '<h3>' + hash.title + '</h3>' + //
                    '</div>' + //
                    '</div>',
            });
        };

        function loading() {
            return $uibModal.open({
                templateUrl: 'app/entities/message/messageLoading.html',
                backdrop: 'static',
                keyboard: false,
                windowClass: 'loading-window'
            });
        };

        function confirm(obj,confirmCallback, cancelCallback, translate) {

            var ModalInstanceCtrl = ['$scope', '$uibModalInstance',
                function($scope, $uibModalInstance) {
                    $scope.obj = obj;
                    $scope.ok = function() {
                        $uibModalInstance.close('ok');
                    };

                    $scope.cancel = function(flag) {
                        $uibModalInstance.dismiss(flag);
                    };
                }
            ];
            var modalInstance = $uibModal.open({
                templateUrl: 'app/entities/message/messageConfirm.html',
                controller: ModalInstanceCtrl,
                windowClass: 'confirm-window'
            });


            modalInstance.result.then(function() {
                if (typeof confirmCallback == 'function') {
                    confirmCallback();
                }
            }, function(flag) {
                if (typeof cancelCallback == 'function') {
                    cancelCallback(flag);
                }
            });

        };

        function successConfirm(msg, confirmCallback, translate) {
            var ModalInstanceCtrl = ['$scope', '$uibModalInstance',
                function($scope, $uibModalInstance) {

                    $scope.ok = function() {
                        $uibModalInstance.close('ok');
                    };

                }
            ];

            if(!!translate){
                 var modalInstance = $uibModal.open({
                    template: '<div class="modal-body">' + //
                        '<div class="row" style="text-align:center;">' + //
                        '<h3 style="cursor:pointer;" ng-click="ok()"><label translate='+msg+'></label></h3>',
                    controller: ModalInstanceCtrl
                });
            }else{
                var modalInstance = $uibModal.open({
                    template: '<div class="modal-body">' + //
                        '<div class="row" style="text-align:center;">' + //
                        '<h3 style="cursor:pointer;" ng-click="ok()">' + msg + '</h3>',
                    controller: ModalInstanceCtrl
                });
            }



            modalInstance.result.then(function() {
                if (typeof confirmCallback == 'function') {
                    confirmCallback();
                }
            });
        };

        function comment(msg, confirmCallback, cancelCallback, commentMust, translate) {
            var ModalInstanceCtrl = ['$scope', '$uibModalInstance', '$timeout',
                function($scope, $uibModalInstance, $timeout) {
                    $scope.ok = function(comment) {
                        if (commentMust && !comment) {
                            // return self.error('评论必填');
                            $scope.error = true;
                            return;
                        }
                        $scope.error = false;
                        $uibModalInstance.close(comment);
                    };
                    if (commentMust) {
                        $scope.placeholderMsg = "请输入评论(必填)";
                    } else {
                        $scope.placeholderMsg = "请输入评论(可空)";
                    }

                    $scope.cancel = function() {
                        $uibModalInstance.dismiss('cancel');
                    };
                    $timeout(function() {
                        $scope.$apply();
                    });
                }
            ];

            if(!!translate){
                var modalInstance = $uibModal.open({
                    template: '<div class="modal-body">' + //
                        '<div class="row" style="text-align:center;">' + //
                        '<h3><label translate='+msg+'></label></h3>' + //
                        '<input type="text" class="form-control highlight" ng-model="comment" placeholder="{{placeholderMsg}}">' + //
                        '<span style="color:red;float:left;margin-left:10px;" ng-show="error">必填</span>' + //
                        '</div>' + //
                        '<div class="row">' + //
                        '<button class="btn btn-warning pull-right" ng-click="cancel()">取消</button>' + //
                        '<button class="btn btn-primary pull-right" ng-click="ok(comment)">确认</button>' + //
                        '</div>' + //
                        '</div>',
                    controller: ModalInstanceCtrl
                });
            }else{
                var modalInstance = $uibModal.open({
                    template: '<div class="modal-body">' + //
                        '<div class="row" style="text-align:center;">' + //
                        '<h3>' + msg + '</h3>' + //
                        '<input type="text" class="form-control highlight" ng-model="comment" placeholder="{{placeholderMsg}}">' + //
                        '<span style="color:red;float:left;margin-left:10px;" ng-show="error">必填</span>' + //
                        '</div>' + //
                        '<div class="row">' + //
                        '<button class="btn btn-warning pull-right" ng-click="cancel()">取消</button>' + //
                        '<button class="btn btn-primary pull-right" ng-click="ok(comment)">确认</button>' + //
                        '</div>' + //
                        '</div>',
                    controller: ModalInstanceCtrl
                });
            }

            modalInstance.result.then(function(comment) {
                if (typeof confirmCallback == 'function') {
                    confirmCallback(comment);
                }
            }, function() {
                if (typeof cancelCallback == 'function') {
                    cancelCallback();
                }
            });
        };
        return service;
    }

})();

(function() {
	'use strict';
	angular
		.module('platformApp')
		.factory('ListService', ListService);

	ListService.$inject = [];

	function ListService() {
		var service = {
			inList: inList,
			inList2 :inList2,
			removeEmptyInList: removeEmptyInList
		};
		return service;

		function inList2(value, list, valueAttr , listAttr) {
			if (list) {
				for (var i = list.length - 1; i >= 0; i--) {
					var v = list[i];
					if (valueAttr && listAttr) {
						if (v && value[valueAttr] == v[listAttr]) {
							return v;
						};
					} else {
						if (v && v.id == value.id) {
							return v;
						}
					}
				}
			}
		}

		function inList(value, list, attrList) {
			if (list) {
				for (var i = list.length - 1; i >= 0; i--) {
					var v = list[i];
					if (attrList) {
						if (v) {
							var match = 0;
							for (var j = 0; attrList && j < attrList.length; j++) {
								var attr = attrList[j];
								if (attr) {
									if (v[attr] == value[attr]) {
										match++;
									} else {
										break;
									}
								}
							}
							if (match == attrList.length) {
								return v;
							}
						}
					} else {
						if (v && v.id == value.id) {
							return v;
						}
					}
				}
			}
		}

		function removeEmptyInList(list, key) {
			if (!list) return;
			for (var i = 0; i < list.length; i++) {
				var item = list[i];
				if (item && !item[key]) {
					list.splice(i, 1);
					i--;
				}
			}
		}
	}



})();

/**
 * jquery.bookblock.js v2.0.1
 * http://www.codrops.com
 *
 * Licensed under the MIT license.
 * http://www.opensource.org/licenses/mit-license.php
 *
 * Copyright 2013, Codrops
 * http://www.codrops.com
 */
;( function( $, window, undefined ) {

    'use strict';

    // global
    var $window = $(window),
        Modernizr = window.Modernizr;

    // https://gist.github.com/edankwan/4389601
    Modernizr.addTest('csstransformspreserve3d', function () {
        var prop = Modernizr.prefixed('transformStyle');
        var val = 'preserve-3d';
        var computedStyle;
        if(!prop) return false;

        prop = prop.replace(/([A-Z])/g, function(str,m1){ return '-' + m1.toLowerCase(); }).replace(/^ms-/,'-ms-');

        Modernizr.testStyles('#modernizr{' + prop + ':' + val + ';}', function (el, rule) {
            computedStyle = window.getComputedStyle ? getComputedStyle(el, null).getPropertyValue(prop) : '';
        });

        return (computedStyle === val);
    });

    /*
    * debouncedresize: special jQuery event that happens once after a window resize
    *
    * latest version and complete README available on Github:
    * https://github.com/louisremi/jquery-smartresize
    *
    * Copyright 2012 @louis_remi
    * Licensed under the MIT license.
    *
    * This saved you an hour of work?
    * Send me music http://www.amazon.co.uk/wishlist/HNTU0468LQON
    */
    var $event = $.event,
        $special,
        resizeTimeout;

    $special = $event.special.debouncedresize = {
        setup: function() {
            $( this ).on( "resize", $special.handler );
        },
        teardown: function() {
            $( this ).off( "resize", $special.handler );
        },
        handler: function( event, execAsap ) {
            // Save the context
            var context = this,
                args = arguments,
                dispatch = function() {
                    // set correct event type
                    event.type = "debouncedresize";
                    $event.dispatch.apply( context, args );
                };

            if ( resizeTimeout ) {
                clearTimeout( resizeTimeout );
            }

            execAsap ?
                dispatch() :
                resizeTimeout = setTimeout( dispatch, $special.threshold );
        },
        threshold: 150
    };

    $.BookBlock = function( options, element ) {
        this.$el = $( element );
        this._init( options );
    };

    // the options
    $.BookBlock.defaults = {
        // vertical or horizontal flip
        orientation : 'vertical',
        // ltr (left to right) or rtl (right to left)
        direction : 'ltr',
        // speed for the flip transition in ms
        speed : 1000,
        // easing for the flip transition
        easing : 'ease-in-out',
        // if set to true, both the flipping page and the sides will have an overlay to simulate shadows
        shadows : true,
        // opacity value for the "shadow" on both sides (when the flipping page is over it)
        // value : 0.1 - 1
        shadowSides : 0.2,
        // opacity value for the "shadow" on the flipping page (while it is flipping)
        // value : 0.1 - 1
        shadowFlip : 0.1,
        // if we should show the first item after reaching the end
        circular : false,
        // if we want to specify a selector that triggers the next() function. example: ´#bb-nav-next´
        nextEl : '',
        // if we want to specify a selector that triggers the prev() function
        prevEl : '',
        // autoplay. If true it overwrites the circular option to true
        autoplay : false,
        // time (ms) between page switch, if autoplay is true
        interval : 3000,
        // callback after the flip transition
        // old is the index of the previous item
        // page is the current item´s index
        // isLimit is true if the current page is the last one (or the first one)
        onEndFlip : function(old, page, isLimit) { return false; },
        // callback before the flip transition
        // page is the current item´s index
        onBeforeFlip : function(page) { return false; }
    };

    $.BookBlock.prototype = {
        _init : function(options) {
            // options
            this.options = $.extend( true, {}, $.BookBlock.defaults, options );
            // orientation class
            this.$el.addClass( 'bb-' + this.options.orientation );
            // items
            this.$items = this.$el.children( '.bb-item' ).hide();
            // total items
            this.itemsCount = this.$items.length;
            // current item´s index
            this.current = 0;
            // previous item´s index
            this.previous = -1;
            // show first item
            this.$current = this.$items.eq( this.current ).show();
            // get width of this.$el
            // this will be necessary to create the flipping layout
            this.elWidth = this.$el.width();
            var transEndEventNames = {
                'WebkitTransition': 'webkitTransitionEnd',
                'MozTransition': 'transitionend',
                'OTransition': 'oTransitionEnd',
                'msTransition': 'MSTransitionEnd',
                'transition': 'transitionend'
            };
            this.transEndEventName = transEndEventNames[Modernizr.prefixed( 'transition' )] + '.bookblock';
            // support css 3d transforms && css transitions && Modernizr.csstransformspreserve3d
            this.support = Modernizr.csstransitions && Modernizr.csstransforms3d && Modernizr.csstransformspreserve3d;
            // initialize/bind some events
            this._initEvents();
            // start slideshow
            if ( this.options.autoplay ) {
                this.options.circular = true;
                this._startSlideshow();
            }
        },
        _initEvents : function() {

            var self = this;

            if ( this.options.nextEl !== '' ) {
                $( this.options.nextEl ).on( 'click.bookblock touchstart.bookblock', function() { self._action( 'next' ); return false; } );
            }

            if ( this.options.prevEl !== '' ) {
                $( this.options.prevEl ).on( 'click.bookblock touchstart.bookblock', function() { self._action( 'prev' ); return false; } );
            }

            $window.on( 'debouncedresize', function() {
                // update width value
                self.elWidth = self.$el.width();
            } );

        },
        _action : function( dir, page ) {
            this._stopSlideshow();
            this._navigate( dir, page );
        },
        _navigate : function( dir, page ) {

            if ( this.isAnimating ) {
                return false;
            }

            // callback trigger
            this.options.onBeforeFlip( this.current );

            this.isAnimating = true;
            // update current value
            this.$current = this.$items.eq( this.current );

            if ( page !== undefined ) {
                this.current = page;
            }
            else if ( dir === 'next' && this.options.direction === 'ltr' || dir === 'prev' && this.options.direction === 'rtl' ) {
                if ( !this.options.circular && this.current === this.itemsCount - 1 ) {
                    this.end = true;
                }
                else {
                    this.previous = this.current;
                    this.current = this.current < this.itemsCount - 1 ? this.current + 1 : 0;
                }
            }
            else if ( dir === 'prev' && this.options.direction === 'ltr' || dir === 'next' && this.options.direction === 'rtl' ) {
                if ( !this.options.circular && this.current === 0 ) {
                    this.end = true;
                }
                else {
                    this.previous = this.current;
                    this.current = this.current > 0 ? this.current - 1 : this.itemsCount - 1;
                }
            }

            this.$nextItem = !this.options.circular && this.end ? this.$current : this.$items.eq( this.current );
            if ( !this.support ) {
                this._layoutNoSupport( dir );
            } else {
                this._layout( dir );
            }

        },
        _layoutNoSupport : function(dir) {
            this.$items.hide();
            this.$nextItem.show();
            this.end = false;
            this.isAnimating = false;
            var isLimit = dir === 'next' && this.current === this.itemsCount - 1 || dir === 'prev' && this.current === 0;
            // callback trigger
            this.options.onEndFlip( this.previous, this.current, isLimit );
        },
        // creates the necessary layout for the 3d structure
        _layout : function(dir) {

            var self = this,
                // basic structure: 1 element for the left side.
                $s_left = this._addSide( 'left', dir ),
                // 1 element for the flipping/middle page
                $s_middle = this._addSide( 'middle', dir ),
                // 1 element for the right side
                $s_right = this._addSide( 'right', dir ),
                // overlays
                $o_left = $s_left.find( 'div.bb-overlay' ),
                $o_middle_f = $s_middle.find( 'div.bb-flipoverlay:first' ),
                $o_middle_b = $s_middle.find( 'div.bb-flipoverlay:last' ),
                $o_right = $s_right.find( 'div.bb-overlay' ),
                speed = this.end ? 400 : this.options.speed;
            var partid = this.$current.data('partid');
            var nextPartId = this.$nextItem.data("partid");
            var productType = this.$current.data("producttype");
            if((partid && nextPartId && !productType) || (productType == 'CALENDAR' && ((partid != 'P' && partid != 'B1') || (nextPartId != 'P' && nextPartId != 'B1')))){
                if(partid !== nextPartId){
                    $s_middle.find(".bb-outer").css({overflow: 'inherit'});
                    $s_left.hide();
                    $s_right.hide();
                }
                if(partid !== "P"){
                    if(this.previous === 0 && this.current === 1){
                        $s_right.css({'opacity':0});
                    }
                    if(this.previous === this.itemsCount - 1 &&  this.current === this.itemsCount - 2){
                        $s_left.css({'opacity':0});
                    }
                }
            }
            this.$items.hide();
            this.$el.prepend( $s_left, $s_middle, $s_right );

            $s_middle.css({
                transitionDuration: speed + 'ms',
                transitionTimingFunction : this.options.easing
            }).on( this.transEndEventName, function( event ) {
                if ( $( event.target ).hasClass( 'bb-page' ) ) {
                    self.$el.children( '.bb-page' ).remove();
                    self.$nextItem.show();
                    self.end = false;
                    self.isAnimating = false;
                    var isLimit = dir === 'next' && self.current === self.itemsCount - 1 || dir === 'prev' && self.current === 0;
                    // callback trigger
                    self.options.onEndFlip( self.previous, self.current, isLimit );
                }
            });

            if ( dir === 'prev' ) {
                $s_middle.addClass( 'bb-flip-initial' );
            }

            // overlays
            if (this.options.shadows && !this.end) {

                var o_left_style = (dir === 'next') ? {
                        transition: 'opacity ' + this.options.speed / 2 + 'ms ' + 'linear' + ' ' + this.options.speed / 2 + 'ms'
                    } : {
                        transition: 'opacity ' + this.options.speed / 2 + 'ms ' + 'linear',
                        opacity: this.options.shadowSides
                    },
                    o_middle_f_style = (dir === 'next') ? {
                        transition: 'opacity ' + this.options.speed / 2 + 'ms ' + 'linear'
                    } : {
                        transition: 'opacity ' + this.options.speed / 2 + 'ms ' + 'linear' + ' ' + this.options.speed / 2 + 'ms',
                        opacity: this.options.shadowFlip
                    },
                    o_middle_b_style = (dir === 'next') ? {
                        transition: 'opacity ' + this.options.speed / 2 + 'ms ' + 'linear' + ' ' + this.options.speed / 2 + 'ms',
                        opacity: this.options.shadowFlip
                    } : {
                        transition: 'opacity ' + this.options.speed / 2 + 'ms ' + 'linear'
                    },
                    o_right_style = (dir === 'next') ? {
                        transition: 'opacity ' + this.options.speed / 2 + 'ms ' + 'linear',
                        opacity: this.options.shadowSides
                    } : {
                        transition: 'opacity ' + this.options.speed / 2 + 'ms ' + 'linear' + ' ' + this.options.speed / 2 + 'ms'
                    };

                $o_middle_f.css(o_middle_f_style);
                $o_middle_b.css(o_middle_b_style);
                $o_left.css(o_left_style);
                $o_right.css(o_right_style);

            }

            setTimeout( function() {
                // first && last pages lift slightly up when we can't go further
                $s_middle.addClass( self.end ? 'bb-flip-' + dir + '-end' : 'bb-flip-' + dir );

                // overlays
                if ( self.options.shadows && !self.end ) {

                    $o_middle_f.css({
                        opacity: dir === 'next' ? self.options.shadowFlip : 0
                    });

                    $o_middle_b.css({
                        opacity: dir === 'next' ? 0 : self.options.shadowFlip
                    });

                    $o_left.css({
                        opacity: dir === 'next' ? self.options.shadowSides : 0
                    });

                    $o_right.css({
                        opacity: dir === 'next' ? 0 : self.options.shadowSides
                    });

                }
            }, 25 );
        },
        // adds the necessary sides (bb-page) to the layout
        _addSide : function( side, dir ) {
            var $side;

            switch (side) {
                case 'left':
                    /*
                    <div class="bb-page" style="z-index:102;">
                        <div class="bb-back">
                            <div class="bb-outer">
                                <div class="bb-content">
                                    <div class="bb-inner">
                                        dir==='next' ? [content of current page] : [content of next page]
                                    </div>
                                </div>
                                <div class="bb-overlay"></div>
                            </div>
                        </div>
                    </div>
                    */
                    $side = $('<div class="bb-page"><div class="bb-back"><div class="bb-outer"><div class="bb-content"><div class="bb-inner">' + ( dir === 'next' ? this.$current.html() : this.$nextItem.html() ) + '</div></div><div class="bb-overlay"></div></div></div></div>').css( 'z-index', 102 );
                    break;
                case 'middle':
                    /*
                    <div class="bb-page" style="z-index:103;">
                        <div class="bb-front">
                            <div class="bb-outer">
                                <div class="bb-content">
                                    <div class="bb-inner">
                                        dir==='next' ? [content of current page] : [content of next page]
                                    </div>
                                </div>
                                <div class="bb-flipoverlay"></div>
                            </div>
                        </div>
                        <div class="bb-back">
                            <div class="bb-outer">
                                <div class="bb-content">
                                    <div class="bb-inner">
                                        dir==='next' ? [content of next page] : [content of current page]
                                    </div>
                                </div>
                                <div class="bb-flipoverlay"></div>
                            </div>
                        </div>
                    </div>
                    */
                    $side = $('<div class="bb-page"><div class="bb-front"><div class="bb-outer"><div class="bb-content"><div class="bb-inner">' + (dir === 'next' ? this.$current.html() : this.$nextItem.html()) + '</div></div><div class="bb-flipoverlay"></div></div></div><div class="bb-back"><div class="bb-outer"><div class="bb-content" style="width:' + this.elWidth + 'px"><div class="bb-inner">' + ( dir === 'next' ? this.$nextItem.html() : this.$current.html() ) + '</div></div><div class="bb-flipoverlay"></div></div></div></div>').css( 'z-index', 103 );
                    break;
                case 'right':
                    /*
                    <div class="bb-page" style="z-index:101;">
                        <div class="bb-front">
                            <div class="bb-outer">
                                <div class="bb-content">
                                    <div class="bb-inner">
                                        dir==='next' ? [content of next page] : [content of current page]
                                    </div>
                                </div>
                                <div class="bb-overlay"></div>
                            </div>
                        </div>
                    </div>
                    */
                    $side = $('<div class="bb-page"><div class="bb-front"><div class="bb-outer"><div class="bb-content"><div class="bb-inner">' + ( dir === 'next' ? this.$nextItem.html() : this.$current.html() ) + '</div></div><div class="bb-overlay"></div></div></div></div>').css( 'z-index', 101 );
                    break;
            }

            return $side;
        },
        _startSlideshow : function() {
            var self = this;
            this.slideshow = setTimeout( function() {
                self._navigate( 'next' );
                if ( self.options.autoplay ) {
                    self._startSlideshow();
                }
            }, this.options.interval );
        },
        _stopSlideshow : function() {
            if ( this.options.autoplay ) {
                clearTimeout( this.slideshow );
                this.options.autoplay = false;
            }
        },
        // public method: flips next
        next : function() {
            this._action( this.options.direction === 'ltr' ? 'next' : 'prev' );
        },
        // public method: flips back
        prev : function() {
            this._action( this.options.direction === 'ltr' ? 'prev' : 'next' );
        },
        // public method: goes to a specific page
        jump : function( page ) {

            page -= 1;

            if ( page === this.current || page >= this.itemsCount || page < 0 ) {
                return false;
            }

            var dir;
            if( this.options.direction === 'ltr' ) {
                dir = page > this.current ? 'next' : 'prev';
            }
            else {
                dir = page > this.current ? 'prev' : 'next';
            }
            this._action( dir, page );

        },
        // public method: goes to the last page
        last : function() {
            this.jump( this.itemsCount );
        },
        // public method: goes to the first page
        first : function() {
            this.jump( 1 );
        },
        // public method: check if isAnimating is true
        isActive: function() {
            return this.isAnimating;
        },
        // public method: dynamically adds new elements
        // call this method after inserting new "bb-item" elements inside the BookBlock
        update : function () {
            var $currentItem = this.$items.eq( this.current );
            this.$items = this.$el.children( '.bb-item' );
            this.itemsCount = this.$items.length;
            this.current = $currentItem.index();
        },
        destroy : function() {
            if ( this.options.autoplay ) {
                this._stopSlideshow();
            }
            this.$el.removeClass( 'bb-' + this.options.orientation );
            this.$items.show();

            if ( this.options.nextEl !== '' ) {
                $( this.options.nextEl ).off( '.bookblock' );
            }

            if ( this.options.prevEl !== '' ) {
                $( this.options.prevEl ).off( '.bookblock' );
            }

            $window.off( 'debouncedresize' );
        }
    }

    var logError = function( message ) {
        if ( window.console ) {
            window.console.error( message );
        }
    };

    $.fn.bookblock = function( options ) {
        if ( typeof options === 'string' ) {
            var args = Array.prototype.slice.call( arguments, 1 );
            this.each(function() {
                var instance = $.data( this, 'bookblock' );
                if ( !instance ) {
                    logError( "cannot call methods on bookblock prior to initialization; " +
                        "attempted to call method '" + options + "'" );
                    return;
                }
                if ( !$.isFunction( instance[options] ) || options.charAt(0) === "_" ) {
                    logError( "no such method '" + options + "' for bookblock instance" );
                    return;
                }
                instance[ options ].apply( instance, args );
            });
        }
        else {
            this.each(function() {
                var instance = $.data( this, 'bookblock' );
                if ( instance ) {
                    instance._init();
                }
                else {
                    instance = $.data( this, 'bookblock', new $.BookBlock( options, this ) );
                }
            });
        }
        return this;
    };

} )( jQuery, window );

(function() {
    'use strict';

    var jhiItemCount = {
        template: '<div class="info" data-translate="global.item-count" ' +
        'translate-value-first="{{(($ctrl.page - 1) * $ctrl.itemsPerPage) === 0 ? 1 : (($ctrl.page - 1) * $ctrl.itemsPerPage + 1)}}" ' +
        'translate-value-second="{{($ctrl.page * $ctrl.itemsPerPage) < $ctrl.queryCount ? ($ctrl.page * $ctrl.itemsPerPage) : $ctrl.queryCount}}" ' +
        'translate-value-total="{{$ctrl.queryCount}}">' +
        'Showing {{(($ctrl.page - 1) * $ctrl.itemsPerPage) == 0 ? 1 : (($ctrl.page - 1) * $ctrl.itemsPerPage + 1)}} - ' +
        '{{($ctrl.page * $ctrl.itemsPerPage) < $ctrl.queryCount ? ($ctrl.page * $ctrl.itemsPerPage) : $ctrl.queryCount}} ' +
        'of {{$ctrl.queryCount}} items.' +
        '</div>',
        bindings: {
            page: '<',
            queryCount: '<total',
            itemsPerPage: '<'
        }
    };

    angular
        .module('platformApp')
        .component('jhiItemCount', jhiItemCount);
})();


var Image2Path = (function() {

	var threshold = 100;
	var bm = null,
      pathlist = [],
      callback,
      renderID = -1,
      info = {
        isReady: false,
        turnpolicy: "minority", 
        turdsize: 2,
        optcurve: true,
        alphamax: 1,
        opttolerance: 0.2
      };

	function Point(x, y) {
	    this.x = x;
	    this.y = y;
	}
	  
	Point.prototype.copy = function(){
	    return new Point(this.x, this.y);
	};

	function Bitmap(w, h) {
	    this.w = w;
	    this.h = h;
	    this.size = w * h;
	    this.arraybuffer = new ArrayBuffer(this.size);
	    this.data = new Int8Array(this.arraybuffer);
	}

	Bitmap.prototype.at = function (x, y) {
	    return (x >= 0 && x < this.w && y >=0 && y < this.h) && 
	        this.data[this.w * y + x] === 1;
	};

	Bitmap.prototype.index = function(i) {
	    var point = new Point();
	    point.y = Math.floor(i / this.w);
	    point.x = i - point.y * this.w;
	    return point;
	};

	Bitmap.prototype.flip = function(x, y) {
	    if (this.at(x, y)) {
	      this.data[this.w * y + x] = 0;
	    } else {
	      this.data[this.w * y + x] = 1;
	    }
	};
	    
	Bitmap.prototype.copy = function() {
	    var bm = new Bitmap(this.w, this.h), i;
	    for (i = 0; i < this.size; i++) {
	      bm.data[i] = this.data[i];
	    }
	    return bm;
	};

	function Path() {
	    this.area = 0;
	    this.len = 0;
	    this.curve = {};
	    this.pt = [];
	    this.minX = 100000;
	    this.minY = 100000;
	    this.maxX= -1;
	    this.maxY = -1;
	}

	function Curve(n) {
	    this.n = n;
	    this.tag = new Array(n);
	    this.c = new Array(n * 3);
	    this.alphaCurve = 0;
	    this.vertex = new Array(n);
	    this.alpha = new Array(n);
	    this.alpha0 = new Array(n);
	    this.beta = new Array(n);
	}

	function fetchPathFromImage(imageUrl, w, h) {
		return internalFetch(imageUrl, w, h);
	}

	function internalFetch(imageUrl, w, h) {
		var promise = new Promise(function (resolve, reject) {
			try {
				getPathFromImage(imageUrl, w, h, function (data) {
					resolve(data);
				});
			} catch (e) {
				reject(e);
			}

		});
		return promise;
	}

	function getPathFromImage(imageUrl, w, h, callback) {
		if (info.isReady) {
			clear();
		}
		if (!imageUrl) {
			if (callback) {
				callback(null, "invalid imageUrl");
			}
		}
		
		// image load
		var image = new Image();
		image.onerror = function (err) {
			if (callback) {
				callback(null, err);
			}
		}
		image.src = imageUrl;
		image.setAttribute("crossOrigin",'Anonymous');
		image.onload = function() {
			var width = image.width;
			var height = image.height;
			if (w && w > 0) {
				width = w;
			}
			if (h && h > 0) {
				height = h;
			}
			var canvas = document.createElement("canvas");
			canvas.width = width;
			canvas.height = height;

			var context = canvas.getContext('2d');
			context.drawImage(image, 0, 0, image.width, image.height, 0, 0, width, height);

			var pixels = context.getImageData(0, 0, width, height);
			var data = pixels.data;
			for (var i = 0; i < data.length; i += 4) {
				var red = data[i];
				var green = data[i+1];
				var blue = data[i+2];
				var alpha = data[i+3];

				// 转为白底黑色内容
				if (alpha > threshold) {
					// 不透明的为黑色内容
					// if (( 0.2126 * red + 0.7152 * green + 0.0722 * blue ) >= threshold) {
					// 	data[i] = data[i+1] = data[i+2] = 0;
					// } else {
					// 	data[i] = data[i+1] = data[i+2] = 255;
					// }
					data[i] = data[i + 1] = data[i + 2] = 0;
				}
				else {
					// 透明的为白底
					data[i] = data[i + 1] = data[i+2] = 255;
				}
				data[i+3] = 255;
			}

			context.putImageData(pixels, 0, 0 );

			loadBm(canvas);

			try {
				process(function (res) {
					if (res && res.done) {
						if (callback) {
							callback(pathlist);
						}
					} 
				});
			} catch (e) {
				if (callback) {
					callback(null, e);
				}
			}
		}

		
	}

	function loadBm(canvas) {
		var ctx = canvas.getContext('2d');
	    bm = new Bitmap(canvas.width, canvas.height);
	    var imgdataobj = ctx.getImageData(0, 0, bm.w, bm.h);
	    var l = imgdataobj.data.length, i, j, color;
	    for (i = 0, j = 0; i < l; i += 4, j++) {
	      color = 0.2126 * imgdataobj.data[i] + 0.7153 * imgdataobj.data[i + 1] +
	          0.0721 * imgdataobj.data[i + 2];
	      bm.data[j] = (color < 128 ? 1 : 0);
	    }
	    info.isReady = true;
	}

	function clear() {
	    bm = null;
	    pathlist = [];
	    info.isReady = false;
	    renderID = -1;
	}

	function bmToPathlist() {
	    var bm1 = bm.copy(),
	      currentPoint = new Point(0, 0),
	      path;
	    
	    function findNext(point) {
	      var i = bm1.w * point.y + point.x;
	      while (i < bm1.size && bm1.data[i] !== 1) {
	        i++;
	      }

	      return i < bm1.size && bm1.index(i);
	    }
	    
	    function majority(x, y) {
	      var i, a, ct;
	      for (i = 2; i < 5; i++) {
	        ct = 0;
	        for (a = -i + 1; a <= i - 1; a++) {
	          ct += bm1.at(x + a, y + i - 1) ? 1 : -1;
	          ct += bm1.at(x + i - 1, y + a - 1) ? 1 : -1;
	          ct += bm1.at(x + a - 1, y - i) ? 1 : -1;
	          ct += bm1.at(x - i, y + a) ? 1 : -1;
	        }
	        if (ct > 0) {
	          return 1;
	        } else if (ct < 0) {
	          return 0;
	        }
	      }
	      return 0;
	    }
	    
	    function findPath(point) {
	      var path = new Path(),
	        x = point.x, y = point.y,
	        dirx = 0, diry = 1, tmp;
	      
	      path.sign = bm.at(point.x, point.y) ? "+" : "-";
	      
	      while (1) {
	        path.pt.push(new Point(x, y));
	        if (x > path.maxX)
	          path.maxX = x;
	        if (x < path.minX)
	          path.minX = x;
	        if (y > path.maxY)
	          path.maxY = y;
	        if (y < path.minY)
	          path.minY = y;
	        path.len++;
	        
	        x += dirx;
	        y += diry;
	        path.area -= x * diry;
	        
	        if (x === point.x && y === point.y)
	          break;
	        
	        var l = bm1.at(x + (dirx + diry - 1 ) / 2, y + (diry - dirx - 1) / 2);
	        var r = bm1.at(x + (dirx - diry - 1) / 2, y + (diry + dirx - 1) / 2);
	        
	        if (r && !l) {
	          if (info.turnpolicy === "right" ||
	          (info.turnpolicy === "black" && path.sign === '+') ||
	          (info.turnpolicy === "white" && path.sign === '-') ||
	          (info.turnpolicy === "majority" && majority(x, y)) ||
	          (info.turnpolicy === "minority" && !majority(x, y))) {
	            tmp = dirx;
	            dirx = -diry;
	            diry = tmp;
	          } else {
	            tmp = dirx;
	            dirx = diry;
	            diry = -tmp;
	          }
	        } else if (r) {
	          tmp = dirx;
	          dirx = -diry;
	          diry = tmp;
	        } else if (!l) {
	          tmp = dirx;
	          dirx = diry;
	          diry = -tmp;
	        }
	      }
	      return path;
	    }
	    
	    function xorPath(path){
	      var y1 = path.pt[0].y,
	        len = path.len,
	        x, y, maxX, minY, i, j;
	      for (i = 1; i < len; i++) {
	        x = path.pt[i].x;
	        y = path.pt[i].y;
	        
	        if (y !== y1) {
	          minY = y1 < y ? y1 : y;
	          maxX = path.maxX;
	          for (j = x; j < maxX; j++) {
	            bm1.flip(j, minY);
	          }
	          y1 = y;
	        }
	      }
	      
	    }
	    
	    while (currentPoint = findNext(currentPoint)) {

	      path = findPath(currentPoint);
	      
	      xorPath(path);
	      
	      if (path.area > info.turdsize) {
	        pathlist.push(path);
	      }
	    }
	    
	  }
	  

	  function processPath( firstPathIndex, thisRenderID, doneCallback ) {
	    //cancel render process if another has been started
	    if ( thisRenderID !== renderID ) {
	      if ( callback ) callback ( { aborted: true, renderID: thisRenderID } )
	      return;
	    }
	  
	    function Quad() {
	      this.data = [0,0,0,0,0,0,0,0,0];
	    }

	    Quad.prototype.at = function(x, y) {
	      return this.data[x * 3 + y];
	    };
	    
	    function Sum(x, y, xy, x2, y2) {
	      this.x = x;
	      this.y = y;
	      this.xy = xy;
	      this.x2 = x2;
	      this.y2 = y2;
	    }
	    
	    function mod(a, n) {
	        return a >= n ? a % n : a>=0 ? a : n-1-(-1-a) % n;
	    }
	  
	    function xprod(p1, p2) {
	      return p1.x * p2.y - p1.y * p2.x;
	    }
	    
	    function cyclic(a, b, c) {
	      if (a <= c) {
	        return (a <= b && b < c);
	      } else {
	        return (a <= b || b < c);
	      }
	    }
	      
	    function sign(i) {
	      return i > 0 ? 1 : i < 0 ? -1 : 0;
	    }
	    
	    function quadform(Q, w) {
	      var v = new Array(3), i, j, sum;
	    
	      v[0] = w.x;
	      v[1] = w.y;
	      v[2] = 1;
	      sum = 0.0;
	    
	      for (i=0; i<3; i++) {
	        for (j=0; j<3; j++) {
	          sum += v[i] * Q.at(i, j) * v[j];
	        }
	      }
	      return sum;
	    }
	  
	    function interval(lambda, a, b) {
	      var res = new Point();
	    
	      res.x = a.x + lambda * (b.x - a.x);
	      res.y = a.y + lambda * (b.y - a.y);
	      return res;
	    }
	    
	    function dorth_infty(p0, p2) {
	      var r = new Point();
	      
	      r.y = sign(p2.x - p0.x);
	      r.x = -sign(p2.y - p0.y);
	    
	      return r;
	    }
	    
	    function ddenom(p0, p2) {
	      var r = dorth_infty(p0, p2);
	    
	      return r.y * (p2.x - p0.x) - r.x * (p2.y - p0.y);
	    }
	    
	    function dpara(p0, p1, p2) {
	      var x1, y1, x2, y2;
	    
	      x1 = p1.x - p0.x;
	      y1 = p1.y - p0.y;
	      x2 = p2.x - p0.x;
	      y2 = p2.y - p0.y;
	    
	      return x1 * y2 - x2 * y1;
	    }
	    
	    function cprod(p0, p1, p2, p3) {
	      var x1, y1, x2, y2;
	    
	      x1 = p1.x - p0.x;
	      y1 = p1.y - p0.y;
	      x2 = p3.x - p2.x;
	      y2 = p3.y - p2.y;
	    
	      return x1 * y2 - x2 * y1;
	    }
	      
	    function iprod(p0, p1, p2) {
	      var x1, y1, x2, y2;
	    
	      x1 = p1.x - p0.x;
	      y1 = p1.y - p0.y;
	      x2 = p2.x - p0.x;
	      y2 = p2.y - p0.y;
	    
	      return x1*x2 + y1*y2;
	    }
	      
	    function iprod1(p0, p1, p2, p3) {
	      var x1, y1, x2, y2;
	    
	      x1 = p1.x - p0.x;
	      y1 = p1.y - p0.y;
	      x2 = p3.x - p2.x;
	      y2 = p3.y - p2.y;
	    
	      return x1 * x2 + y1 * y2;
	    }
	    
	    function ddist(p, q) {
	      return Math.sqrt((p.x - q.x) * (p.x - q.x) + (p.y - q.y) * (p.y - q.y));
	    }
	    
	    function bezier(t, p0, p1, p2, p3) {
	      var s = 1 - t, res = new Point();
	    
	      res.x = s*s*s*p0.x + 3*(s*s*t)*p1.x + 3*(t*t*s)*p2.x + t*t*t*p3.x;
	      res.y = s*s*s*p0.y + 3*(s*s*t)*p1.y + 3*(t*t*s)*p2.y + t*t*t*p3.y;
	    
	      return res;
	    }
	  
	    function tangent(p0, p1, p2, p3, q0, q1) {
	      var A, B, C, a, b, c, d, s, r1, r2;
	    
	      A = cprod(p0, p1, q0, q1);
	      B = cprod(p1, p2, q0, q1);
	      C = cprod(p2, p3, q0, q1);
	    
	      a = A - 2 * B + C;
	      b = -2 * A + 2 * B;
	      c = A;
	      
	      d = b * b - 4 * a * c;
	    
	      if (a===0 || d<0) {
	        return -1.0;
	      }
	    
	      s = Math.sqrt(d);
	    
	      r1 = (-b + s) / (2 * a);
	      r2 = (-b - s) / (2 * a);
	    
	      if (r1 >= 0 && r1 <= 1) {
	        return r1;
	      } else if (r2 >= 0 && r2 <= 1) {
	        return r2;
	      } else {
	        return -1.0;
	      }
	    }
	    
	    function calcSums(path) {
	      var i, x, y;
	      path.x0 = path.pt[0].x;
	      path.y0 = path.pt[0].y;
	      
	      path.sums = [];
	      var s = path.sums;
	      s.push(new Sum(0, 0, 0, 0, 0));
	      for(i = 0; i < path.len; i++){
	        x = path.pt[i].x - path.x0;
	        y = path.pt[i].y - path.y0;
	        s.push(new Sum(s[i].x + x, s[i].y + y, s[i].xy + x * y,
	            s[i].x2 + x * x, s[i].y2 + y * y));
	      }
	    }
	   
	    function calcLon(path) {
	      
	      var n = path.len, pt = path.pt, dir,
	        pivk = new Array(n),
	        nc = new Array(n),
	        ct = new Array(4);
	      path.lon = new Array(n);
	      
	      var constraint = [new Point(), new Point()],
	          cur = new Point(),
	          off = new Point(),
	          dk = new Point(),
	          foundk;
	      
	      var i, j, k1, a, b, c, d, k = 0;
	      for(i = n - 1; i >= 0; i--){
	        if (pt[i].x != pt[k].x && pt[i].y != pt[k].y) {
	          k = i + 1;
	        }
	        nc[i] = k;
	      }
	      
	      for (i = n - 1; i >= 0; i--) {
	        ct[0] = ct[1] = ct[2] = ct[3] = 0;
	        dir = (3 + 3 * (pt[mod(i + 1, n)].x - pt[i].x) + 
	            (pt[mod(i + 1, n)].y - pt[i].y)) / 2;
	        ct[dir]++;
	        
	        constraint[0].x = 0;
	        constraint[0].y = 0;
	        constraint[1].x = 0;
	        constraint[1].y = 0;
	        
	        k = nc[i];
	        k1 = i;
	        while (1) {
	          foundk = 0;
	          dir =  (3 + 3 * sign(pt[k].x - pt[k1].x) + 
	              sign(pt[k].y - pt[k1].y)) / 2;
	          ct[dir]++;
	          
	          if (ct[0] && ct[1] && ct[2] && ct[3]) {
	            pivk[i] = k1;
	            foundk = 1;
	            break;
	          }
	          
	          cur.x = pt[k].x - pt[i].x;
	          cur.y = pt[k].y - pt[i].y;
	          
	          if (xprod(constraint[0], cur) < 0 || xprod(constraint[1], cur) > 0) {
	            break;
	          }
	              
	          if (Math.abs(cur.x) <= 1 && Math.abs(cur.y) <= 1) {
	          
	          } else {
	            off.x = cur.x + ((cur.y >= 0 && (cur.y > 0 || cur.x < 0)) ? 1 : -1);
	            off.y = cur.y + ((cur.x <= 0 && (cur.x < 0 || cur.y < 0)) ? 1 : -1);
	            if (xprod(constraint[0], off) >= 0) {
	              constraint[0].x = off.x;
	              constraint[0].y = off.y;
	            }
	            off.x = cur.x + ((cur.y <= 0 && (cur.y < 0 || cur.x < 0)) ? 1 : -1);
	            off.y = cur.y + ((cur.x >= 0 && (cur.x > 0 || cur.y < 0)) ? 1 : -1);
	            if (xprod(constraint[1], off) <= 0) {
	              constraint[1].x = off.x;
	              constraint[1].y = off.y;
	            }
	          }
	          k1 = k;
	          k = nc[k1];
	          if (!cyclic(k, i, k1)) {
	            break;
	          }
	        }
	        if (foundk === 0) {
	          dk.x = sign(pt[k].x-pt[k1].x);
	          dk.y = sign(pt[k].y-pt[k1].y);
	          cur.x = pt[k1].x - pt[i].x;
	          cur.y = pt[k1].y - pt[i].y;
	  
	          a = xprod(constraint[0], cur);
	          b = xprod(constraint[0], dk);
	          c = xprod(constraint[1], cur);
	          d = xprod(constraint[1], dk);
	  
	          j = 10000000;
	          if (b < 0) {
	            j = Math.floor(a / -b);
	          }
	          if (d > 0) {
	            j = Math.min(j, Math.floor(-c / d));
	          }
	          pivk[i] = mod(k1+j,n);
	        }
	      }
	      
	      j=pivk[n-1];
	      path.lon[n-1]=j;
	      for (i=n-2; i>=0; i--) {
	        if (cyclic(i+1,pivk[i],j)) {
	          j=pivk[i];
	        }
	        path.lon[i]=j;
	      }
	  
	      for (i=n-1; cyclic(mod(i+1,n),j,path.lon[i]); i--) {
	        path.lon[i] = j;
	      }
	    }
	    
	    function bestPolygon(path) {
	      
	      function penalty3(path, i, j) {
	        
	        var n = path.len, pt = path.pt, sums = path.sums;
	        var x, y, xy, x2, y2,
	          k, a, b, c, s,
	          px, py, ex, ey,
	          r = 0;
	        if (j>=n) {
	          j -= n;
	          r = 1;
	        }
	        
	        if (r === 0) {
	          x = sums[j+1].x - sums[i].x;
	          y = sums[j+1].y - sums[i].y;
	          x2 = sums[j+1].x2 - sums[i].x2;
	          xy = sums[j+1].xy - sums[i].xy;
	          y2 = sums[j+1].y2 - sums[i].y2;
	          k = j+1 - i;
	        } else {
	          x = sums[j+1].x - sums[i].x + sums[n].x;
	          y = sums[j+1].y - sums[i].y + sums[n].y;
	          x2 = sums[j+1].x2 - sums[i].x2 + sums[n].x2;
	          xy = sums[j+1].xy - sums[i].xy + sums[n].xy;
	          y2 = sums[j+1].y2 - sums[i].y2 + sums[n].y2;
	          k = j+1 - i + n;
	        } 
	      
	        px = (pt[i].x + pt[j].x) / 2.0 - pt[0].x;
	        py = (pt[i].y + pt[j].y) / 2.0 - pt[0].y;
	        ey = (pt[j].x - pt[i].x);
	        ex = -(pt[j].y - pt[i].y);
	      
	        a = ((x2 - 2*x*px) / k + px*px);
	        b = ((xy - x*py - y*px) / k + px*py);
	        c = ((y2 - 2*y*py) / k + py*py);
	        
	        s = ex*ex*a + 2*ex*ey*b + ey*ey*c;
	      
	        return Math.sqrt(s);
	      }
	      
	      var i, j, m, k,    
	      n = path.len,
	      pen = new Array(n + 1),
	      prev = new Array(n + 1),
	      clip0 = new Array(n),
	      clip1 = new Array(n + 1),
	      seg0 = new Array (n + 1),
	      seg1 = new Array(n + 1),
	      thispen, best, c;
	      
	      for (i=0; i<n; i++) {
	        c = mod(path.lon[mod(i-1,n)]-1,n);
	        if (c == i) {
	          c = mod(i+1,n);
	        }
	        if (c < i) {
	          clip0[i] = n;
	        } else {
	          clip0[i] = c;
	        }
	      }
	      
	      j = 1;
	      for (i=0; i<n; i++) {
	        while (j <= clip0[i]) {
	          clip1[j] = i;
	          j++;
	        }
	      }
	      
	      i = 0;
	      for (j=0; i<n; j++) {
	        seg0[j] = i;
	        i = clip0[i];
	      }
	      seg0[j] = n;
	      m = j;
	    
	      i = n;
	      for (j=m; j>0; j--) {
	        seg1[j] = i;
	        i = clip1[i];
	      }
	      seg1[0] = 0;
	      
	      pen[0]=0;
	      for (j=1; j<=m; j++) {
	        for (i=seg1[j]; i<=seg0[j]; i++) {
	          best = -1;
	          for (k=seg0[j-1]; k>=clip1[i]; k--) {
	            thispen = penalty3(path, k, i) + pen[k];
	            if (best < 0 || thispen < best) {
	              prev[i] = k;
	              best = thispen;
	            }
	          }
	          pen[i] = best;
	        }
	      }
	      path.m = m;
	      path.po = new Array(m);
	    
	      for (i=n, j=m-1; i>0; j--) {
	        i = prev[i];
	        path.po[j] = i;
	      }
	    }
	    
	    function adjustVertices(path) {
	      
	      function pointslope(path, i, j, ctr, dir) {
	    
	        var n = path.len, sums = path.sums,
	          x, y, x2, xy, y2,
	          k, a, b, c, lambda2, l, r=0;
	      
	        while (j>=n) {
	          j-=n;
	          r+=1;
	        }
	        while (i>=n) {
	          i-=n;
	          r-=1;
	        }
	        while (j<0) {
	          j+=n;
	          r-=1;
	        }
	        while (i<0) {
	          i+=n;
	          r+=1;
	        }
	        
	        x = sums[j+1].x-sums[i].x+r*sums[n].x;
	        y = sums[j+1].y-sums[i].y+r*sums[n].y;
	        x2 = sums[j+1].x2-sums[i].x2+r*sums[n].x2;
	        xy = sums[j+1].xy-sums[i].xy+r*sums[n].xy;
	        y2 = sums[j+1].y2-sums[i].y2+r*sums[n].y2;
	        k = j+1-i+r*n;
	        
	        ctr.x = x/k;
	        ctr.y = y/k;
	      
	        a = (x2-x*x/k)/k;
	        b = (xy-x*y/k)/k;
	        c = (y2-y*y/k)/k;
	        
	        lambda2 = (a+c+Math.sqrt((a-c)*(a-c)+4*b*b))/2;
	      
	        a -= lambda2;
	        c -= lambda2;
	      
	        if (Math.abs(a) >= Math.abs(c)) {
	          l = Math.sqrt(a*a+b*b);
	          if (l!==0) {
	            dir.x = -b/l;
	            dir.y = a/l;
	          }
	        } else {
	          l = Math.sqrt(c*c+b*b);
	          if (l!==0) {
	            dir.x = -c/l;
	            dir.y = b/l;
	          }
	        }
	        if (l===0) {
	          dir.x = dir.y = 0; 
	        }
	      }
	      
	      var m = path.m, po = path.po, n = path.len, pt = path.pt,
	        x0 = path.x0, y0 = path.y0,
	        ctr = new Array(m), dir = new Array(m),
	        q = new Array(m),
	        v = new Array(3), d, i, j, k, l,
	        s = new Point();
	      
	      path.curve = new Curve(m);
	  
	      for (i=0; i<m; i++) {
	        j = po[mod(i+1,m)];
	        j = mod(j-po[i],n)+po[i];
	        ctr[i] = new Point();
	        dir[i] = new Point();
	        pointslope(path, po[i], j, ctr[i], dir[i]);
	      }
	    
	      for (i=0; i<m; i++) {
	        q[i] = new Quad();
	        d = dir[i].x * dir[i].x + dir[i].y * dir[i].y;
	        if (d === 0.0) {
	          for (j=0; j<3; j++) {
	            for (k=0; k<3; k++) {
	              q[i].data[j * 3 + k] = 0;
	            }
	          }
	        } else {
	          v[0] = dir[i].y;
	          v[1] = -dir[i].x;
	          v[2] = - v[1] * ctr[i].y - v[0] * ctr[i].x;
	          for (l=0; l<3; l++) {
	            for (k=0; k<3; k++) {
	              q[i].data[l * 3 + k] = v[l] * v[k] / d;
	            }
	          }
	        }
	      }
	     
	      var Q, w, dx, dy, det, min, cand, xmin, ymin, z;
	      for (i=0; i<m; i++) {
	        Q = new Quad();
	        w = new Point();
	    
	        s.x = pt[po[i]].x-x0;
	        s.y = pt[po[i]].y-y0;
	    
	        j = mod(i-1,m);
	        
	        for (l=0; l<3; l++) {
	          for (k=0; k<3; k++) {
	            Q.data[l * 3 + k] = q[j].at(l, k) + q[i].at(l, k);
	          }
	        }
	        
	        while(1) {
	          
	          det = Q.at(0, 0)*Q.at(1, 1) - Q.at(0, 1)*Q.at(1, 0);
	          if (det !== 0.0) {
	            w.x = (-Q.at(0, 2)*Q.at(1, 1) + Q.at(1, 2)*Q.at(0, 1)) / det;
	            w.y = ( Q.at(0, 2)*Q.at(1, 0) - Q.at(1, 2)*Q.at(0, 0)) / det;
	            break;
	          }
	    
	          if (Q.at(0, 0)>Q.at(1, 1)) {
	            v[0] = -Q.at(0, 1);
	            v[1] = Q.at(0, 0);
	          } else if (Q.at(1, 1)) {
	            v[0] = -Q.at(1, 1);
	            v[1] = Q.at(1, 0);
	          } else {
	            v[0] = 1;
	            v[1] = 0;
	          }
	          d = v[0] * v[0] + v[1] * v[1];
	          v[2] = - v[1] * s.y - v[0] * s.x;
	          for (l=0; l<3; l++) {
	            for (k=0; k<3; k++) {
	              Q.data[l * 3 + k] += v[l] * v[k] / d;
	            }
	          }
	        }
	        dx = Math.abs(w.x-s.x);
	        dy = Math.abs(w.y-s.y);
	        if (dx <= 0.5 && dy <= 0.5) {
	          path.curve.vertex[i] = new Point(w.x+x0, w.y+y0);
	          continue;
	        }
	    
	        min = quadform(Q, s);
	        xmin = s.x;
	        ymin = s.y;
	    
	        if (Q.at(0, 0) !== 0.0) {
	          for (z=0; z<2; z++) {
	            w.y = s.y-0.5+z;
	            w.x = - (Q.at(0, 1) * w.y + Q.at(0, 2)) / Q.at(0, 0);
	            dx = Math.abs(w.x-s.x);
	            cand = quadform(Q, w);
	            if (dx <= 0.5 && cand < min) {
	              min = cand;
	              xmin = w.x;
	              ymin = w.y;
	            }
	          }
	        }
	  
	        if (Q.at(1, 1) !== 0.0) {
	          for (z=0; z<2; z++) {
	            w.x = s.x-0.5+z;
	            w.y = - (Q.at(1, 0) * w.x + Q.at(1, 2)) / Q.at(1, 1);
	            dy = Math.abs(w.y-s.y);
	            cand = quadform(Q, w);
	            if (dy <= 0.5 && cand < min) {
	              min = cand;
	              xmin = w.x;
	              ymin = w.y;
	            }
	          }
	        }
	  
	        for (l=0; l<2; l++) {
	          for (k=0; k<2; k++) {
	            w.x = s.x-0.5+l;
	            w.y = s.y-0.5+k;
	            cand = quadform(Q, w);
	            if (cand < min) {
	              min = cand;
	              xmin = w.x;
	              ymin = w.y;
	            }
	          }
	        }
	    
	        path.curve.vertex[i] = new Point(xmin + x0, ymin + y0);
	      }
	    }
	    
	    function reverse(path) {
	      var curve = path.curve, m = curve.n, v = curve.vertex, i, j, tmp;
	    
	      for (i=0, j=m-1; i<j; i++, j--) {
	        tmp = v[i];
	        v[i] = v[j];
	        v[j] = tmp;
	      }
	    }
	    
	    function smooth(path) {
	      var m = path.curve.n, curve = path.curve;

	      var i, j, k, dd, denom, alpha,
	        p2, p3, p4;
	    
	      for (i=0; i<m; i++) {
	        j = mod(i+1, m);
	        k = mod(i+2, m);
	        p4 = interval(1/2.0, curve.vertex[k], curve.vertex[j]);
	    
	        denom = ddenom(curve.vertex[i], curve.vertex[k]);
	        if (denom !== 0.0) {
	          dd = dpara(curve.vertex[i], curve.vertex[j], curve.vertex[k]) / denom;
	          dd = Math.abs(dd);
	          alpha = dd>1 ? (1 - 1.0/dd) : 0;
	          alpha = alpha / 0.75;
	        } else {
	          alpha = 4/3.0;
	        }
	        curve.alpha0[j] = alpha;
	    
	        if (alpha >= info.alphamax) { 
	          curve.tag[j] = "CORNER";
	          curve.c[3 * j + 1] = curve.vertex[j];
	          curve.c[3 * j + 2] = p4;
	        } else {
	          if (alpha < 0.55) {
	            alpha = 0.55;
	          } else if (alpha > 1) {
	            alpha = 1;
	          }
	          p2 = interval(0.5+0.5*alpha, curve.vertex[i], curve.vertex[j]);
	          p3 = interval(0.5+0.5*alpha, curve.vertex[k], curve.vertex[j]);
	          curve.tag[j] = "CURVE";
	          curve.c[3 * j + 0] = p2;
	          curve.c[3 * j + 1] = p3;
	          curve.c[3 * j + 2] = p4;
	        }
	        curve.alpha[j] = alpha;  
	        curve.beta[j] = 0.5;
	      }
	      curve.alphacurve = 1;
	    }
	    
	    function optiCurve(path) {
	      function Opti(){
	        this.pen = 0;
	        this.c = [new Point(), new Point()];
	        this.t = 0;
	        this.s = 0;
	        this.alpha = 0;
	      }
	      
	      function opti_penalty(path, i, j, res, opttolerance, convc, areac) {
	        var m = path.curve.n, curve = path.curve, vertex = curve.vertex, 
	          k, k1, k2, conv, i1,
	          area, alpha, d, d1, d2,
	          p0, p1, p2, p3, pt,
	          A, R, A1, A2, A3, A4,
	          s, t;
	      
	        if (i==j) {
	          return 1;
	        }
	      
	        k = i;
	        i1 = mod(i+1, m);
	        k1 = mod(k+1, m);
	        conv = convc[k1];
	        if (conv === 0) {
	          return 1;
	        }
	        d = ddist(vertex[i], vertex[i1]);
	        for (k=k1; k!=j; k=k1) {
	          k1 = mod(k+1, m);
	          k2 = mod(k+2, m);
	          if (convc[k1] != conv) {
	            return 1;
	          }
	          if (sign(cprod(vertex[i], vertex[i1], vertex[k1], vertex[k2])) !=
	              conv) {
	            return 1;
	          }
	          if (iprod1(vertex[i], vertex[i1], vertex[k1], vertex[k2]) <
	              d * ddist(vertex[k1], vertex[k2]) * -0.999847695156) {
	            return 1;
	          }
	        }
	    
	        p0 = curve.c[mod(i,m) * 3 + 2].copy();
	        p1 = vertex[mod(i+1,m)].copy();
	        p2 = vertex[mod(j,m)].copy();
	        p3 = curve.c[mod(j,m) * 3 + 2].copy();
	      
	        area = areac[j] - areac[i];
	        area -= dpara(vertex[0], curve.c[i * 3 + 2], curve.c[j * 3 + 2])/2;
	        if (i>=j) {
	          area += areac[m];
	        }
	      
	        A1 = dpara(p0, p1, p2);
	        A2 = dpara(p0, p1, p3);
	        A3 = dpara(p0, p2, p3);
	  
	        A4 = A1+A3-A2;    
	        
	        if (A2 == A1) {
	          return 1;
	        }
	      
	        t = A3/(A3-A4);
	        s = A2/(A2-A1);
	        A = A2 * t / 2.0;
	        
	        if (A === 0.0) {
	          return 1;
	        }
	      
	        R = area / A;
	        alpha = 2 - Math.sqrt(4 - R / 0.3);
	      
	        res.c[0] = interval(t * alpha, p0, p1);
	        res.c[1] = interval(s * alpha, p3, p2);
	        res.alpha = alpha;
	        res.t = t;
	        res.s = s;
	      
	        p1 = res.c[0].copy();
	        p2 = res.c[1].copy(); 
	      
	        res.pen = 0;
	      
	        for (k=mod(i+1,m); k!=j; k=k1) {
	          k1 = mod(k+1,m);
	          t = tangent(p0, p1, p2, p3, vertex[k], vertex[k1]);
	          if (t<-0.5) {
	            return 1;
	          }
	          pt = bezier(t, p0, p1, p2, p3);
	          d = ddist(vertex[k], vertex[k1]);
	          if (d === 0.0) {
	            return 1;
	          }
	          d1 = dpara(vertex[k], vertex[k1], pt) / d;
	          if (Math.abs(d1) > opttolerance) {
	            return 1;
	          }
	          if (iprod(vertex[k], vertex[k1], pt) < 0 ||
	              iprod(vertex[k1], vertex[k], pt) < 0) {
	            return 1;
	          }
	          res.pen += d1 * d1;
	        }
	      
	        for (k=i; k!=j; k=k1) {
	          k1 = mod(k+1,m);
	          t = tangent(p0, p1, p2, p3, curve.c[k * 3 + 2], curve.c[k1 * 3 + 2]);
	          if (t<-0.5) {
	            return 1;
	          }
	          pt = bezier(t, p0, p1, p2, p3);
	          d = ddist(curve.c[k * 3 + 2], curve.c[k1 * 3 + 2]);
	          if (d === 0.0) {
	            return 1;
	          }
	          d1 = dpara(curve.c[k * 3 + 2], curve.c[k1 * 3 + 2], pt) / d;
	          d2 = dpara(curve.c[k * 3 + 2], curve.c[k1 * 3 + 2], vertex[k1]) / d;
	          d2 *= 0.75 * curve.alpha[k1];
	          if (d2 < 0) {
	            d1 = -d1;
	            d2 = -d2;
	          }
	          if (d1 < d2 - opttolerance) {
	            return 1;
	          }
	          if (d1 < d2) {
	            res.pen += (d1 - d2) * (d1 - d2);
	          }
	        }
	      
	        return 0;
	      }
	    
	      var curve = path.curve, m = curve.n, vert = curve.vertex, 
	        pt = new Array(m + 1),
	        pen = new Array(m + 1),
	        len = new Array(m + 1),
	        opt = new Array(m + 1),
	        om, i,j,r,
	        o = new Opti(), p0,
	        i1, area, alpha, ocurve,
	        s, t;
	      
	      var convc = new Array(m), areac = new Array(m + 1);
	      
	      for (i=0; i<m; i++) {
	        if (curve.tag[i] == "CURVE") {
	          convc[i] = sign(dpara(vert[mod(i-1,m)], vert[i], vert[mod(i+1,m)]));
	        } else {
	          convc[i] = 0;
	        }
	      }
	    
	      area = 0.0;
	      areac[0] = 0.0;
	      p0 = curve.vertex[0];
	      for (i=0; i<m; i++) {
	        i1 = mod(i+1, m);
	        if (curve.tag[i1] == "CURVE") {
	          alpha = curve.alpha[i1];
	          area += 0.3 * alpha * (4-alpha) *
	              dpara(curve.c[i * 3 + 2], vert[i1], curve.c[i1 * 3 + 2])/2;
	          area += dpara(p0, curve.c[i * 3 + 2], curve.c[i1 * 3 + 2])/2;
	        }
	        areac[i+1] = area;
	      }
	    
	      pt[0] = -1;
	      pen[0] = 0;
	      len[0] = 0;
	    
	    
	      for (j=1; j<=m; j++) {
	        pt[j] = j-1;
	        pen[j] = pen[j-1];
	        len[j] = len[j-1]+1;
	    
	        for (i=j-2; i>=0; i--) {
	          r = opti_penalty(path, i, mod(j,m), o, info.opttolerance, convc, 
	              areac);
	          if (r) {
	            break;
	          }
	            if (len[j] > len[i]+1 ||
	                (len[j] == len[i]+1 && pen[j] > pen[i] + o.pen)) {
	              pt[j] = i;
	              pen[j] = pen[i] + o.pen;
	              len[j] = len[i] + 1;
	              opt[j] = o;
	              o = new Opti();
	            }
	        }
	      }
	      om = len[m];
	      ocurve = new Curve(om);
	      s = new Array(om);
	      t = new Array(om);
	    
	      j = m;
	      for (i=om-1; i>=0; i--) {
	        if (pt[j]==j-1) {
	          ocurve.tag[i]     = curve.tag[mod(j,m)];
	          ocurve.c[i * 3 + 0]    = curve.c[mod(j,m) * 3 + 0];
	          ocurve.c[i * 3 + 1]    = curve.c[mod(j,m) * 3 + 1];
	          ocurve.c[i * 3 + 2]    = curve.c[mod(j,m) * 3 + 2];
	          ocurve.vertex[i]  = curve.vertex[mod(j,m)];
	          ocurve.alpha[i]   = curve.alpha[mod(j,m)];
	          ocurve.alpha0[i]  = curve.alpha0[mod(j,m)];
	          ocurve.beta[i]    = curve.beta[mod(j,m)];
	          s[i] = t[i] = 1.0;
	        } else {
	          ocurve.tag[i] = "CURVE";
	          ocurve.c[i * 3 + 0] = opt[j].c[0];
	          ocurve.c[i * 3 + 1] = opt[j].c[1];
	          ocurve.c[i * 3 + 2] = curve.c[mod(j,m) * 3 + 2];
	          ocurve.vertex[i] = interval(opt[j].s, curve.c[mod(j,m) * 3 + 2],
	                                       vert[mod(j,m)]);
	          ocurve.alpha[i] = opt[j].alpha;
	          ocurve.alpha0[i] = opt[j].alpha;
	          s[i] = opt[j].s;
	          t[i] = opt[j].t;
	        }
	        j = pt[j];
	      }
	    
	      for (i=0; i<om; i++) {
	        i1 = mod(i+1,om);
	        ocurve.beta[i] = s[i] / (s[i] + t[i1]);
	      }
	      ocurve.alphacurve = 1;
	      path.curve = ocurve;
	    }

	    var percent = parseInt( pathlist.length / 20 );

	    for (var i = firstPathIndex || 0; i < pathlist.length; i++) {
	      var path = pathlist[i];
	      calcSums(path);
	      calcLon(path);
	      bestPolygon(path);
	      adjustVertices(path);
	      
	      if (path.sign === "-") {
	        reverse(path);
	      }
	      
	      smooth(path);
	      
	      if (info.optcurve) {
	        optiCurve(path);
	      }

	      //call callback on every 2.5% percentage change of progress
	      if ( i && ! ( i % percent ) && typeof callback === 'function' ) {
	        callback( {
	          progress: parseInt( Math.ceil( i * 100 / pathlist.length ) ),
	          continueProcess: function() {
	            processPath( i + 1, thisRenderID, doneCallback );
	          }
	        } );

	        break;
	      }
	    }

	    if ( i === pathlist.length && typeof doneCallback === 'function' ) doneCallback();
	  
	}

	function process(callback) {
		//store render ID so we can cancel any outstanding renders
		renderID++;

		bmToPathlist();
		processPath( 0, renderID, function() {
			if (callback) {
		  		callback( { done:true } );
				}
		} );

		return renderID;
	}

	return {
		fetchPathFromImage: fetchPathFromImage,
		getPathFromImage: getPathFromImage
	}

})();
// browserify support
if ( typeof module === 'object' ) {

  module.exports = Image2Path;

}
/**
 * Created by rae on 3/26/2018.
 */
window.angular.module('image.service', []).
factory('ImageService', ['$location', '$http', '$timeout', '$rootScope', '$state',
    function ($location, $http, $timeout, $rootScope, $state) {

        /**
         * png,jpg等图片格式转base64
         * @param url
         * @param callback
         * @param outputFormat
         */
        this.convertImgToBase64 = function (url, callback, outputFormat) {
            var canvas = document.createElement('CANVAS'),
                ctx = canvas.getContext('2d'),
                img = new Image;
            img.crossOrigin = 'Anonymous';
            img.setAttribute('crossOrigin', 'anonymous');
            img.onload = function () {
                canvas.height = img.height;
                canvas.width = img.width;
                ctx.imageSmoothingEnabled = true;
                ctx.mozImageSmoothingEnabled = true;
                ctx.webkitImageSmoothingEnabled = true;
                ctx.msImageSmoothingEnabled = true;
                ctx.drawImage(img, 0, 0);
                var dataURL = canvas.toDataURL(outputFormat || 'image/png');
                // callback.call(this, dataURL);
                callback.call(this, dataURLtoBlobs(dataURL));
                canvas = null;
            };
            img.src = url;
        };

        /**
         * base64转Blob
         * @param dataurl
         * @returns {*}
         */
        this.dataURLtoBlob=function(dataurl) {
            return dataURLtoBlobs(dataurl);
        };
        function dataURLtoBlobs(dataurl) {
            var arr = dataurl.split(','),
                bstr = atob(arr[1]), n = bstr.length, u8arr = new Uint8Array(n);
            while (n--) {
                u8arr[n] = bstr.charCodeAt(n);
            }
            var createObjectURL = function (blob) {
                return window[window.webkitURL ? 'webkitURL' : 'URL']['createObjectURL'](blob);
            };
            var fileURL = URL.createObjectURL(new Blob([u8arr], {type: 'image/*'}));
            return fileURL;
        }

        return this;

    }]);

/*!
 * html2canvas 1.4.1 <https://html2canvas.hertzen.com>
 * Copyright (c) 2022 Niklas von Hertzen <https://hertzen.com>
 * Released under MIT License
 */
(function (global, factory) {
    typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory() :
    typeof define === 'function' && define.amd ? define(factory) :
    (global = typeof globalThis !== 'undefined' ? globalThis : global || self, global.html2canvas = factory());
}(this, (function () { 'use strict';
    

    /*! *****************************************************************************
    Copyright (c) Microsoft Corporation.

    Permission to use, copy, modify, and/or distribute this software for any
    purpose with or without fee is hereby granted.

    THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
    REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
    AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
    INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
    LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
    OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
    PERFORMANCE OF THIS SOFTWARE.
    ***************************************************************************** */
    /* global Reflect, Promise */

    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };

    function __extends(d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    }

    var __assign = function() {
        __assign = Object.assign || function __assign(t) {
            for (var s, i = 1, n = arguments.length; i < n; i++) {
                s = arguments[i];
                for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
            }
            return t;
        };
        return __assign.apply(this, arguments);
    };

    function __awaiter(thisArg, _arguments, P, generator) {
        function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
        return new (P || (P = Promise))(function (resolve, reject) {
            function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
            function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
            function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
            step((generator = generator.apply(thisArg, _arguments || [])).next());
        });
    }

    function __generator(thisArg, body) {
        var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
        return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
        function verb(n) { return function (v) { return step([n, v]); }; }
        function step(op) {
            if (f) throw new TypeError("Generator is already executing.");
            while (_) try {
                if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
                if (y = 0, t) op = [op[0] & 2, t.value];
                switch (op[0]) {
                    case 0: case 1: t = op; break;
                    case 4: _.label++; return { value: op[1], done: false };
                    case 5: _.label++; y = op[1]; op = [0]; continue;
                    case 7: op = _.ops.pop(); _.trys.pop(); continue;
                    default:
                        if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                        if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                        if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                        if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                        if (t[2]) _.ops.pop();
                        _.trys.pop(); continue;
                }
                op = body.call(thisArg, _);
            } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
            if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
        }
    }

    function __spreadArray(to, from, pack) {
        if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
            if (ar || !(i in from)) {
                if (!ar) ar = Array.prototype.slice.call(from, 0, i);
                ar[i] = from[i];
            }
        }
        return to.concat(ar || from);
    }

    var Bounds = /** @class */ (function () {
        function Bounds(left, top, width, height) {
            this.left = left;
            this.top = top;
            this.width = width;
            this.height = height;
        }
        Bounds.prototype.add = function (x, y, w, h) {
            return new Bounds(this.left + x, this.top + y, this.width + w, this.height + h);
        };
        Bounds.fromClientRect = function (context, clientRect) {
            return new Bounds(clientRect.left + context.windowBounds.left, clientRect.top + context.windowBounds.top, clientRect.width, clientRect.height);
        };
        Bounds.fromDOMRectList = function (context, domRectList) {
            var domRect = Array.from(domRectList).find(function (rect) { return rect.width !== 0; });
            return domRect
                ? new Bounds(domRect.left + context.windowBounds.left, domRect.top + context.windowBounds.top, domRect.width, domRect.height)
                : Bounds.EMPTY;
        };
        Bounds.EMPTY = new Bounds(0, 0, 0, 0);
        return Bounds;
    }());
    var parseBounds = function (context, node) {
        return Bounds.fromClientRect(context, node.getBoundingClientRect());
    };
    var parseDocumentSize = function (document) {
        var body = document.body;
        var documentElement = document.documentElement;
        if (!body || !documentElement) {
            throw new Error("Unable to get document size");
        }
        var width = Math.max(Math.max(body.scrollWidth, documentElement.scrollWidth), Math.max(body.offsetWidth, documentElement.offsetWidth), Math.max(body.clientWidth, documentElement.clientWidth));
        var height = Math.max(Math.max(body.scrollHeight, documentElement.scrollHeight), Math.max(body.offsetHeight, documentElement.offsetHeight), Math.max(body.clientHeight, documentElement.clientHeight));
        return new Bounds(0, 0, width, height);
    };

    /*
     * css-line-break 2.1.0 <https://github.com/niklasvh/css-line-break#readme>
     * Copyright (c) 2022 Niklas von Hertzen <https://hertzen.com>
     * Released under MIT License
     */
    var toCodePoints$1 = function (str) {
        var codePoints = [];
        var i = 0;
        var length = str.length;
        while (i < length) {
            var value = str.charCodeAt(i++);
            if (value >= 0xd800 && value <= 0xdbff && i < length) {
                var extra = str.charCodeAt(i++);
                if ((extra & 0xfc00) === 0xdc00) {
                    codePoints.push(((value & 0x3ff) << 10) + (extra & 0x3ff) + 0x10000);
                }
                else {
                    codePoints.push(value);
                    i--;
                }
            }
            else {
                codePoints.push(value);
            }
        }
        return codePoints;
    };
    var fromCodePoint$1 = function () {
        var codePoints = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            codePoints[_i] = arguments[_i];
        }
        if (String.fromCodePoint) {
            return String.fromCodePoint.apply(String, codePoints);
        }
        var length = codePoints.length;
        if (!length) {
            return '';
        }
        var codeUnits = [];
        var index = -1;
        var result = '';
        while (++index < length) {
            var codePoint = codePoints[index];
            if (codePoint <= 0xffff) {
                codeUnits.push(codePoint);
            }
            else {
                codePoint -= 0x10000;
                codeUnits.push((codePoint >> 10) + 0xd800, (codePoint % 0x400) + 0xdc00);
            }
            if (index + 1 === length || codeUnits.length > 0x4000) {
                result += String.fromCharCode.apply(String, codeUnits);
                codeUnits.length = 0;
            }
        }
        return result;
    };
    var chars$2 = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
    // Use a lookup table to find the index.
    var lookup$2 = typeof Uint8Array === 'undefined' ? [] : new Uint8Array(256);
    for (var i$2 = 0; i$2 < chars$2.length; i$2++) {
        lookup$2[chars$2.charCodeAt(i$2)] = i$2;
    }

    /*
     * utrie 1.0.2 <https://github.com/niklasvh/utrie>
     * Copyright (c) 2022 Niklas von Hertzen <https://hertzen.com>
     * Released under MIT License
     */
    var chars$1$1 = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
    // Use a lookup table to find the index.
    var lookup$1$1 = typeof Uint8Array === 'undefined' ? [] : new Uint8Array(256);
    for (var i$1$1 = 0; i$1$1 < chars$1$1.length; i$1$1++) {
        lookup$1$1[chars$1$1.charCodeAt(i$1$1)] = i$1$1;
    }
    var decode$1 = function (base64) {
        var bufferLength = base64.length * 0.75, len = base64.length, i, p = 0, encoded1, encoded2, encoded3, encoded4;
        if (base64[base64.length - 1] === '=') {
            bufferLength--;
            if (base64[base64.length - 2] === '=') {
                bufferLength--;
            }
        }
        var buffer = typeof ArrayBuffer !== 'undefined' &&
            typeof Uint8Array !== 'undefined' &&
            typeof Uint8Array.prototype.slice !== 'undefined'
            ? new ArrayBuffer(bufferLength)
            : new Array(bufferLength);
        var bytes = Array.isArray(buffer) ? buffer : new Uint8Array(buffer);
        for (i = 0; i < len; i += 4) {
            encoded1 = lookup$1$1[base64.charCodeAt(i)];
            encoded2 = lookup$1$1[base64.charCodeAt(i + 1)];
            encoded3 = lookup$1$1[base64.charCodeAt(i + 2)];
            encoded4 = lookup$1$1[base64.charCodeAt(i + 3)];
            bytes[p++] = (encoded1 << 2) | (encoded2 >> 4);
            bytes[p++] = ((encoded2 & 15) << 4) | (encoded3 >> 2);
            bytes[p++] = ((encoded3 & 3) << 6) | (encoded4 & 63);
        }
        return buffer;
    };
    var polyUint16Array$1 = function (buffer) {
        var length = buffer.length;
        var bytes = [];
        for (var i = 0; i < length; i += 2) {
            bytes.push((buffer[i + 1] << 8) | buffer[i]);
        }
        return bytes;
    };
    var polyUint32Array$1 = function (buffer) {
        var length = buffer.length;
        var bytes = [];
        for (var i = 0; i < length; i += 4) {
            bytes.push((buffer[i + 3] << 24) | (buffer[i + 2] << 16) | (buffer[i + 1] << 8) | buffer[i]);
        }
        return bytes;
    };

    /** Shift size for getting the index-2 table offset. */
    var UTRIE2_SHIFT_2$1 = 5;
    /** Shift size for getting the index-1 table offset. */
    var UTRIE2_SHIFT_1$1 = 6 + 5;
    /**
     * Shift size for shifting left the index array values.
     * Increases possible data size with 16-bit index values at the cost
     * of compactability.
     * This requires data blocks to be aligned by UTRIE2_DATA_GRANULARITY.
     */
    var UTRIE2_INDEX_SHIFT$1 = 2;
    /**
     * Difference between the two shift sizes,
     * for getting an index-1 offset from an index-2 offset. 6=11-5
     */
    var UTRIE2_SHIFT_1_2$1 = UTRIE2_SHIFT_1$1 - UTRIE2_SHIFT_2$1;
    /**
     * The part of the index-2 table for U+D800..U+DBFF stores values for
     * lead surrogate code _units_ not code _points_.
     * Values for lead surrogate code _points_ are indexed with this portion of the table.
     * Length=32=0x20=0x400>>UTRIE2_SHIFT_2. (There are 1024=0x400 lead surrogates.)
     */
    var UTRIE2_LSCP_INDEX_2_OFFSET$1 = 0x10000 >> UTRIE2_SHIFT_2$1;
    /** Number of entries in a data block. 32=0x20 */
    var UTRIE2_DATA_BLOCK_LENGTH$1 = 1 << UTRIE2_SHIFT_2$1;
    /** Mask for getting the lower bits for the in-data-block offset. */
    var UTRIE2_DATA_MASK$1 = UTRIE2_DATA_BLOCK_LENGTH$1 - 1;
    var UTRIE2_LSCP_INDEX_2_LENGTH$1 = 0x400 >> UTRIE2_SHIFT_2$1;
    /** Count the lengths of both BMP pieces. 2080=0x820 */
    var UTRIE2_INDEX_2_BMP_LENGTH$1 = UTRIE2_LSCP_INDEX_2_OFFSET$1 + UTRIE2_LSCP_INDEX_2_LENGTH$1;
    /**
     * The 2-byte UTF-8 version of the index-2 table follows at offset 2080=0x820.
     * Length 32=0x20 for lead bytes C0..DF, regardless of UTRIE2_SHIFT_2.
     */
    var UTRIE2_UTF8_2B_INDEX_2_OFFSET$1 = UTRIE2_INDEX_2_BMP_LENGTH$1;
    var UTRIE2_UTF8_2B_INDEX_2_LENGTH$1 = 0x800 >> 6; /* U+0800 is the first code point after 2-byte UTF-8 */
    /**
     * The index-1 table, only used for supplementary code points, at offset 2112=0x840.
     * Variable length, for code points up to highStart, where the last single-value range starts.
     * Maximum length 512=0x200=0x100000>>UTRIE2_SHIFT_1.
     * (For 0x100000 supplementary code points U+10000..U+10ffff.)
     *
     * The part of the index-2 table for supplementary code points starts
     * after this index-1 table.
     *
     * Both the index-1 table and the following part of the index-2 table
     * are omitted completely if there is only BMP data.
     */
    var UTRIE2_INDEX_1_OFFSET$1 = UTRIE2_UTF8_2B_INDEX_2_OFFSET$1 + UTRIE2_UTF8_2B_INDEX_2_LENGTH$1;
    /**
     * Number of index-1 entries for the BMP. 32=0x20
     * This part of the index-1 table is omitted from the serialized form.
     */
    var UTRIE2_OMITTED_BMP_INDEX_1_LENGTH$1 = 0x10000 >> UTRIE2_SHIFT_1$1;
    /** Number of entries in an index-2 block. 64=0x40 */
    var UTRIE2_INDEX_2_BLOCK_LENGTH$1 = 1 << UTRIE2_SHIFT_1_2$1;
    /** Mask for getting the lower bits for the in-index-2-block offset. */
    var UTRIE2_INDEX_2_MASK$1 = UTRIE2_INDEX_2_BLOCK_LENGTH$1 - 1;
    var slice16$1 = function (view, start, end) {
        if (view.slice) {
            return view.slice(start, end);
        }
        return new Uint16Array(Array.prototype.slice.call(view, start, end));
    };
    var slice32$1 = function (view, start, end) {
        if (view.slice) {
            return view.slice(start, end);
        }
        return new Uint32Array(Array.prototype.slice.call(view, start, end));
    };
    var createTrieFromBase64$1 = function (base64, _byteLength) {
        var buffer = decode$1(base64);
        var view32 = Array.isArray(buffer) ? polyUint32Array$1(buffer) : new Uint32Array(buffer);
        var view16 = Array.isArray(buffer) ? polyUint16Array$1(buffer) : new Uint16Array(buffer);
        var headerLength = 24;
        var index = slice16$1(view16, headerLength / 2, view32[4] / 2);
        var data = view32[5] === 2
            ? slice16$1(view16, (headerLength + view32[4]) / 2)
            : slice32$1(view32, Math.ceil((headerLength + view32[4]) / 4));
        return new Trie$1(view32[0], view32[1], view32[2], view32[3], index, data);
    };
    var Trie$1 = /** @class */ (function () {
        function Trie(initialValue, errorValue, highStart, highValueIndex, index, data) {
            this.initialValue = initialValue;
            this.errorValue = errorValue;
            this.highStart = highStart;
            this.highValueIndex = highValueIndex;
            this.index = index;
            this.data = data;
        }
        /**
         * Get the value for a code point as stored in the Trie.
         *
         * @param codePoint the code point
         * @return the value
         */
        Trie.prototype.get = function (codePoint) {
            var ix;
            if (codePoint >= 0) {
                if (codePoint < 0x0d800 || (codePoint > 0x0dbff && codePoint <= 0x0ffff)) {
                    // Ordinary BMP code point, excluding leading surrogates.
                    // BMP uses a single level lookup.  BMP index starts at offset 0 in the Trie2 index.
                    // 16 bit data is stored in the index array itself.
                    ix = this.index[codePoint >> UTRIE2_SHIFT_2$1];
                    ix = (ix << UTRIE2_INDEX_SHIFT$1) + (codePoint & UTRIE2_DATA_MASK$1);
                    return this.data[ix];
                }
                if (codePoint <= 0xffff) {
                    // Lead Surrogate Code Point.  A Separate index section is stored for
                    // lead surrogate code units and code points.
                    //   The main index has the code unit data.
                    //   For this function, we need the code point data.
                    // Note: this expression could be refactored for slightly improved efficiency, but
                    //       surrogate code points will be so rare in practice that it's not worth it.
                    ix = this.index[UTRIE2_LSCP_INDEX_2_OFFSET$1 + ((codePoint - 0xd800) >> UTRIE2_SHIFT_2$1)];
                    ix = (ix << UTRIE2_INDEX_SHIFT$1) + (codePoint & UTRIE2_DATA_MASK$1);
                    return this.data[ix];
                }
                if (codePoint < this.highStart) {
                    // Supplemental code point, use two-level lookup.
                    ix = UTRIE2_INDEX_1_OFFSET$1 - UTRIE2_OMITTED_BMP_INDEX_1_LENGTH$1 + (codePoint >> UTRIE2_SHIFT_1$1);
                    ix = this.index[ix];
                    ix += (codePoint >> UTRIE2_SHIFT_2$1) & UTRIE2_INDEX_2_MASK$1;
                    ix = this.index[ix];
                    ix = (ix << UTRIE2_INDEX_SHIFT$1) + (codePoint & UTRIE2_DATA_MASK$1);
                    return this.data[ix];
                }
                if (codePoint <= 0x10ffff) {
                    return this.data[this.highValueIndex];
                }
            }
            // Fall through.  The code point is outside of the legal range of 0..0x10ffff.
            return this.errorValue;
        };
        return Trie;
    }());

    /*
     * base64-arraybuffer 1.0.2 <https://github.com/niklasvh/base64-arraybuffer>
     * Copyright (c) 2022 Niklas von Hertzen <https://hertzen.com>
     * Released under MIT License
     */
    var chars$3 = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
    // Use a lookup table to find the index.
    var lookup$3 = typeof Uint8Array === 'undefined' ? [] : new Uint8Array(256);
    for (var i$3 = 0; i$3 < chars$3.length; i$3++) {
        lookup$3[chars$3.charCodeAt(i$3)] = i$3;
    }

    var base64$1 = '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';

    var LETTER_NUMBER_MODIFIER = 50;
    // Non-tailorable Line Breaking Classes
    var BK = 1; //  Cause a line break (after)
    var CR$1 = 2; //  Cause a line break (after), except between CR and LF
    var LF$1 = 3; //  Cause a line break (after)
    var CM = 4; //  Prohibit a line break between the character and the preceding character
    var NL = 5; //  Cause a line break (after)
    var WJ = 7; //  Prohibit line breaks before and after
    var ZW = 8; //  Provide a break opportunity
    var GL = 9; //  Prohibit line breaks before and after
    var SP = 10; // Enable indirect line breaks
    var ZWJ$1 = 11; // Prohibit line breaks within joiner sequences
    // Break Opportunities
    var B2 = 12; //  Provide a line break opportunity before and after the character
    var BA = 13; //  Generally provide a line break opportunity after the character
    var BB = 14; //  Generally provide a line break opportunity before the character
    var HY = 15; //  Provide a line break opportunity after the character, except in numeric context
    var CB = 16; //   Provide a line break opportunity contingent on additional information
    // Characters Prohibiting Certain Breaks
    var CL = 17; //  Prohibit line breaks before
    var CP = 18; //  Prohibit line breaks before
    var EX = 19; //  Prohibit line breaks before
    var IN = 20; //  Allow only indirect line breaks between pairs
    var NS = 21; //  Allow only indirect line breaks before
    var OP = 22; //  Prohibit line breaks after
    var QU = 23; //  Act like they are both opening and closing
    // Numeric Context
    var IS = 24; //  Prevent breaks after any and before numeric
    var NU = 25; //  Form numeric expressions for line breaking purposes
    var PO = 26; //  Do not break following a numeric expression
    var PR = 27; //  Do not break in front of a numeric expression
    var SY = 28; //  Prevent a break before; and allow a break after
    // Other Characters
    var AI = 29; //  Act like AL when the resolvedEAW is N; otherwise; act as ID
    var AL = 30; //  Are alphabetic characters or symbols that are used with alphabetic characters
    var CJ = 31; //  Treat as NS or ID for strict or normal breaking.
    var EB = 32; //  Do not break from following Emoji Modifier
    var EM = 33; //  Do not break from preceding Emoji Base
    var H2 = 34; //  Form Korean syllable blocks
    var H3 = 35; //  Form Korean syllable blocks
    var HL = 36; //  Do not break around a following hyphen; otherwise act as Alphabetic
    var ID = 37; //  Break before or after; except in some numeric context
    var JL = 38; //  Form Korean syllable blocks
    var JV = 39; //  Form Korean syllable blocks
    var JT = 40; //  Form Korean syllable blocks
    var RI$1 = 41; //  Keep pairs together. For pairs; break before and after other classes
    var SA = 42; //  Provide a line break opportunity contingent on additional, language-specific context analysis
    var XX = 43; //  Have as yet unknown line breaking behavior or unassigned code positions
    var ea_OP = [0x2329, 0xff08];
    var BREAK_MANDATORY = '!';
    var BREAK_NOT_ALLOWED$1 = '×';
    var BREAK_ALLOWED$1 = '÷';
    var UnicodeTrie$1 = createTrieFromBase64$1(base64$1);
    var ALPHABETICS = [AL, HL];
    var HARD_LINE_BREAKS = [BK, CR$1, LF$1, NL];
    var SPACE$1 = [SP, ZW];
    var PREFIX_POSTFIX = [PR, PO];
    var LINE_BREAKS = HARD_LINE_BREAKS.concat(SPACE$1);
    var KOREAN_SYLLABLE_BLOCK = [JL, JV, JT, H2, H3];
    var HYPHEN = [HY, BA];
    var codePointsToCharacterClasses = function (codePoints, lineBreak) {
        if (lineBreak === void 0) { lineBreak = 'strict'; }
        var types = [];
        var indices = [];
        var categories = [];
        codePoints.forEach(function (codePoint, index) {
            var classType = UnicodeTrie$1.get(codePoint);
            if (classType > LETTER_NUMBER_MODIFIER) {
                categories.push(true);
                classType -= LETTER_NUMBER_MODIFIER;
            }
            else {
                categories.push(false);
            }
            if (['normal', 'auto', 'loose'].indexOf(lineBreak) !== -1) {
                // U+2010, – U+2013, 〜 U+301C, ゠ U+30A0
                if ([0x2010, 0x2013, 0x301c, 0x30a0].indexOf(codePoint) !== -1) {
                    indices.push(index);
                    return types.push(CB);
                }
            }
            if (classType === CM || classType === ZWJ$1) {
                // LB10 Treat any remaining combining mark or ZWJ as AL.
                if (index === 0) {
                    indices.push(index);
                    return types.push(AL);
                }
                // LB9 Do not break a combining character sequence; treat it as if it has the line breaking class of
                // the base character in all of the following rules. Treat ZWJ as if it were CM.
                var prev = types[index - 1];
                if (LINE_BREAKS.indexOf(prev) === -1) {
                    indices.push(indices[index - 1]);
                    return types.push(prev);
                }
                indices.push(index);
                return types.push(AL);
            }
            indices.push(index);
            if (classType === CJ) {
                return types.push(lineBreak === 'strict' ? NS : ID);
            }
            if (classType === SA) {
                return types.push(AL);
            }
            if (classType === AI) {
                return types.push(AL);
            }
            // For supplementary characters, a useful default is to treat characters in the range 10000..1FFFD as AL
            // and characters in the ranges 20000..2FFFD and 30000..3FFFD as ID, until the implementation can be revised
            // to take into account the actual line breaking properties for these characters.
            if (classType === XX) {
                if ((codePoint >= 0x20000 && codePoint <= 0x2fffd) || (codePoint >= 0x30000 && codePoint <= 0x3fffd)) {
                    return types.push(ID);
                }
                else {
                    return types.push(AL);
                }
            }
            types.push(classType);
        });
        return [indices, types, categories];
    };
    var isAdjacentWithSpaceIgnored = function (a, b, currentIndex, classTypes) {
        var current = classTypes[currentIndex];
        if (Array.isArray(a) ? a.indexOf(current) !== -1 : a === current) {
            var i = currentIndex;
            while (i <= classTypes.length) {
                i++;
                var next = classTypes[i];
                if (next === b) {
                    return true;
                }
                if (next !== SP) {
                    break;
                }
            }
        }
        if (current === SP) {
            var i = currentIndex;
            while (i > 0) {
                i--;
                var prev = classTypes[i];
                if (Array.isArray(a) ? a.indexOf(prev) !== -1 : a === prev) {
                    var n = currentIndex;
                    while (n <= classTypes.length) {
                        n++;
                        var next = classTypes[n];
                        if (next === b) {
                            return true;
                        }
                        if (next !== SP) {
                            break;
                        }
                    }
                }
                if (prev !== SP) {
                    break;
                }
            }
        }
        return false;
    };
    var previousNonSpaceClassType = function (currentIndex, classTypes) {
        var i = currentIndex;
        while (i >= 0) {
            var type = classTypes[i];
            if (type === SP) {
                i--;
            }
            else {
                return type;
            }
        }
        return 0;
    };
    var _lineBreakAtIndex = function (codePoints, classTypes, indicies, index, forbiddenBreaks) {
        if (indicies[index] === 0) {
            return BREAK_NOT_ALLOWED$1;
        }
        var currentIndex = index - 1;
        if (Array.isArray(forbiddenBreaks) && forbiddenBreaks[currentIndex] === true) {
            return BREAK_NOT_ALLOWED$1;
        }
        var beforeIndex = currentIndex - 1;
        var afterIndex = currentIndex + 1;
        var current = classTypes[currentIndex];
        // LB4 Always break after hard line breaks.
        // LB5 Treat CR followed by LF, as well as CR, LF, and NL as hard line breaks.
        var before = beforeIndex >= 0 ? classTypes[beforeIndex] : 0;
        var next = classTypes[afterIndex];
        if (current === CR$1 && next === LF$1) {
            return BREAK_NOT_ALLOWED$1;
        }
        if (HARD_LINE_BREAKS.indexOf(current) !== -1) {
            return BREAK_MANDATORY;
        }
        // LB6 Do not break before hard line breaks.
        if (HARD_LINE_BREAKS.indexOf(next) !== -1) {
            return BREAK_NOT_ALLOWED$1;
        }
        // LB7 Do not break before spaces or zero width space.
        if (SPACE$1.indexOf(next) !== -1) {
            return BREAK_NOT_ALLOWED$1;
        }
        // LB8 Break before any character following a zero-width space, even if one or more spaces intervene.
        if (previousNonSpaceClassType(currentIndex, classTypes) === ZW) {
            return BREAK_ALLOWED$1;
        }
        // LB8a Do not break after a zero width joiner.
        if (UnicodeTrie$1.get(codePoints[currentIndex]) === ZWJ$1) {
            return BREAK_NOT_ALLOWED$1;
        }
        // zwj emojis
        if ((current === EB || current === EM) && UnicodeTrie$1.get(codePoints[afterIndex]) === ZWJ$1) {
            return BREAK_NOT_ALLOWED$1;
        }
        // LB11 Do not break before or after Word joiner and related characters.
        if (current === WJ || next === WJ) {
            return BREAK_NOT_ALLOWED$1;
        }
        // LB12 Do not break after NBSP and related characters.
        if (current === GL) {
            return BREAK_NOT_ALLOWED$1;
        }
        // LB12a Do not break before NBSP and related characters, except after spaces and hyphens.
        if ([SP, BA, HY].indexOf(current) === -1 && next === GL) {
            return BREAK_NOT_ALLOWED$1;
        }
        // LB13 Do not break before ‘]’ or ‘!’ or ‘;’ or ‘/’, even after spaces.
        if ([CL, CP, EX, IS, SY].indexOf(next) !== -1) {
            return BREAK_NOT_ALLOWED$1;
        }
        // LB14 Do not break after ‘[’, even after spaces.
        if (previousNonSpaceClassType(currentIndex, classTypes) === OP) {
            return BREAK_NOT_ALLOWED$1;
        }
        // LB15 Do not break within ‘”[’, even with intervening spaces.
        if (isAdjacentWithSpaceIgnored(QU, OP, currentIndex, classTypes)) {
            return BREAK_NOT_ALLOWED$1;
        }
        // LB16 Do not break between closing punctuation and a nonstarter (lb=NS), even with intervening spaces.
        if (isAdjacentWithSpaceIgnored([CL, CP], NS, currentIndex, classTypes)) {
            return BREAK_NOT_ALLOWED$1;
        }
        // LB17 Do not break within ‘——’, even with intervening spaces.
        if (isAdjacentWithSpaceIgnored(B2, B2, currentIndex, classTypes)) {
            return BREAK_NOT_ALLOWED$1;
        }
        // LB18 Break after spaces.
        if (current === SP) {
            return BREAK_ALLOWED$1;
        }
        // LB19 Do not break before or after quotation marks, such as ‘ ” ’.
        if (current === QU || next === QU) {
            return BREAK_NOT_ALLOWED$1;
        }
        // LB20 Break before and after unresolved CB.
        if (next === CB || current === CB) {
            return BREAK_ALLOWED$1;
        }
        // LB21 Do not break before hyphen-minus, other hyphens, fixed-width spaces, small kana, and other non-starters, or after acute accents.
        if ([BA, HY, NS].indexOf(next) !== -1 || current === BB) {
            return BREAK_NOT_ALLOWED$1;
        }
        // LB21a Don't break after Hebrew + Hyphen.
        if (before === HL && HYPHEN.indexOf(current) !== -1) {
            return BREAK_NOT_ALLOWED$1;
        }
        // LB21b Don’t break between Solidus and Hebrew letters.
        if (current === SY && next === HL) {
            return BREAK_NOT_ALLOWED$1;
        }
        // LB22 Do not break before ellipsis.
        if (next === IN) {
            return BREAK_NOT_ALLOWED$1;
        }
        // LB23 Do not break between digits and letters.
        if ((ALPHABETICS.indexOf(next) !== -1 && current === NU) || (ALPHABETICS.indexOf(current) !== -1 && next === NU)) {
            return BREAK_NOT_ALLOWED$1;
        }
        // LB23a Do not break between numeric prefixes and ideographs, or between ideographs and numeric postfixes.
        if ((current === PR && [ID, EB, EM].indexOf(next) !== -1) ||
            ([ID, EB, EM].indexOf(current) !== -1 && next === PO)) {
            return BREAK_NOT_ALLOWED$1;
        }
        // LB24 Do not break between numeric prefix/postfix and letters, or between letters and prefix/postfix.
        if ((ALPHABETICS.indexOf(current) !== -1 && PREFIX_POSTFIX.indexOf(next) !== -1) ||
            (PREFIX_POSTFIX.indexOf(current) !== -1 && ALPHABETICS.indexOf(next) !== -1)) {
            return BREAK_NOT_ALLOWED$1;
        }
        // LB25 Do not break between the following pairs of classes relevant to numbers:
        if (
        // (PR | PO) × ( OP | HY )? NU
        ([PR, PO].indexOf(current) !== -1 &&
            (next === NU || ([OP, HY].indexOf(next) !== -1 && classTypes[afterIndex + 1] === NU))) ||
            // ( OP | HY ) × NU
            ([OP, HY].indexOf(current) !== -1 && next === NU) ||
            // NU ×	(NU | SY | IS)
            (current === NU && [NU, SY, IS].indexOf(next) !== -1)) {
            return BREAK_NOT_ALLOWED$1;
        }
        // NU (NU | SY | IS)* × (NU | SY | IS | CL | CP)
        if ([NU, SY, IS, CL, CP].indexOf(next) !== -1) {
            var prevIndex = currentIndex;
            while (prevIndex >= 0) {
                var type = classTypes[prevIndex];
                if (type === NU) {
                    return BREAK_NOT_ALLOWED$1;
                }
                else if ([SY, IS].indexOf(type) !== -1) {
                    prevIndex--;
                }
                else {
                    break;
                }
            }
        }
        // NU (NU | SY | IS)* (CL | CP)? × (PO | PR))
        if ([PR, PO].indexOf(next) !== -1) {
            var prevIndex = [CL, CP].indexOf(current) !== -1 ? beforeIndex : currentIndex;
            while (prevIndex >= 0) {
                var type = classTypes[prevIndex];
                if (type === NU) {
                    return BREAK_NOT_ALLOWED$1;
                }
                else if ([SY, IS].indexOf(type) !== -1) {
                    prevIndex--;
                }
                else {
                    break;
                }
            }
        }
        // LB26 Do not break a Korean syllable.
        if ((JL === current && [JL, JV, H2, H3].indexOf(next) !== -1) ||
            ([JV, H2].indexOf(current) !== -1 && [JV, JT].indexOf(next) !== -1) ||
            ([JT, H3].indexOf(current) !== -1 && next === JT)) {
            return BREAK_NOT_ALLOWED$1;
        }
        // LB27 Treat a Korean Syllable Block the same as ID.
        if ((KOREAN_SYLLABLE_BLOCK.indexOf(current) !== -1 && [IN, PO].indexOf(next) !== -1) ||
            (KOREAN_SYLLABLE_BLOCK.indexOf(next) !== -1 && current === PR)) {
            return BREAK_NOT_ALLOWED$1;
        }
        // LB28 Do not break between alphabetics (“at”).
        if (ALPHABETICS.indexOf(current) !== -1 && ALPHABETICS.indexOf(next) !== -1) {
            return BREAK_NOT_ALLOWED$1;
        }
        // LB29 Do not break between numeric punctuation and alphabetics (“e.g.”).
        if (current === IS && ALPHABETICS.indexOf(next) !== -1) {
            return BREAK_NOT_ALLOWED$1;
        }
        // LB30 Do not break between letters, numbers, or ordinary symbols and opening or closing parentheses.
        if ((ALPHABETICS.concat(NU).indexOf(current) !== -1 &&
            next === OP &&
            ea_OP.indexOf(codePoints[afterIndex]) === -1) ||
            (ALPHABETICS.concat(NU).indexOf(next) !== -1 && current === CP)) {
            return BREAK_NOT_ALLOWED$1;
        }
        // LB30a Break between two regional indicator symbols if and only if there are an even number of regional
        // indicators preceding the position of the break.
        if (current === RI$1 && next === RI$1) {
            var i = indicies[currentIndex];
            var count = 1;
            while (i > 0) {
                i--;
                if (classTypes[i] === RI$1) {
                    count++;
                }
                else {
                    break;
                }
            }
            if (count % 2 !== 0) {
                return BREAK_NOT_ALLOWED$1;
            }
        }
        // LB30b Do not break between an emoji base and an emoji modifier.
        if (current === EB && next === EM) {
            return BREAK_NOT_ALLOWED$1;
        }
        return BREAK_ALLOWED$1;
    };
    var cssFormattedClasses = function (codePoints, options) {
        if (!options) {
            options = { lineBreak: 'normal', wordBreak: 'normal' };
        }
        var _a = codePointsToCharacterClasses(codePoints, options.lineBreak), indicies = _a[0], classTypes = _a[1], isLetterNumber = _a[2];
        if (options.wordBreak === 'break-all' || options.wordBreak === 'break-word') {
            classTypes = classTypes.map(function (type) { return ([NU, AL, SA].indexOf(type) !== -1 ? ID : type); });
        }
        var forbiddenBreakpoints = options.wordBreak === 'keep-all'
            ? isLetterNumber.map(function (letterNumber, i) {
                return letterNumber && codePoints[i] >= 0x4e00 && codePoints[i] <= 0x9fff;
            })
            : undefined;
        return [indicies, classTypes, forbiddenBreakpoints];
    };
    var Break = /** @class */ (function () {
        function Break(codePoints, lineBreak, start, end) {
            this.codePoints = codePoints;
            this.required = lineBreak === BREAK_MANDATORY;
            this.start = start;
            this.end = end;
        }
        Break.prototype.slice = function () {
            return fromCodePoint$1.apply(void 0, this.codePoints.slice(this.start, this.end));
        };
        return Break;
    }());
    var LineBreaker = function (str, options) {
        var codePoints = toCodePoints$1(str);
        var _a = cssFormattedClasses(codePoints, options), indicies = _a[0], classTypes = _a[1], forbiddenBreakpoints = _a[2];
        var length = codePoints.length;
        var lastEnd = 0;
        var nextIndex = 0;
        return {
            next: function () {
                if (nextIndex >= length) {
                    return { done: true, value: null };
                }
                var lineBreak = BREAK_NOT_ALLOWED$1;
                while (nextIndex < length &&
                    (lineBreak = _lineBreakAtIndex(codePoints, classTypes, indicies, ++nextIndex, forbiddenBreakpoints)) ===
                        BREAK_NOT_ALLOWED$1) { }
                if (lineBreak !== BREAK_NOT_ALLOWED$1 || nextIndex === length) {
                    var value = new Break(codePoints, lineBreak, lastEnd, nextIndex);
                    lastEnd = nextIndex;
                    return { value: value, done: false };
                }
                return { done: true, value: null };
            },
        };
    };

    // https://www.w3.org/TR/css-syntax-3
    var FLAG_UNRESTRICTED = 1 << 0;
    var FLAG_ID = 1 << 1;
    var FLAG_INTEGER = 1 << 2;
    var FLAG_NUMBER = 1 << 3;
    var LINE_FEED = 0x000a;
    var SOLIDUS = 0x002f;
    var REVERSE_SOLIDUS = 0x005c;
    var CHARACTER_TABULATION = 0x0009;
    var SPACE = 0x0020;
    var QUOTATION_MARK = 0x0022;
    var EQUALS_SIGN = 0x003d;
    var NUMBER_SIGN = 0x0023;
    var DOLLAR_SIGN = 0x0024;
    var PERCENTAGE_SIGN = 0x0025;
    var APOSTROPHE = 0x0027;
    var LEFT_PARENTHESIS = 0x0028;
    var RIGHT_PARENTHESIS = 0x0029;
    var LOW_LINE = 0x005f;
    var HYPHEN_MINUS = 0x002d;
    var EXCLAMATION_MARK = 0x0021;
    var LESS_THAN_SIGN = 0x003c;
    var GREATER_THAN_SIGN = 0x003e;
    var COMMERCIAL_AT = 0x0040;
    var LEFT_SQUARE_BRACKET = 0x005b;
    var RIGHT_SQUARE_BRACKET = 0x005d;
    var CIRCUMFLEX_ACCENT = 0x003d;
    var LEFT_CURLY_BRACKET = 0x007b;
    var QUESTION_MARK = 0x003f;
    var RIGHT_CURLY_BRACKET = 0x007d;
    var VERTICAL_LINE = 0x007c;
    var TILDE = 0x007e;
    var CONTROL = 0x0080;
    var REPLACEMENT_CHARACTER = 0xfffd;
    var ASTERISK = 0x002a;
    var PLUS_SIGN = 0x002b;
    var COMMA = 0x002c;
    var COLON = 0x003a;
    var SEMICOLON = 0x003b;
    var FULL_STOP = 0x002e;
    var NULL = 0x0000;
    var BACKSPACE = 0x0008;
    var LINE_TABULATION = 0x000b;
    var SHIFT_OUT = 0x000e;
    var INFORMATION_SEPARATOR_ONE = 0x001f;
    var DELETE = 0x007f;
    var EOF = -1;
    var ZERO = 0x0030;
    var a = 0x0061;
    var e = 0x0065;
    var f = 0x0066;
    var u = 0x0075;
    var z = 0x007a;
    var A = 0x0041;
    var E = 0x0045;
    var F = 0x0046;
    var U = 0x0055;
    var Z = 0x005a;
    var isDigit = function (codePoint) { return codePoint >= ZERO && codePoint <= 0x0039; };
    var isSurrogateCodePoint = function (codePoint) { return codePoint >= 0xd800 && codePoint <= 0xdfff; };
    var isHex = function (codePoint) {
        return isDigit(codePoint) || (codePoint >= A && codePoint <= F) || (codePoint >= a && codePoint <= f);
    };
    var isLowerCaseLetter = function (codePoint) { return codePoint >= a && codePoint <= z; };
    var isUpperCaseLetter = function (codePoint) { return codePoint >= A && codePoint <= Z; };
    var isLetter = function (codePoint) { return isLowerCaseLetter(codePoint) || isUpperCaseLetter(codePoint); };
    var isNonASCIICodePoint = function (codePoint) { return codePoint >= CONTROL; };
    var isWhiteSpace = function (codePoint) {
        return codePoint === LINE_FEED || codePoint === CHARACTER_TABULATION || codePoint === SPACE;
    };
    var isNameStartCodePoint = function (codePoint) {
        return isLetter(codePoint) || isNonASCIICodePoint(codePoint) || codePoint === LOW_LINE;
    };
    var isNameCodePoint = function (codePoint) {
        return isNameStartCodePoint(codePoint) || isDigit(codePoint) || codePoint === HYPHEN_MINUS;
    };
    var isNonPrintableCodePoint = function (codePoint) {
        return ((codePoint >= NULL && codePoint <= BACKSPACE) ||
            codePoint === LINE_TABULATION ||
            (codePoint >= SHIFT_OUT && codePoint <= INFORMATION_SEPARATOR_ONE) ||
            codePoint === DELETE);
    };
    var isValidEscape = function (c1, c2) {
        if (c1 !== REVERSE_SOLIDUS) {
            return false;
        }
        return c2 !== LINE_FEED;
    };
    var isIdentifierStart = function (c1, c2, c3) {
        if (c1 === HYPHEN_MINUS) {
            return isNameStartCodePoint(c2) || isValidEscape(c2, c3);
        }
        else if (isNameStartCodePoint(c1)) {
            return true;
        }
        else if (c1 === REVERSE_SOLIDUS && isValidEscape(c1, c2)) {
            return true;
        }
        return false;
    };
    var isNumberStart = function (c1, c2, c3) {
        if (c1 === PLUS_SIGN || c1 === HYPHEN_MINUS) {
            if (isDigit(c2)) {
                return true;
            }
            return c2 === FULL_STOP && isDigit(c3);
        }
        if (c1 === FULL_STOP) {
            return isDigit(c2);
        }
        return isDigit(c1);
    };
    var stringToNumber = function (codePoints) {
        var c = 0;
        var sign = 1;
        if (codePoints[c] === PLUS_SIGN || codePoints[c] === HYPHEN_MINUS) {
            if (codePoints[c] === HYPHEN_MINUS) {
                sign = -1;
            }
            c++;
        }
        var integers = [];
        while (isDigit(codePoints[c])) {
            integers.push(codePoints[c++]);
        }
        var int = integers.length ? parseInt(fromCodePoint$1.apply(void 0, integers), 10) : 0;
        if (codePoints[c] === FULL_STOP) {
            c++;
        }
        var fraction = [];
        while (isDigit(codePoints[c])) {
            fraction.push(codePoints[c++]);
        }
        var fracd = fraction.length;
        var frac = fracd ? parseInt(fromCodePoint$1.apply(void 0, fraction), 10) : 0;
        if (codePoints[c] === E || codePoints[c] === e) {
            c++;
        }
        var expsign = 1;
        if (codePoints[c] === PLUS_SIGN || codePoints[c] === HYPHEN_MINUS) {
            if (codePoints[c] === HYPHEN_MINUS) {
                expsign = -1;
            }
            c++;
        }
        var exponent = [];
        while (isDigit(codePoints[c])) {
            exponent.push(codePoints[c++]);
        }
        var exp = exponent.length ? parseInt(fromCodePoint$1.apply(void 0, exponent), 10) : 0;
        return sign * (int + frac * Math.pow(10, -fracd)) * Math.pow(10, expsign * exp);
    };
    var LEFT_PARENTHESIS_TOKEN = {
        type: 2 /* LEFT_PARENTHESIS_TOKEN */
    };
    var RIGHT_PARENTHESIS_TOKEN = {
        type: 3 /* RIGHT_PARENTHESIS_TOKEN */
    };
    var COMMA_TOKEN = { type: 4 /* COMMA_TOKEN */ };
    var SUFFIX_MATCH_TOKEN = { type: 13 /* SUFFIX_MATCH_TOKEN */ };
    var PREFIX_MATCH_TOKEN = { type: 8 /* PREFIX_MATCH_TOKEN */ };
    var COLUMN_TOKEN = { type: 21 /* COLUMN_TOKEN */ };
    var DASH_MATCH_TOKEN = { type: 9 /* DASH_MATCH_TOKEN */ };
    var INCLUDE_MATCH_TOKEN = { type: 10 /* INCLUDE_MATCH_TOKEN */ };
    var LEFT_CURLY_BRACKET_TOKEN = {
        type: 11 /* LEFT_CURLY_BRACKET_TOKEN */
    };
    var RIGHT_CURLY_BRACKET_TOKEN = {
        type: 12 /* RIGHT_CURLY_BRACKET_TOKEN */
    };
    var SUBSTRING_MATCH_TOKEN = { type: 14 /* SUBSTRING_MATCH_TOKEN */ };
    var BAD_URL_TOKEN = { type: 23 /* BAD_URL_TOKEN */ };
    var BAD_STRING_TOKEN = { type: 1 /* BAD_STRING_TOKEN */ };
    var CDO_TOKEN = { type: 25 /* CDO_TOKEN */ };
    var CDC_TOKEN = { type: 24 /* CDC_TOKEN */ };
    var COLON_TOKEN = { type: 26 /* COLON_TOKEN */ };
    var SEMICOLON_TOKEN = { type: 27 /* SEMICOLON_TOKEN */ };
    var LEFT_SQUARE_BRACKET_TOKEN = {
        type: 28 /* LEFT_SQUARE_BRACKET_TOKEN */
    };
    var RIGHT_SQUARE_BRACKET_TOKEN = {
        type: 29 /* RIGHT_SQUARE_BRACKET_TOKEN */
    };
    var WHITESPACE_TOKEN = { type: 31 /* WHITESPACE_TOKEN */ };
    var EOF_TOKEN = { type: 32 /* EOF_TOKEN */ };
    var Tokenizer = /** @class */ (function () {
        function Tokenizer() {
            this._value = [];
        }
        Tokenizer.prototype.write = function (chunk) {
            this._value = this._value.concat(toCodePoints$1(chunk));
        };
        Tokenizer.prototype.read = function () {
            var tokens = [];
            var token = this.consumeToken();
            while (token !== EOF_TOKEN) {
                tokens.push(token);
                token = this.consumeToken();
            }
            return tokens;
        };
        Tokenizer.prototype.consumeToken = function () {
            var codePoint = this.consumeCodePoint();
            switch (codePoint) {
                case QUOTATION_MARK:
                    return this.consumeStringToken(QUOTATION_MARK);
                case NUMBER_SIGN:
                    var c1 = this.peekCodePoint(0);
                    var c2 = this.peekCodePoint(1);
                    var c3 = this.peekCodePoint(2);
                    if (isNameCodePoint(c1) || isValidEscape(c2, c3)) {
                        var flags = isIdentifierStart(c1, c2, c3) ? FLAG_ID : FLAG_UNRESTRICTED;
                        var value = this.consumeName();
                        return { type: 5 /* HASH_TOKEN */, value: value, flags: flags };
                    }
                    break;
                case DOLLAR_SIGN:
                    if (this.peekCodePoint(0) === EQUALS_SIGN) {
                        this.consumeCodePoint();
                        return SUFFIX_MATCH_TOKEN;
                    }
                    break;
                case APOSTROPHE:
                    return this.consumeStringToken(APOSTROPHE);
                case LEFT_PARENTHESIS:
                    return LEFT_PARENTHESIS_TOKEN;
                case RIGHT_PARENTHESIS:
                    return RIGHT_PARENTHESIS_TOKEN;
                case ASTERISK:
                    if (this.peekCodePoint(0) === EQUALS_SIGN) {
                        this.consumeCodePoint();
                        return SUBSTRING_MATCH_TOKEN;
                    }
                    break;
                case PLUS_SIGN:
                    if (isNumberStart(codePoint, this.peekCodePoint(0), this.peekCodePoint(1))) {
                        this.reconsumeCodePoint(codePoint);
                        return this.consumeNumericToken();
                    }
                    break;
                case COMMA:
                    return COMMA_TOKEN;
                case HYPHEN_MINUS:
                    var e1 = codePoint;
                    var e2 = this.peekCodePoint(0);
                    var e3 = this.peekCodePoint(1);
                    if (isNumberStart(e1, e2, e3)) {
                        this.reconsumeCodePoint(codePoint);
                        return this.consumeNumericToken();
                    }
                    if (isIdentifierStart(e1, e2, e3)) {
                        this.reconsumeCodePoint(codePoint);
                        return this.consumeIdentLikeToken();
                    }
                    if (e2 === HYPHEN_MINUS && e3 === GREATER_THAN_SIGN) {
                        this.consumeCodePoint();
                        this.consumeCodePoint();
                        return CDC_TOKEN;
                    }
                    break;
                case FULL_STOP:
                    if (isNumberStart(codePoint, this.peekCodePoint(0), this.peekCodePoint(1))) {
                        this.reconsumeCodePoint(codePoint);
                        return this.consumeNumericToken();
                    }
                    break;
                case SOLIDUS:
                    if (this.peekCodePoint(0) === ASTERISK) {
                        this.consumeCodePoint();
                        while (true) {
                            var c = this.consumeCodePoint();
                            if (c === ASTERISK) {
                                c = this.consumeCodePoint();
                                if (c === SOLIDUS) {
                                    return this.consumeToken();
                                }
                            }
                            if (c === EOF) {
                                return this.consumeToken();
                            }
                        }
                    }
                    break;
                case COLON:
                    return COLON_TOKEN;
                case SEMICOLON:
                    return SEMICOLON_TOKEN;
                case LESS_THAN_SIGN:
                    if (this.peekCodePoint(0) === EXCLAMATION_MARK &&
                        this.peekCodePoint(1) === HYPHEN_MINUS &&
                        this.peekCodePoint(2) === HYPHEN_MINUS) {
                        this.consumeCodePoint();
                        this.consumeCodePoint();
                        return CDO_TOKEN;
                    }
                    break;
                case COMMERCIAL_AT:
                    var a1 = this.peekCodePoint(0);
                    var a2 = this.peekCodePoint(1);
                    var a3 = this.peekCodePoint(2);
                    if (isIdentifierStart(a1, a2, a3)) {
                        var value = this.consumeName();
                        return { type: 7 /* AT_KEYWORD_TOKEN */, value: value };
                    }
                    break;
                case LEFT_SQUARE_BRACKET:
                    return LEFT_SQUARE_BRACKET_TOKEN;
                case REVERSE_SOLIDUS:
                    if (isValidEscape(codePoint, this.peekCodePoint(0))) {
                        this.reconsumeCodePoint(codePoint);
                        return this.consumeIdentLikeToken();
                    }
                    break;
                case RIGHT_SQUARE_BRACKET:
                    return RIGHT_SQUARE_BRACKET_TOKEN;
                case CIRCUMFLEX_ACCENT:
                    if (this.peekCodePoint(0) === EQUALS_SIGN) {
                        this.consumeCodePoint();
                        return PREFIX_MATCH_TOKEN;
                    }
                    break;
                case LEFT_CURLY_BRACKET:
                    return LEFT_CURLY_BRACKET_TOKEN;
                case RIGHT_CURLY_BRACKET:
                    return RIGHT_CURLY_BRACKET_TOKEN;
                case u:
                case U:
                    var u1 = this.peekCodePoint(0);
                    var u2 = this.peekCodePoint(1);
                    if (u1 === PLUS_SIGN && (isHex(u2) || u2 === QUESTION_MARK)) {
                        this.consumeCodePoint();
                        this.consumeUnicodeRangeToken();
                    }
                    this.reconsumeCodePoint(codePoint);
                    return this.consumeIdentLikeToken();
                case VERTICAL_LINE:
                    if (this.peekCodePoint(0) === EQUALS_SIGN) {
                        this.consumeCodePoint();
                        return DASH_MATCH_TOKEN;
                    }
                    if (this.peekCodePoint(0) === VERTICAL_LINE) {
                        this.consumeCodePoint();
                        return COLUMN_TOKEN;
                    }
                    break;
                case TILDE:
                    if (this.peekCodePoint(0) === EQUALS_SIGN) {
                        this.consumeCodePoint();
                        return INCLUDE_MATCH_TOKEN;
                    }
                    break;
                case EOF:
                    return EOF_TOKEN;
            }
            if (isWhiteSpace(codePoint)) {
                this.consumeWhiteSpace();
                return WHITESPACE_TOKEN;
            }
            if (isDigit(codePoint)) {
                this.reconsumeCodePoint(codePoint);
                return this.consumeNumericToken();
            }
            if (isNameStartCodePoint(codePoint)) {
                this.reconsumeCodePoint(codePoint);
                return this.consumeIdentLikeToken();
            }
            return { type: 6 /* DELIM_TOKEN */, value: fromCodePoint$1(codePoint) };
        };
        Tokenizer.prototype.consumeCodePoint = function () {
            var value = this._value.shift();
            return typeof value === 'undefined' ? -1 : value;
        };
        Tokenizer.prototype.reconsumeCodePoint = function (codePoint) {
            this._value.unshift(codePoint);
        };
        Tokenizer.prototype.peekCodePoint = function (delta) {
            if (delta >= this._value.length) {
                return -1;
            }
            return this._value[delta];
        };
        Tokenizer.prototype.consumeUnicodeRangeToken = function () {
            var digits = [];
            var codePoint = this.consumeCodePoint();
            while (isHex(codePoint) && digits.length < 6) {
                digits.push(codePoint);
                codePoint = this.consumeCodePoint();
            }
            var questionMarks = false;
            while (codePoint === QUESTION_MARK && digits.length < 6) {
                digits.push(codePoint);
                codePoint = this.consumeCodePoint();
                questionMarks = true;
            }
            if (questionMarks) {
                var start_1 = parseInt(fromCodePoint$1.apply(void 0, digits.map(function (digit) { return (digit === QUESTION_MARK ? ZERO : digit); })), 16);
                var end = parseInt(fromCodePoint$1.apply(void 0, digits.map(function (digit) { return (digit === QUESTION_MARK ? F : digit); })), 16);
                return { type: 30 /* UNICODE_RANGE_TOKEN */, start: start_1, end: end };
            }
            var start = parseInt(fromCodePoint$1.apply(void 0, digits), 16);
            if (this.peekCodePoint(0) === HYPHEN_MINUS && isHex(this.peekCodePoint(1))) {
                this.consumeCodePoint();
                codePoint = this.consumeCodePoint();
                var endDigits = [];
                while (isHex(codePoint) && endDigits.length < 6) {
                    endDigits.push(codePoint);
                    codePoint = this.consumeCodePoint();
                }
                var end = parseInt(fromCodePoint$1.apply(void 0, endDigits), 16);
                return { type: 30 /* UNICODE_RANGE_TOKEN */, start: start, end: end };
            }
            else {
                return { type: 30 /* UNICODE_RANGE_TOKEN */, start: start, end: start };
            }
        };
        Tokenizer.prototype.consumeIdentLikeToken = function () {
            var value = this.consumeName();
            if (value.toLowerCase() === 'url' && this.peekCodePoint(0) === LEFT_PARENTHESIS) {
                this.consumeCodePoint();
                return this.consumeUrlToken();
            }
            else if (this.peekCodePoint(0) === LEFT_PARENTHESIS) {
                this.consumeCodePoint();
                return { type: 19 /* FUNCTION_TOKEN */, value: value };
            }
            return { type: 20 /* IDENT_TOKEN */, value: value };
        };
        Tokenizer.prototype.consumeUrlToken = function () {
            var value = [];
            this.consumeWhiteSpace();
            if (this.peekCodePoint(0) === EOF) {
                return { type: 22 /* URL_TOKEN */, value: '' };
            }
            var next = this.peekCodePoint(0);
            if (next === APOSTROPHE || next === QUOTATION_MARK) {
                var stringToken = this.consumeStringToken(this.consumeCodePoint());
                if (stringToken.type === 0 /* STRING_TOKEN */) {
                    this.consumeWhiteSpace();
                    if (this.peekCodePoint(0) === EOF || this.peekCodePoint(0) === RIGHT_PARENTHESIS) {
                        this.consumeCodePoint();
                        return { type: 22 /* URL_TOKEN */, value: stringToken.value };
                    }
                }
                this.consumeBadUrlRemnants();
                return BAD_URL_TOKEN;
            }
            while (true) {
                var codePoint = this.consumeCodePoint();
                if (codePoint === EOF || codePoint === RIGHT_PARENTHESIS) {
                    return { type: 22 /* URL_TOKEN */, value: fromCodePoint$1.apply(void 0, value) };
                }
                else if (isWhiteSpace(codePoint)) {
                    this.consumeWhiteSpace();
                    if (this.peekCodePoint(0) === EOF || this.peekCodePoint(0) === RIGHT_PARENTHESIS) {
                        this.consumeCodePoint();
                        return { type: 22 /* URL_TOKEN */, value: fromCodePoint$1.apply(void 0, value) };
                    }
                    this.consumeBadUrlRemnants();
                    return BAD_URL_TOKEN;
                }
                else if (codePoint === QUOTATION_MARK ||
                    codePoint === APOSTROPHE ||
                    codePoint === LEFT_PARENTHESIS ||
                    isNonPrintableCodePoint(codePoint)) {
                    this.consumeBadUrlRemnants();
                    return BAD_URL_TOKEN;
                }
                else if (codePoint === REVERSE_SOLIDUS) {
                    if (isValidEscape(codePoint, this.peekCodePoint(0))) {
                        value.push(this.consumeEscapedCodePoint());
                    }
                    else {
                        this.consumeBadUrlRemnants();
                        return BAD_URL_TOKEN;
                    }
                }
                else {
                    value.push(codePoint);
                }
            }
        };
        Tokenizer.prototype.consumeWhiteSpace = function () {
            while (isWhiteSpace(this.peekCodePoint(0))) {
                this.consumeCodePoint();
            }
        };
        Tokenizer.prototype.consumeBadUrlRemnants = function () {
            while (true) {
                var codePoint = this.consumeCodePoint();
                if (codePoint === RIGHT_PARENTHESIS || codePoint === EOF) {
                    return;
                }
                if (isValidEscape(codePoint, this.peekCodePoint(0))) {
                    this.consumeEscapedCodePoint();
                }
            }
        };
        Tokenizer.prototype.consumeStringSlice = function (count) {
            var SLICE_STACK_SIZE = 50000;
            var value = '';
            while (count > 0) {
                var amount = Math.min(SLICE_STACK_SIZE, count);
                value += fromCodePoint$1.apply(void 0, this._value.splice(0, amount));
                count -= amount;
            }
            this._value.shift();
            return value;
        };
        Tokenizer.prototype.consumeStringToken = function (endingCodePoint) {
            var value = '';
            var i = 0;
            do {
                var codePoint = this._value[i];
                if (codePoint === EOF || codePoint === undefined || codePoint === endingCodePoint) {
                    value += this.consumeStringSlice(i);
                    return { type: 0 /* STRING_TOKEN */, value: value };
                }
                if (codePoint === LINE_FEED) {
                    this._value.splice(0, i);
                    return BAD_STRING_TOKEN;
                }
                if (codePoint === REVERSE_SOLIDUS) {
                    var next = this._value[i + 1];
                    if (next !== EOF && next !== undefined) {
                        if (next === LINE_FEED) {
                            value += this.consumeStringSlice(i);
                            i = -1;
                            this._value.shift();
                        }
                        else if (isValidEscape(codePoint, next)) {
                            value += this.consumeStringSlice(i);
                            value += fromCodePoint$1(this.consumeEscapedCodePoint());
                            i = -1;
                        }
                    }
                }
                i++;
            } while (true);
        };
        Tokenizer.prototype.consumeNumber = function () {
            var repr = [];
            var type = FLAG_INTEGER;
            var c1 = this.peekCodePoint(0);
            if (c1 === PLUS_SIGN || c1 === HYPHEN_MINUS) {
                repr.push(this.consumeCodePoint());
            }
            while (isDigit(this.peekCodePoint(0))) {
                repr.push(this.consumeCodePoint());
            }
            c1 = this.peekCodePoint(0);
            var c2 = this.peekCodePoint(1);
            if (c1 === FULL_STOP && isDigit(c2)) {
                repr.push(this.consumeCodePoint(), this.consumeCodePoint());
                type = FLAG_NUMBER;
                while (isDigit(this.peekCodePoint(0))) {
                    repr.push(this.consumeCodePoint());
                }
            }
            c1 = this.peekCodePoint(0);
            c2 = this.peekCodePoint(1);
            var c3 = this.peekCodePoint(2);
            if ((c1 === E || c1 === e) && (((c2 === PLUS_SIGN || c2 === HYPHEN_MINUS) && isDigit(c3)) || isDigit(c2))) {
                repr.push(this.consumeCodePoint(), this.consumeCodePoint());
                type = FLAG_NUMBER;
                while (isDigit(this.peekCodePoint(0))) {
                    repr.push(this.consumeCodePoint());
                }
            }
            return [stringToNumber(repr), type];
        };
        Tokenizer.prototype.consumeNumericToken = function () {
            var _a = this.consumeNumber(), number = _a[0], flags = _a[1];
            var c1 = this.peekCodePoint(0);
            var c2 = this.peekCodePoint(1);
            var c3 = this.peekCodePoint(2);
            if (isIdentifierStart(c1, c2, c3)) {
                var unit = this.consumeName();
                return { type: 15 /* DIMENSION_TOKEN */, number: number, flags: flags, unit: unit };
            }
            if (c1 === PERCENTAGE_SIGN) {
                this.consumeCodePoint();
                return { type: 16 /* PERCENTAGE_TOKEN */, number: number, flags: flags };
            }
            return { type: 17 /* NUMBER_TOKEN */, number: number, flags: flags };
        };
        Tokenizer.prototype.consumeEscapedCodePoint = function () {
            var codePoint = this.consumeCodePoint();
            if (isHex(codePoint)) {
                var hex = fromCodePoint$1(codePoint);
                while (isHex(this.peekCodePoint(0)) && hex.length < 6) {
                    hex += fromCodePoint$1(this.consumeCodePoint());
                }
                if (isWhiteSpace(this.peekCodePoint(0))) {
                    this.consumeCodePoint();
                }
                var hexCodePoint = parseInt(hex, 16);
                if (hexCodePoint === 0 || isSurrogateCodePoint(hexCodePoint) || hexCodePoint > 0x10ffff) {
                    return REPLACEMENT_CHARACTER;
                }
                return hexCodePoint;
            }
            if (codePoint === EOF) {
                return REPLACEMENT_CHARACTER;
            }
            return codePoint;
        };
        Tokenizer.prototype.consumeName = function () {
            var result = '';
            while (true) {
                var codePoint = this.consumeCodePoint();
                if (isNameCodePoint(codePoint)) {
                    result += fromCodePoint$1(codePoint);
                }
                else if (isValidEscape(codePoint, this.peekCodePoint(0))) {
                    result += fromCodePoint$1(this.consumeEscapedCodePoint());
                }
                else {
                    this.reconsumeCodePoint(codePoint);
                    return result;
                }
            }
        };
        return Tokenizer;
    }());

    var Parser = /** @class */ (function () {
        function Parser(tokens) {
            this._tokens = tokens;
        }
        Parser.create = function (value) {
            var tokenizer = new Tokenizer();
            tokenizer.write(value);
            return new Parser(tokenizer.read());
        };
        Parser.parseValue = function (value) {
            return Parser.create(value).parseComponentValue();
        };
        Parser.parseValues = function (value) {
            return Parser.create(value).parseComponentValues();
        };
        Parser.prototype.parseComponentValue = function () {
            var token = this.consumeToken();
            while (token.type === 31 /* WHITESPACE_TOKEN */) {
                token = this.consumeToken();
            }
            if (token.type === 32 /* EOF_TOKEN */) {
                throw new SyntaxError("Error parsing CSS component value, unexpected EOF");
            }
            this.reconsumeToken(token);
            var value = this.consumeComponentValue();
            do {
                token = this.consumeToken();
            } while (token.type === 31 /* WHITESPACE_TOKEN */);
            if (token.type === 32 /* EOF_TOKEN */) {
                return value;
            }
            throw new SyntaxError("Error parsing CSS component value, multiple values found when expecting only one");
        };
        Parser.prototype.parseComponentValues = function () {
            var values = [];
            while (true) {
                var value = this.consumeComponentValue();
                if (value.type === 32 /* EOF_TOKEN */) {
                    return values;
                }
                values.push(value);
                values.push();
            }
        };
        Parser.prototype.consumeComponentValue = function () {
            var token = this.consumeToken();
            switch (token.type) {
                case 11 /* LEFT_CURLY_BRACKET_TOKEN */:
                case 28 /* LEFT_SQUARE_BRACKET_TOKEN */:
                case 2 /* LEFT_PARENTHESIS_TOKEN */:
                    return this.consumeSimpleBlock(token.type);
                case 19 /* FUNCTION_TOKEN */:
                    return this.consumeFunction(token);
            }
            return token;
        };
        Parser.prototype.consumeSimpleBlock = function (type) {
            var block = { type: type, values: [] };
            var token = this.consumeToken();
            while (true) {
                if (token.type === 32 /* EOF_TOKEN */ || isEndingTokenFor(token, type)) {
                    return block;
                }
                this.reconsumeToken(token);
                block.values.push(this.consumeComponentValue());
                token = this.consumeToken();
            }
        };
        Parser.prototype.consumeFunction = function (functionToken) {
            var cssFunction = {
                name: functionToken.value,
                values: [],
                type: 18 /* FUNCTION */
            };
            while (true) {
                var token = this.consumeToken();
                if (token.type === 32 /* EOF_TOKEN */ || token.type === 3 /* RIGHT_PARENTHESIS_TOKEN */) {
                    return cssFunction;
                }
                this.reconsumeToken(token);
                cssFunction.values.push(this.consumeComponentValue());
            }
        };
        Parser.prototype.consumeToken = function () {
            var token = this._tokens.shift();
            return typeof token === 'undefined' ? EOF_TOKEN : token;
        };
        Parser.prototype.reconsumeToken = function (token) {
            this._tokens.unshift(token);
        };
        return Parser;
    }());
    var isDimensionToken = function (token) { return token.type === 15 /* DIMENSION_TOKEN */; };
    var isNumberToken = function (token) { return token.type === 17 /* NUMBER_TOKEN */; };
    var isIdentToken = function (token) { return token.type === 20 /* IDENT_TOKEN */; };
    var isStringToken = function (token) { return token.type === 0 /* STRING_TOKEN */; };
    var isIdentWithValue = function (token, value) {
        return isIdentToken(token) && token.value === value;
    };
    var nonWhiteSpace = function (token) { return token.type !== 31 /* WHITESPACE_TOKEN */; };
    var nonFunctionArgSeparator = function (token) {
        return token.type !== 31 /* WHITESPACE_TOKEN */ && token.type !== 4 /* COMMA_TOKEN */;
    };
    var parseFunctionArgs = function (tokens) {
        var args = [];
        var arg = [];
        tokens.forEach(function (token) {
            if (token.type === 4 /* COMMA_TOKEN */) {
                if (arg.length === 0) {
                    throw new Error("Error parsing function args, zero tokens for arg");
                }
                args.push(arg);
                arg = [];
                return;
            }
            if (token.type !== 31 /* WHITESPACE_TOKEN */) {
                arg.push(token);
            }
        });
        if (arg.length) {
            args.push(arg);
        }
        return args;
    };
    var isEndingTokenFor = function (token, type) {
        if (type === 11 /* LEFT_CURLY_BRACKET_TOKEN */ && token.type === 12 /* RIGHT_CURLY_BRACKET_TOKEN */) {
            return true;
        }
        if (type === 28 /* LEFT_SQUARE_BRACKET_TOKEN */ && token.type === 29 /* RIGHT_SQUARE_BRACKET_TOKEN */) {
            return true;
        }
        return type === 2 /* LEFT_PARENTHESIS_TOKEN */ && token.type === 3 /* RIGHT_PARENTHESIS_TOKEN */;
    };

    var isLength = function (token) {
        return token.type === 17 /* NUMBER_TOKEN */ || token.type === 15 /* DIMENSION_TOKEN */;
    };

    var isLengthPercentage = function (token) {
        return token.type === 16 /* PERCENTAGE_TOKEN */ || isLength(token);
    };
    var parseLengthPercentageTuple = function (tokens) {
        return tokens.length > 1 ? [tokens[0], tokens[1]] : [tokens[0]];
    };
    var ZERO_LENGTH = {
        type: 17 /* NUMBER_TOKEN */,
        number: 0,
        flags: FLAG_INTEGER
    };
    var FIFTY_PERCENT = {
        type: 16 /* PERCENTAGE_TOKEN */,
        number: 50,
        flags: FLAG_INTEGER
    };
    var HUNDRED_PERCENT = {
        type: 16 /* PERCENTAGE_TOKEN */,
        number: 100,
        flags: FLAG_INTEGER
    };
    var getAbsoluteValueForTuple = function (tuple, width, height) {
        var x = tuple[0], y = tuple[1];
        return [getAbsoluteValue(x, width), getAbsoluteValue(typeof y !== 'undefined' ? y : x, height)];
    };
    var getAbsoluteValue = function (token, parent) {
        if (token.type === 16 /* PERCENTAGE_TOKEN */) {
            return (token.number / 100) * parent;
        }
        if (isDimensionToken(token)) {
            switch (token.unit) {
                case 'rem':
                case 'em':
                    return 16 * token.number; // TODO use correct font-size
                case 'px':
                default:
                    return token.number;
            }
        }
        return token.number;
    };

    var DEG = 'deg';
    var GRAD = 'grad';
    var RAD = 'rad';
    var TURN = 'turn';
    var angle = {
        name: 'angle',
        parse: function (_context, value) {
            if (value.type === 15 /* DIMENSION_TOKEN */) {
                switch (value.unit) {
                    case DEG:
                        return (Math.PI * value.number) / 180;
                    case GRAD:
                        return (Math.PI / 200) * value.number;
                    case RAD:
                        return value.number;
                    case TURN:
                        return Math.PI * 2 * value.number;
                }
            }
            throw new Error("Unsupported angle type");
        }
    };
    var isAngle = function (value) {
        if (value.type === 15 /* DIMENSION_TOKEN */) {
            if (value.unit === DEG || value.unit === GRAD || value.unit === RAD || value.unit === TURN) {
                return true;
            }
        }
        return false;
    };
    var parseNamedSide = function (tokens) {
        var sideOrCorner = tokens
            .filter(isIdentToken)
            .map(function (ident) { return ident.value; })
            .join(' ');
        switch (sideOrCorner) {
            case 'to bottom right':
            case 'to right bottom':
            case 'left top':
            case 'top left':
                return [ZERO_LENGTH, ZERO_LENGTH];
            case 'to top':
            case 'bottom':
                return deg(0);
            case 'to bottom left':
            case 'to left bottom':
            case 'right top':
            case 'top right':
                return [ZERO_LENGTH, HUNDRED_PERCENT];
            case 'to right':
            case 'left':
                return deg(90);
            case 'to top left':
            case 'to left top':
            case 'right bottom':
            case 'bottom right':
                return [HUNDRED_PERCENT, HUNDRED_PERCENT];
            case 'to bottom':
            case 'top':
                return deg(180);
            case 'to top right':
            case 'to right top':
            case 'left bottom':
            case 'bottom left':
                return [HUNDRED_PERCENT, ZERO_LENGTH];
            case 'to left':
            case 'right':
                return deg(270);
        }
        return 0;
    };
    var deg = function (deg) { return (Math.PI * deg) / 180; };

    var color$1 = {
        name: 'color',
        parse: function (context, value) {
            if (value.type === 18 /* FUNCTION */) {
                var colorFunction = SUPPORTED_COLOR_FUNCTIONS[value.name];
                if (typeof colorFunction === 'undefined') {
                    throw new Error("Attempting to parse an unsupported color function \"" + value.name + "\"");
                }
                return colorFunction(context, value.values);
            }
            if (value.type === 5 /* HASH_TOKEN */) {
                if (value.value.length === 3) {
                    var r = value.value.substring(0, 1);
                    var g = value.value.substring(1, 2);
                    var b = value.value.substring(2, 3);
                    return pack(parseInt(r + r, 16), parseInt(g + g, 16), parseInt(b + b, 16), 1);
                }
                if (value.value.length === 4) {
                    var r = value.value.substring(0, 1);
                    var g = value.value.substring(1, 2);
                    var b = value.value.substring(2, 3);
                    var a = value.value.substring(3, 4);
                    return pack(parseInt(r + r, 16), parseInt(g + g, 16), parseInt(b + b, 16), parseInt(a + a, 16) / 255);
                }
                if (value.value.length === 6) {
                    var r = value.value.substring(0, 2);
                    var g = value.value.substring(2, 4);
                    var b = value.value.substring(4, 6);
                    return pack(parseInt(r, 16), parseInt(g, 16), parseInt(b, 16), 1);
                }
                if (value.value.length === 8) {
                    var r = value.value.substring(0, 2);
                    var g = value.value.substring(2, 4);
                    var b = value.value.substring(4, 6);
                    var a = value.value.substring(6, 8);
                    return pack(parseInt(r, 16), parseInt(g, 16), parseInt(b, 16), parseInt(a, 16) / 255);
                }
            }
            if (value.type === 20 /* IDENT_TOKEN */) {
                var namedColor = COLORS[value.value.toUpperCase()];
                if (typeof namedColor !== 'undefined') {
                    return namedColor;
                }
            }
            return COLORS.TRANSPARENT;
        }
    };
    var isTransparent = function (color) { return (0xff & color) === 0; };
    var asString = function (color) {
        var alpha = 0xff & color;
        var blue = 0xff & (color >> 8);
        var green = 0xff & (color >> 16);
        var red = 0xff & (color >> 24);
        return alpha < 255 ? "rgba(" + red + "," + green + "," + blue + "," + alpha / 255 + ")" : "rgb(" + red + "," + green + "," + blue + ")";
    };
    var asColorString = function (color, alpha) {
        var alpha = 0xff & alpha;
        var blue = 0xff & (color >> 8);
        var green = 0xff & (color >> 16);
        var red = 0xff & (color >> 24);
        return alpha < 255 ? "rgba(" + red + "," + green + "," + blue + "," + alpha / 255 + ")" : "rgb(" + red + "," + green + "," + blue + ")";
    };
    var pack = function (r, g, b, a) {
        return ((r << 24) | (g << 16) | (b << 8) | (Math.round(a * 255) << 0)) >>> 0;
    };
    var getTokenColorValue = function (token, i) {
        if (token.type === 17 /* NUMBER_TOKEN */) {
            return token.number;
        }
        if (token.type === 16 /* PERCENTAGE_TOKEN */) {
            var max = i === 3 ? 1 : 255;
            return i === 3 ? (token.number / 100) * max : Math.round((token.number / 100) * max);
        }
        return 0;
    };
    var rgb = function (_context, args) {
        var tokens = args.filter(nonFunctionArgSeparator);
        if (tokens.length === 3) {
            var _a = tokens.map(getTokenColorValue), r = _a[0], g = _a[1], b = _a[2];
            return pack(r, g, b, 1);
        }
        if (tokens.length === 4) {
            var _b = tokens.map(getTokenColorValue), r = _b[0], g = _b[1], b = _b[2], a = _b[3];
            return pack(r, g, b, a);
        }
        return 0;
    };
    function hue2rgb(t1, t2, hue) {
        if (hue < 0) {
            hue += 1;
        }
        if (hue >= 1) {
            hue -= 1;
        }
        if (hue < 1 / 6) {
            return (t2 - t1) * hue * 6 + t1;
        }
        else if (hue < 1 / 2) {
            return t2;
        }
        else if (hue < 2 / 3) {
            return (t2 - t1) * 6 * (2 / 3 - hue) + t1;
        }
        else {
            return t1;
        }
    }
    var hsl = function (context, args) {
        var tokens = args.filter(nonFunctionArgSeparator);
        var hue = tokens[0], saturation = tokens[1], lightness = tokens[2], alpha = tokens[3];
        var h = (hue.type === 17 /* NUMBER_TOKEN */ ? deg(hue.number) : angle.parse(context, hue)) / (Math.PI * 2);
        var s = isLengthPercentage(saturation) ? saturation.number / 100 : 0;
        var l = isLengthPercentage(lightness) ? lightness.number / 100 : 0;
        var a = typeof alpha !== 'undefined' && isLengthPercentage(alpha) ? getAbsoluteValue(alpha, 1) : 1;
        if (s === 0) {
            return pack(l * 255, l * 255, l * 255, 1);
        }
        var t2 = l <= 0.5 ? l * (s + 1) : l + s - l * s;
        var t1 = l * 2 - t2;
        var r = hue2rgb(t1, t2, h + 1 / 3);
        var g = hue2rgb(t1, t2, h);
        var b = hue2rgb(t1, t2, h - 1 / 3);
        return pack(r * 255, g * 255, b * 255, a);
    };
    var SUPPORTED_COLOR_FUNCTIONS = {
        hsl: hsl,
        hsla: hsl,
        rgb: rgb,
        rgba: rgb
    };
    var parseColor = function (context, value) {
        return color$1.parse(context, Parser.create(value).parseComponentValue());
    };
    var COLORS = {
        ALICEBLUE: 0xf0f8ffff,
        ANTIQUEWHITE: 0xfaebd7ff,
        AQUA: 0x00ffffff,
        AQUAMARINE: 0x7fffd4ff,
        AZURE: 0xf0ffffff,
        BEIGE: 0xf5f5dcff,
        BISQUE: 0xffe4c4ff,
        BLACK: 0x000000ff,
        BLANCHEDALMOND: 0xffebcdff,
        BLUE: 0x0000ffff,
        BLUEVIOLET: 0x8a2be2ff,
        BROWN: 0xa52a2aff,
        BURLYWOOD: 0xdeb887ff,
        CADETBLUE: 0x5f9ea0ff,
        CHARTREUSE: 0x7fff00ff,
        CHOCOLATE: 0xd2691eff,
        CORAL: 0xff7f50ff,
        CORNFLOWERBLUE: 0x6495edff,
        CORNSILK: 0xfff8dcff,
        CRIMSON: 0xdc143cff,
        CYAN: 0x00ffffff,
        DARKBLUE: 0x00008bff,
        DARKCYAN: 0x008b8bff,
        DARKGOLDENROD: 0xb886bbff,
        DARKGRAY: 0xa9a9a9ff,
        DARKGREEN: 0x006400ff,
        DARKGREY: 0xa9a9a9ff,
        DARKKHAKI: 0xbdb76bff,
        DARKMAGENTA: 0x8b008bff,
        DARKOLIVEGREEN: 0x556b2fff,
        DARKORANGE: 0xff8c00ff,
        DARKORCHID: 0x9932ccff,
        DARKRED: 0x8b0000ff,
        DARKSALMON: 0xe9967aff,
        DARKSEAGREEN: 0x8fbc8fff,
        DARKSLATEBLUE: 0x483d8bff,
        DARKSLATEGRAY: 0x2f4f4fff,
        DARKSLATEGREY: 0x2f4f4fff,
        DARKTURQUOISE: 0x00ced1ff,
        DARKVIOLET: 0x9400d3ff,
        DEEPPINK: 0xff1493ff,
        DEEPSKYBLUE: 0x00bfffff,
        DIMGRAY: 0x696969ff,
        DIMGREY: 0x696969ff,
        DODGERBLUE: 0x1e90ffff,
        FIREBRICK: 0xb22222ff,
        FLORALWHITE: 0xfffaf0ff,
        FORESTGREEN: 0x228b22ff,
        FUCHSIA: 0xff00ffff,
        GAINSBORO: 0xdcdcdcff,
        GHOSTWHITE: 0xf8f8ffff,
        GOLD: 0xffd700ff,
        GOLDENROD: 0xdaa520ff,
        GRAY: 0x808080ff,
        GREEN: 0x008000ff,
        GREENYELLOW: 0xadff2fff,
        GREY: 0x808080ff,
        HONEYDEW: 0xf0fff0ff,
        HOTPINK: 0xff69b4ff,
        INDIANRED: 0xcd5c5cff,
        INDIGO: 0x4b0082ff,
        IVORY: 0xfffff0ff,
        KHAKI: 0xf0e68cff,
        LAVENDER: 0xe6e6faff,
        LAVENDERBLUSH: 0xfff0f5ff,
        LAWNGREEN: 0x7cfc00ff,
        LEMONCHIFFON: 0xfffacdff,
        LIGHTBLUE: 0xadd8e6ff,
        LIGHTCORAL: 0xf08080ff,
        LIGHTCYAN: 0xe0ffffff,
        LIGHTGOLDENRODYELLOW: 0xfafad2ff,
        LIGHTGRAY: 0xd3d3d3ff,
        LIGHTGREEN: 0x90ee90ff,
        LIGHTGREY: 0xd3d3d3ff,
        LIGHTPINK: 0xffb6c1ff,
        LIGHTSALMON: 0xffa07aff,
        LIGHTSEAGREEN: 0x20b2aaff,
        LIGHTSKYBLUE: 0x87cefaff,
        LIGHTSLATEGRAY: 0x778899ff,
        LIGHTSLATEGREY: 0x778899ff,
        LIGHTSTEELBLUE: 0xb0c4deff,
        LIGHTYELLOW: 0xffffe0ff,
        LIME: 0x00ff00ff,
        LIMEGREEN: 0x32cd32ff,
        LINEN: 0xfaf0e6ff,
        MAGENTA: 0xff00ffff,
        MAROON: 0x800000ff,
        MEDIUMAQUAMARINE: 0x66cdaaff,
        MEDIUMBLUE: 0x0000cdff,
        MEDIUMORCHID: 0xba55d3ff,
        MEDIUMPURPLE: 0x9370dbff,
        MEDIUMSEAGREEN: 0x3cb371ff,
        MEDIUMSLATEBLUE: 0x7b68eeff,
        MEDIUMSPRINGGREEN: 0x00fa9aff,
        MEDIUMTURQUOISE: 0x48d1ccff,
        MEDIUMVIOLETRED: 0xc71585ff,
        MIDNIGHTBLUE: 0x191970ff,
        MINTCREAM: 0xf5fffaff,
        MISTYROSE: 0xffe4e1ff,
        MOCCASIN: 0xffe4b5ff,
        NAVAJOWHITE: 0xffdeadff,
        NAVY: 0x000080ff,
        OLDLACE: 0xfdf5e6ff,
        OLIVE: 0x808000ff,
        OLIVEDRAB: 0x6b8e23ff,
        ORANGE: 0xffa500ff,
        ORANGERED: 0xff4500ff,
        ORCHID: 0xda70d6ff,
        PALEGOLDENROD: 0xeee8aaff,
        PALEGREEN: 0x98fb98ff,
        PALETURQUOISE: 0xafeeeeff,
        PALEVIOLETRED: 0xdb7093ff,
        PAPAYAWHIP: 0xffefd5ff,
        PEACHPUFF: 0xffdab9ff,
        PERU: 0xcd853fff,
        PINK: 0xffc0cbff,
        PLUM: 0xdda0ddff,
        POWDERBLUE: 0xb0e0e6ff,
        PURPLE: 0x800080ff,
        REBECCAPURPLE: 0x663399ff,
        RED: 0xff0000ff,
        ROSYBROWN: 0xbc8f8fff,
        ROYALBLUE: 0x4169e1ff,
        SADDLEBROWN: 0x8b4513ff,
        SALMON: 0xfa8072ff,
        SANDYBROWN: 0xf4a460ff,
        SEAGREEN: 0x2e8b57ff,
        SEASHELL: 0xfff5eeff,
        SIENNA: 0xa0522dff,
        SILVER: 0xc0c0c0ff,
        SKYBLUE: 0x87ceebff,
        SLATEBLUE: 0x6a5acdff,
        SLATEGRAY: 0x708090ff,
        SLATEGREY: 0x708090ff,
        SNOW: 0xfffafaff,
        SPRINGGREEN: 0x00ff7fff,
        STEELBLUE: 0x4682b4ff,
        TAN: 0xd2b48cff,
        TEAL: 0x008080ff,
        THISTLE: 0xd8bfd8ff,
        TOMATO: 0xff6347ff,
        TRANSPARENT: 0x00000000,
        TURQUOISE: 0x40e0d0ff,
        VIOLET: 0xee82eeff,
        WHEAT: 0xf5deb3ff,
        WHITE: 0xffffffff,
        WHITESMOKE: 0xf5f5f5ff,
        YELLOW: 0xffff00ff,
        YELLOWGREEN: 0x9acd32ff
    };

    var backgroundClip = {
        name: 'background-clip',
        initialValue: 'border-box',
        prefix: false,
        type: 1 /* LIST */,
        parse: function (_context, tokens) {
            return tokens.map(function (token) {
                if (isIdentToken(token)) {
                    switch (token.value) {
                        case 'padding-box':
                            return 1 /* PADDING_BOX */;
                        case 'content-box':
                            return 2 /* CONTENT_BOX */;
                    }
                }
                return 0 /* BORDER_BOX */;
            });
        }
    };

    var backgroundColor = {
        name: "background-color",
        initialValue: 'transparent',
        prefix: false,
        type: 3 /* TYPE_VALUE */,
        format: 'color'
    };

    var parseColorStop = function (context, args) {
        var color = color$1.parse(context, args[0]);
        var stop = args[1];
        return stop && isLengthPercentage(stop) ? { color: color, stop: stop } : { color: color, stop: null };
    };
    var processColorStops = function (stops, lineLength) {
        var first = stops[0];
        var last = stops[stops.length - 1];
        if (first.stop === null) {
            first.stop = ZERO_LENGTH;
        }
        if (last.stop === null) {
            last.stop = HUNDRED_PERCENT;
        }
        var processStops = [];
        var previous = 0;
        for (var i = 0; i < stops.length; i++) {
            var stop_1 = stops[i].stop;
            if (stop_1 !== null) {
                var absoluteValue = getAbsoluteValue(stop_1, lineLength);
                if (absoluteValue > previous) {
                    processStops.push(absoluteValue);
                }
                else {
                    processStops.push(previous);
                }
                previous = absoluteValue;
            }
            else {
                processStops.push(null);
            }
        }
        var gapBegin = null;
        for (var i = 0; i < processStops.length; i++) {
            var stop_2 = processStops[i];
            if (stop_2 === null) {
                if (gapBegin === null) {
                    gapBegin = i;
                }
            }
            else if (gapBegin !== null) {
                var gapLength = i - gapBegin;
                var beforeGap = processStops[gapBegin - 1];
                var gapValue = (stop_2 - beforeGap) / (gapLength + 1);
                for (var g = 1; g <= gapLength; g++) {
                    processStops[gapBegin + g - 1] = gapValue * g;
                }
                gapBegin = null;
            }
        }
        return stops.map(function (_a, i) {
            var color = _a.color;
            return { color: color, stop: Math.max(Math.min(1, processStops[i] / lineLength), 0) };
        });
    };
    var getAngleFromCorner = function (corner, width, height) {
        var centerX = width / 2;
        var centerY = height / 2;
        var x = getAbsoluteValue(corner[0], width) - centerX;
        var y = centerY - getAbsoluteValue(corner[1], height);
        return (Math.atan2(y, x) + Math.PI * 2) % (Math.PI * 2);
    };
    var calculateGradientDirection = function (angle, width, height) {
        var radian = typeof angle === 'number' ? angle : getAngleFromCorner(angle, width, height);
        var lineLength = Math.abs(width * Math.sin(radian)) + Math.abs(height * Math.cos(radian));
        var halfWidth = width / 2;
        var halfHeight = height / 2;
        var halfLineLength = lineLength / 2;
        var yDiff = Math.sin(radian - Math.PI / 2) * halfLineLength;
        var xDiff = Math.cos(radian - Math.PI / 2) * halfLineLength;
        return [lineLength, halfWidth - xDiff, halfWidth + xDiff, halfHeight - yDiff, halfHeight + yDiff];
    };
    var distance = function (a, b) { return Math.sqrt(a * a + b * b); };
    var findCorner = function (width, height, x, y, closest) {
        var corners = [
            [0, 0],
            [0, height],
            [width, 0],
            [width, height]
        ];
        return corners.reduce(function (stat, corner) {
            var cx = corner[0], cy = corner[1];
            var d = distance(x - cx, y - cy);
            if (closest ? d < stat.optimumDistance : d > stat.optimumDistance) {
                return {
                    optimumCorner: corner,
                    optimumDistance: d
                };
            }
            return stat;
        }, {
            optimumDistance: closest ? Infinity : -Infinity,
            optimumCorner: null
        }).optimumCorner;
    };
    var calculateRadius = function (gradient, x, y, width, height) {
        var rx = 0;
        var ry = 0;
        switch (gradient.size) {
            case 0 /* CLOSEST_SIDE */:
                // The ending shape is sized so that that it exactly meets the side of the gradient box closest to the gradient’s center.
                // If the shape is an ellipse, it exactly meets the closest side in each dimension.
                if (gradient.shape === 0 /* CIRCLE */) {
                    rx = ry = Math.min(Math.abs(x), Math.abs(x - width), Math.abs(y), Math.abs(y - height));
                }
                else if (gradient.shape === 1 /* ELLIPSE */) {
                    rx = Math.min(Math.abs(x), Math.abs(x - width));
                    ry = Math.min(Math.abs(y), Math.abs(y - height));
                }
                break;
            case 2 /* CLOSEST_CORNER */:
                // The ending shape is sized so that that it passes through the corner of the gradient box closest to the gradient’s center.
                // If the shape is an ellipse, the ending shape is given the same aspect-ratio it would have if closest-side were specified.
                if (gradient.shape === 0 /* CIRCLE */) {
                    rx = ry = Math.min(distance(x, y), distance(x, y - height), distance(x - width, y), distance(x - width, y - height));
                }
                else if (gradient.shape === 1 /* ELLIPSE */) {
                    // Compute the ratio ry/rx (which is to be the same as for "closest-side")
                    var c = Math.min(Math.abs(y), Math.abs(y - height)) / Math.min(Math.abs(x), Math.abs(x - width));
                    var _a = findCorner(width, height, x, y, true), cx = _a[0], cy = _a[1];
                    rx = distance(cx - x, (cy - y) / c);
                    ry = c * rx;
                }
                break;
            case 1 /* FARTHEST_SIDE */:
                // Same as closest-side, except the ending shape is sized based on the farthest side(s)
                if (gradient.shape === 0 /* CIRCLE */) {
                    rx = ry = Math.max(Math.abs(x), Math.abs(x - width), Math.abs(y), Math.abs(y - height));
                }
                else if (gradient.shape === 1 /* ELLIPSE */) {
                    rx = Math.max(Math.abs(x), Math.abs(x - width));
                    ry = Math.max(Math.abs(y), Math.abs(y - height));
                }
                break;
            case 3 /* FARTHEST_CORNER */:
                // Same as closest-corner, except the ending shape is sized based on the farthest corner.
                // If the shape is an ellipse, the ending shape is given the same aspect ratio it would have if farthest-side were specified.
                if (gradient.shape === 0 /* CIRCLE */) {
                    rx = ry = Math.max(distance(x, y), distance(x, y - height), distance(x - width, y), distance(x - width, y - height));
                }
                else if (gradient.shape === 1 /* ELLIPSE */) {
                    // Compute the ratio ry/rx (which is to be the same as for "farthest-side")
                    var c = Math.max(Math.abs(y), Math.abs(y - height)) / Math.max(Math.abs(x), Math.abs(x - width));
                    var _b = findCorner(width, height, x, y, false), cx = _b[0], cy = _b[1];
                    rx = distance(cx - x, (cy - y) / c);
                    ry = c * rx;
                }
                break;
        }
        if (Array.isArray(gradient.size)) {
            rx = getAbsoluteValue(gradient.size[0], width);
            ry = gradient.size.length === 2 ? getAbsoluteValue(gradient.size[1], height) : rx;
        }
        return [rx, ry];
    };

    var linearGradient = function (context, tokens) {
        var angle$1 = deg(180);
        var stops = [];
        parseFunctionArgs(tokens).forEach(function (arg, i) {
            if (i === 0) {
                var firstToken = arg[0];
                if (firstToken.type === 20 /* IDENT_TOKEN */ && firstToken.value === 'to') {
                    angle$1 = parseNamedSide(arg);
                    return;
                }
                else if (isAngle(firstToken)) {
                    angle$1 = angle.parse(context, firstToken);
                    return;
                }
            }
            var colorStop = parseColorStop(context, arg);
            stops.push(colorStop);
        });
        return { angle: angle$1, stops: stops, type: 1 /* LINEAR_GRADIENT */ };
    };

    var prefixLinearGradient = function (context, tokens) {
        var angle$1 = deg(180);
        var stops = [];
        parseFunctionArgs(tokens).forEach(function (arg, i) {
            if (i === 0) {
                var firstToken = arg[0];
                if (firstToken.type === 20 /* IDENT_TOKEN */ &&
                    ['top', 'left', 'right', 'bottom'].indexOf(firstToken.value) !== -1) {
                    angle$1 = parseNamedSide(arg);
                    return;
                }
                else if (isAngle(firstToken)) {
                    angle$1 = (angle.parse(context, firstToken) + deg(270)) % deg(360);
                    return;
                }
            }
            var colorStop = parseColorStop(context, arg);
            stops.push(colorStop);
        });
        return {
            angle: angle$1,
            stops: stops,
            type: 1 /* LINEAR_GRADIENT */
        };
    };

    var webkitGradient = function (context, tokens) {
        var angle = deg(180);
        var stops = [];
        var type = 1 /* LINEAR_GRADIENT */;
        var shape = 0 /* CIRCLE */;
        var size = 3 /* FARTHEST_CORNER */;
        var position = [];
        parseFunctionArgs(tokens).forEach(function (arg, i) {
            var firstToken = arg[0];
            if (i === 0) {
                if (isIdentToken(firstToken) && firstToken.value === 'linear') {
                    type = 1 /* LINEAR_GRADIENT */;
                    return;
                }
                else if (isIdentToken(firstToken) && firstToken.value === 'radial') {
                    type = 2 /* RADIAL_GRADIENT */;
                    return;
                }
            }
            if (firstToken.type === 18 /* FUNCTION */) {
                if (firstToken.name === 'from') {
                    var color = color$1.parse(context, firstToken.values[0]);
                    stops.push({ stop: ZERO_LENGTH, color: color });
                }
                else if (firstToken.name === 'to') {
                    var color = color$1.parse(context, firstToken.values[0]);
                    stops.push({ stop: HUNDRED_PERCENT, color: color });
                }
                else if (firstToken.name === 'color-stop') {
                    var values = firstToken.values.filter(nonFunctionArgSeparator);
                    if (values.length === 2) {
                        var color = color$1.parse(context, values[1]);
                        var stop_1 = values[0];
                        if (isNumberToken(stop_1)) {
                            stops.push({
                                stop: { type: 16 /* PERCENTAGE_TOKEN */, number: stop_1.number * 100, flags: stop_1.flags },
                                color: color
                            });
                        }
                    }
                }
            }
        });
        return type === 1 /* LINEAR_GRADIENT */
            ? {
                angle: (angle + deg(180)) % deg(360),
                stops: stops,
                type: type
            }
            : { size: size, shape: shape, stops: stops, position: position, type: type };
    };

    var CLOSEST_SIDE = 'closest-side';
    var FARTHEST_SIDE = 'farthest-side';
    var CLOSEST_CORNER = 'closest-corner';
    var FARTHEST_CORNER = 'farthest-corner';
    var CIRCLE = 'circle';
    var ELLIPSE = 'ellipse';
    var COVER = 'cover';
    var CONTAIN = 'contain';
    var radialGradient = function (context, tokens) {
        var shape = 0 /* CIRCLE */;
        var size = 3 /* FARTHEST_CORNER */;
        var stops = [];
        var position = [];
        parseFunctionArgs(tokens).forEach(function (arg, i) {
            var isColorStop = true;
            if (i === 0) {
                var isAtPosition_1 = false;
                isColorStop = arg.reduce(function (acc, token) {
                    if (isAtPosition_1) {
                        if (isIdentToken(token)) {
                            switch (token.value) {
                                case 'center':
                                    position.push(FIFTY_PERCENT);
                                    return acc;
                                case 'top':
                                case 'left':
                                    position.push(ZERO_LENGTH);
                                    return acc;
                                case 'right':
                                case 'bottom':
                                    position.push(HUNDRED_PERCENT);
                                    return acc;
                            }
                        }
                        else if (isLengthPercentage(token) || isLength(token)) {
                            position.push(token);
                        }
                    }
                    else if (isIdentToken(token)) {
                        switch (token.value) {
                            case CIRCLE:
                                shape = 0 /* CIRCLE */;
                                return false;
                            case ELLIPSE:
                                shape = 1 /* ELLIPSE */;
                                return false;
                            case 'at':
                                isAtPosition_1 = true;
                                return false;
                            case CLOSEST_SIDE:
                                size = 0 /* CLOSEST_SIDE */;
                                return false;
                            case COVER:
                            case FARTHEST_SIDE:
                                size = 1 /* FARTHEST_SIDE */;
                                return false;
                            case CONTAIN:
                            case CLOSEST_CORNER:
                                size = 2 /* CLOSEST_CORNER */;
                                return false;
                            case FARTHEST_CORNER:
                                size = 3 /* FARTHEST_CORNER */;
                                return false;
                        }
                    }
                    else if (isLength(token) || isLengthPercentage(token)) {
                        if (!Array.isArray(size)) {
                            size = [];
                        }
                        size.push(token);
                        return false;
                    }
                    return acc;
                }, isColorStop);
            }
            if (isColorStop) {
                var colorStop = parseColorStop(context, arg);
                stops.push(colorStop);
            }
        });
        return { size: size, shape: shape, stops: stops, position: position, type: 2 /* RADIAL_GRADIENT */ };
    };

    var prefixRadialGradient = function (context, tokens) {
        var shape = 0 /* CIRCLE */;
        var size = 3 /* FARTHEST_CORNER */;
        var stops = [];
        var position = [];
        parseFunctionArgs(tokens).forEach(function (arg, i) {
            var isColorStop = true;
            if (i === 0) {
                isColorStop = arg.reduce(function (acc, token) {
                    if (isIdentToken(token)) {
                        switch (token.value) {
                            case 'center':
                                position.push(FIFTY_PERCENT);
                                return false;
                            case 'top':
                            case 'left':
                                position.push(ZERO_LENGTH);
                                return false;
                            case 'right':
                            case 'bottom':
                                position.push(HUNDRED_PERCENT);
                                return false;
                        }
                    }
                    else if (isLengthPercentage(token) || isLength(token)) {
                        position.push(token);
                        return false;
                    }
                    return acc;
                }, isColorStop);
            }
            else if (i === 1) {
                isColorStop = arg.reduce(function (acc, token) {
                    if (isIdentToken(token)) {
                        switch (token.value) {
                            case CIRCLE:
                                shape = 0 /* CIRCLE */;
                                return false;
                            case ELLIPSE:
                                shape = 1 /* ELLIPSE */;
                                return false;
                            case CONTAIN:
                            case CLOSEST_SIDE:
                                size = 0 /* CLOSEST_SIDE */;
                                return false;
                            case FARTHEST_SIDE:
                                size = 1 /* FARTHEST_SIDE */;
                                return false;
                            case CLOSEST_CORNER:
                                size = 2 /* CLOSEST_CORNER */;
                                return false;
                            case COVER:
                            case FARTHEST_CORNER:
                                size = 3 /* FARTHEST_CORNER */;
                                return false;
                        }
                    }
                    else if (isLength(token) || isLengthPercentage(token)) {
                        if (!Array.isArray(size)) {
                            size = [];
                        }
                        size.push(token);
                        return false;
                    }
                    return acc;
                }, isColorStop);
            }
            if (isColorStop) {
                var colorStop = parseColorStop(context, arg);
                stops.push(colorStop);
            }
        });
        return { size: size, shape: shape, stops: stops, position: position, type: 2 /* RADIAL_GRADIENT */ };
    };

    var isLinearGradient = function (background) {
        return background.type === 1 /* LINEAR_GRADIENT */;
    };
    var isRadialGradient = function (background) {
        return background.type === 2 /* RADIAL_GRADIENT */;
    };
    var image = {
        name: 'image',
        parse: function (context, value) {
            if (value.type === 22 /* URL_TOKEN */) {
                var image_1 = { url: value.value, type: 0 /* URL */ };
                context.cache.addImage(value.value);
                return image_1;
            }
            if (value.type === 18 /* FUNCTION */) {
                var imageFunction = SUPPORTED_IMAGE_FUNCTIONS[value.name];
                if (typeof imageFunction === 'undefined') {
                    throw new Error("Attempting to parse an unsupported image function \"" + value.name + "\"");
                }
                return imageFunction(context, value.values);
            }
            throw new Error("Unsupported image type " + value.type);
        }
    };
    function isSupportedImage(value) {
        return (!(value.type === 20 /* IDENT_TOKEN */ && value.value === 'none') &&
            (value.type !== 18 /* FUNCTION */ || !!SUPPORTED_IMAGE_FUNCTIONS[value.name]));
    }
    var SUPPORTED_IMAGE_FUNCTIONS = {
        'linear-gradient': linearGradient,
        '-moz-linear-gradient': prefixLinearGradient,
        '-ms-linear-gradient': prefixLinearGradient,
        '-o-linear-gradient': prefixLinearGradient,
        '-webkit-linear-gradient': prefixLinearGradient,
        'radial-gradient': radialGradient,
        '-moz-radial-gradient': prefixRadialGradient,
        '-ms-radial-gradient': prefixRadialGradient,
        '-o-radial-gradient': prefixRadialGradient,
        '-webkit-radial-gradient': prefixRadialGradient,
        '-webkit-gradient': webkitGradient
    };

    var backgroundImage = {
        name: 'background-image',
        initialValue: 'none',
        type: 1 /* LIST */,
        prefix: false,
        parse: function (context, tokens) {
            if (tokens.length === 0) {
                return [];
            }
            var first = tokens[0];
            if (first.type === 20 /* IDENT_TOKEN */ && first.value === 'none') {
                return [];
            }
            return tokens
                .filter(function (value) { return nonFunctionArgSeparator(value) && isSupportedImage(value); })
                .map(function (value) { return image.parse(context, value); });
        }
    };

    var backgroundOrigin = {
        name: 'background-origin',
        initialValue: 'border-box',
        prefix: false,
        type: 1 /* LIST */,
        parse: function (_context, tokens) {
            return tokens.map(function (token) {
                if (isIdentToken(token)) {
                    switch (token.value) {
                        case 'padding-box':
                            return 1 /* PADDING_BOX */;
                        case 'content-box':
                            return 2 /* CONTENT_BOX */;
                    }
                }
                return 0 /* BORDER_BOX */;
            });
        }
    };

    var backgroundPosition = {
        name: 'background-position',
        initialValue: '0% 0%',
        type: 1 /* LIST */,
        prefix: false,
        parse: function (_context, tokens) {
            return parseFunctionArgs(tokens)
                .map(function (values) { return values.filter(isLengthPercentage); })
                .map(parseLengthPercentageTuple);
        }
    };

    var backgroundRepeat = {
        name: 'background-repeat',
        initialValue: 'repeat',
        prefix: false,
        type: 1 /* LIST */,
        parse: function (_context, tokens) {
            return parseFunctionArgs(tokens)
                .map(function (values) {
                return values
                    .filter(isIdentToken)
                    .map(function (token) { return token.value; })
                    .join(' ');
            })
                .map(parseBackgroundRepeat);
        }
    };
    var parseBackgroundRepeat = function (value) {
        switch (value) {
            case 'no-repeat':
                return 1 /* NO_REPEAT */;
            case 'repeat-x':
            case 'repeat no-repeat':
                return 2 /* REPEAT_X */;
            case 'repeat-y':
            case 'no-repeat repeat':
                return 3 /* REPEAT_Y */;
            case 'repeat':
            default:
                return 0 /* REPEAT */;
        }
    };

    var BACKGROUND_SIZE;
    (function (BACKGROUND_SIZE) {
        BACKGROUND_SIZE["AUTO"] = "auto";
        BACKGROUND_SIZE["CONTAIN"] = "contain";
        BACKGROUND_SIZE["COVER"] = "cover";
    })(BACKGROUND_SIZE || (BACKGROUND_SIZE = {}));
    var backgroundSize = {
        name: 'background-size',
        initialValue: '0',
        prefix: false,
        type: 1 /* LIST */,
        parse: function (_context, tokens) {
            return parseFunctionArgs(tokens).map(function (values) { return values.filter(isBackgroundSizeInfoToken); });
        }
    };
    var isBackgroundSizeInfoToken = function (value) {
        return isIdentToken(value) || isLengthPercentage(value);
    };

    var borderColorForSide = function (side) { return ({
        name: "border-" + side + "-color",
        initialValue: 'transparent',
        prefix: false,
        type: 3 /* TYPE_VALUE */,
        format: 'color'
    }); };
    var borderTopColor = borderColorForSide('top');
    var borderRightColor = borderColorForSide('right');
    var borderBottomColor = borderColorForSide('bottom');
    var borderLeftColor = borderColorForSide('left');

    var borderRadiusForSide = function (side) { return ({
        name: "border-radius-" + side,
        initialValue: '0 0',
        prefix: false,
        type: 1 /* LIST */,
        parse: function (_context, tokens) {
            return parseLengthPercentageTuple(tokens.filter(isLengthPercentage));
        }
    }); };
    var borderTopLeftRadius = borderRadiusForSide('top-left');
    var borderTopRightRadius = borderRadiusForSide('top-right');
    var borderBottomRightRadius = borderRadiusForSide('bottom-right');
    var borderBottomLeftRadius = borderRadiusForSide('bottom-left');

    var borderStyleForSide = function (side) { return ({
        name: "border-" + side + "-style",
        initialValue: 'solid',
        prefix: false,
        type: 2 /* IDENT_VALUE */,
        parse: function (_context, style) {
            switch (style) {
                case 'none':
                    return 0 /* NONE */;
                case 'dashed':
                    return 2 /* DASHED */;
                case 'dotted':
                    return 3 /* DOTTED */;
                case 'double':
                    return 4 /* DOUBLE */;
            }
            return 1 /* SOLID */;
        }
    }); };
    var borderTopStyle = borderStyleForSide('top');
    var borderRightStyle = borderStyleForSide('right');
    var borderBottomStyle = borderStyleForSide('bottom');
    var borderLeftStyle = borderStyleForSide('left');

    var borderWidthForSide = function (side) { return ({
        name: "border-" + side + "-width",
        initialValue: '0',
        type: 0 /* VALUE */,
        prefix: false,
        parse: function (_context, token) {
            if (isDimensionToken(token)) {
                return token.number;
            }
            return 0;
        }
    }); };
    var borderTopWidth = borderWidthForSide('top');
    var borderRightWidth = borderWidthForSide('right');
    var borderBottomWidth = borderWidthForSide('bottom');
    var borderLeftWidth = borderWidthForSide('left');

    var color = {
        name: "color",
        initialValue: 'transparent',
        prefix: false,
        type: 3 /* TYPE_VALUE */,
        format: 'color'
    };

    var direction = {
        name: 'direction',
        initialValue: 'ltr',
        prefix: false,
        type: 2 /* IDENT_VALUE */,
        parse: function (_context, direction) {
            switch (direction) {
                case 'rtl':
                    return 1 /* RTL */;
                case 'ltr':
                default:
                    return 0 /* LTR */;
            }
        }
    };

    var display = {
        name: 'display',
        initialValue: 'inline-block',
        prefix: false,
        type: 1 /* LIST */,
        parse: function (_context, tokens) {
            return tokens.filter(isIdentToken).reduce(function (bit, token) {
                return bit | parseDisplayValue(token.value);
            }, 0 /* NONE */);
        }
    };
    var parseDisplayValue = function (display) {
        switch (display) {
            case 'block':
            case '-webkit-box':
                return 2 /* BLOCK */;
            case 'inline':
                return 4 /* INLINE */;
            case 'run-in':
                return 8 /* RUN_IN */;
            case 'flow':
                return 16 /* FLOW */;
            case 'flow-root':
                return 32 /* FLOW_ROOT */;
            case 'table':
                return 64 /* TABLE */;
            case 'flex':
            case '-webkit-flex':
                return 128 /* FLEX */;
            case 'grid':
            case '-ms-grid':
                return 256 /* GRID */;
            case 'ruby':
                return 512 /* RUBY */;
            case 'subgrid':
                return 1024 /* SUBGRID */;
            case 'list-item':
                return 2048 /* LIST_ITEM */;
            case 'table-row-group':
                return 4096 /* TABLE_ROW_GROUP */;
            case 'table-header-group':
                return 8192 /* TABLE_HEADER_GROUP */;
            case 'table-footer-group':
                return 16384 /* TABLE_FOOTER_GROUP */;
            case 'table-row':
                return 32768 /* TABLE_ROW */;
            case 'table-cell':
                return 65536 /* TABLE_CELL */;
            case 'table-column-group':
                return 131072 /* TABLE_COLUMN_GROUP */;
            case 'table-column':
                return 262144 /* TABLE_COLUMN */;
            case 'table-caption':
                return 524288 /* TABLE_CAPTION */;
            case 'ruby-base':
                return 1048576 /* RUBY_BASE */;
            case 'ruby-text':
                return 2097152 /* RUBY_TEXT */;
            case 'ruby-base-container':
                return 4194304 /* RUBY_BASE_CONTAINER */;
            case 'ruby-text-container':
                return 8388608 /* RUBY_TEXT_CONTAINER */;
            case 'contents':
                return 16777216 /* CONTENTS */;
            case 'inline-block':
                return 33554432 /* INLINE_BLOCK */;
            case 'inline-list-item':
                return 67108864 /* INLINE_LIST_ITEM */;
            case 'inline-table':
                return 134217728 /* INLINE_TABLE */;
            case 'inline-flex':
                return 268435456 /* INLINE_FLEX */;
            case 'inline-grid':
                return 536870912 /* INLINE_GRID */;
        }
        return 0 /* NONE */;
    };

    var float = {
        name: 'float',
        initialValue: 'none',
        prefix: false,
        type: 2 /* IDENT_VALUE */,
        parse: function (_context, float) {
            switch (float) {
                case 'left':
                    return 1 /* LEFT */;
                case 'right':
                    return 2 /* RIGHT */;
                case 'inline-start':
                    return 3 /* INLINE_START */;
                case 'inline-end':
                    return 4 /* INLINE_END */;
            }
            return 0 /* NONE */;
        }
    };

    var letterSpacing = {
        name: 'letter-spacing',
        initialValue: '0',
        prefix: false,
        type: 0 /* VALUE */,
        parse: function (_context, token) {
            if (token.type === 20 /* IDENT_TOKEN */ && token.value === 'normal') {
                return 0;
            }
            if (token.type === 17 /* NUMBER_TOKEN */) {
                return token.number;
            }
            if (token.type === 15 /* DIMENSION_TOKEN */) {
                return token.number;
            }
            return 0;
        }
    };

    var LINE_BREAK;
    (function (LINE_BREAK) {
        LINE_BREAK["NORMAL"] = "normal";
        LINE_BREAK["STRICT"] = "strict";
    })(LINE_BREAK || (LINE_BREAK = {}));
    var lineBreak = {
        name: 'line-break',
        initialValue: 'normal',
        prefix: false,
        type: 2 /* IDENT_VALUE */,
        parse: function (_context, lineBreak) {
            switch (lineBreak) {
                case 'strict':
                    return LINE_BREAK.STRICT;
                case 'normal':
                default:
                    return LINE_BREAK.NORMAL;
            }
        }
    };

    var lineHeight = {
        name: 'line-height',
        initialValue: 'normal',
        prefix: false,
        type: 4 /* TOKEN_VALUE */
    };
    var computeLineHeight = function (token, fontSize) {
        if (isIdentToken(token) && token.value === 'normal') {
            return 1.2 * fontSize;
        }
        else if (token.type === 17 /* NUMBER_TOKEN */) {
            return fontSize * token.number;
        }
        else if (isLengthPercentage(token)) {
            return getAbsoluteValue(token, fontSize);
        }
        return fontSize;
    };

    var listStyleImage = {
        name: 'list-style-image',
        initialValue: 'none',
        type: 0 /* VALUE */,
        prefix: false,
        parse: function (context, token) {
            if (token.type === 20 /* IDENT_TOKEN */ && token.value === 'none') {
                return null;
            }
            return image.parse(context, token);
        }
    };

    var listStylePosition = {
        name: 'list-style-position',
        initialValue: 'outside',
        prefix: false,
        type: 2 /* IDENT_VALUE */,
        parse: function (_context, position) {
            switch (position) {
                case 'inside':
                    return 0 /* INSIDE */;
                case 'outside':
                default:
                    return 1 /* OUTSIDE */;
            }
        }
    };

    var listStyleType = {
        name: 'list-style-type',
        initialValue: 'none',
        prefix: false,
        type: 2 /* IDENT_VALUE */,
        parse: function (_context, type) {
            switch (type) {
                case 'disc':
                    return 0 /* DISC */;
                case 'circle':
                    return 1 /* CIRCLE */;
                case 'square':
                    return 2 /* SQUARE */;
                case 'decimal':
                    return 3 /* DECIMAL */;
                case 'cjk-decimal':
                    return 4 /* CJK_DECIMAL */;
                case 'decimal-leading-zero':
                    return 5 /* DECIMAL_LEADING_ZERO */;
                case 'lower-roman':
                    return 6 /* LOWER_ROMAN */;
                case 'upper-roman':
                    return 7 /* UPPER_ROMAN */;
                case 'lower-greek':
                    return 8 /* LOWER_GREEK */;
                case 'lower-alpha':
                    return 9 /* LOWER_ALPHA */;
                case 'upper-alpha':
                    return 10 /* UPPER_ALPHA */;
                case 'arabic-indic':
                    return 11 /* ARABIC_INDIC */;
                case 'armenian':
                    return 12 /* ARMENIAN */;
                case 'bengali':
                    return 13 /* BENGALI */;
                case 'cambodian':
                    return 14 /* CAMBODIAN */;
                case 'cjk-earthly-branch':
                    return 15 /* CJK_EARTHLY_BRANCH */;
                case 'cjk-heavenly-stem':
                    return 16 /* CJK_HEAVENLY_STEM */;
                case 'cjk-ideographic':
                    return 17 /* CJK_IDEOGRAPHIC */;
                case 'devanagari':
                    return 18 /* DEVANAGARI */;
                case 'ethiopic-numeric':
                    return 19 /* ETHIOPIC_NUMERIC */;
                case 'georgian':
                    return 20 /* GEORGIAN */;
                case 'gujarati':
                    return 21 /* GUJARATI */;
                case 'gurmukhi':
                    return 22 /* GURMUKHI */;
                case 'hebrew':
                    return 22 /* HEBREW */;
                case 'hiragana':
                    return 23 /* HIRAGANA */;
                case 'hiragana-iroha':
                    return 24 /* HIRAGANA_IROHA */;
                case 'japanese-formal':
                    return 25 /* JAPANESE_FORMAL */;
                case 'japanese-informal':
                    return 26 /* JAPANESE_INFORMAL */;
                case 'kannada':
                    return 27 /* KANNADA */;
                case 'katakana':
                    return 28 /* KATAKANA */;
                case 'katakana-iroha':
                    return 29 /* KATAKANA_IROHA */;
                case 'khmer':
                    return 30 /* KHMER */;
                case 'korean-hangul-formal':
                    return 31 /* KOREAN_HANGUL_FORMAL */;
                case 'korean-hanja-formal':
                    return 32 /* KOREAN_HANJA_FORMAL */;
                case 'korean-hanja-informal':
                    return 33 /* KOREAN_HANJA_INFORMAL */;
                case 'lao':
                    return 34 /* LAO */;
                case 'lower-armenian':
                    return 35 /* LOWER_ARMENIAN */;
                case 'malayalam':
                    return 36 /* MALAYALAM */;
                case 'mongolian':
                    return 37 /* MONGOLIAN */;
                case 'myanmar':
                    return 38 /* MYANMAR */;
                case 'oriya':
                    return 39 /* ORIYA */;
                case 'persian':
                    return 40 /* PERSIAN */;
                case 'simp-chinese-formal':
                    return 41 /* SIMP_CHINESE_FORMAL */;
                case 'simp-chinese-informal':
                    return 42 /* SIMP_CHINESE_INFORMAL */;
                case 'tamil':
                    return 43 /* TAMIL */;
                case 'telugu':
                    return 44 /* TELUGU */;
                case 'thai':
                    return 45 /* THAI */;
                case 'tibetan':
                    return 46 /* TIBETAN */;
                case 'trad-chinese-formal':
                    return 47 /* TRAD_CHINESE_FORMAL */;
                case 'trad-chinese-informal':
                    return 48 /* TRAD_CHINESE_INFORMAL */;
                case 'upper-armenian':
                    return 49 /* UPPER_ARMENIAN */;
                case 'disclosure-open':
                    return 50 /* DISCLOSURE_OPEN */;
                case 'disclosure-closed':
                    return 51 /* DISCLOSURE_CLOSED */;
                case 'none':
                default:
                    return -1 /* NONE */;
            }
        }
    };

    var marginForSide = function (side) { return ({
        name: "margin-" + side,
        initialValue: '0',
        prefix: false,
        type: 4 /* TOKEN_VALUE */
    }); };
    var marginTop = marginForSide('top');
    var marginRight = marginForSide('right');
    var marginBottom = marginForSide('bottom');
    var marginLeft = marginForSide('left');

    var overflow = {
        name: 'overflow',
        initialValue: 'visible',
        prefix: false,
        type: 1 /* LIST */,
        parse: function (_context, tokens) {
            return tokens.filter(isIdentToken).map(function (overflow) {
                switch (overflow.value) {
                    case 'hidden':
                        return 1 /* HIDDEN */;
                    case 'scroll':
                        return 2 /* SCROLL */;
                    case 'clip':
                        return 3 /* CLIP */;
                    case 'auto':
                        return 4 /* AUTO */;
                    case 'visible':
                    default:
                        return 0 /* VISIBLE */;
                }
            });
        }
    };

    var overflowWrap = {
        name: 'overflow-wrap',
        initialValue: 'normal',
        prefix: false,
        type: 2 /* IDENT_VALUE */,
        parse: function (_context, overflow) {
            switch (overflow) {
                case 'break-word':
                    return "break-word" /* BREAK_WORD */;
                case 'normal':
                default:
                    return "normal" /* NORMAL */;
            }
        }
    };

    var paddingForSide = function (side) { return ({
        name: "padding-" + side,
        initialValue: '0',
        prefix: false,
        type: 3 /* TYPE_VALUE */,
        format: 'length-percentage'
    }); };
    var paddingTop = paddingForSide('top');
    var paddingRight = paddingForSide('right');
    var paddingBottom = paddingForSide('bottom');
    var paddingLeft = paddingForSide('left');

    var textAlign = {
        name: 'text-align',
        initialValue: 'left',
        prefix: false,
        type: 2 /* IDENT_VALUE */,
        parse: function (_context, textAlign) {
            switch (textAlign) {
                case 'right':
                    return 2 /* RIGHT */;
                case 'center':
                case 'justify':
                    return 1 /* CENTER */;
                case 'left':
                default:
                    return 0 /* LEFT */;
            }
        }
    };

    var position = {
        name: 'position',
        initialValue: 'static',
        prefix: false,
        type: 2 /* IDENT_VALUE */,
        parse: function (_context, position) {
            switch (position) {
                case 'relative':
                    return 1 /* RELATIVE */;
                case 'absolute':
                    return 2 /* ABSOLUTE */;
                case 'fixed':
                    return 3 /* FIXED */;
                case 'sticky':
                    return 4 /* STICKY */;
            }
            return 0 /* STATIC */;
        }
    };

    var textShadow = {
        name: 'text-shadow',
        initialValue: 'none',
        type: 1 /* LIST */,
        prefix: false,
        parse: function (context, tokens) {
            if (tokens.length === 1 && isIdentWithValue(tokens[0], 'none')) {
                return [];
            }
            return parseFunctionArgs(tokens).map(function (values) {
                var shadow = {
                    color: COLORS.TRANSPARENT,
                    offsetX: ZERO_LENGTH,
                    offsetY: ZERO_LENGTH,
                    blur: ZERO_LENGTH
                };
                var c = 0;
                for (var i = 0; i < values.length; i++) {
                    var token = values[i];
                    if (isLength(token)) {
                        if (c === 0) {
                            shadow.offsetX = token;
                        }
                        else if (c === 1) {
                            shadow.offsetY = token;
                        }
                        else {
                            shadow.blur = token;
                        }
                        c++;
                    }
                    else {
                        shadow.color = color$1.parse(context, token);
                    }
                }
                return shadow;
            });
        }
    };

    var textTransform = {
        name: 'text-transform',
        initialValue: 'none',
        prefix: false,
        type: 2 /* IDENT_VALUE */,
        parse: function (_context, textTransform) {
            switch (textTransform) {
                case 'uppercase':
                    return 2 /* UPPERCASE */;
                case 'lowercase':
                    return 1 /* LOWERCASE */;
                case 'capitalize':
                    return 3 /* CAPITALIZE */;
            }
            return 0 /* NONE */;
        }
    };

    var transform$1 = {
        name: 'transform',
        initialValue: 'none',
        prefix: true,
        type: 0 /* VALUE */,
        parse: function (_context, token) {
            if (token.type === 20 /* IDENT_TOKEN */ && token.value === 'none') {
                return null;
            }
            if (token.type === 18 /* FUNCTION */) {
                var transformFunction = SUPPORTED_TRANSFORM_FUNCTIONS[token.name];
                if (typeof transformFunction === 'undefined') {
                    throw new Error("Attempting to parse an unsupported transform function \"" + token.name + "\"");
                }
                return transformFunction(token.values);
            }
            return null;
        }
    };
    var matrix = function (args) {
        var values = args.filter(function (arg) { return arg.type === 17 /* NUMBER_TOKEN */; }).map(function (arg) { return arg.number; });
        return values.length === 6 ? values : null;
    };
    // doesn't support 3D transforms at the moment
    var matrix3d = function (args) {
        var values = args.filter(function (arg) { return arg.type === 17 /* NUMBER_TOKEN */; }).map(function (arg) { return arg.number; });
        var a1 = values[0], b1 = values[1]; values[2]; values[3]; var a2 = values[4], b2 = values[5]; values[6]; values[7]; values[8]; values[9]; values[10]; values[11]; var a4 = values[12], b4 = values[13]; values[14]; values[15];
        return values.length === 16 ? [a1, b1, a2, b2, a4, b4] : null;
    };
    var SUPPORTED_TRANSFORM_FUNCTIONS = {
        matrix: matrix,
        matrix3d: matrix3d
    };

    var DEFAULT_VALUE = {
        type: 16 /* PERCENTAGE_TOKEN */,
        number: 50,
        flags: FLAG_INTEGER
    };
    var DEFAULT = [DEFAULT_VALUE, DEFAULT_VALUE];
    var transformOrigin = {
        name: 'transform-origin',
        initialValue: '50% 50%',
        prefix: true,
        type: 1 /* LIST */,
        parse: function (_context, tokens) {
            var origins = tokens.filter(isLengthPercentage);
            if (origins.length !== 2) {
                return DEFAULT;
            }
            return [origins[0], origins[1]];
        }
    };

    var visibility = {
        name: 'visible',
        initialValue: 'none',
        prefix: false,
        type: 2 /* IDENT_VALUE */,
        parse: function (_context, visibility) {
            switch (visibility) {
                case 'hidden':
                    return 1 /* HIDDEN */;
                case 'collapse':
                    return 2 /* COLLAPSE */;
                case 'visible':
                default:
                    return 0 /* VISIBLE */;
            }
        }
    };

    var WORD_BREAK;
    (function (WORD_BREAK) {
        WORD_BREAK["NORMAL"] = "normal";
        WORD_BREAK["BREAK_ALL"] = "break-all";
        WORD_BREAK["KEEP_ALL"] = "keep-all";
    })(WORD_BREAK || (WORD_BREAK = {}));
    var wordBreak = {
        name: 'word-break',
        initialValue: 'normal',
        prefix: false,
        type: 2 /* IDENT_VALUE */,
        parse: function (_context, wordBreak) {
            switch (wordBreak) {
                case 'break-all':
                    return WORD_BREAK.BREAK_ALL;
                case 'keep-all':
                    return WORD_BREAK.KEEP_ALL;
                case 'normal':
                default:
                    return WORD_BREAK.NORMAL;
            }
        }
    };

    var zIndex = {
        name: 'z-index',
        initialValue: 'auto',
        prefix: false,
        type: 0 /* VALUE */,
        parse: function (_context, token) {
            if (token.type === 20 /* IDENT_TOKEN */) {
                return { auto: true, order: 0 };
            }
            if (isNumberToken(token)) {
                return { auto: false, order: token.number };
            }
            throw new Error("Invalid z-index number parsed");
        }
    };

    var time = {
        name: 'time',
        parse: function (_context, value) {
            if (value.type === 15 /* DIMENSION_TOKEN */) {
                switch (value.unit.toLowerCase()) {
                    case 's':
                        return 1000 * value.number;
                    case 'ms':
                        return value.number;
                }
            }
            throw new Error("Unsupported time type");
        }
    };

    var opacity = {
        name: 'opacity',
        initialValue: '1',
        type: 0 /* VALUE */,
        prefix: false,
        parse: function (_context, token) {
            if (isNumberToken(token)) {
                return token.number;
            }
            return 1;
        }
    };

    var textDecorationColor = {
        name: "text-decoration-color",
        initialValue: 'transparent',
        prefix: false,
        type: 3 /* TYPE_VALUE */,
        format: 'color'
    };

    var textDecorationLine = {
        name: 'text-decoration-line',
        initialValue: 'none',
        prefix: false,
        type: 1 /* LIST */,
        parse: function (_context, tokens) {
            return tokens
                .filter(isIdentToken)
                .map(function (token) {
                switch (token.value) {
                    case 'underline':
                        return 1 /* UNDERLINE */;
                    case 'overline':
                        return 2 /* OVERLINE */;
                    case 'line-through':
                        return 3 /* LINE_THROUGH */;
                    case 'none':
                        return 4 /* BLINK */;
                }
                return 0 /* NONE */;
            })
                .filter(function (line) { return line !== 0 /* NONE */; });
        }
    };

    var fontFamily = {
        name: "font-family",
        initialValue: '',
        prefix: false,
        type: 1 /* LIST */,
        parse: function (_context, tokens) {
            var accumulator = [];
            var results = [];
            tokens.forEach(function (token) {
                switch (token.type) {
                    case 20 /* IDENT_TOKEN */:
                    case 0 /* STRING_TOKEN */:
                        accumulator.push(token.value);
                        break;
                    case 17 /* NUMBER_TOKEN */:
                        accumulator.push(token.number.toString());
                        break;
                    case 4 /* COMMA_TOKEN */:
                        results.push(accumulator.join(' '));
                        accumulator.length = 0;
                        break;
                }
            });
            if (accumulator.length) {
                results.push(accumulator.join(' '));
            }
            return results.map(function (result) { return (result.indexOf(' ') === -1 ? result : "'" + result + "'"); });
        }
    };

    var fontSize = {
        name: "font-size",
        initialValue: '0',
        prefix: false,
        type: 3 /* TYPE_VALUE */,
        format: 'length'
    };

    var fontWeight = {
        name: 'font-weight',
        initialValue: 'normal',
        type: 0 /* VALUE */,
        prefix: false,
        parse: function (_context, token) {
            if (isNumberToken(token)) {
                return token.number;
            }
            if (isIdentToken(token)) {
                switch (token.value) {
                    case 'bold':
                        return 700;
                    case 'normal':
                    default:
                        return 400;
                }
            }
            return 400;
        }
    };

    var fontVariant = {
        name: 'font-variant',
        initialValue: 'none',
        type: 1 /* LIST */,
        prefix: false,
        parse: function (_context, tokens) {
            return tokens.filter(isIdentToken).map(function (token) { return token.value; });
        }
    };

    var fontStyle = {
        name: 'font-style',
        initialValue: 'normal',
        prefix: false,
        type: 2 /* IDENT_VALUE */,
        parse: function (_context, overflow) {
            switch (overflow) {
                case 'oblique':
                    return "oblique" /* OBLIQUE */;
                case 'italic':
                    return "italic" /* ITALIC */;
                case 'normal':
                default:
                    return "normal" /* NORMAL */;
            }
        }
    };

    var contains = function (bit, value) { return (bit & value) !== 0; };

    var content = {
        name: 'content',
        initialValue: 'none',
        type: 1 /* LIST */,
        prefix: false,
        parse: function (_context, tokens) {
            if (tokens.length === 0) {
                return [];
            }
            var first = tokens[0];
            if (first.type === 20 /* IDENT_TOKEN */ && first.value === 'none') {
                return [];
            }
            return tokens;
        }
    };

    var counterIncrement = {
        name: 'counter-increment',
        initialValue: 'none',
        prefix: true,
        type: 1 /* LIST */,
        parse: function (_context, tokens) {
            if (tokens.length === 0) {
                return null;
            }
            var first = tokens[0];
            if (first.type === 20 /* IDENT_TOKEN */ && first.value === 'none') {
                return null;
            }
            var increments = [];
            var filtered = tokens.filter(nonWhiteSpace);
            for (var i = 0; i < filtered.length; i++) {
                var counter = filtered[i];
                var next = filtered[i + 1];
                if (counter.type === 20 /* IDENT_TOKEN */) {
                    var increment = next && isNumberToken(next) ? next.number : 1;
                    increments.push({ counter: counter.value, increment: increment });
                }
            }
            return increments;
        }
    };

    var counterReset = {
        name: 'counter-reset',
        initialValue: 'none',
        prefix: true,
        type: 1 /* LIST */,
        parse: function (_context, tokens) {
            if (tokens.length === 0) {
                return [];
            }
            var resets = [];
            var filtered = tokens.filter(nonWhiteSpace);
            for (var i = 0; i < filtered.length; i++) {
                var counter = filtered[i];
                var next = filtered[i + 1];
                if (isIdentToken(counter) && counter.value !== 'none') {
                    var reset = next && isNumberToken(next) ? next.number : 0;
                    resets.push({ counter: counter.value, reset: reset });
                }
            }
            return resets;
        }
    };

    var duration = {
        name: 'duration',
        initialValue: '0s',
        prefix: false,
        type: 1 /* LIST */,
        parse: function (context, tokens) {
            return tokens.filter(isDimensionToken).map(function (token) { return time.parse(context, token); });
        }
    };

    var quotes = {
        name: 'quotes',
        initialValue: 'none',
        prefix: true,
        type: 1 /* LIST */,
        parse: function (_context, tokens) {
            if (tokens.length === 0) {
                return null;
            }
            var first = tokens[0];
            if (first.type === 20 /* IDENT_TOKEN */ && first.value === 'none') {
                return null;
            }
            var quotes = [];
            var filtered = tokens.filter(isStringToken);
            if (filtered.length % 2 !== 0) {
                return null;
            }
            for (var i = 0; i < filtered.length; i += 2) {
                var open_1 = filtered[i].value;
                var close_1 = filtered[i + 1].value;
                quotes.push({ open: open_1, close: close_1 });
            }
            return quotes;
        }
    };
    var getQuote = function (quotes, depth, open) {
        if (!quotes) {
            return '';
        }
        var quote = quotes[Math.min(depth, quotes.length - 1)];
        if (!quote) {
            return '';
        }
        return open ? quote.open : quote.close;
    };

    var dropShadowFilter = {
        name: 'filter',
        initialValue: 'none',
        type: 1, /* LIST */
        prefix: false,
        parse: function (context, tokens) {
            if (tokens.length === 1 && isIdentWithValue(tokens[0], 'none')) {
                return [];
            }
            return parseFunctionArgs(tokens).map(function (values) {

                var firstToken = values[0];
                if (firstToken.type == 18  /* FUNCTION */) {
                    if (firstToken.name == 'drop-shadow') {
                        return dropShadowFunction(context, firstToken.values);
                    }
                }
                return null;
            });

        }
    };

    var dropShadowFunction = function(context, values) {
        var shadow = {
            color: 0x777777ff,
            offsetX: ZERO_LENGTH,
            offsetY: ZERO_LENGTH,
            blur: ZERO_LENGTH,
            inset: false
        };
        var c = 0;
        for (var i = 0; i < values.length; i++) {
            var token = values[i];
            if (isIdentWithValue(token, 'inset')) {
                shadow.inset = true;
            }
            else if (token.type == 31 /* White Space */) {
                continue;
            }
            else if (isLength(token)) {
                if (c === 0) {
                    shadow.offsetX = token;
                }
                else if (c === 1) {
                    shadow.offsetY = token;
                }
                else {
                    shadow.blur = token;
                }
                c++;
            }
            else {
                shadow.color = color$1.parse(context, token);
            }
        }
        return shadow;
    }

    var boxShadow = {
        name: 'box-shadow',
        initialValue: 'none',
        type: 1 /* LIST */,
        prefix: false,
        parse: function (context, tokens) {
            if (tokens.length === 1 && isIdentWithValue(tokens[0], 'none')) {
                return [];
            }
            return parseFunctionArgs(tokens).map(function (values) {
                var shadow = {
                    color: 0x000000ff,
                    offsetX: ZERO_LENGTH,
                    offsetY: ZERO_LENGTH,
                    blur: ZERO_LENGTH,
                    spread: ZERO_LENGTH,
                    inset: false
                };
                var c = 0;
                for (var i = 0; i < values.length; i++) {
                    var token = values[i];
                    if (isIdentWithValue(token, 'inset')) {
                        shadow.inset = true;
                    }
                    else if (isLength(token)) {
                        if (c === 0) {
                            shadow.offsetX = token;
                        }
                        else if (c === 1) {
                            shadow.offsetY = token;
                        }
                        else if (c === 2) {
                            shadow.blur = token;
                        }
                        else {
                            shadow.spread = token;
                        }
                        c++;
                    }
                    else {
                        shadow.color = color$1.parse(context, token);
                    }
                }
                return shadow;
            });
        }
    };

    var paintOrder = {
        name: 'paint-order',
        initialValue: 'normal',
        prefix: false,
        type: 1 /* LIST */,
        parse: function (_context, tokens) {
            var DEFAULT_VALUE = [0 /* FILL */, 1 /* STROKE */, 2 /* MARKERS */];
            var layers = [];
            tokens.filter(isIdentToken).forEach(function (token) {
                switch (token.value) {
                    case 'stroke':
                        layers.push(1 /* STROKE */);
                        break;
                    case 'fill':
                        layers.push(0 /* FILL */);
                        break;
                    case 'markers':
                        layers.push(2 /* MARKERS */);
                        break;
                }
            });
            DEFAULT_VALUE.forEach(function (value) {
                if (layers.indexOf(value) === -1) {
                    layers.push(value);
                }
            });
            return layers;
        }
    };

    var webkitTextStrokeColor = {
        name: "-webkit-text-stroke-color",
        initialValue: 'currentcolor',
        prefix: false,
        type: 3 /* TYPE_VALUE */,
        format: 'color'
    };

    var webkitTextStrokeWidth = {
        name: "-webkit-text-stroke-width",
        initialValue: '0',
        type: 0 /* VALUE */,
        prefix: false,
        parse: function (_context, token) {
            if (isDimensionToken(token)) {
                return token.number;
            }
            return 0;
        }
    };

    var webkitMaskImage = {
        name: "-webkit-mask-image",
        initialValue: 'none',
        prefix: false,
        type: 1 /* LIST */,
        parse: function (context, tokens) {
            if (tokens.length === 0) {
                return [];
            }
            var first = tokens[0];
            if (first.type === 20 /* IDENT_TOKEN */ && first.value === 'none') {
                return [];
            }
            return tokens
                .filter(function (value) { return nonFunctionArgSeparator(value) && isSupportedImage(value); })
                .map(function (value) { return image.parse(context, value); });
        }
    };

    var CSSParsedDeclaration = /** @class */ (function () {
        function CSSParsedDeclaration(context, declaration) {
            var _a, _b;
            this.animationDuration = parse(context, duration, declaration.animationDuration);
            this.backgroundClip = parse(context, backgroundClip, declaration.backgroundClip);
            this.backgroundColor = parse(context, backgroundColor, declaration.backgroundColor);
            this.backgroundImage = parse(context, backgroundImage, declaration.backgroundImage);
            this.backgroundOrigin = parse(context, backgroundOrigin, declaration.backgroundOrigin);
            this.backgroundPosition = parse(context, backgroundPosition, declaration.backgroundPosition);
            this.backgroundRepeat = parse(context, backgroundRepeat, declaration.backgroundRepeat);
            this.backgroundSize = parse(context, backgroundSize, declaration.backgroundSize);
            this.borderTopColor = parse(context, borderTopColor, declaration.borderTopColor);
            this.borderRightColor = parse(context, borderRightColor, declaration.borderRightColor);
            this.borderBottomColor = parse(context, borderBottomColor, declaration.borderBottomColor);
            this.borderLeftColor = parse(context, borderLeftColor, declaration.borderLeftColor);
            this.borderTopLeftRadius = parse(context, borderTopLeftRadius, declaration.borderTopLeftRadius);
            this.borderTopRightRadius = parse(context, borderTopRightRadius, declaration.borderTopRightRadius);
            this.borderBottomRightRadius = parse(context, borderBottomRightRadius, declaration.borderBottomRightRadius);
            this.borderBottomLeftRadius = parse(context, borderBottomLeftRadius, declaration.borderBottomLeftRadius);
            this.borderTopStyle = parse(context, borderTopStyle, declaration.borderTopStyle);
            this.borderRightStyle = parse(context, borderRightStyle, declaration.borderRightStyle);
            this.borderBottomStyle = parse(context, borderBottomStyle, declaration.borderBottomStyle);
            this.borderLeftStyle = parse(context, borderLeftStyle, declaration.borderLeftStyle);
            this.borderTopWidth = parse(context, borderTopWidth, declaration.borderTopWidth);
            this.borderRightWidth = parse(context, borderRightWidth, declaration.borderRightWidth);
            this.borderBottomWidth = parse(context, borderBottomWidth, declaration.borderBottomWidth);
            this.borderLeftWidth = parse(context, borderLeftWidth, declaration.borderLeftWidth);
            this.boxShadow = parse(context, boxShadow, declaration.boxShadow);
            this.dropShadow = parse(context, dropShadowFilter, declaration.filter);
            this.color = parse(context, color, declaration.color);
            this.direction = parse(context, direction, declaration.direction);
            this.display = parse(context, display, declaration.display);
            this.float = parse(context, float, declaration.cssFloat);
            this.fontFamily = parse(context, fontFamily, declaration.fontFamily);
            this.fontSize = parse(context, fontSize, declaration.fontSize);
            this.fontStyle = parse(context, fontStyle, declaration.fontStyle);
            this.fontVariant = parse(context, fontVariant, declaration.fontVariant);
            this.fontWeight = parse(context, fontWeight, declaration.fontWeight);
            this.letterSpacing = parse(context, letterSpacing, declaration.letterSpacing);
            this.lineBreak = parse(context, lineBreak, declaration.lineBreak);
            this.lineHeight = parse(context, lineHeight, declaration.lineHeight);
            this.listStyleImage = parse(context, listStyleImage, declaration.listStyleImage);
            this.listStylePosition = parse(context, listStylePosition, declaration.listStylePosition);
            this.listStyleType = parse(context, listStyleType, declaration.listStyleType);
            this.marginTop = parse(context, marginTop, declaration.marginTop);
            this.marginRight = parse(context, marginRight, declaration.marginRight);
            this.marginBottom = parse(context, marginBottom, declaration.marginBottom);
            this.marginLeft = parse(context, marginLeft, declaration.marginLeft);
            this.opacity = parse(context, opacity, declaration.opacity);
            var overflowTuple = parse(context, overflow, declaration.overflow);
            this.overflowX = overflowTuple[0];
            this.overflowY = overflowTuple[overflowTuple.length > 1 ? 1 : 0];
            this.overflowWrap = parse(context, overflowWrap, declaration.overflowWrap);
            this.paddingTop = parse(context, paddingTop, declaration.paddingTop);
            this.paddingRight = parse(context, paddingRight, declaration.paddingRight);
            this.paddingBottom = parse(context, paddingBottom, declaration.paddingBottom);
            this.paddingLeft = parse(context, paddingLeft, declaration.paddingLeft);
            this.paintOrder = parse(context, paintOrder, declaration.paintOrder);
            this.position = parse(context, position, declaration.position);
            this.textAlign = parse(context, textAlign, declaration.textAlign);
            this.textDecorationColor = parse(context, textDecorationColor, (_a = declaration.textDecorationColor) !== null && _a !== void 0 ? _a : declaration.color);
            this.textDecorationLine = parse(context, textDecorationLine, (_b = declaration.textDecorationLine) !== null && _b !== void 0 ? _b : declaration.textDecoration);
            this.textShadow = parse(context, textShadow, declaration.textShadow);
            this.textTransform = parse(context, textTransform, declaration.textTransform);
            this.transform = parse(context, transform$1, declaration.transform);
            this.transformOrigin = parse(context, transformOrigin, declaration.transformOrigin);
            this.visibility = parse(context, visibility, declaration.visibility);
            this.webkitTextStrokeColor = parse(context, webkitTextStrokeColor, declaration.webkitTextStrokeColor);
            this.webkitTextStrokeWidth = parse(context, webkitTextStrokeWidth, declaration.webkitTextStrokeWidth);
            this.wordBreak = parse(context, wordBreak, declaration.wordBreak);
            this.zIndex = parse(context, zIndex, declaration.zIndex);
            this.webkitMaskImage = parse(context, webkitMaskImage, declaration.webkitMaskImage);
        }
        CSSParsedDeclaration.prototype.isVisible = function () {
            return this.display > 0 && this.opacity > 0 && this.visibility === 0 /* VISIBLE */;
        };
        CSSParsedDeclaration.prototype.isTransparent = function () {
            return isTransparent(this.backgroundColor);
        };
        CSSParsedDeclaration.prototype.isTransformed = function () {
            return this.transform !== null;
        };
        CSSParsedDeclaration.prototype.isPositioned = function () {
            return this.position !== 0 /* STATIC */;
        };
        CSSParsedDeclaration.prototype.isPositionedWithZIndex = function () {
            return this.isPositioned() && !this.zIndex.auto;
        };
        CSSParsedDeclaration.prototype.isFloating = function () {
            return this.float !== 0 /* NONE */;
        };
        CSSParsedDeclaration.prototype.isInlineLevel = function () {
            return (contains(this.display, 4 /* INLINE */) ||
                contains(this.display, 33554432 /* INLINE_BLOCK */) ||
                contains(this.display, 268435456 /* INLINE_FLEX */) ||
                contains(this.display, 536870912 /* INLINE_GRID */) ||
                contains(this.display, 67108864 /* INLINE_LIST_ITEM */) ||
                contains(this.display, 134217728 /* INLINE_TABLE */));
        };
        return CSSParsedDeclaration;
    }());
    var CSSParsedPseudoDeclaration = /** @class */ (function () {
        function CSSParsedPseudoDeclaration(context, declaration) {
            this.content = parse(context, content, declaration.content);
            this.quotes = parse(context, quotes, declaration.quotes);
        }
        return CSSParsedPseudoDeclaration;
    }());
    var CSSParsedCounterDeclaration = /** @class */ (function () {
        function CSSParsedCounterDeclaration(context, declaration) {
            this.counterIncrement = parse(context, counterIncrement, declaration.counterIncrement);
            this.counterReset = parse(context, counterReset, declaration.counterReset);
        }
        return CSSParsedCounterDeclaration;
    }());
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var parse = function (context, descriptor, style) {
        var tokenizer = new Tokenizer();
        var value = style !== null && typeof style !== 'undefined' ? style.toString() : descriptor.initialValue;
        tokenizer.write(value);
        var parser = new Parser(tokenizer.read());
        switch (descriptor.type) {
            case 2 /* IDENT_VALUE */:
                var token = parser.parseComponentValue();
                return descriptor.parse(context, isIdentToken(token) ? token.value : descriptor.initialValue);
            case 0 /* VALUE */:
                return descriptor.parse(context, parser.parseComponentValue());
            case 1 /* LIST */:
                return descriptor.parse(context, parser.parseComponentValues());
            case 4 /* TOKEN_VALUE */:
                return parser.parseComponentValue();
            case 3 /* TYPE_VALUE */:
                switch (descriptor.format) {
                    case 'angle':
                        return angle.parse(context, parser.parseComponentValue());
                    case 'color':
                        return color$1.parse(context, parser.parseComponentValue());
                    case 'image':
                        return image.parse(context, parser.parseComponentValue());
                    case 'length':
                        var length_1 = parser.parseComponentValue();
                        return isLength(length_1) ? length_1 : ZERO_LENGTH;
                    case 'length-percentage':
                        var value_1 = parser.parseComponentValue();
                        return isLengthPercentage(value_1) ? value_1 : ZERO_LENGTH;
                    case 'time':
                        return time.parse(context, parser.parseComponentValue());
                }
                break;
        }
    };

    var elementDebuggerAttribute = 'data-html2canvas-debug';
    var getElementDebugType = function (element) {
        var attribute = element.getAttribute(elementDebuggerAttribute);
        switch (attribute) {
            case 'all':
                return 1 /* ALL */;
            case 'clone':
                return 2 /* CLONE */;
            case 'parse':
                return 3 /* PARSE */;
            case 'render':
                return 4 /* RENDER */;
            default:
                return 0 /* NONE */;
        }
    };
    var isDebugging = function (element, type) {
        var elementType = getElementDebugType(element);
        return elementType === 1 /* ALL */ || type === elementType;
    };

    var ElementContainer = /** @class */ (function () {
        function ElementContainer(context, element) {
            this.context = context;
            this.textNodes = [];
            this.elements = [];
            this.flags = 0;
            if (isDebugging(element, 3 /* PARSE */)) {
                debugger;
            }
            this.styles = new CSSParsedDeclaration(context, window.getComputedStyle(element, null));
            if (isHTMLElementNode(element)) {
                if (this.styles.animationDuration.some(function (duration) { return duration > 0; })) {
                    element.style.animationDuration = '0s';
                }
                if (this.styles.transform !== null) {
                    // getBoundingClientRect takes transforms into account
                    element.style.transform = 'none';
                }
            }
            this.bounds = parseBounds(this.context, element);

            if (element.hasAttribute('data-html2canvas-hole')) {
                this.isHole = true;
            }
            if (element.hasAttribute('data-html2canvas-target')) {
                this.isTarget = true;
            }

            if (isDebugging(element, 4 /* RENDER */)) {
                this.flags |= 16 /* DEBUG_RENDER */;
            }
        }
        return ElementContainer;
    }());

    /*
     * text-segmentation 1.0.3 <https://github.com/niklasvh/text-segmentation>
     * Copyright (c) 2022 Niklas von Hertzen <https://hertzen.com>
     * Released under MIT License
     */
    var base64 = 'AAAAAAAAAAAAEA4AGBkAAFAaAAACAAAAAAAIABAAGAAwADgACAAQAAgAEAAIABAACAAQAAgAEAAIABAACAAQAAgAEAAIABAAQABIAEQATAAIABAACAAQAAgAEAAIABAAVABcAAgAEAAIABAACAAQAGAAaABwAHgAgACIAI4AlgAIABAAmwCjAKgAsAC2AL4AvQDFAMoA0gBPAVYBWgEIAAgACACMANoAYgFkAWwBdAF8AX0BhQGNAZUBlgGeAaMBlQGWAasBswF8AbsBwwF0AcsBYwHTAQgA2wG/AOMBdAF8AekB8QF0AfkB+wHiAHQBfAEIAAMC5gQIAAsCEgIIAAgAFgIeAggAIgIpAggAMQI5AkACygEIAAgASAJQAlgCYAIIAAgACAAKBQoFCgUTBRMFGQUrBSsFCAAIAAgACAAIAAgACAAIAAgACABdAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACABoAmgCrwGvAQgAbgJ2AggAHgEIAAgACADnAXsCCAAIAAgAgwIIAAgACAAIAAgACACKAggAkQKZAggAPADJAAgAoQKkAqwCsgK6AsICCADJAggA0AIIAAgACAAIANYC3gIIAAgACAAIAAgACABAAOYCCAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAkASoB+QIEAAgACAA8AEMCCABCBQgACABJBVAFCAAIAAgACAAIAAgACAAIAAgACABTBVoFCAAIAFoFCABfBWUFCAAIAAgACAAIAAgAbQUIAAgACAAIAAgACABzBXsFfQWFBYoFigWKBZEFigWKBYoFmAWfBaYFrgWxBbkFCAAIAAgACAAIAAgACAAIAAgACAAIAMEFCAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAMgFCADQBQgACAAIAAgACAAIAAgACAAIAAgACAAIAO4CCAAIAAgAiQAIAAgACABAAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAD0AggACAD8AggACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIANYFCAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAMDvwAIAAgAJAIIAAgACAAIAAgACAAIAAgACwMTAwgACAB9BOsEGwMjAwgAKwMyAwsFYgE3A/MEPwMIAEUDTQNRAwgAWQOsAGEDCAAIAAgACAAIAAgACABpAzQFNQU2BTcFOAU5BToFNAU1BTYFNwU4BTkFOgU0BTUFNgU3BTgFOQU6BTQFNQU2BTcFOAU5BToFNAU1BTYFNwU4BTkFOgU0BTUFNgU3BTgFOQU6BTQFNQU2BTcFOAU5BToFNAU1BTYFNwU4BTkFOgU0BTUFNgU3BTgFOQU6BTQFNQU2BTcFOAU5BToFNAU1BTYFNwU4BTkFOgU0BTUFNgU3BTgFOQU6BTQFNQU2BTcFOAU5BToFNAU1BTYFNwU4BTkFOgU0BTUFNgU3BTgFOQU6BTQFNQU2BTcFOAU5BToFNAU1BTYFNwU4BTkFOgU0BTUFNgU3BTgFOQU6BTQFNQU2BTcFOAU5BToFNAU1BTYFNwU4BTkFOgU0BTUFNgU3BTgFOQU6BTQFNQU2BTcFOAU5BToFNAU1BTYFNwU4BTkFOgU0BTUFNgU3BTgFOQU6BTQFNQU2BTcFOAU5BToFNAU1BTYFNwU4BTkFOgU0BTUFNgU3BTgFOQU6BTQFNQU2BTcFOAU5BToFNAU1BTYFNwU4BTkFOgU0BTUFNgU3BTgFOQU6BTQFNQU2BTcFOAU5BToFNAU1BTYFNwU4BTkFOgU0BTUFNgU3BTgFOQU6BTQFNQU2BTcFOAU5BToFNAU1BTYFNwU4BTkFOgU0BTUFNgU3BTgFOQU6BTQFNQU2BTcFOAU5BToFNAU1BTYFNwU4BTkFOgU0BTUFNgU3BTgFOQU6BTQFNQU2BTcFOAU5BToFNAU1BTYFNwU4BTkFOgU0BTUFNgU3BTgFOQU6BTQFNQU2BTcFOAU5BToFNAU1BTYFNwU4BTkFOgU0BTUFNgU3BTgFOQU6BTQFNQU2BTcFOAU5BToFNAU1BTYFNwU4BTkFOgU0BTUFNgU3BTgFOQU6BTQFNQU2BTcFOAU5BToFNAU1BTYFNwU4BTkFIQUoBSwFCAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACABtAwgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACABMAEwACAAIAAgACAAIABgACAAIAAgACAC/AAgACAAyAQgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACACAAIAAwAAgACAAIAAgACAAIAAgACAAIAAAARABIAAgACAAIABQASAAIAAgAIABwAEAAjgCIABsAqAC2AL0AigDQAtwC+IJIQqVAZUBWQqVAZUBlQGVAZUBlQGrC5UBlQGVAZUBlQGVAZUBlQGVAXsKlQGVAbAK6wsrDGUMpQzlDJUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAfAKAAuZA64AtwCJALoC6ADwAAgAuACgA/oEpgO6AqsD+AAIAAgAswMIAAgACAAIAIkAuwP5AfsBwwPLAwgACAAIAAgACADRA9kDCAAIAOED6QMIAAgACAAIAAgACADuA/YDCAAIAP4DyQAIAAgABgQIAAgAXQAOBAgACAAIAAgACAAIABMECAAIAAgACAAIAAgACAD8AAQBCAAIAAgAGgQiBCoECAExBAgAEAEIAAgACAAIAAgACAAIAAgACAAIAAgACAA4BAgACABABEYECAAIAAgATAQYAQgAVAQIAAgACAAIAAgACAAIAAgACAAIAFoECAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgAOQEIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAB+BAcACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAEABhgSMBAgACAAIAAgAlAQIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAwAEAAQABAADAAMAAwADAAQABAAEAAQABAAEAAQABHATAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgAdQMIAAgACAAIAAgACAAIAMkACAAIAAgAfQMIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACACFA4kDCAAIAAgACAAIAOcBCAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAIcDCAAIAAgACAAIAAgACAAIAAgACAAIAJEDCAAIAAgACADFAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACABgBAgAZgQIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgAbAQCBXIECAAIAHkECAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACABAAJwEQACjBKoEsgQIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAC6BMIECAAIAAgACAAIAAgACABmBAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgAxwQIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAGYECAAIAAgAzgQIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgAigWKBYoFigWKBYoFigWKBd0FXwUIAOIF6gXxBYoF3gT5BQAGCAaKBYoFigWKBYoFigWKBYoFigWKBYoFigXWBIoFigWKBYoFigWKBYoFigWKBYsFEAaKBYoFigWKBYoFigWKBRQGCACKBYoFigWKBQgACAAIANEECAAIABgGigUgBggAJgYIAC4GMwaKBYoF0wQ3Bj4GigWKBYoFigWKBYoFigWKBYoFigWKBYoFigUIAAgACAAIAAgACAAIAAgAigWKBYoFigWKBYoFigWKBYoFigWKBYoFigWKBYoFigWKBYoFigWKBYoFigWKBYoFigWKBYoFigWKBYoFigWLBf///////wQABAAEAAQABAAEAAQABAAEAAQAAwAEAAQAAgAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAAAAAAAAAAAAAAAAAAAAAAAAAOAAAAAAAAAAQADgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAUABQAFAAUABQAFAAUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAAAAUAAAAFAAUAAAAFAAUAAAAFAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABAAEAAQABAAEAAQAAAAAAAAAAAAAAAAAAAAAAAAAAAAUABQAFAAUABQAFAAUABQAFAAUABQAAAAQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAUABQAFAAUABQAFAAUAAQAAAAUABQAFAAUABQAFAAAAAAAFAAUAAAAFAAUABQAFAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEAAAAFAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAFAAUABQAFAAUABQAFAAUABQAFAAUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAFAAUABQAFAAUABQAFAAUABQAAAAAAAAAAAAAAAAAAAAAAAAAFAAAAAAAFAAUAAQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABwAFAAUABQAFAAAABwAHAAcAAAAHAAcABwAFAAEAAAAAAAAAAAAAAAAAAAAAAAUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAHAAcABwAFAAUABQAFAAcABwAFAAUAAAAAAAEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAHAAAAAQABAAAAAAAAAAAAAAAFAAUABQAFAAAABwAFAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABQAHAAcABwAHAAcAAAAHAAcAAAAAAAUABQAHAAUAAQAHAAEABwAFAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABQAFAAUABQAFAAUABwABAAUABQAFAAUAAAAAAAAAAAAAAAEAAQABAAEAAQABAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABwAFAAUAAAAAAAAAAAAAAAAABQAFAAUABQAFAAUAAQAFAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAUABQAFAAQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQABQANAAQABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQABAAEAAQABAAEAAQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAOAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABAAEAAQABAAEAAQABAAEAAQABAAEAAQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEAAQABAAEAAQABAAEAAQABAAAAAAAAAAAAAAAAAAAAAAABQAHAAUABQAFAAAAAAAAAAcABQAFAAUABQAFAAQABAAEAAQABAAEAAQABAAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAUABQAFAAUAAAAFAAUABQAFAAUAAAAFAAUABQAAAAUABQAFAAUABQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAFAAUABQAAAAAAAAAAAAUABQAFAAcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABQAHAAUAAAAHAAcABwAFAAUABQAFAAUABQAFAAUABwAHAAcABwAFAAcABwAAAAUABQAFAAUABQAFAAUAAAAAAAAAAAAAAAAAAAAAAAAAAAAFAAUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAUABwAHAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABQAAAAUABwAHAAUABQAFAAUAAAAAAAcABwAAAAAABwAHAAUAAAAAAAAAAAAAAAAAAAAAAAAABQAAAAAAAAAAAAAAAAAAAAAAAAAAAAUABQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABQAAAAAABQAFAAcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAFAAAABwAHAAcABQAFAAAAAAAAAAAABQAFAAAAAAAFAAUABQAAAAAAAAAFAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAUABQAAAAAAAAAFAAAAAAAAAAAAAAAAAAAAAAAAAAAABwAFAAUABQAFAAUAAAAFAAUABwAAAAcABwAFAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAFAAUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAFAAUABQAFAAUABQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAUAAAAFAAUABwAFAAUABQAFAAAAAAAHAAcAAAAAAAcABwAFAAAAAAAAAAAAAAAAAAAABQAFAAUAAAAAAAAAAAAAAAAAAAAAAAAAAAAFAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAFAAcABwAAAAAAAAAHAAcABwAAAAcABwAHAAUAAAAAAAAAAAAAAAAAAAAAAAAABQAAAAAAAAAAAAAAAAAAAAAABQAHAAcABwAFAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAUABwAHAAcABwAAAAUABQAFAAAABQAFAAUABQAAAAAAAAAAAAAAAAAAAAUABQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABQAAAAcABQAHAAcABQAHAAcAAAAFAAcABwAAAAcABwAFAAUAAAAAAAAAAAAAAAAAAAAFAAUAAAAAAAAAAAAAAAAAAAAAAAAABQAFAAcABwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAUABQAAAAUABwAAAAAAAAAAAAAAAAAAAAAAAAAAAAUAAAAAAAAAAAAFAAcABwAFAAUABQAAAAUAAAAHAAcABwAHAAcABwAHAAUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAUAAAAHAAUABQAFAAUABQAFAAUAAAAAAAAAAAAAAAAAAAAAAAUABQAFAAUABQAFAAUABQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAFAAAABwAFAAUABQAFAAUABQAFAAUABQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABQAFAAUABQAFAAUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAUABQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABQAAAAUAAAAFAAAAAAAAAAAABwAHAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABwAFAAUABQAFAAUAAAAFAAUAAAAAAAAAAAAAAAUABQAFAAUABQAFAAUABQAFAAUABQAAAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAUABQAFAAUABwAFAAUABQAFAAUABQAAAAUABQAHAAcABQAFAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAHAAcABQAFAAAAAAAAAAAABQAFAAUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAFAAUABQAFAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABQAAAAcABQAFAAAAAAAAAAAAAAAAAAUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABQAFAAUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAUABQAHAAUABQAFAAUABQAFAAUABwAHAAcABwAHAAcABwAHAAUABwAHAAUABQAFAAUABQAFAAUABQAFAAUABQAAAAAAAAAAAAAAAAAAAAAAAAAFAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABQAFAAUABwAHAAcABwAFAAUABwAHAAcAAAAAAAAAAAAHAAcABQAHAAcABwAHAAcABwAFAAUABQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABQAFAAcABwAFAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAcABQAHAAUABQAFAAUABQAFAAUAAAAFAAAABQAAAAAABQAFAAUABQAFAAUABQAFAAcABwAHAAcABwAHAAUABQAFAAUABQAFAAUABQAFAAUAAAAAAAUABQAFAAUABQAHAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAUABQAFAAUABQAFAAUABwAFAAcABwAHAAcABwAFAAcABwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAFAAUABQAFAAUABQAFAAUABQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAFAAUABwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAHAAUABQAFAAUABwAHAAUABQAHAAUABQAFAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAFAAcABQAFAAcABwAHAAUABwAFAAUABQAHAAcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABwAHAAcABwAHAAcABwAHAAUABQAFAAUABQAFAAUABQAHAAcABQAFAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABQAFAAUAAAAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAcABQAFAAUABQAFAAUABQAAAAAAAAAAAAUAAAAAAAAAAAAAAAAABQAAAAAABwAFAAUAAAAAAAAAAAAAAAAABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAAABQAFAAUABQAFAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAUABQAFAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABQAFAAUABQAFAAUADgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAOAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAUABQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAUABQAFAAUAAAAFAAUABQAFAAUABQAFAAUABQAFAAAAAAAAAAAABQAAAAAAAAAFAAAAAAAAAAAABQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABwAHAAUABQAHAAAAAAAAAAAABQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAcABwAHAAcABQAFAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAUAAAAAAAAAAAAAAAAABQAFAAUABQAFAAUABQAFAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAUABQAFAAUABQAFAAUABQAFAAUABQAHAAcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAFAAcABwAFAAUABQAFAAcABwAFAAUABwAHAAAAAAAAAAAAAAAFAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAUABQAFAAUABQAFAAcABwAFAAUABwAHAAUABQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAFAAAAAAAAAAAAAAAAAAAAAAAFAAcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAUAAAAFAAUABQAAAAAABQAFAAAAAAAAAAAAAAAFAAUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAcABQAFAAcABwAAAAAAAAAAAAAABwAFAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAcABwAFAAcABwAFAAcABwAAAAcABQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAFAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAUABQAFAAUABQAAAAAAAAAAAAAAAAAFAAUABQAAAAUABQAAAAAAAAAAAAAABQAFAAUABQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAFAAUABQAAAAAAAAAAAAUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAUABQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAcABQAHAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAFAAUABQAFAAUABwAFAAUABQAFAAUABQAFAAUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAFAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABwAHAAcABQAFAAUABQAFAAUABQAFAAUABwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAHAAcABwAFAAUABQAHAAcABQAHAAUABQAAAAAAAAAAAAAAAAAFAAAABwAHAAcABQAFAAUABQAFAAUABQAFAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAUABwAHAAcABwAAAAAABwAHAAAAAAAHAAcABwAAAAAAAAAAAAAAAAAAAAAAAAAFAAAAAAAAAAAAAAAAAAAAAAAAAAAABwAHAAAAAAAFAAUABQAFAAUABQAFAAAAAAAAAAUABQAFAAUABQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAHAAcABwAFAAUABQAFAAUABQAFAAUABwAHAAUABQAFAAcABQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABQAHAAcABQAFAAUABQAFAAUABwAFAAcABwAFAAcABQAFAAcABQAFAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABQAHAAcABQAFAAUABQAAAAAABwAHAAcABwAFAAUABwAFAAUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABQAFAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAcABwAHAAUABQAFAAUABQAFAAUABQAHAAcABQAHAAUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAUABwAFAAcABwAFAAUABQAFAAUABQAHAAUAAAAAAAAAAAAAAAAAAAAAAAcABwAFAAUABQAFAAcABQAFAAUABQAFAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAHAAcABwAFAAUABQAFAAUABQAFAAUABQAHAAUABQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAHAAcABwAFAAUABQAFAAAAAAAFAAUABwAHAAcABwAFAAAAAAAAAAcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAFAAUABQAFAAUABQAFAAUABQAFAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAUAAAAAAAAAAAAAAAAAAAAAAAAABQAFAAUABQAFAAUABwAHAAUABQAFAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAcABQAFAAUABQAFAAUABQAAAAUABQAFAAUABQAFAAcABQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAAAAHAAUABQAFAAUABQAFAAUABwAFAAUABwAFAAUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABQAFAAUABQAFAAUAAAAAAAAABQAAAAUABQAAAAUAAAAAAAAAAAAAAAAAAAAAAAAAAAAHAAcABwAHAAcAAAAFAAUAAAAHAAcABQAHAAUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAFAAUABwAHAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAFAAUABQAFAAUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAFAAUABQAFAAUABQAFAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABQAAAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAAAAAAAAAAAAAAAAAAABQAFAAUABQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAcABwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAUABQAAAAUABQAFAAAAAAAFAAUABQAFAAUABQAFAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABQAFAAUABQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABQAFAAUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAAAAAAAAAAABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAAAAAAAAAAAAAAAAAAAAAAFAAAAAAAAAAAAAAAAAAAAAAAAAAAABQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAUABQAFAAUABQAAAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABQAFAAUABQAFAAUABQAAAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAAAAAABQAFAAUABQAFAAUABQAAAAUABQAAAAUABQAFAAUABQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAFAAUABQAFAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABQAFAAUABQAFAAUABQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAOAA4ADgAOAA4ADgAOAA4ADgAOAA4ADgAOAA4ADgAOAA4ADgAOAA4ADgAOAA4ADgAOAA4ADgAFAAUABQAFAAUADgAOAA4ADgAOAA4ADwAPAA8ADwAPAA8ADwAPAA8ADwAPAA8ADwAPAA8ADwAPAA8ADwAPAA8ADwAPAA8ADwAPAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAcABwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABwAHAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAAAAAAAAAkACQAJAAkACQAJAAkACQAJAAkACQAJAAkACQAJAAkACQAJAAkACQAJAAkACQAJAAkACQAJAAkACQAJAAkACQAKAAoACgAKAAoACgAKAAoACgAKAAoACgAKAAoACgAKAAoACgAKAAoACgAKAAoACgAMAAwADAAMAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAkACQAJAAkACQAJAAkACQAJAAkACQAJAAkACQAJAAkACQAJAAkAAAAAAAAAAAAKAAoACgAKAAoACgAKAAoACgAKAAoACgAKAAoACgAKAAoACgAKAAoACgAKAAoACgAKAAoACgAKAAoACgAKAAoACgAAAAAAAAAAAAsADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwACwAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAAAAAADgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAOAA4ADgAOAA4ADgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADgAOAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA4ADgAAAAAAAAAAAAAAAAAAAAAADgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADgAOAA4ADgAOAA4ADgAOAA4ADgAOAAAAAAAAAAAADgAOAA4AAAAAAAAAAAAAAAAAAAAOAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADgAOAAAAAAAAAAAAAAAAAAAAAAAAAAAADgAAAAAAAAAAAAAAAAAAAAAAAAAOAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADgAOAA4ADgAAAA4ADgAOAA4ADgAOAAAADgAOAA4ADgAOAA4ADgAOAA4ADgAOAA4AAAAOAA4ADgAOAA4ADgAOAA4ADgAOAA4ADgAOAA4ADgAOAA4ADgAOAA4ADgAOAA4ADgAOAA4ADgAOAA4ADgAOAA4ADgAOAAAAAAAAAAAAAAAAAAAAAAAAAAAADgAOAA4ADgAOAA4ADgAOAA4ADgAOAA4ADgAOAA4ADgAOAA4AAAAAAA4ADgAOAA4ADgAOAA4ADgAOAA4ADgAAAA4AAAAOAAAAAAAAAAAAAAAAAA4AAAAAAAAAAAAAAAAADgAAAAAAAAAAAAAAAAAAAAAAAAAAAA4ADgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADgAAAAAADgAAAAAAAAAAAA4AAAAOAAAAAAAAAAAADgAOAA4AAAAOAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAOAA4ADgAOAA4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAOAA4ADgAAAAAAAAAAAAAAAAAAAAAAAAAOAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAOAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAOAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAOAA4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA4ADgAOAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADgAOAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADgAAAAAAAAAAAA4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAOAAAADgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAOAA4ADgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA4ADgAOAA4ADgAOAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA4ADgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADgAAAAAADgAOAA4ADgAOAA4ADgAOAA4ADgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADgAOAA4ADgAOAA4ADgAOAA4ADgAOAA4ADgAOAA4ADgAOAA4ADgAAAA4ADgAOAA4ADgAOAA4ADgAOAA4ADgAOAA4ADgAOAAAAAAAAAAAAAAAAAAAAAAAAAAAADgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA4AAAAAAA4ADgAOAA4ADgAOAA4ADgAOAAAADgAOAA4ADgAAAAAAAAAAAAAAAAAAAAAAAAAOAA4ADgAOAA4ADgAOAA4ADgAOAA4ADgAOAA4ADgAOAA4ADgAOAA4ADgAOAA4AAAAAAAAAAAAAAAAADgAOAA4ADgAOAA4ADgAOAA4ADgAOAA4ADgAOAA4ADgAOAA4ADgAOAA4ADgAOAA4ADgAOAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA4ADgAOAA4ADgAOAA4ADgAOAA4ADgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAOAA4ADgAOAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADgAOAA4ADgAOAA4ADgAOAAAAAAAAAAAAAAAAAAAAAAAAAAAADgAOAA4ADgAOAA4AAAAAAAAAAAAAAAAAAAAAAA4ADgAOAA4ADgAOAA4ADgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAOAA4ADgAOAA4ADgAOAA4ADgAOAA4ADgAOAA4ADgAOAA4ADgAOAA4ADgAOAA4ADgAOAA4ADgAOAA4AAAAOAA4ADgAOAA4ADgAAAA4ADgAOAA4ADgAOAA4ADgAOAA4ADgAOAA4ADgAOAA4ADgAOAA4ADgAOAA4ADgAOAA4AAAAAAAAAAAA=';

    /*
     * utrie 1.0.2 <https://github.com/niklasvh/utrie>
     * Copyright (c) 2022 Niklas von Hertzen <https://hertzen.com>
     * Released under MIT License
     */
    var chars$1 = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
    // Use a lookup table to find the index.
    var lookup$1 = typeof Uint8Array === 'undefined' ? [] : new Uint8Array(256);
    for (var i$1 = 0; i$1 < chars$1.length; i$1++) {
        lookup$1[chars$1.charCodeAt(i$1)] = i$1;
    }
    var decode = function (base64) {
        var bufferLength = base64.length * 0.75, len = base64.length, i, p = 0, encoded1, encoded2, encoded3, encoded4;
        if (base64[base64.length - 1] === '=') {
            bufferLength--;
            if (base64[base64.length - 2] === '=') {
                bufferLength--;
            }
        }
        var buffer = typeof ArrayBuffer !== 'undefined' &&
            typeof Uint8Array !== 'undefined' &&
            typeof Uint8Array.prototype.slice !== 'undefined'
            ? new ArrayBuffer(bufferLength)
            : new Array(bufferLength);
        var bytes = Array.isArray(buffer) ? buffer : new Uint8Array(buffer);
        for (i = 0; i < len; i += 4) {
            encoded1 = lookup$1[base64.charCodeAt(i)];
            encoded2 = lookup$1[base64.charCodeAt(i + 1)];
            encoded3 = lookup$1[base64.charCodeAt(i + 2)];
            encoded4 = lookup$1[base64.charCodeAt(i + 3)];
            bytes[p++] = (encoded1 << 2) | (encoded2 >> 4);
            bytes[p++] = ((encoded2 & 15) << 4) | (encoded3 >> 2);
            bytes[p++] = ((encoded3 & 3) << 6) | (encoded4 & 63);
        }
        return buffer;
    };
    var polyUint16Array = function (buffer) {
        var length = buffer.length;
        var bytes = [];
        for (var i = 0; i < length; i += 2) {
            bytes.push((buffer[i + 1] << 8) | buffer[i]);
        }
        return bytes;
    };
    var polyUint32Array = function (buffer) {
        var length = buffer.length;
        var bytes = [];
        for (var i = 0; i < length; i += 4) {
            bytes.push((buffer[i + 3] << 24) | (buffer[i + 2] << 16) | (buffer[i + 1] << 8) | buffer[i]);
        }
        return bytes;
    };

    /** Shift size for getting the index-2 table offset. */
    var UTRIE2_SHIFT_2 = 5;
    /** Shift size for getting the index-1 table offset. */
    var UTRIE2_SHIFT_1 = 6 + 5;
    /**
     * Shift size for shifting left the index array values.
     * Increases possible data size with 16-bit index values at the cost
     * of compactability.
     * This requires data blocks to be aligned by UTRIE2_DATA_GRANULARITY.
     */
    var UTRIE2_INDEX_SHIFT = 2;
    /**
     * Difference between the two shift sizes,
     * for getting an index-1 offset from an index-2 offset. 6=11-5
     */
    var UTRIE2_SHIFT_1_2 = UTRIE2_SHIFT_1 - UTRIE2_SHIFT_2;
    /**
     * The part of the index-2 table for U+D800..U+DBFF stores values for
     * lead surrogate code _units_ not code _points_.
     * Values for lead surrogate code _points_ are indexed with this portion of the table.
     * Length=32=0x20=0x400>>UTRIE2_SHIFT_2. (There are 1024=0x400 lead surrogates.)
     */
    var UTRIE2_LSCP_INDEX_2_OFFSET = 0x10000 >> UTRIE2_SHIFT_2;
    /** Number of entries in a data block. 32=0x20 */
    var UTRIE2_DATA_BLOCK_LENGTH = 1 << UTRIE2_SHIFT_2;
    /** Mask for getting the lower bits for the in-data-block offset. */
    var UTRIE2_DATA_MASK = UTRIE2_DATA_BLOCK_LENGTH - 1;
    var UTRIE2_LSCP_INDEX_2_LENGTH = 0x400 >> UTRIE2_SHIFT_2;
    /** Count the lengths of both BMP pieces. 2080=0x820 */
    var UTRIE2_INDEX_2_BMP_LENGTH = UTRIE2_LSCP_INDEX_2_OFFSET + UTRIE2_LSCP_INDEX_2_LENGTH;
    /**
     * The 2-byte UTF-8 version of the index-2 table follows at offset 2080=0x820.
     * Length 32=0x20 for lead bytes C0..DF, regardless of UTRIE2_SHIFT_2.
     */
    var UTRIE2_UTF8_2B_INDEX_2_OFFSET = UTRIE2_INDEX_2_BMP_LENGTH;
    var UTRIE2_UTF8_2B_INDEX_2_LENGTH = 0x800 >> 6; /* U+0800 is the first code point after 2-byte UTF-8 */
    /**
     * The index-1 table, only used for supplementary code points, at offset 2112=0x840.
     * Variable length, for code points up to highStart, where the last single-value range starts.
     * Maximum length 512=0x200=0x100000>>UTRIE2_SHIFT_1.
     * (For 0x100000 supplementary code points U+10000..U+10ffff.)
     *
     * The part of the index-2 table for supplementary code points starts
     * after this index-1 table.
     *
     * Both the index-1 table and the following part of the index-2 table
     * are omitted completely if there is only BMP data.
     */
    var UTRIE2_INDEX_1_OFFSET = UTRIE2_UTF8_2B_INDEX_2_OFFSET + UTRIE2_UTF8_2B_INDEX_2_LENGTH;
    /**
     * Number of index-1 entries for the BMP. 32=0x20
     * This part of the index-1 table is omitted from the serialized form.
     */
    var UTRIE2_OMITTED_BMP_INDEX_1_LENGTH = 0x10000 >> UTRIE2_SHIFT_1;
    /** Number of entries in an index-2 block. 64=0x40 */
    var UTRIE2_INDEX_2_BLOCK_LENGTH = 1 << UTRIE2_SHIFT_1_2;
    /** Mask for getting the lower bits for the in-index-2-block offset. */
    var UTRIE2_INDEX_2_MASK = UTRIE2_INDEX_2_BLOCK_LENGTH - 1;
    var slice16 = function (view, start, end) {
        if (view.slice) {
            return view.slice(start, end);
        }
        return new Uint16Array(Array.prototype.slice.call(view, start, end));
    };
    var slice32 = function (view, start, end) {
        if (view.slice) {
            return view.slice(start, end);
        }
        return new Uint32Array(Array.prototype.slice.call(view, start, end));
    };
    var createTrieFromBase64 = function (base64, _byteLength) {
        var buffer = decode(base64);
        var view32 = Array.isArray(buffer) ? polyUint32Array(buffer) : new Uint32Array(buffer);
        var view16 = Array.isArray(buffer) ? polyUint16Array(buffer) : new Uint16Array(buffer);
        var headerLength = 24;
        var index = slice16(view16, headerLength / 2, view32[4] / 2);
        var data = view32[5] === 2
            ? slice16(view16, (headerLength + view32[4]) / 2)
            : slice32(view32, Math.ceil((headerLength + view32[4]) / 4));
        return new Trie(view32[0], view32[1], view32[2], view32[3], index, data);
    };
    var Trie = /** @class */ (function () {
        function Trie(initialValue, errorValue, highStart, highValueIndex, index, data) {
            this.initialValue = initialValue;
            this.errorValue = errorValue;
            this.highStart = highStart;
            this.highValueIndex = highValueIndex;
            this.index = index;
            this.data = data;
        }
        /**
         * Get the value for a code point as stored in the Trie.
         *
         * @param codePoint the code point
         * @return the value
         */
        Trie.prototype.get = function (codePoint) {
            var ix;
            if (codePoint >= 0) {
                if (codePoint < 0x0d800 || (codePoint > 0x0dbff && codePoint <= 0x0ffff)) {
                    // Ordinary BMP code point, excluding leading surrogates.
                    // BMP uses a single level lookup.  BMP index starts at offset 0 in the Trie2 index.
                    // 16 bit data is stored in the index array itself.
                    ix = this.index[codePoint >> UTRIE2_SHIFT_2];
                    ix = (ix << UTRIE2_INDEX_SHIFT) + (codePoint & UTRIE2_DATA_MASK);
                    return this.data[ix];
                }
                if (codePoint <= 0xffff) {
                    // Lead Surrogate Code Point.  A Separate index section is stored for
                    // lead surrogate code units and code points.
                    //   The main index has the code unit data.
                    //   For this function, we need the code point data.
                    // Note: this expression could be refactored for slightly improved efficiency, but
                    //       surrogate code points will be so rare in practice that it's not worth it.
                    ix = this.index[UTRIE2_LSCP_INDEX_2_OFFSET + ((codePoint - 0xd800) >> UTRIE2_SHIFT_2)];
                    ix = (ix << UTRIE2_INDEX_SHIFT) + (codePoint & UTRIE2_DATA_MASK);
                    return this.data[ix];
                }
                if (codePoint < this.highStart) {
                    // Supplemental code point, use two-level lookup.
                    ix = UTRIE2_INDEX_1_OFFSET - UTRIE2_OMITTED_BMP_INDEX_1_LENGTH + (codePoint >> UTRIE2_SHIFT_1);
                    ix = this.index[ix];
                    ix += (codePoint >> UTRIE2_SHIFT_2) & UTRIE2_INDEX_2_MASK;
                    ix = this.index[ix];
                    ix = (ix << UTRIE2_INDEX_SHIFT) + (codePoint & UTRIE2_DATA_MASK);
                    return this.data[ix];
                }
                if (codePoint <= 0x10ffff) {
                    return this.data[this.highValueIndex];
                }
            }
            // Fall through.  The code point is outside of the legal range of 0..0x10ffff.
            return this.errorValue;
        };
        return Trie;
    }());

    /*
     * base64-arraybuffer 1.0.2 <https://github.com/niklasvh/base64-arraybuffer>
     * Copyright (c) 2022 Niklas von Hertzen <https://hertzen.com>
     * Released under MIT License
     */
    var chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
    // Use a lookup table to find the index.
    var lookup = typeof Uint8Array === 'undefined' ? [] : new Uint8Array(256);
    for (var i = 0; i < chars.length; i++) {
        lookup[chars.charCodeAt(i)] = i;
    }

    var Prepend = 1;
    var CR = 2;
    var LF = 3;
    var Control = 4;
    var Extend = 5;
    var SpacingMark = 7;
    var L = 8;
    var V = 9;
    var T = 10;
    var LV = 11;
    var LVT = 12;
    var ZWJ = 13;
    var Extended_Pictographic = 14;
    var RI = 15;
    var toCodePoints = function (str) {
        var codePoints = [];
        var i = 0;
        var length = str.length;
        while (i < length) {
            var value = str.charCodeAt(i++);
            if (value >= 0xd800 && value <= 0xdbff && i < length) {
                var extra = str.charCodeAt(i++);
                if ((extra & 0xfc00) === 0xdc00) {
                    codePoints.push(((value & 0x3ff) << 10) + (extra & 0x3ff) + 0x10000);
                }
                else {
                    codePoints.push(value);
                    i--;
                }
            }
            else {
                codePoints.push(value);
            }
        }
        return codePoints;
    };
    var fromCodePoint = function () {
        var codePoints = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            codePoints[_i] = arguments[_i];
        }
        if (String.fromCodePoint) {
            return String.fromCodePoint.apply(String, codePoints);
        }
        var length = codePoints.length;
        if (!length) {
            return '';
        }
        var codeUnits = [];
        var index = -1;
        var result = '';
        while (++index < length) {
            var codePoint = codePoints[index];
            if (codePoint <= 0xffff) {
                codeUnits.push(codePoint);
            }
            else {
                codePoint -= 0x10000;
                codeUnits.push((codePoint >> 10) + 0xd800, (codePoint % 0x400) + 0xdc00);
            }
            if (index + 1 === length || codeUnits.length > 0x4000) {
                result += String.fromCharCode.apply(String, codeUnits);
                codeUnits.length = 0;
            }
        }
        return result;
    };
    var UnicodeTrie = createTrieFromBase64(base64);
    var BREAK_NOT_ALLOWED = '×';
    var BREAK_ALLOWED = '÷';
    var codePointToClass = function (codePoint) { return UnicodeTrie.get(codePoint); };
    var _graphemeBreakAtIndex = function (_codePoints, classTypes, index) {
        var prevIndex = index - 2;
        var prev = classTypes[prevIndex];
        var current = classTypes[index - 1];
        var next = classTypes[index];
        // GB3 Do not break between a CR and LF
        if (current === CR && next === LF) {
            return BREAK_NOT_ALLOWED;
        }
        // GB4 Otherwise, break before and after controls.
        if (current === CR || current === LF || current === Control) {
            return BREAK_ALLOWED;
        }
        // GB5
        if (next === CR || next === LF || next === Control) {
            return BREAK_ALLOWED;
        }
        // Do not break Hangul syllable sequences.
        // GB6
        if (current === L && [L, V, LV, LVT].indexOf(next) !== -1) {
            return BREAK_NOT_ALLOWED;
        }
        // GB7
        if ((current === LV || current === V) && (next === V || next === T)) {
            return BREAK_NOT_ALLOWED;
        }
        // GB8
        if ((current === LVT || current === T) && next === T) {
            return BREAK_NOT_ALLOWED;
        }
        // GB9 Do not break before extending characters or ZWJ.
        if (next === ZWJ || next === Extend) {
            return BREAK_NOT_ALLOWED;
        }
        // Do not break before SpacingMarks, or after Prepend characters.
        // GB9a
        if (next === SpacingMark) {
            return BREAK_NOT_ALLOWED;
        }
        // GB9a
        if (current === Prepend) {
            return BREAK_NOT_ALLOWED;
        }
        // GB11 Do not break within emoji modifier sequences or emoji zwj sequences.
        if (current === ZWJ && next === Extended_Pictographic) {
            while (prev === Extend) {
                prev = classTypes[--prevIndex];
            }
            if (prev === Extended_Pictographic) {
                return BREAK_NOT_ALLOWED;
            }
        }
        // GB12 Do not break within emoji flag sequences.
        // That is, do not break between regional indicator (RI) symbols
        // if there is an odd number of RI characters before the break point.
        if (current === RI && next === RI) {
            var countRI = 0;
            while (prev === RI) {
                countRI++;
                prev = classTypes[--prevIndex];
            }
            if (countRI % 2 === 0) {
                return BREAK_NOT_ALLOWED;
            }
        }
        return BREAK_ALLOWED;
    };
    var GraphemeBreaker = function (str) {
        var codePoints = toCodePoints(str);
        var length = codePoints.length;
        var index = 0;
        var lastEnd = 0;
        var classTypes = codePoints.map(codePointToClass);
        return {
            next: function () {
                if (index >= length) {
                    return { done: true, value: null };
                }
                var graphemeBreak = BREAK_NOT_ALLOWED;
                while (index < length &&
                    (graphemeBreak = _graphemeBreakAtIndex(codePoints, classTypes, ++index)) === BREAK_NOT_ALLOWED) { }
                if (graphemeBreak !== BREAK_NOT_ALLOWED || index === length) {
                    var value = fromCodePoint.apply(null, codePoints.slice(lastEnd, index));
                    lastEnd = index;
                    return { value: value, done: false };
                }
                return { done: true, value: null };
            },
        };
    };
    var splitGraphemes = function (str) {
        var breaker = GraphemeBreaker(str);
        var graphemes = [];
        var bk;
        while (!(bk = breaker.next()).done) {
            if (bk.value) {
                graphemes.push(bk.value.slice());
            }
        }
        return graphemes;
    };

    var testRangeBounds = function (document) {
        var TEST_HEIGHT = 123;
        if (document.createRange) {
            var range = document.createRange();
            if (range.getBoundingClientRect) {
                var testElement = document.createElement('boundtest');
                testElement.style.height = TEST_HEIGHT + "px";
                testElement.style.display = 'block';
                document.body.appendChild(testElement);
                range.selectNode(testElement);
                var rangeBounds = range.getBoundingClientRect();
                var rangeHeight = Math.round(rangeBounds.height);
                document.body.removeChild(testElement);
                if (rangeHeight === TEST_HEIGHT) {
                    return true;
                }
            }
        }
        return false;
    };
    var testIOSLineBreak = function (document) {
        var testElement = document.createElement('boundtest');
        testElement.style.width = '50px';
        testElement.style.display = 'block';
        testElement.style.fontSize = '12px';
        testElement.style.letterSpacing = '0px';
        testElement.style.wordSpacing = '0px';
        document.body.appendChild(testElement);
        var range = document.createRange();
        testElement.innerHTML = typeof ''.repeat === 'function' ? '&#128104;'.repeat(10) : '';
        var node = testElement.firstChild;
        var textList = toCodePoints$1(node.data).map(function (i) { return fromCodePoint$1(i); });
        var offset = 0;
        var prev = {};
        // ios 13 does not handle range getBoundingClientRect line changes correctly #2177
        var supports = textList.every(function (text, i) {
            range.setStart(node, offset);
            range.setEnd(node, offset + text.length);
            var rect = range.getBoundingClientRect();
            offset += text.length;
            var boundAhead = rect.x > prev.x || rect.y > prev.y;
            prev = rect;
            if (i === 0) {
                return true;
            }
            return boundAhead;
        });
        document.body.removeChild(testElement);
        return supports;
    };
    var testCORS = function () { return typeof new Image().crossOrigin !== 'undefined'; };
    var testResponseType = function () { return typeof new XMLHttpRequest().responseType === 'string'; };
    var testSVG = function (document) {
        var img = new Image();
        var canvas = document.createElement('canvas');
        var ctx = canvas.getContext('2d');
        if (!ctx) {
            return false;
        }
        img.src = "data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg'></svg>";
        try {
            ctx.drawImage(img, 0, 0);
            canvas.toDataURL();
        }
        catch (e) {
            return false;
        }
        return true;
    };
    var isGreenPixel = function (data) {
        return data[0] === 0 && data[1] === 255 && data[2] === 0 && data[3] === 255;
    };
    var testForeignObject = function (document) {
        var canvas = document.createElement('canvas');
        var size = 100;
        canvas.width = size;
        canvas.height = size;
        var ctx = canvas.getContext('2d');
        if (!ctx) {
            return Promise.reject(false);
        }
        ctx.fillStyle = 'rgb(0, 255, 0)';
        ctx.fillRect(0, 0, size, size);
        var img = new Image();
        var greenImageSrc = canvas.toDataURL();
        img.src = greenImageSrc;
        var svg = createForeignObjectSVG(size, size, 0, 0, img);
        ctx.fillStyle = 'red';
        ctx.fillRect(0, 0, size, size);
        return loadSerializedSVG$1(svg)
            .then(function (img) {
            ctx.drawImage(img, 0, 0);
            var data = ctx.getImageData(0, 0, size, size).data;
            ctx.fillStyle = 'red';
            ctx.fillRect(0, 0, size, size);
            var node = document.createElement('div');
            node.style.backgroundImage = "url(" + greenImageSrc + ")";
            node.style.height = size + "px";
            // Firefox 55 does not render inline <img /> tags
            return isGreenPixel(data)
                ? loadSerializedSVG$1(createForeignObjectSVG(size, size, 0, 0, node))
                : Promise.reject(false);
        })
            .then(function (img) {
            ctx.drawImage(img, 0, 0);
            // Edge does not render background-images
            return isGreenPixel(ctx.getImageData(0, 0, size, size).data);
        })
            .catch(function () { return false; });
    };
    var createForeignObjectSVG = function (width, height, x, y, node) {
        var xmlns = 'http://www.w3.org/2000/svg';
        var svg = document.createElementNS(xmlns, 'svg');
        var foreignObject = document.createElementNS(xmlns, 'foreignObject');
        svg.setAttributeNS(null, 'width', width.toString());
        svg.setAttributeNS(null, 'height', height.toString());
        foreignObject.setAttributeNS(null, 'width', '100%');
        foreignObject.setAttributeNS(null, 'height', '100%');
        foreignObject.setAttributeNS(null, 'x', x.toString());
        foreignObject.setAttributeNS(null, 'y', y.toString());
        foreignObject.setAttributeNS(null, 'externalResourcesRequired', 'true');
        svg.appendChild(foreignObject);
        foreignObject.appendChild(node);
        return svg;
    };
    var loadSerializedSVG$1 = function (svg) {
        return new Promise(function (resolve, reject) {
            var img = new Image();
            img.onload = function () { return resolve(img); };
            img.onerror = reject;
            img.src = "data:image/svg+xml;charset=utf-8," + encodeURIComponent(new XMLSerializer().serializeToString(svg));
        });
    };
    var FEATURES = {
        get SUPPORT_RANGE_BOUNDS() {
            var value = testRangeBounds(document);
            Object.defineProperty(FEATURES, 'SUPPORT_RANGE_BOUNDS', { value: value });
            return value;
        },
        get SUPPORT_WORD_BREAKING() {
            var value = FEATURES.SUPPORT_RANGE_BOUNDS && testIOSLineBreak(document);
            Object.defineProperty(FEATURES, 'SUPPORT_WORD_BREAKING', { value: value });
            return value;
        },
        get SUPPORT_SVG_DRAWING() {
            var value = testSVG(document);
            Object.defineProperty(FEATURES, 'SUPPORT_SVG_DRAWING', { value: value });
            return value;
        },
        get SUPPORT_FOREIGNOBJECT_DRAWING() {
            var value = typeof Array.from === 'function' && typeof window.fetch === 'function'
                ? testForeignObject(document)
                : Promise.resolve(false);
            Object.defineProperty(FEATURES, 'SUPPORT_FOREIGNOBJECT_DRAWING', { value: value });
            return value;
        },
        get SUPPORT_CORS_IMAGES() {
            var value = testCORS();
            Object.defineProperty(FEATURES, 'SUPPORT_CORS_IMAGES', { value: value });
            return value;
        },
        get SUPPORT_RESPONSE_TYPE() {
            var value = testResponseType();
            Object.defineProperty(FEATURES, 'SUPPORT_RESPONSE_TYPE', { value: value });
            return value;
        },
        get SUPPORT_CORS_XHR() {
            var value = 'withCredentials' in new XMLHttpRequest();
            Object.defineProperty(FEATURES, 'SUPPORT_CORS_XHR', { value: value });
            return value;
        },
        get SUPPORT_NATIVE_TEXT_SEGMENTATION() {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            var value = !!(typeof Intl !== 'undefined' && Intl.Segmenter);
            Object.defineProperty(FEATURES, 'SUPPORT_NATIVE_TEXT_SEGMENTATION', { value: value });
            return value;
        }
    };

    var TextBounds = /** @class */ (function () {
        function TextBounds(text, bounds) {
            this.text = text;
            this.bounds = bounds;
        }
        return TextBounds;
    }());
    var parseTextBounds = function (context, value, styles, node) {
        var textList = breakText(value, styles);
        var textBounds = [];
        var offset = 0;
        textList.forEach(function (text) {
            if (styles.textDecorationLine.length || text.trim().length > 0) {
                if (FEATURES.SUPPORT_RANGE_BOUNDS) {
                    var clientRects = createRange(node, offset, text.length).getClientRects();
                    if (clientRects.length > 1) {
                        var subSegments = segmentGraphemes(text);
                        var subOffset_1 = 0;
                        subSegments.forEach(function (subSegment) {
                            textBounds.push(new TextBounds(subSegment, Bounds.fromDOMRectList(context, createRange(node, subOffset_1 + offset, subSegment.length).getClientRects())));
                            subOffset_1 += subSegment.length;
                        });
                    }
                    else {
                        textBounds.push(new TextBounds(text, Bounds.fromDOMRectList(context, clientRects)));
                    }
                }
                else {
                    var replacementNode = node.splitText(text.length);
                    textBounds.push(new TextBounds(text, getWrapperBounds(context, node)));
                    node = replacementNode;
                }
            }
            else if (!FEATURES.SUPPORT_RANGE_BOUNDS) {
                node = node.splitText(text.length);
            }
            offset += text.length;
        });
        return textBounds;
    };
    var getWrapperBounds = function (context, node) {
        var ownerDocument = node.ownerDocument;
        if (ownerDocument) {
            var wrapper = ownerDocument.createElement('html2canvaswrapper');
            wrapper.appendChild(node.cloneNode(true));
            var parentNode = node.parentNode;
            if (parentNode) {
                parentNode.replaceChild(wrapper, node);
                var bounds = parseBounds(context, wrapper);
                if (wrapper.firstChild) {
                    parentNode.replaceChild(wrapper.firstChild, wrapper);
                }
                return bounds;
            }
        }
        return Bounds.EMPTY;
    };
    var createRange = function (node, offset, length) {
        var ownerDocument = node.ownerDocument;
        if (!ownerDocument) {
            throw new Error('Node has no owner document');
        }
        var range = ownerDocument.createRange();
        range.setStart(node, offset);
        range.setEnd(node, offset + length);
        return range;
    };
    var segmentGraphemes = function (value) {
        if (FEATURES.SUPPORT_NATIVE_TEXT_SEGMENTATION) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            var segmenter = new Intl.Segmenter(void 0, { granularity: 'grapheme' });
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            return Array.from(segmenter.segment(value)).map(function (segment) { return segment.segment; });
        }
        return splitGraphemes(value);
    };
    var segmentWords = function (value, styles) {
        if (FEATURES.SUPPORT_NATIVE_TEXT_SEGMENTATION) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            var segmenter = new Intl.Segmenter(void 0, {
                granularity: 'word'
            });
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            return Array.from(segmenter.segment(value)).map(function (segment) { return segment.segment; });
        }
        return breakWords(value, styles);
    };
    var breakText = function (value, styles) {
        return styles.letterSpacing !== 0 ? segmentGraphemes(value) : segmentWords(value, styles);
    };
    // https://drafts.csswg.org/css-text/#word-separator
    var wordSeparators = [0x0020, 0x00a0, 0x1361, 0x10100, 0x10101, 0x1039, 0x1091];
    var breakWords = function (str, styles) {
        var breaker = LineBreaker(str, {
            lineBreak: styles.lineBreak,
            wordBreak: styles.overflowWrap === "break-word" /* BREAK_WORD */ ? 'break-word' : styles.wordBreak
        });
        var words = [];
        var bk;
        var _loop_1 = function () {
            if (bk.value) {
                var value = bk.value.slice();
                var codePoints = toCodePoints$1(value);
                var word_1 = '';
                codePoints.forEach(function (codePoint) {
                    if (wordSeparators.indexOf(codePoint) === -1) {
                        word_1 += fromCodePoint$1(codePoint);
                    }
                    else {
                        if (word_1.length) {
                            words.push(word_1);
                        }
                        words.push(fromCodePoint$1(codePoint));
                        word_1 = '';
                    }
                });
                if (word_1.length) {
                    words.push(word_1);
                }
            }
        };
        while (!(bk = breaker.next()).done) {
            _loop_1();
        }
        return words;
    };

    var TextContainer = /** @class */ (function () {
        function isValidWritingMode(mode) {
            if (!mode) {
                return false;
            }
            switch (mode) {
                case 'none':
                case 'unset':
                case 'inherit': 
                case 'initial':
                    return false;
                default:
                    return true;
            }
            if ('unset' == mode) {
                return false;
            }
            if ('none' == mode) {
                return false;
            }
            if ('inherit' == mode) {
                return false;
            }
        }
        function TextContainer(context, node, styles) {
            this.text = transform(node.data, styles.textTransform);
            if (isValidWritingMode(node.parentElement.style.writingMode)) {
                styles.writingMode = node.parentElement.style.writingMode;
            } 
            else if (isValidWritingMode(node.parentElement.parentElement.style.writingMode)) {
                styles.writingMode = node.parentElement.parentElement.style.writingMode;
            }
            this.textBounds = parseTextBounds(context, this.text, styles, node);
            if(this.textBounds && this.textBounds.length>0 && (styles.writingMode == "vertical-rl" || styles.writingMode == "vertical-lr")){
                for (var i = 0; i < this.textBounds.length; i++) {
                    var bound = this.textBounds[i];
                    if(bound && bound.bounds){
                        bound.bounds.left += 5;
                    }
                }
            }else{
                for (var i = 0; i < this.textBounds.length; i++) {
                    var bound = this.textBounds[i];
                    if(bound && bound.bounds){
                        bound.bounds.top += 5;
                    }
                }
            }
        }
        return TextContainer;
    }());
    var transform = function (text, transform) {
        switch (transform) {
            case 1 /* LOWERCASE */:
                return text.toLowerCase();
            case 3 /* CAPITALIZE */:
                return text.replace(CAPITALIZE, capitalize);
            case 2 /* UPPERCASE */:
                return text.toUpperCase();
            default:
                return text;
        }
    };
    var CAPITALIZE = /(^|\s|:|-|\(|\))([a-z])/g;
    var capitalize = function (m, p1, p2) {
        if (m.length > 0) {
            return p1 + p2.toUpperCase();
        }
        return m;
    };

    var ImageElementContainer = /** @class */ (function (_super) {
        __extends(ImageElementContainer, _super);
        function ImageElementContainer(context, img) {
            var _this = _super.call(this, context, img) || this;
            _this.src = img.currentSrc || img.src;
            _this.intrinsicWidth = img.naturalWidth;
            _this.intrinsicHeight = img.naturalHeight;
            _this.context.cache.addImage(_this.src);
            return _this;
        }
        return ImageElementContainer;
    }(ElementContainer));

    var CanvasElementContainer = /** @class */ (function (_super) {
        __extends(CanvasElementContainer, _super);
        function CanvasElementContainer(context, canvas) {
            var _this = _super.call(this, context, canvas) || this;
            _this.canvas = canvas;
            _this.intrinsicWidth = canvas.width;
            _this.intrinsicHeight = canvas.height;
            return _this;
        }
        return CanvasElementContainer;
    }(ElementContainer));

    var SVGElementContainer = /** @class */ (function (_super) {
        __extends(SVGElementContainer, _super);
        function SVGElementContainer(context, img) {
            var _this = _super.call(this, context, img) || this;
            var s = new XMLSerializer();
            var bounds = parseBounds(context, img);
            img.setAttribute('width', bounds.width + "px");
            img.setAttribute('height', bounds.height + "px");
            _this.svg = "data:image/svg+xml," + encodeURIComponent(s.serializeToString(img));
            _this.intrinsicWidth = img.width.baseVal.value;
            _this.intrinsicHeight = img.height.baseVal.value;
            _this.context.cache.addImage(_this.svg);
            return _this;
        }
        return SVGElementContainer;
    }(ElementContainer));

    var LIElementContainer = /** @class */ (function (_super) {
        __extends(LIElementContainer, _super);
        function LIElementContainer(context, element) {
            var _this = _super.call(this, context, element) || this;
            _this.value = element.value;
            return _this;
        }
        return LIElementContainer;
    }(ElementContainer));

    var OLElementContainer = /** @class */ (function (_super) {
        __extends(OLElementContainer, _super);
        function OLElementContainer(context, element) {
            var _this = _super.call(this, context, element) || this;
            _this.start = element.start;
            _this.reversed = typeof element.reversed === 'boolean' && element.reversed === true;
            return _this;
        }
        return OLElementContainer;
    }(ElementContainer));

    var CHECKBOX_BORDER_RADIUS = [
        {
            type: 15 /* DIMENSION_TOKEN */,
            flags: 0,
            unit: 'px',
            number: 3
        }
    ];
    var RADIO_BORDER_RADIUS = [
        {
            type: 16 /* PERCENTAGE_TOKEN */,
            flags: 0,
            number: 50
        }
    ];
    var reformatInputBounds = function (bounds) {
        if (bounds.width > bounds.height) {
            return new Bounds(bounds.left + (bounds.width - bounds.height) / 2, bounds.top, bounds.height, bounds.height);
        }
        else if (bounds.width < bounds.height) {
            return new Bounds(bounds.left, bounds.top + (bounds.height - bounds.width) / 2, bounds.width, bounds.width);
        }
        return bounds;
    };
    var getInputValue = function (node) {
        var value = node.type === PASSWORD ? new Array(node.value.length + 1).join('\u2022') : node.value;
        return value.length === 0 ? node.placeholder || '' : value;
    };
    var CHECKBOX = 'checkbox';
    var RADIO = 'radio';
    var PASSWORD = 'password';
    var INPUT_COLOR = 0x2a2a2aff;
    var InputElementContainer = /** @class */ (function (_super) {
        __extends(InputElementContainer, _super);
        function InputElementContainer(context, input) {
            var _this = _super.call(this, context, input) || this;
            _this.type = input.type.toLowerCase();
            _this.checked = input.checked;
            _this.value = getInputValue(input);
            if (_this.type === CHECKBOX || _this.type === RADIO) {
                _this.styles.backgroundColor = 0xdededeff;
                _this.styles.borderTopColor =
                    _this.styles.borderRightColor =
                        _this.styles.borderBottomColor =
                            _this.styles.borderLeftColor =
                                0xa5a5a5ff;
                _this.styles.borderTopWidth =
                    _this.styles.borderRightWidth =
                        _this.styles.borderBottomWidth =
                            _this.styles.borderLeftWidth =
                                1;
                _this.styles.borderTopStyle =
                    _this.styles.borderRightStyle =
                        _this.styles.borderBottomStyle =
                            _this.styles.borderLeftStyle =
                                1 /* SOLID */;
                _this.styles.backgroundClip = [0 /* BORDER_BOX */];
                _this.styles.backgroundOrigin = [0 /* BORDER_BOX */];
                _this.bounds = reformatInputBounds(_this.bounds);
            }
            switch (_this.type) {
                case CHECKBOX:
                    _this.styles.borderTopRightRadius =
                        _this.styles.borderTopLeftRadius =
                            _this.styles.borderBottomRightRadius =
                                _this.styles.borderBottomLeftRadius =
                                    CHECKBOX_BORDER_RADIUS;
                    break;
                case RADIO:
                    _this.styles.borderTopRightRadius =
                        _this.styles.borderTopLeftRadius =
                            _this.styles.borderBottomRightRadius =
                                _this.styles.borderBottomLeftRadius =
                                    RADIO_BORDER_RADIUS;
                    break;
            }
            return _this;
        }
        return InputElementContainer;
    }(ElementContainer));

    var SelectElementContainer = /** @class */ (function (_super) {
        __extends(SelectElementContainer, _super);
        function SelectElementContainer(context, element) {
            var _this = _super.call(this, context, element) || this;
            var option = element.options[element.selectedIndex || 0];
            _this.value = option ? option.text || '' : '';
            return _this;
        }
        return SelectElementContainer;
    }(ElementContainer));

    var TextareaElementContainer = /** @class */ (function (_super) {
        __extends(TextareaElementContainer, _super);
        function TextareaElementContainer(context, element) {
            var _this = _super.call(this, context, element) || this;
            _this.value = element.value;
            return _this;
        }
        return TextareaElementContainer;
    }(ElementContainer));

    var IFrameElementContainer = /** @class */ (function (_super) {
        __extends(IFrameElementContainer, _super);
        function IFrameElementContainer(context, iframe) {
            var _this = _super.call(this, context, iframe) || this;
            _this.src = iframe.src;
            _this.width = parseInt(iframe.width, 10) || 0;
            _this.height = parseInt(iframe.height, 10) || 0;
            _this.backgroundColor = _this.styles.backgroundColor;
            try {
                if (iframe.contentWindow &&
                    iframe.contentWindow.document &&
                    iframe.contentWindow.document.documentElement) {
                    _this.tree = parseTree(context, iframe.contentWindow.document.documentElement);
                    // http://www.w3.org/TR/css3-background/#special-backgrounds
                    var documentBackgroundColor = iframe.contentWindow.document.documentElement
                        ? parseColor(context, getComputedStyle(iframe.contentWindow.document.documentElement).backgroundColor)
                        : COLORS.TRANSPARENT;
                    var bodyBackgroundColor = iframe.contentWindow.document.body
                        ? parseColor(context, getComputedStyle(iframe.contentWindow.document.body).backgroundColor)
                        : COLORS.TRANSPARENT;
                    _this.backgroundColor = isTransparent(documentBackgroundColor)
                        ? isTransparent(bodyBackgroundColor)
                            ? _this.styles.backgroundColor
                            : bodyBackgroundColor
                        : documentBackgroundColor;
                }
            }
            catch (e) { }
            return _this;
        }
        return IFrameElementContainer;
    }(ElementContainer));

    var LIST_OWNERS = ['OL', 'UL', 'MENU'];
    var parseNodeTree = function (context, node, parent, root) {
        for (var childNode = node.firstChild, nextNode = void 0; childNode; childNode = nextNode) {
            nextNode = childNode.nextSibling;
            if (isTextNode(childNode) && childNode.data.trim().length > 0) {
                parent.textNodes.push(new TextContainer(context, childNode, parent.styles));
            }
            else if (isElementNode(childNode)) {
                if (isSlotElement(childNode) && childNode.assignedNodes) {
                    childNode.assignedNodes().forEach(function (childNode) { return parseNodeTree(context, childNode, parent, root); });
                }
                else {
                    var container = createContainer(context, childNode);
                    if (container.styles.isVisible()) {
                        if (createsRealStackingContext(childNode, container, root)) {
                            container.flags |= 4 /* CREATES_REAL_STACKING_CONTEXT */;
                        }
                        else if (createsStackingContext(container.styles)) {
                            container.flags |= 2 /* CREATES_STACKING_CONTEXT */;
                        }
                        if (LIST_OWNERS.indexOf(childNode.tagName) !== -1) {
                            container.flags |= 8 /* IS_LIST_OWNER */;
                        }
                        parent.elements.push(container);
                        childNode.slot;
                        if (childNode.shadowRoot) {
                            parseNodeTree(context, childNode.shadowRoot, container, root);
                        }
                        else if (!isTextareaElement(childNode) &&
                            !isSVGElement(childNode) &&
                            !isSelectElement(childNode)) {
                            parseNodeTree(context, childNode, container, root);
                        }
                    }
                }
            }
        }
    };
    var createContainer = function (context, element) {
        if (isImageElement(element)) {
            return new ImageElementContainer(context, element);
        }
        if (isCanvasElement(element)) {
            return new CanvasElementContainer(context, element);
        }
        if (isSVGElement(element)) {
            return new SVGElementContainer(context, element);
        }
        if (isLIElement(element)) {
            return new LIElementContainer(context, element);
        }
        if (isOLElement(element)) {
            return new OLElementContainer(context, element);
        }
        if (isInputElement(element)) {
            return new InputElementContainer(context, element);
        }
        if (isSelectElement(element)) {
            return new SelectElementContainer(context, element);
        }
        if (isTextareaElement(element)) {
            return new TextareaElementContainer(context, element);
        }
        if (isIFrameElement(element)) {
            return new IFrameElementContainer(context, element);
        }
        return new ElementContainer(context, element);
    };
    var parseTree = function (context, element) {
        var container = createContainer(context, element);
        container.flags |= 4 /* CREATES_REAL_STACKING_CONTEXT */;
        parseNodeTree(context, element, container, container);
        return container;
    };
    var createsRealStackingContext = function (node, container, root) {
        return (container.styles.isPositionedWithZIndex() ||
            container.styles.opacity < 1 ||
            container.styles.isTransformed() ||
            (isBodyElement(node) && root.styles.isTransparent()));
    };
    var createsStackingContext = function (styles) { return styles.isPositioned() || styles.isFloating(); };
    var isTextNode = function (node) { return node.nodeType === Node.TEXT_NODE; };
    var isElementNode = function (node) { return node.nodeType === Node.ELEMENT_NODE; };
    var isHTMLElementNode = function (node) {
        return isElementNode(node) && typeof node.style !== 'undefined' && !isSVGElementNode(node);
    };
    var isSVGElementNode = function (element) {
        return typeof element.className === 'object';
    };
    var isLIElement = function (node) { return node.tagName === 'LI'; };
    var isOLElement = function (node) { return node.tagName === 'OL'; };
    var isInputElement = function (node) { return node.tagName === 'INPUT'; };
    var isHTMLElement = function (node) { return node.tagName === 'HTML'; };
    var isSVGElement = function (node) { return node.tagName === 'svg'; };
    var isBodyElement = function (node) { return node.tagName === 'BODY'; };
    var isCanvasElement = function (node) { return node.tagName === 'CANVAS'; };
    var isVideoElement = function (node) { return node.tagName === 'VIDEO'; };
    var isImageElement = function (node) { return node.tagName === 'IMG'; };
    var isIFrameElement = function (node) { return node.tagName === 'IFRAME'; };
    var isStyleElement = function (node) { return node.tagName === 'STYLE'; };
    var isScriptElement = function (node) { return node.tagName === 'SCRIPT'; };
    var isTextareaElement = function (node) { return node.tagName === 'TEXTAREA'; };
    var isSelectElement = function (node) { return node.tagName === 'SELECT'; };
    var isSlotElement = function (node) { return node.tagName === 'SLOT'; };
    // https://html.spec.whatwg.org/multipage/custom-elements.html#valid-custom-element-name
    var isCustomElement = function (node) { return node.tagName.indexOf('-') > 0; };

    var CounterState = /** @class */ (function () {
        function CounterState() {
            this.counters = {};
        }
        CounterState.prototype.getCounterValue = function (name) {
            var counter = this.counters[name];
            if (counter && counter.length) {
                return counter[counter.length - 1];
            }
            return 1;
        };
        CounterState.prototype.getCounterValues = function (name) {
            var counter = this.counters[name];
            return counter ? counter : [];
        };
        CounterState.prototype.pop = function (counters) {
            var _this = this;
            counters.forEach(function (counter) { return _this.counters[counter].pop(); });
        };
        CounterState.prototype.parse = function (style) {
            var _this = this;
            var counterIncrement = style.counterIncrement;
            var counterReset = style.counterReset;
            var canReset = true;
            if (counterIncrement !== null) {
                counterIncrement.forEach(function (entry) {
                    var counter = _this.counters[entry.counter];
                    if (counter && entry.increment !== 0) {
                        canReset = false;
                        if (!counter.length) {
                            counter.push(1);
                        }
                        counter[Math.max(0, counter.length - 1)] += entry.increment;
                    }
                });
            }
            var counterNames = [];
            if (canReset) {
                counterReset.forEach(function (entry) {
                    var counter = _this.counters[entry.counter];
                    counterNames.push(entry.counter);
                    if (!counter) {
                        counter = _this.counters[entry.counter] = [];
                    }
                    counter.push(entry.reset);
                });
            }
            return counterNames;
        };
        return CounterState;
    }());
    var ROMAN_UPPER = {
        integers: [1000, 900, 500, 400, 100, 90, 50, 40, 10, 9, 5, 4, 1],
        values: ['M', 'CM', 'D', 'CD', 'C', 'XC', 'L', 'XL', 'X', 'IX', 'V', 'IV', 'I']
    };
    var ARMENIAN = {
        integers: [
            9000, 8000, 7000, 6000, 5000, 4000, 3000, 2000, 1000, 900, 800, 700, 600, 500, 400, 300, 200, 100, 90, 80, 70,
            60, 50, 40, 30, 20, 10, 9, 8, 7, 6, 5, 4, 3, 2, 1
        ],
        values: [
            'Ք',
            'Փ',
            'Ւ',
            'Ց',
            'Ր',
            'Տ',
            'Վ',
            'Ս',
            'Ռ',
            'Ջ',
            'Պ',
            'Չ',
            'Ո',
            'Շ',
            'Ն',
            'Յ',
            'Մ',
            'Ճ',
            'Ղ',
            'Ձ',
            'Հ',
            'Կ',
            'Ծ',
            'Խ',
            'Լ',
            'Ի',
            'Ժ',
            'Թ',
            'Ը',
            'Է',
            'Զ',
            'Ե',
            'Դ',
            'Գ',
            'Բ',
            'Ա'
        ]
    };
    var HEBREW = {
        integers: [
            10000, 9000, 8000, 7000, 6000, 5000, 4000, 3000, 2000, 1000, 400, 300, 200, 100, 90, 80, 70, 60, 50, 40, 30, 20,
            19, 18, 17, 16, 15, 10, 9, 8, 7, 6, 5, 4, 3, 2, 1
        ],
        values: [
            'י׳',
            'ט׳',
            'ח׳',
            'ז׳',
            'ו׳',
            'ה׳',
            'ד׳',
            'ג׳',
            'ב׳',
            'א׳',
            'ת',
            'ש',
            'ר',
            'ק',
            'צ',
            'פ',
            'ע',
            'ס',
            'נ',
            'מ',
            'ל',
            'כ',
            'יט',
            'יח',
            'יז',
            'טז',
            'טו',
            'י',
            'ט',
            'ח',
            'ז',
            'ו',
            'ה',
            'ד',
            'ג',
            'ב',
            'א'
        ]
    };
    var GEORGIAN = {
        integers: [
            10000, 9000, 8000, 7000, 6000, 5000, 4000, 3000, 2000, 1000, 900, 800, 700, 600, 500, 400, 300, 200, 100, 90,
            80, 70, 60, 50, 40, 30, 20, 10, 9, 8, 7, 6, 5, 4, 3, 2, 1
        ],
        values: [
            'ჵ',
            'ჰ',
            'ჯ',
            'ჴ',
            'ხ',
            'ჭ',
            'წ',
            'ძ',
            'ც',
            'ჩ',
            'შ',
            'ყ',
            'ღ',
            'ქ',
            'ფ',
            'ჳ',
            'ტ',
            'ს',
            'რ',
            'ჟ',
            'პ',
            'ო',
            'ჲ',
            'ნ',
            'მ',
            'ლ',
            'კ',
            'ი',
            'თ',
            'ჱ',
            'ზ',
            'ვ',
            'ე',
            'დ',
            'გ',
            'ბ',
            'ა'
        ]
    };
    var createAdditiveCounter = function (value, min, max, symbols, fallback, suffix) {
        if (value < min || value > max) {
            return createCounterText(value, fallback, suffix.length > 0);
        }
        return (symbols.integers.reduce(function (string, integer, index) {
            while (value >= integer) {
                value -= integer;
                string += symbols.values[index];
            }
            return string;
        }, '') + suffix);
    };
    var createCounterStyleWithSymbolResolver = function (value, codePointRangeLength, isNumeric, resolver) {
        var string = '';
        do {
            if (!isNumeric) {
                value--;
            }
            string = resolver(value) + string;
            value /= codePointRangeLength;
        } while (value * codePointRangeLength >= codePointRangeLength);
        return string;
    };
    var createCounterStyleFromRange = function (value, codePointRangeStart, codePointRangeEnd, isNumeric, suffix) {
        var codePointRangeLength = codePointRangeEnd - codePointRangeStart + 1;
        return ((value < 0 ? '-' : '') +
            (createCounterStyleWithSymbolResolver(Math.abs(value), codePointRangeLength, isNumeric, function (codePoint) {
                return fromCodePoint$1(Math.floor(codePoint % codePointRangeLength) + codePointRangeStart);
            }) +
                suffix));
    };
    var createCounterStyleFromSymbols = function (value, symbols, suffix) {
        if (suffix === void 0) { suffix = '. '; }
        var codePointRangeLength = symbols.length;
        return (createCounterStyleWithSymbolResolver(Math.abs(value), codePointRangeLength, false, function (codePoint) { return symbols[Math.floor(codePoint % codePointRangeLength)]; }) + suffix);
    };
    var CJK_ZEROS = 1 << 0;
    var CJK_TEN_COEFFICIENTS = 1 << 1;
    var CJK_TEN_HIGH_COEFFICIENTS = 1 << 2;
    var CJK_HUNDRED_COEFFICIENTS = 1 << 3;
    var createCJKCounter = function (value, numbers, multipliers, negativeSign, suffix, flags) {
        if (value < -9999 || value > 9999) {
            return createCounterText(value, 4 /* CJK_DECIMAL */, suffix.length > 0);
        }
        var tmp = Math.abs(value);
        var string = suffix;
        if (tmp === 0) {
            return numbers[0] + string;
        }
        for (var digit = 0; tmp > 0 && digit <= 4; digit++) {
            var coefficient = tmp % 10;
            if (coefficient === 0 && contains(flags, CJK_ZEROS) && string !== '') {
                string = numbers[coefficient] + string;
            }
            else if (coefficient > 1 ||
                (coefficient === 1 && digit === 0) ||
                (coefficient === 1 && digit === 1 && contains(flags, CJK_TEN_COEFFICIENTS)) ||
                (coefficient === 1 && digit === 1 && contains(flags, CJK_TEN_HIGH_COEFFICIENTS) && value > 100) ||
                (coefficient === 1 && digit > 1 && contains(flags, CJK_HUNDRED_COEFFICIENTS))) {
                string = numbers[coefficient] + (digit > 0 ? multipliers[digit - 1] : '') + string;
            }
            else if (coefficient === 1 && digit > 0) {
                string = multipliers[digit - 1] + string;
            }
            tmp = Math.floor(tmp / 10);
        }
        return (value < 0 ? negativeSign : '') + string;
    };
    var CHINESE_INFORMAL_MULTIPLIERS = '十百千萬';
    var CHINESE_FORMAL_MULTIPLIERS = '拾佰仟萬';
    var JAPANESE_NEGATIVE = 'マイナス';
    var KOREAN_NEGATIVE = '마이너스';
    var createCounterText = function (value, type, appendSuffix) {
        var defaultSuffix = appendSuffix ? '. ' : '';
        var cjkSuffix = appendSuffix ? '、' : '';
        var koreanSuffix = appendSuffix ? ', ' : '';
        var spaceSuffix = appendSuffix ? ' ' : '';
        switch (type) {
            case 0 /* DISC */:
                return '•' + spaceSuffix;
            case 1 /* CIRCLE */:
                return '◦' + spaceSuffix;
            case 2 /* SQUARE */:
                return '◾' + spaceSuffix;
            case 5 /* DECIMAL_LEADING_ZERO */:
                var string = createCounterStyleFromRange(value, 48, 57, true, defaultSuffix);
                return string.length < 4 ? "0" + string : string;
            case 4 /* CJK_DECIMAL */:
                return createCounterStyleFromSymbols(value, '〇一二三四五六七八九', cjkSuffix);
            case 6 /* LOWER_ROMAN */:
                return createAdditiveCounter(value, 1, 3999, ROMAN_UPPER, 3 /* DECIMAL */, defaultSuffix).toLowerCase();
            case 7 /* UPPER_ROMAN */:
                return createAdditiveCounter(value, 1, 3999, ROMAN_UPPER, 3 /* DECIMAL */, defaultSuffix);
            case 8 /* LOWER_GREEK */:
                return createCounterStyleFromRange(value, 945, 969, false, defaultSuffix);
            case 9 /* LOWER_ALPHA */:
                return createCounterStyleFromRange(value, 97, 122, false, defaultSuffix);
            case 10 /* UPPER_ALPHA */:
                return createCounterStyleFromRange(value, 65, 90, false, defaultSuffix);
            case 11 /* ARABIC_INDIC */:
                return createCounterStyleFromRange(value, 1632, 1641, true, defaultSuffix);
            case 12 /* ARMENIAN */:
            case 49 /* UPPER_ARMENIAN */:
                return createAdditiveCounter(value, 1, 9999, ARMENIAN, 3 /* DECIMAL */, defaultSuffix);
            case 35 /* LOWER_ARMENIAN */:
                return createAdditiveCounter(value, 1, 9999, ARMENIAN, 3 /* DECIMAL */, defaultSuffix).toLowerCase();
            case 13 /* BENGALI */:
                return createCounterStyleFromRange(value, 2534, 2543, true, defaultSuffix);
            case 14 /* CAMBODIAN */:
            case 30 /* KHMER */:
                return createCounterStyleFromRange(value, 6112, 6121, true, defaultSuffix);
            case 15 /* CJK_EARTHLY_BRANCH */:
                return createCounterStyleFromSymbols(value, '子丑寅卯辰巳午未申酉戌亥', cjkSuffix);
            case 16 /* CJK_HEAVENLY_STEM */:
                return createCounterStyleFromSymbols(value, '甲乙丙丁戊己庚辛壬癸', cjkSuffix);
            case 17 /* CJK_IDEOGRAPHIC */:
            case 48 /* TRAD_CHINESE_INFORMAL */:
                return createCJKCounter(value, '零一二三四五六七八九', CHINESE_INFORMAL_MULTIPLIERS, '負', cjkSuffix, CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS | CJK_HUNDRED_COEFFICIENTS);
            case 47 /* TRAD_CHINESE_FORMAL */:
                return createCJKCounter(value, '零壹貳參肆伍陸柒捌玖', CHINESE_FORMAL_MULTIPLIERS, '負', cjkSuffix, CJK_ZEROS | CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS | CJK_HUNDRED_COEFFICIENTS);
            case 42 /* SIMP_CHINESE_INFORMAL */:
                return createCJKCounter(value, '零一二三四五六七八九', CHINESE_INFORMAL_MULTIPLIERS, '负', cjkSuffix, CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS | CJK_HUNDRED_COEFFICIENTS);
            case 41 /* SIMP_CHINESE_FORMAL */:
                return createCJKCounter(value, '零壹贰叁肆伍陆柒捌玖', CHINESE_FORMAL_MULTIPLIERS, '负', cjkSuffix, CJK_ZEROS | CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS | CJK_HUNDRED_COEFFICIENTS);
            case 26 /* JAPANESE_INFORMAL */:
                return createCJKCounter(value, '〇一二三四五六七八九', '十百千万', JAPANESE_NEGATIVE, cjkSuffix, 0);
            case 25 /* JAPANESE_FORMAL */:
                return createCJKCounter(value, '零壱弐参四伍六七八九', '拾百千万', JAPANESE_NEGATIVE, cjkSuffix, CJK_ZEROS | CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS);
            case 31 /* KOREAN_HANGUL_FORMAL */:
                return createCJKCounter(value, '영일이삼사오육칠팔구', '십백천만', KOREAN_NEGATIVE, koreanSuffix, CJK_ZEROS | CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS);
            case 33 /* KOREAN_HANJA_INFORMAL */:
                return createCJKCounter(value, '零一二三四五六七八九', '十百千萬', KOREAN_NEGATIVE, koreanSuffix, 0);
            case 32 /* KOREAN_HANJA_FORMAL */:
                return createCJKCounter(value, '零壹貳參四五六七八九', '拾百千', KOREAN_NEGATIVE, koreanSuffix, CJK_ZEROS | CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS);
            case 18 /* DEVANAGARI */:
                return createCounterStyleFromRange(value, 0x966, 0x96f, true, defaultSuffix);
            case 20 /* GEORGIAN */:
                return createAdditiveCounter(value, 1, 19999, GEORGIAN, 3 /* DECIMAL */, defaultSuffix);
            case 21 /* GUJARATI */:
                return createCounterStyleFromRange(value, 0xae6, 0xaef, true, defaultSuffix);
            case 22 /* GURMUKHI */:
                return createCounterStyleFromRange(value, 0xa66, 0xa6f, true, defaultSuffix);
            case 22 /* HEBREW */:
                return createAdditiveCounter(value, 1, 10999, HEBREW, 3 /* DECIMAL */, defaultSuffix);
            case 23 /* HIRAGANA */:
                return createCounterStyleFromSymbols(value, 'あいうえおかきくけこさしすせそたちつてとなにぬねのはひふへほまみむめもやゆよらりるれろわゐゑをん');
            case 24 /* HIRAGANA_IROHA */:
                return createCounterStyleFromSymbols(value, 'いろはにほへとちりぬるをわかよたれそつねならむうゐのおくやまけふこえてあさきゆめみしゑひもせす');
            case 27 /* KANNADA */:
                return createCounterStyleFromRange(value, 0xce6, 0xcef, true, defaultSuffix);
            case 28 /* KATAKANA */:
                return createCounterStyleFromSymbols(value, 'アイウエオカキクケコサシスセソタチツテトナニヌネノハヒフヘホマミムメモヤユヨラリルレロワヰヱヲン', cjkSuffix);
            case 29 /* KATAKANA_IROHA */:
                return createCounterStyleFromSymbols(value, 'イロハニホヘトチリヌルヲワカヨタレソツネナラムウヰノオクヤマケフコエテアサキユメミシヱヒモセス', cjkSuffix);
            case 34 /* LAO */:
                return createCounterStyleFromRange(value, 0xed0, 0xed9, true, defaultSuffix);
            case 37 /* MONGOLIAN */:
                return createCounterStyleFromRange(value, 0x1810, 0x1819, true, defaultSuffix);
            case 38 /* MYANMAR */:
                return createCounterStyleFromRange(value, 0x1040, 0x1049, true, defaultSuffix);
            case 39 /* ORIYA */:
                return createCounterStyleFromRange(value, 0xb66, 0xb6f, true, defaultSuffix);
            case 40 /* PERSIAN */:
                return createCounterStyleFromRange(value, 0x6f0, 0x6f9, true, defaultSuffix);
            case 43 /* TAMIL */:
                return createCounterStyleFromRange(value, 0xbe6, 0xbef, true, defaultSuffix);
            case 44 /* TELUGU */:
                return createCounterStyleFromRange(value, 0xc66, 0xc6f, true, defaultSuffix);
            case 45 /* THAI */:
                return createCounterStyleFromRange(value, 0xe50, 0xe59, true, defaultSuffix);
            case 46 /* TIBETAN */:
                return createCounterStyleFromRange(value, 0xf20, 0xf29, true, defaultSuffix);
            case 3 /* DECIMAL */:
            default:
                return createCounterStyleFromRange(value, 48, 57, true, defaultSuffix);
        }
    };

    var IGNORE_ATTRIBUTE = 'data-html2canvas-ignore';
    var DocumentCloner = /** @class */ (function () {
        function DocumentCloner(context, element, options) {
            this.context = context;
            this.options = options;
            this.scrolledElements = [];
            this.referenceElement = element;
            this.counters = new CounterState();
            this.quoteDepth = 0;
            if (!element.ownerDocument) {
                throw new Error('Cloned element does not have an owner document');
            }
            this.documentElement = this.cloneNode(element.ownerDocument.documentElement, false);
        }
        DocumentCloner.prototype.toIFrame = function (ownerDocument, windowSize) {
            var _this = this;
            var iframe = createIFrameContainer(ownerDocument, windowSize);
            if (!iframe.contentWindow) {
                return Promise.reject("Unable to find iframe window");
            }
            var scrollX = ownerDocument.defaultView.pageXOffset;
            var scrollY = ownerDocument.defaultView.pageYOffset;
            var cloneWindow = iframe.contentWindow;
            var documentClone = cloneWindow.document;
            /* Chrome doesn't detect relative background-images assigned in inline <style> sheets when fetched through getComputedStyle
             if window url is about:blank, we can assign the url to current by writing onto the document
             */
            var iframeLoad = iframeLoader(iframe).then(function () { return __awaiter(_this, void 0, void 0, function () {
                var onclone, referenceElement;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            this.scrolledElements.forEach(restoreNodeScroll);
                            if (cloneWindow) {
                                cloneWindow.scrollTo(windowSize.left, windowSize.top);
                                if (/(iPad|iPhone|iPod)/g.test(navigator.userAgent) &&
                                    (cloneWindow.scrollY !== windowSize.top || cloneWindow.scrollX !== windowSize.left)) {
                                    this.context.logger.warn('Unable to restore scroll position for cloned document');
                                    this.context.windowBounds = this.context.windowBounds.add(cloneWindow.scrollX - windowSize.left, cloneWindow.scrollY - windowSize.top, 0, 0);
                                }
                            }
                            onclone = this.options.onclone;
                            referenceElement = this.clonedReferenceElement;
                            if (typeof referenceElement === 'undefined') {
                                return [2 /*return*/, Promise.reject("Error finding the " + this.referenceElement.nodeName + " in the cloned document")];
                            }
                            if (!(documentClone.fonts && documentClone.fonts.ready)) return [3 /*break*/, 2];
                            return [4 /*yield*/, documentClone.fonts.ready];
                        case 1:
                            _a.sent();
                            _a.label = 2;
                        case 2:
                            if (!/(AppleWebKit)/g.test(navigator.userAgent)) return [3 /*break*/, 4];
                            return [4 /*yield*/, imagesReady(documentClone)];
                        case 3:
                            _a.sent();
                            _a.label = 4;
                        case 4:
                            if (typeof onclone === 'function') {
                                return [2 /*return*/, Promise.resolve()
                                        .then(function () { return onclone(documentClone, referenceElement); })
                                        .then(function () { return iframe; })];
                            }
                            return [2 /*return*/, iframe];
                    }
                });
            }); });
            documentClone.open();
            documentClone.write(serializeDoctype(document.doctype) + "<html></html>");
            // Chrome scrolls the parent document for some reason after the write to the cloned window???
            restoreOwnerScroll(this.referenceElement.ownerDocument, scrollX, scrollY);
            documentClone.replaceChild(documentClone.adoptNode(this.documentElement), documentClone.documentElement);
            documentClone.close();
            return iframeLoad;
        };
        DocumentCloner.prototype.createElementClone = function (node) {
            if (isDebugging(node, 2 /* CLONE */)) {
                debugger;
            }
            if (isCanvasElement(node)) {
                return this.createCanvasClone(node);
            }
            if (isVideoElement(node)) {
                return this.createVideoClone(node);
            }
            if (isStyleElement(node)) {
                return this.createStyleClone(node);
            }
            var clone = node.cloneNode(false);
            if (isImageElement(clone)) {
                if (isImageElement(node) && node.currentSrc && node.currentSrc !== node.src) {
                    clone.src = node.currentSrc;
                    clone.srcset = '';
                }
                if (clone.loading === 'lazy') {
                    clone.loading = 'eager';
                }
            }
            if (isCustomElement(clone)) {
                return this.createCustomElementClone(clone);
            }
            return clone;
        };
        DocumentCloner.prototype.createCustomElementClone = function (node) {
            var clone = document.createElement('html2canvascustomelement');
            copyCSSStyles(node.style, clone);
            return clone;
        };
        DocumentCloner.prototype.createStyleClone = function (node) {
            try {
                var sheet = node.sheet;
                if (sheet && sheet.cssRules) {
                    var css = [].slice.call(sheet.cssRules, 0).reduce(function (css, rule) {
                        if (rule && typeof rule.cssText === 'string') {
                            return css + rule.cssText;
                        }
                        return css;
                    }, '');
                    var style = node.cloneNode(false);
                    style.textContent = css;
                    return style;
                }
            }
            catch (e) {
                // accessing node.sheet.cssRules throws a DOMException
                this.context.logger.error('Unable to access cssRules property', e);
                if (e.name !== 'SecurityError') {
                    throw e;
                }
            }
            return node.cloneNode(false);
        };
        DocumentCloner.prototype.createCanvasClone = function (canvas) {
            var _a;
            if (this.options.inlineImages && canvas.ownerDocument) {
                var img = canvas.ownerDocument.createElement('img');
                try {
                    img.src = canvas.toDataURL();
                    return img;
                }
                catch (e) {
                    this.context.logger.info("Unable to inline canvas contents, canvas is tainted", canvas);
                }
            }
            var clonedCanvas = canvas.cloneNode(false);
            try {
                clonedCanvas.width = canvas.width;
                clonedCanvas.height = canvas.height;
                var ctx = canvas.getContext('2d');
                var clonedCtx = clonedCanvas.getContext('2d');
                if (clonedCtx) {
                    if (!this.options.allowTaint && ctx) {
                        clonedCtx.putImageData(ctx.getImageData(0, 0, canvas.width, canvas.height), 0, 0);
                    }
                    else {
                        var gl = (_a = canvas.getContext('webgl2')) !== null && _a !== void 0 ? _a : canvas.getContext('webgl');
                        if (gl) {
                            var attribs = gl.getContextAttributes();
                            if ((attribs === null || attribs === void 0 ? void 0 : attribs.preserveDrawingBuffer) === false) {
                                this.context.logger.warn('Unable to clone WebGL context as it has preserveDrawingBuffer=false', canvas);
                            }
                        }
                        clonedCtx.drawImage(canvas, 0, 0);
                    }
                }
                return clonedCanvas;
            }
            catch (e) {
                this.context.logger.info("Unable to clone canvas as it is tainted", canvas);
            }
            return clonedCanvas;
        };
        DocumentCloner.prototype.createVideoClone = function (video) {
            var canvas = video.ownerDocument.createElement('canvas');
            canvas.width = video.offsetWidth;
            canvas.height = video.offsetHeight;
            var ctx = canvas.getContext('2d');
            try {
                if (ctx) {
                    ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
                    if (!this.options.allowTaint) {
                        ctx.getImageData(0, 0, canvas.width, canvas.height);
                    }
                }
                return canvas;
            }
            catch (e) {
                this.context.logger.info("Unable to clone video as it is tainted", video);
            }
            var blankCanvas = video.ownerDocument.createElement('canvas');
            blankCanvas.width = video.offsetWidth;
            blankCanvas.height = video.offsetHeight;
            return blankCanvas;
        };
        DocumentCloner.prototype.appendChildNode = function (clone, child, copyStyles) {
            if (!isElementNode(child) ||
                (!isScriptElement(child) &&
                    !child.hasAttribute(IGNORE_ATTRIBUTE) &&
                    (typeof this.options.ignoreElements !== 'function' || !this.options.ignoreElements(child)))) {
                if (!this.options.copyStyles || !isElementNode(child) || !isStyleElement(child)) {
                    clone.appendChild(this.cloneNode(child, copyStyles));
                }
            }
        };
        DocumentCloner.prototype.cloneChildNodes = function (node, clone, copyStyles) {
            var _this = this;
            for (var child = node.shadowRoot ? node.shadowRoot.firstChild : node.firstChild; child; child = child.nextSibling) {
                if (isElementNode(child) && isSlotElement(child) && typeof child.assignedNodes === 'function') {
                    var assignedNodes = child.assignedNodes();
                    if (assignedNodes.length) {
                        assignedNodes.forEach(function (assignedNode) { return _this.appendChildNode(clone, assignedNode, copyStyles); });
                    }
                }
                else {
                    this.appendChildNode(clone, child, copyStyles);
                }
            }
        };
        DocumentCloner.prototype.cloneNode = function (node, copyStyles) {
            if (isTextNode(node)) {
                return document.createTextNode(node.data);
            }
            if (!node.ownerDocument) {
                return node.cloneNode(false);
            }
            var window = node.ownerDocument.defaultView;
            if (window && isElementNode(node) && (isHTMLElementNode(node) || isSVGElementNode(node))) {
                var clone = this.createElementClone(node);
                clone.style.transitionProperty = 'none';
                var style = window.getComputedStyle(node);
                var styleBefore = window.getComputedStyle(node, ':before');
                var styleAfter = window.getComputedStyle(node, ':after');
                if (this.referenceElement === node && isHTMLElementNode(clone)) {
                    this.clonedReferenceElement = clone;
                }
                if (isBodyElement(clone)) {
                    createPseudoHideStyles(clone);
                }
                var counters = this.counters.parse(new CSSParsedCounterDeclaration(this.context, style));
                var before = this.resolvePseudoContent(node, clone, styleBefore, PseudoElementType.BEFORE);
                if (isCustomElement(node)) {
                    copyStyles = true;
                }
                if (!isVideoElement(node)) {
                    this.cloneChildNodes(node, clone, copyStyles);
                }
                if (before) {
                    clone.insertBefore(before, clone.firstChild);
                }
                var after = this.resolvePseudoContent(node, clone, styleAfter, PseudoElementType.AFTER);
                if (after) {
                    clone.appendChild(after);
                }
                this.counters.pop(counters);
                if ((style && (this.options.copyStyles || isSVGElementNode(node)) && !isIFrameElement(node)) ||
                    copyStyles) {
                    copyCSSStyles(style, clone);
                }
                if (node.scrollTop !== 0 || node.scrollLeft !== 0) {
                    this.scrolledElements.push([clone, node.scrollLeft, node.scrollTop]);
                }
                if ((isTextareaElement(node) || isSelectElement(node)) &&
                    (isTextareaElement(clone) || isSelectElement(clone))) {
                    clone.value = node.value;
                }
                return clone;
            }
            return node.cloneNode(false);
        };
        DocumentCloner.prototype.resolvePseudoContent = function (node, clone, style, pseudoElt) {
            var _this = this;
            if (!style) {
                return;
            }
            var value = style.content;
            var document = clone.ownerDocument;
            if (!document || !value || value === 'none' || value === '-moz-alt-content' || style.display === 'none') {
                return;
            }
            this.counters.parse(new CSSParsedCounterDeclaration(this.context, style));
            var declaration = new CSSParsedPseudoDeclaration(this.context, style);
            var anonymousReplacedElement = document.createElement('html2canvaspseudoelement');
            copyCSSStyles(style, anonymousReplacedElement);
            declaration.content.forEach(function (token) {
                if (token.type === 0 /* STRING_TOKEN */) {
                    anonymousReplacedElement.appendChild(document.createTextNode(token.value));
                }
                else if (token.type === 22 /* URL_TOKEN */) {
                    var img = document.createElement('img');
                    img.src = token.value;
                    img.style.opacity = '1';
                    anonymousReplacedElement.appendChild(img);
                }
                else if (token.type === 18 /* FUNCTION */) {
                    if (token.name === 'attr') {
                        var attr = token.values.filter(isIdentToken);
                        if (attr.length) {
                            anonymousReplacedElement.appendChild(document.createTextNode(node.getAttribute(attr[0].value) || ''));
                        }
                    }
                    else if (token.name === 'counter') {
                        var _a = token.values.filter(nonFunctionArgSeparator), counter = _a[0], counterStyle = _a[1];
                        if (counter && isIdentToken(counter)) {
                            var counterState = _this.counters.getCounterValue(counter.value);
                            var counterType = counterStyle && isIdentToken(counterStyle)
                                ? listStyleType.parse(_this.context, counterStyle.value)
                                : 3 /* DECIMAL */;
                            anonymousReplacedElement.appendChild(document.createTextNode(createCounterText(counterState, counterType, false)));
                        }
                    }
                    else if (token.name === 'counters') {
                        var _b = token.values.filter(nonFunctionArgSeparator), counter = _b[0], delim = _b[1], counterStyle = _b[2];
                        if (counter && isIdentToken(counter)) {
                            var counterStates = _this.counters.getCounterValues(counter.value);
                            var counterType_1 = counterStyle && isIdentToken(counterStyle)
                                ? listStyleType.parse(_this.context, counterStyle.value)
                                : 3 /* DECIMAL */;
                            var separator = delim && delim.type === 0 /* STRING_TOKEN */ ? delim.value : '';
                            var text = counterStates
                                .map(function (value) { return createCounterText(value, counterType_1, false); })
                                .join(separator);
                            anonymousReplacedElement.appendChild(document.createTextNode(text));
                        }
                    }
                    else ;
                }
                else if (token.type === 20 /* IDENT_TOKEN */) {
                    switch (token.value) {
                        case 'open-quote':
                            anonymousReplacedElement.appendChild(document.createTextNode(getQuote(declaration.quotes, _this.quoteDepth++, true)));
                            break;
                        case 'close-quote':
                            anonymousReplacedElement.appendChild(document.createTextNode(getQuote(declaration.quotes, --_this.quoteDepth, false)));
                            break;
                        default:
                            // safari doesn't parse string tokens correctly because of lack of quotes
                            anonymousReplacedElement.appendChild(document.createTextNode(token.value));
                    }
                }
            });
            anonymousReplacedElement.className = PSEUDO_HIDE_ELEMENT_CLASS_BEFORE + " " + PSEUDO_HIDE_ELEMENT_CLASS_AFTER;
            var newClassName = pseudoElt === PseudoElementType.BEFORE
                ? " " + PSEUDO_HIDE_ELEMENT_CLASS_BEFORE
                : " " + PSEUDO_HIDE_ELEMENT_CLASS_AFTER;
            if (isSVGElementNode(clone)) {
                clone.className.baseValue += newClassName;
            }
            else {
                clone.className += newClassName;
            }
            return anonymousReplacedElement;
        };
        DocumentCloner.destroy = function (container) {
            if (container.parentNode) {
                container.parentNode.removeChild(container);
                return true;
            }
            return false;
        };
        return DocumentCloner;
    }());
    var PseudoElementType;
    (function (PseudoElementType) {
        PseudoElementType[PseudoElementType["BEFORE"] = 0] = "BEFORE";
        PseudoElementType[PseudoElementType["AFTER"] = 1] = "AFTER";
    })(PseudoElementType || (PseudoElementType = {}));
    var createIFrameContainer = function (ownerDocument, bounds) {
        var cloneIframeContainer = ownerDocument.createElement('iframe');
        cloneIframeContainer.className = 'html2canvas-container';
        cloneIframeContainer.style.visibility = 'hidden';
        cloneIframeContainer.style.position = 'fixed';
        cloneIframeContainer.style.left = '-10000px';
        cloneIframeContainer.style.top = '0px';
        cloneIframeContainer.style.border = '0';
        cloneIframeContainer.width = bounds.width.toString();
        cloneIframeContainer.height = bounds.height.toString();
        cloneIframeContainer.scrolling = 'no'; // ios won't scroll without it
        cloneIframeContainer.setAttribute(IGNORE_ATTRIBUTE, 'true');
        ownerDocument.body.appendChild(cloneIframeContainer);
        return cloneIframeContainer;
    };
    var imageReady = function (img) {
        return new Promise(function (resolve) {
            if (img.complete) {
                resolve();
                return;
            }
            if (!img.src) {
                resolve();
                return;
            }
            img.onload = resolve;
            img.onerror = resolve;
        });
    };
    var imagesReady = function (document) {
        return Promise.all([].slice.call(document.images, 0).map(imageReady));
    };
    var iframeLoader = function (iframe) {
        return new Promise(function (resolve, reject) {
            var cloneWindow = iframe.contentWindow;
            if (!cloneWindow) {
                return reject("No window assigned for iframe");
            }
            var documentClone = cloneWindow.document;
            cloneWindow.onload = iframe.onload = function () {
                cloneWindow.onload = iframe.onload = null;
                var interval = setInterval(function () {
                    if (documentClone.body.childNodes.length > 0 && documentClone.readyState === 'complete') {
                        clearInterval(interval);
                        resolve(iframe);
                    }
                }, 50);
            };
        });
    };
    var ignoredStyleProperties = [
        'all',
        'd',
        'content' // Safari shows pseudoelements if content is set
    ];
    var copyCSSStyles = function (style, target) {
        // Edge does not provide value for cssText
        for (var i = style.length - 1; i >= 0; i--) {
            var property = style.item(i);
            if (ignoredStyleProperties.indexOf(property) === -1) {
                target.style.setProperty(property, style.getPropertyValue(property));
            }
        }
        return target;
    };
    var serializeDoctype = function (doctype) {
        var str = '';
        if (doctype) {
            str += '<!DOCTYPE ';
            if (doctype.name) {
                str += doctype.name;
            }
            if (doctype.internalSubset) {
                str += doctype.internalSubset;
            }
            if (doctype.publicId) {
                str += "\"" + doctype.publicId + "\"";
            }
            if (doctype.systemId) {
                str += "\"" + doctype.systemId + "\"";
            }
            str += '>';
        }
        return str;
    };
    var restoreOwnerScroll = function (ownerDocument, x, y) {
        if (ownerDocument &&
            ownerDocument.defaultView &&
            (x !== ownerDocument.defaultView.pageXOffset || y !== ownerDocument.defaultView.pageYOffset)) {
            ownerDocument.defaultView.scrollTo(x, y);
        }
    };
    var restoreNodeScroll = function (_a) {
        var element = _a[0], x = _a[1], y = _a[2];
        element.scrollLeft = x;
        element.scrollTop = y;
    };
    var PSEUDO_BEFORE = ':before';
    var PSEUDO_AFTER = ':after';
    var PSEUDO_HIDE_ELEMENT_CLASS_BEFORE = '___html2canvas___pseudoelement_before';
    var PSEUDO_HIDE_ELEMENT_CLASS_AFTER = '___html2canvas___pseudoelement_after';
    var PSEUDO_HIDE_ELEMENT_STYLE = "{\n    content: \"\" !important;\n    display: none !important;\n}";
    var createPseudoHideStyles = function (body) {
        createStyles(body, "." + PSEUDO_HIDE_ELEMENT_CLASS_BEFORE + PSEUDO_BEFORE + PSEUDO_HIDE_ELEMENT_STYLE + "\n         ." + PSEUDO_HIDE_ELEMENT_CLASS_AFTER + PSEUDO_AFTER + PSEUDO_HIDE_ELEMENT_STYLE);
    };
    var createStyles = function (body, styles) {
        var document = body.ownerDocument;
        if (document) {
            var style = document.createElement('style');
            style.textContent = styles;
            body.appendChild(style);
        }
    };

    var CacheStorage = /** @class */ (function () {
        function CacheStorage() {
        }
        CacheStorage.getOrigin = function (url) {
            var link = CacheStorage._link;
            if (!link) {
                return 'about:blank';
            }
            link.href = url;
            link.href = link.href; // IE9, LOL! - http://jsfiddle.net/niklasvh/2e48b/
            return link.protocol + link.hostname + link.port;
        };
        CacheStorage.isSameOrigin = function (src) {
            return CacheStorage.getOrigin(src) === CacheStorage._origin;
        };
        CacheStorage.setContext = function (window) {
            CacheStorage._link = window.document.createElement('a');
            CacheStorage._origin = CacheStorage.getOrigin(window.location.href);
        };
        CacheStorage._origin = 'about:blank';
        return CacheStorage;
    }());
    var Cache = /** @class */ (function () {
        function Cache(context, _options) {
            this.context = context;
            this._options = _options;
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            this._cache = {};
        }
        Cache.prototype.addImage = function (src) {
            var result = Promise.resolve();
            if (this.has(src)) {
                return result;
            }
            if (isBlobImage(src) || isRenderable(src)) {
                (this._cache[src] = this.loadImage(src)).catch(function () {
                    // prevent unhandled rejection
                });
                return result;
            }
            return result;
        };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        Cache.prototype.match = function (src) {
            return this._cache[src];
        };
        Cache.prototype.loadImage = function (key) {
            return __awaiter(this, void 0, void 0, function () {
                var isSameOrigin, useCORS, useProxy, src;
                var _this = this;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            isSameOrigin = CacheStorage.isSameOrigin(key);
                            useCORS = !isInlineImage(key) && this._options.useCORS === true && FEATURES.SUPPORT_CORS_IMAGES && !isSameOrigin;
                            useProxy = !isInlineImage(key) &&
                                !isSameOrigin &&
                                !isBlobImage(key) &&
                                typeof this._options.proxy === 'string' &&
                                FEATURES.SUPPORT_CORS_XHR &&
                                !useCORS;
                            if (!isSameOrigin &&
                                this._options.allowTaint === false &&
                                !isInlineImage(key) &&
                                !isBlobImage(key) &&
                                !useProxy &&
                                !useCORS) {
                                return [2 /*return*/];
                            }
                            src = key;
                            if (!useProxy) return [3 /*break*/, 2];
                            return [4 /*yield*/, this.proxy(src)];
                        case 1:
                            src = _a.sent();
                            _a.label = 2;
                        case 2:
                            this.context.logger.debug("Added image " + key.substring(0, 256));
                            return [4 /*yield*/, new Promise(function (resolve, reject) {
                                    var img = new Image();
                                    img.onload = function () { return resolve(img); };
                                    img.onerror = reject;
                                    //ios safari 10.3 taints canvas with data urls unless crossOrigin is set to anonymous
                                    if (isInlineBase64Image(src) || useCORS) {
                                        img.crossOrigin = 'anonymous';
                                    }
                                    img.src = src;
                                    if (img.complete === true) {
                                        // Inline XML images may fail to parse, throwing an Error later on
                                        setTimeout(function () { return resolve(img); }, 500);
                                    }
                                    if (_this._options.imageTimeout > 0) {
                                        setTimeout(function () { return reject("Timed out (" + _this._options.imageTimeout + "ms) loading image"); }, _this._options.imageTimeout);
                                    }
                                })];
                        case 3: return [2 /*return*/, _a.sent()];
                    }
                });
            });
        };
        Cache.prototype.has = function (key) {
            return typeof this._cache[key] !== 'undefined';
        };
        Cache.prototype.keys = function () {
            return Promise.resolve(Object.keys(this._cache));
        };
        Cache.prototype.proxy = function (src) {
            var _this = this;
            var proxy = this._options.proxy;
            if (!proxy) {
                throw new Error('No proxy defined');
            }
            var key = src.substring(0, 256);
            return new Promise(function (resolve, reject) {
                var responseType = FEATURES.SUPPORT_RESPONSE_TYPE ? 'blob' : 'text';
                var xhr = new XMLHttpRequest();
                xhr.onload = function () {
                    if (xhr.status === 200) {
                        if (responseType === 'text') {
                            resolve(xhr.response);
                        }
                        else {
                            var reader_1 = new FileReader();
                            reader_1.addEventListener('load', function () { return resolve(reader_1.result); }, false);
                            reader_1.addEventListener('error', function (e) { return reject(e); }, false);
                            reader_1.readAsDataURL(xhr.response);
                        }
                    }
                    else {
                        reject("Failed to proxy resource " + key + " with status code " + xhr.status);
                    }
                };
                xhr.onerror = reject;
                var queryString = proxy.indexOf('?') > -1 ? '&' : '?';
                xhr.open('GET', "" + proxy + queryString + "url=" + encodeURIComponent(src) + "&responseType=" + responseType);
                if (responseType !== 'text' && xhr instanceof XMLHttpRequest) {
                    xhr.responseType = responseType;
                }
                if (_this._options.imageTimeout) {
                    var timeout_1 = _this._options.imageTimeout;
                    xhr.timeout = timeout_1;
                    xhr.ontimeout = function () { return reject("Timed out (" + timeout_1 + "ms) proxying " + key); };
                }
                xhr.send();
            });
        };
        return Cache;
    }());
    var INLINE_SVG = /^data:image\/svg\+xml/i;
    var INLINE_BASE64 = /^data:image\/.*;base64,/i;
    var INLINE_IMG = /^data:image\/.*/i;
    var isRenderable = function (src) { return FEATURES.SUPPORT_SVG_DRAWING || !isSVG(src); };
    var isInlineImage = function (src) { return INLINE_IMG.test(src); };
    var isInlineBase64Image = function (src) { return INLINE_BASE64.test(src); };
    var isBlobImage = function (src) { return src.substr(0, 4) === 'blob'; };
    var isSVG = function (src) { return src.substr(-3).toLowerCase() === 'svg' || INLINE_SVG.test(src); };

    var Vector = /** @class */ (function () {
        function Vector(x, y) {
            this.type = 0 /* VECTOR */;
            this.x = x;
            this.y = y;
        }
        Vector.prototype.add = function (deltaX, deltaY) {
            return new Vector(this.x + deltaX, this.y + deltaY);
        };
        return Vector;
    }());

    var lerp = function (a, b, t) {
        return new Vector(a.x + (b.x - a.x) * t, a.y + (b.y - a.y) * t);
    };
    var BezierCurve = /** @class */ (function () {
        function BezierCurve(start, startControl, endControl, end) {
            this.type = 1 /* BEZIER_CURVE */;
            this.start = start;
            this.startControl = startControl;
            this.endControl = endControl;
            this.end = end;
        }
        BezierCurve.prototype.subdivide = function (t, firstHalf) {
            var ab = lerp(this.start, this.startControl, t);
            var bc = lerp(this.startControl, this.endControl, t);
            var cd = lerp(this.endControl, this.end, t);
            var abbc = lerp(ab, bc, t);
            var bccd = lerp(bc, cd, t);
            var dest = lerp(abbc, bccd, t);
            return firstHalf ? new BezierCurve(this.start, ab, abbc, dest) : new BezierCurve(dest, bccd, cd, this.end);
        };
        BezierCurve.prototype.add = function (deltaX, deltaY) {
            return new BezierCurve(this.start.add(deltaX, deltaY), this.startControl.add(deltaX, deltaY), this.endControl.add(deltaX, deltaY), this.end.add(deltaX, deltaY));
        };
        BezierCurve.prototype.reverse = function () {
            return new BezierCurve(this.end, this.endControl, this.startControl, this.start);
        };
        return BezierCurve;
    }());
    var isBezierCurve = function (path) { return path.type === 1 /* BEZIER_CURVE */; };

    var BoundCurves = /** @class */ (function () {
        function BoundCurves(element) {
            var styles = element.styles;
            var bounds = element.bounds;
            var _a = getAbsoluteValueForTuple(styles.borderTopLeftRadius, bounds.width, bounds.height), tlh = _a[0], tlv = _a[1];
            var _b = getAbsoluteValueForTuple(styles.borderTopRightRadius, bounds.width, bounds.height), trh = _b[0], trv = _b[1];
            var _c = getAbsoluteValueForTuple(styles.borderBottomRightRadius, bounds.width, bounds.height), brh = _c[0], brv = _c[1];
            var _d = getAbsoluteValueForTuple(styles.borderBottomLeftRadius, bounds.width, bounds.height), blh = _d[0], blv = _d[1];
            var factors = [];
            factors.push((tlh + trh) / bounds.width);
            factors.push((blh + brh) / bounds.width);
            factors.push((tlv + blv) / bounds.height);
            factors.push((trv + brv) / bounds.height);
            var maxFactor = Math.max.apply(Math, factors);
            if (maxFactor > 1) {
                tlh /= maxFactor;
                tlv /= maxFactor;
                trh /= maxFactor;
                trv /= maxFactor;
                brh /= maxFactor;
                brv /= maxFactor;
                blh /= maxFactor;
                blv /= maxFactor;
            }
            var topWidth = bounds.width - trh;
            var rightHeight = bounds.height - brv;
            var bottomWidth = bounds.width - brh;
            var leftHeight = bounds.height - blv;
            var borderTopWidth = styles.borderTopWidth;
            var borderRightWidth = styles.borderRightWidth;
            var borderBottomWidth = styles.borderBottomWidth;
            var borderLeftWidth = styles.borderLeftWidth;
            var paddingTop = getAbsoluteValue(styles.paddingTop, element.bounds.width);
            var paddingRight = getAbsoluteValue(styles.paddingRight, element.bounds.width);
            var paddingBottom = getAbsoluteValue(styles.paddingBottom, element.bounds.width);
            var paddingLeft = getAbsoluteValue(styles.paddingLeft, element.bounds.width);
            this.topLeftBorderDoubleOuterBox =
                tlh > 0 || tlv > 0
                    ? getCurvePoints(bounds.left + borderLeftWidth / 3, bounds.top + borderTopWidth / 3, tlh - borderLeftWidth / 3, tlv - borderTopWidth / 3, CORNER.TOP_LEFT)
                    : new Vector(bounds.left + borderLeftWidth / 3, bounds.top + borderTopWidth / 3);
            this.topRightBorderDoubleOuterBox =
                trh > 0 || trv > 0
                    ? getCurvePoints(bounds.left + topWidth, bounds.top + borderTopWidth / 3, trh - borderRightWidth / 3, trv - borderTopWidth / 3, CORNER.TOP_RIGHT)
                    : new Vector(bounds.left + bounds.width - borderRightWidth / 3, bounds.top + borderTopWidth / 3);
            this.bottomRightBorderDoubleOuterBox =
                brh > 0 || brv > 0
                    ? getCurvePoints(bounds.left + bottomWidth, bounds.top + rightHeight, brh - borderRightWidth / 3, brv - borderBottomWidth / 3, CORNER.BOTTOM_RIGHT)
                    : new Vector(bounds.left + bounds.width - borderRightWidth / 3, bounds.top + bounds.height - borderBottomWidth / 3);
            this.bottomLeftBorderDoubleOuterBox =
                blh > 0 || blv > 0
                    ? getCurvePoints(bounds.left + borderLeftWidth / 3, bounds.top + leftHeight, blh - borderLeftWidth / 3, blv - borderBottomWidth / 3, CORNER.BOTTOM_LEFT)
                    : new Vector(bounds.left + borderLeftWidth / 3, bounds.top + bounds.height - borderBottomWidth / 3);
            this.topLeftBorderDoubleInnerBox =
                tlh > 0 || tlv > 0
                    ? getCurvePoints(bounds.left + (borderLeftWidth * 2) / 3, bounds.top + (borderTopWidth * 2) / 3, tlh - (borderLeftWidth * 2) / 3, tlv - (borderTopWidth * 2) / 3, CORNER.TOP_LEFT)
                    : new Vector(bounds.left + (borderLeftWidth * 2) / 3, bounds.top + (borderTopWidth * 2) / 3);
            this.topRightBorderDoubleInnerBox =
                trh > 0 || trv > 0
                    ? getCurvePoints(bounds.left + topWidth, bounds.top + (borderTopWidth * 2) / 3, trh - (borderRightWidth * 2) / 3, trv - (borderTopWidth * 2) / 3, CORNER.TOP_RIGHT)
                    : new Vector(bounds.left + bounds.width - (borderRightWidth * 2) / 3, bounds.top + (borderTopWidth * 2) / 3);
            this.bottomRightBorderDoubleInnerBox =
                brh > 0 || brv > 0
                    ? getCurvePoints(bounds.left + bottomWidth, bounds.top + rightHeight, brh - (borderRightWidth * 2) / 3, brv - (borderBottomWidth * 2) / 3, CORNER.BOTTOM_RIGHT)
                    : new Vector(bounds.left + bounds.width - (borderRightWidth * 2) / 3, bounds.top + bounds.height - (borderBottomWidth * 2) / 3);
            this.bottomLeftBorderDoubleInnerBox =
                blh > 0 || blv > 0
                    ? getCurvePoints(bounds.left + (borderLeftWidth * 2) / 3, bounds.top + leftHeight, blh - (borderLeftWidth * 2) / 3, blv - (borderBottomWidth * 2) / 3, CORNER.BOTTOM_LEFT)
                    : new Vector(bounds.left + (borderLeftWidth * 2) / 3, bounds.top + bounds.height - (borderBottomWidth * 2) / 3);
            this.topLeftBorderStroke =
                tlh > 0 || tlv > 0
                    ? getCurvePoints(bounds.left + borderLeftWidth / 2, bounds.top + borderTopWidth / 2, tlh - borderLeftWidth / 2, tlv - borderTopWidth / 2, CORNER.TOP_LEFT)
                    : new Vector(bounds.left + borderLeftWidth / 2, bounds.top + borderTopWidth / 2);
            this.topRightBorderStroke =
                trh > 0 || trv > 0
                    ? getCurvePoints(bounds.left + topWidth, bounds.top + borderTopWidth / 2, trh - borderRightWidth / 2, trv - borderTopWidth / 2, CORNER.TOP_RIGHT)
                    : new Vector(bounds.left + bounds.width - borderRightWidth / 2, bounds.top + borderTopWidth / 2);
            this.bottomRightBorderStroke =
                brh > 0 || brv > 0
                    ? getCurvePoints(bounds.left + bottomWidth, bounds.top + rightHeight, brh - borderRightWidth / 2, brv - borderBottomWidth / 2, CORNER.BOTTOM_RIGHT)
                    : new Vector(bounds.left + bounds.width - borderRightWidth / 2, bounds.top + bounds.height - borderBottomWidth / 2);
            this.bottomLeftBorderStroke =
                blh > 0 || blv > 0
                    ? getCurvePoints(bounds.left + borderLeftWidth / 2, bounds.top + leftHeight, blh - borderLeftWidth / 2, blv - borderBottomWidth / 2, CORNER.BOTTOM_LEFT)
                    : new Vector(bounds.left + borderLeftWidth / 2, bounds.top + bounds.height - borderBottomWidth / 2);
            this.topLeftBorderBox =
                tlh > 0 || tlv > 0
                    ? getCurvePoints(bounds.left, bounds.top, tlh, tlv, CORNER.TOP_LEFT)
                    : new Vector(bounds.left, bounds.top);
            this.topRightBorderBox =
                trh > 0 || trv > 0
                    ? getCurvePoints(bounds.left + topWidth, bounds.top, trh, trv, CORNER.TOP_RIGHT)
                    : new Vector(bounds.left + bounds.width, bounds.top);
            this.bottomRightBorderBox =
                brh > 0 || brv > 0
                    ? getCurvePoints(bounds.left + bottomWidth, bounds.top + rightHeight, brh, brv, CORNER.BOTTOM_RIGHT)
                    : new Vector(bounds.left + bounds.width, bounds.top + bounds.height);
            this.bottomLeftBorderBox =
                blh > 0 || blv > 0
                    ? getCurvePoints(bounds.left, bounds.top + leftHeight, blh, blv, CORNER.BOTTOM_LEFT)
                    : new Vector(bounds.left, bounds.top + bounds.height);
            this.topLeftPaddingBox =
                tlh > 0 || tlv > 0
                    ? getCurvePoints(bounds.left + borderLeftWidth, bounds.top + borderTopWidth, Math.max(0, tlh - borderLeftWidth), Math.max(0, tlv - borderTopWidth), CORNER.TOP_LEFT)
                    : new Vector(bounds.left + borderLeftWidth, bounds.top + borderTopWidth);
            this.topRightPaddingBox =
                trh > 0 || trv > 0
                    ? getCurvePoints(bounds.left + Math.min(topWidth, bounds.width - borderRightWidth), bounds.top + borderTopWidth, topWidth > bounds.width + borderRightWidth ? 0 : Math.max(0, trh - borderRightWidth), Math.max(0, trv - borderTopWidth), CORNER.TOP_RIGHT)
                    : new Vector(bounds.left + bounds.width - borderRightWidth, bounds.top + borderTopWidth);
            this.bottomRightPaddingBox =
                brh > 0 || brv > 0
                    ? getCurvePoints(bounds.left + Math.min(bottomWidth, bounds.width - borderLeftWidth), bounds.top + Math.min(rightHeight, bounds.height - borderBottomWidth), Math.max(0, brh - borderRightWidth), Math.max(0, brv - borderBottomWidth), CORNER.BOTTOM_RIGHT)
                    : new Vector(bounds.left + bounds.width - borderRightWidth, bounds.top + bounds.height - borderBottomWidth);
            this.bottomLeftPaddingBox =
                blh > 0 || blv > 0
                    ? getCurvePoints(bounds.left + borderLeftWidth, bounds.top + Math.min(leftHeight, bounds.height - borderBottomWidth), Math.max(0, blh - borderLeftWidth), Math.max(0, blv - borderBottomWidth), CORNER.BOTTOM_LEFT)
                    : new Vector(bounds.left + borderLeftWidth, bounds.top + bounds.height - borderBottomWidth);
            this.topLeftContentBox =
                tlh > 0 || tlv > 0
                    ? getCurvePoints(bounds.left + borderLeftWidth + paddingLeft, bounds.top + borderTopWidth + paddingTop, Math.max(0, tlh - (borderLeftWidth + paddingLeft)), Math.max(0, tlv - (borderTopWidth + paddingTop)), CORNER.TOP_LEFT)
                    : new Vector(bounds.left + borderLeftWidth + paddingLeft, bounds.top + borderTopWidth + paddingTop);
            this.topRightContentBox =
                trh > 0 || trv > 0
                    ? getCurvePoints(bounds.left + Math.min(topWidth, bounds.width -( borderLeftWidth + paddingLeft)), bounds.top + borderTopWidth + paddingTop, topWidth > bounds.width - borderLeftWidth + paddingLeft ? 0 : trh - borderLeftWidth + paddingLeft, trv - (borderTopWidth + paddingTop), CORNER.TOP_RIGHT)
                    : new Vector(bounds.left + bounds.width - (borderRightWidth + paddingRight), bounds.top + borderTopWidth + paddingTop);
            this.bottomRightContentBox =
                brh > 0 || brv > 0
                    ? getCurvePoints(bounds.left + Math.min(bottomWidth, bounds.width - (borderLeftWidth + paddingLeft)), bounds.top + Math.min(rightHeight, bounds.height - (borderTopWidth + paddingTop)), Math.max(0, brh - (borderRightWidth + paddingRight)), brv - (borderBottomWidth + paddingBottom), CORNER.BOTTOM_RIGHT)
                    : new Vector(bounds.left + bounds.width - (borderRightWidth + paddingRight), bounds.top + bounds.height - (borderBottomWidth + paddingBottom));
            this.bottomLeftContentBox =
                blh > 0 || blv > 0
                    ? getCurvePoints(bounds.left + borderLeftWidth + paddingLeft, bounds.top + leftHeight, Math.max(0, blh - (borderLeftWidth + paddingLeft)), blv - (borderBottomWidth + paddingBottom), CORNER.BOTTOM_LEFT)
                    : new Vector(bounds.left + borderLeftWidth + paddingLeft, bounds.top + bounds.height - (borderBottomWidth + paddingBottom));

            // customize by Caravan
        }
        return BoundCurves;
    }());
    var CORNER;
    (function (CORNER) {
        CORNER[CORNER["TOP_LEFT"] = 0] = "TOP_LEFT";
        CORNER[CORNER["TOP_RIGHT"] = 1] = "TOP_RIGHT";
        CORNER[CORNER["BOTTOM_RIGHT"] = 2] = "BOTTOM_RIGHT";
        CORNER[CORNER["BOTTOM_LEFT"] = 3] = "BOTTOM_LEFT";
    })(CORNER || (CORNER = {}));
    var getCurvePoints = function (x, y, r1, r2, position) {
        var kappa = 4 * ((Math.sqrt(2) - 1) / 3);
        var ox = r1 * kappa; // control point offset horizontal
        var oy = r2 * kappa; // control point offset vertical
        var xm = x + r1; // x-middle
        var ym = y + r2; // y-middle
        switch (position) {
            case CORNER.TOP_LEFT:
                return new BezierCurve(new Vector(x, ym), new Vector(x, ym - oy), new Vector(xm - ox, y), new Vector(xm, y));
            case CORNER.TOP_RIGHT:
                return new BezierCurve(new Vector(x, y), new Vector(x + ox, y), new Vector(xm, ym - oy), new Vector(xm, ym));
            case CORNER.BOTTOM_RIGHT:
                return new BezierCurve(new Vector(xm, y), new Vector(xm, y + oy), new Vector(x + ox, ym), new Vector(x, ym));
            case CORNER.BOTTOM_LEFT:
            default:
                return new BezierCurve(new Vector(xm, ym), new Vector(xm - ox, ym), new Vector(x, y + oy), new Vector(x, y));
        }
    };
    var calculateBorderBoxPath = function (curves) {
        return [curves.topLeftBorderBox, curves.topRightBorderBox, curves.bottomRightBorderBox, curves.bottomLeftBorderBox];
    };
    var calculateContentBoxPath = function (curves) {
        return [
            curves.topLeftContentBox,
            curves.topRightContentBox,
            curves.bottomRightContentBox,
            curves.bottomLeftContentBox
        ];
    };
    var calculatePaddingBoxPath = function (curves) {
        return [
            curves.topLeftPaddingBox,
            curves.topRightPaddingBox,
            curves.bottomRightPaddingBox,
            curves.bottomLeftPaddingBox
        ];
    };

    var TransformEffect = /** @class */ (function () {
        function TransformEffect(offsetX, offsetY, matrix) {
            this.offsetX = offsetX;
            this.offsetY = offsetY;
            this.matrix = matrix;
            this.type = 0 /* TRANSFORM */;
            this.target = 2 /* BACKGROUND_BORDERS */ | 4 /* CONTENT */;
        }
        return TransformEffect;
    }());
    var ClipEffect = /** @class */ (function () {
        function ClipEffect(path, target) {
            this.path = path;
            this.target = target;
            this.type = 1 /* CLIP */;
        }
        return ClipEffect;
    }());
    var OpacityEffect = /** @class */ (function () {
        function OpacityEffect(opacity) {
            this.opacity = opacity;
            this.type = 2 /* OPACITY */;
            this.target = 2 /* BACKGROUND_BORDERS */ | 4 /* CONTENT */;
        }
        return OpacityEffect;
    }());
    var isTransformEffect = function (effect) {
        return effect.type === 0 /* TRANSFORM */;
    };
    var isClipEffect = function (effect) { return effect.type === 1 /* CLIP */; };
    var isOpacityEffect = function (effect) { return effect.type === 2 /* OPACITY */; };

    var equalPath = function (a, b) {
        if (a.length === b.length) {
            return a.some(function (v, i) { return v === b[i]; });
        }
        return false;
    };
    var transformPath = function (path, deltaX, deltaY, deltaW, deltaH) {
        return path.map(function (point, index) {
            switch (index) {
                case 0:
                    return point.add(deltaX, deltaY);
                case 1:
                    return point.add(deltaX + deltaW, deltaY);
                case 2:
                    return point.add(deltaX + deltaW, deltaY + deltaH);
                case 3:
                    return point.add(deltaX, deltaY + deltaH);
            }
            return point;
        });
    };

    var StackingContext = /** @class */ (function () {
        function StackingContext(container) {
            this.element = container;
            this.inlineLevel = [];
            this.nonInlineLevel = [];
            this.negativeZIndex = [];
            this.zeroOrAutoZIndexOrTransformedOrOpacity = [];
            this.positiveZIndex = [];
            this.nonPositionedFloats = [];
            this.nonPositionedInlineLevel = [];
        }
        return StackingContext;
    }());
    var ElementPaint = /** @class */ (function () {
        function ElementPaint(container, parent) {
            this.container = container;
            this.parent = parent;
            this.effects = [];
            this.curves = new BoundCurves(this.container);
            if (this.container.styles.opacity < 1) {
                this.effects.push(new OpacityEffect(this.container.styles.opacity));
            }
            if (this.container.styles.transform !== null) {
                var offsetX = this.container.bounds.left + this.container.styles.transformOrigin[0].number;
                var offsetY = this.container.bounds.top + this.container.styles.transformOrigin[1].number;
                var matrix = this.container.styles.transform;
                this.effects.push(new TransformEffect(offsetX, offsetY, matrix));
            }
            if (this.container.styles.overflowX !== 0 /* VISIBLE */) {
                var borderBox = calculateBorderBoxPath(this.curves);
                var paddingBox = calculatePaddingBoxPath(this.curves);
                if (equalPath(borderBox, paddingBox)) {
                    this.effects.push(new ClipEffect(borderBox, 2 /* BACKGROUND_BORDERS */ | 4 /* CONTENT */));
                }
                else {
                    this.effects.push(new ClipEffect(borderBox, 2 /* BACKGROUND_BORDERS */));
                    this.effects.push(new ClipEffect(paddingBox, 4 /* CONTENT */));
                }
            }
            if (this.container.isHole) {
                var target = this.parent;
                while (target) {
                    if (target.container.isTarget) {
                        target.container.holeCurves = this.curves;
                        break;
                    } 
                    else {
                        target = target.parent;
                    }
                }
            }
        }
        ElementPaint.prototype.getEffects = function (target) {
            var inFlow = [2 /* ABSOLUTE */, 3 /* FIXED */].indexOf(this.container.styles.position) === -1;
            var parent = this.parent;
            var effects = this.effects.slice(0);
            while (parent) {
                var croplessEffects = parent.effects.filter(function (effect) { return !isClipEffect(effect); });
                if (inFlow || parent.container.styles.position !== 0 /* STATIC */ || !parent.parent) {
                    effects.unshift.apply(effects, croplessEffects);
                    inFlow = [2 /* ABSOLUTE */, 3 /* FIXED */].indexOf(parent.container.styles.position) === -1;
                    if (parent.container.styles.overflowX !== 0 /* VISIBLE */) {
                        var borderBox = calculateBorderBoxPath(parent.curves);
                        var paddingBox = calculatePaddingBoxPath(parent.curves);
                        if (!equalPath(borderBox, paddingBox)) {
                            effects.unshift(new ClipEffect(paddingBox, 2 /* BACKGROUND_BORDERS */ | 4 /* CONTENT */));
                        }
                    }
                }
                else {
                    effects.unshift.apply(effects, croplessEffects);
                }
                parent = parent.parent;
            }
            return effects.filter(function (effect) { return contains(effect.target, target); });
        };
        return ElementPaint;
    }());
    var parseStackTree = function (parent, stackingContext, realStackingContext, listItems) {
        parent.container.elements.forEach(function (child) {
            var treatAsRealStackingContext = contains(child.flags, 4 /* CREATES_REAL_STACKING_CONTEXT */);
            var createsStackingContext = contains(child.flags, 2 /* CREATES_STACKING_CONTEXT */);
            var paintContainer = new ElementPaint(child, parent);
            if (contains(child.styles.display, 2048 /* LIST_ITEM */)) {
                listItems.push(paintContainer);
            }
            var listOwnerItems = contains(child.flags, 8 /* IS_LIST_OWNER */) ? [] : listItems;
            if (treatAsRealStackingContext || createsStackingContext) {
                var parentStack = treatAsRealStackingContext || child.styles.isPositioned() ? realStackingContext : stackingContext;
                var stack = new StackingContext(paintContainer);
                if (child.styles.isPositioned() || child.styles.opacity < 1 || child.styles.isTransformed()) {
                    var order_1 = child.styles.zIndex.order;
                    if (order_1 < 0) {
                        var index_1 = 0;
                        parentStack.negativeZIndex.some(function (current, i) {
                            if (order_1 > current.element.container.styles.zIndex.order) {
                                index_1 = i;
                                return false;
                            }
                            else if (index_1 > 0) {
                                return true;
                            }
                            return false;
                        });
                        parentStack.negativeZIndex.splice(index_1, 0, stack);
                    }
                    else if (order_1 > 0) {
                        var index_2 = 0;
                        parentStack.positiveZIndex.some(function (current, i) {
                            if (order_1 >= current.element.container.styles.zIndex.order) {
                                index_2 = i + 1;
                                return false;
                            }
                            else if (index_2 > 0) {
                                return true;
                            }
                            return false;
                        });
                        parentStack.positiveZIndex.splice(index_2, 0, stack);
                    }
                    else {
                        parentStack.zeroOrAutoZIndexOrTransformedOrOpacity.push(stack);
                    }
                }
                else {
                    if (child.styles.isFloating()) {
                        parentStack.nonPositionedFloats.push(stack);
                    }
                    else {
                        parentStack.nonPositionedInlineLevel.push(stack);
                    }
                }
                parseStackTree(paintContainer, stack, treatAsRealStackingContext ? stack : realStackingContext, listOwnerItems);
            }
            else {
                if (child.styles.isInlineLevel()) {
                    stackingContext.inlineLevel.push(paintContainer);
                }
                else {
                    stackingContext.nonInlineLevel.push(paintContainer);
                }
                parseStackTree(paintContainer, stackingContext, realStackingContext, listOwnerItems);
            }
            if (contains(child.flags, 8 /* IS_LIST_OWNER */)) {
                processListItems(child, listOwnerItems);
            }
        });
    };
    var processListItems = function (owner, elements) {
        var numbering = owner instanceof OLElementContainer ? owner.start : 1;
        var reversed = owner instanceof OLElementContainer ? owner.reversed : false;
        for (var i = 0; i < elements.length; i++) {
            var item = elements[i];
            if (item.container instanceof LIElementContainer &&
                typeof item.container.value === 'number' &&
                item.container.value !== 0) {
                numbering = item.container.value;
            }
            item.listValue = createCounterText(numbering, item.container.styles.listStyleType, true);
            numbering += reversed ? -1 : 1;
        }
    };
    var parseStackingContexts = function (container) {
        var paintContainer = new ElementPaint(container, null);
        var root = new StackingContext(paintContainer);
        var listItems = [];
        parseStackTree(paintContainer, root, root, listItems);
        processListItems(paintContainer.container, listItems);
        return root;
    };

    var parsePathForBorder = function (curves, borderSide) {
        switch (borderSide) {
            case 0:
                return createPathFromCurves(curves.topLeftBorderBox, curves.topLeftPaddingBox, curves.topRightBorderBox, curves.topRightPaddingBox);
            case 1:
                return createPathFromCurves(curves.topRightBorderBox, curves.topRightPaddingBox, curves.bottomRightBorderBox, curves.bottomRightPaddingBox);
            case 2:
                return createPathFromCurves(curves.bottomRightBorderBox, curves.bottomRightPaddingBox, curves.bottomLeftBorderBox, curves.bottomLeftPaddingBox);
            case 3:
            default:
                return createPathFromCurves(curves.bottomLeftBorderBox, curves.bottomLeftPaddingBox, curves.topLeftBorderBox, curves.topLeftPaddingBox);
        }
    };
    var parsePathForBorderDoubleOuter = function (curves, borderSide) {
        switch (borderSide) {
            case 0:
                return createPathFromCurves(curves.topLeftBorderBox, curves.topLeftBorderDoubleOuterBox, curves.topRightBorderBox, curves.topRightBorderDoubleOuterBox);
            case 1:
                return createPathFromCurves(curves.topRightBorderBox, curves.topRightBorderDoubleOuterBox, curves.bottomRightBorderBox, curves.bottomRightBorderDoubleOuterBox);
            case 2:
                return createPathFromCurves(curves.bottomRightBorderBox, curves.bottomRightBorderDoubleOuterBox, curves.bottomLeftBorderBox, curves.bottomLeftBorderDoubleOuterBox);
            case 3:
            default:
                return createPathFromCurves(curves.bottomLeftBorderBox, curves.bottomLeftBorderDoubleOuterBox, curves.topLeftBorderBox, curves.topLeftBorderDoubleOuterBox);
        }
    };
    var parsePathForBorderDoubleInner = function (curves, borderSide) {
        switch (borderSide) {
            case 0:
                return createPathFromCurves(curves.topLeftBorderDoubleInnerBox, curves.topLeftPaddingBox, curves.topRightBorderDoubleInnerBox, curves.topRightPaddingBox);
            case 1:
                return createPathFromCurves(curves.topRightBorderDoubleInnerBox, curves.topRightPaddingBox, curves.bottomRightBorderDoubleInnerBox, curves.bottomRightPaddingBox);
            case 2:
                return createPathFromCurves(curves.bottomRightBorderDoubleInnerBox, curves.bottomRightPaddingBox, curves.bottomLeftBorderDoubleInnerBox, curves.bottomLeftPaddingBox);
            case 3:
            default:
                return createPathFromCurves(curves.bottomLeftBorderDoubleInnerBox, curves.bottomLeftPaddingBox, curves.topLeftBorderDoubleInnerBox, curves.topLeftPaddingBox);
        }
    };
    var parsePathForBorderStroke = function (curves, borderSide) {
        switch (borderSide) {
            case 0:
                return createStrokePathFromCurves(curves.topLeftBorderStroke, curves.topRightBorderStroke);
            case 1:
                return createStrokePathFromCurves(curves.topRightBorderStroke, curves.bottomRightBorderStroke);
            case 2:
                return createStrokePathFromCurves(curves.bottomRightBorderStroke, curves.bottomLeftBorderStroke);
            case 3:
            default:
                return createStrokePathFromCurves(curves.bottomLeftBorderStroke, curves.topLeftBorderStroke);
        }
    };
    var createStrokePathFromCurves = function (outer1, outer2) {
        var path = [];
        if (isBezierCurve(outer1)) {
            path.push(outer1.subdivide(0.5, false));
        }
        else {
            path.push(outer1);
        }
        if (isBezierCurve(outer2)) {
            path.push(outer2.subdivide(0.5, true));
        }
        else {
            path.push(outer2);
        }
        return path;
    };
    var createPathFromCurves = function (outer1, inner1, outer2, inner2) {
        var path = [];
        if (isBezierCurve(outer1)) {
            path.push(outer1.subdivide(0.5, false));
        }
        else {
            path.push(outer1);
        }
        if (isBezierCurve(outer2)) {
            path.push(outer2.subdivide(0.5, true));
        }
        else {
            path.push(outer2);
        }
        if (isBezierCurve(inner2)) {
            path.push(inner2.subdivide(0.5, true).reverse());
        }
        else {
            path.push(inner2);
        }
        if (isBezierCurve(inner1)) {
            path.push(inner1.subdivide(0.5, false).reverse());
        }
        else {
            path.push(inner1);
        }
        return path;
    };

    var reversePath = function (paths) {
        var list = [];
        if (paths.length > 0) {
            for (var i = paths.length - 1; i >= 0; i--) {
                var p = paths[i];
                if (isBezierCurve(p)) {
                    var rc = p.reverse();
                    list.push(rc);
                }
                else {
                    list.push(new Vector(p.x, p.y));
                }
            }
        }
        return list;
    };

    var paddingBox = function (element) {
        var bounds = element.bounds;
        var styles = element.styles;
        return bounds.add(styles.borderLeftWidth, styles.borderTopWidth, -(styles.borderRightWidth + styles.borderLeftWidth), -(styles.borderTopWidth + styles.borderBottomWidth));
    };
    var contentBox = function (element) {
        var styles = element.styles;
        var bounds = element.bounds;
        var paddingLeft = getAbsoluteValue(styles.paddingLeft, bounds.width);
        var paddingRight = getAbsoluteValue(styles.paddingRight, bounds.width);
        var paddingTop = getAbsoluteValue(styles.paddingTop, bounds.width);
        var paddingBottom = getAbsoluteValue(styles.paddingBottom, bounds.width);
        return bounds.add(paddingLeft + styles.borderLeftWidth, paddingTop + styles.borderTopWidth, -(styles.borderRightWidth + styles.borderLeftWidth + paddingLeft + paddingRight), -(styles.borderTopWidth + styles.borderBottomWidth + paddingTop + paddingBottom));
    };

    var calculateBackgroundPositioningArea = function (backgroundOrigin, element) {
        if (backgroundOrigin === 0 /* BORDER_BOX */) {
            return element.bounds;
        }
        if (backgroundOrigin === 2 /* CONTENT_BOX */) {
            return contentBox(element);
        }
        return paddingBox(element);
    };
    var calculateBackgroundPaintingArea = function (backgroundClip, element) {
        if (backgroundClip === 0 /* BORDER_BOX */) {
            return element.bounds;
        }
        if (backgroundClip === 2 /* CONTENT_BOX */) {
            return contentBox(element);
        }
        return paddingBox(element);
    };
    var calculateBackgroundRendering = function (container, index, intrinsicSize) {
        var backgroundPositioningArea = calculateBackgroundPositioningArea(getBackgroundValueForIndex(container.styles.backgroundOrigin, index), container);
        var backgroundPaintingArea = calculateBackgroundPaintingArea(getBackgroundValueForIndex(container.styles.backgroundClip, index), container);
        var backgroundImageSize = calculateBackgroundSize(getBackgroundValueForIndex(container.styles.backgroundSize, index), intrinsicSize, backgroundPositioningArea);
        var sizeWidth = backgroundImageSize[0], sizeHeight = backgroundImageSize[1];
        var position = getAbsoluteValueForTuple(getBackgroundValueForIndex(container.styles.backgroundPosition, index), backgroundPositioningArea.width - sizeWidth, backgroundPositioningArea.height - sizeHeight);
        var path = calculateBackgroundRepeatPath(getBackgroundValueForIndex(container.styles.backgroundRepeat, index), position, backgroundImageSize, backgroundPositioningArea, backgroundPaintingArea);
        var offsetX = Math.round(backgroundPositioningArea.left + position[0]);
        var offsetY = Math.round(backgroundPositioningArea.top + position[1]);
        return [path, offsetX, offsetY, sizeWidth, sizeHeight];
    };
    var isAuto = function (token) { return isIdentToken(token) && token.value === BACKGROUND_SIZE.AUTO; };
    var hasIntrinsicValue = function (value) { return typeof value === 'number'; };
    var calculateBackgroundSize = function (size, _a, bounds) {
        var intrinsicWidth = _a[0], intrinsicHeight = _a[1], intrinsicProportion = _a[2];
        var first = size[0], second = size[1];
        if (!first) {
            return [0, 0];
        }
        if (isLengthPercentage(first) && second && isLengthPercentage(second)) {
            return [getAbsoluteValue(first, bounds.width), getAbsoluteValue(second, bounds.height)];
        }
        var hasIntrinsicProportion = hasIntrinsicValue(intrinsicProportion);
        if (isIdentToken(first) && (first.value === BACKGROUND_SIZE.CONTAIN || first.value === BACKGROUND_SIZE.COVER)) {
            if (hasIntrinsicValue(intrinsicProportion)) {
                var targetRatio = bounds.width / bounds.height;
                return targetRatio < intrinsicProportion !== (first.value === BACKGROUND_SIZE.COVER)
                    ? [bounds.width, bounds.width / intrinsicProportion]
                    : [bounds.height * intrinsicProportion, bounds.height];
            }
            return [bounds.width, bounds.height];
        }
        var hasIntrinsicWidth = hasIntrinsicValue(intrinsicWidth);
        var hasIntrinsicHeight = hasIntrinsicValue(intrinsicHeight);
        var hasIntrinsicDimensions = hasIntrinsicWidth || hasIntrinsicHeight;
        // If the background-size is auto or auto auto:
        if (isAuto(first) && (!second || isAuto(second))) {
            // If the image has both horizontal and vertical intrinsic dimensions, it's rendered at that size.
            if (hasIntrinsicWidth && hasIntrinsicHeight) {
                return [intrinsicWidth, intrinsicHeight];
            }
            // If the image has no intrinsic dimensions and has no intrinsic proportions,
            // it's rendered at the size of the background positioning area.
            if (!hasIntrinsicProportion && !hasIntrinsicDimensions) {
                return [bounds.width, bounds.height];
            }
            // TODO If the image has no intrinsic dimensions but has intrinsic proportions, it's rendered as if contain had been specified instead.
            // If the image has only one intrinsic dimension and has intrinsic proportions, it's rendered at the size corresponding to that one dimension.
            // The other dimension is computed using the specified dimension and the intrinsic proportions.
            if (hasIntrinsicDimensions && hasIntrinsicProportion) {
                var width_1 = hasIntrinsicWidth
                    ? intrinsicWidth
                    : intrinsicHeight * intrinsicProportion;
                var height_1 = hasIntrinsicHeight
                    ? intrinsicHeight
                    : intrinsicWidth / intrinsicProportion;
                return [width_1, height_1];
            }
            // If the image has only one intrinsic dimension but has no intrinsic proportions,
            // it's rendered using the specified dimension and the other dimension of the background positioning area.
            var width_2 = hasIntrinsicWidth ? intrinsicWidth : bounds.width;
            var height_2 = hasIntrinsicHeight ? intrinsicHeight : bounds.height;
            return [width_2, height_2];
        }
        // If the image has intrinsic proportions, it's stretched to the specified dimension.
        // The unspecified dimension is computed using the specified dimension and the intrinsic proportions.
        if (hasIntrinsicProportion) {
            var width_3 = 0;
            var height_3 = 0;
            if (isLengthPercentage(first)) {
                width_3 = getAbsoluteValue(first, bounds.width);
            }
            else if (isLengthPercentage(second)) {
                height_3 = getAbsoluteValue(second, bounds.height);
            }
            if (isAuto(first)) {
                width_3 = height_3 * intrinsicProportion;
            }
            else if (!second || isAuto(second)) {
                height_3 = width_3 / intrinsicProportion;
            }
            return [width_3, height_3];
        }
        // If the image has no intrinsic proportions, it's stretched to the specified dimension.
        // The unspecified dimension is computed using the image's corresponding intrinsic dimension,
        // if there is one. If there is no such intrinsic dimension,
        // it becomes the corresponding dimension of the background positioning area.
        var width = null;
        var height = null;
        if (isLengthPercentage(first)) {
            width = getAbsoluteValue(first, bounds.width);
        }
        else if (second && isLengthPercentage(second)) {
            height = getAbsoluteValue(second, bounds.height);
        }
        if (width !== null && (!second || isAuto(second))) {
            height =
                hasIntrinsicWidth && hasIntrinsicHeight
                    ? (width / intrinsicWidth) * intrinsicHeight
                    : bounds.height;
        }
        if (height !== null && isAuto(first)) {
            width =
                hasIntrinsicWidth && hasIntrinsicHeight
                    ? (height / intrinsicHeight) * intrinsicWidth
                    : bounds.width;
        }
        if (width !== null && height !== null) {
            return [width, height];
        }
        throw new Error("Unable to calculate background-size for element");
    };
    var getBackgroundValueForIndex = function (values, index) {
        var value = values[index];
        if (typeof value === 'undefined') {
            return values[0];
        }
        return value;
    };
    var calculateBackgroundRepeatPath = function (repeat, _a, _b, backgroundPositioningArea, backgroundPaintingArea) {
        var x = _a[0], y = _a[1];
        var width = _b[0], height = _b[1];
        switch (repeat) {
            case 2 /* REPEAT_X */:
                return [
                    new Vector(Math.round(backgroundPositioningArea.left), Math.round(backgroundPositioningArea.top + y)),
                    new Vector(Math.round(backgroundPositioningArea.left + backgroundPositioningArea.width), Math.round(backgroundPositioningArea.top + y)),
                    new Vector(Math.round(backgroundPositioningArea.left + backgroundPositioningArea.width), Math.round(height + backgroundPositioningArea.top + y)),
                    new Vector(Math.round(backgroundPositioningArea.left), Math.round(height + backgroundPositioningArea.top + y))
                ];
            case 3 /* REPEAT_Y */:
                return [
                    new Vector(Math.round(backgroundPositioningArea.left + x), Math.round(backgroundPositioningArea.top)),
                    new Vector(Math.round(backgroundPositioningArea.left + x + width), Math.round(backgroundPositioningArea.top)),
                    new Vector(Math.round(backgroundPositioningArea.left + x + width), Math.round(backgroundPositioningArea.height + backgroundPositioningArea.top)),
                    new Vector(Math.round(backgroundPositioningArea.left + x), Math.round(backgroundPositioningArea.height + backgroundPositioningArea.top))
                ];
            case 1 /* NO_REPEAT */:
                return [
                    new Vector(Math.round(backgroundPositioningArea.left + x), Math.round(backgroundPositioningArea.top + y)),
                    new Vector(Math.round(backgroundPositioningArea.left + x + width), Math.round(backgroundPositioningArea.top + y)),
                    new Vector(Math.round(backgroundPositioningArea.left + x + width), Math.round(backgroundPositioningArea.top + y + height)),
                    new Vector(Math.round(backgroundPositioningArea.left + x), Math.round(backgroundPositioningArea.top + y + height))
                ];
            default:
                return [
                    new Vector(Math.round(backgroundPaintingArea.left), Math.round(backgroundPaintingArea.top)),
                    new Vector(Math.round(backgroundPaintingArea.left + backgroundPaintingArea.width), Math.round(backgroundPaintingArea.top)),
                    new Vector(Math.round(backgroundPaintingArea.left + backgroundPaintingArea.width), Math.round(backgroundPaintingArea.height + backgroundPaintingArea.top)),
                    new Vector(Math.round(backgroundPaintingArea.left), Math.round(backgroundPaintingArea.height + backgroundPaintingArea.top))
                ];
        }
    };

    var SMALL_IMAGE = 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7';

    var SAMPLE_TEXT = 'Hidden Text';
    var FontMetrics = /** @class */ (function () {
        function FontMetrics(document) {
            this._data = {};
            this._document = document;
        }
        FontMetrics.prototype.parseMetrics = function (fontFamily, fontSize) {
            var container = this._document.createElement('div');
            var img = this._document.createElement('img');
            var span = this._document.createElement('span');
            var body = this._document.body;
            container.style.visibility = 'hidden';
            container.style.fontFamily = fontFamily;
            container.style.fontSize = fontSize;
            container.style.margin = '0';
            container.style.padding = '0';
            container.style.whiteSpace = 'nowrap';
            body.appendChild(container);
            img.src = SMALL_IMAGE;
            img.width = 1;
            img.height = 1;
            img.style.margin = '0';
            img.style.padding = '0';
            img.style.verticalAlign = 'baseline';
            span.style.fontFamily = fontFamily;
            span.style.fontSize = fontSize;
            span.style.margin = '0';
            span.style.padding = '0';
            span.appendChild(this._document.createTextNode(SAMPLE_TEXT));
            container.appendChild(span);
            container.appendChild(img);
            var baseline = img.offsetTop - span.offsetTop - 5;
            // var baseline = parseInt(getComputedStyle(span,null).lineHeight,10) - 5;
            container.removeChild(span);
            container.appendChild(this._document.createTextNode(SAMPLE_TEXT));
            container.style.lineHeight = 'normal';
            img.style.verticalAlign = 'super';
            var middle = img.offsetTop - container.offsetTop + 2;
            body.removeChild(container);
            return { baseline: baseline, middle: middle };
        };
        FontMetrics.prototype.getMetrics = function (fontFamily, fontSize) {
            var key = fontFamily + " " + fontSize;
            if (typeof this._data[key] === 'undefined') {
                this._data[key] = this.parseMetrics(fontFamily, fontSize);
            }
            return this._data[key];
        };
        return FontMetrics;
    }());

    var Renderer = /** @class */ (function () {
        function Renderer(context, options) {
            this.context = context;
            this.options = options;
        }
        return Renderer;
    }());

    var MASK_OFFSET = 10000;
    var CanvasRenderer = /** @class */ (function (_super) {
        __extends(CanvasRenderer, _super);
        function CanvasRenderer(context, options) {
            var _this = _super.call(this, context, options) || this;
            _this._activeEffects = [];
            _this.canvas = options.canvas ? options.canvas : document.createElement('canvas');
            _this.ctx = _this.canvas.getContext('2d');
            if (!options.canvas) {
                _this.canvas.width = Math.floor(options.width * options.scale);
                _this.canvas.height = Math.floor(options.height * options.scale);
                _this.canvas.style.width = options.width + "px";
                _this.canvas.style.height = options.height + "px";
            }
            _this.fontMetrics = new FontMetrics(document);
            _this.ctx.scale(_this.options.scale, _this.options.scale);
            _this.ctx.translate(-options.x, -options.y);
            _this.ctx.textBaseline = 'bottom';
            _this._activeEffects = [];
            _this.context.logger.debug("Canvas renderer initialized (" + options.width + "x" + options.height + ") with scale " + options.scale);
            return _this;
        }
        CanvasRenderer.prototype.applyEffects = function (effects) {
            var _this = this;
            while (this._activeEffects.length) {
                this.popEffect();
            }
            effects.forEach(function (effect) { return _this.applyEffect(effect); });
        };
        CanvasRenderer.prototype.applyEffect = function (effect) {
            this.ctx.save();
            if (isOpacityEffect(effect)) {
                this.ctx.globalAlpha = effect.opacity;
            }
            if (isTransformEffect(effect)) {
                this.ctx.translate(effect.offsetX, effect.offsetY);
                this.ctx.transform(effect.matrix[0], effect.matrix[1], effect.matrix[2], effect.matrix[3], effect.matrix[4], effect.matrix[5]);
                this.ctx.translate(-effect.offsetX, -effect.offsetY);
            }
            if (isClipEffect(effect)) {
                this.path(effect.path);
                this.ctx.clip();
            }
            this._activeEffects.push(effect);
        };
        CanvasRenderer.prototype.popEffect = function () {
            this._activeEffects.pop();
            this.ctx.restore();
        };
        CanvasRenderer.prototype.renderStack = function (stack, topMaskCurves) {
            var _this = this;
            return __awaiter(this, void 0, void 0, function () {
                var paint, styles, bounds, maskImageUrl, ratio = 1, borderLeft = 0, borderTop = 0, n, curve, maskCurves, pathCurves, pathList, pt0, pt;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            paint = stack.element;
                            bounds = paint.container.bounds || {left: 0, top: 0, width: 100, height: 100};
                            styles = paint.container.styles;
                            if (!styles.isVisible()) return [3 /*break*/, 5];
                            if (paint.container.isHole) {
                                return [3 /*break*/, 5]; // ignore content
                            }
                            if (paint.parent && paint.parent.container.isHole) {
                                return [3 /*break*/, 5]; // ignore content
                            }
                            if (styles.dropShadow && styles.dropShadow.length > 0) {
                                return [4 /*yield*/, this.renderNodeDropShadow(stack.element)];
                            } else {
                                _a.sent();
                                _a.label = 1;
                            }
                        case 1: 
                            ratio = (_this.options.ratio * _this.options.scale);
                            borderLeft = (styles.borderLeftWidth || 0)  * ratio;
                            borderTop = (styles.borderTopWidth || 0)  * ratio;
                            if (styles.webkitMaskImage && styles.webkitMaskImage.length > 0) {
                                if (styles.webkitMaskImage[0].url) {
                                    maskImageUrl = styles.webkitMaskImage[0].url;
                                }
                            }
                            if (maskImageUrl) {
                                return [4, Image2Path.fetchPathFromImage(maskImageUrl, bounds.width, bounds.height)]; // 异步获取image的path数据
                            }
                            else {
                                return [3 /*break*/, 3];
                            }
                        case 2:
                            pathList = _a.sent();
                            if (pathList && pathList.length > 0) {
                                maskCurves = [];
                                for (var p = 0; p < pathList.length; p++) {
                                    pathCurves = [];
                                    curve = pathList[p].curve;
                                    n = curve.n;

                                    pt = new Vector(
                                        curve.c[(n - 1) * 3 + 2].x + bounds.left - borderLeft, 
                                        curve.c[(n - 1) * 3 + 2].y + bounds.top - borderTop
                                    ); 
                                    pathCurves.push(pt);
                                    
                                    for (var i = 0; i < n; i++) {
                                        if (curve.tag[i] === "CORNER") {
                                            pt0 = new Vector(
                                                curve.c[i * 3 + 1].x + bounds.left - borderLeft, 
                                                curve.c[i * 3 + 1].y + bounds.top - borderTop);

                                            pathCurves.push(pt0);

                                            pt = new Vector(
                                                curve.c[i * 3 + 2].x + bounds.left - borderLeft, 
                                                curve.c[i * 3 + 2].y + bounds.top - borderTop);

                                            pathCurves.push(pt);
                                        }
                                        else if (curve.tag[i] === "CURVE") {
                                            pt0 = pt;
                                            pt = new Vector(
                                                curve.c[i * 3 + 2].x + bounds.left - borderLeft, 
                                                curve.c[i * 3 + 2].y + bounds.top - borderTop);

                                            pathCurves.push(new BezierCurve(
                                                pt0,
                                                new Vector(
                                                    curve.c[i * 3 + 0].x + bounds.left - borderLeft, 
                                                    curve.c[i * 3 + 0].y + bounds.top - borderTop),
                                                new Vector(
                                                    curve.c[i * 3 + 1].x + bounds.left - borderLeft, 
                                                    curve.c[i * 3 + 1].y + bounds.top - borderTop),
                                                pt));
                                        }
                                    }
                                    if (pathCurves.length > 0) {
                                        maskCurves.push(pathCurves);
                                    }
                                }
                                paint.maskCurves = maskCurves;
                            }
                            _a.label = 3;
                        case 3:
                            return [4 /*yield*/, this.renderStackContent(stack, paint.maskCurves || topMaskCurves)];
                        case 4:
                            _a.sent();
                            _a.label = 5;
                        case 5: return [2 /*return*/];
                    }
                });
            });
        };
        CanvasRenderer.prototype.renderNode = function (paint, maskCurves) {
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (contains(paint.container.flags, 16 /* DEBUG_RENDER */)) {
                                debugger;
                            }
                            if (!paint.container.styles.isVisible()) return [3 /*break*/, 3];
                            if (paint.container.isHole) {
                                return [3 /*break*/, 3]; // ignore node content 
                            }
                            if (paint.parent && paint.parent.container.isHole) {
                                return [3 /*break*/, 3]; // ignore content
                            }
                            return [4 /*yield*/, this.renderNodeBackgroundAndBorders(paint, maskCurves)];
                        case 1:
                            _a.sent();
                            return [4 /*yield*/, this.renderNodeContent(paint, maskCurves)];
                        case 2:
                            _a.sent();
                            _a.label = 3;
                        case 3: return [2 /*return*/];
                    }
                });
            });
        };
        function isSpecialPunctuation(text) {
            switch (text) {
                case '（':
                case '）':
                case '「':
                case '」':
                case '【':
                case '】':
                    return true;
                default:
                    return false;
            }
        }
        CanvasRenderer.prototype.renderTextWithLetterSpacing = function (text, letterSpacing, baseline, textIsVertical) {
            var _this = this;
            if (textIsVertical) {
                this.ctx.save();
                var textIsAscii = false;
                if (text.text && text.text.match(/[\u0000-\u00ff]/g)) {
                    textIsAscii = true;
                }
                if (textIsAscii || isSpecialPunctuation(text.text)) {
                    this.ctx.translate(text.bounds.left + text.bounds.width / 2, text.bounds.top + text.bounds.height / 2);
                    this.ctx.rotate(Math.PI / 2, Math.PI / 2);
                    this.ctx.fillText(text.text, -text.bounds.height / 2 , -text.bounds.width / 2 + baseline);
                } else {
                    for (var i = 0; i < text.text.length; i++) {
                        var character = text.text[i];
                        var charHeight = baseline + baseline / 8;
                        var newBounds = {
                            left: text.bounds.left,
                            top: text.bounds.top + (charHeight + letterSpacing) * i,
                            width: text.bounds.width,
                            height: charHeight
                        };
                        var size = baseline;
                        switch (character) {
                            case '，':
                            case '。':
                            case '、':
                            case '·':
                            case '“':
                            case '”':
                            case '‘':
                            case '’':
                                size = baseline / 2;
                                newBounds.left += baseline / 2;
                                break;
                            case '？':
                            case '！':
                            case '：':
                            case '；':
                                size = baseline * 3 / 4;
                                newBounds.left += baseline / 2;
                                break;
                            default:
                                ;

                        }
                        this.ctx.fillText(character, newBounds.left, newBounds.top + size);
                    }
                }
                this.ctx.restore();
            } else {
                if (letterSpacing === 0) {
                    this.ctx.fillText(text.text, text.bounds.left, text.bounds.top + baseline);
                }
                else {
                    var letters = segmentGraphemes(text.text);
                    letters.reduce(function (left, letter) {
                        _this.ctx.fillText(letter, left, text.bounds.top + baseline);
                        return left + _this.ctx.measureText(letter).width;
                    }, text.bounds.left);
                }
            }
        };
        CanvasRenderer.prototype.createFontStyle = function (styles) {
            var fontVariant = styles.fontVariant
                .filter(function (variant) { return variant === 'normal' || variant === 'small-caps'; })
                .join('');
            var fontFamily = fixIOSSystemFonts(styles.fontFamily).join(', ');
            var fontSize = isDimensionToken(styles.fontSize)
                ? "" + styles.fontSize.number + styles.fontSize.unit
                : styles.fontSize.number + "px";
            return [
                [styles.fontStyle, fontVariant, styles.fontWeight, fontSize, fontFamily].join(' '),
                fontFamily,
                fontSize
            ];
        };
        CanvasRenderer.prototype.renderTextNode = function (text, styles) {
            return __awaiter(this, void 0, void 0, function () {
                var _a, font, fontFamily, fontSize, _b, baseline, middle, paintOrder,textIsVertical;
                var _this = this;
                return __generator(this, function (_c) {
                    _a = this.createFontStyle(styles), font = _a[0], fontFamily = _a[1], fontSize = _a[2];
                    this.ctx.font = font;
                    this.ctx.direction = styles.direction === 1 /* RTL */ ? 'rtl' : 'ltr';
                    this.ctx.textAlign = 'left';
                    this.ctx.textBaseline = 'alphabetic';
                    _b = this.fontMetrics.getMetrics(fontFamily, fontSize), baseline = _b.baseline, middle = _b.middle;
                    paintOrder = styles.paintOrder;
                    var writingmode = styles.writingMode || 'unset';
                    if (writingmode == 'vertical-lr' || writingmode == 'vertical-rl') {
                        textIsVertical = true;
                    }
                    text.textBounds.forEach(function (text) {
                        paintOrder.forEach(function (paintOrderLayer) {
                            switch (paintOrderLayer) {
                                case 0 /* FILL */:
                                    _this.ctx.fillStyle = asString(styles.color);
                                    _this.renderTextWithLetterSpacing(text, styles.letterSpacing, baseline, textIsVertical);
                                    var textShadows = styles.textShadow;
                                    if (textShadows.length && text.text.trim().length) {
                                        textShadows
                                            .slice(0)
                                            .reverse()
                                            .forEach(function (textShadow) {
                                            _this.ctx.shadowColor = asString(textShadow.color);
                                            _this.ctx.shadowOffsetX = textShadow.offsetX.number * _this.options.scale;
                                            _this.ctx.shadowOffsetY = textShadow.offsetY.number * _this.options.scale;
                                            _this.ctx.shadowBlur = textShadow.blur.number;
                                            _this.renderTextWithLetterSpacing(text, styles.letterSpacing, baseline, textIsVertical);
                                        });
                                        _this.ctx.shadowColor = '';
                                        _this.ctx.shadowOffsetX = 0;
                                        _this.ctx.shadowOffsetY = 0;
                                        _this.ctx.shadowBlur = 0;
                                    }
                                    if (styles.textDecorationLine.length) {
                                        _this.ctx.fillStyle = asString(styles.textDecorationColor || styles.color);
                                        styles.textDecorationLine.forEach(function (textDecorationLine) {
                                            switch (textDecorationLine) {
                                                case 1 /* UNDERLINE */:
                                                    // Draws a line at the baseline of the font
                                                    // TODO As some browsers display the line as more than 1px if the font-size is big,
                                                    // need to take that into account both in position and size
                                                    _this.ctx.fillRect(text.bounds.left, Math.round(text.bounds.top + baseline), text.bounds.width, 1);
                                                    break;
                                                case 2 /* OVERLINE */:
                                                    _this.ctx.fillRect(text.bounds.left, Math.round(text.bounds.top), text.bounds.width, 1);
                                                    break;
                                                case 3 /* LINE_THROUGH */:
                                                    // TODO try and find exact position for line-through
                                                    _this.ctx.fillRect(text.bounds.left, Math.ceil(text.bounds.top + middle), text.bounds.width, 1);
                                                    break;
                                            }
                                        });
                                    }
                                    break;
                                case 1 /* STROKE */:
                                    if (styles.webkitTextStrokeWidth && text.text.trim().length) {
                                        _this.ctx.strokeStyle = asString(styles.webkitTextStrokeColor);
                                        _this.ctx.lineWidth = styles.webkitTextStrokeWidth;
                                        // eslint-disable-next-line @typescript-eslint/no-explicit-any
                                        _this.ctx.lineJoin = !!window.chrome ? 'miter' : 'round';
                                        _this.ctx.strokeText(text.text, text.bounds.left, text.bounds.top + baseline);
                                    }
                                    _this.ctx.strokeStyle = '';
                                    _this.ctx.lineWidth = 0;
                                    _this.ctx.lineJoin = 'miter';
                                    break;
                            }
                        });
                    });
                    return [2 /*return*/];
                });
            });
        };
        CanvasRenderer.prototype.renderReplacedElement = function (container, curves, image, maskCurves) {
            if (image && container.intrinsicWidth > 0 && container.intrinsicHeight > 0) {
                var box = contentBox(container);
                var path;
                if (!maskCurves) {
                    path = calculatePaddingBoxPath(curves);
                    this.path(path);
                } else {
                    path = maskCurves;
                    this.pathList(path);
                }
                this.ctx.save();
                this.ctx.clip();
                this.ctx.drawImage(image, 0, 0, container.intrinsicWidth, container.intrinsicHeight, box.left, box.top, box.width, box.height);
                this.ctx.restore();
            }
        };
        CanvasRenderer.prototype.renderNodeContent = function (paint, maskCurves) {
            return __awaiter(this, void 0, void 0, function () {
                var container, curves, styles, _i, _a, child, image, image, iframeRenderer, canvas, size, _b, fontFamily, fontSize, baseline, bounds, x, textBounds, img, image, url, fontFamily, bounds;
                return __generator(this, function (_c) {
                    switch (_c.label) {
                        case 0:
                            this.applyEffects(paint.getEffects(4 /* CONTENT */));
                            container = paint.container;
                            curves = paint.curves;
                            styles = container.styles;
                            _i = 0, _a = container.textNodes;
                            _c.label = 1;
                        case 1:
                            if (!(_i < _a.length)) return [3 /*break*/, 4];
                            child = _a[_i];
                            return [4 /*yield*/, this.renderTextNode(child, styles)];
                        case 2:
                            _c.sent();
                            _c.label = 3;
                        case 3:
                            _i++;
                            return [3 /*break*/, 1];
                        case 4:
                            if (!(container instanceof ImageElementContainer)) return [3 /*break*/, 8];
                            _c.label = 5;
                        case 5:
                            _c.trys.push([5, 7, , 8]);
                            return [4 /*yield*/, this.context.cache.match(container.src)];
                        case 6:
                            image = _c.sent();
                            this.renderReplacedElement(container, curves, image, maskCurves);
                            return [3 /*break*/, 8];
                        case 7:
                            _c.sent();
                            this.context.logger.error("Error loading image " + container.src);
                            return [3 /*break*/, 8];
                        case 8:
                            if (container instanceof CanvasElementContainer) {
                                this.renderReplacedElement(container, curves, container.canvas);
                            }
                            if (!(container instanceof SVGElementContainer)) return [3 /*break*/, 12];
                            _c.label = 9;
                        case 9:
                            _c.trys.push([9, 11, , 12]);
                            return [4 /*yield*/, this.context.cache.match(container.svg)];
                        case 10:
                            image = _c.sent();
                            this.renderReplacedElement(container, curves, image);
                            return [3 /*break*/, 12];
                        case 11:
                            _c.sent();
                            this.context.logger.error("Error loading svg " + container.svg.substring(0, 255));
                            return [3 /*break*/, 12];
                        case 12:
                            if (!(container instanceof IFrameElementContainer && container.tree)) return [3 /*break*/, 14];
                            iframeRenderer = new CanvasRenderer(this.context, {
                                scale: this.options.scale,
                                backgroundColor: container.backgroundColor,
                                x: 0,
                                y: 0,
                                width: container.width,
                                height: container.height
                            });
                            return [4 /*yield*/, iframeRenderer.render(container.tree)];
                        case 13:
                            canvas = _c.sent();
                            if (container.width && container.height) {
                                this.ctx.drawImage(canvas, 0, 0, container.width, container.height, container.bounds.left, container.bounds.top, container.bounds.width, container.bounds.height);
                            }
                            _c.label = 14;
                        case 14:
                            if (container instanceof InputElementContainer) {
                                size = Math.min(container.bounds.width, container.bounds.height);
                                if (container.type === CHECKBOX) {
                                    if (container.checked) {
                                        this.ctx.save();
                                        this.path([
                                            new Vector(container.bounds.left + size * 0.39363, container.bounds.top + size * 0.79),
                                            new Vector(container.bounds.left + size * 0.16, container.bounds.top + size * 0.5549),
                                            new Vector(container.bounds.left + size * 0.27347, container.bounds.top + size * 0.44071),
                                            new Vector(container.bounds.left + size * 0.39694, container.bounds.top + size * 0.5649),
                                            new Vector(container.bounds.left + size * 0.72983, container.bounds.top + size * 0.23),
                                            new Vector(container.bounds.left + size * 0.84, container.bounds.top + size * 0.34085),
                                            new Vector(container.bounds.left + size * 0.39363, container.bounds.top + size * 0.79)
                                        ]);
                                        this.ctx.fillStyle = asString(INPUT_COLOR);
                                        this.ctx.fill();
                                        this.ctx.restore();
                                    }
                                }
                                else if (container.type === RADIO) {
                                    if (container.checked) {
                                        this.ctx.save();
                                        this.ctx.beginPath();
                                        this.ctx.arc(container.bounds.left + size / 2, container.bounds.top + size / 2, size / 4, 0, Math.PI * 2, true);
                                        this.ctx.fillStyle = asString(INPUT_COLOR);
                                        this.ctx.fill();
                                        this.ctx.restore();
                                    }
                                }
                            }
                            if (isTextInputElement(container) && container.value.length) {
                                _b = this.createFontStyle(styles), fontFamily = _b[0], fontSize = _b[1];
                                baseline = this.fontMetrics.getMetrics(fontFamily, fontSize).baseline;
                                this.ctx.font = fontFamily;
                                this.ctx.fillStyle = asString(styles.color);
                                this.ctx.textBaseline = 'alphabetic';
                                this.ctx.textAlign = canvasTextAlign(container.styles.textAlign);
                                bounds = contentBox(container);
                                x = 0;
                                switch (container.styles.textAlign) {
                                    case 1 /* CENTER */:
                                        x += bounds.width / 2;
                                        break;
                                    case 2 /* RIGHT */:
                                        x += bounds.width;
                                        break;
                                }
                                textBounds = bounds.add(x, 0, 0, -bounds.height / 2 + 1);
                                this.ctx.save();
                                this.path([
                                    new Vector(bounds.left, bounds.top),
                                    new Vector(bounds.left + bounds.width, bounds.top),
                                    new Vector(bounds.left + bounds.width, bounds.top + bounds.height),
                                    new Vector(bounds.left, bounds.top + bounds.height)
                                ]);
                                this.ctx.clip();
                                this.renderTextWithLetterSpacing(new TextBounds(container.value, textBounds), styles.letterSpacing, baseline);
                                this.ctx.restore();
                                this.ctx.textBaseline = 'alphabetic';
                                this.ctx.textAlign = 'left';
                            }
                            if (!contains(container.styles.display, 2048 /* LIST_ITEM */)) return [3 /*break*/, 20];
                            if (!(container.styles.listStyleImage !== null)) return [3 /*break*/, 19];
                            img = container.styles.listStyleImage;
                            if (!(img.type === 0 /* URL */)) return [3 /*break*/, 18];
                            image = void 0;
                            url = img.url;
                            _c.label = 15;
                        case 15:
                            _c.trys.push([15, 17, , 18]);
                            return [4 /*yield*/, this.context.cache.match(url)];
                        case 16:
                            image = _c.sent();
                            this.ctx.drawImage(image, container.bounds.left - (image.width + 10), container.bounds.top);
                            return [3 /*break*/, 18];
                        case 17:
                            _c.sent();
                            this.context.logger.error("Error loading list-style-image " + url);
                            return [3 /*break*/, 18];
                        case 18: return [3 /*break*/, 20];
                        case 19:
                            if (paint.listValue && container.styles.listStyleType !== -1 /* NONE */) {
                                fontFamily = this.createFontStyle(styles)[0];
                                this.ctx.font = fontFamily;
                                this.ctx.fillStyle = asString(styles.color);
                                this.ctx.textBaseline = 'middle';
                                this.ctx.textAlign = 'right';
                                bounds = new Bounds(container.bounds.left, container.bounds.top + getAbsoluteValue(container.styles.paddingTop, container.bounds.width), container.bounds.width, computeLineHeight(styles.lineHeight, styles.fontSize.number) / 2 + 1);
                                this.renderTextWithLetterSpacing(new TextBounds(paint.listValue, bounds), styles.letterSpacing, computeLineHeight(styles.lineHeight, styles.fontSize.number) / 2 + 2);
                                this.ctx.textBaseline = 'bottom';
                                this.ctx.textAlign = 'left';
                            }
                            _c.label = 20;
                        case 20: return [2 /*return*/];
                    }
                });
            });
        };
        var getImageContainer = function (container) {
            if (!container) {
                return null;
            }
            if (container instanceof ImageElementContainer && container.src) {
                return container;
            }
            for (var i = 0; i < container.elements.length; i++) {
                var element = container.elements[i];
                if (element) {
                    var c = getImageContainer(element);
                    if (c) {
                        return c;
                    }
                }
            }
            return null;
        }
        var getMaskImage = function (container) {
            if (!container) {
                return null;
            }
            if (container.styles && container.styles.webkitMaskImage && container.styles.webkitMaskImage.length > 0) {
                return container.styles.webkitMaskImage[0].url;
            }
            if (container instanceof ImageElementContainer && container.src) {
                if (container.src.startsWith("blob:http")) {
                    return container.src;
                }
            }
            for (var i = 0; i < container.elements.length; i++) {
                var element = container.elements[i];
                if (element) {
                    var c = getMaskImage(element);
                    if (c) {
                        return c;
                    }
                }
            }
            return null;
        }
        CanvasRenderer.prototype.renderNodeDropShadow = function (paint) {
            var _this = this;
            return __awaiter(this, void 0, void 0, function () {
                var styles, container, bounds, ratio, maskOffset = 0, borderBoxArea, shadowPaintingArea, shadow, pathList, imageContainer, imageUrl, n, curve, path_ready = false, borderLeft = 0, borderTop = 0, canvasOffsetX = 0, canvasOffsetY = 0;
                canvasOffsetX = -_this.canvas.width;
                canvasOffsetY = -_this.canvas.height;
                return __generator(this, function (_p) {
                    switch (_p.label) {
                        case 0:
                            // console.log("renderNodeDropShadow: label=0");
                            container = paint.container;
                            bounds = container.bounds || {left: 0, top: 0, width: 100, height: 100};
                            styles = container.styles;
                            if (!styles || !styles.dropShadow || styles.dropShadow.length == 0) {
                                return [3, 3]; // 结束
                            }
                            shadow = styles.dropShadow[0];
                            if (!shadow || !(
                                (shadow.offsetX && Math.abs(shadow.offsetX.number) > 0) || 
                                (shadow.offsetY && Math.abs(shadow.offsetY.number) > 0) || 
                                (shadow.blur && shadow.blur.number > 0)
                            )) {
                                return [3, 3]; // 结束
                            }

                            // * test client *
                            // _this.ctx.beginPath();
                            // _this.ctx.moveTo(canvasOffsetX, canvasOffsetY);
                            // _this.ctx.lineTo(canvasOffsetX + _this.canvas.width, canvasOffsetY);
                            // _this.ctx.lineTo(canvasOffsetX + _this.canvas.width, canvasOffsetY + _this.canvas.height);
                            // _this.ctx.lineTo(canvasOffsetX, canvasOffsetY + _this.canvas.height);
                            // _this.ctx.lineTo(canvasOffsetX, canvasOffsetY);
                            // _this.ctx.fillStyle = 'red';
                            // _this.ctx.fill();


                            _this.ctx.save();
                            
                            ratio = (_this.options.ratio * _this.options.scale);
                            borderLeft = (styles.borderLeftWidth || 0)  * ratio;
                            borderTop = (styles.borderTopWidth || 0)  * ratio;
                            borderBoxArea = calculateBorderBoxPath(paint.curves);
                            maskOffset = 0; //MASK_OFFSET;
                            shadowPaintingArea = transformPath(borderBoxArea, -maskOffset, 0, 0, 0);
                            imageUrl = getMaskImage(paint.container);
                            if (imageUrl) {
                                return [4, Image2Path.fetchPathFromImage(imageUrl, bounds.width, bounds.height)]; // 异步获取image的path数据
                            } else {

                                return [3, 2]; // 跳转到step-2, 根据box形状画阴影
                            }
                                
                        case 1:
                            // console.log("renderNodeDropShadow: label=1");
                            pathList = _p.sent();
                            if (pathList && pathList.length > 0) {
                                _this.ctx.beginPath();
                                _this.ctx.moveTo(canvasOffsetX, canvasOffsetY);
                                _this.ctx.lineTo(_this.canvas.width - canvasOffsetX, canvasOffsetY);
                                _this.ctx.lineTo(_this.canvas.width - canvasOffsetX, _this.canvas.height - canvasOffsetY);
                                _this.ctx.lineTo(canvasOffsetX, _this.canvas.height - canvasOffsetY);
                                _this.ctx.lineTo(canvasOffsetX, canvasOffsetY);
                                for (var p = 0; p < pathList.length; p++) {
                                    curve = pathList[p].curve;
                                    n = curve.n;

                                    _this.ctx.moveTo(
                                        curve.c[(n - 1) * 3 + 2].x + bounds.left - borderLeft, 
                                        curve.c[(n - 1) * 3 + 2].y + bounds.top - borderTop);
                                    for (var i = 0; i < n; i++) {
                                        if (curve.tag[i] === "CORNER") {
                                            _this.ctx.lineTo(
                                                curve.c[i * 3 + 1].x + bounds.left - borderLeft, 
                                                curve.c[i * 3 + 1].y + bounds.top - borderTop);
                                            _this.ctx.lineTo(
                                                curve.c[i * 3 + 2].x + bounds.left - borderLeft, 
                                                curve.c[i * 3 + 2].y + bounds.top - borderTop);
                                        }
                                        else if (curve.tag[i] === "CURVE") {
                                            _this.ctx.bezierCurveTo(
                                                curve.c[i * 3 + 0].x + bounds.left - borderLeft, 
                                                curve.c[i * 3 + 0].y + bounds.top - borderTop,
                                                curve.c[i * 3 + 1].x + bounds.left - borderLeft, 
                                                curve.c[i * 3 + 1].y + bounds.top - borderTop,
                                                curve.c[i * 3 + 2].x + bounds.left - borderLeft, 
                                                curve.c[i * 3 + 2].y + bounds.top - borderTop);
                                        }
                                    }
                                }
                                _this.ctx.clip('evenodd');

                                _this.ctx.beginPath();
                                for (var p = 0; p < pathList.length; p++) {
                                    curve = pathList[p].curve;
                                    n = curve.n;

                                    _this.ctx.moveTo(
                                        curve.c[(n - 1) * 3 + 2].x + bounds.left - borderLeft, 
                                        curve.c[(n - 1) * 3 + 2].y + bounds.top - borderTop);
                                    for (var i = 0; i < n; i++) {
                                        if (curve.tag[i] === "CORNER") {
                                            _this.ctx.lineTo(
                                                curve.c[i * 3 + 1].x + bounds.left - borderLeft, 
                                                curve.c[i * 3 + 1].y + bounds.top - borderTop);
                                            _this.ctx.lineTo(
                                                curve.c[i * 3 + 2].x + bounds.left - borderLeft, 
                                                curve.c[i * 3 + 2].y + bounds.top - borderTop);
                                        }
                                        else if (curve.tag[i] === "CURVE") {
                                            _this.ctx.bezierCurveTo(
                                                curve.c[i * 3 + 0].x + bounds.left - borderLeft, 
                                                curve.c[i * 3 + 0].y + bounds.top - borderTop,
                                                curve.c[i * 3 + 1].x + bounds.left - borderLeft, 
                                                curve.c[i * 3 + 1].y + bounds.top - borderTop,
                                                curve.c[i * 3 + 2].x + bounds.left - borderLeft, 
                                                curve.c[i * 3 + 2].y + bounds.top - borderTop);
                                        }
                                    }
                                }
                                _this.ctx.closePath();
                                path_ready = true;
                            }
                            _p.label = 2;
                        case 2:
                            // console.log("renderNodeDropShadow: label=2");
                            if (!path_ready) {
                                _this.mask2(borderBoxArea);
                                _this.ctx.clip("evenodd");
                                _this.path2(shadowPaintingArea);
                            }
                            _this.ctx.shadowOffsetX = (ratio * shadow.offsetX.number) + maskOffset;
                            _this.ctx.shadowOffsetY = (ratio * shadow.offsetY.number);
                            _this.ctx.shadowColor = asString(shadow.color);
                            _this.ctx.shadowBlur = ratio * shadow.blur.number * 2;
                            _this.ctx.fillStyle = asString(shadow.color); //asString(shadow.color);
                            _this.ctx.fill();
                            _this.ctx.restore();
                            _p.sent();
                            _p.label = 3;
                        case 3:
                            return [2 /*return*/];
                    }
                });
            });
        }
        CanvasRenderer.prototype.renderStackContent = function (stack, maskCurves) {
            var _this = this;
            return __awaiter(this, void 0, void 0, function () {
                var _i, _a, child, _b, _c, child, _d, _e, child, _f, _g, child, _h, _j, child, _k, _l, child, _m, _o, child;
                var stackMaskCurves;
                return __generator(this, function (_p) {
                    switch (_p.label) {
                        case 0:
                            if (contains(stack.element.container.flags, 16 /* DEBUG_RENDER */)) {
                                debugger;
                            }
                            // https://www.w3.org/TR/css-position-3/#painting-order
                            // 1. the background and borders of the element forming the stacking context.
                            return [4 /*yield*/, this.renderNodeBackgroundAndBorders(stack.element, maskCurves)];
                        case 1:
                            // https://www.w3.org/TR/css-position-3/#painting-order
                            // 1. the background and borders of the element forming the stacking context.
                            _p.sent();
                            _i = 0, _a = stack.negativeZIndex;
                            _p.label = 2;
                        case 2:
                            if (!(_i < _a.length)) return [3 /*break*/, 5];
                            child = _a[_i];
                            return [4 /*yield*/, this.renderStack(child)];
                        case 3:
                            _p.sent();
                            _p.label = 4;
                        case 4:
                            _i++;
                            return [3 /*break*/, 2];
                        case 5: 
                        // 3. For all its in-flow, non-positioned, block-level descendants in tree order:
                        return [4 /*yield*/, this.renderNodeContent(stack.element, maskCurves)];
                        case 6:
                            // 3. For all its in-flow, non-positioned, block-level descendants in tree order:
                            _p.sent();
                            _b = 0, _c = stack.nonInlineLevel;
                            _p.label = 7;
                        case 7:
                            if (!(_b < _c.length)) return [3 /*break*/, 10];
                            child = _c[_b];
                            return [4 /*yield*/, this.renderNode(child, maskCurves)];
                        case 8:
                            _p.sent();
                            _p.label = 9;
                        case 9:
                            _b++;
                            return [3 /*break*/, 7];
                        case 10:
                            _d = 0, _e = stack.nonPositionedFloats;
                            _p.label = 11;
                        case 11:
                            if (!(_d < _e.length)) return [3 /*break*/, 14];
                            child = _e[_d];
                            return [4 /*yield*/, this.renderStack(child)];
                        case 12:
                            _p.sent();
                            _p.label = 13;
                        case 13:
                            _d++;
                            return [3 /*break*/, 11];
                        case 14:
                            _f = 0, _g = stack.nonPositionedInlineLevel;
                            _p.label = 15;
                        case 15:
                            if (!(_f < _g.length)) return [3 /*break*/, 18];
                            child = _g[_f];
                            return [4 /*yield*/, this.renderStack(child)];
                        case 16:
                            _p.sent();
                            _p.label = 17;
                        case 17:
                            _f++;
                            return [3 /*break*/, 15];
                        case 18:
                            _h = 0, _j = stack.inlineLevel;
                            _p.label = 19;
                        case 19:
                            if (!(_h < _j.length)) return [3 /*break*/, 22];
                            child = _j[_h];
                            return [4 /*yield*/, this.renderNode(child, maskCurves)];
                        case 20:
                            _p.sent();
                            _p.label = 21;
                        case 21:
                            _h++;
                            return [3 /*break*/, 19];
                        case 22:
                            _k = 0, _l = stack.zeroOrAutoZIndexOrTransformedOrOpacity;
                            stackMaskCurves = null;
                            _p.label = 23;
                        case 23:
                            if (!(_k < _l.length)) return [3 /*break*/, 26];
                            child = _l[_k];
                            return [4 /*yield*/, this.renderStack(child, stackMaskCurves || maskCurves)];
                        case 24:
                            _p.sent();
                            if (child.element.maskCurves && child.element.maskCurves.length) {
                                stackMaskCurves = child.element.maskCurves;
                            }
                            _p.label = 25;
                        case 25:
                            _k++;
                            return [3 /*break*/, 23];
                        case 26:
                            _m = 0, _o = stack.positiveZIndex;
                            stackMaskCurves = null;
                            _p.label = 27;
                        case 27:
                            if (!(_m < _o.length)) return [3 /*break*/, 30];
                            child = _o[_m];
                            return [4 /*yield*/, this.renderStack(child, stackMaskCurves || maskCurves)];
                        case 28:
                            _p.sent();
                            if (child.element.maskCurves && child.element.maskCurves.length) {
                                stackMaskCurves = child.element.maskCurves;
                            }
                            _p.label = 29;
                        case 29:
                            _m++;
                            return [3 /*break*/, 27];
                        case 30: return [2 /*return*/];
                    }
                });
            });
        };
        CanvasRenderer.prototype.mask = function (paths) {
            this.ctx.beginPath();
            this.ctx.moveTo(0, 0);
            this.ctx.lineTo(this.canvas.width, 0);
            this.ctx.lineTo(this.canvas.width, this.canvas.height);
            this.ctx.lineTo(0, this.canvas.height);
            this.ctx.lineTo(0, 0);
            this.formatPath(reversePath(paths.slice(0)));
            this.ctx.closePath();
        };
        CanvasRenderer.prototype.mask2 = function (paths) {
            var offsetX = -this.canvas.width;
            var offsetY = -this.canvas.height;
            this.ctx.beginPath();
            this.ctx.moveTo(offsetX, offsetY);
            this.ctx.lineTo(this.canvas.width - offsetX , offsetY);
            this.ctx.lineTo(this.canvas.width - offsetX, this.canvas.height - offsetY);
            this.ctx.lineTo(offsetX, this.canvas.height - offsetY);
            this.ctx.lineTo(offsetX, offsetY);
            this.formatPath(reversePath(paths.slice(0)));
            this.ctx.closePath();
        };

        CanvasRenderer.prototype.pathHole = function(paths, holes) {
            this.ctx.beginPath();
            this.formatPath(paths);
            if (holes) {
                this.formatPath(reversePath(holes));
            }
            this.ctx.closePath();
        }

        CanvasRenderer.prototype.path = function (paths) {
            this.ctx.beginPath();
            this.formatPath(paths);
            this.ctx.closePath();
        };
        CanvasRenderer.prototype.path2 = function (paths) {
            this.ctx.beginPath();
            this.formatPath(paths);
            this.ctx.closePath();
        };

        CanvasRenderer.prototype.pathList = function (paths) {
            this.ctx.beginPath();
            for (var i = 0; i < paths.length; i++) {
                this.formatPath(paths[i]);
                this.ctx.closePath();
            }
        };

        CanvasRenderer.prototype.formatPath = function (paths) {
            var _this = this;
            paths.forEach(function (point, index) {
                var start = isBezierCurve(point) ? point.start : point;
                if (index === 0) {
                    _this.ctx.moveTo(start.x, start.y);
                }
                else {
                    _this.ctx.lineTo(start.x, start.y);
                }
                if (isBezierCurve(point)) {
                    _this.ctx.bezierCurveTo(point.startControl.x, point.startControl.y, point.endControl.x, point.endControl.y, point.end.x, point.end.y);
                }
            });
        };
        CanvasRenderer.prototype.renderRepeat = function (path, pattern, offsetX, offsetY) {
            this.path(path);
            this.ctx.fillStyle = pattern;
            this.ctx.translate(offsetX, offsetY);
            this.ctx.fill();
            this.ctx.translate(-offsetX, -offsetY);
        };
        CanvasRenderer.prototype.resizeImage = function (image, width, height) {
            var _a;
            if (image.width === width && image.height === height) {
                return image;
            }
            var ownerDocument = (_a = this.canvas.ownerDocument) !== null && _a !== void 0 ? _a : document;
            var canvas = ownerDocument.createElement('canvas');
            canvas.width = Math.max(1, width);
            canvas.height = Math.max(1, height);
            var ctx = canvas.getContext('2d');
            ctx.drawImage(image, 0, 0, image.width, image.height, 0, 0, width, height);
            return canvas;
        };
        CanvasRenderer.prototype.renderBackgroundImage = function (container) {
            return __awaiter(this, void 0, void 0, function () {
                var index, _loop_1, this_1, _i, _a, backgroundImage;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            index = container.styles.backgroundImage.length - 1;
                            _loop_1 = function (backgroundImage) {
                                var image, url, _c, path, x, y, width, height, pattern, _d, path, x, y, width, height, _e, lineLength, x0, x1, y0, y1, canvas, ctx, gradient_1, pattern, _f, path, left, top_1, width, height, position, x, y, _g, rx, ry, radialGradient_1, midX, midY, f, invF;
                                return __generator(this, function (_h) {
                                    switch (_h.label) {
                                        case 0:
                                            if (!(backgroundImage.type === 0 /* URL */)) return [3 /*break*/, 5];
                                            image = void 0;
                                            url = backgroundImage.url;
                                            _h.label = 1;
                                        case 1:
                                            _h.trys.push([1, 3, , 4]);
                                            return [4 /*yield*/, this_1.context.cache.match(url)];
                                        case 2:
                                            image = _h.sent();
                                            return [3 /*break*/, 4];
                                        case 3:
                                            _h.sent();
                                            this_1.context.logger.error("Error loading background-image " + url);
                                            return [3 /*break*/, 4];
                                        case 4:
                                            if (image) {
                                                _c = calculateBackgroundRendering(container, index, [
                                                    image.width,
                                                    image.height,
                                                    image.width / image.height
                                                ]), path = _c[0], x = _c[1], y = _c[2], width = _c[3], height = _c[4];
                                                pattern = this_1.ctx.createPattern(this_1.resizeImage(image, width, height), 'repeat');
                                                this_1.renderRepeat(path, pattern, x, y);
                                            }
                                            return [3 /*break*/, 6];
                                        case 5:
                                            if (isLinearGradient(backgroundImage)) {
                                                _d = calculateBackgroundRendering(container, index, [null, null, null]), path = _d[0], x = _d[1], y = _d[2], width = _d[3], height = _d[4];
                                                _e = calculateGradientDirection(backgroundImage.angle, width, height), lineLength = _e[0], x0 = _e[1], x1 = _e[2], y0 = _e[3], y1 = _e[4];
                                                canvas = document.createElement('canvas');
                                                canvas.width = width;
                                                canvas.height = height;
                                                ctx = canvas.getContext('2d');
                                                gradient_1 = ctx.createLinearGradient(x0, y0, x1, y1);
                                                processColorStops(backgroundImage.stops, lineLength).forEach(function (colorStop) {
                                                    return gradient_1.addColorStop(colorStop.stop, asString(colorStop.color));
                                                });
                                                ctx.fillStyle = gradient_1;
                                                ctx.fillRect(0, 0, width, height);
                                                if (width > 0 && height > 0) {
                                                    pattern = this_1.ctx.createPattern(canvas, 'repeat');
                                                    this_1.renderRepeat(path, pattern, x, y);
                                                }
                                            }
                                            else if (isRadialGradient(backgroundImage)) {
                                                _f = calculateBackgroundRendering(container, index, [
                                                    null,
                                                    null,
                                                    null
                                                ]), path = _f[0], left = _f[1], top_1 = _f[2], width = _f[3], height = _f[4];
                                                position = backgroundImage.position.length === 0 ? [FIFTY_PERCENT] : backgroundImage.position;
                                                x = getAbsoluteValue(position[0], width);
                                                y = getAbsoluteValue(position[position.length - 1], height);
                                                _g = calculateRadius(backgroundImage, x, y, width, height), rx = _g[0], ry = _g[1];
                                                if (rx > 0 && ry > 0) {
                                                    radialGradient_1 = this_1.ctx.createRadialGradient(left + x, top_1 + y, 0, left + x, top_1 + y, rx);
                                                    processColorStops(backgroundImage.stops, rx * 2).forEach(function (colorStop) {
                                                        return radialGradient_1.addColorStop(colorStop.stop, asString(colorStop.color));
                                                    });
                                                    this_1.path(path);
                                                    this_1.ctx.fillStyle = radialGradient_1;
                                                    if (rx !== ry) {
                                                        midX = container.bounds.left + 0.5 * container.bounds.width;
                                                        midY = container.bounds.top + 0.5 * container.bounds.height;
                                                        f = ry / rx;
                                                        invF = 1 / f;
                                                        this_1.ctx.save();
                                                        this_1.ctx.translate(midX, midY);
                                                        this_1.ctx.transform(1, 0, 0, f, 0, 0);
                                                        this_1.ctx.translate(-midX, -midY);
                                                        this_1.ctx.fillRect(left, invF * (top_1 - midY) + midY, width, height * invF);
                                                        this_1.ctx.restore();
                                                    }
                                                    else {
                                                        this_1.ctx.fill();
                                                    }
                                                }
                                            }
                                            _h.label = 6;
                                        case 6:
                                            index--;
                                            return [2 /*return*/];
                                    }
                                });
                            };
                            this_1 = this;
                            _i = 0, _a = container.styles.backgroundImage.slice(0).reverse();
                            _b.label = 1;
                        case 1:
                            if (!(_i < _a.length)) return [3 /*break*/, 4];
                            backgroundImage = _a[_i];
                            return [5 /*yield**/, _loop_1(backgroundImage)];
                        case 2:
                            _b.sent();
                            _b.label = 3;
                        case 3:
                            _i++;
                            return [3 /*break*/, 1];
                        case 4: return [2 /*return*/];
                    }
                });
            });
        };
        CanvasRenderer.prototype.renderSolidBorder = function (color, side, curvePoints) {
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    this.ctx.save();
                    this.path(parsePathForBorder(curvePoints, side));
                    this.ctx.fillStyle = asString(color);
                    this.ctx.fill();

                    //var oldLineWidth = this.ctx.lineWidth;
                    //var oldStrokeStyle = this.ctx.strokeStyle;
                    this.ctx.lineWidth = 2;
                    this.ctx.strokeStyle = asString(color);
                    this.ctx.stroke();
                    //this.ctx.lineWidth = oldLineWidth;
                    //this.ctx.strokeStyle = oldStrokeStyle;
                    this.ctx.restore();
                    return [2 /*return*/];
                });
            });
        };
        CanvasRenderer.prototype.renderDoubleBorder = function (color, width, side, curvePoints) {
            return __awaiter(this, void 0, void 0, function () {
                var outerPaths, innerPaths;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (!(width < 3)) return [3 /*break*/, 2];
                            return [4 /*yield*/, this.renderSolidBorder(color, side, curvePoints)];
                        case 1:
                            _a.sent();
                            return [2 /*return*/];
                        case 2:
                            this.ctx.save();
                            outerPaths = parsePathForBorderDoubleOuter(curvePoints, side);
                            this.path(outerPaths);
                            this.ctx.fillStyle = asString(color);
                            this.ctx.fill();
                            innerPaths = parsePathForBorderDoubleInner(curvePoints, side);
                            this.path(innerPaths);
                            this.ctx.fill();
                            this.ctx.restore();
                            return [2 /*return*/];
                    }
                });
            });
        };
        CanvasRenderer.prototype.renderNodeBackgroundAndBorders = function (paint, maskCurves) {
            return __awaiter(this, void 0, void 0, function () {
                var styles, hasBackground, borders, backgroundPaintingArea, side, _i, borders_1, border, holeBorderBoxPath;
                var _this = this;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            this.applyEffects(paint.getEffects(2 /* BACKGROUND_BORDERS */));
                            styles = paint.container.styles;
                            hasBackground = !isTransparent(styles.backgroundColor) || styles.backgroundImage.length;
                            borders = [
                                { style: styles.borderTopStyle, color: styles.borderTopColor, width: styles.borderTopWidth },
                                { style: styles.borderRightStyle, color: styles.borderRightColor, width: styles.borderRightWidth },
                                { style: styles.borderBottomStyle, color: styles.borderBottomColor, width: styles.borderBottomWidth },
                                { style: styles.borderLeftStyle, color: styles.borderLeftColor, width: styles.borderLeftWidth }
                            ];
                            backgroundPaintingArea = calculateBackgroundCurvedPaintingArea(getBackgroundValueForIndex(styles.backgroundClip, 0), paint.curves);
                            if (!(hasBackground || styles.boxShadow.length)) return [3 /*break*/, 2];
                            this.ctx.save();

                            if (maskCurves) {
                                this.pathList(maskCurves);
                            }
                            else if (paint.container.holeCurves) {
                                holeBorderBoxPath = calculateBorderBoxPath(paint.container.holeCurves);
                                this.pathHole(backgroundPaintingArea, holeBorderBoxPath);
                            } else {
                                this.path(backgroundPaintingArea);
                            }
                            this.ctx.clip();
                            if (!isTransparent(styles.backgroundColor)) {
                                this.ctx.fillStyle = asString(styles.backgroundColor);
                                this.ctx.fill();
                            }
                            return [4 /*yield*/, this.renderBackgroundImage(paint.container)];
                        case 1:
                            _a.sent();
                            this.ctx.restore();
                            styles.boxShadow
                                .slice(0)
                                .reverse()
                                .forEach(function (shadow) {
                                    if ((shadow.offsetX && Math.abs(shadow.offsetX.number) > 0) || (shadow.offsetY && Math.abs(shadow.offsetY.number) > 0) || (shadow.blur && shadow.blur.number > 0)) {
                                        _this.ctx.save();
                                        var borderBoxArea = calculateBorderBoxPath(paint.curves);
                                        var maskOffset = shadow.inset ? 0 : MASK_OFFSET;
                                        var shadowPaintingArea = transformPath(borderBoxArea, -maskOffset + (shadow.inset ? 1 : -1) * shadow.spread.number, (shadow.inset ? 1 : -1) * shadow.spread.number, shadow.spread.number * (shadow.inset ? -2 : 2), shadow.spread.number * (shadow.inset ? -2 : 2));
                                        if (shadow.inset) {
                                            _this.path2(borderBoxArea);
                                            _this.ctx.clip();
                                            _this.mask2(shadowPaintingArea);
                                        }
                                        else {
                                            _this.mask2(borderBoxArea);
                                            _this.ctx.clip();
                                            _this.path2(shadowPaintingArea);
                                        }
                                        _this.ctx.shadowOffsetX = shadow.offsetX.number + maskOffset;
                                        _this.ctx.shadowOffsetY = shadow.offsetY.number;
                                        _this.ctx.shadowColor = asString(shadow.color);
                                        _this.ctx.shadowBlur = shadow.blur.number;
                                        _this.ctx.fillStyle = shadow.inset ? asString(shadow.color) : 'rgba(0,0,0,1)';
                                        _this.ctx.fill();
                                        _this.ctx.restore();
                                    }
                            });
                            _a.label = 2;
                        case 2:
                            side = 0;
                            _i = 0, borders_1 = borders;
                            _a.label = 3;
                        case 3:
                            if (!(_i < borders_1.length)) return [3 /*break*/, 13];
                            border = borders_1[_i];
                            if (!(border.style !== 0 /* NONE */ && !isTransparent(border.color) && border.width > 0)) return [3 /*break*/, 11];
                            if (!(border.style === 2 /* DASHED */)) return [3 /*break*/, 5];
                            return [4 /*yield*/, this.renderDashedDottedBorder(border.color, border.width, side, paint.curves, 2 /* DASHED */)];
                        case 4:
                            _a.sent();
                            return [3 /*break*/, 11];
                        case 5:
                            if (!(border.style === 3 /* DOTTED */)) return [3 /*break*/, 7];
                            return [4 /*yield*/, this.renderDashedDottedBorder(border.color, border.width, side, paint.curves, 3 /* DOTTED */)];
                        case 6:
                            _a.sent();
                            return [3 /*break*/, 11];
                        case 7:
                            if (!(border.style === 4 /* DOUBLE */)) return [3 /*break*/, 9];
                            return [4 /*yield*/, this.renderDoubleBorder(border.color, border.width, side, paint.curves)];
                        case 8:
                            _a.sent();
                            return [3 /*break*/, 11];
                        case 9: return [4 /*yield*/, this.renderSolidBorder(border.color, side, paint.curves)];
                        case 10:
                            _a.sent();
                            _a.label = 11;
                        case 11:
                            side++;
                            _a.label = 12;
                        case 12:
                            _i++;
                            return [3 /*break*/, 3];
                        case 13: return [2 /*return*/];
                    }
                });
            });
        };
        CanvasRenderer.prototype.renderDashedDottedBorder = function (color, width, side, curvePoints, style) {
            return __awaiter(this, void 0, void 0, function () {
                var strokePaths, boxPaths, startX, startY, endX, endY, length, dashLength, spaceLength, useLineDash, multiplier, numberOfDashes, minSpace, maxSpace, path1, path2, path1, path2;
                return __generator(this, function (_a) {
                    this.ctx.save();
                    strokePaths = parsePathForBorderStroke(curvePoints, side);
                    boxPaths = parsePathForBorder(curvePoints, side);
                    if (style === 2 /* DASHED */) {
                        this.path(boxPaths);
                        this.ctx.clip();
                    }
                    if (isBezierCurve(boxPaths[0])) {
                        startX = boxPaths[0].start.x;
                        startY = boxPaths[0].start.y;
                    }
                    else {
                        startX = boxPaths[0].x;
                        startY = boxPaths[0].y;
                    }
                    if (isBezierCurve(boxPaths[1])) {
                        endX = boxPaths[1].end.x;
                        endY = boxPaths[1].end.y;
                    }
                    else {
                        endX = boxPaths[1].x;
                        endY = boxPaths[1].y;
                    }
                    if (side === 0 || side === 2) {
                        length = Math.abs(startX - endX);
                    }
                    else {
                        length = Math.abs(startY - endY);
                    }
                    this.ctx.beginPath();
                    if (style === 3 /* DOTTED */) {
                        this.formatPath(strokePaths);
                    }
                    else {
                        this.formatPath(boxPaths.slice(0, 2));
                    }
                    dashLength = width < 3 ? width * 3 : width * 2;
                    spaceLength = width < 3 ? width * 2 : width;
                    if (style === 3 /* DOTTED */) {
                        dashLength = width;
                        spaceLength = width;
                    }
                    useLineDash = true;
                    if (length <= dashLength * 2) {
                        useLineDash = false;
                    }
                    else if (length <= dashLength * 2 + spaceLength) {
                        multiplier = length / (2 * dashLength + spaceLength);
                        dashLength *= multiplier;
                        spaceLength *= multiplier;
                    }
                    else {
                        numberOfDashes = Math.floor((length + spaceLength) / (dashLength + spaceLength));
                        minSpace = (length - numberOfDashes * dashLength) / (numberOfDashes - 1);
                        maxSpace = (length - (numberOfDashes + 1) * dashLength) / numberOfDashes;
                        spaceLength =
                            maxSpace <= 0 || Math.abs(spaceLength - minSpace) < Math.abs(spaceLength - maxSpace)
                                ? minSpace
                                : maxSpace;
                    }
                    if (useLineDash) {
                        if (style === 3 /* DOTTED */) {
                            this.ctx.setLineDash([0, dashLength + spaceLength]);
                        }
                        else {
                            this.ctx.setLineDash([dashLength, spaceLength]);
                        }
                    }
                    if (style === 3 /* DOTTED */) {
                        this.ctx.lineCap = 'round';
                        this.ctx.lineWidth = width;
                    }
                    else {
                        this.ctx.lineWidth = width * 2 + 1.1;
                    }
                    this.ctx.strokeStyle = asString(color);
                    this.ctx.stroke();
                    this.ctx.setLineDash([]);
                    // dashed round edge gap
                    if (style === 2 /* DASHED */) {
                        if (isBezierCurve(boxPaths[0])) {
                            path1 = boxPaths[3];
                            path2 = boxPaths[0];
                            this.ctx.beginPath();
                            this.formatPath([new Vector(path1.end.x, path1.end.y), new Vector(path2.start.x, path2.start.y)]);
                            this.ctx.stroke();
                        }
                        if (isBezierCurve(boxPaths[1])) {
                            path1 = boxPaths[1];
                            path2 = boxPaths[2];
                            this.ctx.beginPath();
                            this.formatPath([new Vector(path1.end.x, path1.end.y), new Vector(path2.start.x, path2.start.y)]);
                            this.ctx.stroke();
                        }
                    }
                    this.ctx.restore();
                    return [2 /*return*/];
                });
            });
        };
        CanvasRenderer.prototype.render = function (element) {
            return __awaiter(this, void 0, void 0, function () {
                var stack;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (this.options.backgroundColor) {
                                this.ctx.fillStyle = asString(this.options.backgroundColor);
                                this.ctx.fillRect(this.options.x, this.options.y, this.options.width, this.options.height);
                            }
                            stack = parseStackingContexts(element);
                            return [4 /*yield*/, this.renderStack(stack)];
                        case 1:
                            _a.sent();
                            this.applyEffects([]);
                            return [2 /*return*/, this.canvas];
                    }
                });
            });
        };
        return CanvasRenderer;
    }(Renderer));
    var isTextInputElement = function (container) {
        if (container instanceof TextareaElementContainer) {
            return true;
        }
        else if (container instanceof SelectElementContainer) {
            return true;
        }
        else if (container instanceof InputElementContainer && container.type !== RADIO && container.type !== CHECKBOX) {
            return true;
        }
        return false;
    };
    var calculateBackgroundCurvedPaintingArea = function (clip, curves) {
        switch (clip) {
            case 0 /* BORDER_BOX */:
                return calculateBorderBoxPath(curves);
            case 2 /* CONTENT_BOX */:
                return calculateContentBoxPath(curves);
            case 1 /* PADDING_BOX */:
            default:
                return calculatePaddingBoxPath(curves);
        }
    };
    var canvasTextAlign = function (textAlign) {
        switch (textAlign) {
            case 1 /* CENTER */:
                return 'center';
            case 2 /* RIGHT */:
                return 'right';
            case 0 /* LEFT */:
            default:
                return 'left';
        }
    };
    // see https://github.com/niklasvh/html2canvas/pull/2645
    var iOSBrokenFonts = ['-apple-system', 'system-ui'];
    var fixIOSSystemFonts = function (fontFamilies) {
        return /iPhone OS 15_(0|1)/.test(window.navigator.userAgent)
            ? fontFamilies.filter(function (fontFamily) { return iOSBrokenFonts.indexOf(fontFamily) === -1; })
            : fontFamilies;
    };

    var ForeignObjectRenderer = /** @class */ (function (_super) {
        __extends(ForeignObjectRenderer, _super);
        function ForeignObjectRenderer(context, options) {
            var _this = _super.call(this, context, options) || this;
            _this.canvas = options.canvas ? options.canvas : document.createElement('canvas');
            _this.ctx = _this.canvas.getContext('2d');
            _this.options = options;
            _this.canvas.width = Math.floor(options.width * options.scale);
            _this.canvas.height = Math.floor(options.height * options.scale);
            _this.canvas.style.width = options.width + "px";
            _this.canvas.style.height = options.height + "px";
            _this.ctx.scale(_this.options.scale, _this.options.scale);
            _this.ctx.translate(-options.x, -options.y);
            _this.context.logger.debug("EXPERIMENTAL ForeignObject renderer initialized (" + options.width + "x" + options.height + " at " + options.x + "," + options.y + ") with scale " + options.scale);
            return _this;
        }
        ForeignObjectRenderer.prototype.render = function (element) {
            return __awaiter(this, void 0, void 0, function () {
                var svg, img;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            svg = createForeignObjectSVG(this.options.width * this.options.scale, this.options.height * this.options.scale, this.options.scale, this.options.scale, element);
                            return [4 /*yield*/, loadSerializedSVG(svg)];
                        case 1:
                            img = _a.sent();
                            if (this.options.backgroundColor) {
                                this.ctx.fillStyle = asString(this.options.backgroundColor);
                                this.ctx.fillRect(0, 0, this.options.width * this.options.scale, this.options.height * this.options.scale);
                            }
                            this.ctx.drawImage(img, -this.options.x * this.options.scale, -this.options.y * this.options.scale);
                            return [2 /*return*/, this.canvas];
                    }
                });
            });
        };
        return ForeignObjectRenderer;
    }(Renderer));
    var loadSerializedSVG = function (svg) {
        return new Promise(function (resolve, reject) {
            var img = new Image();
            img.onload = function () {
                resolve(img);
            };
            img.onerror = reject;
            img.src = "data:image/svg+xml;charset=utf-8," + encodeURIComponent(new XMLSerializer().serializeToString(svg));
        });
    };

    var Logger = /** @class */ (function () {
        function Logger(_a) {
            var id = _a.id, enabled = _a.enabled;
            this.id = id;
            this.enabled = enabled;
            this.start = Date.now();
        }
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        Logger.prototype.debug = function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            if (this.enabled) {
                // eslint-disable-next-line no-console
                if (typeof window !== 'undefined' && window.console && typeof console.debug === 'function') {
                    // eslint-disable-next-line no-console
                    console.debug.apply(console, __spreadArray([this.id, this.getTime() + "ms"], args));
                }
                else {
                    this.info.apply(this, args);
                }
            }
        };
        Logger.prototype.getTime = function () {
            return Date.now() - this.start;
        };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        Logger.prototype.info = function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            if (this.enabled) {
                // eslint-disable-next-line no-console
                if (typeof window !== 'undefined' && window.console && typeof console.info === 'function') {
                    // eslint-disable-next-line no-console
                    console.info.apply(console, __spreadArray([this.id, this.getTime() + "ms"], args));
                }
            }
        };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        Logger.prototype.warn = function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            if (this.enabled) {
                // eslint-disable-next-line no-console
                if (typeof window !== 'undefined' && window.console && typeof console.warn === 'function') {
                    // eslint-disable-next-line no-console
                    console.warn.apply(console, __spreadArray([this.id, this.getTime() + "ms"], args));
                }
                else {
                    this.info.apply(this, args);
                }
            }
        };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        Logger.prototype.error = function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            if (this.enabled) {
                // eslint-disable-next-line no-console
                if (typeof window !== 'undefined' && window.console && typeof console.error === 'function') {
                    // eslint-disable-next-line no-console
                    console.error.apply(console, __spreadArray([this.id, this.getTime() + "ms"], args));
                }
                else {
                    this.info.apply(this, args);
                }
            }
        };
        Logger.instances = {};
        return Logger;
    }());

    var Context = /** @class */ (function () {
        function Context(options, windowBounds) {
            var _a;
            this.windowBounds = windowBounds;
            this.instanceName = "#" + Context.instanceCount++;
            this.logger = new Logger({ id: this.instanceName, enabled: options.logging });
            this.cache = (_a = options.cache) !== null && _a !== void 0 ? _a : new Cache(this, options);
        }
        Context.instanceCount = 1;
        return Context;
    }());

    var html2canvas = function (element, options) {
        if (options === void 0) { options = {}; }
        return renderElement(element, options);
    };
    if (typeof window !== 'undefined') {
        CacheStorage.setContext(window);
    }
    var renderElement = function (element, opts) { return __awaiter(void 0, void 0, void 0, function () {
        var ownerDocument, defaultView, resourceOptions, contextOptions, windowOptions, windowBounds, context, foreignObjectRendering, cloneOptions, documentCloner, clonedElement, container, _a, width, height, left, top, backgroundColor, renderOptions, canvas, renderer, root, renderer;
        var _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t;
        return __generator(this, function (_u) {
            switch (_u.label) {
                case 0:
                    if (!element || typeof element !== 'object') {
                        return [2 /*return*/, Promise.reject('Invalid element provided as first argument')];
                    }
                    ownerDocument = element.ownerDocument;
                    if (!ownerDocument) {
                        throw new Error("Element is not attached to a Document");
                    }
                    defaultView = ownerDocument.defaultView;
                    if (!defaultView) {
                        throw new Error("Document is not attached to a Window");
                    }
                    resourceOptions = {
                        allowTaint: (_b = opts.allowTaint) !== null && _b !== void 0 ? _b : false,
                        imageTimeout: (_c = opts.imageTimeout) !== null && _c !== void 0 ? _c : 15000,
                        proxy: opts.proxy,
                        useCORS: (_d = opts.useCORS) !== null && _d !== void 0 ? _d : false
                    };
                    contextOptions = __assign({ logging: (_e = opts.logging) !== null && _e !== void 0 ? _e : true, cache: opts.cache }, resourceOptions);
                    windowOptions = {
                        windowWidth: (_f = opts.windowWidth) !== null && _f !== void 0 ? _f : defaultView.innerWidth,
                        windowHeight: (_g = opts.windowHeight) !== null && _g !== void 0 ? _g : defaultView.innerHeight,
                        scrollX: (_h = opts.scrollX) !== null && _h !== void 0 ? _h : defaultView.pageXOffset,
                        scrollY: (_j = opts.scrollY) !== null && _j !== void 0 ? _j : defaultView.pageYOffset
                    };
                    windowBounds = new Bounds(windowOptions.scrollX, windowOptions.scrollY, windowOptions.windowWidth, windowOptions.windowHeight);
                    context = new Context(contextOptions, windowBounds);
                    foreignObjectRendering = (_k = opts.foreignObjectRendering) !== null && _k !== void 0 ? _k : false;
                    cloneOptions = {
                        allowTaint: (_l = opts.allowTaint) !== null && _l !== void 0 ? _l : false,
                        onclone: opts.onclone,
                        ignoreElements: opts.ignoreElements,
                        inlineImages: foreignObjectRendering,
                        copyStyles: foreignObjectRendering
                    };
                    context.logger.debug("Starting document clone with size " + windowBounds.width + "x" + windowBounds.height + " scrolled to " + -windowBounds.left + "," + -windowBounds.top);
                    documentCloner = new DocumentCloner(context, element, cloneOptions);
                    clonedElement = documentCloner.clonedReferenceElement;
                    if (!clonedElement) {
                        return [2 /*return*/, Promise.reject("Unable to find element in cloned iframe")];
                    }
                    return [4 /*yield*/, documentCloner.toIFrame(ownerDocument, windowBounds)];
                case 1:
                    container = _u.sent();
                    _a = isBodyElement(clonedElement) || isHTMLElement(clonedElement)
                        ? parseDocumentSize(clonedElement.ownerDocument)
                        : parseBounds(context, clonedElement), width = _a.width, height = _a.height, left = _a.left, top = _a.top;
                    backgroundColor = parseBackgroundColor(context, clonedElement, opts.backgroundColor);
                    renderOptions = {
                        canvas: opts.canvas,
                        backgroundColor: backgroundColor,
                        scale: (_o = (_m = opts.scale) !== null && _m !== void 0 ? _m : defaultView.devicePixelRatio) !== null && _o !== void 0 ? _o : 1,
                        x: ((_p = opts.x) !== null && _p !== void 0 ? _p : 0) + left,
                        y: ((_q = opts.y) !== null && _q !== void 0 ? _q : 0) + top,
                        width: (_r = opts.width) !== null && _r !== void 0 ? _r : Math.ceil(width),
                        height: (_s = opts.height) !== null && _s !== void 0 ? _s : Math.ceil(height),
                        ratio: opts.ratio || 1
                    };
                    if (!foreignObjectRendering) return [3 /*break*/, 3];
                    context.logger.debug("Document cloned, using foreign object rendering");
                    renderer = new ForeignObjectRenderer(context, renderOptions);
                    return [4 /*yield*/, renderer.render(clonedElement)];
                case 2:
                    canvas = _u.sent();
                    return [3 /*break*/, 5];
                case 3:
                    context.logger.debug("Document cloned, element located at " + left + "," + top + " with size " + width + "x" + height + " using computed rendering");
                    context.logger.debug("Starting DOM parsing");
                    root = parseTree(context, clonedElement);
                    if (backgroundColor === root.styles.backgroundColor) {
                        root.styles.backgroundColor = COLORS.TRANSPARENT;
                    }
                    context.logger.debug("Starting renderer for element at " + renderOptions.x + "," + renderOptions.y + " with size " + renderOptions.width + "x" + renderOptions.height);
                    renderer = new CanvasRenderer(context, renderOptions);
                    return [4 /*yield*/, renderer.render(root)];
                case 4:
                    canvas = _u.sent();
                    _u.label = 5;
                case 5:
                    if ((_t = opts.removeContainer) !== null && _t !== void 0 ? _t : true) {
                        if (!DocumentCloner.destroy(container)) {
                            context.logger.error("Cannot detach cloned iframe as it is not in the DOM anymore");
                        }
                    }
                    context.logger.debug("Finished rendering");
                    return [2 /*return*/, canvas];
            }
        });
    }); };
    var parseBackgroundColor = function (context, element, backgroundColorOverride) {
        var ownerDocument = element.ownerDocument;
        // http://www.w3.org/TR/css3-background/#special-backgrounds
        var documentBackgroundColor = ownerDocument.documentElement
            ? parseColor(context, getComputedStyle(ownerDocument.documentElement).backgroundColor)
            : COLORS.TRANSPARENT;
        var bodyBackgroundColor = ownerDocument.body
            ? parseColor(context, getComputedStyle(ownerDocument.body).backgroundColor)
            : COLORS.TRANSPARENT;
        var defaultBackgroundColor = typeof backgroundColorOverride === 'string'
            ? parseColor(context, backgroundColorOverride)
            : backgroundColorOverride === null
                ? COLORS.TRANSPARENT
                : 0xffffffff;
        return element === ownerDocument.documentElement
            ? isTransparent(documentBackgroundColor)
                ? isTransparent(bodyBackgroundColor)
                    ? defaultBackgroundColor
                    : bodyBackgroundColor
                : documentBackgroundColor
            : defaultBackgroundColor;
    };

    return html2canvas;

})));




function html2canvas_adapt(node, options) {
	// https://github.com/niklasvh/html2canvas/blob/v1.4.1/docs/configuration.md
	options.allowTaint = true;
	options.useCORS = true;
	options.x = 0;
	options.y = 0;
	options.onclone = onElementClone;
	options.logging = true;
	// 支持自定义DPI（屏幕96DPI），不传则默认96
	if (options.dpi && !options.scale) {
		options.scale = options.dpi / 96;
	}
	html2canvas(node, options)
	.then(function (canvas) {
		if (options.onrendered) {
			options.onrendered(canvas);
		}
	});

	function onElementClone (element) {
	}
}

(function(){
    'user strict';
    angular.module('platformApp')
    .directive('fileread', fileread);

    function fileread() {
        var directive = {
            restrict: 'A',
            scope: false,
            link: linkFunc
        };
        return directive;
        function linkFunc(scope, element, attrs, parentCtrl) {
            element.bind("change", function(changeEvent) {
                scope.$parent.upLoading = true;
                scope.uploadFile(changeEvent.target.files[0], changeEvent.target.id);
            });
        }
    }
})();



(function() {
    'use strict';

    angular
        .module('platformApp')
        .constant('errorConstants', (function() {
            var problemBaseUrl = 'http://www.jhipster.tech/problem';
            return {
                EMAIL_ALREADY_USED_TYPE: problemBaseUrl + '/email-already-used',
                LOGIN_ALREADY_USED_TYPE: problemBaseUrl + '/login-already-used',
                EMAIL_NOT_FOUND_TYPE: problemBaseUrl + '/email-not-found'
            }
        })());
})();

/**
 * @author alteredq / http://alteredqualia.com/
 * @author mr.doob / http://mrdoob.com/
 */

var Detector = {

  canvas: !! window.CanvasRenderingContext2D,
  webgl: ( function () {

    try {

      var canvas = document.createElement( 'canvas' ); return !! ( window.WebGLRenderingContext && ( canvas.getContext( 'webgl' ) || canvas.getContext( 'experimental-webgl' ) ) );

    } catch ( e ) {

      return false;

    }

  } )(),
  workers: !! window.Worker,
  fileapi: window.File && window.FileReader && window.FileList && window.Blob,

  getWebGLErrorMessage: function () {

    var element = document.createElement( 'div' );
    element.id = 'webgl-error-message';
    element.style.fontFamily = 'monospace';
    element.style.fontSize = '13px';
    element.style.fontWeight = 'normal';
    element.style.textAlign = 'center';
    element.style.background = '#fff';
    element.style.color = '#000';
    element.style.padding = '1.5em';
    element.style.width = '400px';
    element.style.margin = '5em auto 0';

    if ( ! this.webgl ) {

      element.innerHTML = window.WebGLRenderingContext ? [
        'Your graphics card does not seem to support <a href="http://khronos.org/webgl/wiki/Getting_a_WebGL_Implementation" style="color:#000">WebGL</a>.<br />',
        'Find out how to get it <a href="http://get.webgl.org/" style="color:#000">here</a>.'
      ].join( '\n' ) : [
        'Your browser does not seem to support <a href="http://khronos.org/webgl/wiki/Getting_a_WebGL_Implementation" style="color:#000">WebGL</a>.<br/>',
        'Find out how to get it <a href="http://get.webgl.org/" style="color:#000">here</a>.'
      ].join( '\n' );

    }

    return element;

  },

  addGetWebGLMessage: function ( parameters ) {

    var parent, id, element;

    parameters = parameters || {};

    parent = parameters.parent !== undefined ? parameters.parent : document.body;
    id = parameters.id !== undefined ? parameters.id : 'oldie';

    element = Detector.getWebGLErrorMessage();
    element.id = id;

    parent.appendChild( element );

  }

};

// browserify support
if ( typeof module === 'object' ) {

  module.exports = Detector;

}

(function() {
    'use strict';

    angular
        .module('platformApp')
        .factory('DateUtils', DateUtils);

    DateUtils.$inject = ['$filter'];

    function DateUtils($filter) {

        var service = {
            convertDateTimeFromServer: convertDateTimeFromServer,
            convertLocalDateFromServer: convertLocalDateFromServer,
            convertLocalDateToServer: convertLocalDateToServer,
            dateformat: dateformat
        };

        return service;

        function convertDateTimeFromServer(date) {
            if (date) {
                return new Date(date);
            } else {
                return null;
            }
        }

        function convertLocalDateFromServer(date) {
            if (date) {
                var dateString = date.split('-');
                return new Date(dateString[0], dateString[1] - 1, dateString[2]);
            }
            return null;
        }

        function convertLocalDateToServer(date) {
            if (date) {
                return $filter('date')(date, 'yyyy-MM-dd');
            } else {
                return null;
            }
        }

        function dateformat() {
            return 'yyyy-MM-dd';
        }
    }

})();

(function() {
    'use strict';

    angular
        .module('platformApp')
        .factory('DataUtils', DataUtils);

    DataUtils.$inject = ['$window'];

    function DataUtils ($window) {

        var service = {
            abbreviate: abbreviate,
            byteSize: byteSize,
            openFile: openFile,
            toBase64: toBase64
        };

        return service;

        function abbreviate (text) {
            if (!angular.isString(text)) {
                return '';
            }
            if (text.length < 30) {
                return text;
            }
            return text ? (text.substring(0, 15) + '...' + text.slice(-10)) : '';
        }

        function byteSize (base64String) {
            if (!angular.isString(base64String)) {
                return '';
            }

            function endsWith(suffix, str) {
                return str.indexOf(suffix, str.length - suffix.length) !== -1;
            }

            function paddingSize(base64String) {
                if (endsWith('==', base64String)) {
                    return 2;
                }
                if (endsWith('=', base64String)) {
                    return 1;
                }
                return 0;
            }

            function size(base64String) {
                return base64String.length / 4 * 3 - paddingSize(base64String);
            }

            function formatAsBytes(size) {
                return size.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ') + ' bytes';
            }

            return formatAsBytes(size(base64String));
        }

        function openFile (type, data) {
            var fileURL = 'data:' + type +';base64,' + data;
            var win = $window.open('', '_blank');
            win.document.write(
                '<iframe src="' +
                fileURL +
                '" frameborder="0" style="border:0; top:0px; left:0px; bottom:0px; right:0px; width:100%; height:100%;" allowfullscreen></iframe>'
            );
        }

        function toBase64 (file, cb) {
            var fileReader = new FileReader();
            fileReader.readAsDataURL(file);
            fileReader.onload = function (e) {
                var base64Data = e.target.result.substr(e.target.result.indexOf('base64,') + 'base64,'.length);
                cb(base64Data);
            };
        }
    }
})();

/**
 * dat-gui JavaScript Controller Library
 * https://github.com/dataarts/dat.gui
 *
 * Copyright 2016 Data Arts Team, Google Creative Lab
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 */
!function(e, t) {
    "object" == typeof exports && "object" == typeof module ? module.exports = t() : "function" == typeof define && define.amd ? define([], t) : "object" == typeof exports ? exports.dat = t() : e.dat = t()
}(this, function() {
    return function(e) {
        function t(o) {
            if (n[o])
                return n[o].exports;
            var i = n[o] = {
                exports: {},
                id: o,
                loaded: !1
            };
            return e[o].call(i.exports, i, i.exports, t),
                i.loaded = !0,
                i.exports
        }
        var n = {};
        return t.m = e,
            t.c = n,
            t.p = "",
            t(0)
    }([function(e, t, n) {
        "use strict";
        function o(e) {
            return e && e.__esModule ? e : {
                "default": e
            }
        }
        var i = n(1)
            , r = o(i);
        e.exports = r["default"]
    }
        , function(e, t, n) {
            "use strict";
            function o(e) {
                return e && e.__esModule ? e : {
                    "default": e
                }
            }
            t.__esModule = !0;
            var i = n(2)
                , r = o(i)
                , a = n(6)
                , l = o(a)
                , s = n(3)
                , u = o(s)
                , d = n(7)
                , c = o(d)
                , f = n(8)
                , _ = o(f)
                , p = n(10)
                , h = o(p)
                , m = n(11)
                , b = o(m)
                , g = n(12)
                , v = o(g)
                , y = n(13)
                , w = o(y)
                , x = n(14)
                , E = o(x)
                , C = n(15)
                , A = o(C)
                , S = n(16)
                , k = o(S)
                , O = n(9)
                , T = o(O)
                , R = n(17)
                , L = o(R);
            t["default"] = {
                color: {
                    Color: r["default"],
                    math: l["default"],
                    interpret: u["default"]
                },
                controllers: {
                    Controller: c["default"],
                    BooleanController: _["default"],
                    OptionController: h["default"],
                    StringController: b["default"],
                    NumberController: v["default"],
                    NumberControllerBox: w["default"],
                    NumberControllerSlider: E["default"],
                    FunctionController: A["default"],
                    ColorController: k["default"]
                },
                dom: {
                    dom: T["default"]
                },
                gui: {
                    GUI: L["default"]
                },
                GUI: L["default"]
            }
        }
        , function(e, t, n) {
            "use strict";
            function o(e) {
                return e && e.__esModule ? e : {
                    "default": e
                }
            }
            function i(e, t) {
                if (!(e instanceof t))
                    throw new TypeError("Cannot call a class as a function")
            }
            function r(e, t, n) {
                Object.defineProperty(e, t, {
                    get: function() {
                        return "RGB" === this.__state.space ? this.__state[t] : (h.recalculateRGB(this, t, n),
                            this.__state[t])
                    },
                    set: function(e) {
                        "RGB" !== this.__state.space && (h.recalculateRGB(this, t, n),
                            this.__state.space = "RGB"),
                            this.__state[t] = e
                    }
                })
            }
            function a(e, t) {
                Object.defineProperty(e, t, {
                    get: function() {
                        return "HSV" === this.__state.space ? this.__state[t] : (h.recalculateHSV(this),
                            this.__state[t])
                    },
                    set: function(e) {
                        "HSV" !== this.__state.space && (h.recalculateHSV(this),
                            this.__state.space = "HSV"),
                            this.__state[t] = e
                    }
                })
            }
            t.__esModule = !0;
            var l = n(3)
                , s = o(l)
                , u = n(6)
                , d = o(u)
                , c = n(4)
                , f = o(c)
                , _ = n(5)
                , p = o(_)
                , h = function() {
                function e() {
                    if (i(this, e),
                        this.__state = s["default"].apply(this, arguments),
                    this.__state === !1)
                        throw new Error("Failed to interpret color arguments");
                    this.__state.a = this.__state.a || 1
                }
                return e.prototype.toString = function() {
                    return (0,
                        f["default"])(this)
                }
                    ,
                    e.prototype.toHexString = function() {
                        return (0,
                            f["default"])(this, !0)
                    }
                    ,
                    e.prototype.toOriginal = function() {
                        return this.__state.conversion.write(this)
                    }
                    ,
                    e
            }();
            h.recalculateRGB = function(e, t, n) {
                if ("HEX" === e.__state.space)
                    e.__state[t] = d["default"].component_from_hex(e.__state.hex, n);
                else {
                    if ("HSV" !== e.__state.space)
                        throw new Error("Corrupted color state");
                    p["default"].extend(e.__state, d["default"].hsv_to_rgb(e.__state.h, e.__state.s, e.__state.v))
                }
            }
                ,
                h.recalculateHSV = function(e) {
                    var t = d["default"].rgb_to_hsv(e.r, e.g, e.b);
                    p["default"].extend(e.__state, {
                        s: t.s,
                        v: t.v
                    }),
                        p["default"].isNaN(t.h) ? p["default"].isUndefined(e.__state.h) && (e.__state.h = 0) : e.__state.h = t.h
                }
                ,
                h.COMPONENTS = ["r", "g", "b", "h", "s", "v", "hex", "a"],
                r(h.prototype, "r", 2),
                r(h.prototype, "g", 1),
                r(h.prototype, "b", 0),
                a(h.prototype, "h"),
                a(h.prototype, "s"),
                a(h.prototype, "v"),
                Object.defineProperty(h.prototype, "a", {
                    get: function() {
                        return this.__state.a
                    },
                    set: function(e) {
                        this.__state.a = e
                    }
                }),
                Object.defineProperty(h.prototype, "hex", {
                    get: function() {
                        return "HEX" !== !this.__state.space && (this.__state.hex = d["default"].rgb_to_hex(this.r, this.g, this.b)),
                            this.__state.hex
                    },
                    set: function(e) {
                        this.__state.space = "HEX",
                            this.__state.hex = e
                    }
                }),
                t["default"] = h
        }
        , function(e, t, n) {
            "use strict";
            function o(e) {
                return e && e.__esModule ? e : {
                    "default": e
                }
            }
            t.__esModule = !0;
            var i = n(4)
                , r = o(i)
                , a = n(5)
                , l = o(a)
                , s = [{
                litmus: l["default"].isString,
                conversions: {
                    THREE_CHAR_HEX: {
                        read: function(e) {
                            var t = e.match(/^#([A-F0-9])([A-F0-9])([A-F0-9])$/i);
                            return null !== t && {
                                space: "HEX",
                                hex: parseInt("0x" + t[1].toString() + t[1].toString() + t[2].toString() + t[2].toString() + t[3].toString() + t[3].toString(), 0)
                            }
                        },
                        write: r["default"]
                    },
                    SIX_CHAR_HEX: {
                        read: function(e) {
                            var t = e.match(/^#([A-F0-9]{6})$/i);
                            return null !== t && {
                                space: "HEX",
                                hex: parseInt("0x" + t[1].toString(), 0)
                            }
                        },
                        write: r["default"]
                    },
                    CSS_RGB: {
                        read: function(e) {
                            var t = e.match(/^rgb\(\s*(.+)\s*,\s*(.+)\s*,\s*(.+)\s*\)/);
                            return null !== t && {
                                space: "RGB",
                                r: parseFloat(t[1]),
                                g: parseFloat(t[2]),
                                b: parseFloat(t[3])
                            }
                        },
                        write: r["default"]
                    },
                    CSS_RGBA: {
                        read: function(e) {
                            var t = e.match(/^rgba\(\s*(.+)\s*,\s*(.+)\s*,\s*(.+)\s*,\s*(.+)\s*\)/);
                            return null !== t && {
                                space: "RGB",
                                r: parseFloat(t[1]),
                                g: parseFloat(t[2]),
                                b: parseFloat(t[3]),
                                a: parseFloat(t[4])
                            }
                        },
                        write: r["default"]
                    }
                }
            }, {
                litmus: l["default"].isNumber,
                conversions: {
                    HEX: {
                        read: function(e) {
                            return {
                                space: "HEX",
                                hex: e,
                                conversionName: "HEX"
                            }
                        },
                        write: function(e) {
                            return e.hex
                        }
                    }
                }
            }, {
                litmus: l["default"].isArray,
                conversions: {
                    RGB_ARRAY: {
                        read: function(e) {
                            return 3 === e.length && {
                                space: "RGB",
                                r: e[0],
                                g: e[1],
                                b: e[2]
                            }
                        },
                        write: function(e) {
                            return [e.r, e.g, e.b]
                        }
                    },
                    RGBA_ARRAY: {
                        read: function(e) {
                            return 4 === e.length && {
                                space: "RGB",
                                r: e[0],
                                g: e[1],
                                b: e[2],
                                a: e[3]
                            }
                        },
                        write: function(e) {
                            return [e.r, e.g, e.b, e.a]
                        }
                    }
                }
            }, {
                litmus: l["default"].isObject,
                conversions: {
                    RGBA_OBJ: {
                        read: function(e) {
                            return !!(l["default"].isNumber(e.r) && l["default"].isNumber(e.g) && l["default"].isNumber(e.b) && l["default"].isNumber(e.a)) && {
                                space: "RGB",
                                r: e.r,
                                g: e.g,
                                b: e.b,
                                a: e.a
                            }
                        },
                        write: function(e) {
                            return {
                                r: e.r,
                                g: e.g,
                                b: e.b,
                                a: e.a
                            }
                        }
                    },
                    RGB_OBJ: {
                        read: function(e) {
                            return !!(l["default"].isNumber(e.r) && l["default"].isNumber(e.g) && l["default"].isNumber(e.b)) && {
                                space: "RGB",
                                r: e.r,
                                g: e.g,
                                b: e.b
                            }
                        },
                        write: function(e) {
                            return {
                                r: e.r,
                                g: e.g,
                                b: e.b
                            }
                        }
                    },
                    HSVA_OBJ: {
                        read: function(e) {
                            return !!(l["default"].isNumber(e.h) && l["default"].isNumber(e.s) && l["default"].isNumber(e.v) && l["default"].isNumber(e.a)) && {
                                space: "HSV",
                                h: e.h,
                                s: e.s,
                                v: e.v,
                                a: e.a
                            }
                        },
                        write: function(e) {
                            return {
                                h: e.h,
                                s: e.s,
                                v: e.v,
                                a: e.a
                            }
                        }
                    },
                    HSV_OBJ: {
                        read: function(e) {
                            return !!(l["default"].isNumber(e.h) && l["default"].isNumber(e.s) && l["default"].isNumber(e.v)) && {
                                space: "HSV",
                                h: e.h,
                                s: e.s,
                                v: e.v
                            }
                        },
                        write: function(e) {
                            return {
                                h: e.h,
                                s: e.s,
                                v: e.v
                            }
                        }
                    }
                }
            }]
                , u = void 0
                , d = void 0
                , c = function() {
                d = !1;
                var e = arguments.length > 1 ? l["default"].toArray(arguments) : arguments[0];
                return l["default"].each(s, function(t) {
                    if (t.litmus(e))
                        return l["default"].each(t.conversions, function(t, n) {
                            if (u = t.read(e),
                            d === !1 && u !== !1)
                                return d = u,
                                    u.conversionName = n,
                                    u.conversion = t,
                                    l["default"].BREAK
                        }),
                            l["default"].BREAK
                }),
                    d
            };
            t["default"] = c
        }
        , function(e, t) {
            "use strict";
            t.__esModule = !0,
                t["default"] = function(e, t) {
                    var n = e.__state.conversionName.toString()
                        , o = Math.round(e.r)
                        , i = Math.round(e.g)
                        , r = Math.round(e.b)
                        , a = e.a
                        , l = Math.round(e.h)
                        , s = e.s.toFixed(1)
                        , u = e.v.toFixed(1);
                    if (t || "THREE_CHAR_HEX" === n || "SIX_CHAR_HEX" === n) {
                        for (var d = e.hex.toString(16); d.length < 6; )
                            d = "0" + d;
                        return "#" + d
                    }
                    return "CSS_RGB" === n ? "rgb(" + o + "," + i + "," + r + ")" : "CSS_RGBA" === n ? "rgba(" + o + "," + i + "," + r + "," + a + ")" : "HEX" === n ? "0x" + e.hex.toString(16) : "RGB_ARRAY" === n ? "[" + o + "," + i + "," + r + "]" : "RGBA_ARRAY" === n ? "[" + o + "," + i + "," + r + "," + a + "]" : "RGB_OBJ" === n ? "{r:" + o + ",g:" + i + ",b:" + r + "}" : "RGBA_OBJ" === n ? "{r:" + o + ",g:" + i + ",b:" + r + ",a:" + a + "}" : "HSV_OBJ" === n ? "{h:" + l + ",s:" + s + ",v:" + u + "}" : "HSVA_OBJ" === n ? "{h:" + l + ",s:" + s + ",v:" + u + ",a:" + a + "}" : "unknown format"
                }
        }
        , function(e, t) {
            "use strict";
            t.__esModule = !0;
            var n = Array.prototype.forEach
                , o = Array.prototype.slice
                , i = {
                BREAK: {},
                extend: function(e) {
                    return this.each(o.call(arguments, 1), function(t) {
                        var n = this.isObject(t) ? Object.keys(t) : [];
                        n.forEach(function(n) {
                            this.isUndefined(t[n]) || (e[n] = t[n])
                        }
                            .bind(this))
                    }, this),
                        e
                },
                defaults: function(e) {
                    return this.each(o.call(arguments, 1), function(t) {
                        var n = this.isObject(t) ? Object.keys(t) : [];
                        n.forEach(function(n) {
                            this.isUndefined(e[n]) && (e[n] = t[n])
                        }
                            .bind(this))
                    }, this),
                        e
                },
                compose: function() {
                    var e = o.call(arguments);
                    return function() {
                        for (var t = o.call(arguments), n = e.length - 1; n >= 0; n--)
                            t = [e[n].apply(this, t)];
                        return t[0]
                    }
                },
                each: function(e, t, o) {
                    if (e)
                        if (n && e.forEach && e.forEach === n)
                            e.forEach(t, o);
                        else if (e.length === e.length + 0) {
                            var i = void 0
                                , r = void 0;
                            for (i = 0,
                                     r = e.length; i < r; i++)
                                if (i in e && t.call(o, e[i], i) === this.BREAK)
                                    return
                        } else
                            for (var a in e)
                                if (t.call(o, e[a], a) === this.BREAK)
                                    return
                },
                defer: function(e) {
                    setTimeout(e, 0)
                },
                debounce: function(e, t) {
                    var n = void 0;
                    return function() {
                        function o() {
                            n = null
                        }
                        var i = this
                            , r = arguments
                            , a = !n;
                        clearTimeout(n),
                            n = setTimeout(o, t),
                        a && e.apply(i, r)
                    }
                },
                toArray: function(e) {
                    return e.toArray ? e.toArray() : o.call(e)
                },
                isUndefined: function(e) {
                    return void 0 === e
                },
                isNull: function(e) {
                    return null === e
                },
                isNaN: function(e) {
                    function t(t) {
                        return e.apply(this, arguments)
                    }
                    return t.toString = function() {
                        return e.toString()
                    }
                        ,
                        t
                }(function(e) {
                    return isNaN(e)
                }),
                isArray: Array.isArray || function(e) {
                    return e.constructor === Array
                }
                ,
                isObject: function(e) {
                    return e === Object(e)
                },
                isNumber: function(e) {
                    return e === e + 0
                },
                isString: function(e) {
                    return e === e + ""
                },
                isBoolean: function(e) {
                    return e === !1 || e === !0
                },
                isFunction: function(e) {
                    return "[object Function]" === Object.prototype.toString.call(e)
                }
            };
            t["default"] = i
        }
        , function(e, t) {
            "use strict";
            t.__esModule = !0;
            var n = void 0
                , o = {
                hsv_to_rgb: function(e, t, n) {
                    var o = Math.floor(e / 60) % 6
                        , i = e / 60 - Math.floor(e / 60)
                        , r = n * (1 - t)
                        , a = n * (1 - i * t)
                        , l = n * (1 - (1 - i) * t)
                        , s = [[n, l, r], [a, n, r], [r, n, l], [r, a, n], [l, r, n], [n, r, a]][o];
                    return {
                        r: 255 * s[0],
                        g: 255 * s[1],
                        b: 255 * s[2]
                    }
                },
                rgb_to_hsv: function(e, t, n) {
                    var o = Math.min(e, t, n)
                        , i = Math.max(e, t, n)
                        , r = i - o
                        , a = void 0
                        , l = void 0;
                    return 0 === i ? {
                        h: NaN,
                        s: 0,
                        v: 0
                    } : (l = r / i,
                        a = e === i ? (t - n) / r : t === i ? 2 + (n - e) / r : 4 + (e - t) / r,
                        a /= 6,
                    a < 0 && (a += 1),
                        {
                            h: 360 * a,
                            s: l,
                            v: i / 255
                        })
                },
                rgb_to_hex: function(e, t, n) {
                    var o = this.hex_with_component(0, 2, e);
                    return o = this.hex_with_component(o, 1, t),
                        o = this.hex_with_component(o, 0, n)
                },
                component_from_hex: function(e, t) {
                    return e >> 8 * t & 255
                },
                hex_with_component: function(e, t, o) {
                    return o << (n = 8 * t) | e & ~(255 << n)
                }
            };
            t["default"] = o
        }
        , function(e, t) {
            "use strict";
            function n(e, t) {
                if (!(e instanceof t))
                    throw new TypeError("Cannot call a class as a function")
            }
            t.__esModule = !0;
            var o = function() {
                function e(t, o) {
                    n(this, e),
                        this.initialValue = t[o],
                        this.domElement = document.createElement("div"),
                        this.object = t,
                        this.property = o,
                        this.__onChange = void 0,
                        this.__onFinishChange = void 0
                }
                return e.prototype.onChange = function(e) {
                    return this.__onChange = e,
                        this
                }
                    ,
                    e.prototype.onFinishChange = function(e) {
                        return this.__onFinishChange = e,
                            this
                    }
                    ,
                    e.prototype.setValue = function(e) {
                        return this.object[this.property] = e,
                        this.__onChange && this.__onChange.call(this, e),
                            this.updateDisplay(),
                            this
                    }
                    ,
                    e.prototype.getValue = function() {
                        return this.object[this.property]
                    }
                    ,
                    e.prototype.updateDisplay = function() {
                        return this
                    }
                    ,
                    e.prototype.isModified = function() {
                        return this.initialValue !== this.getValue()
                    }
                    ,
                    e
            }();
            t["default"] = o
        }
        , function(e, t, n) {
            "use strict";
            function o(e) {
                return e && e.__esModule ? e : {
                    "default": e
                }
            }
            function i(e, t) {
                if (!(e instanceof t))
                    throw new TypeError("Cannot call a class as a function")
            }
            function r(e, t) {
                if (!e)
                    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return !t || "object" != typeof t && "function" != typeof t ? e : t
            }
            function a(e, t) {
                if ("function" != typeof t && null !== t)
                    throw new TypeError("Super expression must either be null or a function, not " + typeof t);
                e.prototype = Object.create(t && t.prototype, {
                    constructor: {
                        value: e,
                        enumerable: !1,
                        writable: !0,
                        configurable: !0
                    }
                }),
                t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t)
            }
            t.__esModule = !0;
            var l = n(7)
                , s = o(l)
                , u = n(9)
                , d = o(u)
                , c = function(e) {
                function t(n, o) {
                    function a() {
                        s.setValue(!s.__prev)
                    }
                    i(this, t);
                    var l = r(this, e.call(this, n, o))
                        , s = l;
                    return l.__prev = l.getValue(),
                        l.__checkbox = document.createElement("input"),
                        l.__checkbox.setAttribute("type", "checkbox"),
                        d["default"].bind(l.__checkbox, "change", a, !1),
                        l.domElement.appendChild(l.__checkbox),
                        l.updateDisplay(),
                        l
                }
                return a(t, e),
                    t.prototype.setValue = function(t) {
                        var n = e.prototype.setValue.call(this, t);
                        return this.__onFinishChange && this.__onFinishChange.call(this, this.getValue()),
                            this.__prev = this.getValue(),
                            n
                    }
                    ,
                    t.prototype.updateDisplay = function() {
                        return this.getValue() === !0 ? (this.__checkbox.setAttribute("checked", "checked"),
                            this.__checkbox.checked = !0) : this.__checkbox.checked = !1,
                            e.prototype.updateDisplay.call(this)
                    }
                    ,
                    t
            }(s["default"]);
            t["default"] = c
        }
        , function(e, t, n) {
            "use strict";
            function o(e) {
                return e && e.__esModule ? e : {
                    "default": e
                }
            }
            function i(e) {
                if ("0" === e || a["default"].isUndefined(e))
                    return 0;
                var t = e.match(u);
                return a["default"].isNull(t) ? 0 : parseFloat(t[1])
            }
            t.__esModule = !0;
            var r = n(5)
                , a = o(r)
                , l = {
                HTMLEvents: ["change"],
                MouseEvents: ["click", "mousemove", "mousedown", "mouseup", "mouseover"],
                KeyboardEvents: ["keydown"]
            }
                , s = {};
            a["default"].each(l, function(e, t) {
                a["default"].each(e, function(e) {
                    s[e] = t
                })
            });
            var u = /(\d+(\.\d+)?)px/
                , d = {
                makeSelectable: function(e, t) {
                    void 0 !== e && void 0 !== e.style && (e.onselectstart = t ? function() {
                            return !1
                        }
                        : function() {}
                        ,
                        e.style.MozUserSelect = t ? "auto" : "none",
                        e.style.KhtmlUserSelect = t ? "auto" : "none",
                        e.unselectable = t ? "on" : "off")
                },
                makeFullscreen: function(e, t, n) {
                    var o = n
                        , i = t;
                    a["default"].isUndefined(i) && (i = !0),
                    a["default"].isUndefined(o) && (o = !0),
                        e.style.position = "absolute",
                    i && (e.style.left = 0,
                        e.style.right = 0),
                    o && (e.style.top = 0,
                        e.style.bottom = 0)
                },
                fakeEvent: function(e, t, n, o) {
                    var i = n || {}
                        , r = s[t];
                    if (!r)
                        throw new Error("Event type " + t + " not supported.");
                    var l = document.createEvent(r);
                    switch (r) {
                        case "MouseEvents":
                            var u = i.x || i.clientX || 0
                                , d = i.y || i.clientY || 0;
                            l.initMouseEvent(t, i.bubbles || !1, i.cancelable || !0, window, i.clickCount || 1, 0, 0, u, d, !1, !1, !1, !1, 0, null);
                            break;
                        case "KeyboardEvents":
                            var c = l.initKeyboardEvent || l.initKeyEvent;
                            a["default"].defaults(i, {
                                cancelable: !0,
                                ctrlKey: !1,
                                altKey: !1,
                                shiftKey: !1,
                                metaKey: !1,
                                keyCode: void 0,
                                charCode: void 0
                            }),
                                c(t, i.bubbles || !1, i.cancelable, window, i.ctrlKey, i.altKey, i.shiftKey, i.metaKey, i.keyCode, i.charCode);
                            break;
                        default:
                            l.initEvent(t, i.bubbles || !1, i.cancelable || !0)
                    }
                    a["default"].defaults(l, o),
                        e.dispatchEvent(l)
                },
                bind: function(e, t, n, o) {
                    var i = o || !1;
                    return e.addEventListener ? e.addEventListener(t, n, i) : e.attachEvent && e.attachEvent("on" + t, n),
                        d
                },
                unbind: function(e, t, n, o) {
                    var i = o || !1;
                    return e.removeEventListener ? e.removeEventListener(t, n, i) : e.detachEvent && e.detachEvent("on" + t, n),
                        d
                },
                addClass: function(e, t) {
                    if (void 0 === e.className)
                        e.className = t;
                    else if (e.className !== t) {
                        var n = e.className.split(/ +/);
                        n.indexOf(t) === -1 && (n.push(t),
                            e.className = n.join(" ").replace(/^\s+/, "").replace(/\s+$/, ""))
                    }
                    return d
                },
                removeClass: function(e, t) {
                    if (t)
                        if (e.className === t)
                            e.removeAttribute("class");
                        else {
                            var n = e.className.split(/ +/)
                                , o = n.indexOf(t);
                            o !== -1 && (n.splice(o, 1),
                                e.className = n.join(" "))
                        }
                    else
                        e.className = void 0;
                    return d
                },
                hasClass: function(e, t) {
                    return new RegExp("(?:^|\\s+)" + t + "(?:\\s+|$)").test(e.className) || !1
                },
                getWidth: function(e) {
                    var t = getComputedStyle(e);
                    return i(t["border-left-width"]) + i(t["border-right-width"]) + i(t["padding-left"]) + i(t["padding-right"]) + i(t.width)
                },
                getHeight: function(e) {
                    var t = getComputedStyle(e);
                    return i(t["border-top-width"]) + i(t["border-bottom-width"]) + i(t["padding-top"]) + i(t["padding-bottom"]) + i(t.height)
                },
                getOffset: function(e) {
                    var t = e
                        , n = {
                        left: 0,
                        top: 0
                    };
                    if (t.offsetParent)
                        do
                            n.left += t.offsetLeft,
                                n.top += t.offsetTop,
                                t = t.offsetParent;
                        while (t);return n
                },
                isActive: function(e) {
                    return e === document.activeElement && (e.type || e.href)
                }
            };
            t["default"] = d
        }
        , function(e, t, n) {
            "use strict";
            function o(e) {
                return e && e.__esModule ? e : {
                    "default": e
                }
            }
            function i(e, t) {
                if (!(e instanceof t))
                    throw new TypeError("Cannot call a class as a function")
            }
            function r(e, t) {
                if (!e)
                    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return !t || "object" != typeof t && "function" != typeof t ? e : t
            }
            function a(e, t) {
                if ("function" != typeof t && null !== t)
                    throw new TypeError("Super expression must either be null or a function, not " + typeof t);
                e.prototype = Object.create(t && t.prototype, {
                    constructor: {
                        value: e,
                        enumerable: !1,
                        writable: !0,
                        configurable: !0
                    }
                }),
                t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t)
            }
            t.__esModule = !0;
            var l = n(7)
                , s = o(l)
                , u = n(9)
                , d = o(u)
                , c = n(5)
                , f = o(c)
                , _ = function(e) {
                function t(n, o, a) {
                    i(this, t);
                    var l = r(this, e.call(this, n, o))
                        , s = a
                        , u = l;
                    return l.__select = document.createElement("select"),
                    f["default"].isArray(s) && !function() {
                        var e = {};
                        f["default"].each(s, function(t) {
                            e[t] = t
                        }),
                            s = e
                    }(),
                        f["default"].each(s, function(e, t) {
                            var n = document.createElement("option");
                            n.innerHTML = t,
                                n.setAttribute("value", e),
                                u.__select.appendChild(n)
                        }),
                        l.updateDisplay(),
                        d["default"].bind(l.__select, "change", function() {
                            var e = this.options[this.selectedIndex].value;
                            u.setValue(e)
                        }),
                        l.domElement.appendChild(l.__select),
                        l
                }
                return a(t, e),
                    t.prototype.setValue = function(t) {
                        var n = e.prototype.setValue.call(this, t);
                        return this.__onFinishChange && this.__onFinishChange.call(this, this.getValue()),
                            n
                    }
                    ,
                    t.prototype.updateDisplay = function() {
                        return d["default"].isActive(this.__select) ? this : (this.__select.value = this.getValue(),
                            e.prototype.updateDisplay.call(this))
                    }
                    ,
                    t
            }(s["default"]);
            t["default"] = _
        }
        , function(e, t, n) {
            "use strict";
            function o(e) {
                return e && e.__esModule ? e : {
                    "default": e
                }
            }
            function i(e, t) {
                if (!(e instanceof t))
                    throw new TypeError("Cannot call a class as a function")
            }
            function r(e, t) {
                if (!e)
                    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return !t || "object" != typeof t && "function" != typeof t ? e : t
            }
            function a(e, t) {
                if ("function" != typeof t && null !== t)
                    throw new TypeError("Super expression must either be null or a function, not " + typeof t);
                e.prototype = Object.create(t && t.prototype, {
                    constructor: {
                        value: e,
                        enumerable: !1,
                        writable: !0,
                        configurable: !0
                    }
                }),
                t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t)
            }
            t.__esModule = !0;
            var l = n(7)
                , s = o(l)
                , u = n(9)
                , d = o(u)
                , c = function(e) {
                function t(n, o) {
                    function a() {
                        u.setValue(u.__input.value)
                    }
                    function l() {
                        u.__onFinishChange && u.__onFinishChange.call(u, u.getValue())
                    }
                    i(this, t);
                    var s = r(this, e.call(this, n, o))
                        , u = s;
                    return s.__input = document.createElement("input"),
                        s.__input.setAttribute("type", "text"),
                        d["default"].bind(s.__input, "keyup", a),
                        d["default"].bind(s.__input, "change", a),
                        d["default"].bind(s.__input, "blur", l),
                        d["default"].bind(s.__input, "keydown", function(e) {
                            13 === e.keyCode && this.blur()
                        }),
                        s.updateDisplay(),
                        s.domElement.appendChild(s.__input),
                        s
                }
                return a(t, e),
                    t.prototype.updateDisplay = function() {
                        return d["default"].isActive(this.__input) || (this.__input.value = this.getValue()),
                            e.prototype.updateDisplay.call(this)
                    }
                    ,
                    t
            }(s["default"]);
            t["default"] = c
        }
        , function(e, t, n) {
            "use strict";
            function o(e) {
                return e && e.__esModule ? e : {
                    "default": e
                }
            }
            function i(e, t) {
                if (!(e instanceof t))
                    throw new TypeError("Cannot call a class as a function")
            }
            function r(e, t) {
                if (!e)
                    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return !t || "object" != typeof t && "function" != typeof t ? e : t
            }
            function a(e, t) {
                if ("function" != typeof t && null !== t)
                    throw new TypeError("Super expression must either be null or a function, not " + typeof t);
                e.prototype = Object.create(t && t.prototype, {
                    constructor: {
                        value: e,
                        enumerable: !1,
                        writable: !0,
                        configurable: !0
                    }
                }),
                t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t)
            }
            function l(e) {
                var t = e.toString();
                return t.indexOf(".") > -1 ? t.length - t.indexOf(".") - 1 : 0
            }
            t.__esModule = !0;
            var s = n(7)
                , u = o(s)
                , d = n(5)
                , c = o(d)
                , f = function(e) {
                function t(n, o, a) {
                    i(this, t);
                    var s = r(this, e.call(this, n, o))
                        , u = a || {};
                    return s.__min = u.min,
                        s.__max = u.max,
                        s.__step = u.step,
                        c["default"].isUndefined(s.__step) ? 0 === s.initialValue ? s.__impliedStep = 1 : s.__impliedStep = Math.pow(10, Math.floor(Math.log(Math.abs(s.initialValue)) / Math.LN10)) / 10 : s.__impliedStep = s.__step,
                        s.__precision = l(s.__impliedStep),
                        s
                }
                return a(t, e),
                    t.prototype.setValue = function(t) {
                        var n = t;
                        return void 0 !== this.__min && n < this.__min ? n = this.__min : void 0 !== this.__max && n > this.__max && (n = this.__max),
                        void 0 !== this.__step && n % this.__step !== 0 && (n = Math.round(n / this.__step) * this.__step),
                            e.prototype.setValue.call(this, n)
                    }
                    ,
                    t.prototype.min = function(e) {
                        return this.__min = e,
                            this
                    }
                    ,
                    t.prototype.max = function(e) {
                        return this.__max = e,
                            this
                    }
                    ,
                    t.prototype.step = function(e) {
                        return this.__step = e,
                            this.__impliedStep = e,
                            this.__precision = l(e),
                            this
                    }
                    ,
                    t
            }(u["default"]);
            t["default"] = f
        }
        , function(e, t, n) {
            "use strict";
            function o(e) {
                return e && e.__esModule ? e : {
                    "default": e
                }
            }
            function i(e, t) {
                if (!(e instanceof t))
                    throw new TypeError("Cannot call a class as a function")
            }
            function r(e, t) {
                if (!e)
                    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return !t || "object" != typeof t && "function" != typeof t ? e : t
            }
            function a(e, t) {
                if ("function" != typeof t && null !== t)
                    throw new TypeError("Super expression must either be null or a function, not " + typeof t);
                e.prototype = Object.create(t && t.prototype, {
                    constructor: {
                        value: e,
                        enumerable: !1,
                        writable: !0,
                        configurable: !0
                    }
                }),
                t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t)
            }
            function l(e, t) {
                var n = Math.pow(10, t);
                return Math.round(e * n) / n
            }
            t.__esModule = !0;
            var s = n(12)
                , u = o(s)
                , d = n(9)
                , c = o(d)
                , f = n(5)
                , _ = o(f)
                , p = function(e) {
                function t(n, o, a) {
                    function l() {
                        var e = parseFloat(m.__input.value);
                        _["default"].isNaN(e) || m.setValue(e)
                    }
                    function s() {
                        m.__onFinishChange && m.__onFinishChange.call(m, m.getValue())
                    }
                    function u() {
                        s()
                    }
                    function d(e) {
                        var t = b - e.clientY;
                        m.setValue(m.getValue() + t * m.__impliedStep),
                            b = e.clientY
                    }
                    function f() {
                        c["default"].unbind(window, "mousemove", d),
                            c["default"].unbind(window, "mouseup", f),
                            s()
                    }
                    function p(e) {
                        c["default"].bind(window, "mousemove", d),
                            c["default"].bind(window, "mouseup", f),
                            b = e.clientY
                    }
                    i(this, t);
                    var h = r(this, e.call(this, n, o, a));
                    h.__truncationSuspended = !1;
                    var m = h
                        , b = void 0;
                    return h.__input = document.createElement("input"),
                        h.__input.setAttribute("type", "text"),
                        c["default"].bind(h.__input, "change", l),
                        c["default"].bind(h.__input, "blur", u),
                        c["default"].bind(h.__input, "mousedown", p),
                        c["default"].bind(h.__input, "keydown", function(e) {
                            13 === e.keyCode && (m.__truncationSuspended = !0,
                                this.blur(),
                                m.__truncationSuspended = !1,
                                s())
                        }),
                        h.updateDisplay(),
                        h.domElement.appendChild(h.__input),
                        h
                }
                return a(t, e),
                    t.prototype.updateDisplay = function() {
                        return this.__input.value = this.__truncationSuspended ? this.getValue() : l(this.getValue(), this.__precision),
                            e.prototype.updateDisplay.call(this)
                    }
                    ,
                    t
            }(u["default"]);
            t["default"] = p
        }
        , function(e, t, n) {
            "use strict";
            function o(e) {
                return e && e.__esModule ? e : {
                    "default": e
                }
            }
            function i(e, t) {
                if (!(e instanceof t))
                    throw new TypeError("Cannot call a class as a function")
            }
            function r(e, t) {
                if (!e)
                    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return !t || "object" != typeof t && "function" != typeof t ? e : t
            }
            function a(e, t) {
                if ("function" != typeof t && null !== t)
                    throw new TypeError("Super expression must either be null or a function, not " + typeof t);
                e.prototype = Object.create(t && t.prototype, {
                    constructor: {
                        value: e,
                        enumerable: !1,
                        writable: !0,
                        configurable: !0
                    }
                }),
                t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t)
            }
            function l(e, t, n, o, i) {
                return o + (i - o) * ((e - t) / (n - t))
            }
            t.__esModule = !0;
            var s = n(12)
                , u = o(s)
                , d = n(9)
                , c = o(d)
                , f = function(e) {
                function t(n, o, a, s, u) {
                    function d(e) {
                        document.activeElement.blur(),
                            c["default"].bind(window, "mousemove", f),
                            c["default"].bind(window, "mouseup", _),
                            f(e)
                    }
                    function f(e) {
                        e.preventDefault();
                        var t = h.__background.getBoundingClientRect();
                        return h.setValue(l(e.clientX, t.left, t.right, h.__min, h.__max)),
                            !1
                    }
                    function _() {
                        c["default"].unbind(window, "mousemove", f),
                            c["default"].unbind(window, "mouseup", _),
                        h.__onFinishChange && h.__onFinishChange.call(h, h.getValue())
                    }
                    i(this, t);
                    var p = r(this, e.call(this, n, o, {
                        min: a,
                        max: s,
                        step: u
                    }))
                        , h = p;
                    return p.__background = document.createElement("div"),
                        p.__foreground = document.createElement("div"),
                        c["default"].bind(p.__background, "mousedown", d),
                        c["default"].addClass(p.__background, "slider"),
                        c["default"].addClass(p.__foreground, "slider-fg"),
                        p.updateDisplay(),
                        p.__background.appendChild(p.__foreground),
                        p.domElement.appendChild(p.__background),
                        p
                }
                return a(t, e),
                    t.prototype.updateDisplay = function() {
                        var t = (this.getValue() - this.__min) / (this.__max - this.__min);
                        return this.__foreground.style.width = 100 * t + "%",
                            e.prototype.updateDisplay.call(this)
                    }
                    ,
                    t
            }(u["default"]);
            t["default"] = f
        }
        , function(e, t, n) {
            "use strict";
            function o(e) {
                return e && e.__esModule ? e : {
                    "default": e
                }
            }
            function i(e, t) {
                if (!(e instanceof t))
                    throw new TypeError("Cannot call a class as a function")
            }
            function r(e, t) {
                if (!e)
                    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return !t || "object" != typeof t && "function" != typeof t ? e : t
            }
            function a(e, t) {
                if ("function" != typeof t && null !== t)
                    throw new TypeError("Super expression must either be null or a function, not " + typeof t);
                e.prototype = Object.create(t && t.prototype, {
                    constructor: {
                        value: e,
                        enumerable: !1,
                        writable: !0,
                        configurable: !0
                    }
                }),
                t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t)
            }
            t.__esModule = !0;
            var l = n(7)
                , s = o(l)
                , u = n(9)
                , d = o(u)
                , c = function(e) {
                function t(n, o, a) {
                    i(this, t);
                    var l = r(this, e.call(this, n, o))
                        , s = l;
                    return l.__button = document.createElement("div"),
                        l.__button.innerHTML = void 0 === a ? "Fire" : a,
                        d["default"].bind(l.__button, "click", function(e) {
                            return e.preventDefault(),
                                s.fire(),
                                !1
                        }),
                        d["default"].addClass(l.__button, "button"),
                        l.domElement.appendChild(l.__button),
                        l
                }
                return a(t, e),
                    t.prototype.fire = function() {
                        this.__onChange && this.__onChange.call(this),
                            this.getValue().call(this.object),
                        this.__onFinishChange && this.__onFinishChange.call(this, this.getValue())
                    }
                    ,
                    t
            }(s["default"]);
            t["default"] = c
        }
        , function(e, t, n) {
            "use strict";
            function o(e) {
                return e && e.__esModule ? e : {
                    "default": e
                }
            }
            function i(e, t) {
                if (!(e instanceof t))
                    throw new TypeError("Cannot call a class as a function")
            }
            function r(e, t) {
                if (!e)
                    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return !t || "object" != typeof t && "function" != typeof t ? e : t
            }
            function a(e, t) {
                if ("function" != typeof t && null !== t)
                    throw new TypeError("Super expression must either be null or a function, not " + typeof t);
                e.prototype = Object.create(t && t.prototype, {
                    constructor: {
                        value: e,
                        enumerable: !1,
                        writable: !0,
                        configurable: !0
                    }
                }),
                t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t)
            }
            function l(e, t, n, o) {
                e.style.background = "",
                    g["default"].each(y, function(i) {
                        e.style.cssText += "background: " + i + "linear-gradient(" + t + ", " + n + " 0%, " + o + " 100%); "
                    })
            }
            function s(e) {
                e.style.background = "",
                    e.style.cssText += "background: -moz-linear-gradient(top,  #ff0000 0%, #ff00ff 17%, #0000ff 34%, #00ffff 50%, #00ff00 67%, #ffff00 84%, #ff0000 100%);",
                    e.style.cssText += "background: -webkit-linear-gradient(top,  #ff0000 0%,#ff00ff 17%,#0000ff 34%,#00ffff 50%,#00ff00 67%,#ffff00 84%,#ff0000 100%);",
                    e.style.cssText += "background: -o-linear-gradient(top,  #ff0000 0%,#ff00ff 17%,#0000ff 34%,#00ffff 50%,#00ff00 67%,#ffff00 84%,#ff0000 100%);",
                    e.style.cssText += "background: -ms-linear-gradient(top,  #ff0000 0%,#ff00ff 17%,#0000ff 34%,#00ffff 50%,#00ff00 67%,#ffff00 84%,#ff0000 100%);",
                    e.style.cssText += "background: linear-gradient(top,  #ff0000 0%,#ff00ff 17%,#0000ff 34%,#00ffff 50%,#00ff00 67%,#ffff00 84%,#ff0000 100%);"
            }
            t.__esModule = !0;
            var u = n(7)
                , d = o(u)
                , c = n(9)
                , f = o(c)
                , _ = n(2)
                , p = o(_)
                , h = n(3)
                , m = o(h)
                , b = n(5)
                , g = o(b)
                , v = function(e) {
                function t(n, o) {
                    function a(e) {
                        h(e),
                            f["default"].bind(window, "mousemove", h),
                            f["default"].bind(window, "mouseup", u)
                    }
                    function u() {
                        f["default"].unbind(window, "mousemove", h),
                            f["default"].unbind(window, "mouseup", u),
                            _()
                    }
                    function d() {
                        var e = (0,
                            m["default"])(this.value);
                        e !== !1 ? (y.__color.__state = e,
                            y.setValue(y.__color.toOriginal())) : this.value = y.__color.toString()
                    }
                    function c() {
                        f["default"].unbind(window, "mousemove", b),
                            f["default"].unbind(window, "mouseup", c),
                            _()
                    }
                    function _() {
                        y.__onFinishChange && y.__onFinishChange.call(y, y.__color.toOriginal())
                    }
                    function h(e) {
                        e.preventDefault();
                        var t = y.__saturation_field.getBoundingClientRect()
                            , n = (e.clientX - t.left) / (t.right - t.left)
                            , o = 1 - (e.clientY - t.top) / (t.bottom - t.top);
                        return o > 1 ? o = 1 : o < 0 && (o = 0),
                            n > 1 ? n = 1 : n < 0 && (n = 0),
                            y.__color.v = o,
                            y.__color.s = n,
                            y.setValue(y.__color.toOriginal()),
                            !1
                    }
                    function b(e) {
                        e.preventDefault();
                        var t = y.__hue_field.getBoundingClientRect()
                            , n = 1 - (e.clientY - t.top) / (t.bottom - t.top);
                        return n > 1 ? n = 1 : n < 0 && (n = 0),
                            y.__color.h = 360 * n,
                            y.setValue(y.__color.toOriginal()),
                            !1
                    }
                    i(this, t);
                    var v = r(this, e.call(this, n, o));
                    v.__color = new p["default"](v.getValue()),
                        v.__temp = new p["default"](0);
                    var y = v;
                    v.domElement = document.createElement("div"),
                        f["default"].makeSelectable(v.domElement, !1),
                        v.__selector = document.createElement("div"),
                        v.__selector.className = "selector",
                        v.__saturation_field = document.createElement("div"),
                        v.__saturation_field.className = "saturation-field",
                        v.__field_knob = document.createElement("div"),
                        v.__field_knob.className = "field-knob",
                        v.__field_knob_border = "2px solid ",
                        v.__hue_knob = document.createElement("div"),
                        v.__hue_knob.className = "hue-knob",
                        v.__hue_field = document.createElement("div"),
                        v.__hue_field.className = "hue-field",
                        v.__input = document.createElement("input"),
                        v.__input.type = "text",
                        v.__input_textShadow = "0 1px 1px ",
                        f["default"].bind(v.__input, "keydown", function(e) {
                            13 === e.keyCode && d.call(this)
                        }),
                        f["default"].bind(v.__input, "blur", d),
                        f["default"].bind(v.__selector, "mousedown", function() {
                            f["default"].addClass(this, "drag").bind(window, "mouseup", function() {
                                f["default"].removeClass(y.__selector, "drag")
                            })
                        });
                    var w = document.createElement("div");
                    return g["default"].extend(v.__selector.style, {
                        width: "122px",
                        height: "102px",
                        padding: "3px",
                        backgroundColor: "#222",
                        boxShadow: "0px 1px 3px rgba(0,0,0,0.3)"
                    }),
                        g["default"].extend(v.__field_knob.style, {
                            position: "absolute",
                            width: "12px",
                            height: "12px",
                            border: v.__field_knob_border + (v.__color.v < .5 ? "#fff" : "#000"),
                            boxShadow: "0px 1px 3px rgba(0,0,0,0.5)",
                            borderRadius: "12px",
                            zIndex: 1
                        }),
                        g["default"].extend(v.__hue_knob.style, {
                            position: "absolute",
                            width: "15px",
                            height: "2px",
                            borderRight: "4px solid #fff",
                            zIndex: 1
                        }),
                        g["default"].extend(v.__saturation_field.style, {
                            width: "100px",
                            height: "100px",
                            border: "1px solid #555",
                            marginRight: "3px",
                            display: "inline-block",
                            cursor: "pointer"
                        }),
                        g["default"].extend(w.style, {
                            width: "100%",
                            height: "100%",
                            background: "none"
                        }),
                        l(w, "top", "rgba(0,0,0,0)", "#000"),
                        g["default"].extend(v.__hue_field.style, {
                            width: "15px",
                            height: "100px",
                            border: "1px solid #555",
                            cursor: "ns-resize",
                            position: "absolute",
                            top: "3px",
                            right: "3px"
                        }),
                        s(v.__hue_field),
                        g["default"].extend(v.__input.style, {
                            outline: "none",
                            textAlign: "center",
                            color: "#fff",
                            border: 0,
                            fontWeight: "bold",
                            textShadow: v.__input_textShadow + "rgba(0,0,0,0.7)"
                        }),
                        f["default"].bind(v.__saturation_field, "mousedown", a),
                        f["default"].bind(v.__field_knob, "mousedown", a),
                        f["default"].bind(v.__hue_field, "mousedown", function(e) {
                            b(e),
                                f["default"].bind(window, "mousemove", b),
                                f["default"].bind(window, "mouseup", c)
                        }),
                        v.__saturation_field.appendChild(w),
                        v.__selector.appendChild(v.__field_knob),
                        v.__selector.appendChild(v.__saturation_field),
                        v.__selector.appendChild(v.__hue_field),
                        v.__hue_field.appendChild(v.__hue_knob),
                        v.domElement.appendChild(v.__input),
                        v.domElement.appendChild(v.__selector),
                        v.updateDisplay(),
                        v
                }
                return a(t, e),
                    t.prototype.updateDisplay = function() {
                        var e = (0,
                            m["default"])(this.getValue());
                        if (e !== !1) {
                            var t = !1;
                            g["default"].each(p["default"].COMPONENTS, function(n) {
                                if (!g["default"].isUndefined(e[n]) && !g["default"].isUndefined(this.__color.__state[n]) && e[n] !== this.__color.__state[n])
                                    return t = !0,
                                        {}
                            }, this),
                            t && g["default"].extend(this.__color.__state, e)
                        }
                        g["default"].extend(this.__temp.__state, this.__color.__state),
                            this.__temp.a = 1;
                        var n = this.__color.v < .5 || this.__color.s > .5 ? 255 : 0
                            , o = 255 - n;
                        g["default"].extend(this.__field_knob.style, {
                            marginLeft: 100 * this.__color.s - 7 + "px",
                            marginTop: 100 * (1 - this.__color.v) - 7 + "px",
                            backgroundColor: this.__temp.toHexString(),
                            border: this.__field_knob_border + "rgb(" + n + "," + n + "," + n + ")"
                        }),
                            this.__hue_knob.style.marginTop = 100 * (1 - this.__color.h / 360) + "px",
                            this.__temp.s = 1,
                            this.__temp.v = 1,
                            l(this.__saturation_field, "left", "#fff", this.__temp.toHexString()),
                            this.__input.value = this.__color.toString(),
                            g["default"].extend(this.__input.style, {
                                backgroundColor: this.__color.toHexString(),
                                color: "rgb(" + n + "," + n + "," + n + ")",
                                textShadow: this.__input_textShadow + "rgba(" + o + "," + o + "," + o + ",.7)"
                            })
                    }
                    ,
                    t
            }(d["default"])
                , y = ["-moz-", "-o-", "-webkit-", "-ms-", ""];
            t["default"] = v
        }
        , function(e, t, n) {
            "use strict";
            function o(e) {
                return e && e.__esModule ? e : {
                    "default": e
                }
            }
            function i(e, t, n) {
                var o = document.createElement("li");
                return t && o.appendChild(t),
                    n ? e.__ul.insertBefore(o, n) : e.__ul.appendChild(o),
                    e.onResize(),
                    o
            }
            function r(e, t) {
                var n = e.__preset_select[e.__preset_select.selectedIndex];
                t ? n.innerHTML = n.value + "*" : n.innerHTML = n.value
            }
            function a(e, t, n) {
                if (n.__li = t,
                    n.__gui = e,
                    U["default"].extend(n, {
                        options: function(t) {
                            if (arguments.length > 1) {
                                var o = n.__li.nextElementSibling;
                                return n.remove(),
                                    s(e, n.object, n.property, {
                                        before: o,
                                        factoryArgs: [U["default"].toArray(arguments)]
                                    })
                            }
                            if (U["default"].isArray(t) || U["default"].isObject(t)) {
                                var i = n.__li.nextElementSibling;
                                return n.remove(),
                                    s(e, n.object, n.property, {
                                        before: i,
                                        factoryArgs: [t]
                                    })
                            }
                        },
                        name: function(e) {
                            return n.__li.firstElementChild.firstElementChild.innerHTML = e,
                                n
                        },
                        listen: function() {
                            return n.__gui.listen(n),
                                n
                        },
                        remove: function() {
                            return n.__gui.remove(n),
                                n
                        }
                    }),
                n instanceof B["default"])
                    !function() {
                        var e = new N["default"](n.object,n.property,{
                            min: n.__min,
                            max: n.__max,
                            step: n.__step
                        });
                        U["default"].each(["updateDisplay", "onChange", "onFinishChange", "step"], function(t) {
                            var o = n[t]
                                , i = e[t];
                            n[t] = e[t] = function() {
                                var t = Array.prototype.slice.call(arguments);
                                return i.apply(e, t),
                                    o.apply(n, t)
                            }
                        }),
                            z["default"].addClass(t, "has-slider"),
                            n.domElement.insertBefore(e.domElement, n.domElement.firstElementChild)
                    }();
                else if (n instanceof N["default"]) {
                    var o = function(t) {
                        if (U["default"].isNumber(n.__min) && U["default"].isNumber(n.__max)) {
                            var o = n.__li.firstElementChild.firstElementChild.innerHTML
                                , i = n.__gui.__listening.indexOf(n) > -1;
                            n.remove();
                            var r = s(e, n.object, n.property, {
                                before: n.__li.nextElementSibling,
                                factoryArgs: [n.__min, n.__max, n.__step]
                            });
                            return r.name(o),
                            i && r.listen(),
                                r
                        }
                        return t
                    };
                    n.min = U["default"].compose(o, n.min),
                        n.max = U["default"].compose(o, n.max)
                } else
                    n instanceof O["default"] ? (z["default"].bind(t, "click", function() {
                        z["default"].fakeEvent(n.__checkbox, "click")
                    }),
                        z["default"].bind(n.__checkbox, "click", function(e) {
                            e.stopPropagation()
                        })) : n instanceof R["default"] ? (z["default"].bind(t, "click", function() {
                        z["default"].fakeEvent(n.__button, "click")
                    }),
                        z["default"].bind(t, "mouseover", function() {
                            z["default"].addClass(n.__button, "hover")
                        }),
                        z["default"].bind(t, "mouseout", function() {
                            z["default"].removeClass(n.__button, "hover")
                        })) : n instanceof j["default"] && (z["default"].addClass(t, "color"),
                        n.updateDisplay = U["default"].compose(function(e) {
                            return t.style.borderLeftColor = n.__color.toString(),
                                e
                        }, n.updateDisplay),
                        n.updateDisplay());
                n.setValue = U["default"].compose(function(t) {
                    return e.getRoot().__preset_select && n.isModified() && r(e.getRoot(), !0),
                        t
                }, n.setValue)
            }
            function l(e, t) {
                var n = e.getRoot()
                    , o = n.__rememberedObjects.indexOf(t.object);
                if (o !== -1) {
                    var i = n.__rememberedObjectIndecesToControllers[o];
                    if (void 0 === i && (i = {},
                        n.__rememberedObjectIndecesToControllers[o] = i),
                        i[t.property] = t,
                    n.load && n.load.remembered) {
                        var r = n.load.remembered
                            , a = void 0;
                        if (r[e.preset])
                            a = r[e.preset];
                        else {
                            if (!r[Q])
                                return;
                            a = r[Q]
                        }
                        if (a[o] && void 0 !== a[o][t.property]) {
                            var l = a[o][t.property];
                            t.initialValue = l,
                                t.setValue(l)
                        }
                    }
                }
            }
            function s(e, t, n, o) {
                if (void 0 === t[n])
                    throw new Error('Object "' + t + '" has no property "' + n + '"');
                var r = void 0;
                if (o.color)
                    r = new j["default"](t,n);
                else {
                    var s = [t, n].concat(o.factoryArgs);
                    r = C["default"].apply(e, s)
                }
                o.before instanceof S["default"] && (o.before = o.before.__li),
                    l(e, r),
                    z["default"].addClass(r.domElement, "c");
                var u = document.createElement("span");
                z["default"].addClass(u, "property-name"),
                    u.innerHTML = r.property;
                var d = document.createElement("div");
                d.appendChild(u),
                    d.appendChild(r.domElement);
                var c = i(e, d, o.before);
                return z["default"].addClass(c, oe.CLASS_CONTROLLER_ROW),
                    r instanceof j["default"] ? z["default"].addClass(c, "color") : z["default"].addClass(c, g(r.getValue())),
                    a(e, c, r),
                    e.__controllers.push(r),
                    r
            }
            function u(e, t) {
                return document.location.href + "." + t
            }
            function d(e, t, n) {
                var o = document.createElement("option");
                o.innerHTML = t,
                    o.value = t,
                    e.__preset_select.appendChild(o),
                n && (e.__preset_select.selectedIndex = e.__preset_select.length - 1)
            }
            function c(e, t) {
                t.style.display = e.useLocalStorage ? "block" : "none"
            }
            function f(e) {
                var t = e.__save_row = document.createElement("li");
                z["default"].addClass(e.domElement, "has-save"),
                    e.__ul.insertBefore(t, e.__ul.firstChild),
                    z["default"].addClass(t, "save-row");
                var n = document.createElement("span");
                n.innerHTML = "&nbsp;",
                    z["default"].addClass(n, "button gears");
                var o = document.createElement("span");
                o.innerHTML = "Save",
                    z["default"].addClass(o, "button"),
                    z["default"].addClass(o, "save");
                var i = document.createElement("span");
                i.innerHTML = "New",
                    z["default"].addClass(i, "button"),
                    z["default"].addClass(i, "save-as");
                var r = document.createElement("span");
                r.innerHTML = "Revert",
                    z["default"].addClass(r, "button"),
                    z["default"].addClass(r, "revert");
                var a = e.__preset_select = document.createElement("select");
                e.load && e.load.remembered ? U["default"].each(e.load.remembered, function(t, n) {
                    d(e, n, n === e.preset)
                }) : d(e, Q, !1),
                    z["default"].bind(a, "change", function() {
                        for (var t = 0; t < e.__preset_select.length; t++)
                            e.__preset_select[t].innerHTML = e.__preset_select[t].value;
                        e.preset = this.value
                    }),
                    t.appendChild(a),
                    t.appendChild(n),
                    t.appendChild(o),
                    t.appendChild(i),
                    t.appendChild(r),
                q && !function() {
                    var t = document.getElementById("dg-local-explain")
                        , n = document.getElementById("dg-local-storage")
                        , o = document.getElementById("dg-save-locally");
                    o.style.display = "block",
                    "true" === localStorage.getItem(u(e, "isLocal")) && n.setAttribute("checked", "checked"),
                        c(e, t),
                        z["default"].bind(n, "change", function() {
                            e.useLocalStorage = !e.useLocalStorage,
                                c(e, t)
                        })
                }();
                var l = document.getElementById("dg-new-constructor");
                z["default"].bind(l, "keydown", function(e) {
                    !e.metaKey || 67 !== e.which && 67 !== e.keyCode || Z.hide()
                }),
                    z["default"].bind(n, "click", function() {
                        l.innerHTML = JSON.stringify(e.getSaveObject(), void 0, 2),
                            Z.show(),
                            l.focus(),
                            l.select()
                    }),
                    z["default"].bind(o, "click", function() {
                        e.save()
                    }),
                    z["default"].bind(i, "click", function() {
                        var t = prompt("Enter a new preset name.");
                        t && e.saveAs(t)
                    }),
                    z["default"].bind(r, "click", function() {
                        e.revert()
                    })
            }
            function _(e) {
                function t(t) {
                    return t.preventDefault(),
                        e.width += i - t.clientX,
                        e.onResize(),
                        i = t.clientX,
                        !1
                }
                function n() {
                    z["default"].removeClass(e.__closeButton, oe.CLASS_DRAG),
                        z["default"].unbind(window, "mousemove", t),
                        z["default"].unbind(window, "mouseup", n)
                }
                function o(o) {
                    return o.preventDefault(),
                        i = o.clientX,
                        z["default"].addClass(e.__closeButton, oe.CLASS_DRAG),
                        z["default"].bind(window, "mousemove", t),
                        z["default"].bind(window, "mouseup", n),
                        !1
                }
                var i = void 0;
                e.__resize_handle = document.createElement("div"),
                    U["default"].extend(e.__resize_handle.style, {
                        width: "6px",
                        marginLeft: "-3px",
                        height: "200px",
                        cursor: "ew-resize",
                        position: "absolute"
                    }),
                    z["default"].bind(e.__resize_handle, "mousedown", o),
                    z["default"].bind(e.__closeButton, "mousedown", o),
                    e.domElement.insertBefore(e.__resize_handle, e.domElement.firstElementChild)
            }
            function p(e, t) {
                e.domElement.style.width = t + "px",
                e.__save_row && e.autoPlace && (e.__save_row.style.width = t + "px"),
                e.__closeButton && (e.__closeButton.style.width = t + "px")
            }
            function h(e, t) {
                var n = {};
                return U["default"].each(e.__rememberedObjects, function(o, i) {
                    var r = {}
                        , a = e.__rememberedObjectIndecesToControllers[i];
                    U["default"].each(a, function(e, n) {
                        r[n] = t ? e.initialValue : e.getValue()
                    }),
                        n[i] = r
                }),
                    n
            }
            function m(e) {
                for (var t = 0; t < e.__preset_select.length; t++)
                    e.__preset_select[t].value === e.preset && (e.__preset_select.selectedIndex = t)
            }
            function b(e) {
                0 !== e.length && D["default"].call(window, function() {
                    b(e)
                }),
                    U["default"].each(e, function(e) {
                        e.updateDisplay()
                    })
            }
            var g = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                    return typeof e
                }
                : function(e) {
                    return e && "function" == typeof Symbol && e.constructor === Symbol ? "symbol" : typeof e
                }
                , v = n(18)
                , y = o(v)
                , w = n(19)
                , x = o(w)
                , E = n(20)
                , C = o(E)
                , A = n(7)
                , S = o(A)
                , k = n(8)
                , O = o(k)
                , T = n(15)
                , R = o(T)
                , L = n(13)
                , N = o(L)
                , M = n(14)
                , B = o(M)
                , H = n(16)
                , j = o(H)
                , P = n(21)
                , D = o(P)
                , V = n(22)
                , F = o(V)
                , I = n(9)
                , z = o(I)
                , G = n(5)
                , U = o(G)
                , X = n(23)
                , K = o(X);
            y["default"].inject(K["default"]);
            var Y = "dg"
                , J = 72
                , W = 20
                , Q = "Default"
                , q = function() {
                try {
                    return "localStorage"in window && null !== window.localStorage
                } catch (e) {
                    return !1
                }
            }()
                , Z = void 0
                , $ = !0
                , ee = void 0
                , te = !1
                , ne = []
                , oe = function ie(e) {
                function t() {
                    var e = n.getRoot();
                    e.width += 1,
                        U["default"].defer(function() {
                            e.width -= 1
                        })
                }
                var n = this
                    , o = e || {};
                this.domElement = document.createElement("div"),
                    this.__ul = document.createElement("ul"),
                    this.domElement.appendChild(this.__ul),
                    z["default"].addClass(this.domElement, Y),
                    this.__folders = {},
                    this.__controllers = [],
                    this.__rememberedObjects = [],
                    this.__rememberedObjectIndecesToControllers = [],
                    this.__listening = [],
                    o = U["default"].defaults(o, {
                        autoPlace: !0,
                        width: ie.DEFAULT_WIDTH
                    }),
                    o = U["default"].defaults(o, {
                        resizable: o.autoPlace,
                        hideable: o.autoPlace
                    }),
                    U["default"].isUndefined(o.load) ? o.load = {
                        preset: Q
                    } : o.preset && (o.load.preset = o.preset),
                U["default"].isUndefined(o.parent) && o.hideable && ne.push(this),
                    o.resizable = U["default"].isUndefined(o.parent) && o.resizable,
                o.autoPlace && U["default"].isUndefined(o.scrollable) && (o.scrollable = !0);
                var r = q && "true" === localStorage.getItem(u(this, "isLocal"))
                    , a = void 0;
                if (Object.defineProperties(this, {
                    parent: {
                        get: function() {
                            return o.parent
                        }
                    },
                    scrollable: {
                        get: function() {
                            return o.scrollable
                        }
                    },
                    autoPlace: {
                        get: function() {
                            return o.autoPlace
                        }
                    },
                    preset: {
                        get: function() {
                            return n.parent ? n.getRoot().preset : o.load.preset
                        },
                        set: function(e) {
                            n.parent ? n.getRoot().preset = e : o.load.preset = e,
                                m(this),
                                n.revert()
                        }
                    },
                    width: {
                        get: function() {
                            return o.width
                        },
                        set: function(e) {
                            o.width = e,
                                p(n, e)
                        }
                    },
                    name: {
                        get: function() {
                            return o.name
                        },
                        set: function(e) {
                            o.name = e,
                            titleRowName && (titleRowName.innerHTML = o.name)
                        }
                    },
                    closed: {
                        get: function() {
                            return o.closed
                        },
                        set: function(e) {
                            o.closed = e,
                                o.closed ? z["default"].addClass(n.__ul, ie.CLASS_CLOSED) : z["default"].removeClass(n.__ul, ie.CLASS_CLOSED),
                                this.onResize(),
                            n.__closeButton && (n.__closeButton.innerHTML = e ? ie.TEXT_OPEN : ie.TEXT_CLOSED)
                        }
                    },
                    load: {
                        get: function() {
                            return o.load
                        }
                    },
                    useLocalStorage: {
                        get: function() {
                            return r
                        },
                        set: function(e) {
                            q && (r = e,
                                e ? z["default"].bind(window, "unload", a) : z["default"].unbind(window, "unload", a),
                                localStorage.setItem(u(n, "isLocal"), e))
                        }
                    }
                }),
                    U["default"].isUndefined(o.parent)) {
                    if (o.closed = !1,
                        z["default"].addClass(this.domElement, ie.CLASS_MAIN),
                        z["default"].makeSelectable(this.domElement, !1),
                    q && r) {
                        n.useLocalStorage = !0;
                        var l = localStorage.getItem(u(this, "gui"));
                        l && (o.load = JSON.parse(l))
                    }
                    this.__closeButton = document.createElement("div"),
                        this.__closeButton.innerHTML = ie.TEXT_CLOSED,
                        z["default"].addClass(this.__closeButton, ie.CLASS_CLOSE_BUTTON),
                        this.domElement.appendChild(this.__closeButton),
                        z["default"].bind(this.__closeButton, "click", function() {
                            n.closed = !n.closed
                        })
                } else {
                    void 0 === o.closed && (o.closed = !0);
                    var s = document.createTextNode(o.name);
                    z["default"].addClass(s, "controller-name");
                    var d = i(n, s)
                        , c = function(e) {
                        return e.preventDefault(),
                            n.closed = !n.closed,
                            !1
                    };
                    z["default"].addClass(this.__ul, ie.CLASS_CLOSED),
                        z["default"].addClass(d, "title"),
                        z["default"].bind(d, "click", c),
                    o.closed || (this.closed = !1)
                }
                o.autoPlace && (U["default"].isUndefined(o.parent) && ($ && (ee = document.createElement("div"),
                    z["default"].addClass(ee, Y),
                    z["default"].addClass(ee, ie.CLASS_AUTO_PLACE_CONTAINER),
                    document.body.appendChild(ee),
                    $ = !1),
                    ee.appendChild(this.domElement),
                    z["default"].addClass(this.domElement, ie.CLASS_AUTO_PLACE)),
                this.parent || p(n, o.width)),
                    this.__resizeHandler = function() {
                        n.onResizeDebounced()
                    }
                    ,
                    z["default"].bind(window, "resize", this.__resizeHandler),
                    z["default"].bind(this.__ul, "webkitTransitionEnd", this.__resizeHandler),
                    z["default"].bind(this.__ul, "transitionend", this.__resizeHandler),
                    z["default"].bind(this.__ul, "oTransitionEnd", this.__resizeHandler),
                    this.onResize(),
                o.resizable && _(this),
                    a = function() {
                        q && "true" === localStorage.getItem(u(n, "isLocal")) && localStorage.setItem(u(n, "gui"), JSON.stringify(n.getSaveObject()))
                    }
                    ,
                    this.saveToLocalStorageIfPossible = a,
                o.parent || t()
            };
            oe.toggleHide = function() {
                te = !te,
                    U["default"].each(ne, function(e) {
                        e.domElement.style.display = te ? "none" : ""
                    })
            }
                ,
                oe.CLASS_AUTO_PLACE = "a",
                oe.CLASS_AUTO_PLACE_CONTAINER = "ac",
                oe.CLASS_MAIN = "main",
                oe.CLASS_CONTROLLER_ROW = "cr",
                oe.CLASS_TOO_TALL = "taller-than-window",
                oe.CLASS_CLOSED = "closed",
                oe.CLASS_CLOSE_BUTTON = "close-button",
                oe.CLASS_DRAG = "drag",
                oe.DEFAULT_WIDTH = 245,
                oe.TEXT_CLOSED = "Close Controls",
                oe.TEXT_OPEN = "Open Controls",
                oe._keydownHandler = function(e) {
                    "text" === document.activeElement.type || e.which !== J && e.keyCode !== J || oe.toggleHide()
                }
                ,
                z["default"].bind(window, "keydown", oe._keydownHandler, !1),
                U["default"].extend(oe.prototype, {
                    add: function(e, t) {
                        return s(this, e, t, {
                            factoryArgs: Array.prototype.slice.call(arguments, 2)
                        })
                    },
                    addColor: function(e, t) {
                        return s(this, e, t, {
                            color: !0
                        })
                    },
                    remove: function(e) {
                        this.__ul.removeChild(e.__li),
                            this.__controllers.splice(this.__controllers.indexOf(e), 1);
                        var t = this;
                        U["default"].defer(function() {
                            t.onResize()
                        })
                    },
                    destroy: function() {
                        this.autoPlace && ee.removeChild(this.domElement),
                            z["default"].unbind(window, "keydown", oe._keydownHandler, !1),
                            z["default"].unbind(window, "resize", this.__resizeHandler),
                        this.saveToLocalStorageIfPossible && z["default"].unbind(window, "unload", this.saveToLocalStorageIfPossible)
                    },
                    addFolder: function(e) {
                        if (void 0 !== this.__folders[e])
                            throw new Error('You already have a folder in this GUI by the name "' + e + '"');
                        var t = {
                            name: e,
                            parent: this
                        };
                        t.autoPlace = this.autoPlace,
                        this.load && this.load.folders && this.load.folders[e] && (t.closed = this.load.folders[e].closed,
                            t.load = this.load.folders[e]);
                        var n = new oe(t);
                        this.__folders[e] = n;
                        var o = i(this, n.domElement);
                        return z["default"].addClass(o, "folder"),
                            n
                    },
                    open: function() {
                        this.closed = !1
                    },
                    close: function() {
                        this.closed = !0
                    },
                    onResize: function() {
                        var e = this.getRoot();
                        if (e.scrollable) {
                            var t = z["default"].getOffset(e.__ul).top
                                , n = 0;
                            U["default"].each(e.__ul.childNodes, function(t) {
                                e.autoPlace && t === e.__save_row || (n += z["default"].getHeight(t))
                            }),
                                window.innerHeight - t - W < n ? (z["default"].addClass(e.domElement, oe.CLASS_TOO_TALL),
                                    e.__ul.style.height = window.innerHeight - t - W + "px") : (z["default"].removeClass(e.domElement, oe.CLASS_TOO_TALL),
                                    e.__ul.style.height = "auto")
                        }
                        e.__resize_handle && U["default"].defer(function() {
                            e.__resize_handle.style.height = e.__ul.offsetHeight + "px"
                        }),
                        e.__closeButton && (e.__closeButton.style.width = e.width + "px")
                    },
                    onResizeDebounced: U["default"].debounce(function() {
                        this.onResize()
                    }, 200),
                    remember: function() {
                        if (U["default"].isUndefined(Z) && (Z = new F["default"],
                            Z.domElement.innerHTML = x["default"]),
                            this.parent)
                            throw new Error("You can only call remember on a top level GUI.");
                        var e = this;
                        U["default"].each(Array.prototype.slice.call(arguments), function(t) {
                            0 === e.__rememberedObjects.length && f(e),
                            e.__rememberedObjects.indexOf(t) === -1 && e.__rememberedObjects.push(t)
                        }),
                        this.autoPlace && p(this, this.width)
                    },
                    getRoot: function() {
                        for (var e = this; e.parent; )
                            e = e.parent;
                        return e
                    },
                    getSaveObject: function() {
                        var e = this.load;
                        return e.closed = this.closed,
                        this.__rememberedObjects.length > 0 && (e.preset = this.preset,
                        e.remembered || (e.remembered = {}),
                            e.remembered[this.preset] = h(this)),
                            e.folders = {},
                            U["default"].each(this.__folders, function(t, n) {
                                e.folders[n] = t.getSaveObject()
                            }),
                            e
                    },
                    save: function() {
                        this.load.remembered || (this.load.remembered = {}),
                            this.load.remembered[this.preset] = h(this),
                            r(this, !1),
                            this.saveToLocalStorageIfPossible()
                    },
                    saveAs: function(e) {
                        this.load.remembered || (this.load.remembered = {},
                            this.load.remembered[Q] = h(this, !0)),
                            this.load.remembered[e] = h(this),
                            this.preset = e,
                            d(this, e, !0),
                            this.saveToLocalStorageIfPossible()
                    },
                    revert: function(e) {
                        U["default"].each(this.__controllers, function(t) {
                            this.getRoot().load.remembered ? l(e || this.getRoot(), t) : t.setValue(t.initialValue),
                            t.__onFinishChange && t.__onFinishChange.call(t, t.getValue())
                        }, this),
                            U["default"].each(this.__folders, function(e) {
                                e.revert(e)
                            }),
                        e || r(this.getRoot(), !1)
                    },
                    listen: function(e) {
                        var t = 0 === this.__listening.length;
                        this.__listening.push(e),
                        t && b(this.__listening)
                    },
                    updateDisplay: function() {
                        U["default"].each(this.__controllers, function(e) {
                            e.updateDisplay()
                        }),
                            U["default"].each(this.__folders, function(e) {
                                e.updateDisplay()
                            })
                    }
                }),
                e.exports = oe
        }
        , function(e, t) {
            "use strict";
            e.exports = {
                load: function(e, t) {
                    var n = t || document
                        , o = n.createElement("link");
                    o.type = "text/css",
                        o.rel = "stylesheet",
                        o.href = e,
                        n.getElementsByTagName("head")[0].appendChild(o)
                },
                inject: function(e, t) {
                    var n = t || document
                        , o = document.createElement("style");
                    o.type = "text/css",
                        o.innerHTML = e;
                    var i = n.getElementsByTagName("head")[0];
                    try {
                        i.appendChild(o)
                    } catch (r) {}
                }
            }
        }
        , function(e, t) {
            e.exports = "<div id=dg-save class=\"dg dialogue\"> Here's the new load parameter for your <code>GUI</code>'s constructor: <textarea id=dg-new-constructor></textarea> <div id=dg-save-locally> <input id=dg-local-storage type=checkbox /> Automatically save values to <code>localStorage</code> on exit. <div id=dg-local-explain>The values saved to <code>localStorage</code> will override those passed to <code>dat.GUI</code>'s constructor. This makes it easier to work incrementally, but <code>localStorage</code> is fragile, and your friends may not see the same values you do. </div> </div> </div>"
        }
        , function(e, t, n) {
            "use strict";
            function o(e) {
                return e && e.__esModule ? e : {
                    "default": e
                }
            }
            t.__esModule = !0;
            var i = n(10)
                , r = o(i)
                , a = n(13)
                , l = o(a)
                , s = n(14)
                , u = o(s)
                , d = n(11)
                , c = o(d)
                , f = n(15)
                , _ = o(f)
                , p = n(8)
                , h = o(p)
                , m = n(5)
                , b = o(m)
                , g = function(e, t) {
                var n = e[t];
                return b["default"].isArray(arguments[2]) || b["default"].isObject(arguments[2]) ? new r["default"](e,t,arguments[2]) : b["default"].isNumber(n) ? b["default"].isNumber(arguments[2]) && b["default"].isNumber(arguments[3]) ? b["default"].isNumber(arguments[4]) ? new u["default"](e,t,arguments[2],arguments[3],arguments[4]) : new u["default"](e,t,arguments[2],arguments[3]) : b["default"].isNumber(arguments[4]) ? new l["default"](e,t,{
                    min: arguments[2],
                    max: arguments[3],
                    step: arguments[4]
                }) : new l["default"](e,t,{
                    min: arguments[2],
                    max: arguments[3]
                }) : b["default"].isString(n) ? new c["default"](e,t) : b["default"].isFunction(n) ? new _["default"](e,t,"") : b["default"].isBoolean(n) ? new h["default"](e,t) : null
            };
            t["default"] = g
        }
        , function(e, t) {
            "use strict";
            function n(e) {
                setTimeout(e, 1e3 / 60)
            }
            t.__esModule = !0,
                t["default"] = window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || window.oRequestAnimationFrame || window.msRequestAnimationFrame || n
        }
        , function(e, t, n) {
            "use strict";
            function o(e) {
                return e && e.__esModule ? e : {
                    "default": e
                }
            }
            function i(e, t) {
                if (!(e instanceof t))
                    throw new TypeError("Cannot call a class as a function")
            }
            t.__esModule = !0;
            var r = n(9)
                , a = o(r)
                , l = n(5)
                , s = o(l)
                , u = function() {
                function e() {
                    i(this, e),
                        this.backgroundElement = document.createElement("div"),
                        s["default"].extend(this.backgroundElement.style, {
                            backgroundColor: "rgba(0,0,0,0.8)",
                            top: 0,
                            left: 0,
                            display: "none",
                            zIndex: "1000",
                            opacity: 0,
                            WebkitTransition: "opacity 0.2s linear",
                            transition: "opacity 0.2s linear"
                        }),
                        a["default"].makeFullscreen(this.backgroundElement),
                        this.backgroundElement.style.position = "fixed",
                        this.domElement = document.createElement("div"),
                        s["default"].extend(this.domElement.style, {
                            position: "fixed",
                            display: "none",
                            zIndex: "1001",
                            opacity: 0,
                            WebkitTransition: "-webkit-transform 0.2s ease-out, opacity 0.2s linear",
                            transition: "transform 0.2s ease-out, opacity 0.2s linear"
                        }),
                        document.body.appendChild(this.backgroundElement),
                        document.body.appendChild(this.domElement);
                    var t = this;
                    a["default"].bind(this.backgroundElement, "click", function() {
                        t.hide()
                    })
                }
                return e.prototype.show = function() {
                    var e = this;
                    this.backgroundElement.style.display = "block",
                        this.domElement.style.display = "block",
                        this.domElement.style.opacity = 0,
                        this.domElement.style.webkitTransform = "scale(1.1)",
                        this.layout(),
                        s["default"].defer(function() {
                            e.backgroundElement.style.opacity = 1,
                                e.domElement.style.opacity = 1,
                                e.domElement.style.webkitTransform = "scale(1)"
                        })
                }
                    ,
                    e.prototype.hide = function t() {
                        var e = this
                            , t = function n() {
                            e.domElement.style.display = "none",
                                e.backgroundElement.style.display = "none",
                                a["default"].unbind(e.domElement, "webkitTransitionEnd", n),
                                a["default"].unbind(e.domElement, "transitionend", n),
                                a["default"].unbind(e.domElement, "oTransitionEnd", n)
                        };
                        a["default"].bind(this.domElement, "webkitTransitionEnd", t),
                            a["default"].bind(this.domElement, "transitionend", t),
                            a["default"].bind(this.domElement, "oTransitionEnd", t),
                            this.backgroundElement.style.opacity = 0,
                            this.domElement.style.opacity = 0,
                            this.domElement.style.webkitTransform = "scale(1.1)"
                    }
                    ,
                    e.prototype.layout = function() {
                        this.domElement.style.left = window.innerWidth / 2 - a["default"].getWidth(this.domElement) / 2 + "px",
                            this.domElement.style.top = window.innerHeight / 2 - a["default"].getHeight(this.domElement) / 2 + "px"
                    }
                    ,
                    e
            }();
            t["default"] = u
        }
        , function(e, t, n) {
            t = e.exports = n(24)(),
                t.push([e.id, ".dg ul{list-style:none;margin:0;padding:0;width:100%;clear:both}.dg.ac{position:fixed;top:0;left:0;right:0;height:0;z-index:0}.dg:not(.ac) .main{overflow:hidden}.dg.main{-webkit-transition:opacity .1s linear;transition:opacity .1s linear}.dg.main.taller-than-window{overflow-y:auto}.dg.main.taller-than-window .close-button{opacity:1;margin-top:-1px;border-top:1px solid #2c2c2c}.dg.main ul.closed .close-button{opacity:1!important}.dg.main .close-button.drag,.dg.main:hover .close-button{opacity:1}.dg.main .close-button{-webkit-transition:opacity .1s linear;transition:opacity .1s linear;border:0;position:absolute;line-height:19px;height:20px;cursor:pointer;text-align:center;background-color:#000}.dg.main .close-button:hover{background-color:#111}.dg.a{float:right;margin-right:15px;overflow-x:hidden}.dg.a.has-save>ul{margin-top:27px}.dg.a.has-save>ul.closed{margin-top:0}.dg.a .save-row{position:fixed;top:0;z-index:1002}.dg li{-webkit-transition:height .1s ease-out;transition:height .1s ease-out}.dg li:not(.folder){cursor:auto;height:27px;line-height:27px;overflow:hidden;padding:0 4px 0 5px}.dg li.folder{padding:0;border-left:4px solid transparent}.dg li.title{cursor:pointer;margin-left:-4px}.dg .closed li:not(.title),.dg .closed ul li,.dg .closed ul li>*{height:0;overflow:hidden;border:0}.dg .cr{clear:both;padding-left:3px;height:27px}.dg .property-name{cursor:default;float:left;clear:left;width:40%;overflow:hidden;text-overflow:ellipsis}.dg .c{float:left;width:60%}.dg .c input[type=text]{border:0;margin-top:4px;padding:3px;width:100%;float:right}.dg .has-slider input[type=text]{width:30%;margin-left:0}.dg .slider{float:left;width:66%;margin-left:-5px;margin-right:0;height:19px;margin-top:4px}.dg .slider-fg{height:100%}.dg .c input[type=checkbox]{margin-top:9px}.dg .c select{margin-top:5px}.dg .cr.boolean,.dg .cr.boolean *,.dg .cr.function,.dg .cr.function *,.dg .cr.function .property-name{cursor:pointer}.dg .selector{display:none;position:absolute;margin-left:-9px;margin-top:23px;z-index:10}.dg .c:hover .selector,.dg .selector.drag{display:block}.dg li.save-row{padding:0}.dg li.save-row .button{display:inline-block;padding:0 6px}.dg.dialogue{background-color:#222;width:460px;padding:15px;font-size:13px;line-height:15px}#dg-new-constructor{padding:10px;color:#222;font-family:Monaco,monospace;font-size:10px;border:0;resize:none;box-shadow:inset 1px 1px 1px #888;word-wrap:break-word;margin:12px 0;display:block;width:440px;overflow-y:scroll;height:100px;position:relative}#dg-local-explain{display:none;font-size:11px;line-height:17px;border-radius:3px;background-color:#333;padding:8px;margin-top:10px}#dg-local-explain code{font-size:10px}#dat-gui-save-locally{display:none}.dg{color:#eee;font:11px Lucida Grande,sans-serif;text-shadow:0 -1px 0 #111}.dg.main::-webkit-scrollbar{width:5px;background:#1a1a1a}.dg.main::-webkit-scrollbar-corner{height:0;display:none}.dg.main::-webkit-scrollbar-thumb{border-radius:5px;background:#676767}.dg li:not(.folder){background:#1a1a1a;border-bottom:1px solid #2c2c2c}.dg li.save-row{line-height:25px;background:#dad5cb;border:0}.dg li.save-row select{margin-left:5px;width:108px}.dg li.save-row .button{margin-left:5px;margin-top:1px;border-radius:2px;font-size:9px;line-height:7px;padding:4px 4px 5px;background:#c5bdad;color:#fff;text-shadow:0 1px 0 #b0a58f;box-shadow:0 -1px 0 #b0a58f;cursor:pointer}.dg li.save-row .button.gears{background:#c5bdad url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAsAAAANCAYAAAB/9ZQ7AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAQJJREFUeNpiYKAU/P//PwGIC/ApCABiBSAW+I8AClAcgKxQ4T9hoMAEUrxx2QSGN6+egDX+/vWT4e7N82AMYoPAx/evwWoYoSYbACX2s7KxCxzcsezDh3evFoDEBYTEEqycggWAzA9AuUSQQgeYPa9fPv6/YWm/Acx5IPb7ty/fw+QZblw67vDs8R0YHyQhgObx+yAJkBqmG5dPPDh1aPOGR/eugW0G4vlIoTIfyFcA+QekhhHJhPdQxbiAIguMBTQZrPD7108M6roWYDFQiIAAv6Aow/1bFwXgis+f2LUAynwoIaNcz8XNx3Dl7MEJUDGQpx9gtQ8YCueB+D26OECAAQDadt7e46D42QAAAABJRU5ErkJggg==) 2px 1px no-repeat;height:7px;width:8px}.dg li.save-row .button:hover{background-color:#bab19e;box-shadow:0 -1px 0 #b0a58f}.dg li.folder{border-bottom:0}.dg li.title{padding-left:16px;background:#000 url(data:image/gif;base64,R0lGODlhBQAFAJEAAP////Pz8////////yH5BAEAAAIALAAAAAAFAAUAAAIIlI+hKgFxoCgAOw==) 6px 10px no-repeat;cursor:pointer;border-bottom:1px solid hsla(0,0%,100%,.2)}.dg .closed li.title{background-image:url(data:image/gif;base64,R0lGODlhBQAFAJEAAP////Pz8////////yH5BAEAAAIALAAAAAAFAAUAAAIIlGIWqMCbWAEAOw==)}.dg .cr.boolean{border-left:3px solid #806787}.dg .cr.color{border-left:3px solid}.dg .cr.function{border-left:3px solid #e61d5f}.dg .cr.number{border-left:3px solid #2fa1d6}.dg .cr.number input[type=text]{color:#2fa1d6}.dg .cr.string{border-left:3px solid #1ed36f}.dg .cr.string input[type=text]{color:#1ed36f}.dg .cr.boolean:hover,.dg .cr.function:hover{background:#111}.dg .c input[type=text]{background:#303030;outline:none}.dg .c input[type=text]:hover{background:#3c3c3c}.dg .c input[type=text]:focus{background:#494949;color:#fff}.dg .c .slider{background:#303030;cursor:ew-resize}.dg .c .slider-fg{background:#2fa1d6;max-width:100%}.dg .c .slider:hover{background:#3c3c3c}.dg .c .slider:hover .slider-fg{background:#44abda}", ""])
        }
        , function(e, t) {
            e.exports = function() {
                var e = [];
                return e.toString = function() {
                    for (var e = [], t = 0; t < this.length; t++) {
                        var n = this[t];
                        n[2] ? e.push("@media " + n[2] + "{" + n[1] + "}") : e.push(n[1])
                    }
                    return e.join("")
                }
                    ,
                    e.i = function(t, n) {
                        "string" == typeof t && (t = [[null, t, ""]]);
                        for (var o = {}, i = 0; i < this.length; i++) {
                            var r = this[i][0];
                            "number" == typeof r && (o[r] = !0)
                        }
                        for (i = 0; i < t.length; i++) {
                            var a = t[i];
                            "number" == typeof a[0] && o[a[0]] || (n && !a[2] ? a[2] = n : n && (a[2] = "(" + a[2] + ") and (" + n + ")"),
                                e.push(a))
                        }
                    }
                    ,
                    e
            }
        }
    ])
});

var menuImageView = '?imageMogr2/thumbnail/200x200>'; //左侧菜单栏图片大小
var pageImageView = '?imageMogr2/thumbnail/800x800>'; //画布图片大小
var pageImageViewOrient = '?imageMogr2/auto-orient/thumbnail/800x800>'//画布图片加自动校正

//移动画布
var isMoveCanvas = false;
function moveCanvas($event, callback) {
    var x = $event.clientX;
    var y = $event.clientY;
    isMoveCanvas = true;
    //鼠标移动
    window.onmousemove = function (e) {
        if (!isMoveCanvas) {
            return;
        }
        // console.log('canvas moving');
        callback(e.clientX - x, e.clientY - y)
    };
    //鼠标抬起事件
    window.onmouseup = function ($event) {
        isMoveCanvas = false;
    }
}
//page排序
function pageSeq(page, UidService, callback) {
    page.forEach(function (item, index) {
        item.seq = index + 1;
        // item.uuid = UidService.get();
    })
    callback(page)
}

function getDPI() {
    var arrDPI = new Array();
    if (window.screen.deviceXDPI != undefined) {
        arrDPI[0] = window.screen.deviceXDPI;
        arrDPI[1] = window.screen.deviceYDPI;
    } else {
        var tmpNode = document.createElement("DIV");
        tmpNode.style.cssText = "width:1in;height:1in;position:absolute;left:0px;top:0px;z-index:99;visibility:hidden";
        document.body.appendChild(tmpNode);
        arrDPI[0] = parseInt(tmpNode.offsetWidth);
        arrDPI[1] = parseInt(tmpNode.offsetHeight);
        tmpNode.parentNode.removeChild(tmpNode);
    }
    return arrDPI[0];
}
// mm换算成px
function MmTurnPx(mm) {
    return (mm / 25.4 * this.getDPI()).toFixed(2) - 0;
};
// px换算成mm
function PxTurnMm(px) {
    return (px / this.getDPI() * 25.4).toFixed(2) - 0;
};
//px换算成英寸
function PxTurnIn(item) {
    return (item / this.getDPI()).toFixed(2) - 0;
};
//英寸换算成px
function InTurnPx(item) {
    return (item * this.getDPI()).toFixed(2) - 0;
};
//英寸换算成mm
function InTurnMm(item) {
    return PxTurnMm(InTurnPx(item));
};
//mm换算成英寸
function MmTurnIn(item) {
    return PxTurnIn(MmTurnPx(item));
};
//pt换算成px
function ptToPx(pt) {
    var px = pt * this.getDPI() / 72;
    return px;
}

/*******************************************素材处理*************************************************************************/
//添加素材
function imageartAdd($http, imageart,mediabox, callback) {
    $http({url: imageart.resource.identifier + '?imageInfo'}).success(function (data) {
        var _imageart = {
            onlyshow: false,
            movable: true,
            editable: true,
            lock: false,
            offsetx: '0',
            offsety: '0',
            transparency: '1',
            geometry: {
                x: '0',
                y: '0',
                width: data.width,
                height: data.height
            },
            rotation: {
                angle: '0'
            },
            resource: {
                provider: '',
                identifier: imageart.identifier,
                width: '',
                height: ''
            },
            scale: 1,
        }

        var bgImgW = data.width;
        var bgImgH = data.height;
        var bgImgR = bgImgW / bgImgH;
        if (bgImgR >= 1) {
            if (bgImgW > mediabox.width) {
                _imageart.geometry.width = mediabox.width * 0.5;
                _imageart.geometry.height = _imageart.geometry.width * bgImgH / bgImgW;
            } else {
                _imageart.geometry.width = bgImgW;
                _imageart.geometry.height = bgImgH;
            }
        } else {
            if (bgImgH > mediabox.height) {
                _imageart.geometry.height = mediabox.height * 0.5;
                _imageart.geometry.width = _imageart.geometry.height * bgImgW / bgImgH;
            } else {
                _imageart.geometry.width = bgImgW;
                _imageart.geometry.height = bgImgH;
            }
        }
        _imageart.resource.width = _imageart.geometry.width;
        _imageart.resource.height = _imageart.geometry.height;
        _imageart.geometry.x = (mediabox.width - _imageart.geometry.width) / 2 + mediabox.x;
        _imageart.geometry.y = (mediabox.height - _imageart.geometry.height) / 2 + mediabox.y;
        callback(_imageart)
    }).error(function (error) {
    });
}
//像素不足
function pxInsufficient(imageW, imageH, imageScale, geometryW, geometryH) {
    var scale = imageScale || 1;
    var dpi = Math.ceil(imageW*25.4/geometryW / scale);
    return dpi;
}

function imageInfo($http, res, callback){
    $http({url: res.identifier + '?imageInfo'}).success(function (data) {
        res.width = data.width;
        res.height = data.height;
        res.size = data.size;
        callback()
    }).error(function (error) {
        console.error("获取图片信息失败");
        // MessageService.error("获取图片信息失败");
    });
}
function getUuid(len, radix) {
    var chars = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz'.split('');
    var uuid = [],
        i;
    radix = radix || chars.length;

    if (len) {
        // Compact form
        for (i = 0; i < len; i++) uuid[i] = chars[0 | Math.random() * radix];
    } else {
        // rfc4122, version 4 form
        var r;

        // rfc4122 requires these characters
        uuid[8] = uuid[13] = uuid[18] = uuid[23] = '-';
        uuid[14] = '4';

        // Fill in random data.  At i==19 set the high bits of clock sequence as
        // per rfc4122, sec. 4.1.5
        for (i = 0; i < 36; i++) {
            if (!uuid[i]) {
                r = 0 | Math.random() * 16;
                uuid[i] = chars[(i == 19) ? (r & 0x3) | 0x8 : r];
            }
        }
    }

    return uuid.join('');
}
/*******************************************元素缩放处理*************************************************************************/
// 通用的缩放算法
// $event: 鼠标事件
// item: 用户数据，item.geometry可用
// stick :  left - 左
//          leftTop - 左上
//          top - 上
//          rightTop - 右上
//          right - 右
//          rightBottom - 右下
//          bottom - 下
//          leftBottom - 左下
//
//      leftTop ---------- top ----------- rightTop
//          |                                   |
//          |                                   |
//         left                               right
//          |                                   |
//          |                                   |
//       leftBottom ----- bottom ---------- rightBottom
//
//  boxElement: box框元素，可以用来计算box的位置和尺寸
var boxZoomStickDown = false;
function editorBoxZoom($event, item, stick, scale, boxElement, moveCallback, upCallback) {
    fn($event)
    if (!item || !stick || !boxElement) {
        return;
    }
    var element;
    if (boxElement.offset) {
        // 元素组
        element = boxElement[0];
    } else if (boxElement.offsetLeft) {
        element = boxElement;
    }
    boxZoomStickDown = true;
    var l0 = element.offsetLeft;
    var t0 = element.offsetTop;
    var w0 = element.offsetWidth;
    var h0 = element.offsetHeight;
    var cx = l0 + w0 / 2;   // 原中心点x
    var cy = t0 + h0 / 2;   // 原中心点y
    var angle = Number(item.rotation.angle);
    if(item.current == 'imagebox'){
        angle = 360-Number(item.rotation.angle);
    }
    var pt0 = rotatePoint({x: $event.clientX, y: $event.clientY}, {x: cx, y: cy}, -angle);
    var dx = 0;     // 框left变化
    var dy = 0;     // 框top变化
    var dw = 0;     // 框长变化
    var dh = 0;     // 框高变化
    var dcx = 0;    // 中心点x向偏移
    var dcy = 0;    // 中心点y向偏移

    var gx = item.geometry.x;
    var gy = item.geometry.y;
    var gw = item.geometry.width;
    var gh = item.geometry.height;
    if(item.offsetx || item.offsety){
        var nw = angular.copy(item.geometry.width);
        var nh = angular.copy(item.geometry.height);
        var nw1 = angular.copy(item.resource.width);
        var nh1 = angular.copy(item.resource.height);
        var x1 = angular.copy(item.offsetx);
        var y1 = angular.copy(item.offsety);
    }
    if(item.style){
        var nw = angular.copy(item.geometry.width);
        var nh = angular.copy(item.geometry.height);
        var _size = angular.copy(parseInt(item.style.size));
        var _lineheight = angular.copy(parseInt(item.style.lineheight));
    }


    function px2mm(pixels) {
        return (pixels || 0) * 25.4 / 96;
    }

    window.onmousemove = function (e) {
        // fn(e)
        if (!boxZoomStickDown) {
            // e.stopPropagation();
            return;
        }
        var pt1 = rotatePoint({x: e.clientX, y: e.clientY}, {x: cx, y: cy}, -angle);
        if (stick == 'left') {
            dx = pt1.x - pt0.x;
            dw = -dx;
            dcx = dx/2;
        }
        else if (stick == 'top') {
            dy = pt1.y - pt0.y;
            dh = -dy;
            dcy = dy/2;
        }
        else if (stick == 'right') {
            dw = pt1.x - pt0.x;
            dcx = dw / 2;
        }
        else if (stick == 'bottom') {
            dh = pt1.y - pt0.y;
            dcy = dh / 2;
        }
        else if (stick == 'leftTop') {
            var offsetX = pt1.x - pt0.x;
            var offsetY = pt1.y - pt0.y;
            if ((gw - offsetX / scale) * gh  > (gh - offsetY / scale) * gw ) {
                offsetX = offsetY * gw / gh;
            } else {
                offsetY = offsetX * gh / gw;
            }

            dx = offsetX;
            dy = offsetY;

            dw = -dx;
            dh = -dy;
            dcx = dx / 2;
            dcy = dy / 2;
        }
        else if (stick == 'leftBottom') {
            var offsetX = pt1.x - pt0.x;
            var offsetY = pt1.y - pt0.y;
            if ((gw - offsetX / scale) * gh  > (gh + offsetY / scale) * gw ) {
                offsetX = -1 * offsetY * gw / gh;
            } else {
                offsetY = -1 * offsetX * gh / gw;
            }

            dx = offsetX;
            dw = -dx;
            dh = offsetY;
            dcx = dx / 2;
            dcy = dh / 2;
        }
        else if (stick == 'rightTop') {
            var offsetX = pt1.x - pt0.x;
            var offsetY = pt1.y - pt0.y;
            if ((gw + offsetX / scale) * gh  > (gh - offsetY / scale) * gw ) {
                offsetX = -1 * offsetY * gw / gh;
            } else {
                offsetY = -1 * offsetX * gh / gw;
            }

            dy = offsetY;
            dw = offsetX;
            dh = -dy;
            dcx = dw / 2;
            dcy = dy / 2;
        }
        else if (stick == 'rightBottom') {
            var offsetX = pt1.x - pt0.x;
            var offsetY = pt1.y - pt0.y;
            if ((gw + offsetX / scale) * gh  > (gh + offsetY / scale) * gw ) {
                offsetX = offsetY * gw / gh;
            } else {
                offsetY = offsetX * gh / gw;
            }

            dw = offsetX;
            dh = offsetY;
            dcx = dw / 2;
            dcy = dh / 2;
        }
        else {
            console.error('zoom-dragging - invalid stick: ' + stick);
            e.stopPropagation();
            return;
        }
        // 如果框尺寸小于5mm, 不处理
        if (gw + (dw / scale) < 5 || gh + (dh / scale) < 5) {
            e.stopPropagation();
            return;
        }
        // 中心点偏移dc1
        var dc1 = rotatePoint({x: dcx, y: dcy}, {x: 0, y: 0}, angle);
        // 偏移补偿
        var cx_fix =  dc1.x - dcx;
        var cy_fix = dc1.y - dcy;

        item.geometry.width = gw + (dw / scale);
        item.geometry.height = gh + (dh / scale);
        if(item.style){
            if(item.geometry.width > ptToPx(item.style.size)){
                item.geometry.x = gx + ((dx + cx_fix) / scale);
                item.geometry.y = gy + ((dy + cy_fix) / scale);
            }
        }else{
            item.geometry.x = gx + ((dx + cx_fix) / scale);
            item.geometry.y = gy + ((dy + cy_fix) / scale);
        }
        if(item.offsetx || item.offsety){
            item.offsetx = ((gw + dw / scale) / (nw / nw1)) / (nw1 / x1);
            item.offsety = ((gh + dh / scale) / (nh / nh1)) / (nh1 / y1);
        }

        if(item.style){
            if((stick != 'left' && stick != 'top' && stick != 'right' && stick != 'bottom')){
                var size1 = Math.ceil((gw + (dw / scale)) / nw * _size);
                if(size1<6){
                    size1 = 6;
                    item.style.size = size1;
                    item.style.lineheight = Math.floor((size1 / _size * _lineheight));
                    boxZoomStickDown = false;
                    if (upCallback) {
                        upCallback(item);
                    }
                    return false
                }
                item.style.size = size1;
                item.style.lineheight = Math.floor((size1 / _size * _lineheight));
            }
            if(stick == 'left'|| stick == 'right'){
                if(item.geometry.width < ptToPx(item.style.size)){
                    item.geometry.width = ptToPx(item.style.size)+10;
                    boxZoomStickDown = false;
                    if (upCallback) {
                        upCallback(item);
                    }
                }
            }
            if(stick == 'top' || stick == 'bottom'){
                if(item.geometry.height < ptToPx(item.style.size)){
                    item.geometry.height = ptToPx(item.style.size)+10;
                    boxZoomStickDown = false;
                    if (upCallback) {
                        upCallback(item);
                    }
                }
            }
        }


        // console.log('dx=' + dx + ", dy=" + dy + ', dw=' + dw + ', dh=' + dh);

        if (moveCallback) {
            moveCallback(item);
        }
        // e.stopPropagation();
    }

    window.onmouseup = function (e) {
        // fn(e)
        if (!boxZoomStickDown) {
            // e.stopPropagation();
            return;
        }
        var pt1 = rotatePoint({x: e.clientX, y: e.clientY}, {x: cx, y: cy}, -angle);
        if (stick == 'left') {
            dx = pt1.x - pt0.x;
            dw = -dx;
            dcx = dx/2;
        }
        else if (stick == 'top') {
            dy = pt1.y - pt0.y;
            dh = -dy;
            dcy = dy/2;
        }
        else if (stick == 'right') {
            dw = pt1.x - pt0.x;
            dcx = dw / 2;
        }
        else if (stick == 'bottom') {
            dh = pt1.y - pt0.y;
            dcy = dh / 2;
        }
        else if (stick == 'leftTop') {
            var offsetX = pt1.x - pt0.x;
            var offsetY = pt1.y - pt0.y;
            if ((gw - offsetX / scale) * gh  > (gh - offsetY / scale) * gw ) {
                offsetX = offsetY * gw / gh;
            } else {
                offsetY = offsetX * gh / gw;
            }

            dx = offsetX;
            dy = offsetY;

            dw = -dx;
            dh = -dy;
            dcx = dx / 2;
            dcy = dy / 2;
        }
        else if (stick == 'leftBottom') {
            var offsetX = pt1.x - pt0.x;
            var offsetY = pt1.y - pt0.y;
            if ((gw - offsetX / scale) * gh  > (gh + offsetY / scale) * gw ) {
                offsetX = -1 * offsetY * gw / gh;
            } else {
                offsetY = -1 * offsetX * gh / gw;
            }

            dx = offsetX;
            dw = -dx;
            dh = offsetY;
            dcx = dx / 2;
            dcy = dh / 2;
        }
        else if (stick == 'rightTop') {
            var offsetX = pt1.x - pt0.x;
            var offsetY = pt1.y - pt0.y;
            if ((gw + offsetX / scale) * gh  > (gh - offsetY / scale) * gw ) {
                offsetX = -1 * offsetY * gw / gh;
            } else {
                offsetY = -1 * offsetX * gh / gw;
            }

            dy = offsetY;
            dw = offsetX;
            dh = -dy;
            dcx = dw / 2;
            dcy = dy / 2;
        }
        else if (stick == 'rightBottom') {
            var offsetX = pt1.x - pt0.x;
            var offsetY = pt1.y - pt0.y;
            if ((gw + offsetX / scale) * gh  > (gh + offsetY / scale) * gw ) {
                offsetX = offsetY * gw / gh;
            } else {
                offsetY = offsetX * gh / gw;
            }

            dw = offsetX;
            dh = offsetY;
            dcx = dw / 2;
            dcy = dh / 2;
        }
        else {
            console.error('zoom-dragging - invalid stick: ' + stick);
            // e.stopPropagation();
            return;
        }

        // 如果框尺寸小于5mm, 不处理
        if (gw + (dw / scale) < 5 || gh + (dh / scale) < 5) {
            // e.stopPropagation();
            if (upCallback) {
                upCallback(item);
            }
            boxZoomStickDown = false;
            return;
        }

        // 中心点偏移dc1
        var dc1 = rotatePoint({x: dcx, y: dcy}, {x: 0, y: 0}, angle);
        // 偏移补偿
        var cx_fix =  dc1.x - dcx;
        var cy_fix = dc1.y - dcy;

        if(!item.style){
            item.geometry.x = gx + ((dx + cx_fix) / scale);
            item.geometry.y = gy + ((dy + cy_fix) / scale);
            item.geometry.width = gw + (dw / scale);
            item.geometry.height = gh + (dh / scale);
        }

        if (upCallback) {
            upCallback(item);
        }
        boxZoomStickDown = false;
        // e.stopPropagation();
    }
}

function rotatePoint(ptSrc, ptRotationCenter, angle){
    var a = ptRotationCenter.x;
    var b = ptRotationCenter.y;
    var x0 = ptSrc.x;
    var y0 = ptSrc.y;
    var rx = a + (x0-a) * Math.cos(angle * Math.PI / 180) - (y0-b) * Math.sin(angle * Math.PI / 180);
    var ry = b + (x0-a) * Math.sin(angle * Math.PI / 180) + (y0-b) * Math.cos(angle * Math.PI / 180);
    var json = {x:rx,y:ry}
    return json;
}

function imageboxImg(imagebox, callback) {
    var newImg = new Image();
    newImg.crossOrigin = "Anonymous";
    newImg.src = imagebox.image.resource.identifier + '?imageMogr2/strip/rotate/' + (imagebox.image.angle || 0) + '/thumbnail/!40p';
    newImg.onload = function () {
        var imgR = imagebox.geometry.width / imagebox.geometry.height;
        var imgR1 = newImg.width / newImg.height;
        if (imgR >= imgR1) {
            imagebox.image.resource.adaptation = 'Height';
            imagebox.image.width = imagebox.geometry.width;
            imagebox.image.height = imagebox.geometry.width / newImg.width * newImg.height;
            imagebox.image.offsetx = 0;
            imagebox.image.offsety = -(imagebox.image.height - imagebox.geometry.height) / 2;
        } else {
            imagebox.image.resource.adaptation = 'Width';
            imagebox.image.width = imagebox.geometry.height / newImg.height * newImg.width;
            imagebox.image.height = imagebox.geometry.height;
            imagebox.image.offsetx = -(imagebox.image.width - imagebox.geometry.width) / 2;
            imagebox.image.offsety = 0;
        }
        if(callback){
            callback()
        }
    };
}

function fontuuid2family(fontuuid) {
    if (fontuuid && !fontuuid.startsWith("font_")) {
        return "font_" + fontuuid.replaceAll("-", "_");
    }
    return fontuuid;
}
//文字校验
function fontSupport(FontManagement, font, callback) {
    FontManagement.fontSupport({
        uuid: font.fontuuid,
        bold: font.style.bold,
        italic: font.style.italic,
        content: font.text
    }, function (res) {
        if(res.status == 200){
            font.success = res.message.success;
        }
        if(callback)(callback())
    }, function (error) {
        if(callback){callback()}
    })
}
function dropShadow(imagebox,width,height){
    if(imagebox.shadow.x == 0 && imagebox.shadow.y == 0 && imagebox.shadow.blur == 0){
        return ''
    }
    var blur = 0;
    var x = 0;
    var y = 0;
    if (width>=height) {
        blur = width * imagebox.shadow.blur * 0.005
    }else{
        blur = height * imagebox.shadow.blur * 0.005
    }
    x = width * imagebox.shadow.x * 0.01;
    y = height * imagebox.shadow.y * 0.01;
    return 'drop-shadow('+x+'px '+y+'px '+blur+'px '+imagebox.shadow.color+')'
}
//生成缩略图
function dataURLtoBlob(dataurl) {
    var arr = dataurl.split(','), mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]), n = bstr.length, u8arr = new Uint8Array(n);
    while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
    }
    return new Blob([u8arr], {type: mime});
}

/*
    x0,y0,左上角坐标
    x1,y1,右下角坐标
    angle,旋转角度
    return 旋转后大盒子宽高，坐标
*/
function outerRectangle(x0, y0, x1, y1, angle) {
    var angle = angle || 0;
    var cx = (x0 + x1) / 2;
    var cy = (y0 + y1) / 2;
    var pt0 = rotatePoint({x: x0, y: y0}, {x: cx, y: cy}, angle);
    var pt1 = rotatePoint({x: x1, y: y0}, {x: cx, y: cy}, angle);
    var pt2 = rotatePoint({x: x1, y: y1}, {x: cx, y: cy}, angle);
    var pt3 = rotatePoint({x: x0, y: y1}, {x: cx, y: cy}, angle);

    var minX = Math.min(pt0.x, pt1.x, pt2.x, pt3.x);
    var minY = Math.min(pt0.y, pt1.y, pt2.y, pt3.y);
    var maxX = Math.max(pt0.x, pt1.x, pt2.x, pt3.x);
    var maxY = Math.max(pt0.y, pt1.y, pt2.y, pt3.y);

    return {
        x: minX,
        y: minY,
        x1:maxX,
        y1:maxY,
        width: maxX - minX,
        height: maxY - minY,
    };
}


//画布上下左右对齐，贴边
function elementAlign(item, angle, direction, pageWidth, pageHeight) {
    var x0 = item.x;
    var y0 = item.y;
    var x1 = item.x + item.width;
    var y1 = item.y + item.height;
    var outer = outerRectangle(x0, y0, x1, y1, angle);
    if(direction == 'left') {
        return (outer.width-item.width)/2
    }
    if(direction == 'right') {
        return pageWidth - item.width - (outer.width - item.width)/2
    }
    if(direction == 'top') {
        return (outer.height-item.height)/2
    }
    if(direction == 'bottom') {
        return pageHeight - item.height - (outer.height - item.height)/2
    }
}
function coordinates(level,levelI) {
    var _data={
        x:[],
        y:[],
    }
    if(level){
        level.forEach(function (level,index) {
            if(levelI != index){
                var _coordinate = null;
                if(level.imagebox&&level.imagebox.geometry){
                    _coordinate = coordinatesItem(level.imagebox.geometry,level.imagebox.rotation.angle);
                }
                if(level.imageart&&level.imageart.geometry){
                    _coordinate = coordinatesItem(level.imageart.geometry,level.imageart.rotation.angle);
                }
                if(level.textbox&&level.textbox.geometry){
                    _coordinate = coordinatesItem(level.textbox.geometry,level.textbox.rotation.angle);
                }
                if(level.textdocument&&level.textdocument.geometry){
                    _coordinate = coordinatesItem(level.textdocument.geometry,level.textdocument.rotation.angle);
                }
                if(level.calTitleBox&&level.calTitleBox.geometry){
                    _coordinate = coordinatesItem(level.calTitleBox.geometry,level.calTitleBox.rotation.angle);
                }
                if(level.calMonthBox&&level.calMonthBox.geometry){
                    _coordinate = coordinatesItem(level.calMonthBox.geometry,level.calMonthBox.rotation.angle);
                }
                if(_coordinate){
                    _data.x = _data.x.concat(_coordinate.x);
                    _data.y = _data.y.concat(_coordinate.y);
                }
            }
        })
    }
    return _data
}
function coordinatesItem(geometry,angle) {
    var x0 = geometry.x;
    var y0 = geometry.y;
    var x1 = geometry.x + geometry.width;
    var y1 = geometry.y + geometry.height;
    var outer = outerRectangle(x0, y0, x1, y1, angle);
    return {
        x:[outer.x, outer.x1],
        y:[outer.y, outer.y1],
    }
}
function getItemCoordinates(box,coordinates,callback) {
    var _thisItem = coordinatesItem(box.geometry,box.rotation.angle);
    var _x = approach(_thisItem.x, coordinates.x);
    var _y = approach(_thisItem.y, coordinates.y);
    var _z = {};
    if(_x.minDiff < 10){
        _z.x=_x;
    }
    if(_y.minDiff < 10){
        _z.y=_y;
    }
    callback(_z)
}

function approach(a,b) {
    var _a = a[0];
    var closestNum = b[0]; // 初始化最接近的数字为b数组的第一个元素
    var minDiff = Math.abs(a[0] - closestNum); // 初始化差值绝对值为a数组第一个元素与最接近数字的差值

    for (var i = 0; i < a.length; i++) {
        for (var j = 0; j < b.length; j++) {
            var diff = Math.abs(a[i] - b[j]); // 计算差值绝对值
            if (diff < minDiff) { // 如果差值绝对值更小，更新最接近数字和最小差值绝对值
                minDiff = diff;
                closestNum = b[j];
                _a = a[i];
            }
        }
    }
    return {
        a:_a,
        closestNum:closestNum,
        minDiff:minDiff,
        diff:_a > closestNum ? -minDiff : minDiff,
    }
}
function documentTextDetection(document) {
    var isPass = {
        pass: true,
        pages:[],
    };
    if(document.backupPages&&document.backupPages.list){
        var page = document.backupPages.list;
        for(var i=0; i<page.length; i++){
            if (!page[i] || !page[i].levels || !page[i].levels.level) {
                continue;
            }
            if (!page[i].levels.level.length) {
                continue;
            }
            var _page={
                valid: false,
                pageIndex: i + 1,
                texts:[],
                repetitions:[],
            }
            for(var j=0; j<page[i].levels.level.length; j++){
                var _level = page[i].levels.level[j];
                if(_level.textbox && _level.textbox.geometry && _level.textbox.success === false){
                    _page.valid = true;
                    isPass.isText = true;
                    _page.texts.push(_level.textbox)
                }
                var _repetition = [];
                for (var key in _level){
                    if(_level[key] && (key=='imagebox'||key=='code'||key=='imageart'||key=='textbox'||key=='textdocument')){
                        _level[key].levelType = key;
                        _repetition.push(_level[key])
                    }
                }
                if(_repetition.length>1){
                    _page.valid = true;
                    isPass.isRepetition = true;
                    _page.repetitions.push(_level);
                }
            }
            if(_page.valid){
                isPass.pass = false;
                isPass.pages.push(_page)
            }
        }
    }
    if(document.pages&&document.pages.page){
        var page = document.pages.page;
        for(var i=0; i<page.length; i++){
            if (!page[i] || !page[i].levels || !page[i].levels.level) {
                continue;
            }
            if (!page[i].levels.level.length) {
                continue;
            }
            var _page={
                valid: false,
                pageIndex: i + 1,
                texts:[],
                repetitions:[],
            }
            for(var j=0; j<page[i].levels.level.length; j++){
                var _level = page[i].levels.level[j];
                if(_level.textbox && _level.textbox.geometry && _level.textbox.success === false){
                    _page.valid = true;
                    isPass.isText = true;
                    _page.texts.push(_level.textbox)
                }
                var _repetition = [];
                for (var key in _level){
                    if(_level[key] && (key=='imagebox'||key=='code'||key=='imageart'||key=='textbox'||key=='textdocument')){
                        _level[key].levelType = key;
                        _repetition.push(_level[key])
                    }
                }
                if(_repetition.length>1){
                    _page.valid = true;
                    isPass.isRepetition = true;
                    _page.repetitions.push(_level);
                }
            }
            if(_page.valid){
                isPass.pass = false;
                isPass.pages.push(_page)
            }
        }
    }
    return isPass
}
function fn(e) {
    if (e && e.stopPropagation) {
        e.stopPropagation();
    } else {
        window.event.cancelBubble = true;
    }
    if (e && e.preventDefault) {
        e.preventDefault();
    } else {
        window.event.returnValue = false;
    }
}


/*
    计算旋转后的元素外框四点坐标
    x0,y0,左上角坐标
    x1,y1,右下角坐标
    angle,旋转角度
    return 旋转后大盒子宽高，坐标
*/
function outerRectangle2(x0, y0, x1, y1, angle) {
    var angle = angle || 0;
    var cx = (x0 + x1) / 2;
    var cy = (y0 + y1) / 2;
    var pt0 = rotatePoint({x: x0, y: y0}, {x: cx, y: cy}, angle);
    var pt1 = rotatePoint({x: x1, y: y0}, {x: cx, y: cy}, angle);
    var pt2 = rotatePoint({x: x1, y: y1}, {x: cx, y: cy}, angle);
    var pt3 = rotatePoint({x: x0, y: y1}, {x: cx, y: cy}, angle);

    var minX = Math.min(pt0.x, pt1.x, pt2.x, pt3.x);
    var minY = Math.min(pt0.y, pt1.y, pt2.y, pt3.y);
    var maxX = Math.max(pt0.x, pt1.x, pt2.x, pt3.x);
    var maxY = Math.max(pt0.y, pt1.y, pt2.y, pt3.y);

    return {
        minX: minX,
        minY: minY,
        maxX: maxX,
        maxY: maxY
    };
}



/**
 * 获取多个元素画框后的最大最小坐标
 * @param {*} list
 * @returns
 */
function getAllElemCoord(list){
    var allX = [];
    var allY = [];
    list.forEach(function(box){
        var outer = outerRectangle2(box.geometry.x, box.geometry.y, box.geometry.x + box.geometry.width, box.geometry.y + box.geometry.height, box.rotation.angle);
        allX.push(outer.minX);
        allY.push(outer.minY);
        allX.push(outer.maxX);
        allY.push(outer.maxY);
    })
    var minX = Math.min.apply(null, allX);
    var minY = Math.min.apply(null, allY);
    var maxX = Math.max.apply(null, allX);
    var maxY = Math.max.apply(null, allY);

    return {
        minX: minX,
        minY: minY,
        maxX: maxX,
        maxY: maxY
    };
}

/**
 * 获取单个元素对齐移动后的坐标（多元素对齐）
 * @param {*} place 对齐方向 top left right bottom
 * @param {*} coord 大框的坐标
 * @param {*} el    元素信息
 * @returns 移动后的x/y轴坐标
 */
function getElemMoveCoord(place,coord,el){
    var geometry = el.geometry;
    var outer = outerRectangle2(geometry.x, geometry.y, geometry.x + geometry.width, geometry.y + geometry.height, el.rotation.angle);
    if(place === "left"){
        if(outer.minX === coord.minX) return geometry.x;
        return geometry.x - (outer.minX - coord.minX);
    }
    if(place === "right"){
        if(outer.maxX === coord.maxX) return geometry.x;
        return geometry.x + (coord.maxX - outer.maxX);
    }
    if(place === "top"){
        if(outer.minY === coord.minY) return geometry.y;
        return geometry.y - (outer.minY - coord.minY);
    }
    if(place === "bottom"){
        if(outer.maxY === coord.maxY) return geometry.y;
        return geometry.y + (coord.maxY - outer.maxY);
    }


}

// 多元素水平垂直居中对齐
function horizontalAndVerticalCenter(attr, all){
    var allX = [];
    var allY = [];
    all.forEach(function(box){
        var outer = outerRectangle2(box.geometry.x, box.geometry.y, box.geometry.x + box.geometry.width, box.geometry.y + box.geometry.height, box.rotation.angle);
        allX.push(outer.minX);
        allY.push(outer.minY);
        allX.push(outer.maxX);
        allY.push(outer.maxY);
    })
    var minX = Math.min.apply(null, allX);
    var minY = Math.min.apply(null, allY);
    var maxX = Math.max.apply(null, allX);
    var maxY = Math.max.apply(null, allY);
    if (attr == 'vertical') {
        return maxY - (maxY - minY)/2;
    }
    if (attr == "standard") {
        return maxX - (maxX - minX)/2;
    }
}

//解析document
function documentAnalysis($scope,$http, document,FontManagement, callbackRatio, callback) {
    angular.forEach(document.pages.page, function (page, index) {
        (function (page, index) {
            page.seq = index;
            page.mediabox = {
                width: MmTurnPx(page.mediabox.width),
                height: MmTurnPx(page.mediabox.height),
                x: MmTurnPx(page.mediabox.x),
                y: MmTurnPx(page.mediabox.y)
            };
            page.trimbox = {
                width: MmTurnPx(page.trimbox.width),
                height: MmTurnPx(page.trimbox.height),
                x: MmTurnPx(page.trimbox.x),
                y: MmTurnPx(page.trimbox.y)
            };
            // 兼容旧模板 可编辑区域
            if (!page.editbox) {
                page.editbox = angular.copy(page.trimbox);
            }else{
                page.editbox = {
                    width: MmTurnPx(page.editbox.width),
                    height: MmTurnPx(page.editbox.height),
                    x: MmTurnPx(page.editbox.x),
                    y: MmTurnPx(page.editbox.y)
                };
            }
            if(!page.editboxes || !page.editboxes.editbox){
                page.editboxes = {
                    editbox: [page.editbox]
                }
            }else{
                page.editboxes.editbox.forEach(function (editbox, editboxIndex) {
                    page.editboxes.editbox[editboxIndex] = {
                        width: MmTurnPx(editbox.width),
                        height: MmTurnPx(editbox.height),
                        x: MmTurnPx(editbox.x),
                        y: MmTurnPx(editbox.y)
                    }
                })
            }
            page.custom = {};
            if (page.scene) {
                page.scene.geometry = {
                    width: MmTurnPx(page.scene.geometry.width),
                    height: MmTurnPx(page.scene.geometry.height),
                    x: MmTurnPx(page.scene.geometry.x),
                    y: MmTurnPx(page.scene.geometry.y)
                };
                page.scene.imagebox.geometry = {
                    width: MmTurnPx(page.scene.imagebox.geometry.width),
                    height: MmTurnPx(page.scene.imagebox.geometry.height),
                    x: MmTurnPx(page.scene.imagebox.geometry.x),
                    y: MmTurnPx(page.scene.imagebox.geometry.y)
                };
                if (page.scene.resource) {
                    getBackgroundSource($http, page.scene.resource, page.scene.geometry.width, page.scene.geometry.height, document.pages.page[index].scene, $scope);
                }
                page.custom.width = page.scene.geometry.width;
                page.custom.height = page.scene.geometry.height;
            } else {
                page.custom.width = page.mediabox.width;
                page.custom.height = page.mediabox.height;
            }
            page.custom.thumbnailScale = 300 / page.custom.width;
            callbackRatio(page,index)
            //条形码
            if (page.barcode) {
                page.barcode.geometry = {
                    width: MmTurnPx(page.barcode.geometry.width),
                    height: MmTurnPx(page.barcode.geometry.height),
                    x: MmTurnPx(page.barcode.geometry.x),
                    y: MmTurnPx(page.barcode.geometry.y)
                };
            }
            if (page.qrcode) {
                page.qrcode.geometry = {
                    width: MmTurnPx(page.qrcode.geometry.width),
                    height: MmTurnPx(page.qrcode.geometry.height),
                    x: MmTurnPx(page.qrcode.geometry.x),
                    y: MmTurnPx(page.qrcode.geometry.y)
                };
            }
            //背景
            if (page.background && page.background.resource &&page.background.resource.identifier) {
                getBackgroundSource($http, page.background.resource, page.mediabox.width, page.mediabox.height, document.pages.page[index].background, $scope);
                page.background.offsetx = MmTurnPx(page.background.offsetx);
                page.background.offsety = MmTurnPx(page.background.offsety);
                page.background.type = 'Pic'
            }
            if(!page.levels.level){
                page.levels.level=[];
            }
            angular.forEach(page.levels.level, function (level, i) {
                (function (level, i) {
                    if (level.code && level.code.geometry) {
                        level.code.lock = true;
                        level.code.lock = true;
                        level.code.geometry = {
                            width: MmTurnPx(level.code.geometry.width),
                            height: MmTurnPx(level.code.geometry.height),
                            x: MmTurnPx(level.code.geometry.x),
                            y: MmTurnPx(level.code.geometry.y)
                        };
                    }
                    if (level.imageart && level.imageart.geometry) {
                        level.imageart.levelI = i;
                        level.imageart.pageI = index;
                        level.imageart.offsetx = MmTurnPx(level.imageart.offsetx);
                        level.imageart.offsety = MmTurnPx(level.imageart.offsety);
                        level.imageart.geometry = {
                            width: MmTurnPx(level.imageart.geometry.width),
                            height: MmTurnPx(level.imageart.geometry.height),
                            x: MmTurnPx(level.imageart.geometry.x),
                            y: MmTurnPx(level.imageart.geometry.y)
                        };
                        level.imageart.rotation.angle = -level.imageart.rotation.angle;
                        if (level.imageart.resource.identifier) {
                            getBackgroundSource($http, level.imageart.resource, level.imageart.geometry.width, level.imageart.geometry.height, document.pages.page[index].levels.level[i].imageart, $scope);
                        }
                    }
                    if (level.imagebox&&level.imagebox.geometry) {
                        level.imagebox.transparency = isNaN(level.imagebox.transparency) ? 1 : level.imagebox.transparency;
                        level.imagebox.geometry = {
                            width: MmTurnPx(level.imagebox.geometry.width),
                            height: MmTurnPx(level.imagebox.geometry.height),
                            x: MmTurnPx(level.imagebox.geometry.x),
                            y: MmTurnPx(level.imagebox.geometry.y)
                        };
                        // level.imagebox.rotation.angle = -level.imagebox.rotation.angle;
                        if (level.imagebox.image) {
                            level.imagebox.image.offsetx = MmTurnPx(level.imagebox.image.offsetx);
                            level.imagebox.image.offsety = MmTurnPx(level.imagebox.image.offsety);
                            if (level.imagebox.image.resource && level.imagebox.image.resource.identifier) {
                                getBackgroundSource1(level.imagebox.image.resource, level.imagebox.geometry.width, level.imagebox.geometry.height, document.pages.page[index].levels.level[i].imagebox.image, $scope,
                                    function () {})
                            }
                        }
                    }
                    if (level.textbox && level.textbox.geometry) {
                        level.textbox.geometry = {
                            width: MmTurnPx(level.textbox.geometry.width),
                            height: MmTurnPx(level.textbox.geometry.height),
                            x: MmTurnPx(level.textbox.geometry.x),
                            y: MmTurnPx(level.textbox.geometry.y)
                        };
                        level.textbox.rotation.angle = -level.textbox.rotation.angle;
                        if (level.textbox.fontuuid) {
                            //下载字体
                            getFont(level.textbox,FontManagement);
                        }
                        if (level.textbox.style.bold && level.textbox.style.italic) {
                            level.textbox.styles = 'BOLD_ITALIC';
                        } else if (level.textbox.style.bold) {
                            level.textbox.styles = 'BOLD';
                        } else if (level.textbox.style.italic) {
                            level.textbox.styles = 'ITALIC';
                        } else {
                            level.textbox.styles = 'NORMAL';
                        }
                    }
                    if (level.textdocument && level.textdocument.geometry) {
                        var textdocument = angular.copy(level.textdocument);
                        level.textdocument = {
                            background: textdocument.background,
                            geometry: {
                                width: MmTurnPx(textdocument.geometry.width),
                                height: MmTurnPx(textdocument.geometry.height),
                                x: MmTurnPx(textdocument.geometry.x),
                                y: MmTurnPx(textdocument.geometry.y)
                            },
                            rotation: {
                                angle: textdocument.rotation.angle!= null? textdocument.rotation.angle : 0
                            },
                            current: 'textdocument',
                            levels: angular.copy(textdocument.levels),
                            lock: true,
                            transparency: textdocument.transparency,
                            movable: textdocument.movable,
                            useradded: textdocument.useradded,
                            editable: textdocument.editable,
                            scale: textdocument.geometry.width / page.mediabox.width,
                            levelI:i,
                            pageI: index
                        }

                        var backg = textdocument.background;
                        var pageW = textdocument.geometry.width,
                            pageH = textdocument.geometry.height;
                        if (backg.resource.identifier) {
                            getBackgroundSource($http, backg.resource, pageW, pageH, document.pages.page[index].levels.level[i].textdocument.background, $scope);
                            backg.offsetx = MmTurnPx(backg.offsetx);
                            backg.offsety = MmTurnPx(backg.offsety);
                        }

                        angular.forEach(textdocument.levels.level, function (lev, l) {
                            if (lev.imageart && lev.imageart.geometry) {
                                var art = lev.imageart;
                                $http({url: art.resource.identifier + '?imageInfo'}).success(function (data) {
                                    level.textdocument.levels.level[l].imageart = {
                                        geometry: {
                                            width: MmTurnPx(art.geometry.width),
                                            height: MmTurnPx(art.geometry.height),
                                            x: MmTurnPx(art.geometry.x),
                                            y: MmTurnPx(art.geometry.y)
                                        },
                                        rotation: angular.copy(art.rotation),
                                        type: art.type,
                                        resource: {
                                            identifier: art.resource.identifier,
                                            provider: art.resource.provider,
                                            width: data.width,
                                            height: data.height
                                        },
                                        scale: art.scale,
                                        offsetx: MmTurnPx(art.offsetx),
                                        offsety: MmTurnPx(art.offsety),
                                        current: 'imageart',
                                        lock: false,
                                        transparency: art.transparency,
                                        onlyshow: art.onlyshow,
                                        movable: art.movable,
                                        useradded: art.useradded,
                                        editable: art.editable,
                                        levelI:i,
                                        pageI: index
                                    }
                                    level.textdocument.levels.level[l].imageart.rotation.angle = -level.textdocument.levels.level[l].imageart.rotation.angle;
                                }).error(function (error) {
                                });
                            }
                            if (lev.textbox && lev.textbox.geometry) {
                                var text = lev.textbox;
                                level.textdocument.levels.level[l].textbox = {
                                    geometry: {
                                        width: MmTurnPx(text.geometry.width),
                                        height: MmTurnPx(text.geometry.height),
                                        x: MmTurnPx(text.geometry.x),
                                        y: MmTurnPx(text.geometry.y)
                                    },
                                    identifier: text.identifier,
                                    rotation: angular.copy(text.rotation),
                                    angle: angular.copy(text.angle),
                                    status: angular.copy(text.status),
                                    style: angular.copy(text.style),
                                    type: angular.copy(text.type),
                                    text: angular.copy(text.text),
                                    fontStyle: [{
                                        style: '',
                                        path: text.identifier
                                    }],
                                    current: 'textbox',
                                    lock: true,
                                    transparency: text.transparency,
                                    fontuuid: text.fontuuid,
                                    version: text.version,
                                    levelI:i,
                                    pageI: index
                                }
                                level.textdocument.levels.level[l].textbox.rotation.angle = -level.textdocument.levels.level[l].textbox.rotation.angle;
                                getFont(text,FontManagement)
                            }
                        })
                    }
                    if (level.calMonthBox && level.calMonthBox.geometry) {
                        var calMonthBox = angular.copy(level.calMonthBox);
                        level.calMonthBox.geometry = {
                            width: MmTurnPx(calMonthBox.geometry.width),
                            height: MmTurnPx(calMonthBox.geometry.height),
                            x: MmTurnPx(calMonthBox.geometry.x),
                            y: MmTurnPx(calMonthBox.geometry.y),
                        }
                        level.calMonthBox.sampleYear = getDay('year',document.config.startYear,document.config.startMonth,page.config.monthIndex);
                        level.calMonthBox.sampleMonth = getDay('month',document.config.startYear,document.config.startMonth,page.config.monthIndex);
                    }
                    if (level.calTitleBox && level.calTitleBox.geometry) {
                        var calTitleBox = angular.copy(level.calTitleBox);
                        level.calTitleBox.geometry = {
                            width: MmTurnPx(calTitleBox.geometry.width),
                            height: MmTurnPx(calTitleBox.geometry.height),
                            x: MmTurnPx(calTitleBox.geometry.x),
                            y: MmTurnPx(calTitleBox.geometry.y),
                        }
                        level.calTitleBox.sampleYear = getDay('year',document.config.startYear,document.config.startMonth,page.config.monthIndex);
                        level.calTitleBox.sampleMonth = getDay('month',document.config.startYear,document.config.startMonth,page.config.monthIndex);
                    }
                })(level, i)
            })
        })(page, index)
    })
    setTimeout(function () {
        callback.call(this,document);
        $scope.$apply();
    },1000)
}
//裁切区域
function pageTrimbox(page, text) {
    if(page && page.custom){
        page.mediabox1 = angular.copy(page.mediabox);
        page.custom.width = page.trimbox.width;
        page.custom.height = page.trimbox.height;
        page.mediabox.width = page.trimbox.width;
        page.mediabox.height = page.trimbox.height;
        if (page.background && page.background.resource &&page.background.resource.identifier) {
            page.background.offsetx = page.background.offsetx-page.trimbox.x;
            page.background.offsety = page.background.offsety-page.trimbox.y;
        }
        if (page.barcode) {
            page.barcode.geometry.x = page.barcode.geometry.x-page.trimbox.x;
            page.barcode.geometry.y = page.barcode.geometry.y-page.trimbox.y;
        }
        if (page.qrcode) {
            page.qrcode.geometry.x = page.qrcode.geometry.x-page.trimbox.x;
            page.qrcode.geometry.y = page.qrcode.geometry.y-page.trimbox.y;
        }
        angular.forEach(page.levels.level, function (level, i) {
            if (level.imageart) {
                level.imageart.geometry.x = level.imageart.geometry.x-page.trimbox.x;
                level.imageart.geometry.y = level.imageart.geometry.y-page.trimbox.y;
            }
            if(level.imagebox){
                level.imagebox.geometry.x = level.imagebox.geometry.x-page.trimbox.x;
                level.imagebox.geometry.y = level.imagebox.geometry.y-page.trimbox.y;
            }
            if (level.textbox) {
                if (!(level.textbox.text == '' || level.textbox.text == null || level.textbox.text == text || level.textbox.text == '双击输入文字') && (level.textbox.geometry.width != 0 && level.textbox.geometry.height != 0)) {
                    level.textbox.geometry.x = level.textbox.geometry.x-page.trimbox.x;
                    level.textbox.geometry.y = level.textbox.geometry.y-page.trimbox.y;
                }else{
                    level.textbox = null;
                }
            }
            if (level.textdocument) {
                level.textdocument.geometry.x = level.textdocument.geometry.x-page.trimbox.x;
                level.textdocument.geometry.y = level.textdocument.geometry.y-page.trimbox.y;
            }
            if (level.code) {
                level.code.geometry.x = level.code.geometry.x-page.trimbox.x;
                level.code.geometry.y = level.code.geometry.y-page.trimbox.y;
            }
            if (level.calTitleBox) {
                level.calTitleBox.geometry.x = level.calTitleBox.geometry.x-page.trimbox.x;
                level.calTitleBox.geometry.y = level.calTitleBox.geometry.y-page.trimbox.y;
            }
            if (level.calMonthBox) {
                level.calMonthBox.geometry.x = level.calMonthBox.geometry.x-page.trimbox.x;
                level.calMonthBox.geometry.y = level.calMonthBox.geometry.y-page.trimbox.y;
            }
        })
    }
}
function getBackgroundSource($http, res, pageW, pageH, item, $scope, callback) {
    var newImg = new Image();
    newImg.crossOrigin = "Anonymous";
    newImg.src = res.identifier + "?imageMogr2/thumbnail/10x10";
    newImg.onload = function () {
        var bgImgW = pageW;
        var bgImgH = pageH;
        var bgImgR = bgImgW/bgImgH;
        var bgImgR1 = newImg.width/newImg.height;
        item.width = newImg.width;
        item.height = newImg.height;
        if(bgImgR >= bgImgR1){
            item.resource.adaptation = 'Width';
            item.adaptation = 'Width';
        }else {
            item.resource.adaptation = 'Height';
            item.adaptation = 'Height';
        }
        if(callback){
            callback();
        }
        $scope.$apply();
    };
}
function getBackgroundSource1(res, pageW, pageH, item, $scope,callback) {
    if(!item.height && !item.width){
        var newImg = new Image();
        newImg.crossOrigin = "Anonymous";
        newImg.src = res.identifier + '?imageMogr2/strip/rotate/' + item.angle + '/thumbnail/!40p';
        newImg.onload = function () {
            getBackgroundSource1Cb(res, pageW, pageH, item, $scope,newImg, function () {
                if(callback){callback()};
                $scope.$apply();
            })
        };
    }else{
        var newImg = {
            width: angular.copy(item.width),
            height: angular.copy(item.height),
        }
        getBackgroundSource1Cb(res, pageW, pageH, item, $scope,newImg, callback)
    }
}
function getBackgroundSource1Cb(res, pageW, pageH, item, $scope,newImg, callback) {
    var imgR = pageW / pageH;
    var imgR1 = newImg.width / newImg.height;
    if (imgR >= imgR1) {
        item.resource.adaptation = 'Height';
        item.width = pageW;
        item.height = pageW / newImg.width * newImg.height;
    } else {
        item.resource.adaptation = 'Width';
        item.width = pageH / newImg.height * newImg.width;
        item.height = pageH;
    }
    if(callback){
        callback()
    }
}
var fontuuids = [];
function getFont(item,FontManagement, callback) {
    if(!fontuuids){
        fontuuids = [];
    }
    if(fontuuids.indexOf(item.fontuuid) == -1){
        fontuuids.push(item.fontuuid);
        FontManagement.getCss({uuid: item.fontuuid}, function (res) {
            var fontnode = res.message;
            var style = document.createElement("style");
            style.type = 'text/css';
            try {
                style.appendChild(document.createTextNode(fontnode));
            } catch (ex) {
                style.stylesheet.cssText = fontnode;
            }
            var Head = document.getElementsByTagName("head")[0];
            Head.appendChild(style);
            document.fonts.ready.then(function () {});
            if (callback) {
                callback();
            }
        });
    }else{
        if (callback) {
            callback();
        }
    }
}

function checkFloatNum(str){
    str = Number(str);
    var reg_zs = /^[0-9]\d*(\.\d+)?$/i;
    if (!reg_zs.test(str)) {
        return false;
    }
    return true;
}


function compare(property, attr) {
    return function (a, b) {
        var value1 = a[property];
        var value2 = b[property];
        if (attr) {
            return value1 - value2;
        } else {
            return value2 - value1;
        }
    }
}

/**
 * 校验手机号
 */
function checkPhone(phone){
    var reg = /^1[3456789]\d{9}$/;
    return reg.test(phone);
}
/**
 * 校验账号
 */
function checkUserName(name){
    var reg = /^[_'.@A-Za-z0-9-]*$/;
    return reg.test(name);
}


var adsorbNumber = 6;
function adsorbAngle(angle) {
    if(-adsorbNumber < angle && angle < adsorbNumber){angle = 0}
    else if(90-adsorbNumber < angle && angle < 90+adsorbNumber){angle = 90}
    else if(180-adsorbNumber < angle && angle < 180+adsorbNumber){angle = 180}
    else if(270-adsorbNumber < angle && angle < 270+adsorbNumber){angle = 270}
    else if(360-adsorbNumber < angle && angle < 360+adsorbNumber){angle = 360}
    return angle
}

/**
 * 获取年月
 * */
function getDay(item,year,month,monthIndex) {
    var _ret = "";
    var month = month<10?"0"+month:month;
    var currentDate = new Date(year + "-" + month);
    currentDate.setMonth(currentDate.getMonth() + monthIndex-1);
    if(item=='year'){
        _ret = currentDate.getFullYear()
    }
    if(item=='month'){
        _ret = (currentDate.getMonth() + 1)
    }
    return _ret
}
/**
 * 创建日历和标题
 * */
function getTitleWidget(seq,titleWidget,unitConversion,x,y) {
    var _titleWidget = angular.copy(titleWidget);
    
    var _level = {
        calTitleBox:{
            geometry: {
                width:unitConversion?_titleWidget.width : PxTurnMm(_titleWidget.width),
                height:unitConversion?_titleWidget.height : PxTurnMm(_titleWidget.height),
                x:x?(unitConversion?x:PxTurnMm(x)):0,
                y:y?(unitConversion?y:PxTurnMm(y)):0,
            },
            rotation:{
                angle:0
            },
            name:_titleWidget.name,
            previewUrl:_titleWidget.previewUrl,
            settings:{
                border:_titleWidget.settings.border,
                items:{
                    item:_titleWidget.settings.items
                }
            },
            layout:{
                geometry: {
                    width:_titleWidget.layout.width,
                    height:_titleWidget.layout.height,
                    x:0,
                    y:0,
                },
                previewUrl:_titleWidget.layout.previewUrl,
                type:_titleWidget.layout.type,
                items:{
                    item:_titleWidget.layout.items,
                }
            },
            current: 'calTitleBox',
        },
        seq:seq
    }
    _level.calTitleBox.layout.items.item.forEach(function (item) {
        item.geometry = {
            width:item.w,
            height:item.h,
            x:item.x,
            y:item.y,
        }
    })
    _level.calTitleBox.settings.items.item.forEach(function (item) {
        item.geometry = {
            width:item.w,
            height:item.h,
            x:item.x,
            y:item.y,
        }
    })
    return _level
}
function getMonthWidget(seq,monthWidget,unitConversion,x,y) {
    var _monthWidget = angular.copy(monthWidget);
    var _level = {
        calMonthBox:{
            geometry: {
                width:unitConversion?_monthWidget.width : PxTurnMm(_monthWidget.width),
                height:unitConversion?_monthWidget.height : PxTurnMm(_monthWidget.height),
                x:x?(unitConversion?x:PxTurnMm(x)):0,
                y:y?(unitConversion?y:PxTurnMm(y)):0,
            },
            rotation:{
                angle:0
            },
            weekConfig:_monthWidget.weekConfig,
            weekStyles:{item:_monthWidget.weekStyles},
            weekLayout:{
                geometry: {
                    width:_monthWidget.weekLayout.width,
                    height:_monthWidget.weekLayout.height,
                    x:0,
                    y:0,
                },
                items:{
                    item:_monthWidget.weekLayout.items
                },
                type:_monthWidget.weekLayout.type,
                previewUrl:_monthWidget.weekLayout.previewUrl
            },
            dateConfig:_monthWidget.dateConfig,
            dateStyles:{item:_monthWidget.dateStyles},
            dateLayout:{
                geometry: {
                    width:_monthWidget.dateLayout.width,
                    height:_monthWidget.dateLayout.height,
                    x:0,
                    y:0,
                },
                items:{
                    item:_monthWidget.dateLayout.items
                },
                type:_monthWidget.dateLayout.type,
                previewUrl:_monthWidget.dateLayout.previewUrl
            },
            displayType:_monthWidget.displayType,
            backgroundColor:_monthWidget.backgroundColor,
            showOthers:_monthWidget.showOthers,
            startOfWeek:_monthWidget.startOfWeek,
            current: 'calMonthBox',
        },
        seq:seq
    }
    _level.calMonthBox.weekLayout.items.item.forEach(function (weekLayout) {
        weekLayout.geometry = {
            width:weekLayout.w,
            height:weekLayout.h,
            x:weekLayout.x,
            y:weekLayout.y,
        }
    })
    _level.calMonthBox.dateLayout.items.item.forEach(function (dateLayout) {
        dateLayout.geometry = {
            width:dateLayout.w,
            height:dateLayout.h,
            x:dateLayout.x,
            y:dateLayout.y,
        }
    })
    _level.calMonthBox.weekStyles.item.forEach(function (weekStyle) {
        var _items = angular.copy(weekStyle.items);
        _items.forEach(function (_item) {
            _item.geometry = {
                width:_item.w,
                height:_item.h,
                x:_item.x,
                y:_item.y,
            }
        })
        weekStyle.items = {
            item:_items
        }
    })
    _level.calMonthBox.dateStyles.item.forEach(function (dateStyle) {
        var _items = angular.copy(dateStyle.items);
        _items.forEach(function (_item) {
            _item.geometry = {
                width:_item.w,
                height:_item.h,
                x:_item.x,
                y:_item.y,
            }
        })
        dateStyle.items = {
            item:_items
        }
    })
    return _level
}
//防抖
var _antiShake = null;
function antiShake(callback,time) {
    var _time = time || 500;
    if (_antiShake !== null) {
        clearTimeout(_antiShake)
    }
    _antiShake = setTimeout(function () {
        callback()
    },_time)
}

//判断月份是否连续，并列出不连续的月份
function findMissingNumbers(numbers) {
    var missingNumbers = [];
    var max = Math.max.apply(null, numbers);
    var min = Math.min.apply(null, numbers);
    for (var i = min; i <= max; i++) {
        if (!numbers.includes(i)) {
            missingNumbers.push(i);
        }
    }
    return missingNumbers;
}
//获取日历一行几列
function displayType(item) {
    switch (item) {
        case 'C7':
            return 7;
        case 'C14':
            return 14;
        case 'C21':
            return 21;
        default:
            return 7;
    }
}


// 监听dom元素加载完成事件
function getDomOnload(scope, id, callback) {
    var monitorNum  = 0;
    // 如果monitorNum始终为0，则判断dom没有渲染
    setTimeout(function () {
        if (monitorNum == 0) {
            if (typeof callback === 'function') callback();
            observer.disconnect();
            scope.$apply();
        }
    },500)
    var targetDiv = document.querySelector('#'+id);// 获取要监听的 div 元素
    var config = { childList: true, subtree: true};// 配置 MutationObserver，监听子节点的变化
    var observer = new MutationObserver(function(mutationsList, observer) {// 创建一个 MutationObserver 实例
        // 遍历所有的 mutation
        for (var i = 0; i < mutationsList.length; i++) {
            var mutation = mutationsList[i];
            // 判断 mutation 是否是子节点的变化
            if (mutation.type === 'childList') {
                // 判断是否是更新状态的变化
                if (mutation.addedNodes.length) {
                    monitorNum++;
                    takeScreenshot();
                }
            }
        }
    });
    observer.observe(targetDiv, config);
    // 执行截图事件的函数
    var timer = null;
    function takeScreenshot() {
        if (timer !== null) {
            clearTimeout(timer)
        }
        timer = setTimeout(function () {
            if (typeof callback === 'function') callback();
            observer.disconnect();
            scope.$apply();
        },1000)
    }
}

// 圆角切换  固定/百分比
function switchToRoundedMode(imagebox, borderRadiusAllbtn) {
    var radiusW = Math.min(imagebox.geometry.width, imagebox.geometry.height);
    radiusW = radiusW + Number(imagebox.border.lineWidth);
    if (imagebox.border.radius.filletType == 'Proportion') {// 固定值转百分比
        if (borderRadiusAllbtn == true) {
            var all = (imagebox.border.radius.all / radiusW * 100) > 100 ? 100 : Math.round(imagebox.border.radius.all / radiusW * 100);
            imagebox.border.radius.all = all;
            imagebox.border.radius.lt = all;
            imagebox.border.radius.rt = all;
            imagebox.border.radius.rb = all;
            imagebox.border.radius.lb = all;
        } else {
            var scaleDown = scaleDownTo100((imagebox.border.radius.lt / radiusW * 100), (imagebox.border.radius.rt / radiusW * 100), (imagebox.border.radius.rb / radiusW * 100), (imagebox.border.radius.lb / radiusW * 100))
            imagebox.border.radius.lt = scaleDown[0];
            imagebox.border.radius.rt = scaleDown[1];
            imagebox.border.radius.rb = scaleDown[2];
            imagebox.border.radius.lb = scaleDown[3];
        }
    } else {//百分比转固定值
        if (borderRadiusAllbtn == true) {
            var all = Math.round(imagebox.border.radius.all / 100 * radiusW);
            imagebox.border.radius.all = all;
            imagebox.border.radius.lt = all;
            imagebox.border.radius.rt = all;
            imagebox.border.radius.rb = all;
            imagebox.border.radius.lb = all;
        } else {
            imagebox.border.radius.lt = Math.round(imagebox.border.radius.lt / 100 * radiusW);
            imagebox.border.radius.rt = Math.round(imagebox.border.radius.rt / 100 * radiusW);
            imagebox.border.radius.rb = Math.round(imagebox.border.radius.rb / 100 * radiusW);
            imagebox.border.radius.lb = Math.round(imagebox.border.radius.lb / 100 * radiusW);
        }
    }


    // 等比列缩小到100以下
    function scaleDownTo100(value1, value2, value3, value4) {
        var maxValue = Math.max(value1, value2, value3, value4);
        if (maxValue < 100) {
            return [Math.round(value1), Math.round(value2), Math.round(value3), Math.round(value4)];
        }
        var scaleRatio = 100 / maxValue;

        // 缩小数值
        var scaledValue1 = Math.round(value1 * scaleRatio);
        var scaledValue2 = Math.round(value2 * scaleRatio);
        var scaledValue3 = Math.round(value3 * scaleRatio);
        var scaledValue4 = Math.round(value4 * scaleRatio);

        // 返回缩小后的数值
        return [scaledValue1, scaledValue2, scaledValue3, scaledValue4];
    }
}

function getTextHeight(textbox,isAdd) {
    // 创建临时div
    var div = document.createElement('div');
    // 设置样式
    div.className = 'addDiv';
    div.style.width = writingmodeInit(textbox.style.writingmode) || isAdd ? 'auto' : textbox.geometry.width-10 + "px";
    div.style.height = !writingmodeInit(textbox.style.writingmode) || isAdd ? 'auto' : textbox.geometry.height-10 + "px";
    div.style.fontSize = textbox.style.size + "pt";
    div.style.letterSpacing = textbox.style.letterspacing + "pt";
    div.style.lineHeight = textbox.style.lineheight + "pt";
    div.style.fontFamily = textbox.fontuuid;
    div.style.writingMode = textbox.style.writingmode; // 确保自动换行
    div.style.whiteSpace = 'pre-wrap'; // 确保自动换行
    div.style.wordBreak = 'break-all'; // 确保自动换行
    div.style.position = 'absolute'; // 避免影响布局
    div.style.visibility = 'hidden'; // 隐藏元素
    // 设置文本内容
    div.textContent = textbox.text;
    // 添加到DOM（必须添加到文档中才能获取高度）
    document.body.appendChild(div);
    
    // 获取高度（包括内边距但不包括边框和外边距）
    var height = div.clientHeight;
    var width = div.clientWidth;
    
    if(!writingmodeInit(textbox.style.writingmode)){
        textbox.geometry.height = height+10;
        if(isAdd){
            textbox.geometry.width = width+10;
        }
    }
    if(writingmodeInit(textbox.style.writingmode)){
        textbox.geometry.width = width+10;
        if(isAdd){
            textbox.geometry.height = height+10;
        }
    }
    // 清理临时元素
    document.body.removeChild(div);
}
function writingmodeInit(item) {
    if(item == 'vertical-lr' || item == 'vertical-rl'){
        return true
    }else{
        return false
    }
}
(function() {
    'use strict';

    angular
        .module('platformApp')
        .filter('capitalize', capitalize);

    function capitalize() {
        return capitalizeFilter;

        function capitalizeFilter (input) {
            if (input !== null) {
                input = input.toLowerCase();
                input = input.substring(0, 1).toUpperCase() + input.substring(1);
            }
            return input;
        }
    }
})();

/**
 * bookblock.js v2.0.1
 * http://www.codrops.com
 *
 * Licensed under the MIT license.
 * http://www.opensource.org/licenses/mit-license.php
 * 
 * Copyright 2013, Codrops
 * http://www.codrops.com
 */
;( function( window ) {
	
	'use strict';

	// global
	var document = window.document,
		Modernizr = window.Modernizr;

	// https://gist.github.com/edankwan/4389601
	Modernizr.addTest('csstransformspreserve3d', function () {
		var prop = Modernizr.prefixed('transformStyle');
		var val = 'preserve-3d';
		var computedStyle;
		if(!prop) return false;

		prop = prop.replace(/([A-Z])/g, function(str,m1){ return '-' + m1.toLowerCase(); }).replace(/^ms-/,'-ms-');

		Modernizr.testStyles('#modernizr{' + prop + ':' + val + ';}', function (el, rule) {
			computedStyle = window.getComputedStyle ? getComputedStyle(el, null).getPropertyValue(prop) : '';
		});

		return (computedStyle === val);
	});

	function extend( a, b ) {
		for( var key in b ) { 
			if( b.hasOwnProperty( key ) ) {
				a[key] = b[key];
			}
		}
		return a;
	}

	function BookBlock( el, options ) {
		this.el = el;
		this.options = extend( this.defaults, options );
		this._init();
	}

	BookBlock.prototype = {
		defaults : {
			// vertical or horizontal flip
			orientation : 'vertical',
			// ltr (left to right) or rtl (right to left)
			direction : 'ltr',
			// speed for the flip transition in ms
			speed : 1000,
			// easing for the flip transition
			easing : 'ease-in-out',
			// if set to true, both the flipping page and the sides will have an overlay to simulate shadows
			shadows : true,
			// opacity value for the "shadow" on both sides (when the flipping page is over it)
			// value : 0.1 - 1
			shadowSides : 0.2,
			// opacity value for the "shadow" on the flipping page (while it is flipping)
			// value : 0.1 - 1
			shadowFlip : 0.1,
			// if we should show the first item after reaching the end
			circular : false,
			// if we want to specify a selector that triggers the next() function. example: ´#bb-nav-next´
			nextEl : '',
			// if we want to specify a selector that triggers the prev() function
			prevEl : '',
			// autoplay. If true it overwrites the circular option to true
			autoplay : false,
			// time (ms) between page switch, if autoplay is true
			interval : 3000,
			// callback after the flip transition
			// old is the index of the previous item
			// page is the current item´s index
			// isLimit is true if the current page is the last one (or the first one)
			onEndFlip : function(old, page, isLimit) { return false; },
			// callback before the flip transition
			// page is the current item´s index
			onBeforeFlip : function(page) { return false; }
		},
		_init : function() {
			// orientation class
			this.el.className += ' bb-' + this.options.orientation;
			// items
			this.items = Array.prototype.slice.call( this.el.querySelectorAll( '.bb-item' ) );
			// total items
			this.itemsCount = this.items.length;
			// current item´s index
			this.currentIdx = 0;
			// previous item´s index
			this.previous = -1;
			// show first item
			this.current = this.items[ this.currentIdx ];
			this.current.style.display = 'block';
			// get width of this.el
			// this will be necessary to create the flipping layout
			this.elWidth = this.el.offsetWidth;
			var transEndEventNames = {
				'WebkitTransition': 'webkitTransitionEnd',
				'MozTransition': 'transitionend',
				'OTransition': 'oTransitionEnd',
				'msTransition': 'MSTransitionEnd',
				'transition': 'transitionend'
			};
			this.transEndEventName = transEndEventNames[Modernizr.prefixed( 'transition' )];
			// support css 3d transforms && css transitions && Modernizr.csstransformspreserve3d
			this.support = Modernizr.csstransitions && Modernizr.csstransforms3d && Modernizr.csstransformspreserve3d;
			// initialize/bind some events
			this._initEvents();
			// start slideshow
			if ( this.options.autoplay ) {
				this.options.circular = true;
				this._startSlideshow();
			}
		},
		_initEvents : function() {

			var self = this;

			if ( this.options.nextEl !== '' ) {
				document.querySelector( this.options.nextEl ).addEventListener( 'click', function() { self._action( 'next' ); return false; } );
				document.querySelector( this.options.nextEl ).addEventListener( 'touchstart', function() { self._action( 'next' ); return false; } );
			}

			if ( this.options.prevEl !== '' ) {
				document.querySelector( this.options.prevEl ).addEventListener( 'click', function() { self._action( 'prev' ); return false; } );
				document.querySelector( this.options.prevEl ).addEventListener( 'touchstart', function() { self._action( 'prev' ); return false; } );
			}
			
			window.addEventListener( 'resize', function() { self._resizeHandler(); } );

		},
		_action : function( dir, page ) {
			this._stopSlideshow();
			this._navigate( dir, page );
		},
		_navigate : function( dir, page ) {

			if ( this.isAnimating ) {
				return false;
			}

			// callback trigger
			this.options.onBeforeFlip( this.currentIdx );

			this.isAnimating = true;
			// update current value
			this.current = this.items[ this.currentIdx ];

			if ( page !== undefined ) {
				this.currentIdx = page;
			}
			else if ( dir === 'next' && this.options.direction === 'ltr' || dir === 'prev' && this.options.direction === 'rtl' ) {
				if ( !this.options.circular && this.currentIdx === this.itemsCount - 1 ) {
					this.end = true;
				}
				else {
					this.previous = this.currentIdx;
					this.currentIdx = this.currentIdx < this.itemsCount - 1 ? this.currentIdx + 1 : 0;
				}
			}
			else if ( dir === 'prev' && this.options.direction === 'ltr' || dir === 'next' && this.options.direction === 'rtl' ) {
				if ( !this.options.circular && this.currentIdx === 0 ) {
					this.end = true;
				}
				else {
					this.previous = this.currentIdx;
					this.currentIdx = this.currentIdx > 0 ? this.currentIdx - 1 : this.itemsCount - 1;
				}
			}

			this.nextItem = !this.options.circular && this.end ? this.current : this.items[ this.currentIdx ];
			
			this.items.forEach( function( el, i ) { el.style.display = 'none'; } );
			if ( !this.support ) {
				this._layoutNoSupport( dir );
			} else {
				this._layout( dir );
			}

		},
		_layoutNoSupport : function(dir) {
			this.nextItem.style.display = 'block';
			this.end = false;
			this.isAnimating = false;
			var isLimit = dir === 'next' && this.currentIdx === this.itemsCount - 1 || dir === 'prev' && this.currentIdx === 0;
			// callback trigger
			this.options.onEndFlip( this.previous, this.currentIdx, isLimit );
		},
		// creates the necessary layout for the 3d structure and triggers the transitions
		_layout : function(dir) {

			var self = this,
				// basic structure: 1 element for the left side.
				s_left = this._addSide( 'left', dir ),
				// 1 element for the flipping/middle page
				s_middle = this._addSide( 'middle', dir ),
				// 1 element for the right side
				s_right = this._addSide( 'right', dir ),
				// overlays
				o_left = s_left.querySelector( 'div.bb-overlay' ),
				o_middle_f = s_middle.querySelector( 'div.bb-front' ).querySelector( 'div.bb-flipoverlay' ),
				o_middle_b = s_middle.querySelector( 'div.bb-back' ).querySelector( 'div.bb-flipoverlay' ),
				o_right = s_right.querySelector( 'div.bb-overlay' ),
				speed = this.end ? 400 : this.options.speed;

			var fChild = this.items[0];
			this.el.insertBefore( s_left, fChild );
			this.el.insertBefore( s_middle, fChild );
			this.el.insertBefore( s_right, fChild );
			s_left.style.zIndex = 102;
			s_middle.style.zIndex = 103;
			s_right.style.zIndex = 101;

			s_middle.style.transitionDuration = speed + 'ms';
			s_middle.style.transitionTimingFunction = this.options.easing;
			
			s_middle.addEventListener( this.transEndEventName, function( event ) {
				if ( (" " + event.target.className + " ").replace(/[\n\t]/g, " ").indexOf(" bb-page ") > -1 ) {
					Array.prototype.slice.call( self.el.querySelectorAll( '.bb-page' ) ).forEach( function( el, i ) {
						self.el.removeChild( el );
					} );
					self.nextItem.style.display = 'block';
					self.end = false;
					self.isAnimating = false;
					var isLimit = dir === 'next' && self.currentIdx === self.itemsCount - 1 || dir === 'prev' && self.currentIdx === 0;
					// callback trigger
					self.options.onEndFlip( self.previous, self.currentIdx, isLimit );
				}
			} );

			if ( dir === 'prev' ) {
				s_middle.className += ' bb-flip-initial';
			}

			// overlays
			if ( this.options.shadows && !this.end ) {
				if( dir === 'next' ) {
					o_middle_f.style.transition = 'opacity ' + this.options.speed / 2 + 'ms ' + 'linear';
					o_middle_b.style.transition = 'opacity ' + this.options.speed / 2 + 'ms ' + 'linear' + ' ' + this.options.speed / 2 + 'ms';
					o_middle_b.style.opacity = this.options.shadowFlip;
					o_left.style.transition = 'opacity ' + this.options.speed / 2 + 'ms ' + 'linear' + ' ' + this.options.speed / 2 + 'ms';
					o_right.style.transition = 'opacity ' + this.options.speed / 2 + 'ms ' + 'linear';
					o_right.style.opacity = this.options.shadowSides;
				}
				else if( dir === 'prev' ) {
					o_middle_f.style.transition = 'opacity ' + this.options.speed / 2 + 'ms ' + 'linear' + ' ' + this.options.speed / 2 + 'ms';
					o_middle_f.style.opacity = this.options.shadowFlip;
					o_middle_b.style.transition = 'opacity ' + this.options.speed / 2 + 'ms ' + 'linear';
					o_left.style.transition = 'opacity ' + this.options.speed / 2 + 'ms ' + 'linear';
					o_left.style.opacity = this.options.shadowSides;
					o_right.style.transition = 'opacity ' + this.options.speed / 2 + 'ms ' + 'linear' + ' ' + this.options.speed / 2 + 'ms';
				}
			}

			setTimeout( function() {
				// first && last pages lift slightly up when we can't go further
				s_middle.className += self.end ? ' bb-flip-' + dir + '-end' : ' bb-flip-' + dir;

				// overlays
				if ( self.options.shadows && !self.end ) {
					o_middle_f.style.opacity = dir === 'next' ? self.options.shadowFlip : 0;
					o_middle_b.style.opacity = dir === 'next' ? 0 : self.options.shadowFlip;
					o_left.style.opacity = dir === 'next' ? self.options.shadowSides : 0;
					o_right.style.opacity = dir === 'next' ? 0 : self.options.shadowSides;
				}
			}, 25 );
		},
		// adds the necessary sides (bb-page) to the layout 
		_addSide : function( side, dir ) {
			var sideEl = document.createElement( 'div' );
			sideEl.className = 'bb-page';

			switch (side) {
				case 'left':
						/*
						<div class="bb-page" style="z-index:102;">
							<div class="bb-back">
								<div class="bb-outer">
									<div class="bb-content">
										<div class="bb-inner">
											dir==='next' ? [content of current page] : [content of next page]
										</div>
									</div>
									<div class="bb-overlay"></div>
								</div>
							</div>
						</div>
						*/
					var inner = dir === 'next' ? this.current.innerHTML : this.nextItem.innerHTML;
					sideEl.innerHTML = '<div class="bb-back"><div class="bb-outer"><div class="bb-content"><div class="bb-inner">' + inner + '</div></div><div class="bb-overlay"></div></div></div>';
					break;
				case 'middle':
						/*
						<div class="bb-page" style="z-index:103;">
							<div class="bb-front">
								<div class="bb-outer">
									<div class="bb-content">
										<div class="bb-inner">
											dir==='next' ? [content of current page] : [content of next page]
										</div>
									</div>
									<div class="bb-flipoverlay"></div>
								</div>
							</div>
							<div class="bb-back">
								<div class="bb-outer">
									<div class="bb-content">
										<div class="bb-inner">
											dir==='next' ? [content of next page] : [content of current page]
										</div>
									</div>
									<div class="bb-flipoverlay"></div>
								</div>
							</div>
						</div>
						*/
					var frontinner = dir === 'next' ? this.current.innerHTML : this.nextItem.innerHTML;
					var backinner = dir === 'next' ? this.nextItem.innerHTML : this.current.innerHTML; 
					sideEl.innerHTML = '<div class="bb-front"><div class="bb-outer"><div class="bb-content"><div class="bb-inner">' + frontinner + '</div></div><div class="bb-flipoverlay"></div></div></div><div class="bb-back"><div class="bb-outer"><div class="bb-content" style="width:' + this.elWidth + 'px"><div class="bb-inner">' + backinner + '</div></div><div class="bb-flipoverlay"></div></div></div>';
					break;
				case 'right':
						/*
						<div class="bb-page" style="z-index:101;">
							<div class="bb-front">
								<div class="bb-outer">
									<div class="bb-content">
										<div class="bb-inner">
											dir==='next' ? [content of next page] : [content of current page]
										</div>
									</div>
									<div class="bb-overlay"></div>
								</div>
							</div>
						</div>
						*/
					var inner = dir === 'next' ? this.nextItem.innerHTML : this.current.innerHTML;
					sideEl.innerHTML = '<div class="bb-front"><div class="bb-outer"><div class="bb-content"><div class="bb-inner">' + inner + '</div></div><div class="bb-overlay"></div></div></div>';
					break;
			}

			return sideEl;
		},
		_startSlideshow : function() {
			var self = this;
			this.slideshow = setTimeout( function() {
				self._navigate( 'next' );
				if ( self.options.autoplay ) {
					self._startSlideshow();
				}
			}, this.options.interval );
		},
		_stopSlideshow : function() {
			if ( this.options.autoplay ) {
				clearTimeout( this.slideshow );
				this.options.autoplay = false;
			}
		},
		// public method: flips next
		next : function() {
			this._action( this.options.direction === 'ltr' ? 'next' : 'prev' );
		},
		// public method: flips back
		prev : function() {
			this._action( this.options.direction === 'ltr' ? 'prev' : 'next' );
		},
		// public method: goes to a specific page
		jump : function( page ) {

			page -= 1;

			if ( page === this.currentIdx || page >= this.itemsCount || page < 0 ) {
				return false;
			}
			var dir;
			if( this.options.direction === 'ltr' ) {
				dir = page > this.currentIdx ? 'next' : 'prev';
			}
			else {
				dir = page > this.currentIdx ? 'prev' : 'next';
			}
			this._action( dir, page );

		},
		// public method: goes to the last page
		last : function() {
			this.jump( this.itemsCount );
		},
		// public method: goes to the first page
		first : function() {
			this.jump( 1 );
		},
		// taken from https://github.com/desandro/vanilla-masonry/blob/master/masonry.js by David DeSandro
		// original debounce by John Hann
    	// http://unscriptable.com/index.php/2009/03/20/debouncing-javascript-methods/
		_resizeHandler : function() {
			var self = this;
			function delayed() {
				self._resize();
				self._resizeTimeout = null;
			}
			if ( this._resizeTimeout ) {
				clearTimeout( this._resizeTimeout );
			}
			this._resizeTimeout = setTimeout( delayed, 50 );
		},
		_resize : function() {
			// update width value
			this.elWidth = this.el.offsetWidth;
		},
		// public method: check if isAnimating is true
		isActive: function() {
			return this.isAnimating;
		},
		// public method: dynamically adds new elements
		// call this method after inserting new "bb-item" elements inside the BookBlock
		update : function () {
			var currentItem = this.items[ this.current ];
			this.items = Array.prototype.slice.call( this.el.querySelectorAll( '.bb-item' ) );
			this.itemsCount = this.items.length;
			this.currentIdx = this.items.indexOf( currentItem );
		},
		destroy : function() {
			if ( this.options.autoplay ) {
				this._stopSlideshow();
			}
			this.el.className = this.el.className.replace(new RegExp("(^|\\s+)" + 'bb-' + this.options.orientation + "(\\s+|$)"), ' ');
			this.items.forEach( function( el, i ) { el.style.display = 'block'; } );

			if ( this.options.nextEl !== '' ) {
				this.options.nextEl.removeEventListener( 'click' );
				this.options.nextEl.removeEventListener( 'touchstart' );
			}

			if ( this.options.prevEl !== '' ) {
				this.options.prevEl.removeEventListener( 'click' );
				this.options.prevEl.removeEventListener( 'touchstart' );
			}

			window.removeEventListener( 'debouncedresize' );
		}
	}

	// add to global namespace
	window.BookBlock = BookBlock;

} )( window );
(function() {
    /*jshint bitwise: false*/
    'use strict';

    angular
        .module('platformApp')
        .factory('Base64Image', Base64Image);

    function Base64Image () {
        

        var service = {
            getSize: getSize,
            getMimeType: getMimeType,
            compress: compress
        };

        return service;

        function getSize(data) {
            if (!data) {
                return 0;
            }
            var start = 0;
            var end = data.length;
            var pos = data.indexOf(';base64,');

            if (pos > 0) {
                start = pos + 8;
            }
            pos = data.indexOf("=");
            if (pos > 0) {
                end = pos;
            }

            var len = end - start;
            return parseInt(len - (len/8) * 2);
        }

        function getMimeType(data) {
            var arr = data.split(',');
            var mime = arr[0].match(/:(.*?);/)[1];
            // return mime.replace("image/", "");
            return mime;
        }

        function compress(data, length, quality, callback) {
            var getMimeType = function (urlData) {
                var arr = urlData.split(',');
                var mime = arr[0].match(/:(.*?);/)[1];
                // return mime.replace("image/", "");
                return mime;
            };

            var quality_value = quality || 0.6;
            var newImage = new Image();
            var imgWidth, imgHeight;

            newImage.src = data;
            newImage.setAttribute("crossOrigin", 'Anonymous');  //url为外域时需要
            newImage.onload = function() {
                imgWidth = this.width;
                imgHeight = this.height;
                var canvas = document.createElement("canvas");
                var ctx = canvas.getContext("2d");
                if (Math.max(imgWidth, imgHeight) > length) {
                    if (imgWidth > imgHeight) {
                        canvas.width = length;
                        canvas.height = length * imgHeight / imgWidth;
                    } else {
                        canvas.height = length;
                        canvas.width = length * imgWidth / imgHeight;
                    }
                } else {
                    canvas.width = imgWidth;
                    canvas.height = imgHeight;
                }
                // 覆盖默认填充颜色 (#000)
                var fillStyle = '#fff';
                ctx.fillStyle = fillStyle;
                ctx.clearRect(0, 0, canvas.width, canvas.height);
                ctx.drawImage(this, 0, 0, canvas.width, canvas.height);
                var base64 = canvas.toDataURL("image/jpeg", quality_value); //压缩语句

                if (callback) {
                    callback(base64);
                }
            }
        }
    }
})();

(function() {
    /*jshint bitwise: false*/
    'use strict';

    angular
        .module('platformApp')
        .factory('Base64', Base64);

    function Base64 () {
        var keyStr = 'ABCDEFGHIJKLMNOP' +
            'QRSTUVWXYZabcdef' +
            'ghijklmnopqrstuv' +
            'wxyz0123456789+/' +
            '=';

        var service = {
            decode : decode,
            encode : encode
        };

        return service;

        function encode (input) {
            var output = '',
                chr1, chr2, chr3,
                enc1, enc2, enc3, enc4,
                i = 0;

            while (i < input.length) {
                chr1 = input.charCodeAt(i++);
                chr2 = input.charCodeAt(i++);
                chr3 = input.charCodeAt(i++);

                enc1 = chr1 >> 2;
                enc2 = ((chr1 & 3) << 4) | (chr2 >> 4);
                enc3 = ((chr2 & 15) << 2) | (chr3 >> 6);
                enc4 = chr3 & 63;

                if (isNaN(chr2)) {
                    enc3 = enc4 = 64;
                } else if (isNaN(chr3)) {
                    enc4 = 64;
                }

                output = output +
                    keyStr.charAt(enc1) +
                    keyStr.charAt(enc2) +
                    keyStr.charAt(enc3) +
                    keyStr.charAt(enc4);
            }

            return output;
        }

        function decode (input) {
            var output = '',
                chr1, chr2, chr3,
                enc1, enc2, enc3, enc4,
                i = 0;

            // remove all characters that are not A-Z, a-z, 0-9, +, /, or =
            input = input.replace(/[^A-Za-z0-9\+\/\=]/g, '');

            while (i < input.length) {
                enc1 = keyStr.indexOf(input.charAt(i++));
                enc2 = keyStr.indexOf(input.charAt(i++));
                enc3 = keyStr.indexOf(input.charAt(i++));
                enc4 = keyStr.indexOf(input.charAt(i++));

                chr1 = (enc1 << 2) | (enc2 >> 4);
                chr2 = ((enc2 & 15) << 4) | (enc3 >> 2);
                chr3 = ((enc3 & 3) << 6) | enc4;

                output = output + String.fromCharCode(chr1);

                if (enc3 !== 64) {
                    output = output + String.fromCharCode(chr2);
                }
                if (enc4 !== 64) {
                    output = output + String.fromCharCode(chr3);
                }
            }

            return output;
        }
    }
})();

(function () {
    /*jshint bitwise: false*/
    'use strict';

    angular
        .module('platformApp')
        .factory('PsdTemplateLoader', PsdTemplateLoader);

    PsdTemplateLoader.$inject = ['$q', 'TxMatrix', 'Base64Image', 'TextUtilService'];

    function PsdTemplateLoader($q, TxMatrix, Base64Image, TextUtilService) {

    	var service = {
    		loadPsdFile: loadPsdFile
    	};
    	return service;

        var dpi = 150;

    	function px2mm(px) {
    		return px * 25.4 / 96;
    	}

    	function pt2px(pt) {
    		return pt * 96 / 72;
    	}


        function dpi2px(pt) {
            return pt * 96 / dpi;
        }

        function dpi2pt(p) {
        	return p * 72 / dpi;
        }
		function loadPsdFile(file) {


			var deferred = $q.defer();

			PSD.fromDroppedFile(file).then(function(psd){
				// console.log('psd', psd);
				var header = psd.header || {};
				if (header.mode != 3 && header.mode != 4) {
					console.log("PSD无法处理: color_mode=", header.mode);
					deferred.reject({error: 'PSD无法处理, color_mode=' + header.mode});
					return;
				}
				if (8 != header.depth) {
					console.log("PSD无法处理, 目前仅支持8位通道. depth=" + header.depth);
					deferred.reject({error: 'PPSD无法处理, 目前仅支持8位通道'});
					return;
				}


				// check the PSD
				var plat;
				try {
                	plat = psd.tree().export();
                }
				catch (e) {
					console.log("PSD解析失败: ", e.message);
					deferred.reject({error: 'PSD解析失败'});
					return;
				}

				var thumbnailUrl = null;

                var dpiResources = psd.resources.obj.resources;
                Object.keys(dpiResources).forEach(function (key) {
                    if(key == 1005){
                        dpi = dpiResources[key].v_res
                    }
                    else if (key == 1036) {
                    	thumbnailUrl = dpiResources[key].url;
                    }
                    // console.log(dpiResources[key])
                })
                console.log('dpi', dpi);

                // 排序
                psd.layers.sort(function(l1, l2) {
                	l1.layerId().get();
                	l2.layerId().get();
                	return l1.layerId().obj.id > l2.layerId().obj.id;
                });

                var template = initPage(psd, thumbnailUrl);
                template.layers = [];

                var layer_promises = [];
                var clipping_layers = [];
                // for (var i = psd.layers.length - 1; i >= 0; i--) {
                for (var i = 0; i < psd.layers.length; i++) {
                	var layer = psd.layers[i];

                	if (!layer.layerId().obj) {
                		layer.layerId().get();
                	}
                	var layerId = layer.layerId().obj.id;
                	// console.log("layer id: " + layerId.id + ", layerName:" + layer.name);

                	var layerNode = layer.node;
                	if (!layerNode) {
                		console.log("discard: ", layerNode);
                		continue;
                	}
                	if (layerNode.parent && layerNode.root && layerNode.parent != layerNode.root()) {
                		// parent不是root, 可能属于某个group
                		continue;
                	}
                	try {
	                	if (layerNode.type === 'group') {
	                		var children = layerNode.children();
	                		for (var k = 0; k < children.length; k++) {
	                			var cl = children[k].layer;
	                			if (!cl.layerId().obj) {
	                				cl.layerId().get();
	                			}
	                			var clId = cl.layerId().obj.id;

	                			var cnode = cl.node;
	                			if (cnode.type !== 'layer') {
	                				console.log("layer discard, type=" + cnode.type, cl);
	                				continue;
	                			}
	                			try {
	                				if (cl.rows <= 0 || cl.cols <= 0) {
	                					continue;
	                				}
		                			var child = cnode.export();
		                			var data = parseLayer(clId, cl, child, header, clipping_layers);
		                			if (data) {
		                				layer_promises.push(data.promise);
		                				template.layers.unshift(data);
		                			}
		                		} catch (e) {
		                			console.log(e);
		                		}
	                		}

	                	}
	                	else {
	                		try {
	                			if (layer.rows <= 0 || layer.cols <= 0) {
	                				continue;
	                			}
		                		var child = layerNode.export();
		                		// console.log("layer export: " , child);
		                		var data = parseLayer(layerId, layer, child, header, clipping_layers);
		                		if (data) {
		                			layer_promises.push(data.promise);
		                			template.layers.unshift(data);
		                		}
		                	} catch (e) {
		                		console.log(e);
		                	}
	                	}
	                } catch (e) {
	                	console.log(e);
	                }
                }
                $q.all(layer_promises).then(function() {
                	deferred.resolve(template);
                	// console.log(template);
                });
            },function(err){
                console.error('Error in PSD.fromDroppedFile:', err);
                deferred.reject({ error: 'Error in PSD.fromDroppedFile' });
            });

			return deferred.promise;
		}

		function initPage(psd, thumbnailData) {
			var header = psd.header;
			var page = {};
			page.unit = 'px';
			page.box = {
				x: 0,
				y: 0,
				width: header.width, // px2mm(header.width),
				height: header.height // px2mm(header.height)
			};
			// signature, always '8BPS'
			page.signature = header.sig;
			// version, always 1
			page.version = header.version;
			page.channels = header.channels;
			page.depth = header.depth;
			// color mode: Bitmap = 0; Grayscale = 1; Indexed = 2; RGB = 3; CMYK = 4; Multichannel = 7; Duotone = 8; Lab = 9.
			page.mode = header.mode;
			if (thumbnailData) {
				page.imageData = thumbnailData;
			} else {
				page.imageData = psd.image.toPng()['src'];
			}
			page.imageUrl = null;

			return page;
		}

		function parseLayer(layerId, layer, child, header, clipping_layers) {
			// console.log(index, layer, child);
			if (child.text) {
                		// console.log(i, '->', 'Text');
        		return parseText(layerId, layer, child, header);

        	} else {
        		if (layer.infoKeys.indexOf('vmsk') != -1) {
        			// console.log("vmsk", layer);
        			for (var i = 0; i < clipping_layers.length; i++) {
        				var cl_id = clipping_layers[i];
        				if (layerId == cl_id) {
        					return null;
        				}
        			}
        			// return null;
        		}
        		// console.log(i, '->', 'Image');
        		return parseImage(layerId, layer, child, header, clipping_layers);
        	}
		}

		function parseImage(layerId, layer, c, h, clipping_layers) {
			var deferred = $q.defer();
			// console.log(layer);

			var image = { id: layerId, type: 'Image', compressed: false };
			image.cols = layer.cols;
			image.rows = layer.rows;
			image.geometry = {
				x: dpi2px(layer.left), // px2mm(layer.left),
				y: dpi2px(layer.top),  // px2mm(layer.top),
				width: dpi2px(layer.width), // px2mm(layer.width),
				height: dpi2px(layer.height) // px2mm(layer.height)
			};
			image.rotation = {
				angle: 0
			};
			var opacity = layer.image.opacity;
			image.opacity = opacity;

			var imageData = layer.image.toBase64();
			var imageSize = Base64Image.getSize(imageData);
			var mimeType = Base64Image.getMimeType(imageData);
			// console.log("id: " + layerId + ", mimeType: " + mimeType + ", size:" + imageSize + ", opacity:" + opacity);
			if (imageSize > 1048576 * 19.9) {
				Base64Image.compress(imageData, 5000, 0.8, function(newBase64) {
					image.imageData = newBase64;
					image.compressed = true;
					var compressedSize = Base64Image.getSize(newBase64);
					console.log("compress: " + imageSize + " ==> " + compressedSize);
					deferred.resolve('ok');
				});
			} else {
				image.imageData = imageData;
				deferred.resolve('ok');
			}

			image.imageUrl = null;
			if (layer.node && layer.node.clippingMaskCached
				&& layer.node.clippingMaskCached.layer
				&& layer.node.clippingMaskCached.layer.image) {
				var maskLayer = layer.node.clippingMaskCached.layer;
				if (!maskLayer.layerId().obj) {
					maskLayer.layerId().get();
				}
				var maskLayerId = maskLayer.layerId().obj.id;
				clipping_layers.push(maskLayerId);

				var mask = { type: 'Mask' };
				mask.cols = maskLayer.cols;
				mask.rows = maskLayer.rows;
				mask.geometry = {
					x: dpi2px(maskLayer.left), // px2mm(layer.left),
					y: dpi2px(maskLayer.top),  // px2mm(layer.top),
					width: dpi2px(maskLayer.width), // px2mm(layer.width),
					height: dpi2px(maskLayer.height) // px2mm(layer.height)
				}
				mask.rotation = {
					angle: 0
				};
				mask.imageData = maskLayer.image.toBase64();
				mask.imageUrl = null;
				image.mask = mask;
				image.hasMask = true;
			} else {
				image.hasMask = false;
			}
			image.promise = deferred.promise;
			setTimeout(function() {
				deferred.resolve('ok');
			}, 100);
			return image;
		}

		function parseText(layerId, layer, child, header) {
			var textType = layer.typeTool(); // {_style: {...}, textData: {...}, transform: {...}}
			var textFont = textType.export().font; // {alignment:['left'],colors:[],leading:[],names:[],sizes:[],styles:['normal'],weights:['bold']}
			var textStyle = textType._styles || {}; // {FontSize: [n,...], Leading: [n,...], FillColor:[...], StrokeColor:[...]}
			var textData = textType.textData || {}; // {boundingBox:{...}, bounds:{...}}
			var textTransform = textType.transform;
			var textValue = textType.textValue;
			var boundingBox = textData.boundingBox || {
				Left: {value: 0},
				"Top ": {value: 0},
				Rght: {value: 0},
				Btom: { value: 0}
			};
			var bounds = textData.bounds || {
				Left: {value: 0},
				"Top ": {value: 0},
				Rght: {value: 0},
				Btom: { value: 0}
			};
			// console.log(textType, textFont);

			var tm = [textTransform.xx, textTransform.yx, textTransform.xy, textTransform.yy, textTransform.tx, textTransform.ty];
			var scale = TxMatrix.getScaleValue(tm) || 1;

			var fontSize = getArrayValue(textFont.sizes, textStyle.FontSize[0], "max");
			var leading = 0;
			if (textFont.leading) {
				leading = getArrayValue(textFont.leading, textFont.leading[0], "max");
				if (leading !== leading || leading == "auto" || leading == "unset") {
					// NaN
					leading = 0;
				}
			}
			var tracking = 0;
			if (textFont.Tracking) {
				tracking = textStyle.Tracking ? getArrayValue(textStyle.Tracking) / 1000 : 0;
				if (tracking !== tracking || tracking == "auto" || tracking == "unset") {
					// NaN
					tracking = 0;
				}
			}
			var minFontSize = getArrayValue(textStyle.FontSize, fontSize, "min");
			var letterspace = minFontSize * tracking;
			fontSize = (fontSize * scale);
			leading = (leading * scale);
			letterspace = (letterspace * scale);
			var lineheight = leading;
			if (lineheight < fontSize) {
				lineheight = fontSize;
			}
			var writingMode = "unset";
			if (textData.Ornt && "Vrtc" === textData.Ornt.value) {
				writingMode = "vertical-rl";
			}

			var text = { id: layerId,  type: 'Text', compressed: false};

			var alignment = 'left';
			if (textFont.alignment && textFont.alignment.length > 0) {
				alignment = textFont.alignment[0] || 'left';
			}
			text.style = {
				font: textFont.names[0],
				size: parseInt(dpi2pt(fontSize).toFixed(0)),
				color: parseColor(textFont.colors[0], header.mode),
				align: alignment,
				lineheight: parseFloat(dpi2pt(lineheight).toFixed(1)),
				letterspace: parseFloat(dpi2pt(letterspace).toFixed(1)),
				writemode: writingMode,
				italic: textStyle.FauxItalic ? (textStyle.FauxItalic[0] === true) : false,
				bold: textStyle.FauxBold ? (textStyle.FauxBold[0] === true) : false
			};
			text.opacity = child.opacity || 1.0;

			text.rotation = {
				angle: parseRotateAngle(tm)
			};

			// var lines = getTextLines(textValue);
			text.value = TextUtilService.escapeNoPrintables(textValue.replaceAll('\r', '\n'));

			var left, top, width, height;

			var bl = bounds.Left.value;
			var bt = bounds["Top "].value;
			var br = bounds.Rght.value;
			var bb = bounds.Btom.value;
			if ((bl == 0 && br == 0) || (bt == 0 && bb == 0)) {
				/* old way to calculate the coordinates */
				width = layer.width;
				height = layer.height;
				left = layer.left;
				top = layer.top;
				// var offsetX = (bounds.Left.value - boundingBox.Left.value) * scale;
				// var offsetY = (bounds["Top "].value - boundingBox["Top "].value) * scale;
				// if (writingMode === "vertical-rl") {
				// 	height += (Math.max(0, letterspace) + fontSize + fontSize / 2);
				// 	width += (leading > fontSize ? leading - fontSize / 2 : fontSize / 2);
				// 	left += offsetX;
				// }
				// else {
				// 	width += (Math.max(0, letterspace) + fontSize / 2);
				// 	left += offsetX;
				// 	height += (leading > fontSize ? leading - fontSize / 2 : fontSize / 2)
				// }
				// var line_height_ratio = leading / fontSize;
				// if (line_height_ratio < 1 || line_height_ratio !== line_height_ratio) {
				// 	line_height_ratio = 1;
				// }
				// var topOffset = 0.5 * (1.15 - line_height_ratio) * fontSize;
				// top += topOffset;
			}
			else {
				/* using bounds to calculate the coordinates */
				var ltPoint = tmTransform(tm, bounds.Left.value, bounds["Top "].value);
				var rbPoint = tmTransform(tm, bounds.Rght.value, bounds.Btom.value);
				left = ltPoint.x;
				top = ltPoint.y;
				width = Math.abs(rbPoint.x - ltPoint.x);
				height = Math.abs(rbPoint.y - ltPoint.y);
			}
			if (lineheight > height) {
				text.style.lineheight = parseFloat(dpi2pt(height).toFixed(1));
			}

			// var height = lines * leading *
			text.geometry = {
				x: dpi2px(left), // px2mm(layer.left),
				y: dpi2px(top),  // px2mm(layer.top),
				width: dpi2px(width), // px2mm(layer.width),
				height: dpi2px(height) // px2mm(layer.height)
			};

			var deferred = $q.defer();
			text.promise = deferred.promise;
			setTimeout(function() {
				deferred.resolve("ok");
			}, 100);

			return text;
		}

		function getTextLines(text) {
		  if (!text) {
		    return 1;
		  }
		  var num = 1;
		  var index = text.indexOf('\n');
		  while (index !== -1) {
		    // console.log(index);
		    num++;
		    index = text.indexOf('\n', index + 1);
		  }
		  return num;
		}

		function getArrayValue(values, default_value, flag) {
			var result;
			if (values) {
				if (Array.isArray(values)) {
					if (flag == "max" && "number" == typeof values[0] && "number" == typeof values[1]) {
						result = Math.max(values[0], values[1]);
					}
					else if (flag == "min") {
						if (values.length == 1) {
							result = values[0];
						}
						else if (values.length == 2) {
							result = Math.min(values[0], values[1]);
						}
						else if (values.length == 3) {
							result = Math.min(values[0], values[1], values[2]);
						}
						else if (values.length >= 4) {
							result = Math.min(values[0], values[1], values[2], values[3]);
						}
					}
					else {
						result = values[1] || values[0];
					}
				}
				else {
					result = values;
				}
			}
			return !result && result != '0' ? default_value : result;
		}

		function parseColor(colors, color_mode) {
			if (!colors
				|| !(colors instanceof Array)
				|| colors.length < 3) {
				return '0x000000'; // default black
			}
			// console.log(colors);
			if (color_mode == 4) {
				return cmyk2rgba(colors);
			}
			else {
				try {
					if (colors.length == 3) {
						return 'rgba(' + colors[0] + ',' + colors[1] + ',' + colors[2] + ',' + 255 + ')';
					}
					return 'rgba(' + colors[0] + ',' + colors[1] + ',' + colors[2] + ',' + colors[3] + ')';
				}
				catch(e){
					return 'rgba(0, 0, 0, 255)';
				}
			}
		}

		function parseRotateAngle(tm) {
			return TxMatrix.getRotateAngle(tm);
		}

		function parseTextGeometry(tm, cx, cy, textWidth, textHeight) {
			var tx = tm[4];
			var ty = tm[5];

			return {
				x: dpi2px(cx - tx / 2), // px2mm(cx - tx/2),
				y: dpi2px(cy - textHeight / 2), // px2mm(cy - ty/2),
				width: dpi2px(tx), // px2mm(tx),
				height: dpi2px(textHeight) // px2mm(ty)
			};
		}

		function parseTextGeometryLeft(tm, lx, ty, textWidth, textHeight) {
			var tx = tm[4];
			return {
				x: dpi2px(lx),
				y: dpi2px(ty),
				width: dpi2px(tx),
				height: dpi2px(textHeight)
			};
		}

		function parseTextGeometryRight(tm, rx, by, textWidth, textHeight) {
			var tx = tm[4];
			var lx = rx - tx;
			var ty = by - textHeight;

			return {
				x: dpi2px(lx),
				y: dpi2px(ty),
				width: dpi2px(tx),
				height: dpi2px(textHeight)
			};
		}

		function cmyk2rgba(colors) {
			try {
				var c = colors[0] / 255;
				var m = colors[1] / 255;
				var y = colors[2] / 255;
				var k = colors[3] / 255;
				var alpha = 255;
				if (colors.length == 5) {
					alpha = colors[4];
				}
				var r = 255 * (1 - c) * (1 - k);
				var g = 255 * (1 - m) * (1 - k);
				var b = 255 * (1 - y) * (1 - k);
				return 'rgba(' + r + ',' + g + ',' + b + ',' + alpha + ')';
			}
			catch (e) {
				return 'rgba(0, 0, 0, 255)';
			}
		}

		function tmTransform(tm, x, y) {
			return {
		        x: tm[0] * x + tm[2] * y + tm[4],
		        y: tm[1] * x + tm[3] * y + tm[5]
		    };
		}
    }

})();

(function () {
    /*jshint bitwise: false*/
    'use strict';

    angular
        .module('platformApp')
        .factory('TxMatrix', TxMatrix);

    function TxMatrix() {
    	var service = {
    		transformPt: transformPt,
    		transformRect: transformRect,
    		getRotateAngle: getRotateAngle,
    		getRotateInstance: getRotateInstance,
    		getScaleValue: getScaleValue
    	};
    	return service;

    	// Matrix definition
    	// [ xx  xy   0
    	//   yx  yy   0
    	//   tx  ty   1 ]
    	// 
    	// [ cos(theta)    -sin(theta)       0
    	//   sin(theta)	   cos(theta)		 0
    	//	   tx             ty             1]
    	//
    	// tm = [xx, xy, yx, yy, tx, ty]

    	// 点的矩阵变换
    	function transformPt(tm, x, y) {
    		var a = tm[0];
    		var b = tm[1];
    		var c = tm[2];
    		var d = tm[3];
    		var e = tm[4];
    		var f = tm[5];

    		return {
    			x: x * a + y * c + e, 
    			y: x * b + y * d + f
    		};
    	}

    	// 矩形的矩阵变换
    	function transformRect(tm, x, y, width, height) {
    		var pt0 = transformPt(tm, x, y);
    		var pt1 = transformPt(tm, x + width, y);
    		var pt2 = transformPt(tm, x, y + height);
    		var pt3 = transformPt(tm, x + width, y + height);

    		var minX = Math.min(pt0.x, Math.min(pt1.x, Math.min(pt2.x, pt3.x)));
    		var maxX = Math.max(pt0.x, Math.max(pt1.x, Math.max(pt2.x, pt3.x)));
    		var minY = Math.min(pt0.y, Math.min(pt1.y, Math.min(pt2.y, pt3.y)));
    		var maxY = Math.max(pt0.y, Math.max(pt1.y, Math.max(pt2.y, pt3.y)));

    		return {
    			x: minX,
    			y: minY,
    			width: maxX - minX,
    			height: maxY - minY
    		};
    	}

    	function getRotateAngle(tm) {
    		var xx = tm[0];
			var xy = tm[1];
			var yx = tm[2];
			var yy = tm[3];

			var ssp = Math.sqrt(Math.pow(xx, 2) + Math.pow(yx, 2), 2);

			// [-90 - 90]
			if (xx >= 0) {
				var degree = Math.asin(yx / ssp) * 180 / Math.PI;
				if (degree < 0) {
					degree += 360;
				}
				return degree;
			}
			// (90, 180)
			else if (xx < 0) {
				return 180 - Math.asin(yx / ssp) * 180 / Math.PI;
			}
    	}

    	function getScaleValue(tm) {
    		var xx = tm[0];
			var xy = tm[1];
			var yx = tm[2];
			var yy = tm[3];

			var ssp = Math.sqrt(Math.pow(xx, 2) + Math.pow(yx, 2), 2);
			return ssp;
    	}

    	// 求逆矩阵
    	function getRotateInstance(angle) {

    		var tm = [];
    		var theta = angleToRad(angle);
    		tm.push(Math.cos(theta));
    		tm.push(-Math.sin(theta));
    		tm.push(Math.sin(theta));
    		tm.push(Math.cos(theta));
    		tm.push(0);
    		tm.push(0);

    		return tm;
    	}

    	function angleToRad(angle) {
    		return angle * Math.PI / 180;
    	}

    }

})();
(function() {
    'use strict';

    angular
        .module('platformApp')
        .factory('LoginService', LoginService);

    LoginService.$inject = ['$uibModal'];

    function LoginService ($uibModal) {
        var service = {
            open: open
        };

        var modalInstance = null;
        var resetModal = function () {
            modalInstance = null;
        };

        return service;

        function open () {
            if (modalInstance !== null) return;
            modalInstance = $uibModal.open({
                animation: true,
                templateUrl: 'app/components/login/login.html',
                controller: 'LoginController',
                controllerAs: 'vm',
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('login');
                        return $translate.refresh();
                    }]
                }
            });
            modalInstance.result.then(
                resetModal,
                resetModal
            );
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('platformApp')
        .controller('LoginController', LoginController);

    LoginController.$inject = ['$rootScope', '$state', '$timeout', 'Auth', '$uibModalInstance'];

    function LoginController ($rootScope, $state, $timeout, Auth, $uibModalInstance) {
        var vm = this;

        vm.authenticationError = false;
        vm.cancel = cancel;
        vm.credentials = {};
        vm.login = login;
        vm.password = null;
        vm.register = register;
        vm.rememberMe = true;
        vm.requestResetPassword = requestResetPassword;
        vm.username = null;

        $timeout(function (){angular.element('#username').focus();});

        function cancel () {
            vm.credentials = {
                username: null,
                password: null,
                rememberMe: true
            };
            vm.authenticationError = false;
            $uibModalInstance.dismiss('cancel');
        }

        function login (event) {
            event.preventDefault();
            Auth.login({
                username: vm.username,
                password: vm.password,
                rememberMe: vm.rememberMe
            }).then(function () {
                vm.authenticationError = false;
                $uibModalInstance.close();
                if ($state.current.name === 'register' || $state.current.name === 'activate' ||
                    $state.current.name === 'finishReset' || $state.current.name === 'requestReset') {
                    $state.go('home');
                }

                $rootScope.$broadcast('authenticationSuccess');

                // previousState was set in the authExpiredInterceptor before being redirected to login modal.
                // since login is successful, go to stored previousState and clear previousState
                if (Auth.getPreviousState()) {
                    var previousState = Auth.getPreviousState();
                    Auth.resetPreviousState();
                    $state.go(previousState.name, previousState.params);
                }
            }).catch(function () {
                vm.authenticationError = true;
            });
        }

        function register () {
            $uibModalInstance.dismiss('cancel');
            $state.go('register');
        }

        function requestResetPassword () {
            $uibModalInstance.dismiss('cancel');
            $state.go('requestReset');
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('platformApp')
        .factory('JhiLanguageService', JhiLanguageService);

    JhiLanguageService.$inject = ['$q', '$http', '$translate', 'LANGUAGES'];

    function JhiLanguageService ($q, $http, $translate, LANGUAGES) {
        var service = {
            getAll: getAll,
            getCurrent: getCurrent
        };

        return service;

        function getAll () {
            var deferred = $q.defer();
            deferred.resolve(LANGUAGES);
            return deferred.promise;
        }

        function getCurrent () {
            var deferred = $q.defer();
            // var language = $translate.storage().get('NG_TRANSLATE_LANG_KEY');
            var language = "zh-cn";

            deferred.resolve(language);

            return deferred.promise;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('platformApp')
        .filter('findLanguageFromKey', findLanguageFromKey)
        .filter('findLanguageRtlFromKey', findLanguageRtlFromKey);

    var languages = {
        'zh-cn': { name: '中文（简体）' },
        'en': { name: 'English' }
        // jhipster-needle-i18n-language-key-pipe - JHipster will add/remove languages in this object
    };

    function findLanguageFromKey() {
        return findLanguageFromKeyFilter;

        function findLanguageFromKeyFilter(lang) {
            return languages[lang].name;
        }
    }

    function findLanguageRtlFromKey() {
        return findLanguageRtlFromKeyFilter;

        function findLanguageRtlFromKeyFilter(lang) {
            return languages[lang].rtl;
        }
    }

})();

(function() {
    'use strict';

    angular
        .module('platformApp')
        .controller('JhiLanguageController', JhiLanguageController);

    JhiLanguageController.$inject = ['$translate', 'JhiLanguageService', 'tmhDynamicLocale'];

    function JhiLanguageController ($translate, JhiLanguageService, tmhDynamicLocale) {
        var vm = this;

        vm.changeLanguage = changeLanguage;
        vm.languages = null;

        JhiLanguageService.getAll().then(function (languages) {
            vm.languages = languages;
        });

        function changeLanguage (languageKey) {
            $translate.use(languageKey);
            tmhDynamicLocale.set(languageKey);
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('platformApp')

        /*
         Languages codes are ISO_639-1 codes, see http://en.wikipedia.org/wiki/List_of_ISO_639-1_codes
         They are written in English to avoid character encoding issues (not a perfect solution)
         */
        .constant('LANGUAGES', [
            'en',
            'zh-cn'
            // jhipster-needle-i18n-language-constant - JHipster will add/remove languages in this array
        ]
    );
})();

(function() {
    'use strict';

    angular
        .module('platformApp')
        .directive('showValidation', showValidation);

    function showValidation () {
        var directive = {
            restrict: 'A',
            require: 'form',
            link: linkFunc
        };

        return directive;

        function linkFunc (scope, element, attrs, formCtrl) {
            element.find('.form-group').each(function() {
                var $formGroup = angular.element(this);
                var $inputs = $formGroup.find('input[ng-model],textarea[ng-model],select[ng-model]');

                if ($inputs.length > 0) {
                    $inputs.each(function() {
                        var $input = angular.element(this);
                        var inputName = $input.attr('name');
                        scope.$watch(function() {
                            return formCtrl[inputName].$invalid && formCtrl[inputName].$dirty;
                        }, function(isInvalid) {
                            $formGroup.toggleClass('has-error', isInvalid);
                        });
                    });
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('platformApp')
        .constant('paginationConstants', {
            'itemsPerPage': 20
        });
})();

(function() {
    'use strict';

    angular
        .module('platformApp')
        .directive('minbytes', minbytes);

    function minbytes () {
        var directive = {
            restrict: 'A',
            require: '?ngModel',
            link: linkFunc
        };

        return directive;

        function linkFunc (scope, element, attrs, ngModel) {
            if (!ngModel) {
                return;
            }

            ngModel.$validators.minbytes = function (modelValue) {
                return ngModel.$isEmpty(modelValue) || numberOfBytes(modelValue) >= attrs.minbytes;
            };
        }

        function endsWith(suffix, str) {
            return str.indexOf(suffix, str.length - suffix.length) !== -1;
        }

        function paddingSize(base64String) {
            if (endsWith('==', base64String)) {
                return 2;
            }
            if (endsWith('=', base64String)) {
                return 1;
            }
            return 0;
        }

        function numberOfBytes(base64String) {
            return base64String.length / 4 * 3 - paddingSize(base64String);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('platformApp')
        .directive('maxbytes', maxbytes);

    function maxbytes () {
        var directive = {
            restrict: 'A',
            require: '?ngModel',
            link: linkFunc
        };

        return directive;

        function linkFunc (scope, element, attrs, ngModel) {
            if (!ngModel) {
                return;
            }

            ngModel.$validators.maxbytes = function (modelValue) {
                return ngModel.$isEmpty(modelValue) || numberOfBytes(modelValue) <= attrs.maxbytes;
            };
        }

        function endsWith(suffix, str) {
            return str.indexOf(suffix, str.length - suffix.length) !== -1;
        }

        function paddingSize(base64String) {
            if (endsWith('==', base64String)) {
                return 2;
            }
            if (endsWith('=', base64String)) {
                return 1;
            }
            return 0;
        }

        function numberOfBytes(base64String) {
            return base64String.length / 4 * 3 - paddingSize(base64String);
        }
    }

})();

(function() {
    'use strict';

    var jhiAlertError = {
        template: '<div class="alerts" ng-cloak="" role="alert">' +
                        '<div ng-repeat="alert in $ctrl.alerts" ng-class="[alert.position, {\'toast\': alert.toast}]">' +
                            '<uib-alert ng-cloak="" type="{{alert.type}}" close="alert.close($ctrl.alerts)"><pre>{{ alert.msg }}</pre></uib-alert>' +
                        '</div>' +
                  '</div>',
        controller: jhiAlertErrorController
    };

    angular
        .module('platformApp')
        .component('jhiAlertError', jhiAlertError);

    jhiAlertErrorController.$inject = ['$scope', 'AlertService', '$rootScope', '$translate'];

    function jhiAlertErrorController ($scope, AlertService, $rootScope, $translate) {
        var vm = this;

        vm.alerts = [];

        function addErrorAlert (message, key, data) {
            key = key ? key : message;
            vm.alerts.push(
                AlertService.add(
                    {
                        type: 'danger',
                        msg: key,
                        params: data,
                        timeout: 5000,
                        toast: AlertService.isToast(),
                        scoped: true
                    },
                    vm.alerts
                )
            );
        }

        var cleanHttpErrorListener = $rootScope.$on('platformApp.httpError', function (event, httpResponse) {
            var i;
            event.stopPropagation();
            switch (httpResponse.status) {
            // connection refused, server not reachable
            case 0:
                addErrorAlert('Server not reachable','error.server.not.reachable');
                break;

            case 400:
                var headers = Object.keys(httpResponse.headers()).filter(function (header) {
                    return header.indexOf('app-error', header.length - 'app-error'.length) !== -1 || header.indexOf('app-params', header.length - 'app-params'.length) !== -1;
                }).sort();
                var errorHeader = httpResponse.headers(headers[0]);
                var entityKey = httpResponse.headers(headers[1]);
                if (angular.isString(errorHeader)) {
                    var entityName = $translate.instant('global.menu.entities.' + entityKey);
                    addErrorAlert(errorHeader, errorHeader, {entityName: entityName});
                } else if (httpResponse.data && httpResponse.data.fieldErrors) {
                    for (i = 0; i < httpResponse.data.fieldErrors.length; i++) {
                        var fieldError = httpResponse.data.fieldErrors[i];
                        // convert 'something[14].other[4].id' to 'something[].other[].id' so translations can be written to it
                        var convertedField = fieldError.field.replace(/\[\d*\]/g, '[]');
                        var fieldName = $translate.instant('platformApp.' + fieldError.objectName + '.' + convertedField);
                        addErrorAlert('Field ' + fieldName + ' cannot be empty', 'error.' + fieldError.message, {fieldName: fieldName});
                    }
                } else if (httpResponse.data && httpResponse.data.message) {
                    addErrorAlert(httpResponse.data.message, httpResponse.data.message, httpResponse.data);
                } else {
                    addErrorAlert(httpResponse.data);
                }
                break;

            case 404:
                addErrorAlert('Not found','error.url.not.found');
                break;

            default:
                if (httpResponse.data && httpResponse.data.message) {
                    addErrorAlert(httpResponse.data.message);
                } else {
                    addErrorAlert(angular.toJson(httpResponse));
                }
            }
        });

        $scope.$on('$destroy', function () {
            if(angular.isDefined(cleanHttpErrorListener) && cleanHttpErrorListener !== null){
                cleanHttpErrorListener();
                vm.alerts = [];
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('platformApp')
        .provider('AlertService', AlertService);

    function AlertService () {
        this.toast = false;
        /*jshint validthis: true */
        this.$get = getService;

        this.showAsToast = function(isToast) {
            this.toast = isToast;
        };

        getService.$inject = ['$timeout', '$sce', '$translate'];

        function getService ($timeout, $sce,$translate) {
            var toast = this.toast,
                alertId = 0, // unique id for each alert. Starts from 0.
                alerts = [],
                timeout = 5000; // default timeout

            return {
                factory: factory,
                isToast: isToast,
                add: addAlert,
                closeAlert: closeAlert,
                closeAlertByIndex: closeAlertByIndex,
                clear: clear,
                get: get,
                success: success,
                error: error,
                info: info,
                warning : warning
            };

            function isToast() {
                return toast;
            }

            function clear() {
                alerts = [];
            }

            function get() {
                return alerts;
            }

            function success(msg, params, position) {
                return this.add({
                    type: 'success',
                    msg: msg,
                    params: params,
                    timeout: timeout,
                    toast: toast,
                    position: position
                });
            }

            function error(msg, params, position) {
                return this.add({
                    type: 'danger',
                    msg: msg,
                    params: params,
                    timeout: timeout,
                    toast: toast,
                    position: position
                });
            }

            function warning(msg, params, position) {
                return this.add({
                    type: 'warning',
                    msg: msg,
                    params: params,
                    timeout: timeout,
                    toast: toast,
                    position: position
                });
            }

            function info(msg, params, position) {
                return this.add({
                    type: 'info',
                    msg: msg,
                    params: params,
                    timeout: timeout,
                    toast: toast,
                    position: position
                });
            }

            function factory(alertOptions) {
                var alert = {
                    type: alertOptions.type,
                    msg: $sce.trustAsHtml(alertOptions.msg),
                    id: alertOptions.alertId,
                    timeout: alertOptions.timeout,
                    toast: alertOptions.toast,
                    position: alertOptions.position ? alertOptions.position : 'top right',
                    scoped: alertOptions.scoped,
                    close: function (alerts) {
                        return closeAlert(this.id, alerts);
                    }
                };
                if(!alert.scoped) {
                    alerts.push(alert);
                }
                return alert;
            }

            function addAlert(alertOptions, extAlerts) {
                alertOptions.alertId = alertId++;
                alertOptions.msg = $translate.instant(alertOptions.msg, alertOptions.params);
                var that = this;
                var alert = this.factory(alertOptions);
                if (alertOptions.timeout && alertOptions.timeout > 0) {
                    $timeout(function () {
                        that.closeAlert(alertOptions.alertId, extAlerts);
                    }, alertOptions.timeout);
                }
                return alert;
            }

            function closeAlert(id, extAlerts) {
                var thisAlerts = extAlerts ? extAlerts : alerts;
                return closeAlertByIndex(thisAlerts.map(function(e) { return e.id; }).indexOf(id), thisAlerts);
            }

            function closeAlertByIndex(index, thisAlerts) {
                return thisAlerts.splice(index, 1);
            }
        }
    }
})();

(function() {
    'use strict';

    var jhiAlert = {
        template: '<div class="alerts" ng-cloak="" role="alert">' +
                        '<div ng-repeat="alert in $ctrl.alerts" ng-class="[alert.position, {\'toast\': alert.toast}]">' +
                            '<uib-alert ng-cloak="" type="{{alert.type}}" close="alert.close($ctrl.alerts)"><pre ng-bind-html="alert.msg"></pre></uib-alert>' +
                        '</div>' +
                  '</div>',
        controller: jhiAlertController
    };

    angular
        .module('platformApp')
        .component('jhiAlert', jhiAlert);

    jhiAlertController.$inject = ['$scope', 'AlertService'];

    function jhiAlertController($scope, AlertService) {
        var vm = this;

        vm.alerts = AlertService.get();
        $scope.$on('$destroy', function () {
            vm.alerts = [];
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('platformApp')
        .factory('notificationInterceptor', notificationInterceptor);

    notificationInterceptor.$inject = ['$q', 'AlertService'];

    function notificationInterceptor ($q, AlertService) {
        var service = {
            response: response
        };

        return service;

        function response (response) {
            var headers = Object.keys(response.headers()).filter(function (header) {
                return header.indexOf('app-alert', header.length - 'app-alert'.length) !== -1 || header.indexOf('app-params', header.length - 'app-params'.length) !== -1;
            }).sort();
            var alertKey = response.headers(headers[0]);
            if (angular.isString(alertKey)) {
                AlertService.success(alertKey, { param : response.headers(headers[1])});
            }
            return response;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('platformApp')
        .factory('errorHandlerInterceptor', errorHandlerInterceptor);

    errorHandlerInterceptor.$inject = ['$q', '$rootScope'];

    function errorHandlerInterceptor ($q, $rootScope) {
        var service = {
            responseError: responseError
        };

        return service;

        function responseError (response) {
            if (!(response.status === 401 && (response.data === '' || (response.data.path && response.data.path.indexOf('/api/account') === 0 )))) {
                $rootScope.$emit('platformApp.httpError', response);
            }
            return $q.reject(response);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('platformApp')
        .factory('authExpiredInterceptor', authExpiredInterceptor);

    authExpiredInterceptor.$inject = ['$rootScope', '$q', '$injector', '$localStorage', '$sessionStorage'];

    function authExpiredInterceptor($rootScope, $q, $injector, $localStorage, $sessionStorage) {
        var service = {
            responseError: responseError
        };

        return service;

        function responseError(response) {
            if (response.status === 401) {
                delete $localStorage.authenticationToken;
                delete $sessionStorage.authenticationToken;
                var Principal = $injector.get('Principal');
                if (Principal.isAuthenticated()) {
                    var Auth = $injector.get('Auth');
                    Auth.authorize(true);
                }
            }
            return $q.reject(response);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('platformApp')
        .factory('authInterceptor', authInterceptor);

    authInterceptor.$inject = ['$rootScope', '$q', '$location', '$localStorage', '$sessionStorage'];

    function authInterceptor ($rootScope, $q, $location, $localStorage, $sessionStorage) {
        var service = {
            request: request
        };

        return service;

        function request (config) {
            if (!config || !config.url || /^http/.test(config.url)) return config;

            /*jshint camelcase: false */
            config.headers = config.headers || {};
            var token = $localStorage.authenticationToken || $sessionStorage.authenticationToken;
            if (token) {
                config.headers.Authorization = 'Bearer ' + token;
            }
            return config;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('platformApp')
        .factory('translationHandler', translationHandler);

    translationHandler.$inject = ['$rootScope', '$window', '$state', '$translate'];

    function translationHandler($rootScope, $window, $state, $translate) {
        return {
            initialize: initialize,
            updateTitle: updateTitle
        };

        function initialize() {
            // if the current translation changes, update the window title
            var translateChangeSuccess = $rootScope.$on('$translateChangeSuccess', function() {
                updateTitle();
            });

            $rootScope.$on('$destroy', function () {
                if(angular.isDefined(translateChangeSuccess) && translateChangeSuccess !== null){
                    translateChangeSuccess();
                }
            });
        }


        // update the window title using params in the following
        // precedence
        // 1. titleKey parameter
        // 2. $state.$current.data.pageTitle (current state page title)
        // 3. 'global.title'
        function updateTitle(titleKey) {
            if (!titleKey && $state.$current.data && $state.$current.data.pageTitle) {
                titleKey = $state.$current.data.pageTitle;
            }
            $translate(titleKey || 'global.title').then(function (title) {
                $window.document.title = title;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('platformApp')
        .factory('stateHandler', stateHandler);

    stateHandler.$inject = ['$rootScope', '$state', '$sessionStorage', '$translate', 'JhiLanguageService', 'translationHandler', '$window',
        'Auth', 'Principal', 'VERSION'];

    function stateHandler($rootScope, $state, $sessionStorage, $translate, JhiLanguageService, translationHandler, $window,
        Auth, Principal, VERSION) {
        return {
            initialize: initialize
        };

        function initialize() {
            $rootScope.VERSION = VERSION;

            var stateChangeStart = $rootScope.$on('$stateChangeStart', function (event, toState, toStateParams, fromState) {
                $rootScope.toState = toState;
                $rootScope.toStateParams = toStateParams;
                $rootScope.fromState = fromState;

                // Redirect to a state with an external URL (http://stackoverflow.com/a/30221248/1098564)
                if (toState.external) {
                    event.preventDefault();
                    $window.open(toState.url, '_self');
                }

                if (Principal.isIdentityResolved()) {
                    Auth.authorize();
                }

                // Update the language
                JhiLanguageService.getCurrent().then(function (language) {
                    $translate.use(language);
                });
            });

            var stateChangeSuccess = $rootScope.$on('$stateChangeSuccess',  function(event, toState, toParams, fromState, fromParams) {
                var titleKey = 'global.title' ;

                // Set the page title key to the one configured in state or use default one
                if (toState.data.pageTitle) {
                    titleKey = toState.data.pageTitle;
                }
                translationHandler.updateTitle(titleKey);
            });

            $rootScope.$on('$destroy', function () {
                if(angular.isDefined(stateChangeStart) && stateChangeStart !== null){
                    stateChangeStart();
                }
                if(angular.isDefined(stateChangeSuccess) && stateChangeSuccess !== null){
                    stateChangeSuccess();
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('platformApp')
        .config(paginationConfig);

    paginationConfig.$inject = ['uibPaginationConfig', 'paginationConstants'];

    function paginationConfig(uibPaginationConfig, paginationConstants) {
        uibPaginationConfig.itemsPerPage = paginationConstants.itemsPerPage;
        uibPaginationConfig.maxSize = 5;
        uibPaginationConfig.boundaryLinks = true;
        uibPaginationConfig.firstText = '«';
        uibPaginationConfig.previousText = '‹';
        uibPaginationConfig.nextText = '›';
        uibPaginationConfig.lastText = '»';
    }
})();

(function () {
    'use strict';

    angular
        .module('platformApp')
        .config(pagerConfig);

    pagerConfig.$inject = ['uibPagerConfig', 'paginationConstants'];

    function pagerConfig(uibPagerConfig, paginationConstants) {
        uibPagerConfig.itemsPerPage = paginationConstants.itemsPerPage;
        uibPagerConfig.previousText = '«';
        uibPagerConfig.nextText = '»';
    }
})();

(function() {
    'use strict';

    angular
        .module('platformApp')
        .factory('translationStorageProvider', translationStorageProvider);

    translationStorageProvider.$inject = ['$cookies', '$log', 'LANGUAGES'];

    function translationStorageProvider($cookies, $log, LANGUAGES) {
        return {
            get: get,
            put: put
        };

        function get(name) {
            if (LANGUAGES.indexOf($cookies.getObject(name)) === -1) {
                $log.info('Resetting invalid cookie language "' + $cookies.getObject(name) + '" to preferred language "en"');
                $cookies.putObject(name, 'zh-cn');
            }
            return $cookies.getObject(name);
        }

        function put(name, value) {
            $cookies.putObject(name, value);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('platformApp')
        .config(translationConfig);

    translationConfig.$inject = ['$translateProvider', 'tmhDynamicLocaleProvider', 'BUILD_TIMESTAMP'];

    function translationConfig($translateProvider, tmhDynamicLocaleProvider, BUILD_TIMESTAMP) {
        // Initialize angular-translate
        $translateProvider.useLoader('$translatePartialLoader', {
            urlTemplate: 'i18n/{lang}/{part}.json' + (BUILD_TIMESTAMP ? '?build=' + BUILD_TIMESTAMP : '')
        });

        $translateProvider.preferredLanguage('en');
        $translateProvider.useStorage('translationStorageProvider');
        $translateProvider.useSanitizeValueStrategy('escaped');
        $translateProvider.addInterpolation('$translateMessageFormatInterpolation');

        tmhDynamicLocaleProvider.localeLocationPattern('i18n/angular-locale_{{locale}}.js');
        tmhDynamicLocaleProvider.useCookieStorage();
        tmhDynamicLocaleProvider.storageKey('NG_TRANSLATE_LANG_KEY');
    }
})();

/**!
 * Sortable 1.10.1
 * @author	RubaXa   <trash@rubaxa.org>
 * @author	owenm    <owen23355@gmail.com>
 * @license MIT
 */
(function (global, factory) {
    typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory() :
        typeof define === 'function' && define.amd ? define(factory) :
            (global = global || self, global.Sortable = factory());
}(this, function () { 'use strict';

    function _typeof(obj) {
        if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
            _typeof = function (obj) {
                return typeof obj;
            };
        } else {
            _typeof = function (obj) {
                return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
            };
        }

        return _typeof(obj);
    }

    function _defineProperty(obj, key, value) {
        if (key in obj) {
            Object.defineProperty(obj, key, {
                value: value,
                enumerable: true,
                configurable: true,
                writable: true
            });
        } else {
            obj[key] = value;
        }

        return obj;
    }

    function _extends() {
        _extends = Object.assign || function (target) {
                for (var i = 1; i < arguments.length; i++) {
                    var source = arguments[i];

                    for (var key in source) {
                        if (Object.prototype.hasOwnProperty.call(source, key)) {
                            target[key] = source[key];
                        }
                    }
                }

                return target;
            };

        return _extends.apply(this, arguments);
    }

    function _objectSpread(target) {
        for (var i = 1; i < arguments.length; i++) {
            var source = arguments[i] != null ? arguments[i] : {};
            var ownKeys = Object.keys(source);

            if (typeof Object.getOwnPropertySymbols === 'function') {
                ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
                    return Object.getOwnPropertyDescriptor(source, sym).enumerable;
                }));
            }

            ownKeys.forEach(function (key) {
                _defineProperty(target, key, source[key]);
            });
        }

        return target;
    }

    function _objectWithoutPropertiesLoose(source, excluded) {
        if (source == null) return {};
        var target = {};
        var sourceKeys = Object.keys(source);
        var key, i;

        for (i = 0; i < sourceKeys.length; i++) {
            key = sourceKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            target[key] = source[key];
        }

        return target;
    }

    function _objectWithoutProperties(source, excluded) {
        if (source == null) return {};

        var target = _objectWithoutPropertiesLoose(source, excluded);

        var key, i;

        if (Object.getOwnPropertySymbols) {
            var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

            for (i = 0; i < sourceSymbolKeys.length; i++) {
                key = sourceSymbolKeys[i];
                if (excluded.indexOf(key) >= 0) continue;
                if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
                target[key] = source[key];
            }
        }

        return target;
    }

    function _toConsumableArray(arr) {
        return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
    }

    function _arrayWithoutHoles(arr) {
        if (Array.isArray(arr)) {
            for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) arr2[i] = arr[i];

            return arr2;
        }
    }

    function _iterableToArray(iter) {
        if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
    }

    function _nonIterableSpread() {
        throw new TypeError("Invalid attempt to spread non-iterable instance");
    }

    var version = "1.10.1";

    function userAgent(pattern) {
        if (typeof window !== 'undefined' && window.navigator) {
            return !!
                /*@__PURE__*/
                navigator.userAgent.match(pattern);
        }
    }

    var IE11OrLess = userAgent(/(?:Trident.*rv[ :]?11\.|msie|iemobile|Windows Phone)/i);
    var Edge = userAgent(/Edge/i);
    var FireFox = userAgent(/firefox/i);
    var Safari = userAgent(/safari/i) && !userAgent(/chrome/i) && !userAgent(/android/i);
    var IOS = userAgent(/iP(ad|od|hone)/i);
    var ChromeForAndroid = userAgent(/chrome/i) && userAgent(/android/i);

    var captureMode = {
        capture: false,
        passive: false
    };

    function on(el, event, fn) {
        el.addEventListener(event, fn, !IE11OrLess && captureMode);
    }

    function off(el, event, fn) {
        el.removeEventListener(event, fn, !IE11OrLess && captureMode);
    }

    function matches(
        /**HTMLElement*/
        el,
        /**String*/
        selector) {
        if (!selector) return;
        selector[0] === '>' && (selector = selector.substring(1));

        if (el) {
            try {
                if (el.matches) {
                    return el.matches(selector);
                } else if (el.msMatchesSelector) {
                    return el.msMatchesSelector(selector);
                } else if (el.webkitMatchesSelector) {
                    return el.webkitMatchesSelector(selector);
                }
            } catch (_) {
                return false;
            }
        }

        return false;
    }

    function getParentOrHost(el) {
        return el.host && el !== document && el.host.nodeType ? el.host : el.parentNode;
    }

    function closest(
        /**HTMLElement*/
        el,
        /**String*/
        selector,
        /**HTMLElement*/
        ctx, includeCTX) {
        if (el) {
            ctx = ctx || document;

            do {
                if (selector != null && (selector[0] === '>' ? el.parentNode === ctx && matches(el, selector) : matches(el, selector)) || includeCTX && el === ctx) {
                    return el;
                }

                if (el === ctx) break;
                /* jshint boss:true */
            } while (el = getParentOrHost(el));
        }

        return null;
    }

    var R_SPACE = /\s+/g;

    function toggleClass(el, name, state) {
        if (el && name) {
            if (el.classList) {
                el.classList[state ? 'add' : 'remove'](name);
            } else {
                var className = (' ' + el.className + ' ').replace(R_SPACE, ' ').replace(' ' + name + ' ', ' ');
                el.className = (className + (state ? ' ' + name : '')).replace(R_SPACE, ' ');
            }
        }
    }

    function css(el, prop, val) {
        var style = el && el.style;

        if (style) {
            if (val === void 0) {
                if (document.defaultView && document.defaultView.getComputedStyle) {
                    val = document.defaultView.getComputedStyle(el, '');
                } else if (el.currentStyle) {
                    val = el.currentStyle;
                }

                return prop === void 0 ? val : val[prop];
            } else {
                if (!(prop in style) && prop.indexOf('webkit') === -1) {
                    prop = '-webkit-' + prop;
                }

                style[prop] = val + (typeof val === 'string' ? '' : 'px');
            }
        }
    }

    function matrix(el, selfOnly) {
        var appliedTransforms = '';

        if (typeof el === 'string') {
            appliedTransforms = el;
        } else {
            do {
                var transform = css(el, 'transform');

                if (transform && transform !== 'none') {
                    appliedTransforms = transform + ' ' + appliedTransforms;
                }
                /* jshint boss:true */

            } while (!selfOnly && (el = el.parentNode));
        }

        var matrixFn = window.DOMMatrix || window.WebKitCSSMatrix || window.CSSMatrix;
        /*jshint -W056 */

        return matrixFn && new matrixFn(appliedTransforms);
    }

    function find(ctx, tagName, iterator) {
        if (ctx) {
            var list = ctx.getElementsByTagName(tagName),
                i = 0,
                n = list.length;

            if (iterator) {
                for (; i < n; i++) {
                    iterator(list[i], i);
                }
            }

            return list;
        }

        return [];
    }

    function getWindowScrollingElement() {
        if (IE11OrLess) {
            return document.documentElement;
        } else {
            return document.scrollingElement;
        }
    }
    /**
     * Returns the "bounding client rect" of given element
     * @param  {HTMLElement} el                       The element whose boundingClientRect is wanted
     * @param  {[Boolean]} relativeToContainingBlock  Whether the rect should be relative to the containing block of (including) the container
     * @param  {[Boolean]} relativeToNonStaticParent  Whether the rect should be relative to the relative parent of (including) the contaienr
     * @param  {[Boolean]} undoScale                  Whether the container's scale() should be undone
     * @param  {[HTMLElement]} container              The parent the element will be placed in
     * @return {Object}                               The boundingClientRect of el, with specified adjustments
     */


    function getRect(el, relativeToContainingBlock, relativeToNonStaticParent, undoScale, container) {
        if (!el.getBoundingClientRect && el !== window) return;
        var elRect, top, left, bottom, right, height, width;

        if (el !== window && el !== getWindowScrollingElement()) {
            elRect = el.getBoundingClientRect();
            top = elRect.top;
            left = elRect.left;
            bottom = elRect.bottom;
            right = elRect.right;
            height = elRect.height;
            width = elRect.width;
        } else {
            top = 0;
            left = 0;
            bottom = window.innerHeight;
            right = window.innerWidth;
            height = window.innerHeight;
            width = window.innerWidth;
        }

        if ((relativeToContainingBlock || relativeToNonStaticParent) && el !== window) {
            // Adjust for translate()
            container = container || el.parentNode; // solves #1123 (see: https://stackoverflow.com/a/37953806/6088312)
            // Not needed on <= IE11

            if (!IE11OrLess) {
                do {
                    if (container && container.getBoundingClientRect && (css(container, 'transform') !== 'none' || relativeToNonStaticParent && css(container, 'position') !== 'static')) {
                        var containerRect = container.getBoundingClientRect(); // Set relative to edges of padding box of container

                        top -= containerRect.top + parseInt(css(container, 'border-top-width'));
                        left -= containerRect.left + parseInt(css(container, 'border-left-width'));
                        bottom = top + elRect.height;
                        right = left + elRect.width;
                        break;
                    }
                    /* jshint boss:true */

                } while (container = container.parentNode);
            }
        }

        if (undoScale && el !== window) {
            // Adjust for scale()
            var elMatrix = matrix(container || el),
                scaleX = elMatrix && elMatrix.a,
                scaleY = elMatrix && elMatrix.d;

            if (elMatrix) {
                top /= scaleY;
                left /= scaleX;
                width /= scaleX;
                height /= scaleY;
                bottom = top + height;
                right = left + width;
            }
        }

        return {
            top: top,
            left: left,
            bottom: bottom,
            right: right,
            width: width,
            height: height
        };
    }
    /**
     * Checks if a side of an element is scrolled past a side of its parents
     * @param  {HTMLElement}  el           The element who's side being scrolled out of view is in question
     * @param  {String}       elSide       Side of the element in question ('top', 'left', 'right', 'bottom')
     * @param  {String}       parentSide   Side of the parent in question ('top', 'left', 'right', 'bottom')
     * @return {HTMLElement}               The parent scroll element that the el's side is scrolled past, or null if there is no such element
     */


    function isScrolledPast(el, elSide, parentSide) {
        var parent = getParentAutoScrollElement(el, true),
            elSideVal = getRect(el)[elSide];
        /* jshint boss:true */

        while (parent) {
            var parentSideVal = getRect(parent)[parentSide],
                visible = void 0;

            if (parentSide === 'top' || parentSide === 'left') {
                visible = elSideVal >= parentSideVal;
            } else {
                visible = elSideVal <= parentSideVal;
            }

            if (!visible) return parent;
            if (parent === getWindowScrollingElement()) break;
            parent = getParentAutoScrollElement(parent, false);
        }

        return false;
    }
    /**
     * Gets nth child of el, ignoring hidden children, sortable's elements (does not ignore clone if it's visible)
     * and non-draggable elements
     * @param  {HTMLElement} el       The parent element
     * @param  {Number} childNum      The index of the child
     * @param  {Object} options       Parent Sortable's options
     * @return {HTMLElement}          The child at index childNum, or null if not found
     */


    function getChild(el, childNum, options) {
        var currentChild = 0,
            i = 0,
            children = el.children;

        while (i < children.length) {
            if (children[i].style.display !== 'none' && children[i] !== Sortable.ghost && children[i] !== Sortable.dragged && closest(children[i], options.draggable, el, false)) {
                if (currentChild === childNum) {
                    return children[i];
                }

                currentChild++;
            }

            i++;
        }

        return null;
    }
    /**
     * Gets the last child in the el, ignoring ghostEl or invisible elements (clones)
     * @param  {HTMLElement} el       Parent element
     * @param  {selector} selector    Any other elements that should be ignored
     * @return {HTMLElement}          The last child, ignoring ghostEl
     */


    function lastChild(el, selector) {
        var last = el.lastElementChild;

        while (last && (last === Sortable.ghost || css(last, 'display') === 'none' || selector && !matches(last, selector))) {
            last = last.previousElementSibling;
        }

        return last || null;
    }
    /**
     * Returns the index of an element within its parent for a selected set of
     * elements
     * @param  {HTMLElement} el
     * @param  {selector} selector
     * @return {number}
     */


    function index(el, selector) {
        var index = 0;

        if (!el || !el.parentNode) {
            return -1;
        }
        /* jshint boss:true */


        while (el = el.previousElementSibling) {
            if (el.nodeName.toUpperCase() !== 'TEMPLATE' && el !== Sortable.clone && (!selector || matches(el, selector))) {
                index++;
            }
        }

        return index;
    }
    /**
     * Returns the scroll offset of the given element, added with all the scroll offsets of parent elements.
     * The value is returned in real pixels.
     * @param  {HTMLElement} el
     * @return {Array}             Offsets in the format of [left, top]
     */


    function getRelativeScrollOffset(el) {
        var offsetLeft = 0,
            offsetTop = 0,
            winScroller = getWindowScrollingElement();

        if (el) {
            do {
                var elMatrix = matrix(el),
                    scaleX = elMatrix.a,
                    scaleY = elMatrix.d;
                offsetLeft += el.scrollLeft * scaleX;
                offsetTop += el.scrollTop * scaleY;
            } while (el !== winScroller && (el = el.parentNode));
        }

        return [offsetLeft, offsetTop];
    }
    /**
     * Returns the index of the object within the given array
     * @param  {Array} arr   Array that may or may not hold the object
     * @param  {Object} obj  An object that has a key-value pair unique to and identical to a key-value pair in the object you want to find
     * @return {Number}      The index of the object in the array, or -1
     */


    function indexOfObject(arr, obj) {
        for (var i in arr) {
            if (!arr.hasOwnProperty(i)) continue;

            for (var key in obj) {
                if (obj.hasOwnProperty(key) && obj[key] === arr[i][key]) return Number(i);
            }
        }

        return -1;
    }

    function getParentAutoScrollElement(el, includeSelf) {
        // skip to window
        if (!el || !el.getBoundingClientRect) return getWindowScrollingElement();
        var elem = el;
        var gotSelf = false;

        do {
            // we don't need to get elem css if it isn't even overflowing in the first place (performance)
            if (elem.clientWidth < elem.scrollWidth || elem.clientHeight < elem.scrollHeight) {
                var elemCSS = css(elem);

                if (elem.clientWidth < elem.scrollWidth && (elemCSS.overflowX == 'auto' || elemCSS.overflowX == 'scroll') || elem.clientHeight < elem.scrollHeight && (elemCSS.overflowY == 'auto' || elemCSS.overflowY == 'scroll')) {
                    if (!elem.getBoundingClientRect || elem === document.body) return getWindowScrollingElement();
                    if (gotSelf || includeSelf) return elem;
                    gotSelf = true;
                }
            }
            /* jshint boss:true */

        } while (elem = elem.parentNode);

        return getWindowScrollingElement();
    }

    function extend(dst, src) {
        if (dst && src) {
            for (var key in src) {
                if (src.hasOwnProperty(key)) {
                    dst[key] = src[key];
                }
            }
        }

        return dst;
    }

    function isRectEqual(rect1, rect2) {
        return Math.round(rect1.top) === Math.round(rect2.top) && Math.round(rect1.left) === Math.round(rect2.left) && Math.round(rect1.height) === Math.round(rect2.height) && Math.round(rect1.width) === Math.round(rect2.width);
    }

    var _throttleTimeout;

    function throttle(callback, ms) {
        return function () {
            if (!_throttleTimeout) {
                var args = arguments,
                    _this = this;

                if (args.length === 1) {
                    callback.call(_this, args[0]);
                } else {
                    callback.apply(_this, args);
                }

                _throttleTimeout = setTimeout(function () {
                    _throttleTimeout = void 0;
                }, ms);
            }
        };
    }

    function cancelThrottle() {
        clearTimeout(_throttleTimeout);
        _throttleTimeout = void 0;
    }

    function scrollBy(el, x, y) {
        el.scrollLeft += x;
        el.scrollTop += y;
    }

    function clone(el) {
        var Polymer = window.Polymer;
        var $ = window.jQuery || window.Zepto;

        if (Polymer && Polymer.dom) {
            return Polymer.dom(el).cloneNode(true);
        } else if ($) {
            return $(el).clone(true)[0];
        } else {
            return el.cloneNode(true);
        }
    }

    function setRect(el, rect) {
        css(el, 'position', 'absolute');
        css(el, 'top', rect.top);
        css(el, 'left', rect.left);
        css(el, 'width', rect.width);
        css(el, 'height', rect.height);
    }

    function unsetRect(el) {
        css(el, 'position', '');
        css(el, 'top', '');
        css(el, 'left', '');
        css(el, 'width', '');
        css(el, 'height', '');
    }

    var expando = 'Sortable' + new Date().getTime();

    function AnimationStateManager() {
        var animationStates = [],
            animationCallbackId;
        return {
            captureAnimationState: function captureAnimationState() {
                animationStates = [];
                if (!this.options.animation) return;
                var children = [].slice.call(this.el.children);
                children.forEach(function (child) {
                    if (css(child, 'display') === 'none' || child === Sortable.ghost) return;
                    animationStates.push({
                        target: child,
                        rect: getRect(child)
                    });

                    var fromRect = _objectSpread({}, animationStates[animationStates.length - 1].rect); // If animating: compensate for current animation


                    if (child.thisAnimationDuration) {
                        var childMatrix = matrix(child, true);

                        if (childMatrix) {
                            fromRect.top -= childMatrix.f;
                            fromRect.left -= childMatrix.e;
                        }
                    }

                    child.fromRect = fromRect;
                });
            },
            addAnimationState: function addAnimationState(state) {
                animationStates.push(state);
            },
            removeAnimationState: function removeAnimationState(target) {
                animationStates.splice(indexOfObject(animationStates, {
                    target: target
                }), 1);
            },
            animateAll: function animateAll(callback) {
                var _this = this;

                if (!this.options.animation) {
                    clearTimeout(animationCallbackId);
                    if (typeof callback === 'function') callback();
                    return;
                }

                var animating = false,
                    animationTime = 0;
                animationStates.forEach(function (state) {
                    var time = 0,
                        target = state.target,
                        fromRect = target.fromRect,
                        toRect = getRect(target),
                        prevFromRect = target.prevFromRect,
                        prevToRect = target.prevToRect,
                        animatingRect = state.rect,
                        targetMatrix = matrix(target, true);

                    if (targetMatrix) {
                        // Compensate for current animation
                        toRect.top -= targetMatrix.f;
                        toRect.left -= targetMatrix.e;
                    }

                    target.toRect = toRect;

                    if (target.thisAnimationDuration) {
                        // Could also check if animatingRect is between fromRect and toRect
                        if (isRectEqual(prevFromRect, toRect) && !isRectEqual(fromRect, toRect) && // Make sure animatingRect is on line between toRect & fromRect
                            (animatingRect.top - toRect.top) / (animatingRect.left - toRect.left) === (fromRect.top - toRect.top) / (fromRect.left - toRect.left)) {
                            // If returning to same place as started from animation and on same axis
                            time = calculateRealTime(animatingRect, prevFromRect, prevToRect, _this.options);
                        }
                    } // if fromRect != toRect: animate


                    if (!isRectEqual(toRect, fromRect)) {
                        target.prevFromRect = fromRect;
                        target.prevToRect = toRect;

                        if (!time) {
                            time = _this.options.animation;
                        }

                        _this.animate(target, animatingRect, toRect, time);
                    }

                    if (time) {
                        animating = true;
                        animationTime = Math.max(animationTime, time);
                        clearTimeout(target.animationResetTimer);
                        target.animationResetTimer = setTimeout(function () {
                            target.animationTime = 0;
                            target.prevFromRect = null;
                            target.fromRect = null;
                            target.prevToRect = null;
                            target.thisAnimationDuration = null;
                        }, time);
                        target.thisAnimationDuration = time;
                    }
                });
                clearTimeout(animationCallbackId);

                if (!animating) {
                    if (typeof callback === 'function') callback();
                } else {
                    animationCallbackId = setTimeout(function () {
                        if (typeof callback === 'function') callback();
                    }, animationTime);
                }

                animationStates = [];
            },
            animate: function animate(target, currentRect, toRect, duration) {
                if (duration) {
                    css(target, 'transition', '');
                    css(target, 'transform', '');
                    var elMatrix = matrix(this.el),
                        scaleX = elMatrix && elMatrix.a,
                        scaleY = elMatrix && elMatrix.d,
                        translateX = (currentRect.left - toRect.left) / (scaleX || 1),
                        translateY = (currentRect.top - toRect.top) / (scaleY || 1);
                    target.animatingX = !!translateX;
                    target.animatingY = !!translateY;
                    css(target, 'transform', 'translate3d(' + translateX + 'px,' + translateY + 'px,0)');
                    repaint(target); // repaint

                    css(target, 'transition', 'transform ' + duration + 'ms' + (this.options.easing ? ' ' + this.options.easing : ''));
                    css(target, 'transform', 'translate3d(0,0,0)');
                    typeof target.animated === 'number' && clearTimeout(target.animated);
                    target.animated = setTimeout(function () {
                        css(target, 'transition', '');
                        css(target, 'transform', '');
                        target.animated = false;
                        target.animatingX = false;
                        target.animatingY = false;
                    }, duration);
                }
            }
        };
    }

    function repaint(target) {
        return target.offsetWidth;
    }

    function calculateRealTime(animatingRect, fromRect, toRect, options) {
        return Math.sqrt(Math.pow(fromRect.top - animatingRect.top, 2) + Math.pow(fromRect.left - animatingRect.left, 2)) / Math.sqrt(Math.pow(fromRect.top - toRect.top, 2) + Math.pow(fromRect.left - toRect.left, 2)) * options.animation;
    }

    var plugins = [];
    var defaults = {
        initializeByDefault: true
    };
    var PluginManager = {
        mount: function mount(plugin) {
            // Set default static properties
            for (var option in defaults) {
                if (defaults.hasOwnProperty(option) && !(option in plugin)) {
                    plugin[option] = defaults[option];
                }
            }

            plugins.push(plugin);
        },
        pluginEvent: function pluginEvent(eventName, sortable, evt) {
            var _this = this;

            this.eventCanceled = false;

            evt.cancel = function () {
                _this.eventCanceled = true;
            };

            var eventNameGlobal = eventName + 'Global';
            plugins.forEach(function (plugin) {
                if (!sortable[plugin.pluginName]) return; // Fire global events if it exists in this sortable

                if (sortable[plugin.pluginName][eventNameGlobal]) {
                    sortable[plugin.pluginName][eventNameGlobal](_objectSpread({
                        sortable: sortable
                    }, evt));
                } // Only fire plugin event if plugin is enabled in this sortable,
                // and plugin has event defined


                if (sortable.options[plugin.pluginName] && sortable[plugin.pluginName][eventName]) {
                    sortable[plugin.pluginName][eventName](_objectSpread({
                        sortable: sortable
                    }, evt));
                }
            });
        },
        initializePlugins: function initializePlugins(sortable, el, defaults, options) {
            plugins.forEach(function (plugin) {
                var pluginName = plugin.pluginName;
                if (!sortable.options[pluginName] && !plugin.initializeByDefault) return;
                var initialized = new plugin(sortable, el, sortable.options);
                initialized.sortable = sortable;
                initialized.options = sortable.options;
                sortable[pluginName] = initialized; // Add default options from plugin

                _extends(defaults, initialized.defaults);
            });

            for (var option in sortable.options) {
                if (!sortable.options.hasOwnProperty(option)) continue;
                var modified = this.modifyOption(sortable, option, sortable.options[option]);

                if (typeof modified !== 'undefined') {
                    sortable.options[option] = modified;
                }
            }
        },
        getEventProperties: function getEventProperties(name, sortable) {
            var eventProperties = {};
            plugins.forEach(function (plugin) {
                if (typeof plugin.eventProperties !== 'function') return;

                _extends(eventProperties, plugin.eventProperties.call(sortable[plugin.pluginName], name));
            });
            return eventProperties;
        },
        modifyOption: function modifyOption(sortable, name, value) {
            var modifiedValue;
            plugins.forEach(function (plugin) {
                // Plugin must exist on the Sortable
                if (!sortable[plugin.pluginName]) return; // If static option listener exists for this option, call in the context of the Sortable's instance of this plugin

                if (plugin.optionListeners && typeof plugin.optionListeners[name] === 'function') {
                    modifiedValue = plugin.optionListeners[name].call(sortable[plugin.pluginName], value);
                }
            });
            return modifiedValue;
        }
    };

    function dispatchEvent(_ref) {
        var sortable = _ref.sortable,
            rootEl = _ref.rootEl,
            name = _ref.name,
            targetEl = _ref.targetEl,
            cloneEl = _ref.cloneEl,
            toEl = _ref.toEl,
            fromEl = _ref.fromEl,
            oldIndex = _ref.oldIndex,
            newIndex = _ref.newIndex,
            oldDraggableIndex = _ref.oldDraggableIndex,
            newDraggableIndex = _ref.newDraggableIndex,
            originalEvent = _ref.originalEvent,
            putSortable = _ref.putSortable,
            extraEventProperties = _ref.extraEventProperties;
        sortable = sortable || rootEl && rootEl[expando];
        if (!sortable) return;
        var evt,
            options = sortable.options,
            onName = 'on' + name.charAt(0).toUpperCase() + name.substr(1); // Support for new CustomEvent feature

        if (window.CustomEvent && !IE11OrLess && !Edge) {
            evt = new CustomEvent(name, {
                bubbles: true,
                cancelable: true
            });
        } else {
            evt = document.createEvent('Event');
            evt.initEvent(name, true, true);
        }

        evt.to = toEl || rootEl;
        evt.from = fromEl || rootEl;
        evt.item = targetEl || rootEl;
        evt.clone = cloneEl;
        evt.oldIndex = oldIndex;
        evt.newIndex = newIndex;
        evt.oldDraggableIndex = oldDraggableIndex;
        evt.newDraggableIndex = newDraggableIndex;
        evt.originalEvent = originalEvent;
        evt.pullMode = putSortable ? putSortable.lastPutMode : undefined;

        var allEventProperties = _objectSpread({}, extraEventProperties, PluginManager.getEventProperties(name, sortable));

        for (var option in allEventProperties) {
            evt[option] = allEventProperties[option];
        }

        if (rootEl) {
            rootEl.dispatchEvent(evt);
        }

        if (options[onName]) {
            options[onName].call(sortable, evt);
        }
    }

    var pluginEvent = function pluginEvent(eventName, sortable) {
        var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
            originalEvent = _ref.evt,
            data = _objectWithoutProperties(_ref, ["evt"]);

        PluginManager.pluginEvent.bind(Sortable)(eventName, sortable, _objectSpread({
            dragEl: dragEl,
            parentEl: parentEl,
            ghostEl: ghostEl,
            rootEl: rootEl,
            nextEl: nextEl,
            lastDownEl: lastDownEl,
            cloneEl: cloneEl,
            cloneHidden: cloneHidden,
            dragStarted: moved,
            putSortable: putSortable,
            activeSortable: Sortable.active,
            originalEvent: originalEvent,
            oldIndex: oldIndex,
            oldDraggableIndex: oldDraggableIndex,
            newIndex: newIndex,
            newDraggableIndex: newDraggableIndex,
            hideGhostForTarget: _hideGhostForTarget,
            unhideGhostForTarget: _unhideGhostForTarget,
            cloneNowHidden: function cloneNowHidden() {
                cloneHidden = true;
            },
            cloneNowShown: function cloneNowShown() {
                cloneHidden = false;
            },
            dispatchSortableEvent: function dispatchSortableEvent(name) {
                _dispatchEvent({
                    sortable: sortable,
                    name: name,
                    originalEvent: originalEvent
                });
            }
        }, data));
    };

    function _dispatchEvent(info) {
        dispatchEvent(_objectSpread({
            putSortable: putSortable,
            cloneEl: cloneEl,
            targetEl: dragEl,
            rootEl: rootEl,
            oldIndex: oldIndex,
            oldDraggableIndex: oldDraggableIndex,
            newIndex: newIndex,
            newDraggableIndex: newDraggableIndex
        }, info));
    }

    var dragEl,
        parentEl,
        ghostEl,
        rootEl,
        nextEl,
        lastDownEl,
        cloneEl,
        cloneHidden,
        oldIndex,
        newIndex,
        oldDraggableIndex,
        newDraggableIndex,
        activeGroup,
        putSortable,
        awaitingDragStarted = false,
        ignoreNextClick = false,
        sortables = [],
        tapEvt,
        touchEvt,
        lastDx,
        lastDy,
        tapDistanceLeft,
        tapDistanceTop,
        moved,
        lastTarget,
        lastDirection,
        pastFirstInvertThresh = false,
        isCircumstantialInvert = false,
        targetMoveDistance,
    // For positioning ghost absolutely
        ghostRelativeParent,
        ghostRelativeParentInitialScroll = [],
    // (left, top)
        _silent = false,
        savedInputChecked = [];
    /** @const */

    var documentExists = typeof document !== 'undefined',
        PositionGhostAbsolutely = IOS,
        CSSFloatProperty = Edge || IE11OrLess ? 'cssFloat' : 'float',
    // This will not pass for IE9, because IE9 DnD only works on anchors
        supportDraggable = documentExists && !ChromeForAndroid && !IOS && 'draggable' in document.createElement('div'),
        supportCssPointerEvents = function () {
            if (!documentExists) return; // false when <= IE11

            if (IE11OrLess) {
                return false;
            }

            var el = document.createElement('x');
            el.style.cssText = 'pointer-events:auto';
            return el.style.pointerEvents === 'auto';
        }(),
        _detectDirection = function _detectDirection(el, options) {
            var elCSS = css(el),
                elWidth = parseInt(elCSS.width) - parseInt(elCSS.paddingLeft) - parseInt(elCSS.paddingRight) - parseInt(elCSS.borderLeftWidth) - parseInt(elCSS.borderRightWidth),
                child1 = getChild(el, 0, options),
                child2 = getChild(el, 1, options),
                firstChildCSS = child1 && css(child1),
                secondChildCSS = child2 && css(child2),
                firstChildWidth = firstChildCSS && parseInt(firstChildCSS.marginLeft) + parseInt(firstChildCSS.marginRight) + getRect(child1).width,
                secondChildWidth = secondChildCSS && parseInt(secondChildCSS.marginLeft) + parseInt(secondChildCSS.marginRight) + getRect(child2).width;

            if (elCSS.display === 'flex') {
                return elCSS.flexDirection === 'column' || elCSS.flexDirection === 'column-reverse' ? 'vertical' : 'horizontal';
            }

            if (elCSS.display === 'grid') {
                return elCSS.gridTemplateColumns.split(' ').length <= 1 ? 'vertical' : 'horizontal';
            }

            if (child1 && firstChildCSS["float"] && firstChildCSS["float"] !== 'none') {
                var touchingSideChild2 = firstChildCSS["float"] === 'left' ? 'left' : 'right';
                return child2 && (secondChildCSS.clear === 'both' || secondChildCSS.clear === touchingSideChild2) ? 'vertical' : 'horizontal';
            }

            return child1 && (firstChildCSS.display === 'block' || firstChildCSS.display === 'flex' || firstChildCSS.display === 'table' || firstChildCSS.display === 'grid' || firstChildWidth >= elWidth && elCSS[CSSFloatProperty] === 'none' || child2 && elCSS[CSSFloatProperty] === 'none' && firstChildWidth + secondChildWidth > elWidth) ? 'vertical' : 'horizontal';
        },
        _dragElInRowColumn = function _dragElInRowColumn(dragRect, targetRect, vertical) {
            var dragElS1Opp = vertical ? dragRect.left : dragRect.top,
                dragElS2Opp = vertical ? dragRect.right : dragRect.bottom,
                dragElOppLength = vertical ? dragRect.width : dragRect.height,
                targetS1Opp = vertical ? targetRect.left : targetRect.top,
                targetS2Opp = vertical ? targetRect.right : targetRect.bottom,
                targetOppLength = vertical ? targetRect.width : targetRect.height;
            return dragElS1Opp === targetS1Opp || dragElS2Opp === targetS2Opp || dragElS1Opp + dragElOppLength / 2 === targetS1Opp + targetOppLength / 2;
        },

        /**
         * Detects first nearest empty sortable to X and Y position using emptyInsertThreshold.
         * @param  {Number} x      X position
         * @param  {Number} y      Y position
         * @return {HTMLElement}   Element of the first found nearest Sortable
         */
        _detectNearestEmptySortable = function _detectNearestEmptySortable(x, y) {
            var ret;
            sortables.some(function (sortable) {
                if (lastChild(sortable)) return;
                var rect = getRect(sortable),
                    threshold = sortable[expando].options.emptyInsertThreshold,
                    insideHorizontally = x >= rect.left - threshold && x <= rect.right + threshold,
                    insideVertically = y >= rect.top - threshold && y <= rect.bottom + threshold;

                if (threshold && insideHorizontally && insideVertically) {
                    return ret = sortable;
                }
            });
            return ret;
        },
        _prepareGroup = function _prepareGroup(options) {
            function toFn(value, pull) {
                return function (to, from, dragEl, evt) {
                    var sameGroup = to.options.group.name && from.options.group.name && to.options.group.name === from.options.group.name;

                    if (value == null && (pull || sameGroup)) {
                        // Default pull value
                        // Default pull and put value if same group
                        return true;
                    } else if (value == null || value === false) {
                        return false;
                    } else if (pull && value === 'clone') {
                        return value;
                    } else if (typeof value === 'function') {
                        return toFn(value(to, from, dragEl, evt), pull)(to, from, dragEl, evt);
                    } else {
                        var otherGroup = (pull ? to : from).options.group.name;
                        return value === true || typeof value === 'string' && value === otherGroup || value.join && value.indexOf(otherGroup) > -1;
                    }
                };
            }

            var group = {};
            var originalGroup = options.group;

            if (!originalGroup || _typeof(originalGroup) != 'object') {
                originalGroup = {
                    name: originalGroup
                };
            }

            group.name = originalGroup.name;
            group.checkPull = toFn(originalGroup.pull, true);
            group.checkPut = toFn(originalGroup.put);
            group.revertClone = originalGroup.revertClone;
            options.group = group;
        },
        _hideGhostForTarget = function _hideGhostForTarget() {
            if (!supportCssPointerEvents && ghostEl) {
                css(ghostEl, 'display', 'none');
            }
        },
        _unhideGhostForTarget = function _unhideGhostForTarget() {
            if (!supportCssPointerEvents && ghostEl) {
                css(ghostEl, 'display', '');
            }
        }; // #1184 fix - Prevent click event on fallback if dragged but item not changed position


    if (documentExists) {
        document.addEventListener('click', function (evt) {
            if (ignoreNextClick) {
                evt.preventDefault();
                evt.stopPropagation && evt.stopPropagation();
                evt.stopImmediatePropagation && evt.stopImmediatePropagation();
                ignoreNextClick = false;
                return false;
            }
        }, true);
    }

    var nearestEmptyInsertDetectEvent = function nearestEmptyInsertDetectEvent(evt) {
        if (dragEl) {
            evt = evt.touches ? evt.touches[0] : evt;

            var nearest = _detectNearestEmptySortable(evt.clientX, evt.clientY);

            if (nearest) {
                // Create imitation event
                var event = {};

                for (var i in evt) {
                    if (evt.hasOwnProperty(i)) {
                        event[i] = evt[i];
                    }
                }

                event.target = event.rootEl = nearest;
                event.preventDefault = void 0;
                event.stopPropagation = void 0;

                nearest[expando]._onDragOver(event);
            }
        }
    };

    var _checkOutsideTargetEl = function _checkOutsideTargetEl(evt) {
        if (dragEl) {
            dragEl.parentNode[expando]._isOutsideThisEl(evt.target);
        }
    };
    /**
     * @class  Sortable
     * @param  {HTMLElement}  el
     * @param  {Object}       [options]
     */


    function Sortable(el, options) {
        if (!(el && el.nodeType && el.nodeType === 1)) {
            throw "Sortable: `el` must be an HTMLElement, not ".concat({}.toString.call(el));
        }

        this.el = el; // root element

        this.options = options = _extends({}, options); // Export instance

        el[expando] = this;
        var defaults = {
            group: null,
            sort: true,
            disabled: false,
            store: null,
            handle: null,
            draggable: /^[uo]l$/i.test(el.nodeName) ? '>li' : '>*',
            swapThreshold: 1,
            // percentage; 0 <= x <= 1
            invertSwap: false,
            // invert always
            invertedSwapThreshold: null,
            // will be set to same as swapThreshold if default
            removeCloneOnHide: true,
            direction: function direction() {
                return _detectDirection(el, this.options);
            },
            ghostClass: 'sortable-ghost',
            chosenClass: 'sortable-chosen',
            dragClass: 'sortable-drag',
            ignore: 'a, img',
            filter: null,
            preventOnFilter: true,
            animation: 0,
            easing: null,
            setData: function setData(dataTransfer, dragEl) {
                dataTransfer.setData('Text', dragEl.textContent);
            },
            dropBubble: false,
            dragoverBubble: false,
            dataIdAttr: 'data-id',
            delay: 0,
            delayOnTouchOnly: false,
            touchStartThreshold: (Number.parseInt ? Number : window).parseInt(window.devicePixelRatio, 10) || 1,
            forceFallback: false,
            fallbackClass: 'sortable-fallback',
            fallbackOnBody: false,
            fallbackTolerance: 0,
            fallbackOffset: {
                x: 0,
                y: 0
            },
            supportPointer: Sortable.supportPointer !== false && 'PointerEvent' in window,
            emptyInsertThreshold: 5
        };
        PluginManager.initializePlugins(this, el, defaults); // Set default options

        for (var name in defaults) {
            !(name in options) && (options[name] = defaults[name]);
        }

        _prepareGroup(options); // Bind all private methods


        for (var fn in this) {
            if (fn.charAt(0) === '_' && typeof this[fn] === 'function') {
                this[fn] = this[fn].bind(this);
            }
        } // Setup drag mode


        this.nativeDraggable = options.forceFallback ? false : supportDraggable;

        if (this.nativeDraggable) {
            // Touch start threshold cannot be greater than the native dragstart threshold
            this.options.touchStartThreshold = 1;
        } // Bind events


        if (options.supportPointer) {
            on(el, 'pointerdown', this._onTapStart);
        } else {
            on(el, 'mousedown', this._onTapStart);
            on(el, 'touchstart', this._onTapStart);
        }

        if (this.nativeDraggable) {
            on(el, 'dragover', this);
            on(el, 'dragenter', this);
        }

        sortables.push(this.el); // Restore sorting

        options.store && options.store.get && this.sort(options.store.get(this) || []); // Add animation state manager

        _extends(this, AnimationStateManager());
    }

    Sortable.prototype =
        /** @lends Sortable.prototype */
    {
        constructor: Sortable,
        _isOutsideThisEl: function _isOutsideThisEl(target) {
            if (!this.el.contains(target) && target !== this.el) {
                lastTarget = null;
            }
        },
        _getDirection: function _getDirection(evt, target) {
            return typeof this.options.direction === 'function' ? this.options.direction.call(this, evt, target, dragEl) : this.options.direction;
        },
        _onTapStart: function _onTapStart(
            /** Event|TouchEvent */
            evt) {
            if (!evt.cancelable) return;

            var _this = this,
                el = this.el,
                options = this.options,
                preventOnFilter = options.preventOnFilter,
                type = evt.type,
                touch = evt.touches && evt.touches[0] || evt.pointerType && evt.pointerType === 'touch' && evt,
                target = (touch || evt).target,
                originalTarget = evt.target.shadowRoot && (evt.path && evt.path[0] || evt.composedPath && evt.composedPath()[0]) || target,
                filter = options.filter;

            _saveInputCheckedState(el); // Don't trigger start event when an element is been dragged, otherwise the evt.oldindex always wrong when set option.group.


            if (dragEl) {
                return;
            }

            if (/mousedown|pointerdown/.test(type) && evt.button !== 0 || options.disabled) {
                return; // only left button and enabled
            } // cancel dnd if original target is content editable


            if (originalTarget.isContentEditable) {
                return;
            }

            target = closest(target, options.draggable, el, false);

            if (target && target.animated) {
                return;
            }

            if (lastDownEl === target) {
                // Ignoring duplicate `down`
                return;
            } // Get the index of the dragged element within its parent


            oldIndex = index(target);
            oldDraggableIndex = index(target, options.draggable); // Check filter

            if (typeof filter === 'function') {
                if (filter.call(this, evt, target, this)) {
                    _dispatchEvent({
                        sortable: _this,
                        rootEl: originalTarget,
                        name: 'filter',
                        targetEl: target,
                        toEl: el,
                        fromEl: el
                    });

                    pluginEvent('filter', _this, {
                        evt: evt
                    });
                    preventOnFilter && evt.cancelable && evt.preventDefault();
                    return; // cancel dnd
                }
            } else if (filter) {
                filter = filter.split(',').some(function (criteria) {
                    criteria = closest(originalTarget, criteria.trim(), el, false);

                    if (criteria) {
                        _dispatchEvent({
                            sortable: _this,
                            rootEl: criteria,
                            name: 'filter',
                            targetEl: target,
                            fromEl: el,
                            toEl: el
                        });

                        pluginEvent('filter', _this, {
                            evt: evt
                        });
                        return true;
                    }
                });

                if (filter) {
                    preventOnFilter && evt.cancelable && evt.preventDefault();
                    return; // cancel dnd
                }
            }

            if (options.handle && !closest(originalTarget, options.handle, el, false)) {
                return;
            } // Prepare `dragstart`


            this._prepareDragStart(evt, touch, target);
        },
        _prepareDragStart: function _prepareDragStart(
            /** Event */
            evt,
            /** Touch */
            touch,
            /** HTMLElement */
            target) {
            var _this = this,
                el = _this.el,
                options = _this.options,
                ownerDocument = el.ownerDocument,
                dragStartFn;

            if (target && !dragEl && target.parentNode === el) {
                var dragRect = getRect(target);
                rootEl = el;
                dragEl = target;
                parentEl = dragEl.parentNode;
                nextEl = dragEl.nextSibling;
                lastDownEl = target;
                activeGroup = options.group;
                Sortable.dragged = dragEl;
                tapEvt = {
                    target: dragEl,
                    clientX: (touch || evt).clientX,
                    clientY: (touch || evt).clientY
                };
                tapDistanceLeft = tapEvt.clientX - dragRect.left;
                tapDistanceTop = tapEvt.clientY - dragRect.top;
                this._lastX = (touch || evt).clientX;
                this._lastY = (touch || evt).clientY;
                dragEl.style['will-change'] = 'all';

                dragStartFn = function dragStartFn() {
                    pluginEvent('delayEnded', _this, {
                        evt: evt
                    });

                    if (Sortable.eventCanceled) {
                        _this._onDrop();

                        return;
                    } // Delayed drag has been triggered
                    // we can re-enable the events: touchmove/mousemove


                    _this._disableDelayedDragEvents();

                    if (!FireFox && _this.nativeDraggable) {
                        dragEl.draggable = true;
                    } // Bind the events: dragstart/dragend


                    _this._triggerDragStart(evt, touch); // Drag start event


                    _dispatchEvent({
                        sortable: _this,
                        name: 'choose',
                        originalEvent: evt
                    }); // Chosen item


                    toggleClass(dragEl, options.chosenClass, true);
                }; // Disable "draggable"


                options.ignore.split(',').forEach(function (criteria) {
                    find(dragEl, criteria.trim(), _disableDraggable);
                });
                on(ownerDocument, 'dragover', nearestEmptyInsertDetectEvent);
                on(ownerDocument, 'mousemove', nearestEmptyInsertDetectEvent);
                on(ownerDocument, 'touchmove', nearestEmptyInsertDetectEvent);
                on(ownerDocument, 'mouseup', _this._onDrop);
                on(ownerDocument, 'touchend', _this._onDrop);
                on(ownerDocument, 'touchcancel', _this._onDrop); // Make dragEl draggable (must be before delay for FireFox)

                if (FireFox && this.nativeDraggable) {
                    this.options.touchStartThreshold = 4;
                    dragEl.draggable = true;
                }

                pluginEvent('delayStart', this, {
                    evt: evt
                }); // Delay is impossible for native DnD in Edge or IE

                if (options.delay && (!options.delayOnTouchOnly || touch) && (!this.nativeDraggable || !(Edge || IE11OrLess))) {
                    if (Sortable.eventCanceled) {
                        this._onDrop();

                        return;
                    } // If the user moves the pointer or let go the click or touch
                    // before the delay has been reached:
                    // disable the delayed drag


                    on(ownerDocument, 'mouseup', _this._disableDelayedDrag);
                    on(ownerDocument, 'touchend', _this._disableDelayedDrag);
                    on(ownerDocument, 'touchcancel', _this._disableDelayedDrag);
                    on(ownerDocument, 'mousemove', _this._delayedDragTouchMoveHandler);
                    on(ownerDocument, 'touchmove', _this._delayedDragTouchMoveHandler);
                    options.supportPointer && on(ownerDocument, 'pointermove', _this._delayedDragTouchMoveHandler);
                    _this._dragStartTimer = setTimeout(dragStartFn, options.delay);
                } else {
                    dragStartFn();
                }
            }
        },
        _delayedDragTouchMoveHandler: function _delayedDragTouchMoveHandler(
            /** TouchEvent|PointerEvent **/
            e) {
            var touch = e.touches ? e.touches[0] : e;

            if (Math.max(Math.abs(touch.clientX - this._lastX), Math.abs(touch.clientY - this._lastY)) >= Math.floor(this.options.touchStartThreshold / (this.nativeDraggable && window.devicePixelRatio || 1))) {
                this._disableDelayedDrag();
            }
        },
        _disableDelayedDrag: function _disableDelayedDrag() {
            dragEl && _disableDraggable(dragEl);
            clearTimeout(this._dragStartTimer);

            this._disableDelayedDragEvents();
        },
        _disableDelayedDragEvents: function _disableDelayedDragEvents() {
            var ownerDocument = this.el.ownerDocument;
            off(ownerDocument, 'mouseup', this._disableDelayedDrag);
            off(ownerDocument, 'touchend', this._disableDelayedDrag);
            off(ownerDocument, 'touchcancel', this._disableDelayedDrag);
            off(ownerDocument, 'mousemove', this._delayedDragTouchMoveHandler);
            off(ownerDocument, 'touchmove', this._delayedDragTouchMoveHandler);
            off(ownerDocument, 'pointermove', this._delayedDragTouchMoveHandler);
        },
        _triggerDragStart: function _triggerDragStart(
            /** Event */
            evt,
            /** Touch */
            touch) {
            touch = touch || evt.pointerType == 'touch' && evt;

            if (!this.nativeDraggable || touch) {
                if (this.options.supportPointer) {
                    on(document, 'pointermove', this._onTouchMove);
                } else if (touch) {
                    on(document, 'touchmove', this._onTouchMove);
                } else {
                    on(document, 'mousemove', this._onTouchMove);
                }
            } else {
                on(dragEl, 'dragend', this);
                on(rootEl, 'dragstart', this._onDragStart);
            }

            try {
                if (document.selection) {
                    // Timeout neccessary for IE9
                    _nextTick(function () {
                        document.selection.empty();
                    });
                } else {
                    window.getSelection().removeAllRanges();
                }
            } catch (err) {}
        },
        _dragStarted: function _dragStarted(fallback, evt) {

            awaitingDragStarted = false;

            if (rootEl && dragEl) {
                pluginEvent('dragStarted', this, {
                    evt: evt
                });

                if (this.nativeDraggable) {
                    on(document, 'dragover', _checkOutsideTargetEl);
                }

                var options = this.options; // Apply effect

                !fallback && toggleClass(dragEl, options.dragClass, false);
                toggleClass(dragEl, options.ghostClass, true);
                Sortable.active = this;
                fallback && this._appendGhost(); // Drag start event

                _dispatchEvent({
                    sortable: this,
                    name: 'start',
                    originalEvent: evt
                });
            } else {
                this._nulling();
            }
        },
        _emulateDragOver: function _emulateDragOver() {
            if (touchEvt) {
                this._lastX = touchEvt.clientX;
                this._lastY = touchEvt.clientY;

                _hideGhostForTarget();

                var target = document.elementFromPoint(touchEvt.clientX, touchEvt.clientY);
                var parent = target;

                while (target && target.shadowRoot) {
                    target = target.shadowRoot.elementFromPoint(touchEvt.clientX, touchEvt.clientY);
                    if (target === parent) break;
                    parent = target;
                }

                dragEl.parentNode[expando]._isOutsideThisEl(target);

                if (parent) {
                    do {
                        if (parent[expando]) {
                            var inserted = void 0;
                            inserted = parent[expando]._onDragOver({
                                clientX: touchEvt.clientX,
                                clientY: touchEvt.clientY,
                                target: target,
                                rootEl: parent
                            });

                            if (inserted && !this.options.dragoverBubble) {
                                break;
                            }
                        }

                        target = parent; // store last element
                    }
                        /* jshint boss:true */
                    while (parent = parent.parentNode);
                }

                _unhideGhostForTarget();
            }
        },
        _onTouchMove: function _onTouchMove(
            /**TouchEvent*/
            evt) {
            if (tapEvt) {
                var options = this.options,
                    fallbackTolerance = options.fallbackTolerance,
                    fallbackOffset = options.fallbackOffset,
                    touch = evt.touches ? evt.touches[0] : evt,
                    ghostMatrix = ghostEl && matrix(ghostEl),
                    scaleX = ghostEl && ghostMatrix && ghostMatrix.a,
                    scaleY = ghostEl && ghostMatrix && ghostMatrix.d,
                    relativeScrollOffset = PositionGhostAbsolutely && ghostRelativeParent && getRelativeScrollOffset(ghostRelativeParent),
                    dx = (touch.clientX - tapEvt.clientX + fallbackOffset.x) / (scaleX || 1) + (relativeScrollOffset ? relativeScrollOffset[0] - ghostRelativeParentInitialScroll[0] : 0) / (scaleX || 1),
                    dy = (touch.clientY - tapEvt.clientY + fallbackOffset.y) / (scaleY || 1) + (relativeScrollOffset ? relativeScrollOffset[1] - ghostRelativeParentInitialScroll[1] : 0) / (scaleY || 1); // only set the status to dragging, when we are actually dragging

                if (!Sortable.active && !awaitingDragStarted) {
                    if (fallbackTolerance && Math.max(Math.abs(touch.clientX - this._lastX), Math.abs(touch.clientY - this._lastY)) < fallbackTolerance) {
                        return;
                    }

                    this._onDragStart(evt, true);
                }

                if (ghostEl) {
                    if (ghostMatrix) {
                        ghostMatrix.e += dx - (lastDx || 0);
                        ghostMatrix.f += dy - (lastDy || 0);
                    } else {
                        ghostMatrix = {
                            a: 1,
                            b: 0,
                            c: 0,
                            d: 1,
                            e: dx,
                            f: dy
                        };
                    }

                    var cssMatrix = "matrix(".concat(ghostMatrix.a, ",").concat(ghostMatrix.b, ",").concat(ghostMatrix.c, ",").concat(ghostMatrix.d, ",").concat(ghostMatrix.e, ",").concat(ghostMatrix.f, ")");
                    css(ghostEl, 'webkitTransform', cssMatrix);
                    css(ghostEl, 'mozTransform', cssMatrix);
                    css(ghostEl, 'msTransform', cssMatrix);
                    css(ghostEl, 'transform', cssMatrix);
                    lastDx = dx;
                    lastDy = dy;
                    touchEvt = touch;
                }

                evt.cancelable && evt.preventDefault();
            }
        },
        _appendGhost: function _appendGhost() {
            // Bug if using scale(): https://stackoverflow.com/questions/2637058
            // Not being adjusted for
            if (!ghostEl) {
                var container = this.options.fallbackOnBody ? document.body : rootEl,
                    rect = getRect(dragEl, true, PositionGhostAbsolutely, true, container),
                    options = this.options; // Position absolutely

                if (PositionGhostAbsolutely) {
                    // Get relatively positioned parent
                    ghostRelativeParent = container;

                    while (css(ghostRelativeParent, 'position') === 'static' && css(ghostRelativeParent, 'transform') === 'none' && ghostRelativeParent !== document) {
                        ghostRelativeParent = ghostRelativeParent.parentNode;
                    }

                    if (ghostRelativeParent !== document.body && ghostRelativeParent !== document.documentElement) {
                        if (ghostRelativeParent === document) ghostRelativeParent = getWindowScrollingElement();
                        rect.top += ghostRelativeParent.scrollTop;
                        rect.left += ghostRelativeParent.scrollLeft;
                    } else {
                        ghostRelativeParent = getWindowScrollingElement();
                    }

                    ghostRelativeParentInitialScroll = getRelativeScrollOffset(ghostRelativeParent);
                }

                ghostEl = dragEl.cloneNode(true);
                toggleClass(ghostEl, options.ghostClass, false);
                toggleClass(ghostEl, options.fallbackClass, true);
                toggleClass(ghostEl, options.dragClass, true);
                css(ghostEl, 'transition', '');
                css(ghostEl, 'transform', '');
                css(ghostEl, 'box-sizing', 'border-box');
                css(ghostEl, 'margin', 0);
                css(ghostEl, 'top', rect.top);
                css(ghostEl, 'left', rect.left);
                css(ghostEl, 'width', rect.width);
                css(ghostEl, 'height', rect.height);
                css(ghostEl, 'opacity', '0.8');
                css(ghostEl, 'position', PositionGhostAbsolutely ? 'absolute' : 'fixed');
                css(ghostEl, 'zIndex', '100000');
                css(ghostEl, 'pointerEvents', 'none');
                Sortable.ghost = ghostEl;
                container.appendChild(ghostEl); // Set transform-origin

                css(ghostEl, 'transform-origin', tapDistanceLeft / parseInt(ghostEl.style.width) * 100 + '% ' + tapDistanceTop / parseInt(ghostEl.style.height) * 100 + '%');
            }
        },
        _onDragStart: function _onDragStart(
            /**Event*/
            evt,
            /**boolean*/
            fallback) {
            var _this = this;

            var dataTransfer = evt.dataTransfer;
            var options = _this.options;
            pluginEvent('dragStart', this, {
                evt: evt
            });

            if (Sortable.eventCanceled) {
                this._onDrop();

                return;
            }

            pluginEvent('setupClone', this);

            if (!Sortable.eventCanceled) {
                cloneEl = clone(dragEl);
                cloneEl.draggable = false;
                cloneEl.style['will-change'] = '';

                this._hideClone();

                toggleClass(cloneEl, this.options.chosenClass, false);
                Sortable.clone = cloneEl;
            } // #1143: IFrame support workaround


            _this.cloneId = _nextTick(function () {
                pluginEvent('clone', _this);
                if (Sortable.eventCanceled) return;

                if (!_this.options.removeCloneOnHide) {
                    rootEl.insertBefore(cloneEl, dragEl);
                }

                _this._hideClone();

                _dispatchEvent({
                    sortable: _this,
                    name: 'clone'
                });
            });
            !fallback && toggleClass(dragEl, options.dragClass, true); // Set proper drop events

            if (fallback) {
                ignoreNextClick = true;
                _this._loopId = setInterval(_this._emulateDragOver, 50);
            } else {
                // Undo what was set in _prepareDragStart before drag started
                off(document, 'mouseup', _this._onDrop);
                off(document, 'touchend', _this._onDrop);
                off(document, 'touchcancel', _this._onDrop);

                if (dataTransfer) {
                    dataTransfer.effectAllowed = 'move';
                    options.setData && options.setData.call(_this, dataTransfer, dragEl);
                }

                on(document, 'drop', _this); // #1276 fix:

                css(dragEl, 'transform', 'translateZ(0)');
            }

            awaitingDragStarted = true;
            _this._dragStartId = _nextTick(_this._dragStarted.bind(_this, fallback, evt));
            on(document, 'selectstart', _this);
            moved = true;

            if (Safari) {
                css(document.body, 'user-select', 'none');
            }
        },
        // Returns true - if no further action is needed (either inserted or another condition)
        _onDragOver: function _onDragOver(
            /**Event*/
            evt) {
            var el = this.el,
                target = evt.target,
                dragRect,
                targetRect,
                revert,
                options = this.options,
                group = options.group,
                activeSortable = Sortable.active,
                isOwner = activeGroup === group,
                canSort = options.sort,
                fromSortable = putSortable || activeSortable,
                vertical,
                _this = this,
                completedFired = false;

            if (_silent) return;

            function dragOverEvent(name, extra) {
                pluginEvent(name, _this, _objectSpread({
                    evt: evt,
                    isOwner: isOwner,
                    axis: vertical ? 'vertical' : 'horizontal',
                    revert: revert,
                    dragRect: dragRect,
                    targetRect: targetRect,
                    canSort: canSort,
                    fromSortable: fromSortable,
                    target: target,
                    completed: completed,
                    onMove: function onMove(target, after) {
                        return _onMove(rootEl, el, dragEl, dragRect, target, getRect(target), evt, after);
                    },
                    changed: changed
                }, extra));
            } // Capture animation state


            function capture() {
                dragOverEvent('dragOverAnimationCapture');

                _this.captureAnimationState();

                if (_this !== fromSortable) {
                    fromSortable.captureAnimationState();
                }
            } // Return invocation when dragEl is inserted (or completed)


            function completed(insertion) {
                dragOverEvent('dragOverCompleted', {
                    insertion: insertion
                });

                if (insertion) {
                    // Clones must be hidden before folding animation to capture dragRectAbsolute properly
                    if (isOwner) {
                        activeSortable._hideClone();
                    } else {
                        activeSortable._showClone(_this);
                    }

                    if (_this !== fromSortable) {
                        // Set ghost class to new sortable's ghost class
                        toggleClass(dragEl, putSortable ? putSortable.options.ghostClass : activeSortable.options.ghostClass, false);
                        toggleClass(dragEl, options.ghostClass, true);
                    }

                    if (putSortable !== _this && _this !== Sortable.active) {
                        putSortable = _this;
                    } else if (_this === Sortable.active && putSortable) {
                        putSortable = null;
                    } // Animation


                    if (fromSortable === _this) {
                        _this._ignoreWhileAnimating = target;
                    }

                    _this.animateAll(function () {
                        dragOverEvent('dragOverAnimationComplete');
                        _this._ignoreWhileAnimating = null;
                    });

                    if (_this !== fromSortable) {
                        fromSortable.animateAll();
                        fromSortable._ignoreWhileAnimating = null;
                    }
                } // Null lastTarget if it is not inside a previously swapped element


                if (target === dragEl && !dragEl.animated || target === el && !target.animated) {
                    lastTarget = null;
                } // no bubbling and not fallback


                if (!options.dragoverBubble && !evt.rootEl && target !== document) {
                    dragEl.parentNode[expando]._isOutsideThisEl(evt.target); // Do not detect for empty insert if already inserted


                    !insertion && nearestEmptyInsertDetectEvent(evt);
                }

                !options.dragoverBubble && evt.stopPropagation && evt.stopPropagation();
                return completedFired = true;
            } // Call when dragEl has been inserted


            function changed() {
                newIndex = index(dragEl);
                newDraggableIndex = index(dragEl, options.draggable);

                _dispatchEvent({
                    sortable: _this,
                    name: 'change',
                    toEl: el,
                    newIndex: newIndex,
                    newDraggableIndex: newDraggableIndex,
                    originalEvent: evt
                });
            }

            if (evt.preventDefault !== void 0) {
                evt.cancelable && evt.preventDefault();
            }

            target = closest(target, options.draggable, el, true);
            dragOverEvent('dragOver');
            if (Sortable.eventCanceled) return completedFired;

            if (dragEl.contains(evt.target) || target.animated && target.animatingX && target.animatingY || _this._ignoreWhileAnimating === target) {
                return completed(false);
            }

            ignoreNextClick = false;

            if (activeSortable && !options.disabled && (isOwner ? canSort || (revert = !rootEl.contains(dragEl)) // Reverting item into the original list
                    : putSortable === this || (this.lastPutMode = activeGroup.checkPull(this, activeSortable, dragEl, evt)) && group.checkPut(this, activeSortable, dragEl, evt))) {
                vertical = this._getDirection(evt, target) === 'vertical';
                dragRect = getRect(dragEl);
                dragOverEvent('dragOverValid');
                if (Sortable.eventCanceled) return completedFired;

                if (revert) {
                    parentEl = rootEl; // actualization

                    capture();

                    this._hideClone();

                    dragOverEvent('revert');

                    if (!Sortable.eventCanceled) {
                        if (nextEl) {
                            rootEl.insertBefore(dragEl, nextEl);
                        } else {
                            rootEl.appendChild(dragEl);
                        }
                    }

                    return completed(true);
                }

                var elLastChild = lastChild(el, options.draggable);

                if (!elLastChild || _ghostIsLast(evt, vertical, this) && !elLastChild.animated) {
                    // If already at end of list: Do not insert
                    if (elLastChild === dragEl) {
                        return completed(false);
                    } // assign target only if condition is true


                    if (elLastChild && el === evt.target) {
                        target = elLastChild;
                    }

                    if (target) {
                        targetRect = getRect(target);
                    }

                    if (_onMove(rootEl, el, dragEl, dragRect, target, targetRect, evt, !!target) !== false) {
                        capture();
                        el.appendChild(dragEl);
                        parentEl = el; // actualization

                        changed();
                        return completed(true);
                    }
                } else if (target.parentNode === el) {
                    targetRect = getRect(target);
                    var direction = 0,
                        targetBeforeFirstSwap,
                        differentLevel = dragEl.parentNode !== el,
                        differentRowCol = !_dragElInRowColumn(dragEl.animated && dragEl.toRect || dragRect, target.animated && target.toRect || targetRect, vertical),
                        side1 = vertical ? 'top' : 'left',
                        scrolledPastTop = isScrolledPast(target, 'top', 'top') || isScrolledPast(dragEl, 'top', 'top'),
                        scrollBefore = scrolledPastTop ? scrolledPastTop.scrollTop : void 0;

                    if (lastTarget !== target) {
                        targetBeforeFirstSwap = targetRect[side1];
                        pastFirstInvertThresh = false;
                        isCircumstantialInvert = !differentRowCol && options.invertSwap || differentLevel;
                    }

                    direction = _getSwapDirection(evt, target, targetRect, vertical, differentRowCol ? 1 : options.swapThreshold, options.invertedSwapThreshold == null ? options.swapThreshold : options.invertedSwapThreshold, isCircumstantialInvert, lastTarget === target);
                    var sibling;

                    if (direction !== 0) {
                        // Check if target is beside dragEl in respective direction (ignoring hidden elements)
                        var dragIndex = index(dragEl);

                        do {
                            dragIndex -= direction;
                            sibling = parentEl.children[dragIndex];
                        } while (sibling && (css(sibling, 'display') === 'none' || sibling === ghostEl));
                    } // If dragEl is already beside target: Do not insert


                    if (direction === 0 || sibling === target) {
                        return completed(false);
                    }

                    lastTarget = target;
                    lastDirection = direction;
                    var nextSibling = target.nextElementSibling,
                        after = false;
                    after = direction === 1;

                    var moveVector = _onMove(rootEl, el, dragEl, dragRect, target, targetRect, evt, after);

                    if (moveVector !== false) {
                        if (moveVector === 1 || moveVector === -1) {
                            after = moveVector === 1;
                        }

                        _silent = true;
                        setTimeout(_unsilent, 30);
                        capture();

                        if (after && !nextSibling) {
                            el.appendChild(dragEl);
                        } else {
                            target.parentNode.insertBefore(dragEl, after ? nextSibling : target);
                        } // Undo chrome's scroll adjustment (has no effect on other browsers)


                        if (scrolledPastTop) {
                            scrollBy(scrolledPastTop, 0, scrollBefore - scrolledPastTop.scrollTop);
                        }

                        parentEl = dragEl.parentNode; // actualization
                        // must be done before animation

                        if (targetBeforeFirstSwap !== undefined && !isCircumstantialInvert) {
                            targetMoveDistance = Math.abs(targetBeforeFirstSwap - getRect(target)[side1]);
                        }

                        changed();
                        return completed(true);
                    }
                }

                if (el.contains(dragEl)) {
                    return completed(false);
                }
            }

            return false;
        },
        _ignoreWhileAnimating: null,
        _offMoveEvents: function _offMoveEvents() {
            off(document, 'mousemove', this._onTouchMove);
            off(document, 'touchmove', this._onTouchMove);
            off(document, 'pointermove', this._onTouchMove);
            off(document, 'dragover', nearestEmptyInsertDetectEvent);
            off(document, 'mousemove', nearestEmptyInsertDetectEvent);
            off(document, 'touchmove', nearestEmptyInsertDetectEvent);
        },
        _offUpEvents: function _offUpEvents() {
            var ownerDocument = this.el.ownerDocument;
            off(ownerDocument, 'mouseup', this._onDrop);
            off(ownerDocument, 'touchend', this._onDrop);
            off(ownerDocument, 'pointerup', this._onDrop);
            off(ownerDocument, 'touchcancel', this._onDrop);
            off(document, 'selectstart', this);
        },
        _onDrop: function _onDrop(
            /**Event*/
            evt) {
            var el = this.el,
                options = this.options; // Get the index of the dragged element within its parent

            newIndex = index(dragEl);
            newDraggableIndex = index(dragEl, options.draggable);
            pluginEvent('drop', this, {
                evt: evt
            });
            parentEl = dragEl && dragEl.parentNode; // Get again after plugin event

            newIndex = index(dragEl);
            newDraggableIndex = index(dragEl, options.draggable);

            if (Sortable.eventCanceled) {
                this._nulling();

                return;
            }

            awaitingDragStarted = false;
            isCircumstantialInvert = false;
            pastFirstInvertThresh = false;
            clearInterval(this._loopId);
            clearTimeout(this._dragStartTimer);

            _cancelNextTick(this.cloneId);

            _cancelNextTick(this._dragStartId); // Unbind events


            if (this.nativeDraggable) {
                off(document, 'drop', this);
                off(el, 'dragstart', this._onDragStart);
            }

            this._offMoveEvents();

            this._offUpEvents();

            if (Safari) {
                css(document.body, 'user-select', '');
            }

            if (evt) {
                if (moved) {
                    evt.cancelable && evt.preventDefault();
                    !options.dropBubble && evt.stopPropagation();
                }

                ghostEl && ghostEl.parentNode && ghostEl.parentNode.removeChild(ghostEl);

                if (rootEl === parentEl || putSortable && putSortable.lastPutMode !== 'clone') {
                    // Remove clone(s)
                    cloneEl && cloneEl.parentNode && cloneEl.parentNode.removeChild(cloneEl);
                }

                if (dragEl) {
                    if (this.nativeDraggable) {
                        off(dragEl, 'dragend', this);
                    }

                    _disableDraggable(dragEl);

                    dragEl.style['will-change'] = ''; // Remove classes
                    // ghostClass is added in dragStarted

                    if (moved && !awaitingDragStarted) {
                        toggleClass(dragEl, putSortable ? putSortable.options.ghostClass : this.options.ghostClass, false);
                    }

                    toggleClass(dragEl, this.options.chosenClass, false); // Drag stop event

                    _dispatchEvent({
                        sortable: this,
                        name: 'unchoose',
                        toEl: parentEl,
                        newIndex: null,
                        newDraggableIndex: null,
                        originalEvent: evt
                    });

                    if (rootEl !== parentEl) {
                        if (newIndex >= 0) {
                            // Add event
                            _dispatchEvent({
                                rootEl: parentEl,
                                name: 'add',
                                toEl: parentEl,
                                fromEl: rootEl,
                                originalEvent: evt
                            }); // Remove event


                            _dispatchEvent({
                                sortable: this,
                                name: 'remove',
                                toEl: parentEl,
                                originalEvent: evt
                            }); // drag from one list and drop into another


                            _dispatchEvent({
                                rootEl: parentEl,
                                name: 'sort',
                                toEl: parentEl,
                                fromEl: rootEl,
                                originalEvent: evt
                            });

                            _dispatchEvent({
                                sortable: this,
                                name: 'sort',
                                toEl: parentEl,
                                originalEvent: evt
                            });
                        }

                        putSortable && putSortable.save();
                    } else {
                        if (newIndex !== oldIndex) {
                            if (newIndex >= 0) {
                                // drag & drop within the same list
                                _dispatchEvent({
                                    sortable: this,
                                    name: 'update',
                                    toEl: parentEl,
                                    originalEvent: evt
                                });

                                _dispatchEvent({
                                    sortable: this,
                                    name: 'sort',
                                    toEl: parentEl,
                                    originalEvent: evt
                                });
                            }
                        }
                    }

                    if (Sortable.active) {
                        /* jshint eqnull:true */
                        if (newIndex == null || newIndex === -1) {
                            newIndex = oldIndex;
                            newDraggableIndex = oldDraggableIndex;
                        }

                        _dispatchEvent({
                            sortable: this,
                            name: 'end',
                            toEl: parentEl,
                            originalEvent: evt
                        }); // Save sorting


                        this.save();
                    }
                }
            }

            this._nulling();
        },
        _nulling: function _nulling() {
            pluginEvent('nulling', this);
            rootEl = dragEl = parentEl = ghostEl = nextEl = cloneEl = lastDownEl = cloneHidden = tapEvt = touchEvt = moved = newIndex = newDraggableIndex = oldIndex = oldDraggableIndex = lastTarget = lastDirection = putSortable = activeGroup = Sortable.dragged = Sortable.ghost = Sortable.clone = Sortable.active = null;
            savedInputChecked.forEach(function (el) {
                el.checked = true;
            });
            savedInputChecked.length = lastDx = lastDy = 0;
        },
        handleEvent: function handleEvent(
            /**Event*/
            evt) {
            switch (evt.type) {
                case 'drop':
                case 'dragend':
                    this._onDrop(evt);

                    break;

                case 'dragenter':
                case 'dragover':
                    if (dragEl) {
                        this._onDragOver(evt);

                        _globalDragOver(evt);
                    }

                    break;

                case 'selectstart':
                    evt.preventDefault();
                    break;
            }
        },

        /**
         * Serializes the item into an array of string.
         * @returns {String[]}
         */
        toArray: function toArray() {
            var order = [],
                el,
                children = this.el.children,
                i = 0,
                n = children.length,
                options = this.options;

            for (; i < n; i++) {
                el = children[i];

                if (closest(el, options.draggable, this.el, false)) {
                    order.push(el.getAttribute(options.dataIdAttr) || _generateId(el));
                }
            }

            return order;
        },

        /**
         * Sorts the elements according to the array.
         * @param  {String[]}  order  order of the items
         */
        sort: function sort(order) {
            var items = {},
                rootEl = this.el;
            this.toArray().forEach(function (id, i) {
                var el = rootEl.children[i];

                if (closest(el, this.options.draggable, rootEl, false)) {
                    items[id] = el;
                }
            }, this);
            order.forEach(function (id) {
                if (items[id]) {
                    rootEl.removeChild(items[id]);
                    rootEl.appendChild(items[id]);
                }
            });
        },

        /**
         * Save the current sorting
         */
        save: function save() {
            var store = this.options.store;
            store && store.set && store.set(this);
        },

        /**
         * For each element in the set, get the first element that matches the selector by testing the element itself and traversing up through its ancestors in the DOM tree.
         * @param   {HTMLElement}  el
         * @param   {String}       [selector]  default: `options.draggable`
         * @returns {HTMLElement|null}
         */
        closest: function closest$1(el, selector) {
            return closest(el, selector || this.options.draggable, this.el, false);
        },

        /**
         * Set/get option
         * @param   {string} name
         * @param   {*}      [value]
         * @returns {*}
         */
        option: function option(name, value) {
            var options = this.options;

            if (value === void 0) {
                return options[name];
            } else {
                var modifiedValue = PluginManager.modifyOption(this, name, value);

                if (typeof modifiedValue !== 'undefined') {
                    options[name] = modifiedValue;
                } else {
                    options[name] = value;
                }

                if (name === 'group') {
                    _prepareGroup(options);
                }
            }
        },

        /**
         * Destroy
         */
        destroy: function destroy() {
            pluginEvent('destroy', this);
            var el = this.el;
            el[expando] = null;
            off(el, 'mousedown', this._onTapStart);
            off(el, 'touchstart', this._onTapStart);
            off(el, 'pointerdown', this._onTapStart);

            if (this.nativeDraggable) {
                off(el, 'dragover', this);
                off(el, 'dragenter', this);
            } // Remove draggable attributes


            Array.prototype.forEach.call(el.querySelectorAll('[draggable]'), function (el) {
                el.removeAttribute('draggable');
            });

            this._onDrop();

            sortables.splice(sortables.indexOf(this.el), 1);
            this.el = el = null;
        },
        _hideClone: function _hideClone() {
            if (!cloneHidden) {
                pluginEvent('hideClone', this);
                if (Sortable.eventCanceled) return;
                css(cloneEl, 'display', 'none');

                if (this.options.removeCloneOnHide && cloneEl.parentNode) {
                    cloneEl.parentNode.removeChild(cloneEl);
                }

                cloneHidden = true;
            }
        },
        _showClone: function _showClone(putSortable) {
            if (putSortable.lastPutMode !== 'clone') {
                this._hideClone();

                return;
            }

            if (cloneHidden) {
                pluginEvent('showClone', this);
                if (Sortable.eventCanceled) return; // show clone at dragEl or original position

                if (rootEl.contains(dragEl) && !this.options.group.revertClone) {
                    rootEl.insertBefore(cloneEl, dragEl);
                } else if (nextEl) {
                    rootEl.insertBefore(cloneEl, nextEl);
                } else {
                    rootEl.appendChild(cloneEl);
                }

                if (this.options.group.revertClone) {
                    this.animate(dragEl, cloneEl);
                }

                css(cloneEl, 'display', '');
                cloneHidden = false;
            }
        }
    };

    function _globalDragOver(
        /**Event*/
        evt) {
        if (evt.dataTransfer) {
            evt.dataTransfer.dropEffect = 'move';
        }

        evt.cancelable && evt.preventDefault();
    }

    function _onMove(fromEl, toEl, dragEl, dragRect, targetEl, targetRect, originalEvent, willInsertAfter) {
        var evt,
            sortable = fromEl[expando],
            onMoveFn = sortable.options.onMove,
            retVal; // Support for new CustomEvent feature

        if (window.CustomEvent && !IE11OrLess && !Edge) {
            evt = new CustomEvent('move', {
                bubbles: true,
                cancelable: true
            });
        } else {
            evt = document.createEvent('Event');
            evt.initEvent('move', true, true);
        }

        evt.to = toEl;
        evt.from = fromEl;
        evt.dragged = dragEl;
        evt.draggedRect = dragRect;
        evt.related = targetEl || toEl;
        evt.relatedRect = targetRect || getRect(toEl);
        evt.willInsertAfter = willInsertAfter;
        evt.originalEvent = originalEvent;
        fromEl.dispatchEvent(evt);

        if (onMoveFn) {
            retVal = onMoveFn.call(sortable, evt, originalEvent);
        }

        return retVal;
    }

    function _disableDraggable(el) {
        el.draggable = false;
    }

    function _unsilent() {
        _silent = false;
    }

    function _ghostIsLast(evt, vertical, sortable) {
        var rect = getRect(lastChild(sortable.el, sortable.options.draggable));
        var spacer = 10;
        return vertical ? evt.clientX > rect.right + spacer || evt.clientX <= rect.right && evt.clientY > rect.bottom && evt.clientX >= rect.left : evt.clientX > rect.right && evt.clientY > rect.top || evt.clientX <= rect.right && evt.clientY > rect.bottom + spacer;
    }

    function _getSwapDirection(evt, target, targetRect, vertical, swapThreshold, invertedSwapThreshold, invertSwap, isLastTarget) {
        var mouseOnAxis = vertical ? evt.clientY : evt.clientX,
            targetLength = vertical ? targetRect.height : targetRect.width,
            targetS1 = vertical ? targetRect.top : targetRect.left,
            targetS2 = vertical ? targetRect.bottom : targetRect.right,
            invert = false;

        if (!invertSwap) {
            // Never invert or create dragEl shadow when target movemenet causes mouse to move past the end of regular swapThreshold
            if (isLastTarget && targetMoveDistance < targetLength * swapThreshold) {
                // multiplied only by swapThreshold because mouse will already be inside target by (1 - threshold) * targetLength / 2
                // check if past first invert threshold on side opposite of lastDirection
                if (!pastFirstInvertThresh && (lastDirection === 1 ? mouseOnAxis > targetS1 + targetLength * invertedSwapThreshold / 2 : mouseOnAxis < targetS2 - targetLength * invertedSwapThreshold / 2)) {
                    // past first invert threshold, do not restrict inverted threshold to dragEl shadow
                    pastFirstInvertThresh = true;
                }

                if (!pastFirstInvertThresh) {
                    // dragEl shadow (target move distance shadow)
                    if (lastDirection === 1 ? mouseOnAxis < targetS1 + targetMoveDistance // over dragEl shadow
                            : mouseOnAxis > targetS2 - targetMoveDistance) {
                        return -lastDirection;
                    }
                } else {
                    invert = true;
                }
            } else {
                // Regular
                if (mouseOnAxis > targetS1 + targetLength * (1 - swapThreshold) / 2 && mouseOnAxis < targetS2 - targetLength * (1 - swapThreshold) / 2) {
                    return _getInsertDirection(target);
                }
            }
        }

        invert = invert || invertSwap;

        if (invert) {
            // Invert of regular
            if (mouseOnAxis < targetS1 + targetLength * invertedSwapThreshold / 2 || mouseOnAxis > targetS2 - targetLength * invertedSwapThreshold / 2) {
                return mouseOnAxis > targetS1 + targetLength / 2 ? 1 : -1;
            }
        }

        return 0;
    }
    /**
     * Gets the direction dragEl must be swapped relative to target in order to make it
     * seem that dragEl has been "inserted" into that element's position
     * @param  {HTMLElement} target       The target whose position dragEl is being inserted at
     * @return {Number}                   Direction dragEl must be swapped
     */


    function _getInsertDirection(target) {
        if (index(dragEl) < index(target)) {
            return 1;
        } else {
            return -1;
        }
    }
    /**
     * Generate id
     * @param   {HTMLElement} el
     * @returns {String}
     * @private
     */


    function _generateId(el) {
        var str = el.tagName + el.className + el.src + el.href + el.textContent,
            i = str.length,
            sum = 0;

        while (i--) {
            sum += str.charCodeAt(i);
        }

        return sum.toString(36);
    }

    function _saveInputCheckedState(root) {
        savedInputChecked.length = 0;
        var inputs = root.getElementsByTagName('input');
        var idx = inputs.length;

        while (idx--) {
            var el = inputs[idx];
            el.checked && savedInputChecked.push(el);
        }
    }

    function _nextTick(fn) {
        return setTimeout(fn, 0);
    }

    function _cancelNextTick(id) {
        return clearTimeout(id);
    } // Fixed #973:


    if (documentExists) {
        on(document, 'touchmove', function (evt) {
            if ((Sortable.active || awaitingDragStarted) && evt.cancelable) {
                evt.preventDefault();
            }
        });
    } // Export utils


    Sortable.utils = {
        on: on,
        off: off,
        css: css,
        find: find,
        is: function is(el, selector) {
            return !!closest(el, selector, el, false);
        },
        extend: extend,
        throttle: throttle,
        closest: closest,
        toggleClass: toggleClass,
        clone: clone,
        index: index,
        nextTick: _nextTick,
        cancelNextTick: _cancelNextTick,
        detectDirection: _detectDirection,
        getChild: getChild
    };
    /**
     * Get the Sortable instance of an element
     * @param  {HTMLElement} element The element
     * @return {Sortable|undefined}         The instance of Sortable
     */

    Sortable.get = function (element) {
        return element[expando];
    };
    /**
     * Mount a plugin to Sortable
     * @param  {...SortablePlugin|SortablePlugin[]} plugins       Plugins being mounted
     */


    Sortable.mount = function () {
        for (var _len = arguments.length, plugins = new Array(_len), _key = 0; _key < _len; _key++) {
            plugins[_key] = arguments[_key];
        }

        if (plugins[0].constructor === Array) plugins = plugins[0];
        plugins.forEach(function (plugin) {
            if (!plugin.prototype || !plugin.prototype.constructor) {
                throw "Sortable: Mounted plugin must be a constructor function, not ".concat({}.toString.call(plugin));
            }

            if (plugin.utils) Sortable.utils = _objectSpread({}, Sortable.utils, plugin.utils);
            PluginManager.mount(plugin);
        });
    };
    /**
     * Create sortable instance
     * @param {HTMLElement}  el
     * @param {Object}      [options]
     */


    Sortable.create = function (el, options) {
        return new Sortable(el, options);
    }; // Export


    Sortable.version = version;

    var autoScrolls = [],
        scrollEl,
        scrollRootEl,
        scrolling = false,
        lastAutoScrollX,
        lastAutoScrollY,
        touchEvt$1,
        pointerElemChangedInterval;

    function AutoScrollPlugin() {
        function AutoScroll() {
            this.defaults = {
                scroll: true,
                scrollSensitivity: 30,
                scrollSpeed: 10,
                bubbleScroll: true
            }; // Bind all private methods

            for (var fn in this) {
                if (fn.charAt(0) === '_' && typeof this[fn] === 'function') {
                    this[fn] = this[fn].bind(this);
                }
            }
        }

        AutoScroll.prototype = {
            dragStarted: function dragStarted(_ref) {
                var originalEvent = _ref.originalEvent;

                if (this.sortable.nativeDraggable) {
                    on(document, 'dragover', this._handleAutoScroll);
                } else {
                    if (this.options.supportPointer) {
                        on(document, 'pointermove', this._handleFallbackAutoScroll);
                    } else if (originalEvent.touches) {
                        on(document, 'touchmove', this._handleFallbackAutoScroll);
                    } else {
                        on(document, 'mousemove', this._handleFallbackAutoScroll);
                    }
                }
            },
            dragOverCompleted: function dragOverCompleted(_ref2) {
                var originalEvent = _ref2.originalEvent;

                // For when bubbling is canceled and using fallback (fallback 'touchmove' always reached)
                if (!this.options.dragOverBubble && !originalEvent.rootEl) {
                    this._handleAutoScroll(originalEvent);
                }
            },
            drop: function drop() {
                if (this.sortable.nativeDraggable) {
                    off(document, 'dragover', this._handleAutoScroll);
                } else {
                    off(document, 'pointermove', this._handleFallbackAutoScroll);
                    off(document, 'touchmove', this._handleFallbackAutoScroll);
                    off(document, 'mousemove', this._handleFallbackAutoScroll);
                }

                clearPointerElemChangedInterval();
                clearAutoScrolls();
                cancelThrottle();
            },
            nulling: function nulling() {
                touchEvt$1 = scrollRootEl = scrollEl = scrolling = pointerElemChangedInterval = lastAutoScrollX = lastAutoScrollY = null;
                autoScrolls.length = 0;
            },
            _handleFallbackAutoScroll: function _handleFallbackAutoScroll(evt) {
                this._handleAutoScroll(evt, true);
            },
            _handleAutoScroll: function _handleAutoScroll(evt, fallback) {
                var _this = this;

                var x = (evt.touches ? evt.touches[0] : evt).clientX,
                    y = (evt.touches ? evt.touches[0] : evt).clientY,
                    elem = document.elementFromPoint(x, y);
                touchEvt$1 = evt; // IE does not seem to have native autoscroll,
                // Edge's autoscroll seems too conditional,
                // MACOS Safari does not have autoscroll,
                // Firefox and Chrome are good

                if (fallback || Edge || IE11OrLess || Safari) {
                    autoScroll(evt, this.options, elem, fallback); // Listener for pointer element change

                    var ogElemScroller = getParentAutoScrollElement(elem, true);

                    if (scrolling && (!pointerElemChangedInterval || x !== lastAutoScrollX || y !== lastAutoScrollY)) {
                        pointerElemChangedInterval && clearPointerElemChangedInterval(); // Detect for pointer elem change, emulating native DnD behaviour

                        pointerElemChangedInterval = setInterval(function () {
                            var newElem = getParentAutoScrollElement(document.elementFromPoint(x, y), true);

                            if (newElem !== ogElemScroller) {
                                ogElemScroller = newElem;
                                clearAutoScrolls();
                            }

                            autoScroll(evt, _this.options, newElem, fallback);
                        }, 10);
                        lastAutoScrollX = x;
                        lastAutoScrollY = y;
                    }
                } else {
                    // if DnD is enabled (and browser has good autoscrolling), first autoscroll will already scroll, so get parent autoscroll of first autoscroll
                    if (!this.options.bubbleScroll || getParentAutoScrollElement(elem, true) === getWindowScrollingElement()) {
                        clearAutoScrolls();
                        return;
                    }

                    autoScroll(evt, this.options, getParentAutoScrollElement(elem, false), false);
                }
            }
        };
        return _extends(AutoScroll, {
            pluginName: 'scroll',
            initializeByDefault: true
        });
    }

    function clearAutoScrolls() {
        autoScrolls.forEach(function (autoScroll) {
            clearInterval(autoScroll.pid);
        });
        autoScrolls = [];
    }

    function clearPointerElemChangedInterval() {
        clearInterval(pointerElemChangedInterval);
    }

    var autoScroll = throttle(function (evt, options, rootEl, isFallback) {
        // Bug: https://bugzilla.mozilla.org/show_bug.cgi?id=505521
        if (!options.scroll) return;
        var x = (evt.touches ? evt.touches[0] : evt).clientX,
            y = (evt.touches ? evt.touches[0] : evt).clientY,
            sens = options.scrollSensitivity,
            speed = options.scrollSpeed,
            winScroller = getWindowScrollingElement();
        var scrollThisInstance = false,
            scrollCustomFn; // New scroll root, set scrollEl

        if (scrollRootEl !== rootEl) {
            scrollRootEl = rootEl;
            clearAutoScrolls();
            scrollEl = options.scroll;
            scrollCustomFn = options.scrollFn;

            if (scrollEl === true) {
                scrollEl = getParentAutoScrollElement(rootEl, true);
            }
        }

        var layersOut = 0;
        var currentParent = scrollEl;

        do {
            var el = currentParent,
                rect = getRect(el),
                top = rect.top,
                bottom = rect.bottom,
                left = rect.left,
                right = rect.right,
                width = rect.width,
                height = rect.height,
                canScrollX = void 0,
                canScrollY = void 0,
                scrollWidth = el.scrollWidth,
                scrollHeight = el.scrollHeight,
                elCSS = css(el),
                scrollPosX = el.scrollLeft,
                scrollPosY = el.scrollTop;

            if (el === winScroller) {
                canScrollX = width < scrollWidth && (elCSS.overflowX === 'auto' || elCSS.overflowX === 'scroll' || elCSS.overflowX === 'visible');
                canScrollY = height < scrollHeight && (elCSS.overflowY === 'auto' || elCSS.overflowY === 'scroll' || elCSS.overflowY === 'visible');
            } else {
                canScrollX = width < scrollWidth && (elCSS.overflowX === 'auto' || elCSS.overflowX === 'scroll');
                canScrollY = height < scrollHeight && (elCSS.overflowY === 'auto' || elCSS.overflowY === 'scroll');
            }

            var vx = canScrollX && (Math.abs(right - x) <= sens && scrollPosX + width < scrollWidth) - (Math.abs(left - x) <= sens && !!scrollPosX);
            var vy = canScrollY && (Math.abs(bottom - y) <= sens && scrollPosY + height < scrollHeight) - (Math.abs(top - y) <= sens && !!scrollPosY);

            if (!autoScrolls[layersOut]) {
                for (var i = 0; i <= layersOut; i++) {
                    if (!autoScrolls[i]) {
                        autoScrolls[i] = {};
                    }
                }
            }

            if (autoScrolls[layersOut].vx != vx || autoScrolls[layersOut].vy != vy || autoScrolls[layersOut].el !== el) {
                autoScrolls[layersOut].el = el;
                autoScrolls[layersOut].vx = vx;
                autoScrolls[layersOut].vy = vy;
                clearInterval(autoScrolls[layersOut].pid);

                if (vx != 0 || vy != 0) {
                    scrollThisInstance = true;
                    /* jshint loopfunc:true */

                    autoScrolls[layersOut].pid = setInterval(function () {
                        // emulate drag over during autoscroll (fallback), emulating native DnD behaviour
                        if (isFallback && this.layer === 0) {
                            Sortable.active._onTouchMove(touchEvt$1); // To move ghost if it is positioned absolutely

                        }

                        var scrollOffsetY = autoScrolls[this.layer].vy ? autoScrolls[this.layer].vy * speed : 0;
                        var scrollOffsetX = autoScrolls[this.layer].vx ? autoScrolls[this.layer].vx * speed : 0;

                        if (typeof scrollCustomFn === 'function') {
                            if (scrollCustomFn.call(Sortable.dragged.parentNode[expando], scrollOffsetX, scrollOffsetY, evt, touchEvt$1, autoScrolls[this.layer].el) !== 'continue') {
                                return;
                            }
                        }

                        scrollBy(autoScrolls[this.layer].el, scrollOffsetX, scrollOffsetY);
                    }.bind({
                        layer: layersOut
                    }), 24);
                }
            }

            layersOut++;
        } while (options.bubbleScroll && currentParent !== winScroller && (currentParent = getParentAutoScrollElement(currentParent, false)));

        scrolling = scrollThisInstance; // in case another function catches scrolling as false in between when it is not
    }, 30);

    var drop = function drop(_ref) {
        var originalEvent = _ref.originalEvent,
            putSortable = _ref.putSortable,
            dragEl = _ref.dragEl,
            activeSortable = _ref.activeSortable,
            dispatchSortableEvent = _ref.dispatchSortableEvent,
            hideGhostForTarget = _ref.hideGhostForTarget,
            unhideGhostForTarget = _ref.unhideGhostForTarget;
        if (!originalEvent) return;
        var toSortable = putSortable || activeSortable;
        hideGhostForTarget();
        var touch = originalEvent.changedTouches && originalEvent.changedTouches.length ? originalEvent.changedTouches[0] : originalEvent;
        var target = document.elementFromPoint(touch.clientX, touch.clientY);
        unhideGhostForTarget();

        if (toSortable && !toSortable.el.contains(target)) {
            dispatchSortableEvent('spill');
            this.onSpill({
                dragEl: dragEl,
                putSortable: putSortable
            });
        }
    };

    function Revert() {}

    Revert.prototype = {
        startIndex: null,
        dragStart: function dragStart(_ref2) {
            var oldDraggableIndex = _ref2.oldDraggableIndex;
            this.startIndex = oldDraggableIndex;
        },
        onSpill: function onSpill(_ref3) {
            var dragEl = _ref3.dragEl,
                putSortable = _ref3.putSortable;
            this.sortable.captureAnimationState();

            if (putSortable) {
                putSortable.captureAnimationState();
            }

            var nextSibling = getChild(this.sortable.el, this.startIndex, this.options);

            if (nextSibling) {
                this.sortable.el.insertBefore(dragEl, nextSibling);
            } else {
                this.sortable.el.appendChild(dragEl);
            }

            this.sortable.animateAll();

            if (putSortable) {
                putSortable.animateAll();
            }
        },
        drop: drop
    };

    _extends(Revert, {
        pluginName: 'revertOnSpill'
    });

    function Remove() {}

    Remove.prototype = {
        onSpill: function onSpill(_ref4) {
            var dragEl = _ref4.dragEl,
                putSortable = _ref4.putSortable;
            var parentSortable = putSortable || this.sortable;
            parentSortable.captureAnimationState();
            dragEl.parentNode && dragEl.parentNode.removeChild(dragEl);
            parentSortable.animateAll();
        },
        drop: drop
    };

    _extends(Remove, {
        pluginName: 'removeOnSpill'
    });

    var lastSwapEl;

    function SwapPlugin() {
        function Swap() {
            this.defaults = {
                swapClass: 'sortable-swap-highlight'
            };
        }

        Swap.prototype = {
            dragStart: function dragStart(_ref) {
                var dragEl = _ref.dragEl;
                lastSwapEl = dragEl;
            },
            dragOverValid: function dragOverValid(_ref2) {
                var completed = _ref2.completed,
                    target = _ref2.target,
                    onMove = _ref2.onMove,
                    activeSortable = _ref2.activeSortable,
                    changed = _ref2.changed,
                    cancel = _ref2.cancel;
                if (!activeSortable.options.swap) return;
                var el = this.sortable.el,
                    options = this.options;

                if (target && target !== el) {
                    var prevSwapEl = lastSwapEl;

                    if (onMove(target) !== false) {
                        toggleClass(target, options.swapClass, true);
                        lastSwapEl = target;
                    } else {
                        lastSwapEl = null;
                    }

                    if (prevSwapEl && prevSwapEl !== lastSwapEl) {
                        toggleClass(prevSwapEl, options.swapClass, false);
                    }
                }

                changed();
                completed(true);
                cancel();
            },
            drop: function drop(_ref3) {
                var activeSortable = _ref3.activeSortable,
                    putSortable = _ref3.putSortable,
                    dragEl = _ref3.dragEl;
                var toSortable = putSortable || this.sortable;
                var options = this.options;
                lastSwapEl && toggleClass(lastSwapEl, options.swapClass, false);

                if (lastSwapEl && (options.swap || putSortable && putSortable.options.swap)) {
                    if (dragEl !== lastSwapEl) {
                        toSortable.captureAnimationState();
                        if (toSortable !== activeSortable) activeSortable.captureAnimationState();
                        swapNodes(dragEl, lastSwapEl);
                        toSortable.animateAll();
                        if (toSortable !== activeSortable) activeSortable.animateAll();
                    }
                }
            },
            nulling: function nulling() {
                lastSwapEl = null;
            }
        };
        return _extends(Swap, {
            pluginName: 'swap',
            eventProperties: function eventProperties() {
                return {
                    swapItem: lastSwapEl
                };
            }
        });
    }

    function swapNodes(n1, n2) {
        var p1 = n1.parentNode,
            p2 = n2.parentNode,
            i1,
            i2;
        if (!p1 || !p2 || p1.isEqualNode(n2) || p2.isEqualNode(n1)) return;
        i1 = index(n1);
        i2 = index(n2);

        if (p1.isEqualNode(p2) && i1 < i2) {
            i2++;
        }

        p1.insertBefore(n2, p1.children[i1]);
        p2.insertBefore(n1, p2.children[i2]);
    }

    var multiDragElements = [],
        multiDragClones = [],
        lastMultiDragSelect,
    // for selection with modifier key down (SHIFT)
        multiDragSortable,
        initialFolding = false,
    // Initial multi-drag fold when drag started
        folding = false,
    // Folding any other time
        dragStarted = false,
        dragEl$1,
        clonesFromRect,
        clonesHidden;

    function MultiDragPlugin() {
        function MultiDrag(sortable) {
            // Bind all private methods
            for (var fn in this) {
                if (fn.charAt(0) === '_' && typeof this[fn] === 'function') {
                    this[fn] = this[fn].bind(this);
                }
            }

            if (sortable.options.supportPointer) {
                on(document, 'pointerup', this._deselectMultiDrag);
            } else {
                on(document, 'mouseup', this._deselectMultiDrag);
                on(document, 'touchend', this._deselectMultiDrag);
            }

            on(document, 'keydown', this._checkKeyDown);
            on(document, 'keyup', this._checkKeyUp);
            this.defaults = {
                selectedClass: 'sortable-selected',
                multiDragKey: null,
                setData: function setData(dataTransfer, dragEl) {
                    var data = '';

                    if (multiDragElements.length && multiDragSortable === sortable) {
                        multiDragElements.forEach(function (multiDragElement, i) {
                            data += (!i ? '' : ', ') + multiDragElement.textContent;
                        });
                    } else {
                        data = dragEl.textContent;
                    }

                    dataTransfer.setData('Text', data);
                }
            };
        }

        MultiDrag.prototype = {
            multiDragKeyDown: false,
            isMultiDrag: false,
            delayStartGlobal: function delayStartGlobal(_ref) {
                var dragged = _ref.dragEl;
                dragEl$1 = dragged;
            },
            delayEnded: function delayEnded() {
                this.isMultiDrag = ~multiDragElements.indexOf(dragEl$1);
            },
            setupClone: function setupClone(_ref2) {
                var sortable = _ref2.sortable,
                    cancel = _ref2.cancel;
                if (!this.isMultiDrag) return;

                for (var i = 0; i < multiDragElements.length; i++) {
                    multiDragClones.push(clone(multiDragElements[i]));
                    multiDragClones[i].sortableIndex = multiDragElements[i].sortableIndex;
                    multiDragClones[i].draggable = false;
                    multiDragClones[i].style['will-change'] = '';
                    toggleClass(multiDragClones[i], this.options.selectedClass, false);
                    multiDragElements[i] === dragEl$1 && toggleClass(multiDragClones[i], this.options.chosenClass, false);
                }

                sortable._hideClone();

                cancel();
            },
            clone: function clone(_ref3) {
                var sortable = _ref3.sortable,
                    rootEl = _ref3.rootEl,
                    dispatchSortableEvent = _ref3.dispatchSortableEvent,
                    cancel = _ref3.cancel;
                if (!this.isMultiDrag) return;

                if (!this.options.removeCloneOnHide) {
                    if (multiDragElements.length && multiDragSortable === sortable) {
                        insertMultiDragClones(true, rootEl);
                        dispatchSortableEvent('clone');
                        cancel();
                    }
                }
            },
            showClone: function showClone(_ref4) {
                var cloneNowShown = _ref4.cloneNowShown,
                    rootEl = _ref4.rootEl,
                    cancel = _ref4.cancel;
                if (!this.isMultiDrag) return;
                insertMultiDragClones(false, rootEl);
                multiDragClones.forEach(function (clone) {
                    css(clone, 'display', '');
                });
                cloneNowShown();
                clonesHidden = false;
                cancel();
            },
            hideClone: function hideClone(_ref5) {
                var _this = this;

                var sortable = _ref5.sortable,
                    cloneNowHidden = _ref5.cloneNowHidden,
                    cancel = _ref5.cancel;
                if (!this.isMultiDrag) return;
                multiDragClones.forEach(function (clone) {
                    css(clone, 'display', 'none');

                    if (_this.options.removeCloneOnHide && clone.parentNode) {
                        clone.parentNode.removeChild(clone);
                    }
                });
                cloneNowHidden();
                clonesHidden = true;
                cancel();
            },
            dragStartGlobal: function dragStartGlobal(_ref6) {
                var sortable = _ref6.sortable;

                if (!this.isMultiDrag && multiDragSortable) {
                    multiDragSortable.multiDrag._deselectMultiDrag();
                }

                multiDragElements.forEach(function (multiDragElement) {
                    multiDragElement.sortableIndex = index(multiDragElement);
                }); // Sort multi-drag elements

                multiDragElements = multiDragElements.sort(function (a, b) {
                    return a.sortableIndex - b.sortableIndex;
                });
                dragStarted = true;
            },
            dragStarted: function dragStarted(_ref7) {
                var _this2 = this;

                var sortable = _ref7.sortable;
                if (!this.isMultiDrag) return;

                if (this.options.sort) {
                    // Capture rects,
                    // hide multi drag elements (by positioning them absolute),
                    // set multi drag elements rects to dragRect,
                    // show multi drag elements,
                    // animate to rects,
                    // unset rects & remove from DOM
                    sortable.captureAnimationState();

                    if (this.options.animation) {
                        multiDragElements.forEach(function (multiDragElement) {
                            if (multiDragElement === dragEl$1) return;
                            css(multiDragElement, 'position', 'absolute');
                        });
                        var dragRect = getRect(dragEl$1, false, true, true);
                        multiDragElements.forEach(function (multiDragElement) {
                            if (multiDragElement === dragEl$1) return;
                            setRect(multiDragElement, dragRect);
                        });
                        folding = true;
                        initialFolding = true;
                    }
                }

                sortable.animateAll(function () {
                    folding = false;
                    initialFolding = false;

                    if (_this2.options.animation) {
                        multiDragElements.forEach(function (multiDragElement) {
                            unsetRect(multiDragElement);
                        });
                    } // Remove all auxiliary multidrag items from el, if sorting enabled


                    if (_this2.options.sort) {
                        removeMultiDragElements();
                    }
                });
            },
            dragOver: function dragOver(_ref8) {
                var target = _ref8.target,
                    completed = _ref8.completed,
                    cancel = _ref8.cancel;

                if (folding && ~multiDragElements.indexOf(target)) {
                    completed(false);
                    cancel();
                }
            },
            revert: function revert(_ref9) {
                var fromSortable = _ref9.fromSortable,
                    rootEl = _ref9.rootEl,
                    sortable = _ref9.sortable,
                    dragRect = _ref9.dragRect;

                if (multiDragElements.length > 1) {
                    // Setup unfold animation
                    multiDragElements.forEach(function (multiDragElement) {
                        sortable.addAnimationState({
                            target: multiDragElement,
                            rect: folding ? getRect(multiDragElement) : dragRect
                        });
                        unsetRect(multiDragElement);
                        multiDragElement.fromRect = dragRect;
                        fromSortable.removeAnimationState(multiDragElement);
                    });
                    folding = false;
                    insertMultiDragElements(!this.options.removeCloneOnHide, rootEl);
                }
            },
            dragOverCompleted: function dragOverCompleted(_ref10) {
                var sortable = _ref10.sortable,
                    isOwner = _ref10.isOwner,
                    insertion = _ref10.insertion,
                    activeSortable = _ref10.activeSortable,
                    parentEl = _ref10.parentEl,
                    putSortable = _ref10.putSortable;
                var options = this.options;

                if (insertion) {
                    // Clones must be hidden before folding animation to capture dragRectAbsolute properly
                    if (isOwner) {
                        activeSortable._hideClone();
                    }

                    initialFolding = false; // If leaving sort:false root, or already folding - Fold to new location

                    if (options.animation && multiDragElements.length > 1 && (folding || !isOwner && !activeSortable.options.sort && !putSortable)) {
                        // Fold: Set all multi drag elements's rects to dragEl's rect when multi-drag elements are invisible
                        var dragRectAbsolute = getRect(dragEl$1, false, true, true);
                        multiDragElements.forEach(function (multiDragElement) {
                            if (multiDragElement === dragEl$1) return;
                            setRect(multiDragElement, dragRectAbsolute); // Move element(s) to end of parentEl so that it does not interfere with multi-drag clones insertion if they are inserted
                            // while folding, and so that we can capture them again because old sortable will no longer be fromSortable

                            parentEl.appendChild(multiDragElement);
                        });
                        folding = true;
                    } // Clones must be shown (and check to remove multi drags) after folding when interfering multiDragElements are moved out


                    if (!isOwner) {
                        // Only remove if not folding (folding will remove them anyways)
                        if (!folding) {
                            removeMultiDragElements();
                        }

                        if (multiDragElements.length > 1) {
                            var clonesHiddenBefore = clonesHidden;

                            activeSortable._showClone(sortable); // Unfold animation for clones if showing from hidden


                            if (activeSortable.options.animation && !clonesHidden && clonesHiddenBefore) {
                                multiDragClones.forEach(function (clone) {
                                    activeSortable.addAnimationState({
                                        target: clone,
                                        rect: clonesFromRect
                                    });
                                    clone.fromRect = clonesFromRect;
                                    clone.thisAnimationDuration = null;
                                });
                            }
                        } else {
                            activeSortable._showClone(sortable);
                        }
                    }
                }
            },
            dragOverAnimationCapture: function dragOverAnimationCapture(_ref11) {
                var dragRect = _ref11.dragRect,
                    isOwner = _ref11.isOwner,
                    activeSortable = _ref11.activeSortable;
                multiDragElements.forEach(function (multiDragElement) {
                    multiDragElement.thisAnimationDuration = null;
                });

                if (activeSortable.options.animation && !isOwner && activeSortable.multiDrag.isMultiDrag) {
                    clonesFromRect = _extends({}, dragRect);
                    var dragMatrix = matrix(dragEl$1, true);
                    clonesFromRect.top -= dragMatrix.f;
                    clonesFromRect.left -= dragMatrix.e;
                }
            },
            dragOverAnimationComplete: function dragOverAnimationComplete() {
                if (folding) {
                    folding = false;
                    removeMultiDragElements();
                }
            },
            drop: function drop(_ref12) {
                var evt = _ref12.originalEvent,
                    rootEl = _ref12.rootEl,
                    parentEl = _ref12.parentEl,
                    sortable = _ref12.sortable,
                    dispatchSortableEvent = _ref12.dispatchSortableEvent,
                    oldIndex = _ref12.oldIndex,
                    putSortable = _ref12.putSortable;
                var toSortable = putSortable || this.sortable;
                if (!evt) return;
                var options = this.options,
                    children = parentEl.children; // Multi-drag selection

                if (!dragStarted) {
                    if (options.multiDragKey && !this.multiDragKeyDown) {
                        this._deselectMultiDrag();
                    }

                    toggleClass(dragEl$1, options.selectedClass, !~multiDragElements.indexOf(dragEl$1));

                    if (!~multiDragElements.indexOf(dragEl$1)) {
                        multiDragElements.push(dragEl$1);
                        dispatchEvent({
                            sortable: sortable,
                            rootEl: rootEl,
                            name: 'select',
                            targetEl: dragEl$1,
                            originalEvt: evt
                        }); // Modifier activated, select from last to dragEl

                        if (evt.shiftKey && lastMultiDragSelect && sortable.el.contains(lastMultiDragSelect)) {
                            var lastIndex = index(lastMultiDragSelect),
                                currentIndex = index(dragEl$1);

                            if (~lastIndex && ~currentIndex && lastIndex !== currentIndex) {
                                // Must include lastMultiDragSelect (select it), in case modified selection from no selection
                                // (but previous selection existed)
                                var n, i;

                                if (currentIndex > lastIndex) {
                                    i = lastIndex;
                                    n = currentIndex;
                                } else {
                                    i = currentIndex;
                                    n = lastIndex + 1;
                                }

                                for (; i < n; i++) {
                                    if (~multiDragElements.indexOf(children[i])) continue;
                                    toggleClass(children[i], options.selectedClass, true);
                                    multiDragElements.push(children[i]);
                                    dispatchEvent({
                                        sortable: sortable,
                                        rootEl: rootEl,
                                        name: 'select',
                                        targetEl: children[i],
                                        originalEvt: evt
                                    });
                                }
                            }
                        } else {
                            lastMultiDragSelect = dragEl$1;
                        }

                        multiDragSortable = toSortable;
                    } else {
                        multiDragElements.splice(multiDragElements.indexOf(dragEl$1), 1);
                        lastMultiDragSelect = null;
                        dispatchEvent({
                            sortable: sortable,
                            rootEl: rootEl,
                            name: 'deselect',
                            targetEl: dragEl$1,
                            originalEvt: evt
                        });
                    }
                } // Multi-drag drop


                if (dragStarted && this.isMultiDrag) {
                    // Do not "unfold" after around dragEl if reverted
                    if ((parentEl[expando].options.sort || parentEl !== rootEl) && multiDragElements.length > 1) {
                        var dragRect = getRect(dragEl$1),
                            multiDragIndex = index(dragEl$1, ':not(.' + this.options.selectedClass + ')');
                        if (!initialFolding && options.animation) dragEl$1.thisAnimationDuration = null;
                        toSortable.captureAnimationState();

                        if (!initialFolding) {
                            if (options.animation) {
                                dragEl$1.fromRect = dragRect;
                                multiDragElements.forEach(function (multiDragElement) {
                                    multiDragElement.thisAnimationDuration = null;

                                    if (multiDragElement !== dragEl$1) {
                                        var rect = folding ? getRect(multiDragElement) : dragRect;
                                        multiDragElement.fromRect = rect; // Prepare unfold animation

                                        toSortable.addAnimationState({
                                            target: multiDragElement,
                                            rect: rect
                                        });
                                    }
                                });
                            } // Multi drag elements are not necessarily removed from the DOM on drop, so to reinsert
                            // properly they must all be removed


                            removeMultiDragElements();
                            multiDragElements.forEach(function (multiDragElement) {
                                if (children[multiDragIndex]) {
                                    parentEl.insertBefore(multiDragElement, children[multiDragIndex]);
                                } else {
                                    parentEl.appendChild(multiDragElement);
                                }

                                multiDragIndex++;
                            }); // If initial folding is done, the elements may have changed position because they are now
                            // unfolding around dragEl, even though dragEl may not have his index changed, so update event
                            // must be fired here as Sortable will not.

                            if (oldIndex === index(dragEl$1)) {
                                var update = false;
                                multiDragElements.forEach(function (multiDragElement) {
                                    if (multiDragElement.sortableIndex !== index(multiDragElement)) {
                                        update = true;
                                        return;
                                    }
                                });

                                if (update) {
                                    dispatchSortableEvent('update');
                                }
                            }
                        } // Must be done after capturing individual rects (scroll bar)


                        multiDragElements.forEach(function (multiDragElement) {
                            unsetRect(multiDragElement);
                        });
                        toSortable.animateAll();
                    }

                    multiDragSortable = toSortable;
                } // Remove clones if necessary


                if (rootEl === parentEl || putSortable && putSortable.lastPutMode !== 'clone') {
                    multiDragClones.forEach(function (clone) {
                        clone.parentNode && clone.parentNode.removeChild(clone);
                    });
                }
            },
            nullingGlobal: function nullingGlobal() {
                this.isMultiDrag = dragStarted = false;
                multiDragClones.length = 0;
            },
            destroyGlobal: function destroyGlobal() {
                this._deselectMultiDrag();

                off(document, 'pointerup', this._deselectMultiDrag);
                off(document, 'mouseup', this._deselectMultiDrag);
                off(document, 'touchend', this._deselectMultiDrag);
                off(document, 'keydown', this._checkKeyDown);
                off(document, 'keyup', this._checkKeyUp);
            },
            _deselectMultiDrag: function _deselectMultiDrag(evt) {
                if (dragStarted) return; // Only deselect if selection is in this sortable

                if (multiDragSortable !== this.sortable) return; // Only deselect if target is not item in this sortable

                if (evt && closest(evt.target, this.options.draggable, this.sortable.el, false)) return; // Only deselect if left click

                if (evt && evt.button !== 0) return;

                while (multiDragElements.length) {
                    var el = multiDragElements[0];
                    toggleClass(el, this.options.selectedClass, false);
                    multiDragElements.shift();
                    dispatchEvent({
                        sortable: this.sortable,
                        rootEl: this.sortable.el,
                        name: 'deselect',
                        targetEl: el,
                        originalEvt: evt
                    });
                }
            },
            _checkKeyDown: function _checkKeyDown(evt) {
                if (evt.key === this.options.multiDragKey) {
                    this.multiDragKeyDown = true;
                }
            },
            _checkKeyUp: function _checkKeyUp(evt) {
                if (evt.key === this.options.multiDragKey) {
                    this.multiDragKeyDown = false;
                }
            }
        };
        return _extends(MultiDrag, {
            // Static methods & properties
            pluginName: 'multiDrag',
            utils: {
                /**
                 * Selects the provided multi-drag item
                 * @param  {HTMLElement} el    The element to be selected
                 */
                select: function select(el) {
                    var sortable = el.parentNode[expando];
                    if (!sortable || !sortable.options.multiDrag || ~multiDragElements.indexOf(el)) return;

                    if (multiDragSortable && multiDragSortable !== sortable) {
                        multiDragSortable.multiDrag._deselectMultiDrag();

                        multiDragSortable = sortable;
                    }

                    toggleClass(el, sortable.options.selectedClass, true);
                    multiDragElements.push(el);
                },

                /**
                 * Deselects the provided multi-drag item
                 * @param  {HTMLElement} el    The element to be deselected
                 */
                deselect: function deselect(el) {
                    var sortable = el.parentNode[expando],
                        index = multiDragElements.indexOf(el);
                    if (!sortable || !sortable.options.multiDrag || !~index) return;
                    toggleClass(el, sortable.options.selectedClass, false);
                    multiDragElements.splice(index, 1);
                }
            },
            eventProperties: function eventProperties() {
                var _this3 = this;

                var oldIndicies = [],
                    newIndicies = [];
                multiDragElements.forEach(function (multiDragElement) {
                    oldIndicies.push({
                        multiDragElement: multiDragElement,
                        index: multiDragElement.sortableIndex
                    }); // multiDragElements will already be sorted if folding

                    var newIndex;

                    if (folding && multiDragElement !== dragEl$1) {
                        newIndex = -1;
                    } else if (folding) {
                        newIndex = index(multiDragElement, ':not(.' + _this3.options.selectedClass + ')');
                    } else {
                        newIndex = index(multiDragElement);
                    }

                    newIndicies.push({
                        multiDragElement: multiDragElement,
                        index: newIndex
                    });
                });
                return {
                    items: _toConsumableArray(multiDragElements),
                    clones: [].concat(multiDragClones),
                    oldIndicies: oldIndicies,
                    newIndicies: newIndicies
                };
            },
            optionListeners: {
                multiDragKey: function multiDragKey(key) {
                    key = key.toLowerCase();

                    if (key === 'ctrl') {
                        key = 'Control';
                    } else if (key.length > 1) {
                        key = key.charAt(0).toUpperCase() + key.substr(1);
                    }

                    return key;
                }
            }
        });
    }

    function insertMultiDragElements(clonesInserted, rootEl) {
        multiDragElements.forEach(function (multiDragElement, i) {
            var target = rootEl.children[multiDragElement.sortableIndex + (clonesInserted ? Number(i) : 0)];

            if (target) {
                rootEl.insertBefore(multiDragElement, target);
            } else {
                rootEl.appendChild(multiDragElement);
            }
        });
    }
    /**
     * Insert multi-drag clones
     * @param  {[Boolean]} elementsInserted  Whether the multi-drag elements are inserted
     * @param  {HTMLElement} rootEl
     */


    function insertMultiDragClones(elementsInserted, rootEl) {
        multiDragClones.forEach(function (clone, i) {
            var target = rootEl.children[clone.sortableIndex + (elementsInserted ? Number(i) : 0)];

            if (target) {
                rootEl.insertBefore(clone, target);
            } else {
                rootEl.appendChild(clone);
            }
        });
    }

    function removeMultiDragElements() {
        multiDragElements.forEach(function (multiDragElement) {
            if (multiDragElement === dragEl$1) return;
            multiDragElement.parentNode && multiDragElement.parentNode.removeChild(multiDragElement);
        });
    }

    Sortable.mount(new AutoScrollPlugin());
    Sortable.mount(Remove, Revert);

    Sortable.mount(new SwapPlugin());
    Sortable.mount(new MultiDragPlugin());

    return Sortable;

}));

(function() {
    'use strict';

    angular
        .module('platformApp')
        .config(localStorageConfig);

    localStorageConfig.$inject = ['$localStorageProvider', '$sessionStorageProvider'];

    function localStorageConfig($localStorageProvider, $sessionStorageProvider) {
        $localStorageProvider.setKeyPrefix('platform2-');
        $sessionStorageProvider.setKeyPrefix('platform2-');
    }
})();

/*! jQuery UI - v1.12.1 - 2018-01-07
 * http://jqueryui.com
 * Includes: widget.js, position.js, data.js, disable-selection.js, focusable.js, form-reset-mixin.js, jquery-1-7.js, keycode.js, labels.js, scroll-parent.js, tabbable.js, unique-id.js, widgets/draggable.js, widgets/droppable.js, widgets/resizable.js, widgets/selectable.js, widgets/sortable.js, widgets/accordion.js, widgets/autocomplete.js, widgets/button.js, widgets/checkboxradio.js, widgets/controlgroup.js, widgets/datepicker.js, widgets/dialog.js, widgets/menu.js, widgets/mouse.js, widgets/progressbar.js, widgets/selectmenu.js, widgets/slider.js, widgets/spinner.js, widgets/tabs.js, widgets/tooltip.js, effect.js, effects/effect-blind.js, effects/effect-bounce.js, effects/effect-clip.js, effects/effect-drop.js, effects/effect-explode.js, effects/effect-fade.js, effects/effect-fold.js, effects/effect-highlight.js, effects/effect-puff.js, effects/effect-pulsate.js, effects/effect-scale.js, effects/effect-shake.js, effects/effect-size.js, effects/effect-slide.js, effects/effect-transfer.js
 * Copyright jQuery Foundation and other contributors; Licensed MIT */

(function (e) {
    "function" == typeof define && define.amd ? define(["jquery"], e) : e(jQuery)
})(function (e) {
    function t(e) {
        for (var t = e.css("visibility"); "inherit" === t;)e = e.parent(), t = e.css("visibility");
        return "hidden" !== t
    }

    function i(e) {
        for (var t, i; e.length && e[0] !== document;) {
            if (t = e.css("position"), ("absolute" === t || "relative" === t || "fixed" === t) && (i = parseInt(e.css("zIndex"), 10), !isNaN(i) && 0 !== i))return i;
            e = e.parent()
        }
        return 0
    }

    function s() {
        this._curInst = null, this._keyEvent = !1, this._disabledInputs = [], this._datepickerShowing = !1, this._inDialog = !1, this._mainDivId = "ui-datepicker-div", this._inlineClass = "ui-datepicker-inline", this._appendClass = "ui-datepicker-append", this._triggerClass = "ui-datepicker-trigger", this._dialogClass = "ui-datepicker-dialog", this._disableClass = "ui-datepicker-disabled", this._unselectableClass = "ui-datepicker-unselectable", this._currentClass = "ui-datepicker-current-day", this._dayOverClass = "ui-datepicker-days-cell-over", this.regional = [], this.regional[""] = {
            closeText: "Done",
            prevText: "Prev",
            nextText: "Next",
            currentText: "Today",
            monthNames: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
            monthNamesShort: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
            dayNames: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
            dayNamesShort: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
            dayNamesMin: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
            weekHeader: "Wk",
            dateFormat: "mm/dd/yy",
            firstDay: 0,
            isRTL: !1,
            showMonthAfterYear: !1,
            yearSuffix: ""
        }, this._defaults = {
            showOn: "focus",
            showAnim: "fadeIn",
            showOptions: {},
            defaultDate: null,
            appendText: "",
            buttonText: "...",
            buttonImage: "",
            buttonImageOnly: !1,
            hideIfNoPrevNext: !1,
            navigationAsDateFormat: !1,
            gotoCurrent: !1,
            changeMonth: !1,
            changeYear: !1,
            yearRange: "c-10:c+10",
            showOtherMonths: !1,
            selectOtherMonths: !1,
            showWeek: !1,
            calculateWeek: this.iso8601Week,
            shortYearCutoff: "+10",
            minDate: null,
            maxDate: null,
            duration: "fast",
            beforeShowDay: null,
            beforeShow: null,
            onSelect: null,
            onChangeMonthYear: null,
            onClose: null,
            numberOfMonths: 1,
            showCurrentAtPos: 0,
            stepMonths: 1,
            stepBigMonths: 12,
            altField: "",
            altFormat: "",
            constrainInput: !0,
            showButtonPanel: !1,
            autoSize: !1,
            disabled: !1
        }, e.extend(this._defaults, this.regional[""]), this.regional.en = e.extend(!0, {}, this.regional[""]), this.regional["en-US"] = e.extend(!0, {}, this.regional.en), this.dpDiv = n(e("<div id='" + this._mainDivId + "' class='ui-datepicker ui-widget ui-widget-content ui-helper-clearfix ui-corner-all'></div>"))
    }

    function n(t) {
        var i = "button, .ui-datepicker-prev, .ui-datepicker-next, .ui-datepicker-calendar td a";
        return t.on("mouseout", i, function () {
            e(this).removeClass("ui-state-hover"), -1 !== this.className.indexOf("ui-datepicker-prev") && e(this).removeClass("ui-datepicker-prev-hover"), -1 !== this.className.indexOf("ui-datepicker-next") && e(this).removeClass("ui-datepicker-next-hover")
        }).on("mouseover", i, a)
    }

    function a() {
        e.datepicker._isDisabledDatepicker(p.inline ? p.dpDiv.parent()[0] : p.input[0]) || (e(this).parents(".ui-datepicker-calendar").find("a").removeClass("ui-state-hover"), e(this).addClass("ui-state-hover"), -1 !== this.className.indexOf("ui-datepicker-prev") && e(this).addClass("ui-datepicker-prev-hover"), -1 !== this.className.indexOf("ui-datepicker-next") && e(this).addClass("ui-datepicker-next-hover"))
    }

    function o(t, i) {
        e.extend(t, i);
        for (var s in i)null == i[s] && (t[s] = i[s]);
        return t
    }

    function r(e) {
        return function () {
            var t = this.element.val();
            e.apply(this, arguments), this._refresh(), t !== this.element.val() && this._trigger("change")
        }
    }

    e.ui = e.ui || {}, e.ui.version = "1.12.1";
    var h = 0, l = Array.prototype.slice;
    e.cleanData = function (t) {
        return function (i) {
            var s, n, a;
            for (a = 0; null != (n = i[a]); a++)try {
                s = e._data(n, "events"), s && s.remove && e(n).triggerHandler("remove")
            } catch (o) {
            }
            t(i)
        }
    }(e.cleanData), e.widget = function (t, i, s) {
        var n, a, o, r = {}, h = t.split(".")[0];
        t = t.split(".")[1];
        var l = h + "-" + t;
        return s || (s = i, i = e.Widget), e.isArray(s) && (s = e.extend.apply(null, [{}].concat(s))), e.expr[":"][l.toLowerCase()] = function (t) {
            return !!e.data(t, l)
        }, e[h] = e[h] || {}, n = e[h][t], a = e[h][t] = function (e, t) {
            return this._createWidget ? (arguments.length && this._createWidget(e, t), void 0) : new a(e, t)
        }, e.extend(a, n, {
            version: s.version,
            _proto: e.extend({}, s),
            _childConstructors: []
        }), o = new i, o.options = e.widget.extend({}, o.options), e.each(s, function (t, s) {
            return e.isFunction(s) ? (r[t] = function () {
                    function e() {
                        return i.prototype[t].apply(this, arguments)
                    }

                    function n(e) {
                        return i.prototype[t].apply(this, e)
                    }

                    return function () {
                        var t, i = this._super, a = this._superApply;
                        return this._super = e, this._superApply = n, t = s.apply(this, arguments), this._super = i, this._superApply = a, t
                    }
                }(), void 0) : (r[t] = s, void 0)
        }), a.prototype = e.widget.extend(o, {widgetEventPrefix: n ? o.widgetEventPrefix || t : t}, r, {
            constructor: a,
            namespace: h,
            widgetName: t,
            widgetFullName: l
        }), n ? (e.each(n._childConstructors, function (t, i) {
                var s = i.prototype;
                e.widget(s.namespace + "." + s.widgetName, a, i._proto)
            }), delete n._childConstructors) : i._childConstructors.push(a), e.widget.bridge(t, a), a
    }, e.widget.extend = function (t) {
        for (var i, s, n = l.call(arguments, 1), a = 0, o = n.length; o > a; a++)for (i in n[a])s = n[a][i], n[a].hasOwnProperty(i) && void 0 !== s && (t[i] = e.isPlainObject(s) ? e.isPlainObject(t[i]) ? e.widget.extend({}, t[i], s) : e.widget.extend({}, s) : s);
        return t
    }, e.widget.bridge = function (t, i) {
        var s = i.prototype.widgetFullName || t;
        e.fn[t] = function (n) {
            var a = "string" == typeof n, o = l.call(arguments, 1), r = this;
            return a ? this.length || "instance" !== n ? this.each(function () {
                        var i, a = e.data(this, s);
                        return "instance" === n ? (r = a, !1) : a ? e.isFunction(a[n]) && "_" !== n.charAt(0) ? (i = a[n].apply(a, o), i !== a && void 0 !== i ? (r = i && i.jquery ? r.pushStack(i.get()) : i, !1) : void 0) : e.error("no such method '" + n + "' for " + t + " widget instance") : e.error("cannot call methods on " + t + " prior to initialization; " + "attempted to call method '" + n + "'")
                    }) : r = void 0 : (o.length && (n = e.widget.extend.apply(null, [n].concat(o))), this.each(function () {
                    var t = e.data(this, s);
                    t ? (t.option(n || {}), t._init && t._init()) : e.data(this, s, new i(n, this))
                })), r
        }
    }, e.Widget = function () {
    }, e.Widget._childConstructors = [], e.Widget.prototype = {
        widgetName: "widget",
        widgetEventPrefix: "",
        defaultElement: "<div>",
        options: {classes: {}, disabled: !1, create: null},
        _createWidget: function (t, i) {
            i = e(i || this.defaultElement || this)[0], this.element = e(i), this.uuid = h++, this.eventNamespace = "." + this.widgetName + this.uuid, this.bindings = e(), this.hoverable = e(), this.focusable = e(), this.classesElementLookup = {}, i !== this && (e.data(i, this.widgetFullName, this), this._on(!0, this.element, {
                remove: function (e) {
                    e.target === i && this.destroy()
                }
            }), this.document = e(i.style ? i.ownerDocument : i.document || i), this.window = e(this.document[0].defaultView || this.document[0].parentWindow)), this.options = e.widget.extend({}, this.options, this._getCreateOptions(), t), this._create(), this.options.disabled && this._setOptionDisabled(this.options.disabled), this._trigger("create", null, this._getCreateEventData()), this._init()
        },
        _getCreateOptions: function () {
            return {}
        },
        _getCreateEventData: e.noop,
        _create: e.noop,
        _init: e.noop,
        destroy: function () {
            var t = this;
            this._destroy(), e.each(this.classesElementLookup, function (e, i) {
                t._removeClass(i, e)
            }), this.element.off(this.eventNamespace).removeData(this.widgetFullName), this.widget().off(this.eventNamespace).removeAttr("aria-disabled"), this.bindings.off(this.eventNamespace)
        },
        _destroy: e.noop,
        widget: function () {
            return this.element
        },
        option: function (t, i) {
            var s, n, a, o = t;
            if (0 === arguments.length)return e.widget.extend({}, this.options);
            if ("string" == typeof t)if (o = {}, s = t.split("."), t = s.shift(), s.length) {
                for (n = o[t] = e.widget.extend({}, this.options[t]), a = 0; s.length - 1 > a; a++)n[s[a]] = n[s[a]] || {}, n = n[s[a]];
                if (t = s.pop(), 1 === arguments.length)return void 0 === n[t] ? null : n[t];
                n[t] = i
            } else {
                if (1 === arguments.length)return void 0 === this.options[t] ? null : this.options[t];
                o[t] = i
            }
            return this._setOptions(o), this
        },
        _setOptions: function (e) {
            var t;
            for (t in e)this._setOption(t, e[t]);
            return this
        },
        _setOption: function (e, t) {
            return "classes" === e && this._setOptionClasses(t), this.options[e] = t, "disabled" === e && this._setOptionDisabled(t), this
        },
        _setOptionClasses: function (t) {
            var i, s, n;
            for (i in t)n = this.classesElementLookup[i], t[i] !== this.options.classes[i] && n && n.length && (s = e(n.get()), this._removeClass(n, i), s.addClass(this._classes({
                element: s,
                keys: i,
                classes: t,
                add: !0
            })))
        },
        _setOptionDisabled: function (e) {
            this._toggleClass(this.widget(), this.widgetFullName + "-disabled", null, !!e), e && (this._removeClass(this.hoverable, null, "ui-state-hover"), this._removeClass(this.focusable, null, "ui-state-focus"))
        },
        enable: function () {
            return this._setOptions({disabled: !1})
        },
        disable: function () {
            return this._setOptions({disabled: !0})
        },
        _classes: function (t) {
            function i(i, a) {
                var o, r;
                for (r = 0; i.length > r; r++)o = n.classesElementLookup[i[r]] || e(), o = t.add ? e(e.unique(o.get().concat(t.element.get()))) : e(o.not(t.element).get()), n.classesElementLookup[i[r]] = o, s.push(i[r]), a && t.classes[i[r]] && s.push(t.classes[i[r]])
            }

            var s = [], n = this;
            return t = e.extend({
                element: this.element,
                classes: this.options.classes || {}
            }, t), this._on(t.element, {remove: "_untrackClassesElement"}), t.keys && i(t.keys.match(/\S+/g) || [], !0), t.extra && i(t.extra.match(/\S+/g) || []), s.join(" ")
        },
        _untrackClassesElement: function (t) {
            var i = this;
            e.each(i.classesElementLookup, function (s, n) {
                -1 !== e.inArray(t.target, n) && (i.classesElementLookup[s] = e(n.not(t.target).get()))
            })
        },
        _removeClass: function (e, t, i) {
            return this._toggleClass(e, t, i, !1)
        },
        _addClass: function (e, t, i) {
            return this._toggleClass(e, t, i, !0)
        },
        _toggleClass: function (e, t, i, s) {
            s = "boolean" == typeof s ? s : i;
            var n = "string" == typeof e || null === e, a = {
                extra: n ? t : i,
                keys: n ? e : t,
                element: n ? this.element : e,
                add: s
            };
            return a.element.toggleClass(this._classes(a), s), this
        },
        _on: function (t, i, s) {
            var n, a = this;
            "boolean" != typeof t && (s = i, i = t, t = !1), s ? (i = n = e(i), this.bindings = this.bindings.add(i)) : (s = i, i = this.element, n = this.widget()), e.each(s, function (s, o) {
                function r() {
                    return t || a.options.disabled !== !0 && !e(this).hasClass("ui-state-disabled") ? ("string" == typeof o ? a[o] : o).apply(a, arguments) : void 0
                }

                "string" != typeof o && (r.guid = o.guid = o.guid || r.guid || e.guid++);
                var h = s.match(/^([\w:-]*)\s*(.*)$/), l = h[1] + a.eventNamespace, u = h[2];
                u ? n.on(l, u, r) : i.on(l, r)
            })
        },
        _off: function (t, i) {
            i = (i || "").split(" ").join(this.eventNamespace + " ") + this.eventNamespace, t.off(i).off(i), this.bindings = e(this.bindings.not(t).get()), this.focusable = e(this.focusable.not(t).get()), this.hoverable = e(this.hoverable.not(t).get())
        },
        _delay: function (e, t) {
            function i() {
                return ("string" == typeof e ? s[e] : e).apply(s, arguments)
            }

            var s = this;
            return setTimeout(i, t || 0)
        },
        _hoverable: function (t) {
            this.hoverable = this.hoverable.add(t), this._on(t, {
                mouseenter: function (t) {
                    this._addClass(e(t.currentTarget), null, "ui-state-hover")
                }, mouseleave: function (t) {
                    this._removeClass(e(t.currentTarget), null, "ui-state-hover")
                }
            })
        },
        _focusable: function (t) {
            this.focusable = this.focusable.add(t), this._on(t, {
                focusin: function (t) {
                    this._addClass(e(t.currentTarget), null, "ui-state-focus")
                }, focusout: function (t) {
                    this._removeClass(e(t.currentTarget), null, "ui-state-focus")
                }
            })
        },
        _trigger: function (t, i, s) {
            var n, a, o = this.options[t];
            if (s = s || {}, i = e.Event(i), i.type = (t === this.widgetEventPrefix ? t : this.widgetEventPrefix + t).toLowerCase(), i.target = this.element[0], a = i.originalEvent)for (n in a)n in i || (i[n] = a[n]);
            return this.element.trigger(i, s), !(e.isFunction(o) && o.apply(this.element[0], [i].concat(s)) === !1 || i.isDefaultPrevented())
        }
    }, e.each({show: "fadeIn", hide: "fadeOut"}, function (t, i) {
        e.Widget.prototype["_" + t] = function (s, n, a) {
            "string" == typeof n && (n = {effect: n});
            var o, r = n ? n === !0 || "number" == typeof n ? i : n.effect || i : t;
            n = n || {}, "number" == typeof n && (n = {duration: n}), o = !e.isEmptyObject(n), n.complete = a, n.delay && s.delay(n.delay), o && e.effects && e.effects.effect[r] ? s[t](n) : r !== t && s[r] ? s[r](n.duration, n.easing, a) : s.queue(function (i) {
                        e(this)[t](), a && a.call(s[0]), i()
                    })
        }
    }), e.widget, function () {
        function t(e, t, i) {
            return [parseFloat(e[0]) * (c.test(e[0]) ? t / 100 : 1), parseFloat(e[1]) * (c.test(e[1]) ? i / 100 : 1)]
        }

        function i(t, i) {
            return parseInt(e.css(t, i), 10) || 0
        }

        function s(t) {
            var i = t[0];
            return 9 === i.nodeType ? {
                    width: t.width(),
                    height: t.height(),
                    offset: {top: 0, left: 0}
                } : e.isWindow(i) ? {
                        width: t.width(),
                        height: t.height(),
                        offset: {top: t.scrollTop(), left: t.scrollLeft()}
                    } : i.preventDefault ? {
                            width: 0,
                            height: 0,
                            offset: {top: i.pageY, left: i.pageX}
                        } : {width: t.outerWidth(), height: t.outerHeight(), offset: t.offset()}
        }

        var n, a = Math.max, o = Math.abs, r = /left|center|right/, h = /top|center|bottom/, l = /[\+\-]\d+(\.[\d]+)?%?/, u = /^\w+/, c = /%$/, d = e.fn.position;
        e.position = {
            scrollbarWidth: function () {
                if (void 0 !== n)return n;
                var t, i, s = e("<div style='display:block;position:absolute;width:50px;height:50px;overflow:hidden;'><div style='height:100px;width:auto;'></div></div>"), a = s.children()[0];
                return e("body").append(s), t = a.offsetWidth, s.css("overflow", "scroll"), i = a.offsetWidth, t === i && (i = s[0].clientWidth), s.remove(), n = t - i
            }, getScrollInfo: function (t) {
                var i = t.isWindow || t.isDocument ? "" : t.element.css("overflow-x"), s = t.isWindow || t.isDocument ? "" : t.element.css("overflow-y"), n = "scroll" === i || "auto" === i && t.width < t.element[0].scrollWidth, a = "scroll" === s || "auto" === s && t.height < t.element[0].scrollHeight;
                return {width: a ? e.position.scrollbarWidth() : 0, height: n ? e.position.scrollbarWidth() : 0}
            }, getWithinInfo: function (t) {
                var i = e(t || window), s = e.isWindow(i[0]), n = !!i[0] && 9 === i[0].nodeType, a = !s && !n;
                return {
                    element: i,
                    isWindow: s,
                    isDocument: n,
                    offset: a ? e(t).offset() : {left: 0, top: 0},
                    scrollLeft: i.scrollLeft(),
                    scrollTop: i.scrollTop(),
                    width: i.outerWidth(),
                    height: i.outerHeight()
                }
            }
        }, e.fn.position = function (n) {
            if (!n || !n.of)return d.apply(this, arguments);
            n = e.extend({}, n);
            var c, p, f, m, g, v, _ = e(n.of), b = e.position.getWithinInfo(n.within), y = e.position.getScrollInfo(b), x = (n.collision || "flip").split(" "), k = {};
            return v = s(_), _[0].preventDefault && (n.at = "left top"), p = v.width, f = v.height, m = v.offset, g = e.extend({}, m), e.each(["my", "at"], function () {
                var e, t, i = (n[this] || "").split(" ");
                1 === i.length && (i = r.test(i[0]) ? i.concat(["center"]) : h.test(i[0]) ? ["center"].concat(i) : ["center", "center"]), i[0] = r.test(i[0]) ? i[0] : "center", i[1] = h.test(i[1]) ? i[1] : "center", e = l.exec(i[0]), t = l.exec(i[1]), k[this] = [e ? e[0] : 0, t ? t[0] : 0], n[this] = [u.exec(i[0])[0], u.exec(i[1])[0]]
            }), 1 === x.length && (x[1] = x[0]), "right" === n.at[0] ? g.left += p : "center" === n.at[0] && (g.left += p / 2), "bottom" === n.at[1] ? g.top += f : "center" === n.at[1] && (g.top += f / 2), c = t(k.at, p, f), g.left += c[0], g.top += c[1], this.each(function () {
                var s, r, h = e(this), l = h.outerWidth(), u = h.outerHeight(), d = i(this, "marginLeft"), v = i(this, "marginTop"), w = l + d + i(this, "marginRight") + y.width, T = u + v + i(this, "marginBottom") + y.height, D = e.extend({}, g), S = t(k.my, h.outerWidth(), h.outerHeight());
                "right" === n.my[0] ? D.left -= l : "center" === n.my[0] && (D.left -= l / 2), "bottom" === n.my[1] ? D.top -= u : "center" === n.my[1] && (D.top -= u / 2), D.left += S[0], D.top += S[1], s = {
                    marginLeft: d,
                    marginTop: v
                }, e.each(["left", "top"], function (t, i) {
                    e.ui.position[x[t]] && e.ui.position[x[t]][i](D, {
                        targetWidth: p,
                        targetHeight: f,
                        elemWidth: l,
                        elemHeight: u,
                        collisionPosition: s,
                        collisionWidth: w,
                        collisionHeight: T,
                        offset: [c[0] + S[0], c[1] + S[1]],
                        my: n.my,
                        at: n.at,
                        within: b,
                        elem: h
                    })
                }), n.using && (r = function (e) {
                    var t = m.left - D.left, i = t + p - l, s = m.top - D.top, r = s + f - u, c = {
                        target: {
                            element: _,
                            left: m.left,
                            top: m.top,
                            width: p,
                            height: f
                        },
                        element: {element: h, left: D.left, top: D.top, width: l, height: u},
                        horizontal: 0 > i ? "left" : t > 0 ? "right" : "center",
                        vertical: 0 > r ? "top" : s > 0 ? "bottom" : "middle"
                    };
                    l > p && p > o(t + i) && (c.horizontal = "center"), u > f && f > o(s + r) && (c.vertical = "middle"), c.important = a(o(t), o(i)) > a(o(s), o(r)) ? "horizontal" : "vertical", n.using.call(this, e, c)
                }), h.offset(e.extend(D, {using: r}))
            })
        }, e.ui.position = {
            fit: {
                left: function (e, t) {
                    var i, s = t.within, n = s.isWindow ? s.scrollLeft : s.offset.left, o = s.width, r = e.left - t.collisionPosition.marginLeft, h = n - r, l = r + t.collisionWidth - o - n;
                    t.collisionWidth > o ? h > 0 && 0 >= l ? (i = e.left + h + t.collisionWidth - o - n, e.left += h - i) : e.left = l > 0 && 0 >= h ? n : h > l ? n + o - t.collisionWidth : n : h > 0 ? e.left += h : l > 0 ? e.left -= l : e.left = a(e.left - r, e.left)
                }, top: function (e, t) {
                    var i, s = t.within, n = s.isWindow ? s.scrollTop : s.offset.top, o = t.within.height, r = e.top - t.collisionPosition.marginTop, h = n - r, l = r + t.collisionHeight - o - n;
                    t.collisionHeight > o ? h > 0 && 0 >= l ? (i = e.top + h + t.collisionHeight - o - n, e.top += h - i) : e.top = l > 0 && 0 >= h ? n : h > l ? n + o - t.collisionHeight : n : h > 0 ? e.top += h : l > 0 ? e.top -= l : e.top = a(e.top - r, e.top)
                }
            }, flip: {
                left: function (e, t) {
                    var i, s, n = t.within, a = n.offset.left + n.scrollLeft, r = n.width, h = n.isWindow ? n.scrollLeft : n.offset.left, l = e.left - t.collisionPosition.marginLeft, u = l - h, c = l + t.collisionWidth - r - h, d = "left" === t.my[0] ? -t.elemWidth : "right" === t.my[0] ? t.elemWidth : 0, p = "left" === t.at[0] ? t.targetWidth : "right" === t.at[0] ? -t.targetWidth : 0, f = -2 * t.offset[0];
                    0 > u ? (i = e.left + d + p + f + t.collisionWidth - r - a, (0 > i || o(u) > i) && (e.left += d + p + f)) : c > 0 && (s = e.left - t.collisionPosition.marginLeft + d + p + f - h, (s > 0 || c > o(s)) && (e.left += d + p + f))
                }, top: function (e, t) {
                    var i, s, n = t.within, a = n.offset.top + n.scrollTop, r = n.height, h = n.isWindow ? n.scrollTop : n.offset.top, l = e.top - t.collisionPosition.marginTop, u = l - h, c = l + t.collisionHeight - r - h, d = "top" === t.my[1], p = d ? -t.elemHeight : "bottom" === t.my[1] ? t.elemHeight : 0, f = "top" === t.at[1] ? t.targetHeight : "bottom" === t.at[1] ? -t.targetHeight : 0, m = -2 * t.offset[1];
                    0 > u ? (s = e.top + p + f + m + t.collisionHeight - r - a, (0 > s || o(u) > s) && (e.top += p + f + m)) : c > 0 && (i = e.top - t.collisionPosition.marginTop + p + f + m - h, (i > 0 || c > o(i)) && (e.top += p + f + m))
                }
            }, flipfit: {
                left: function () {
                    e.ui.position.flip.left.apply(this, arguments), e.ui.position.fit.left.apply(this, arguments)
                }, top: function () {
                    e.ui.position.flip.top.apply(this, arguments), e.ui.position.fit.top.apply(this, arguments)
                }
            }
        }
    }(), e.ui.position, e.extend(e.expr[":"], {
        data: e.expr.createPseudo ? e.expr.createPseudo(function (t) {
                return function (i) {
                    return !!e.data(i, t)
                }
            }) : function (t, i, s) {
                return !!e.data(t, s[3])
            }
    }), e.fn.extend({
        disableSelection: function () {
            var e = "onselectstart" in document.createElement("div") ? "selectstart" : "mousedown";
            return function () {
                return this.on(e + ".ui-disableSelection", function (e) {
                    e.preventDefault()
                })
            }
        }(), enableSelection: function () {
            return this.off(".ui-disableSelection")
        }
    }), e.ui.focusable = function (i, s) {
        var n, a, o, r, h, l = i.nodeName.toLowerCase();
        return "area" === l ? (n = i.parentNode, a = n.name, i.href && a && "map" === n.nodeName.toLowerCase() ? (o = e("img[usemap='#" + a + "']"), o.length > 0 && o.is(":visible")) : !1) : (/^(input|select|textarea|button|object)$/.test(l) ? (r = !i.disabled, r && (h = e(i).closest("fieldset")[0], h && (r = !h.disabled))) : r = "a" === l ? i.href || s : s, r && e(i).is(":visible") && t(e(i)))
    }, e.extend(e.expr[":"], {
        focusable: function (t) {
            return e.ui.focusable(t, null != e.attr(t, "tabindex"))
        }
    }), e.ui.focusable, e.fn.form = function () {
        return "string" == typeof this[0].form ? this.closest("form") : e(this[0].form)
    }, e.ui.formResetMixin = {
        _formResetHandler: function () {
            var t = e(this);
            setTimeout(function () {
                var i = t.data("ui-form-reset-instances");
                e.each(i, function () {
                    this.refresh()
                })
            })
        }, _bindFormResetHandler: function () {
            if (this.form = this.element.form(), this.form.length) {
                var e = this.form.data("ui-form-reset-instances") || [];
                e.length || this.form.on("reset.ui-form-reset", this._formResetHandler), e.push(this), this.form.data("ui-form-reset-instances", e)
            }
        }, _unbindFormResetHandler: function () {
            if (this.form.length) {
                var t = this.form.data("ui-form-reset-instances");
                t.splice(e.inArray(this, t), 1), t.length ? this.form.data("ui-form-reset-instances", t) : this.form.removeData("ui-form-reset-instances").off("reset.ui-form-reset")
            }
        }
    }, "1.7" === e.fn.jquery.substring(0, 3) && (e.each(["Width", "Height"], function (t, i) {
        function s(t, i, s, a) {
            return e.each(n, function () {
                i -= parseFloat(e.css(t, "padding" + this)) || 0, s && (i -= parseFloat(e.css(t, "border" + this + "Width")) || 0), a && (i -= parseFloat(e.css(t, "margin" + this)) || 0)
            }), i
        }

        var n = "Width" === i ? ["Left", "Right"] : ["Top", "Bottom"], a = i.toLowerCase(), o = {
            innerWidth: e.fn.innerWidth,
            innerHeight: e.fn.innerHeight,
            outerWidth: e.fn.outerWidth,
            outerHeight: e.fn.outerHeight
        };
        e.fn["inner" + i] = function (t) {
            return void 0 === t ? o["inner" + i].call(this) : this.each(function () {
                    e(this).css(a, s(this, t) + "px")
                })
        }, e.fn["outer" + i] = function (t, n) {
            return "number" != typeof t ? o["outer" + i].call(this, t) : this.each(function () {
                    e(this).css(a, s(this, t, !0, n) + "px")
                })
        }
    }), e.fn.addBack = function (e) {
        return this.add(null == e ? this.prevObject : this.prevObject.filter(e))
    }), e.ui.keyCode = {
        BACKSPACE: 8,
        COMMA: 188,
        DELETE: 46,
        DOWN: 40,
        END: 35,
        ENTER: 13,
        ESCAPE: 27,
        HOME: 36,
        LEFT: 37,
        PAGE_DOWN: 34,
        PAGE_UP: 33,
        PERIOD: 190,
        RIGHT: 39,
        SPACE: 32,
        TAB: 9,
        UP: 38
    }, e.ui.escapeSelector = function () {
        var e = /([!"#$%&'()*+,./:;<=>?@[\]^`{|}~])/g;
        return function (t) {
            return t.replace(e, "\\$1")
        }
    }(), e.fn.labels = function () {
        var t, i, s, n, a;
        return this[0].labels && this[0].labels.length ? this.pushStack(this[0].labels) : (n = this.eq(0).parents("label"), s = this.attr("id"), s && (t = this.eq(0).parents().last(), a = t.add(t.length ? t.siblings() : this.siblings()), i = "label[for='" + e.ui.escapeSelector(s) + "']", n = n.add(a.find(i).addBack(i))), this.pushStack(n))
    }, e.fn.scrollParent = function (t) {
        var i = this.css("position"), s = "absolute" === i, n = t ? /(auto|scroll|hidden)/ : /(auto|scroll)/, a = this.parents().filter(function () {
            var t = e(this);
            return s && "static" === t.css("position") ? !1 : n.test(t.css("overflow") + t.css("overflow-y") + t.css("overflow-x"))
        }).eq(0);
        return "fixed" !== i && a.length ? a : e(this[0].ownerDocument || document)
    }, e.extend(e.expr[":"], {
        tabbable: function (t) {
            var i = e.attr(t, "tabindex"), s = null != i;
            return (!s || i >= 0) && e.ui.focusable(t, s)
        }
    }), e.fn.extend({
        uniqueId: function () {
            var e = 0;
            return function () {
                return this.each(function () {
                    this.id || (this.id = "ui-id-" + ++e)
                })
            }
        }(), removeUniqueId: function () {
            return this.each(function () {
                /^ui-id-\d+$/.test(this.id) && e(this).removeAttr("id")
            })
        }
    }), e.ui.ie = !!/msie [\w.]+/.exec(navigator.userAgent.toLowerCase());
    var u = !1;
    e(document).on("mouseup", function () {
        u = !1
    }), e.widget("ui.mouse", {
        version: "1.12.1",
        options: {cancel: "input, textarea, button, select, option", distance: 1, delay: 0},
        _mouseInit: function () {
            var t = this;
            this.element.on("mousedown." + this.widgetName, function (e) {
                return t._mouseDown(e)
            }).on("click." + this.widgetName, function (i) {
                return !0 === e.data(i.target, t.widgetName + ".preventClickEvent") ? (e.removeData(i.target, t.widgetName + ".preventClickEvent"), i.stopImmediatePropagation(), !1) : void 0
            }), this.started = !1
        },
        _mouseDestroy: function () {
            conso
            this.element.off("." + this.widgetName), this._mouseMoveDelegate && this.document.off("mousemove." + this.widgetName, this._mouseMoveDelegate).off("mouseup." + this.widgetName, this._mouseUpDelegate)
        },
        _mouseDown: function (t) {
            if (!u) {
                this._mouseMoved = !1, this._mouseStarted && this._mouseUp(t), this._mouseDownEvent = t;
                var i = this, s = 1 === t.which, n = "string" == typeof this.options.cancel && t.target.nodeName ? e(t.target).closest(this.options.cancel).length : !1;
                return s && !n && this._mouseCapture(t) ? (this.mouseDelayMet = !this.options.delay, this.mouseDelayMet || (this._mouseDelayTimer = setTimeout(function () {
                        i.mouseDelayMet = !0
                    }, this.options.delay)), this._mouseDistanceMet(t) && this._mouseDelayMet(t) && (this._mouseStarted = this._mouseStart(t) !== !1, !this._mouseStarted) ? (t.preventDefault(), !0) : (!0 === e.data(t.target, this.widgetName + ".preventClickEvent") && e.removeData(t.target, this.widgetName + ".preventClickEvent"), this._mouseMoveDelegate = function (e) {
                            return i._mouseMove(e)
                        }, this._mouseUpDelegate = function (e) {
                            return i._mouseUp(e)
                        }, this.document.on("mousemove." + this.widgetName, this._mouseMoveDelegate).on("mouseup." + this.widgetName, this._mouseUpDelegate), t.preventDefault(), u = !0, !0)) : !0
            }
        },
        _mouseMove: function (t) {
            if (this._mouseMoved) {
                if (e.ui.ie && (!document.documentMode || 9 > document.documentMode) && !t.button)return this._mouseUp(t);
                if (!t.which)if (t.originalEvent.altKey || t.originalEvent.ctrlKey || t.originalEvent.metaKey || t.originalEvent.shiftKey) this.ignoreMissingWhich = !0; else if (!this.ignoreMissingWhich)return this._mouseUp(t)
            }
            return (t.which || t.button) && (this._mouseMoved = !0), this._mouseStarted ? (this._mouseDrag(t), t.preventDefault()) : (this._mouseDistanceMet(t) && this._mouseDelayMet(t) && (this._mouseStarted = this._mouseStart(this._mouseDownEvent, t) !== !1, this._mouseStarted ? this._mouseDrag(t) : this._mouseUp(t)), !this._mouseStarted)
        },
        _mouseUp: function (t) {
            this.document.off("mousemove." + this.widgetName, this._mouseMoveDelegate).off("mouseup." + this.widgetName, this._mouseUpDelegate), this._mouseStarted && (this._mouseStarted = !1, t.target === this._mouseDownEvent.target && e.data(t.target, this.widgetName + ".preventClickEvent", !0), this._mouseStop(t)), this._mouseDelayTimer && (clearTimeout(this._mouseDelayTimer), delete this._mouseDelayTimer), this.ignoreMissingWhich = !1, u = !1, t.preventDefault()
        },
        _mouseDistanceMet: function (e) {
            return Math.max(Math.abs(this._mouseDownEvent.pageX - e.pageX), Math.abs(this._mouseDownEvent.pageY - e.pageY)) >= this.options.distance
        },
        _mouseDelayMet: function () {
            return this.mouseDelayMet
        },
        _mouseStart: function () {
        },
        _mouseDrag: function () {
        },
        _mouseStop: function () {
        },
        _mouseCapture: function () {
            return !0
        }
    }), e.ui.plugin = {
        add: function (t, i, s) {
            var n, a = e.ui[t].prototype;
            for (n in s)a.plugins[n] = a.plugins[n] || [], a.plugins[n].push([i, s[n]])
        }, call: function (e, t, i, s) {
            var n, a = e.plugins[t];
            if (a && (s || e.element[0].parentNode && 11 !== e.element[0].parentNode.nodeType))for (n = 0; a.length > n; n++)e.options[a[n][0]] && a[n][1].apply(e.element, i)
        }
    }, e.ui.safeActiveElement = function (e) {
        var t;
        try {
            t = e.activeElement
        } catch (i) {
            t = e.body
        }
        return t || (t = e.body), t.nodeName || (t = e.body), t
    }, e.ui.safeBlur = function (t) {
        t && "body" !== t.nodeName.toLowerCase() && e(t).trigger("blur")
    }, e.widget("ui.draggable", e.ui.mouse, {
        version: "1.12.1",
        widgetEventPrefix: "drag",
        options: {
            addClasses: !0,
            appendTo: "parent",
            axis: !1,
            connectToSortable: !1,
            containment: !1,
            cursor: "auto",
            cursorAt: !1,
            grid: !1,
            handle: !1,
            helper: "original",
            iframeFix: !1,
            opacity: !1,
            refreshPositions: !1,
            revert: !1,
            revertDuration: 500,
            scope: "default",
            scroll: !0,
            scrollSensitivity: 20,
            scrollSpeed: 20,
            snap: !1,
            snapMode: "both",
            snapTolerance: 20,
            stack: !1,
            zIndex: !1,
            drag: null,
            start: null,
            stop: null
        },
        _create: function () {
            "original" === this.options.helper && this._setPositionRelative(), this.options.addClasses && this._addClass("ui-draggable"), this._setHandleClassName(), this._mouseInit()
        },
        _setOption: function (e, t) {
            this._super(e, t), "handle" === e && (this._removeHandleClassName(), this._setHandleClassName())
        },
        _destroy: function () {
            return (this.helper || this.element).is(".ui-draggable-dragging") ? (this.destroyOnClear = !0, void 0) : (this._removeHandleClassName(), this._mouseDestroy(), void 0)
        },
        _mouseCapture: function (t) {
            var i = this.options;
            return this.helper || i.disabled || e(t.target).closest(".ui-resizable-handle").length > 0 ? !1 : (this.handle = this._getHandle(t), this.handle ? (this._blurActiveElement(t), this._blockFrames(i.iframeFix === !0 ? "iframe" : i.iframeFix), !0) : !1)
        },
        _blockFrames: function (t) {
            this.iframeBlocks = this.document.find(t).map(function () {
                var t = e(this);
                return e("<div>").css("position", "absolute").appendTo(t.parent()).outerWidth(t.outerWidth()).outerHeight(t.outerHeight()).offset(t.offset())[0]
            })
        },
        _unblockFrames: function () {
            this.iframeBlocks && (this.iframeBlocks.remove(), delete this.iframeBlocks)
        },
        _blurActiveElement: function (t) {
            var i = e.ui.safeActiveElement(this.document[0]), s = e(t.target);
            s.closest(i).length || e.ui.safeBlur(i)
        },
        _mouseStart: function (t) {
            var i = this.options;
            return this.helper = this._createHelper(t), this._addClass(this.helper, "ui-draggable-dragging"), this._cacheHelperProportions(), e.ui.ddmanager && (e.ui.ddmanager.current = this), this._cacheMargins(), this.cssPosition = this.helper.css("position"), this.scrollParent = this.helper.scrollParent(!0), this.offsetParent = this.helper.offsetParent(), this.hasFixedAncestor = this.helper.parents().filter(function () {
                    return "fixed" === e(this).css("position")
                }).length > 0, this.positionAbs = this.element.offset(), this._refreshOffsets(t), this.originalPosition = this.position = this._generatePosition(t, !1), this.originalPageX = t.pageX, this.originalPageY = t.pageY, i.cursorAt && this._adjustOffsetFromHelper(i.cursorAt), this._setContainment(), this._trigger("start", t) === !1 ? (this._clear(), !1) : (this._cacheHelperProportions(), e.ui.ddmanager && !i.dropBehaviour && e.ui.ddmanager.prepareOffsets(this, t), this._mouseDrag(t, !0), e.ui.ddmanager && e.ui.ddmanager.dragStart(this, t), !0)
        },
        _refreshOffsets: function (e) {
            this.offset = {
                top: this.positionAbs.top - this.margins.top,
                left: this.positionAbs.left - this.margins.left,
                scroll: !1,
                parent: this._getParentOffset(),
                relative: this._getRelativeOffset()
            }, this.offset.click = {left: e.pageX - this.offset.left, top: e.pageY - this.offset.top}
        },
        _mouseDrag: function (t, i) {
            if (this.hasFixedAncestor && (this.offset.parent = this._getParentOffset()), this.position = this._generatePosition(t, !0), this.positionAbs = this._convertPositionTo("absolute"), !i) {
                var s = this._uiHash();
                if (this._trigger("drag", t, s) === !1)return this._mouseUp(new e.Event("mouseup", t)), !1;
                this.position = s.position
            }
            return this.helper[0].style.left = this.position.left + "px", this.helper[0].style.top = this.position.top + "px", e.ui.ddmanager && e.ui.ddmanager.drag(this, t), !1
        },
        _mouseStop: function (t) {
            var i = this, s = !1;
            return e.ui.ddmanager && !this.options.dropBehaviour && (s = e.ui.ddmanager.drop(this, t)), this.dropped && (s = this.dropped, this.dropped = !1), "invalid" === this.options.revert && !s || "valid" === this.options.revert && s || this.options.revert === !0 || e.isFunction(this.options.revert) && this.options.revert.call(this.element, s) ? e(this.helper).animate(this.originalPosition, parseInt(this.options.revertDuration, 10), function () {
                    i._trigger("stop", t) !== !1 && i._clear()
                }) : this._trigger("stop", t) !== !1 && this._clear(), !1
        },
        _mouseUp: function (t) {
            return this._unblockFrames(), e.ui.ddmanager && e.ui.ddmanager.dragStop(this, t), this.handleElement.is(t.target) && this.element.trigger("focus"), e.ui.mouse.prototype._mouseUp.call(this, t)
        },
        cancel: function () {
            return this.helper.is(".ui-draggable-dragging") ? this._mouseUp(new e.Event("mouseup", {target: this.element[0]})) : this._clear(), this
        },
        _getHandle: function (t) {
            return this.options.handle ? !!e(t.target).closest(this.element.find(this.options.handle)).length : !0
        },
        _setHandleClassName: function () {
            this.handleElement = this.options.handle ? this.element.find(this.options.handle) : this.element, this._addClass(this.handleElement, "ui-draggable-handle")
        },
        _removeHandleClassName: function () {
            this._removeClass(this.handleElement, "ui-draggable-handle")
        },
        _createHelper: function (t) {
            var i = this.options, s = e.isFunction(i.helper), n = s ? e(i.helper.apply(this.element[0], [t])) : "clone" === i.helper ? this.element.clone().removeAttr("id") : this.element;
            return n.parents("body").length || n.appendTo("parent" === i.appendTo ? this.element[0].parentNode : i.appendTo), s && n[0] === this.element[0] && this._setPositionRelative(), n[0] === this.element[0] || /(fixed|absolute)/.test(n.css("position")) || n.css("position", "absolute"), n
        },
        _setPositionRelative: function () {
            /^(?:r|a|f)/.test(this.element.css("position")) || (this.element[0].style.position = "relative")
        },
        _adjustOffsetFromHelper: function (t) {
            "string" == typeof t && (t = t.split(" ")), e.isArray(t) && (t = {
                left: +t[0],
                top: +t[1] || 0
            }), "left" in t && (this.offset.click.left = t.left + this.margins.left), "right" in t && (this.offset.click.left = this.helperProportions.width - t.right + this.margins.left), "top" in t && (this.offset.click.top = t.top + this.margins.top), "bottom" in t && (this.offset.click.top = this.helperProportions.height - t.bottom + this.margins.top)
        },
        _isRootNode: function (e) {
            return /(html|body)/i.test(e.tagName) || e === this.document[0]
        },
        _getParentOffset: function () {
            var t = this.offsetParent.offset(), i = this.document[0];
            return "absolute" === this.cssPosition && this.scrollParent[0] !== i && e.contains(this.scrollParent[0], this.offsetParent[0]) && (t.left += this.scrollParent.scrollLeft(), t.top += this.scrollParent.scrollTop()), this._isRootNode(this.offsetParent[0]) && (t = {
                top: 0,
                left: 0
            }), {
                top: t.top + (parseInt(this.offsetParent.css("borderTopWidth"), 10) || 0),
                left: t.left + (parseInt(this.offsetParent.css("borderLeftWidth"), 10) || 0)
            }
        },
        _getRelativeOffset: function () {
            if ("relative" !== this.cssPosition)return {top: 0, left: 0};
            var e = this.element.position(), t = this._isRootNode(this.scrollParent[0]);
            return {
                top: e.top - (parseInt(this.helper.css("top"), 10) || 0) + (t ? 0 : this.scrollParent.scrollTop()),
                left: e.left - (parseInt(this.helper.css("left"), 10) || 0) + (t ? 0 : this.scrollParent.scrollLeft())
            }
        },
        _cacheMargins: function () {
            this.margins = {
                left: parseInt(this.element.css("marginLeft"), 10) || 0,
                top: parseInt(this.element.css("marginTop"), 10) || 0,
                right: parseInt(this.element.css("marginRight"), 10) || 0,
                bottom: parseInt(this.element.css("marginBottom"), 10) || 0
            }
        },
        _cacheHelperProportions: function () {
            this.helperProportions = {width: this.helper.outerWidth(), height: this.helper.outerHeight()}
        },
        _setContainment: function () {
            var t, i, s, n = this.options, a = this.document[0];
            return this.relativeContainer = null, n.containment ? "window" === n.containment ? (this.containment = [e(window).scrollLeft() - this.offset.relative.left - this.offset.parent.left, e(window).scrollTop() - this.offset.relative.top - this.offset.parent.top, e(window).scrollLeft() + e(window).width() - this.helperProportions.width - this.margins.left, e(window).scrollTop() + (e(window).height() || a.body.parentNode.scrollHeight) - this.helperProportions.height - this.margins.top], void 0) : "document" === n.containment ? (this.containment = [0, 0, e(a).width() - this.helperProportions.width - this.margins.left, (e(a).height() || a.body.parentNode.scrollHeight) - this.helperProportions.height - this.margins.top], void 0) : n.containment.constructor === Array ? (this.containment = n.containment, void 0) : ("parent" === n.containment && (n.containment = this.helper[0].parentNode), i = e(n.containment), s = i[0], s && (t = /(scroll|auto)/.test(i.css("overflow")), this.containment = [(parseInt(i.css("borderLeftWidth"), 10) || 0) + (parseInt(i.css("paddingLeft"), 10) || 0), (parseInt(i.css("borderTopWidth"), 10) || 0) + (parseInt(i.css("paddingTop"), 10) || 0), (t ? Math.max(s.scrollWidth, s.offsetWidth) : s.offsetWidth) - (parseInt(i.css("borderRightWidth"), 10) || 0) - (parseInt(i.css("paddingRight"), 10) || 0) - this.helperProportions.width - this.margins.left - this.margins.right, (t ? Math.max(s.scrollHeight, s.offsetHeight) : s.offsetHeight) - (parseInt(i.css("borderBottomWidth"), 10) || 0) - (parseInt(i.css("paddingBottom"), 10) || 0) - this.helperProportions.height - this.margins.top - this.margins.bottom], this.relativeContainer = i), void 0) : (this.containment = null, void 0)
        },
        _convertPositionTo: function (e, t) {
            t || (t = this.position);
            var i = "absolute" === e ? 1 : -1, s = this._isRootNode(this.scrollParent[0]);
            return {
                top: t.top + this.offset.relative.top * i + this.offset.parent.top * i - ("fixed" === this.cssPosition ? -this.offset.scroll.top : s ? 0 : this.offset.scroll.top) * i,
                left: t.left + this.offset.relative.left * i + this.offset.parent.left * i - ("fixed" === this.cssPosition ? -this.offset.scroll.left : s ? 0 : this.offset.scroll.left) * i
            }
        },
        _generatePosition: function (e, t) {
            var i, s, n, a, o = this.options, r = this._isRootNode(this.scrollParent[0]), h = e.pageX, l = e.pageY;
            return r && this.offset.scroll || (this.offset.scroll = {
                top: this.scrollParent.scrollTop(),
                left: this.scrollParent.scrollLeft()
            }), t && (this.containment && (this.relativeContainer ? (s = this.relativeContainer.offset(), i = [this.containment[0] + s.left, this.containment[1] + s.top, this.containment[2] + s.left, this.containment[3] + s.top]) : i = this.containment, e.pageX - this.offset.click.left < i[0] && (h = i[0] + this.offset.click.left), e.pageY - this.offset.click.top < i[1] && (l = i[1] + this.offset.click.top), e.pageX - this.offset.click.left > i[2] && (h = i[2] + this.offset.click.left), e.pageY - this.offset.click.top > i[3] && (l = i[3] + this.offset.click.top)), o.grid && (n = o.grid[1] ? this.originalPageY + Math.round((l - this.originalPageY) / o.grid[1]) * o.grid[1] : this.originalPageY, l = i ? n - this.offset.click.top >= i[1] || n - this.offset.click.top > i[3] ? n : n - this.offset.click.top >= i[1] ? n - o.grid[1] : n + o.grid[1] : n, a = o.grid[0] ? this.originalPageX + Math.round((h - this.originalPageX) / o.grid[0]) * o.grid[0] : this.originalPageX, h = i ? a - this.offset.click.left >= i[0] || a - this.offset.click.left > i[2] ? a : a - this.offset.click.left >= i[0] ? a - o.grid[0] : a + o.grid[0] : a), "y" === o.axis && (h = this.originalPageX), "x" === o.axis && (l = this.originalPageY)), {
                top: l - this.offset.click.top - this.offset.relative.top - this.offset.parent.top + ("fixed" === this.cssPosition ? -this.offset.scroll.top : r ? 0 : this.offset.scroll.top),
                left: h - this.offset.click.left - this.offset.relative.left - this.offset.parent.left + ("fixed" === this.cssPosition ? -this.offset.scroll.left : r ? 0 : this.offset.scroll.left)
            }
        },
        _clear: function () {
            this._removeClass(this.helper, "ui-draggable-dragging"), this.helper[0] === this.element[0] || this.cancelHelperRemoval || this.helper.remove(), this.helper = null, this.cancelHelperRemoval = !1, this.destroyOnClear && this.destroy()
        },
        _trigger: function (t, i, s) {
            return s = s || this._uiHash(), e.ui.plugin.call(this, t, [i, s, this], !0), /^(drag|start|stop)/.test(t) && (this.positionAbs = this._convertPositionTo("absolute"), s.offset = this.positionAbs), e.Widget.prototype._trigger.call(this, t, i, s)
        },
        plugins: {},
        _uiHash: function () {
            return {
                helper: this.helper,
                position: this.position,
                originalPosition: this.originalPosition,
                offset: this.positionAbs
            }
        }
    }), e.ui.plugin.add("draggable", "connectToSortable", {
        start: function (t, i, s) {
            var n = e.extend({}, i, {item: s.element});
            s.sortables = [], e(s.options.connectToSortable).each(function () {
                var i = e(this).sortable("instance");
                i && !i.options.disabled && (s.sortables.push(i), i.refreshPositions(), i._trigger("activate", t, n))
            })
        }, stop: function (t, i, s) {
            var n = e.extend({}, i, {item: s.element});
            s.cancelHelperRemoval = !1, e.each(s.sortables, function () {
                var e = this;
                e.isOver ? (e.isOver = 0, s.cancelHelperRemoval = !0, e.cancelHelperRemoval = !1, e._storedCSS = {
                        position: e.placeholder.css("position"),
                        top: e.placeholder.css("top"),
                        left: e.placeholder.css("left")
                    }, e._mouseStop(t), e.options.helper = e.options._helper) : (e.cancelHelperRemoval = !0, e._trigger("deactivate", t, n))
            })
        }, drag: function (t, i, s) {
            e.each(s.sortables, function () {
                var n = !1, a = this;
                a.positionAbs = s.positionAbs, a.helperProportions = s.helperProportions, a.offset.click = s.offset.click, a._intersectsWith(a.containerCache) && (n = !0, e.each(s.sortables, function () {
                    return this.positionAbs = s.positionAbs, this.helperProportions = s.helperProportions, this.offset.click = s.offset.click, this !== a && this._intersectsWith(this.containerCache) && e.contains(a.element[0], this.element[0]) && (n = !1), n
                })), n ? (a.isOver || (a.isOver = 1, s._parent = i.helper.parent(), a.currentItem = i.helper.appendTo(a.element).data("ui-sortable-item", !0), a.options._helper = a.options.helper, a.options.helper = function () {
                        return i.helper[0]
                    }, t.target = a.currentItem[0], a._mouseCapture(t, !0), a._mouseStart(t, !0, !0), a.offset.click.top = s.offset.click.top, a.offset.click.left = s.offset.click.left, a.offset.parent.left -= s.offset.parent.left - a.offset.parent.left, a.offset.parent.top -= s.offset.parent.top - a.offset.parent.top, s._trigger("toSortable", t), s.dropped = a.element, e.each(s.sortables, function () {
                        this.refreshPositions()
                    }), s.currentItem = s.element, a.fromOutside = s), a.currentItem && (a._mouseDrag(t), i.position = a.position)) : a.isOver && (a.isOver = 0, a.cancelHelperRemoval = !0, a.options._revert = a.options.revert, a.options.revert = !1, a._trigger("out", t, a._uiHash(a)), a._mouseStop(t, !0), a.options.revert = a.options._revert, a.options.helper = a.options._helper, a.placeholder && a.placeholder.remove(), i.helper.appendTo(s._parent), s._refreshOffsets(t), i.position = s._generatePosition(t, !0), s._trigger("fromSortable", t), s.dropped = !1, e.each(s.sortables, function () {
                        this.refreshPositions()
                    }))
            })
        }
    }), e.ui.plugin.add("draggable", "cursor", {
        start: function (t, i, s) {
            var n = e("body"), a = s.options;
            n.css("cursor") && (a._cursor = n.css("cursor")), n.css("cursor", a.cursor)
        }, stop: function (t, i, s) {
            var n = s.options;
            n._cursor && e("body").css("cursor", n._cursor)
        }
    }), e.ui.plugin.add("draggable", "opacity", {
        start: function (t, i, s) {
            var n = e(i.helper), a = s.options;
            n.css("opacity") && (a._opacity = n.css("opacity")), n.css("opacity", a.opacity)
        }, stop: function (t, i, s) {
            var n = s.options;
            n._opacity && e(i.helper).css("opacity", n._opacity)
        }
    }), e.ui.plugin.add("draggable", "scroll", {
        start: function (e, t, i) {
            i.scrollParentNotHidden || (i.scrollParentNotHidden = i.helper.scrollParent(!1)), i.scrollParentNotHidden[0] !== i.document[0] && "HTML" !== i.scrollParentNotHidden[0].tagName && (i.overflowOffset = i.scrollParentNotHidden.offset())
        }, drag: function (t, i, s) {
            var n = s.options, a = !1, o = s.scrollParentNotHidden[0], r = s.document[0];
            o !== r && "HTML" !== o.tagName ? (n.axis && "x" === n.axis || (s.overflowOffset.top + o.offsetHeight - t.pageY < n.scrollSensitivity ? o.scrollTop = a = o.scrollTop + n.scrollSpeed : t.pageY - s.overflowOffset.top < n.scrollSensitivity && (o.scrollTop = a = o.scrollTop - n.scrollSpeed)), n.axis && "y" === n.axis || (s.overflowOffset.left + o.offsetWidth - t.pageX < n.scrollSensitivity ? o.scrollLeft = a = o.scrollLeft + n.scrollSpeed : t.pageX - s.overflowOffset.left < n.scrollSensitivity && (o.scrollLeft = a = o.scrollLeft - n.scrollSpeed))) : (n.axis && "x" === n.axis || (t.pageY - e(r).scrollTop() < n.scrollSensitivity ? a = e(r).scrollTop(e(r).scrollTop() - n.scrollSpeed) : e(window).height() - (t.pageY - e(r).scrollTop()) < n.scrollSensitivity && (a = e(r).scrollTop(e(r).scrollTop() + n.scrollSpeed))), n.axis && "y" === n.axis || (t.pageX - e(r).scrollLeft() < n.scrollSensitivity ? a = e(r).scrollLeft(e(r).scrollLeft() - n.scrollSpeed) : e(window).width() - (t.pageX - e(r).scrollLeft()) < n.scrollSensitivity && (a = e(r).scrollLeft(e(r).scrollLeft() + n.scrollSpeed)))), a !== !1 && e.ui.ddmanager && !n.dropBehaviour && e.ui.ddmanager.prepareOffsets(s, t)
        }
    }), e.ui.plugin.add("draggable", "snap", {
        start: function (t, i, s) {
            var n = s.options;
            s.snapElements = [], e(n.snap.constructor !== String ? n.snap.items || ":data(ui-draggable)" : n.snap).each(function () {
                var t = e(this), i = t.offset();
                this !== s.element[0] && s.snapElements.push({
                    item: this,
                    width: t.outerWidth(),
                    height: t.outerHeight(),
                    top: i.top,
                    left: i.left
                })
            })
        }, drag: function (t, i, s) {
            var n, a, o, r, h, l, u, c, d, p, f = s.options, m = f.snapTolerance, g = i.offset.left, v = g + s.helperProportions.width, _ = i.offset.top, b = _ + s.helperProportions.height;
            for (d = s.snapElements.length - 1; d >= 0; d--)h = s.snapElements[d].left - s.margins.left, l = h + s.snapElements[d].width, u = s.snapElements[d].top - s.margins.top, c = u + s.snapElements[d].height, h - m > v || g > l + m || u - m > b || _ > c + m || !e.contains(s.snapElements[d].item.ownerDocument, s.snapElements[d].item) ? (s.snapElements[d].snapping && s.options.snap.release && s.options.snap.release.call(s.element, t, e.extend(s._uiHash(), {snapItem: s.snapElements[d].item})), s.snapElements[d].snapping = !1) : ("inner" !== f.snapMode && (n = m >= Math.abs(u - b), a = m >= Math.abs(c - _), o = m >= Math.abs(h - v), r = m >= Math.abs(l - g), n && (i.position.top = s._convertPositionTo("relative", {
                    top: u - s.helperProportions.height,
                    left: 0
                }).top), a && (i.position.top = s._convertPositionTo("relative", {
                    top: c,
                    left: 0
                }).top), o && (i.position.left = s._convertPositionTo("relative", {
                    top: 0,
                    left: h - s.helperProportions.width
                }).left), r && (i.position.left = s._convertPositionTo("relative", {
                    top: 0,
                    left: l
                }).left)), p = n || a || o || r, "outer" !== f.snapMode && (n = m >= Math.abs(u - _), a = m >= Math.abs(c - b), o = m >= Math.abs(h - g), r = m >= Math.abs(l - v), n && (i.position.top = s._convertPositionTo("relative", {
                    top: u,
                    left: 0
                }).top), a && (i.position.top = s._convertPositionTo("relative", {
                    top: c - s.helperProportions.height,
                    left: 0
                }).top), o && (i.position.left = s._convertPositionTo("relative", {
                    top: 0,
                    left: h
                }).left), r && (i.position.left = s._convertPositionTo("relative", {
                    top: 0,
                    left: l - s.helperProportions.width
                }).left)), !s.snapElements[d].snapping && (n || a || o || r || p) && s.options.snap.snap && s.options.snap.snap.call(s.element, t, e.extend(s._uiHash(), {snapItem: s.snapElements[d].item})), s.snapElements[d].snapping = n || a || o || r || p)
        }
    }), e.ui.plugin.add("draggable", "stack", {
        start: function (t, i, s) {
            var n, a = s.options, o = e.makeArray(e(a.stack)).sort(function (t, i) {
                return (parseInt(e(t).css("zIndex"), 10) || 0) - (parseInt(e(i).css("zIndex"), 10) || 0)
            });
            o.length && (n = parseInt(e(o[0]).css("zIndex"), 10) || 0, e(o).each(function (t) {
                e(this).css("zIndex", n + t)
            }), this.css("zIndex", n + o.length))
        }
    }), e.ui.plugin.add("draggable", "zIndex", {
        start: function (t, i, s) {
            var n = e(i.helper), a = s.options;
            n.css("zIndex") && (a._zIndex = n.css("zIndex")), n.css("zIndex", a.zIndex)
        }, stop: function (t, i, s) {
            var n = s.options;
            n._zIndex && e(i.helper).css("zIndex", n._zIndex)
        }
    }), e.ui.draggable, e.widget("ui.droppable", {
        version: "1.12.1",
        widgetEventPrefix: "drop",
        options: {
            accept: "*",
            addClasses: !0,
            greedy: !1,
            scope: "default",
            tolerance: "intersect",
            activate: null,
            deactivate: null,
            drop: null,
            out: null,
            over: null
        },
        _create: function () {
            var t, i = this.options, s = i.accept;
            this.isover = !1, this.isout = !0, this.accept = e.isFunction(s) ? s : function (e) {
                    return e.is(s)
                }, this.proportions = function () {
                return arguments.length ? (t = arguments[0], void 0) : t ? t : t = {
                            width: this.element[0].offsetWidth,
                            height: this.element[0].offsetHeight
                        }
            }, this._addToManager(i.scope), i.addClasses && this._addClass("ui-droppable")
        },
        _addToManager: function (t) {
            e.ui.ddmanager.droppables[t] = e.ui.ddmanager.droppables[t] || [], e.ui.ddmanager.droppables[t].push(this)
        },
        _splice: function (e) {
            for (var t = 0; e.length > t; t++)e[t] === this && e.splice(t, 1)
        },
        _destroy: function () {
            var t = e.ui.ddmanager.droppables[this.options.scope];
            this._splice(t)
        },
        _setOption: function (t, i) {
            if ("accept" === t) this.accept = e.isFunction(i) ? i : function (e) {
                    return e.is(i)
                }; else if ("scope" === t) {
                var s = e.ui.ddmanager.droppables[this.options.scope];
                this._splice(s), this._addToManager(i)
            }
            this._super(t, i)
        },
        _activate: function (t) {
            var i = e.ui.ddmanager.current;
            this._addActiveClass(), i && this._trigger("activate", t, this.ui(i))
        },
        _deactivate: function (t) {
            var i = e.ui.ddmanager.current;
            this._removeActiveClass(), i && this._trigger("deactivate", t, this.ui(i))
        },
        _over: function (t) {
            var i = e.ui.ddmanager.current;
            i && (i.currentItem || i.element)[0] !== this.element[0] && this.accept.call(this.element[0], i.currentItem || i.element) && (this._addHoverClass(), this._trigger("over", t, this.ui(i)))
        },
        _out: function (t) {
            var i = e.ui.ddmanager.current;
            i && (i.currentItem || i.element)[0] !== this.element[0] && this.accept.call(this.element[0], i.currentItem || i.element) && (this._removeHoverClass(), this._trigger("out", t, this.ui(i)))
        },
        _drop: function (t, i) {
            var s = i || e.ui.ddmanager.current, n = !1;
            return s && (s.currentItem || s.element)[0] !== this.element[0] ? (this.element.find(":data(ui-droppable)").not(".ui-draggable-dragging").each(function () {
                    var i = e(this).droppable("instance");
                    return i.options.greedy && !i.options.disabled && i.options.scope === s.options.scope && i.accept.call(i.element[0], s.currentItem || s.element) && c(s, e.extend(i, {offset: i.element.offset()}), i.options.tolerance, t) ? (n = !0, !1) : void 0
                }), n ? !1 : this.accept.call(this.element[0], s.currentItem || s.element) ? (this._removeActiveClass(), this._removeHoverClass(), this._trigger("drop", t, this.ui(s)), this.element) : !1) : !1
        },
        ui: function (e) {
            return {
                draggable: e.currentItem || e.element,
                helper: e.helper,
                position: e.position,
                offset: e.positionAbs
            }
        },
        _addHoverClass: function () {
            this._addClass("ui-droppable-hover")
        },
        _removeHoverClass: function () {
            this._removeClass("ui-droppable-hover")
        },
        _addActiveClass: function () {
            this._addClass("ui-droppable-active")
        },
        _removeActiveClass: function () {
            this._removeClass("ui-droppable-active")
        }
    });
    var c = e.ui.intersect = function () {
        function e(e, t, i) {
            return e >= t && t + i > e
        }

        return function (t, i, s, n) {
            if (!i.offset)return !1;
            var a = (t.positionAbs || t.position.absolute).left + t.margins.left, o = (t.positionAbs || t.position.absolute).top + t.margins.top, r = a + t.helperProportions.width, h = o + t.helperProportions.height, l = i.offset.left, u = i.offset.top, c = l + i.proportions().width, d = u + i.proportions().height;
            switch (s) {
                case"fit":
                    return a >= l && c >= r && o >= u && d >= h;
                case"intersect":
                    return a + t.helperProportions.width / 2 > l && c > r - t.helperProportions.width / 2 && o + t.helperProportions.height / 2 > u && d > h - t.helperProportions.height / 2;
                case"pointer":
                    return e(n.pageY, u, i.proportions().height) && e(n.pageX, l, i.proportions().width);
                case"touch":
                    return (o >= u && d >= o || h >= u && d >= h || u > o && h > d) && (a >= l && c >= a || r >= l && c >= r || l > a && r > c);
                default:
                    return !1
            }
        }
    }();
    e.ui.ddmanager = {
        current: null, droppables: {"default": []}, prepareOffsets: function (t, i) {
            var s, n, a = e.ui.ddmanager.droppables[t.options.scope] || [], o = i ? i.type : null, r = (t.currentItem || t.element).find(":data(ui-droppable)").addBack();
            e:for (s = 0; a.length > s; s++)if (!(a[s].options.disabled || t && !a[s].accept.call(a[s].element[0], t.currentItem || t.element))) {
                for (n = 0; r.length > n; n++)if (r[n] === a[s].element[0]) {
                    a[s].proportions().height = 0;
                    continue e
                }
                a[s].visible = "none" !== a[s].element.css("display"), a[s].visible && ("mousedown" === o && a[s]._activate.call(a[s], i), a[s].offset = a[s].element.offset(), a[s].proportions({
                    width: a[s].element[0].offsetWidth,
                    height: a[s].element[0].offsetHeight
                }))
            }
        }, drop: function (t, i) {
            var s = !1;
            return e.each((e.ui.ddmanager.droppables[t.options.scope] || []).slice(), function () {
                this.options && (!this.options.disabled && this.visible && c(t, this, this.options.tolerance, i) && (s = this._drop.call(this, i) || s), !this.options.disabled && this.visible && this.accept.call(this.element[0], t.currentItem || t.element) && (this.isout = !0, this.isover = !1, this._deactivate.call(this, i)))
            }), s
        }, dragStart: function (t, i) {
            t.element.parentsUntil("body").on("scroll.droppable", function () {
                t.options.refreshPositions || e.ui.ddmanager.prepareOffsets(t, i)
            })
        }, drag: function (t, i) {
            t.options.refreshPositions && e.ui.ddmanager.prepareOffsets(t, i), e.each(e.ui.ddmanager.droppables[t.options.scope] || [], function () {
                if (!this.options.disabled && !this.greedyChild && this.visible) {
                    var s, n, a, o = c(t, this, this.options.tolerance, i), r = !o && this.isover ? "isout" : o && !this.isover ? "isover" : null;
                    r && (this.options.greedy && (n = this.options.scope, a = this.element.parents(":data(ui-droppable)").filter(function () {
                        return e(this).droppable("instance").options.scope === n
                    }), a.length && (s = e(a[0]).droppable("instance"), s.greedyChild = "isover" === r)), s && "isover" === r && (s.isover = !1, s.isout = !0, s._out.call(s, i)), this[r] = !0, this["isout" === r ? "isover" : "isout"] = !1, this["isover" === r ? "_over" : "_out"].call(this, i), s && "isout" === r && (s.isout = !1, s.isover = !0, s._over.call(s, i)))
                }
            })
        }, dragStop: function (t, i) {
            t.element.parentsUntil("body").off("scroll.droppable"), t.options.refreshPositions || e.ui.ddmanager.prepareOffsets(t, i)
        }
    }, e.uiBackCompat !== !1 && e.widget("ui.droppable", e.ui.droppable, {
        options: {hoverClass: !1, activeClass: !1},
        _addActiveClass: function () {
            this._super(), this.options.activeClass && this.element.addClass(this.options.activeClass)
        },
        _removeActiveClass: function () {
            this._super(), this.options.activeClass && this.element.removeClass(this.options.activeClass)
        },
        _addHoverClass: function () {
            this._super(), this.options.hoverClass && this.element.addClass(this.options.hoverClass)
        },
        _removeHoverClass: function () {
            this._super(), this.options.hoverClass && this.element.removeClass(this.options.hoverClass)
        }
    }), e.ui.droppable, e.widget("ui.resizable", e.ui.mouse, {
        version: "1.12.1",
        widgetEventPrefix: "resize",
        options: {
            alsoResize: !1,
            animate: !1,
            animateDuration: "slow",
            animateEasing: "swing",
            aspectRatio: !1,
            autoHide: !1,
            classes: {"ui-resizable-se": "ui-icon ui-icon-gripsmall-diagonal-se"},
            containment: !1,
            ghost: !1,
            grid: !1,
            handles: "e,s,se",
            helper: !1,
            maxHeight: null,
            maxWidth: null,
            minHeight: 10,
            minWidth: 10,
            zIndex: 90,
            resize: null,
            start: null,
            stop: null
        },
        _num: function (e) {
            return parseFloat(e) || 0
        },
        _isNumber: function (e) {
            return !isNaN(parseFloat(e))
        },
        _hasScroll: function (t, i) {
            if ("hidden" === e(t).css("overflow"))return !1;
            var s = i && "left" === i ? "scrollLeft" : "scrollTop", n = !1;
            return t[s] > 0 ? !0 : (t[s] = 1, n = t[s] > 0, t[s] = 0, n)
        },
        _create: function () {
            var t, i = this.options, s = this;
            this._addClass("ui-resizable"), e.extend(this, {
                _aspectRatio: !!i.aspectRatio,
                aspectRatio: i.aspectRatio,
                originalElement: this.element,
                _proportionallyResizeElements: [],
                _helper: i.helper || i.ghost || i.animate ? i.helper || "ui-resizable-helper" : null
            }), this.element[0].nodeName.match(/^(canvas|textarea|input|select|button|img)$/i) && (this.element.wrap(e("<div class='ui-wrapper' style='overflow: hidden;'></div>").css({
                position: this.element.css("position"),
                width: this.element.outerWidth(),
                height: this.element.outerHeight(),
                top: this.element.css("top"),
                left: this.element.css("left")
            })), this.element = this.element.parent().data("ui-resizable", this.element.resizable("instance")), this.elementIsWrapper = !0, t = {
                marginTop: this.originalElement.css("marginTop"),
                marginRight: this.originalElement.css("marginRight"),
                marginBottom: this.originalElement.css("marginBottom"),
                marginLeft: this.originalElement.css("marginLeft")
            }, this.element.css(t), this.originalElement.css("margin", 0), this.originalResizeStyle = this.originalElement.css("resize"), this.originalElement.css("resize", "none"), this._proportionallyResizeElements.push(this.originalElement.css({
                position: "static",
                zoom: 1,
                display: "block"
            })), this.originalElement.css(t), this._proportionallyResize()), this._setupHandles(), i.autoHide && e(this.element).on("mouseenter", function () {
                i.disabled || (s._removeClass("ui-resizable-autohide"), s._handles.show())
            }).on("mouseleave", function () {
                i.disabled || s.resizing || (s._addClass("ui-resizable-autohide"), s._handles.hide())
            }), this._mouseInit()
        },
        _destroy: function () {
            this._mouseDestroy();
            var t, i = function (t) {
                e(t).removeData("resizable").removeData("ui-resizable").off(".resizable").find(".ui-resizable-handle").remove()
            };
            return this.elementIsWrapper && (i(this.element), t = this.element, this.originalElement.css({
                position: t.css("position"),
                width: t.outerWidth(),
                height: t.outerHeight(),
                top: t.css("top"),
                left: t.css("left")
            }).insertAfter(t), t.remove()), this.originalElement.css("resize", this.originalResizeStyle), i(this.originalElement), this
        },
        _setOption: function (e, t) {
            switch (this._super(e, t), e) {
                case"handles":
                    this._removeHandles(), this._setupHandles();
                    break;
                default:
            }
        },
        _setupHandles: function () {
            var t, i, s, n, a, o = this.options, r = this;
            if (this.handles = o.handles || (e(".ui-resizable-handle", this.element).length ? {
                            n: ".ui-resizable-n",
                            e: ".ui-resizable-e",
                            s: ".ui-resizable-s",
                            w: ".ui-resizable-w",
                            se: ".ui-resizable-se",
                            sw: ".ui-resizable-sw",
                            ne: ".ui-resizable-ne",
                            nw: ".ui-resizable-nw"
                        } : "e,s,se"), this._handles = e(), this.handles.constructor === String)for ("all" === this.handles && (this.handles = "n,e,s,w,se,sw,ne,nw"), s = this.handles.split(","), this.handles = {}, i = 0; s.length > i; i++)t = e.trim(s[i]), n = "ui-resizable-" + t, a = e("<div>"), this._addClass(a, "ui-resizable-handle " + n), a.css({zIndex: o.zIndex}), this.handles[t] = ".ui-resizable-" + t, this.element.append(a);
            this._renderAxis = function (t) {
                var i, s, n, a;
                t = t || this.element;
                for (i in this.handles)this.handles[i].constructor === String ? this.handles[i] = this.element.children(this.handles[i]).first().show() : (this.handles[i].jquery || this.handles[i].nodeType) && (this.handles[i] = e(this.handles[i]), this._on(this.handles[i], {mousedown: r._mouseDown})), this.elementIsWrapper && this.originalElement[0].nodeName.match(/^(textarea|input|select|button)$/i) && (s = e(this.handles[i], this.element), a = /sw|ne|nw|se|n|s/.test(i) ? s.outerHeight() : s.outerWidth(), n = ["padding", /ne|nw|n/.test(i) ? "Top" : /se|sw|s/.test(i) ? "Bottom" : /^e$/.test(i) ? "Right" : "Left"].join(""), t.css(n, a), this._proportionallyResize()), this._handles = this._handles.add(this.handles[i])
            }, this._renderAxis(this.element), this._handles = this._handles.add(this.element.find(".ui-resizable-handle")), this._handles.disableSelection(), this._handles.on("mouseover", function () {
                r.resizing || (this.className && (a = this.className.match(/ui-resizable-(se|sw|ne|nw|n|e|s|w)/i)), r.axis = a && a[1] ? a[1] : "se")
            }), o.autoHide && (this._handles.hide(), this._addClass("ui-resizable-autohide"))
        },
        _removeHandles: function () {
            this._handles.remove()
        },
        _mouseCapture: function (t) {
            var i, s, n = !1;
            for (i in this.handles)s = e(this.handles[i])[0], (s === t.target || e.contains(s, t.target)) && (n = !0);
            return !this.options.disabled && n
        },
        _mouseStart: function (t) {
            var i, s, n, a = this.options, o = this.element;
            return this.resizing = !0, this._renderProxy(), i = this._num(this.helper.css("left")), s = this._num(this.helper.css("top")), a.containment && (i += e(a.containment).scrollLeft() || 0, s += e(a.containment).scrollTop() || 0), this.offset = this.helper.offset(), this.position = {
                left: i,
                top: s
            }, this.size = this._helper ? {
                    width: this.helper.width(),
                    height: this.helper.height()
                } : {width: o.width(), height: o.height()}, this.originalSize = this._helper ? {
                    width: o.outerWidth(),
                    height: o.outerHeight()
                } : {width: o.width(), height: o.height()}, this.sizeDiff = {
                width: o.outerWidth() - o.width(),
                height: o.outerHeight() - o.height()
            }, this.originalPosition = {left: i, top: s}, this.originalMousePosition = {
                left: t.pageX,
                top: t.pageY
            }, this.aspectRatio = "number" == typeof a.aspectRatio ? a.aspectRatio : this.originalSize.width / this.originalSize.height || 1, n = e(".ui-resizable-" + this.axis).css("cursor"), e("body").css("cursor", "auto" === n ? this.axis + "-resize" : n), this._addClass("ui-resizable-resizing"), this._propagate("start", t), !0
        },
        _mouseDrag: function (t) {
            var i, s, n = this.originalMousePosition, a = this.axis, o = t.pageX - n.left || 0, r = t.pageY - n.top || 0, h = this._change[a];
            return this._updatePrevProperties(), h ? (i = h.apply(this, [t, o, r]), this._updateVirtualBoundaries(t.shiftKey), (this._aspectRatio || t.shiftKey) && (i = this._updateRatio(i, t)), i = this._respectSize(i, t), this._updateCache(i), this._propagate("resize", t), s = this._applyChanges(), !this._helper && this._proportionallyResizeElements.length && this._proportionallyResize(), e.isEmptyObject(s) || (this._updatePrevProperties(), this._trigger("resize", t, this.ui()), this._applyChanges()), !1) : !1
        },
        _mouseStop: function (t) {
            this.resizing = !1;
            var i, s, n, a, o, r, h, l = this.options, u = this;
            return this._helper && (i = this._proportionallyResizeElements, s = i.length && /textarea/i.test(i[0].nodeName), n = s && this._hasScroll(i[0], "left") ? 0 : u.sizeDiff.height, a = s ? 0 : u.sizeDiff.width, o = {
                width: u.helper.width() - a,
                height: u.helper.height() - n
            }, r = parseFloat(u.element.css("left")) + (u.position.left - u.originalPosition.left) || null, h = parseFloat(u.element.css("top")) + (u.position.top - u.originalPosition.top) || null, l.animate || this.element.css(e.extend(o, {
                top: h,
                left: r
            })), u.helper.height(u.size.height), u.helper.width(u.size.width), this._helper && !l.animate && this._proportionallyResize()), e("body").css("cursor", "auto"), this._removeClass("ui-resizable-resizing"), this._propagate("stop", t), this._helper && this.helper.remove(), !1
        },
        _updatePrevProperties: function () {
            this.prevPosition = {
                top: this.position.top,
                left: this.position.left
            }, this.prevSize = {width: this.size.width, height: this.size.height}
        },
        _applyChanges: function () {
            var e = {};
            return this.position.top !== this.prevPosition.top && (e.top = this.position.top + "px"), this.position.left !== this.prevPosition.left && (e.left = this.position.left + "px"), this.size.width !== this.prevSize.width && (e.width = this.size.width + "px"), this.size.height !== this.prevSize.height && (e.height = this.size.height + "px"), this.helper.css(e), e
        },
        _updateVirtualBoundaries: function (e) {
            var t, i, s, n, a, o = this.options;
            a = {
                minWidth: this._isNumber(o.minWidth) ? o.minWidth : 0,
                maxWidth: this._isNumber(o.maxWidth) ? o.maxWidth : 1 / 0,
                minHeight: this._isNumber(o.minHeight) ? o.minHeight : 0,
                maxHeight: this._isNumber(o.maxHeight) ? o.maxHeight : 1 / 0
            }, (this._aspectRatio || e) && (t = a.minHeight * this.aspectRatio, s = a.minWidth / this.aspectRatio, i = a.maxHeight * this.aspectRatio, n = a.maxWidth / this.aspectRatio, t > a.minWidth && (a.minWidth = t), s > a.minHeight && (a.minHeight = s), a.maxWidth > i && (a.maxWidth = i), a.maxHeight > n && (a.maxHeight = n)), this._vBoundaries = a
        },
        _updateCache: function (e) {
            this.offset = this.helper.offset(), this._isNumber(e.left) && (this.position.left = e.left), this._isNumber(e.top) && (this.position.top = e.top), this._isNumber(e.height) && (this.size.height = e.height), this._isNumber(e.width) && (this.size.width = e.width)
        },
        _updateRatio: function (e) {
            var t = this.position, i = this.size, s = this.axis;
            return this._isNumber(e.height) ? e.width = e.height * this.aspectRatio : this._isNumber(e.width) && (e.height = e.width / this.aspectRatio), "sw" === s && (e.left = t.left + (i.width - e.width), e.top = null), "nw" === s && (e.top = t.top + (i.height - e.height), e.left = t.left + (i.width - e.width)), e
        },
        _respectSize: function (e) {
            var t = this._vBoundaries, i = this.axis, s = this._isNumber(e.width) && t.maxWidth && t.maxWidth < e.width, n = this._isNumber(e.height) && t.maxHeight && t.maxHeight < e.height, a = this._isNumber(e.width) && t.minWidth && t.minWidth > e.width, o = this._isNumber(e.height) && t.minHeight && t.minHeight > e.height, r = this.originalPosition.left + this.originalSize.width, h = this.originalPosition.top + this.originalSize.height, l = /sw|nw|w/.test(i), u = /nw|ne|n/.test(i);
            return a && (e.width = t.minWidth), o && (e.height = t.minHeight), s && (e.width = t.maxWidth), n && (e.height = t.maxHeight), a && l && (e.left = r - t.minWidth), s && l && (e.left = r - t.maxWidth), o && u && (e.top = h - t.minHeight), n && u && (e.top = h - t.maxHeight), e.width || e.height || e.left || !e.top ? e.width || e.height || e.top || !e.left || (e.left = null) : e.top = null, e
        },
        _getPaddingPlusBorderDimensions: function (e) {
            for (var t = 0, i = [], s = [e.css("borderTopWidth"), e.css("borderRightWidth"), e.css("borderBottomWidth"), e.css("borderLeftWidth")], n = [e.css("paddingTop"), e.css("paddingRight"), e.css("paddingBottom"), e.css("paddingLeft")]; 4 > t; t++)i[t] = parseFloat(s[t]) || 0, i[t] += parseFloat(n[t]) || 0;
            return {height: i[0] + i[2], width: i[1] + i[3]}
        },
        _proportionallyResize: function () {
            if (this._proportionallyResizeElements.length)for (var e, t = 0, i = this.helper || this.element; this._proportionallyResizeElements.length > t; t++)e = this._proportionallyResizeElements[t], this.outerDimensions || (this.outerDimensions = this._getPaddingPlusBorderDimensions(e)), e.css({
                height: i.height() - this.outerDimensions.height || 0,
                width: i.width() - this.outerDimensions.width || 0
            })
        },
        _renderProxy: function () {
            var t = this.element, i = this.options;
            this.elementOffset = t.offset(), this._helper ? (this.helper = this.helper || e("<div style='overflow:hidden;'></div>"), this._addClass(this.helper, this._helper), this.helper.css({
                    width: this.element.outerWidth(),
                    height: this.element.outerHeight(),
                    position: "absolute",
                    left: this.elementOffset.left + "px",
                    top: this.elementOffset.top + "px",
                    zIndex: ++i.zIndex
                }), this.helper.appendTo("body").disableSelection()) : this.helper = this.element
        },
        _change: {
            e: function (e, t) {
                return {width: this.originalSize.width + t}
            }, w: function (e, t) {
                var i = this.originalSize, s = this.originalPosition;
                return {left: s.left + t, width: i.width - t}
            }, n: function (e, t, i) {
                var s = this.originalSize, n = this.originalPosition;
                return {top: n.top + i, height: s.height - i}
            }, s: function (e, t, i) {
                return {height: this.originalSize.height + i}
            }, se: function (t, i, s) {
                return e.extend(this._change.s.apply(this, arguments), this._change.e.apply(this, [t, i, s]))
            }, sw: function (t, i, s) {
                return e.extend(this._change.s.apply(this, arguments), this._change.w.apply(this, [t, i, s]))
            }, ne: function (t, i, s) {
                return e.extend(this._change.n.apply(this, arguments), this._change.e.apply(this, [t, i, s]))
            }, nw: function (t, i, s) {
                return e.extend(this._change.n.apply(this, arguments), this._change.w.apply(this, [t, i, s]))
            }
        },
        _propagate: function (t, i) {
            e.ui.plugin.call(this, t, [i, this.ui()]), "resize" !== t && this._trigger(t, i, this.ui())
        },
        plugins: {},
        ui: function () {
            return {
                originalElement: this.originalElement,
                element: this.element,
                helper: this.helper,
                position: this.position,
                size: this.size,
                originalSize: this.originalSize,
                originalPosition: this.originalPosition
            }
        }
    }), e.ui.plugin.add("resizable", "animate", {
        stop: function (t) {
            var i = e(this).resizable("instance"), s = i.options, n = i._proportionallyResizeElements, a = n.length && /textarea/i.test(n[0].nodeName), o = a && i._hasScroll(n[0], "left") ? 0 : i.sizeDiff.height, r = a ? 0 : i.sizeDiff.width, h = {
                width: i.size.width - r,
                height: i.size.height - o
            }, l = parseFloat(i.element.css("left")) + (i.position.left - i.originalPosition.left) || null, u = parseFloat(i.element.css("top")) + (i.position.top - i.originalPosition.top) || null;
            i.element.animate(e.extend(h, u && l ? {top: u, left: l} : {}), {
                duration: s.animateDuration,
                easing: s.animateEasing,
                step: function () {
                    var s = {
                        width: parseFloat(i.element.css("width")),
                        height: parseFloat(i.element.css("height")),
                        top: parseFloat(i.element.css("top")),
                        left: parseFloat(i.element.css("left"))
                    };
                    n && n.length && e(n[0]).css({
                        width: s.width,
                        height: s.height
                    }), i._updateCache(s), i._propagate("resize", t)
                }
            })
        }
    }), e.ui.plugin.add("resizable", "containment", {
        start: function () {
            var t, i, s, n, a, o, r, h = e(this).resizable("instance"), l = h.options, u = h.element, c = l.containment, d = c instanceof e ? c.get(0) : /parent/.test(c) ? u.parent().get(0) : c;
            d && (h.containerElement = e(d), /document/.test(c) || c === document ? (h.containerOffset = {
                    left: 0,
                    top: 0
                }, h.containerPosition = {left: 0, top: 0}, h.parentData = {
                    element: e(document),
                    left: 0,
                    top: 0,
                    width: e(document).width(),
                    height: e(document).height() || document.body.parentNode.scrollHeight
                }) : (t = e(d), i = [], e(["Top", "Right", "Left", "Bottom"]).each(function (e, s) {
                    i[e] = h._num(t.css("padding" + s))
                }), h.containerOffset = t.offset(), h.containerPosition = t.position(), h.containerSize = {
                    height: t.innerHeight() - i[3],
                    width: t.innerWidth() - i[1]
                }, s = h.containerOffset, n = h.containerSize.height, a = h.containerSize.width, o = h._hasScroll(d, "left") ? d.scrollWidth : a, r = h._hasScroll(d) ? d.scrollHeight : n, h.parentData = {
                    element: d,
                    left: s.left,
                    top: s.top,
                    width: o,
                    height: r
                }))
        }, resize: function (t) {
            var i, s, n, a, o = e(this).resizable("instance"), r = o.options, h = o.containerOffset, l = o.position, u = o._aspectRatio || t.shiftKey, c = {
                top: 0,
                left: 0
            }, d = o.containerElement, p = !0;
            d[0] !== document && /static/.test(d.css("position")) && (c = h), l.left < (o._helper ? h.left : 0) && (o.size.width = o.size.width + (o._helper ? o.position.left - h.left : o.position.left - c.left), u && (o.size.height = o.size.width / o.aspectRatio, p = !1), o.position.left = r.helper ? h.left : 0), l.top < (o._helper ? h.top : 0) && (o.size.height = o.size.height + (o._helper ? o.position.top - h.top : o.position.top), u && (o.size.width = o.size.height * o.aspectRatio, p = !1), o.position.top = o._helper ? h.top : 0), n = o.containerElement.get(0) === o.element.parent().get(0), a = /relative|absolute/.test(o.containerElement.css("position")), n && a ? (o.offset.left = o.parentData.left + o.position.left, o.offset.top = o.parentData.top + o.position.top) : (o.offset.left = o.element.offset().left, o.offset.top = o.element.offset().top), i = Math.abs(o.sizeDiff.width + (o._helper ? o.offset.left - c.left : o.offset.left - h.left)), s = Math.abs(o.sizeDiff.height + (o._helper ? o.offset.top - c.top : o.offset.top - h.top)), i + o.size.width >= o.parentData.width && (o.size.width = o.parentData.width - i, u && (o.size.height = o.size.width / o.aspectRatio, p = !1)), s + o.size.height >= o.parentData.height && (o.size.height = o.parentData.height - s, u && (o.size.width = o.size.height * o.aspectRatio, p = !1)), p || (o.position.left = o.prevPosition.left, o.position.top = o.prevPosition.top, o.size.width = o.prevSize.width, o.size.height = o.prevSize.height)
        }, stop: function () {
            var t = e(this).resizable("instance"), i = t.options, s = t.containerOffset, n = t.containerPosition, a = t.containerElement, o = e(t.helper), r = o.offset(), h = o.outerWidth() - t.sizeDiff.width, l = o.outerHeight() - t.sizeDiff.height;
            t._helper && !i.animate && /relative/.test(a.css("position")) && e(this).css({
                left: r.left - n.left - s.left,
                width: h,
                height: l
            }), t._helper && !i.animate && /static/.test(a.css("position")) && e(this).css({
                left: r.left - n.left - s.left,
                width: h,
                height: l
            })
        }
    }), e.ui.plugin.add("resizable", "alsoResize", {
        start: function () {
            var t = e(this).resizable("instance"), i = t.options;
            e(i.alsoResize).each(function () {
                var t = e(this);
                t.data("ui-resizable-alsoresize", {
                    width: parseFloat(t.width()),
                    height: parseFloat(t.height()),
                    left: parseFloat(t.css("left")),
                    top: parseFloat(t.css("top"))
                })
            })
        }, resize: function (t, i) {
            var s = e(this).resizable("instance"), n = s.options, a = s.originalSize, o = s.originalPosition, r = {
                height: s.size.height - a.height || 0,
                width: s.size.width - a.width || 0,
                top: s.position.top - o.top || 0,
                left: s.position.left - o.left || 0
            };
            e(n.alsoResize).each(function () {
                var t = e(this), s = e(this).data("ui-resizable-alsoresize"), n = {}, a = t.parents(i.originalElement[0]).length ? ["width", "height"] : ["width", "height", "top", "left"];
                e.each(a, function (e, t) {
                    var i = (s[t] || 0) + (r[t] || 0);
                    i && i >= 0 && (n[t] = i || null)
                }), t.css(n)
            })
        }, stop: function () {
            e(this).removeData("ui-resizable-alsoresize")
        }
    }), e.ui.plugin.add("resizable", "ghost", {
        start: function () {
            var t = e(this).resizable("instance"), i = t.size;
            t.ghost = t.originalElement.clone(), t.ghost.css({
                opacity: .25,
                display: "block",
                position: "relative",
                height: i.height,
                width: i.width,
                margin: 0,
                left: 0,
                top: 0
            }), t._addClass(t.ghost, "ui-resizable-ghost"), e.uiBackCompat !== !1 && "string" == typeof t.options.ghost && t.ghost.addClass(this.options.ghost), t.ghost.appendTo(t.helper)
        }, resize: function () {
            var t = e(this).resizable("instance");
            t.ghost && t.ghost.css({position: "relative", height: t.size.height, width: t.size.width})
        }, stop: function () {
            var t = e(this).resizable("instance");
            t.ghost && t.helper && t.helper.get(0).removeChild(t.ghost.get(0))
        }
    }), e.ui.plugin.add("resizable", "grid", {
        resize: function () {
            var t, i = e(this).resizable("instance"), s = i.options, n = i.size, a = i.originalSize, o = i.originalPosition, r = i.axis, h = "number" == typeof s.grid ? [s.grid, s.grid] : s.grid, l = h[0] || 1, u = h[1] || 1, c = Math.round((n.width - a.width) / l) * l, d = Math.round((n.height - a.height) / u) * u, p = a.width + c, f = a.height + d, m = s.maxWidth && p > s.maxWidth, g = s.maxHeight && f > s.maxHeight, v = s.minWidth && s.minWidth > p, _ = s.minHeight && s.minHeight > f;
            s.grid = h, v && (p += l), _ && (f += u), m && (p -= l), g && (f -= u), /^(se|s|e)$/.test(r) ? (i.size.width = p, i.size.height = f) : /^(ne)$/.test(r) ? (i.size.width = p, i.size.height = f, i.position.top = o.top - d) : /^(sw)$/.test(r) ? (i.size.width = p, i.size.height = f, i.position.left = o.left - c) : ((0 >= f - u || 0 >= p - l) && (t = i._getPaddingPlusBorderDimensions(this)), f - u > 0 ? (i.size.height = f, i.position.top = o.top - d) : (f = u - t.height, i.size.height = f, i.position.top = o.top + a.height - f), p - l > 0 ? (i.size.width = p, i.position.left = o.left - c) : (p = l - t.width, i.size.width = p, i.position.left = o.left + a.width - p))
        }
    }), e.ui.resizable, e.widget("ui.selectable", e.ui.mouse, {
        version: "1.12.1",
        options: {
            appendTo: "body",
            autoRefresh: !0,
            distance: 0,
            filter: "*",
            tolerance: "touch",
            selected: null,
            selecting: null,
            start: null,
            stop: null,
            unselected: null,
            unselecting: null
        },
        _create: function () {
            var t = this;
            this._addClass("ui-selectable"), this.dragged = !1, this.refresh = function () {
                t.elementPos = e(t.element[0]).offset(), t.selectees = e(t.options.filter, t.element[0]), t._addClass(t.selectees, "ui-selectee"), t.selectees.each(function () {
                    var i = e(this), s = i.offset(), n = {
                        left: s.left - t.elementPos.left,
                        top: s.top - t.elementPos.top
                    };
                    e.data(this, "selectable-item", {
                        element: this,
                        $element: i,
                        left: n.left,
                        top: n.top,
                        right: n.left + i.outerWidth(),
                        bottom: n.top + i.outerHeight(),
                        startselected: !1,
                        selected: i.hasClass("ui-selected"),
                        selecting: i.hasClass("ui-selecting"),
                        unselecting: i.hasClass("ui-unselecting")
                    })
                })
            }, this.refresh(), this._mouseInit(), this.helper = e("<div>"), this._addClass(this.helper, "ui-selectable-helper")
        },
        _destroy: function () {
            this.selectees.removeData("selectable-item"), this._mouseDestroy()
        },
        _mouseStart: function (t) {
            var i = this, s = this.options;
            this.opos = [t.pageX, t.pageY], this.elementPos = e(this.element[0]).offset(), this.options.disabled || (this.selectees = e(s.filter, this.element[0]), this._trigger("start", t), e(s.appendTo).append(this.helper), this.helper.css({
                left: t.pageX,
                top: t.pageY,
                width: 0,
                height: 0
            }), s.autoRefresh && this.refresh(), this.selectees.filter(".ui-selected").each(function () {
                var s = e.data(this, "selectable-item");
                s.startselected = !0, t.metaKey || t.ctrlKey || (i._removeClass(s.$element, "ui-selected"), s.selected = !1, i._addClass(s.$element, "ui-unselecting"), s.unselecting = !0, i._trigger("unselecting", t, {unselecting: s.element}))
            }), e(t.target).parents().addBack().each(function () {
                var s, n = e.data(this, "selectable-item");
                return n ? (s = !t.metaKey && !t.ctrlKey || !n.$element.hasClass("ui-selected"), i._removeClass(n.$element, s ? "ui-unselecting" : "ui-selected")._addClass(n.$element, s ? "ui-selecting" : "ui-unselecting"), n.unselecting = !s, n.selecting = s, n.selected = s, s ? i._trigger("selecting", t, {selecting: n.element}) : i._trigger("unselecting", t, {unselecting: n.element}), !1) : void 0
            }))
        },
        _mouseDrag: function (t) {
            if (this.dragged = !0, !this.options.disabled) {
                var i, s = this, n = this.options, a = this.opos[0], o = this.opos[1], r = t.pageX, h = t.pageY;
                return a > r && (i = r, r = a, a = i), o > h && (i = h, h = o, o = i), this.helper.css({
                    left: a,
                    top: o,
                    width: r - a,
                    height: h - o
                }), this.selectees.each(function () {
                    var i = e.data(this, "selectable-item"), l = !1, u = {};
                    i && i.element !== s.element[0] && (u.left = i.left + s.elementPos.left, u.right = i.right + s.elementPos.left, u.top = i.top + s.elementPos.top, u.bottom = i.bottom + s.elementPos.top, "touch" === n.tolerance ? l = !(u.left > r || a > u.right || u.top > h || o > u.bottom) : "fit" === n.tolerance && (l = u.left > a && r > u.right && u.top > o && h > u.bottom), l ? (i.selected && (s._removeClass(i.$element, "ui-selected"), i.selected = !1), i.unselecting && (s._removeClass(i.$element, "ui-unselecting"), i.unselecting = !1), i.selecting || (s._addClass(i.$element, "ui-selecting"), i.selecting = !0, s._trigger("selecting", t, {selecting: i.element}))) : (i.selecting && ((t.metaKey || t.ctrlKey) && i.startselected ? (s._removeClass(i.$element, "ui-selecting"), i.selecting = !1, s._addClass(i.$element, "ui-selected"), i.selected = !0) : (s._removeClass(i.$element, "ui-selecting"), i.selecting = !1, i.startselected && (s._addClass(i.$element, "ui-unselecting"), i.unselecting = !0), s._trigger("unselecting", t, {unselecting: i.element}))), i.selected && (t.metaKey || t.ctrlKey || i.startselected || (s._removeClass(i.$element, "ui-selected"), i.selected = !1, s._addClass(i.$element, "ui-unselecting"), i.unselecting = !0, s._trigger("unselecting", t, {unselecting: i.element})))))
                }), !1
            }
        },
        _mouseStop: function (t) {
            var i = this;
            return this.dragged = !1, e(".ui-unselecting", this.element[0]).each(function () {
                var s = e.data(this, "selectable-item");
                i._removeClass(s.$element, "ui-unselecting"), s.unselecting = !1, s.startselected = !1, i._trigger("unselected", t, {unselected: s.element})
            }), e(".ui-selecting", this.element[0]).each(function () {
                var s = e.data(this, "selectable-item");
                i._removeClass(s.$element, "ui-selecting")._addClass(s.$element, "ui-selected"), s.selecting = !1, s.selected = !0, s.startselected = !0, i._trigger("selected", t, {selected: s.element})
            }), this._trigger("stop", t), this.helper.remove(), !1
        }
    }), e.widget("ui.sortable", e.ui.mouse, {
        version: "1.12.1",
        widgetEventPrefix: "sort",
        ready: !1,
        options: {
            appendTo: "parent",
            axis: !1,
            connectWith: !1,
            containment: !1,
            cursor: "auto",
            cursorAt: !1,
            dropOnEmpty: !0,
            forcePlaceholderSize: !1,
            forceHelperSize: !1,
            grid: !1,
            handle: !1,
            helper: "original",
            items: "> *",
            opacity: !1,
            placeholder: !1,
            revert: !1,
            scroll: !0,
            scrollSensitivity: 20,
            scrollSpeed: 20,
            scope: "default",
            tolerance: "intersect",
            zIndex: 1e3,
            activate: null,
            beforeStop: null,
            change: null,
            deactivate: null,
            out: null,
            over: null,
            receive: null,
            remove: null,
            sort: null,
            start: null,
            stop: null,
            update: null
        },
        _isOverAxis: function (e, t, i) {
            return e >= t && t + i > e
        },
        _isFloating: function (e) {
            return /left|right/.test(e.css("float")) || /inline|table-cell/.test(e.css("display"))
        },
        _create: function () {
            this.containerCache = {}, this._addClass("ui-sortable"), this.refresh(), this.offset = this.element.offset(), this._mouseInit(), this._setHandleClassName(), this.ready = !0
        },
        _setOption: function (e, t) {
            this._super(e, t), "handle" === e && this._setHandleClassName()
        },
        _setHandleClassName: function () {
            var t = this;
            this._removeClass(this.element.find(".ui-sortable-handle"), "ui-sortable-handle"), e.each(this.items, function () {
                t._addClass(this.instance.options.handle ? this.item.find(this.instance.options.handle) : this.item, "ui-sortable-handle")
            })
        },
        _destroy: function () {
            this._mouseDestroy();
            for (var e = this.items.length - 1; e >= 0; e--)this.items[e].item.removeData(this.widgetName + "-item");
            return this
        },
        _mouseCapture: function (t, i) {
            var s = null, n = !1, a = this;
            return this.reverting ? !1 : this.options.disabled || "static" === this.options.type ? !1 : (this._refreshItems(t), e(t.target).parents().each(function () {
                        return e.data(this, a.widgetName + "-item") === a ? (s = e(this), !1) : void 0
                    }), e.data(t.target, a.widgetName + "-item") === a && (s = e(t.target)), s ? !this.options.handle || i || (e(this.options.handle, s).find("*").addBack().each(function () {
                            this === t.target && (n = !0)
                        }), n) ? (this.currentItem = s, this._removeCurrentsFromItems(), !0) : !1 : !1)
        },
        _mouseStart: function (t, i, s) {
            var n, a, o = this.options;
            if (this.currentContainer = this, this.refreshPositions(), this.helper = this._createHelper(t), this._cacheHelperProportions(), this._cacheMargins(), this.scrollParent = this.helper.scrollParent(), this.offset = this.currentItem.offset(), this.offset = {
                    top: this.offset.top - this.margins.top,
                    left: this.offset.left - this.margins.left
                }, e.extend(this.offset, {
                    click: {left: t.pageX - this.offset.left, top: t.pageY - this.offset.top},
                    parent: this._getParentOffset(),
                    relative: this._getRelativeOffset()
                }), this.helper.css("position", "absolute"), this.cssPosition = this.helper.css("position"), this.originalPosition = this._generatePosition(t), this.originalPageX = t.pageX, this.originalPageY = t.pageY, o.cursorAt && this._adjustOffsetFromHelper(o.cursorAt), this.domPosition = {
                    prev: this.currentItem.prev()[0],
                    parent: this.currentItem.parent()[0]
                }, this.helper[0] !== this.currentItem[0] && this.currentItem.hide(), this._createPlaceholder(), o.containment && this._setContainment(), o.cursor && "auto" !== o.cursor && (a = this.document.find("body"), this.storedCursor = a.css("cursor"), a.css("cursor", o.cursor), this.storedStylesheet = e("<style>*{ cursor: " + o.cursor + " !important; }</style>").appendTo(a)), o.opacity && (this.helper.css("opacity") && (this._storedOpacity = this.helper.css("opacity")), this.helper.css("opacity", o.opacity)), o.zIndex && (this.helper.css("zIndex") && (this._storedZIndex = this.helper.css("zIndex")), this.helper.css("zIndex", o.zIndex)), this.scrollParent[0] !== this.document[0] && "HTML" !== this.scrollParent[0].tagName && (this.overflowOffset = this.scrollParent.offset()), this._trigger("start", t, this._uiHash()), this._preserveHelperProportions || this._cacheHelperProportions(), !s)for (n = this.containers.length - 1; n >= 0; n--)this.containers[n]._trigger("activate", t, this._uiHash(this));
            return e.ui.ddmanager && (e.ui.ddmanager.current = this), e.ui.ddmanager && !o.dropBehaviour && e.ui.ddmanager.prepareOffsets(this, t), this.dragging = !0, this._addClass(this.helper, "ui-sortable-helper"), this._mouseDrag(t), !0
        },
        _mouseDrag: function (t) {
            var i, s, n, a, o = this.options, r = !1;
            for (this.position = this._generatePosition(t), this.positionAbs = this._convertPositionTo("absolute"), this.lastPositionAbs || (this.lastPositionAbs = this.positionAbs), this.options.scroll && (this.scrollParent[0] !== this.document[0] && "HTML" !== this.scrollParent[0].tagName ? (this.overflowOffset.top + this.scrollParent[0].offsetHeight - t.pageY < o.scrollSensitivity ? this.scrollParent[0].scrollTop = r = this.scrollParent[0].scrollTop + o.scrollSpeed : t.pageY - this.overflowOffset.top < o.scrollSensitivity && (this.scrollParent[0].scrollTop = r = this.scrollParent[0].scrollTop - o.scrollSpeed), this.overflowOffset.left + this.scrollParent[0].offsetWidth - t.pageX < o.scrollSensitivity ? this.scrollParent[0].scrollLeft = r = this.scrollParent[0].scrollLeft + o.scrollSpeed : t.pageX - this.overflowOffset.left < o.scrollSensitivity && (this.scrollParent[0].scrollLeft = r = this.scrollParent[0].scrollLeft - o.scrollSpeed)) : (t.pageY - this.document.scrollTop() < o.scrollSensitivity ? r = this.document.scrollTop(this.document.scrollTop() - o.scrollSpeed) : this.window.height() - (t.pageY - this.document.scrollTop()) < o.scrollSensitivity && (r = this.document.scrollTop(this.document.scrollTop() + o.scrollSpeed)), t.pageX - this.document.scrollLeft() < o.scrollSensitivity ? r = this.document.scrollLeft(this.document.scrollLeft() - o.scrollSpeed) : this.window.width() - (t.pageX - this.document.scrollLeft()) < o.scrollSensitivity && (r = this.document.scrollLeft(this.document.scrollLeft() + o.scrollSpeed))), r !== !1 && e.ui.ddmanager && !o.dropBehaviour && e.ui.ddmanager.prepareOffsets(this, t)), this.positionAbs = this._convertPositionTo("absolute"), this.options.axis && "y" === this.options.axis || (this.helper[0].style.left = this.position.left + "px"), this.options.axis && "x" === this.options.axis || (this.helper[0].style.top = this.position.top + "px"), i = this.items.length - 1; i >= 0; i--)if (s = this.items[i], n = s.item[0], a = this._intersectsWithPointer(s), a && s.instance === this.currentContainer && n !== this.currentItem[0] && this.placeholder[1 === a ? "next" : "prev"]()[0] !== n && !e.contains(this.placeholder[0], n) && ("semi-dynamic" === this.options.type ? !e.contains(this.element[0], n) : !0)) {
                if (this.direction = 1 === a ? "down" : "up", "pointer" !== this.options.tolerance && !this._intersectsWithSides(s))break;
                this._rearrange(t, s), this._trigger("change", t, this._uiHash());
                break
            }
            return this._contactContainers(t), e.ui.ddmanager && e.ui.ddmanager.drag(this, t), this._trigger("sort", t, this._uiHash()), this.lastPositionAbs = this.positionAbs, !1
        },
        _mouseStop: function (t, i) {
            if (t) {
                if (e.ui.ddmanager && !this.options.dropBehaviour && e.ui.ddmanager.drop(this, t), this.options.revert) {
                    var s = this, n = this.placeholder.offset(), a = this.options.axis, o = {};
                    a && "x" !== a || (o.left = n.left - this.offset.parent.left - this.margins.left + (this.offsetParent[0] === this.document[0].body ? 0 : this.offsetParent[0].scrollLeft)), a && "y" !== a || (o.top = n.top - this.offset.parent.top - this.margins.top + (this.offsetParent[0] === this.document[0].body ? 0 : this.offsetParent[0].scrollTop)), this.reverting = !0, e(this.helper).animate(o, parseInt(this.options.revert, 10) || 500, function () {
                        s._clear(t)
                    })
                } else this._clear(t, i);
                return !1
            }
        },
        cancel: function () {
            if (this.dragging) {
                this._mouseUp(new e.Event("mouseup", {target: null})), "original" === this.options.helper ? (this.currentItem.css(this._storedCSS), this._removeClass(this.currentItem, "ui-sortable-helper")) : this.currentItem.show();
                for (var t = this.containers.length - 1; t >= 0; t--)this.containers[t]._trigger("deactivate", null, this._uiHash(this)), this.containers[t].containerCache.over && (this.containers[t]._trigger("out", null, this._uiHash(this)), this.containers[t].containerCache.over = 0)
            }
            return this.placeholder && (this.placeholder[0].parentNode && this.placeholder[0].parentNode.removeChild(this.placeholder[0]), "original" !== this.options.helper && this.helper && this.helper[0].parentNode && this.helper.remove(), e.extend(this, {
                helper: null,
                dragging: !1,
                reverting: !1,
                _noFinalSort: null
            }), this.domPosition.prev ? e(this.domPosition.prev).after(this.currentItem) : e(this.domPosition.parent).prepend(this.currentItem)), this
        },
        serialize: function (t) {
            var i = this._getItemsAsjQuery(t && t.connected), s = [];
            return t = t || {}, e(i).each(function () {
                var i = (e(t.item || this).attr(t.attribute || "id") || "").match(t.expression || /(.+)[\-=_](.+)/);
                i && s.push((t.key || i[1] + "[]") + "=" + (t.key && t.expression ? i[1] : i[2]))
            }), !s.length && t.key && s.push(t.key + "="), s.join("&")
        },
        toArray: function (t) {
            var i = this._getItemsAsjQuery(t && t.connected), s = [];
            return t = t || {}, i.each(function () {
                s.push(e(t.item || this).attr(t.attribute || "id") || "")
            }), s
        },
        _intersectsWith: function (e) {
            var t = this.positionAbs.left, i = t + this.helperProportions.width, s = this.positionAbs.top, n = s + this.helperProportions.height, a = e.left, o = a + e.width, r = e.top, h = r + e.height, l = this.offset.click.top, u = this.offset.click.left, c = "x" === this.options.axis || s + l > r && h > s + l, d = "y" === this.options.axis || t + u > a && o > t + u, p = c && d;
            return "pointer" === this.options.tolerance || this.options.forcePointerForContainers || "pointer" !== this.options.tolerance && this.helperProportions[this.floating ? "width" : "height"] > e[this.floating ? "width" : "height"] ? p : t + this.helperProportions.width / 2 > a && o > i - this.helperProportions.width / 2 && s + this.helperProportions.height / 2 > r && h > n - this.helperProportions.height / 2
        },
        _intersectsWithPointer: function (e) {
            var t, i, s = "x" === this.options.axis || this._isOverAxis(this.positionAbs.top + this.offset.click.top, e.top, e.height), n = "y" === this.options.axis || this._isOverAxis(this.positionAbs.left + this.offset.click.left, e.left, e.width), a = s && n;
            return a ? (t = this._getDragVerticalDirection(), i = this._getDragHorizontalDirection(), this.floating ? "right" === i || "down" === t ? 2 : 1 : t && ("down" === t ? 2 : 1)) : !1
        },
        _intersectsWithSides: function (e) {
            var t = this._isOverAxis(this.positionAbs.top + this.offset.click.top, e.top + e.height / 2, e.height), i = this._isOverAxis(this.positionAbs.left + this.offset.click.left, e.left + e.width / 2, e.width), s = this._getDragVerticalDirection(), n = this._getDragHorizontalDirection();
            return this.floating && n ? "right" === n && i || "left" === n && !i : s && ("down" === s && t || "up" === s && !t)
        },
        _getDragVerticalDirection: function () {
            var e = this.positionAbs.top - this.lastPositionAbs.top;
            return 0 !== e && (e > 0 ? "down" : "up")
        },
        _getDragHorizontalDirection: function () {
            var e = this.positionAbs.left - this.lastPositionAbs.left;
            return 0 !== e && (e > 0 ? "right" : "left")
        },
        refresh: function (e) {
            return this._refreshItems(e), this._setHandleClassName(), this.refreshPositions(), this
        },
        _connectWith: function () {
            var e = this.options;
            return e.connectWith.constructor === String ? [e.connectWith] : e.connectWith
        },
        _getItemsAsjQuery: function (t) {
            function i() {
                r.push(this)
            }

            var s, n, a, o, r = [], h = [], l = this._connectWith();
            if (l && t)for (s = l.length - 1; s >= 0; s--)for (a = e(l[s], this.document[0]), n = a.length - 1; n >= 0; n--)o = e.data(a[n], this.widgetFullName), o && o !== this && !o.options.disabled && h.push([e.isFunction(o.options.items) ? o.options.items.call(o.element) : e(o.options.items, o.element).not(".ui-sortable-helper").not(".ui-sortable-placeholder"), o]);
            for (h.push([e.isFunction(this.options.items) ? this.options.items.call(this.element, null, {
                    options: this.options,
                    item: this.currentItem
                }) : e(this.options.items, this.element).not(".ui-sortable-helper").not(".ui-sortable-placeholder"), this]), s = h.length - 1; s >= 0; s--)h[s][0].each(i);
            return e(r)
        },
        _removeCurrentsFromItems: function () {
            var t = this.currentItem.find(":data(" + this.widgetName + "-item)");
            this.items = e.grep(this.items, function (e) {
                for (var i = 0; t.length > i; i++)if (t[i] === e.item[0])return !1;
                return !0
            })
        },
        _refreshItems: function (t) {
            this.items = [], this.containers = [this];
            var i, s, n, a, o, r, h, l, u = this.items, c = [[e.isFunction(this.options.items) ? this.options.items.call(this.element[0], t, {item: this.currentItem}) : e(this.options.items, this.element), this]], d = this._connectWith();
            if (d && this.ready)for (i = d.length - 1; i >= 0; i--)for (n = e(d[i], this.document[0]), s = n.length - 1; s >= 0; s--)a = e.data(n[s], this.widgetFullName), a && a !== this && !a.options.disabled && (c.push([e.isFunction(a.options.items) ? a.options.items.call(a.element[0], t, {item: this.currentItem}) : e(a.options.items, a.element), a]), this.containers.push(a));
            for (i = c.length - 1; i >= 0; i--)for (o = c[i][1], r = c[i][0], s = 0, l = r.length; l > s; s++)h = e(r[s]), h.data(this.widgetName + "-item", o), u.push({
                item: h,
                instance: o,
                width: 0,
                height: 0,
                left: 0,
                top: 0
            })
        },
        refreshPositions: function (t) {
            this.floating = this.items.length ? "x" === this.options.axis || this._isFloating(this.items[0].item) : !1, this.offsetParent && this.helper && (this.offset.parent = this._getParentOffset());
            var i, s, n, a;
            for (i = this.items.length - 1; i >= 0; i--)s = this.items[i], s.instance !== this.currentContainer && this.currentContainer && s.item[0] !== this.currentItem[0] || (n = this.options.toleranceElement ? e(this.options.toleranceElement, s.item) : s.item, t || (s.width = n.outerWidth(), s.height = n.outerHeight()), a = n.offset(), s.left = a.left, s.top = a.top);
            if (this.options.custom && this.options.custom.refreshContainers) this.options.custom.refreshContainers.call(this); else for (i = this.containers.length - 1; i >= 0; i--)a = this.containers[i].element.offset(), this.containers[i].containerCache.left = a.left, this.containers[i].containerCache.top = a.top, this.containers[i].containerCache.width = this.containers[i].element.outerWidth(), this.containers[i].containerCache.height = this.containers[i].element.outerHeight();
            return this
        },
        _createPlaceholder: function (t) {
            t = t || this;
            var i, s = t.options;
            s.placeholder && s.placeholder.constructor !== String || (i = s.placeholder, s.placeholder = {
                element: function () {
                    var s = t.currentItem[0].nodeName.toLowerCase(), n = e("<" + s + ">", t.document[0]);
                    return t._addClass(n, "ui-sortable-placeholder", i || t.currentItem[0].className)._removeClass(n, "ui-sortable-helper"), "tbody" === s ? t._createTrPlaceholder(t.currentItem.find("tr").eq(0), e("<tr>", t.document[0]).appendTo(n)) : "tr" === s ? t._createTrPlaceholder(t.currentItem, n) : "img" === s && n.attr("src", t.currentItem.attr("src")), i || n.css("visibility", "hidden"), n
                }, update: function (e, n) {
                    (!i || s.forcePlaceholderSize) && (n.height() || n.height(t.currentItem.innerHeight() - parseInt(t.currentItem.css("paddingTop") || 0, 10) - parseInt(t.currentItem.css("paddingBottom") || 0, 10)), n.width() || n.width(t.currentItem.innerWidth() - parseInt(t.currentItem.css("paddingLeft") || 0, 10) - parseInt(t.currentItem.css("paddingRight") || 0, 10)))
                }
            }), t.placeholder = e(s.placeholder.element.call(t.element, t.currentItem)), t.currentItem.after(t.placeholder), s.placeholder.update(t, t.placeholder)
        },
        _createTrPlaceholder: function (t, i) {
            var s = this;
            t.children().each(function () {
                e("<td>&#160;</td>", s.document[0]).attr("colspan", e(this).attr("colspan") || 1).appendTo(i)
            })
        },
        _contactContainers: function (t) {
            var i, s, n, a, o, r, h, l, u, c, d = null, p = null;
            for (i = this.containers.length - 1; i >= 0; i--)if (!e.contains(this.currentItem[0], this.containers[i].element[0]))if (this._intersectsWith(this.containers[i].containerCache)) {
                if (d && e.contains(this.containers[i].element[0], d.element[0]))continue;
                d = this.containers[i], p = i
            } else this.containers[i].containerCache.over && (this.containers[i]._trigger("out", t, this._uiHash(this)), this.containers[i].containerCache.over = 0);
            if (d)if (1 === this.containers.length) this.containers[p].containerCache.over || (this.containers[p]._trigger("over", t, this._uiHash(this)), this.containers[p].containerCache.over = 1); else {
                for (n = 1e4, a = null, u = d.floating || this._isFloating(this.currentItem), o = u ? "left" : "top", r = u ? "width" : "height", c = u ? "pageX" : "pageY", s = this.items.length - 1; s >= 0; s--)e.contains(this.containers[p].element[0], this.items[s].item[0]) && this.items[s].item[0] !== this.currentItem[0] && (h = this.items[s].item.offset()[o], l = !1, t[c] - h > this.items[s][r] / 2 && (l = !0), n > Math.abs(t[c] - h) && (n = Math.abs(t[c] - h), a = this.items[s], this.direction = l ? "up" : "down"));
                if (!a && !this.options.dropOnEmpty)return;
                if (this.currentContainer === this.containers[p])return this.currentContainer.containerCache.over || (this.containers[p]._trigger("over", t, this._uiHash()), this.currentContainer.containerCache.over = 1), void 0;
                a ? this._rearrange(t, a, null, !0) : this._rearrange(t, null, this.containers[p].element, !0), this._trigger("change", t, this._uiHash()), this.containers[p]._trigger("change", t, this._uiHash(this)), this.currentContainer = this.containers[p], this.options.placeholder.update(this.currentContainer, this.placeholder), this.containers[p]._trigger("over", t, this._uiHash(this)), this.containers[p].containerCache.over = 1
            }
        },
        _createHelper: function (t) {
            var i = this.options, s = e.isFunction(i.helper) ? e(i.helper.apply(this.element[0], [t, this.currentItem])) : "clone" === i.helper ? this.currentItem.clone() : this.currentItem;
            return s.parents("body").length || e("parent" !== i.appendTo ? i.appendTo : this.currentItem[0].parentNode)[0].appendChild(s[0]), s[0] === this.currentItem[0] && (this._storedCSS = {
                width: this.currentItem[0].style.width,
                height: this.currentItem[0].style.height,
                position: this.currentItem.css("position"),
                top: this.currentItem.css("top"),
                left: this.currentItem.css("left")
            }), (!s[0].style.width || i.forceHelperSize) && s.width(this.currentItem.width()), (!s[0].style.height || i.forceHelperSize) && s.height(this.currentItem.height()), s
        },
        _adjustOffsetFromHelper: function (t) {
            "string" == typeof t && (t = t.split(" ")), e.isArray(t) && (t = {
                left: +t[0],
                top: +t[1] || 0
            }), "left" in t && (this.offset.click.left = t.left + this.margins.left), "right" in t && (this.offset.click.left = this.helperProportions.width - t.right + this.margins.left), "top" in t && (this.offset.click.top = t.top + this.margins.top), "bottom" in t && (this.offset.click.top = this.helperProportions.height - t.bottom + this.margins.top)
        },
        _getParentOffset: function () {
            this.offsetParent = this.helper.offsetParent();
            var t = this.offsetParent.offset();
            return "absolute" === this.cssPosition && this.scrollParent[0] !== this.document[0] && e.contains(this.scrollParent[0], this.offsetParent[0]) && (t.left += this.scrollParent.scrollLeft(), t.top += this.scrollParent.scrollTop()), (this.offsetParent[0] === this.document[0].body || this.offsetParent[0].tagName && "html" === this.offsetParent[0].tagName.toLowerCase() && e.ui.ie) && (t = {
                top: 0,
                left: 0
            }), {
                top: t.top + (parseInt(this.offsetParent.css("borderTopWidth"), 10) || 0),
                left: t.left + (parseInt(this.offsetParent.css("borderLeftWidth"), 10) || 0)
            }
        },
        _getRelativeOffset: function () {
            if ("relative" === this.cssPosition) {
                var e = this.currentItem.position();
                return {
                    top: e.top - (parseInt(this.helper.css("top"), 10) || 0) + this.scrollParent.scrollTop(),
                    left: e.left - (parseInt(this.helper.css("left"), 10) || 0) + this.scrollParent.scrollLeft()
                }
            }
            return {top: 0, left: 0}
        },
        _cacheMargins: function () {
            this.margins = {
                left: parseInt(this.currentItem.css("marginLeft"), 10) || 0,
                top: parseInt(this.currentItem.css("marginTop"), 10) || 0
            }
        },
        _cacheHelperProportions: function () {
            this.helperProportions = {width: this.helper.outerWidth(), height: this.helper.outerHeight()}
        },
        _setContainment: function () {
            var t, i, s, n = this.options;
            "parent" === n.containment && (n.containment = this.helper[0].parentNode), ("document" === n.containment || "window" === n.containment) && (this.containment = [0 - this.offset.relative.left - this.offset.parent.left, 0 - this.offset.relative.top - this.offset.parent.top, "document" === n.containment ? this.document.width() : this.window.width() - this.helperProportions.width - this.margins.left, ("document" === n.containment ? this.document.height() || document.body.parentNode.scrollHeight : this.window.height() || this.document[0].body.parentNode.scrollHeight) - this.helperProportions.height - this.margins.top]), /^(document|window|parent)$/.test(n.containment) || (t = e(n.containment)[0], i = e(n.containment).offset(), s = "hidden" !== e(t).css("overflow"), this.containment = [i.left + (parseInt(e(t).css("borderLeftWidth"), 10) || 0) + (parseInt(e(t).css("paddingLeft"), 10) || 0) - this.margins.left, i.top + (parseInt(e(t).css("borderTopWidth"), 10) || 0) + (parseInt(e(t).css("paddingTop"), 10) || 0) - this.margins.top, i.left + (s ? Math.max(t.scrollWidth, t.offsetWidth) : t.offsetWidth) - (parseInt(e(t).css("borderLeftWidth"), 10) || 0) - (parseInt(e(t).css("paddingRight"), 10) || 0) - this.helperProportions.width - this.margins.left, i.top + (s ? Math.max(t.scrollHeight, t.offsetHeight) : t.offsetHeight) - (parseInt(e(t).css("borderTopWidth"), 10) || 0) - (parseInt(e(t).css("paddingBottom"), 10) || 0) - this.helperProportions.height - this.margins.top])
        },
        _convertPositionTo: function (t, i) {
            i || (i = this.position);
            var s = "absolute" === t ? 1 : -1, n = "absolute" !== this.cssPosition || this.scrollParent[0] !== this.document[0] && e.contains(this.scrollParent[0], this.offsetParent[0]) ? this.scrollParent : this.offsetParent, a = /(html|body)/i.test(n[0].tagName);
            return {
                top: i.top + this.offset.relative.top * s + this.offset.parent.top * s - ("fixed" === this.cssPosition ? -this.scrollParent.scrollTop() : a ? 0 : n.scrollTop()) * s,
                left: i.left + this.offset.relative.left * s + this.offset.parent.left * s - ("fixed" === this.cssPosition ? -this.scrollParent.scrollLeft() : a ? 0 : n.scrollLeft()) * s
            }
        },
        _generatePosition: function (t) {
            var i, s, n = this.options, a = t.pageX, o = t.pageY, r = "absolute" !== this.cssPosition || this.scrollParent[0] !== this.document[0] && e.contains(this.scrollParent[0], this.offsetParent[0]) ? this.scrollParent : this.offsetParent, h = /(html|body)/i.test(r[0].tagName);
            return "relative" !== this.cssPosition || this.scrollParent[0] !== this.document[0] && this.scrollParent[0] !== this.offsetParent[0] || (this.offset.relative = this._getRelativeOffset()), this.originalPosition && (this.containment && (t.pageX - this.offset.click.left < this.containment[0] && (a = this.containment[0] + this.offset.click.left), t.pageY - this.offset.click.top < this.containment[1] && (o = this.containment[1] + this.offset.click.top), t.pageX - this.offset.click.left > this.containment[2] && (a = this.containment[2] + this.offset.click.left), t.pageY - this.offset.click.top > this.containment[3] && (o = this.containment[3] + this.offset.click.top)), n.grid && (i = this.originalPageY + Math.round((o - this.originalPageY) / n.grid[1]) * n.grid[1], o = this.containment ? i - this.offset.click.top >= this.containment[1] && i - this.offset.click.top <= this.containment[3] ? i : i - this.offset.click.top >= this.containment[1] ? i - n.grid[1] : i + n.grid[1] : i, s = this.originalPageX + Math.round((a - this.originalPageX) / n.grid[0]) * n.grid[0], a = this.containment ? s - this.offset.click.left >= this.containment[0] && s - this.offset.click.left <= this.containment[2] ? s : s - this.offset.click.left >= this.containment[0] ? s - n.grid[0] : s + n.grid[0] : s)), {
                top: o - this.offset.click.top - this.offset.relative.top - this.offset.parent.top + ("fixed" === this.cssPosition ? -this.scrollParent.scrollTop() : h ? 0 : r.scrollTop()),
                left: a - this.offset.click.left - this.offset.relative.left - this.offset.parent.left + ("fixed" === this.cssPosition ? -this.scrollParent.scrollLeft() : h ? 0 : r.scrollLeft())
            }
        },
        _rearrange: function (e, t, i, s) {
            i ? i[0].appendChild(this.placeholder[0]) : t.item[0].parentNode.insertBefore(this.placeholder[0], "down" === this.direction ? t.item[0] : t.item[0].nextSibling), this.counter = this.counter ? ++this.counter : 1;
            var n = this.counter;
            this._delay(function () {
                n === this.counter && this.refreshPositions(!s)
            })
        },
        _clear: function (e, t) {
            function i(e, t, i) {
                return function (s) {
                    i._trigger(e, s, t._uiHash(t))
                }
            }

            this.reverting = !1;
            var s, n = [];
            if (!this._noFinalSort && this.currentItem.parent().length && this.placeholder.before(this.currentItem), this._noFinalSort = null, this.helper[0] === this.currentItem[0]) {
                for (s in this._storedCSS)("auto" === this._storedCSS[s] || "static" === this._storedCSS[s]) && (this._storedCSS[s] = "");
                this.currentItem.css(this._storedCSS), this._removeClass(this.currentItem, "ui-sortable-helper")
            } else this.currentItem.show();
            for (this.fromOutside && !t && n.push(function (e) {
                this._trigger("receive", e, this._uiHash(this.fromOutside))
            }), !this.fromOutside && this.domPosition.prev === this.currentItem.prev().not(".ui-sortable-helper")[0] && this.domPosition.parent === this.currentItem.parent()[0] || t || n.push(function (e) {
                this._trigger("update", e, this._uiHash())
            }), this !== this.currentContainer && (t || (n.push(function (e) {
                this._trigger("remove", e, this._uiHash())
            }), n.push(function (e) {
                return function (t) {
                    e._trigger("receive", t, this._uiHash(this))
                }
            }.call(this, this.currentContainer)), n.push(function (e) {
                return function (t) {
                    e._trigger("update", t, this._uiHash(this))
                }
            }.call(this, this.currentContainer)))), s = this.containers.length - 1; s >= 0; s--)t || n.push(i("deactivate", this, this.containers[s])), this.containers[s].containerCache.over && (n.push(i("out", this, this.containers[s])), this.containers[s].containerCache.over = 0);
            if (this.storedCursor && (this.document.find("body").css("cursor", this.storedCursor), this.storedStylesheet.remove()), this._storedOpacity && this.helper.css("opacity", this._storedOpacity), this._storedZIndex && this.helper.css("zIndex", "auto" === this._storedZIndex ? "" : this._storedZIndex), this.dragging = !1, t || this._trigger("beforeStop", e, this._uiHash()), this.placeholder[0].parentNode.removeChild(this.placeholder[0]), this.cancelHelperRemoval || (this.helper[0] !== this.currentItem[0] && this.helper.remove(), this.helper = null), !t) {
                for (s = 0; n.length > s; s++)n[s].call(this, e);
                this._trigger("stop", e, this._uiHash())
            }
            return this.fromOutside = !1, !this.cancelHelperRemoval
        },
        _trigger: function () {
            e.Widget.prototype._trigger.apply(this, arguments) === !1 && this.cancel()
        },
        _uiHash: function (t) {
            var i = t || this;
            return {
                helper: i.helper,
                placeholder: i.placeholder || e([]),
                position: i.position,
                originalPosition: i.originalPosition,
                offset: i.positionAbs,
                item: i.currentItem,
                sender: t ? t.element : null
            }
        }
    }), e.widget("ui.accordion", {
        version: "1.12.1",
        options: {
            active: 0,
            animate: {},
            classes: {
                "ui-accordion-header": "ui-corner-top",
                "ui-accordion-header-collapsed": "ui-corner-all",
                "ui-accordion-content": "ui-corner-bottom"
            },
            collapsible: !1,
            event: "click",
            header: "> li > :first-child, > :not(li):even",
            heightStyle: "auto",
            icons: {activeHeader: "ui-icon-triangle-1-s", header: "ui-icon-triangle-1-e"},
            activate: null,
            beforeActivate: null
        },
        hideProps: {
            borderTopWidth: "hide",
            borderBottomWidth: "hide",
            paddingTop: "hide",
            paddingBottom: "hide",
            height: "hide"
        },
        showProps: {
            borderTopWidth: "show",
            borderBottomWidth: "show",
            paddingTop: "show",
            paddingBottom: "show",
            height: "show"
        },
        _create: function () {
            var t = this.options;
            this.prevShow = this.prevHide = e(), this._addClass("ui-accordion", "ui-widget ui-helper-reset"), this.element.attr("role", "tablist"), t.collapsible || t.active !== !1 && null != t.active || (t.active = 0), this._processPanels(), 0 > t.active && (t.active += this.headers.length), this._refresh()
        },
        _getCreateEventData: function () {
            return {header: this.active, panel: this.active.length ? this.active.next() : e()}
        },
        _createIcons: function () {
            var t, i, s = this.options.icons;
            s && (t = e("<span>"), this._addClass(t, "ui-accordion-header-icon", "ui-icon " + s.header), t.prependTo(this.headers), i = this.active.children(".ui-accordion-header-icon"), this._removeClass(i, s.header)._addClass(i, null, s.activeHeader)._addClass(this.headers, "ui-accordion-icons"))
        },
        _destroyIcons: function () {
            this._removeClass(this.headers, "ui-accordion-icons"), this.headers.children(".ui-accordion-header-icon").remove()
        },
        _destroy: function () {
            var e;
            this.element.removeAttr("role"), this.headers.removeAttr("role aria-expanded aria-selected aria-controls tabIndex").removeUniqueId(), this._destroyIcons(), e = this.headers.next().css("display", "").removeAttr("role aria-hidden aria-labelledby").removeUniqueId(), "content" !== this.options.heightStyle && e.css("height", "")
        },
        _setOption: function (e, t) {
            return "active" === e ? (this._activate(t), void 0) : ("event" === e && (this.options.event && this._off(this.headers, this.options.event), this._setupEvents(t)), this._super(e, t), "collapsible" !== e || t || this.options.active !== !1 || this._activate(0), "icons" === e && (this._destroyIcons(), t && this._createIcons()), void 0)
        },
        _setOptionDisabled: function (e) {
            this._super(e), this.element.attr("aria-disabled", e), this._toggleClass(null, "ui-state-disabled", !!e), this._toggleClass(this.headers.add(this.headers.next()), null, "ui-state-disabled", !!e)
        },
        _keydown: function (t) {
            if (!t.altKey && !t.ctrlKey) {
                var i = e.ui.keyCode, s = this.headers.length, n = this.headers.index(t.target), a = !1;
                switch (t.keyCode) {
                    case i.RIGHT:
                    case i.DOWN:
                        a = this.headers[(n + 1) % s];
                        break;
                    case i.LEFT:
                    case i.UP:
                        a = this.headers[(n - 1 + s) % s];
                        break;
                    case i.SPACE:
                    case i.ENTER:
                        this._eventHandler(t);
                        break;
                    case i.HOME:
                        a = this.headers[0];
                        break;
                    case i.END:
                        a = this.headers[s - 1]
                }
                a && (e(t.target).attr("tabIndex", -1), e(a).attr("tabIndex", 0), e(a).trigger("focus"), t.preventDefault())
            }
        },
        _panelKeyDown: function (t) {
            t.keyCode === e.ui.keyCode.UP && t.ctrlKey && e(t.currentTarget).prev().trigger("focus")
        },
        refresh: function () {
            var t = this.options;
            this._processPanels(), t.active === !1 && t.collapsible === !0 || !this.headers.length ? (t.active = !1, this.active = e()) : t.active === !1 ? this._activate(0) : this.active.length && !e.contains(this.element[0], this.active[0]) ? this.headers.length === this.headers.find(".ui-state-disabled").length ? (t.active = !1, this.active = e()) : this._activate(Math.max(0, t.active - 1)) : t.active = this.headers.index(this.active), this._destroyIcons(), this._refresh()
        },
        _processPanels: function () {
            var e = this.headers, t = this.panels;
            this.headers = this.element.find(this.options.header), this._addClass(this.headers, "ui-accordion-header ui-accordion-header-collapsed", "ui-state-default"), this.panels = this.headers.next().filter(":not(.ui-accordion-content-active)").hide(), this._addClass(this.panels, "ui-accordion-content", "ui-helper-reset ui-widget-content"), t && (this._off(e.not(this.headers)), this._off(t.not(this.panels)))
        },
        _refresh: function () {
            var t, i = this.options, s = i.heightStyle, n = this.element.parent();
            this.active = this._findActive(i.active), this._addClass(this.active, "ui-accordion-header-active", "ui-state-active")._removeClass(this.active, "ui-accordion-header-collapsed"), this._addClass(this.active.next(), "ui-accordion-content-active"), this.active.next().show(), this.headers.attr("role", "tab").each(function () {
                var t = e(this), i = t.uniqueId().attr("id"), s = t.next(), n = s.uniqueId().attr("id");
                t.attr("aria-controls", n), s.attr("aria-labelledby", i)
            }).next().attr("role", "tabpanel"), this.headers.not(this.active).attr({
                "aria-selected": "false",
                "aria-expanded": "false",
                tabIndex: -1
            }).next().attr({"aria-hidden": "true"}).hide(), this.active.length ? this.active.attr({
                    "aria-selected": "true",
                    "aria-expanded": "true",
                    tabIndex: 0
                }).next().attr({"aria-hidden": "false"}) : this.headers.eq(0).attr("tabIndex", 0), this._createIcons(), this._setupEvents(i.event), "fill" === s ? (t = n.height(), this.element.siblings(":visible").each(function () {
                    var i = e(this), s = i.css("position");
                    "absolute" !== s && "fixed" !== s && (t -= i.outerHeight(!0))
                }), this.headers.each(function () {
                    t -= e(this).outerHeight(!0)
                }), this.headers.next().each(function () {
                    e(this).height(Math.max(0, t - e(this).innerHeight() + e(this).height()))
                }).css("overflow", "auto")) : "auto" === s && (t = 0, this.headers.next().each(function () {
                    var i = e(this).is(":visible");
                    i || e(this).show(), t = Math.max(t, e(this).css("height", "").height()), i || e(this).hide()
                }).height(t))
        },
        _activate: function (t) {
            var i = this._findActive(t)[0];
            i !== this.active[0] && (i = i || this.active[0], this._eventHandler({
                target: i,
                currentTarget: i,
                preventDefault: e.noop
            }))
        },
        _findActive: function (t) {
            return "number" == typeof t ? this.headers.eq(t) : e()
        },
        _setupEvents: function (t) {
            var i = {keydown: "_keydown"};
            t && e.each(t.split(" "), function (e, t) {
                i[t] = "_eventHandler"
            }), this._off(this.headers.add(this.headers.next())), this._on(this.headers, i), this._on(this.headers.next(), {keydown: "_panelKeyDown"}), this._hoverable(this.headers), this._focusable(this.headers)
        },
        _eventHandler: function (t) {
            var i, s, n = this.options, a = this.active, o = e(t.currentTarget), r = o[0] === a[0], h = r && n.collapsible, l = h ? e() : o.next(), u = a.next(), c = {
                oldHeader: a,
                oldPanel: u,
                newHeader: h ? e() : o,
                newPanel: l
            };
            t.preventDefault(), r && !n.collapsible || this._trigger("beforeActivate", t, c) === !1 || (n.active = h ? !1 : this.headers.index(o), this.active = r ? e() : o, this._toggle(c), this._removeClass(a, "ui-accordion-header-active", "ui-state-active"), n.icons && (i = a.children(".ui-accordion-header-icon"), this._removeClass(i, null, n.icons.activeHeader)._addClass(i, null, n.icons.header)), r || (this._removeClass(o, "ui-accordion-header-collapsed")._addClass(o, "ui-accordion-header-active", "ui-state-active"), n.icons && (s = o.children(".ui-accordion-header-icon"), this._removeClass(s, null, n.icons.header)._addClass(s, null, n.icons.activeHeader)), this._addClass(o.next(), "ui-accordion-content-active")))
        },
        _toggle: function (t) {
            var i = t.newPanel, s = this.prevShow.length ? this.prevShow : t.oldPanel;
            this.prevShow.add(this.prevHide).stop(!0, !0), this.prevShow = i, this.prevHide = s, this.options.animate ? this._animate(i, s, t) : (s.hide(), i.show(), this._toggleComplete(t)), s.attr({"aria-hidden": "true"}), s.prev().attr({
                "aria-selected": "false",
                "aria-expanded": "false"
            }), i.length && s.length ? s.prev().attr({
                    tabIndex: -1,
                    "aria-expanded": "false"
                }) : i.length && this.headers.filter(function () {
                    return 0 === parseInt(e(this).attr("tabIndex"), 10)
                }).attr("tabIndex", -1), i.attr("aria-hidden", "false").prev().attr({
                "aria-selected": "true",
                "aria-expanded": "true",
                tabIndex: 0
            })
        },
        _animate: function (e, t, i) {
            var s, n, a, o = this, r = 0, h = e.css("box-sizing"), l = e.length && (!t.length || e.index() < t.index()), u = this.options.animate || {}, c = l && u.down || u, d = function () {
                o._toggleComplete(i)
            };
            return "number" == typeof c && (a = c), "string" == typeof c && (n = c), n = n || c.easing || u.easing, a = a || c.duration || u.duration, t.length ? e.length ? (s = e.show().outerHeight(), t.animate(this.hideProps, {
                        duration: a,
                        easing: n,
                        step: function (e, t) {
                            t.now = Math.round(e)
                        }
                    }), e.hide().animate(this.showProps, {
                        duration: a, easing: n, complete: d, step: function (e, i) {
                            i.now = Math.round(e), "height" !== i.prop ? "content-box" === h && (r += i.now) : "content" !== o.options.heightStyle && (i.now = Math.round(s - t.outerHeight() - r), r = 0)
                        }
                    }), void 0) : t.animate(this.hideProps, a, n, d) : e.animate(this.showProps, a, n, d)
        },
        _toggleComplete: function (e) {
            var t = e.oldPanel, i = t.prev();
            this._removeClass(t, "ui-accordion-content-active"), this._removeClass(i, "ui-accordion-header-active")._addClass(i, "ui-accordion-header-collapsed"), t.length && (t.parent()[0].className = t.parent()[0].className), this._trigger("activate", null, e)
        }
    }), e.widget("ui.menu", {
        version: "1.12.1",
        defaultElement: "<ul>",
        delay: 300,
        options: {
            icons: {submenu: "ui-icon-caret-1-e"},
            items: "> *",
            menus: "ul",
            position: {my: "left top", at: "right top"},
            role: "menu",
            blur: null,
            focus: null,
            select: null
        },
        _create: function () {
            this.activeMenu = this.element, this.mouseHandled = !1, this.element.uniqueId().attr({
                role: this.options.role,
                tabIndex: 0
            }), this._addClass("ui-menu", "ui-widget ui-widget-content"), this._on({
                "mousedown .ui-menu-item": function (e) {
                    e.preventDefault()
                }, "click .ui-menu-item": function (t) {
                    var i = e(t.target), s = e(e.ui.safeActiveElement(this.document[0]));
                    !this.mouseHandled && i.not(".ui-state-disabled").length && (this.select(t), t.isPropagationStopped() || (this.mouseHandled = !0), i.has(".ui-menu").length ? this.expand(t) : !this.element.is(":focus") && s.closest(".ui-menu").length && (this.element.trigger("focus", [!0]), this.active && 1 === this.active.parents(".ui-menu").length && clearTimeout(this.timer)))
                }, "mouseenter .ui-menu-item": function (t) {
                    if (!this.previousFilter) {
                        var i = e(t.target).closest(".ui-menu-item"), s = e(t.currentTarget);
                        i[0] === s[0] && (this._removeClass(s.siblings().children(".ui-state-active"), null, "ui-state-active"), this.focus(t, s))
                    }
                }, mouseleave: "collapseAll", "mouseleave .ui-menu": "collapseAll", focus: function (e, t) {
                    var i = this.active || this.element.find(this.options.items).eq(0);
                    t || this.focus(e, i)
                }, blur: function (t) {
                    this._delay(function () {
                        var i = !e.contains(this.element[0], e.ui.safeActiveElement(this.document[0]));
                        i && this.collapseAll(t)
                    })
                }, keydown: "_keydown"
            }), this.refresh(), this._on(this.document, {
                click: function (e) {
                    this._closeOnDocumentClick(e) && this.collapseAll(e), this.mouseHandled = !1
                }
            })
        },
        _destroy: function () {
            var t = this.element.find(".ui-menu-item").removeAttr("role aria-disabled"), i = t.children(".ui-menu-item-wrapper").removeUniqueId().removeAttr("tabIndex role aria-haspopup");
            this.element.removeAttr("aria-activedescendant").find(".ui-menu").addBack().removeAttr("role aria-labelledby aria-expanded aria-hidden aria-disabled tabIndex").removeUniqueId().show(), i.children().each(function () {
                var t = e(this);
                t.data("ui-menu-submenu-caret") && t.remove()
            })
        },
        _keydown: function (t) {
            var i, s, n, a, o = !0;
            switch (t.keyCode) {
                case e.ui.keyCode.PAGE_UP:
                    this.previousPage(t);
                    break;
                case e.ui.keyCode.PAGE_DOWN:
                    this.nextPage(t);
                    break;
                case e.ui.keyCode.HOME:
                    this._move("first", "first", t);
                    break;
                case e.ui.keyCode.END:
                    this._move("last", "last", t);
                    break;
                case e.ui.keyCode.UP:
                    this.previous(t);
                    break;
                case e.ui.keyCode.DOWN:
                    this.next(t);
                    break;
                case e.ui.keyCode.LEFT:
                    this.collapse(t);
                    break;
                case e.ui.keyCode.RIGHT:
                    this.active && !this.active.is(".ui-state-disabled") && this.expand(t);
                    break;
                case e.ui.keyCode.ENTER:
                case e.ui.keyCode.SPACE:
                    this._activate(t);
                    break;
                case e.ui.keyCode.ESCAPE:
                    this.collapse(t);
                    break;
                default:
                    o = !1, s = this.previousFilter || "", a = !1, n = t.keyCode >= 96 && 105 >= t.keyCode ? "" + (t.keyCode - 96) : String.fromCharCode(t.keyCode), clearTimeout(this.filterTimer), n === s ? a = !0 : n = s + n, i = this._filterMenuItems(n), i = a && -1 !== i.index(this.active.next()) ? this.active.nextAll(".ui-menu-item") : i, i.length || (n = String.fromCharCode(t.keyCode), i = this._filterMenuItems(n)), i.length ? (this.focus(t, i), this.previousFilter = n, this.filterTimer = this._delay(function () {
                            delete this.previousFilter
                        }, 1e3)) : delete this.previousFilter
            }
            o && t.preventDefault()
        },
        _activate: function (e) {
            this.active && !this.active.is(".ui-state-disabled") && (this.active.children("[aria-haspopup='true']").length ? this.expand(e) : this.select(e))
        },
        refresh: function () {
            var t, i, s, n, a, o = this, r = this.options.icons.submenu, h = this.element.find(this.options.menus);
            this._toggleClass("ui-menu-icons", null, !!this.element.find(".ui-icon").length), s = h.filter(":not(.ui-menu)").hide().attr({
                role: this.options.role,
                "aria-hidden": "true",
                "aria-expanded": "false"
            }).each(function () {
                var t = e(this), i = t.prev(), s = e("<span>").data("ui-menu-submenu-caret", !0);
                o._addClass(s, "ui-menu-icon", "ui-icon " + r), i.attr("aria-haspopup", "true").prepend(s), t.attr("aria-labelledby", i.attr("id"))
            }), this._addClass(s, "ui-menu", "ui-widget ui-widget-content ui-front"), t = h.add(this.element), i = t.find(this.options.items), i.not(".ui-menu-item").each(function () {
                var t = e(this);
                o._isDivider(t) && o._addClass(t, "ui-menu-divider", "ui-widget-content")
            }), n = i.not(".ui-menu-item, .ui-menu-divider"), a = n.children().not(".ui-menu").uniqueId().attr({
                tabIndex: -1,
                role: this._itemRole()
            }), this._addClass(n, "ui-menu-item")._addClass(a, "ui-menu-item-wrapper"), i.filter(".ui-state-disabled").attr("aria-disabled", "true"), this.active && !e.contains(this.element[0], this.active[0]) && this.blur()
        },
        _itemRole: function () {
            return {menu: "menuitem", listbox: "option"}[this.options.role]
        },
        _setOption: function (e, t) {
            if ("icons" === e) {
                var i = this.element.find(".ui-menu-icon");
                this._removeClass(i, null, this.options.icons.submenu)._addClass(i, null, t.submenu)
            }
            this._super(e, t)
        },
        _setOptionDisabled: function (e) {
            this._super(e), this.element.attr("aria-disabled", e + ""), this._toggleClass(null, "ui-state-disabled", !!e)
        },
        focus: function (e, t) {
            var i, s, n;
            this.blur(e, e && "focus" === e.type), this._scrollIntoView(t), this.active = t.first(), s = this.active.children(".ui-menu-item-wrapper"), this._addClass(s, null, "ui-state-active"), this.options.role && this.element.attr("aria-activedescendant", s.attr("id")), n = this.active.parent().closest(".ui-menu-item").children(".ui-menu-item-wrapper"), this._addClass(n, null, "ui-state-active"), e && "keydown" === e.type ? this._close() : this.timer = this._delay(function () {
                    this._close()
                }, this.delay), i = t.children(".ui-menu"), i.length && e && /^mouse/.test(e.type) && this._startOpening(i), this.activeMenu = t.parent(), this._trigger("focus", e, {item: t})
        },
        _scrollIntoView: function (t) {
            var i, s, n, a, o, r;
            this._hasScroll() && (i = parseFloat(e.css(this.activeMenu[0], "borderTopWidth")) || 0, s = parseFloat(e.css(this.activeMenu[0], "paddingTop")) || 0, n = t.offset().top - this.activeMenu.offset().top - i - s, a = this.activeMenu.scrollTop(), o = this.activeMenu.height(), r = t.outerHeight(), 0 > n ? this.activeMenu.scrollTop(a + n) : n + r > o && this.activeMenu.scrollTop(a + n - o + r))
        },
        blur: function (e, t) {
            t || clearTimeout(this.timer), this.active && (this._removeClass(this.active.children(".ui-menu-item-wrapper"), null, "ui-state-active"), this._trigger("blur", e, {item: this.active}), this.active = null)
        },
        _startOpening: function (e) {
            clearTimeout(this.timer), "true" === e.attr("aria-hidden") && (this.timer = this._delay(function () {
                this._close(), this._open(e)
            }, this.delay))
        },
        _open: function (t) {
            var i = e.extend({of: this.active}, this.options.position);
            clearTimeout(this.timer), this.element.find(".ui-menu").not(t.parents(".ui-menu")).hide().attr("aria-hidden", "true"), t.show().removeAttr("aria-hidden").attr("aria-expanded", "true").position(i)
        },
        collapseAll: function (t, i) {
            clearTimeout(this.timer), this.timer = this._delay(function () {
                var s = i ? this.element : e(t && t.target).closest(this.element.find(".ui-menu"));
                s.length || (s = this.element), this._close(s), this.blur(t), this._removeClass(s.find(".ui-state-active"), null, "ui-state-active"), this.activeMenu = s
            }, this.delay)
        },
        _close: function (e) {
            e || (e = this.active ? this.active.parent() : this.element), e.find(".ui-menu").hide().attr("aria-hidden", "true").attr("aria-expanded", "false")
        },
        _closeOnDocumentClick: function (t) {
            return !e(t.target).closest(".ui-menu").length
        },
        _isDivider: function (e) {
            return !/[^\-\u2014\u2013\s]/.test(e.text())
        },
        collapse: function (e) {
            var t = this.active && this.active.parent().closest(".ui-menu-item", this.element);
            t && t.length && (this._close(), this.focus(e, t))
        },
        expand: function (e) {
            var t = this.active && this.active.children(".ui-menu ").find(this.options.items).first();
            t && t.length && (this._open(t.parent()), this._delay(function () {
                this.focus(e, t)
            }))
        },
        next: function (e) {
            this._move("next", "first", e)
        },
        previous: function (e) {
            this._move("prev", "last", e)
        },
        isFirstItem: function () {
            return this.active && !this.active.prevAll(".ui-menu-item").length
        },
        isLastItem: function () {
            return this.active && !this.active.nextAll(".ui-menu-item").length
        },
        _move: function (e, t, i) {
            var s;
            this.active && (s = "first" === e || "last" === e ? this.active["first" === e ? "prevAll" : "nextAll"](".ui-menu-item").eq(-1) : this.active[e + "All"](".ui-menu-item").eq(0)), s && s.length && this.active || (s = this.activeMenu.find(this.options.items)[t]()), this.focus(i, s)
        },
        nextPage: function (t) {
            var i, s, n;
            return this.active ? (this.isLastItem() || (this._hasScroll() ? (s = this.active.offset().top, n = this.element.height(), this.active.nextAll(".ui-menu-item").each(function () {
                        return i = e(this), 0 > i.offset().top - s - n
                    }), this.focus(t, i)) : this.focus(t, this.activeMenu.find(this.options.items)[this.active ? "last" : "first"]())), void 0) : (this.next(t), void 0)
        },
        previousPage: function (t) {
            var i, s, n;
            return this.active ? (this.isFirstItem() || (this._hasScroll() ? (s = this.active.offset().top, n = this.element.height(), this.active.prevAll(".ui-menu-item").each(function () {
                        return i = e(this), i.offset().top - s + n > 0
                    }), this.focus(t, i)) : this.focus(t, this.activeMenu.find(this.options.items).first())), void 0) : (this.next(t), void 0)
        },
        _hasScroll: function () {
            return this.element.outerHeight() < this.element.prop("scrollHeight")
        },
        select: function (t) {
            this.active = this.active || e(t.target).closest(".ui-menu-item");
            var i = {item: this.active};
            this.active.has(".ui-menu").length || this.collapseAll(t, !0), this._trigger("select", t, i)
        },
        _filterMenuItems: function (t) {
            var i = t.replace(/[\-\[\]{}()*+?.,\\\^$|#\s]/g, "\\$&"), s = RegExp("^" + i, "i");
            return this.activeMenu.find(this.options.items).filter(".ui-menu-item").filter(function () {
                return s.test(e.trim(e(this).children(".ui-menu-item-wrapper").text()))
            })
        }
    }), e.widget("ui.autocomplete", {
        version: "1.12.1",
        defaultElement: "<input>",
        options: {
            appendTo: null,
            autoFocus: !1,
            delay: 300,
            minLength: 1,
            position: {my: "left top", at: "left bottom", collision: "none"},
            source: null,
            change: null,
            close: null,
            focus: null,
            open: null,
            response: null,
            search: null,
            select: null
        },
        requestIndex: 0,
        pending: 0,
        _create: function () {
            var t, i, s, n = this.element[0].nodeName.toLowerCase(), a = "textarea" === n, o = "input" === n;
            this.isMultiLine = a || !o && this._isContentEditable(this.element), this.valueMethod = this.element[a || o ? "val" : "text"], this.isNewMenu = !0, this._addClass("ui-autocomplete-input"), this.element.attr("autocomplete", "off"), this._on(this.element, {
                keydown: function (n) {
                    if (this.element.prop("readOnly"))return t = !0, s = !0, i = !0, void 0;
                    t = !1, s = !1, i = !1;
                    var a = e.ui.keyCode;
                    switch (n.keyCode) {
                        case a.PAGE_UP:
                            t = !0, this._move("previousPage", n);
                            break;
                        case a.PAGE_DOWN:
                            t = !0, this._move("nextPage", n);
                            break;
                        case a.UP:
                            t = !0, this._keyEvent("previous", n);
                            break;
                        case a.DOWN:
                            t = !0, this._keyEvent("next", n);
                            break;
                        case a.ENTER:
                            this.menu.active && (t = !0, n.preventDefault(), this.menu.select(n));
                            break;
                        case a.TAB:
                            this.menu.active && this.menu.select(n);
                            break;
                        case a.ESCAPE:
                            this.menu.element.is(":visible") && (this.isMultiLine || this._value(this.term), this.close(n), n.preventDefault());
                            break;
                        default:
                            i = !0, this._searchTimeout(n)
                    }
                }, keypress: function (s) {
                    if (t)return t = !1, (!this.isMultiLine || this.menu.element.is(":visible")) && s.preventDefault(), void 0;
                    if (!i) {
                        var n = e.ui.keyCode;
                        switch (s.keyCode) {
                            case n.PAGE_UP:
                                this._move("previousPage", s);
                                break;
                            case n.PAGE_DOWN:
                                this._move("nextPage", s);
                                break;
                            case n.UP:
                                this._keyEvent("previous", s);
                                break;
                            case n.DOWN:
                                this._keyEvent("next", s)
                        }
                    }
                }, input: function (e) {
                    return s ? (s = !1, e.preventDefault(), void 0) : (this._searchTimeout(e), void 0)
                }, focus: function () {
                    this.selectedItem = null, this.previous = this._value()
                }, blur: function (e) {
                    return this.cancelBlur ? (delete this.cancelBlur, void 0) : (clearTimeout(this.searching), this.close(e), this._change(e), void 0)
                }
            }), this._initSource(), this.menu = e("<ul>").appendTo(this._appendTo()).menu({role: null}).hide().menu("instance"), this._addClass(this.menu.element, "ui-autocomplete", "ui-front"), this._on(this.menu.element, {
                mousedown: function (t) {
                    t.preventDefault(), this.cancelBlur = !0, this._delay(function () {
                        delete this.cancelBlur, this.element[0] !== e.ui.safeActiveElement(this.document[0]) && this.element.trigger("focus")
                    })
                }, menufocus: function (t, i) {
                    var s, n;
                    return this.isNewMenu && (this.isNewMenu = !1, t.originalEvent && /^mouse/.test(t.originalEvent.type)) ? (this.menu.blur(), this.document.one("mousemove", function () {
                            e(t.target).trigger(t.originalEvent)
                        }), void 0) : (n = i.item.data("ui-autocomplete-item"), !1 !== this._trigger("focus", t, {item: n}) && t.originalEvent && /^key/.test(t.originalEvent.type) && this._value(n.value), s = i.item.attr("aria-label") || n.value, s && e.trim(s).length && (this.liveRegion.children().hide(), e("<div>").text(s).appendTo(this.liveRegion)), void 0)
                }, menuselect: function (t, i) {
                    var s = i.item.data("ui-autocomplete-item"), n = this.previous;
                    this.element[0] !== e.ui.safeActiveElement(this.document[0]) && (this.element.trigger("focus"), this.previous = n, this._delay(function () {
                        this.previous = n, this.selectedItem = s
                    })), !1 !== this._trigger("select", t, {item: s}) && this._value(s.value), this.term = this._value(), this.close(t), this.selectedItem = s
                }
            }), this.liveRegion = e("<div>", {
                role: "status",
                "aria-live": "assertive",
                "aria-relevant": "additions"
            }).appendTo(this.document[0].body), this._addClass(this.liveRegion, null, "ui-helper-hidden-accessible"), this._on(this.window, {
                beforeunload: function () {
                    this.element.removeAttr("autocomplete")
                }
            })
        },
        _destroy: function () {
            clearTimeout(this.searching), this.element.removeAttr("autocomplete"), this.menu.element.remove(), this.liveRegion.remove()
        },
        _setOption: function (e, t) {
            this._super(e, t), "source" === e && this._initSource(), "appendTo" === e && this.menu.element.appendTo(this._appendTo()), "disabled" === e && t && this.xhr && this.xhr.abort()
        },
        _isEventTargetInWidget: function (t) {
            var i = this.menu.element[0];
            return t.target === this.element[0] || t.target === i || e.contains(i, t.target)
        },
        _closeOnClickOutside: function (e) {
            this._isEventTargetInWidget(e) || this.close()
        },
        _appendTo: function () {
            var t = this.options.appendTo;
            return t && (t = t.jquery || t.nodeType ? e(t) : this.document.find(t).eq(0)), t && t[0] || (t = this.element.closest(".ui-front, dialog")), t.length || (t = this.document[0].body), t
        },
        _initSource: function () {
            var t, i, s = this;
            e.isArray(this.options.source) ? (t = this.options.source, this.source = function (i, s) {
                    s(e.ui.autocomplete.filter(t, i.term))
                }) : "string" == typeof this.options.source ? (i = this.options.source, this.source = function (t, n) {
                        s.xhr && s.xhr.abort(), s.xhr = e.ajax({
                            url: i,
                            data: t,
                            dataType: "json",
                            success: function (e) {
                                n(e)
                            },
                            error: function () {
                                n([])
                            }
                        })
                    }) : this.source = this.options.source
        },
        _searchTimeout: function (e) {
            clearTimeout(this.searching), this.searching = this._delay(function () {
                var t = this.term === this._value(), i = this.menu.element.is(":visible"), s = e.altKey || e.ctrlKey || e.metaKey || e.shiftKey;
                (!t || t && !i && !s) && (this.selectedItem = null, this.search(null, e))
            }, this.options.delay)
        },
        search: function (e, t) {
            return e = null != e ? e : this._value(), this.term = this._value(), e.length < this.options.minLength ? this.close(t) : this._trigger("search", t) !== !1 ? this._search(e) : void 0
        },
        _search: function (e) {
            this.pending++, this._addClass("ui-autocomplete-loading"), this.cancelSearch = !1, this.source({term: e}, this._response())
        },
        _response: function () {
            var t = ++this.requestIndex;
            return e.proxy(function (e) {
                t === this.requestIndex && this.__response(e), this.pending--, this.pending || this._removeClass("ui-autocomplete-loading")
            }, this)
        },
        __response: function (e) {
            e && (e = this._normalize(e)), this._trigger("response", null, {content: e}), !this.options.disabled && e && e.length && !this.cancelSearch ? (this._suggest(e), this._trigger("open")) : this._close()
        },
        close: function (e) {
            this.cancelSearch = !0, this._close(e)
        },
        _close: function (e) {
            this._off(this.document, "mousedown"), this.menu.element.is(":visible") && (this.menu.element.hide(), this.menu.blur(), this.isNewMenu = !0, this._trigger("close", e))
        },
        _change: function (e) {
            this.previous !== this._value() && this._trigger("change", e, {item: this.selectedItem})
        },
        _normalize: function (t) {
            return t.length && t[0].label && t[0].value ? t : e.map(t, function (t) {
                    return "string" == typeof t ? {label: t, value: t} : e.extend({}, t, {
                            label: t.label || t.value,
                            value: t.value || t.label
                        })
                })
        },
        _suggest: function (t) {
            var i = this.menu.element.empty();
            this._renderMenu(i, t), this.isNewMenu = !0, this.menu.refresh(), i.show(), this._resizeMenu(), i.position(e.extend({of: this.element}, this.options.position)), this.options.autoFocus && this.menu.next(), this._on(this.document, {mousedown: "_closeOnClickOutside"})
        },
        _resizeMenu: function () {
            var e = this.menu.element;
            e.outerWidth(Math.max(e.width("").outerWidth() + 1, this.element.outerWidth()))
        },
        _renderMenu: function (t, i) {
            var s = this;
            e.each(i, function (e, i) {
                s._renderItemData(t, i)
            })
        },
        _renderItemData: function (e, t) {
            return this._renderItem(e, t).data("ui-autocomplete-item", t)
        },
        _renderItem: function (t, i) {
            return e("<li>").append(e("<div>").text(i.label)).appendTo(t)
        },
        _move: function (e, t) {
            return this.menu.element.is(":visible") ? this.menu.isFirstItem() && /^previous/.test(e) || this.menu.isLastItem() && /^next/.test(e) ? (this.isMultiLine || this._value(this.term), this.menu.blur(), void 0) : (this.menu[e](t), void 0) : (this.search(null, t), void 0)
        },
        widget: function () {
            return this.menu.element
        },
        _value: function () {
            return this.valueMethod.apply(this.element, arguments)
        },
        _keyEvent: function (e, t) {
            (!this.isMultiLine || this.menu.element.is(":visible")) && (this._move(e, t), t.preventDefault())
        },
        _isContentEditable: function (e) {
            if (!e.length)return !1;
            var t = e.prop("contentEditable");
            return "inherit" === t ? this._isContentEditable(e.parent()) : "true" === t
        }
    }), e.extend(e.ui.autocomplete, {
        escapeRegex: function (e) {
            return e.replace(/[\-\[\]{}()*+?.,\\\^$|#\s]/g, "\\$&")
        }, filter: function (t, i) {
            var s = RegExp(e.ui.autocomplete.escapeRegex(i), "i");
            return e.grep(t, function (e) {
                return s.test(e.label || e.value || e)
            })
        }
    }), e.widget("ui.autocomplete", e.ui.autocomplete, {
        options: {
            messages: {
                noResults: "No search results.",
                results: function (e) {
                    return e + (e > 1 ? " results are" : " result is") + " available, use up and down arrow keys to navigate."
                }
            }
        }, __response: function (t) {
            var i;
            this._superApply(arguments), this.options.disabled || this.cancelSearch || (i = t && t.length ? this.options.messages.results(t.length) : this.options.messages.noResults, this.liveRegion.children().hide(), e("<div>").text(i).appendTo(this.liveRegion))
        }
    }), e.ui.autocomplete;
    var d = /ui-corner-([a-z]){2,6}/g;
    e.widget("ui.controlgroup", {
        version: "1.12.1",
        defaultElement: "<div>",
        options: {
            direction: "horizontal",
            disabled: null,
            onlyVisible: !0,
            items: {
                button: "input[type=button], input[type=submit], input[type=reset], button, a",
                controlgroupLabel: ".ui-controlgroup-label",
                checkboxradio: "input[type='checkbox'], input[type='radio']",
                selectmenu: "select",
                spinner: ".ui-spinner-input"
            }
        },
        _create: function () {
            this._enhance()
        },
        _enhance: function () {
            this.element.attr("role", "toolbar"), this.refresh()
        },
        _destroy: function () {
            this._callChildMethod("destroy"), this.childWidgets.removeData("ui-controlgroup-data"), this.element.removeAttr("role"), this.options.items.controlgroupLabel && this.element.find(this.options.items.controlgroupLabel).find(".ui-controlgroup-label-contents").contents().unwrap()
        },
        _initWidgets: function () {
            var t = this, i = [];
            e.each(this.options.items, function (s, n) {
                var a, o = {};
                return n ? "controlgroupLabel" === s ? (a = t.element.find(n), a.each(function () {
                            var t = e(this);
                            t.children(".ui-controlgroup-label-contents").length || t.contents().wrapAll("<span class='ui-controlgroup-label-contents'></span>")
                        }), t._addClass(a, null, "ui-widget ui-widget-content ui-state-default"), i = i.concat(a.get()), void 0) : (e.fn[s] && (o = t["_" + s + "Options"] ? t["_" + s + "Options"]("middle") : {classes: {}}, t.element.find(n).each(function () {
                            var n = e(this), a = n[s]("instance"), r = e.widget.extend({}, o);
                            if ("button" !== s || !n.parent(".ui-spinner").length) {
                                a || (a = n[s]()[s]("instance")), a && (r.classes = t._resolveClassesValues(r.classes, a)), n[s](r);
                                var h = n[s]("widget");
                                e.data(h[0], "ui-controlgroup-data", a ? a : n[s]("instance")), i.push(h[0])
                            }
                        })), void 0) : void 0
            }), this.childWidgets = e(e.unique(i)), this._addClass(this.childWidgets, "ui-controlgroup-item")
        },
        _callChildMethod: function (t) {
            this.childWidgets.each(function () {
                var i = e(this), s = i.data("ui-controlgroup-data");
                s && s[t] && s[t]()
            })
        },
        _updateCornerClass: function (e, t) {
            var i = "ui-corner-top ui-corner-bottom ui-corner-left ui-corner-right ui-corner-all", s = this._buildSimpleOptions(t, "label").classes.label;
            this._removeClass(e, null, i), this._addClass(e, null, s)
        },
        _buildSimpleOptions: function (e, t) {
            var i = "vertical" === this.options.direction, s = {classes: {}};
            return s.classes[t] = {
                middle: "",
                first: "ui-corner-" + (i ? "top" : "left"),
                last: "ui-corner-" + (i ? "bottom" : "right"),
                only: "ui-corner-all"
            }[e], s
        },
        _spinnerOptions: function (e) {
            var t = this._buildSimpleOptions(e, "ui-spinner");
            return t.classes["ui-spinner-up"] = "", t.classes["ui-spinner-down"] = "", t
        },
        _buttonOptions: function (e) {
            return this._buildSimpleOptions(e, "ui-button")
        },
        _checkboxradioOptions: function (e) {
            return this._buildSimpleOptions(e, "ui-checkboxradio-label")
        },
        _selectmenuOptions: function (e) {
            var t = "vertical" === this.options.direction;
            return {
                width: t ? "auto" : !1,
                classes: {
                    middle: {"ui-selectmenu-button-open": "", "ui-selectmenu-button-closed": ""},
                    first: {
                        "ui-selectmenu-button-open": "ui-corner-" + (t ? "top" : "tl"),
                        "ui-selectmenu-button-closed": "ui-corner-" + (t ? "top" : "left")
                    },
                    last: {
                        "ui-selectmenu-button-open": t ? "" : "ui-corner-tr",
                        "ui-selectmenu-button-closed": "ui-corner-" + (t ? "bottom" : "right")
                    },
                    only: {"ui-selectmenu-button-open": "ui-corner-top", "ui-selectmenu-button-closed": "ui-corner-all"}
                }[e]
            }
        },
        _resolveClassesValues: function (t, i) {
            var s = {};
            return e.each(t, function (n) {
                var a = i.options.classes[n] || "";
                a = e.trim(a.replace(d, "")), s[n] = (a + " " + t[n]).replace(/\s+/g, " ")
            }), s
        },
        _setOption: function (e, t) {
            return "direction" === e && this._removeClass("ui-controlgroup-" + this.options.direction), this._super(e, t), "disabled" === e ? (this._callChildMethod(t ? "disable" : "enable"), void 0) : (this.refresh(), void 0)
        },
        refresh: function () {
            var t, i = this;
            this._addClass("ui-controlgroup ui-controlgroup-" + this.options.direction), "horizontal" === this.options.direction && this._addClass(null, "ui-helper-clearfix"), this._initWidgets(), t = this.childWidgets, this.options.onlyVisible && (t = t.filter(":visible")), t.length && (e.each(["first", "last"], function (e, s) {
                var n = t[s]().data("ui-controlgroup-data");
                if (n && i["_" + n.widgetName + "Options"]) {
                    var a = i["_" + n.widgetName + "Options"](1 === t.length ? "only" : s);
                    a.classes = i._resolveClassesValues(a.classes, n), n.element[n.widgetName](a)
                } else i._updateCornerClass(t[s](), s)
            }), this._callChildMethod("refresh"))
        }
    }), e.widget("ui.checkboxradio", [e.ui.formResetMixin, {
        version: "1.12.1",
        options: {
            disabled: null,
            label: null,
            icon: !0,
            classes: {"ui-checkboxradio-label": "ui-corner-all", "ui-checkboxradio-icon": "ui-corner-all"}
        },
        _getCreateOptions: function () {
            var t, i, s = this, n = this._super() || {};
            return this._readType(), i = this.element.labels(), this.label = e(i[i.length - 1]), this.label.length || e.error("No label found for checkboxradio widget"), this.originalLabel = "", this.label.contents().not(this.element[0]).each(function () {
                s.originalLabel += 3 === this.nodeType ? e(this).text() : this.outerHTML
            }), this.originalLabel && (n.label = this.originalLabel), t = this.element[0].disabled, null != t && (n.disabled = t), n
        },
        _create: function () {
            var e = this.element[0].checked;
            this._bindFormResetHandler(), null == this.options.disabled && (this.options.disabled = this.element[0].disabled), this._setOption("disabled", this.options.disabled), this._addClass("ui-checkboxradio", "ui-helper-hidden-accessible"), this._addClass(this.label, "ui-checkboxradio-label", "ui-button ui-widget"), "radio" === this.type && this._addClass(this.label, "ui-checkboxradio-radio-label"), this.options.label && this.options.label !== this.originalLabel ? this._updateLabel() : this.originalLabel && (this.options.label = this.originalLabel), this._enhance(), e && (this._addClass(this.label, "ui-checkboxradio-checked", "ui-state-active"), this.icon && this._addClass(this.icon, null, "ui-state-hover")), this._on({
                change: "_toggleClasses",
                focus: function () {
                    this._addClass(this.label, null, "ui-state-focus ui-visual-focus")
                },
                blur: function () {
                    this._removeClass(this.label, null, "ui-state-focus ui-visual-focus")
                }
            })
        },
        _readType: function () {
            var t = this.element[0].nodeName.toLowerCase();
            this.type = this.element[0].type, "input" === t && /radio|checkbox/.test(this.type) || e.error("Can't create checkboxradio on element.nodeName=" + t + " and element.type=" + this.type)
        },
        _enhance: function () {
            this._updateIcon(this.element[0].checked)
        },
        widget: function () {
            return this.label
        },
        _getRadioGroup: function () {
            var t, i = this.element[0].name, s = "input[name='" + e.ui.escapeSelector(i) + "']";
            return i ? (t = this.form.length ? e(this.form[0].elements).filter(s) : e(s).filter(function () {
                        return 0 === e(this).form().length
                    }), t.not(this.element)) : e([])
        },
        _toggleClasses: function () {
            var t = this.element[0].checked;
            this._toggleClass(this.label, "ui-checkboxradio-checked", "ui-state-active", t), this.options.icon && "checkbox" === this.type && this._toggleClass(this.icon, null, "ui-icon-check ui-state-checked", t)._toggleClass(this.icon, null, "ui-icon-blank", !t), "radio" === this.type && this._getRadioGroup().each(function () {
                var t = e(this).checkboxradio("instance");
                t && t._removeClass(t.label, "ui-checkboxradio-checked", "ui-state-active")
            })
        },
        _destroy: function () {
            this._unbindFormResetHandler(), this.icon && (this.icon.remove(), this.iconSpace.remove())
        },
        _setOption: function (e, t) {
            return "label" !== e || t ? (this._super(e, t), "disabled" === e ? (this._toggleClass(this.label, null, "ui-state-disabled", t), this.element[0].disabled = t, void 0) : (this.refresh(), void 0)) : void 0
        },
        _updateIcon: function (t) {
            var i = "ui-icon ui-icon-background ";
            this.options.icon ? (this.icon || (this.icon = e("<span>"), this.iconSpace = e("<span> </span>"), this._addClass(this.iconSpace, "ui-checkboxradio-icon-space")), "checkbox" === this.type ? (i += t ? "ui-icon-check ui-state-checked" : "ui-icon-blank", this._removeClass(this.icon, null, t ? "ui-icon-blank" : "ui-icon-check")) : i += "ui-icon-blank", this._addClass(this.icon, "ui-checkboxradio-icon", i), t || this._removeClass(this.icon, null, "ui-icon-check ui-state-checked"), this.icon.prependTo(this.label).after(this.iconSpace)) : void 0 !== this.icon && (this.icon.remove(), this.iconSpace.remove(), delete this.icon)
        },
        _updateLabel: function () {
            var e = this.label.contents().not(this.element[0]);
            this.icon && (e = e.not(this.icon[0])), this.iconSpace && (e = e.not(this.iconSpace[0])), e.remove(), this.label.append(this.options.label)
        },
        refresh: function () {
            var e = this.element[0].checked, t = this.element[0].disabled;
            this._updateIcon(e), this._toggleClass(this.label, "ui-checkboxradio-checked", "ui-state-active", e), null !== this.options.label && this._updateLabel(), t !== this.options.disabled && this._setOptions({disabled: t})
        }
    }]), e.ui.checkboxradio, e.widget("ui.button", {
        version: "1.12.1",
        defaultElement: "<button>",
        options: {
            classes: {"ui-button": "ui-corner-all"},
            disabled: null,
            icon: null,
            iconPosition: "beginning",
            label: null,
            showLabel: !0
        },
        _getCreateOptions: function () {
            var e, t = this._super() || {};
            return this.isInput = this.element.is("input"), e = this.element[0].disabled, null != e && (t.disabled = e), this.originalLabel = this.isInput ? this.element.val() : this.element.html(), this.originalLabel && (t.label = this.originalLabel), t
        },
        _create: function () {
            !this.option.showLabel & !this.options.icon && (this.options.showLabel = !0), null == this.options.disabled && (this.options.disabled = this.element[0].disabled || !1), this.hasTitle = !!this.element.attr("title"), this.options.label && this.options.label !== this.originalLabel && (this.isInput ? this.element.val(this.options.label) : this.element.html(this.options.label)), this._addClass("ui-button", "ui-widget"), this._setOption("disabled", this.options.disabled), this._enhance(), this.element.is("a") && this._on({
                keyup: function (t) {
                    t.keyCode === e.ui.keyCode.SPACE && (t.preventDefault(), this.element[0].click ? this.element[0].click() : this.element.trigger("click"))
                }
            })
        },
        _enhance: function () {
            this.element.is("button") || this.element.attr("role", "button"), this.options.icon && (this._updateIcon("icon", this.options.icon), this._updateTooltip())
        },
        _updateTooltip: function () {
            this.title = this.element.attr("title"), this.options.showLabel || this.title || this.element.attr("title", this.options.label)
        },
        _updateIcon: function (t, i) {
            var s = "iconPosition" !== t, n = s ? this.options.iconPosition : i, a = "top" === n || "bottom" === n;
            this.icon ? s && this._removeClass(this.icon, null, this.options.icon) : (this.icon = e("<span>"), this._addClass(this.icon, "ui-button-icon", "ui-icon"), this.options.showLabel || this._addClass("ui-button-icon-only")), s && this._addClass(this.icon, null, i), this._attachIcon(n), a ? (this._addClass(this.icon, null, "ui-widget-icon-block"), this.iconSpace && this.iconSpace.remove()) : (this.iconSpace || (this.iconSpace = e("<span> </span>"), this._addClass(this.iconSpace, "ui-button-icon-space")), this._removeClass(this.icon, null, "ui-wiget-icon-block"), this._attachIconSpace(n))
        },
        _destroy: function () {
            this.element.removeAttr("role"), this.icon && this.icon.remove(), this.iconSpace && this.iconSpace.remove(), this.hasTitle || this.element.removeAttr("title")
        },
        _attachIconSpace: function (e) {
            this.icon[/^(?:end|bottom)/.test(e) ? "before" : "after"](this.iconSpace)
        },
        _attachIcon: function (e) {
            this.element[/^(?:end|bottom)/.test(e) ? "append" : "prepend"](this.icon)
        },
        _setOptions: function (e) {
            var t = void 0 === e.showLabel ? this.options.showLabel : e.showLabel, i = void 0 === e.icon ? this.options.icon : e.icon;
            t || i || (e.showLabel = !0), this._super(e)
        },
        _setOption: function (e, t) {
            "icon" === e && (t ? this._updateIcon(e, t) : this.icon && (this.icon.remove(), this.iconSpace && this.iconSpace.remove())), "iconPosition" === e && this._updateIcon(e, t), "showLabel" === e && (this._toggleClass("ui-button-icon-only", null, !t), this._updateTooltip()), "label" === e && (this.isInput ? this.element.val(t) : (this.element.html(t), this.icon && (this._attachIcon(this.options.iconPosition), this._attachIconSpace(this.options.iconPosition)))), this._super(e, t), "disabled" === e && (this._toggleClass(null, "ui-state-disabled", t), this.element[0].disabled = t, t && this.element.blur())
        },
        refresh: function () {
            var e = this.element.is("input, button") ? this.element[0].disabled : this.element.hasClass("ui-button-disabled");
            e !== this.options.disabled && this._setOptions({disabled: e}), this._updateTooltip()
        }
    }), e.uiBackCompat !== !1 && (e.widget("ui.button", e.ui.button, {
        options: {
            text: !0,
            icons: {primary: null, secondary: null}
        }, _create: function () {
            this.options.showLabel && !this.options.text && (this.options.showLabel = this.options.text), !this.options.showLabel && this.options.text && (this.options.text = this.options.showLabel), this.options.icon || !this.options.icons.primary && !this.options.icons.secondary ? this.options.icon && (this.options.icons.primary = this.options.icon) : this.options.icons.primary ? this.options.icon = this.options.icons.primary : (this.options.icon = this.options.icons.secondary, this.options.iconPosition = "end"), this._super()
        }, _setOption: function (e, t) {
            return "text" === e ? (this._super("showLabel", t), void 0) : ("showLabel" === e && (this.options.text = t), "icon" === e && (this.options.icons.primary = t), "icons" === e && (t.primary ? (this._super("icon", t.primary), this._super("iconPosition", "beginning")) : t.secondary && (this._super("icon", t.secondary), this._super("iconPosition", "end"))), this._superApply(arguments), void 0)
        }
    }), e.fn.button = function (t) {
        return function () {
            return !this.length || this.length && "INPUT" !== this[0].tagName || this.length && "INPUT" === this[0].tagName && "checkbox" !== this.attr("type") && "radio" !== this.attr("type") ? t.apply(this, arguments) : (e.ui.checkboxradio || e.error("Checkboxradio widget missing"), 0 === arguments.length ? this.checkboxradio({icon: !1}) : this.checkboxradio.apply(this, arguments))
        }
    }(e.fn.button), e.fn.buttonset = function () {
        return e.ui.controlgroup || e.error("Controlgroup widget missing"), "option" === arguments[0] && "items" === arguments[1] && arguments[2] ? this.controlgroup.apply(this, [arguments[0], "items.button", arguments[2]]) : "option" === arguments[0] && "items" === arguments[1] ? this.controlgroup.apply(this, [arguments[0], "items.button"]) : ("object" == typeof arguments[0] && arguments[0].items && (arguments[0].items = {button: arguments[0].items}), this.controlgroup.apply(this, arguments))
    }), e.ui.button, e.extend(e.ui, {datepicker: {version: "1.12.1"}});
    var p;
    e.extend(s.prototype, {
        markerClassName: "hasDatepicker",
        maxRows: 4,
        _widgetDatepicker: function () {
            return this.dpDiv
        },
        setDefaults: function (e) {
            return o(this._defaults, e || {}), this
        },
        _attachDatepicker: function (t, i) {
            var s, n, a;
            s = t.nodeName.toLowerCase(), n = "div" === s || "span" === s, t.id || (this.uuid += 1, t.id = "dp" + this.uuid), a = this._newInst(e(t), n), a.settings = e.extend({}, i || {}), "input" === s ? this._connectDatepicker(t, a) : n && this._inlineDatepicker(t, a)
        },
        _newInst: function (t, i) {
            var s = t[0].id.replace(/([^A-Za-z0-9_\-])/g, "\\\\$1");
            return {
                id: s,
                input: t,
                selectedDay: 0,
                selectedMonth: 0,
                selectedYear: 0,
                drawMonth: 0,
                drawYear: 0,
                inline: i,
                dpDiv: i ? n(e("<div class='" + this._inlineClass + " ui-datepicker ui-widget ui-widget-content ui-helper-clearfix ui-corner-all'></div>")) : this.dpDiv
            }
        },
        _connectDatepicker: function (t, i) {
            var s = e(t);
            i.append = e([]), i.trigger = e([]), s.hasClass(this.markerClassName) || (this._attachments(s, i), s.addClass(this.markerClassName).on("keydown", this._doKeyDown).on("keypress", this._doKeyPress).on("keyup", this._doKeyUp), this._autoSize(i), e.data(t, "datepicker", i), i.settings.disabled && this._disableDatepicker(t))
        },
        _attachments: function (t, i) {
            var s, n, a, o = this._get(i, "appendText"), r = this._get(i, "isRTL");
            i.append && i.append.remove(), o && (i.append = e("<span class='" + this._appendClass + "'>" + o + "</span>"), t[r ? "before" : "after"](i.append)), t.off("focus", this._showDatepicker), i.trigger && i.trigger.remove(), s = this._get(i, "showOn"), ("focus" === s || "both" === s) && t.on("focus", this._showDatepicker), ("button" === s || "both" === s) && (n = this._get(i, "buttonText"), a = this._get(i, "buttonImage"), i.trigger = e(this._get(i, "buttonImageOnly") ? e("<img/>").addClass(this._triggerClass).attr({
                    src: a,
                    alt: n,
                    title: n
                }) : e("<button type='button'></button>").addClass(this._triggerClass).html(a ? e("<img/>").attr({
                        src: a,
                        alt: n,
                        title: n
                    }) : n)), t[r ? "before" : "after"](i.trigger), i.trigger.on("click", function () {
                return e.datepicker._datepickerShowing && e.datepicker._lastInput === t[0] ? e.datepicker._hideDatepicker() : e.datepicker._datepickerShowing && e.datepicker._lastInput !== t[0] ? (e.datepicker._hideDatepicker(), e.datepicker._showDatepicker(t[0])) : e.datepicker._showDatepicker(t[0]), !1
            }))
        },
        _autoSize: function (e) {
            if (this._get(e, "autoSize") && !e.inline) {
                var t, i, s, n, a = new Date(2009, 11, 20), o = this._get(e, "dateFormat");
                o.match(/[DM]/) && (t = function (e) {
                    for (i = 0, s = 0, n = 0; e.length > n; n++)e[n].length > i && (i = e[n].length, s = n);
                    return s
                }, a.setMonth(t(this._get(e, o.match(/MM/) ? "monthNames" : "monthNamesShort"))), a.setDate(t(this._get(e, o.match(/DD/) ? "dayNames" : "dayNamesShort")) + 20 - a.getDay())), e.input.attr("size", this._formatDate(e, a).length)
            }
        },
        _inlineDatepicker: function (t, i) {
            var s = e(t);
            s.hasClass(this.markerClassName) || (s.addClass(this.markerClassName).append(i.dpDiv), e.data(t, "datepicker", i), this._setDate(i, this._getDefaultDate(i), !0), this._updateDatepicker(i), this._updateAlternate(i), i.settings.disabled && this._disableDatepicker(t), i.dpDiv.css("display", "block"))
        },
        _dialogDatepicker: function (t, i, s, n, a) {
            var r, h, l, u, c, d = this._dialogInst;
            return d || (this.uuid += 1, r = "dp" + this.uuid, this._dialogInput = e("<input type='text' id='" + r + "' style='position: absolute; top: -100px; width: 0px;'/>"), this._dialogInput.on("keydown", this._doKeyDown), e("body").append(this._dialogInput), d = this._dialogInst = this._newInst(this._dialogInput, !1), d.settings = {}, e.data(this._dialogInput[0], "datepicker", d)), o(d.settings, n || {}), i = i && i.constructor === Date ? this._formatDate(d, i) : i, this._dialogInput.val(i), this._pos = a ? a.length ? a : [a.pageX, a.pageY] : null, this._pos || (h = document.documentElement.clientWidth, l = document.documentElement.clientHeight, u = document.documentElement.scrollLeft || document.body.scrollLeft, c = document.documentElement.scrollTop || document.body.scrollTop, this._pos = [h / 2 - 100 + u, l / 2 - 150 + c]), this._dialogInput.css("left", this._pos[0] + 20 + "px").css("top", this._pos[1] + "px"), d.settings.onSelect = s, this._inDialog = !0, this.dpDiv.addClass(this._dialogClass), this._showDatepicker(this._dialogInput[0]), e.blockUI && e.blockUI(this.dpDiv), e.data(this._dialogInput[0], "datepicker", d), this
        },
        _destroyDatepicker: function (t) {
            var i, s = e(t), n = e.data(t, "datepicker");
            s.hasClass(this.markerClassName) && (i = t.nodeName.toLowerCase(), e.removeData(t, "datepicker"), "input" === i ? (n.append.remove(), n.trigger.remove(), s.removeClass(this.markerClassName).off("focus", this._showDatepicker).off("keydown", this._doKeyDown).off("keypress", this._doKeyPress).off("keyup", this._doKeyUp)) : ("div" === i || "span" === i) && s.removeClass(this.markerClassName).empty(), p === n && (p = null))
        },
        _enableDatepicker: function (t) {
            var i, s, n = e(t), a = e.data(t, "datepicker");
            n.hasClass(this.markerClassName) && (i = t.nodeName.toLowerCase(), "input" === i ? (t.disabled = !1, a.trigger.filter("button").each(function () {
                    this.disabled = !1
                }).end().filter("img").css({
                    opacity: "1.0",
                    cursor: ""
                })) : ("div" === i || "span" === i) && (s = n.children("." + this._inlineClass), s.children().removeClass("ui-state-disabled"), s.find("select.ui-datepicker-month, select.ui-datepicker-year").prop("disabled", !1)), this._disabledInputs = e.map(this._disabledInputs, function (e) {
                return e === t ? null : e
            }))
        },
        _disableDatepicker: function (t) {
            var i, s, n = e(t), a = e.data(t, "datepicker");
            n.hasClass(this.markerClassName) && (i = t.nodeName.toLowerCase(), "input" === i ? (t.disabled = !0, a.trigger.filter("button").each(function () {
                    this.disabled = !0
                }).end().filter("img").css({
                    opacity: "0.5",
                    cursor: "default"
                })) : ("div" === i || "span" === i) && (s = n.children("." + this._inlineClass), s.children().addClass("ui-state-disabled"), s.find("select.ui-datepicker-month, select.ui-datepicker-year").prop("disabled", !0)), this._disabledInputs = e.map(this._disabledInputs, function (e) {
                return e === t ? null : e
            }), this._disabledInputs[this._disabledInputs.length] = t)
        },
        _isDisabledDatepicker: function (e) {
            if (!e)return !1;
            for (var t = 0; this._disabledInputs.length > t; t++)if (this._disabledInputs[t] === e)return !0;
            return !1
        },
        _getInst: function (t) {
            try {
                return e.data(t, "datepicker")
            } catch (i) {
                throw"Missing instance data for this datepicker"
            }
        },
        _optionDatepicker: function (t, i, s) {
            var n, a, r, h, l = this._getInst(t);
            return 2 === arguments.length && "string" == typeof i ? "defaults" === i ? e.extend({}, e.datepicker._defaults) : l ? "all" === i ? e.extend({}, l.settings) : this._get(l, i) : null : (n = i || {}, "string" == typeof i && (n = {}, n[i] = s), l && (this._curInst === l && this._hideDatepicker(), a = this._getDateDatepicker(t, !0), r = this._getMinMaxDate(l, "min"), h = this._getMinMaxDate(l, "max"), o(l.settings, n), null !== r && void 0 !== n.dateFormat && void 0 === n.minDate && (l.settings.minDate = this._formatDate(l, r)), null !== h && void 0 !== n.dateFormat && void 0 === n.maxDate && (l.settings.maxDate = this._formatDate(l, h)), "disabled" in n && (n.disabled ? this._disableDatepicker(t) : this._enableDatepicker(t)), this._attachments(e(t), l), this._autoSize(l), this._setDate(l, a), this._updateAlternate(l), this._updateDatepicker(l)), void 0)
        },
        _changeDatepicker: function (e, t, i) {
            this._optionDatepicker(e, t, i)
        },
        _refreshDatepicker: function (e) {
            var t = this._getInst(e);
            t && this._updateDatepicker(t)
        },
        _setDateDatepicker: function (e, t) {
            var i = this._getInst(e);
            i && (this._setDate(i, t), this._updateDatepicker(i), this._updateAlternate(i))
        },
        _getDateDatepicker: function (e, t) {
            var i = this._getInst(e);
            return i && !i.inline && this._setDateFromField(i, t), i ? this._getDate(i) : null
        },
        _doKeyDown: function (t) {
            var i, s, n, a = e.datepicker._getInst(t.target), o = !0, r = a.dpDiv.is(".ui-datepicker-rtl");
            if (a._keyEvent = !0, e.datepicker._datepickerShowing)switch (t.keyCode) {
                case 9:
                    e.datepicker._hideDatepicker(), o = !1;
                    break;
                case 13:
                    return n = e("td." + e.datepicker._dayOverClass + ":not(." + e.datepicker._currentClass + ")", a.dpDiv), n[0] && e.datepicker._selectDay(t.target, a.selectedMonth, a.selectedYear, n[0]), i = e.datepicker._get(a, "onSelect"), i ? (s = e.datepicker._formatDate(a), i.apply(a.input ? a.input[0] : null, [s, a])) : e.datepicker._hideDatepicker(), !1;
                case 27:
                    e.datepicker._hideDatepicker();
                    break;
                case 33:
                    e.datepicker._adjustDate(t.target, t.ctrlKey ? -e.datepicker._get(a, "stepBigMonths") : -e.datepicker._get(a, "stepMonths"), "M");
                    break;
                case 34:
                    e.datepicker._adjustDate(t.target, t.ctrlKey ? +e.datepicker._get(a, "stepBigMonths") : +e.datepicker._get(a, "stepMonths"), "M");
                    break;
                case 35:
                    (t.ctrlKey || t.metaKey) && e.datepicker._clearDate(t.target), o = t.ctrlKey || t.metaKey;
                    break;
                case 36:
                    (t.ctrlKey || t.metaKey) && e.datepicker._gotoToday(t.target), o = t.ctrlKey || t.metaKey;
                    break;
                case 37:
                    (t.ctrlKey || t.metaKey) && e.datepicker._adjustDate(t.target, r ? 1 : -1, "D"), o = t.ctrlKey || t.metaKey, t.originalEvent.altKey && e.datepicker._adjustDate(t.target, t.ctrlKey ? -e.datepicker._get(a, "stepBigMonths") : -e.datepicker._get(a, "stepMonths"), "M");
                    break;
                case 38:
                    (t.ctrlKey || t.metaKey) && e.datepicker._adjustDate(t.target, -7, "D"), o = t.ctrlKey || t.metaKey;
                    break;
                case 39:
                    (t.ctrlKey || t.metaKey) && e.datepicker._adjustDate(t.target, r ? -1 : 1, "D"), o = t.ctrlKey || t.metaKey, t.originalEvent.altKey && e.datepicker._adjustDate(t.target, t.ctrlKey ? +e.datepicker._get(a, "stepBigMonths") : +e.datepicker._get(a, "stepMonths"), "M");
                    break;
                case 40:
                    (t.ctrlKey || t.metaKey) && e.datepicker._adjustDate(t.target, 7, "D"), o = t.ctrlKey || t.metaKey;
                    break;
                default:
                    o = !1
            } else 36 === t.keyCode && t.ctrlKey ? e.datepicker._showDatepicker(this) : o = !1;
            o && (t.preventDefault(), t.stopPropagation())
        },
        _doKeyPress: function (t) {
            var i, s, n = e.datepicker._getInst(t.target);
            return e.datepicker._get(n, "constrainInput") ? (i = e.datepicker._possibleChars(e.datepicker._get(n, "dateFormat")), s = String.fromCharCode(null == t.charCode ? t.keyCode : t.charCode), t.ctrlKey || t.metaKey || " " > s || !i || i.indexOf(s) > -1) : void 0
        },
        _doKeyUp: function (t) {
            var i, s = e.datepicker._getInst(t.target);
            if (s.input.val() !== s.lastVal)try {
                i = e.datepicker.parseDate(e.datepicker._get(s, "dateFormat"), s.input ? s.input.val() : null, e.datepicker._getFormatConfig(s)), i && (e.datepicker._setDateFromField(s), e.datepicker._updateAlternate(s), e.datepicker._updateDatepicker(s))
            } catch (n) {
            }
            return !0
        },
        _showDatepicker: function (t) {
            if (t = t.target || t, "input" !== t.nodeName.toLowerCase() && (t = e("input", t.parentNode)[0]), !e.datepicker._isDisabledDatepicker(t) && e.datepicker._lastInput !== t) {
                var s, n, a, r, h, l, u;
                s = e.datepicker._getInst(t), e.datepicker._curInst && e.datepicker._curInst !== s && (e.datepicker._curInst.dpDiv.stop(!0, !0), s && e.datepicker._datepickerShowing && e.datepicker._hideDatepicker(e.datepicker._curInst.input[0])), n = e.datepicker._get(s, "beforeShow"), a = n ? n.apply(t, [t, s]) : {}, a !== !1 && (o(s.settings, a), s.lastVal = null, e.datepicker._lastInput = t, e.datepicker._setDateFromField(s), e.datepicker._inDialog && (t.value = ""), e.datepicker._pos || (e.datepicker._pos = e.datepicker._findPos(t), e.datepicker._pos[1] += t.offsetHeight), r = !1, e(t).parents().each(function () {
                    return r |= "fixed" === e(this).css("position"), !r
                }), h = {
                    left: e.datepicker._pos[0],
                    top: e.datepicker._pos[1]
                }, e.datepicker._pos = null, s.dpDiv.empty(), s.dpDiv.css({
                    position: "absolute",
                    display: "block",
                    top: "-1000px"
                }), e.datepicker._updateDatepicker(s), h = e.datepicker._checkOffset(s, h, r), s.dpDiv.css({
                    position: e.datepicker._inDialog && e.blockUI ? "static" : r ? "fixed" : "absolute",
                    display: "none",
                    left: h.left + "px",
                    top: h.top + "px"
                }), s.inline || (l = e.datepicker._get(s, "showAnim"), u = e.datepicker._get(s, "duration"), s.dpDiv.css("z-index", i(e(t)) + 1), e.datepicker._datepickerShowing = !0, e.effects && e.effects.effect[l] ? s.dpDiv.show(l, e.datepicker._get(s, "showOptions"), u) : s.dpDiv[l || "show"](l ? u : null), e.datepicker._shouldFocusInput(s) && s.input.trigger("focus"), e.datepicker._curInst = s))
            }
        },
        _updateDatepicker: function (t) {
            this.maxRows = 4, p = t, t.dpDiv.empty().append(this._generateHTML(t)), this._attachHandlers(t);
            var i, s = this._getNumberOfMonths(t), n = s[1], o = 17, r = t.dpDiv.find("." + this._dayOverClass + " a");
            r.length > 0 && a.apply(r.get(0)), t.dpDiv.removeClass("ui-datepicker-multi-2 ui-datepicker-multi-3 ui-datepicker-multi-4").width(""), n > 1 && t.dpDiv.addClass("ui-datepicker-multi-" + n).css("width", o * n + "em"), t.dpDiv[(1 !== s[0] || 1 !== s[1] ? "add" : "remove") + "Class"]("ui-datepicker-multi"), t.dpDiv[(this._get(t, "isRTL") ? "add" : "remove") + "Class"]("ui-datepicker-rtl"), t === e.datepicker._curInst && e.datepicker._datepickerShowing && e.datepicker._shouldFocusInput(t) && t.input.trigger("focus"), t.yearshtml && (i = t.yearshtml, setTimeout(function () {
                i === t.yearshtml && t.yearshtml && t.dpDiv.find("select.ui-datepicker-year:first").replaceWith(t.yearshtml), i = t.yearshtml = null
            }, 0))
        },
        _shouldFocusInput: function (e) {
            return e.input && e.input.is(":visible") && !e.input.is(":disabled") && !e.input.is(":focus")
        },
        _checkOffset: function (t, i, s) {
            var n = t.dpDiv.outerWidth(), a = t.dpDiv.outerHeight(), o = t.input ? t.input.outerWidth() : 0, r = t.input ? t.input.outerHeight() : 0, h = document.documentElement.clientWidth + (s ? 0 : e(document).scrollLeft()), l = document.documentElement.clientHeight + (s ? 0 : e(document).scrollTop());
            return i.left -= this._get(t, "isRTL") ? n - o : 0, i.left -= s && i.left === t.input.offset().left ? e(document).scrollLeft() : 0, i.top -= s && i.top === t.input.offset().top + r ? e(document).scrollTop() : 0, i.left -= Math.min(i.left, i.left + n > h && h > n ? Math.abs(i.left + n - h) : 0), i.top -= Math.min(i.top, i.top + a > l && l > a ? Math.abs(a + r) : 0), i
        },
        _findPos: function (t) {
            for (var i, s = this._getInst(t), n = this._get(s, "isRTL"); t && ("hidden" === t.type || 1 !== t.nodeType || e.expr.filters.hidden(t));)t = t[n ? "previousSibling" : "nextSibling"];
            return i = e(t).offset(), [i.left, i.top]
        },
        _hideDatepicker: function (t) {
            var i, s, n, a, o = this._curInst;
            !o || t && o !== e.data(t, "datepicker") || this._datepickerShowing && (i = this._get(o, "showAnim"), s = this._get(o, "duration"), n = function () {
                e.datepicker._tidyDialog(o)
            }, e.effects && (e.effects.effect[i] || e.effects[i]) ? o.dpDiv.hide(i, e.datepicker._get(o, "showOptions"), s, n) : o.dpDiv["slideDown" === i ? "slideUp" : "fadeIn" === i ? "fadeOut" : "hide"](i ? s : null, n), i || n(), this._datepickerShowing = !1, a = this._get(o, "onClose"), a && a.apply(o.input ? o.input[0] : null, [o.input ? o.input.val() : "", o]), this._lastInput = null, this._inDialog && (this._dialogInput.css({
                position: "absolute",
                left: "0",
                top: "-100px"
            }), e.blockUI && (e.unblockUI(), e("body").append(this.dpDiv))), this._inDialog = !1)
        },
        _tidyDialog: function (e) {
            e.dpDiv.removeClass(this._dialogClass).off(".ui-datepicker-calendar")
        },
        _checkExternalClick: function (t) {
            if (e.datepicker._curInst) {
                var i = e(t.target), s = e.datepicker._getInst(i[0]);
                (i[0].id !== e.datepicker._mainDivId && 0 === i.parents("#" + e.datepicker._mainDivId).length && !i.hasClass(e.datepicker.markerClassName) && !i.closest("." + e.datepicker._triggerClass).length && e.datepicker._datepickerShowing && (!e.datepicker._inDialog || !e.blockUI) || i.hasClass(e.datepicker.markerClassName) && e.datepicker._curInst !== s) && e.datepicker._hideDatepicker()
            }
        },
        _adjustDate: function (t, i, s) {
            var n = e(t), a = this._getInst(n[0]);
            this._isDisabledDatepicker(n[0]) || (this._adjustInstDate(a, i + ("M" === s ? this._get(a, "showCurrentAtPos") : 0), s), this._updateDatepicker(a))
        },
        _gotoToday: function (t) {
            var i, s = e(t), n = this._getInst(s[0]);
            this._get(n, "gotoCurrent") && n.currentDay ? (n.selectedDay = n.currentDay, n.drawMonth = n.selectedMonth = n.currentMonth, n.drawYear = n.selectedYear = n.currentYear) : (i = new Date, n.selectedDay = i.getDate(), n.drawMonth = n.selectedMonth = i.getMonth(), n.drawYear = n.selectedYear = i.getFullYear()), this._notifyChange(n), this._adjustDate(s)
        },
        _selectMonthYear: function (t, i, s) {
            var n = e(t), a = this._getInst(n[0]);
            a["selected" + ("M" === s ? "Month" : "Year")] = a["draw" + ("M" === s ? "Month" : "Year")] = parseInt(i.options[i.selectedIndex].value, 10), this._notifyChange(a), this._adjustDate(n)
        },
        _selectDay: function (t, i, s, n) {
            var a, o = e(t);
            e(n).hasClass(this._unselectableClass) || this._isDisabledDatepicker(o[0]) || (a = this._getInst(o[0]), a.selectedDay = a.currentDay = e("a", n).html(), a.selectedMonth = a.currentMonth = i, a.selectedYear = a.currentYear = s, this._selectDate(t, this._formatDate(a, a.currentDay, a.currentMonth, a.currentYear)))
        },
        _clearDate: function (t) {
            var i = e(t);
            this._selectDate(i, "")
        },
        _selectDate: function (t, i) {
            var s, n = e(t), a = this._getInst(n[0]);
            i = null != i ? i : this._formatDate(a), a.input && a.input.val(i), this._updateAlternate(a), s = this._get(a, "onSelect"), s ? s.apply(a.input ? a.input[0] : null, [i, a]) : a.input && a.input.trigger("change"), a.inline ? this._updateDatepicker(a) : (this._hideDatepicker(), this._lastInput = a.input[0], "object" != typeof a.input[0] && a.input.trigger("focus"), this._lastInput = null)
        },
        _updateAlternate: function (t) {
            var i, s, n, a = this._get(t, "altField");
            a && (i = this._get(t, "altFormat") || this._get(t, "dateFormat"), s = this._getDate(t), n = this.formatDate(i, s, this._getFormatConfig(t)), e(a).val(n))
        },
        noWeekends: function (e) {
            var t = e.getDay();
            return [t > 0 && 6 > t, ""]
        },
        iso8601Week: function (e) {
            var t, i = new Date(e.getTime());
            return i.setDate(i.getDate() + 4 - (i.getDay() || 7)), t = i.getTime(), i.setMonth(0), i.setDate(1), Math.floor(Math.round((t - i) / 864e5) / 7) + 1
        },
        parseDate: function (t, i, s) {
            if (null == t || null == i)throw"Invalid arguments";
            if (i = "object" == typeof i ? "" + i : i + "", "" === i)return null;
            var n, a, o, r, h = 0, l = (s ? s.shortYearCutoff : null) || this._defaults.shortYearCutoff, u = "string" != typeof l ? l : (new Date).getFullYear() % 100 + parseInt(l, 10), c = (s ? s.dayNamesShort : null) || this._defaults.dayNamesShort, d = (s ? s.dayNames : null) || this._defaults.dayNames, p = (s ? s.monthNamesShort : null) || this._defaults.monthNamesShort, f = (s ? s.monthNames : null) || this._defaults.monthNames, m = -1, g = -1, v = -1, _ = -1, b = !1, y = function (e) {
                var i = t.length > n + 1 && t.charAt(n + 1) === e;
                return i && n++, i
            }, x = function (e) {
                var t = y(e), s = "@" === e ? 14 : "!" === e ? 20 : "y" === e && t ? 4 : "o" === e ? 3 : 2, n = "y" === e ? s : 1, a = RegExp("^\\d{" + n + "," + s + "}"), o = i.substring(h).match(a);
                if (!o)throw"Missing number at position " + h;
                return h += o[0].length, parseInt(o[0], 10)
            }, k = function (t, s, n) {
                var a = -1, o = e.map(y(t) ? n : s, function (e, t) {
                    return [[t, e]]
                }).sort(function (e, t) {
                    return -(e[1].length - t[1].length)
                });
                if (e.each(o, function (e, t) {
                        var s = t[1];
                        return i.substr(h, s.length).toLowerCase() === s.toLowerCase() ? (a = t[0], h += s.length, !1) : void 0
                    }), -1 !== a)return a + 1;
                throw"Unknown name at position " + h
            }, w = function () {
                if (i.charAt(h) !== t.charAt(n))throw"Unexpected literal at position " + h;
                h++
            };
            for (n = 0; t.length > n; n++)if (b) "'" !== t.charAt(n) || y("'") ? w() : b = !1; else switch (t.charAt(n)) {
                case"d":
                    v = x("d");
                    break;
                case"D":
                    k("D", c, d);
                    break;
                case"o":
                    _ = x("o");
                    break;
                case"m":
                    g = x("m");
                    break;
                case"M":
                    g = k("M", p, f);
                    break;
                case"y":
                    m = x("y");
                    break;
                case"@":
                    r = new Date(x("@")), m = r.getFullYear(), g = r.getMonth() + 1, v = r.getDate();
                    break;
                case"!":
                    r = new Date((x("!") - this._ticksTo1970) / 1e4), m = r.getFullYear(), g = r.getMonth() + 1, v = r.getDate();
                    break;
                case"'":
                    y("'") ? w() : b = !0;
                    break;
                default:
                    w()
            }
            if (i.length > h && (o = i.substr(h), !/^\s+/.test(o)))throw"Extra/unparsed characters found in date: " + o;
            if (-1 === m ? m = (new Date).getFullYear() : 100 > m && (m += (new Date).getFullYear() - (new Date).getFullYear() % 100 + (u >= m ? 0 : -100)), _ > -1)for (g = 1, v = _; ;) {
                if (a = this._getDaysInMonth(m, g - 1), a >= v)break;
                g++, v -= a
            }
            if (r = this._daylightSavingAdjust(new Date(m, g - 1, v)), r.getFullYear() !== m || r.getMonth() + 1 !== g || r.getDate() !== v)throw"Invalid date";
            return r
        },
        ATOM: "yy-mm-dd",
        COOKIE: "D, dd M yy",
        ISO_8601: "yy-mm-dd",
        RFC_822: "D, d M y",
        RFC_850: "DD, dd-M-y",
        RFC_1036: "D, d M y",
        RFC_1123: "D, d M yy",
        RFC_2822: "D, d M yy",
        RSS: "D, d M y",
        TICKS: "!",
        TIMESTAMP: "@",
        W3C: "yy-mm-dd",
        _ticksTo1970: 1e7 * 60 * 60 * 24 * (718685 + Math.floor(492.5) - Math.floor(19.7) + Math.floor(4.925)),
        formatDate: function (e, t, i) {
            if (!t)return "";
            var s, n = (i ? i.dayNamesShort : null) || this._defaults.dayNamesShort, a = (i ? i.dayNames : null) || this._defaults.dayNames, o = (i ? i.monthNamesShort : null) || this._defaults.monthNamesShort, r = (i ? i.monthNames : null) || this._defaults.monthNames, h = function (t) {
                var i = e.length > s + 1 && e.charAt(s + 1) === t;
                return i && s++, i
            }, l = function (e, t, i) {
                var s = "" + t;
                if (h(e))for (; i > s.length;)s = "0" + s;
                return s
            }, u = function (e, t, i, s) {
                return h(e) ? s[t] : i[t]
            }, c = "", d = !1;
            if (t)for (s = 0; e.length > s; s++)if (d) "'" !== e.charAt(s) || h("'") ? c += e.charAt(s) : d = !1; else switch (e.charAt(s)) {
                case"d":
                    c += l("d", t.getDate(), 2);
                    break;
                case"D":
                    c += u("D", t.getDay(), n, a);
                    break;
                case"o":
                    c += l("o", Math.round((new Date(t.getFullYear(), t.getMonth(), t.getDate()).getTime() - new Date(t.getFullYear(), 0, 0).getTime()) / 864e5), 3);
                    break;
                case"m":
                    c += l("m", t.getMonth() + 1, 2);
                    break;
                case"M":
                    c += u("M", t.getMonth(), o, r);
                    break;
                case"y":
                    c += h("y") ? t.getFullYear() : (10 > t.getFullYear() % 100 ? "0" : "") + t.getFullYear() % 100;
                    break;
                case"@":
                    c += t.getTime();
                    break;
                case"!":
                    c += 1e4 * t.getTime() + this._ticksTo1970;
                    break;
                case"'":
                    h("'") ? c += "'" : d = !0;
                    break;
                default:
                    c += e.charAt(s)
            }
            return c
        },
        _possibleChars: function (e) {
            var t, i = "", s = !1, n = function (i) {
                var s = e.length > t + 1 && e.charAt(t + 1) === i;
                return s && t++, s
            };
            for (t = 0; e.length > t; t++)if (s) "'" !== e.charAt(t) || n("'") ? i += e.charAt(t) : s = !1; else switch (e.charAt(t)) {
                case"d":
                case"m":
                case"y":
                case"@":
                    i += "0123456789";
                    break;
                case"D":
                case"M":
                    return null;
                case"'":
                    n("'") ? i += "'" : s = !0;
                    break;
                default:
                    i += e.charAt(t)
            }
            return i
        },
        _get: function (e, t) {
            return void 0 !== e.settings[t] ? e.settings[t] : this._defaults[t]
        },
        _setDateFromField: function (e, t) {
            if (e.input.val() !== e.lastVal) {
                var i = this._get(e, "dateFormat"), s = e.lastVal = e.input ? e.input.val() : null, n = this._getDefaultDate(e), a = n, o = this._getFormatConfig(e);
                try {
                    a = this.parseDate(i, s, o) || n
                } catch (r) {
                    s = t ? "" : s
                }
                e.selectedDay = a.getDate(), e.drawMonth = e.selectedMonth = a.getMonth(), e.drawYear = e.selectedYear = a.getFullYear(), e.currentDay = s ? a.getDate() : 0, e.currentMonth = s ? a.getMonth() : 0, e.currentYear = s ? a.getFullYear() : 0, this._adjustInstDate(e)
            }
        },
        _getDefaultDate: function (e) {
            return this._restrictMinMax(e, this._determineDate(e, this._get(e, "defaultDate"), new Date))
        },
        _determineDate: function (t, i, s) {
            var n = function (e) {
                var t = new Date;
                return t.setDate(t.getDate() + e), t
            }, a = function (i) {
                try {
                    return e.datepicker.parseDate(e.datepicker._get(t, "dateFormat"), i, e.datepicker._getFormatConfig(t))
                } catch (s) {
                }
                for (var n = (i.toLowerCase().match(/^c/) ? e.datepicker._getDate(t) : null) || new Date, a = n.getFullYear(), o = n.getMonth(), r = n.getDate(), h = /([+\-]?[0-9]+)\s*(d|D|w|W|m|M|y|Y)?/g, l = h.exec(i); l;) {
                    switch (l[2] || "d") {
                        case"d":
                        case"D":
                            r += parseInt(l[1], 10);
                            break;
                        case"w":
                        case"W":
                            r += 7 * parseInt(l[1], 10);
                            break;
                        case"m":
                        case"M":
                            o += parseInt(l[1], 10), r = Math.min(r, e.datepicker._getDaysInMonth(a, o));
                            break;
                        case"y":
                        case"Y":
                            a += parseInt(l[1], 10), r = Math.min(r, e.datepicker._getDaysInMonth(a, o))
                    }
                    l = h.exec(i)
                }
                return new Date(a, o, r)
            }, o = null == i || "" === i ? s : "string" == typeof i ? a(i) : "number" == typeof i ? isNaN(i) ? s : n(i) : new Date(i.getTime());
            return o = o && "Invalid Date" == "" + o ? s : o, o && (o.setHours(0), o.setMinutes(0), o.setSeconds(0), o.setMilliseconds(0)), this._daylightSavingAdjust(o)
        },
        _daylightSavingAdjust: function (e) {
            return e ? (e.setHours(e.getHours() > 12 ? e.getHours() + 2 : 0), e) : null
        },
        _setDate: function (e, t, i) {
            var s = !t, n = e.selectedMonth, a = e.selectedYear, o = this._restrictMinMax(e, this._determineDate(e, t, new Date));
            e.selectedDay = e.currentDay = o.getDate(), e.drawMonth = e.selectedMonth = e.currentMonth = o.getMonth(), e.drawYear = e.selectedYear = e.currentYear = o.getFullYear(), n === e.selectedMonth && a === e.selectedYear || i || this._notifyChange(e), this._adjustInstDate(e), e.input && e.input.val(s ? "" : this._formatDate(e))
        },
        _getDate: function (e) {
            var t = !e.currentYear || e.input && "" === e.input.val() ? null : this._daylightSavingAdjust(new Date(e.currentYear, e.currentMonth, e.currentDay));
            return t
        },
        _attachHandlers: function (t) {
            var i = this._get(t, "stepMonths"), s = "#" + t.id.replace(/\\\\/g, "\\");
            t.dpDiv.find("[data-handler]").map(function () {
                var t = {
                    prev: function () {
                        e.datepicker._adjustDate(s, -i, "M")
                    }, next: function () {
                        e.datepicker._adjustDate(s, +i, "M")
                    }, hide: function () {
                        e.datepicker._hideDatepicker()
                    }, today: function () {
                        e.datepicker._gotoToday(s)
                    }, selectDay: function () {
                        return e.datepicker._selectDay(s, +this.getAttribute("data-month"), +this.getAttribute("data-year"), this), !1
                    }, selectMonth: function () {
                        return e.datepicker._selectMonthYear(s, this, "M"), !1
                    }, selectYear: function () {
                        return e.datepicker._selectMonthYear(s, this, "Y"), !1
                    }
                };
                e(this).on(this.getAttribute("data-event"), t[this.getAttribute("data-handler")])
            })
        },
        _generateHTML: function (e) {
            var t, i, s, n, a, o, r, h, l, u, c, d, p, f, m, g, v, _, b, y, x, k, w, T, D, S, M, C, N, P, A, I, H, z, F, j, O, E, L, W = new Date, R = this._daylightSavingAdjust(new Date(W.getFullYear(), W.getMonth(), W.getDate())), Y = this._get(e, "isRTL"), B = this._get(e, "showButtonPanel"), J = this._get(e, "hideIfNoPrevNext"), Q = this._get(e, "navigationAsDateFormat"), K = this._getNumberOfMonths(e), V = this._get(e, "showCurrentAtPos"), U = this._get(e, "stepMonths"), q = 1 !== K[0] || 1 !== K[1], G = this._daylightSavingAdjust(e.currentDay ? new Date(e.currentYear, e.currentMonth, e.currentDay) : new Date(9999, 9, 9)), X = this._getMinMaxDate(e, "min"), $ = this._getMinMaxDate(e, "max"), Z = e.drawMonth - V, et = e.drawYear;
            if (0 > Z && (Z += 12, et--), $)for (t = this._daylightSavingAdjust(new Date($.getFullYear(), $.getMonth() - K[0] * K[1] + 1, $.getDate())), t = X && X > t ? X : t; this._daylightSavingAdjust(new Date(et, Z, 1)) > t;)Z--, 0 > Z && (Z = 11, et--);
            for (e.drawMonth = Z, e.drawYear = et, i = this._get(e, "prevText"), i = Q ? this.formatDate(i, this._daylightSavingAdjust(new Date(et, Z - U, 1)), this._getFormatConfig(e)) : i, s = this._canAdjustMonth(e, -1, et, Z) ? "<a class='ui-datepicker-prev ui-corner-all' data-handler='prev' data-event='click' title='" + i + "'><span class='ui-icon ui-icon-circle-triangle-" + (Y ? "e" : "w") + "'>" + i + "</span></a>" : J ? "" : "<a class='ui-datepicker-prev ui-corner-all ui-state-disabled' title='" + i + "'><span class='ui-icon ui-icon-circle-triangle-" + (Y ? "e" : "w") + "'>" + i + "</span></a>", n = this._get(e, "nextText"), n = Q ? this.formatDate(n, this._daylightSavingAdjust(new Date(et, Z + U, 1)), this._getFormatConfig(e)) : n, a = this._canAdjustMonth(e, 1, et, Z) ? "<a class='ui-datepicker-next ui-corner-all' data-handler='next' data-event='click' title='" + n + "'><span class='ui-icon ui-icon-circle-triangle-" + (Y ? "w" : "e") + "'>" + n + "</span></a>" : J ? "" : "<a class='ui-datepicker-next ui-corner-all ui-state-disabled' title='" + n + "'><span class='ui-icon ui-icon-circle-triangle-" + (Y ? "w" : "e") + "'>" + n + "</span></a>", o = this._get(e, "currentText"), r = this._get(e, "gotoCurrent") && e.currentDay ? G : R, o = Q ? this.formatDate(o, r, this._getFormatConfig(e)) : o, h = e.inline ? "" : "<button type='button' class='ui-datepicker-close ui-state-default ui-priority-primary ui-corner-all' data-handler='hide' data-event='click'>" + this._get(e, "closeText") + "</button>", l = B ? "<div class='ui-datepicker-buttonpane ui-widget-content'>" + (Y ? h : "") + (this._isInRange(e, r) ? "<button type='button' class='ui-datepicker-current ui-state-default ui-priority-secondary ui-corner-all' data-handler='today' data-event='click'>" + o + "</button>" : "") + (Y ? "" : h) + "</div>" : "", u = parseInt(this._get(e, "firstDay"), 10), u = isNaN(u) ? 0 : u, c = this._get(e, "showWeek"), d = this._get(e, "dayNames"), p = this._get(e, "dayNamesMin"), f = this._get(e, "monthNames"), m = this._get(e, "monthNamesShort"), g = this._get(e, "beforeShowDay"), v = this._get(e, "showOtherMonths"), _ = this._get(e, "selectOtherMonths"), b = this._getDefaultDate(e), y = "", k = 0; K[0] > k; k++) {
                for (w = "", this.maxRows = 4, T = 0; K[1] > T; T++) {
                    if (D = this._daylightSavingAdjust(new Date(et, Z, e.selectedDay)), S = " ui-corner-all", M = "", q) {
                        if (M += "<div class='ui-datepicker-group", K[1] > 1)switch (T) {
                            case 0:
                                M += " ui-datepicker-group-first", S = " ui-corner-" + (Y ? "right" : "left");
                                break;
                            case K[1] - 1:
                                M += " ui-datepicker-group-last", S = " ui-corner-" + (Y ? "left" : "right");
                                break;
                            default:
                                M += " ui-datepicker-group-middle", S = ""
                        }
                        M += "'>"
                    }
                    for (M += "<div class='ui-datepicker-header ui-widget-header ui-helper-clearfix" + S + "'>" + (/all|left/.test(S) && 0 === k ? Y ? a : s : "") + (/all|right/.test(S) && 0 === k ? Y ? s : a : "") + this._generateMonthYearHeader(e, Z, et, X, $, k > 0 || T > 0, f, m) + "</div><table class='ui-datepicker-calendar'><thead>" + "<tr>", C = c ? "<th class='ui-datepicker-week-col'>" + this._get(e, "weekHeader") + "</th>" : "", x = 0; 7 > x; x++)N = (x + u) % 7, C += "<th scope='col'" + ((x + u + 6) % 7 >= 5 ? " class='ui-datepicker-week-end'" : "") + ">" + "<span title='" + d[N] + "'>" + p[N] + "</span></th>";
                    for (M += C + "</tr></thead><tbody>", P = this._getDaysInMonth(et, Z), et === e.selectedYear && Z === e.selectedMonth && (e.selectedDay = Math.min(e.selectedDay, P)), A = (this._getFirstDayOfMonth(et, Z) - u + 7) % 7, I = Math.ceil((A + P) / 7), H = q ? this.maxRows > I ? this.maxRows : I : I, this.maxRows = H, z = this._daylightSavingAdjust(new Date(et, Z, 1 - A)), F = 0; H > F; F++) {
                        for (M += "<tr>", j = c ? "<td class='ui-datepicker-week-col'>" + this._get(e, "calculateWeek")(z) + "</td>" : "", x = 0; 7 > x; x++)O = g ? g.apply(e.input ? e.input[0] : null, [z]) : [!0, ""], E = z.getMonth() !== Z, L = E && !_ || !O[0] || X && X > z || $ && z > $, j += "<td class='" + ((x + u + 6) % 7 >= 5 ? " ui-datepicker-week-end" : "") + (E ? " ui-datepicker-other-month" : "") + (z.getTime() === D.getTime() && Z === e.selectedMonth && e._keyEvent || b.getTime() === z.getTime() && b.getTime() === D.getTime() ? " " + this._dayOverClass : "") + (L ? " " + this._unselectableClass + " ui-state-disabled" : "") + (E && !v ? "" : " " + O[1] + (z.getTime() === G.getTime() ? " " + this._currentClass : "") + (z.getTime() === R.getTime() ? " ui-datepicker-today" : "")) + "'" + (E && !v || !O[2] ? "" : " title='" + O[2].replace(/'/g, "&#39;") + "'") + (L ? "" : " data-handler='selectDay' data-event='click' data-month='" + z.getMonth() + "' data-year='" + z.getFullYear() + "'") + ">" + (E && !v ? "&#xa0;" : L ? "<span class='ui-state-default'>" + z.getDate() + "</span>" : "<a class='ui-state-default" + (z.getTime() === R.getTime() ? " ui-state-highlight" : "") + (z.getTime() === G.getTime() ? " ui-state-active" : "") + (E ? " ui-priority-secondary" : "") + "' href='#'>" + z.getDate() + "</a>") + "</td>", z.setDate(z.getDate() + 1), z = this._daylightSavingAdjust(z);
                        M += j + "</tr>"
                    }
                    Z++, Z > 11 && (Z = 0, et++), M += "</tbody></table>" + (q ? "</div>" + (K[0] > 0 && T === K[1] - 1 ? "<div class='ui-datepicker-row-break'></div>" : "") : ""), w += M
                }
                y += w
            }
            return y += l, e._keyEvent = !1, y
        },
        _generateMonthYearHeader: function (e, t, i, s, n, a, o, r) {
            var h, l, u, c, d, p, f, m, g = this._get(e, "changeMonth"), v = this._get(e, "changeYear"), _ = this._get(e, "showMonthAfterYear"), b = "<div class='ui-datepicker-title'>", y = "";
            if (a || !g) y += "<span class='ui-datepicker-month'>" + o[t] + "</span>"; else {
                for (h = s && s.getFullYear() === i, l = n && n.getFullYear() === i, y += "<select class='ui-datepicker-month' data-handler='selectMonth' data-event='change'>", u = 0; 12 > u; u++)(!h || u >= s.getMonth()) && (!l || n.getMonth() >= u) && (y += "<option value='" + u + "'" + (u === t ? " selected='selected'" : "") + ">" + r[u] + "</option>");
                y += "</select>"
            }
            if (_ || (b += y + (!a && g && v ? "" : "&#xa0;")), !e.yearshtml)if (e.yearshtml = "", a || !v) b += "<span class='ui-datepicker-year'>" + i + "</span>"; else {
                for (c = this._get(e, "yearRange").split(":"), d = (new Date).getFullYear(), p = function (e) {
                    var t = e.match(/c[+\-].*/) ? i + parseInt(e.substring(1), 10) : e.match(/[+\-].*/) ? d + parseInt(e, 10) : parseInt(e, 10);
                    return isNaN(t) ? d : t
                }, f = p(c[0]), m = Math.max(f, p(c[1] || "")), f = s ? Math.max(f, s.getFullYear()) : f, m = n ? Math.min(m, n.getFullYear()) : m, e.yearshtml += "<select class='ui-datepicker-year' data-handler='selectYear' data-event='change'>"; m >= f; f++)e.yearshtml += "<option value='" + f + "'" + (f === i ? " selected='selected'" : "") + ">" + f + "</option>";
                e.yearshtml += "</select>", b += e.yearshtml, e.yearshtml = null
            }
            return b += this._get(e, "yearSuffix"), _ && (b += (!a && g && v ? "" : "&#xa0;") + y), b += "</div>"
        },
        _adjustInstDate: function (e, t, i) {
            var s = e.selectedYear + ("Y" === i ? t : 0), n = e.selectedMonth + ("M" === i ? t : 0), a = Math.min(e.selectedDay, this._getDaysInMonth(s, n)) + ("D" === i ? t : 0), o = this._restrictMinMax(e, this._daylightSavingAdjust(new Date(s, n, a)));
            e.selectedDay = o.getDate(), e.drawMonth = e.selectedMonth = o.getMonth(), e.drawYear = e.selectedYear = o.getFullYear(), ("M" === i || "Y" === i) && this._notifyChange(e)
        },
        _restrictMinMax: function (e, t) {
            var i = this._getMinMaxDate(e, "min"), s = this._getMinMaxDate(e, "max"), n = i && i > t ? i : t;
            return s && n > s ? s : n
        },
        _notifyChange: function (e) {
            var t = this._get(e, "onChangeMonthYear");
            t && t.apply(e.input ? e.input[0] : null, [e.selectedYear, e.selectedMonth + 1, e])
        },
        _getNumberOfMonths: function (e) {
            var t = this._get(e, "numberOfMonths");
            return null == t ? [1, 1] : "number" == typeof t ? [1, t] : t
        },
        _getMinMaxDate: function (e, t) {
            return this._determineDate(e, this._get(e, t + "Date"), null)
        },
        _getDaysInMonth: function (e, t) {
            return 32 - this._daylightSavingAdjust(new Date(e, t, 32)).getDate()
        },
        _getFirstDayOfMonth: function (e, t) {
            return new Date(e, t, 1).getDay()
        },
        _canAdjustMonth: function (e, t, i, s) {
            var n = this._getNumberOfMonths(e), a = this._daylightSavingAdjust(new Date(i, s + (0 > t ? t : n[0] * n[1]), 1));
            return 0 > t && a.setDate(this._getDaysInMonth(a.getFullYear(), a.getMonth())), this._isInRange(e, a)
        },
        _isInRange: function (e, t) {
            var i, s, n = this._getMinMaxDate(e, "min"), a = this._getMinMaxDate(e, "max"), o = null, r = null, h = this._get(e, "yearRange");
            return h && (i = h.split(":"), s = (new Date).getFullYear(), o = parseInt(i[0], 10), r = parseInt(i[1], 10), i[0].match(/[+\-].*/) && (o += s), i[1].match(/[+\-].*/) && (r += s)), (!n || t.getTime() >= n.getTime()) && (!a || t.getTime() <= a.getTime()) && (!o || t.getFullYear() >= o) && (!r || r >= t.getFullYear())
        },
        _getFormatConfig: function (e) {
            var t = this._get(e, "shortYearCutoff");
            return t = "string" != typeof t ? t : (new Date).getFullYear() % 100 + parseInt(t, 10), {
                shortYearCutoff: t,
                dayNamesShort: this._get(e, "dayNamesShort"),
                dayNames: this._get(e, "dayNames"),
                monthNamesShort: this._get(e, "monthNamesShort"),
                monthNames: this._get(e, "monthNames")
            }
        },
        _formatDate: function (e, t, i, s) {
            t || (e.currentDay = e.selectedDay, e.currentMonth = e.selectedMonth, e.currentYear = e.selectedYear);
            var n = t ? "object" == typeof t ? t : this._daylightSavingAdjust(new Date(s, i, t)) : this._daylightSavingAdjust(new Date(e.currentYear, e.currentMonth, e.currentDay));
            return this.formatDate(this._get(e, "dateFormat"), n, this._getFormatConfig(e))
        }
    }), e.fn.datepicker = function (t) {
        if (!this.length)return this;
        e.datepicker.initialized || (e(document).on("mousedown", e.datepicker._checkExternalClick), e.datepicker.initialized = !0), 0 === e("#" + e.datepicker._mainDivId).length && e("body").append(e.datepicker.dpDiv);
        var i = Array.prototype.slice.call(arguments, 1);
        return "string" != typeof t || "isDisabled" !== t && "getDate" !== t && "widget" !== t ? "option" === t && 2 === arguments.length && "string" == typeof arguments[1] ? e.datepicker["_" + t + "Datepicker"].apply(e.datepicker, [this[0]].concat(i)) : this.each(function () {
                    "string" == typeof t ? e.datepicker["_" + t + "Datepicker"].apply(e.datepicker, [this].concat(i)) : e.datepicker._attachDatepicker(this, t)
                }) : e.datepicker["_" + t + "Datepicker"].apply(e.datepicker, [this[0]].concat(i))
    }, e.datepicker = new s, e.datepicker.initialized = !1, e.datepicker.uuid = (new Date).getTime(), e.datepicker.version = "1.12.1", e.datepicker, e.widget("ui.dialog", {
        version: "1.12.1",
        options: {
            appendTo: "body",
            autoOpen: !0,
            buttons: [],
            classes: {"ui-dialog": "ui-corner-all", "ui-dialog-titlebar": "ui-corner-all"},
            closeOnEscape: !0,
            closeText: "Close",
            draggable: !0,
            hide: null,
            height: "auto",
            maxHeight: null,
            maxWidth: null,
            minHeight: 150,
            minWidth: 150,
            modal: !1,
            position: {
                my: "center", at: "center", of: window, collision: "fit", using: function (t) {
                    var i = e(this).css(t).offset().top;
                    0 > i && e(this).css("top", t.top - i)
                }
            },
            resizable: !0,
            show: null,
            title: null,
            width: 300,
            beforeClose: null,
            close: null,
            drag: null,
            dragStart: null,
            dragStop: null,
            focus: null,
            open: null,
            resize: null,
            resizeStart: null,
            resizeStop: null
        },
        sizeRelatedOptions: {
            buttons: !0,
            height: !0,
            maxHeight: !0,
            maxWidth: !0,
            minHeight: !0,
            minWidth: !0,
            width: !0
        },
        resizableRelatedOptions: {maxHeight: !0, maxWidth: !0, minHeight: !0, minWidth: !0},
        _create: function () {
            this.originalCss = {
                display: this.element[0].style.display,
                width: this.element[0].style.width,
                minHeight: this.element[0].style.minHeight,
                maxHeight: this.element[0].style.maxHeight,
                height: this.element[0].style.height
            }, this.originalPosition = {
                parent: this.element.parent(),
                index: this.element.parent().children().index(this.element)
            }, this.originalTitle = this.element.attr("title"), null == this.options.title && null != this.originalTitle && (this.options.title = this.originalTitle), this.options.disabled && (this.options.disabled = !1), this._createWrapper(), this.element.show().removeAttr("title").appendTo(this.uiDialog), this._addClass("ui-dialog-content", "ui-widget-content"), this._createTitlebar(), this._createButtonPane(), this.options.draggable && e.fn.draggable && this._makeDraggable(), this.options.resizable && e.fn.resizable && this._makeResizable(), this._isOpen = !1, this._trackFocus()
        },
        _init: function () {
            this.options.autoOpen && this.open()
        },
        _appendTo: function () {
            var t = this.options.appendTo;
            return t && (t.jquery || t.nodeType) ? e(t) : this.document.find(t || "body").eq(0)
        },
        _destroy: function () {
            var e, t = this.originalPosition;
            this._untrackInstance(), this._destroyOverlay(), this.element.removeUniqueId().css(this.originalCss).detach(), this.uiDialog.remove(), this.originalTitle && this.element.attr("title", this.originalTitle), e = t.parent.children().eq(t.index), e.length && e[0] !== this.element[0] ? e.before(this.element) : t.parent.append(this.element)
        },
        widget: function () {
            return this.uiDialog
        },
        disable: e.noop,
        enable: e.noop,
        close: function (t) {
            var i = this;
            this._isOpen && this._trigger("beforeClose", t) !== !1 && (this._isOpen = !1, this._focusedElement = null, this._destroyOverlay(), this._untrackInstance(), this.opener.filter(":focusable").trigger("focus").length || e.ui.safeBlur(e.ui.safeActiveElement(this.document[0])), this._hide(this.uiDialog, this.options.hide, function () {
                i._trigger("close", t)
            }))
        },
        isOpen: function () {
            return this._isOpen
        },
        moveToTop: function () {
            this._moveToTop()
        },
        _moveToTop: function (t, i) {
            var s = !1, n = this.uiDialog.siblings(".ui-front:visible").map(function () {
                return +e(this).css("z-index")
            }).get(), a = Math.max.apply(null, n);
            return a >= +this.uiDialog.css("z-index") && (this.uiDialog.css("z-index", a + 1), s = !0), s && !i && this._trigger("focus", t), s
        },
        open: function () {
            var t = this;
            return this._isOpen ? (this._moveToTop() && this._focusTabbable(), void 0) : (this._isOpen = !0, this.opener = e(e.ui.safeActiveElement(this.document[0])), this._size(), this._position(), this._createOverlay(), this._moveToTop(null, !0), this.overlay && this.overlay.css("z-index", this.uiDialog.css("z-index") - 1), this._show(this.uiDialog, this.options.show, function () {
                    t._focusTabbable(), t._trigger("focus")
                }), this._makeFocusTarget(), this._trigger("open"), void 0)
        },
        _focusTabbable: function () {
            var e = this._focusedElement;
            e || (e = this.element.find("[autofocus]")), e.length || (e = this.element.find(":tabbable")), e.length || (e = this.uiDialogButtonPane.find(":tabbable")), e.length || (e = this.uiDialogTitlebarClose.filter(":tabbable")), e.length || (e = this.uiDialog), e.eq(0).trigger("focus")
        },
        _keepFocus: function (t) {
            function i() {
                var t = e.ui.safeActiveElement(this.document[0]), i = this.uiDialog[0] === t || e.contains(this.uiDialog[0], t);
                i || this._focusTabbable()
            }

            t.preventDefault(), i.call(this), this._delay(i)
        },
        _createWrapper: function () {
            this.uiDialog = e("<div>").hide().attr({
                tabIndex: -1,
                role: "dialog"
            }).appendTo(this._appendTo()), this._addClass(this.uiDialog, "ui-dialog", "ui-widget ui-widget-content ui-front"), this._on(this.uiDialog, {
                keydown: function (t) {
                    if (this.options.closeOnEscape && !t.isDefaultPrevented() && t.keyCode && t.keyCode === e.ui.keyCode.ESCAPE)return t.preventDefault(), this.close(t), void 0;
                    if (t.keyCode === e.ui.keyCode.TAB && !t.isDefaultPrevented()) {
                        var i = this.uiDialog.find(":tabbable"), s = i.filter(":first"), n = i.filter(":last");
                        t.target !== n[0] && t.target !== this.uiDialog[0] || t.shiftKey ? t.target !== s[0] && t.target !== this.uiDialog[0] || !t.shiftKey || (this._delay(function () {
                                n.trigger("focus")
                            }), t.preventDefault()) : (this._delay(function () {
                                s.trigger("focus")
                            }), t.preventDefault())
                    }
                }, mousedown: function (e) {
                    this._moveToTop(e) && this._focusTabbable()
                }
            }), this.element.find("[aria-describedby]").length || this.uiDialog.attr({"aria-describedby": this.element.uniqueId().attr("id")})
        },
        _createTitlebar: function () {
            var t;
            this.uiDialogTitlebar = e("<div>"), this._addClass(this.uiDialogTitlebar, "ui-dialog-titlebar", "ui-widget-header ui-helper-clearfix"), this._on(this.uiDialogTitlebar, {
                mousedown: function (t) {
                    e(t.target).closest(".ui-dialog-titlebar-close") || this.uiDialog.trigger("focus")
                }
            }), this.uiDialogTitlebarClose = e("<button type='button'></button>").button({
                label: e("<a>").text(this.options.closeText).html(),
                icon: "ui-icon-closethick",
                showLabel: !1
            }).appendTo(this.uiDialogTitlebar), this._addClass(this.uiDialogTitlebarClose, "ui-dialog-titlebar-close"), this._on(this.uiDialogTitlebarClose, {
                click: function (e) {
                    e.preventDefault(), this.close(e)
                }
            }), t = e("<span>").uniqueId().prependTo(this.uiDialogTitlebar), this._addClass(t, "ui-dialog-title"), this._title(t), this.uiDialogTitlebar.prependTo(this.uiDialog), this.uiDialog.attr({"aria-labelledby": t.attr("id")})
        },
        _title: function (e) {
            this.options.title ? e.text(this.options.title) : e.html("&#160;")
        },
        _createButtonPane: function () {
            this.uiDialogButtonPane = e("<div>"), this._addClass(this.uiDialogButtonPane, "ui-dialog-buttonpane", "ui-widget-content ui-helper-clearfix"), this.uiButtonSet = e("<div>").appendTo(this.uiDialogButtonPane), this._addClass(this.uiButtonSet, "ui-dialog-buttonset"), this._createButtons()
        },
        _createButtons: function () {
            var t = this, i = this.options.buttons;
            return this.uiDialogButtonPane.remove(), this.uiButtonSet.empty(), e.isEmptyObject(i) || e.isArray(i) && !i.length ? (this._removeClass(this.uiDialog, "ui-dialog-buttons"), void 0) : (e.each(i, function (i, s) {
                    var n, a;
                    s = e.isFunction(s) ? {
                            click: s,
                            text: i
                        } : s, s = e.extend({type: "button"}, s), n = s.click, a = {
                        icon: s.icon,
                        iconPosition: s.iconPosition,
                        showLabel: s.showLabel,
                        icons: s.icons,
                        text: s.text
                    }, delete s.click, delete s.icon, delete s.iconPosition, delete s.showLabel, delete s.icons, "boolean" == typeof s.text && delete s.text, e("<button></button>", s).button(a).appendTo(t.uiButtonSet).on("click", function () {
                        n.apply(t.element[0], arguments)
                    })
                }), this._addClass(this.uiDialog, "ui-dialog-buttons"), this.uiDialogButtonPane.appendTo(this.uiDialog), void 0)
        },
        _makeDraggable: function () {
            function t(e) {
                return {position: e.position, offset: e.offset}
            }

            var i = this, s = this.options;
            this.uiDialog.draggable({
                cancel: ".ui-dialog-content, .ui-dialog-titlebar-close",
                handle: ".ui-dialog-titlebar",
                containment: "document",
                start: function (s, n) {
                    i._addClass(e(this), "ui-dialog-dragging"), i._blockFrames(), i._trigger("dragStart", s, t(n))
                },
                drag: function (e, s) {
                    i._trigger("drag", e, t(s))
                },
                stop: function (n, a) {
                    var o = a.offset.left - i.document.scrollLeft(), r = a.offset.top - i.document.scrollTop();
                    s.position = {
                        my: "left top",
                        at: "left" + (o >= 0 ? "+" : "") + o + " " + "top" + (r >= 0 ? "+" : "") + r,
                        of: i.window
                    }, i._removeClass(e(this), "ui-dialog-dragging"), i._unblockFrames(), i._trigger("dragStop", n, t(a))
                }
            })
        },
        _makeResizable: function () {
            function t(e) {
                return {
                    originalPosition: e.originalPosition,
                    originalSize: e.originalSize,
                    position: e.position,
                    size: e.size
                }
            }

            var i = this, s = this.options, n = s.resizable, a = this.uiDialog.css("position"), o = "string" == typeof n ? n : "n,e,s,w,se,sw,ne,nw";
            this.uiDialog.resizable({
                cancel: ".ui-dialog-content",
                containment: "document",
                alsoResize: this.element,
                maxWidth: s.maxWidth,
                maxHeight: s.maxHeight,
                minWidth: s.minWidth,
                minHeight: this._minHeight(),
                handles: o,
                start: function (s, n) {
                    i._addClass(e(this), "ui-dialog-resizing"), i._blockFrames(), i._trigger("resizeStart", s, t(n))
                },
                resize: function (e, s) {
                    i._trigger("resize", e, t(s))
                },
                stop: function (n, a) {
                    var o = i.uiDialog.offset(), r = o.left - i.document.scrollLeft(), h = o.top - i.document.scrollTop();
                    s.height = i.uiDialog.height(), s.width = i.uiDialog.width(), s.position = {
                        my: "left top",
                        at: "left" + (r >= 0 ? "+" : "") + r + " " + "top" + (h >= 0 ? "+" : "") + h,
                        of: i.window
                    }, i._removeClass(e(this), "ui-dialog-resizing"), i._unblockFrames(), i._trigger("resizeStop", n, t(a))
                }
            }).css("position", a)
        },
        _trackFocus: function () {
            this._on(this.widget(), {
                focusin: function (t) {
                    this._makeFocusTarget(), this._focusedElement = e(t.target)
                }
            })
        },
        _makeFocusTarget: function () {
            this._untrackInstance(), this._trackingInstances().unshift(this)
        },
        _untrackInstance: function () {
            var t = this._trackingInstances(), i = e.inArray(this, t);
            -1 !== i && t.splice(i, 1)
        },
        _trackingInstances: function () {
            var e = this.document.data("ui-dialog-instances");
            return e || (e = [], this.document.data("ui-dialog-instances", e)), e
        },
        _minHeight: function () {
            var e = this.options;
            return "auto" === e.height ? e.minHeight : Math.min(e.minHeight, e.height)
        },
        _position: function () {
            var e = this.uiDialog.is(":visible");
            e || this.uiDialog.show(), this.uiDialog.position(this.options.position), e || this.uiDialog.hide()
        },
        _setOptions: function (t) {
            var i = this, s = !1, n = {};
            e.each(t, function (e, t) {
                i._setOption(e, t), e in i.sizeRelatedOptions && (s = !0), e in i.resizableRelatedOptions && (n[e] = t)
            }), s && (this._size(), this._position()), this.uiDialog.is(":data(ui-resizable)") && this.uiDialog.resizable("option", n)
        },
        _setOption: function (t, i) {
            var s, n, a = this.uiDialog;
            "disabled" !== t && (this._super(t, i), "appendTo" === t && this.uiDialog.appendTo(this._appendTo()), "buttons" === t && this._createButtons(), "closeText" === t && this.uiDialogTitlebarClose.button({label: e("<a>").text("" + this.options.closeText).html()}), "draggable" === t && (s = a.is(":data(ui-draggable)"), s && !i && a.draggable("destroy"), !s && i && this._makeDraggable()), "position" === t && this._position(), "resizable" === t && (n = a.is(":data(ui-resizable)"), n && !i && a.resizable("destroy"), n && "string" == typeof i && a.resizable("option", "handles", i), n || i === !1 || this._makeResizable()), "title" === t && this._title(this.uiDialogTitlebar.find(".ui-dialog-title")))
        },
        _size: function () {
            var e, t, i, s = this.options;
            this.element.show().css({
                width: "auto",
                minHeight: 0,
                maxHeight: "none",
                height: 0
            }), s.minWidth > s.width && (s.width = s.minWidth), e = this.uiDialog.css({
                height: "auto",
                width: s.width
            }).outerHeight(), t = Math.max(0, s.minHeight - e), i = "number" == typeof s.maxHeight ? Math.max(0, s.maxHeight - e) : "none", "auto" === s.height ? this.element.css({
                    minHeight: t,
                    maxHeight: i,
                    height: "auto"
                }) : this.element.height(Math.max(0, s.height - e)), this.uiDialog.is(":data(ui-resizable)") && this.uiDialog.resizable("option", "minHeight", this._minHeight())
        },
        _blockFrames: function () {
            this.iframeBlocks = this.document.find("iframe").map(function () {
                var t = e(this);
                return e("<div>").css({
                    position: "absolute",
                    width: t.outerWidth(),
                    height: t.outerHeight()
                }).appendTo(t.parent()).offset(t.offset())[0]
            })
        },
        _unblockFrames: function () {
            this.iframeBlocks && (this.iframeBlocks.remove(), delete this.iframeBlocks)
        },
        _allowInteraction: function (t) {
            return e(t.target).closest(".ui-dialog").length ? !0 : !!e(t.target).closest(".ui-datepicker").length
        },
        _createOverlay: function () {
            if (this.options.modal) {
                var t = !0;
                this._delay(function () {
                    t = !1
                }), this.document.data("ui-dialog-overlays") || this._on(this.document, {
                    focusin: function (e) {
                        t || this._allowInteraction(e) || (e.preventDefault(), this._trackingInstances()[0]._focusTabbable())
                    }
                }), this.overlay = e("<div>").appendTo(this._appendTo()), this._addClass(this.overlay, null, "ui-widget-overlay ui-front"), this._on(this.overlay, {mousedown: "_keepFocus"}), this.document.data("ui-dialog-overlays", (this.document.data("ui-dialog-overlays") || 0) + 1)
            }
        },
        _destroyOverlay: function () {
            if (this.options.modal && this.overlay) {
                var e = this.document.data("ui-dialog-overlays") - 1;
                e ? this.document.data("ui-dialog-overlays", e) : (this._off(this.document, "focusin"), this.document.removeData("ui-dialog-overlays")), this.overlay.remove(), this.overlay = null
            }
        }
    }), e.uiBackCompat !== !1 && e.widget("ui.dialog", e.ui.dialog, {
        options: {dialogClass: ""},
        _createWrapper: function () {
            this._super(), this.uiDialog.addClass(this.options.dialogClass)
        },
        _setOption: function (e, t) {
            "dialogClass" === e && this.uiDialog.removeClass(this.options.dialogClass).addClass(t), this._superApply(arguments)
        }
    }), e.ui.dialog, e.widget("ui.progressbar", {
        version: "1.12.1",
        options: {
            classes: {
                "ui-progressbar": "ui-corner-all",
                "ui-progressbar-value": "ui-corner-left",
                "ui-progressbar-complete": "ui-corner-right"
            }, max: 100, value: 0, change: null, complete: null
        },
        min: 0,
        _create: function () {
            this.oldValue = this.options.value = this._constrainedValue(), this.element.attr({
                role: "progressbar",
                "aria-valuemin": this.min
            }), this._addClass("ui-progressbar", "ui-widget ui-widget-content"), this.valueDiv = e("<div>").appendTo(this.element), this._addClass(this.valueDiv, "ui-progressbar-value", "ui-widget-header"), this._refreshValue()
        },
        _destroy: function () {
            this.element.removeAttr("role aria-valuemin aria-valuemax aria-valuenow"), this.valueDiv.remove()
        },
        value: function (e) {
            return void 0 === e ? this.options.value : (this.options.value = this._constrainedValue(e), this._refreshValue(), void 0)
        },
        _constrainedValue: function (e) {
            return void 0 === e && (e = this.options.value), this.indeterminate = e === !1, "number" != typeof e && (e = 0), this.indeterminate ? !1 : Math.min(this.options.max, Math.max(this.min, e))
        },
        _setOptions: function (e) {
            var t = e.value;
            delete e.value, this._super(e), this.options.value = this._constrainedValue(t), this._refreshValue()
        },
        _setOption: function (e, t) {
            "max" === e && (t = Math.max(this.min, t)), this._super(e, t)
        },
        _setOptionDisabled: function (e) {
            this._super(e), this.element.attr("aria-disabled", e), this._toggleClass(null, "ui-state-disabled", !!e)
        },
        _percentage: function () {
            return this.indeterminate ? 100 : 100 * (this.options.value - this.min) / (this.options.max - this.min)
        },
        _refreshValue: function () {
            var t = this.options.value, i = this._percentage();
            this.valueDiv.toggle(this.indeterminate || t > this.min).width(i.toFixed(0) + "%"), this._toggleClass(this.valueDiv, "ui-progressbar-complete", null, t === this.options.max)._toggleClass("ui-progressbar-indeterminate", null, this.indeterminate), this.indeterminate ? (this.element.removeAttr("aria-valuenow"), this.overlayDiv || (this.overlayDiv = e("<div>").appendTo(this.valueDiv), this._addClass(this.overlayDiv, "ui-progressbar-overlay"))) : (this.element.attr({
                    "aria-valuemax": this.options.max,
                    "aria-valuenow": t
                }), this.overlayDiv && (this.overlayDiv.remove(), this.overlayDiv = null)), this.oldValue !== t && (this.oldValue = t, this._trigger("change")), t === this.options.max && this._trigger("complete")
        }
    }), e.widget("ui.selectmenu", [e.ui.formResetMixin, {
        version: "1.12.1",
        defaultElement: "<select>",
        options: {
            appendTo: null,
            classes: {"ui-selectmenu-button-open": "ui-corner-top", "ui-selectmenu-button-closed": "ui-corner-all"},
            disabled: null,
            icons: {button: "ui-icon-triangle-1-s"},
            position: {my: "left top", at: "left bottom", collision: "none"},
            width: !1,
            change: null,
            close: null,
            focus: null,
            open: null,
            select: null
        },
        _create: function () {
            var t = this.element.uniqueId().attr("id");
            this.ids = {
                element: t,
                button: t + "-button",
                menu: t + "-menu"
            }, this._drawButton(), this._drawMenu(), this._bindFormResetHandler(), this._rendered = !1, this.menuItems = e()
        },
        _drawButton: function () {
            var t, i = this, s = this._parseOption(this.element.find("option:selected"), this.element[0].selectedIndex);
            this.labels = this.element.labels().attr("for", this.ids.button), this._on(this.labels, {
                click: function (e) {
                    this.button.focus(), e.preventDefault()
                }
            }), this.element.hide(), this.button = e("<span>", {
                tabindex: this.options.disabled ? -1 : 0,
                id: this.ids.button,
                role: "combobox",
                "aria-expanded": "false",
                "aria-autocomplete": "list",
                "aria-owns": this.ids.menu,
                "aria-haspopup": "true",
                title: this.element.attr("title")
            }).insertAfter(this.element), this._addClass(this.button, "ui-selectmenu-button ui-selectmenu-button-closed", "ui-button ui-widget"), t = e("<span>").appendTo(this.button), this._addClass(t, "ui-selectmenu-icon", "ui-icon " + this.options.icons.button), this.buttonItem = this._renderButtonItem(s).appendTo(this.button), this.options.width !== !1 && this._resizeButton(), this._on(this.button, this._buttonEvents), this.button.one("focusin", function () {
                i._rendered || i._refreshMenu()
            })
        },
        _drawMenu: function () {
            var t = this;
            this.menu = e("<ul>", {
                "aria-hidden": "true",
                "aria-labelledby": this.ids.button,
                id: this.ids.menu
            }), this.menuWrap = e("<div>").append(this.menu), this._addClass(this.menuWrap, "ui-selectmenu-menu", "ui-front"), this.menuWrap.appendTo(this._appendTo()), this.menuInstance = this.menu.menu({
                classes: {"ui-menu": "ui-corner-bottom"},
                role: "listbox",
                select: function (e, i) {
                    e.preventDefault(), t._setSelection(), t._select(i.item.data("ui-selectmenu-item"), e)
                },
                focus: function (e, i) {
                    var s = i.item.data("ui-selectmenu-item");
                    null != t.focusIndex && s.index !== t.focusIndex && (t._trigger("focus", e, {item: s}), t.isOpen || t._select(s, e)), t.focusIndex = s.index, t.button.attr("aria-activedescendant", t.menuItems.eq(s.index).attr("id"))
                }
            }).menu("instance"), this.menuInstance._off(this.menu, "mouseleave"), this.menuInstance._closeOnDocumentClick = function () {
                return !1
            }, this.menuInstance._isDivider = function () {
                return !1
            }
        },
        refresh: function () {
            this._refreshMenu(), this.buttonItem.replaceWith(this.buttonItem = this._renderButtonItem(this._getSelectedItem().data("ui-selectmenu-item") || {})), null === this.options.width && this._resizeButton()
        },
        _refreshMenu: function () {
            var e, t = this.element.find("option");
            this.menu.empty(), this._parseOptions(t), this._renderMenu(this.menu, this.items), this.menuInstance.refresh(), this.menuItems = this.menu.find("li").not(".ui-selectmenu-optgroup").find(".ui-menu-item-wrapper"), this._rendered = !0, t.length && (e = this._getSelectedItem(), this.menuInstance.focus(null, e), this._setAria(e.data("ui-selectmenu-item")), this._setOption("disabled", this.element.prop("disabled")))
        },
        open: function (e) {
            this.options.disabled || (this._rendered ? (this._removeClass(this.menu.find(".ui-state-active"), null, "ui-state-active"), this.menuInstance.focus(null, this._getSelectedItem())) : this._refreshMenu(), this.menuItems.length && (this.isOpen = !0, this._toggleAttr(), this._resizeMenu(), this._position(), this._on(this.document, this._documentClick), this._trigger("open", e)))
        },
        _position: function () {
            this.menuWrap.position(e.extend({of: this.button}, this.options.position))
        },
        close: function (e) {
            this.isOpen && (this.isOpen = !1, this._toggleAttr(), this.range = null, this._off(this.document), this._trigger("close", e))
        },
        widget: function () {
            return this.button
        },
        menuWidget: function () {
            return this.menu
        },
        _renderButtonItem: function (t) {
            var i = e("<span>");
            return this._setText(i, t.label), this._addClass(i, "ui-selectmenu-text"), i
        },
        _renderMenu: function (t, i) {
            var s = this, n = "";
            e.each(i, function (i, a) {
                var o;
                a.optgroup !== n && (o = e("<li>", {text: a.optgroup}), s._addClass(o, "ui-selectmenu-optgroup", "ui-menu-divider" + (a.element.parent("optgroup").prop("disabled") ? " ui-state-disabled" : "")), o.appendTo(t), n = a.optgroup), s._renderItemData(t, a)
            })
        },
        _renderItemData: function (e, t) {
            return this._renderItem(e, t).data("ui-selectmenu-item", t)
        },
        _renderItem: function (t, i) {
            var s = e("<li>"), n = e("<div>", {title: i.element.attr("title")});
            return i.disabled && this._addClass(s, null, "ui-state-disabled"), this._setText(n, i.label), s.append(n).appendTo(t)
        },
        _setText: function (e, t) {
            t ? e.text(t) : e.html("&#160;")
        },
        _move: function (e, t) {
            var i, s, n = ".ui-menu-item";
            this.isOpen ? i = this.menuItems.eq(this.focusIndex).parent("li") : (i = this.menuItems.eq(this.element[0].selectedIndex).parent("li"), n += ":not(.ui-state-disabled)"), s = "first" === e || "last" === e ? i["first" === e ? "prevAll" : "nextAll"](n).eq(-1) : i[e + "All"](n).eq(0), s.length && this.menuInstance.focus(t, s)
        },
        _getSelectedItem: function () {
            return this.menuItems.eq(this.element[0].selectedIndex).parent("li")
        },
        _toggle: function (e) {
            this[this.isOpen ? "close" : "open"](e)
        },
        _setSelection: function () {
            var e;
            this.range && (window.getSelection ? (e = window.getSelection(), e.removeAllRanges(), e.addRange(this.range)) : this.range.select(), this.button.focus())
        },
        _documentClick: {
            mousedown: function (t) {
                this.isOpen && (e(t.target).closest(".ui-selectmenu-menu, #" + e.ui.escapeSelector(this.ids.button)).length || this.close(t))
            }
        },
        _buttonEvents: {
            mousedown: function () {
                var e;
                window.getSelection ? (e = window.getSelection(), e.rangeCount && (this.range = e.getRangeAt(0))) : this.range = document.selection.createRange()
            }, click: function (e) {
                this._setSelection(), this._toggle(e)
            }, keydown: function (t) {
                var i = !0;
                switch (t.keyCode) {
                    case e.ui.keyCode.TAB:
                    case e.ui.keyCode.ESCAPE:
                        this.close(t), i = !1;
                        break;
                    case e.ui.keyCode.ENTER:
                        this.isOpen && this._selectFocusedItem(t);
                        break;
                    case e.ui.keyCode.UP:
                        t.altKey ? this._toggle(t) : this._move("prev", t);
                        break;
                    case e.ui.keyCode.DOWN:
                        t.altKey ? this._toggle(t) : this._move("next", t);
                        break;
                    case e.ui.keyCode.SPACE:
                        this.isOpen ? this._selectFocusedItem(t) : this._toggle(t);
                        break;
                    case e.ui.keyCode.LEFT:
                        this._move("prev", t);
                        break;
                    case e.ui.keyCode.RIGHT:
                        this._move("next", t);
                        break;
                    case e.ui.keyCode.HOME:
                    case e.ui.keyCode.PAGE_UP:
                        this._move("first", t);
                        break;
                    case e.ui.keyCode.END:
                    case e.ui.keyCode.PAGE_DOWN:
                        this._move("last", t);
                        break;
                    default:
                        this.menu.trigger(t), i = !1
                }
                i && t.preventDefault()
            }
        },
        _selectFocusedItem: function (e) {
            var t = this.menuItems.eq(this.focusIndex).parent("li");
            t.hasClass("ui-state-disabled") || this._select(t.data("ui-selectmenu-item"), e)
        },
        _select: function (e, t) {
            var i = this.element[0].selectedIndex;
            this.element[0].selectedIndex = e.index, this.buttonItem.replaceWith(this.buttonItem = this._renderButtonItem(e)), this._setAria(e), this._trigger("select", t, {item: e}), e.index !== i && this._trigger("change", t, {item: e}), this.close(t)
        },
        _setAria: function (e) {
            var t = this.menuItems.eq(e.index).attr("id");
            this.button.attr({
                "aria-labelledby": t,
                "aria-activedescendant": t
            }), this.menu.attr("aria-activedescendant", t)
        },
        _setOption: function (e, t) {
            if ("icons" === e) {
                var i = this.button.find("span.ui-icon");
                this._removeClass(i, null, this.options.icons.button)._addClass(i, null, t.button)
            }
            this._super(e, t), "appendTo" === e && this.menuWrap.appendTo(this._appendTo()), "width" === e && this._resizeButton()
        },
        _setOptionDisabled: function (e) {
            this._super(e), this.menuInstance.option("disabled", e), this.button.attr("aria-disabled", e), this._toggleClass(this.button, null, "ui-state-disabled", e), this.element.prop("disabled", e), e ? (this.button.attr("tabindex", -1), this.close()) : this.button.attr("tabindex", 0)
        },
        _appendTo: function () {
            var t = this.options.appendTo;
            return t && (t = t.jquery || t.nodeType ? e(t) : this.document.find(t).eq(0)), t && t[0] || (t = this.element.closest(".ui-front, dialog")), t.length || (t = this.document[0].body), t
        },
        _toggleAttr: function () {
            this.button.attr("aria-expanded", this.isOpen), this._removeClass(this.button, "ui-selectmenu-button-" + (this.isOpen ? "closed" : "open"))._addClass(this.button, "ui-selectmenu-button-" + (this.isOpen ? "open" : "closed"))._toggleClass(this.menuWrap, "ui-selectmenu-open", null, this.isOpen), this.menu.attr("aria-hidden", !this.isOpen)
        },
        _resizeButton: function () {
            var e = this.options.width;
            return e === !1 ? (this.button.css("width", ""), void 0) : (null === e && (e = this.element.show().outerWidth(), this.element.hide()), this.button.outerWidth(e), void 0)
        },
        _resizeMenu: function () {
            this.menu.outerWidth(Math.max(this.button.outerWidth(), this.menu.width("").outerWidth() + 1))
        },
        _getCreateOptions: function () {
            var e = this._super();
            return e.disabled = this.element.prop("disabled"), e
        },
        _parseOptions: function (t) {
            var i = this, s = [];
            t.each(function (t, n) {
                s.push(i._parseOption(e(n), t))
            }), this.items = s
        },
        _parseOption: function (e, t) {
            var i = e.parent("optgroup");
            return {
                element: e,
                index: t,
                value: e.val(),
                label: e.text(),
                optgroup: i.attr("label") || "",
                disabled: i.prop("disabled") || e.prop("disabled")
            }
        },
        _destroy: function () {
            this._unbindFormResetHandler(), this.menuWrap.remove(), this.button.remove(), this.element.show(), this.element.removeUniqueId(), this.labels.attr("for", this.ids.element)
        }
    }]), e.widget("ui.slider", e.ui.mouse, {
        version: "1.12.1",
        widgetEventPrefix: "slide",
        options: {
            animate: !1,
            classes: {
                "ui-slider": "ui-corner-all",
                "ui-slider-handle": "ui-corner-all",
                "ui-slider-range": "ui-corner-all ui-widget-header"
            },
            distance: 0,
            max: 100,
            min: 0,
            orientation: "horizontal",
            range: !1,
            step: 1,
            value: 0,
            values: null,
            change: null,
            slide: null,
            start: null,
            stop: null
        },
        numPages: 5,
        _create: function () {
            this._keySliding = !1, this._mouseSliding = !1, this._animateOff = !0, this._handleIndex = null, this._detectOrientation(), this._mouseInit(), this._calculateNewMax(), this._addClass("ui-slider ui-slider-" + this.orientation, "ui-widget ui-widget-content"), this._refresh(), this._animateOff = !1
        },
        _refresh: function () {
            this._createRange(), this._createHandles(), this._setupEvents(), this._refreshValue()
        },
        _createHandles: function () {
            var t, i, s = this.options, n = this.element.find(".ui-slider-handle"), a = "<span tabindex='0'></span>", o = [];
            for (i = s.values && s.values.length || 1, n.length > i && (n.slice(i).remove(), n = n.slice(0, i)), t = n.length; i > t; t++)o.push(a);
            this.handles = n.add(e(o.join("")).appendTo(this.element)), this._addClass(this.handles, "ui-slider-handle", "ui-state-default"), this.handle = this.handles.eq(0), this.handles.each(function (t) {
                e(this).data("ui-slider-handle-index", t).attr("tabIndex", 0)
            })
        },
        _createRange: function () {
            var t = this.options;
            t.range ? (t.range === !0 && (t.values ? t.values.length && 2 !== t.values.length ? t.values = [t.values[0], t.values[0]] : e.isArray(t.values) && (t.values = t.values.slice(0)) : t.values = [this._valueMin(), this._valueMin()]), this.range && this.range.length ? (this._removeClass(this.range, "ui-slider-range-min ui-slider-range-max"), this.range.css({
                        left: "",
                        bottom: ""
                    })) : (this.range = e("<div>").appendTo(this.element), this._addClass(this.range, "ui-slider-range")), ("min" === t.range || "max" === t.range) && this._addClass(this.range, "ui-slider-range-" + t.range)) : (this.range && this.range.remove(), this.range = null)
        },
        _setupEvents: function () {
            this._off(this.handles), this._on(this.handles, this._handleEvents), this._hoverable(this.handles), this._focusable(this.handles)
        },
        _destroy: function () {
            this.handles.remove(), this.range && this.range.remove(), this._mouseDestroy()
        },
        _mouseCapture: function (t) {
            var i, s, n, a, o, r, h, l, u = this, c = this.options;
            return c.disabled ? !1 : (this.elementSize = {
                    width: this.element.outerWidth(),
                    height: this.element.outerHeight()
                }, this.elementOffset = this.element.offset(), i = {
                    x: t.pageX,
                    y: t.pageY
                }, s = this._normValueFromMouse(i), n = this._valueMax() - this._valueMin() + 1, this.handles.each(function (t) {
                    var i = Math.abs(s - u.values(t));
                    (n > i || n === i && (t === u._lastChangedValue || u.values(t) === c.min)) && (n = i, a = e(this), o = t)
                }), r = this._start(t, o), r === !1 ? !1 : (this._mouseSliding = !0, this._handleIndex = o, this._addClass(a, null, "ui-state-active"), a.trigger("focus"), h = a.offset(), l = !e(t.target).parents().addBack().is(".ui-slider-handle"), this._clickOffset = l ? {
                            left: 0,
                            top: 0
                        } : {
                            left: t.pageX - h.left - a.width() / 2,
                            top: t.pageY - h.top - a.height() / 2 - (parseInt(a.css("borderTopWidth"), 10) || 0) - (parseInt(a.css("borderBottomWidth"), 10) || 0) + (parseInt(a.css("marginTop"), 10) || 0)
                        }, this.handles.hasClass("ui-state-hover") || this._slide(t, o, s), this._animateOff = !0, !0))
        },
        _mouseStart: function () {
            return !0
        },
        _mouseDrag: function (e) {
            var t = {x: e.pageX, y: e.pageY}, i = this._normValueFromMouse(t);
            return this._slide(e, this._handleIndex, i), !1
        },
        _mouseStop: function (e) {
            return this._removeClass(this.handles, null, "ui-state-active"), this._mouseSliding = !1, this._stop(e, this._handleIndex), this._change(e, this._handleIndex), this._handleIndex = null, this._clickOffset = null, this._animateOff = !1, !1
        },
        _detectOrientation: function () {
            this.orientation = "vertical" === this.options.orientation ? "vertical" : "horizontal"
        },
        _normValueFromMouse: function (e) {
            var t, i, s, n, a;
            return "horizontal" === this.orientation ? (t = this.elementSize.width, i = e.x - this.elementOffset.left - (this._clickOffset ? this._clickOffset.left : 0)) : (t = this.elementSize.height, i = e.y - this.elementOffset.top - (this._clickOffset ? this._clickOffset.top : 0)), s = i / t, s > 1 && (s = 1), 0 > s && (s = 0), "vertical" === this.orientation && (s = 1 - s), n = this._valueMax() - this._valueMin(), a = this._valueMin() + s * n, this._trimAlignValue(a)
        },
        _uiHash: function (e, t, i) {
            var s = {handle: this.handles[e], handleIndex: e, value: void 0 !== t ? t : this.value()};
            return this._hasMultipleValues() && (s.value = void 0 !== t ? t : this.values(e), s.values = i || this.values()), s
        },
        _hasMultipleValues: function () {
            return this.options.values && this.options.values.length
        },
        _start: function (e, t) {
            return this._trigger("start", e, this._uiHash(t))
        },
        _slide: function (e, t, i) {
            var s, n, a = this.value(), o = this.values();
            this._hasMultipleValues() && (n = this.values(t ? 0 : 1), a = this.values(t), 2 === this.options.values.length && this.options.range === !0 && (i = 0 === t ? Math.min(n, i) : Math.max(n, i)), o[t] = i), i !== a && (s = this._trigger("slide", e, this._uiHash(t, i, o)), s !== !1 && (this._hasMultipleValues() ? this.values(t, i) : this.value(i)))
        },
        _stop: function (e, t) {
            this._trigger("stop", e, this._uiHash(t))
        },
        _change: function (e, t) {
            this._keySliding || this._mouseSliding || (this._lastChangedValue = t, this._trigger("change", e, this._uiHash(t)))
        },
        value: function (e) {
            return arguments.length ? (this.options.value = this._trimAlignValue(e), this._refreshValue(), this._change(null, 0), void 0) : this._value()
        },
        values: function (t, i) {
            var s, n, a;
            if (arguments.length > 1)return this.options.values[t] = this._trimAlignValue(i), this._refreshValue(), this._change(null, t), void 0;
            if (!arguments.length)return this._values();
            if (!e.isArray(arguments[0]))return this._hasMultipleValues() ? this._values(t) : this.value();
            for (s = this.options.values, n = arguments[0], a = 0; s.length > a; a += 1)s[a] = this._trimAlignValue(n[a]), this._change(null, a);
            this._refreshValue()
        },
        _setOption: function (t, i) {
            var s, n = 0;
            switch ("range" === t && this.options.range === !0 && ("min" === i ? (this.options.value = this._values(0), this.options.values = null) : "max" === i && (this.options.value = this._values(this.options.values.length - 1), this.options.values = null)), e.isArray(this.options.values) && (n = this.options.values.length), this._super(t, i), t) {
                case"orientation":
                    this._detectOrientation(), this._removeClass("ui-slider-horizontal ui-slider-vertical")._addClass("ui-slider-" + this.orientation), this._refreshValue(), this.options.range && this._refreshRange(i), this.handles.css("horizontal" === i ? "bottom" : "left", "");
                    break;
                case"value":
                    this._animateOff = !0, this._refreshValue(), this._change(null, 0), this._animateOff = !1;
                    break;
                case"values":
                    for (this._animateOff = !0, this._refreshValue(), s = n - 1; s >= 0; s--)this._change(null, s);
                    this._animateOff = !1;
                    break;
                case"step":
                case"min":
                case"max":
                    this._animateOff = !0, this._calculateNewMax(), this._refreshValue(), this._animateOff = !1;
                    break;
                case"range":
                    this._animateOff = !0, this._refresh(), this._animateOff = !1
            }
        },
        _setOptionDisabled: function (e) {
            this._super(e), this._toggleClass(null, "ui-state-disabled", !!e)
        },
        _value: function () {
            var e = this.options.value;
            return e = this._trimAlignValue(e)
        },
        _values: function (e) {
            var t, i, s;
            if (arguments.length)return t = this.options.values[e], t = this._trimAlignValue(t);
            if (this._hasMultipleValues()) {
                for (i = this.options.values.slice(), s = 0; i.length > s; s += 1)i[s] = this._trimAlignValue(i[s]);
                return i
            }
            return []
        },
        _trimAlignValue: function (e) {
            if (this._valueMin() >= e)return this._valueMin();
            if (e >= this._valueMax())return this._valueMax();
            var t = this.options.step > 0 ? this.options.step : 1, i = (e - this._valueMin()) % t, s = e - i;
            return 2 * Math.abs(i) >= t && (s += i > 0 ? t : -t), parseFloat(s.toFixed(5))
        },
        _calculateNewMax: function () {
            var e = this.options.max, t = this._valueMin(), i = this.options.step, s = Math.round((e - t) / i) * i;
            e = s + t, e > this.options.max && (e -= i), this.max = parseFloat(e.toFixed(this._precision()))
        },
        _precision: function () {
            var e = this._precisionOf(this.options.step);
            return null !== this.options.min && (e = Math.max(e, this._precisionOf(this.options.min))), e
        },
        _precisionOf: function (e) {
            var t = "" + e, i = t.indexOf(".");
            return -1 === i ? 0 : t.length - i - 1
        },
        _valueMin: function () {
            return this.options.min
        },
        _valueMax: function () {
            return this.max
        },
        _refreshRange: function (e) {
            "vertical" === e && this.range.css({width: "", left: ""}), "horizontal" === e && this.range.css({
                height: "",
                bottom: ""
            })
        },
        _refreshValue: function () {
            var t, i, s, n, a, o = this.options.range, r = this.options, h = this, l = this._animateOff ? !1 : r.animate, u = {};
            this._hasMultipleValues() ? this.handles.each(function (s) {
                    i = 100 * ((h.values(s) - h._valueMin()) / (h._valueMax() - h._valueMin())), u["horizontal" === h.orientation ? "left" : "bottom"] = i + "%", e(this).stop(1, 1)[l ? "animate" : "css"](u, r.animate), h.options.range === !0 && ("horizontal" === h.orientation ? (0 === s && h.range.stop(1, 1)[l ? "animate" : "css"]({left: i + "%"}, r.animate), 1 === s && h.range[l ? "animate" : "css"]({width: i - t + "%"}, {
                            queue: !1,
                            duration: r.animate
                        })) : (0 === s && h.range.stop(1, 1)[l ? "animate" : "css"]({bottom: i + "%"}, r.animate), 1 === s && h.range[l ? "animate" : "css"]({height: i - t + "%"}, {
                            queue: !1,
                            duration: r.animate
                        }))), t = i
                }) : (s = this.value(), n = this._valueMin(), a = this._valueMax(), i = a !== n ? 100 * ((s - n) / (a - n)) : 0, u["horizontal" === this.orientation ? "left" : "bottom"] = i + "%", this.handle.stop(1, 1)[l ? "animate" : "css"](u, r.animate), "min" === o && "horizontal" === this.orientation && this.range.stop(1, 1)[l ? "animate" : "css"]({width: i + "%"}, r.animate), "max" === o && "horizontal" === this.orientation && this.range.stop(1, 1)[l ? "animate" : "css"]({width: 100 - i + "%"}, r.animate), "min" === o && "vertical" === this.orientation && this.range.stop(1, 1)[l ? "animate" : "css"]({height: i + "%"}, r.animate), "max" === o && "vertical" === this.orientation && this.range.stop(1, 1)[l ? "animate" : "css"]({height: 100 - i + "%"}, r.animate))
        },
        _handleEvents: {
            keydown: function (t) {
                var i, s, n, a, o = e(t.target).data("ui-slider-handle-index");
                switch (t.keyCode) {
                    case e.ui.keyCode.HOME:
                    case e.ui.keyCode.END:
                    case e.ui.keyCode.PAGE_UP:
                    case e.ui.keyCode.PAGE_DOWN:
                    case e.ui.keyCode.UP:
                    case e.ui.keyCode.RIGHT:
                    case e.ui.keyCode.DOWN:
                    case e.ui.keyCode.LEFT:
                        if (t.preventDefault(), !this._keySliding && (this._keySliding = !0, this._addClass(e(t.target), null, "ui-state-active"), i = this._start(t, o), i === !1))return
                }
                switch (a = this.options.step, s = n = this._hasMultipleValues() ? this.values(o) : this.value(), t.keyCode) {
                    case e.ui.keyCode.HOME:
                        n = this._valueMin();
                        break;
                    case e.ui.keyCode.END:
                        n = this._valueMax();
                        break;
                    case e.ui.keyCode.PAGE_UP:
                        n = this._trimAlignValue(s + (this._valueMax() - this._valueMin()) / this.numPages);
                        break;
                    case e.ui.keyCode.PAGE_DOWN:
                        n = this._trimAlignValue(s - (this._valueMax() - this._valueMin()) / this.numPages);
                        break;
                    case e.ui.keyCode.UP:
                    case e.ui.keyCode.RIGHT:
                        if (s === this._valueMax())return;
                        n = this._trimAlignValue(s + a);
                        break;
                    case e.ui.keyCode.DOWN:
                    case e.ui.keyCode.LEFT:
                        if (s === this._valueMin())return;
                        n = this._trimAlignValue(s - a)
                }
                this._slide(t, o, n)
            }, keyup: function (t) {
                var i = e(t.target).data("ui-slider-handle-index");
                this._keySliding && (this._keySliding = !1, this._stop(t, i), this._change(t, i), this._removeClass(e(t.target), null, "ui-state-active"))
            }
        }
    }), e.widget("ui.spinner", {
        version: "1.12.1",
        defaultElement: "<input>",
        widgetEventPrefix: "spin",
        options: {
            classes: {
                "ui-spinner": "ui-corner-all",
                "ui-spinner-down": "ui-corner-br",
                "ui-spinner-up": "ui-corner-tr"
            },
            culture: null,
            icons: {down: "ui-icon-triangle-1-s", up: "ui-icon-triangle-1-n"},
            incremental: !0,
            max: null,
            min: null,
            numberFormat: null,
            page: 10,
            step: 1,
            change: null,
            spin: null,
            start: null,
            stop: null
        },
        _create: function () {
            this._setOption("max", this.options.max), this._setOption("min", this.options.min), this._setOption("step", this.options.step), "" !== this.value() && this._value(this.element.val(), !0), this._draw(), this._on(this._events), this._refresh(), this._on(this.window, {
                beforeunload: function () {
                    this.element.removeAttr("autocomplete")
                }
            })
        },
        _getCreateOptions: function () {
            var t = this._super(), i = this.element;
            return e.each(["min", "max", "step"], function (e, s) {
                var n = i.attr(s);
                null != n && n.length && (t[s] = n)
            }), t
        },
        _events: {
            keydown: function (e) {
                this._start(e) && this._keydown(e) && e.preventDefault()
            }, keyup: "_stop", focus: function () {
                this.previous = this.element.val()
            }, blur: function (e) {
                return this.cancelBlur ? (delete this.cancelBlur, void 0) : (this._stop(), this._refresh(), this.previous !== this.element.val() && this._trigger("change", e), void 0)
            }, mousewheel: function (e, t) {
                if (t) {
                    if (!this.spinning && !this._start(e))return !1;
                    this._spin((t > 0 ? 1 : -1) * this.options.step, e), clearTimeout(this.mousewheelTimer), this.mousewheelTimer = this._delay(function () {
                        this.spinning && this._stop(e)
                    }, 100), e.preventDefault()
                }
            }, "mousedown .ui-spinner-button": function (t) {
                function i() {
                    var t = this.element[0] === e.ui.safeActiveElement(this.document[0]);
                    t || (this.element.trigger("focus"), this.previous = s, this._delay(function () {
                        this.previous = s
                    }))
                }

                var s;
                s = this.element[0] === e.ui.safeActiveElement(this.document[0]) ? this.previous : this.element.val(), t.preventDefault(), i.call(this), this.cancelBlur = !0, this._delay(function () {
                    delete this.cancelBlur, i.call(this)
                }), this._start(t) !== !1 && this._repeat(null, e(t.currentTarget).hasClass("ui-spinner-up") ? 1 : -1, t)
            }, "mouseup .ui-spinner-button": "_stop", "mouseenter .ui-spinner-button": function (t) {
                return e(t.currentTarget).hasClass("ui-state-active") ? this._start(t) === !1 ? !1 : (this._repeat(null, e(t.currentTarget).hasClass("ui-spinner-up") ? 1 : -1, t), void 0) : void 0
            }, "mouseleave .ui-spinner-button": "_stop"
        },
        _enhance: function () {
            this.uiSpinner = this.element.attr("autocomplete", "off").wrap("<span>").parent().append("<a></a><a></a>")
        },
        _draw: function () {
            this._enhance(), this._addClass(this.uiSpinner, "ui-spinner", "ui-widget ui-widget-content"), this._addClass("ui-spinner-input"), this.element.attr("role", "spinbutton"), this.buttons = this.uiSpinner.children("a").attr("tabIndex", -1).attr("aria-hidden", !0).button({classes: {"ui-button": ""}}), this._removeClass(this.buttons, "ui-corner-all"), this._addClass(this.buttons.first(), "ui-spinner-button ui-spinner-up"), this._addClass(this.buttons.last(), "ui-spinner-button ui-spinner-down"), this.buttons.first().button({
                icon: this.options.icons.up,
                showLabel: !1
            }), this.buttons.last().button({
                icon: this.options.icons.down,
                showLabel: !1
            }), this.buttons.height() > Math.ceil(.5 * this.uiSpinner.height()) && this.uiSpinner.height() > 0 && this.uiSpinner.height(this.uiSpinner.height())
        },
        _keydown: function (t) {
            var i = this.options, s = e.ui.keyCode;
            switch (t.keyCode) {
                case s.UP:
                    return this._repeat(null, 1, t), !0;
                case s.DOWN:
                    return this._repeat(null, -1, t), !0;
                case s.PAGE_UP:
                    return this._repeat(null, i.page, t), !0;
                case s.PAGE_DOWN:
                    return this._repeat(null, -i.page, t), !0
            }
            return !1
        },
        _start: function (e) {
            return this.spinning || this._trigger("start", e) !== !1 ? (this.counter || (this.counter = 1), this.spinning = !0, !0) : !1
        },
        _repeat: function (e, t, i) {
            e = e || 500, clearTimeout(this.timer), this.timer = this._delay(function () {
                this._repeat(40, t, i)
            }, e), this._spin(t * this.options.step, i)
        },
        _spin: function (e, t) {
            var i = this.value() || 0;
            this.counter || (this.counter = 1), i = this._adjustValue(i + e * this._increment(this.counter)), this.spinning && this._trigger("spin", t, {value: i}) === !1 || (this._value(i), this.counter++)
        },
        _increment: function (t) {
            var i = this.options.incremental;
            return i ? e.isFunction(i) ? i(t) : Math.floor(t * t * t / 5e4 - t * t / 500 + 17 * t / 200 + 1) : 1
        },
        _precision: function () {
            var e = this._precisionOf(this.options.step);
            return null !== this.options.min && (e = Math.max(e, this._precisionOf(this.options.min))), e
        },
        _precisionOf: function (e) {
            var t = "" + e, i = t.indexOf(".");
            return -1 === i ? 0 : t.length - i - 1
        },
        _adjustValue: function (e) {
            var t, i, s = this.options;
            return t = null !== s.min ? s.min : 0, i = e - t, i = Math.round(i / s.step) * s.step, e = t + i, e = parseFloat(e.toFixed(this._precision())), null !== s.max && e > s.max ? s.max : null !== s.min && s.min > e ? s.min : e
        },
        _stop: function (e) {
            this.spinning && (clearTimeout(this.timer), clearTimeout(this.mousewheelTimer), this.counter = 0, this.spinning = !1, this._trigger("stop", e))
        },
        _setOption: function (e, t) {
            var i, s, n;
            return "culture" === e || "numberFormat" === e ? (i = this._parse(this.element.val()), this.options[e] = t, this.element.val(this._format(i)), void 0) : (("max" === e || "min" === e || "step" === e) && "string" == typeof t && (t = this._parse(t)), "icons" === e && (s = this.buttons.first().find(".ui-icon"), this._removeClass(s, null, this.options.icons.up), this._addClass(s, null, t.up), n = this.buttons.last().find(".ui-icon"), this._removeClass(n, null, this.options.icons.down), this._addClass(n, null, t.down)), this._super(e, t), void 0)
        },
        _setOptionDisabled: function (e) {
            this._super(e), this._toggleClass(this.uiSpinner, null, "ui-state-disabled", !!e), this.element.prop("disabled", !!e), this.buttons.button(e ? "disable" : "enable")
        },
        _setOptions: r(function (e) {
            this._super(e)
        }),
        _parse: function (e) {
            return "string" == typeof e && "" !== e && (e = window.Globalize && this.options.numberFormat ? Globalize.parseFloat(e, 10, this.options.culture) : +e), "" === e || isNaN(e) ? null : e
        },
        _format: function (e) {
            return "" === e ? "" : window.Globalize && this.options.numberFormat ? Globalize.format(e, this.options.numberFormat, this.options.culture) : e
        },
        _refresh: function () {
            this.element.attr({
                "aria-valuemin": this.options.min,
                "aria-valuemax": this.options.max,
                "aria-valuenow": this._parse(this.element.val())
            })
        },
        isValid: function () {
            var e = this.value();
            return null === e ? !1 : e === this._adjustValue(e)
        },
        _value: function (e, t) {
            var i;
            "" !== e && (i = this._parse(e), null !== i && (t || (i = this._adjustValue(i)), e = this._format(i))), this.element.val(e), this._refresh()
        },
        _destroy: function () {
            this.element.prop("disabled", !1).removeAttr("autocomplete role aria-valuemin aria-valuemax aria-valuenow"), this.uiSpinner.replaceWith(this.element)
        },
        stepUp: r(function (e) {
            this._stepUp(e)
        }),
        _stepUp: function (e) {
            this._start() && (this._spin((e || 1) * this.options.step), this._stop())
        },
        stepDown: r(function (e) {
            this._stepDown(e)
        }),
        _stepDown: function (e) {
            this._start() && (this._spin((e || 1) * -this.options.step), this._stop())
        },
        pageUp: r(function (e) {
            this._stepUp((e || 1) * this.options.page)
        }),
        pageDown: r(function (e) {
            this._stepDown((e || 1) * this.options.page)
        }),
        value: function (e) {
            return arguments.length ? (r(this._value).call(this, e), void 0) : this._parse(this.element.val())
        },
        widget: function () {
            return this.uiSpinner
        }
    }), e.uiBackCompat !== !1 && e.widget("ui.spinner", e.ui.spinner, {
        _enhance: function () {
            this.uiSpinner = this.element.attr("autocomplete", "off").wrap(this._uiSpinnerHtml()).parent().append(this._buttonHtml())
        }, _uiSpinnerHtml: function () {
            return "<span>"
        }, _buttonHtml: function () {
            return "<a></a><a></a>"
        }
    }), e.ui.spinner, e.widget("ui.tabs", {
        version: "1.12.1",
        delay: 300,
        options: {
            active: null,
            classes: {
                "ui-tabs": "ui-corner-all",
                "ui-tabs-nav": "ui-corner-all",
                "ui-tabs-panel": "ui-corner-bottom",
                "ui-tabs-tab": "ui-corner-top"
            },
            collapsible: !1,
            event: "click",
            heightStyle: "content",
            hide: null,
            show: null,
            activate: null,
            beforeActivate: null,
            beforeLoad: null,
            load: null
        },
        _isLocal: function () {
            var e = /#.*$/;
            return function (t) {
                var i, s;
                i = t.href.replace(e, ""), s = location.href.replace(e, "");
                try {
                    i = decodeURIComponent(i)
                } catch (n) {
                }
                try {
                    s = decodeURIComponent(s)
                } catch (n) {
                }
                return t.hash.length > 1 && i === s
            }
        }(),
        _create: function () {
            var t = this, i = this.options;
            this.running = !1, this._addClass("ui-tabs", "ui-widget ui-widget-content"), this._toggleClass("ui-tabs-collapsible", null, i.collapsible), this._processTabs(), i.active = this._initialActive(), e.isArray(i.disabled) && (i.disabled = e.unique(i.disabled.concat(e.map(this.tabs.filter(".ui-state-disabled"), function (e) {
                return t.tabs.index(e)
            }))).sort()), this.active = this.options.active !== !1 && this.anchors.length ? this._findActive(i.active) : e(), this._refresh(), this.active.length && this.load(i.active)
        },
        _initialActive: function () {
            var t = this.options.active, i = this.options.collapsible, s = location.hash.substring(1);
            return null === t && (s && this.tabs.each(function (i, n) {
                return e(n).attr("aria-controls") === s ? (t = i, !1) : void 0
            }), null === t && (t = this.tabs.index(this.tabs.filter(".ui-tabs-active"))), (null === t || -1 === t) && (t = this.tabs.length ? 0 : !1)), t !== !1 && (t = this.tabs.index(this.tabs.eq(t)), -1 === t && (t = i ? !1 : 0)), !i && t === !1 && this.anchors.length && (t = 0), t
        },
        _getCreateEventData: function () {
            return {tab: this.active, panel: this.active.length ? this._getPanelForTab(this.active) : e()}
        },
        _tabKeydown: function (t) {
            var i = e(e.ui.safeActiveElement(this.document[0])).closest("li"), s = this.tabs.index(i), n = !0;
            if (!this._handlePageNav(t)) {
                switch (t.keyCode) {
                    case e.ui.keyCode.RIGHT:
                    case e.ui.keyCode.DOWN:
                        s++;
                        break;
                    case e.ui.keyCode.UP:
                    case e.ui.keyCode.LEFT:
                        n = !1, s--;
                        break;
                    case e.ui.keyCode.END:
                        s = this.anchors.length - 1;
                        break;
                    case e.ui.keyCode.HOME:
                        s = 0;
                        break;
                    case e.ui.keyCode.SPACE:
                        return t.preventDefault(), clearTimeout(this.activating), this._activate(s), void 0;
                    case e.ui.keyCode.ENTER:
                        return t.preventDefault(), clearTimeout(this.activating), this._activate(s === this.options.active ? !1 : s), void 0;
                    default:
                        return
                }
                t.preventDefault(), clearTimeout(this.activating), s = this._focusNextTab(s, n), t.ctrlKey || t.metaKey || (i.attr("aria-selected", "false"), this.tabs.eq(s).attr("aria-selected", "true"), this.activating = this._delay(function () {
                    this.option("active", s)
                }, this.delay))
            }
        },
        _panelKeydown: function (t) {
            this._handlePageNav(t) || t.ctrlKey && t.keyCode === e.ui.keyCode.UP && (t.preventDefault(), this.active.trigger("focus"))
        },
        _handlePageNav: function (t) {
            return t.altKey && t.keyCode === e.ui.keyCode.PAGE_UP ? (this._activate(this._focusNextTab(this.options.active - 1, !1)), !0) : t.altKey && t.keyCode === e.ui.keyCode.PAGE_DOWN ? (this._activate(this._focusNextTab(this.options.active + 1, !0)), !0) : void 0
        },
        _findNextTab: function (t, i) {
            function s() {
                return t > n && (t = 0), 0 > t && (t = n), t
            }

            for (var n = this.tabs.length - 1; -1 !== e.inArray(s(), this.options.disabled);)t = i ? t + 1 : t - 1;
            return t
        },
        _focusNextTab: function (e, t) {
            return e = this._findNextTab(e, t), this.tabs.eq(e).trigger("focus"), e
        },
        _setOption: function (e, t) {
            return "active" === e ? (this._activate(t), void 0) : (this._super(e, t), "collapsible" === e && (this._toggleClass("ui-tabs-collapsible", null, t), t || this.options.active !== !1 || this._activate(0)), "event" === e && this._setupEvents(t), "heightStyle" === e && this._setupHeightStyle(t), void 0)
        },
        _sanitizeSelector: function (e) {
            return e ? e.replace(/[!"$%&'()*+,.\/:;<=>?@\[\]\^`{|}~]/g, "\\$&") : ""
        },
        refresh: function () {
            var t = this.options, i = this.tablist.children(":has(a[href])");
            t.disabled = e.map(i.filter(".ui-state-disabled"), function (e) {
                return i.index(e)
            }), this._processTabs(), t.active !== !1 && this.anchors.length ? this.active.length && !e.contains(this.tablist[0], this.active[0]) ? this.tabs.length === t.disabled.length ? (t.active = !1, this.active = e()) : this._activate(this._findNextTab(Math.max(0, t.active - 1), !1)) : t.active = this.tabs.index(this.active) : (t.active = !1, this.active = e()), this._refresh()
        },
        _refresh: function () {
            this._setOptionDisabled(this.options.disabled), this._setupEvents(this.options.event), this._setupHeightStyle(this.options.heightStyle), this.tabs.not(this.active).attr({
                "aria-selected": "false",
                "aria-expanded": "false",
                tabIndex: -1
            }), this.panels.not(this._getPanelForTab(this.active)).hide().attr({"aria-hidden": "true"}), this.active.length ? (this.active.attr({
                    "aria-selected": "true",
                    "aria-expanded": "true",
                    tabIndex: 0
                }), this._addClass(this.active, "ui-tabs-active", "ui-state-active"), this._getPanelForTab(this.active).show().attr({"aria-hidden": "false"})) : this.tabs.eq(0).attr("tabIndex", 0)
        },
        _processTabs: function () {
            var t = this, i = this.tabs, s = this.anchors, n = this.panels;
            this.tablist = this._getList().attr("role", "tablist"), this._addClass(this.tablist, "ui-tabs-nav", "ui-helper-reset ui-helper-clearfix ui-widget-header"), this.tablist.on("mousedown" + this.eventNamespace, "> li", function (t) {
                e(this).is(".ui-state-disabled") && t.preventDefault()
            }).on("focus" + this.eventNamespace, ".ui-tabs-anchor", function () {
                e(this).closest("li").is(".ui-state-disabled") && this.blur()
            }), this.tabs = this.tablist.find("> li:has(a[href])").attr({
                role: "tab",
                tabIndex: -1
            }), this._addClass(this.tabs, "ui-tabs-tab", "ui-state-default"), this.anchors = this.tabs.map(function () {
                return e("a", this)[0]
            }).attr({
                role: "presentation",
                tabIndex: -1
            }), this._addClass(this.anchors, "ui-tabs-anchor"), this.panels = e(), this.anchors.each(function (i, s) {
                var n, a, o, r = e(s).uniqueId().attr("id"), h = e(s).closest("li"), l = h.attr("aria-controls");
                t._isLocal(s) ? (n = s.hash, o = n.substring(1), a = t.element.find(t._sanitizeSelector(n))) : (o = h.attr("aria-controls") || e({}).uniqueId()[0].id, n = "#" + o, a = t.element.find(n), a.length || (a = t._createPanel(o), a.insertAfter(t.panels[i - 1] || t.tablist)), a.attr("aria-live", "polite")), a.length && (t.panels = t.panels.add(a)), l && h.data("ui-tabs-aria-controls", l), h.attr({
                    "aria-controls": o,
                    "aria-labelledby": r
                }), a.attr("aria-labelledby", r)
            }), this.panels.attr("role", "tabpanel"), this._addClass(this.panels, "ui-tabs-panel", "ui-widget-content"), i && (this._off(i.not(this.tabs)), this._off(s.not(this.anchors)), this._off(n.not(this.panels)))
        },
        _getList: function () {
            return this.tablist || this.element.find("ol, ul").eq(0)
        },
        _createPanel: function (t) {
            return e("<div>").attr("id", t).data("ui-tabs-destroy", !0)
        },
        _setOptionDisabled: function (t) {
            var i, s, n;
            for (e.isArray(t) && (t.length ? t.length === this.anchors.length && (t = !0) : t = !1), n = 0; s = this.tabs[n]; n++)i = e(s), t === !0 || -1 !== e.inArray(n, t) ? (i.attr("aria-disabled", "true"), this._addClass(i, null, "ui-state-disabled")) : (i.removeAttr("aria-disabled"), this._removeClass(i, null, "ui-state-disabled"));
            this.options.disabled = t, this._toggleClass(this.widget(), this.widgetFullName + "-disabled", null, t === !0)
        },
        _setupEvents: function (t) {
            var i = {};
            t && e.each(t.split(" "), function (e, t) {
                i[t] = "_eventHandler"
            }), this._off(this.anchors.add(this.tabs).add(this.panels)), this._on(!0, this.anchors, {
                click: function (e) {
                    e.preventDefault()
                }
            }), this._on(this.anchors, i), this._on(this.tabs, {keydown: "_tabKeydown"}), this._on(this.panels, {keydown: "_panelKeydown"}), this._focusable(this.tabs), this._hoverable(this.tabs)
        },
        _setupHeightStyle: function (t) {
            var i, s = this.element.parent();
            "fill" === t ? (i = s.height(), i -= this.element.outerHeight() - this.element.height(), this.element.siblings(":visible").each(function () {
                    var t = e(this), s = t.css("position");
                    "absolute" !== s && "fixed" !== s && (i -= t.outerHeight(!0))
                }), this.element.children().not(this.panels).each(function () {
                    i -= e(this).outerHeight(!0)
                }), this.panels.each(function () {
                    e(this).height(Math.max(0, i - e(this).innerHeight() + e(this).height()))
                }).css("overflow", "auto")) : "auto" === t && (i = 0, this.panels.each(function () {
                    i = Math.max(i, e(this).height("").height())
                }).height(i))
        },
        _eventHandler: function (t) {
            var i = this.options, s = this.active, n = e(t.currentTarget), a = n.closest("li"), o = a[0] === s[0], r = o && i.collapsible, h = r ? e() : this._getPanelForTab(a), l = s.length ? this._getPanelForTab(s) : e(), u = {
                oldTab: s,
                oldPanel: l,
                newTab: r ? e() : a,
                newPanel: h
            };
            t.preventDefault(), a.hasClass("ui-state-disabled") || a.hasClass("ui-tabs-loading") || this.running || o && !i.collapsible || this._trigger("beforeActivate", t, u) === !1 || (i.active = r ? !1 : this.tabs.index(a), this.active = o ? e() : a, this.xhr && this.xhr.abort(), l.length || h.length || e.error("jQuery UI Tabs: Mismatching fragment identifier."), h.length && this.load(this.tabs.index(a), t), this._toggle(t, u))
        },
        _toggle: function (t, i) {
            function s() {
                a.running = !1, a._trigger("activate", t, i)
            }

            function n() {
                a._addClass(i.newTab.closest("li"), "ui-tabs-active", "ui-state-active"), o.length && a.options.show ? a._show(o, a.options.show, s) : (o.show(), s())
            }

            var a = this, o = i.newPanel, r = i.oldPanel;
            this.running = !0, r.length && this.options.hide ? this._hide(r, this.options.hide, function () {
                    a._removeClass(i.oldTab.closest("li"), "ui-tabs-active", "ui-state-active"), n()
                }) : (this._removeClass(i.oldTab.closest("li"), "ui-tabs-active", "ui-state-active"), r.hide(), n()), r.attr("aria-hidden", "true"), i.oldTab.attr({
                "aria-selected": "false",
                "aria-expanded": "false"
            }), o.length && r.length ? i.oldTab.attr("tabIndex", -1) : o.length && this.tabs.filter(function () {
                    return 0 === e(this).attr("tabIndex")
                }).attr("tabIndex", -1), o.attr("aria-hidden", "false"), i.newTab.attr({
                "aria-selected": "true",
                "aria-expanded": "true",
                tabIndex: 0
            })
        },
        _activate: function (t) {
            var i, s = this._findActive(t);
            s[0] !== this.active[0] && (s.length || (s = this.active), i = s.find(".ui-tabs-anchor")[0], this._eventHandler({
                target: i,
                currentTarget: i,
                preventDefault: e.noop
            }))
        },
        _findActive: function (t) {
            return t === !1 ? e() : this.tabs.eq(t)
        },
        _getIndex: function (t) {
            return "string" == typeof t && (t = this.anchors.index(this.anchors.filter("[href$='" + e.ui.escapeSelector(t) + "']"))), t
        },
        _destroy: function () {
            this.xhr && this.xhr.abort(), this.tablist.removeAttr("role").off(this.eventNamespace), this.anchors.removeAttr("role tabIndex").removeUniqueId(), this.tabs.add(this.panels).each(function () {
                e.data(this, "ui-tabs-destroy") ? e(this).remove() : e(this).removeAttr("role tabIndex aria-live aria-busy aria-selected aria-labelledby aria-hidden aria-expanded")
            }), this.tabs.each(function () {
                var t = e(this), i = t.data("ui-tabs-aria-controls");
                i ? t.attr("aria-controls", i).removeData("ui-tabs-aria-controls") : t.removeAttr("aria-controls")
            }), this.panels.show(), "content" !== this.options.heightStyle && this.panels.css("height", "")
        },
        enable: function (t) {
            var i = this.options.disabled;
            i !== !1 && (void 0 === t ? i = !1 : (t = this._getIndex(t), i = e.isArray(i) ? e.map(i, function (e) {
                        return e !== t ? e : null
                    }) : e.map(this.tabs, function (e, i) {
                        return i !== t ? i : null
                    })), this._setOptionDisabled(i))
        },
        disable: function (t) {
            var i = this.options.disabled;
            if (i !== !0) {
                if (void 0 === t) i = !0; else {
                    if (t = this._getIndex(t), -1 !== e.inArray(t, i))return;
                    i = e.isArray(i) ? e.merge([t], i).sort() : [t]
                }
                this._setOptionDisabled(i)
            }
        },
        load: function (t, i) {
            t = this._getIndex(t);
            var s = this, n = this.tabs.eq(t), a = n.find(".ui-tabs-anchor"), o = this._getPanelForTab(n), r = {
                tab: n,
                panel: o
            }, h = function (e, t) {
                "abort" === t && s.panels.stop(!1, !0), s._removeClass(n, "ui-tabs-loading"), o.removeAttr("aria-busy"), e === s.xhr && delete s.xhr
            };
            this._isLocal(a[0]) || (this.xhr = e.ajax(this._ajaxSettings(a, i, r)), this.xhr && "canceled" !== this.xhr.statusText && (this._addClass(n, "ui-tabs-loading"), o.attr("aria-busy", "true"), this.xhr.done(function (e, t, n) {
                setTimeout(function () {
                    o.html(e), s._trigger("load", i, r), h(n, t)
                }, 1)
            }).fail(function (e, t) {
                setTimeout(function () {
                    h(e, t)
                }, 1)
            })))
        },
        _ajaxSettings: function (t, i, s) {
            var n = this;
            return {
                url: t.attr("href").replace(/#.*$/, ""), beforeSend: function (t, a) {
                    return n._trigger("beforeLoad", i, e.extend({jqXHR: t, ajaxSettings: a}, s))
                }
            }
        },
        _getPanelForTab: function (t) {
            var i = e(t).attr("aria-controls");
            return this.element.find(this._sanitizeSelector("#" + i))
        }
    }), e.uiBackCompat !== !1 && e.widget("ui.tabs", e.ui.tabs, {
        _processTabs: function () {
            this._superApply(arguments), this._addClass(this.tabs, "ui-tab")
        }
    }), e.ui.tabs, e.widget("ui.tooltip", {
        version: "1.12.1", options: {
            classes: {"ui-tooltip": "ui-corner-all ui-widget-shadow"},
            content: function () {
                var t = e(this).attr("title") || "";
                return e("<a>").text(t).html()
            },
            hide: !0,
            items: "[title]:not([disabled])",
            position: {my: "left top+15", at: "left bottom", collision: "flipfit flip"},
            show: !0,
            track: !1,
            close: null,
            open: null
        }, _addDescribedBy: function (t, i) {
            var s = (t.attr("aria-describedby") || "").split(/\s+/);
            s.push(i), t.data("ui-tooltip-id", i).attr("aria-describedby", e.trim(s.join(" ")))
        }, _removeDescribedBy: function (t) {
            var i = t.data("ui-tooltip-id"), s = (t.attr("aria-describedby") || "").split(/\s+/), n = e.inArray(i, s);
            -1 !== n && s.splice(n, 1), t.removeData("ui-tooltip-id"), s = e.trim(s.join(" ")), s ? t.attr("aria-describedby", s) : t.removeAttr("aria-describedby")
        }, _create: function () {
            this._on({
                mouseover: "open",
                focusin: "open"
            }), this.tooltips = {}, this.parents = {}, this.liveRegion = e("<div>").attr({
                role: "log",
                "aria-live": "assertive",
                "aria-relevant": "additions"
            }).appendTo(this.document[0].body), this._addClass(this.liveRegion, null, "ui-helper-hidden-accessible"), this.disabledTitles = e([])
        }, _setOption: function (t, i) {
            var s = this;
            this._super(t, i), "content" === t && e.each(this.tooltips, function (e, t) {
                s._updateContent(t.element)
            })
        }, _setOptionDisabled: function (e) {
            this[e ? "_disable" : "_enable"]()
        }, _disable: function () {
            var t = this;
            e.each(this.tooltips, function (i, s) {
                var n = e.Event("blur");
                n.target = n.currentTarget = s.element[0], t.close(n, !0)
            }), this.disabledTitles = this.disabledTitles.add(this.element.find(this.options.items).addBack().filter(function () {
                var t = e(this);
                return t.is("[title]") ? t.data("ui-tooltip-title", t.attr("title")).removeAttr("title") : void 0
            }))
        }, _enable: function () {
            this.disabledTitles.each(function () {
                var t = e(this);
                t.data("ui-tooltip-title") && t.attr("title", t.data("ui-tooltip-title"))
            }), this.disabledTitles = e([])
        }, open: function (t) {
            var i = this, s = e(t ? t.target : this.element).closest(this.options.items);
            s.length && !s.data("ui-tooltip-id") && (s.attr("title") && s.data("ui-tooltip-title", s.attr("title")), s.data("ui-tooltip-open", !0), t && "mouseover" === t.type && s.parents().each(function () {
                var t, s = e(this);
                s.data("ui-tooltip-open") && (t = e.Event("blur"), t.target = t.currentTarget = this, i.close(t, !0)), s.attr("title") && (s.uniqueId(), i.parents[this.id] = {
                    element: this,
                    title: s.attr("title")
                }, s.attr("title", ""))
            }), this._registerCloseHandlers(t, s), this._updateContent(s, t))
        }, _updateContent: function (e, t) {
            var i, s = this.options.content, n = this, a = t ? t.type : null;
            return "string" == typeof s || s.nodeType || s.jquery ? this._open(t, e, s) : (i = s.call(e[0], function (i) {
                    n._delay(function () {
                        e.data("ui-tooltip-open") && (t && (t.type = a), this._open(t, e, i))
                    })
                }), i && this._open(t, e, i), void 0)
        }, _open: function (t, i, s) {
            function n(e) {
                l.of = e, o.is(":hidden") || o.position(l)
            }

            var a, o, r, h, l = e.extend({}, this.options.position);
            if (s) {
                if (a = this._find(i))return a.tooltip.find(".ui-tooltip-content").html(s), void 0;
                i.is("[title]") && (t && "mouseover" === t.type ? i.attr("title", "") : i.removeAttr("title")), a = this._tooltip(i), o = a.tooltip, this._addDescribedBy(i, o.attr("id")), o.find(".ui-tooltip-content").html(s), this.liveRegion.children().hide(), h = e("<div>").html(o.find(".ui-tooltip-content").html()), h.removeAttr("name").find("[name]").removeAttr("name"), h.removeAttr("id").find("[id]").removeAttr("id"), h.appendTo(this.liveRegion), this.options.track && t && /^mouse/.test(t.type) ? (this._on(this.document, {mousemove: n}), n(t)) : o.position(e.extend({of: i}, this.options.position)), o.hide(), this._show(o, this.options.show), this.options.track && this.options.show && this.options.show.delay && (r = this.delayedShow = setInterval(function () {
                    o.is(":visible") && (n(l.of), clearInterval(r))
                }, e.fx.interval)), this._trigger("open", t, {tooltip: o})
            }
        }, _registerCloseHandlers: function (t, i) {
            var s = {
                keyup: function (t) {
                    if (t.keyCode === e.ui.keyCode.ESCAPE) {
                        var s = e.Event(t);
                        s.currentTarget = i[0], this.close(s, !0)
                    }
                }
            };
            i[0] !== this.element[0] && (s.remove = function () {
                this._removeTooltip(this._find(i).tooltip)
            }), t && "mouseover" !== t.type || (s.mouseleave = "close"), t && "focusin" !== t.type || (s.focusout = "close"), this._on(!0, i, s)
        }, close: function (t) {
            var i, s = this, n = e(t ? t.currentTarget : this.element), a = this._find(n);
            return a ? (i = a.tooltip, a.closing || (clearInterval(this.delayedShow), n.data("ui-tooltip-title") && !n.attr("title") && n.attr("title", n.data("ui-tooltip-title")), this._removeDescribedBy(n), a.hiding = !0, i.stop(!0), this._hide(i, this.options.hide, function () {
                    s._removeTooltip(e(this))
                }), n.removeData("ui-tooltip-open"), this._off(n, "mouseleave focusout keyup"), n[0] !== this.element[0] && this._off(n, "remove"), this._off(this.document, "mousemove"), t && "mouseleave" === t.type && e.each(this.parents, function (t, i) {
                    e(i.element).attr("title", i.title), delete s.parents[t]
                }), a.closing = !0, this._trigger("close", t, {tooltip: i}), a.hiding || (a.closing = !1)), void 0) : (n.removeData("ui-tooltip-open"), void 0)
        }, _tooltip: function (t) {
            var i = e("<div>").attr("role", "tooltip"), s = e("<div>").appendTo(i), n = i.uniqueId().attr("id");
            return this._addClass(s, "ui-tooltip-content"), this._addClass(i, "ui-tooltip", "ui-widget ui-widget-content"), i.appendTo(this._appendTo(t)), this.tooltips[n] = {
                element: t,
                tooltip: i
            }
        }, _find: function (e) {
            var t = e.data("ui-tooltip-id");
            return t ? this.tooltips[t] : null
        }, _removeTooltip: function (e) {
            e.remove(), delete this.tooltips[e.attr("id")]
        }, _appendTo: function (e) {
            var t = e.closest(".ui-front, dialog");
            return t.length || (t = this.document[0].body), t
        }, _destroy: function () {
            var t = this;
            e.each(this.tooltips, function (i, s) {
                var n = e.Event("blur"), a = s.element;
                n.target = n.currentTarget = a[0], t.close(n, !0), e("#" + i).remove(), a.data("ui-tooltip-title") && (a.attr("title") || a.attr("title", a.data("ui-tooltip-title")), a.removeData("ui-tooltip-title"))
            }), this.liveRegion.remove()
        }
    }), e.uiBackCompat !== !1 && e.widget("ui.tooltip", e.ui.tooltip, {
        options: {tooltipClass: null},
        _tooltip: function () {
            var e = this._superApply(arguments);
            return this.options.tooltipClass && e.tooltip.addClass(this.options.tooltipClass), e
        }
    }), e.ui.tooltip;
    var f = "ui-effects-", m = "ui-effects-style", g = "ui-effects-animated", v = e;
    e.effects = {effect: {}}, function (e, t) {
        function i(e, t, i) {
            var s = c[t.type] || {};
            return null == e ? i || !t.def ? null : t.def : (e = s.floor ? ~~e : parseFloat(e), isNaN(e) ? t.def : s.mod ? (e + s.mod) % s.mod : 0 > e ? 0 : e > s.max ? s.max : e)
        }

        function s(i) {
            var s = l(), n = s._rgba = [];
            return i = i.toLowerCase(), f(h, function (e, a) {
                var o, r = a.re.exec(i), h = r && a.parse(r), l = a.space || "rgba";
                return h ? (o = s[l](h), s[u[l].cache] = o[u[l].cache], n = s._rgba = o._rgba, !1) : t
            }), n.length ? ("0,0,0,0" === n.join() && e.extend(n, a.transparent), s) : a[i]
        }

        function n(e, t, i) {
            return i = (i + 1) % 1, 1 > 6 * i ? e + 6 * (t - e) * i : 1 > 2 * i ? t : 2 > 3 * i ? e + 6 * (t - e) * (2 / 3 - i) : e
        }

        var a, o = "backgroundColor borderBottomColor borderLeftColor borderRightColor borderTopColor color columnRuleColor outlineColor textDecorationColor textEmphasisColor", r = /^([\-+])=\s*(\d+\.?\d*)/, h = [{
            re: /rgba?\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})\s*(?:,\s*(\d?(?:\.\d+)?)\s*)?\)/,
            parse: function (e) {
                return [e[1], e[2], e[3], e[4]]
            }
        }, {
            re: /rgba?\(\s*(\d+(?:\.\d+)?)\%\s*,\s*(\d+(?:\.\d+)?)\%\s*,\s*(\d+(?:\.\d+)?)\%\s*(?:,\s*(\d?(?:\.\d+)?)\s*)?\)/,
            parse: function (e) {
                return [2.55 * e[1], 2.55 * e[2], 2.55 * e[3], e[4]]
            }
        }, {
            re: /#([a-f0-9]{2})([a-f0-9]{2})([a-f0-9]{2})/, parse: function (e) {
                return [parseInt(e[1], 16), parseInt(e[2], 16), parseInt(e[3], 16)]
            }
        }, {
            re: /#([a-f0-9])([a-f0-9])([a-f0-9])/, parse: function (e) {
                return [parseInt(e[1] + e[1], 16), parseInt(e[2] + e[2], 16), parseInt(e[3] + e[3], 16)]
            }
        }, {
            re: /hsla?\(\s*(\d+(?:\.\d+)?)\s*,\s*(\d+(?:\.\d+)?)\%\s*,\s*(\d+(?:\.\d+)?)\%\s*(?:,\s*(\d?(?:\.\d+)?)\s*)?\)/,
            space: "hsla",
            parse: function (e) {
                return [e[1], e[2] / 100, e[3] / 100, e[4]]
            }
        }], l = e.Color = function (t, i, s, n) {
            return new e.Color.fn.parse(t, i, s, n)
        }, u = {
            rgba: {
                props: {
                    red: {idx: 0, type: "byte"},
                    green: {idx: 1, type: "byte"},
                    blue: {idx: 2, type: "byte"}
                }
            },
            hsla: {
                props: {
                    hue: {idx: 0, type: "degrees"},
                    saturation: {idx: 1, type: "percent"},
                    lightness: {idx: 2, type: "percent"}
                }
            }
        }, c = {
            "byte": {floor: !0, max: 255},
            percent: {max: 1},
            degrees: {mod: 360, floor: !0}
        }, d = l.support = {}, p = e("<p>")[0], f = e.each;
        p.style.cssText = "background-color:rgba(1,1,1,.5)", d.rgba = p.style.backgroundColor.indexOf("rgba") > -1, f(u, function (e, t) {
            t.cache = "_" + e, t.props.alpha = {idx: 3, type: "percent", def: 1}
        }), l.fn = e.extend(l.prototype, {
            parse: function (n, o, r, h) {
                if (n === t)return this._rgba = [null, null, null, null], this;
                (n.jquery || n.nodeType) && (n = e(n).css(o), o = t);
                var c = this, d = e.type(n), p = this._rgba = [];
                return o !== t && (n = [n, o, r, h], d = "array"), "string" === d ? this.parse(s(n) || a._default) : "array" === d ? (f(u.rgba.props, function (e, t) {
                            p[t.idx] = i(n[t.idx], t)
                        }), this) : "object" === d ? (n instanceof l ? f(u, function (e, t) {
                                    n[t.cache] && (c[t.cache] = n[t.cache].slice())
                                }) : f(u, function (t, s) {
                                    var a = s.cache;
                                    f(s.props, function (e, t) {
                                        if (!c[a] && s.to) {
                                            if ("alpha" === e || null == n[e])return;
                                            c[a] = s.to(c._rgba)
                                        }
                                        c[a][t.idx] = i(n[e], t, !0)
                                    }), c[a] && 0 > e.inArray(null, c[a].slice(0, 3)) && (c[a][3] = 1, s.from && (c._rgba = s.from(c[a])))
                                }), this) : t
            }, is: function (e) {
                var i = l(e), s = !0, n = this;
                return f(u, function (e, a) {
                    var o, r = i[a.cache];
                    return r && (o = n[a.cache] || a.to && a.to(n._rgba) || [], f(a.props, function (e, i) {
                        return null != r[i.idx] ? s = r[i.idx] === o[i.idx] : t
                    })), s
                }), s
            }, _space: function () {
                var e = [], t = this;
                return f(u, function (i, s) {
                    t[s.cache] && e.push(i)
                }), e.pop()
            }, transition: function (e, t) {
                var s = l(e), n = s._space(), a = u[n], o = 0 === this.alpha() ? l("transparent") : this, r = o[a.cache] || a.to(o._rgba), h = r.slice();
                return s = s[a.cache], f(a.props, function (e, n) {
                    var a = n.idx, o = r[a], l = s[a], u = c[n.type] || {};
                    null !== l && (null === o ? h[a] = l : (u.mod && (l - o > u.mod / 2 ? o += u.mod : o - l > u.mod / 2 && (o -= u.mod)), h[a] = i((l - o) * t + o, n)))
                }), this[n](h)
            }, blend: function (t) {
                if (1 === this._rgba[3])return this;
                var i = this._rgba.slice(), s = i.pop(), n = l(t)._rgba;
                return l(e.map(i, function (e, t) {
                    return (1 - s) * n[t] + s * e
                }))
            }, toRgbaString: function () {
                var t = "rgba(", i = e.map(this._rgba, function (e, t) {
                    return null == e ? t > 2 ? 1 : 0 : e
                });
                return 1 === i[3] && (i.pop(), t = "rgb("), t + i.join() + ")"
            }, toHslaString: function () {
                var t = "hsla(", i = e.map(this.hsla(), function (e, t) {
                    return null == e && (e = t > 2 ? 1 : 0), t && 3 > t && (e = Math.round(100 * e) + "%"), e
                });
                return 1 === i[3] && (i.pop(), t = "hsl("), t + i.join() + ")"
            }, toHexString: function (t) {
                var i = this._rgba.slice(), s = i.pop();
                return t && i.push(~~(255 * s)), "#" + e.map(i, function (e) {
                    return e = (e || 0).toString(16), 1 === e.length ? "0" + e : e
                }).join("")
            }, toString: function () {
                return 0 === this._rgba[3] ? "transparent" : this.toRgbaString()
            }
        }), l.fn.parse.prototype = l.fn, u.hsla.to = function (e) {
            if (null == e[0] || null == e[1] || null == e[2])return [null, null, null, e[3]];
            var t, i, s = e[0] / 255, n = e[1] / 255, a = e[2] / 255, o = e[3], r = Math.max(s, n, a), h = Math.min(s, n, a), l = r - h, u = r + h, c = .5 * u;
            return t = h === r ? 0 : s === r ? 60 * (n - a) / l + 360 : n === r ? 60 * (a - s) / l + 120 : 60 * (s - n) / l + 240, i = 0 === l ? 0 : .5 >= c ? l / u : l / (2 - u), [Math.round(t) % 360, i, c, null == o ? 1 : o]
        }, u.hsla.from = function (e) {
            if (null == e[0] || null == e[1] || null == e[2])return [null, null, null, e[3]];
            var t = e[0] / 360, i = e[1], s = e[2], a = e[3], o = .5 >= s ? s * (1 + i) : s + i - s * i, r = 2 * s - o;
            return [Math.round(255 * n(r, o, t + 1 / 3)), Math.round(255 * n(r, o, t)), Math.round(255 * n(r, o, t - 1 / 3)), a]
        }, f(u, function (s, n) {
            var a = n.props, o = n.cache, h = n.to, u = n.from;
            l.fn[s] = function (s) {
                if (h && !this[o] && (this[o] = h(this._rgba)), s === t)return this[o].slice();
                var n, r = e.type(s), c = "array" === r || "object" === r ? s : arguments, d = this[o].slice();
                return f(a, function (e, t) {
                    var s = c["object" === r ? e : t.idx];
                    null == s && (s = d[t.idx]), d[t.idx] = i(s, t)
                }), u ? (n = l(u(d)), n[o] = d, n) : l(d)
            }, f(a, function (t, i) {
                l.fn[t] || (l.fn[t] = function (n) {
                    var a, o = e.type(n), h = "alpha" === t ? this._hsla ? "hsla" : "rgba" : s, l = this[h](), u = l[i.idx];
                    return "undefined" === o ? u : ("function" === o && (n = n.call(this, u), o = e.type(n)), null == n && i.empty ? this : ("string" === o && (a = r.exec(n), a && (n = u + parseFloat(a[2]) * ("+" === a[1] ? 1 : -1))), l[i.idx] = n, this[h](l)))
                })
            })
        }), l.hook = function (t) {
            var i = t.split(" ");
            f(i, function (t, i) {
                e.cssHooks[i] = {
                    set: function (t, n) {
                        var a, o, r = "";
                        if ("transparent" !== n && ("string" !== e.type(n) || (a = s(n)))) {
                            if (n = l(a || n), !d.rgba && 1 !== n._rgba[3]) {
                                for (o = "backgroundColor" === i ? t.parentNode : t; ("" === r || "transparent" === r) && o && o.style;)try {
                                    r = e.css(o, "backgroundColor"), o = o.parentNode
                                } catch (h) {
                                }
                                n = n.blend(r && "transparent" !== r ? r : "_default")
                            }
                            n = n.toRgbaString()
                        }
                        try {
                            t.style[i] = n
                        } catch (h) {
                        }
                    }
                }, e.fx.step[i] = function (t) {
                    t.colorInit || (t.start = l(t.elem, i), t.end = l(t.end), t.colorInit = !0), e.cssHooks[i].set(t.elem, t.start.transition(t.end, t.pos))
                }
            })
        }, l.hook(o), e.cssHooks.borderColor = {
            expand: function (e) {
                var t = {};
                return f(["Top", "Right", "Bottom", "Left"], function (i, s) {
                    t["border" + s + "Color"] = e
                }), t
            }
        }, a = e.Color.names = {
            aqua: "#00ffff",
            black: "#000000",
            blue: "#0000ff",
            fuchsia: "#ff00ff",
            gray: "#808080",
            green: "#008000",
            lime: "#00ff00",
            maroon: "#800000",
            navy: "#000080",
            olive: "#808000",
            purple: "#800080",
            red: "#ff0000",
            silver: "#c0c0c0",
            teal: "#008080",
            white: "#ffffff",
            yellow: "#ffff00",
            transparent: [null, null, null, 0],
            _default: "#ffffff"
        }
    }(v), function () {
        function t(t) {
            var i, s, n = t.ownerDocument.defaultView ? t.ownerDocument.defaultView.getComputedStyle(t, null) : t.currentStyle, a = {};
            if (n && n.length && n[0] && n[n[0]])for (s = n.length; s--;)i = n[s], "string" == typeof n[i] && (a[e.camelCase(i)] = n[i]); else for (i in n)"string" == typeof n[i] && (a[i] = n[i]);
            return a
        }

        function i(t, i) {
            var s, a, o = {};
            for (s in i)a = i[s], t[s] !== a && (n[s] || (e.fx.step[s] || !isNaN(parseFloat(a))) && (o[s] = a));
            return o
        }

        var s = ["add", "remove", "toggle"], n = {
            border: 1,
            borderBottom: 1,
            borderColor: 1,
            borderLeft: 1,
            borderRight: 1,
            borderTop: 1,
            borderWidth: 1,
            margin: 1,
            padding: 1
        };
        e.each(["borderLeftStyle", "borderRightStyle", "borderBottomStyle", "borderTopStyle"], function (t, i) {
            e.fx.step[i] = function (e) {
                ("none" !== e.end && !e.setAttr || 1 === e.pos && !e.setAttr) && (v.style(e.elem, i, e.end), e.setAttr = !0)
            }
        }), e.fn.addBack || (e.fn.addBack = function (e) {
            return this.add(null == e ? this.prevObject : this.prevObject.filter(e))
        }), e.effects.animateClass = function (n, a, o, r) {
            var h = e.speed(a, o, r);
            return this.queue(function () {
                var a, o = e(this), r = o.attr("class") || "", l = h.children ? o.find("*").addBack() : o;
                l = l.map(function () {
                    var i = e(this);
                    return {el: i, start: t(this)}
                }), a = function () {
                    e.each(s, function (e, t) {
                        n[t] && o[t + "Class"](n[t])
                    })
                }, a(), l = l.map(function () {
                    return this.end = t(this.el[0]), this.diff = i(this.start, this.end), this
                }), o.attr("class", r), l = l.map(function () {
                    var t = this, i = e.Deferred(), s = e.extend({}, h, {
                        queue: !1, complete: function () {
                            i.resolve(t)
                        }
                    });
                    return this.el.animate(this.diff, s), i.promise()
                }), e.when.apply(e, l.get()).done(function () {
                    a(), e.each(arguments, function () {
                        var t = this.el;
                        e.each(this.diff, function (e) {
                            t.css(e, "")
                        })
                    }), h.complete.call(o[0])
                })
            })
        }, e.fn.extend({
            addClass: function (t) {
                return function (i, s, n, a) {
                    return s ? e.effects.animateClass.call(this, {add: i}, s, n, a) : t.apply(this, arguments)
                }
            }(e.fn.addClass), removeClass: function (t) {
                return function (i, s, n, a) {
                    return arguments.length > 1 ? e.effects.animateClass.call(this, {remove: i}, s, n, a) : t.apply(this, arguments)
                }
            }(e.fn.removeClass), toggleClass: function (t) {
                return function (i, s, n, a, o) {
                    return "boolean" == typeof s || void 0 === s ? n ? e.effects.animateClass.call(this, s ? {add: i} : {remove: i}, n, a, o) : t.apply(this, arguments) : e.effects.animateClass.call(this, {toggle: i}, s, n, a)
                }
            }(e.fn.toggleClass), switchClass: function (t, i, s, n, a) {
                return e.effects.animateClass.call(this, {add: i, remove: t}, s, n, a)
            }
        })
    }(), function () {
        function t(t, i, s, n) {
            return e.isPlainObject(t) && (i = t, t = t.effect), t = {effect: t}, null == i && (i = {}), e.isFunction(i) && (n = i, s = null, i = {}), ("number" == typeof i || e.fx.speeds[i]) && (n = s, s = i, i = {}), e.isFunction(s) && (n = s, s = null), i && e.extend(t, i), s = s || i.duration, t.duration = e.fx.off ? 0 : "number" == typeof s ? s : s in e.fx.speeds ? e.fx.speeds[s] : e.fx.speeds._default, t.complete = n || i.complete, t
        }

        function i(t) {
            return !t || "number" == typeof t || e.fx.speeds[t] ? !0 : "string" != typeof t || e.effects.effect[t] ? e.isFunction(t) ? !0 : "object" != typeof t || t.effect ? !1 : !0 : !0
        }

        function s(e, t) {
            var i = t.outerWidth(), s = t.outerHeight(), n = /^rect\((-?\d*\.?\d*px|-?\d+%|auto),?\s*(-?\d*\.?\d*px|-?\d+%|auto),?\s*(-?\d*\.?\d*px|-?\d+%|auto),?\s*(-?\d*\.?\d*px|-?\d+%|auto)\)$/, a = n.exec(e) || ["", 0, i, s, 0];
            return {
                top: parseFloat(a[1]) || 0,
                right: "auto" === a[2] ? i : parseFloat(a[2]),
                bottom: "auto" === a[3] ? s : parseFloat(a[3]),
                left: parseFloat(a[4]) || 0
            }
        }

        e.expr && e.expr.filters && e.expr.filters.animated && (e.expr.filters.animated = function (t) {
            return function (i) {
                return !!e(i).data(g) || t(i)
            }
        }(e.expr.filters.animated)), e.uiBackCompat !== !1 && e.extend(e.effects, {
            save: function (e, t) {
                for (var i = 0, s = t.length; s > i; i++)null !== t[i] && e.data(f + t[i], e[0].style[t[i]])
            }, restore: function (e, t) {
                for (var i, s = 0, n = t.length; n > s; s++)null !== t[s] && (i = e.data(f + t[s]), e.css(t[s], i))
            }, setMode: function (e, t) {
                return "toggle" === t && (t = e.is(":hidden") ? "show" : "hide"), t
            }, createWrapper: function (t) {
                if (t.parent().is(".ui-effects-wrapper"))return t.parent();
                var i = {
                    width: t.outerWidth(!0),
                    height: t.outerHeight(!0),
                    "float": t.css("float")
                }, s = e("<div></div>").addClass("ui-effects-wrapper").css({
                    fontSize: "100%",
                    background: "transparent",
                    border: "none",
                    margin: 0,
                    padding: 0
                }), n = {width: t.width(), height: t.height()}, a = document.activeElement;
                try {
                    a.id
                } catch (o) {
                    a = document.body
                }
                return t.wrap(s), (t[0] === a || e.contains(t[0], a)) && e(a).trigger("focus"), s = t.parent(), "static" === t.css("position") ? (s.css({position: "relative"}), t.css({position: "relative"})) : (e.extend(i, {
                        position: t.css("position"),
                        zIndex: t.css("z-index")
                    }), e.each(["top", "left", "bottom", "right"], function (e, s) {
                        i[s] = t.css(s), isNaN(parseInt(i[s], 10)) && (i[s] = "auto")
                    }), t.css({
                        position: "relative",
                        top: 0,
                        left: 0,
                        right: "auto",
                        bottom: "auto"
                    })), t.css(n), s.css(i).show()
            }, removeWrapper: function (t) {
                var i = document.activeElement;
                return t.parent().is(".ui-effects-wrapper") && (t.parent().replaceWith(t), (t[0] === i || e.contains(t[0], i)) && e(i).trigger("focus")), t
            }
        }), e.extend(e.effects, {
            version: "1.12.1", define: function (t, i, s) {
                return s || (s = i, i = "effect"), e.effects.effect[t] = s, e.effects.effect[t].mode = i, s
            }, scaledDimensions: function (e, t, i) {
                if (0 === t)return {height: 0, width: 0, outerHeight: 0, outerWidth: 0};
                var s = "horizontal" !== i ? (t || 100) / 100 : 1, n = "vertical" !== i ? (t || 100) / 100 : 1;
                return {
                    height: e.height() * n,
                    width: e.width() * s,
                    outerHeight: e.outerHeight() * n,
                    outerWidth: e.outerWidth() * s
                }
            }, clipToBox: function (e) {
                return {
                    width: e.clip.right - e.clip.left,
                    height: e.clip.bottom - e.clip.top,
                    left: e.clip.left,
                    top: e.clip.top
                }
            }, unshift: function (e, t, i) {
                var s = e.queue();
                t > 1 && s.splice.apply(s, [1, 0].concat(s.splice(t, i))), e.dequeue()
            }, saveStyle: function (e) {
                e.data(m, e[0].style.cssText)
            }, restoreStyle: function (e) {
                e[0].style.cssText = e.data(m) || "", e.removeData(m)
            }, mode: function (e, t) {
                var i = e.is(":hidden");
                return "toggle" === t && (t = i ? "show" : "hide"), (i ? "hide" === t : "show" === t) && (t = "none"), t
            }, getBaseline: function (e, t) {
                var i, s;
                switch (e[0]) {
                    case"top":
                        i = 0;
                        break;
                    case"middle":
                        i = .5;
                        break;
                    case"bottom":
                        i = 1;
                        break;
                    default:
                        i = e[0] / t.height
                }
                switch (e[1]) {
                    case"left":
                        s = 0;
                        break;
                    case"center":
                        s = .5;
                        break;
                    case"right":
                        s = 1;
                        break;
                    default:
                        s = e[1] / t.width
                }
                return {x: s, y: i}
            }, createPlaceholder: function (t) {
                var i, s = t.css("position"), n = t.position();
                return t.css({
                    marginTop: t.css("marginTop"),
                    marginBottom: t.css("marginBottom"),
                    marginLeft: t.css("marginLeft"),
                    marginRight: t.css("marginRight")
                }).outerWidth(t.outerWidth()).outerHeight(t.outerHeight()), /^(static|relative)/.test(s) && (s = "absolute", i = e("<" + t[0].nodeName + ">").insertAfter(t).css({
                    display: /^(inline|ruby)/.test(t.css("display")) ? "inline-block" : "block",
                    visibility: "hidden",
                    marginTop: t.css("marginTop"),
                    marginBottom: t.css("marginBottom"),
                    marginLeft: t.css("marginLeft"),
                    marginRight: t.css("marginRight"),
                    "float": t.css("float")
                }).outerWidth(t.outerWidth()).outerHeight(t.outerHeight()).addClass("ui-effects-placeholder"), t.data(f + "placeholder", i)), t.css({
                    position: s,
                    left: n.left,
                    top: n.top
                }), i
            }, removePlaceholder: function (e) {
                var t = f + "placeholder", i = e.data(t);
                i && (i.remove(), e.removeData(t))
            }, cleanUp: function (t) {
                e.effects.restoreStyle(t), e.effects.removePlaceholder(t)
            }, setTransition: function (t, i, s, n) {
                return n = n || {}, e.each(i, function (e, i) {
                    var a = t.cssUnit(i);
                    a[0] > 0 && (n[i] = a[0] * s + a[1])
                }), n
            }
        }), e.fn.extend({
            effect: function () {
                function i(t) {
                    function i() {
                        r.removeData(g), e.effects.cleanUp(r), "hide" === s.mode && r.hide(), o()
                    }

                    function o() {
                        e.isFunction(h) && h.call(r[0]), e.isFunction(t) && t()
                    }

                    var r = e(this);
                    s.mode = u.shift(), e.uiBackCompat === !1 || a ? "none" === s.mode ? (r[l](), o()) : n.call(r[0], s, i) : (r.is(":hidden") ? "hide" === l : "show" === l) ? (r[l](), o()) : n.call(r[0], s, o)
                }

                var s = t.apply(this, arguments), n = e.effects.effect[s.effect], a = n.mode, o = s.queue, r = o || "fx", h = s.complete, l = s.mode, u = [], c = function (t) {
                    var i = e(this), s = e.effects.mode(i, l) || a;
                    i.data(g, !0), u.push(s), a && ("show" === s || s === a && "hide" === s) && i.show(), a && "none" === s || e.effects.saveStyle(i), e.isFunction(t) && t()
                };
                return e.fx.off || !n ? l ? this[l](s.duration, h) : this.each(function () {
                            h && h.call(this)
                        }) : o === !1 ? this.each(c).each(i) : this.queue(r, c).queue(r, i)
            }, show: function (e) {
                return function (s) {
                    if (i(s))return e.apply(this, arguments);
                    var n = t.apply(this, arguments);
                    return n.mode = "show", this.effect.call(this, n)
                }
            }(e.fn.show), hide: function (e) {
                return function (s) {
                    if (i(s))return e.apply(this, arguments);
                    var n = t.apply(this, arguments);
                    return n.mode = "hide", this.effect.call(this, n)
                }
            }(e.fn.hide), toggle: function (e) {
                return function (s) {
                    if (i(s) || "boolean" == typeof s)return e.apply(this, arguments);
                    var n = t.apply(this, arguments);
                    return n.mode = "toggle", this.effect.call(this, n)
                }
            }(e.fn.toggle), cssUnit: function (t) {
                var i = this.css(t), s = [];
                return e.each(["em", "px", "%", "pt"], function (e, t) {
                    i.indexOf(t) > 0 && (s = [parseFloat(i), t])
                }), s
            }, cssClip: function (e) {
                return e ? this.css("clip", "rect(" + e.top + "px " + e.right + "px " + e.bottom + "px " + e.left + "px)") : s(this.css("clip"), this)
            }, transfer: function (t, i) {
                var s = e(this), n = e(t.to), a = "fixed" === n.css("position"), o = e("body"), r = a ? o.scrollTop() : 0, h = a ? o.scrollLeft() : 0, l = n.offset(), u = {
                    top: l.top - r,
                    left: l.left - h,
                    height: n.innerHeight(),
                    width: n.innerWidth()
                }, c = s.offset(), d = e("<div class='ui-effects-transfer'></div>").appendTo("body").addClass(t.className).css({
                    top: c.top - r,
                    left: c.left - h,
                    height: s.innerHeight(),
                    width: s.innerWidth(),
                    position: a ? "fixed" : "absolute"
                }).animate(u, t.duration, t.easing, function () {
                    d.remove(), e.isFunction(i) && i()
                })
            }
        }), e.fx.step.clip = function (t) {
            t.clipInit || (t.start = e(t.elem).cssClip(), "string" == typeof t.end && (t.end = s(t.end, t.elem)), t.clipInit = !0), e(t.elem).cssClip({
                top: t.pos * (t.end.top - t.start.top) + t.start.top,
                right: t.pos * (t.end.right - t.start.right) + t.start.right,
                bottom: t.pos * (t.end.bottom - t.start.bottom) + t.start.bottom,
                left: t.pos * (t.end.left - t.start.left) + t.start.left
            })
        }
    }(), function () {
        var t = {};
        e.each(["Quad", "Cubic", "Quart", "Quint", "Expo"], function (e, i) {
            t[i] = function (t) {
                return Math.pow(t, e + 2)
            }
        }), e.extend(t, {
            Sine: function (e) {
                return 1 - Math.cos(e * Math.PI / 2)
            }, Circ: function (e) {
                return 1 - Math.sqrt(1 - e * e)
            }, Elastic: function (e) {
                return 0 === e || 1 === e ? e : -Math.pow(2, 8 * (e - 1)) * Math.sin((80 * (e - 1) - 7.5) * Math.PI / 15)
            }, Back: function (e) {
                return e * e * (3 * e - 2)
            }, Bounce: function (e) {
                for (var t, i = 4; ((t = Math.pow(2, --i)) - 1) / 11 > e;);
                return 1 / Math.pow(4, 3 - i) - 7.5625 * Math.pow((3 * t - 2) / 22 - e, 2)
            }
        }), e.each(t, function (t, i) {
            e.easing["easeIn" + t] = i, e.easing["easeOut" + t] = function (e) {
                return 1 - i(1 - e)
            }, e.easing["easeInOut" + t] = function (e) {
                return .5 > e ? i(2 * e) / 2 : 1 - i(-2 * e + 2) / 2
            }
        })
    }();
    var _ = e.effects;
    e.effects.define("blind", "hide", function (t, i) {
        var s = {
            up: ["bottom", "top"],
            vertical: ["bottom", "top"],
            down: ["top", "bottom"],
            left: ["right", "left"],
            horizontal: ["right", "left"],
            right: ["left", "right"]
        }, n = e(this), a = t.direction || "up", o = n.cssClip(), r = {clip: e.extend({}, o)}, h = e.effects.createPlaceholder(n);
        r.clip[s[a][0]] = r.clip[s[a][1]], "show" === t.mode && (n.cssClip(r.clip), h && h.css(e.effects.clipToBox(r)), r.clip = o), h && h.animate(e.effects.clipToBox(r), t.duration, t.easing), n.animate(r, {
            queue: !1,
            duration: t.duration,
            easing: t.easing,
            complete: i
        })
    }), e.effects.define("bounce", function (t, i) {
        var s, n, a, o = e(this), r = t.mode, h = "hide" === r, l = "show" === r, u = t.direction || "up", c = t.distance, d = t.times || 5, p = 2 * d + (l || h ? 1 : 0), f = t.duration / p, m = t.easing, g = "up" === u || "down" === u ? "top" : "left", v = "up" === u || "left" === u, _ = 0, b = o.queue().length;
        for (e.effects.createPlaceholder(o), a = o.css(g), c || (c = o["top" === g ? "outerHeight" : "outerWidth"]() / 3), l && (n = {opacity: 1}, n[g] = a, o.css("opacity", 0).css(g, v ? 2 * -c : 2 * c).animate(n, f, m)), h && (c /= Math.pow(2, d - 1)), n = {}, n[g] = a; d > _; _++)s = {}, s[g] = (v ? "-=" : "+=") + c, o.animate(s, f, m).animate(n, f, m), c = h ? 2 * c : c / 2;
        h && (s = {opacity: 0}, s[g] = (v ? "-=" : "+=") + c, o.animate(s, f, m)), o.queue(i), e.effects.unshift(o, b, p + 1)
    }), e.effects.define("clip", "hide", function (t, i) {
        var s, n = {}, a = e(this), o = t.direction || "vertical", r = "both" === o, h = r || "horizontal" === o, l = r || "vertical" === o;
        s = a.cssClip(), n.clip = {
            top: l ? (s.bottom - s.top) / 2 : s.top,
            right: h ? (s.right - s.left) / 2 : s.right,
            bottom: l ? (s.bottom - s.top) / 2 : s.bottom,
            left: h ? (s.right - s.left) / 2 : s.left
        }, e.effects.createPlaceholder(a), "show" === t.mode && (a.cssClip(n.clip), n.clip = s), a.animate(n, {
            queue: !1,
            duration: t.duration,
            easing: t.easing,
            complete: i
        })
    }), e.effects.define("drop", "hide", function (t, i) {
        var s, n = e(this), a = t.mode, o = "show" === a, r = t.direction || "left", h = "up" === r || "down" === r ? "top" : "left", l = "up" === r || "left" === r ? "-=" : "+=", u = "+=" === l ? "-=" : "+=", c = {opacity: 0};
        e.effects.createPlaceholder(n), s = t.distance || n["top" === h ? "outerHeight" : "outerWidth"](!0) / 2, c[h] = l + s, o && (n.css(c), c[h] = u + s, c.opacity = 1), n.animate(c, {
            queue: !1,
            duration: t.duration,
            easing: t.easing,
            complete: i
        })
    }), e.effects.define("explode", "hide", function (t, i) {
        function s() {
            b.push(this), b.length === c * d && n()
        }

        function n() {
            p.css({visibility: "visible"}), e(b).remove(), i()
        }

        var a, o, r, h, l, u, c = t.pieces ? Math.round(Math.sqrt(t.pieces)) : 3, d = c, p = e(this), f = t.mode, m = "show" === f, g = p.show().css("visibility", "hidden").offset(), v = Math.ceil(p.outerWidth() / d), _ = Math.ceil(p.outerHeight() / c), b = [];
        for (a = 0; c > a; a++)for (h = g.top + a * _, u = a - (c - 1) / 2, o = 0; d > o; o++)r = g.left + o * v, l = o - (d - 1) / 2, p.clone().appendTo("body").wrap("<div></div>").css({
            position: "absolute",
            visibility: "visible",
            left: -o * v,
            top: -a * _
        }).parent().addClass("ui-effects-explode").css({
            position: "absolute",
            overflow: "hidden",
            width: v,
            height: _,
            left: r + (m ? l * v : 0),
            top: h + (m ? u * _ : 0),
            opacity: m ? 0 : 1
        }).animate({
            left: r + (m ? 0 : l * v),
            top: h + (m ? 0 : u * _),
            opacity: m ? 1 : 0
        }, t.duration || 500, t.easing, s)
    }), e.effects.define("fade", "toggle", function (t, i) {
        var s = "show" === t.mode;
        e(this).css("opacity", s ? 0 : 1).animate({opacity: s ? 1 : 0}, {
            queue: !1,
            duration: t.duration,
            easing: t.easing,
            complete: i
        })
    }), e.effects.define("fold", "hide", function (t, i) {
        var s = e(this), n = t.mode, a = "show" === n, o = "hide" === n, r = t.size || 15, h = /([0-9]+)%/.exec(r), l = !!t.horizFirst, u = l ? ["right", "bottom"] : ["bottom", "right"], c = t.duration / 2, d = e.effects.createPlaceholder(s), p = s.cssClip(), f = {clip: e.extend({}, p)}, m = {clip: e.extend({}, p)}, g = [p[u[0]], p[u[1]]], v = s.queue().length;
        h && (r = parseInt(h[1], 10) / 100 * g[o ? 0 : 1]), f.clip[u[0]] = r, m.clip[u[0]] = r, m.clip[u[1]] = 0, a && (s.cssClip(m.clip), d && d.css(e.effects.clipToBox(m)), m.clip = p), s.queue(function (i) {
            d && d.animate(e.effects.clipToBox(f), c, t.easing).animate(e.effects.clipToBox(m), c, t.easing), i()
        }).animate(f, c, t.easing).animate(m, c, t.easing).queue(i), e.effects.unshift(s, v, 4)
    }), e.effects.define("highlight", "show", function (t, i) {
        var s = e(this), n = {backgroundColor: s.css("backgroundColor")};
        "hide" === t.mode && (n.opacity = 0), e.effects.saveStyle(s), s.css({
            backgroundImage: "none",
            backgroundColor: t.color || "#ffff99"
        }).animate(n, {queue: !1, duration: t.duration, easing: t.easing, complete: i})
    }), e.effects.define("size", function (t, i) {
        var s, n, a, o = e(this), r = ["fontSize"], h = ["borderTopWidth", "borderBottomWidth", "paddingTop", "paddingBottom"], l = ["borderLeftWidth", "borderRightWidth", "paddingLeft", "paddingRight"], u = t.mode, c = "effect" !== u, d = t.scale || "both", p = t.origin || ["middle", "center"], f = o.css("position"), m = o.position(), g = e.effects.scaledDimensions(o), v = t.from || g, _ = t.to || e.effects.scaledDimensions(o, 0);
        e.effects.createPlaceholder(o), "show" === u && (a = v, v = _, _ = a), n = {
            from: {
                y: v.height / g.height,
                x: v.width / g.width
            }, to: {y: _.height / g.height, x: _.width / g.width}
        }, ("box" === d || "both" === d) && (n.from.y !== n.to.y && (v = e.effects.setTransition(o, h, n.from.y, v), _ = e.effects.setTransition(o, h, n.to.y, _)), n.from.x !== n.to.x && (v = e.effects.setTransition(o, l, n.from.x, v), _ = e.effects.setTransition(o, l, n.to.x, _))), ("content" === d || "both" === d) && n.from.y !== n.to.y && (v = e.effects.setTransition(o, r, n.from.y, v), _ = e.effects.setTransition(o, r, n.to.y, _)), p && (s = e.effects.getBaseline(p, g), v.top = (g.outerHeight - v.outerHeight) * s.y + m.top, v.left = (g.outerWidth - v.outerWidth) * s.x + m.left, _.top = (g.outerHeight - _.outerHeight) * s.y + m.top, _.left = (g.outerWidth - _.outerWidth) * s.x + m.left), o.css(v), ("content" === d || "both" === d) && (h = h.concat(["marginTop", "marginBottom"]).concat(r), l = l.concat(["marginLeft", "marginRight"]), o.find("*[width]").each(function () {
            var i = e(this), s = e.effects.scaledDimensions(i), a = {
                height: s.height * n.from.y,
                width: s.width * n.from.x,
                outerHeight: s.outerHeight * n.from.y,
                outerWidth: s.outerWidth * n.from.x
            }, o = {
                height: s.height * n.to.y,
                width: s.width * n.to.x,
                outerHeight: s.height * n.to.y,
                outerWidth: s.width * n.to.x
            };
            n.from.y !== n.to.y && (a = e.effects.setTransition(i, h, n.from.y, a), o = e.effects.setTransition(i, h, n.to.y, o)), n.from.x !== n.to.x && (a = e.effects.setTransition(i, l, n.from.x, a), o = e.effects.setTransition(i, l, n.to.x, o)), c && e.effects.saveStyle(i), i.css(a), i.animate(o, t.duration, t.easing, function () {
                c && e.effects.restoreStyle(i)
            })
        })), o.animate(_, {
            queue: !1, duration: t.duration, easing: t.easing, complete: function () {
                var t = o.offset();
                0 === _.opacity && o.css("opacity", v.opacity), c || (o.css("position", "static" === f ? "relative" : f).offset(t), e.effects.saveStyle(o)), i()
            }
        })
    }), e.effects.define("scale", function (t, i) {
        var s = e(this), n = t.mode, a = parseInt(t.percent, 10) || (0 === parseInt(t.percent, 10) ? 0 : "effect" !== n ? 0 : 100), o = e.extend(!0, {
            from: e.effects.scaledDimensions(s),
            to: e.effects.scaledDimensions(s, a, t.direction || "both"),
            origin: t.origin || ["middle", "center"]
        }, t);
        t.fade && (o.from.opacity = 1, o.to.opacity = 0), e.effects.effect.size.call(this, o, i)
    }), e.effects.define("puff", "hide", function (t, i) {
        var s = e.extend(!0, {}, t, {fade: !0, percent: parseInt(t.percent, 10) || 150});
        e.effects.effect.scale.call(this, s, i)
    }), e.effects.define("pulsate", "show", function (t, i) {
        var s = e(this), n = t.mode, a = "show" === n, o = "hide" === n, r = a || o, h = 2 * (t.times || 5) + (r ? 1 : 0), l = t.duration / h, u = 0, c = 1, d = s.queue().length;
        for ((a || !s.is(":visible")) && (s.css("opacity", 0).show(), u = 1); h > c; c++)s.animate({opacity: u}, l, t.easing), u = 1 - u;
        s.animate({opacity: u}, l, t.easing), s.queue(i), e.effects.unshift(s, d, h + 1)
    }), e.effects.define("shake", function (t, i) {
        var s = 1, n = e(this), a = t.direction || "left", o = t.distance || 20, r = t.times || 3, h = 2 * r + 1, l = Math.round(t.duration / h), u = "up" === a || "down" === a ? "top" : "left", c = "up" === a || "left" === a, d = {}, p = {}, f = {}, m = n.queue().length;
        for (e.effects.createPlaceholder(n), d[u] = (c ? "-=" : "+=") + o, p[u] = (c ? "+=" : "-=") + 2 * o, f[u] = (c ? "-=" : "+=") + 2 * o, n.animate(d, l, t.easing); r > s; s++)n.animate(p, l, t.easing).animate(f, l, t.easing);
        n.animate(p, l, t.easing).animate(d, l / 2, t.easing).queue(i), e.effects.unshift(n, m, h + 1)
    }), e.effects.define("slide", "show", function (t, i) {
        var s, n, a = e(this), o = {
            up: ["bottom", "top"],
            down: ["top", "bottom"],
            left: ["right", "left"],
            right: ["left", "right"]
        }, r = t.mode, h = t.direction || "left", l = "up" === h || "down" === h ? "top" : "left", u = "up" === h || "left" === h, c = t.distance || a["top" === l ? "outerHeight" : "outerWidth"](!0), d = {};
        e.effects.createPlaceholder(a), s = a.cssClip(), n = a.position()[l], d[l] = (u ? -1 : 1) * c + n, d.clip = a.cssClip(), d.clip[o[h][1]] = d.clip[o[h][0]], "show" === r && (a.cssClip(d.clip), a.css(l, d[l]), d.clip = s, d[l] = n), a.animate(d, {
            queue: !1,
            duration: t.duration,
            easing: t.easing,
            complete: i
        })
    });
    var _;
    e.uiBackCompat !== !1 && (_ = e.effects.define("transfer", function (t, i) {
        e(this).transfer(t, i)
    }))
});

(function() {
    'use strict';

    angular
        .module('platformApp')
        .config(httpConfig);

    httpConfig.$inject = ['$urlRouterProvider', '$httpProvider', 'httpRequestInterceptorCacheBusterProvider', '$urlMatcherFactoryProvider'];

    function httpConfig($urlRouterProvider, $httpProvider, httpRequestInterceptorCacheBusterProvider, $urlMatcherFactoryProvider) {
        //Cache everything except rest api requests
        httpRequestInterceptorCacheBusterProvider.setMatchlist([/.*api.*/, /.*protected.*/], true);

        $urlRouterProvider.otherwise('/');

        $httpProvider.interceptors.push('errorHandlerInterceptor');
        $httpProvider.interceptors.push('authExpiredInterceptor');
        $httpProvider.interceptors.push('authInterceptor');
        $httpProvider.interceptors.push('notificationInterceptor');
        // jhipster-needle-angularjs-add-interceptor JHipster will add new application http interceptor here

        $urlMatcherFactoryProvider.type('boolean', {
            name : 'boolean',
            decode: function(val) { return val === true || val === 'true'; },
            encode: function(val) { return val ? 1 : 0; },
            equals: function(a, b) { return this.is(a) && a === b; },
            is: function(val) { return [true,false,0,1].indexOf(val) >= 0; },
            pattern: /bool|true|0|1/
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('platformApp')
        .config(compileServiceConfig);

    compileServiceConfig.$inject = ['$compileProvider','DEBUG_INFO_ENABLED'];

    function compileServiceConfig($compileProvider,DEBUG_INFO_ENABLED) {
        // disable debug data on prod profile to improve performance
        $compileProvider.debugInfoEnabled(DEBUG_INFO_ENABLED);

        /*
        If you wish to debug an application with this information
        then you should open up a debug console in the browser
        then call this method directly in this console:

		angular.reloadWithDebugInfo();
		*/
    }
})();

(function() {
    'use strict';

    angular
        .module('platformApp')
        .config(alertServiceConfig);

    alertServiceConfig.$inject = ['AlertServiceProvider'];

    function alertServiceConfig(AlertServiceProvider) {
        // set below to true to make alerts look like toast
        AlertServiceProvider.showAsToast(false);
    }
})();

(function() {
    'use strict';

    angular
        .module('platformApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider','$uibTooltipProvider'];

    function stateConfig($stateProvider,$uibTooltipProvider) {
        if ($uibTooltipProvider) {
            $uibTooltipProvider.options({ appendToBody: true });
        }
        $stateProvider.state('app', {
            abstract: true,
            views: {
                'navbar@': {
                    templateUrl: 'app/layouts/navbar/navbar.html',
                    controller: 'NavbarController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                authorize: ['Auth',
                    function (Auth) {
                        return Auth.authorize();
                    }
                ],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('global');
                }]
            }
        })
        $stateProvider.state('app1', {
            abstract: true,
            views: {
                'navbar@': {
                    templateUrl: 'app/layouts/navbar/navbar1.html',
                    controller: 'NavbarController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                authorize: ['Auth',
                    function (Auth) {
                        return Auth.authorize();
                    }
                ],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('global');
                }]
            }
        })
        $stateProvider.state('app2', {
            abstract: true,
            views: {
                'navbar@': {
                    templateUrl: 'app/layouts/navbar/navbar2.html',
                    controller: 'NavbarController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                authorize: ['Auth',
                    function (Auth) {
                        return Auth.authorize();
                    }
                ],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('global');
                }]
            }
        });
    }
})();

(function () {
    'use strict';
    // DO NOT EDIT THIS FILE, EDIT THE GULP TASK NGCONSTANT SETTINGS INSTEAD WHICH GENERATES THIS FILE
    angular
        .module('platformApp')
        .constant('VERSION', "0.0.1-SNAPSHOT")
        .constant('DEBUG_INFO_ENABLED', false)
        .constant('BUILD_TIMESTAMP', 1788343468131)
;
})();

(function() {
    'use strict';

    angular
        .module('platformApp')
        .controller('UserManagementDialogController',UserManagementDialogController);

    UserManagementDialogController.$inject = ['$stateParams', '$uibModalInstance', 'entity', 'User', 'JhiLanguageService'];

    function UserManagementDialogController ($stateParams, $uibModalInstance, entity, User, JhiLanguageService) {
        var vm = this;

        vm.authorities = ['ROLE_USER', 'ROLE_ADMIN'];
        vm.clear = clear;
        vm.languages = null;
        vm.save = save;
        vm.user = entity;


        JhiLanguageService.getAll().then(function (languages) {
            vm.languages = languages;
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function onSaveSuccess (result) {
            vm.isSaving = false;
            $uibModalInstance.close(result);
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        function save () {
            vm.isSaving = true;
            if (vm.user.id !== null) {
                User.update(vm.user, onSaveSuccess, onSaveError);
            } else {
                User.save(vm.user, onSaveSuccess, onSaveError);
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('platformApp')
        .controller('UserManagementDetailController', UserManagementDetailController);

    UserManagementDetailController.$inject = ['$stateParams', 'User'];

    function UserManagementDetailController($stateParams, User) {
        var vm = this;

        vm.load = load;
        vm.user = {};

        vm.load($stateParams.login);

        function load(login) {
            User.get({login: login}, function(result) {
                vm.user = result;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('platformApp')
        .controller('UserManagementDeleteController', UserManagementDeleteController);

    UserManagementDeleteController.$inject = ['$uibModalInstance', 'entity', 'User'];

    function UserManagementDeleteController ($uibModalInstance, entity, User) {
        var vm = this;

        vm.user = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (login) {
            User.delete({login: login},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('platformApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('user-management', {
            parent: 'admin',
            url: '/user-management?page&sort',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'userManagement.home.title'
            },
            views: {
                'content': {
                    templateUrl: 'app/admin/user-management/user-management.html',
                    controller: 'UserManagementController',
                    controllerAs: 'vm'
                }
            },            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                }
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort)
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('user-management');
                    return $translate.refresh();
                }]

            }        })
        .state('user-management.new', {
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/admin/user-management/user-management-dialog.html',
                    controller: 'UserManagementDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                id: null, login: null, firstName: null, lastName: null, email: null,
                                activated: true, langKey: null, createdBy: null, createdDate: null,
                                lastModifiedBy: null, lastModifiedDate: null, resetDate: null,
                                resetKey: null, authorities: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('user-management', null, { reload: true });
                }, function() {
                    $state.go('user-management');
                });
            }]
        })
        .state('user-management.edit', {
            url: '/{login}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/admin/user-management/user-management-dialog.html',
                    controller: 'UserManagementDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['User', function(User) {
                            return User.get({login : $stateParams.login}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('user-management', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('user-management-detail', {
            parent: 'user-management',
            url: '/{login}',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'user-management.detail.title'
            },
            views: {
                'content': {
                    templateUrl: 'app/admin/user-management/user-management-detail.html',
                    controller: 'UserManagementDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('user-management');
                    return $translate.refresh();
                }]
            }
        })
        .state('user-management.delete', {
            url: '/{login}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/admin/user-management/user-management-delete-dialog.html',
                    controller: 'UserManagementDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['User', function(User) {
                            return User.get({login : $stateParams.login}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('user-management', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('platformApp')
        .controller('UserManagementController', UserManagementController);

    UserManagementController.$inject = ['Principal', 'User', 'ParseLinks', 'AlertService', '$state', 'pagingParams', 'paginationConstants', 'JhiLanguageService'];

    function UserManagementController(Principal, User, ParseLinks, AlertService, $state, pagingParams, paginationConstants, JhiLanguageService) {
        var vm = this;

        vm.authorities = ['ROLE_USER', 'ROLE_ADMIN'];
        vm.currentAccount = null;
        vm.languages = null;
        vm.loadAll = loadAll;
        vm.setActive = setActive;
        vm.users = [];
        vm.page = 1;
        vm.totalItems = null;
        vm.clear = clear;
        vm.links = null;
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.transition = transition;

        vm.loadAll();
        JhiLanguageService.getAll().then(function (languages) {
            vm.languages = languages;
        });
        Principal.identity().then(function(account) {
            vm.currentAccount = account;
        });

        function setActive (user, isActivated) {
            user.activated = isActivated;
            User.update(user, function () {
                vm.loadAll();
                vm.clear();
            });
        }

        function loadAll () {
            User.query({
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
        }

        function onSuccess(data, headers) {
            vm.links = ParseLinks.parse(headers('link'));
            vm.totalItems = headers('X-Total-Count');
            vm.queryCount = vm.totalItems;
            vm.page = pagingParams.page;
            vm.users = data;
        }

        function onError(error) {
            AlertService.error(error.data.message);
        }

        function clear () {
            vm.user = {
                id: null, login: null, firstName: null, lastName: null, email: null,
                activated: null, langKey: null, createdBy: null, createdDate: null,
                lastModifiedBy: null, lastModifiedDate: null, resetDate: null,
                resetKey: null, authorities: null
            };
        }

        function sort () {
            var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
            if (vm.predicate !== 'id') {
                result.push('id');
            }
            return result;
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('platformApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('jhi-metrics', {
            parent: 'admin',
            url: '/metrics',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'metrics.title'
            },
            views: {
                'content': {
                    templateUrl: 'app/admin/metrics/metrics.html',
                    controller: 'JhiMetricsMonitoringController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('metrics');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('platformApp')
        .factory('JhiMetricsService', JhiMetricsService);

    JhiMetricsService.$inject = ['$rootScope', '$http'];

    function JhiMetricsService ($rootScope, $http) {
        var service = {
            getMetrics: getMetrics,
            threadDump: threadDump
        };

        return service;

        function getMetrics () {
            return $http.get('management/metrics').then(function (response) {
                return response.data;
            });
        }

        function threadDump () {
            return $http.get('management/dump').then(function (response) {
                return response.data;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('platformApp')
        .controller('JhiMetricsMonitoringModalController', JhiMetricsMonitoringModalController);

    JhiMetricsMonitoringModalController.$inject = ['$uibModalInstance', 'threadDump'];

    function JhiMetricsMonitoringModalController ($uibModalInstance, threadDump) {
        var vm = this;

        vm.cancel = cancel;
        vm.getLabelClass = getLabelClass;
        vm.threadDump = threadDump;
        vm.threadDumpAll = 0;
        vm.threadDumpBlocked = 0;
        vm.threadDumpRunnable = 0;
        vm.threadDumpTimedWaiting = 0;
        vm.threadDumpWaiting = 0;

        angular.forEach(threadDump, function(value) {
            if (value.threadState === 'RUNNABLE') {
                vm.threadDumpRunnable += 1;
            } else if (value.threadState === 'WAITING') {
                vm.threadDumpWaiting += 1;
            } else if (value.threadState === 'TIMED_WAITING') {
                vm.threadDumpTimedWaiting += 1;
            } else if (value.threadState === 'BLOCKED') {
                vm.threadDumpBlocked += 1;
            }
        });

        vm.threadDumpAll = vm.threadDumpRunnable + vm.threadDumpWaiting +
            vm.threadDumpTimedWaiting + vm.threadDumpBlocked;

        function cancel () {
            $uibModalInstance.dismiss('cancel');
        }

        function getLabelClass (threadState) {
            if (threadState === 'RUNNABLE') {
                return 'label-success';
            } else if (threadState === 'WAITING') {
                return 'label-info';
            } else if (threadState === 'TIMED_WAITING') {
                return 'label-warning';
            } else if (threadState === 'BLOCKED') {
                return 'label-danger';
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('platformApp')
        .controller('JhiMetricsMonitoringController', JhiMetricsMonitoringController);

    JhiMetricsMonitoringController.$inject = ['$scope','JhiMetricsService', '$uibModal'];

    function JhiMetricsMonitoringController ($scope, JhiMetricsService, $uibModal) {
        var vm = this;

        vm.metrics = {};
        vm.refresh = refresh;
        vm.refreshThreadDumpData = refreshThreadDumpData;
        vm.servicesStats = {};
        vm.updatingMetrics = true;

        vm.refresh();

        $scope.$watch('vm.metrics', function (newValue) {
            vm.servicesStats = {};
            angular.forEach(newValue.timers, function (value, key) {
                if (key.includes('web.rest') || key.includes('service')) {
                    vm.servicesStats[key] = value;
                }
            });

        });

        function refresh () {
            vm.updatingMetrics = true;
            JhiMetricsService.getMetrics().then(function (promise) {
                vm.metrics = promise;
                vm.updatingMetrics = false;
            }, function (promise) {
                vm.metrics = promise.data;
                vm.updatingMetrics = false;
            });
        }

        function refreshThreadDumpData () {
            JhiMetricsService.threadDump().then(function(data) {
                $uibModal.open({
                    templateUrl: 'app/admin/metrics/metrics.modal.html',
                    controller: 'JhiMetricsMonitoringModalController',
                    controllerAs: 'vm',
                    size: 'lg',
                    resolve: {
                        threadDump: function() {
                            return data;
                        }

                    }
                });
            });
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('platformApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('logs', {
            parent: 'admin',
            url: '/logs',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'logs.title'
            },
            views: {
                'content': {
                    templateUrl: 'app/admin/logs/logs.html',
                    controller: 'LogsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('logs');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('platformApp')
        .factory('LogsService', LogsService);

    LogsService.$inject = ['$resource'];

    function LogsService ($resource) {
        var service = $resource('management/logs', {}, {
            'findAll': { method: 'GET', isArray: true},
            'changeLevel': { method: 'PUT'}
        });

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('platformApp')
        .controller('LogsController', LogsController);

    LogsController.$inject = ['LogsService'];

    function LogsController (LogsService) {
        var vm = this;

        vm.changeLevel = changeLevel;
        vm.loggers = LogsService.findAll();

        function changeLevel (name, level) {
            LogsService.changeLevel({name: name, level: level}, function () {
                vm.loggers = LogsService.findAll();
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('platformApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('jhi-health', {
            parent: 'admin',
            url: '/health',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'health.title'
            },
            views: {
                'content': {
                    templateUrl: 'app/admin/health/health.html',
                    controller: 'JhiHealthCheckController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('health');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('platformApp')
        .factory('JhiHealthService', JhiHealthService);

    JhiHealthService.$inject = ['$rootScope', '$http'];

    function JhiHealthService ($rootScope, $http) {
        var separator = '.';
        var service = {
            checkHealth: checkHealth,
            transformHealthData: transformHealthData,
            getBaseName: getBaseName,
            getSubSystemName: getSubSystemName
        };

        return service;

        function checkHealth () {
            return $http.get('management/health').then(function (response) {
                return response.data;
            });
        }

        function transformHealthData (data) {
            var response = [];
            flattenHealthData(response, null, data);
            return response;
        }

        function getBaseName (name) {
            if (name) {
                var split = name.split('.');
                return split[0];
            }
        }

        function getSubSystemName (name) {
            if (name) {
                var split = name.split('.');
                split.splice(0, 1);
                var remainder = split.join('.');
                return remainder ? ' - ' + remainder : '';
            }
        }

        /* private methods */
        function flattenHealthData (result, path, data) {
            angular.forEach(data, function (value, key) {
                if (isHealthObject(value)) {
                    if (hasSubSystem(value)) {
                        addHealthObject(result, false, value, getModuleName(path, key));
                        flattenHealthData(result, getModuleName(path, key), value);
                    } else {
                        addHealthObject(result, true, value, getModuleName(path, key));
                    }
                }
            });
            return result;
        }

        function addHealthObject (result, isLeaf, healthObject, name) {

            var healthData = {
                'name': name
            };
            var details = {};
            var hasDetails = false;

            angular.forEach(healthObject, function (value, key) {
                if (key === 'status' || key === 'error') {
                    healthData[key] = value;
                } else {
                    if (!isHealthObject(value)) {
                        details[key] = value;
                        hasDetails = true;
                    }
                }
            });

            // Add the of the details
            if (hasDetails) {
                angular.extend(healthData, { 'details': details});
            }

            // Only add nodes if they provide additional information
            if (isLeaf || hasDetails || healthData.error) {
                result.push(healthData);
            }
            return healthData;
        }

        function getModuleName (path, name) {
            var result;
            if (path && name) {
                result = path + separator + name;
            }  else if (path) {
                result = path;
            } else if (name) {
                result = name;
            } else {
                result = '';
            }
            return result;
        }

        function hasSubSystem (healthObject) {
            var result = false;
            angular.forEach(healthObject, function (value) {
                if (value && value.status) {
                    result = true;
                }
            });
            return result;
        }

        function isHealthObject (healthObject) {
            var result = false;
            angular.forEach(healthObject, function (value, key) {
                if (key === 'status') {
                    result = true;
                }
            });
            return result;
        }

    }
})();

(function() {
    'use strict';

    angular.module('platformApp')
        .controller('HealthModalController', HealthModalController);

    HealthModalController.$inject = ['$uibModalInstance', 'currentHealth', 'baseName', 'subSystemName'];

    function HealthModalController ($uibModalInstance, currentHealth, baseName, subSystemName) {
        var vm = this;

        vm.cancel = cancel;
        vm.currentHealth = currentHealth;
        vm.baseName = baseName;
        vm.subSystemName = subSystemName;

        function cancel() {
            $uibModalInstance.dismiss('cancel');
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('platformApp')
        .controller('JhiHealthCheckController', JhiHealthCheckController);

    JhiHealthCheckController.$inject = ['JhiHealthService', '$uibModal'];

    function JhiHealthCheckController (JhiHealthService, $uibModal) {
        var vm = this;

        vm.updatingHealth = true;
        vm.getLabelClass = getLabelClass;
        vm.refresh = refresh;
        vm.showHealth = showHealth;
        vm.baseName = JhiHealthService.getBaseName;
        vm.subSystemName = JhiHealthService.getSubSystemName;

        vm.refresh();

        function getLabelClass (statusState) {
            if (statusState === 'UP') {
                return 'label-success';
            } else {
                return 'label-danger';
            }
        }

        function refresh () {
            vm.updatingHealth = true;
            JhiHealthService.checkHealth().then(function (response) {
                vm.healthData = JhiHealthService.transformHealthData(response);
                vm.updatingHealth = false;
            }, function (response) {
                vm.healthData =  JhiHealthService.transformHealthData(response.data);
                vm.updatingHealth = false;
            });
        }

        function showHealth (health) {
            $uibModal.open({
                templateUrl: 'app/admin/health/health.modal.html',
                controller: 'HealthModalController',
                controllerAs: 'vm',
                size: 'lg',
                resolve: {
                    currentHealth: function() {
                        return health;
                    },
                    baseName: function() {
                        return vm.baseName;
                    },
                    subSystemName: function() {
                        return vm.subSystemName;
                    }

                }
            });
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('platformApp')
        .factory('GatewayRoutes', GatewayRoutes);

    GatewayRoutes.$inject = ['$resource'];

    function GatewayRoutes ($resource) {
        var service = $resource('api/gateway/routes/:id', {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'update': { method:'PUT' }
        });

        return service;
    }

})();

(function() {
    'use strict';

    angular
        .module('platformApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('gateway', {
            parent: 'admin',
            url: '/gateway',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'gateway.title'
            },
            views: {
                'content': {
                    templateUrl: 'app/admin/gateway/gateway.html',
                    controller: 'GatewayController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('gateway');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('platformApp')
        .controller('GatewayController', GatewayController);

    GatewayController.$inject = ['$filter', '$interval', 'GatewayRoutes'];

    function GatewayController ($filter, $interval, GatewayRoutes) {
        var vm = this;

        vm.gatewayRoutes = null;
        vm.refresh = refresh;
        vm.updatingRoutes = null;

        vm.refresh();

        function refresh () {
            vm.updatingRoutes = true;
            GatewayRoutes.query(function(result) {
                vm.gatewayRoutes = result;
                vm.updatingRoutes = false;
            });
        }
    }

})();

(function() {
    'use strict';

    angular
        .module('platformApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig ($stateProvider) {
        $stateProvider.state('docs', {
            parent: 'admin',
            url: '/docs',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'global.menu.admin.apidocs'
            },
            views: {
                'content': {
                    templateUrl: 'app/admin/docs/docs.html'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', function ($translate) {
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('platformApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('jhi-configuration', {
            parent: 'admin',
            url: '/configuration',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'configuration.title'
            },
            views: {
                'content': {
                    templateUrl: 'app/admin/configuration/configuration.html',
                    controller: 'JhiConfigurationController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('configuration');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('platformApp')
        .factory('JhiConfigurationService', JhiConfigurationService);

    JhiConfigurationService.$inject = ['$filter', '$http'];

    function JhiConfigurationService ($filter, $http) {
        var service = {
            get: get,
            getEnv: getEnv
        };

        return service;

        function get () {
            return $http.get('management/configprops').then(getConfigPropsComplete);

            function getConfigPropsComplete (response) {
                var properties = [];
                angular.forEach(response.data, function (data) {
                    properties.push(data);
                });
                var orderBy = $filter('orderBy');
                return orderBy(properties, 'prefix');
            }
        }

        function getEnv () {
            return $http.get('management/env').then(getEnvComplete);

            function getEnvComplete (response) {
                var properties = {};
                angular.forEach(response.data, function (val,key) {
                    var vals = [];
                    angular.forEach(val, function (v,k) {
                        vals.push({ key:k, val:v });
                    });
                    properties[key] = vals;
                });
                return properties;
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('platformApp')
        .controller('JhiConfigurationController', JhiConfigurationController);

    JhiConfigurationController.$inject = ['$filter','JhiConfigurationService'];

    function JhiConfigurationController (filter,JhiConfigurationService) {
        var vm = this;

        vm.allConfiguration = null;
        vm.configuration = null;

        JhiConfigurationService.get().then(function(configuration) {
            vm.configuration = configuration;
        });
        JhiConfigurationService.getEnv().then(function (configuration) {
            vm.allConfiguration = configuration;
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('platformApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('audits', {
            parent: 'admin',
            url: '/audits',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'audits.title'
            },
            views: {
                'content': {
                    templateUrl: 'app/admin/audits/audits.html',
                    controller: 'AuditsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('audits');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('platformApp')
        .factory('AuditsService', AuditsService);

    AuditsService.$inject = ['$resource'];

    function AuditsService ($resource) {
        var service = $resource('management/audits/:id', {}, {
            'get': {
                method: 'GET',
                isArray: true
            },
            'query': {
                method: 'GET',
                isArray: true,
                params: {fromDate: null, toDate: null}
            }
        });

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('platformApp')
        .controller('AuditsController', AuditsController);

    AuditsController.$inject = ['$filter', 'AuditsService', 'ParseLinks'];

    function AuditsController ($filter, AuditsService, ParseLinks) {
        var vm = this;

        vm.audits = null;
        vm.fromDate = null;
        vm.links = null;
        vm.loadPage = loadPage;
        vm.onChangeDate = onChangeDate;
        vm.page = 1;
        vm.previousMonth = previousMonth;
        vm.toDate = null;
        vm.today = today;
        vm.totalItems = null;

        vm.today();
        vm.previousMonth();
        vm.onChangeDate();

        function onChangeDate () {
            var dateFormat = 'yyyy-MM-dd';
            var fromDate = $filter('date')(vm.fromDate, dateFormat);
            var toDate = $filter('date')(vm.toDate, dateFormat);

            AuditsService.query({page: vm.page -1, size: 20, fromDate: fromDate, toDate: toDate}, function(result, headers){
                vm.audits = result;
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
            });
        }

        // Date picker configuration
        function today () {
            // Today + 1 day - needed if the current day must be included
            var today = new Date();
            vm.toDate = new Date(today.getFullYear(), today.getMonth(), today.getDate() + 1);
        }

        function previousMonth () {
            var fromDate = new Date();
            if (fromDate.getMonth() === 0) {
                fromDate = new Date(fromDate.getFullYear() - 1, 11, fromDate.getDate());
            } else {
                fromDate = new Date(fromDate.getFullYear(), fromDate.getMonth() - 1, fromDate.getDate());
            }

            vm.fromDate = fromDate;
        }

        function loadPage (page) {
            vm.page = page;
            vm.onChangeDate();
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('platformApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig ($stateProvider) {
        $stateProvider.state('admin', {
            abstract: true,
            parent: 'app'
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('platformApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('settings', {
            parent: 'account',
            url: '/settings',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.menu.account.settings'
            },
            views: {
                'content': {
                    templateUrl: 'app/account/settings/settings.html',
                    controller: 'SettingsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('settings');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('platformApp')
        .controller('SettingsController', SettingsController);

    SettingsController.$inject = ['Principal', 'Auth', 'JhiLanguageService', '$translate'];

    function SettingsController (Principal, Auth, JhiLanguageService, $translate) {
        var vm = this;

        vm.error = null;
        vm.save = save;
        vm.settingsAccount = null;
        vm.success = null;

        /**
         * Store the "settings account" in a separate variable, and not in the shared "account" variable.
         */
        var copyAccount = function (account) {
            return {
                activated: account.activated,
                email: account.email,
                firstName: account.firstName,
                langKey: account.langKey,
                lastName: account.lastName,
                login: account.login
            };
        };

        Principal.identity().then(function(account) {
            vm.settingsAccount = copyAccount(account);
        });

        function save () {
            Auth.updateAccount(vm.settingsAccount).then(function() {
                vm.error = null;
                vm.success = 'OK';
                Principal.identity(true).then(function(account) {
                    vm.settingsAccount = copyAccount(account);
                });
                JhiLanguageService.getCurrent().then(function(current) {
                    if (vm.settingsAccount.langKey !== current) {
                        $translate.use(vm.settingsAccount.langKey);
                    }
                });
            }).catch(function() {
                vm.success = null;
                vm.error = 'ERROR';
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('platformApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('requestReset', {
            parent: 'account',
            url: '/reset/request',
            data: {
                authorities: []
            },
            views: {
                'navbar@': {
                    templateUrl: 'app/account/reset/request/reset.request.html',
                    controller: 'RequestResetController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('reset');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function () {
    "use strict";

    angular.module("platformApp").controller("RequestResetController", RequestResetController);

    RequestResetController.$inject = [
        "$timeout",
        "Auth",
        "errorConstants",
        "$scope",
        "MessageService",
        "Verify",
        "$interval",
        "FrontUser",
        "$state"
    ];

    function RequestResetController(
        $timeout,
        Auth,
        errorConstants,
        $scope,
        MessageService,
        Verify,
        $interval,
        FrontUser,
        $state
    ) {
        var vm = this;

        vm.error = null;
        vm.resetPassword = resetPassword;
        $scope.paracont = "获取验证码";
        vm.success = null;
        vm.checkCode = false;
        //密码框类型
        vm.passType = "password";
        vm.confirmPassType = "password";
        //手机号校验错误状态
        vm.checkPhoneErr = false;
        var timer = null;

        $scope.checkVerifyCode = function () {
            if (vm.registerAccount.code.length <= 5) {
                return;
            }
            Verify.checkVerifyCode(
                {
                    tel: vm.registerAccount.phone,
                    code: vm.registerAccount.code,
                    incident: "忘记密码"
                },
                function (msg) {
                    if (msg.status == 200 && msg.message == true) {
                        vm.checkCode = true;
                    } else {
                        vm.checkCode = false;
                        MessageService.error("手机验证失败");
                    }
                },
                function () {
                    vm.checkCode = false;
                    MessageService.error("手机验证失败");
                }
            );
        };

        $scope.changePhone = function () {
            vm.checkPhoneErr = false;
        };
        //更改密码框类型
        $scope.changePassType = function (passType, type) {
            vm[passType] = type;
        };

        $scope.getVerifyCode = function () {
            if (vm.disabled) {
                return;
            }
            if (vm.registerAccount.phone == null || vm.registerAccount.phone == "") {
                MessageService.error("请先输入手机号码");
                return;
            }
            var flag = checkPhone(vm.registerAccount.phone);
            if (!flag) {
                vm.checkPhoneErr = true;
                return MessageService.error("您的手机号不合规，请检查重新输入");
            }
            vm.countdown = 120;
            // 发送验证码到手机
            Verify.getVerifyCode(
                {
                    tel: vm.registerAccount.phone,
                    incident: "忘记密码"
                },
                function (msg) {
                    clearInterval(timer);
                    timer = $interval(function () {
                        if (vm.countdown > 0) {
                            vm.disabled = true;
                            vm.countdown--;
                            $scope.paracont = vm.countdown + "s";
                        } else {
                            vm.disabled = false;
                            $interval.cancel(timer);
                            $scope.paracont = "重发验证码";
                        }
                    }, 1000);
                }
            );
        };

        function resetPassword() {
            vm.error = null;
            if (vm.registerAccount.name == null || vm.registerAccount.name == "") {
                return MessageService.error("账号不能为空");
            }
            if (vm.registerAccount.password && vm.registerAccount.password.length < 5) {
                return MessageService.error("密码至少有五个字符");
            }
            if (vm.registerAccount.password !== vm.confirmPassword) {
                return MessageService.error("两次输入的密码不一致，请重新输入");
            }
            if (!vm.checkCode) {
                return MessageService.error("手机号验证失败，请重试");
            }
            var postData = {
                phone: vm.registerAccount.phone,
                password: vm.registerAccount.password
            };
            FrontUser.forgetPassword(
                postData,
                function (data) {
                    MessageService.success("密码重置成功，请使用新密码登录");
                    $state.go("home");
                },
                function () {
                    MessageService.error("重置密码失败，请稍后再试");
                }
            );
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('platformApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('finishReset', {
            parent: 'account',
            url: '/reset/finish?key',
            data: {
                authorities: []
            },
            views: {
                'content': {
                    templateUrl: 'app/account/reset/finish/reset.finish.html',
                    controller: 'ResetFinishController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('reset');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('platformApp')
        .controller('ResetFinishController', ResetFinishController);

    ResetFinishController.$inject = ['$stateParams', '$timeout', 'Auth', 'LoginService'];

    function ResetFinishController ($stateParams, $timeout, Auth, LoginService) {
        var vm = this;

        vm.keyMissing = angular.isUndefined($stateParams.key);
        vm.confirmPassword = null;
        vm.doNotMatch = null;
        vm.error = null;
        vm.finishReset = finishReset;
        vm.login = LoginService.open;
        vm.resetAccount = {};
        vm.success = null;

        $timeout(function (){angular.element('#password').focus();});

        function finishReset() {
            vm.doNotMatch = null;
            vm.error = null;
            if (vm.resetAccount.password !== vm.confirmPassword) {
                vm.doNotMatch = 'ERROR';
            } else {
                Auth.resetPasswordFinish({key: $stateParams.key, newPassword: vm.resetAccount.password}).then(function () {
                    vm.success = 'OK';
                }).catch(function () {
                    vm.success = null;
                    vm.error = 'ERROR';
                });
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('platformApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('register', {
            parent: 'account',
            url: '/register',
            data: {
                authorities: [],
                pageTitle: 'register.title'
            },
            views: {
                'navbar@': {
                    templateUrl: 'app/account/register/register.html',
                    controller: 'RegisterController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('register');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('platformApp')
        .controller('RegisterController', RegisterController);


    RegisterController.$inject = ['$translate', '$timeout', 'Auth', 'LoginService', 'errorConstants', 'Verify',
    'MessageService', '$scope', '$interval', '$state', 'FrontUser'];

    function RegisterController ($translate, $timeout, Auth, LoginService, errorConstants, Verify,
        MessageService, $scope, $interval, $state, FrontUser) {
        var vm = this;

        vm.doNotMatch = null;
        vm.error = null;
        vm.errorUserExists = null;
        vm.login = LoginService.open;
        vm.register = register;
        vm.registerAccount = {};
        vm.success = null;
        vm.checkCode = false;
        vm.disabled = false;
        //密码框类型
        vm.passType = "password";
        vm.confirmPassType = "password";
        //手机号校验错误状态
        vm.checkPhoneErr = false;
        $scope.paracont = "获取验证码";
        var timer = null;
        $(".navbar").hide();
        $(".wrap").css({margin:0})
        vm.bottom =(window.innerHeight-parseFloat($(".register-content").css('height'))-parseFloat($(".register-all").css('top')))/2;
        console.log($scope,111)
        $scope.getVerifyCode = function () {
            if (vm.disabled) {
                return;
            }
            if (vm.registerAccount.phone == null || vm.registerAccount.phone == "") {
                vm.checkPhoneErr = true;
                MessageService.error("请先输入手机号码");
                return;
            }

            var flag = checkPhone(vm.registerAccount.phone);
            if(!flag){
                vm.checkPhoneErr = true;
                return MessageService.error('您的手机号不合规，请检查重新输入');
            }
            $scope.checkPhone(function(){
                vm.countdown = 120;
                // 发送验证码到手机
                Verify.getVerifyCode({
                    tel: vm.registerAccount.phone,
                    incident: "用户注册"
                }, function (msg) {
                    clearInterval(timer);
                    timer = $interval(function () {
                        if (vm.countdown > 0) {
                            vm.disabled = true;
                            vm.countdown -- ;
                            $scope.paracont = vm.countdown + 's';
                        } else {
                            vm.disabled = false;
                            $interval.cancel(timer);
                            $scope.paracont = "重发验证码";
                        }
                    }, 1000);
                });
            })
        };
        $scope.changePhone = function(){
            vm.checkPhoneErr = false;
        }
        $scope.checkVerifyCode = function(){
            if (vm.registerAccount.code.length<=5) {
                return;
            }
            Verify.checkVerifyCode({
                tel: vm.registerAccount.phone,
                code: vm.registerAccount.code,
                incident: "用户注册"
            }, function (msg) {
                if (msg.status == 200 && msg.message==true) {
                    vm.checkCode = true;
                }else{
                   MessageService.error("手机验证失败");
                }
            },function(){
                MessageService.error("手机验证失败");
            });
        }


        $timeout(function (){angular.element('#login').focus();});

        $scope.checkUser = function(){
            if (vm.registerAccount.name == null || vm.registerAccount.name == "") {
                return;
            }
            FrontUser.checkUser({
                items: [{ key: "name", op: "=", value:vm.registerAccount.name}]
            }, function(data) {
                if (data.length > 0) {
                    MessageService.error("该账号已经存在，请选择其他用户名");
                } else {
                    MessageService.info("账号可用");
                }
            });
        }

        $scope.checkPhone = function(callback){
            if (vm.registerAccount.phone == null || vm.registerAccount.phone == "") {
                return;
            }
            FrontUser.checkUser({
                items: [{ key: "phone", op: "=", value:vm.registerAccount.phone}, { key: "cancelled", op: "=", value:"false"}, { key: "status", op: "!=", value:"Rejected"}]
            }, function(data) {
                if (data.length > 0) {
                    MessageService.error("该手机号已经存在，请选择其他手机号");
                } else {
                    // MessageService.info("手机号可用");
                    // vm.disabled = false;
                    if(typeof callback === 'function'){
                        callback();
                    }
                }
            })
        }
        //更改密码框类型
        $scope.changePassType = function(passType,type){
            vm[passType] = type;
        }
        function register () {
            if(vm.registerAccount.name == null || vm.registerAccount.name == ""){
                return MessageService.error("账号不能为空");
            }
            if(!checkUserName(vm.registerAccount.name)){
                return MessageService.error("账号只能使用字母以及数字");
            }
            if(vm.registerAccount.password && vm.registerAccount.password.length < 5){
                return MessageService.error('密码至少有五个字符');
            }
            if (vm.registerAccount.password !== vm.confirmPassword) {
                return MessageService.error("两次输入的密码不一致，请重新输入");
            }
            vm.registerAccount.langKey = $translate.use();
            vm.doNotMatch = null;
            vm.error = null;
            vm.errorUserExists = null;
            vm.errorEmailExists = null;
            Verify.checkVerifyCode({
                tel: vm.registerAccount.phone,
                code: vm.registerAccount.code,
                incident: "用户注册"
            }, function (msg) {
                if (msg.status == 200 && msg.message==true) {
                    Auth.createAccount(vm.registerAccount).then(function () {
                        vm.success = 'OK';
                        MessageService.success("注册成功，管理员审核后，将短信通知您");
                        $state.go("home");
                    }).catch(function (response) {
                        vm.success = null;
                        if (response.status === 400 &&  response.data === "name or phone already in use") {
                            MessageService.error("注册失败，用户名或手机号已经被使用，请更换后重新注册");
                        } else if (response.status === 400 && angular.fromJson(response.data).type === errorConstants.EMAIL_ALREADY_USED_TYPE) {
                            vm.errorEmailExists = 'ERROR';
                        } else {
                            vm.error = 'ERROR';
                        }
                    });
                }else{
                    MessageService.error("手机验证失败");
                }
            },function(){
                MessageService.error("手机验证失败");
            });
        }
    }
})();

/* globals $ */
(function() {
    'use strict';

    angular
        .module('platformApp')
        .directive('passwordStrengthBar', passwordStrengthBar);

    function passwordStrengthBar () {
        var directive = {
            replace: true,
            restrict: 'E',
            template: '<div id="strength">' +
                '<small data-translate="global.messages.validate.newpassword.strength" style="color: #89919D">Password strength:</small>' +
                '<ul id="strengthBar">' +
                '<li class="point"></li><li class="point"></li><li class="point"></li><li class="point"></li><li class="point"></li>' +
                '</ul>' +
                '</div>',
            scope: {
                passwordToCheck: '='
            },
            link: linkFunc
        };

        return directive;

        /* private helper methods*/

        function linkFunc(scope, iElement) {
            var strength = {
                colors: ['#F00', '#F90', '#FF0', '#9F0', '#0F0'],
                mesureStrength: function (p) {

                    var _force = 0;
                    var _regex = /[$-/:-?{-~!"^_`\[\]]/g; // "

                    var _lowerLetters = /[a-z]+/.test(p);
                    var _upperLetters = /[A-Z]+/.test(p);
                    var _numbers = /[0-9]+/.test(p);
                    var _symbols = _regex.test(p);

                    var _flags = [_lowerLetters, _upperLetters, _numbers, _symbols];
                    var _passedMatches = $.grep(_flags, function (el) {
                        return el === true;
                    }).length;

                    _force += 2 * p.length + ((p.length >= 10) ? 1 : 0);
                    _force += _passedMatches * 10;

                    // penalty (short password)
                    _force = (p.length <= 6) ? Math.min(_force, 10) : _force;

                    // penalty (poor variety of characters)
                    _force = (_passedMatches === 1) ? Math.min(_force, 10) : _force;
                    _force = (_passedMatches === 2) ? Math.min(_force, 20) : _force;
                    _force = (_passedMatches === 3) ? Math.min(_force, 40) : _force;

                    return _force;

                },
                getColor: function (s) {

                    var idx;
                    if (s <= 10) {
                        idx = 0;
                    }
                    else if (s <= 20) {
                        idx = 1;
                    }
                    else if (s <= 30) {
                        idx = 2;
                    }
                    else if (s <= 40) {
                        idx = 3;
                    }
                    else {
                        idx = 4;
                    }

                    return { idx: idx + 1, col: this.colors[idx] };
                }
            };
            scope.$watch('passwordToCheck', function (password) {
                console.log(password)
                if (password) {
                    var c = strength.getColor(strength.mesureStrength(password));
                    iElement.removeClass('ng-hide');
                    iElement.find('ul').children('li')
                        .css({ 'background-color': '#DDD' })
                        .slice(0, c.idx)
                        .css({ 'background-color': c.col });
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('platformApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('password', {
            parent: 'account',
            url: '/password',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.menu.account.password'
            },
            views: {
                'content': {
                    templateUrl: 'app/account/password/password.html',
                    controller: 'PasswordController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('password');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function () {
    "use strict";

    angular.module("platformApp").controller("PasswordController", PasswordController);

    PasswordController.$inject = [
        "Auth",
        "Principal",
        "$scope",
        "FrontUser",
        "MessageService",
        "$state",
        "$uibModalInstance"
    ];

    function PasswordController(Auth, Principal, $scope, FrontUser, MessageService, $state, $uibModalInstance) {
        var vm = this;

        vm.changePassword = changePassword;
        vm.doNotMatch = null;
        vm.error = null;
        vm.success = null;

        Principal.identity().then(function (account) {
            vm.account = account;
        });

        $scope.getBtnDisabledState = function () {
            if (vm.oldpassword && vm.password && vm.confirmPassword) {
                return false;
            } else {
                return true;
            }
        };

        $scope.inputChange = function () {
            vm.oldpasswordError = "";
            vm.passwordError = "";
            vm.confirmPasswordError = "";
        };
        function changePassword() {
            vm.oldpasswordError = "";
            vm.passwordError = "";
            vm.confirmPasswordError = "";
            if (!vm.oldpassword) {
                vm.oldpasswordError = "旧密码不能为空";
                return;
            }
            if (!vm.password || vm.password.length < 5) {
                vm.passwordError = "新密码不能小于5个字符";
                return;
            }
            if (vm.password !== vm.confirmPassword) {
                vm.confirmPasswordError = "新密码和密码确认不一致，请重新输入";
                return;
            }
            vm.doNotMatch = null;
            FrontUser.checkPassword(
                { id: vm.account.id, password: vm.oldpassword },
                function (data) {
                    if (data.status != 200) {
                        vm.oldpasswordError = "旧密码输入错误";
                    } else {
                        FrontUser.changePassword(
                            { id: vm.account.id, oldPassword: vm.oldpassword, password: vm.password },
                            function (data) {
                                MessageService.success("修改密码成功，请重新登录");
                                Auth.logout();
                                $state.go("home");
                                $uibModalInstance.dismiss("cancel");
                            },
                            function () {
                                MessageService.error("修改密码失败");
                            }
                        );
                    }
                },
                function () {
                    vm.oldpasswordError = "旧密码输入错误";
                }
            );
        }
        vm.cancel = function () {
            $uibModalInstance.dismiss();
        };
    }
})();

(function() {
    'use strict';

    angular
        .module('platformApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('activate', {
            parent: 'account',
            url: '/activate?key',
            data: {
                authorities: [],
                pageTitle: 'activate.title'
            },
            views: {
                'content': {
                    templateUrl: 'app/account/activate/activate.html',
                    controller: 'ActivationController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('activate');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('platformApp')
        .controller('ActivationController', ActivationController);

    ActivationController.$inject = ['$stateParams', 'Auth', 'LoginService'];

    function ActivationController ($stateParams, Auth, LoginService) {
        var vm = this;

        Auth.activateAccount({key: $stateParams.key}).then(function () {
            vm.error = null;
            vm.success = 'OK';
        }).catch(function () {
            vm.success = null;
            vm.error = 'ERROR';
        });

        vm.login = LoginService.open;
    }
})();

(function() {
    'use strict';

    angular
        .module('platformApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('account', {
            abstract: true,
            parent: 'app'
        });
    }
})();
(function(){angular.module('platformApp').run(['$templateCache', function($templateCache) {$templateCache.put('app/home/home.html','<div ng-cloak class="login_wrap"><div class="login_content"><div class="login_bg"></div><div class="login_box"><div class="login_logo"><img src="content/images/logo.png" alt=""></div><div class="login_title">\u8D26\u6237\u767B\u5F55</div><form class="login_form" ng-submit="vm.login($event)"><div class="form_item mb16"><i class="iconfont icon-zhanghao input_icon left"></i> <input name="username" ng-model="vm.username" class="icon_left" type="text" placeholder="\u8BF7\u8F93\u5165\u8D26\u53F7"></div><div class="form_item mb32"><i class="iconfont icon-mima1 input_icon left"></i> <input name="password" ng-model="vm.password" class="icon_left icon_right" type="{{vm.passType}}" placeholder="\u8BF7\u8F93\u5165\u5BC6\u7801"> <i class="iconfont icon-yanjing-biyan input_icon right pointer" ng-if="vm.password && vm.passType == \'password\'" ng-click="vm.changePassType(\'text\')"></i> <i class="iconfont icon-yanjing-zhengyan input_icon right pointer" ng-if="vm.password && vm.passType == \'text\'" ng-click="vm.changePassType(\'password\')"></i></div><div class="form_item mb16"><button type="submit">\u767B\u5F55</button></div><div class="footer_link"><a ui-sref="register">\u6CE8\u518C\u8D26\u53F7</a> <a ui-sref="requestReset" style="color:#89919D">\u5FD8\u8BB0\u5BC6\u7801</a></div></form></div><div class="company_info">Powered By MomentsGo</div></div></div>');
$templateCache.put('app/account/activate/activate.html','<div><div class="row"><div class="col-md-8 col-md-offset-2"><h1 data-translate="activate.title">Activation</h1><div class="alert alert-success" ng-show="vm.success" data-translate="activate.messages.success" translate-compile><strong>Your user has been activated.</strong> Please <a class="alert-link" href="" ng-click="vm.login()">sign in</a>.</div><div class="alert alert-danger" ng-show="vm.error" data-translate="activate.messages.error"><strong>Your user could not be activated.</strong> Please use the registration form to sign up.</div></div></div></div>');
$templateCache.put('app/account/password/password.html','<div class="c-model"><div class="c-model-head"><div class="c-model-head-title">\u4FEE\u6539\u5BC6\u7801</div><i class="iconfont icon-closeicon1" ng-click="vm.cancel()"></i></div><div class="c-model-body"><div class="c-model-body-view"><div class="pw-view" ng-class="{\'errorView\' : vm.oldpasswordError}"><div class="pw-title"><span>\u65E7\u5BC6\u7801\uFF1A</span> <span class="errorText">{{vm.oldpasswordError}}</span></div><div class="pw-input"><input type="{{!vm.oldpasswordHide?\'password\':\'text\'}}" placeholder="\u8BF7\u8F93\u5165\u65E7\u5BC6\u7801" ng-model="vm.oldpassword" ng-change="inputChange()"> <i class="iconfont icon-yanjing-biyan" ng-if="!vm.oldpasswordHide && vm.oldpassword" ng-click="vm.oldpasswordHide=true"></i> <i class="iconfont icon-yanjing-zhengyan" ng-if="vm.oldpasswordHide && vm.oldpassword" ng-click="vm.oldpasswordHide=false"></i></div></div><div class="pw-view" ng-class="{\'errorView\' : vm.passwordError}"><div class="pw-title"><span>\u65B0\u5BC6\u7801\uFF1A</span> <span class="errorText">{{vm.passwordError}}</span></div><div class="pw-input" style="margin-bottom: 10px"><input type="{{!vm.passwordHide?\'password\':\'text\'}}" placeholder="\u8BF7\u8F93\u5165\u65B0\u5BC6\u7801" ng-model="vm.password" ng-change="inputChange()"> <i class="iconfont icon-yanjing-biyan" ng-if="!vm.passwordHide && vm.password" ng-click="vm.passwordHide=true"></i> <i class="iconfont icon-yanjing-zhengyan" ng-if="vm.passwordHide && vm.password" ng-click="vm.passwordHide=false"></i></div><password-strength-bar password-to-check="vm.password"></password-strength-bar></div><div class="pw-view" ng-class="{\'errorView\' : vm.confirmPasswordError}" style="margin-bottom: 0"><div class="pw-title"><span>\u65B0\u5BC6\u7801\u786E\u8BA4\uFF1A</span> <span class="errorText">{{vm.confirmPasswordError}}</span></div><div class="pw-input"><input type="{{!vm.confirmPasswordHide?\'password\':\'text\'}}" placeholder="\u8BF7\u518D\u6B21\u8F93\u5165\u65B0\u5BC6\u7801" ng-model="vm.confirmPassword" ng-change="inputChange()"> <i class="iconfont icon-yanjing-biyan" ng-if="!vm.confirmPasswordHide && vm.confirmPassword" ng-click="vm.confirmPasswordHide=true"></i> <i class="iconfont icon-yanjing-zhengyan" ng-if="vm.confirmPasswordHide && vm.confirmPassword" ng-click="vm.confirmPasswordHide=false"></i></div></div></div></div><div class="c-model-foot" style="text-align: center"><button type="button" style="padding: 0;width: 160px" ng-disabled="getBtnDisabledState()" class="btn btn-info btn-max" data-translate="password.form.button" ng-click="vm.changePassword()">Save</button></div></div>');
$templateCache.put('app/account/register/register.html','<div class="register_wrap"><div class="register_content"><div class="register_bg"></div><div class="register_box"><div class="register_title">\u8D26\u6237\u6CE8\u518C</div><form class="register_form" ng-submit="vm.register()"><div class="form_item mb16"><i class="iconfont icon-zhanghao input_icon left"></i> <input ng-model="vm.registerAccount.name" maxlength="50" ng-blur="checkUser()" class="icon_left" type="text" placeholder="\u8BF7\u8F93\u5165\u8D26\u53F7"></div><div class="form_item mb16"><i class="iconfont icon-mima1 input_icon left"></i> <input ng-model="vm.registerAccount.password" maxlength="50" class="icon_left icon_right" type="{{vm.passType}}" placeholder="\u8BF7\u8F93\u5165\u65B0\u5BC6\u7801"> <i class="iconfont icon-yanjing-biyan input_icon right pointer" ng-if="vm.registerAccount.password && vm.passType == \'password\'" ng-click="changePassType(\'passType\',\'text\')"></i> <i class="iconfont icon-yanjing-zhengyan input_icon right pointer" ng-if="vm.registerAccount.password && vm.passType == \'text\'" ng-click="changePassType(\'passType\',\'password\')"></i></div><div class="form_item mb16"><i class="iconfont icon-mima1 input_icon left"></i> <input ng-model="vm.confirmPassword" maxlength="50" class="icon_left icon_right" type="{{vm.confirmPassType}}" placeholder="\u8BF7\u518D\u6B21\u8F93\u5165\u65B0\u5BC6\u7801"> <i class="iconfont icon-yanjing-biyan input_icon right pointer" ng-if="vm.confirmPassword && vm.confirmPassType == \'password\'" ng-click="changePassType(\'confirmPassType\',\'text\')"></i> <i class="iconfont icon-yanjing-zhengyan input_icon right pointer" ng-if="vm.confirmPassword && vm.confirmPassType == \'text\'" ng-click="changePassType(\'confirmPassType\',\'password\')"></i></div><div class="form_item mb16"><i class="iconfont icon-gerenxinxi input_icon left"></i> <input ng-model="vm.registerAccount.realName" class="icon_left" type="text" placeholder="\u8BF7\u8F93\u5165\u771F\u5B9E\u59D3\u540D"></div><div class="form_item mb16"><i class="iconfont icon-qiye input_icon left"></i> <input ng-model="vm.registerAccount.companyName" class="icon_left" type="text" placeholder="\u8BF7\u8F93\u5165\u6240\u5C5E\u516C\u53F8"></div><div class="form_item send_code mb16"><i class="iconfont icon-shouji1 input_icon left"></i> <input ng-model="vm.registerAccount.phone" class="icon_left" ng-class="{\'checkErr\' : vm.checkPhoneErr}" type="text" placeholder="\u8BF7\u8F93\u5165\u624B\u673A\u53F7" ng-change="changePhone()"> <a class="btn_code pointer" ng-class="{\'disabled\' : vm.disabled}" ng-click="getVerifyCode()" ng-disabled="vm.disabled" ng-bind="paracont"></a></div><div class="form_item mb32"><i class="iconfont icon-yanzhengma1 input_icon left"></i> <input ng-model="vm.registerAccount.code" ng-change="checkVerifyCode()" class="icon_left" type="text" placeholder="\u8BF7\u8F93\u5165\u9A8C\u8BC1\u7801"></div><div class="form_item mb16"><button type="submit">\u6CE8\u518C</button></div><div class="footer_link"><a ui-sref="home">\u5DF2\u6709\u8D26\u6237\uFF0C\u8FD4\u56DE\u767B\u5F55</a></div></form></div><div class="company_info">Powered By MomentsGo</div></div></div>');
$templateCache.put('app/account/settings/settings.html','<div><div class="row"><div class="col-md-8 col-md-offset-2"><h2 data-translate="settings.title" translate-values="{username: \'{{vm.settingsAccount.login}}\'}">User settings for [<b>{{vm.settingsAccount.login}}</b>]</h2><div class="alert alert-success" ng-show="vm.success" data-translate="settings.messages.success"><strong>Settings saved!</strong></div><jhi-alert-error></jhi-alert-error><form name="form" role="form" novalidate ng-submit="vm.save()" show-validation><div class="form-group"><label class="control-label" for="firstName" data-translate="settings.form.firstname">First Name</label><input type="text" class="form-control" id="firstName" name="firstName" placeholder="{{\'settings.form.firstname.placeholder\' | translate}}" ng-model="vm.settingsAccount.firstName" ng-minlength="1" ng-maxlength="50" required maxlength="50"><div ng-show="form.firstName.$dirty && form.firstName.$invalid"><p class="help-block" ng-show="form.firstName.$error.required" data-translate="settings.messages.validate.firstname.required">Your first name is required.</p><p class="help-block" ng-show="form.firstName.$error.minlength" data-translate="settings.messages.validate.firstname.minlength">Your first name is required to be at least 1 character.</p><p class="help-block" ng-show="form.firstName.$error.maxlength" data-translate="settings.messages.validate.firstname.maxlength">Your first name cannot be longer than 50 characters.</p></div></div><div class="form-group"><label class="control-label" for="lastName" data-translate="settings.form.lastname">Last Name</label><input type="text" class="form-control" id="lastName" name="lastName" placeholder="{{\'settings.form.lastname.placeholder\' | translate}}" ng-model="vm.settingsAccount.lastName" ng-minlength="1" ng-maxlength="50" required maxlength="50"><div ng-show="form.lastName.$dirty && form.lastName.$invalid"><p class="help-block" ng-show="form.lastName.$error.required" data-translate="settings.messages.validate.lastname.required">Your last name is required.</p><p class="help-block" ng-show="form.lastName.$error.minlength" data-translate="settings.messages.validate.lastname.minlength">Your last name is required to be at least 1 character.</p><p class="help-block" ng-show="form.lastName.$error.maxlength" data-translate="settings.messages.validate.lastname.maxlength">Your last name cannot be longer than 50 characters.</p></div></div><div class="form-group"><label class="control-label" for="email" data-translate="global.form.email">Email</label><input type="email" class="form-control" id="email" name="email" placeholder="{{\'global.form.email.placeholder\' | translate}}" ng-model="vm.settingsAccount.email" ng-minlength="5" ng-maxlength="100" required maxlength="100"><div ng-show="form.email.$dirty && form.email.$invalid"><p class="help-block" ng-show="form.email.$error.required" data-translate="global.messages.validate.email.required">Your email is required.</p><p class="help-block" ng-show="form.email.$error.email" data-translate="global.messages.validate.email.invalid">Your email is invalid.</p><p class="help-block" ng-show="form.email.$error.minlength" data-translate="global.messages.validate.email.minlength">Your email is required to be at least 5 characters.</p><p class="help-block" ng-show="form.email.$error.maxlength" data-translate="global.messages.validate.email.maxlength">Your email cannot be longer than 100 characters.</p></div></div><div class="form-group"><label for="langKey" data-translate="settings.form.language">Language</label><select id="langKey" name="langKey" class="form-control" ng-model="vm.settingsAccount.langKey" ng-controller="JhiLanguageController as languageVm" ng-options="code as (code | findLanguageFromKey) for code in languageVm.languages"></select></div><button type="submit" ng-disabled="form.$invalid" class="btn btn-primary" data-translate="settings.form.button">Save</button></form></div></div></div>');
$templateCache.put('app/admin/audits/audits.html','<div><h2 data-translate="audits.title">Audits</h2><div class="row"><div class="col-md-5"><h4 data-translate="audits.filter.title">Filter by date</h4><p class="input-group"><span class="input-group-addon" data-translate="audits.filter.from">from</span> <input type="date" class="input-sm form-control" name="start" ng-model="vm.fromDate" ng-change="vm.onChangeDate()" required> <span class="input-group-addon" data-translate="audits.filter.to">to</span> <input type="date" class="input-sm form-control" name="end" ng-model="vm.toDate" ng-change="vm.onChangeDate()" required></p></div></div><table class="table table-condensed table-striped table-bordered table-responsive"><thead><tr><th ng-click="predicate = \'timestamp\'; reverse=!reverse"><span data-translate="audits.table.header.date">Date</span></th><th ng-click="predicate = \'principal\'; reverse=!reverse"><span data-translate="audits.table.header.principal">User</span></th><th ng-click="predicate = \'type\'; reverse=!reverse"><span data-translate="audits.table.header.status">State</span></th><th ng-click="predicate = \'data.message\'; reverse=!reverse"><span data-translate="audits.table.header.data">Extra data</span></th></tr></thead><tr ng-repeat="audit in vm.audits | filter:filter | orderBy:predicate:reverse" ng-hide="audit.filtered"><td><span>{{audit.timestamp| date:\'medium\'}}</span></td><td><small>{{audit.principal}}</small></td><td>{{audit.type}}</td><td><span ng-show="audit.data.message">{{audit.data.message}}</span> <span ng-show="audit.data.remoteAddress"><span data-translate="audits.table.data.remoteAddress">Remote Address</span> {{audit.data.remoteAddress}}</span></td></tr></table><div class="text-center"><uib-pagination class="pagination-sm" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.loadPage(vm.page)"></uib-pagination></div></div>');
$templateCache.put('app/admin/configuration/configuration.html','<div><h2 data-translate="configuration.title">Configuration</h2><span data-translate="configuration.filter">Filter (by prefix)</span> <input type="text" ng-model="filter" class="form-control"><h3 ng-hide="filteredConfig.length === 0">Spring configuration</h3><table class="table table-condensed table-striped table-bordered table-responsive" style="table-layout:fixed" ng-hide="filteredConfig.length === 0"><thead><tr><th ng-click="predicate = \'prefix\'; reverse=!reverse" class="col-sm-4"><span data-translate="configuration.table.prefix">Prefix</span></th><th data-translate="configuration.table.properties" class="col-sm-8">Properties</th></tr></thead><tr ng-repeat="entry in filtered = (vm.configuration | filter:filter | orderBy:predicate:reverse)"><td><span>{{entry.prefix}}</span></td><td><div class="row" ng-repeat="(key, value) in entry.properties"><div class="col-md-4">{{key}}</div><div class="col-md-8"><span class="pull-right label label-success break">{{value}}</span></div></div></td></tr></table><div ng-repeat="(key, value) in vm.allConfiguration"><h4 ng-hide="filtered.length === 0"><span>{{key}}</span></h4><table class="table table-condensed table-striped table-bordered table-responsive" style="table-layout:fixed" ng-hide="filtered.length === 0"><thead><tr><th class="col-sm-4">Property</th><th class="col-sm-8">Value</th></tr></thead><tbody><tr ng-repeat="item in filtered = (value | filter:filter)"><td class="break">{{item.key}}</td><td class="break"><span class="pull-right label label-success break">{{item.val}}</span></td></tr></tbody></table></div></div>');
$templateCache.put('app/admin/docs/docs.html','<iframe src="swagger-ui/index.html" frameborder="0" marginheight="0" marginwidth="0" width="100%" height="900" scrolling="auto" target="_top" title="Swagger UI"></iframe>');
$templateCache.put('app/admin/gateway/gateway.html','<div><h2 data-translate="gateway.title">Gateway</h2><h3 data-translate="gateway.routes.title">Current routes</h3><p><button type="button" class="btn btn-primary" ng-click="vm.refresh()" ng-show="vm.updatingRoutes === false"><span class="glyphicon glyphicon-refresh glyphicon-"></span>&nbsp;<span data-translate="gateway.refresh.button">Refresh</span></button> <button type="button" class="btn btn-danger" ng-show="vm.updatingRoutes"><span class="glyphicon glyphicon-refresh"></span>&nbsp;<span data-translate="gateway.refresh.button">Refresh</span></button></p><table class="table table-striped table-responsive"><thead><tr><th data-translate="gateway.routes.url">URL</th><th data-translate="gateway.routes.service">Service</th><th data-translate="gateway.routes.servers">Available servers</th></tr></thead><tr ng-repeat="route in vm.gatewayRoutes"><td>{{route.path}}</td><td>{{route.serviceId}}</td><td><div ng-show="{{route.serviceInstances.length === 0}}" class="label label-danger" data-translate="gateway.routes.error">Warning: no server available!</div><table class="table table-responsive"><tr ng-repeat="instance in route.serviceInstances"><td>{{instance.host}}:{{instance.port}}</td><td ng-show="{{instance.instanceInfo.status === \'UP\'}}"><div class="label label-success">{{instance.instanceInfo.status}}</div></td><td ng-hide="{{instance.instanceInfo.status === \'UP\'}}"><div class="label label-danger">{{instance.instanceInfo.status}}</div></td></tr></table></td></tr></table></div>');
$templateCache.put('app/admin/health/health.html','<div><h2 data-translate="health.title">Health Checks</h2><p><button type="button" class="btn btn-primary" ng-click="vm.refresh()"><span class="glyphicon glyphicon-refresh"></span>&nbsp;<span data-translate="health.refresh.button">Refresh</span></button></p><table id="healthCheck" class="table table-striped"><thead><tr><th class="col-md-7" data-translate="health.table.service">Service Name</th><th class="col-md-2 text-center" data-translate="health.table.status">Status</th><th class="col-md-2 text-center" data-translate="health.details.details">Details</th></tr></thead><tbody><tr ng-repeat="health in vm.healthData"><td>{{\'health.indicator.\' + vm.baseName(health.name) | translate}} {{vm.subSystemName(health.name)}}</td><td class="text-center"><span class="label" ng-class="vm.getLabelClass(health.status)">{{\'health.status.\' + health.status | translate}}</span></td><td class="text-center"><a class="hand" ng-click="vm.showHealth(health)" ng-show="health.details || health.error"><i class="glyphicon glyphicon-eye-open"></i></a></td></tr></tbody></table></div>');
$templateCache.put('app/admin/health/health.modal.html','<div class="modal-header"><button aria-label="Close" data-dismiss="modal" class="close" type="button" ng-click="vm.cancel()"><span aria-hidden="true">&times;</span></button><h4 class="modal-title" id="showHealthLabel">{{\'health.indicator.\' + vm.baseName(vm.currentHealth.name) | translate}} {{vm.subSystemName(vm.currentHealth.name)}}</h4></div><div class="modal-body pad"><div ng-show="vm.currentHealth.details"><h4 data-translate="health.details.properties">Properties</h4><table class="table table-striped"><thead><tr><th class="col-md-6 text-left" data-translate="health.details.name">Name</th><th class="col-md-6 text-left" data-translate="health.details.value">Value</th></tr></thead><tbody><tr ng-repeat="(k,v) in vm.currentHealth.details"><td class="col-md-6 text-left">{{k}}</td><td class="col-md-6 text-left">{{v}}</td></tr></tbody></table></div><div ng-show="vm.currentHealth.error"><h4 data-translate="health.details.error">Error</h4><pre>{{vm.currentHealth.error}}</pre></div></div><div class="modal-footer"><button data-dismiss="modal" class="btn btn-default pull-left" type="button" ng-click="vm.cancel()">Done</button></div>');
$templateCache.put('app/admin/logs/logs.html','<div class="table-responsive"><h2 data-translate="logs.title">Logs</h2><p data-translate="logs.nbloggers" translate-values="{total: \'{{ vm.loggers.length }}\'}">There are {{ vm.loggers.length }} loggers.</p><span data-translate="logs.filter">Filter</span> <input type="text" ng-model="filter" class="form-control"><table class="table table-condensed table-striped table-bordered"><thead><tr title="click to order"><th ng-click="predicate = \'name\'; reverse=!reverse"><span data-translate="logs.table.name">Name</span></th><th ng-click="predicate = \'level\'; reverse=!reverse"><span data-translate="logs.table.level">Level</span></th></tr></thead><tr ng-repeat="logger in vm.loggers | filter:filter | orderBy:predicate:reverse"><td><small>{{logger.name | characters:140}}</small></td><td><button ng-click="vm.changeLevel(logger.name, \'TRACE\')" ng-class="(logger.level==\'TRACE\') ? \'btn-danger\' : \'btn-default\'" class="btn btn-default btn-xs">TRACE</button> <button ng-click="vm.changeLevel(logger.name, \'DEBUG\')" ng-class="(logger.level==\'DEBUG\') ? \'btn-warning\' : \'btn-default\'" class="btn btn-default btn-xs">DEBUG</button> <button ng-click="vm.changeLevel(logger.name, \'INFO\')" ng-class="(logger.level==\'INFO\') ? \'btn-info\' : \'btn-default\'" class="btn btn-default btn-xs">INFO</button> <button ng-click="vm.changeLevel(logger.name, \'WARN\')" ng-class="(logger.level==\'WARN\') ? \'btn-success\' : \'btn-default\'" class="btn btn-default btn-xs">WARN</button> <button ng-click="vm.changeLevel(logger.name, \'ERROR\')" ng-class="(logger.level==\'ERROR\') ? \'btn-primary\' : \'btn-default\'" class="btn btn-default btn-xs">ERROR</button></td></tr></table></div>');
$templateCache.put('app/admin/metrics/metrics.html','<div><h2 data-translate="metrics.title">Application Metrics</h2><p><button type="button" class="btn btn-primary" ng-click="vm.refresh()"><span class="glyphicon glyphicon-refresh"></span>&nbsp;<span data-translate="metrics.refresh.button">Refresh</span></button></p><h3 data-translate="metrics.jvm.title">JVM Metrics</h3><div class="row" ng-hide="vm.updatingMetrics"><div class="col-md-4"><b data-translate="metrics.jvm.memory.title">Memory</b><p><span data-translate="metrics.jvm.memory.total">Total Memory</span> ({{vm.metrics.gauges[\'jvm.memory.total.used\'].value / 1000000 | number:0}}M / {{vm.metrics.gauges[\'jvm.memory.total.max\'].value / 1000000 | number:0}}M)</p><uib-progressbar min="0" max="vm.metrics.gauges[\'jvm.memory.total.max\'].value" value="vm.metrics.gauges[\'jvm.memory.total.used\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'jvm.memory.total.used\'].value * 100 / vm.metrics.gauges[\'jvm.memory.total.max\'].value | number:0}}%</span></uib-progressbar><p><span data-translate="metrics.jvm.memory.heap">Heap Memory</span> ({{vm.metrics.gauges[\'jvm.memory.heap.used\'].value / 1000000 | number:0}}M / {{vm.metrics.gauges[\'jvm.memory.heap.max\'].value / 1000000 | number:0}}M)</p><uib-progressbar min="0" max="vm.metrics.gauges[\'jvm.memory.heap.max\'].value" value="vm.metrics.gauges[\'jvm.memory.heap.used\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'jvm.memory.heap.used\'].value * 100 / vm.metrics.gauges[\'jvm.memory.heap.max\'].value | number:0}}%</span></uib-progressbar><p><span data-translate="metrics.jvm.memory.nonheap">Non-Heap Memory</span> ({{vm.metrics.gauges[\'jvm.memory.non-heap.used\'].value / 1000000 | number:0}}M / {{vm.metrics.gauges[\'jvm.memory.non-heap.committed\'].value / 1000000 | number:0}}M)</p><uib-progressbar min="0" max="vm.metrics.gauges[\'jvm.memory.non-heap.committed\'].value" value="vm.metrics.gauges[\'jvm.memory.non-heap.used\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'jvm.memory.non-heap.used\'].value * 100 / vm.metrics.gauges[\'jvm.memory.non-heap.committed\'].value | number:0}}%</span></uib-progressbar></div><div class="col-md-4"><b data-translate="metrics.jvm.threads.title">Threads</b> (Total: {{vm.metrics.gauges[\'jvm.threads.count\'].value}}) <a class="hand" ng-click="vm.refreshThreadDumpData()" data-toggle="modal" data-target="#threadDump"><i class="glyphicon glyphicon-eye-open"></i></a><p><span data-translate="metrics.jvm.threads.runnable">Runnable</span> {{vm.metrics.gauges[\'jvm.threads.runnable.count\'].value}}</p><uib-progressbar min="0" value="vm.metrics.gauges[\'jvm.threads.runnable.count\'].value" max="vm.metrics.gauges[\'jvm.threads.count\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'jvm.threads.runnable.count\'].value * 100 / vm.metrics.gauges[\'jvm.threads.count\'].value | number:0}}%</span></uib-progressbar><p><span data-translate="metrics.jvm.threads.timedwaiting">Timed Waiting</span> ({{vm.metrics.gauges[\'jvm.threads.timed_waiting.count\'].value}})</p><uib-progressbar min="0" value="vm.metrics.gauges[\'jvm.threads.timed_waiting.count\'].value" max="vm.metrics.gauges[\'jvm.threads.count\'].value" class="progress-striped active" type="warning"><span>{{vm.metrics.gauges[\'jvm.threads.timed_waiting.count\'].value * 100 / vm.metrics.gauges[\'jvm.threads.count\'].value | number:0}}%</span></uib-progressbar><p><span data-translate="metrics.jvm.threads.waiting">Waiting</span> ({{vm.metrics.gauges[\'jvm.threads.waiting.count\'].value}})</p><uib-progressbar min="0" value="vm.metrics.gauges[\'jvm.threads.waiting.count\'].value" max="vm.metrics.gauges[\'jvm.threads.count\'].value" class="progress-striped active" type="warning"><span>{{vm.metrics.gauges[\'jvm.threads.waiting.count\'].value * 100 / vm.metrics.gauges[\'jvm.threads.count\'].value | number:0}}%</span></uib-progressbar><p><span data-translate="metrics.jvm.threads.blocked">Blocked</span> ({{vm.metrics.gauges[\'jvm.threads.blocked.count\'].value}})</p><uib-progressbar min="0" value="vm.metrics.gauges[\'jvm.threads.blocked.count\'].value" max="vm.metrics.gauges[\'jvm.threads.count\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'jvm.threads.blocked.count\'].value * 100 / vm.metrics.gauges[\'jvm.threads.count\'].value | number:0}}%</span></uib-progressbar></div><div class="col-md-4"><b data-translate="metrics.jvm.gc.title">Garbage collections</b><div class="row"><div class="col-md-9" data-translate="metrics.jvm.gc.marksweepcount">Mark Sweep count</div><div class="col-md-3 text-right">{{vm.metrics.gauges[\'jvm.garbage.PS-MarkSweep.count\'].value}}</div></div><div class="row"><div class="col-md-9" data-translate="metrics.jvm.gc.marksweeptime">Mark Sweep time</div><div class="col-md-3 text-right">{{vm.metrics.gauges[\'jvm.garbage.PS-MarkSweep.time\'].value}}ms</div></div><div class="row"><div class="col-md-9" data-translate="metrics.jvm.gc.scavengecount">Scavenge count</div><div class="col-md-3 text-right">{{vm.metrics.gauges[\'jvm.garbage.PS-Scavenge.count\'].value}}</div></div><div class="row"><div class="col-md-9" data-translate="metrics.jvm.gc.scavengetime">Scavenge time</div><div class="col-md-3 text-right">{{vm.metrics.gauges[\'jvm.garbage.PS-Scavenge.time\'].value}}ms</div></div></div></div><div class="well well-lg" ng-show="vm.updatingMetrics" data-translate="metrics.updating">Updating...</div><h3 data-translate="metrics.jvm.http.title">HTTP requests (events per second)</h3><p><span data-translate="metrics.jvm.http.active">Active requests</span> <b>{{vm.metrics.counters[\'com.codahale.metrics.servlet.InstrumentedFilter.activeRequests\'].count | number:0}}</b> - <span data-translate="metrics.jvm.http.total">Total requests</span> <b>{{vm.metrics.timers[\'com.codahale.metrics.servlet.InstrumentedFilter.requests\'].count | number:0}}</b></p><div class="table-responsive"><table class="table table-striped"><thead><tr><th data-translate="metrics.jvm.http.table.code">Code</th><th data-translate="metrics.jvm.http.table.count">Count</th><th class="text-right" data-translate="metrics.jvm.http.table.mean">Mean</th><th class="text-right"><span data-translate="metrics.jvm.http.table.average">Average</span> (1 min)</th><th class="text-right"><span data-translate="metrics.jvm.http.table.average">Average</span> (5 min)</th><th class="text-right"><span data-translate="metrics.jvm.http.table.average">Average</span> (15 min)</th></tr></thead><tbody><tr><td data-translate="metrics.jvm.http.code.ok">OK</td><td><uib-progressbar min="0" max="vm.metrics.timers[\'com.codahale.metrics.servlet.InstrumentedFilter.requests\'].count" value="vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].count" class="progress-striped active" type="success"><span>{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].count}}</span></uib-progressbar></td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].mean_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].m1_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].m5_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].m15_rate | number:2}}</td></tr><tr><td data-translate="metrics.jvm.http.code.notfound">Not Found</td><td><uib-progressbar min="0" max="vm.metrics.timers[\'com.codahale.metrics.servlet.InstrumentedFilter.requests\'].count" value="vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].count" class="progress-striped active" type="success"><span>{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].count}}</span></uib-progressbar></td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].mean_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].m1_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].m5_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].m15_rate | number:2}}</td></tr><tr><td data-translate="metrics.jvm.http.code.servererror">Server error</td><td><uib-progressbar min="0" max="vm.metrics.timers[\'com.codahale.metrics.servlet.InstrumentedFilter.requests\'].count" value="vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].count" class="progress-striped active" type="success"><span>{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].count}}</span></uib-progressbar></td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].mean_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].m1_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].m5_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].m15_rate | number:2}}</td></tr></tbody></table></div><h3 data-translate="metrics.servicesstats.title">Services statistics (time in millisecond)</h3><div class="table-responsive"><table class="table table-striped"><thead><tr><th data-translate="metrics.servicesstats.table.name">Service name</th><th class="text-right" data-translate="metrics.servicesstats.table.count">Count</th><th class="text-right" data-translate="metrics.servicesstats.table.mean">Mean</th><th class="text-right" data-translate="metrics.servicesstats.table.min">Min</th><th class="text-right" data-translate="metrics.servicesstats.table.p50">p50</th><th class="text-right" data-translate="metrics.servicesstats.table.p75">p75</th><th class="text-right" data-translate="metrics.servicesstats.table.p95">p95</th><th class="text-right" data-translate="metrics.servicesstats.table.p99">p99</th><th class="text-right" data-translate="metrics.servicesstats.table.max">Max</th></tr></thead><tbody><tr ng-repeat="(k, v) in vm.servicesStats"><td>{{k}}</td><td class="text-right">{{v.count}}</td><td class="text-right">{{v.mean * 1000 | number:0}}</td><td class="text-right">{{v.min * 1000 | number:0}}</td><td class="text-right">{{v.p50 * 1000 | number:0}}</td><td class="text-right">{{v.p75 * 1000 | number:0}}</td><td class="text-right">{{v.p95 * 1000 | number:0}}</td><td class="text-right">{{v.p99 * 1000 | number:0}}</td><td class="text-right">{{v.max * 1000 | number:0}}</td></tr></tbody></table></div><h3 data-translate="metrics.datasource.title" ng-show="vm.metrics.gauges[\'HikariPool-1.pool.TotalConnections\'].value > 0">DataSource statistics (time in millisecond)</h3><div class="table-responsive" ng-show="vm.metrics.gauges[\'HikariPool-1.pool.TotalConnections\'].value > 0"><table class="table table-striped"><thead><tr><th><span data-translate="metrics.datasource.usage">Usage</span> ({{vm.metrics.gauges[\'HikariPool-1.pool.ActiveConnections\'].value}} / {{vm.metrics.gauges[\'HikariPool-1.pool.TotalConnections\'].value}})</th><th class="text-right" data-translate="metrics.datasource.count">Count</th><th class="text-right" data-translate="metrics.datasource.mean">Mean</th><th class="text-right" data-translate="metrics.datasource.min">Min</th><th class="text-right" data-translate="metrics.datasource.p50">p50</th><th class="text-right" data-translate="metrics.datasource.p75">p75</th><th class="text-right" data-translate="metrics.datasource.p95">p95</th><th class="text-right" data-translate="metrics.datasource.p99">p99</th><th class="text-right" data-translate="metrics.datasource.max">Max</th></tr></thead><tbody><tr><td><div class="progress progress-striped"><uib-progressbar min="0" max="vm.metrics.gauges[\'HikariPool-1.pool.TotalConnections\'].value" value="vm.metrics.gauges[\'HikariPool-1.pool.ActiveConnections\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'HikariPool-1.pool.ActiveConnections\'].value * 100 / vm.metrics.gauges[\'HikariPool-1.pool.TotalConnections\'].value | number:0}}%</span></uib-progressbar></div></td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].count}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].mean | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].min | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].p50 | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].p75 | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].p95 | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].p99 | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].max | number:2}}</td></tr></tbody></table></div></div>');
$templateCache.put('app/admin/metrics/metrics.modal.html','<!-- Modal used to display the threads dump --><div class="modal-header"><button type="button" class="close" ng-click="vm.cancel()">&times;</button><h4 class="modal-title" data-translate="metrics.jvm.threads.dump.title">Threads dump</h4></div><div class="modal-body pad"><span class="label label-primary" ng-click="threadDumpFilter = {}">All&nbsp;<span class="badge">{{vm.threadDumpAll}}</span></span>&nbsp; <span class="label label-success" ng-click="threadDumpFilter = {threadState: \'RUNNABLE\'}">Runnable&nbsp;<span class="badge">{{vm.threadDumpRunnable}}</span></span>&nbsp; <span class="label label-info" ng-click="threadDumpFilter = {threadState: \'WAITING\'}">Waiting&nbsp;<span class="badge">{{vm.threadDumpWaiting}}</span></span>&nbsp; <span class="label label-warning" ng-click="threadDumpFilter = {threadState: \'TIMED_WAITING\'}">Timed Waiting&nbsp;<span class="badge">{{vm.threadDumpTimedWaiting}}</span></span>&nbsp; <span class="label label-danger" ng-click="threadDumpFilter = {threadState: \'BLOCKED\'}">Blocked&nbsp;<span class="badge">{{vm.threadDumpBlocked}}</span></span>&nbsp;<div class="voffset2">&nbsp;</div>Filter <input type="text" ng-model="threadDumpFilter" class="form-control"><div class="row pad" ng-repeat="(k, v) in vm.threadDump | filter:threadDumpFilter"><h5><span class="label" ng-class="vm.getLabelClass(v.threadState)">{{v.threadState}}</span>&nbsp;{{v.threadName}} (ID {{v.threadId}}) <a ng-click="show = !show"><span ng-show="!show" data-translate="metrics.jvm.threads.dump.show">Show StackTrace</span> <span ng-show="show" data-translate="metrics.jvm.threads.dump.hide">Hide StackTrace</span></a></h5><div class="well" ng-show="show"><div ng-repeat="(stK, stV) in v.stackTrace">{{stV.className}}.{{stV.methodName}}({{stV.fileName}}:{{stV.lineNumber}}) <span class="voffset1"></span></div></div><table class="table table-condensed"><thead><tr><th class="text-right" data-translate="metrics.jvm.threads.dump.blockedtime">Blocked Time</th><th class="text-right" data-translate="metrics.jvm.threads.dump.blockedcount">Blocked Count</th><th class="text-right" data-translate="metrics.jvm.threads.dump.waitedtime">Waited Time</th><th class="text-right" data-translate="metrics.jvm.threads.dump.waitedcount">Waited Count</th><th data-translate="metrics.jvm.threads.dump.lockname">Lock Name</th></tr></thead><tbody><tr><td>{{v.blockedTime}}</td><td>{{v.blockedCount}}</td><td>{{v.waitedTime}}</td><td>{{v.waitedCount}}</td><td>{{v.lockName}}</td></tr></tbody></table></div></div><div class="modal-footer"><button type="button" class="btn btn-default pull-left" data-dismiss="modal" ng-click="vm.cancel()">Done</button></div>');
$templateCache.put('app/admin/user-management/user-management-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.user.login)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="userManagement.delete.question" translate-values="{login: \'{{vm.user.login}}\'}">Are you sure you want to delete this User?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/admin/user-management/user-management-detail.html','<div><h2><span data-translate="userManagement.detail.title">User</span> [<b>{{vm.user.login}}</b>]</h2><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="userManagement.login">Login</span></dt><dd><span>{{vm.user.login}}</span> <span class="label label-danger" ng-show="!vm.user.activated" data-translate="userManagement.deactivated">Deactivated</span> <span class="label label-success" ng-show="vm.user.activated" data-translate="userManagement.activated">Activated</span></dd><dt><span data-translate="userManagement.firstName">First Name</span></dt><dd>{{vm.user.firstName}}</dd><dt><span data-translate="userManagement.lastName">Last Name</span></dt><dd>{{vm.user.lastName}}</dd><dt><span data-translate="userManagement.email">Email</span></dt><dd>{{vm.user.email}}</dd><dt><span data-translate="userManagement.langKey">Lang Key</span></dt><dd>{{vm.user.langKey}}</dd><dt><span data-translate="userManagement.createdBy">Created By</span></dt><dd>{{vm.user.createdBy}}</dd><dt><span data-translate="userManagement.createdDate">Created Date</span></dt><dd>{{vm.user.createdDate | date:\'dd/MM/yy HH:mm\' }}</dd><dt><span data-translate="userManagement.lastModifiedBy">Last Modified By</span></dt><dd>{{vm.user.lastModifiedBy}}</dd><dt><span data-translate="userManagement.lastModifiedDate">Last Modified Date</span></dt><dd>{{vm.user.lastModifiedDate | date:\'dd/MM/yy HH:mm\'}}</dd><dt><span data-translate="userManagement.profiles">Profiles</span></dt><dd><ul class="list-unstyled"><li ng-repeat="authority in vm.user.authorities"><span class="label label-info">{{authority}}</span></li></ul></dd></dl><button type="submit" ui-sref="user-management" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button></div>');
$templateCache.put('app/admin/user-management/user-management-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myUserLabel" data-translate="userManagement.home.createOrEditLabel">Create or edit a User</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.user.id"><label data-translate="global.field.id">ID</label><input type="text" class="form-control" name="id" ng-model="vm.user.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="userManagement.login">Login</label><input type="text" class="form-control" name="login" ng-model="vm.user.login" required ng-minlength="1" ng-maxlength="50" ng-pattern="/^[_\'.@A-Za-z0-9-]*$/"><div ng-show="editForm.login.$invalid"><p class="help-block" ng-show="editForm.login.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.login.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="userManagement.firstName">First Name</label><input type="text" class="form-control" name="firstName" ng-model="vm.user.firstName" ng-maxlength="50"><div ng-show="editForm.firstName.$invalid"><p class="help-block" ng-show="editForm.firstName.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div></div><div class="form-group"><label data-translate="userManagement.lastName">Last Name</label><input type="text" class="form-control" name="lastName" ng-model="vm.user.lastName" ng-maxlength="50"><div ng-show="editForm.lastName.$invalid"><p class="help-block" ng-show="editForm.lastName.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="userManagement.email">Email</label><input type="email" class="form-control" name="email" ng-model="vm.user.email" required ng-maxlength="100"><div ng-show="editForm.email.$invalid"><p class="help-block" ng-show="editForm.email.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.email.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="100">This field cannot be longer than 100 characters.</p><p class="help-block" ng-show="editForm.email.$error.email" data-translate="global.messages.validate.email.invalid">Your email is invalid.</p></div></div><div class="form-group"><label for="activated"><input ng-disabled="vm.user.id === null" type="checkbox" id="activated" name="activated" ng-model="vm.user.activated"> <span data-translate="userManagement.activated">Activated</span></label></div><div class="form-group"><label data-translate="userManagement.langKey">Lang Key</label><select class="form-control" name="langKey" ng-model="vm.user.langKey" ng-options="language as language for language in vm.languages track by language"></select></div><div class="form-group"><label data-translate="userManagement.profiles">Profiles</label><select class="form-control" multiple="multiple" name="authority" ng-model="vm.user.authorities" ng-options="authority for authority in vm.authorities"></select></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/admin/user-management/user-management.html','<div><h2 data-translate="userManagement.home.title">Users</h2><jhi-alert></jhi-alert><div class="row"><div class="col-md-4"><button class="btn btn-primary" ui-sref="user-management.new"><span class="glyphicon glyphicon-flash"></span> <span data-translate="userManagement.home.createLabel">Create a new User</span></button></div></div><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span><span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="login"><span data-translate="userManagement.login">Login</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="email"><span data-translate="userManagement.email">Email</span> <span class="glyphicon glyphicon-sort"></span></th><th></th><th jh-sort-by="langKey"><span data-translate="userManagement.langKey">Lang Key</span> <span class="glyphicon glyphicon-sort"></span></th><th><span data-translate="userManagement.profiles">Profiles</span></th><th jh-sort-by="createdDate"><span data-translate="userManagement.createdDate">Created Date</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="lastModifiedBy"><span data-translate="userManagement.lastModifiedBy">Last Modified By</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="lastModifiedDate"><span data-translate="userManagement.lastModifiedDate">Last Modified Date</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody><tr ng-repeat="user in vm.users track by user.id"><td><a ui-sref="user-management-detail({login:user.login})">{{user.id}}</a></td><td>{{user.login}}</td><td>{{user.email}}</td><td><button class="btn btn-danger btn-xs" ng-click="vm.setActive(user, true)" ng-show="!user.activated" data-translate="userManagement.deactivated">Deactivated</button> <button class="btn btn-success btn-xs" ng-click="vm.setActive(user, false)" ng-show="user.activated" ng-disabled="vm.currentAccount.login === user.login" data-translate="userManagement.activated">Activated</button></td><td>{{user.langKey}}</td><td><div ng-repeat="authority in user.authorities"><span class="label label-info">{{ authority }}</span></div></td><td>{{user.createdDate | date:\'dd/MM/yy HH:mm\'}}</td><td>{{user.lastModifiedBy}}</td><td>{{user.lastModifiedDate | date:\'dd/MM/yy HH:mm\'}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="user-management-detail({login:user.login})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="user-management.edit({login:user.login})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="user-management.delete({login:user.login})" class="btn btn-danger btn-sm" ng-disabled="vm.currentAccount.login === user.login"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div>');
$templateCache.put('app/components/login/login.html','<div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.cancel()">&times;</button><h4 class="modal-title" data-translate="login.title">Sign in</h4></div><div class="modal-body"><div class="row"><div class="col-md-4 col-md-offset-4"><h1 data-translate="login.title">Sign in</h1></div><div class="col-md-8 col-md-offset-2"><div class="alert alert-danger" ng-show="vm.authenticationError" data-translate="login.messages.error.authentication"><strong>Failed to sign in!</strong> Please check your credentials and try again.</div></div><div class="col-md-8 col-md-offset-2"><form class="form" role="form" ng-submit="vm.login($event)"><div class="form-group"><label for="username" data-translate="global.form.username">Login</label><input type="text" class="form-control" id="username" placeholder="{{\'global.form.username.placeholder\' | translate}}" ng-model="vm.username"></div><div class="form-group"><label for="password" data-translate="login.form.password">Password</label><input type="password" class="form-control" id="password" placeholder="{{\'login.form.password.placeholder\' | translate}}" ng-model="vm.password"></div><div class="form-group"><label for="rememberMe"><input type="checkbox" id="rememberMe" ng-model="vm.rememberMe" checked="checked"> <span data-translate="login.form.rememberme">Remember me</span></label></div><button type="submit" class="btn btn-primary" data-translate="login.form.button">Sign in</button></form><p></p><div class="alert alert-warning"><a class="alert-link" href="" ng-click="vm.requestResetPassword()" data-translate="login.password.forgot">Did you forget your password?</a></div><div class="alert alert-warning" data-translate="global.messages.info.register" translate-compile>You don\'t have an account yet? <a class="alert-link" href="" ng-click="vm.register()">Register a new account</a></div></div></div></div>');
$templateCache.put('app/entities/calendar/calendar-title-xml.html','<div class="c-editor"><div class="c-editor-head"><div class="c-editor-head-fl"><input type="text" ng-model="vm.widget.name" class="c-editor-head-name"> <i class="iconfont icon-chehui" uib-tooltip="\u4E0A\u4E00\u6B65" tooltip-placement="bottom" ng-click="lastStep()" ng-style="{\'cursor\': vm.datas.length > 0 ? \'\' : \'not-allowed\'}"></i> <i class="iconfont icon-fanhuibanben" uib-tooltip="\u6062\u590D" tooltip-placement="bottom" ng-click="initData()" ng-style="{\'cursor\': vm.datas.length > 0 ? \'\' : \'not-allowed\'}"></i> <i class="iconfont icon-quanping" uib-tooltip="\u5168\u5C4F" tooltip-placement="bottom" ng-if="!vm.isFullScreen" ng-click="fullScreen()"></i> <i class="iconfont icon-xingzhuang3" uib-tooltip="\u9000\u51FA\u5168\u5C4F" tooltip-placement="bottom" ng-click="exitScreen()" ng-if="vm.isFullScreen"></i></div><div class="c-editor-head-fr"><button type="button" class="c-editor-head-btn2" ng-click="save()">\u4FDD\u5B58</button> <button type="button" class="c-editor-head-btn1" ng-click="out()">\u9000\u51FA</button></div></div><div class="c-editor-nav scrollbar-none"><div class="c-editor-nav-li" ng-repeat="item in vm.navList track by $index" ng-class="{\'c-editor-nav-navOn\':item.id == vm.navPitch}" ng-click="navCb(item)"><i class="iconfont {{item.icon}}"></i> <span>{{item.name}}</span></div></div><div class="c-editor-content scrollbar-none" ng-style="{right: vm.isUnfoldRight ? \'0\' : \'288px\',}" ng-click="selectCancel()"><div id="layout-wrapper" style="display: inline-block;box-shadow: 0 0 10px #ccc;position: absolute" ng-style="{\n                \'left\' : canvasCoordX(),\n                \'top\' : canvasCoordY(),\n                \'transform\' : \'scale(\' + vm.scale + \')\'\n            }"><title-cell ng-if="!vm.loading1" year="vm.widget.sampleYear" month="vm.widget.sampleMonth" widget="vm.widget"></title-cell></div><div class="choose-size-box"><div class="left-menu"><div class="lessen" ng-click="changeCanvasSize(1)" uib-tooltip="\u753B\u5E03\u7F29\u5C0F" tooltip-placement="top" tooltip-append-to-body="true"><i class="iconfont icon-jian"></i></div><div class="ratio">{{(100*vm.scale)|number:0}}%</div><div class="magnify" ng-click="changeCanvasSize(2)" uib-tooltip="\u753B\u5E03\u653E\u5927" tooltip-placement="top" tooltip-append-to-body="true"><i class="iconfont icon-jia2"></i></div></div><div class="right-menu"><div class="menu-item" ng-click="changeCanvasSize(0)" uib-tooltip="\u521D\u59CB\u5C3A\u5BF8" tooltip-placement="top" tooltip-append-to-body="true"><i class="iconfont icon-fangda"></i></div><div class="menu-item" ng-click="vm.moveCanvasView = !vm.moveCanvasView" uib-tooltip="\u62D6\u62FD\u753B\u5E03" tooltip-placement="top" tooltip-append-to-body="true"><i class="iconfont icon-icon-zhuashou" ng-class="{\'active\' : vm.moveCanvasView}"></i></div><div class="menu-item" ng-click="changeCanvasSize(3)" uib-tooltip="\u539F\u5C3A\u5BF8" tooltip-placement="left" tooltip-append-to-body="true"><i class="iconfont icon-icon-test"></i></div></div></div><div class="moveCanvas-view" ng-mousedown="moveCanvas($event)" ng-if="vm.moveCanvasView" data-html2canvas-ignore></div></div><div class="c-editor-attribute scrollbar-main" ng-style="{right: vm.isUnfoldRight ? \'-288px\' : \'0\', display: vm.isUnfoldRight ? \'none\' : \'block\'}"><div class="c-editor-attribute-body"><div class="title">\u793A\u4F8B\u6570\u636E</div><div class="c-editor-attribute-body-item2"><modele-select prefix="\u5E74:" ng-model="vm.widget.sampleYear" ng-change="onYearMonthChnage()" label-key="value" value-key="id" options="vm.sampleYears"></modele-select></div><div class="c-editor-attribute-body-item2"><modele-select prefix="\u6708:" ng-model="vm.widget.sampleMonth" ng-change="onYearMonthChnage()" label-key="value" value-key="id" options="vm.sampleMonths"></modele-select></div><div class="c-editor-attribute-body-hr"></div><style-setting title="true" theme-colors="vm.themeColors" settings="vm.widget.settings" font-list="vm.fontList" :style="\'two\'" on-change="onSettingsChange(text)" ng-if="vm.widget&&vm.isFontList"></style-setting></div></div><div class="unfold-right" ng-style="{right: vm.isUnfoldRight ? \'0\' : \'288px\'}" ng-click="unfoldRight()"><i class="iconfont" ng-class="{\'icon-right\':!vm.isUnfoldRight,\'icon-left\':vm.isUnfoldRight}"></i></div></div><div data-html2canvas class="page-item2" id="page-item2"><title-cell ng-if="!vm.loading1" year="vm.widget.sampleYear" month="vm.widget.sampleMonth" widget="vm.widget"></title-cell></div><style>.title{\n        line-height: 20px;\n        font-size: 14px;\n        font-weight: 600;\n        color: #222529;\n        margin-bottom: 16px;\n    }\n    .c-editor-attribute-body-item{\n        width: 100%;\n        height: 36px;\n        line-height: 36px;\n        padding: 0 8px;\n        background: #F5F7FA;\n        border-radius: 2px;\n        color: #222529;\n        font-size: 12px;\n    }\n    .c-editor-attribute-body-item1{\n        width: 100%;\n        display: flex;\n        border-radius: 2px;\n        border: 1px solid #E1E5EB;\n    }\n    .c-editor-attribute-body-item1 div{\n        width: 50%;\n        height: 36px;\n        cursor: pointer;\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        background: #fff;\n        color: #222529;\n        font-weight: bold;\n    }\n    .c-editor-attribute-body-item1-view{\n        background: #264DF0 !important;\n        color: #fff !important;\n    }\n    .c-editor-attribute-body-item2{\n        position: relative;\n        width: 100%;\n        height: 36px;\n        margin-bottom: 8px;\n    }\n    .c-editor-attribute-body-item2 span{\n        position: absolute;\n        left: 8px;\n        top: 0;\n        font-size: 12px;\n        color: #89919D;\n        display: inline-block;\n        height: 36px;\n        line-height: 36px;\n    }\n    .c-editor-attribute-body-item2 select, .c-editor-attribute-body-item2 input{\n        width: 100%;\n        height: 36px;\n        border-radius: 2px;\n        border: 1px solid #E1E5EB;\n        padding: 0 16px 0 28px;\n        font-size: 12px;\n        color: #222529;\n    }\n    .c-editor-attribute-body-hr{\n        width: 100%;\n        height: 1px;\n        background: #EEEEEE;\n        margin: 16px 0 24px;\n    }\n    .c-previewUrl-view{\n        display: flex;\n        justify-content: space-between;\n        align-items: center;\n        width: 100%;\n    }\n    .c-previewUrl-view-item{\n        background: #F5F7FA;\n        border-radius: 2px;\n        width: calc(100% - 30px) !important;\n        height: 80px;\n        display: flex;\n        justify-content: center;\n        align-items: center;\n    }\n    .c-previewUrl-view-item img{\n        max-width: 90%;\n        max-height: 70px;\n    }\n    .c-cell-view{\n        background: #f3f3f3;\n        display: flex;\n        justify-content: space-between;\n        align-items: center;\n        width: 80px;\n        height: 40px;\n    }\n    .c-cell-view span{\n        font-size: 12px;\n        padding: 0 5px 0 10px;\n        line-height: 13px;\n    }\n    .c-cell-view input{\n        border: 0;\n        background: none;\n        padding: 0;\n        font-size: 12px;\n    }\n    .c-weekStyles-view{\n        margin-top: 10px;\n    }\n    .c-weekStyles-view-li{\n        display: flex;\n        width: 100%;\n        justify-content: space-between;\n        align-items: center;\n        height: 36px;\n        background: #F5F7FA;\n        color: #333;\n        padding: 0 10px;\n        border-radius: 4px;\n        margin-bottom: 10px;\n    }</style>');
$templateCache.put('app/entities/calendar/calendar-title.html','<div class="c-body"><div class="c-title"><span class="c-title-nav mad-right-6 cursorPointer" ui-sref="calendar">\u65E5\u5386\u7EC4\u4EF6\u5217\u8868</span> <span class="c-title-nav c-title-navOn">\u6807\u9898\u7EC4\u4EF6\u5217\u8868</span></div><div class="mar-top-20"><div><button class="btn text-new-btn" ng-click="add()">\u65B0\u589E\u6807\u9898\u7EC4\u4EF6</button></div><div class="c-table" style="margin-top: 20px"><table><thead><tr><th>\u6807\u9898\u7EC4\u4EF6\u6837\u5F0F</th><th>\u6807\u9898\u7EC4\u4EF6\u540D\u79F0</th><th>\u72B6\u6001</th><th>\u64CD\u4F5C</th></tr></thead><tbody><tr ng-repeat="item in vm.textList track by item.id"><td><img ng-src="{{item.previewUrl}}" ng-if="item.previewUrl" alt="{{item.name}}" height="55"> <span ng-if="!item.previewUrl">\u65E0\u56FE</span></td><td>{{item.name}}</td><td>{{vm.status(item.status)}}</td><td style="width: 350px; max-width: 350px; min-width: 350px"><button type="button" class="c-table-btn" ng-click="look(item)">\u67E5\u770B</button> <button type="button" class="c-table-btn" ui-sref="calendar-title-xml({id: item.id})">\u7F16\u8F91</button> <button type="button" class="c-table-btn" ng-click="share(item)" ng-if="!item.status || item.status == \'Rejected\'">\u5206\u4EAB</button> <button type="button" class="c-table-btn" ng-click="copy(item)">\u590D\u5236</button> <button type="button" class="c-table-btn" style="border: 0" ng-click="delete(item)">\u5220\u9664</button></td></tr></tbody></table></div></div><div class="text-left" style="height: 70px;line-height: 70px;background: #f1f2f7 !important"><uib-pagination class="pagination-sm" style="float: left" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.transition()" previous-text="<" next-text=">" boundary-links="false"></uib-pagination><div class="text-jump"><span translate="global.page.goto">Go to</span> <input type="text" class="page-text page" max="100000" ng-model="vm.jumpText" onkeyup="value=value.replace(/[^\\d]/g,\'\')"> <span class="page-btn page" ng-click="vm.jump()">\u8DF3\u8F6C</span></div></div></div>');
$templateCache.put('app/entities/calendar/calendar-xml.html','<div class="c-editor"><div class="c-editor-head"><div class="c-editor-head-fl"><input type="text" ng-model="vm.data.name" class="c-editor-head-name"> <i class="iconfont icon-chehui" uib-tooltip="\u4E0A\u4E00\u6B65" tooltip-placement="bottom" ng-click="lastStep()" ng-style="{\'cursor\': vm.datas.length > 0 ? \'\' : \'not-allowed\'}"></i> <i class="iconfont icon-fanhuibanben" uib-tooltip="\u6062\u590D" tooltip-placement="bottom" ng-click="initData()" ng-style="{\'cursor\': vm.datas.length > 0 ? \'\' : \'not-allowed\'}"></i> <i class="iconfont icon-quanping" uib-tooltip="\u5168\u5C4F" tooltip-placement="bottom" ng-if="!vm.isFullScreen" ng-click="fullScreen()"></i> <i class="iconfont icon-xingzhuang3" uib-tooltip="\u9000\u51FA\u5168\u5C4F" tooltip-placement="bottom" ng-click="exitScreen()" ng-if="vm.isFullScreen"></i></div><div class="c-editor-head-fr"><button type="button" class="c-editor-head-btn2" ng-click="save()">\u4FDD\u5B58</button> <button type="button" class="c-editor-head-btn1" ng-click="out()">\u9000\u51FA</button></div></div><div class="c-editor-nav scrollbar-none"><div class="c-editor-nav-li" ng-repeat="item in vm.navList track by $index" ng-class="{\'c-editor-nav-navOn\':item.id == vm.navPitch}" ng-click="navCb(item)"><i class="iconfont {{item.icon}}"></i> <span>{{item.name}}</span></div></div><div class="c-editor-content scrollbar-none" ng-style="{right: vm.isUnfoldRight ? \'0\' : \'288px\',}" ng-click="selectCancel()"><div ng-if="!vm.isLoading" id="layout-wrapper" style="display: inline-block;box-shadow: 0 0 10px #ccc;position: absolute" ng-style="{\n                \'left\' : canvasCoordX(),\n                \'top\' : canvasCoordY(),\n                \'transform\': \'scale(\'+(vm.scale || 1) + \')\',\n                \'transform-origin\' : \'0px 0px\'\n            }"><div class="layout-wrapper-view"><month-table widget="vm.data" year="vm.data.sampleYear" month="vm.data.sampleMonth" week="vm.data.startOfWeek"></month-table></div></div><div class="choose-size-box"><div class="left-menu"><div class="lessen" ng-click="changeCanvasSize(1)" uib-tooltip="\u753B\u5E03\u7F29\u5C0F" tooltip-placement="top" tooltip-append-to-body="true"><i class="iconfont icon-jian"></i></div><div class="ratio">{{(100*vm.scale)|number:0}}%</div><div class="magnify" ng-click="changeCanvasSize(2)" uib-tooltip="\u753B\u5E03\u653E\u5927" tooltip-placement="top" tooltip-append-to-body="true"><i class="iconfont icon-jia2"></i></div></div><div class="right-menu"><div class="menu-item" ng-click="changeCanvasSize(0)" uib-tooltip="\u521D\u59CB\u5C3A\u5BF8" tooltip-placement="top" tooltip-append-to-body="true"><i class="iconfont icon-fangda"></i></div><div class="menu-item" ng-click="vm.moveCanvasView = !vm.moveCanvasView" uib-tooltip="\u62D6\u62FD\u753B\u5E03" tooltip-placement="top" tooltip-append-to-body="true"><i class="iconfont icon-icon-zhuashou" ng-class="{\'active\' : vm.moveCanvasView}"></i></div><div class="menu-item" ng-click="changeCanvasSize(3)" uib-tooltip="\u539F\u5C3A\u5BF8" tooltip-placement="left" tooltip-append-to-body="true"><i class="iconfont icon-icon-test"></i></div></div></div><div class="moveCanvas-view" ng-mousedown="moveCanvas($event)" ng-if="vm.moveCanvasView" data-html2canvas-ignore></div></div><div class="c-editor-attribute scrollbar-main" ng-style="{right: vm.isUnfoldRight ? \'-288px\' : \'0\', display: vm.isUnfoldRight ? \'none\' : \'block\'}"><calendar-set data="vm.data" on-change="onSettingsChange(text)" ng-if="vm.data && vm.dataInit"></calendar-set></div><div class="unfold-right" ng-style="{right: vm.isUnfoldRight ? \'0\' : \'288px\'}" ng-click="unfoldRight()"><i class="iconfont" ng-class="{\'icon-right\':!vm.isUnfoldRight,\'icon-left\':vm.isUnfoldRight}"></i></div></div><div data-html2canvas class="page-item2" id="page-item2"><month-table ng-if="!vm.isLoading" widget="vm.data" thumbnail="true" year="vm.data.sampleYear" month="vm.data.sampleMonth" week="vm.data.startOfWeek"></month-table></div><style>.title{\n        line-height: 20px;\n        font-size: 14px;\n        font-weight: 600;\n        color: #222529;\n        margin-bottom: 16px;\n    }\n    .c-cell-view{\n        background: #f3f3f3;\n        display: flex;\n        justify-content: space-between;\n        align-items: center;\n        width: 80px;\n        height: 40px;\n    }\n    .c-cell-view span{\n        font-size: 12px;\n        padding: 0 5px 0 10px;\n        line-height: 13px;\n    }\n    .c-cell-view input{\n        border: 0;\n        background: none;\n        padding: 0;\n        font-size: 12px;\n    }\n    .leftPanel-bg-choose-color{\n        top: 0 !important;\n    }</style>');
$templateCache.put('app/entities/calendar/calendar.html','<div class="workbench"><div class="work-head"><div class="work-title">\u6211\u7684\u65E5\u5386</div><div class="search-box"><div class="search-input"><i class="iconfont icon-sousuo"></i> <input type="text" ng-model="vm.searchQuery" ng-readonly="vm.batchState" ng-keydown="vm.search()" placeholder="\u5173\u952E\u8BCD\u641C\u7D22"></div><div class="handle"><div class="batch-btn" ng-if="!vm.batchState" ng-click="vm.batchState = true"><i class="iconfont icon-batch"></i>\u6279\u91CF\u64CD\u4F5C</div><div class="btn-primary" ng-if="vm.batchState" ng-click="vm.batchState = false">\u9000\u51FA</div><div class="btn-primary create-model" ng-if="!vm.batchState" style="margin-left: 8px" ng-click="add()">\u521B\u5EFA\u65E5\u5386<div class="menu-box"><div class="menu-list"><div class="menu-item" ng-click="add(\'calendar\')">\u521B\u5EFA\u65E5\u5386\u7EC4\u4EF6</div><div class="menu-item" ng-click="add(\'calendarTitle\')">\u521B\u5EFA\u6807\u9898\u7EC4\u4EF6</div></div></div></div></div></div></div><div class="share-screen"><div class="screen-box"><div class="screen-tit">\u5206\u7C7B\uFF1A</div><div class="option-list"><div class="option-item" ng-class="{\'active\' : item.value == vm.pageView}" ng-repeat="item in  vm.genreList track by $index" ng-click="selectGenre(item)">{{item.label}}</div></div></div><div class="screen-line" style="padding-top: 32px"><div class="screen"><div class="genre no-cut"><div class="item" ng-repeat="item in vm.statusList" ng-class="{\'active\' : item.value === vm.selectStatus}" ng-click="statusCheck(item.value)">{{item.label}}</div></div></div></div></div><div class="template-list"><div class="empty-view" ng-if="vm.textList.length < 1"><img class="empty-img" src="content/images/calendar-empty.png" alt="\u65E0\u6570\u636E"><div class="empty-text">\u8FD8\u6CA1\u6709\u5185\u5BB9\u54E6\uFF0C <span class="link" ng-if="vm.pageView == \'calendar\'" ng-click="add(\'calendar\')">\u5FEB\u53BB\u521B\u5EFA\u5427<i class="iconfont icon-right"></i> </span><span class="link" ng-if="vm.pageView == \'calendarTitle\'" ng-click="add(\'calendarTitle\')">\u5FEB\u53BB\u521B\u5EFA\u5427<i class="iconfont icon-right"></i></span></div></div><div class="template-item" ng-repeat="item in vm.textList track by item.id"><div class="img-view" ng-click="checkItem(item)"><div class="cover-view"><img class="cover-img" err-src="content/images/default-cover.png" ng-src="{{item.previewUrl + \'?imageMogr2/interlace/1/thumbnail/268x268\'}}" ng-if="item.previewUrl" alt="{{item.name}}"> <img class="cover-img" ng-if="!item.previewUrl" src="content/images/default-cover.png" alt="\u65E0\u56FE"><div class="check-box" ng-class="{\'checked\' : item.selected}" ng-if="vm.batchState"><i class="iconfont icon-gou"></i></div><div class="tag-box" ng-if="!vm.batchState"><div class="tag" ng-if="item.status === \'Approved\'">\u5DF2\u5206\u4EAB</div><div class="tag tag-success" ng-if="item.status === \'Created\'">\u5BA1\u6838\u4E2D</div><div class="tag tag-warn" ng-if="item.status === \'Rejected\'">\u5DF2\u9A73\u56DE</div></div></div><div class="shade-view" ng-if="!vm.batchState"><div class="preview-btn" ng-click="look(item)" uib-tooltip="\u9884\u89C8" tooltip-placement="bottom"><i class="iconfont icon-yulan"></i></div><div class="menu-view"><i class="iconfont icon-gengduo1"></i><div class="menu-content"><div class="menu-list"><div class="menu-item" ng-if="vm.pageView == \'calendar\'" ui-sref="calendar-xml({id: item.id})">\u7F16\u8F91</div><div class="menu-item" ng-if="vm.pageView == \'calendarTitle\'" ui-sref="calendar-title-xml({id: item.id})">\u7F16\u8F91</div><div class="menu-item" ng-click="copy(item)">\u590D\u5236</div><div class="menu-item" ng-click="delete(item)">\u5220\u9664</div><div class="menu-item" ng-if="item.status == \'Rejected\'" ng-click="showReason(item)">\u67E5\u770B\u9A73\u56DE\u539F\u56E0</div><div class="cut-line" ng-if="!item.status || item.status == \'Rejected\'"></div><div class="menu-item" ng-if="!item.status || item.status == \'Rejected\'" ng-click="share(item)">\u5206\u4EAB</div></div></div></div></div></div><div class="template-info"><div class="template-name" uib-tooltip="{{item.name}}" tooltip-placement="bottom">{{item.name}}</div></div></div></div><div class="batch-bar" ng-if="vm.batchState"><div class="checked-count"><span class="num">({{vm.selectCount}})</span>\u5DF2\u9009\u4E2D</div><div class="btns"><div class="batch-btn" ng-click="batchShare()"><i class="iconfont icon-fenxiang"></i>\u5206\u4EAB</div><div class="batch-btn" ng-click="batchDelete()"><i class="iconfont calendarTitle"></i>\u5220\u9664</div></div><div class="btn-close" ng-click="vm.batchState = false"><i class="iconfont icon-closeicon1"></i></div></div><modele-pagination style="margin-top:10px" ng-show="!vm.batchState" page="vm.pageInfo.page" size="vm.pageInfo.size" total="vm.pageInfo.total" current-change="vm.currentChange()"></modele-pagination></div>');
$templateCache.put('app/entities/calendar-center/calendar-center-body-preview-model.html','<div class="preview-model"><div class="preview-model-head"><div class="title">\u9884\u89C8</div><div class="close-btn" ng-click="vm.cancel()"><i class="iconfont icon-closeicon1"></i></div></div><div class="preview-model-content"><img ng-src="{{vm.widget.previewUrl}}" alt=""></div></div>');
$templateCache.put('app/entities/calendar-center/calendar-center-body.html','<div class="share-content"><div class="share-head"><div class="share-title">\u65E5\u5386\u4E2D\u5FC3</div><div class="search-box"><div class="search-input"><i class="iconfont icon-sousuo"></i> <input type="text" ng-model="vm.searchQuery" ng-keydown="vm.search()" placeholder="\u5173\u952E\u8BCD\u641C\u7D22"></div></div></div><div class="share-screen"><div class="screen-box"><div class="screen-tit">\u5206\u7C7B\uFF1A</div><div class="option-list"><div class="option-item" ng-class="{\'active\' : vm.viewType == \'calendar\'}" ng-click="clickTypeItem(\'calendar\')">\u65E5\u5386\u7EC4\u4EF6</div><div class="option-item" ng-class="{\'active\' : vm.viewType == \'title\'}" ng-click="clickTypeItem(\'title\')">\u6807\u9898\u7EC4\u4EF6</div></div></div></div><!-- \u65E5\u5386\u63D2\u4EF6/\u6807\u9898\u5217\u8868 --><div class="template-list" style="margin-top: 24px"><div class="empty-view" ng-if="vm.titleList.length < 1"><img class="empty-img" src="content/images/page-empty.png" alt="\u65E0\u6570\u636E"><div class="empty-text">\u6682\u65E0\u5185\u5BB9</div></div><div class="template-item" ng-repeat="item in vm.titleList track by item.id"><div class="img-view"><div class="cover-view"><img class="cover-img" alt="\u56FE\u7247\u7F3A\u5931" ng-src="{{item.previewUrl +\'?imageMogr2/interlace/1/thumbnail/268x268\'}}" err-src="content/images/default-cover.png"></div><div class="shade-view"><div class="preview-btn" ng-click="look(item)" uib-tooltip="\u9884\u89C8" tooltip-placement="bottom"><i class="iconfont icon-yulan"></i></div><div class="temp-btn" ng-click="save(item)">\u4F7F\u7528</div></div></div><div class="template-info"><div class="template-name" uib-tooltip="{{item.name}}" tooltip-placement="top">{{item.name}}</div><div class="info-list"><div class="item" style="color:#89919D">{{item.width}}x{{item.height}}</div></div></div></div></div><modele-pagination style="margin-top:10px" page="vm.pageInfo.page" size="vm.pageInfo.size" total="vm.pageInfo.total" current-change="vm.currentChange()"></modele-pagination></div>');
$templateCache.put('app/entities/calendar-center/calendar-center-title-preview-model.html','<div class="preview-model"><div class="preview-model-head"><div class="title">\u9884\u89C8</div><div class="close-btn" ng-click="vm.cancel()"><i class="iconfont icon-closeicon1"></i></div></div><div class="preview-model-content"><img ng-src="{{vm.widget.previewUrl}}" alt=""></div></div><style>.modal-content {\n        width: 100%;\n        margin: 100px auto;\n    }</style>');
$templateCache.put('app/entities/calendar-center/calendar-center-title.html','<div class="c-body" style="margin-top: 30px"><div class="mar-top-20" style="width: 1107px; margin: 0 auto"><div class="c-table"><table><thead><tr><th style="width: 300px">\u6807\u9898\u7EC4\u4EF6\u6837\u5F0F</th><th>\u6807\u9898\u7EC4\u4EF6\u540D\u79F0</th><th>\u5C3A\u5BF8</th><th>\u64CD\u4F5C</th></tr></thead><tbody><tr ng-repeat="item in vm.titleList track by item.id" style="height: 50px"><td><img ng-if="item.previewUrl" ng-src="{{item.previewUrl}}" style="max-height: 100px;max-width: 300px"> <span ng-if="!item.previewUrl">\u65E0\u56FE</span></td><td>{{item.name}}</td><td>{{item.width}}x{{item.height}}</td><td style="width: 350px; max-width: 350px; min-width: 350px"><button type="button" class="c-table-btn" ng-click="look(item)">\u67E5\u770B</button> <button type="button" class="c-table-btn" ng-click="save(item)" style="border: 0">\u4F7F\u7528</button></td></tr></tbody></table></div><div class="text-left" style="height: 70px;line-height: 70px;background: #f1f2f7 !important"><uib-pagination class="pagination-sm" style="float: left" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.transition()" previous-text="<" next-text=">" boundary-links="false"></uib-pagination><div class="text-jump"><span translate="global.page.goto">Go to</span> <input type="text" class="page-text page" max="100000" ng-model="vm.jumpText" onkeyup="value=value.replace(/[^\\d]/g,\'\')"> <span class="page-btn page" ng-click="vm.jump()">\u8DF3\u8F6C</span></div></div></div></div>');
$templateCache.put('app/entities/font-management/font-management-detail.html','<div class="c-model"><div class="c-model-head"><div class="c-model-head-title">\u5B57\u4F53\u67E5\u770B</div><i class="iconfont icon-closeicon1" ng-click="vm.clear()"></i></div><div class="c-model-body font-info-body"><div class="c-model-body-view font-info-view"><div class="font-info-item"><div class="tit">\u540D\u79F0\uFF1A</div><div class="info">{{vm.fontManagement.family}}</div></div><div class="font-info-item"><div class="tit">\u5C5E\u6027\uFF1A</div><div class="info"><div ng-repeat="fontStyle in vm.fontManagement.fontStyles track by $index"><span translate="{{\'platformApp.style.\'+ fontStyle.style }}">{{fontStyle.style}}</span></div></div></div><div class="font-info-item"><div class="tit">\u6709\u6548\u5B57\u4F53\uFF1A</div><div class="info">{{ vm.fontManagement.enable ? \'\u662F\' : \'\u5426\' }}</div></div></div></div></div><style>.c-model-body.font-info-body{\n        margin-top: 0;\n        padding: 24px;\n    }\n    .font-info-view .font-info-item{\n        display: flex;\n        font-size: 14px;\n        color: #505760;\n        margin-bottom: 16px;\n    }\n    .font-info-view .font-info-item:last-child{\n        margin-bottom: 0;\n    }\n    .font-info-item .tit{\n        width: 70px;\n    }\n    .font-info-item .info{\n        font-weight: bold;\n    }</style>');
$templateCache.put('app/entities/font-management/font-management-dialog.html','<!-- <form name="editForm" role="form" novalidate class="listBGC listCreate pad-0">\n    <div class="col-lg-12 col-sm-12 exit-box-con-head">\n        <span class="col-md-6 col-sm-6 col-xs-6 font-16 text-left">\u5B57\u4F53\u5BFC\u5165</span>\n        <span class="col-md-6 col-sm-6 col-xs-6 text-right">\n            <img src="content/images/icons/close.svg" style="width: 16px;" ng-click="vm.clear()">\n        </span>\n    </div>\n    <div class="col-lg-12 col-sm-12 scrollbar" style="height: 450px;font-size: 16px;background: #fff;overflow-y: auto;">\n        <div class="col-lg-12 col-sm-12" style="text-align: center;color: #bcbcbc;margin-top: 180px;"\n            ng-show="!vm.files">\n            <span>\n                \u8BF7\u4E00\u6B21\u6027\u9009\u62E9\u4E0D\u8D85\u8FC730\u4E2A\u5B57\u4F53\u6587\u4EF6\uFF0C<br />\n                \u5B57\u4F53\u5927\u5C0F\u8BF7\u52FF\u8D85\u8FC720MB\uFF01\n            </span>\n        </div>\n        <div class="col-lg-12 col-sm-12 psd-list" style="margin-top: 15px; line-height: 20px;height:20px;"\n            ng-repeat="file in vm.files track by $index">\n            <div class="col-lg-8 col-sm-8 psd-list-left">\n                <div class="psd-status2" ng-show="file.status!=\'success\'">{{file.name}}</div>\n                <div class="psd-status1" ng-show="file.status==\'success\'">{{file.name}}</div>\n            </div>\n            <div class="col-lg-4 col-sm-4 psd-list-right">\n                <div class="psd-wait" ng-show="file.status==\'wait\'"><img src="content/images/icons/psd-wait.png"\n                        width="19px">\u51C6\u5907\u5C31\u7EEA</div>\n                <div class="psd-loading" ng-show="file.status==\'loading\'"><img\n                        src="content/images/icons/psd-loading.png" width="19px">\u4E0A\u4F20\u4E2D\u2026</div>\n                <div class="psd-success" ng-show="file.status==\'success\'"><img\n                        src="content/images/icons/psd-success.png" width="19px">\u4E0A\u4F20\u6210\u529F\uFF01</div>\n                <div class="psd-error" ng-show="file.status==\'error\'"><img src="content/images/icons/psd-error.png"\n                        width="19px">\u4E0A\u4F20\u5931\u8D25\uFF01</div>\n            </div>\n        </div>\n    </div>\n\n    <div class="col-lg-12 col-sm-12 pad-0" style="border-top:1px solid #dfdfdf;">\n        <button class="col-lg-6 col-sm-6 pad-0 back-btn3" ng-disabled="vm.uploading">\n            <span>\u9009\u62E9\u5B57\u4F53\u6587\u4EF6</span>\n            <input type="file" name="file" class="add-pic cursor-point" ng-show="!vm.uploading" multiple\n                accept=".ttf, .otf, .fon" onchange="updateImgFile(event)" ng-model-options="{debounce:500}">\n        </button>\n        <button class="col-lg-6 col-sm-6 pad-0 back-btn4" ng-click="save()">\n            {{vm.saveText}}\n        </button>\n    </div>\n</form> --><!-- \u6DFB\u52A0\u5B57\u4F53 --><div class="c-model"><div class="c-model-head"><div class="c-model-head-title">\u5BFC\u5165\u5B57\u4F53\u6587\u4EF6</div><i class="iconfont icon-closeicon1" ng-click="vm.clear()"></i></div><div class="c-model-body"><div class="c-model-body-view upload-font-box" ng-if="vm.files.length === 0" draggable="true" id="upload-font-box"><div class="upload-font-img"><img src="content/images/upload-font.png" alt=""></div><div class="upload-tips">\u62D6\u62FD\u6587\u4EF6\u5230\u6B64\u5904\uFF0C\u6216\u8005</div><div class="upload-btn">\u9009\u62E9\u6587\u4EF6... <input type="file" name="file" class="add-pic cursor-point" ng-show="!vm.uploading" multiple="multiple" accept=".ttf, .otf, .fon" onchange="updateImgFile(event)" ng-model-options="{debounce:500}"></div></div><div class="c-model-body-view font-list-view" ng-if="vm.files.length > 0"><div class="font-item" ng-repeat="item in vm.files track by $index"><div class="font-info"><i class="iconfont icon-ziti2"></i> <span class="name">{{item.name}}</span></div><div class="del-font" ng-if="item.status == \'wait\'" ng-click="deleteFont($index)"><i class="iconfont icon-dustbin_icon"></i></div><div class="status-view" ng-if="item.status != \'wait\'"><!-- \u5BFC\u5165\u4E2D --><div class="status-item status-loading" ng-if="item.status == \'loading\'"><i class="iconfont icon-dengdai"></i> <span>\u5BFC\u5165\u4E2D</span></div><!-- \u5BFC\u5165\u6210\u529F --><div class="status-item status-success" ng-if="item.status == \'success\'"><i class="iconfont icon-dui1"></i> <span>\u5BFC\u5165\u6210\u529F</span></div><!-- \u5BFC\u5165\u5931\u8D25 --><div class="status-item status-error" ng-if="item.status == \'error\'"><i class="iconfont icon-shixinguanbi"></i> <span>\u5BFC\u5165\u5931\u8D25</span></div></div></div></div></div><div class="c-model-foot upload-font-foot"><div class="prompt" ng-if="vm.files.length === 0"><span>*\u8BF7\u4E00\u6B21\u6027\u9009\u62E9\u4E0D\u8D85\u8FC730\u4E2A\u5B57\u4F53\u6587\u4EF6\uFF0C\u5B57\u4F53\u5927\u5C0F\u8BF7\u52FF\u8D85\u8FC720MB\uFF01</span></div><div class="btns" ng-if="vm.files.length > 0 && vm.showUpload"><div class="add-font"><i class="iconfont icon-jia2"></i> <span>\u6DFB\u52A0\u6587\u4EF6</span> <input type="file" name="file" class="add-pic cursor-point" multiple="multiple" accept=".ttf, .otf, .fon" onchange="updateImgFile(event)" ng-model-options="{debounce:500}"></div><button type="button" class="btn btn-info" ng-click="save()">\u5BFC\u5165</button></div></div></div><style>.c-model {\n        width: 880px;\n    }</style>');
$templateCache.put('app/entities/font-management/font-managements.html','<div style="padding-bottom: 80px"><div class="current-location" style="display: flex; margin-bottom: 8px"><div class="page-title" ui-sref="{{tab.url}}" ng-class="{\'tab-selected\' : vm.currentName == tab.key}" ng-repeat="tab in vm.tabs">{{tab.value}}</div><div style="margin-left: auto; margin-right: 25px"><div class="input-group pull-right"><button class="btn upload-batch" ng-show="!vm.batch" ng-click="vm.batch =  !vm.batch"><i class="iconfont icon-batch"></i> \u6279\u91CF\u64CD\u4F5C</button> <button class="upload-add" ng-show="!vm.batch" ui-sref="font-management.new"><span>\u6DFB\u52A0\u5B57\u4F53</span></button> <button class="upload-add" ng-show="vm.batch" ng-click="exitBatch()"><span>\u9000\u51FA</span></button></div></div></div><div class="list-body" style="margin-bottom: 10px"><div class="table-responsive list-table pad-left-15 pad-right-15"><table class="jh-table table table-striped"><thead class="table-thead"><tr class="table-thead" style="height: 48px; background: #F5F7FA; font-size: 14px"><th ng-show="vm.batch" ng-click="selecteAll()"><div ng-show="vm.batch&&!vm.selecteAll" class="batch-select"></div><div ng-show="vm.batch && vm.selecteAll" class="batch-selected"><i class="iconfont icon-duihao" style="font-size: 32px;  line-height: 32px; color: white"></i></div></th><th><span data-translate="global.field.id">ID</span></th><th><span data-translate="platformApp.fontManagement.family">Family</span></th><th><span data-translate="platformApp.fontManagement.style">style</span></th><th><span>\u65E5\u5386\u63A7\u4EF6</span></th><th><span>\u652F\u6301\u4E2D\u6587</span></th><th><span>\u6709\u6548\u5B57\u4F53</span></th><th><span translate="global.field.operate">Operate</span></th></tr></thead><tbody class="table-tbody"><tr ng-repeat="fontManagement in vm.fontManagements track by fontManagement.id" class="content-tr" ng-click="itemSelect(fontManagement)"><td ng-show="vm.batch"><div ng-show="!fontManagement.selected" class="batch-select"></div><div ng-show="fontManagement.selected" class="batch-selected"><i class="iconfont icon-duihao" style="font-size: 32px;  line-height: 32px; color: white"></i></div></td><td class="vertical-middle">{{$index+1}}</td><td class="vertical-middle">{{fontManagement.family}}</td><td class="vertical-middle"><div ng-repeat="fontStyle in fontManagement.fontStyles"><img ng-if="vm.domainQ" ng-src="{{vm.domainQ + fontStyle.identifier}}"></div></td><td class="vertical-middle">{{fontManagement.calendarSupport?"\u662F":"\u5426"}}</td><td class="vertical-middle">{{fontManagement.chineseSupport?"\u662F":"\u5426"}}</td><td class="vertical-middle">{{fontManagement.enable?"\u662F":"\u5426"}}</td><td class="text-right vertical-middle"><div class="right-btn"><button type="submit" ng-click="viewFont(fontManagement);$event.stopPropagation();" class="font-btn btn-view" ng-style="{\'opacity\':vm.batch ? \'0.5\' : \'\'}">\u67E5\u770B</button> <button type="submit" ng-click="delete(fontManagement.id);$event.stopPropagation();" class="font-btn btn-cancel" ng-style="{\'opacity\':vm.batch ? \'0.5\' : \'\'}">\u5220\u9664</button></div></td></tr></tbody></table></div></div><modele-pagination ng-show="!vm.batch" page="vm.page" size="vm.itemsPerPage" total="vm.totalItems" current-change="vm.currentChange()"></modele-pagination></div><div ng-show="vm.batch" class="batch-bar"><div style="margin-left: 32px">({{vm.count || 0}})\u5DF2\u9009\u4E2D</div><div style="margin-left: 676px" ng-click="batchDelet()"><i class="iconfont icon-dustbin_icon"></i> \u5220\u9664</div><div style="margin-left: 740px" ng-click="exitBatch()"><i class="iconfont icon-closeicon1" style="color: #FFFFFF"></i></div></div><style type="text/css" media="screen">.c-home-body{\n        padding: 32px 0px 32px 32px;\n    }\n\n    .content-tr:hover{\n        background: #EFF2FA;\n    }\n\n\n    .page-title {\n        width: 96px;\n        height: 40px;\n        border: 1px solid #E1E5EB;\n        border-radius: 22px;\n        text-align: center;\n        font-size: 18px;\n        line-height: 38px;\n        margin-right: 16px;\n        font-weight: 600;\n        color: #222529;\n        cursor: pointer;\n    }\n    .tab-selected{\n        border: none;\n        color: #264DF0;\n        background: rgba(38,77,240,0.09);\n    }\n\n    .upload-batch{\n        width: 112px;\n        height: 36px;\n        border-radius: 2px;\n        border: 1px solid #E1E5EB;\n        margin-right: 8px;\n    }\n\n    .upload-add{\n        width: 112px;\n        height: 36px;\n        background: #264DF0;\n        border-radius: 2px;\n        color: white;\n    }\n    .upload-add:hover{\n        background: rgba(58, 124, 255, 0.85);\n    }\n\n    .upload-input{\n        width: 112px;\n        height: 36px;\n        top: -31px;\n        left: -17px;\n        position: relative;\n    }\n\n    .batch-select{\n        width: 32px;\n        height: 32px;\n        background: #FFFFFF;\n        box-shadow: 0px 2px 4px 0px rgba(34,37,41,0.13);\n        border-radius: 4px;\n        border: 1px solid #E1E5EB;\n        left: 16px;\n        position: relative;\n    }\n\n    .batch-selected{\n        width: 32px;\n        height: 32px;\n        background: #264DF0;\n        border-radius: 4px;\n        left: 16px;\n        position: relative;\n    }\n    .batch-bar{\n        position: fixed;\n        bottom: 0;\n        height: 72px;\n        background: #FF4444;\n        display: flex;\n        left: 264px;\n        width: calc(100% - 264px);\n        font-size: 16px;\n        color: #FFFFFF;\n        line-height: 72px;\n\n    }\n\n    .font-btn{\n        width: 44px;\n        height: 24px;\n        background: #F5F7FA;\n        border-radius: 2px;\n        margin-right: 16px;\n    }\n\n    .btn-view:hover{\n        color:white;\n        background: #264DF0;\n    }\n\n    .btn-cancel:hover{\n        color:white;\n        background: #FF4444;\n    }</style>');
$templateCache.put('app/entities/components/input-number.html','<!-- \u98CE\u683C\u4E00 --><div class="ant-input-number" ng-if="vm.typeStyle != \'two\'"><div class="ant-input-number-handler-wrap"><span class="ant-input-number-handler ant-input-number-handler-up" ng-click="up(this)"><i aria-label="\u56FE\u6807: up" class="ant-input-number-handler-up-inner"><svg viewBox="64 64 896 896" focusable="false" class="" data-icon="up" width="1em" height="1em" fill="currentColor" aria-hidden="true"><path d="M890.5 755.3L537.9 269.2c-12.8-17.6-39-17.6-51.7 0L133.5 755.3A8 8 0 0 0 140 768h75c5.1 0 9.9-2.5 12.9-6.6L512 369.8l284.1 391.6c3 4.1 7.8 6.6 12.9 6.6h75c6.5 0 10.3-7.4 6.5-12.7z"></path></svg> </i></span><span class="ant-input-number-handler ant-input-number-handler-down" ng-click="down(this)"><i aria-label="\u56FE\u6807: down" class="ant-input-number-handler-down-inner"><svg viewBox="64 64 896 896" focusable="false" class="" data-icon="down" width="1em" height="1em" fill="currentColor" aria-hidden="true"><path d="M884 256h-75c-5.1 0-9.9 2.5-12.9 6.6L512 654.2 227.9 262.6c-3-4.1-7.8-6.6-12.9-6.6h-75c-6.5 0-10.3 7.4-6.5 12.7l352.6 486.1c12.8 17.6 39 17.6 51.7 0l352.6-486.1c3.9-5.3.1-12.7-6.4-12.7z"></path></svg></i></span></div><div class="ant-input-number-input-wrap"><input type="number" class="ant-input-number-input" ng-model="vm.ngModel" ng-keypress="$event.keyCode === 13 ? ngKeypress(this) : return" ng-blur="ngBlur(this)"></div></div><!-- \u98CE\u683C\u4E8C --><div class="ant-input-number2" ng-if="vm.typeStyle == \'two\'"><input type="number" ng-model="vm.ngModel" ng-keypress="$event.keyCode === 13 ? ngKeypress(this) : return" ng-blur="ngBlur(this)"><div class="ant-input-number2-handler-wrap"><i class="iconfont icon-shangjiantou" ng-click="up(this)"></i> <i class="iconfont icon-xiajiantou" ng-click="down(this)"></i></div></div><input type="radio" class="focusInput" style="position: absolute;left: -9999px;top: -9999px;z-index: -1;opacity: 0">');
$templateCache.put('app/entities/components/local-loading.html','<!-- \u4F7F\u7528\u65F6\uFF0C\u7236\u5143\u7D20\u8BBE\u7F6E\u76F8\u5BF9\u5B9A\u4F4D\uFF0C\u9700\u8981\u6709\u6700\u5C0F\u9AD8\u5EA6\uFF0C\u9ED8\u8BA4\u5BBD\u9AD8100% --><div class="local-loading" ng-if="vm.show"><img class="loading-icon" src="/content/images/icon/loading-all.gif" alt="{{vm.title}}"><div class="loading-title">{{vm.title}}</div></div><style>.local-loading{\n        position: absolute;\n        top: 0;\n        left: 0;\n        width: 100%;\n        height: 100%;\n        background: #ffffff;\n        display: flex;\n        flex-direction: column;\n        justify-content: center;\n        align-items: center;\n\n    }\n    .local-loading .loading-icon{\n        width: 48px;\n        margin-bottom: 8px;\n    }\n    .local-loading .loading-title{\n        color: #264DF0;\n        font-size: 14px;\n    }</style>');
$templateCache.put('app/entities/components/modele-color-picker.html','<div class="modele-color-picker" style="position: relative"><div class="color-box" ng-style="{\'background\':vm.color}"></div></div><style>.modele-color-picker{\n        display: flex;\n    }\n    .modele-color-picker .color-box{\n        width: 28px;\n        height: 28px;\n        border: 1px solid #dddddd;\n        background-image: linear-gradient(45deg, #eee 25%, transparent 25%, transparent 75%, #eee 75%, #eee), linear-gradient(45deg, #eee 25%, transparent 25%, transparent 75%, #eee 75%, #eee);\n        background-size: 16px 16px;\n        background-position: 0 0, 8px 8px;\n        border-radius: 4px;\n        cursor: pointer;\n    }</style>');
$templateCache.put('app/entities/components/modele-pagination.html','<!-- \u5206\u9875\u7EC4\u4EF6 --><div class="modele-pagination" ng-class="{\'empty\' : vm.total == 0}"><div id="modele-pagination"></div><div class="page-count">\u5171{{vm.pages}}\u9875</div></div>');
$templateCache.put('app/entities/components/modele-select.html','<div class="modele-select" ng-click="clickInput()" style="{{vm.style || \'\'}}" ng-class="{\'open\' : vm.showOption}"><div class="prefix" ng-if="vm.prefix">{{ vm.prefix }}</div><input value="{{vm.getShowName()}}" class="modele-select-input" type="text" readonly="readonly" placeholder="{{vm.placeholder}}"> <i class="arrow iconfont icon-down"></i></div>');
$templateCache.put('app/entities/components/outline-view.html','<div class="three-modal"><div class="c-modal"><div class="c-modal-head" style="border: none"><span style="font-weight: bold">\u7F16\u8F91\u5200\u7EBF</span> <img style="float: right; width: 20px" src="content/images/icons/close1.svg" ng-click="modalHide()"></div><div class="c-modal-body chalk-view" style="text-align: left"><div class="chalk-view-1"><div class="chalk-view-1-3"><div ng-style="{\n                        position: \'relative\',\n                        width: vm.scale * page.mediabox.width,\n                        height: vm.scale * page.mediabox.height,\n                        background: \'#ddd\'}"><div style="width: 100%;height:100%;position: relative" ng-if="!vm.threeLoading"><img ng-if="page.outline && page.outline.cutline.resource && page.outline.cutline.resource.identifier" ng-src="{{page.outline.cutline.resource.identifier}}" style="width: 100%; height: 100%; pointer-events: none; position: absolute;left: 0; top: 0;z-index: 10"><div ng-if="!page.outline" class="border-outline" ng-style="{\n                                \'width\':page.trimbox.width * vm.scale,\n                                \'height\':page.trimbox.height * vm.scale,\n                                \'left\':page.trimbox.x * vm.scale,\n                                \'top\':page.trimbox.y * vm.scale,\n                            }"></div><page-preview page="page" scale="vm.scale"></page-preview></div><!-- <div class="not-text" ng-if="!page.outline || !page.outline.cutline.resource || !page.outline.cutline.resource.identifier">\u6682\u65E0\u6587\u4EF6</div> --><!-- \u9AD8\u5EA6\u6807\u6CE8\u7EBF\uFF08\u5DE6\u4FA7\uFF09 --><div class="dimension-h"><span class="dimension-h-tick dimension-h-tick-top"></span> <span class="dimension-h-text">{{vm.height}}mm</span> <span class="dimension-h-tick dimension-h-tick-bottom"></span></div><!-- \u5BBD\u5EA6\u6807\u6CE8\u7EBF\uFF08\u5E95\u90E8\uFF09 --><div class="dimension-w"><span class="dimension-w-tick dimension-w-tick-left"></span> <span class="dimension-w-text">{{vm.width}}mm</span> <span class="dimension-w-tick dimension-w-tick-right"></span></div></div></div></div><div class="chalk-view-2"><div class="chalk-view-2-2"><i class="iconfont iconshangchuanzhaopian1"></i> <span>\u4E0A\u4F20\u81EA\u5B9A\u4E49\u5200\u7EBF</span> <input onchange="updatePic(event)" type="file" accept="image/png"></div><div class="chalk-view-2-2 chalk-view-2-2-reset" ng-click="resetOutline()"><i class="iconfont iconqingchu"></i> <span>\u91CD\u65B0\u751F\u6210\u5200\u7EBF</span></div><div class="outline-width-control" ng-if="page.outline && page.outline.type && page.outline.type === \'cutline\' && page.outline.cutline.resource && page.outline.cutline.resource.identifier"><div class="outline-width-title">\u63CF\u8FB9\u5927\u5C0F</div><div class="outline-width-slider"><input class="outline-width-range" type="range" min="0" max="5" step="1" ng-model="vm.outlineWidth" ng-change="vm.changeOutlineWidth()" ng-model-options="{ debounce: 250 }" aria-label="\u63CF\u8FB9\u5927\u5C0F"><div class="outline-width-ticks" aria-hidden="true"><span></span><span></span><span></span><span></span><span></span><span></span></div></div><div class="outline-width-labels"><span>\u6EE1\u5207</span> <span>1mm</span> <span>2mm</span> <span>3mm</span> <span>4mm</span> <span>5mm</span></div></div><div class="chalk-view-2-2 chalk-view-2-2-delete" style="margin-top: 60px" ng-click="removeOutline()" ng-if="page.outline && page.outline.cutline.resource && page.outline.cutline.resource.identifier"><i class="iconfont iconqingchu"></i> <span>\u5220\u9664\u5200\u7EBF</span></div></div></div><div class="c-modal-foot"><button class="confirm-dialog-footer-cancel" ng-click="modalHide()">\u53D6\u6D88</button> <button class="confirm-dialog-footer-delete" ng-click="save()">\u4FDD\u5B58</button></div></div></div><div class="three-modal1" ng-if="vm.threeLoading"><img src="content/images/icon/loading-all.gif" alt=""><div>{{vm.threeLoadingText}}</div></div><!-- \u7F29\u7565\u56FE --><div id="thumbnail-outline" ng-if="page" style="position: absolute;left: 0;top: 0; z-index: -1; overflow: hidden"><page-preview page="page" scale="1" thumbnail="true"></page-preview></div><!-- \u5200\u7EBF\u5931\u8D25 --><div class="three-modal" style="z-index: 1011" ng-if="vm.errorImage" ng-class="{\'c-mode-modal\': vm.isMobile}"><div class="c-modal"><div class="c-modal-head" style="border: none"><span style="font-weight: bold">\u7F16\u8F91\u5200\u7EBF</span> <img style="float: right; width: 20px" src="content/images/icons/close1.svg" ng-click="vm.errorImage = null"></div><div class="c-modal-body" style="text-align: left; padding: 0 20px"><div style="color: #333; font-size: 16px; line-height: 30px">\u68C0\u6D4B\u5230\u6587\u4EF6\u5F02\u5E38\uFF0C\u8BF7\u4FEE\u6539\u540E\u91CD\u65B0\u4E0A\u4F20</div><div style="color: #333; font-size: 14px; line-height: 30px"><i class="iconfont iconjinggao1" style="color: #FF4D4F"></i>\u5355\u90E8\u4EF6\u4EC5\u652F\u6301\u8BBE\u8BA1\u4E00\u4E2A\u5916\u8F6E\u5ED3\uFF0C\u591A\u4E2A\u5206\u79BB\u5916\u8F6E\u5ED3\u8BF7\u521B\u5EFA\u591A\u4E2A\u90E8\u4EF6</div><div style="width: 100%; display: flex; justify-content: center; align-items: center; padding: 30px 0"><div ng-style="{\n                position: \'relative\',\n                width: vm.scale1 * page.mediabox.width,\n                height: vm.scale1 * page.mediabox.height}"><img ng-src="{{vm.errorImage.image}}" style="width: 100%; height: 100%"><div class="outline-error-mask" style="position: absolute; left: 0; top: 0; width: 100%; height: 100%; mask-size: cover" ng-style="{\'mask-image\': \'url(\' + vm.errorImage.multiple + \')\'}"></div></div></div></div><div class="c-modal-foot"><button class="confirm-dialog-footer-cancel" ng-click="vm.errorImage = null">\u53D6\u6D88</button> <button class="confirm-dialog-footer-delete" style="position: relative"><span>\u91CD\u65B0\u4E0A\u4F20</span> <input onchange="updatePic(event)" type="file" accept="image/png"></button></div></div></div><style>.border-outline{\n        position: absolute;\n        z-index: 402;\n        pointer-events: none !important;\n        border:1px solid #ee3f3f;\n        background: unset\n    }\n    .three-modal{\n        position: fixed;\n        left: 0;\n        top: 0;\n        right: 0;\n        bottom: 0;\n        background: rgba(0,0,0,0.6);\n        z-index: 1010;\n    }\n    .c-modal {\n        width: 1090px;\n        height: auto;\n        background: #fff;\n        border-radius: 8px;\n        margin: 50px auto;\n    }\n\n    .chalk-view {\n        padding: 24px;\n        height: 100%;\n        display: flex;\n        justify-content: space-between;\n    }\n\n    .chalk-view-1 {\n        width: 600px;\n        height: 600px;\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        position: relative;\n    }\n\n    .chalk-view-1-3 {\n        width: 100%;\n        height: 100%;\n        display: flex;\n        justify-content: center;\n        align-items: center;\n    }\n\n    .chalk-view-2 {\n        width: 400px;\n    }\n\n    .chalk-view-2-2 {\n        position: relative;\n        margin-top: 16px;\n        width: 100%;\n        height: 40px;\n        background: #FC5722;\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        color: #fff;\n        font-size: 14px;\n        border-radius: 8px;\n        cursor: pointer;\n    }\n\n    input[type="file"] {\n        width: 100%;\n        height: 100%;\n        position: absolute;\n        top: 0;\n        left: 0;\n        opacity: 0;\n        cursor: pointer;\n        z-index: 1;\n    }\n    .chalk-view-2-2-reset{\n        background: #176be8;\n        color: #fff;\n    }\n    .chalk-view-2-2-delete {\n        background: #ffa503;\n        color: #fff;\n    }\n\n    .outline-width-control {\n        margin-top: 16px;\n        width: 100%;\n        color: #666666;\n    }\n\n    .outline-width-title {\n        font-size: 14px;\n        line-height: 20px;\n    }\n\n    .outline-width-range {\n        width: 100% !important;\n        height: 4px !important;\n        margin: 10px 0 8px !important;\n        appearance: none !important;\n        -webkit-appearance: none !important;\n        background:\n            radial-gradient(circle at 0% 50%, #FFFFFF 0, #FFFFFF 5px, #D1D5DB 5px, #D1D5DB 7px, transparent 7px),\n            radial-gradient(circle at 20% 50%, #FFFFFF 0, #FFFFFF 5px, #D1D5DB 5px, #D1D5DB 7px, transparent 7px),\n            radial-gradient(circle at 40% 50%, #FFFFFF 0, #FFFFFF 5px, #D1D5DB 5px, #D1D5DB 7px, transparent 7px),\n            radial-gradient(circle at 60% 50%, #FFFFFF 0, #FFFFFF 5px, #D1D5DB 5px, #D1D5DB 7px, transparent 7px),\n            radial-gradient(circle at 80% 50%, #FFFFFF 0, #FFFFFF 5px, #D1D5DB 5px, #D1D5DB 7px, transparent 7px),\n            radial-gradient(circle at 100% 50%, #FFFFFF 0, #FFFFFF 5px, #D1D5DB 5px, #D1D5DB 7px, transparent 7px),\n            #E5E7EB !important;\n        border-radius: 2px !important;\n        cursor: pointer !important;\n        vertical-align: middle !important;\n    }\n\n    .outline-width-slider {\n        position: relative;\n        height: 14px;\n        margin: 10px 0 8px;\n    }\n\n    .outline-width-slider::before {\n        content: \'\';\n        position: absolute;\n        top: 5px;\n        right: 7px;\n        left: 7px;\n        height: 4px;\n        background: #E5E7EB;\n        border-radius: 2px;\n    }\n\n    .outline-width-slider .outline-width-range {\n        position: absolute;\n        top: 1px;\n        left: 0;\n        z-index: 2;\n        margin: 0 !important;\n        background: transparent !important;\n    }\n\n    .outline-width-range::-webkit-slider-runnable-track {\n        background: transparent;\n    }\n\n    .outline-width-range::-moz-range-track {\n        background: transparent;\n    }\n\n    .outline-width-ticks {\n        position: absolute;\n        top: 0;\n        left: 7px;\n        right: 7px;\n        z-index: 1;\n        pointer-events: none;\n    }\n\n    .outline-width-ticks span {\n        position: absolute;\n        top: 0;\n        width: 14px;\n        height: 14px;\n        margin-left: -7px;\n        box-sizing: border-box;\n        background: #FFFFFF;\n        border: 2px solid #D1D5DB;\n        border-radius: 50%;\n    }\n\n    /* \u84DD\u5708thumb\u5706\u5FC3\u5728 7px ~ (100% - 7px) \u95F4\u79FB\u52A8\uFF0C\u7070\u70B9\u6309\u540C\u4E00\u8F68\u8FF9\u5B9A\u4F4D */\n    .outline-width-ticks span:nth-child(1) { left: calc(7px + (100% - 14px) * 0 / 5); }\n    .outline-width-ticks span:nth-child(2) { left: calc(7px + (100% - 14px) * 1 / 5); }\n    .outline-width-ticks span:nth-child(3) { left: calc(7px + (100% - 14px) * 2 / 5); }\n    .outline-width-ticks span:nth-child(4) { left: calc(7px + (100% - 14px) * 3 / 5); }\n    .outline-width-ticks span:nth-child(5) { left: calc(7px + (100% - 14px) * 4 / 5); }\n    .outline-width-ticks span:nth-child(6) { left: calc(7px + (100% - 14px) * 5 / 5); }\n\n    .outline-width-range::-webkit-slider-thumb {\n        width: 14px !important;\n        height: 14px !important;\n        box-sizing: border-box !important;\n        appearance: none !important;\n        -webkit-appearance: none !important;\n        background: #FFFFFF !important;\n        border: 2px solid #0A8DFE !important;\n        border-radius: 50% !important;\n    }\n\n    .outline-width-range::-moz-range-thumb {\n        width: 14px !important;\n        height: 14px !important;\n        box-sizing: border-box !important;\n        background: #FFFFFF !important;\n        border: 2px solid #0A8DFE !important;\n        border-radius: 50% !important;\n    }\n\n    .outline-width-labels {\n        display: flex;\n        justify-content: space-between;\n        font-size: 12px;\n        color: #A1A1AA;\n        line-height: 16px;\n    }\n\n    /* \u79FB\u52A8\u7AEF */\n    .c-mobile-modal {\n        position: relative;\n        width: 100%;\n        height: 100%;\n        background: #fff;\n        padding-top: 100px;\n    }\n\n    .mobile-btn {\n        width: 60px;\n        height: 35px;\n        background: #FFFFFF;\n        box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.1);\n        border-radius: 16px;\n        font-weight: 500;\n        font-size: 14px;\n        color: #333333;\n        display: flex;\n        justify-content: center;\n        align-items: center;\n    }\n\n    .mobile-content {\n        position: relative;\n        width: 343px;\n        height: 343px;\n        margin: 0 auto 20px;\n    }\n\n    .mobile-content-1 {\n        width: 100%;\n        height: 100%;\n        display: flex;\n        justify-content: center;\n        align-items: center;\n    }\n\n    .mobile-content-2 {\n        position: relative;\n        width: 100%;\n        height: 100%;\n        display: flex;\n        justify-content: center;\n        align-items: center;\n    }\n\n    .mobile-content-2-1 {\n        position: relative;\n        width: 100%;\n        height: 110px;\n        display: flex;\n        flex-wrap: wrap;\n        justify-content: center;\n        align-items: center;\n        color: #0A8DFE;\n        font-size: 16px;\n        font-weight: bold;\n        text-align: center;\n    }\n\n    .mobile-content-2-1 i {\n        font-size: 32px;\n    }\n\n    .mobile-foot {\n        position: fixed;\n        left: 0;\n        bottom: 0;\n        width: 100%;\n        height: 88px;\n        background: #FFFFFF;\n        box-shadow: 0px -12px 21px -10px rgba(6, 6, 6, 0.11);\n        display: flex;\n        justify-content: space-between;\n        padding: 16px;\n    }\n\n    .mobile-foot .outline-width-control {\n        margin: 0;\n    }\n\n    .mobile-btn-2 {\n        position: relative;\n        width: 80px;\n        height: 35px;\n        background: #fff;\n        color: #FB5721;\n        border: 1px solid #FB5721;\n        border-radius: 20px;\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        font-size: 14px;\n    }\n\n    .mobile-btn-3 {\n        width: 80px;\n        height: 35px;\n        background: #FB5721;\n        color: #fff;\n        border: 1px solid #FB5721;\n        border-radius: 20px;\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        font-size: 14px;\n        color: #FFFFFF;\n    }\n\n    /* \u5C3A\u5BF8\u6807\u6CE8\u7EBF */\n    .dimension-h {\n        position: absolute;\n        left: -18px;\n        top: 0;\n        height: 100%;\n        display: flex;\n        flex-direction: column;\n        align-items: center;\n        justify-content: space-between;\n        z-index: 2;\n    }\n    .dimension-h::before {\n        content: \'\';\n        position: absolute;\n        left: 50%;\n        top: 6px;\n        bottom: 6px;\n        width: 1px;\n        background: #0A8DFE;\n        transform: translateX(-50%);\n    }\n    .dimension-h-tick {\n        width: 8px;\n        height: 1px;\n        background: #0A8DFE;\n        flex-shrink: 0;\n    }\n    .dimension-h-text {\n        position: absolute;\n        top: 50%;\n        left: 50%;\n        transform: translate(-50%, -50%) rotate(-90deg);\n        background: #F4F5F6;\n        padding: 2px 4px;\n        font-size: 11px;\n        color: #0A8DFE;\n        font-weight: normal;\n        white-space: nowrap;\n    }\n\n    .dimension-w {\n        position: absolute;\n        bottom: -18px;\n        left: 0;\n        width: 100%;\n        display: flex;\n        align-items: center;\n        justify-content: space-between;\n        z-index: 2;\n    }\n    .dimension-w::before {\n        content: \'\';\n        position: absolute;\n        top: 50%;\n        left: 6px;\n        right: 6px;\n        height: 1px;\n        background: #0A8DFE;\n        transform: translateY(-50%);\n    }\n    .dimension-w-tick {\n        width: 1px;\n        height: 8px;\n        background: #0A8DFE;\n        flex-shrink: 0;\n    }\n    .dimension-w-text {\n        position: absolute;\n        top: 50%;\n        left: 50%;\n        transform: translate(-50%, -50%);\n        background: #F4F5F6;\n        padding: 2px 4px;\n        font-size: 11px;\n        color: #0A8DFE;\n        font-weight: normal;\n        white-space: nowrap;\n    }\n\n    .not-text{\n        width: 100%;\n        height: 100%;\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        font-size: 18px;\n    }\n    .mobile-head{\n        position: fixed;\n        left: 0;\n        top: 0;\n        width: 100%;\n        background: #FFFFFF;\n        box-shadow: 0px 12px 21px -10px rgba(6, 6, 6, 0.11);\n        display: flex;\n        justify-content: space-between;\n        padding: 16px;\n    }\n    \n    /* \u5200\u7EBF\u5F02\u5E38\u9AD8\u4EAE\uFF1A\u7EA2\u8272\u80CC\u666F + \u95EA\u70C1\u52A8\u753B\uFF08\u901A\u8FC7 mask \u53EA\u663E\u793A\u5F02\u5E38\u8F6E\u5ED3\u533A\u57DF\uFF09 */\n    .outline-error-mask {\n        background: #FF4D4F;\n        animation: outline-error-blink 0.8s ease-in-out infinite;\n    }\n\n    @keyframes outline-error-blink {\n        0%, 100% { opacity: 1; }\n        50% { opacity: 0.25; }\n    }\n    \n    .c-mode-modal .c-modal{\n        position: absolute;\n        left: 0;\n        bottom: 0;\n        width: 100%;\n        border-radius: 8px 8px 0 0;\n        margin: 0;\n    }\n    .c-mode-modal .c-modal-body{\n        padding: 0 20px;\n    }\n    .c-mode-modal .c-modal-foot{\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        gap: 20px;\n    }\n    .c-mode-modal .c-modal-foot button{\n        width: 40%;\n        height: 40px;\n        border-radius: 20px;\n        font-size: 14px;\n        margin: 0;\n    }</style>');
$templateCache.put('app/entities/components/page-preview.html','<div ng-style="{\n        \'width\': vm.page.custom.width * vm.scale,\n        \'height\': vm.page.custom.height * vm.scale,\n        \'box-shadow\' : !vm.page.boxShadow ? \'0px 0px 13px 0 rgba(0, 0, 0, 0.3)\' : \'none\'\n    }" style="overflow: hidden;position: relative"><div ng-if="!vm.isCover || !vm.page.pagecover || !vm.page.pagecover.identifier" style="position: relative" ng-style="{\n                                        \'width\': vm.page.custom.width * vm.scale,\n                                        \'height\': vm.page.custom.height * vm.scale\n                                    }"><div style="width: 100%; height: 100%; position: absolute" ng-if="vm.page.scene && !vm.cover" ng-style="{\n                    \'position\': \'absolute\',\n                    \'width\': vm.page.custom.width * vm.scale,\n                    \'height\': vm.page.custom.height * vm.scale,\n                    \'z-index\': vm.page.scene.hierarchy == \'TOP\' ? \'1\' : \'0\',\n                    \'pointer-events\': \'none\'\n                }"><img ng-src="{{vm.page.scene.background ? vm.page.scene.background.resource.identifier : vm.page.scene.resource.identifier}}?imageMogr2/thumbnail/800x800>" alt="" ng-style="{\n                                            \'width\': vm.page.custom.width*vm.scale\n                                        }"><div ng-style="{\n                                            \'position\': \'absolute\',\n                                            \'width\': vm.page.scene.imagebox.geometry.width * vm.scale,\n                                            \'height\': vm.page.scene.imagebox.geometry.height * vm.scale,\n                                            \'left\': vm.page.scene.imagebox.geometry.x * vm.scale,\n                                            \'top\': vm.page.scene.imagebox.geometry.y * vm.scale,\n                                            \'transform\': \'rotate(\' + vm.page.scene.imagebox.rotation.angle + \'deg)\',\n                                        }"></div></div><div style="width: 100%; height: 100%; position: relative" ng-style="{\n                \'z-index\': vm.page.scene && !vm.cover && vm.page.scene.hierarchy == \'TOP\' ? 0 : 1\n            }"><div ng-style="{\n                                        \'position\': \'absolute\',\n                                        \'width\': vm.page.mediabox.width * vm.scale,\n                                        \'height\': vm.page.mediabox.height * vm.scale,\n                                        \'left\': vm.page.scene && !vm.cover ? vm.page.scene.imagebox.geometry.x * vm.scale : vm.page.mediabox.x * vm.scale,\n                                        \'top\': vm.page.scene && !vm.cover ? vm.page.scene.imagebox.geometry.y * vm.scale : vm.page.mediabox.y * vm.scale,\n                                        \'background\': vm.page.background.color ? vm.page.background.color : \'\',\n                                        }"><div style="width: 100%; height: 100%; position: relative; overflow: hidden"><img ng-src="{{vm.page.background.resource.identifier}}?imageMogr2/thumbnail/800x800>" alt="" ng-if="vm.page.background.resource.identifier" ng-style="{\n                                                    \'position\': \'absolute\',\n                                                    \'width\': vm.page.background.resource.adaptation == \'Width\' || vm.page.background.adaptation == \'Width\' ? (vm.page.mediabox1 ? vm.page.mediabox1.width : vm.page.mediabox.width) * vm.scale : \'auto\',\n                                                    \'height\': vm.page.background.resource.adaptation == \'Height\' || vm.page.background.adaptation == \'Height\' ? (vm.page.mediabox1 ? vm.page.mediabox1.height : vm.page.mediabox.height) * vm.scale : \'auto\',\n                                                    \'left\': vm.page.background.offsetx * vm.scale,\n                                                    \'top\': vm.page.background.offsety * vm.scale\n                                                }"><div style="position: absolute;width: 100%; height: 100%; left: 0; top: 0" ng-repeat="level in vm.page.levels.level"><div ng-if="level.code&&level.code.geometry" ng-style="{\n                         \'position\':\'absolute\',\n                        \'width\': level.code.geometry.width*vm.scale,\n                         \'height\': level.code.geometry.height*vm.scale,\n                         \'left\': level.code.geometry.x*vm.scale,\n                         \'top\': level.code.geometry.y*vm.scale,\n                         \'z-index\':level.seq-0+200,\n                         \'transform\': \'rotate(-\' + level.code.rotation.angle + \'deg)\'\n                        }"><img src="content/images/QrCode.png" alt="" style="width: 100%; height: 100%"></div><div ng-if="level.imagebox" class="imageboxView imageboxView{{vm.pageIndex}}{{$index}}" data-imgindex="{{$index}}" ng-style="{\n                             \'position\': \'absolute\',\n                                width: imageboxW(level.imagebox)*vm.scale,\n                                height: imageboxH(level.imagebox)*vm.scale,\n                                left: imageboxL(level.imagebox)*vm.scale,\n                                top: imageboxT(level.imagebox)*vm.scale,\n                                \'z-index\':level.seq-0+200,\n                                \'transform\': \'rotate(-\' + level.imagebox.rotation.angle + \'deg)\',\n                                        }"><div ng-style="{\n                                        \'position\': \'absolute\',\n                                        \'z-index\':0,\n                                        \'left\': (level.imagebox.border && level.imagebox.border.type == \'Pic\') ? -imageboxWEdge(level.imagebox,\'left\')*vm.scale : 0,\n                                        \'top\': (level.imagebox.border && level.imagebox.border.type == \'Pic\') ? -imageboxWEdge(level.imagebox,\'top\')*vm.scale : 0,\n                                        \'right\': (level.imagebox.border && level.imagebox.border.type == \'Pic\') ? -imageboxWEdge(level.imagebox,\'right\')*vm.scale : 0,\n                                        \'bottom\': (level.imagebox.border && level.imagebox.border.type == \'Pic\') ? -imageboxWEdge(level.imagebox,\'bottom\')*vm.scale : 0,\n                                        \'background-image\': (level.imagebox.border && level.imagebox.border.type == \'Pic\') ? \'url(\' + level.imagebox.border.resource.identifier + \')\' : \'\',\n                                        \'background-size\': (level.imagebox.border && level.imagebox.border.type == \'Pic\') ? \'100% 100%\' : \'\'\n                                        }"></div><div class="relative-view2"><div class="relative-view1" data-imgindex="{{$index}}" ng-style="{\n                                                    \'overflow\': (level.imagebox.border && level.imagebox.border.type == \'Pic\') ? \'unset\' : \'hidden\',\n                                                    \'opacity\':level.imagebox.transparency,\n                                                    \'border-top-left-radius\':(level.imagebox.border && level.imagebox.border.type == \'Pic\') ? 0 : imageboxWRadius(level.imagebox, \'lt\',vm.scale),\n                                                    \'border-top-right-radius\':(level.imagebox.border && level.imagebox.border.type == \'Pic\') ? 0 : imageboxWRadius(level.imagebox, \'rt\',vm.scale),\n                                                    \'border-bottom-right-radius\':(level.imagebox.border && level.imagebox.border.type == \'Pic\') ? 0 : imageboxWRadius(level.imagebox, \'rb\',vm.scale),\n                                                    \'border-bottom-left-radius\':(level.imagebox.border && level.imagebox.border.type == \'Pic\') ? 0 : imageboxWRadius(level.imagebox, \'lb\',vm.scale),\n                                                    \'border-width\': (level.imagebox.border && level.imagebox.border.type == \'Color\') ? ((level.imagebox.border.lineWidth*vm.scale) | number:0) : \'\',\n                                                    \'border-style\': (level.imagebox.border && level.imagebox.border.type == \'Color\') ? (level.imagebox.border.lineType || \'solid\') : \'none\',\n                                                    \'border-color\': (level.imagebox.border && level.imagebox.border.type == \'Color\') ? level.imagebox.border.color : \'\',\n                                                    \'box-shadow\' : (level.imagebox.border && level.imagebox.border.type == \'Color\' && level.imagebox.border.lineWidth>0 && (!level.imagebox.border.lineType || level.imagebox.border.lineType == \'solid\')) ? \'0 0 0 1px \' + level.imagebox.border.color + \' inset\' : \'none\',\n                                                    \'filter\' : dropShadow(level.imagebox,vm.scale),\n                                        }"><div class="relative-view1" data-imgindex="{{$index}}" ng-style="{\n                                            \'-webkit-mask-image\': level.imagebox.mask.resource.identifier ? \'url(\' + level.imagebox.mask.resource.identifier + \')\' : \'none\',\n                                            \'-webkit-mask-size\': \'100% 100%\',\n                                            \'border-top-left-radius\':imageboxWRadius1(level.imagebox, \'lt\',vm.scale),\n                                            \'border-top-right-radius\':imageboxWRadius1(level.imagebox, \'rt\',vm.scale),\n                                            \'border-bottom-right-radius\':imageboxWRadius1(level.imagebox, \'rb\',vm.scale),\n                                            \'border-bottom-left-radius\':imageboxWRadius1(level.imagebox, \'lb\',vm.scale),\n                                            }"><div ng-if="!level.imagebox.image || !level.imagebox.image.resource || !level.imagebox.image.resource.identifier" data-imgindex="{{$index}}" class="image-placeholder image-placeholder-class"><!--                                            <img src="content/images/icons/camera.svg"--><!--                                                 ng-style="{\'width\':imageboxW(level.imagebox)*vm.page[vm.pageIndex].custom.ratio <= 56 || imageboxH(level.imagebox)*vm.page[vm.pageIndex].custom.ratio <= 56 ? \'50%\' : \'\' ,\'height\':imageboxW(level.imagebox)*vm.page[vm.pageIndex].custom.ratio <= 58 || imageboxH(level.imagebox)*vm.page[vm.pageIndex].custom.ratio <= 58 ? \'50%\' : \'\'}">--></div><div style="position: relative;width: 100%; height: 100%;overflow: hidden" ng-if="level.imagebox.image.resource.identifier" data-imgindex="{{$index}}"><img alt="" data-imgindex="{{$index}}" ng-if="level.imagebox.image.resource.identifier" ng-src="{{level.imagebox.image.resource.identifier+ \'?imageMogr2/strip/rotate/\' + (level.imagebox.image.angle||0)+\'/thumbnail/800x800>\'}}" ng-style="{\n                                                        \'transform\': level.imagebox.flip ? \'rotateY(180deg)\' : \'unset\',\n                                                        \'position\': \'absolute\',\n                                                        \'width\': level.imagebox.image.width*vm.scale*level.imagebox.image.scale,\n                                                        \'height\': level.imagebox.image.height*vm.scale*level.imagebox.image.scale,\n                                                        \'left\':level.imagebox.image.offsetx*vm.scale*level.imagebox.image.scale,\n                                                        \'top\':level.imagebox.image.offsety*vm.scale*level.imagebox.image.scale\n                                                    }"></div><!--                                        <div style="position: relative;width: 100%; height: 100%;overflow: hidden;"--><!--                                             ng-if="level.imagebox.bokehtype == \'Blurred\' && level.imagebox.image.resource.identifier"--><!--                                             data-imgIndex="{{$index}}">--><!--                                            <img class="c-blur" alt=""--><!--                                                 ng-if="level.imagebox.image.resource.identifier"--><!--                                                 ng-src="{{level.imagebox.image.resource.identifier+ \'?imageMogr2/strip/rotate/\' + level.imagebox.image.angle+\'/thumbnail/800x800/blur/40x1000\'}}"--><!--                                                 data-index="{{$index}}"--><!--                                                 data-imgIndex="{{$index}}"--><!--                                                 ng-style="{--><!--                                                        \'transform\': level.imagebox.flip ? \'rotateY(180deg)\' : \'unset\',--><!--                                                    \'position\': \'absolute\',--><!--                                                }">--><!--                                            <img--><!--                                                ng-src="{{level.imagebox.image.resource.identifier+ \'?imageMogr2/strip/rotate/\' + level.imagebox.image.angle+\'/thumbnail/800x800>\'}}"--><!--                                                data-imgIndex="{{$index}}"--><!--                                                ng-if="level.imagebox.image.resource.identifier"--><!--                                                ng-style="{--><!--                                                        \'transform\': level.imagebox.flip ? \'rotateY(180deg)\' : \'unset\',--><!--                                                        \'position\': \'absolute\',--><!--                                                        \'width\': level.imagebox.blurredrectangle.width*vm.scale*level.imagebox.image.scale,--><!--                                                        \'height\': level.imagebox.blurredrectangle.height*vm.scale*level.imagebox.image.scale,--><!--                                                        \'left\':level.imagebox.blurredrectangle.x*vm.scale*level.imagebox.image.scale,--><!--                                                        \'top\':level.imagebox.blurredrectangle.y*vm.scale*level.imagebox.image.scale,--><!--                                                    \'z-index\': 1--><!--                                                }">--><!--                                        </div>--><!--                                        <div style="position: relative;width: 100%; height: 100%;overflow: hidden;"--><!--                                             data-imgIndex="{{$index}}"--><!--                                             ng-if="level.imagebox.bokehtype == \'Transparent\' && level.imagebox.image.resource.identifier">--><!--                                            <img alt=""--><!--                                                 ng-src="{{level.imagebox.image.resource.identifier+ \'?imageMogr2/strip/rotate/\' + level.imagebox.image.angle+\'/thumbnail/800x800>\'}}"--><!--                                                 ng-if="level.imagebox.image.resource.identifier"--><!--                                                 data-index="{{$index}}"--><!--                                                 data-imgIndex="{{$index}}"--><!--                                                 ng-style="{--><!--                                                        \'transform\': level.imagebox.flip ? \'rotateY(180deg)\' : \'unset\',--><!--                                                    \'position\': \'absolute\',--><!--                                                    \'width\': level.imagebox.blurredrectangle.width*vm.scale*level.imagebox.image.scale,--><!--                                                    \'height\': level.imagebox.blurredrectangle.height*vm.scale*level.imagebox.image.scale,--><!--                                                    \'left\':level.imagebox.blurredrectangle.x*vm.scale*level.imagebox.image.scale,--><!--                                                    \'top\':level.imagebox.blurredrectangle.y*vm.scale*level.imagebox.image.scale--><!--                                                }">--><!--                                        </div>--></div></div></div></div><div ng-if="level.imageart" class="no-events" ng-style="{\n                                                    \'position\': \'absolute\',\n                                                    \'width\': level.imageart.geometry.width * vm.scale,\n                                                    \'height\': level.imageart.geometry.height * vm.scale,\n                                                    \'left\': level.imageart.geometry.x * vm.scale,\n                                                    \'top\': level.imageart.geometry.y * vm.scale,\n                                                            \'transform\': \'rotate(\' + level.imageart.rotation.angle + \'deg)\',\n                                                    \'z-index\':level.seq-0+200,\n                                                }"><div style="overflow: hidden; position: relative; width: 100%; height: 100%"><img ng-src="{{level.imageart.resource.identifier}}?imageMogr2/thumbnail/800x800>" alt="" ng-style="{\n                                                            \'position\': \'absolute\',\n                                                            \'width\': level.imageart.geometry.width * vm.scale * level.imageart.scale,\n                                                            \'left\': level.imageart.offsetx * vm.scale,\n                                                            \'top\': level.imageart.offsety * vm.scale,\n                                                            \'opacity\': level.imageart.transparency,\n                                                            \'transform\': level.imageart.flip ? \'rotateY(180deg)\' : \'unset\'\n                                                        }"></div></div><div ng-if="level.textbox" ng-style="{\n                                                    \'position\': \'absolute\',\n                                                    \'width\': level.textbox.geometry.width * vm.scale,\n                                                    \'height\': level.textbox.geometry.height * vm.scale,\n                                                    \'left\': level.textbox.geometry.x * vm.scale,\n                                                    \'top\': level.textbox.geometry.y * vm.scale,\n                                                    \'transform\': \'rotate(\' + level.textbox.rotation.angle + \'deg)\',\n                                                    \'z-index\': level.seq-0+200\n                                                }"><pre class="c-xml-page-textboxe-text web-font" data-index="{{$index}}" ng-style="{\n                                                        \'font-family\': \'\\\'\' + level.textbox.fontuuid + \'\\\'\',\n                                                        \'font-size\': (level.textbox.style.size*vm.scale > 12 ? level.textbox.style.size* vm.scale : 12) + \'pt\',\n                                                        \'color\': level.textbox.style.color,\n                                                        \'font-weight\': level.textbox.style.bold ? \'bold\': \'400\',\n                                                        \'font-style\': level.textbox.style.italic ? \'italic\': \'initial\',\n                                                        \'line-height\': (level.textbox.style.size * vm.scale > 12 ? level.textbox.style.lineheight * vm.scale : (level.textbox.style.lineheight * vm.scale) / (1 / 12 * level.textbox.style.size * vm.scale)) + \'pt\',\n                                                        \'letter-spacing\': (level.textbox.style.size * vm.scale > 12 ? level.textbox.style.letterspacing * vm.scale : (level.textbox.style.letterspacing * vm.scale) / (1 / 12 * level.textbox.style.size * vm.scale)) + \'pt\',\n                                                        \'opacity\': level.textbox.transparency,\n                                                        \'text-decoration\': \'none\',\n                                                        \'text-align\': level.textbox.style.align,\n                                                        \'text-align-last\': \'unset\',\n                                                        \'transform\':\'scale(\'+(1 / 12 * level.textbox.style.size* vm.scale > 1 ? 1 : 1 / 12 * level.textbox.style.size* vm.scale)+\')\',\n                                                        \'transform-origin\': \'0 0\',\n                                                        \'writing-mode\': level.textbox.style.writingmode,\n                                                        \'width\': level.textbox.style.size * vm.scale > 12 ? level.textbox.geometry.width * vm.scale : (level.textbox.geometry.width * vm.scale) / (1 / 12 * level.textbox.style.size * vm.scale) + \'px\',\n                                                        \'height\': level.textbox.style.size * vm.scale > 12 ? level.textbox.geometry.height * vm.scale : (level.textbox.geometry.height * vm.scale) / (1 / 12 * level.textbox.style.size * vm.scale) + \'px\'\n                                                    }"><span class="c-xml-page-textboxe-span">{{level.textbox.text}}</span></pre></div><div data-index="{{$index}}" ng-if="level.textdocument" ng-style="{\n                                                        position: \'absolute\',\n                                                        width: level.textdocument.geometry.width * vm.scale,\n                                                        height: level.textdocument.geometry.height * vm.scale,\n                                                        left: level.textdocument.geometry.x * vm.scale,\n                                                        top: level.textdocument.geometry.y * vm.scale,\n                                                        \'z-index\':level.seq-0+200,\n                                                        \'opacity\':level.textdocument.transparency.toFixed(2),\n                                                        filter: \'alpha(opacity=\'+level.textdocument.transparency*100+\')\',\n                                                        \'transform\': \'rotate(-\' + level.textdocument.rotation.angle + \'deg)\'}"><div style="overflow: hidden;width: 100%;height: 100%;position: relative" class="no-events"><img class="bg-image bg-image{{template.pageI}} pos" ng-cloak ng-if="level.textdocument.background.resource.identifier" ng-src="{{level.textdocument.background.resource.identifier+\'?imageMogr2/thumbnail/800x800>\'||\'//:0\'}}" ng-style="{\n                                                                position: \'absolute\',\n                                                                left:level.textdocument.background.offsetx * vm.scale,\n                                                                top:level.textdocument.background.offsety * vm.scale,\n                                                                width: level.textdocument.background.adaptation==\'Width\'?level.textdocument.geometry.width * vm.scale:\'\',\n                                                                height:level.textdocument.background.adaptation!=\'Width\'?level.textdocument.geometry.height * vm.scale:\'\'}"><div ng-repeat="docLevel in level.textdocument.levels.level track by $index" ng-init="docIndex = $index" style="position: relative"><div data-index="{{docIndex}}" class="img-art" ng-if="docLevel.imageart" ng-style="{\n                                                                    width: docLevel.imageart.geometry.width * vm.scale,\n                                                                    height: docLevel.imageart.geometry.height * vm.scale,\n                                                                    left: docLevel.imageart.geometry.x * vm.scale,\n                                                                    top: docLevel.imageart.geometry.y * vm.scale,\n                                                                    \'z-index\':docLevel.seq-0+200,\n                                                                    \'opacity\':docLevel.imageart.transparency,\n                                                                    filter: \'alpha(opacity=\'+docLevel.imageart.transparency*100+\')\',\n                                                                    \'transform\': \'rotate(\' + docLevel.imageart.rotation.angle + \'deg)\'}"><div style="overflow: hidden; position: relative; width: 100%; height: 100%"><img data-index="{{$index}}" style="transition: opacity 0.3s;position: absolute" ng-style="{\n                                                                            \'left\': docLevel.imageart.offsetx * vm.scale,\n                                                                            \'top\': docLevel.imageart.offsety * vm.scale,\n                                                                            \'width\': docLevel.imageart.geometry.width * vm.scale}" ng-src="{{docLevel.imageart.resource.identifier+\'?imageMogr2/thumbnail/800x800>\'}}"></div></div><div class="c-xml-page-textboxe" ng-show="docLevel.textbox" style="white-space: normal" data-index="{{docIndex}}" ng-style="{\n                                                                    \'width\': docLevel.textbox.geometry.width * vm.scale,\n                                                                    \'height\': docLevel.textbox.geometry.height * vm.scale,\n                                                                    \'left\': docLevel.textbox.geometry.x * vm.scale,\n                                                                    \'top\': docLevel.textbox.geometry.y * vm.scale,\n                                                                    \'z-index\':docLevel.seq-0+200,\n                                                                    \'transform\': \'rotate(\' + docLevel.textbox.rotation.angle + \'deg)\'}"><pre class="c-xml-page-textboxe-text web-font" ng-style="{\n                                                                \'font-family\':  \'\\\'\' + docLevel.textbox.fontuuid + \'\\\'\',\n                                                                \'font-size\': (docLevel.textbox.style.size*vm.scale > 12 ? docLevel.textbox.style.size* vm.scale : 12) + \'pt\',\n                                                                \'color\': docLevel.textbox.style.color,\n                                                                \'font-weight\': docLevel.textbox.style.bold ? \'bold\': \'400\',\n                                                                \'font-style\': docLevel.textbox.style.italic ? \'italic\': \'initial\',\n                                                                \'line-height\': (docLevel.textbox.style.size * vm.scale > 12 ? docLevel.textbox.style.lineheight * vm.scale : (docLevel.textbox.style.lineheight * vm.scale) / (1 / 12 * docLevel.textbox.style.size * vm.scale)) + \'pt\',\n                                                                \'letter-spacing\': (docLevel.textbox.style.size * vm.scale > 12 ? docLevel.textbox.style.letterspacing * vm.scale : (docLevel.textbox.style.letterspacing * vm.scale) / (1 / 12 * docLevel.textbox.style.size * vm.scale)) + \'pt\',\n                                                                \'opacity\': docLevel.textbox.transparency,\n                                                                \'text-decoration\': \'none\',\n                                                                \'text-align\': docLevel.textbox.style.align,\n                                                                \'text-align-last\': \'unset\',\n                                                                \'transform\':\'scale(\'+(1 / 12 * docLevel.textbox.style.size* vm.scale > 1 ? 1 : 1 / 12 * docLevel.textbox.style.size* vm.scale)+\')\',\n                                                                \'width\': docLevel.textbox.style.size * vm.scale > 12 ? docLevel.textbox.geometry.width * vm.scale : (docLevel.textbox.geometry.width * vm.scale) / (1 / 12 * docLevel.textbox.style.size * vm.scale) + \'px\'\n                                                            }"><span class="c-xml-page-textboxe-span">{{docLevel.textbox.text}}</span></pre></div></div></div></div><div ng-if="level.calMonthBox" class="no-events" ng-style="{\n                                                    \'position\': \'absolute\',\n                                                    \'width\': level.calMonthBox.geometry.width * vm.scale,\n                                                    \'height\': level.calMonthBox.geometry.height * vm.scale,\n                                                    \'left\': level.calMonthBox.geometry.x * vm.scale,\n                                                    \'top\': level.calMonthBox.geometry.y * vm.scale,\n                                                            \'transform\': \'rotate(\' + level.calMonthBox.rotation.angle + \'deg)\',\n                                                    \'z-index\':level.seq-0+200,\n                                                }"><month-table widget="level.calMonthBox" scale="vm.scale" year="level.calMonthBox.sampleYear" month="level.calMonthBox.sampleMonth" week="level.calMonthBox.startOfWeek" width="level.calMonthBox.geometry.width" height="level.calMonthBox.geometry.height" thumbnail="vm.thumbnail" update="level.calMonthBox.update" is-min="vm.isMin"></month-table></div><div ng-if="level.calTitleBox" class="no-events" ng-style="{\n                                                    \'position\': \'absolute\',\n                                                    \'width\': level.calTitleBox.geometry.width * vm.scale,\n                                                    \'height\': level.calTitleBox.geometry.height * vm.scale,\n                                                    \'left\': level.calTitleBox.geometry.x * vm.scale,\n                                                    \'top\': level.calTitleBox.geometry.y * vm.scale,\n                                                            \'transform\': \'rotate(\' + level.calTitleBox.rotation.angle + \'deg)\',\n                                                    \'z-index\':level.seq-0+200,\n                                                    \'overflow\': \'hidden\'\n                                                }"><title-cell width="level.calTitleBox.geometry.width" height="level.calTitleBox.geometry.height" scale="vm.scale" year="level.calTitleBox.sampleYear" month="level.calTitleBox.sampleMonth" widget="level.calTitleBox"></title-cell></div></div><div class="barcode" ng-show="vm.page.barcode && vm.page.barcode.geometry" ng-style="{\n                                                    \'z-index\':999,\n                                                    \'width\': vm.page.barcode.geometry.width * vm.scale,\n                                                    \'height\': vm.page.barcode.geometry.height * vm.scale,\n                                                    \'left\': vm.page.barcode.geometry.x * vm.scale,\n                                                    \'top\': vm.page.barcode.geometry.y * vm.scale,\n                                                    \'transform\': \'rotate(-\' + vm.page.barcode.rotation.angle + \'deg)\' }"><img src="content/images/txm.png" style="width: 100%;height: 100%"></div><div class="barcode" ng-show="vm.page.qrcode && vm.page.qrcode.geometry" ng-style="{\n                                                    \'z-index\':999,\n                                                    \'width\': vm.page.qrcode.geometry.width * vm.scale,\n                                                    \'height\': vm.page.qrcode.geometry.height * vm.scale,\n                                                    \'left\': vm.page.qrcode.geometry.x * vm.scale,\n                                                    \'top\': vm.page.qrcode.geometry.y * vm.scale,\n                                                    \'transform\': \'rotate(-\' + vm.page.qrcode.rotation.angle + \'deg)\' }"><img src="content/images/QrCode.png" style="width: 100%;height: 100%"></div></div></div></div></div><img ng-src="{{vm.page.pagecover.identifier}}" alt="" ng-if="vm.isCover && vm.page.pagecover && vm.page.pagecover.identifier" style="width: 100%; height: 100%"></div>');
$templateCache.put('app/entities/home-first/home-first.html','<!-- \u65B0ui --><div class="login_wrap"><div class="login_content"><div class="login_bg"></div><div class="login_box check_box" ng-if="vm.page1"><div class="login_title" style="margin-bottom: 64px">\u9996\u6B21\u8FDB\u5165-\u6570\u636E\u6821\u9A8C</div><div class="login_form check_form"><div class="check_prompt">\u60A8\u662F\u5426\u5DF2\u5728\u6A21\u677F\u5DE5\u5177\u521B\u5EFA\u8D26\u53F7\uFF1F</div><div class="radio_group" ng-class="{\'isAccount\' : vm.data.isAccount}"><div class="radio_item" ng-click="accountSelect(false)"><i class="iconfont icon-xuanze" ng-class="{\'active\' : !vm.data.isAccount}"></i> <span>\u5426</span></div><div class="radio_item" ng-click="accountSelect(true)"><i class="iconfont icon-xuanze" ng-class="{\'active\' : vm.data.isAccount}"></i> <span>\u662F</span></div></div><div ng-if="vm.data.isAccount"><div class="form_item send_code mb16"><i class="iconfont icon-shouji1 input_icon left"></i> <input ng-model="vm.phone" readonly="readonly" class="icon_left" ng-class="{\'checkErr\' : vm.checkPhoneErr}" type="text" placeholder="\u8BF7\u8F93\u5165\u624B\u673A\u53F7" ng-change="changePhone()"> <a class="btn_code pointer" ng-class="{\'disabled\' : vm.codeDisable}" ng-click="getCode()">{{vm.codeName}}</a></div><div class="form_item mb32"><i class="iconfont icon-yanzhengma1 input_icon left"></i> <input ng-model="vm.code" class="icon_left" type="text" placeholder="\u8BF7\u8F93\u5165\u9A8C\u8BC1\u7801"></div></div><div class="form_item"><button type="button" ng-click="save1()">\u4E0B\u4E00\u6B65</button></div></div></div><div class="login_box check_box" ng-if="vm.page2"><div class="login_title">\u9996\u6B21\u8FDB\u5165-\u4FE1\u606F\u5F55\u5165</div><div class="login_form check_form"><div class="form_item mb16"><i class="iconfont icon-zhanghao input_icon left"></i> <input ng-model="vm.data1.name" maxlength="50" class="icon_left" type="text" placeholder="\u8BF7\u8F93\u5165\u8D26\u53F7"></div><div class="form_item mb16"><i class="iconfont icon-mima1 input_icon left"></i> <input ng-model="vm.data1.password" maxlength="50" class="icon_left icon_right" type="{{vm.passType}}" placeholder="\u8BF7\u8F93\u5165\u65B0\u5BC6\u7801"> <i class="iconfont icon-yanjing-biyan input_icon right pointer" ng-if="vm.data1.password && vm.passType == \'password\'" ng-click="changePassType(\'passType\',\'text\')"></i> <i class="iconfont icon-yanjing-zhengyan input_icon right pointer" ng-if="vm.data1.password && vm.passType == \'text\'" ng-click="changePassType(\'passType\',\'password\')"></i></div><div class="form_item mb16"><i class="iconfont icon-mima1 input_icon left"></i> <input ng-model="vm.data1.password1" maxlength="50" class="icon_left icon_right" type="{{vm.confirmPassType}}" placeholder="\u8BF7\u518D\u6B21\u8F93\u5165\u65B0\u5BC6\u7801"> <i class="iconfont icon-yanjing-biyan input_icon right pointer" ng-if="vm.data1.password1 && vm.confirmPassType == \'password\'" ng-click="changePassType(\'confirmPassType\',\'text\')"></i> <i class="iconfont icon-yanjing-zhengyan input_icon right pointer" ng-if="vm.data1.password1 && vm.confirmPassType == \'text\'" ng-click="changePassType(\'confirmPassType\',\'password\')"></i></div><div class="form_item mb16"><i class="iconfont icon-gerenxinxi input_icon left"></i> <input ng-model="vm.data1.realName" class="icon_left" type="text" placeholder="\u8BF7\u8F93\u5165\u771F\u5B9E\u59D3\u540D"></div><div class="form_item mb16"><i class="iconfont icon-qiye input_icon left"></i> <input ng-model="vm.data1.company" class="icon_left" type="text" placeholder="\u8BF7\u8F93\u5165\u6240\u5C5E\u516C\u53F8"></div><div class="form_item send_code mb16"><i class="iconfont icon-shouji1 input_icon left"></i> <input ng-model="vm.phone" class="icon_left" ng-class="{\'checkErr\' : vm.checkPhoneErr}" type="text" placeholder="\u8BF7\u8F93\u5165\u624B\u673A\u53F7" ng-change="changePhone()"> <a class="btn_code pointer" ng-class="{\'disabled\' : vm.codeDisable}" ng-click="getCode()">{{vm.codeName}}</a></div><div class="form_item mb32"><i class="iconfont icon-yanzhengma1 input_icon left"></i> <input ng-model="vm.code" class="icon_left" type="text" placeholder="\u8BF7\u8F93\u5165\u9A8C\u8BC1\u7801"></div><div class="form_item"><button type="button" ng-click="registerByThird()">\u786E\u8BA4</button></div></div></div><div class="company_info">Powered By MomentsGo</div></div></div>');
$templateCache.put('app/entities/frame-control/frame-control-dialog.html','<div class="c-model"><div class="c-model-head"><div class="c-model-head-title">{{vm.isEdit ? \'\u8FB9\u6846\u7F16\u8F91\' : \'\u6DFB\u52A0\u8FB9\u6846\'}}</div><i class="iconfont icon-closeicon1" ng-click="vm.clear()"></i></div><div class="c-model-body"><div class="c-model-body-view"><!-- \u7B2C\u4E00\u6B65 --><div ng-show="vm.step==\'first\'"><div class="c-form"><label class="c-form-label">\u6807\u7B7E</label><div class="c-form-div"><modele-select ng-model="vm.frame.themeClassifyId" label-key="name" value-key="id" options="vm.themeClassifies"></modele-select></div></div><div class="c-form"><label class="c-form-label" translate="backApp.frame.name" for="name">name</label><div class="c-form-div"><input type="text" class="c-input1" name="name" id="name" ng-model="vm.frame.name" placeholder="\u8BF7\u8F93\u5165"></div></div><div class="c-form"><label class="c-form-label" translate="backApp.frame.seq" for="seq">seq</label><div class="c-form-div"><input type="text" class="c-input1" name="seq" id="seq" ng-model="vm.frame.seq" placeholder="\u8BF7\u8F93\u5165" onkeyup="this.value=this.value.replace(/[^1-9]*$/g, \'\')"></div></div><div class="c-form"><label class="c-form-label">\u8FB9\u6846\u7C7B\u578B</label><div class="c-form-div"><modele-select ng-model="vm.frame.shape" label-key="name" value-key="value" options="vm.shape"></modele-select></div></div><div class="c-form"><label class="c-form-label" translate="backApp.frame.enable" for="enable">enable</label><div class="c-form-div"><div class="radio-group"><div class="radio-item" ng-click="vm.openedCheck(true)" ng-class="{true:\'active\' }[vm.frame.enable]"><i class="iconfont icon-xuanze"></i> <span>\u662F</span></div><div class="radio-item" ng-click="vm.openedCheck(false)" ng-class="{false:\'active\' }[vm.frame.enable]"><i class="iconfont icon-xuanze"></i> <span>\u5426</span></div></div></div></div><div class="c-form"><label class="c-form-label">\u8FB9\u6846</label><div class="upload-box" ng-if="!vm.frame.img"><i class="iconfont icon-jia1"></i> \u4E0A\u4F20\u56FE\u7247 <input type="file" name="file" class="form-control" accept="image/jpeg, image/png" onchange="updateImgFile(event)" ng-model-options="{debounce : 500}"></div><div class="upload-preview" ng-if="vm.frame.img"><div class="img-view"><img alt="\u56FE\u7247\u7F3A\u5931" ng-src="{{vm.frame.img}}"></div><div class="reload-btn" ng-click="vm.frame.img=null"><i class="iconfont icon-zhongxuan"></i>\u91CD\u65B0\u4E0A\u4F20</div></div></div></div><!-- \u7B2C\u4E8C\u6B65 --><div class="panel-body form-horizontal" ng-show="vm.step==\'second\'" style="display: flex"><div class="editor-border-left"><div class="editor-border-right-content" style="width: 236px"><div style="background-size:cover" ng-style="{ \'background\': \'url(\' +  vm.frame.img +  \')center center\', \'background-size\': \'100% 100%\',  \'width\' : vm.imgZoom * vm.imgWidth, \'height\' : vm.imgZoom * vm.imgHeight, }"><div class="editor-right-border" style="width: 100%;height: 100%" ng-style="{  \'border-radius\':vm.frame.shape==\'Ellipse\'?\'50%\':\'0\',  \'padding-top\':HeightTop(), \'padding-bottom\':HeightBottom() ,  \'padding-left\':WidthLeft(), \'padding-right\':WidthRight(), }"><div style="position: relative;overflow: hidden;width: 100%;height: 100%;max-width: 236" ng-style="{ \'border-radius\':vm.frame.shape==\'Ellipse\'?\'50%\':\'0\', }"><div style="color: #264DF0" ng-if="!level.imagebox.image&&!level.imagebox.image.resource.identifier" class="image-placeholder"><img src="content/images/icons/camera.svg" style="width: 25px"> <span style="font-size: 14px;  color: #89919D">\u62D6\u5165\u76F8\u7247</span></div><span style="position: absolute; top: 5px; left: 50%; ;transform: translateX(-50%)">\u4E0A</span> <span style="position: absolute; bottom:5px; left: 50%; ;transform: translateX(-50%)">\u4E0B</span> <span style="position: absolute; left: 5px; top: 50%; ;transform: translateY(-50%)">\u5DE6</span> <span style="position: absolute; right: 5px; top: 50%; ;transform: translateY(-50%)">\u53F3</span></div></div></div></div></div><div class="editor-border-right"><div class="img-place" style="padding: 20px 23px 0px"><span style="color:#202020 ;font-weight: bold">\u7167\u7247\u5B54\u4F4D\u7F6E</span></div><div class="img-place1"><span>\u4E0A</span><input-number ng-model="vm.frameCopy.marginTop1" on-change="marginTop()" min="0" max="100"></input-number><!-- <input class="img-place1-input" type="number" ng-blur="marginTop()" ng-keypress="$event.keyCode === 13 ? marginTop() : return" ng-model="vm.frameCopy.marginTop1" oninput="if(!/^[0-9]+$/.test(value)) value=value.replace(/\\D/g,\'\');if(value>100)value=100;if(value<0)value=null"> --> <span>\u4E0B</span><input-number ng-model="vm.frameCopy.marginBottom1" on-change="marginBottom()" min="0" max="100"></input-number><!-- <input class="img-place1-input" type="number" ng-blur="marginBottom()" ng-keypress="$event.keyCode === 13 ? marginBottom() : return" ng-model="vm.frameCopy.marginBottom1" oninput="if(!/^[0-9]+$/.test(value)) value=value.replace(/\\D/g,\'\');if(value>100)value=100;if(value<0)value=null"> --> <span style="position: absolute;  right: 30px">%</span></div><div class="img-place1"><span>\u5DE6</span><input-number ng-model="vm.frameCopy.marginLeft1" on-change="marginLeft()" min="0" max="100"></input-number><!-- <input class="img-place1-input" type="number" ng-blur="marginLeft()" ng-keypress="$event.keyCode === 13 ? marginLeft() : return"  ng-model="vm.frameCopy.marginLeft1" oninput="if(!/^[0-9]+$/.test(value)) value=value.replace(/\\D/g,\'\');if(value>100)value=100;if(value<0)value=null"> --> <span>\u53F3</span><input-number ng-model="vm.frameCopy.marginRight1" on-change="marginRight()" min="0" max="100"></input-number><!-- <input class="img-place1-input" type="number" ng-blur="marginRight()" ng-keypress="$event.keyCode === 13 ? marginRight() : return"  ng-model="vm.frameCopy.marginRight1" oninput="if(!/^[0-9]+$/.test(value)) value=value.replace(/\\D/g,\'\');if(value>100)value=100;if(value<0)value=null"> --> <span style="position: absolute;  right: 30px">%</span></div></div></div></div></div><div class="modal-footer" style="text-align: center;    border: none"><button type="button" class="btn btn-cancel" ng-show="vm.step==\'first\'" style="height: 40px;width: 96px" data-dismiss="modal" ng-click="vm.clear()"><span>\u53D6\u6D88</span></button> <button type="submit" style="background: #264DF0; height: 40px;width: 96px; color: white" class="btn btn-cancel" ng-click="nextStep()" ng-show="vm.step==\'first\'" class="btn btn-primary btn-save btn-info"><span translate="entity.action.nextStep">nextStep</span></button> <button type="button" style="height: 40px;width: 96px" class="btn btn-cancel" data-dismiss="modal" ng-click="vm.step=\'first\'" ng-show="vm.step==\'second\'"><span translate="entity.action.upStep">upStep</span></button> <button type="submit" style="background: #264DF0; height: 40px;width: 96px; color: white" ng-click="vm.save()" ng-disabled="editForm.$invalid || vm.isSaving" ng-show="vm.step==\'second\'" class="btn btn-primary btn-save btn-info"><span translate="entity.action.save">Save</span></button></div></div><div id="photoFrame" style="background-size:cover;position: fixed;left: 6px;top: 70px;z-index: -111" ng-show="vm.step==\'second\'" ng-style="{ \'background\': \'url(\' +  vm.frame.img +  \')center center\',\'background-size\': \'100% 100%\',\'width\' : vm.imgZoom * vm.imgWidth,\'height\' : vm.imgZoom * vm.imgHeight,}" data-html2canvas-target><div class="editor-right-border" style="width: 100%;height: 100%" ng-style="{\'border-radius\':vm.frame.shape==\'Ellipse\'?\'200%\':\'0\',\'padding-top\':HeightTop(),\'padding-bottom\':HeightBottom() ,\'padding-left\':WidthLeft(),\'padding-right\':WidthRight(),}"><div style="position: relative;overflow: hidden;width: 100%;height: 100%;max-width: 300px" ng-style="{ \'border-radius\':vm.frame.shape==\'Ellipse\'?\'200%\':\'0\', }" data-html2canvas-hole><div ng-if="!level.imagebox.image&&!level.imagebox.image.resource.identifier" class="image-placeholder" ng-style="{\'border-radius\':vm.frame.shape==\'Ellipse\'?\'50%\':\'0\'}"><img src="content/images/icons/camera.svg" alt="" srcset="" style="width: 25px"> <span>\u62D6\u5165\u76F8\u7247</span></div></div></div></div><style media="screen">.c-form .c-form-label{\n        line-height: 40px;\n        width: 65px;\n    }\n    .c-form .c-form-div{\n        margin-left: 74px;\n    }\n    .c-form .c-form-div input.c-input1{\n        height: 40px;\n        padding: 0 16px;\n    }\n    .iconfont{\n        font-size: 16px;\n    }\n    .iconfont-selected{\n        color:#264DF0;\n    }\n    .modal-body{\n        background: #FFFFFF;\n        margin: 0px 24px;\n    }\n    .img-place1{\n        margin-left: 23px;\n        margin-top: 24px;\n        padding: 0px 0px 0px 16px;\n        width: 200px;\n        height: 40px;\n        line-height: 40px;\n        border-radius: 4px;\n        font-size: 14px;\n        border: 1px solid #E1E5EB;\n    }\n\n    .img-place1-input{\n        width: 70px;\n        margin-right: 5px;\n        border: none !important;\n    }\n\n    .modal-content{\n        width: 100% !important;\n    }\n    .ant-input-number{\n        border: none !important;\n    }</style>');
$templateCache.put('app/entities/frame-control/frame-control-issue-dialog.html','<!-- <form name="editForm" role="form" class="listBGC listCreate pad-0">\n    <button type="button" class="pad-5 close" data-dismiss="modal" aria-hidden="true"\n        ng-click="vm.clear()">&times;</button>\n\n    <div class="modal-detail">\n        <h4 class="modal-title" ng-show="vm.step == \'firstStep\'">\u53D1\u5E03\u5230\u7B2C\u4E09\u65B9</h4>\n        <h4 class="modal-title" ng-show="vm.step == \'secondStep\'">\u53D1\u5E03\u7ED3\u679C</h4>\n    </div>\n\n    <div class="modal-body" ng-show="vm.step == \'firstStep\'">\n        <div class="c-document-detection-body-view2-2-1">\n            <div class="c-document-detection-body-view2-2-1-title" style="color: #383838;">\u8BF7\u9009\u62E9\u60A8\u8981\u53D1\u5E03\u7684\u6E20\u9053\u540D\u79F0\uFF1A</div>\n            <div class="c-checkbox-view">\n                <div ng-class="{\'checkbox-1\':vm.checkAll,\'checkbox-0\':!vm.checkAll}" class="checkbox-icon checkbox-0"\n                    ng-click="vm.checkAllFn()"></div>\n                <span ng-click="vm.checkAllFn()">\u5168\u9009</span>\n            </div>\n        </div>\n        <div class="c-document-detection-body-view2-2-2">\n            <div class="c-checkbox-view" ng-repeat="item in vm.thirdPartySettings">\n                <div ng-class="{\'checkbox-1\':item.selected,\'checkbox-0\':!item.selected}"\n                    class="checkbox-icon checkbox-0" ng-click="vm.checkFn(item)"></div>\n                <span ng-click="vm.checkFn(item)">{{item.name}}</span>\n            </div>\n        </div>\n    </div>\n\n    <div class="modal-body" ng-show="vm.step == \'secondStep\'">\n        <div class="c-document-detection-body-view2-3-1" ng-if="vm.releaseData.status == 200">\n            <img src="content/images/icon/icon-success1.png" alt="" style="width: 249px;">\n            <div class="c-document-detection-body-view2-3-1-text" style="margin-top: 20px;">\u53D1\u5E03\u6210\u529F</div>\n        </div>\n        <div class="c-document-detection-body-view2-3-2" ng-if="vm.releaseData.status == 400">\n            <div class="c-document-detection-body-view2-3-2-li" ng-repeat="item in vm.releaseData.message">\n                <div class="c-document-detection-body-view2-3-2-li-title">{{item.name}}</div>\n                <div class="c-document-detection-body-view2-3-2-li-success" ng-if="item.success"><i\n                        class="iconfont icon-dui1"></i> <span>\u53D1\u5E03\u6210\u529F</span></div>\n                <div class="c-document-detection-body-view2-3-2-li-error" ng-if="!item.success"><i\n                        class="iconfont icon-closeicon11"></i> <span>{{item.reason}}</span></div>\n            </div>\n        </div>\n        <div ng-if="vm.releaseData.status != 400 && vm.releaseData.status != 200">{{vm.releaseData.message}}</div>\n    </div>\n    <div class="modal-footer">\n        <button type="button" class="btn btn-cancel" data-dismiss="modal" ng-click="vm.clear()">\n            <span>\u8FD4\u56DE</span>\n        </button>\n        <button type="submit" ng-click="vm.save()" ng-disabled="editForm.$invalid || vm.isSaving"\n            class="btn btn-primary btn-save btn-info" ng-show="vm.step == \'firstStep\'">\n            <span>\u53D1\u5E03</span>\n        </button>\n\n    </div>\n</form> --><!-- \u53D1\u5E03\u8FB9\u6846 --><div class="c-model"><div class="c-model-head"><div class="c-model-head-title">\u53D1\u5E03\u8FB9\u6846</div><i class="iconfont icon-closeicon1" ng-click="vm.clear()"></i></div><div class="c-model-body"><div class="c-model-body-view release-view"><div class="channel-view" ng-show="vm.step == \'firstStep\'"><div class="channel-head"><div class="channel-title">\u9009\u62E9\u53D1\u5E03\u6E20\u9053\uFF1A</div><div class="check-box" ng-class="{\'active\':vm.checkAll}" ng-click="vm.checkAllFn()"><i class="iconfont icon-xuanze"></i>\u5168\u9009</div></div><div class="channel-list"><div class="channel-item" ng-repeat="item in vm.thirdPartySettings" ng-class="{\'active\':item.selected}" ng-click="vm.checkFn(item)">{{item.name}}</div></div></div><div class="result-view" ng-show="vm.step == \'secondStep\'"><local-loading title="\u53D1\u5E03\u4E2D" show="vm.saveLoading"></local-loading><div ng-if="!vm.saveLoading"><div class="success-box" ng-if="vm.releaseData.status == 200"><div class="success-icon"><img src="content/images/release-success.png" alt="\u53D1\u5E03\u6210\u529F"></div><div class="success-tips">\u53D1\u5E03\u6210\u529F</div></div><div class="result-List" ng-if="vm.releaseData.status == 400"><div class="result-item" ng-repeat="item in vm.releaseData.message"><div class="result-name">{{item.name}}</div><div class="result-info"><div class="result-success" ng-if="item.success"><i class="iconfont icon-chenggong"></i> <span>\u53D1\u5E03\u6210\u529F</span></div><div class="result-error" ng-if="!item.success"><i class="iconfont icon-shixinguanbi"></i> <span>{{item.reason}}</span></div></div></div></div><div ng-if="vm.releaseData.status != 400 && vm.releaseData.status != 200" class="error-info">{{vm.releaseData.message}}</div></div></div></div></div><div class="c-model-foot release-foot-view"><div class="btns"><button type="button" class="btn btn-cancel" data-dismiss="modal" ng-click="vm.clear()"><span>\u8FD4\u56DE</span></button> <button type="submit" ng-click="vm.save()" class="btn btn-info" ng-show="vm.step == \'firstStep\'"><span>\u53D1\u5E03</span></button></div></div></div><style>.c-model {\n        width: 900px;\n    }</style>');
$templateCache.put('app/entities/frame-control/frame-control.html','<div class="workbench"><div class="work-head"><div class="tab-location"><div class="location-item" ui-sref="{{tab.url}}" ng-class="{\'active\' : vm.currentName == tab.key}" ng-repeat="tab in vm.tabs">{{tab.value}}</div></div><div class="search-box"><div class="handle"><div class="batch-btn" ng-show="!vm.batch" ng-click="vm.batch =  !vm.batch"><i class="iconfont icon-batch"></i>\u6279\u91CF\u64CD\u4F5C</div><div class="btn-primary" ng-show="vm.batch" ng-click="exitBatch()">\u9000\u51FA</div><div class="btn-primary" ng-if="!vm.batch" style="margin-left: 8px" ui-sref="frame-control.new">\u6DFB\u52A0\u8FB9\u6846</div></div></div></div><div class="share-screen"><div class="screen-box"><div class="screen-tit">\u6807\u7B7E</div><div class="option-list"><div class="option-item" ng-class="{\'active\' : hashtag.active}" ng-repeat="hashtag in vm.themeClassifies | orderBy:\'seq\' track by $index" ng-click="selectTag(hashtag)">{{ hashtag.name}}</div><div class="theme-btn" uib-tooltip="\u7F16\u8F91\u6807\u7B7E" tooltip-placement="bottom" ng-click="editTag()"><i class="iconfont icon-bianji"></i></div></div></div></div><div class="template-list" style="margin-top: 32px"><div class="empty-view" ng-if="!vm.sourceMaterials || vm.sourceMaterials.length < 1"><img class="empty-img" src="content/images/page-empty.png" alt="\u65E0\u6570\u636E"><div class="empty-text">\u6682\u65E0\u5185\u5BB9</div></div><div class="template-item" ng-repeat="item in vm.sourceMaterials track by item.id"><div class="img-view" ng-click="itemSelect(item)"><div class="cover-view"><img class="cover-img" err-src="content/images/default-cover.png" ng-src="{{item.cover +\'?imageMogr2/interlace/1/thumbnail/268x268>\'}}" alt="\u56FE\u7247\u7F3A\u5931"><div class="check-box" ng-class="{\'checked\' : item.selected}" ng-if="vm.batch"><i class="iconfont icon-gou"></i></div><div class="tag-box" ng-if="!vm.batch"><div class="tag" ng-if="item.enable">\u542F\u7528\u4E2D</div><div class="tag tag-success" ng-if="!item.enable">\u672A\u542F\u7528</div></div></div><div class="shade-view" ng-if="!vm.batch"><div class="tag-btn" uib-tooltip="\u6807\u7B7E" tooltip-placement="bottom" ui-sref="frame-control.updateTag({id:item.id})"><i class="iconfont icon-biaoqian"></i></div><div class="menu-view"><i class="iconfont icon-gengduo1"></i><div class="menu-content"><div class="menu-list"><div class="menu-item" ui-sref="frame-control.edit({id:item.id})">\u7F16\u8F91</div><div class="menu-item" ng-click="delete(item.id)">\u5220\u9664</div><div class="cut-line"></div><div class="menu-item" ng-click="issue(item)">\u53D1\u5E03</div></div></div></div></div></div><div class="template-info"><div class="template-name" uib-tooltip="{{item.name}}" tooltip-placement="top">{{(item.name!=null&&item.name!="")?item.name:\'\u672A\u547D\u540D\u8FB9\u6846\'}}</div><div class="tags-view one"><div class="tag" uib-tooltip="{{!item.cancelledThemeClassify ? (item.themeClassifyName!=null?item.themeClassifyName:\'\') : \'\'}}" tooltip-placement="top">{{!item.cancelledThemeClassify ? (item.themeClassifyName!=null?item.themeClassifyName:\'\u6682\u65E0\u6807\u7B7E\') : \'\u6682\u65E0\u6807\u7B7E\'}}</div></div></div></div></div><div class="batch-bar" ng-if="vm.batch" style="background: #FF4444"><div class="checked-count"><span class="num">({{vm.count}})</span>\u5DF2\u9009\u4E2D</div><div class="btns"><div class="batch-btn" ng-click="batchDelet()"><i class="iconfont icon-shanchu3"></i>\u5220\u9664</div></div><div class="btn-close" ng-click="exitBatch()"><i class="iconfont icon-closeicon1"></i></div></div><modele-pagination ng-show="!vm.batch" style="margin-top:10px" page="vm.page" size="vm.itemsPerPage" total="vm.totalItems" current-change="vm.currentChange()"></modele-pagination></div>');
$templateCache.put('app/entities/frame-control/update-tag.html','<div class="c-model"><div class="c-model-head" style="padding: 16px 24px 0; height: 48px"><div class="c-model-head-title">\u4FEE\u6539\u5173\u8054\u6807\u7B7E</div><i class="iconfont icon-closeicon1" ng-click="vm.clear()"></i></div><div class="c-model-body"><div class="c-model-body-view"><div class="c-form"><label class="c-form-label">\u5173\u8054\u6807\u7B7E\uFF1A</label><div class="c-form-div"><modele-select ng-model="vm.frame.themeClassifyId" label-key="name" value-key="id" options="vm.themeClassifies"></modele-select></div></div></div></div><div class="c-model-foot" style="text-align: center"><button style="margin-right: 16px" type="button" class="btn btn-cancel" ng-click="vm.clear()">\u53D6\u6D88</button> <button type="button" class="btn btn-info" ng-click="vm.save()">\u786E\u5B9A</button></div></div>');
$templateCache.put('app/entities/message/messageConfirm.html','<div class="confirm-dialog"><div class="confirm-dialog-header"><div class="confirm-dialog-title">{{obj.title}}</div><span class="iconfont icon-closeicon1" ng-click="cancel(false)"></span></div><div class="confirm-dialog-content">{{obj.msg}}</div><div class="confirm-dialog-footer"><button class="confirm-dialog-footer-cancel" ng-click="cancel(false)" ng-if="obj.goback" style="margin-right: 16px">{{obj.goback}}</button> <button class="confirm-dialog-footer-cancel" ng-click="cancel(true)" ng-if="!obj.hideCancel">{{obj.cancel}}</button> <button class="confirm-dialog-footer-theme" ng-class="{\'confirm-dialog-footer-delete\':obj.isDelete}" ng-click="ok()">{{obj.confirm}}</button></div></div><style>.confirm-window .modal-content{\n        width: 528px;\n        border-radius: 8px;\n    }</style>');
$templateCache.put('app/entities/message/messageLoading.html','<img src="content/images/icon/loading-all.gif" alt=""> <span>\u62FC\u547D\u52A0\u8F7D\u4E2D</span><style>.loading-window .modal-content{\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        flex-direction: column;\n        height: 500px;\n        color: #FFF;\n        font-size: 16px;\n    }\n    .loading-window img{\n        width: 40px;\n        margin-bottom: 10px;\n    }</style>');
$templateCache.put('app/entities/message/messageLoading2.html','<div class="bounce"><span class="letter">M</span> <span class="letter">o</span> <span class="letter">d</span> <span class="letter">e</span> <span class="letter">l</span> <span class="letter">e</span></div><style>.loading-window .modal-content{\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        flex-direction: column;\n        height: 500px;\n        color: #FFF;\n        font-size: 50px;\n    }\n    .loading-window img{\n        width: 40px;\n        margin-bottom: 10px;\n    }\n\n    .loading-window .bounce {\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        width: 100%;\n        color: rgb(255, 255, 255);\n        height: 100%;\n        white-space: nowrap;\n        font-family: myFont;\n        font-size: 50px;\n    }\n\n    .loading-window .letter {\n        animation: bounce 0.75s cubic-bezier(0.05, 0, 0.2, 1) infinite alternate;\n        display: inline-block;\n        transform: translate3d(0, 0, 0);\n        margin-top: 0.5em;\n        text-shadow: rgba(255, 255, 255, 0.4) 0 0 0.05em;\n        font-family: myFont;\n    }\n    .loading-window .letter:nth-child(1) {\n        animation-delay: 0s;\n    }\n    .loading-window .letter:nth-child(2) {\n        animation-delay: 0.0833333333s;\n    }\n    .loading-window .letter:nth-child(3) {\n        animation-delay: 0.1666666667s;\n    }\n    .loading-window .letter:nth-child(4) {\n        animation-delay: 0.25s;\n    }\n    .loading-window .letter:nth-child(5) {\n        animation-delay: 0.3333333333s;\n    }\n    .loading-window .letter:nth-child(6) {\n        animation-delay: 0.4166666667s;\n    }\n    @keyframes bounce {\n        0% {\n            transform: translate3d(0, 0, 0);\n            text-shadow: rgba(255, 255, 255, 0.4) 0 0 0.05em;\n        }\n        100% {\n            transform: translate3d(0, -1em, 0);\n            text-shadow: rgba(255, 255, 255, 0.6) 0 1em 0.35em;\n        }\n    }\n\n    @font-face {\n        font-family: myFont; \n        src: url(\'content/fonts/Chalkboard-Bold.ttf\');\n    }</style>');
$templateCache.put('app/entities/my-upload/background-view.html','<div class="c-model notice-detail-head-title"><div class="c-model-head" style="padding: 16px 24px 0; height: 48px"><div class="c-model-head-head-title">\u9884\u89C8</div><button aria-label="Close" data-dismiss="modal" class="close" type="button" style="margin: 0px; height: 24px" ng-click="cancel()"><span aria-hidden="true" style="position: relative; top: -10px">&times;</span></button></div><div class="notice-detail-body"><img alt="\u56FE\u7247\u7F3A\u5931" ng-src="{{vm.data.identifier +\'?imageMogr2/interlace/1/thumbnail/500x500>\'}}"></div></div><style type="text/css" media="screen">.notice-detail-head-title{\n        min-height: 200px; \n        font-weight: 600;\n        padding-bottom: 24px;\n    }    \n\n    .notice-detail-body{\n        overflow: auto;\n        font-size: 16px;\n        margin: 0px 24px ;\n        display: flex;\n        max-height: 600px !important;\n        justify-content: center;\n        align-items: center;\n    }</style>');
$templateCache.put('app/entities/my-upload/background.html','<div class="workbench"><div class="work-head"><div class="tab-location"><div class="location-item" ui-sref="{{tab.url}}" ng-class="{\'active\' : vm.currentName == tab.key}" ng-repeat="tab in vm.tabs">{{tab.value}}</div></div><div class="search-box"><div class="handle"><div class="batch-btn" ng-show="!vm.batch" ng-click="vm.batch =  !vm.batch"><i class="iconfont icon-batch"></i>\u6279\u91CF\u64CD\u4F5C</div><div class="btn-primary" ng-show="vm.batch" ng-click="exitBatch()">\u9000\u51FA</div><div class="btn-primary" ng-if="!vm.batch" style="margin-left: 8px" ng-click="addBackground()">\u6DFB\u52A0\u80CC\u666F</div></div></div></div><div class="share-screen"><div class="screen-box"><div class="screen-tit">\u6807\u7B7E</div><div class="option-list"><div class="option-item" ng-class="{\'active\' : hashtag.active}" ng-repeat="hashtag in vm.themeClassifies | orderBy:\'seq\' track by $index" ng-click="selectTag(hashtag)">{{ hashtag.name}}</div><div class="theme-btn" uib-tooltip="\u7F16\u8F91\u6807\u7B7E" tooltip-placement="bottom" ng-click="editTag()"><i class="iconfont icon-bianji"></i></div></div></div></div><div class="template-list" style="margin-top: 32px"><div class="empty-view" ng-if="vm.bgimgs.length < 1"><img class="empty-img" src="content/images/page-empty.png" alt="\u65E0\u6570\u636E"><div class="empty-text">\u6682\u65E0\u5185\u5BB9</div></div><div class="template-item" ng-repeat="item in vm.bgimgs track by item.id"><div class="img-view" ng-click="itemSelect(item)"><div class="cover-view"><img class="cover-img" err-src="content/images/default-cover.png" ng-src="{{item.identifier +\'?imageMogr2/interlace/1/thumbnail/268x268>\'}}" alt="\u56FE\u7247\u7F3A\u5931"><div class="check-box" ng-class="{\'checked\' : item.selected}" ng-if="vm.batch"><i class="iconfont icon-gou"></i></div></div><div class="shade-view" ng-if="!vm.batch"><div class="tag-btn" uib-tooltip="\u6807\u7B7E" tooltip-placement="bottom" ui-sref="background.updateTag({id:item.id})"><i class="iconfont icon-biaoqian"></i></div><div class="preview-btn" ng-click="view(item)" uib-tooltip="\u9884\u89C8" tooltip-placement="bottom"><i class="iconfont icon-yulan"></i></div><div class="menu-view"><i class="iconfont icon-gengduo1"></i><div class="menu-content"><div class="menu-list"><div class="menu-item" ng-click="delete(item)">\u5220\u9664</div></div></div></div></div></div><div class="template-info"><div class="template-name" uib-tooltip="{{item.name}}" tooltip-placement="top">{{(item.name!=null&&item.name!="")?item.name:\'\u672A\u547D\u540D\u80CC\u666F\'}}</div><div class="info-list"><div class="item" style="color: #89919D">{{item.width}}*{{item.height}}</div><div class="item">{{item.size | sizeTransition}}</div><div class="item">{{item.format}}</div></div><div class="tags-view"><div class="tag" uib-tooltip="{{!item.cancelledThemeClassify ? (item.themeClassifyName!=null?item.themeClassifyName:\'\') : \'\'}}" tooltip-placement="top">{{!item.cancelledThemeClassify ? (item.themeClassifyName!=null?item.themeClassifyName:\'\u6682\u65E0\u6807\u7B7E\') : \'\u6682\u65E0\u6807\u7B7E\'}}</div></div></div></div></div><div class="batch-bar" ng-if="vm.batch" style="background: #FF4444"><div class="checked-count"><span class="num">({{vm.count}})</span>\u5DF2\u9009\u4E2D</div><div class="btns"><div class="batch-btn" ng-click="batchDelet()"><i class="iconfont icon-shanchu3"></i>\u5220\u9664</div></div><div class="btn-close" ng-click="exitBatch()"><i class="iconfont icon-closeicon1"></i></div></div><modele-pagination ng-show="!vm.batch" style="margin-top:10px" page="vm.page" size="vm.size" total="vm.totalItems" current-change="vm.currentChange()"></modele-pagination></div>');
$templateCache.put('app/entities/my-upload/clipArt.html','<div class="workbench"><div class="work-head"><div class="tab-location"><div class="location-item" ui-sref="{{tab.url}}" ng-class="{\'active\' : vm.currentName == tab.key}" ng-repeat="tab in vm.tabs">{{tab.value}}</div></div><div class="search-box"><div class="handle"><div class="batch-btn" ng-show="!vm.batch" ng-click="vm.batch =  !vm.batch"><i class="iconfont icon-batch"></i>\u6279\u91CF\u64CD\u4F5C</div><div class="btn-primary" ng-show="vm.batch" ng-click="exitBatch()">\u9000\u51FA</div><div class="btn-primary" ng-if="!vm.batch" style="margin-left: 8px" ng-click="addClipArt()">\u6DFB\u52A0\u7D20\u6750</div></div></div></div><div class="share-screen"><div class="screen-box"><div class="screen-tit">\u6807\u7B7E</div><div class="option-list"><div class="option-item" ng-class="{\'active\' : hashtag.active}" ng-repeat="hashtag in vm.themeClassifies | orderBy:\'seq\' track by $index" ng-click="selectTag(hashtag)">{{ hashtag.name}}</div><div class="theme-btn" uib-tooltip="\u7F16\u8F91\u6807\u7B7E" tooltip-placement="bottom" ng-click="editTag()"><i class="iconfont icon-bianji"></i></div></div></div></div><div class="template-list" style="margin-top: 32px"><div class="empty-view" ng-if="!vm.resources || vm.resources.length < 1"><img class="empty-img" src="content/images/page-empty.png" alt="\u65E0\u6570\u636E"><div class="empty-text">\u6682\u65E0\u5185\u5BB9</div></div><div class="template-item" ng-repeat="item in vm.resources track by item.id"><div class="img-view" ng-click="itemSelect(item)"><div class="cover-view"><img class="cover-img" err-src="content/images/default-cover.png" ng-src="{{item.identifier +\'?imageMogr2/interlace/1/thumbnail/268x268>\'}}" alt="\u56FE\u7247\u7F3A\u5931"><div class="check-box" ng-class="{\'checked\' : item.selected}" ng-if="vm.batch"><i class="iconfont icon-gou"></i></div></div><div class="shade-view" ng-if="!vm.batch"><div class="preview-btn" ng-click="view(item)" uib-tooltip="\u9884\u89C8" tooltip-placement="bottom"><i class="iconfont icon-yulan"></i></div><div class="tag-btn" uib-tooltip="\u6807\u7B7E" tooltip-placement="bottom" ui-sref="clip-art.updateTag({id:item.id})"><i class="iconfont icon-biaoqian"></i></div><div class="menu-view"><i class="iconfont icon-gengduo1"></i><div class="menu-content"><div class="menu-list"><div class="menu-item" ng-click="delete(item.id)">\u5220\u9664</div></div></div></div></div></div><div class="template-info"><div class="template-name" uib-tooltip="{{item.name}}" tooltip-placement="top">{{(item.name!=null&&item.name!="")?item.name:\'\u672A\u547D\u540D\u7D20\u6750\'}}</div><div class="info-list"><div class="item" style="color: #89919D">{{item.width}}*{{item.height}}</div><div class="item">{{item.size | sizeTransition}}</div><div class="item">{{item.format}}</div></div><div class="tags-view"><div class="tag" uib-tooltip="{{!item.cancelledThemeClassify ? (item.themeClassifyName!=null?item.themeClassifyName:\'\') : \'\'}}" tooltip-placement="top">{{!item.cancelledThemeClassify ? (item.themeClassifyName!=null?item.themeClassifyName:\'\u6682\u65E0\u6807\u7B7E\') : \'\u6682\u65E0\u6807\u7B7E\'}}</div></div></div></div></div><div class="batch-bar" ng-if="vm.batch" style="background: #FF4444"><div class="checked-count"><span class="num">({{vm.count}})</span>\u5DF2\u9009\u4E2D</div><div class="btns"><div class="batch-btn" ng-click="batchDelet()"><i class="iconfont icon-shanchu3"></i>\u5220\u9664</div></div><div class="btn-close" ng-click="exitBatch()"><i class="iconfont icon-closeicon1"></i></div></div><modele-pagination ng-show="!vm.batch" style="margin-top:10px" page="vm.page" size="vm.size" total="vm.totalItems" current-change="vm.currentChange()"></modele-pagination></div>');
$templateCache.put('app/entities/my-upload/mask.html','<div class="workbench"><div class="work-head"><div class="tab-location"><div class="location-item" ui-sref="{{tab.url}}" ng-class="{\'active\' : vm.currentName == tab.key}" ng-repeat="tab in vm.tabs">{{tab.value}}</div></div><div class="search-box"><div class="handle"><div class="batch-btn" ng-show="!vm.batch" ng-click="vm.batch =  !vm.batch"><i class="iconfont icon-batch"></i>\u6279\u91CF\u64CD\u4F5C</div><div class="btn-primary" ng-show="vm.batch" ng-click="exitBatch()">\u9000\u51FA</div><div class="btn-primary" ng-if="!vm.batch" style="margin-left: 8px" ng-click="addMask()">\u6DFB\u52A0\u76F8\u6846</div></div></div></div><div class="share-screen"><div class="screen-box"><div class="screen-tit">\u6807\u7B7E</div><div class="option-list"><div class="option-item" ng-class="{\'active\' : hashtag.active}" ng-repeat="hashtag in vm.themeClassifies | orderBy:\'seq\' track by $index" ng-click="selectTag(hashtag)">{{ hashtag.name}}</div><div class="theme-btn" uib-tooltip="\u7F16\u8F91\u6807\u7B7E" tooltip-placement="bottom" ng-click="editTag()"><i class="iconfont icon-bianji"></i></div></div></div></div><div class="template-list" style="margin-top: 32px"><div class="empty-view" ng-if="!vm.resources || vm.resources.length < 1"><img class="empty-img" src="content/images/page-empty.png" alt="\u65E0\u6570\u636E"><div class="empty-text">\u6682\u65E0\u5185\u5BB9</div></div><div class="template-item" ng-repeat="item in vm.resources track by item.id"><div class="img-view" ng-click="itemSelect(item)"><div class="cover-view"><img class="cover-img" err-src="content/images/default-cover.png" ng-src="{{item.identifier +\'?imageMogr2/interlace/1/thumbnail/268x268>\'}}" alt="\u56FE\u7247\u7F3A\u5931"><div class="check-box" ng-class="{\'checked\' : item.selected}" ng-if="vm.batch"><i class="iconfont icon-gou"></i></div></div><div class="shade-view" ng-if="!vm.batch"><div class="tag-btn" uib-tooltip="\u6807\u7B7E" tooltip-placement="bottom" ui-sref="mask.updateTag({id:item.id})"><i class="iconfont icon-biaoqian"></i></div><div class="preview-btn" ng-click="view(item)" uib-tooltip="\u9884\u89C8" tooltip-placement="bottom"><i class="iconfont icon-yulan"></i></div><div class="menu-view"><i class="iconfont icon-gengduo1"></i><div class="menu-content"><div class="menu-list"><div class="menu-item" ng-click="delete(item.id)">\u5220\u9664</div></div></div></div></div></div><div class="template-info"><div class="template-name" uib-tooltip="{{item.name}}" tooltip-placement="top">{{(item.name!=null&&item.name!="")?item.name:\'\u672A\u547D\u540D\u76F8\u6846\'}}</div><div class="info-list"><div class="item" style="color: #89919D">{{item.width}}*{{item.height}}</div><div class="item">{{item.size | sizeTransition }}</div><div class="item">{{item.format}}</div></div><div class="tags-view"><div class="tag" uib-tooltip="{{!item.cancelledThemeClassify ? (item.themeClassifyName!=null?item.themeClassifyName:\'\') : \'\'}}" tooltip-placement="top">{{!item.cancelledThemeClassify ? (item.themeClassifyName!=null?item.themeClassifyName:\'\u6682\u65E0\u6807\u7B7E\') : \'\u6682\u65E0\u6807\u7B7E\'}}</div></div></div></div></div><div class="batch-bar" ng-if="vm.batch" style="background: #FF4444"><div class="checked-count"><span class="num">({{vm.count}})</span>\u5DF2\u9009\u4E2D</div><div class="btns"><div class="batch-btn" ng-click="batchDelet()"><i class="iconfont icon-shanchu3"></i>\u5220\u9664</div></div><div class="btn-close" ng-click="exitBatch()"><i class="iconfont icon-closeicon1"></i></div></div><modele-pagination ng-show="!vm.batch" style="margin-top:10px" page="vm.page" size="vm.size" total="vm.totalItems" current-change="vm.currentChange()"></modele-pagination></div>');
$templateCache.put('app/entities/my-upload/pic.html','<div class="workbench"><div class="work-head"><div class="tab-location"><div class="location-item" ui-sref="{{tab.url}}" ng-class="{\'active\' : vm.currentName == tab.key}" ng-repeat="tab in vm.tabs">{{tab.value}}</div></div><div class="search-box"><div class="handle"><div class="batch-btn" ng-show="!vm.batch" ng-click="vm.batch =  !vm.batch"><i class="iconfont icon-batch"></i>\u6279\u91CF\u64CD\u4F5C</div><div class="btn-primary" ng-show="vm.batch" ng-click="exitBatch()">\u9000\u51FA</div><div class="btn-primary" ng-if="!vm.batch" style="margin-left: 8px" ng-click="addPic()">\u6DFB\u52A0\u56FE\u7247</div></div></div></div><div class="share-screen"><div class="screen-box"><div class="screen-tit">\u6807\u7B7E</div><div class="option-list"><div class="option-item" ng-class="{\'active\' : hashtag.active}" ng-repeat="hashtag in vm.themeClassifies | orderBy:\'seq\' track by $index" ng-click="selectTag(hashtag)">{{ hashtag.name}}</div><div class="theme-btn" uib-tooltip="\u7F16\u8F91\u6807\u7B7E" tooltip-placement="bottom" ng-click="editTag()"><i class="iconfont icon-bianji"></i></div></div></div></div><div class="template-list" style="margin-top: 32px"><div class="empty-view" ng-if="vm.galleries.length < 1"><img class="empty-img" src="content/images/page-empty.png" alt="\u65E0\u6570\u636E"><div class="empty-text">\u6682\u65E0\u5185\u5BB9</div></div><div class="template-item" ng-repeat="item in vm.galleries track by item.id"><div class="img-view" ng-click="itemSelect(item)"><div class="cover-view"><img class="cover-img" err-src="content/images/default-cover.png" ng-src="{{item.identifier +\'?imageMogr2/interlace/1/thumbnail/268x268>\'}}" alt="\u56FE\u7247\u7F3A\u5931"><div class="check-box" ng-class="{\'checked\' : item.selected}" ng-if="vm.batch"><i class="iconfont icon-gou"></i></div></div><div class="shade-view" ng-if="!vm.batch"><div class="tag-btn" uib-tooltip="\u6807\u7B7E" tooltip-placement="bottom" ui-sref="pic.updateTag({id:item.id})"><i class="iconfont icon-biaoqian"></i></div><div class="preview-btn" ng-click="view(item)" uib-tooltip="\u9884\u89C8" tooltip-placement="bottom"><i class="iconfont icon-yulan"></i></div><div class="menu-view"><i class="iconfont icon-gengduo1"></i><div class="menu-content"><div class="menu-list"><div class="menu-item" ng-click="delete(item)">\u5220\u9664</div></div></div></div></div></div><div class="template-info"><div class="template-name" uib-tooltip="{{item.name}}" tooltip-placement="top">{{(item.name!=null&&item.name!="")?item.name:\'\u672A\u547D\u540D\u56FE\u7247\'}}</div><div class="info-list"><div class="item" style="color: #89919D">{{item.width}}*{{item.height}}</div><div class="item">{{item.imgSize | sizeTransition}}</div><div class="item">{{item.format}}</div></div><div class="tags-view"><div class="tag" uib-tooltip="{{!item.cancelledThemeClassify ? (item.themeClassifyName!=null?item.themeClassifyName:\'\') : \'\'}}" tooltip-placement="top">{{!item.cancelledThemeClassify ? (item.themeClassifyName!=null?item.themeClassifyName:\'\u6682\u65E0\u6807\u7B7E\') : \'\u6682\u65E0\u6807\u7B7E\'}}</div></div></div></div></div><div class="batch-bar" ng-if="vm.batch" style="background: #FF4444"><div class="checked-count"><span class="num">({{vm.count}})</span>\u5DF2\u9009\u4E2D</div><div class="btns"><div class="batch-btn" ng-click="batchDelet()"><i class="iconfont icon-shanchu3"></i>\u5220\u9664</div></div><div class="btn-close" ng-click="exitBatch()"><i class="iconfont icon-closeicon1"></i></div></div><modele-pagination ng-show="!vm.batch" style="margin-top:10px" page="vm.page" size="vm.size" total="vm.totalItems" current-change="vm.currentChange()"></modele-pagination></div>');
$templateCache.put('app/entities/my-upload/update-tag.html','<div class="c-model"><div class="c-model-head"><div class="c-model-head-title">\u4FEE\u6539\u5173\u8054\u6807\u7B7E</div><i class="iconfont icon-closeicon1" ng-click="cancel()"></i></div><div class="c-model-body"><div class="c-model-body-view"><div class="c-form"><label class="c-form-label">\u5173\u8054\u6807\u7B7E\uFF1A</label><div class="c-form-div"><modele-select ng-if="vm.data.themeClassify==undefined" ng-model="vm.data.themeClassifyId" label-key="name" value-key="id" options="vm.themeClassifies"></modele-select><modele-select ng-if="vm.data.themeClassify!=undefined" ng-model="vm.data.themeClassify.id" label-key="name" value-key="id" options="vm.themeClassifies"></modele-select></div></div></div></div><div class="c-model-foot" style="text-align: center"><button style="margin-right: 16px" type="button" class="btn btn-cancel" ng-click="cancel()">\u53D6\u6D88</button> <button type="button" class="btn btn-info" ng-click="vm.save()">\u786E\u5B9A</button></div></div>');
$templateCache.put('app/entities/notice/notice-detail.html','<div class="c-model"><div class="c-model-head"><div class="c-model-head-title">\u6D88\u606F\u8BE6\u60C5</div><i class="iconfont icon-closeicon1" ng-click="cancel()"></i></div><div class="c-model-body" style="padding-bottom: 24px"><div class="c-model-body-view"><div class="notice-detail-titel">{{vm.notice.title}}</div><div class="notice-detail-time">{{vm.notice.createdDate | date:"yyyy-MM-dd HH:mm:ss"}}</div><div class="notice-detail-content">{{vm.notice.content}}</div></div></div></div><style type="text/css" media="screen">.notice-detail-head-title{\n        min-height: 200px; \n        font-weight: 600;\n        padding-bottom: 24px;\n    }    \n\n    .notice-detail-body{\n        max-height: 500px;\n        overflow: auto;\n        font-size: 16px;\n        background: white;  \n        margin: 0px 24px;\n      padding: 32px 24px 24px 24px;\n    }    \n    .notice-detail-titel{\n       text-align: center;\n       height: 25px;\n       font-size: 18px;\n       font-weight: 600;\n       color: #222529;\n       margin-bottom: 16px;\n       line-height: 25px;\n   }\n   .notice-detail-time{\n        text-align: center;\n        font-size: 14px;\n        color: #89919D;\n    }\n    .notice-detail-content{\n        margin-top: 24px; \n        font-size: 14px;\n        color: #505760; \n    }</style>');
$templateCache.put('app/entities/notice/notice.html','<div class="c-home-nav scrollbar-none"><div class="c-home-nav-li" ng-click="checkoutTab(\'\')" style="margin-top: 23px" ng-class="{\' c-title-nav\': vm.tab==\'\'}"><span>\u5168\u90E8</span></div><div class="c-home-nav-li" ng-click="checkoutTab(\'announcement\')" ng-class="{\' c-title-nav\': vm.tab==\'announcement\'}"><span>\u516C\u544A</span></div><div class="c-home-nav-li" ng-click="checkoutTab(\'audit\')" ng-class="{\' c-title-nav\': vm.tab==\'audit\'}"><span>\u5BA1\u6838</span></div></div><div class="page-wrap scrollbar-main" style="margin-top: 30px;  left: 410px; position: fixed; overflow: auto"><div class="con"><ul class="inform-ul"><li ng-repeat="item in vm.data track by item.id" ng-click="giveNoticeCb(item)" class="notice-li"><div style="float: left;line-height: 64px"><img src="content/images/home-icon4.png" ng-show="item.noticeType == \'announcement\'" style="width: 40px"> <img src="content/images/home-icon3.png" ng-show="item.noticeType == \'audit\'" style="width: 40px"></div><div style="padding-left: 56px"><div class="notice-title"><p class="title slh">{{item.title}}</p><span class="notice-un-read" ng-show="!item.read"></span></div><div class="notice-content slh">{{item.content}}</div><div class="notice-time">{{item.createdDate | date:"yyyy-MM-dd"}}</div></div></li></ul></div></div><!-- <div class="c-body"  >\n    <div class="c-title" style="color: #8E8E8E">\n        <span class="c-title-nav" ng-click="checkoutTab(\'\')"  ng-class="{\' c-title-navOn2\': vm.tab==\'\'}" >\u5168\u90E8</span>\n        <span class="c-title-nav  "  ng-click="checkoutTab(\'announcement\')"  ng-class="{\' c-title-navOn2\': vm.tab==\'announcement\'}" >\u516C\u544A</span>\n        <span class="c-title-nav  " ng-click="checkoutTab(\'audit\')"  ng-class="{\' c-title-navOn2\': vm.tab==\'audit\'}" >\u5BA1\u6838</span>\n    </div>\n    <div class="page-wrap" style="margin-top: 30px; ">\n        <div class="con">\n            <ul class="inform-ul">\n                <li ng-repeat="item in vm.data track by item.id" ng-click="giveNoticeCb(item)" class="notice-li">\n                    <div style=" float: left;line-height: 64px; ">\n                        <img src="content/images/home-icon4.png" ng-show="item.noticeType == \'announcement\'" style=" width: 40px; ">\n                        <img src="content/images/home-icon3.png" ng-show="item.noticeType == \'audit\'" style=" width: 40px; ">\n                    </div>\n                    <div style=" padding-left: 56px;">\n                        <div  class="notice-title">\n                            {{item.title}}\n                            <span class="notice-un-read" ng-show="!item.read" ></span>\n                        </div>\n                        <div class="notice-content" >\n                            {{item.content}}\n                        </div>\n                        <div class="notice-content">\n                            {{item.createdDate | date:"yyyy-MM-dd"}}\n                        </div>\n                    </div>\n                </li>\n            </ul>\n        </div>\n    </div>\n</div> --><style type="text/css" media="screen">.c-title-nav{\n        background: #F5F7FA;\n        color: #222529;\n    }\n\n    .c-home-nav{\n        position: fixed;\n        left: 260px;\n        top: 72px;\n        bottom: 0;\n        width: 176px;\n        background: #fff;\n        overflow: auto;\n        padding: 0px 16px;\n        border-right: 1px solid #E2E2E2;\n        z-index: 1;\n        text-align: center;\n    }\n\n    .c-home-nav-li{\n        display: block !important;\n        height: 44px;\n        line-height: 44px;\n        padding: 0px 16px;\n    }\n\n    .notice-li{\n        padding: 8px;\n        width: 1192px;\n        margin-bottom: 16px;\n        background: rgba(255,255,255,0);\n        border-radius: 3px;\n    }\n    .notice-li:hover{\n        background:#F5F7FA;\n    }\n\n    .notice-title{\n        font-size: 16px;\n        font-weight: 600;\n        color: #222529;\n        line-height: 22px;\n    }\n    .notice-title .title{\n        max-width: 98%;\n        display: inline-block;\n    }\n\n    .notice-un-read{\n        display: inline-block;\n        background-color: red;\n        border-radius: 10px;\n        width: 6px;\n        margin-bottom: 10px;\n        height: 6px;\n        vertical-align: top;\n    }\n\n    .notice-content{\n        font-size: 14px;\n        color: #505760;\n        margin-bottom: 8px;\n    }\n    .notice-time{\n        color: #89919D;\n        font-size: 14px;\n    }</style>');
$templateCache.put('app/entities/mycenter/mycenter.html','<div class="share-content" style="padding-bottom: 0px"><div class="share-head"><div class="share-title">\u6A21\u677F\u8BBE\u7F6E</div></div></div><div class="list-body mar-top-20 content-div" style="padding-top: 25px"><div class="list-body-title content-lable"><span>\u7CBE\u5EA6\u8BBE\u7F6E</span> <button ng-click="vm.edit = true" ng-if="!vm.edit" class="edit-btn"><span>\u7F16\u8F91</span></button> <button ng-click="submitDpi()" ng-if="vm.edit" class="save-btn"><span>\u4FDD\u5B58</span></button></div><div class="list-body-main"><div><span class="list-body-main-div-span1">\u80CC\u666F\u7CBE\u5EA6\u4E0D\u4F4E\u4E8E</span><select ng-if="vm.edit" class="list-body-main-div-select" ng-model="store.bgDpi" ng-options="n.value as n.value for n in vm.gitDpiOptions"></select><span ng-if="!vm.edit" class="list-body-main-div-span2">{{store.bgDpi}}</span>&nbsp; <span class="list-body-main-div-span1">DPI</span><br><span class="list-body-main-div-span1">\u7D20\u6750\u7CBE\u5EA6\u4E0D\u4F4E\u4E8E</span><select ng-if="vm.edit" class="list-body-main-div-select" ng-model="store.clipArtDpi" ng-options="n.value as n.value for n in vm.gitDpiOptions"></select><span ng-if="!vm.edit" class="list-body-main-div-span2">{{store.clipArtDpi}}</span>&nbsp; <span class="list-body-main-div-span1">DPI</span></div><div><span class="list-body-main-div-span1">\u76F8\u6846\u8499\u7248\u7CBE\u5EA6\u4E0D\u4F4E\u4E8E</span><select ng-if="vm.edit" class="list-body-main-div-select" ng-model="store.maskDpi" ng-options="n.value as n.value for n in vm.gitDpiOptions"></select><span ng-if="!vm.edit" class="list-body-main-div-span2">{{store.maskDpi}}</span>&nbsp; <span class="list-body-main-div-span1">DPI</span><br><span class="list-body-main-div-span1">\u56FE\u7247\u4E0A\u4F20\u7CBE\u5EA6\u4E0D\u4F4E\u4E8E</span><select ng-if="vm.edit" class="list-body-main-div-select" ng-model="store.imgDpi" ng-options="n.value as n.value for n in vm.gitDpiOptions"></select><span ng-if="!vm.edit" class="list-body-main-div-span2">{{store.imgDpi}}</span>&nbsp; <span class="list-body-main-div-span1">DPI</span></div></div></div><style type="text/css" media="screen">.page-title {\n        height: 28px;\n        font-size: 20px;\n        font-weight: 600;\n        color: #222529;\n        line-height: 28px;\n    }\n\n    .content-div{\n        width: 784px;\n        height: 208px;\n        border-radius: 8px;\n        border: 1px solid #E1E5EB;\n    }\n    .content-lable{\n        font-size: 18px;\n        font-weight: 500;\n        color: #222529;\n    }\n\n    .edit-btn{\n        float: right;\n        margin-right: 32px;\n        width: 56px;\n        height: 28px;\n        background: #F5F7FA;\n        border-radius: 4px;\n    }\n    .save-btn{\n        float: right; \n        margin-right: 32px;\n        width: 56px;\n        height: 28px;\n        background: #264DF0;\n        color: #FFFFFF;\n        border-radius: 4px\n    }\n\n\n    .list-body-main-div-span1{\n        color: #505760;\n    }\n\n    .list-body-main-div-span2{\n        display: inline-block;\n        width: 90px;    \n        padding: 0 8px;\n        height: 25px;\n        border-radius: 4px;\n        line-height: 25px;\n        border: 1px solid #E1E5EB\n    }</style>');
$templateCache.put('app/entities/patterns/patterns.html','<div class="workbench"><div class="work-head"><div class="work-title">\u6211\u7684\u6A21\u578B</div><div class="search-box"><div class="search-input"><i class="iconfont icon-sousuo"></i> <input type="text" ng-model="vm.searchQuery" ng-readonly="vm.batchState" ng-keydown="vm.search()" placeholder="\u5173\u952E\u8BCD\u641C\u7D22"></div><div class="handle"><div class="batch-btn" ng-if="!vm.batchState" ng-click="vm.batchState = true"><i class="iconfont icon-batch"></i>\u6279\u91CF\u64CD\u4F5C</div><div class="btn-primary" ng-if="vm.batchState" ng-click="vm.batchState = false">\u9000\u51FA</div><div class="btn-primary create-model" ng-if="!vm.batchState" style="margin-left: 8px">\u521B\u5EFA\u6A21\u578B<div class="menu-box"><div class="menu-list"><div class="menu-item" ng-click="add(\'TWO\')">\u521B\u5EFA2D\u6A21\u578B</div><div class="menu-item" ng-click="add(\'THREE\')">\u521B\u5EFA3D\u6A21\u578B</div></div></div></div></div></div></div><div class="share-screen"><div class="screen-box"><div class="screen-tit">\u5206\u7C7B\uFF1A</div><div class="option-list"><div class="option-item" ng-repeat="item in vm.modelTypeList track by $index" ng-class="{\'active\':item.value === vm.modelType}" ng-click="modelTypeTab(item)">{{item.name}}</div></div></div></div><div class="template-list" style="padding-top: 24px"><div class="empty-view" ng-if="vm.data.length < 1"><img class="empty-img" src="content/images/model-empty.png" alt="\u65E0\u6570\u636E"><div class="empty-text">\u8FD8\u6CA1\u6709\u5185\u5BB9\u54E6\uFF0C <span class="link" ng-if="vm.modelType == \'TWO\'" ng-click="add(\'TWO\')">\u5FEB\u53BB\u521B\u5EFA\u5427 <i class="iconfont icon-right"></i> </span><span class="link" ng-if="vm.modelType == \'THREE\'" ng-click="add(\'THREE\')">\u5FEB\u53BB\u521B\u5EFA\u5427 <i class="iconfont icon-right"></i></span></div></div><div class="template-item" ng-repeat="item in vm.data track by item.id"><div class="img-view" ng-click="checkItem(item)"><div class="cover-view"><img class="cover-img" ng-if="domains.domain" err-src="content/images/default-cover.png" ng-src="{{domains.domain + item.modelPic + \'?imageMogr2/interlace/1/thumbnail/268x268\'}}" alt="{{item.name}}"> <img class="cover-img" ng-if="!domains.domain" src="content/images/default-cover.png" alt=""><div class="check-box" ng-class="{\'checked\' : item.selected}" ng-if="vm.batchState"><i class="iconfont icon-gou"></i></div></div><div class="shade-view" ng-if="!vm.batchState"><div class="preview-btn" ng-click="look(item)" uib-tooltip="\u9884\u89C8" tooltip-placement="bottom"><i class="iconfont icon-yulan"></i></div><div class="menu-view"><i class="iconfont icon-gengduo1"></i><div class="menu-content"><div class="menu-list"><div class="menu-item" ng-click="edit(item.id)">\u7F16\u8F91</div><div class="menu-item" ng-click="delete(item.id)">\u5220\u9664</div></div></div></div></div></div><div class="template-info"><div class="template-name" uib-tooltip="{{item.name}}" tooltip-placement="bottom">{{item.name}}</div></div></div></div><div class="batch-bar" style="background: #FF4444" ng-if="vm.batchState"><div class="checked-count"><span class="num">({{vm.selectCount}})</span>\u5DF2\u9009\u4E2D</div><div class="btns"><div class="batch-btn" ng-click="batchDelete()"><i class="iconfont icon-shanchu2"></i>\u5220\u9664</div></div><div class="btn-close" ng-click="vm.batchState = false"><i class="iconfont icon-closeicon1"></i></div></div><modele-pagination style="margin-top:10px" ng-show="!vm.batchState" page="vm.pageInfo.page" size="vm.pageInfo.size" total="vm.pageInfo.total" current-change="vm.currentChange()"></modele-pagination></div>');
$templateCache.put('app/entities/picture/picture-share-modal.html','<!--<form name="editForm" role="form" novalidate ng-submit="vm.save()" class="listBGC listCreate pad-0">--><!--    <button type="button" class="pad-5 close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;--><!--    </button>--><!--    <div class="modal-detail">--><!--        <h4 class="modal-title">\u5206\u4EAB</h4>--><!--    </div>--><!--    <div class="modal-body">--><!--        <div  class="panel-body form-horizontal">--><!--            <div class="col-lg-6 col-sm-6 form-group"  >--><!--                <div class="form-group">--><!--                    <label class="col-md-3 col-sm-3 col-xs-3  control-label">\u4E13\u9898</label>--><!--                    <div class="col-md-9 col-sm-9 col-xs-9">--><!--                        <select ng-options="catalog as catalog.name for catalog in vm.catalogs" ng-model-options="{debounce:500}" class="form-control fontSel" ng-model="vm.backCatalog">--><!--                            </select>--><!--                    </div>--><!--                </div>--><!--            </div>--><!--        </div>--><!--    </div>--><!--    <div class="modal-footer">--><!--        <button type="button" class="btn btn-cancel" data-dismiss="modal" ng-click="vm.clear()">--><!--            <span translate="entity.action.cancel">Cancel</span>--><!--        </button>--><!--        <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" style="width: 66px;" class="btn btn-primary btn-save btn-info mar-left-30">--><!--            <span translate="entity.action.save">save</span>--><!--        </button>--><!--    </div>--><!--</form>--><div class="c-model"><div class="c-model-head"><div class="c-model-head-title">\u5206\u4EAB\u5E03\u5C40</div><i class="iconfont icon-closeicon1" ng-click="vm.clear()"></i></div><div class="c-model-body"><div class="c-model-body-view"><div class="c-form"><label class="c-form-label">\u4E13\u9898</label><div class="c-form-div"><modele-select ng-model="vm.backCatalog" label-key="name" value-key="id" options="vm.catalogs"></modele-select></div></div></div></div><div class="c-model-foot" style="text-align: center"><button style="margin-right: 16px" type="button" class="btn btn-cancel" data-dismiss="modal" ng-click="vm.clear()">\u53D6\u6D88</button> <button type="button" class="btn btn-info" ng-disabled="editForm.$invalid || vm.isSaving" ng-click="vm.save()">\u786E\u5B9A</button></div></div><style>.c-form {\n        margin-bottom: 16px;\n    }\n\n    .c-model-body-view .c-form:last-child {\n        margin-bottom: 0;\n    }\n\n    .c-form .c-form-label {\n        width: 50px;\n        text-align: left;\n        line-height: 40px;\n        font-size: 14px;\n        color: #505760;\n    }\n\n    .c-form .c-form-div {\n        margin-left: 50px;\n        width: auto;\n    }\n\n    .c-form .c-form-div input.c-input1 {\n        height: 40px;\n    }\n\n    .c-form .c-form-div select.c-select1 {\n        height: 40px;\n    }</style>');
$templateCache.put('app/entities/picture/picture-share-modal1.html','<div class="c-model"><div class="c-model-head"><div class="c-model-head-title">\u9009\u62E9\u4E3B\u9898</div><i class="iconfont icon-closeicon1" ng-click="vm.cancel()"></i></div><div class="c-model-body"><div class="c-model-body-view"><div class="c-form"><label class="c-form-label" style="width: 80px">\u5173\u8054\u4E3B\u9898\uFF1A</label><div class="c-form-div" style="margin-left: 85px"><modele-select ng-model="vm.catalogId" label-key="name" value-key="id" options="vm.catalogs"></modele-select></div></div></div></div><div class="c-model-foot" style="text-align: center"><button type="button" class="btn btn-info" ng-click="vm.save()">\u786E\u5B9A</button> <button type="button" class="btn btn-cancel" ng-click="vm.cancel()">\u8FD4\u56DE</button></div></div><style>.modal-content {\n        width: 100%;\n        margin: 100px auto;\n    }</style>');
$templateCache.put('app/entities/picture/picture-share.html','<div class="share-content"><div class="share-head"><div class="share-title">\u5E03\u5C40\u4E2D\u5FC3</div><div class="search-box"><div class="search-input"><i class="iconfont icon-sousuo"></i> <input type="text" ng-model="vm.searchQuery" ng-keydown="vm.search()" placeholder="\u5173\u952E\u8BCD\u641C\u7D22"></div><div class="handle"><div class="batch-btn" ng-if="!vm.batchState" ng-click="vm.batchState = true"><i class="iconfont icon-batch"></i>\u6279\u91CF\u64CD\u4F5C</div><div class="quit-btn" ng-if="vm.batchState" ng-click="vm.batchState = false">\u9000\u51FA</div></div></div></div><div class="share-screen"><div class="screen-box"><div class="screen-tit">\u5206\u7C7B\uFF1A</div><div class="option-list"><div class="option-item" ng-repeat="item in vm.catalogs track by item.id" ng-class="{\'active\' : vm.catalogId == item.id}" ng-click="catalogClick(item)">{{item.name}}</div></div></div></div><div class="picture-list" style="margin-top: 24px"><div class="empty-view" ng-if="vm.textList.length < 1"><img class="empty-img" src="content/images/page-empty.png" alt="\u65E0\u6570\u636E"><div class="empty-text">\u6682\u65E0\u5185\u5BB9</div></div><div class="picture-item" ng-repeat="item in vm.textList track by item.id"><div class="img-view" ng-click="pictureSelect(item)"><div class="cover-view"><img class="cover-img" alt="\u56FE\u7247\u7F3A\u5931" ng-src="{{item.cover +\'?imageMogr2/interlace/1/thumbnail/268x268\'}}" err-src="content/images/default-cover.png"><div class="check-box" ng-class="{\'checked\' : item.selected}" ng-if="vm.batchState"><i class="iconfont icon-gou"></i></div></div><div class="shade-view" ng-if="!vm.batchState"><div class="preview-btn" ng-click="look(item)" uib-tooltip="\u9884\u89C8" tooltip-placement="bottom"><i class="iconfont icon-yulan"></i></div><div class="temp-btn" ng-click="save(item.id)">\u4F7F\u7528</div></div></div><div class="picture-info"><div class="picture-name">{{item.name}}</div></div></div></div><div class="batch-bar" ng-if="vm.batchState"><div class="checked-count"><span class="num">({{ vm.pictureArr.length }})</span>\u5DF2\u9009\u4E2D</div><div class="btn-use" ng-click="save()"><i class="iconfont icon-gou"></i> \u7ACB\u5373\u4F7F\u7528</div><div class="btn-close" ng-click="vm.batchState = false"><i class="iconfont icon-closeicon1"></i></div></div><modele-pagination style="margin-top:10px" ng-show="!vm.batchState" page="vm.pageInfo.page" size="vm.pageInfo.size" total="vm.pageInfo.total" current-change="vm.currentChange()"></modele-pagination></div>');
$templateCache.put('app/entities/picture/picture-xml.html','<div class="picture-xml-edit"><div class="header"><div class="left"><input type="text" ng-model="vm.data.name" placeholder="\u540D\u5B57"></div><div class="center"><span class="iconfont icon-chehui" ng-class="{\'disabled-btn\':vm.cookies.length <= 1}" uib-tooltip="\u4E0A\u4E00\u6B65" tooltip-placement="bottom" ng-click="xmlRevocation($event)"></span> <span class="iconfont icon-fanhuibanben" ng-class="{\'disabled-btn\':vm.cookies.length <= 1}" uib-tooltip="\u6062\u590D" tooltip-placement="bottom" ng-click="xmlNextStep($event)"></span> <span class="iconfont icon-quanping" uib-tooltip="\u5168\u5C4F" tooltip-placement="bottom" ng-click="fullScreen()" ng-if="!vm.isFullScreen"></span> <span class="iconfont icon-xingzhuang3" uib-tooltip="\u9000\u51FA\u5168\u5C4F" tooltip-placement="bottom" ng-click="exitScreen()" ng-if="vm.isFullScreen"></span></div><div class="right"><button type="button" class="btn1" ng-click="save()">\u4FDD\u5B58</button> <button type="button" class="btn2" ng-click="out()">\u9000\u51FA</button></div></div><div class="body"><div class="nav"><ul><li ng-class="{\'navOn\':\'imagebox\' == vm.navPitch}" ng-click="navCb(\'imagebox\')"><span class="iconfont icon-bianjiqi-xiangkuang"></span> <span>\u76F8\u6846</span></li></ul></div><div class="operationLeft hover-scrollbar" ng-if="!vm.isUnfold" id="navId"><div class="operationMain" ng-show="vm.navPitch == \'imagebox\'"><div class="upload-btn"><span class="iconfont icon-shangchuan"></span> \u6DFB\u52A0\u76F8\u6846\u5F62\u72B6 <input type="file" accept="image/jpeg, image/png" onchange="updatePic(event)"></div><div class="line"></div><div class="classify" ng-if="masklabels.length>0"><button ng-repeat="label in masklabels track by $index" ng-click="selectMaskLabel(label,$index)" data-index="{{$index}}" class="classify-btn" ng-class="{\'classify-btn-active\':label.id==vm.masklabelChooseId}">{{label.name}}</button></div><!-- <div class="classify-unfold" ng-click="">\n                    <span>\u5C55\u5F00<span class="iconfont icon-down"></span></span>\n                    <span>\u6536\u56DE<span class="iconfont icon-up"></span></span>\n                </div> --><div class="mask-body"><ul><li ng-repeat="item in vm.mask track by $index" ng-click="bgImgCb(item)" ng-if="(vm.photoTab == \'recommend\' && item.isRecommend) || vm.photoTab == \'oneself\'"><div class="mask-item"><img class="img" ng-src="{{item.identifier}}" alt=""><div class="delete" ng-click="bgImgDelete($event, item, $index)" ng-if="item.type == \'User\'"><span class="iconfont icon-shanchu2"></span></div></div></li></ul></div><div class="noData" ng-if="vm.isBgImgData">\u6CA1\u6709\u66F4\u591A\u5566</div></div></div><div class="main" ng-style="{\'overflow\' : vm.moveCanvasView ? \'hidden\' : \'\' }"><div class="top-btn"><div class="top-btn-left"><div class="iconfont icon-huabuduiqi" ng-class="{\'disabled-btn\':!selectBox,\'btn-avtive\':isAlignHover}" uib-tooltip="\u5BF9\u9F50" tooltip-placement="bottom" ng-click="toobarAlignment(!isAlignHover)"><div class="roundedSet" ng-show="isAlignHover" style="width: 320px"><div class="roundedSet-title"><div class="rightPanel-title">{{vm.ctrlKey.length > 1?\'\u5143\u7D20\u5BF9\u9F50\':\'\u753B\u5E03\u5BF9\u9F50\'}}</div></div><div class="align-view"><div ng-click="singleBoxAlignment(\'left\')"><i class="iconfont icon-zuoduiqi font-18"></i><div>\u5DE6\u5BF9\u9F50</div></div><div ng-click="singleBoxAlignment(\'right\')"><i class="iconfont icon-youduiqi font-18"></i><div>\u53F3\u5BF9\u9F50</div></div><div ng-click="singleBoxAlignment(\'standard\')"><i class="iconfont icon-huabuduiqi-chuizhijuzhong font-18"></i><div>\u6C34\u5E73\u5C45\u4E2D</div></div><div ng-click="singleBoxAlignment(\'vertical\')"><i class="iconfont icon-huabuduiqi-shuipingjuzhong font-18"></i><div>\u5782\u76F4\u5C45\u4E2D</div></div><div ng-click="singleBoxAlignment(\'top\')"><i class="iconfont icon-shangduiqi font-18"></i><div>\u4E0A\u5BF9\u9F50</div></div><div ng-click="singleBoxAlignment(\'bottom\')"><i class="iconfont icon-xiaduiqi font-18"></i><div>\u4E0B\u5BF9\u9F50</div></div></div><div class="roundedSet-title" style="margin-top: 20px" ng-if="vm.ctrlKey.length > 2"><div class="rightPanel-title">\u5143\u7D20\u5206\u5E03</div></div><div class="align-view" ng-if="vm.ctrlKey.length > 2"><div ng-click="boxDistribution(\'standard\')"><i class="iconfont icon-fenbu-shuipingfenbu font-18"></i><div>\u6C34\u5E73\u5206\u5E03</div></div><div ng-click="boxDistribution(\'vertical\')"><i class="iconfont icon-fenbu-chuizhifenbu font-18"></i><div>\u5782\u76F4\u5206\u5E03</div></div></div></div></div><div class="iconfont icon-huabujuzhong" ng-click="canvasMiddle()" uib-tooltip="\u753B\u5E03\u5C40\u4E2D" ng-class="{\'disabled-btn\':!selectBox}" tooltip-placement="bottom"></div></div><div class="top-btn-right"><div class="iconfont icon-yuanjiao" uib-tooltip="\u5706\u89D2" tooltip-placement="bottom" ng-class="{\'disabled-btn\':!selectBox.border,\'btn-avtive\':vm.isRoundedSet}" ng-click="roundedSet(!vm.isRoundedSet)"><div class="roundedSet" ng-show="vm.isRoundedSet" style="width: 320px;padding: 0" ng-click="fn($event)"><div class="roundedSet-title"><div style="display: flex;align-items: center"><h4 class="rightPanel-title" style="margin-right: 10px">\u5706\u89D2\u8BBE\u7F6E</h4><span class="filletType" ng-class="{\'filletTypeActive\': selectBox.border.radius.filletType == \'Fixed\'}" ng-click="changeFilletType(\'Fixed\')">px</span> <span class="filletType" ng-class="{\'filletTypeActive\': selectBox.border.radius.filletType == \'Proportion\'}" ng-click="changeFilletType(\'Proportion\')">%</span></div><div class="border-radio-btn"><span class="iconfont icon-yuanjiaoshezhi1" ng-click="borderRadiusAllbtn($event)" ng-style="{\'background\':vm.borderRadiusAllbtn?\'#F5F7FA\':\'\'}" style="padding:2px 5px;border-radius: 4px"></span> <span class="iconfont icon-yuanjiaoshezhi2" ng-click="vm.borderRadiusAllbtn = false" ng-style="{\'background\':!vm.borderRadiusAllbtn?\'#F5F7FA\':\'\'}" style="padding:2px 5px;border-radius: 4px"></span></div></div><!-- \u767E\u5206\u6BD4 --><div ng-if="selectBox.border.radius.filletType == \'Proportion\'"><div ng-if="!vm.borderRadiusAllbtn" style="margin-bottom: 10px"><div class="c-schedule-view"><span class="c-schedule-title">\u5DE6\u4E0A\uFF1A</span> <input type="range" min="0" max="100" step="1" value="{{selectBox.border.radius.lt}}" ng-model="selectBox.border.radius.lt" ng-change="borderRadius($event)" class="text-range" style="width: 100% !important" ng-style="{\'background-size\': selectBox.border.radius.lt + \'% \' + \'100%\'}"> <span style="width: 30px">{{selectBox.border.radius.lt}}%</span></div><div class="c-schedule-view"><span class="c-schedule-title">\u53F3\u4E0A\uFF1A</span> <input type="range" min="0" max="100" step="1" value="{{selectBox.border.radius.rt}}" ng-model="selectBox.border.radius.rt" ng-change="borderRadius($event)" class="text-range" style="width: 100% !important" ng-style="{\'background-size\': selectBox.border.radius.rt + \'% \' + \'100%\'}"> <span style="width: 30px">{{selectBox.border.radius.rt}}%</span></div><div class="c-schedule-view"><span class="c-schedule-title">\u53F3\u4E0B\uFF1A</span> <input type="range" min="0" max="100" step="1" value="{{selectBox.border.radius.rb}}" ng-model="selectBox.border.radius.rb" ng-change="borderRadius($event)" class="text-range" style="width: 100% !important" ng-style="{\'background-size\': selectBox.border.radius.rb + \'% \' + \'100%\'}"> <span style="width: 30px">{{selectBox.border.radius.rb}}%</span></div><div class="c-schedule-view"><span class="c-schedule-title">\u5DE6\u4E0B\uFF1A</span> <input type="range" min="0" max="100" step="1" value="{{selectBox.border.radius.lb}}" ng-model="selectBox.border.radius.lb" ng-change="borderRadius($event)" class="text-range" style="width: 100% !important" ng-style="{\'background-size\': selectBox.border.radius.lb + \'% \' + \'100%\'}"> <span style="width: 30px">{{selectBox.border.radius.lb}}%</span></div></div><div ng-if="vm.borderRadiusAllbtn"><div class="c-schedule-view"><span class="c-schedule-title">\u5168\u90E8\uFF1A</span> <input type="range" min="0" max="100" step="1" value="{{selectBox.border.radius.all}}" ng-model="selectBox.border.radius.all" ng-change="borderRadiusAll()" class="text-range" style="width: 100% !important" ng-style="{\'background-size\': selectBox.border.radius.all + \'% \' + \'100%\'}"> <span style="width: 30px">{{selectBox.border.radius.all}}%</span></div></div></div><!-- \u56FA\u5B9A\u503C --><div ng-if="selectBox.border.radius.filletType == \'Fixed\'"><div ng-if="!vm.borderRadiusAllbtn" style="margin: 10px 0;display: flex;flex-wrap: wrap;row-gap: 10px"><div class="c-schedule-view2"><span class="c-schedule-title">\u5DE6\u4E0A\uFF1A</span><input-number ng-model="selectBox.border.radius.lt" on-change="borderRadius($event)" min="0" type-style="\'one\'"></input-number><span style="width: 30px">px</span></div><div class="c-schedule-view2"><span class="c-schedule-title">\u53F3\u4E0A\uFF1A</span><input-number ng-model="selectBox.border.radius.rt" on-change="borderRadius($event)" min="0" type-style="\'one\'"></input-number><span style="width: 30px">px</span></div><div class="c-schedule-view2"><span class="c-schedule-title">\u5DE6\u4E0B\uFF1A</span><input-number ng-model="selectBox.border.radius.lb" on-change="borderRadius($event)" min="0" type-style="\'one\'"></input-number><span style="width: 30px">px</span></div><div class="c-schedule-view2"><span class="c-schedule-title">\u53F3\u4E0B\uFF1A</span><input-number ng-model="selectBox.border.radius.rb" on-change="borderRadius($event)" min="0" type-style="\'one\'"></input-number><span style="width: 30px">px</span></div></div><div ng-if="vm.borderRadiusAllbtn" style="margin: 10px 0"><div class="c-schedule-view2"><span class="c-schedule-title">\u5168\u90E8\uFF1A</span><input-number ng-model="selectBox.border.radius.all" on-change="borderRadiusAll()" min="0" type-style="\'one\'"></input-number><span style="width: 30px">px</span></div></div></div></div></div><div class="iconfont icon-bianjiqi-biankuang" uib-tooltip="\u8FB9\u6846" tooltip-placement="bottom" ng-class="{\'disabled-btn\':!selectBox.border,\'btn-avtive\':vm.isBorderSet}" ng-click="borderSet(!vm.isBorderSet)"><div class="roundedSet" ng-show="vm.isBorderSet" ng-click="fn($event)" style="width: 320px"><div class="roundedSet-title"><h4 class="rightPanel-title">\u8FB9\u6846\u8BBE\u7F6E</h4></div><div class="borderSet-body"><div class="bezel-set-color" style="width: 30px;height: 30px" ng-style="{background:vm.data.document.levels.level[vm.xmlSelect.index].imagebox.border.color}"><input type="color" ng-value="vm.data.document.levels.level[vm.xmlSelect.index].imagebox.border.color" ng-model="vm.data.document.levels.level[vm.xmlSelect.index].imagebox.border.color"></div><div class="c-font-view" style="height: 30px;flex: 1;padding: 0 10px"><div class="c-font-view-head2"><div ng-show="vm.data.document.levels.level[vm.xmlSelect.index].imagebox.border.lineType == \'solid\'"><img src="content/images/icons/solid.png"></div><div ng-show="vm.data.document.levels.level[vm.xmlSelect.index].imagebox.border.lineType == \'dashed\'"><img src="content/images/icons/dashed.png"></div><div ng-show="vm.data.document.levels.level[vm.xmlSelect.index].imagebox.border.lineType == \'dotted\'"><img src="content/images/icons/dotted.png"></div><span class="iconfont icon-down" style="position: absolute;width: 20px;right: 5px;top: 50%;transform: translateY(-50%)"></span></div><div class="c-font-view-body" style="box-shadow: 0 0 10px 0 #cfcfcf"><div class="c-font-view-body-ul" style="margin-top: 0"><div class="c-font-view-body-li" ng-click="lineTypeChenge(\'solid\')"><img src="content/images/icons/solid.png"></div><div class="c-font-view-body-li" ng-click="lineTypeChenge(\'dashed\')"><img src="content/images/icons/dashed.png"></div><div class="c-font-view-body-li" ng-click="lineTypeChenge(\'dotted\')"><img src="content/images/icons/dotted.png"></div></div></div></div><div style="width: 80px;height: 30px;display: flex"><input type="number" class="c-input1" oninput="if(!/^[0-9]+$/.test(value)) value=value.replace(/\\D/g,\'\');if(value>999)value=999;if(value<0)value=null" ng-model="vm.data.document.levels.level[vm.xmlSelect.index].imagebox.border.lineWidth"> <span>px</span></div></div></div></div><div class="iconfont icon-touying" uib-tooltip="\u9634\u5F71" tooltip-placement="bottom" ng-class="{\'disabled-btn\':!selectBox.shadow,\'btn-avtive\':vm.isShadowSet}" ng-click="shadowSet(!vm.isShadowSet)"><div class="roundedSet" ng-show="vm.isShadowSet" ng-click="fn($event)" style="width: 320px"><div class="roundedSet-title"><h4 class="rightPanel-title">\u9634\u5F71\u8BBE\u7F6E</h4></div><div><div class="c-schedule-view"><span class="c-schedule-title">\u989C\u8272\uFF1A</span><div class="bezel-set-color" style="width: 30px;height: 30px" ng-style="{background:vm.data.document.levels.level[vm.xmlSelect.index].imagebox.shadow.color}"><input type="color" ng-value="vm.data.document.levels.level[vm.xmlSelect.index].imagebox.shadow.color" ng-model="vm.data.document.levels.level[vm.xmlSelect.index].imagebox.shadow.color"></div></div><div class="c-schedule-view"><span class="c-schedule-title">X\u8F74\uFF1A</span> <input type="range" min="-100" max="100" step="1" value="{{selectBox.shadow.x}}" ng-model="selectBox.shadow.x" ng-change="borderRadius($event)" class="text-range" style="width: 100% !important" ng-style="{\'background-size\': rangeShadowX(selectBox.shadow.x)}"> <span style="width: 30px">{{selectBox.shadow.x}}%</span></div><div class="c-schedule-view"><span class="c-schedule-title">Y\u8F74\uFF1A</span> <input type="range" min="-100" max="100" step="1" value="{{selectBox.shadow.y}}" ng-model="selectBox.shadow.y" ng-change="borderRadius($event)" class="text-range" style="width: 100% !important" ng-style="{\'background-size\':  rangeShadowY(selectBox.shadow.y)}"> <span style="width: 30px">{{selectBox.shadow.y}}%</span></div><div class="c-schedule-view"><span class="c-schedule-title">\u6A21\u7CCA\uFF1A</span> <input type="range" min="0" max="20" step="1" value="{{selectBox.shadow.blur}}" ng-model="selectBox.shadow.blur" ng-change="borderRadius($event)" class="text-range" style="width: 100% !important" ng-style="{\'background-size\': selectBox.shadow.blur * 5 + \'% \' + \'100%\'}"> <span style="width: 30px">{{selectBox.shadow.blur}}%</span></div></div></div></div><div class="iconfont icon-toumingdu" uib-tooltip="\u900F\u660E\u5EA6" tooltip-placement="bottom" ng-class="{\'disabled-btn\':!selectBox,\'btn-avtive\':vm.isTransp}" ng-click="transparencySelect($event,!vm.isTransp)"><div class="roundedSet" ng-show="vm.isTransp" style="width: 320px" ng-click="fn($event)"><div class="roundedSet-title"><h4 class="rightPanel-title">\u900F\u660E\u5EA6\u8BBE\u7F6E</h4></div><div class="c-schedule-view"><!-- <span class="c-schedule-title" style="width: 60px !important;">\u900F\u660E\u5EA6\u8BBE\u7F6E\uFF1A</span> --> <input type="range" min="0" max="1" step="0.01" value="{{selectBox.transparency}}" ng-model="selectBox.transparency" class="text-range" style="width: 100% !important" ng-style="{\'background-size\': selectBox.transparency*100 + \'% \' + \'100%\'}" ng-change="changeTransparency($event)"><!--                                <span style="width: 30px;">{{selectBox.transparency*100}}</span>--> <input type="number" step="1" class="c-input1" style="width: 70px;height: 30px;padding-right: 0;margin-left: 5px" ng-model="vm.transparency1" ng-change="transparencyChange1($event)"></div></div></div><div class="iconfont icon-tuceng" uib-tooltip="\u56FE\u5C42" tooltip-placement="bottom" ng-class="{\'disabled-btn\':!selectBox,\'btn-avtive\':vm.isCoverage}" ng-click="coverageSelect(!vm.isCoverage)"><div class="roundedSet" ng-show="vm.isCoverage" style="width: 245px" ng-click="fn($event)"><div class="roundedSet-title"><div class="rightPanel-title">\u56FE\u5C42\u8BBE\u7F6E</div></div><div class="c-schedule-view coverageItem" ng-click="seqStick($event)"><div class="iconfont icon-yizhidingceng"></div><div class="name">\u79FB\u81F3\u9876\u5C42</div></div><div class="c-schedule-view coverageItem" ng-click="seqUp($event)"><div class="iconfont icon-shangyiyiceng"></div><div class="name">\u4E0A\u79FB\u4E00\u5C42</div></div><div class="c-schedule-view coverageItem" ng-click="seqDown($event)"><div class="iconfont icon-shangyiyiceng"></div><div class="name">\u4E0B\u79FB\u4E00\u5C42</div></div><div class="c-schedule-view coverageItem" ng-click="seqBottom($event)"><div class="iconfont icon-xiayiyiceng"></div><div class="name">\u79FB\u81F3\u5E95\u5C42</div></div></div></div><div class="iconfont" uib-tooltip="{{vm.data.document.levels.level[vm.xmlSelect.index].imagebox.lock ? \'\u89E3\u9501\' : \'\u9501\u5B9A\'}}" tooltip-placement="bottom" ng-class="{\'disabled-btn\':!selectBox}" ng-click="xmlLock($event)"><span class="iconfont icon-suoding" ng-class="{\'shake3\':vm.data.document.levels.level[vm.xmlSelect.index].imagebox.lock}" style="font-size: 22px"></span></div><div class="iconfont icon-fuzhi2" uib-tooltip="\u590D\u5236" tooltip-placement="bottom" ng-class="{\'disabled-btn\':!selectBox}" ng-click="xmlCopy($event)"></div><div class="iconfont icon-shanchu" uib-tooltip="\u5220\u9664" tooltip-placement="bottom" ng-class="{\'disabled-btn\':!selectBox}" ng-click="xmlDelete($event)"></div></div></div><div class="canvas" id="canvas" ng-click="clearCtrlKey($event)"><div id="c-xml" style="background: #fff; position: relative" ng-dblclick="xmlDblclick($event)" onselectstart="return false" ng-style="{\n                    \'width\': vm.data.document.mediabox.width * vm.ratio,\n                    \'height\': vm.data.document.mediabox.height * vm.ratio,\n                    \'margin-left\': canvasCoordX(vm.data.document.mediabox.width * vm.ratio),\n                    \'margin-top\': canvasCoordY(vm.data.document.mediabox.height * vm.ratio)\n                    }"><div style="width: 100%; height: 100%; position: absolute; left: 0; top: 0; z-index: 1"><div style="width: 100%; height: 100%;overflow: hidden" ng-repeat=" item in vm.data.document.levels.level track by $index"><div class="c-xml-page-material" ng-click="imageartClick($event, item.imagebox, $index)" ng-class="{\'selected\': item.imagebox.selected || $index === vm.xmlSelect.index}" ng-if="item.imagebox" ng-style="{\n                            \'width\': item.imagebox.geometry.width * vm.ratio,\n                            \'height\': item.imagebox.geometry.height * vm.ratio,\n                            \'left\': item.imagebox.geometry.x * vm.ratio,\n                            \'top\': item.imagebox.geometry.y * vm.ratio,\n                            \'transform\': \'rotate(\' + item.imagebox.rotation.angle + \'deg)\',\n                            \'z-index\': item.seq-0+200\n                            }"><div style="width: 100%; height: 100%; position: relative;overflow: hidden" ng-style="{\n                                    \'border-top-left-radius\':(item.imagebox.border && item.imagebox.border.type == \'Pic\') ? 0 : imageboxWRadius(item.imagebox, \'lt\', vm.ratio),\n                                    \'border-top-right-radius\':(item.imagebox.border && item.imagebox.border.type == \'Pic\') ? 0 : imageboxWRadius(item.imagebox, \'rt\', vm.ratio),\n                                    \'border-bottom-right-radius\':(item.imagebox.border && item.imagebox.border.type == \'Pic\') ? 0 : imageboxWRadius(item.imagebox, \'rb\', vm.ratio),\n                                    \'border-bottom-left-radius\':(item.imagebox.border && item.imagebox.border.type == \'Pic\') ? 0 : imageboxWRadius(item.imagebox, \'lb\', vm.ratio),\n                                    \'border-width\': (item.imagebox.border && item.imagebox.border.type == \'Color\') ? (item.imagebox.border.lineWidth*vm.ratio | number:0) : \'\',\n                                    \'border-style\': (item.imagebox.border && item.imagebox.border.type == \'Color\' && item.imagebox.border.lineType == \'solid\') ? \'solid\' : (item.imagebox.border && item.imagebox.border.type == \'Color\' && item.imagebox.border.lineType == \'dashed\') ? \'dashed\' : (item.imagebox.border && item.imagebox.border.type == \'Color\' && item.imagebox.border.lineType == \'dotted\') ? \'dotted\' : \'none\',\n                                    \'border-color\': (item.imagebox.border && item.imagebox.border.type == \'Color\') ? item.imagebox.border.color : \'\',\n                                    \'box-shadow\' : (item.imagebox.border && item.imagebox.border.type == \'Color\' && item.imagebox.border.lineWidth>0 && item.imagebox.border && item.imagebox.border.lineType == \'solid\') ? \'0 0 0 1px \' + item.imagebox.border.color + \' inset\' : \'none\',\n                                    \'filter\' : dropShadow(item.imagebox,vm.ratio),\n                                    \'opacity\' : item.imagebox.transparency\n\n                                }" ng-mousedown="imageboxDown($event,item.imagebox)"><img data-index="{{$index}}" class="img-holder mask" style="width: 100%; height: 100%" ng-src="{{item.imagebox.bgImg}}"><div data-index="{{$index}}" class="image-placeholder-picture-xml" style="width: 100%;height: 100%"><img src="content/images/icons/camera.svg" alt="" srcset="" data-index="{{$index}}" ng-style="{\'width\':item.imagebox.geometry.width * vm.ratio < 56 ? \'50%\' : \'\' , \'height\':item.imagebox.geometry.height * vm.ratio < 56 ? \'50%\' : \'\'}"> <span ng-if="item.imagebox.geometry.width * vm.ratio > 60 && item.imagebox.geometry.height * vm.ratio > 80" data-index="{{$index}}">\u62D6\u5165\u76F8\u7247</span></div></div><span class="sel-top" data-index="{{$index}}" ng-style="{\'cursor\': cursor(item.imagebox.rotation.angle, \'left\', false)}" ng-mousedown="resizeStartLeft($event,item.imagebox,vm.ratio, $index)" ng-if="$index === vm.xmlSelect.index && vm.xmlSelect.type === \'imagebox\' && !item.imagebox.lock && vm.ctrlKey.length == 0"></span> <span class="sel-right" data-index="{{$index}}" ng-style="{\'cursor\': cursor(item.imagebox.rotation.angle, \'top\', false)}" ng-mousedown="resizeStartTop($event,item.imagebox,vm.ratio, $index)" ng-if="$index === vm.xmlSelect.index && vm.xmlSelect.type === \'imagebox\' && !item.imagebox.lock && vm.ctrlKey.length == 0"></span> <span class="sel-bottom" data-index="{{$index}}" ng-style="{\'cursor\': cursor(item.imagebox.rotation.angle, \'right\', false)}" ng-mousedown="resizeStartRigth($event, item.imagebox,vm.ratio, $index)" ng-if="$index === vm.xmlSelect.index && vm.xmlSelect.type === \'imagebox\' && !item.imagebox.lock && vm.ctrlKey.length == 0"></span> <span class="sel-left" data-index="{{$index}}" ng-style="{\'cursor\': cursor(item.imagebox.rotation.angle, \'bottom\', false)}" ng-mousedown="resizeStartBottom($event,item.imagebox,vm.ratio, $index)" ng-if="$index === vm.xmlSelect.index && vm.xmlSelect.type === \'imagebox\' && !item.imagebox.lock && vm.ctrlKey.length == 0"></span> <span class="sel-left1" data-index="{{$index}}" ng-style="{\'cursor\': cursor(item.imagebox.rotation.angle, \'left1\', false)}" ng-mousedown="resizeStartLeft1($event,item.imagebox,vm.ratio, $index)" ng-if="$index === vm.xmlSelect.index && vm.xmlSelect.type === \'imagebox\' && !item.imagebox.lock && vm.ctrlKey.length == 0"></span> <span class="sel-top1" data-index="{{$index}}" ng-style="{\'cursor\': cursor(item.imagebox.rotation.angle, \'top1\', false)}" ng-mousedown="resizeStartTop1($event,item.imagebox,vm.ratio, $index)" ng-if="$index === vm.xmlSelect.index && vm.xmlSelect.type === \'imagebox\' && !item.imagebox.lock && vm.ctrlKey.length == 0"></span> <span class="sel-right1" data-index="{{$index}}" ng-style="{\'cursor\': cursor(item.imagebox.rotation.angle, \'right1\', false)}" ng-mousedown="resizeStartRight1($event,item.imagebox,vm.ratio, $index)" ng-if="$index === vm.xmlSelect.index && vm.xmlSelect.type === \'imagebox\' && !item.imagebox.lock && vm.ctrlKey.length == 0"></span> <span class="sel-bottom1" data-index="{{$index}}" ng-style="{\'cursor\': cursor(item.imagebox.rotation.angle, \'bottom1\', false)}" ng-mousedown="resizeStartBottom1($event,item.imagebox,vm.ratio, $index)" ng-if="$index === vm.xmlSelect.index && vm.xmlSelect.type === \'imagebox\' && !item.imagebox.lock && vm.ctrlKey.length == 0"></span><div class="rotate-box" ng-if="$index === vm.xmlSelect.index && vm.xmlSelect.type === \'imagebox\' && !item.imagebox.lock && vm.ctrlKey.length == 0" ng-style="{width:item.imagebox.geometry.width * vm.ratio}"><div style="position: relative; width: 100%"><span class="rotate-icon rotate-icon{{$index}}" data-index="{{$index}}" ng-mousedown="imageboxdownRotate($event,item.imagebox)" style="position: absolute; top: 17px; left: 50%; margin-left: -11px"></span></div></div><span class="sel-right-lock" ng-if="$index === vm.xmlSelect.index && vm.xmlSelect.type === \'imagebox\' && item.imagebox.lock && vm.ctrlKey.length == 0"><span class="iconfont icon-suoding"></span></span></div></div></div></div></div><!-- \u7F29\u653E\u64CD\u4F5C\u6309\u94AE --><div class="choose-size-box"><div class="left-menu"><div class="lessen" ng-click="changeCanvasSize(1)" uib-tooltip="\u753B\u5E03\u7F29\u5C0F" tooltip-placement="top" tooltip-append-to-body="true"><i class="iconfont icon-jian"></i></div><div class="ratio">{{(100*vm.ratio)|number:0}}%</div><div class="magnify" ng-click="changeCanvasSize(2)" uib-tooltip="\u753B\u5E03\u653E\u5927" tooltip-placement="top" tooltip-append-to-body="true"><i class="iconfont icon-jia2"></i></div></div><div class="right-menu"><div class="menu-item" ng-click="changeCanvasSize(0)" uib-tooltip="\u521D\u59CB\u5C3A\u5BF8" tooltip-placement="top" tooltip-append-to-body="true"><i class="iconfont icon-fangda"></i></div><div class="menu-item" ng-click="vm.moveCanvasView = !vm.moveCanvasView" uib-tooltip="\u62D6\u62FD\u753B\u5E03" tooltip-placement="top" tooltip-append-to-body="true"><i class="iconfont icon-icon-zhuashou" ng-class="{\'active\' : vm.moveCanvasView}"></i></div><div class="menu-item" ng-click="changeCanvasSize(3)" uib-tooltip="\u539F\u5C3A\u5BF8" tooltip-placement="left" tooltip-append-to-body="true"><i class="iconfont icon-icon-test"></i></div></div></div><div class="moveCanvas-view" ng-mousedown="moveCanvas($event)" ng-if="vm.moveCanvasView" data-html2canvas-ignore></div><div class="unfoldLeft" ng-click="unfoldLeft()"><span class="iconfont icon-right" ng-if="vm.isUnfold"></span> <span class="iconfont icon-left" ng-if="!vm.isUnfold"></span></div><div class="unfoldRight" ng-click="unfoldRight()"><span class="iconfont icon-left" ng-if="vm.isUnfoldRight"></span> <span class="iconfont icon-right" ng-if="!vm.isUnfoldRight"></span></div></div><div class="right" ng-if="!vm.isUnfoldRight"><div class="attribute-head">\u5F53\u524D\u56FE\u7247\u6846 {{vm.data.document.levels.level.length}} \u4E2A</div><div class="attribute-body"><div class="attribute-body-module" ng-if="vm.xmlSelect.type == \'\'"><div class="attribute-body-module-title">\u4F5C\u54C1\u5C3A\u5BF8</div><div class="attribute-body-module-form"><div class="attribute-body-module-form-input"><span>\u5BBD</span> <input type="text" ng-model="vm.attribute.product.width"></div><div class="attribute-body-module-form-select"><select ng-model="vm.unit" ng-options="unit.id as unit.name for unit in vm.units" ng-change="unitConversion()"></select></div></div><div class="attribute-body-module-form"><div class="attribute-body-module-form-input"><span>\u9AD8</span> <input type="text" ng-model="vm.attribute.product.height"></div><div class="attribute-body-module-form-select"><select ng-model="vm.unit" ng-options="unit.id as unit.name for unit in vm.units" ng-change="unitConversion()"></select></div></div></div><div class="attribute-body-module" ng-if="vm.xmlSelect.type == \'imagebox\'"><div class="attribute-body-module-title">\u76F8\u6846\u5C3A\u5BF8</div><div class="attribute-body-module-form"><div class="attribute-body-module-form-input"><span>\u5BBD</span> <input type="text" ng-change="updateBoxParameter()" max="" min="0" ng-model-options="{debounce:500}" ng-model="vm.attribute.imagebox.width"></div><div class="attribute-body-module-form-select"><select ng-model="vm.unit" ng-options="unit.id as unit.name for unit in vm.units" ng-change="unitConversion()"></select></div></div><div class="attribute-body-module-form"><div class="attribute-body-module-form-input"><span>\u9AD8</span> <input type="text" ng-change="updateBoxParameter()" max="" min="0" ng-model-options="{debounce:500}" ng-model="vm.attribute.imagebox.height"></div><div class="attribute-body-module-form-select"><select ng-model="vm.unit" ng-options="unit.id as unit.name for unit in vm.units" ng-change="unitConversion()"></select></div></div></div><div class="attribute-body-module" ng-if="vm.xmlSelect.type == \'imagebox\'"><div class="attribute-body-module-title">\u5750\u6807</div><div class="attribute-body-module-form"><div class="attribute-body-module-form-input"><span>X</span> <input type="text" ng-change="updateBoxParameter()" max="" ng-model-options="{debounce:500}" ng-model="vm.attribute.imagebox.x"></div><div class="attribute-body-module-form-select"><select ng-model="vm.unit" ng-options="unit.id as unit.name for unit in vm.units" ng-change="unitConversion()"></select></div></div><div class="attribute-body-module-form"><div class="attribute-body-module-form-input"><span>Y</span> <input type="text" ng-change="updateBoxParameter()" max="" ng-model-options="{debounce:500}" ng-model="vm.attribute.imagebox.y"></div><div class="attribute-body-module-form-select"><select ng-model="vm.unit" ng-options="unit.id as unit.name for unit in vm.units" ng-change="unitConversion()"></select></div></div></div><div class="attribute-body-module" ng-if="vm.xmlSelect.type == \'imagebox\'"><div class="attribute-body-module-title">\u65CB\u8F6C\u89D2\u5EA6</div><div class="attribute-body-module-form"><div class="attribute-body-module-form-input2"><span>\u5EA6</span> <input type="number" ng-change="updateRotate()" max="" min="0" ng-model-options="{debounce:500}" ng-model="vm.data.document.levels.level[vm.xmlSelect.index].imagebox.rotation.angle"></div></div></div><div class="thumbnail-title">\u5F53\u524D\u9875\u9762\u7F29\u7565\u56FE</div><div class="thumbnail"><div style="background: #ffffff; margin: 0 auto; position: relative" ng-style="{\n                            \'width\': vm.data.document.mediabox.width * vm.ratio1,\n                            \'height\': vm.data.document.mediabox.height * vm.ratio1\n                        }"><div style="width: 100%; height: 100%; position: absolute; left: 0; top: 0; z-index: 1; overflow: hidden"><div style="width: 100%; height: 100%" ng-repeat=" item in vm.data.document.levels.level track by $index"><div class="c-xml-page-material" ng-if="item.imagebox" ng-style="{\n                                        \'width\': item.imagebox.geometry.width * vm.ratio1,\n                                        \'height\': item.imagebox.geometry.height * vm.ratio1,\n                                        \'left\': item.imagebox.geometry.x * vm.ratio1,\n                                        \'top\': item.imagebox.geometry.y * vm.ratio1,\n                                        \'transform\': \'rotate(\' + item.imagebox.rotation.angle + \'deg)\',\n                                        \'z-index\': item.seq-0+200\n                                    }"><div style="width: 100%; height: 100%; position: relative;overflow: hidden" ng-style="{\n                                        \'border-top-left-radius\':(item.imagebox.border && item.imagebox.border.type == \'Pic\') ? 0 : imageboxWRadius(item.imagebox, \'lt\', vm.ratio1),\n                                        \'border-top-right-radius\':(item.imagebox.border && item.imagebox.border.type == \'Pic\') ? 0 : imageboxWRadius(item.imagebox, \'rt\', vm.ratio1),\n                                        \'border-bottom-right-radius\':(item.imagebox.border && item.imagebox.border.type == \'Pic\') ? 0 : imageboxWRadius(item.imagebox, \'rb\', vm.ratio1),\n                                        \'border-bottom-left-radius\':(item.imagebox.border && item.imagebox.border.type == \'Pic\') ? 0 : imageboxWRadius(item.imagebox, \'lb\', vm.ratio1),\n                                        \'border-width\': (item.imagebox.border && item.imagebox.border.type == \'Color\') ? (item.imagebox.border.lineWidth*vm.ratio1 | number:0) : \'\',\n                                        \'border-style\': (item.imagebox.border && item.imagebox.border.type == \'Color\' && item.imagebox.border.lineType == \'solid\') ? \'solid\' : (item.imagebox.border && item.imagebox.border.type == \'Color\' && item.imagebox.border.lineType == \'dashed\') ? \'dashed\' : (item.imagebox.border && item.imagebox.border.type == \'Color\' && item.imagebox.border.lineType == \'dotted\') ? \'dotted\' : \'none\',\n                                        \'border-color\': (item.imagebox.border && item.imagebox.border.type == \'Color\') ? item.imagebox.border.color : \'\',\n                                        \'box-shadow\' : (item.imagebox.border && item.imagebox.border.type == \'Color\' && item.imagebox.border.lineWidth>0 && item.imagebox.border && item.imagebox.border.lineType == \'solid\') ? \'0 0 0 1px \' + item.imagebox.border.color + \' inset\' : \'none\',\n                                        \'filter\' : dropShadow(item.imagebox,vm.ratio1),\n                                        \'opacity\' : item.imagebox.transparency\n                                    }"><img data-index="{{$index}}" class="img-holder mask" style="width: 100%; height: 100%" ng-src="{{item.imagebox.bgImg}}"><div data-index="{{$index}}" class="image-placeholder-picture-xml-2" style="width: 100%;height: 100%"><img src="content/images/icons/camera.svg" alt="" srcset="" data-index="{{$index}}" ng-style="{\'width\':item.imagebox.geometry.width * vm.ratio1 < 36 ? \'50%\' : \'18px\' , \'height\':item.imagebox.geometry.height * vm.ratio1 < 36 ? \'50%\' : \'18px\'}"></div></div></div></div></div></div></div></div></div></div></div><style>.wrap{\n        display: none !important;\n    }</style>');
$templateCache.put('app/entities/picture/picture.html','<div class="workbench"><div class="work-head"><div class="work-title">\u5E03\u5C40\u7EC4\u4EF6</div><div class="search-box"><div class="search-input"><i class="iconfont icon-sousuo"></i> <input type="text" ng-model="vm.searchQuery" ng-readonly="vm.batchState" ng-keydown="vm.search()" placeholder="\u5173\u952E\u8BCD\u641C\u7D22"></div><div class="handle"><div class="batch-btn" ng-if="!vm.batchState" ng-click="vm.batchState = true"><i class="iconfont icon-batch"></i>\u6279\u91CF\u64CD\u4F5C</div><div class="btn-primary" ng-if="vm.batchState" ng-click="vm.batchState = false">\u9000\u51FA</div><div class="btn-primary" ng-if="!vm.batchState" style="margin-left: 8px" ng-click="add()">\u521B\u5EFA\u5E03\u5C40</div></div></div></div><div class="share-screen"><div class="screen-box"><div class="screen-tit">\u4E3B\u9898\uFF1A</div><div class="option-list"><div class="option-item" ng-class="{\'active\' : vm.catalogSelected == null}" ng-click="selectCatalog(catalog)">\u5168\u90E8</div><div class="option-item" ng-class="{\'active\' : catalog.id == vm.catalogSelected}" ng-repeat="catalog in  vm.catalogs track by $index" ng-click="selectCatalog(catalog)">{{catalog.name}}</div><div class="theme-btn" uib-tooltip="\u4E3B\u9898\u7BA1\u7406" tooltip-placement="bottom" ng-click="editorClassify()"><i class="iconfont icon-bianji"></i></div></div></div><div class="screen-line" style="padding-top: 32px"><div class="screen"><div class="genre no-cut"><div class="item" ng-repeat="item in vm.statusList" ng-class="{\'active\' : item.value === vm.selectStatus}" ng-click="statusCheck(item.value)">{{item.label}}</div></div></div></div></div><div class="template-list"><div class="empty-view" ng-if="vm.textList.length < 1"><img class="empty-img" src="content/images/picture-empty.png" alt="\u65E0\u6570\u636E"><div class="empty-text">\u8FD8\u6CA1\u6709\u5185\u5BB9\u54E6\uFF0C<span class="link" ng-click="add()">\u5FEB\u53BB\u521B\u5EFA\u5427<i class="iconfont icon-right"></i></span></div></div><div class="template-item" ng-repeat="item in vm.textList track by item.id"><div class="img-view" ng-click="checkItem(item)"><div class="cover-view"><img class="cover-img" err-src="content/images/default-cover.png" ng-src="{{item.cover +\'?imageMogr2/interlace/1/thumbnail/268x268\'}}" alt="{{item.name}}"><div class="check-box" ng-class="{\'checked\' : item.selected}" ng-if="vm.batchState"><i class="iconfont icon-gou"></i></div><div class="tag-box" ng-if="!vm.batchState"><div class="tag" ng-if="item.status === \'Approved\'">\u5DF2\u5206\u4EAB</div><div class="tag tag-success" ng-if="item.status === \'Created\'">\u5BA1\u6838\u4E2D</div><div class="tag tag-warn" ng-if="item.status === \'Rejected\'">\u5DF2\u9A73\u56DE</div></div></div><div class="shade-view" ng-if="!vm.batchState"><div class="preview-btn" ng-click="look(item)" uib-tooltip="\u9884\u89C8" tooltip-placement="bottom"><i class="iconfont icon-yulan"></i></div><div class="menu-view"><i class="iconfont icon-gengduo1"></i><div class="menu-content"><div class="menu-list"><div class="menu-item" ng-click="editXml(item)">\u7F16\u8F91</div><div class="menu-item" ng-click="copyXml(item)">\u590D\u5236</div><div class="menu-item" ng-click="editXmlTheme(item)">\u4FEE\u6539\u4E3B\u9898</div><div class="menu-item" ng-click="delete(item)">\u5220\u9664</div><div class="menu-item" ng-if="item.status == \'Rejected\'" ng-click="showReason(item)">\u67E5\u770B\u9A73\u56DE\u539F\u56E0</div><div class="cut-line" ng-if="item.status !== \'Approved\' && item.status !== \'Created\'"></div><div class="menu-item" ng-click="share(item)" ng-if="item.status !== \'Approved\' && item.status !== \'Created\'">\u5206\u4EAB</div></div></div></div></div></div><div class="template-info"><div class="template-name" uib-tooltip="{{item.name}}" tooltip-placement="bottom">{{item.name}}</div></div></div></div><div class="batch-bar" ng-if="vm.batchState"><div class="checked-count"><span class="num">({{vm.selectCount}})</span>\u5DF2\u9009\u4E2D</div><div class="btns"><div class="batch-btn" ng-click="share()"><i class="iconfont icon-fenxiang"></i>\u5206\u4EAB</div><div class="batch-btn" ng-click="batchDelete()"><i class="iconfont icon-shanchu3"></i>\u5220\u9664</div></div><div class="btn-close" ng-click="vm.batchState = false"><i class="iconfont icon-closeicon1"></i></div></div><modele-pagination style="margin-top:10px" ng-show="!vm.batchState" page="vm.pageInfo.page" size="vm.pageInfo.size" total="vm.pageInfo.total" current-change="vm.currentChange()"></modele-pagination></div>');
$templateCache.put('app/entities/page/alipay-xml.html','<div ng-bind-html="trustHtml"></div>');
$templateCache.put('app/entities/page/article-preview.html','<div class="preview-view"><local-loading title="\u52A0\u8F7D\u4E2D" show="vm.loading"></local-loading><div class="preview-view-left" ng-show="!vm.loading"><div class="preview-view-tab" ng-if="vm.bindingtypes.length>1"><!-- <div class="preview-view-tab-name">{{bindingtypeInfo()}}</div> --><div class="preview-view-tab-list"><div class="preview-view-tab-list-li" ng-repeat="item in vm.bindingtypes" ng-click="bindingtypeSelect(item)" ng-class="{\'preview-view-tab-list-li-select\' : item.id == vm.bindingtype}">{{item.name}}</div></div></div><div ng-show="vm.bindingtype == \'Left\' || vm.bindingtype == \'Top\'"><div class="prevImg" ng-if="(vm.bindingtype == \'Left\' || vm.bindingtype == \'Top\') && vm.thisPage>0" ng-click="prevPage(vm.thisPage)"><i class="iconfont icon-left"></i></div><div class="nextImg" ng-if="(vm.bindingtype == \'Left\' || vm.bindingtype == \'Top\') && vm.thisPage<vm.insidePages.length-1" ng-click="nextPage(vm.thisPage)"><i class="iconfont icon-right"></i></div><div class="preview-view-left-1"><div id="bb-bookblock" class="bb-bookblock" ng-style="{\n                width: vm.pageMaxWidth,\n                height: vm.pageMaxHeight,\n             }"><div class="bb-item" data-partid="{{page.partid}}" ng-repeat="page in vm.insidePages track by $index" style="width: 100%; display: flex; flex-wrap:nowrap" ng-if="vm.bindingtype == \'Left\'" ng-click="flipPage($event, $index)"><!--                         ng-click="prevPage($index)"--><div class="page-item" ng-if="page.page1"><div class="page-item-box-shadow" ng-style="{\n                                    \'margin-left\':page.page1.marginLeft,\n                                    \'margin-top\':(vm.pageMaxHeight-page.page1.custom.height * page.page1.ratio)/2\n                                    }"><page-preview page="page.page1" is-cover="template.config.dynamic" scale="page.page1.ratio"></page-preview></div></div><!--                         ng-click="nextPage($index)"--><div class="page-item" ng-if="page.page2"><div class="page-item-box-shadow" ng-style="{\n                                    \'margin-left\':page.page2.marginLeft,\n                                    \'margin-top\':(vm.pageMaxHeight-page.page2.custom.height * page.page2.ratio)/2\n                                    }"><page-preview page="page.page2" is-cover="template.config.dynamic" scale="page.page2.ratio"></page-preview></div></div></div><div class="bb-item" data-partid="{{page.partid}}" data-producttype="{{vm.productType}}" ng-repeat="page in vm.insidePages track by $index" style="width: 100%; display: flex; flex-wrap: wrap" ng-if="vm.bindingtype == \'Top\'" ng-click="flipPage($event, $index,\'Top\')"><!--                         ng-click="prevPage($index)"--><div class="page-item1" ng-if="page.page1"><div class="page-item-box-shadow" ng-style="{\n                            \'margin-top\':page.page1.marginLeft,\n                            \'margin-left\':(vm.pageMaxWidth-page.page1.custom.width * page.page1.ratio)/2\n                            }"><page-preview page="page.page1" is-cover="template.config.dynamic" scale="page.page1.ratio"></page-preview></div></div><!--                         ng-click="nextPage($index)"--><div class="page-item1" ng-if="page.page2"><div class="page-item-box-shadow" ng-style="{\n                        \'margin-top\':page.page2.marginLeft,\n                        \'margin-left\':(vm.pageMaxWidth-page.page2.custom.width * page.page2.ratio)/2\n                        }"><page-preview page="page.page2" is-cover="template.config.dynamic" scale="page.page2.ratio"></page-preview></div></div></div></div></div><div class="preview-view-left-2 scrollbar-main"><div class="preview-view-left-2-part" ng-repeat="part in vm.parts"><div class="preview-view-left-2-page" ng-if="part.id != \'P\'" ng-click="jumpPage(part.id)"><div class="preview-view-left-2-page-item" ng-repeat="pageItem in part.pages" ng-class="{\'pageSelect\' : vm.insidePages[vm.thisPage].partid == part.id}"><div class="pageIndex" uib-tooltip="{{part.name}}" tooltip-placement="auto top"><span>{{part.name}}</span></div><page-preview page="pageItem" scale="vm.ratio1" is-cover="template.config.dynamic"></page-preview></div></div><div class="preview-view-left-2-page" ng-if="part.id == \'P\'"><div class="preview-view-left-2-page-item1" ng-repeat="page in vm.insidePages" ng-if="page.partid == \'P\'" ng-click="jumpPage(page.partid,$index)" ng-class="{\'pageSelect\' : vm.insidePages[vm.thisPage].partid == page.partid && vm.thisPage == $index}"><div class="preview-view-left-2-page-item1-view" ng-if="page.page1"><page-preview page="page.page1" is-cover="template.config.dynamic" scale="vm.ratio1" is-cover="true"></page-preview></div><div class="preview-view-left-2-page-item1-view" ng-if="page.page2 && !page.page2.spread"><page-preview page="page.page2" is-cover="template.config.dynamic" scale="vm.ratio1" is-cover="true"></page-preview></div><div class="pageIndex"><span ng-class="{\'pageIndex-not\' : !page.page1.pageNumber}">{{page.page1.pageNumber}}</span> <span ng-class="{\'pageIndex-not\' : !page.page2.pageNumber}">{{page.page2.pageNumber}}</span></div></div></div></div></div></div><div class="tile-view scrollbar-main" ng-if="vm.bindingtype == \'Tile\'"><div class="tile-view-item scrollbar-main" ng-repeat="page in template.pages.page" ng-style="{width:vm.windowW1}"><page-preview page="page" is-cover="template.config.dynamic" scale="vm.ratioTile"></page-preview></div></div></div></div><style>.preview-view {\n        position: fixed;\n        left: 0;\n        top: 0;\n        right: 0;\n        bottom: 0;\n        background: #ffffff;\n    }\n\n    .loading-img {\n        position: fixed;\n        left: 50%;\n        top: 50%;\n        width: 200px;\n        margin: -100px 0 0 -100px;\n        z-index: 99;\n    }\n\n    .preview-view-left {\n        position: relative;\n        width: 100%;\n        height: 100%;\n    }\n\n    .preview-view-left-1 {\n        position: absolute;\n        left: 0;\n        top: 30px;\n        right: 0;\n        bottom: 160px;\n        display: flex;\n        justify-content: center;\n        align-items: center;\n    }\n\n    .page-item {\n        width: 50%;\n        height: 100%;\n        /*overflow: hidden;*/\n    }\n\n    .page-item1 {\n        width: 100%;\n        height: 50%;\n        /*overflow: hidden;*/\n    }\n\n    .preview-view-left-2 {\n        position: absolute;\n        left: 0;\n        bottom: 0;\n        right: 0;\n        width: 100%;\n        background: #F5F7FA;\n        overflow: auto;\n        padding: 16px;\n        display: flex;\n        z-index: 1000;\n    }\n\n    .preview-view-left-2-part {\n        display: flex;\n        margin-right: 15px;\n        border-right: 1px solid #ddd;\n    }\n\n    .preview-view-left-2-part:last-child {\n        border: 0;\n    }\n\n    .preview-view-left-2-page {\n        display: flex;\n    }\n\n    .preview-view-left-2-page-item {\n        height: fit-content;\n        margin-right: 15px;\n        position: relative;\n    }\n\n    .preview-view-left-2-page-item1 {\n        position: relative;\n        height: fit-content;\n        margin-right: 15px;\n        display: flex;\n    }\n\n    .preview-view-left-2-page-item1-view {\n        position: relative;\n        height: fit-content;\n    }\n\n    .pageIndex {\n        position: absolute;\n        top: -10px;\n        left: 0;\n        width: 100%;\n        z-index: 9;\n        display: flex;\n        justify-content: space-around;\n    }\n\n    .pageIndex span {\n        max-width: 100%;\n        display: inline-block;\n        padding: 2px 10px;\n        background: #777;\n        border-radius: 10px;\n        font-size: 12px;\n        color: #fff;\n        white-space: nowrap;\n        text-overflow: ellipsis;\n        overflow: hidden;\n        word-break: break-all;\n    }\n    .pageIndex span.pageIndex-not{\n        background: none !important;\n    }\n\n    .pageSelect {\n        border: 1px solid #299DFF;\n    }\n\n    .pageSelect .pageIndex span {\n        background: #299DFF;\n    }\n\n    .preview-view-tab {\n        position: fixed;\n        left: 32px;\n        top: 32px;\n        z-index: 9;\n        width: 224px;\n    }\n\n    .preview-view-tab-list {\n        width: 100%;\n        height: 48px;\n        background: #fff;\n        border: 1px solid #264DF0;\n        display: flex;\n        border-radius: 24px;\n        overflow: hidden;\n    }\n\n    .preview-view-tab-list-li {\n        width: 112px;\n        color: #264DF0;\n        font-size: 14px;\n        font-weight: bold;\n        cursor: pointer;\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        transition: all 0.1s;\n    }\n\n    .preview-view-tab-list-li-select {\n        background: #264DF0;\n        color: #ffffff;\n    }\n\n    .preview-view-tab:hover .preview-view-tab-name {\n        border-radius: 25px 25px 0 0;\n    }\n\n    .tile-view {\n        width: 100%;\n        height: 100%;\n        overflow: auto;\n        background: #f3f3f3;\n    }\n\n    .tile-view-item {\n        margin: 20px auto;\n        height: fit-content;\n        overflow: auto;\n    }\n\n    .prevImg {\n        position: fixed;\n        left: 120px;\n        top: 50%;\n        width: 56px;\n        height: 56px;\n        margin-top: -114px;\n    }\n\n    .nextImg {\n        position: fixed;\n        right: 120px;\n        top: 50%;\n        width: 56px;\n        height: 56px;\n        margin-top: -114px;\n    }\n\n    .nextImg,\n    .prevImg {\n        background: #F5F7FA;\n        border-radius: 50%;\n        color: #7D8692;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        font-size: 32px;\n        z-index: 20;\n    }</style>');
$templateCache.put('app/entities/page/buy-product-xml.html','<div class="c-model"><div class="c-model-head"><div class="c-model-head-title">\u6A21\u677F\u8D2D\u4E70</div><i class="iconfont icon-closeicon1" ng-click="reback()"></i></div><div class="c-model-body"><div class="c-model-body-view"><div class="c-model-body-view pay-model-view"><div class="pay-head"><div class="pay-title">\u5E94\u4ED8\u91D1\u989D\uFF1A</div><div class="amount">\uFFE5{{vm.xml.price}}</div></div><div class="pay-type"><div class="pay-title">\u8BF7\u9009\u62E9\u652F\u4ED8\u65B9\u5F0F\uFF1A</div><div class="pay-tabs-view"><div class="pay-tabs"><div class="tab-item" ng-class="{\'active\' : vm.payMethod==\'WeChat\'}" ng-click="changePayMethod(\'WeChat\')">\u5FAE\u4FE1\u652F\u4ED8</div><div class="tab-item" ng-class="{\'active\' : vm.payMethod==\'Alipay\'}" ng-click="changePayMethod(\'Alipay\')">\u652F\u4ED8\u5B9D</div></div><!-- \u5FAE\u4FE1\u652F\u4ED8 --><div class="tabs-content" ng-if="vm.payMethod==\'WeChat\'"><div class="pay-code-view"><div class="pay-code"><img class="code-img" ng-src="{{image}}"></div><p>\u8BF7\u4F7F\u7528\u5FAE\u4FE1\u626B\u7801\u8FDB\u884C\u652F\u4ED8</p></div></div><!-- \u652F\u4ED8\u5B9D\u652F\u4ED8 --><div class="tabs-content" ng-if="vm.payMethod==\'Alipay\'"><div class="pay-code-view"><div class="pay-code"><img class="alipay-icon" src="content/images/alipay-icon.png" alt="\u652F\u4ED8\u5B9D"></div><p ng-if="!vm.paymentState">\u8BF7\u70B9\u51FB\u4E0B\u65B9\u652F\u4ED8\u6309\u94AE\u652F\u4ED8</p><p ng-if="vm.paymentState">\u8DF3\u8F6C\u652F\u4ED8\u5B9D\uFF0C\u6B63\u5728\u652F\u4ED8\u4E2D...</p></div></div></div></div></div></div></div><div class="c-model-foot pay-model-foot"><button class="btn-close" ng-click="reback()" ng-if="!vm.paymentState">\u5173\u95ED</button> <button class="btn-pay" ng-if="vm.payMethod==\'Alipay\' && !vm.paymentState" ng-click="rechargeAlipay()">\u7ACB\u5373\u652F\u4ED8</button> <button class="btn-pay" ng-if="vm.payMethod==\'Alipay\' && vm.paymentState" ng-click="reback()">\u53D6\u6D88\u652F\u4ED8</button></div></div><style>.c-model-foot .btn{\n        margin-right: 16px;\n        line-height: 40px;\n        height: 40px;\n    }\n    .c-model-foot .btn:last-child{\n        margin-right: 0;\n    }</style>');
$templateCache.put('app/entities/page/catalog-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" class="listBGC listCreate pad-0"><button type="button" class="pad-5 close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><div class="modal-detail"><h4 class="modal-title" ng-if="vm.catalog.catalogType == \'XML\'">\u65B0\u5EFA\u6A21\u677F\u5206\u7C7B</h4><h4 class="modal-title" ng-if="vm.catalog.catalogType == \'LAYOUT\'">\u65B0\u5EFA\u5E03\u5C40\u5206\u7C7B</h4><h4 class="modal-title" ng-if="vm.catalog.catalogType == \'CLIPART\'">\u65B0\u5EFA\u7D20\u6750\u5206\u7C7B</h4><h4 class="modal-title" ng-if="vm.catalog.catalogType == \'BORDER\'">\u65B0\u5EFA\u8FB9\u6846\u5206\u7C7B</h4></div><div class="modal-body"><div class="panel-body form-horizontal"><div class="col-lg-12 col-sm-12 form-group"><div class="form-group"><label class="col-md-2 col-sm-2 col-xs-2 control-label">\u540D\u79F0</label><div class="col-md-10 col-sm-10 col-xs-10"><input type="text" class="form-control border-radius" placeholder="\u8BF7\u8F93\u5165\u54C1\u7C7B\u540D\u79F0" name="catalogName" id="catalogName" ng-model="vm.catalog.name"></div></div><div class="form-group"><label class="col-md-2 col-sm-2 col-xs-2 control-label">\u6392\u5E8F</label><div class="col-md-10 col-sm-10 col-xs-10"><input type="number" class="form-control border-radius" placeholder="\u8BF7\u8F93\u5165\u6392\u5E8F\u53F7" ng-model="vm.catalog.seq"></div></div><!--                <div class="form-group">--><!--                    <label class="col-md-2 col-sm-2 col-xs-2 control-label">\u7C7B\u578B</label>--><!--                    <div class="col-md-10 col-sm-10 col-xs-10">--><!--                        <div ng-class="{\'checkbox-1\':vm.catalog.catalogType == \'XML\',\'checkbox-0\':vm.catalog.catalogType != \'XML\'}" class="checkbox-icon float-left"--><!--                             ng-click="vm.catalog.catalogType = \'XML\'">--><!--                        </div>--><!--                        <div ng-click="vm.catalog.catalogType = \'XML\'" class="checkbox-icon float-left" style=" margin-top: 7px; margin-left: 5px; width: 30px;">\u6A21\u677F</div>--><!--                        <div ng-class="{\'checkbox-1\':vm.catalog.catalogType == \'LAYOUT\',\'checkbox-0\': vm.catalog.catalogType != \'LAYOUT\'}" class="checkbox-icon float-left"--><!--                             ng-click="vm.catalog.catalogType = \'LAYOUT\'" style="margin-left: 30px;">--><!--                        </div>--><!--                        <span ng-click="vm.catalog.catalogType = \'LAYOUT\'" class="checkbox-icon float-left" style=" margin-top: 7px; margin-left: 5px; width: 30px;">\u5E03\u5C40</span>--><!--                    </div>--><!--                </div>--></div></div></div><div class="modal-footer"><button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary btn-save btn-info"><span translate="entity.action.save">Save</span></button> <button type="button" class="btn btn-cancel" data-dismiss="modal" ng-click="vm.clear()"><span translate="entity.action.back">back</span></button></div></form>');
$templateCache.put('app/entities/page/catalog-management.html','<div class="c-model"><div class="c-model-head"><div class="c-model-head-title">{{vm.name}}\u7BA1\u7406</div><i class="iconfont icon-closeicon1" ng-click="close()"></i></div><div class="c-model-body scrollbar-main" id="model-body" style="overflow-y: auto;padding-top: 5px;min-height: 300px;max-height: 500px"><ul class="clearfix" ng-if="!vm.sortCatalog"><li ng-repeat="catalog in vm.catalogs track by $index" class="catalogW"><span class="seq-icon">{{ $index + 1 }}</span> <span ng-show="!catalog.edit" style="font-size: 14px;color:#222529;font-weight: bold;width: 300px;text-align: left;line-height: 16px">{{catalog.name}}</span><div class="catalog-input-box"><input class="catalog-input" ng-show="catalog.edit" ng-model="catalog.name" ng-class="{\'border-color-red\':catalog.name.length>22}"> <span class="catalog-input-info" ng-show="catalog.edit">{{catalog.name.length || "0"}}/22</span></div><span ng-show="catalog.edit" ng-click="save(catalog)" style="font-size: 14px; color: #264DF0; margin-left: 24px">\u786E\u5B9A</span> <span ng-show="catalog.edit" ng-click="cancel(catalog)" style="font-size: 14px; color: #505760; margin-left: 16px">\u53D6\u6D88</span><label class="i-switch" ng-click="useCatalog(catalog)" ng-show="!catalog.edit"><input type="checkbox" class="checkOrIf" name="enabled" ng-model="catalog.used" ng-if="vm.catalogType==\'CLIPART\' || vm.catalogType==\'BORDER\'|| vm.catalogType==\'MASK\'|| vm.catalogType==\'BACKGROUND\'|| vm.catalogType==\'GALLERY\'"> <input type="checkbox" class="checkOrIf" name="enabled" ng-model="catalog.usable" ng-if="!(vm.catalogType==\'CLIPART\' || vm.catalogType==\'BORDER\'|| vm.catalogType==\'MASK\'|| vm.catalogType==\'BACKGROUND\'|| vm.catalogType==\'GALLERY\')"></label><i class="iconfont icon-bianji" ng-click="edit(catalog)" style="position: absolute; right: 74px;font-size: 15px" ng-show="!catalog.edit"></i> <i class="iconfont icon-closeicon1" ng-click="delete(catalog,$event)" style="position: absolute; right: 26px;font-size: 15px" ng-show="!catalog.edit"></i></li></ul><ul class="clearfix" id="pageList" ng-if="vm.sortCatalog"><li ng-repeat="catalog in vm.catalogs track by $index" class="catalogW"><span class="seq-icon">{{ $index + 1 }}</span> <span ng-show="!catalog.edit" style="font-size: 14px;color:#222529;font-weight: bold;width: 300px;text-align: left;line-height: 16px">{{catalog.name}}</span> <i class="iconfont icon-yidong" style="margin-left: auto"></i></li></ul></div><div class="c-model-foot" style="display: flex;align-items: center"><span ng-click="addCatalog()" ng-if="!vm.sortCatalog">+\u6DFB\u52A0\u6807\u7B7E</span> <span ng-click="sortCatalog()" ng-if="!vm.addCatalog && !vm.sortCatalog" style="margin-left: auto;text-align: right !important">\u6807\u7B7E\u6392\u5E8F</span><div style="margin-left: auto" ng-if="vm.sortCatalog"><span ng-click="sortSave()">\u5B8C\u6210</span> <span ng-click="sortCancel()" style="color: #505760;margin-left: 10px">\u53D6\u6D88</span></div></div></div><style type="text/css" media="screen">.seq-icon{\n        width: 25px;\n        height: 25px;\n        border-radius: 25px;\n        line-height: initial;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        margin: 0 10px;\n        color:#264DF0;\n        background-color: rgba(38, 77, 240, 0.09) !important;\n    }\n    .detail-body{\n        padding: 0 24px;\n    }\n    .catalogW{\n        width: 535px;\n        height: 56px;\n        background: #FFFFFF;\n        border-radius: 2px;\n        margin: 0px 0px 8px 0px;\n        display: flex;\n        align-items: center;\n    }\n\n    #model-body .iconfont{\n        font-size: 20px;\n        margin: 0px 16px;\n    }\n\n\n    .catalog-input-box{\n        position: relative;\n    }\n    .catalog-input{\n        width: 240px;\n        height: 40px;\n        border-radius: 4px;\n        border: 1px solid #E1E5EB;\n        font-size: 14px;\n        padding-right: 55px;\n    }\n    .catalog-input.border-color-red{\n        border: 1px solid #f02626 !important;\n    }\n    .catalog-input.border-color-red:focus{\n        box-shadow: 0px 0px 4px 0px rgba(255, 58, 58, 0.45);\n        border: 1px solid #f02626 !important;\n    }\n    .catalog-input-info{\n        position: absolute;\n        top: 50%;\n        right: 16px;\n        transform: translate(0,-50%);\n        color: #89919D;\n        line-height: 40px;\n    }\n\n    .i-switch{\n        position: absolute;\n        right: 121px;\n        margin: 0px 16px;\n    }\n\n    .checkOrIf{\n        border: none; width: 24px !important; height: 12px !important;\n        background: #D1D5DC;\n    }\n\n    .checkOrIf:checked {\n        background: #264DF0;\n    }\n\n    .checkOrIf:before{\n        position: absolute;\n        left: 1px;\n        top: 0;\n        content: \'\';\n        width: 12px;\n        height: 12px;\n        outline: none;\n        border-radius: 50%;\n        background: white;\n        border: none;\n        box-shadow: 0px 0px 5px #ddd;\n        transition: all 0.2s linear;\n    }\n\n    .checkOrIf:checked:before {\n        left: 12px;\n        top: 0;\n        width: 12px;\n        height: 12px;\n        background: #fff;\n        transition: all 0.2s linear;\n    }\n\n    .c-model-foot span{\n        text-align: left !important;\n        width: 100px;\n        font-size: 16px;\n        font-weight: 600;\n        color: #264DF0;\n    }\n    .catalog-input:focus{\n        box-shadow: 0px 0px 4px 0px rgba(58,124,255,0.45);\n        border: 1px solid #264DF0 !important;\n    }</style>');
$templateCache.put('app/entities/page/page-add-label.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" class="listBGC listCreate pad-0"><div class="container-fluid"><div class="row moduleNameBGC"><button type="button" class="pad-5 close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><div class="modal-detail"><span translate="platformApp.page.edit">edit</span></div></div></div><div class="modal-body"><div class="panel-body form-horizontal" style="padding-bottom: 0"><div class="col-lg-10 col-sm-10 form-group"><div class="form-group"><label class="col-md-3 col-sm-3 col-xs-3 control-label" translate="platformApp.page.themeClassify">themeClassify</label><div class="col-md-9 col-sm-9 col-xs-9"><input type="text" class="form-control" placeholder="\u8BF7\u8F93\u5165" ng-change="updateTemplateHeightAndWidth(\'px\')" max="" ng-model-options="{debounce:500}" ng-model="vm.label"></div></div></div></div></div><div class="modal-footer align-center"><button type="button" class="btn btn-cancel" style="width: 66px" data-dismiss="modal" ng-click="vm.clear()"><span translate="entity.action.back">back</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" style="width: 66px" class="btn btn-primary btn-save btn-info mar-left-30"><span translate="entity.action.sure">sure</span></button></div></form>');
$templateCache.put('app/entities/page/page-create.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" class="listBGC listCreate pad-0" style="margin-top: -150px"><div class="container-fluid"><div class="row moduleNameBGC"><button type="button" class="pad-5 close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><div class="modal-detail"><span translate="platformApp.page.create">create</span></div></div></div><div class="modal-body"><div class="panel-body form-horizontal"><div class="col-lg-10 col-sm-10 form-group mar-bottom-0"><div class="form-group"><label class="col-md-3 col-sm-3 col-xs-3 control-label" translate="platformApp.page.workName" for="field_workName">workName</label><div class="col-md-9 col-sm-9 col-xs-9"><input type="text" class="form-control" name="field_name" id="field_workName" ng-model="vm.page.name" placeholder="\u8BF7\u8F93\u5165\u540D\u79F0" maxlength="20"></div></div></div><div class="col-lg-10 col-sm-10 form-group mar-bottom-0"><div class="form-group"><label class="col-md-3 col-sm-3 col-xs-3 control-label" translate="platformApp.page.workSize">workName</label><div class="col-md-9 col-sm-9 col-xs-9"><img src="content/images/icons/ic_guanlian.png" class="creat-guanlian" ng-click="guanlian(0)" ng-show="!isGuanlian"> <img src="content/images/icons/ic_guanlian2.svg" class="creat-guanlian" ng-click="guanlian(1)" ng-show="isGuanlian"><div class="col-md-4 col-sm-4 col-md-4 text-center mar-left--15"><input type="number" class="form-control" placeholder="\u5BBD" max="" min="0" onkeyup="value=value.replace(/^(0+)|[^\\d]+/g,\'\')" name="pageWidth" ng-change="updateTemplateHeightAndWidth(0)" ng-disabled="vm.aid" ng-model-options="{debounce:500}" ng-model="vm.page.pageSize.width"></div><div class="col-md-4 col-sm-4 col-md-4 text-center"><input type="number" class="form-control mar-left-30" placeholder="\u9AD8" max="" min="0" onkeyup="value=value.replace(/^(0+)|[^\\d]+/g,\'\')" name="pageHeight" ng-change="updateTemplateHeightAndWidth(1)" ng-disabled="vm.aid" ng-model-options="{debounce:500}" ng-model="vm.page.pageSize.height"></div><div class="col-md-4 col-sm-4 col-lg-4 text-left"><select ng-options="dpi as dpi.data for dpi in vm.dpiChoose" ng-disabled="vm.aid" ng-model-options="{debounce:500}" class="form-control fontSel mar-left-30" ng-change="updateDpi(dpi)" ng-model="dpi"></select></div></div></div></div><div class="col-lg-10 col-sm-10 form-group mar-bottom-0"><div class="form-group"><label class="col-md-3 col-sm-3 col-xs-3 control-label" translate="platformApp.page.bloodSize">bloodSize</label><div class="col-md-9 col-sm-9 col-xs-9"><div class="col-md-2 col-sm-2 col-md-2 text-center pad-0 mar-right-4"><input type="number" class="form-control" placeholder="\u4E0A" max="" min="0" name="bloodTop" onkeyup="value=value.replace(/^(-1+)|[^\\d]+/g,\'\')" ng-model-options="{debounce:500}" ng-model="vm.page.bloodSize.top"></div><div class="col-md-2 col-sm-2 col-md-2 text-center pad-0 mar-right-4"><input type="number" class="form-control" placeholder="\u4E0B" max="" min="0" onkeyup="value=value.replace(/^(-1+)|[^\\d]+/g,\'\')" name="bloodBottom" ng-model-options="{debounce:500}" ng-model="vm.page.bloodSize.bottom"></div><div class="col-md-2 col-sm-2 col-md-2 text-center pad-0 mar-right-4"><input type="number" class="form-control" placeholder="\u5DE6" max="" min="0" onkeyup="value=value.replace(/^(-1+)|[^\\d]+/g,\'\')" name="bloodLeft" ng-model-options="{debounce:500}" ng-model="vm.page.bloodSize.left"></div><div class="col-md-2 col-sm-2 col-md-2 text-center pad-0"><input type="number" class="form-control" placeholder="\u53F3" max="" min="0" onkeyup="value=value.replace(/^(-1+)|[^\\d]+/g,\'\')" name="bloodRight" ng-model-options="{debounce:500}" ng-model="vm.page.bloodSize.right"></div><div class="col-md-3 col-sm-3 col-lg-3 text-left pad-0" style="margin-left: 18px"><select ng-options="dpi as dpi.data for dpi in vm.dpiChoose" ng-model-options="{debounce:500}" class="form-control fontSel" ng-change="updateDpi(dpi)" ng-model="dpi"></select></div></div></div></div><div class="col-lg-10 col-sm-10 form-group mar-bottom-0"><div class="form-group"><label class="col-md-3 col-sm-3 col-xs-3 control-label" translate="platformApp.page.editSize">editSize</label><div class="col-md-9 col-sm-9 col-xs-9"><div class="col-md-2 col-sm-2 col-md-2 text-center pad-0 mar-right-4"><input type="number" class="form-control page-input" placeholder="\u5BBD\u5EA6" max="" min="0" onkeyup="value=value.replace(/^(0+)|[^\\d]+/g,\'\')" ng-disabled="vm.aid" name="bloodTop" ng-model-options="{debounce:500}" ng-model="vm.page.editbox.width"></div><div class="col-md-2 col-sm-2 col-md-2 text-center pad-0 mar-right-4"><input type="number" class="form-control page-input" placeholder="\u9AD8\u5EA6" max="" min="0" onkeyup="value=value.replace(/^(0+)|[^\\d]+/g,\'\')" ng-disabled="vm.aid" name="bloodBottom" ng-model-options="{debounce:500}" ng-model="vm.page.editbox.height"></div><div class="col-md-2 col-sm-2 col-md-2 text-center pad-0 mar-right-4"><input type="number" class="form-control" placeholder="x" max="" min="0" onkeyup="value=value.replace(/^(-1+)|[^\\d]+/g,\'\')" ng-disabled="vm.aid" name="bloodLeft" ng-model-options="{debounce:500}" ng-model="vm.page.editbox.x"></div><div class="col-md-2 col-sm-2 col-md-2 text-center pad-0"><input type="number" class="form-control" placeholder="y" max="" min="0" onkeyup="value=value.replace(/^(-1+)|[^\\d]+/g,\'\')" ng-disabled="vm.aid" name="bloodRight" ng-model-options="{debounce:500}" ng-model="vm.page.editbox.y"></div><div class="col-md-3 col-sm-3 col-lg-3 text-left pad-0" style="margin-left: 18px"><select ng-options="dpi as dpi.data for dpi in vm.dpiChoose" ng-model-options="{debounce:500}" class="form-control fontSel" ng-change="updateDpi(dpi)" ng-disabled="vm.aid" ng-model="dpi"></select></div></div></div></div><div class="col-lg-10 col-sm-10 form-group mar-bottom-0"><div class="form-group"><label class="col-md-3 col-sm-3 col-xs-3 control-label" translate="platformApp.page.pageSize">pageSize</label><div class="col-md-9 col-sm-9 col-xs-9"><input type="number" class="form-control" placeholder="\u8BF7\u8F93\u5165" ng-change="updateTemplateHeightAndWidth(\'px\')" max="" ng-disabled="vm.aid" name="pageNum" ng-model-options="{debounce:500}" ng-model="vm.page.pageNum"></div></div></div><div class="col-lg-10 col-sm-10 form-group mar-bottom-0"><div class="form-group"><label class="col-md-3 col-sm-3 col-xs-3 control-label" translate="platformApp.page.reprint" for="field_reprint">Spread</label><div class="col-md-9 col-sm-9 col-xs-9"><select class="form-control" name="field_reprint" id="field_reprint" ng-model="vm.page.bindingType"><!-- <option value="Standard" data-translate="backApp.ProductType.Standard">Standard</option> --><option value="Left" data-translate="platformApp.page.horizontal">Horizontal</option><option value="Top" data-translate="platformApp.page.vertical">Vertical</option><option value="None" data-translate="platformApp.page.other">Other</option></select></div></div></div><div class="col-lg-10 col-sm-10 form-group mar-bottom-0"><div class="form-group"><label class="col-md-3 col-sm-3 col-xs-3 control-label">\u7F16\u8F91\u6A21\u5F0F</label><div class="col-md-9 col-sm-9 col-xs-9"><select class="form-control" ng-model="vm.page.pattern"><option value="BOOK">\u4E66\u520A\u6A21\u5F0F</option><option value="OTHER">\u666E\u901A\u6A21\u5F0F</option></select></div></div></div><div class="col-lg-10 col-sm-10 form-group mar-bottom-0"><div class="form-group"><label class="col-md-3 col-sm-3 col-xs-3 control-label">\u6A21\u677F\u66FF\u6362</label><div class="col-md-9 col-sm-9 col-xs-9"><select class="form-control" ng-model="vm.page.replace"><option value="true">\u53EF\u66FF\u6362</option><option value="false">\u4E0D\u53EF\u66FF\u6362</option></select></div></div></div><div class="col-lg-10 col-sm-10 form-group mar-bottom-0"><div class="form-group"><label class="col-md-3 col-sm-3 col-xs-3 control-label">\u4E3B\u9898</label><div class="col-md-9 col-sm-9 col-xs-9"><select class="form-control" name="field_name" ng-model="vm.page.catalogId" ng-change="catalogChange()" ng-options="catalog.id as catalog.name for catalog in vm.catalogs"></select></div></div></div></div></div><div class="modal-footer align-center"><button type="button" class="btn btn-cancel" style="width: 66px" data-dismiss="modal" ng-click="vm.clear()"><span translate="entity.action.back">back</span></button> <button type="submit" ng-disabled="vm.isSaving" style="width: 66px" class="btn btn-primary btn-save btn-info mar-left-30"><span translate="entity.action.sure">sure</span></button></div></form>');
$templateCache.put('app/entities/page/page-edit.html','<div class="c-model"><div class="c-model-head"><div class="c-model-head-title" ng-show="isPageSize==1">\u4FEE\u6539\u5F53\u524D\u9875\u9762\u753B\u5E03\u5C3A\u5BF8</div><div class="c-model-head-title" ng-show="isPageSize==2">\u4FEE\u6539\u5F53\u524D\u9875\u9762\u51FA\u8840\u5C3A\u5BF8</div><div class="c-model-head-title" ng-show="isPageSize==0">\u4FEE\u6539\u5F53\u524D\u9875\u9762\u53EF\u7F16\u8F91\u533A\u57DF</div><i class="iconfont icon-closeicon1" ng-click="vm.clear()"></i></div><div class="c-model-body"><div class="c-model-body-view"><div class="c-form"><label class="c-form-label">\u7F16\u8F91\u533A\u57DF\uFF1A</label><div class="c-form-div"><div style="display: flex; justify-content: space-between; width: 100%;position: relative; margin-bottom: 10px;align-items: center" ng-repeat="editbox in vm.page.editboxs track by $index"><div class="c-editor-form-view1 c-editor-form-view1-1-border"><div class="c-editor-form-view1-1"><span>X</span> <input type="text" ng-model="editbox.x"></div><div class="c-editor-form-view1-1"><span>Y</span> <input type="text" ng-model="editbox.y"></div><div class="c-editor-form-view1-1"><span>\u5BBD</span> <input type="text" ng-model="editbox.width"></div><div class="c-editor-form-view1-1"><span>\u9AD8</span> <input type="text" ng-model="editbox.height"></div></div><div class="c-editor-form-view1" style="width: 134px; min-width: 134px; margin: 0 10px"><div class="c-editor-form-view1-1"><span>\u5355\u4F4D</span><select ng-options="dpi as dpi.data for dpi in vm.dpiChoose" ng-model-options="{debounce:500}" ng-change="updateDpi(vm.page.dpi1)" ng-model="vm.page.dpi1"></select></div></div><i class="iconfont icon-jiahao2fill pageEditAdd" ng-click="addPageEdit()" ng-if="$index == (vm.page.editboxs.length - 1)"></i> <i class="iconfont icon-dustbin_icon pageEditAdd" ng-click="removePageEdit($index)" ng-if="$index < (vm.page.editboxs.length - 1)" style="background: rgba(255,68,68,0.08);color: #ff4444;width: 28px;height: 28px;border-radius: 28px;font-size: 16px;display: flex;align-items: center;justify-content: center"></i></div></div></div><!--            <div class="col-lg-1 col-sm-1 form-group"></div>--><!--            <div class="col-lg-10 col-sm-10 form-group" ng-show="isPageSize==1">--><!--                <div class="form-group">--><!--                    <div class="col-md-12 col-sm-12 col-xs-12">--><!--                        <img src="content/images/icons/ic_guanlian.png" style="position: absolute;left:52.4%;top:25%">--><!--                        <div class="col-md-3 col-sm-3 col-md-3"></div>--><!--                        <div class="col-md-3 col-sm-3 col-md-3 text-center rightPanel-input" style="line-height: 34px;">--><!--                            <div class="col-md-8 col-sm-8 col-md-8 text-center pad-0">--><!--                                <input type="number" class="no-appearance" placeholder="\u5BBD"--><!--                                       max=""--><!--                                       min="0"--><!--                                       name="pageWidth"--><!--                                       ng-model-options="{debounce:500}"--><!--                                       ng-model="vm.page.pageSize.width">--><!--                            </div>--><!--                            <div class="col-md-4 col-sm-4 col-lg-4 text-center pad-0 color-A6">--><!--                                <div class="input-line"></div>\u5BBD--><!--                            </div>--><!--                        </div>--><!--                        <div class="col-md-1 col-sm-1 col-md-1"></div>--><!--                        <div class="col-md-3 col-sm-3 col-md-3 text-center rightPanel-input" style="line-height: 34px;">--><!--                            <div class="col-md-8 col-sm-8 col-md-8 text-center pad-0">--><!--                                <input type="number" class="no-appearance" placeholder="\u9AD8"--><!--                                       max=""--><!--                                       min="0"--><!--                                       name="pageHeight"--><!--                                       ng-model-options="{debounce:500}"--><!--                                       ng-model="vm.page.pageSize.height">--><!--                            </div>--><!--                            <div class="col-md-4 col-sm-4 col-lg-4 text-center pad-0 color-A6">--><!--                                <div class="input-line"></div>\u9AD8--><!--                            </div>--><!--                        </div>--><!--                        <div class="col-md-2 col-sm-2 col-lg-2 text-left ">--><!--                            <select ng-options="dpi as dpi.data for dpi in vm.dpiChoose"--><!--                                    ng-model-options="{debounce:500}"--><!--                                    class="form-control fontSel rightPanel-input"--><!--                                    ng-change="updateDpi(vm.page.dpi1)"--><!--                                    ng-model="vm.page.dpi1">--><!--                            </select>--><!--                        </div>--><!--                    </div>--><!--                </div>--><!--            </div>--><!--            <div class="col-lg-1 col-sm-1 form-group"></div>--><!--            <div class="col-lg-1 col-sm-1 form-group"></div>--><!--            <div class="col-lg-10 col-sm-10 form-group pad-0" ng-show="isPageSize==2">--><!--                <div class="form-group">--><!--                    <div class="col-md-12 col-sm-12 col-xs-12 pad-0">--><!--                        <div class="col-md-2 col-sm-2 col-md-2 text-center pad-0 rightPanel-input" style="line-height: 34px;">--><!--                            <div class="col-md-8 col-sm-8 col-md-8 text-center pad-0">--><!--                                <input type="number" class="no-appearance" placeholder="\u4E0A"--><!--                                       max=""--><!--                                       min="0"--><!--                                       name="bloodTop"--><!--                                       ng-model-options="{debounce:500}"--><!--                                       ng-model="vm.page.pageBloodT">--><!--                            </div>--><!--                            <div class="col-md-4 col-sm-4 col-lg-4 text-center pad-0 color-A6">--><!--                                <div class="input-line"></div>\u4E0A--><!--                            </div>--><!--                        </div>--><!--                        <div class="col-md-1 col-sm-1 col-md-1" style="line-height: 34px;">x</div>--><!--                        <div class="col-md-2 col-sm-2 col-md-2 text-center pad-0 rightPanel-input" style="line-height: 34px;">--><!--                            <div class="col-md-8 col-sm-8 col-md-8 text-center pad-0">--><!--                                <input type="number" class="no-appearance" placeholder="\u4E0B"--><!--                                       max=""--><!--                                       min="0"--><!--                                       name="bloodBottom"--><!--                                       ng-model-options="{debounce:500}"--><!--                                       ng-model="vm.page.pageBloodB">--><!--                            </div>--><!--                            <div class="col-md-4 col-sm-4 col-lg-4 text-center pad-0 color-A6">--><!--                                <div class="input-line"></div>\u4E0B--><!--                            </div>--><!--                        </div>--><!--                        <div class="col-md-1 col-sm-1 col-md-1" style="line-height: 34px;">x</div>--><!--                        <div class="col-md-2 col-sm-2 col-md-2 text-center pad-0 rightPanel-input" style="line-height: 34px;">--><!--                            <div class="col-md-8 col-sm-8 col-md-8 text-center pad-0">--><!--                                <input type="number" class="no-appearance" placeholder="\u5DE6"--><!--                                       max=""--><!--                                       min="0"--><!--                                       name="bloodLeft"--><!--                                       ng-model-options="{debounce:500}"--><!--                                       ng-model="vm.page.pageBloodL">--><!--                            </div>--><!--                            <div class="col-md-4 col-sm-4 col-lg-4 text-center pad-0 color-A6">--><!--                                <div class="input-line"></div>\u5DE6--><!--                            </div>--><!--                        </div>--><!--                        <div class="col-md-1 col-sm-1 col-md-1" style="line-height: 34px;">x</div>--><!--                        <div class="col-md-2 col-sm-2 col-md-2 text-center pad-0 rightPanel-input" style="line-height: 34px;">--><!--                            <div class="col-md-8 col-sm-8 col-md-8 text-center pad-0">--><!--                                <input type="number" class="no-appearance" placeholder="\u53F3"--><!--                                       max=""--><!--                                       min="0"--><!--                                       name="bloodRight"--><!--                                       ng-model-options="{debounce:500}"--><!--                                       ng-model="vm.page.pageBloodR">--><!--                            </div>--><!--                            <div class="col-md-4 col-sm-4 col-lg-4 text-center pad-0 color-A6">--><!--                                <div class="input-line"></div>\u53F3--><!--                            </div>--><!--                        </div>--><!--                        <div class="col-md-1 col-sm-1 col-lg-1 text-center pad-0" style="line-height: 34px;">--><!--                            <select ng-options="dpi as dpi.data for dpi in vm.dpiChoose"--><!--                                    ng-model-options="{debounce:500}" class="form-control fontSel rightPanel-input mar-left-15"--><!--                                    ng-change="updateDpi(vm.page.dpi1)"--><!--                                    ng-model="vm.page.dpi1">--><!--                            </select>--><!--                        </div>--><!--                    </div>--><!--                </div>--><!--            </div>--><!--            <div class="col-lg-10 col-sm-10 form-group" ng-show="isPageSize==0">--><!--                <div class="form-group" ng-repeat="editbox in vm.page.editboxs track by $index">--><!--                    <div class="col-md-12 col-sm-12 col-xs-12 pad-0">--><!--                        <div class="col-md-2 col-sm-2 col-md-2 text-center pad-0 rightPanel-input" style="line-height: 34px;">--><!--                            <div class="col-md-8 col-sm-8 col-md-8 text-center pad-0">--><!--                                <input type="number" class="no-appearance" placeholder="\u5BBD\u5EA6"--><!--                                       max=""--><!--                                       min="0"--><!--                                       ng-model-options="{debounce:500}"--><!--                                       ng-model="editbox.width">--><!--                            </div>--><!--                            <div class="col-md-4 col-sm-4 col-lg-4 text-center pad-0 color-A6">--><!--                                <div class="input-line"></div>\u5BBD--><!--                            </div>--><!--                        </div>--><!--                        <div class="col-md-1 col-sm-1 col-md-1" style="line-height: 34px;">x</div>--><!--                        <div class="col-md-2 col-sm-2 col-md-2 text-center pad-0 rightPanel-input" style="line-height: 34px;">--><!--                            <div class="col-md-8 col-sm-8 col-md-8 text-center pad-0">--><!--                                <input type="number" class="no-appearance" placeholder="\u9AD8\u5EA6"--><!--                                       max=""--><!--                                       min="0"--><!--                                       ng-model-options="{debounce:500}"--><!--                                       ng-model="editbox.height">--><!--                            </div>--><!--                            <div class="col-md-4 col-sm-4 col-lg-4 text-center pad-0 color-A6">--><!--                                <div class="input-line"></div>\u9AD8--><!--                            </div>--><!--                        </div>--><!--                        <div class="col-md-1 col-sm-1 col-md-1" style="line-height: 34px;">x</div>--><!--                        <div class="col-md-2 col-sm-2 col-md-2 text-center pad-0 rightPanel-input" style="line-height: 34px;">--><!--                            <div class="col-md-8 col-sm-8 col-md-8 text-center pad-0">--><!--                                <input type="number" class="no-appearance" placeholder="x"--><!--                                       max=""--><!--                                       min="0"--><!--                                       ng-model-options="{debounce:500}"--><!--                                       ng-model="editbox.x">--><!--                            </div>--><!--                            <div class="col-md-4 col-sm-4 col-lg-4 text-center pad-0 color-A6">--><!--                                <div class="input-line"></div>x--><!--                            </div>--><!--                        </div>--><!--                        <div class="col-md-1 col-sm-1 col-md-1" style="line-height: 34px;">x</div>--><!--                        <div class="col-md-2 col-sm-2 col-md-2 text-center pad-0 rightPanel-input" style="line-height: 34px;">--><!--                            <div class="col-md-8 col-sm-8 col-md-8 text-center pad-0">--><!--                                <input type="number" class="no-appearance" placeholder="y"--><!--                                       max=""--><!--                                       min="0"--><!--                                       ng-model-options="{debounce:500}"--><!--                                       ng-model="editbox.y">--><!--                            </div>--><!--                            <div class="col-md-4 col-sm-4 col-lg-4 text-center pad-0 color-A6">--><!--                                <div class="input-line"></div>y--><!--                            </div>--><!--                        </div>--><!--                        <div class="col-md-1 col-sm-1 col-lg-1 text-center pad-0" style="line-height: 34px;">--><!--                            <select ng-options="dpi as dpi.data for dpi in vm.dpiChoose"--><!--                                    ng-model-options="{debounce:500}" class="form-control fontSel rightPanel-input mar-left-15"--><!--                                    ng-change="updateDpi(vm.page.dpi1)"--><!--                                    ng-model="vm.page.dpi1">--><!--                            </select>--><!--                        </div>--><!--                        <button type="button" class="btn btn-cancel pageEditAdd" ng-click="addPageEdit()" ng-if="$index == 0" style="right: -65px;">\u6DFB\u52A0</button>--><!--                        <button type="button" class="btn btn-cancel pageEditAdd" ng-click="removePageEdit($index)" ng-if="$index > 0" style="right: -65px;">\u5220\u9664</button>--><!--                    </div>--><!--                </div>--><!--            </div>--></div></div><div class="c-model-foot"><button type="button" class="btn btn-cancel" data-dismiss="modal" ng-click="vm.clear()">\u53D6\u6D88</button> <button type="button" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-info" ng-click="vm.save()">\u786E\u5B9A</button></div></div><style>.modal-content{\n        width: 720px !important;\n    }\n    .c-form{width: 90%;}\n    .c-form .c-form-label{\n        width: 70px;\n        padding: 0;\n        height: 40px;\n        line-height: 40px;\n    }\n    .c-form .c-form-div{\n        position: relative;\n        margin-left: 70px;\n        width: auto;\n        min-height: 40px;\n    }</style>');
$templateCache.put('app/entities/page/page-scene.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" class="listBGC listCreate pad-0"><div class="container-fluid"><div class="row moduleNameBGC"><button type="button" class="pad-5 close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><div class="modal-detail"><span style="color: #232323">\u4E0A\u4F20\u573A\u666F\u9884\u89C8\u56FE</span></div></div></div><div class="modal-body"><div class="panel-body form-horizontal" style="padding-bottom: 0"><div class="col-lg-12 col-sm-12 col-xs-12 mar-bottom-20"><div class="form-group"><span class="col-md-2 col-sm-2 col-xs-2 control-label text-right pad-right-0">\u5BBD\uFF1A</span><div class="col-md-6 col-sm-6 col-xs-6"><input type="number" class="form-control" placeholder="\u5BBD" max="" name="width" ng-model-options="{debounce:500}" ng-model="scene.widthM" ng-show="dpi.id==0"> <input type="number" class="form-control" placeholder="\u5BBD" max="" name="width" ng-model-options="{debounce:500}" ng-model="scene.widthPx" ng-show="dpi.id==1"></div><div class="col-md-2 col-sm-2 col-lg-2 text-left"><select ng-options="dpi as dpi.data for dpi in vm.dpiChoose" ng-model-options="{debounce:500}" class="form-control fontSel" ng-change="updateDpi(dpi)" ng-model="dpi"></select></div></div></div><div class="col-lg-12 col-sm-12 col-xs-12 mar-bottom-20"><div class="form-group"><span class="col-md-2 col-sm-2 col-xs-2 control-label text-right pad-right-0">\u9AD8\uFF1A</span><div class="col-md-6 col-sm-6 col-xs-6"><input type="number" class="form-control" placeholder="\u9AD8" max="" name="height" ng-model-options="{debounce:500}" ng-model="scene.heightM" ng-show="dpi.id==0"> <input type="number" class="form-control" placeholder="\u9AD8" max="" name="height" ng-model-options="{debounce:500}" ng-model="scene.heightPx" ng-show="dpi.id==1"></div><div class="col-md-2 col-sm-2 col-lg-2 text-left"><select ng-options="dpi as dpi.data for dpi in vm.dpiChoose" ng-model-options="{debounce:500}" class="form-control fontSel" ng-change="updateDpi(dpi)" ng-model="dpi"></select></div></div></div><div class="col-lg-12 col-sm-12 col-xs-12 mar-bottom-20"><div class="form-group"><span class="col-md-2 col-sm-2 col-xs-2 control-label text-right pad-right-0">\u9009\u62E9\u9884\u89C8\u56FE\uFF1A</span><div class="col-md-10 col-sm-10 col-xs-10"><input ng-if="!scene.background.resource.identifier" type="file" name="file" class="form-control border-radius input-upload" accept=" image/jpeg, image/png" onchange="updateImgFile(event)" ng-model-options="{debounce : 500}"><div class="pic-upload" ng-if="!scene.background.resource.identifier"><img src="content/images/icons/upload_img.svg"></div><div ng-if="scene.background.resource.identifier" style="width: 104px;text-align: center"><img class="picture-border" ng-src="{{scene.background.resource.identifier}}" style="width: 100%"> <i class="glyphicon glyphicon-remove" ng-click="removeFile(scene.background.resource.identifier)" style="color: red"></i></div></div></div></div></div></div><div class="modal-footer align-center pad-0"><div class="col-lg-12 col-sm-12 col-xs-12 pad-0" style=""><button type="button" class="col-md-6 col-sm-6 col-xs-6" data-dismiss="modal" style="color: #2c2c2c;font-size: 15px;height: 60px;border-right:1px solid #E8E8E8" ng-click="vm.clear()"><span translate="entity.action.back">back</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" style="background: #ffc872;color:#232323;font-size: 15px;height: 60px" class="col-md-6 col-sm-6 col-xs-6"><span translate="entity.action.sure">sure</span></button></div></div></form>');
$templateCache.put('app/entities/page/page-simple.html','<div class="c-model"><div class="c-model-head"><div class="c-model-head-title">\u4E0A\u4F20\u6837\u4F8B\u56FE</div><i class="iconfont icon-closeicon1" ng-click="vm.clear()"></i></div><div class="c-model-body"><div class="c-model-body-view scrollbar-main" style="display: flex; flex-wrap: wrap"><div class="c-simple-view" ng-repeat="pic in vm.documentpics.documentpic" ng-if="!pic.deleted && !pic.cancelled"><i class="iconfont icon-closeicon1 closeicon1" ng-click="deletePic($index)"></i> <img ng-src="{{pic.resource.identifier +\'?imageView2\'}}"></div><div class="c-simple-view1"><i class="iconfont icon-shangchuan"></i><div>\u6587\u4EF6\u4E0A\u4F20</div><input onchange="uploadPic(event)" id="uploadImg2" type="file" multiple="multiple" accept="image/*" name="file" value="" style="opacity: 0; position: absolute; top: 0; left: 0"></div></div></div><div class="c-model-foot" style="display: flex; justify-content: space-between"><div class="align-items-center" style="cursor: pointer" ng-click="generCover()"><i class="iconfont icon-zhongxuan"></i> <span style="color: #264DF0; margin-left:1px;height: 21px">\u4E00\u952E\u5237\u65B0</span></div><div><button type="button" class="btn btn-cancel" ng-click="vm.clear()">\u53D6\u6D88</button> <button type="button" class="btn btn-info" ng-click="vm.save()">\u786E\u5B9A</button></div></div></div><style>.closeicon1{\n        width: 28px;\n        height: 28px;\n        position: absolute;\n        top: 0px;\n        right: 0px;\n        background-color: rgba(0, 0, 0, 0.64);\n        border-radius: 0 0 0 28px;\n        font-size: 14px;\n        color: #fff;\n        line-height: 22px;\n        text-align: center;\n        padding-left: 5px;\n    }\n    .modal-content{\n        width: 656px !important;\n    }\n    .c-simple-view{\n        position: relative;\n        width: 96px;\n        height: 96px;\n        background: #F5F7FA;\n        border-radius: 1px;\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        margin: 4px;\n    }\n    .c-simple-view img{\n        max-width: 100%;\n        max-height: 100%;\n    }\n    .c-simple-view1{\n        position: relative;\n        width: 96px;\n        height: 96px;\n        background: #fff;\n        border-radius: 1px;\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        flex-direction: column;\n        margin: 4px;\n        border: 1px solid #E1E5EB;\n    }</style>');
$templateCache.put('app/entities/page/page.html','<div class="c-page-1"><div class="c-page-1-1" style="margin-right: 48px" ng-click="gotoCreate(\'\', true,\'BOOK\')"><div class="c-page-1-1-view"><img src="content/images/home-icon1.png" alt="" class="c-page-1-1-img"><div class="c-page-1-1-1"><div class="c-page-1-1-1-title">\u6807\u51C6\u6A21\u677F</div><div class="c-page-1-1-1-text">\u652F\u6301\u4E09\u5927\u4EA7\u54C1\u7C7B\u578B</div></div></div><div class="c-page-1-1-2"><span>\u53BB\u8BBE\u8BA1</span> <i class="iconfont icon-right"></i></div></div><div class="c-page-1-1" ng-click="gotoCreate(\'\', true,\'THING\')"><div class="c-page-1-1-view"><img src="content/images/home-icon2.png" alt="" class="c-page-1-1-img"><div class="c-page-1-1-1"><div class="c-page-1-1-1-title">\u4E07\u7269\u6A21\u677F</div><div class="c-page-1-1-1-text">\u7ED1\u5B9A\u6A21\u578B \u4E07\u7269\u7686\u53EF\u521B\u4F5C</div></div></div><div class="c-page-1-1-2"><span>\u53BB\u8BBE\u8BA1</span> <i class="iconfont icon-right"></i></div></div></div><div class="c-page-2" ng-if="vm.kingKong && vm.kingKong.length>0"><div class="c-page-2-li {{\'c-page-2-\' + ($index + 1)}}" ng-repeat="item in vm.kingKong track by $index" ui-sref="recommendTemplate({catalogId:item.id})"><div class="c-page-2-li-name">{{item.name}}</div><div class="c-page-2-li-btn">\u4E86\u89E3\u66F4\u591A <i class="iconfont icon-right"></i></div></div></div><div class="c-page-title"><span class="c-page-title-name">\u63A8\u8350\u6A21\u677F</span><div class="c-page-title-icon" ui-sref="recommendTemplate({catalogId:vm.catalogView.id})">\u67E5\u770B\u66F4\u591A <i class="iconfont icon-right"></i></div></div><div class="c-page-3"><div class="c-page-3-li" ng-class="{\'c-page-3-li-selected\' : !vm.catalogView}" ng-click="catalogCb(\'all\')">\u63A8\u8350</div><div class="c-page-3-li" ng-repeat="item in vm.catalogs track by $index" ng-class="{\'c-page-3-li-selected\' : item.id == vm.catalogView.id}" ng-click="catalogCb(item)">{{item.name}}</div></div><div class="c-page-4 c-page-4-swiper swiper-container" style="height: 300px"><div class="swiper-wrapper" ng-if="vm.userDefined && vm.userDefined.length>0"><div class="swiper-slide" ng-repeat="item in vm.userDefined track by $index"><div class="c-page-4-view"><div class="c-page-4-img"><img alt="\u56FE\u7247\u7F3A\u5931" err-src="content/images/default-cover.png" ng-src="{{vm.domainQ + item.cover +\'?imageView2\'}}"><div class="c-page-4-img-view"><div class="c-page-4-img-view-btn" ng-click="gotoCreate(item)">\u53BB\u8BBE\u8BA1</div></div></div><div class="c-page-4-name slh" uib-tooltip="{{item.name}}{{productType(item.type)}}">{{item.name}}{{productType(item.type)}}</div><div class="c-page-4-size" ng-show="item.version > 1">{{item.parts[0].pageSizeW}}*{{item.parts[0].pageSizeH}}mm</div></div></div></div><div class="c-notData" ng-if="!vm.userDefined || vm.userDefined.length == 0">\u6682\u65E0\u6570\u636E...</div><div class="swiper-button-next swiper-button-black c-page-4-swiper-next"></div><div class="swiper-button-prev swiper-button-black c-page-4-swiper-prev"></div></div><div class="c-page-title"><span class="c-page-title-name">\u70ED\u95E8\u6A21\u677F</span><div class="c-page-title-icon" ui-sref="xml-center()">\u67E5\u770B\u66F4\u591A <i class="iconfont icon-right"></i></div></div><div class="c-page-4 c-page-5-swiper swiper-container"><div class="swiper-wrapper" ng-if="vm.hotxmls && vm.hotxmls.length>0"><div class="swiper-slide" ng-repeat="item in vm.hotxmls track by $index"><div class="c-page-4-view"><div class="c-page-4-img"><img alt="\u56FE\u7247\u7F3A\u5931" err-src="content/images/default-cover.png" ng-src="{{vm.domainQ + item.cover +\'?imageView2\'}}"><div class="c-page-4-img-view"><div class="c-page-4-img-view-btn" ng-click="operateLi(item)">\u53BB\u8BBE\u8BA1</div></div></div><div class="c-page-4-name slh" uib-tooltip="{{item.name}}{{productType(item.type)}}">{{item.name}}{{productType(item.type)}}</div><div class="c-page-4-size" ng-show="item.version > 1">{{item.parts[0].pageSizeW}}*{{item.parts[0].pageSizeH}}mm</div></div></div></div><div class="c-notData" ng-if="!vm.hotxmls || vm.hotxmls.length == 0">\u6682\u65E0\u6570\u636E...</div><div class="swiper-button-next swiper-button-black c-page-5-swiper-next"></div><div class="swiper-button-prev swiper-button-black c-page-5-swiper-prev"></div></div><div class="c-page-title"><span class="c-page-title-name">\u6700\u8FD1\u8BBE\u8BA1</span><div class="c-page-title-icon" ui-sref="selfTemplateList()">\u67E5\u770B\u66F4\u591A <i class="iconfont icon-right"></i></div></div><div class="c-page-4 c-page-6-swiper swiper-container"><div class="swiper-wrapper" ng-if="vm.latexmls && vm.latexmls.length>0"><div class="swiper-slide" ng-repeat="item in vm.latexmls track by $index"><div class="c-page-4-view"><div class="c-page-4-img"><img alt="\u56FE\u7247\u7F3A\u5931" err-src="content/images/default-cover.png" ng-src="{{vm.domainQ + item.cover +\'?imageView2\'}}"><div class="c-page-4-img-view"><div class="c-page-4-img-view-btn" ng-click="operateLi(item)">\u53BB\u8BBE\u8BA1</div></div></div><div class="c-page-4-name slh" uib-tooltip="{{item.name}}{{productType(item.type)}}">{{item.name}}{{productType(item.type)}}</div><div class="c-page-4-size" ng-show="item.version > 1">{{item.parts[0].pageSizeW}}*{{item.parts[0].pageSizeH}}mm</div></div></div></div><div class="c-notData" ng-if="!vm.latexmls || vm.latexmls.length == 0">\u6682\u65E0\u6570\u636E...</div><div class="swiper-button-next swiper-button-black c-page-6-swiper-next"></div><div class="swiper-button-prev swiper-button-black c-page-6-swiper-prev"></div></div>');
$templateCache.put('app/entities/page/pagesmySuffix-save.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" class="listBGC listCreate pad-0"><!-- <button type="button" class="pad-5 close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button> --><div class="modal-detail"><h4 class="modal-title" translate="platformApp.page.save">save</h4></div><div class="modal-body"><div class="panel-body form-horizontal"><div class="col-lg-10 col-sm-10 form-group"><div class="form-group"><label class="col-md-3 col-sm-3 col-xs-3 control-label" translate="platformApp.page.category" for="field_category">Category</label><div class="col-md-9 col-sm-9 col-xs-9"><select class="form-control" id="field_category" name="field_category" ng-model="vm.page.category" ng-options="category.id as category.name for category in vm.categories | orderBy:\'id\'"><option value="{{category.name}}"></option></select></div></div></div><div class="col-lg-10 col-sm-10 form-group"><div class="form-group"><label class="col-md-3 col-sm-3 col-xs-3 control-label" translate="platformApp.page.reprint" for="field_reprint">Spread</label><div class="col-md-9 col-sm-9 col-xs-9"><select class="form-control" name="field_reprint" id="field_reprint" ng-model="vm.page.reprint"><!-- <option value="Standard" data-translate="backApp.ProductType.Standard">Standard</option> --><option value="LAR" data-translate="platformApp.page.horizontal">Horizontal</option><option value="UAD" data-translate="platformApp.page.vertical">Vertical</option><option value="OTHER" data-translate="platformApp.page.other">Other</option></select></div></div></div><div class="col-lg-10 col-sm-10 form-group"><div class="form-group"><label class="col-md-3 col-sm-3 col-xs-3 control-label" translate="platformApp.page.themeClassify" for="field_name">themeClassify</label><div class="col-md-9 col-sm-9 col-xs-9"><select class="form-control" name="field_name" ng-model="vm.themeClassify" ng-options="themeClassify.id as themeClassify.name for themeClassify in vm.themeClassifyList"></select></div></div></div><div class="col-lg-10 col-sm-10 form-group"><div class="form-group"><label class="col-md-3 col-sm-3 col-xs-3 control-label" translate="platformApp.page.workName" for="field_workName">workName</label><div class="col-md-9 col-sm-9 col-xs-9"><input type="text" class="form-control" name="field_name" id="field_workName" ng-model="vm.page.name" placeholder="\u8BF7\u8F93\u5165\u540D\u79F0" maxlength="20"></div></div></div><div class="col-lg-10 col-sm-10 form-group"><div class="form-group"><label class="col-md-3 col-sm-3 col-xs-3 control-label" translate="platformApp.page.type" for="type">type</label><div class="col-md-9 col-sm-9 col-xs-9"><select class="form-control" name="type" id="type" ng-model="vm.page.type"><option value="Custom" data-translate="platformApp.page.customType.Custom">Custom</option><option value="Currency" data-translate="platformApp.page.customType.Currency">Currency</option></select></div></div></div><div class="col-lg-10 col-sm-10 form-group" ng-if="vm.page.type == \'Custom\' "><div class="form-group"><label class="col-md-3 col-sm-3 col-xs-3 control-label" translate="platformApp.page.customStore" for="customStore">customStore</label><div class="col-md-9 col-sm-9 col-xs-9"><select class="form-control" name="field_name" ng-model="vm.customStore" ng-change="customStoreChange()" ng-options="store.id as store.name for store in vm.stores"></select></div></div></div></div></div><div class="modal-footer"><button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary btn-save btn-info"><span translate="entity.action.confirm">Confirm</span></button></div></form>');
$templateCache.put('app/entities/page/pagesmySuffix.html','<div data-html2canvas class="page-item2" id="pageThumbnail"><page-preview page="lastPage" scale="lastPage.ratio" thumbnail="true" ng-if="lastPage"></page-preview></div><div class="c-editor picture-xml-edit" data-html2canvas-ignore><canvas id="mask-canvas" class="hide1"></canvas><div class="c-editor-head"><div class="c-editor-head-fl"><div class="page-head-file" ng-mouseenter="vm.isPageFile = false"><div class="page-file-text" ng-click="vm.isPageFile = true"><i class="iconfont icon-wenziliangduanduiqi"></i></div><div class="page-file-size" ng-if="true"><!-- vm.isPageFile --><div class="page-file-size-title"><div class="page-file-size-title-view slh" ng-click="pageNameCb1()" ng-show="!vm.isPageName1" uib-tooltip="\u70B9\u51FB\u4FEE\u6539\u6807\u9898" tooltip-placement="bottom" tooltip-append-to-body="false">{{vm.page.name}}</div><textarea class="page-file-size-title-textarea" id="c-editor-head-name1" ng-model="vm.page.name" ng-show="vm.isPageName1" ng-blur="vm.isPageName1 = false"></textarea></div><!--                    <div class="c-editor-head-name-view" style="width: 100%; margin-right: 0; margin-bottom: 10px;">--><!--                        <div class="c-editor-head-name1 slh2"--><!--                             style="font-size: 18px; font-weight: bold; color: #222529; line-height: 25px;"--><!--                             uib-tooltip="\u70B9\u51FB\u4FEE\u6539\u6807\u9898" tooltip-placement="bottom" ng-click="pageNameCb1()" ng-show="!vm.isPageName1">{{vm.page.name}}</div>--><!--                        <input type="text" ng-model="vm.page.name" class="c-editor-head-name" id="c-editor-head-name1" ng-show="vm.isPageName1" ng-blur="vm.isPageName1 = false">--><!--                    </div>--><div class="page-file-size-title1"><span>\u6A21\u677F\u7C7B\u578B</span> <span class="page-file-size-title1-type">{{productType(template.config.productType)}}</span></div><div class="page-file-size-hr"></div><div class="page-file-size-1"><div class="page-file-size-title1"><span>\u5F53\u524D\u90E8\u4EF6</span> <span class="page-file-size-title1-type1" uib-tooltip="{{template.config.parts.list[getPartIndex()].name}}" tooltip-placement="bottom" tooltip-append-to-body="false">{{template.config.parts.list[getPartIndex()].name}}</span></div><div class="page-file-size-1-btn" ng-click="editorPart()"><i class="iconfont icon-bianji"></i> <span>\u7F16\u8F91</span></div></div><div class="page-file-size-2" style="margin-bottom: 8px">\u90E8\u4EF6\u5C3A\u5BF8\uFF1A{{template.config.parts.list[getPartIndex()].mediabox.width}}*{{template.config.parts.list[getPartIndex()].mediabox.height}}{{vm.unit}}</div><div class="page-file-size-2">\u51FA\u8840\u5C3A\u5BF8\uFF1A{{template.config.parts.list[getPartIndex()].bleed.top }}*{{template.config.parts.list[getPartIndex()].bleed.bottom }}*{{template.config.parts.list[getPartIndex()].bleed.left }}*{{template.config.parts.list[getPartIndex()].bleed.right}}mm</div><div class="page-file-size-hr"></div><div class="page-file-size-1"><div class="page-file-size-title1"><span>\u5F53\u524D\u9875\u53EF\u7F16\u8F91\u533A\u57DF</span></div><div class="page-file-size-1-btn" ng-click="editSize(\'editbox\')"><i class="iconfont icon-bianji"></i> <span>\u7F16\u8F91</span></div></div><div class="page-file-size-2" style="display: flex"><span>\u5C3A\u5BF8\uFF1A</span><div><div ng-repeat="editbox in currentPage.editboxes.editbox">{{PxTurnMm(editbox.x) }},{{PxTurnMm(editbox.y) }}&nbsp;&nbsp; {{PxTurnMm(editbox.width) }}x{{PxTurnMm(editbox.height) }}mm</div></div></div><div class="page-file-size-hr"></div><div class="page-file-size-3" ng-click="vm.staff = !vm.staff"><span>\u663E\u793A\u6807\u5C3A\u548C\u53C2\u8003\u7EBF</span> <i class="iconfont icon-gou" ng-if="vm.staff"></i></div><div class="page-file-size-3" ng-click="addLineReference()"><span>\u65B0\u5EFA\u53C2\u8003\u7EBF</span></div><div class="page-file-size-hr"></div><div class="page-file-size-3" ng-click="clearAllImageboxImg()"><span>\u4E00\u952E\u6E05\u9664\u76F8\u6846</span></div></div></div><div class="c-editor-head-name-view"><div class="c-editor-head-name1 slh" uib-tooltip="\u70B9\u51FB\u4FEE\u6539\u6807\u9898" tooltip-placement="bottom" ng-click="pageNameCb()" ng-show="!vm.isPageName">{{vm.page.name}}</div><input type="text" ng-model="vm.page.name" class="c-editor-head-name" id="c-editor-head-name" ng-show="vm.isPageName" ng-blur="vm.isPageName = false"></div><i class="iconfont icon-chehui" uib-tooltip="\u4E0A\u4E00\u6B65" tooltip-placement="bottom" ng-click="rollback(0)" ng-style="{\'cursor\': pageHistory.length > 0 ? \'\' : \'not-allowed\',\'opacity\': pageHistory.length > 1 ? \'\' : \'0.6\'}"></i> <i class="iconfont icon-fanhuibanben" uib-tooltip="\u6062\u590D" tooltip-placement="bottom" ng-click="rollback(1)" ng-style="{\'cursor\': pageHistory.length > 0 ? \'\' : \'not-allowed\',\'opacity\': pageHistory.length > 1 ? \'\' : \'0.6\'}"></i> <i class="iconfont icon-quanping" uib-tooltip="\u5168\u5C4F" tooltip-placement="bottom" ng-if="!vm.isFullScreen" ng-click="fullScreen()"></i> <i class="iconfont icon-xingzhuang3" uib-tooltip="\u9000\u51FA\u5168\u5C4F" tooltip-placement="bottom" ng-if="vm.isFullScreen" ng-click="exitScreen()"></i></div><div class="c-editor-head-fr"><button class="c-editor-head-btn4" ng-click="savePage(3)" ng-disabled="vm.isSaving" ng-style="{opacity:vm.isSaving?0.7:1}" ng-if="!vm.thirdparty" uib-tooltip="{{vm.saveDate}}" tooltip-placement="bottom"><i class="iconfont icon-baocun"></i> <span>\u4FDD\u5B58</span></button> <button class="c-editor-head-btn4" ng-click="watchArticle()" ng-style="{opacity:vm.isSaving?0.7:1}"><i class="iconfont icon-yulan"></i> <span>\u9884\u89C8</span></button> <button class="c-editor-head-btn4" ng-click="savePage(1)" ng-disabled="vm.isSaving" ng-style="{opacity:vm.isSaving?0.7:1}" ng-if="vm.thirdparty"><i class="iconfont icon-baocun"></i> <span>\u4FDD\u5B58</span></button><!--            <button class="save-xml pull-left" ng-click="savePage(1)" ng-disabled="vm.isSaving" ng-style="{opacity:vm.isSaving?0.7:1}">\u4FDD\u5B58\u4F5C\u54C1</button>--> <button class="c-editor-head-btn3" ng-click="savePage(2)" ng-disabled="vm.isSaving" ng-style="{opacity:vm.isSaving?0.7:1}" ng-show="!vm.thirdSave && !vm.thirdparty">\u53D1\u5E03\u4EA7\u54C1</button> <button class="c-editor-head-btn2" ng-click="savePage(0)" ng-disabled="vm.isSaving" ng-style="{opacity:vm.isSaving?0.7:1}" ng-show="!vm.thirdSave && !vm.thirdparty">\u53D1\u5E03\u6A21\u677F</button> <button class="c-editor-head-btn1" ng-click="exitSureCb()" ng-style="{opacity:vm.isSaving?0.7:1}">\u9000\u51FA</button></div></div><div class="c-editor-nav scrollbar-none"><div class="c-editor-nav-li" ng-repeat="item in vm.navList track by $index" ng-class="{\'c-editor-nav-navOn\':item.id == selPanel}" ng-click="selectPanel(item.id)" ng-if="!item.isShow || (vm.page.productType == \'CALENDAR\'&& template.config.dynamic && (item.id == \'widgetTitle\' || item.id == \'widgetMonth\'))"><i class="iconfont {{item.icon}}"></i> <span>{{item.name}}</span></div></div><div class="c-editor-nav-view scrollbar-none" ng-show="vm.leftShow"><div class="c-editor-nav-view-li" ng-show="selPanel==\'page\'"><div class="align-items-center"><div class="c-editor-nav-title">\u80CC\u666F\u989C\u8272</div><input type="text" ng-change="chooseColor()" ng-model="template.pages.page[template.pageI].background.color" style="margin-left: 16px; height: 30px; width: 96px; border: 1px solid #E1E5EB"></div><div class="c-editor-nav-view-li-1"><input class="c-editor-nav-view-li-1-choose-color" type="color" ng-value="template.pages.page[template.pageI].background.color" ng-change="chooseColor()" ng-model="template.pages.page[template.pageI].background.color"><div class="c-editor-nav-view-li-1-color c-editor-nav-view-li-1-color1"></div><div class="c-editor-nav-view-li-1-color" ng-repeat="color in vm.colorArr1" ng-if="$index<6" ng-click="chooseBgColor(color)" ng-style="{background:color,border:$first?\'1px solid #DADADA\':none}"></div></div><div class="c-editor-nav-title mt10">\u9884\u9009\u989C\u8272</div><div class="c-editor-nav-view-li-1"><div class="c-editor-nav-view-li-1-color custom-grid2" ng-click="chooseBgColor()"></div><div class="c-editor-nav-view-li-1-color" ng-repeat="color in vm.colorArr2" ng-click="chooseBgColor(color)" ng-style="{background:color,border:$index==4?\'1px solid #DADADA\':none}"></div></div><div class="c-editor-nav-view-li-btn1" ng-if="!vm.thirdparty"><i class="iconfont icon-shangchuan"></i> <span>\u6DFB\u52A0\u80CC\u666F\u56FE\u7247</span> <input name="token" type="hidden" value="{{vm.token}}"> <input type="file" name="file" class="c-editor-nav-view-li-btn1-input" multiple="multiple" accept="image/png, image/jpeg, image/jpg" onchange="updateBackground(event)" ng-model-options="{debounce:100}"></div><div class="c-editor-nav-view-li-hr"></div><div class="c-editor-nav-view-li-2" ng-if="!vm.thirdparty"><div ng-class="{\'c-editor-nav-view-li-2-active\':vm.bgimgs2Tab==\'all\'}" ng-click="switchBgTab(\'all\')"><span>\u6211\u7684\u80CC\u666F</span><div class="div-hr"></div></div><div ng-class="{\'c-editor-nav-view-li-2-active\':vm.bgimgs2Tab!=\'all\'}" ng-click="switchBgTab()"><span>\u63A8\u8350\u80CC\u666F</span><div class="div-hr"></div></div></div><div class="c-editor-nav-classify" ng-if="!vm.thirdparty && vm.bgimgs2Tab==\'all\'"><div class="c-editor-nav-classify-view"><div ng-repeat="label in vm.backgroundLabels track by $index" ng-click="backgroundData(label.id)" data-index="{{$index}}" class="c-editor-nav-classify-view-btn" ng-show="$index<9||vm.showBackgroundsLabel" ng-class="{\'c-editor-nav-classify-view-btn-active\':label.id==vm.backgroundLabel}">{{label.name}}</div></div><div class="c-editor-nav-classify-view-cursorPointer" ng-if="vm.backgroundLabels.length >9"><div class="c-editor-nav-classify-view-cursorPointer-btn" ng-if="!vm.showBackgroundsLabel" ng-click="vm.showBackgroundsLabel = !vm.showBackgroundsLabel"><span>\u5C55\u5F00</span> <i class="iconfont icon-down"></i></div><div class="c-editor-nav-classify-view-cursorPointer-btn" ng-if="vm.showBackgroundsLabel" ng-click="vm.showBackgroundsLabel = !vm.showBackgroundsLabel"><span>\u6536\u8D77</span> <i class="iconfont icon-up"></i></div></div></div><div class="c-editor-nav-view-li-3 mt20"><div class="c-editor-nav-view-li-3-li" ng-repeat="bg in vm.showBackgrounds.bgimg track by $index" data-index="{{$index}}"><img class="c-editor-nav-view-li-3-li-img" ng-src="{{bg.identifier+vm.menuImageView}}" draggable="true" ondragstart="dragStart(event)" id="dragtarget{{$index}}" data-index="{{$index}}"><div class="c-editor-nav-view-li-3-li-recommend" ng-click="recommendBgImg2(\'\',bg)" uib-tooltip="{{bg.isRecommend?\'\u53D6\u6D88\u63A8\u8350\':\'\u63A8\u8350\'}}" tooltip-placement="bottom"><i class="iconfont icon-tuijian1" ng-style="{color:bg.isRecommend?\'#FFBA2B\' : \'#fff\'}"></i></div><div class="bg-del{{$index}} c-editor-nav-view-li-3-li-del" ng-show="vm.bgimgs2Tab==\'all\'" ng-click="deleteLeftPanelPic($index)"><i class="iconfont icon-shanchu3"></i></div></div><div class="c-editor-nav-view-li-3-li-more" ng-click="loadMoreBackgrounds()" ng-show="vm.bgimgs2Tab==\'all\' && !vm.thirdparty && vm.bgimgs2.bgimg.length != vm.totalBgItems">\u52A0\u8F7D\u66F4\u591A</div><div class="c-editor-data-completed" ng-if="vm.bgimgs2.bgimg.length == vm.totalBgItems">\u6CA1\u6709\u66F4\u591A\u5566</div></div></div><div class="c-editor-nav-view-li" ng-show="selPanel==\'mask\'"><div><div class="c-editor-nav-view-li-btn1" ng-if="!vm.thirdparty && vm.maskTab==\'my\'"><i class="iconfont icon-shangchuan"></i> <span>\u4E0A\u4F20\u6211\u7684\u76F8\u6846</span> <input name="token" type="hidden" value="{{vm.token}}"> <input type="file" name="file" class="c-editor-nav-view-li-btn1-input" multiple="multiple" accept="image/png" onchange="updateMask(event)" ng-model-options="{debounce:100}"></div><div class="c-editor-nav-view-li-hr" ng-if="!vm.thirdparty && vm.maskTab==\'my\'"></div><div class="c-editor-nav-view-li-2" ng-if="!vm.thirdparty"><div ng-class="{\'c-editor-nav-view-li-2-active\':vm.maskTab==\'all\'}" ng-click="switchMaskTab(\'all\')"><span>\u5E73\u53F0\u76F8\u6846</span><div class="div-hr"></div></div><div ng-class="{\'c-editor-nav-view-li-2-active\':vm.maskTab==\'recommend\'}" ng-click="switchMaskTab(\'recommend\')"><span>\u63A8\u8350\u76F8\u6846</span><div class="div-hr"></div></div><div ng-class="{\'c-editor-nav-view-li-2-active\':vm.maskTab==\'my\'}" ng-click="switchMaskTab(\'my\')"><span>\u6211\u7684\u76F8\u6846</span><div class="div-hr"></div></div></div><div class="c-editor-nav-title1" style="margin-top: 24px"><span>\u901A\u7528\u76F8\u6846</span> <i class="iconfont icon-wenhao" uib-tooltip="\u5E73\u53F0\u5185\u7F6E\u901A\u7528\u77E2\u91CF\u76F8\u6846\uFF0C\u5706\u5F62\u76F8\u6846\u4E0D\u652F\u6301\u8BBE\u7F6E\u5706\u89D2" tooltip-placement="bottom-right"></i></div><div class="c-rahmen-view"><div class="c-rahmen-view-li"><img ng-src="https://pic-modele-dev.momentsgocdn.com/material-d97dbc11-06b7-42c3-a6c0-83a9263a2677{{vm.menuImageView}}" alt="" draggable="true" ondragstart="dragStart(event)" id="dragtargetMaskRound" data-mask="https://pic-modele-dev.momentsgocdn.com/material-d97dbc11-06b7-42c3-a6c0-83a9263a2677"></div><div class="c-rahmen-view-li"><img ng-src="https://pic-modele-dev.momentsgocdn.com/material-9627c267-5653-4ad2-a539-1d5cbe13e820{{vm.menuImageView}}" alt="" draggable="true" ondragstart="dragStart(event)" id="dragtargetMaskRectangle" data-mask="https://pic-modele-dev.momentsgocdn.com/material-9627c267-5653-4ad2-a539-1d5cbe13e820"></div></div><div class="c-editor-nav-classify" ng-if="!vm.thirdparty"><div class="c-editor-nav-classify-view"><div ng-repeat="label in masklabels track by $index" ng-click="selectMaskLabel(label)" data-index="{{$index}}" class="c-editor-nav-classify-view-btn" ng-show="$index<9||showMaskLabels" ng-class="{\'c-editor-nav-classify-view-btn-active\':label.id==masklabelChooseId}">{{label.name}}</div></div><div class="c-editor-nav-classify-view-cursorPointer" ng-if="masklabels.length >9"><div class="c-editor-nav-classify-view-cursorPointer-btn" ng-if="!showMaskLabels" ng-click="showMoreMaskLabels()"><span>\u5C55\u5F00</span> <i class="iconfont icon-down"></i></div><div class="c-editor-nav-classify-view-cursorPointer-btn" ng-if="showMaskLabels" ng-click="showMoreMaskLabels()"><span>\u6536\u8D77</span> <i class="iconfont icon-up"></i></div></div></div></div><div class="c-editor-nav-view-li-3 mt20" ng-if="!vm.thirdparty"><div ng-repeat="mask in vm.showMasks.mask track by $index" data-index="{{$index}}" class="c-editor-nav-view-li-3-li"><img class="c-editor-nav-view-li-3-li-img" style="filter: brightness(85%)" ng-src="{{mask.resource.identifier+vm.menuImageView}}" draggable="true" ondragstart="dragStart(event)" id="dragtargetMask{{$index}}" data-mask="{{mask.resource.identifier}}" data-index="{{$index}}"><div class="c-editor-nav-view-li-3-li-recommend" ng-click="recommendMask(\'\',mask)" uib-tooltip="{{mask.isRecommend?\'\u53D6\u6D88\u63A8\u8350\':\'\u63A8\u8350\'}}" tooltip-placement="bottom"><i class="iconfont icon-tuijian1" ng-style="{color:mask.isRecommend?\'#FFBA2B\' : \'#fff\'}"></i></div><div class="bg-del{{$index}} c-editor-nav-view-li-3-li-del" ng-show="vm.maskTab!=\'recommend\'" ng-click="deleteLeftPanelPic($index)"><i class="iconfont icon-shanchu3"></i></div><!--                            <button class="bg-del{{$index}} leftPanel-del"--><!--                                    ng-hide="mask.type==\'SYSTEM\'||vm.maskTab!=\'all\'"--><!--                                    ng-click="deleteLeftPanelPic($index)">--><!--                                <div></div>--><!--                                <img src="content/images/icons/ic_delete.svg">--><!--                            </button>--><!--                            <button class="leftPanel-recommend" ng-if="vm.maskTab!=\'SYSTEM\'"--><!--                                    ng-click="recommendMask(\'\',mask)">--><!--                                <div></div>--><!--                                <img src="content/images/icons/ic_recom_fal.png" style="width: 17px;"--><!--                                     ng-if="!mask.isRecommend&&vm.maskTab==\'all\'">--><!--                                <img src="content/images/icons/ic_recommend.svg" ng-if="mask.isRecommend">--><!--                                <div class="tip4" style="top:30px;" ng-if="!mask.isRecommend&&vm.maskTab==\'all\'">\u8BBE\u4E3A\u63A8\u8350--><!--                                </div>--><!--                                <div class="tip4" style="top:30px;" ng-if="mask.isRecommend">\u53D6\u6D88\u63A8\u8350</div>--><!--                            </button>--></div><div class="c-editor-nav-view-li-3-li-more" ng-click="loadMoreMask()" ng-show="(vm.maskTab==\'all\' ||vm.maskTab==\'my\') && vm.showMasks.mask.length < vm.totalMaskItems">\u52A0\u8F7D\u66F4\u591A</div><div class="c-editor-data-completed" ng-if="vm.showMasks.mask.length == vm.totalMaskItems">\u6CA1\u6709\u66F4\u591A\u5566</div></div></div><div class="c-editor-nav-view-li" ng-show="selPanel==\'material\'"><div class="c-editor-nav-view-li-2" ng-if="!vm.thirdparty"><div ng-class="{\'c-editor-nav-view-li-2-active\':vm.materialTab==\'SYSTEM\'}" ng-click="chooseMaterialTab(\'SYSTEM\')"><span>\u5E73\u53F0\u7D20\u6750</span><div class="div-hr"></div></div><div ng-class="{\'c-editor-nav-view-li-2-active\':vm.materialTab==\'recommend\'}" ng-click="chooseMaterialTab(\'recommend\')"><span>\u63A8\u8350\u7D20\u6750</span><div class="div-hr"></div></div><div ng-class="{\'c-editor-nav-view-li-2-active\':vm.materialTab==\'USER\'}" ng-click="chooseMaterialTab(\'USER\')"><span>\u6211\u7684\u7D20\u6750</span><div class="div-hr"></div></div></div><div class="c-editor-nav-classify" ng-if="!vm.thirdparty"><div class="c-editor-nav-classify-view"><div ng-repeat="label in clipartlabels track by $index" ng-click="selectLabel(label,$index)" data-index="{{$index}}" class="c-editor-nav-classify-view-btn" ng-show="$index<9||showLabels" ng-class="{\'c-editor-nav-classify-view-btn-active\':label.id==artlabelChooseId}">{{label.name}}</div></div><div class="c-editor-nav-classify-view-cursorPointer" ng-if="clipartlabels.length >9"><div class="c-editor-nav-classify-view-cursorPointer-btn" ng-if="!showLabels" ng-click="showMoreLabels()"><span>\u5C55\u5F00</span> <i class="iconfont icon-down"></i></div><div class="c-editor-nav-classify-view-cursorPointer-btn" ng-if="showLabels" ng-click="showMoreLabels()"><span>\u6536\u8D77</span> <i class="iconfont icon-up"></i></div></div></div><div class="c-editor-nav-view-li-btn1 mt20" ng-if="vm.materialTab==\'USER\'"><i class="iconfont icon-shangchuan"></i> <span>\u6DFB\u52A0\u7D20\u6750</span> <input name="token" type="hidden" value="{{vm.token}}"> <input type="file" name="file" class="c-editor-nav-view-li-btn1-input" accept="image/png, image/jpeg, image/jpg" multiple="multiple" onchange="updateArts(event)" ng-model-options="{debounce:100}"></div><div class="c-editor-nav-view-li-3 mt20"><div ng-repeat="clipArt in vm.showCliparts.clipart track by $index" data-index="{{$index}}" class="c-editor-nav-view-li-3-li clipart{{$index}}"><img class="c-editor-nav-view-li-3-li-img" ng-src="{{clipArt.resource.identifier+vm.menuImageView||\'//:0\'}}" data-art="{{clipArt.resource.identifier}}" draggable="true" ondragstart="dragStart(event)" ng-click="addArt(clipArt.resource.identifier,$index)" id="dragtargetClipArt{{$index}}" data-index="{{$index}}"><div class="c-editor-nav-view-li-3-li-recommend" ng-if="vm.clipartTab!=\'SYSTEM\'" ng-click="recommendArt(\'clipArts.clipArt\',clipArt)" uib-tooltip="{{clipArt.isRecommend?\'\u53D6\u6D88\u63A8\u8350\':\'\u63A8\u8350\'}}" tooltip-placement="bottom"><i class="iconfont icon-tuijian1" ng-style="{color:clipArt.isRecommend?\'#FFBA2B\' : \'#fff\'}"></i></div><div class="bg-del{{$index}} c-editor-nav-view-li-3-li-del" ng-hide="clipArt.type==\'SYSTEM\'||vm.clipartTab!=\'all\'" ng-click="deleteLeftPanelPic($index)"><i class="iconfont icon-shanchu3"></i></div></div><div class="c-editor-nav-view-li-3-li-more" ng-click="loadMoreClipart()" ng-show="vm.materialTab!=\'recommend\' && vm.allCliparts.clipart.length < vm.totalClipartItems">\u52A0\u8F7D\u66F4\u591A</div><div class="c-editor-data-completed" ng-if="vm.allCliparts.clipart.length == vm.totalClipartItems">\u6CA1\u6709\u66F4\u591A\u5566</div></div></div><div class="c-editor-nav-view-li" ng-show="selPanel==\'text\'"><div class="c-editor-nav-textbox"><div class="text-size-24" ng-click="addText(24)">\u70B9\u51FB\u6DFB\u52A0\u6807\u9898\u6587\u5B57</div><div class="text-size-20" ng-click="addText(20)">\u70B9\u51FB\u6DFB\u52A0\u6807\u9898\u6587\u5B57</div><div class="text-size-16" ng-click="addText(16)">\u70B9\u51FB\u6DFB\u52A0\u6807\u9898\u6587\u5B57</div></div><div class="c-editor-nav-view-li-hr"></div><div class="c-editor-nav-view-li-3 mt20"><div ng-repeat="font in vm.fontDoc track by $index" data-index="{{$index}}" class="c-editor-nav-view-li-3-li clipart{{$index}}" ng-click="addTextDoc(font)"><img class="c-editor-nav-view-li-3-li-img" ng-src="{{font.cover+vm.menuImageView||\'//:0\'}}" data-art="{{font.cover}}"></div></div><div class="c-editor-data-completed">\u6CA1\u6709\u66F4\u591A\u5566</div></div><div class="c-editor-nav-view-li" ng-show="selPanel==\'img\'"><div class="c-editor-nav-classify" ng-if="!vm.thirdparty"><div class="c-editor-nav-classify-view"><div ng-repeat="label in vm.imgLabels track by $index" ng-click="setImgLabel(label.id)" data-index="{{$index}}" class="c-editor-nav-classify-view-btn" ng-show="$index<9||vm.showImgLabel" ng-class="{\'c-editor-nav-classify-view-btn-active\':label.id==vm.imgLabel}">{{label.name}}</div></div><div class="c-editor-nav-classify-view-cursorPointer" ng-if="vm.imgLabels.length >9"><div class="c-editor-nav-classify-view-cursorPointer-btn" ng-if="!vm.showImgLabel" ng-click="vm.showImgLabel = !vm.showImgLabel"><span>\u5C55\u5F00</span> <i class="iconfont icon-down"></i></div><div class="c-editor-nav-classify-view-cursorPointer-btn" ng-if="vm.showImgLabel" ng-click="vm.showImgLabel = !vm.showImgLabel"><span>\u6536\u8D77</span> <i class="iconfont icon-up"></i></div></div></div><div class="c-editor-nav-view-li-btn1 mt20"><i class="iconfont icon-shangchuan"></i> <span>\u6DFB\u52A0\u56FE\u7247</span> <input name="token" type="hidden" value="{{vm.token}}"> <input type="file" name="file" class="c-editor-nav-view-li-btn1-input" accept="image/png, image/jpeg, image/jpg" multiple="multiple" onchange="updatePic1(event)" ng-model-options="{debounce:100}"></div><div class="c-editor-nav-view-li-hr"></div><div class="c-editor-nav-view-li-3 mt20"><div ng-repeat="data in vm.userImgAll track by $index" data-index="{{$index}}" class="c-editor-nav-view-li-3-li"><img class="c-editor-nav-view-li-3-li-img" ng-src="{{data.identifier+vm.menuImageView}}" alt="" draggable="true" ondragstart="dragStart(event)" id="dragtargetPhoto{{$index}}" data-mask="{{data.identifier}}"><div class="c-editor-nav-view-li-3-li-del" ng-click="fillImgDelete(data, $index)"><i class="iconfont icon-shanchu3"></i></div></div><div class="c-editor-nav-view-li-3-li-more" ng-click="fillImgCb()" ng-if="vm.isUserImg">\u52A0\u8F7D\u66F4\u591A</div><div class="c-editor-data-completed" ng-if="!vm.isUserImg">\u6CA1\u6709\u66F4\u591A\u5566</div><!--                <span ng-if="!vm.isUserImg">\u6682\u65E0\u66F4\u591A...</span>--></div></div><div class="c-editor-nav-view-li" ng-show="selPanel==\'backup\'"><div class="c-editor-nav-classify"><div class="c-editor-nav-classify-view"><div ng-repeat="part in template.config.parts.list track by $index" ng-if="part.counter>0" ng-click="backupPartCb(part)" class="c-editor-nav-classify-view-btn" ng-class="{\'c-editor-nav-classify-view-btn-active\':part.id==vm.backupPartId}">{{part.name}}</div></div></div><div class="c-editor-nav-view-li-3 mt20" id="standbyPage"><div ng-repeat="page in template.backupPages.list track by $index" ng-show="page.config.partid == vm.backupPartId" data-page="{{page}}" class="clipart{{$index}} c-editor-nav-view-li-3-li standbyPageLi"><img class="c-editor-nav-view-li-3-li-img" ng-click="replaceBackupPage($event, page)" ng-src="{{page.pagecover.identifier+vm.menuImageView||\'//:0\'}}" data-index="{{$index}}"><!--                        <div class="loading-font" ng-if="!page.pagecover.identifier"></div>--><div class="bg-del{{$index}} c-editor-nav-view-li-3-li-del" ng-click="deleteBackup($index)"><i class="iconfont icon-shanchu3"></i></div><div class="c-editor-nav-view-li-3-li-recommend" ng-click="pageLook($index)"><i class="iconfont icon-fangdajing"></i></div></div><div class="c-editor-data-completed">\u6CA1\u6709\u66F4\u591A\u5566</div></div></div><div class="c-editor-nav-view-li" ng-show="selPanel==\'layout\'"><select ng-options="data.id as data.name for data in vm.catalogList" class="c-select1" ng-model-options="{debounce:100}" ng-change="changeCatalog(data)" ng-model="vm.catalogId"></select><div class="c-editor-nav-classify"><div class="c-editor-nav-classify-view"><div ng-repeat="label in vm.picLayoutXmlsList track by $index" ng-click="selectLayoutLabel(label,$index)" data-index="{{$index}}" class="c-editor-nav-classify-view-btn" ng-class="{\'c-editor-nav-classify-view-btn-active\':label.name==vm.picLayoutXmlGroup.name}">{{label.name}}</div></div></div><div class="c-editor-nav-view-li-hr"></div><div ng-click="recommendAllLayout($event)" class="align-items-center"><input type="checkbox" ng-model="vm.picLayoutXmlGroup.layoutChooseAll" style="width: 12px; height: 13px; margin-right: 2px"> <span>\u5168\u9009\uFF08<span ng-if="!vm.picLayoutXmlGroup.layoutChooseAll">\u8BBE\u4E3A</span><span ng-if="vm.picLayoutXmlGroup.layoutChooseAll">\u53D6\u6D88</span>\u63A8\u8350\uFF09</span></div><div class="c-editor-nav-view-li-3 mt10"><div ng-repeat="value in vm.picLayoutXmlGroup.data track by $index" data-index="{{$index}}" class="c-editor-nav-view-li-3-li picLayoutXml{{$index}}"><img class="c-editor-nav-view-li-3-li-img" ng-src="{{value.cover+vm.menuImageView||\'//:0\'}}" data-art="{{value.identifier}}" ng-click="addLayout(value,$index)" data-index="{{$index}}"><div class="c-editor-nav-view-li-3-li-recommend" ng-click="recommendLayout(value,$index)" uib-tooltip="{{value.isRecommend?\'\u53D6\u6D88\u63A8\u8350\':\'\u63A8\u8350\'}}" tooltip-placement="bottom"><i class="iconfont icon-tuijian1" ng-style="{color:value.isRecommend?\'#FFBA2B\' : \'#fff\'}"></i></div></div></div><div class="c-editor-data-completed">\u6CA1\u6709\u66F4\u591A\u5566</div></div><div class="c-editor-nav-view-li" ng-show="selPanel==\'recycle\'"><div class="c-editor-nav-classify"><div class="c-editor-nav-classify-view"><div ng-repeat="part in template.config.parts.list track by $index" ng-click="backupPartCb(part)" class="c-editor-nav-classify-view-btn" ng-class="{\'c-editor-nav-classify-view-btn-active\':part.id==vm.backupPartId}">{{part.name}}</div></div></div><div class="c-editor-nav-view-li-3 mt20"><div ng-repeat="page in template.deletedPages.page track by $index" ng-show="page.config.partid == vm.backupPartId" data-page="{{page}}" class="c-editor-nav-view-li-3-li"><img class="c-editor-nav-view-li-3-li-img" ng-src="{{page.pagecover.identifier+vm.menuImageView||\'//:0\'}}" data-index="{{$index}}"><div class="bg-del{{$index}} c-editor-nav-view-li-3-li-del" ng-click="restorePage(page,$index)"><i class="iconfont icon-huifushanchu"></i></div></div><div style="color: #89919D;text-align: center;margin-top: 12px;width: 100%">\u6CA1\u6709\u66F4\u591A\u5566</div><!-- {{template.deletedPages.page.length > 0 ? \'\u6CA1\u6709\u66F4\u591A\u5566\' : \'\u6682\u65E0\u6570\u636E\'}} --></div></div><div class="c-editor-nav-view-li" ng-show="selPanel==\'psdimportor\'"><div class="c-editor-nav-view-li-btn1" ng-click="showPsdModal()"><i class="iconfont icon-shangchuan"></i> <span>\u5BFC\u5165PSD</span></div><div class="c-editor-nav-view-li-hr"></div><div class="c-editor-nav-view-li-3"><div ng-repeat="item in template.psdFiles.psdFile | orderBy:\'name\'" ng-click="insertPsdFile(item,$index)" class="c-editor-nav-view-li-3-li" style="width: 100%"><img class="c-editor-nav-view-li-3-li-img" ng-src="{{item.cover.identifier + vm.menuImageView}}"><div class="c-editor-nav-view-li-3-li-del" ng-click="delPsdFile($event, item)"><i class="iconfont icon-shanchu3"></i></div><div class="c-editor-nav-view-li-3-li-edit" ng-click="editPsdFontMapping($event, $index, item)"><i class="iconfont icon-ziti" title="\u8BBE\u7F6E\u5B57\u4F53"></i></div></div></div></div><div class="c-editor-nav-view-li" ng-show="selPanel==\'productTemplate\'"><div class="c-editor-nav-classify"><div class="c-editor-nav-classify-view"><div ng-repeat="label in vm.catalogs track by $index" ng-click="selectTempLabel(label,$index)" data-index="{{$index}}" class="c-editor-nav-classify-view-btn" ng-show="$index<9||showTempLabels" ng-class="{\'leftPanel-nav-active\':label.id==vm.tempCatalogId}">{{label.name}}</div></div><div class="c-editor-nav-classify-view-cursorPointer" ng-if="vm.catalogs.length >9"><div class="c-editor-nav-classify-view-cursorPointer-btn" ng-if="!showTempLabels" ng-click="showTempMoreLabels()"><span>\u5C55\u5F00</span> <i class="iconfont icon-down"></i></div><div class="c-editor-nav-classify-view-cursorPointer-btn" ng-if="showTempLabels" ng-click="showTempMoreLabels()"><span>\u6536\u8D77</span> <i class="iconfont icon-up"></i></div></div></div><div class="c-editor-nav-view-li-3 mt20"><div style="margin-bottom: 16px; width: 100%" ng-repeat="item in vm.productTemplates track by $index" ng-if="item.modelType == vm.page.modelType" data-index="{{$index}}"><div class="c-editor-nav-view-li-3-li" style="margin: 0; width: 100%;height: auto; padding: 10px"><img class="c-editor-nav-view-li-3-li-img" ng-if="item.cover" ng-src="{{vm.url + item.cover+vm.menuImageView||\'//:0\'}}" data-art="{{item.cover}}" ng-click="changeProductTemplate(item,$index)" data-index="{{$index}}"> <img class="c-editor-nav-view-li-3-li-img" ng-if="!item.cover || !vm.url" src="content/images/default-cover.png" ng-click="changeProductTemplate(item,$index)" data-index="{{$index}}"><div class="productTemplate-dark" ng-if="item.id==vm.page.id"><div class="productTemplate-mask"></div><i class="icon iconfont icon-xuanzhong1"></i></div></div><div class="slh" style="width: 100%; font-size: 16px; line-height: 22px; margin-top: 10px">{{item.name}}</div></div><div class="c-editor-nav-view-li-3-li-more" ng-click="loadMoreProductTemplates()" ng-if="vm.productTemplates.length < vm.productTemplatesCount">\u52A0\u8F7D\u66F4\u591A</div><div class="c-editor-data-completed" ng-if="vm.productTemplates.length == vm.productTemplatesCount">\u6CA1\u6709\u66F4\u591A\u5566</div></div></div><div class="c-editor-nav-view-li" ng-show="selPanel==\'barcode\'"><div style="width: 100%; background: #F5F7FA;padding: 16px"><img src="content/images/txm.png" alt="" ng-click="addBarCode()" style="width: 100%"></div><div style="width: 100%; background: #F5F7FA;padding: 16px; margin-top: 20px"><img src="content/images/QrCode.png" alt="" ng-click="addQrCode()" style="width: 100%"></div><div class="c-editor-data-completed">\u6CA1\u6709\u66F4\u591A\u5566</div></div><div class="c-editor-nav-view-li" ng-show="selPanel==\'border\'"><div class="c-editor-nav-view-li-2" ng-if="!vm.thirdparty"><div ng-class="{\'c-editor-nav-view-li-2-active\':vm.borderTab==\'SYSTEM\'}" ng-click="chooseBorderTab(\'SYSTEM\')"><span>\u5E73\u53F0\u8FB9\u6846</span><div class="div-hr"></div></div><div ng-class="{\'c-editor-nav-view-li-2-active\':vm.borderTab==\'RECOMMEND\'}" ng-click="chooseBorderTab(\'RECOMMEND\')"><span>\u63A8\u8350\u8FB9\u6846</span><div class="div-hr"></div></div><div ng-class="{\'c-editor-nav-view-li-2-active\':vm.borderTab==\'USER\'}" ng-click="chooseBorderTab(\'USER\')"><span>\u6211\u7684\u8FB9\u6846</span><div class="div-hr"></div></div></div><div class="c-editor-nav-classify" ng-show="vm.borderTab!=\'RECOMMEND\' && !vm.thirdparty" id="borderLabelsHeight"><div class="c-editor-nav-classify-view"><div ng-click="selectBorderLabelAll()" class="c-editor-nav-classify-view-btn" ng-class="{\'c-editor-nav-classify-view-btn-active\':vm.chooseBorderClassId==null}">\u5168\u90E8</div><div ng-repeat="label in borderLabels track by $index" ng-click="selectBorderLabel(label,$index)" data-index="{{$index}}" class="c-editor-nav-classify-view-btn" ng-show="$index<9||vm.showBorderLabels" ng-class="{\'c-editor-nav-classify-view-btn-active\':label.id==vm.chooseBorderClassId}">{{label.name}}</div><div class="c-editor-nav-classify-view-cursorPointer" ng-if="borderLabels.length >9"><div class="c-editor-nav-classify-view-cursorPointer-btn" ng-if="!vm.showBorderLabels" ng-click="showMoreBorderLabels()"><span>\u5C55\u5F00</span> <i class="iconfont icon-down"></i></div><div class="c-editor-nav-classify-view-cursorPointer-btn" ng-if="vm.showBorderLabels" ng-click="showMoreBorderLabels()"><span>\u6536\u8D77</span> <i class="iconfont icon-up"></i></div></div></div></div><div class="c-editor-nav-view-li-3 mt20"><div ng-repeat="item in vm.frameConfigs track by $index" data-index="{{$index}}" class="c-editor-nav-view-li-3-li clipart{{$index}}"><img class="c-editor-nav-view-li-3-li-img" ng-src="{{item.cover + vm.menuImageView}}" draggable="true" ondragstart="dragStart(event)" id="dragtargetMaskFrameConfig{{$index}}" data-mask="{{item.cover}}" data-index="{{$index}}" style="max-width: 100%;max-height: 100%"><div class="c-editor-nav-view-li-3-li-recommend" ng-click="recommendBorder(item)" uib-tooltip="{{item.isRecommend?\'\u53D6\u6D88\u63A8\u8350\':\'\u63A8\u8350\'}}" tooltip-placement="bottom"><i class="iconfont icon-tuijian1" ng-style="{color:item.isRecommend?\'#FFBA2B\' : \'#fff\'}"></i></div></div><div class="c-editor-nav-view-li-3-li-more" ng-click="loadMoreBorder()" ng-show="vm.borderTab != \'RECOMMEND\' && vm.frameConfigs.length < vm.borderDataCount">\u52A0\u8F7D\u66F4\u591A</div><div class="c-editor-data-completed" ng-if="vm.frameConfigs.length == vm.borderDataCount">\u6CA1\u6709\u66F4\u591A\u5566</div></div></div><div class="c-editor-nav-view-li" ng-show="selPanel==\'widgetTitle\'"><div class="c-editor-nav-view-li-2" ng-if="!vm.thirdparty"><div ng-class="{\'c-editor-nav-view-li-2-active\':vm.widgetTitleTab==\'SYSTEM\'}" ng-click="widgetTitleInit(\'SYSTEM\')"><span>\u5E73\u53F0\u6807\u9898</span><div class="div-hr"></div></div><div ng-class="{\'c-editor-nav-view-li-2-active\':vm.widgetTitleTab==\'USER\'}" ng-click="widgetTitleInit(\'USER\')"><span>\u6211\u7684\u6807\u9898</span><div class="div-hr"></div></div></div><div class="c-editor-nav-view-li-3 mt20"><div ng-repeat="item in vm.widgetTitleList track by $index" class="c-editor-nav-view-li-3-li" style="width: 100%; padding: 8px; cursor: pointer" ng-click="widgetTitleAdd($event, item)"><img class="c-editor-nav-view-li-3-li-img" ng-src="{{item.previewUrl || \'content/images/default-cover.png\'}}" data-mask="{{item.cover}}" data-index="{{$index}}" style="max-width: 100%;max-height: 100%; cursor: pointer"><!--                    <div class="c-editor-nav-view-li-3-li-recommend"--><!--                         ng-click="recommendBorder(item)"--><!--                         uib-tooltip="{{item.isRecommend?\'\u53D6\u6D88\u63A8\u8350\':\'\u63A8\u8350\'}}"--><!--                         tooltip-placement="bottom">--><!--                        <i class="iconfont icon-tuijian1" ng-style="{color:item.isRecommend?\'#FFBA2B\' : \'#fff\'}"></i>--><!--                    </div>--></div><div class="c-editor-nav-view-li-3-li-more" ng-click="widgetTitleNext()" ng-show="vm.widgetTitleTab==\'USER\' && vm.widgetTitleList.length < vm.widgetTitleCount">\u52A0\u8F7D\u66F4\u591A</div><div class="c-editor-data-completed" ng-if="vm.widgetTitleList.length == vm.widgetTitleCount">\u6CA1\u6709\u66F4\u591A\u5566</div></div></div><div class="c-editor-nav-view-li" ng-show="selPanel==\'widgetMonth\'"><div class="c-editor-nav-view-li-2" ng-if="!vm.thirdparty"><div ng-class="{\'c-editor-nav-view-li-2-active\':vm.widgetMonthTab==\'SYSTEM\'}" ng-click="widgetMonthInit(\'SYSTEM\')"><span>\u5E73\u53F0\u65E5\u5386</span><div class="div-hr"></div></div><div ng-class="{\'c-editor-nav-view-li-2-active\':vm.widgetMonthTab==\'USER\'}" ng-click="widgetMonthInit(\'USER\')"><span>\u6211\u7684\u65E5\u5386</span><div class="div-hr"></div></div></div><div class="c-editor-nav-view-li-3"><div ng-repeat="item in vm.widgetMonthList track by $index" class="c-editor-nav-view-li-3-li" style="width: 100%; padding: 8px; cursor: pointer" ng-click="widgetMonthAdd($event, item)"><img class="c-editor-nav-view-li-3-li-img" ng-src="{{item.previewUrl || \'content/images/default-cover.png\'}}" data-mask="{{item.cover}}" data-index="{{$index}}" style="max-width: 100%;max-height: 100%"><!--                    <div class="c-editor-nav-view-li-3-li-recommend"--><!--                         ng-click="recommendBorder(item)"--><!--                         uib-tooltip="{{item.isRecommend?\'\u53D6\u6D88\u63A8\u8350\':\'\u63A8\u8350\'}}"--><!--                         tooltip-placement="bottom">--><!--                        <i class="iconfont icon-tuijian1" ng-style="{color:item.isRecommend?\'#FFBA2B\' : \'#fff\'}"></i>--><!--                    </div>--></div><div class="c-editor-nav-view-li-3-li-more" ng-click="widgetMonthNext()" ng-show="vm.widgetMonthTab==\'USER\' && vm.widgetMonthList.length < vm.widgetMonthCount">\u52A0\u8F7D\u66F4\u591A</div><div class="c-editor-data-completed" ng-if="vm.widgetMonthList.length == vm.widgetMonthCount">\u6CA1\u6709\u66F4\u591A\u5566</div></div></div></div><div class="c-editor-operation" id="nav-header" ng-style="{\n            \'left\':vm.leftShow?\'392px\':\'72px\',\n            \'right\':vm.rightShow?\'200px\':\'0\',\n         }"><div class="top-btn-left"><div ng-show="RightPanel==\'text\'&&!selectBox.lock"><ul class="c-xml-action-icon-font"><li><div class="c-xml-action-div-icon c-xml-action-div-icon-color" ng-click="operationColorOpen($event)" ng-style="{background: currentPage.levels.level[template.levelI].textbox.style.color}" style="border: 1px solid #ddd" uib-tooltip="\u989C\u8272" tooltip-placement="bottom"></div><div class="c-xml-action-div-color-modal clearfix" style="z-index: 999;top:48px;left: -5px" ng-if="vm.isOperationColor"><input class="c-xml-action-div-color-modal-btn" type="color" ng-change="chooseTextColor()" ng-model="vm.textColor"> <span ng-repeat="item in vm.colorList track by $index" ng-style="{ \'background\' : item.id}" ng-class="{\'c-xml-action-div-color-on\' : item.id == currentPage.levels.level[template.levelI].textbox.style.color}" ng-click="operationColor(item)"></span></div></li><li><div class="c-font-view"><div class="c-font-view-head" ng-style="{\'font-family\': \'\\\'\' + item.uuid + \'\\\'\',}">{{vm.selectFontName(currentPage.levels.level[template.levelI].textbox.fontuuid)}}</div><div class="c-font-view-body"><div class="c-font-view-body-head"><input type="text" class="c-font-view-body-head-input" id="selectFontInput" ng-model="vm.selectFont" ng-change="vm.selectFontBtn()"> <span class="c-font-view-body-head-btn" ng-click="vm.selectFontBtn()" style="top: 6px"></span></div><div class="chinese-support-view"><div class="chinese-support-item" ng-class="{\'chinese-support-select\' : vm.chineseSupport}" ng-click="vm.chineseSupport=true">\u4E2D\u6587\u5B57\u4F53</div><div class="chinese-support-item" ng-class="{\'chinese-support-select\' : !vm.chineseSupport}" ng-click="vm.chineseSupport=false">\u5176\u4ED6\u5B57\u4F53</div></div><div class="c-font-view-body-ul scrollbar-main"><div class="c-font-view-body-li" ng-repeat="font in vm.fontList track by $index" ng-click="updateTextFont(font)" ng-if="vm.chineseSupport == font.chineseSupport" ng-class="{\'c-font-view-body-li-on\' : currentPage.levels.level[template.levelI].textbox.fontuuid == font.uuid}"><img ng-src="{{vm.url + font.fontStyles[0].identifier}}" alt="" ng-if="font.fontStyles[0].identifier"> <span ng-if="!font.fontStyles[0].identifier">{{font.name}}</span></div></div></div></div></li><li><div class="c-font-view" style="width: 90px"><!-- <div class="c-font-view-head">\n                                <input type="number" class="c-input1"\n                                       style=" width: 100%; border: 0;"\n                                       ng-model="currentPage.levels.level[template.levelI].textbox.style.size"\n                                       ng-change="updateTextSize(currentPage.levels.level[template.levelI].textbox.style.size)">\n                                <input type="number" class="c-input1"\n                                       style=" width: 100%; border: 0;"\n                                       ng-model="vm.selectElementCopy.textbox.style.size"\n                                       ng-keypress="$event.keyCode === 13 ? updateTextSize(vm.selectElementCopy.textbox.style.size) : return" ng-blur="updateTextSize(vm.selectElementCopy.textbox.style.size)">\n                            </div> --><input-number ng-model="vm.selectElementCopy.textbox.style.size" on-change="updateTextSize(vm.selectElementCopy.textbox.style.size)" step="1" type-style="\'one\'"></input-number><div class="c-font-view-body"><div class="c-font-view-body-ul scrollbar-main"><div class="c-font-view-body-li" ng-repeat="size in fontSizes track by $index" ng-click="updateTextSize(size)" ng-class="{\'c-font-view-body-li-on\' : currentPage.levels.level[template.levelI].textbox.style.size == size}">{{size}}</div></div></div></div></li><li class="iconfont icon-I" ng-click="operationItalic()" ng-if="selectBox.style.italic1 && !vm.moreIcon" uib-tooltip="\u659C\u4F53" tooltip-placement="bottom" ng-class="{\'toolsSelected\':currentPage.levels.level[template.levelI].textbox.style.italic}"></li><li class="iconfont icon-b" ng-if="selectBox.style.bold1 && !vm.moreIcon" ng-click="operationBold()" uib-tooltip="\u7C97\u4F53" tooltip-placement="bottom" ng-class="{\'toolsSelected\':currentPage.levels.level[template.levelI].textbox.style.bold}"></li><li ng-click="operationSpacing($event)" ng-if="!vm.moreIcon" class="iconfont icon-wenzi-hangjianjushezhi" uib-tooltip="\u5B57\u95F4\u8DDD" tooltip-placement="bottom" tooltip-append-to-body="false" ng-class="{\'btn-avtive\':vm.isOperationSpacing}"><div class="roundedSet" ng-show="vm.isOperationSpacing" style="width: 320px" ng-click="fn($event)"><div class="roundedSet-title"><h4 class="rightPanel-title">\u5B57\u95F4\u8DDD</h4></div><div class="c-schedule-view"><input type="range" min="0" max="100" step="1" value="{{vm.selectElementCopy.textbox.style.letterspacing}}" ng-model="vm.selectElementCopy.textbox.style.letterspacing" class="text-range" style="width: 100% !important" ng-style="{\'background-size\': vm.selectElementCopy.textbox.style.letterspacing + \'% \' + \'100%\'}" ng-change="changeLetterspacing()"> <input type="text" min="0" max="100" step="1" style="width: 60px;height: 32px;margin-left: 10px" ng-model="vm.selectElementCopy.textbox.style.letterspacing" ng-blur="changeLetterspacing()" ng-keypress="$event.keyCode === 13 ? changeLetterspacing() : return"></div><div class="roundedSet-title"><h4 class="rightPanel-title">\u884C\u95F4\u8DDD</h4></div><div class="c-schedule-view"><input type="range" min="0" max="100" step="1" value="{{vm.selectElementCopy.textbox.style.lineheight}}" ng-model="vm.selectElementCopy.textbox.style.lineheight" class="text-range" style="width: 100% !important" ng-style="{\'background-size\': vm.selectElementCopy.textbox.style.lineheight + \'% \' + \'100%\'}" ng-change="changeLineheight()"> <input type="text" min="0" max="100" step="1" style="width: 60px;height: 32px;margin-left: 10px" ng-model="vm.selectElementCopy.textbox.style.lineheight" ng-blur="changeLineheight()" ng-keypress="$event.keyCode === 13 ? changeLineheight() : return"></div></div></li><li ng-if="!vm.moreIcon" class="iconfont icon-wenzizuoduiqi" ng-click="operationDir()" uib-tooltip="\u5BF9\u9F50" tooltip-append-to-body="false" tooltip-placement="bottom" ng-class="{\'btn-avtive\':vm.isOperationDir}"><div class="roundedSet" ng-show="vm.isOperationDir" style="width: 220px" ng-click="fn($event)"><div class="roundedSet-title"><h4 class="rightPanel-title">\u5BF9\u9F50</h4></div><div class="c-schedule-view coverageItem" ng-click="operationBarLeft($event)"><div class="iconfont icon-wenzizuoduiqi"></div><div class="name">\u5DE6\u5BF9\u9F50</div></div><div class="c-schedule-view coverageItem" ng-click="operationBarCenter($event)"><div class="iconfont icon-wenzijuzhong"></div><div class="name">\u5C45\u4E2D\u5BF9\u9F50</div></div><div class="c-schedule-view coverageItem" ng-click="operationBarRight($event)"><div class="iconfont icon-wenziyouduiqi"></div><div class="name">\u53F3\u5BF9\u9F50</div></div><div class="c-schedule-view coverageItem" ng-click="operationBarJustify($event)"><div class="iconfont icon-wenziliangduanduiqi"></div><div class="name">\u4E24\u7AEF\u5BF9\u9F50</div></div></div></li><li class="iconfont icon-hengban" uib-tooltip="\u6A2A\u7248" tooltip-placement="bottom" ng-click="textHengban()" ng-if="template.pages.page[template.pageI].levels.level[template.levelI].textbox.style.writingmode != \'horizontal-tb\' && !vm.moreIcon"></li><li class="iconfont icon-shubanzuo2" uib-tooltip="\u7AD6\u7248\u5DE6" tooltip-placement="bottom" ng-if="template.pages.page[template.pageI].levels.level[template.levelI].textbox.style.writingmode != \'vertical-lr\' && !vm.moreIcon" ng-click="textShuban(\'vertical-lr\')"></li><li class="iconfont icon-shubanyou2" uib-tooltip="\u7AD6\u7248\u53F3" tooltip-placement="bottom" ng-if="template.pages.page[template.pageI].levels.level[template.levelI].textbox.style.writingmode != \'vertical-rl\' && !vm.moreIcon" ng-click="textShuban(\'vertical-rl\')"></li></ul></div><ul class="c-xml-action-icon-font"><li class="iconfont icon-chaifenzuhe" ng-if="RightPanel==\'textDoc\'&&selectBox.editable" uib-tooltip="\u62C6\u5206\u7EC4\u5408" tooltip-placement="bottom" ng-click="slipGroup()"></li><li class="iconfont icon-huabujuzhong" ng-if="RightPanel" uib-tooltip="\u753B\u5E03\u5C45\u4E2D" tooltip-placement="bottom" ng-click="canvasMiddle()"></li><li ng-if="RightPanel" class="iconfont icon-huabuduiqi" ng-class="{\'btn-avtive\':isAlignHover}" uib-tooltip="\u5BF9\u9F50" tooltip-placement="bottom" tooltip-append-to-body="false" ng-click="toobarAlignment()"><div class="roundedSet" ng-show="isAlignHover" style="width: 320px"><div class="roundedSet-title"><div class="rightPanel-title">{{vm.getAllCtrlKeyArray().length > 1?\'\u5143\u7D20\u5BF9\u9F50\':\'\u753B\u5E03\u5BF9\u9F50\'}}</div></div><div class="align-view"><div ng-click="singleBoxAlignment(\'left\')"><i class="iconfont icon-zuoduiqi font-18"></i><div>\u5DE6\u5BF9\u9F50</div></div><div ng-click="singleBoxAlignment(\'right\')"><i class="iconfont icon-youduiqi font-18"></i><div>\u53F3\u5BF9\u9F50</div></div><div ng-click="singleBoxAlignment(\'standard\')"><i class="iconfont icon-huabuduiqi-chuizhijuzhong font-18"></i><div>\u6C34\u5E73\u5C45\u4E2D</div></div><div ng-click="singleBoxAlignment(\'vertical\')"><i class="iconfont icon-huabuduiqi-shuipingjuzhong font-18"></i><div>\u5782\u76F4\u5C45\u4E2D</div></div><div ng-click="singleBoxAlignment(\'top\')"><i class="iconfont icon-shangduiqi font-18"></i><div>\u4E0A\u5BF9\u9F50</div></div><div ng-click="singleBoxAlignment(\'bottom\')"><i class="iconfont icon-xiaduiqi font-18"></i><div>\u4E0B\u5BF9\u9F50</div></div></div><div class="roundedSet-title" style="margin-top: 20px" ng-if="vm.getAllCtrlKeyArray().length > 2"><div class="rightPanel-title">\u5143\u7D20\u5206\u5E03</div></div><div class="align-view" ng-if="vm.getAllCtrlKeyArray().length > 2"><div ng-click="boxDistribution(\'standard\')"><i class="iconfont icon-fenbu-shuipingfenbu font-18"></i><div>\u6C34\u5E73\u5206\u5E03</div></div><div ng-click="boxDistribution(\'vertical\')"><i class="iconfont icon-chuizhifenbu font-18"></i><div>\u5782\u76F4\u5206\u5E03</div></div></div></div></li></ul></div><div class="top-btn-right"><div class="iconfont icon-yuanjiao" uib-tooltip="\u5706\u89D2" tooltip-placement="bottom" tooltip-append-to-body="false" ng-if="RightPanel&&currentPage.levels.level[template.levelI].imagebox.current == \'imagebox\' &&selectBox.border && selectBox.border.type == \'Color\' && selectBox.border.shape == \'Rectangle\'" ng-class="{\'disabled-btn\':!selectBox.border,\'btn-avtive\':vm.isRoundedSet}" ng-click="roundedSet(!vm.isRoundedSet)"><div class="roundedSet" ng-show="vm.isRoundedSet" style="width: 320px;padding: 0" ng-click="fn($event)"><div class="roundedSet-title"><div style="display: flex;align-items: center"><h4 class="rightPanel-title" style="margin-right: 10px">\u5706\u89D2\u8BBE\u7F6E</h4><span class="filletType" ng-class="{\'filletTypeActive\': vm.selectElementCopy.imagebox.border.radius.filletType == \'Fixed\'}" ng-click="changeFilletType(\'Fixed\')">px</span> <span class="filletType" ng-class="{\'filletTypeActive\': vm.selectElementCopy.imagebox.border.radius.filletType == \'Proportion\'}" ng-click="changeFilletType(\'Proportion\')">%</span></div><div class="border-radio-btn"><span class="iconfont icon-yuanjiaoshezhi1" ng-click="borderRadiusAllbtn($event)" ng-style="{\'background\':vm.borderRadiusAllbtn?\'#F5F7FA\':\'\'}" style="padding:2px 5px;border-radius: 4px"></span> <span class="iconfont icon-yuanjiaoshezhi2" ng-click="vm.borderRadiusAllbtn = false" ng-style="{\'background\':!vm.borderRadiusAllbtn?\'#F5F7FA\':\'\'}" style="padding:2px 5px;border-radius: 4px"></span></div></div><!-- \u767E\u5206\u6BD4 --><div ng-if="vm.selectElementCopy.imagebox.border.radius.filletType == \'Proportion\'"><div ng-if="!vm.borderRadiusAllbtn" style="margin-bottom: 10px"><div class="c-schedule-view"><span class="c-schedule-title">\u5DE6\u4E0A\uFF1A</span> <input type="range" min="0" max="100" step="1" value="{{vm.selectElementCopy.imagebox.border.radius.lt}}" ng-model="vm.selectElementCopy.imagebox.border.radius.lt" ng-change="borderRadius($event)" class="text-range" style="width: 100% !important" ng-style="{\'background-size\': vm.selectElementCopy.imagebox.border.radius.lt + \'% \' + \'100%\'}"> <span style="width: 30px">{{vm.selectElementCopy.imagebox.border.radius.lt}}%</span></div><div class="c-schedule-view"><span class="c-schedule-title">\u53F3\u4E0A\uFF1A</span> <input type="range" min="0" max="100" step="1" value="{{vm.selectElementCopy.imagebox.border.radius.rt}}" ng-model="vm.selectElementCopy.imagebox.border.radius.rt" ng-change="borderRadius($event)" class="text-range" style="width: 100% !important" ng-style="{\'background-size\': vm.selectElementCopy.imagebox.border.radius.rt + \'% \' + \'100%\'}"> <span style="width: 30px">{{vm.selectElementCopy.imagebox.border.radius.rt}}%</span></div><div class="c-schedule-view"><span class="c-schedule-title">\u53F3\u4E0B\uFF1A</span> <input type="range" min="0" max="100" step="1" value="{{vm.selectElementCopy.imagebox.border.radius.rb}}" ng-model="vm.selectElementCopy.imagebox.border.radius.rb" ng-change="borderRadius($event)" class="text-range" style="width: 100% !important" ng-style="{\'background-size\': vm.selectElementCopy.imagebox.border.radius.rb + \'% \' + \'100%\'}"> <span style="width: 30px">{{vm.selectElementCopy.imagebox.border.radius.rb}}%</span></div><div class="c-schedule-view"><span class="c-schedule-title">\u5DE6\u4E0B\uFF1A</span> <input type="range" min="0" max="100" step="1" value="{{vm.selectElementCopy.imagebox.border.radius.lb}}" ng-model="vm.selectElementCopy.imagebox.border.radius.lb" ng-change="borderRadius($event)" class="text-range" style="width: 100% !important" ng-style="{\'background-size\': vm.selectElementCopy.imagebox.border.radius.lb + \'% \' + \'100%\'}"> <span style="width: 30px">{{vm.selectElementCopy.imagebox.border.radius.lb}}%</span></div></div><div ng-if="vm.borderRadiusAllbtn"><div class="c-schedule-view"><span class="c-schedule-title">\u5168\u90E8\uFF1A</span> <input type="range" min="0" max="100" step="1" value="{{vm.selectElementCopy.imagebox.border.radius.all}}" ng-model="vm.selectElementCopy.imagebox.border.radius.all" ng-change="borderRadiusAll()" class="text-range" style="width: 100% !important" ng-style="{\'background-size\': vm.selectElementCopy.imagebox.border.radius.all + \'% \' + \'100%\'}"> <span style="width: 30px">{{vm.selectElementCopy.imagebox.border.radius.all}}%</span></div></div></div><!-- \u56FA\u5B9A\u503C --><div ng-if="vm.selectElementCopy.imagebox.border.radius.filletType == \'Fixed\'"><div ng-if="!vm.borderRadiusAllbtn" style="margin: 10px 0;display: flex;flex-wrap: wrap;row-gap: 10px"><div class="c-schedule-view2"><span class="c-schedule-title">\u5DE6\u4E0A\uFF1A</span><input-number ng-model="vm.selectElementCopy.imagebox.border.radius.lt" on-change="borderRadius($event)" min="0" type-style="\'one\'"></input-number><span style="width: 30px">px</span></div><div class="c-schedule-view2"><span class="c-schedule-title">\u53F3\u4E0A\uFF1A</span><input-number ng-model="vm.selectElementCopy.imagebox.border.radius.rt" on-change="borderRadius($event)" min="0" type-style="\'one\'"></input-number><span style="width: 30px">px</span></div><div class="c-schedule-view2"><span class="c-schedule-title">\u5DE6\u4E0B\uFF1A</span><input-number ng-model="vm.selectElementCopy.imagebox.border.radius.lb" on-change="borderRadius($event)" min="0" type-style="\'one\'"></input-number><span style="width: 30px">px</span></div><div class="c-schedule-view2"><span class="c-schedule-title">\u53F3\u4E0B\uFF1A</span><input-number ng-model="vm.selectElementCopy.imagebox.border.radius.rb" on-change="borderRadius($event)" min="0" type-style="\'one\'"></input-number><span style="width: 30px">px</span></div></div><div ng-if="vm.borderRadiusAllbtn" style="margin: 10px 0"><div class="c-schedule-view2"><span class="c-schedule-title">\u5168\u90E8\uFF1A</span><input-number ng-model="vm.selectElementCopy.imagebox.border.radius.all" on-change="borderRadiusAll()" min="0" type-style="\'one\'"></input-number><span style="width: 30px">px</span></div></div></div></div></div><div class="iconfont icon-bianjiqi-biankuang" uib-tooltip="\u8FB9\u6846" tooltip-placement="bottom" tooltip-append-to-body="false" ng-if="RightPanel&&currentPage.levels.level[template.levelI].imagebox.current == \'imagebox\' &&selectBox.border && selectBox.border.type == \'Color\'" ng-class="{\'disabled-btn\':!selectBox.border,\'btn-avtive\':vm.isBorderSet}" ng-click="borderSet(!vm.isBorderSet)"><div class="roundedSet" ng-show="vm.isBorderSet" ng-click="fn($event)" style="width: 320px"><div class="roundedSet-title"><h4 class="rightPanel-title">\u8FB9\u6846\u8BBE\u7F6E</h4></div><div class="borderSet-body"><div class="bezel-set-color" style="width: 30px;height: 30px" ng-style="{background:template.pages.page[template.pageI].levels.level[template.levelI].imagebox.border.color}"><input type="color" ng-value="template.pages.page[template.pageI].levels.level[template.levelI].imagebox.border.color" ng-model="template.pages.page[template.pageI].levels.level[template.levelI].imagebox.border.color"></div><div class="c-font-view" style="height: 30px;flex: 1;padding: 0 10px"><div class="c-font-view-head2"><div ng-show="template.pages.page[template.pageI].levels.level[template.levelI].imagebox.border.lineType == \'solid\'"><img src="content/images/icons/solid.png"></div><div ng-show="template.pages.page[template.pageI].levels.level[template.levelI].imagebox.border.lineType == \'dashed\'"><img src="content/images/icons/dashed.png"></div><div ng-show="template.pages.page[template.pageI].levels.level[template.levelI].imagebox.border.lineType == \'dotted\'"><img src="content/images/icons/dotted.png"></div><span class="iconfont icon-down" style="position: absolute;width: 20px;right: 5px;top: 50%;transform: translateY(-50%)"></span></div><div class="c-font-view-body" style="box-shadow: 0 0 10px 0 #cfcfcf"><div class="c-font-view-body-ul" style="margin-top: 0"><div class="c-font-view-body-li" ng-click="lineTypeChenge(\'solid\')"><img src="content/images/icons/solid.png"></div><div class="c-font-view-body-li" ng-click="lineTypeChenge(\'dashed\')"><img src="content/images/icons/dashed.png"></div><div class="c-font-view-body-li" ng-click="lineTypeChenge(\'dotted\')"><img src="content/images/icons/dotted.png"></div></div></div></div><div style="width: 80px;height: 30px;display: flex"><!-- <input type="number" class="c-input1"\n                                oninput="if(!/^[0-9]+$/.test(value)) value=value.replace(/\\D/g,\'\');if(value>999)value=999;if(value<0)value=null"\n                                ng-model="vm.selectElementCopy.imagebox.border.lineWidth"\n                                ng-keypress="$event.keyCode === 13 ? lineWidthChange() : return"\n                                ng-blur="lineWidthChange()"> --><input-number ng-model="vm.selectElementCopy.imagebox.border.lineWidth" on-change="lineWidthChange()" min="0" type-style="\'one\'"></input-number><span>px</span></div></div></div></div><div class="iconfont icon-touying" ng-if="RightPanel&&currentPage.levels.level[template.levelI].imagebox.current == \'imagebox\' &&(!selectBox.border || (selectBox.border && selectBox.border.type != \'Pic\'))" uib-tooltip="\u9634\u5F71" tooltip-append-to-body="false" tooltip-placement="bottom" ng-class="{\'disabled-btn\':!selectBox.shadow,\'btn-avtive\':vm.isShadowSet}" ng-click="shadowSet(!vm.isShadowSet)"><div class="roundedSet" ng-show="vm.isShadowSet" ng-click="fn($event)" style="width: 320px"><div class="roundedSet-title"><h4 class="rightPanel-title">\u9634\u5F71\u8BBE\u7F6E</h4></div><div><div class="c-schedule-view"><span class="c-schedule-title">\u989C\u8272\uFF1A</span><div class="bezel-set-color" style="width: 30px;height: 30px" ng-style="{background:template.pages.page[template.pageI].levels.level[template.levelI].imagebox.shadow.color}"><input type="color" ng-value="template.pages.page[template.pageI].levels.level[template.levelI].imagebox.shadow.color" ng-model="template.pages.page[template.pageI].levels.level[template.levelI].imagebox.shadow.color"></div></div><div class="c-schedule-view"><span class="c-schedule-title">X\u8F74\uFF1A</span> <input type="range" min="-100" max="100" step="1" value="{{selectBox.shadow.x}}" ng-model="selectBox.shadow.x" ng-change="borderRadius()" class="text-range" style="width: 100% !important" ng-style="{\'background-size\': rangeShadowX(selectBox.shadow.x)}"> <span style="width: 30px">{{selectBox.shadow.x}}%</span></div><div class="c-schedule-view"><span class="c-schedule-title">Y\u8F74\uFF1A</span> <input type="range" min="-100" max="100" step="1" value="{{selectBox.shadow.y}}" ng-model="selectBox.shadow.y" ng-change="borderRadius()" class="text-range" style="width: 100% !important" ng-style="{\'background-size\':  rangeShadowY(selectBox.shadow.y)}"> <span style="width: 30px">{{selectBox.shadow.y}}%</span></div><div class="c-schedule-view"><span class="c-schedule-title">\u6A21\u7CCA\uFF1A</span> <input type="range" min="0" max="20" step="1" value="{{selectBox.shadow.blur}}" ng-model="selectBox.shadow.blur" ng-change="borderRadius()" class="text-range" style="width: 100% !important" ng-style="{\'background-size\': selectBox.shadow.blur * 5 + \'% \' + \'100%\'}"> <span style="width: 30px">{{selectBox.shadow.blur}}%</span></div></div></div></div><div class="iconfont icon-zhongfushengcheng" ng-class="{\'disabled-btn\':!RightPanel || selectBox.lock}" uib-tooltip="\u91CD\u590D\u751F\u6210" tooltip-placement="bottom" ng-click="generBox($event,selectBox)"></div><div class="iconfont icon-toumingdu" uib-tooltip="\u900F\u660E\u5EA6" tooltip-placement="bottom" tooltip-append-to-body="false" ng-class="{\'disabled-btn\':!RightPanel || RightPanel==\'calMonthBox\' || RightPanel==\'calTitleBox\',\'btn-avtive\':(RightPanel && vm.isTransp)}" ng-click="transparencySelect(!vm.isTransp)"><div class="roundedSet" ng-show="RightPanel && vm.isTransp" style="width: 320px" ng-click="fn($event)"><div class="roundedSet-title"><h4 class="rightPanel-title">\u900F\u660E\u5EA6\u8BBE\u7F6E</h4></div><div class="c-schedule-view"><input type="range" min="0" max="1" step="0.01" value="{{selectBox.transparency}}" ng-model="selectBox.transparency" class="text-range" style="width: 100% !important" ng-style="{\'background-size\': selectBox.transparency*100 + \'% \' + \'100%\'}"> <input type="number" step="1" class="c-input1" style="width: 70px;height: 30px;padding-right: 0;margin-left: 5px" ng-model="template.transparency" ng-change="transparencyChange1()"></div></div></div><div class="iconfont icon-tuceng" uib-tooltip="\u56FE\u5C42" tooltip-placement="bottom" tooltip-append-to-body="false" ng-class="{\'disabled-btn\':!RightPanel,\'btn-avtive\':(RightPanel && vm.isCoverage)}" ng-click="coverageSelect(!vm.isCoverage)"><div class="roundedSet" ng-show="RightPanel && vm.isCoverage" style="width: 245px" ng-click="fn($event)"><div class="roundedSet-title"><div class="rightPanel-title">\u56FE\u5C42\u8BBE\u7F6E</div></div><div class="c-schedule-view coverageItem" ng-click="coverageMove(\'top\')"><div class="iconfont icon-yizhidingceng"></div><div class="name">\u79FB\u81F3\u9876\u5C42</div></div><div class="c-schedule-view coverageItem" ng-click="coverageMove(\'up\')"><div class="iconfont icon-shangyiyiceng"></div><div class="name">\u4E0A\u79FB\u4E00\u5C42</div></div><div class="c-schedule-view coverageItem" ng-click="coverageMove(\'down\')"><div class="iconfont icon-shangyiyiceng"></div><div class="name">\u4E0B\u79FB\u4E00\u5C42</div></div><div class="c-schedule-view coverageItem" ng-click="coverageMove(\'bottom\')"><div class="iconfont icon-xiayiyiceng"></div><div class="name">\u79FB\u81F3\u5E95\u5C42</div></div></div></div><div class="iconfont" uib-tooltip="{{selectBox.lock ? \'\u89E3\u9501\' : \'\u9501\u5B9A\'}}" tooltip-placement="bottom" ng-class="{\'disabled-btn\':!RightPanel}" ng-click="locking($event)"><span class="iconfont icon-suoding" ng-class="{\'shake3\':RightPanel&&selectBox.lock}" style="font-size: 22px"></span></div><div class="iconfont icon-fuzhi2" uib-tooltip="\u590D\u5236" tooltip-placement="bottom" ng-class="{\'disabled-btn\':!RightPanel}" ng-click="copying()"></div><div class="iconfont icon-shanchu" uib-tooltip="\u5220\u9664" tooltip-placement="bottom" ng-class="{\'disabled-btn\':!RightPanel}" ng-click="deleteBox()"></div></div></div><div class="page-item-cover" style="transform:translate(-50% -50%)!important;outline: none" ng-style="{\n                                     \'width\': currentPage.mediabox.width/currentPage.proportion*currentPage.scale,\n                                         \'height\': currentPage.mediabox.height/currentPage.proportion*currentPage.scale,\n                                    }"><div class="content-container2 content-page content-page-cover" ng-style="{\n                                        \'width\': currentPage.mediabox.width/currentPage.proportion*currentPage.scale,\n                                         \'height\': currentPage.mediabox.height/currentPage.proportion*currentPage.scale}"><img ng-src="{{currentPage.pagecover.identifier + vm.pageImageView||\'//:0\'}}"></div></div><div class="c-editor-canvas" ng-style="{\n            \'left\':vm.leftShow?\'392px\':\'72px\',\n            \'right\':vm.rightShow?\'200px\':\'0\',\n            \'bottom\':vm.bottomShow?\'120px\':\'0\',\n         }"><div class="c-editor-canvas-view" id="pageCenterSize" ng-click="resetCtrlKeyArray($event)"><div class="page-item" ng-show="!currentPage.isScene" style="transform:translate(-50% -50%)!important;outline: none" ng-class="{\'custom-grid\':currentPage.background.type==\'Color\'&&!currentPage.background.color}" ng-style="{\n                                         \'width\': currentPage.mediabox.width/currentPage.proportion*currentPage.scale,\n                                         \'height\': currentPage.mediabox.height/currentPage.proportion*currentPage.scale,\n                                         \'margin-left\':canvasCoordX(currentPage.mediabox.width/currentPage.proportion*currentPage.scale),\n                                         \'margin-top\': canvasCoordY(currentPage.mediabox.height/currentPage.proportion*currentPage.scale),\n                                        }"><div class="content-container content-page content-page-main" ng-click="clearCtrlKey(1,$event)" ng-style="{\n                                            width: (currentPage.mediabox.width/currentPage.proportion)*currentPage.scale,\n                                            height: (currentPage.mediabox.height/currentPage.proportion)*currentPage.scale,\n                                            background:currentPage.background.type==\'Color\'?currentPage.background.color:\'\'\n                                            }"><div style="position: relative; width: 100%; height: 100%; overflow: hidden"><img id="bgImg" class="bg-image bg-image{{template.pageI}} pos" ng-cloak ondblclick="doubleClickbgImg(event)" ng-if="currentPage.background.type==\'Pic\'&&currentPage.background.resource.identifier" ng-src="{{currentPage.background.resource.identifier + vm.pageImageView||\'//:0\'}}" ng-style="{\n                                             position: \'absolute\',\n                                             left:currentPage.background.offsetx*currentPage.scale/currentPage.proportion,\n                                             top:currentPage.background.offsety*currentPage.scale/currentPage.proportion,\n                                             width: currentPage.background.adaptation==\'Width\'?currentPage.background.width*currentPage.scale/currentPage.proportion:\'\',\n                                             height:currentPage.background.adaptation==\'Height\'?currentPage.background.height*currentPage.scale/currentPage.proportion:\'\'}"><div class="iconWarn1" ng-if="currentPage.lowAccuracy"><img src="content/images/icon/icon-breezing-bj.png" alt=""></div></div><div ng-repeat="level in currentPage.levels.level track by $index" ng-init="levelIndex = $index" ng-if="!level.isHidden"><div id="mask" data-index="{{$index}}" class="imgBox" ng-show="level.imagebox.current" ng-class="{\'selected\': level.imagebox.ctrlKey || $index == template.levelI && (RightPanel==\'mask\')}" ng-style="{\n                                                    width: imageboxW(level.imagebox)*currentPage.scale/currentPage.proportion,\n                                                    height: imageboxH(level.imagebox)*currentPage.scale/currentPage.proportion,\n                                                    left: imageboxL(level.imagebox)*currentPage.scale/currentPage.proportion,\n                                                    top: imageboxT(level.imagebox)*currentPage.scale/currentPage.proportion,\n                                                    \'z-index\':level.seq-0+200,\n                                                    \'transform\': \'rotate(-\' + level.imagebox.rotation.angle + \'deg)\',\n                                                    \'opacity\': opacityElement(currentPage.mediabox, level.imagebox.geometry)\n                                                    }" ng-dblclick="doubleClickImagebox($event, $index, level.imagebox)" ng-click="selectImg($event, $index, level.imagebox)"><div class="relative-view1" data-index="{{$index}}" ng-mousedown="moveBoxStart($event,level.imagebox,$index)" ng-style="{\n                                                 \'overflow\': (level.imagebox.border && level.imagebox.border.type == \'Pic\') ? \'unset\' : \'hidden\',\n                                                \'border-top-left-radius\':(level.imagebox.border && level.imagebox.border.type == \'Pic\') ? 0 : imageboxWRadius(level.imagebox, \'lt\', currentPage.scale/currentPage.proportion),\n                                                \'border-top-right-radius\':(level.imagebox.border && level.imagebox.border.type == \'Pic\') ? 0 : imageboxWRadius(level.imagebox, \'rt\', currentPage.scale/currentPage.proportion),\n                                                \'border-bottom-right-radius\':(level.imagebox.border && level.imagebox.border.type == \'Pic\') ? 0 : imageboxWRadius(level.imagebox, \'rb\', currentPage.scale/currentPage.proportion),\n                                                \'border-bottom-left-radius\':(level.imagebox.border && level.imagebox.border.type == \'Pic\') ? 0 : imageboxWRadius(level.imagebox, \'lb\', currentPage.scale/currentPage.proportion),\n                                                \'border-width\': (level.imagebox.border && level.imagebox.border.type == \'Color\') ? ((level.imagebox.border.lineWidth*currentPage.scale/currentPage.proportion) | number:0) : \'\',\n                                                \'border-style\': (level.imagebox.border && level.imagebox.border.type == \'Color\' && level.imagebox.border.lineType == \'solid\') ? \'solid\' : (level.imagebox.border && level.imagebox.border.type == \'Color\' && level.imagebox.border.lineType == \'dashed\') ? \'dashed\' : (level.imagebox.border && level.imagebox.border.type == \'Color\' && level.imagebox.border.lineType == \'dotted\') ? \'dotted\' : \'none\',\n                                                \'border-color\': (level.imagebox.border && level.imagebox.border.type == \'Color\') ? level.imagebox.border.color : \'\',\n                                                \'opacity\':level.imagebox.transparency,\n                                                \'box-shadow\' : (level.imagebox.border && level.imagebox.border.type == \'Color\' && level.imagebox.border.lineWidth>0 && level.imagebox.border && level.imagebox.border.lineType == \'solid\') ? \'0 0 0 1px \' + level.imagebox.border.color + \' inset\' : \'none\',\n                                                \'filter\' : dropShadow(level.imagebox,currentPage.scale/currentPage.proportion),\n                                            }"><div ng-style="{\n                                                     \'position\': \'absolute\',\n                                                     \'z-index\':0,\n                                                    \'left\': (level.imagebox.border && level.imagebox.border.type == \'Pic\') ? -imageboxWEdge(level.imagebox,\'left\')*currentPage.scale/currentPage.proportion : 0,\n                                                    \'top\': (level.imagebox.border && level.imagebox.border.type == \'Pic\') ? -imageboxWEdge(level.imagebox,\'top\')*currentPage.scale/currentPage.proportion : 0,\n                                                    \'right\': (level.imagebox.border && level.imagebox.border.type == \'Pic\') ? -imageboxWEdge(level.imagebox,\'right\')*currentPage.scale/currentPage.proportion : 0,\n                                                    \'bottom\': (level.imagebox.border && level.imagebox.border.type == \'Pic\') ? -imageboxWEdge(level.imagebox,\'bottom\')*currentPage.scale/currentPage.proportion : 0,\n                                                    \'background-image\': (level.imagebox.border && level.imagebox.border.type == \'Pic\') ? \'url(\' + level.imagebox.border.resource.identifier + vm.pageImageView + \')\' : \'\',\n                                                    \'background-size\': (level.imagebox.border && level.imagebox.border.type == \'Pic\') ? \'100% 100%\' : \'\',\n                                                    }"></div><div data-index="{{$index}}" class="relative-view1" ng-class="{\'selected\': level.imagebox.ctrlKey || $index == template.levelI && (RightPanel==\'mask\')}" ng-style="{\n                                                    \'border-top-left-radius\':imageboxWRadius1(level.imagebox, \'lt\', currentPage.scale/currentPage.proportion),\n                                                    \'border-top-right-radius\':imageboxWRadius1(level.imagebox, \'rt\', currentPage.scale/currentPage.proportion),\n                                                    \'border-bottom-right-radius\':imageboxWRadius1(level.imagebox, \'rb\', currentPage.scale/currentPage.proportion),\n                                                    \'border-bottom-left-radius\':imageboxWRadius1(level.imagebox, \'lb\', currentPage.scale/currentPage.proportion),\n                                                    \'-webkit-mask-image\': level.imagebox.mask.resource.identifier ? \'url(\' + level.imagebox.mask.resource.identifier + \')\' : \'none\',\n                                                    \'-webkit-mask-size\': \'100% 100%\'\n                                                    }"><div ng-if="!level.imagebox.image&&!level.imagebox.image.resource.identifier" data-index="{{$index}}" class="image-placeholder"><img src="content/images/icons/camera.svg" alt="" srcset="" data-index="{{$index}}" ng-style="{\'width\':imageboxW(level.imagebox)*currentPage.scale/currentPage.proportion < 56 ? \'50%\' : \'\' , \'height\':imageboxH(level.imagebox)*currentPage.scale/currentPage.proportion < 56 ? \'50%\' : \'\'}"> <span ng-if="imageboxW(level.imagebox)*currentPage.scale/currentPage.proportion > 60 && imageboxH(level.imagebox)*currentPage.scale/currentPage.proportion > 80" data-index="{{$index}}">\u62D6\u5165\u76F8\u7247</span></div><img data-index="{{$index}}" ng-if="level.imagebox.image&&level.imagebox.image.resource.identifier" class="img-holder mask" style="position: absolute" ng-style="{\n                                                    width: level.imagebox.image.width*currentPage.scale/currentPage.proportion * level.imagebox.image.scale,\n                                                    height: level.imagebox.image.height*currentPage.scale/currentPage.proportion * level.imagebox.image.scale,\n                                                    left: level.imagebox.image.offsetx*currentPage.scale/currentPage.proportion * level.imagebox.image.scale,\n                                                    top: level.imagebox.image.offsety*currentPage.scale/currentPage.proportion * level.imagebox.image.scale\n                                                 }" ng-src="{{level.imagebox.image.resource.identifier+vm.pageImageViewOrient}}"><div class="iconWarn1" ng-if="level.imagebox.lowAccuracy || level.imagebox.lowAccuracyMask"><img src="content/images/icon/icon-breezing-xk.png" alt="" ng-if="level.imagebox.lowAccuracyMask && !level.imagebox.lowAccuracy"> <img src="content/images/icon/icon-breezing-tp.png" alt="" ng-if="level.imagebox.lowAccuracy"></div></div></div><span class="sel-top" data-index="{{$index}}" ng-style="{\'cursor\': cursor(level.imagebox.rotation.angle, \'left\', false)}" ng-mousedown="resizeStartLeft($event,level.imagebox,currentPage.scale/currentPage.proportion, $index)" ng-if="$index == template.levelI && (RightPanel==\'mask\')&&!level.imagebox.ctrlKey&&!level.imagebox.lock"></span> <span class="sel-right-lock" ng-mousedown="locking($event)" ng-if="$index == template.levelI && (RightPanel==\'mask\')&&!level.imagebox.ctrlKey && level.imagebox.lock"><i class="iconfont icon-jiesuo"></i> </span><span class="sel-right" data-index="{{$index}}" ng-style="{\'cursor\': cursor(level.imagebox.rotation.angle, \'top\', false)}" ng-mousedown="resizeStartTop($event, level.imagebox,currentPage.scale/currentPage.proportion, $index)" ng-if="$index == template.levelI && (RightPanel==\'mask\')&&!level.imagebox.ctrlKey&&!level.imagebox.lock"></span> <span class="sel-bottom" data-index="{{$index}}" ng-style="{\'cursor\': cursor(level.imagebox.rotation.angle, \'right\', false)}" ng-mousedown="resizeStartRigth($event, level.imagebox,currentPage.scale/currentPage.proportion, $index)" ng-if="$index == template.levelI && (RightPanel==\'mask\')&&!level.imagebox.ctrlKey&&!level.imagebox.lock"></span> <span class="sel-left" data-index="{{$index}}" ng-style="{\'cursor\': cursor(level.imagebox.rotation.angle, \'bottom\', false)}" ng-mousedown="resizeStartBottom($event,level.imagebox,currentPage.scale/currentPage.proportion, $index)" ng-if="$index == template.levelI && (RightPanel==\'mask\')&&!level.imagebox.ctrlKey&&!level.imagebox.lock"></span> <span class="sel-left1" data-index="{{$index}}" ng-style="{\'cursor\': cursor(level.imagebox.rotation.angle, \'left1\', false)}" ng-mousedown="resizeStartLeft1($event,level.imagebox,currentPage.scale/currentPage.proportion, $index)" ng-if="$index == template.levelI && (RightPanel==\'mask\')&&!level.imagebox.ctrlKey&&!level.imagebox.lock"></span> <span class="sel-top1" data-index="{{$index}}" ng-style="{\'cursor\': cursor(level.imagebox.rotation.angle, \'top1\', false)}" ng-mousedown="resizeStartTop1($event,level.imagebox,currentPage.scale/currentPage.proportion, $index)" ng-if="$index == template.levelI && (RightPanel==\'mask\')&&!level.imagebox.ctrlKey&&!level.imagebox.lock"></span> <span class="sel-right1" data-index="{{$index}}" ng-style="{\'cursor\': cursor(level.imagebox.rotation.angle, \'right1\', false)}" ng-mousedown="resizeStartRight1($event,level.imagebox,currentPage.scale/currentPage.proportion, $index)" ng-if="$index == template.levelI && (RightPanel==\'mask\')&&!level.imagebox.ctrlKey&&!level.imagebox.lock"></span> <span class="sel-bottom1" data-index="{{$index}}" ng-style="{\'cursor\': cursor(level.imagebox.rotation.angle, \'bottom1\', false)}" ng-mousedown="resizeStartBottom1($event,level.imagebox,currentPage.scale/currentPage.proportion, $index)" ng-if="$index == template.levelI && (RightPanel==\'mask\')&&!level.imagebox.ctrlKey&&!level.imagebox.lock"></span><div class="rotate-box" ng-if="$index == template.levelI && (RightPanel==\'mask\')&&!level.imagebox.ctrlKey&&!level.imagebox.lock" ng-style="{width:level.imagebox.geometry.width*currentPage.scale/currentPage.proportion-20}"><span class="rotate-line"></span><br><span class="rotate-icon rotate-icon{{$index}}" data-index="{{$index}}" ng-mousedown="rotateBoxStart($event,level.imagebox,$index)"></span></div></div><div id="art" data-index="{{$index}}" class="img-art img-art{{template.pageI}}{{$index}}" ondblclick="doubleClickClipart(event)" ng-show="level.imageart&&level.imageart.current" ng-style="{\n                                                    width: level.imageart.geometry.width*currentPage.scale/currentPage.proportion,\n                                                    height: level.imageart.geometry.height*currentPage.scale/currentPage.proportion,\n                                                    left: level.imageart.geometry.x*currentPage.scale/currentPage.proportion,\n                                                    top: level.imageart.geometry.y*currentPage.scale/currentPage.proportion,\n                                                    \'z-index\':level.seq-0+200,\n                                                    \'transform\': \'rotate(\' + level.imageart.rotation.angle + \'deg)\',\n                                                    \'opacity\': opacityElement(currentPage.mediabox, level.imageart.geometry)}" ng-click="selectArt($event, $index, level.imageart)" ng-class="{\'selected\': level.imageart.ctrlKey || $index == template.levelI && RightPanel==\'material\'}"><div style="overflow: hidden; position: relative; width: 100%; height: 100%"><img data-index="{{$index}}" id="art-img{{$index}}" class="c-xml-page-material-img" ng-mousedown="moveBoxStart($event,level.imageart,$index)" style="transition: opacity 0.3s;position: absolute" ng-style="{\n                                                        \'opacity\':level.imageart.transparency,\n                                                        filter: \'alpha(opacity=\'+level.imageart.transparency*100+\')\',\n                                                        \'left\': level.imageart.offsetx *currentPage.scale/currentPage.proportion,\n                                                        \'top\': level.imageart.offsety *currentPage.scale/currentPage.proportion,\n                                                        \'width\': level.imageart.geometry.width *currentPage.scale/currentPage.proportion * level.imageart.scale\n                                                     }" ng-src="{{level.imageart.resource.identifier + vm.pageImageView}}"><div class="iconWarn1" ng-if="level.imageart.lowAccuracy"><img src="content/images/icon/icon-breezing-sc.png" alt=""></div></div><div ng-if="$index == template.levelI && RightPanel == \'material\'&&!level.imageart.ctrlKey"><span class="sel-left" ng-style="{\'cursor\': cursor(level.imageart.rotation.angle, \'bottom\', true)}" ng-mousedown="imageartdownZoomBottom($event,level.imageart, currentPage.scale/currentPage.proportion)" ng-if="!level.imageart.lock"></span> <span class="sel-top" ng-style="{\'cursor\': cursor(level.imageart.rotation.angle, \'left\', true)}" ng-mousedown="imageartdownZoomLeft($event,level.imageart, currentPage.scale/currentPage.proportion)" ng-if="!level.imageart.lock"></span> <span class="sel-right-lock" ng-mousedown="locking($event)" ng-if="level.imageart.lock"><i class="iconfont icon-jiesuo"></i> </span><span class="sel-right" ng-style="{\'cursor\': cursor(level.imageart.rotation.angle, \'top\', true)}" ng-mousedown="imageartdownZoomTop($event,level.imageart, currentPage.scale/currentPage.proportion)" ng-if="!level.imageart.lock"></span> <span class="sel-bottom" ng-style="{\'cursor\': cursor(level.imageart.rotation.angle, \'right\', true)}" ng-mousedown="imageartdownZoomRight($event,level.imageart, currentPage.scale/currentPage.proportion)" ng-if="!level.imageart.lock"></span><div class="c-xml-page-material-rotate1" ng-if="!level.imageart.lock"><span class="c-xml-page-material-rotate-icon" ng-mousedown="rotateBoxStart($event,level.imageart,$index)"></span></div></div></div><div class="c-xml-page-textboxe textbox{{template.pageI}}{{$index}}" ng-show="level.textbox.current" ng-click="selectText($event, $index, level.textbox)" style="white-space: normal" ng-class="{\'selected\': level.textbox.ctrlKey || $index == template.levelI && RightPanel == \'text\'}" ng-style="{\n                                                \'z-index\':level.seq-0+200,\n                                                \'width\': level.textbox.geometry.width * currentPage.scale/currentPage.proportion,\n                                                \'height\': level.textbox.geometry.height * currentPage.scale/currentPage.proportion,\n                                                \'left\': level.textbox.geometry.x * currentPage.scale/currentPage.proportion,\n                                                \'top\': level.textbox.geometry.y * currentPage.scale/currentPage.proportion,\n                                                \'transform\': \'rotate(\' + level.textbox.rotation.angle + \'deg)\',\n                                                \'opacity\': opacityElement(currentPage.mediabox, level.textbox.geometry)\n                                             }"><pre class="c-xml-page-textboxe-text web-font" ng-dblclick="doubleClicktext($event, level.textbox, $index)" ng-mousedown="moveBoxStart($event,level.textbox,$index)" style="overflow: hidden" data-index="{{$index}}" ng-style="{\n                                                        \'font-family\': \'\\\'\' + level.textbox.fontuuid + \'\\\'\',\n                                                        \'font-size\': (level.textbox.style.size*currentPage.scale/currentPage.proportion > 12 ? level.textbox.style.size* currentPage.scale/currentPage.proportion : 12) + \'pt\',\n                                                        \'color\': level.textbox.style.color,\n                                                        \'font-weight\': level.textbox.style.bold ? \'bold\': \'400\',\n                                                        \'font-style\': level.textbox.style.italic ? \'italic\': \'initial\',\n                                                        \'line-height\': (level.textbox.style.size * currentPage.scale/currentPage.proportion > 12 ? level.textbox.style.lineheight * currentPage.scale/currentPage.proportion : (level.textbox.style.lineheight * currentPage.scale/currentPage.proportion) / (1 / 12 * level.textbox.style.size * currentPage.scale/currentPage.proportion)) + \'pt\',\n                                                        \'letter-spacing\': (level.textbox.style.size * currentPage.scale/currentPage.proportion > 12 ? level.textbox.style.letterspacing * currentPage.scale/currentPage.proportion : (level.textbox.style.letterspacing * currentPage.scale/currentPage.proportion) / (1 / 12 * level.textbox.style.size * currentPage.scale/currentPage.proportion)) + \'pt\',\n                                                        \'opacity\': level.textbox.transparency,\n                                                        \'text-decoration\': \'none\',\n                                                        \'text-align\': level.textbox.style.align,\n                                                        \'text-align-last\': \'unset\',\n                                                        \'transform\':\'scale(\'+(1 / 12 * level.textbox.style.size* currentPage.scale/currentPage.proportion > 1 ? 1 : 1 / 12 * level.textbox.style.size* currentPage.scale/currentPage.proportion)+\')\',\n                                                        \'transform-origin\': \'0 0\',\n                                                        \'writing-mode\': level.textbox.style.writingmode,\n                                                         \'width\': level.textbox.style.size * currentPage.scale/currentPage.proportion > 12 ? level.textbox.geometry.width * currentPage.scale/currentPage.proportion : (level.textbox.geometry.width * currentPage.scale/currentPage.proportion) / (1 / 12 * level.textbox.style.size * currentPage.scale/currentPage.proportion) + \'px\',\n                                                         \'height\': level.textbox.style.size * currentPage.scale/currentPage.proportion > 12 ? level.textbox.geometry.height * currentPage.scale/currentPage.proportion : (level.textbox.geometry.height * currentPage.scale/currentPage.proportion) / (1 / 12 * level.textbox.style.size * currentPage.scale/currentPage.proportion) + \'px\',\n                                                    }"><span class="c-xml-page-textboxe-span" ng-blur="textBlur($event,level.textbox)" ng-keyup="changeHeight($event,level.textbox)">{{level.textbox.text}}</span></pre><!--                                            <span class="sel-bottom" data-index="{{$index}}"--><!--                                                  onmousedown="resizeTextStart(event)"--><!--                                                  ng-if="$index == template.levelI && RightPanel == \'text\'&&!level.textbox.ctrlKey"></span>--> <span class="c-xml-page-material-zoom c-xml-page-material-zoom-left" style="display: block" ng-style="{\'cursor\': cursor(level.textbox.rotation.angle, \'left1\', true)}" ng-if="$index == template.levelI && RightPanel == \'text\'&&!level.textbox.ctrlKey && !writingmodeInit(level.textbox.style.writingmode)&&!level.textbox.lock&&!vm.textEditor" ng-mousedown="textboxZoomLeft($event,level.textbox,currentPage.scale/currentPage.proportion,$index)"></span> <span class="c-xml-page-material-zoom c-xml-page-material-zoom-right" style="display: block" ng-style="{\'cursor\': cursor(level.textbox.rotation.angle, \'right1\', true)}" ng-if="$index == template.levelI && RightPanel == \'text\'&&!level.textbox.ctrlKey && !writingmodeInit(level.textbox.style.writingmode)&&!level.textbox.lock&&!vm.textEditor" ng-mousedown="textboxZoomRight($event,level.textbox,currentPage.scale/currentPage.proportion,$index)"></span> <span class="sel-top1" ng-style="{\'cursor\': cursor(level.textbox.rotation.angle, \'top1\', true)}" ng-if="$index == template.levelI && RightPanel == \'text\'&&!level.textbox.ctrlKey && writingmodeInit(level.textbox.style.writingmode)&&!level.textbox.lock&&!vm.textEditor" ng-mousedown="textboxZoomTop($event,level.textbox,currentPage.scale/currentPage.proportion,$index)"></span> <span class="sel-bottom1" style="bottom: -13px" ng-style="{\'cursor\': cursor(level.textbox.rotation.angle, \'bottom1\', true)}" ng-if="$index == template.levelI && RightPanel == \'text\'&&!level.textbox.ctrlKey && writingmodeInit(level.textbox.style.writingmode)&&!level.textbox.lock&&!vm.textEditor" ng-mousedown="textboxZoomBottom($event,level.textbox,currentPage.scale/currentPage.proportion,$index)"></span> <span class="c-xml-page-material-zoom c-xml-page-material-zoom-left1" style="display: block" ng-style="{\'cursor\': cursor(level.textbox.rotation.angle, \'left\', true)}" ng-if="$index == template.levelI && RightPanel == \'text\'&&!level.textbox.ctrlKey&&!level.textbox.lock&&!vm.textEditor" ng-mousedown="textboxZoomLeft1($event,level.textbox,currentPage.scale/currentPage.proportion,$index)"></span> <span class="sel-right-lock" ng-mousedown="locking($event)" ng-if="$index == template.levelI && RightPanel == \'text\'&&!level.textbox.ctrlKey && level.textbox.lock&&!vm.textEditor"><i class="iconfont icon-jiesuo"></i> </span><span class="c-xml-page-material-zoom c-xml-page-material-zoom-top1" style="display: block" ng-style="{\'cursor\': cursor(level.textbox.rotation.angle, \'top\', true)}" ng-if="$index == template.levelI && RightPanel == \'text\'&&!level.textbox.ctrlKey&&!level.textbox.lock&&!vm.textEditor" ng-mousedown="textboxZoomTop1($event,level.textbox,currentPage.scale/currentPage.proportion,$index)"></span> <span class="c-xml-page-material-zoom c-xml-page-material-zoom-right1" style="display: block" ng-style="{\'cursor\': cursor(level.textbox.rotation.angle, \'right\', true)}" ng-if="$index == template.levelI && RightPanel == \'text\'&&!level.textbox.ctrlKey&&!level.textbox.lock&&!vm.textEditor" ng-mousedown="textboxZoomRight1($event,level.textbox,currentPage.scale/currentPage.proportion,$index)"></span> <span class="c-xml-page-material-zoom c-xml-page-material-zoom-bottom1" style="display: block" ng-style="{\'cursor\': cursor(level.textbox.rotation.angle, \'bottom\', true)}" ng-if="$index == template.levelI && RightPanel == \'text\'&&!level.textbox.ctrlKey&&!level.textbox.lock&&!vm.textEditor" ng-mousedown="textboxZoomBottom1($event,level.textbox,currentPage.scale/currentPage.proportion,$index)"></span><div class="rotate-box" ng-if="$index == template.levelI && RightPanel == \'text\'&&!level.textbox.ctrlKey&&!level.textbox.lock&&!vm.textEditor" ng-style="{width:level.textbox.geometry.width*currentPage.scale/currentPage.proportion-20,\n                                                 top:level.textbox.geometry.height*currentPage.scale/currentPage.proportion}"><span class="rotate-line"></span><br><span class="rotate-icon rotate-icon{{$index}}" data-index="{{$index}}" style="margin-left: 12px" ng-mousedown="rotateBoxStart($event,level.textbox,$index)"></span></div><div class="loading-font" ng-if="level.textbox.loading"></div></div><div id="textdocument" class="c-textdocument" data-index="{{$index}}" ng-show="level.textdocument.current" ng-mousedown="moveBoxStart($event,level.textdocument,levelIndex)" ng-class="{\'selected\': level.textdocument.ctrlKey || $index == template.levelI && RightPanel==\'textDoc\'}" ng-style="{\n                                                 position: \'absolute\',\n                                                width: level.textdocument.geometry.width*currentPage.scale/currentPage.proportion,\n                                                height: level.textdocument.geometry.height*currentPage.scale/currentPage.proportion,\n                                                left: level.textdocument.geometry.x*currentPage.scale/currentPage.proportion,\n                                                top: level.textdocument.geometry.y*currentPage.scale/currentPage.proportion,\n                                                \'z-index\':level.seq-0+200,\n                                                \'opacity\': opacityElement(currentPage.mediabox, level.textdocument.geometry),\n                                                filter: \'alpha(opacity=\'+level.textdocument.transparency*100+\')\',\n                                                \'transform\': \'rotate(-\' + level.textdocument.rotation.angle + \'deg)\'}" ng-click="selectDoc($event, $index, level.textdocument)"><div style="overflow: hidden;width: 100%;height: 100%;position: relative" ng-style="{\'opacity\':level.textdocument.transparency.toFixed(2)}"><img class="bg-image bg-image{{template.pageI}} pos no-events" ng-cloak ng-if="level.textdocument.background.resource.identifier" ng-src="{{level.textdocument.background.resource.identifier + vm.pageImageView||\'//:0\'}}" ng-style="{\n                                                 position: \'absolute\',\n                                                 left:level.textdocument.background.offsetx*currentPage.scale/currentPage.proportion,\n                                                 top:level.textdocument.background.offsety*currentPage.scale/currentPage.proportion,\n                                                 width: level.textdocument.background.adaptation==\'Width\'?level.textdocument.geometry.width*currentPage.scale/currentPage.proportion:\'\',\n                                                 height:level.textdocument.background.adaptation!=\'Width\'?level.textdocument.geometry.height*currentPage.scale/currentPage.proportion:\'\'}"><div ng-repeat="docLevel in level.textdocument.levels.level track by $index" ng-init="docIndex = $index" style="position: relative"><div data-index="{{docIndex}}" class="img-art no-events" ng-show="docLevel.imageart" ng-style="{\n                                                            width: docLevel.imageart.geometry.width*currentPage.scale/currentPage.proportion,\n                                                            height: docLevel.imageart.geometry.height*currentPage.scale/currentPage.proportion,\n                                                            left: docLevel.imageart.geometry.x*currentPage.scale/currentPage.proportion,\n                                                            top: docLevel.imageart.geometry.y*currentPage.scale/currentPage.proportion,\n                                                            \'z-index\':docLevel.seq-0+200,\n                                                            \'opacity\':docLevel.imageart.transparency,\n                                                            filter: \'alpha(opacity=\'+docLevel.imageart.transparency*100+\')\',\n                                                            \'transform\': \'rotate(\' + docLevel.imageart.rotation.angle + \'deg)\'}"><div style="overflow: hidden; position: relative; width: 100%; height: 100%"><img data-index="{{$index}}" style="transition: opacity 0.3s;position: absolute" ng-style="{\n                                                                \'left\': docLevel.imageart.offsetx *currentPage.scale/currentPage.proportion,\n                                                                \'top\': docLevel.imageart.offsety *currentPage.scale/currentPage.proportion,\n                                                                \'width\': docLevel.imageart.geometry.width * currentPage.scale/currentPage.proportion * docLevel.imageart.scale}" ng-src="{{docLevel.imageart.resource.identifier + vm.pageImageView}}"></div></div><div class="c-xml-page-textboxe textbox{{template.pageI}}{{levelIndex}}{{docIndex}}" ng-show="docLevel.textbox" style="white-space: normal" data-index="{{docIndex}}" ng-style="{\n                                                        \'z-index\':docLevel.seq-0+200,\n                                                        \'width\': docLevel.textbox.geometry.width * currentPage.scale/currentPage.proportion,\n                                                        \'height\': docLevel.textbox.geometry.height * currentPage.scale/currentPage.proportion,\n                                                        \'left\': docLevel.textbox.geometry.x * currentPage.scale/currentPage.proportion,\n                                                        \'top\': docLevel.textbox.geometry.y * currentPage.scale/currentPage.proportion,\n                                                        \'transform\': \'rotate(\' + docLevel.textbox.rotation.angle + \'deg)\'}"><div style="width: 100%;height: 100%;position: absolute;top:0;left: 0"><pre class="c-xml-page-textboxe-text web-font" ng-style="{\n                                                                    \'font-family\': \'\\\'\' + docLevel.textbox.fontuuid + \'\\\'\',\n                                                                    \'font-size\': (docLevel.textbox.style.size*currentPage.scale/currentPage.proportion > 12 ? docLevel.textbox.style.size* currentPage.scale/currentPage.proportion : 12) + \'pt\',\n                                                                    \'color\': docLevel.textbox.style.color,\n                                                                    \'font-weight\': docLevel.textbox.style.bold ? \'bold\': \'400\',\n                                                                    \'font-style\': docLevel.textbox.style.italic ? \'italic\': \'initial\',\n                                                                    \'line-height\': (docLevel.textbox.style.size * currentPage.scale/currentPage.proportion > 12 ? docLevel.textbox.style.lineheight * currentPage.scale/currentPage.proportion : (docLevel.textbox.style.lineheight * currentPage.scale/currentPage.proportion) / (1 / 12 * docLevel.textbox.style.size * currentPage.scale/currentPage.proportion)) + \'pt\',\n                                                                    \'letter-spacing\': (docLevel.textbox.style.size * currentPage.scale/currentPage.proportion > 12 ? docLevel.textbox.style.letterspacing * currentPage.scale/currentPage.proportion : (docLevel.textbox.style.letterspacing * currentPage.scale/currentPage.proportion) / (1 / 12 * docLevel.textbox.style.size * currentPage.scale/currentPage.proportion)) + \'pt\',\n                                                                    \'opacity\': docLevel.textbox.transparency,\n                                                                    \'text-decoration\': \'none\',\n                                                                    \'text-align\': docLevel.textbox.style.align,\n                                                                    \'text-align-last\': \'unset\',\n                                                                    \'transform\':\'scale(\'+(1 / 12 * docLevel.textbox.style.size* currentPage.scale/currentPage.proportion > 1 ? 1 : 1 / 12 * docLevel.textbox.style.size* currentPage.scale/currentPage.proportion)+\')\',\n                                                                    \'transform-origin\': \'0 0\',\n                                                                    \'writing-mode\': docLevel.textbox.style.writingmode,\n                                                                     \'width\': docLevel.textbox.style.size * currentPage.scale/currentPage.proportion > 12 ? docLevel.textbox.geometry.width * currentPage.scale/currentPage.proportion : (docLevel.textbox.geometry.width * currentPage.scale/currentPage.proportion) / (1 / 12 * docLevel.textbox.style.size * currentPage.scale/currentPage.proportion) + \'px\',\n                                                                     \'height\': docLevel.textbox.style.size * currentPage.scale/currentPage.proportion > 12 ? docLevel.textbox.geometry.height * currentPage.scale/currentPage.proportion : (docLevel.textbox.geometry.height * currentPage.scale/currentPage.proportion) / (1 / 12 * docLevel.textbox.style.size * currentPage.scale/currentPage.proportion) + \'px\',\n                                                                }"><span class="c-xml-page-textboxe-span">{{docLevel.textbox.text}}</span></pre></div></div></div></div><span class="sel-right-lock" ng-mousedown="locking($event)" ng-if="$index == template.levelI&& (RightPanel==\'textDoc\')&&!level.textdocument.ctrlKey && level.textdocument.lock"><i class="iconfont icon-jiesuo"></i> </span><span class="sel-bottom" data-index="{{$index}}" onmousedown="resizeDocStart(event)" ng-if="$index == template.levelI&& (RightPanel==\'textDoc\')&&!level.textdocument.ctrlKey&&!level.textdocument.lock"></span><!--<span class="sel-left" data-index="{{$index}}"--><!--ng-if="$index == template.levelI && (RightPanel==\'mask\')&&!img.ctrlKey"></span>--><div class="rotate-box" ng-if="$index == template.levelI && (RightPanel==\'textDoc\')&&!level.textdocument.lock" ng-style="{\n                                                 width:level.textdocument.geometry.width*currentPage.scale/currentPage.proportion-20,\n                                                 bottom:\'-49px\' }"><span class="rotate-line"></span><br><span class="rotate-icon rotate-icon{{$index}}" data-index="{{$index}}" ng-mousedown="rotateBoxStart($event,level.textdocument,$index)"></span></div></div><div class="pos-abso" ng-if="level.calMonthBox&&level.calMonthBox.current" ng-style="{\n                                                    width: level.calMonthBox.geometry.width*currentPage.scale/currentPage.proportion,\n                                                    height: level.calMonthBox.geometry.height*currentPage.scale/currentPage.proportion,\n                                                    left: level.calMonthBox.geometry.x*currentPage.scale/currentPage.proportion,\n                                                    top: level.calMonthBox.geometry.y*currentPage.scale/currentPage.proportion,\n                                                    \'z-index\':level.seq-0+200,\n                                                    \'transform\': \'rotate(\' + level.calMonthBox.rotation.angle + \'deg)\',\n                                                    \'opacity\': opacityElement(currentPage.mediabox, level.calMonthBox.geometry)}" ng-click="selectCalMonthBox($event, $index, level.calMonthBox)" ng-mousedown="moveBoxStart($event,level.calMonthBox,$index)" ng-class="{\'selected\': level.calMonthBox.ctrlKey || $index == template.levelI && RightPanel==\'calMonthBox\'}"><div style="width: 100%; height: 100%"><month-table widget="level.calMonthBox" scale="currentPage.scale/currentPage.proportion" year="level.calMonthBox.sampleYear" month="level.calMonthBox.sampleMonth" week="level.calMonthBox.startOfWeek" width="level.calMonthBox.geometry.width" height="level.calMonthBox.geometry.height" update="level.calMonthBox.update"></month-table></div><div ng-if="$index == template.levelI && RightPanel == \'calMonthBox\'&&!level.calMonthBox.ctrlKey"><span class="sel-left" ng-style="{\'cursor\': cursor(level.calMonthBox.rotation.angle, \'bottom\', true)}" ng-mousedown="imageartdownZoomBottom($event,level.calMonthBox, currentPage.scale/currentPage.proportion)" ng-if="!level.calMonthBox.lock"></span> <span class="sel-top" ng-style="{\'cursor\': cursor(level.calMonthBox.rotation.angle, \'left\', true)}" ng-mousedown="imageartdownZoomLeft($event,level.calMonthBox, currentPage.scale/currentPage.proportion)" ng-if="!level.calMonthBox.lock"></span> <span class="sel-right-lock" ng-mousedown="locking($event)" ng-if="level.calMonthBox.lock"><i class="iconfont icon-jiesuo"></i> </span><span class="sel-right" ng-style="{\'cursor\': cursor(level.calMonthBox.rotation.angle, \'top\', true)}" ng-mousedown="imageartdownZoomTop($event,level.calMonthBox, currentPage.scale/currentPage.proportion)" ng-if="!level.calMonthBox.lock"></span> <span class="sel-bottom" ng-style="{\'cursor\': cursor(level.calMonthBox.rotation.angle, \'right\', true)}" ng-mousedown="imageartdownZoomRight($event,level.calMonthBox, currentPage.scale/currentPage.proportion)" ng-if="!level.calMonthBox.lock"></span><!--                                <div class="c-xml-page-material-rotate1"--><!--                                     ng-if="!level.calMonthBox.lock">--><!--                                                <span class="c-xml-page-material-rotate-icon"--><!--                                                      ng-mousedown="rotateBoxStart($event,level.calMonthBox,$index)"></span>--><!--                                </div>--></div></div><div class="pos-abso" ng-if="level.calTitleBox&&level.calTitleBox.current" ng-style="{\n                                                    width: level.calTitleBox.geometry.width*currentPage.scale/currentPage.proportion,\n                                                    height: level.calTitleBox.geometry.height*currentPage.scale/currentPage.proportion,\n                                                    left: level.calTitleBox.geometry.x*currentPage.scale/currentPage.proportion,\n                                                    top: level.calTitleBox.geometry.y*currentPage.scale/currentPage.proportion,\n                                                    \'z-index\':level.seq-0+200,\n                                                    \'transform\': \'rotate(\' + level.calTitleBox.rotation.angle + \'deg)\',\n                                                    \'opacity\': opacityElement(currentPage.mediabox, level.calTitleBox.geometry)}" ng-click="selectCalTitleBox($event, $index, level.calTitleBox)" ng-mousedown="moveBoxStart($event,level.calTitleBox,$index)" ng-class="{\'selected\': level.calTitleBox.ctrlKey || $index == template.levelI && RightPanel==\'calTitleBox\'}"><div style="width: 100%; height: 100%; overflow: hidden"><title-cell ng-if="level.calTitleBox.settings" width="level.calTitleBox.geometry.width" height="level.calTitleBox.geometry.height" scale="currentPage.scale/currentPage.proportion" year="level.calTitleBox.sampleYear" month="level.calTitleBox.sampleMonth" widget="level.calTitleBox"></title-cell></div><div ng-if="$index == template.levelI && RightPanel == \'calTitleBox\'&&!level.calTitleBox.ctrlKey"><span class="sel-left" ng-style="{\'cursor\': cursor(level.calTitleBox.rotation.angle, \'bottom\', true)}" ng-mousedown="imageartdownZoomBottom($event,level.calTitleBox, currentPage.scale/currentPage.proportion)" ng-if="!level.calTitleBox.lock"></span> <span class="sel-top" ng-style="{\'cursor\': cursor(level.calTitleBox.rotation.angle, \'left\', true)}" ng-mousedown="imageartdownZoomLeft($event,level.calTitleBox, currentPage.scale/currentPage.proportion)" ng-if="!level.calTitleBox.lock"></span> <span class="sel-right-lock" ng-mousedown="locking($event)" ng-if="level.calTitleBox.lock"><i class="iconfont icon-jiesuo"></i> </span><span class="sel-right" ng-style="{\'cursor\': cursor(level.calTitleBox.rotation.angle, \'top\', true)}" ng-mousedown="imageartdownZoomTop($event,level.calTitleBox, currentPage.scale/currentPage.proportion)" ng-if="!level.calTitleBox.lock"></span> <span class="sel-bottom" ng-style="{\'cursor\': cursor(level.calTitleBox.rotation.angle, \'right\', true)}" ng-mousedown="imageartdownZoomRight($event,level.calTitleBox, currentPage.scale/currentPage.proportion)" ng-if="!level.calTitleBox.lock"></span><!--                                <div class="c-xml-page-material-rotate1"--><!--                                     ng-if="!level.calTitleBox.lock">--><!--                                                <span class="c-xml-page-material-rotate-icon"--><!--                                                      ng-mousedown="rotateBoxStart($event,level.calTitleBox,$index)"></span>--><!--                                </div>--></div></div></div><div class="barcode cursorPointer" id="barcode{{template.pageI}}" ng-click="selectBar($event,currentPage, \'barcode\')" ng-class="{\'selected\': RightPanel == \'barcode\'}" onmousedown="moveBarcodeStart(event)" readonly="readonly" ng-show="currentPage.barcode&&currentPage.barcode.geometry && !currentPage.barcode.isHidden" ng-style="{\n                                                             \'line-height\':\'0\',\n                                                             top: currentPage.barcode.geometry.y*currentPage.scale/currentPage.proportion,\n                                                             left: currentPage.barcode.geometry.x*currentPage.scale/currentPage.proportion,\n                                                             width: currentPage.barcode.geometry.width*currentPage.scale/currentPage.proportion,\n                                                             height: currentPage.barcode.geometry.height*currentPage.scale/currentPage.proportion,\n                                                             \'z-index\': 300,\n                                                            \'transform\': \'rotate(-\' + currentPage.barcode.rotation.angle + \'deg)\'\n                                                        }"><img src="content/images/txm.png" style="width: 100%;height: 100%"></div><div class="barcode cursorPointer" id="qrcode{{template.pageI}}" ng-click="selectBar($event,currentPage, \'qrcode\')" ng-class="{\'selected\': RightPanel == \'qrcode\'}" onmousedown="moveQrcodeStart(event)" readonly="readonly" ng-show="currentPage.qrcode&&currentPage.qrcode.geometry && !currentPage.qrcode.isHidden" ng-style="{\n                                                             \'line-height\':\'0\',\n                                                             top: currentPage.qrcode.geometry.y*currentPage.scale/currentPage.proportion,\n                                                             left: currentPage.qrcode.geometry.x*currentPage.scale/currentPage.proportion,\n                                                             width: currentPage.qrcode.geometry.width*currentPage.scale/currentPage.proportion,\n                                                             height: currentPage.qrcode.geometry.height*currentPage.scale/currentPage.proportion,\n                                                             \'z-index\': 300,\n                                                            \'transform\': \'rotate(-\' + currentPage.qrcode.rotation.angle + \'deg)\'\n                                                        }"><img src="content/images/QrCode.png" style="width: 100%;height: 100%"></div><div class="border-red cursorPointer no-events" ng-show="!currentPage.outline" id="border-red" ng-repeat="editbox in currentPage.editboxes.editbox" ng-style="{\n                                                        width:editbox.width/ currentPage.proportion*currentPage.scale,\n                                                        height:editbox.height/ currentPage.proportion*currentPage.scale,\n                                                        top:editbox.y/ currentPage.proportion*currentPage.scale,\n                                                        left:editbox.x/ currentPage.proportion*currentPage.scale}"></div><div class="border-blue cursorPointer no-events" ng-show="!currentPage.outline" ng-style="{\n                                                    width:currentPage.trimbox.width*currentPage.scale/currentPage.proportion,\n                                                    height:currentPage.trimbox.height*currentPage.scale/currentPage.proportion,\n                                                    top:currentPage.trimbox.y*currentPage.scale/currentPage.proportion,\n                                                    left:currentPage.trimbox.x*currentPage.scale/currentPage.proportion}"></div><object ng-attr-data="{{currentPage.outline.cutline.resource.identifier}}" ng-if="currentPage.outline && currentPage.outline.cutline && currentPage.outline.cutline.resource && currentPage.outline.cutline.resource.identifier" type="image/svg+xml" style="width: 100%; height: 100%; pointer-events: none; position: absolute;left: 0; top: 0;z-index: 399"></object></div></div><div class="page-item" ng-show="currentPage.isScene" style="transform:translate(-50% -50%)!important;outline: none" ng-style="{\n                                     \'width\': (currentPage.scene.geometry.width)*currentPage.scale/currentPage.scene.proportion,\n                                     \'height\': (currentPage.scene.geometry.height)*currentPage.scale/currentPage.scene.proportion,\n                                     \'margin-left\':canvasCoordX((currentPage.scene.geometry.width)*currentPage.scale/currentPage.scene.proportion),\n                                     \'margin-top\':canvasCoordY((currentPage.scene.geometry.height)*currentPage.scale/currentPage.scene.proportion),\n                                    }"><div style="width: 100%; height: 100%; position: relative"><div class="content-container" id="content" ng-click="clearCtrlKey(1)" ng-style="{\n                                            \'position\': \'absolute\',\n                                            \'width\': (currentPage.scene.geometry.width)*currentPage.scale/currentPage.scene.proportion,\n                                            \'height\': (currentPage.scene.geometry.height)*currentPage.scale/currentPage.scene.proportion,\n                                            \'z-index\': currentPage.scene.hierarchy == \'TOP\' ? \'1\' : \'0\',\n                                            \'pointer-events\': \'none\'\n                                        }"><div style="width: 100%; height: 100%; overflow: hidden"><img class="bg-image bg-image{{template.pageI}}" ng-cloak ng-show="currentPage.scene.background.resource.identifier" ng-src="{{currentPage.scene.background.resource.identifier + vm.pageImageView||\'//:0\'}}" ng-style="{width: currentPage.scene.background.resource.identifier?currentPage.scene.geometry.width*currentPage.scale/currentPage.scene.proportion:0}"></div><div ng-style="{\n                                                    position: \'absolute\',\n                                                    width: currentPage.scene.imagebox.geometry.width*currentPage.scale/currentPage.scene.proportion,\n                                                    height: currentPage.scene.imagebox.geometry.height*currentPage.scale/currentPage.scene.proportion,\n                                                    left: currentPage.scene.imagebox.geometry.x*currentPage.scale/currentPage.scene.proportion,\n                                                    top: currentPage.scene.imagebox.geometry.y*currentPage.scale/currentPage.scene.proportion,\n                                                    \'z-index\':$index,\n                                                    \'transform\': \'rotate(-\' + currentPage.scene.imagebox.rotation.angle + \'deg)\'}" ng-show="currentPage.scene.imagebox"></div></div><div class="editing1" ng-dblclick="selectSceneImgDblclick($event)" ng-class="{\'custom-grid\':currentPage.background.type==\'Color\'&&!currentPage.background.color}" ng-style="{\n                                         \'position\': \'absolute\',\n                                         \'background\':currentPage.background.color ? currentPage.background.color : \'none\',\n                                         \'width\': currentPage.mediabox.width*currentPage.scale/currentPage.scene.proportion,\n                                         \'height\': currentPage.mediabox.height*currentPage.scale/currentPage.scene.proportion,\n                                         \'left\':currentPage.scene.imagebox.geometry.x*currentPage.scale/currentPage.scene.proportion,\n                                         \'top\':currentPage.scene.imagebox.geometry.y*currentPage.scale/currentPage.scene.proportion,\n                                         \'z-index\': currentPage.scene.hierarchy == \'TOP\' ? 0 : 1,\n                                         }" style="border: 1px solid #299DFF"><div style="position: relative; width: 100%; height: 100%; overflow: hidden"><img class="bg-image bg-image{{template.pageI}} pos" ng-cloak ng-if="currentPage.background.resource.identifier" ng-src="{{currentPage.background.resource.identifier + vm.pageImageView||\'//:0\'}}" ng-style="{\n                                                         position: \'absolute\',\n                                                         left:currentPage.background.offsetx*currentPage.scale/currentPage.scene.proportion,\n                                                         top:currentPage.background.offsety*currentPage.scale/currentPage.scene.proportion,\n                                                         width: currentPage.background.adaptation==\'Width\'?currentPage.background.width*currentPage.scale/currentPage.scene.proportion:\'\',\n                                                         height:currentPage.background.adaptation==\'Height\'?currentPage.background.height*currentPage.scale/currentPage.scene.proportion:\'\'}"><div class="iconWarn1" ng-if="currentPage.lowAccuracy"><img src="content/images/icon/icon-breezing-bj.png" alt=""></div></div><div ng-repeat="level in currentPage.levels.level track by $index" class="wh100" ng-if="!level.isHidden"><div data-index="{{$index}}" class="imgBox" ng-show="level.imagebox.current" ng-class="{\'selected\': level.imagebox.ctrlKey || $index == template.levelI && (RightPanel==\'mask\')}" ng-style="{\n                                                            width: imageboxW(level.imagebox)*currentPage.scale/currentPage.scene.proportion,\n                                                            height: imageboxH(level.imagebox)*currentPage.scale/currentPage.scene.proportion,\n                                                            left: imageboxL(level.imagebox)*currentPage.scale/currentPage.scene.proportion,\n                                                            top: imageboxT(level.imagebox)*currentPage.scale/currentPage.scene.proportion,\n                                                            \'z-index\':level.seq-0+200,\n                                                            \'line-height\':\'0\',\n                                                            \'transform\': \'rotate(-\' + level.imagebox.rotation.angle + \'deg)\',\n                                                            \'opacity\': opacityElement(currentPage.mediabox, level.imagebox.geometry)}" ng-click="selectImg($event, $index, level.imagebox)"><div class="relative-view1" data-index="{{$index}}" ng-mousedown="moveBoxStart1($event,level.imagebox,$index)" ng-style="{\n                                                     \'overflow\': (level.imagebox.border && level.imagebox.border.type == \'Pic\') ? \'unset\' : \'hidden\',\n                                                    \'border-top-left-radius\':(level.imagebox.border && level.imagebox.border.type == \'Pic\') ? 0 : imageboxWRadius(level.imagebox, \'lt\', currentPage.scale/currentPage.scene.proportion),\n                                                    \'border-top-right-radius\':(level.imagebox.border && level.imagebox.border.type == \'Pic\') ? 0 : imageboxWRadius(level.imagebox, \'rt\', currentPage.scale/currentPage.scene.proportion),\n                                                    \'border-bottom-right-radius\':(level.imagebox.border && level.imagebox.border.type == \'Pic\') ? 0 : imageboxWRadius(level.imagebox, \'rb\', currentPage.scale/currentPage.scene.proportion),\n                                                    \'border-bottom-left-radius\':(level.imagebox.border && level.imagebox.border.type == \'Pic\') ? 0 : imageboxWRadius(level.imagebox, \'lb\', currentPage.scale/currentPage.scene.proportion),\n                                                    \'border-width\': (level.imagebox.border && level.imagebox.border.type == \'Color\') ? ((level.imagebox.border.lineWidth*currentPage.scale/currentPage.scene.proportion) | number:0) : \'\',\n                                                    \'border-style\': (level.imagebox.border && level.imagebox.border.type == \'Color\' && level.imagebox.border.lineType == \'solid\') ? \'solid\' : (level.imagebox.border && level.imagebox.border.type == \'Color\' && level.imagebox.border.lineType == \'dashed\') ? \'dashed\' : (level.imagebox.border && level.imagebox.border.type == \'Color\' && level.imagebox.border.lineType == \'dotted\') ? \'dotted\' : \'none\',\n                                                    \'border-color\': (level.imagebox.border && level.imagebox.border.type == \'Color\') ? level.imagebox.border.color : \'\',\n                                                    \'box-shadow\' : (level.imagebox.border && level.imagebox.border.type == \'Color\' && level.imagebox.border.lineWidth>0 && level.imagebox.border && level.imagebox.border.lineType == \'solid\') ? \'0 0 0 1px \' + level.imagebox.border.color + \' inset\' : \'none\',\n                                                    \'filter\' : dropShadow(level.imagebox,currentPage.scale/currentPage.scene.proportion),\n                                                    \'opacity\':(level.imagebox.border.type == \'Color\')? level.imagebox.transparency : \'\',\n                                                    }"><div ng-style="{\n                                                     \'position\': \'absolute\',\n                                                     \'z-index\':0,\n                                                    \'left\': (level.imagebox.border && level.imagebox.border.type == \'Pic\') ? -imageboxWEdge(level.imagebox,\'left\')*currentPage.scale/currentPage.scene.proportion : 0,\n                                                    \'top\': (level.imagebox.border && level.imagebox.border.type == \'Pic\') ? -imageboxWEdge(level.imagebox,\'top\')*currentPage.scale/currentPage.scene.proportion : 0,\n                                                    \'right\': (level.imagebox.border && level.imagebox.border.type == \'Pic\') ? -imageboxWEdge(level.imagebox,\'right\')*currentPage.scale/currentPage.scene.proportion : 0,\n                                                    \'bottom\': (level.imagebox.border && level.imagebox.border.type == \'Pic\') ? -imageboxWEdge(level.imagebox,\'bottom\')*currentPage.scale/currentPage.scene.proportion : 0,\n                                                    \'background-image\': (level.imagebox.border && level.imagebox.border.type == \'Pic\') ? \'url(\' + level.imagebox.border.resource.identifier + vm.pageImageView + \')\' : \'\',\n                                                    \'background-size\': (level.imagebox.border && level.imagebox.border.type == \'Pic\') ? \'100% 100%\' : \'\',\n                                                    }"></div><div data-index="{{$index}}" ng-class="{\'selected\': level.imagebox.ctrlKey || $index == template.levelI && (RightPanel==\'mask\')}" class="relative-view1" ng-style="{\n                                                        \'border-top-left-radius\':imageboxWRadius1(level.imagebox, \'lt\', currentPage.scale/currentPage.scene.proportion),\n                                                        \'border-top-right-radius\':imageboxWRadius1(level.imagebox, \'rt\', currentPage.scale/currentPage.scene.proportion),\n                                                        \'border-bottom-right-radius\':imageboxWRadius1(level.imagebox, \'rb\', currentPage.scale/currentPage.scene.proportion),\n                                                        \'border-bottom-left-radius\':imageboxWRadius1(level.imagebox, \'lb\', currentPage.scale/currentPage.scene.proportion),\n                                                        \'opacity\':(level.imagebox.border.type == \'Pic\')? level.imagebox.transparency : \'\',\n                                                        \'-webkit-mask-image\': level.imagebox.mask.resource.identifier ? \'url(\' + level.imagebox.mask.resource.identifier + \')\' : \'none\',\n                                                        \'-webkit-mask-size\': \'100% 100%\'\n                                                        }"><!-- <img data-index="{{$index}}"\n                                             ng-if="!level.imagebox.image&&!level.imagebox.image.resource.identifier"\n                                             class="img-holder mask"\n                                             style="width: 100%; height: 100%;"\n                                             src="content/images/mask_souce.png"\n                                             data-mask="content/images/centerblur.png"/> --><div ng-if="!level.imagebox.image&&!level.imagebox.image.resource.identifier" data-index="{{$index}}" class="image-placeholder"><!-- <img src="content/images/icons/camera.svg" alt="" srcset="" data-index="{{$index}}"> --> <img src="content/images/icons/camera.svg" alt="" srcset="" data-index="{{$index}}" ng-style="{\'width\':imageboxW(level.imagebox)*currentPage.scale/currentPage.scene.proportion < 56 ? \'50%\' : \'\' , \'height\':imageboxH(level.imagebox)*currentPage.scale/currentPage.scene.proportion < 56 ? \'50%\' : \'\'}"> <span ng-if="imageboxW(level.imagebox)*currentPage.scale/currentPage.scene.proportion > 60 && imageboxH(level.imagebox)*currentPage.scale/currentPage.scene.proportion > 80" data-index="{{$index}}">\u62D6\u5165\u76F8\u7247</span></div><img data-index="{{$index}}" ng-if="level.imagebox.image&&level.imagebox.image.resource.identifier" class="img-holder mask" style="position: absolute" ng-style="{\n                                                        width: level.imagebox.image.width*currentPage.scale/currentPage.scene.proportion * level.imagebox.image.scale,\n                                                        height: level.imagebox.image.height*currentPage.scale/currentPage.scene.proportion * level.imagebox.image.scale,\n                                                        left: level.imagebox.image.offsetx*currentPage.scale/currentPage.scene.proportion * level.imagebox.image.scale,\n                                                        top: level.imagebox.image.offsety*currentPage.scale/currentPage.scene.proportion * level.imagebox.image.scale\n                                                     }" ng-src="{{level.imagebox.image.resource.identifier+vm.pageImageViewOrient}}"><div class="iconWarn1" ng-if="level.imagebox.lowAccuracy || level.imagebox.lowAccuracyMask"><img src="content/images/icon/icon-breezing-xk.png" alt="" ng-if="level.imagebox.lowAccuracyMask && !level.imagebox.lowAccuracy"> <img src="content/images/icon/icon-breezing-tp.png" alt="" ng-if="level.imagebox.lowAccuracy"></div></div></div><span class="sel-top" data-index="{{$index}}" ng-style="{\'cursor\': cursor(level.imagebox.rotation.angle, \'left\', false)}" ng-mousedown="resizeStartLeft($event,level.imagebox,currentPage.scale/currentPage.scene.proportion, $index)" ng-if="$index == template.levelI && (RightPanel==\'mask\')&&!level.imagebox.ctrlKey"></span> <span class="sel-right" data-index="{{$index}}" ng-style="{\'cursor\': cursor(level.imagebox.rotation.angle, \'top\', false)}" ng-mousedown="resizeStartTop($event,level.imagebox,currentPage.scale/currentPage.scene.proportion, $index)" ng-if="$index == template.levelI && (RightPanel==\'mask\')&&!level.imagebox.ctrlKey"></span> <span class="sel-bottom" data-index="{{$index}}" ng-style="{\'cursor\': cursor(level.imagebox.rotation.angle, \'right\', false)}" ng-mousedown="resizeStartRigth($event, level.imagebox,currentPage.scale/currentPage.scene.proportion, $index)" ng-if="$index == template.levelI && (RightPanel==\'mask\')&&!level.imagebox.ctrlKey"></span> <span class="sel-left" data-index="{{$index}}" ng-style="{\'cursor\': cursor(level.imagebox.rotation.angle, \'bottom\', false)}" ng-mousedown="resizeStartBottom($event,level.imagebox,currentPage.scale/currentPage.scene.proportion, $index)" ng-if="$index == template.levelI && (RightPanel==\'mask\')&&!level.imagebox.ctrlKey"></span> <span class="sel-left1" data-index="{{$index}}" ng-style="{\'cursor\': cursor(level.imagebox.rotation.angle, \'left1\', false)}" ng-mousedown="resizeStartLeft1($event,level.imagebox,currentPage.scale/currentPage.scene.proportion, $index)" ng-if="$index == template.levelI && (RightPanel==\'mask\')&&!level.imagebox.ctrlKey"></span> <span class="sel-top1" data-index="{{$index}}" ng-style="{\'cursor\': cursor(level.imagebox.rotation.angle, \'top1\', false)}" ng-mousedown="resizeStartTop1($event,level.imagebox,currentPage.scale/currentPage.scene.proportion, $index)" ng-if="$index == template.levelI && (RightPanel==\'mask\')&&!level.imagebox.ctrlKey"></span> <span class="sel-right1" data-index="{{$index}}" ng-style="{\'cursor\': cursor(level.imagebox.rotation.angle, \'right1\', false)}" ng-mousedown="resizeStartRight1($event,level.imagebox,currentPage.scale/currentPage.scene.proportion, $index)" ng-if="$index == template.levelI && (RightPanel==\'mask\')&&!level.imagebox.ctrlKey"></span> <span class="sel-bottom1" data-index="{{$index}}" ng-style="{\'cursor\': cursor(level.imagebox.rotation.angle, \'bottom1\', false)}" ng-mousedown="resizeStartBottom1($event,level.imagebox,currentPage.scale/currentPage.scene.proportion, $index)" ng-if="$index == template.levelI && (RightPanel==\'mask\')&&!level.imagebox.ctrlKey"></span><div class="rotate-box" ng-if="$index == template.levelI && (RightPanel==\'mask\')" ng-style="{width:level.imagebox.geometry.width*currentPage.scale/currentPage.scene.proportion}"><div style="position: relative; width: 100%"><span class="rotate-line" style="position: absolute;left: 50%;margin-left: -0.5px"></span><br><span class="rotate-icon rotate-icon{{$index}}" data-index="{{$index}}" ng-mousedown="rotateBoxStart($event,level.imagebox,$index)" style="position: absolute; top: 17px; left: 50%; margin-left: -11px"></span></div></div></div><div data-index="{{$index}}" class="img-art img-art{{$index}}" ng-show="level.imageart.current" ng-style="{\n                                                            width: level.imageart.geometry.width*currentPage.scale/currentPage.scene.proportion,\n                                                            height: level.imageart.geometry.height*currentPage.scale/currentPage.scene.proportion,\n                                                            \'line-height\': level.imageart.geometry.height*currentPage.scale/currentPage.scene.proportion+\'px\',\n                                                            left: level.imageart.geometry.x*currentPage.scale/currentPage.scene.proportion,\n                                                            top: level.imageart.geometry.y*currentPage.scale/currentPage.scene.proportion,\n                                                            \'z-index\':level.seq-0+200,\n                                                            filter: \'alpha(opacity=\'+level.imageart.transparency*100+\')\',\n                                                            \'transform\': \'rotate(\' + level.imageart.rotation.angle + \'deg)\',\n                                                            \'opacity\': opacityElement(currentPage.mediabox, level.imageart.geometry)}" ng-click="selectArt($event, $index, level.imageart)" ng-class="{\'selected\': level.imageart.ctrlKey || $index == template.levelI && RightPanel==\'material\'}"><div style="overflow: hidden; position: relative; width: 100%; height: 100%" ng-style="{\'opacity\':level.imageart.transparency}"><img data-index="{{$index}}" class="c-xml-page-material-img" style="transition: opacity 0.3s;position: absolute" ng-mousedown="moveBoxStart1($event,level.imageart,$index)" ng-style="{\n                                                                \'opacity\':level.imageart.transparency,\n                                                                \'left\': level.imageart.offsetx*currentPage.scale/currentPage.scene.proportion,\n                                                                \'top\': level.imageart.offsety*currentPage.scale/currentPage.scene.proportion,\n                                                                \'width\': level.imageart.geometry.width*currentPage.scale/currentPage.scene.proportion * level.imageart.scale}" ng-src="{{level.imageart.resource.identifier + vm.pageImageView}}"><div class="iconWarn1" ng-if="level.imageart.lowAccuracy"><img src="content/images/icon/icon-breezing-sc.png" alt=""></div></div><div ng-if="$index == template.levelI && RightPanel == \'material\'&&!level.imageart.ctrlKey"><span class="sel-left" ng-style="{\'cursor\': cursor(level.imageart.rotation.angle, \'bottom\', true)}" ng-mousedown="imageartdownZoomBottom($event,level.imageart, true)"></span> <span class="sel-top" ng-style="{\'cursor\': cursor(level.imageart.rotation.angle, \'left\', true)}" ng-mousedown="imageartdownZoomLeft($event,level.imageart, true)"></span> <span class="sel-right" ng-style="{\'cursor\': cursor(level.imageart.rotation.angle, \'top\', true)}" ng-mousedown="imageartdownZoomTop($event,level.imageart, true)"></span> <span class="sel-bottom" ng-style="{\'cursor\': cursor(level.imageart.rotation.angle, \'right\', true)}" ng-mousedown="imageartdownZoomRight($event,level.imageart, currentPage.scale/currentPage.scene.proportion)"></span></div><div class="c-xml-page-material-rotate1" ng-if="$index == template.levelI && (RightPanel==\'material\')"><span class="c-xml-page-material-rotate-icon" ng-mousedown="rotateBoxStart($event,level.imageart,$index)"></span></div></div><div class="c-xml-page-textboxe textbox1{{template.pageI}}{{$index}}" ng-show="level.textbox.current" ng-click="selectText($event, $index, level.textbox)" ng-mousedown="moveBoxStart1($event,level.textbox,$index)" style="white-space: normal" ng-class="{\'selected\': level.textbox.ctrlKey || $index == template.levelI && RightPanel == \'text\'}" ng-style="{\n                                                        \'z-index\':level.seq-0+200,\n                                                        \'width\': level.textbox.geometry.width*currentPage.scale/currentPage.scene.proportion,\n                                                        \'left\': level.textbox.geometry.x*currentPage.scale/currentPage.scene.proportion,\n                                                        \'top\': level.textbox.geometry.y*currentPage.scale/currentPage.scene.proportion,\n                                                        \'height\': level.textbox.geometry.height*currentPage.scale/currentPage.scene.proportion,\n                                                        \'transform\': \'rotate(\' + level.textbox.rotation.angle + \'deg)\',\n                                                        \'opacity\': opacityElement(currentPage.mediabox, level.textbox.geometry)\n                                                     }"><div style="width: 100%;height: 100%;position: absolute;top:0;left: 0;overflow: hidden"><pre class="c-xml-page-textboxe-text web-font" ng-dblclick="doubleClicktext($event, level.textbox, $index)" data-index="{{$index}}" ng-style="{\n                                                                \'font-family\': \'\\\'\' + level.textbox.fontuuid + \'\\\'\',\n                                                                \'font-size\': (level.textbox.style.size*currentPage.scale/currentPage.scene.proportion > 12 ? level.textbox.style.size* currentPage.scale/currentPage.scene.proportion : 12) + \'pt\',\n                                                                \'color\': level.textbox.style.color,\n                                                                \'font-weight\': level.textbox.style.bold ? \'bold\': \'400\',\n                                                                \'font-style\': level.textbox.style.italic ? \'italic\': \'initial\',\n                                                                \'line-height\': (level.textbox.style.size * currentPage.scale/currentPage.scene.proportion > 12 ? level.textbox.style.lineheight * currentPage.scale/currentPage.scene.proportion : (level.textbox.style.lineheight * currentPage.scale/currentPage.scene.proportion) / (1 / 12 * level.textbox.style.size * currentPage.scale/currentPage.scene.proportion)) + \'pt\',\n                                                                \'letter-spacing\': (level.textbox.style.size * currentPage.scale/currentPage.scene.proportion > 12 ? level.textbox.style.letterspacing * currentPage.scale/currentPage.scene.proportion : (level.textbox.style.letterspacing * currentPage.scale/currentPage.scene.proportion) / (1 / 12 * level.textbox.style.size * currentPage.scale/currentPage.scene.proportion)) + \'pt\',\n                                                                \'opacity\': level.textbox.transparency,\n                                                                \'text-decoration\': \'none\',\n                                                                \'text-align\': level.textbox.style.align,\n                                                                \'text-align-last\': \'unset\',\n                                                                \'transform\':\'scale(\'+(1 / 12 * level.textbox.style.size* currentPage.scale/currentPage.scene.proportion > 1 ? 1 : 1 / 12 * level.textbox.style.size* currentPage.scale/currentPage.scene.proportion)+\')\',\n                                                                \'transform-origin\': \'0 0\',\n                                                                \'writing-mode\': level.textbox.style.writingmode,\n                                                                 \'width\': level.textbox.style.size * currentPage.scale/currentPage.scene.proportion > 12 ? level.textbox.geometry.width * currentPage.scale/currentPage.scene.proportion : (level.textbox.geometry.width * currentPage.scale/currentPage.scene.proportion) / (1 / 12 * level.textbox.style.size * currentPage.scale/currentPage.scene.proportion) + \'px\',\n                                                                 \'height\': level.textbox.style.size * currentPage.scale/currentPage.scene.proportion > 12 ? level.textbox.geometry.height * currentPage.scale/currentPage.scene.proportion : (level.textbox.geometry.height * currentPage.scale/currentPage.scene.proportion) / (1 / 12 * level.textbox.style.size * currentPage.scale/currentPage.scene.proportion) + \'px\',\n                                                            }"><span class="c-xml-page-textboxe-span" ng-blur="textBlur($event,level.textbox)" ng-keyup="changeHeight($event,level.textbox)">{{level.textbox.text}}</span></pre><div class="rotate-box" ng-if="level.textbox.ctrlKey || $index == template.levelI && RightPanel == \'text\'" ng-style="{width:level.textbox.geometry.width*currentPage.scale/currentPage.scene.proportion-20,\n                                                                    top:level.textbox.geometry.height*currentPage.scale/currentPage.scene.proportion}"><span class="rotate-line"></span><br><span class="rotate-icon rotate-icon{{$index}}" data-index="{{$index}}" style="margin-left: 12px" ng-mousedown="rotateBoxStart($event,level.textbox,$index)"></span></div><div class="loading-font" ng-if="level.textbox.loading"></div></div><span class="c-xml-page-material-zoom c-xml-page-material-zoom-left" style="display: block" ng-style="{\'cursor\': cursor(level.textbox.rotation.angle, \'left1\', true)}" ng-if="level.textbox.ctrlKey || $index == template.levelI && RightPanel == \'text\' && !writingmodeInit(level.textbox.style.writingmode)&&!level.textbox.lock&&!vm.textEditor" ng-mousedown="textboxZoomLeft($event,level.textbox,currentPage.scale/currentPage.scene.proportion,$index)"></span> <span class="c-xml-page-material-zoom c-xml-page-material-zoom-right" style="display: block" ng-style="{\'cursor\': cursor(level.textbox.rotation.angle, \'right1\', true)}" ng-if="level.textbox.ctrlKey || $index == template.levelI && RightPanel == \'text\' && !writingmodeInit(level.textbox.style.writingmode)&&!level.textbox.lock&&!vm.textEditor" ng-mousedown="textboxZoomRight($event,level.textbox,currentPage.scale/currentPage.scene.proportion,$index)"></span> <span class="sel-top1" ng-style="{\'cursor\': cursor(level.textbox.rotation.angle, \'top1\', true)}" ng-if="level.textbox.ctrlKey || $index == template.levelI && RightPanel == \'text\' && writingmodeInit(level.textbox.style.writingmode)&&!level.textbox.lock&&!vm.textEditor" ng-mousedown="textboxZoomTop($event,level.textbox,currentPage.scale/currentPage.scene.proportion,$index)"></span> <span class="sel-bottom1" style="bottom: -13px" ng-style="{\'cursor\': cursor(level.textbox.rotation.angle, \'bottom1\', true)}" ng-if="level.textbox.ctrlKey || $index == template.levelI && RightPanel == \'text\' && writingmodeInit(level.textbox.style.writingmode)&&!level.textbox.lock&&!vm.textEditor" ng-mousedown="textboxZoomBottom($event,level.textbox,currentPage.scale/currentPage.scene.proportion,$index)"></span> <span class="c-xml-page-material-zoom c-xml-page-material-zoom-left1" style="display: block" ng-style="{\'cursor\': cursor(level.textbox.rotation.angle, \'left\', true)}" ng-if="level.textbox.ctrlKey || $index == template.levelI && RightPanel == \'text\'&&!level.textbox.lock&&!vm.textEditor" ng-mousedown="textboxZoomLeft1($event,level.textbox,currentPage.scale/currentPage.scene.proportion,$index)"></span> <span class="c-xml-page-material-zoom c-xml-page-material-zoom-top1" style="display: block" ng-style="{\'cursor\': cursor(level.textbox.rotation.angle, \'top\', true)}" ng-if="level.textbox.ctrlKey || $index == template.levelI && RightPanel == \'text\'&&!level.textbox.lock&&!vm.textEditor" ng-mousedown="textboxZoomTop1($event,level.textbox,currentPage.scale/currentPage.scene.proportion,$index)"></span> <span class="c-xml-page-material-zoom c-xml-page-material-zoom-right1" style="display: block" ng-style="{\'cursor\': cursor(level.textbox.rotation.angle, \'right\', true)}" ng-if="level.textbox.ctrlKey || $index == template.levelI && RightPanel == \'text\'&&!level.textbox.lock&&!vm.textEditor" ng-mousedown="textboxZoomRight1($event,level.textbox,currentPage.scale/currentPage.scene.proportion,$index)"></span> <span class="c-xml-page-material-zoom c-xml-page-material-zoom-bottom1" style="display: block" ng-style="{\'cursor\': cursor(level.textbox.rotation.angle, \'bottom\', true)}" ng-if="level.textbox.ctrlKey || $index == template.levelI && RightPanel == \'text\'&&!level.textbox.lock&&!vm.textEditor" ng-mousedown="textboxZoomBottom1($event,level.textbox,currentPage.scale/currentPage.scene.proportion,$index)"></span><div class="rotate-box" ng-if="$index == template.levelI && RightPanel == \'text\'&&!level.textbox.ctrlKey&&!level.textbox.lock&&!vm.textEditor" ng-style="{width:level.textbox.geometry.width*currentPage.scale/currentPage.scene.proportion-20,\n                                                 top:level.textbox.geometry.height*currentPage.scale/currentPage.scene.proportion}"><span class="rotate-line"></span><br><span class="rotate-icon rotate-icon{{$index}}" data-index="{{$index}}" style="margin-left: 12px" ng-mousedown="rotateBoxStart($event,level.textbox,$index)"></span></div><div class="loading-font" ng-if="level.textbox.loading"></div></div><div data-index="{{$index}}" class="c-textdocument" ng-show="level.textdocument.current" ng-mousedown="moveBoxStart1($event,level.textdocument,levelIndex)" ng-class="{\'selected\': level.textdocument.ctrlKey || $index == template.levelI && RightPanel==\'textDoc\'}" ng-style="{\n                                                            position: \'absolute\',\n                                                            width: level.textdocument.geometry.width*currentPage.scale/currentPage.scene.proportion,\n                                                            height: level.textdocument.geometry.height*currentPage.scale/currentPage.scene.proportion,\n                                                            left: level.textdocument.geometry.x*currentPage.scale/currentPage.scene.proportion,\n                                                            top: level.textdocument.geometry.y*currentPage.scale/currentPage.scene.proportion,\n                                                            \'z-index\':level.seq-0+200,\n                                                            filter: \'alpha(opacity=\'+level.textdocument.transparency*100+\')\',\n                                                            \'transform\': \'rotate(-\' + level.textdocument.rotation.angle + \'deg)\',\n                                                            \'opacity\': opacityElement(currentPage.mediabox, level.textdocument.geometry)}" ng-click="selectDoc($event, $index, level.textdocument)"><div style="overflow: hidden;width: 100%;height: 100%;position: relative;z-index: 1" class="no-events" ng-style="{\'opacity\':level.textdocument.transparency.toFixed(2)}"><img class="bg-image bg-image{{template.pageI}} pos" ng-cloak ng-if="level.textdocument.background.resource.identifier" ng-src="{{level.textdocument.background.resource.identifier + vm.pageImageView||\'//:0\'}}" ng-style="{\n                                                                     position: \'absolute\',\n                                                                     left:level.textdocument.background.offsetx*currentPage.scale/currentPage.scene.proportion,\n                                                                     top:level.textdocument.background.offsety*currentPage.scale/currentPage.scene.proportion,\n                                                                     width: level.textdocument.background.adaptation==\'Width\'?level.textdocument.geometry.width*currentPage.scale/currentPage.scene.proportion:\'\',\n                                                                     height:level.textdocument.background.adaptation!=\'Width\'?level.textdocument.geometry.height*currentPage.scale/currentPage.scene.proportion:\'\'}"><div ng-repeat="docLevel in level.textdocument.levels.level track by $index" ng-init="docIndex = $index" style="position: relative"><div data-index="{{docIndex}}" class="img-art" ng-show="docLevel.imageart" ng-style="{\n                                                                        width: docLevel.imageart.geometry.width*currentPage.scale/currentPage.scene.proportion,\n                                                                        height: docLevel.imageart.geometry.height*currentPage.scale/currentPage.scene.proportion,\n                                                                        left: docLevel.imageart.geometry.x*currentPage.scale/currentPage.scene.proportion,\n                                                                        top: docLevel.imageart.geometry.y*currentPage.scale/currentPage.scene.proportion,\n                                                                        \'z-index\':docLevel.seq-0+200,\n                                                                        \'opacity\':docLevel.imageart.transparency,\n                                                                        filter: \'alpha(opacity=\'+docLevel.imageart.transparency*100+\')\',\n                                                                        \'transform\': \'rotate(\' + docLevel.imageart.rotation.angle + \'deg)\'}"><div style="overflow: hidden; position: relative; width: 100%; height: 100%"><img data-index="{{$index}}" style="transition: opacity 0.3s;position: absolute" ng-style="{\n                                                                            \'left\': docLevel.imageart.offsetx *currentPage.scale/currentPage.scene.proportion,\n                                                                            \'top\': docLevel.imageart.offsety *currentPage.scale/currentPage.scene.proportion,\n                                                                            \'width\': docLevel.imageart.geometry.width * currentPage.scale/currentPage.scene.proportion * docLevel.imageart.scale}" ng-src="{{docLevel.imageart.resource.identifier + vm.pageImageView}}"></div></div><div class="c-xml-page-textboxe" ng-show="docLevel.textbox" style="white-space: normal" data-index="{{docIndex}}" ng-style="{\n                                                                    \'z-index\':docLevel.seq-0+200,\n                                                                    \'width\': docLevel.textbox.geometry.width * currentPage.scale/currentPage.scene.proportion,\n                                                                    \'left\': docLevel.textbox.geometry.x * currentPage.scale/currentPage.scene.proportion,\n                                                                    \'top\': docLevel.textbox.geometry.y * currentPage.scale/currentPage.scene.proportion,\n                                                                    \'height\': docLevel.textbox.geometry.height * currentPage.scale/currentPage.scene.proportion,\n                                                                    \'transform\': \'rotate(\' + docLevel.textbox.rotation.angle + \'deg)\'}"><div style="width: 100%;height: 100%;position: absolute;top:0;left: 0"><pre class="c-xml-page-textboxe-text web-font" ng-style="{\n                                                                \'font-family\': \'\\\'\' + docLevel.textbox.fontuuid + \'\\\'\',\n                                                                \'font-size\': (docLevel.textbox.style.size*currentPage.scale/currentPage.scene.proportion > 12 ? docLevel.textbox.style.size* currentPage.scale/currentPage.scene.proportion : 12) + \'pt\',\n                                                                \'color\': docLevel.textbox.style.color,\n                                                                \'font-weight\': docLevel.textbox.style.bold ? \'bold\': \'400\',\n                                                                \'font-style\': docLevel.textbox.style.italic ? \'italic\': \'initial\',\n                                                                \'line-height\': (docLevel.textbox.style.size * currentPage.scale/currentPage.scene.proportion > 12 ? docLevel.textbox.style.lineheight * currentPage.scale/currentPage.scene.proportion : (docLevel.textbox.style.lineheight * currentPage.scale/currentPage.scene.proportion) / (1 / 12 * docLevel.textbox.style.size * currentPage.scale/currentPage.scene.proportion)) + \'pt\',\n                                                                \'letter-spacing\': (docLevel.textbox.style.size * currentPage.scale/currentPage.scene.proportion > 12 ? docLevel.textbox.style.letterspacing * currentPage.scale/currentPage.scene.proportion : (docLevel.textbox.style.letterspacing * currentPage.scale/currentPage.scene.proportion) / (1 / 12 * docLevel.textbox.style.size * currentPage.scale/currentPage.scene.proportion)) + \'pt\',\n                                                                \'opacity\': docLevel.textbox.transparency,\n                                                                \'text-decoration\': \'none\',\n                                                                \'text-align\': docLevel.textbox.style.align,\n                                                                \'text-align-last\': \'unset\',\n                                                                \'transform\':\'scale(\'+(1 / 12 * docLevel.textbox.style.size* currentPage.scale/currentPage.scene.proportion > 1 ? 1 : 1 / 12 * docLevel.textbox.style.size* currentPage.scale/currentPage.scene.proportion)+\')\',\n                                                                \'transform-origin\': \'0 0\',\n                                                                \'writing-mode\': docLevel.textbox.style.writingmode,\n                                                                 \'width\': docLevel.textbox.style.size * currentPage.scale/currentPage.scene.proportion > 12 ? docLevel.textbox.geometry.width * currentPage.scale/currentPage.scene.proportion : (docLevel.textbox.geometry.width * currentPage.scale/currentPage.scene.proportion) / (1 / 12 * docLevel.textbox.style.size * currentPage.scale/currentPage.scene.proportion) + \'px\',\n                                                                 \'height\': docLevel.textbox.style.size * currentPage.scale/currentPage.scene.proportion > 12 ? docLevel.textbox.geometry.height * currentPage.scale/currentPage.scene.proportion : (docLevel.textbox.geometry.height * currentPage.scale/currentPage.scene.proportion) / (1 / 12 * docLevel.textbox.style.size * currentPage.scale/currentPage.scene.proportion) + \'px\',\n                                                            }"><span class="c-xml-page-textboxe-span">{{docLevel.textbox.text}}</span></pre></div></div></div></div><span class="sel-bottom" data-index="{{$index}}" onmousedown="resizeDocStart1(event)" ng-if="$index == template.levelI&& (RightPanel==\'textDoc\')&&!level.textdocument.ctrlKey"></span><div class="rotate-box" ng-if="$index == template.levelI && (RightPanel==\'textDoc\')" style="width:100%;bottom:-12px"><div style="position: relative; width: 100%"><span class="rotate-line" style="position: absolute;left: 50%;margin-left: -0.5px"></span><br><span class="rotate-icon rotate-icon{{$index}}" data-index="{{$index}}" ng-mousedown="rotateBoxStart($event,level.textdocument,$index)" style="position: absolute; top: 17px; left: 50%; margin-left: -11px"></span></div></div></div><!--                                                <div class="barcode cursorPointer"--><!--                                                     readonly="readonly"--><!--                                                     ng-show="currentPage.page.barcode&&currentPage.page.barcode.geometry"--><!--                                                     ng-style="{--><!--                                                             \'line-height\':\'0\',--><!--                                                             top: currentPage.page.barcode.geometry.y*currentPage.page.scale/currentPage.page.proportion*proportion,--><!--                                                             left: currentPage.page.barcode.geometry.x*currentPage.page.scale/currentPage.page.proportion*proportion,--><!--                                                             width: currentPage.page.barcode.geometry.width*currentPage.page.scale/currentPage.page.proportion*proportion,--><!--                                                             height: currentPage.page.barcode.geometry.height*currentPage.page.scale/currentPage.page.proportion*proportion,--><!--                                                             \'z-index\': 998,--><!--                                                            \'transform\': \'rotate(-\' + currentPage.barcode.rotation.angle + \'deg)\'--><!--                                                        }">--><!--                                                    <img src="content/images/txm.png" style="width: 100%;height: 100%">--><!--                                                </div>--><div class="barcode cursorPointer" readonly="readonly" ng-show="currentPage.barcode&&currentPage.barcode.geometry" onmousedown="moveBarcodeStart1(event)" ng-style="{\n                                                         \'line-height\':\'0\',\n                                                         top: currentPage.barcode.geometry.y*currentPage.scale/currentPage.scene.proportion,\n                                                         left: currentPage.barcode.geometry.x*currentPage.scale/currentPage.scene.proportion,\n                                                         width: currentPage.barcode.geometry.width*currentPage.scale/currentPage.scene.proportion,\n                                                         height: currentPage.barcode.geometry.height*currentPage.scale/currentPage.scene.proportion,\n                                                         \'z-index\': 300,\n                                                        \'transform\': \'rotate(-\' + currentPage.barcode.rotation.angle + \'deg)\'\n                                                    }"><img src="content/images/txm.png" style="width: 100%;height: 100%"></div><div class="barcode cursorPointer" readonly="readonly" ng-show="currentPage.qrcode&&currentPage.qrcode.geometry" onmousedown="moveQrcodeStart1(event)" ng-style="{\n                                                         \'line-height\':\'0\',\n                                                         top: currentPage.qrcode.geometry.y*currentPage.scale/currentPage.scene.proportion,\n                                                         left: currentPage.qrcode.geometry.x*currentPage.scale/currentPage.scene.proportion,\n                                                         width: currentPage.qrcode.geometry.width*currentPage.scale/currentPage.scene.proportion,\n                                                         height: currentPage.qrcode.geometry.height*currentPage.scale/currentPage.scene.proportion,\n                                                         \'z-index\': 300,\n                                                        \'transform\': \'rotate(-\' + currentPage.qrcode.rotation.angle + \'deg)\'\n                                                    }"><img src="content/images/QrCode.png" style="width: 100%;height: 100%"></div></div><div class="barcode cursorPointer" ng-click="selectBar($event,currentPage, \'barcode\')" ng-class="{\'selected\': RightPanel == \'barcode\'}" onmousedown="moveBarcodeStart1(event)" readonly="readonly" ng-show="currentPage.barcode&&currentPage.barcode.geometry" ng-style="{\n                                                             \'line-height\':\'0\',\n                                                             top: currentPage.barcode.geometry.y*currentPage.scale/currentPage.scene.proportion,\n                                                             left: currentPage.barcode.geometry.x*currentPage.scale/currentPage.scene.proportion,\n                                                             width: currentPage.barcode.geometry.width*currentPage.scale/currentPage.scene.proportion,\n                                                             height: currentPage.barcode.geometry.height*currentPage.scale/currentPage.scene.proportion,\n                                                             \'z-index\': 300,\n                                                            \'transform\': \'rotate(-\' + currentPage.barcode.rotation.angle + \'deg)\'\n                                                        }"><img src="content/images/txm.png" style="width: 100%;height: 100%"></div><div class="barcode cursorPointer" ng-click="selectBar($event,currentPage, \'qrcode\')" ng-class="{\'selected\': RightPanel == \'qrcode\'}" onmousedown="moveQrcodeStart1(event)" readonly="readonly" ng-show="currentPage.qrcode&&currentPage.qrcode.geometry" ng-style="{\n                                                             \'line-height\':\'0\',\n                                                             top: currentPage.qrcode.geometry.y*currentPage.scale/currentPage.scene.proportion,\n                                                             left: currentPage.qrcode.geometry.x*currentPage.scale/currentPage.scene.proportion,\n                                                             width: currentPage.qrcode.geometry.width*currentPage.scale/currentPage.scene.proportion,\n                                                             height: currentPage.qrcode.geometry.height*currentPage.scale/currentPage.scene.proportion,\n                                                             \'z-index\': 300,\n                                                            \'transform\': \'rotate(-\' + currentPage.qrcode.rotation.angle + \'deg)\'\n                                                        }"><img src="content/images/QrCode.png" style="width: 100%;height: 100%"></div></div></div></div><!-- \u523B\u5EA6\u7EBF --><div ng-if="vm.staff"><div class="lineReference-x" ng-style="{left:(!currentPage.isScene?canvasCoordX(currentPage.mediabox.width/currentPage.proportion*currentPage.scale):canvasCoordX((currentPage.scene.geometry.width)*currentPage.scale/currentPage.scene.proportion)) + (!currentPage.isScene?vm.lineReferenceX/currentPage.proportion*currentPage.scale:vm.lineReferenceX*currentPage.scale/currentPage.scene.proportion) + (currentPage.isScene?currentPage.scene.imagebox.geometry.x*currentPage.scale/currentPage.scene.proportion:0)}" ng-if="vm.lineReferenceX != null"></div><div class="lineReference-y" ng-style="{top:(!currentPage.isScene?canvasCoordY(currentPage.mediabox.height/currentPage.proportion*currentPage.scale):canvasCoordY((currentPage.scene.geometry.height)*currentPage.scale/currentPage.scene.proportion)) + (!currentPage.isScene?vm.lineReferenceY/currentPage.proportion*currentPage.scale:vm.lineReferenceY*currentPage.scale/currentPage.scene.proportion) + (currentPage.isScene?currentPage.scene.imagebox.geometry.y*currentPage.scale/currentPage.scene.proportion:0)}" ng-if="vm.lineReferenceY != null"></div><div class="lineReference-x1" ng-repeat="item in vm.sublinesX track by $index" ng-style="{left:(!currentPage.isScene?canvasCoordX(currentPage.mediabox.width/currentPage.proportion*currentPage.scale):canvasCoordX((currentPage.scene.geometry.width)*currentPage.scale/currentPage.scene.proportion)) + (!currentPage.isScene?item/currentPage.proportion*currentPage.scale:item*currentPage.scale/currentPage.scene.proportion) + (currentPage.isScene?currentPage.scene.imagebox.geometry.x*currentPage.scale/currentPage.scene.proportion:0)}" ng-mousedown="moveLineReference($event,item, $index, \'x\')"><div class="lineReference-x1-hr"></div><span class="lineReference-item">{{PxTurnMm(item)+PxTurnMm(currentPage.isScene?currentPage.scene.imagebox.geometry.x:0) | number:0}}</span></div><div class="lineReference-y1" ng-repeat="item in vm.sublinesY track by $index" ng-style="{top:(!currentPage.isScene?canvasCoordY(currentPage.mediabox.height/currentPage.proportion*currentPage.scale):canvasCoordY((currentPage.scene.geometry.height)*currentPage.scale/currentPage.scene.proportion)) + (!currentPage.isScene?item/currentPage.proportion*currentPage.scale:item*currentPage.scale/currentPage.scene.proportion) + (currentPage.isScene?currentPage.scene.imagebox.geometry.y*currentPage.scale/currentPage.scene.proportion:0)}" ng-mousedown="moveLineReference($event,item, $index, \'y\')"><div class="lineReference-y1-hr"></div><span class="lineReference-item">{{PxTurnMm(item)+PxTurnMm(currentPage.isScene?currentPage.scene.imagebox.geometry.y:0) | number:0}}</span></div></div></div><div class="c-editor-canvas-page-turning"><i class="iconfont icon-left" ng-click="pageDirection(true)" ng-style="{\'cursor\': visibleLeft ? \'\' : \'not-allowed\'}"></i> <span>{{template.pageI+1}}</span> <span style="margin: 0 10px; color: #E2E2E2">|</span> <span>{{template.pages.page.length}}</span> <i class="iconfont icon-right" ng-click="pageDirection(false)" ng-style="{\'cursor\': visibleRight ? \'\' : \'not-allowed\'}"></i></div><div class="page-scale"><div class="iconfont icon-jian" style="font-weight: bold" uib-tooltip="\u753B\u5E03\u7F29\u5C0F" tooltip-placement="top" ng-click="changeShirnk(1)"></div><div class="">{{(100*currentPage.proportion1)|number:0}}%</div><div class="iconfont icon-add" style="font-weight: bold" uib-tooltip="\u753B\u5E03\u653E\u5927" tooltip-placement="top" ng-click="changeShirnk(2)"></div><div class="iconfont icon-fangda" uib-tooltip="\u521D\u59CB\u5C3A\u5BF8" tooltip-placement="top" ng-click="changeShirnk(0)"></div><div class="iconfont icon-icon-zhuashou" uib-tooltip="\u62D6\u62FD\u753B\u5E03" tooltip-placement="top" ng-style="{\'color\':vm.moveCanvasView?\'#fac779\':\'\'}" ng-click="vm.moveCanvasView = !vm.moveCanvasView"></div><div class="iconfont icon-icon-test" ng-click="changeShirnk(3)" uib-tooltip="\u539F\u5C3A\u5BF8" tooltip-placement="left"></div></div><div ng-show="showCut" class="cut-image-box" onmousedown="startEdit(event)" ontouchmove="dragEdit(event)" ontouchend="stopEdit()"><img ng-if="currentPage.background.resource.identifier" ng-src="{{currentPage.background.resource.identifier + vm.pageImageView}}" id="cut-img" class="cut-img" style="z-index: 9999" ng-style="{ width:w, height:h}"> <img class="cut-mask" id="cut-mask" style="position: absolute;top:0;left: 0;z-index: 9999"><div class="pos-abso" ng-style="{\n                                \'z-index\':9999,\n                                left:l+pageW,\n                                top:t+pageH/2-24,\n                                width:32}"><div style="border-bottom: 1px solid #e6e6e6" ng-click="showCut=false"><img src="content/images/icons/web_canvel.svg"></div><div ng-click="showCut=false"><img src="content/images/icons/web_save.svg"></div></div></div><div ng-show="showImageCut" class="cut-image-box" onmousedown="startImageEdit(event)" ontouchmove="dragImageEdit(event)" ontouchend="stopImageEdit()"><div onmousewheel="return bbimg()" class="pos-abso" id="mouseWheel"><img ng-if="imgUrl" ng-src="{{imgUrl+\'/rotate/\'+currentImage.image.angle}}" style="z-index: 9999 !important" id="cutImagebox-img" class="cut-img" ng-style="{ width:w?w*scale:\'\', height:h?h*scale:\'\'}"> <img class="cut-mask" id="cutImagebox-mask" style="position: absolute;top:0;left: 0;z-index:9999"> <span class="cut-img opacity-zero cut-position"><img ng-if="currentImage.imgUrl" ng-src="{{currentImage.imgUrl+ \'/rotate/0\'}}" id="cut-opacity" class="cut-img" ng-style="{width:wOpacity?wOpacity*scale:\'\',height:hOpacity?hOpacity*scale:\'\'}"></span><div ng-style="{left:originL+ww,top:originT+hh/2-48,width:32}" style="z-index: 9999" class="pos-abso"><!--<div style="border-bottom: 1px solid #e6e6e6" ng-click="changeBlurred()"--><!--ng-show="productBokeh">--><!--<img src="content/images/icons/web_zhankai.svg">--><!--</div>--><!--<div style="border-bottom: 1px solid #e6e6e6" ng-click="rotateImage()">--><!--<img src="content/images/icons/web_rotate1.svg">--><!--</div>--><!--<div style="border-bottom: 1px solid #e6e6e6" ng-click="deleteImage()">--><!--<img src="content/images/icons/del_pic.svg">--><!--</div>--><div style="border-bottom: 1px solid #e6e6e6" ng-click="showImageCut=false"><img src="content/images/icons/web_canvel.svg"></div><div ng-click="saveMove()"><img src="content/images/icons/web_save.svg"></div></div></div></div><div class="c-xml-imageart-trim" style="z-index: 999" ng-if="vm.isImageartTrim"><div class="relative-view2" ng-click="canvasCb($event)"></div><div style="position: relative;padding-bottom: 30px" ng-style="{\n                                \'width\': (currentPage.mediabox.width/currentPage.proportion)*currentPage.scale,\n                                \'height\': (currentPage.mediabox.height/currentPage.proportion)*currentPage.scale,\n                                \'margin-left\':canvasCoordX(currentPage.mediabox.width/currentPage.proportion*currentPage.scale),\n                                \'margin-top\': canvasCoordY(currentPage.mediabox.height/currentPage.proportion*currentPage.scale),\n                             }"><div class="relative-view2" ng-click="canvasCb($event)"></div><div id="c-xml-imageart-trim-img" style="position: absolute" ng-style="{\n                                    \'width\': vm.imageartTrim.geometry.width1 * currentPage.scale/currentPage.proportion,\n                                    \'height\': vm.imageartTrim.geometry.height1 * currentPage.scale/currentPage.proportion,\n                                    \'left\': vm.imageartTrim.geometry.x1 * currentPage.scale/currentPage.proportion + \'px\',\n                                    \'top\': vm.imageartTrim.geometry.y1 * currentPage.scale/currentPage.proportion + \'px\'}"><div style="position: relative; width: 100%; height: 100%"><div class="c-xml-imageart-trim-div" id="c-xml-imageart-trim-div" ng-style="{\n                                            \'left\': vm.imageartTrim.offsetx * currentPage.scale/currentPage.proportion,\n                                            \'top\': vm.imageartTrim.offsety * currentPage.scale/currentPage.proportion\n                                         }"><img id="imageartTrimRight1" ng-src="{{vm.imageartTrim.resource.identifier + vm.pageImageView}}" ng-style="{\'width\': vm.imageartTrim.geometry.width1 * currentPage.scale/currentPage.proportion * vm.imageartTrim.scale + \'px\'}"><div style="width: 100%; height: 100%; position: absolute; background: rgba(0,0,0,0.5); top: 0; left: 0;z-index: 1"></div></div></div></div><div id="c-xml-imageart-trim-frame" style="position: absolute; z-index: 1" ng-style="{\n                                    \'width\': vm.imageartTrim.geometry.width * currentPage.scale/currentPage.proportion,\n                                    \'height\': vm.imageartTrim.geometry.height * currentPage.scale/currentPage.proportion,\n                                    \'left\': vm.imageartTrim.geometry.x * currentPage.scale/currentPage.proportion + \'px\',\n                                    \'top\': vm.imageartTrim.geometry.y * currentPage.scale/currentPage.proportion + \'px\'\n                                 }"><div style="width: 100%; height: 100%; overflow: hidden;position: absolute;border: 1px solid #e1a13c"><div style="position: absolute" id="c-xml-imageart-trim-frame-img" ng-mousedown="imageartTrimdown($event)" ng-style="{\n                                                \'left\': (vm.imageartTrim.geometry.x1 - vm.imageartTrim.geometry.x + vm.imageartTrim.offsetx) * currentPage.scale/currentPage.proportion,\n                                                \'top\': (vm.imageartTrim.geometry.y1 - vm.imageartTrim.geometry.y + vm.imageartTrim.offsety) * currentPage.scale/currentPage.proportion}"><img ng-src="{{vm.imageartTrim.resource.identifier + vm.pageImageView}}" ng-style="{\'width\': vm.imageartTrim.geometry.width1 * currentPage.scale/currentPage.proportion * vm.imageartTrim.scale + \'px\'}"></div></div><span class="c-xml-page-material-zoom c-xml-page-material-zoom-right1" style="display: block" ng-mousedown="imageartTrimRight($event,vm.imageartTrim)"></span><div class="c-xml-operation"><button type="button" ng-click="imageartTrimTrueClick()">\u221A</button> <button type="button" ng-click="imageartTrimFalseClick()">\xD7</button></div></div></div></div><div class="c-xml-bgImg-trim" ng-if="vm.isImageboxTrim" style="z-index: 999 !important; background: none" ng-mousedown="imageboxMouseDown($event)" onmousewheel="return bbimg()"><div class="relative-view2" ng-click="canvasCb($event)"></div><div style="position: absolute;margin: auto;left: 0;top: 0; right: 0;bottom: 0" ng-style="{\n                                \'width\': (currentPage.mediabox.width/currentPage.proportion)*currentPage.scale,\n                                \'height\': (currentPage.mediabox.height/currentPage.proportion)*currentPage.scale,\n                                \'margin-left\':canvasCoordX(currentPage.mediabox.width/currentPage.proportion*currentPage.scale),\n                                \'margin-top\': canvasCoordY(currentPage.mediabox.height/currentPage.proportion*currentPage.scale),\n                                }"><div style="width: 100%; height: 100%; position: absolute; left: 0; top: 0"><div ng-style="{\n                                            \'position\': \'absolute\',\n                                            \'width\': vm.imageboxDouble.geometry.width*currentPage.scale/currentPage.proportion,\n                                            \'height\': vm.imageboxDouble.geometry.height*currentPage.scale/currentPage.proportion,\n                                            \'left\': vm.imageboxDouble.geometry.x*currentPage.scale/currentPage.proportion,\n                                            \'top\': vm.imageboxDouble.geometry.y*currentPage.scale/currentPage.proportion,\n                                            \'transform\': \'rotate(-\' + vm.imageboxDouble.rotation.angle + \'deg)\',\n                                        }"><div style="width: 100%; height: 100%;position: relative"><img ng-src="{{ vm.imageboxDouble.image.resource.identifier+vm.pageImageViewOrient}}" ng-style="{\n                                                    \'width\': vm.imageboxDouble.image.width*currentPage.scale/currentPage.proportion * vm.imageboxDouble.image.scale,\n                                                    \'height\': vm.imageboxDouble.image.height*currentPage.scale/currentPage.proportion * vm.imageboxDouble.image.scale,\n                                                    \'left\': vm.imageboxDouble.image.offsetx *currentPage.scale/currentPage.proportion * vm.imageboxDouble.image.scale,\n                                                    \'top\': vm.imageboxDouble.image.offsety *currentPage.scale/currentPage.proportion * vm.imageboxDouble.image.scale\n                                                 }" style="position: absolute" alt="\u80CC\u666F\u56FE\u7247"><div style="position: absolute;background: rgba(0,0,0,0.5); z-index: 1" ng-style="{\n                                                    \'width\': vm.imageboxDouble.image.width*currentPage.scale/currentPage.proportion * vm.imageboxDouble.image.scale,\n                                                    \'height\': vm.imageboxDouble.image.height*currentPage.scale/currentPage.proportion * vm.imageboxDouble.image.scale,\n                                                    \'left\': vm.imageboxDouble.image.offsetx *currentPage.scale/currentPage.proportion * vm.imageboxDouble.image.scale,\n                                                    \'top\': vm.imageboxDouble.image.offsety *currentPage.scale/currentPage.proportion * vm.imageboxDouble.image.scale\n                                                 }"></div></div></div></div><div style="width: 100%; height: 100%; position: absolute; left: 0; top: 0; z-index: 10"><div class="relative-view2" ng-click="canvasCb($event)"></div><div ng-style="{\n                                            \'position\': \'absolute\',\n                                            \'width\': vm.imageboxDouble.geometry.width*currentPage.scale/currentPage.proportion,\n                                            \'height\': vm.imageboxDouble.geometry.height*currentPage.scale/currentPage.proportion,\n                                            \'left\': vm.imageboxDouble.geometry.x*currentPage.scale/currentPage.proportion,\n                                            \'top\': vm.imageboxDouble.geometry.y*currentPage.scale/currentPage.proportion,\n                                            \'transform\': \'rotate(-\' + vm.imageboxDouble.rotation.angle + \'deg)\',\n                                        }"><div style="width: 100%; height: 100%;position: relative;overflow: hidden" ng-style="{\n                                                \'-webkit-mask-image\': vm.imageboxDouble.mask.resource.identifier ? \'url(\' + vm.imageboxDouble.mask.resource.identifier + \')\' : \'none\',\n                                                \'-webkit-mask-size\': \'100% 100%\'\n                                                }"><img ng-src="{{ vm.imageboxDouble.image.resource.identifier+vm.pageImageViewOrient}}" ng-style="{\n                                                    \'width\': vm.imageboxDouble.image.width*currentPage.scale/currentPage.proportion * vm.imageboxDouble.image.scale,\n                                                    \'height\': vm.imageboxDouble.image.height*currentPage.scale/currentPage.proportion * vm.imageboxDouble.image.scale,\n                                                    \'left\': vm.imageboxDouble.image.offsetx *currentPage.scale/currentPage.proportion * vm.imageboxDouble.image.scale,\n                                                    \'top\': vm.imageboxDouble.image.offsety *currentPage.scale/currentPage.proportion * vm.imageboxDouble.image.scale\n                                                 }" style="position: absolute" alt="\u80CC\u666F\u56FE\u7247"></div><div class="c-xml-operation" style="z-index: 10"><button type="button" ng-click="imageboxTrueClick()" ng-style="{\'transform\': \'rotate(-\' + (360-vm.imageboxDouble.rotation.angle) + \'deg)\',}">\u221A</button> <button type="button" ng-click="imageboxFalseClick()" ng-style="{\'transform\': \'rotate(-\' + (360-vm.imageboxDouble.rotation.angle) + \'deg)\',}">\xD7</button></div></div></div></div></div><div class="parts-view"><div class="parts-view-1" ng-if="!vm.isPageList2"><div id="pageList2" class="scrollbar-main" style="display: flex;overflow: auto"><div class="parts-li sortingPageView" ng-repeat="part in template.config.parts.list" ng-class="{\n                     \'parts-li-select\' : part.id == currentPage.config.partid,\n                     \'filtered\':(part.id ==\'P\' || part.id == \'B1\')&&template.config.productType == \'CALENDAR\',\n                     \'notDrag\': (part.id ==\'P\' || part.id == \'B1\')&&template.config.productType == \'CALENDAR\'\n                     }" ng-click="partCb(part, $event)" ng-if="part.counter>0" data-page="{{part}}">{{part.name}}</div><div class="parts-li" ng-click="hidePanel(2)" style="position: sticky;right: 0;background-color: #fff"><i class="iconfont" style="font-size: 16px" ng-class="{\'icon-down\' : vm.bottomShow, \'icon-up\':!vm.bottomShow}"></i></div></div></div><div class="parts-li1" ng-if="vm.page.productType != \'PHOTO\'&&!vm.thirdparty"><i class="iconfont icon-icon_tianjia" ng-click="addPart()"></i></div></div><div class="moveCanvas-view" ng-mousedown="moveCanvas($event)" ng-if="vm.moveCanvasView" data-html2canvas-ignore></div><!--\u523B\u5EA6\u5C3A--><div class="graduatedScale-unit" ng-show="vm.staff">mm</div><div id="graduatedScale-cross" ng-show="vm.staff"></div><div id="graduatedScale-vertical" ng-show="vm.staff"></div></div><div class="c-editor-toggle-left" ng-click="hidePanel(1)" ng-style="{left:vm.leftShow?\'392px\':\'72px\'}"><i class="iconfont" ng-class="{\'icon-left\' : vm.leftShow, \'icon-right\':!vm.leftShow}"></i></div><div class="c-editor-toggle-right" ng-click="hidePanel(0)" ng-style="{right:vm.rightShow?\'200px\':\'0\'}"><i class="iconfont" ng-class="{\'icon-left\' : !vm.rightShow, \'icon-right\':vm.rightShow}"></i></div><div class="c-editor-canvas-pagelist scrollbar-main" ng-show="vm.bottomShow" ng-style="{\n            \'left\':vm.leftShow?\'392px\':\'72px\',\n            \'right\':vm.rightShow?\'200px\':\'0\',\n         }"><ul class="c-editor-canvas-pagelist-ul scrollbar-main" id="pageList"><li ng-repeat="page in template.pages.page track by $index" class="sortingPageView" ng-class="{\'part-page-last\':partPageLast(page,$index)&&!$last, \'add-page-menu\':partPageLast(page,$index) && page.config.partid == \'P\'}" data-index="{{$index}}" data-page="{{page}}"><div style="position: relative" ng-class="{\'selected\': $index == template.pageI}" ng-click="selectPages($index,$event)"><page-preview page="page" scale="page.minScale" is-min="true" is-cover="page.uuid != currentPage.uuid" ng-if="!page.update"></page-preview><div class="page-del" ng-click="deletePage($index,$event)" ng-if="template.pages.page.length>1 && (vm.page.productType == \'THING\' || (!template.config.parts.list[getItemPartIndex(page)].required || (template.config.parts.list[getItemPartIndex(page)].required && template.config.parts.list[getItemPartIndex(page)].counter>1)))"><i class="iconfont icon-shanchu3"></i></div><div class="page-seq" style="z-index: 999!important" ng-if="page.config.partid === \'P\'">{{pageSeq(page)}}</div><div class="page-not-month" ng-if="!isSetMonth(page)"><i class="iconfont icon-jinggao"></i> <span>\u672A\u8BBE\u7F6E\u6708</span></div><div class="page-not-month" ng-if="page.uuid != currentPage.uuid && page.updateThumbnail && isSetMonth(page)"><span>\u672A\u66F4\u65B0</span></div></div><div class="add-box" ng-if="!vm.isMould && !vm.thirdparty && partPageLast(page,$index) && page.config.partid == \'P\'" ng-click="addPage()"><i class="iconfont icon-jia2"></i><p>\u65B0\u589E</p><p>\u9875\u9762</p></div><div class="page-border"></div></li></ul><!--\u589E\u52A0\u4E00\u9875--><!--        <div class="c-editor-canvas-pagelist-page"--><!--             ng-if="!vm.isMould && !vm.thirdparty && currentPage.config.partid === \'P\'">--><!--            <div class="page-noNav" ng-click="addPage()">--><!--                <i class="iconfont icon-jia2"></i>--><!--                <p>\u65B0\u589E</p>--><!--                <p>\u9875\u9762</p>--><!--            </div>--><!--            <div class="page-noNav" ng-click="addNoModelPage()" ng-if="vm.tempType == \'noModel\'">--><!--                <i class="iconfont icon-jia2"></i>--><!--                <p>\u65B0\u589E</p>--><!--                <p>\u9875\u9762</p>--><!--            </div>--><!--        </div>--></div><div class="c-editor-attribute scrollbar-main" style="width: 200px" ng-show="vm.rightShow"><div class="c-editor-attribute-head"><div class="c-editor-attribute-tab-li" ng-class="{\'c-editor-attribute-head-selected\': vm.attributeTab==\'page\'}" ng-click="attributeTab(\'page\')">\u9875\u9762</div><div class="c-editor-attribute-tab-li" ng-class="{\'c-editor-attribute-head-selected\': vm.attributeTab==\'coverage\'}" ng-click="attributeTab(\'coverage\')">\u56FE\u5C42</div></div><div ng-if="vm.attributeTab==\'page\'"><div class="rightPanel-head"><div>\u7B2C{{template.pageI+1}}\u9875</div><div>\u5F53\u524D\u56FE\u7247\u6846{{vm.count||0}}\u4E2A</div></div><div class="c-editor-attribute-view" ng-show="!RightPanel || RightPanel==\'page\'"><div class="c-editor-attribute-view-title"><span style="display: block; width: 100px">\u5F53\u524D\u9875\u753B\u5E03\u5C3A\u5BF8</span><select ng-model="vm.unit" ng-options="unit.id as unit.name for unit in vm.units" ng-change="unitConversion()" class="c-editor-attribute-view-title-select"></select></div><div class="c-editor-attribute-view-input"><div class="c-editor-attribute-view-input-view"><span>\u5BBD</span> <input type="text" ng-model="pageValue.mediabox.width" readonly="readonly"></div><div class="c-editor-attribute-view-input-view"><span>\u9AD8</span> <input type="text" ng-model="pageValue.mediabox.height" readonly="readonly"></div></div><div ng-if="currentPage.config.partid == \'P\' && vm.page.productType == \'BOOK\'"><div class="c-editor-attribute-view-hr"></div><div class="c-editor-attribute-view-title"><span>\u6A21\u677F\u8BBE\u7F6E</span></div><div class="c-editor-attribute-view-1"><div ng-click="pageIsSpread(1)" ng-class="{\'c-editor-attribute-view-1-selected\':currentPage.spread}">\u8DE8\u9875</div><div ng-click="pageIsSpread(0)" ng-class="{\'c-editor-attribute-view-1-selected\':!currentPage.spread}">\u975E\u8DE8\u9875</div></div><div style="display: flex; justify-content: space-between; align-items: center; margin-top: 10px"><div>\u9002\u5E94\u5C3A\u5BF8</div><input type="checkbox" class="checkOrIf" ng-model="vm.spreadSize"></div></div><div ng-hide="vm.tempType==\'hasModel\'"><div class="c-editor-attribute-view-hr"></div><div class="c-editor-attribute-view-title"><span>\u9875\u9762\u8BBE\u7F6E</span></div><div class="c-editor-attribute-view-1"><div ng-click="pageIsReplace(1)" ng-class="{\'c-editor-attribute-view-1-selected\':currentPage.unreplace==false}">\u53EF\u66FF\u6362</div><div ng-click="pageIsReplace(0)" ng-class="{\'c-editor-attribute-view-1-selected\': currentPage.unreplace==true}">\u4E0D\u53EF\u66FF\u6362</div></div></div><div ng-if="vm.page.productType == \'BOOK\' && currentPage.config.partid == \'P\' && pageSeq(currentPage) == 1 && !currentPage.spread"><div class="c-editor-attribute-view-hr"></div><div class="c-editor-attribute-view-title"><span>\u5185\u9875\u7B2C\u4E00\u9875</span></div><div class="c-editor-attribute-view-1"><div ng-click="template.config.innerOffset = 0;vm.operation = true;" ng-class="{\'c-editor-attribute-view-1-selected\':template.config.innerOffset == 0}">\u5DE6\u4FA7</div><div ng-click="template.config.innerOffset = 1;vm.operation = true;" ng-class="{\'c-editor-attribute-view-1-selected\':template.config.innerOffset == 1}">\u53F3\u4FA7</div></div></div><div class="c-editor-attribute-view-hr"></div><div class="c-editor-attribute-view-btn c-editor-attribute-view-btn2" ng-hide="vm.tempType==\'hasModel\' || currentPage.unreplace" ng-click="pageIsBackup()">\u4FDD\u5B58\u4E3A\u66FF\u6362\u5E03\u5C40</div><div class="c-editor-attribute-view-btn c-editor-attribute-view-btn1" ng-click="addSimple()" ng-if="!vm.thirdparty">\u4E0A\u4F20\u6837\u4F8B\u56FE</div><div class="c-editor-attribute-view-btn3"><div class="c-editor-attribute-view-btn3-text">\u67E5\u770B\u7F29\u7565\u56FE</div><div class="c-editor-attribute-view-btn3-view" ng-style="{top:attributeViewBtn3($event)?\'unset\' : \'36px\',bottom:attributeViewBtn3($event)?\'36px\' : \'unset\'}"><div class="c-editor-attribute-view-btn3-view1"><div class="c-editor-attribute-view-btn3-btn" ng-click="showThumbnailPic()">\u67E5\u770B\u5F53\u9875\u7F29\u7565\u56FE</div><div class="c-editor-attribute-view-btn3-btn" ng-click="showAllThumbnailPic()">\u67E5\u770B\u5168\u90E8\u7F29\u7565\u56FE</div></div></div></div><div ng-if="template.config.dynamic"><div class="c-editor-attribute-view-hr"></div><div class="c-editor-attribute-view-title" style="display: flex; justify-content: space-between"><span>\u7B2C\u51E0\u4E2A\u6708</span><div style="line-height: 30px; color: red" ng-if="!isSetMonth(currentPage)">\u672A\u8BBE\u7F6E</div></div><input type="number" ng-model="currentPage.config.monthIndex" ng-change="monthIndexUpdate()" style="height: 30px" ng-if="isSetMonth(currentPage)"> <input type="number" ng-model="currentPage.config.monthIndex" ng-change="monthIndexUpdate()" style="height: 30px" placeholder="\u8BF7\u8BBE\u7F6E\u7B2C\u51E0\u4E2A\u6708" ng-if="!isSetMonth(currentPage)"></div><div><div class="c-editor-attribute-view-hr"></div><div class="c-editor-attribute-view-btn" ng-click="clearImageboxImg()">\u4E00\u952E\u6E05\u9664\u76F8\u6846</div></div><div ng-if="template.config.productType == \'PHOTO\' && currentPage.config.partid === \'P0\'"><div class="c-editor-attribute-view-hr"></div><div class="c-editor-attribute-view-btn" ng-click="setOutline()">\u5200\u7EBF\u8BBE\u7F6E</div></div></div><div class="c-editor-attribute-view" ng-show="RightPanel == \'barcode\'"><div class="c-editor-attribute-view-title"><span>\u6761\u5F62\u7801\u5C3A\u5BF8</span><select ng-model="vm.unit" ng-options="unit.id as unit.name for unit in vm.units" ng-change="unitConversion()" class="c-editor-attribute-view-title-select"></select></div><div class="c-editor-attribute-view-input"><div class="c-editor-attribute-view-input-view"><span>\u5BBD</span><!-- ng-change="updateBarParameter(\'width\')" --><!-- <input type="number"\n                               ng-keypress="$event.keyCode === 13 ? updateBarParameter(\'width\') : return"\n                               ng-blur="updateBarParameter(\'width\')"\n                               max=""\n                               min="0"\n                               ng-model-options="{debounce:100}"\n                               ng-model="pageValue.barcode.width"> --><input-number ng-model="pageValue.barcode.width" on-change="updateBarParameter(\'width\')" min="1" type-style="\'two\'"></input-number></div><div class="c-editor-attribute-view-input-view"><span>\u9AD8</span><!-- ng-change="updateBarParameter(\'height\')" --><!-- <input type="number"\n                               ng-keypress="$event.keyCode === 13 ? updateBarParameter(\'height\') : return"\n                               ng-blur="updateBarParameter(\'height\')"\n                               max=""\n                               min="0"\n                               ng-model-options="{debounce:100}"\n                               ng-model="pageValue.barcode.height"> --><input-number ng-model="pageValue.barcode.height" on-change="updateBarParameter(\'height\')" min="1" type-style="\'two\'"></input-number></div></div><div class="c-editor-attribute-view-hr"></div><div class="c-editor-attribute-view-title"><span>\u5750\u6807\u5C3A\u5BF8</span><select ng-model="vm.unit" ng-options="unit.id as unit.name for unit in vm.units" ng-change="unitConversion()" class="c-editor-attribute-view-title-select"></select></div><div class="c-editor-attribute-view-input"><div class="c-editor-attribute-view-input-view"><span>x</span><!-- ng-change="updateBarParameter()" --><!-- <input type="number"\n                               ng-keypress="$event.keyCode === 13 ? updateBarParameter() : return"\n                               ng-blur="updateBarParameter()"\n                               max=""\n                               min="0"\n                               ng-model-options="{debounce:100}"\n                               ng-model="pageValue.barcode.x"> --><input-number ng-model="pageValue.barcode.x" on-change="updateBarParameter()" type-style="\'two\'"></input-number></div><div class="c-editor-attribute-view-input-view"><span>y</span><!-- ng-change="updateBarParameter()" --><!-- <input type="number"\n                               ng-keypress="$event.keyCode === 13 ? updateBarParameter() : return"\n                               ng-blur="updateBarParameter()"\n                               max=""\n                               min="0"\n                               ng-model-options="{debounce:100}"\n                               ng-model="pageValue.barcode.y"> --><input-number ng-model="pageValue.barcode.y" on-change="updateBarParameter()" type-style="\'two\'"></input-number></div></div><div class="c-editor-attribute-view-hr"></div><div class="c-editor-attribute-view-title"><span>\u65CB\u8F6C\u89D2\u5EA6</span></div><!-- ng-change="updateRotate()" --><!-- <input type="number"\n                       placeholder="\u89D2\u5EA6"\n                       ng-keypress="$event.keyCode === 13 ? updateRotate() : return"\n                       ng-blur="updateRotate()"\n                       max=""\n                       min="0"\n                       ng-model-options="{debounce:100}"\n                       ng-model="template.angle"\n                       style="height: 30px;"> --><input-number ng-model="template.angle" on-change="updateRotate()" type-style="\'one\'" min="0"></input-number></div><div class="c-editor-attribute-view" ng-show="RightPanel == \'qrcode\'"><div class="c-editor-attribute-view-title"><span>\u4E8C\u7EF4\u7801\u5C3A\u5BF8</span><select ng-model="vm.unit" ng-options="unit.id as unit.name for unit in vm.units" ng-change="unitConversion()" class="c-editor-attribute-view-title-select"></select></div><div class="c-editor-attribute-view-input"><div class="c-editor-attribute-view-input-view"><span>\u5BBD</span><!-- ng-change="updateQrcodeParameter(\'width\')" --><!-- <input type="number"\n                               ng-keypress="$event.keyCode === 13 ? updateQrcodeParameter(\'width\') : return"\n                               ng-blur="updateQrcodeParameter(\'width\')"\n                               max=""\n                               min="0"\n                               ng-model-options="{debounce:100}"\n                               ng-model="pageValue.qrcode.width"> --><input-number ng-model="pageValue.qrcode.width" on-change="updateQrcodeParameter(\'width\')" min="1" type-style="\'two\'"></input-number></div><div class="c-editor-attribute-view-input-view"><span>\u9AD8</span><!-- ng-change="updateQrcodeParameter(\'height\')" --><!-- <input type="number"\n                               ng-keypress="$event.keyCode === 13 ? updateQrcodeParameter(\'height\') : return"\n                               ng-blur="updateQrcodeParameter(\'height\')"\n                               max=""\n                               min="0"\n                               ng-model-options="{debounce:100}"\n                               ng-model="pageValue.qrcode.height"> --><input-number ng-model="pageValue.qrcode.height" on-change="updateQrcodeParameter(\'height\')" min="1" type-style="\'two\'"></input-number></div></div><div class="c-editor-attribute-view-hr"></div><div class="c-editor-attribute-view-title"><span>\u5750\u6807\u5C3A\u5BF8</span><select ng-model="vm.unit" ng-options="unit.id as unit.name for unit in vm.units" ng-change="unitConversion()" class="c-editor-attribute-view-title-select"></select></div><div class="c-editor-attribute-view-input"><div class="c-editor-attribute-view-input-view"><span>x</span><!-- <input type="number"\n                               ng-keypress="$event.keyCode === 13 ? updateQrcodeParameter() : return"\n                               ng-blur="updateQrcodeParameter()"\n                               max=""\n                               min="0"\n                               ng-model-options="{debounce:100}"\n                               ng-model="pageValue.qrcode.x"> --><input-number ng-model="pageValue.qrcode.x" on-change="updateQrcodeParameter()" type-style="\'two\'"></input-number></div><div class="c-editor-attribute-view-input-view"><span>y</span><!-- ng-change="updateQrcodeParameter()" --><!-- <input type="number"\n                               ng-keypress="$event.keyCode === 13 ? updateQrcodeParameter() : return"\n                               ng-blur="updateQrcodeParameter()"\n                               max=""\n                               min="0"\n                               ng-model-options="{debounce:100}"\n                               ng-model="pageValue.qrcode.y"> --><input-number ng-model="pageValue.qrcode.y" on-change="updateQrcodeParameter()" type-style="\'two\'"></input-number></div></div><div class="c-editor-attribute-view-hr"></div><div class="c-editor-attribute-view-title"><span>\u65CB\u8F6C\u89D2\u5EA6</span></div><!-- ng-change="updateRotate()" --><!-- <input type="number"\n                       placeholder="\u89D2\u5EA6"\n                       ng-keypress="$event.keyCode === 13 ? updateRotate() : return"\n                       ng-blur="updateRotate()"\n                       max=""\n                       min="0"\n                       ng-model-options="{debounce:100}"\n                       ng-model="template.angle"\n                       style="height: 30px;"> --><input-number ng-model="template.angle" on-change="updateRotate()" type-style="\'one\'" min="0"></input-number></div><div class="c-editor-attribute-view" ng-show="RightPanel==\'text\'"><div class="c-editor-attribute-view-title"><span>\u6587\u5B57\u5C3A\u5BF8</span><select ng-model="vm.unit" ng-options="unit.id as unit.name for unit in vm.units" ng-change="unitConversion()" class="c-editor-attribute-view-title-select"></select></div><div class="c-editor-attribute-view-input"><div class="c-editor-attribute-view-input-view" style="width: 100%"><span>\u5BBD</span><!-- ng-change="updateBoxParameter()" --><!-- <input type="number"\n                               ng-keypress="$event.keyCode === 13 ? updateBoxParameter() : return"\n                               ng-blur="updateBoxParameter()"\n                               max=""\n                               min="0"\n                               ng-model-options="{debounce:100}"\n                               ng-model="pageValue.textbox.width"> --><input-number ng-model="pageValue.textbox.width" on-change="updateBoxParameter()" min="1" type-style="\'two\'"></input-number></div></div><div class="c-editor-attribute-view-hr"></div><div class="c-editor-attribute-view-title"><span>\u5750\u6807\u5C3A\u5BF8</span><select ng-model="vm.unit" ng-options="unit.id as unit.name for unit in vm.units" ng-change="unitConversion()" class="c-editor-attribute-view-title-select"></select></div><div class="c-editor-attribute-view-input"><div class="c-editor-attribute-view-input-view"><span>x</span><!-- ng-change="updateBoxParameter(\'x\',\'offsetXM\')" --><!-- <input type="number"\n                               ng-keypress="$event.keyCode === 13 ? updateBoxParameter(\'x\',\'offsetXM\') : return"\n                               ng-blur="updateBoxParameter(\'x\',\'offsetXM\')"\n                               max=""\n                               min="0"\n                               ng-model-options="{debounce:100}"\n                               ng-model="pageValue.textbox.x"> --><input-number ng-model="pageValue.textbox.x" on-change="updateBoxParameter(\'x\',\'offsetXM\')" type-style="\'two\'"></input-number></div><div class="c-editor-attribute-view-input-view"><span>y</span><!-- ng-change="updateBoxParameter(\'y\',\'offsetYM\')" --><!-- <input type="number"\n                               ng-keypress="$event.keyCode === 13 ? updateBoxParameter(\'y\',\'offsetXM\') : return"\n                               ng-blur="updateBoxParameter(\'y\',\'offsetXM\')"\n                               max=""\n                               min="0"\n                               ng-model-options="{debounce:100}"\n                               ng-model="pageValue.textbox.y"> --><input-number ng-model="pageValue.textbox.y" on-change="updateBoxParameter(\'y\',\'offsetYM\')" type-style="\'two\'"></input-number></div></div><div class="c-editor-attribute-view-hr"></div><div class="c-editor-attribute-view-title"><span>\u65CB\u8F6C\u89D2\u5EA6</span></div><!-- ng-change="updateRotate()" --><!-- <input type="number"\n                       placeholder="\u89D2\u5EA6"\n                       ng-keypress="$event.keyCode === 13 ? updateRotate() : return"\n                       ng-blur="updateRotate()"\n                       max=""\n                       min="0"\n                       ng-model-options="{debounce:100}"\n                       ng-model="template.angle"\n                       style="height: 30px;"> --><input-number ng-model="template.angle" on-change="updateRotate()" step="1" type-style="\'one\'" min="0"></input-number><div class="c-editor-attribute-view-hr"></div><div class="c-editor-attribute-view-title"><span>\u6587\u5B57\u8BBE\u7F6E</span></div><div class="c-editor-attribute-view-1"><div ng-click="editableSel(\'textbox\',true)" ng-class="{\'c-editor-attribute-view-1-selected\':currentPage.levels.level[template.levelI].textbox.editable}">\u53EF\u7F16\u8F91</div><div ng-click="editableSel(\'textbox\',false)" ng-class="{\'c-editor-attribute-view-1-selected\':!currentPage.levels.level[template.levelI].textbox.editable}">\u4E0D\u53EF\u7F16\u8F91</div></div><div class="c-editor-attribute-view-1 mt20"><div ng-click="movableSel(\'textbox\',true)" ng-class="{\'c-editor-attribute-view-1-selected\':currentPage.levels.level[template.levelI].textbox.movable}">\u53EF\u79FB\u52A8</div><div ng-click="movableSel(\'textbox\',false)" ng-class="{\'c-editor-attribute-view-1-selected\':!currentPage.levels.level[template.levelI].textbox.movable}">\u4E0D\u53EF\u79FB\u52A8</div></div><!--                <div class="c-editor-attribute-view-hr"></div>--><!--                <div class="c-editor-attribute-view-title">--><!--                    <span>\u6587\u5B57\u5185\u5BB9</span>--><!--                </div>--><!--                <textarea class="c-textarea1" ng-model="vm.text" ng-trim="false" style="width: 100%;"--><!--                          ng-focus="verifyTextFocus()" ng-blur="verifyText($event)"></textarea>--><div ng-if="selectBox.current == \'imagebox\'||selectBox.current == \'textbox\'"><div class="c-editor-attribute-view-hr"></div><div class="c-editor-attribute-view-title"><span>\u662F\u5426\u8BBE\u4E3A\u53EF\u53D8\u6570\u636E</span></div><div class="c-editor-attribute-view-1 mt20"><div ng-click="setVariable(1)" ng-class="{\'c-editor-attribute-view-1-selected\':currentPage.levels.level[template.levelI].variable}">\u662F</div><div ng-click="setVariable(0)" ng-class="{\'c-editor-attribute-view-1-selected\':!currentPage.levels.level[template.levelI].variable}">\u5426</div></div><div class="c-editor-attribute-view-hr"></div><div class="c-editor-attribute-view-title"><span>\u6570\u636E\u540D\u79F0</span></div><textarea class="c-textarea1" ng-model="currentPage.levels.level[template.levelI].name" style="width: 100%" placeholder="\u8BF7\u8F93\u5165\u6570\u636E\u540D\u79F0"></textarea></div></div><div class="c-editor-attribute-view" ng-show="RightPanel==\'textDoc\'"><div class="c-editor-attribute-view-title"><span>\u6587\u5B57\u6A21\u677F\u5C3A\u5BF8</span><select ng-model="vm.unit" ng-options="unit.id as unit.name for unit in vm.units" ng-change="unitConversion()" class="c-editor-attribute-view-title-select"></select></div><div class="c-editor-attribute-view-input"><div class="c-editor-attribute-view-input-view"><span>\u5BBD</span><!-- ng-change="updatetextDocParameter(\'width\')" --><!-- <input type="number"\n                               ng-keypress="$event.keyCode === 13 ? updatetextDocParameter(\'width\') : return"\n                               ng-blur="updatetextDocParameter(\'width\')"\n                               max=""\n                               min="0"\n                               ng-model-options="{debounce:100}"\n                               ng-model="pageValue.textdocument.width"> --><input-number ng-model="pageValue.textdocument.width" on-change="updatetextDocParameter(\'width\')" min="1" type-style="\'two\'"></input-number></div><div class="c-editor-attribute-view-input-view"><span>\u9AD8</span><!-- ng-change="updatetextDocParameter(\'height\')"  --><!-- <input type="number"\n                               ng-keypress="$event.keyCode === 13 ? updatetextDocParameter(\'height\') : return"\n                               ng-blur="updatetextDocParameter(\'height\')"\n                               max=""\n                               min="0"\n                               ng-model-options="{debounce:100}"\n                               ng-model="pageValue.textdocument.height"> --><input-number ng-model="pageValue.textdocument.height" on-change="updatetextDocParameter(\'height\')" min="1" type-style="\'two\'"></input-number></div></div><div class="c-editor-attribute-view-hr"></div><div class="c-editor-attribute-view-title"><span>\u5750\u6807\u5C3A\u5BF8</span><select ng-model="vm.unit" ng-options="unit.id as unit.name for unit in vm.units" ng-change="unitConversion()" class="c-editor-attribute-view-title-select"></select></div><div class="c-editor-attribute-view-input"><div class="c-editor-attribute-view-input-view"><span>x</span><!-- ng-change="updateBoxParameter(\'x\')" --><!-- <input type="number"\n                               ng-keypress="$event.keyCode === 13 ? updateBoxParameter(\'x\') : return"\n                               ng-blur="updateBoxParameter(\'x\')"\n                               max=""\n                               min="0"\n                               ng-model-options="{debounce:100}"\n                               ng-model="pageValue.textdocument.x"> --><input-number ng-model="pageValue.textdocument.x" on-change="updateBoxParameter(\'x\')" type-style="\'two\'"></input-number></div><div class="c-editor-attribute-view-input-view"><span>y</span><!-- ng-change="updateBoxParameter(\'y\')" --><!-- <input type="number"\n                               ng-keypress="$event.keyCode === 13 ? updateBoxParameter(\'y\') : return"\n                               ng-blur="updateBoxParameter(\'y\')"\n                               max=""\n                               min="0"\n                               ng-model-options="{debounce:100}"\n                               ng-model="pageValue.textdocument.y"> --><input-number ng-model="pageValue.textdocument.y" on-change="updateBoxParameter(\'y\')" type-style="\'two\'"></input-number></div></div><div class="c-editor-attribute-view-hr"></div><div class="c-editor-attribute-view-title"><span>\u65CB\u8F6C\u89D2\u5EA6</span></div><!-- ng-change="updateRotate()" --><!-- <input type="number"\n                       placeholder="\u89D2\u5EA6"\n                       ng-keypress="$event.keyCode === 13 ? updateRotate() : return"\n                       ng-blur="updateRotate()"\n                       max=""\n                       min="0"\n                       ng-model-options="{debounce:100}"\n                       ng-model="template.angle" style="height: 30px;"> --><input-number ng-model="template.angle" on-change="updateRotate()" step="1" type-style="\'one\'" min="0"></input-number><div class="c-editor-attribute-view-hr"></div><div class="c-editor-attribute-view-title"><span>\u6587\u5B57\u6A21\u677F\u8BBE\u7F6E</span></div><div class="c-editor-attribute-view-1"><div ng-click="editableSel(\'textdocument\',true)" ng-class="{\'c-editor-attribute-view-1-selected\':currentPage.levels.level[template.levelI].textdocument.editable}">\u53EF\u7F16\u8F91</div><div ng-click="editableSel(\'textdocument\',false)" ng-class="{\'c-editor-attribute-view-1-selected\':!currentPage.levels.level[template.levelI].textdocument.editable}">\u4E0D\u53EF\u7F16\u8F91</div></div><div class="c-editor-attribute-view-1 mt20"><div ng-click="movableSel(\'textdocument\',true)" ng-class="{\'c-editor-attribute-view-1-selected\':currentPage.levels.level[template.levelI].textdocument.movable}">\u53EF\u79FB\u52A8</div><div ng-click="movableSel(\'textdocument\',false)" ng-class="{\'c-editor-attribute-view-1-selected\':!currentPage.levels.level[template.levelI].textdocument.movable}">\u4E0D\u53EF\u79FB\u52A8</div></div><!--                <div class="c-editor-attribute-view-hr"></div>--><!--                <div class="c-editor-attribute-view-title">--><!--                    <span>\u6587\u5B57\u5185\u5BB9</span>--><!--                </div>--><!--                <textarea class="c-textarea1" ng-model="vm.textDocCon" style="width: 100%;"></textarea>--></div><div class="c-editor-attribute-view" ng-show="RightPanel==\'mask\'||RightPanel==\'placement\'"><div class="c-editor-attribute-view-title"><span>\u8499\u7248\u5C3A\u5BF8</span><select ng-model="vm.unit" ng-options="unit.id as unit.name for unit in vm.units" ng-change="unitConversion()" class="c-editor-attribute-view-title-select"></select></div><div class="c-editor-attribute-view-input"><div class="c-editor-attribute-view-input-view"><span>\u5BBD</span><!-- ng-change="updateBoxParameter()" --><!-- <input type="number"\n                               ng-keypress="$event.keyCode === 13 ? updateBoxParameter() : return"\n                               ng-blur="updateBoxParameter()"\n                               max=""\n                               min="0"\n                               ng-model-options="{debounce:100}"\n                               ng-model="pageValue.imagebox.width"> --><input-number ng-model="pageValue.imagebox.width" on-change="updateBoxParameter()" min="1" type-style="\'two\'"></input-number></div><div class="c-editor-attribute-view-input-view"><span>\u9AD8</span><!-- ng-change="updateBoxParameter()" --><!-- <input type="number"\n                               ng-keypress="$event.keyCode === 13 ? updateBoxParameter() : return"\n                               ng-blur="updateBoxParameter()"\n                               max=""\n                               min="0"\n                               ng-model-options="{debounce:100}"\n                               ng-model="pageValue.imagebox.height"> --><input-number ng-model="pageValue.imagebox.height" on-change="updateBoxParameter()" min="1" type-style="\'two\'"></input-number></div></div><div class="c-editor-attribute-view-hr"></div><div class="c-editor-attribute-view-title"><span>\u5750\u6807\u5C3A\u5BF8</span><select ng-model="vm.unit" ng-options="unit.id as unit.name for unit in vm.units" ng-change="unitConversion()" class="c-editor-attribute-view-title-select"></select></div><div class="c-editor-attribute-view-input"><div class="c-editor-attribute-view-input-view"><span>x</span><!-- ng-change="updateBoxParameter()" --><!-- <input type="number"\n                               ng-keypress="$event.keyCode === 13 ? updateBoxParameter() : return"\n                               ng-blur="updateBoxParameter()"\n                               max=""\n                               min="0"\n                               ng-model-options="{debounce:100}"\n                               ng-model="pageValue.imagebox.x"> --><input-number ng-model="pageValue.imagebox.x" on-change="updateBoxParameter()" type-style="\'two\'"></input-number></div><div class="c-editor-attribute-view-input-view"><span>y</span><!-- ng-change="updateBoxParameter()" --><!-- <input type="number"\n                               ng-keypress="$event.keyCode === 13 ? updateBoxParameter() : return"\n                               ng-blur="updateBoxParameter()"\n                               max=""\n                               min="0"\n                               ng-model-options="{debounce:100}"\n                               ng-model="pageValue.imagebox.y"> --><input-number ng-model="pageValue.imagebox.y" on-change="updateBoxParameter()" type-style="\'two\'"></input-number></div></div><div class="c-editor-attribute-view-hr"></div><div class="c-editor-attribute-view-title"><span>\u65CB\u8F6C\u89D2\u5EA6</span></div><!-- ng-change="updateRotate()" --><!-- <input type="number"\n                       placeholder="\u89D2\u5EA6"\n                       ng-keypress="$event.keyCode === 13 ? updateRotate() : return"\n                       ng-blur="updateRotate()"\n                       max=""\n                       min="0"\n                       ng-model-options="{debounce:100}"\n                       ng-model="template.angle"\n                       style="height: 30px;"> --><input-number ng-model="template.angle" on-change="updateRotate()" type-style="\'one\'" min="0"></input-number><div class="c-editor-attribute-view-btn c-editor-attribute-view-btn1 mt20" ng-click="delPic()" ng-if="selectBox.image&&selectBox.image.resource&&selectBox.image.resource.identifier">\u6E05\u9664\u56FE\u7247</div><div ng-if="selectBox.current == \'imagebox\'||selectBox.current == \'textbox\'"><div class="c-editor-attribute-view-hr"></div><div class="c-editor-attribute-view-title"><span>\u662F\u5426\u8BBE\u4E3A\u53EF\u53D8\u6570\u636E</span></div><div class="c-editor-attribute-view-1"><div ng-click="setVariable(1)" ng-class="{\'c-editor-attribute-view-1-selected\':currentPage.levels.level[template.levelI].variable}">\u662F</div><div ng-click="setVariable(0)" ng-class="{\'c-editor-attribute-view-1-selected\':!currentPage.levels.level[template.levelI].variable}">\u5426</div></div><div class="c-editor-attribute-view-hr"></div><div class="c-editor-attribute-view-title"><span>\u6570\u636E\u540D\u79F0</span></div><textarea class="c-textarea1" ng-model="currentPage.levels.level[template.levelI].name" style="width: 100%" placeholder="\u8BF7\u8F93\u5165\u6570\u636E\u540D\u79F0"></textarea></div></div><div class="c-editor-attribute-view" ng-show="RightPanel==\'material\'"><div class="c-editor-attribute-view-title"><span>\u7D20\u6750\u5C3A\u5BF8</span><select ng-model="vm.unit" ng-options="unit.id as unit.name for unit in vm.units" ng-change="unitConversion()" class="c-editor-attribute-view-title-select"></select></div><div class="c-editor-attribute-view-input"><div class="c-editor-attribute-view-input-view"><span>\u5BBD</span><!-- ng-change="updateBoxParameter(\'width\')" --><!-- <input type="number"\n                               ng-keypress="$event.keyCode === 13 ? updateBoxParameter(\'width\') : return"\n                               ng-blur="updateBoxParameter(\'width\')"\n                               max=""\n                               min="0"\n                               ng-model-options="{debounce:100}"\n                               ng-model="pageValue.imageart.width"> --><input-number ng-model="pageValue.imageart.width" on-change="updateBoxParameter(\'width\')" min="1" type-style="\'two\'"></input-number></div><div class="c-editor-attribute-view-input-view"><span>\u9AD8</span><!-- ng-change="updateBoxParameter(\'height\')" --><!-- <input type="number"\n                               ng-keypress="$event.keyCode === 13 ? updateBoxParameter(\'height\') : return"\n                               ng-blur="updateBoxParameter(\'height\')"\n                               max=""\n                               min="0"\n                               ng-model-options="{debounce:100}"\n                               ng-model="pageValue.imageart.height"> --><input-number ng-model="pageValue.imageart.height" on-change="updateBoxParameter(\'height\')" min="1" type-style="\'two\'"></input-number></div></div><div class="c-editor-attribute-view-hr"></div><div class="c-editor-attribute-view-title"><span>\u5750\u6807\u5C3A\u5BF8</span><select ng-model="vm.unit" ng-options="unit.id as unit.name for unit in vm.units" ng-change="unitConversion()" class="c-editor-attribute-view-title-select"></select></div><div class="c-editor-attribute-view-input"><div class="c-editor-attribute-view-input-view"><span>x</span><!-- ng-change="updateBoxParameter(\'x\')" --><!-- <input type="number"\n                               ng-keypress="$event.keyCode === 13 ? updateBoxParameter(\'x\') : return"\n                               ng-blur="updateBoxParameter(\'x\')"\n                               max=""\n                               min="0"\n                               ng-model-options="{debounce:100}"\n                               ng-model="pageValue.imageart.x"> --><input-number ng-model="pageValue.imageart.x" on-change="updateBoxParameter(\'x\')" type-style="\'two\'"></input-number></div><div class="c-editor-attribute-view-input-view"><span>y</span><!-- ng-change="updateBoxParameter(\'y\')" --><!-- <input type="number"\n                               ng-keypress="$event.keyCode === 13 ? updateBoxParameter(\'y\') : return"\n                               ng-blur="updateBoxParameter(\'y\')"\n                               max=""\n                               min="0"\n                               ng-model-options="{debounce:100}"\n                               ng-model="pageValue.imageart.y"> --><input-number ng-model="pageValue.imageart.y" on-change="updateBoxParameter(\'y\')" type-style="\'two\'"></input-number></div></div><div class="c-editor-attribute-view-hr"></div><div class="c-editor-attribute-view-title"><span>\u65CB\u8F6C\u89D2\u5EA6</span></div><!-- ng-change="updateRotate()" --><!-- <input type="number"\n                       placeholder="\u89D2\u5EA6"\n                       ng-keypress="$event.keyCode === 13 ? updateRotate() : return"\n                       ng-blur="updateRotate()"\n                       max=""\n                       min="0"\n                       ng-model-options="{debounce:100}"\n                       ng-model="template.angle"\n                       style="height: 30px;"> --><input-number ng-model="template.angle" on-change="updateRotate()" type-style="\'one\'" min="0"></input-number><div class="c-editor-attribute-view-hr"></div><div class="c-editor-attribute-view-title"><span>\u7D20\u6750\u8BBE\u7F6E</span></div><div class="c-editor-attribute-view-1"><div ng-click="editableSel(\'imageart\',true)" ng-class="{\'c-editor-attribute-view-1-selected\':currentPage.levels.level[template.levelI].imageart.editable}">\u53EF\u7F16\u8F91</div><div ng-click="editableSel(\'imageart\',false)" ng-class="{\'c-editor-attribute-view-1-selected\':!currentPage.levels.level[template.levelI].imageart.editable}">\u4E0D\u53EF\u7F16\u8F91</div></div><div class="c-editor-attribute-view-1 mt20"><div ng-click="movableSel(\'imageart\',true)" ng-class="{\'c-editor-attribute-view-1-selected\':currentPage.levels.level[template.levelI].imageart.movable}">\u53EF\u79FB\u52A8</div><div ng-click="movableSel(\'imageart\',false)" ng-class="{\'c-editor-attribute-view-1-selected\':!currentPage.levels.level[template.levelI].imageart.movable}">\u4E0D\u53EF\u79FB\u52A8</div></div><div class="c-editor-attribute-view-btn c-editor-attribute-view-btn2 mt20" ng-click="imageartToImagebox()">\u8BBE\u4E3A\u76F8\u6846</div><div class="imageartOnlyshow" ng-click="currentPage.levels.level[template.levelI].imageart.onlyshow = !currentPage.levels.level[template.levelI].imageart.onlyshow"><i class="iconfont icon-dui1" ng-style="{color:currentPage.levels.level[template.levelI].imageart.onlyshow?\'#FC6223\':\'\'}"></i> <span>\u4EC5\u63D0\u793A\u4E0D\u8F93\u51FA</span></div></div><div class="c-editor-attribute-view c-editor-attribute-view-calTitleBox" ng-show="RightPanel==\'calTitleBox\'"><div class="c-editor-attribute-view-title"><span>\u5C3A\u5BF8</span><select ng-model="vm.unit" ng-options="unit.id as unit.name for unit in vm.units" ng-change="unitConversion()" class="c-editor-attribute-view-title-select"></select></div><div class="c-editor-attribute-view-input"><div class="c-editor-attribute-view-input-view"><span>\u5BBD</span><!-- ng-change="updateBoxParameter(\'width\')" --><!-- <input type="number"\n                               ng-keypress="$event.keyCode === 13 ? updateBoxParameter(\'width\') : return"\n                               ng-blur="updateBoxParameter(\'width\')"\n                               max=""\n                               min="0"\n                               ng-model-options="{debounce:100}"\n                               ng-model="pageValue.calTitleBox.width"> --><input-number ng-model="pageValue.calTitleBox.width" on-change="updateBoxParameter(\'width\')" min="1" type-style="\'two\'"></input-number></div><div class="c-editor-attribute-view-input-view"><span>\u9AD8</span><!-- ng-change="updateBoxParameter(\'height\')" --><!-- <input type="number"\n                               ng-keypress="$event.keyCode === 13 ? updateBoxParameter(\'height\') : return"\n                               ng-blur="updateBoxParameter(\'height\')"\n                               max=""\n                               min="0"\n                               ng-model-options="{debounce:100}"\n                               ng-model="pageValue.calTitleBox.height"> --><input-number ng-model="pageValue.calTitleBox.height" on-change="updateBoxParameter(\'height\')" min="1" type-style="\'two\'"></input-number></div></div><div class="c-editor-attribute-view-hr"></div><div class="c-editor-attribute-view-title"><span>\u5750\u6807</span><select ng-model="vm.unit" ng-options="unit.id as unit.name for unit in vm.units" ng-change="unitConversion()" class="c-editor-attribute-view-title-select"></select></div><div class="c-editor-attribute-view-input"><div class="c-editor-attribute-view-input-view"><span>x</span><!-- ng-change="updateBoxParameter(\'x\')" --><!-- <input type="number"\n                               ng-keypress="$event.keyCode === 13 ? updateBoxParameter(\'x\') : return"\n                               ng-blur="updateBoxParameter(\'x\')"\n                               max=""\n                               min="0"\n                               ng-model-options="{debounce:100}"\n                               ng-model="pageValue.calTitleBox.x"> --><input-number ng-model="pageValue.calTitleBox.x" on-change="updateBoxParameter(\'x\')" type-style="\'two\'"></input-number></div><div class="c-editor-attribute-view-input-view"><span>y</span><!-- ng-change="updateBoxParameter(\'y\')" --><!-- <input type="number"\n                               ng-keypress="$event.keyCode === 13 ? updateBoxParameter(\'y\') : return"\n                               ng-blur="updateBoxParameter(\'y\')"\n                               max=""\n                               min="0"\n                               ng-model-options="{debounce:100}"\n                               ng-model="pageValue.calTitleBox.y"> --><input-number ng-model="pageValue.calTitleBox.y" on-change="updateBoxParameter(\'y\')" type-style="\'two\'"></input-number></div></div><div class="c-editor-attribute-view-hr"></div><style-setting title="true" settings="currentPage.levels.level[template.levelI].calTitleBox.settings" font-list="vm.fontList" :style="\'two\'" on-change="onSettingsChange(text)" ng-if="!vm.calTitleBoxLoading && vm.fontList.length>0"></style-setting></div><div class="c-editor-attribute-view" ng-show="RightPanel==\'calMonthBox\'" style="padding: 0"><calendar-set data="currentPage.levels.level[template.levelI].calMonthBox" page-value="pageValue" unit="vm.unit" units="vm.units" on-unit="unitConversion()" on-update-page-value="updateBoxParameter(text)" on-change="onMonthChange(text)" ng-if="RightPanel==\'calMonthBox\'"></calendar-set></div></div><div ng-if="vm.attributeTab==\'coverage\'"><div class="editor-page-element-body"><div class="editor-page-element-body-view" ng-click="selectBar($event,currentPage, \'barcode\')" ng-class="{\'selected\': RightPanel == \'barcode\'}" ng-show="currentPage.barcode&&currentPage.barcode.geometry"><div class="editor-page-element-body-view-img" style="justify-content: flex-start"><img src="content/images/txm.png" style="height: auto;max-width: 100%"></div><div class="editor-page-element-body-view-1"><div class="editor-page-element-body-view-sh" ng-click="currentPage.barcode.isHidden = !currentPage.barcode.isHidden"><i class="iconfont icon-gongkai" ng-if="!currentPage.barcode.isHidden"></i> <i class="iconfont icon-yincang" ng-if="currentPage.barcode.isHidden"></i></div><div class="editor-page-element-body-view-text">\u6761\u5F62\u7801</div><div class="editor-page-element-body-view-delete"><i class="iconfont icon-dustbin_icon" ng-click="codeDelete(\'barcode\')"></i></div></div></div><div class="editor-page-element-body-view" ng-click="selectBar($event,currentPage, \'qrcode\')" ng-class="{\'selected\': RightPanel == \'qrcode\'}" ng-show="currentPage.qrcode&&currentPage.qrcode.geometry"><div class="editor-page-element-body-view-img"><img src="content/images/QrCode.png"></div><div class="editor-page-element-body-view-1"><div class="editor-page-element-body-view-sh" ng-click="currentPage.qrcode.isHidden = !currentPage.qrcode.isHidden"><i class="iconfont icon-gongkai" ng-if="!currentPage.qrcode.isHidden"></i> <i class="iconfont icon-yincang" ng-if="currentPage.qrcode.isHidden"></i></div><div class="editor-page-element-body-view-text">\u4E8C\u7EF4\u7801</div><div class="editor-page-element-body-view-delete"><i class="iconfont icon-dustbin_icon" ng-click="codeDelete(\'qrcode\')"></i></div></div></div><div id="pageList1" ng-show="currentPage && currentPage.levels && currentPage.levels.level"><div class="editor-page-element-body-view" ng-repeat="level in currentPage.levels.level | reverse"><div class="sortingPageView" data-page="{{level}}"><div class="editor-page-element-body-view-img" ng-class="{\'selected\' : completeIndex($index) == template.levelI && RightPanel && !(RightPanel == \'qrcode\' || RightPanel == \'barcode\')}" ng-click="levelClick($event, level, $index)"><img ng-if="level.imagebox && !level.imagebox.image" src="content/images/icons/photo-icon.png"> <img ng-if="level.calTitleBox" src="content/images/cal-title.png"> <img ng-if="level.calMonthBox" src="content/images/cal-month.png"> <img ng-if="level.imagebox && level.imagebox.image && level.imagebox.image.resource && level.imagebox.image.resource.identifier" ng-src="{{level.imagebox.image.resource.identifier + vm.pageImageView}}"> <img ng-if="level.imageart && level.imageart.resource && level.imageart.resource.identifier" ng-src="{{level.imageart.resource.identifier + vm.pageImageView}}"> <i class="iconfont icon-wenzishape" ng-if="level.textbox || level.textdocument"></i> <i class="iconfont icon-waring iconWarn" ng-if="warnInfo(level) || (level.textbox && level.textbox.success === false)" style="top: 9px"></i></div><div class="editor-page-element-body-view-1"><div class="editor-page-element-body-view-sh" ng-click="level.isHidden = !level.isHidden"><i class="iconfont icon-gongkai" ng-if="!level.isHidden"></i> <i class="iconfont icon-yincang" ng-if="level.isHidden"></i></div><div class="editor-page-element-body-view-text">{{levelInfo(level, $index)}}</div><div class="editor-page-element-body-view-delete"><i class="iconfont icon-dustbin_icon" ng-click="levelDelete($index)"></i></div></div></div></div></div></div><div class="editor-page-element-foot" ng-if="currentPage && currentPage.levels && currentPage.levels.level && currentPage.levels.level.length>0" ng-click="clearPage()">\u4E00\u952E\u6E05\u9664</div></div></div><div ng-if="vm.watchSure || vm.threeView"><div ng-if="vm.watchSure" class="preview-article"><img src="content/images/preview-bg.jpg" class="preview-bg"> <img class="preview-article-close" src="content/images/icons/close4.svg" width="40px" ng-click="vm.watchSure = false"><div class="preview-article-con" style="overflow:auto"><article-preview preview-article="vm.previewArticle" domain="vm.url"></article-preview></div></div><!-- 3D\u9884\u89C8 --><div ng-if="vm.threeView" class="preview-article"><img src="content/images/preview-bg.jpg" class="preview-bg"> <img class="preview-article-close" src="content/images/icons/close4.svg" width="40px" ng-click="vm.threeView = false"><div class="preview-article-con1"><three-preview width="700" height="700" style="background: #fff" product-xml="vm.threeProductXmlData" pages="vm.threeTemplate.pages.page"></three-preview></div></div></div></div><div class="c-modal exit-box" style="z-index:1000" ng-if="thumbnailPic"><div class="exit-box-mask"></div><div class="c-model exit-box-con" style="width: 700px;margin: 0 auto;position: relative;top: calc(50vh - 200px)" ng-if="thumbnailType==\'one\'"><div class="c-model-head"><div class="c-model-head-title">\u67E5\u770B\u5F53\u9875\u7F29\u7565\u56FE</div><i class="iconfont icon-closeicon1" ng-click="modalHide()"></i></div><div class="c-model-body"><div class="c-model-body-view"><div class="swiper-container2"><div class="swiper-wrapper"><div class="swiper-slide2"><img ng-if="currentPage.pagecover.identifier" ng-src="{{currentPage.pagecover.identifier + vm.pageImageView}}"><div ng-if="!currentPage.pagecover.identifier" style="width: 100%;height: 100%;background-color: #e2e3e7"></div></div></div></div><!-- Add Arrows --><div class="swiper-pagination2"></div></div></div></div><div class="c-model exit-box-con" style="width: 1360px;max-height: 800px;margin: 50px auto" ng-if="thumbnailType==\'all\'"><div class="c-model-head"><div class="c-model-head-title">\u67E5\u770B\u5168\u90E8\u7F29\u7565\u56FE</div><i class="iconfont icon-closeicon1" ng-click="modalHide()"></i></div><div class="c-model-body"><div class="c-model-body-view scrollbar-main" style="max-height: 660px;padding: 16px"><div class="c-thumbnail-all-body"><div class="c-thumbnail-all-body-view2"><div class="c-thumbnail-all-body-view2-li" ng-repeat="page in template.pages.page track by $index" ng-if="!page.backup"><div class="c-thumbnail-all-body-view2-li-img"><img ng-if="page.pagecover.identifier" ng-src="{{page.pagecover.identifier + vm.pageImageView}}"><div class="c-prompt" ng-if="page.isPrompt && !page.loading"><i class="iconfont icon-tishi"></i> <span>\u8D85\u65F6\u52A0\u8F7D\u5931\u8D25</span></div></div><div class="c-thumbnail-all-body-view2-li-conetnt"><span ng-if="page.config.partid == \'P\'">\u7B2C{{pageSeq(page)}}\u9875</span> <span ng-if="page.config.partid != \'P\'">{{partName(page.config.partid)}}</span><div ng-click="thisThumbnailUpdate($index)" ng-if="page.updateThumbnail"><i class="iconfont icon-zhongxuan"></i></div></div><div class="loading-font" ng-if="page.loading"></div></div></div></div></div></div><div class="c-model-foot" style="display: flex;align-items: center;justify-content: flex-end"><span>\u5171{{pageLength(template.pages.page)}}\u9875</span> <button type="button" class="btn btn-info" ng-click="allThumbnailUpdate()" style="margin-left: 16px">\u5168\u90E8\u66F4\u65B0</button></div></div></div><!-- <div class="c-modal exit-box" style="z-index:9999;" ng-if="vm.deleteSure">\n    <div class="exit-box-mask"></div>\n    <div class="c-model exit-box-con">\n        <div class="c-model-head">\n            <div class="c-model-head-title">\u63D0\u793A</div>\n            <i class="iconfont icon-closeicon1" ng-click="vm.deleteSure = false"></i>\n        </div>\n        <div class="c-model-body">\n            <div class="c-model-body-view proTempModal-text" style="height: auto;">\n                <div>\u786E\u8BA4\u8981\u5220\u9664\u5F53\u524D\u9875\u9762\u5417\uFF1F</div>\n            </div>\n        </div>\n        <div class="c-model-foot">\n            <button type="button" class="btn btn-cancel btn-max" ng-click="vm.deleteSure = false">\u53D6\u6D88</button>\n            <button type="button" class="btn btn-info btn-max" ng-click="deletePageSure()">\u786E\u5B9A</button>\n        </div>\n    </div>\n</div> --><!-- <div class="c-modal exit-box" style="z-index:9999;" ng-if="vm.exitSure">\n    <div class="exit-box-mask"></div>\n    <div class="c-model exit-box-con">\n        <div class="c-model-head">\n            <div class="c-model-head-title">\u6E29\u99A8\u63D0\u793A</div>\n            <i class="iconfont icon-closeicon1" ng-click="vm.exitSure = false"></i>\n        </div>\n        <div class="c-model-body">\n            <div class="c-model-body-view proTempModal-text" style="height: auto;">\n                <div>\u9000\u51FA\u524D\u662F\u5426\u9700\u8981\u4FDD\u5B58\u5DF2\u53D8\u66F4\u7684\u5185\u5BB9?</div>\n            </div>\n        </div>\n        <div class="c-model-foot">\n            <button type="button" class="btn btn-cancel btn-max" ng-click="exitPageHide()">\u53D6\u6D88</button>\n            <button type="button" class="btn btn-info btn-max" ng-click="exitPage()">\u786E\u5B9A</button>\n        </div>\n    </div>\n</div> --><div class="modal-property" ng-if="vm.isChoosePage"><div class="modal-mask"></div><div class="content-scroll modal-con"><div class="col-lg-12 col-sm-12 modal-t"><span class="col-md-6 col-sm-6 col-xs-6 font-16 text-left">\u65B0\u589E\u9875\u9762\u53C2\u6570\u9009\u62E9</span> <span class="col-md-6 col-sm-6 col-xs-6 text-right"><img src="content/images/icons/close1.svg" style="width: 16px" ng-click="vm.isChoosePage=false"></span></div><div class="col-lg-12 col-sm-12 pad-0 scrollbar" style="margin-top: 54px;height: 28vh"><div class="col-lg-12 col-sm-12 pad-0" style="height:40px;line-height: 40px;margin: 20px 0"><div class="col-md-4 col-sm-4 col-xs-4 text-right">\u8BF7\u9009\u62E9\u753B\u5E03\u5C3A\u5BF8</div><div class="col-md-6 col-sm-6 col-xs-8"><select ng-options="item as item.value for item in vm.addPageValue" ng-model-options="{debounce:100}" class="form-control" ng-change="updatePageValue(value)" ng-model="value"></select></div></div><div class="col-lg-2 col-sm-2 pad-0"></div><div class="col-lg-10 col-sm-10 pad-0 text-left"><div class="col-lg-12 col-sm-12 pad-0 size-height">\u753B\u5E03\u5C3A\u5BF8\uFF1A\u5BBD\uFF1A{{pageValue.mediabox.width}}mm \u9AD8\uFF1A{{pageValue.mediabox.height}}mm</div><div class="col-lg-12 col-sm-12 pad-0 size-height">\u51FA\u8840\u5C3A\u5BF8\uFF1A\u4E0A\uFF1A{{pageValue.blood.top}}mm \u4E0B\uFF1A{{pageValue.blood.bottom}}mm \u5DE6\uFF1A{{pageValue.blood.left}}mm \u53F3\uFF1A{{pageValue.blood.right}}mm</div><!--{{currentPage.blood.top}}*{{currentPage.blood.bottom}}*{{currentPage.blood.left}}*{{currentPage.blood.right}}mm--><div class="col-lg-12 col-sm-12 pad-0 size-height">\u7F16\u8F91\u533A\u57DF\uFF1A x\uFF1A{{pageValue.editbox.x}}mm y\uFF1A{{pageValue.editbox.y}}mm \u5BBD\uFF1A{{pageValue.editbox.width}}mm \u9AD8\uFF1A{{pageValue.editbox.height}}mm</div></div></div><!--<div class="col-lg-12 col-sm-12" style="height: 80px;"></div>--><div class="col-lg-12 col-sm-12 pad-0" style="border-top: 1px solid #E8E8E8"><button type="button" class="col-md-6 col-sm-6 col-xs-6" data-dismiss="modal" style="color: #232323;font-size: 15px;height: 60px;border-right:1px solid #E8E8E8" ng-click="vm.isChoosePage=false">\u53D6\u6D88</button> <button type="submit" style="background: #ffc872;color:#232323;font-size: 15px;height: 60px" class="col-md-6 col-sm-6 col-xs-6" ng-click="saveAddPageValue()">\u786E\u5B9A</button></div></div></div><div class="c-modal exit-box confirm-window" style="z-index:9999" ng-if="vm.changeProTempSure"><div class="exit-box-mask"></div><div class="confirm-dialog" style="z-index: 999;position: absolute;left: 50%;top: 50%;transform: translate(-50%, -50%)"><div class="confirm-dialog-header"><div class="confirm-dialog-title">\u6E29\u99A8\u63D0\u793A</div><span class="iconfont icon-closeicon1" ng-click="vm.changeProTempSure = false"></span></div><div class="confirm-dialog-content"><span>{{vm.proTempTitle}}</span> <span style="color: #264DF0">{{vm.proTempText}}</span></div><div class="confirm-dialog-footer"><button class="confirm-dialog-footer-cancel" ng-click="vm.changeProTempSure = false" style="margin-right: 16px">\u53D6\u6D88</button> <button class="confirm-dialog-footer-delete" ng-click="exitChangeProTemp()">\u786E\u5B9A</button></div></div></div><div class="c-thumbnail-view" ng-if="vm.isPageThumbnail" ng-click="pageThumbnailHide($event)"><img style="width: 300px; height: auto" ng-src="{{vm.pageThumbnails[vm.pageThumbnailsIndex].pagecover.identifier + vm.pageImageView}}" ng-click="pageThumbnailHide1($event)"> <i class="iconfont icon-closeicon1" ng-click="vm.isPageThumbnail = false"></i></div><!--\u6587\u6863\u68C0\u6D4B--><div class="c-modal c-modal1" data-html2canvas-ignore ng-if="!vm.documentDetection.pass"><div class="c-modal-view"><div class="c-modal-head"><p>\u6587\u6863\u68C0\u6D4B</p><span class="c-modal-hide" ng-click="vm.documentDetection.pass=true">X</span></div><div class="c-modal-body"><div class="c-documentDetection-tab"><div ng-class="{\'c-documentDetection-tab-select\' : vm.documentDetectionTab==\'text\'}" ng-click="vm.documentDetectionTab=\'text\'" ng-if="vm.documentDetection.isText">\u6587\u5B57\u5931\u6548\u68C0\u6D4B</div><div ng-class="{\'c-documentDetection-tab-select\' : vm.documentDetectionTab==\'repetition\'}" ng-click="vm.documentDetectionTab=\'repetition\'" ng-if="vm.documentDetection.isRepetition">\u5143\u7D20\u91CD\u53E0\u68C0\u6D4B</div></div><div class="dialog-content hover-scrollbar" style="max-height: 800px; overflow: auto" ng-if="vm.documentDetectionTab==\'text\'"><div><i class="iconfont icon-waring mad-right-6" style="color: #FF6E33"></i>\u68C0\u6D4B\u51FA\u4EE5\u4E0B\u9875\u9762\u6587\u5B57\u4F7F\u7528\u7684\u5B57\u4F53\u5DF2\u5931\u6548\uFF0C\u4F5C\u54C1\u4FDD\u5B58\u4E2D\u65AD\uFF0C\u8BF7\u524D\u5F80\u8C03\u6574\uFF0C\u5982\u679C\u65E0\u6CD5\u4FEE\u6539\u8BF7\u8054\u7CFB\u5BA2\u670D\u3002</div><div class="c-documentDetection-view mar-top-10" ng-repeat="page in vm.documentDetection.pages" ng-if="page.texts && page.texts.length>0"><div class="c-documentDetection-view-title">\u7B2C{{page.pageIndex}}\u9875</div><div class="c-documentDetection-view-1"><div class="c-documentDetection-view-1-li-text" ng-repeat="item in page.texts" ng-if="page.texts && page.texts.length>0">{{item.text}}</div></div></div></div><div class="dialog-content hover-scrollbar" style="max-height: 800px; overflow: auto" ng-if="vm.documentDetectionTab==\'repetition\'"><div><i class="iconfont icon-waring mad-right-6" style="color: #FF6E33"></i>\u68C0\u6D4B\u51FA\u4EE5\u4E0B\u9875\u9762\u5B58\u5728\u5143\u7D20\u91CD\u53E0\uFF0C\u4F5C\u54C1\u4FDD\u5B58\u4E2D\u65AD\uFF0C\u8BF7\u524D\u5F80\u8C03\u6574\uFF0C\u5982\u679C\u65E0\u6CD5\u4FEE\u6539\u8BF7\u8054\u7CFB\u5BA2\u670D\u3002</div><div class="c-documentDetection-view mar-top-10" ng-repeat="page in vm.documentDetection.pages" ng-if="page.repetitions && page.repetitions.length>0"><div class="c-documentDetection-view-title">\u7B2C{{page.pageIndex}}\u9875</div><div class="c-documentDetection-view-1"><div class="c-documentDetection-view-1-li" ng-repeat="level in page.repetitions"><div class="c-documentDetection-view-1-li-fl"><img ng-if="level.imagebox && !level.imagebox.image" src="content/images/icons/photo-icon.svg"> <img ng-if="level.imagebox && level.imagebox.image && level.imagebox.image.resource && level.imagebox.image.resource.identifier" ng-src="{{level.imagebox.image.resource.identifier + vm.pageImageView}}"> <img ng-if="level.imageart && level.imageart.resource && level.imageart.resource.identifier" ng-src="{{level.imageart.resource.identifier + vm.pageImageView}}"> <i class="iconfont icon-zitidaxiao-" ng-if="level.textbox || level.textdocument" style="color: #fff"></i></div><div class="c-documentDetection-view-1-li-fr">{{levelInfo(level)}}</div></div></div></div></div></div><div class="c-modal-foot" style="display: flex; justify-content: center"><button class="c-editor-head-btn4" ng-click="vm.documentDetection.pass=true">\u53D6\u6D88</button> <button class="c-editor-head-btn2" style="margin-left: 10px" ng-click="vm.documentDetection.pass=true">\u524D\u5F80\u8C03\u6574</button></div></div></div><!--\u52A8\u6001\u65E5\u5386\u8FDE\u7EED\u6708\u68C0\u6D4B--><div class="c-modal exit-box confirm-window" style="z-index:9999" ng-if="vm.isCalendar"><div class="exit-box-mask"></div><div class="confirm-dialog" style="z-index: 999;position: absolute;left: 50%;top: 50%;transform: translate(-50%, -50%)"><div class="confirm-dialog-header"><div class="confirm-dialog-title">\u63D0\u793A</div><span class="iconfont icon-closeicon1" ng-click="vm.isCalendar = false"></span></div><div class="confirm-dialog-content"><div class="">\u5F53\u524D\u52A8\u6001\u65E5\u5386\u6A21\u677F\u5176\u5B9E\u5E74\u6708\u4E3A\uFF1A<span></span>\u5E74<span></span>\u6708-<span></span>\u5E74<span></span>\u6708</div><div>\u68C0\u6D4B\u5230\u6708\u4EFD\u91CD\u62C5\uFF0C\u4EE5\u4E0B\u6708\u4EFD\u4E0D\u5B58\u5728\uFF0C\u662F\u5426\u786E\u8BA4\u53D1\u5E03\uFF1F</div><div class="c-isCalendar-view1"><div class="c-isCalendar-view1-1">2023</div><div class="c-isCalendar-view1-2"><span>\u4E09\u6708</span> <span>\u56DB\u6708</span></div></div></div><div class="confirm-dialog-footer"><button class="confirm-dialog-footer-cancel" ng-click="vm.isCalendar = false" style="margin-right: 16px">\u53D6\u6D88</button> <button class="confirm-dialog-footer-delete" ng-click="savePage()">\u786E\u5B9A</button></div></div></div><!-- \u52A8\u6001\u65E5\u5386\u6708\u4EFD\u662F\u5426\u6709\u8BBE\u7F6E --><div class="c-modal exit-box confirm-window" style="z-index:9999" ng-if="vm.issetMonth"><div class="exit-box-mask"></div><div class="confirm-dialog" style="z-index: 999;position: absolute;left: 50%;top: 50%;transform: translate(-50%, -50%); width: 800px"><div class="confirm-dialog-header"><div class="confirm-dialog-title">\u63D0\u793A</div><span class="iconfont icon-closeicon1" ng-click="vm.issetMonth = false"></span></div><div style="line-height: 30px; font-size: 16px;color: #333">\u68C0\u6D4B\u5230\u4EE5\u4E0B\u9875\u9762\u672A\u8BBE\u7F6E\u6708\u5E8F\uFF0C\u65E0\u6CD5\u53D1\u5E03\uFF0C\u8BF7\u524D\u5F80\u8C03\u6574\u3002</div><div class="confirm-dialog-content scrollbar-main" style="max-height: 500px;overflow: auto"><div class="c-document-detection-body-view2-1-conent-li-item"><div class="c-document-detection-body-view2-1-conent-li-item-view" ng-repeat="page in vm.serialNumberPages"><div class="c-document-detection-body-view2-1-conent-li-item-view-img"><img ng-src="{{page.pagecover.identifier}}" alt=""></div><div class="c-document-detection-body-view2-1-conent-li-item-view-describe"><div class="c-document-detection-body-view2-1-conent-li-item-view-describe-index">{{pageSeq1(page)}}</div></div></div></div></div><div class="confirm-dialog-footer" style="display: flex; justify-content: space-between; align-items: center; margin-top: 10px"><div><i class="iconfont icon-jinggao"></i> <span>\u5F53\u9875\u9762\u4E2D\u5B58\u5728\u65E5\u5386\u6807\u9898/\u65E5\u5386\u7EC4\u4EF6\u65F6\uFF0C\u9700\u8981\u5173\u8054\u9875\u9762\u6708\u5E8F\uFF0C\u5982\u4E0D\u9700\u8981\u8BF7\u524D\u5F80\u5220\u9664\u7EC4\u4EF6</span></div><button class="c-editor-head-btn2" ng-click="vm.issetMonth = false">\u524D\u5F80\u8C03\u6574</button></div></div></div><!--\u52A0\u8F7D\u4E2D--><div class="c-loading" ng-if="vm.loadingImg || vm.isSaving"></div><style>.c-modal-btn {\n        width: 120px;\n        height: 40px;\n        line-height: 40px;\n        border-radius: 4px;\n        text-align: center;\n    }\n\n    .c-modal-btn-hide {\n        color: #232323;\n        background: #fff;\n        border: 1px solid #ddd;\n    }\n\n    .swiper-container2 {\n        width: 20vw;\n        height: 22vh;\n        margin: 10px auto 30px;\n    }\n\n    .swiper-button-next2 {\n        position: absolute;\n        right: 40px;\n        outline: none;\n    }\n\n    .swiper-pagination2 {\n        position: absolute;\n        bottom: 10px;\n        width: 100%;\n    }\n\n    .swiper-button-prev2 {\n        position: absolute;\n        left: 40px;\n        outline: none;\n    }\n\n    .swiper-slide2 {\n        text-align: center;\n        font-size: 18px;\n        background: #fff;\n        line-height: 22vh;\n        margin: 0 auto;\n    }\n\n    .swiper-slide2 img {\n        max-width: 100%;\n        max-height: 100%;\n        box-shadow: 0 2px 5px rgba(187, 187, 187, 0.6);\n    }\n\n    .tooltip {\n        z-index: 99999;\n    }</style><!-- \u6587\u5B57 --><div style="opacity: 0; position: fixed" ng-style="{\'width\': (template.pages.page[template.pageI].trimbox.width-10)}"><pre id="c-xml-page-material-fontId" style="display: inline-block; opacity: 0" ng-style="{\n    \'font-family\': \'\\\'\' + vm.fontHide.fontuuid + \'\\\'\',\n    \'font-size\': (vm.fontHide.style.size) + \'pt\',\n    \'color\': vm.fontHide.style.color,\n    \'font-weight\': vm.fontHide.style.bold ? \'bold\': \'400\',\n    \'font-style\': vm.fontHide.style.italic ? \'italic\': \'initial\',\n    \'line-height\': (vm.fontHide.style.lineheight) + \'pt\',\n    \'letter-spacing\': (vm.fontHide.style.letterspacing) + \'pt\',\n    \'text-decoration\': \'none\',\n    \'text-align-last\': \'unset\',\n    \'max-width\' : \'100%\',\n    \'writing-mode\': vm.fontHide.style.writingmode\n    }"><span class="c-xml-page-textboxe-span">{{vm.fontHide.text}}</span></pre></div><div style="opacity: 0; position: fixed" ng-style="{\n            \'width\': writingmodeInit(selectBox.style.writingmode) ? \'auto\' : (selectBox.geometry.width),\n            \'height\': !writingmodeInit(selectBox.style.writingmode) ? \'auto\' : (selectBox.geometry.height)\n            }"><pre id="c-xml-page-material-fontId1" style="display: inline-block; opacity: 0" ng-style="{\n                    \'font-family\': \'\\\'\' + selectBox.fontuuid + \'\\\'\',\n                    \'font-size\': (selectBox.style.size) + \'pt\',\n                    \'color\': selectBox.style.color,\n                    \'font-weight\': selectBox.style.bold ? \'bold\': \'400\',\n                    \'font-style\': selectBox.style.italic ? \'italic\': \'initial\',\n                    \'line-height\': (selectBox.style.lineheight) + \'pt\',\n                    \'letter-spacing\': (selectBox.style.letterspacing) + \'pt\',\n                    \'text-decoration\': \'none\',\n                    \'text-align-last\': \'unset\',\n                    \'max-width\' : \'100%\',\n                    \'writing-mode\': selectBox.style.writingmode\n                    }"><span class="c-xml-page-textboxe-span">{{selectBox.text}}</span></pre></div><div style="opacity: 0; position: fixed" ng-style="{\n        \'width\': writingmodeInit(vm.textEditor.style.writingmode) ? \'auto\' : (vm.textEditor.geometry.width),\n        \'height\': !writingmodeInit(vm.textEditor.style.writingmode) ? \'auto\' : (vm.textEditor.geometry.height)\n        }"><pre id="c-xml-page-material-fontId2" style="display: inline-block; opacity: 0" ng-style="{\n        \'font-family\': \'\\\'\' + vm.textEditor.fontuuid + \'\\\'\',\n        \'font-size\': (vm.textEditor.style.size) + \'pt\',\n        \'color\': vm.textEditor.style.color,\n        \'font-weight\': vm.textEditor.style.bold ? \'bold\': \'400\',\n        \'font-style\': vm.textEditor.style.italic ? \'italic\': \'initial\',\n        \'line-height\': (vm.textEditor.style.lineheight) + \'pt\',\n        \'letter-spacing\': (vm.textEditor.style.letterspacing) + \'pt\',\n        \'text-decoration\': \'none\',\n        \'text-align-last\':\'unset\',\n        \'max-width\' : \'100%\',\n        \'writing-mode\': vm.textEditor.style.writingmode\n        }"><span class="c-xml-page-textboxe-span">{{vm.textEditor.text}}</span></pre></div><outline-view ng-if="vm.isOutline" page="currentPage" on-change="outlineChange(text)"></outline-view><style>.roundedSet-8 {\n        left: 0;\n    }\n\n    .roundedSet-8 ::after {\n        left: 8%;\n    }\n    .confirm-window .modal-content{\n        width: 528px;\n        border-radius: 8px;\n    }\n    .leftPanel-bg-choose-color{\n        top: 0 !important;\n    }\n    .c-editor-attribute-view-calTitleBox .leftPanel-bg-choose-color{\n        top: 35px !important;\n    }</style><input type="radio" id="focusInput" style="position: absolute;left: -9999px;top: -9999px;z-index: -1">');
$templateCache.put('app/entities/page/pagesmySuffix2.html','<div data-html2canvas style="position: relative"><div class="page-item2" ng-if="!lastPage.isScene" style="transform:translate(-50% -50%)!important;outline: none" ng-class="{\'custom-grid\':lastPage.background.type==\'Color\'&&!lastPage.background.color}" ng-style="{\n             width: lastPage.mediabox.width/lastPage.proportion*lastPage.scale,\n             height: lastPage.mediabox.height/lastPage.proportion*lastPage.scale\n            }"><div class="content-container2 content-page" ng-style="{\n                width: (lastPage.mediabox.width/lastPage.proportion)*lastPage.scale,\n                height: (lastPage.mediabox.height/lastPage.proportion)*lastPage.scale,\n                background:lastPage.background.type==\'Color\'?lastPage.background.color:\'\'\n                }"><img class="bg-image pos" ng-cloak ng-if="lastPage.background.type==\'Pic\'&&lastPage.background.resource.identifier" ng-src="{{lastPage.background.resource.identifier + vm.pageImageView||\'//:0\'}}" ng-style="{\n                 position: \'absolute\',\n                 left:lastPage.background.offsetx*lastPage.scale/lastPage.proportion,\n                 top:lastPage.background.offsety*lastPage.scale/lastPage.proportion,\n                 width: lastPage.background.adaptation==\'Width\'?lastPage.background.width*lastPage.scale/lastPage.proportion:\'\',\n                 height:lastPage.background.adaptation==\'Height\'?lastPage.background.height*lastPage.scale/lastPage.proportion:\'\'}"><div ng-repeat="level in lastPage.levels.level track by $index" ng-init="levelIndex = $index"><div class="imgBox" ng-show="level.imagebox.current" ng-style="{\n                        width: imageboxW(level.imagebox)*lastPage.scale/lastPage.proportion,\n                        height: imageboxH(level.imagebox)*lastPage.scale/lastPage.proportion,\n                        left: imageboxL(level.imagebox)*lastPage.scale/lastPage.proportion,\n                        top: imageboxT(level.imagebox)*lastPage.scale/lastPage.proportion,\n                        \'opacity\':level.imagebox.transparency,\n                        \'z-index\':level.seq-0+200,\n                        \'transform\': \'rotate(-\' + level.imagebox.rotation.angle + \'deg)\'}"><div class="relative-view1" ng-style="{\n                    \'overflow\': (level.imagebox.border && level.imagebox.border.type == \'Pic\') ? \'unset\' : \'hidden\',\n                        \'border-top-left-radius\':(level.imagebox.border && level.imagebox.border.type == \'Pic\') ? 0 : imageboxWRadius2(level.imagebox, \'lt\', lastPage.scale/lastPage.proportion),\n                        \'border-top-right-radius\':(level.imagebox.border && level.imagebox.border.type == \'Pic\') ? 0 : imageboxWRadius2(level.imagebox, \'rt\', lastPage.scale/lastPage.proportion),\n                        \'border-bottom-right-radius\':(level.imagebox.border && level.imagebox.border.type == \'Pic\') ? 0 : imageboxWRadius2(level.imagebox, \'rb\', lastPage.scale/lastPage.proportion),\n                        \'border-bottom-left-radius\':(level.imagebox.border && level.imagebox.border.type == \'Pic\') ? 0 : imageboxWRadius2(level.imagebox, \'lb\', lastPage.scale/lastPage.proportion),\n                        \'border-width\': (level.imagebox.border && level.imagebox.border.type == \'Color\') ? (level.imagebox.border.lineWidth*lastPage.scale/lastPage.proportion) : \'\',\n                        \'border-style\': (level.imagebox.border && level.imagebox.border.type == \'Color\' && level.imagebox.border.lineType == \'solid\') ? \'solid\' : (level.imagebox.border && level.imagebox.border.type == \'Color\' && level.imagebox.border.lineType == \'dashed\') ? \'dashed\' : (level.imagebox.border && level.imagebox.border.type == \'Color\' && level.imagebox.border.lineType == \'dotted\') ? \'dotted\' : \'none\',\n                        \'border-color\': (level.imagebox.border && level.imagebox.border.type == \'Color\') ? level.imagebox.border.color : \'\',\n                        \'box-shadow\' : (level.imagebox.border && level.imagebox.border.type == \'Color\' && level.imagebox.border.lineWidth>0 && level.imagebox.border && level.imagebox.border.lineType == \'solid\') ? \'0 0 0 1px \' + level.imagebox.border.color + \' inset\' : \'none\',\n                        \'filter\' : dropShadow(level.imagebox,lastPage.scale/lastPage.proportion),\n                        }"><div ng-style="{\n                             \'position\': \'absolute\',\n                             \'z-index\':0,\n                            \'left\': (level.imagebox.border && level.imagebox.border.type == \'Pic\') ? -imageboxWEdge(level.imagebox,\'left\')*lastPage.scale/lastPage.proportion : 0,\n                            \'top\': (level.imagebox.border && level.imagebox.border.type == \'Pic\') ? -imageboxWEdge(level.imagebox,\'top\')*lastPage.scale/lastPage.proportion : 0,\n                            \'right\': (level.imagebox.border && level.imagebox.border.type == \'Pic\') ? -imageboxWEdge(level.imagebox,\'right\')*lastPage.scale/lastPage.proportion : 0,\n                            \'bottom\': (level.imagebox.border && level.imagebox.border.type == \'Pic\') ? -imageboxWEdge(level.imagebox,\'bottom\')*lastPage.scale/lastPage.proportion : 0,\n                            \'background-image\': (level.imagebox.border && level.imagebox.border.type == \'Pic\') ? \'url(\' + level.imagebox.border.resource.identifier + vm.pageImageView + \')\' : \'\',\n                            \'background-size\': (level.imagebox.border && level.imagebox.border.type == \'Pic\') ? \'100% 100%\' : \'\',\n                            }"></div><div class="relative-view1" ng-style="{\n                             width: (level.imagebox.border && level.imagebox.border.type == \'Pic\') ? level.imagebox.geometry.width : \'100%\',\n                            height: (level.imagebox.border && level.imagebox.border.type == \'Pic\') ? level.imagebox.geometry.height : \'100%\',\n                             \'left\': (level.imagebox.border && level.imagebox.border.type == \'Pic\') ? \'unset\' : ((level.imagebox.border && level.imagebox.border.type == \'Color\') ? (level.imagebox.border.lineWidth) : 0),\n                             \'top\': (level.imagebox.border && level.imagebox.border.type == \'Pic\') ? \'unset\' : ((level.imagebox.border && level.imagebox.border.type == \'Color\') ? (level.imagebox.border.lineWidth) : 0),\n                             \'border-top-left-radius\':imageboxWRadius3(level.imagebox, \'lt\', lastPage.scale/lastPage.proportion),\n                            \'border-top-right-radius\':imageboxWRadius3(level.imagebox, \'rt\', lastPage.scale/lastPage.proportion),\n                            \'border-bottom-right-radius\':imageboxWRadius3(level.imagebox, \'rb\', lastPage.scale/lastPage.proportion),\n                            \'border-bottom-left-radius\':imageboxWRadius3(level.imagebox, \'lb\', lastPage.scale/lastPage.proportion)}"><!-- <img data-index="{{$index}}"\n                                 ng-if="level.imagebox.mask.resource.identifier == \'\'||level.imagebox.mask.resource.identifier == null"\n                                 style="position: absolute; width: 100%; height: 100%;"\n                                 ng-style="{\n                                    width: level.imagebox.image.width*lastPage.scale/lastPage.proportion * level.imagebox.image.scale,\n                                    height: level.imagebox.image.height*lastPage.scale/lastPage.proportion * level.imagebox.image.scale,\n                                    left: level.imagebox.image.offsetx*lastPage.scale/lastPage.proportion * level.imagebox.image.scale,\n                                    top: level.imagebox.image.offsety*lastPage.scale/lastPage.proportion * level.imagebox.image.scale\n                                }"\n                                 ng-src="{{level.imagebox.image.resource.identifier ? level.imagebox.image.resource.identifier + vm.pageImageViewOrient : \'content/images/mask_souce.png\'}}"/> --><div ng-if="level.imagebox.mask.resource.identifier == \'\'||level.imagebox.mask.resource.identifier == null" style="width: 100%;height: 100%"><img data-index="{{$index}}" ng-if="level.imagebox.image.resource.identifier" style="position: absolute; width: 100%; height: 100%" ng-style="{\n                                            width: (level.imagebox.image.width * level.imagebox.image.scale) || \'100%\',\n                                            height: (level.imagebox.image.height * level.imagebox.image.scale) || \'100%\',\n                                            left: level.imagebox.image.offsetx * level.imagebox.image.scale,\n                                            top: level.imagebox.image.offsety * level.imagebox.image.scale\n                                        }" ng-src="{{level.imagebox.image.resource.identifier+ vm.pageImageViewOrient}}"><div ng-if="!level.imagebox.image.resource.identifier" data-index="{{$index}}" class="image-placeholder" style="width: 100%;height: 100%"><img src="content/images/icons/camera.svg" alt="" srcset="" data-index="{{$index}}"> <span ng-if="imageboxW(level.imagebox)*currentPage.scale/currentPage.scene.proportion > 60 && imageboxH(level.imagebox)*currentPage.scale/currentPage.scene.proportion > 80" data-index="{{$index}}">\u62D6\u5165\u76F8\u7247</span></div></div><img data-index="{{$index}}" ng-if="level.imagebox.mask.resource && level.imagebox.mask.resource.identifier" style="position: absolute; width: 100%; height: 100%" ng-src="{{level.imagebox.bgImg +vm.pageImageView}}"></div></div></div><div class="img-art" ng-show="level.imageart&&level.imageart.current" ng-style="{\n                        width: level.imageart.geometry.width*lastPage.scale/lastPage.proportion,\n                        height: level.imageart.geometry.height*lastPage.scale/lastPage.proportion,\n                        left: level.imageart.geometry.x*lastPage.scale/lastPage.proportion,\n                        top: level.imageart.geometry.y*lastPage.scale/lastPage.proportion,\n                        \'z-index\':level.seq-0+200,\n                        \'transform\': \'rotate(\' + level.imageart.rotation.angle + \'deg)\'}"><div style="overflow: hidden; position: relative; width: 100%; height: 100%"><img class="c-xml-page-material-img" style="transition: opacity 0.3s;position: absolute" ng-style="{\n                            \'opacity\':level.imageart.transparency,\n                            filter: \'alpha(opacity=\'+level.imageart.transparency*100+\')\',\n                            \'left\': level.imageart.offsetx *lastPage.scale/lastPage.proportion,\n                            \'top\': level.imageart.offsety *lastPage.scale/lastPage.proportion,\n                            \'width\': level.imageart.geometry.width *lastPage.scale/lastPage.proportion * level.imageart.scale\n                         }" ng-src="{{level.imageart.resource.identifier + vm.pageImageView}}"></div></div><div class="c-xml-page-textboxe" ng-show="level.textbox.current" style="white-space: normal" ng-style="{\n                    \'z-index\':level.seq-0+200,\n                    \'width\': level.textbox.geometry.width * lastPage.scale/lastPage.proportion,\n                    \'height\': level.textbox.geometry.height * lastPage.scale/lastPage.proportion,\n                    \'left\': level.textbox.geometry.x * lastPage.scale/lastPage.proportion,\n                    \'top\': level.textbox.geometry.y * lastPage.scale/lastPage.proportion,\n                    \'transform\': \'rotate(\' + level.textbox.rotation.angle + \'deg)\'\n                 }"><pre class="c-xml-page-textboxe-text web-font" data-index="{{$index}}" ng-style="{\n                    \'font-family\':  \'\\\'\' + level.textbox.fontuuid + \'\\\'\',\n                    \'font-size\': level.textbox.style.size + \'pt\',\n                    \'color\': level.textbox.style.color,\n                    \'font-weight\': level.textbox.style.bold ? \'bold\': \'400\',\n                    \'font-style\': level.textbox.style.italic ? \'italic\': \'initial\',\n                    \'line-height\': level.textbox.style.lineheight + \'pt\',\n                    \'letter-spacing\': level.textbox.style.letterspacing + \'pt\',\n                    \'opacity\': level.textbox.transparency,\n                    \'text-decoration\': \'none\',\n                    \'text-align\': level.textbox.style.align,\n                    \'text-align-last\': \'unset\',\n                    transform:\'scale(\'+(lastPage.scale*lastPage.proportionText)+\')\',\n                    \'transform-origin\': \'0 0\',\n                    width: level.textbox.geometry.width/lastPage.proportion/lastPage.proportionText,\n                    height: level.textbox.geometry.height/lastPage.proportion/lastPage.proportionText\n                  }"><span class="c-xml-page-textboxe-span">{{level.textbox.text}}</span></pre></div><div class="c-textdocument" ng-show="level.textdocument.current" ng-style="{\n                     position: \'absolute\',\n                    width: level.textdocument.geometry.width*lastPage.scale/lastPage.proportion,\n                    height: level.textdocument.geometry.height*lastPage.scale/lastPage.proportion,\n                    left: level.textdocument.geometry.x*lastPage.scale/lastPage.proportion,\n                    top: level.textdocument.geometry.y*lastPage.scale/lastPage.proportion,\n                    \'z-index\':level.seq-0+200,\n                    \'opacity\':level.textdocument.transparency.toFixed(2),\n                    filter: \'alpha(opacity=\'+level.textdocument.transparency*100+\')\',\n                    \'transform\': \'rotate(-\' + level.textdocument.rotation.angle + \'deg)\'}"><div style="overflow: hidden;width: 100%;height: 100%;position: relative"><img class="bg-image pos no-events" ng-cloak ng-if="level.textdocument.background.resource.identifier" ng-src="{{level.textdocument.background.resource.identifier + vm.pageImageView||\'//:0\'}}" ng-style="{\n                     position: \'absolute\',\n                     left:level.textdocument.background.offsetx*lastPage.scale/lastPage.proportion,\n                     top:level.textdocument.background.offsety*lastPage.scale/lastPage.proportion,\n                     width: level.textdocument.background.adaptation==\'Width\'?level.textdocument.geometry.width*lastPage.scale/lastPage.proportion:\'\',\n                     height:level.textdocument.background.adaptation!=\'Width\'?level.textdocument.geometry.height*lastPage.scale/lastPage.proportion:\'\'}"><div ng-repeat="docLevel in level.textdocument.levels.level track by $index" ng-init="docIndex = $index" style="position: relative"><div class="img-art no-events" ng-show="docLevel.imageart" ng-style="{\n                                width: docLevel.imageart.geometry.width*lastPage.scale/lastPage.proportion,\n                                height: docLevel.imageart.geometry.height*lastPage.scale/lastPage.proportion,\n                                left: docLevel.imageart.geometry.x*lastPage.scale/lastPage.proportion,\n                                top: docLevel.imageart.geometry.y*lastPage.scale/lastPage.proportion,\n                                \'z-index\':docLevel.seq-0+200,\n                                \'opacity\':docLevel.imageart.transparency,\n                                filter: \'alpha(opacity=\'+docLevel.imageart.transparency*100+\')\',\n                                \'transform\': \'rotate(\' + docLevel.imageart.rotation.angle + \'deg)\'}"><div style="overflow: hidden; position: relative; width: 100%; height: 100%"><img style="transition: opacity 0.3s;position: absolute" ng-style="{\n                                    \'left\': docLevel.imageart.offsetx *lastPage.scale/lastPage.proportion,\n                                    \'top\': docLevel.imageart.offsety *lastPage.scale/lastPage.proportion,\n                                    \'width\': docLevel.imageart.geometry.width * lastPage.scale/lastPage.proportion * docLevel.imageart.scale}" ng-src="{{docLevel.imageart.resource.identifier + vm.pageImageView}}"></div></div><div class="c-xml-page-textboxe" ng-show="docLevel.textbox" style="white-space: normal" ng-style="{\n                            \'z-index\':docLevel.seq-0+200,\n                            \'width\': docLevel.textbox.geometry.width * lastPage.scale/lastPage.proportion,\n                            \'height\': docLevel.textbox.geometry.height * lastPage.scale/lastPage.proportion,\n                            \'left\': docLevel.textbox.geometry.x * lastPage.scale/lastPage.proportion,\n                            \'top\': docLevel.textbox.geometry.y * lastPage.scale/lastPage.proportion,\n                            \'transform\': \'rotate(\' + docLevel.textbox.rotation.angle + \'deg)\'}"><div style="width: 100%;height: 100%;position: absolute;top:0;left: 0"><pre class="c-xml-page-textboxe-text web-font" ng-style="{\n                                \'font-family\':  \'\\\'\' + docLevel.textbox.fontuuid + \'\\\'\',\n                                \'font-size\': docLevel.textbox.style.size + \'pt\',\n                                \'color\': docLevel.textbox.style.color,\n                                \'font-weight\': docLevel.textbox.style.bold ? \'bold\': \'400\',\n                                \'font-style\': docLevel.textbox.style.italic ? \'italic\': \'initial\',\n                                \'line-height\': docLevel.textbox.style.lineheight + \'pt\',\n                                \'letter-spacing\': docLevel.textbox.style.letterspacing + \'pt\',\n                                \'opacity\': docLevel.textbox.transparency,\n                                \'text-decoration\': \'none\',\n                                \'text-align\': docLevel.textbox.style.align,\n                                \'text-align-last\': \'unset\',\n                                transform:\'scale(\'+(lastPage.scale*lastPage.proportionText)+\')\',\n                                \'transform-origin\': \'0 0\',\n                                width: docLevel.textbox.geometry.width/lastPage.proportion/lastPage.proportionText,\n                                height: docLevel.textbox.geometry.height/lastPage.proportion/lastPage.proportionText\n                              }"><span class="c-xml-page-textboxe-span">{{docLevel.textbox.text}}</span></pre></div></div></div></div></div></div><div class="barcode cursorPointer" ng-show="lastPage.barcode&&lastPage.barcode.geometry" ng-style="{\n                                 \'line-height\':\'0\',\n                                 top: lastPage.barcode.geometry.y*lastPage.scale/lastPage.proportion,\n                                 left: lastPage.barcode.geometry.x*lastPage.scale/lastPage.proportion,\n                                 width: lastPage.barcode.geometry.width*lastPage.scale/lastPage.proportion,\n                                 height: lastPage.barcode.geometry.height*lastPage.scale/lastPage.proportion,\n                                 \'z-index\': 998,\n                                \'transform\': \'rotate(-\' + lastPage.barcode.rotation.angle + \'deg)\'\n                            }"><img src="content/images/txm.png" style="width: 100%;height: 100%"></div><div class="barcode cursorPointer" ng-show="lastPage.qrcode&&lastPage.qrcode.geometry" ng-style="{\n                                 \'line-height\':\'0\',\n                                 top: lastPage.qrcode.geometry.y*lastPage.scale/lastPage.proportion,\n                                 left: lastPage.qrcode.geometry.x*lastPage.scale/lastPage.proportion,\n                                 width: lastPage.qrcode.geometry.width*lastPage.scale/lastPage.proportion,\n                                 height: lastPage.qrcode.geometry.height*lastPage.scale/lastPage.proportion,\n                                 \'z-index\': 998,\n                                \'transform\': \'rotate(-\' + lastPage.qrcode.rotation.angle + \'deg)\'\n                            }"><img src="content/images/QrCode.png" style="width: 100%;height: 100%"></div></div></div><div class="page-item2" ng-if="lastPage.isScene" style="transform:translate(-50% -50%)!important;outline: none" ng-style="{\n         width: (lastPage.scene.geometry.width)*lastPage.scale/lastPage.scene.proportion,\n         height: (lastPage.scene.geometry.height)*lastPage.scale/lastPage.scene.proportion}"><div style="width: 100%; height: 100%; position: relative"><div class="content-container2" ng-style="{\n                \'position\': \'absolute\',\n                \'width\': (lastPage.scene.geometry.width)*lastPage.scale/lastPage.scene.proportion,\n                \'height\': (lastPage.scene.geometry.height)*lastPage.scale/lastPage.scene.proportion,\n                \'z-index\': lastPage.scene.hierarchy == \'TOP\' ? \'1\' : \'0\',\n                \'pointer-events\': \'none\'\n            }"><img class="bg-image" ng-cloak ng-show="lastPage.scene.background.resource.identifier" ng-src="{{lastPage.scene.background.resource.identifier + vm.pageImageView||\'//:0\'}}" ng-style="{width: lastPage.scene.background.resource.identifier?lastPage.scene.geometry.width*lastPage.scale/lastPage.scene.proportion:0}"><div ng-style="{\n                        position: \'absolute\',\n                        width: lastPage.scene.imagebox.geometry.width*lastPage.scale/lastPage.scene.proportion,\n                        height: lastPage.scene.imagebox.geometry.height*lastPage.scale/lastPage.scene.proportion,\n                        left: lastPage.scene.imagebox.geometry.x*lastPage.scale/lastPage.scene.proportion,\n                        top: lastPage.scene.imagebox.geometry.y*lastPage.scale/lastPage.scene.proportion,\n                        \'z-index\':$index,\n                        \'transform\': \'rotate(-\' + lastPage.scene.imagebox.rotation.angle + \'deg)\'}" ng-show="lastPage.scene.imagebox"></div></div><div ng-class="{\'custom-grid\':lastPage.background.type==\'Color\'&&!lastPage.background.color}" ng-style="{\n             \'position\': \'absolute\',\n             \'background\':lastPage.background.color ? lastPage.background.color : \'none\',\n             \'width\': lastPage.mediabox.width*lastPage.scale/lastPage.scene.proportion,\n             \'height\': lastPage.mediabox.height*lastPage.scale/lastPage.scene.proportion,\n             \'left\':lastPage.scene.imagebox.geometry.x*lastPage.scale/lastPage.scene.proportion,\n             \'top\':lastPage.scene.imagebox.geometry.y*lastPage.scale/lastPage.scene.proportion,\n             \'z-index\': lastPage.scene.hierarchy == \'TOP\' ? 0 : 1,\n             }" style="overflow: hidden; border: 1px solid #299DFF"><img class="bg-image pos" ng-cloak ng-if="lastPage.background.resource.identifier" ng-src="{{lastPage.background.resource.identifier + vm.pageImageView||\'//:0\'}}" ng-style="{\n                             position: \'absolute\',\n                             left:lastPage.background.offsetx*lastPage.scale/lastPage.scene.proportion,\n                             top:lastPage.background.offsety*lastPage.scale/lastPage.scene.proportion,\n                             width: lastPage.background.adaptation==\'Width\'?lastPage.background.width*lastPage.scale/lastPage.scene.proportion:\'\',\n                             height:lastPage.background.adaptation==\'Height\'?lastPage.background.height*lastPage.scale/lastPage.scene.proportion:\'\'}"><div ng-repeat="level in lastPage.levels.level track by $index" class="wh100"><div class="imgBox" ng-show="level.imagebox.current" ng-style="{\n                                width: imageboxW(level.imagebox)*lastPage.scale/lastPage.scene.proportion,\n                                height: imageboxH(level.imagebox)*lastPage.scale/lastPage.scene.proportion,\n                                left: imageboxL(level.imagebox)*lastPage.scale/lastPage.scene.proportion,\n                                top: imageboxT(level.imagebox)*lastPage.scale/lastPage.scene.proportion,\n                                \'opacity\':level.imagebox.transparency,\n                                \'z-index\':level.seq-0+200,\n                                \'line-height\':\'0\',\n                                \'transform\': \'rotate(-\' + level.imagebox.rotation.angle + \'deg)\'}"><div class="relative-view1" ng-style="{\n                        \'overflow\': (level.imagebox.border && level.imagebox.border.type == \'Pic\') ? \'unset\' : \'hidden\',\n                        \'border-top-left-radius\':(level.imagebox.border && level.imagebox.border.type == \'Pic\') ? 0 : imageboxWRadius2(level.imagebox, \'lt\', lastPage.scale/lastPage.scene.proportion),\n                        \'border-top-right-radius\':(level.imagebox.border && level.imagebox.border.type == \'Pic\') ? 0 : imageboxWRadius2(level.imagebox, \'rt\', lastPage.scale/lastPage.scene.proportion),\n                        \'border-bottom-right-radius\':(level.imagebox.border && level.imagebox.border.type == \'Pic\') ? 0 : imageboxWRadius2(level.imagebox, \'rb\', lastPage.scale/lastPage.scene.proportion),\n                        \'border-bottom-left-radius\':(level.imagebox.border && level.imagebox.border.type == \'Pic\') ? 0 : imageboxWRadius2(level.imagebox, \'lb\', lastPage.scale/lastPage.scene.proportion),\n                        \'border-width\': (level.imagebox.border && level.imagebox.border.type == \'Color\') ? (level.imagebox.border.lineWidth*lastPage.scale/lastPage.scene.proportion) : \'\',\n                        \'border-style\': (level.imagebox.border && level.imagebox.border.type == \'Color\' && level.imagebox.border.lineType == \'solid\') ? \'solid\' : (level.imagebox.border && level.imagebox.border.type == \'Color\' && level.imagebox.border.lineType == \'dashed\') ? \'dashed\' : (level.imagebox.border && level.imagebox.border.type == \'Color\' && level.imagebox.border.lineType == \'dotted\') ? \'dotted\' : \'none\',\n                        \'border-color\': (level.imagebox.border && level.imagebox.border.type == \'Color\') ? level.imagebox.border.color : \'\',\n                        \'box-shadow\' : (level.imagebox.border && level.imagebox.border.type == \'Color\' && level.imagebox.border.lineWidth>0 && level.imagebox.border && level.imagebox.border.lineType == \'solid\') ? \'0 0 0 1px \' + level.imagebox.border.color + \' inset\' : \'none\',\n                        \'filter\' : dropShadow(level.imagebox,lastPage.scale/lastPage.scene.proportion),\n                        }"><div ng-style="{\n                             \'position\': \'absolute\',\n                             \'z-index\':0,\n                            \'left\': (level.imagebox.border && level.imagebox.border.type == \'Pic\') ? -imageboxWEdge(level.imagebox,\'left\')*lastPage.scale/lastPage.scene.proportion : 0,\n                            \'top\': (level.imagebox.border && level.imagebox.border.type == \'Pic\') ? -imageboxWEdge(level.imagebox,\'top\')*lastPage.scale/lastPage.scene.proportion : 0,\n                            \'right\': (level.imagebox.border && level.imagebox.border.type == \'Pic\') ? -imageboxWEdge(level.imagebox,\'right\')*lastPage.scale/lastPage.scene.proportion : 0,\n                            \'bottom\': (level.imagebox.border && level.imagebox.border.type == \'Pic\') ? -imageboxWEdge(level.imagebox,\'bottom\')*lastPage.scale/lastPage.scene.proportion : 0,\n                            \'background-image\': (level.imagebox.border && level.imagebox.border.type == \'Pic\') ? \'url(\' + level.imagebox.border.resource.identifier + vm.pageImageView + \')\' : \'\',\n                            \'background-size\': (level.imagebox.border && level.imagebox.border.type == \'Pic\') ? \'100% 100%\' : \'\',\n                            }"></div><div class="relative-view1" ng-style="{\n                             width: (level.imagebox.border && level.imagebox.border.type == \'Pic\') ? level.imagebox.geometry.width : \'100%\',\n                             height: (level.imagebox.border && level.imagebox.border.type == \'Pic\') ? level.imagebox.geometry.height : \'100%\',\n                             \'left\': (level.imagebox.border && level.imagebox.border.type == \'Pic\') ? \'unset\' : ((level.imagebox.border && level.imagebox.border.type == \'Color\') ? (level.imagebox.border.lineWidth) : 0),\n                             \'top\': (level.imagebox.border && level.imagebox.border.type == \'Pic\') ? \'unset\' : ((level.imagebox.border && level.imagebox.border.type == \'Color\') ? (level.imagebox.border.lineWidth) : 0),\n                             \'border-top-left-radius\':imageboxWRadius3(level.imagebox, \'lt\', lastPage.scale/lastPage.scene.proportion),\n                            \'border-top-right-radius\':imageboxWRadius3(level.imagebox, \'rt\', lastPage.scale/lastPage.scene.proportion),\n                            \'border-bottom-right-radius\':imageboxWRadius3(level.imagebox, \'rb\', lastPage.scale/lastPage.scene.proportion),\n                            \'border-bottom-left-radius\':imageboxWRadius3(level.imagebox, \'lb\', lastPage.scale/lastPage.scene.proportion),\n                            }"><!-- <img ng-if="!level.imagebox.image&&!level.imagebox.image.resource.identifier"\n                                     class="img-holder mask"\n                                     style="width: 100%; height: 100%;"\n                                     src="content/images/mask_souce.png"\n                                     data-mask="content/images/centerblur.png"/> --><div ng-if="!level.imagebox.image&&!level.imagebox.image.resource.identifier" data-index="{{$index}}" class="image-placeholder"><img src="content/images/icons/camera.svg" alt="" srcset="" data-index="{{$index}}"> <span ng-if="imageboxW(level.imagebox)*currentPage.scale/currentPage.proportion > 60 && imageboxH(level.imagebox)*currentPage.scale/currentPage.proportion > 80" data-index="{{$index}}">\u62D6\u5165\u76F8\u7247</span></div><img ng-if="level.imagebox.image&&level.imagebox.image.resource.identifier" class="img-holder mask" style="position: absolute" ng-style="{\n                            width: level.imagebox.image.width*lastPage.scale/lastPage.scene.proportion * level.imagebox.image.scale,\n                            height: level.imagebox.image.height*lastPage.scale/lastPage.scene.proportion * level.imagebox.image.scale,\n                            left: level.imagebox.image.offsetx*lastPage.scale/lastPage.scene.proportion * level.imagebox.image.scale,\n                            top: level.imagebox.image.offsety*lastPage.scale/lastPage.scene.proportion * level.imagebox.image.scale\n                         }" ng-src="{{level.imagebox.image.resource.identifier+vm.pageImageViewOrient}}"></div></div></div><div ng-show="level.imageart.current" ng-style="{\n                                width: level.imageart.geometry.width*lastPage.scale/lastPage.scene.proportion,\n                                height: level.imageart.geometry.height*lastPage.scale/lastPage.scene.proportion,\n                                \'line-height\': level.imageart.geometry.height*lastPage.scale/lastPage.scene.proportion+\'px\',\n                                left: level.imageart.geometry.x*lastPage.scale/lastPage.scene.proportion,\n                                top: level.imageart.geometry.y*lastPage.scale/lastPage.scene.proportion,\n                                \'z-index\':level.seq-0+200,\n                                \'opacity\':level.imageart.transparency,\n                                filter: \'alpha(opacity=\'+level.imageart.transparency*100+\')\',\n                                \'transform\': \'rotate(\' + level.imageart.rotation.angle + \'deg)\'}"><div style="overflow: hidden; position: relative; width: 100%; height: 100%"><img class="c-xml-page-material-img" style="transition: opacity 0.3s;position: absolute" ng-style="{\n                                    \'left\': level.imageart.offsetx*lastPage.scale/lastPage.scene.proportion,\n                                    \'top\': level.imageart.offsety*lastPage.scale/lastPage.scene.proportion,\n                                    \'width\': level.imageart.geometry.width*lastPage.scale/lastPage.scene.proportion * level.imageart.scale}" ng-src="{{level.imageart.resource.identifier + vm.pageImageView}}"></div></div><div class="c-xml-page-textboxe" ng-show="level.textbox.current" style="white-space: normal" ng-style="{\n                            \'z-index\':level.seq-0+200,\n                            \'width\': level.textbox.geometry.width*lastPage.scale/lastPage.scene.proportion,\n                            \'left\': level.textbox.geometry.x*lastPage.scale/lastPage.scene.proportion,\n                            \'top\': level.textbox.geometry.y*lastPage.scale/lastPage.scene.proportion,\n                            \'height\': level.textbox.geometry.height*lastPage.scale/lastPage.scene.proportion,\n                            \'transform\': \'rotate(\' + level.textbox.rotation.angle + \'deg)\'\n                         }"><div style="width: 100%;height: 100%;position: absolute;top:0;left: 0"><pre class="c-xml-page-textboxe-text web-font" ng-style="{\n                                \'font-family\':  \'\\\'\' + level.textbox.fontuuid + \'\\\'\',\n                                \'font-size\': level.textbox.style.size + \'pt\',\n                                \'color\': level.textbox.style.color,\n                                \'font-weight\': level.textbox.style.bold ? \'bold\': \'400\',\n                                \'font-style\': level.textbox.style.italic ? \'italic\': \'initial\',\n                                \'line-height\': level.textbox.style.lineheight + \'pt\',\n                                \'letter-spacing\': level.textbox.style.letterspacing + \'pt\',\n                                \'opacity\': level.textbox.transparency,\n                                \'text-decoration\': \'none\',\n                                \'text-align\': level.textbox.style.align,\n                                \'text-align-last\': \'unset\',\n                                transform:\'scale(\'+(lastPage.scale/lastPage.scene.proportion)+\')\',\n                                \'transform-origin\': \'0 0\',\n                                width: level.textbox.geometry.width,\n                                height: level.textbox.geometry.height\n                              }"><span class="c-xml-page-textboxe-span">{{level.textbox.text}}</span></pre></div></div><div class="c-textdocument" ng-show="level.textdocument.current" ng-style="{\n                                position: \'absolute\',\n                                width: level.textdocument.geometry.width*lastPage.scale/lastPage.scene.proportion,\n                                height: level.textdocument.geometry.height*lastPage.scale/lastPage.scene.proportion,\n                                left: level.textdocument.geometry.x*lastPage.scale/lastPage.scene.proportion,\n                                top: level.textdocument.geometry.y*lastPage.scale/lastPage.scene.proportion,\n                                \'z-index\':level.seq-0+200,\n                                \'opacity\':level.textdocument.transparency.toFixed(2),\n                                filter: \'alpha(opacity=\'+level.textdocument.transparency*100+\')\',\n                                \'transform\': \'rotate(-\' + level.textdocument.rotation.angle + \'deg)\'}"><div style="overflow: hidden;width: 100%;height: 100%;position: relative;z-index: 1" class="no-events"><img class="bg-image bg-image{{template.pageI}} pos" ng-cloak ng-if="level.textdocument.background.resource.identifier" ng-src="{{level.textdocument.background.resource.identifier + vm.pageImageView||\'//:0\'}}" ng-style="{\n                                         position: \'absolute\',\n                                         left:level.textdocument.background.offsetx*lastPage.scale/lastPage.scene.proportion,\n                                         top:level.textdocument.background.offsety*lastPage.scale/lastPage.scene.proportion,\n                                         width: level.textdocument.background.adaptation==\'Width\'?level.textdocument.geometry.width*lastPage.scale/lastPage.scene.proportion:\'\',\n                                         height:level.textdocument.background.adaptation!=\'Width\'?level.textdocument.geometry.height*lastPage.scale/lastPage.scene.proportion:\'\'}"><div ng-repeat="docLevel in level.textdocument.levels.level track by $index" ng-init="docIndex = $index" style="position: relative"><div class="img-art" ng-show="docLevel.imageart" ng-style="{\n                                            width: docLevel.imageart.geometry.width*lastPage.scale/lastPage.scene.proportion,\n                                            height: docLevel.imageart.geometry.height*lastPage.scale/lastPage.scene.proportion,\n                                            left: docLevel.imageart.geometry.x*lastPage.scale/lastPage.scene.proportion,\n                                            top: docLevel.imageart.geometry.y*lastPage.scale/lastPage.scene.proportion,\n                                            \'z-index\':docLevel.seq-0+200,\n                                            \'opacity\':docLevel.imageart.transparency,\n                                            filter: \'alpha(opacity=\'+docLevel.imageart.transparency*100+\')\',\n                                            \'transform\': \'rotate(\' + docLevel.imageart.rotation.angle + \'deg)\'}"><div style="overflow: hidden; position: relative; width: 100%; height: 100%"><img style="transition: opacity 0.3s;position: absolute" ng-style="{\n                                                \'left\': docLevel.imageart.offsetx *lastPage.scale/lastPage.scene.proportion,\n                                                \'top\': docLevel.imageart.offsety *lastPage.scale/lastPage.scene.proportion,\n                                                \'width\': docLevel.imageart.geometry.width * lastPage.scale/lastPage.scene.proportion * docLevel.imageart.scale}" ng-src="{{docLevel.imageart.resource.identifier + vm.pageImageView}}"></div></div><div class="c-xml-page-textboxe" ng-show="docLevel.textbox" style="white-space: normal" ng-style="{\n                                        \'z-index\':docLevel.seq-0+200,\n                                        \'width\': docLevel.textbox.geometry.width * lastPage.scale/lastPage.scene.proportion,\n                                        \'left\': docLevel.textbox.geometry.x * lastPage.scale/lastPage.scene.proportion,\n                                        \'top\': docLevel.textbox.geometry.y * lastPage.scale/lastPage.scene.proportion,\n                                        \'height\': docLevel.textbox.geometry.height * lastPage.scale/lastPage.scene.proportion,\n                                        \'transform\': \'rotate(\' + docLevel.textbox.rotation.angle + \'deg)\'}"><div style="width: 100%;height: 100%;position: absolute;top:0;left: 0"><pre class="c-xml-page-textboxe-text web-font" ng-style="{\n                                            \'font-family\':  \'\\\'\' + docLevel.textbox.fontuuid + \'\\\'\',\n                                            \'font-size\': docLevel.textbox.style.size + \'pt\',\n                                            \'color\': docLevel.textbox.style.color,\n                                            \'font-weight\': docLevel.textbox.style.bold ? \'bold\': \'400\',\n                                            \'font-style\': docLevel.textbox.style.italic ? \'italic\': \'initial\',\n                                            \'line-height\': docLevel.textbox.style.lineheight + \'pt\',\n                                            \'letter-spacing\': docLevel.textbox.style.letterspacing + \'pt\',\n                                            \'opacity\': docLevel.textbox.transparency,\n                                            \'text-decoration\': \'none\',\n                                            \'text-align\': docLevel.textbox.style.align,\n                                            \'text-align-last\': \'unset\',\n                                            transform:\'scale(\'+(lastPage.scale/lastPage.scene.proportion)+\')\',\n                                            \'transform-origin\': \'0 0\',\n                                            width: docLevel.textbox.geometry.width,\n                                            height: docLevel.textbox.geometry.height\n                                          }"><span class="c-xml-page-textboxe-span">{{docLevel.textbox.text}}</span></pre></div></div></div></div></div><div class="barcode cursorPointer" ng-show="lastPage.barcode&&lastPage.barcode.geometry" ng-style="{\n                             \'line-height\':\'0\',\n                             top: lastPage.barcode.geometry.y*lastPage.scale/lastPage.scene.proportion,\n                             left: lastPage.barcode.geometry.x*lastPage.scale/lastPage.scene.proportion,\n                             width: lastPage.barcode.geometry.width*lastPage.scale/lastPage.scene.proportion,\n                             height: lastPage.barcode.geometry.height*lastPage.scale/lastPage.scene.proportion,\n                             \'z-index\': 998,\n                            \'transform\': \'rotate(-\' + lastPage.barcode.rotation.angle + \'deg)\'\n                        }"><img src="content/images/txm.png" style="width: 100%;height: 100%"></div><div class="barcode cursorPointer" ng-show="lastPage.qrcode&&lastPage.qrcode.geometry" ng-style="{\n                             \'line-height\':\'0\',\n                             top: lastPage.qrcode.geometry.y*lastPage.scale/lastPage.scene.proportion,\n                             left: lastPage.qrcode.geometry.x*lastPage.scale/lastPage.scene.proportion,\n                             width: lastPage.qrcode.geometry.width*lastPage.scale/lastPage.scene.proportion,\n                             height: lastPage.qrcode.geometry.height*lastPage.scale/lastPage.scene.proportion,\n                             \'z-index\': 998,\n                            \'transform\': \'rotate(-\' + lastPage.qrcode.rotation.angle + \'deg)\'\n                        }"><img src="content/images/QrCode.png" style="width: 100%;height: 100%"></div></div></div></div></div></div><div data-html2canvas-ignore><canvas id="mask-canvas" class="hide1"></canvas><header class="page-head"><div class="page-head-icon mar-right-40"><!--<img src="content/images/icons/leftLogo.png">--> <img src="content/images/momentsgo.png"></div><div class="page-head-file"><div class="page-file-text"><span>\u6587\u4EF6</span> <i></i></div><div class="page-file-size"><div><span>\u753B\u5E03\u5C3A\u5BF8\uFF1A{{vm.page.pageSize.width}}*{{vm.page.pageSize.height}}{{vm.page.dpi.data}}</span></div><div><span>\u51FA\u8840\u5C3A\u5BF8\uFF1A{{vm.page.pageBloodT}}*{{vm.page.pageBloodB}}*{{vm.page.pageBloodL}}*{{vm.page.pageBloodR}}{{vm.page.dpi.data}}</span></div><div><span>\u53EF\u7F16\u8F91\u5C3A\u5BF8\uFF1A{{vm.page.editbox.width}}*{{vm.page.editbox.height}}\uFF0C{{vm.page.editbox.x}}*{{vm.page.editbox.y}}{{vm.page.dpi.data}}</span></div><div class="page-file-size-edit" ng-click="editSize(\'pageSize\')" style="border-top:1px solid #d9d9d9" ng-if="vm.isCustom"><span>\u4FEE\u6539\u5F53\u524D\u9875\u9762\u753B\u5E03\u5C3A\u5BF8</span></div><div class="page-file-size-edit" ng-click="editSize(\'bloodSize\')" ng-if="vm.isCustom"><span>\u4FEE\u6539\u5F53\u524D\u9875\u9762\u51FA\u8840\u5C3A\u5BF8</span></div><div class="page-file-size-edit" ng-click="editSize(\'editbox\')" ng-if="vm.isCustom"><span>\u4FEE\u6539\u5F53\u524D\u9875\u9762\u53EF\u7F16\u8F91\u533A\u57DF\u5C3A\u5BF8</span></div></div></div><div class="page-head-title"><div id="page-title" onkeyup="setpageTitle()" ng-model="vm.page.name">{{vm.page.name}}</div></div><div class="page-head-save"><button class="save-exit pull-left" ng-click="watchArticle()" ng-style="{opacity:vm.isSaving?0.7:1}">\u9884\u89C8</button> <button class="save-exit" ng-click="vm.exitSure=true" ng-style="{opacity:vm.isSaving?0.7:1}">\u9000\u51FA</button> <button class="save-release" ng-click="savePage(1)" ng-disabled="vm.isSaving" ng-style="{opacity:vm.isSaving?0.7:1}">\u4FDD\u5B58\u81F3\u4F5C\u54C1</button></div></header><section style="overflow: hidden;position: absolute; width: 100%; height: calc(100vh - 50px);top: 50px"><div class="leftPanel"><div class="leftPanels"><nav class="leftPanel-leftPanelMenu"><div class="leftPanel-leftPanelMenuList leftPanel-bg" ng-click="selectPanel(\'page\')" ng-class="{\'leftPanel-bg-active\':selPanel==\'page\'}">\u80CC\u666F<div class="leftPanel-border"></div></div><!--<div class="leftPanel-leftPanelMenuList leftPanel-placement" ng-click="selectPanel(\'placement\')"--><!--ng-class="{\'leftPanel-placement-active\':selPanel==\'placement\'}">\u56FE\u7247\u6846--><!--<div class="leftPanel-border"></div>--><!--</div>--><div class="leftPanel-leftPanelMenuList leftPanel-placement" ng-click="selectPanel(\'mask\')" ng-class="{\'leftPanel-mask-active\':selPanel==\'mask\'}">\u76F8\u6846<div class="leftPanel-border"></div></div><div class="leftPanel-leftPanelMenuList leftPanel-material" ng-click="selectPanel(\'material\')" ng-class="{\'leftPanel-material-active\':selPanel==\'material\'}">\u7D20\u6750<div class="leftPanel-border"></div></div><div class="leftPanel-leftPanelMenuList leftPanel-bg-design" ng-click="selectPanel(\'design\')" ng-class="{\'leftPanel-bg-design-active\':selPanel==\'design\'}">\u8BBE\u8BA1\u80CC\u666F<div class="leftPanel-border"></div></div><!--                    <div class="leftPanel-leftPanelMenuList leftPanel-bg-scene" ng-click="addScene()"--><!--                         ng-class="{\'leftPanel-bg-design-active\':selPanel==\'scene\'}">\u573A\u666F\u9884\u89C8--><!--                        <div class="leftPanel-border"></div>--><!--                    </div>--><div class="leftPanel-leftPanelMenuList leftPanel-barcode" ng-click="selectPanel(\'barcode\')" ng-class="{\'leftPanel-barcode-active\':selPanel==\'barcode\'}">\u6761\u7801<div class="leftPanel-border"></div></div><!--<div class="leftPanel-leftPanelMenuList leftPanel-shezhi" ng-click="shezhiClick()"--><!--ng-class="{\'leftPanel-shezhi-active\':shezhi==true}">\u8BBE\u7F6E--><!--</div>--><div class="leftPanel-leftPanelMenuList2" ng-click="selectPanel(\'backup\')" ng-class="{\'leftPanel-barcode-active\':selPanel==\'backup\'}"><i class="icon iconfont icon-iconset0335"></i>\u5907\u7528\u9875<div class="leftPanel-border"></div></div></nav><ul class="shezhi-tab" ng-show="shezhi"><li><span>\u65B0\u624B\u5F15\u5BFC</span></li><li ng-click="darkTheme=!darkTheme"><span>\u6DF1\u8272\u754C\u9762</span></li></ul><div class="leftPanel-mainContent"><div class="leftPanel-main-wrap" ng-class="{\'dark-theme\':darkTheme==true}"><div class="leftPanel-bg-show" ng-show="selPanel==\'page\'"><div class="leftPanel-bg-text">\u80CC\u666F\u989C\u8272</div><div class="leftPanel-bg-head"><div id="picker"></div><input class="leftPanel-bg-choose-color" type="color" ng-change="chooseColor()" ng-model="vm.bgColor"> <button class="leftPanel-bg-color leftPanel-bg-choose-mask"></button> <button class="leftPanel-bg-color" ng-repeat="color in vm.colorArr1" ng-click="chooseBgColor(color)" ng-style="{background:color,border:$first?\'1px solid #DADADA\':none}"></button></div><div class="leftPanel-bg-text mar-top-20">\u9884\u9009\u989C\u8272</div><div class="leftPanel-bg-head" style="padding-left: 9px"><button class="custom-grid2" ng-click="chooseBgColor()"></button> <button class="leftPanel-bg-color" ng-repeat="color in vm.colorArr2" ng-click="chooseBgColor(color)" ng-style="{background:color,border:$index==4?\'1px solid #DADADA\':none}"></button></div><div class="leftPanel-con scrollbar" style="height: calc(100vh - 260px)" ng-style="{\'border-top\':darkTheme?\'2px solid #6d6d6d\':\'2px solid #e6e6e6\'}"><ul class="clearfix" id="main0"><li ng-repeat="bg in template.bgimgs2.bgimg track by $index" data-index="{{$index}}" is-over="toggle.now" class="left-panel-hover lihover" ng-class="{\'dark-theme-shadow2\':darkTheme==true}"><div style="position: relative;width: 100%;height: 100%"><img ng-src="{{bg.identifier + vm.menuImageView}}" draggable="true" ondragstart="dragStart(event)" id="dragtarget{{$index}}" style="width: 100%" data-index="{{$index}}"> <button class="bg-del{{$index}} leftPanel-del" ng-click="deleteLeftPanelPic($index)"><div></div><img src="content/images/icons/ic_delete.svg"></button></div></li></ul></div></div><div class="leftPanel-bg-show" ng-show="selPanel==\'design\'"><div class="leftPanel-con scrollbar" ng-style="{\'border-top\':darkTheme?\'2px solid #6d6d6d\':\'2px solid #e6e6e6\'}"><ul class="clearfix" id="main3"><li ng-repeat="bg in template.bgimgs.bgimg track by $index" data-index="{{$index}}" class="left-panel-hover lihover" ng-class="{\'dark-theme-shadow2\':darkTheme==true}"><div style="position: relative;width: 100%;height: 100%"><img ng-src="{{bg.identifier + vm.menuImageView||\'//:0\'}}" style="width: 100%" data-index="{{$index}}"> <button class="bg-del{{$index}} leftPanel-del" ng-click="deleteLeftPanelPic($index)"><div></div><img src="content/images/icons/ic_delete.svg"></button></div></li></ul></div></div><div class="leftPanel-mask-show" ng-show="selPanel==\'mask\'"><div class="leftPanel-con leftPanel-con-mask2 scrollbar" ng-style="{\'border-top\':darkTheme?\'2px solid #6d6d6d\':\'2px solid #e6e6e6\'}"><ul class="clearfix" id="main2"><li ng-repeat="mask in template.masks.mask track by $index" data-index="{{$index}}" class="left-panel-hover lihover" ng-class="{\'dark-theme-shadow2\':darkTheme==true}"><div style="position: relative;width: 100%;height: 100%;background: #E6E6E6"><img ng-src="{{mask.resource.identifier + vm.menuImageView}}" draggable="true" ondragstart="dragStart(event)" id="dragtargetMask{{$index}}" data-mask="{{mask.resource.identifier}}" style="width: 100%" data-index="{{$index}}"> <button class="bg-del{{$index}} leftPanel-del" ng-hide="mask.type==\'SYSTEM\'" ng-click="deleteLeftPanelPic($index)"><div></div><img src="content/images/icons/ic_delete.svg"></button></div></li></ul></div></div><div class="leftPanel-material-show" ng-show="selPanel==\'material\'"><div class="leftPanel-con scrollbar clipart-con2" style="border: none" ng-style="{\'border-top\':darkTheme?\'2px solid #6d6d6d\':\'2px solid #e6e6e6\'}"><ul class="clearfix" id="main1"><li ng-repeat="clipArt in template.cliparts.clipart track by $index" data-index="{{$index}}" ng-class="{\'dark-theme-shadow2\':darkTheme==true}" class="clipart{{$index}} lihover left-panel-hover outline-none custom-grid" style="position: relative;height: 100px;line-height: 100px"><div style="width: 100%;height: 100%;overflow: hidden"><img ng-src="{{clipArt.resource.identifier + vm.menuImageView||\'//:0\'}}" data-art="{{clipArt.resource.identifier}}" draggable="true" ondragstart="dragStart(event)" ng-click="addArt(clipArt.resource.identifier,$index)" id="dragtargetClipArt{{$index}}" data-index="{{$index}}" style="left:0;top:0;width: 100%;position: absolute;height: 100%;z-index:100;opacity: 0;filter:alpha(opacity=0)"> <img style="max-width: 100%;max-height: 100%" ng-src="{{clipArt.resource.identifier + vm.menuImageView||\'//:0\'}}"> <button class="art-del{{$index}} leftPanel-del" ng-hide="clipArt.type==\'SYSTEM\'" ng-click="deleteLeftPanelPic($index)"><div></div><img src="content/images/icons/ic_delete.svg"></button></div></li></ul></div></div><div class="leftPanel-img-show" ng-show="selPanel==\'backup\'"><div class="leftPanel-con scrollbar backup-con" style="border: none" style="height: calc(100vh - 54px)"><ul class="clearfix" id="main7"><li ng-repeat="page in backupPages() track by $index" ng-if="page.backup" data-index="{{page.index}}" ng-class="{\'dark-theme-shadow2\':darkTheme==true}" class="clipart{{page.index}} lihover left-panel-hover outline-none" style="position: relative;height: 100px;line-height: 100px"><div style="width: 100%;height: 100%;overflow: hidden"><img ng-click="replaceBackupPage($event, page)" ng-src="{{page.pagecover.identifier + vm.menuImageView||\'//:0\'}}" data-index="{{page.index}}" style="left:0;top:0;width: 100%;position: absolute;height: 100%;z-index:100;opacity: 0;filter:alpha(opacity=0)"> <img style="max-width: 100%;max-height: 100%" ng-if="page.pagecover.identifier" ng-src="{{page.pagecover.identifier + vm.menuImageView||\'//:0\'}}"><div class="loading-font" ng-if="!page.pagecover.identifier"></div><button class="bg-del{{page.index}} leftPanel-del" ng-click="deleteBackup(page.index)"><div></div><img src="content/images/icons/ic_delete.svg"></button></div></li></ul></div><div class="leftPanel-img-show-content-foot"><button type="button" class="load-more" ng-click="loadMoreBackupPages()" ng-if="vm.backupPageSize < template.pages.page.length">\u52A0\u8F7D\u66F4\u591A</button> <span ng-if="vm.backupPageSize >= template.pages.page.length">\u6682\u65E0\u66F4\u591A...</span></div></div><div class="leftPanel-material-show" ng-show="selPanel==\'barcode\'"><img src="content/images/txm.png" alt="" ng-click="addBarCode()" style="width: 90%; margin: 20px auto"> <img src="content/images/QrCode.png" alt="" ng-click="addQrCode()" style="width: 90%; margin: 20px auto"></div></div></div><div class="leftPanel-mainContent-toggle" ng-click="hidePanel(1)"></div></div></div><div class="rightPanel" ng-class="{\'dark-theme-con\':darkTheme==true}"><div class="col-lg-12 col-sm-12 col-md-12 no-padding home-page"><div class="add-all col-lg-12 col-sm-12 col-md-12 no-padding"><header class="nav-bg col-lg-12 col-sm-12 col-md-12 pad-0 clearfix" ng-show="!currentPage.isScene" ng-class="{\'dark-theme\':darkTheme==true}"><div style="float: left;padding-left: 10px"><span ng-show="RightPanel==\'text\'"><ul class="clearfix c-xml-action-icon-font"><li><div class="c-xml-action-div-icon c-xml-action-div-icon-color" ng-click="operationColorOpen($event)" ng-style="{background: currentPage.levels.level[template.levelI].textbox.style.color}" style="border: 1px solid #ddd"><div class="tip3" style="top:50px">\u989C\u8272</div></div><div class="c-xml-action-div-color-modal clearfix" style="z-index: 999;top:48px;left: -5px" ng-if="vm.isOperationColor"><input class="c-xml-action-div-color-modal-btn" type="color" ng-change="chooseTextColor()" ng-model="vm.textColor"> <span ng-repeat="item in vm.colorList track by $index" ng-style="{ \'background\' : item.id}" ng-class="{\'c-xml-action-div-color-on\' : item.id == currentPage.levels.level[template.levelI].textbox.style.color}" ng-click="operationColor(item)"></span></div></li><li><div class="c-font-view"><div class="c-font-view-head"><input type="number" class="c-input1" style="width: 100%; border: 0" ng-model="currentPage.levels.level[template.levelI].textbox.style.size" ng-change="updateTextSize(currentPage.levels.level[template.levelI].textbox.style.size)"></div><div class="c-font-view-body"><div class="c-font-view-body-ul"><div class="c-font-view-body-li" ng-repeat="size in fontSizes track by $index" ng-click="updateTextSize(size)" ng-class="{\'c-font-view-body-li-on\' : currentPage.levels.level[template.levelI].textbox.style.size == size}">{{size}}</div></div></div></div><!--                                        <select ng-options="size for size in fontSizes" style="width: 70px;"--><!--                                        ng-model-options="{debounce:500}" class="select-text"--><!--                                        ng-change="updateTextSize(size)"--><!--                                        ng-model="size">--><!--                                        </select>--></li><li class="pad-0" ng-if="selectBox.style.italic1"><button class="nav-lock tool-bar-btn" ng-click="operationItalic()"><img src="content/images/icons/tools_bar_italic.svg" alt="\u659C\u4F53" onmouseover="this.src=\'content/images/icons/tools_bar_italic_Selected.svg\'" onmouseout="this.src=\'content/images/icons/tools_bar_italic.svg\'" ng-show="!currentPage.levels.level[template.levelI].textbox.style.italic"> <img src="content/images/icons/tools_bar_italic_Selected.svg" alt="\u659C\u4F53" ng-show="currentPage.levels.level[template.levelI].textbox.style.italic"><div class="tip">\u659C\u4F53</div></button></li><!--<li>--><!--&lt;!&ndash;                ng-class="{\'tools_bar_underline\':!vm.font.style.italic,\'tools_bar_underline_Selected\':vm.font.style.italic}"&ndash;&gt;--><!--<div class="c-xml-action-div-icon tools_bar_underline"--><!--ng-click="operationItalic()">--><!--<div class="tip3">\u4E0B\u5212\u7EBF</div>--><!--</div>--><!--</li>--><li class="pad-0" ng-if="selectBox.style.bold1"><button class="nav-lock tool-bar-btn" ng-click="operationBold()"><img src="content/images/icons/tools_bar_bold.svg" alt="\u7C97\u4F53" onmouseover="this.src=\'content/images/icons/tools_bar_bold_Selected.svg\'" onmouseout="this.src=\'content/images/icons/tools_bar_bold.svg\'" ng-show="!currentPage.levels.level[template.levelI].textbox.style.bold"> <img src="content/images/icons/tools_bar_bold_Selected.svg" alt="\u7C97\u4F53" ng-show="currentPage.levels.level[template.levelI].textbox.style.bold"><div class="tip">\u7C97\u4F53</div></button></li><li class="pad-0"><button class="nav-lock tool-bar-btn"><img src="content/images/icons/tools_bar_spacing1.svg" onmouseover="this.src=\'content/images/icons/tools_bar_spacing_Selected.svg\'" onmouseout="this.src=\'content/images/icons/tools_bar_spacing1.svg\'" ng-show="!vm.isOperationSpacing" ng-click="operationSpacing(true)"> <img src="content/images/icons/tools_bar_spacing_Selected.svg" ng-show="vm.isOperationSpacing" ng-click="operationSpacing(false)"><div class="tip" style="left: -1px">\u95F4\u8DDD</div><div class="space-slider" ng-if="vm.isOperationSpacing" style="z-index: 1000"><div class="slider"><label class="slider-label">\u5B57\u95F4\u8DDD</label><div class="slider-area"><div class="slider-back" data-value="width" ng-click="spacingClick($event)"></div><div class="slider-block block-width" data-value="width" onmousedown="resizeSpacingStart(event)"></div></div><input type="number" class="slider-input" min="{{template.letterspacing}}" onmousewheel="return false;" ng-model="template.letterspacing" ng-change="spacingChange(1)"></div><div class="slider"><label class="slider-label">\u884C\u95F4\u8DDD</label><div class="slider-area"><div class="slider-back" data-value="height" ng-click="spacingClick($event)"></div><div class="slider-block block-height" data-value="height" onmousedown="resizeSpacingStart(event)"></div></div><input type="number" class="slider-input" min="{{template.lineheight}}" onmousewheel="return false;" ng-model="template.lineheight" ng-change="spacingChange(0)"></div></div></button></li><li class="pad-0"><button class="nav-operation tool-bar-btn"><img src="content/images/icons/tools_bar_left_justifying.svg" onmouseover="this.src=\'content/images/icons/tools_bar_left_justifying_Selected.svg\'" onmouseout="this.src=\'content/images/icons/tools_bar_left_justifying.svg\'" ng-show="!vm.isOperationDir" ng-click="operationDir(true)"> <img src="content/images/icons/tools_bar_left_justifying_Selected.svg" ng-show="vm.isOperationDir" ng-click="operationDir(false)"><div class="tip" style="left: -1px">\u5BF9\u9F50</div><div class="coverage-slider operation" ng-show="vm.isOperationDir" style="z-index: 1000"><ul><li ng-click="operationBarLeft($event)"><div class="tip4" style="left:-14px;top:36px">\u5DE6\u5BF9\u9F50</div></li><li ng-click="operationBarCenter($event)"><div class="tip4" style="left:-14px;top:36px">\u5C45\u4E2D\u5BF9\u9F50</div></li><li ng-click="operationBarRight($event)"><div class="tip3" style="left:-2px;top:36px">\u53F3\u5BF9\u9F50</div></li><li ng-click="operationBarJustify($event)"><div class="tip4" style="left:-14px;top:36px">\u4E24\u7AEF\u5BF9\u9F50</div></li></ul></div></button></li></ul></span><span ng-show="RightPanel==\'textDoc\'&&selectBox.editable" style="color: #E1A03A" ng-click="slipGroup()">\u62C6\u5206\u7EC4\u5408</span><div ng-hide="RightPanel==\'text\'||RightPanel==\'textDoc\'"><span class="nav-alignment pos-rela" ng-click="toobarAlignment()" ng-class="{\'nav-alig-avtive\':isAlignHover,\'dark-theme-navali\':darkTheme==true}"><div class="tip" style="left:-2px;top:50px">\u5BF9\u9F50</div><div class="tool-bar-alignment" ng-show="isAlignHover" style="z-index: 1000"><ul><li ng-click="boxAlignment(\'left\')"><div class="tip3" style="left:-8px;top:36px">\u5DE6\u5BF9\u9F50</div></li><li ng-click="boxAlignment(\'right\')"><div class="tip3" style="left:-8px;top:36px">\u53F3\u5BF9\u9F50</div></li><li ng-click="boxAlignment(\'top\')"><div class="tip4" style="left:-14px;top:36px">\u9876\u90E8\u5BF9\u9F50</div></li><li ng-click="boxAlignment(\'bottom\')"><div class="tip4" style="left:-14px;top:36px">\u5E95\u90E8\u5BF9\u9F50</div></li><li ng-click="boxAlignment(\'vertical\')"><div class="tip4" style="left:-12px;top:36px">\u5782\u76F4\u5C45\u4E2D</div></li><li ng-click="boxAlignment(\'standard\')"><div class="tip4" style="left:-14px;top:36px">\u6C34\u5E73\u5C45\u4E2D</div></li></ul></div></span><span class="nav-distribution pos-rela" ng-click="toolbarDistribution()" ng-class="{\'nav-distri-active\':isDistriHover,\'dark-theme-navdis\':darkTheme==true}"><div class="tip" style="left:-2px;top:50px">\u5206\u5E03</div><div class="tool-bar-distribution" ng-show="isDistriHover" style="z-index: 1000"><ul><li ng-click="boxDistribution(\'standard\')"><div class="tip4" style="left:-14px;top:36px">\u6C34\u5E73\u5206\u5E03</div></li><li ng-click="boxDistribution(\'vertical\')"><div class="tip4" style="left:-14px;top:36px">\u5782\u76F4\u5206\u5E03</div></li></ul></div></span></div></div><div style="float: right;padding-right: 4px" class="text-right"><div class="col-lg-12 col-sm-12 col-md-12 no-padding" style="z-index:400"><button class="nav-lock tool-bar-btn" ng-if="selectBox.border && selectBox.border.type == \'Color\'"><img src="content/images/icons/tools_bar_shadow.svg" onmouseover="this.src=\'content/images/icons/tools_bar_shadow_pre.svg\'" onmouseout="this.src=\'content/images/icons/tools_bar_shadow.svg\'" ng-show="!vm.isShadowSet" ng-click="shadowSet(true)"> <img src="content/images/icons/tools_bar_shadow_pre.svg" ng-show="vm.isShadowSet" ng-click="shadowSet(false)"><div class="tip3">\u9634\u5F71\u8BBE\u7F6E</div><div class="roundedSet" ng-show="vm.isShadowSet" style="z-index: 1000"><div class="roundedSet-title"><h4 class="rightPanel-title">\u9634\u5F71\u8BBE\u7F6E</h4></div><div><div class="c-schedule-view"><span class="c-schedule-title">\u989C\u8272\uFF1A</span><div class="bezel-set-color" style="width: 30px;height: 30px" ng-style="{background:template.pages.page[template.pageI].levels.level[template.levelI].imagebox.shadow.color}"><input type="color" ng-value="template.pages.page[template.pageI].levels.level[template.levelI].imagebox.shadow.color" ng-model="template.pages.page[template.pageI].levels.level[template.levelI].imagebox.shadow.color"></div></div><div class="c-schedule-view"><span class="c-schedule-title">X\u8F74\uFF1A</span> <input type="range" min="-100" max="100" step="1" value="{{selectBox.shadow.x}}" ng-model="selectBox.shadow.x" ng-change="borderRadius()" class="text-range" style="width: 100% !important"> <span style="width: 30px">{{selectBox.shadow.x}}%</span></div><div class="c-schedule-view"><span class="c-schedule-title">Y\u8F74\uFF1A</span> <input type="range" min="-100" max="100" step="1" value="{{selectBox.shadow.y}}" ng-model="selectBox.shadow.y" ng-change="borderRadius()" class="text-range" style="width: 100% !important"> <span style="width: 30px">{{selectBox.shadow.y}}%</span></div><div class="c-schedule-view"><span class="c-schedule-title">\u6A21\u7CCA\uFF1A</span> <input type="range" min="0" max="20" step="1" value="{{selectBox.shadow.blur}}" ng-model="selectBox.shadow.blur" ng-change="borderRadius()" class="text-range" style="width: 100% !important"> <span style="width: 30px">{{selectBox.shadow.blur}}%</span></div></div></div></button> <button class="nav-lock tool-bar-btn"><img src="content/images/icons/tools_bar_transparency.svg" onmouseover="this.src=\'content/images/icons/tools_bar_transparency_pre.svg\'" onmouseout="this.src=\'content/images/icons/tools_bar_transparency.svg\'" ng-show="!vm.isTransp" ng-click="transparencySelect(true)"> <img src="content/images/icons/tools_bar_transparency_pre.svg" ng-show="vm.isTransp" ng-click="transparencySelect(false)"><div class="tip3">\u900F\u660E\u5EA6</div><div class="transparency-slider transparency" ng-show="vm.isTransp" style="z-index: 1000"><div class="slider-rela"><label class="slider-label">\u900F\u660E\u5EA6</label><input type="range" min="0" max="1" step="0.1" value="1" class="text-range rangeSize"> <input type="number" class="slider-input transparency-num" min="0" onmousewheel="return false;" ng-model="template.transparency" ng-change="transparencyChange()"></div></div></button> <button class="nav-coverage tool-bar-btn"><img src="content/images/icons/tools_bar_coverage.svg" onmouseover="this.src=\'content/images/icons/tools_bar_coverage_pre.svg\'" onmouseout="this.src=\'content/images/icons/tools_bar_coverage.svg\'" ng-show="!vm.isCoverage" ng-click="coverageSelect(true)"> <img src="content/images/icons/tools_bar_coverage_pre.svg" ng-show="vm.isCoverage" ng-click="coverageSelect(false)"><div class="tip5" style="left:-3px">\u56FE\u5C42</div><div class="coverage-slider coverage" ng-show="vm.isCoverage" style="z-index:1000"><ul><li ng-click="coverageMove(\'up\')"><div class="tip4" style="left:-14px;top:36px">\u4E0A\u79FB\u4E00\u5C42</div></li><li ng-click="coverageMove(\'down\')"><div class="tip4" style="left:-14px;top:36px">\u4E0B\u79FB\u4E00\u5C42</div></li><li ng-click="coverageMove(\'top\')"><div class="tip" style="left:-2px;top:36px">\u7F6E\u9876</div></li><li ng-click="coverageMove(\'bottom\')"><div class="tip" style="left:-2px;top:36px">\u7F6E\u5E95</div></li></ul></div></button> <button class="nav-lock tool-bar-btn" ng-click="locking()"><img src="content/images/icons/tools_bar_lock.svg" alt="\u9501\u5B9A" onmouseover="this.src=\'content/images/icons/tools_bar_lock_pre.svg\'" onmouseout="this.src=\'content/images/icons/tools_bar_lock.svg\'" ng-show="!selectBox.lock&&!darkTheme"> <img src="content/images/icons/tools_bar_lock_dark.svg" alt="\u9501\u5B9A" onmouseover="this.src=\'content/images/icons/tools_bar_lock_pre.svg\'" onmouseout="this.src=\'content/images/icons/tools_bar_lock_dark.svg\'" ng-show="!selectBox.lock&&darkTheme"> <img src="content/images/icons/tools_bar_lock_pre.svg" alt="\u9501\u5B9A" ng-show="selectBox.lock"><div class="tip6" ng-show="selectBox.lock"></div></button> <button class="nav-copy tool-bar-btn" ng-click="copying()"><img src="content/images/icons/tools_bar_copy.svg" ng-show="!darkTheme" onmouseover="this.src=\'content/images/icons/tools_bar_copy_pre.svg\'" onmouseout="this.src=\'content/images/icons/tools_bar_copy.svg\'" alt="\u590D\u5236"> <img src="content/images/icons/tools_bar_copy_dark.svg" ng-show="darkTheme" onmouseover="this.src=\'content/images/icons/tools_bar_copy_pre.svg\'" onmouseout="this.src=\'content/images/icons/tools_bar_copy_dark.svg\'" alt="\u590D\u5236"><div class="tip">\u590D\u5236</div></button> <button class="rollback-undo tool-bar-btn" ng-click="rollback(0)" ng-class="{\'rollback-active\':pageHistory[template.pageI].currentHistoryIndex}" ng-style="{cursor:!pageHistory[template.pageI].currentHistoryIndex?\'not-allowed\':\'pointer\'}" ng-disabled="!pageHistory[template.pageI].currentHistoryIndex"><img src="content/images/icons/tools_bar_revocation.svg" ng-show="!darkTheme" onmouseover="this.src=\'content/images/icons/tools_bar_revocation_pre.svg\'" onmouseout="this.src=\'content/images/icons/tools_bar_revocation.svg\'"> <img src="content/images/icons/tools_bar_revocation_dark.svg" ng-show="darkTheme" onmouseover="this.src=\'content/images/icons/tools_bar_revocation_pre.svg\'" onmouseout="this.src=\'content/images/icons/tools_bar_revocation_dark.svg\'"><div class="tip3">\u4E0A\u4E00\u6B65</div></button> <button class="rollback-redo rollback-active tool-bar-btn" ng-click="rollback(1)" ng-style="{cursor:!pageHistory[template.pageI].currentHistoryIndex?\'not-allowed\':\'pointer\'}" ng-disabled="!pageHistory[template.pageI].currentHistoryIndex"><img src="content/images/icons/tools_bar_recover.svg" alt="\u6062\u590D" ng-show="!darkTheme" onmouseover="this.src=\'content/images/icons/tools_bar_recover_pre.svg\'" onmouseout="this.src=\'content/images/icons/tools_bar_recover.svg\'"> <img src="content/images/icons/tools_bar_recover_dark.svg" alt="\u6062\u590D" ng-show="darkTheme" onmouseover="this.src=\'content/images/icons/tools_bar_recover_pre.svg\'" onmouseout="this.src=\'content/images/icons/tools_bar_recover_dark.svg\'"><div class="tip">\u6062\u590D</div></button> <button class="nav-delete pos-rela tool-bar-btn" ng-click="deleteBox()"><img src="content/images/icons/tools_bar_delete.svg" alt="\u5220\u9664" ng-show="!darkTheme" onmouseover="this.src=\'content/images/icons/tools_bar_delete_pre.svg\'" onmouseout="this.src=\'content/images/icons/tools_bar_delete.svg\'"> <img src="content/images/icons/tools_bar_delete_dark.svg" alt="\u5220\u9664" ng-show="darkTheme" onmouseover="this.src=\'content/images/icons/tools_bar_delete_pre.svg\'" onmouseout="this.src=\'content/images/icons/tools_bar_delete_dark.svg\'"><div class="tip">\u5220\u9664</div></button> <button class="nav-lock tool-bar-btn" ng-click="toggleFullScreen()"><img src="content/images/icons/tools_bar_full_screen.svg" onmouseover="this.src=\'content/images/icons/tools_bar_full_screen_pre.svg\'" onmouseout="this.src=\'content/images/icons/tools_bar_full_screen.svg\'"><!--<img src="content/images/icons/tools_bar_full_screen_pre.svg"--><!--ng-show="vm.fullFlag">--><div class="tip">\u6EE1\u5C4F</div></button></div></div></header><header class="nav-bg col-lg-12 col-sm-12 col-md-12 pad-0 clearfix" ng-show="currentPage.isScene" ng-class="{\'dark-theme\':darkTheme==true}"><div class="col-lg-9 col-sm-9 col-md-9"></div><div class="col-lg-3 col-sm-3 col-md-3 text-right"><button class="nav-delete pos-rela" ng-click="deleteSceneimagebox()"><img src="content/images/icons/tools_bar_delete.svg" alt="\u5220\u9664" ng-show="!darkTheme"> <img src="content/images/icons/tools_bar_delete_dark.svg" alt="\u5220\u9664" ng-show="darkTheme"><div class="tip">\u5220\u9664</div></button></div></header><section class="body-content col-md-12 col-sm-12 col-md-12"><button class="leftBtn-page ll{{$index}}" ng-click="pageDirection(true)" ng-show="visibleLeft"><img src="content/images/icons/design_scale_page.svg" ng-show="!darkTheme"> <img src="content/images/icons/design_scale_page_dark.svg" ng-show="darkTheme"></button><div class="col-md-12 col-sm-12 col-md-12 template-display no-padding content-scroll" id="pageCenterSize" style="position: relative;height: 760px"><div><!-- old place for page-item2 --><div class="page-item-cover" style="transform:translate(-50% -50%)!important;outline: none" ng-style="{\n                                         width: backupPage.mediabox.width/backupPage.proportion*backupPage.scale,\n                                         height: backupPage.mediabox.height/backupPage.proportion*backupPage.scale\n                                        }"><div class="content-container2 content-page content-page-cover" ng-style="{\n                                            width: (backupPage.mediabox.width/backupPage.proportion)*backupPage.scale,\n                                            height: (backupPage.mediabox.height/backupPage.proportion)*backupPage.scale}"><img ng-src="{{backupPage.pagecover.identifier + vm.pageImageView||\'//:0\'}}"></div></div></div><div class="page-item" ng-show="!currentPage.scene" style="transform:translate(-50% -50%)!important;outline: none" ng-class="{\'custom-grid\':currentPage.background.type==\'Color\'&&!currentPage.background.color}" ng-style="{\n                                         \'width\': currentPage.mediabox.width/currentPage.proportion*currentPage.scale,\n                                         \'height\': currentPage.mediabox.height/currentPage.proportion*currentPage.scale,\n                                         \'margin-left\':canvasCoordX(currentPage.mediabox.width/currentPage.proportion*currentPage.scale),\n                                         \'margin-top\': canvasCoordY(currentPage.mediabox.height/currentPage.proportion*currentPage.scale),\n                                        }"><div class="content-container content-page content-page-main" style="overflow:hidden" ng-click="clearCtrlKey(1)" ng-style="{\n                                            width: (currentPage.mediabox.width/currentPage.proportion)*currentPage.scale,\n                                            height: (currentPage.mediabox.height/currentPage.proportion)*currentPage.scale,\n                                            background:currentPage.background.type==\'Color\'?currentPage.background.color:\'\'\n                                            }"><img id="bgImg" class="bg-image bg-image{{template.pageI}} pos" ng-cloak ondblclick="doubleClickbgImg(event, false)" ng-if="currentPage.background.resource.identifier" ng-src="{{currentPage.background.resource.identifier + vm.pageImageView||\'//:0\'}}" ng-style="{\n                                             position: \'absolute\',\n                                             left:currentPage.background.offsetx*currentPage.scale/currentPage.proportion,\n                                             top:currentPage.background.offsety*currentPage.scale/currentPage.proportion,\n                                             width: currentPage.background.adaptation==\'Width\'?currentPage.background.width*currentPage.scale/currentPage.proportion:\'\',\n                                             height:currentPage.background.adaptation==\'Height\'?currentPage.background.height*currentPage.scale/currentPage.proportion:\'\'}"><div ng-repeat="level in currentPage.levels.level track by $index" ng-init="levelIndex = $index"><div id="mask" data-index="{{$index}}" class="imgBox" ng-show="level.imagebox.current" ng-dblclick="doubleClickImagebox($event, $index, level.imagebox)" ng-class="{\'selected\': level.imagebox.ctrlKey || $index == template.levelI && (RightPanel==\'mask\')}" ng-style="{\n                                                width: imageboxW(level.imagebox)*currentPage.scale/currentPage.proportion,\n                                                height: imageboxH(level.imagebox)*currentPage.scale/currentPage.proportion,\n                                                left: imageboxL(level.imagebox)*currentPage.scale/currentPage.proportion,\n                                                top: imageboxT(level.imagebox)*currentPage.scale/currentPage.proportion,\n                                                \'opacity\':level.imagebox.transparency,\n                                                \'z-index\':level.seq-0+200,\n                                                \'transform\': \'rotate(-\' + level.imagebox.rotation.angle + \'deg)\'\n                                            }" ng-click="selectImg($event, $index, level.imagebox)"><div class="relative-view1" data-index="{{$index}}" ng-mousedown="moveBoxStart($event,level.imagebox,$index)" ng-style="{\n                                                 \'overflow\': (level.imagebox.border && level.imagebox.border.type == \'Pic\') ? \'unset\' : \'hidden\',\n                                                    \'border-top-left-radius\':(level.imagebox.border && level.imagebox.border.type == \'Pic\') ? 0 : imageboxWRadius(level.imagebox, \'lt\', currentPage.scale/currentPage.proportion),\n                                                    \'border-top-right-radius\':(level.imagebox.border && level.imagebox.border.type == \'Pic\') ? 0 : imageboxWRadius(level.imagebox, \'rt\', currentPage.scale/currentPage.proportion),\n                                                    \'border-bottom-right-radius\':(level.imagebox.border && level.imagebox.border.type == \'Pic\') ? 0 : imageboxWRadius(level.imagebox, \'rb\', currentPage.scale/currentPage.proportion),\n                                                    \'border-bottom-left-radius\':(level.imagebox.border && level.imagebox.border.type == \'Pic\') ? 0 : imageboxWRadius(level.imagebox, \'lb\', currentPage.scale/currentPage.proportion),\n                                                    \'border-width\': (level.imagebox.border && level.imagebox.border.type == \'Color\') ? (level.imagebox.border.lineWidth*currentPage.scale/currentPage.proportion) : \'\',\n                                                    \'border-style\': (level.imagebox.border && level.imagebox.border.type == \'Color\' && level.imagebox.border.lineType == \'solid\') ? \'solid\' : (level.imagebox.border && level.imagebox.border.type == \'Color\' && level.imagebox.border.lineType == \'dashed\') ? \'dashed\' : (level.imagebox.border && level.imagebox.border.type == \'Color\' && level.imagebox.border.lineType == \'dotted\') ? \'dotted\' : \'none\',\n                                                    \'border-color\': (level.imagebox.border && level.imagebox.border.type == \'Color\') ? level.imagebox.border.color : \'\',\n                                                    \'box-shadow\' : (level.imagebox.border && level.imagebox.border.type == \'Color\' && level.imagebox.border.lineWidth>0 && level.imagebox.border && level.imagebox.border.lineType == \'solid\') ? \'0 0 0 1px \' + level.imagebox.border.color + \' inset\' : \'none\',\n                                                    \'filter\' : dropShadow(level.imagebox,currentPage.scale/currentPage.proportion) ,\n                                                    }"><div ng-style="{\n                                                     \'position\': \'absolute\',\n                                                     \'z-index\':0,\n                                                    \'left\': (level.imagebox.border && level.imagebox.border.type == \'Pic\') ? -imageboxWEdge(level.imagebox,\'left\')*currentPage.scale/currentPage.proportion : 0,\n                                                    \'top\': (level.imagebox.border && level.imagebox.border.type == \'Pic\') ? -imageboxWEdge(level.imagebox,\'top\')*currentPage.scale/currentPage.proportion : 0,\n                                                    \'right\': (level.imagebox.border && level.imagebox.border.type == \'Pic\') ? -imageboxWEdge(level.imagebox,\'right\')*currentPage.scale/currentPage.proportion : 0,\n                                                    \'bottom\': (level.imagebox.border && level.imagebox.border.type == \'Pic\') ? -imageboxWEdge(level.imagebox,\'bottom\')*currentPage.scale/currentPage.proportion : 0,\n                                                    \'background-image\': (level.imagebox.border && level.imagebox.border.type == \'Pic\') ? \'url(\' + level.imagebox.border.resource.identifier + vm.pageImageView + \')\' : \'\',\n                                                    \'background-size\': (level.imagebox.border && level.imagebox.border.type == \'Pic\') ? \'100% 100%\' : \'\',\n                                                    }"></div><div class="relative-view1" ng-style="{\n                                                    \'border-top-left-radius\':imageboxWRadius1(level.imagebox, \'lt\', currentPage.scale/currentPage.proportion),\n                                                        \'border-top-right-radius\':imageboxWRadius1(level.imagebox, \'rt\', currentPage.scale/currentPage.proportion),\n                                                        \'border-bottom-right-radius\':imageboxWRadius1(level.imagebox, \'rb\', currentPage.scale/currentPage.proportion),\n                                                        \'border-bottom-left-radius\':imageboxWRadius1(level.imagebox, \'lb\', currentPage.scale/currentPage.proportion),\n                                                    \'-webkit-mask-image\': level.imagebox.mask.resource.identifier ? \'url(\' + level.imagebox.mask.resource.identifier + \')\' : \'none\',\n                                                    \'-webkit-mask-size\': \'100% 100%\'\n                                                    }"><!-- <img data-index="{{$index}}"\n                                                         ng-if="!level.imagebox.image&&!level.imagebox.image.resource.identifier"\n                                                         class="img-holder mask"\n                                                         style="width: 100%; height: 100%;"\n                                                         src="content/images/mask_souce.png"\n                                                         data-mask="content/images/centerblur.png"/> --><div ng-if="!level.imagebox.image&&!level.imagebox.image.resource.identifier" data-index="{{$index}}" class="image-placeholder"><img src="content/images/icons/camera.svg" alt="" srcset="" data-index="{{$index}}"> <span ng-if="imageboxW(level.imagebox)*currentPage.scale/currentPage.proportion > 60 && imageboxH(level.imagebox)*currentPage.scale/currentPage.proportion > 80" data-index="{{$index}}">\u62D6\u5165\u76F8\u7247</span></div><img data-index="{{$index}}" ng-if="level.imagebox.image&&level.imagebox.image.resource.identifier" class="img-holder mask" style="position: absolute" ng-style="{\n                                                        width: level.imagebox.image.width*currentPage.scale/currentPage.proportion,\n                                                        height: level.imagebox.image.height*currentPage.scale/currentPage.proportion,\n                                                        left: level.imagebox.image.offsetx*currentPage.scale/currentPage.proportion,\n                                                        top: level.imagebox.image.offsety*currentPage.scale/currentPage.proportion\n                                                     }" ng-src="{{level.imagebox.image.resource.identifier+vm.pageImageViewOrient}}"></div></div><span class="sel-bottom" data-index="{{$index}}" onmousedown="resizeStart(event)" ng-if="$index == template.levelI && (RightPanel==\'mask\')&&!level.imagebox.ctrlKey"></span> <span class="sel-top" data-index="{{$index}}" ng-mousedown="resizeStartLeft($event,level.imagebox,currentPage.scale/currentPage.proportion, $index)" ng-if="$index == template.levelI && (RightPanel==\'mask\')&&!level.imagebox.ctrlKey"></span> <span class="sel-right" data-index="{{$index}}" ng-mousedown="resizeStartTop($event,level.imagebox,currentPage.scale/currentPage.proportion, $index)" ng-if="$index == template.levelI && (RightPanel==\'mask\')&&!level.imagebox.ctrlKey"></span> <span class="sel-bottom" data-index="{{$index}}" ng-mousedown="resizeStartRigth($event, level.imagebox,currentPage.scale/currentPage.proportion, $index)" ng-if="$index == template.levelI && (RightPanel==\'mask\')&&!level.imagebox.ctrlKey"></span> <span class="sel-left" data-index="{{$index}}" ng-mousedown="resizeStartBottom($event,level.imagebox,currentPage.scale/currentPage.proportion, $index)" ng-if="$index == template.levelI && (RightPanel==\'mask\')&&!level.imagebox.ctrlKey"></span> <span class="sel-left1" data-index="{{$index}}" ng-mousedown="resizeStartLeft1($event,level.imagebox,currentPage.scale/currentPage.proportion, $index)" ng-if="$index == template.levelI && (RightPanel==\'mask\')&&!level.imagebox.ctrlKey"></span> <span class="sel-top1" data-index="{{$index}}" ng-mousedown="resizeStartTop1($event,level.imagebox,currentPage.scale/currentPage.proportion, $index)" ng-if="$index == template.levelI && (RightPanel==\'mask\')&&!level.imagebox.ctrlKey"></span> <span class="sel-right1" data-index="{{$index}}" ng-mousedown="resizeStartRight1($event,level.imagebox,currentPage.scale/currentPage.proportion, $index)" ng-if="$index == template.levelI && (RightPanel==\'mask\')&&!level.imagebox.ctrlKey"></span> <span class="sel-bottom1" data-index="{{$index}}" ng-mousedown="resizeStartBottom1($event,level.imagebox,currentPage.scale/currentPage.proportion, $index)" ng-if="$index == template.levelI && (RightPanel==\'mask\')&&!level.imagebox.ctrlKey"></span><div class="rotate-box" ng-if="$index == template.levelI && (RightPanel==\'mask\')" ng-style="{width:level.imagebox.geometry.width*currentPage.scale/currentPage.proportion-20}"><span class="rotate-line"></span><br><span class="rotate-icon rotate-icon{{$index}}" data-index="{{$index}}" ng-mousedown="rotateBoxStart($event,level.imagebox,$index)"></span></div></div><div id="art" data-index="{{$index}}" class="img-art img-art{{template.pageI}}{{$index}}" ondblclick="doubleClickClipart(event)" ng-show="level.imageart&&level.imageart.current" ng-style="{\n                                                    width: level.imageart.geometry.width*currentPage.scale/currentPage.proportion,\n                                                    height: level.imageart.geometry.height*currentPage.scale/currentPage.proportion,\n                                                    left: level.imageart.geometry.x*currentPage.scale/currentPage.proportion,\n                                                    top: level.imageart.geometry.y*currentPage.scale/currentPage.proportion,\n                                                    \'z-index\':level.seq-0+200,\n                                                    \'transform\': \'rotate(\' + level.imageart.rotation.angle + \'deg)\'}" ng-click="selectArt($event, $index, level.imageart)" ng-class="{\'selected\': level.imageart.ctrlKey || $index == template.levelI && RightPanel==\'material\'}"><div style="overflow: hidden; position: relative; width: 100%; height: 100%"><img data-index="{{$index}}" id="art-img{{$index}}" ng-mousedown="moveBoxStart($event,level.imageart,$index)" style="transition: opacity 0.3s;position: absolute" ng-style="{\n                                                        \'opacity\':level.imageart.transparency,\n                                                        filter: \'alpha(opacity=\'+level.imageart.transparency*100+\')\',\n                                                        \'left\': level.imageart.offsetx *currentPage.scale/currentPage.proportion,\n                                                        \'top\': level.imageart.offsety *currentPage.scale/currentPage.proportion,\n                                                        \'width\': level.imageart.geometry.width *currentPage.scale/currentPage.proportion * level.imageart.scale\n                                                     }" ng-src="{{level.imageart.resource.identifier + vm.pageImageView}}"></div><div ng-if="$index == template.levelI && RightPanel == \'material\'&&!level.imageart.ctrlKey"><span class="sel-left" ng-mousedown="imageartdownZoomBottom($event,level.imageart)"></span> <span class="sel-top" ng-mousedown="imageartdownZoomLeft($event,level.imageart)"></span> <span class="sel-right" ng-mousedown="imageartdownZoomTop($event,level.imageart)"></span> <span class="sel-bottom" ng-mousedown="imageartdownZoomRight($event,level.imageart)"></span></div><div class="c-xml-page-material-rotate1" ng-if="$index == template.levelI && (RightPanel==\'material\')"><span class="c-xml-page-material-rotate-icon" ng-mousedown="rotateBoxStart($event,level.imageart,$index)"></span></div></div><div class="c-xml-page-textboxe textbox{{template.pageI}}{{$index}}" ng-show="level.textbox.current" ng-click="selectText($event, $index, level.textbox)" style="white-space: normal" ng-class="{\'selected\': level.textbox.ctrlKey || $index == template.levelI && RightPanel == \'text\'}" ng-style="{\n                                                \'z-index\':level.seq-0+200,\n                                                \'width\': level.textbox.geometry.width * currentPage.scale/currentPage.proportion,\n                                                \'height\': level.textbox.geometry.height * currentPage.scale/currentPage.proportion,\n                                                \'left\': level.textbox.geometry.x * currentPage.scale/currentPage.proportion,\n                                                \'top\': level.textbox.geometry.y * currentPage.scale/currentPage.proportion,\n                                                \'transform\': \'rotate(\' + level.textbox.rotation.angle + \'deg)\'\n                                             }"><pre class="c-xml-page-textboxe-text web-font" data-index="{{$index}}" ng-style="{\n                                                \'font-family\':  \'\\\'\' + level.textbox.fontuuid + \'\\\'\',\n                                                \'font-size\': level.textbox.style.size + \'pt\',\n                                                \'color\': level.textbox.style.color,\n                                                \'font-weight\': level.textbox.style.bold ? \'bold\': \'400\',\n                                                \'font-style\': level.textbox.style.italic ? \'italic\': \'initial\',\n                                                \'line-height\': level.textbox.style.lineheight + \'pt\',\n                                                \'letter-spacing\': level.textbox.style.letterspacing + \'pt\',\n                                                \'opacity\': level.textbox.transparency,\n                                                \'text-decoration\': \'none\',\n                                                \'text-align\': level.textbox.style.align,\n                                                \'text-align-last\': \'unset\',\n                                                transform:\'scale(\'+(currentPage.scale*currentPage.proportionText)+\')\',\n                                                \'transform-origin\': \'0 0\',\n                                                width: level.textbox.geometry.width/currentPage.proportion/currentPage.proportionText,\n                                                height: level.textbox.geometry.height/currentPage.proportion/currentPage.proportionText\n                                              }" ng-mousedown="moveBoxStart($event,level.textbox,$index)"><span class="c-xml-page-textboxe-span">{{level.textbox.text}}</span></pre><span class="c-xml-page-material-zoom c-xml-page-material-zoom-left" style="display: block" ng-if="$index == template.levelI && RightPanel == \'text\'&&!level.textbox.ctrlKey" ng-mousedown="textboxZoomLeft($event,level.textbox,currentPage.scale/currentPage.proportion,$index)"></span> <span class="c-xml-page-material-zoom c-xml-page-material-zoom-right" style="display: block" ng-if="$index == template.levelI && RightPanel == \'text\'&&!level.textbox.ctrlKey" ng-mousedown="textboxZoomRight($event,level.textbox,currentPage.scale/currentPage.proportion,$index)"></span> <span class="c-xml-page-material-zoom c-xml-page-material-zoom-left1" style="display: block" ng-if="$index == template.levelI && RightPanel == \'text\'&&!level.textbox.ctrlKey" ng-mousedown="textboxZoomLeft1($event,level.textbox,currentPage.scale/currentPage.proportion,$index)"></span> <span class="c-xml-page-material-zoom c-xml-page-material-zoom-top1" style="display: block" ng-if="$index == template.levelI && RightPanel == \'text\'&&!level.textbox.ctrlKey" ng-mousedown="textboxZoomTop1($event,level.textbox,currentPage.scale/currentPage.proportion,$index)"></span> <span class="c-xml-page-material-zoom c-xml-page-material-zoom-right1" style="display: block" ng-if="$index == template.levelI && RightPanel == \'text\'&&!level.textbox.ctrlKey" ng-mousedown="textboxZoomRight1($event,level.textbox,currentPage.scale/currentPage.proportion,$index)"></span> <span class="c-xml-page-material-zoom c-xml-page-material-zoom-bottom1" style="display: block" ng-if="$index == template.levelI && RightPanel == \'text\'&&!level.textbox.ctrlKey" ng-mousedown="textboxZoomBottom1($event,level.textbox,currentPage.scale/currentPage.proportion,$index)"></span><div class="rotate-box" ng-if="$index == template.levelI && RightPanel == \'text\'&&!level.textbox.ctrlKey" ng-style="{width:level.textbox.geometry.width*currentPage.scale/currentPage.proportion-20,\n                                                 top:level.textbox.geometry.height*currentPage.scale/currentPage.proportion}"><span class="rotate-line"></span><br><span class="rotate-icon rotate-icon{{$index}}" data-index="{{$index}}" style="margin-left: 12px" ng-mousedown="rotateBoxStart($event,level.textbox,$index)"></span></div><div class="loading-font" ng-if="level.textbox.loading"></div></div><div id="textdocument" data-index="{{$index}}" ng-show="level.textdocument.current" ng-mousedown="moveBoxStart($event,level.textdocument,$index)" ng-class="{\'selected\': level.textdocument.ctrlKey || $index == template.levelI && RightPanel==\'textDoc\'}" ng-style="{\n                                                 position: \'absolute\',\n                                                width: level.textdocument.geometry.width*currentPage.scale/currentPage.proportion,\n                                                height: level.textdocument.geometry.height*currentPage.scale/currentPage.proportion,\n                                                left: level.textdocument.geometry.x*currentPage.scale/currentPage.proportion,\n                                                top: level.textdocument.geometry.y*currentPage.scale/currentPage.proportion,\n                                                \'z-index\':level.seq-0+200,\n                                                \'opacity\':level.textdocument.transparency.toFixed(2),\n                                                filter: \'alpha(opacity=\'+level.textdocument.transparency*100+\')\',\n                                                \'transform\': \'rotate(-\' + level.textdocument.rotation.angle + \'deg)\'}" ng-click="selectDoc($event, $index, level.textdocument)"><div style="overflow: hidden;width: 100%;height: 100%;position: relative"><img class="bg-image bg-image{{template.pageI}} pos no-events" ng-cloak ng-if="level.textdocument.background.resource.identifier" ng-src="{{level.textdocument.background.resource.identifier + vm.pageImageView||\'//:0\'}}" ng-style="{\n                                                 position: \'absolute\',\n                                                 left:level.textdocument.background.offsetx*currentPage.scale/currentPage.proportion,\n                                                 top:level.textdocument.background.offsety*currentPage.scale/currentPage.proportion,\n                                                 width: level.textdocument.background.adaptation==\'Width\'?level.textdocument.geometry.width*currentPage.scale/currentPage.proportion:\'\',\n                                                 height:level.textdocument.background.adaptation!=\'Width\'?level.textdocument.geometry.height*currentPage.scale/currentPage.proportion:\'\'}"><div ng-repeat="docLevel in level.textdocument.levels.level track by $index" ng-init="docIndex = $index" style="position: relative"><div data-index="{{docIndex}}" class="img-art no-events" ng-show="docLevel.imageart" ng-style="{\n                                                            width: docLevel.imageart.geometry.width*currentPage.scale/currentPage.proportion,\n                                                            height: docLevel.imageart.geometry.height*currentPage.scale/currentPage.proportion,\n                                                            left: docLevel.imageart.geometry.x*currentPage.scale/currentPage.proportion,\n                                                            top: docLevel.imageart.geometry.y*currentPage.scale/currentPage.proportion,\n                                                            \'z-index\':docLevel.seq-0+200,\n                                                            \'opacity\':docLevel.imageart.transparency,\n                                                            filter: \'alpha(opacity=\'+docLevel.imageart.transparency*100+\')\',\n                                                            \'transform\': \'rotate(\' + docLevel.imageart.rotation.angle + \'deg)\'}"><div style="overflow: hidden; position: relative; width: 100%; height: 100%"><img data-index="{{$index}}" style="transition: opacity 0.3s;position: absolute" ng-style="{\n                                                                \'left\': docLevel.imageart.offsetx *currentPage.scale/currentPage.proportion,\n                                                                \'top\': docLevel.imageart.offsety *currentPage.scale/currentPage.proportion,\n                                                                \'width\': docLevel.imageart.geometry.width * currentPage.scale/currentPage.proportion * docLevel.imageart.scale}" ng-src="{{docLevel.imageart.resource.identifier + vm.pageImageView}}"></div></div><div class="c-xml-page-textboxe textbox{{template.pageI}}{{levelIndex}}{{docIndex}}" ng-show="docLevel.textbox" style="white-space: normal" data-index="{{docIndex}}" ng-click="selectTextDocFont($event, levelIndex,docIndex, docLevel.textbox)" ng-class="{\'selected\': levelIndex == template.levelI&&docIndex == template.docI && RightPanel == \'textDoc\'}" ng-style="{\n                                                        \'z-index\':docLevel.seq-0+200,\n                                                        \'width\': docLevel.textbox.geometry.width * currentPage.scale/currentPage.proportion,\n                                                        \'height\': docLevel.textbox.geometry.height * currentPage.scale/currentPage.proportion,\n                                                        \'left\': docLevel.textbox.geometry.x * currentPage.scale/currentPage.proportion,\n                                                        \'top\': docLevel.textbox.geometry.y * currentPage.scale/currentPage.proportion,\n                                                        \'transform\': \'rotate(\' + docLevel.textbox.rotation.angle + \'deg)\'}"><div style="width: 100%;height: 100%;position: absolute;top:0;left: 0"><pre class="c-xml-page-textboxe-text web-font" ng-style="{\n                                                            \'font-family\':  \'\\\'\' + docLevel.textbox.fontuuid + \'\\\'\',\n                                                            \'font-size\': docLevel.textbox.style.size + \'pt\',\n                                                            \'color\': docLevel.textbox.style.color,\n                                                            \'font-weight\': docLevel.textbox.style.bold ? \'bold\': \'400\',\n                                                            \'font-style\': docLevel.textbox.style.italic ? \'italic\': \'initial\',\n                                                            \'line-height\': docLevel.textbox.style.lineheight + \'pt\',\n                                                            \'letter-spacing\': docLevel.textbox.style.letterspacing + \'pt\',\n                                                            \'opacity\': docLevel.textbox.transparency,\n                                                            \'text-decoration\': \'none\',\n                                                            \'text-align\': docLevel.textbox.style.align,\n                                                            \'text-align-last\': \'unset\',\n                                                            transform:\'scale(\'+(currentPage.scale*currentPage.proportionText)+\')\',\n                                                            \'transform-origin\': \'0 0\',\n                                                            width: docLevel.textbox.geometry.width/currentPage.proportion/currentPage.proportionText,\n                                                            height: docLevel.textbox.geometry.height/currentPage.proportion/currentPage.proportionText\n                                                          }"><span class="c-xml-page-textboxe-span">{{docLevel.textbox.text}}</span></pre></div></div></div></div><span class="sel-bottom" data-index="{{$index}}" onmousedown="resizeDocStart(event)" ng-if="$index == template.levelI && (RightPanel==\'textDoc\')&&!level.textdocument.ctrlKey"></span><!--<span class="sel-left" data-index="{{$index}}"--><!--ng-if="$index == template.levelI && (RightPanel==\'mask\')&&!img.ctrlKey"></span>--><div class="rotate-box" ng-if="$index == template.levelI && (RightPanel==\'textDoc\')" ng-style="{\n                                                 width:level.textdocument.geometry.width*currentPage.scale/currentPage.proportion-20,\n                                                 bottom:\'-49px\' }"><span class="rotate-line"></span><br><span class="rotate-icon rotate-icon{{$index}}" data-index="{{$index}}" ng-mousedown="rotateBoxStart($event,level.textdocument,$index)"></span></div></div></div><div class="barcode cursorPointer" id="barcode{{template.pageI}}" ng-click="selectBar($event,currentPage, \'barcode\')" ng-class="{\'selected\': RightPanel == \'barcode\'}" onmousedown="moveBarcodeStart(event)" readonly="readonly" ng-show="currentPage.barcode&&currentPage.barcode.geometry" ng-style="{\n                                                             \'line-height\':\'0\',\n                                                             top: currentPage.barcode.geometry.y*currentPage.scale/currentPage.proportion,\n                                                             left: currentPage.barcode.geometry.x*currentPage.scale/currentPage.proportion,\n                                                             width: currentPage.barcode.geometry.width*currentPage.scale/currentPage.proportion,\n                                                             height: currentPage.barcode.geometry.height*currentPage.scale/currentPage.proportion,\n                                                             \'z-index\': 998,\n                                                            \'transform\': \'rotate(-\' + currentPage.barcode.rotation.angle + \'deg)\'\n                                                        }"><img src="content/images/txm.png" style="width: 100%;height: 100%"></div><div class="barcode cursorPointer" ng-click="selectBar($event,currentPage, \'qrcode\')" ng-class="{\'selected\': RightPanel == \'qrcode\'}" onmousedown="moveQrcodeStart(event)" readonly="readonly" ng-show="currentPage.qrcode&&currentPage.qrcode.geometry" ng-style="{\n                                                             \'line-height\':\'0\',\n                                                             top: currentPage.qrcode.geometry.y*currentPage.scale/currentPage.proportion,\n                                                             left: currentPage.qrcode.geometry.x*currentPage.scale/currentPage.proportion,\n                                                             width: currentPage.qrcode.geometry.width*currentPage.scale/currentPage.proportion,\n                                                             height: currentPage.qrcode.geometry.height*currentPage.scale/currentPage.proportion,\n                                                             \'z-index\': 998,\n                                                            \'transform\': \'rotate(-\' + currentPage.qrcode.rotation.angle + \'deg)\'\n                                                        }"><img src="content/images/QrCode.png" style="width: 100%;height: 100%"></div><div class="border-red cursorPointer no-events" id="border-red" ng-repeat="editbox in currentPage.editboxes.editbox" ng-style="{\n                                                        width:editbox.width/ currentPage.proportion*currentPage.scale,\n                                                        height:editbox.height/ currentPage.proportion*currentPage.scale,\n                                                        top:editbox.y/ currentPage.proportion*currentPage.scale,\n                                                        left:editbox.x/ currentPage.proportion*currentPage.scale}"></div><div class="border-blue cursorPointer no-events" ng-style="{\n                                                    width:currentPage.width*currentPage.scale,\n                                                    height:currentPage.height*currentPage.scale,\n                                                    top:currentPage.bloodPx.top*currentPage.scale/currentPage.proportion,\n                                                    left:currentPage.bloodPx.left*currentPage.scale/currentPage.proportion}"></div></div></div><div class="page-item page-item1" ng-show="currentPage.scene" style="transform:translate(-50% -50%)!important;outline: none" ng-class="{\'custom-grid\':currentPage.background.type==\'Color\'&&!currentPage.background.color}" ng-style="{\n                                     width: (currentPage.scene.geometry.width)*currentPage.scene.ratio,\n                                     height: (currentPage.scene.geometry.height)*currentPage.scene.ratio,\n                                     \'margin-left\':canvasCoordX((currentPage.scene.geometry.width)*currentPage.scene.ratio),\n                                     \'margin-top\': canvasCoordY((currentPage.scene.geometry.height)*currentPage.scene.ratio),\n                                    }"><div style="width: 100%; height: 100%; position: relative"><div class="content-container content-page" ng-click="clearCtrlKey(1)" ng-style="{\n                                        position: \'absolute\',\n                                        width: (currentPage.scene.geometry.width)*currentPage.scene.ratio,\n                                        height: (currentPage.scene.geometry.height)*currentPage.scene.ratio,\n                                        \'z-index\': currentPage.scene.hierarchy == \'TOP\' ? \'1\' : \'0\',\n                                        \'pointer-events\': \'none\',\n                                    }"><img class="bg-image bg-image{{template.pageI}}" ng-cloak ng-show="currentPage.scene.background.resource.identifier" ng-src="{{currentPage.scene.background.resource.identifier  + vm.pageImageView}}" ng-style="{width: currentPage.scene.background.resource.identifier?currentPage.scene.geometry.width*currentPage.scene.ratio:0}"><div ng-style="{\n                                                    position: \'absolute\',\n                                                    width: currentPage.scene.imagebox.geometry.width*currentPage.scene.ratio,\n                                                    height: currentPage.scene.imagebox.geometry.height*currentPage.scene.ratio,\n                                                    left: currentPage.scene.imagebox.geometry.x*currentPage.scene.ratio,\n                                                    top: currentPage.scene.imagebox.geometry.y*currentPage.scene.ratio,\n                                                    \'transform\': \'rotate(-\' + currentPage.scene.imagebox.rotation.angle + \'deg)\'}" ng-show="currentPage.scene.imagebox"></div></div><div class="editing1" id="content1" ng-style="{\n                                     position: \'absolute\',\n                                     background:currentPage.background.color ? currentPage.background.color : \'none\',\n                                     width: currentPage.mediabox.width*currentPage.scene.ratio,\n                                     height: currentPage.mediabox.height*currentPage.scene.ratio,\n                                     left: currentPage.scene.imagebox.geometry.x*currentPage.scene.ratio,\n                                     top: currentPage.scene.imagebox.geometry.y*currentPage.scene.ratio,\n                                    \'z-index\': currentPage.scene.hierarchy == \'TOP\' ? 0 : 1,\n                                     }" style="overflow: hidden;border: 1px solid #299DFF"><img class="bg-image bg-image1{{template.pageI}} pos" ng-cloak ondblclick="doubleClickbgImg(event,true)" ng-if="currentPage.background.resource.identifier" ng-src="{{currentPage.background.resource.identifier + vm.pageImageView||\'//:0\'}}" ng-style="{\n                                                         position: \'absolute\',\n                                                         left:currentPage.background.offsetx*currentPage.scene.ratio,\n                                                         top:currentPage.background.offsety*currentPage.scene.ratio,\n                                                         width: currentPage.background.adaptation==\'Width\'?currentPage.mediabox.width*currentPage.scene.ratio:\'\',\n                                                         height:currentPage.background.adaptation==\'Height\'?currentPage.mediabox.height*currentPage.scene.ratio:\'\'}"><div ng-repeat="level in currentPage.levels.level track by $index"><div data-index="{{$index}}" class="imgBox" ng-show="level.imagebox.current" ng-class="{\'selected\': level.imagebox.ctrlKey || $index == template.levelI && (RightPanel==\'mask\')}" ng-dblclick="doubleClickImagebox($event, $index, level.imagebox)" ng-click="selectImg($event, $index, level.imagebox)" ng-style="{\n                                                    \'opacity\':level.imagebox.transparency,\n                                                    width: imageboxW(level.imagebox)*currentPage.scene.ratio,\n                                                    height: imageboxH(level.imagebox)*currentPage.scene.ratio,\n                                                    left: imageboxL(level.imagebox)*currentPage.scene.ratio,\n                                                    top: imageboxT(level.imagebox)*currentPage.scene.ratio,\n                                                    \'z-index\':level.seq-0+200,\n                                                    \'transform\': \'rotate(-\' + level.imagebox.rotation.angle + \'deg)\'\n                                                    }"><div class="relative-view1" data-index="{{$index}}" ng-mousedown="moveBoxStart1($event,level.imagebox,$index)" ng-style="{\n                                                     \'overflow\': (level.imagebox.border && level.imagebox.border.type == \'Pic\') ? \'unset\' : \'hidden\',\n                                                    \'border-top-left-radius\':(level.imagebox.border && level.imagebox.border.type == \'Pic\') ? 0 : imageboxWRadius(level.imagebox, \'lt\',currentPage.scene.ratio),\n                                                    \'border-top-right-radius\':(level.imagebox.border && level.imagebox.border.type == \'Pic\') ? 0 : imageboxWRadius(level.imagebox, \'rt\',currentPage.scene.ratio),\n                                                    \'border-bottom-right-radius\':(level.imagebox.border && level.imagebox.border.type == \'Pic\') ? 0 : imageboxWRadius(level.imagebox, \'rb\',currentPage.scene.ratio),\n                                                    \'border-bottom-left-radius\':(level.imagebox.border && level.imagebox.border.type == \'Pic\') ? 0 : imageboxWRadius(level.imagebox, \'lb\',currentPage.scene.ratio),\n                                                    \'border-width\': (level.imagebox.border && level.imagebox.border.type == \'Color\') ? (level.imagebox.border.lineWidth*currentPage.scene.ratio) : \'\',\n                                                    \'border-style\': (level.imagebox.border && level.imagebox.border.type == \'Color\' && level.imagebox.border.lineType == \'solid\') ? \'solid\' : (level.imagebox.border && level.imagebox.border.type == \'Color\' && level.imagebox.border.lineType == \'dashed\') ? \'dashed\' : (level.imagebox.border && level.imagebox.border.type == \'Color\' && level.imagebox.border.lineType == \'dotted\') ? \'dotted\' : \'none\',\n                                                    \'border-color\': (level.imagebox.border && level.imagebox.border.type == \'Color\') ? level.imagebox.border.color : \'\',\n                                                    \'box-shadow\' : (level.imagebox.border && level.imagebox.border.type == \'Color\' && level.imagebox.border.lineWidth>0 && level.imagebox.border && level.imagebox.border.lineType == \'solid\') ? \'0 0 0 1px \' + level.imagebox.border.color + \' inset\' : \'none\',\n                                                    \'filter\' : dropShadow(level.imagebox,currentPage.scene.ratio),\n                                                    }"><div ng-style="{\n                                                     \'position\': \'absolute\',\n                                                     \'z-index\':0,\n                                                    \'left\': (level.imagebox.border && level.imagebox.border.type == \'Pic\') ? -imageboxWEdge(level.imagebox,\'left\')*currentPage.scene.ratio : 0,\n                                                    \'top\': (level.imagebox.border && level.imagebox.border.type == \'Pic\') ? -imageboxWEdge(level.imagebox,\'top\')*currentPage.scene.ratio : 0,\n                                                    \'right\': (level.imagebox.border && level.imagebox.border.type == \'Pic\') ? -imageboxWEdge(level.imagebox,\'right\')*currentPage.scene.ratio : 0,\n                                                    \'bottom\': (level.imagebox.border && level.imagebox.border.type == \'Pic\') ? -imageboxWEdge(level.imagebox,\'bottom\')*currentPage.scene.ratio : 0,\n                                                    \'background-image\': (level.imagebox.border && level.imagebox.border.type == \'Pic\') ? \'url(\' + level.imagebox.border.resource.identifier + vm.pageImageView + \')\' : \'\',\n                                                    \'background-size\': (level.imagebox.border && level.imagebox.border.type == \'Pic\') ? \'100% 100%\' : \'\',\n                                                    }"></div><div class="relative-view1" ng-style="{\n                                                        \'border-top-left-radius\':imageboxWRadius1(level.imagebox, \'lt\', currentPage.scene.ratio),\n                                                        \'border-top-right-radius\':imageboxWRadius1(level.imagebox, \'rt\', currentPage.scene.ratio),\n                                                        \'border-bottom-right-radius\':imageboxWRadius1(level.imagebox, \'rb\', currentPage.scene.ratio),\n                                                        \'border-bottom-left-radius\':imageboxWRadius1(level.imagebox, \'lb\', currentPage.scene.ratio),\n                                                        \'-webkit-mask-image\': level.imagebox.mask.resource.identifier ? \'url(\' + level.imagebox.mask.resource.identifier + \')\' : \'none\',\n                                                        \'-webkit-mask-size\': \'100% 100%\'\n                                                        }"><!-- <img data-index="{{$index}}"\n                                                             ng-if="!level.imagebox.image&&!level.imagebox.image.resource.identifier"\n                                                             class="img-holder mask"\n                                                             style="width: 100%; height: 100%;"\n                                                             src="content/images/mask_souce.png"\n                                                             data-mask="content/images/centerblur.png"/> --><div ng-if="!level.imagebox.image&&!level.imagebox.image.resource.identifier" data-index="{{$index}}" class="image-placeholder"><img src="content/images/icons/camera.svg" alt="" srcset="" data-index="{{$index}}"> <span ng-if="imageboxW(level.imagebox)*currentPage.scale/currentPage.proportion > 60 && imageboxH(level.imagebox)*currentPage.scale/currentPage.proportion > 80" data-index="{{$index}}">\u62D6\u5165\u76F8\u7247</span></div><img data-index="{{$index}}" ng-if="level.imagebox.image&&level.imagebox.image.resource.identifier" class="img-holder mask" style="position: absolute" ng-style="{\n                                                        width: level.imagebox.image.width*currentPage.scene.ratio,\n                                                        height: level.imagebox.image.height*currentPage.scene.ratio,\n                                                        left: level.imagebox.image.offsetx*currentPage.scene.ratio,\n                                                        top: level.imagebox.image.offsety*currentPage.scene.ratio\n                                                     }" ng-src="{{level.imagebox.image.resource.identifier+vm.pageImageViewOrient}}"><!--                                                    <img data-index="{{$index}}"--><!--                                                         class="img-holder mask"--><!--                                                         style="width: 100%;height: 100%"--><!--                                                         ng-src="{{level.imagebox.image.resource.identifier?level.imagebox.image.resource.identifier+ \'?imageMogr2/auto-orient/rotate/\' + level.imagebox.rotation.angle+\'/thumbnail/!40p\':\'content/images/mask_souce.png\'}}"--><!--                                                         ng-mousedown="moveBoxStart1($event,level.imagebox,$index)"--><!--                                                         data-mask="content/images/centerblur.png"/>--></div></div><span class="sel-top" data-index="{{$index}}" ng-mousedown="resizeStartLeft($event,level.imagebox,currentPage.scene.ratio, $index)" ng-if="$index == template.levelI && (RightPanel==\'mask\')&&!level.imagebox.ctrlKey"></span> <span class="sel-right" data-index="{{$index}}" ng-mousedown="resizeStartTop($event,level.imagebox,currentPage.scene.ratio, $index)" ng-if="$index == template.levelI && (RightPanel==\'mask\')&&!level.imagebox.ctrlKey"></span> <span class="sel-bottom" data-index="{{$index}}" ng-mousedown="resizeStartRigth($event, level.imagebox,currentPage.scene.ratio, $index)" ng-if="$index == template.levelI && (RightPanel==\'mask\')&&!level.imagebox.ctrlKey"></span> <span class="sel-left" data-index="{{$index}}" ng-mousedown="resizeStartBottom($event,level.imagebox,currentPage.scene.ratio, $index)" ng-if="$index == template.levelI && (RightPanel==\'mask\')&&!level.imagebox.ctrlKey"></span> <span class="sel-left1" data-index="{{$index}}" ng-mousedown="resizeStartLeft1($event,level.imagebox,currentPage.scene.ratio, $index)" ng-if="$index == template.levelI && (RightPanel==\'mask\')&&!level.imagebox.ctrlKey"></span> <span class="sel-top1" data-index="{{$index}}" ng-mousedown="resizeStartTop1($event,level.imagebox,currentPage.scene.ratio, $index)" ng-if="$index == template.levelI && (RightPanel==\'mask\')&&!level.imagebox.ctrlKey"></span> <span class="sel-right1" data-index="{{$index}}" ng-mousedown="resizeStartRight1($event,level.imagebox,currentPage.scene.ratio, $index)" ng-if="$index == template.levelI && (RightPanel==\'mask\')&&!level.imagebox.ctrlKey"></span> <span class="sel-bottom1" data-index="{{$index}}" ng-mousedown="resizeStartBottom1($event,level.imagebox,currentPage.scene.ratio, $index)" ng-if="$index == template.levelI && (RightPanel==\'mask\')&&!level.imagebox.ctrlKey"></span><div class="rotate-box" ng-if="$index == template.levelI && (RightPanel==\'mask\')" style="width: 100%"><div style="position: relative; width: 100%"><span class="rotate-line" style="position: absolute;left: 50%;margin-left: -0.5px"></span><br><span class="rotate-icon rotate-icon{{$index}}" data-index="{{$index}}" ng-mousedown="rotateBoxStart($event,level.imagebox,$index)" style="position: absolute; top: 17px; left: 50%; margin-left: -11px"></span></div></div></div><div data-index="{{$index}}" class="img-art img-art{{$index}}" ng-show="level.imageart.current" ondblclick="doubleClickClipart(event)" ng-click="selectArt($event, $index, level.imageart)" ng-class="{\'selected\': level.imageart.ctrlKey || $index == template.levelI && RightPanel==\'material\'}" ng-style="{\n                                                            width: level.imageart.geometry.width*currentPage.scene.ratio,\n                                                            height: level.imageart.geometry.height*currentPage.scene.ratio,\n                                                            \'line-height\': level.imageart.geometry.height*currentPage.scene.ratio+\'px\',\n                                                            left: level.imageart.geometry.x*currentPage.scene.ratio,\n                                                            top: level.imageart.geometry.y*currentPage.scene.ratio,\n                                                            \'z-index\':level.seq-0+200,\n                                                            \'opacity\':level.imageart.transparency,\n                                                            filter: \'alpha(opacity=\'+level.imageart.transparency*100+\')\',\n                                                            \'transform\': \'rotate(\' + level.imageart.rotation.angle + \'deg)\'}"><div style="overflow: hidden; position: relative; width: 100%; height: 100%"><img data-index="{{$index}}" id="art-img{{$index}}" ng-mousedown="moveBoxStart1($event,level.imageart,$index)" style="transition: opacity 0.3s;position: absolute" ng-style="{\n                                                        \'opacity\':level.imageart.transparency,\n                                                                \'left\': level.imageart.offsetx*currentPage.scene.ratio,\n                                                                \'top\': level.imageart.offsety*currentPage.scene.ratio,\n                                                                \'width\': level.imageart.geometry.width*currentPage.scene.ratio * level.imageart.scale}" ng-src="{{level.imageart.resource.identifier + vm.pageImageView}}"></div><!--                                                <span class="sel-bottom" data-index="{{$index}}"--><!--                                                      onmousedown="resizeArtStart1(event)"--><!--                                                      ng-if="$index == template.levelI && RightPanel == \'material\'&&!level.imageart.ctrlKey"></span>--><!--                                                <div class="rotate-box" ng-if="$index == template.levelI && (RightPanel==\'material\')" style=" width: 100%;">--><!--                                                    <div style="position: relative; width: 100%;">--><!--                                                        <span class="rotate-line" style="position: absolute;left: 50%;margin-left: -0.5px;"></span><br>--><!--                                                        <span class="rotate-icon rotate-icon{{$index}}" data-index="{{$index}}" ng-mousedown="rotateBoxStart($event,level.imageart,$index)" style=" position: absolute; top: 17px; left: 50%; margin-left: -11px;"></span>--><!--                                                    </div>--><!--                                                </div>--><div ng-if="$index == template.levelI && RightPanel == \'material\'&&!level.imageart.ctrlKey"><span class="sel-left" ng-mousedown="imageartdownZoomBottom($event,level.imageart, true)"></span> <span class="sel-top" ng-mousedown="imageartdownZoomLeft($event,level.imageart, true)"></span> <span class="sel-right" ng-mousedown="imageartdownZoomTop($event,level.imageart, true)"></span> <span class="sel-bottom" ng-mousedown="imageartdownZoomRight($event,level.imageart, true)"></span></div><div class="c-xml-page-material-rotate1" ng-if="$index == template.levelI && (RightPanel==\'material\')"><span class="c-xml-page-material-rotate-icon" ng-mousedown="rotateBoxStart($event,level.imageart,$index)"></span></div></div><div class="c-xml-page-textboxe textbox1{{template.pageI}}{{$index}}" ng-show="level.textbox.current" ng-click="selectText($event, $index, level.textbox)" ng-class="{\'selected\': level.textbox.ctrlKey || $index == template.levelI && RightPanel == \'text\'}" style="white-space: normal" ng-style="{\n                                                        \'z-index\':level.seq-0+200,\n                                                        \'width\': level.textbox.geometry.width*currentPage.scene.ratio,\n                                                        \'left\': level.textbox.geometry.x*currentPage.scene.ratio,\n                                                        \'top\': level.textbox.geometry.y*currentPage.scene.ratio,\n                                                        \'height\': level.textbox.geometry.height*currentPage.scene.ratio,\n                                                        \'transform\': \'rotate(\' + level.textbox.rotation.angle + \'deg)\'\n                                                     }"><div style="width: 100%;height: 100%;position: absolute;top:0;left: 0"><pre class="c-xml-page-textboxe-text web-font" data-index="{{$index}}" ng-style="{\n                                                            \'font-family\':  \'\\\'\' + level.textbox.fontuuid + \'\\\'\',\n                                                            \'font-size\': level.textbox.style.size + \'pt\',\n                                                            \'color\': level.textbox.style.color,\n                                                            \'font-weight\': level.textbox.style.bold ? \'bold\': \'400\',\n                                                            \'font-style\': level.textbox.style.italic ? \'italic\': \'initial\',\n                                                            \'line-height\': level.textbox.style.lineheight + \'pt\',\n                                                            \'letter-spacing\': level.textbox.style.letterspacing + \'pt\',\n                                                            \'opacity\': level.textbox.transparency,\n                                                            \'text-decoration\': \'none\',\n                                                            \'text-align\': level.textbox.style.align,\n                                                            \'text-align-last\': \'unset\',\n                                                            transform:\'scale(\'+(currentPage.scene.ratio)+\')\',\n                                                            \'transform-origin\': \'0 0\',\n                                                            width: level.textbox.geometry.width,\n                                                            height: level.textbox.geometry.height\n                                                          }" ng-mousedown="moveBoxStart1($event,level.textbox,$index)"><span class="c-xml-page-textboxe-span">{{level.textbox.text}}</span></pre><span class="c-xml-page-material-zoom c-xml-page-material-zoom-left" style="display: block" ng-if="level.textbox.ctrlKey || $index == template.levelI && RightPanel == \'text\'" ng-mousedown="textboxZoomLeft($event,level.textbox,currentPage.scene.ratio,$index)"></span> <span class="c-xml-page-material-zoom c-xml-page-material-zoom-right" style="display: block" ng-if="level.textbox.ctrlKey || $index == template.levelI && RightPanel == \'text\'" ng-mousedown="textboxZoomRight($event,level.textbox,currentPage.scene.ratio,$index)"></span> <span class="c-xml-page-material-zoom c-xml-page-material-zoom-left1" style="display: block" ng-if="level.textbox.ctrlKey || $index == template.levelI && RightPanel == \'text\'" ng-mousedown="textboxZoomLeft1($event,level.textbox,currentPage.scene.ratio,$index)"></span> <span class="c-xml-page-material-zoom c-xml-page-material-zoom-top1" style="display: block" ng-if="level.textbox.ctrlKey || $index == template.levelI && RightPanel == \'text\'" ng-mousedown="textboxZoomTop1($event,level.textbox,currentPage.scene.ratio,$index)"></span> <span class="c-xml-page-material-zoom c-xml-page-material-zoom-right1" style="display: block" ng-if="level.textbox.ctrlKey || $index == template.levelI && RightPanel == \'text\'" ng-mousedown="textboxZoomRight1($event,level.textbox,currentPage.scene.ratio,$index)"></span> <span class="c-xml-page-material-zoom c-xml-page-material-zoom-bottom1" style="display: block" ng-if="level.textbox.ctrlKey || $index == template.levelI && RightPanel == \'text\'" ng-mousedown="textboxZoomBottom1($event,level.textbox,currentPage.scene.ratio,$index)"></span><div class="rotate-box" ng-if="$index == template.levelI && RightPanel == \'text\'&&!level.textbox.ctrlKey" style="width: 100%"><div style="position: relative; width: 100%"><span class="rotate-line" style="position: absolute;left: 50%;margin-left: -0.5px"></span><br><span class="rotate-icon rotate-icon{{$index}}" data-index="{{$index}}" ng-mousedown="rotateBoxStart($event,level.textbox,$index)" style="position: absolute; top: 17px; left: 50%; margin-left: -11px"></span></div></div><div class="loading-font" ng-if="level.textbox.loading"></div></div></div><div data-index="{{$index}}" ng-show="level.textdocument.current" ng-mousedown="moveBoxStart1($event,level.textdocument,$index)" ng-class="{\'selected\': level.textdocument.ctrlKey || $index == template.levelI && RightPanel==\'textDoc\'}" ng-style="{\n                                                            position: \'absolute\',\n                                                            width: level.textdocument.geometry.width*currentPage.scene.ratio,\n                                                            height: level.textdocument.geometry.height*currentPage.scene.ratio,\n                                                            left: level.textdocument.geometry.x*currentPage.scene.ratio,\n                                                            top: level.textdocument.geometry.y*currentPage.scene.ratio,\n                                                            \'z-index\':level.seq-0+200,\n                                                            \'opacity\':level.textdocument.transparency.toFixed(2),\n                                                            filter: \'alpha(opacity=\'+level.textdocument.transparency*100+\')\',\n                                                            \'transform\': \'rotate(-\' + level.textdocument.rotation.angle + \'deg)\'}" ng-click="selectDoc($event, $index, level.textdocument)"><div style="overflow: hidden;width: 100%;height: 100%;position: relative" class="no-events"><img class="bg-image bg-image{{template.pageI}} pos" ng-cloak ng-if="level.textdocument.background.resource.identifier" ng-src="{{level.textdocument.background.resource.identifier  + vm.pageImageView||\'//:0\'}}" ng-style="{\n                                                                     position: \'absolute\',\n                                                                     left:level.textdocument.background.offsetx*currentPage.scene.ratio,\n                                                                     top:level.textdocument.background.offsety*currentPage.scene.ratio,\n                                                                     width: level.textdocument.background.adaptation==\'Width\'?level.textdocument.geometry.width*currentPage.scene.ratio:\'\',\n                                                                     height:level.textdocument.background.adaptation!=\'Width\'?level.textdocument.geometry.height*currentPage.scene.ratio:\'\'}"><div ng-repeat="docLevel in level.textdocument.levels.level track by $index" ng-init="docIndex = $index" style="position: relative"><div data-index="{{docIndex}}" class="img-art" ng-show="docLevel.imageart" ng-style="{\n                                                                        width: docLevel.imageart.geometry.width*currentPage.scene.ratio,\n                                                                        height: docLevel.imageart.geometry.height*currentPage.scene.ratio,\n                                                                        left: docLevel.imageart.geometry.x*currentPage.scene.ratio,\n                                                                        top: docLevel.imageart.geometry.y*currentPage.scene.ratio,\n                                                                        \'z-index\':docLevel.seq-0+200,\n                                                                        \'opacity\':docLevel.imageart.transparency,\n                                                                        filter: \'alpha(opacity=\'+docLevel.imageart.transparency*100+\')\',\n                                                                        \'transform\': \'rotate(\' + docLevel.imageart.rotation.angle + \'deg)\'}"><div style="overflow: hidden; position: relative; width: 100%; height: 100%"><img data-index="{{$index}}" style="transition: opacity 0.3s;position: absolute" ng-style="{\n                                                                            \'left\': docLevel.imageart.offsetx *currentPage.scene.ratio,\n                                                                            \'top\': docLevel.imageart.offsety *currentPage.scene.ratio,\n                                                                            \'width\': docLevel.imageart.geometry.width * currentPage.scene.ratio * docLevel.imageart.scale}" ng-src="{{docLevel.imageart.resource.identifier + vm.pageImageView}}"></div></div><div class="c-xml-page-textboxe" ng-show="docLevel.textbox" style="white-space: normal" data-index="{{docIndex}}" ng-style="{\n                                                                    \'z-index\':docLevel.seq-0+200,\n                                                                    \'width\': docLevel.textbox.geometry.width * currentPage.scene.ratio,\n                                                                    \'left\': docLevel.textbox.geometry.x * currentPage.scene.ratio,\n                                                                    \'top\': docLevel.textbox.geometry.y * currentPage.scene.ratio,\n                                                                    \'height\': docLevel.textbox.geometry.height * currentPage.scene.ratio,\n                                                                    \'transform\': \'rotate(\' + docLevel.textbox.rotation.angle + \'deg)\'}"><div style="width: 100%;height: 100%;position: absolute;top:0;left: 0"><pre class="c-xml-page-textboxe-text web-font" ng-style="{\n                                                                        \'font-family\':  \'\\\'\' + docLevel.textbox.fontuuid + \'\\\'\',\n                                                                        \'font-size\': docLevel.textbox.style.size + \'pt\',\n                                                                        \'color\': docLevel.textbox.style.color,\n                                                                        \'font-weight\': docLevel.textbox.style.bold ? \'bold\': \'400\',\n                                                                        \'font-style\': docLevel.textbox.style.italic ? \'italic\': \'initial\',\n                                                                        \'line-height\': docLevel.textbox.style.lineheight + \'pt\',\n                                                                        \'letter-spacing\': docLevel.textbox.style.letterspacing + \'pt\',\n                                                                        \'opacity\': docLevel.textbox.transparency,\n                                                                        \'text-decoration\': \'none\',\n                                                                        \'text-align\': docLevel.textbox.style.align,\n                                                                        \'text-align-last\': \'unset\',\n                                                                        transform:\'scale(\'+(currentPage.scene.ratio)+\')\',\n                                                                        \'transform-origin\': \'0 0\',\n                                                                        width: docLevel.textbox.geometry.width,\n                                                                        height: docLevel.textbox.geometry.height\n                                                                      }"><span class="c-xml-page-textboxe-span">{{docLevel.textbox.text}}</span></pre></div></div></div></div><span class="sel-bottom" data-index="{{$index}}" onmousedown="resizeDocStart1(event)" ng-if="$index == template.levelI && (RightPanel==\'textDoc\')&&!level.textdocument.ctrlKey"></span><!--<span class="sel-left" data-index="{{$index}}"--><!--ng-if="$index == template.levelI && (RightPanel==\'mask\')&&!img.ctrlKey"></span>--><div class="rotate-box" ng-if="$index == template.levelI && (RightPanel==\'textDoc\')" style="width: 100%"><div style="position: relative; width: 100%"><span class="rotate-line" style="position: absolute;left: 50%;margin-left: -0.5px"></span><br><span class="rotate-icon rotate-icon{{$index}}" data-index="{{$index}}" ng-mousedown="rotateBoxStart($event,level.textdocument,$index)" style="position: absolute; top: 17px; left: 50%; margin-left: -11px"></span></div></div></div></div><div class="barcode cursorPointer" readonly="readonly" ng-show="currentPage.barcode&&currentPage.barcode.geometry" id="barcode{{template.pageI}}" ng-click="selectBar($event,currentPage, \'barcode\')" ng-class="{\'selected\': RightPanel == \'barcode\'}" onmousedown="moveBarcodeStart1(event)" ng-style="{\n                                                             \'line-height\':\'0\',\n                                                             top: currentPage.barcode.geometry.y*currentPage.scene.ratio,\n                                                             left: currentPage.barcode.geometry.x*currentPage.scene.ratio,\n                                                             width: currentPage.barcode.geometry.width*currentPage.scene.ratio,\n                                                             height: currentPage.barcode.geometry.height*currentPage.scene.ratio,\n                                                             \'z-index\': 998,\n                                                            \'transform\': \'rotate(-\' + currentPage.barcode.rotation.angle + \'deg)\'\n                                                        }"><img src="content/images/txm.png" style="width: 100%;height: 100%"></div><div class="barcode cursorPointer" readonly="readonly" ng-show="currentPage.qrcode&&currentPage.qrcode.geometry" ng-click="selectBar($event,currentPage, \'qrcode\')" ng-class="{\'selected\': RightPanel == \'qrcode\'}" onmousedown="moveQrcodeStart1(event)" ng-style="{\n                                                             \'line-height\':\'0\',\n                                                             top: currentPage.qrcode.geometry.y*currentPage.scene.ratio,\n                                                             left: currentPage.qrcode.geometry.x*currentPage.scene.ratio,\n                                                             width: currentPage.qrcode.geometry.width*currentPage.scene.ratio,\n                                                             height: currentPage.qrcode.geometry.height*currentPage.scene.ratio,\n                                                             \'z-index\': 998,\n                                                            \'transform\': \'rotate(-\' + currentPage.qrcode.rotation.angle + \'deg)\'\n                                                        }"><img src="content/images/QrCode.png" style="width: 100%;height: 100%"></div></div></div></div><div class="page-scale"><div class="iconfont icon-jian" style="font-weight: bold" ng-click="changeShirnk(1)"></div><div class="">{{(100*currentPage.scale)|number:0}}%</div><div class="iconfont icon-add" style="font-weight: bold" ng-click="changeShirnk(2)"></div><div class="iconfont icon-fangda" ng-click="changeShirnk(0)"></div><div class="iconfont icon-icon-zhuashou" ng-style="{\'color\':vm.moveCanvasView?\'#fac779\':\'\'}" ng-click="vm.moveCanvasView = !vm.moveCanvasView"></div></div></div><button class="rightBtn-page rr{{$index}}" ng-click="pageDirection(false)" ng-show="visibleRight"><img src="content/images/icons/design_scale_next.svg" ng-show="!darkTheme"> <img src="content/images/icons/design_scale_next_dark.svg" ng-show="darkTheme"></button><div ng-show="showCut" class="cut-image-box" ng-style="{height:dHeight-50}" onmousedown="startEdit(event)" ontouchmove="dragEdit(event)" ontouchend="stopEdit()"><div class="pos-abso" id="mouseWheel"><img ng-src="{{currentPage.background.resource.identifier + vm.pageImageView}}" id="cut-img" class="cut-img" style="z-index: 9999" ng-style="{ width:w, height:h}"> <img class="cut-mask" id="cut-mask" style="position: absolute;top:0;left: 0;z-index: 9999"><div class="pos-abso" ng-style="{\n                                    \'z-index\':9999,\n                                    left:l+pageW,\n                                    top:t+pageH/2-24,\n                                    width:32}"><div style="border-bottom: 1px solid #e6e6e6" ng-click="showCut=false"><img src="content/images/icons/web_canvel.svg"></div><div ng-click="showCut=false"><img src="content/images/icons/web_save.svg"></div></div></div></div><div class="c-xml-imageart-trim" style="z-index: 999" ng-if="vm.isImageartTrim"><div style="margin: 0 auto; position: relative" ng-style="{\n                                \'width\': (currentPage.mediabox.width * vm.imageartTrimRatio),\n                                \'height\': (currentPage.mediabox.height * vm.imageartTrimRatio),\n                                \'margin-top\': vm.pageMarginTop\n                             }"><div id="c-xml-imageart-trim-img" style="position: absolute" ng-style="{\n                                    \'width\': vm.imageartTrim.geometry.width1 * vm.imageartTrimRatio,\n                                    \'height\': vm.imageartTrim.geometry.height1 * vm.imageartTrimRatio,\n                                    \'left\': vm.imageartTrim.geometry.x1 * vm.imageartTrimRatio + \'px\',\n                                    \'top\': vm.imageartTrim.geometry.y1 * vm.imageartTrimRatio + \'px\'}"><div style="position: relative; width: 100%; height: 100%"><div class="c-xml-imageart-trim-div" id="c-xml-imageart-trim-div" ng-style="{\n                                            \'left\': vm.imageartTrim.offsetx * vm.imageartTrimRatio,\n                                            \'top\': vm.imageartTrim.offsety * vm.imageartTrimRatio\n                                         }"><img id="imageartTrimRight1" ng-src="{{vm.imageartTrim.resource.identifier  + vm.pageImageView}}" ng-style="{\'width\': vm.imageartTrim.geometry.width1 * vm.imageartTrimRatio * vm.imageartTrim.scale + \'px\'}"><div style="width: 100%; height: 100%; position: absolute; background: rgba(0,0,0,0.5); top: 0; left: 0;z-index: 1"></div><div class="c-xml-operation"><button type="button" ng-click="imageartTrimTrueClick()">\u221A</button> <button type="button" ng-click="imageartTrimFalseClick()">\xD7</button></div></div></div></div><div id="c-xml-imageart-trim-frame" style="position: absolute; z-index: 1" ng-style="{\n                                    \'width\': vm.imageartTrim.geometry.width*vm.imageartTrimRatio,\n                                    \'height\': vm.imageartTrim.geometry.height*vm.imageartTrimRatio,\n                                    \'left\': vm.imageartTrim.geometry.x *vm.imageartTrimRatio + \'px\',\n                                    \'top\': vm.imageartTrim.geometry.y*vm.imageartTrimRatio + \'px\'\n                                 }"><div style="width: 100%; height: 100%; overflow: hidden;position: absolute;border: 1px solid #e1a13c"><div style="position: absolute" id="c-xml-imageart-trim-frame-img" ng-mousedown="imageartTrimdown($event)" ng-style="{\n                                                \'left\': (vm.imageartTrim.geometry.x1 - vm.imageartTrim.geometry.x + vm.imageartTrim.offsetx) * vm.imageartTrimRatio,\n                                                \'top\': (vm.imageartTrim.geometry.y1 - vm.imageartTrim.geometry.y + vm.imageartTrim.offsety) * vm.imageartTrimRatio}"><img ng-src="{{vm.imageartTrim.resource.identifier  + vm.pageImageView}}" ng-style="{\'width\': vm.imageartTrim.geometry.width1 * currentPage.scale/currentPage.proportion * vm.imageartTrim.scale + \'px\'}"></div></div><span class="c-xml-page-material-zoom c-xml-page-material-zoom-right" style="display: block" ng-mousedown="imageartTrimRight($event,vm.imageartTrim)"></span></div></div></div><pre id="c-xml-page-material-fontId" style="display: inline-block; opacity: 0" ng-style="{\n                            \'font-family\': \'\\\'\' + vm.fontHide.fontuuid + \'\\\'\',\n                            \'font-size\': (vm.fontHide.style.size * currentPage.scale*currentPage.proportionText > 12 ? vm.fontHide.style.size* currentPage.scale*currentPage.proportionText : 12) + \'pt\',\n                            \'color\': vm.fontHide.style.color,\n                            \'font-weight\': vm.fontHide.style.bold ? \'bold\': \'400\',\n                            \'font-style\': vm.fontHide.style.italic ? \'italic\': \'initial\',\n                            \'line-height\': (vm.fontHide.style.size* currentPage.scale*currentPage.proportionText > 12 ? vm.fontHide.style.lineheight* currentPage.scale*currentPage.proportionText : vm.fontHide.style.lineheight*12/vm.fontHide.style.size) + \'pt\',\n                            \'letter-spacing\': (vm.fontHide.style.size* currentPage.scale*currentPage.proportionText > 12 ? vm.fontHide.style.letterspacing* currentPage.scale*currentPage.proportionText : vm.fontHide.style.letterspacing*12/vm.fontHide.style.size) + \'pt\',\n                            \'text-decoration\': \'none\',\n                            \'text-align-last\': \'unset\',\n                            \'transform\':\'scale(\' + (1 / 12 * vm.fontHide.style.size* currentPage.scale*currentPage.proportionText > 1 ? 1 : 1 / 12 * vm.fontHide.style.size* currentPage.scale*currentPage.proportionText) + \')\'\n                          }"><span class="c-xml-page-textboxe-span">{{vm.fontHide.text}}</span></pre><div class="c-xml-bgImg-trim" ng-if="vm.isImageboxTrim && !currentPage.scene" ng-mousedown="imageboxMouseDown($event)" style="z-index: 999 !important; height: calc(100vh - 232px)"><div style="position: absolute;margin: auto;left: 0;top: 0; right: 0;bottom: 0" ng-style="{\n                                \'width\': (currentPage.mediabox.width/currentPage.proportion)*currentPage.scale,\n                                \'height\': (currentPage.mediabox.height/currentPage.proportion)*currentPage.scale\n                                }"><div style="width: 100%; height: 100%; position: absolute; left: 0; top: 0"><div ng-style="{\n                                            \'position\': \'absolute\',\n                                            \'width\': vm.imageboxDouble.geometry.width*currentPage.scale/currentPage.proportion,\n                                            \'height\': vm.imageboxDouble.geometry.height*currentPage.scale/currentPage.proportion,\n                                            \'left\': vm.imageboxDouble.geometry.x*currentPage.scale/currentPage.proportion,\n                                            \'top\': vm.imageboxDouble.geometry.y*currentPage.scale/currentPage.proportion,\n                                        }"><div style="width: 100%; height: 100%;position: relative"><img ng-src="{{ vm.imageboxDouble.image.resource.identifier+vm.pageImageViewOrient}}" ng-style="{\n                                                    \'width\': vm.imageboxDouble.image.width*currentPage.scale/currentPage.proportion * vm.imageboxDouble.image.scale,\n                                                    \'height\': vm.imageboxDouble.image.height*currentPage.scale/currentPage.proportion * vm.imageboxDouble.image.scale,\n                                                    \'left\': vm.imageboxDouble.image.offsetx *currentPage.scale/currentPage.proportion * vm.imageboxDouble.image.scale,\n                                                    \'top\': vm.imageboxDouble.image.offsety *currentPage.scale/currentPage.proportion * vm.imageboxDouble.image.scale\n                                                 }" style="position: absolute" alt="\u80CC\u666F\u56FE\u7247"><div style="position: absolute;background: rgba(0,0,0,0.5); z-index: 1" ng-style="{\n                                                    \'width\': vm.imageboxDouble.image.width*currentPage.scale/currentPage.proportion * vm.imageboxDouble.image.scale,\n                                                    \'height\': vm.imageboxDouble.image.height*currentPage.scale/currentPage.proportion * vm.imageboxDouble.image.scale,\n                                                    \'left\': vm.imageboxDouble.image.offsetx *currentPage.scale/currentPage.proportion * vm.imageboxDouble.image.scale,\n                                                    \'top\': vm.imageboxDouble.image.offsety *currentPage.scale/currentPage.proportion * vm.imageboxDouble.image.scale\n                                                 }"></div></div></div></div><div style="width: 100%; height: 100%; position: absolute; left: 0; top: 0; z-index: 10"><div ng-style="{\n                                            \'position\': \'absolute\',\n                                            \'width\': vm.imageboxDouble.geometry.width*currentPage.scale/currentPage.proportion,\n                                            \'height\': vm.imageboxDouble.geometry.height*currentPage.scale/currentPage.proportion,\n                                            \'left\': vm.imageboxDouble.geometry.x*currentPage.scale/currentPage.proportion,\n                                            \'top\': vm.imageboxDouble.geometry.y*currentPage.scale/currentPage.proportion,\n                                        }"><div style="width: 100%; height: 100%;position: relative;overflow: hidden" ng-style="{\n                                                \'-webkit-mask-image\': vm.imageboxDouble.mask.resource.identifier ? \'url(\' + vm.imageboxDouble.mask.resource.identifier + \')\' : \'none\',\n                                                \'-webkit-mask-size\': \'100% 100%\'\n                                                }"><img ng-src="{{ vm.imageboxDouble.image.resource.identifier+vm.pageImageViewOrient}}" ng-style="{\n                                                    \'width\': vm.imageboxDouble.image.width*currentPage.scale/currentPage.proportion * vm.imageboxDouble.image.scale,\n                                                    \'height\': vm.imageboxDouble.image.height*currentPage.scale/currentPage.proportion * vm.imageboxDouble.image.scale,\n                                                    \'left\': vm.imageboxDouble.image.offsetx *currentPage.scale/currentPage.proportion * vm.imageboxDouble.image.scale,\n                                                    \'top\': vm.imageboxDouble.image.offsety *currentPage.scale/currentPage.proportion * vm.imageboxDouble.image.scale\n                                                 }" style="position: absolute" alt="\u80CC\u666F\u56FE\u7247"></div></div></div><div class="c-xml-operation" style="z-index: 10"><button type="button" ng-click="imageboxTrueClick()">\u221A</button> <button type="button" ng-click="imageboxFalseClick()">\xD7</button></div></div></div><div class="c-xml-bgImg-trim" ng-if="vm.isImageboxTrim && currentPage.scene" ng-mousedown="imageboxMouseDown1($event)" style="z-index: 999 !important; height: calc(100vh - 232px)"><div style="position: absolute;margin: auto;left: 0;top: 0; right: 0;bottom: 0" ng-style="{\n                                 width: currentPage.mediabox.width*currentPage.scene.ratio,\n                                 height: currentPage.mediabox.height*currentPage.scene.ratio,\n                                 left: currentPage.scene.imagebox.geometry.x*currentPage.scene.ratio,\n                                 top: currentPage.scene.imagebox.geometry.y*currentPage.scene.ratio,\n                                }"><div style="width: 100%; height: 100%; position: absolute; left: 0; top: 0"><div ng-style="{\n                                            \'position\': \'absolute\',\n                                            \'width\': vm.imageboxDouble.geometry.width*currentPage.scene.ratio,\n                                            \'height\': vm.imageboxDouble.geometry.height*currentPage.scene.ratio,\n                                            \'left\': vm.imageboxDouble.geometry.x*currentPage.scene.ratio,\n                                            \'top\': vm.imageboxDouble.geometry.y*currentPage.scene.ratio,\n                                        }"><div style="width: 100%; height: 100%;position: relative"><img ng-src="{{ vm.imageboxDouble.image.resource.identifier+ vm.pageImageViewOrient}}" ng-style="{\n                                                    \'width\': vm.imageboxDouble.image.width*currentPage.scene.ratio,\n                                                    \'height\': vm.imageboxDouble.image.height*currentPage.scene.ratio,\n                                                    \'left\': vm.imageboxDouble.image.offsetx *currentPage.scene.ratio,\n                                                    \'top\': vm.imageboxDouble.image.offsety *currentPage.scene.ratio\n                                                 }" style="position: absolute" alt="\u80CC\u666F\u56FE\u7247"></div></div></div><div style="width: 100%; height: 100%; position: absolute; left: 0; top: 0; z-index: 10"><div ng-style="{\n                                            \'position\': \'absolute\',\n                                            \'width\': vm.imageboxDouble.geometry.width*currentPage.scene.ratio,\n                                            \'height\': vm.imageboxDouble.geometry.height*currentPage.scene.ratio,\n                                            \'left\': vm.imageboxDouble.geometry.x*currentPage.scene.ratio,\n                                            \'top\': vm.imageboxDouble.geometry.y*currentPage.scene.ratio,\n                                        }"><div style="width: 100%; height: 100%;position: relative;overflow: hidden" ng-style="{\n                                                \'-webkit-mask-image\': vm.imageboxDouble.mask.resource.identifier ? \'url(\' + vm.imageboxDouble.mask.resource.identifier + \')\' : \'none\',\n                                                \'-webkit-mask-size\': \'100% 100%\'\n                                                }"><img ng-src="{{ vm.imageboxDouble.image.resource.identifier+ vm.pageImageViewOrient}}" ng-style="{\n                                                    \'width\': vm.imageboxDouble.image.width*currentPage.scene.ratio,\n                                                    \'height\': vm.imageboxDouble.image.height*currentPage.scene.ratio,\n                                                    \'left\': vm.imageboxDouble.image.offsetx *currentPage.scene.ratio,\n                                                    \'top\': vm.imageboxDouble.image.offsety *currentPage.scene.ratio\n                                                 }" style="position: absolute" alt="\u80CC\u666F\u56FE\u7247"></div></div></div><div class="c-xml-operation" style="z-index: 10"><button type="button" ng-click="imageboxTrueClick()">\u221A</button> <button type="button" ng-click="imageboxFalseClick()">\xD7</button></div></div><div style="position: absolute; left: 0; top: 0; width: 100%; height: 100%; background: rgba(0,0,0,0.5); z-index: 1"></div></div></section></div></div><div class="rightPanel-bottom col-lg-12 col-sm-12 col-md-12 col-sm-10 pad-0"><div class="page-top" ng-class="{\'dark-theme\':darkTheme==true}"><div class="page-nav col-lg-12 col-sm-12 col-md-12 pad-right-0 pad-left-0"><div class="nav-ul"><div ng-repeat="page in template.pages.page track by $index" style="position: absolute;z-index: -1" ng-hide="page.backup"><div class="pageNode" ng-if="!page.scene"><div data-index="{{$index}}" style="overflow:hidden" ng-style="{\n                                                height:\'98px\',\n                                                width:page.mediabox.width*98/page.mediabox.height,\n                                                margin:\'0 auto\',\n                                                position:\'relative\'}"><div style="width: 100%;height:100%" ng-style="{background:page.background.color}"><img data-index="{{$index}}" ng-if="page.background.resource.identifier" ng-src="{{page.background.resource.identifier + vm.pageImageView||\'//:0\'}}" ng-style="{\n                                                    position: \'absolute\',\n                                                    width: page.background.adaptation==\'Width\'?page.mediabox.width*98/page.mediabox.height:\'\',\n                                                    height: page.background.adaptation==\'Height\'?\'98px\':\'\',\n                                                    left: page.background.offsetx/page.mediabox.height*98,\n                                                    top: page.background.offsety/page.mediabox.height*98}"><div ng-repeat="level in page.levels.level track by $index"><div ng-if="level.imageart&&level.imageart.current" ng-style="{\n                                                    position: \'absolute\',\n                                                    width: level.imageart.geometry.width/page.mediabox.height*98,\n                                                    height: level.imageart.geometry.height/page.mediabox.height*98,\n                                                    left: level.imageart.geometry.x/page.mediabox.height*98,\n                                                    top: level.imageart.geometry.y/page.mediabox.height*98,\n                                                    \'z-index\':level.seq-0+200,\n                                                    \'opacity\':level.imageart.transparency,\n                                                    filter: \'alpha(opacity=\'+level.imageart.transparency*100+\')\',\n                                                    \'transform\': \'rotate(\' + level.imageart.rotation.angle + \'deg)\'}"><div style="overflow: hidden; position: relative; width: 100%; height: 100%"><img data-index="{{$index}}" style="position: absolute" ng-style="{\n                                                            \'left\': level.imageart.offsetx*98/page.mediabox.height,\n                                                            \'top\': level.imageart.offsety*98/page.mediabox.height,\n                                                            \'width\': level.imageart.geometry.width*98/page.mediabox.height * level.imageart.scale}" ng-src="{{level.imageart.resource.identifier + vm.pageImageView}}"></div></div><div style="position: absolute" ng-if="level.imagebox&&level.imagebox.current" ng-style="{\n                                                            width: imageboxW(level.imagebox)*98/page.mediabox.height,\n                                                            height: imageboxH(level.imagebox)*98/page.mediabox.height,\n                                                            left: imageboxL(level.imagebox)*98/page.mediabox.height,\n                                                            top: imageboxT(level.imagebox)*98/page.mediabox.height,\n                                                            \'opacity\':level.imagebox.transparency,\n                                                            \'z-index\':level.seq-0+200,\n                                                            \'transform\': \'rotate(-\' + level.imagebox.rotation.angle + \'deg)\'}"><div class="relative-view1" ng-style="{\n                                                    \'overflow\': (level.imagebox.border && level.imagebox.border.type == \'Pic\') ? \'unset\' : \'hidden\',\n                                                    \'border-top-left-radius\':(level.imagebox.border && level.imagebox.border.type == \'Pic\') ? 0 : imageboxWRadius(level.imagebox, \'lt\', 98/page.mediabox.height),\n                                                    \'border-top-right-radius\':(level.imagebox.border && level.imagebox.border.type == \'Pic\') ? 0 : imageboxWRadius(level.imagebox, \'rt\', 98/page.mediabox.height),\n                                                    \'border-bottom-right-radius\':(level.imagebox.border && level.imagebox.border.type == \'Pic\') ? 0 : imageboxWRadius(level.imagebox, \'rb\', 98/page.mediabox.height),\n                                                    \'border-bottom-left-radius\':(level.imagebox.border && level.imagebox.border.type == \'Pic\') ? 0 : imageboxWRadius(level.imagebox, \'lb\', 98/page.mediabox.height),\n                                                    \'border-width\': (level.imagebox.border && level.imagebox.border.type == \'Color\') ? (level.imagebox.border.lineWidth*98/page.mediabox.height) : \'\',\n                                                    \'border-style\': (level.imagebox.border && level.imagebox.border.type == \'Color\' && level.imagebox.border.lineType == \'solid\') ? \'solid\' : (level.imagebox.border && level.imagebox.border.type == \'Color\' && level.imagebox.border.lineType == \'dashed\') ? \'dashed\' : (level.imagebox.border && level.imagebox.border.type == \'Color\' && level.imagebox.border.lineType == \'dotted\') ? \'dotted\' : \'none\',\n                                                    \'border-color\': (level.imagebox.border && level.imagebox.border.type == \'Color\') ? level.imagebox.border.color : \'\',\n                                                    \'box-shadow\' : (level.imagebox.border && level.imagebox.border.type == \'Color\' && level.imagebox.border.lineWidth>0 && level.imagebox.border && level.imagebox.border.lineType == \'solid\') ? \'0 0 0 1px \' + level.imagebox.border.color + \' inset\' : \'none\',\n                                                    \'filter\' : dropShadow(level.imagebox,98/page.mediabox.height),\n                                                    }"><div ng-style="{\n                                                             \'position\': \'absolute\',\n                                                             \'z-index\':0,\n                                                            \'left\': (level.imagebox.border && level.imagebox.border.type == \'Pic\') ? -imageboxWEdge(level.imagebox,\'left\')*98/page.mediabox.height : 0,\n                                                            \'top\': (level.imagebox.border && level.imagebox.border.type == \'Pic\') ? -imageboxWEdge(level.imagebox,\'top\')*98/page.mediabox.height : 0,\n                                                            \'right\': (level.imagebox.border && level.imagebox.border.type == \'Pic\') ? -imageboxWEdge(level.imagebox,\'right\')*98/page.mediabox.height : 0,\n                                                            \'bottom\': (level.imagebox.border && level.imagebox.border.type == \'Pic\') ? -imageboxWEdge(level.imagebox,\'bottom\')*98/page.mediabox.height : 0,\n                                                            \'background-image\': (level.imagebox.border && level.imagebox.border.type == \'Pic\') ? \'url(\' + level.imagebox.border.resource.identifier + vm.pageImageView + \')\' : \'\',\n                                                            \'background-size\': (level.imagebox.border && level.imagebox.border.type == \'Pic\') ? \'100% 100%\' : \'\',\n                                                            }"></div><div data-index="{{$index}}" class="relative-view1" ng-style="{\n                                                            \'border-top-left-radius\':imageboxWRadius1(level.imagebox, \'lt\', 98/page.mediabox.height),\n                                                        \'border-top-right-radius\':imageboxWRadius1(level.imagebox, \'rt\', 98/page.mediabox.height),\n                                                        \'border-bottom-right-radius\':imageboxWRadius1(level.imagebox, \'rb\', 98/page.mediabox.height),\n                                                        \'border-bottom-left-radius\':imageboxWRadius1(level.imagebox, \'lb\', 98/page.mediabox.height),}"><!-- <img data-index="{{$index}}"\n                                                                 ng-if="level.imagebox.mask.resource.identifier == \'\'||level.imagebox.mask.resource.identifier == null"\n                                                                 style="position: absolute; width: 100%; height: 100%;"\n                                                                 ng-style="{\n                                                                width: level.imagebox.image.width*98/page.mediabox.height * level.imagebox.image.scale,\n                                                                height: level.imagebox.image.height*98/page.mediabox.height * level.imagebox.image.scale,\n                                                                left: level.imagebox.image.offsetx*98/page.mediabox.height * level.imagebox.image.scale,\n                                                                top: level.imagebox.image.offsety*98/page.mediabox.height * level.imagebox.image.scale\n                                                            }"\n                                                                 ng-src="{{level.imagebox.image.resource.identifier ? level.imagebox.image.resource.identifier + vm.pageImageViewOrient : \'content/images/mask_souce.png\'}}"/> --><div ng-if="level.imagebox.mask.resource.identifier == \'\'||level.imagebox.mask.resource.identifier == null" style="width: 100%;height: 100%"><img data-index="{{$index}}" ng-if="level.imagebox.image.resource.identifier" style="position: absolute; width: 100%; height: 100%" ng-style="{\n                                                                            width: (level.imagebox.image.width * level.imagebox.image.scale) || \'100%\',\n                                                                            height: (level.imagebox.image.height * level.imagebox.image.scale) || \'100%\',\n                                                                            left: level.imagebox.image.offsetx * level.imagebox.image.scale,\n                                                                            top: level.imagebox.image.offsety * level.imagebox.image.scale\n                                                                        }" ng-src="{{level.imagebox.image.resource.identifier+ vm.pageImageViewOrient}}"><div ng-if="!level.imagebox.image.resource.identifier" data-index="{{$index}}" class="image-placeholder" style="width: 100%;height: 100%"><img src="content/images/icons/camera.svg" alt="" srcset="" data-index="{{$index}}"> <span ng-if="imageboxW(level.imagebox)*currentPage.scale/currentPage.scene.proportion > 60 && imageboxH(level.imagebox)*currentPage.scale/currentPage.scene.proportion > 80" data-index="{{$index}}">\u62D6\u5165\u76F8\u7247</span></div></div><img data-index="{{$index}}" ng-if="level.imagebox.mask.resource && level.imagebox.mask.resource.identifier" style="position: absolute; width: 100%; height: 100%" ng-src="{{level.imagebox.bgImg  + vm.pageImageView}}"></div></div></div><div ng-if="level.textbox.current" style="white-space: normal" ng-style="{\n                                                    position: \'absolute\',\n                                                    \'z-index\':level.seq-0+200,\n                                                    \'width\': level.textbox.geometry.width*98/page.mediabox.height,\n                                                    \'left\': level.textbox.geometry.x*98/page.mediabox.height,\n                                                    \'top\': level.textbox.geometry.y*98/page.mediabox.height,\n                                                    \'height\': level.textbox.geometry.height*98/page.mediabox.height,\n                                                    \'transform\': \'rotate(\' + level.textbox.rotation.angle + \'deg)\'\n                                                }"><div style="width: 100%;height: 100%;position: absolute;top:0;left: 0"><pre class="c-xml-page-textboxe-text web-font" ng-style="{\n                                                        \'font-family\':  \'\\\'\' + level.textbox.fontuuid + \'\\\'\',\n                                                        \'font-size\': level.textbox.style.size + \'pt\',\n                                                        \'color\': level.textbox.style.color,\n                                                        \'font-weight\': level.textbox.style.bold ? \'bold\': \'400\',\n                                                        \'font-style\': level.textbox.style.italic ? \'italic\': \'initial\',\n                                                        \'line-height\': level.textbox.style.lineheight + \'pt\',\n                                                        \'letter-spacing\': level.textbox.style.letterspacing+ \'pt\',\n                                                        \'opacity\': level.textbox.transparency,\n                                                        \'text-decoration\': \'none\',\n                                                        \'text-align\': level.textbox.style.align,\n                                                        \'text-align-last\': \'unset\',\n                                                        transform:\'scale(\'+(page.proportionTextSmalll)+\')\',\n                                                        \'transform-origin\': \'0 0\',\n                                                        width: level.textbox.geometry.width*98/page.mediabox.height/page.proportionTextSmalll,\n                                                        height: level.textbox.geometry.height*98/page.mediabox.height/page.proportionTextSmalll\n                                                      }"><span class="c-xml-page-textboxe-span">{{level.textbox.text}}</span></pre></div></div><div data-index="{{$index}}" ng-if="level.textdocument.current" ng-style="{\n                                                        position: \'absolute\',\n                                                        width: level.textdocument.geometry.width*98/page.mediabox.height,\n                                                        height: level.textdocument.geometry.height*98/page.mediabox.height,\n                                                        left: level.textdocument.geometry.x*98/page.mediabox.height,\n                                                        top: level.textdocument.geometry.y*98/page.mediabox.height,\n                                                        \'z-index\':level.seq-0+200,\n                                                        \'opacity\':level.textdocument.transparency.toFixed(2),\n                                                        filter: \'alpha(opacity=\'+level.textdocument.transparency*100+\')\',\n                                                        \'transform\': \'rotate(-\' + level.textdocument.rotation.angle + \'deg)\'}"><div style="overflow: hidden;width: 100%;height: 100%;position: relative"><img class="bg-image bg-image{{template.pageI}} pos" ng-cloak ng-if="level.textdocument.background.resource.identifier" ng-src="{{level.textdocument.background.resource.identifier  + vm.pageImageView||\'//:0\'}}" ng-style="{\n                                                             position: \'absolute\',\n                                                             left:level.textdocument.background.offsetx*98/page.mediabox.height,\n                                                             top:level.textdocument.background.offsety*98/page.mediabox.height,\n                                                             width: level.textdocument.background.adaptation==\'Width\'?\'100%\':\'\',\n                                                             height:level.textdocument.background.adaptation!=\'Width\'?\'100%\':\'\'}"><div ng-repeat="docLevel in level.textdocument.levels.level track by $index" ng-init="docIndex = $index" style="position: relative"><div data-index="{{docIndex}}" class="img-art" ng-if="docLevel.imageart" ng-style="{\n                                                                    width: docLevel.imageart.geometry.width*98/page.mediabox.height,\n                                                                    height: docLevel.imageart.geometry.height*98/page.mediabox.height,\n                                                                    left: docLevel.imageart.geometry.x*98/page.mediabox.height,\n                                                                    top: docLevel.imageart.geometry.y*98/page.mediabox.height,\n                                                                    \'z-index\':docLevel.seq-0+200,\n                                                                    \'opacity\':docLevel.imageart.transparency,\n                                                                    filter: \'alpha(opacity=\'+docLevel.imageart.transparency*100+\')\',\n                                                                    \'transform\': \'rotate(\' + docLevel.imageart.rotation.angle + \'deg)\'}"><div style="overflow: hidden; position: relative; width: 100%; height: 100%"><img data-index="{{$index}}" style="position: absolute" ng-style="{\n                                                                        \'left\': docLevel.imageart.offsetx*98/page.mediabox.height,\n                                                                        \'top\': docLevel.imageart.offsety*98/page.mediabox.height,\n                                                                        \'width\': docLevel.imageart.geometry.width*98/page.mediabox.height * docLevel.imageart.scale}" ng-src="{{docLevel.imageart.resource.identifier + vm.pageImageView}}"></div></div><div class="c-xml-page-textboxe" ng-if="docLevel.textbox" style="white-space: normal" data-index="{{docIndex}}" ng-style="{\n                                                                \'z-index\':docLevel.seq-0+200,\n                                                                \'width\': docLevel.textbox.geometry.width*98/page.mediabox.height,\n                                                                \'height\': docLevel.textbox.geometry.height*98/page.mediabox.height,\n                                                                \'left\': docLevel.textbox.geometry.x*98/page.mediabox.height,\n                                                                \'top\': docLevel.textbox.geometry.y*98/page.mediabox.height,\n                                                                \'transform\': \'rotate(\' + docLevel.textbox.rotation.angle + \'deg)\'}"><div style="width: 100%;height: 100%;position: absolute;top:0;left: 0"><pre class="c-xml-page-textboxe-text web-font" ng-style="{\n                                                                        \'font-family\':  \'\\\'\' + docLevel.textbox.fontuuid + \'\\\'\',\n                                                                        \'font-size\': docLevel.textbox.style.size + \'pt\',\n                                                                        \'color\': docLevel.textbox.style.color,\n                                                                        \'font-weight\': docLevel.textbox.style.bold ? \'bold\': \'400\',\n                                                                        \'font-style\': docLevel.textbox.style.italic ? \'italic\': \'initial\',\n                                                                        \'line-height\': docLevel.textbox.style.lineheight + \'pt\',\n                                                                        \'letter-spacing\': docLevel.textbox.style.letterspacing + \'pt\',\n                                                                        \'opacity\': docLevel.textbox.transparency,\n                                                                        \'text-decoration\': \'none\',\n                                                                        \'text-align\': docLevel.textbox.style.align,\n                                                                        \'text-align-last\': \'unset\',\n                                                                        transform:\'scale(\'+(page.proportionTextSmalll)+\')\',\n                                                                        \'transform-origin\': \'0 0\',\n                                                                        width: docLevel.textbox.geometry.width*98/page.mediabox.height/page.proportionTextSmalll,\n                                                                        height: docLevel.textbox.geometry.height*98/page.mediabox.height/page.proportionTextSmalll\n                                                                  }"><span class="c-xml-page-textboxe-span">{{docLevel.textbox.text}}</span></pre></div></div></div></div></div></div><div class="barcode cursorPointer" ng-if="page.barcode&&page.barcode.geometry" readonly="readonly" ng-style="{\n                                                 position: \'absolute\',\n                                                 top: page.barcode.geometry.y*98/page.mediabox.height,\n                                                 left: page.barcode.geometry.x*98/page.mediabox.height,\n                                                 width: page.barcode.geometry.width*98/page.mediabox.height,\n                                                 height: page.barcode.geometry.height*98/page.mediabox.height,\n                                                 \'z-index\': 998,\n                                                 \'line-height\':\'0\',\n                                                 \'transform\': \'rotate(-\' + page.barcode.rotation.angle + \'deg)\'\n                                                    }"><img src="content/images/txm.png"></div><div class="barcode cursorPointer" ng-if="page.qrcode&&page.qrcode.geometry" readonly="readonly" ng-style="{\n                                                 position: \'absolute\',\n                                                 top: page.qrcode.geometry.y*98/page.mediabox.height,\n                                                 left: page.qrcode.geometry.x*98/page.mediabox.height,\n                                                 width: page.qrcode.geometry.width*98/page.mediabox.height,\n                                                 height: page.qrcode.geometry.height*98/page.mediabox.height,\n                                                 \'z-index\': 998,\n                                                 \'line-height\':\'0\',\n                                                 \'transform\': \'rotate(-\' + page.qrcode.rotation.angle + \'deg)\'\n                                                    }"><img src="content/images/QrCode.png"></div></div></div></div><div class="pageNode" ng-if="page.scene" style="transform:translate(-50% -50%)!important;outline: none" ng-style="{\n                                         width: (page.scene.geometry.width)*page.scene.ratio1,\n                                         height: (page.scene.geometry.height)*page.scene.ratio1}"><div style="width: 100%; height: 100%; position: relative"><div class="content-container" ng-style="{\n                                                    \'position\': \'absolute\',\n                                                    \'width\': (page.scene.geometry.width)*page.scene.ratio1,\n                                                    \'height\': (page.scene.geometry.height)*page.scene.ratio1,\n                                                    \'z-index\': page.scene.hierarchy == \'TOP\' ? \'1\' : \'0\',\n                                                    \'pointer-events\': \'none\'\n                                                }"><img class="bg-image bg-image{{template.pageI}}" ng-cloak ng-show="page.scene.background.resource.identifier" ng-src="{{page.scene.background.resource.identifier  + vm.pageImageView||\'//:0\'}}" ng-style="{width: page.scene.background.resource.identifier?page.scene.geometry.width*page.scene.ratio1:0}"><div ng-style="{\n                                                    position: \'absolute\',\n                                                    width: page.scene.imagebox.geometry.width*page.scene.ratio1,\n                                                    height: page.scene.imagebox.geometry.height*page.scene.ratio1,\n                                                    left: page.scene.imagebox.geometry.x*page.scene.ratio1,\n                                                    top: page.scene.imagebox.geometry.y*page.scene.ratio1,\n                                                    \'transform\': \'rotate(-\' + page.scene.imagebox.rotation.angle + \'deg)\'}" ng-show="page.scene.imagebox"></div></div><div class="editing1" ng-style="{\n                                                     \'position\': \'absolute\',\n                                                     \'background\':page.background.color ? page.background.color : \'none\',\n                                                     \'width\': page.mediabox.width*page.scene.ratio1,\n                                                     \'height\': page.mediabox.height*page.scene.ratio1,\n                                                     \'left\': page.scene.imagebox.geometry.x*page.scene.ratio1,\n                                                     \'top\': page.scene.imagebox.geometry.y*page.scene.ratio1,\n                                                     \'z-index\': page.scene.hierarchy == \'TOP\' ? 0 : 1\n                                                 }" style="overflow: hidden; border: 1px solid #299DFF"><img class="bg-image bg-image{{template.pageI}} pos" ng-cloak ng-if="page.background.resource.identifier" ng-src="{{page.background.resource.identifier + vm.pageImageView||\'//:0\'}}" ng-style="{\n                                                         position: \'absolute\',\n                                                         left:page.background.offsetx*page.scene.ratio1,\n                                                         top:page.background.offsety*page.scene.ratio1,\n                                                         width: page.background.adaptation==\'Width\'?page.mediabox.width*page.scene.ratio1:\'\',\n                                                         height:page.background.adaptation==\'Height\'?page.mediabox.height*page.scene.ratio1:\'\'}"><div ng-repeat="level in page.levels.level track by $index"><div data-index="{{$index}}" class="imgBox" ng-show="level.imagebox.current" ng-style="{\n                                                    \'opacity\':level.imagebox.transparency,\n                                                            width: imageboxW(level.imagebox)*page.scene.ratio1,\n                                                            height: imageboxH(level.imagebox)*page.scene.ratio1,\n                                                            left: imageboxL(level.imagebox)*page.scene.ratio1,\n                                                            top: imageboxT(level.imagebox)*page.scene.ratio1,\n                                                            \'z-index\':level.seq-0+200,\n                                                            \'transform\': \'rotate(-\' + level.imagebox.rotation.angle + \'deg)\'}"><div class="relative-view1" ng-style="{\n                                                    \'overflow\': (level.imagebox.border && level.imagebox.border.type == \'Pic\') ? \'unset\' : \'hidden\',\n                                                    \'border-top-left-radius\':(level.imagebox.border && level.imagebox.border.type == \'Pic\') ? 0 : imageboxWRadius(level.imagebox, \'lt\', page.scene.ratio1),\n                                                    \'border-top-right-radius\':(level.imagebox.border && level.imagebox.border.type == \'Pic\') ? 0 : imageboxWRadius(level.imagebox, \'rt\', page.scene.ratio1),\n                                                    \'border-bottom-right-radius\':(level.imagebox.border && level.imagebox.border.type == \'Pic\') ? 0 : imageboxWRadius(level.imagebox, \'rb\', page.scene.ratio1),\n                                                    \'border-bottom-left-radius\':(level.imagebox.border && level.imagebox.border.type == \'Pic\') ? 0 : imageboxWRadius(level.imagebox, \'lb\', page.scene.ratio1),\n                                                    \'border-width\': (level.imagebox.border && level.imagebox.border.type == \'Color\') ? (level.imagebox.border.lineWidth*page.scene.ratio1) : \'\',\n                                                    \'border-style\': (level.imagebox.border && level.imagebox.border.type == \'Color\' && level.imagebox.border.lineType == \'solid\') ? \'solid\' : (level.imagebox.border && level.imagebox.border.type == \'Color\' && level.imagebox.border.lineType == \'dashed\') ? \'dashed\' : (level.imagebox.border && level.imagebox.border.type == \'Color\' && level.imagebox.border.lineType == \'dotted\') ? \'dotted\' : \'none\',\n                                                    \'border-color\': (level.imagebox.border && level.imagebox.border.type == \'Color\') ? level.imagebox.border.color : \'\',\n                                                    \'box-shadow\' : (level.imagebox.border && level.imagebox.border.type == \'Color\' && level.imagebox.border.lineWidth>0 && level.imagebox.border && level.imagebox.border.lineType == \'solid\') ? \'0 0 0 1px \' + level.imagebox.border.color + \' inset\' : \'none\',\n                                                    \'filter\' : dropShadow(level.imagebox,page.scene.ratio1),\n                                                    }"><div ng-style="{\n                                                             \'position\': \'absolute\',\n                                                             \'z-index\':0,\n                                                            \'left\': (level.imagebox.border && level.imagebox.border.type == \'Pic\') ? -imageboxWEdge(level.imagebox,\'left\')*page.scene.ratio1 : 0,\n                                                            \'top\': (level.imagebox.border && level.imagebox.border.type == \'Pic\') ? -imageboxWEdge(level.imagebox,\'top\')*page.scene.ratio1 : 0,\n                                                            \'right\': (level.imagebox.border && level.imagebox.border.type == \'Pic\') ? -imageboxWEdge(level.imagebox,\'right\')*page.scene.ratio1 : 0,\n                                                            \'bottom\': (level.imagebox.border && level.imagebox.border.type == \'Pic\') ? -imageboxWEdge(level.imagebox,\'bottom\')*page.scene.ratio1 : 0,\n                                                            \'background-image\': (level.imagebox.border && level.imagebox.border.type == \'Pic\') ? \'url(\' + level.imagebox.border.resource.identifier + vm.pageImageView + \')\' : \'\',\n                                                            \'background-size\': (level.imagebox.border && level.imagebox.border.type == \'Pic\') ? \'100% 100%\' : \'\',\n                                                            }"></div><div data-index="{{$index}}" class="relative-view1" ng-style="{\n                                                            \'border-top-left-radius\':imageboxWRadius1(level.imagebox, \'lt\', page.scene.ratio1),\n                                                        \'border-top-right-radius\':imageboxWRadius1(level.imagebox, \'rt\', page.scene.ratio1),\n                                                        \'border-bottom-right-radius\':imageboxWRadius1(level.imagebox, \'rb\', page.scene.ratio1),\n                                                        \'border-bottom-left-radius\':imageboxWRadius1(level.imagebox, \'lb\', page.scene.ratio1),}"><!-- <img data-index="{{$index}}"\n                                                                 ng-if="level.imagebox.mask.resource.identifier == \'\'"\n                                                                 style="position: absolute; width: 100%; height: 100%;"\n                                                                 ng-style="{\n                                                                width: level.imagebox.image.width/((page.width+wahBorder)/((page.width+wahBorder)*98/(page.height+xayBorder)))/page.proportion,\n                                                                height: level.imagebox.image.height/page.proportion/((page.height+xayBorder)/98),\n                                                                left: level.imagebox.image.offsetx/((page.width+wahBorder)/((page.width+wahBorder)*98/(page.height+xayBorder)))/page.proportion,\n                                                                top: level.imagebox.image.offsety/page.proportion/((page.height+xayBorder)/98)\n                                                            }"\n                                                                 ng-src="{{level.imagebox.image.resource.identifier ? level.imagebox.image.resource.identifier + vm.pageImageViewOrient : \'content/images/mask_souce.png\'}}"/> --><div ng-if="level.imagebox.mask.resource.identifier == \'\'||level.imagebox.mask.resource.identifier == null" style="width: 100%;height: 100%"><img data-index="{{$index}}" ng-if="level.imagebox.image.resource.identifier" style="position: absolute; width: 100%; height: 100%" ng-style="{\n                                                                            width: (level.imagebox.image.width * level.imagebox.image.scale) || \'100%\',\n                                                                            height: (level.imagebox.image.height * level.imagebox.image.scale) || \'100%\',\n                                                                            left: level.imagebox.image.offsetx * level.imagebox.image.scale,\n                                                                            top: level.imagebox.image.offsety * level.imagebox.image.scale\n                                                                        }" ng-src="{{level.imagebox.image.resource.identifier+ vm.pageImageViewOrient}}"><div ng-if="!level.imagebox.image.resource.identifier" data-index="{{$index}}" class="image-placeholder" style="width: 100%;height: 100%"><img src="content/images/icons/camera.svg" alt="" srcset="" data-index="{{$index}}"> <span ng-if="imageboxW(level.imagebox)*currentPage.scale/currentPage.scene.proportion > 60 && imageboxH(level.imagebox)*currentPage.scale/currentPage.scene.proportion > 80" data-index="{{$index}}">\u62D6\u5165\u76F8\u7247</span></div></div><img data-index="{{$index}}" ng-if="level.imagebox.mask.resource && level.imagebox.mask.resource.identifier" style="position: absolute; width: 100%; height: 100%" ng-src="{{level.imagebox.bgImg  + vm.pageImageView}}"></div></div></div><div data-index="{{$index}}" class="img-art img-art{{$index}}" ng-show="level.imageart.current" ng-style="{\n                                                            width: level.imageart.geometry.width*page.scene.ratio1,\n                                                            height: level.imageart.geometry.height*page.scene.ratio1,\n                                                            \'line-height\': level.imageart.geometry.height*page.scene.ratio1+\'px\',\n                                                            left: level.imageart.geometry.x*page.scene.ratio1,\n                                                            top: level.imageart.geometry.y*page.scene.ratio1,\n                                                            \'z-index\':level.seq-0+200,\n                                                            \'opacity\':level.imageart.transparency,\n                                                            filter: \'alpha(opacity=\'+level.imageart.transparency*100+\')\',\n                                                            \'transform\': \'rotate(\' + level.imageart.rotation.angle + \'deg)\'}"><div style="overflow: hidden; position: relative; width: 100%; height: 100%"><img style="transition: opacity 0.3s;position: absolute" ng-style="{\n                                                                \'left\': level.imageart.offsetx*page.scene.ratio1,\n                                                                \'top\': level.imageart.offsety*page.scene.ratio1,\n                                                                \'width\': level.imageart.geometry.width*page.scene.ratio1 * level.imageart.scale}" ng-src="{{level.imageart.resource.identifier + vm.pageImageView}}"></div></div><div class="c-xml-page-textboxe" ng-show="level.textbox.current" style="white-space: normal" ng-style="{\n                                                                \'z-index\':level.seq-0+200,\n                                                                \'width\': level.textbox.geometry.width*page.scene.ratio1,\n                                                                \'left\': level.textbox.geometry.x*page.scene.ratio1,\n                                                                \'top\': level.textbox.geometry.y*page.scene.ratio1,\n                                                                \'height\': level.textbox.geometry.height*page.scene.ratio1,\n                                                                \'transform\': \'rotate(\' + level.textbox.rotation.angle + \'deg)\'\n                                                             }"><div style="width: 100%;height: 100%;position: absolute;top:0;left: 0"><pre class="c-xml-page-textboxe-text web-font" ng-style="{\n                                                                \'font-family\':  \'\\\'\' + level.textbox.fontuuid + \'\\\'\',\n                                                                \'font-size\': level.textbox.style.size + \'pt\',\n                                                                \'color\': level.textbox.style.color,\n                                                                \'font-weight\': level.textbox.style.bold ? \'bold\': \'400\',\n                                                                \'font-style\': level.textbox.style.italic ? \'italic\': \'initial\',\n                                                                \'line-height\': level.textbox.style.lineheight + \'pt\',\n                                                                \'letter-spacing\': level.textbox.style.letterspacing + \'pt\',\n                                                                \'opacity\': level.textbox.transparency,\n                                                                \'text-decoration\': \'none\',\n                                                                \'text-align\': level.textbox.style.align,\n                                                                \'text-align-last\': \'unset\',\n                                                                transform:\'scale(\'+(page.scene.ratio1)+\')\',\n                                                                \'transform-origin\': \'0 0\',\n                                                                width: level.textbox.geometry.width,\n                                                                height: level.textbox.geometry.height\n                                                              }"><span class="c-xml-page-textboxe-span">{{level.textbox.text}}</span></pre></div></div><div data-index="{{$index}}" ng-show="level.textdocument.current" ng-style="{\n                                                            position: \'absolute\',\n                                                            width: level.textdocument.geometry.width*page.scene.ratio1,\n                                                            height: level.textdocument.geometry.height*page.scene.ratio1,\n                                                            left: level.textdocument.geometry.x*page.scene.ratio1,\n                                                            top: level.textdocument.geometry.y*page.scene.ratio1,\n                                                            \'z-index\':level.seq-0+200,\n                                                            \'opacity\':level.textdocument.transparency.toFixed(2),\n                                                            filter: \'alpha(opacity=\'+level.textdocument.transparency*100+\')\',\n                                                            \'transform\': \'rotate(-\' + level.textdocument.rotation.angle + \'deg)\'}"><div style="overflow: hidden;width: 100%;height: 100%;position: relative" class="no-events"><img class="bg-image bg-image{{template.pageI}} pos" ng-cloak ng-if="level.textdocument.background.resource.identifier" ng-src="{{level.textdocument.background.resource.identifier  + vm.pageImageView||\'//:0\'}}" ng-style="{\n                                                                     position: \'absolute\',\n                                                                     left:level.textdocument.background.offsetx*page.scene.ratio1,\n                                                                     top:level.textdocument.background.offsety*page.scene.ratio1,\n                                                                     width: level.textdocument.background.adaptation==\'Width\'?level.textdocument.geometry.width*page.scene.ratio1:\'\',\n                                                                     height:level.textdocument.background.adaptation!=\'Width\'?level.textdocument.geometry.height*page.scene.ratio1:\'\'}"><div ng-repeat="docLevel in level.textdocument.levels.level track by $index" ng-init="docIndex = $index" style="position: relative"><div data-index="{{docIndex}}" class="img-art" ng-show="docLevel.imageart" ng-style="{\n                                                                        width: docLevel.imageart.geometry.width*page.scene.ratio1,\n                                                                        height: docLevel.imageart.geometry.height*page.scene.ratio1,\n                                                                        left: docLevel.imageart.geometry.x*page.scene.ratio1,\n                                                                        top: docLevel.imageart.geometry.y*page.scene.ratio1,\n                                                                        \'z-index\':docLevel.seq-0+200,\n                                                                        \'opacity\':docLevel.imageart.transparency,\n                                                                        filter: \'alpha(opacity=\'+docLevel.imageart.transparency*100+\')\',\n                                                                        \'transform\': \'rotate(\' + docLevel.imageart.rotation.angle + \'deg)\'}"><div style="overflow: hidden; position: relative; width: 100%; height: 100%"><img data-index="{{$index}}" style="transition: opacity 0.3s;position: absolute" ng-style="{\n                                                                            \'left\': docLevel.imageart.offsetx *page.scene.ratio1,\n                                                                            \'top\': docLevel.imageart.offsety *page.scene.ratio1,\n                                                                            \'width\': docLevel.imageart.geometry.width * page.scene.ratio1 * docLevel.imageart.scale}" ng-src="{{docLevel.imageart.resource.identifier + vm.pageImageView}}"></div></div><div class="c-xml-page-textboxe" ng-show="docLevel.textbox" style="white-space: normal" data-index="{{docIndex}}" ng-style="{\n                                                                    \'z-index\':docLevel.seq-0+200,\n                                                                    \'width\': docLevel.textbox.geometry.width * page.scene.ratio1,\n                                                                    \'left\': docLevel.textbox.geometry.x * page.scene.ratio1,\n                                                                    \'top\': docLevel.textbox.geometry.y * page.scene.ratio1,\n                                                                    \'height\': docLevel.textbox.geometry.height * page.scene.ratio1,\n                                                                    \'transform\': \'rotate(\' + docLevel.textbox.rotation.angle + \'deg)\'}"><div style="width: 100%;height: 100%;position: absolute;top:0;left: 0"><pre class="c-xml-page-textboxe-text web-font" ng-style="{\n                                                                        \'font-family\':  \'\\\'\' + docLevel.textbox.fontuuid + \'\\\'\',\n                                                                        \'font-size\': docLevel.textbox.style.size + \'pt\',\n                                                                        \'color\': docLevel.textbox.style.color,\n                                                                        \'font-weight\': docLevel.textbox.style.bold ? \'bold\': \'400\',\n                                                                        \'font-style\': docLevel.textbox.style.italic ? \'italic\': \'initial\',\n                                                                        \'line-height\': docLevel.textbox.style.lineheight + \'pt\',\n                                                                        \'letter-spacing\': docLevel.textbox.style.letterspacing + \'pt\',\n                                                                        \'opacity\': docLevel.textbox.transparency,\n                                                                        \'text-decoration\': \'none\',\n                                                                        \'text-align\': docLevel.textbox.style.align,\n                                                                        \'text-align-last\': \'unset\',\n                                                                        transform:\'scale(\'+(page.scene.ratio1)+\')\',\n                                                                        \'transform-origin\': \'0 0\',\n                                                                        width: docLevel.textbox.geometry.width,\n                                                                        height: docLevel.textbox.geometry.height\n                                                                      }"><span class="c-xml-page-textboxe-span">{{docLevel.textbox.text}}</span></pre></div></div></div></div></div></div><div class="barcode cursorPointer" readonly="readonly" ng-show="page.barcode&&page.barcode.geometry" ng-style="{\n                                                             \'line-height\':\'0\',\n                                                             top: page.barcode.geometry.y*page.scene.ratio1,\n                                                             left: page.barcode.geometry.x*page.scene.ratio1,\n                                                             width: page.barcode.geometry.width*page.scene.ratio1,\n                                                             height: page.barcode.geometry.height*page.scene.ratio1,\n                                                             \'z-index\': 998,\n                                                            \'transform\': \'rotate(-\' + page.barcode.rotation.angle + \'deg)\'\n                                                        }"><img src="content/images/txm.png" style="width: 100%;height: 100%"></div><div class="barcode cursorPointer" readonly="readonly" ng-show="page.qrcode&&page.qrcode.geometry" ng-style="{\n                                                             \'line-height\':\'0\',\n                                                             top: page.qrcode.geometry.y*page.scene.ratio1,\n                                                             left: page.qrcode.geometry.x*page.scene.ratio1,\n                                                             width: page.qrcode.geometry.width*page.scene.ratio1,\n                                                             height: page.qrcode.geometry.height*page.scene.ratio1,\n                                                             \'z-index\': 998,\n                                                            \'transform\': \'rotate(-\' + page.qrcode.rotation.angle + \'deg)\'\n                                                        }"><img src="content/images/QrCode.png" style="width: 100%;height: 100%"></div></div></div></div></div><ul ui-sortable="sortableOptions" ng-model="template.pages.page" class="sort-ul col-lg-11 col-md-11 col-sm-11 pad-0"><li ng-repeat="page in template.pages.page track by $index" ng-hide="page.backup" ng-click="selectPages($index,$event)" data-index="{{$index}}"><div ng-if="!page.scene" ng-class="{\'nav-active\': page.seq == currentPage.seq}" class="page-nav-box"><div data-index="{{$index}}" style="overflow:hidden" ng-class="{\'custom-grid\':page.background.type==\'Color\'&&!page.background.color}" ng-style="{\n                                                height:\'98px\',\n                                                width:page.mediabox.width*98/page.mediabox.height,\n                                                margin:\'0 auto\',\n                                                position:\'relative\'}"><div style="width: 100%;height:100%" ng-style="{background:page.background.type==\'Color\'?page.background.color:\'\'}"><img class="top-img" data-index="{{$index}}" ng-if="page.background.type==\'Pic\'&&page.background.resource.identifier" ng-src="{{page.background.resource.identifier + vm.pageImageView||\'//:0\'}}" ng-style="{\n                                                    position: \'absolute\',\n                                                    width: page.background.adaptation==\'Width\'?page.mediabox.width*98/page.mediabox.height:\'\',\n                                                    height: page.background.adaptation==\'Height\'?\'98px\':\'\',\n                                                    left: page.background.offsetx*98/page.mediabox.height,\n                                                    top: page.background.offsety*98/page.mediabox.height}"><div ng-repeat="level in page.levels.level track by $index"><div class="img-art" ng-if="level.imageart&&level.imageart.current" ng-style="{\n                                                    width: level.imageart.geometry.width*98/page.mediabox.height,\n                                                    height: level.imageart.geometry.height*98/page.mediabox.height,\n                                                    left: level.imageart.geometry.x*98/page.mediabox.height,\n                                                    top: level.imageart.geometry.y*98/page.mediabox.height,\n                                                    \'z-index\':level.seq-0+200,\n                                                    \'opacity\':level.imageart.transparency,\n                                                    filter: \'alpha(opacity=\'+level.imageart.transparency*100+\')\',\n                                                    \'transform\': \'rotate(\' + level.imageart.rotation.angle + \'deg)\'}"><div style="overflow: hidden; position: relative; width: 100%; height: 100%"><img data-index="{{$index}}" style="position: absolute" ng-style="{\n                                                            \'left\': level.imageart.offsetx*98/page.mediabox.height,\n                                                            \'top\': level.imageart.offsety*98/page.mediabox.height,\n                                                            \'width\': level.imageart.geometry.width*98/page.mediabox.height * level.imageart.scale}" ng-src="{{level.imageart.resource.identifier + vm.pageImageView}}"></div></div><div class="imgBox" style="position: absolute" ng-if="level.imagebox&&level.imagebox.current" ng-style="{\n                                                            width: imageboxW(level.imagebox)*98/page.mediabox.height,\n                                                            height: imageboxH(level.imagebox)*98/page.mediabox.height,\n                                                            left: imageboxL(level.imagebox)*98/page.mediabox.height,\n                                                            top: imageboxT(level.imagebox)*98/page.mediabox.height,\n                                                            \'opacity\':level.imagebox.transparency,\n                                                            \'z-index\':level.seq-0+200,\n                                                            \'transform\': \'rotate(-\' + level.imagebox.rotation.angle + \'deg)\'}"><div class="relative-view1" ng-style="{\n                                                        \'overflow\': (level.imagebox.border && level.imagebox.border.type == \'Pic\') ? \'unset\' : \'hidden\',\n                                                        \'border-top-left-radius\':(level.imagebox.border && level.imagebox.border.type == \'Pic\') ? 0 : imageboxWRadius(level.imagebox, \'lt\', 98/page.mediabox.height),\n                                                        \'border-top-right-radius\':(level.imagebox.border && level.imagebox.border.type == \'Pic\') ? 0 : imageboxWRadius(level.imagebox, \'rt\', 98/page.mediabox.height),\n                                                        \'border-bottom-right-radius\':(level.imagebox.border && level.imagebox.border.type == \'Pic\') ? 0 : imageboxWRadius(level.imagebox, \'rb\', 98/page.mediabox.height),\n                                                        \'border-bottom-left-radius\':(level.imagebox.border && level.imagebox.border.type == \'Pic\') ? 0 : imageboxWRadius(level.imagebox, \'lb\', 98/page.mediabox.height),\n                                                        \'padding-left\': (level.imagebox.border && level.imagebox.border.type == \'Pic\') ? imageboxWEdge(level.imagebox,\'left\')*98/page.mediabox.height : 0,\n                                                        \'padding-top\': (level.imagebox.border && level.imagebox.border.type == \'Pic\') ? imageboxWEdge(level.imagebox,\'top\')*98/page.mediabox.height : 0,\n                                                        \'padding-right\': (level.imagebox.border && level.imagebox.border.type == \'Pic\') ? imageboxWEdge(level.imagebox,\'right\')*98/page.mediabox.height : 0,\n                                                        \'padding-bottom\': (level.imagebox.border && level.imagebox.border.type == \'Pic\') ? imageboxWEdge(level.imagebox,\'bottom\')*98/page.mediabox.height : 0,\n                                                        \'background-image\': (level.imagebox.border && level.imagebox.border.type == \'Pic\') ? \'url(\' + level.imagebox.border.resource.identifier + vm.pageImageView + \')\' : \'\',\n                                                        \'background-size\': (level.imagebox.border && level.imagebox.border.type == \'Pic\') ? \'100% 100%\' : \'\',\n                                                        \'border-width\': (level.imagebox.border && level.imagebox.border.type == \'Color\') ? (level.imagebox.border.lineWidth*98/page.mediabox.height) : \'\',\n                                                        \'border-style\': (level.imagebox.border && level.imagebox.border.type == \'Color\' && level.imagebox.border.lineType == \'solid\') ? \'solid\' : (level.imagebox.border && level.imagebox.border.type == \'Color\' && level.imagebox.border.lineType == \'dashed\') ? \'dashed\' : (level.imagebox.border && level.imagebox.border.type == \'Color\' && level.imagebox.border.lineType == \'dotted\') ? \'dotted\' : \'none\',\n                                                        \'border-color\': (level.imagebox.border && level.imagebox.border.type == \'Color\') ? level.imagebox.border.color : \'\',\n                                                        \'box-shadow\' : (level.imagebox.border && level.imagebox.border.type == \'Color\' && level.imagebox.border.lineWidth>0 && level.imagebox.border && level.imagebox.border.lineType == \'solid\') ? \'0 0 0 1px \' + level.imagebox.border.color + \' inset\' : \'none\',\n                                                        \'filter\' : dropShadow(level.imagebox,98/page.mediabox.height),\n                                                        }"><div ng-style="{\n                                                             \'position\': \'absolute\',\n                                                             \'z-index\':0,\n                                                            \'left\': (level.imagebox.border && level.imagebox.border.type == \'Pic\') ? -imageboxWEdge(level.imagebox,\'left\')*98/page.mediabox.height : 0,\n                                                            \'top\': (level.imagebox.border && level.imagebox.border.type == \'Pic\') ? -imageboxWEdge(level.imagebox,\'top\')*98/page.mediabox.height : 0,\n                                                            \'right\': (level.imagebox.border && level.imagebox.border.type == \'Pic\') ? -imageboxWEdge(level.imagebox,\'right\')*98/page.mediabox.height : 0,\n                                                            \'bottom\': (level.imagebox.border && level.imagebox.border.type == \'Pic\') ? -imageboxWEdge(level.imagebox,\'bottom\')*98/page.mediabox.height : 0,\n                                                            \'background-image\': (level.imagebox.border && level.imagebox.border.type == \'Pic\') ? \'url(\' + level.imagebox.border.resource.identifier + vm.pageImageView + \')\' : \'\',\n                                                            \'background-size\': (level.imagebox.border && level.imagebox.border.type == \'Pic\') ? \'100% 100%\' : \'\',\n                                                            }"></div><div data-index="{{$index}}" class="relative-view1" ng-style="{\n                                                                \'border-top-left-radius\':imageboxWRadius1(level.imagebox, \'lt\', 98/page.mediabox.height),\n                                                        \'border-top-right-radius\':imageboxWRadius1(level.imagebox, \'rt\', 98/page.mediabox.height),\n                                                        \'border-bottom-right-radius\':imageboxWRadius1(level.imagebox, \'rb\', 98/page.mediabox.height),\n                                                        \'border-bottom-left-radius\':imageboxWRadius1(level.imagebox, \'lb\', 98/page.mediabox.height),\n                                                                \'-webkit-mask-image\': level.imagebox.mask.resource.identifier ? \'url(\' + level.imagebox.mask.resource.identifier + \')\' : \'none\',\n                                                                \'-webkit-mask-size\': \'100% 100%\'\n                                                                }"><!-- <img data-index="{{$index}}"\n                                                                     ng-if="!level.imagebox.image&&!level.imagebox.image.resource.identifier"\n                                                                     class="img-holder mask"\n                                                                     style="width: 100%; height: 100%; position: absolute; left: 0; top: 0;"\n                                                                     src="content/images/mask_souce.png"\n                                                                     data-mask="content/images/mask_souce.png"/> --><div ng-if="!level.imagebox.image&&!level.imagebox.image.resource.identifier" data-index="{{$index}}" class="image-placeholder"><img src="content/images/icons/camera.svg" alt="" srcset="" data-index="{{$index}}" style="width: 15px"></div><img data-index="{{$index}}" ng-if="level.imagebox.image&&level.imagebox.image.resource.identifier" class="img-holder mask" style="position: absolute" ng-style="{\n                                                                    width: level.imagebox.image.width*98/page.mediabox.height,\n                                                                    height: level.imagebox.image.height*98/page.mediabox.height,\n                                                                    left: level.imagebox.image.offsetx*98/page.mediabox.height,\n                                                                    top: level.imagebox.image.offsety*98/page.mediabox.height\n                                                                 }" ng-src="{{level.imagebox.image.resource.identifier+vm.pageImageViewOrient}}"></div></div></div><div class="c-xml-page-textboxe" ng-if="level.textbox.current" style="white-space: normal" ng-style="{\n                                                    \'z-index\':level.seq-0+200,\n                                                    \'width\': level.textbox.geometry.width*98/page.mediabox.height,\n                                                    \'left\': level.textbox.geometry.x*98/page.mediabox.height,\n                                                    \'top\': level.textbox.geometry.y*98/page.mediabox.height,\n                                                    \'height\': level.textbox.geometry.height*98/page.mediabox.height,\n                                                    \'transform\': \'rotate(\' + level.textbox.rotation.angle + \'deg)\'\n                                                }"><div style="width: 100%;height: 100%;position: absolute;top:0;left: 0"><pre class="c-xml-page-textboxe-text web-font" ng-style="{\n                                                        \'font-family\':  \'\\\'\' + level.textbox.fontuuid + \'\\\'\',\n                                                        \'font-size\': level.textbox.style.size + \'pt\',\n                                                        \'color\': level.textbox.style.color,\n                                                        \'font-weight\': level.textbox.style.bold ? \'bold\': \'400\',\n                                                        \'font-style\': level.textbox.style.italic ? \'italic\': \'initial\',\n                                                        \'line-height\': level.textbox.style.lineheight + \'pt\',\n                                                        \'letter-spacing\': level.textbox.style.letterspacing + \'pt\',\n                                                        \'opacity\': level.textbox.transparency,\n                                                        \'text-decoration\': \'none\',\n                                                        \'text-align\': level.textbox.style.align,\n                                                        \'text-align-last\': \'unset\',\n                                                        transform:\'scale(\'+(page.proportionTextSmalll)+\')\',\n                                                        \'transform-origin\': \'0 0\',\n                                                        width: level.textbox.geometry.width*98/page.mediabox.height/page.proportionTextSmalll,\n                                                        height: level.textbox.geometry.height*98/page.mediabox.height/page.proportionTextSmalll\n                                                      }"><span class="c-xml-page-textboxe-span">{{level.textbox.text}}</span></pre></div></div><div data-index="{{$index}}" ng-if="level.textdocument.current" ng-style="{\n                                                        position: \'absolute\',\n                                                        width: level.textdocument.geometry.width*98/page.mediabox.height,\n                                                        height: level.textdocument.geometry.height*98/page.mediabox.height,\n                                                        left: level.textdocument.geometry.x*98/page.mediabox.height,\n                                                        top: level.textdocument.geometry.y*98/page.mediabox.height,\n                                                        \'z-index\':level.seq-0+200,\n                                                        \'opacity\':level.textdocument.transparency.toFixed(2),\n                                                        filter: \'alpha(opacity=\'+level.textdocument.transparency*100+\')\',\n                                                        \'transform\': \'rotate(-\' + level.textdocument.rotation.angle + \'deg)\'}"><div style="overflow: hidden;width: 100%;height: 100%;position: relative" class="no-events"><img class="bg-image bg-image{{template.pageI}} pos" ng-cloak ng-if="level.textdocument.background.resource.identifier" ng-src="{{level.textdocument.background.resource.identifier  + vm.pageImageView||\'//:0\'}}" ng-style="{\n                                                             position: \'absolute\',\n                                                             left:level.textdocument.background.offsetx*98/page.mediabox.height,\n                                                             top:level.textdocument.background.offsety*98/page.mediabox.height,\n                                                             width: level.textdocument.background.adaptation==\'Width\'?\'100%\':\'\',\n                                                             height:level.textdocument.background.adaptation!=\'Width\'?\'100%\':\'\'}"><div ng-repeat="docLevel in level.textdocument.levels.level track by $index" ng-init="docIndex = $index" style="position: relative"><div data-index="{{docIndex}}" class="img-art" ng-if="docLevel.imageart" ng-style="{\n                                                                    width: docLevel.imageart.geometry.width*98/page.mediabox.height,\n                                                                    height: docLevel.imageart.geometry.height*98/page.mediabox.height,\n                                                                    left: docLevel.imageart.geometry.x*98/page.mediabox.height,\n                                                                    top: docLevel.imageart.geometry.y*98/page.mediabox.height,\n                                                                    \'z-index\':docLevel.seq-0+200,\n                                                                    \'opacity\':docLevel.imageart.transparency,\n                                                                    filter: \'alpha(opacity=\'+docLevel.imageart.transparency*100+\')\',\n                                                                    \'transform\': \'rotate(\' + docLevel.imageart.rotation.angle + \'deg)\'}"><div style="overflow: hidden; position: relative; width: 100%; height: 100%"><img data-index="{{$index}}" style="position: absolute" ng-style="{\n                                                                        \'left\': docLevel.imageart.offsetx*98/page.mediabox.height,\n                                                                        \'top\': docLevel.imageart.offsety*98/page.mediabox.height,\n                                                                        \'width\': docLevel.imageart.geometry.width*98/page.mediabox.height * docLevel.imageart.scale}" ng-src="{{docLevel.imageart.resource.identifier + vm.pageImageView}}"></div></div><div class="c-xml-page-textboxe" ng-if="docLevel.textbox" style="white-space: normal" data-index="{{docIndex}}" ng-style="{\n                                                                \'z-index\':docLevel.seq-0+200,\n                                                                \'width\': docLevel.textbox.geometry.width*98/page.mediabox.height,\n                                                                \'height\': docLevel.textbox.geometry.height*98/page.mediabox.height,\n                                                                \'left\': docLevel.textbox.geometry.x*98/page.mediabox.height,\n                                                                \'top\': docLevel.textbox.geometry.y*98/page.mediabox.height,\n                                                                \'transform\': \'rotate(\' + docLevel.textbox.rotation.angle + \'deg)\'}"><div style="width: 100%;height: 100%;position: absolute;top:0;left: 0"><pre class="c-xml-page-textboxe-text web-font" ng-style="{\n                                                                        \'font-family\':  \'\\\'\' + docLevel.textbox.fontuuid + \'\\\'\',\n                                                                        \'font-size\': docLevel.textbox.style.size + \'pt\',\n                                                                        \'color\': docLevel.textbox.style.color,\n                                                                        \'font-weight\': docLevel.textbox.style.bold ? \'bold\': \'400\',\n                                                                        \'font-style\': docLevel.textbox.style.italic ? \'italic\': \'initial\',\n                                                                        \'line-height\': docLevel.textbox.style.lineheight + \'pt\',\n                                                                        \'letter-spacing\': docLevel.textbox.style.letterspacing + \'pt\',\n                                                                        \'opacity\': docLevel.textbox.transparency,\n                                                                        \'text-decoration\': \'none\',\n                                                                        \'text-align\': docLevel.textbox.style.align,\n                                                                        \'text-align-last\': \'unset\',\n                                                                        transform:\'scale(\'+(page.proportionTextSmalll)+\')\',\n                                                                        \'transform-origin\': \'0 0\',\n                                                                        width: docLevel.textbox.geometry.width*98/page.mediabox.height/page.proportionTextSmalll,\n                                                                        height: docLevel.textbox.geometry.height*98/page.mediabox.height/page.proportionTextSmalll\n                                                                  }"><span class="c-xml-page-textboxe-span">{{docLevel.textbox.text}}</span></pre></div></div></div></div></div></div><div class="barcode cursorPointer" ng-if="page.barcode&&page.barcode.geometry" readonly="readonly" ng-style="{\n                                                 top: page.barcode.geometry.y*98/page.mediabox.height,\n                                                 left: page.barcode.geometry.x*98/page.mediabox.height,\n                                                 width: page.barcode.geometry.width*98/page.mediabox.height,\n                                                 height: page.barcode.geometry.height*98/page.mediabox.height,\n                                                 \'z-index\': 998,\n                                                 \'line-height\':\'0\',\n                                                 \'transform\': \'rotate(-\' + page.barcode.rotation.angle + \'deg)\'\n                                                    }"><img src="content/images/txm.png"></div><div class="barcode cursorPointer" ng-if="page.qrcode&&page.qrcode.geometry" readonly="readonly" ng-style="{\n                                                 top: page.qrcode.geometry.y*98/page.mediabox.height,\n                                                 left: page.qrcode.geometry.x*98/page.mediabox.height,\n                                                 width: page.qrcode.geometry.width*98/page.mediabox.height,\n                                                 height: page.qrcode.geometry.height*98/page.mediabox.height,\n                                                 \'z-index\': 998,\n                                                 \'line-height\':\'0\',\n                                                 \'transform\': \'rotate(-\' + page.qrcode.rotation.angle + \'deg)\'\n                                                    }"><img src="content/images/QrCode.png"></div></div></div><button class="page-del leftPanel-del" ng-click="deletePage($index,$event)" style="z-index: 999!important" ng-if="vm.isCustom"><div style=""></div><img src="content/images/icons/ic_delete.svg"></button><div class="page-seq" style="z-index: 999!important">{{page.seq}}</div><div class="page-cover" ng-if="page.type==\'Cover\'">\u5C01\u9762</div><div class="page-cover" ng-if="page.type==\'BackCover\'">\u5C01\u5E95</div><div class="page-cover" ng-if="page.type==\'FrontBack\'">\u5C01\u9762\u5C01\u5E95</div></div><div class="page-nav-box" ng-show="page.scene" style="transform:translate(-50% -50%)!important;outline: none" ng-style="{\n                                         width: (page.scene.geometry.width)*page.scene.ratio1,\n                                         height: (page.scene.geometry.height)*page.scene.ratio1}"><div style="width: 100%; height: 100%; position: relative"><div class="content-container" id="content" ng-class="{\'custom-grid\':page.background.type==\'Color\'&&!page.background.color}" ng-style="{\n                                                    \'position\': \'absolute\',\n                                                    \'width\': (page.scene.geometry.width)*page.scene.ratio1,\n                                                    \'height\': (page.scene.geometry.height)*page.scene.ratio1,\n                                                    \'z-index\': page.scene.hierarchy == \'TOP\' ? \'1\' : \'0\',\n                                                    \'pointer-events\': \'none\'\n                                                 }"><img class="bg-image bg-image{{template.pageI}}" ng-cloak ng-show="page.scene.background.resource.identifier" ng-src="{{page.scene.background.resource.identifier  + vm.pageImageView||\'//:0\'}}" ng-style="{width: page.scene.background.resource.identifier?page.scene.geometry.width*page.scene.ratio1:0}"><div ng-style="{\n                                                    position: \'absolute\',\n                                                    width: page.scene.imagebox.geometry.width*page.scene.ratio1,\n                                                    height: page.scene.imagebox.geometry.height*page.scene.ratio1,\n                                                    left: page.scene.imagebox.geometry.x*page.scene.ratio1,\n                                                    top: page.scene.imagebox.geometry.y*page.scene.ratio1,\n                                                    \'transform\': \'rotate(-\' + page.scene.imagebox.rotation.angle + \'deg)\'}" ng-show="page.scene.imagebox"></div></div><div class="editing1" ng-style="{\n                                                    \'position\': \'absolute\',\n                                                     background:page.background.color,\n                                                     width: page.mediabox.width*page.scene.ratio1,\n                                                     height: page.mediabox.height*page.scene.ratio1,\n                                                     \'left\':page.scene.imagebox.geometry.x*page.scene.ratio1,\n                                                     \'top\':page.scene.imagebox.geometry.y*page.scene.ratio1,\n                                                     \'z-index\': page.scene.hierarchy == \'TOP\' ? 0 : 1\n                                                 }" style="overflow: hidden;border: 1px solid #299DFF"><img class="bg-image bg-image{{template.pageI}} pos" ng-cloak ng-if="page.background.resource.identifier" ng-src="{{page.background.resource.identifier + vm.pageImageView||\'//:0\'}}" ng-style="{\n                                                         position: \'absolute\',\n                                                         left:page.background.offsetx*page.scene.ratio1,\n                                                         top:page.background.offsety*page.scene.ratio1,\n                                                         width: page.background.adaptation==\'Width\'?page.mediabox.width*page.scene.ratio1:\'\',\n                                                         height:page.background.adaptation==\'Height\'?page.mediabox.height*page.scene.ratio1:\'\'}"><div ng-repeat="level in page.levels.level track by $index"><div data-index="{{$index}}" class="imgBox" ng-show="level.imagebox.current" ng-class="{\'selected\': level.imagebox.ctrlKey || $index == template.levelI && (RightPanel==\'mask\')}" ng-style="{\n                                                        width: imageboxW(level.imagebox)*page.scene.ratio1,\n                                                        height: imageboxH(level.imagebox)*page.scene.ratio1,\n                                                        left: imageboxL(level.imagebox)*page.scene.ratio1,\n                                                        top: imageboxT(level.imagebox)*page.scene.ratio1,\n                                                        \'opacity\':level.imagebox.transparency,\n                                                        \'z-index\':level.seq-0+200,\n                                                        \'transform\': \'rotate(-\' + level.imagebox.rotation.angle + \'deg)\'}"><div class="relative-view1" ng-style="{\n                                                        \'overflow\': (level.imagebox.border && level.imagebox.border.type == \'Pic\') ? \'unset\' : \'hidden\',\n                                                        \'border-top-left-radius\':(level.imagebox.border && level.imagebox.border.type == \'Pic\') ? 0 : imageboxWRadius(level.imagebox, \'lt\', page.scene.ratio1),\n                                                        \'border-top-right-radius\':(level.imagebox.border && level.imagebox.border.type == \'Pic\') ? 0 : imageboxWRadius(level.imagebox, \'rt\', page.scene.ratio1),\n                                                        \'border-bottom-right-radius\':(level.imagebox.border && level.imagebox.border.type == \'Pic\') ? 0 : imageboxWRadius(level.imagebox, \'rb\', page.scene.ratio1),\n                                                        \'border-bottom-left-radius\':(level.imagebox.border && level.imagebox.border.type == \'Pic\') ? 0 : imageboxWRadius(level.imagebox, \'lb\', page.scene.ratio1),\n                                                        \'padding-left\': (level.imagebox.border && level.imagebox.border.type == \'Pic\') ? imageboxWEdge(level.imagebox,\'left\')*page.scene.ratio1 : 0,\n                                                        \'padding-top\': (level.imagebox.border && level.imagebox.border.type == \'Pic\') ? imageboxWEdge(level.imagebox,\'top\')*page.scene.ratio1 : 0,\n                                                        \'padding-right\': (level.imagebox.border && level.imagebox.border.type == \'Pic\') ? imageboxWEdge(level.imagebox,\'right\')*page.scene.ratio1 : 0,\n                                                        \'padding-bottom\': (level.imagebox.border && level.imagebox.border.type == \'Pic\') ? imageboxWEdge(level.imagebox,\'bottom\')*page.scene.ratio1 : 0,\n                                                        \'background-image\': (level.imagebox.border && level.imagebox.border.type == \'Pic\') ? \'url(\' + level.imagebox.border.resource.identifier + vm.pageImageView + \')\' : \'\',\n                                                        \'background-size\': (level.imagebox.border && level.imagebox.border.type == \'Pic\') ? \'100% 100%\' : \'\',\n                                                        \'border-width\': (level.imagebox.border && level.imagebox.border.type == \'Color\') ? (level.imagebox.border.lineWidth*page.scene.ratio1) : \'\',\n                                                        \'border-style\': (level.imagebox.border && level.imagebox.border.type == \'Color\' && level.imagebox.border.lineType == \'solid\') ? \'solid\' : (level.imagebox.border && level.imagebox.border.type == \'Color\' && level.imagebox.border.lineType == \'dashed\') ? \'dashed\' : (level.imagebox.border && level.imagebox.border.type == \'Color\' && level.imagebox.border.lineType == \'dotted\') ? \'dotted\' : \'none\',\n                                                        \'border-color\': (level.imagebox.border && level.imagebox.border.type == \'Color\') ? level.imagebox.border.color : \'\',\n                                                        \'box-shadow\' : (level.imagebox.border && level.imagebox.border.type == \'Color\' && level.imagebox.border.lineWidth>0 && level.imagebox.border && level.imagebox.border.lineType == \'solid\') ? \'0 0 0 1px \' + level.imagebox.border.color + \' inset\' : \'none\',\n                                                        \'filter\' : dropShadow(level.imagebox,page.scene.ratio1),\n                                                        }"><div ng-style="{\n                                                             \'position\': \'absolute\',\n                                                             \'z-index\':0,\n                                                            \'left\': (level.imagebox.border && level.imagebox.border.type == \'Pic\') ? -imageboxWEdge(level.imagebox,\'left\')*page.scene.ratio1 : 0,\n                                                            \'top\': (level.imagebox.border && level.imagebox.border.type == \'Pic\') ? -imageboxWEdge(level.imagebox,\'top\')*page.scene.ratio1 : 0,\n                                                            \'right\': (level.imagebox.border && level.imagebox.border.type == \'Pic\') ? -imageboxWEdge(level.imagebox,\'right\')*page.scene.ratio1 : 0,\n                                                            \'bottom\': (level.imagebox.border && level.imagebox.border.type == \'Pic\') ? -imageboxWEdge(level.imagebox,\'bottom\')*page.scene.ratio1 : 0,\n                                                            \'background-image\': (level.imagebox.border && level.imagebox.border.type == \'Pic\') ? \'url(\' + level.imagebox.border.resource.identifier + vm.pageImageView + \')\' : \'\',\n                                                            \'background-size\': (level.imagebox.border && level.imagebox.border.type == \'Pic\') ? \'100% 100%\' : \'\',\n                                                            }"></div><div class="relative-view1" ng-style="{\n                                                                \'border-top-left-radius\':imageboxWRadius1(level.imagebox, \'lt\', page.scene.ratio1),\n                                                        \'border-top-right-radius\':imageboxWRadius1(level.imagebox, \'rt\', page.scene.ratio1),\n                                                        \'border-bottom-right-radius\':imageboxWRadius1(level.imagebox, \'rb\', page.scene.ratio1),\n                                                        \'border-bottom-left-radius\':imageboxWRadius1(level.imagebox, \'lb\', page.scene.ratio1),\n                                                                \'-webkit-mask-image\': level.imagebox.mask.resource.identifier ? \'url(\' + level.imagebox.mask.resource.identifier + \')\' : \'none\',\n                                                                \'-webkit-mask-size\': \'100% 100%\'\n                                                            }"><!-- <img data-index="{{$index}}"\n                                                                     ng-if="!level.imagebox.image&&!level.imagebox.image.resource.identifier"\n                                                                     class="img-holder mask"\n                                                                     style="width: 100%; height: 100%; position: absolute; left: 0; top: 0;"\n                                                                     src="content/images/mask_souce.png"\n                                                                     data-mask="content/images/centerblur.png"/> --><div ng-if="!level.imagebox.image&&!level.imagebox.image.resource.identifier" data-index="{{$index}}" class="image-placeholder"><!-- <img src="content/images/icons/camera.svg" alt="" srcset="" data-index="{{$index}}"> --><!-- <span ng-if="imageboxW(level.imagebox)*currentPage.scale/currentPage.proportion > 60 && imageboxH(level.imagebox)*currentPage.scale/currentPage.proportion > 80" data-index="{{$index}}">\u62D6\u5165\u76F8\u7247</span> --></div><img data-index="{{$index}}" ng-if="level.imagebox.image&&level.imagebox.image.resource.identifier" class="img-holder mask" style="position: absolute" ng-style="{\n                                                                width: level.imagebox.image.width*page.scene.ratio1,\n                                                                height: level.imagebox.image.height*page.scene.ratio1,\n                                                                left: level.imagebox.image.offsetx*page.scene.ratio1,\n                                                                top: level.imagebox.image.offsety*page.scene.ratio1,\n                                                             }" ng-src="{{level.imagebox.image.resource.identifier+vm.pageImageViewOrient}}"></div></div></div><div data-index="{{$index}}" class="img-art img-art{{$index}}" ng-show="level.imageart.current" ng-style="{\n                                                            width: level.imageart.geometry.width*page.scene.ratio1,\n                                                            height: level.imageart.geometry.height*page.scene.ratio1,\n                                                            \'line-height\': level.imageart.geometry.height*page.scene.ratio1+\'px\',\n                                                            left: level.imageart.geometry.x*page.scene.ratio1,\n                                                            top: level.imageart.geometry.y*page.scene.ratio1,\n                                                            \'z-index\':level.seq-0+200,\n                                                            \'opacity\':level.imageart.transparency,\n                                                            filter: \'alpha(opacity=\'+level.imageart.transparency*100+\')\',\n                                                            \'transform\': \'rotate(\' + level.imageart.rotation.angle + \'deg)\'}"><div style="overflow: hidden; position: relative; width: 100%; height: 100%"><img data-index="{{$index}}" ng-mousedown="moveBoxStart1($event,level.imageart,$index)" style="transition: opacity 0.3s;position: absolute" ng-style="{\n                                                                \'left\': level.imageart.offsetx*page.scene.ratio1,\n                                                                \'top\': level.imageart.offsety*page.scene.ratio1,\n                                                                \'width\': level.imageart.geometry.width*page.scene.ratio1 * level.imageart.scale}" ng-src="{{level.imageart.resource.identifier + vm.pageImageView}}"></div></div><div class="c-xml-page-textboxe" ng-show="level.textbox.current" style="white-space: normal" ng-style="{\n                                                                \'z-index\':level.seq-0+200,\n                                                                \'width\': level.textbox.geometry.width*page.scene.ratio1,\n                                                                \'left\': level.textbox.geometry.x*page.scene.ratio1,\n                                                                \'top\': level.textbox.geometry.y*page.scene.ratio1,\n                                                                \'height\': level.textbox.geometry.height*page.scene.ratio1,\n                                                                \'transform\': \'rotate(\' + level.textbox.rotation.angle + \'deg)\'\n                                                             }"><div style="width: 100%;height: 100%;position: absolute;top:0;left: 0"><pre class="c-xml-page-textboxe-text web-font" ng-style="{\n                                                                \'font-family\':  \'\\\'\' + level.textbox.fontuuid + \'\\\'\',\n                                                                \'font-size\': level.textbox.style.size + \'pt\',\n                                                                \'color\': level.textbox.style.color,\n                                                                \'font-weight\': level.textbox.style.bold ? \'bold\': \'400\',\n                                                                \'font-style\': level.textbox.style.italic ? \'italic\': \'initial\',\n                                                                \'line-height\': level.textbox.style.lineheight + \'pt\',\n                                                                \'letter-spacing\': level.textbox.style.letterspacing + \'pt\',\n                                                                \'opacity\': level.textbox.transparency,\n                                                                \'text-decoration\': \'none\',\n                                                                \'text-align\': level.textbox.style.align,\n                                                                \'text-align-last\': \'unset\',\n                                                                transform:\'scale(\'+(page.scene.ratio1)+\')\',\n                                                                \'transform-origin\': \'0 0\',\n                                                                width: level.textbox.geometry.width,\n                                                                height: level.textbox.geometry.height\n                                                              }"><span class="c-xml-page-textboxe-span">{{level.textbox.text}}</span></pre></div></div><div data-index="{{$index}}" ng-show="level.textdocument.current" ng-style="{\n                                                            position: \'absolute\',\n                                                            width: level.textdocument.geometry.width*page.scene.ratio1,\n                                                            height: level.textdocument.geometry.height*page.scene.ratio1,\n                                                            left: level.textdocument.geometry.x*page.scene.ratio1,\n                                                            top: level.textdocument.geometry.y*page.scene.ratio1,\n                                                            \'z-index\':level.seq-0+200,\n                                                            \'opacity\':level.textdocument.transparency.toFixed(2),\n                                                            filter: \'alpha(opacity=\'+level.textdocument.transparency*100+\')\',\n                                                            \'transform\': \'rotate(-\' + level.textdocument.rotation.angle + \'deg)\'}"><div style="overflow: hidden;width: 100%;height: 100%;position: relative" class="no-events"><img class="bg-image bg-image{{template.pageI}} pos" ng-cloak ng-if="level.textdocument.background.resource.identifier" ng-src="{{level.textdocument.background.resource.identifier  + vm.pageImageView||\'//:0\'}}" ng-style="{\n                                                                     position: \'absolute\',\n                                                                     left:level.textdocument.background.offsetx*page.scene.ratio1,\n                                                                     top:level.textdocument.background.offsety*page.scene.ratio1,\n                                                                     width: level.textdocument.background.adaptation==\'Width\'?level.textdocument.geometry.width*page.scene.ratio1:\'\',\n                                                                     height:level.textdocument.background.adaptation!=\'Width\'?level.textdocument.geometry.height*page.scene.ratio1:\'\'}"><div ng-repeat="docLevel in level.textdocument.levels.level track by $index" ng-init="docIndex = $index" style="position: relative"><div data-index="{{docIndex}}" class="img-art" ng-show="docLevel.imageart" ng-style="{\n                                                                        width: docLevel.imageart.geometry.width*page.scene.ratio1,\n                                                                        height: docLevel.imageart.geometry.height*page.scene.ratio1,\n                                                                        left: docLevel.imageart.geometry.x*page.scene.ratio1,\n                                                                        top: docLevel.imageart.geometry.y*page.scene.ratio1,\n                                                                        \'z-index\':docLevel.seq-0+200,\n                                                                        \'opacity\':docLevel.imageart.transparency,\n                                                                        filter: \'alpha(opacity=\'+docLevel.imageart.transparency*100+\')\',\n                                                                        \'transform\': \'rotate(\' + docLevel.imageart.rotation.angle + \'deg)\'}"><div style="overflow: hidden; position: relative; width: 100%; height: 100%"><img data-index="{{$index}}" style="transition: opacity 0.3s;position: absolute" ng-style="{\n                                                                            \'left\': docLevel.imageart.offsetx *page.scene.ratio1,\n                                                                            \'top\': docLevel.imageart.offsety *page.scene.ratio1,\n                                                                            \'width\': docLevel.imageart.geometry.width * page.scene.ratio1 * docLevel.imageart.scale}" ng-src="{{docLevel.imageart.resource.identifier + vm.pageImageView}}"></div></div><div class="c-xml-page-textboxe" ng-show="docLevel.textbox" style="white-space: normal" data-index="{{docIndex}}" ng-style="{\n                                                                    \'z-index\':docLevel.seq-0+200,\n                                                                    \'width\': docLevel.textbox.geometry.width * page.scene.ratio1,\n                                                                    \'left\': docLevel.textbox.geometry.x * page.scene.ratio1,\n                                                                    \'top\': docLevel.textbox.geometry.y * page.scene.ratio1,\n                                                                    \'height\': docLevel.textbox.geometry.height * page.scene.ratio1,\n                                                                    \'transform\': \'rotate(\' + docLevel.textbox.rotation.angle + \'deg)\'}"><div style="width: 100%;height: 100%;position: absolute;top:0;left: 0"><pre class="c-xml-page-textboxe-text web-font" ng-style="{\n                                                                        \'font-family\':  \'\\\'\' + docLevel.textbox.fontuuid + \'\\\'\',\n                                                                        \'font-size\': docLevel.textbox.style.size + \'pt\',\n                                                                        \'color\': docLevel.textbox.style.color,\n                                                                        \'font-weight\': docLevel.textbox.style.bold ? \'bold\': \'400\',\n                                                                        \'font-style\': docLevel.textbox.style.italic ? \'italic\': \'initial\',\n                                                                        \'line-height\': docLevel.textbox.style.lineheight + \'pt\',\n                                                                        \'letter-spacing\': docLevel.textbox.style.letterspacing + \'pt\',\n                                                                        \'opacity\': docLevel.textbox.transparency,\n                                                                        \'text-decoration\': \'none\',\n                                                                        \'text-align\': docLevel.textbox.style.align,\n                                                                        \'text-align-last\': \'unset\',\n                                                                        transform:\'scale(\'+(page.scene.ratio1)+\')\',\n                                                                        \'transform-origin\': \'0 0\',\n                                                                        width: docLevel.textbox.geometry.width,\n                                                                        height: docLevel.textbox.geometry.height\n                                                                      }"><span class="c-xml-page-textboxe-span">{{docLevel.textbox.text}}</span></pre></div></div></div></div></div></div><div class="barcode cursorPointer" readonly="readonly" ng-show="page.barcode&&page.barcode.geometry" ng-style="{\n                                                             \'line-height\':\'0\',\n                                                             top: page.barcode.geometry.y*page.scene.ratio1,\n                                                             left: page.barcode.geometry.x*page.scene.ratio1,\n                                                             width: page.barcode.geometry.width*page.scene.ratio1,\n                                                             height: page.barcode.geometry.height*page.scene.ratio1,\n                                                             \'z-index\': 998,\n                                                            \'transform\': \'rotate(-\' + page.barcode.rotation.angle + \'deg)\'\n                                                        }"><img src="content/images/txm.png" style="width: 100%;height: 100%"></div><div class="barcode cursorPointer" readonly="readonly" ng-show="page.qrcode&&page.qrcode.geometry" ng-style="{\n                                                             \'line-height\':\'0\',\n                                                             top: page.qrcode.geometry.y*page.scene.ratio1,\n                                                             left: page.qrcode.geometry.x*page.scene.ratio1,\n                                                             width: page.qrcode.geometry.width*page.scene.ratio1,\n                                                             height: page.qrcode.geometry.height*page.scene.ratio1,\n                                                             \'z-index\': 998,\n                                                            \'transform\': \'rotate(-\' + page.qrcode.rotation.angle + \'deg)\'\n                                                        }"><img src="content/images/QrCode.png" style="width: 100%;height: 100%"></div></div></div><button class="page-del leftPanel-del" ng-click="deletePage($index,$event)" style="z-index: 999!important" ng-if="vm.isCustom"><div style=""></div><img src="content/images/icons/ic_delete.svg"></button><div class="page-seq" style="z-index: 999!important">{{$index+1}}</div></div></li><li class="page-nav-box" ng-show="template.scene" ng-class="{\'nav-active\': currentPage.isScene==true}" ng-click="selectScene()"><div data-index="{{$index}}" ng-style="{\n                                                height:\'98px\',\n                                                width:template.scene.geometry.width*98/template.scene.geometry.height,\n                                                margin:\'0 auto\',\n                                                background:\'#fff\',\n                                                position:\'relative\'}"><img class="top-img" data-index="{{$index}}" ng-show="template.scene.bgImg||template.scene.background.resource.identifier" ng-src="{{template.scene.background.resource.identifier + vm.pageImageView||\'//:0\'}}" style="width: 100%"><div data-index="{{index}}" class="imgBoxs"><!--<img data-index="{{$index}}"--><!--class="img-place-holder mask"--><!--ng-style="{--><!--width: img.geometry.width/(template.scene.geometry.width/(template.scene.geometry.width*98/page.height))/page.proportion,--><!--height: img.geometry.height/(page.height/98)/page.proportion,--><!--left: img.geometry.x/page.proportion/(page.width/(page.width*98/page.height)),--><!--top: img.geometry.y/page.proportion/(page.height/98),--><!--\'transform\': \'rotate(-\' + img.rotation.angle + \'deg)\'}"--><!--ng-src="{{img.mask.resource.identifier?img.bgImg:\'content/images/mask_souce.png\'}}"--><!--data-mask="content/images/centerblur.png"/>--></div></div><button class="page-del leftPanel-del" ng-click="deleteScene()" style="z-index: 999!important"><div style=""></div><img src="content/images/icons/ic_delete.svg"></button><div class="page-seq">{{template.pages.page.length+1}}</div></li></ul><!--\u589E\u52A0\u4E00\u9875--><!--                            <div class="col-lg-1 col-md-1 col-sm-1 pad-0 text-right add-page" style="z-index: 600;">--><!--                                <button class="page-noNav" ng-click="addPage()"--><!--                                        ng-class="{\'dark-theme\':darkTheme==true}">--><!--                                    <img src="content/images/icons/page_add.svg">--><!--                                    <p>\u65B0\u589E</p>--><!--                                    <p>\u9875\u9762</p>--><!--                                </button>--><!--                            </div>--></div></div></div></div></div><div class="rightPanel-2"><div class="col-md-12 col-sm-12 col-lg-12 pad-0 rightPanel-canshu"><div class="template-edit" ng-class="{\'dark-theme\':darkTheme==true}"><div class="rightPanel-head"><div ng-class="{\'dark-theme-color\':darkTheme==true}">\u7B2C{{template.pageI+1}}\u9875</div><div></div><div ng-class="{\'dark-theme-color\':darkTheme==true}">\u5F53\u524D\u56FE\u7247\u6846{{vm.count||0}}\u4E2A</div></div><div class="page-menu" ng-show="RightPanel==\'page\'&&!currentPage.scene" style="padding: 14px 10px 14px 10px"><div class="col-md-12 col-sm-12 col-md-12 pad-0" style="line-height: 34px" ng-show="vm.isCustom"><h4 class="rightPanel-title mar-top-0">\u753B\u5E03\u5C3A\u5BF8</h4><div class="col-md-7 col-sm-7 col-md-7 text-center rightPanel-input"><div class="col-md-8 col-sm-8 col-md-8 text-center temp-mm pad-0"><input type="number" class="no-appearance" placeholder="\u5BBD" ng-change="updateTemplateHeightAndWidth()" max="" min="2" onkeyup="this.value= this.value.match(/\\d+(\\.\\d{0,2})?/) ? this.value.match(/\\d+(\\.\\d{0,2})?/)[0] : \'\'" name="pageWidth" ng-model-options="{debounce:500}" ng-model="pageValue.mediabox.width"></div><div class="col-md-4 col-sm-4 col-lg-4 text-center pad-0 color-A6" ng-class="{\'dark-theme-color\':darkTheme==true}"><div class="input-line"></div>\u5BBD</div></div><div class="col-md-1 col-sm-1 col-lg-1 pad-0"></div><div class="col-md-4 col-sm-4 col-lg-4 pad-0"><select ng-model="vm.unit" ng-options="unit.id as unit.name for unit in vm.units" ng-change="unitConversion()" class="form-control fontSel rightPanel-input"></select></div></div><div class="col-md-12 col-sm-12 col-md-12 mar-top-20 pad-0" style="line-height: 34px" ng-show="vm.isCustom"><div class="col-md-7 col-sm-7 col-md-7 text-center rightPanel-input"><div class="col-md-8 col-sm-8 col-md-8 text-center temp-mm pad-0"><input type="number" class="no-appearance" placeholder="\u9AD8" ng-change="updateTemplateHeightAndWidth()" max="" min="2" onkeyup="this.value= this.value.match(/\\d+(\\.\\d{0,2})?/) ? this.value.match(/\\d+(\\.\\d{0,2})?/)[0] : \'\'" name="pageHeight" ng-model-options="{debounce:500}" ng-model="pageValue.mediabox.height"></div><div class="col-md-4 col-sm-4 col-lg-4 text-center pad-0 color-A6" ng-class="{\'dark-theme-color\':darkTheme==true}"><div class="input-line"></div>\u9AD8</div></div><div class="col-md-1 col-sm-1 col-lg-1 pad-0"></div><div class="col-md-4 col-sm-4 col-lg-4 pad-0"><select ng-model="vm.unit" ng-options="unit.id as unit.name for unit in vm.units" ng-change="unitConversion()" class="form-control fontSel rightPanel-input"></select></div></div><div class="col-md-12 col-sm-12 col-md-12 mar-top-20 pad-0" style="line-height: 34px;border-top:1px solid #DADADA" ng-show="vm.isCustom"><h4 class="rightPanel-title">\u6A21\u677F\u8BBE\u7F6E</h4><div class="col-md-12 col-sm-12 col-md-12 text-left pad-0 rightPanel-btn"><button class="button-b col-md-6 col-sm-6 col-md-6 pad-0" ng-click="pageIsSpread(1)" ng-class="{\'buttonA\':currentPage.spread==true}">\u8DE8\u9875</button> <button class="button-i col-md-6 col-sm-6 col-md-6 pad-0" ng-click="pageIsSpread(0)" ng-class="{\'buttonA\': currentPage.spread==false}">\u975E\u8DE8\u9875</button></div></div><div class="col-md-12 col-sm-12 col-md-12 mar-top-20 pad-0" style="line-height: 34px" ng-show="vm.page.replace && vm.isCustom"><div class="col-md-12 col-sm-12 col-md-12 text-left pad-0 rightPanel-btn"><button class="button-b col-md-6 col-sm-6 col-md-6 pad-0" ng-click="pageIsReplace(1)" ng-class="{\'buttonA\':currentPage.unreplace==false}">\u53EF\u66FF\u6362</button> <button class="button-i col-md-6 col-sm-6 col-md-6 pad-0" ng-click="pageIsReplace(0)" ng-class="{\'buttonA\': currentPage.unreplace==true}">\u4E0D\u53EF\u66FF\u6362</button></div></div><div class="col-md-12 col-sm-12 col-md-12 mar-top-20 pad-0" style="line-height: 34px"><div class="col-md-12 col-sm-12 col-md-12 text-left pad-0 rightPanel-btn" ng-if="!currentPage.spread"><button class="button-b col-md-6 col-sm-6 col-md-6 pad-0" ng-click="pageIsCover(\'Cover\')" ng-class="{\'buttonA\':currentPage.type==\'Cover\'}">\u5C01\u9762</button> <button class="button-i col-md-6 col-sm-6 col-md-6 pad-0" ng-click="pageIsCover(\'BackCover\')" ng-class="{\'buttonA\': currentPage.type==\'BackCover\'}">\u5C01\u5E95</button></div><div class="col-md-12 col-sm-12 col-md-12 text-left pad-0 rightPanel-btn text-center" ng-click="pageIsCover(\'FrontBack\')" ng-class="{\'buttonA\':currentPage.type==\'FrontBack\'}" ng-if="currentPage.spread">\u5C01\u9762\u5C01\u5E95</div></div><div class="col-md-12 col-sm-12 col-md-12 mar-top-20 rightPanel-btn" ng-hide="vm.tempType==\'hasModel\'" ng-click="pageIsBackup()" style="line-height: 32px;color: #000;background: #FAC779;height: 32px">\u4FDD\u5B58\u4E3A\u66FF\u6362\u5E03\u5C40</div><div class="col-md-12 col-sm-12 col-lg-12 pad-0" ng-show="vm.isCustom"></div><!--<span ng-class="{\'dark-theme-color\':darkTheme==true}">\u53EF\u7F16\u8F91\u533A\u57DF\u5C3A\u5BF8\u8BBE\u7F6E</span>--><!--                        <div class="col-md-12 col-sm-12 col-lg-12 mar-top-20 pad-0"--><!--                             style="line-height: 34px;border-top:1px solid #DADADA;" ng-show="vm.isCustom">--><!--                            <h4 class="rightPanel-title">\u53EF\u7F16\u8F91\u533A\u57DF\u5C3A\u5BF8\u8BBE\u7F6E</h4>--><!--                            <div class="col-md-7 col-sm-7 col-md-7 text-center rightPanel-input">--><!--                                <div class="col-md-8 col-sm-8 col-md-8 text-center pad-0">--><!--                                    <input type="number" class="no-appearance"--><!--                                           placeholder="\u5BBD\u5EA6"--><!--                                           ng-change="updateEditbox()"--><!--                                           ng-class="{\'cursor-no\':vm.tempType!=\'customize\'}"--><!--                                           max="" min="2" ng-disabled="vm.tempType!=\'customize\'"--><!--                                           onkeyup="this.value= this.value.match(/\\d+(\\.\\d{0,2})?/) ? this.value.match(/\\d+(\\.\\d{0,2})?/)[0] : \'\'"--><!--                                           ng-model-options="{debounce:500}"--><!--                                           ng-model="pageValue.editbox.width">--><!--                                </div>--><!--                                <div class="col-md-4 col-sm-4 col-lg-4 text-center pad-0 color-A6"--><!--                                  ng-class="{\'dark-theme-color\':darkTheme==true}">--><!--                                    <div class="input-line"></div>\u5BBD</div>--><!--                            </div>--><!--                            <div class="col-md-1 col-sm-1 col-lg-1 pad-0"></div>--><!--                            <div class="col-md-4 col-sm-4 col-lg-4 pad-0">--><!--                                <select ng-model="vm.unit" ng-options="unit.id as unit.name for unit in vm.units" ng-change="unitConversion()"--><!--                                        class="form-control fontSel rightPanel-input"></select>--><!--                            </div>--><!--                        </div>--><!--                        <div class="col-md-12 col-sm-12 col-lg-12 mar-top-20 pad-0"--><!--                             style="line-height: 34px;" ng-show="vm.isCustom">--><!--                            <div class="col-md-7 col-sm-7 col-md-7 text-center rightPanel-input">--><!--                                <div class="col-md-8 col-sm-8 col-md-8 text-center pad-0">--><!--                                    <input type="number" class="no-appearance"--><!--                                           placeholder="\u9AD8\u5EA6"--><!--                                           ng-change="updateEditbox()"--><!--                                           ng-class="{\'cursor-no\':vm.tempType!=\'customize\'}"--><!--                                           max="" min="2" ng-disabled="vm.tempType!=\'customize\'"--><!--                                           onkeyup="this.value= this.value.match(/\\d+(\\.\\d{0,2})?/) ? this.value.match(/\\d+(\\.\\d{0,2})?/)[0] : \'\'"--><!--                                           ng-model-options="{debounce:500}"--><!--                                           ng-model="pageValue.editbox.height">--><!--                                </div>--><!--                                <div class="col-md-4 col-sm-4 col-lg-4 text-center pad-0 color-A6"--><!--                                  ng-class="{\'dark-theme-color\':darkTheme==true}">--><!--                                    <div class="input-line"></div>\u9AD8</div>--><!--                            </div>--><!--                            <div class="col-md-1 col-sm-1 col-lg-1 pad-0"></div>--><!--                            <div class="col-md-4 col-sm-4 col-lg-4 pad-0">--><!--                                <select ng-model="vm.unit" ng-options="unit.id as unit.name for unit in vm.units" ng-change="unitConversion()"--><!--                                        class="form-control fontSel rightPanel-input"></select>--><!--                            </div>--><!--                        </div>--><!--                        <div class="col-md-12 col-sm-12 col-lg-12 mar-top-20 pad-0"--><!--                             style="line-height: 34px;border-top:1px solid #DADADA;" ng-show="vm.isCustom">--><!--                            <h4 class="rightPanel-title mar-top-20">\u53EF\u7F16\u8F91\u5750\u6807\u5C3A\u5BF8\u8BBE\u7F6E</h4>--><!--                            <div class="col-md-7 col-sm-7 col-md-7 text-center rightPanel-input">--><!--                                <div class="col-md-8 col-sm-8 col-md-8 text-center pad-0">--><!--                                    <input type="number" class="no-appearance"--><!--                                           placeholder="offset X"--><!--                                           ng-change="updateEditbox()"--><!--                                           ng-class="{\'cursor-no\':vm.tempType!=\'customize\'}"--><!--                                           max="" min="0" ng-disabled="vm.tempType!=\'customize\'"--><!--                                           onkeyup="this.value= this.value.match(/\\d+(\\.\\d{0,2})?/) ? this.value.match(/\\d+(\\.\\d{0,2})?/)[0] : \'\'"--><!--                                           ng-model-options="{debounce:500}"--><!--                                           ng-model="pageValue.editbox.x">--><!--                                </div>--><!--                                <div class="col-md-4 col-sm-4 col-lg-4 text-center pad-0 color-A6"--><!--                                      ng-class="{\'dark-theme-color\':darkTheme==true}">--><!--                                    <div class="input-line"></div>x\u8F74</div>--><!--                            </div>--><!--                            <div class="col-md-1 col-sm-1 col-lg-1 pad-0"></div>--><!--                            <div class="col-md-4 col-sm-4 col-lg-4 pad-0">--><!--                                <select ng-model="vm.unit" ng-options="unit.id as unit.name for unit in vm.units" ng-change="unitConversion()"--><!--                                        class="form-control fontSel rightPanel-input"></select>--><!--                            </div>--><!--                        </div>--><!--                        <div class="col-md-12 col-sm-12 col-lg-12 mar-top-20 pad-0"--><!--                             style="line-height: 34px;" ng-show="vm.isCustom">--><!--                            <div class="col-md-7 col-sm-7 col-md-7 text-center rightPanel-input">--><!--                                <div class="col-md-8 col-sm-8 col-md-8 text-center temp-mm pad-0">--><!--                                    <input type="number" class="no-appearance"--><!--                                           placeholder="offset Y"--><!--                                           ng-change="updateEditbox()"--><!--                                           ng-class="{\'cursor-no\':vm.tempType!=\'customize\'}"--><!--                                           max="" min="0" ng-disabled="vm.tempType!=\'customize\'"--><!--                                           onkeyup="this.value= this.value.match(/\\d+(\\.\\d{0,2})?/) ? this.value.match(/\\d+(\\.\\d{0,2})?/)[0] : \'\'"--><!--                                           ng-model-options="{debounce:500}"--><!--                                           ng-model="pageValue.editbox.y">--><!--                                </div>--><!--                                <div class="col-md-4 col-sm-4 col-lg-4 text-center pad-0 color-A6"--><!--                                      ng-class="{\'dark-theme-color\':darkTheme==true}">--><!--                                    <div class="input-line"></div>y\u8F74</div>--><!--                            </div>--><!--                            <div class="col-md-1 col-sm-1 col-lg-1 pad-0"></div>--><!--                            <div class="col-md-4 col-sm-4 col-lg-4 pad-0">--><!--                                <select ng-model="vm.unit" ng-options="unit.id as unit.name for unit in vm.units" ng-change="unitConversion()"--><!--                                        class="form-control fontSel rightPanel-input"></select>--><!--                            </div>--><!--                        </div>--><div class="col-md-12 col-sm-12 col-md-12 mar-top-20 mar-bottom-30 rightPanel-btn" ng-click="showThumbnailPic()" style="line-height: 32px;background: #fff8ee;border: 1px solid #E1A03A;height: 32px;color: #E1A03A">\u67E5\u770B\u5F53\u9875\u7F29\u7565\u56FE</div><div class="col-md-12 col-sm-12 col-md-12 mar-top-20 mar-bottom-30 rightPanel-btn" ng-click="showAllThumbnailPic()" style="line-height: 32px;background: #fff8ee;border: 1px solid #E1A03A;height: 32px;color: #E1A03A">\u67E5\u770B\u5168\u90E8\u7F29\u7565\u56FE</div></div><div class="page-menu" ng-show="RightPanel==\'page\'&&currentPage.scene" style="padding: 14px 10px 14px 10px"><div class="col-md-12 col-sm-12 col-md-12 pad-0" style="line-height: 34px"><div class="col-md-7 col-sm-7 col-md-7 text-center rightPanel-input"><div class="col-md-8 col-sm-8 col-md-8 text-center pad-0"><input type="number" class="no-appearance" placeholder="\u5BBD" max="" min="2" disabled="disabled" name="pageWidth" ng-model-options="{debounce:500}" ng-model="pageValue.mediabox.width"></div><div class="col-md-4 col-sm-4 col-lg-4 text-center pad-0 color-A6" ng-class="{\'dark-theme-color\':darkTheme==true}"><div class="input-line"></div>\u5BBD</div></div><div class="col-md-1 col-sm-1 col-lg-1 pad-0"></div><div class="col-md-4 col-sm-4 col-lg-4 pad-0"><select ng-model="vm.unit" ng-options="unit.id as unit.name for unit in vm.units" ng-change="unitConversion()" class="form-control fontSel rightPanel-input"></select></div></div><div class="col-md-12 col-sm-12 col-md-12 mar-top-20 pad-0" style="line-height: 34px"><div class="col-md-7 col-sm-7 col-md-7 text-center rightPanel-input"><div class="col-md-8 col-sm-8 col-md-8 text-center pad-0"><input type="number" class="no-appearance" placeholder="\u9AD8" max="" min="2" disabled="disabled" name="pageHeight" ng-model-options="{debounce:500}" ng-model="pageValue.mediabox.height"></div><div class="col-md-4 col-sm-4 col-lg-4 text-center pad-0 color-A6" ng-class="{\'dark-theme-color\':darkTheme==true}"><div class="input-line"></div>\u9AD8</div></div><div class="col-md-1 col-sm-1 col-lg-1 pad-0"></div><div class="col-md-4 col-sm-4 col-lg-4 pad-0"><select ng-model="vm.unit" ng-options="unit.id as unit.name for unit in vm.units" ng-change="unitConversion()" class="form-control fontSel rightPanel-input"></select></div></div></div><div ng-show="RightPanel == \'barcode\'"><div class="col-md-12 col-sm-12 col-lg-12" style="padding: 14px 10px 14px 10px!important"><div class="col-md-12 col-sm-12 col-lg-12 pad-0" style="line-height: 34px"><h4 class="rightPanel-title mar-top-0">\u6761\u5F62\u7801\u5C3A\u5BF8</h4><div class="col-md-7 col-sm-7 col-md-7 text-center rightPanel-input"><div class="col-md-8 col-sm-8 col-md-8 text-center temp-mm pad-0"><input type="number" class="no-appearance" placeholder="\u5BBD\u5EA6" ng-change="updateBarParameter()" max="" min="2" onkeyup="this.value= this.value.match(/\\d+(\\.\\d{0,2})?/) ? this.value.match(/\\d+(\\.\\d{0,2})?/)[0] : \'\'" ng-model-options="{debounce:500}" ng-model="pageValue.barcode.width"></div><div class="col-md-4 col-sm-4 col-lg-4 text-center pad-0 color-A6" ng-class="{\'dark-theme-color\':darkTheme==true}"><div class="input-line"></div>\u5BBD</div></div><div class="col-md-1 col-sm-1 col-lg-1 pad-0"></div><div class="col-md-4 col-sm-4 col-lg-4 pad-0"><select ng-model="vm.unit" ng-options="unit.id as unit.name for unit in vm.units" ng-change="unitConversion()" class="form-control fontSel rightPanel-input"></select></div></div><div class="col-md-12 col-sm-12 col-lg-12 mar-top-20 pad-0" style="line-height: 34px"><div class="col-md-7 col-sm-7 col-md-7 text-center rightPanel-input"><div class="col-md-8 col-sm-8 col-md-8 text-center temp-mm pad-0"><input type="number" class="no-appearance" placeholder="\u9AD8\u5EA6" ng-change="updateBarParameter()" max="" min="2" onkeyup="this.value= this.value.match(/\\d+(\\.\\d{0,2})?/) ? this.value.match(/\\d+(\\.\\d{0,2})?/)[0] : \'\'" ng-model-options="{debounce:500}" ng-model="pageValue.barcode.height"></div><div class="col-md-4 col-sm-4 col-lg-4 text-center pad-0 color-A6" ng-class="{\'dark-theme-color\':darkTheme==true}"><div class="input-line"></div>\u9AD8</div></div><div class="col-md-1 col-sm-1 col-lg-1 pad-0"></div><div class="col-md-4 col-sm-4 col-lg-4 pad-0"><select ng-model="vm.unit" ng-options="unit.id as unit.name for unit in vm.units" ng-change="unitConversion()" class="form-control fontSel rightPanel-input"></select></div></div><div class="col-md-12 col-sm-12 col-lg-12 mar-top-20 pad-0" style="line-height: 34px;border-top:1px solid #DADADA"><h4 class="rightPanel-title">\u5750\u6807\u5C3A\u5BF8</h4><div class="col-md-7 col-sm-7 col-md-7 text-center rightPanel-input"><div class="col-md-8 col-sm-8 col-md-8 text-center pad-0"><input type="number" class="no-appearance" placeholder="offset X" ng-change="updateBarParameter()" max="" min="0" onkeyup="this.value= this.value.match(/\\d+(\\.\\d{0,2})?/) ? this.value.match(/\\d+(\\.\\d{0,2})?/)[0] : \'\'" ng-model-options="{debounce:500}" ng-model="pageValue.barcode.x"></div><div class="col-md-4 col-sm-4 col-lg-4 text-center pad-0 color-A6" ng-class="{\'dark-theme-color\':darkTheme==true}"><div class="input-line"></div>x\u8F74</div></div><div class="col-md-1 col-sm-1 col-lg-1 pad-0"></div><div class="col-md-4 col-sm-4 col-lg-4 pad-0"><select ng-model="vm.unit" ng-options="unit.id as unit.name for unit in vm.units" ng-change="unitConversion()" class="form-control fontSel rightPanel-input"></select></div></div><div class="col-md-12 col-sm-12 col-lg-12 mar-top-20 pad-0" style="line-height: 34px"><div class="col-md-7 col-sm-7 col-md-7 text-center rightPanel-input"><div class="col-md-8 col-sm-8 col-md-8 text-center pad-0"><input type="number" class="no-appearance" placeholder="offset Y" ng-change="updateBarParameter()" max="" min="0" onkeyup="this.value= this.value.match(/\\d+(\\.\\d{0,2})?/) ? this.value.match(/\\d+(\\.\\d{0,2})?/)[0] : \'\'" ng-model-options="{debounce:500}" ng-model="pageValue.barcode.y"></div><div class="col-md-4 col-sm-4 col-lg-4 text-center pad-0 color-A6" ng-class="{\'dark-theme-color\':darkTheme==true}"><div class="input-line"></div>y\u8F74</div></div><div class="col-md-1 col-sm-1 col-lg-1 pad-0"></div><div class="col-md-4 col-sm-4 col-lg-4 pad-0"><select ng-model="vm.unit" ng-options="unit.id as unit.name for unit in vm.units" ng-change="unitConversion()" class="form-control fontSel rightPanel-input"></select></div></div><div class="col-md-12 col-sm-12 col-lg-12 mar-top-20 pad-0" style="line-height: 34px;border-top:1px solid #DADADA"><h4 class="rightPanel-title">\u65CB\u8F6C\u89D2\u5EA6</h4><div class="col-md-12 col-sm-12 col-lg-12 text-center rightPanel-input" style="line-height: 34px"><div class="col-md-8 col-sm-8 col-lg-8 text-left pad-0"><input type="number" class="no-appearance" placeholder="\u89D2\u5EA6" ng-change="updateRotate()" max="" min="0" ng-model-options="{debounce:500}" ng-model="template.angle"></div><div class="col-md-4 col-sm-4 col-lg-4 text-center pad-0 color-A6" ng-class="{\'dark-theme-color\':darkTheme==true}"><div class="input-line"></div>\uFF08\u5EA6\uFF09</div></div></div></div></div><div ng-show="RightPanel == \'qrcode\'"><div class="col-md-12 col-sm-12 col-lg-12" style="padding: 14px 10px 14px 10px!important"><div class="col-md-12 col-sm-12 col-lg-12 pad-0" style="line-height: 34px"><h4 class="rightPanel-title mar-top-0">\u4E8C\u7EF4\u7801\u5C3A\u5BF8</h4><div class="col-md-7 col-sm-7 col-md-7 text-center rightPanel-input"><div class="col-md-8 col-sm-8 col-md-8 text-center pad-0"><input type="number" class="no-appearance" placeholder="\u5BBD\u5EA6" ng-change="updateQrcodeParameter(\'width\')" max="" min="0" onkeyup="this.value= this.value.match(/\\d+(\\.\\d{0,2})?/) ? this.value.match(/\\d+(\\.\\d{0,2})?/)[0] : \'\'" ng-model-options="{debounce:500}" ng-model="pageValue.qrcode.width"></div><div class="col-md-4 col-sm-4 col-lg-4 text-center pad-0 color-A6" ng-class="{\'dark-theme-color\':darkTheme==true}"><div class="input-line"></div>\u5BBD</div></div><div class="col-md-1 col-sm-1 col-lg-1 pad-0"></div><div class="col-md-4 col-sm-4 col-lg-4 pad-0"><select ng-model="vm.unit" ng-options="unit.id as unit.name for unit in vm.units" ng-change="unitConversion()" class="form-control fontSel rightPanel-input"></select></div></div><div class="col-md-12 col-sm-12 col-lg-12 mar-top-20 pad-0" style="line-height: 34px"><div class="col-md-7 col-sm-7 col-md-7 text-center rightPanel-input"><div class="col-md-8 col-sm-8 col-md-8 text-center pad-0"><input type="number" class="no-appearance" placeholder="\u9AD8\u5EA6" ng-change="updateQrcodeParameter(\'height\')" max="" min="0" onkeyup="this.value= this.value.match(/\\d+(\\.\\d{0,2})?/) ? this.value.match(/\\d+(\\.\\d{0,2})?/)[0] : \'\'" ng-model-options="{debounce:500}" ng-model="pageValue.qrcode.height"></div><div class="col-md-4 col-sm-4 col-lg-4 text-center pad-0 color-A6" ng-class="{\'dark-theme-color\':darkTheme==true}"><div class="input-line"></div>\u9AD8</div></div><div class="col-md-1 col-sm-1 col-lg-1 pad-0"></div><div class="col-md-4 col-sm-4 col-lg-4 pad-0"><select ng-model="vm.unit" ng-options="unit.id as unit.name for unit in vm.units" ng-change="unitConversion()" class="form-control fontSel rightPanel-input"></select></div></div><div class="col-md-12 col-sm-12 col-lg-12 mar-top-20 pad-0" style="line-height: 34px;border-top:1px solid #DADADA"><h4 class="rightPanel-title">\u5750\u6807\u5C3A\u5BF8</h4><div class="col-md-7 col-sm-7 col-md-7 text-center rightPanel-input"><div class="col-md-8 col-sm-8 col-md-8 text-center pad-0"><input type="number" class="no-appearance" placeholder="offset X" ng-change="updateQrcodeParameter()" max="" min="0" onkeyup="this.value= this.value.match(/\\d+(\\.\\d{0,2})?/) ? this.value.match(/\\d+(\\.\\d{0,2})?/)[0] : \'\'" ng-model-options="{debounce:500}" ng-model="pageValue.qrcode.x"></div><div class="col-md-4 col-sm-4 col-lg-4 text-center pad-0 color-A6" ng-class="{\'dark-theme-color\':darkTheme==true}"><div class="input-line"></div>x\u8F74</div></div><div class="col-md-1 col-sm-1 col-lg-1 pad-0"></div><div class="col-md-4 col-sm-4 col-lg-4 pad-0"><select ng-model="vm.unit" ng-options="unit.id as unit.name for unit in vm.units" ng-change="unitConversion()" class="form-control fontSel rightPanel-input"></select></div></div><div class="col-md-12 col-sm-12 col-lg-12 mar-top-20 pad-0" style="line-height: 34px"><div class="col-md-7 col-sm-7 col-md-7 text-center rightPanel-input"><div class="col-md-8 col-sm-8 col-md-8 text-center pad-0"><input type="number" class="no-appearance" placeholder="offset Y" ng-change="updateQrcodeParameter()" max="" min="0" onkeyup="this.value= this.value.match(/\\d+(\\.\\d{0,2})?/) ? this.value.match(/\\d+(\\.\\d{0,2})?/)[0] : \'\'" ng-model-options="{debounce:500}" ng-model="pageValue.qrcode.y"></div><div class="col-md-4 col-sm-4 col-lg-4 text-center pad-0 color-A6" ng-class="{\'dark-theme-color\':darkTheme==true}"><div class="input-line"></div>y\u8F74</div></div><div class="col-md-1 col-sm-1 col-lg-1 pad-0"></div><div class="col-md-4 col-sm-4 col-lg-4 pad-0"><select ng-model="vm.unit" ng-options="unit.id as unit.name for unit in vm.units" ng-change="unitConversion()" class="form-control fontSel rightPanel-input"></select></div></div><div class="col-md-12 col-sm-12 col-lg-12 mar-top-20 pad-0" style="line-height: 34px;border-top:1px solid #DADADA"><h4 class="rightPanel-title">\u65CB\u8F6C\u89D2\u5EA6</h4><div class="col-md-12 col-sm-12 col-lg-12 text-center rightPanel-input" style="line-height: 34px"><div class="col-md-8 col-sm-8 col-lg-8 text-left pad-0"><input type="number" class="no-appearance" placeholder="\u89D2\u5EA6" ng-change="updateRotate()" max="" min="0" ng-model-options="{debounce:500}" ng-model="template.angle"></div><div class="col-md-4 col-sm-4 col-lg-4 text-center pad-0 color-A6" ng-class="{\'dark-theme-color\':darkTheme==true}"><div class="input-line"></div>\uFF08\u5EA6\uFF09</div></div></div></div></div><div ng-show="RightPanel==\'text\'"><div style="padding: 14px 10px 14px 10px"><div class="col-md-12 col-sm-12 col-lg-12 pad-0" style="line-height: 34px"><h4 class="rightPanel-title mar-top-0">\u6587\u5B57\u5C3A\u5BF8</h4><div class="col-md-7 col-sm-7 col-md-7 text-center rightPanel-input"><div class="col-md-8 col-sm-8 col-md-8 text-center temp-mm pad-0"><input type="number" class="no-appearance" placeholder="\u5BBD\u5EA6" ng-change="updateBoxParameter()" max="" min="2" onkeyup="this.value= this.value.match(/\\d+(\\.\\d{0,2})?/) ? this.value.match(/\\d+(\\.\\d{0,2})?/)[0] : \'\'" ng-model-options="{debounce:500}" ng-model="pageValue.textbox.width"></div><div class="col-md-4 col-sm-4 col-lg-4 text-center pad-0 color-A6" ng-class="{\'dark-theme-color\':darkTheme==true}"><div class="input-line"></div>\u5BBD</div></div><div class="col-md-1 col-sm-1 col-lg-1 pad-0"></div><div class="col-md-4 col-sm-4 col-lg-4 pad-0"><select ng-model="vm.unit" ng-options="unit.id as unit.name for unit in vm.units" ng-change="unitConversion()" class="form-control fontSel rightPanel-input"></select></div></div><div class="col-md-12 col-sm-12 col-lg-12 mar-top-20 pad-0" style="line-height: 34px;border-top:1px solid #DADADA"><h4 class="rightPanel-title">\u5750\u6807\u5C3A\u5BF8</h4><div class="col-md-7 col-sm-7 col-md-7 text-center rightPanel-input"><div class="col-md-8 col-sm-8 col-md-8 text-center temp-mm pad-0"><input type="number" class="no-appearance" placeholder="offset X" ng-change="updateBoxParameter(\'x\',\'offsetXM\')" max="" min="0" onkeyup="this.value= this.value.match(/\\d+(\\.\\d{0,2})?/) ? this.value.match(/\\d+(\\.\\d{0,2})?/)[0] : \'\'" ng-model-options="{debounce:500}" ng-model="pageValue.textbox.x"></div><div class="col-md-4 col-sm-4 col-lg-4 text-center pad-0 color-A6" ng-class="{\'dark-theme-color\':darkTheme==true}"><div class="input-line"></div>x\u8F74</div></div><div class="col-md-1 col-sm-1 col-lg-1 pad-0"></div><div class="col-md-4 col-sm-4 col-lg-4 pad-0"><select ng-model="vm.unit" ng-options="unit.id as unit.name for unit in vm.units" ng-change="unitConversion()" class="form-control fontSel rightPanel-input"></select></div></div><div class="col-md-12 col-sm-12 col-lg-12 mar-top-20 pad-0" style="line-height: 34px"><div class="col-md-7 col-sm-7 col-md-7 text-center rightPanel-input"><div class="col-md-8 col-sm-8 col-md-8 text-center temp-mm pad-0"><input type="number" class="no-appearance" placeholder="offset Y" ng-change="updateBoxParameter(\'y\',\'offsetYM\')" max="" min="0" onkeyup="this.value= this.value.match(/\\d+(\\.\\d{0,2})?/) ? this.value.match(/\\d+(\\.\\d{0,2})?/)[0] : \'\'" ng-model-options="{debounce:500}" ng-model="pageValue.textbox.y"></div><div class="col-md-4 col-sm-4 col-lg-4 text-center pad-0 color-A6" ng-class="{\'dark-theme-color\':darkTheme==true}"><div class="input-line"></div>y\u8F74</div></div><div class="col-md-1 col-sm-1 col-lg-1 pad-0"></div><div class="col-md-4 col-sm-4 col-lg-4 pad-0"><select ng-model="vm.unit" ng-options="unit.id as unit.name for unit in vm.units" ng-change="unitConversion()" class="form-control fontSel rightPanel-input"></select></div></div><div class="col-md-12 col-sm-12 col-lg-12 mar-top-20 pad-0" style="line-height: 34px;border-top:1px solid #DADADA"><h4 class="rightPanel-title">\u65CB\u8F6C\u89D2\u5EA6</h4><div class="col-md-12 col-sm-12 col-lg-12 text-center rightPanel-input" style="line-height: 34px"><div class="col-md-8 col-sm-8 col-lg-8 text-left pad-0"><input type="number" class="no-appearance" placeholder="\u89D2\u5EA6" ng-change="updateRotate()" max="" min="0" ng-model-options="{debounce:500}" ng-model="template.angle"></div><div class="col-md-4 col-sm-4 col-lg-4 text-center pad-0 color-A6" ng-class="{\'dark-theme-color\':darkTheme==true}"><div class="input-line"></div>\uFF08\u5EA6\uFF09</div></div></div><div class="col-md-12 col-sm-12 col-lg-12 mar-top-20 pad-0" style="line-height: 34px;border-top:1px solid #DADADA"><h4 class="rightPanel-title">\u6587\u5B57\u8BBE\u7F6E</h4><div class="col-md-12 col-sm-12 col-md-12 text-left pad-0 rightPanel-btn"><button class="button-b col-md-6 col-sm-6 col-md-6 pad-0" ng-click="editableSel(\'textbox\',true)" ng-class="{\'buttonA\':currentPage.levels.level[template.levelI].textbox.editable}">\u53EF\u7F16\u8F91</button> <button class="button-i col-md-6 col-sm-6 col-md-6 pad-0" ng-click="editableSel(\'textbox\',false)" ng-class="{\'buttonA\': !currentPage.levels.level[template.levelI].textbox.editable}">\u4E0D\u53EF\u7F16\u8F91</button></div><div class="col-md-12 col-sm-12 col-md-12 text-left pad-0 rightPanel-btn mar-top-20"><button class="button-b col-md-6 col-sm-6 col-md-6 pad-0" ng-click="movableSel(\'textbox\',true)" ng-class="{\'buttonA\':currentPage.levels.level[template.levelI].textbox.movable}">\u53EF\u79FB\u52A8</button> <button class="button-i col-md-6 col-sm-6 col-md-6 pad-0" ng-click="movableSel(\'textbox\',false)" ng-class="{\'buttonA\': !currentPage.levels.level[template.levelI].textbox.movable}">\u4E0D\u53EF\u79FB\u52A8</button></div></div><div class="col-md-12 col-sm-12 col-lg-12 mar-top-20 pad-0" style="line-height: 34px;border-top:1px solid #DADADA"><h4 class="rightPanel-title">\u6587\u5B57\u5185\u5BB9</h4><div class="c-xml-attribute-body-module-form"><textarea class="c-textarea1" ng-model="vm.text" style="width: 90%"></textarea></div></div><div class="col-md-12 col-sm-12 col-lg-12 pad-0" ng-if="selectBox.current == \'imagebox\'||selectBox.current == \'textbox\'"><div class="col-md-12 col-sm-12 col-lg-12 pad-0"><h4 class="rightPanel-title">\u662F\u5426\u8BBE\u4E3A\u53EF\u53D8\u6570\u636E</h4><div class="col-md-12 col-sm-12 col-md-12 text-left pad-0 rightPanel-btn"><button class="button-b col-md-6 col-sm-6 col-md-6 pad-0" ng-click="setVariable(1)" ng-class="{\'buttonA\':currentPage.levels.level[template.levelI].variable==true}">\u662F</button> <button class="button-i col-md-6 col-sm-6 col-md-6 pad-0" ng-click="setVariable(0)" ng-class="{\'buttonA\': currentPage.levels.level[template.levelI].variable==false}">\u5426</button></div></div><div class="col-md-12 col-sm-12 col-lg-12 pad-0" style="line-height: 34px"><h4 class="rightPanel-title">\u6570\u636E\u540D\u79F0</h4><div class="c-xml-attribute-body-module-form"><textarea class="c-textarea1" ng-model="currentPage.levels.level[template.levelI].name" style="width: 90%" placeholder="\u8BF7\u8F93\u5165\u6570\u636E\u540D\u79F0"></textarea></div></div></div></div></div><div ng-show="RightPanel==\'textDoc\'"><div style="padding: 14px 10px 14px 10px"><div class="col-md-12 col-sm-12 col-lg-12 pad-0" style="line-height: 34px"><h4 class="rightPanel-title mar-top-0">\u6587\u5B57\u6A21\u677F\u5C3A\u5BF8</h4><div class="col-md-7 col-sm-7 col-md-7 text-center rightPanel-input"><div class="col-md-8 col-sm-8 col-md-8 text-center temp-mm pad-0"><input type="number" class="no-appearance" placeholder="\u5BBD\u5EA6" ng-change="updatetextDocParameter(\'width\')" max="" min="2" onkeyup="this.value= this.value.match(/\\d+(\\.\\d{0,2})?/) ? this.value.match(/\\d+(\\.\\d{0,2})?/)[0] : \'\'" ng-model-options="{debounce:500}" ng-model="pageValue.textdocument.width"></div><div class="col-md-4 col-sm-4 col-lg-4 text-center pad-0 color-A6" ng-class="{\'dark-theme-color\':darkTheme==true}"><div class="input-line"></div>\u5BBD</div></div><div class="col-md-1 col-sm-1 col-lg-1 pad-0"></div><div class="col-md-4 col-sm-4 col-lg-4 pad-0"><select ng-model="vm.unit" ng-options="unit.id as unit.name for unit in vm.units" ng-change="unitConversion()" class="form-control fontSel rightPanel-input"></select></div></div><div class="col-md-12 col-sm-12 col-lg-12 mar-top-20 pad-0" style="line-height: 34px"><div class="col-md-7 col-sm-7 col-md-7 text-center rightPanel-input"><div class="col-md-8 col-sm-8 col-md-8 text-center pad-0"><input type="number" class="no-appearance" placeholder="\u9AD8\u5EA6" ng-change="updatetextDocParameter(\'height\')" max="" min="2" onkeyup="this.value= this.value.match(/\\d+(\\.\\d{0,2})?/) ? this.value.match(/\\d+(\\.\\d{0,2})?/)[0] : \'\'" ng-model-options="{debounce:500}" ng-model="pageValue.textdocument.height"></div><div class="col-md-4 col-sm-4 col-lg-4 text-center pad-0 color-A6" ng-class="{\'dark-theme-color\':darkTheme==true}"><div class="input-line"></div>\u9AD8</div></div><div class="col-md-1 col-sm-1 col-lg-1 pad-0"></div><div class="col-md-4 col-sm-4 col-lg-4 pad-0"><select ng-model="vm.unit" ng-options="unit.id as unit.name for unit in vm.units" ng-change="unitConversion()" class="form-control fontSel rightPanel-input"></select></div></div><div class="col-md-12 col-sm-12 col-lg-12 mar-top-20 pad-0" style="line-height: 34px;border-top:1px solid #DADADA"><h4 class="rightPanel-title">\u5750\u6807\u5C3A\u5BF8</h4><div class="col-md-7 col-sm-7 col-md-7 text-center rightPanel-input"><div class="col-md-8 col-sm-8 col-md-8 text-center pad-0"><input type="number" class="no-appearance" placeholder="offset X" ng-change="updateBoxParameter(\'x\')" max="" min="0" onkeyup="this.value= this.value.match(/\\d+(\\.\\d{0,2})?/) ? this.value.match(/\\d+(\\.\\d{0,2})?/)[0] : \'\'" ng-model-options="{debounce:500}" ng-model="pageValue.textdocument.x"></div><div class="col-md-4 col-sm-4 col-lg-4 text-center pad-0 color-A6" ng-class="{\'dark-theme-color\':darkTheme==true}"><div class="input-line"></div>x\u8F74</div></div><div class="col-md-1 col-sm-1 col-lg-1 pad-0"></div><div class="col-md-4 col-sm-4 col-lg-4 pad-0"><select ng-model="vm.unit" ng-options="unit.id as unit.name for unit in vm.units" ng-change="unitConversion()" class="form-control fontSel rightPanel-input"></select></div></div><div class="col-md-12 col-sm-12 col-lg-12 mar-top-20 pad-0" style="line-height: 34px"><div class="col-md-7 col-sm-7 col-md-7 text-center rightPanel-input"><div class="col-md-8 col-sm-8 col-md-8 text-center pad-0"><input type="number" class="no-appearance" placeholder="offset Y" ng-change="updateBoxParameter(\'y\')" max="" min="0" onkeyup="this.value= this.value.match(/\\d+(\\.\\d{0,2})?/) ? this.value.match(/\\d+(\\.\\d{0,2})?/)[0] : \'\'" ng-model-options="{debounce:500}" ng-model="pageValue.textdocument.y"></div><div class="col-md-4 col-sm-4 col-lg-4 text-center pad-0 color-A6" ng-class="{\'dark-theme-color\':darkTheme==true}"><div class="input-line"></div>y\u8F74</div></div><div class="col-md-1 col-sm-1 col-lg-1 pad-0"></div><div class="col-md-4 col-sm-4 col-lg-4 pad-0"><select ng-model="vm.unit" ng-options="unit.id as unit.name for unit in vm.units" ng-change="unitConversion()" class="form-control fontSel rightPanel-input"></select></div></div><div class="col-md-12 col-sm-12 col-lg-12 mar-top-20 pad-0" style="line-height: 34px;border-top:1px solid #DADADA"><h4 class="rightPanel-title">\u65CB\u8F6C\u89D2\u5EA6</h4><div class="col-md-12 col-sm-12 col-lg-12 text-center rightPanel-input" style="line-height: 34px"><div class="col-md-8 col-sm-8 col-lg-8 text-left pad-0"><input type="number" class="no-appearance" placeholder="\u89D2\u5EA6" ng-change="updateRotate()" max="" min="0" ng-model-options="{debounce:500}" ng-model="template.angle"></div><div class="col-md-4 col-sm-4 col-lg-4 text-center pad-0 color-A6" ng-class="{\'dark-theme-color\':darkTheme==true}"><div class="input-line"></div>\uFF08\u5EA6\uFF09</div></div></div><div class="col-md-12 col-sm-12 col-lg-12 mar-top-20 pad-0" style="line-height: 34px;border-top:1px solid #DADADA"><h4 class="rightPanel-title">\u6587\u5B57\u6A21\u677F\u8BBE\u7F6E</h4><div class="col-md-12 col-sm-12 col-md-12 text-left pad-0 rightPanel-btn"><button class="button-b col-md-6 col-sm-6 col-md-6 pad-0" ng-click="editableSel(\'textdocument\',true)" ng-class="{\'buttonA\':currentPage.levels.level[template.levelI].textdocument.editable}">\u53EF\u7F16\u8F91</button> <button class="button-i col-md-6 col-sm-6 col-md-6 pad-0" ng-click="editableSel(\'textdocument\',false)" ng-class="{\'buttonA\': !currentPage.levels.level[template.levelI].textdocument.editable}">\u4E0D\u53EF\u7F16\u8F91</button></div><div class="col-md-12 col-sm-12 col-md-12 text-left pad-0 rightPanel-btn mar-top-20"><button class="button-b col-md-6 col-sm-6 col-md-6 pad-0" ng-click="movableSel(\'textdocument\',true)" ng-class="{\'buttonA\':currentPage.levels.level[template.levelI].textdocument.movable}">\u53EF\u79FB\u52A8</button> <button class="button-i col-md-6 col-sm-6 col-md-6 pad-0" ng-click="movableSel(\'textdocument\',false)" ng-class="{\'buttonA\': !currentPage.levels.level[template.levelI].textdocument.movable}">\u4E0D\u53EF\u79FB\u52A8</button></div></div><div class="col-md-12 col-sm-12 col-lg-12 mar-top-20 pad-0" style="line-height: 34px;border-top:1px solid #DADADA"><h4 class="rightPanel-title">\u6587\u5B57\u5185\u5BB9</h4><div class="c-xml-attribute-body-module-form"><textarea class="c-textarea1" ng-model="vm.textDocCon" style="width: 90%"></textarea></div></div></div></div><div ng-show="RightPanel==\'mask\'||RightPanel==\'placement\'"><div style="padding: 14px 10px 14px 10px"><div class="col-md-12 col-sm-12 col-lg-12 pad-0" style="line-height: 34px"><h4 class="rightPanel-title mar-top-0">\u8499\u7248\u5C3A\u5BF8</h4><div class="col-md-7 col-sm-7 col-md-7 text-center rightPanel-input"><div class="col-md-8 col-sm-8 col-md-8 text-center pad-0"><input type="number" class="no-appearance" placeholder="\u5BBD\u5EA6" ng-change="updateBoxParameter()" max="" min="2" onkeyup="this.value= this.value.match(/\\d+(\\.\\d{0,2})?/) ? this.value.match(/\\d+(\\.\\d{0,2})?/)[0] : \'\'" ng-model-options="{debounce:500}" ng-model="pageValue.imagebox.width"></div><div class="col-md-4 col-sm-4 col-lg-4 text-center pad-0 color-A6" ng-class="{\'dark-theme-color\':darkTheme==true}"><div class="input-line"></div>\u5BBD</div></div><div class="col-md-1 col-sm-1 col-lg-1 pad-0"></div><div class="col-md-4 col-sm-4 col-lg-4 pad-0"><select ng-model="vm.unit" ng-options="unit.id as unit.name for unit in vm.units" ng-change="unitConversion()" class="form-control fontSel rightPanel-input"></select></div></div><div class="col-md-12 col-sm-12 col-lg-12 mar-top-20 pad-0" style="line-height: 34px"><div class="col-md-7 col-sm-7 col-md-7 text-center rightPanel-input"><div class="col-md-8 col-sm-8 col-md-8 text-center pad-0"><input type="number" class="no-appearance" placeholder="\u9AD8\u5EA6" ng-change="updateBoxParameter()" max="" min="2" onkeyup="this.value= this.value.match(/\\d+(\\.\\d{0,2})?/) ? this.value.match(/\\d+(\\.\\d{0,2})?/)[0] : \'\'" ng-model-options="{debounce:500}" ng-model="pageValue.imagebox.height"></div><div class="col-md-4 col-sm-4 col-lg-4 text-center pad-0 color-A6" ng-class="{\'dark-theme-color\':darkTheme==true}"><div class="input-line"></div>\u9AD8</div></div><div class="col-md-1 col-sm-1 col-lg-1 pad-0"></div><div class="col-md-4 col-sm-4 col-lg-4 pad-0"><select ng-model="vm.unit" ng-options="unit.id as unit.name for unit in vm.units" ng-change="unitConversion()" class="form-control fontSel rightPanel-input"></select></div></div><div class="col-md-12 col-sm-12 col-lg-12 mar-top-20 pad-0" style="line-height: 34px;border-top:1px solid #DADADA"><h4 class="rightPanel-title">\u5750\u6807\u5C3A\u5BF8</h4><div class="col-md-7 col-sm-7 col-md-7 text-center rightPanel-input"><div class="col-md-8 col-sm-8 col-md-8 text-center pad-0"><input type="number" class="no-appearance" placeholder="offset X" ng-change="updateBoxParameter()" max="" min="0" onkeyup="this.value= this.value.match(/\\d+(\\.\\d{0,2})?/) ? this.value.match(/\\d+(\\.\\d{0,2})?/)[0] : \'\'" ng-model-options="{debounce:500}" ng-model="pageValue.imagebox.x"></div><div class="col-md-4 col-sm-4 col-lg-4 text-center pad-0 color-A6" ng-class="{\'dark-theme-color\':darkTheme==true}"><div class="input-line"></div>x\u8F74</div></div><div class="col-md-1 col-sm-1 col-lg-1 pad-0"></div><div class="col-md-4 col-sm-4 col-lg-4 pad-0"><select ng-model="vm.unit" ng-options="unit.id as unit.name for unit in vm.units" ng-change="unitConversion()" class="form-control fontSel rightPanel-input"></select></div></div><div class="col-md-12 col-sm-12 col-lg-12 mar-top-20 pad-0" style="line-height: 34px"><div class="col-md-7 col-sm-7 col-md-7 text-center rightPanel-input"><div class="col-md-8 col-sm-8 col-md-8 text-center pad-0"><input type="number" class="no-appearance" placeholder="offset Y" ng-change="updateBoxParameter()" max="" min="0" onkeyup="this.value= this.value.match(/\\d+(\\.\\d{0,2})?/) ? this.value.match(/\\d+(\\.\\d{0,2})?/)[0] : \'\'" ng-model-options="{debounce:500}" ng-model="pageValue.imagebox.y"></div><div class="col-md-4 col-sm-4 col-lg-4 text-center pad-0 color-A6" ng-class="{\'dark-theme-color\':darkTheme==true}"><div class="input-line"></div>y\u8F74</div></div><div class="col-md-1 col-sm-1 col-lg-1 pad-0"></div><div class="col-md-4 col-sm-4 col-lg-4 pad-0"><select ng-model="vm.unit" ng-options="unit.id as unit.name for unit in vm.units" ng-change="unitConversion()" class="form-control fontSel rightPanel-input"></select></div></div><div class="col-md-12 col-sm-12 col-lg-12 mar-top-20 pad-0" style="line-height: 34px;border-top:1px solid #DADADA"><h4 class="rightPanel-title">\u65CB\u8F6C\u89D2\u5EA6</h4><div class="col-md-12 col-sm-12 col-lg-12 text-center rightPanel-input" style="line-height: 34px"><div class="col-md-8 col-sm-8 col-lg-8 text-left pad-0"><input type="number" class="no-appearance" placeholder="\u89D2\u5EA6" ng-change="updateRotate()" max="" min="0" ng-model-options="{debounce:500}" ng-model="template.angle"></div><div class="col-md-4 col-sm-4 col-lg-4 text-center pad-0 color-A6" ng-class="{\'dark-theme-color\':darkTheme==true}"><div class="input-line"></div>\uFF08\u5EA6\uFF09</div></div></div><div class="col-md-12 col-sm-12 col-lg-12 mar-top-20 pad-0" style="border-top:1px solid #DADADA" ng-if="selectBox.border && (selectBox.border.shape == \'Rectangle\' || selectBox.border.type == \'Pic\')"><h4 class="rightPanel-title">\u5706\u89D2\u8BBE\u7F6E</h4><div><div class="c-schedule-view"><span class="c-schedule-title">\u5DE6\u4E0A\uFF1A</span> <input type="range" min="0" max="50" step="1" value="{{selectBox.border.radius.lt}}" ng-model="selectBox.border.radius.lt" ng-change="borderRadius()" class="text-range" style="width: 100% !important"></div><div class="c-schedule-view"><span class="c-schedule-title">\u53F3\u4E0A\uFF1A</span> <input type="range" min="0" max="50" step="1" value="{{selectBox.border.radius.rt}}" ng-model="selectBox.border.radius.rt" ng-change="borderRadius()" class="text-range" style="width: 100% !important"></div><div class="c-schedule-view"><span class="c-schedule-title">\u53F3\u4E0B\uFF1A</span> <input type="range" min="0" max="50" step="1" value="{{selectBox.border.radius.rb}}" ng-model="selectBox.border.radius.rb" ng-change="borderRadius()" class="text-range" style="width: 100% !important"></div><div class="c-schedule-view"><span class="c-schedule-title">\u5DE6\u4E0B\uFF1A</span> <input type="range" min="0" max="50" step="1" value="{{selectBox.border.radius.lb}}" ng-model="selectBox.border.radius.lb" ng-change="borderRadius()" class="text-range" style="width: 100% !important"></div></div></div><div class="col-md-12 col-sm-12 col-lg-12 mar-top-20 pad-0" style="border-top:1px solid #DADADA" ng-if="selectBox.border && selectBox.border.type == \'Color\'"><h4 class="rightPanel-title">\u8FB9\u6846\u8BBE\u7F6E</h4><div class="bezel-set"><div class="bezel-set-color" ng-style="{background:template.pages.page[template.pageI].levels.level[template.levelI].imagebox.border.color}"><input type="color" ng-value="template.pages.page[template.pageI].levels.level[template.levelI].imagebox.border.color" ng-model="template.pages.page[template.pageI].levels.level[template.levelI].imagebox.border.color"></div><input type="number" class="c-input1" style="width: 60px; height: 30px; border: 1px solid #ddd; margin: 0 5px" ng-model="template.pages.page[template.pageI].levels.level[template.levelI].imagebox.border.lineWidth"> <span>px</span></div></div><div class="col-md-12 col-sm-12 col-lg-12 mar-top-20 pad-0" style="border-top:1px solid #DADADA" ng-if="selectBox.border && selectBox.border.type == \'Color\'"><h4 class="rightPanel-title">\u8FB9\u6846\u7EBF\u7C7B\u578B</h4><div class="c-font-view" style="width: 170px"><div class="c-font-view-head2"><div ng-show="template.pages.page[template.pageI].levels.level[template.levelI].imagebox.border.lineType == \'solid\'"><img src="content/images/icons/solid.png"></div><div ng-show="template.pages.page[template.pageI].levels.level[template.levelI].imagebox.border.lineType == \'dashed\'"><img src="content/images/icons/dashed.png"></div><div ng-show="template.pages.page[template.pageI].levels.level[template.levelI].imagebox.border.lineType == \'dotted\'"><img src="content/images/icons/dotted.png"></div><img src="content/images/icons/pulldownIcon.png" alt="" style="position: absolute;width: 20px;right: 5px;top: 50%;transform: translateY(-50%)"></div><div class="c-font-view-body" style="box-shadow: 0 0 10px 0 #cfcfcf"><div class="c-font-view-body-ul" style="margin-top: 0"><div class="c-font-view-body-li" ng-click="lineTypeChenge(\'solid\')"><img src="content/images/icons/solid.png"></div><div class="c-font-view-body-li" ng-click="lineTypeChenge(\'dashed\')"><img src="content/images/icons/dashed.png"></div><div class="c-font-view-body-li" ng-click="lineTypeChenge(\'dotted\')"><img src="content/images/icons/dotted.png"></div></div></div></div></div><div class="col-md-12 col-sm-12 col-md-12 mar-top-20 mar-bottom-30 rightPanel-btn" ng-click="delPic()" ng-if="selectBox.image&&selectBox.image.resource&&selectBox.image.resource.identifier" style="line-height: 32px;color: #000;background: #FAC779;height: 32px">\u6E05\u9664\u56FE\u7247</div><div class="col-md-12 col-sm-12 col-lg-12 pad-0" ng-if="selectBox.current == \'imagebox\'||selectBox.current == \'textbox\'"><div class="col-md-12 col-sm-12 col-lg-12 pad-0"><h4 class="rightPanel-title">\u662F\u5426\u8BBE\u4E3A\u53EF\u53D8\u6570\u636E</h4><div class="col-md-12 col-sm-12 col-md-12 text-left pad-0 rightPanel-btn"><button class="button-b col-md-6 col-sm-6 col-md-6 pad-0" ng-click="setVariable(1)" ng-class="{\'buttonA\':currentPage.levels.level[template.levelI].variable==true}">\u662F</button> <button class="button-i col-md-6 col-sm-6 col-md-6 pad-0" ng-click="setVariable(0)" ng-class="{\'buttonA\': currentPage.levels.level[template.levelI].variable==false}">\u5426</button></div></div><div class="col-md-12 col-sm-12 col-lg-12 pad-0" style="line-height: 34px"><h4 class="rightPanel-title">\u6570\u636E\u540D\u79F0</h4><div class="c-xml-attribute-body-module-form"><textarea class="c-textarea1" ng-model="currentPage.levels.level[template.levelI].name" style="width: 90%" placeholder="\u8BF7\u8F93\u5165\u6570\u636E\u540D\u79F0"></textarea></div></div></div></div></div><div ng-show="RightPanel==\'material\'"><div style="padding: 14px 10px 14px 10px"><div class="col-md-12 col-sm-12 col-lg-12 pad-0" style="line-height: 34px"><h4 class="rightPanel-title mar-top-0">\u7D20\u6750\u5C3A\u5BF8</h4><div class="col-md-7 col-sm-7 col-md-7 text-center rightPanel-input"><div class="col-md-8 col-sm-8 col-md-8 text-center pad-0"><input type="number" class="no-appearance" placeholder="\u5BBD\u5EA6" ng-change="updateBoxParameter(\'width\')" max="" min="2" onkeyup="this.value= this.value.match(/\\d+(\\.\\d{0,2})?/) ? this.value.match(/\\d+(\\.\\d{0,2})?/)[0] : \'\'" ng-model-options="{debounce:500}" ng-model="pageValue.imageart.width"></div><div class="col-md-4 col-sm-4 col-lg-4 text-center pad-0 color-A6" ng-class="{\'dark-theme-color\':darkTheme==true}"><div class="input-line"></div>\u5BBD</div></div><div class="col-md-1 col-sm-1 col-lg-1 pad-0"></div><div class="col-md-4 col-sm-4 col-lg-4 pad-0"><select ng-model="vm.unit" ng-options="unit.id as unit.name for unit in vm.units" ng-change="unitConversion()" class="form-control fontSel rightPanel-input"></select></div></div><div class="col-md-12 col-sm-12 col-lg-12 mar-top-20 pad-0" style="line-height: 34px"><div class="col-md-7 col-sm-7 col-md-7 text-center rightPanel-input"><div class="col-md-8 col-sm-8 col-md-8 text-center pad-0"><input type="number" class="no-appearance" placeholder="\u9AD8\u5EA6" ng-change="updateBoxParameter(\'height\')" max="" min="2" onkeyup="this.value= this.value.match(/\\d+(\\.\\d{0,2})?/) ? this.value.match(/\\d+(\\.\\d{0,2})?/)[0] : \'\'" ng-model-options="{debounce:500}" ng-model="pageValue.imageart.height"></div><div class="col-md-4 col-sm-4 col-lg-4 text-center pad-0 color-A6" ng-class="{\'dark-theme-color\':darkTheme==true}"><div class="input-line"></div>\u9AD8</div></div><div class="col-md-1 col-sm-1 col-lg-1 pad-0"></div><div class="col-md-4 col-sm-4 col-lg-4 pad-0"><select ng-model="vm.unit" ng-options="unit.id as unit.name for unit in vm.units" ng-change="unitConversion()" class="form-control fontSel rightPanel-input"></select></div></div><div class="col-md-12 col-sm-12 col-lg-12 mar-top-20 pad-0" style="line-height: 34px;border-top:1px solid #DADADA"><h4 class="rightPanel-title">\u5750\u6807\u5C3A\u5BF8</h4><div class="col-md-7 col-sm-7 col-md-7 text-center rightPanel-input"><div class="col-md-8 col-sm-8 col-md-8 text-center pad-0"><input type="number" class="no-appearance" placeholder="offset X" ng-change="updateBoxParameter(\'x\')" max="" min="0" onkeyup="this.value= this.value.match(/\\d+(\\.\\d{0,2})?/) ? this.value.match(/\\d+(\\.\\d{0,2})?/)[0] : \'\'" ng-model-options="{debounce:500}" ng-model="pageValue.imageart.x"></div><div class="col-md-4 col-sm-4 col-lg-4 text-center pad-0 color-A6" ng-class="{\'dark-theme-color\':darkTheme==true}"><div class="input-line"></div>x\u8F74</div></div><div class="col-md-1 col-sm-1 col-lg-1 pad-0"></div><div class="col-md-4 col-sm-4 col-lg-4 pad-0"><select ng-model="vm.unit" ng-options="unit.id as unit.name for unit in vm.units" ng-change="unitConversion()" class="form-control fontSel rightPanel-input"></select></div></div><div class="col-md-12 col-sm-12 col-lg-12 mar-top-20 pad-0" style="line-height: 34px"><div class="col-md-7 col-sm-7 col-md-7 text-center rightPanel-input"><div class="col-md-8 col-sm-8 col-md-8 text-center pad-0"><input type="number" class="no-appearance" placeholder="offset Y" ng-change="updateBoxParameter(\'y\')" max="" min="0" onkeyup="this.value= this.value.match(/\\d+(\\.\\d{0,2})?/) ? this.value.match(/\\d+(\\.\\d{0,2})?/)[0] : \'\'" ng-model-options="{debounce:500}" ng-model="pageValue.imageart.y"></div><div class="col-md-4 col-sm-4 col-lg-4 text-center pad-0 color-A6" ng-class="{\'dark-theme-color\':darkTheme==true}"><div class="input-line"></div>y\u8F74</div></div><div class="col-md-1 col-sm-1 col-lg-1 pad-0"></div><div class="col-md-4 col-sm-4 col-lg-4 pad-0"><select ng-model="vm.unit" ng-options="unit.id as unit.name for unit in vm.units" ng-change="unitConversion()" class="form-control fontSel rightPanel-input"></select></div></div><div class="col-md-12 col-sm-12 col-lg-12 mar-top-20 pad-0" style="line-height: 34px;border-top:1px solid #DADADA"><h4 class="rightPanel-title">\u65CB\u8F6C\u89D2\u5EA6</h4><div class="col-md-12 col-sm-12 col-lg-12 text-center rightPanel-input" style="line-height: 34px"><div class="col-md-8 col-sm-8 col-lg-8 text-left pad-0"><input type="number" class="no-appearance" placeholder="\u89D2\u5EA6" ng-change="updateRotate()" max="" min="0" ng-model-options="{debounce:500}" ng-model="template.angle"></div><div class="col-md-4 col-sm-4 col-lg-4 text-center pad-0 color-A6" ng-class="{\'dark-theme-color\':darkTheme==true}"><div class="input-line"></div>\uFF08\u5EA6\uFF09</div></div></div><div class="col-md-12 col-sm-12 col-lg-12 mar-top-20 pad-0" style="line-height: 34px;border-top:1px solid #DADADA"><h4 class="rightPanel-title">\u7D20\u6750\u8BBE\u7F6E</h4><div class="col-md-12 col-sm-12 col-md-12 text-left pad-0 rightPanel-btn"><button class="button-b col-md-6 col-sm-6 col-md-6 pad-0" ng-click="editableSel(\'imageart\',true)" ng-class="{\'buttonA\':currentPage.levels.level[template.levelI].imageart.editable}">\u53EF\u7F16\u8F91</button> <button class="button-i col-md-6 col-sm-6 col-md-6 pad-0" ng-click="editableSel(\'imageart\',false)" ng-class="{\'buttonA\': !currentPage.levels.level[template.levelI].imageart.editable}">\u4E0D\u53EF\u7F16\u8F91</button></div><div class="col-md-12 col-sm-12 col-md-12 text-left pad-0 rightPanel-btn mar-top-20"><button class="button-b col-md-6 col-sm-6 col-md-6 pad-0" ng-click="movableSel(\'imageart\',true)" ng-class="{\'buttonA\':currentPage.levels.level[template.levelI].imageart.movable}">\u53EF\u79FB\u52A8</button> <button class="button-i col-md-6 col-sm-6 col-md-6 pad-0" ng-click="movableSel(\'imageart\',false)" ng-class="{\'buttonA\': !currentPage.levels.level[template.levelI].imageart.movable}">\u4E0D\u53EF\u79FB\u52A8</button></div></div></div></div></div></div></div><div class="rightPanel-mainContent-toggle" ng-click="hidePanel(0)"></div><div ng-if="vm.watchSure" class="preview-article"><img src="content/images/preview-bg.jpg" class="preview-bg"> <img class="preview-article-close" src="content/images/icons/close4.svg" width="40px" ng-click="vm.watchSure = false"><div class="preview-article-con"><article-preview page="1" preview-article="vm.previewArticle" domain="vm.url"></article-preview></div></div><!-- 3D\u9884\u89C8 --><div ng-if="vm.threeView" class="preview-article"><img src="content/images/preview-bg.jpg" class="preview-bg"> <img class="preview-article-close" src="content/images/icons/close4.svg" width="40px" ng-click="vm.threeView = false"><div class="preview-article-con1"><three-preview width="700" height="700" style="background: #fff" product-xml="vm.threeProductXmlData" pages="vm.threeTemplate.pages.page"></three-preview></div></div></section></div><div class="moveCanvas-view" ng-mousedown="moveCanvas($event)" ng-if="vm.moveCanvasView" data-html2canvas-ignore></div><div class="c-modal exit-box" style="z-index:9999" ng-if="thumbnailPic"><div class="exit-box-mask"></div><div style="width: 30vw;margin: 30vh auto;min-height: 40vh;background: #fff;border-radius: 5px;position: relative;text-align: center"><div class="col-lg-12 col-sm-12" style="border-bottom: 1px solid #d9d9d9;padding: 16px 0"><span class="col-md-6 col-sm-6 col-xs-6 font-16 text-left">\u7F29\u7565\u56FE</span> <span class="col-md-6 col-sm-6 col-xs-6 text-right"><img src="content/images/icons/close.svg" style="width: 16px" ng-click="modalHide()"></span></div><div class="col-lg-12 col-sm-12"><div class="swiper-container2"><div class="swiper-wrapper"><div class="swiper-slide2" ng-repeat="page in template.pages.page track by $index" ng-if="thumbnailType==\'all\'&&!page.backup"><img ng-src="{{page.pagecover.identifier ? page.pagecover.identifier + vm.pageImageView : \'content/images/default.png\'}}"></div><div class="swiper-slide2" ng-if="thumbnailType==\'one\'"><img ng-src="{{currentPage.pagecover.identifier?currentPage.pagecover.identifier  + vm.pageImageView : \'content/images/default.png\'}}"></div></div></div><!-- Add Arrows --><div class="swiper-pagination2"></div><div ng-if="thumbnailType==\'all\'"><div class="swiper-button-next2"></div><div class="swiper-button-prev2"></div></div></div><!--<div class="col-lg-12 col-sm-12">--><!--<button class="c-modal-btn c-modal-btn-hide" ng-click="modalHide()">\u5173\u95ED</button>--><!--</div>--></div></div><div class="c-modal exit-box" style="z-index:9999" ng-if="vm.exitSure"><div class="exit-box-mask"></div><div class="exit-box-con"><div class="col-lg-12 col-sm-12 exit-box-con-head"><span class="col-md-6 col-sm-6 col-xs-6 font-16 text-left">\u63D0\u793A</span> <span class="col-md-6 col-sm-6 col-xs-6 text-right"><img src="content/images/icons/close.svg" style="width: 16px" ng-click="vm.exitSure = false"></span></div><div class="col-lg-12 col-sm-12" style="height: 100px;line-height: 100px;font-size: 16px;font-weight: bold;background: #fff">\u786E\u8BA4\u8981\u9000\u51FA\u5417\uFF1F</div><div class="col-lg-12 col-sm-12 pad-0" style="border-top:1px solid #dfdfdf"><button class="col-lg-6 col-sm-6 pad-0 back-btn1" ng-click="vm.exitSure = false">\u53D6\u6D88</button> <button class="col-lg-6 col-sm-6 pad-0 back-btn2" ng-click="exitPage()">\u786E\u5B9A</button></div></div></div><style>.c-modal-btn{\n        width: 120px;\n        height: 40px;\n        line-height: 40px;\n        border-radius: 4px;\n        text-align: center;\n    }\n    .c-modal-btn-hide{\n        color: #232323;\n        background: #fff;\n        border: 1px solid #ddd;\n    }\n    .swiper-container2 {\n        width: 20vw;\n        height: 22vh;\n        margin: 10px auto 30px;\n    }\n    .swiper-button-next2{\n        position: absolute;\n        right: 40px;\n        outline: none;\n    }\n    .swiper-pagination2{\n        position: absolute;\n        bottom: 10px;\n        width: 100%;\n    }\n    .swiper-button-prev2{\n        position: absolute;\n        left: 40px;\n        outline: none;\n    }\n    .swiper-slide2 {\n        text-align: center;\n        font-size: 18px;\n        background: #fff;\n        line-height: 22vh;\n    }\n    .swiper-slide2 img{\n        max-width: 100%;\n        max-height: 100%;\n        box-shadow: 0 2px 5px rgba(187, 187, 187, 0.6);\n    }</style>');
$templateCache.put('app/entities/page/purchased-template.html','<div class="share-content"><div class="back-view"><div class="back-link" ng-click="backToTemp()"><i class="iconfont icon-left"></i>\u8FD4\u56DE\u6A21\u677F\u4E2D\u5FC3</div></div><div class="share-head"><div class="share-title">\u6211\u8D2D\u4E70\u7684\u6A21\u677F</div></div><div class="template-list"><div class="empty-view" ng-if="vm.productList.length < 1"><img class="empty-img" src="content/images/page-empty.png" alt="\u65E0\u6570\u636E"><div class="empty-text">\u6682\u65E0\u5185\u5BB9</div></div><div class="template-item" ng-repeat="template in vm.productList track by template.id"><div class="img-view"><div class="cover-view"><img class="cover-img" alt="\u56FE\u7247\u7F3A\u5931" ng-if="vm.domainQ && template.cover" ng-src="{{vm.domainQ + template.cover +\'?imageView2\'}}" err-src="content/images/default-cover.png" ng-click="template.show=!template.show"> <img class="cover-img" ng-if="!vm.domainQ || !template.cover" src="content/images/default-cover.png"><div class="buy-tag" ng-if="template.purchased">\u5DF2\u8D2D\u4E70</div><!-- <div class="personal-tag">\u4E2A\u4EBA</div> --></div><div class="shade-view"><div class="preview-btn" ng-click="previewTemplate(template)"><i class="iconfont icon-yulan"></i></div><div class="temp-btn" ng-click="useTemp(template)">\u4F7F\u7528</div></div></div><div class="template-info"><div class="template-name">{{template.name}}</div><div class="info-list"><div class="item" ng-if="template.productType">{{template.productType}}</div><div class="item">{{template.pageSizeW}}*{{template.pageSizeH}}</div><div class="item">{{template.pageCount}}P</div><div class="item">{{template.picQuantity}}\u5F20</div></div><div class="tags-view" ng-class="{\'one\' : template.hashtags.split(\',\').length === 1,\'two\' : template.hashtags.split(\',\').length === 2, \'three\' : template.hashtags.split(\',\').length >=3}"><div class="tag" ng-repeat="tag in template.hashtags.split(\',\') | limitTo: 3" ng-if="tag">{{ tag }}</div><div class="tag" ng-if="!template.hashtags || template.hashtags == \'\'">\u6682\u65E0\u6807\u7B7E</div></div></div></div></div><modele-pagination style="margin-top:10px" page="vm.pageInfo.page" size="vm.pageInfo.size" total="vm.pageInfo.total" current-change="vm.currentChange()"></modele-pagination></div>');
$templateCache.put('app/entities/page/recommendTemplate.html','<div class="workbench"><div class="work-head"><div class="work-title">\u4E3A\u4F60\u63A8\u8350</div><div class="search-box"><div class="search-input"><i class="iconfont icon-sousuo"></i> <input type="text" ng-model="vm.searchQuery" ng-readonly="vm.batchState" ng-keydown="vm.search()" placeholder="\u5173\u952E\u8BCD\u641C\u7D22"></div></div></div><div class="share-screen"><div class="screen-box"><div class="screen-tit">\u5206\u7C7B\uFF1A</div><div class="option-list"><div class="option-item" ng-class="{\'active\' : !vm.catalogView}" ng-click="catalogCb(\'all\')">\u5168\u90E8</div><div class="option-item" ng-class="{\'active\' : item.id == vm.catalogView.id}" ng-repeat="item in vm.catalogs track by $index" ng-click="catalogCb(item)">{{item.name}}</div></div></div><div class="screen-box"><div class="screen-tit">\u4EA7\u54C1\uFF1A</div><div class="option-list"><div class="option-item" ng-class="{\'active\' : vm.productSelected === product.value}" ng-repeat="product in vm.productList track by $index" ng-click="selectProduct(product)">{{ product.label }}</div></div></div></div><div class="template-list" style="padding-top: 32px"><div class="empty-view" ng-if="vm.userDefined.length < 1"><img class="empty-img" src="content/images/page-empty.png" alt="\u65E0\u6570\u636E"><div class="empty-text">\u6682\u65E0\u5185\u5BB9</div></div><div class="template-item" ng-repeat="item in vm.userDefined track by $index"><div class="img-view"><div class="cover-view"><img class="cover-img" err-src="content/images/default-cover.png" ng-if="vm.domainQ" ng-src="{{vm.domainQ + item.cover + \'?imageMogr2/interlace/1/thumbnail/268x268\'}}" alt="\u56FE\u7247\u7F3A\u5931"> <img ng-if="!vm.domainQ" src="content/images/default-cover.png" alt="\u56FE\u7247\u7F3A\u5931"></div><div class="shade-view"><div class="preview-btn" ng-click="look(item)" uib-tooltip="\u9884\u89C8" tooltip-placement="bottom"><i class="iconfont icon-yulan"></i></div><div class="temp-btn" ng-click="gotoCreate(item)">\u4F7F\u7528</div></div></div><div class="template-info"><div class="template-product"><div class="product-name" ng-if="item.type">{{productType(item.type)}}</div></div><div class="template-name" uib-tooltip="{{item.name}}" tooltip-placement="bottom">{{item.name}}</div></div></div></div><modele-pagination style="margin-top: 10px" ng-show="!vm.batchState" page="vm.pageInfo.page" size="vm.pageInfo.size" total="vm.pageInfo.total" current-change="vm.currentChange()"></modele-pagination></div>');
$templateCache.put('app/entities/page/template-dialog.html','<div class="c-model"><div class="c-model-head"><div class="c-model-head-title">\u6DFB\u52A0\u6807\u7B7E</div><i class="iconfont icon-closeicon1" ng-click="vm.clear()"></i></div><div class="c-model-body"><div class="c-model-body-view" style="min-height: 352px"><div class="tag-list"><div class="tag-item" ng-class="{\'active-tag-item\':hashtag.selected}" ng-repeat="hashtag in vm.hashtags track by $index" ng-click="useHashtag(hashtag)">{{hashtag.name}}</div></div></div></div><div class="c-model-foot" style="display: flex;align-items: center;justify-content: space-between"><div style="color: #89919D">*\u6700\u591A\u53EF\u9009\u62E93\u4E2A\u4E3B\u9898\u6807\u7B7E</div><div><button type="button" class="btn btn-cancel btn-max" ng-click="vm.clear()">\u53D6\u6D88</button> <button type="button" class="btn btn-info btn-max" ng-click="vm.save()">\u786E\u5B9A</button></div></div></div><style>.tag-list{\n        width: 100%;\n        display: flex;\n        align-items: center;\n        flex-wrap: wrap;\n        row-gap: 16px;\n        column-gap: 8px;\n    }\n    .tag-item{\n        padding: 6px 12px;\n        background: #F5F7FA;\n        border-radius: 2px;\n        color: #505760;\n    }\n    .tag-item:hover{\n        color: #264DF0;\n    }\n    .active-tag-item{\n        background: #264DF0;\n        color: #FFFFFF !important;\n    }</style>');
$templateCache.put('app/entities/page/template-opened-result.html','<div class="c-model"><div class="c-model-head"><div class="c-model-head-title">\u9A73\u56DE\u7406\u7531</div><i class="iconfont icon-closeicon1" ng-click="vm.clear()"></i></div><div class="c-model-body"><div class="c-model-body-view"><div class="c-form"><label class="c-form-label">\u7406\u7531\uFF1A</label><div class="c-form-div align-items-center" style="width: auto">{{vm.productXml.statusRemarks}}</div></div></div></div><div class="c-model-foot" style="text-align: center"><button type="button" class="btn btn-info" ng-click="vm.clear()">\u5173\u95ED</button></div></div><style>.align-items-center{\n        display: flex;\n        align-items: center;\n    }</style>');
$templateCache.put('app/entities/page/template-share.html','<div class="c-model"><div class="c-model-head"><div class="c-model-head-title">\u5206\u4EAB</div><i class="iconfont icon-closeicon1" ng-click="vm.clear()"></i></div><div class="c-model-body"><div class="c-model-body-view"><div class="c-form"><label class="c-form-label" style="width: 80px">\u4E13\u9898</label><div class="c-form-div align-items-center" style="width: auto"><select ng-options="catalog as catalog.name for catalog in vm.catalogs" ng-model-options="{debounce:500}" class="form-control fontSel" ng-model="vm.backCatalog"></select></div></div></div></div><div class="c-model-foot" style="text-align: center"><button type="button" class="btn btn-cancel" ng-click="vm.clear()">\u5173\u95ED</button> <button type="button" class="btn btn-info" ng-click="vm.save()">\u786E\u5B9A</button></div></div>');
$templateCache.put('app/entities/page/template-view.html','<div ng-if="vm.watchSure"><article-preview preview-article="vm.article.document" domain="vm.url"></article-preview></div><three-preview width="600" height="600" style="background: #fff" product-xml="vm.threeProductXmlData" pages="vm.threeTemplate.pages.page" ng-if="vm.threeView"></three-preview><!-- <img class="preview-article-close" src="content/images/icons/close4.svg" width="40px" > --><div class="preview-article-close" ng-click="backTo()"><i class="iconfont icon-closeicon1"></i></div><style>.modal .modal-dialog {\n        width: 100vw;\n        height: 100vh;\n        padding: 0;\n        margin: 0;\n        position: fixed;\n        top: 0;\n        left: 0;\n        transform: translate(0, 0) !important;\n    }\n\n    .modal-content {\n        position: relative;\n        width: 100vw;\n        height: 100vh;\n        margin: 0;\n        background: none;\n        overflow: hidden;\n    }\n\n    .preview-article-close {\n        position: absolute;\n        width: 48px;\n        height: 48px;\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        background: #000000;\n        border-radius: 50%;\n        right: 32px;\n        top: 32px;\n        cursor: pointer;\n        z-index: 999;\n    }\n\n    .preview-article-close .iconfont {\n        font-size: 28px;\n        color: #ffffff;\n    }</style>');
$templateCache.put('app/entities/page/template.html','<div class="bg-fff"><div class="page-wrap"><!--\u5206\u7C7B\u663E\u793A--><div class="templateItem"><div class="templateTitle">\u81EA\u5B9A\u4E49\u6A21\u677F</div><ul><li ng-repeat="template in vm.userDefined | limitTo:5 track by $index" class="templateW" ng-click="gotoCreate(template)"><img alt="\u56FE\u7247\u7F3A\u5931" class="product-img" ng-src="{{vm.domainQ + template.cover +\'?imageView2\'}}"><div class="templateName">{{template.name}}</div><div class="templateSize">{{template.pageSizeW}}*{{template.pageSizeH}}mm</div></li><li class="templateW" ng-click="gotoCreate(\'\')"><div style="width: 100px;height: 100px"><img alt="\u56FE\u7247\u7F3A\u5931" src="content/images/selfPic.svg" width="80" height="80"></div><div class="templateName">\u81EA\u5B9A\u4E49\u5C3A\u5BF8</div><div class="templateSize"></div></li></ul></div><div class="templateItem"><div class="templateTitle">\u70ED\u95E8\u6A21\u677F<span class="moreTemplate" ng-click="vm.more()">\u66F4\u591A</span></div><!--<ul>--><!--<li ng-repeat="template in vm.userDefined | limitTo:6 track by $index" class="templateW" ng-click="gotoCreate(template)">--><!--<img alt="\u56FE\u7247\u7F3A\u5931" class="product-img" ng-src="{{vm.domainQ + template.cover +\'?imageView2\'}}">--><!--<div class="templateName">{{template.name}}</div>--><!--<div class="templateSize">{{template.pageSizeW}}*{{template.pageSizeH}}mm</div>--><!--</li>--><!--</ul>--></div><div class="templateItem"><div class="templateTitle">\u6700\u8FD1\u6253\u5F00<span class="moreTemplate" ng-click="vm.more()">\u66F4\u591A</span></div><!--<ul>--><!--<li ng-repeat="template in vm.userDefined | limitTo:6 track by $index" class="templateW" ng-click="gotoCreate(template)">--><!--<img alt="\u56FE\u7247\u7F3A\u5931" class="product-img" ng-src="{{vm.domainQ + template.cover +\'?imageView2\'}}">--><!--<div class="templateName">{{template.name}}</div>--><!--<div class="templateSize">{{template.pageSizeW}}*{{template.pageSizeH}}mm</div>--><!--</li>--><!--</ul>--></div></div></div>');
$templateCache.put('app/entities/page/templateList.html','<div class="my-design"><div class="header"><div class="header-left"><div class="header-title"><img src="content/images/home-icon1.png" alt=""><div class="content"><div class="content-title1">\u6807\u51C6\u6A21\u677F</div><div class="content-title2">\u652F\u6301\u4E09\u5927\u4EA7\u54C1\u7C7B\u578B</div></div></div><div class="header-btn" ng-click="gotoCreate(\'\', true,\'BOOK\')">\u53BB\u8BBE\u8BA1 <span class="iconfont icon-right"></span></div></div><div class="header-right"><div class="header-title"><img src="content/images/home-icon2.png" alt=""><div class="content"><div class="content-title1">\u4E07\u7269\u6A21\u677F</div><div class="content-title2">\u7ED1\u5B9A\u6A21\u578B \u4E07\u7269\u7686\u53EF\u521B\u4F5C</div></div></div><div class="header-btn" ng-click="gotoCreate(\'\', true,\'THING\')">\u53BB\u8BBE\u8BA1 <span class="iconfont icon-right"></span></div></div></div><div class="body"><div class="top1"><div class="left">\u6211\u7684\u8BBE\u8BA1</div><div class="right"><div class="input"><span class="iconfont icon-sousuo"></span> <input type="text" ng-model="vm.tableData.searchQuery" placeholder="\u5173\u952E\u8BCD\u641C\u7D22" ng-keypress="vm.search()"></div><div class="btn1" ng-click="batch()" ng-if="!vm.batch"><span class="iconfont icon-batch"></span> \u6279\u91CF\u64CD\u4F5C</div><div class="btn2" ng-click="quitBatch()" ng-if="vm.batch">\u9000\u51FA</div></div></div><div class="top2"><div class="classify" style="align-items: flex-start"><div class="name">\u5206\u7C7B\uFF1A</div><div class="classify2" style="height: auto"><div class="tag" ng-class="{\'active-tag\': vm.tableData.classify == \'\'}" ng-click="selectClassify(\'\')">\u5168\u90E8</div><div class="tag" ng-repeat="item in vm.catalogs | orderBy:\'seq\' track by $index" ng-class="{\'active-tag\': vm.tableData.classify == item.id}" ng-click="selectClassify(item.id)">{{item.name}}</div><div class="editor iconfont icon-bianji" uib-tooltip="\u7F16\u8F91\u5206\u7C7B" tooltip-placement="bottom" ng-click="editorClassify()"></div></div></div><div class="classify" style="align-items: flex-start"><div class="name">\u6807\u7B7E\uFF1A</div><div class="classify2" ng-style="{\'height\':vm.tagScreenIsOpen?\'auto\':\'30px\'}"><div class="tag" ng-class="{\'active-tag\':vm.tableData.selectN == \'\'}" ng-click="selectTag(\'\')">\u5168\u90E8</div><div class="tag" ng-class="{\'active-tag\':vm.tableData.selectN == hashtag.name}" ng-repeat="hashtag in vm.hashtags | orderBy:seq track by $index" ng-click="selectTag(hashtag.name)">{{hashtag.name}}</div></div><div class="more" ng-click="changeMore()">\u66F4\u591A<i class="iconfont" ng-class="{\'icon-down\' : !vm.tagScreenIsOpen,\'icon-up\' : vm.tagScreenIsOpen}"></i></div></div><div class="classify"><div class="name">\u6765\u6E90\uFF1A</div><div class="tag" ng-class="{\'active-tag\':vm.tableData.source == \'\'}" ng-click="selectSource(\'\')">\u5168\u90E8</div><div class="tag" ng-repeat="item in vm.sourceList track by $index" ng-class="{\'active-tag\':vm.tableData.source == item.id}" ng-click="selectSource(item.id)">{{item.name}}</div></div><div class="classify"><div class="name">\u4EA7\u54C1\uFF1A</div><div class="tag" ng-class="{\'active-tag\':vm.tableData.product == \'\'}" ng-click="selectProduct(\'\')">\u5168\u90E8</div><div class="tag" ng-repeat="item in vm.productList track by $index" ng-class="{\'active-tag\':vm.tableData.product == item.id}" ng-click="selectProduct(item.id)">{{item.name}}</div></div></div><div class="top3"><div class="shareStatus"><span ng-repeat="item in vm.shareStatus track by $index" ng-click="selectShareStatus(item.id)" ng-class="{\'active-tag\':item.id == vm.tableData.shareStatus}">{{item.name}}</span></div><div class="line"></div><div class="upgradeStatus">\u72B6\u6001\uFF1A<span ng-repeat="item in vm.upgradeStatus track by $index" ng-click="selectUpgradeStatus(item.id)" ng-class="{\'active-tag\':item.id == vm.tableData.upgradeStatus}">{{item.name}}</span></div></div><div class="content"><div class="template-list"><div class="item" ng-repeat="template in vm.templateList track by $index" ng-click="selectItem(template)"><span class="selected0" ng-if="vm.batch && !template.selected"></span> <span class="selected1 iconfont icon-duihao" ng-if="vm.batch && template.selected"></span><div class="item-top" ng-class="{\'maskShow\':!vm.batch}"><div class="flag" ng-if="template.status && !vm.batch"><span data-translate="{{\'platformApp.FrontStatus.\' + template.status}}" ng-style="{\'color\':template.status == \'Rejected\' ? \'#FF4444\' : template.status == \'Created\' ? \'#264DF0\': \'#222529\'}">{{template.status}}</span></div><div class="upgrade" ng-if="template.version != \'4.0\'">\u53EF\u5347\u7EA7</div><img alt="\u56FE\u7247\u7F3A\u5931" ng-src="{{vm.domainQ ? vm.domainQ + template.cover +\'?imageMogr2/interlace/1/thumbnail/268x268\' : \'\'}}" ng-if="template.cover" ng-click="template.show=!template.show"> <img class="cover-img" ng-if="!vm.domainQ || !template.cover" src="content/images/default-cover.png"><div class="maskbg"></div><div class="mask-operate"><span class="iconfont icon-gongkai" ng-click="previewTemplate(template)" uib-tooltip="\u9884\u89C8" tooltip-placement="bottom"></span> <span class="iconfont icon-biaoqian" ng-click="addLabel(template)" uib-tooltip="\u6DFB\u52A0\u6807\u7B7E" tooltip-placement="bottom"></span> <span class="iconfont icon-gengduo1 template-more"><div class="template-menus"><div class="menus"><div ng-click="operateLi(template, \'\u590D\u5236\')">\u590D\u5236</div><div ng-click="operateLi(template, \'\u5220\u9664\')">\u5220\u9664</div><div ng-if="template.productType !=\'THING\' && template.status != \'Approved\' && template.status != \'Created\'" ng-click="operateLi(template, \'\u5206\u4EAB\')">\u5206\u4EAB</div><div ng-click="operateLi(template, \'\u7F16\u8F91\u6570\u636E\')">\u7F16\u8F91\u6570\u636E</div><div ng-click="getResult(template)" ng-if="template.status == \'Rejected\'">\u67E5\u770B\u9A73\u56DE\u539F\u56E0</div><div class="line"></div><div ng-click="operateLi(template, \'\u53D1\u5E03\u6A21\u677F\')">\u53D1\u5E03\u6A21\u677F</div><div ng-click="operateLi(template, \'\u53D1\u5E03\u4EA7\u54C1\')">\u53D1\u5E03\u4EA7\u54C1</div><!--                                        <div class="line"></div>--><!--                                        <div ng-click="operateLi(template, \'\u83B7\u53D6\u6570\u636E\')">\u83B7\u53D6\u6570\u636E</div>--></div></div></span><div class="btn1" ng-if="template.version == \'4.0\'" ng-click="operateLi(template, \'\u7F16\u8F91\')">\u7F16\u8F91</div><div class="btn1" ng-if="template.version != \'4.0\'" ng-click="operateLi(template, \'\u5347\u7EA7\')">\u5347\u7EA7</div></div></div><div class="item-bottom"><div class="name" uib-tooltip="{{template.name}}" tooltip-placement="bottom">{{template.name}}</div><div class="property"><span class="productType" ng-if="template.productType">{{productType(template.productType)}}</span> <span ng-style="{\'padding-left\':!template.productType ? \'0px\' : \'\'}">{{template.pageSizeW}}*{{template.pageSizeH}}</span> <span>{{template.pageCount}}P</span> <span ng-if="template.minPicQuantity!= template.maxPicQuantity">{{template.minPicQuantity}}~{{template.maxPicQuantity}}\u5F20 </span><span ng-if="template.minPicQuantity == template.maxPicQuantity">{{template.minPicQuantity}}\u5F20</span></div><div class="tags"><span ng-repeat="hashtag in hashtags(template.hashtags) track by $index" ng-if="hashtag" ng-style="{\'max-width\':hashtags(template.hashtags).length == 1 ? \'100%\' : hashtags(template.hashtags).length == 2 ? \'50%\' : \'33%\'}">{{hashtag}}</span> <span ng-if="template.hashtags ==null || template.hashtags==\'\'">\u6682\u65E0\u6807\u7B7E</span></div></div></div></div><div class="data-null" ng-if="vm.templateList.length == 0"><img src="content/images/template_null.png" alt=""><div>\u8FD8\u6CA1\u6709\u5185\u5BB9\u54E6\uFF0C<span class="themecolor" ng-click="gotoCreate(\'\', true,\'BOOK\')">\u5FEB\u53BB\u521B\u5EFA\u5427<span class="iconfont icon-youjiantou"></span></span></div></div></div></div><modele-pagination ng-show="!vm.batch" style="margin-top:10px" page="vm.tableData.page" size="vm.tableData.size" total="vm.totalItems" current-change="vm.pageCb(page)"></modele-pagination><div style="height: 72px" ng-if="vm.batch"></div><div class="batchOperate" ng-if="vm.batch"><div>\u5DF2\u9009({{vm.selectList.length}})</div><div class="delete" ng-click="deleteSelect()"><span class="iconfont icon-dustbin_icon"></span>\u5220\u9664</div><span class="iconfont icon-closeicon1" style="color: #fff" ng-click="quitBatch()"></span></div></div>');
$templateCache.put('app/entities/page/three-preview.html','<div ng-style="{width: vm.width, height: vm.height}" style="margin: 20px auto; position: relative"><div class="loading-page3" ng-if="vm.loading"><img src="content/images/loading-all.gif"></div><div id="threeView" ng-show="!vm.loading && !vm.error" style="width: 100%; height: 100%" ng-mouseover="onMouseOver()" ng-mouseout="onMouseOut()"></div><div class="c-modelBlendent-view"><div class="c-modelBlendent-view-li" ng-class="{\'c-modelBlendent-view-li-selected\' : vm.modelBlendentItem == null}" ng-click="modelBlendentCb(null)">\u9ED8\u8BA4\u914D\u8272</div><div class="c-modelBlendent-view-li" ng-repeat="item in vm.modelBlendent track by $index" ng-class="{\'c-modelBlendent-view-li-selected\' : vm.modelBlendentItem && vm.modelBlendentItem.name == item.name}" ng-click="modelBlendentCb(item)">{{item.name}}</div></div></div><style>.modal-content {\n        width: 100%;\n    }</style>');
$templateCache.put('app/entities/page/thumbnailator.html','<div class="c-model"><div class="c-model-head"><div class="c-model-head-title">\u56FE\u7247\u538B\u7F29</div><i class="iconfont icon-closeicon1" ng-click="vm.clear()"></i></div><div class="c-model-body"><div class="c-model-body-view" style="position: relative"><div class="loading-font" ng-if="vm.loading"></div><div class="font-14 mar-bottom-30">\u7CFB\u7EDF\u68C0\u6D4B\u5230\u4EE5\u4E0B\u56FE\u7247\u5747\u5927\u4E8E20M\uFF0C\u56FE\u7247\u5927\u4E8E20M\u5C06\u65E0\u6CD5\u6B63\u5E38\u663E\u793A\uFF0C\u662F\u5426\u9700\u8981\u7CFB\u7EDF\u538B\u7F29\u540E\u518D\u4E0A\u4F20\uFF1F</div><div style="display: flex; flex-wrap: wrap;margin: 0 -5px"><div class="text-center1" ng-repeat="file in vm.files track by $index"><div class="text-center1-pic"><img ng-src="{{file.blobCover}}" class="thumbnailator-pic-cover"> <i class="iconfont icon-closeicon1" ng-click="deletePic($index)"></i></div><div class="thumbnailator-text">\u539F\u56FE\uFF1A<span>{{file.imageSize}}</span>M</div><div class="thumbnailator-text" ng-if="vm.isEnd">\u538B\u7F29\u540E\uFF1A<span>{{file.lowerSize}}</span>M</div></div></div></div></div><div class="c-model-foot"><button type="button" class="btn btn-cancel" ng-click="vm.clear()">\u53D6\u6D88</button> <button type="button" class="btn btn-info" ng-click="compression()" ng-if="!vm.isEnd">\u538B\u7F29</button> <button type="button" class="btn btn-info" ng-click="vm.save()" ng-if="vm.isEnd" ng-disabled="editForm.$invalid || vm.isSaving">\u7EE7\u7EED\u4E0A\u4F20</button></div><!--    <div class="modal-footer pad-0 mar-0" style="border-top: 1px solid #E8E8E8">--><!--        <button type="button" class="col-md-6 col-sm-6 col-xs-6 pad-0" data-dismiss="modal"--><!--                style="background:#fff;color: #232323;font-size: 15px;height: 60px;border-right:1px solid #E8E8E8" ng-click="vm.clear()">--><!--            \u53D6\u6D88--><!--        </button>--><!--        <button type="submit" style="font-size: 15px;height: 60px;padding: 0;background: #FAC779;color: #fff" class="col-md-6 col-sm-6 col-xs-6"--><!--                ng-click="compression()" ng-if="!vm.isEnd">\u538B\u7F29</button>--><!--        <button type="submit" style="font-size: 15px;height: 60px;padding: 0;background: #FAC779;color: #fff" ng-if="vm.isEnd"--><!--                class="col-md-6 col-sm-6 col-xs-6" ng-disabled="editForm.$invalid || vm.isSaving" ng-click="vm.save()">\u7EE7\u7EED\u4E0A\u4F20--><!--        </button>--><!--    </div>--></div><style>.text-center1{\n        margin: 5px;\n    }\n    .text-center1-pic{\n        width: 120px;\n        height: 120px;\n        overflow: hidden;\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        position: relative;\n        background: #f3f3f3;\n    }\n    .text-center1-pic img{\n        max-width: 100%;\n        max-height: 100%;\n    }\n    .text-center1-pic .iconfont{\n        position: absolute;\n        right: 5px;\n        top: 5px;\n        cursor: pointer;\n    }\n    .thumbnailator-text{\n        width: 100%;\n        height: 35px;\n        line-height: 35px;\n    }</style>');
$templateCache.put('app/entities/page/xml-center.html','<div class="share-content"><div class="share-head"><div class="share-title">\u6A21\u677F\u4E2D\u5FC3</div><div class="search-box"><div class="search-input"><i class="iconfont icon-sousuo"></i> <input type="text" ng-model="vm.searchQuery" ng-keydown="vm.search()" placeholder="\u5173\u952E\u8BCD\u641C\u7D22"></div></div></div><!-- \u7B5B\u9009\u90E8\u5206 --><div class="share-screen"><div class="screen-box"><div class="screen-tit">\u5206\u7C7B\uFF1A</div><div class="option-list"><div class="option-item" ng-class="{\'active\' : catalog.active}" ng-repeat="catalog in  vm.catalogList track by $index" ng-click="selectCatalog(catalog)">{{catalog.name}}</div></div></div><div class="screen-box"><div class="screen-tit">\u6807\u7B7E\uFF1A</div><div class="option-list more" ng-class="{\'open\' : vm.tagScreenIsOpen}"><div class="option-item" ng-class="{\'active\' : hashtag.active}" ng-repeat="hashtag in vm.hashtagList track by $index" ng-click="selectTag(hashtag)">{{ hashtag.name}}</div><div class="more-btn" ng-click="changeMoreState(\'tagScreenIsOpen\')">\u66F4\u591A<i class="iconfont" ng-class="{\'icon-down\' : !vm.tagScreenIsOpen,\'icon-up\' : vm.tagScreenIsOpen}"></i></div></div></div><div class="screen-box"><div class="screen-tit">\u4EA7\u54C1\uFF1A</div><div class="option-list"><div class="option-item" ng-class="{\'active\' : vm.productActive === $index}" ng-repeat="product in vm.productList track by $index" ng-click="selectProduct($index)">{{ product.label }}</div></div></div><div class="screen-line"><div class="screen"><div class="genre"><div class="item" ng-repeat="sort in vm.sortList" ng-class="{\'active\' : sort.value === vm.predicate}" ng-click="selectSort(sort.value)">{{sort.label}}</div></div><div class="price-select"><div class="tit">\u4EF7\u683C\uFF1A</div><div class="option-list"><div class="option-item" ng-repeat="item in vm.priceList" ng-class="{\'active\' : item.value == priceSelected}" ng-click="selectPrice(item.value)">{{item.label}}</div></div></div></div><div class="btns"><a ui-sref="purchased-template" class="skip-btn">\u67E5\u770B\u5DF2\u8D2D\u4E70\u6A21\u677F</a></div></div></div><!-- \u6A21\u677F\u5217\u8868 --><div class="template-list"><div class="empty-view" ng-if="vm.productXmls.length < 1"><img class="empty-img" src="content/images/page-empty.png" alt="\u65E0\u6570\u636E"><div class="empty-text">\u6682\u65E0\u5185\u5BB9</div></div><div class="template-item" ng-repeat="template in vm.productXmls track by template.id"><div class="img-view"><div class="cover-view"><img class="cover-img" alt="\u56FE\u7247\u7F3A\u5931" ng-if="vm.domainQ && template.cover" ng-src="{{vm.domainQ + template.cover + \'?imageMogr2/interlace/1/thumbnail/268x268\'}}" err-src="content/images/default-cover.png" ng-click="template.show=!template.show"> <img class="cover-img" ng-if="!vm.domainQ || !template.cover" src="content/images/default-cover.png"><div class="buy-tag" ng-if="template.purchased">\u5DF2\u8D2D\u4E70</div><div class="personal-tag" ng-if="!template.productTemplateId">\u4E2A\u4EBA</div></div><div class="shade-view"><div class="preview-btn" ng-click="previewTemplate(template)" uib-tooltip="\u9884\u89C8" tooltip-placement="bottom"><i class="iconfont icon-yulan"></i></div><div class="temp-btn" ng-if="canUse(template)" ng-click="useTemp(template)">\u4F7F\u7528</div><div class="temp-btn" ng-if="!canUse(template)" ng-click="buyXml(template)">\uFFE5{{template.price}}\u8D2D\u4E70</div></div></div><div class="template-info"><div class="template-name" uib-tooltip="{{template.name}}" tooltip-placement="bottom">{{template.name}}</div><div class="info-list"><div class="item" ng-if="template.productType">{{getProductName(template.productType)}}</div><div class="item">{{template.pageSizeW}}*{{template.pageSizeH}}</div><div class="item">{{template.pageCount}}P</div><div class="item">{{template.picQuantity}}\u5F20</div></div><div class="tags-view" ng-class="{\'one\' : template.hashtags.split(\',\').length === 1,\'two\' : template.hashtags.split(\',\').length === 2, \'three\' : template.hashtags.split(\',\').length >=3}"><div class="tag" ng-repeat="tag in template.hashtags.split(\',\') | limitTo: 3" ng-if="tag">{{ tag }}</div><div class="tag" ng-if="!template.hashtags || template.hashtags == \'\'">\u6682\u65E0\u6807\u7B7E</div></div></div></div></div><modele-pagination style="margin-top: 10px" page="vm.pageInfo.page" size="vm.pageInfo.size" total="vm.pageInfo.total" current-change="vm.currentChange()"></modele-pagination></div>');
$templateCache.put('app/entities/product-xml-purchase/product-xml-purchase.html','<div class="share-content" style="padding-bottom: 0px"><div class="share-head"><div class="share-title">\u8D2D\u4E70\u8BB0\u5F55</div><div class="search-box"><div class="search-input"><i class="iconfont icon-sousuo"></i> <input type="text" id="search" ng-model="vm.searchQuery" style="width: 210px" ng-keydown="vm.search(vm.searchQuery)" placeholder="\u8F93\u5165\u8BA2\u5355\u53F7\u6216\u6A21\u677F\u540D\u79F0\u67E5\u8BE2"></div></div></div></div><div class="table-responsive white pad-left-15 pad-right-15" style="margin-bottom: 20px"><table class="jh-table table table-striped"><thead class="table-thead" style="width: 1596px;height: 48px;background: #F5F7FA"><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="number"><span data-translate="platformApp.productXmlPurchase.number">number</span> <img src="content/images/paixu2.png" ng-show="vm.predicate == \'number\' && vm.reverse" style="width: 16px"> <img src="content/images/paixu3.png" ng-show="vm.predicate == \'number\' && !vm.reverse" style="width: 16px"> <span class="iconfont icon-paixu11" ng-show="vm.predicate != \'number\'"></span></th><th jh-sort-by="productXml.id"><span data-translate="platformApp.productXmlPurchase.productXmlId">productXmlId</span> <img src="content/images/paixu2.png" ng-show="vm.predicate == \'productXml.id\' && vm.reverse" style="width: 16px"> <img src="content/images/paixu3.png" ng-show="vm.predicate == \'productXml.id\' && !vm.reverse" style="width: 16px"> <span class="iconfont icon-paixu11" ng-show="vm.predicate != \'productXml.id\'"></span></th><th jh-sort-by="productXml.name"><span data-translate="platformApp.productXmlPurchase.productXmlName">productXmlName</span> <img src="content/images/paixu2.png" ng-show="vm.predicate == \'productXml.name\' && vm.reverse" style="width: 16px"> <img src="content/images/paixu3.png" ng-show="vm.predicate == \'productXml.name\' && !vm.reverse" style="width: 16px"> <span class="iconfont icon-paixu11" ng-show="vm.predicate != \'productXml.name\'"></span></th><th jh-sort-by="amount"><span data-translate="platformApp.productXmlPurchase.amount">amount</span> <img src="content/images/paixu2.png" ng-show="vm.predicate == \'amount\' && vm.reverse" style="width: 16px"> <img src="content/images/paixu3.png" ng-show="vm.predicate == \'amount\' && !vm.reverse" style="width: 16px"> <span class="iconfont icon-paixu11" ng-show="vm.predicate != \'amount\'"></span></th><th jh-sort-by="paidDate"><span data-translate="platformApp.productXmlPurchase.paidDate">paidDate</span> <img src="content/images/paixu2.png" ng-show="vm.predicate == \'paidDate\' && vm.reverse" style="width: 16px"> <img src="content/images/paixu3.png" ng-show="vm.predicate == \'paidDate\' && !vm.reverse" style="width: 16px"> <span class="iconfont icon-paixu11" ng-show="vm.predicate != \'paidDate\'"></span></th><th jh-sort-by="type"><span data-translate="platformApp.productXmlPurchase.type">type</span> <img src="content/images/paixu2.png" ng-show="vm.predicate == \'type\' && vm.reverse" style="width: 16px"> <img src="content/images/paixu3.png" ng-show="vm.predicate == \'type\' && !vm.reverse" style="width: 16px"> <span class="iconfont icon-paixu11" ng-show="vm.predicate != \'type\'"></span></th><th jh-sort-by="transactionId"><span data-translate="platformApp.productXmlPurchase.transactionId">transactionId</span> <img src="content/images/paixu2.png" ng-show="vm.predicate == \'transactionId\' && vm.reverse" style="width: 16px"> <img src="content/images/paixu3.png" ng-show="vm.predicate == \'transactionId\' && !vm.reverse" style="width: 16px"> <span class="iconfont icon-paixu11" ng-show="vm.predicate != \'transactionId\'"></span></th></tr></thead><tbody class="table-tbody"><tr ng-repeat="p in vm.productXmlPurchases track by p.id" class="content-tr"><td class="vertical-middle">{{p.number}}</td><td class="vertical-middle">{{p.productXmlId}}</td><td class="vertical-middle">{{p.productXmlName}}</td><td class="vertical-middle">{{p.amount|currency}}</td><td class="vertical-middle">{{p.paidDate|date:\'medium\'}}</td><td class="vertical-middle" data-translate="{{\'platformApp.productXmlPurchase.types.\' + p.type}}">{{p.type}}</td><td class="vertical-middle">{{p.transactionId}}</td></tr></tbody></table></div><modele-pagination page="vm.page" size="vm.itemsPerPage" total="vm.totalItems" current-change="vm.currentChange()"></modele-pagination><style type="text/css" media="screen">.content-tr:hover{\n        background: #EFF2FA;\n    }</style>');
$templateCache.put('app/entities/product-xml/product-xmls.html','<div class="listBGC"><div class="current-location"><div><span translate="global.menu.current-location">\u5F53\u524D\u4F4D\u7F6E:</span> <span translate="global.menu.entities.productXml" class="current-menu">productXml</span></div></div><div class="list-body"><div class="container-fluid pad-bottom-10"><div class="row moduleNameBGC"><div class="searchBar"><form name="searchForm" class="form-search form-inline"><div class="input-group pull-right" id="test"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="{{ \'platformApp.productXml.home.search\' | translate }}"> <span class="input-group-btn width-min btn-searched"><button class="btn btn-search" ng-click="vm.search(vm.searchQuery)"></button> </span><span class="input-group-btn width-min btn-clear" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span translate="global.form.clear"></span></button></span></div></form></div></div></div><div class="table-responsive white pad-left-15 pad-right-15"><table class="jh-table table table-striped"><thead class="table-thead"><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="name"><span data-translate="platformApp.productXml.name">Name</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="reprint"><span data-translate="platformApp.productXml.reprint">Reprint</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="pattern"><span data-translate="platformApp.productXml.pattern">pattern</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="replace"><span data-translate="platformApp.productXml.replace">replace</span> <span class="glyphicon glyphicon-sort"></span></th><th><span translate="global.field.operate">Operate</span></th></tr></thead><tbody class="table-tbody"><tr ng-repeat="productXml in vm.productXmls track by productXml.id"><td class="vertical-middle">{{productXml.name}}</td><td class="vertical-middle" data-translate="{{\'platformApp.ReprintType.\' + productXml.reprint}}">{{productXml.reprint}}</td><td class="vertical-middle" data-translate="{{\'platformApp.productXml.patternType.\' + productXml.pattern}}">{{productXml.pattern}}</td><td>{{productXml.replace?\'\u662F\':\'\u5426\'}}</td><td class="text-right vertical-middle"><div class="right-btn"><button type="submit" ui-sref="page-edit({id:productXml.id})" class="btn-sub btn1"><span class="btn-edit"></span><p class="hover-box">\u7F16\u8F91</p></button> <button type="submit" ui-sref="page-my-suffix-copy({id:productXml.id})" class="btn-sub btn1"><span class="btn-copy"></span><p class="hover-box">\u590D\u5236</p></button> <button type="submit" ng-click="delete(productXml.id)" class="btn-sub btn1"><span class="btn-del"></span><p class="hover-box">\u5220\u9664</p></button></div></td></tr></tbody></table></div></div><div class="text-left" style="height: 70px;line-height: 70px"><uib-pagination class="pagination-sm" style="float: left" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.transition()" previous-text="<" next-text=">" boundary-links="false"></uib-pagination><div class="text-jump"><span translate="global.page.goto">Go to</span> <input type="text" class="page-text page" max="100000" ng-model="vm.jumpText" onkeyup="value=value.replace(/[^\\d]/g,\'\')"> <span class="page-btn page" ng-click="vm.jump()">\u8DF3\u8F6C</span></div></div></div>');
$templateCache.put('app/entities/text/text-list.html','<div class="c-body"><div class="c-title"><span class="c-title-nav" ui-sref="page" style="cursor: pointer">\u63A8\u8350\u6A21\u677F</span> <span class="c-title-nav c-title-navOn">\u65B0\u589E\u6587\u5B57\u6A21\u677F</span></div><div style="margin-top: 40px"><ul class="clearfix"><li class="templateW" ng-click="add()"><div class="templateW-img"><img alt="\u56FE\u7247\u7F3A\u5931" src="content/images/selfPic.svg" width="80" height="80"></div><div class="templateName">\u81EA\u5B9A\u4E49\u5C3A\u5BF8</div></li></ul><!--        <div style="width: 100px; text-align: center;" ng-click="add()">--><!--            <img src="content/images/selfPic.svg" alt="" style="width: 100px;">--><!--            <span>\u81EA\u5B9A\u4E49\u5C3A\u5BF8</span>--><!--        </div>--></div></div>');
$templateCache.put('app/entities/text/text-share.html','<div class="share-content"><div class="share-head"><div class="share-title">\u6587\u5B57\u4E2D\u5FC3</div><div class="search-box"><div class="search-input"><i class="iconfont icon-sousuo"></i> <input type="text" ng-model="vm.searchQuery" ng-readonly="vm.batchState" ng-keydown="vm.search()" placeholder="\u5173\u952E\u8BCD\u641C\u7D22"></div><div class="handle"><div class="batch-btn" ng-if="!vm.batchState" ng-click="vm.batchState = true"><i class="iconfont icon-batch"></i>\u6279\u91CF\u64CD\u4F5C</div><div class="quit-btn" ng-if="vm.batchState" ng-click="vm.batchState = false">\u9000\u51FA</div></div></div></div><div class="text-list"><div class="empty-view" ng-if="vm.textList.length < 1"><img class="empty-img" src="content/images/page-empty.png" alt="\u65E0\u6570\u636E"><div class="empty-text">\u6682\u65E0\u5185\u5BB9</div></div><div class="text-item" ng-repeat="item in vm.textList track by item.id"><div class="img-view" ng-click="vm.checkItem(item)"><div class="cover-view"><img class="cover-img" ng-src="{{item.cover +\'?imageMogr2/interlace/1/thumbnail/268x268\'}}" alt="{{item.name}}"><div class="check-box" ng-class="{\'checked\' : item.checked}" ng-if="vm.batchState"><i class="iconfont icon-gou"></i></div></div><div class="shade-view" ng-if="!vm.batchState"><div class="preview-btn" ng-click="look(item)" uib-tooltip="\u9884\u89C8" tooltip-placement="bottom"><i class="iconfont icon-yulan"></i></div><div class="temp-btn" ng-click="save(item)">\u4F7F\u7528</div></div></div><div class="text-info"><div class="text-name" uib-tooltip="{{item.name}}" tooltip-placement="top">{{item.name}}</div></div></div></div><div class="batch-bar" ng-if="vm.batchState"><div class="checked-count"><span class="num">({{ vm.selectCount }})</span>\u5DF2\u9009\u4E2D</div><div class="btn-use" ng-click="batchUse()"><i class="iconfont icon-gou"></i> \u7ACB\u5373\u4F7F\u7528</div><div class="btn-close" ng-click="vm.batchState = false"><i class="iconfont icon-closeicon1"></i></div></div><modele-pagination style="margin-top:10px" ng-show="!vm.batchState" page="vm.pageInfo.page" size="vm.pageInfo.size" total="vm.pageInfo.total" current-change="vm.currentChange()"></modele-pagination></div>');
$templateCache.put('app/entities/text/text-xml-edit.html','<div class="picture-xml-edit"><div class="header"><div class="left"><input type="text" ng-model="vm.data.name" placeholder="\u540D\u5B57"></div><div class="center"><span class="iconfont icon-chehui" ng-class="{\'disabled-btn\':vm.cookies.length <= 1}" uib-tooltip="\u4E0A\u4E00\u6B65" tooltip-placement="bottom" ng-click="xmlRevocation($event)"></span> <span class="iconfont icon-fanhuibanben" ng-class="{\'disabled-btn\':vm.cookies.length <= 1}" uib-tooltip="\u6062\u590D" tooltip-placement="bottom" ng-click="xmlNextStep($event)"></span> <span class="iconfont icon-quanping" uib-tooltip="\u5168\u5C4F" tooltip-placement="bottom" ng-click="fullScreen()" ng-if="!vm.isFullScreen"></span> <span class="iconfont icon-xingzhuang3" uib-tooltip="\u9000\u51FA\u5168\u5C4F" tooltip-placement="bottom" ng-click="exitScreen()" ng-if="vm.isFullScreen"></span></div><div class="right"><button type="button" class="btn1" ng-click="save()">\u4FDD\u5B58</button> <button type="button" class="btn2" ng-click="out()">\u9000\u51FA</button></div></div><div class="body"><div class="nav"><ul><li ng-class="{\'navOn\':\'font\' == vm.navPitch}" ng-click="navCb(\'font\')"><span class="iconfont icon-bianjiqi-wenben"></span> <span>\u5B57\u4F53</span></li><li ng-class="{\'navOn\':\'background\' == vm.navPitch}" ng-click="navCb(\'background\')"><span class="iconfont icon-bianjiqi-beijing"></span> <span>\u80CC\u666F</span></li><li ng-class="{\'navOn\':\'material\' == vm.navPitch}" ng-click="navCb(\'material\')"><span class="iconfont icon-bianjiqi-sucai"></span> <span>\u7D20\u6750</span></li></ul></div><div class="operationLeft hover-scrollbar" ng-if="!vm.isUnfold" id="navId"><div class="operationMain operationFont" ng-show="vm.navPitch == \'font\'"><ul><li ng-repeat="font in vm.fontList" ng-click="fontAdd(font)"><img ng-src="{{vm.url + font.fontStyles[0].identifier}}" alt=""></li></ul><div class="noData">\u6CA1\u6709\u66F4\u591A\u5566</div></div><div class="operationMain" ng-show="vm.navPitch == \'background\'"><div class="upload-btn mt20"><span class="iconfont icon-shangchuan"></span> \u6DFB\u52A0\u80CC\u666F <input type="file" name="file" multiple="multiple" accept=" image/jpeg, image/png" onchange="updatePic(event, \'background\')" ng-model-options="{debounce : 500}"></div><div class="line"></div><div class="classify"><button ng-repeat="item in vm.backgroundLabels track by $index" ng-click="backgroundData(item.id)" ng-class="{\'classify-btn-active\': vm.backgroundLabel == item.id}" class="classify-btn" ng-if="(!vm.showBackgroundsLabel && $index<6) || vm.showBackgroundsLabel">{{item.name}}</button></div><div class="classify-unfold" ng-if="vm.backgroundLabels.length > 6"><span ng-click="vm.showBackgroundsLabel = !vm.showBackgroundsLabel" ng-if="!vm.showBackgroundsLabel">\u5C55\u5F00<span class="iconfont icon-down"></span></span> <span ng-click="vm.showBackgroundsLabel = !vm.showBackgroundsLabel" ng-if="vm.showBackgroundsLabel">\u6536\u56DE<span class="iconfont icon-up"></span></span></div><div class="mask-body"><ul class="clearfix"><li ng-repeat="item in vm.bgImgList track by $index" ng-click="bgImgCb(item)"><div class="mask-item"><img class="img" ng-src="{{item.identifier + vm.menuImageView}}" alt=""><div class="delete" ng-click="bgImgDelete($event, item,$index)"><span class="iconfont icon-shanchu2"></span></div></div></li></ul></div><div class="noData" ng-if="vm.isBgImgData">\u6CA1\u6709\u66F4\u591A\u5566</div></div><div class="operationMain" ng-show="vm.navPitch == \'material\'"><div class="upload-btn"><span class="iconfont icon-shangchuan"></span> \u6DFB\u52A0\u7D20\u6750 <input type="file" name="file" multiple="multiple" accept=" image/jpeg, image/png" onchange="updatePic(event, \'material\')" ng-model-options="{debounce : 500}"></div><div class="line"></div><div class="classify"><button ng-click="themeClassifiesCb1()" ng-class="{\'classify-btn-active\': vm.isTheme == \'isTheme\'}" class="classify-btn">\u6211\u7684\u7D20\u6750</button> <button ng-repeat="item in vm.themeClassifies track by $index" ng-click="themeClassifiesCb(item)" ng-class="{\'classify-btn-active\': vm.isTheme == item.id}" class="classify-btn" ng-if="(!vm.materialUnfold && $index<6) || vm.materialUnfold">{{item.name}}</button></div><div class="classify-unfold" ng-if="vm.themeClassifies.length > 6"><span ng-click="materialUnfold()" ng-if="!vm.materialUnfold">\u5C55\u5F00<span class="iconfont icon-down"></span></span> <span ng-click="materialUnfold()" ng-if="vm.materialUnfold">\u6536\u56DE<span class="iconfont icon-up"></span></span></div><div class="mask-body"><ul><li ng-repeat="item in vm.materialList track by $index" ng-click="materialCb(item)"><div class="mask-item"><img class="img" ng-src="{{item.identifier + vm.menuImageView}}" alt=""><div class="delete" ng-click="materialDelete($event, item, $index)"><span class="iconfont icon-shanchu2"></span></div></div></li></ul></div><div class="noData" ng-if="vm.isMaterialData">\u6CA1\u6709\u66F4\u591A\u5566</div></div></div><div class="main" ng-style="{\'overflow\' : vm.moveCanvasView ? \'hidden\' : \'auto\' }"><div class="top-btn"><div class="top-btn-left"><ul class="c-xml-action-icon-font" ng-show="vm.isFont"><li><div class="c-xml-action-div-icon c-xml-action-div-icon-color" ng-click="operationColorOpen($event)" ng-style="{background: vm.font.style.color}" style="border: 1px solid #ddd" uib-tooltip="\u989C\u8272" tooltip-placement="bottom"></div><div class="c-xml-action-div-color-modal clearfix" ng-style="{\n                                \'opacity\': vm.isOperationColor ? \'1\' : \'0\',\n                                \'top\':  vm.isOperationColor ? \'40px\' : \'-500px\'\n                                }"><input class="c-xml-action-div-color-modal-btn" type="color" ng-change="chooseColor()" ng-model="vm.font.style.color"> <span ng-repeat="item in vm.colorList track by $index" ng-style="{ \'background\' : item.id}" ng-class="{\'c-xml-action-div-color-on\' : item.id == vm.font.style.color}" ng-click="operationColor(item)"></span></div></li><li><div class="c-font-view"><div class="c-font-view-head" ng-style="{\'font-family\': \'\\\'\' + vm.font.fontuuid + \'\\\'\',}">{{vm.selectFontName(vm.font.fontuuid)}}</div><div class="c-font-view-body"><div class="c-font-view-body-head"><input type="text" class="c-font-view-body-head-input" ng-model="vm.selectFont" ng-change="vm.selectFontBtn()"> <span class="c-font-view-body-head-btn" ng-click="vm.selectFontBtn()"></span></div><div class="chinese-support-view"><div class="chinese-support-item" ng-class="{\'chinese-support-select\' : vm.chineseSupport}" ng-click="vm.chineseSupport=true">\u4E2D\u6587\u5B57\u4F53</div><div class="chinese-support-item" ng-class="{\'chinese-support-select\' : !vm.chineseSupport}" ng-click="vm.chineseSupport=false">\u5176\u4ED6\u5B57\u4F53</div></div><div class="c-font-view-body-ul"><div class="c-font-view-body-li" ng-repeat="item in vm.fontList1 track by $index" ng-click="operationFontFamily(item)" ng-if="vm.chineseSupport == item.chineseSupport" ng-class="{\'c-font-view-body-li-on\' : vm.font.fontuuid == item.uuid}"><img ng-src="{{vm.url + item.fontStyles[0].identifier}}" alt="" ng-if="item.fontStyles[0].identifier"> <span ng-if="!item.fontStyles[0].identifier">{{item.name}}</span></div></div></div></div></li><li><select class="c-select1" style="height: 30px" ng-model="vm.font.style.size" ng-options="item.id as item.name for item in vm.sizeList" ng-change="operationFont()"></select></li><li class="iconfont icon-I" ng-if="vm.font.style.italic1 && !vm.moreIcon" ng-click="operationItalic()" uib-tooltip="\u659C\u4F53" tooltip-placement="bottom" ng-class="{\'toolsSelected\':vm.font.style.italic}"></li><li class="iconfont icon-b" ng-if="vm.font.style.bold1 && !vm.moreIcon" ng-click="operationBold()" uib-tooltip="\u7C97\u4F53" tooltip-placement="bottom" ng-class="{\'toolsSelected\':vm.font.style.bold}"></li><li ng-click="operationSpacing($event)" ng-if="!vm.moreIcon" class="iconfont icon-wenzi-hangjianjushezhi" uib-tooltip="\u5B57\u95F4\u8DDD" tooltip-placement="bottom" ng-class="{\'btn-avtive\':vm.isOperationSpacing}"><div class="roundedSet" ng-show="vm.isOperationSpacing" style="width: 320px" ng-click="fn($event)"><div class="roundedSet-title"><h4 class="rightPanel-title">\u5B57\u95F4\u8DDD</h4></div><div class="c-schedule-view"><input type="range" min="0" max="100" step="1" value="{{vm.font.style.letterspacing}}" ng-model="vm.font.style.letterspacing" ng-change="changeLetterspacing($event)" class="text-range" style="width: 100% !important" ng-style="{\'background-size\': vm.font.style.letterspacing + \'% \' + \'100%\'}"> <input type="number" min="0" max="100" step="1" style="width: 60px;height: 32px;margin-left: 10px" ng-model="vm.font.style.letterspacing" ng-change="changeLetterspacing($event)"></div><div class="roundedSet-title"><h4 class="rightPanel-title">\u884C\u95F4\u8DDD</h4></div><div class="c-schedule-view"><input type="range" min="0" max="100" step="1" value="{{vm.font.style.lineheight}}" ng-model="vm.font.style.lineheight" ng-change="changeLineheight($event)" class="text-range" style="width: 100% !important" ng-style="{\'background-size\': vm.font.style.lineheight + \'% \' + \'100%\'}"> <input type="number" min="0" max="100" step="1" style="width: 60px;height: 32px;margin-left: 10px" ng-model="vm.font.style.lineheight" ng-change="changeLineheight($event)"></div></div></li><li ng-if="!vm.moreIcon" class="iconfont icon-wenzizuoduiqi" ng-click="operationAlignAt($event)" uib-tooltip="\u5BF9\u9F50" tooltip-placement="bottom" ng-class="{\'btn-avtive\':vm.isAlignAt}"><div class="roundedSet" ng-show="vm.isAlignAt" style="width: 320px" ng-click="fn($event)"><div class="roundedSet-title"><h4 class="rightPanel-title">\u5BF9\u9F50</h4></div><div class="c-schedule-view coverageItem" ng-click="operationBarLeft($event)"><div class="iconfont icon-wenzizuoduiqi"></div><div class="name">\u5DE6\u5BF9\u9F50</div></div><div class="c-schedule-view coverageItem" ng-click="operationBarCenter($event)"><div class="iconfont icon-wenzijuzhong"></div><div class="name">\u5C45\u4E2D\u5BF9\u9F50</div></div><div class="c-schedule-view coverageItem" ng-click="operationBarRight($event)"><div class="iconfont icon-wenziyouduiqi"></div><div class="name">\u53F3\u5BF9\u9F50</div></div><div class="c-schedule-view coverageItem" ng-click="operationBarJustify($event)"><div class="iconfont icon-wenziliangduanduiqi"></div><div class="name">\u4E24\u7AEF\u5BF9\u9F50</div></div></div></li></ul></div><div class="top-btn-right"><div class="iconfont icon-toumingdu" uib-tooltip="\u900F\u660E\u5EA6" tooltip-placement="bottom" ng-click="transparencyCb($event)" ng-class="{\'btn-avtive\':vm.isTransparency,\'disabled-btn\':!vm.xmlSelect.type}"><div class="roundedSet" ng-show="vm.isTransparency" style="width: 320px" ng-click="fn($event)"><div class="roundedSet-title"><h4 class="rightPanel-title">\u900F\u660E\u5EA6\u8BBE\u7F6E</h4></div><div class="c-schedule-view"><input type="range" min="0" max="1" step="0.01" value="{{vm.xmlSelect.transparency}}" ng-model="vm.xmlSelect.transparency" ng-change="changeTransparency($event)" class="text-range" style="width: 100% !important" ng-style="{\'background-size\': vm.xmlSelect.transparency*100 + \'% \' + \'100%\'}"><!--                                <span style="width: 30px;">{{vm.xmlSelect.transparency*100}}</span>--> <input type="number" step="1" class="c-input1" style="width: 70px;height: 30px;padding-right: 0;margin-left: 5px" ng-model="vm.xmlSelect.transparency1" ng-change="transparencyChange1()"></div></div></div><div class="iconfont icon-tuceng" uib-tooltip="\u56FE\u5C42" tooltip-placement="bottom" ng-click="coverageSelect($event)" ng-class="{\'btn-avtive\':vm.isCoverage,\'disabled-btn\':!vm.xmlSelect.type}"><div class="roundedSet" ng-show="vm.isCoverage" style="width: 245px" ng-click="fn($event)"><div class="roundedSet-title"><div class="rightPanel-title">\u56FE\u5C42\u8BBE\u7F6E</div></div><div class="c-schedule-view coverageItem" ng-click="seqStick($event)"><div class="iconfont icon-yizhidingceng"></div><div class="name">\u79FB\u81F3\u9876\u5C42</div></div><div class="c-schedule-view coverageItem" ng-click="seqUp($event)"><div class="iconfont icon-shangyiyiceng"></div><div class="name">\u4E0A\u79FB\u4E00\u5C42</div></div><div class="c-schedule-view coverageItem" ng-click="seqDown($event)"><div class="iconfont icon-shangyiyiceng"></div><div class="name">\u4E0B\u79FB\u4E00\u5C42</div></div><div class="c-schedule-view coverageItem" ng-click="seqBottom($event)"><div class="iconfont icon-xiayiyiceng"></div><div class="name">\u79FB\u81F3\u5E95\u5C42</div></div></div></div><div class="iconfont" uib-tooltip="{{vm.xmlSelect.lock ? \'\u89E3\u9501\' : \'\u9501\u5B9A\'}}" tooltip-placement="bottom" ng-click="xmlLock($event)" ng-class="{\'disabled-btn\':!vm.xmlSelect.type}"><span class="iconfont icon-suoding" ng-class="{\'shake3\':vm.xmlSelect.lock}" style="font-size: 22px"></span></div><div class="iconfont icon-fuzhi2" uib-tooltip="\u590D\u5236" tooltip-placement="bottom" ng-click="xmlCopy($event)" ng-class="{\'disabled-btn\':!vm.xmlSelect.type}"></div><div class="iconfont icon-shanchu" uib-tooltip="\u5220\u9664" tooltip-placement="bottom" ng-click="xmlDelete($event)" ng-class="{\'disabled-btn\':!vm.xmlSelect.type}"></div></div></div><div class="canvas" id="canvas" ng-click="selectCancel()"><div id="c-xml" style="background: #fff; position: relative" ng-if="vm.dataInit" ng-click="xmlClick($event)" ng-dblclick="xmlDblclick($event)" onselectstart="return false" ng-style="{\n                        \'width\': vm.data.textDocument.geometry.width * vm.ratio,\n                        \'height\': vm.data.textDocument.geometry.height * vm.ratio,\n                        \'margin-left\': canvasCoordX(vm.data.textDocument.geometry.width * vm.ratio),\n                        \'margin-top\': canvasCoordY(vm.data.textDocument.geometry.height * vm.ratio)\n                    }"><img id="c-xml-bgImg" ng-if="vm.data.textDocument.background.resource.identifier" ng-src="{{ vm.data.textDocument.background.resource.identifier ? vm.data.textDocument.background.resource.identifier : \'\'}}" style="display: none"><div style="width: 100%; height: 100%; position: absolute; left: 0; top: 0; overflow: hidden"><img id="c-xmlbgImg" ng-if="vm.data.textDocument.background.resource.identifier" ng-src="{{ vm.data.textDocument.background.resource.identifier ? vm.data.textDocument.background.resource.identifier+\'?imageMogr2/thumbnail/800x800>\' : \'\'}}" ng-style="{\n                            \'width\': vm.data.textDocument.background.adaptation == \'Width\' ? vm.data.textDocument.geometry.width * vm.ratio : \'auto\',\n                            \'height\': vm.data.textDocument.background.adaptation == \'Height\' ? vm.data.textDocument.geometry.height * vm.ratio : \'auto\',\n                            \'left\': vm.data.textDocument.background.offsetx * vm.ratio,\n                            \'top\': vm.data.textDocument.background.offsety * vm.ratio\n                        }" style="position: absolute" alt="\u80CC\u666F\u56FE\u7247"></div><div style="width: 100%; height: 100%; position: absolute; left: 0; top: 0; z-index: 1"><div style="width: 100%; height: 100%" ng-repeat=" item in vm.data.textDocument.levels.level track by $index"><div class="c-xml-page-material" ng-click="imageartClick($event, item.imageart, $index)" ng-dblclick="imageartDblclick($event, item.imageart)" ng-class="{\'c-xml-page-material-pitch\': item.imageart.selected , \'selected\': item.imageart.ctrlKey}" ng-if="item.imageart" ng-style="{\n                                \'width\': item.imageart.geometry.width * vm.ratio,\n                                \'height\': item.imageart.geometry.height * vm.ratio,\n                                \'left\': item.imageart.geometry.x * vm.ratio,\n                                \'top\': item.imageart.geometry.y * vm.ratio,\n                                \'transform\': \'rotate(\' + item.imageart.rotation.angle + \'deg)\',\n                                \'z-index\': item.seq-0+200\n                            }"><div style="overflow: hidden; position: relative; width: 100%; height: 100%" ng-mousedown="imageartdown($event,item.imageart)"><img class="c-xml-page-material-img" style="position: absolute" ng-if="item.imageart.resource.identifier" ng-src="{{ item.imageart.resource.identifier ? item.imageart.resource.identifier + \'?imageMogr2/thumbnail/800x800>\' : \'\'}}" ng-style="{\n                                            \'opacity\' : item.imageart.transparency,\n                                            \'left\': item.imageart.offsetx * vm.ratio + \'px\',\n                                            \'top\': item.imageart.offsety * vm.ratio + \'px\',\n                                            \'width\': item.imageart.geometry.width * vm.ratio * item.imageart.scale\n                                        }" alt="\u7D20\u6750\u56FE\u7247"></div><span class="c-xml-page-material-zoom c-xml-page-material-zoom-left1" ng-mousedown="imageartdownZoomLeft($event,item.imageart)" ng-show="!item.imageart.lock"></span> <span class="c-xml-page-material-zoom c-xml-page-material-zoom-top" ng-mousedown="imageartdownZoomTop($event,item.imageart)" ng-show="!item.imageart.lock"></span> <span class="c-xml-page-material-zoom c-xml-page-material-zoom-right1" ng-mousedown="imageartdownZoomRight($event,item.imageart)" ng-show="!item.imageart.lock"></span> <span class="c-xml-page-material-zoom c-xml-page-material-zoom-bottom" ng-mousedown="imageartdownZoomBottom($event,item.imageart)" ng-show="!item.imageart.lock"></span><div class="c-xml-page-material-rotate" ng-show="!item.imageart.lock"><span class="c-xml-page-material-rotate-icon" ng-mousedown="imageartdownRotate($event,item.imageart)"></span></div><div class="c-xml-page-material-lock" ng-show="item.imageart.lock && item.imageart.selected"><span class="iconfont icon-suoding"></span></div></div><div class="c-xml-page-textboxe" ng-click="textboxClick($event, item.textbox, $index)" ng-class="{\'c-xml-page-textboxe-pitch\': item.textbox.selected,\'selected\': item.textbox.ctrlKey}" ng-if="item.textbox" ng-style="{\n                                \'width\': item.textbox.geometry.width * vm.ratio,\n                                \'height\': item.textbox.geometry.height * vm.ratio,\n                                \'left\': item.textbox.geometry.x * vm.ratio,\n                                \'top\': item.textbox.geometry.y * vm.ratio,\n                                \'transform\': \'rotate(\' + item.textbox.rotation.angle + \'deg)\',\n                                \'z-index\': item.seq-0+200\n                            }"><pre class="c-xml-page-textboxe-text web-font" ng-if="!item.textbox.loading" ng-style="{\n                                    \'font-family\': \'\\\'\' + item.textbox.fontuuid + \'\\\'\',\n                                    \'font-size\': (item.textbox.style.size * vm.ratio > 12 ? item.textbox.style.size * vm.ratio : 12) + \'pt\',\n                                    \'color\': item.textbox.style.color,\n                                    \'font-weight\': item.textbox.style.bold ? \'bold\': \'400\',\n                                    \'font-style\': item.textbox.style.italic ? \'italic\': \'initial\',\n                                    \'line-height\': (item.textbox.style.size * vm.ratio > 12 ? item.textbox.style.lineheight * vm.ratio : (item.textbox.style.lineheight * vm.ratio) / (1 / 12 * item.textbox.style.size * vm.ratio)) + \'pt\',\n                                    \'letter-spacing\': (item.textbox.style.size * vm.ratio > 12 ? item.textbox.style.letterspacing * vm.ratio : (item.textbox.style.letterspacing * vm.ratio) / (1 / 12 * item.textbox.style.size * vm.ratio)) + \'pt\',\n                                    \'opacity\': item.textbox.transparency,\n                                    \'text-decoration\': \'none\',\n                                    \'text-align\': item.textbox.style.align,\n                                    \'text-align-last\': \'unset\',\n                                    \'transform\':\'scale(\' + (1 / 12 * item.textbox.style.size * vm.ratio > 1 ? 1 : 1 / 12 * item.textbox.style.size * vm.ratio) + \')\',\n                                    \'width\': item.textbox.style.size * vm.ratio > 12 ? item.textbox.geometry.width * vm.ratio : (item.textbox.geometry.width * vm.ratio) / (1 / 12 * item.textbox.style.size * vm.ratio) + \'px\'\n                                }" ng-dblclick="doubleClicktext($event, item.textbox, $index)" ng-mousedown="textboxdown($event,item.textbox)"><span class="c-xml-page-textboxe-span" ng-blur="textBlur($event,item.textbox)" ng-keyup="changeHeight($event,item.textbox)">{{item.textbox.text}}</span></pre><span class="c-xml-page-material-zoom c-xml-page-material-zoom-left" ng-mousedown="textboxZoomLeft($event,item.textbox)" ng-show="!item.textbox.lock"></span> <span class="c-xml-page-material-zoom c-xml-page-material-zoom-right" ng-mousedown="textboxZoomRight($event,item.textbox)" ng-show="!item.textbox.lock"></span> <span class="c-xml-page-material-zoom c-xml-page-material-zoom-left1" ng-mousedown="textboxZoomLeft1($event,item.textbox)" ng-show="!item.textbox.lock"></span> <span class="c-xml-page-material-zoom c-xml-page-material-zoom-top1" ng-mousedown="textboxZoomTop1($event,item.textbox)" ng-show="!item.textbox.lock"></span> <span class="c-xml-page-material-zoom c-xml-page-material-zoom-right1" ng-mousedown="textboxZoomRight1($event,item.textbox)" ng-show="!item.textbox.lock"></span> <span class="c-xml-page-material-zoom c-xml-page-material-zoom-bottom1" ng-mousedown="textboxZoomBottom1($event,item.textbox)" ng-show="!item.textbox.lock"></span><div class="c-xml-page-material-rotate" ng-show="!item.textbox.lock"><span class="c-xml-page-material-rotate-icon" ng-mousedown="textboxRotate($event,item.textbox)"></span></div><div class="c-xml-page-material-lock" ng-show="item.textbox.lock && item.textbox.selected"><span class="iconfont icon-suoding"></span></div><div class="loading-font" ng-if="item.textbox.loading"><pre class="c-xml-page-textboxe-text web-font" ng-style="{\n                                        \'background\': \'rgba(0,0,0,0)\',\n                                        \'font-size\': (item.textbox.style.size * vm.ratio > 12 ? item.textbox.style.size * vm.ratio : 12) + \'pt\',\n                                        \'color\': item.textbox.style.color,\n                                        \'font-weight\': item.textbox.style.bold ? \'bold\': \'400\',\n                                        \'font-style\': item.textbox.style.italic ? \'italic\': \'initial\',\n                                        \'line-height\': (item.textbox.style.size * vm.ratio > 12 ? item.textbox.style.lineheight * vm.ratio : (item.textbox.style.lineheight * vm.ratio) / (1 / 12 * item.textbox.style.size * vm.ratio)) + \'pt\',\n                                        \'letter-spacing\': (item.textbox.style.size * vm.ratio > 12 ? item.textbox.style.letterspacing * vm.ratio : (item.textbox.style.letterspacing * vm.ratio) / (1 / 12 * item.textbox.style.size * vm.ratio)) + \'pt\',\n                                        \'opacity\': item.textbox.transparency,\n                                        \'text-decoration\': \'none\',\n                                        \'text-align\': item.textbox.style.align,\n                                        \'text-align-last\': \'unset\',\n                                        \'transform\':\'scale(\' + (1 / 12 * item.textbox.style.size * vm.ratio > 1 ? 1 : 1 / 12 * item.textbox.style.size * vm.ratio) + \')\',\n                                        \'width\': item.textbox.style.size * vm.ratio > 12 ? item.textbox.geometry.width * vm.ratio : (item.textbox.geometry.width * vm.ratio) / (1 / 12 * item.textbox.style.size * vm.ratio) + \'px\'\n                                    }"><span class="c-xml-page-textboxe-span">{{item.textbox.text}}</span></pre></div></div></div></div></div><img id="c-xml-page-material-imgId" ng-src="{{ vm.xmlImg ? vm.xmlImg : \'\'}}" style="display: none"><div class="c-xml-imageart-trim" ng-if="vm.isImageartTrim"><div style="margin: 0 auto; position: relative" id="c-xml-imageart-div" ng-style="{\n                        \'width\': vm.data.textDocument.geometry.width * vm.ratio,\n                        \'height\': vm.data.textDocument.geometry.height * vm.ratio,\n                        \'margin-top\': (vm.windowH-vm.data.textDocument.geometry.height * vm.ratio)/2\n                    }"><div id="c-xml-imageart-trim-img" style="position: absolute" ng-style="{\n                            \'width\': vm.imageartTrim.geometry.width1 * vm.ratio,\n                            \'height\': vm.imageartTrim.geometry.height1 * vm.ratio,\n                            \'left\': vm.imageartTrim.geometry.x1 * vm.ratio + \'px\',\n                            \'top\': vm.imageartTrim.geometry.y1 * vm.ratio + \'px\'\n                            }"><div style="position: relative; width: 100%; height: 100%"><div class="c-xml-imageart-trim-div" id="c-xml-imageart-trim-div" ng-style="{\n                                        \'left\': vm.imageartTrim.offsetx * vm.ratio,\n                                        \'top\': vm.imageartTrim.offsety * vm.ratio\n                                    }"><img id="imageartTrimRight1" ng-src="{{vm.imageartTrim.resource.identifier}}" ng-style="{\'width\': vm.imageartTrim.geometry.width1 * vm.ratio * vm.imageartTrim.scale + \'px\'}"><div style="width: 100%; height: 100%; position: absolute; background: rgba(0,0,0,0.5); top: 0; left: 0;z-index: 1"></div><div class="c-xml-operation"><button type="button" ng-click="imageartTrimTrueClick()">\u221A</button> <button type="button" ng-click="imageartTrimFalseClick()">\xD7</button></div><span class="c-xml-page-material-zoom c-xml-page-material-zoom-right" style="display: block; z-index: 10" ng-mousedown="imageartTrimRight1($event,vm.imageartTrim)"></span></div></div></div><div id="c-xml-imageart-trim-frame" style="position: absolute; z-index: 2" ng-style="{\n                                            \'width\': vm.imageartTrim.geometry.width * vm.ratio,\n                                            \'height\': vm.imageartTrim.geometry.height * vm.ratio,\n                                            \'left\': vm.imageartTrim.geometry.x * vm.ratio + \'px\',\n                                            \'top\': vm.imageartTrim.geometry.y * vm.ratio + \'px\'\n                                        }"><div style="width: 100%; height: 100%; overflow: hidden;position: absolute;border: 1px solid #e1a13c"><div style="position: absolute" id="c-xml-imageart-trim-frame-img" ng-mousedown="imageartTrimdown($event)" ng-style="{\n                                    \'left\': vm.imageartTrim.geometry.x1 * vm.ratio - vm.imageartTrim.geometry.x * vm.ratio + vm.imageartTrim.offsetx * vm.ratio,\n                                    \'top\': vm.imageartTrim.geometry.y1 * vm.ratio - vm.imageartTrim.geometry.y * vm.ratio + vm.imageartTrim.offsety * vm.ratio}"><img ng-src="{{vm.imageartTrim.resource.identifier}}" ng-style="{\'width\': vm.imageartTrim.geometry.width1 * vm.ratio * vm.imageartTrim.scale + \'px\'}"></div></div><span class="c-xml-page-material-zoom c-xml-page-material-zoom-right" style="display: block" ng-mousedown="imageartTrimRight($event,vm.imageartTrim)"></span></div></div></div><span id="c-xml-page-material-fontId" style="display: inline-block; opacity: 0" ng-style="{\n                    \'font-family\': \'\\\'\' + vm.fontHide.fontuuid + \'\\\'\',\n                    \'font-size\': (vm.fontHide.style.size * vm.ratio > 12 ? vm.fontHide.style.size * vm.ratio : 12) + \'pt\',\n                    \'color\': vm.fontHide.style.color,\n                    \'font-weight\': vm.fontHide.style.bold ? \'bold\': \'400\',\n                    \'font-style\': vm.fontHide.style.italic ? \'italic\': \'initial\',\n                    \'line-height\': (vm.fontHide.style.size * vm.ratio > 12 ? vm.fontHide.style.lineheight * vm.ratio : (vm.fontHide.style.lineheight * vm.ratio) / (1 / 12 * vm.fontHide.style.size * vm.ratio)) + \'pt\',\n                    \'letter-spacing\': (vm.fontHide.style.size * vm.ratio > 12 ? vm.fontHide.style.letterspacing * vm.ratio : (vm.fontHide.style.letterspacing * vm.ratio) / (1 / 12 * vm.fontHide.style.size * vm.ratio)) + \'pt\',\n                    \'text-decoration\': \'none\',\n                    \'text-align-last\': \'unset\',\n                    \'transform\':\'scale(\' + (1 / 12 * vm.fontHide.style.size * vm.ratio > 1 ? 1 : 1 / 12 * vm.fontHide.style.size * vm.ratio) + \')\'\n                }">{{vm.fontHide.text}}</span><div class="c-xml-bgImg-trim" ng-if="vm.isXmlDblclick"><div style="position: relative;margin: 0 auto" ng-style="{\n                            \'width\': vm.data.textDocument.geometry.width * vm.ratio,\n                            \'height\': vm.data.textDocument.geometry.height * vm.ratio,\n                            \'margin-top\': (vm.windowH-vm.data.textDocument.geometry.height * vm.ratio)/2\n                            }"><div id="c-xml-bgImg-trim-img" style="width: 100%; height: 100%; position: absolute; left: 0; top: 0"><img ng-if="vm.data.textDocument.background.resource.identifier" ng-src="{{ vm.data.textDocument.background.resource.identifier}}" ng-style="{\n                                \'width\': vm.data.textDocument.background.adaptation == \'Width\' ? vm.data.textDocument.geometry.width * vm.ratio : \'auto\',\n                                \'height\': vm.data.textDocument.background.adaptation == \'Height\' ? vm.data.textDocument.geometry.height * vm.ratio : \'auto\',\n                                \'left\': vm.data.textDocument.background.offsetx * vm.ratio,\n                                \'top\': vm.data.textDocument.background.offsety * vm.ratio\n                            }" style="position: absolute" alt="\u80CC\u666F\u56FE\u7247"></div><div style="width: 100%; height: 100%; position: absolute; left: 0; top: 0; z-index: 10; overflow: hidden"><img ng-if="vm.data.textDocument.background.resource.identifier" ng-src="{{ vm.data.textDocument.background.resource.identifier}}" ng-mousedown="bgImgMouseDown($event)" ng-style="{\n                                \'width\': vm.data.textDocument.background.adaptation == \'Width\' ? vm.data.textDocument.geometry.width * vm.ratio : \'auto\',\n                                \'height\': vm.data.textDocument.background.adaptation == \'Height\' ? vm.data.textDocument.geometry.height * vm.ratio : \'auto\',\n                                \'left\': vm.data.textDocument.background.offsetx * vm.ratio,\n                                \'top\': vm.data.textDocument.background.offsety * vm.ratio\n                            }" style="position: absolute" alt="\u80CC\u666F\u56FE\u7247"></div><div class="c-xml-operation" style="z-index: 10"><button type="button" ng-click="bgImgTrueClick()">\u221A</button> <button type="button" ng-click="bgImgFalseClick()">\xD7</button></div></div><div style="position: absolute; left: 0; top: 0; width: 100%; height: 100%; background: rgba(0,0,0,0.5); z-index: 1"></div></div></div><!-- \u7F29\u653E\u64CD\u4F5C\u6309\u94AE --><div class="choose-size-box"><div class="left-menu"><div class="lessen" ng-click="changeCanvasSize(1)" uib-tooltip="\u753B\u5E03\u7F29\u5C0F" tooltip-placement="top" tooltip-append-to-body="true"><i class="iconfont icon-jian"></i></div><div class="ratio">{{(100*vm.ratio)|number:0}}%</div><div class="magnify" ng-click="changeCanvasSize(2)" uib-tooltip="\u753B\u5E03\u653E\u5927" tooltip-placement="top" tooltip-append-to-body="true"><i class="iconfont icon-jia2"></i></div></div><div class="right-menu"><div class="menu-item" ng-click="changeCanvasSize(0)" uib-tooltip="\u521D\u59CB\u5C3A\u5BF8" tooltip-placement="top" tooltip-append-to-body="true"><i class="iconfont icon-fangda"></i></div><div class="menu-item" ng-click="vm.moveCanvasView = !vm.moveCanvasView" uib-tooltip="\u62D6\u62FD\u753B\u5E03" tooltip-placement="top" tooltip-append-to-body="true"><i class="iconfont icon-icon-zhuashou" ng-class="{\'active\' : vm.moveCanvasView}"></i></div><div class="menu-item" ng-click="changeCanvasSize(3)" uib-tooltip="\u539F\u5C3A\u5BF8" tooltip-placement="left" tooltip-append-to-body="true"><i class="iconfont icon-icon-test"></i></div></div></div><div class="moveCanvas-view" ng-mousedown="moveCanvas($event)" ng-if="vm.moveCanvasView" data-html2canvas-ignore></div><div class="unfoldLeft" ng-click="unfoldLeft()"><span class="iconfont icon-right" ng-if="vm.isUnfold"></span> <span class="iconfont icon-left" ng-if="!vm.isUnfold"></span></div><div class="unfoldRight" ng-click="unfoldRight()"><span class="iconfont icon-left" ng-if="vm.isUnfoldRight"></span> <span class="iconfont icon-right" ng-if="!vm.isUnfoldRight"></span></div></div><div class="right" ng-if="!vm.isUnfoldRight"><div class="attribute-head">\u5C5E\u6027\u680F</div><div class="attribute-body"><div class="attribute-body-module" ng-if="vm.xmlSelect.type == \'\'"><div class="attribute-body-module-title">\u4F5C\u54C1\u5C3A\u5BF8</div><div class="attribute-body-module-form"><div class="attribute-body-module-form-input"><span>\u5BBD</span> <input type="text" ng-model="vm.attribute.product.width"></div><div class="attribute-body-module-form-select"><select ng-model="vm.unit" ng-options="unit.id as unit.name for unit in vm.units" ng-change="unitConversion()"></select></div></div><div class="attribute-body-module-form"><div class="attribute-body-module-form-input"><span>\u9AD8</span> <input type="text" ng-model="vm.attribute.product.height"></div><div class="attribute-body-module-form-select"><select ng-model="vm.unit" ng-options="unit.id as unit.name for unit in vm.units" ng-change="unitConversion()"></select></div></div></div><div class="attribute-body-module" ng-if="vm.xmlSelect.type == \'textbox\'"><!--                    <div class="attribute-body-module-title">\u6587\u5B57\u5185\u5BB9</div>--><!--                    <div class="attribute-body-module-form">--><!--                        <textarea id="fontContent" ng-model="vm.font.text" ng-blur="verifyText()"></textarea>--><!--                    </div>--><div class="attribute-body-module-title" style="margin-top: 16px">\u6587\u5B57\u5C3A\u5BF8</div><div class="attribute-body-module-form"><div class="attribute-body-module-form-input"><span>\u5BBD</span> <input type="text" ng-model="vm.attribute.font.width"></div><div class="attribute-body-module-form-select"><select ng-model="vm.unit" ng-options="unit.id as unit.name for unit in vm.units" ng-change="unitConversion()"></select></div></div></div><div class="attribute-body-module" ng-if="vm.xmlSelect.type == \'textbox\'"><div class="attribute-body-module-title">\u5750\u6807</div><div class="attribute-body-module-form"><div class="attribute-body-module-form-input"><span>X</span> <input type="text" ng-model="vm.attribute.font.x"></div><div class="attribute-body-module-form-select"><select ng-model="vm.unit" ng-options="unit.id as unit.name for unit in vm.units" ng-change="unitConversion()"></select></div></div><div class="attribute-body-module-form"><div class="attribute-body-module-form-input"><span>Y</span> <input type="text" ng-model="vm.attribute.font.y"></div><div class="attribute-body-module-form-select"><select ng-model="vm.unit" ng-options="unit.id as unit.name for unit in vm.units" ng-change="unitConversion()"></select></div></div></div><div class="attribute-body-module" ng-if="vm.xmlSelect.type == \'imageart\'"><div class="attribute-body-module-title" style="margin-top: 16px">\u7D20\u6750\u5C3A\u5BF8</div><div class="attribute-body-module-form"><div class="attribute-body-module-form-input"><span>\u5BBD</span> <input type="text" ng-model="vm.attribute.material.width" ng-change="attributeMaterialWidth()"></div><div class="attribute-body-module-form-select"><select ng-model="vm.unit" ng-options="unit.id as unit.name for unit in vm.units" ng-change="unitConversion()"></select></div></div><div class="attribute-body-module-form"><div class="attribute-body-module-form-input"><span>\u9AD8</span> <input type="text" ng-model="vm.attribute.material.height" ng-change="attributeMaterialHeight()"></div><div class="attribute-body-module-form-select"><select ng-model="vm.unit" ng-options="unit.id as unit.name for unit in vm.units" ng-change="unitConversion()"></select></div></div></div><div class="attribute-body-module" ng-if="vm.xmlSelect.type == \'imageart\'"><div class="attribute-body-module-title">\u5750\u6807</div><div class="attribute-body-module-form"><div class="attribute-body-module-form-input"><span>X</span> <input type="text" ng-model="vm.attribute.material.x"></div><div class="attribute-body-module-form-select"><select ng-model="vm.unit" ng-options="unit.id as unit.name for unit in vm.units" ng-change="unitConversion()"></select></div></div><div class="attribute-body-module-form"><div class="attribute-body-module-form-input"><span>Y</span> <input type="text" ng-model="vm.attribute.material.y"></div><div class="attribute-body-module-form-select"><select ng-model="vm.unit" ng-options="unit.id as unit.name for unit in vm.units" ng-change="unitConversion()"></select></div></div></div><div class="thumbnail-title">\u5F53\u524D\u9875\u9762\u7F29\u7565\u56FE</div><div class="thumbnail"><div id="c-xml1" style="background: #fff; margin: 0 auto 0; position: relative" ng-style="{\n                            \'width\': vm.data.textDocument.geometry.width * vm.ratio1,\n                            \'height\': vm.data.textDocument.geometry.height * vm.ratio1\n                        }"><div style="width: 100%; height: 100%; position: absolute; left: 0; top: 0; overflow: hidden"><img ng-if="vm.data.textDocument.background.resource.identifier" ng-src="{{ vm.data.textDocument.background.resource.identifier ? vm.data.textDocument.background.resource.identifier : \'\'}}" ng-style="{\n                                    \'width\': vm.data.textDocument.background.adaptation == \'Width\' ? vm.data.textDocument.geometry.width * vm.ratio1 : \'auto\',\n                                    \'height\': vm.data.textDocument.background.adaptation == \'Height\' ? vm.data.textDocument.geometry.height * vm.ratio1 : \'auto\',\n                                    \'left\': vm.data.textDocument.background.offsetx * vm.ratio1,\n                                    \'top\': vm.data.textDocument.background.offsety * vm.ratio1\n                                }" style="position: absolute" alt="\u80CC\u666F\u56FE\u7247"></div><div style="width: 100%; height: 100%; position: absolute; left: 0; top: 0; z-index: 1; overflow: hidden"><div style="width: 100%; height: 100%" ng-repeat=" item in vm.data.textDocument.levels.level track by $index"><div class="c-xml-page-material" ng-if="item.imageart" ng-style="{\n                                        \'width\': item.imageart.geometry.width * vm.ratio1,\n                                        \'height\': item.imageart.geometry.height * vm.ratio1,\n                                        \'left\': item.imageart.geometry.x * vm.ratio1,\n                                        \'top\': item.imageart.geometry.y * vm.ratio1,\n                                        \'transform\': \'rotate(\' + item.imageart.rotation.angle + \'deg)\',\n                                        \'z-index\': item.seq-0+200\n                                    }"><div style="overflow: hidden; position: relative; width: 100%; height: 100%"><img class="c-xml-page-material-img" style="position: absolute" ng-if="item.imageart.resource.identifier" ng-src="{{ item.imageart.resource.identifier ? item.imageart.resource.identifier : \'\'}}" ng-style="{\n                                                \'opacity\' : item.imageart.transparency,\n                                                \'left\': item.imageart.offsetx * vm.ratio1 + \'px\',\n                                                \'top\': item.imageart.offsety * vm.ratio1 + \'px\',\n                                                \'width\': item.imageart.geometry.width * vm.ratio1 * item.imageart.scale\n                                            }" alt="\u7D20\u6750\u56FE\u7247"></div></div><div class="c-xml-page-textboxe" ng-if="item.textbox" ng-style="{\n                                        \'width\': item.textbox.geometry.width * vm.ratio1,\n                                        \'height\': item.textbox.geometry.height * vm.ratio1,\n                                        \'left\': item.textbox.geometry.x * vm.ratio1,\n                                        \'top\': item.textbox.geometry.y * vm.ratio1,\n                                        \'transform\': \'rotate(\' + item.textbox.rotation.angle + \'deg)\',\n                                        \'z-index\': item.seq-0+200\n                                    }"><pre class="c-xml-page-textboxe-text web-font" ng-style="{\n                                            \'font-family\': \'\\\'\' + item.textbox.fontuuid + \'\\\'\',\n                                            \'font-size\': (item.textbox.style.size * vm.ratio1 > 12 ? item.textbox.style.size * vm.ratio1 : 12) + \'pt\',\n                                            \'color\': item.textbox.style.color,\n                                            \'font-weight\': item.textbox.style.bold ? \'bold\': \'400\',\n                                            \'font-style\': item.textbox.style.italic ? \'italic\': \'initial\',\n                                            \'line-height\': (item.textbox.style.size * vm.ratio1 > 12 ? item.textbox.style.lineheight * vm.ratio1 : (item.textbox.style.lineheight * vm.ratio1) / (1 / 12 * item.textbox.style.size * vm.ratio1)) + \'pt\',\n                                            \'letter-spacing\': (item.textbox.style.size * vm.ratio1 > 12 ? item.textbox.style.letterspacing * vm.ratio1 : (item.textbox.style.letterspacing * vm.ratio1) / (1 / 12 * item.textbox.style.size * vm.ratio1)) + \'pt\',\n                                            \'opacity\': item.textbox.transparency,\n                                            \'text-decoration\': \'none\',\n                                            \'text-align\': item.textbox.style.align,\n                                            \'text-align-last\': \'unset\',\n                                            \'transform\':\'scale(\' + (1 / 12 * item.textbox.style.size * vm.ratio1 > 1 ? 1 : 1 / 12 * item.textbox.style.size * vm.ratio1) + \')\',\n                                            \'width\': item.textbox.style.size * vm.ratio1 > 12 ? item.textbox.geometry.width * vm.ratio1 : (item.textbox.geometry.width * vm.ratio1) / (1 / 12 * item.textbox.style.size * vm.ratio1) + 2 + \'px\'\n                                        }"><span style="display: inline-block; width: 100%; white-space: pre-wrap; word-break: break-word">{{item.textbox.text}}</span></pre></div></div></div></div></div></div></div></div></div><div style="opacity: 0; position: fixed" ng-style="{\n        \'width\': writingmodeInit(vm.textEditor.style.writingmode) ? \'auto\' : (vm.textEditor.geometry.width),\n        \'height\': !writingmodeInit(vm.textEditor.style.writingmode) ? \'auto\' : (vm.textEditor.geometry.height)\n        }"><pre id="c-xml-page-material-fontId2" style="display: inline-block; opacity: 0" ng-style="{\n        \'font-family\': \'\\\'\' + vm.textEditor.fontuuid + \'\\\'\',\n        \'font-size\': (vm.textEditor.style.size) + \'pt\',\n        \'color\': vm.textEditor.style.color,\n        \'font-weight\': vm.textEditor.style.bold ? \'bold\': \'400\',\n        \'font-style\': vm.textEditor.style.italic ? \'italic\': \'initial\',\n        \'line-height\': (vm.textEditor.style.lineheight) + \'pt\',\n        \'letter-spacing\': (vm.textEditor.style.letterspacing) + \'pt\',\n        \'text-decoration\': \'none\',\n        \'text-align-last\':\'unset\',\n        \'max-width\' : \'100%\',\n        \'writing-mode\': vm.textEditor.style.writingmode\n        }"><span class="c-xml-page-textboxe-span">{{vm.textEditor.text}}</span></pre></div><!--\u52A0\u8F7D\u4E2D--><div class="c-loading" ng-if="vm.loading"></div><style>.wrap{\n        display: none !important;\n    }</style>');
$templateCache.put('app/entities/text/text-xml.html','<!--<div class="c-xml">--><!--    <div class="c-xml-head">--><!--        <div class="c-xml-logo"><img src="content/images/momentsgo.png" alt="logo"></div>--><!--&lt;!&ndash;        <div class="c-xml-head-fileSelect">&ndash;&gt;--><!--&lt;!&ndash;            <div class="c-xml-head-fileSelect-span">\u6587\u4EF6</div>&ndash;&gt;--><!--&lt;!&ndash;            <div class="c-xml-head-fileSelect-list">&ndash;&gt;--><!--&lt;!&ndash;                <ul>&ndash;&gt;--><!--&lt;!&ndash;                    <li ng-repeat="item in vm.fileSelect">{{item.name}}</li>&ndash;&gt;--><!--&lt;!&ndash;                </ul>&ndash;&gt;--><!--&lt;!&ndash;            </div>&ndash;&gt;--><!--&lt;!&ndash;        </div>&ndash;&gt;--><!--        <div class="c-xml-head-name">--><!--            <input type="text" ng-model="vm.data.name">--><!--        </div>--><!--        <div class="clearfix c-xml-head-fr">--><!--            <button type="button" class="c-xml-head-btn1" ng-click="out()">\u9000\u51FA</button>--><!--            <button type="button" class="c-xml-head-btn1" ng-click="save()">\u4FDD\u5B58\u81F3\u4F5C\u54C1</button>--><!--            <button type="button" class="c-xml-head-btn2" ng-click="publish()">\u4FDD\u5B58\u5E76\u53D1\u5E03</button>--><!--        </div>--><!--    </div>--><!--    <div style="position: absolute;width: 100%; height: calc(100vh - 50px);min-width: 1300px;">--><!--        <div class="c-xml-nav">--><!--            <ul>--><!--                <li ng-repeat="item in vm.navList track by $index"--><!--                    ng-class="{\'c-xml-navOn\':item.id == vm.navPitch}"--><!--                    ng-click="navCb(item)">--><!--                    <img ng-src="{{item.img}}" alt="">--><!--                    <span>{{item.name}}</span>--><!--                    <div class="c-xml-navOn-border"></div>--><!--                </li>--><!--            </ul>--><!--        </div>--><!--        <div class="c-xml-cdr"--><!--             ng-style="{left: vm.isUnfold ? \'-300px\' : \'60px\'}">--><!--            <div class="c-xml-cdr-font" ng-show="vm.navPitch == \'font\'">--><!--                <ul>--><!--                    <li ng-repeat="font in vm.fontList">--><!--                        <div class="c-xml-cdr-font-div" ng-click="fontAdd(font)">--><!--    &lt;!&ndash;                        <span style="font-size: 12px;">{{font.name}}</span>&ndash;&gt;--><!--                            <img ng-src="{{vm.url + font.fontStyles[0].identifier}}" alt="">--><!--                        </div>--><!--                    </li>--><!--                </ul>--><!--            </div>--><!--            <div class="c-xml-cdr-background" ng-show="vm.navPitch == \'background\'">--><!--                <div class="c-xml-cdr-head">--><!--                    <span class="c-xml-cdr-background-btn">\u6DFB\u52A0\u80CC\u666F</span>--><!--                    <input type="file" name="file" multiple="multiple"--><!--                           class="c-xml-cdr-background-file" accept=" image/jpeg, image/png"--><!--                           onchange="updatePic(event, \'background\')" ng-model-options="{debounce : 500}">--><!--                </div>--><!--                <div class="c-xml-cdr-body">--><!--                    <ul class="clearfix">--><!--                        <li ng-repeat="item in vm.bgImgList track by $index" ng-click="bgImgCb(item)">--><!--                            <div class="c-xml-cdr-body-img"--><!--                                 ng-class="{\'c-xml-cdr-body-imgOn\': item.identifier == vm.data.textDocument.background.resource.identifier}">--><!--                                <img ng-src="{{item.identifier}}" alt="">--><!--                                <div class="c-xml-cdr-delete" ng-click="bgImgDelete($event, item, $index)"></div>--><!--                            </div>--><!--                        </li>--><!--                    </ul>--><!--                </div>--><!--                <div class="c-xml-cdr-body-paging">--><!--                    <button type="button" ng-click="bgImgPageing()" ng-if="!vm.isBgImgData">\u52A0\u8F7D\u66F4\u591A</button>--><!--                    <span ng-if="vm.isBgImgData">\u6682\u65E0\u66F4\u591A...</span>--><!--                </div>--><!--            </div>--><!--            <div class="c-xml-cdr-material" ng-show="vm.navPitch == \'material\'">--><!--                <div class="c-xml-cdr-head1">--><!--                    <ul class="clearfix">--><!--                        <li ng-class="{\'themeOn\': vm.isTheme == \'isTheme\'}" ng-click="themeClassifiesCb1()">--><!--                            <span>\u6211\u7684\u7D20\u6750</span>--><!--                        </li>--><!--                        <li ng-repeat="item in vm.themeClassifies track by $index" ng-click="themeClassifiesCb(item)" ng-class="{\'themeOn\': vm.isTheme == item.id}">--><!--                            <span>{{item.name}}</span>--><!--                        </li>--><!--                    </ul>--><!--                </div>--><!--                <div class="c-xml-cdr-head" style="position: relative;">--><!--                    <span class="c-xml-cdr-background-btn">\u6DFB\u52A0\u7D20\u6750</span>--><!--                    <input type="file" name="file" multiple="multiple"--><!--                           class="c-xml-cdr-background-file" accept=" image/jpeg, image/png"--><!--                           onchange="updatePic(event, \'material\')" ng-model-options="{debounce : 500}">--><!--                </div>--><!--                <div class="c-xml-cdr-body">--><!--                    <ul class="clearfix">--><!--                        <li ng-repeat="item in vm.materialList track by $index" ng-click="materialCb(item)">--><!--                            <div class="c-xml-cdr-body-img">--><!--                                <img ng-src="{{item.identifier}}" alt="">--><!--                                <div class="c-xml-cdr-delete" ng-click="materialDelete($event, item, $index)"></div>--><!--                            </div>--><!--                        </li>--><!--                    </ul>--><!--                </div>--><!--                <div class="c-xml-cdr-body-paging">--><!--                    <button type="button" ng-click="materialPageing()" ng-if="!vm.isMaterialData">\u52A0\u8F7D\u66F4\u591A</button>--><!--                    <span ng-if="vm.isMaterialData">\u6682\u65E0\u66F4\u591A...</span>--><!--                </div>--><!--            </div>--><!--        </div>--><!--        <div class="c-xml-action" ng-style="{left: vm.isUnfold ? \'60px\' : \'300px\', right: vm.isUnfoldRight ? \'0\' : \'200px\'}">--><!--            <ul class="clearfix c-xml-action-icon-font" ng-show="vm.isFont">--><!--                <li>--><!--                    <div class="c-xml-action-div-icon c-xml-action-div-icon-color"--><!--                         ng-click="operationColorOpen($event)"--><!--                         ng-style="{background: vm.font.style.color}"--><!--                         style="border: 1px solid #ddd;">--><!--                        <div class="tip3">\u989C\u8272</div>--><!--                    </div>--><!--                    <div class="c-xml-action-div-color-modal clearfix"--><!--                         ng-style="{--><!--                         \'opacity\': vm.isOperationColor ? \'1\' : \'0\',--><!--                         \'top\':  vm.isOperationColor ? \'40px\' : \'-500px\'--><!--                         }">--><!--                        <input class="c-xml-action-div-color-modal-btn" type="color" ng-change="chooseColor()" ng-model="vm.font.style.color"/>--><!--                        <span ng-repeat="item in vm.colorList track by $index"--><!--                              ng-style="{ \'background\' : item.id}"--><!--                              ng-class="{\'c-xml-action-div-color-on\' : item.id == vm.font.style.color}"--><!--                              ng-click="operationColor(item)"></span>--><!--                    </div>--><!--                </li>--><!--                <li>--><!--                    <div class="c-font-view">--><!--                        <div class="c-font-view-head" ng-style="{\'font-family\': \'\\\'\' + vm.font.fontuuid + \'\\\'\',}">{{vm.selectFontName(vm.font.fontuuid)}}</div>--><!--                        <div class="c-font-view-body">--><!--                            <div class="c-font-view-body-head">--><!--                                <input type="text" class="c-font-view-body-head-input" ng-model="vm.selectFont" ng-change="vm.selectFontBtn()">--><!--                                <span class="c-font-view-body-head-btn" ng-click="vm.selectFontBtn()"></span>--><!--                            </div>--><!--                            <div class="c-font-view-body-ul">--><!--                                <div class="c-font-view-body-li" ng-repeat="item in vm.fontList1 track by $index" ng-click="operationFontFamily(item)" ng-class="{\'c-font-view-body-li-on\' : vm.font.fontuuid == item.uuid}">--><!--                                    <img ng-src="{{vm.url + item.fontStyles[0].identifier}}" alt="" ng-if="item.fontStyles[0].identifier">--><!--                                    <span ng-if="!item.fontStyles[0].identifier">{{item.name}}</span>--><!--                                </div>--><!--                            </div>--><!--                        </div>--><!--                    </div>--><!--                </li>--><!--                <li>--><!--                    <select class="c-select1" style="height: 30px;"--><!--                            ng-model="vm.font.style.size" ng-options="item.id as item.name for item in vm.sizeList"--><!--                            ng-change="operationFont()"></select>--><!--                </li>--><!--                <li ng-if="vm.font.style.italic1">--><!--                    <div class="c-xml-action-div-icon" style="background-size: auto;"--><!--                         ng-class="{\'tools_bar_italic\':!vm.font.style.italic,\'tools_bar_italic_Selected\':vm.font.style.italic}"--><!--                         ng-click="operationItalic()">--><!--                        <div class="tip3">\u659C\u4F53</div>--><!--                    </div>--><!--                </li>--><!--    &lt;!&ndash;            <li>&ndash;&gt;--><!--    &lt;!&ndash;&lt;!&ndash;                ng-class="{\'tools_bar_underline\':!vm.font.style.italic,\'tools_bar_underline_Selected\':vm.font.style.italic}"&ndash;&gt;&ndash;&gt;--><!--    &lt;!&ndash;                <div class="c-xml-action-div-icon tools_bar_underline"&ndash;&gt;--><!--    &lt;!&ndash;                     ng-click="operationItalic()">&ndash;&gt;--><!--    &lt;!&ndash;                    <div class="tip3">\u4E0B\u5212\u7EBF</div>&ndash;&gt;--><!--    &lt;!&ndash;                </div>&ndash;&gt;--><!--    &lt;!&ndash;            </li>&ndash;&gt;--><!--                <li ng-if="vm.font.style.bold1">--><!--                    <div class="c-xml-action-div-icon"--><!--                         ng-class="{\'tools_bar_bold\':!vm.font.style.bold,\'tools_bar_bold_Selected\':vm.font.style.bold}"--><!--                         ng-click="operationBold()">--><!--                        <div class="tip3">\u7C97\u4F53</div>--><!--                    </div>--><!--                </li>--><!--                <li ng-click="operationSpacing($event)">--><!--                    <div class="c-xml-action-div-icon tools_bar_spacing1">--><!--                        <div class="tip3">\u95F4\u8DDD</div>--><!--                    </div>--><!--                    <div class="c-xml-action-div-transparency" ng-if="vm.isOperationSpacing" style="height: auto; width: auto; margin-left: -136px;">--><!--                        <div class="c-xml-action-div-transparency" style=" position: unset;margin: 0 0 10px 0; border: 0; box-shadow: none; padding: 0; height: 30px; width: 250px;">--><!--                            <span class="c-xml-action-div-transparency-title">\u5B57\u95F4\u8DDD</span>--><!--                            <div class="c-xml-action-div-transparency-bar">--><!--                                <div class="c-xml-action-div-transparency-bar1"></div>--><!--                                <span class="c-xml-action-div-transparency-bar2"--><!--                                      id="c-xml-wordSpace"--><!--                                      ng-mousedown="wordSpacedown($event)"--><!--                                      ng-style="{--><!--                                    left: vm.font.style.letterspacing--><!--                                  }"--><!--                                ></span>--><!--                            </div>--><!--                            <input type="number" class="c-xml-action-div-transparency-input" ng-model="vm.font.style.letterspacing">--><!--                        </div>--><!--                        <div class="c-xml-action-div-transparency" style="position: unset;margin: 0; border: 0; box-shadow: none; padding: 0; height: 30px; width: 250px;">--><!--                            <span class="c-xml-action-div-transparency-title">\u884C\u95F4\u8DDD</span>--><!--                            <div class="c-xml-action-div-transparency-bar">--><!--                                <div class="c-xml-action-div-transparency-bar1"></div>--><!--                                <span class="c-xml-action-div-transparency-bar2"--><!--                                      id="c-xml-lineSpace"--><!--                                      ng-mousedown="lineSpacedown($event)"--><!--                                      ng-style="{--><!--                                    left: vm.font.style.lineheight--><!--                                  }"--><!--                                ></span>--><!--                            </div>--><!--                            <input type="number" class="c-xml-action-div-transparency-input" ng-model="vm.font.style.lineheight">--><!--                        </div>--><!--                    </div>--><!--                </li>--><!--                <li>--><!--                    <div class="c-xml-action-div-icon-align">--><!--                        <div class="c-xml-action-div-icon-align-div clearfix">--><!--                            <div class="c-xml-action-div-icon tools_bar_left_justifying" ng-click="operationBarLeft($event)"><div class="tip3">\u5DE6\u5BF9\u9F50</div></div>--><!--                            <div class="c-xml-action-div-icon tools_bar_align_center" ng-click="operationBarCenter($event)"><div class="tip3">\u5C45\u4E2D\u5BF9\u9F50</div></div>--><!--                            <div class="c-xml-action-div-icon tools_bar_align_right" ng-click="operationBarRight($event)"><div class="tip3">\u53F3\u5BF9\u9F50</div></div>--><!--                            <div class="c-xml-action-div-icon tools_bar_justify_align" ng-click="operationBarJustify($event)"><div class="tip3">\u4E24\u7AEF\u5BF9\u9F50</div></div>--><!--                        </div>--><!--                    </div>--><!--                </li>--><!--            </ul>--><!--            <ul class="clearfix c-xml-action-icon">--><!--                <li ng-click="transparencyCb($event)">--><!--                    <div class="c-xml-action-div-icon tools_bar_transparency">--><!--                        <div class="tip3">\u900F\u660E\u5EA6</div>--><!--                    </div>--><!--                    <div class="c-xml-action-div-transparency" ng-if="vm.isTransparency">--><!--                        <span class="c-xml-action-div-transparency-title">\u900F\u660E\u5EA6</span>--><!--                        <div class="c-xml-action-div-transparency-bar">--><!--                            <div class="c-xml-action-div-transparency-bar1"></div>--><!--                            <span class="c-xml-action-div-transparency-bar2"--><!--                                  id="c-xml-action-div-transparency-bar"--><!--                                  ng-mousedown="transparencydown($event)"--><!--                                  ng-style="{--><!--                                    left: vm.xmlSelect.transparency--><!--                                  }"--><!--                            ></span>--><!--                        </div>--><!--                        <input type="number" class="c-xml-action-div-transparency-input" ng-model="vm.xmlSelect.transparency">--><!--                    </div>--><!--                </li>--><!--                <li class="c-xml-action-div-seq">--><!--                    <div class="c-xml-action-div-icon tools_bar_coverage"></div>--><!--                    <div class="c-xml-action-div-icon-align-div clearfix">--><!--                        <div class="c-xml-action-div-icon coverage_move_up" ng-click="seqUp($event)"><div class="tip3">\u4E0A\u79FB\u4E00\u5C42</div></div>--><!--                        <div class="c-xml-action-div-icon coverage_move_down" ng-click="seqDown($event)"><div class="tip3">\u4E0B\u79FB\u4E00\u5C42</div></div>--><!--                        <div class="c-xml-action-div-icon coverage_stick" ng-click="seqStick($event)"><div class="tip3">\u7F6E\u9876</div></div>--><!--                        <div class="c-xml-action-div-icon coverage_bottom" ng-click="seqBottom($event)"><div class="tip3">\u7F6E\u5E95</div></div>--><!--                    </div>--><!--                </li>--><!--                <li>--><!--                    <div class="c-xml-action-div-icon tools_bar_lock" ng-click="xmlLock()">--><!--                        <div class="tip3">\u9501\u5B9A</div>--><!--                    </div>--><!--                </li>--><!--                <li>--><!--                    <div class="c-xml-action-div-icon tools_bar_copy" ng-click="xmlCopy()">--><!--                        <div class="tip3">\u590D\u5236</div>--><!--                    </div>--><!--                </li>--><!--                <li>--><!--                    <div class="c-xml-action-div-icon tools_bar_revocation" ng-click="xmlRevocation()">--><!--                        <div class="tip3">\u4E0A\u4E00\u6B65</div>--><!--                    </div>--><!--                </li>--><!--                <li>--><!--                    <div class="c-xml-action-div-icon tools_bar_recover" ng-click="xmlNextStep()">--><!--                        <div class="tip3">\u6062\u590D</div>--><!--                    </div>--><!--                </li>--><!--                <li>--><!--                    <div class="c-xml-action-div-icon tools_bar_delete" ng-click="xmlDelete()">--><!--                        <div class="tip3">\u5220\u9664</div>--><!--                    </div>--><!--                </li>--><!--                <li>--><!--                    <div class="c-xml-action-div-icon tools_bar_full_screen" ng-click="fullScreen()" ng-if="!vm.isFullScreen">--><!--                        <div class="tip3">{{!vm.isFullScreen ? \'\u5168\u5C4F\' : \'\u9000\u51FA\u5168\u5C4F\'}}</div>--><!--                    </div>--><!--                    <div class="c-xml-action-div-icon tools_bar_full_screen" ng-click="exitScreen()" ng-if="vm.isFullScreen">--><!--                        <div class="tip3">{{!vm.isFullScreen ? \'\u5168\u5C4F\' : \'\u9000\u51FA\u5168\u5C4F\'}}</div>--><!--                    </div>--><!--                </li>--><!--            </ul>--><!--        </div>--><!--        <div class="c-xml-content" ng-style="{left: vm.isUnfold ? \'60px\' : \'300px\', right: vm.isUnfoldRight ? \'0\' : \'200px\', \'background-color\' : vm.isXmlDblclick ? \'#999\' : \'#ececec\'}">--><!--    &lt;!&ndash;        <div class="c-xml-font" ng-if="vm.isFont">&ndash;&gt;--><!--    &lt;!&ndash;            <input type="text" ng-model="vm.font.text">&ndash;&gt;--><!--    &lt;!&ndash;        </div>&ndash;&gt;--><!--            <div id="c-xml" style="background: #fff; margin: 0 auto; position: relative;"--><!--                 ng-click="xmlClick($event)"--><!--                 ng-dblclick = "xmlDblclick($event)"--><!--                 onselectstart="return false"--><!--                 ng-style="{--><!--                    \'width\': vm.data.textDocument.geometry.width * vm.ratio,--><!--                    \'height\': vm.data.textDocument.geometry.height * vm.ratio,--><!--                    \'margin-top\': (vm.windowH-vm.data.textDocument.geometry.height * vm.ratio)/2--><!--                 }">--><!--                <img id="c-xml-bgImg" ng-if="vm.data.textDocument.background.resource.identifier" ng-src="{{ vm.data.textDocument.background.resource.identifier ? vm.data.textDocument.background.resource.identifier : \'\'}}" style="display: none;">--><!--                <div style="width: 100%; height: 100%; position: absolute; left: 0; top: 0; overflow: hidden;">--><!--                    <img id="c-xmlbgImg" ng-if="vm.data.textDocument.background.resource.identifier"--><!--                         ng-src="{{ vm.data.textDocument.background.resource.identifier ? vm.data.textDocument.background.resource.identifier : \'\'}}"--><!--                         ng-style="{--><!--                        \'width\': vm.data.textDocument.background.adaptation == \'Width\' ? vm.data.textDocument.geometry.width * vm.ratio : \'auto\',--><!--                        \'height\': vm.data.textDocument.background.adaptation == \'Height\' ? vm.data.textDocument.geometry.height * vm.ratio : \'auto\',--><!--                        \'left\': vm.data.textDocument.background.offsetx * vm.ratio,--><!--                        \'top\': vm.data.textDocument.background.offsety * vm.ratio--><!--                     }"--><!--                         style="position: absolute;"--><!--                         alt="\u80CC\u666F\u56FE\u7247">--><!--                </div>--><!--                <div style="width: 100%; height: 100%; position: absolute; left: 0; top: 0; z-index: 1; overflow: hidden;">--><!--                    <div style="width: 100%; height: 100%;"--><!--                         ng-repeat=" item in vm.data.textDocument.levels.level track by $index">--><!--                        <div class="c-xml-page-material"--><!--                             ng-click="imageartClick($event, item.imageart, $index)"--><!--                             ng-dblclick="imageartDblclick($event, item.imageart)"--><!--                             ng-class="{\'c-xml-page-material-pitch\': item.imageart.selected}"--><!--                             ng-if="item.imageart"--><!--                             ng-style="{--><!--                            \'width\': item.imageart.geometry.width * vm.ratio,--><!--                            \'height\': item.imageart.geometry.height * vm.ratio,--><!--                            \'left\': item.imageart.geometry.x * vm.ratio,--><!--                            \'top\': item.imageart.geometry.y * vm.ratio,--><!--                            \'transform\': \'rotate(\' + item.imageart.rotation.angle + \'deg)\',--><!--                            \'z-index\': item.seq-0+200--><!--                         }">--><!--                            <div style="overflow: hidden; position: relative; width: 100%; height: 100%;"--><!--                                 ng-mousedown="imageartdown($event,item.imageart)">--><!--                                <img class="c-xml-page-material-img"--><!--                                     style="position: absolute;"--><!--                                     ng-if="item.imageart.resource.identifier"--><!--                                     ng-src="{{ item.imageart.resource.identifier ? item.imageart.resource.identifier : \'\'}}"--><!--                                     ng-style="{--><!--                                        \'opacity\' : item.imageart.transparency,--><!--                                        \'left\': item.imageart.offsetx * vm.ratio + \'px\',--><!--                                        \'top\': item.imageart.offsety * vm.ratio + \'px\',--><!--                                        \'width\': item.imageart.geometry.width * vm.ratio * item.imageart.scale--><!--                                     }"--><!--                                     alt="\u7D20\u6750\u56FE\u7247">--><!--                            </div>--><!--                            <span class="c-xml-page-material-zoom c-xml-page-material-zoom-left1"--><!--                                  ng-mousedown="imageartdownZoomLeft($event,item.imageart)"></span>--><!--                            <span class="c-xml-page-material-zoom c-xml-page-material-zoom-top"--><!--                                  ng-mousedown="imageartdownZoomTop($event,item.imageart)"></span>--><!--                            <span class="c-xml-page-material-zoom c-xml-page-material-zoom-right1"--><!--                                  ng-mousedown="imageartdownZoomRight($event,item.imageart)"></span>--><!--                            <span class="c-xml-page-material-zoom c-xml-page-material-zoom-bottom"--><!--                                  ng-mousedown="imageartdownZoomBottom($event,item.imageart)"></span>--><!--                            <div class="c-xml-page-material-rotate">--><!--                                <span class="c-xml-page-material-rotate-icon"--><!--                                  ng-mousedown="imageartdownRotate($event,item.imageart)"></span>--><!--                            </div>--><!--                        </div>--><!--                        <div class="c-xml-page-textboxe"--><!--                             ng-click="textboxClick($event, item.textbox, $index)"--><!--                             ng-dblclick="textboxDblclick($event, item.textbox)"--><!--                             ng-class="{\'c-xml-page-textboxe-pitch\': item.textbox.selected}"--><!--                             ng-if="item.textbox"--><!--                             ng-style="{--><!--                            \'width\': item.textbox.geometry.width * vm.ratio,--><!--                            \'height\': item.textbox.geometry.height * vm.ratio,--><!--                            \'left\': item.textbox.geometry.x * vm.ratio,--><!--                            \'top\': item.textbox.geometry.y * vm.ratio,--><!--                            \'transform\': \'rotate(\' + item.textbox.rotation.angle + \'deg)\',--><!--                            \'z-index\': item.seq-0+200--><!--                         }">--><!--                            <pre class="c-xml-page-textboxe-text web-font"--><!--                                 ng-if="!item.textbox.loading"--><!--                                  ng-style="{--><!--                                \'font-family\': \'\\\'\' + item.textbox.fontuuid + \'\\\'\',--><!--                                \'font-size\': (item.textbox.style.size * vm.ratio > 12 ? item.textbox.style.size * vm.ratio : 12) + \'pt\',--><!--                                \'color\': item.textbox.style.color,--><!--                                \'font-weight\': item.textbox.style.bold ? \'bold\': \'400\',--><!--                                \'font-style\': item.textbox.style.italic ? \'italic\': \'initial\',--><!--                                \'line-height\': (item.textbox.style.size * vm.ratio > 12 ? item.textbox.style.lineheight * vm.ratio : (item.textbox.style.lineheight * vm.ratio1) / (1 / 12 * item.textbox.style.size * vm.ratio1)) + \'pt\',--><!--                                \'letter-spacing\': (item.textbox.style.size * vm.ratio > 12 ? item.textbox.style.letterspacing * vm.ratio : (item.textbox.style.letterspacing * vm.ratio) / (1 / 12 * item.textbox.style.size * vm.ratio)) + \'pt\',--><!--                                \'opacity\': item.textbox.transparency,--><!--                                \'text-decoration\': \'none\',--><!--                                \'text-align\': item.textbox.style.align,--><!--                                \'text-align-last\': item.textbox.style.align == \'justified\' ? \'justify\' : \'unset\',--><!--                                \'transform\':\'scale(\' + (1 / 12 * item.textbox.style.size * vm.ratio > 1 ? 1 : 1 / 12 * item.textbox.style.size * vm.ratio) + \')\',--><!--                                \'width\': item.textbox.style.size * vm.ratio > 12 ? item.textbox.geometry.width * vm.ratio : (item.textbox.geometry.width * vm.ratio) / (1 / 12 * item.textbox.style.size * vm.ratio) + \'px\'--><!--                              }"--><!--                                  ng-mousedown="textboxdown($event,item.textbox)"><span style="display: inline-block; width: 100%; white-space: pre-wrap; word-break: break-word;">{{item.textbox.text}}</span></pre>--><!--                            <span class="c-xml-page-material-zoom c-xml-page-material-zoom-left"--><!--                                  ng-mousedown="textboxZoomLeft($event,item.textbox)"></span>--><!--                            <span class="c-xml-page-material-zoom c-xml-page-material-zoom-right"--><!--                                  ng-mousedown="textboxZoomRight($event,item.textbox)"></span>--><!--                            <span class="c-xml-page-material-zoom c-xml-page-material-zoom-left1"--><!--                                  ng-mousedown="textboxZoomLeft1($event,item.textbox)"></span>--><!--                            <span class="c-xml-page-material-zoom c-xml-page-material-zoom-top1"--><!--                                  ng-mousedown="textboxZoomTop1($event,item.textbox)"></span>--><!--                            <span class="c-xml-page-material-zoom c-xml-page-material-zoom-right1"--><!--                                  ng-mousedown="textboxZoomRight1($event,item.textbox)"></span>--><!--                            <span class="c-xml-page-material-zoom c-xml-page-material-zoom-bottom1"--><!--                                  ng-mousedown="textboxZoomBottom1($event,item.textbox)"></span>--><!--                            <div class="c-xml-page-material-rotate">--><!--                            <span class="c-xml-page-material-rotate-icon"--><!--                                  ng-mousedown="textboxRotate($event,item.textbox)"></span>--><!--                            </div>--><!--                            <div class="loading-font" ng-if="item.textbox.loading">--><!--                                <pre class="c-xml-page-textboxe-text web-font"--><!--                                     ng-style="{--><!--                                     \'background\': \'rgba(0,0,0,0)\',--><!--                                    \'font-size\': (item.textbox.style.size * vm.ratio > 12 ? item.textbox.style.size * vm.ratio : 12) + \'pt\',--><!--                                    \'color\': item.textbox.style.color,--><!--                                    \'font-weight\': item.textbox.style.bold ? \'bold\': \'400\',--><!--                                    \'font-style\': item.textbox.style.italic ? \'italic\': \'initial\',--><!--                                    \'line-height\': (item.textbox.style.size * vm.ratio > 12 ? item.textbox.style.lineheight * vm.ratio : (item.textbox.style.lineheight * vm.ratio) / (1 / 12 * item.textbox.style.size * vm.ratio)) + \'pt\',--><!--                                    \'letter-spacing\': (item.textbox.style.size * vm.ratio > 12 ? item.textbox.style.letterspacing * vm.ratio : (item.textbox.style.letterspacing * vm.ratio) / (1 / 12 * item.textbox.style.size * vm.ratio)) + \'pt\',--><!--                                    \'opacity\': item.textbox.transparency,--><!--                                    \'text-decoration\': \'none\',--><!--                                    \'text-align\': item.textbox.style.align,--><!--                                    \'text-align-last\': item.textbox.style.align == \'justified\' ? \'justify\' : \'unset\',--><!--                                    \'transform\':\'scale(\' + (1 / 12 * item.textbox.style.size * vm.ratio > 1 ? 1 : 1 / 12 * item.textbox.style.size * vm.ratio) + \')\',--><!--                                    \'width\': item.textbox.style.size * vm.ratio > 12 ? item.textbox.geometry.width * vm.ratio : (item.textbox.geometry.width * vm.ratio) / (1 / 12 * item.textbox.style.size * vm.ratio) + \'px\'--><!--                                  }"><span style="display: inline-block; width: 100%; white-space: pre-wrap; word-break: break-word;">{{item.textbox.text}}</span></pre>--><!--                            </div>--><!--                        </div>--><!--                    </div>--><!--                </div>--><!--                <div class="c-xml-operation" ng-if="vm.isXmlDblclick">--><!--                    <button type="button" ng-click="bgImgTrueClick()">\u221A</button>--><!--                    <button type="button" ng-click="bgImgFalseClick()">\xD7</button>--><!--                </div>--><!--            </div>--><!--            <img id="c-xml-page-material-imgId" ng-src="{{ vm.xmlImg}}" style="display: none;">--><!--            <div class="c-xml-imageart-trim" ng-if="vm.isImageartTrim">--><!--                <div style="margin: 0 auto; position: relative;"--><!--                     id="c-xml-imageart-div"--><!--                     ng-style="{--><!--                    \'width\': vm.data.textDocument.geometry.width * vm.ratio,--><!--                    \'height\': vm.data.textDocument.geometry.height * vm.ratio,--><!--                    \'margin-top\': (vm.windowH-vm.data.textDocument.geometry.height * vm.ratio)/2--><!--                 }">--><!--                    <div id="c-xml-imageart-trim-img" style="position: absolute;"--><!--                         ng-style="{--><!--                        \'width\': vm.imageartTrim.geometry.width1 * vm.ratio,--><!--                        \'height\': vm.imageartTrim.geometry.height1 * vm.ratio,--><!--                        \'left\': vm.imageartTrim.geometry.x1 * vm.ratio + \'px\',--><!--                        \'top\': vm.imageartTrim.geometry.y1 * vm.ratio + \'px\'--><!--                        }">--><!--                        <div style="position: relative; width: 100%; height: 100%;">--><!--                            <div class="c-xml-imageart-trim-div"--><!--                                 id="c-xml-imageart-trim-div"--><!--                                 ng-style="{--><!--                                    \'left\': vm.imageartTrim.offsetx * vm.ratio,--><!--                                    \'top\': vm.imageartTrim.offsety * vm.ratio--><!--                                 }">--><!--                                <img id="imageartTrimRight1" ng-src="{{vm.imageartTrim.resource.identifier}}" ng-style="{\'width\': vm.imageartTrim.geometry.width1 * vm.ratio * vm.imageartTrim.scale + \'px\'}">--><!--                                <div style="width: 100%; height: 100%; position: absolute; background: rgba(0,0,0,0.5); top: 0; left: 0;z-index: 1;"></div>--><!--                                <div class="c-xml-operation">--><!--                                    <button type="button" ng-click="imageartTrimTrueClick()">\u221A</button>--><!--                                    <button type="button" ng-click="imageartTrimFalseClick()">\xD7</button>--><!--                                </div>--><!--                                <span class="c-xml-page-material-zoom c-xml-page-material-zoom-right" style="display: block; z-index: 10;"--><!--                                      ng-mousedown="imageartTrimRight1($event,vm.imageartTrim)"></span>--><!--                            </div>--><!--                        </div>--><!--                    </div>--><!--                    <div id="c-xml-imageart-trim-frame"--><!--                         style="position: absolute; z-index: 2;"--><!--                         ng-style="{--><!--                                        \'width\': vm.imageartTrim.geometry.width * vm.ratio,--><!--                                        \'height\': vm.imageartTrim.geometry.height * vm.ratio,--><!--                                        \'left\': vm.imageartTrim.geometry.x * vm.ratio + \'px\',--><!--                                        \'top\': vm.imageartTrim.geometry.y * vm.ratio + \'px\'--><!--                                     }">--><!--                        <div style="width: 100%; height: 100%; overflow: hidden;position: absolute;border: 1px solid #e1a13c;">--><!--                            <div style="position: absolute;"--><!--                                 id="c-xml-imageart-trim-frame-img"--><!--                                 ng-mousedown="imageartTrimdown($event)"--><!--                                 ng-style="{--><!--                                \'left\': vm.imageartTrim.geometry.x1 * vm.ratio - vm.imageartTrim.geometry.x * vm.ratio + vm.imageartTrim.offsetx * vm.ratio,--><!--                                \'top\': vm.imageartTrim.geometry.y1 * vm.ratio - vm.imageartTrim.geometry.y * vm.ratio + vm.imageartTrim.offsety * vm.ratio}">--><!--                                <img ng-src="{{vm.imageartTrim.resource.identifier}}"--><!--                                     ng-style="{\'width\': vm.imageartTrim.geometry.width1 * vm.ratio * vm.imageartTrim.scale + \'px\'}">--><!--                            </div>--><!--                        </div>--><!--                        <span class="c-xml-page-material-zoom c-xml-page-material-zoom-right" style="display: block;"--><!--                              ng-mousedown="imageartTrimRight($event,vm.imageartTrim)"></span>--><!--                    </div>--><!--                </div>--><!--            </div>--><!--            <span id="c-xml-page-material-fontId" style="display: inline-block; opacity: 0" ng-style="{--><!--                \'font-family\': \'\\\'\' + vm.fontHide.fontuuid + \'\\\'\',--><!--                \'font-size\': (vm.fontHide.style.size * vm.ratio > 12 ? vm.fontHide.style.size * vm.ratio : 12) + \'pt\',--><!--                \'color\': vm.fontHide.style.color,--><!--                \'font-weight\': vm.fontHide.style.bold ? \'bold\': \'400\',--><!--                \'font-style\': vm.fontHide.style.italic ? \'italic\': \'initial\',--><!--                \'line-height\': (vm.fontHide.style.size * vm.ratio > 12 ? vm.fontHide.style.lineheight * vm.ratio : (vm.fontHide.style.lineheight * vm.ratio1) / (1 / 12 * vm.fontHide.style.size * vm.ratio1)) + \'pt\',--><!--                \'letter-spacing\': (vm.fontHide.style.size * vm.ratio > 12 ? vm.fontHide.style.letterspacing * vm.ratio : (vm.fontHide.style.letterspacing * vm.ratio) / (1 / 12 * vm.fontHide.style.size * vm.ratio)) + \'px\',--><!--                \'text-decoration\': \'none\',--><!--                \'text-align-last\': vm.fontHide.style.align == \'justified\' ? \'justify\' : \'unset\',--><!--                \'transform\':\'scale(\' + (1 / 12 * vm.fontHide.style.size * vm.ratio > 1 ? 1 : 1 / 12 * vm.fontHide.style.size * vm.ratio) + \')\'--><!--              }">{{vm.fontHide.text}}</span>--><!--            <div class="c-xml-bgImg-trim" ng-if="vm.isXmlDblclick">--><!--                <div style=" position: relative;margin: 0 auto;"--><!--                     ng-style="{--><!--                        \'width\': vm.data.textDocument.geometry.width * vm.ratio,--><!--                        \'height\': vm.data.textDocument.geometry.height * vm.ratio,--><!--                        \'margin-top\': (vm.windowH-vm.data.textDocument.geometry.height * vm.ratio)/2--><!--                        }">--><!--                    <div id="c-xml-bgImg-trim-img" style="width: 100%; height: 100%; position: absolute; left: 0; top: 0;">--><!--                        <img ng-if="vm.data.textDocument.background.resource.identifier"--><!--                             ng-src="{{ vm.data.textDocument.background.resource.identifier}}"--><!--                             ng-style="{--><!--                            \'width\': vm.data.textDocument.background.adaptation == \'Width\' ? vm.data.textDocument.geometry.width * vm.ratio : \'auto\',--><!--                            \'height\': vm.data.textDocument.background.adaptation == \'Height\' ? vm.data.textDocument.geometry.height * vm.ratio : \'auto\',--><!--                            \'left\': vm.data.textDocument.background.offsetx * vm.ratio,--><!--                            \'top\': vm.data.textDocument.background.offsety * vm.ratio--><!--                         }"--><!--                             style="position: absolute;"--><!--                             alt="\u80CC\u666F\u56FE\u7247">--><!--                    </div>--><!--                    <div style="width: 100%; height: 100%; position: absolute; left: 0; top: 0; z-index: 10; overflow: hidden;">--><!--                        <img ng-if="vm.data.textDocument.background.resource.identifier"--><!--                             ng-src="{{ vm.data.textDocument.background.resource.identifier}}"--><!--                             ng-mousedown="bgImgMouseDown($event)"--><!--                             ng-style="{--><!--                            \'width\': vm.data.textDocument.background.adaptation == \'Width\' ? vm.data.textDocument.geometry.width * vm.ratio : \'auto\',--><!--                            \'height\': vm.data.textDocument.background.adaptation == \'Height\' ? vm.data.textDocument.geometry.height * vm.ratio : \'auto\',--><!--                            \'left\': vm.data.textDocument.background.offsetx * vm.ratio,--><!--                            \'top\': vm.data.textDocument.background.offsety * vm.ratio--><!--                         }"--><!--                             style="position: absolute;"--><!--                             alt="\u80CC\u666F\u56FE\u7247">--><!--                    </div>--><!--                    <div class="c-xml-operation" style="z-index: 10;">--><!--                        <button type="button" ng-click="bgImgTrueClick()">\u221A</button>--><!--                        <button type="button" ng-click="bgImgFalseClick()">\xD7</button>--><!--                    </div>--><!--                </div>--><!--                <div style="position: absolute; left: 0; top: 0; width: 100%; height: 100%; background: rgba(0,0,0,0.5); z-index: 1"></div>--><!--            </div>--><!--        </div>--><!--        <div class="c-xml-attribute" ng-style="{right: vm.isUnfoldRight ? \'-300px\' : \'0\', display: vm.isUnfoldRight ? \'none\' : \'block\'}">--><!--            <div class="c-xml-attribute-head">\u5C5E\u6027\u680F</div>--><!--            <div class="c-xml-attribute-body">--><!--                <div class="c-xml-attribute-body-module" ng-if="vm.xmlSelect.type == \'\'">--><!--                    <div class="c-xml-attribute-body-module-title">\u4F5C\u54C1\u5C3A\u5BF8</div>--><!--                    <div class="c-xml-attribute-body-module-form clearfix">--><!--                        <div class="c-xml-attribute-body-module-form-input">--><!--                            <input type="text" ng-model="vm.attribute.product.width">--><!--                            <span>\u5BBD</span>--><!--                        </div>--><!--                        <div class="c-xml-attribute-body-module-form-select">--><!--                            <select ng-model="vm.unit" ng-options="unit.id as unit.name for unit in vm.units" ng-change="unitConversion()"></select>--><!--                        </div>--><!--                    </div>--><!--                    <div class="c-xml-attribute-body-module-form clearfix">--><!--                        <div class="c-xml-attribute-body-module-form-input">--><!--                            <input type="text" ng-model="vm.attribute.product.height">--><!--                            <span>\u9AD8</span>--><!--                        </div>--><!--                        <div class="c-xml-attribute-body-module-form-select">--><!--                            <select ng-model="vm.unit" ng-options="unit.id as unit.name for unit in vm.units" ng-change="unitConversion()"></select>--><!--                        </div>--><!--                    </div>--><!--                </div>--><!--    &lt;!&ndash;            <div class="c-xml-attribute-body-module" ng-if="vm.xmlSelect.type == \'\'">&ndash;&gt;--><!--    &lt;!&ndash;                <div class="c-xml-attribute-body-module-title">\u80CC\u666F\u5C3A\u5BF8</div>&ndash;&gt;--><!--    &lt;!&ndash;                <div class="c-xml-attribute-body-module-form clearfix">&ndash;&gt;--><!--    &lt;!&ndash;                    <div class="c-xml-attribute-body-module-form-input">&ndash;&gt;--><!--    &lt;!&ndash;                        <input type="text" ng-model="vm.attribute.background.width">&ndash;&gt;--><!--    &lt;!&ndash;                        <span>\u5BBD</span>&ndash;&gt;--><!--    &lt;!&ndash;                    </div>&ndash;&gt;--><!--    &lt;!&ndash;                    <div class="c-xml-attribute-body-module-form-select">&ndash;&gt;--><!--    &lt;!&ndash;                        <select ng-model="vm.unit" ng-options="unit.id as unit.name for unit in vm.units" ng-change="unitConversion()"></select>&ndash;&gt;--><!--    &lt;!&ndash;                    </div>&ndash;&gt;--><!--    &lt;!&ndash;                </div>&ndash;&gt;--><!--    &lt;!&ndash;                <div class="c-xml-attribute-body-module-form clearfix">&ndash;&gt;--><!--    &lt;!&ndash;                    <div class="c-xml-attribute-body-module-form-input">&ndash;&gt;--><!--    &lt;!&ndash;                        <input type="text" ng-model="vm.attribute.background.height">&ndash;&gt;--><!--    &lt;!&ndash;                        <span>\u9AD8</span>&ndash;&gt;--><!--    &lt;!&ndash;                    </div>&ndash;&gt;--><!--    &lt;!&ndash;                    <div class="c-xml-attribute-body-module-form-select">&ndash;&gt;--><!--    &lt;!&ndash;                        <select ng-model="vm.unit" ng-options="unit.id as unit.name for unit in vm.units" ng-change="unitConversion()"></select>&ndash;&gt;--><!--    &lt;!&ndash;                    </div>&ndash;&gt;--><!--    &lt;!&ndash;                </div>&ndash;&gt;--><!--    &lt;!&ndash;            </div>&ndash;&gt;--><!--    &lt;!&ndash;            <div class="c-xml-attribute-body-module" ng-if="vm.xmlSelect.type == \'\'">&ndash;&gt;--><!--    &lt;!&ndash;                <div class="c-xml-attribute-body-module-title">\u80CC\u666F\u5750\u6807\u5C3A\u5BF8</div>&ndash;&gt;--><!--    &lt;!&ndash;                <div class="c-xml-attribute-body-module-form clearfix">&ndash;&gt;--><!--    &lt;!&ndash;                    <div class="c-xml-attribute-body-module-form-input">&ndash;&gt;--><!--    &lt;!&ndash;                        <input type="text" ng-model="vm.attribute.background.x">&ndash;&gt;--><!--    &lt;!&ndash;                        <span>X\u8F74</span>&ndash;&gt;--><!--    &lt;!&ndash;                    </div>&ndash;&gt;--><!--    &lt;!&ndash;                    <div class="c-xml-attribute-body-module-form-select">&ndash;&gt;--><!--    &lt;!&ndash;                        <select ng-model="vm.unit" ng-options="unit.id as unit.name for unit in vm.units" ng-change="unitConversion()"></select>&ndash;&gt;--><!--    &lt;!&ndash;                    </div>&ndash;&gt;--><!--    &lt;!&ndash;                </div>&ndash;&gt;--><!--    &lt;!&ndash;                <div class="c-xml-attribute-body-module-form clearfix">&ndash;&gt;--><!--    &lt;!&ndash;                    <div class="c-xml-attribute-body-module-form-input">&ndash;&gt;--><!--    &lt;!&ndash;                        <input type="text" ng-model="vm.attribute.background.y">&ndash;&gt;--><!--    &lt;!&ndash;                        <span>Y\u8F74</span>&ndash;&gt;--><!--    &lt;!&ndash;                    </div>&ndash;&gt;--><!--    &lt;!&ndash;                    <div class="c-xml-attribute-body-module-form-select">&ndash;&gt;--><!--    &lt;!&ndash;                        <select ng-model="vm.unit" ng-options="unit.id as unit.name for unit in vm.units" ng-change="unitConversion()"></select>&ndash;&gt;--><!--    &lt;!&ndash;                    </div>&ndash;&gt;--><!--    &lt;!&ndash;                </div>&ndash;&gt;--><!--    &lt;!&ndash;            </div>&ndash;&gt;--><!--                <div class="c-xml-attribute-body-module" ng-if="vm.xmlSelect.type == \'textbox\'">--><!--                    <div class="c-xml-attribute-body-module-title">\u6587\u5B57\u5185\u5BB9</div>--><!--                    <div class="c-xml-attribute-body-module-form">--><!--                        <textarea class="c-textarea1" ng-model="vm.font.text" style="width: 90%;" ng-blur="verifyText()"></textarea>--><!--                    </div>--><!--                </div>--><!--                <div class="c-xml-attribute-body-module" ng-if="vm.xmlSelect.type == \'textbox\'">--><!--                    <div class="c-xml-attribute-body-module-title">\u6587\u5B57\u5C3A\u5BF8</div>--><!--                    <div class="c-xml-attribute-body-module-form clearfix">--><!--                        <div class="c-xml-attribute-body-module-form-input">--><!--                            <input type="text" ng-model="vm.attribute.font.width">--><!--                            <span>\u5BBD</span>--><!--                        </div>--><!--                        <div class="c-xml-attribute-body-module-form-select">--><!--                            <select ng-model="vm.unit" ng-options="unit.id as unit.name for unit in vm.units" ng-change="unitConversion()"></select>--><!--                        </div>--><!--                    </div>--><!--                </div>--><!--                <div class="c-xml-attribute-body-module" ng-if="vm.xmlSelect.type == \'textbox\'">--><!--                    <div class="c-xml-attribute-body-module-title">\u5750\u6807\u5C3A\u5BF8</div>--><!--                    <div class="c-xml-attribute-body-module-form clearfix">--><!--                        <div class="c-xml-attribute-body-module-form-input">--><!--                            <input type="text" ng-model="vm.attribute.font.x">--><!--                            <span>X\u8F74</span>--><!--                        </div>--><!--                        <div class="c-xml-attribute-body-module-form-select">--><!--                            <select ng-model="vm.unit" ng-options="unit.id as unit.name for unit in vm.units" ng-change="unitConversion()"></select>--><!--                        </div>--><!--                    </div>--><!--                    <div class="c-xml-attribute-body-module-form clearfix">--><!--                        <div class="c-xml-attribute-body-module-form-input">--><!--                            <input type="text" ng-model="vm.attribute.font.y">--><!--                            <span>Y\u8F74</span>--><!--                        </div>--><!--                        <div class="c-xml-attribute-body-module-form-select">--><!--                            <select ng-model="vm.unit" ng-options="unit.id as unit.name for unit in vm.units" ng-change="unitConversion()"></select>--><!--                        </div>--><!--                    </div>--><!--                </div>--><!--                <div class="c-xml-attribute-body-module" ng-if="vm.xmlSelect.type == \'imageart\'">--><!--                    <div class="c-xml-attribute-body-module-title">\u7D20\u6750\u5C3A\u5BF8</div>--><!--                    <div class="c-xml-attribute-body-module-form clearfix">--><!--                        <div class="c-xml-attribute-body-module-form-input">--><!--                            <input type="text" ng-model="vm.attribute.material.width" ng-change="attributeMaterialWidth()">--><!--                            <span>\u5BBD</span>--><!--                        </div>--><!--                        <div class="c-xml-attribute-body-module-form-select">--><!--                            <select ng-model="vm.unit" ng-options="unit.id as unit.name for unit in vm.units" ng-change="unitConversion()"></select>--><!--                        </div>--><!--                    </div>--><!--                    <div class="c-xml-attribute-body-module-form clearfix">--><!--                        <div class="c-xml-attribute-body-module-form-input">--><!--                            <input type="text" ng-model="vm.attribute.material.height" ng-change="attributeMaterialHeight()">--><!--                            <span>\u9AD8</span>--><!--                        </div>--><!--                        <div class="c-xml-attribute-body-module-form-select">--><!--                            <select ng-model="vm.unit" ng-options="unit.id as unit.name for unit in vm.units" ng-change="unitConversion()"></select>--><!--                        </div>--><!--                    </div>--><!--                </div>--><!--                <div class="c-xml-attribute-body-module" ng-if="vm.xmlSelect.type == \'imageart\'">--><!--                    <div class="c-xml-attribute-body-module-title">\u5750\u6807\u5C3A\u5BF8</div>--><!--                    <div class="c-xml-attribute-body-module-form clearfix">--><!--                        <div class="c-xml-attribute-body-module-form-input">--><!--                            <input type="text" ng-model="vm.attribute.material.x">--><!--                            <span>X\u8F74</span>--><!--                        </div>--><!--                        <div class="c-xml-attribute-body-module-form-select">--><!--                            <select ng-model="vm.unit" ng-options="unit.id as unit.name for unit in vm.units" ng-change="unitConversion()"></select>--><!--                        </div>--><!--                    </div>--><!--                    <div class="c-xml-attribute-body-module-form clearfix">--><!--                        <div class="c-xml-attribute-body-module-form-input">--><!--                            <input type="text" ng-model="vm.attribute.material.y">--><!--                            <span>Y\u8F74</span>--><!--                        </div>--><!--                        <div class="c-xml-attribute-body-module-form-select">--><!--                            <select ng-model="vm.unit" ng-options="unit.id as unit.name for unit in vm.units" ng-change="unitConversion()"></select>--><!--                        </div>--><!--                    </div>--><!--                </div>--><!--    &lt;!&ndash;            <div class="c-xml-attribute-body-module">&ndash;&gt;--><!--    &lt;!&ndash;                <div class="c-xml-attribute-body-module-title">\u7F16\u8F91\u8BBE\u7F6E</div>&ndash;&gt;--><!--    &lt;!&ndash;                <div class="c-xml-attribute-body-module-edit">&ndash;&gt;--><!--    &lt;!&ndash;                    <div class="clearfix" style="display: inline-block;">&ndash;&gt;--><!--    &lt;!&ndash;                        <span class="c-xml-attribute-body-module-edit-btn1"&ndash;&gt;--><!--    &lt;!&ndash;                              ng-class="{\'c-xml-attribute-body-module-edit-btnOn\': vm.xmlSelect.editable}"&ndash;&gt;--><!--    &lt;!&ndash;                              ng-click="editableTrue()">\u53EF\u7F16\u8F91</span>&ndash;&gt;--><!--    &lt;!&ndash;                        <span class="c-xml-attribute-body-module-edit-btn2"&ndash;&gt;--><!--    &lt;!&ndash;                              ng-class="{\'c-xml-attribute-body-module-edit-btnOn\': !vm.xmlSelect.editable}"&ndash;&gt;--><!--    &lt;!&ndash;                              ng-click="editableFalse()">\u4E0D\u53EF\u7F16\u8F91</span>&ndash;&gt;--><!--    &lt;!&ndash;                    </div>&ndash;&gt;--><!--    &lt;!&ndash;                </div>&ndash;&gt;--><!--    &lt;!&ndash;            </div>&ndash;&gt;--><!--                <div class="c-xml-attribute-body-module" style="border-bottom: 0;">--><!--                    <div class="c-xml-attribute-body-module-title">\u5F53\u524D\u9875\u9762\u7F29\u7565\u56FE</div>--><!--                    <div class="c-xml-thumbnail">--><!--                        <div class="c-xml-thumbnail">--><!--                            <div id="c-xml1" style="background: #fff; margin: 10px auto 0; position: relative;"--><!--                                 ng-style="{--><!--                                    \'width\': vm.data.textDocument.geometry.width * vm.ratio1,--><!--                                    \'height\': vm.data.textDocument.geometry.height * vm.ratio1--><!--                                 }">--><!--                                <div style="width: 100%; height: 100%; position: absolute; left: 0; top: 0; overflow: hidden;">--><!--                                    <img ng-if="vm.data.textDocument.background.resource.identifier"--><!--                                         ng-src="{{ vm.data.textDocument.background.resource.identifier}}"--><!--                                         ng-style="{--><!--                                            \'width\': vm.data.textDocument.background.adaptation == \'Width\' ? vm.data.textDocument.geometry.width * vm.ratio1 : \'auto\',--><!--                                            \'height\': vm.data.textDocument.background.adaptation == \'Height\' ? vm.data.textDocument.geometry.height * vm.ratio1 : \'auto\',--><!--                                            \'left\': vm.data.textDocument.background.offsetx * vm.ratio1,--><!--                                            \'top\': vm.data.textDocument.background.offsety * vm.ratio1--><!--                                         }"--><!--                                         style="position: absolute;"--><!--                                         alt="\u80CC\u666F\u56FE\u7247">--><!--                                </div>--><!--                                <div style="width: 100%; height: 100%; position: absolute; left: 0; top: 0; z-index: 1; overflow: hidden;">--><!--                                    <div style="width: 100%; height: 100%;"--><!--                                         ng-repeat=" item in vm.data.textDocument.levels.level track by $index">--><!--                                        <div class="c-xml-page-material"--><!--                                             ng-if="item.imageart"--><!--                                             ng-style="{--><!--                                                \'width\': item.imageart.geometry.width * vm.ratio1,--><!--                                                \'height\': item.imageart.geometry.height * vm.ratio1,--><!--                                                \'left\': item.imageart.geometry.x * vm.ratio1,--><!--                                                \'top\': item.imageart.geometry.y * vm.ratio1,--><!--                                                \'transform\': \'rotate(\' + item.imageart.rotation.angle + \'deg)\',--><!--                                                \'z-index\': item.seq-0+200--><!--                                             }">--><!--                                            <div style="overflow: hidden; position: relative; width: 100%; height: 100%;">--><!--                                                <img class="c-xml-page-material-img"--><!--                                                     style="position: absolute;"--><!--                                                     ng-if="item.imageart.resource.identifier"--><!--                                                     ng-src="{{ item.imageart.resource.identifier ? item.imageart.resource.identifier : \'\'}}"--><!--                                                     ng-style="{--><!--                                                        \'opacity\' : item.imageart.transparency,--><!--                                                        \'left\': item.imageart.offsetx * vm.ratio1 + \'px\',--><!--                                                        \'top\': item.imageart.offsety * vm.ratio1 + \'px\',--><!--                                                        \'width\': item.imageart.geometry.width * vm.ratio1 * item.imageart.scale--><!--                                                     }"--><!--                                                     alt="\u7D20\u6750\u56FE\u7247">--><!--                                            </div>--><!--                                        </div>--><!--                                        <div class="c-xml-page-textboxe"--><!--                                             ng-if="item.textbox"--><!--                                             ng-style="{--><!--                                                \'width\': item.textbox.geometry.width * vm.ratio1,--><!--                                                \'height\': item.textbox.geometry.height * vm.ratio1,--><!--                                                \'left\': item.textbox.geometry.x * vm.ratio1,--><!--                                                \'top\': item.textbox.geometry.y * vm.ratio1,--><!--                                                \'transform\': \'rotate(\' + item.textbox.rotation.angle + \'deg)\',--><!--                                                \'z-index\': item.seq-0+200--><!--                                             }">--><!--                                                <pre class="c-xml-page-textboxe-text web-font"--><!--                                                      ng-style="{--><!--                                                    \'font-family\': \'\\\'\' + item.textbox.fontuuid + \'\\\'\',--><!--                                                    \'font-size\': (item.textbox.style.size * vm.ratio1 > 12 ? item.textbox.style.size * vm.ratio1 : 12) + \'pt\',--><!--                                                    \'color\': item.textbox.style.color,--><!--                                                    \'font-weight\': item.textbox.style.bold ? \'bold\': \'400\',--><!--                                                    \'font-style\': item.textbox.style.italic ? \'italic\': \'initial\',--><!--                                                    \'line-height\': (item.textbox.style.size * vm.ratio1 > 12 ? item.textbox.style.lineheight * vm.ratio1 : (item.textbox.style.lineheight * vm.ratio1) / (1 / 12 * item.textbox.style.size * vm.ratio1)) + \'pt\',--><!--                                                    \'letter-spacing\': (item.textbox.style.size * vm.ratio1 > 12 ? item.textbox.style.letterspacing * vm.ratio1 : (item.textbox.style.letterspacing * vm.ratio1) / (1 / 12 * item.textbox.style.size * vm.ratio1)) + \'pt\',--><!--                                                    \'opacity\': item.textbox.transparency,--><!--                                                    \'text-decoration\': \'none\',--><!--                                                    \'text-align\': item.textbox.style.align,--><!--                                                    \'text-align-last\': item.textbox.style.align == \'justified\' ? \'justify\' : \'unset\',--><!--                                                    \'transform\':\'scale(\' + (1 / 12 * item.textbox.style.size * vm.ratio1 > 1 ? 1 : 1 / 12 * item.textbox.style.size * vm.ratio1) + \')\',--><!--                                                    \'width\': item.textbox.style.size * vm.ratio1 > 12 ? item.textbox.geometry.width * vm.ratio1 : (item.textbox.geometry.width * vm.ratio1) / (1 / 12 * item.textbox.style.size * vm.ratio1) + 2 + \'px\'--><!--                                                  }"><span style="display: inline-block; width: 100%; white-space: pre-wrap; word-break: break-word;">{{item.textbox.text}}</span></pre>--><!--                                        </div>--><!--                                    </div>--><!--                                </div>--><!--                            </div>--><!--                        </div>--><!--                    </div>--><!--                </div>--><!--            </div>--><!--        </div>--><!--    &lt;!&ndash;    <div class="unfold-left" ng-style="{left: vm.isUnfold ? \'60px\' : \'300px\'}" ng-click="unfoldLeft()"></div>&ndash;&gt;--><!--        <div class="unfold-right" ng-style="{right: vm.isUnfoldRight ? \'0\' : \'200px\'}" ng-click="unfoldRight()"></div>--><!--    </div>--><!--</div>-->');
$templateCache.put('app/entities/text/text.html','<div class="workbench"><div class="work-head"><div class="work-title">\u6587\u5B57\u7EC4\u4EF6</div><div class="search-box"><div class="search-input"><i class="iconfont icon-sousuo"></i> <input type="text" ng-model="vm.searchQuery" ng-readonly="vm.batchState" ng-keydown="vm.search()" placeholder="\u5173\u952E\u8BCD\u641C\u7D22"></div><div class="handle"><div class="batch-btn" ng-if="!vm.batchState" ng-click="vm.batchState = true"><i class="iconfont icon-batch"></i>\u6279\u91CF\u64CD\u4F5C</div><div class="btn-primary" ng-if="vm.batchState" ng-click="vm.batchState = false">\u9000\u51FA</div><div class="btn-primary" ng-if="!vm.batchState" style="margin-left: 8px" ng-click="add()">\u521B\u5EFA\u6587\u5B57</div></div></div></div><div class="share-screen"><div class="screen-line" style="padding-top: 8px"><div class="screen"><div class="genre no-cut"><div class="item" ng-repeat="item in vm.statusList" ng-class="{\'active\' : item.value === vm.selectStatus}" ng-click="statusCheck(item.value)">{{item.label}}</div></div></div></div></div><div class="template-list"><div class="empty-view" ng-if="vm.textList.length < 1"><img class="empty-img" src="content/images/text-empty.png" alt="\u65E0\u6570\u636E"><div class="empty-text">\u8FD8\u6CA1\u6709\u5185\u5BB9\u54E6\uFF0C<span class="link" ng-click="add()">\u5FEB\u53BB\u521B\u5EFA\u5427<i class="iconfont icon-right"></i></span></div></div><div class="template-item" ng-repeat="item in vm.textList track by item.id"><div class="img-view" ng-click="checkItem(item)"><div class="cover-view"><img class="cover-img" err-src="content/images/default-cover.png" ng-src="{{item.cover +\'?imageMogr2/interlace/1/thumbnail/268x268\'}}" alt="{{item.name}}"><div class="check-box" ng-class="{\'checked\' : item.selected}" ng-if="vm.batchState"><i class="iconfont icon-gou"></i></div><div class="tag-box" ng-if="!vm.batchState"><div class="tag" ng-if="item.status === \'Approved\'">\u5DF2\u5206\u4EAB</div><div class="tag tag-success" ng-if="item.status === \'Created\'">\u5BA1\u6838\u4E2D</div><div class="tag tag-warn" ng-if="item.status === \'Rejected\'">\u5DF2\u9A73\u56DE</div></div></div><div class="shade-view" ng-if="!vm.batchState"><div class="preview-btn" ng-click="look(item)" uib-tooltip="\u9884\u89C8" tooltip-placement="bottom"><i class="iconfont icon-yulan"></i></div><div class="menu-view"><i class="iconfont icon-gengduo1"></i><div class="menu-content"><div class="menu-list"><div class="menu-item" ui-sref="text-xml-edit({id: item.id})">\u7F16\u8F91</div><div class="menu-item" ng-click="delete(item)">\u5220\u9664</div><div class="menu-item" ng-click="copy(item)">\u590D\u5236</div><div class="menu-item" ng-if="item.status == \'Rejected\'" ng-click="showReason(item)">\u67E5\u770B\u9A73\u56DE\u539F\u56E0</div><div class="cut-line"></div><div class="menu-item" ng-click="share(item)" ng-if="!item.status || item.status == \'Rejected\'">\u5206\u4EAB</div><div class="menu-item" ng-click="release(item)">\u53D1\u5E03</div></div></div></div></div></div><div class="template-info"><div class="template-name" uib-tooltip="{{item.name}}" tooltip-placement="bottom">{{item.name}}</div></div></div></div><div class="batch-bar" ng-if="vm.batchState"><div class="checked-count"><span class="num">({{vm.selectCount}})</span>\u5DF2\u9009\u4E2D</div><div class="btns"><div class="batch-btn" ng-click="batchShare()"><i class="iconfont icon-fenxiang"></i>\u5206\u4EAB</div><div class="batch-btn" ng-click="batchDelete()"><i class="iconfont icon-shanchu3"></i>\u5220\u9664</div></div><div class="btn-close" ng-click="vm.batchState = false"><i class="iconfont icon-closeicon1"></i></div></div><modele-pagination style="margin-top:10px" ng-show="!vm.batchState" page="vm.pageInfo.page" size="vm.pageInfo.size" total="vm.pageInfo.total" current-change="vm.currentChange()"></modele-pagination></div>');
$templateCache.put('app/layouts/error/accessdenied.html','<div ng-cloak><div class="row"><div class="col-md-4"><span class="hipster img-responsive img-rounded"></span></div><div class="col-md-8"><h1 data-translate="error.title">Error Page!</h1><div class="alert alert-danger" data-translate="error.http.403">You are not authorized to access this page.</div></div></div></div>');
$templateCache.put('app/layouts/error/error.html','<div ng-cloak><div class="row"><div class="col-md-4"><span class="hipster img-responsive img-rounded"></span></div><div class="col-md-8"><h1 data-translate="error.title">Error Page!</h1><div ng-show="errorMessage"><div class="alert alert-danger">{{errorMessage}}</div></div></div></div></div>');
$templateCache.put('app/layouts/navbar/home-head.html','<div class="c-home-head"><div class="c-home-head-fl"><img src="content/images/logo.png" alt="" class="logo" ui-sref="page"><div class="c-home-head-nav"><div class="c-home-head-nav-li" ng-repeat="item in vm.items" ng-class="{\'c-home-head-nav-li-selected\' : item == selectedEvent}" ng-click="chooseItem(item)"><span>{{item}}</span><div class="c-home-head-nav-li-hr"></div></div></div></div><div class="c-home-head-fr"><div class="c-home-message" ng-mouseenter="jzMessageOver($event)"><div class="c-home-message-1"><i class="iconfont icon-xiaoxi"></i> <span class="c-home-message-quantity" ng-if="vm.remind>0">{{vm.remind}}</span></div><div class="c-home-message-2"><div class="c-home-message-2-1"><div class="c-home-message-2-1-title">\u6D88\u606F\u901A\u77E5</div><div class="c-link" ng-click="readBatch()">\u5168\u90E8\u5DF2\u8BFB</div></div><div class="c-home-message-2-2 scrollbar-main" ng-if="vm.jzMessage.length>0"><div class="c-home-message-2-2-li" ng-repeat="item in vm.jzMessage" ng-click="read(item)"><div class="c-home-message-2-2-li-icon"><img src="content/images/home-icon4.png" alt="" ng-if="item.noticeType == \'announcement\'"> <img src="content/images/home-icon3.png" alt="" ng-if="item.noticeType == \'audit\'"></div><div class="c-home-message-2-2-li-fr"><div class="c-home-message-2-2-li-fr1 slh"><p class="title slh">{{item.title}}</p><span class="unread-icon" ng-if="!item.read"></span></div><div class="c-home-message-2-2-li-fr2 slh">{{item.content}}</div><div class="c-home-message-2-2-li-fr3">{{item.createdDate | date:\'yyyy-MM-dd HH:mm:ss\'}}</div></div></div></div><div class="c-home-message-2-3" ng-if="vm.jzMessage.length==0">\u6682\u65E0\u901A\u77E5...</div><div class="c-home-message-2-4" ui-sref="notice">\u67E5\u770B\u5168\u90E8\u6D88\u606F</div></div></div><div class="c-home-user"><div class="c-home-user-1" style="width: 100px; justify-content: end"><img src="content/images/home-user.png"></div><div class="c-home-user-2"><div class="c-home-user-1"><img src="content/images/home-user.png" width="32px"><div class="c-home-user-1-text slh">{{vm.account.name}}</div></div><div class="c-home-user-2-hr"></div><div class="c-home-user-2-li" ng-click="resetPassword()"><i class="iconfont icon-mima1"></i> <span>\u4FEE\u6539\u5BC6\u7801</span></div><div class="c-home-user-2-li" ng-click="vm.logout()" id="logout"><i class="iconfont icon-logout"></i> <span>\u9000\u51FA\u767B\u5F55</span></div></div></div></div></div>');
$templateCache.put('app/layouts/navbar/home-nav.html','<div class="c-home-nav scrollbar-none"><img class="c-home-nav-bg" src="content/images/nav-bg.png" alt=""><div class="c-home-nav-li" ui-sref="page" ng-class="{\'c-home-nav-li-selected\' : vm.current.name == \'page\'}"><i class="iconfont icon-shouye"></i> <span>\u9996\u9875</span></div><div class="c-home-nav-li" ui-sref="recommendTemplate" ng-class="{\'c-home-nav-li-selected\' : vm.current.name == \'recommendTemplate\'}"><i class="iconfont icon-tuijian"></i> <span>\u4E3A\u4F60\u63A8\u8350</span></div><div class="c-home-nav-li" ui-sref="xml-center" ng-class="{\'c-home-nav-li-selected\' : vm.current.name == \'xml-center\'}"><i class="iconfont icon-bianjiqi-buju"></i> <span>\u6A21\u677F\u4E2D\u5FC3</span></div><div class="c-home-nav-title">\u5DE5\u4F5C\u53F0</div><div class="c-home-nav-li" ui-sref="selfTemplateList({self:\'self\'})" ng-class="{\'c-home-nav-li-selected\' : vm.current.name == \'selfTemplateList\'}"><i class="iconfont icon-wodesheji"></i> <span>\u6211\u7684\u8BBE\u8BA1</span></div><div class="c-home-nav-li" ui-sref="text" ng-class="{\'c-home-nav-li-selected\' : vm.current.name == \'text\'}"><i class="iconfont icon-bianjiqi-wenben"></i> <span>\u6587\u5B57\u7EC4\u4EF6</span></div><div class="c-home-nav-li" ui-sref="picture" ng-class="{\'c-home-nav-li-selected\' : vm.current.name == \'picture\'}"><i class="iconfont icon-bianjiqi-tupian"></i> <span>\u5E03\u5C40\u7EC4\u4EF6</span></div><div class="c-home-nav-li" ui-sref="patterns" ng-class="{\'c-home-nav-li-selected\' : vm.current.name == \'patterns\'}"><i class="iconfont icon-moxing"></i> <span>\u6211\u7684\u6A21\u578B</span></div><div class="c-home-nav-li" ui-sref="calendar" ng-class="{\'c-home-nav-li-selected\' : vm.current.name == \'calendar\'}"><i class="iconfont icon-rili"></i> <span>\u6211\u7684\u65E5\u5386</span></div><div class="c-home-nav-li" ui-sref="background" ng-class="{\'c-home-nav-li-selected\' : vm.current.name == \'background\' || vm.current.name == \'mask\' || vm.current.name == \'frame-control\' || vm.current.name == \'font-management\' || vm.current.name == \'clip-art\' || vm.current.name == \'pic\'}"><i class="iconfont icon-shangchuan"></i> <span>\u6211\u4E0A\u4F20\u7684</span></div><div class="c-home-nav-title">\u4E2A\u4EBA\u7A7A\u95F4</div><div class="c-home-nav-li" ui-sref="mycenter" ng-class="{\'c-home-nav-li-selected\' : vm.current.name == \'mycenter\'}"><i class="iconfont icon-shezhi"></i> <span>\u6A21\u677F\u8BBE\u7F6E</span></div><div class="c-home-nav-li" ui-sref="product-xml-purchase" ng-class="{\'c-home-nav-li-selected\' : vm.current.name == \'product-xml-purchase\'}"><i class="iconfont icon-goumaijilu"></i> <span>\u8D2D\u4E70\u8BB0\u5F55</span></div></div>');
$templateCache.put('app/layouts/navbar/home-nav1.html','<div class="c-home-nav scrollbar-none"><!-- <div class="c-home-nav-li" ui-sref="xml-center" ng-class="{\'c-home-nav-li-selected\' : vm.current.name == \'xml-center\'}">\n        <i class="iconfont icon-bianjiqi-buju"></i>\n        <span>\u6A21\u677F\u4E2D\u5FC3</span>\n    </div> --><div class="c-home-nav-li" ui-sref="textShare" ng-class="{\'c-home-nav-li-selected\' : vm.current.name == \'textShare\'}"><i class="iconfont icon-bianjiqi-wenben"></i> <span>\u6587\u5B57\u4E2D\u5FC3</span></div><div class="c-home-nav-li" ui-sref="picture-share" ng-class="{\'c-home-nav-li-selected\' : vm.current.name == \'picture-share\'}"><i class="iconfont icon-bianjiqi-tupian"></i> <span>\u5E03\u5C40\u4E2D\u5FC3</span></div><div class="c-home-nav-li" ui-sref="calendar-center-body" ng-class="{\'c-home-nav-li-selected\' : vm.current.name == \'calendar-center-body\'}"><i class="iconfont icon-rili"></i> <span>\u65E5\u5386\u4E2D\u5FC3</span></div></div>');
$templateCache.put('app/layouts/navbar/navbar.html','<!--<nav class="navbar" role="navigation" data-html2canvas-ignore style="display:none;">--><!--    <div class="navbar-wrap">--><!--        <div class="navbar-top">--><!--            <div class="navbar-logo"><img src="content/images/momentsgo.png" alt=""></div>--><!--            <ul class="titleList clearfix">--><!--                <li ng-repeat="item in vm.items track by $index" ng-style="{\'border-bottom\':selectedEvent == item ? \'3px solid #FF4747\' :\'3px solid transparent\',\'color\':selectedEvent == item ?\'#FF4747\':\'\'}" ng-click="chooseItem(item)">{{item}}</li>--><!--            </ul>--><!--            <div class="navbar-collapse navbar-setting" uib-collapse="vm.isNavbarCollapsed" ng-switch="true">--><!--                <div ng-class="{active: vm.$state.includes(\'account\')}" uib-dropdown class="dropdown pointer navbar-user">--><!--                    <p class="dropdown-toggle moduleNavbarColor arrowHover" uib-dropdown-toggle href="" id="account-menu" ng-click="vm.passwords()">--><!--                        <span class="users-a">{{vm.account.name}}</span>--><!--                        <b class="arrows-icon"></b>--><!--                    </p>--><!--                    <ul class="dropdown-menu" uib-dropdown-menu>--><!--                        <li ui-sref-active="active" ng-switch-when="true">--><!--                            <a ng-click="resetPassword()">--><!--                                <span class="glyphicon glyphicon-lock"></span>&nbsp;--><!--                                <span translate="global.menu.account.password">Password</span>--><!--                            </a>--><!--                        </li>--><!--                        <li ui-sref-active="active" ng-switch-when="true">--><!--                            <a href="" ng-click="vm.logout()" id="logout">--><!--                                <span class="glyphicon glyphicon-log-out"></span>&nbsp;--><!--                                <span translate="global.menu.account.logout">Sign out</span>--><!--                            </a>--><!--                        </li>--><!--                    </ul>--><!--                </div>--><!--            </div>--><!--            <div class="shell-head-inform" ng-mouseenter="jzMessageOver($event)">--><!--                <div class="shell-head-inform-icon">--><!--                    <div ng-show="!!vm.remind" style="float: right; background-color: red; border-radius: 10px; width: 6px; height: 6px;margin-top: 20px;">--><!--                    </div>--><!--                </div>--><!--                <div class="jz-message" ng-if="vm.jzMessageShow">--><!--                    &lt;!&ndash; <div class="jz-message"  > &ndash;&gt;--><!--                    <div class="jz-message-head">--><!--                        <span class="title" style="font-size: 22px">\u6D88\u606F\u901A\u77E5</span>--><!--                        <span class="jz-message-head-btn" style="font-size: 16px; color: #fe5454" ng-click="readBatch()">\u5168\u90E8\u5DF2\u8BFB</span>--><!--                    </div>--><!--                    <div class="jz-message-body" style="border-top:0px;">--><!--                        <div class="jz-message-body-li" ng-repeat="item in vm.jzMessage" ng-click="read(item)" ng-if="vm.jzMessage.length>0">--><!--                            <div class="jz-message-body-li-title" style="clear: both;">--><!--                                <div style="text-align: left; float: left;color: #000000">--><!--                                    {{item.title}}--><!--                                    <div ng-show="!item.read" style="float: right; background-color: red; border-radius: 10px; width: 6px; height: 6px; "></div>--><!--                                </div>--><!--                                <div style="text-align: right;font-size: 14px; float: right; background-color: #E1E1E1; color: #919191; padding: 0 5px; border-radius: 5px;" ng-if="item.read">\u5DF2\u8BFB</div>--><!--                            </div>--><!--                            <div class="jz-message-body-li-content" style="clear: both;">--><!--                                <div style="font-size: 16px;color: #8E8E8E ">--><!--                                    {{item.content}}--><!--                                </div>--><!--                                <div style="font-size: 14px;color: #777777 ">--><!--                                    {{item.createdDate | date:"yyyy-MM-dd"}}--><!--                                </div>--><!--                            </div>--><!--                        </div>--><!--                        <div ng-if="vm.jzMessage.length === 0" style="padding: 30px 0; text-align: center;">\u6682\u65E0\u901A\u77E5...</div>--><!--                    </div>--><!--                    <div class="jz-message-font" style="border-top:0px;">--><!--                        <a style="font-size: 16px;" ui-sref="notice">\u67E5\u770B\u6240\u6709\u6D88\u606F</a>--><!--                    </div>--><!--                </div>--><!--            </div>--><!--        </div>--><!--        <div class="navbar-collapse side" uib-collapse="vm.isNavbarCollapsed" ng-switch="vm.isAuthenticated()">--><!--            <div class="sidebar1">--><!--                <ul>--><!--                    <li class="bar1-active">--><!--                        <a ui-sref="page" ui-sref-active="hover">--><!--                            <span class="bar1-text">\u65B0\u5EFA\u6A21\u677F</span>--><!--                        </a>--><!--                    </li>--><!--                    <li class="bar1-active">--><!--                        <a ui-sref="templateList" ui-sref-active="hover" class="moduleList" ng-click="templateList()">--><!--                            <span class="bar1-text">\u63A8\u8350\u6A21\u677F</span>--><!--                            <span class="glyphicon glyphicon-chevron-down" style="color: #939393;font-size: 10px;"></span>--><!--                        </a>--><!--                        <ul class="sub subMenu" style="display: none;">--><!--                            <li ng-repeat="menu in vm.menus |orderBy:\'seq\' track by $index">--><!--                                <a ui-sref="template({id:menu.id})" ui-sref-active="hover" class="pad-80">--><!--                                    <span class="bar1-text">{{menu.name}}</span>--><!--                                </a>--><!--                            </li>--><!--                        </ul>--><!--                    </li>--><!--                    <li class="bar1-active">--><!--                        <a ui-sref="selfTemplateList({self:\'self\'})" ui-sref-active="hover" class="moduleList" ng-click="templateList()">--><!--                            <span class="bar1-text">\u81EA\u5B9A\u4E49\u6A21\u677F\u5217\u8868</span>--><!--                            <span class="glyphicon glyphicon-chevron-down" style="color: #939393;font-size: 10px;"></span>--><!--                        </a>--><!--                        <ul class="sub subMenu" style="display: none;">--><!--                            <li ng-repeat="menu in vm.menusSelf |orderBy:\'seq\' track by $index">--><!--                                <a ui-sref="template({id:menu.id,self:\'self\'})" ui-sref-active="hover" class="pad-80">--><!--                                    <span class="bar1-text">{{menu.name}}</span>--><!--                                </a>--><!--                            </li>--><!--                        </ul>--><!--                    </li>--><!--                    <li class="bar1-active">--><!--                        <a ui-sref="text" ui-sref-active="hover">--><!--                            <span class="bar1-text">\u6587\u5B57\u6A21\u677F\u5217\u8868</span>--><!--                        </a>--><!--                    </li>--><!--                    <li class="bar1-active">--><!--                        <a ui-sref="picture" ui-sref-active="hover" class="moduleList">--><!--                            <span class="bar1-text">\u7167\u7247\u5E03\u5C40\u5217\u8868</span>--><!--                            <span class="glyphicon glyphicon-chevron-down" style="color: #939393;font-size: 10px;"></span>--><!--                        </a>--><!--                        <ul class="sub subMenu" style="display: none;">--><!--                            <li ng-repeat="item in vm.catalogs |orderBy:\'seq\' track by $index">--><!--                                <a ui-sref="picture1({id:item.id})" ui-sref-active="hover" class="pad-80">--><!--                                    <span class="bar1-text">{{item.name}}</span>--><!--                                </a>--><!--                            </li>--><!--                        </ul>--><!--                    </li>--><!--                    <li class="bar1-active">--><!--                        <a ui-sref="frame-control" ui-sref-active="hover">--><!--                            <span class="bar1-text">\u8FB9\u6846\u7BA1\u7406</span>--><!--                        </a>--><!--                    </li>--><!--                    <li class="bar1-active">--><!--                        <a ui-sref="font-management" ui-sref-active="hover">--><!--                            <span class="bar1-text">\u5B57\u4F53</span>--><!--                        </a>--><!--                    </li>--><!--                    <li class="bar1-active">--><!--                        <a ui-sref="product-xml-purchase" ui-sref-active="hover">--><!--                            <span class="bar1-text" translate="global.menu.entities.purchaseHistory">Purchase History</span>--><!--                        </a>--><!--                    </li>--><!--                    <li class="bar1-active">--><!--                        <a ui-sref-active="hover" class="moduleList">--><!--                            <span class="bar1-text">\u5206\u7C7B\u7BA1\u7406</span>--><!--                            <span class="glyphicon glyphicon-chevron-down" style="color: #939393;font-size: 10px;"></span>--><!--                        </a>--><!--                        <ul class="sub subMenu" style="display: none;">--><!--                            <li ng-repeat="menu in vm.categoryList track by $index">--><!--                                <a ui-sref="catalog-management({catalogType:menu.catalogType})" ui-sref-active="hover" class="pad-80">--><!--                                    <span class="bar1-text">{{menu.name}}</span>--><!--                                </a>--><!--                            </li>--><!--                        </ul>--><!--                    </li>--><!--                    <li class="bar1-active">--><!--                        <a ui-sref="patterns" ui-sref-active="hover">--><!--                            <span class="bar1-text">\u6211\u7684\u6A21\u578B</span>--><!--                        </a>--><!--                    </li>--><!--                    <li class="bar1-active">--><!--                        <a ui-sref="mycenter" ui-sref-active="hover">--><!--                            <span class="bar1-text">\u4E2A\u4EBA\u4E2D\u5FC3</span>--><!--                        </a>--><!--                    </li>--><!--                    <li class="bar1-active">--><!--                        <a ui-sref="calendar" ui-sref-active="hover">--><!--                            <span class="bar1-text">\u65E5\u5386\u5217\u8868</span>--><!--                        </a>--><!--                    </li>--><!--                </ul>--><!--            </div>--><!--        </div>--><!--    </div>--><!--</nav>--><home-head></home-head><home-nav :current="vm.current"></home-nav><div class="c-home-body scrollbar-main"><div ui-view="content" style="min-width: 1400px"></div></div>');
$templateCache.put('app/layouts/navbar/navbar1.html','<home-head></home-head><home-nav1 :current="vm.current"></home-nav1><div class="c-home-body scrollbar-main"><div ui-view="content1" style="min-width: 1400px"></div></div>');
$templateCache.put('app/layouts/navbar/navbar2.html','<home-head></home-head><div class="c-home-body1 scrollbar-main"><div ui-view="content2" style="min-width: 1400px"></div></div>');
$templateCache.put('app/account/reset/finish/reset.finish.html','<div><div class="row"><div class="col-md-4 col-md-offset-4"><h1 data-translate="reset.finish.title">Reset password</h1><div class="alert alert-danger" data-translate="reset.finish.messages.keymissing" ng-show="vm.keyMissing"><strong>The password reset key is missing.</strong></div><div class="alert alert-warning" ng-hide="vm.success || vm.keyMissing"><p data-translate="reset.finish.messages.info">Choose a new password</p></div><div class="alert alert-danger" ng-show="vm.error"><p data-translate="reset.finish.messages.error">Your password couldn\'t be reset. Remember a password request is only valid for 24 hours.</p></div><div class="alert alert-success" ng-show="vm.success"><p data-translate="reset.finish.messages.success" translate-compile><strong>Your password has been reset.</strong> Please <a class="alert-link" href="" ng-click="vm.login()">sign in</a>.</p></div><div class="alert alert-danger" ng-show="vm.doNotMatch" data-translate="global.messages.error.dontmatch">The password and its confirmation do not match!</div><div ng-hide="vm.keyMissing"><form ng-show="!vm.success" name="form" role="form" novalidate ng-submit="vm.finishReset()" show-validation><div class="form-group"><label class="control-label" for="password" data-translate="global.form.newpassword">New password</label><input type="password" class="form-control" id="password" name="password" placeholder="{{\'global.form.newpassword.placeholder\' | translate}}" ng-model="vm.resetAccount.password" ng-minlength="4" ng-maxlength="50" required><div ng-show="form.password.$dirty && form.password.$invalid"><p class="help-block" ng-show="form.password.$error.required" data-translate="global.messages.validate.newpassword.required">Your password is required.</p><p class="help-block" ng-show="form.password.$error.minlength" data-translate="global.messages.validate.newpassword.minlength">Your password is required to be at least 4 characters.</p><p class="help-block" ng-show="form.password.$error.maxlength" data-translate="global.messages.validate.newpassword.maxlength">Your password cannot be longer than 50 characters.</p></div><password-strength-bar password-to-check="vm.resetAccount.password"></password-strength-bar></div><div class="form-group"><label class="control-label" for="confirmPassword" data-translate="global.form.confirmpassword">New password confirmation</label><input type="password" class="form-control" id="confirmPassword" name="confirmPassword" placeholder="{{\'global.form.confirmpassword.placeholder\' | translate}}" ng-model="vm.confirmPassword" ng-minlength="4" ng-maxlength="50" required><div ng-show="form.confirmPassword.$dirty && form.confirmPassword.$invalid"><p class="help-block" ng-show="form.confirmPassword.$error.required" data-translate="global.messages.validate.confirmpassword.required">Your password confirmation is required.</p><p class="help-block" ng-show="form.confirmPassword.$error.minlength" data-translate="global.messages.validate.confirmpassword.minlength">Your password confirmation is required to be at least 4 characters.</p><p class="help-block" ng-show="form.confirmPassword.$error.maxlength" data-translate="global.messages.validate.confirmpassword.maxlength">Your password confirmation cannot be longer than 50 characters.</p></div></div><button type="submit" ng-disabled="form.$invalid" class="btn btn-primary" data-translate="reset.finish.form.button">Reset Password</button></form></div></div></div></div>');
$templateCache.put('app/account/reset/request/reset.request.html','<div class="register_wrap"><div class="register_content"><div class="register_bg"></div><div class="register_box"><div class="register_title">\u5BC6\u7801\u91CD\u7F6E</div><form class="register_form"><div class="form_item mb16"><i class="iconfont icon-zhanghao input_icon left"></i> <input ng-model="vm.registerAccount.name" maxlength="50" ng-blur="checkUser()" class="icon_left" type="text" placeholder="\u8BF7\u8F93\u5165\u8D26\u53F7"></div><div class="form_item mb16"><i class="iconfont icon-mima1 input_icon left"></i> <input ng-model="vm.registerAccount.password" maxlength="50" class="icon_left icon_right" type="{{vm.passType}}" placeholder="\u8BF7\u8F93\u5165\u65B0\u5BC6\u7801"> <i class="iconfont icon-yanjing-biyan input_icon right pointer" ng-if="vm.registerAccount.password && vm.passType == \'password\'" ng-click="changePassType(\'passType\',\'text\')"></i> <i class="iconfont icon-yanjing-zhengyan input_icon right pointer" ng-if="vm.registerAccount.password && vm.passType == \'text\'" ng-click="changePassType(\'passType\',\'password\')"></i></div><div class="form_item mb16"><i class="iconfont icon-mima1 input_icon left"></i> <input ng-model="vm.confirmPassword" maxlength="50" class="icon_left icon_right" type="{{vm.confirmPassType}}" placeholder="\u8BF7\u518D\u6B21\u8F93\u5165\u65B0\u5BC6\u7801"> <i class="iconfont icon-yanjing-biyan input_icon right pointer" ng-if="vm.confirmPassword && vm.confirmPassType == \'password\'" ng-click="changePassType(\'confirmPassType\',\'text\')"></i> <i class="iconfont icon-yanjing-zhengyan input_icon right pointer" ng-if="vm.confirmPassword && vm.confirmPassType == \'text\'" ng-click="changePassType(\'confirmPassType\',\'password\')"></i></div><div class="form_item send_code mb16"><i class="iconfont icon-shouji1 input_icon left"></i> <input ng-model="vm.registerAccount.phone" class="icon_left" ng-class="{\'checkErr\' : vm.checkPhoneErr}" type="text" placeholder="\u8BF7\u8F93\u5165\u624B\u673A\u53F7" ng-change="changePhone()"> <a class="btn_code pointer" ng-class="{\'disabled\' : vm.disabled}" ng-click="getVerifyCode()" ng-disabled="vm.disabled" ng-bind="paracont"></a></div><div class="form_item mb32"><i class="iconfont icon-yanzhengma1 input_icon left"></i> <input ng-model="vm.registerAccount.code" ng-change="checkVerifyCode()" class="icon_left" type="text" placeholder="\u8BF7\u8F93\u5165\u9A8C\u8BC1\u7801"></div><div class="form_item mb16"><button type="submit" ng-click="vm.resetPassword()">\u91CD\u7F6E\u5BC6\u7801</button></div><div class="footer_link"><a ui-sref="home">\u8FD4\u56DE\u767B\u5F55</a></div></form></div><div class="company_info">Powered By MomentsGo</div></div></div>');
$templateCache.put('app/entities/calendar/controls/calendar-set.control.html','<div class="c-editor-attribute-view1"><div class="c-editor-attribute-head"><div ng-class="{\'c-editor-attribute-head-selected\' : vm.tag == 1}" ng-click="tagClick(1)">\u65E5\u5386</div><div ng-class="{\'c-editor-attribute-head-selected\' : vm.tag == 2}" ng-click="tagClick(2)">\u5468\u8BBE\u7F6E</div><div ng-class="{\'c-editor-attribute-head-selected\' : vm.tag == 3}" ng-click="tagClick(3)">\u65E5\u8BBE\u7F6E</div></div><div class="c-editor-attribute-body"><div ng-if="vm.tag == 1"><div ng-if="!vm.data.geometry"><div class="title">\u5E03\u5C40</div><div class="c-editor-attribute-body-item2"><modele-select ng-model="vm.data.displayType" ng-change="onYearMonthChnage()" label-key="name" value-key="id" options="vm.displayTypes"></modele-select></div><div class="c-editor-attribute-body-hr"></div></div><div ng-if="vm.data.geometry"><div class="c-editor-attribute-view-title"><span>\u5C3A\u5BF8</span><select ng-model="vm.unit" ng-options="unit.id as unit.name for unit in vm.units" ng-change="unitConversion()" class="c-editor-attribute-view-title-select"></select></div><div class="c-editor-attribute-view-input"><div class="c-editor-attribute-view-input-view"><span>\u5BBD</span><!-- <input type="number"\n                               ng-change="updateBoxParameter(\'width\')"\n                               ng-model-options="{debounce:500}"\n                               ng-model="vm.pageValue.calMonthBox.width"> --><input-number ng-model="vm.pageValue.calMonthBox.width" on-change="updateBoxParameter(\'width\')" type-style="\'two\'" min="1"></input-number></div><div class="c-editor-attribute-view-input-view"><span>\u9AD8</span><!-- <input type="number"\n                               ng-change="updateBoxParameter(\'height\')"\n                               ng-model-options="{debounce:500}"\n                               ng-model="vm.pageValue.calMonthBox.height"> --><input-number ng-model="vm.pageValue.calMonthBox.height" on-change="updateBoxParameter(\'height\')" type-style="\'two\'" min="1"></input-number></div></div><div class="c-editor-attribute-view-hr"></div><div class="c-editor-attribute-view-title"><span>\u5750\u6807</span><select ng-model="vm.unit" ng-options="unit.id as unit.name for unit in vm.units" ng-change="unitConversion()" class="c-editor-attribute-view-title-select"></select></div><div class="c-editor-attribute-view-input"><div class="c-editor-attribute-view-input-view"><span>x</span><!-- <input type="number"\n                               ng-change="updateBoxParameter(\'x\')"\n                               ng-model-options="{debounce:500}"\n                               ng-model="vm.pageValue.calMonthBox.x"> --><input-number ng-model="vm.pageValue.calMonthBox.x" on-change="updateBoxParameter(\'x\')" type-style="\'two\'"></input-number></div><div class="c-editor-attribute-view-input-view"><span>y</span><!-- <input type="number"\n                               ng-change="updateBoxParameter(\'y\')"\n                               ng-model-options="{debounce:500}"\n                               ng-model="vm.pageValue.calMonthBox.y"> --><input-number ng-model="vm.pageValue.calMonthBox.y" on-change="updateBoxParameter(\'y\')" type-style="\'two\'"></input-number></div></div><div class="c-editor-attribute-view-hr"></div></div><div class="title" ng-if="!vm.data.geometry">\u5C3A\u5BF8</div><!--            <div class="c-editor-attribute-body-item" ng-if="vm.data.geometry">{{vm.data.geometry.width | number:0}} X {{vm.data.geometry.height | number:0}}</div>--><div class="c-editor-attribute-body-item" ng-if="!vm.data.geometry">{{vm.data.width | number:0}} X {{vm.data.height | number:0}}</div><div class="c-editor-attribute-body-hr" ng-if="!vm.data.geometry"></div><div class="title">\u80CC\u666F\u989C\u8272</div><color-pick color="vm.data.backgroundColor" colors="vm.colors.backgroundColors" transparent="true" on-update="widgetUpdate()"></color-pick><div class="c-editor-attribute-body-hr"></div><div class="title">\u4E00\u5468\u5F00\u59CB</div><div class="c-editor-attribute-body-item">{{vm.data.startOfWeek==1 ? \'1 - \u5468\u4E00\' : \'0 - \u5468\u65E5\'}}</div><div class="c-editor-attribute-body-hr"></div><div class="title">\u663E\u793A\u5176\u4ED6\u6708\u65E5\u671F</div><div class="c-editor-attribute-body-item1"><div ng-class="{\'c-editor-attribute-body-item1-view\' : !vm.data.showOthers}" ng-click="showOthersCb(false)">\u4E0D\u663E\u793A</div><div ng-class="{\'c-editor-attribute-body-item1-view\' : vm.data.showOthers}" ng-click="showOthersCb(true)">\u663E\u793A</div></div><div ng-if="!vm.data.geometry"><div class="c-editor-attribute-body-hr"></div><div class="title">\u793A\u4F8B\u6570\u636E</div><div class="c-editor-attribute-body-item2"><modele-select prefix="\u5E74:" ng-model="vm.data.sampleYear" ng-change="onYearMonthChnage()" label-key="value" value-key="id" options="vm.sampleYears"></modele-select></div><div class="c-editor-attribute-body-item2" style="margin: 0"><modele-select prefix="\u6708:" ng-model="vm.data.sampleMonth" ng-change="onYearMonthChnage()" label-key="value" value-key="id" options="vm.sampleMonths"></modele-select></div></div></div><div ng-if="vm.tag == 2"><div class="title">\u7C7B\u578B</div><div ng-click="selectWeekLayout()" class="c-previewUrl-view"><div class="c-previewUrl-view-item"><img ng-if="vm.data.weekLayout.previewUrl" ng-src="{{vm.data.weekLayout.previewUrl}}"><div ng-if="!vm.data.weekLayout.previewUrl">\u65E0\u56FE</div></div><i class="iconfont icon-xia"></i></div><div class="c-editor-attribute-body-hr"></div><div class="c-form" style="margin: 0"><label class="c-form-label" style="width: 110px !important;text-align: left;font-size: 12px">\u9690\u85CF</label><div class="c-form-div align-items-center" style="width: auto;margin-left: 70px"><input type="checkbox" class="checkOrIf" ng-model="vm.data.weekConfig.hideWeek"></div></div><div class="c-form" style="margin: 0"><label class="c-form-label" style="width: 110px !important;text-align: left;font-size: 12px">\u79FB\u9664\u91CD\u53E0\u8FB9 <i class="iconfont icon-wenhao" style="color: #999" uib-tooltip="\u91CD\u53E0\u8FB9\u4E3A\u5468\u5355\u5143\u683C\u5DE6\u53F3\u76F8\u90BB\u8FB9\u3002\u6253\u5F00\u5219\u91CD\u7F6E\u5355\u5143\u683C\u95F4\u8DDD\u4E3A0\uFF0C\u5355\u5143\u683C\u5706\u89D2\u4E3A0." tooltip-placement="bottom"></i></label><div class="c-form-div align-items-center" style="width: auto;margin-left: 70px"><input type="checkbox" class="checkOrIf" ng-model="vm.data.weekConfig.removeBorderOverlap" ng-change="weekRemoveBorderOverlap()"></div></div><div class="c-form" style="margin: 0"><label class="c-form-label" style="width: 110px !important;text-align: left;font-size: 12px">\u79FB\u9664\u5E95\u8FB9 <i class="iconfont icon-wenhao" style="color: #999" uib-tooltip="\u5E95\u8FB9\u4E3A\u5468\u5355\u5143\u683C\u5E95\u90E8\u8FB9\u6846\u3002\u6253\u5F00\u5219\u91CD\u7F6E\u8868\u5934\u95F4\u8DDD\u4E3A0\uFF0C\u5355\u5143\u683C\u5706\u89D2\u4E3A0." tooltip-placement="bottom"></i></label><div class="c-form-div align-items-center" style="width: auto;margin-left: 70px"><input type="checkbox" class="checkOrIf" ng-model="vm.data.weekConfig.removeBorderBottom" ng-change="weekRemoveBorderBottom()"></div></div><div class="c-editor-attribute-body-hr"></div><div><div class="title">\u5355\u5143\u683C\u5C3A\u5BF8(px)</div><div class="c-editor-attribute-body-item2"><span>\u5BBD</span> <input type="number" ng-model="vm.data.weekConfig.cellWidth" min="10" step="1" ng-change="sizeUpdate()"></div><div class="c-editor-attribute-body-item2"><span>\u9AD8</span> <input type="number" ng-model="vm.data.weekConfig.cellHeight" min="10" step="1" ng-change="sizeUpdate()"></div><div class="c-editor-attribute-body-item2" ng-if="!vm.data.weekConfig.removeBorderOverlap"><span>\u95F4\u8DDD</span> <input type="number" ng-model="vm.data.weekConfig.margin" step="1" ng-keyup="weekConfigMargin()" style="padding-left: 40px"></div><div class="c-editor-attribute-body-item2" style="margin: 0" ng-if="!vm.data.weekConfig.removeBorderBottom"><span>\u8868\u5934\u95F4\u8DDD</span> <input type="number" ng-model="vm.data.dateConfig.headSpacing" step="1" ng-keyup="dateConfigHeadSpacing()" style="padding-left: 70px"></div><div class="c-editor-attribute-body-hr"></div></div><div style="display: flex; justify-content: space-between; align-items: center; margin-top: 10px;padding-right: 10px"><div class="title" style="margin: 0">\u81EA\u5B9A\u4E49\u6837\u5F0F</div><div class="c-icon-btn"><i class="iconfont icon-jia2" ng-click="vm.addWeekStyle()" uib-tooltip="\u6DFB\u52A0" tooltip-placement="top"></i></div></div><div class="c-weekStyles-view"><div class="c-weekStyles-view-li" ng-repeat="s in vm.data.weekStyles track by $index"><span class="tit" uib-tooltip="{{ s.name }}" tooltip-placement="bottom">{{s.name}}</span><div class="handle"><i class="iconfont icon-shixinguanbi" style="color: #89919D" ng-click="vm.removeWeekStyle($index)" ng-if="$index>0" uib-tooltip="\u5220\u9664" tooltip-placement="top"></i> <i class="iconfont icon-fuzhi3" style="color: #89919D;cursor: pointer" ng-click="vm.copyWeekStyle($index)" uib-tooltip="\u590D\u5236" tooltip-placement="top"></i> <i class="iconfont icon-bianji" style="color: #89919D" ng-click="vm.editWeekStyle(s,$index)" uib-tooltip="\u7F16\u8F91" tooltip-placement="top"></i></div></div></div><div class="c-editor-attribute-body-hr"></div><div class="title">\u65E5\u671F\u6837\u5F0F\u8BBE\u7F6E</div><div><div class="select-item" style="margin-bottom: 8px"><modele-select style="margin-bottom: 20px" ng-model="vm.weekStyleKey" ng-change="widgetUpdate()" label-key="value" value-key="id" options="vm.weekStyleKeys"></modele-select></div><div class="select-item"><modele-select ng-model="vm.data.weekConfig[vm.weekStyleKey]" ng-change="widgetUpdate()" label-key="name" value-key="uuid" options="vm.weekStyleOptions"></modele-select></div><!--                    <select class="c-select1" style="margin-bottom: 8px;" ng-model="vm.weekStyleKey" ng-options="s.id as s.value for s in vm.weekStyleKeys" ng-change="widgetUpdate()"></select>--><!--                    <select class="c-select1" ng-model="vm.data.weekConfig[vm.weekStyleKey]" ng-options="s.uuid as s.name for s in vm.weekStyleOptions" ng-change="widgetUpdate()"></select>--></div></div><div ng-if="vm.tag == 3"><div class="title">\u7C7B\u578B</div><div ng-click="selectDateLayout()" class="c-previewUrl-view"><div class="c-previewUrl-view-item"><img ng-if="vm.data.dateLayout.previewUrl" ng-src="{{vm.data.dateLayout.previewUrl}}"><div ng-if="!vm.data.dateLayout.previewUrl">\u65E0\u56FE</div></div><i class="iconfont icon-xia"></i></div><div class="c-editor-attribute-body-hr"></div><div class="c-form" style="margin: 0"><label class="c-form-label" style="width: 110px !important;text-align: left;font-size: 12px">\u79FB\u9664\u91CD\u53E0\u8FB9 <i class="iconfont icon-wenhao" style="color: #999" uib-tooltip="\u91CD\u53E0\u8FB9\u4E3A\u5355\u5143\u683C\u4E0A\u4E0B\u5DE6\u53F3\u76F8\u90BB\u8FB9\u3002\u6253\u5F00\u5219\u91CD\u7F6E\u5355\u5143\u683C\u95F4\u8DDD\u4E3A0\uFF0C\u5355\u5143\u683C\u5706\u89D2\u4E3A0." tooltip-placement="bottom"></i></label><div class="c-form-div align-items-center" style="width: auto;margin-left: 70px"><input type="checkbox" class="checkOrIf" ng-model="vm.data.dateConfig.removeBorderOverlap" ng-change="dateRemoveBorderOverlap()"></div></div><div class="c-editor-attribute-body-hr"></div><div><div class="title">\u5355\u5143\u683C\u5C3A\u5BF8(px)</div><div class="c-editor-attribute-body-item2"><span>\u5BBD</span> <input type="number" ng-model="vm.data.dateConfig.cellWidth" min="10" step="1" ng-change="sizeUpdate()"></div><div class="c-editor-attribute-body-item2"><span>\u9AD8</span> <input type="number" ng-model="vm.data.dateConfig.cellHeight" min="10" step="1" ng-change="sizeUpdate()"></div><div class="c-editor-attribute-body-item2" style="margin: 0" ng-if="!vm.data.dateConfig.removeBorderOverlap"><span>\u95F4\u8DDD</span> <input type="number" ng-model="vm.data.dateConfig.margin" step="1" ng-keyup="dateConfigMargin()" style="padding-left: 40px"></div><div class="c-editor-attribute-body-hr"></div></div><div style="display: flex; justify-content: space-between; align-items: center; margin-top: 10px;padding-right: 10px"><div class="title" style="margin: 0">\u81EA\u5B9A\u4E49\u6837\u5F0F</div><div class="c-icon-btn"><i class="iconfont icon-jia2" ng-click="vm.addDateStyle()" uib-tooltip="\u6DFB\u52A0" tooltip-placement="top"></i></div></div><div class="c-weekStyles-view"><div class="c-weekStyles-view-li" ng-repeat="s in vm.data.dateStyles track by $index"><span class="tit" uib-tooltip="{{ s.name }}" tooltip-placement="bottom">{{s.name}}</span><div class="handle"><i class="iconfont icon-shixinguanbi" style="color: #89919D" ng-click="vm.removeDateStyle($index)" ng-if="$index>0" uib-tooltip="\u5220\u9664" tooltip-placement="top"></i> <i class="iconfont icon-fuzhi3" style="color: #89919D;cursor: pointer" ng-click="vm.copyDateStyle($index)" uib-tooltip="\u590D\u5236" tooltip-placement="top"></i> <i class="iconfont icon-bianji" style="color: #89919D" ng-click="vm.editDateStyle(s,$index)" uib-tooltip="\u7F16\u8F91" tooltip-placement="top"></i></div></div></div><div class="c-editor-attribute-body-hr"></div><div class="title">\u65E5\u671F\u6837\u5F0F\u8BBE\u7F6E</div><div><div class="select-item" style="margin-bottom: 8px"><modele-select ng-model="vm.dateConfigKey" ng-change="widgetUpdate()" label-key="value" value-key="id" options="vm.dateConfigKeys"></modele-select></div><div class="select-item"><modele-select ng-model="vm.data.dateConfig[vm.dateConfigKey]" ng-change="widgetUpdate()" label-key="name" value-key="uuid" options="vm.dateStyleOptions"></modele-select></div><!--                    <select class="c-select1" style="margin-bottom: 8px;" ng-model="vm.dateConfigKey" ng-options="s.id as s.value for s in vm.dateConfigKeys" ng-change="widgetUpdate()"></select>--><!--                    <select class="c-select1" ng-model="vm.data.dateConfig[vm.dateConfigKey]" ng-options="s.uuid as s.name for s in vm.dateStyleOptions" ng-change="widgetUpdate()"></select>--></div></div></div></div><style>.c-editor-attribute-body-item{\n        width: 100%;\n        height: 36px;\n        line-height: 36px;\n        padding: 0 8px;\n        background: #F5F7FA;\n        border-radius: 2px;\n        color: #222529;\n        font-size: 12px;\n    }\n    .c-editor-attribute-body-item1{\n        width: 100%;\n        display: flex;\n        border-radius: 2px;\n        border: 1px solid #E1E5EB;\n    }\n    .c-editor-attribute-body-item1 div{\n        width: 50%;\n        height: 36px;\n        cursor: pointer;\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        background: #fff;\n        color: #222529;\n        font-weight: bold;\n    }\n    .c-editor-attribute-body-item1-view{\n        background: #264DF0 !important;\n        color: #fff !important;\n    }\n    .c-editor-attribute-body-item2{\n        position: relative;\n        width: 100%;\n        height: 36px;\n        margin-bottom: 8px;\n    }\n    .c-editor-attribute-body-item2 span{\n        position: absolute;\n        left: 8px;\n        top: 0;\n        font-size: 12px;\n        color: #89919D;\n        display: inline-block;\n        height: 36px;\n        line-height: 36px;\n    }\n    .c-editor-attribute-body-item2 select, .c-editor-attribute-body-item2 input{\n        width: 100%;\n        height: 36px;\n        border-radius: 2px;\n        border: 1px solid #E1E5EB;\n        padding: 0 16px 0 28px;\n        font-size: 12px;\n        color: #222529;\n    }\n    .c-editor-attribute-body-hr{\n        width: 100%;\n        height: 1px;\n        background: #EEEEEE;\n        margin: 16px 0 24px;\n    }\n    .c-previewUrl-view{\n        display: flex;\n        justify-content: space-between;\n        align-items: center;\n        width: 100%;\n    }\n    .c-previewUrl-view-item{\n        background: #F5F7FA;\n        border-radius: 2px;\n        width: calc(100% - 30px) !important;\n        height: 80px;\n        display: flex;\n        justify-content: center;\n        align-items: center;\n    }\n    .c-previewUrl-view-item img{\n        max-width: 90%;\n        max-height: 70px;\n    }\n\n    .c-weekStyles-view{\n        margin-top: 10px;\n    }\n    .c-weekStyles-view-li{\n        display: flex;\n        width: 100%;\n        justify-content: space-between;\n        align-items: center;\n        height: 36px;\n        background: #F5F7FA;\n        color: #333;\n        padding: 0 10px;\n        border-radius: 4px;\n        margin-bottom: 10px;\n    }\n    .c-weekStyles-view-li .tit{\n        flex: 1;\n        white-space: nowrap;\n        overflow: hidden;\n        text-overflow: ellipsis;\n    }</style>');
$templateCache.put('app/entities/calendar/controls/cell-settings-modal.html','<div class="c-model"><div class="c-model-head"><div class="c-model-head-title">\u5355\u5143\u683C\u8BBE\u7F6E</div><i class="iconfont icon-closeicon1" ng-click="vm.clear()"></i></div><div class="c-model-body"><div class="c-model-body-view scrollbar-main" style="display: flex; flex-wrap: wrap"><div style="width: 59%; min-height: 300px; margin-left: -10px"><div class="c-form"><div class="c-form-label">\u6837\u5F0F\u540D\u79F0:</div><div class="c-form-div"><input type="text" class="c-select1" ng-model="vm.data.name"></div></div><style-setting config="vm.data.config" theme-colors="vm.data.colors" settings="vm.data.settings" font-list="vm.fontList" on-change="onSettingsChange(text)" options="{backgroundEnabled: true, borderEnabled: true, debugEnabled: true}" ng-if="vm.isFontList"></style-setting></div><div style="width: 40%; position: absolute; right: 10px"><div style="width: 200px; height: 100px; border: 1px solid #eee; position: relative; display: flex;justify-content: center;align-items: center" ng-if="vm.data.layout.type==\'WEEK\'"><week-cell width="vm.data.config.cellWidth" height="vm.data.config.cellHeight" layout="vm.data.layout" settings="vm.data.settings"></week-cell></div><div style="width: 200px; height: 200px; border: 1px solid #eee; position: relative; display: flex;justify-content: center;align-items: center" ng-if="vm.data.layout.type==\'DATE\'"><date-cell is-set="true" width="vm.data.config.cellWidth" height="vm.data.config.cellHeight" layout="vm.data.layout" settings="vm.data.settings"></date-cell></div></div></div></div><div class="c-model-foot"><button type="button" style="margin-right: 10px" class="btn btn-cancel btn-max" ng-click="vm.clear()">\u53D6\u6D88</button> <button type="button" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-info btn-max" ng-click="vm.save()">\u786E\u5B9A</button></div></div><style type="text/css"></style>');
$templateCache.put('app/entities/calendar/controls/color-pick.control.html','<div class="leftPanel-bg-head"><input class="leftPanel-bg-choose-color" type="color" ng-value="vm.data.color" ng-change="onInputChange()" ng-model="vm.data.color" style="top: 35px"> <button class="leftPanel-bg-color leftPanel-bg-choose-mask"></button> <button class="leftPanel-bg-color" ng-repeat="c in vm.colorOptions" ng-click="onClick(c)" ng-style="{background:c.value,border:\'1px solid #DADADA\'}"></button> <button class="leftPanel-bg-color custom-grid2" style="border: 1px solid #ddd" ng-click="onClean()" ng-if="vm.data.transparent"></button></div><style>.leftPanel-bg-head{\n        padding: 0;\n    }</style>');
$templateCache.put('app/entities/calendar/controls/date-cell.control.html','<div ng-style="vm.data.styles" style="position: relative; overflow: hidden"><div ng-repeat="item in vm.data.items" ng-if="vm.data.showOthers"><div ng-if=" item.type==\'image\' " ng-style="item.styles"><img ng-if="item.url" ng-src="{{item.url}}" style="object-fit: contain; width:100%;height:100%;text-align: center"></div><div ng-if=" item.type==\'userimage\' " ng-style="item.styles"><img ng-if="item.url" ng-src="{{item.url}}" style="object-fit: contain; width:100%;height:100%;text-align: center"></div><div ng-if=" item.type==\'date\' || item.type==\'event\' " ng-style="item.styles">{{item.value}}</div></div></div>');
$templateCache.put('app/entities/calendar/controls/font-family.html','<div class="c-font-view" style="width: 100%"><div class="c-font-view-head" style="height: 36px;line-height: 36px" ng-style="{\'font-family\': \'\\\'\' + vm.family + \'\\\'\',}">{{selectFontName(vm.family)}}</div><div class="c-font-view-body"><div class="c-font-view-body-head"><input type="text" class="c-font-view-body-head-input" id="selectFontInput" ng-model="vm.selectFont" ng-change="vm.selectFontBtn()"> <span class="c-font-view-body-head-btn" ng-click="vm.selectFontBtn()" style="top: 6px"></span></div><div class="c-font-view-body-ul"><div class="c-font-view-body-li" ng-repeat="font in vm.fontList track by $index" ng-click="updateTextFont(font)" ng-class="{\'c-font-view-body-li-on\' : vm.family == font.uuid}"><img ng-src="{{vm.url + font.fontStyles[0].identifier}}" alt="" ng-if="vm.url && font.fontStyles[0].identifier"> <span ng-if="!font.fontStyles[0].identifier">{{font.name}}</span></div></div></div></div>');
$templateCache.put('app/entities/calendar/controls/layout-select.html','<div class="c-model"><div class="c-model-head"><div class="c-model-head-title">\u9009\u62E9\u5355\u5143\u683C\u5E03\u5C40</div><i class="iconfont icon-closeicon1" ng-click="vm.clear()"></i></div><div class="c-model-body"><div class="c-model-body-view" style="display: flex; flex-wrap: wrap"><div ng-repeat="layout in vm.layouts" ng-click="vm.onLayoutSelect(layout)" style="margin: 10px; border: 1px solid #fff" ng-class="{\'layout-select\': layout.id==vm.selectedId}"><img ng-if="layout.previewUrl" ng-src="{{layout.previewUrl}}" width="100"> <span ng-if="!layout.previewUrl">\u65E0\u56FE</span></div></div></div><div class="c-model-foot" style="text-align: center"><button type="button" class="btn btn-cancel btn-max" ng-click="vm.clear()" translate="entity.action.cancel">Cancel</button> <button type="button" ng-disabled="vm.isSaving" class="btn btn-info btn-max" ng-click="vm.save()">\u786E\u5B9A</button></div></div><!--<div class="listBGC listCreate pad-0">--><!--    <button type="button" class="pad-5 close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;--><!--    </button>--><!--    <div class="modal-detail">--><!--        <h4 class="modal-title" >\u9009\u62E9\u5355\u5143\u683C\u5E03\u5C40</h4>--><!--    </div>--><!--    <div class="modal-body">--><!--        <div style="display: flex; flex-wrap: wrap;">--><!--        \t<div ng-repeat="layout in vm.layouts" ng-click="vm.onLayoutSelect(layout)" style="margin: 10px;" ng-class="{\'layout-select\': layout.id==vm.selectedId}">--><!--        \t\t<img ng-if="layout.previewUrl" ng-src="{{layout.previewUrl}}" width="100" />--><!--        \t\t<span ng-if="!layout.previewUrl">\u65E0\u56FE</span>--><!--        \t</div>--><!--        </div>--><!--    </div>--><!--    <div class="modal-footer" style="text-align: left;">--><!--        <button type="button" ng-disabled="vm.isSaving" style="width: 96px;" class="btn btn-primary btn-save btn-info" ng-click="vm.save()">--><!--            <span>\u786E\u5B9A</span>--><!--        </button>--><!--        <button type="button" class="btn btn-cancel mar-left-30" data-dismiss="modal" ng-click="vm.clear()">--><!--            <span translate="entity.action.cancel">Cancel</span>--><!--        </button>--><!--        --><!--    </div>--><!--</div>--><style type="text/css">.layout-select {\n\t\tborder: 1px solid #264DF0 !important;\n\t}</style>');
$templateCache.put('app/entities/calendar/controls/month-table.html','<div ng-style="vm.data.styles" style="position: relative" ng-if="!vm.loading"><div ng-style="{width:vm.data.headWidth,\'margin-bottom\':vm.data.headSpacing}" style="width: 100%;height: fit-content;display: flex"><div ng-repeat="head in vm.data.heads" style="height: fit-content" ng-style="{\'margin-right\':$index<vm.data.heads.length-1 ? head.margin : 0,\'opacity\':vm.widget.weekConfig.hideWeek?0:1}"><week-cell index="$index" week-config="vm.widget.weekConfig" width="head.width" height="head.height" obj="head.obj" layout="head.layout" settings="head.settings" is-min="vm.isMin"></week-cell></div></div><div ng-style="{height:vm.data.bodyHeight,width:vm.data.bodyWidth}" style="display: flex; align-content: space-between;flex-wrap: wrap"><div ng-repeat="dateRow in vm.data.dates" ng-init="trIndex = $index" style="width: 100%;height: fit-content;display: flex"><div ng-repeat="date in dateRow" ng-init="tdIndex = $index" style="height: fit-content" ng-style="{\'margin-right\':tdIndex<dateRow.length-1 ? date.margin : 0,\'margin-bottom\':trIndex<vm.data.dates.length-1 ? date.marginH : 0}"><date-cell tr-index="trIndex" td-index="tdIndex" date-config="vm.widget.dateConfig" width="date.width" height="date.height" obj="date.obj" layout="date.layout" settings="date.settings" is-min="vm.isMin"></date-cell></div></div></div></div>');
$templateCache.put('app/entities/calendar/controls/style-setting.control.html','<div style="position: relative" ng-class="{\'c-style-two\' : vm.style}"><div ng-if="vm.options" class="c-view-set"><!--        <div class="c-form" ng-if="vm.options.debugEnabled">--><!--            <div class="c-form-label">\u8C03\u8BD5\u5F00\u5173:</div>--><!--            <div class="c-form-div align-items-center">--><!--                <input type="checkbox" class="checkOrIf" ng-model="vm.data.settings.debug"  ng-change="onCheckboxChange()" aria-invalid="false" style="margin: 0;">--><!--            </div>--><!--        </div>--><div class="c-form" ng-if="vm.options.backgroundEnabled"><div class="c-form-label">\u80CC\u666F\u8272:</div><div class="c-form-div" style="display: flex;align-items: center"><modele-color-picker theme-colors="vm.themeColors" color="vm.data.settings.backgroundColor" on-change="onColorChange()"></modele-color-picker><!--                <color-pick color="vm.data.settings.backgroundColor" transparent="true" on-update="onColorChange(text)"></color-pick>--></div></div><div ng-if="vm.options.borderEnabled"><div class="c-form"><div class="c-form-label">\u8FB9\u6846:</div><div class="c-form-div" style="display: flex;align-items: center"><!--                    <input type="number" class="c-select1" ng-model="vm.data.settings.border.lineWidth" step="1" min="0" max="3" ng-change="onBorderInputChange(vm.data.settings.border.lineWidth)" />--><modele-color-picker style="margin-right: 10px" theme-colors="vm.themeColors" color="vm.data.settings.border.color" on-change="onColorChange()"></modele-color-picker><modele-select ng-model="vm.data.settings.border.lineWidth" ng-change="onBorderInputChange(vm.data.settings.border.lineWidth)" label-key="value" value-key="id" options="vm.lineWidths"></modele-select><span style="margin-left: 5px;font-size: 16px">px</span></div></div><!--            <div class="c-form">--><!--                <div class="c-form-label">\u8FB9\u6846\u8272:</div>--><!--                <div class="c-form-div">--><!--                    <color-pick color="vm.data.settings.border.color" transparent="true" on-update="onColorChange(text)"></color-pick>--><!--                </div>--><!--            </div>--><div class="c-form" ng-if="!vm.config.removeBorderOverlap && !vm.config.removeBorderBottom"><div class="c-form-label">\u5706\u89D2:</div><div class="c-form-div group-form"><div class="group-form-input"><div class="group-form-item"><span class="group-form-item-title">TL</span> <input type="number" ng-model="vm.data.settings.border.tlRadius" ng-change="onItemChange()"></div><div class="group-form-item"><span class="group-form-item-title">TR</span> <input type="number" ng-model="vm.data.settings.border.trRadius" ng-change="onItemChange()"></div><div class="group-form-item"><span class="group-form-item-title">BL</span> <input type="number" ng-model="vm.data.settings.border.blRadius" ng-change="onItemChange()"></div><div class="group-form-item"><span class="group-form-item-title">BR</span> <input type="number" ng-model="vm.data.settings.border.brRadius" ng-change="onItemChange()"></div></div></div></div></div></div><div class="c-view-set" ng-repeat="item in vm.data.settings.items track by $index" ng-if="item.type == \'date\' || item.type ==\'week\' || item.type == \'year\' || item.type == \'month\' || item.type == \'event\' "><div class="c-style-title">{{item.name || "\u672A\u77E5\u540D\u79F0"}}</div><div class="c-form"><div class="c-form-label">\u80CC\u666F\u8272:</div><div class="c-form-div" style="display: flex"><modele-color-picker theme-colors="vm.themeColors" color="item.backgroundColor" on-change="onColorChange()"></modele-color-picker></div></div><div class="c-form" ng-if="!vm.title"><div class="c-form-label">\u4F4D\u7F6E\u5927\u5C0F:</div><div class="c-form-div group-form"><div class="group-form-input"><div class="group-form-item"><span class="group-form-item-title">X</span> <input type="number" ng-model="item.x" ng-change="onItemChange()"></div><div class="line"></div><div class="group-form-item"><span class="group-form-item-title">Y</span> <input type="number" ng-model="item.y" ng-change="onItemChange()"></div><div class="line"></div><div class="group-form-item"><span class="group-form-item-title">W</span> <input type="number" ng-model="item.w" ng-change="onItemChange()"></div><div class="line"></div><div class="group-form-item"><span class="group-form-item-title">H</span> <input type="number" ng-model="item.h" ng-change="onItemChange()"></div></div><div style="margin-left: 10px">%</div></div></div><div class="c-form" ng-if="vm.title"><div class="c-form-label">\u4F4D\u7F6E\u5927\u5C0F:</div><div class="c-editor-attribute-view-input"><div class="c-editor-attribute-view-input-view"><span>X</span> <input type="number" ng-model="item.x" ng-change="onItemChange()"></div><div class="c-editor-attribute-view-input-view"><span>Y</span> <input type="number" ng-model="item.y" ng-change="onItemChange()"></div></div><div class="c-editor-attribute-view-input"><div class="c-editor-attribute-view-input-view"><span>\u5BBD</span> <input type="number" ng-model="item.w" ng-change="onItemChange()"></div><div class="c-editor-attribute-view-input-view"><span>\u9AD8</span> <input type="number" ng-model="item.h" ng-change="onItemChange()"></div></div></div><div ng-if="vm.style"><div class="c-form"><div class="c-form-label">\u6587\u5B57\u989C\u8272:</div><div class="c-form-div" style="display: flex;align-items: center"><modele-color-picker style="margin-right: 10px" transparent="false" theme-colors="vm.themeColors" color="item.textColor" on-change="onColorChange()"></modele-color-picker></div></div><div class="c-form"><div class="c-form-label">\u6587\u5B57\u5927\u5C0F:</div><div class="c-form-div"><input type="number" class="c-select1" ng-model="item.textSize" step="1" min="10" ng-change="onInputChange(item.textSize, $index)"></div></div><div class="c-form"><div class="c-form-label">\u6587\u5B57\u5B57\u4F53:</div><div class="c-form-div"><font-family :is-calendar="true" :family="item.textFontUuid" on-change="onFontChange(text,item)"></font-family></div></div></div><div ng-if="!vm.style"><div class="c-form"><div class="c-form-label">\u6587\u5B57:</div><div class="c-form-div" style="display: flex;align-items: center"><modele-color-picker style="margin-right: 10px" transparent="false" theme-colors="vm.themeColors" color="item.textColor" on-change="onColorChange()"></modele-color-picker><div style="width: 200px; margin-right: 10px"><font-family :is-calendar="true" :family="item.textFontUuid" on-change="onFontChange(text,item)"></font-family></div><input type="number" class="c-select1" ng-model="item.textSize" step="1" min="10" ng-change="onInputChange(item.textSize, $index)" style="width: 80px"></div></div></div><div class="c-form"><div class="c-form-label">\u5BF9\u9F50:</div><div class="c-form-div"><modele-select ng-model="item.textAlign" ng-change="onItemChange()" label-key="value" value-key="id" options="vm.textAligns"></modele-select><!--                <select class="c-select1" name="textAlign" ng-model="item.textAlign" ng-change="onItemChange()">--><!--                    <option value="left">\u5DE6\u5BF9\u9F50</option>--><!--                    <option value="center">\u5C45\u4E2D</option>--><!--                    <option value="right">\u53F3\u5BF9\u9F50</option>--><!--                </select>--></div></div><div class="c-form" ng-if="item.textBold1"><div class="c-form-label">\u7C97\u4F53:</div><div class="c-form-div" style="display: flex;align-items: center"><input type="checkbox" class="checkOrIf" ng-checked="item.textBold" ng-click="operationBold($event, item)"></div></div><div class="c-form" ng-if="item.textItalic1"><div class="c-form-label">\u659C\u4F53:</div><div class="c-form-div" style="display: flex;align-items: center"><input type="checkbox" class="checkOrIf" ng-checked="item.textItalic" ng-click="operationItalic($event, item)"></div></div></div></div><style>.c-view-set{\n        margin-bottom: 15px;\n        border-bottom: 1px solid #ddd;\n    }\n    .c-view-set:last-child{\n        border: 0;\n    }\n    .c-style-title{\n        line-height: 30px;\n        font-size: 14px;\n        font-weight: 600;\n        margin: 0 !important;\n    }\n    .title1{\n        height: 30px;\n        display: flex;\n        align-items: center;\n        font-weight: 400;\n        color: #555;\n        margin-top: 10px;\n    }\n    .title1:first-child{\n        margin-top: 0 !important;\n    }\n    .c-form-label{\n        width: 75px !important;\n        font-size: 14px;\n    }\n    .c-form-div{\n        width: auto !important;\n        margin-left: 75px !important;\n    }\n    /*\u6837\u5F0F\u4E8C*/\n    .c-style-two .c-form-label{\n        width: 100% !important;\n        text-align: left;\n    }\n    .c-style-two .c-form-div{\n        margin: 0 !important;\n        width: 100% !important;\n    }</style>');
$templateCache.put('app/entities/calendar/controls/title-cell.control.html','<div ng-style="vm.data.styles" style="position: relative" ng-if="!vm.loading"><div ng-repeat="item in vm.data.items"><div ng-if=" item.type==\'image\' " ng-style="item.styles"><img ng-if="item.url" ng-src="{{item.url}}" style="object-fit: contain; width:100%;height:100%;text-align: center"></div><div ng-if=" item.type==\'userimage\' " ng-style="item.styles"><img ng-if="item.url" ng-src="{{item.url}}" style="object-fit: contain; width:100%;height:100%;text-align: center"></div><div ng-if=" item.type==\'year\' || item.type==\'month\' " ng-style="item.styles">{{item.value}}</div></div></div>');
$templateCache.put('app/entities/calendar/controls/week-cell.control.html','<div ng-style="vm.data.styles" style="position: relative"><div ng-repeat="item in vm.data.items"><div ng-if=" item.type==\'image\' " ng-style="item.styles"><img ng-if="item.url" ng-src="{{item.url}}" style="object-fit: contain; width:100%;height:100%;text-align: center"></div><div ng-if=" item.type==\'userimage\' " ng-style="item.styles"><img ng-if="item.url" ng-src="{{item.url}}" style="object-fit: contain; width:100%;height:100%;text-align: center"></div><div ng-if=" item.type==\'week\' " ng-style="item.styles">{{itemValue(item)}}</div></div></div>');
$templateCache.put('app/entities/calendar/modal/calendar-add.html','<div class="c-model"><div class="c-model-head"><div class="c-model-head-title">{{vm.isCopy ? \'\u590D\u5236\u65E5\u5386\u7EC4\u4EF6\' : \'\u521B\u5EFA\u65E5\u5386\u7EC4\u4EF6\'}}</div><i class="iconfont icon-closeicon1" ng-click="vm.cancel()"></i></div><div class="c-model-body"><div class="c-model-body-view"><div class="c-form"><label class="c-form-label">\u7EC4\u4EF6\u540D\u79F0\uFF1A</label><div class="c-form-div"><input type="text" class="c-input1" ng-model="vm.data.name" placeholder="\u8BF7\u8F93\u5165"></div></div><div class="c-form" ng-if="!vm.isCopy"><label class="c-form-label">\u5E03\u5C40\u7C7B\u578B\uFF1A</label><div class="c-form-div"><modele-select ng-model="vm.data.displayType" label-key="name" value-key="id" options="vm.types" ng-change="displayTypeUpdate()"></modele-select></div></div></div></div><div class="c-model-foot" style="text-align: center"><button type="button" style="margin-right: 16px" class="btn btn-cancel" ng-click="vm.cancel()">\u8FD4\u56DE</button> <button type="button" class="btn btn-info" ng-click="vm.save()">\u786E\u5B9A</button></div></div><style>.c-model{\n        width: 680px;\n        margin: 0 auto;\n    }\n    .c-form {\n        margin-bottom: 16px;\n    }\n\n    .c-model-body-view .c-form:last-child {\n        margin-bottom: 0;\n    }\n\n    .c-form .c-form-label {\n        width: 80px;\n        text-align: left;\n        line-height: 40px;\n        font-size: 14px;\n        color: #505760;\n        padding-right: 0;\n    }\n\n    .c-form .c-form-div {\n        margin-left: 80px;\n        width: auto;\n    }\n\n    .c-form .c-form-div input.c-input1 {\n        height: 40px;\n    }\n\n    .c-form .c-form-div select.c-select1 {\n        height: 40px;\n    }</style>');
$templateCache.put('app/entities/calendar/modal/calendar-title-add.html','<div class="c-model"><div class="c-model-head"><div class="c-model-head-title">{{vm.isCopy ? "\u590D\u5236" : "\u521B\u5EFA"}}\u6807\u9898\u7EC4\u4EF6</div><i class="iconfont icon-closeicon1" ng-click="vm.cancel()"></i></div><div class="c-model-body"><div class="c-model-body-view"><div class="c-form"><label class="c-form-label">\u7EC4\u4EF6\u540D\u79F0\uFF1A</label><div class="c-form-div"><input type="text" class="c-input1" ng-model="vm.data.name" placeholder="\u8BF7\u8F93\u5165"></div></div><div class="c-form"><label class="c-form-label">\u5E03\u5C40\u7C7B\u578B\uFF1A</label><div class="upload-box pointer" ng-if="!vm.data.layout.previewUrl" ng-click="selectLayout()"><i class="iconfont icon-jia1"></i> \u53BB\u6DFB\u52A0</div><div class="upload-preview pointer" ng-if="vm.data.layout.previewUrl" ng-click="selectLayout()"><div class="img-view"><img alt="\u56FE\u7247\u7F3A\u5931" ng-src="{{vm.data.layout.previewUrl}}"></div></div></div></div></div><div class="c-model-foot" style="text-align: center"><button style="margin-right: 16px" type="button" class="btn btn-cancel" ng-click="vm.cancel()">\u53D6\u6D88</button> <button type="button" class="btn btn-info" ng-click="vm.save()">\u786E\u5B9A</button></div></div><style>.c-model{\n        width: 680px;\n        margin: 0 auto;\n    }\n    .c-form {\n        margin-bottom: 16px;\n    }\n\n    .c-model-body-view .c-form:last-child {\n        margin-bottom: 0;\n    }\n\n    .c-form .c-form-label {\n        width: 80px;\n        text-align: left;\n        line-height: 40px;\n        font-size: 14px;\n        color: #505760;\n        padding-right: 0;\n    }\n\n    .c-form .c-form-div {\n        margin-left: 80px;\n        width: auto;\n    }\n\n    .c-form .c-form-div input.c-input1 {\n        height: 40px;\n    }\n\n    .c-form .c-form-div select.c-select1 {\n        height: 40px;\n    }</style>');
$templateCache.put('app/entities/calendar/modal/calendar-title-data.html','<div class="c-model" style="width: 784px"><div class="c-model-head"><div class="c-model-head-title">\u65B0\u5EFA\u6807\u9898\u7EC4\u4EF6</div><i class="iconfont icon-closeicon1" ng-click="vm.cancel()"></i></div><div class="c-model-body"><div class="c-model-body-view scrollbar-main" style="padding: 16px"><div class="layout-list"><div class="layout-item" ng-repeat="layout in vm.layouts" ng-click="vm.onLayoutSelect(layout)" ng-class="{\'active\': layout.id==vm.data.id}"><img ng-if="layout.previewUrl" ng-src="{{layout.previewUrl}}"> <span ng-if="!layout.previewUrl">\u65E0\u56FE</span></div></div></div></div><div class="c-model-foot" style="text-align: center"><button style="margin-right: 16px" type="button" class="btn btn-cancel" ng-click="vm.cancel()">\u8FD4\u56DE</button> <button type="button" class="btn btn-info" ng-click="vm.save()">\u786E\u5B9A</button></div></div><style>.layout-list{\n        display: flex;\n        flex-wrap: wrap;\n        align-items: center;\n    }\n    .layout-item{\n        display: flex;\n        align-items: center;\n        width: 128px;\n        height: 128px;\n        padding: 8px;\n        background: #F5F7FA;\n        border: 1px solid transparent;\n        margin-right: 16px;\n        margin-bottom: 16px;\n    }\n    .layout-item.active{\n        border-color: #264DF0;\n    }\n    .layout-item img{\n        max-width: 100%;\n        max-height: 100%;\n    }</style>');
$templateCache.put('app/entities/my-upload/modal/background-add.html','<div class="c-model"><div class="c-model-head"><div class="c-model-head-title">\u4E0A\u4F20\u80CC\u666F</div><i class="iconfont icon-closeicon1" ng-click="vm.cancel()"></i></div><div class="c-model-body"><div class="c-model-body-view"><div class="c-form"><label class="c-form-label">\u6807\u7B7E\uFF1A</label><div class="c-form-div"><modele-select ng-model="vm.themeClassifyId" style="width:100%" label-key="name" value-key="id" options="vm.themeClassifies"></modele-select></div></div><div class="c-form"><label class="c-form-label">\u80CC\u666F\uFF1A</label><div class="upload-view scrollbar-main"><div class="upload-item" ng-repeat="item in vm.fileList"><local-loading show="item.loadState === 1 || item.loadState === 0" title="{{ item.loadState === 0 ? \'\u7B49\u5F85\u4E0A\u4F20\' : \'\u4E0A\u4F20\u4E2D\' }}"></local-loading><div class="item-preview" ng-if="item.loadState === 2 || item.loadState === 3"><div class="error-box" ng-if="item.loadState === 3"><i class="iconfont icon-error"></i> <span>\u4E0A\u4F20\u5931\u8D25</span></div><img ng-src="{{ item.preview }}" alt=""></div><div class="btn-delete" ng-if="item.loadState !== 0" ng-click="deleteItem($index)"><i class="iconfont icon-cuo"></i></div></div><div class="upload-box" ng-if="vm.fileList.length < 50 && !vm.subLoading"><i class="iconfont icon-jia1"></i> \u4E0A\u4F20\u56FE\u7247 <input type="file" name="file" multiple="multiple" class="form-control" accept="image/jpeg, image/png" onchange="updateBackground(event)" ng-model-options="{debounce : 500}"></div></div></div></div></div><div class="c-model-foot"><button type="button" class="btn btn-cancel" ng-click="vm.cancel()" style="margin-right: 16px">\u53D6\u6D88</button> <button type="button" class="btn btn-info" ng-click="vm.subAdd()">\u786E\u5B9A</button></div></div><style>.modal-dialog{\n        width: 665px;\n    }\n    .c-form .c-form-label{\n        line-height: 40px;\n        width: 50px;\n    }\n    .c-form .c-form-div{\n        margin-left: 55px;\n        width: auto;\n    }\n    .c-form .upload-view{\n        margin-left: 55px;\n    }\n    .c-form .upload-box{\n        margin-left: 55px;\n    }</style>');
$templateCache.put('app/entities/my-upload/modal/clipArt-add.html','<div class="c-model"><div class="c-model-head"><div class="c-model-head-title">\u4E0A\u4F20\u7D20\u6750</div><i class="iconfont icon-closeicon1" ng-click="vm.cancel()"></i></div><div class="c-model-body"><div class="c-model-body-view"><div class="c-form"><label class="c-form-label">\u6807\u7B7E\uFF1A</label><div class="c-form-div"><modele-select ng-model="vm.themeClassifyId" style="width:100%" label-key="name" value-key="id" options="vm.themeClassifies"></modele-select></div></div><div class="c-form"><label class="c-form-label">\u7D20\u6750\uFF1A</label><div class="upload-view scrollbar-main"><div class="upload-item" ng-repeat="item in vm.fileList"><local-loading show="item.loadState === 1 || item.loadState === 0" title="{{ item.loadState === 0 ? \'\u7B49\u5F85\u4E0A\u4F20\' : \'\u4E0A\u4F20\u4E2D\' }}"></local-loading><div class="item-preview" ng-if="item.loadState === 2 || item.loadState === 3"><div class="error-box" ng-if="item.loadState === 3"><i class="iconfont icon-error"></i> <span>\u4E0A\u4F20\u5931\u8D25</span></div><img ng-src="{{ item.preview }}" alt=""></div><div class="btn-delete" ng-if="item.loadState !== 0" ng-click="deleteItem($index)"><i class="iconfont icon-cuo"></i></div></div><div class="upload-box" ng-if="vm.fileList.length < 50 && !vm.subLoading"><i class="iconfont icon-jia1"></i> \u4E0A\u4F20\u56FE\u7247 <input type="file" name="file" multiple="multiple" class="form-control" accept="image/jpeg, image/png" onchange="updateBackground(event)" ng-model-options="{debounce : 500}"></div></div></div></div></div><div class="c-model-foot"><button type="button" class="btn btn-cancel" ng-click="vm.cancel()" style="margin-right: 16px">\u53D6\u6D88</button> <button type="button" class="btn btn-info" ng-click="vm.subAdd()">\u786E\u5B9A</button></div></div><style>.modal-dialog{\n        width: 665px;\n    }\n    .c-form .c-form-label{\n        line-height: 40px;\n        width: 50px;\n    }\n    .c-form .c-form-div{\n        margin-left: 55px;\n        width: auto;\n    }\n    .c-form .upload-view{\n        margin-left: 55px;\n    }\n    .c-form .upload-box{\n        margin-left: 55px;\n    }</style>');
$templateCache.put('app/entities/my-upload/modal/mask-add.html','<div class="c-model"><div class="c-model-head"><div class="c-model-head-title">\u4E0A\u4F20\u76F8\u6846</div><i class="iconfont icon-closeicon1" ng-click="vm.cancel()"></i></div><div class="c-model-body"><div class="c-model-body-view"><div class="c-form"><label class="c-form-label">\u6807\u7B7E\uFF1A</label><div class="c-form-div"><modele-select ng-model="vm.themeClassifyId" style="width:100%" label-key="name" value-key="id" options="vm.themeClassifies"></modele-select></div></div><div class="c-form"><label class="c-form-label">\u76F8\u6846\uFF1A</label><div class="upload-view scrollbar-main"><div class="upload-item" ng-repeat="item in vm.fileList"><local-loading show="item.loadState === 1 || item.loadState === 0" title="{{ item.loadState === 0 ? \'\u7B49\u5F85\u4E0A\u4F20\' : \'\u4E0A\u4F20\u4E2D\' }}"></local-loading><div class="item-preview" ng-if="item.loadState === 2 || item.loadState === 3"><div class="error-box" ng-if="item.loadState === 3"><i class="iconfont icon-error"></i> <span>\u4E0A\u4F20\u5931\u8D25</span></div><img ng-src="{{ item.preview }}" alt=""></div><div class="btn-delete" ng-if="item.loadState !== 0" ng-click="deleteItem($index)"><i class="iconfont icon-cuo"></i></div></div><div class="upload-box" ng-if="vm.fileList.length < 50 && !vm.subLoading"><i class="iconfont icon-jia1"></i> \u4E0A\u4F20\u56FE\u7247 <input type="file" name="file" multiple="multiple" class="form-control" accept="image/jpeg, image/png" onchange="updateBackground(event)" ng-model-options="{debounce : 500}"></div></div><div class="c-form-div" style="margin-top: 8px"><p class="tips" style="font-size: 14px;color: red">*\u53EA\u652F\u6301\u767D\u8272\u548C\u900F\u660E\u989C\u8272\u7684\u8D44\u6E90</p></div></div></div></div><div class="c-model-foot"><button type="button" class="btn btn-cancel" ng-click="vm.cancel()" style="margin-right: 16px">\u53D6\u6D88</button> <button type="button" class="btn btn-info" ng-click="vm.subAdd()">\u786E\u5B9A</button></div></div><style>.modal-dialog{\n        width: 665px;\n    }\n    .c-form .c-form-label{\n        line-height: 40px;\n        width: 50px;\n    }\n    .c-form .c-form-div{\n        margin-left: 55px;\n        width: auto;\n    }\n    .c-form .upload-view{\n        margin-left: 55px;\n    }</style>');
$templateCache.put('app/entities/my-upload/modal/pic-add.html','<div class="c-model"><div class="c-model-head"><div class="c-model-head-title">\u4E0A\u4F20\u56FE\u7247</div><i class="iconfont icon-closeicon1" ng-click="vm.cancel()"></i></div><div class="c-model-body"><div class="c-model-body-view"><div class="c-form"><label class="c-form-label">\u6807\u7B7E\uFF1A</label><div class="c-form-div"><modele-select ng-model="vm.themeClassifyId" style="width:100%" label-key="name" value-key="id" options="vm.themeClassifies"></modele-select></div></div><div class="c-form"><label class="c-form-label">\u56FE\u7247\uFF1A</label><div class="upload-view scrollbar-main"><div class="upload-item" ng-repeat="item in vm.fileList"><local-loading show="item.loadState === 1 || item.loadState === 0" title="{{ item.loadState === 0 ? \'\u7B49\u5F85\u4E0A\u4F20\' : \'\u4E0A\u4F20\u4E2D\' }}"></local-loading><div class="item-preview" ng-if="item.loadState === 2 || item.loadState === 3"><div class="error-box" ng-if="item.loadState === 3"><i class="iconfont icon-error"></i> <span>\u4E0A\u4F20\u5931\u8D25</span></div><img ng-src="{{ item.preview }}" alt=""></div><div class="btn-delete" ng-if="item.loadState !== 0" ng-click="deleteItem($index)"><i class="iconfont icon-cuo"></i></div></div><div class="upload-box" ng-if="vm.fileList.length < 50 && !vm.subLoading"><i class="iconfont icon-jia1"></i> \u4E0A\u4F20\u56FE\u7247 <input type="file" name="file" multiple="multiple" class="form-control" accept="image/jpeg, image/png" onchange="updateBackground(event)" ng-model-options="{debounce : 500}"></div></div></div></div></div><div class="c-model-foot"><button type="button" class="btn btn-cancel" ng-click="vm.cancel()" style="margin-right: 16px">\u53D6\u6D88</button> <button type="button" class="btn btn-info" ng-click="vm.subAdd()">\u786E\u5B9A</button></div></div><style>.modal-dialog{\n        width: 665px;\n    }\n    .c-form .c-form-label{\n        line-height: 40px;\n        width: 50px;\n    }\n    .c-form .c-form-div{\n        margin-left: 55px;\n        width: auto;\n    }\n    .c-form .upload-view{\n        margin-left: 55px;\n    }\n    .c-form .upload-box{\n        margin-left: 55px;\n    }</style>');
$templateCache.put('app/entities/patterns/modal/patterns-modal-three.html','<div class="c-model" ng-if="vm.oldView"><div class="c-model-head clearfix"><div class="c-model-head-title">\u6211\u7684\u6A21\u578B</div><button aria-label="Close" data-dismiss="modal" class="close" type="button" ng-click="vm.cancel()"><span aria-hidden="true">&times;</span></button></div><div class="c-model-body"><div class="c-form"><label class="c-form-label" style="width: 150px">\u6A21\u578B\u540D\u79F0\uFF1A</label><div class="c-form-div lh35" style="margin-left: 150px; width: 335px"><input type="text" class="c-input1" ng-model="vm.data.name" ng-if="vm.type != \'look\'" placeholder="\u8BF7\u8F93\u5165\u6A21\u578B\u540D\u79F0"> <span ng-if="vm.type == \'look\'">{{vm.data.name}}</span></div></div><div class="c-form"><label class="c-form-label" style="width: 150px">\u6A21\u578B\u56FE\u7247\uFF1A</label><div class="c-form-div lh35" style="margin-left: 150px; width: 335px" ng-if="vm.type != \'look\'"><div ng-if="vm.data.modelPic" style="width: 100px; position: relative"><img alt="\u56FE\u7247\u7F3A\u5931" ng-if="domains.domain" ng-src="{{domains.domain + vm.data.modelPic}}" style="max-width: 100px; max-height: 100px"> <i class="glyphicon glyphicon-remove" ng-click="removeFile()" style="color: red; position: absolute; right: -20px; top: 50%; margin-top: -10px" role="button" tabindex="0"></i></div><div style="width: 100px; height: 100px;position: relative" ng-if="!vm.data.modelPic"><input type="file" name="file" accept=" image/jpeg, image/png" onchange="uploadPic(event)" ng-model-options="{debounce : 500}" style="position: absolute;display: block; top: 0; left: 0; width: 100%; height: 100%; font-size: 100px; opacity: 0; filter: alpha(opacity=0); z-index: 1"> <img src="content/images/icon/upload_img.svg" alt="" style="position: absolute; width: 100%; z-index: 0"></div></div><div class="c-form-div lh35" style="margin-left: 150px; width: 335px" ng-if="vm.type == \'look\'"><div ng-if="vm.data.modelPic" style="width: 100px; position: relative"><img alt="\u56FE\u7247\u7F3A\u5931" ng-if="domains.domain" ng-src="{{domains.domain + vm.data.modelPic}}" style="max-width: 100px; max-height: 100px"></div></div></div><div class="c-form" ng-if="vm.type != \'look\'"><label class="c-form-label" style="width: 150px">3D\u6A21\u578B\uFF1A</label><div class="c-form-div lh35" style="margin-left: 150px; width: 335px"><div class="btn-3dfile"><input type="file" name="file" class="filePrew" accept=".gltf,.glb" onchange="uploadPic1(event)" ng-model-options="{debounce : 500}"> <span>{{vm.data.modelPath ? \'\u91CD\u65B0\u9009\u62E9\' : \'\u4E0A\u4F203D\u6A21\u578B\'}}</span></div><div class="">\u53EA\u652F\u6301.gltf .glb\u683C\u5F0F</div></div></div><div class="c-form" ng-if="vm.data.modelPath"><label class="c-form-label" style="width: 150px">3D\u6A21\u578B\u6570\u636E\uFF1A</label><div class="c-form-div lh35" style="margin-left: 150px; width: 335px"><div ng-repeat="item in vm.modelData track by $index" ng-if="!vm.modelLoad">{{item.materialName}}</div><div ng-if="vm.modelLoad" style="color: #999">\u6570\u636E\u89E3\u6790\u4E2D...</div></div></div></div><div class="c-model-foot" style="text-align: center"><button type="button" class="btn btn-info" ng-click="vm.save()" ng-if="vm.type != \'look\'">\u786E\u5B9A</button> <button type="button" class="btn btn-cancel" ng-click="vm.cancel()">\u53D6\u6D88</button></div></div><div class="c-model"><div class="c-model-head"><div class="c-model-head-title">{{vm.type == \'add\' ? \'\u521B\u5EFA3D\u6A21\u578B\' : \'\u6A21\u578B\u7F16\u8F91\'}}</div><i class="iconfont icon-closeicon1" ng-click="vm.cancel()"></i></div><div class="c-model-body"><div class="c-model-body-view"><div class="c-form"><label class="c-form-label">\u6A21\u578B\u540D\u79F0\uFF1A</label><div class="c-form-div lh35"><input type="text" class="c-input1" ng-model="vm.data.name" placeholder="\u8BF7\u8F93\u5165\u6A21\u578B\u540D\u79F0"></div></div><div class="c-form"><label class="c-form-label">\u6A21\u578B\u56FE\u7247\uFF1A</label><div class="upload-box" ng-if="!vm.data.modelPic"><i class="iconfont icon-jia1"></i> \u4E0A\u4F20\u56FE\u7247 <input type="file" name="file" accept=" image/jpeg, image/png" onchange="uploadPic(event)" ng-model-options="{debounce : 500}"></div><div class="upload-preview" ng-if="vm.data.modelPic"><div class="img-view"><img alt="\u56FE\u7247\u7F3A\u5931" ng-if="domains.domain" ng-src="{{domains.domain + vm.data.modelPic}}"></div><div class="reload-btn" ng-click="removeFile()"><i class="iconfont icon-zhongxuan"></i>\u91CD\u65B0\u4E0A\u4F20</div></div></div><div class="c-form"><label class="c-form-label">3D\u6A21\u578B\uFF1A</label><div class="upload-box2"><div class="lh35" ng-if="vm.data.modeTFileName">{{vm.data.modeTFileName}}</div><div class="upload-btn"><i class="iconfont icon-Upload"></i> {{ vm.data.modelPath ? \'\u91CD\u65B0\u4E0A\u4F20\' : \'\u4E0A\u4F20\u6587\u4EF6\' }} <input type="file" name="file" accept=".gltf,.glb" onchange="uploadPic1(event)" ng-model-options="{debounce : 500}"></div><div class="upload-tips">\u53EA\u652F\u6301.gltf .glb\u683C\u5F0F</div></div></div><div class="c-form" ng-if="vm.data.modelPath"><label class="c-form-label">\u6A21\u578B\u6570\u636E\uFF1A</label><div class="model-info"><div class="info-item" ng-if="vm.modelLoad">\u6570\u636E\u89E3\u6790\u4E2D...</div><div class="info-item" ng-repeat="item in vm.modelData track by $index" ng-if="!vm.modelLoad">{{item.materialName}}{{$index != vm.modelData.length-1 ? "\u3001" : "" }}</div></div></div></div></div><div class="c-model-foot" style="text-align: center"><button style="margin-right: 16px" type="button" class="btn btn-cancel" ng-click="vm.cancel()">\u53D6\u6D88</button> <button type="button" class="btn btn-info" ng-click="vm.save()">\u786E\u5B9A</button></div></div><style>.c-model {\n        width: 680px;\n        margin: 0 auto;\n    }\n\n    .c-form {\n        margin-bottom: 16px;\n    }\n\n    .c-model-body-view .c-form:last-child {\n        margin-bottom: 0;\n    }\n\n    .c-form .c-form-label {\n        width: 70px;\n        text-align: left;\n        line-height: 40px;\n        font-size: 14px;\n        color: #505760;\n        padding-right: 0;\n    }\n\n    .c-form .c-form-div {\n        margin-left: 70px;\n        width: auto;\n    }\n\n    .c-form .c-form-div input.c-input1 {\n        height: 40px;\n    }\n\n    .c-form .c-form-div select.c-select1 {\n        height: 40px;\n    }</style>');
$templateCache.put('app/entities/patterns/modal/patterns-modal.html','<div class="c-model" ng-if="vm.oldView"><div class="c-model-head"><div class="c-model-head-title">{{vm.type == \'add\' ? \'\u521B\u5EFA2D\u6A21\u578B\' : \'\u67E5\u770B\u6A21\u578B\'}}</div><i class="iconfont icon-closeicon1" ng-click="vm.cancel()"></i></div><div class="c-model-body"><div class="c-model-body-view"><div class="c-form"><label class="c-form-label">\u6A21\u578B\u540D\u79F0\uFF1A</label><div class="c-form-div"><input type="text" class="c-input1" ng-model="vm.data.name" ng-if="vm.type != \'look\'" placeholder="\u8BF7\u8F93\u5165\u6A21\u578B\u540D\u79F0"> <span ng-if="vm.type == \'look\'">{{vm.data.name}}</span></div></div><div class="c-form"><label class="c-form-label" style="width: 150px">\u6A21\u578B\u5C3A\u5BF8\uFF1A</label><div class="c-form-div lh35" style="margin-left: 150px; width: 335px" ng-if="vm.type != \'look\'"><input type="text" class="c-input1" ng-model="vm.data.gWidth" style="width: 80px" placeholder="\u5BBD\u5EA6"> <span style="margin: 0 20px"><img src="content/images/icons/ic_guanlian.png" alt=""></span><input type="text" class="c-input1" ng-model="vm.data.gHeight" style="width: 80px" placeholder="\u9AD8\u5EA6"><select class="c-select1" ng-model="vm.data.sizeUnit" ng-options="item.id as item.name for item in vm.units" ng-change="unitConversion()" style="width: 80px; margin-left: 25px"></select></div><div class="c-form-div lh35" style="margin-left: 150px; width: 335px" ng-if="vm.type == \'look\'"><span>{{vm.data.gWidth}}</span> <span style="margin-right: 15px">\u5BBD</span> <span>{{vm.data.gHeight}}</span> <span style="margin-right: 15px">\u9AD8</span> <span>{{vm.data.sizeUnit}}</span></div></div><div class="c-form"><label class="c-form-label" style="width: 150px">\u5B9A\u5236\u533A\u57DF\uFF1A</label><div class="c-form-div lh35" style="margin-left: 150px; width: 335px" ng-if="vm.type != \'look\'"><input type="text" class="c-input1" ng-model="vm.data.x" style="width: 80px" placeholder="x"> <input type="text" class="c-input1" ng-model="vm.data.y" style="width: 80px" placeholder="y"> <input type="text" class="c-input1" ng-model="vm.data.width" style="width: 80px" placeholder="\u5BBD"> <input type="text" class="c-input1" ng-model="vm.data.height" style="width: 80px" placeholder="\u9AD8"></div><div class="c-form-div lh35" style="margin-left: 150px; width: 335px" ng-if="vm.type == \'look\'"><span style="margin-right: 15px">{{vm.data.x}}</span> <span style="margin-right: 15px">{{vm.data.y}}</span> <span style="margin-right: 15px">{{vm.data.width}}</span> <span style="margin-right: 15px">{{vm.data.height}}</span></div></div><div class="c-form"><label class="c-form-label" style="width: 150px">\u6A21\u578B\u56FE\u7247\uFF1A</label><div class="c-form-div lh35" style="margin-left: 150px; width: 335px" ng-if="vm.type != \'look\'"><div ng-if="vm.data.modelPic" style="width: 100px; position: relative"><img alt="\u56FE\u7247\u7F3A\u5931" ng-if="domains.domain" ng-src="{{domains.domain + vm.data.modelPic}}" style="max-width: 100px; max-height: 100px"> <i class="glyphicon glyphicon-remove" ng-click="removeFile()" style="color: red; position: absolute; right: -20px; top: 50%; margin-top: -10px" role="button" tabindex="0"></i></div><div style="width: 100px; height: 100px;position: relative" ng-if="!vm.data.modelPic"><input type="file" name="file" accept=" image/jpeg, image/png" onchange="uploadPic(event)" ng-model-options="{debounce : 500}" style="position: absolute;display: block; top: 0; left: 0; width: 100%; height: 100%; font-size: 100px; opacity: 0; filter: alpha(opacity=0); z-index: 1"> <img src="content/images/icon/upload_img.svg" alt="" style="position: absolute; width: 100%; z-index: 0"></div></div><div class="c-form-div lh35" style="margin-left: 150px; width: 335px" ng-if="vm.type == \'look\'"><div ng-if="vm.data.modelPic" style="width: 100px; position: relative"><img alt="\u56FE\u7247\u7F3A\u5931" ng-if="domains.domain" ng-src="{{domains.domain + vm.data.modelPic}}" style="max-width: 100px; max-height: 100px"></div></div></div><div class="c-form"><label class="c-form-label" style="width: 150px">\u56FE\u7247\u5C42\u7EA7\uFF1A</label><div class="c-form-div" style="margin-left: 150px; width: 335px" ng-if="vm.type != \'look\'"><div ng-class="{\'checkbox-1\':vm.data.hierarchy == \'BOTTOM\',\'checkbox-0\': vm.data.hierarchy != \'BOTTOM\'}" class="checkbox-icon float-left" ng-click="vm.openedCheck(false)"></div><span ng-click="vm.openedCheck(false)" class="checkbox-icon float-left mar-left-10" style="margin-top: 7px; width: 30px">\u7F6E\u5E95</span><div ng-class="{\'checkbox-1\':vm.data.hierarchy == \'TOP\',\'checkbox-0\':vm.data.hierarchy != \'TOP\'}" class="checkbox-icon float-left" ng-click="vm.openedCheck(true)" style="margin-left: 30px"></div><div ng-click="vm.openedCheck(true)" class="checkbox-icon float-left mar-left-10" style="margin-top: 7px; width: 30px">\u7F6E\u9876</div></div><div class="c-form-div lh35" style="margin-left: 150px; width: 335px" ng-if="vm.type == \'look\'"><span ng-if="vm.data.hierarchy == \'BOTTOM\'">\u7F6E\u5E95</span> <span ng-if="vm.data.hierarchy == \'TOP\'">\u7F6E\u9876</span></div></div></div></div><div class="c-model-foot" style="text-align: center"><button type="button" class="btn btn-info" ng-click="vm.save()" ng-if="vm.type != \'look\'">\u786E\u5B9A</button> <button type="button" class="btn btn-cancel" ng-click="vm.cancel()">\u53D6\u6D88</button></div></div><div class="c-model"><div class="c-model-head"><div class="c-model-head-title">{{vm.type == \'add\' ? \'\u521B\u5EFA2D\u6A21\u578B\' : \'\u6A21\u578B\u7F16\u8F91\'}}</div><i class="iconfont icon-closeicon1" ng-click="vm.cancel()"></i></div><div class="c-model-body"><div class="c-model-body-view"><div class="c-form"><label class="c-form-label">\u6A21\u578B\u540D\u79F0\uFF1A</label><div class="c-form-div"><input type="text" class="c-input1" ng-model="vm.data.name" placeholder="\u8BF7\u8F93\u5165\u6A21\u578B\u540D\u79F0"></div></div><div class="c-form"><label class="c-form-label">\u6A21\u578B\u5C3A\u5BF8\uFF1A</label><div class="c-form-div group-form-view"><div class="group-size-input"><div class="item"><span class="title">\u5BBD</span> <input type="text" ng-model="vm.data.gWidth"></div><div class="item"><span class="title">\u9AD8</span> <input type="text" ng-model="vm.data.gHeight"></div></div><modele-select style="width:134px" ng-if="vm.data" prefix="\u5355\u4F4D" ng-model="vm.data.sizeUnit" label-key="name" value-key="id" options="vm.units" ng-change="unitConversion()"></modele-select></div></div><div class="c-form"><label class="c-form-label">\u5B9A\u5236\u533A\u57DF\uFF1A</label><div class="c-form-div group-form-view"><div class="group-size-input" style="width: 100%"><div class="item"><span class="title">X</span> <input type="text" ng-model="vm.data.x"></div><div class="item"><span class="title">Y</span> <input type="text" ng-model="vm.data.y"></div><div class="item"><span class="title">\u5BBD</span> <input type="text" ng-model="vm.data.width"></div><div class="item"><span class="title">\u9AD8</span> <input type="text" ng-model="vm.data.height"></div></div></div></div><div class="c-form"><label class="c-form-label">\u6A21\u578B\u56FE\u7247\uFF1A</label><div class="upload-box" ng-if="!vm.data.modelPic"><i class="iconfont icon-jia1"></i> \u4E0A\u4F20\u56FE\u7247 <input type="file" name="file" accept=" image/jpeg, image/png" onchange="uploadPic(event)" ng-model-options="{debounce : 500}"></div><div class="upload-preview" ng-if="vm.data.modelPic"><div class="img-view"><img alt="\u56FE\u7247\u7F3A\u5931" ng-if="domains.domain" ng-src="{{domains.domain + vm.data.modelPic}}"></div><div class="reload-btn" ng-click="removeFile()"><i class="iconfont icon-zhongxuan"></i>\u91CD\u65B0\u4E0A\u4F20</div></div></div><div class="c-form"><label class="c-form-label">\u56FE\u7247\u5C42\u7EA7\uFF1A</label><div class="c-form-div"><div class="radio-group"><div class="radio-item" ng-class="{\'active\':vm.data.hierarchy == \'BOTTOM\'}" ng-click="vm.openedCheck(false)"><i class="iconfont icon-xuanze"></i> <span>\u7F6E\u5E95</span></div><div class="radio-item" ng-class="{\'active\':vm.data.hierarchy == \'TOP\'}" ng-click="vm.openedCheck(true)"><i class="iconfont icon-xuanze"></i> <span>\u7F6E\u9876</span></div></div></div></div></div></div><div class="c-model-foot" style="text-align: center"><button style="margin-right: 16px" type="button" class="btn btn-cancel" ng-click="vm.cancel()">\u53D6\u6D88</button> <button type="button" class="btn btn-info" ng-click="vm.save()">\u786E\u5B9A</button></div></div><style>.c-model {\n        width: 680px;\n        margin: 0 auto;\n    }\n\n    .c-form {\n        margin-bottom: 16px;\n    }\n\n    .c-model-body-view .c-form:last-child {\n        margin-bottom: 0;\n    }\n\n    .c-form .c-form-label {\n        width: 70px;\n        text-align: left;\n        line-height: 40px;\n        font-size: 14px;\n        color: #505760;\n        padding-right: 0;\n    }\n\n    .c-form .c-form-div {\n        margin-left: 70px;\n        width: auto;\n    }\n\n    .c-form .c-form-div input.c-input1 {\n        height: 40px;\n    }\n\n    .c-form .c-form-div select.c-select1 {\n        height: 40px;\n    }</style>');
$templateCache.put('app/entities/patterns/modal/patterns-preview.html','<div class="preview-view"><div class="preview-close" ng-click="vm.cancel()"><i class="iconfont icon-closeicon1"></i></div><div class="preview-img-box" ng-if="vm.modelType == \'TWO\'"><img ng-src="{{vm.modelPic}}" alt=""></div><div class="preview-three-box" ng-if="vm.modelType == \'THREE\'"><three-preview1 width="300" height="300" style="background: #fff" model-data="vm.modelData" model-path="vm.modelPath"></three-preview1></div></div><style>.modal .modal-dialog{\n        width: 100vw;\n        height: 100vh;\n        position: fixed;\n        top: 0;\n        left: 0;\n        margin: 0 !important;\n        transform: none !important;\n    }\n    .modal-content{\n        margin: 0;\n    }\n    .preview-view{\n        position: fixed;\n        top: 0;\n        left: 0;\n        width: 100vw;\n        height: 100vh;\n        background: #ffffff;\n    }\n    .preview-close{\n        position: absolute;\n        top: 32px;\n        right: 32px;\n        width: 48px;\n        height: 48px;\n        background: #000000;\n        border-radius: 50%;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        cursor: pointer;\n        z-index: 10;\n    }\n    .preview-close .iconfont{\n        color: #ffffff;\n        font-size: 28px;\n    }\n    .preview-img-box,.preview-three-box{\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        width: 100%;\n        height: 100%;\n    }\n    .preview-img-box img{\n        max-width: 80%;\n        max-height: 80%;\n    }</style>');
$templateCache.put('app/entities/picture/modal/picture-add.html','<div class="c-model"><div class="c-model-head"><div class="c-model-head-title">\u521B\u5EFA\u7167\u7247\u5E03\u5C40</div><i class="iconfont icon-closeicon1" ng-click="vm.cancel()"></i></div><div class="c-model-body"><div class="c-model-body-view"><div class="c-form"><label class="c-form-label">\u5E03\u5C40\u5C3A\u5BF8\uFF1A</label><div class="c-form-div group-form-view"><div class="group-size-input"><div class="item"><span class="title">\u5BBD</span> <input type="text" ng-model="vm.data.width"></div><div class="item"><span class="title">\u9AD8</span> <input type="text" ng-model="vm.data.height"></div></div><modele-select style="width:134px" prefix="\u5355\u4F4D" ng-model="vm.data.unit" ng-change="unitCb()" label-key="name" value-key="id" options="vm.units"></modele-select></div></div><div class="c-form"><label class="c-form-label">\u5173\u8054\u4E3B\u9898\uFF1A</label><div class="c-form-div"><modele-select ng-model="vm.data.catalogId" label-key="name" value-key="id" options="vm.catalogs"></modele-select></div></div></div></div><div class="c-model-foot" style="text-align: center"><button style="margin-right: 16px" type="button" class="btn btn-cancel" ng-click="vm.cancel()">\u53D6\u6D88</button> <button type="button" class="btn btn-info" ng-click="vm.save()">\u786E\u5B9A</button></div></div><style>.c-model{\n        width: 680px;\n        margin: 0 auto;\n    }\n    .c-form {\n        margin-bottom: 16px;\n    }\n\n    .c-model-body-view .c-form:last-child {\n        margin-bottom: 0;\n    }\n\n    .c-form .c-form-label {\n        width: 70px;\n        text-align: left;\n        line-height: 40px;\n        font-size: 14px;\n        color: #505760;\n        padding-right: 0;\n    }\n\n    .c-form .c-form-div {\n        margin-left: 70px;\n        width: auto;\n    }\n\n    .c-form .c-form-div input.c-input1 {\n        height: 40px;\n    }\n\n    .c-form .c-form-div select.c-select1 {\n        height: 40px;\n    }</style>');
$templateCache.put('app/entities/picture/modal/picture-edit.html','<div class="c-model"><div class="c-model-head"><div class="c-model-head-title">\u4FEE\u6539\u4E3B\u9898</div><i class="iconfont icon-closeicon1" ng-click="vm.cancel()"></i></div><div class="c-model-body"><div class="c-model-body-view"><div class="c-form"><label class="c-form-label">\u5173\u8054\u4E3B\u9898\uFF1A</label><div class="c-form-div"><modele-select ng-model="vm.data.catalogId" label-key="name" value-key="id" options="vm.catalogs"></modele-select></div></div></div></div><div class="c-model-foot" style="text-align: center"><button type="button" class="btn btn-info" ng-click="vm.save()">\u786E\u5B9A</button> <button type="button" class="btn btn-cancel" ng-click="vm.cancel()">\u8FD4\u56DE</button></div></div><style>.c-form {\n        margin-bottom: 16px;\n    }\n\n    .c-model-body-view .c-form:last-child {\n        margin-bottom: 0;\n    }\n\n    .c-form .c-form-label {\n        width: 80px;\n        text-align: left;\n        line-height: 40px;\n        font-size: 14px;\n        color: #505760;\n    }\n\n    .c-form .c-form-div {\n        margin-left: 80px;\n        width: auto;\n    }\n\n    .c-form .c-form-div input.c-input1 {\n        height: 40px;\n    }\n\n    .c-form .c-form-div select.c-select1 {\n        height: 40px;\n    }</style>');
$templateCache.put('app/entities/picture/modal/picture-preview.html','<div class="preview-model"><div class="preview-model-head"><div class="title">\u9884\u89C8</div><div class="close-btn" ng-click="vm.cancel()"><i class="iconfont icon-closeicon1"></i></div></div><div class="preview-model-content"><img ng-src="{{vm.cover}}" alt=""></div></div>');
$templateCache.put('app/entities/page/modal/blendent-modal.html','<div class="c-model"><div class="c-model-head"><div class="c-model-head-title">\u8BBE\u7F6E\u914D\u8272</div><i class="iconfont icon-closeicon1" ng-click="vm.cancel()"></i></div><div class="c-model-body"><div class="c-form" ng-repeat="item in vm.modelData" ng-if="!item.page && item.page!==0"><label class="c-form-label" style="width: 150px">{{item.materialName}}\uFF1A</label><div class="c-form-div lh35" style="margin-left: 150px"><input type="text" class="c-input1" ng-model="item.color" ng-style="{background: item.color ? item.color : \'#fff\'}" style="width: 150px"> <input type="color" ng-value="item.color" ng-model="item.color" ng-change="colorChange()" style="width: 40px; height: 32px"></div></div><three-preview1 width="300" height="300" style="background: #fff" model-data="vm.modelData1" model-path="vm.modelPath"></three-preview1></div><div class="c-model-foot" style="text-align: center"><button type="button" class="btn btn-cancel btn-max" ng-click="vm.cancel()">\u53D6\u6D88</button> <button type="button" class="btn btn-info btn-max" ng-click="vm.save()">\u786E\u8BA4</button></div></div><style>.modal-content {\n        width: 100%;\n        margin: 100px auto;\n    }</style>');
$templateCache.put('app/entities/page/modal/box-copy.html','<div class="c-model"><div class="c-model-head"><div class="c-model-head-title">\u91CD\u590D\u751F\u6210</div><i class="iconfont icon-closeicon1" ng-click="vm.clear()"></i></div><div class="c-model-body"><div class="c-model-body-view"><div class="c-form" style="margin-bottom: 10px"><label class="c-form-label">\u9875\u9762\u8303\u56F4\uFF1A</label><div class="c-form-div"><select class="c-select1" ng-model="vm.data.range" ng-options="type.page as type.name for type in vm.types" ng-change="unitConversion()" style="height: 40px"></select></div></div><div class="c-form"><label class="c-form-label"></label><div class="c-form-div align-items-center"><div ng-click="vm.data.generLoc = \'all\'"><i class="iconfont icon-xuanze" ng-style="{color:vm.data.generLoc == \'all\' ? \'#264DF0\' : \'#505760\'}"></i> <span>\u76F8\u540C\u4F4D\u7F6E\u6240\u6709\u9875\u751F\u6210</span></div><div style="margin-left: 20px" ng-click="vm.data.generLoc = \'next\'"><i class="iconfont icon-xuanze" ng-style="{color:vm.data.generLoc == \'next\' ? \'#264DF0\' : \'#505760\'}"></i> <span>\u76F8\u540C\u4F4D\u7F6E\u9694\u9875\u751F\u6210</span></div></div></div></div></div><div class="c-model-foot"><button type="button" class="btn btn-cancel" ng-click="vm.clear()">\u53D6\u6D88</button> <button type="button" class="btn btn-info" ng-click="vm.save()" ng-disabled="editForm.$invalid || vm.isSaving">\u786E\u5B9A</button></div></div><style>.c-form{width: 100%;}\n    .c-form .c-form-label{\n        width: 70px;\n        padding: 0;\n        height: 40px;\n        line-height: 40px;\n    }\n    .c-form .c-form-div{\n        position: relative;\n        margin-left: 70px;\n        width: auto;\n        min-height: 40px;\n    }</style>');
$templateCache.put('app/entities/page/modal/calendar-modal.html','<div class="c-model"><div class="c-model-head"><div class="c-model-head-title">\u63D0\u793A</div><i class="iconfont icon-closeicon1" ng-click="vm.cancel()"></i></div><div class="c-model-body"><div class="c-model-body-view scrollbar-main" style="max-height: 500px"><div class="c-isCalendar-view-title">\u5F53\u524D\u52A8\u6001\u65E5\u5386\u6A21\u677F\u8D77\u59CB\u5E74\u6708\u4E3A\uFF1A<span>{{vm.startYear}}\u5E74{{vm.startMonth}}\u6708-{{vm.endYear}}\u5E74{{vm.endMonth}}\u6708</span></div><div class="c-isCalendar-view-title">\u68C0\u6D4B\u5230\u6708\u4EFD\u4E2D\u65AD\uFF0C\u4EE5\u4E0B\u6708\u4EFD\u4E0D\u5B58\u5728\uFF0C\u662F\u5426\u786E\u8BA4\u53D1\u5E03\uFF1F</div><div class="c-isCalendar-view1" ng-repeat="item in vm.defaultDate"><div class="c-isCalendar-view1-1">{{item.year}}\u5E74</div><div class="c-isCalendar-view1-2"><span ng-repeat="month in item.months">{{month}}\u6708</span></div></div></div></div><div class="c-model-foot"><button type="button" class="btn btn-cancel btn-max" ng-click="vm.cancel()">\u53D6\u6D88</button> <button type="button" class="btn btn-info btn-max" ng-click="vm.save()">\u786E\u8BA4</button></div></div><style>.c-isCalendar-view-title{\n        font-size: 14px;\n    }\n    .c-isCalendar-view-title span{\n        color: #264DF0;\n    }\n    .c-isCalendar-view1{\n        margin-top: 10px;\n    }\n    .c-isCalendar-view1-1{\n        color: #999;\n        font-size: 14px;\n    }\n    .c-isCalendar-view1-2{\n        width: 100%;\n        display: flex;\n        flex-wrap: wrap;\n        margin: 0 -5px;\n    }\n    .c-isCalendar-view1-2 span{\n        display: inline-block;\n        background: #fff5ee;\n        color: #ff8179;\n        width: 46px;\n        height: 30px;\n        border-radius: 4px;\n        line-height: 30px;\n        text-align: center;\n        margin: 5px;\n    }</style>');
$templateCache.put('app/entities/page/modal/document-detection.html','<div class="c-model" ng-if="vm.isDocumentDetection"><div class="c-model-head"><div class="c-model-head-title">{{vm.saveData.type==\'PRODUCT\' ? \'\u53D1\u5E03\u4EA7\u54C1\' : \'\u53D1\u5E03\u6A21\u677F\'}}</div><i class="iconfont icon-closeicon1" ng-click="vm.cancel()"></i></div><div class="c-model-body"><div class="c-model-body-view c-document-detection-body scrollbar-main"><div class="threeLoading1" ng-if="vm.loading">\u52A0\u8F7D\u4E2D...</div><div class="c-document-detection-body-view1"><div class="c-document-detection-body-view1-tab" ng-class="{\'c-document-detection-body-view1-tab-selected\' : vm.tapIndex == 1 || vm.tapIndex == 2 || vm.tapIndex == 3}">\u2460 \u5370\u5237\u98CE\u9669\u68C0\u6D4B</div><div class="c-document-detection-body-view1-hr" ng-class="{\'c-document-detection-body-view1-hr-selected\' : vm.tapIndex == 2 || vm.tapIndex == 3}" ng-if="vm.thirdPartySettings.length > 1"></div><div class="c-document-detection-body-view1-tab" ng-class="{\'c-document-detection-body-view1-tab-selected\' : vm.tapIndex == 2 || vm.tapIndex == 3}" ng-if="vm.thirdPartySettings.length > 1">\u2461 \u53D1\u5E03\u6E20\u9053\u9009\u62E9</div><div class="c-document-detection-body-view1-hr" ng-class="{\'c-document-detection-body-view1-hr-selected\' : vm.tapIndex == 3}"></div><div class="c-document-detection-body-view1-tab" ng-class="{\'c-document-detection-body-view1-tab-selected\' : vm.tapIndex == 3}">{{vm.thirdPartySettings.length > 1 ? \'\u2462\' : \'\u2461\'}} \u53D1\u5E03\u7ED3\u679C</div></div><div class="c-document-detection-body-view2"><div class="c-document-detection-body-view2-1" ng-if="vm.tapIndex == 1"><div class="c-document-detection-body-view2-1-tab"><div ng-class="{\'c-document-detection-body-view2-1-tab-selected\' : !vm.backup}" ng-click="backupFn(false)"><span>\u9ED8\u8BA4\u9875</span><div class="c-document-detection-body-view2-1-tab-hr"></div></div><div ng-class="{\'c-document-detection-body-view2-1-tab-selected\' : vm.backup}" ng-click="backupFn(true)"><span>\u5907\u7528\u9875</span><div class="c-document-detection-body-view2-1-tab-hr"></div></div></div><div class="c-document-detection-body-view2-1-conent"><div class="c-document-detection-body-view2-1-conent-li" ng-repeat="page in vm.pages track by $index" ng-if="page.dpiResult.length>0||page.fontResult.length>0 " ng-init="pageIndex = $index"><!--                            <div class="c-document-detection-body-view2-1-conent-li-title">\u7B2C{{$index+1}}\u9875</div>--><div class="c-document-detection-body-view2-1-conent-li-item"><div class="c-document-detection-body-view2-1-conent-li-item-view" ng-repeat="dpiResult in page.dpiResult"><div class="c-document-detection-body-view2-1-conent-li-item-view-img"><img ng-src="{{dpiResult.img}}" alt=""></div><div class="c-document-detection-body-view2-1-conent-li-item-view-describe"><div class="c-document-detection-body-view2-1-conent-li-item-view-describe-index">{{pageSeq(page)}}</div><div class="c-document-detection-body-view2-1-conent-li-item-view-describe-text">{{dpiResult.name}}\u7CBE\u5EA6\u4E0D\u8DB3\u3010{{dpiResult.dpi | number:2}}\u3011\uFF0C\u671F\u671B\u7CBE\u5EA6:\u3010{{dpiResult.expectDpi}}\u3011</div></div></div><div class="c-document-detection-body-view2-1-conent-li-item-view" ng-repeat="fontResult in page.fontResult"><div class="c-document-detection-body-view2-1-conent-li-item-view-img"><i class="iconfont icon-zitidaxiao-"></i></div><div class="c-document-detection-body-view2-1-conent-li-item-view-describe">{{fontResult.message}}</div></div></div></div><div class="c-document-detection-body-view2-1-conent-2" ng-if="!vm.disqualification && !vm.loading"><img src="content/images/editor-icon2.png" alt="" style="width: 249px"><!--                            <div>\u68C0\u6D4B\u6210\u529F</div>--></div></div></div><div class="c-document-detection-body-view2-2" ng-if="vm.tapIndex == 2"><div class="c-document-detection-body-view2-2-1"><div class="c-document-detection-body-view2-2-1-title">\u8BF7\u9009\u62E9\u60A8\u8981\u53D1\u5E03\u7684\u6E20\u9053\u540D\u79F0\uFF1A</div><div class="c-checkbox-view" ng-click="vm.checkAllFn()"><i class="iconfont icon-dui1" ng-style="{color:vm.checkAll?\'#264DF0\':\'#505760\'}" style="margin-right: 4px"></i> <span>\u5168\u9009</span></div></div><div class="c-document-detection-body-view2-2-2"><div class="c-checkbox-view1" ng-repeat="item in vm.thirdPartySettings" ng-click="vm.checkFn(item)" ng-class="{\'c-checkbox-view1-selected\' : item.selected}">{{item.name}}</div></div></div><div class="c-document-detection-body-view2-3" ng-if="vm.tapIndex == 3"><div class="c-document-detection-body-view2-3-loadding" ng-if="vm.saveLoading"><i class="iconfont icon-jiazai" style="font-size: 30px"></i><div style="margin-top: 20px">\u53D1\u5E03\u4E2D...</div></div><div ng-if="!vm.saveLoading"><div class="c-document-detection-body-view2-3-1" ng-if="vm.releaseData.status == 200"><img src="content/images/editor-icon2.png" alt="" style="width: 249px"><div class="c-document-detection-body-view2-3-1-text" style="margin-top: 20px">\u53D1\u5E03\u6210\u529F</div></div><div class="c-document-detection-body-view2-3-2" ng-if="vm.releaseData.status == 400"><div class="c-document-detection-body-view2-3-2-li" ng-repeat="item in vm.releaseData.message"><div class="c-document-detection-body-view2-3-2-li-title">{{item.name}}</div><div class="c-document-detection-body-view2-3-2-li-success" ng-if="item.success"><i class="iconfont icon-dui1"></i> <span>\u53D1\u5E03\u6210\u529F</span></div><div class="c-document-detection-body-view2-3-2-li-error" ng-if="!item.success"><i class="iconfont icon-guanbi"></i> <span>{{item.reason}}</span></div></div></div><div ng-if="vm.releaseData.status != 400 && vm.releaseData.status != 200">{{vm.releaseData.message}}</div></div></div></div></div></div><div class="c-model-foot c-document-detection-foot"><div class="c-document-detection-foot-text"><span ng-if="vm.tapIndex == 1"><i class="iconfont icon-tishi1" style="color: #89919D"></i>\u5206\u8FA8\u7387\u4E0D\u8DB3\u5C06\u4F1A\u5F71\u54CD\u5370\u5237\u8D28\u91CF\uFF0C\u53EF\u80FD\u4F1A\u5BFC\u81F4\u6A21\u7CCA\uFF1B\u82E5\u4E0D\u8C03\u6574\uFF0C\u5BFC\u81F4\u7684\u5370\u5237\u95EE\u9898\u7CFB\u7EDF\u6982\u4E0D\u8D1F\u8D23\u3002</span></div><div style="width: 280px; text-align: right"><div class="c-document-detection-btn1 c-document-detection-btn3" ng-click="vm.cancel()" ng-if="vm.tapIndex == 1 && vm.disqualification && !vm.loading">{{vm.source == \'list\' ? \'\u8FD4\u56DE\' : \'\u524D\u5F80\u8C03\u6574\'}}</div><div class="c-document-detection-btn1 c-document-detection-btn2" ng-click="save1()" ng-if="vm.tapIndex == 1">\u7EE7\u7EED\u53D1\u5E03</div><div class="c-document-detection-btn1" ng-click="cancel2()" ng-if="vm.tapIndex == 2">\u8FD4\u56DE</div><div class="c-document-detection-btn1 c-document-detection-btn2" ng-click="save2()" ng-if="vm.tapIndex == 2">\u7EE7\u7EED\u53D1\u5E03</div><div class="c-document-detection-btn1" ng-click="cancel2()" ng-if="vm.tapIndex == 3 && (vm.releaseData.status != 200 || !vm.releaseData)">\u8FD4\u56DE</div><div class="c-document-detection-btn1 c-document-detection-btn2" ng-click="save3()" ng-if="vm.tapIndex == 3 && vm.releaseData.status == 200">\u8FD4\u56DE</div></div></div></div><!--\u6587\u6863\u68C0\u6D4B--><div class="c-model" data-html2canvas-ignore ng-if="!vm.documentDetection.pass"><div class="c-model-head"><div class="c-model-head-title">\u6587\u6863\u68C0\u6D4B</div><i class="iconfont icon-closeicon1" ng-click="vm.cancel()"></i></div><div class="c-model-body"><div class="c-model-body-view"><div class="c-documentDetection-tab"><div ng-class="{\'c-documentDetection-tab-select\' : vm.documentDetectionTab==\'text\'}" ng-click="vm.documentDetectionTab=\'text\'" ng-if="vm.documentDetection.isText">\u6587\u5B57\u5931\u6548\u68C0\u6D4B</div><div ng-class="{\'c-documentDetection-tab-select\' : vm.documentDetectionTab==\'repetition\'}" ng-click="vm.documentDetectionTab=\'repetition\'" ng-if="vm.documentDetection.isRepetition">\u5143\u7D20\u91CD\u53E0\u68C0\u6D4B</div></div><div class="dialog-content hover-scrollbar" style="max-height: 800px; overflow: auto" ng-if="vm.documentDetectionTab==\'text\'"><div><i class="iconfont icon-waring mad-right-6" style="color: #FF6E33"></i>\u68C0\u6D4B\u51FA\u4EE5\u4E0B\u9875\u9762\u6587\u5B57\u4F7F\u7528\u7684\u5B57\u4F53\u5DF2\u5931\u6548\uFF0C\u4F5C\u54C1\u4FDD\u5B58\u4E2D\u65AD\uFF0C\u8BF7\u524D\u5F80\u8C03\u6574\uFF0C\u5982\u679C\u65E0\u6CD5\u4FEE\u6539\u8BF7\u8054\u7CFB\u5BA2\u670D\u3002</div><div class="c-documentDetection-view mar-top-10" ng-repeat="page in vm.documentDetection.pages" ng-if="page.texts && page.texts.length>0"><div class="c-documentDetection-view-title">\u7B2C{{page.pageIndex}}\u9875</div><div class="c-documentDetection-view-1"><div class="c-documentDetection-view-1-li-text" ng-repeat="item in page.texts">{{item.text}}</div></div></div></div><div class="dialog-content hover-scrollbar" style="max-height: 800px; overflow: auto" ng-if="vm.documentDetectionTab==\'repetition\'"><div><i class="iconfont icon-waring mad-right-6" style="color: #FF6E33"></i>\u68C0\u6D4B\u51FA\u4EE5\u4E0B\u9875\u9762\u5B58\u5728\u5143\u7D20\u91CD\u53E0\uFF0C\u4F5C\u54C1\u4FDD\u5B58\u4E2D\u65AD\uFF0C\u8BF7\u524D\u5F80\u8C03\u6574\uFF0C\u5982\u679C\u65E0\u6CD5\u4FEE\u6539\u8BF7\u8054\u7CFB\u5BA2\u670D\u3002</div><div class="c-documentDetection-view mar-top-10" ng-repeat="page in vm.documentDetection.pages" ng-if="page.repetitions && page.repetitions.length>0"><div class="c-documentDetection-view-title">\u7B2C{{page.pageIndex}}\u9875</div><div class="c-documentDetection-view-1"><div class="c-documentDetection-view-1-li" ng-repeat="level in page.repetitions"><div class="c-documentDetection-view-1-li-fl"><img ng-if="level.imagebox && !level.imagebox.image" src="content/images/icons/photo-icon.svg"> <img ng-if="level.imagebox && level.imagebox.image && level.imagebox.image.resource && level.imagebox.image.resource.identifier" ng-src="{{level.imagebox.image.resource.identifier + vm.pageImageView}}"> <img ng-if="level.imageart && level.imageart.resource && level.imageart.resource.identifier" ng-src="{{level.imageart.resource.identifier + vm.pageImageView}}"> <i class="iconfont icon-zitidaxiao-" ng-if="level.textbox || level.textdocument" style="color: #fff"></i></div><div class="c-documentDetection-view-1-li-fr">{{levelInfo(level)}}</div></div></div></div></div></div></div><div class="c-modal-foot"><button class="c-modal-btn c-modal-btn-hide" ng-click="vm.cancel()">\u53D6\u6D88</button> <button class="c-modal-btn c-modal-btn-submint" style="margin-left: 30px" ng-click="vm.cancel()">\u524D\u5F80\u8C03\u6574</button></div></div><style>.modal-content {\n        width: 900px !important;\n        margin: 100px auto;\n    }</style>');
$templateCache.put('app/entities/page/modal/model-select.html','<div class="c-model" ng-if="vm.modelType == \'TWO\'"><div class="c-model-head"><div class="c-model-head-title">\u9009\u62E9\u6A21\u578B</div><div class="c-model-head-title-input"><span class="iconfont icon-sousuo"></span> <input type="text" ng-model="vm.search" placeholder="\u5173\u952E\u8BCD\u641C\u7D22" ng-keypress="vm.selectTable($event)"></div></div><div class="c-model-body"><div class="c-model-body-view scrollbar-main"><div class="model-item-3d" ng-if="vm.modelType ==\'THREE\'" ng-repeat="item in vm.data track by item.id" ng-click="vm.check(item)" ng-style="{\'background\':item.selected ? \'#ebeffe\' :\'\'}"><div class="item-img"><img ng-if="domains.domain" ng-src="{{domains.domain + item.modelPic}}" alt=""></div><div class="item-name">{{item.name}}</div><div class="item-selected"><span class="iconfont" ng-class="{\'icon-xuanzhong1 themecolor\':item.selected,\'icon-xuanzhong\':!item.selected}"></span></div></div><div ng-if="vm.modelType ==\'THREE\' && vm.data.length == 0" style="width: 100%;height: 300px;display: flex;align-items: center;flex-direction: column;justify-content: center"><img src="content/images/template_null.png" alt="" style="width: 150px;margin-bottom: 10px"><div>\u6682\u65E0\u6570\u636E</div></div><table class="jh-table table table-striped"><thead class="table-thead" style="background: rgba(38,77,240,0.06)"><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th><span>\u9009\u62E9</span></th><th><span>\u6A21\u578B\u540D\u79F0</span></th><th><span>\u6A21\u578B</span></th><th><span>\u6A21\u578B\u5C3A\u5BF8</span></th><th><span>\u5B9A\u5236\u533A\u57DF</span></th></tr></thead><tbody class="table-tbody"><tr ng-repeat="item in vm.data track by item.id" ng-if="vm.data.length > 0" ng-click="vm.check(item)"><td class="vertical-middle"><span class="iconfont" ng-class="{\'icon-xuanzhong1 themecolor\':item.selected,\'icon-xuanzhong\':!item.selected}"></span></td><td class="vertical-middle">{{item.name}}</td><td class="vertical-middle"><div style="width: 70px; height: 70px; line-height: 70px; text-align: center; margin: 0 auto"><img ng-if="domains.domain" ng-src="{{domains.domain + item.modelPic}}" alt="" style="max-width: 70px; max-height: 70px"></div></td><td class="vertical-middle"><span>{{item.gWidth}}*{{item.gHeight}}mm</span></td><td class="vertical-middle"><span class="input-span">{{item.x}}</span> <span class="input-span">{{item.y}}</span> <span class="input-span">{{item.width}}</span> <span class="input-span">{{item.height}}</span></td></tr><tr ng-if="vm.data.length == 0"><td colspan="5" style="height: 50px; text-align: center; color: #999 !important; font-size: 16px">\u6682\u65E0\u6A21\u578B...</td></tr></tbody></table></div></div><div class="c-model-foot" style="text-align: center"><button type="button" class="btn btn-info btn-max" ng-click="vm.save()" ng-if="vm.type != \'look\'">\u786E\u5B9A</button> <button type="button" class="btn btn-cancel btn-max" ng-click="vm.cancel()">\u53D6\u6D88</button></div></div><div class="c-model c-model-threeModel" ng-if="vm.modelType == \'THREE\'"><div class="c-model-head"><div class="c-model-head-title">\u9009\u62E9\u6A21\u578B</div><div class="c-model-head-title-input"><span class="iconfont icon-sousuo"></span> <input type="text" ng-model="vm.search" placeholder="\u5173\u952E\u8BCD\u641C\u7D22" ng-keypress="vm.selectTable($event)"></div></div><div class="c-model-body scrollbar-main" style="height: 440px;overflow: auto"><div class="model-item-3d" ng-if="vm.modelType ==\'THREE\'" ng-repeat="item in vm.data track by item.id" ng-click="vm.check(item)" ng-style="{\'background\':item.selected ? \'#ebeffe\' :\'\'}"><div class="item-img"><img ng-if="domains.domain" ng-src="{{domains.domain + item.modelPic}}" alt=""></div><div class="item-name">{{item.name}}</div><div class="item-selected"><span class="iconfont" ng-class="{\'icon-xuanzhong1 themecolor\':item.selected,\'icon-xuanzhong\':!item.selected}"></span></div></div><div ng-if="vm.modelType ==\'THREE\' && vm.data.length == 0" style="width: 100%;height: 300px;display: flex;align-items: center;flex-direction: column;justify-content: center"><img src="content/images/template_null.png" alt="" style="width: 150px;margin-bottom: 10px"><div>\u6682\u65E0\u6570\u636E</div></div></div><div class="c-model-foot" style="text-align: center"><button type="button" class="btn btn-info btn-max" ng-click="vm.save()" ng-if="vm.type != \'look\'">\u786E\u5B9A</button> <button type="button" class="btn btn-cancel btn-max" ng-click="vm.cancel()">\u53D6\u6D88</button></div></div><style>.modal-content {\n        width: 100%;\n        margin: 100px auto;\n    }\n    .c-model-threeModel{\n        width: 640px;\n        background: #FFFFFF;\n        box-shadow: 0px 4px 12px 0px rgba(34,37,41,0.25);\n        border-radius: 4px;\n        margin: 100px auto;\n    }</style>');
$templateCache.put('app/entities/page/modal/month-index-set.html','<div class="c-model"><div class="c-model-head"><div class="c-model-head-title">\u8BF7\u8BBE\u7F6E\u6708\u4EFD\u987A\u5E8F</div><i class="iconfont icon-closeicon1" ng-click="vm.clear()"></i></div><div class="c-model-body"><div class="c-model-body-view"><div class="c-form" style="margin-bottom: 0"><label class="c-form-label">\u7B2C\u51E0\u4E2A\u6708\uFF1A</label><div class="c-form-div"><input type="number" class="c-input1" style="height: 40px" ng-model="vm.monthIndex"></div></div></div></div><div class="c-model-foot"><button type="button" class="btn btn-cancel" ng-click="vm.clear()">\u53D6\u6D88</button> <button type="button" class="btn btn-info" ng-click="vm.save()">\u786E\u5B9A</button></div></div><style>.c-form{width: 100%;}\n    .c-form .c-form-label{\n        width: 70px;\n        padding: 0;\n        height: 40px;\n        line-height: 40px;\n    }\n    .c-form .c-form-div{\n        position: relative;\n        margin-left: 70px;\n        width: auto;\n        min-height: 40px;\n    }</style>');
$templateCache.put('app/entities/page/modal/original-agreement.html','<div class="original-agreement"><div class="original-close" ng-click="close()"><i class="iconfont icon-closeicon1" style="color: #505760; font-size: 24px"></i></div><div class="original-head">\u539F\u521B\u4F5C\u54C1\u8BF4\u660E</div><div class="original-title" style="margin-bottom: 16px">\u672C\u4EBA\u5BF9\u5728\u6B64\u5E73\u53F0\u521B\u4F5C\u7684\u4F5C\u54C1\uFF08\u4EE5\u4E0B\u7B80\u79F0\u201C\u4F5C\u54C1\u201D\uFF09\uFF0C\u5BF9\u5176\u4EAB\u6709\u5B8C\u6574\u7684\u8457\u4F5C\u6743\u3002</div><div class="original-title" style="margin-bottom: 8px">\u5728\u6B64\u58F0\u660E\uFF1A</div><div class="info">1.\u4F5C\u54C1\u4E3A\u672C\u4EBA\u72EC\u7ACB\u521B\u4F5C\u5B8C\u6210\uFF0C\u5E76\u975E\u6B6A\u66F2\u3001\u7BE1\u6539\u3001\u6284\u88AD\u3001\u527D\u7A83\u3001\u8F6C\u53D1\u3001\u5927\u91CF\u5F15\u7528\u4ED6\u4EBA\u521B\u4F5C\u800C\u4EA7\u751F\u7684\u4F5C\u54C1\u3002\u5982\u6709\u4F7F\u7528\u4ED6\u4EBA\u4F5C\u54C1\u6216\u5176\u4ED6\u7B2C\u4E09\u65B9\u53EF\u80FD\u4EAB\u6709\u6743\u5229\u7684\u5185\u5BB9\uFF0C\u5747\u5DF2\u53D6\u5F97\u76F8\u5173\u6743\u5229\u4EBA\u7684\u6388\u6743\u3002\u672C\u4EBA\u5BF9\u4F5C\u54C1\u4F5C\u51FA\u7684\u4EFB\u4F55\u6388\u6743\u65E0\u9700\u53D6\u5F97\u4EFB\u4F55\u7B2C\u4E09\u65B9\u6743\u5229\u4EBA\u7684\u8FDB\u4E00\u6B65\u6388\u6743\u6216\u540C\u610F\u3002</div><div class="info"><p>2.\u4F5C\u54C1\u4E0D\u5305\u542B\uFF1A</p><p>(1)\u8FDD\u53CD\u56FD\u5BB6\u6CD5\u5F8B\u3001\u5371\u5BB3\u56FD\u5BB6\u5B89\u5168\u7EDF\u4E00\u3001\u793E\u4F1A\u7A33\u5B9A\u3001\u516C\u5E8F\u826F\u4FD7\u3001\u793E\u4F1A\u516C\u5FB7\u4EE5\u53CA\u4FAE\u8FB1\u3001\u8BFD\u8C24\u3001\u6DEB\u79FD\u6216\u542B\u6709\u4EFB\u4F55\u6027\u6216\u6027\u6697\u793A\u7684\u3001\u66B4\u529B\u7684\u5185\u5BB9\uFF1B</p><p>(2)\u4FB5\u5BB3\u4ED6\u4EBA\u540D\u8A89\u6743\u3001\u8096\u50CF\u6743\u3001\u59D3\u540D\u6743\u3001\u540D\u79F0\u6743\u3001\u5176\u4ED6\u77E5\u8BC6\u4EA7\u6743\u3001\u5546\u4E1A\u79D8\u5BC6\u7B49\u5408\u6CD5\u6743\u76CA\u7684\u5185\u5BB9\uFF1B</p><p>(3)\u6D89\u53CA\u4ED6\u4EBA\u9690\u79C1\u3001\u4E2A\u4EBA\u4FE1\u606F\u6216\u8D44\u6599\u7684\uFF1B</p><p>(4)\u9A9A\u6270\u3001\u5E7F\u544A\u4FE1\u606F\u53CA\u5783\u573E\u4FE1\u606F\uFF1B</p><p>(5)\u5176\u4ED6\u8FDD\u53CD\u6CD5\u5F8B\u6CD5\u89C4\u3001\u653F\u7B56\u53CA\u516C\u5E8F\u826F\u4FD7\u3001\u793E\u4F1A\u516C\u5FB7\u6216\u5E72\u6270\u89C6\u9891\u6B63\u5E38\u8FD0\u8425\u548C\u4FB5\u72AF\u5176\u4ED6\u7528\u6237\u6216\u7B2C\u4E09\u65B9\u5408\u6CD5\u6743\u76CA\u5185\u5BB9\u7684\u4FE1\u606F\u3002</p></div><div class="info" style="margin-bottom: 32px">3.\u5982\u4F5C\u54C1\u6709\u4FB5\u5BB3\u4ED6\u4EBA\u5408\u6CD5\u6743\u76CA\u6216\u8FDD\u53CD\u672C\u58F0\u660E\u7684\u95EE\u9898\uFF0C\u672C\u4EBA\u613F\u610F\u627F\u62C5\u5168\u90E8\u6CD5\u5F8B\u548C\u8D54\u507F\u8D23\u4EFB\u3002</div><div class="btns"><div class="btn-cancel" ng-click="close()">\u4E0D\u540C\u610F</div><div class="btn-agree" ng-click="submitAgree()">\u540C\u610F</div></div></div><style>.original-agreement{\n        background: #ffffff;\n        margin: 0 auto;\n        width: 800px;\n        border-radius: 8px;\n        padding: 32px;\n        font-size: 14px;\n        color: #505760;\n        position: relative;\n        line-height: 20px;\n    }\n    .original-agreement .original-close{\n        position: absolute;\n        cursor: pointer;\n        top: 16px;\n        right: 24px;\n        z-index: 5;\n    }\n    .original-agreement .original-head{\n        text-align: center;\n        font-size: 18px;\n        font-weight: bold;\n        color: #222529;\n        line-height: 25px;\n        margin-bottom: 32px;\n    }\n    .original-agreement .original-title{\n        font-weight: 500;\n        color: #222529;\n        font-weight: bold;\n    }\n    .original-agreement .info{\n        margin-bottom: 8px;\n    }\n    .original-agreement .info p{\n        margin: 0;\n    }\n    .original-agreement .btns{\n        display: flex;\n        justify-content: center;\n\n    }\n    .original-agreement .btn-cancel{\n        border: 0;\n        cursor: pointer;\n        width: 96px;\n        line-height: 40px;\n        border-radius: 4px;\n        text-align: center;\n        font-size: 14px;\n        color: #505760;\n        background: #F5F7FA;\n        margin-right: 16px;\n    }\n    .original-agreement .btn-agree{\n        cursor: pointer;\n        background: #264DF0;\n        width: 96px;\n        text-align: center;\n        border-radius: 4px;\n        font-size: 14px;\n        color: #FFFFFF;\n        line-height: 40px;\n    }\n    .original-agreement .btn-agree:hover{\n        background: rgba(58, 124, 255, 0.85);\n    }</style>');
$templateCache.put('app/entities/page/modal/page-standard.html','<div class="c-model" ng-if="!vm.hideModal"><div class="c-model-head"><div class="c-model-head-title">\u6A21\u677F{{vm.title()}}</div><i class="iconfont icon-closeicon1" ng-click="vm.cancel()"></i></div><div class="c-model-body"><div class="c-model-body-view"><div class="c-form"><label class="c-form-label" style="width: 70px">\u6A21\u677F\u540D\u79F0\uFF1A</label><div class="c-form-div lh35" style="margin-left: 70px;width:auto"><input type="text" class="c-input1" ng-model="vm.data.name"></div></div><div class="c-form" ng-if="vm.itemType == \'add\' || vm.itemType == \'edit\'"><label class="c-form-label" style="width: 70px">\u6A21\u677F\u7C7B\u578B\uFF1A</label><div class="c-form-div lh35" style="margin-left: 70px;width:auto"><input type="text" class="c-input1" disabled="disabled" value="{{vm.data.modelType == \'TWO\' ? \'\u6A21\u578B\u6A21\u677F\' : (vm.data.productTemplateId ? \'\u6807\u51C6\u6A21\u677F\' : \'\u81EA\u5B9A\u4E49\u6A21\u677F\')}}"></div></div><div class="c-form" ng-if="vm.itemType == \'add\' || vm.itemType == \'edit\'"><label class="c-form-label" style="width: 70px">\u6A21\u677F\u5206\u7C7B\uFF1A</label><div class="c-form-div lh35" style="margin-left: 70px;width:auto"><div ng-if="!vm.type||vm.data.self==\'self\'"><modele-select ng-model="vm.catalogId" ng-change="changeCatalogId()" label-key="name" value-key="id" options="vm.catalogs"></modele-select></div><span ng-if="vm.type&&vm.data.self!=\'self\'">{{vm.data.catalog.name}}</span></div></div><div class="c-form" ng-if="vm.data.productType == \'BOOK\' && vm.itemType == \'edit\'"><label class="c-form-label" style="width: 70px">\u5185\u9875\u9996\u9875\uFF1A</label><div class="c-form-div" style="margin-left: 70px;width:auto; display: flex"><div style="display: flex" ng-click="vm.data.document.config.innerOffset = 0"><div ng-style="{\'color\':vm.data.document.config.innerOffset == 0 ? \'#264DF0\' : \'#505760\'}"><span class="iconfont icon-xuanzhong" ng-show="vm.data.document.config.innerOffset != 0"></span> <span class="iconfont icon-xuanzhong1" ng-show="vm.data.document.config.innerOffset == 0"></span> \u5DE6\u4FA7</div><img style="width: 80px;margin-left: 10px" src="content/images/first-inside-page.png" alt=""></div><div style="margin-left: 40px; display: flex" ng-click="vm.data.document.config.innerOffset = 1"><div ng-style="{\'color\':vm.data.document.config.innerOffset == 1 ? \'#264DF0\' : \'#505760\'}"><span class="iconfont icon-xuanzhong" ng-show="vm.data.document.config.innerOffset != 1"></span> <span class="iconfont icon-xuanzhong1" ng-show="vm.data.document.config.innerOffset == 1"></span> <span>\u53F3\u4FA7</span></div><img style="width: 80px;margin-left: 10px" src="content/images/second-inside-page.png" alt=""></div></div></div><div class="c-form" ng-if="vm.data.productType == \'CALENDAR\' && vm.data.document.config.dynamic"><label class="c-form-label" style="width: 70px">\u5F00\u59CB\u6708\u4EFD\uFF1A</label><div class="c-form-div lh35" style="margin-left: 70px;width:auto; display: flex;position: relative"><input id="startTime" style="height: 40px" type="text" class="c-input1" name="month" uib-datepicker-popup="yyyy-MM" datepicker-options="options" ng-model="vm.month" is-open="vm.isMonth" clear-text="\u6E05\u7A7A" close-text="\u5173\u95ED" current-text="\u672C\u6708" ng-click="vm.isMonth = true" placeholder="\u5F00\u59CB\u6708\u4EFD"> <i style="position:absolute;top: 50%;transform: translate(0,-50%);right:16px;font-size: 16px;color: #222529" class="iconfont icon-down"></i></div></div><div ng-if="vm.data.productType == \'THING\' && vm.data.cover && vm.itemType == \'edit\'"><div class="c-form"><label class="c-form-label" style="width: 70px">\u9884\u89C8\u56FE\uFF1A</label><div class="c-form-div lh35" style="margin-left: 70px;width:auto"><img alt="\u56FE\u7247\u7F3A\u5931" ng-if="vm.url" ng-src="{{vm.url + vm.data.cover}}" style="max-width: 100px; max-height: 100px"></div></div><div class="c-form"><label class="c-form-label" style="width: 70px">\u6A21\u677F\u66FF\u6362\uFF1A</label><div class="c-form-div align-items-center" style="margin-left: 70px;width:auto"><input type="checkbox" class="checkOrIf" name="enabled" ng-model="vm.data.replace"><!--                        <modele-select--><!--                            ng-model="vm.data.replace"--><!--                            label-key="value"--><!--                            value-key="id"--><!--                            options="vm.replaces">--><!--                        </modele-select>--></div></div></div><div ng-if="vm.data.productType == \'BOOK\' || vm.data.productType == \'CALENDAR\'"><div class="c-form" ng-if="vm.itemType == \'add\' || vm.itemType == \'edit\'"><label class="c-form-label" style="width: 70px">\u6A21\u677F\u66FF\u6362\uFF1A</label><div class="c-form-div align-items-center" style="margin-left: 70px;width:auto"><input type="checkbox" class="checkOrIf" name="enabled" ng-model="vm.data.replace"><!--                        <modele-select--><!--                            ng-model="vm.data.replace"--><!--                            label-key="value"--><!--                            value-key="id"--><!--                            options="vm.replaces">--><!--                        </modele-select>--></div></div></div><div ng-if="vm.data.productType == \'BOOK\' || (vm.data.productType == \'CALENDAR\'&&!vm.data.document.config.dynamic)"><div class="c-form" ng-if="vm.itemType == \'add\' || vm.itemType == \'edit\'"><label class="c-form-label" style="width: 70px">\u52A0\u9875\uFF1A</label><div class="c-form-div lh35" style="margin-left: 70px;width:auto"><modele-select ng-model="vm.data.addpage" label-key="value" value-key="id" options="vm.addpages"></modele-select></div></div><div ng-if="vm.data.addpage && (vm.itemType == \'add\' || vm.itemType == \'edit\')"><div class="c-form"><label class="c-form-label" style="width: 70px">\u9875\u6570\u8303\u56F4\uFF1A</label><div class="c-form-div lh35" style="margin-left: 70px;width:auto"><input type="text" class="c-input1" ng-model="vm.data.minpage" style="width: 50px; margin-right: 10px"> \u81F3 <input type="text" class="c-input1" ng-model="vm.data.maxpage" style="width: 50px; margin-left: 10px"> \u9875</div></div><div class="c-form"><label class="c-form-label" style="width: 70px">\u52A0\u9875\u5355\u4F4D\uFF1A</label><div class="c-form-div lh35" style="margin-left: 70px;width:auto"><input type="text" class="c-input1" ng-model="vm.data.addunit" style="width: 80px; margin-right: 10px">\u9875</div></div></div></div></div></div><div class="c-model-foot" style="text-align: center"><button type="button" class="btn btn-cancel btn-max" ng-click="vm.cancel()">\u53D6\u6D88</button> <button type="button" class="btn btn-info btn-max" style="margin-left: 16px" ng-click="vm.save()" ng-if="vm.itemType == \'add\' || vm.itemType == \'copy\'">\u786E\u5B9A</button> <button type="button" class="btn btn-info btn-max" style="margin-left: 16px" ng-click="vm.save()" ng-if="vm.itemType == \'edit\'">\u4FDD\u5B58</button><!-- <button type="button" class="btn btn-info btn-max" style="margin-left: 16px;" ng-click="vm.save(true)" ng-if="vm.itemType == \'edit\'">\u4FDD\u5B58\u5E76\u7F16\u8F91</button> --></div></div><style>.modal-dialog {\n        width: 680px;\n    }\n    .c-form .c-form-div input.c-input1{\n        height: 40px;\n    }</style>');
$templateCache.put('app/entities/page/modal/part-add.html','<div class="c-model"><div class="c-model-head"><div class="c-model-head-title">\u6DFB\u52A0\u90E8\u4EF6</div><i class="iconfont icon-closeicon1" ng-click="vm.cancel()"></i></div><div class="c-model-body"><div class="c-model-body-view"><div class="step-body"><div class="c-form"><label class="c-form-label">\u90E8\u4EF6\u540D\u79F0\uFF1A</label><div class="c-form-div c-add-part-view" ng-if="vm.data.productType == \'BOOK\'"><div class="c-add-part-view-name">{{vm.data.part.name}}</div><div class="c-add-part-view-list"><div class="c-add-part-view-list-li" ng-repeat="item in vm.parts" ng-if="!item.exist" ng-click="partCb(item)" ng-class="{\'c-add-part-view-list-li-selected\' : vm.data.part.id == item.id}">{{item.name}}</div><div class="c-add-part-view-list-li-hr"></div><div class="c-add-part-view-list-li-btn" ng-click="addPart()"><i class="iconfont icon-jia1"></i> <span>\u6DFB\u52A0</span></div></div></div><div class="c-form-div" ng-if="vm.data.productType != \'BOOK\'"><input type="text" class="c-input1" style="height: 40px" ng-model="vm.data.part.name" maxlength="30" ng-change="partNameChange()" placeholder="\u8BF7\u8F93\u5165\u90E8\u4EF6\u540D\u79F0"></div></div><div class="c-form"><label class="c-form-label">\u753B\u5E03\u5C3A\u5BF8\uFF1A</label><div class="c-form-div" style="display: flex; justify-content: space-between"><div class="c-editor-form-view1 c-editor-form-view1-1-border"><div class="c-editor-form-view1-1"><span>\u5BBD</span> <input type="text" ng-model="vm.data.part.mediabox.width" ng-readonly="vm.data.part.id == \'P1\'"></div><div class="c-editor-form-view1-1"><span>\u9AD8</span> <input type="text" ng-model="vm.data.part.mediabox.height" ng-readonly="vm.data.part.id == \'P1\'"></div><div class="timesSign" ng-class="{\'timesSign-select\' : vm.equalRatio}" ng-click="vm.equalRatio = !vm.equalRatio"><i class="iconfont icon-lianjie-connect1"></i></div></div><div class="c-editor-form-view1" style="width: 134px; min-width: 134px; margin-left: 10px"><div class="c-editor-form-view1-1"><span>\u5355\u4F4D</span><select ng-model="vm.data.unit1" ng-options="item.id as item.name for item in vm.units" ng-change="unitConversion(vm.data.unit1)"></select></div></div></div></div><div class="c-form"><label class="c-form-label">\u51FA\u8840\u5C3A\u5BF8\uFF1A</label><div class="c-form-div" style="display: flex; justify-content: space-between"><div class="c-editor-form-view1 c-editor-form-view1-1-border"><div class="c-editor-form-view1-1"><span>\u4E0A</span> <input type="text" ng-model="vm.data.part.bleed.top"></div><div class="c-editor-form-view1-1"><span>\u4E0B</span> <input type="text" ng-model="vm.data.part.bleed.bottom"></div><div class="c-editor-form-view1-1"><span>\u5DE6</span> <input type="text" ng-model="vm.data.part.bleed.left"></div><div class="c-editor-form-view1-1"><span>\u53F3</span> <input type="text" ng-model="vm.data.part.bleed.right"></div></div><div class="c-editor-form-view1" style="width: 134px; min-width: 134px; margin-left: 10px"><div class="c-editor-form-view1-1"><span>\u5355\u4F4D</span><select ng-model="vm.data.unit1" ng-options="item.id as item.name for item in vm.units" ng-change="unitConversion(vm.data.unit1)"></select></div></div></div></div><div ng-if="vm.data.modelType == \'THREE\'"><div class="c-form" style="margin-bottom: 10px" ng-if="vm.data.modelName&&vm.data.modelPic"><label class="c-form-label">\u5173\u8054\u6A21\u578B\uFF1A</label><div class="c-form-div"><div class="c-table"><table><thead><tr><th>\u6A21\u578B\u540D\u79F0</th><th>\u6A21\u578B</th></tr></thead><tbody><tr><td>{{vm.data.modelName}}</td><td><img ng-src="{{vm.url + vm.data.modelPic}}" height="55"></td></tr></tbody></table></div></div></div><div class="c-form" style="margin-bottom: 10px"><label class="c-form-label">\u5173\u8054\u6A21\u578B\u9875\uFF1A</label><div class="c-form-div"><select class="c-select1" style="height: 40px" ng-model="vm.materialName" ng-options="item.materialName as item.materialName for item in vm.modelData"><option value="" class="" selected="selected">\u8BF7\u5173\u8054\u6750\u8D28</option></select></div></div></div><div class="c-form" ng-if="vm.data.modelType == \'TWO\'"><label class="c-form-label">\u6A21\u578B\uFF1A</label><div class="c-form-div" style="display: flex"><div class="upload-form"><div class="upload-input" ng-if="!vm.data.mould" ng-click="vm.selectModel(vm.data)"><div class="iconfont icon-hao"></div><div>\u8BF7\u9009\u62E9</div></div><div ng-if="vm.data.mould" class="upload-img"><img ng-src="{{vm.data.mould.modelPic}}" alt=""><!--                            <i class="iconfont icon-guanbi1" ng-click="removeMould($event)"></i>--></div></div><div style="display: flex; align-items: flex-end; height: 96px; margin-left: 16px; cursor: pointer" ng-click="vm.selectModelEdit(vm.data)" ng-if="vm.data.mould"><i class="iconfont icon-bianji"></i> <span style="line-height: 21px; margin-left: 5px">\u4FEE\u6539</span></div></div></div></div></div></div><div class="c-model-foot"><button type="button" class="btn btn-cancel" ng-click="vm.cancel()">\u53D6\u6D88</button> <button type="button" class="btn btn-info" ng-click="vm.save()">\u786E\u5B9A</button></div></div><div class="c-add-part-view1-model" ng-if="vm.isPart"></div><div class="c-add-part-view1" ng-if="vm.isPart"><div class="c-add-part-view1-title">\u6DFB\u52A0\u90E8\u4EF6\u540D</div><div class="c-add-part-view1-body"><input type="text" ng-model="vm.part" maxlength="30"></div><div class="c-add-part-view1-foot"><button type="button" class="btn btn-cancel btn-max" ng-click="vm.isPart = false;">\u53D6\u6D88</button> <button type="button" class="btn btn-info btn-max" ng-click="partBlur()">\u786E\u5B9A</button></div></div><style>.step-body{\n        margin-top: 10px;\n    }\n    .step-body-1-view-content{\n        display: flex;\n        flex-wrap: wrap;\n        width: auto !important;\n    }\n    .step-body-1-view-content-li{\n        padding: 0 15px;\n        height: 35px;\n        border: 1px solid #ddd;\n        color: #333;\n        border-radius: 3px;\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        background: #fff;\n        margin: 0 10px 10px 0;\n        cursor: pointer;\n    }\n    .step-body-1-view-content-li:hover{\n        color: #264DF0;\n    }\n    .step-body-1-view-content-li-select{\n        background: #264DF0;\n        color: #fff !important;\n        border: 1px solid #264DF0;\n    }\n    .step-body-1-view-content-li-not{\n        background: #f3f3f3;\n        color: #0A0A0A !important;\n        border: 1px solid #f3f3f3;\n    }\n    .c-form .c-form-label{\n        width: 70px;\n        padding: 0;\n        height: 40px;\n        line-height: 40px;\n    }\n    .c-form .c-form-div{\n        position: relative;\n        margin-left: 70px;\n        width: auto;\n        min-height: 40px;\n    }\n    .timesSign-select{\n        color: #E1A03A;\n    }</style>');
$templateCache.put('app/entities/page/modal/part-edit.html','<div class="c-model" id="c-model"><div class="c-model-head"><div class="c-model-head-title">\u7F16\u8F91\u90E8\u4EF6</div><i class="iconfont icon-closeicon1" ng-click="vm.cancel()"></i></div><div class="c-model-body" id="c-model-body"><div class="c-model-body-view" id="c-model-body-view"><div class="c-form"><label class="c-form-label">\u90E8\u4EF6\u540D\u79F0\uFF1A</label><div class="c-form-div"><input type="text" class="c-input1" ng-model="vm.data.part.name" maxlength="30" style="height: 40px" ng-disabled="!(vm.data.part.custom || vm.data.productType == \'THING\')" placeholder="\u8BF7\u8F93\u5165\u90E8\u4EF6\u540D\u79F0"></div></div><div class="c-form"><label class="c-form-label">\u753B\u5E03\u5C3A\u5BF8\uFF1A</label><div class="c-form-div" style="display: flex; justify-content: space-between"><div class="c-editor-form-view1 c-editor-form-view1-1-border"><div class="c-editor-form-view1-1"><span>\u5BBD</span> <input type="text" ng-model="vm.data.part.mediabox.width" ng-readonly="vm.data.part.id == \'P1\'" ng-change="updateMediabox()"></div><div class="c-editor-form-view1-1"><span>\u9AD8</span> <input type="text" ng-model="vm.data.part.mediabox.height" ng-readonly="vm.data.part.id == \'P1\'" ng-change="updateMediabox()"></div><div class="timesSign" ng-class="{\'timesSign-select\' : vm.equalRatio}" ng-click="vm.equalRatio = !vm.equalRatio"><i class="iconfont icon-lianjie-connect1"></i></div></div><div class="c-editor-form-view1" style="width: 134px; min-width: 134px; margin-left: 10px"><div class="c-editor-form-view1-1"><span>\u5355\u4F4D</span><select ng-model="vm.data.unit1" ng-options="item.id as item.name for item in vm.units" ng-change="unitConversion(vm.data.unit1)"></select></div></div></div></div><div class="c-form"><label class="c-form-label">\u51FA\u8840\u5C3A\u5BF8\uFF1A</label><div class="c-form-div" style="display: flex; justify-content: space-between"><div class="c-editor-form-view1 c-editor-form-view1-1-border"><div class="c-editor-form-view1-1"><span>\u4E0A</span> <input type="text" ng-model="vm.data.part.bleed.top" ng-readonly="vm.data.part.id == \'P1\'" ng-change="updateMediabox()"></div><div class="c-editor-form-view1-1"><span>\u4E0B</span> <input type="text" ng-model="vm.data.part.bleed.bottom" ng-readonly="vm.data.part.id == \'P1\'" ng-change="updateMediabox()"></div><div class="c-editor-form-view1-1"><span>\u5DE6</span> <input type="text" ng-model="vm.data.part.bleed.left" ng-readonly="vm.data.part.id == \'P1\'" ng-change="updateMediabox()"></div><div class="c-editor-form-view1-1"><span>\u53F3</span> <input type="text" ng-model="vm.data.part.bleed.right" ng-readonly="vm.data.part.id == \'P1\'" ng-change="updateMediabox()"></div></div><div class="c-editor-form-view1" style="width: 134px; min-width: 134px; margin-left: 10px"><div class="c-editor-form-view1-1"><span>\u5355\u4F4D</span><select ng-model="vm.data.unit1" ng-options="item.id as item.name for item in vm.units" ng-change="unitConversion(vm.data.unit1)"></select></div></div></div></div><div class="c-form"><label class="c-form-label">\u7F16\u8F91\u533A\u57DF\uFF1A</label><div class="c-form-div"><div style="display: flex; justify-content: space-between; width: 100%;position: relative; margin-bottom: 10px" ng-repeat="editbox in vm.data.part.editboxes.editbox track by $index"><div class="c-editor-form-view1 c-editor-form-view1-1-border"><div class="c-editor-form-view1-1"><span>X</span> <input type="text" ng-model="editbox.x" ng-readonly="vm.data.part.id == \'P1\'" ng-change="updateEditbox()"></div><div class="c-editor-form-view1-1"><span>Y</span> <input type="text" ng-model="editbox.y" ng-readonly="vm.data.part.id == \'P1\'" ng-change="updateEditbox()"></div><div class="c-editor-form-view1-1"><span>\u5BBD</span> <input type="text" ng-model="editbox.width" ng-readonly="vm.data.part.id == \'P1\'" ng-change="updateEditbox()"></div><div class="c-editor-form-view1-1"><span>\u9AD8</span> <input type="text" ng-model="editbox.height" ng-readonly="vm.data.part.id == \'P1\'" ng-change="updateEditbox()"></div></div><div class="c-editor-form-view1" style="width: 134px; min-width: 134px; margin-left: 10px"><div class="c-editor-form-view1-1"><span>\u5355\u4F4D</span><select ng-model="vm.data.unit1" ng-options="item.id as item.name for item in vm.units" ng-change="unitConversion(vm.data.unit1)"></select></div></div><i class="iconfont icon-jiahao2fill pageEditAdd" ng-click="addPageEdit()" ng-if="$index == 0 && vm.data.part.id != \'P1\'"></i> <i class="iconfont icon-shixinguanbi pageEditAdd" ng-click="removePageEdit($index)" ng-if="$index > 0 && vm.data.part.id != \'P1\'"></i></div></div></div><div class="c-form" id="select-form"><label class="c-form-label">\u5E94\u7528\u5230\u5176\u5B83\u90E8\u4EF6\uFF1A</label><div class="c-form-div" id="select-div"><div class="select-div" ng-mouseenter="mouseenter()" ng-mouseleave="mouseleave()"><span class="select-div-item" ng-repeat="item in vm.data.parts" ng-if="item.selected && vm.data.part.id != item.id">{{item.name}} <span class="iconfont icon-guanbi2" ng-click="delete(item)"></span></span><div class="select-list" ng-if="vm.partsListShow" ng-style="{\'left\':vm.partsListX + \'px\' , \'top\':vm.partsListY + \'px\'}"><div ng-repeat="item in vm.data.parts" ng-if="vm.data.part.id != item.id && item.counter > 0" class="select-li" ng-class="{\'select-li-selected\':item.selected}" ng-click="item.selected = !item.selected"><span>{{item.name}}</span> <span class="iconfont icon-gou" ng-if="item.selected"></span></div></div></div></div></div><div ng-if="vm.data.modelType == \'THREE\'"><div class="c-form" style="margin-bottom: 10px" ng-if="vm.data.modelName&&vm.data.modelPic"><label class="c-form-label">\u5173\u8054\u6A21\u578B\uFF1A</label><div class="c-form-div"><div class="c-table"><table><thead><tr><th>\u6A21\u578B\u540D\u79F0</th><th>\u6A21\u578B</th></tr></thead><tbody><tr><td>{{vm.data.modelName}}</td><td><img ng-src="{{vm.url + vm.data.modelPic}}" height="55"></td></tr></tbody></table></div></div></div><div class="c-form" style="margin-bottom: 10px"><label class="c-form-label">\u5173\u8054\u6A21\u578B\u9875\uFF1A</label><div class="c-form-div"><select class="c-select1" style="height: 40px" ng-model="vm.materialName" ng-options="item.materialName as item.materialName for item in vm.modelData"><option value="" class="" selected="selected">\u8BF7\u5173\u8054\u6750\u8D28</option></select></div></div></div><!--            <div ng-if="vm.data.modelType == \'THREE\'" class="c-form" ng-repeat="item in vm.data.modelData track by $index" style="margin-bottom: 10px;">--><!--                <label class="c-form-label">{{item.materialName}}\uFF1A</label>--><!--                <div class="c-form-div">--><!--                    <select class="c-select1"--><!--                            ng-model="item.page"--><!--                            ng-options="page.seq as page.name for page in vm.parts">--><!--                        <option value="" class="" selected="selected">\u8BF7\u5173\u8054\u6750\u8D28</option>--><!--                    </select>--><!--                </div>--><!--            </div>--><div class="c-form" ng-if="vm.data.modelType == \'TWO\'"><label class="c-form-label">\u6A21\u578B\uFF1A</label><div class="c-form-div" style="display: flex"><div class="upload-form"><div class="upload-input" ng-if="!vm.data.mould" ng-click="vm.selectModel(vm.data)"><div class="iconfont icon-hao"></div><div>\u8BF7\u9009\u62E9</div></div><div ng-if="vm.data.mould" class="upload-img"><img ng-src="{{vm.data.mould.modelPic}}" alt=""><!--                            <i class="iconfont icon-guanbi1" ng-click="removeMould($event)"></i>--></div></div><div style="display: flex; align-items: flex-end; height: 96px; margin-left: 16px; cursor: pointer" ng-click="vm.selectModel(vm.data)" ng-if="vm.data.mould"><i class="iconfont icon-bianji"></i> <span style="line-height: 21px; margin-left: 5px">\u4FEE\u6539</span></div></div></div></div></div><div class="c-model-foot"><button type="button" class="btn btn-cancel" ng-click="vm.cancel()">\u53D6\u6D88</button> <button type="button" class="btn btn-info" ng-click="vm.save()">\u786E\u5B9A</button></div></div><style>.timesSign{\n        display: inline-block;\n        height: 32px;\n        line-height: 30px;\n        cursor: pointer;\n    }\n    .timesSign-select{\n        color: #E1A03A;\n    }\n    .c-form{width: 90%;}\n    .c-form .c-form-label{\n        width: 120px !important;\n        padding: 0;\n        height: 40px;\n        line-height: 40px;\n    }\n    .c-form .c-form-div{\n        position: relative;\n        margin-left: 120px !important;\n        width: auto;\n        min-height: 40px;\n    }\n    .select-div{\n        width: 100%;\n        height: 40px;\n        border: 1px solid #E1E5EB;\n        border-radius: 4px;\n        background-color: #fff;\n        padding: 0 10px;\n        display: flex;\n        flex-wrap: wrap;\n        gap: 10px;\n        align-items: center;\n    }\n    .select-list{\n        width: 250px;\n        background-color: #ffffff;\n        border-radius: 4px;\n        filter: drop-shadow(0px 0px 3px #1616165d);\n        position: fixed;\n        padding: 15px 0;\n        z-index: 1;\n    }\n    .select-list::after{\n        content: "";\n        position: absolute;\n        top: -10px;\n        left: 10%;\n        transform: translateX(-50%);\n        width: 0;\n        height: 0;\n        border-style: solid;\n        border-width: 0 20px 20px;\n        border-color: transparent transparent #fff;\n    }\n    .select-li{\n        padding: 5px 10px;\n        display: flex;\n        align-items: center;\n        justify-content: space-between;\n        height: 30px;\n        width: 100%;\n    }\n    .select-li:hover{\n        background-color: #f5f7fa;\n    }\n    .select-li-selected{\n        color: #264df0;\n    }\n    .select-div-item{\n        padding: 5px 10px;\n        background-color: #f0f2f5;\n        border-radius: 5px;\n    }</style>');
$templateCache.put('app/entities/page/modal/psd-font-mapping.html','<div class="c-model"><div class="c-model-head"><div class="c-model-head-title">\u8BBE\u7F6EPSD\u5B57\u4F53\u6620\u5C04</div><i class="iconfont icon-closeicon1" ng-click="vm.cancel()"></i></div><div class="c-model-body"><div class="psf-fm-table"><table class="jh-table table table-striped"><thead class="table-thead" style="background: rgba(38,77,240,0.06)"><tr><th style="width: 10%; text-align: center">\u5E8F\u53F7</th><th style="width: 40%">PSD\u5B57\u4F53</th><th>\u6620\u5C04\u5B57\u4F53</th><th style="width: 10%">\u64CD\u4F5C</th></tr></thead><tbody class="table-body"><tr ng-repeat="item in vm.fontMapping.items track by $index" ng-if="vm.fontMapping && vm.fontMapping.items && vm.fontMapping.items.length"><td class="psf-fm-td">{{$index + 1}}</td><td class="psf-fm-td"><input type="text" ng-model="item.name" placeholder="\u8BF7\u8F93\u5165\u5B57\u4F53\u540D\u79F0"></td><td class="psf-fm-td"><select ui-select2 class="c-select1" ng-model="item.fontId" ng-options="font.id as font.family for font in vm.fontList" ng-change="vm.onMappingItemChange($index)"><option value="">\u8BF7\u9009\u62E9</option></select></td><td class="psf-fm-td"><i class="iconfont icon-shanchu3" ng-click="vm.deleteFontItem($index)"></i></td></tr><tr ng-if="!vm.fontMapping || !vm.fontMapping.items || vm.fontMapping.items.length == 0"><td colspan="3" style="height: 50px; text-align: center; color: #999 !important; font-size: 16px">\u6682\u65E0\u6620\u5C04\u6570\u636E...</td></tr></tbody></table></div></div><div class="c-model-foot psf-fm-foot"><div><button type="button" class="btn btn-info" ng-click="vm.addFontItem()">\u6DFB\u52A0</button> <button type="button" class="btn btn-info" ng-click="vm.loadFromPsd()">\u4ECEPSD\u8F7D\u5165</button></div><div><button type="button" class="btn btn-info btn-max" ng-click="vm.save()">\u786E\u8BA4\u4FDD\u5B58</button></div></div></div><style type="text/css">.psf-fm-table {\n        background: #fff;\n        width: 100%;\n        padding: 20px;\n        max-height: 500px;\n        min-height: 300px;\n        overflow-y: scroll;\n    }\n\n    .psf-fm-foot {\n        display: flex; \n        justify-content: space-between; \n        align-items: center;\n    }\n\n    .psf-fm-td {\n        padding: 0px !important;\n\n        input {\n            width: calc(100% - 5px);\n            margin-left: 3px;\n            height: 30px;\n            line-height: 30px;\n            font-size: 14px;\n        }\n    }\n\n    .table-body td {\n        color: #3e3e3e !important;\n        text-align: center;\n        font-size: 14px;\n        padding: 0px 0px !important;\n        vertical-align: middle !important;\n    }</style>');
$templateCache.put('app/entities/page/modal/psd-upload.html','<div class="c-model"><div class="c-model-head"><div class="c-model-head-title">\u5BFC\u5165PSD\u6587\u4EF6</div><i class="iconfont icon-closeicon1" ng-click="vm.cancel()"></i></div><div class="c-model-body scrollbar-main"><div class="c-model-body-view" style="padding: 20px 0" id="upload-psd-box"><div class="c-psd-page1" ng-if="vm.psdFiles.length == 0"><img src="content/images/editor-upload.png" alt="" class="c-psd-page1-img"><div class="c-psd-page1-text">\u62D6\u62FD\u6587\u4EF6\u5230\u6B64\u5904\uFF0C\u6216\u8005</div><div class="c-psd-upload"><span>\u9009\u62E9\u6587\u4EF6...</span> <input name="token" type="hidden" value="{{vm.token}}"> <input type="file" name="file" class="c-psd-upload-input" multiple="multiple" accept=".psd" onchange="uploadPsd(event)" ng-model-options="{debounce:500}"></div></div><div class="c-psd-page2" ng-if="vm.psdFiles.length > 0"><div class="c-psd-page2-list" ng-repeat="file in vm.psdFiles track by $index"><div class="c-psd-page2-list-fl"><img src="content/images/icon/PSD-icon.png" alt="" style="width: 32px;margin-right: 16px"> {{file.name}}<!--                        <div class="psd-status2" ng-show="file.status!=\'success\'">--><!--                            <i class="iconfont icon-bianjiqi-PSDdaoru"></i>{{file.name}}--><!--                        </div>--><!--                        <div class="psd-status1" ng-show="file.status==\'success\'">--><!--                            <i class="iconfont icon-bianjiqi-PSDdaoru"></i>{{file.name}}--><!--                        </div>--></div><div class="c-psd-page2-list-fr"><!-- <div class="psd-wait" ng-show="file.status==\'wait\'">\n                            <i class="iconfont icon-dengdai"></i>\u7B49\u5F85\u5904\u7406\n                        </div> --><div class="psd-loading" ng-show="file.status==\'loading\'"><i class="iconfont icon-dengdai"></i>\u5BFC\u5165\u4E2D\u2026</div><div class="psd-success" ng-show="file.status==\'success\'"><i class="iconfont icon-chenggong"></i>\u5BFC\u5165\u6210\u529F</div><div class="psd-error" ng-show="file.status==\'error\'"><i class="iconfont icon-shixinguanbi"></i>\u5BFC\u5165\u5931\u8D25</div><i class="iconfont icon-shanchu3" ng-click="deletePsd($index)" ng-if="vm.isCanUpload"></i></div></div></div></div></div><div class="c-model-foot" style="text-align: left;color: #89919D;font-size: 12px" ng-if="vm.psdFiles.length == 0">* \u4EC5\u652F\u6301\u4E0A\u4F20psd\u6587\u4EF6\u683C\u5F0F</div><div class="c-model-foot" ng-if="vm.psdFiles.length > 0" style="display: flex; justify-content: space-between; align-items: center"><div class="c-psd-upload" style="width: 100px; justify-content: flex-start" ng-if="vm.isCanUpload"><span><i class="iconfont icon-jia2"></i>\u6DFB\u52A0\u6587\u4EF6</span> <input name="token" type="hidden" value="{{vm.token}}"> <input type="file" name="file" class="c-psd-upload-input" multiple="multiple" accept=".psd" onchange="uploadPsd(event)" ng-model-options="{debounce:500}"></div><button type="button" class="btn btn-info btn-max" ng-click="savePsdFile()" ng-if="vm.isCanUpload">\u5BFC\u5165</button></div></div><style>.c-psd-page1{\n        width: 100%;\n        height: 100%;\n        display: flex;\n        justify-content: center;\n        align-content: center;\n        flex-wrap: wrap;\n        padding: 30px 0;\n    }\n    .c-psd-page1-img{\n        width: 288px;\n    }\n    .c-psd-page1-text{\n        color: #505760;\n        font-size: 16px;\n        line-height: 22px;\n        margin: 10px;\n        width: 100%;\n        text-align: center;\n    }\n    .c-psd-upload{\n        position: relative;\n        width: 100%;\n        height: 30px;\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        color: #264DF0;\n        font-size: 14px;\n        cursor: pointer;\n    }\n    .c-psd-upload-input{\n        position: absolute;\n        left: 0;\n        top: 0;\n        width: 100%;\n        height: 100%;\n        opacity: 0;\n    }\n    .c-psd-page2{\n        width: 100%;\n    }\n    .c-psd-page2-list{\n        width: 100%;\n        height: 50px;\n        display: flex;\n        justify-content: space-between;\n        padding: 0 16px;\n    }\n    .c-psd-page2-list:hover{\n        background: #F5F7FA;\n    }\n    .c-psd-page2-list-fl,.c-psd-page2-list-fr{\n        height: 100%;\n        display: flex;\n        align-items: center;\n    }\n    .c-psd-page2-list-fl .iconfont{\n        color: #264DF0;\n        font-size: 18px;\n    }\n    .icon-shanchu3{\n        font-size: 18px;\n        color: #9BA2AD;\n        cursor: pointer;\n        margin-left: 30px;\n    }</style>');
$templateCache.put('app/entities/page/modal/recommend-look.html','<div class="preview-model"><div class="preview-model-head"><div class="title">\u9884\u89C8</div><div class="close-btn" ng-click="vm.cancel()"><i class="iconfont icon-closeicon1"></i></div></div><div class="preview-model-content"><img ng-src="{{vm.url}}" alt=""></div></div>');
$templateCache.put('app/entities/page/modal/reference.html','<div class="c-model"><div class="c-model-head"><div class="c-model-head-title">\u65B0\u5EFA\u53C2\u8003\u7EBF</div><i class="iconfont icon-closeicon1" ng-click="vm.clear()"></i></div><div class="c-model-body"><div class="c-model-body-view"><div class="c-form"><label class="c-form-label">\u53D6\u5411\uFF1A</label><div class="c-form-div" style="display: flex; align-items: center"><div ng-style="{\'color\':vm.direction == \'y\' ? \'#264DF0\' : \'#505760\'}" style="color: rgb(38, 77, 240); margin-right: 20px" ng-click="vm.direction = \'y\'"><i class="iconfont icon-xuanzhong" ng-show="vm.direction != \'y\'"></i> <i class="iconfont icon-xuanzhong1" ng-show="vm.direction == \'y\'"></i> <span>\u6C34\u5E73</span></div><div ng-style="{\'color\':vm.direction == \'x\' ? \'#264DF0\' : \'#505760\'}" style="color: rgb(38, 77, 240)" ng-click="vm.direction = \'x\'"><i class="iconfont icon-xuanzhong" ng-show="vm.direction != \'x\'"></i> <i class="iconfont icon-xuanzhong1" ng-show="vm.direction == \'x\'"></i> <span>\u5782\u76F4</span></div></div></div><div class="c-form"><label class="c-form-label">\u4F4D\u7F6E\uFF1A</label><div class="c-form-div group-form"><div class="group-form-input"><div class="group-form-item"><input type="text" ng-model="vm.place"></div></div><div class="c-editor-form-view1" style="width: 134px; min-width: 134px; margin: 0 10px"><div class="c-editor-form-view1-1"><span>\u5355\u4F4D</span><select ng-options="dpi as dpi.data for dpi in vm.dpiChoose" ng-model-options="{debounce:500}" ng-change="updateDpi(vm.dpi1)" ng-model="vm.dpi1"></select></div></div></div></div></div></div><div class="c-model-foot"><button type="button" class="btn btn-cancel" ng-click="vm.clear()">\u53D6\u6D88</button> <button type="button" class="btn btn-info" ng-click="vm.save()">\u786E\u5B9A</button></div></div><style>.modal-content{\n        width: 720px !important;\n    }\n    .c-form{width: 90%;}\n    .c-form .c-form-label{\n        width: 70px;\n        padding: 0;\n        height: 40px;\n        line-height: 40px;\n    }\n    .c-form .c-form-div{\n        position: relative;\n        margin-left: 70px;\n        width: auto;\n        min-height: 40px;\n    }</style>');
$templateCache.put('app/entities/page/modal/template-add.html','<div class="c-model" ng-style="{\'width\':vm.step == 2 ? \'723px\' : \'100%\'}" style="margin: 0 auto"><div class="c-model-head"><div class="c-model-head-title">{{getTilte()}}</div><i class="iconfont icon-closeicon1" ng-click="vm.cancel()"></i></div><div class="c-model-body"><div class="c-model-body-view scrollbar-main"><div class="step-body" ng-if="vm.step == 1"><div ng-if="vm.productType != \'THING\'"><div class="c-title">\u9009\u62E9\u4EA7\u54C1\u7C7B\u578B</div><div class="step-body-view-1"><div class="step-body-view-1-li" ng-repeat="item in vm.productList" ng-class="{\'step-body-view-1-li-selected\' : item.id == vm.productList[vm.productSeq].id}" ng-click="productCb($index)" ng-if="!vm.productType || (vm.productType == \'BOOK\'&&item.id != \'THING\')"><img ng-src="{{item.icon}}" alt=""><div>{{item.name}}</div><span>{{item.describe}}</span></div></div><div class="c-form" ng-if="vm.productList[vm.productSeq].id == \'BOOK\'"><div class="c-title">\u9009\u62E9\u90E8\u4EF6\uFF1A</div><div class="step-body-1-view-content"><div class="step-body-1-view-content-li" ng-repeat="item in vm.productList[vm.productSeq].parts" ng-class="{\'step-body-1-view-content-li-select\' : item.selected}" ng-click="item.selected = !item.selected" ng-if="!item.required">{{item.name}}</div></div><div class="c-title" style="color: #999" ng-if="vm.productList[vm.productSeq].id == \'BOOK\'">*\u521D\u59CB\u5316\u7167\u7247\u4E66\u6A21\u677F\uFF0C\u8BF7\u9009\u62E9\u9700\u8981\u7684\u90E8\u4EF6\u3002</div></div><div class="c-form" ng-if="vm.productList[vm.productSeq].id == \'CALENDAR\'"><div class="c-title">\u9009\u62E9\u9875\u6570\uFF1A</div><div class="step-body-1-view-content"><div class="step-body-1-view-content-li" ng-repeat="item in vm.productList[vm.productSeq].pages" ng-class="{\'step-body-1-view-content-li-select\' : vm.data.photoPage == item.id}" ng-click="vm.data.photoPage = item.id">{{item.name}}</div></div><p style="font-size: 12px;color: #89919D">*\u6B64\u5411\u5BFC\u4E3A\u5FEB\u901F\u751F\u6210\u6A21\u677F\uFF0C\u7F16\u8F91\u5668\u5185\u652F\u6301\u52A0\u9875</p></div><div class="c-form" ng-if="vm.productList[vm.productSeq].id == \'CALENDAR\' || vm.productList[vm.productSeq].id == \'PHOTO\'"><div class="c-title">\u9009\u62E9\u7C7B\u578B\uFF1A</div><div class="step-body-1-view-content"><div class="step-body-1-view-content-li" ng-repeat="item in vm.productList[vm.productSeq].types" ng-class="{\'step-body-1-view-content-li-select\' : typeReturn() == item.id}" ng-click="typeCb(item)">{{item.name}}</div></div></div></div><div ng-if="vm.productList[vm.productSeq].id == \'THING\'"><div class="c-title">\u9009\u62E9\u4EA7\u54C1\u7C7B\u578B</div><div class="step-body-view-1" style="gap: 20px"><div class="step-body-view-1-li" style="width: calc(50% - 10px)" ng-repeat="item in vm.productList[vm.productSeq].types" ng-class="{\'step-body-view-1-li-selected\' : typeReturn() == item.id}" ng-click="typeCb(item)"><img ng-src="{{item.icon}}" alt=""><div>{{item.name}}</div></div></div><div class="c-form"><div class="c-title">\u9009\u62E9\u90E8\u4EF6\uFF1A</div><div class="step-body-1-view-content"><div class="step-body-1-view-content-li part-tag" ng-repeat="item in vm.productList[vm.productSeq].parts"><span>{{item.name}}</span> <i class="iconfont icon-guanbi" style="margin-left: 10px; cursor: pointer;height: 18px" ng-click="deletePart($index)"></i></div><div class="add-part-btn" ng-click="addPart()" ng-if="!vm.isPart"><i class="iconfont icon-jia2" style="font-size: 16px"></i> <span>\u65B0\u589E</span></div><div class="step-body-1-view-content-li part-input" style="cursor: auto; padding: 0;color: #333 !important;height: 40px" ng-if="vm.isPart"><input type="text" id="partInput" ng-model="vm.part" maxlength="30" ng-blur="partBlur()" style="border: 0; width: 100px"></div></div></div></div></div><div class="step-body" ng-if="vm.step == 2"><div class="spread-select" ng-if="vm.productList[vm.productSeq].id == \'BOOK\'"><div class="spread-button" ng-click="vm.data.spread = true;vm.data.innerOffset = 0;" ng-class="{\'spread-button-selected\':vm.data.spread}">\u8DE8\u9875\u6A21\u677F<div class="spread-button-tooltip"><div class="spread-button-tooltip-item">P1</div><div class="spread-button-tooltip-item">P2</div><div class="spread-button-tooltip-item" style="margin-left: 10px">P3</div><div class="spread-button-tooltip-item">P4</div></div></div><div class="spread-button" ng-click="vm.data.spread = false" ng-class="{\'spread-button-selected\':!vm.data.spread}">\u975E\u8DE8\u9875\u6A21\u677F<div class="spread-button-tooltip" style="gap: 10px"><div class="spread-button-tooltip-item">P1</div><div class="spread-button-tooltip-item">P2</div><div class="spread-button-tooltip-item">P3</div><div class="spread-button-tooltip-item">P4</div></div></div></div><div class="c-form"><label class="c-form-label"><span class="c-form-required">*</span>\u6A21\u677F\u540D\u79F0\uFF1A</label><div class="c-form-div lh35"><input type="text" class="c-input1" style="height: 40px" ng-model="vm.data.name" placeholder="\u8BF7\u8F93\u5165"></div></div><div class="c-form"><label class="c-form-label">\u6A21\u677F\u7C7B\u578B\uFF1A</label><div class="c-form-div lh35"><input type="text" class="c-input1" style="height: 40px" value="{{modelTypeInfo()}}" disabled="disabled"></div></div><div ng-if="vm.productList[vm.productSeq].id == \'BOOK\' || vm.productList[vm.productSeq].id == \'CALENDAR\' || vm.productList[vm.productSeq].id == \'PHOTO\'"><div class="c-form"><label class="c-form-label">\u6A21\u677F\u5206\u7C7B\uFF1A</label><div class="c-form-div lh35"><modele-select ng-model="vm.catalogId" label-key="name" value-key="id" ng-change="changeCatalog()" options="vm.catalogs"></modele-select></div></div><div ng-if="vm.productList[vm.productSeq].id == \'CALENDAR\' && vm.data.photoType == \'dynamic\'"><div class="c-form"><label class="c-form-label"><span class="c-form-required">*</span>\u5F00\u59CB\u6708\u4EFD\uFF1A</label><div class="c-form-div lh35" style="position: relative"><input id="startTime" style="height: 40px" type="text" class="c-input1" name="month" uib-datepicker-popup="yyyy-MM" datepicker-options="options" ng-model="vm.data.month" is-open="vm.isMonth" clear-text="\u6E05\u7A7A" close-text="\u5173\u95ED" current-text="\u672C\u6708" ng-click="vm.isMonth = true" placeholder="\u5F00\u59CB\u6708\u4EFD"> <i style="position:absolute;top: 50%;transform: translate(0,-50%);right:16px;font-size: 16px;color: #222529" class="iconfont icon-down"></i></div></div><div class="c-form"><label class="c-form-label">\u6807\u9898\u9884\u9009\uFF1A</label><div class="c-form-div lh35"><div class="forward-select" ng-if="!vm.titleWidget" ng-click="showWidgetModal(\'titleWidget\')">\u9009\u62E9(\u975E\u5FC5\u9009)</div><div class="forward-selected" ng-if="vm.titleWidget"><div class="cover-img"><img ng-src="{{vm.titleWidget.previewUrl}}" alt="{{vm.titleWidget.name}}"></div><div class="selected-info"><div class="selected-name">{{vm.titleWidget.name}}</div><div class="delete-icon" ng-click="deleteWidget(\'titleWidget\')"><i class="iconfont icon-dustbin_icon"></i></div></div></div></div></div><div class="c-form"><label class="c-form-label">\u5E03\u5C40\u9884\u9009\uFF1A</label><div class="c-form-div lh35"><div class="forward-select" ng-if="!vm.monthWidget" ng-click="showWidgetModal(\'monthWidget\')">\u9009\u62E9(\u975E\u5FC5\u9009)</div><div class="forward-selected" ng-if="vm.monthWidget"><div class="cover-img"><img ng-src="{{vm.monthWidget.previewUrl}}" alt="{{vm.monthWidget.name}}"></div><div class="selected-info"><div class="selected-name">{{vm.monthWidget.name}}</div><div class="delete-icon" ng-click="deleteWidget(\'monthWidget\')"><i class="iconfont icon-dustbin_icon"></i></div></div></div><!--                                <select class="c-select1" ng-model="vm.monthWidget" style="height: 40px;" ng-options="item.name for item in vm.monthWidgets"></select>--></div></div></div><div class="c-form"><label class="c-form-label"><span class="c-form-required">*</span>\u753B\u5E03\u5C3A\u5BF8\uFF1A</label><div class="c-form-div group-form"><div class="group-form-input"><div class="group-form-item"><span class="group-form-item-title">\u5BBD</span> <input type="text" ng-model="vm.data.pageSizeW"></div><div class="line"></div><div class="group-form-item"><span class="group-form-item-title">\u9AD8</span> <input type="text" ng-model="vm.data.pageSizeH"></div></div><div class="group-form-select"><modele-select ng-model="vm.data.unit1" prefix="\u5355\u4F4D" label-key="name" value-key="id" ng-change="unitConversion(vm.data.unit1)" options="vm.units"></modele-select></div></div></div><div class="c-form"><label class="c-form-label"><span class="c-form-required">*</span>\u51FA\u8840\u5C3A\u5BF8\uFF1A</label><div class="c-form-div group-form"><div class="group-form-input"><div class="group-form-item"><span class="group-form-item-title">\u4E0A</span> <input type="text" ng-model="vm.data.pageBloodT"></div><div class="line"></div><div class="group-form-item"><span class="group-form-item-title">\u4E0B</span> <input type="text" ng-model="vm.data.pageBloodB"></div><div class="line"></div><div class="group-form-item"><span class="group-form-item-title">\u5DE6</span> <input type="text" ng-model="vm.data.pageBloodL"></div><div class="line"></div><div class="group-form-item"><span class="group-form-item-title">\u53F3</span> <input type="text" ng-model="vm.data.pageBloodR"></div></div><div class="group-form-select"><modele-select ng-model="vm.data.unit1" prefix="\u5355\u4F4D" label-key="name" value-key="id" ng-change="unitConversion(vm.data.unit1)" options="vm.units"></modele-select></div></div></div><div class="c-form" ng-if="vm.productList[vm.productSeq].id == \'BOOK\' && !vm.data.spread"><label class="c-form-label">\u5185\u9875\u9996\u9875\uFF1A</label><div class="c-form-div" style="margin-left: 150px; display: flex; width: auto"><div style="display: flex" ng-click="vm.data.innerOffset = 0"><div ng-style="{\'color\':vm.data.innerOffset == 0 ? \'#264DF0\' : \'#505760\'}"><span class="iconfont icon-xuanzhong" ng-show="vm.data.innerOffset != 0"></span> <span class="iconfont icon-xuanzhong1" ng-show="vm.data.innerOffset == 0"></span> \u5DE6\u4FA7</div><img style="width: 80px;margin-left: 10px" src="content/images/first-inside-page.png" alt=""></div><div style="margin-left: 40px; display: flex" ng-click="vm.data.innerOffset = 1"><div ng-style="{\'color\':vm.data.innerOffset == 1 ? \'#264DF0\' : \'#505760\'}"><span class="iconfont icon-xuanzhong" ng-show="vm.data.innerOffset != 1"></span> <span class="iconfont icon-xuanzhong1" ng-show="vm.data.innerOffset == 1"></span> <span>\u53F3\u4FA7</span></div><img style="width: 80px;margin-left: 10px" src="content/images/second-inside-page.png" alt=""></div></div></div><div class="c-form" ng-if="vm.productList[vm.productSeq].id == \'BOOK\' || vm.productList[vm.productSeq].id == \'CALENDAR\'"><label class="c-form-label"><i class="iconfont icon-wenhao" style="color: #999" uib-tooltip-html="replaceTppltip" tooltip-placement="bottom"></i>\u6A21\u677F\u66FF\u6362\uFF1A</label><div class="c-form-div align-items-center"><input type="checkbox" class="checkOrIf" name="enabled" ng-model="vm.data.replace"><!--                            <modele-select--><!--                                ng-model="vm.data.replace"--><!--                                label-key="value"--><!--                                value-key="id"--><!--                                options="vm.replaces">--><!--                            </modele-select>--></div></div><div class="c-form" ng-if="vm.productList[vm.productSeq].id == \'BOOK\'"><label class="c-form-label"><span class="c-form-required">*</span>\u5185\u9875\u9875\u6570\uFF1A</label><div class="c-form-div lh35"><input type="text" class="c-input1" ng-model="vm.data.pageCount" style="width: 90px; margin-right: 10px;height: 40px" placeholder="\u8BF7\u8F93\u5165"> \u9875</div></div><div class="c-form" ng-if="vm.productList[vm.productSeq].id == \'BOOK\' || (vm.productList[vm.productSeq].id == \'CALENDAR\' && vm.data.photoType == \'ordinary\')"><label class="c-form-label"><i class="iconfont icon-wenhao" style="color: #999" uib-tooltip-html="addPageTppltip" tooltip-placement="bottom"></i>\u52A0\u9875\uFF1A</label><div class="c-form-div lh35"><modele-select ng-model="vm.data.addpage" label-key="value" value-key="id" options="vm.addpages"></modele-select></div></div><div ng-if="vm.data.addpage && (vm.productList[vm.productSeq].id == \'BOOK\' || (vm.productList[vm.productSeq].id == \'CALENDAR\' && vm.data.photoType == \'ordinary\'))"><div class="c-form"><label class="c-form-label"><span class="c-form-required">*</span>\u9875\u6570\u8303\u56F4\uFF1A</label><div class="c-form-div lh35"><input type="number" min="1" class="c-input1" ng-model="vm.data.minpage" style="width: 90px; margin-right: 10px; height: 40px" placeholder="\u5F00\u59CB\u9875\u6570"> \u81F3 <input type="number" min="1" class="c-input1" ng-model="vm.data.maxpage" style="width: 90px; margin-left: 10px; height: 40px" placeholder="\u7ED3\u675F\u9875\u6570"> \u9875</div></div><div class="c-form"><label class="c-form-label"><span class="c-form-required">*</span>\u52A0\u9875\u5355\u4F4D\uFF1A</label><div class="c-form-div lh35"><input type="number" min="1" class="c-input1" ng-model="vm.data.addunit" style="width: 90px; margin-right: 10px; height: 40px" placeholder="\u52A0\u9875\u5355\u4F4D">\u9875</div></div></div></div><div ng-if="vm.productList[vm.productSeq].id == \'THING\'"><div class="c-form"><label class="c-form-label"><span class="c-form-required">*</span>\u9884\u89C8\u56FE\uFF1A</label><div class="c-form-div"><div class="upload-form"><div class="upload-input" ng-if="!vm.data.cover"><div class="iconfont icon-hao"></div><div>\u4E0A\u4F20\u56FE\u7247</div></div><div ng-if="vm.data.cover" class="upload-img"><img alt="\u56FE\u7247\u7F3A\u5931" ng-if="vm.url" ng-src="{{vm.url + vm.data.cover}}"> <i class="iconfont icon-closeicon1" ng-click="removeFile()"></i></div><input type="file" name="file" accept=" image/jpeg, image/png" onchange="uploadPic(event)" ng-model-options="{debounce : 500}" style="position: absolute;display: block; top: 0; left: 0; width: 100%; height: 100%; font-size: 100px; opacity: 0; filter: alpha(opacity=0); z-index: 1"></div></div></div><div class="c-form"><label class="c-form-label">\u6A21\u677F\u5206\u7C7B\uFF1A</label><div class="c-form-div"><modele-select ng-model="vm.catalogId" label-key="name" value-key="id" ng-change="changeCatalog()" options="vm.catalogs"></modele-select></div></div><div class="c-form"><label class="c-form-label"><i class="iconfont icon-wenhao" style="color: #999" uib-tooltip="\u51B3\u5B9A\u7528\u6237\u4F7F\u7528\u6A21\u677F\u65F6\uFF0C\u5185\u9875\u662F\u5426\u53EF\u66FF\u6362\u4EE5\u53CA\u6392\u5E8F\u3002" tooltip-placement="bottom"></i>\u6A21\u677F\u66FF\u6362\uFF1A</label><div class="c-form-div align-items-center"><input type="checkbox" class="checkOrIf" name="enabled" ng-model="vm.data.replace"><!--                            <modele-select--><!--                                ng-model="vm.data.replace"--><!--                                label-key="value"--><!--                                value-key="id"--><!--                                options="vm.replaces">--><!--                            </modele-select>--></div></div><div ng-if="vm.data.modelType == \'THREE\'"><div class="c-form"><label class="c-form-label"><span class="c-form-required">*</span>\u5173\u8054\u6A21\u578B\uFF1A</label><div class="c-form-div" ng-if="!vm.data.modelPath"><div class="upload-form" ng-click="vm.modelPathTab()"><div class="upload-input"><div class="iconfont icon-hao"></div><div>\u8BF7\u9009\u62E9</div></div></div></div><div class="c-form-div" ng-if="vm.data.modelPath"><div class="c-table"><table><thead><tr><th>\u6A21\u578B\u540D\u79F0</th><th>\u6A21\u578B</th><th>\u6750\u8D28</th><th></th></tr></thead><tbody><tr><td>{{vm.data.mould.name}}</td><td><img ng-src="{{vm.url + vm.data.mould.modelPic}}" height="55"></td><td><div ng-repeat="item in vm.modelData">{{item.materialName}}</div></td><td><span class="iconfont icon-zhongxuan" style="color: #264DF0" ng-click="vm.modelPathTab()">\u91CD\u9009</span></td></tr></tbody></table></div></div></div><div class="c-form" ng-repeat="item in vm.modelData" style="margin-bottom: 10px"><label class="c-form-label">{{item.materialName}}\uFF1A</label><div class="c-form-div"><modele-select ng-model="item.page" label-key="name" placeholder="\u8BF7\u5173\u8054\u90E8\u4EF6" value-key="seq" options="vm.productList[vm.productSeq].parts"></modele-select></div></div><div class="c-form"><label class="c-form-label">\u914D\u8272\u7BA1\u7406\uFF1A</label><div class="c-form-div"><div ng-repeat="item in vm.data.modelBlendent track by $index" class="color-matching"><input type="text" class="c-input1" ng-model="item.name" placeholder="\u8F93\u5165\u540D\u79F0"> <span ng-click="modelBlendentSet(item)">\u8BBE\u7F6E\u914D\u8272</span> <span class="iconfont icon-shixinguanbi" ng-click="removeModelBlendent($index)"></span></div><button type="button" class="btn-white" ng-click="modelBlendentAdd()" style="margin-top: 8px">\u65B0\u589E</button></div></div></div><div class="c-hr"></div><div class="c-tab-view"><div class="c-tab-view-li" ng-class="{\'c-tab-view-li-select\' : vm.thingPart.partIndex == $index}" ng-repeat="item in vm.productList[vm.productSeq].parts" ng-click="thingPartCb($index)">{{item.name}}</div></div><div style="margin-top: 16px"><div class="c-form"><label class="c-form-label"><span class="c-form-required">*</span>\u5C3A\u5BF8\uFF1A</label><div class="c-form-div group-form"><div class="group-form-input"><div class="group-form-item"><span class="group-form-item-title">\u5BBD</span> <input type="text" ng-model="vm.productList[vm.productSeq].parts[vm.thingPart.partIndex].page[vm.thingPart.pageIndex].pageSizeW"></div><div class="line"></div><div class="group-form-item"><span class="group-form-item-title">\u9AD8</span> <input type="text" ng-model="vm.productList[vm.productSeq].parts[vm.thingPart.partIndex].page[vm.thingPart.pageIndex].pageSizeH"></div></div><div class="group-form-select" style="border: none"><modele-select ng-model="vm.data.unit1" prefix="\u5355\u4F4D" label-key="name" value-key="id" ng-change="unitConversion1(vm.data.unit1)" options="vm.units"></modele-select></div></div></div><div class="c-form"><label class="c-form-label"><span class="c-form-required">*</span>\u51FA\u8840\u5C3A\u5BF8\uFF1A</label><div class="c-form-div group-form"><div class="group-form-input"><div class="group-form-item"><span class="group-form-item-title">\u4E0A</span> <input type="text" ng-model="vm.productList[vm.productSeq].parts[vm.thingPart.partIndex].page[vm.thingPart.pageIndex].pageBloodT"></div><div class="line"></div><div class="group-form-item"><span class="group-form-item-title">\u4E0B</span> <input type="text" ng-model="vm.productList[vm.productSeq].parts[vm.thingPart.partIndex].page[vm.thingPart.pageIndex].pageBloodB"></div><div class="line"></div><div class="group-form-item"><span class="group-form-item-title">\u5DE6</span> <input type="text" ng-model="vm.productList[vm.productSeq].parts[vm.thingPart.partIndex].page[vm.thingPart.pageIndex].pageBloodL"></div><div class="line"></div><div class="group-form-item"><span class="group-form-item-title">\u53F3</span> <input type="text" ng-model="vm.productList[vm.productSeq].parts[vm.thingPart.partIndex].page[vm.thingPart.pageIndex].pageBloodR"></div></div><div class="group-form-select" style="border: none"><modele-select ng-model="vm.data.unit1" prefix="\u5355\u4F4D" label-key="name" value-key="id" ng-change="unitConversion1(vm.data.unit1)" options="vm.units"></modele-select></div></div></div><div class="c-form" ng-if="vm.data.modelType == \'TWO\'"><label class="c-form-label"><span class="c-form-required">*</span>\u6A21\u578B\uFF1A</label><div class="c-form-div"><div class="upload-form" ng-click="vm.selectModelEdit(vm.productList[vm.productSeq].parts[vm.thingPart.partIndex].page[vm.thingPart.pageIndex])"><div class="upload-input" ng-if="!vm.productList[vm.productSeq].parts[vm.thingPart.partIndex].page[vm.thingPart.pageIndex].mould.modelPic"><div class="iconfont icon-hao"></div><div>\u8BF7\u9009\u62E9</div></div><div ng-if="vm.productList[vm.productSeq].parts[vm.thingPart.partIndex].page[vm.thingPart.pageIndex].mould.modelPic" class="upload-img"><img ng-src="{{vm.productList[vm.productSeq].parts[vm.thingPart.partIndex].page[vm.thingPart.pageIndex].mould.modelPic}}" alt=""> <i class="iconfont icon-closeicon1" ng-click="removeMould($event)"></i></div></div></div></div><div class="c-form" ng-if="vm.productList[vm.productSeq].parts.length>1"><div class="c-form-div"><button type="button" class="btn btn-info" ng-click="vm.reuse()">\u5E94\u7528\u5230\u6240\u6709\u90E8\u4EF6</button></div></div></div></div></div></div></div><div class="c-model-foot" style="display: flex;justify-content: center;align-items: center;gap: 16px"><button type="button" class="btn btn-cancel btn-max" ng-click="vm.cancel()" ng-if="vm.step == 1">\u53D6\u6D88</button> <button type="button" class="btn btn-info btn-max" ng-click="vm.next()" ng-if="vm.step == 1">\u4E0B\u4E00\u6B65</button> <button type="button" class="btn btn-cancel btn-max" ng-click="vm.step = 1" ng-if="vm.step == 2">\u4E0A\u4E00\u6B65</button> <button type="button" class="btn btn-info btn-max" ng-click="vm.save()" ng-if="vm.step == 2">\u5F00\u59CB\u8BBE\u8BA1</button></div></div><style>.c-title{\n        margin-bottom: 5px;\n    }\n    .step-tab{\n        position: relative;\n        display: flex;\n        justify-content: space-around;\n    }\n    .step-tab-view{\n        width: 100px;\n        display: flex;\n        justify-content: center;\n        flex-wrap: wrap;\n        position: relative;\n        z-index: 1;\n        color: #999;\n    }\n    .step-tab-view-label{\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        width: 35px;\n        height: 35px;\n        border: 2px solid #999;\n        font-size: 14px;\n        border-radius: 18px;\n        background: #fff;\n    }\n    .step-tab-view-text{\n        width: 100%;\n        text-align: center;\n        margin-top: 10px;\n        font-size: 16px;\n    }\n    .step-tab-hr{\n        position: absolute;\n        left: 50%;\n        top: 17.5px;\n        width: 240px;\n        height: 2px;\n        background: #999;\n        margin-left: -120px;\n    }\n    .step-tab-hr-select{\n        background: #333;\n    }\n    .step-tab-view-select{\n        color: #333;\n    }\n    .step-tab-view-select .step-tab-view-label{\n        border: 2px solid #333;\n    }\n    .step-body{\n    }\n    .step-body-view-1{\n        display: flex;\n        justify-content: space-between;\n        margin-bottom: 16px;\n    }\n    .step-body-view-1-li{\n        width: calc(33% - 10px);\n        height: 144px;\n        background: #F5F7FA;\n        border-radius: 4px;\n        display: flex;\n        flex-direction: column;\n        align-items: center;\n        justify-content: space-around;\n        padding: 20px 0;\n    }\n    .step-body-view-1-li img{\n        height: 36px;\n    }\n    .step-body-view-1-li div{\n        font-size: 18px;\n        font-weight: bold;\n    }\n    .step-body-view-1-li span{\n        font-size: 12px;\n        color: #89919D;\n    }\n    .step-body-view-1-li-selected{\n        background: rgba(38,77,240,0.09);\n    }\n    .step-body-view-1-li-selected div{\n        color: #264DF0;\n    }\n    .step-body-view-1-li-selected span{\n        color: #505760;\n    }\n    .step-body-1-view-content{\n        display: flex;\n        flex-wrap: wrap;\n        width: auto !important;\n    }\n    .step-body-1-view-content-li{\n        padding: 0 15px;\n        height: 35px;\n        color: #505760;\n        border-radius: 3px;\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        background: #F5F7FA;\n        margin: 0 10px 10px 0;\n        cursor: pointer;\n        transition: all .1s;\n    }\n    .step-body-1-view-content-li:hover{\n        color: #264DF0;\n    }\n    .step-body-1-view-content-li-select{\n        background: rgba(38,77,240,0.09) !important;\n        color: #264DF0 !important;\n    }\n    .c-hr{\n        width: 100%;\n        height: 1px;\n        background: #ddd;\n        margin: 20px 0;\n    }\n    .c-tab-view{\n        width: 90%;\n        display: flex;\n        flex-wrap: wrap;\n        align-items: center;\n        gap: 16px;\n    }\n    .c-tab-view-li{\n        padding: 4px 0;\n        color: #0A0A0A;\n        cursor: pointer;\n        border-bottom: 2px solid #ffffff;\n    }\n    .c-tab-view-li-select{\n        border-bottom: 2px solid #264DF0;\n    }\n    .c-form-label{\n        width: 85px !important;\n    }\n    .c-form-div{\n        width: auto !important;\n        margin-left: 85px !important;\n    }\n    .color-matching{\n        display: flex;\n        align-items: center;\n        margin-bottom: 8px;\n    }\n    .color-matching input{\n        width: 160px !important;\n        height: 40px !important;\n    }\n    .color-matching span{\n        margin-left: 8px;\n        color: #264DF0;\n    }\n    .color-matching .iconfont{\n        color: #d1d5dc;\n        font-size: 20px;\n    }\n    .btn-white{\n        width: 64px;\n        height: 40px;\n        border-radius: 4px;\n        border: 1px solid #E1E5EB;\n        font-size: 14px;\n        font-weight: 400;\n        color: #89919D;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        background: #FFF;\n    }\n    .add-part-btn{\n        width: 84px;\n        height: 40px;\n        border: 1px solid #E1E5EB;\n        border-radius: 4px;\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        color: #505760;\n        font-size: 14px;\n    }\n    .add-part-btn:hover{\n        border-color: #264DF0;\n    }\n    .add-part-btn .iconfont{\n        color: #89919D;\n        margin-right: 4px;\n    }\n    .part-tag{\n        height: 40px;\n        color: #264DF0;\n        font-weight: bold;\n        background: rgba(38,77,240,0.09);\n    }\n    .part-tag:hover{\n        background: rgba(255,68,68,0.08);\n        color: #FF4444;\n    }\n    .part-tag:hover .iconfont{\n        color: #FF4444;\n    }\n    .part-tag .iconfont{\n        color: #89919D;\n        font-weight: normal;\n    }\n    .forward-select{\n        display: inline-block;\n        padding: 0 16px;\n        color: #89919D;\n        line-height: 38px;\n        font-size: 14px;\n        border: 1px solid #E1E5EB;\n        border-radius: 4px;\n        cursor: pointer;\n\n\n    }\n    .forward-select:hover{\n        box-shadow: 0px 0px 4px 0px rgba(58, 124, 255, 0.45);\n        border: 1px solid #264DF0;\n        color: #264DF0;\n    }\n    .forward-selected{\n        width: 100%;\n        border: 1px solid #E1E5EB;\n        border-radius: 4px;\n        padding: 10px;\n        display: flex;\n    }\n    .forward-selected .cover-img{\n        width: 80px;\n        height: 80px;\n        background: #EEF0F3;\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        margin-right: 16px;\n    }\n    .forward-selected .cover-img img{\n        max-width: 100%;\n        max-height: 100%;\n    }\n    .forward-selected .selected-info{\n        display: flex;\n        flex: 1;\n        align-items: center;\n        position: relative;\n        padding-right: 20px;\n    }\n    .forward-selected .selected-name{\n        color: #505760;\n        font-size: 14px;\n    }\n    .forward-selected .delete-icon{\n        position: absolute;\n        right: 0;\n        top: 50%;\n        transform: translate(0,-50%);\n    }\n    .forward-selected .delete-icon .iconfont{\n        font-size: 18px;\n        color: #89919D;\n        cursor: pointer;\n    }\n    .spread-select{\n        display: flex;\n        align-items: center;\n        justify-content: space-evenly;\n        padding: 0 100px 10px;\n    }\n    .spread-button{\n        width: 150px;\n        height: 40px;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        background-color: #f5f7fa;\n        color: #000;\n        font-size: 16px;\n        border-radius: 4px;\n        position: relative;\n    }\n    .spread-button-selected{\n        background-color: #264DF0;\n        color: #fff;\n    }\n    .spread-button:hover .spread-button-tooltip{\n        display: flex;\n    }\n    .spread-button-tooltip{\n        display: none;\n        position: absolute;\n        left: 50%;\n        top: 100%;\n        transform: translate(-50%,20%);\n        background-color: #FFF;\n        width: 200px;\n        height: 60px;\n        border-radius: 4px;\n        filter: drop-shadow(1px 1px 8px #00000044);\n        align-items: center;\n        padding: 10px;\n    }\n    .spread-button-tooltip-item{\n        width: 20px;\n        height: 100%;\n        background-color: #c4c4c4;\n        display: flex;\n        align-items: center;\n        color: #ffffff;\n        flex: 1;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n    }\n    .spread-button-tooltip:after{\n        content: \'\';\n        width: 0;\n        height: 0;\n        position: absolute;\n        left: 50%;\n        top: -20%;\n        transform: translateX(-50%);\n        border-left: 10px solid transparent;\n        border-right: 10px solid transparent;\n        border-bottom: 12px solid rgb(255, 255, 255);\n    }</style>');
$templateCache.put('app/entities/page/modal/template-modal.html','<div class="c-model"><div class="c-model-head clearfix"><div class="c-model-head-title">\u65B0\u5EFA\u6A21\u677F</div><button aria-label="Close" data-dismiss="modal" class="close" type="button" ng-click="vm.cancel()"><span aria-hidden="true">&times;</span></button></div><div class="c-model-body"><div class="c-form"><label class="c-form-label" style="width: 150px">\u6A21\u677F\u540D\u79F0\uFF1A</label><div class="c-form-div lh35" style="margin-left: 150px"><input type="text" class="c-input1" ng-model="vm.data.name" ng-if="vm.page == 0 && vm.isEdit"> <span ng-if="vm.page > 0 || !vm.isEdit">{{vm.data.name}}</span></div></div><div class="c-form"><label class="c-form-label" style="width: 150px">\u6A21\u578B\u7C7B\u578B\uFF1A</label><div class="c-form-div" style="margin-left: 150px" ng-if="vm.page == 0 && vm.isEdit"><select class="c-select1" ng-model="vm.data.modelType" ng-options="item.value as item.name for item in vm.modelTypeList" ng-change="modelTypeTab()"><option value="">\u8BF7\u9009\u62E9</option></select></div><div class="c-form-div lh35" style="margin-left: 150px" ng-if="vm.page > 0 || !vm.isEdit"><span>{{vm.data.modelType == \'THREE\' ? \'3D\u6A21\u578B\' : \'2D\u6A21\u578B\'}}</span></div></div><div class="c-form"><label class="c-form-label" style="width: 150px">\u8BBE\u7F6E\u9875\u6570\uFF1A</label><div class="c-form-div lh35" style="margin-left: 150px"><span ng-if="vm.page > 0 || !vm.isEdit">{{vm.pageCount}}</span> <input type="text" class="c-input1" ng-model="vm.pageCount" ng-if="vm.page == 0 && vm.isEdit" style="width: 60%"> <button type="button" class="btn btn-info" style="height: 30px" ng-if="vm.page == 0 && vm.isEdit" ng-click="pageCountTab()">\u786E\u5B9A</button></div></div><div class="c-form"><label class="c-form-label" style="width: 150px">\u9884\u89C8\u56FE\uFF1A</label><div class="c-form-div lh35" style="margin-left: 150px" ng-if="vm.page == 0 && vm.isEdit"><div ng-if="vm.data.cover" style="width: 100px; position: relative"><img alt="\u56FE\u7247\u7F3A\u5931" ng-if="domains.domain" ng-src="{{domains.domain + vm.data.cover}}" style="max-width: 100px; max-height: 100px"> <i class="glyphicon glyphicon-remove" ng-click="removeFile()" style="color: red; position: absolute; right: -20px; top: 50%; margin-top: -10px" role="button" tabindex="0"></i></div><div style="width: 100px; height: 100px;position: relative" ng-if="!vm.data.cover"><input type="file" name="file" accept=" image/jpeg, image/png" onchange="uploadPic(event)" ng-model-options="{debounce : 500}" style="position: absolute;display: block; top: 0; left: 0; width: 100%; height: 100%; font-size: 100px; opacity: 0; filter: alpha(opacity=0); z-index: 1"> <img src="content/images/icon/upload_img.svg" alt="" style="position: absolute; width: 100%; z-index: 0"></div></div><div class="c-form-div lh35" style="margin-left: 150px" ng-if="vm.page > 0 || !vm.isEdit"><div ng-if="vm.data.cover" style="width: 100px; position: relative"><img alt="\u56FE\u7247\u7F3A\u5931" ng-if="domains.domain" ng-src="{{domains.domain + vm.data.cover}}" style="max-width: 100px; max-height: 100px"></div></div></div><div class="c-form"><label class="c-form-label" style="width: 150px">\u9875\u9762\u590D\u7528\uFF1A</label><div class="c-form-div" style="margin-left: 150px" ng-if="vm.isEdit"><div ng-class="{\'checkbox-1\':vm.data.reuse,\'checkbox-0\':!vm.data.reuse}" class="checkbox-icon float-left" ng-click="vm.reuseCheck(true)"></div><div ng-click="vm.reuseCheck(true)" class="checkbox-icon float-left mar-left-10" style="margin-top: 7px; width: 30px">\u662F</div><div ng-class="{\'checkbox-1\':!vm.data.reuse,\'checkbox-0\': vm.data.reuse}" class="checkbox-icon float-left" ng-click="vm.reuseCheck(false)" style="margin-left: 30px"></div><span ng-click="vm.reuseCheck(false)" class="checkbox-icon float-left mar-left-10" style="margin-top: 7px; width: 30px">\u5426</span></div><div class="c-form-div lh35" style="margin-left: 150px" ng-if="!vm.isEdit"><span ng-if="vm.data.reuse">\u662F</span> <span ng-if="!vm.data.reuse">\u5426</span></div></div><div class="c-form"><label class="c-form-label" style="width: 150px">\u6A21\u677F\u5206\u7C7B\uFF1A</label><div class="c-form-div" style="margin-left: 150px" ng-if="vm.page == 0 && vm.isEdit"><select class="c-select1" ng-model="vm.data.catalog" ng-options="item.name for item in vm.catalogs"><option value="">\u8BF7\u9009\u62E9</option></select></div><div class="c-form-div lh35" style="margin-left: 150px" ng-if="vm.page > 0 || !vm.isEdit"><span>{{vm.data.catalog.name}}</span></div></div><div class="c-form"><label class="c-form-label" style="width: 150px">\u9884\u89C8\u7FFB\u9875\uFF1A</label><div class="c-form-div lh35" style="margin-left: 150px"><select class="form-control" name="field_reprint" id="field_reprint" ng-model="vm.data.bindingType" ng-if="vm.page == 0 && vm.isEdit"><option value="Left">\u5DE6\u53F3\u6ED1\u52A8\uFF08\u542B\u5C01\u9762\uFF09</option><option value="Top">\u4E0A\u4E0B\u6ED1\u52A8</option><option value="None">\u5355\u9875\u5C55\u793A</option><option value="Left2">\u5DE6\u53F3\u6ED1\u52A8\uFF08\u4E0D\u542B\u5C01\u9762\uFF09</option></select><span ng-if="!vm.isEdit|| vm.page != 0">{{bindingTypeInfo(vm.data.bindingType)}}</span></div></div><div class="c-form"><label class="c-form-label" style="width: 150px">\u7F16\u8F91\u6A21\u5F0F\uFF1A</label><div class="c-form-div lh35" style="margin-left: 150px"><select class="c-select1" ng-model="vm.data.pattern" ng-if="vm.page == 0 && vm.isEdit"><option value="BOOK">\u4E66\u520A\u6A21\u5F0F</option><option value="OTHER">\u666E\u901A\u6A21\u5F0F</option><option value="BOOK2">\u4E66\u520A\uFF08\u4E0D\u542B\u5C01\u9762\uFF09</option></select><span ng-if="!vm.isEdit|| vm.page != 0">{{patternInfo(vm.data.pattern)}}</span></div></div><div class="c-form"><label class="c-form-label" style="width: 150px">\u6A21\u677F\u66FF\u6362\uFF1A</label><div class="c-form-div lh35" style="margin-left: 150px"><select class="form-control" ng-model="vm.data.replace" ng-options="item.id as item.value for item in vm.replaces" ng-if="vm.page == 0 && vm.isEdit"></select><span ng-if="!vm.isEdit|| vm.page != 0">{{vm.data.replace?\'\u53EF\u66FF\u6362\':\'\u4E0D\u53EF\u66FF\u6362\'}}</span></div></div><div class="c-form" ng-if="vm.data.modelType == \'THREE\' && vm.page == 0 && vm.isEdit"><label class="c-form-label" style="width: 150px">\u5173\u8054\u6A21\u578B\uFF1A</label><div class="c-form-div" style="margin-left: 150px" ng-if="!vm.data.modelPath"><button type="button" class="btn btn-info" ng-click="vm.modelPathTab()">\u6A21\u578B</button></div><div class="c-form-div" style="margin-left: 150px" ng-if="vm.data.modelPath"><button type="button" class="btn btn-info" ng-click="vm.modelPathTabEdit()" style="margin-bottom: 10px">\u91CD\u65B0\u9009\u62E9</button><div><div class="c-form" ng-repeat="item in vm.modelData" style="margin-bottom: 10px"><label class="c-form-label" style="width: 80px">{{item.materialName}}\uFF1A</label><div class="c-form-div" style="margin-left: 80px"><select class="c-select1" style="width: 120px" ng-model="item.page" ng-options="page.index as page.name for page in vm.pageList"><option value="" class="" selected="selected">\u8BF7\u9009\u62E9</option></select></div></div></div></div></div><div class="c-form" ng-if="vm.data.modelType == \'THREE\' && (vm.page > 0 || !vm.isEdit)"><label class="c-form-label" style="width: 150px">\u5173\u8054\u6A21\u578B\uFF1A</label><div class="c-form-div lh35" style="margin-left: 150px" ng-if="vm.data.modelPath"><div ng-repeat="item in vm.modelData">{{item.materialName}}\uFF1A\u7B2C{{item.page+1}}\u9875</div></div></div><div class="c-form" ng-if="vm.data.modelType == \'THREE\' && vm.page == 0 && vm.isEdit"><label class="c-form-label" style="width: 150px">\u914D\u8272\u7BA1\u7406\uFF1A</label><div class="c-form-div" style="margin-left: 150px; margin-bottom: 5px; position: relative; padding: 10px; border: 1px solid #ddd; border-radius: 6px" ng-repeat="item in vm.data.modelBlendent track by $index"><div style="display: flex; align-items: center; height: 35px">\u914D\u8272\u540D\u79F0\uFF1A<input type="text" class="c-input1" style="width: 150px" ng-model="item.name"></div><button type="button" class="btn btn-info" ng-click="modelBlendentSet(item)" style="margin: 5px 0 0 70px">\u8BBE\u7F6E\u914D\u8272</button> <i class="glyphicon glyphicon-remove" ng-click="removeModelBlendent($index)" style="color: red; position: absolute; right: 5px; top: 5px" role="button" tabindex="0"></i></div><div class="c-form-div" style="margin-left: 150px"><button type="button" class="btn btn-info" ng-click="modelBlendentAdd()">\u65B0\u589E</button></div></div><hr style="margin-bottom: 20px"><div style="margin-bottom: 20px; line-height: 35px; text-align: center">\u5F53\u524D\u9875\uFF1A\u7B2C{{vm.page+1}}\u9875</div><div class="c-form" ng-if="vm.data.modelType != \'THREE\'"><label class="c-form-label" style="width: 150px">\u6A21\u578B\uFF1A</label><div class="c-form-div" style="margin-left: 150px" ng-if="!vm.data.pageTemplates[vm.page].mould"><button type="button" class="btn btn-info" ng-click="vm.selectModel(vm.data.pageTemplates[vm.page])" ng-if="vm.isEdit">\u6A21\u578B</button></div><div class="c-form-div" style="margin-left: 150px" ng-if="vm.data.pageTemplates[vm.page].mould"><button type="button" class="btn btn-info" ng-click="vm.selectModelEdit(vm.data.pageTemplates[vm.page])" ng-if="vm.isEdit" style="margin-bottom: 10px">\u6A21\u578B</button><div style="width: 70px; height: 70px"><img ng-src="{{vm.data.pageTemplates[vm.page].mould.modelPic}}" alt="" style="max-width: 70px; max-height: 70px"></div></div></div><div class="c-form"><label class="c-form-label" style="width: 150px">\u5C3A\u5BF8\uFF1A</label><div class="c-form-div" style="margin-left: 150px" ng-if="vm.isEdit"><input type="text" class="c-input1" ng-model="vm.data.pageTemplates[vm.page].pageSizeW" style="width: 100px; margin-right: 13.5px" placeholder="\u5BBD\u5EA6"> <span style="margin-right: 13.5px">*</span> <input type="text" class="c-input1" ng-model="vm.data.pageTemplates[vm.page].pageSizeH" style="width: 100px; margin-right: 10px" placeholder="\u9AD8\u5EA6"><select class="c-select1" ng-model="vm.data.pageTemplates[vm.page].pageSizeUnit1" ng-options="item.id as item.name for item in vm.units" ng-change="unitConversion(vm.data.pageTemplates[vm.page].pageSizeUnit1)" style="width: 100px"></select></div><div class="c-form-div lh35" style="margin-left: 150px" ng-if="!vm.isEdit"><span class="input-span">{{vm.data.pageTemplates[vm.page].pageSizeW}}</span> <span style="margin: 0 10px">*</span> <span class="input-span">{{vm.data.pageTemplates[vm.page].pageSizeH}}</span> <span class="input-span">{{vm.data.pageTemplates[vm.page].pageSizeUnit}}</span></div></div><div class="c-form"><label class="c-form-label" style="width: 150px">\u51FA\u8840\u5C3A\u5BF8\uFF1A</label><div class="c-form-div" style="margin-left: 150px" ng-if="vm.isEdit"><input type="text" class="c-input1" ng-model="vm.data.pageTemplates[vm.page].pageBloodT" style="width: 50px; margin-right: 10px" placeholder="\u4E0A"> <input type="text" class="c-input1" ng-model="vm.data.pageTemplates[vm.page].pageBloodB" style="width: 50px; margin-right: 10px" placeholder="\u4E0B"> <input type="text" class="c-input1" ng-model="vm.data.pageTemplates[vm.page].pageBloodL" style="width: 50px; margin-right: 10px" placeholder="\u5DE6"> <input type="text" class="c-input1" ng-model="vm.data.pageTemplates[vm.page].pageBloodR" style="width: 50px; margin-right: 10px" placeholder="\u53F3"><select class="c-select1" ng-model="vm.data.pageTemplates[vm.page].pageBloodUnit1" ng-options="item.id as item.name for item in vm.units" ng-change="unitConversion(vm.data.pageTemplates[vm.page].pageBloodUnit1)" style="width: 100px"></select></div><div class="c-form-div lh35" style="margin-left: 150px" ng-if="!vm.isEdit"><span class="input-span">{{vm.data.pageTemplates[vm.page].pageBloodT}}</span> <span class="input-span">{{vm.data.pageTemplates[vm.page].pageBloodB}}</span> <span class="input-span">{{vm.data.pageTemplates[vm.page].pageBloodL}}</span> <span class="input-span">{{vm.data.pageTemplates[vm.page].pageBloodR}}</span> <span class="input-span">{{vm.data.pageTemplates[vm.page].pageBloodUnit}}</span></div></div><div class="c-form"><label class="c-form-label" style="width: 150px">\u7F16\u8F91\u533A\u57DF\uFF1A</label><div class="c-form-div" style="margin-left: 150px" ng-if="vm.isEdit"><div ng-repeat="pageEdit in vm.data.pageTemplates[vm.page].pageEdits track by $index" style="position: relative; margin-bottom: 5px"><input type="text" class="c-input1" ng-model="pageEdit.pageEditX" style="width: 50px; margin-right: 10px" placeholder="X"> <input type="text" class="c-input1" ng-model="pageEdit.pageEditY" style="width: 50px; margin-right: 10px" placeholder="Y"> <input type="text" class="c-input1" ng-model="pageEdit.pageEditW" style="width: 50px; margin-right: 10px" placeholder="\u5BBD"> <input type="text" class="c-input1" ng-model="pageEdit.pageEditH" style="width: 50px; margin-right: 10px" placeholder="\u9AD8"><select class="c-select1" ng-model="vm.data.pageTemplates[vm.page].pageEditUnit1" ng-options="item.id as item.name for item in vm.units" ng-if="$index == 0" ng-change="unitConversion(vm.data.pageTemplates[vm.page].pageEditUnit1)" style="width: 100px"></select><button type="button" class="btn btn-cancel pageEditAdd" ng-click="addPageEdit()" ng-if="$index == 0">\u6DFB\u52A0</button> <button type="button" class="btn btn-cancel pageEditAdd" ng-click="removePageEdit($index)" ng-if="$index > 0" style="position: unset">\u5220\u9664</button></div><div class="c-form-div lh35" style="margin-left: 150px" ng-if="!vm.isEdit"><span class="input-span">{{pageEdit.pageEditX}}</span> <span class="input-span">{{pageEdit.pageEditY}}</span> <span class="input-span">{{pageEdit.pageEditW}}</span> <span class="input-span">{{pageEdit.pageEditH}}</span> <span class="input-span">{{vm.data.pageTemplates[vm.page].pageEditUnit}}</span></div></div></div><div style="text-align: center"><button type="button" class="btn btn-info" ng-click="vm.cutPage(\'up\')" ng-if="vm.page+1 > 1">\u4E0A\u4E00\u9875</button> <button type="button" class="btn btn-info" ng-click="vm.cutPage(\'next\')" ng-if="vm.page+1 < vm.data.pageCount">\u4E0B\u4E00\u9875</button></div></div><div class="c-model-foot" style="text-align: center"><button type="button" class="btn btn-info" ng-click="vm.save()" ng-if="vm.type != \'look\'">\u786E\u5B9A</button> <button type="button" class="btn btn-cancel" ng-click="vm.cancel()">\u53D6\u6D88</button></div></div><style>.modal-content {\n        width: 100%;\n        margin: 100px auto;\n    }</style>');
$templateCache.put('app/entities/page/modal/template-rename.html','<div class="c-model"><div class="c-model-head clearfix"><div class="c-model-head-title">\u91CD\u547D\u540D</div><button aria-label="Close" data-dismiss="modal" class="close" type="button" ng-click="vm.cancel()"><span aria-hidden="true">&times;</span></button></div><div class="c-model-body"><div class="c-form"><label class="c-form-label" style="width: 100px">\u6A21\u677F\u540D\u79F0\uFF1A</label><div class="c-form-div lh35" style="margin-left: 100px"><input type="text" class="c-input1" ng-model="vm.data.name"></div></div></div><div class="c-model-foot" style="text-align: center"><button type="button" class="btn btn-info" ng-click="vm.save()">\u786E\u5B9A</button> <button type="button" class="btn btn-cancel" ng-click="vm.cancel()">\u8FD4\u56DE</button></div></div><style>.modal-content {\n        width: 100%;\n        margin: 100px auto;\n    }</style>');
$templateCache.put('app/entities/page/modal/template-upgrade.html','<div class="c-model"><div class="c-model-head"><div class="c-model-head-title">\u6A21\u677F\u5347\u7EA7</div><i class="iconfont icon-closeicon1" ng-click="vm.cancel()"></i></div><div class="c-model-body"><div class="c-model-body-view"><div style="text-align: left;color: #505760">\u9009\u62E9\u4EA7\u54C1\u7C7B\u578B\uFF1A</div><div style="display: flex; margin-top: 20px"><div class="step-body-1-view-content-li" ng-repeat="item in vm.productList" ng-class="{\'step-body-1-view-content-li-select\' : item.id == vm.productList[vm.productSeq].id}" ng-click="productCb($index)">{{item.name}}</div></div><div style="display: flex; justify-content: left;align-items: center; margin: 20px 0" ng-if="vm.productList[vm.productSeq].id == \'BOOK\'">\u662F\u5426\u6709\u5C01\u9762\uFF1A<input type="checkbox" name="isCover" id="isCover" ng-model="vm.isCover" style="margin: 0;width: 20px"></div><div class="swiper-container swiper-container-modal" style="height: 300px;background-color: #ececec"><div class="swiper-wrapper"><div class="swiper-slide" ng-repeat="page in vm.pages track by $index" style="display: flex;align-items: center;justify-content: center"><img ng-src="{{page.pagecover.identifier}}" style="max-width: 100%;max-height: 100%"></div></div><div class="swiper-button-next swiper-button-black"></div><div class="swiper-button-prev swiper-button-black"></div></div></div></div><div class="c-model-foot" style="display: flex;justify-content: center;align-items: center;gap: 16px"><button type="button" class="btn btn-cancel btn-max" ng-click="vm.cancel()">\u5173\u95ED</button> <button type="button" class="btn btn-info btn-max" ng-click="vm.save()">\u786E\u5B9A</button></div></div><style>.step-body-1-view-content-li{\n        padding: 10px 34px;\n        height: 35px;\n        color: #333;\n        border-radius: 3px;\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        background: #F5F7FA;\n        margin: 0 10px 10px 0;\n        cursor: pointer;\n    }\n    .step-body-1-view-content-li:hover{\n        color: #264DF0;\n    }\n    .step-body-1-view-content-li-select{\n        background: #264DF0;\n        color: #fff !important;\n        border: 1px solid #264DF0;\n    }</style>');
$templateCache.put('app/entities/page/modal/three-preview1.html','<div ng-style="{width: vm.width, height: vm.height}" style="margin: 20px auto; position: relative"><div class="loading-page3" ng-if="vm.loading"><img src="content/images/loading-all.gif"></div><div id="threeView" ng-show="!vm.loading && !vm.error" style="width: 100%; height: 100%" ng-mouseover="onMouseOver()" ng-mouseout="onMouseOut()"></div></div><style>.modal-content {\n        width: 100%;\n    }</style>');
$templateCache.put('app/entities/page/modal/upgrade-prompt.html','<div class="upgrade-view"><div class="upgrade-close" ng-click="vm.close()"><i class="iconfont icon-closeicon1" style="color: #ffffff; font-size: 26px"></i></div><div class="upgrade-swiper swiper-container"><div class="swiper-wrapper"><div class="swiper-slide" ng-repeat="item in vm.swiperList"><img ng-src="{{item.src}}" alt=""></div></div></div><div class="upgrade-info"><div class="upgrade-title">\u6A21\u677F\u5DE5\u5177\u5168\u65B0\u5347\u7EA7</div><div class="upgrade-reminder">\u672C\u6B21\u66F4\u65B0\u6211\u4EEC\u8FDB\u884C\u4E86\u5168\u5C40\u529F\u80FD\u6846\u67B6\u4F18\u5316\uFF0C\u4E3A\u4F60\u63D0\u4F9B\u6A21\u7248\u90E8\u4EF6\u521B\u5EFA\u80FD\u529B\uFF0C\u66F4\u8F7B\u4FBF\u7684\u6587\u4EF6\u7BA1\u7406\u65B9\u5F0F\uFF0C\u66F4\u9AD8\u6548\u7684\u5185\u5BB9\u521B\u4F5C\u4E0E\u534F\u4F5C\u4F53\u9A8C\uFF0C\u5FEB\u53BB\u8BD5\u8BD5\u5427\uFF5E</div><div class="btns"><div class="btn-upgrade" ng-click="vm.submitOpen()">\u5F00\u542F\u5168\u65B0\u6A21\u677F\u8BBE\u8BA1</div></div></div></div><style>.upgrade-view {\n        width: 800px;\n        margin: 0 auto;\n        border-radius: 16px;\n        overflow: hidden;\n        position: relative;\n    }\n    .upgrade-view .upgrade-close {\n        position: absolute;\n        top: 28px;\n        right: 28px;\n        cursor: pointer;\n        z-index: 5;\n    }\n    .upgrade-swiper {\n        width: 100%;\n        height: 376px;\n    }\n    .upgrade-swiper .swiper-slide img {\n        display: block;\n        width: 100%;\n    }\n    .upgrade-info {\n        padding: 32px;\n        background: #ffffff;\n    }\n    .upgrade-info .upgrade-title {\n        color: #222529;\n        font-size: 22px;\n        font-weight: bold;\n        line-height: 30px;\n        margin-bottom: 8px;\n    }\n    .upgrade-info .upgrade-reminder {\n        font-size: 14px;\n        color: #505760;\n        line-height: 20px;\n        margin-bottom: 24px;\n    }\n    .upgrade-info .btns {\n        display: flex;\n        justify-content: center;\n    }\n    .upgrade-info .btn-upgrade {\n        font-size: 14px;\n        color: #ffffff;\n        line-height: 40px;\n        padding: 0 32px;\n        border-radius: 4px;\n        background: #264df0;\n        cursor: pointer;\n    }\n    .upgrade-info .btn-upgrade:hover {\n        background: rgba(58, 124, 255, 0.85);\n    }</style>');
$templateCache.put('app/entities/page/modal/widget-select.html','<div class="c-model widget-select-model"><div class="c-model-body"><div class="widget-select-head"><div class="title">{{vm.getTitle()}}</div><div class="search-input"><i class="iconfont iconfont icon-sousuo"></i> <input type="text" placeholder="\u5173\u952E\u8BCD\u641C\u7D22" ng-model="vm.searchQuery" ng-model-options="{debounce:300}" ng-change="search()"></div></div><div class="option-list scrollbar-main"><div class="option-item" ng-repeat="item in vm.list track by item.id" ng-click="selectItem(item.id)"><div class="cover-img"><img ng-src="{{item.previewUrl}}" alt="{{item.name}}"></div><div class="option-info"><div class="option-name">{{item.name}}</div><div class="select-icon" ng-class="{\'active\' : item.id === vm.selected}"><i class="iconfont icon-dui1"></i></div></div></div></div></div><div class="c-model-foot widget-select-model-foot"><button type="button" class="btn btn-cancel" style="margin-right: 16px" ng-click="cancel()">\u53D6\u6D88</button> <button type="button" class="btn btn-info" ng-click="confirm()">\u786E\u5B9A</button></div></div><style>.c-model{\n\n    }\n    .option-item:hover{\n        background-color: #ebeffe;\n    }</style>');
$templateCache.put('app/entities/text/modal/text-add.html','<div class="c-model"><div class="c-model-head"><div class="c-model-head-title">\u521B\u5EFA\u6587\u5B57\u6A21\u677F</div><i class="iconfont icon-closeicon1" ng-click="vm.cancel()"></i></div><div class="c-model-body"><div class="c-model-body-view"><div class="c-form"><label class="c-form-label">\u6A21\u677F\u540D\u79F0\uFF1A</label><div class="c-form-div"><input type="text" class="c-input1" ng-model="vm.data.name"></div></div><div class="c-form"><label class="c-form-label">\u6A21\u677F\u5C3A\u5BF8\uFF1A</label><div class="c-form-div group-form-view"><div class="group-size-input"><div class="item"><span class="title">\u5BBD</span> <input type="text" ng-model="vm.data.width"></div><div class="item"><span class="title">\u9AD8</span> <input type="text" ng-model="vm.data.height"></div></div><modele-select style="width:134px" prefix="\u5355\u4F4D" ng-model="vm.data.unit" ng-change="unitCb()" label-key="name" value-key="id" options="vm.units"></modele-select></div></div></div></div><div class="c-model-foot" style="text-align: center"><button type="button" style="margin-right: 16px" class="btn btn-cancel" ng-click="vm.cancel()">\u8FD4\u56DE</button> <button type="button" class="btn btn-info" ng-click="vm.save()">\u786E\u5B9A</button></div></div><style>.c-model {\n        width: 680px;\n        margin: 0 auto;\n    }\n    .c-form {\n        margin-bottom: 16px;\n    }\n\n    .c-model-body-view .c-form:last-child {\n        margin-bottom: 0;\n    }\n\n    .c-form .c-form-label {\n        width: 70px;\n        text-align: left;\n        line-height: 40px;\n        font-size: 14px;\n        color: #505760;\n        padding-right: 0;\n    }\n\n    .c-form .c-form-div {\n        margin-left: 70px;\n        width: auto;\n    }\n\n    .c-form .c-form-div input.c-input1 {\n        height: 40px;\n    }\n\n    .c-form .c-form-div select.c-select1 {\n        height: 40px;\n    }</style>');
$templateCache.put('app/entities/text/modal/text-detection.html','<!--\u53D1\u5E03\u6587\u5B57\u5F39\u7A97--><div class="c-model"><div class="c-model-head"><div class="c-model-head-title">\u53D1\u5E03\u6587\u5B57\u7EC4\u4EF6</div><i class="iconfont icon-closeicon1" ng-click="vm.cancel()"></i></div><div class="c-model-body"><div class="c-model-body-view release-view"><div class="progress-view"><div class="progress-item" ng-class="{\'active\' : [1,2,3].includes(vm.tapIndex)}"><p class="num">1</p>\u5370\u5237\u98CE\u9669\u68C0\u6D4B</div><div class="cut-line" ng-if="vm.thirdPartySettings.length > 1" ng-class="{\'active\' : [2,3].includes(vm.tapIndex)}"></div><div class="progress-item" ng-if="vm.thirdPartySettings.length > 1" ng-class="{\'active\' : [2,3].includes(vm.tapIndex)}"><p class="num">2</p>\u53D1\u5E03\u6E20\u9053\u9009\u62E9</div><div class="cut-line" ng-class="{\'active\' : vm.tapIndex == 3}"></div><div class="progress-item" ng-class="{\'active\' : vm.tapIndex == 3}"><p class="num">{{vm.thirdPartySettings.length > 1 ? \'3\' : \'2\'}}</p>\u53D1\u5E03\u7ED3\u679C</div></div><div class="info-list" ng-if="vm.tapIndex == 1"><div class="info-empty" ng-if="!vm.loading && vm.textDocument.dpiResult.length == 0 && vm.textDocument.fontResult.length == 0"><img src="content/images/editor-icon2.png" alt=""></div><local-loading title="\u68C0\u6D4B\u4E2D" show="vm.loading"></local-loading><div class="info-item" style="align-items: flex-start" ng-repeat="dpiResult in vm.textDocument.dpiResult"><div class="error-img"><img ng-src="{{dpiResult.img}}" alt=""></div><div class="info"><div class="desc">{{dpiResult.name}}\u7CBE\u5EA6\u4E0D\u8DB3\u3010{{dpiResult.dpi | number:2}}\u3011\uFF0C\u671F\u671B\u7CBE\u5EA6:\u3010{{dpiResult.expectDpi}}\u3011</div></div></div><div class="info-item" ng-repeat="fontResult in vm.textDocument.fontResult"><div class="error-img"></div><div class="info"><div class="desc">{{fontResult.message}}</div></div></div></div><div class="channel-view" ng-if="vm.tapIndex == 2"><div class="channel-head"><div class="channel-title">\u9009\u62E9\u53D1\u5E03\u6E20\u9053\uFF1A</div><div class="check-box" ng-class="{\'active\':vm.checkAll}" ng-click="vm.checkAllFn()"><i class="iconfont icon-xuanze"></i>\u5168\u9009</div></div><div class="channel-list"><div class="channel-item" ng-repeat="item in vm.thirdPartySettings" ng-class="{\'active\':item.selected}" ng-click="vm.checkFn(item)">{{item.name}}</div></div></div><div class="result-view" ng-if="vm.tapIndex == 3"><local-loading title="\u53D1\u5E03\u4E2D" show="vm.saveLoading"></local-loading><div ng-if="!vm.saveLoading"><div class="success-box" ng-if="vm.releaseData.status == 200"><div class="success-icon"><img src="content/images/release-success.png" alt="\u53D1\u5E03\u6210\u529F"></div><div class="success-tips">\u53D1\u5E03\u6210\u529F</div></div><div class="result-List" ng-if="vm.releaseData.status == 400"><div class="result-item" ng-repeat="item in vm.releaseData.message"><div class="result-name">{{item.storeName}}</div><div class="result-info"><div class="result-success" ng-if="item.success"><i class="iconfont icon-chenggong"></i> <span>\u53D1\u5E03\u6210\u529F</span></div><div class="result-error" ng-if="!item.success"><i class="iconfont icon-shixinguanbi"></i> <span>{{item.reason}}</span></div></div></div></div><div ng-if="vm.releaseData.status != 400 && vm.releaseData.status != 200" class="error-info">{{vm.releaseData.message}}</div></div></div></div></div><div class="c-model-foot release-foot-view" ng-class="{\'center\' : vm.tapIndex == 1}"><div class="prompt" ng-if="vm.tapIndex == 1"><i class="iconfont icon-jinggao"></i> <span>\u5206\u8FA8\u7387\u4E0D\u8DB3\u5C06\u4F1A\u5F71\u54CD\u5370\u5237\u8D28\u91CF\uFF0C\u53EF\u80FD\u4F1A\u5BFC\u81F4\u6A21\u7CCA\uFF1B\u82E5\u4E0D\u8C03\u6574\uFF0C\u5BFC\u81F4\u7684\u5370\u5237\u95EE\u9898\u7CFB\u7EDF\u6982\u4E0D\u8D1F\u8D23\u3002</span></div><div class="btns"><button type="button" class="btn btn-cancel" ng-if="vm.tapIndex == 1 && vm.disqualification && !vm.loading" ng-click="vm.cancel()">{{vm.source == \'list\' ? \'\u8FD4\u56DE\' : \'\u524D\u5F80\u8C03\u6574\'}}</button> <button type="button" class="btn btn-info" ng-if="vm.tapIndex == 1" ng-click="save1()">\u7EE7\u7EED\u53D1\u5E03</button> <button type="button" class="btn btn-cancel" ng-click="cancel2()" ng-if="vm.tapIndex == 2 || (vm.tapIndex == 3 && (vm.releaseData.status != 200 || !vm.releaseData))">\u8FD4\u56DE</button> <button type="button" class="btn btn-info" ng-click="save2()" ng-if="vm.tapIndex == 2">\u7EE7\u7EED\u53D1\u5E03</button> <button type="button" class="btn btn-info" ng-click="save3()" ng-if="vm.tapIndex == 3 && vm.releaseData.status == 200">\u786E\u5B9A</button></div></div></div><style>.c-model {\n        width: 900px;\n    }</style>');
$templateCache.put('app/entities/text/modal/text-xml-look.html','<div class="preview-model"><div class="preview-model-head"><div class="title">\u9884\u89C8</div><div class="close-btn" ng-click="vm.cancel()"><i class="iconfont icon-closeicon1"></i></div></div><div class="preview-model-content"><img ng-src="{{vm.url}}" alt=""></div></div>');
$templateCache.put('app/entities/text/modal/text-xml-out.html','<div class="c-model"><div class="c-model-head"><div class="c-model-head-title" style="font-weight: bold">\u67E5\u770B</div><i class="iconfont icon-closeicon1" ng-click="vm.cancel()"></i></div><div class="c-model-body" style="font-size: 16px">\u786E\u5B9A\u8981\u9000\u51FA\u5417\uFF1F</div><div class="c-model-foot" style="text-align: right"><button type="button" class="btn btn-cancel btn-max" ng-click="vm.cancel()">\u53D6\u6D88</button> <button type="button" class="btn btn-info btn-max" ng-click="vm.save()">\u786E\u5B9A</button></div></div><style>.modal-content{\n        width: 500px;\n    }</style>');}]);})();